/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		83: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "assets/" + chunkId + "." + "a9061b7bee4bcd788923" + ".chunk.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 884);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(886);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1078)();
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate (y) {
        var date;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            var args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays (ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays :
            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
            : (m) ? weekdays[m.day()] : weekdays;
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                __webpack_require__(1112)("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    var MS_PER_SECOND = 1000;
    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':   return months;
                case 'quarter': return months / 3;
                case 'year':    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asQuarters     = makeAs('Q');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asQuarters     = asQuarters;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.24.0';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(209)(module)))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactIntl = __webpack_require__(366);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var InjectMassage = function InjectMassage(props) {
  return _react["default"].createElement(_reactIntl.FormattedMessage, props);
};

var _default = (0, _reactIntl.injectIntl)(InjectMassage, {
  withRef: false
});

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(InjectMassage, "InjectMassage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/IntlMessages.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/IntlMessages.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/IntlMessages.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/IntlMessages.js");

  __REACT_HOT_LOADER__.register(InjectMassage, "InjectMassage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/IntlMessages.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/IntlMessages.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/IntlMessages.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/IntlMessages.js");
}();

;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(17);
var core = __webpack_require__(36);
var hide = __webpack_require__(69);
var redefine = __webpack_require__(59);
var ctx = __webpack_require__(84);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Container__ = __webpack_require__(1337);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Container", function() { return __WEBPACK_IMPORTED_MODULE_0__Container__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Row__ = __webpack_require__(1339);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Row", function() { return __WEBPACK_IMPORTED_MODULE_1__Row__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Col__ = __webpack_require__(1340);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Col", function() { return __WEBPACK_IMPORTED_MODULE_2__Col__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Navbar__ = __webpack_require__(1341);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Navbar", function() { return __WEBPACK_IMPORTED_MODULE_3__Navbar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavbarBrand__ = __webpack_require__(1342);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavbarBrand", function() { return __WEBPACK_IMPORTED_MODULE_4__NavbarBrand__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NavbarToggler__ = __webpack_require__(1343);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavbarToggler", function() { return __WEBPACK_IMPORTED_MODULE_5__NavbarToggler__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Nav__ = __webpack_require__(1344);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Nav", function() { return __WEBPACK_IMPORTED_MODULE_6__Nav__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NavItem__ = __webpack_require__(1345);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavItem", function() { return __WEBPACK_IMPORTED_MODULE_7__NavItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__NavDropdown__ = __webpack_require__(1346);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavDropdown", function() { return __WEBPACK_IMPORTED_MODULE_8__NavDropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NavLink__ = __webpack_require__(1351);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavLink", function() { return __WEBPACK_IMPORTED_MODULE_9__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Breadcrumb__ = __webpack_require__(1352);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Breadcrumb", function() { return __WEBPACK_IMPORTED_MODULE_10__Breadcrumb__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__BreadcrumbItem__ = __webpack_require__(1353);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BreadcrumbItem", function() { return __WEBPACK_IMPORTED_MODULE_11__BreadcrumbItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Button__ = __webpack_require__(367);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return __WEBPACK_IMPORTED_MODULE_12__Button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ButtonDropdown__ = __webpack_require__(664);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonDropdown", function() { return __WEBPACK_IMPORTED_MODULE_13__ButtonDropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ButtonGroup__ = __webpack_require__(1354);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonGroup", function() { return __WEBPACK_IMPORTED_MODULE_14__ButtonGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ButtonToolbar__ = __webpack_require__(1355);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonToolbar", function() { return __WEBPACK_IMPORTED_MODULE_15__ButtonToolbar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Dropdown__ = __webpack_require__(212);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Dropdown", function() { return __WEBPACK_IMPORTED_MODULE_16__Dropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DropdownItem__ = __webpack_require__(1356);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DropdownItem", function() { return __WEBPACK_IMPORTED_MODULE_17__DropdownItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DropdownMenu__ = __webpack_require__(1357);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DropdownMenu", function() { return __WEBPACK_IMPORTED_MODULE_18__DropdownMenu__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__DropdownToggle__ = __webpack_require__(1359);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DropdownToggle", function() { return __WEBPACK_IMPORTED_MODULE_19__DropdownToggle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Fade__ = __webpack_require__(368);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Fade", function() { return __WEBPACK_IMPORTED_MODULE_20__Fade__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Badge__ = __webpack_require__(1365);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_21__Badge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Card__ = __webpack_require__(1366);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Card", function() { return __WEBPACK_IMPORTED_MODULE_22__Card__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__CardGroup__ = __webpack_require__(1367);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CardGroup", function() { return __WEBPACK_IMPORTED_MODULE_23__CardGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__CardDeck__ = __webpack_require__(1368);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CardDeck", function() { return __WEBPACK_IMPORTED_MODULE_24__CardDeck__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__CardColumns__ = __webpack_require__(1369);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CardColumns", function() { return __WEBPACK_IMPORTED_MODULE_25__CardColumns__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__CardBody__ = __webpack_require__(668);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CardBody", function() { return __WEBPACK_IMPORTED_MODULE_26__CardBody__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__CardBlock__ = __webpack_require__(1370);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CardBlock", function() { return __WEBPACK_IMPORTED_MODULE_27__CardBlock__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__CardLink__ = __webpack_require__(1371);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CardLink", function() { return __WEBPACK_IMPORTED_MODULE_28__CardLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__CardFooter__ = __webpack_require__(1372);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CardFooter", function() { return __WEBPACK_IMPORTED_MODULE_29__CardFooter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__CardHeader__ = __webpack_require__(1373);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CardHeader", function() { return __WEBPACK_IMPORTED_MODULE_30__CardHeader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__CardImg__ = __webpack_require__(1374);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CardImg", function() { return __WEBPACK_IMPORTED_MODULE_31__CardImg__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__CardImgOverlay__ = __webpack_require__(1375);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CardImgOverlay", function() { return __WEBPACK_IMPORTED_MODULE_32__CardImgOverlay__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Carousel__ = __webpack_require__(669);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Carousel", function() { return __WEBPACK_IMPORTED_MODULE_33__Carousel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__UncontrolledCarousel__ = __webpack_require__(1376);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "UncontrolledCarousel", function() { return __WEBPACK_IMPORTED_MODULE_34__UncontrolledCarousel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__CarouselControl__ = __webpack_require__(670);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CarouselControl", function() { return __WEBPACK_IMPORTED_MODULE_35__CarouselControl__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__CarouselItem__ = __webpack_require__(369);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CarouselItem", function() { return __WEBPACK_IMPORTED_MODULE_36__CarouselItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__CarouselIndicators__ = __webpack_require__(671);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CarouselIndicators", function() { return __WEBPACK_IMPORTED_MODULE_37__CarouselIndicators__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__CarouselCaption__ = __webpack_require__(672);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CarouselCaption", function() { return __WEBPACK_IMPORTED_MODULE_38__CarouselCaption__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__CardSubtitle__ = __webpack_require__(1377);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CardSubtitle", function() { return __WEBPACK_IMPORTED_MODULE_39__CardSubtitle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__CardText__ = __webpack_require__(1378);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CardText", function() { return __WEBPACK_IMPORTED_MODULE_40__CardText__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__CardTitle__ = __webpack_require__(1379);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CardTitle", function() { return __WEBPACK_IMPORTED_MODULE_41__CardTitle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__CustomInput__ = __webpack_require__(1380);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CustomInput", function() { return __WEBPACK_IMPORTED_MODULE_42__CustomInput__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__PopperContent__ = __webpack_require__(673);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PopperContent", function() { return __WEBPACK_IMPORTED_MODULE_43__PopperContent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__PopperTargetHelper__ = __webpack_require__(1381);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PopperTargetHelper", function() { return __WEBPACK_IMPORTED_MODULE_44__PopperTargetHelper__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__Popover__ = __webpack_require__(674);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Popover", function() { return __WEBPACK_IMPORTED_MODULE_45__Popover__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__UncontrolledPopover__ = __webpack_require__(1382);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "UncontrolledPopover", function() { return __WEBPACK_IMPORTED_MODULE_46__UncontrolledPopover__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__PopoverHeader__ = __webpack_require__(676);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PopoverHeader", function() { return __WEBPACK_IMPORTED_MODULE_47__PopoverHeader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__PopoverTitle__ = __webpack_require__(1383);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PopoverTitle", function() { return __WEBPACK_IMPORTED_MODULE_48__PopoverTitle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__PopoverBody__ = __webpack_require__(677);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PopoverBody", function() { return __WEBPACK_IMPORTED_MODULE_49__PopoverBody__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__PopoverContent__ = __webpack_require__(1384);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PopoverContent", function() { return __WEBPACK_IMPORTED_MODULE_50__PopoverContent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__Progress__ = __webpack_require__(1385);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Progress", function() { return __WEBPACK_IMPORTED_MODULE_51__Progress__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__Modal__ = __webpack_require__(1387);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Modal", function() { return __WEBPACK_IMPORTED_MODULE_52__Modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__ModalHeader__ = __webpack_require__(1389);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModalHeader", function() { return __WEBPACK_IMPORTED_MODULE_53__ModalHeader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__ModalBody__ = __webpack_require__(1390);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModalBody", function() { return __WEBPACK_IMPORTED_MODULE_54__ModalBody__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__ModalFooter__ = __webpack_require__(1391);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModalFooter", function() { return __WEBPACK_IMPORTED_MODULE_55__ModalFooter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__Tooltip__ = __webpack_require__(678);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_56__Tooltip__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__Table__ = __webpack_require__(1392);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Table", function() { return __WEBPACK_IMPORTED_MODULE_57__Table__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__ListGroup__ = __webpack_require__(1393);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ListGroup", function() { return __WEBPACK_IMPORTED_MODULE_58__ListGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__Form__ = __webpack_require__(1394);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Form", function() { return __WEBPACK_IMPORTED_MODULE_59__Form__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__FormFeedback__ = __webpack_require__(1395);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormFeedback", function() { return __WEBPACK_IMPORTED_MODULE_60__FormFeedback__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__FormGroup__ = __webpack_require__(1396);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormGroup", function() { return __WEBPACK_IMPORTED_MODULE_61__FormGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__FormText__ = __webpack_require__(1397);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormText", function() { return __WEBPACK_IMPORTED_MODULE_62__FormText__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__Input__ = __webpack_require__(1398);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Input", function() { return __WEBPACK_IMPORTED_MODULE_63__Input__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__InputGroup__ = __webpack_require__(1399);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InputGroup", function() { return __WEBPACK_IMPORTED_MODULE_64__InputGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__InputGroupAddon__ = __webpack_require__(679);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InputGroupAddon", function() { return __WEBPACK_IMPORTED_MODULE_65__InputGroupAddon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__InputGroupButton__ = __webpack_require__(1400);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InputGroupButton", function() { return __WEBPACK_IMPORTED_MODULE_66__InputGroupButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__InputGroupButtonDropdown__ = __webpack_require__(1401);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InputGroupButtonDropdown", function() { return __WEBPACK_IMPORTED_MODULE_67__InputGroupButtonDropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__InputGroupText__ = __webpack_require__(680);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InputGroupText", function() { return __WEBPACK_IMPORTED_MODULE_68__InputGroupText__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__Label__ = __webpack_require__(1402);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Label", function() { return __WEBPACK_IMPORTED_MODULE_69__Label__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__Media__ = __webpack_require__(1403);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Media", function() { return __WEBPACK_IMPORTED_MODULE_70__Media__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__Pagination__ = __webpack_require__(1404);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Pagination", function() { return __WEBPACK_IMPORTED_MODULE_71__Pagination__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__PaginationItem__ = __webpack_require__(1405);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PaginationItem", function() { return __WEBPACK_IMPORTED_MODULE_72__PaginationItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__PaginationLink__ = __webpack_require__(1406);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PaginationLink", function() { return __WEBPACK_IMPORTED_MODULE_73__PaginationLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__TabContent__ = __webpack_require__(1407);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabContent", function() { return __WEBPACK_IMPORTED_MODULE_74__TabContent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__TabPane__ = __webpack_require__(1408);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabPane", function() { return __WEBPACK_IMPORTED_MODULE_75__TabPane__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__Jumbotron__ = __webpack_require__(1409);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Jumbotron", function() { return __WEBPACK_IMPORTED_MODULE_76__Jumbotron__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__Alert__ = __webpack_require__(681);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Alert", function() { return __WEBPACK_IMPORTED_MODULE_77__Alert__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__Collapse__ = __webpack_require__(682);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Collapse", function() { return __WEBPACK_IMPORTED_MODULE_78__Collapse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__ListGroupItem__ = __webpack_require__(1410);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ListGroupItem", function() { return __WEBPACK_IMPORTED_MODULE_79__ListGroupItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__ListGroupItemHeading__ = __webpack_require__(1411);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ListGroupItemHeading", function() { return __WEBPACK_IMPORTED_MODULE_80__ListGroupItemHeading__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__ListGroupItemText__ = __webpack_require__(1412);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ListGroupItemText", function() { return __WEBPACK_IMPORTED_MODULE_81__ListGroupItemText__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__UncontrolledAlert__ = __webpack_require__(1413);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "UncontrolledAlert", function() { return __WEBPACK_IMPORTED_MODULE_82__UncontrolledAlert__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__UncontrolledButtonDropdown__ = __webpack_require__(1414);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "UncontrolledButtonDropdown", function() { return __WEBPACK_IMPORTED_MODULE_83__UncontrolledButtonDropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__UncontrolledCollapse__ = __webpack_require__(1415);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "UncontrolledCollapse", function() { return __WEBPACK_IMPORTED_MODULE_84__UncontrolledCollapse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__UncontrolledDropdown__ = __webpack_require__(683);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "UncontrolledDropdown", function() { return __WEBPACK_IMPORTED_MODULE_85__UncontrolledDropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__UncontrolledNavDropdown__ = __webpack_require__(1416);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "UncontrolledNavDropdown", function() { return __WEBPACK_IMPORTED_MODULE_86__UncontrolledNavDropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__UncontrolledTooltip__ = __webpack_require__(1417);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "UncontrolledTooltip", function() { return __WEBPACK_IMPORTED_MODULE_87__UncontrolledTooltip__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__Spinner__ = __webpack_require__(1418);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Spinner", function() { return __WEBPACK_IMPORTED_MODULE_88__Spinner__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__utils__ = __webpack_require__(9);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "Util", function() { return __WEBPACK_IMPORTED_MODULE_89__utils__; });





















































































































































































/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ON_INITIATIVE_SELECT = exports.ON_INITIATIVE_CLOSE = exports.ON_ALL_INITIATIVE_SELECT = exports.SET_INITIATIVE = exports.ON_EDIT_INITIATIVE = exports.ON_ADD_INITIATIVE = exports.SHOW_INITIATIVE_LOADER = exports.HIDE_INITIATIVE_LOADER = exports.HANDLE_INITIATIVE_REQUEST_CLOSE = exports.GET_UNSELECTED_ALL_INITIATIVE = exports.GET_ALL_INITIATIVE = exports.FILTER_INITIATIVE = exports.FETCH_ALL_INITIATIVE_SUCCESS = exports.FETCH_ALL_INITIATIVE = exports.FETCH_INITIATIVE_SUCCESS = exports.FETCH_INITIATIVE = exports.ADD_FAVOURITE_INITIATIVE_SUCCESS = exports.ADD_FAVOURITE_INITIATIVE = exports.ON_ISSUE_FEATURE_UPDATE = exports.ON_FETCH_SELECT_FEATURE_DATA_SUCCESS = exports.ON_FETCH_SELECT_FEATURE_DATA = exports.UPDATE_SEARCH_ISSUE = exports.SHOW_ISSUE_MESSAGE = exports.ON_TOGGLE_ISSUE_DRAWER = exports.ON_SAVE_ISSUE_SUCCESS = exports.ON_SAVE_ISSUE = exports.ON_FILTER_ISSUE_OPTION_SELECT = exports.ON_FILTER_SELECTED_ISSUE = exports.ON_DELETE_ISSUE_SUCCESS = exports.ON_DELETE_ISSUE = exports.ON_ISSUE_SELECT = exports.ON_ISSUE_CLOSE = exports.ON_ALL_ISSUE_SELECT = exports.SET_ISSUE = exports.ON_EDIT_ISSUE = exports.ON_ADD_ISSUE = exports.SHOW_ISSUE_LOADER = exports.HIDE_ISSUE_LOADER = exports.HANDLE_ISSUE_REQUEST_CLOSE = exports.GET_UNSELECTED_ALL_ISSUE = exports.GET_ALL_ISSUE = exports.FILTER_ISSUE = exports.FETCH_ALL_ISSUE_SUCCESS = exports.FETCH_ALL_ISSUE = exports.FETCH_ISSUE_SUCCESS = exports.FETCH_ISSUE = exports.ADD_FAVOURITE_ISSUE_SUCCESS = exports.ADD_FAVOURITE_ISSUE = exports.UPDATE_SEARCH_PROJECT_BUS_PRIORITY = exports.SHOW_PROJECT_BUS_PRIORITY_MESSAGE = exports.ON_TOGGLE_PROJECT_BUS_PRIORITY_DRAWER = exports.ON_SAVE_PROJECT_BUS_PRIORITY_SUCCESS = exports.ON_SAVE_PROJECT_BUS_PRIORITY = exports.ON_FILTER_PROJECT_BUS_PRIORITY_OPTION_SELECT = exports.ON_FILTER_SELECTED_PROJECT_BUS_PRIORITY = exports.ON_DELETE_PROJECT_BUS_PRIORITY_SUCCESS = exports.ON_DELETE_PROJECT_BUS_PRIORITY = exports.ON_PROJECT_BUS_PRIORITY_SELECT = exports.ON_PROJECT_BUS_PRIORITY_CLOSE = exports.ON_ALL_PROJECT_BUS_PRIORITY_SELECT = exports.ON_EDIT_PROJECT_BUS_PRIORITY = exports.ON_ADD_PROJECT_BUS_PRIORITY = exports.SHOW_PROJECT_BUS_PRIORITY_LOADER = exports.HIDE_PROJECT_BUS_PRIORITY_LOADER = exports.HANDLE_PROJECT_BUS_PRIORITY_REQUEST_CLOSE = exports.GET_UNSELECTED_ALL_PROJECT_BUS_PRIORITY = exports.GET_ALL_PROJECT_BUS_PRIORITY = exports.FILTER_PROJECT_BUS_PRIORITY = exports.FETCH_ALL_PROJECT_BUS_PRIORITY_SUCCESS = exports.FETCH_ALL_PROJECT_BUS_PRIORITY = exports.FETCH_PROJECT_BUS_PRIORITY_SUCCESS = exports.FETCH_PROJECT_BUS_PRIORITY = exports.ADD_FAVOURITE_PROJECT_BUS_PRIORITY_SUCCESS = exports.ADD_FAVOURITE_PROJECT_BUS_PRIORITY = exports.UPDATE_SEARCH_PROJECT_COST_PRIORITY = exports.SHOW_PROJECT_COST_PRIORITY_MESSAGE = exports.ON_TOGGLE_PROJECT_COST_PRIORITY_DRAWER = exports.ON_SAVE_PROJECT_COST_PRIORITY_SUCCESS = exports.ON_SAVE_PROJECT_COST_PRIORITY = exports.ON_FILTER_PROJECT_COST_PRIORITY_OPTION_SELECT = exports.ON_FILTER_SELECTED_PROJECT_COST_PRIORITY = exports.ON_DELETE_PROJECT_COST_PRIORITY_SUCCESS = exports.ON_DELETE_PROJECT_COST_PRIORITY = exports.ON_PROJECT_COST_PRIORITY_SELECT = exports.ON_PROJECT_COST_PRIORITY_CLOSE = exports.ON_ALL_PROJECT_COST_PRIORITY_SELECT = exports.ON_EDIT_PROJECT_COST_PRIORITY = exports.ON_ADD_PROJECT_COST_PRIORITY = exports.SHOW_PROJECT_COST_PRIORITY_LOADER = exports.HIDE_PROJECT_COST_PRIORITY_LOADER = exports.HANDLE_PROJECT_COST_PRIORITY_REQUEST_CLOSE = exports.GET_UNSELECTED_ALL_PROJECT_COST_PRIORITY = exports.GET_ALL_PROJECT_COST_PRIORITY = exports.FILTER_PROJECT_COST_PRIORITY = exports.FETCH_ALL_PROJECT_COST_PRIORITY_SUCCESS = exports.FETCH_ALL_PROJECT_COST_PRIORITY = exports.FETCH_PROJECT_COST_PRIORITY_SUCCESS = exports.FETCH_PROJECT_COST_PRIORITY = exports.ADD_FAVOURITE_PROJECT_COST_PRIORITY_SUCCESS = exports.ADD_FAVOURITE_PROJECT_COST_PRIORITY = void 0;
exports.ADD_FAVOURITE_VALUE_STREAM = exports.UPDATE_SEARCH_MEMBER = exports.SHOW_MEMBER_MESSAGE = exports.ON_TOGGLE_MEMBER_DRAWER = exports.ON_SAVE_MEMBER_SUCCESS = exports.ON_SAVE_MEMBER = exports.ON_FILTER_MEMBER_OPTION_SELECT = exports.ON_FILTER_SELECTED_MEMBER = exports.ON_DELETE_MEMBER_SUCCESS = exports.ON_DELETE_MEMBER = exports.ON_MEMBER_SELECT = exports.ON_MEMBER_CLOSE = exports.ON_ALL_MEMBER_SELECT = exports.ON_EDIT_MEMBER = exports.ON_ADD_MEMBER = exports.SHOW_MEMBER_LOADER = exports.HIDE_MEMBER_LOADER = exports.HANDLE_MEMBER_REQUEST_CLOSE = exports.GET_UNSELECTED_ALL_MEMBER = exports.GET_ALL_MEMBER = exports.FILTER_MEMBER = exports.FETCH_ALL_MEMBER_SUCCESS = exports.FETCH_ALL_MEMBER = exports.FETCH_MEMBER_SUCCESS = exports.FETCH_MEMBER = exports.ADD_FAVOURITE_MEMBER_SUCCESS = exports.ADD_FAVOURITE_MEMBER = exports.ON_TEAM_MEMBER_UPDATE = exports.ON_FETCH_SELECT_MEMBER_DATA_SUCCESS = exports.ON_FETCH_SELECT_MEMBER_DATA = exports.UPDATE_SEARCH_TEAM = exports.SHOW_TEAM_MESSAGE = exports.ON_TOGGLE_TEAM_DRAWER = exports.ON_SAVE_TEAM_SUCCESS = exports.ON_SAVE_TEAM = exports.ON_FILTER_TEAM_OPTION_SELECT = exports.ON_FILTER_SELECTED_TEAM = exports.ON_DELETE_TEAM_SUCCESS = exports.ON_DELETE_TEAM = exports.ON_TEAM_SELECT = exports.ON_TEAM_CLOSE = exports.ON_ALL_TEAM_SELECT = exports.SET_TEAM = exports.ON_EDIT_TEAM = exports.ON_ADD_TEAM = exports.SHOW_TEAM_LOADER = exports.HIDE_TEAM_LOADER = exports.HANDLE_TEAM_REQUEST_CLOSE = exports.GET_UNSELECTED_ALL_TEAM = exports.GET_ALL_TEAM = exports.FILTER_TEAM = exports.FETCH_ALL_TEAM_SUCCESS = exports.FETCH_ALL_TEAM = exports.FETCH_TEAM_SUCCESS = exports.FETCH_TEAM = exports.ADD_FAVOURITE_TEAM_SUCCESS = exports.ADD_FAVOURITE_TEAM = exports.ON_PRODUCT_VALUESTREAM_UPDATE = exports.ON_FETCH_SELECT_VALUESTREAM_DATA_SUCCESS = exports.ON_FETCH_SELECT_VALUESTREAM_DATA = exports.UPDATE_SEARCH_PRODUCT = exports.SHOW_PRODUCT_MESSAGE = exports.ON_TOGGLE_PRODUCT_DRAWER = exports.ON_SAVE_PRODUCT_SUCCESS = exports.ON_SAVE_PRODUCT = exports.ON_FILTER_PRODUCT_OPTION_SELECT = exports.ON_FILTER_SELECTED_PRODUCT = exports.ON_DELETE_PRODUCT_SUCCESS = exports.ON_DELETE_PRODUCT = exports.ON_PRODUCT_SELECT = exports.ON_PRODUCT_CLOSE = exports.ON_ALL_PRODUCT_SELECT = exports.SET_PRODUCT = exports.ON_EDIT_PRODUCT = exports.ON_ADD_PRODUCT = exports.SHOW_PRODUCT_LOADER = exports.HIDE_PRODUCT_LOADER = exports.HANDLE_PRODUCT_REQUEST_CLOSE = exports.GET_UNSELECTED_ALL_PRODUCT = exports.GET_ALL_PRODUCT = exports.FILTER_PRODUCT = exports.FETCH_ALL_PRODUCT_SUCCESS = exports.FETCH_ALL_PRODUCT = exports.FETCH_PRODUCT_SUCCESS = exports.FETCH_PRODUCT = exports.FETCH_PRODUCT_LOOKUP_DATA = exports.ADD_FAVOURITE_PRODUCT_SUCCESS = exports.ADD_FAVOURITE_PRODUCT = exports.ON_INITIATIVE_PRODUCT_UPDATE = exports.ON_FETCH_SELECT_PRODUCT_DATA_SUCCESS = exports.ON_FETCH_SELECT_PRODUCT_DATA = exports.UPDATE_SEARCH_INITIATIVE = exports.SHOW_INITIATIVE_MESSAGE = exports.ON_TOGGLE_INITIATIVE_DRAWER = exports.ON_SAVE_INITIATIVE_SUCCESS = exports.ON_SAVE_INITIATIVE = exports.ON_FILTER_INITIATIVE_OPTION_SELECT = exports.ON_FILTER_SELECTED_INITIATIVE = exports.ON_DELETE_INITIATIVE_SUCCESS = exports.ON_DELETE_INITIATIVE = void 0;
exports.GET_UNSELECTED_ALL_BUSINESS_UNIT = exports.GET_ALL_BUSINESS_UNIT = exports.FILTER_BUSINESS_UNIT = exports.FETCH_ALL_BUSINESS_UNIT_SUCCESS = exports.FETCH_ALL_BUSINESS_UNIT = exports.FETCH_BUSINESS_UNIT_SUCCESS = exports.FETCH_BUSINESS_UNIT = exports.ADD_FAVOURITE_BUSINESS_UNIT_SUCCESS = exports.ADD_FAVOURITE_BUSINESS_UNIT = exports.UPDATE_SEARCH_PORTFOLIO = exports.SHOW_PORTFOLIO_MESSAGE = exports.ON_TOGGLE_PORTFOLIO_DRAWER = exports.ON_SAVE_PORTFOLIO_SUCCESS = exports.ON_SAVE_PORTFOLIO = exports.ON_FILTER_PORTFOLIO_OPTION_SELECT = exports.ON_FILTER_SELECTED_PORTFOLIO = exports.ON_DELETE_PORTFOLIO_SUCCESS = exports.ON_DELETE_PORTFOLIO = exports.ON_PORTFOLIO_SELECT = exports.ON_PORTFOLIO_CLOSE = exports.ON_ALL_PORTFOLIO_SELECT = exports.ON_EDIT_PORTFOLIO = exports.ON_ADD_PORTFOLIO = exports.SHOW_PORTFOLIO_LOADER = exports.HIDE_PORTFOLIO_LOADER = exports.HANDLE_PORTFOLIO_REQUEST_CLOSE = exports.GET_UNSELECTED_ALL_PORTFOLIO = exports.GET_ALL_PORTFOLIO = exports.FILTER_PORTFOLIO = exports.FETCH_ALL_PORTFOLIO_SUCCESS = exports.FETCH_ALL_PORTFOLIO = exports.FETCH_PORTFOLIO_SUCCESS = exports.FETCH_PORTFOLIO = exports.ADD_FAVOURITE_PORTFOLIO_SUCCESS = exports.ADD_FAVOURITE_PORTFOLIO = exports.ON_PORTFOLIO_DASHBOARD_SUCCESS = exports.ON_PORTFOLIO_DASHBOARD = exports.SELECT_PORTFOLIO = exports.ON_FETCH_SELECT_FEATURE_DEPENDENCIES_SUCCESS = exports.ON_FETCH_SELECT_FEATURE_OUTWARD_DEPENDENCIES = exports.ON_FETCH_SELECT_FEATURE_INWARD_DEPENDENCIES = exports.ON_FEATURE_DEPENDENCY_UPDATE_SUCCESS = exports.ON_FEATURE_OUTWARD_DEPENDENCY_UPDATE = exports.ON_FEATURE_INWARD_DEPENDENCY_UPDATE = exports.SET_FEATURE = exports.UPDATE_SEARCH_FEATURE = exports.SHOW_FEATURE_MESSAGE = exports.ON_TOGGLE_FEATURE_DRAWER = exports.ON_SAVE_FEATURE_SUCCESS = exports.ON_SAVE_FEATURE = exports.ON_FILTER_FEATURE_OPTION_SELECT = exports.ON_FILTER_SELECTED_FEATURE = exports.ON_DELETE_FEATURE_SUCCESS = exports.ON_DELETE_FEATURE = exports.ON_FEATURE_SELECT = exports.ON_FEATURE_CLOSE = exports.ON_ALL_FEATURE_SELECT = exports.ON_EDIT_FEATURE = exports.ON_ADD_FEATURE = exports.SHOW_FEATURE_LOADER = exports.HIDE_FEATURE_LOADER = exports.HANDLE_FEATURE_REQUEST_CLOSE = exports.GET_UNSELECTED_ALL_FEATURE = exports.GET_ALL_FEATURE = exports.FILTER_FEATURE = exports.FETCH_ALL_FEATURE_SUCCESS = exports.FETCH_ALL_FEATURE = exports.FETCH_FEATURE_SUCCESS = exports.FETCH_FEATURE = exports.ADD_FAVOURITE_FEATURE_SUCCESS = exports.ADD_FAVOURITE_FEATURE = exports.ON_VALUE_STREAM_TEAM_UPDATE = exports.ON_FETCH_SELECT_TEAM_DATA_SUCCESS = exports.ON_FETCH_SELECT_TEAM_DATA = exports.UPDATE_SEARCH_VALUE_STREAM = exports.SHOW_VALUE_STREAM_MESSAGE = exports.ON_TOGGLE_VALUE_STREAM_DRAWER = exports.ON_SAVE_VALUE_STREAM_SUCCESS = exports.ON_SAVE_VALUE_STREAM = exports.ON_FILTER_VALUE_STREAM_OPTION_SELECT = exports.ON_FILTER_SELECTED_VALUE_STREAM = exports.ON_DELETE_VALUE_STREAM_SUCCESS = exports.ON_DELETE_VALUE_STREAM = exports.ON_VALUE_STREAM_SELECT = exports.ON_VALUE_STREAM_CLOSE = exports.ON_ALL_VALUE_STREAM_SELECT = exports.SET_VALUE_STREAM = exports.ON_EDIT_VALUE_STREAM = exports.ON_ADD_VALUE_STREAM = exports.SHOW_VALUE_STREAM_LOADER = exports.HIDE_VALUE_STREAM_LOADER = exports.HANDLE_VALUE_STREAM_REQUEST_CLOSE = exports.GET_UNSELECTED_ALL_VALUE_STREAM = exports.GET_ALL_VALUE_STREAM = exports.FILTER_VALUE_STREAM = exports.FETCH_ALL_VALUE_STREAM_SUCCESS = exports.FETCH_ALL_VALUE_STREAM = exports.FETCH_VALUE_STREAM_SUCCESS = exports.FETCH_VALUE_STREAM = exports.ADD_FAVOURITE_VALUE_STREAM_SUCCESS = void 0;
exports.FETCH_IMPORT_PROJECTS_SUCCESS = exports.FETCH_IMPORT_PROJECTS = exports.ON_PROJECT_BUSINESS_PRIORITIES_DASHBOARD = exports.ON_GLOBAL_PROJECT_BUSINESS_PRIORITIES_DASHBOARD = exports.ON_GLOBAL_PROJECT_COST_PRIORITIES_DASHBOARD = exports.ON_PROJECT_COST_PRIORITIES_DASHBOARD = exports.UPDATE_SEARCH_PROJECT = exports.SHOW_PROJECT_MESSAGE = exports.ON_TOGGLE_PROJECT_DRAWER = exports.ON_SAVE_PROJECT_SUCCESS = exports.ON_UPDATE_PROJECT_PRIORITIES = exports.ON_SAVE_PROJECT = exports.ON_FILTER_PROJECT_OPTION_SELECT = exports.ON_DELETE_SELECTED_PROJECT = exports.ON_DELETE_PROJECT_SUCCESS = exports.ON_DELETE_PROJECT = exports.ON_PROJECT_SELECT = exports.ON_PROJECT_CLOSE = exports.ON_ALL_PROJECT_SELECT = exports.ON_EDIT_PROJECT = exports.ON_ADD_PROJECT = exports.SHOW_PROJECT_LOADER = exports.HIDE_PROJECT_LOADER = exports.HANDLE_PROJECT_REQUEST_CLOSE = exports.GET_UNSELECTED_ALL_PROJECT = exports.GET_ALL_PROJECT = exports.FILTER_PROJECT = exports.FETCH_ALL_PROJECT_SUCCESS = exports.FETCH_ALL_PROJECT = exports.FETCH_PROJECT_SUCCESS = exports.FETCH_PROJECT = exports.ADD_FAVOURITE_PROJECT_SUCCESS = exports.ADD_FAVOURITE_PROJECT = exports.UPDATE_SEARCH_PROJECT_PRIORITY = exports.SHOW_PROJECT_PRIORITY_MESSAGE = exports.ON_TOGGLE_PROJECT_PRIORITY_DRAWER = exports.ON_SAVE_PROJECT_PRIORITY_SUCCESS = exports.ON_SAVE_PROJECT_PRIORITY = exports.ON_FILTER_PROJECT_PRIORITY_OPTION_SELECT = exports.ON_DELETE_SELECTED_PROJECT_PRIORITY = exports.ON_DELETE_PROJECT_PRIORITY_SUCCESS = exports.ON_DELETE_PROJECT_PRIORITY = exports.ON_PROJECT_PRIORITY_SELECT = exports.ON_PROJECT_PRIORITY_CLOSE = exports.ON_ALL_PROJECT_PRIORITY_SELECT = exports.ON_ADD_PROJECT_PRIORITY = exports.SHOW_PROJECT_PRIORITY_LOADER = exports.HIDE_PROJECT_PRIORITY_LOADER = exports.HANDLE_PROJECT_PRIORITY_REQUEST_CLOSE = exports.GET_UNSELECTED_ALL_PROJECT_PRIORITY = exports.GET_ALL_PROJECT_PRIORITY = exports.FILTER_PROJECT_PRIORITY = exports.FETCH_ALL_PROJECT_PRIORITY_SUCCESS = exports.FETCH_ALL_PROJECT_PRIORITY = exports.FETCH_PROJECT_PRIORITY_SUCCESS = exports.FETCH_PROJECT_PRIORITY = exports.ADD_FAVOURITE_PROJECT_PRIORITY = exports.UPDATE_SEARCH_PROJECT_ISSUE = exports.SHOW_PROJECT_ISSUE_MESSAGE = exports.ON_TOGGLE_PROJECT_ISSUE_DRAWER = exports.ON_SAVE_PROJECT_ISSUE_SUCCESS = exports.ON_SAVE_JIRA_PROJECT_ISSUE = exports.ON_SAVE_PROJECT_ISSUE = exports.ON_FILTER_PROJECT_ISSUE_OPTION_SELECT = exports.ON_FILTER_SELECTED_PROJECT_ISSUE = exports.ON_DELETE_PROJECT_ISSUE_SUCCESS = exports.ON_DELETE_PROJECT_ISSUE = exports.ON_PROJECT_ISSUE_SELECT = exports.ON_PROJECT_ISSUE_CLOSE = exports.ON_ALL_PROJECT_ISSUE_SELECT = exports.ON_ADD_JIRA_PROJECT_ISSUE = exports.ON_ADD_PROJECT_ISSUE = exports.SHOW_PROJECT_ISSUE_LOADER = exports.HIDE_PROJECT_ISSUE_LOADER = exports.HANDLE_PROJECT_ISSUE_REQUEST_CLOSE = exports.GET_UNSELECTED_ALL_PROJECT_ISSUE = exports.GET_ALL_PROJECT_ISSUE = exports.FILTER_PROJECT_ISSUE = exports.FETCH_ALL_PROJECT_ISSUE_SUCCESS = exports.FETCH_ALL_PROJECT_ISSUE = exports.FETCH_PROJECT_ISSUE_SUCCESS = exports.FETCH_PROJECT_ISSUE = exports.ADD_FAVOURITE_PROJECT_ISSUE_SUCCESS = exports.ADD_FAVOURITE_PROJECT_ISSUE = exports.UPDATE_SEARCH_BUSINESS_UNIT = exports.SHOW_BUSINESS_UNIT_MESSAGE = exports.ON_TOGGLE_BUSINESS_UNIT_DRAWER = exports.ON_SAVE_BUSINESS_UNIT_SUCCESS = exports.ON_SAVE_BUSINESS_UNIT = exports.ON_FILTER_BUSINESS_UNIT_OPTION_SELECT = exports.ON_FILTER_SELECTED_BUSINESS_UNIT = exports.ON_DELETE_BUSINESS_UNIT_SUCCESS = exports.ON_DELETE_BUSINESS_UNIT = exports.ON_BUSINESS_UNIT_SELECT = exports.ON_BUSINESS_UNIT_CLOSE = exports.ON_ALL_BUSINESS_UNIT_SELECT = exports.ON_ADD_BUSINESS_UNIT = exports.SHOW_BUSINESS_UNIT_LOADER = exports.HIDE_BUSINESS_UNIT_LOADER = exports.HANDLE_BUSINESS_UNIT_REQUEST_CLOSE = void 0;
exports.ON_IMPORTANT_SELECT = exports.ON_FOLDER_SELECT = exports.ON_FOLDER_MENU_ITEM_SELECT = exports.ON_ALL_MAIL_SELECT = exports.GET_UNSTARRED_MAIL = exports.GET_UNSELECTED_ALL_MAIL = exports.GET_UNREAD_MAIL = exports.GET_UNIMPORTANT_MAIL = exports.GET_STARRED_MAIL = exports.GET_READ_MAIL = exports.GET_NAV_FOLDER = exports.GET_NAV_LABELS = exports.GET_NAV_FILTERS = exports.GET_IMPORTANT_MAIL = exports.FETCH_ALL_MAIL_SUCCESS = exports.FETCH_ALL_MAIL = exports.GET_ALL_MAIL = exports.ADD_LABEL = exports.UPDATE_SEARCH_CHAT_USER = exports.UPDATE_MESSAGE_VALUE = exports.SUBMIT_COMMENT = exports.USER_INFO_STATE = exports.ON_SELECT_USER = exports.FILTER_USERS = exports.FETCH_ALL_CHAT_USER_CONVERSATION_SUCCESS = exports.FETCH_ALL_CHAT_USER_SUCCESS = exports.FETCH_ALL_CHAT_USER_CONVERSATION = exports.FETCH_ALL_CHAT_USER = exports.REQUEST_SIGNIN_ACCESS_CODE_SUCCESS = exports.REQUEST_SIGNIN_ACCESS_CODE = exports.IDENTITY_SUCCESS = exports.INIT_URL = exports.SIGNOUT_USER_SUCCESS = exports.SIGNOUT_USER = exports.SIGNIN_USER_SUCCESS = exports.SIGNIN_USER_PASSWORDLESS = exports.SIGNIN_USER = exports.SIGNIN_GITHUB_USER_SUCCESS = exports.SIGNIN_GITHUB_USER = exports.SIGNIN_TWITTER_USER_SUCCESS = exports.SIGNIN_TWITTER_USER = exports.SIGNIN_FACEBOOK_USER_SUCCESS = exports.SIGNIN_FACEBOOK_USER = exports.SIGNIN_GOOGLE_USER_SUCCESS = exports.SIGNIN_GOOGLE_USER = exports.SIGNUP_USER_SUCCESS = exports.SIGNUP_USER = exports.HIDE_CONTACT_LOADER = exports.UPDATE_SEARCH_USER = exports.ON_ALL_CONTACT_SELECT = exports.GET_UNSELECTED_ALL_CONTACT = exports.GET_ALL_CONTACT = exports.FILTER_CONTACT = exports.ON_DELETE_SELECTED_CONTACT = exports.ON_DELETE_CONTACT = exports.ON_SAVE_CONTACT = exports.ON_FILTER_OPTION_SELECT = exports.ON_CONTACT_CLOSE = exports.ON_ADD_CONTACT = exports.ON_CONTACT_SELECT = exports.FETCH_ALL_CONTACT_SUCCESS = exports.FETCH_ALL_CONTACT = exports.ADD_FAVOURITE = exports.HANDLE_REQUEST_CLOSE = exports.ON_TOGGLE_DRAWER = exports.ON_HIDE_LOADER = exports.ON_SHOW_LOADER = exports.HIDE_MESSAGE = exports.SHOW_MESSAGE = exports.CLEAR_SELECTED_OBJECTS = exports.CLEAR_SESSION = exports.USER_INFO_MODAL = exports.COLOR_OPTIONS_MODAL = exports.BELOW_THE_HEADER = exports.INSIDE_THE_HEADER = exports.ABOVE_THE_HEADER = exports.HORIZONTAL_MENU_POSITION = exports.VERTICAL_NAVIGATION = exports.HORIZONTAL_NAVIGATION = exports.CHANGE_NAVIGATION_STYLE = exports.CHANGE_DIRECTION = exports.SWITCH_LANGUAGE = exports.WINDOW_HEIGHT = exports.WINDOW_WIDTH = exports.DARK_THEME = exports.THEME_COLOR = exports.MINI_DRAWER = exports.COLLAPSED_DRAWER = exports.FIXED_DRAWER = exports.DRAWER_TYPE = exports.TOGGLE_COLLAPSED_NAV = exports.SET_PROJECT = exports.SET_PROJECT_ISSUE = exports.ON_SAVE_PROJECT_CACHE_SUCCESS = exports.ON_SAVE_PROJECT_ISSUE_CACHE_SUCCESS = exports.ON_PROJECT_ISSUES_DASHBOARD = exports.ON_IMPORT_PROJECTS_SUCCESS = exports.ON_IMPORT_PROJECTS = exports.HIDE_IMPORT_PROJECTS_LOADER = exports.SHOW_IMPORT_PROJECTS_LOADER = void 0;
exports.FETCH_NOTIFICATIONS_SUCCESS = exports.FETCH_NOTIFICATIONS = exports.SAVE_EMP_SURVEY_ANSWERS_SUCCESS = exports.SAVE_EMP_SURVEY_ANSWERS = exports.FETCH_EMP_SURVEY_ANSWERS_SUCCESS = exports.FETCH_EMP_SURVEY_ANSWERS = exports.UPDATE_SEARCH_EMP = exports.ON_ALL_EMP_SELECT = exports.GET_UNSELECTED_ALL_EMP = exports.GET_ALL_EMP = exports.FILTER_EMP = exports.ON_DELETE_SELECTED_EMP = exports.ON_DELETE_EMP = exports.ON_SAVE_EMP_SUCCESS = exports.ON_SAVE_EMP = exports.ON_EMP_CLOSE = exports.ON_ADD_EMP = exports.ON_EMP_SELECT = exports.FETCH_ALL_EMP_SUCCESS = exports.FETCH_ALL_EMP = exports.ADD_FAVOURITE_EMP_SUCCESS = exports.ADD_FAVOURITE_EMP = exports.SHOW_EMP_LOADER = exports.HIDE_EMP_DASHBOARD_LOADER = exports.SHOW_EMP_DASHBOARD_LOADER = exports.HIDE_EMP_LOADER = exports.ON_FILTER_EMP_OPTION_SELECT = exports.HANDLE_EMP_REQUEST_CLOSE = exports.ON_TOGGLE_EMP_DRAWER = exports.SHOW_EMP_MESSAGE = exports.FETCH_ORG_STATISTICS_SUCCESS = exports.FETCH_ORG_STATISTICS = exports.ON_PROJECT_PRIORITY_DASHBOARD = exports.ON_IMPERSONATE_DASHBOARD = exports.ON_PROJECT_DASHBOARD = exports.ON_ORG_DASHBOARD_SUCCESS = exports.ON_ORG_DASHBOARD = exports.ON_ORG_SURVEY_DASHBOARD = exports.ON_EMP_DASHBOARD = exports.UPDATE_SEARCH_ORG = exports.ON_ALL_ORG_SELECT = exports.GET_UNSELECTED_ALL_ORG = exports.GET_ALL_ORG = exports.FILTER_ORG = exports.ON_DELETE_SELECTED_ORG = exports.ON_DELETE_ORG = exports.ON_SAVE_ORG_SUCCESS = exports.ON_SAVE_ORG = exports.ON_ORG_CLOSE = exports.ON_ADD_ORG = exports.ON_ORG_SELECT = exports.FETCH_ALL_ORG_SUCCESS = exports.FETCH_ALL_ORG = exports.FETCH_ORGS_SELECT_ORG = exports.FETCH_ORG_SUCCESS = exports.FETCH_ORG = exports.ADD_FAVOURITE_ORG = exports.SHOW_ORG_LOADER = exports.HIDE_ORG_LOADER = exports.ON_FILTER_ORG_OPTION_SELECT = exports.HANDLE_ORG_REQUEST_CLOSE = exports.ON_TOGGLE_ORG_DRAWER = exports.SHOW_ORG_MESSAGE = exports.UPDATE_SEARCH = exports.REMOVE_LABEL = exports.SET_CURRENT_TODO_NULL = exports.ON_TODO_SELECT = exports.ON_TODO_ADD = exports.ON_TODO_CHECKED = exports.GET_TODO_CONVERSATION = exports.SHOW_TODOS = exports.SEARCH_TODO = exports.ON_DELETE_TODO = exports.ON_TODO_UPDATE = exports.ON_LABEL_UPDATE = exports.GET_UNIMPORTANT_TODO = exports.GET_IMPORTANT_TODO = exports.GET_UNSTARRED_TODO = exports.GET_STARRED_TODO = exports.GET_UNSELECTED_ALL_TODO = exports.GET_ALL_TODO = exports.SELECT_ALL_TODO = exports.FETCH_ALL_TODO_CONVERSATION_SUCCESS = exports.FETCH_ALL_TODO_CONVERSATION = exports.FETCH_ALL_TODO_SUCCESS = exports.FETCH_ALL_TODO = exports.ON_SORTEND = exports.ON_COMPOSE_MAIL = exports.SET_CURRENT_MAIL_NULL = exports.ON_DELETE_MAIL = exports.SEARCH_MAIL = exports.ON_START_SELECT = exports.ON_OPTION_MENU_SELECT = exports.ON_OPTION_MENU_ITEM_SELECT = exports.ON_MAIL_SEND = exports.ON_MAIL_SELECT = exports.ON_MAIL_CHECKED = exports.ON_LABEL_SELECT = exports.GET_MARK_AS_START = exports.ON_LABEL_MENU_ITEM_SELECT = void 0;
exports.ADD_FAVOURITE_SURVEY_GROUP_QUESTION = exports.SHOW_SURVEY_GROUP_QUESTION_LOADER = exports.HIDE_SURVEY_GROUP_QUESTION_LOADER = exports.ON_FILTER_SURVEY_GROUP_QUESTION_OPTION_SELECT = exports.HANDLE_SURVEY_GROUP_QUESTION_REQUEST_CLOSE = exports.ON_TOGGLE_SURVEY_GROUP_QUESTION_DRAWER = exports.SHOW_SURVEY_GROUP_QUESTION_MESSAGE = exports.SHOW_SURVEY_QUESTION_LOADER = exports.HIDE_SURVEY_QUESTION_LOADER = exports.FETCH_ALL_SURVEY_QUESTION = exports.FETCH_ALL_SURVEY_QUESTION_SUCCESS = exports.SHOW_SURVEY_QUESTION_MESSAGE = exports.ON_SURVEY_GROUP_QUESTIONS = exports.UPDATE_SEARCH_SURVEY_GROUP = exports.ON_ALL_SURVEY_GROUP_SELECT = exports.GET_UNSELECTED_ALL_SURVEY_GROUP = exports.GET_ALL_SURVEY_GROUP = exports.FILTER_SURVEY_GROUP = exports.ON_DELETE_SELECTED_SURVEY_GROUP = exports.ON_DELETE_SURVEY_GROUP = exports.ON_SAVE_SURVEY_GROUP_SUCCESS = exports.ON_SAVE_SURVEY_GROUP = exports.ON_SURVEY_GROUP_CLOSE = exports.ON_ADD_SURVEY_GROUP = exports.ON_SURVEY_GROUP_SELECT = exports.FETCH_ALL_SURVEY_GROUP_SUCCESS = exports.FETCH_ALL_SURVEY_GROUP = exports.ADD_FAVOURITE_SURVEY_GROUP = exports.SHOW_SURVEY_GROUP_LOADER = exports.HIDE_SURVEY_GROUP_LOADER = exports.ON_FILTER_SURVEY_GROUP_OPTION_SELECT = exports.HANDLE_SURVEY_GROUP_REQUEST_CLOSE = exports.ON_TOGGLE_SURVEY_GROUP_DRAWER = exports.SHOW_SURVEY_GROUP_MESSAGE = exports.ON_SURVEY_QUESTIONS = exports.UPDATE_SEARCH_SURVEY = exports.ON_ALL_SURVEY_SELECT = exports.GET_UNSELECTED_ALL_SURVEY = exports.GET_ALL_SURVEY = exports.FILTER_SURVEY = exports.ON_DELETE_SELECTED_SURVEY = exports.ON_DELETE_SURVEY = exports.ON_SAVE_SURVEY_SUCCESS = exports.ON_SAVE_SURVEY = exports.ON_SURVEY_CLOSE = exports.ON_ADD_SURVEY = exports.ON_SURVEY_SELECT = exports.FETCH_ALL_SURVEY_SUCCESS = exports.FETCH_ALL_SURVEY = exports.ADD_FAVOURITE_SURVEY = exports.SHOW_SURVEY_LOADER = exports.HIDE_SURVEY_LOADER = exports.ON_FILTER_SURVEY_OPTION_SELECT = exports.HANDLE_SURVEY_REQUEST_CLOSE = exports.ON_TOGGLE_SURVEY_DRAWER = exports.SHOW_SURVEY_MESSAGE = exports.HANDLE_ORG_SURVEY_ANSWER_MESSAGE_CLOSE = exports.SHOW_ORG_SURVEY_ANSWERS_MESSAGE = exports.SHOW_ORG_SURVEY_ANSWERS_LOADER = exports.HIDE_ORG_SURVEY_ANSWERS_LOADER = exports.FETCH_ORG_SURVEY_ANSWERS_SUCCESS = exports.FETCH_ORG_SURVEY_ANSWERS = exports.ON_SAVE_ORG_SURVEY_ANSWERS_SUCCESS = exports.ON_SAVE_ORG_SURVEY_ANSWERS = exports.FETCH_ALL_ORG_SURVEY_ENGAGEMENT_REPORT_CHART_DATA_SUCCESS = exports.FETCH_ALL_ORG_SURVEY_ENGAGEMENT_REPORT_CHART_DATA = exports.FETCH_ALL_ORG_SURVEY_COMPARE_BOTTOM_RESULTS_CHART_DATA_SUCCESS = exports.FETCH_ALL_ORG_SURVEY_COMPARE_BOTTOM_RESULTS_CHART_DATA = exports.FETCH_ALL_ORG_SURVEY_COMPARE_TOP_RESULTS_CHART_DATA_SUCCESS = exports.FETCH_ALL_ORG_SURVEY_COMPARE_TOP_RESULTS_CHART_DATA = exports.FETCH_ALL_ORG_SURVEY_COMPARE_DISTRIBUTIONS_CHART_DATA_SUCCESS = exports.FETCH_ALL_ORG_SURVEY_COMPARE_DISTRIBUTIONS_CHART_DATA = exports.FETCH_ALL_ORG_SURVEY_COMPARE_RADAR_CHART_DATA_SUCCESS = exports.FETCH_ALL_ORG_SURVEY_COMPARE_RADAR_CHART_DATA = exports.FETCH_ALL_ORG_SURVEY_COMPARE_SUCCESS = exports.FETCH_ALL_ORG_SURVEY_COMPARE = exports.ON_ORG_SURVEY_COMPARE_SELECT = exports.ON_ORG_SURVEY_COMPARE_DASHBOARD = exports.ON_ORG_SURVEY_QUESTIONS = exports.UPDATE_SEARCH_ORG_SURVEY = exports.ON_ALL_ORG_SURVEY_SELECT = exports.GET_UNSELECTED_ALL_ORG_SURVEY = exports.GET_ALL_ORG_SURVEY = exports.FILTER_ORG_SURVEY = exports.ON_DELETE_SELECTED_ORG_SURVEY = exports.ON_DELETE_ORG_SURVEY = exports.ON_SAVE_ORG_SURVEY_SUCCESS = exports.ON_SAVE_ORG_SURVEY = exports.ON_ORG_SURVEY_CLOSE = exports.ON_ADD_ORG_SURVEY = exports.ON_ORG_SURVEY_SELECT = exports.FETCH_ALL_ORG_SURVEY_SUCCESS = exports.FETCH_ALL_ORG_SURVEY = exports.ADD_FAVOURITE_ORG_SURVEY = exports.SHOW_ORG_SURVEY_LOADER = exports.HIDE_ORG_SURVEY_LOADER = exports.ON_FILTER_ORG_SURVEY_OPTION_SELECT = exports.HANDLE_ORG_SURVEY_REQUEST_CLOSE = exports.ON_TOGGLE_ORG_SURVEY_DRAWER = exports.SHOW_ORG_SURVEY_MESSAGE = void 0;
exports.UPDATE_SEARCH_SECURITY = exports.SHOW_SECURITY_MESSAGE = exports.ON_TOGGLE_SECURITY_DRAWER = exports.ON_SAVE_SECURITY_SUCCESS = exports.ON_SAVE_SECURITY = exports.ON_FILTER_SECURITY_OPTION_SELECT = exports.ON_FILTER_SELECTED_SECURITY = exports.ON_DELETE_SECURITY_SUCCESS = exports.ON_DELETE_SECURITY = exports.ON_SECURITY_SELECT = exports.ON_SECURITY_CLOSE = exports.ON_ALL_SECURITY_SELECT = exports.ON_ADD_SECURITY = exports.SHOW_SECURITY_LOADER = exports.HIDE_SECURITY_LOADER = exports.HANDLE_SECURITY_REQUEST_CLOSE = exports.GET_UNSELECTED_ALL_SECURITY = exports.GET_ALL_SECURITY = exports.FILTER_SECURITY = exports.FETCH_ALL_SECURITY_SUCCESS = exports.FETCH_ALL_SECURITY = exports.FETCH_SECURITY_SUCCESS = exports.FETCH_SECURITY = exports.ADD_FAVOURITE_SECURITY_SUCCESS = exports.ADD_FAVOURITE_SECURITY = exports.UPDATE_SEARCH_SURVEY_GROUP_QUESTION = exports.ON_ALL_SURVEY_GROUP_QUESTION_SELECT = exports.GET_UNSELECTED_ALL_SURVEY_GROUP_QUESTION = exports.GET_ALL_SURVEY_GROUP_QUESTION = exports.FILTER_SURVEY_GROUP_QUESTION = exports.ON_DELETE_SELECTED_SURVEY_GROUP_QUESTION = exports.ON_DELETE_SURVEY_GROUP_QUESTION = exports.ON_SAVE_SURVEY_GROUP_QUESTION = exports.ON_SURVEY_GROUP_QUESTION_CLOSE = exports.ON_ADD_SURVEY_GROUP_QUESTION = exports.ON_SURVEY_GROUP_QUESTION_SELECT = exports.FETCH_ALL_SURVEY_GROUP_QUESTION_SUCCESS = exports.FETCH_ALL_SURVEY_GROUP_QUESTION = void 0; // projectCostPriority component actionTypes

var ADD_FAVOURITE_PROJECT_COST_PRIORITY = 'add_favourite_project_cost_priority';
exports.ADD_FAVOURITE_PROJECT_COST_PRIORITY = ADD_FAVOURITE_PROJECT_COST_PRIORITY;
var ADD_FAVOURITE_PROJECT_COST_PRIORITY_SUCCESS = 'add_favourite_project_cost_priority_success';
exports.ADD_FAVOURITE_PROJECT_COST_PRIORITY_SUCCESS = ADD_FAVOURITE_PROJECT_COST_PRIORITY_SUCCESS;
var FETCH_PROJECT_COST_PRIORITY = 'fetch_project_cost_priority';
exports.FETCH_PROJECT_COST_PRIORITY = FETCH_PROJECT_COST_PRIORITY;
var FETCH_PROJECT_COST_PRIORITY_SUCCESS = 'fetch_project_cost_priority_success';
exports.FETCH_PROJECT_COST_PRIORITY_SUCCESS = FETCH_PROJECT_COST_PRIORITY_SUCCESS;
var FETCH_ALL_PROJECT_COST_PRIORITY = 'fetch_all_project_cost_priority';
exports.FETCH_ALL_PROJECT_COST_PRIORITY = FETCH_ALL_PROJECT_COST_PRIORITY;
var FETCH_ALL_PROJECT_COST_PRIORITY_SUCCESS = 'fetch_all_project_cost_priority_success';
exports.FETCH_ALL_PROJECT_COST_PRIORITY_SUCCESS = FETCH_ALL_PROJECT_COST_PRIORITY_SUCCESS;
var FILTER_PROJECT_COST_PRIORITY = 'filter_project_cost_priority';
exports.FILTER_PROJECT_COST_PRIORITY = FILTER_PROJECT_COST_PRIORITY;
var GET_ALL_PROJECT_COST_PRIORITY = 'get_all_project_cost_priority';
exports.GET_ALL_PROJECT_COST_PRIORITY = GET_ALL_PROJECT_COST_PRIORITY;
var GET_UNSELECTED_ALL_PROJECT_COST_PRIORITY = 'get_unselected_all_project_cost_priority';
exports.GET_UNSELECTED_ALL_PROJECT_COST_PRIORITY = GET_UNSELECTED_ALL_PROJECT_COST_PRIORITY;
var HANDLE_PROJECT_COST_PRIORITY_REQUEST_CLOSE = 'handle_project_cost_priority_request_close';
exports.HANDLE_PROJECT_COST_PRIORITY_REQUEST_CLOSE = HANDLE_PROJECT_COST_PRIORITY_REQUEST_CLOSE;
var HIDE_PROJECT_COST_PRIORITY_LOADER = 'hide_project_cost_priority_loader';
exports.HIDE_PROJECT_COST_PRIORITY_LOADER = HIDE_PROJECT_COST_PRIORITY_LOADER;
var SHOW_PROJECT_COST_PRIORITY_LOADER = 'show_project_cost_priority_loader';
exports.SHOW_PROJECT_COST_PRIORITY_LOADER = SHOW_PROJECT_COST_PRIORITY_LOADER;
var ON_ADD_PROJECT_COST_PRIORITY = 'on_add_project_cost_priority';
exports.ON_ADD_PROJECT_COST_PRIORITY = ON_ADD_PROJECT_COST_PRIORITY;
var ON_EDIT_PROJECT_COST_PRIORITY = 'on_edit_project_cost_priority';
exports.ON_EDIT_PROJECT_COST_PRIORITY = ON_EDIT_PROJECT_COST_PRIORITY;
var ON_ALL_PROJECT_COST_PRIORITY_SELECT = 'on_all_project_cost_priority_select';
exports.ON_ALL_PROJECT_COST_PRIORITY_SELECT = ON_ALL_PROJECT_COST_PRIORITY_SELECT;
var ON_PROJECT_COST_PRIORITY_CLOSE = 'on_project_cost_priority_close';
exports.ON_PROJECT_COST_PRIORITY_CLOSE = ON_PROJECT_COST_PRIORITY_CLOSE;
var ON_PROJECT_COST_PRIORITY_SELECT = 'on_project_cost_priority_select';
exports.ON_PROJECT_COST_PRIORITY_SELECT = ON_PROJECT_COST_PRIORITY_SELECT;
var ON_DELETE_PROJECT_COST_PRIORITY = 'on_delete_project_cost_priority';
exports.ON_DELETE_PROJECT_COST_PRIORITY = ON_DELETE_PROJECT_COST_PRIORITY;
var ON_DELETE_PROJECT_COST_PRIORITY_SUCCESS = 'on_delete_project_cost_priority_success';
exports.ON_DELETE_PROJECT_COST_PRIORITY_SUCCESS = ON_DELETE_PROJECT_COST_PRIORITY_SUCCESS;
var ON_FILTER_SELECTED_PROJECT_COST_PRIORITY = 'on_filter_selected_project_cost_priority';
exports.ON_FILTER_SELECTED_PROJECT_COST_PRIORITY = ON_FILTER_SELECTED_PROJECT_COST_PRIORITY;
var ON_FILTER_PROJECT_COST_PRIORITY_OPTION_SELECT = 'on_filter_project_cost_priority_option_select';
exports.ON_FILTER_PROJECT_COST_PRIORITY_OPTION_SELECT = ON_FILTER_PROJECT_COST_PRIORITY_OPTION_SELECT;
var ON_SAVE_PROJECT_COST_PRIORITY = 'on_save_project_cost_priority';
exports.ON_SAVE_PROJECT_COST_PRIORITY = ON_SAVE_PROJECT_COST_PRIORITY;
var ON_SAVE_PROJECT_COST_PRIORITY_SUCCESS = 'on_save_project_cost_priority_success';
exports.ON_SAVE_PROJECT_COST_PRIORITY_SUCCESS = ON_SAVE_PROJECT_COST_PRIORITY_SUCCESS;
var ON_TOGGLE_PROJECT_COST_PRIORITY_DRAWER = 'on_toggle_project_cost_priority_drawer';
exports.ON_TOGGLE_PROJECT_COST_PRIORITY_DRAWER = ON_TOGGLE_PROJECT_COST_PRIORITY_DRAWER;
var SHOW_PROJECT_COST_PRIORITY_MESSAGE = 'show_project_cost_priority_message';
exports.SHOW_PROJECT_COST_PRIORITY_MESSAGE = SHOW_PROJECT_COST_PRIORITY_MESSAGE;
var UPDATE_SEARCH_PROJECT_COST_PRIORITY = 'update_search_project_cost_priority'; // projectBusPriority component actionTypes

exports.UPDATE_SEARCH_PROJECT_COST_PRIORITY = UPDATE_SEARCH_PROJECT_COST_PRIORITY;
var ADD_FAVOURITE_PROJECT_BUS_PRIORITY = 'add_favourite_project_bus_priority';
exports.ADD_FAVOURITE_PROJECT_BUS_PRIORITY = ADD_FAVOURITE_PROJECT_BUS_PRIORITY;
var ADD_FAVOURITE_PROJECT_BUS_PRIORITY_SUCCESS = 'add_favourite_project_bus_priority_success';
exports.ADD_FAVOURITE_PROJECT_BUS_PRIORITY_SUCCESS = ADD_FAVOURITE_PROJECT_BUS_PRIORITY_SUCCESS;
var FETCH_PROJECT_BUS_PRIORITY = 'fetch_project_bus_priority';
exports.FETCH_PROJECT_BUS_PRIORITY = FETCH_PROJECT_BUS_PRIORITY;
var FETCH_PROJECT_BUS_PRIORITY_SUCCESS = 'fetch_project_bus_priority_success';
exports.FETCH_PROJECT_BUS_PRIORITY_SUCCESS = FETCH_PROJECT_BUS_PRIORITY_SUCCESS;
var FETCH_ALL_PROJECT_BUS_PRIORITY = 'fetch_all_project_bus_priority';
exports.FETCH_ALL_PROJECT_BUS_PRIORITY = FETCH_ALL_PROJECT_BUS_PRIORITY;
var FETCH_ALL_PROJECT_BUS_PRIORITY_SUCCESS = 'fetch_all_project_bus_priority_success';
exports.FETCH_ALL_PROJECT_BUS_PRIORITY_SUCCESS = FETCH_ALL_PROJECT_BUS_PRIORITY_SUCCESS;
var FILTER_PROJECT_BUS_PRIORITY = 'filter_project_bus_priority';
exports.FILTER_PROJECT_BUS_PRIORITY = FILTER_PROJECT_BUS_PRIORITY;
var GET_ALL_PROJECT_BUS_PRIORITY = 'get_all_project_bus_priority';
exports.GET_ALL_PROJECT_BUS_PRIORITY = GET_ALL_PROJECT_BUS_PRIORITY;
var GET_UNSELECTED_ALL_PROJECT_BUS_PRIORITY = 'get_unselected_all_project_bus_priority';
exports.GET_UNSELECTED_ALL_PROJECT_BUS_PRIORITY = GET_UNSELECTED_ALL_PROJECT_BUS_PRIORITY;
var HANDLE_PROJECT_BUS_PRIORITY_REQUEST_CLOSE = 'handle_project_bus_priority_request_close';
exports.HANDLE_PROJECT_BUS_PRIORITY_REQUEST_CLOSE = HANDLE_PROJECT_BUS_PRIORITY_REQUEST_CLOSE;
var HIDE_PROJECT_BUS_PRIORITY_LOADER = 'hide_project_bus_priority_loader';
exports.HIDE_PROJECT_BUS_PRIORITY_LOADER = HIDE_PROJECT_BUS_PRIORITY_LOADER;
var SHOW_PROJECT_BUS_PRIORITY_LOADER = 'show_project_bus_priority_loader';
exports.SHOW_PROJECT_BUS_PRIORITY_LOADER = SHOW_PROJECT_BUS_PRIORITY_LOADER;
var ON_ADD_PROJECT_BUS_PRIORITY = 'on_add_project_bus_priority';
exports.ON_ADD_PROJECT_BUS_PRIORITY = ON_ADD_PROJECT_BUS_PRIORITY;
var ON_EDIT_PROJECT_BUS_PRIORITY = 'on_edit_project_bus_priority';
exports.ON_EDIT_PROJECT_BUS_PRIORITY = ON_EDIT_PROJECT_BUS_PRIORITY;
var ON_ALL_PROJECT_BUS_PRIORITY_SELECT = 'on_all_project_bus_priority_select';
exports.ON_ALL_PROJECT_BUS_PRIORITY_SELECT = ON_ALL_PROJECT_BUS_PRIORITY_SELECT;
var ON_PROJECT_BUS_PRIORITY_CLOSE = 'on_project_bus_priority_close';
exports.ON_PROJECT_BUS_PRIORITY_CLOSE = ON_PROJECT_BUS_PRIORITY_CLOSE;
var ON_PROJECT_BUS_PRIORITY_SELECT = 'on_project_bus_priority_select';
exports.ON_PROJECT_BUS_PRIORITY_SELECT = ON_PROJECT_BUS_PRIORITY_SELECT;
var ON_DELETE_PROJECT_BUS_PRIORITY = 'on_delete_project_bus_priority';
exports.ON_DELETE_PROJECT_BUS_PRIORITY = ON_DELETE_PROJECT_BUS_PRIORITY;
var ON_DELETE_PROJECT_BUS_PRIORITY_SUCCESS = 'on_delete_project_bus_priority_success';
exports.ON_DELETE_PROJECT_BUS_PRIORITY_SUCCESS = ON_DELETE_PROJECT_BUS_PRIORITY_SUCCESS;
var ON_FILTER_SELECTED_PROJECT_BUS_PRIORITY = 'on_filter_selected_project_bus_priority';
exports.ON_FILTER_SELECTED_PROJECT_BUS_PRIORITY = ON_FILTER_SELECTED_PROJECT_BUS_PRIORITY;
var ON_FILTER_PROJECT_BUS_PRIORITY_OPTION_SELECT = 'on_filter_project_bus_priority_option_select';
exports.ON_FILTER_PROJECT_BUS_PRIORITY_OPTION_SELECT = ON_FILTER_PROJECT_BUS_PRIORITY_OPTION_SELECT;
var ON_SAVE_PROJECT_BUS_PRIORITY = 'on_save_project_bus_priority';
exports.ON_SAVE_PROJECT_BUS_PRIORITY = ON_SAVE_PROJECT_BUS_PRIORITY;
var ON_SAVE_PROJECT_BUS_PRIORITY_SUCCESS = 'on_save_project_bus_priority_success';
exports.ON_SAVE_PROJECT_BUS_PRIORITY_SUCCESS = ON_SAVE_PROJECT_BUS_PRIORITY_SUCCESS;
var ON_TOGGLE_PROJECT_BUS_PRIORITY_DRAWER = 'on_toggle_project_bus_priority_drawer';
exports.ON_TOGGLE_PROJECT_BUS_PRIORITY_DRAWER = ON_TOGGLE_PROJECT_BUS_PRIORITY_DRAWER;
var SHOW_PROJECT_BUS_PRIORITY_MESSAGE = 'show_project_bus_priority_message';
exports.SHOW_PROJECT_BUS_PRIORITY_MESSAGE = SHOW_PROJECT_BUS_PRIORITY_MESSAGE;
var UPDATE_SEARCH_PROJECT_BUS_PRIORITY = 'update_search_project_bus_priority';
exports.UPDATE_SEARCH_PROJECT_BUS_PRIORITY = UPDATE_SEARCH_PROJECT_BUS_PRIORITY;
var ADD_FAVOURITE_ISSUE = 'add_favourite_issue';
exports.ADD_FAVOURITE_ISSUE = ADD_FAVOURITE_ISSUE;
var ADD_FAVOURITE_ISSUE_SUCCESS = 'add_favourite_issue_success';
exports.ADD_FAVOURITE_ISSUE_SUCCESS = ADD_FAVOURITE_ISSUE_SUCCESS;
var FETCH_ISSUE = 'fetch_issue';
exports.FETCH_ISSUE = FETCH_ISSUE;
var FETCH_ISSUE_SUCCESS = 'fetch_issue_success';
exports.FETCH_ISSUE_SUCCESS = FETCH_ISSUE_SUCCESS;
var FETCH_ALL_ISSUE = 'fetch_all_issue';
exports.FETCH_ALL_ISSUE = FETCH_ALL_ISSUE;
var FETCH_ALL_ISSUE_SUCCESS = 'fetch_all_issue_success';
exports.FETCH_ALL_ISSUE_SUCCESS = FETCH_ALL_ISSUE_SUCCESS;
var FILTER_ISSUE = 'filter_issue';
exports.FILTER_ISSUE = FILTER_ISSUE;
var GET_ALL_ISSUE = 'get_all_issue';
exports.GET_ALL_ISSUE = GET_ALL_ISSUE;
var GET_UNSELECTED_ALL_ISSUE = 'get_unselected_all_issue';
exports.GET_UNSELECTED_ALL_ISSUE = GET_UNSELECTED_ALL_ISSUE;
var HANDLE_ISSUE_REQUEST_CLOSE = 'handle_issue_request_close';
exports.HANDLE_ISSUE_REQUEST_CLOSE = HANDLE_ISSUE_REQUEST_CLOSE;
var HIDE_ISSUE_LOADER = 'hide_issue_loader';
exports.HIDE_ISSUE_LOADER = HIDE_ISSUE_LOADER;
var SHOW_ISSUE_LOADER = 'show_issue_loader';
exports.SHOW_ISSUE_LOADER = SHOW_ISSUE_LOADER;
var ON_ADD_ISSUE = 'on_add_issue';
exports.ON_ADD_ISSUE = ON_ADD_ISSUE;
var ON_EDIT_ISSUE = 'on_edit_issue';
exports.ON_EDIT_ISSUE = ON_EDIT_ISSUE;
var SET_ISSUE = 'set_issue';
exports.SET_ISSUE = SET_ISSUE;
var ON_ALL_ISSUE_SELECT = 'on_all_issue_select';
exports.ON_ALL_ISSUE_SELECT = ON_ALL_ISSUE_SELECT;
var ON_ISSUE_CLOSE = 'on_issue_close';
exports.ON_ISSUE_CLOSE = ON_ISSUE_CLOSE;
var ON_ISSUE_SELECT = 'on_issue_select';
exports.ON_ISSUE_SELECT = ON_ISSUE_SELECT;
var ON_DELETE_ISSUE = 'on_delete_issue';
exports.ON_DELETE_ISSUE = ON_DELETE_ISSUE;
var ON_DELETE_ISSUE_SUCCESS = 'on_delete_issue_success';
exports.ON_DELETE_ISSUE_SUCCESS = ON_DELETE_ISSUE_SUCCESS;
var ON_FILTER_SELECTED_ISSUE = 'on_filter_selected_issue';
exports.ON_FILTER_SELECTED_ISSUE = ON_FILTER_SELECTED_ISSUE;
var ON_FILTER_ISSUE_OPTION_SELECT = 'on_filter_issue_option_select';
exports.ON_FILTER_ISSUE_OPTION_SELECT = ON_FILTER_ISSUE_OPTION_SELECT;
var ON_SAVE_ISSUE = 'on_save_issue';
exports.ON_SAVE_ISSUE = ON_SAVE_ISSUE;
var ON_SAVE_ISSUE_SUCCESS = 'on_save_issue_success';
exports.ON_SAVE_ISSUE_SUCCESS = ON_SAVE_ISSUE_SUCCESS;
var ON_TOGGLE_ISSUE_DRAWER = 'on_toggle_issue_drawer';
exports.ON_TOGGLE_ISSUE_DRAWER = ON_TOGGLE_ISSUE_DRAWER;
var SHOW_ISSUE_MESSAGE = 'show_issue_message';
exports.SHOW_ISSUE_MESSAGE = SHOW_ISSUE_MESSAGE;
var UPDATE_SEARCH_ISSUE = 'update_search_issue';
exports.UPDATE_SEARCH_ISSUE = UPDATE_SEARCH_ISSUE;
var ON_FETCH_SELECT_FEATURE_DATA = 'on_fetch_select_feature_data';
exports.ON_FETCH_SELECT_FEATURE_DATA = ON_FETCH_SELECT_FEATURE_DATA;
var ON_FETCH_SELECT_FEATURE_DATA_SUCCESS = 'on_fetch_select_feature_data_success';
exports.ON_FETCH_SELECT_FEATURE_DATA_SUCCESS = ON_FETCH_SELECT_FEATURE_DATA_SUCCESS;
var ON_ISSUE_FEATURE_UPDATE = 'on_issue_feature_update'; // initiative component actionTypes

exports.ON_ISSUE_FEATURE_UPDATE = ON_ISSUE_FEATURE_UPDATE;
var ADD_FAVOURITE_INITIATIVE = 'add_favourite_initiative';
exports.ADD_FAVOURITE_INITIATIVE = ADD_FAVOURITE_INITIATIVE;
var ADD_FAVOURITE_INITIATIVE_SUCCESS = 'add_favourite_initiative_success';
exports.ADD_FAVOURITE_INITIATIVE_SUCCESS = ADD_FAVOURITE_INITIATIVE_SUCCESS;
var FETCH_INITIATIVE = 'fetch_initiative';
exports.FETCH_INITIATIVE = FETCH_INITIATIVE;
var FETCH_INITIATIVE_SUCCESS = 'fetch_initiative_success';
exports.FETCH_INITIATIVE_SUCCESS = FETCH_INITIATIVE_SUCCESS;
var FETCH_ALL_INITIATIVE = 'fetch_all_initiative';
exports.FETCH_ALL_INITIATIVE = FETCH_ALL_INITIATIVE;
var FETCH_ALL_INITIATIVE_SUCCESS = 'fetch_all_initiative_success';
exports.FETCH_ALL_INITIATIVE_SUCCESS = FETCH_ALL_INITIATIVE_SUCCESS;
var FILTER_INITIATIVE = 'filter_initiative';
exports.FILTER_INITIATIVE = FILTER_INITIATIVE;
var GET_ALL_INITIATIVE = 'get_all_initiative';
exports.GET_ALL_INITIATIVE = GET_ALL_INITIATIVE;
var GET_UNSELECTED_ALL_INITIATIVE = 'get_unselected_all_initiative';
exports.GET_UNSELECTED_ALL_INITIATIVE = GET_UNSELECTED_ALL_INITIATIVE;
var HANDLE_INITIATIVE_REQUEST_CLOSE = 'handle_initiative_request_close';
exports.HANDLE_INITIATIVE_REQUEST_CLOSE = HANDLE_INITIATIVE_REQUEST_CLOSE;
var HIDE_INITIATIVE_LOADER = 'hide_initiative_loader';
exports.HIDE_INITIATIVE_LOADER = HIDE_INITIATIVE_LOADER;
var SHOW_INITIATIVE_LOADER = 'show_initiative_loader';
exports.SHOW_INITIATIVE_LOADER = SHOW_INITIATIVE_LOADER;
var ON_ADD_INITIATIVE = 'on_add_initiative';
exports.ON_ADD_INITIATIVE = ON_ADD_INITIATIVE;
var ON_EDIT_INITIATIVE = 'on_edit_initiative';
exports.ON_EDIT_INITIATIVE = ON_EDIT_INITIATIVE;
var SET_INITIATIVE = 'set_initiative';
exports.SET_INITIATIVE = SET_INITIATIVE;
var ON_ALL_INITIATIVE_SELECT = 'on_all_initiative_select';
exports.ON_ALL_INITIATIVE_SELECT = ON_ALL_INITIATIVE_SELECT;
var ON_INITIATIVE_CLOSE = 'on_initiative_close';
exports.ON_INITIATIVE_CLOSE = ON_INITIATIVE_CLOSE;
var ON_INITIATIVE_SELECT = 'on_initiative_select';
exports.ON_INITIATIVE_SELECT = ON_INITIATIVE_SELECT;
var ON_DELETE_INITIATIVE = 'on_delete_initiative';
exports.ON_DELETE_INITIATIVE = ON_DELETE_INITIATIVE;
var ON_DELETE_INITIATIVE_SUCCESS = 'on_delete_initiative_success';
exports.ON_DELETE_INITIATIVE_SUCCESS = ON_DELETE_INITIATIVE_SUCCESS;
var ON_FILTER_SELECTED_INITIATIVE = 'on_filter_selected_initiative';
exports.ON_FILTER_SELECTED_INITIATIVE = ON_FILTER_SELECTED_INITIATIVE;
var ON_FILTER_INITIATIVE_OPTION_SELECT = 'on_filter_initiative_option_select';
exports.ON_FILTER_INITIATIVE_OPTION_SELECT = ON_FILTER_INITIATIVE_OPTION_SELECT;
var ON_SAVE_INITIATIVE = 'on_save_initiative';
exports.ON_SAVE_INITIATIVE = ON_SAVE_INITIATIVE;
var ON_SAVE_INITIATIVE_SUCCESS = 'on_save_initiative_success';
exports.ON_SAVE_INITIATIVE_SUCCESS = ON_SAVE_INITIATIVE_SUCCESS;
var ON_TOGGLE_INITIATIVE_DRAWER = 'on_toggle_initiative_drawer';
exports.ON_TOGGLE_INITIATIVE_DRAWER = ON_TOGGLE_INITIATIVE_DRAWER;
var SHOW_INITIATIVE_MESSAGE = 'show_initiative_message';
exports.SHOW_INITIATIVE_MESSAGE = SHOW_INITIATIVE_MESSAGE;
var UPDATE_SEARCH_INITIATIVE = 'update_search_initiative';
exports.UPDATE_SEARCH_INITIATIVE = UPDATE_SEARCH_INITIATIVE;
var ON_FETCH_SELECT_PRODUCT_DATA = 'on_fetch_select_product_data';
exports.ON_FETCH_SELECT_PRODUCT_DATA = ON_FETCH_SELECT_PRODUCT_DATA;
var ON_FETCH_SELECT_PRODUCT_DATA_SUCCESS = 'on_fetch_select_product_data_success';
exports.ON_FETCH_SELECT_PRODUCT_DATA_SUCCESS = ON_FETCH_SELECT_PRODUCT_DATA_SUCCESS;
var ON_INITIATIVE_PRODUCT_UPDATE = 'on_initiative_product_update'; // product component actionTypes

exports.ON_INITIATIVE_PRODUCT_UPDATE = ON_INITIATIVE_PRODUCT_UPDATE;
var ADD_FAVOURITE_PRODUCT = 'add_favourite_product';
exports.ADD_FAVOURITE_PRODUCT = ADD_FAVOURITE_PRODUCT;
var ADD_FAVOURITE_PRODUCT_SUCCESS = 'add_favourite_product_success';
exports.ADD_FAVOURITE_PRODUCT_SUCCESS = ADD_FAVOURITE_PRODUCT_SUCCESS;
var FETCH_PRODUCT_LOOKUP_DATA = 'fetch_product_lookup_data';
exports.FETCH_PRODUCT_LOOKUP_DATA = FETCH_PRODUCT_LOOKUP_DATA;
var FETCH_PRODUCT = 'fetch_product';
exports.FETCH_PRODUCT = FETCH_PRODUCT;
var FETCH_PRODUCT_SUCCESS = 'fetch_product_success';
exports.FETCH_PRODUCT_SUCCESS = FETCH_PRODUCT_SUCCESS;
var FETCH_ALL_PRODUCT = 'fetch_all_product';
exports.FETCH_ALL_PRODUCT = FETCH_ALL_PRODUCT;
var FETCH_ALL_PRODUCT_SUCCESS = 'fetch_all_product_success';
exports.FETCH_ALL_PRODUCT_SUCCESS = FETCH_ALL_PRODUCT_SUCCESS;
var FILTER_PRODUCT = 'filter_product';
exports.FILTER_PRODUCT = FILTER_PRODUCT;
var GET_ALL_PRODUCT = 'get_all_product';
exports.GET_ALL_PRODUCT = GET_ALL_PRODUCT;
var GET_UNSELECTED_ALL_PRODUCT = 'get_unselected_all_product';
exports.GET_UNSELECTED_ALL_PRODUCT = GET_UNSELECTED_ALL_PRODUCT;
var HANDLE_PRODUCT_REQUEST_CLOSE = 'handle_product_request_close';
exports.HANDLE_PRODUCT_REQUEST_CLOSE = HANDLE_PRODUCT_REQUEST_CLOSE;
var HIDE_PRODUCT_LOADER = 'hide_product_loader';
exports.HIDE_PRODUCT_LOADER = HIDE_PRODUCT_LOADER;
var SHOW_PRODUCT_LOADER = 'show_product_loader';
exports.SHOW_PRODUCT_LOADER = SHOW_PRODUCT_LOADER;
var ON_ADD_PRODUCT = 'on_add_product';
exports.ON_ADD_PRODUCT = ON_ADD_PRODUCT;
var ON_EDIT_PRODUCT = 'on_edit_product';
exports.ON_EDIT_PRODUCT = ON_EDIT_PRODUCT;
var SET_PRODUCT = 'set_product';
exports.SET_PRODUCT = SET_PRODUCT;
var ON_ALL_PRODUCT_SELECT = 'on_all_product_select';
exports.ON_ALL_PRODUCT_SELECT = ON_ALL_PRODUCT_SELECT;
var ON_PRODUCT_CLOSE = 'on_product_close';
exports.ON_PRODUCT_CLOSE = ON_PRODUCT_CLOSE;
var ON_PRODUCT_SELECT = 'on_product_select';
exports.ON_PRODUCT_SELECT = ON_PRODUCT_SELECT;
var ON_DELETE_PRODUCT = 'on_delete_product';
exports.ON_DELETE_PRODUCT = ON_DELETE_PRODUCT;
var ON_DELETE_PRODUCT_SUCCESS = 'on_delete_product_success';
exports.ON_DELETE_PRODUCT_SUCCESS = ON_DELETE_PRODUCT_SUCCESS;
var ON_FILTER_SELECTED_PRODUCT = 'on_filter_selected_product';
exports.ON_FILTER_SELECTED_PRODUCT = ON_FILTER_SELECTED_PRODUCT;
var ON_FILTER_PRODUCT_OPTION_SELECT = 'on_filter_product_option_select';
exports.ON_FILTER_PRODUCT_OPTION_SELECT = ON_FILTER_PRODUCT_OPTION_SELECT;
var ON_SAVE_PRODUCT = 'on_save_product';
exports.ON_SAVE_PRODUCT = ON_SAVE_PRODUCT;
var ON_SAVE_PRODUCT_SUCCESS = 'on_save_product_success';
exports.ON_SAVE_PRODUCT_SUCCESS = ON_SAVE_PRODUCT_SUCCESS;
var ON_TOGGLE_PRODUCT_DRAWER = 'on_toggle_product_drawer';
exports.ON_TOGGLE_PRODUCT_DRAWER = ON_TOGGLE_PRODUCT_DRAWER;
var SHOW_PRODUCT_MESSAGE = 'show_product_message';
exports.SHOW_PRODUCT_MESSAGE = SHOW_PRODUCT_MESSAGE;
var UPDATE_SEARCH_PRODUCT = 'update_search_product';
exports.UPDATE_SEARCH_PRODUCT = UPDATE_SEARCH_PRODUCT;
var ON_FETCH_SELECT_VALUESTREAM_DATA = 'on_fetch_select_valueStream_data';
exports.ON_FETCH_SELECT_VALUESTREAM_DATA = ON_FETCH_SELECT_VALUESTREAM_DATA;
var ON_FETCH_SELECT_VALUESTREAM_DATA_SUCCESS = 'on_fetch_select_valueStream_data_success';
exports.ON_FETCH_SELECT_VALUESTREAM_DATA_SUCCESS = ON_FETCH_SELECT_VALUESTREAM_DATA_SUCCESS;
var ON_PRODUCT_VALUESTREAM_UPDATE = 'on_product_valueStream_update'; // team component actionTypes

exports.ON_PRODUCT_VALUESTREAM_UPDATE = ON_PRODUCT_VALUESTREAM_UPDATE;
var ADD_FAVOURITE_TEAM = 'add_favourite_team';
exports.ADD_FAVOURITE_TEAM = ADD_FAVOURITE_TEAM;
var ADD_FAVOURITE_TEAM_SUCCESS = 'add_favourite_team_success';
exports.ADD_FAVOURITE_TEAM_SUCCESS = ADD_FAVOURITE_TEAM_SUCCESS;
var FETCH_TEAM = 'fetch_team';
exports.FETCH_TEAM = FETCH_TEAM;
var FETCH_TEAM_SUCCESS = 'fetch_team_success';
exports.FETCH_TEAM_SUCCESS = FETCH_TEAM_SUCCESS;
var FETCH_ALL_TEAM = 'fetch_all_team';
exports.FETCH_ALL_TEAM = FETCH_ALL_TEAM;
var FETCH_ALL_TEAM_SUCCESS = 'fetch_all_team_success';
exports.FETCH_ALL_TEAM_SUCCESS = FETCH_ALL_TEAM_SUCCESS;
var FILTER_TEAM = 'filter_team';
exports.FILTER_TEAM = FILTER_TEAM;
var GET_ALL_TEAM = 'get_all_team';
exports.GET_ALL_TEAM = GET_ALL_TEAM;
var GET_UNSELECTED_ALL_TEAM = 'get_unselected_all_team';
exports.GET_UNSELECTED_ALL_TEAM = GET_UNSELECTED_ALL_TEAM;
var HANDLE_TEAM_REQUEST_CLOSE = 'handle_team_request_close';
exports.HANDLE_TEAM_REQUEST_CLOSE = HANDLE_TEAM_REQUEST_CLOSE;
var HIDE_TEAM_LOADER = 'hide_team_loader';
exports.HIDE_TEAM_LOADER = HIDE_TEAM_LOADER;
var SHOW_TEAM_LOADER = 'show_team_loader';
exports.SHOW_TEAM_LOADER = SHOW_TEAM_LOADER;
var ON_ADD_TEAM = 'on_add_team';
exports.ON_ADD_TEAM = ON_ADD_TEAM;
var ON_EDIT_TEAM = 'on_edit_team';
exports.ON_EDIT_TEAM = ON_EDIT_TEAM;
var SET_TEAM = 'set_team';
exports.SET_TEAM = SET_TEAM;
var ON_ALL_TEAM_SELECT = 'on_all_team_select';
exports.ON_ALL_TEAM_SELECT = ON_ALL_TEAM_SELECT;
var ON_TEAM_CLOSE = 'on_team_close';
exports.ON_TEAM_CLOSE = ON_TEAM_CLOSE;
var ON_TEAM_SELECT = 'on_team_select';
exports.ON_TEAM_SELECT = ON_TEAM_SELECT;
var ON_DELETE_TEAM = 'on_delete_team';
exports.ON_DELETE_TEAM = ON_DELETE_TEAM;
var ON_DELETE_TEAM_SUCCESS = 'on_delete_team_success';
exports.ON_DELETE_TEAM_SUCCESS = ON_DELETE_TEAM_SUCCESS;
var ON_FILTER_SELECTED_TEAM = 'on_filter_selected_team';
exports.ON_FILTER_SELECTED_TEAM = ON_FILTER_SELECTED_TEAM;
var ON_FILTER_TEAM_OPTION_SELECT = 'on_filter_team_option_select';
exports.ON_FILTER_TEAM_OPTION_SELECT = ON_FILTER_TEAM_OPTION_SELECT;
var ON_SAVE_TEAM = 'on_save_team';
exports.ON_SAVE_TEAM = ON_SAVE_TEAM;
var ON_SAVE_TEAM_SUCCESS = 'on_save_team_success';
exports.ON_SAVE_TEAM_SUCCESS = ON_SAVE_TEAM_SUCCESS;
var ON_TOGGLE_TEAM_DRAWER = 'on_toggle_team_drawer';
exports.ON_TOGGLE_TEAM_DRAWER = ON_TOGGLE_TEAM_DRAWER;
var SHOW_TEAM_MESSAGE = 'show_team_message';
exports.SHOW_TEAM_MESSAGE = SHOW_TEAM_MESSAGE;
var UPDATE_SEARCH_TEAM = 'update_search_team';
exports.UPDATE_SEARCH_TEAM = UPDATE_SEARCH_TEAM;
var ON_FETCH_SELECT_MEMBER_DATA = 'on_fetch_select_member_data';
exports.ON_FETCH_SELECT_MEMBER_DATA = ON_FETCH_SELECT_MEMBER_DATA;
var ON_FETCH_SELECT_MEMBER_DATA_SUCCESS = 'on_fetch_select_member_data_success';
exports.ON_FETCH_SELECT_MEMBER_DATA_SUCCESS = ON_FETCH_SELECT_MEMBER_DATA_SUCCESS;
var ON_TEAM_MEMBER_UPDATE = 'on_team_member_update'; // member component actionTypes

exports.ON_TEAM_MEMBER_UPDATE = ON_TEAM_MEMBER_UPDATE;
var ADD_FAVOURITE_MEMBER = 'add_favourite_member';
exports.ADD_FAVOURITE_MEMBER = ADD_FAVOURITE_MEMBER;
var ADD_FAVOURITE_MEMBER_SUCCESS = 'add_favourite_member_success';
exports.ADD_FAVOURITE_MEMBER_SUCCESS = ADD_FAVOURITE_MEMBER_SUCCESS;
var FETCH_MEMBER = 'fetch_member';
exports.FETCH_MEMBER = FETCH_MEMBER;
var FETCH_MEMBER_SUCCESS = 'fetch_member_success';
exports.FETCH_MEMBER_SUCCESS = FETCH_MEMBER_SUCCESS;
var FETCH_ALL_MEMBER = 'fetch_all_member';
exports.FETCH_ALL_MEMBER = FETCH_ALL_MEMBER;
var FETCH_ALL_MEMBER_SUCCESS = 'fetch_all_member_success';
exports.FETCH_ALL_MEMBER_SUCCESS = FETCH_ALL_MEMBER_SUCCESS;
var FILTER_MEMBER = 'filter_member';
exports.FILTER_MEMBER = FILTER_MEMBER;
var GET_ALL_MEMBER = 'get_all_member';
exports.GET_ALL_MEMBER = GET_ALL_MEMBER;
var GET_UNSELECTED_ALL_MEMBER = 'get_unselected_all_member';
exports.GET_UNSELECTED_ALL_MEMBER = GET_UNSELECTED_ALL_MEMBER;
var HANDLE_MEMBER_REQUEST_CLOSE = 'handle_member_request_close';
exports.HANDLE_MEMBER_REQUEST_CLOSE = HANDLE_MEMBER_REQUEST_CLOSE;
var HIDE_MEMBER_LOADER = 'hide_member_loader';
exports.HIDE_MEMBER_LOADER = HIDE_MEMBER_LOADER;
var SHOW_MEMBER_LOADER = 'show_member_loader';
exports.SHOW_MEMBER_LOADER = SHOW_MEMBER_LOADER;
var ON_ADD_MEMBER = 'on_add_member';
exports.ON_ADD_MEMBER = ON_ADD_MEMBER;
var ON_EDIT_MEMBER = 'on_edit_member';
exports.ON_EDIT_MEMBER = ON_EDIT_MEMBER;
var ON_ALL_MEMBER_SELECT = 'on_all_member_select';
exports.ON_ALL_MEMBER_SELECT = ON_ALL_MEMBER_SELECT;
var ON_MEMBER_CLOSE = 'on_member_close';
exports.ON_MEMBER_CLOSE = ON_MEMBER_CLOSE;
var ON_MEMBER_SELECT = 'on_member_select';
exports.ON_MEMBER_SELECT = ON_MEMBER_SELECT;
var ON_DELETE_MEMBER = 'on_delete_member';
exports.ON_DELETE_MEMBER = ON_DELETE_MEMBER;
var ON_DELETE_MEMBER_SUCCESS = 'on_delete_member_success';
exports.ON_DELETE_MEMBER_SUCCESS = ON_DELETE_MEMBER_SUCCESS;
var ON_FILTER_SELECTED_MEMBER = 'on_filter_selected_member';
exports.ON_FILTER_SELECTED_MEMBER = ON_FILTER_SELECTED_MEMBER;
var ON_FILTER_MEMBER_OPTION_SELECT = 'on_filter_member_option_select';
exports.ON_FILTER_MEMBER_OPTION_SELECT = ON_FILTER_MEMBER_OPTION_SELECT;
var ON_SAVE_MEMBER = 'on_save_member';
exports.ON_SAVE_MEMBER = ON_SAVE_MEMBER;
var ON_SAVE_MEMBER_SUCCESS = 'on_save_member_success';
exports.ON_SAVE_MEMBER_SUCCESS = ON_SAVE_MEMBER_SUCCESS;
var ON_TOGGLE_MEMBER_DRAWER = 'on_toggle_member_drawer';
exports.ON_TOGGLE_MEMBER_DRAWER = ON_TOGGLE_MEMBER_DRAWER;
var SHOW_MEMBER_MESSAGE = 'show_member_message';
exports.SHOW_MEMBER_MESSAGE = SHOW_MEMBER_MESSAGE;
var UPDATE_SEARCH_MEMBER = 'update_search_member'; // valueStream component actionTypes

exports.UPDATE_SEARCH_MEMBER = UPDATE_SEARCH_MEMBER;
var ADD_FAVOURITE_VALUE_STREAM = 'add_favourite_value_stream';
exports.ADD_FAVOURITE_VALUE_STREAM = ADD_FAVOURITE_VALUE_STREAM;
var ADD_FAVOURITE_VALUE_STREAM_SUCCESS = 'add_favourite_value_stream_success';
exports.ADD_FAVOURITE_VALUE_STREAM_SUCCESS = ADD_FAVOURITE_VALUE_STREAM_SUCCESS;
var FETCH_VALUE_STREAM = 'fetch_value_stream';
exports.FETCH_VALUE_STREAM = FETCH_VALUE_STREAM;
var FETCH_VALUE_STREAM_SUCCESS = 'fetch_value_stream_success';
exports.FETCH_VALUE_STREAM_SUCCESS = FETCH_VALUE_STREAM_SUCCESS;
var FETCH_ALL_VALUE_STREAM = 'fetch_all_value_stream';
exports.FETCH_ALL_VALUE_STREAM = FETCH_ALL_VALUE_STREAM;
var FETCH_ALL_VALUE_STREAM_SUCCESS = 'fetch_all_value_stream_success';
exports.FETCH_ALL_VALUE_STREAM_SUCCESS = FETCH_ALL_VALUE_STREAM_SUCCESS;
var FILTER_VALUE_STREAM = 'filter_value_stream';
exports.FILTER_VALUE_STREAM = FILTER_VALUE_STREAM;
var GET_ALL_VALUE_STREAM = 'get_all_value_stream';
exports.GET_ALL_VALUE_STREAM = GET_ALL_VALUE_STREAM;
var GET_UNSELECTED_ALL_VALUE_STREAM = 'get_unselected_all_value_stream';
exports.GET_UNSELECTED_ALL_VALUE_STREAM = GET_UNSELECTED_ALL_VALUE_STREAM;
var HANDLE_VALUE_STREAM_REQUEST_CLOSE = 'handle_value_stream_request_close';
exports.HANDLE_VALUE_STREAM_REQUEST_CLOSE = HANDLE_VALUE_STREAM_REQUEST_CLOSE;
var HIDE_VALUE_STREAM_LOADER = 'hide_value_stream_loader';
exports.HIDE_VALUE_STREAM_LOADER = HIDE_VALUE_STREAM_LOADER;
var SHOW_VALUE_STREAM_LOADER = 'show_value_stream_loader';
exports.SHOW_VALUE_STREAM_LOADER = SHOW_VALUE_STREAM_LOADER;
var ON_ADD_VALUE_STREAM = 'on_add_value_stream';
exports.ON_ADD_VALUE_STREAM = ON_ADD_VALUE_STREAM;
var ON_EDIT_VALUE_STREAM = 'on_edit_value_stream';
exports.ON_EDIT_VALUE_STREAM = ON_EDIT_VALUE_STREAM;
var SET_VALUE_STREAM = 'set_value_stream';
exports.SET_VALUE_STREAM = SET_VALUE_STREAM;
var ON_ALL_VALUE_STREAM_SELECT = 'on_all_value_stream_select';
exports.ON_ALL_VALUE_STREAM_SELECT = ON_ALL_VALUE_STREAM_SELECT;
var ON_VALUE_STREAM_CLOSE = 'on_value_stream_close';
exports.ON_VALUE_STREAM_CLOSE = ON_VALUE_STREAM_CLOSE;
var ON_VALUE_STREAM_SELECT = 'on_value_stream_select';
exports.ON_VALUE_STREAM_SELECT = ON_VALUE_STREAM_SELECT;
var ON_DELETE_VALUE_STREAM = 'on_delete_value_stream';
exports.ON_DELETE_VALUE_STREAM = ON_DELETE_VALUE_STREAM;
var ON_DELETE_VALUE_STREAM_SUCCESS = 'on_delete_value_stream_success';
exports.ON_DELETE_VALUE_STREAM_SUCCESS = ON_DELETE_VALUE_STREAM_SUCCESS;
var ON_FILTER_SELECTED_VALUE_STREAM = 'on_filter_selected_value_stream';
exports.ON_FILTER_SELECTED_VALUE_STREAM = ON_FILTER_SELECTED_VALUE_STREAM;
var ON_FILTER_VALUE_STREAM_OPTION_SELECT = 'on_filter_value_stream_option_select';
exports.ON_FILTER_VALUE_STREAM_OPTION_SELECT = ON_FILTER_VALUE_STREAM_OPTION_SELECT;
var ON_SAVE_VALUE_STREAM = 'on_save_value_stream';
exports.ON_SAVE_VALUE_STREAM = ON_SAVE_VALUE_STREAM;
var ON_SAVE_VALUE_STREAM_SUCCESS = 'on_save_value_stream_success';
exports.ON_SAVE_VALUE_STREAM_SUCCESS = ON_SAVE_VALUE_STREAM_SUCCESS;
var ON_TOGGLE_VALUE_STREAM_DRAWER = 'on_toggle_value_stream_drawer';
exports.ON_TOGGLE_VALUE_STREAM_DRAWER = ON_TOGGLE_VALUE_STREAM_DRAWER;
var SHOW_VALUE_STREAM_MESSAGE = 'show_value_stream_message';
exports.SHOW_VALUE_STREAM_MESSAGE = SHOW_VALUE_STREAM_MESSAGE;
var UPDATE_SEARCH_VALUE_STREAM = 'update_search_value_stream';
exports.UPDATE_SEARCH_VALUE_STREAM = UPDATE_SEARCH_VALUE_STREAM;
var ON_FETCH_SELECT_TEAM_DATA = 'on_fetch_select_team_data';
exports.ON_FETCH_SELECT_TEAM_DATA = ON_FETCH_SELECT_TEAM_DATA;
var ON_FETCH_SELECT_TEAM_DATA_SUCCESS = 'on_fetch_select_team_data_success';
exports.ON_FETCH_SELECT_TEAM_DATA_SUCCESS = ON_FETCH_SELECT_TEAM_DATA_SUCCESS;
var ON_VALUE_STREAM_TEAM_UPDATE = 'on_value_stream_team_update'; // feature component actionTypes

exports.ON_VALUE_STREAM_TEAM_UPDATE = ON_VALUE_STREAM_TEAM_UPDATE;
var ADD_FAVOURITE_FEATURE = 'add_favourite_feature';
exports.ADD_FAVOURITE_FEATURE = ADD_FAVOURITE_FEATURE;
var ADD_FAVOURITE_FEATURE_SUCCESS = 'add_favourite_feature_success';
exports.ADD_FAVOURITE_FEATURE_SUCCESS = ADD_FAVOURITE_FEATURE_SUCCESS;
var FETCH_FEATURE = 'fetch_feature';
exports.FETCH_FEATURE = FETCH_FEATURE;
var FETCH_FEATURE_SUCCESS = 'fetch_feature_success';
exports.FETCH_FEATURE_SUCCESS = FETCH_FEATURE_SUCCESS;
var FETCH_ALL_FEATURE = 'fetch_all_feature';
exports.FETCH_ALL_FEATURE = FETCH_ALL_FEATURE;
var FETCH_ALL_FEATURE_SUCCESS = 'fetch_all_feature_success';
exports.FETCH_ALL_FEATURE_SUCCESS = FETCH_ALL_FEATURE_SUCCESS;
var FILTER_FEATURE = 'filter_feature';
exports.FILTER_FEATURE = FILTER_FEATURE;
var GET_ALL_FEATURE = 'get_all_feature';
exports.GET_ALL_FEATURE = GET_ALL_FEATURE;
var GET_UNSELECTED_ALL_FEATURE = 'get_unselected_all_feature';
exports.GET_UNSELECTED_ALL_FEATURE = GET_UNSELECTED_ALL_FEATURE;
var HANDLE_FEATURE_REQUEST_CLOSE = 'handle_feature_request_close';
exports.HANDLE_FEATURE_REQUEST_CLOSE = HANDLE_FEATURE_REQUEST_CLOSE;
var HIDE_FEATURE_LOADER = 'hide_feature_loader';
exports.HIDE_FEATURE_LOADER = HIDE_FEATURE_LOADER;
var SHOW_FEATURE_LOADER = 'show_feature_loader';
exports.SHOW_FEATURE_LOADER = SHOW_FEATURE_LOADER;
var ON_ADD_FEATURE = 'on_add_feature';
exports.ON_ADD_FEATURE = ON_ADD_FEATURE;
var ON_EDIT_FEATURE = 'on_edit_feature';
exports.ON_EDIT_FEATURE = ON_EDIT_FEATURE;
var ON_ALL_FEATURE_SELECT = 'on_all_feature_select';
exports.ON_ALL_FEATURE_SELECT = ON_ALL_FEATURE_SELECT;
var ON_FEATURE_CLOSE = 'on_feature_close';
exports.ON_FEATURE_CLOSE = ON_FEATURE_CLOSE;
var ON_FEATURE_SELECT = 'on_feature_select';
exports.ON_FEATURE_SELECT = ON_FEATURE_SELECT;
var ON_DELETE_FEATURE = 'on_delete_feature';
exports.ON_DELETE_FEATURE = ON_DELETE_FEATURE;
var ON_DELETE_FEATURE_SUCCESS = 'on_delete_feature_success';
exports.ON_DELETE_FEATURE_SUCCESS = ON_DELETE_FEATURE_SUCCESS;
var ON_FILTER_SELECTED_FEATURE = 'on_filter_selected_feature';
exports.ON_FILTER_SELECTED_FEATURE = ON_FILTER_SELECTED_FEATURE;
var ON_FILTER_FEATURE_OPTION_SELECT = 'on_filter_feature_option_select';
exports.ON_FILTER_FEATURE_OPTION_SELECT = ON_FILTER_FEATURE_OPTION_SELECT;
var ON_SAVE_FEATURE = 'on_save_feature';
exports.ON_SAVE_FEATURE = ON_SAVE_FEATURE;
var ON_SAVE_FEATURE_SUCCESS = 'on_save_feature_success';
exports.ON_SAVE_FEATURE_SUCCESS = ON_SAVE_FEATURE_SUCCESS;
var ON_TOGGLE_FEATURE_DRAWER = 'on_toggle_feature_drawer';
exports.ON_TOGGLE_FEATURE_DRAWER = ON_TOGGLE_FEATURE_DRAWER;
var SHOW_FEATURE_MESSAGE = 'show_feature_message';
exports.SHOW_FEATURE_MESSAGE = SHOW_FEATURE_MESSAGE;
var UPDATE_SEARCH_FEATURE = 'update_search_feature';
exports.UPDATE_SEARCH_FEATURE = UPDATE_SEARCH_FEATURE;
var SET_FEATURE = 'set_feature';
exports.SET_FEATURE = SET_FEATURE;
var ON_FEATURE_INWARD_DEPENDENCY_UPDATE = 'on_feature_inward_dependency_update';
exports.ON_FEATURE_INWARD_DEPENDENCY_UPDATE = ON_FEATURE_INWARD_DEPENDENCY_UPDATE;
var ON_FEATURE_OUTWARD_DEPENDENCY_UPDATE = 'on_feature_outward_dependency_update';
exports.ON_FEATURE_OUTWARD_DEPENDENCY_UPDATE = ON_FEATURE_OUTWARD_DEPENDENCY_UPDATE;
var ON_FEATURE_DEPENDENCY_UPDATE_SUCCESS = 'on_feature_dependency_update_success';
exports.ON_FEATURE_DEPENDENCY_UPDATE_SUCCESS = ON_FEATURE_DEPENDENCY_UPDATE_SUCCESS;
var ON_FETCH_SELECT_FEATURE_INWARD_DEPENDENCIES = 'on_fetch_select_feature_inward_dependencies';
exports.ON_FETCH_SELECT_FEATURE_INWARD_DEPENDENCIES = ON_FETCH_SELECT_FEATURE_INWARD_DEPENDENCIES;
var ON_FETCH_SELECT_FEATURE_OUTWARD_DEPENDENCIES = 'on_fetch_select_feature_outward_dependencies';
exports.ON_FETCH_SELECT_FEATURE_OUTWARD_DEPENDENCIES = ON_FETCH_SELECT_FEATURE_OUTWARD_DEPENDENCIES;
var ON_FETCH_SELECT_FEATURE_DEPENDENCIES_SUCCESS = 'on_fetch_select_feature_dependencies_success'; // portfolio component actiontypes

exports.ON_FETCH_SELECT_FEATURE_DEPENDENCIES_SUCCESS = ON_FETCH_SELECT_FEATURE_DEPENDENCIES_SUCCESS;
var SELECT_PORTFOLIO = 'select_portfolio';
exports.SELECT_PORTFOLIO = SELECT_PORTFOLIO;
var ON_PORTFOLIO_DASHBOARD = 'on_portfolio_dashboard';
exports.ON_PORTFOLIO_DASHBOARD = ON_PORTFOLIO_DASHBOARD;
var ON_PORTFOLIO_DASHBOARD_SUCCESS = 'on_portfolio_dashboard_success';
exports.ON_PORTFOLIO_DASHBOARD_SUCCESS = ON_PORTFOLIO_DASHBOARD_SUCCESS;
var ADD_FAVOURITE_PORTFOLIO = 'add_favourite_portfolios';
exports.ADD_FAVOURITE_PORTFOLIO = ADD_FAVOURITE_PORTFOLIO;
var ADD_FAVOURITE_PORTFOLIO_SUCCESS = 'add_favourite_portfolios_success';
exports.ADD_FAVOURITE_PORTFOLIO_SUCCESS = ADD_FAVOURITE_PORTFOLIO_SUCCESS;
var FETCH_PORTFOLIO = 'fetch_portfolios';
exports.FETCH_PORTFOLIO = FETCH_PORTFOLIO;
var FETCH_PORTFOLIO_SUCCESS = 'fetch_portfolios_success';
exports.FETCH_PORTFOLIO_SUCCESS = FETCH_PORTFOLIO_SUCCESS;
var FETCH_ALL_PORTFOLIO = 'fetch_all_portfolios';
exports.FETCH_ALL_PORTFOLIO = FETCH_ALL_PORTFOLIO;
var FETCH_ALL_PORTFOLIO_SUCCESS = 'fetch_all_portfolios_success';
exports.FETCH_ALL_PORTFOLIO_SUCCESS = FETCH_ALL_PORTFOLIO_SUCCESS;
var FILTER_PORTFOLIO = 'filter_portfolios';
exports.FILTER_PORTFOLIO = FILTER_PORTFOLIO;
var GET_ALL_PORTFOLIO = 'get_all_portfolios';
exports.GET_ALL_PORTFOLIO = GET_ALL_PORTFOLIO;
var GET_UNSELECTED_ALL_PORTFOLIO = 'get_unselected_all_portfolios';
exports.GET_UNSELECTED_ALL_PORTFOLIO = GET_UNSELECTED_ALL_PORTFOLIO;
var HANDLE_PORTFOLIO_REQUEST_CLOSE = 'handle_portfolios_request_close';
exports.HANDLE_PORTFOLIO_REQUEST_CLOSE = HANDLE_PORTFOLIO_REQUEST_CLOSE;
var HIDE_PORTFOLIO_LOADER = 'hide_portfolios_loader';
exports.HIDE_PORTFOLIO_LOADER = HIDE_PORTFOLIO_LOADER;
var SHOW_PORTFOLIO_LOADER = 'show_portfolios_loader';
exports.SHOW_PORTFOLIO_LOADER = SHOW_PORTFOLIO_LOADER;
var ON_ADD_PORTFOLIO = 'on_add_portfolios';
exports.ON_ADD_PORTFOLIO = ON_ADD_PORTFOLIO;
var ON_EDIT_PORTFOLIO = 'on_edit_portfolios';
exports.ON_EDIT_PORTFOLIO = ON_EDIT_PORTFOLIO;
var ON_ALL_PORTFOLIO_SELECT = 'on_all_portfolios_select';
exports.ON_ALL_PORTFOLIO_SELECT = ON_ALL_PORTFOLIO_SELECT;
var ON_PORTFOLIO_CLOSE = 'on_portfolios_close';
exports.ON_PORTFOLIO_CLOSE = ON_PORTFOLIO_CLOSE;
var ON_PORTFOLIO_SELECT = 'on_portfolios_select';
exports.ON_PORTFOLIO_SELECT = ON_PORTFOLIO_SELECT;
var ON_DELETE_PORTFOLIO = 'on_delete_portfolios';
exports.ON_DELETE_PORTFOLIO = ON_DELETE_PORTFOLIO;
var ON_DELETE_PORTFOLIO_SUCCESS = 'on_delete_portfolios_success';
exports.ON_DELETE_PORTFOLIO_SUCCESS = ON_DELETE_PORTFOLIO_SUCCESS;
var ON_FILTER_SELECTED_PORTFOLIO = 'on_filter_selected_portfolios';
exports.ON_FILTER_SELECTED_PORTFOLIO = ON_FILTER_SELECTED_PORTFOLIO;
var ON_FILTER_PORTFOLIO_OPTION_SELECT = 'on_filter_portfolios_option_select';
exports.ON_FILTER_PORTFOLIO_OPTION_SELECT = ON_FILTER_PORTFOLIO_OPTION_SELECT;
var ON_SAVE_PORTFOLIO = 'on_save_portfolios';
exports.ON_SAVE_PORTFOLIO = ON_SAVE_PORTFOLIO;
var ON_SAVE_PORTFOLIO_SUCCESS = 'on_save_portfolios_success';
exports.ON_SAVE_PORTFOLIO_SUCCESS = ON_SAVE_PORTFOLIO_SUCCESS;
var ON_TOGGLE_PORTFOLIO_DRAWER = 'on_toggle_portfolios_drawer';
exports.ON_TOGGLE_PORTFOLIO_DRAWER = ON_TOGGLE_PORTFOLIO_DRAWER;
var SHOW_PORTFOLIO_MESSAGE = 'show_portfolios_message';
exports.SHOW_PORTFOLIO_MESSAGE = SHOW_PORTFOLIO_MESSAGE;
var UPDATE_SEARCH_PORTFOLIO = 'update_search_portfolios'; // businessUnit component actionTypes

exports.UPDATE_SEARCH_PORTFOLIO = UPDATE_SEARCH_PORTFOLIO;
var ADD_FAVOURITE_BUSINESS_UNIT = 'add_favourite_business_unit';
exports.ADD_FAVOURITE_BUSINESS_UNIT = ADD_FAVOURITE_BUSINESS_UNIT;
var ADD_FAVOURITE_BUSINESS_UNIT_SUCCESS = 'add_favourite_business_unit_success';
exports.ADD_FAVOURITE_BUSINESS_UNIT_SUCCESS = ADD_FAVOURITE_BUSINESS_UNIT_SUCCESS;
var FETCH_BUSINESS_UNIT = 'fetch_business_unit';
exports.FETCH_BUSINESS_UNIT = FETCH_BUSINESS_UNIT;
var FETCH_BUSINESS_UNIT_SUCCESS = 'fetch_business_unit_success';
exports.FETCH_BUSINESS_UNIT_SUCCESS = FETCH_BUSINESS_UNIT_SUCCESS;
var FETCH_ALL_BUSINESS_UNIT = 'fetch_all_business_unit';
exports.FETCH_ALL_BUSINESS_UNIT = FETCH_ALL_BUSINESS_UNIT;
var FETCH_ALL_BUSINESS_UNIT_SUCCESS = 'fetch_all_business_unit_success';
exports.FETCH_ALL_BUSINESS_UNIT_SUCCESS = FETCH_ALL_BUSINESS_UNIT_SUCCESS;
var FILTER_BUSINESS_UNIT = 'filter_business_unit';
exports.FILTER_BUSINESS_UNIT = FILTER_BUSINESS_UNIT;
var GET_ALL_BUSINESS_UNIT = 'get_all_business_unit';
exports.GET_ALL_BUSINESS_UNIT = GET_ALL_BUSINESS_UNIT;
var GET_UNSELECTED_ALL_BUSINESS_UNIT = 'get_unselected_all_business_unit';
exports.GET_UNSELECTED_ALL_BUSINESS_UNIT = GET_UNSELECTED_ALL_BUSINESS_UNIT;
var HANDLE_BUSINESS_UNIT_REQUEST_CLOSE = 'handle_business_unit_request_close';
exports.HANDLE_BUSINESS_UNIT_REQUEST_CLOSE = HANDLE_BUSINESS_UNIT_REQUEST_CLOSE;
var HIDE_BUSINESS_UNIT_LOADER = 'hide_business_unit_loader';
exports.HIDE_BUSINESS_UNIT_LOADER = HIDE_BUSINESS_UNIT_LOADER;
var SHOW_BUSINESS_UNIT_LOADER = 'show_business_unit_loader';
exports.SHOW_BUSINESS_UNIT_LOADER = SHOW_BUSINESS_UNIT_LOADER;
var ON_ADD_BUSINESS_UNIT = 'on_add_business_unit';
exports.ON_ADD_BUSINESS_UNIT = ON_ADD_BUSINESS_UNIT;
var ON_ALL_BUSINESS_UNIT_SELECT = 'on_all_business_unit_select';
exports.ON_ALL_BUSINESS_UNIT_SELECT = ON_ALL_BUSINESS_UNIT_SELECT;
var ON_BUSINESS_UNIT_CLOSE = 'on_business_unit_close';
exports.ON_BUSINESS_UNIT_CLOSE = ON_BUSINESS_UNIT_CLOSE;
var ON_BUSINESS_UNIT_SELECT = 'on_business_unit_select';
exports.ON_BUSINESS_UNIT_SELECT = ON_BUSINESS_UNIT_SELECT;
var ON_DELETE_BUSINESS_UNIT = 'on_delete_business_unit';
exports.ON_DELETE_BUSINESS_UNIT = ON_DELETE_BUSINESS_UNIT;
var ON_DELETE_BUSINESS_UNIT_SUCCESS = 'on_delete_business_unit_success';
exports.ON_DELETE_BUSINESS_UNIT_SUCCESS = ON_DELETE_BUSINESS_UNIT_SUCCESS;
var ON_FILTER_SELECTED_BUSINESS_UNIT = 'on_filter_selected_business_unit';
exports.ON_FILTER_SELECTED_BUSINESS_UNIT = ON_FILTER_SELECTED_BUSINESS_UNIT;
var ON_FILTER_BUSINESS_UNIT_OPTION_SELECT = 'on_filter_business_unit_option_select';
exports.ON_FILTER_BUSINESS_UNIT_OPTION_SELECT = ON_FILTER_BUSINESS_UNIT_OPTION_SELECT;
var ON_SAVE_BUSINESS_UNIT = 'on_save_business_unit';
exports.ON_SAVE_BUSINESS_UNIT = ON_SAVE_BUSINESS_UNIT;
var ON_SAVE_BUSINESS_UNIT_SUCCESS = 'on_save_business_unit_success';
exports.ON_SAVE_BUSINESS_UNIT_SUCCESS = ON_SAVE_BUSINESS_UNIT_SUCCESS;
var ON_TOGGLE_BUSINESS_UNIT_DRAWER = 'on_toggle_business_unit_drawer';
exports.ON_TOGGLE_BUSINESS_UNIT_DRAWER = ON_TOGGLE_BUSINESS_UNIT_DRAWER;
var SHOW_BUSINESS_UNIT_MESSAGE = 'show_business_unit_message';
exports.SHOW_BUSINESS_UNIT_MESSAGE = SHOW_BUSINESS_UNIT_MESSAGE;
var UPDATE_SEARCH_BUSINESS_UNIT = 'update_search_business_unit'; // projectIssue component actionTypes

exports.UPDATE_SEARCH_BUSINESS_UNIT = UPDATE_SEARCH_BUSINESS_UNIT;
var ADD_FAVOURITE_PROJECT_ISSUE = 'add_favourite_project_issue';
exports.ADD_FAVOURITE_PROJECT_ISSUE = ADD_FAVOURITE_PROJECT_ISSUE;
var ADD_FAVOURITE_PROJECT_ISSUE_SUCCESS = 'add_favourite_project_issue_success';
exports.ADD_FAVOURITE_PROJECT_ISSUE_SUCCESS = ADD_FAVOURITE_PROJECT_ISSUE_SUCCESS;
var FETCH_PROJECT_ISSUE = 'fetch_project_issue';
exports.FETCH_PROJECT_ISSUE = FETCH_PROJECT_ISSUE;
var FETCH_PROJECT_ISSUE_SUCCESS = 'fetch_project_issue_success';
exports.FETCH_PROJECT_ISSUE_SUCCESS = FETCH_PROJECT_ISSUE_SUCCESS;
var FETCH_ALL_PROJECT_ISSUE = 'fetch_all_project_issue';
exports.FETCH_ALL_PROJECT_ISSUE = FETCH_ALL_PROJECT_ISSUE;
var FETCH_ALL_PROJECT_ISSUE_SUCCESS = 'fetch_all_project_issue_success';
exports.FETCH_ALL_PROJECT_ISSUE_SUCCESS = FETCH_ALL_PROJECT_ISSUE_SUCCESS;
var FILTER_PROJECT_ISSUE = 'filter_project_issue';
exports.FILTER_PROJECT_ISSUE = FILTER_PROJECT_ISSUE;
var GET_ALL_PROJECT_ISSUE = 'get_all_project_issue';
exports.GET_ALL_PROJECT_ISSUE = GET_ALL_PROJECT_ISSUE;
var GET_UNSELECTED_ALL_PROJECT_ISSUE = 'get_unselected_all_project_issue';
exports.GET_UNSELECTED_ALL_PROJECT_ISSUE = GET_UNSELECTED_ALL_PROJECT_ISSUE;
var HANDLE_PROJECT_ISSUE_REQUEST_CLOSE = 'handle_project_issue_request_close';
exports.HANDLE_PROJECT_ISSUE_REQUEST_CLOSE = HANDLE_PROJECT_ISSUE_REQUEST_CLOSE;
var HIDE_PROJECT_ISSUE_LOADER = 'hide_project_issue_loader';
exports.HIDE_PROJECT_ISSUE_LOADER = HIDE_PROJECT_ISSUE_LOADER;
var SHOW_PROJECT_ISSUE_LOADER = 'show_project_issue_loader';
exports.SHOW_PROJECT_ISSUE_LOADER = SHOW_PROJECT_ISSUE_LOADER;
var ON_ADD_PROJECT_ISSUE = 'on_add_project_issue';
exports.ON_ADD_PROJECT_ISSUE = ON_ADD_PROJECT_ISSUE;
var ON_ADD_JIRA_PROJECT_ISSUE = 'on_add_jira_project_issue';
exports.ON_ADD_JIRA_PROJECT_ISSUE = ON_ADD_JIRA_PROJECT_ISSUE;
var ON_ALL_PROJECT_ISSUE_SELECT = 'on_all_project_issue_select';
exports.ON_ALL_PROJECT_ISSUE_SELECT = ON_ALL_PROJECT_ISSUE_SELECT;
var ON_PROJECT_ISSUE_CLOSE = 'on_project_issue_close';
exports.ON_PROJECT_ISSUE_CLOSE = ON_PROJECT_ISSUE_CLOSE;
var ON_PROJECT_ISSUE_SELECT = 'on_project_issue_select';
exports.ON_PROJECT_ISSUE_SELECT = ON_PROJECT_ISSUE_SELECT;
var ON_DELETE_PROJECT_ISSUE = 'on_delete_project_issue';
exports.ON_DELETE_PROJECT_ISSUE = ON_DELETE_PROJECT_ISSUE;
var ON_DELETE_PROJECT_ISSUE_SUCCESS = 'on_delete_project_issue_success';
exports.ON_DELETE_PROJECT_ISSUE_SUCCESS = ON_DELETE_PROJECT_ISSUE_SUCCESS;
var ON_FILTER_SELECTED_PROJECT_ISSUE = 'on_filter_selected_project_issue';
exports.ON_FILTER_SELECTED_PROJECT_ISSUE = ON_FILTER_SELECTED_PROJECT_ISSUE;
var ON_FILTER_PROJECT_ISSUE_OPTION_SELECT = 'on_filter_project_issue_option_select';
exports.ON_FILTER_PROJECT_ISSUE_OPTION_SELECT = ON_FILTER_PROJECT_ISSUE_OPTION_SELECT;
var ON_SAVE_PROJECT_ISSUE = 'on_save_project_issue';
exports.ON_SAVE_PROJECT_ISSUE = ON_SAVE_PROJECT_ISSUE;
var ON_SAVE_JIRA_PROJECT_ISSUE = 'on_save_jira_project_issue';
exports.ON_SAVE_JIRA_PROJECT_ISSUE = ON_SAVE_JIRA_PROJECT_ISSUE;
var ON_SAVE_PROJECT_ISSUE_SUCCESS = 'on_save_project_issue_success';
exports.ON_SAVE_PROJECT_ISSUE_SUCCESS = ON_SAVE_PROJECT_ISSUE_SUCCESS;
var ON_TOGGLE_PROJECT_ISSUE_DRAWER = 'on_toggle_project_issue_drawer';
exports.ON_TOGGLE_PROJECT_ISSUE_DRAWER = ON_TOGGLE_PROJECT_ISSUE_DRAWER;
var SHOW_PROJECT_ISSUE_MESSAGE = 'show_project_issue_message';
exports.SHOW_PROJECT_ISSUE_MESSAGE = SHOW_PROJECT_ISSUE_MESSAGE;
var UPDATE_SEARCH_PROJECT_ISSUE = 'update_search_project_issue'; // project priorities

exports.UPDATE_SEARCH_PROJECT_ISSUE = UPDATE_SEARCH_PROJECT_ISSUE;
var ADD_FAVOURITE_PROJECT_PRIORITY = 'add_favourite_project_priority';
exports.ADD_FAVOURITE_PROJECT_PRIORITY = ADD_FAVOURITE_PROJECT_PRIORITY;
var FETCH_PROJECT_PRIORITY = 'fetch_project_priority';
exports.FETCH_PROJECT_PRIORITY = FETCH_PROJECT_PRIORITY;
var FETCH_PROJECT_PRIORITY_SUCCESS = 'fetch_project_priority_success';
exports.FETCH_PROJECT_PRIORITY_SUCCESS = FETCH_PROJECT_PRIORITY_SUCCESS;
var FETCH_ALL_PROJECT_PRIORITY = 'fetch_all_project_priority';
exports.FETCH_ALL_PROJECT_PRIORITY = FETCH_ALL_PROJECT_PRIORITY;
var FETCH_ALL_PROJECT_PRIORITY_SUCCESS = 'fetch_all_project_priority_success';
exports.FETCH_ALL_PROJECT_PRIORITY_SUCCESS = FETCH_ALL_PROJECT_PRIORITY_SUCCESS;
var FILTER_PROJECT_PRIORITY = 'filter_project_priority';
exports.FILTER_PROJECT_PRIORITY = FILTER_PROJECT_PRIORITY;
var GET_ALL_PROJECT_PRIORITY = 'get_all_project_priority';
exports.GET_ALL_PROJECT_PRIORITY = GET_ALL_PROJECT_PRIORITY;
var GET_UNSELECTED_ALL_PROJECT_PRIORITY = 'get_unselected_all_project_priority';
exports.GET_UNSELECTED_ALL_PROJECT_PRIORITY = GET_UNSELECTED_ALL_PROJECT_PRIORITY;
var HANDLE_PROJECT_PRIORITY_REQUEST_CLOSE = 'handle_project_priority_request_close';
exports.HANDLE_PROJECT_PRIORITY_REQUEST_CLOSE = HANDLE_PROJECT_PRIORITY_REQUEST_CLOSE;
var HIDE_PROJECT_PRIORITY_LOADER = 'hide_project_priority_loader';
exports.HIDE_PROJECT_PRIORITY_LOADER = HIDE_PROJECT_PRIORITY_LOADER;
var SHOW_PROJECT_PRIORITY_LOADER = 'show_project_priority_loader';
exports.SHOW_PROJECT_PRIORITY_LOADER = SHOW_PROJECT_PRIORITY_LOADER;
var ON_ADD_PROJECT_PRIORITY = 'on_add_project_priority';
exports.ON_ADD_PROJECT_PRIORITY = ON_ADD_PROJECT_PRIORITY;
var ON_ALL_PROJECT_PRIORITY_SELECT = 'on_all_project_priority_select';
exports.ON_ALL_PROJECT_PRIORITY_SELECT = ON_ALL_PROJECT_PRIORITY_SELECT;
var ON_PROJECT_PRIORITY_CLOSE = 'on_project_priority_close';
exports.ON_PROJECT_PRIORITY_CLOSE = ON_PROJECT_PRIORITY_CLOSE;
var ON_PROJECT_PRIORITY_SELECT = 'on_project_priority_select';
exports.ON_PROJECT_PRIORITY_SELECT = ON_PROJECT_PRIORITY_SELECT;
var ON_DELETE_PROJECT_PRIORITY = 'on_delete_project_priority';
exports.ON_DELETE_PROJECT_PRIORITY = ON_DELETE_PROJECT_PRIORITY;
var ON_DELETE_PROJECT_PRIORITY_SUCCESS = 'on_delete_project_priority_success';
exports.ON_DELETE_PROJECT_PRIORITY_SUCCESS = ON_DELETE_PROJECT_PRIORITY_SUCCESS;
var ON_DELETE_SELECTED_PROJECT_PRIORITY = 'on_delete_selected_project_priority';
exports.ON_DELETE_SELECTED_PROJECT_PRIORITY = ON_DELETE_SELECTED_PROJECT_PRIORITY;
var ON_FILTER_PROJECT_PRIORITY_OPTION_SELECT = 'on_filter_project_priority_option_select';
exports.ON_FILTER_PROJECT_PRIORITY_OPTION_SELECT = ON_FILTER_PROJECT_PRIORITY_OPTION_SELECT;
var ON_SAVE_PROJECT_PRIORITY = 'on_save_project_priority';
exports.ON_SAVE_PROJECT_PRIORITY = ON_SAVE_PROJECT_PRIORITY;
var ON_SAVE_PROJECT_PRIORITY_SUCCESS = 'on_save_project_priority_success';
exports.ON_SAVE_PROJECT_PRIORITY_SUCCESS = ON_SAVE_PROJECT_PRIORITY_SUCCESS;
var ON_TOGGLE_PROJECT_PRIORITY_DRAWER = 'on_toggle_project_priority_drawer';
exports.ON_TOGGLE_PROJECT_PRIORITY_DRAWER = ON_TOGGLE_PROJECT_PRIORITY_DRAWER;
var SHOW_PROJECT_PRIORITY_MESSAGE = 'show_project_priority_message';
exports.SHOW_PROJECT_PRIORITY_MESSAGE = SHOW_PROJECT_PRIORITY_MESSAGE;
var UPDATE_SEARCH_PROJECT_PRIORITY = 'update_search_project_priority'; // projects

exports.UPDATE_SEARCH_PROJECT_PRIORITY = UPDATE_SEARCH_PROJECT_PRIORITY;
var ADD_FAVOURITE_PROJECT = 'add_favourite_project';
exports.ADD_FAVOURITE_PROJECT = ADD_FAVOURITE_PROJECT;
var ADD_FAVOURITE_PROJECT_SUCCESS = 'add_favourite_project_success';
exports.ADD_FAVOURITE_PROJECT_SUCCESS = ADD_FAVOURITE_PROJECT_SUCCESS;
var FETCH_PROJECT = 'fetch_project';
exports.FETCH_PROJECT = FETCH_PROJECT;
var FETCH_PROJECT_SUCCESS = 'fetch_project_success';
exports.FETCH_PROJECT_SUCCESS = FETCH_PROJECT_SUCCESS;
var FETCH_ALL_PROJECT = 'fetch_all_project';
exports.FETCH_ALL_PROJECT = FETCH_ALL_PROJECT;
var FETCH_ALL_PROJECT_SUCCESS = 'fetch_all_project_success';
exports.FETCH_ALL_PROJECT_SUCCESS = FETCH_ALL_PROJECT_SUCCESS;
var FILTER_PROJECT = 'filter_project';
exports.FILTER_PROJECT = FILTER_PROJECT;
var GET_ALL_PROJECT = 'get_all_project';
exports.GET_ALL_PROJECT = GET_ALL_PROJECT;
var GET_UNSELECTED_ALL_PROJECT = 'get_unselected_all_project';
exports.GET_UNSELECTED_ALL_PROJECT = GET_UNSELECTED_ALL_PROJECT;
var HANDLE_PROJECT_REQUEST_CLOSE = 'handle_project_request_close';
exports.HANDLE_PROJECT_REQUEST_CLOSE = HANDLE_PROJECT_REQUEST_CLOSE;
var HIDE_PROJECT_LOADER = 'hide_project_loader';
exports.HIDE_PROJECT_LOADER = HIDE_PROJECT_LOADER;
var SHOW_PROJECT_LOADER = 'show_project_loader';
exports.SHOW_PROJECT_LOADER = SHOW_PROJECT_LOADER;
var ON_ADD_PROJECT = 'on_add_project';
exports.ON_ADD_PROJECT = ON_ADD_PROJECT;
var ON_EDIT_PROJECT = 'on_edit_project';
exports.ON_EDIT_PROJECT = ON_EDIT_PROJECT;
var ON_ALL_PROJECT_SELECT = 'on_all_project_select';
exports.ON_ALL_PROJECT_SELECT = ON_ALL_PROJECT_SELECT;
var ON_PROJECT_CLOSE = 'on_project_close';
exports.ON_PROJECT_CLOSE = ON_PROJECT_CLOSE;
var ON_PROJECT_SELECT = 'on_project_select';
exports.ON_PROJECT_SELECT = ON_PROJECT_SELECT;
var ON_DELETE_PROJECT = 'on_delete_project';
exports.ON_DELETE_PROJECT = ON_DELETE_PROJECT;
var ON_DELETE_PROJECT_SUCCESS = 'on_delete_project_success';
exports.ON_DELETE_PROJECT_SUCCESS = ON_DELETE_PROJECT_SUCCESS;
var ON_DELETE_SELECTED_PROJECT = 'on_delete_selected_project';
exports.ON_DELETE_SELECTED_PROJECT = ON_DELETE_SELECTED_PROJECT;
var ON_FILTER_PROJECT_OPTION_SELECT = 'on_filter_project_option_select';
exports.ON_FILTER_PROJECT_OPTION_SELECT = ON_FILTER_PROJECT_OPTION_SELECT;
var ON_SAVE_PROJECT = 'on_save_project';
exports.ON_SAVE_PROJECT = ON_SAVE_PROJECT;
var ON_UPDATE_PROJECT_PRIORITIES = 'on_update_project_priorities';
exports.ON_UPDATE_PROJECT_PRIORITIES = ON_UPDATE_PROJECT_PRIORITIES;
var ON_SAVE_PROJECT_SUCCESS = 'on_save_project_success';
exports.ON_SAVE_PROJECT_SUCCESS = ON_SAVE_PROJECT_SUCCESS;
var ON_TOGGLE_PROJECT_DRAWER = 'on_toggle_project_drawer';
exports.ON_TOGGLE_PROJECT_DRAWER = ON_TOGGLE_PROJECT_DRAWER;
var SHOW_PROJECT_MESSAGE = 'show_project_message';
exports.SHOW_PROJECT_MESSAGE = SHOW_PROJECT_MESSAGE;
var UPDATE_SEARCH_PROJECT = 'update_search_project';
exports.UPDATE_SEARCH_PROJECT = UPDATE_SEARCH_PROJECT;
var ON_PROJECT_COST_PRIORITIES_DASHBOARD = 'on_project_cost_priorities_dashboard';
exports.ON_PROJECT_COST_PRIORITIES_DASHBOARD = ON_PROJECT_COST_PRIORITIES_DASHBOARD;
var ON_GLOBAL_PROJECT_COST_PRIORITIES_DASHBOARD = 'on_global_project_cost_priorities_dashboard';
exports.ON_GLOBAL_PROJECT_COST_PRIORITIES_DASHBOARD = ON_GLOBAL_PROJECT_COST_PRIORITIES_DASHBOARD;
var ON_GLOBAL_PROJECT_BUSINESS_PRIORITIES_DASHBOARD = 'on_global_project_business_priorities_dashboard';
exports.ON_GLOBAL_PROJECT_BUSINESS_PRIORITIES_DASHBOARD = ON_GLOBAL_PROJECT_BUSINESS_PRIORITIES_DASHBOARD;
var ON_PROJECT_BUSINESS_PRIORITIES_DASHBOARD = 'on_project_business_priorities_dashboard';
exports.ON_PROJECT_BUSINESS_PRIORITIES_DASHBOARD = ON_PROJECT_BUSINESS_PRIORITIES_DASHBOARD;
var FETCH_IMPORT_PROJECTS = 'fetch_import_projects';
exports.FETCH_IMPORT_PROJECTS = FETCH_IMPORT_PROJECTS;
var FETCH_IMPORT_PROJECTS_SUCCESS = 'fetch_import_projects_success';
exports.FETCH_IMPORT_PROJECTS_SUCCESS = FETCH_IMPORT_PROJECTS_SUCCESS;
var SHOW_IMPORT_PROJECTS_LOADER = 'show_import_projects_loader';
exports.SHOW_IMPORT_PROJECTS_LOADER = SHOW_IMPORT_PROJECTS_LOADER;
var HIDE_IMPORT_PROJECTS_LOADER = 'hide_import_projects_loader';
exports.HIDE_IMPORT_PROJECTS_LOADER = HIDE_IMPORT_PROJECTS_LOADER;
var ON_IMPORT_PROJECTS = 'on_import_projects';
exports.ON_IMPORT_PROJECTS = ON_IMPORT_PROJECTS;
var ON_IMPORT_PROJECTS_SUCCESS = 'on_import_projects_success';
exports.ON_IMPORT_PROJECTS_SUCCESS = ON_IMPORT_PROJECTS_SUCCESS;
var ON_PROJECT_ISSUES_DASHBOARD = 'on_project_issues_dashboard';
exports.ON_PROJECT_ISSUES_DASHBOARD = ON_PROJECT_ISSUES_DASHBOARD;
var ON_SAVE_PROJECT_ISSUE_CACHE_SUCCESS = 'on_save_project_issues_cache_success';
exports.ON_SAVE_PROJECT_ISSUE_CACHE_SUCCESS = ON_SAVE_PROJECT_ISSUE_CACHE_SUCCESS;
var ON_SAVE_PROJECT_CACHE_SUCCESS = 'on_save_project_cache_success';
exports.ON_SAVE_PROJECT_CACHE_SUCCESS = ON_SAVE_PROJECT_CACHE_SUCCESS;
var SET_PROJECT_ISSUE = 'set_project_issue';
exports.SET_PROJECT_ISSUE = SET_PROJECT_ISSUE;
var SET_PROJECT = 'set_project'; // Customizer const

exports.SET_PROJECT = SET_PROJECT;
var TOGGLE_COLLAPSED_NAV = 'toggle_collapse_menu';
exports.TOGGLE_COLLAPSED_NAV = TOGGLE_COLLAPSED_NAV;
var DRAWER_TYPE = 'drawer_type';
exports.DRAWER_TYPE = DRAWER_TYPE;
var FIXED_DRAWER = 'fixed_drawer';
exports.FIXED_DRAWER = FIXED_DRAWER;
var COLLAPSED_DRAWER = 'collapsible';
exports.COLLAPSED_DRAWER = COLLAPSED_DRAWER;
var MINI_DRAWER = 'mini_drawer';
exports.MINI_DRAWER = MINI_DRAWER;
var THEME_COLOR = 'theme_color';
exports.THEME_COLOR = THEME_COLOR;
var DARK_THEME = 'dark_theme';
exports.DARK_THEME = DARK_THEME;
var WINDOW_WIDTH = 'window-width';
exports.WINDOW_WIDTH = WINDOW_WIDTH;
var WINDOW_HEIGHT = 'window-height';
exports.WINDOW_HEIGHT = WINDOW_HEIGHT;
var SWITCH_LANGUAGE = 'switch-language';
exports.SWITCH_LANGUAGE = SWITCH_LANGUAGE;
var CHANGE_DIRECTION = 'change-direction';
exports.CHANGE_DIRECTION = CHANGE_DIRECTION;
var CHANGE_NAVIGATION_STYLE = 'change-navigation-style';
exports.CHANGE_NAVIGATION_STYLE = CHANGE_NAVIGATION_STYLE;
var HORIZONTAL_NAVIGATION = 'horizontal_navigation';
exports.HORIZONTAL_NAVIGATION = HORIZONTAL_NAVIGATION;
var VERTICAL_NAVIGATION = 'vertical_navigation';
exports.VERTICAL_NAVIGATION = VERTICAL_NAVIGATION;
var HORIZONTAL_MENU_POSITION = 'horizontal_menu_position';
exports.HORIZONTAL_MENU_POSITION = HORIZONTAL_MENU_POSITION;
var ABOVE_THE_HEADER = 'above_the_header';
exports.ABOVE_THE_HEADER = ABOVE_THE_HEADER;
var INSIDE_THE_HEADER = 'inside_the_header';
exports.INSIDE_THE_HEADER = INSIDE_THE_HEADER;
var BELOW_THE_HEADER = 'below_the_header';
exports.BELOW_THE_HEADER = BELOW_THE_HEADER;
var COLOR_OPTIONS_MODAL = 'color_options_modal';
exports.COLOR_OPTIONS_MODAL = COLOR_OPTIONS_MODAL;
var USER_INFO_MODAL = 'user_info_modal'; // clear session data

exports.USER_INFO_MODAL = USER_INFO_MODAL;
var CLEAR_SESSION = 'session.clear';
exports.CLEAR_SESSION = CLEAR_SESSION;
var CLEAR_SELECTED_OBJECTS = 'clear.selected.objects'; //Contact Module const

exports.CLEAR_SELECTED_OBJECTS = CLEAR_SELECTED_OBJECTS;
var SHOW_MESSAGE = 'show_message';
exports.SHOW_MESSAGE = SHOW_MESSAGE;
var HIDE_MESSAGE = 'hide_message';
exports.HIDE_MESSAGE = HIDE_MESSAGE;
var ON_SHOW_LOADER = 'on_show_loader';
exports.ON_SHOW_LOADER = ON_SHOW_LOADER;
var ON_HIDE_LOADER = 'on_hide_loader';
exports.ON_HIDE_LOADER = ON_HIDE_LOADER;
var ON_TOGGLE_DRAWER = 'on_toggle_drawer';
exports.ON_TOGGLE_DRAWER = ON_TOGGLE_DRAWER;
var HANDLE_REQUEST_CLOSE = 'handle_request_close';
exports.HANDLE_REQUEST_CLOSE = HANDLE_REQUEST_CLOSE;
var ADD_FAVOURITE = 'add_favourite';
exports.ADD_FAVOURITE = ADD_FAVOURITE;
var FETCH_ALL_CONTACT = 'fetch_all_contact';
exports.FETCH_ALL_CONTACT = FETCH_ALL_CONTACT;
var FETCH_ALL_CONTACT_SUCCESS = 'fetch_all_contact_success';
exports.FETCH_ALL_CONTACT_SUCCESS = FETCH_ALL_CONTACT_SUCCESS;
var ON_CONTACT_SELECT = 'on_contact_select';
exports.ON_CONTACT_SELECT = ON_CONTACT_SELECT;
var ON_ADD_CONTACT = 'on_add_contact';
exports.ON_ADD_CONTACT = ON_ADD_CONTACT;
var ON_CONTACT_CLOSE = 'on_contact_close';
exports.ON_CONTACT_CLOSE = ON_CONTACT_CLOSE;
var ON_FILTER_OPTION_SELECT = 'on_filter_option_select';
exports.ON_FILTER_OPTION_SELECT = ON_FILTER_OPTION_SELECT;
var ON_SAVE_CONTACT = 'on_save_contact';
exports.ON_SAVE_CONTACT = ON_SAVE_CONTACT;
var ON_DELETE_CONTACT = 'on_delete_contact';
exports.ON_DELETE_CONTACT = ON_DELETE_CONTACT;
var ON_DELETE_SELECTED_CONTACT = 'on_delete_selected_contact';
exports.ON_DELETE_SELECTED_CONTACT = ON_DELETE_SELECTED_CONTACT;
var FILTER_CONTACT = 'filter_contact';
exports.FILTER_CONTACT = FILTER_CONTACT;
var GET_ALL_CONTACT = 'get_all_contact';
exports.GET_ALL_CONTACT = GET_ALL_CONTACT;
var GET_UNSELECTED_ALL_CONTACT = 'get_unselected_all_contact';
exports.GET_UNSELECTED_ALL_CONTACT = GET_UNSELECTED_ALL_CONTACT;
var ON_ALL_CONTACT_SELECT = 'on_all_contact_select';
exports.ON_ALL_CONTACT_SELECT = ON_ALL_CONTACT_SELECT;
var UPDATE_SEARCH_USER = 'update_search_user';
exports.UPDATE_SEARCH_USER = UPDATE_SEARCH_USER;
var HIDE_CONTACT_LOADER = 'hide_contact_loader'; //Auth const

exports.HIDE_CONTACT_LOADER = HIDE_CONTACT_LOADER;
var SIGNUP_USER = 'signup_user';
exports.SIGNUP_USER = SIGNUP_USER;
var SIGNUP_USER_SUCCESS = 'signup_user_success';
exports.SIGNUP_USER_SUCCESS = SIGNUP_USER_SUCCESS;
var SIGNIN_GOOGLE_USER = 'signin_google_user';
exports.SIGNIN_GOOGLE_USER = SIGNIN_GOOGLE_USER;
var SIGNIN_GOOGLE_USER_SUCCESS = 'signin_google_user_success';
exports.SIGNIN_GOOGLE_USER_SUCCESS = SIGNIN_GOOGLE_USER_SUCCESS;
var SIGNIN_FACEBOOK_USER = 'signin_facebook_user';
exports.SIGNIN_FACEBOOK_USER = SIGNIN_FACEBOOK_USER;
var SIGNIN_FACEBOOK_USER_SUCCESS = 'signin_facebook_user_success';
exports.SIGNIN_FACEBOOK_USER_SUCCESS = SIGNIN_FACEBOOK_USER_SUCCESS;
var SIGNIN_TWITTER_USER = 'signin_twitter_user';
exports.SIGNIN_TWITTER_USER = SIGNIN_TWITTER_USER;
var SIGNIN_TWITTER_USER_SUCCESS = 'signin_twitter_user_success';
exports.SIGNIN_TWITTER_USER_SUCCESS = SIGNIN_TWITTER_USER_SUCCESS;
var SIGNIN_GITHUB_USER = 'signin_github_user';
exports.SIGNIN_GITHUB_USER = SIGNIN_GITHUB_USER;
var SIGNIN_GITHUB_USER_SUCCESS = 'signin_github_user_SUCCESS';
exports.SIGNIN_GITHUB_USER_SUCCESS = SIGNIN_GITHUB_USER_SUCCESS;
var SIGNIN_USER = 'signin_user';
exports.SIGNIN_USER = SIGNIN_USER;
var SIGNIN_USER_PASSWORDLESS = 'signin_user_passwordless';
exports.SIGNIN_USER_PASSWORDLESS = SIGNIN_USER_PASSWORDLESS;
var SIGNIN_USER_SUCCESS = 'signin_user_success';
exports.SIGNIN_USER_SUCCESS = SIGNIN_USER_SUCCESS;
var SIGNOUT_USER = 'signout_user';
exports.SIGNOUT_USER = SIGNOUT_USER;
var SIGNOUT_USER_SUCCESS = 'signout_user_success';
exports.SIGNOUT_USER_SUCCESS = SIGNOUT_USER_SUCCESS;
var INIT_URL = 'init_url';
exports.INIT_URL = INIT_URL;
var IDENTITY_SUCCESS = 'identity_success';
exports.IDENTITY_SUCCESS = IDENTITY_SUCCESS;
var REQUEST_SIGNIN_ACCESS_CODE = 'request_signin_user_code';
exports.REQUEST_SIGNIN_ACCESS_CODE = REQUEST_SIGNIN_ACCESS_CODE;
var REQUEST_SIGNIN_ACCESS_CODE_SUCCESS = 'request_signin_user_code_success'; // Chat Module const

exports.REQUEST_SIGNIN_ACCESS_CODE_SUCCESS = REQUEST_SIGNIN_ACCESS_CODE_SUCCESS;
var FETCH_ALL_CHAT_USER = 'fetch_all_chat_user';
exports.FETCH_ALL_CHAT_USER = FETCH_ALL_CHAT_USER;
var FETCH_ALL_CHAT_USER_CONVERSATION = 'fetch_all_chat_user_conversation';
exports.FETCH_ALL_CHAT_USER_CONVERSATION = FETCH_ALL_CHAT_USER_CONVERSATION;
var FETCH_ALL_CHAT_USER_SUCCESS = 'fetch_all_chat_user_success';
exports.FETCH_ALL_CHAT_USER_SUCCESS = FETCH_ALL_CHAT_USER_SUCCESS;
var FETCH_ALL_CHAT_USER_CONVERSATION_SUCCESS = 'fetch_all_chat_user_conversation_success';
exports.FETCH_ALL_CHAT_USER_CONVERSATION_SUCCESS = FETCH_ALL_CHAT_USER_CONVERSATION_SUCCESS;
var FILTER_USERS = 'filter_users';
exports.FILTER_USERS = FILTER_USERS;
var ON_SELECT_USER = 'on_select_user';
exports.ON_SELECT_USER = ON_SELECT_USER;
var USER_INFO_STATE = 'user_info_state';
exports.USER_INFO_STATE = USER_INFO_STATE;
var SUBMIT_COMMENT = 'submit_comment';
exports.SUBMIT_COMMENT = SUBMIT_COMMENT;
var UPDATE_MESSAGE_VALUE = 'update_message_value';
exports.UPDATE_MESSAGE_VALUE = UPDATE_MESSAGE_VALUE;
var UPDATE_SEARCH_CHAT_USER = 'update_search_chat_user'; //// Mail Module const

exports.UPDATE_SEARCH_CHAT_USER = UPDATE_SEARCH_CHAT_USER;
var ADD_LABEL = 'ADD_LABEL';
exports.ADD_LABEL = ADD_LABEL;
var GET_ALL_MAIL = 'get_all_mail';
exports.GET_ALL_MAIL = GET_ALL_MAIL;
var FETCH_ALL_MAIL = 'fetch_all_mail';
exports.FETCH_ALL_MAIL = FETCH_ALL_MAIL;
var FETCH_ALL_MAIL_SUCCESS = 'fetch_all_mail_success';
exports.FETCH_ALL_MAIL_SUCCESS = FETCH_ALL_MAIL_SUCCESS;
var GET_IMPORTANT_MAIL = 'get_important_mail';
exports.GET_IMPORTANT_MAIL = GET_IMPORTANT_MAIL;
var GET_NAV_FILTERS = 'get_nav_filters';
exports.GET_NAV_FILTERS = GET_NAV_FILTERS;
var GET_NAV_LABELS = 'get_nav_labels';
exports.GET_NAV_LABELS = GET_NAV_LABELS;
var GET_NAV_FOLDER = 'get_nav_folder';
exports.GET_NAV_FOLDER = GET_NAV_FOLDER;
var GET_READ_MAIL = 'get_read_mail';
exports.GET_READ_MAIL = GET_READ_MAIL;
var GET_STARRED_MAIL = 'get_starred_mail';
exports.GET_STARRED_MAIL = GET_STARRED_MAIL;
var GET_UNIMPORTANT_MAIL = 'get_unimportant_mail';
exports.GET_UNIMPORTANT_MAIL = GET_UNIMPORTANT_MAIL;
var GET_UNREAD_MAIL = 'get_unread_mail';
exports.GET_UNREAD_MAIL = GET_UNREAD_MAIL;
var GET_UNSELECTED_ALL_MAIL = 'get_unselected_all_mail';
exports.GET_UNSELECTED_ALL_MAIL = GET_UNSELECTED_ALL_MAIL;
var GET_UNSTARRED_MAIL = 'get_unstarred_mail';
exports.GET_UNSTARRED_MAIL = GET_UNSTARRED_MAIL;
var ON_ALL_MAIL_SELECT = 'on_all_mail_select';
exports.ON_ALL_MAIL_SELECT = ON_ALL_MAIL_SELECT;
var ON_FOLDER_MENU_ITEM_SELECT = 'on_folder_menu_item_select';
exports.ON_FOLDER_MENU_ITEM_SELECT = ON_FOLDER_MENU_ITEM_SELECT;
var ON_FOLDER_SELECT = 'on_folder_select';
exports.ON_FOLDER_SELECT = ON_FOLDER_SELECT;
var ON_IMPORTANT_SELECT = 'on_important_select';
exports.ON_IMPORTANT_SELECT = ON_IMPORTANT_SELECT;
var ON_LABEL_MENU_ITEM_SELECT = 'on_label_menu_item_select';
exports.ON_LABEL_MENU_ITEM_SELECT = ON_LABEL_MENU_ITEM_SELECT;
var GET_MARK_AS_START = 'get_mark_as_start';
exports.GET_MARK_AS_START = GET_MARK_AS_START;
var ON_LABEL_SELECT = 'on_label_select';
exports.ON_LABEL_SELECT = ON_LABEL_SELECT;
var ON_MAIL_CHECKED = 'on_mail_checked';
exports.ON_MAIL_CHECKED = ON_MAIL_CHECKED;
var ON_MAIL_SELECT = 'on_mail_select';
exports.ON_MAIL_SELECT = ON_MAIL_SELECT;
var ON_MAIL_SEND = 'on_mail_send';
exports.ON_MAIL_SEND = ON_MAIL_SEND;
var ON_OPTION_MENU_ITEM_SELECT = 'on_option_menu_item_select';
exports.ON_OPTION_MENU_ITEM_SELECT = ON_OPTION_MENU_ITEM_SELECT;
var ON_OPTION_MENU_SELECT = 'on_option_menu_select';
exports.ON_OPTION_MENU_SELECT = ON_OPTION_MENU_SELECT;
var ON_START_SELECT = 'on_start_select';
exports.ON_START_SELECT = ON_START_SELECT;
var SEARCH_MAIL = 'search_mail';
exports.SEARCH_MAIL = SEARCH_MAIL;
var ON_DELETE_MAIL = 'on_delete_mail';
exports.ON_DELETE_MAIL = ON_DELETE_MAIL;
var SET_CURRENT_MAIL_NULL = 'set_current_mail_null';
exports.SET_CURRENT_MAIL_NULL = SET_CURRENT_MAIL_NULL;
var ON_COMPOSE_MAIL = 'on_compose_mail'; //// TO-DO Module const

exports.ON_COMPOSE_MAIL = ON_COMPOSE_MAIL;
var ON_SORTEND = 'on_sortend';
exports.ON_SORTEND = ON_SORTEND;
var FETCH_ALL_TODO = 'fetch_all_todo';
exports.FETCH_ALL_TODO = FETCH_ALL_TODO;
var FETCH_ALL_TODO_SUCCESS = 'fetch_all_todo-success';
exports.FETCH_ALL_TODO_SUCCESS = FETCH_ALL_TODO_SUCCESS;
var FETCH_ALL_TODO_CONVERSATION = 'fetch_all_todo_conversation';
exports.FETCH_ALL_TODO_CONVERSATION = FETCH_ALL_TODO_CONVERSATION;
var FETCH_ALL_TODO_CONVERSATION_SUCCESS = 'fetch_all_todo_conversation_success';
exports.FETCH_ALL_TODO_CONVERSATION_SUCCESS = FETCH_ALL_TODO_CONVERSATION_SUCCESS;
var SELECT_ALL_TODO = 'select_all_todo';
exports.SELECT_ALL_TODO = SELECT_ALL_TODO;
var GET_ALL_TODO = 'get_all_todo';
exports.GET_ALL_TODO = GET_ALL_TODO;
var GET_UNSELECTED_ALL_TODO = 'get_unselected_all_todo';
exports.GET_UNSELECTED_ALL_TODO = GET_UNSELECTED_ALL_TODO;
var GET_STARRED_TODO = 'get_starred_todo';
exports.GET_STARRED_TODO = GET_STARRED_TODO;
var GET_UNSTARRED_TODO = 'get_unstarred_todo';
exports.GET_UNSTARRED_TODO = GET_UNSTARRED_TODO;
var GET_IMPORTANT_TODO = 'get_important_todo';
exports.GET_IMPORTANT_TODO = GET_IMPORTANT_TODO;
var GET_UNIMPORTANT_TODO = 'get_unimportant_todo';
exports.GET_UNIMPORTANT_TODO = GET_UNIMPORTANT_TODO;
var ON_LABEL_UPDATE = 'on_label_update';
exports.ON_LABEL_UPDATE = ON_LABEL_UPDATE;
var ON_TODO_UPDATE = 'on_todo_update';
exports.ON_TODO_UPDATE = ON_TODO_UPDATE;
var ON_DELETE_TODO = 'on_delete_todo';
exports.ON_DELETE_TODO = ON_DELETE_TODO;
var SEARCH_TODO = 'search_todo';
exports.SEARCH_TODO = SEARCH_TODO;
var SHOW_TODOS = 'show_todos';
exports.SHOW_TODOS = SHOW_TODOS;
var GET_TODO_CONVERSATION = 'get_todo_conversation';
exports.GET_TODO_CONVERSATION = GET_TODO_CONVERSATION;
var ON_TODO_CHECKED = 'on_todo_checked';
exports.ON_TODO_CHECKED = ON_TODO_CHECKED;
var ON_TODO_ADD = 'on_todo_add';
exports.ON_TODO_ADD = ON_TODO_ADD;
var ON_TODO_SELECT = 'on_todo_select';
exports.ON_TODO_SELECT = ON_TODO_SELECT;
var SET_CURRENT_TODO_NULL = 'set_current_todo_null';
exports.SET_CURRENT_TODO_NULL = SET_CURRENT_TODO_NULL;
var REMOVE_LABEL = 'remove_label';
exports.REMOVE_LABEL = REMOVE_LABEL;
var UPDATE_SEARCH = 'update_search'; // organisations

exports.UPDATE_SEARCH = UPDATE_SEARCH;
var SHOW_ORG_MESSAGE = 'show_org_message';
exports.SHOW_ORG_MESSAGE = SHOW_ORG_MESSAGE;
var ON_TOGGLE_ORG_DRAWER = 'toggle_org_drawer';
exports.ON_TOGGLE_ORG_DRAWER = ON_TOGGLE_ORG_DRAWER;
var HANDLE_ORG_REQUEST_CLOSE = 'handle_org_request_close';
exports.HANDLE_ORG_REQUEST_CLOSE = HANDLE_ORG_REQUEST_CLOSE;
var ON_FILTER_ORG_OPTION_SELECT = 'on_filter_org_option_select';
exports.ON_FILTER_ORG_OPTION_SELECT = ON_FILTER_ORG_OPTION_SELECT;
var HIDE_ORG_LOADER = 'hide_org_loader';
exports.HIDE_ORG_LOADER = HIDE_ORG_LOADER;
var SHOW_ORG_LOADER = 'show_org_loader';
exports.SHOW_ORG_LOADER = SHOW_ORG_LOADER;
var ADD_FAVOURITE_ORG = 'add_favourite_org';
exports.ADD_FAVOURITE_ORG = ADD_FAVOURITE_ORG;
var FETCH_ORG = 'fetch_org';
exports.FETCH_ORG = FETCH_ORG;
var FETCH_ORG_SUCCESS = 'fetch_org_success';
exports.FETCH_ORG_SUCCESS = FETCH_ORG_SUCCESS;
var FETCH_ORGS_SELECT_ORG = 'fetch_org_select_org';
exports.FETCH_ORGS_SELECT_ORG = FETCH_ORGS_SELECT_ORG;
var FETCH_ALL_ORG = 'fetch_all_org';
exports.FETCH_ALL_ORG = FETCH_ALL_ORG;
var FETCH_ALL_ORG_SUCCESS = 'fetch_all_org_success';
exports.FETCH_ALL_ORG_SUCCESS = FETCH_ALL_ORG_SUCCESS;
var ON_ORG_SELECT = 'on_org_select';
exports.ON_ORG_SELECT = ON_ORG_SELECT;
var ON_ADD_ORG = 'on_add_org';
exports.ON_ADD_ORG = ON_ADD_ORG;
var ON_ORG_CLOSE = 'on_org_close';
exports.ON_ORG_CLOSE = ON_ORG_CLOSE;
var ON_SAVE_ORG = 'on_save_org';
exports.ON_SAVE_ORG = ON_SAVE_ORG;
var ON_SAVE_ORG_SUCCESS = 'on_save_org_success';
exports.ON_SAVE_ORG_SUCCESS = ON_SAVE_ORG_SUCCESS;
var ON_DELETE_ORG = 'on_delete_org';
exports.ON_DELETE_ORG = ON_DELETE_ORG;
var ON_DELETE_SELECTED_ORG = 'on_delete_selected_org';
exports.ON_DELETE_SELECTED_ORG = ON_DELETE_SELECTED_ORG;
var FILTER_ORG = 'filter_org';
exports.FILTER_ORG = FILTER_ORG;
var GET_ALL_ORG = 'get_all_org';
exports.GET_ALL_ORG = GET_ALL_ORG;
var GET_UNSELECTED_ALL_ORG = 'get_unselected_all_org';
exports.GET_UNSELECTED_ALL_ORG = GET_UNSELECTED_ALL_ORG;
var ON_ALL_ORG_SELECT = 'on_all_org_select';
exports.ON_ALL_ORG_SELECT = ON_ALL_ORG_SELECT;
var UPDATE_SEARCH_ORG = 'update_search_org';
exports.UPDATE_SEARCH_ORG = UPDATE_SEARCH_ORG;
var ON_EMP_DASHBOARD = 'on_emp_dashboard';
exports.ON_EMP_DASHBOARD = ON_EMP_DASHBOARD;
var ON_ORG_SURVEY_DASHBOARD = 'on_org_survey_dashbaord';
exports.ON_ORG_SURVEY_DASHBOARD = ON_ORG_SURVEY_DASHBOARD;
var ON_ORG_DASHBOARD = 'on_org_dashbaord';
exports.ON_ORG_DASHBOARD = ON_ORG_DASHBOARD;
var ON_ORG_DASHBOARD_SUCCESS = 'on_org_dashbaord_success';
exports.ON_ORG_DASHBOARD_SUCCESS = ON_ORG_DASHBOARD_SUCCESS;
var ON_PROJECT_DASHBOARD = 'on_project_dashboard';
exports.ON_PROJECT_DASHBOARD = ON_PROJECT_DASHBOARD;
var ON_IMPERSONATE_DASHBOARD = 'on_impersonate_dashboard';
exports.ON_IMPERSONATE_DASHBOARD = ON_IMPERSONATE_DASHBOARD;
var ON_PROJECT_PRIORITY_DASHBOARD = 'on_project_priority_dashboard';
exports.ON_PROJECT_PRIORITY_DASHBOARD = ON_PROJECT_PRIORITY_DASHBOARD;
var FETCH_ORG_STATISTICS = 'fetch_org_statistics';
exports.FETCH_ORG_STATISTICS = FETCH_ORG_STATISTICS;
var FETCH_ORG_STATISTICS_SUCCESS = 'fetch_org_statistics_success'; // employees

exports.FETCH_ORG_STATISTICS_SUCCESS = FETCH_ORG_STATISTICS_SUCCESS;
var SHOW_EMP_MESSAGE = 'show_emp_message';
exports.SHOW_EMP_MESSAGE = SHOW_EMP_MESSAGE;
var ON_TOGGLE_EMP_DRAWER = 'toggle_emp_drawer';
exports.ON_TOGGLE_EMP_DRAWER = ON_TOGGLE_EMP_DRAWER;
var HANDLE_EMP_REQUEST_CLOSE = 'handle_emp_request_close';
exports.HANDLE_EMP_REQUEST_CLOSE = HANDLE_EMP_REQUEST_CLOSE;
var ON_FILTER_EMP_OPTION_SELECT = 'on_filter_emp_option_select';
exports.ON_FILTER_EMP_OPTION_SELECT = ON_FILTER_EMP_OPTION_SELECT;
var HIDE_EMP_LOADER = 'hide_emp_loader';
exports.HIDE_EMP_LOADER = HIDE_EMP_LOADER;
var SHOW_EMP_DASHBOARD_LOADER = 'show_emp_dashboard_loader';
exports.SHOW_EMP_DASHBOARD_LOADER = SHOW_EMP_DASHBOARD_LOADER;
var HIDE_EMP_DASHBOARD_LOADER = 'hide_emp_dashboard_loader';
exports.HIDE_EMP_DASHBOARD_LOADER = HIDE_EMP_DASHBOARD_LOADER;
var SHOW_EMP_LOADER = 'show_emp_loader';
exports.SHOW_EMP_LOADER = SHOW_EMP_LOADER;
var ADD_FAVOURITE_EMP = 'add_favourite_emp';
exports.ADD_FAVOURITE_EMP = ADD_FAVOURITE_EMP;
var ADD_FAVOURITE_EMP_SUCCESS = 'add_favourite_emp_success';
exports.ADD_FAVOURITE_EMP_SUCCESS = ADD_FAVOURITE_EMP_SUCCESS;
var FETCH_ALL_EMP = 'fetch_all_emp';
exports.FETCH_ALL_EMP = FETCH_ALL_EMP;
var FETCH_ALL_EMP_SUCCESS = 'fetch_all_emp_success';
exports.FETCH_ALL_EMP_SUCCESS = FETCH_ALL_EMP_SUCCESS;
var ON_EMP_SELECT = 'on_emp_select';
exports.ON_EMP_SELECT = ON_EMP_SELECT;
var ON_ADD_EMP = 'on_add_emp';
exports.ON_ADD_EMP = ON_ADD_EMP;
var ON_EMP_CLOSE = 'on_emp_close';
exports.ON_EMP_CLOSE = ON_EMP_CLOSE;
var ON_SAVE_EMP = 'on_save_emp';
exports.ON_SAVE_EMP = ON_SAVE_EMP;
var ON_SAVE_EMP_SUCCESS = 'on_save_emp_success';
exports.ON_SAVE_EMP_SUCCESS = ON_SAVE_EMP_SUCCESS;
var ON_DELETE_EMP = 'on_delete_emp';
exports.ON_DELETE_EMP = ON_DELETE_EMP;
var ON_DELETE_SELECTED_EMP = 'on_delete_selected_emp';
exports.ON_DELETE_SELECTED_EMP = ON_DELETE_SELECTED_EMP;
var FILTER_EMP = 'filter_emp';
exports.FILTER_EMP = FILTER_EMP;
var GET_ALL_EMP = 'get_all_emp';
exports.GET_ALL_EMP = GET_ALL_EMP;
var GET_UNSELECTED_ALL_EMP = 'get_unselected_all_emp';
exports.GET_UNSELECTED_ALL_EMP = GET_UNSELECTED_ALL_EMP;
var ON_ALL_EMP_SELECT = 'on_all_emp_select';
exports.ON_ALL_EMP_SELECT = ON_ALL_EMP_SELECT;
var UPDATE_SEARCH_EMP = 'update_search_emp';
exports.UPDATE_SEARCH_EMP = UPDATE_SEARCH_EMP;
var FETCH_EMP_SURVEY_ANSWERS = 'fetch_emp_survey_answers';
exports.FETCH_EMP_SURVEY_ANSWERS = FETCH_EMP_SURVEY_ANSWERS;
var FETCH_EMP_SURVEY_ANSWERS_SUCCESS = 'fetch_emp_survey_answers_success';
exports.FETCH_EMP_SURVEY_ANSWERS_SUCCESS = FETCH_EMP_SURVEY_ANSWERS_SUCCESS;
var SAVE_EMP_SURVEY_ANSWERS = 'save_emp_survey_answers';
exports.SAVE_EMP_SURVEY_ANSWERS = SAVE_EMP_SURVEY_ANSWERS;
var SAVE_EMP_SURVEY_ANSWERS_SUCCESS = 'save_emp_survey_answers_success';
exports.SAVE_EMP_SURVEY_ANSWERS_SUCCESS = SAVE_EMP_SURVEY_ANSWERS_SUCCESS;
var FETCH_NOTIFICATIONS = 'fetch_notifications';
exports.FETCH_NOTIFICATIONS = FETCH_NOTIFICATIONS;
var FETCH_NOTIFICATIONS_SUCCESS = 'fetch_notifications_success'; // org surveys

exports.FETCH_NOTIFICATIONS_SUCCESS = FETCH_NOTIFICATIONS_SUCCESS;
var SHOW_ORG_SURVEY_MESSAGE = 'show_org_survey_message';
exports.SHOW_ORG_SURVEY_MESSAGE = SHOW_ORG_SURVEY_MESSAGE;
var ON_TOGGLE_ORG_SURVEY_DRAWER = 'toggle_org_survey_drawer';
exports.ON_TOGGLE_ORG_SURVEY_DRAWER = ON_TOGGLE_ORG_SURVEY_DRAWER;
var HANDLE_ORG_SURVEY_REQUEST_CLOSE = 'handle_org_survey_request_close';
exports.HANDLE_ORG_SURVEY_REQUEST_CLOSE = HANDLE_ORG_SURVEY_REQUEST_CLOSE;
var ON_FILTER_ORG_SURVEY_OPTION_SELECT = 'on_filter_org_survey_option_select';
exports.ON_FILTER_ORG_SURVEY_OPTION_SELECT = ON_FILTER_ORG_SURVEY_OPTION_SELECT;
var HIDE_ORG_SURVEY_LOADER = 'hide_org_survey_loader';
exports.HIDE_ORG_SURVEY_LOADER = HIDE_ORG_SURVEY_LOADER;
var SHOW_ORG_SURVEY_LOADER = 'show_org_survey_loader';
exports.SHOW_ORG_SURVEY_LOADER = SHOW_ORG_SURVEY_LOADER;
var ADD_FAVOURITE_ORG_SURVEY = 'add_favourite_org_survey';
exports.ADD_FAVOURITE_ORG_SURVEY = ADD_FAVOURITE_ORG_SURVEY;
var FETCH_ALL_ORG_SURVEY = 'fetch_all_org_survey';
exports.FETCH_ALL_ORG_SURVEY = FETCH_ALL_ORG_SURVEY;
var FETCH_ALL_ORG_SURVEY_SUCCESS = 'fetch_all_org_survey_success';
exports.FETCH_ALL_ORG_SURVEY_SUCCESS = FETCH_ALL_ORG_SURVEY_SUCCESS;
var ON_ORG_SURVEY_SELECT = 'on_org_survey_select';
exports.ON_ORG_SURVEY_SELECT = ON_ORG_SURVEY_SELECT;
var ON_ADD_ORG_SURVEY = 'on_add_org_survey';
exports.ON_ADD_ORG_SURVEY = ON_ADD_ORG_SURVEY;
var ON_ORG_SURVEY_CLOSE = 'on_org_survey_close';
exports.ON_ORG_SURVEY_CLOSE = ON_ORG_SURVEY_CLOSE;
var ON_SAVE_ORG_SURVEY = 'on_save_org_survey';
exports.ON_SAVE_ORG_SURVEY = ON_SAVE_ORG_SURVEY;
var ON_SAVE_ORG_SURVEY_SUCCESS = 'on_save_org_survey_success';
exports.ON_SAVE_ORG_SURVEY_SUCCESS = ON_SAVE_ORG_SURVEY_SUCCESS;
var ON_DELETE_ORG_SURVEY = 'on_delete_org_survey';
exports.ON_DELETE_ORG_SURVEY = ON_DELETE_ORG_SURVEY;
var ON_DELETE_SELECTED_ORG_SURVEY = 'on_delete_selected_org_survey';
exports.ON_DELETE_SELECTED_ORG_SURVEY = ON_DELETE_SELECTED_ORG_SURVEY;
var FILTER_ORG_SURVEY = 'filter_org_survey';
exports.FILTER_ORG_SURVEY = FILTER_ORG_SURVEY;
var GET_ALL_ORG_SURVEY = 'get_all_org_survey';
exports.GET_ALL_ORG_SURVEY = GET_ALL_ORG_SURVEY;
var GET_UNSELECTED_ALL_ORG_SURVEY = 'get_unselected_all_org_survey';
exports.GET_UNSELECTED_ALL_ORG_SURVEY = GET_UNSELECTED_ALL_ORG_SURVEY;
var ON_ALL_ORG_SURVEY_SELECT = 'on_all_org_survey_select';
exports.ON_ALL_ORG_SURVEY_SELECT = ON_ALL_ORG_SURVEY_SELECT;
var UPDATE_SEARCH_ORG_SURVEY = 'update_search_org_survey';
exports.UPDATE_SEARCH_ORG_SURVEY = UPDATE_SEARCH_ORG_SURVEY;
var ON_ORG_SURVEY_QUESTIONS = 'on_org_survey_questions';
exports.ON_ORG_SURVEY_QUESTIONS = ON_ORG_SURVEY_QUESTIONS;
var ON_ORG_SURVEY_COMPARE_DASHBOARD = 'on_org_survey_compare_dashbaord';
exports.ON_ORG_SURVEY_COMPARE_DASHBOARD = ON_ORG_SURVEY_COMPARE_DASHBOARD;
var ON_ORG_SURVEY_COMPARE_SELECT = 'on_org_survey_compare_select';
exports.ON_ORG_SURVEY_COMPARE_SELECT = ON_ORG_SURVEY_COMPARE_SELECT;
var FETCH_ALL_ORG_SURVEY_COMPARE = 'fetch_all_org_survey_compare';
exports.FETCH_ALL_ORG_SURVEY_COMPARE = FETCH_ALL_ORG_SURVEY_COMPARE;
var FETCH_ALL_ORG_SURVEY_COMPARE_SUCCESS = 'fetch_all_org_survey_compare_success';
exports.FETCH_ALL_ORG_SURVEY_COMPARE_SUCCESS = FETCH_ALL_ORG_SURVEY_COMPARE_SUCCESS;
var FETCH_ALL_ORG_SURVEY_COMPARE_RADAR_CHART_DATA = 'fetch_all_org_survey_compare_radar_chart_data';
exports.FETCH_ALL_ORG_SURVEY_COMPARE_RADAR_CHART_DATA = FETCH_ALL_ORG_SURVEY_COMPARE_RADAR_CHART_DATA;
var FETCH_ALL_ORG_SURVEY_COMPARE_RADAR_CHART_DATA_SUCCESS = 'fetch_all_org_survey_compare_radar_chart_data_success';
exports.FETCH_ALL_ORG_SURVEY_COMPARE_RADAR_CHART_DATA_SUCCESS = FETCH_ALL_ORG_SURVEY_COMPARE_RADAR_CHART_DATA_SUCCESS;
var FETCH_ALL_ORG_SURVEY_COMPARE_DISTRIBUTIONS_CHART_DATA = 'fetch_all_org_survey_compare_distributions_chart_data';
exports.FETCH_ALL_ORG_SURVEY_COMPARE_DISTRIBUTIONS_CHART_DATA = FETCH_ALL_ORG_SURVEY_COMPARE_DISTRIBUTIONS_CHART_DATA;
var FETCH_ALL_ORG_SURVEY_COMPARE_DISTRIBUTIONS_CHART_DATA_SUCCESS = 'fetch_all_org_survey_compare_distributions_chart_data_success';
exports.FETCH_ALL_ORG_SURVEY_COMPARE_DISTRIBUTIONS_CHART_DATA_SUCCESS = FETCH_ALL_ORG_SURVEY_COMPARE_DISTRIBUTIONS_CHART_DATA_SUCCESS;
var FETCH_ALL_ORG_SURVEY_COMPARE_TOP_RESULTS_CHART_DATA = 'fetch_all_org_survey_compare_top_results_chart_data';
exports.FETCH_ALL_ORG_SURVEY_COMPARE_TOP_RESULTS_CHART_DATA = FETCH_ALL_ORG_SURVEY_COMPARE_TOP_RESULTS_CHART_DATA;
var FETCH_ALL_ORG_SURVEY_COMPARE_TOP_RESULTS_CHART_DATA_SUCCESS = 'fetch_all_org_survey_compare_top_results_chart_data_success';
exports.FETCH_ALL_ORG_SURVEY_COMPARE_TOP_RESULTS_CHART_DATA_SUCCESS = FETCH_ALL_ORG_SURVEY_COMPARE_TOP_RESULTS_CHART_DATA_SUCCESS;
var FETCH_ALL_ORG_SURVEY_COMPARE_BOTTOM_RESULTS_CHART_DATA = 'fetch_all_org_survey_compare_bottom_results_chart_data';
exports.FETCH_ALL_ORG_SURVEY_COMPARE_BOTTOM_RESULTS_CHART_DATA = FETCH_ALL_ORG_SURVEY_COMPARE_BOTTOM_RESULTS_CHART_DATA;
var FETCH_ALL_ORG_SURVEY_COMPARE_BOTTOM_RESULTS_CHART_DATA_SUCCESS = 'fetch_all_org_survey_compare_bottom_results_chart_data_success';
exports.FETCH_ALL_ORG_SURVEY_COMPARE_BOTTOM_RESULTS_CHART_DATA_SUCCESS = FETCH_ALL_ORG_SURVEY_COMPARE_BOTTOM_RESULTS_CHART_DATA_SUCCESS;
var FETCH_ALL_ORG_SURVEY_ENGAGEMENT_REPORT_CHART_DATA = 'fetch_all_org_survey_engagement_report_chart_data';
exports.FETCH_ALL_ORG_SURVEY_ENGAGEMENT_REPORT_CHART_DATA = FETCH_ALL_ORG_SURVEY_ENGAGEMENT_REPORT_CHART_DATA;
var FETCH_ALL_ORG_SURVEY_ENGAGEMENT_REPORT_CHART_DATA_SUCCESS = 'fetch_all_org_survey_engagement_report_chart_data_success'; // org survey answers

exports.FETCH_ALL_ORG_SURVEY_ENGAGEMENT_REPORT_CHART_DATA_SUCCESS = FETCH_ALL_ORG_SURVEY_ENGAGEMENT_REPORT_CHART_DATA_SUCCESS;
var ON_SAVE_ORG_SURVEY_ANSWERS = 'on_save_org_survey_answers';
exports.ON_SAVE_ORG_SURVEY_ANSWERS = ON_SAVE_ORG_SURVEY_ANSWERS;
var ON_SAVE_ORG_SURVEY_ANSWERS_SUCCESS = 'on_save_org_survey_answers_success';
exports.ON_SAVE_ORG_SURVEY_ANSWERS_SUCCESS = ON_SAVE_ORG_SURVEY_ANSWERS_SUCCESS;
var FETCH_ORG_SURVEY_ANSWERS = 'fetch_org_survey_answers';
exports.FETCH_ORG_SURVEY_ANSWERS = FETCH_ORG_SURVEY_ANSWERS;
var FETCH_ORG_SURVEY_ANSWERS_SUCCESS = 'fetch_org_survey_answers_success';
exports.FETCH_ORG_SURVEY_ANSWERS_SUCCESS = FETCH_ORG_SURVEY_ANSWERS_SUCCESS;
var HIDE_ORG_SURVEY_ANSWERS_LOADER = 'hide_org_survey_answers_loader';
exports.HIDE_ORG_SURVEY_ANSWERS_LOADER = HIDE_ORG_SURVEY_ANSWERS_LOADER;
var SHOW_ORG_SURVEY_ANSWERS_LOADER = 'show_org_survey_answers_loader';
exports.SHOW_ORG_SURVEY_ANSWERS_LOADER = SHOW_ORG_SURVEY_ANSWERS_LOADER;
var SHOW_ORG_SURVEY_ANSWERS_MESSAGE = 'show_org_survey_answers_message';
exports.SHOW_ORG_SURVEY_ANSWERS_MESSAGE = SHOW_ORG_SURVEY_ANSWERS_MESSAGE;
var HANDLE_ORG_SURVEY_ANSWER_MESSAGE_CLOSE = 'handle_org_survey_answer_message_close'; // surveys

exports.HANDLE_ORG_SURVEY_ANSWER_MESSAGE_CLOSE = HANDLE_ORG_SURVEY_ANSWER_MESSAGE_CLOSE;
var SHOW_SURVEY_MESSAGE = 'show_survey_message';
exports.SHOW_SURVEY_MESSAGE = SHOW_SURVEY_MESSAGE;
var ON_TOGGLE_SURVEY_DRAWER = 'toggle_survey_drawer';
exports.ON_TOGGLE_SURVEY_DRAWER = ON_TOGGLE_SURVEY_DRAWER;
var HANDLE_SURVEY_REQUEST_CLOSE = 'handle_survey_request_close';
exports.HANDLE_SURVEY_REQUEST_CLOSE = HANDLE_SURVEY_REQUEST_CLOSE;
var ON_FILTER_SURVEY_OPTION_SELECT = 'on_filter_survey_option_select';
exports.ON_FILTER_SURVEY_OPTION_SELECT = ON_FILTER_SURVEY_OPTION_SELECT;
var HIDE_SURVEY_LOADER = 'hide_survey_loader';
exports.HIDE_SURVEY_LOADER = HIDE_SURVEY_LOADER;
var SHOW_SURVEY_LOADER = 'show_survey_loader';
exports.SHOW_SURVEY_LOADER = SHOW_SURVEY_LOADER;
var ADD_FAVOURITE_SURVEY = 'add_favourite_survey';
exports.ADD_FAVOURITE_SURVEY = ADD_FAVOURITE_SURVEY;
var FETCH_ALL_SURVEY = 'fetch_all_survey';
exports.FETCH_ALL_SURVEY = FETCH_ALL_SURVEY;
var FETCH_ALL_SURVEY_SUCCESS = 'fetch_all_survey_success';
exports.FETCH_ALL_SURVEY_SUCCESS = FETCH_ALL_SURVEY_SUCCESS;
var ON_SURVEY_SELECT = 'on_survey_select';
exports.ON_SURVEY_SELECT = ON_SURVEY_SELECT;
var ON_ADD_SURVEY = 'on_add_survey';
exports.ON_ADD_SURVEY = ON_ADD_SURVEY;
var ON_SURVEY_CLOSE = 'on_survey_close';
exports.ON_SURVEY_CLOSE = ON_SURVEY_CLOSE;
var ON_SAVE_SURVEY = 'on_save_survey';
exports.ON_SAVE_SURVEY = ON_SAVE_SURVEY;
var ON_SAVE_SURVEY_SUCCESS = 'on_save_survey_success';
exports.ON_SAVE_SURVEY_SUCCESS = ON_SAVE_SURVEY_SUCCESS;
var ON_DELETE_SURVEY = 'on_delete_survey';
exports.ON_DELETE_SURVEY = ON_DELETE_SURVEY;
var ON_DELETE_SELECTED_SURVEY = 'on_delete_selected_survey';
exports.ON_DELETE_SELECTED_SURVEY = ON_DELETE_SELECTED_SURVEY;
var FILTER_SURVEY = 'filter_survey';
exports.FILTER_SURVEY = FILTER_SURVEY;
var GET_ALL_SURVEY = 'get_all_survey';
exports.GET_ALL_SURVEY = GET_ALL_SURVEY;
var GET_UNSELECTED_ALL_SURVEY = 'get_unselected_all_survey';
exports.GET_UNSELECTED_ALL_SURVEY = GET_UNSELECTED_ALL_SURVEY;
var ON_ALL_SURVEY_SELECT = 'on_all_survey_select';
exports.ON_ALL_SURVEY_SELECT = ON_ALL_SURVEY_SELECT;
var UPDATE_SEARCH_SURVEY = 'update_search_survey';
exports.UPDATE_SEARCH_SURVEY = UPDATE_SEARCH_SURVEY;
var ON_SURVEY_QUESTIONS = 'on_survey_questions'; // survey groups

exports.ON_SURVEY_QUESTIONS = ON_SURVEY_QUESTIONS;
var SHOW_SURVEY_GROUP_MESSAGE = 'show_survey_group_message';
exports.SHOW_SURVEY_GROUP_MESSAGE = SHOW_SURVEY_GROUP_MESSAGE;
var ON_TOGGLE_SURVEY_GROUP_DRAWER = 'toggle_survey_group_drawer';
exports.ON_TOGGLE_SURVEY_GROUP_DRAWER = ON_TOGGLE_SURVEY_GROUP_DRAWER;
var HANDLE_SURVEY_GROUP_REQUEST_CLOSE = 'handle_survey_group_request_close';
exports.HANDLE_SURVEY_GROUP_REQUEST_CLOSE = HANDLE_SURVEY_GROUP_REQUEST_CLOSE;
var ON_FILTER_SURVEY_GROUP_OPTION_SELECT = 'on_filter_survey_group_option_select';
exports.ON_FILTER_SURVEY_GROUP_OPTION_SELECT = ON_FILTER_SURVEY_GROUP_OPTION_SELECT;
var HIDE_SURVEY_GROUP_LOADER = 'hide_survey_group_loader';
exports.HIDE_SURVEY_GROUP_LOADER = HIDE_SURVEY_GROUP_LOADER;
var SHOW_SURVEY_GROUP_LOADER = 'show_survey_group_loader';
exports.SHOW_SURVEY_GROUP_LOADER = SHOW_SURVEY_GROUP_LOADER;
var ADD_FAVOURITE_SURVEY_GROUP = 'add_favourite_survey_group';
exports.ADD_FAVOURITE_SURVEY_GROUP = ADD_FAVOURITE_SURVEY_GROUP;
var FETCH_ALL_SURVEY_GROUP = 'fetch_all_survey_group';
exports.FETCH_ALL_SURVEY_GROUP = FETCH_ALL_SURVEY_GROUP;
var FETCH_ALL_SURVEY_GROUP_SUCCESS = 'fetch_all_survey_group_success';
exports.FETCH_ALL_SURVEY_GROUP_SUCCESS = FETCH_ALL_SURVEY_GROUP_SUCCESS;
var ON_SURVEY_GROUP_SELECT = 'on_survey_group_select';
exports.ON_SURVEY_GROUP_SELECT = ON_SURVEY_GROUP_SELECT;
var ON_ADD_SURVEY_GROUP = 'on_add_survey_group';
exports.ON_ADD_SURVEY_GROUP = ON_ADD_SURVEY_GROUP;
var ON_SURVEY_GROUP_CLOSE = 'on_survey_group_close';
exports.ON_SURVEY_GROUP_CLOSE = ON_SURVEY_GROUP_CLOSE;
var ON_SAVE_SURVEY_GROUP = 'on_save_survey_group';
exports.ON_SAVE_SURVEY_GROUP = ON_SAVE_SURVEY_GROUP;
var ON_SAVE_SURVEY_GROUP_SUCCESS = 'on_save_survey_group_success';
exports.ON_SAVE_SURVEY_GROUP_SUCCESS = ON_SAVE_SURVEY_GROUP_SUCCESS;
var ON_DELETE_SURVEY_GROUP = 'on_delete_survey_group';
exports.ON_DELETE_SURVEY_GROUP = ON_DELETE_SURVEY_GROUP;
var ON_DELETE_SELECTED_SURVEY_GROUP = 'on_delete_selected_survey_group';
exports.ON_DELETE_SELECTED_SURVEY_GROUP = ON_DELETE_SELECTED_SURVEY_GROUP;
var FILTER_SURVEY_GROUP = 'filter_survey_group';
exports.FILTER_SURVEY_GROUP = FILTER_SURVEY_GROUP;
var GET_ALL_SURVEY_GROUP = 'get_all_survey_group';
exports.GET_ALL_SURVEY_GROUP = GET_ALL_SURVEY_GROUP;
var GET_UNSELECTED_ALL_SURVEY_GROUP = 'get_unselected_all_survey_group';
exports.GET_UNSELECTED_ALL_SURVEY_GROUP = GET_UNSELECTED_ALL_SURVEY_GROUP;
var ON_ALL_SURVEY_GROUP_SELECT = 'on_all_survey_group_select';
exports.ON_ALL_SURVEY_GROUP_SELECT = ON_ALL_SURVEY_GROUP_SELECT;
var UPDATE_SEARCH_SURVEY_GROUP = 'update_search_survey_group';
exports.UPDATE_SEARCH_SURVEY_GROUP = UPDATE_SEARCH_SURVEY_GROUP;
var ON_SURVEY_GROUP_QUESTIONS = 'on_survey_group_questions'; // survey questions

exports.ON_SURVEY_GROUP_QUESTIONS = ON_SURVEY_GROUP_QUESTIONS;
var SHOW_SURVEY_QUESTION_MESSAGE = 'show_survey_question_message';
exports.SHOW_SURVEY_QUESTION_MESSAGE = SHOW_SURVEY_QUESTION_MESSAGE;
var FETCH_ALL_SURVEY_QUESTION_SUCCESS = 'fetch_all_survey_question_success';
exports.FETCH_ALL_SURVEY_QUESTION_SUCCESS = FETCH_ALL_SURVEY_QUESTION_SUCCESS;
var FETCH_ALL_SURVEY_QUESTION = 'fetch_all_survey_question';
exports.FETCH_ALL_SURVEY_QUESTION = FETCH_ALL_SURVEY_QUESTION;
var HIDE_SURVEY_QUESTION_LOADER = 'hide_survey_question_loader';
exports.HIDE_SURVEY_QUESTION_LOADER = HIDE_SURVEY_QUESTION_LOADER;
var SHOW_SURVEY_QUESTION_LOADER = 'show_survey_question_loader'; // survey group QUESTIONS

exports.SHOW_SURVEY_QUESTION_LOADER = SHOW_SURVEY_QUESTION_LOADER;
var SHOW_SURVEY_GROUP_QUESTION_MESSAGE = 'show_survey_group_question_message';
exports.SHOW_SURVEY_GROUP_QUESTION_MESSAGE = SHOW_SURVEY_GROUP_QUESTION_MESSAGE;
var ON_TOGGLE_SURVEY_GROUP_QUESTION_DRAWER = 'toggle_survey_group_question_drawer';
exports.ON_TOGGLE_SURVEY_GROUP_QUESTION_DRAWER = ON_TOGGLE_SURVEY_GROUP_QUESTION_DRAWER;
var HANDLE_SURVEY_GROUP_QUESTION_REQUEST_CLOSE = 'handle_survey_group_question_request_close';
exports.HANDLE_SURVEY_GROUP_QUESTION_REQUEST_CLOSE = HANDLE_SURVEY_GROUP_QUESTION_REQUEST_CLOSE;
var ON_FILTER_SURVEY_GROUP_QUESTION_OPTION_SELECT = 'on_filter_survey_group_question_option_select';
exports.ON_FILTER_SURVEY_GROUP_QUESTION_OPTION_SELECT = ON_FILTER_SURVEY_GROUP_QUESTION_OPTION_SELECT;
var HIDE_SURVEY_GROUP_QUESTION_LOADER = 'hide_survey_group_question_loader';
exports.HIDE_SURVEY_GROUP_QUESTION_LOADER = HIDE_SURVEY_GROUP_QUESTION_LOADER;
var SHOW_SURVEY_GROUP_QUESTION_LOADER = 'show_survey_group_question_loader';
exports.SHOW_SURVEY_GROUP_QUESTION_LOADER = SHOW_SURVEY_GROUP_QUESTION_LOADER;
var ADD_FAVOURITE_SURVEY_GROUP_QUESTION = 'add_favourite_survey_group';
exports.ADD_FAVOURITE_SURVEY_GROUP_QUESTION = ADD_FAVOURITE_SURVEY_GROUP_QUESTION;
var FETCH_ALL_SURVEY_GROUP_QUESTION = 'fetch_all_survey_group';
exports.FETCH_ALL_SURVEY_GROUP_QUESTION = FETCH_ALL_SURVEY_GROUP_QUESTION;
var FETCH_ALL_SURVEY_GROUP_QUESTION_SUCCESS = 'fetch_all_survey_group_question_success';
exports.FETCH_ALL_SURVEY_GROUP_QUESTION_SUCCESS = FETCH_ALL_SURVEY_GROUP_QUESTION_SUCCESS;
var ON_SURVEY_GROUP_QUESTION_SELECT = 'on_survey_group_question_select';
exports.ON_SURVEY_GROUP_QUESTION_SELECT = ON_SURVEY_GROUP_QUESTION_SELECT;
var ON_ADD_SURVEY_GROUP_QUESTION = 'on_add_survey_group_question';
exports.ON_ADD_SURVEY_GROUP_QUESTION = ON_ADD_SURVEY_GROUP_QUESTION;
var ON_SURVEY_GROUP_QUESTION_CLOSE = 'on_survey_group_question_close';
exports.ON_SURVEY_GROUP_QUESTION_CLOSE = ON_SURVEY_GROUP_QUESTION_CLOSE;
var ON_SAVE_SURVEY_GROUP_QUESTION = 'on_save_survey_group_question';
exports.ON_SAVE_SURVEY_GROUP_QUESTION = ON_SAVE_SURVEY_GROUP_QUESTION;
var ON_DELETE_SURVEY_GROUP_QUESTION = 'on_delete_survey_group';
exports.ON_DELETE_SURVEY_GROUP_QUESTION = ON_DELETE_SURVEY_GROUP_QUESTION;
var ON_DELETE_SELECTED_SURVEY_GROUP_QUESTION = 'on_delete_selected_survey_group';
exports.ON_DELETE_SELECTED_SURVEY_GROUP_QUESTION = ON_DELETE_SELECTED_SURVEY_GROUP_QUESTION;
var FILTER_SURVEY_GROUP_QUESTION = 'filter_survey_group';
exports.FILTER_SURVEY_GROUP_QUESTION = FILTER_SURVEY_GROUP_QUESTION;
var GET_ALL_SURVEY_GROUP_QUESTION = 'get_all_survey_group';
exports.GET_ALL_SURVEY_GROUP_QUESTION = GET_ALL_SURVEY_GROUP_QUESTION;
var GET_UNSELECTED_ALL_SURVEY_GROUP_QUESTION = 'get_unselected_all_survey_group';
exports.GET_UNSELECTED_ALL_SURVEY_GROUP_QUESTION = GET_UNSELECTED_ALL_SURVEY_GROUP_QUESTION;
var ON_ALL_SURVEY_GROUP_QUESTION_SELECT = 'on_all_survey_group_question_select';
exports.ON_ALL_SURVEY_GROUP_QUESTION_SELECT = ON_ALL_SURVEY_GROUP_QUESTION_SELECT;
var UPDATE_SEARCH_SURVEY_GROUP_QUESTION = 'update_search_survey_group'; // security

exports.UPDATE_SEARCH_SURVEY_GROUP_QUESTION = UPDATE_SEARCH_SURVEY_GROUP_QUESTION;
var ADD_FAVOURITE_SECURITY = 'add_favourite_security';
exports.ADD_FAVOURITE_SECURITY = ADD_FAVOURITE_SECURITY;
var ADD_FAVOURITE_SECURITY_SUCCESS = 'add_favourite_security_success';
exports.ADD_FAVOURITE_SECURITY_SUCCESS = ADD_FAVOURITE_SECURITY_SUCCESS;
var FETCH_SECURITY = 'fetch_security';
exports.FETCH_SECURITY = FETCH_SECURITY;
var FETCH_SECURITY_SUCCESS = 'fetch_security_success';
exports.FETCH_SECURITY_SUCCESS = FETCH_SECURITY_SUCCESS;
var FETCH_ALL_SECURITY = 'fetch_all_security';
exports.FETCH_ALL_SECURITY = FETCH_ALL_SECURITY;
var FETCH_ALL_SECURITY_SUCCESS = 'fetch_all_security_success';
exports.FETCH_ALL_SECURITY_SUCCESS = FETCH_ALL_SECURITY_SUCCESS;
var FILTER_SECURITY = 'filter_security';
exports.FILTER_SECURITY = FILTER_SECURITY;
var GET_ALL_SECURITY = 'get_all_security';
exports.GET_ALL_SECURITY = GET_ALL_SECURITY;
var GET_UNSELECTED_ALL_SECURITY = 'get_unselected_all_security';
exports.GET_UNSELECTED_ALL_SECURITY = GET_UNSELECTED_ALL_SECURITY;
var HANDLE_SECURITY_REQUEST_CLOSE = 'handle_security_request_close';
exports.HANDLE_SECURITY_REQUEST_CLOSE = HANDLE_SECURITY_REQUEST_CLOSE;
var HIDE_SECURITY_LOADER = 'hide_security_loader';
exports.HIDE_SECURITY_LOADER = HIDE_SECURITY_LOADER;
var SHOW_SECURITY_LOADER = 'show_security_loader';
exports.SHOW_SECURITY_LOADER = SHOW_SECURITY_LOADER;
var ON_ADD_SECURITY = 'on_add_security';
exports.ON_ADD_SECURITY = ON_ADD_SECURITY;
var ON_ALL_SECURITY_SELECT = 'on_all_security_select';
exports.ON_ALL_SECURITY_SELECT = ON_ALL_SECURITY_SELECT;
var ON_SECURITY_CLOSE = 'on_security_close';
exports.ON_SECURITY_CLOSE = ON_SECURITY_CLOSE;
var ON_SECURITY_SELECT = 'on_security_select';
exports.ON_SECURITY_SELECT = ON_SECURITY_SELECT;
var ON_DELETE_SECURITY = 'on_delete_security';
exports.ON_DELETE_SECURITY = ON_DELETE_SECURITY;
var ON_DELETE_SECURITY_SUCCESS = 'on_delete_security_success';
exports.ON_DELETE_SECURITY_SUCCESS = ON_DELETE_SECURITY_SUCCESS;
var ON_FILTER_SELECTED_SECURITY = 'on_filter_selected_security';
exports.ON_FILTER_SELECTED_SECURITY = ON_FILTER_SELECTED_SECURITY;
var ON_FILTER_SECURITY_OPTION_SELECT = 'on_filter_security_option_select';
exports.ON_FILTER_SECURITY_OPTION_SELECT = ON_FILTER_SECURITY_OPTION_SELECT;
var ON_SAVE_SECURITY = 'on_save_security';
exports.ON_SAVE_SECURITY = ON_SAVE_SECURITY;
var ON_SAVE_SECURITY_SUCCESS = 'on_save_security_success';
exports.ON_SAVE_SECURITY_SUCCESS = ON_SAVE_SECURITY_SUCCESS;
var ON_TOGGLE_SECURITY_DRAWER = 'on_toggle_security_drawer';
exports.ON_TOGGLE_SECURITY_DRAWER = ON_TOGGLE_SECURITY_DRAWER;
var SHOW_SECURITY_MESSAGE = 'show_security_message';
exports.SHOW_SECURITY_MESSAGE = SHOW_SECURITY_MESSAGE;
var UPDATE_SEARCH_SECURITY = 'update_search_security';
exports.UPDATE_SEARCH_SECURITY = UPDATE_SEARCH_SECURITY;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_PROJECT_COST_PRIORITY, "ADD_FAVOURITE_PROJECT_COST_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_PROJECT_COST_PRIORITY_SUCCESS, "ADD_FAVOURITE_PROJECT_COST_PRIORITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_PROJECT_COST_PRIORITY, "FETCH_PROJECT_COST_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_PROJECT_COST_PRIORITY_SUCCESS, "FETCH_PROJECT_COST_PRIORITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_PROJECT_COST_PRIORITY, "FETCH_ALL_PROJECT_COST_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_PROJECT_COST_PRIORITY_SUCCESS, "FETCH_ALL_PROJECT_COST_PRIORITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_PROJECT_COST_PRIORITY, "FILTER_PROJECT_COST_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_PROJECT_COST_PRIORITY, "GET_ALL_PROJECT_COST_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_PROJECT_COST_PRIORITY, "GET_UNSELECTED_ALL_PROJECT_COST_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_PROJECT_COST_PRIORITY_REQUEST_CLOSE, "HANDLE_PROJECT_COST_PRIORITY_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_PROJECT_COST_PRIORITY_LOADER, "HIDE_PROJECT_COST_PRIORITY_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_PROJECT_COST_PRIORITY_LOADER, "SHOW_PROJECT_COST_PRIORITY_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_PROJECT_COST_PRIORITY, "ON_ADD_PROJECT_COST_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_EDIT_PROJECT_COST_PRIORITY, "ON_EDIT_PROJECT_COST_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_PROJECT_COST_PRIORITY_SELECT, "ON_ALL_PROJECT_COST_PRIORITY_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PROJECT_COST_PRIORITY_CLOSE, "ON_PROJECT_COST_PRIORITY_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PROJECT_COST_PRIORITY_SELECT, "ON_PROJECT_COST_PRIORITY_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_PROJECT_COST_PRIORITY, "ON_DELETE_PROJECT_COST_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_PROJECT_COST_PRIORITY_SUCCESS, "ON_DELETE_PROJECT_COST_PRIORITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_SELECTED_PROJECT_COST_PRIORITY, "ON_FILTER_SELECTED_PROJECT_COST_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_PROJECT_COST_PRIORITY_OPTION_SELECT, "ON_FILTER_PROJECT_COST_PRIORITY_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_PROJECT_COST_PRIORITY, "ON_SAVE_PROJECT_COST_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_PROJECT_COST_PRIORITY_SUCCESS, "ON_SAVE_PROJECT_COST_PRIORITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_PROJECT_COST_PRIORITY_DRAWER, "ON_TOGGLE_PROJECT_COST_PRIORITY_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_PROJECT_COST_PRIORITY_MESSAGE, "SHOW_PROJECT_COST_PRIORITY_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_PROJECT_COST_PRIORITY, "UPDATE_SEARCH_PROJECT_COST_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_PROJECT_BUS_PRIORITY, "ADD_FAVOURITE_PROJECT_BUS_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_PROJECT_BUS_PRIORITY_SUCCESS, "ADD_FAVOURITE_PROJECT_BUS_PRIORITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_PROJECT_BUS_PRIORITY, "FETCH_PROJECT_BUS_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_PROJECT_BUS_PRIORITY_SUCCESS, "FETCH_PROJECT_BUS_PRIORITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_PROJECT_BUS_PRIORITY, "FETCH_ALL_PROJECT_BUS_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_PROJECT_BUS_PRIORITY_SUCCESS, "FETCH_ALL_PROJECT_BUS_PRIORITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_PROJECT_BUS_PRIORITY, "FILTER_PROJECT_BUS_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_PROJECT_BUS_PRIORITY, "GET_ALL_PROJECT_BUS_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_PROJECT_BUS_PRIORITY, "GET_UNSELECTED_ALL_PROJECT_BUS_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_PROJECT_BUS_PRIORITY_REQUEST_CLOSE, "HANDLE_PROJECT_BUS_PRIORITY_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_PROJECT_BUS_PRIORITY_LOADER, "HIDE_PROJECT_BUS_PRIORITY_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_PROJECT_BUS_PRIORITY_LOADER, "SHOW_PROJECT_BUS_PRIORITY_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_PROJECT_BUS_PRIORITY, "ON_ADD_PROJECT_BUS_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_EDIT_PROJECT_BUS_PRIORITY, "ON_EDIT_PROJECT_BUS_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_PROJECT_BUS_PRIORITY_SELECT, "ON_ALL_PROJECT_BUS_PRIORITY_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PROJECT_BUS_PRIORITY_CLOSE, "ON_PROJECT_BUS_PRIORITY_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PROJECT_BUS_PRIORITY_SELECT, "ON_PROJECT_BUS_PRIORITY_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_PROJECT_BUS_PRIORITY, "ON_DELETE_PROJECT_BUS_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_PROJECT_BUS_PRIORITY_SUCCESS, "ON_DELETE_PROJECT_BUS_PRIORITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_SELECTED_PROJECT_BUS_PRIORITY, "ON_FILTER_SELECTED_PROJECT_BUS_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_PROJECT_BUS_PRIORITY_OPTION_SELECT, "ON_FILTER_PROJECT_BUS_PRIORITY_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_PROJECT_BUS_PRIORITY, "ON_SAVE_PROJECT_BUS_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_PROJECT_BUS_PRIORITY_SUCCESS, "ON_SAVE_PROJECT_BUS_PRIORITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_PROJECT_BUS_PRIORITY_DRAWER, "ON_TOGGLE_PROJECT_BUS_PRIORITY_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_PROJECT_BUS_PRIORITY_MESSAGE, "SHOW_PROJECT_BUS_PRIORITY_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_PROJECT_BUS_PRIORITY, "UPDATE_SEARCH_PROJECT_BUS_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_ISSUE, "ADD_FAVOURITE_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_ISSUE_SUCCESS, "ADD_FAVOURITE_ISSUE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ISSUE, "FETCH_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ISSUE_SUCCESS, "FETCH_ISSUE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ISSUE, "FETCH_ALL_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ISSUE_SUCCESS, "FETCH_ALL_ISSUE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_ISSUE, "FILTER_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_ISSUE, "GET_ALL_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_ISSUE, "GET_UNSELECTED_ALL_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_ISSUE_REQUEST_CLOSE, "HANDLE_ISSUE_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_ISSUE_LOADER, "HIDE_ISSUE_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_ISSUE_LOADER, "SHOW_ISSUE_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_ISSUE, "ON_ADD_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_EDIT_ISSUE, "ON_EDIT_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SET_ISSUE, "SET_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_ISSUE_SELECT, "ON_ALL_ISSUE_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ISSUE_CLOSE, "ON_ISSUE_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ISSUE_SELECT, "ON_ISSUE_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_ISSUE, "ON_DELETE_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_ISSUE_SUCCESS, "ON_DELETE_ISSUE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_SELECTED_ISSUE, "ON_FILTER_SELECTED_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_ISSUE_OPTION_SELECT, "ON_FILTER_ISSUE_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_ISSUE, "ON_SAVE_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_ISSUE_SUCCESS, "ON_SAVE_ISSUE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_ISSUE_DRAWER, "ON_TOGGLE_ISSUE_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_ISSUE_MESSAGE, "SHOW_ISSUE_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_ISSUE, "UPDATE_SEARCH_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FETCH_SELECT_FEATURE_DATA, "ON_FETCH_SELECT_FEATURE_DATA", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FETCH_SELECT_FEATURE_DATA_SUCCESS, "ON_FETCH_SELECT_FEATURE_DATA_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ISSUE_FEATURE_UPDATE, "ON_ISSUE_FEATURE_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_INITIATIVE, "ADD_FAVOURITE_INITIATIVE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_INITIATIVE_SUCCESS, "ADD_FAVOURITE_INITIATIVE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_INITIATIVE, "FETCH_INITIATIVE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_INITIATIVE_SUCCESS, "FETCH_INITIATIVE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_INITIATIVE, "FETCH_ALL_INITIATIVE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_INITIATIVE_SUCCESS, "FETCH_ALL_INITIATIVE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_INITIATIVE, "FILTER_INITIATIVE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_INITIATIVE, "GET_ALL_INITIATIVE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_INITIATIVE, "GET_UNSELECTED_ALL_INITIATIVE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_INITIATIVE_REQUEST_CLOSE, "HANDLE_INITIATIVE_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_INITIATIVE_LOADER, "HIDE_INITIATIVE_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_INITIATIVE_LOADER, "SHOW_INITIATIVE_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_INITIATIVE, "ON_ADD_INITIATIVE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_EDIT_INITIATIVE, "ON_EDIT_INITIATIVE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SET_INITIATIVE, "SET_INITIATIVE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_INITIATIVE_SELECT, "ON_ALL_INITIATIVE_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_INITIATIVE_CLOSE, "ON_INITIATIVE_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_INITIATIVE_SELECT, "ON_INITIATIVE_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_INITIATIVE, "ON_DELETE_INITIATIVE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_INITIATIVE_SUCCESS, "ON_DELETE_INITIATIVE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_SELECTED_INITIATIVE, "ON_FILTER_SELECTED_INITIATIVE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_INITIATIVE_OPTION_SELECT, "ON_FILTER_INITIATIVE_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_INITIATIVE, "ON_SAVE_INITIATIVE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_INITIATIVE_SUCCESS, "ON_SAVE_INITIATIVE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_INITIATIVE_DRAWER, "ON_TOGGLE_INITIATIVE_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_INITIATIVE_MESSAGE, "SHOW_INITIATIVE_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_INITIATIVE, "UPDATE_SEARCH_INITIATIVE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FETCH_SELECT_PRODUCT_DATA, "ON_FETCH_SELECT_PRODUCT_DATA", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FETCH_SELECT_PRODUCT_DATA_SUCCESS, "ON_FETCH_SELECT_PRODUCT_DATA_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_INITIATIVE_PRODUCT_UPDATE, "ON_INITIATIVE_PRODUCT_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_PRODUCT, "ADD_FAVOURITE_PRODUCT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_PRODUCT_SUCCESS, "ADD_FAVOURITE_PRODUCT_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_PRODUCT_LOOKUP_DATA, "FETCH_PRODUCT_LOOKUP_DATA", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_PRODUCT, "FETCH_PRODUCT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_PRODUCT_SUCCESS, "FETCH_PRODUCT_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_PRODUCT, "FETCH_ALL_PRODUCT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_PRODUCT_SUCCESS, "FETCH_ALL_PRODUCT_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_PRODUCT, "FILTER_PRODUCT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_PRODUCT, "GET_ALL_PRODUCT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_PRODUCT, "GET_UNSELECTED_ALL_PRODUCT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_PRODUCT_REQUEST_CLOSE, "HANDLE_PRODUCT_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_PRODUCT_LOADER, "HIDE_PRODUCT_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_PRODUCT_LOADER, "SHOW_PRODUCT_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_PRODUCT, "ON_ADD_PRODUCT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_EDIT_PRODUCT, "ON_EDIT_PRODUCT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SET_PRODUCT, "SET_PRODUCT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_PRODUCT_SELECT, "ON_ALL_PRODUCT_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PRODUCT_CLOSE, "ON_PRODUCT_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PRODUCT_SELECT, "ON_PRODUCT_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_PRODUCT, "ON_DELETE_PRODUCT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_PRODUCT_SUCCESS, "ON_DELETE_PRODUCT_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_SELECTED_PRODUCT, "ON_FILTER_SELECTED_PRODUCT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_PRODUCT_OPTION_SELECT, "ON_FILTER_PRODUCT_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_PRODUCT, "ON_SAVE_PRODUCT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_PRODUCT_SUCCESS, "ON_SAVE_PRODUCT_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_PRODUCT_DRAWER, "ON_TOGGLE_PRODUCT_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_PRODUCT_MESSAGE, "SHOW_PRODUCT_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_PRODUCT, "UPDATE_SEARCH_PRODUCT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FETCH_SELECT_VALUESTREAM_DATA, "ON_FETCH_SELECT_VALUESTREAM_DATA", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FETCH_SELECT_VALUESTREAM_DATA_SUCCESS, "ON_FETCH_SELECT_VALUESTREAM_DATA_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PRODUCT_VALUESTREAM_UPDATE, "ON_PRODUCT_VALUESTREAM_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_TEAM, "ADD_FAVOURITE_TEAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_TEAM_SUCCESS, "ADD_FAVOURITE_TEAM_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_TEAM, "FETCH_TEAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_TEAM_SUCCESS, "FETCH_TEAM_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_TEAM, "FETCH_ALL_TEAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_TEAM_SUCCESS, "FETCH_ALL_TEAM_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_TEAM, "FILTER_TEAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_TEAM, "GET_ALL_TEAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_TEAM, "GET_UNSELECTED_ALL_TEAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_TEAM_REQUEST_CLOSE, "HANDLE_TEAM_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_TEAM_LOADER, "HIDE_TEAM_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_TEAM_LOADER, "SHOW_TEAM_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_TEAM, "ON_ADD_TEAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_EDIT_TEAM, "ON_EDIT_TEAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SET_TEAM, "SET_TEAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_TEAM_SELECT, "ON_ALL_TEAM_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TEAM_CLOSE, "ON_TEAM_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TEAM_SELECT, "ON_TEAM_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_TEAM, "ON_DELETE_TEAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_TEAM_SUCCESS, "ON_DELETE_TEAM_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_SELECTED_TEAM, "ON_FILTER_SELECTED_TEAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_TEAM_OPTION_SELECT, "ON_FILTER_TEAM_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_TEAM, "ON_SAVE_TEAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_TEAM_SUCCESS, "ON_SAVE_TEAM_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_TEAM_DRAWER, "ON_TOGGLE_TEAM_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_TEAM_MESSAGE, "SHOW_TEAM_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_TEAM, "UPDATE_SEARCH_TEAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FETCH_SELECT_MEMBER_DATA, "ON_FETCH_SELECT_MEMBER_DATA", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FETCH_SELECT_MEMBER_DATA_SUCCESS, "ON_FETCH_SELECT_MEMBER_DATA_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TEAM_MEMBER_UPDATE, "ON_TEAM_MEMBER_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_MEMBER, "ADD_FAVOURITE_MEMBER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_MEMBER_SUCCESS, "ADD_FAVOURITE_MEMBER_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_MEMBER, "FETCH_MEMBER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_MEMBER_SUCCESS, "FETCH_MEMBER_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_MEMBER, "FETCH_ALL_MEMBER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_MEMBER_SUCCESS, "FETCH_ALL_MEMBER_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_MEMBER, "FILTER_MEMBER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_MEMBER, "GET_ALL_MEMBER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_MEMBER, "GET_UNSELECTED_ALL_MEMBER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_MEMBER_REQUEST_CLOSE, "HANDLE_MEMBER_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_MEMBER_LOADER, "HIDE_MEMBER_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_MEMBER_LOADER, "SHOW_MEMBER_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_MEMBER, "ON_ADD_MEMBER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_EDIT_MEMBER, "ON_EDIT_MEMBER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_MEMBER_SELECT, "ON_ALL_MEMBER_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_MEMBER_CLOSE, "ON_MEMBER_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_MEMBER_SELECT, "ON_MEMBER_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_MEMBER, "ON_DELETE_MEMBER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_MEMBER_SUCCESS, "ON_DELETE_MEMBER_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_SELECTED_MEMBER, "ON_FILTER_SELECTED_MEMBER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_MEMBER_OPTION_SELECT, "ON_FILTER_MEMBER_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_MEMBER, "ON_SAVE_MEMBER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_MEMBER_SUCCESS, "ON_SAVE_MEMBER_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_MEMBER_DRAWER, "ON_TOGGLE_MEMBER_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_MEMBER_MESSAGE, "SHOW_MEMBER_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_MEMBER, "UPDATE_SEARCH_MEMBER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_VALUE_STREAM, "ADD_FAVOURITE_VALUE_STREAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_VALUE_STREAM_SUCCESS, "ADD_FAVOURITE_VALUE_STREAM_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_VALUE_STREAM, "FETCH_VALUE_STREAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_VALUE_STREAM_SUCCESS, "FETCH_VALUE_STREAM_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_VALUE_STREAM, "FETCH_ALL_VALUE_STREAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_VALUE_STREAM_SUCCESS, "FETCH_ALL_VALUE_STREAM_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_VALUE_STREAM, "FILTER_VALUE_STREAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_VALUE_STREAM, "GET_ALL_VALUE_STREAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_VALUE_STREAM, "GET_UNSELECTED_ALL_VALUE_STREAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_VALUE_STREAM_REQUEST_CLOSE, "HANDLE_VALUE_STREAM_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_VALUE_STREAM_LOADER, "HIDE_VALUE_STREAM_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_VALUE_STREAM_LOADER, "SHOW_VALUE_STREAM_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_VALUE_STREAM, "ON_ADD_VALUE_STREAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_EDIT_VALUE_STREAM, "ON_EDIT_VALUE_STREAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SET_VALUE_STREAM, "SET_VALUE_STREAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_VALUE_STREAM_SELECT, "ON_ALL_VALUE_STREAM_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_VALUE_STREAM_CLOSE, "ON_VALUE_STREAM_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_VALUE_STREAM_SELECT, "ON_VALUE_STREAM_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_VALUE_STREAM, "ON_DELETE_VALUE_STREAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_VALUE_STREAM_SUCCESS, "ON_DELETE_VALUE_STREAM_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_SELECTED_VALUE_STREAM, "ON_FILTER_SELECTED_VALUE_STREAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_VALUE_STREAM_OPTION_SELECT, "ON_FILTER_VALUE_STREAM_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_VALUE_STREAM, "ON_SAVE_VALUE_STREAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_VALUE_STREAM_SUCCESS, "ON_SAVE_VALUE_STREAM_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_VALUE_STREAM_DRAWER, "ON_TOGGLE_VALUE_STREAM_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_VALUE_STREAM_MESSAGE, "SHOW_VALUE_STREAM_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_VALUE_STREAM, "UPDATE_SEARCH_VALUE_STREAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FETCH_SELECT_TEAM_DATA, "ON_FETCH_SELECT_TEAM_DATA", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FETCH_SELECT_TEAM_DATA_SUCCESS, "ON_FETCH_SELECT_TEAM_DATA_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_VALUE_STREAM_TEAM_UPDATE, "ON_VALUE_STREAM_TEAM_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_FEATURE, "ADD_FAVOURITE_FEATURE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_FEATURE_SUCCESS, "ADD_FAVOURITE_FEATURE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_FEATURE, "FETCH_FEATURE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_FEATURE_SUCCESS, "FETCH_FEATURE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_FEATURE, "FETCH_ALL_FEATURE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_FEATURE_SUCCESS, "FETCH_ALL_FEATURE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_FEATURE, "FILTER_FEATURE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_FEATURE, "GET_ALL_FEATURE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_FEATURE, "GET_UNSELECTED_ALL_FEATURE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_FEATURE_REQUEST_CLOSE, "HANDLE_FEATURE_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_FEATURE_LOADER, "HIDE_FEATURE_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_FEATURE_LOADER, "SHOW_FEATURE_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_FEATURE, "ON_ADD_FEATURE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_EDIT_FEATURE, "ON_EDIT_FEATURE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_FEATURE_SELECT, "ON_ALL_FEATURE_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FEATURE_CLOSE, "ON_FEATURE_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FEATURE_SELECT, "ON_FEATURE_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_FEATURE, "ON_DELETE_FEATURE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_FEATURE_SUCCESS, "ON_DELETE_FEATURE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_SELECTED_FEATURE, "ON_FILTER_SELECTED_FEATURE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_FEATURE_OPTION_SELECT, "ON_FILTER_FEATURE_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_FEATURE, "ON_SAVE_FEATURE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_FEATURE_SUCCESS, "ON_SAVE_FEATURE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_FEATURE_DRAWER, "ON_TOGGLE_FEATURE_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_FEATURE_MESSAGE, "SHOW_FEATURE_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_FEATURE, "UPDATE_SEARCH_FEATURE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SET_FEATURE, "SET_FEATURE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FEATURE_INWARD_DEPENDENCY_UPDATE, "ON_FEATURE_INWARD_DEPENDENCY_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FEATURE_OUTWARD_DEPENDENCY_UPDATE, "ON_FEATURE_OUTWARD_DEPENDENCY_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FEATURE_DEPENDENCY_UPDATE_SUCCESS, "ON_FEATURE_DEPENDENCY_UPDATE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FETCH_SELECT_FEATURE_INWARD_DEPENDENCIES, "ON_FETCH_SELECT_FEATURE_INWARD_DEPENDENCIES", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FETCH_SELECT_FEATURE_OUTWARD_DEPENDENCIES, "ON_FETCH_SELECT_FEATURE_OUTWARD_DEPENDENCIES", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FETCH_SELECT_FEATURE_DEPENDENCIES_SUCCESS, "ON_FETCH_SELECT_FEATURE_DEPENDENCIES_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SELECT_PORTFOLIO, "SELECT_PORTFOLIO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PORTFOLIO_DASHBOARD, "ON_PORTFOLIO_DASHBOARD", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PORTFOLIO_DASHBOARD_SUCCESS, "ON_PORTFOLIO_DASHBOARD_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_PORTFOLIO, "ADD_FAVOURITE_PORTFOLIO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_PORTFOLIO_SUCCESS, "ADD_FAVOURITE_PORTFOLIO_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_PORTFOLIO, "FETCH_PORTFOLIO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_PORTFOLIO_SUCCESS, "FETCH_PORTFOLIO_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_PORTFOLIO, "FETCH_ALL_PORTFOLIO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_PORTFOLIO_SUCCESS, "FETCH_ALL_PORTFOLIO_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_PORTFOLIO, "FILTER_PORTFOLIO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_PORTFOLIO, "GET_ALL_PORTFOLIO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_PORTFOLIO, "GET_UNSELECTED_ALL_PORTFOLIO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_PORTFOLIO_REQUEST_CLOSE, "HANDLE_PORTFOLIO_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_PORTFOLIO_LOADER, "HIDE_PORTFOLIO_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_PORTFOLIO_LOADER, "SHOW_PORTFOLIO_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_PORTFOLIO, "ON_ADD_PORTFOLIO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_EDIT_PORTFOLIO, "ON_EDIT_PORTFOLIO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_PORTFOLIO_SELECT, "ON_ALL_PORTFOLIO_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PORTFOLIO_CLOSE, "ON_PORTFOLIO_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PORTFOLIO_SELECT, "ON_PORTFOLIO_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_PORTFOLIO, "ON_DELETE_PORTFOLIO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_PORTFOLIO_SUCCESS, "ON_DELETE_PORTFOLIO_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_SELECTED_PORTFOLIO, "ON_FILTER_SELECTED_PORTFOLIO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_PORTFOLIO_OPTION_SELECT, "ON_FILTER_PORTFOLIO_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_PORTFOLIO, "ON_SAVE_PORTFOLIO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_PORTFOLIO_SUCCESS, "ON_SAVE_PORTFOLIO_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_PORTFOLIO_DRAWER, "ON_TOGGLE_PORTFOLIO_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_PORTFOLIO_MESSAGE, "SHOW_PORTFOLIO_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_PORTFOLIO, "UPDATE_SEARCH_PORTFOLIO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_BUSINESS_UNIT, "ADD_FAVOURITE_BUSINESS_UNIT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_BUSINESS_UNIT_SUCCESS, "ADD_FAVOURITE_BUSINESS_UNIT_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_BUSINESS_UNIT, "FETCH_BUSINESS_UNIT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_BUSINESS_UNIT_SUCCESS, "FETCH_BUSINESS_UNIT_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_BUSINESS_UNIT, "FETCH_ALL_BUSINESS_UNIT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_BUSINESS_UNIT_SUCCESS, "FETCH_ALL_BUSINESS_UNIT_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_BUSINESS_UNIT, "FILTER_BUSINESS_UNIT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_BUSINESS_UNIT, "GET_ALL_BUSINESS_UNIT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_BUSINESS_UNIT, "GET_UNSELECTED_ALL_BUSINESS_UNIT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_BUSINESS_UNIT_REQUEST_CLOSE, "HANDLE_BUSINESS_UNIT_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_BUSINESS_UNIT_LOADER, "HIDE_BUSINESS_UNIT_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_BUSINESS_UNIT_LOADER, "SHOW_BUSINESS_UNIT_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_BUSINESS_UNIT, "ON_ADD_BUSINESS_UNIT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_BUSINESS_UNIT_SELECT, "ON_ALL_BUSINESS_UNIT_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_BUSINESS_UNIT_CLOSE, "ON_BUSINESS_UNIT_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_BUSINESS_UNIT_SELECT, "ON_BUSINESS_UNIT_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_BUSINESS_UNIT, "ON_DELETE_BUSINESS_UNIT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_BUSINESS_UNIT_SUCCESS, "ON_DELETE_BUSINESS_UNIT_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_SELECTED_BUSINESS_UNIT, "ON_FILTER_SELECTED_BUSINESS_UNIT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_BUSINESS_UNIT_OPTION_SELECT, "ON_FILTER_BUSINESS_UNIT_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_BUSINESS_UNIT, "ON_SAVE_BUSINESS_UNIT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_BUSINESS_UNIT_SUCCESS, "ON_SAVE_BUSINESS_UNIT_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_BUSINESS_UNIT_DRAWER, "ON_TOGGLE_BUSINESS_UNIT_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_BUSINESS_UNIT_MESSAGE, "SHOW_BUSINESS_UNIT_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_BUSINESS_UNIT, "UPDATE_SEARCH_BUSINESS_UNIT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_PROJECT_ISSUE, "ADD_FAVOURITE_PROJECT_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_PROJECT_ISSUE_SUCCESS, "ADD_FAVOURITE_PROJECT_ISSUE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_PROJECT_ISSUE, "FETCH_PROJECT_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_PROJECT_ISSUE_SUCCESS, "FETCH_PROJECT_ISSUE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_PROJECT_ISSUE, "FETCH_ALL_PROJECT_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_PROJECT_ISSUE_SUCCESS, "FETCH_ALL_PROJECT_ISSUE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_PROJECT_ISSUE, "FILTER_PROJECT_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_PROJECT_ISSUE, "GET_ALL_PROJECT_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_PROJECT_ISSUE, "GET_UNSELECTED_ALL_PROJECT_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_PROJECT_ISSUE_REQUEST_CLOSE, "HANDLE_PROJECT_ISSUE_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_PROJECT_ISSUE_LOADER, "HIDE_PROJECT_ISSUE_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_PROJECT_ISSUE_LOADER, "SHOW_PROJECT_ISSUE_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_PROJECT_ISSUE, "ON_ADD_PROJECT_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_JIRA_PROJECT_ISSUE, "ON_ADD_JIRA_PROJECT_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_PROJECT_ISSUE_SELECT, "ON_ALL_PROJECT_ISSUE_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PROJECT_ISSUE_CLOSE, "ON_PROJECT_ISSUE_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PROJECT_ISSUE_SELECT, "ON_PROJECT_ISSUE_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_PROJECT_ISSUE, "ON_DELETE_PROJECT_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_PROJECT_ISSUE_SUCCESS, "ON_DELETE_PROJECT_ISSUE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_SELECTED_PROJECT_ISSUE, "ON_FILTER_SELECTED_PROJECT_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_PROJECT_ISSUE_OPTION_SELECT, "ON_FILTER_PROJECT_ISSUE_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_PROJECT_ISSUE, "ON_SAVE_PROJECT_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_JIRA_PROJECT_ISSUE, "ON_SAVE_JIRA_PROJECT_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_PROJECT_ISSUE_SUCCESS, "ON_SAVE_PROJECT_ISSUE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_PROJECT_ISSUE_DRAWER, "ON_TOGGLE_PROJECT_ISSUE_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_PROJECT_ISSUE_MESSAGE, "SHOW_PROJECT_ISSUE_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_PROJECT_ISSUE, "UPDATE_SEARCH_PROJECT_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_PROJECT_PRIORITY, "ADD_FAVOURITE_PROJECT_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_PROJECT_PRIORITY, "FETCH_PROJECT_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_PROJECT_PRIORITY_SUCCESS, "FETCH_PROJECT_PRIORITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_PROJECT_PRIORITY, "FETCH_ALL_PROJECT_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_PROJECT_PRIORITY_SUCCESS, "FETCH_ALL_PROJECT_PRIORITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_PROJECT_PRIORITY, "FILTER_PROJECT_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_PROJECT_PRIORITY, "GET_ALL_PROJECT_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_PROJECT_PRIORITY, "GET_UNSELECTED_ALL_PROJECT_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_PROJECT_PRIORITY_REQUEST_CLOSE, "HANDLE_PROJECT_PRIORITY_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_PROJECT_PRIORITY_LOADER, "HIDE_PROJECT_PRIORITY_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_PROJECT_PRIORITY_LOADER, "SHOW_PROJECT_PRIORITY_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_PROJECT_PRIORITY, "ON_ADD_PROJECT_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_PROJECT_PRIORITY_SELECT, "ON_ALL_PROJECT_PRIORITY_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PROJECT_PRIORITY_CLOSE, "ON_PROJECT_PRIORITY_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PROJECT_PRIORITY_SELECT, "ON_PROJECT_PRIORITY_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_PROJECT_PRIORITY, "ON_DELETE_PROJECT_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_PROJECT_PRIORITY_SUCCESS, "ON_DELETE_PROJECT_PRIORITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_SELECTED_PROJECT_PRIORITY, "ON_DELETE_SELECTED_PROJECT_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_PROJECT_PRIORITY_OPTION_SELECT, "ON_FILTER_PROJECT_PRIORITY_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_PROJECT_PRIORITY, "ON_SAVE_PROJECT_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_PROJECT_PRIORITY_SUCCESS, "ON_SAVE_PROJECT_PRIORITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_PROJECT_PRIORITY_DRAWER, "ON_TOGGLE_PROJECT_PRIORITY_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_PROJECT_PRIORITY_MESSAGE, "SHOW_PROJECT_PRIORITY_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_PROJECT_PRIORITY, "UPDATE_SEARCH_PROJECT_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_PROJECT, "ADD_FAVOURITE_PROJECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_PROJECT_SUCCESS, "ADD_FAVOURITE_PROJECT_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_PROJECT, "FETCH_PROJECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_PROJECT_SUCCESS, "FETCH_PROJECT_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_PROJECT, "FETCH_ALL_PROJECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_PROJECT_SUCCESS, "FETCH_ALL_PROJECT_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_PROJECT, "FILTER_PROJECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_PROJECT, "GET_ALL_PROJECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_PROJECT, "GET_UNSELECTED_ALL_PROJECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_PROJECT_REQUEST_CLOSE, "HANDLE_PROJECT_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_PROJECT_LOADER, "HIDE_PROJECT_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_PROJECT_LOADER, "SHOW_PROJECT_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_PROJECT, "ON_ADD_PROJECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_EDIT_PROJECT, "ON_EDIT_PROJECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_PROJECT_SELECT, "ON_ALL_PROJECT_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PROJECT_CLOSE, "ON_PROJECT_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PROJECT_SELECT, "ON_PROJECT_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_PROJECT, "ON_DELETE_PROJECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_PROJECT_SUCCESS, "ON_DELETE_PROJECT_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_SELECTED_PROJECT, "ON_DELETE_SELECTED_PROJECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_PROJECT_OPTION_SELECT, "ON_FILTER_PROJECT_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_PROJECT, "ON_SAVE_PROJECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_UPDATE_PROJECT_PRIORITIES, "ON_UPDATE_PROJECT_PRIORITIES", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_PROJECT_SUCCESS, "ON_SAVE_PROJECT_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_PROJECT_DRAWER, "ON_TOGGLE_PROJECT_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_PROJECT_MESSAGE, "SHOW_PROJECT_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_PROJECT, "UPDATE_SEARCH_PROJECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PROJECT_COST_PRIORITIES_DASHBOARD, "ON_PROJECT_COST_PRIORITIES_DASHBOARD", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_GLOBAL_PROJECT_COST_PRIORITIES_DASHBOARD, "ON_GLOBAL_PROJECT_COST_PRIORITIES_DASHBOARD", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_GLOBAL_PROJECT_BUSINESS_PRIORITIES_DASHBOARD, "ON_GLOBAL_PROJECT_BUSINESS_PRIORITIES_DASHBOARD", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PROJECT_BUSINESS_PRIORITIES_DASHBOARD, "ON_PROJECT_BUSINESS_PRIORITIES_DASHBOARD", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_IMPORT_PROJECTS, "FETCH_IMPORT_PROJECTS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_IMPORT_PROJECTS_SUCCESS, "FETCH_IMPORT_PROJECTS_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_IMPORT_PROJECTS_LOADER, "SHOW_IMPORT_PROJECTS_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_IMPORT_PROJECTS_LOADER, "HIDE_IMPORT_PROJECTS_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_IMPORT_PROJECTS, "ON_IMPORT_PROJECTS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_IMPORT_PROJECTS_SUCCESS, "ON_IMPORT_PROJECTS_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PROJECT_ISSUES_DASHBOARD, "ON_PROJECT_ISSUES_DASHBOARD", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_PROJECT_ISSUE_CACHE_SUCCESS, "ON_SAVE_PROJECT_ISSUE_CACHE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_PROJECT_CACHE_SUCCESS, "ON_SAVE_PROJECT_CACHE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SET_PROJECT_ISSUE, "SET_PROJECT_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SET_PROJECT, "SET_PROJECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(TOGGLE_COLLAPSED_NAV, "TOGGLE_COLLAPSED_NAV", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(DRAWER_TYPE, "DRAWER_TYPE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FIXED_DRAWER, "FIXED_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(COLLAPSED_DRAWER, "COLLAPSED_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(MINI_DRAWER, "MINI_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(THEME_COLOR, "THEME_COLOR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(DARK_THEME, "DARK_THEME", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(WINDOW_WIDTH, "WINDOW_WIDTH", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(WINDOW_HEIGHT, "WINDOW_HEIGHT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SWITCH_LANGUAGE, "SWITCH_LANGUAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(CHANGE_DIRECTION, "CHANGE_DIRECTION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(CHANGE_NAVIGATION_STYLE, "CHANGE_NAVIGATION_STYLE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HORIZONTAL_NAVIGATION, "HORIZONTAL_NAVIGATION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(VERTICAL_NAVIGATION, "VERTICAL_NAVIGATION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HORIZONTAL_MENU_POSITION, "HORIZONTAL_MENU_POSITION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ABOVE_THE_HEADER, "ABOVE_THE_HEADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(INSIDE_THE_HEADER, "INSIDE_THE_HEADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(BELOW_THE_HEADER, "BELOW_THE_HEADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(COLOR_OPTIONS_MODAL, "COLOR_OPTIONS_MODAL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(USER_INFO_MODAL, "USER_INFO_MODAL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(CLEAR_SESSION, "CLEAR_SESSION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(CLEAR_SELECTED_OBJECTS, "CLEAR_SELECTED_OBJECTS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_MESSAGE, "SHOW_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_MESSAGE, "HIDE_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SHOW_LOADER, "ON_SHOW_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_HIDE_LOADER, "ON_HIDE_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_DRAWER, "ON_TOGGLE_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_REQUEST_CLOSE, "HANDLE_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE, "ADD_FAVOURITE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_CONTACT, "FETCH_ALL_CONTACT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_CONTACT_SUCCESS, "FETCH_ALL_CONTACT_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_CONTACT_SELECT, "ON_CONTACT_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_CONTACT, "ON_ADD_CONTACT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_CONTACT_CLOSE, "ON_CONTACT_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_OPTION_SELECT, "ON_FILTER_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_CONTACT, "ON_SAVE_CONTACT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_CONTACT, "ON_DELETE_CONTACT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_SELECTED_CONTACT, "ON_DELETE_SELECTED_CONTACT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_CONTACT, "FILTER_CONTACT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_CONTACT, "GET_ALL_CONTACT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_CONTACT, "GET_UNSELECTED_ALL_CONTACT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_CONTACT_SELECT, "ON_ALL_CONTACT_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_USER, "UPDATE_SEARCH_USER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_CONTACT_LOADER, "HIDE_CONTACT_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SIGNUP_USER, "SIGNUP_USER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SIGNUP_USER_SUCCESS, "SIGNUP_USER_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SIGNIN_GOOGLE_USER, "SIGNIN_GOOGLE_USER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SIGNIN_GOOGLE_USER_SUCCESS, "SIGNIN_GOOGLE_USER_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SIGNIN_FACEBOOK_USER, "SIGNIN_FACEBOOK_USER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SIGNIN_FACEBOOK_USER_SUCCESS, "SIGNIN_FACEBOOK_USER_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SIGNIN_TWITTER_USER, "SIGNIN_TWITTER_USER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SIGNIN_TWITTER_USER_SUCCESS, "SIGNIN_TWITTER_USER_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SIGNIN_GITHUB_USER, "SIGNIN_GITHUB_USER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SIGNIN_GITHUB_USER_SUCCESS, "SIGNIN_GITHUB_USER_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SIGNIN_USER, "SIGNIN_USER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SIGNIN_USER_PASSWORDLESS, "SIGNIN_USER_PASSWORDLESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SIGNIN_USER_SUCCESS, "SIGNIN_USER_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SIGNOUT_USER, "SIGNOUT_USER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SIGNOUT_USER_SUCCESS, "SIGNOUT_USER_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(INIT_URL, "INIT_URL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(IDENTITY_SUCCESS, "IDENTITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(REQUEST_SIGNIN_ACCESS_CODE, "REQUEST_SIGNIN_ACCESS_CODE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(REQUEST_SIGNIN_ACCESS_CODE_SUCCESS, "REQUEST_SIGNIN_ACCESS_CODE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_CHAT_USER, "FETCH_ALL_CHAT_USER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_CHAT_USER_CONVERSATION, "FETCH_ALL_CHAT_USER_CONVERSATION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_CHAT_USER_SUCCESS, "FETCH_ALL_CHAT_USER_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_CHAT_USER_CONVERSATION_SUCCESS, "FETCH_ALL_CHAT_USER_CONVERSATION_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_USERS, "FILTER_USERS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SELECT_USER, "ON_SELECT_USER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(USER_INFO_STATE, "USER_INFO_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SUBMIT_COMMENT, "SUBMIT_COMMENT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_MESSAGE_VALUE, "UPDATE_MESSAGE_VALUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_CHAT_USER, "UPDATE_SEARCH_CHAT_USER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_LABEL, "ADD_LABEL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_MAIL, "GET_ALL_MAIL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_MAIL, "FETCH_ALL_MAIL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_MAIL_SUCCESS, "FETCH_ALL_MAIL_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_IMPORTANT_MAIL, "GET_IMPORTANT_MAIL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_NAV_FILTERS, "GET_NAV_FILTERS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_NAV_LABELS, "GET_NAV_LABELS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_NAV_FOLDER, "GET_NAV_FOLDER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_READ_MAIL, "GET_READ_MAIL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_STARRED_MAIL, "GET_STARRED_MAIL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNIMPORTANT_MAIL, "GET_UNIMPORTANT_MAIL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNREAD_MAIL, "GET_UNREAD_MAIL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_MAIL, "GET_UNSELECTED_ALL_MAIL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSTARRED_MAIL, "GET_UNSTARRED_MAIL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_MAIL_SELECT, "ON_ALL_MAIL_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FOLDER_MENU_ITEM_SELECT, "ON_FOLDER_MENU_ITEM_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FOLDER_SELECT, "ON_FOLDER_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_IMPORTANT_SELECT, "ON_IMPORTANT_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_LABEL_MENU_ITEM_SELECT, "ON_LABEL_MENU_ITEM_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_MARK_AS_START, "GET_MARK_AS_START", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_LABEL_SELECT, "ON_LABEL_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_MAIL_CHECKED, "ON_MAIL_CHECKED", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_MAIL_SELECT, "ON_MAIL_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_MAIL_SEND, "ON_MAIL_SEND", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_OPTION_MENU_ITEM_SELECT, "ON_OPTION_MENU_ITEM_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_OPTION_MENU_SELECT, "ON_OPTION_MENU_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_START_SELECT, "ON_START_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SEARCH_MAIL, "SEARCH_MAIL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_MAIL, "ON_DELETE_MAIL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SET_CURRENT_MAIL_NULL, "SET_CURRENT_MAIL_NULL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_COMPOSE_MAIL, "ON_COMPOSE_MAIL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SORTEND, "ON_SORTEND", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_TODO, "FETCH_ALL_TODO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_TODO_SUCCESS, "FETCH_ALL_TODO_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_TODO_CONVERSATION, "FETCH_ALL_TODO_CONVERSATION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_TODO_CONVERSATION_SUCCESS, "FETCH_ALL_TODO_CONVERSATION_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SELECT_ALL_TODO, "SELECT_ALL_TODO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_TODO, "GET_ALL_TODO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_TODO, "GET_UNSELECTED_ALL_TODO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_STARRED_TODO, "GET_STARRED_TODO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSTARRED_TODO, "GET_UNSTARRED_TODO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_IMPORTANT_TODO, "GET_IMPORTANT_TODO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNIMPORTANT_TODO, "GET_UNIMPORTANT_TODO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_LABEL_UPDATE, "ON_LABEL_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TODO_UPDATE, "ON_TODO_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_TODO, "ON_DELETE_TODO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SEARCH_TODO, "SEARCH_TODO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_TODOS, "SHOW_TODOS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_TODO_CONVERSATION, "GET_TODO_CONVERSATION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TODO_CHECKED, "ON_TODO_CHECKED", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TODO_ADD, "ON_TODO_ADD", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TODO_SELECT, "ON_TODO_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SET_CURRENT_TODO_NULL, "SET_CURRENT_TODO_NULL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(REMOVE_LABEL, "REMOVE_LABEL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH, "UPDATE_SEARCH", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_ORG_MESSAGE, "SHOW_ORG_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_ORG_DRAWER, "ON_TOGGLE_ORG_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_ORG_REQUEST_CLOSE, "HANDLE_ORG_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_ORG_OPTION_SELECT, "ON_FILTER_ORG_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_ORG_LOADER, "HIDE_ORG_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_ORG_LOADER, "SHOW_ORG_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_ORG, "ADD_FAVOURITE_ORG", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ORG, "FETCH_ORG", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ORG_SUCCESS, "FETCH_ORG_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ORGS_SELECT_ORG, "FETCH_ORGS_SELECT_ORG", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ORG, "FETCH_ALL_ORG", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ORG_SUCCESS, "FETCH_ALL_ORG_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ORG_SELECT, "ON_ORG_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_ORG, "ON_ADD_ORG", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ORG_CLOSE, "ON_ORG_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_ORG, "ON_SAVE_ORG", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_ORG_SUCCESS, "ON_SAVE_ORG_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_ORG, "ON_DELETE_ORG", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_SELECTED_ORG, "ON_DELETE_SELECTED_ORG", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_ORG, "FILTER_ORG", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_ORG, "GET_ALL_ORG", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_ORG, "GET_UNSELECTED_ALL_ORG", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_ORG_SELECT, "ON_ALL_ORG_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_ORG, "UPDATE_SEARCH_ORG", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_EMP_DASHBOARD, "ON_EMP_DASHBOARD", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ORG_SURVEY_DASHBOARD, "ON_ORG_SURVEY_DASHBOARD", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ORG_DASHBOARD, "ON_ORG_DASHBOARD", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ORG_DASHBOARD_SUCCESS, "ON_ORG_DASHBOARD_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PROJECT_DASHBOARD, "ON_PROJECT_DASHBOARD", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_IMPERSONATE_DASHBOARD, "ON_IMPERSONATE_DASHBOARD", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PROJECT_PRIORITY_DASHBOARD, "ON_PROJECT_PRIORITY_DASHBOARD", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ORG_STATISTICS, "FETCH_ORG_STATISTICS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ORG_STATISTICS_SUCCESS, "FETCH_ORG_STATISTICS_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_EMP_MESSAGE, "SHOW_EMP_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_EMP_DRAWER, "ON_TOGGLE_EMP_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_EMP_REQUEST_CLOSE, "HANDLE_EMP_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_EMP_OPTION_SELECT, "ON_FILTER_EMP_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_EMP_LOADER, "HIDE_EMP_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_EMP_DASHBOARD_LOADER, "SHOW_EMP_DASHBOARD_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_EMP_DASHBOARD_LOADER, "HIDE_EMP_DASHBOARD_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_EMP_LOADER, "SHOW_EMP_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_EMP, "ADD_FAVOURITE_EMP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_EMP_SUCCESS, "ADD_FAVOURITE_EMP_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_EMP, "FETCH_ALL_EMP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_EMP_SUCCESS, "FETCH_ALL_EMP_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_EMP_SELECT, "ON_EMP_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_EMP, "ON_ADD_EMP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_EMP_CLOSE, "ON_EMP_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_EMP, "ON_SAVE_EMP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_EMP_SUCCESS, "ON_SAVE_EMP_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_EMP, "ON_DELETE_EMP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_SELECTED_EMP, "ON_DELETE_SELECTED_EMP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_EMP, "FILTER_EMP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_EMP, "GET_ALL_EMP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_EMP, "GET_UNSELECTED_ALL_EMP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_EMP_SELECT, "ON_ALL_EMP_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_EMP, "UPDATE_SEARCH_EMP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_EMP_SURVEY_ANSWERS, "FETCH_EMP_SURVEY_ANSWERS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_EMP_SURVEY_ANSWERS_SUCCESS, "FETCH_EMP_SURVEY_ANSWERS_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SAVE_EMP_SURVEY_ANSWERS, "SAVE_EMP_SURVEY_ANSWERS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SAVE_EMP_SURVEY_ANSWERS_SUCCESS, "SAVE_EMP_SURVEY_ANSWERS_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_NOTIFICATIONS, "FETCH_NOTIFICATIONS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_NOTIFICATIONS_SUCCESS, "FETCH_NOTIFICATIONS_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_ORG_SURVEY_MESSAGE, "SHOW_ORG_SURVEY_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_ORG_SURVEY_DRAWER, "ON_TOGGLE_ORG_SURVEY_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_ORG_SURVEY_REQUEST_CLOSE, "HANDLE_ORG_SURVEY_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_ORG_SURVEY_OPTION_SELECT, "ON_FILTER_ORG_SURVEY_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_ORG_SURVEY_LOADER, "HIDE_ORG_SURVEY_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_ORG_SURVEY_LOADER, "SHOW_ORG_SURVEY_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_ORG_SURVEY, "ADD_FAVOURITE_ORG_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ORG_SURVEY, "FETCH_ALL_ORG_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ORG_SURVEY_SUCCESS, "FETCH_ALL_ORG_SURVEY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ORG_SURVEY_SELECT, "ON_ORG_SURVEY_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_ORG_SURVEY, "ON_ADD_ORG_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ORG_SURVEY_CLOSE, "ON_ORG_SURVEY_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_ORG_SURVEY, "ON_SAVE_ORG_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_ORG_SURVEY_SUCCESS, "ON_SAVE_ORG_SURVEY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_ORG_SURVEY, "ON_DELETE_ORG_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_SELECTED_ORG_SURVEY, "ON_DELETE_SELECTED_ORG_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_ORG_SURVEY, "FILTER_ORG_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_ORG_SURVEY, "GET_ALL_ORG_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_ORG_SURVEY, "GET_UNSELECTED_ALL_ORG_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_ORG_SURVEY_SELECT, "ON_ALL_ORG_SURVEY_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_ORG_SURVEY, "UPDATE_SEARCH_ORG_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ORG_SURVEY_QUESTIONS, "ON_ORG_SURVEY_QUESTIONS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ORG_SURVEY_COMPARE_DASHBOARD, "ON_ORG_SURVEY_COMPARE_DASHBOARD", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ORG_SURVEY_COMPARE_SELECT, "ON_ORG_SURVEY_COMPARE_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ORG_SURVEY_COMPARE, "FETCH_ALL_ORG_SURVEY_COMPARE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ORG_SURVEY_COMPARE_SUCCESS, "FETCH_ALL_ORG_SURVEY_COMPARE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ORG_SURVEY_COMPARE_RADAR_CHART_DATA, "FETCH_ALL_ORG_SURVEY_COMPARE_RADAR_CHART_DATA", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ORG_SURVEY_COMPARE_RADAR_CHART_DATA_SUCCESS, "FETCH_ALL_ORG_SURVEY_COMPARE_RADAR_CHART_DATA_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ORG_SURVEY_COMPARE_DISTRIBUTIONS_CHART_DATA, "FETCH_ALL_ORG_SURVEY_COMPARE_DISTRIBUTIONS_CHART_DATA", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ORG_SURVEY_COMPARE_DISTRIBUTIONS_CHART_DATA_SUCCESS, "FETCH_ALL_ORG_SURVEY_COMPARE_DISTRIBUTIONS_CHART_DATA_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ORG_SURVEY_COMPARE_TOP_RESULTS_CHART_DATA, "FETCH_ALL_ORG_SURVEY_COMPARE_TOP_RESULTS_CHART_DATA", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ORG_SURVEY_COMPARE_TOP_RESULTS_CHART_DATA_SUCCESS, "FETCH_ALL_ORG_SURVEY_COMPARE_TOP_RESULTS_CHART_DATA_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ORG_SURVEY_COMPARE_BOTTOM_RESULTS_CHART_DATA, "FETCH_ALL_ORG_SURVEY_COMPARE_BOTTOM_RESULTS_CHART_DATA", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ORG_SURVEY_COMPARE_BOTTOM_RESULTS_CHART_DATA_SUCCESS, "FETCH_ALL_ORG_SURVEY_COMPARE_BOTTOM_RESULTS_CHART_DATA_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ORG_SURVEY_ENGAGEMENT_REPORT_CHART_DATA, "FETCH_ALL_ORG_SURVEY_ENGAGEMENT_REPORT_CHART_DATA", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ORG_SURVEY_ENGAGEMENT_REPORT_CHART_DATA_SUCCESS, "FETCH_ALL_ORG_SURVEY_ENGAGEMENT_REPORT_CHART_DATA_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_ORG_SURVEY_ANSWERS, "ON_SAVE_ORG_SURVEY_ANSWERS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_ORG_SURVEY_ANSWERS_SUCCESS, "ON_SAVE_ORG_SURVEY_ANSWERS_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ORG_SURVEY_ANSWERS, "FETCH_ORG_SURVEY_ANSWERS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ORG_SURVEY_ANSWERS_SUCCESS, "FETCH_ORG_SURVEY_ANSWERS_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_ORG_SURVEY_ANSWERS_LOADER, "HIDE_ORG_SURVEY_ANSWERS_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_ORG_SURVEY_ANSWERS_LOADER, "SHOW_ORG_SURVEY_ANSWERS_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_ORG_SURVEY_ANSWERS_MESSAGE, "SHOW_ORG_SURVEY_ANSWERS_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_ORG_SURVEY_ANSWER_MESSAGE_CLOSE, "HANDLE_ORG_SURVEY_ANSWER_MESSAGE_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_SURVEY_MESSAGE, "SHOW_SURVEY_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_SURVEY_DRAWER, "ON_TOGGLE_SURVEY_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_SURVEY_REQUEST_CLOSE, "HANDLE_SURVEY_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_SURVEY_OPTION_SELECT, "ON_FILTER_SURVEY_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_SURVEY_LOADER, "HIDE_SURVEY_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_SURVEY_LOADER, "SHOW_SURVEY_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_SURVEY, "ADD_FAVOURITE_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_SURVEY, "FETCH_ALL_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_SURVEY_SUCCESS, "FETCH_ALL_SURVEY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SURVEY_SELECT, "ON_SURVEY_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_SURVEY, "ON_ADD_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SURVEY_CLOSE, "ON_SURVEY_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_SURVEY, "ON_SAVE_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_SURVEY_SUCCESS, "ON_SAVE_SURVEY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_SURVEY, "ON_DELETE_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_SELECTED_SURVEY, "ON_DELETE_SELECTED_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_SURVEY, "FILTER_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_SURVEY, "GET_ALL_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_SURVEY, "GET_UNSELECTED_ALL_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_SURVEY_SELECT, "ON_ALL_SURVEY_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_SURVEY, "UPDATE_SEARCH_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SURVEY_QUESTIONS, "ON_SURVEY_QUESTIONS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_SURVEY_GROUP_MESSAGE, "SHOW_SURVEY_GROUP_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_SURVEY_GROUP_DRAWER, "ON_TOGGLE_SURVEY_GROUP_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_SURVEY_GROUP_REQUEST_CLOSE, "HANDLE_SURVEY_GROUP_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_SURVEY_GROUP_OPTION_SELECT, "ON_FILTER_SURVEY_GROUP_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_SURVEY_GROUP_LOADER, "HIDE_SURVEY_GROUP_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_SURVEY_GROUP_LOADER, "SHOW_SURVEY_GROUP_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_SURVEY_GROUP, "ADD_FAVOURITE_SURVEY_GROUP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_SURVEY_GROUP, "FETCH_ALL_SURVEY_GROUP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_SURVEY_GROUP_SUCCESS, "FETCH_ALL_SURVEY_GROUP_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SURVEY_GROUP_SELECT, "ON_SURVEY_GROUP_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_SURVEY_GROUP, "ON_ADD_SURVEY_GROUP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SURVEY_GROUP_CLOSE, "ON_SURVEY_GROUP_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_SURVEY_GROUP, "ON_SAVE_SURVEY_GROUP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_SURVEY_GROUP_SUCCESS, "ON_SAVE_SURVEY_GROUP_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_SURVEY_GROUP, "ON_DELETE_SURVEY_GROUP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_SELECTED_SURVEY_GROUP, "ON_DELETE_SELECTED_SURVEY_GROUP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_SURVEY_GROUP, "FILTER_SURVEY_GROUP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_SURVEY_GROUP, "GET_ALL_SURVEY_GROUP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_SURVEY_GROUP, "GET_UNSELECTED_ALL_SURVEY_GROUP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_SURVEY_GROUP_SELECT, "ON_ALL_SURVEY_GROUP_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_SURVEY_GROUP, "UPDATE_SEARCH_SURVEY_GROUP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SURVEY_GROUP_QUESTIONS, "ON_SURVEY_GROUP_QUESTIONS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_SURVEY_QUESTION_MESSAGE, "SHOW_SURVEY_QUESTION_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_SURVEY_QUESTION_SUCCESS, "FETCH_ALL_SURVEY_QUESTION_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_SURVEY_QUESTION, "FETCH_ALL_SURVEY_QUESTION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_SURVEY_QUESTION_LOADER, "HIDE_SURVEY_QUESTION_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_SURVEY_QUESTION_LOADER, "SHOW_SURVEY_QUESTION_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_SURVEY_GROUP_QUESTION_MESSAGE, "SHOW_SURVEY_GROUP_QUESTION_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_SURVEY_GROUP_QUESTION_DRAWER, "ON_TOGGLE_SURVEY_GROUP_QUESTION_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_SURVEY_GROUP_QUESTION_REQUEST_CLOSE, "HANDLE_SURVEY_GROUP_QUESTION_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_SURVEY_GROUP_QUESTION_OPTION_SELECT, "ON_FILTER_SURVEY_GROUP_QUESTION_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_SURVEY_GROUP_QUESTION_LOADER, "HIDE_SURVEY_GROUP_QUESTION_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_SURVEY_GROUP_QUESTION_LOADER, "SHOW_SURVEY_GROUP_QUESTION_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_SURVEY_GROUP_QUESTION, "ADD_FAVOURITE_SURVEY_GROUP_QUESTION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_SURVEY_GROUP_QUESTION, "FETCH_ALL_SURVEY_GROUP_QUESTION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_SURVEY_GROUP_QUESTION_SUCCESS, "FETCH_ALL_SURVEY_GROUP_QUESTION_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SURVEY_GROUP_QUESTION_SELECT, "ON_SURVEY_GROUP_QUESTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_SURVEY_GROUP_QUESTION, "ON_ADD_SURVEY_GROUP_QUESTION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SURVEY_GROUP_QUESTION_CLOSE, "ON_SURVEY_GROUP_QUESTION_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_SURVEY_GROUP_QUESTION, "ON_SAVE_SURVEY_GROUP_QUESTION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_SURVEY_GROUP_QUESTION, "ON_DELETE_SURVEY_GROUP_QUESTION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_SELECTED_SURVEY_GROUP_QUESTION, "ON_DELETE_SELECTED_SURVEY_GROUP_QUESTION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_SURVEY_GROUP_QUESTION, "FILTER_SURVEY_GROUP_QUESTION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_SURVEY_GROUP_QUESTION, "GET_ALL_SURVEY_GROUP_QUESTION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_SURVEY_GROUP_QUESTION, "GET_UNSELECTED_ALL_SURVEY_GROUP_QUESTION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_SURVEY_GROUP_QUESTION_SELECT, "ON_ALL_SURVEY_GROUP_QUESTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_SURVEY_GROUP_QUESTION, "UPDATE_SEARCH_SURVEY_GROUP_QUESTION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_SECURITY, "ADD_FAVOURITE_SECURITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_SECURITY_SUCCESS, "ADD_FAVOURITE_SECURITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_SECURITY, "FETCH_SECURITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_SECURITY_SUCCESS, "FETCH_SECURITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_SECURITY, "FETCH_ALL_SECURITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_SECURITY_SUCCESS, "FETCH_ALL_SECURITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_SECURITY, "FILTER_SECURITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_SECURITY, "GET_ALL_SECURITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_SECURITY, "GET_UNSELECTED_ALL_SECURITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_SECURITY_REQUEST_CLOSE, "HANDLE_SECURITY_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_SECURITY_LOADER, "HIDE_SECURITY_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_SECURITY_LOADER, "SHOW_SECURITY_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_SECURITY, "ON_ADD_SECURITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_SECURITY_SELECT, "ON_ALL_SECURITY_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SECURITY_CLOSE, "ON_SECURITY_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SECURITY_SELECT, "ON_SECURITY_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_SECURITY, "ON_DELETE_SECURITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_SECURITY_SUCCESS, "ON_DELETE_SECURITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_SELECTED_SECURITY, "ON_FILTER_SELECTED_SECURITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_SECURITY_OPTION_SELECT, "ON_FILTER_SECURITY_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_SECURITY, "ON_SAVE_SECURITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_SECURITY_SUCCESS, "ON_SAVE_SECURITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_SECURITY_DRAWER, "ON_TOGGLE_SECURITY_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_SECURITY_MESSAGE, "SHOW_SECURITY_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_SECURITY, "UPDATE_SEARCH_SECURITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_PROJECT_COST_PRIORITY, "ADD_FAVOURITE_PROJECT_COST_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_PROJECT_COST_PRIORITY_SUCCESS, "ADD_FAVOURITE_PROJECT_COST_PRIORITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_PROJECT_COST_PRIORITY, "FETCH_PROJECT_COST_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_PROJECT_COST_PRIORITY_SUCCESS, "FETCH_PROJECT_COST_PRIORITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_PROJECT_COST_PRIORITY, "FETCH_ALL_PROJECT_COST_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_PROJECT_COST_PRIORITY_SUCCESS, "FETCH_ALL_PROJECT_COST_PRIORITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_PROJECT_COST_PRIORITY, "FILTER_PROJECT_COST_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_PROJECT_COST_PRIORITY, "GET_ALL_PROJECT_COST_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_PROJECT_COST_PRIORITY, "GET_UNSELECTED_ALL_PROJECT_COST_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_PROJECT_COST_PRIORITY_REQUEST_CLOSE, "HANDLE_PROJECT_COST_PRIORITY_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_PROJECT_COST_PRIORITY_LOADER, "HIDE_PROJECT_COST_PRIORITY_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_PROJECT_COST_PRIORITY_LOADER, "SHOW_PROJECT_COST_PRIORITY_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_PROJECT_COST_PRIORITY, "ON_ADD_PROJECT_COST_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_EDIT_PROJECT_COST_PRIORITY, "ON_EDIT_PROJECT_COST_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_PROJECT_COST_PRIORITY_SELECT, "ON_ALL_PROJECT_COST_PRIORITY_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PROJECT_COST_PRIORITY_CLOSE, "ON_PROJECT_COST_PRIORITY_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PROJECT_COST_PRIORITY_SELECT, "ON_PROJECT_COST_PRIORITY_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_PROJECT_COST_PRIORITY, "ON_DELETE_PROJECT_COST_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_PROJECT_COST_PRIORITY_SUCCESS, "ON_DELETE_PROJECT_COST_PRIORITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_SELECTED_PROJECT_COST_PRIORITY, "ON_FILTER_SELECTED_PROJECT_COST_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_PROJECT_COST_PRIORITY_OPTION_SELECT, "ON_FILTER_PROJECT_COST_PRIORITY_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_PROJECT_COST_PRIORITY, "ON_SAVE_PROJECT_COST_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_PROJECT_COST_PRIORITY_SUCCESS, "ON_SAVE_PROJECT_COST_PRIORITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_PROJECT_COST_PRIORITY_DRAWER, "ON_TOGGLE_PROJECT_COST_PRIORITY_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_PROJECT_COST_PRIORITY_MESSAGE, "SHOW_PROJECT_COST_PRIORITY_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_PROJECT_COST_PRIORITY, "UPDATE_SEARCH_PROJECT_COST_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_PROJECT_BUS_PRIORITY, "ADD_FAVOURITE_PROJECT_BUS_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_PROJECT_BUS_PRIORITY_SUCCESS, "ADD_FAVOURITE_PROJECT_BUS_PRIORITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_PROJECT_BUS_PRIORITY, "FETCH_PROJECT_BUS_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_PROJECT_BUS_PRIORITY_SUCCESS, "FETCH_PROJECT_BUS_PRIORITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_PROJECT_BUS_PRIORITY, "FETCH_ALL_PROJECT_BUS_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_PROJECT_BUS_PRIORITY_SUCCESS, "FETCH_ALL_PROJECT_BUS_PRIORITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_PROJECT_BUS_PRIORITY, "FILTER_PROJECT_BUS_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_PROJECT_BUS_PRIORITY, "GET_ALL_PROJECT_BUS_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_PROJECT_BUS_PRIORITY, "GET_UNSELECTED_ALL_PROJECT_BUS_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_PROJECT_BUS_PRIORITY_REQUEST_CLOSE, "HANDLE_PROJECT_BUS_PRIORITY_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_PROJECT_BUS_PRIORITY_LOADER, "HIDE_PROJECT_BUS_PRIORITY_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_PROJECT_BUS_PRIORITY_LOADER, "SHOW_PROJECT_BUS_PRIORITY_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_PROJECT_BUS_PRIORITY, "ON_ADD_PROJECT_BUS_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_EDIT_PROJECT_BUS_PRIORITY, "ON_EDIT_PROJECT_BUS_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_PROJECT_BUS_PRIORITY_SELECT, "ON_ALL_PROJECT_BUS_PRIORITY_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PROJECT_BUS_PRIORITY_CLOSE, "ON_PROJECT_BUS_PRIORITY_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PROJECT_BUS_PRIORITY_SELECT, "ON_PROJECT_BUS_PRIORITY_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_PROJECT_BUS_PRIORITY, "ON_DELETE_PROJECT_BUS_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_PROJECT_BUS_PRIORITY_SUCCESS, "ON_DELETE_PROJECT_BUS_PRIORITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_SELECTED_PROJECT_BUS_PRIORITY, "ON_FILTER_SELECTED_PROJECT_BUS_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_PROJECT_BUS_PRIORITY_OPTION_SELECT, "ON_FILTER_PROJECT_BUS_PRIORITY_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_PROJECT_BUS_PRIORITY, "ON_SAVE_PROJECT_BUS_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_PROJECT_BUS_PRIORITY_SUCCESS, "ON_SAVE_PROJECT_BUS_PRIORITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_PROJECT_BUS_PRIORITY_DRAWER, "ON_TOGGLE_PROJECT_BUS_PRIORITY_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_PROJECT_BUS_PRIORITY_MESSAGE, "SHOW_PROJECT_BUS_PRIORITY_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_PROJECT_BUS_PRIORITY, "UPDATE_SEARCH_PROJECT_BUS_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_ISSUE, "ADD_FAVOURITE_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_ISSUE_SUCCESS, "ADD_FAVOURITE_ISSUE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ISSUE, "FETCH_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ISSUE_SUCCESS, "FETCH_ISSUE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ISSUE, "FETCH_ALL_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ISSUE_SUCCESS, "FETCH_ALL_ISSUE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_ISSUE, "FILTER_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_ISSUE, "GET_ALL_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_ISSUE, "GET_UNSELECTED_ALL_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_ISSUE_REQUEST_CLOSE, "HANDLE_ISSUE_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_ISSUE_LOADER, "HIDE_ISSUE_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_ISSUE_LOADER, "SHOW_ISSUE_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_ISSUE, "ON_ADD_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_EDIT_ISSUE, "ON_EDIT_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SET_ISSUE, "SET_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_ISSUE_SELECT, "ON_ALL_ISSUE_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ISSUE_CLOSE, "ON_ISSUE_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ISSUE_SELECT, "ON_ISSUE_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_ISSUE, "ON_DELETE_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_ISSUE_SUCCESS, "ON_DELETE_ISSUE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_SELECTED_ISSUE, "ON_FILTER_SELECTED_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_ISSUE_OPTION_SELECT, "ON_FILTER_ISSUE_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_ISSUE, "ON_SAVE_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_ISSUE_SUCCESS, "ON_SAVE_ISSUE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_ISSUE_DRAWER, "ON_TOGGLE_ISSUE_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_ISSUE_MESSAGE, "SHOW_ISSUE_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_ISSUE, "UPDATE_SEARCH_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FETCH_SELECT_FEATURE_DATA, "ON_FETCH_SELECT_FEATURE_DATA", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FETCH_SELECT_FEATURE_DATA_SUCCESS, "ON_FETCH_SELECT_FEATURE_DATA_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ISSUE_FEATURE_UPDATE, "ON_ISSUE_FEATURE_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_INITIATIVE, "ADD_FAVOURITE_INITIATIVE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_INITIATIVE_SUCCESS, "ADD_FAVOURITE_INITIATIVE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_INITIATIVE, "FETCH_INITIATIVE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_INITIATIVE_SUCCESS, "FETCH_INITIATIVE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_INITIATIVE, "FETCH_ALL_INITIATIVE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_INITIATIVE_SUCCESS, "FETCH_ALL_INITIATIVE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_INITIATIVE, "FILTER_INITIATIVE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_INITIATIVE, "GET_ALL_INITIATIVE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_INITIATIVE, "GET_UNSELECTED_ALL_INITIATIVE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_INITIATIVE_REQUEST_CLOSE, "HANDLE_INITIATIVE_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_INITIATIVE_LOADER, "HIDE_INITIATIVE_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_INITIATIVE_LOADER, "SHOW_INITIATIVE_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_INITIATIVE, "ON_ADD_INITIATIVE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_EDIT_INITIATIVE, "ON_EDIT_INITIATIVE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SET_INITIATIVE, "SET_INITIATIVE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_INITIATIVE_SELECT, "ON_ALL_INITIATIVE_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_INITIATIVE_CLOSE, "ON_INITIATIVE_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_INITIATIVE_SELECT, "ON_INITIATIVE_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_INITIATIVE, "ON_DELETE_INITIATIVE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_INITIATIVE_SUCCESS, "ON_DELETE_INITIATIVE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_SELECTED_INITIATIVE, "ON_FILTER_SELECTED_INITIATIVE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_INITIATIVE_OPTION_SELECT, "ON_FILTER_INITIATIVE_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_INITIATIVE, "ON_SAVE_INITIATIVE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_INITIATIVE_SUCCESS, "ON_SAVE_INITIATIVE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_INITIATIVE_DRAWER, "ON_TOGGLE_INITIATIVE_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_INITIATIVE_MESSAGE, "SHOW_INITIATIVE_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_INITIATIVE, "UPDATE_SEARCH_INITIATIVE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FETCH_SELECT_PRODUCT_DATA, "ON_FETCH_SELECT_PRODUCT_DATA", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FETCH_SELECT_PRODUCT_DATA_SUCCESS, "ON_FETCH_SELECT_PRODUCT_DATA_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_INITIATIVE_PRODUCT_UPDATE, "ON_INITIATIVE_PRODUCT_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_PRODUCT, "ADD_FAVOURITE_PRODUCT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_PRODUCT_SUCCESS, "ADD_FAVOURITE_PRODUCT_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_PRODUCT_LOOKUP_DATA, "FETCH_PRODUCT_LOOKUP_DATA", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_PRODUCT, "FETCH_PRODUCT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_PRODUCT_SUCCESS, "FETCH_PRODUCT_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_PRODUCT, "FETCH_ALL_PRODUCT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_PRODUCT_SUCCESS, "FETCH_ALL_PRODUCT_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_PRODUCT, "FILTER_PRODUCT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_PRODUCT, "GET_ALL_PRODUCT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_PRODUCT, "GET_UNSELECTED_ALL_PRODUCT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_PRODUCT_REQUEST_CLOSE, "HANDLE_PRODUCT_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_PRODUCT_LOADER, "HIDE_PRODUCT_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_PRODUCT_LOADER, "SHOW_PRODUCT_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_PRODUCT, "ON_ADD_PRODUCT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_EDIT_PRODUCT, "ON_EDIT_PRODUCT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SET_PRODUCT, "SET_PRODUCT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_PRODUCT_SELECT, "ON_ALL_PRODUCT_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PRODUCT_CLOSE, "ON_PRODUCT_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PRODUCT_SELECT, "ON_PRODUCT_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_PRODUCT, "ON_DELETE_PRODUCT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_PRODUCT_SUCCESS, "ON_DELETE_PRODUCT_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_SELECTED_PRODUCT, "ON_FILTER_SELECTED_PRODUCT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_PRODUCT_OPTION_SELECT, "ON_FILTER_PRODUCT_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_PRODUCT, "ON_SAVE_PRODUCT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_PRODUCT_SUCCESS, "ON_SAVE_PRODUCT_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_PRODUCT_DRAWER, "ON_TOGGLE_PRODUCT_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_PRODUCT_MESSAGE, "SHOW_PRODUCT_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_PRODUCT, "UPDATE_SEARCH_PRODUCT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FETCH_SELECT_VALUESTREAM_DATA, "ON_FETCH_SELECT_VALUESTREAM_DATA", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FETCH_SELECT_VALUESTREAM_DATA_SUCCESS, "ON_FETCH_SELECT_VALUESTREAM_DATA_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PRODUCT_VALUESTREAM_UPDATE, "ON_PRODUCT_VALUESTREAM_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_TEAM, "ADD_FAVOURITE_TEAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_TEAM_SUCCESS, "ADD_FAVOURITE_TEAM_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_TEAM, "FETCH_TEAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_TEAM_SUCCESS, "FETCH_TEAM_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_TEAM, "FETCH_ALL_TEAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_TEAM_SUCCESS, "FETCH_ALL_TEAM_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_TEAM, "FILTER_TEAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_TEAM, "GET_ALL_TEAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_TEAM, "GET_UNSELECTED_ALL_TEAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_TEAM_REQUEST_CLOSE, "HANDLE_TEAM_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_TEAM_LOADER, "HIDE_TEAM_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_TEAM_LOADER, "SHOW_TEAM_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_TEAM, "ON_ADD_TEAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_EDIT_TEAM, "ON_EDIT_TEAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SET_TEAM, "SET_TEAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_TEAM_SELECT, "ON_ALL_TEAM_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TEAM_CLOSE, "ON_TEAM_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TEAM_SELECT, "ON_TEAM_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_TEAM, "ON_DELETE_TEAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_TEAM_SUCCESS, "ON_DELETE_TEAM_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_SELECTED_TEAM, "ON_FILTER_SELECTED_TEAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_TEAM_OPTION_SELECT, "ON_FILTER_TEAM_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_TEAM, "ON_SAVE_TEAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_TEAM_SUCCESS, "ON_SAVE_TEAM_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_TEAM_DRAWER, "ON_TOGGLE_TEAM_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_TEAM_MESSAGE, "SHOW_TEAM_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_TEAM, "UPDATE_SEARCH_TEAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FETCH_SELECT_MEMBER_DATA, "ON_FETCH_SELECT_MEMBER_DATA", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FETCH_SELECT_MEMBER_DATA_SUCCESS, "ON_FETCH_SELECT_MEMBER_DATA_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TEAM_MEMBER_UPDATE, "ON_TEAM_MEMBER_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_MEMBER, "ADD_FAVOURITE_MEMBER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_MEMBER_SUCCESS, "ADD_FAVOURITE_MEMBER_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_MEMBER, "FETCH_MEMBER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_MEMBER_SUCCESS, "FETCH_MEMBER_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_MEMBER, "FETCH_ALL_MEMBER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_MEMBER_SUCCESS, "FETCH_ALL_MEMBER_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_MEMBER, "FILTER_MEMBER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_MEMBER, "GET_ALL_MEMBER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_MEMBER, "GET_UNSELECTED_ALL_MEMBER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_MEMBER_REQUEST_CLOSE, "HANDLE_MEMBER_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_MEMBER_LOADER, "HIDE_MEMBER_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_MEMBER_LOADER, "SHOW_MEMBER_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_MEMBER, "ON_ADD_MEMBER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_EDIT_MEMBER, "ON_EDIT_MEMBER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_MEMBER_SELECT, "ON_ALL_MEMBER_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_MEMBER_CLOSE, "ON_MEMBER_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_MEMBER_SELECT, "ON_MEMBER_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_MEMBER, "ON_DELETE_MEMBER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_MEMBER_SUCCESS, "ON_DELETE_MEMBER_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_SELECTED_MEMBER, "ON_FILTER_SELECTED_MEMBER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_MEMBER_OPTION_SELECT, "ON_FILTER_MEMBER_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_MEMBER, "ON_SAVE_MEMBER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_MEMBER_SUCCESS, "ON_SAVE_MEMBER_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_MEMBER_DRAWER, "ON_TOGGLE_MEMBER_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_MEMBER_MESSAGE, "SHOW_MEMBER_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_MEMBER, "UPDATE_SEARCH_MEMBER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_VALUE_STREAM, "ADD_FAVOURITE_VALUE_STREAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_VALUE_STREAM_SUCCESS, "ADD_FAVOURITE_VALUE_STREAM_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_VALUE_STREAM, "FETCH_VALUE_STREAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_VALUE_STREAM_SUCCESS, "FETCH_VALUE_STREAM_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_VALUE_STREAM, "FETCH_ALL_VALUE_STREAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_VALUE_STREAM_SUCCESS, "FETCH_ALL_VALUE_STREAM_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_VALUE_STREAM, "FILTER_VALUE_STREAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_VALUE_STREAM, "GET_ALL_VALUE_STREAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_VALUE_STREAM, "GET_UNSELECTED_ALL_VALUE_STREAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_VALUE_STREAM_REQUEST_CLOSE, "HANDLE_VALUE_STREAM_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_VALUE_STREAM_LOADER, "HIDE_VALUE_STREAM_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_VALUE_STREAM_LOADER, "SHOW_VALUE_STREAM_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_VALUE_STREAM, "ON_ADD_VALUE_STREAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_EDIT_VALUE_STREAM, "ON_EDIT_VALUE_STREAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SET_VALUE_STREAM, "SET_VALUE_STREAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_VALUE_STREAM_SELECT, "ON_ALL_VALUE_STREAM_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_VALUE_STREAM_CLOSE, "ON_VALUE_STREAM_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_VALUE_STREAM_SELECT, "ON_VALUE_STREAM_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_VALUE_STREAM, "ON_DELETE_VALUE_STREAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_VALUE_STREAM_SUCCESS, "ON_DELETE_VALUE_STREAM_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_SELECTED_VALUE_STREAM, "ON_FILTER_SELECTED_VALUE_STREAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_VALUE_STREAM_OPTION_SELECT, "ON_FILTER_VALUE_STREAM_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_VALUE_STREAM, "ON_SAVE_VALUE_STREAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_VALUE_STREAM_SUCCESS, "ON_SAVE_VALUE_STREAM_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_VALUE_STREAM_DRAWER, "ON_TOGGLE_VALUE_STREAM_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_VALUE_STREAM_MESSAGE, "SHOW_VALUE_STREAM_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_VALUE_STREAM, "UPDATE_SEARCH_VALUE_STREAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FETCH_SELECT_TEAM_DATA, "ON_FETCH_SELECT_TEAM_DATA", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FETCH_SELECT_TEAM_DATA_SUCCESS, "ON_FETCH_SELECT_TEAM_DATA_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_VALUE_STREAM_TEAM_UPDATE, "ON_VALUE_STREAM_TEAM_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_FEATURE, "ADD_FAVOURITE_FEATURE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_FEATURE_SUCCESS, "ADD_FAVOURITE_FEATURE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_FEATURE, "FETCH_FEATURE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_FEATURE_SUCCESS, "FETCH_FEATURE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_FEATURE, "FETCH_ALL_FEATURE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_FEATURE_SUCCESS, "FETCH_ALL_FEATURE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_FEATURE, "FILTER_FEATURE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_FEATURE, "GET_ALL_FEATURE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_FEATURE, "GET_UNSELECTED_ALL_FEATURE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_FEATURE_REQUEST_CLOSE, "HANDLE_FEATURE_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_FEATURE_LOADER, "HIDE_FEATURE_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_FEATURE_LOADER, "SHOW_FEATURE_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_FEATURE, "ON_ADD_FEATURE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_EDIT_FEATURE, "ON_EDIT_FEATURE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_FEATURE_SELECT, "ON_ALL_FEATURE_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FEATURE_CLOSE, "ON_FEATURE_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FEATURE_SELECT, "ON_FEATURE_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_FEATURE, "ON_DELETE_FEATURE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_FEATURE_SUCCESS, "ON_DELETE_FEATURE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_SELECTED_FEATURE, "ON_FILTER_SELECTED_FEATURE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_FEATURE_OPTION_SELECT, "ON_FILTER_FEATURE_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_FEATURE, "ON_SAVE_FEATURE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_FEATURE_SUCCESS, "ON_SAVE_FEATURE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_FEATURE_DRAWER, "ON_TOGGLE_FEATURE_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_FEATURE_MESSAGE, "SHOW_FEATURE_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_FEATURE, "UPDATE_SEARCH_FEATURE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SET_FEATURE, "SET_FEATURE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FEATURE_INWARD_DEPENDENCY_UPDATE, "ON_FEATURE_INWARD_DEPENDENCY_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FEATURE_OUTWARD_DEPENDENCY_UPDATE, "ON_FEATURE_OUTWARD_DEPENDENCY_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FEATURE_DEPENDENCY_UPDATE_SUCCESS, "ON_FEATURE_DEPENDENCY_UPDATE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FETCH_SELECT_FEATURE_INWARD_DEPENDENCIES, "ON_FETCH_SELECT_FEATURE_INWARD_DEPENDENCIES", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FETCH_SELECT_FEATURE_OUTWARD_DEPENDENCIES, "ON_FETCH_SELECT_FEATURE_OUTWARD_DEPENDENCIES", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FETCH_SELECT_FEATURE_DEPENDENCIES_SUCCESS, "ON_FETCH_SELECT_FEATURE_DEPENDENCIES_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SELECT_PORTFOLIO, "SELECT_PORTFOLIO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PORTFOLIO_DASHBOARD, "ON_PORTFOLIO_DASHBOARD", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PORTFOLIO_DASHBOARD_SUCCESS, "ON_PORTFOLIO_DASHBOARD_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_PORTFOLIO, "ADD_FAVOURITE_PORTFOLIO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_PORTFOLIO_SUCCESS, "ADD_FAVOURITE_PORTFOLIO_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_PORTFOLIO, "FETCH_PORTFOLIO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_PORTFOLIO_SUCCESS, "FETCH_PORTFOLIO_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_PORTFOLIO, "FETCH_ALL_PORTFOLIO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_PORTFOLIO_SUCCESS, "FETCH_ALL_PORTFOLIO_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_PORTFOLIO, "FILTER_PORTFOLIO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_PORTFOLIO, "GET_ALL_PORTFOLIO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_PORTFOLIO, "GET_UNSELECTED_ALL_PORTFOLIO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_PORTFOLIO_REQUEST_CLOSE, "HANDLE_PORTFOLIO_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_PORTFOLIO_LOADER, "HIDE_PORTFOLIO_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_PORTFOLIO_LOADER, "SHOW_PORTFOLIO_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_PORTFOLIO, "ON_ADD_PORTFOLIO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_EDIT_PORTFOLIO, "ON_EDIT_PORTFOLIO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_PORTFOLIO_SELECT, "ON_ALL_PORTFOLIO_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PORTFOLIO_CLOSE, "ON_PORTFOLIO_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PORTFOLIO_SELECT, "ON_PORTFOLIO_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_PORTFOLIO, "ON_DELETE_PORTFOLIO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_PORTFOLIO_SUCCESS, "ON_DELETE_PORTFOLIO_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_SELECTED_PORTFOLIO, "ON_FILTER_SELECTED_PORTFOLIO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_PORTFOLIO_OPTION_SELECT, "ON_FILTER_PORTFOLIO_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_PORTFOLIO, "ON_SAVE_PORTFOLIO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_PORTFOLIO_SUCCESS, "ON_SAVE_PORTFOLIO_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_PORTFOLIO_DRAWER, "ON_TOGGLE_PORTFOLIO_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_PORTFOLIO_MESSAGE, "SHOW_PORTFOLIO_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_PORTFOLIO, "UPDATE_SEARCH_PORTFOLIO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_BUSINESS_UNIT, "ADD_FAVOURITE_BUSINESS_UNIT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_BUSINESS_UNIT_SUCCESS, "ADD_FAVOURITE_BUSINESS_UNIT_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_BUSINESS_UNIT, "FETCH_BUSINESS_UNIT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_BUSINESS_UNIT_SUCCESS, "FETCH_BUSINESS_UNIT_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_BUSINESS_UNIT, "FETCH_ALL_BUSINESS_UNIT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_BUSINESS_UNIT_SUCCESS, "FETCH_ALL_BUSINESS_UNIT_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_BUSINESS_UNIT, "FILTER_BUSINESS_UNIT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_BUSINESS_UNIT, "GET_ALL_BUSINESS_UNIT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_BUSINESS_UNIT, "GET_UNSELECTED_ALL_BUSINESS_UNIT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_BUSINESS_UNIT_REQUEST_CLOSE, "HANDLE_BUSINESS_UNIT_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_BUSINESS_UNIT_LOADER, "HIDE_BUSINESS_UNIT_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_BUSINESS_UNIT_LOADER, "SHOW_BUSINESS_UNIT_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_BUSINESS_UNIT, "ON_ADD_BUSINESS_UNIT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_BUSINESS_UNIT_SELECT, "ON_ALL_BUSINESS_UNIT_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_BUSINESS_UNIT_CLOSE, "ON_BUSINESS_UNIT_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_BUSINESS_UNIT_SELECT, "ON_BUSINESS_UNIT_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_BUSINESS_UNIT, "ON_DELETE_BUSINESS_UNIT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_BUSINESS_UNIT_SUCCESS, "ON_DELETE_BUSINESS_UNIT_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_SELECTED_BUSINESS_UNIT, "ON_FILTER_SELECTED_BUSINESS_UNIT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_BUSINESS_UNIT_OPTION_SELECT, "ON_FILTER_BUSINESS_UNIT_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_BUSINESS_UNIT, "ON_SAVE_BUSINESS_UNIT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_BUSINESS_UNIT_SUCCESS, "ON_SAVE_BUSINESS_UNIT_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_BUSINESS_UNIT_DRAWER, "ON_TOGGLE_BUSINESS_UNIT_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_BUSINESS_UNIT_MESSAGE, "SHOW_BUSINESS_UNIT_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_BUSINESS_UNIT, "UPDATE_SEARCH_BUSINESS_UNIT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_PROJECT_ISSUE, "ADD_FAVOURITE_PROJECT_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_PROJECT_ISSUE_SUCCESS, "ADD_FAVOURITE_PROJECT_ISSUE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_PROJECT_ISSUE, "FETCH_PROJECT_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_PROJECT_ISSUE_SUCCESS, "FETCH_PROJECT_ISSUE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_PROJECT_ISSUE, "FETCH_ALL_PROJECT_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_PROJECT_ISSUE_SUCCESS, "FETCH_ALL_PROJECT_ISSUE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_PROJECT_ISSUE, "FILTER_PROJECT_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_PROJECT_ISSUE, "GET_ALL_PROJECT_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_PROJECT_ISSUE, "GET_UNSELECTED_ALL_PROJECT_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_PROJECT_ISSUE_REQUEST_CLOSE, "HANDLE_PROJECT_ISSUE_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_PROJECT_ISSUE_LOADER, "HIDE_PROJECT_ISSUE_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_PROJECT_ISSUE_LOADER, "SHOW_PROJECT_ISSUE_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_PROJECT_ISSUE, "ON_ADD_PROJECT_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_JIRA_PROJECT_ISSUE, "ON_ADD_JIRA_PROJECT_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_PROJECT_ISSUE_SELECT, "ON_ALL_PROJECT_ISSUE_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PROJECT_ISSUE_CLOSE, "ON_PROJECT_ISSUE_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PROJECT_ISSUE_SELECT, "ON_PROJECT_ISSUE_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_PROJECT_ISSUE, "ON_DELETE_PROJECT_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_PROJECT_ISSUE_SUCCESS, "ON_DELETE_PROJECT_ISSUE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_SELECTED_PROJECT_ISSUE, "ON_FILTER_SELECTED_PROJECT_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_PROJECT_ISSUE_OPTION_SELECT, "ON_FILTER_PROJECT_ISSUE_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_PROJECT_ISSUE, "ON_SAVE_PROJECT_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_JIRA_PROJECT_ISSUE, "ON_SAVE_JIRA_PROJECT_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_PROJECT_ISSUE_SUCCESS, "ON_SAVE_PROJECT_ISSUE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_PROJECT_ISSUE_DRAWER, "ON_TOGGLE_PROJECT_ISSUE_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_PROJECT_ISSUE_MESSAGE, "SHOW_PROJECT_ISSUE_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_PROJECT_ISSUE, "UPDATE_SEARCH_PROJECT_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_PROJECT_PRIORITY, "ADD_FAVOURITE_PROJECT_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_PROJECT_PRIORITY, "FETCH_PROJECT_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_PROJECT_PRIORITY_SUCCESS, "FETCH_PROJECT_PRIORITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_PROJECT_PRIORITY, "FETCH_ALL_PROJECT_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_PROJECT_PRIORITY_SUCCESS, "FETCH_ALL_PROJECT_PRIORITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_PROJECT_PRIORITY, "FILTER_PROJECT_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_PROJECT_PRIORITY, "GET_ALL_PROJECT_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_PROJECT_PRIORITY, "GET_UNSELECTED_ALL_PROJECT_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_PROJECT_PRIORITY_REQUEST_CLOSE, "HANDLE_PROJECT_PRIORITY_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_PROJECT_PRIORITY_LOADER, "HIDE_PROJECT_PRIORITY_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_PROJECT_PRIORITY_LOADER, "SHOW_PROJECT_PRIORITY_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_PROJECT_PRIORITY, "ON_ADD_PROJECT_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_PROJECT_PRIORITY_SELECT, "ON_ALL_PROJECT_PRIORITY_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PROJECT_PRIORITY_CLOSE, "ON_PROJECT_PRIORITY_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PROJECT_PRIORITY_SELECT, "ON_PROJECT_PRIORITY_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_PROJECT_PRIORITY, "ON_DELETE_PROJECT_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_PROJECT_PRIORITY_SUCCESS, "ON_DELETE_PROJECT_PRIORITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_SELECTED_PROJECT_PRIORITY, "ON_DELETE_SELECTED_PROJECT_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_PROJECT_PRIORITY_OPTION_SELECT, "ON_FILTER_PROJECT_PRIORITY_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_PROJECT_PRIORITY, "ON_SAVE_PROJECT_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_PROJECT_PRIORITY_SUCCESS, "ON_SAVE_PROJECT_PRIORITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_PROJECT_PRIORITY_DRAWER, "ON_TOGGLE_PROJECT_PRIORITY_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_PROJECT_PRIORITY_MESSAGE, "SHOW_PROJECT_PRIORITY_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_PROJECT_PRIORITY, "UPDATE_SEARCH_PROJECT_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_PROJECT, "ADD_FAVOURITE_PROJECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_PROJECT_SUCCESS, "ADD_FAVOURITE_PROJECT_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_PROJECT, "FETCH_PROJECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_PROJECT_SUCCESS, "FETCH_PROJECT_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_PROJECT, "FETCH_ALL_PROJECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_PROJECT_SUCCESS, "FETCH_ALL_PROJECT_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_PROJECT, "FILTER_PROJECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_PROJECT, "GET_ALL_PROJECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_PROJECT, "GET_UNSELECTED_ALL_PROJECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_PROJECT_REQUEST_CLOSE, "HANDLE_PROJECT_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_PROJECT_LOADER, "HIDE_PROJECT_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_PROJECT_LOADER, "SHOW_PROJECT_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_PROJECT, "ON_ADD_PROJECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_EDIT_PROJECT, "ON_EDIT_PROJECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_PROJECT_SELECT, "ON_ALL_PROJECT_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PROJECT_CLOSE, "ON_PROJECT_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PROJECT_SELECT, "ON_PROJECT_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_PROJECT, "ON_DELETE_PROJECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_PROJECT_SUCCESS, "ON_DELETE_PROJECT_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_SELECTED_PROJECT, "ON_DELETE_SELECTED_PROJECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_PROJECT_OPTION_SELECT, "ON_FILTER_PROJECT_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_PROJECT, "ON_SAVE_PROJECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_UPDATE_PROJECT_PRIORITIES, "ON_UPDATE_PROJECT_PRIORITIES", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_PROJECT_SUCCESS, "ON_SAVE_PROJECT_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_PROJECT_DRAWER, "ON_TOGGLE_PROJECT_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_PROJECT_MESSAGE, "SHOW_PROJECT_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_PROJECT, "UPDATE_SEARCH_PROJECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PROJECT_COST_PRIORITIES_DASHBOARD, "ON_PROJECT_COST_PRIORITIES_DASHBOARD", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_GLOBAL_PROJECT_COST_PRIORITIES_DASHBOARD, "ON_GLOBAL_PROJECT_COST_PRIORITIES_DASHBOARD", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_GLOBAL_PROJECT_BUSINESS_PRIORITIES_DASHBOARD, "ON_GLOBAL_PROJECT_BUSINESS_PRIORITIES_DASHBOARD", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PROJECT_BUSINESS_PRIORITIES_DASHBOARD, "ON_PROJECT_BUSINESS_PRIORITIES_DASHBOARD", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_IMPORT_PROJECTS, "FETCH_IMPORT_PROJECTS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_IMPORT_PROJECTS_SUCCESS, "FETCH_IMPORT_PROJECTS_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_IMPORT_PROJECTS_LOADER, "SHOW_IMPORT_PROJECTS_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_IMPORT_PROJECTS_LOADER, "HIDE_IMPORT_PROJECTS_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_IMPORT_PROJECTS, "ON_IMPORT_PROJECTS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_IMPORT_PROJECTS_SUCCESS, "ON_IMPORT_PROJECTS_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PROJECT_ISSUES_DASHBOARD, "ON_PROJECT_ISSUES_DASHBOARD", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_PROJECT_ISSUE_CACHE_SUCCESS, "ON_SAVE_PROJECT_ISSUE_CACHE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_PROJECT_CACHE_SUCCESS, "ON_SAVE_PROJECT_CACHE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SET_PROJECT_ISSUE, "SET_PROJECT_ISSUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SET_PROJECT, "SET_PROJECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(TOGGLE_COLLAPSED_NAV, "TOGGLE_COLLAPSED_NAV", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(DRAWER_TYPE, "DRAWER_TYPE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FIXED_DRAWER, "FIXED_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(COLLAPSED_DRAWER, "COLLAPSED_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(MINI_DRAWER, "MINI_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(THEME_COLOR, "THEME_COLOR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(DARK_THEME, "DARK_THEME", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(WINDOW_WIDTH, "WINDOW_WIDTH", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(WINDOW_HEIGHT, "WINDOW_HEIGHT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SWITCH_LANGUAGE, "SWITCH_LANGUAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(CHANGE_DIRECTION, "CHANGE_DIRECTION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(CHANGE_NAVIGATION_STYLE, "CHANGE_NAVIGATION_STYLE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HORIZONTAL_NAVIGATION, "HORIZONTAL_NAVIGATION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(VERTICAL_NAVIGATION, "VERTICAL_NAVIGATION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HORIZONTAL_MENU_POSITION, "HORIZONTAL_MENU_POSITION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ABOVE_THE_HEADER, "ABOVE_THE_HEADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(INSIDE_THE_HEADER, "INSIDE_THE_HEADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(BELOW_THE_HEADER, "BELOW_THE_HEADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(COLOR_OPTIONS_MODAL, "COLOR_OPTIONS_MODAL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(USER_INFO_MODAL, "USER_INFO_MODAL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(CLEAR_SESSION, "CLEAR_SESSION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(CLEAR_SELECTED_OBJECTS, "CLEAR_SELECTED_OBJECTS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_MESSAGE, "SHOW_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_MESSAGE, "HIDE_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SHOW_LOADER, "ON_SHOW_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_HIDE_LOADER, "ON_HIDE_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_DRAWER, "ON_TOGGLE_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_REQUEST_CLOSE, "HANDLE_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE, "ADD_FAVOURITE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_CONTACT, "FETCH_ALL_CONTACT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_CONTACT_SUCCESS, "FETCH_ALL_CONTACT_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_CONTACT_SELECT, "ON_CONTACT_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_CONTACT, "ON_ADD_CONTACT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_CONTACT_CLOSE, "ON_CONTACT_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_OPTION_SELECT, "ON_FILTER_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_CONTACT, "ON_SAVE_CONTACT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_CONTACT, "ON_DELETE_CONTACT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_SELECTED_CONTACT, "ON_DELETE_SELECTED_CONTACT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_CONTACT, "FILTER_CONTACT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_CONTACT, "GET_ALL_CONTACT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_CONTACT, "GET_UNSELECTED_ALL_CONTACT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_CONTACT_SELECT, "ON_ALL_CONTACT_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_USER, "UPDATE_SEARCH_USER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_CONTACT_LOADER, "HIDE_CONTACT_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SIGNUP_USER, "SIGNUP_USER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SIGNUP_USER_SUCCESS, "SIGNUP_USER_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SIGNIN_GOOGLE_USER, "SIGNIN_GOOGLE_USER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SIGNIN_GOOGLE_USER_SUCCESS, "SIGNIN_GOOGLE_USER_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SIGNIN_FACEBOOK_USER, "SIGNIN_FACEBOOK_USER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SIGNIN_FACEBOOK_USER_SUCCESS, "SIGNIN_FACEBOOK_USER_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SIGNIN_TWITTER_USER, "SIGNIN_TWITTER_USER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SIGNIN_TWITTER_USER_SUCCESS, "SIGNIN_TWITTER_USER_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SIGNIN_GITHUB_USER, "SIGNIN_GITHUB_USER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SIGNIN_GITHUB_USER_SUCCESS, "SIGNIN_GITHUB_USER_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SIGNIN_USER, "SIGNIN_USER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SIGNIN_USER_PASSWORDLESS, "SIGNIN_USER_PASSWORDLESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SIGNIN_USER_SUCCESS, "SIGNIN_USER_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SIGNOUT_USER, "SIGNOUT_USER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SIGNOUT_USER_SUCCESS, "SIGNOUT_USER_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(INIT_URL, "INIT_URL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(IDENTITY_SUCCESS, "IDENTITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(REQUEST_SIGNIN_ACCESS_CODE, "REQUEST_SIGNIN_ACCESS_CODE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(REQUEST_SIGNIN_ACCESS_CODE_SUCCESS, "REQUEST_SIGNIN_ACCESS_CODE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_CHAT_USER, "FETCH_ALL_CHAT_USER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_CHAT_USER_CONVERSATION, "FETCH_ALL_CHAT_USER_CONVERSATION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_CHAT_USER_SUCCESS, "FETCH_ALL_CHAT_USER_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_CHAT_USER_CONVERSATION_SUCCESS, "FETCH_ALL_CHAT_USER_CONVERSATION_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_USERS, "FILTER_USERS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SELECT_USER, "ON_SELECT_USER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(USER_INFO_STATE, "USER_INFO_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SUBMIT_COMMENT, "SUBMIT_COMMENT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_MESSAGE_VALUE, "UPDATE_MESSAGE_VALUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_CHAT_USER, "UPDATE_SEARCH_CHAT_USER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_LABEL, "ADD_LABEL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_MAIL, "GET_ALL_MAIL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_MAIL, "FETCH_ALL_MAIL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_MAIL_SUCCESS, "FETCH_ALL_MAIL_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_IMPORTANT_MAIL, "GET_IMPORTANT_MAIL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_NAV_FILTERS, "GET_NAV_FILTERS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_NAV_LABELS, "GET_NAV_LABELS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_NAV_FOLDER, "GET_NAV_FOLDER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_READ_MAIL, "GET_READ_MAIL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_STARRED_MAIL, "GET_STARRED_MAIL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNIMPORTANT_MAIL, "GET_UNIMPORTANT_MAIL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNREAD_MAIL, "GET_UNREAD_MAIL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_MAIL, "GET_UNSELECTED_ALL_MAIL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSTARRED_MAIL, "GET_UNSTARRED_MAIL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_MAIL_SELECT, "ON_ALL_MAIL_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FOLDER_MENU_ITEM_SELECT, "ON_FOLDER_MENU_ITEM_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FOLDER_SELECT, "ON_FOLDER_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_IMPORTANT_SELECT, "ON_IMPORTANT_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_LABEL_MENU_ITEM_SELECT, "ON_LABEL_MENU_ITEM_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_MARK_AS_START, "GET_MARK_AS_START", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_LABEL_SELECT, "ON_LABEL_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_MAIL_CHECKED, "ON_MAIL_CHECKED", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_MAIL_SELECT, "ON_MAIL_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_MAIL_SEND, "ON_MAIL_SEND", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_OPTION_MENU_ITEM_SELECT, "ON_OPTION_MENU_ITEM_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_OPTION_MENU_SELECT, "ON_OPTION_MENU_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_START_SELECT, "ON_START_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SEARCH_MAIL, "SEARCH_MAIL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_MAIL, "ON_DELETE_MAIL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SET_CURRENT_MAIL_NULL, "SET_CURRENT_MAIL_NULL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_COMPOSE_MAIL, "ON_COMPOSE_MAIL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SORTEND, "ON_SORTEND", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_TODO, "FETCH_ALL_TODO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_TODO_SUCCESS, "FETCH_ALL_TODO_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_TODO_CONVERSATION, "FETCH_ALL_TODO_CONVERSATION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_TODO_CONVERSATION_SUCCESS, "FETCH_ALL_TODO_CONVERSATION_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SELECT_ALL_TODO, "SELECT_ALL_TODO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_TODO, "GET_ALL_TODO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_TODO, "GET_UNSELECTED_ALL_TODO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_STARRED_TODO, "GET_STARRED_TODO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSTARRED_TODO, "GET_UNSTARRED_TODO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_IMPORTANT_TODO, "GET_IMPORTANT_TODO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNIMPORTANT_TODO, "GET_UNIMPORTANT_TODO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_LABEL_UPDATE, "ON_LABEL_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TODO_UPDATE, "ON_TODO_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_TODO, "ON_DELETE_TODO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SEARCH_TODO, "SEARCH_TODO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_TODOS, "SHOW_TODOS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_TODO_CONVERSATION, "GET_TODO_CONVERSATION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TODO_CHECKED, "ON_TODO_CHECKED", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TODO_ADD, "ON_TODO_ADD", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TODO_SELECT, "ON_TODO_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SET_CURRENT_TODO_NULL, "SET_CURRENT_TODO_NULL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(REMOVE_LABEL, "REMOVE_LABEL", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH, "UPDATE_SEARCH", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_ORG_MESSAGE, "SHOW_ORG_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_ORG_DRAWER, "ON_TOGGLE_ORG_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_ORG_REQUEST_CLOSE, "HANDLE_ORG_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_ORG_OPTION_SELECT, "ON_FILTER_ORG_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_ORG_LOADER, "HIDE_ORG_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_ORG_LOADER, "SHOW_ORG_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_ORG, "ADD_FAVOURITE_ORG", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ORG, "FETCH_ORG", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ORG_SUCCESS, "FETCH_ORG_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ORGS_SELECT_ORG, "FETCH_ORGS_SELECT_ORG", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ORG, "FETCH_ALL_ORG", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ORG_SUCCESS, "FETCH_ALL_ORG_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ORG_SELECT, "ON_ORG_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_ORG, "ON_ADD_ORG", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ORG_CLOSE, "ON_ORG_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_ORG, "ON_SAVE_ORG", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_ORG_SUCCESS, "ON_SAVE_ORG_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_ORG, "ON_DELETE_ORG", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_SELECTED_ORG, "ON_DELETE_SELECTED_ORG", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_ORG, "FILTER_ORG", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_ORG, "GET_ALL_ORG", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_ORG, "GET_UNSELECTED_ALL_ORG", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_ORG_SELECT, "ON_ALL_ORG_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_ORG, "UPDATE_SEARCH_ORG", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_EMP_DASHBOARD, "ON_EMP_DASHBOARD", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ORG_SURVEY_DASHBOARD, "ON_ORG_SURVEY_DASHBOARD", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ORG_DASHBOARD, "ON_ORG_DASHBOARD", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ORG_DASHBOARD_SUCCESS, "ON_ORG_DASHBOARD_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PROJECT_DASHBOARD, "ON_PROJECT_DASHBOARD", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_IMPERSONATE_DASHBOARD, "ON_IMPERSONATE_DASHBOARD", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_PROJECT_PRIORITY_DASHBOARD, "ON_PROJECT_PRIORITY_DASHBOARD", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ORG_STATISTICS, "FETCH_ORG_STATISTICS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ORG_STATISTICS_SUCCESS, "FETCH_ORG_STATISTICS_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_EMP_MESSAGE, "SHOW_EMP_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_EMP_DRAWER, "ON_TOGGLE_EMP_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_EMP_REQUEST_CLOSE, "HANDLE_EMP_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_EMP_OPTION_SELECT, "ON_FILTER_EMP_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_EMP_LOADER, "HIDE_EMP_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_EMP_DASHBOARD_LOADER, "SHOW_EMP_DASHBOARD_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_EMP_DASHBOARD_LOADER, "HIDE_EMP_DASHBOARD_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_EMP_LOADER, "SHOW_EMP_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_EMP, "ADD_FAVOURITE_EMP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_EMP_SUCCESS, "ADD_FAVOURITE_EMP_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_EMP, "FETCH_ALL_EMP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_EMP_SUCCESS, "FETCH_ALL_EMP_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_EMP_SELECT, "ON_EMP_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_EMP, "ON_ADD_EMP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_EMP_CLOSE, "ON_EMP_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_EMP, "ON_SAVE_EMP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_EMP_SUCCESS, "ON_SAVE_EMP_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_EMP, "ON_DELETE_EMP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_SELECTED_EMP, "ON_DELETE_SELECTED_EMP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_EMP, "FILTER_EMP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_EMP, "GET_ALL_EMP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_EMP, "GET_UNSELECTED_ALL_EMP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_EMP_SELECT, "ON_ALL_EMP_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_EMP, "UPDATE_SEARCH_EMP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_EMP_SURVEY_ANSWERS, "FETCH_EMP_SURVEY_ANSWERS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_EMP_SURVEY_ANSWERS_SUCCESS, "FETCH_EMP_SURVEY_ANSWERS_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SAVE_EMP_SURVEY_ANSWERS, "SAVE_EMP_SURVEY_ANSWERS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SAVE_EMP_SURVEY_ANSWERS_SUCCESS, "SAVE_EMP_SURVEY_ANSWERS_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_NOTIFICATIONS, "FETCH_NOTIFICATIONS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_NOTIFICATIONS_SUCCESS, "FETCH_NOTIFICATIONS_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_ORG_SURVEY_MESSAGE, "SHOW_ORG_SURVEY_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_ORG_SURVEY_DRAWER, "ON_TOGGLE_ORG_SURVEY_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_ORG_SURVEY_REQUEST_CLOSE, "HANDLE_ORG_SURVEY_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_ORG_SURVEY_OPTION_SELECT, "ON_FILTER_ORG_SURVEY_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_ORG_SURVEY_LOADER, "HIDE_ORG_SURVEY_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_ORG_SURVEY_LOADER, "SHOW_ORG_SURVEY_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_ORG_SURVEY, "ADD_FAVOURITE_ORG_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ORG_SURVEY, "FETCH_ALL_ORG_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ORG_SURVEY_SUCCESS, "FETCH_ALL_ORG_SURVEY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ORG_SURVEY_SELECT, "ON_ORG_SURVEY_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_ORG_SURVEY, "ON_ADD_ORG_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ORG_SURVEY_CLOSE, "ON_ORG_SURVEY_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_ORG_SURVEY, "ON_SAVE_ORG_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_ORG_SURVEY_SUCCESS, "ON_SAVE_ORG_SURVEY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_ORG_SURVEY, "ON_DELETE_ORG_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_SELECTED_ORG_SURVEY, "ON_DELETE_SELECTED_ORG_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_ORG_SURVEY, "FILTER_ORG_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_ORG_SURVEY, "GET_ALL_ORG_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_ORG_SURVEY, "GET_UNSELECTED_ALL_ORG_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_ORG_SURVEY_SELECT, "ON_ALL_ORG_SURVEY_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_ORG_SURVEY, "UPDATE_SEARCH_ORG_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ORG_SURVEY_QUESTIONS, "ON_ORG_SURVEY_QUESTIONS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ORG_SURVEY_COMPARE_DASHBOARD, "ON_ORG_SURVEY_COMPARE_DASHBOARD", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ORG_SURVEY_COMPARE_SELECT, "ON_ORG_SURVEY_COMPARE_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ORG_SURVEY_COMPARE, "FETCH_ALL_ORG_SURVEY_COMPARE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ORG_SURVEY_COMPARE_SUCCESS, "FETCH_ALL_ORG_SURVEY_COMPARE_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ORG_SURVEY_COMPARE_RADAR_CHART_DATA, "FETCH_ALL_ORG_SURVEY_COMPARE_RADAR_CHART_DATA", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ORG_SURVEY_COMPARE_RADAR_CHART_DATA_SUCCESS, "FETCH_ALL_ORG_SURVEY_COMPARE_RADAR_CHART_DATA_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ORG_SURVEY_COMPARE_DISTRIBUTIONS_CHART_DATA, "FETCH_ALL_ORG_SURVEY_COMPARE_DISTRIBUTIONS_CHART_DATA", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ORG_SURVEY_COMPARE_DISTRIBUTIONS_CHART_DATA_SUCCESS, "FETCH_ALL_ORG_SURVEY_COMPARE_DISTRIBUTIONS_CHART_DATA_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ORG_SURVEY_COMPARE_TOP_RESULTS_CHART_DATA, "FETCH_ALL_ORG_SURVEY_COMPARE_TOP_RESULTS_CHART_DATA", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ORG_SURVEY_COMPARE_TOP_RESULTS_CHART_DATA_SUCCESS, "FETCH_ALL_ORG_SURVEY_COMPARE_TOP_RESULTS_CHART_DATA_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ORG_SURVEY_COMPARE_BOTTOM_RESULTS_CHART_DATA, "FETCH_ALL_ORG_SURVEY_COMPARE_BOTTOM_RESULTS_CHART_DATA", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ORG_SURVEY_COMPARE_BOTTOM_RESULTS_CHART_DATA_SUCCESS, "FETCH_ALL_ORG_SURVEY_COMPARE_BOTTOM_RESULTS_CHART_DATA_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ORG_SURVEY_ENGAGEMENT_REPORT_CHART_DATA, "FETCH_ALL_ORG_SURVEY_ENGAGEMENT_REPORT_CHART_DATA", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_ORG_SURVEY_ENGAGEMENT_REPORT_CHART_DATA_SUCCESS, "FETCH_ALL_ORG_SURVEY_ENGAGEMENT_REPORT_CHART_DATA_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_ORG_SURVEY_ANSWERS, "ON_SAVE_ORG_SURVEY_ANSWERS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_ORG_SURVEY_ANSWERS_SUCCESS, "ON_SAVE_ORG_SURVEY_ANSWERS_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ORG_SURVEY_ANSWERS, "FETCH_ORG_SURVEY_ANSWERS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ORG_SURVEY_ANSWERS_SUCCESS, "FETCH_ORG_SURVEY_ANSWERS_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_ORG_SURVEY_ANSWERS_LOADER, "HIDE_ORG_SURVEY_ANSWERS_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_ORG_SURVEY_ANSWERS_LOADER, "SHOW_ORG_SURVEY_ANSWERS_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_ORG_SURVEY_ANSWERS_MESSAGE, "SHOW_ORG_SURVEY_ANSWERS_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_ORG_SURVEY_ANSWER_MESSAGE_CLOSE, "HANDLE_ORG_SURVEY_ANSWER_MESSAGE_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_SURVEY_MESSAGE, "SHOW_SURVEY_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_SURVEY_DRAWER, "ON_TOGGLE_SURVEY_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_SURVEY_REQUEST_CLOSE, "HANDLE_SURVEY_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_SURVEY_OPTION_SELECT, "ON_FILTER_SURVEY_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_SURVEY_LOADER, "HIDE_SURVEY_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_SURVEY_LOADER, "SHOW_SURVEY_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_SURVEY, "ADD_FAVOURITE_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_SURVEY, "FETCH_ALL_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_SURVEY_SUCCESS, "FETCH_ALL_SURVEY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SURVEY_SELECT, "ON_SURVEY_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_SURVEY, "ON_ADD_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SURVEY_CLOSE, "ON_SURVEY_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_SURVEY, "ON_SAVE_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_SURVEY_SUCCESS, "ON_SAVE_SURVEY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_SURVEY, "ON_DELETE_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_SELECTED_SURVEY, "ON_DELETE_SELECTED_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_SURVEY, "FILTER_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_SURVEY, "GET_ALL_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_SURVEY, "GET_UNSELECTED_ALL_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_SURVEY_SELECT, "ON_ALL_SURVEY_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_SURVEY, "UPDATE_SEARCH_SURVEY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SURVEY_QUESTIONS, "ON_SURVEY_QUESTIONS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_SURVEY_GROUP_MESSAGE, "SHOW_SURVEY_GROUP_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_SURVEY_GROUP_DRAWER, "ON_TOGGLE_SURVEY_GROUP_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_SURVEY_GROUP_REQUEST_CLOSE, "HANDLE_SURVEY_GROUP_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_SURVEY_GROUP_OPTION_SELECT, "ON_FILTER_SURVEY_GROUP_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_SURVEY_GROUP_LOADER, "HIDE_SURVEY_GROUP_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_SURVEY_GROUP_LOADER, "SHOW_SURVEY_GROUP_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_SURVEY_GROUP, "ADD_FAVOURITE_SURVEY_GROUP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_SURVEY_GROUP, "FETCH_ALL_SURVEY_GROUP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_SURVEY_GROUP_SUCCESS, "FETCH_ALL_SURVEY_GROUP_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SURVEY_GROUP_SELECT, "ON_SURVEY_GROUP_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_SURVEY_GROUP, "ON_ADD_SURVEY_GROUP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SURVEY_GROUP_CLOSE, "ON_SURVEY_GROUP_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_SURVEY_GROUP, "ON_SAVE_SURVEY_GROUP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_SURVEY_GROUP_SUCCESS, "ON_SAVE_SURVEY_GROUP_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_SURVEY_GROUP, "ON_DELETE_SURVEY_GROUP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_SELECTED_SURVEY_GROUP, "ON_DELETE_SELECTED_SURVEY_GROUP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_SURVEY_GROUP, "FILTER_SURVEY_GROUP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_SURVEY_GROUP, "GET_ALL_SURVEY_GROUP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_SURVEY_GROUP, "GET_UNSELECTED_ALL_SURVEY_GROUP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_SURVEY_GROUP_SELECT, "ON_ALL_SURVEY_GROUP_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_SURVEY_GROUP, "UPDATE_SEARCH_SURVEY_GROUP", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SURVEY_GROUP_QUESTIONS, "ON_SURVEY_GROUP_QUESTIONS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_SURVEY_QUESTION_MESSAGE, "SHOW_SURVEY_QUESTION_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_SURVEY_QUESTION_SUCCESS, "FETCH_ALL_SURVEY_QUESTION_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_SURVEY_QUESTION, "FETCH_ALL_SURVEY_QUESTION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_SURVEY_QUESTION_LOADER, "HIDE_SURVEY_QUESTION_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_SURVEY_QUESTION_LOADER, "SHOW_SURVEY_QUESTION_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_SURVEY_GROUP_QUESTION_MESSAGE, "SHOW_SURVEY_GROUP_QUESTION_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_SURVEY_GROUP_QUESTION_DRAWER, "ON_TOGGLE_SURVEY_GROUP_QUESTION_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_SURVEY_GROUP_QUESTION_REQUEST_CLOSE, "HANDLE_SURVEY_GROUP_QUESTION_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_SURVEY_GROUP_QUESTION_OPTION_SELECT, "ON_FILTER_SURVEY_GROUP_QUESTION_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_SURVEY_GROUP_QUESTION_LOADER, "HIDE_SURVEY_GROUP_QUESTION_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_SURVEY_GROUP_QUESTION_LOADER, "SHOW_SURVEY_GROUP_QUESTION_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_SURVEY_GROUP_QUESTION, "ADD_FAVOURITE_SURVEY_GROUP_QUESTION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_SURVEY_GROUP_QUESTION, "FETCH_ALL_SURVEY_GROUP_QUESTION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_SURVEY_GROUP_QUESTION_SUCCESS, "FETCH_ALL_SURVEY_GROUP_QUESTION_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SURVEY_GROUP_QUESTION_SELECT, "ON_SURVEY_GROUP_QUESTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_SURVEY_GROUP_QUESTION, "ON_ADD_SURVEY_GROUP_QUESTION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SURVEY_GROUP_QUESTION_CLOSE, "ON_SURVEY_GROUP_QUESTION_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_SURVEY_GROUP_QUESTION, "ON_SAVE_SURVEY_GROUP_QUESTION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_SURVEY_GROUP_QUESTION, "ON_DELETE_SURVEY_GROUP_QUESTION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_SELECTED_SURVEY_GROUP_QUESTION, "ON_DELETE_SELECTED_SURVEY_GROUP_QUESTION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_SURVEY_GROUP_QUESTION, "FILTER_SURVEY_GROUP_QUESTION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_SURVEY_GROUP_QUESTION, "GET_ALL_SURVEY_GROUP_QUESTION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_SURVEY_GROUP_QUESTION, "GET_UNSELECTED_ALL_SURVEY_GROUP_QUESTION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_SURVEY_GROUP_QUESTION_SELECT, "ON_ALL_SURVEY_GROUP_QUESTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_SURVEY_GROUP_QUESTION, "UPDATE_SEARCH_SURVEY_GROUP_QUESTION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_SECURITY, "ADD_FAVOURITE_SECURITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE_SECURITY_SUCCESS, "ADD_FAVOURITE_SECURITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_SECURITY, "FETCH_SECURITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_SECURITY_SUCCESS, "FETCH_SECURITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_SECURITY, "FETCH_ALL_SECURITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FETCH_ALL_SECURITY_SUCCESS, "FETCH_ALL_SECURITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(FILTER_SECURITY, "FILTER_SECURITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_ALL_SECURITY, "GET_ALL_SECURITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_SECURITY, "GET_UNSELECTED_ALL_SECURITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HANDLE_SECURITY_REQUEST_CLOSE, "HANDLE_SECURITY_REQUEST_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(HIDE_SECURITY_LOADER, "HIDE_SECURITY_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_SECURITY_LOADER, "SHOW_SECURITY_LOADER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ADD_SECURITY, "ON_ADD_SECURITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_ALL_SECURITY_SELECT, "ON_ALL_SECURITY_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SECURITY_CLOSE, "ON_SECURITY_CLOSE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SECURITY_SELECT, "ON_SECURITY_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_SECURITY, "ON_DELETE_SECURITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_DELETE_SECURITY_SUCCESS, "ON_DELETE_SECURITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_SELECTED_SECURITY, "ON_FILTER_SELECTED_SECURITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_FILTER_SECURITY_OPTION_SELECT, "ON_FILTER_SECURITY_OPTION_SELECT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_SECURITY, "ON_SAVE_SECURITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_SAVE_SECURITY_SUCCESS, "ON_SAVE_SECURITY_SUCCESS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(ON_TOGGLE_SECURITY_DRAWER, "ON_TOGGLE_SECURITY_DRAWER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(SHOW_SECURITY_MESSAGE, "SHOW_SECURITY_MESSAGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_SECURITY, "UPDATE_SEARCH_SECURITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ActionTypes.js");
}();

;

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getScrollbarWidth"] = getScrollbarWidth;
/* harmony export (immutable) */ __webpack_exports__["setScrollbarWidth"] = setScrollbarWidth;
/* harmony export (immutable) */ __webpack_exports__["isBodyOverflowing"] = isBodyOverflowing;
/* harmony export (immutable) */ __webpack_exports__["getOriginalBodyPadding"] = getOriginalBodyPadding;
/* harmony export (immutable) */ __webpack_exports__["conditionallyUpdateScrollbar"] = conditionallyUpdateScrollbar;
/* harmony export (immutable) */ __webpack_exports__["setGlobalCssModule"] = setGlobalCssModule;
/* harmony export (immutable) */ __webpack_exports__["mapToCssModules"] = mapToCssModules;
/* harmony export (immutable) */ __webpack_exports__["omit"] = omit;
/* harmony export (immutable) */ __webpack_exports__["pick"] = pick;
/* harmony export (immutable) */ __webpack_exports__["warnOnce"] = warnOnce;
/* harmony export (immutable) */ __webpack_exports__["deprecated"] = deprecated;
/* harmony export (immutable) */ __webpack_exports__["DOMElement"] = DOMElement;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "targetPropType", function() { return targetPropType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tagPropType", function() { return tagPropType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TransitionTimeouts", function() { return TransitionTimeouts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TransitionPropTypeKeys", function() { return TransitionPropTypeKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TransitionStatuses", function() { return TransitionStatuses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyCodes", function() { return keyCodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PopperPlacements", function() { return PopperPlacements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "canUseDOM", function() { return canUseDOM; });
/* harmony export (immutable) */ __webpack_exports__["isReactRefObj"] = isReactRefObj;
/* harmony export (immutable) */ __webpack_exports__["findDOMElements"] = findDOMElements;
/* harmony export (immutable) */ __webpack_exports__["isArrayOrNodeList"] = isArrayOrNodeList;
/* harmony export (immutable) */ __webpack_exports__["getTarget"] = getTarget;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultToggleEvents", function() { return defaultToggleEvents; });
/* harmony export (immutable) */ __webpack_exports__["addMultipleEventListeners"] = addMultipleEventListeners;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "focusableElements", function() { return focusableElements; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isfunction__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isfunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isfunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);

 // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/js/src/modal.js#L436-L443

function getScrollbarWidth() {
  var scrollDiv = document.createElement('div'); // .modal-scrollbar-measure styles // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/scss/_modal.scss#L106-L113

  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  scrollDiv.style.width = '50px';
  scrollDiv.style.height = '50px';
  scrollDiv.style.overflow = 'scroll';
  document.body.appendChild(scrollDiv);
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
}
function setScrollbarWidth(padding) {
  document.body.style.paddingRight = padding > 0 ? padding + "px" : null;
}
function isBodyOverflowing() {
  return document.body.clientWidth < window.innerWidth;
}
function getOriginalBodyPadding() {
  var style = window.getComputedStyle(document.body, null);
  return parseInt(style && style.getPropertyValue('padding-right') || 0, 10);
}
function conditionallyUpdateScrollbar() {
  var scrollbarWidth = getScrollbarWidth(); // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.6/js/src/modal.js#L433

  var fixedContent = document.querySelectorAll('.fixed-top, .fixed-bottom, .is-fixed, .sticky-top')[0];
  var bodyPadding = fixedContent ? parseInt(fixedContent.style.paddingRight || 0, 10) : 0;

  if (isBodyOverflowing()) {
    setScrollbarWidth(bodyPadding + scrollbarWidth);
  }
}
var globalCssModule;
function setGlobalCssModule(cssModule) {
  globalCssModule = cssModule;
}
function mapToCssModules(className, cssModule) {
  if (className === void 0) {
    className = '';
  }

  if (cssModule === void 0) {
    cssModule = globalCssModule;
  }

  if (!cssModule) return className;
  return className.split(' ').map(function (c) {
    return cssModule[c] || c;
  }).join(' ');
}
/**
 * Returns a new object with the key/value pairs from `obj` that are not in the array `omitKeys`.
 */

function omit(obj, omitKeys) {
  var result = {};
  Object.keys(obj).forEach(function (key) {
    if (omitKeys.indexOf(key) === -1) {
      result[key] = obj[key];
    }
  });
  return result;
}
/**
 * Returns a filtered copy of an object with only the specified keys.
 */

function pick(obj, keys) {
  var pickKeys = Array.isArray(keys) ? keys : [keys];
  var length = pickKeys.length;
  var key;
  var result = {};

  while (length > 0) {
    length -= 1;
    key = pickKeys[length];
    result[key] = obj[key];
  }

  return result;
}
var warned = {};
function warnOnce(message) {
  if (!warned[message]) {
    /* istanbul ignore else */
    if (typeof console !== 'undefined') {
      console.error(message); // eslint-disable-line no-console
    }

    warned[message] = true;
  }
}
function deprecated(propType, explanation) {
  return function validate(props, propName, componentName) {
    if (props[propName] !== null && typeof props[propName] !== 'undefined') {
      warnOnce("\"" + propName + "\" property of \"" + componentName + "\" has been deprecated.\n" + explanation);
    }

    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    return propType.apply(void 0, [props, propName, componentName].concat(rest));
  };
}
function DOMElement(props, propName, componentName) {
  if (!(props[propName] instanceof Element)) {
    return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`. Expected prop to be an instance of Element. Validation failed.');
  }
}
var targetPropType = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  current: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
})]);
var tagPropType = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  $$typeof: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.symbol,
  render: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  $$typeof: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.symbol,
  render: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
})]))]);
/* eslint key-spacing: ["error", { afterColon: true, align: "value" }] */
// These are all setup to match what is in the bootstrap _variables.scss
// https://github.com/twbs/bootstrap/blob/v4-dev/scss/_variables.scss

var TransitionTimeouts = {
  Fade: 150,
  // $transition-fade
  Collapse: 350,
  // $transition-collapse
  Modal: 300,
  // $modal-transition
  Carousel: 600 // $carousel-transition

}; // Duplicated Transition.propType keys to ensure that Reactstrap builds
// for distribution properly exclude these keys for nested child HTML attributes
// since `react-transition-group` removes propTypes in production builds.

var TransitionPropTypeKeys = ['in', 'mountOnEnter', 'unmountOnExit', 'appear', 'enter', 'exit', 'timeout', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'];
var TransitionStatuses = {
  ENTERING: 'entering',
  ENTERED: 'entered',
  EXITING: 'exiting',
  EXITED: 'exited'
};
var keyCodes = {
  esc: 27,
  space: 32,
  enter: 13,
  tab: 9,
  up: 38,
  down: 40,
  home: 36,
  end: 35,
  n: 78,
  p: 80
};
var PopperPlacements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function isReactRefObj(target) {
  if (target && typeof target === 'object') {
    return 'current' in target;
  }

  return false;
}
function findDOMElements(target) {
  if (isReactRefObj(target)) {
    return target.current;
  }

  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isfunction___default()(target)) {
    return target();
  }

  if (typeof target === 'string' && canUseDOM) {
    var selection = document.querySelectorAll(target);

    if (!selection.length) {
      selection = document.querySelectorAll("#" + target);
    }

    if (!selection.length) {
      throw new Error("The target '" + target + "' could not be identified in the dom, tip: check spelling");
    }

    return selection;
  }

  return target;
}
function isArrayOrNodeList(els) {
  if (els === null) {
    return false;
  }

  return Array.isArray(els) || canUseDOM && typeof els.length === 'number';
}
function getTarget(target) {
  var els = findDOMElements(target);

  if (isArrayOrNodeList(els)) {
    return els[0];
  }

  return els;
}
var defaultToggleEvents = ['touchstart', 'click'];
function addMultipleEventListeners(_els, handler, _events, useCapture) {
  var els = _els;

  if (!isArrayOrNodeList(els)) {
    els = [els];
  }

  var events = _events;

  if (typeof events === 'string') {
    events = events.split(/\s+/);
  }

  if (!isArrayOrNodeList(els) || typeof handler !== 'function' || !Array.isArray(events)) {
    throw new Error("\n      The first argument of this function must be DOM node or an array on DOM nodes or NodeList.\n      The second must be a function.\n      The third is a string or an array of strings that represents DOM events\n    ");
  }

  Array.prototype.forEach.call(events, function (event) {
    Array.prototype.forEach.call(els, function (el) {
      el.addEventListener(event, handler, useCapture);
    });
  });
  return function removeEvents() {
    Array.prototype.forEach.call(events, function (event) {
      Array.prototype.forEach.call(els, function (el) {
        el.removeEventListener(event, handler, useCapture);
      });
    });
  };
}
var focusableElements = ['a[href]', 'area[href]', 'input:not([disabled]):not([type=hidden])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'object', 'embed', '[tabindex]:not(.modal)', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])'];

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Context__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__connect_connect__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hooks_useDispatch__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hooks_useSelector__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hooks_useStore__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_batch__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_reactBatchedUpdates__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_shallowEqual__ = __webpack_require__(484);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ReactReduxContext", function() { return __WEBPACK_IMPORTED_MODULE_2__components_Context__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_3__connect_connect__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "batch", function() { return __WEBPACK_IMPORTED_MODULE_8__utils_reactBatchedUpdates__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useDispatch", function() { return __WEBPACK_IMPORTED_MODULE_4__hooks_useDispatch__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createDispatchHook", function() { return __WEBPACK_IMPORTED_MODULE_4__hooks_useDispatch__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useSelector", function() { return __WEBPACK_IMPORTED_MODULE_5__hooks_useSelector__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createSelectorHook", function() { return __WEBPACK_IMPORTED_MODULE_5__hooks_useSelector__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useStore", function() { return __WEBPACK_IMPORTED_MODULE_6__hooks_useStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStoreHook", function() { return __WEBPACK_IMPORTED_MODULE_6__hooks_useStore__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "shallowEqual", function() { return __WEBPACK_IMPORTED_MODULE_9__utils_shallowEqual__["a"]; });










Object(__WEBPACK_IMPORTED_MODULE_7__utils_batch__["b" /* setBatch */])(__WEBPACK_IMPORTED_MODULE_8__utils_reactBatchedUpdates__["a" /* unstable_batchedUpdates */]);


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PRESENTATION_ATTRIBUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EVENT_ATTRIBUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SCALE_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LEGEND_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TOOLTIP_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return findAllByType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return findChildByType; });
/* unused harmony export withoutType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getPresentationAttributes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return filterEventAttributes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return filterEventsOfChild; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return validateWidthHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return isSsr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return filterSvgElements; });
/* unused harmony export isSingleChildEqual */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return isChildrenEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return renderByOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getReactEventByType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return parseChildIndex; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isObject__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isArray__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DataUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ShallowEqual__ = __webpack_require__(278);






function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var PRESENTATION_ATTRIBUTES = {
  'aria-current': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  // state
  'aria-details': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-disabled': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  // state
  'aria-hidden': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  // state
  'aria-invalid': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  // state
  'aria-keyshortcuts': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-label': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-roledescription': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  // Widget Attributes
  'aria-autocomplete': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-checked': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-expanded': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-haspopup': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-level': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-modal': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-multiline': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-multiselectable': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-orientation': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-placeholder': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-pressed': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-readonly': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-required': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-selected': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-sort': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-valuemax': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-valuemin': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-valuenow': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-valuetext': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  // Live Region Attributes
  'aria-atomic': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-busy': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-live': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-relevant': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  // Drag-and-Drop Attributes
  'aria-dropeffect': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-grabbed': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  // Relationship Attributes
  'aria-activedescendant': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-colcount': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-colindex': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-colspan': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-controls': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-describedby': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-errormessage': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-flowto': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-labelledby': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-owns': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-posinset': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-rowcount': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-rowindex': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-rowspan': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-setsize': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  alignmentBaseline: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  angle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  baselineShift: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  clip: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  clipPath: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  clipRule: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  colorInterpolation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  colorInterpolationFilters: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  colorProfile: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  colorRendering: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  cursor: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  direction: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['ltr', 'rtl', 'inherit']),
  display: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  dominantBaseline: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  enableBackground: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  fill: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  fillOpacity: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number]),
  fillRule: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['nonzero', 'evenodd', 'inherit']),
  filter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  floodColor: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  floodOpacity: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number]),
  font: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  fontFamily: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  fontSize: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  fontSizeAdjust: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  fontStretch: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['normal', 'wider', 'narrower', 'ultra-condensed', 'extra-condensed', 'condensed', 'semi-condensed', 'semi-expanded', 'expanded', 'extra-expanded', 'ultra-expanded', 'inherit']),
  fontStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['normal', 'italic', 'oblique', 'inherit']),
  fontVariant: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['normal', 'small-caps', 'inherit']),
  fontWeight: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['normal', 'bold', 'bolder', 'lighter', 100, 200, 300, 400, 500, 600, 700, 800, 900, 'inherit']),
  glyphOrientationHorizontal: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  glyphOrientationVertical: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  imageRendering: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['auto', 'optimizeSpeed', 'optimizeQuality', 'inherit']),
  kerning: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  letterSpacing: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  lightingColor: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  lineHeight: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  markerEnd: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  markerMid: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  markerStart: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  mask: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  opacity: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  overflow: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['visible', 'hidden', 'scroll', 'auto', 'inherit']),
  pointerEvents: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['visiblePainted', 'visibleFill', 'visibleStroke', 'visible', 'painted', 'fill', 'stroke', 'all', 'none', 'inherit']),
  shapeRendering: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['auto', 'optimizeSpeed', 'crispEdges', 'geometricPrecision', 'inherit']),
  stopColor: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  stopOpacity: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  stroke: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  strokeDasharray: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  strokeDashoffset: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  strokeLinecap: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['butt', 'round', 'square', 'inherit']),
  strokeLinejoin: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['miter', 'round', 'bevel', 'inherit']),
  strokeMiterlimit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  strokeOpacity: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  strokeWidth: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  textAnchor: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['start', 'middle', 'end', 'inherit']),
  textDecoration: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['none', 'underline', 'overline', 'line-through', 'blink', 'inherit']),
  textRendering: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['auto', 'optimizeSpeed', 'optimizeLegibility', 'geometricPrecision', 'inherit']),
  unicodeBidi: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['normal', 'embed', 'bidi-override', 'inherit']),
  visibility: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['visible', 'hidden', 'collapse', 'inherit']),
  wordSpacing: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  writingMode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['lr-tb', 'rl-tb', 'tb-rl', 'lr', 'rl', 'tb', 'inherit']),
  transform: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  role: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  focusable: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  tabIndex: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  width: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  dx: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  dy: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  x: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  y: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  r: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  // The radius of Rectangle
  radius: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array])
};
var EVENT_ATTRIBUTES = {
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseUp: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseOver: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseMove: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseOut: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onTouchEnd: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onTouchMove: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onTouchCancel: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};
var REACT_BROWSER_EVENT_MAP = {
  click: 'onClick',
  mousedown: 'onMouseDown',
  mouseup: 'onMouseUp',
  mouseover: 'onMouseOver',
  mousemove: 'onMouseMove',
  mouseout: 'onMouseOut',
  mouseenter: 'onMouseEnter',
  mouseleave: 'onMouseLeave',
  touchcancel: 'onTouchCancel',
  touchend: 'onTouchEnd',
  touchmove: 'onTouchMove',
  touchstart: 'onTouchStart'
};
var SCALE_TYPES = ['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utc', 'sequential', 'threshold'];
var LEGEND_TYPES = ['plainline', 'line', 'square', 'rect', 'circle', 'cross', 'diamond', 'star', 'triangle', 'wye', 'none'];
var TOOLTIP_TYPES = ['none'];
/**
 * Get the display name of a component
 * @param  {Object} Comp Specified Component
 * @return {String}      Display name of Component
 */

var getDisplayName = function getDisplayName(Comp) {
  if (typeof Comp === 'string') {
    return Comp;
  }

  if (!Comp) {
    return '';
  }

  return Comp.displayName || Comp.name || 'Component';
};
/*
 * Find and return all matched children by type. `type` can be a React element class or
 * string
 */

var findAllByType = function findAllByType(children, type) {
  var result = [];
  var types = [];

  if (__WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(type)) {
    types = type.map(function (t) {
      return getDisplayName(t);
    });
  } else {
    types = [getDisplayName(type)];
  }

  __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.forEach(children, function (child) {
    var childType = child && child.type && (child.type.displayName || child.type.name);

    if (types.indexOf(childType) !== -1) {
      result.push(child);
    }
  });
  return result;
};
/*
 * Return the first matched child by type, return null otherwise.
 * `type` can be a React element class or string.
 */

var findChildByType = function findChildByType(children, type) {
  var result = findAllByType(children, type);
  return result && result[0];
};
/*
 * Create a new array of children excluding the ones matched the type
 */

var withoutType = function withoutType(children, type) {
  var newChildren = [];
  var types;

  if (__WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(type)) {
    types = type.map(function (t) {
      return getDisplayName(t);
    });
  } else {
    types = [getDisplayName(type)];
  }

  __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.forEach(children, function (child) {
    if (child && child.type && child.type.displayName && types.indexOf(child.type.displayName) !== -1) {
      return;
    }

    newChildren.push(child);
  });
  return newChildren;
};
/**
 * get all the presentation attribute of svg element
 * @param  {Object} el A react element or the props of a react element
 * @return {Object}    attributes or null
 */

var getPresentationAttributes = function getPresentationAttributes(el) {
  if (!el || __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(el)) {
    return null;
  }

  var props = __WEBPACK_IMPORTED_MODULE_5_react___default.a.isValidElement(el) ? el.props : el;

  if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isObject___default()(props)) {
    return null;
  }

  var out = null; // eslint-disable-next-line no-restricted-syntax

  for (var i in props) {
    if ({}.hasOwnProperty.call(props, i) && PRESENTATION_ATTRIBUTES[i]) {
      if (!out) out = {};
      out[i] = props[i];
    }
  }

  return out;
};

var getEventHandlerOfElement = function getEventHandlerOfElement(originalHandler, props) {
  return function (e) {
    originalHandler(props, e);
    return null;
  };
};
/**
 * get all the event attribute of svg element
 * @param  {Object}   el           A react element or the props of a react element
 * @param  {Function} newHandler   New handler of event
 * @param  {Boolean}  wrapCallback Wrap callback and return more parameters or not
 * @return {Object}                attributes or null
 */


var filterEventAttributes = function filterEventAttributes(el, newHandler) {
  var wrapCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (!el || __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(el)) {
    return null;
  }

  var props = __WEBPACK_IMPORTED_MODULE_5_react___default.a.isValidElement(el) ? el.props : el;

  if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isObject___default()(props)) {
    return null;
  }

  var out = null; // eslint-disable-next-line no-restricted-syntax

  for (var i in props) {
    if ({}.hasOwnProperty.call(props, i) && EVENT_ATTRIBUTES[i]) {
      if (!out) out = {};
      out[i] = newHandler || (wrapCallback ? getEventHandlerOfElement(props[i], props) : props[i]);
    }
  }

  return out;
};

var getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
  return function (e) {
    originalHandler(data, index, e);
    return null;
  };
};

var filterEventsOfChild = function filterEventsOfChild(props, data, index) {
  if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isObject___default()(props)) {
    return null;
  }

  var out = null; // eslint-disable-next-line no-restricted-syntax

  for (var i in props) {
    if ({}.hasOwnProperty.call(props, i) && EVENT_ATTRIBUTES[i] && __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(props[i])) {
      if (!out) out = {};
      out[i] = getEventHandlerOfChild(props[i], data, index);
    }
  }

  return out;
};
/**
 * validate the width and height props of a chart element
 * @param  {Object} el A chart element
 * @return {Boolean}   true If the props width and height are number, and greater than 0
 */

var validateWidthHeight = function validateWidthHeight(el) {
  if (!el || !el.props) {
    return false;
  }

  var _el$props = el.props,
      width = _el$props.width,
      height = _el$props.height;

  if (!Object(__WEBPACK_IMPORTED_MODULE_7__DataUtils__["h" /* isNumber */])(width) || width <= 0 || !Object(__WEBPACK_IMPORTED_MODULE_7__DataUtils__["h" /* isNumber */])(height) || height <= 0) {
    return false;
  }

  return true;
};
var isSsr = function isSsr() {
  return !(typeof window !== 'undefined' && window.document && window.document.createElement && window.setTimeout);
};
var SVG_TAGS = ['a', 'altGlyph', 'altGlyphDef', 'altGlyphItem', 'animate', 'animateColor', 'animateMotion', 'animateTransform', 'circle', 'clipPath', 'color-profile', 'cursor', 'defs', 'desc', 'ellipse', 'feBlend', 'feColormatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence', 'filter', 'font', 'font-face', 'font-face-format', 'font-face-name', 'font-face-url', 'foreignObject', 'g', 'glyph', 'glyphRef', 'hkern', 'image', 'line', 'lineGradient', 'marker', 'mask', 'metadata', 'missing-glyph', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'script', 'set', 'stop', 'style', 'svg', 'switch', 'symbol', 'text', 'textPath', 'title', 'tref', 'tspan', 'use', 'view', 'vkern'];

var isSvgElement = function isSvgElement(child) {
  return child && child.type && __WEBPACK_IMPORTED_MODULE_1_lodash_isString___default()(child.type) && SVG_TAGS.indexOf(child.type) >= 0;
};
/**
 * Filter all the svg elements of children
 * @param  {Array} children The children of a react element
 * @return {Array}          All the svg elements
 */


var filterSvgElements = function filterSvgElements(children) {
  var svgElements = [];
  __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.forEach(children, function (entry) {
    if (entry && entry.type && __WEBPACK_IMPORTED_MODULE_1_lodash_isString___default()(entry.type) && SVG_TAGS.indexOf(entry.type) >= 0) {
      svgElements.push(entry);
    }
  });
  return svgElements;
};
var isSingleChildEqual = function isSingleChildEqual(nextChild, prevChild) {
  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(nextChild) && __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(prevChild)) {
    return true;
  }

  if (!__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(nextChild) && !__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(prevChild)) {
    var _ref = nextChild.props || {},
        nextChildren = _ref.children,
        nextProps = _objectWithoutProperties(_ref, ["children"]);

    var _ref2 = prevChild.props || {},
        prevChildren = _ref2.children,
        prevProps = _objectWithoutProperties(_ref2, ["children"]);

    if (nextChildren && prevChildren) {
      // eslint-disable-next-line no-use-before-define
      return Object(__WEBPACK_IMPORTED_MODULE_8__ShallowEqual__["a" /* shallowEqual */])(nextProps, prevProps) && isChildrenEqual(nextChildren, prevChildren);
    }

    if (!nextChildren && !prevChildren) {
      return Object(__WEBPACK_IMPORTED_MODULE_8__ShallowEqual__["a" /* shallowEqual */])(nextProps, prevProps);
    }

    return false;
  }

  return false;
};
/**
 * Wether props of children changed
 * @param  {Object} nextChildren The latest children
 * @param  {Object} prevChildren The prev children
 * @return {Boolean}             equal or not
 */

var isChildrenEqual = function isChildrenEqual(nextChildren, prevChildren) {
  if (nextChildren === prevChildren) {
    return true;
  }

  if (__WEBPACK_IMPORTED_MODULE_5_react__["Children"].count(nextChildren) !== __WEBPACK_IMPORTED_MODULE_5_react__["Children"].count(prevChildren)) {
    return false;
  }

  var count = __WEBPACK_IMPORTED_MODULE_5_react__["Children"].count(nextChildren);

  if (count === 0) {
    return true;
  }

  if (count === 1) {
    return isSingleChildEqual(__WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(nextChildren) ? nextChildren[0] : nextChildren, __WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(prevChildren) ? prevChildren[0] : prevChildren);
  }

  for (var _i = 0; _i < count; _i++) {
    var nextChild = nextChildren[_i];
    var prevChild = prevChildren[_i];

    if (__WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(nextChild) || __WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(prevChild)) {
      if (!isChildrenEqual(nextChild, prevChild)) {
        return false;
      }
    } else if (!isSingleChildEqual(nextChild, prevChild)) {
      return false;
    }
  }

  return true;
};
var renderByOrder = function renderByOrder(children, renderMap) {
  var elements = [];
  var record = {};
  __WEBPACK_IMPORTED_MODULE_5_react__["Children"].forEach(children, function (child, index) {
    if (child && isSvgElement(child)) {
      elements.push(child);
    } else if (child && renderMap[getDisplayName(child.type)]) {
      var displayName = getDisplayName(child.type);
      var _renderMap$displayNam = renderMap[displayName],
          handler = _renderMap$displayNam.handler,
          once = _renderMap$displayNam.once;

      if (once && !record[displayName] || !once) {
        var results = handler(child, displayName, index);

        if (__WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(results)) {
          elements = [elements].concat(_toConsumableArray(results));
        } else {
          elements.push(results);
        }

        record[displayName] = true;
      }
    }
  });
  return elements;
};
var getReactEventByType = function getReactEventByType(e) {
  var type = e && e.type;

  if (type && REACT_BROWSER_EVENT_MAP[type]) {
    return REACT_BROWSER_EVENT_MAP[type];
  }

  return null;
};
var parseChildIndex = function parseChildIndex(child, children) {
  var result = -1;
  __WEBPACK_IMPORTED_MODULE_5_react__["Children"].forEach(children, function (entry, index) {
    if (entry === child) {
      result = index;
    }
  });
  return result;
};

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserRouter", function() { return BrowserRouter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HashRouter", function() { return HashRouter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return Link; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavLink", function() { return NavLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(495);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Prompt", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "__RouterContext", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "generatePath", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "matchPath", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "useHistory", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "useLocation", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "useParams", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "useRouteMatch", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["o"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tiny_warning__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tiny_invariant__ = __webpack_require__(250);











/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props);
    return _this;
  }

  var _proto = BrowserRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  BrowserRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    forceRefresh: PropTypes.bool,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number
  };

  BrowserRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(HashRouter, _React$Component);

  function HashRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props);
    return _this;
  }

  var _proto = HashRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  HashRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    getUserConfirmation: PropTypes.func,
    hashType: PropTypes.oneOf(["hashbang", "noslash", "slash"])
  };

  HashRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.") : void 0;
  };
}

var resolveToLocation = function resolveToLocation(to, currentLocation) {
  return typeof to === "function" ? to(currentLocation) : to;
};
var normalizeToLocation = function normalizeToLocation(to, currentLocation) {
  return typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, currentLocation) : to;
};

var forwardRefShim = function forwardRefShim(C) {
  return C;
};

var forwardRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef;

if (typeof forwardRef === "undefined") {
  forwardRef = forwardRefShim;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

var LinkAnchor = forwardRef(function (_ref, forwardedRef) {
  var innerRef = _ref.innerRef,
      navigate = _ref.navigate,
      _onClick = _ref.onClick,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["innerRef", "navigate", "onClick"]);

  var target = rest.target;

  var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    onClick: function onClick(event) {
      try {
        if (_onClick) _onClick(event);
      } catch (ex) {
        event.preventDefault();
        throw ex;
      }

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && ( // ignore everything but left clicks
      !target || target === "_self") && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();
          navigate();
        }
    }
  }); // React 15 compat


  if (forwardRefShim !== forwardRef) {
    props.ref = forwardedRef || innerRef;
  } else {
    props.ref = innerRef;
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("a", props);
});

if (false) {
  LinkAnchor.displayName = "LinkAnchor";
}
/**
 * The public API for rendering a history-aware <a>.
 */


var Link = forwardRef(function (_ref2, forwardedRef) {
  var _ref2$component = _ref2.component,
      component = _ref2$component === void 0 ? LinkAnchor : _ref2$component,
      replace = _ref2.replace,
      to = _ref2.to,
      innerRef = _ref2.innerRef,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["component", "replace", "to", "innerRef"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["h" /* __RouterContext */].Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Link> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["default"])(false) : void 0;
    var history = context.history;
    var location = normalizeToLocation(resolveToLocation(to, context.location), context.location);
    var href = location ? history.createHref(location) : "";

    var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      href: href,
      navigate: function navigate() {
        var location = resolveToLocation(to, context.location);
        var method = replace ? history.replace : history.push;
        method(location);
      }
    }); // React 15 compat


    if (forwardRefShim !== forwardRef) {
      props.ref = forwardedRef || innerRef;
    } else {
      props.innerRef = innerRef;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props);
  });
});

if (false) {
  var toType = PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func]);
  var refType = PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]);
  Link.displayName = "Link";
  Link.propTypes = {
    innerRef: refType,
    onClick: PropTypes.func,
    replace: PropTypes.bool,
    target: PropTypes.string,
    to: toType.isRequired
  };
}

var forwardRefShim$1 = function forwardRefShim(C) {
  return C;
};

var forwardRef$1 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef;

if (typeof forwardRef$1 === "undefined") {
  forwardRef$1 = forwardRefShim$1;
}

function joinClassnames() {
  for (var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++) {
    classnames[_key] = arguments[_key];
  }

  return classnames.filter(function (i) {
    return i;
  }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */


var NavLink = forwardRef$1(function (_ref, forwardedRef) {
  var _ref$ariaCurrent = _ref["aria-current"],
      ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent,
      _ref$activeClassName = _ref.activeClassName,
      activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName,
      activeStyle = _ref.activeStyle,
      classNameProp = _ref.className,
      exact = _ref.exact,
      isActiveProp = _ref.isActive,
      locationProp = _ref.location,
      strict = _ref.strict,
      styleProp = _ref.style,
      to = _ref.to,
      innerRef = _ref.innerRef,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["aria-current", "activeClassName", "activeStyle", "className", "exact", "isActive", "location", "strict", "style", "to", "innerRef"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["h" /* __RouterContext */].Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <NavLink> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["default"])(false) : void 0;
    var currentLocation = locationProp || context.location;
    var toLocation = normalizeToLocation(resolveToLocation(to, currentLocation), currentLocation);
    var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202

    var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
    var match = escapedPath ? Object(__WEBPACK_IMPORTED_MODULE_0_react_router__["j" /* matchPath */])(currentLocation.pathname, {
      path: escapedPath,
      exact: exact,
      strict: strict
    }) : null;
    var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
    var className = isActive ? joinClassnames(classNameProp, activeClassName) : classNameProp;
    var style = isActive ? Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styleProp, {}, activeStyle) : styleProp;

    var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({
      "aria-current": isActive && ariaCurrent || null,
      className: className,
      style: style,
      to: toLocation
    }, rest); // React 15 compat


    if (forwardRefShim$1 !== forwardRef$1) {
      props.ref = forwardedRef || innerRef;
    } else {
      props.innerRef = innerRef;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Link, props);
  });
});

if (false) {
  NavLink.displayName = "NavLink";
  var ariaCurrentType = PropTypes.oneOf(["page", "step", "location", "date", "time", "true"]);
  NavLink.propTypes = _extends({}, Link.propTypes, {
    "aria-current": ariaCurrentType,
    activeClassName: PropTypes.string,
    activeStyle: PropTypes.object,
    className: PropTypes.string,
    exact: PropTypes.bool,
    isActive: PropTypes.func,
    location: PropTypes.object,
    strict: PropTypes.bool,
    style: PropTypes.object
  });
}


//# sourceMappingURL=react-router-dom.js.map


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEmpty = exports.isNumberValid = exports.is0to100NumberValid = exports.isNumberEnteredValid = exports.isValueEntered = exports.isNameValid = exports.isEmailValid = void 0;

var _validation = __webpack_require__(1258);
/**
 * Utility class for validation handling
 */


var isEmailValid = function isEmailValid(value) {
  if (value) {
    var emailMatch = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
    return emailMatch && emailMatch.length > 0;
  }

  return false;
};

exports.isEmailValid = isEmailValid;

var isNameValid = function isNameValid(value) {
  if (value) {
    return value.length > 0;
  }

  return false;
};

exports.isNameValid = isNameValid;

var isValueEntered = function isValueEntered(value) {
  if (value) {
    return value !== null && value !== undefined && value !== '';
  }

  return false;
};
/**
 * Check the value is a number greater than or equal to the min and less than or equal to the max values specified
 * @param {*} value 
 * @param {*} min 
 * @param {*} max 
 */


exports.isValueEntered = isValueEntered;

var isNumberEnteredValid = function isNumberEnteredValid(value, min, max) {
  if (isNumberValid(value) && value >= min && value <= max) {
    return true;
  }

  return false;
};
/**
 * Check the value is a number greater than or equal to 0 and less than or equal to 100
 * @param {*} value 
 * @param {*} min 
 * @param {*} max 
 */


exports.isNumberEnteredValid = isNumberEnteredValid;

var is0to100NumberValid = function is0to100NumberValid(value) {
  if (isNumberValid(value) && value >= _validation.MIN_PRIORITY_0 && value <= _validation.MAX_PRIORITY_100) {
    return true;
  }

  return false;
};
/**
 * Check the value is a number
 * @param {*} value 
 */


exports.is0to100NumberValid = is0to100NumberValid;

var isNumberValid = function isNumberValid(value) {
  if (value !== null && value !== undefined && !isNaN(value) && typeof value == 'number') {
    return true;
  }

  return false;
};
/**
 * checks if the entry is empty - space, 0, null, undefined
 * @param {*} e 
 */


exports.isNumberValid = isNumberValid;

var isEmpty = function isEmpty(e) {
  switch (e) {
    case '':
    case null:
    case typeof e == 'undefined':
    case undefined:
      return true;

    default:
      return false;
  }
};

exports.isEmpty = isEmpty;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(isEmailValid, "isEmailValid", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Validation.js");

  __REACT_HOT_LOADER__.register(isNameValid, "isNameValid", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Validation.js");

  __REACT_HOT_LOADER__.register(isValueEntered, "isValueEntered", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Validation.js");

  __REACT_HOT_LOADER__.register(isNumberEnteredValid, "isNumberEnteredValid", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Validation.js");

  __REACT_HOT_LOADER__.register(is0to100NumberValid, "is0to100NumberValid", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Validation.js");

  __REACT_HOT_LOADER__.register(isNumberValid, "isNumberValid", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Validation.js");

  __REACT_HOT_LOADER__.register(isEmpty, "isEmpty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Validation.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(isEmailValid, "isEmailValid", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Validation.js");

  __REACT_HOT_LOADER__.register(isNameValid, "isNameValid", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Validation.js");

  __REACT_HOT_LOADER__.register(isValueEntered, "isValueEntered", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Validation.js");

  __REACT_HOT_LOADER__.register(isNumberEnteredValid, "isNumberEnteredValid", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Validation.js");

  __REACT_HOT_LOADER__.register(is0to100NumberValid, "is0to100NumberValid", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Validation.js");

  __REACT_HOT_LOADER__.register(isNumberValid, "isNumberValid", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Validation.js");

  __REACT_HOT_LOADER__.register(isEmpty, "isEmpty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Validation.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Validation.js");
}();

;

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_io__ = __webpack_require__(112);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "take", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["s"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "takem", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["t"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "put", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "all", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "race", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["o"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "call", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "apply", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cps", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fork", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "spawn", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["r"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "join", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cancel", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "select", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["p"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "actionChannel", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cancelled", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "flush", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getContext", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setContext", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["q"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_io_helpers__ = __webpack_require__(1216);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "takeEvery", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_io_helpers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "takeLatest", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_io_helpers__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "throttle", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_io_helpers__["c"]; });




/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseBody = exports.parseError = exports.deleteDataRequest = exports.updateDataRequest = exports.addOrUpdateDataRequest = exports.fetchUriDataRequest = exports.fetchUriDataRequestWithBasicAuth = exports.fetchDataRequest = exports.getDataRequest = exports.postDataRequest = void 0;

var _lodash = __webpack_require__(72);

var _auditService = __webpack_require__(358);

var _ApiClient = __webpack_require__(210);

var _ApiConfig = __webpack_require__(145);

var _messages = __webpack_require__(362);

var _projectService = __webpack_require__(175);

var _promise = _interopRequireDefault(__webpack_require__(655));

var _Validation = __webpack_require__(14);

var _objectService = __webpack_require__(658);

var _this = void 0;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var postDataRequest =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(endpointLookup, body, headers, pathParams, pathParamValues) {
    var endpointConfig, uri, result;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            endpointConfig = (0, _ApiConfig.endpoint)(endpointLookup);
            uri = (0, _ApiConfig.replaceEndpointPathParams)(endpointConfig === null || endpointConfig === void 0 ? void 0 : endpointConfig.uri, pathParams, pathParamValues);
            result = {};

            if (!endpointConfig) {
              _context.next = 6;
              break;
            }

            _context.next = 6;
            return (0, _ApiClient.post)(uri, body, headers).then(function (res) {
              result = res ? res : {};
            })["catch"](function (error) {
              throw error;
            });

          case 6:
            return _context.abrupt("return", result);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function postDataRequest(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();

exports.postDataRequest = postDataRequest;

var getDataRequest =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(endpointLookup) {
    var endpointConfig, result;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            endpointConfig = (0, _ApiConfig.endpoint)(endpointLookup);
            result = {};

            if (!endpointConfig) {
              _context2.next = 5;
              break;
            }

            _context2.next = 5;
            return (0, _ApiClient.get)(endpointConfig.uri).then(function (res) {
              result = res ? res : {};
            })["catch"](function (error) {
              throw error;
            });

          case 5:
            return _context2.abrupt("return", result);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getDataRequest(_x6) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * fetch data with or without any path parameters
 * @param {string} endpointLookup - correspond with ApiConfig service endpoints
 * @param {Array} pathParams - array of known pathParams - i.e. ['orgId'] or null if none
 * @param {Array} pathParamValues - array of corresponding pathParamValues or null if none
 */


exports.getDataRequest = getDataRequest;

var fetchDataRequest =
/*#__PURE__*/
function () {
  var _ref3 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(endpointLookup, pathParams, pathParamValues) {
    var endpointConfig, uri;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            endpointConfig = (0, _ApiConfig.endpoint)(endpointLookup);
            uri = (0, _ApiConfig.replaceEndpointPathParams)(endpointConfig === null || endpointConfig === void 0 ? void 0 : endpointConfig.uri, pathParams, pathParamValues);
            return _context3.abrupt("return", fetchUriDataRequest(uri));

          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function fetchDataRequest(_x7, _x8, _x9) {
    return _ref3.apply(this, arguments);
  };
}();

exports.fetchDataRequest = fetchDataRequest;

var fetchUriDataRequestWithBasicAuth = function fetchUriDataRequestWithBasicAuth(uri, username, password) {
  var header = (0, _projectService.getBasicAuthorizationHeader)(username, password);
  return fetchUriDataRequest(uri, header, true);
};
/**
 * fetch data using the uri provided
 * @param {string} uri - the uri to use in the get request
 * @param {object} headers - the uri to use in the get request
 * @param {boolean} basicApiCall - the uri to use in the get request
 */


exports.fetchUriDataRequestWithBasicAuth = fetchUriDataRequestWithBasicAuth;

var fetchUriDataRequest =
/*#__PURE__*/
function () {
  var _ref4 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee4(uri, headers, basicApiCall) {
    var values;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            values = [];

            if (!uri) {
              _context4.next = 4;
              break;
            }

            _context4.next = 4;
            return (0, _ApiClient.get)(uri, headers, basicApiCall || false).then(function (response) {
              if (Array.isArray(response)) {
                response.forEach(function (rawData) {
                  values.push(rawData);
                });
              } else {
                // should be an object so push the single value
                values = response;
              }
            })["catch"](function (error) {
              throw error;
            });

          case 4:
            return _context4.abrupt("return", values);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function fetchUriDataRequest(_x10, _x11, _x12) {
    return _ref4.apply(this, arguments);
  };
}();
/**
 * Update the payload object and make the call to the API - return the payload updated (may contain an id if a new object)
 * @param {Array} currentList  - current list that is going to be changed - DEPRECATED PARAMETER (May 2020)
 * @param {Object or payload} payload - the payload being updated/ added
 * @param {string} postEndpoint the add endpoint - key links to ApiConfig
 * @param {string} putEndpoint the update endpoint - key links to ApiConfig
 * @param {Array} pathParams - array of known pathParams - i.e. ['orgId'] or null if none
 * @param {Array} pathParamValues - array of corresponding pathParamValues - i.e. [orgId] or null if none
 */


exports.fetchUriDataRequest = fetchUriDataRequest;

var addOrUpdateDataRequest =
/*#__PURE__*/
function () {
  var _ref5 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee5(currentList, payload, postEndpoint, putEndpoint, pathParams, pathParamValues) {
    var _payload, isNew, currentState, updatedPayload, endpointConfig, uri, changedState;

    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            isNew = !(0, _Validation.isValueEntered)((_payload = payload) === null || _payload === void 0 ? void 0 : _payload.id);
            currentState = {};
            payload = (0, _objectService.removeEmptyEntries)(payload);
            updatedPayload = _objectSpread({}, payload); // legacy code - not updated here but in the reducers as lists may be filtered so hard to control here
            // const updatedList = currentList.map((entry) => {
            //     if (entry.id === payload.id) {
            //         isNew = false;
            //         currentState = entry;
            //         return payload;
            //     } else {
            //         return entry;
            //     }
            // });
            // updatedList should now contain either
            // 1. the new list with the updated item
            // 2. The original list without the new item (if adding  an item)

            endpointConfig = isNew ? (0, _ApiConfig.endpoint)(postEndpoint) : (0, _ApiConfig.endpoint)(putEndpoint);
            uri = (0, _ApiConfig.replaceEndpointPathParams)(endpointConfig === null || endpointConfig === void 0 ? void 0 : endpointConfig.uri, pathParams, pathParamValues);

            if (!isNew) {
              _context5.next = 13;
              break;
            }

            if (!uri) {
              _context5.next = 11;
              break;
            }

            _context5.next = 11;
            return (0, _ApiClient.post)(uri, payload).then(function (response) {
              // the response will return the id so place it back into the local object
              var id = response ? response.id : postEndpoint.concat('ResponseError');
              updatedPayload = _objectSpread({}, payload, {
                id: id
              }); // updatedList.push(updatedPayload);
            })["catch"](function (error) {
              throw error;
            });

          case 11:
            _context5.next = 21;
            break;

          case 13:
            if (!uri) {
              _context5.next = 21;
              break;
            }

            if ((0, _lodash.isEqual)(currentState, payload)) {
              _context5.next = 20;
              break;
            }

            changedState = (0, _auditService.objectStateComparator)([currentState], [payload]);
            _context5.next = 18;
            return (0, _ApiClient.update)(uri, payload, (0, _auditService.auditLogHeaderEntry)(changedState)).then(function (payload) {
              return payload;
            }) // already in list
            ["catch"](function (error) {
              throw error;
            });

          case 18:
            _context5.next = 21;
            break;

          case 20:
            throw _messages.DATA_NOT_CHANGED_SO_NOT_UPDATED;

          case 21:
            return _context5.abrupt("return", updatedPayload);

          case 24:
            _context5.prev = 24;
            _context5.t0 = _context5["catch"](0);
            throw _context5.t0;

          case 27:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 24]]);
  }));

  return function addOrUpdateDataRequest(_x13, _x14, _x15, _x16, _x17, _x18) {
    return _ref5.apply(this, arguments);
  };
}();
/**
 * make a call to the API to update the payload
 * @param {Object or payload} payload - the payload being updated
 * @param {string} putEndpoint the update endpoint - key links to ApiConfig
 * @param {Array} auditMessage - the auditMessage to save with the request
 * @param {Array} pathParams [optional] - array of known pathParams - i.e. ['orgId'] or null if none
 * @param {Array} pathParamValues [optional] - array of corresponding pathParamValues - i.e. [orgId] or null if none
 */


exports.addOrUpdateDataRequest = addOrUpdateDataRequest;

var updateDataRequest =
/*#__PURE__*/
function () {
  var _ref6 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee6(payload, putEndpoint, auditMessage, pathParams, pathParamValues) {
    var endpointConfig, uri;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            endpointConfig = (0, _ApiConfig.endpoint)(putEndpoint);
            uri = (0, _ApiConfig.replaceEndpointPathParams)(endpointConfig === null || endpointConfig === void 0 ? void 0 : endpointConfig.uri, pathParams, pathParamValues);
            payload = (0, _objectService.removeEmptyEntries)(payload);
            _context6.next = 6;
            return (0, _ApiClient.update)(uri, payload, (0, _auditService.auditLogHeaderEntry)(auditMessage)).then(function (payload) {
              return payload;
            })["catch"](function (error) {
              throw error;
            });

          case 6:
            return _context6.abrupt("return", payload);

          case 9:
            _context6.prev = 9;
            _context6.t0 = _context6["catch"](0);
            throw _context6.t0;

          case 12:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 9]]);
  }));

  return function updateDataRequest(_x19, _x20, _x21, _x22, _x23) {
    return _ref6.apply(this, arguments);
  };
}();
/**
 * make a call to the API to delete the key
 * @param {string} deleteEndpoint the update endpoint - key links to ApiConfig
 * @param {Array} auditMessage - the auditMessage to save with the request
 * @param {Array} pathParams [optional] - array of known pathParams - i.e. ['orgId'] or null if none
 * @param {Array} pathParamValues [optional] - array of corresponding pathParamValues - i.e. [orgId] or null if none
 */


exports.updateDataRequest = updateDataRequest;

var deleteDataRequest =
/*#__PURE__*/
function () {
  var _ref7 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee7(deleteEndpoint, auditMessage, pathParams, pathParamValues) {
    var endpointConfig, uri;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            endpointConfig = (0, _ApiConfig.endpoint)(deleteEndpoint);
            uri = (0, _ApiConfig.replaceEndpointPathParams)(endpointConfig === null || endpointConfig === void 0 ? void 0 : endpointConfig.uri, pathParams, pathParamValues);
            _context7.next = 5;
            return (0, _ApiClient.remove)(uri, (0, _auditService.auditLogHeaderEntry)(auditMessage)).then(function (payload) {
              return payload;
            })["catch"](function (error) {
              throw error;
            });

          case 5:
            return _context7.abrupt("return");

          case 8:
            _context7.prev = 8;
            _context7.t0 = _context7["catch"](0);
            throw _context7.t0;

          case 11:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[0, 8]]);
  }));

  return function deleteDataRequest(_x24, _x25, _x26, _x27) {
    return _ref7.apply(this, arguments);
  };
}();
/**
 * parse error response
 */


exports.deleteDataRequest = deleteDataRequest;

var parseError = function parseError(messages) {
  // error
  if (messages) {
    if (messages instanceof Array) {
      var mappedMessages = messages.map(function (message) {
        return (message === null || message === void 0 ? void 0 : message.error) ? message.error : message;
      });
      return _promise["default"].reject({
        messages: [mappedMessages.join()]
      }); // creates "," separated string of all errors
    } else {
      return _promise["default"].reject({
        messages: [(messages === null || messages === void 0 ? void 0 : messages.error) ? messages.error : messages]
      });
    }
  } else {
    return _promise["default"].reject({
      messages: ['Error ???']
    });
  }
};
/**
 * parse response
 */


exports.parseError = parseError;

var parseBody = function parseBody(response) {
  //  if (response.status === 200 && response.data.status.code === 200) { // - if use custom status code
  if ((response === null || response === void 0 ? void 0 : response.status) === 200) {
    return _promise["default"].resolve(response.data);
  } else {
    return _this.parseError(response.data.messages);
  }
};

exports.parseBody = parseBody;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(postDataRequest, "postDataRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiService.js");

  __REACT_HOT_LOADER__.register(getDataRequest, "getDataRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiService.js");

  __REACT_HOT_LOADER__.register(fetchDataRequest, "fetchDataRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiService.js");

  __REACT_HOT_LOADER__.register(fetchUriDataRequestWithBasicAuth, "fetchUriDataRequestWithBasicAuth", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiService.js");

  __REACT_HOT_LOADER__.register(fetchUriDataRequest, "fetchUriDataRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiService.js");

  __REACT_HOT_LOADER__.register(addOrUpdateDataRequest, "addOrUpdateDataRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiService.js");

  __REACT_HOT_LOADER__.register(updateDataRequest, "updateDataRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiService.js");

  __REACT_HOT_LOADER__.register(deleteDataRequest, "deleteDataRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiService.js");

  __REACT_HOT_LOADER__.register(parseError, "parseError", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiService.js");

  __REACT_HOT_LOADER__.register(parseBody, "parseBody", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiService.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_promise, "_promise", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiService.js");

  __REACT_HOT_LOADER__.register(_this, "_this", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiService.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiService.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiService.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiService.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiService.js");

  __REACT_HOT_LOADER__.register(asyncGeneratorStep, "asyncGeneratorStep", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiService.js");

  __REACT_HOT_LOADER__.register(_asyncToGenerator, "_asyncToGenerator", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiService.js");

  __REACT_HOT_LOADER__.register(postDataRequest, "postDataRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiService.js");

  __REACT_HOT_LOADER__.register(getDataRequest, "getDataRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiService.js");

  __REACT_HOT_LOADER__.register(fetchDataRequest, "fetchDataRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiService.js");

  __REACT_HOT_LOADER__.register(fetchUriDataRequestWithBasicAuth, "fetchUriDataRequestWithBasicAuth", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiService.js");

  __REACT_HOT_LOADER__.register(fetchUriDataRequest, "fetchUriDataRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiService.js");

  __REACT_HOT_LOADER__.register(addOrUpdateDataRequest, "addOrUpdateDataRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiService.js");

  __REACT_HOT_LOADER__.register(updateDataRequest, "updateDataRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiService.js");

  __REACT_HOT_LOADER__.register(deleteDataRequest, "deleteDataRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiService.js");

  __REACT_HOT_LOADER__.register(parseError, "parseError", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiService.js");

  __REACT_HOT_LOADER__.register(parseBody, "parseBody", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiService.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiService.js");
}();

;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(111),
    isObject = __webpack_require__(58);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(102);
var core = __webpack_require__(218);
var hide = __webpack_require__(701);
var redefine = __webpack_require__(705);
var ctx = __webpack_require__(708);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return mathSign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isPercent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isNumOrStr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return uniqueId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPercentValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAnyElementOfObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return hasDuplicate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return interpolateNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return findEntryInArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getLinearRegression; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isArray__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNaN__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNaN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNaN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNumber__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isNumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isString__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isString__);





var mathSign = function mathSign(value) {
  if (value === 0) {
    return 0;
  }

  if (value > 0) {
    return 1;
  }

  return -1;
};
var isPercent = function isPercent(value) {
  return __WEBPACK_IMPORTED_MODULE_4_lodash_isString___default()(value) && value.indexOf('%') === value.length - 1;
};
var isNumber = function isNumber(value) {
  return __WEBPACK_IMPORTED_MODULE_3_lodash_isNumber___default()(value) && !__WEBPACK_IMPORTED_MODULE_2_lodash_isNaN___default()(value);
};
var isNumOrStr = function isNumOrStr(value) {
  return isNumber(value) || __WEBPACK_IMPORTED_MODULE_4_lodash_isString___default()(value);
};
var idCounter = 0;
var uniqueId = function uniqueId(prefix) {
  var id = ++idCounter;
  return "".concat(prefix || '').concat(id);
};
/**
 * Get percent value of a total value
 * @param {Number|String} percent A percent
 * @param {Number} totalValue     Total value
 * @param {NUmber} defaultValue   The value returned when percent is undefined or invalid
 * @param {Boolean} validate      If set to be true, the result will be validated
 * @return {Number} value
 */

var getPercentValue = function getPercentValue(percent, totalValue) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (!isNumber(percent) && !__WEBPACK_IMPORTED_MODULE_4_lodash_isString___default()(percent)) {
    return defaultValue;
  }

  var value;

  if (isPercent(percent)) {
    var index = percent.indexOf('%');
    value = totalValue * parseFloat(percent.slice(0, index)) / 100;
  } else {
    value = +percent;
  }

  if (__WEBPACK_IMPORTED_MODULE_2_lodash_isNaN___default()(value)) {
    value = defaultValue;
  }

  if (validate && value > totalValue) {
    value = totalValue;
  }

  return value;
};
var getAnyElementOfObject = function getAnyElementOfObject(obj) {
  if (!obj) {
    return null;
  }

  var keys = Object.keys(obj);

  if (keys && keys.length) {
    return obj[keys[0]];
  }

  return null;
};
var hasDuplicate = function hasDuplicate(ary) {
  if (!__WEBPACK_IMPORTED_MODULE_1_lodash_isArray___default()(ary)) {
    return false;
  }

  var len = ary.length;
  var cache = {};

  for (var i = 0; i < len; i++) {
    if (!cache[ary[i]]) {
      cache[ary[i]] = true;
    } else {
      return true;
    }
  }

  return false;
};
var interpolateNumber = function interpolateNumber(numberA, numberB) {
  if (isNumber(numberA) && isNumber(numberB)) {
    return function (t) {
      return numberA + t * (numberB - numberA);
    };
  }

  return function () {
    return numberB;
  };
};
var findEntryInArray = function findEntryInArray(ary, specifiedKey, specifiedValue) {
  if (!ary || !ary.length) {
    return null;
  }

  return ary.find(function (entry) {
    return entry && (typeof specifiedKey === 'function' ? specifiedKey(entry) : __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(entry, specifiedKey)) === specifiedValue;
  });
};
/**
 * The least square linear regression
 * @param {Array} data The array of points
 * @returns {Object} The domain of x, and the parameter of linear function
 */

var getLinearRegression = function getLinearRegression(data) {
  if (!data || !data.length) {
    return null;
  }

  var len = data.length;
  var xsum = 0;
  var ysum = 0;
  var xysum = 0;
  var xxsum = 0;
  var xmin = Infinity;
  var xmax = -Infinity;

  for (var i = 0; i < len; i++) {
    xsum += data[i].cx;
    ysum += data[i].cy;
    xysum += data[i].cx * data[i].cy;
    xxsum += data[i].cx * data[i].cx;
    xmin = Math.min(xmin, data[i].cx);
    xmax = Math.max(xmax, data[i].cx);
  }

  var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
  return {
    xmin: xmin,
    xmax: xmax,
    a: a,
    b: (ysum - a * xsum) / len
  };
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var CircularProgress = function CircularProgress() {
  return _react["default"].createElement("div", {
    className: "loader"
  }, _react["default"].createElement("svg", {
    className: "circular",
    viewBox: "25 25 50 50"
  }, _react["default"].createElement("circle", {
    className: "path",
    cx: "50",
    cy: "50",
    r: "15",
    fill: "none",
    strokeWidth: "2",
    strokeMiterlimit: "10"
  })));
};

var _default = CircularProgress;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CircularProgress, "CircularProgress", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/CircularProgress/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/CircularProgress/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/CircularProgress/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/CircularProgress/index.js");

  __REACT_HOT_LOADER__.register(CircularProgress, "CircularProgress", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/CircularProgress/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/CircularProgress/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/CircularProgress/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/CircularProgress/index.js");
}();

;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JIRA_GET_PROJECTS_ENDPOINT = exports.COMPARE_ORG_SURVEY_ANSWERS_ENDPOINT = exports.ORG_SURVEY_ANSWERS_ENDPOINT = exports.EMPLOYEE_ADD_ENDPOINT = exports.EMPLOYEE_UPDATE_ENDPOINT = exports.EMPLOYEE_FETCH_ENDPOINT = exports.UPDATE_ORGANISATION = exports.ADD_ORGANISATION = exports.ORGANISATION_STATISTICS = exports.PROJECT_COST_PRIORITIES_DELETE_ENDPOINT = exports.PROJECT_COST_PRIORITIES_UPDATE_ENDPOINT = exports.PROJECT_BUS_PRIORITIES_DELETE_ENDPOINT = exports.PROJECT_BUS_PRIORITIES_UPDATE_ENDPOINT = exports.PROJECT_UPDATE_ENDPOINT = exports.PROJECTS_ADD_ENDPOINT = exports.PROJECT_ADD_ENDPOINT = exports.PROJECTS_FETCH_ENDPOINT = exports.PROJECTID_PATH_PARAM = exports.INITIATIVEID_PATH_PARAM = exports.VALUESTREAMID_PATH_PARAM = exports.FEATUREID_PATH_PARAM = exports.ISSUEID_PATH_PARAM = exports.PRODUCTID_PATH_PARAM = exports.ORGID_PATH_PARAM = void 0;
var ORGID_PATH_PARAM = 'orgid';
exports.ORGID_PATH_PARAM = ORGID_PATH_PARAM;
var PRODUCTID_PATH_PARAM = 'productId';
exports.PRODUCTID_PATH_PARAM = PRODUCTID_PATH_PARAM;
var ISSUEID_PATH_PARAM = 'issueId';
exports.ISSUEID_PATH_PARAM = ISSUEID_PATH_PARAM;
var FEATUREID_PATH_PARAM = 'featureId';
exports.FEATUREID_PATH_PARAM = FEATUREID_PATH_PARAM;
var VALUESTREAMID_PATH_PARAM = 'valueStreamId';
exports.VALUESTREAMID_PATH_PARAM = VALUESTREAMID_PATH_PARAM;
var INITIATIVEID_PATH_PARAM = 'initiativeId';
exports.INITIATIVEID_PATH_PARAM = INITIATIVEID_PATH_PARAM;
var PROJECTID_PATH_PARAM = 'projectId';
exports.PROJECTID_PATH_PARAM = PROJECTID_PATH_PARAM;
var PROJECTS_FETCH_ENDPOINT = 'projects';
exports.PROJECTS_FETCH_ENDPOINT = PROJECTS_FETCH_ENDPOINT;
var PROJECT_ADD_ENDPOINT = 'addProject';
exports.PROJECT_ADD_ENDPOINT = PROJECT_ADD_ENDPOINT;
var PROJECTS_ADD_ENDPOINT = 'addProjects';
exports.PROJECTS_ADD_ENDPOINT = PROJECTS_ADD_ENDPOINT;
var PROJECT_UPDATE_ENDPOINT = 'updateProject';
exports.PROJECT_UPDATE_ENDPOINT = PROJECT_UPDATE_ENDPOINT;
var PROJECT_BUS_PRIORITIES_UPDATE_ENDPOINT = 'updateBusPriorities';
exports.PROJECT_BUS_PRIORITIES_UPDATE_ENDPOINT = PROJECT_BUS_PRIORITIES_UPDATE_ENDPOINT;
var PROJECT_BUS_PRIORITIES_DELETE_ENDPOINT = 'deleteBusPriorities';
exports.PROJECT_BUS_PRIORITIES_DELETE_ENDPOINT = PROJECT_BUS_PRIORITIES_DELETE_ENDPOINT;
var PROJECT_COST_PRIORITIES_UPDATE_ENDPOINT = 'updateCostPriorities';
exports.PROJECT_COST_PRIORITIES_UPDATE_ENDPOINT = PROJECT_COST_PRIORITIES_UPDATE_ENDPOINT;
var PROJECT_COST_PRIORITIES_DELETE_ENDPOINT = 'deleteCostPriorities';
exports.PROJECT_COST_PRIORITIES_DELETE_ENDPOINT = PROJECT_COST_PRIORITIES_DELETE_ENDPOINT;
var ORGANISATION_STATISTICS = 'organisationStatistics';
exports.ORGANISATION_STATISTICS = ORGANISATION_STATISTICS;
var ADD_ORGANISATION = 'addOrganisation';
exports.ADD_ORGANISATION = ADD_ORGANISATION;
var UPDATE_ORGANISATION = 'updateOrganisation';
exports.UPDATE_ORGANISATION = UPDATE_ORGANISATION;
var EMPLOYEE_FETCH_ENDPOINT = 'employees';
exports.EMPLOYEE_FETCH_ENDPOINT = EMPLOYEE_FETCH_ENDPOINT;
var EMPLOYEE_UPDATE_ENDPOINT = 'updateEmployee';
exports.EMPLOYEE_UPDATE_ENDPOINT = EMPLOYEE_UPDATE_ENDPOINT;
var EMPLOYEE_ADD_ENDPOINT = 'addEmployee';
exports.EMPLOYEE_ADD_ENDPOINT = EMPLOYEE_ADD_ENDPOINT;
var ORG_SURVEY_ANSWERS_ENDPOINT = 'organisationSurveyAnswers';
exports.ORG_SURVEY_ANSWERS_ENDPOINT = ORG_SURVEY_ANSWERS_ENDPOINT;
var COMPARE_ORG_SURVEY_ANSWERS_ENDPOINT = 'compareOrgSurveyAnswers';
exports.COMPARE_ORG_SURVEY_ANSWERS_ENDPOINT = COMPARE_ORG_SURVEY_ANSWERS_ENDPOINT;
var JIRA_GET_PROJECTS_ENDPOINT = 'importJiraProjects';
exports.JIRA_GET_PROJECTS_ENDPOINT = JIRA_GET_PROJECTS_ENDPOINT;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ORGID_PATH_PARAM, "ORGID_PATH_PARAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(PRODUCTID_PATH_PARAM, "PRODUCTID_PATH_PARAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(ISSUEID_PATH_PARAM, "ISSUEID_PATH_PARAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(FEATUREID_PATH_PARAM, "FEATUREID_PATH_PARAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(VALUESTREAMID_PATH_PARAM, "VALUESTREAMID_PATH_PARAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(INITIATIVEID_PATH_PARAM, "INITIATIVEID_PATH_PARAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(PROJECTID_PATH_PARAM, "PROJECTID_PATH_PARAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(PROJECTS_FETCH_ENDPOINT, "PROJECTS_FETCH_ENDPOINT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(PROJECT_ADD_ENDPOINT, "PROJECT_ADD_ENDPOINT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(PROJECTS_ADD_ENDPOINT, "PROJECTS_ADD_ENDPOINT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(PROJECT_UPDATE_ENDPOINT, "PROJECT_UPDATE_ENDPOINT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(PROJECT_BUS_PRIORITIES_UPDATE_ENDPOINT, "PROJECT_BUS_PRIORITIES_UPDATE_ENDPOINT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(PROJECT_BUS_PRIORITIES_DELETE_ENDPOINT, "PROJECT_BUS_PRIORITIES_DELETE_ENDPOINT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(PROJECT_COST_PRIORITIES_UPDATE_ENDPOINT, "PROJECT_COST_PRIORITIES_UPDATE_ENDPOINT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(PROJECT_COST_PRIORITIES_DELETE_ENDPOINT, "PROJECT_COST_PRIORITIES_DELETE_ENDPOINT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(ORGANISATION_STATISTICS, "ORGANISATION_STATISTICS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(ADD_ORGANISATION, "ADD_ORGANISATION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(UPDATE_ORGANISATION, "UPDATE_ORGANISATION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(EMPLOYEE_FETCH_ENDPOINT, "EMPLOYEE_FETCH_ENDPOINT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(EMPLOYEE_UPDATE_ENDPOINT, "EMPLOYEE_UPDATE_ENDPOINT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(EMPLOYEE_ADD_ENDPOINT, "EMPLOYEE_ADD_ENDPOINT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(ORG_SURVEY_ANSWERS_ENDPOINT, "ORG_SURVEY_ANSWERS_ENDPOINT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(COMPARE_ORG_SURVEY_ANSWERS_ENDPOINT, "COMPARE_ORG_SURVEY_ANSWERS_ENDPOINT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(JIRA_GET_PROJECTS_ENDPOINT, "JIRA_GET_PROJECTS_ENDPOINT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ORGID_PATH_PARAM, "ORGID_PATH_PARAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(PRODUCTID_PATH_PARAM, "PRODUCTID_PATH_PARAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(ISSUEID_PATH_PARAM, "ISSUEID_PATH_PARAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(FEATUREID_PATH_PARAM, "FEATUREID_PATH_PARAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(VALUESTREAMID_PATH_PARAM, "VALUESTREAMID_PATH_PARAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(INITIATIVEID_PATH_PARAM, "INITIATIVEID_PATH_PARAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(PROJECTID_PATH_PARAM, "PROJECTID_PATH_PARAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(PROJECTS_FETCH_ENDPOINT, "PROJECTS_FETCH_ENDPOINT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(PROJECT_ADD_ENDPOINT, "PROJECT_ADD_ENDPOINT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(PROJECTS_ADD_ENDPOINT, "PROJECTS_ADD_ENDPOINT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(PROJECT_UPDATE_ENDPOINT, "PROJECT_UPDATE_ENDPOINT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(PROJECT_BUS_PRIORITIES_UPDATE_ENDPOINT, "PROJECT_BUS_PRIORITIES_UPDATE_ENDPOINT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(PROJECT_BUS_PRIORITIES_DELETE_ENDPOINT, "PROJECT_BUS_PRIORITIES_DELETE_ENDPOINT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(PROJECT_COST_PRIORITIES_UPDATE_ENDPOINT, "PROJECT_COST_PRIORITIES_UPDATE_ENDPOINT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(PROJECT_COST_PRIORITIES_DELETE_ENDPOINT, "PROJECT_COST_PRIORITIES_DELETE_ENDPOINT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(ORGANISATION_STATISTICS, "ORGANISATION_STATISTICS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(ADD_ORGANISATION, "ADD_ORGANISATION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(UPDATE_ORGANISATION, "UPDATE_ORGANISATION", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(EMPLOYEE_FETCH_ENDPOINT, "EMPLOYEE_FETCH_ENDPOINT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(EMPLOYEE_UPDATE_ENDPOINT, "EMPLOYEE_UPDATE_ENDPOINT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(EMPLOYEE_ADD_ENDPOINT, "EMPLOYEE_ADD_ENDPOINT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(ORG_SURVEY_ANSWERS_ENDPOINT, "ORG_SURVEY_ANSWERS_ENDPOINT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(COMPARE_ORG_SURVEY_ANSWERS_ENDPOINT, "COMPARE_ORG_SURVEY_ANSWERS_ENDPOINT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(JIRA_GET_PROJECTS_ENDPOINT, "JIRA_GET_PROJECTS_ENDPOINT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/api.js");
}();

;

/***/ }),
/* 26 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactCustomScrollbars = __webpack_require__(1421);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var CustomScrollbars = function CustomScrollbars(props) {
  return _react["default"].createElement(_reactCustomScrollbars.Scrollbars, _extends({}, props, {
    autoHide: true,
    renderTrackHorizontal: function renderTrackHorizontal(props) {
      return _react["default"].createElement("div", _extends({}, props, {
        style: {
          display: 'none'
        },
        className: "track-horizontal"
      }));
    }
  }));
};

var _default = CustomScrollbars;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CustomScrollbars, "CustomScrollbars", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/CustomScrollbars.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/CustomScrollbars.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/CustomScrollbars.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/CustomScrollbars.js");

  __REACT_HOT_LOADER__.register(_extends, "_extends", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/CustomScrollbars.js");

  __REACT_HOT_LOADER__.register(CustomScrollbars, "CustomScrollbars", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/CustomScrollbars.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/CustomScrollbars.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/CustomScrollbars.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/CustomScrollbars.js");
}();

;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(237)('wks');
var uid = __webpack_require__(132);
var Symbol = __webpack_require__(17).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationManager = exports.NotificationContainer = exports.Notifications = undefined;

var _Notifications = __webpack_require__(803);

var _Notifications2 = _interopRequireDefault(_Notifications);

var _NotificationContainer = __webpack_require__(1790);

var _NotificationContainer2 = _interopRequireDefault(_NotificationContainer);

var _NotificationManager = __webpack_require__(806);

var _NotificationManager2 = _interopRequireDefault(_NotificationManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Notifications = _Notifications2.default;
exports.NotificationContainer = _NotificationContainer2.default;
exports.NotificationManager = _NotificationManager2.default;
exports.default = _Notifications2.default;

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Drawer__ = __webpack_require__(1444);
// export this package's api

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Drawer__["a" /* default */]);

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(86);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * @fileOverview Layer
 */



var propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node])
};

function Layer(props) {
  var children = props.children,
      className = props.className,
      others = _objectWithoutProperties(props, ["children", "className"]);

  var layerClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('recharts-layer', className);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", _extends({
    className: layerClass
  }, others), children);
}

Layer.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (Layer);

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeDuplicatesById = exports.uniqByKeepLast = exports.uniqByKeepFirst = exports.addOrUpdateEntry = exports.sameByIdValue = exports.sameBy = exports.differenceById = exports.differenceBy = exports.unionWith = exports.uniqueSymmetricDifference = void 0;

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}
/**
 * take 2 arrays that have the key of id an return an array that has no common objects
 * Handy for lists that don't require object that have already been selected.
 * @param {*} array1 - one array of objects
 * @param {*} array2 - another array of objects
 */


var uniqueSymmetricDifference = function uniqueSymmetricDifference(array1, array2) {
  if (Array.isArray(array1) && !Array.isArray(array2)) {
    return array1;
  }

  if (!Array.isArray(array1) && Array.isArray(array2)) {
    return array2;
  }

  if (Array.isArray(array1) && Array.isArray(array2)) {
    return [].concat(_toConsumableArray(array1.filter(function (v) {
      return !array2.some(function (entry) {
        return entry.id === v.id;
      });
    })), _toConsumableArray(array2.filter(function (v) {
      return !array1.some(function (entry) {
        return entry.id == v.id;
      });
    })));
  }

  return [];
};
/**
 * All array A items will end up in the result. array b items - Only NON duplicates from array A will be added using the comparator
 * @param {Array} a 
 * @param {Array} b 
 * @param {Function} comp the comparator to match items from array A with Array B
 */


exports.uniqueSymmetricDifference = uniqueSymmetricDifference;

var unionWith = function unionWith(a, b, comp) {
  return Array.from(new Set([].concat(_toConsumableArray(a), _toConsumableArray(b.filter(function (x) {
    return a.findIndex(function (y) {
      return comp(x, y);
    }) === -1;
  })))));
};
/**
 * Returns items from array A that ARE NOT in array B (NOTE - If items from B are not in A - they will not be in the result)
 * @param {Array} a 
 * @param {Array} b 
 * @param {Function} comp the comparator that finds the difference in the 2 arrays
 */


exports.unionWith = unionWith;

var differenceBy = function differenceBy(a, b, fn) {
  var s = new Set(b.map(fn));
  return a.filter(function (x) {
    return !s.has(fn(x));
  });
};
/**
 * Wrapper for differenceBy that uses the object id as the comparator
 * @param {*} a 
 * @param {*} b 
 */


exports.differenceBy = differenceBy;

var differenceById = function differenceById(a, b) {
  return differenceBy(a, b, function (v) {
    return v.id;
  });
};
/**
 * Returns items from array A that ARE NOT in array B (NOTE - If items from B are not in A - they will not be in the result)
 * @param {Array} a 
 * @param {Array} b 
 * @param {Function} comp the comparator that finds the difference in the 2 arrays
 */


exports.differenceById = differenceById;

var sameBy = function sameBy(a, b, comp) {
  var s = new Set(b);
  return a.filter(function (x) {
    return s.has(comp(x));
  });
};
/**
 * Wrapper for differenceBy that uses the object id as the comparator
 * @param {Array} a objects that have an id field [{id: 'id1'}, {id: 'id3'}]
 * @param {Array} b Array of value that contain the id value to lookup ['id1', 'id2']
 */


exports.sameBy = sameBy;

var sameByIdValue = function sameByIdValue(a, b) {
  return sameBy(a, b, function (v) {
    return v.id;
  });
};
/**
 * update the entry in the list based on the id of the object
 * @param {*} list the list to update
 * @param {*} payload the payload to add or update
 */


exports.sameByIdValue = sameByIdValue;

var addOrUpdateEntry = function addOrUpdateEntry(list, payload) {
  var isNew = true;

  if (Array.isArray(list) && payload) {
    var updatedList = list.map(function (entry) {
      if (entry.id === payload.id) {
        // have a match in the list so return the new entry replacing the old one
        isNew = false;
        return payload;
      } else {
        // not a match so simply return the current entry
        return entry;
      }
    }); // if the payload is not in the list then add it before returning the updated list

    if (isNew) {
      updatedList.push(payload);
    }

    return updatedList;
  }

  return list;
};

exports.addOrUpdateEntry = addOrUpdateEntry;

var uniqByKeepFirst = function uniqByKeepFirst(a, key) {
  var seen = new Set();
  return a.filter(function (item) {
    var k = key(item);
    return seen.has(k) ? false : seen.add(k);
  });
};

exports.uniqByKeepFirst = uniqByKeepFirst;

var uniqByKeepLast = function uniqByKeepLast(a, key) {
  return _toConsumableArray(new Map(a.map(function (x) {
    return [key(x), x];
  })).values());
};

exports.uniqByKeepLast = uniqByKeepLast;

var containsById = function containsById(array, obj) {
  for (var i = 0; i < array.length; i++) {
    if (isEqualById(array[i], obj)) return true;
  }

  return false;
}; //comparator


var isEqualById = function isEqualById(obj1, obj2) {
  if (obj1.id == obj2.id) return true;
  return false;
};

var removeDuplicatesById = function removeDuplicatesById(array) {
  var temp = [];
  return array.filter(function (entry) {
    return !containsById(temp, entry) && temp.push(entry);
  });
};

exports.removeDuplicatesById = removeDuplicatesById;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(uniqueSymmetricDifference, "uniqueSymmetricDifference", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/arrayService.js");

  __REACT_HOT_LOADER__.register(unionWith, "unionWith", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/arrayService.js");

  __REACT_HOT_LOADER__.register(differenceBy, "differenceBy", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/arrayService.js");

  __REACT_HOT_LOADER__.register(differenceById, "differenceById", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/arrayService.js");

  __REACT_HOT_LOADER__.register(sameBy, "sameBy", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/arrayService.js");

  __REACT_HOT_LOADER__.register(sameByIdValue, "sameByIdValue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/arrayService.js");

  __REACT_HOT_LOADER__.register(addOrUpdateEntry, "addOrUpdateEntry", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/arrayService.js");

  __REACT_HOT_LOADER__.register(uniqByKeepFirst, "uniqByKeepFirst", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/arrayService.js");

  __REACT_HOT_LOADER__.register(uniqByKeepLast, "uniqByKeepLast", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/arrayService.js");

  __REACT_HOT_LOADER__.register(containsById, "containsById", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/arrayService.js");

  __REACT_HOT_LOADER__.register(isEqualById, "isEqualById", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/arrayService.js");

  __REACT_HOT_LOADER__.register(removeDuplicatesById, "removeDuplicatesById", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/arrayService.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_toConsumableArray, "_toConsumableArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/arrayService.js");

  __REACT_HOT_LOADER__.register(_nonIterableSpread, "_nonIterableSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/arrayService.js");

  __REACT_HOT_LOADER__.register(_iterableToArray, "_iterableToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/arrayService.js");

  __REACT_HOT_LOADER__.register(_arrayWithoutHoles, "_arrayWithoutHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/arrayService.js");

  __REACT_HOT_LOADER__.register(uniqueSymmetricDifference, "uniqueSymmetricDifference", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/arrayService.js");

  __REACT_HOT_LOADER__.register(unionWith, "unionWith", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/arrayService.js");

  __REACT_HOT_LOADER__.register(differenceBy, "differenceBy", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/arrayService.js");

  __REACT_HOT_LOADER__.register(differenceById, "differenceById", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/arrayService.js");

  __REACT_HOT_LOADER__.register(sameBy, "sameBy", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/arrayService.js");

  __REACT_HOT_LOADER__.register(sameByIdValue, "sameByIdValue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/arrayService.js");

  __REACT_HOT_LOADER__.register(addOrUpdateEntry, "addOrUpdateEntry", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/arrayService.js");

  __REACT_HOT_LOADER__.register(uniqByKeepFirst, "uniqByKeepFirst", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/arrayService.js");

  __REACT_HOT_LOADER__.register(uniqByKeepLast, "uniqByKeepLast", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/arrayService.js");

  __REACT_HOT_LOADER__.register(containsById, "containsById", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/arrayService.js");

  __REACT_HOT_LOADER__.register(isEqualById, "isEqualById", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/arrayService.js");

  __REACT_HOT_LOADER__.register(removeDuplicatesById, "removeDuplicatesById", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/arrayService.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/arrayService.js");
}();

;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(887);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 36 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.10' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FormErrors = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _lodash = __webpack_require__(72);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var FormErrors = function FormErrors(_ref) {
  var formErrors = _ref.formErrors;
  return _react["default"].createElement("div", {
    className: "page-error-content"
  }, Object.keys(formErrors).map(function (fieldName, i) {
    if (formErrors[fieldName].length > 0) {
      return _react["default"].createElement("p", {
        key: i
      }, (0, _lodash.capitalize)(fieldName), " ", formErrors[fieldName]);
    } else {
      return '';
    }
  }));
};

exports.FormErrors = FormErrors;
var _default = FormErrors;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(FormErrors, "FormErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/formErrors/FormErrors.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/formErrors/FormErrors.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/formErrors/FormErrors.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/formErrors/FormErrors.js");

  __REACT_HOT_LOADER__.register(FormErrors, "FormErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/formErrors/FormErrors.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/formErrors/FormErrors.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/formErrors/FormErrors.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/formErrors/FormErrors.js");
}();

;

/***/ }),
/* 39 */,
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(18)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(19);
var IE8_DOM_DEFINE = __webpack_require__(448);
var toPrimitive = __webpack_require__(109);
var dP = Object.defineProperty;

exports.f = __webpack_require__(40) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBasicAuthorizationHeader = exports.generateGuid = exports.getRoleName = exports.isOrg = exports.isAdmin = exports.isSuperUser = exports.extractTokenId = exports.isTokenExpired = exports.invalidateSession = exports.getSelectedPortfolio = exports.getIdentityName = exports.getIdentityOrgId = exports.getIdentityId = exports.getIdentityRole = exports.setIdentity = exports.setAuth = exports.getAuth = exports.removeStorageItem = exports.getStorageItem = exports.setStorageItem = exports.isAuthenticated = exports.SELECTED_PORTFOLIO = exports.STATE = exports.IDENTITY_ROLE = exports.IDENTITY_NAME = exports.IDENTITY_ORGID = exports.IDENTITY_ID = exports.AUTH_EXPIRES = exports.AUTH = void 0;

var _jwtDecode = _interopRequireDefault(__webpack_require__(1246));

var _ApiConfig = __webpack_require__(145);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
} // cannot import the following from ../../services (i.e. the module export) as we get a circular dependency error
// so import each directly


var AUTH = 'user-auth';
exports.AUTH = AUTH;
var AUTH_EXPIRES = 'user-auth-expires';
exports.AUTH_EXPIRES = AUTH_EXPIRES;
var IDENTITY_ID = 'id';
exports.IDENTITY_ID = IDENTITY_ID;
var IDENTITY_ORGID = 'orgid';
exports.IDENTITY_ORGID = IDENTITY_ORGID;
var IDENTITY_NAME = 'name';
exports.IDENTITY_NAME = IDENTITY_NAME;
var IDENTITY_ROLE = 'role';
exports.IDENTITY_ROLE = IDENTITY_ROLE;
var STATE = 'state';
exports.STATE = STATE;
var SELECTED_PORTFOLIO = 'portfolioId'; // const JWT_TOKEN = 'bb3837a0-d6e2-4e0d-a170-c5e4fcc207b4'; // TODO to go into config - copied from api for now
// const config;
// const constKey = readFileSync('./const.key');
// const publicKey = readFileSync('./public.key');
// const issuer = 'Agile corp';          // Issuer
// const subject = 'cpsolutions28@gmail.com';        // Subject
// const audience = 'http://theoctoguide.com'; // Audience
// VERIFYING OPTIONS
// const verifyOptions = {
//   issuer,
//   subject,
//   audience,
//   expiresIn: '12h',
//   algorithm: ['RS256']
// };

exports.SELECTED_PORTFOLIO = SELECTED_PORTFOLIO;
var mockSessionInvalidatedFlag = false; // login(uname, pwd) {
//   return this.http
//     .request(this.config.method, this.config.uri, {body: {username: uname, password: pwd}})
//     .pipe(
//       map((user) => {
//         // login successful if there's a jwt token in the response
//         if (user) {
//           // store user details and jwt token in local storage to keep user logged in between page refreshes
//           // localStorage.setItem('currentUser', JSON.stringify(user));
//           this.setAuth(JSON.stringify(user));
//         }
//         return user;
//       }),
//     );
// }
// isLoggedIn() {
//   return this.loggedIn.asObservable();
// }
// logout() {
//   this.invalidateSession();
//   this.loggedIn.next(false);
// }

var isAuthenticated = function isAuthenticated() {
  if ((0, _ApiConfig.isMockData)() && !mockSessionInvalidatedFlag) {
    console.log('USING MOCK DATA - will always authenticate');
    return true;
  }

  var userAuth = localStorage.getItem(AUTH);

  if (userAuth && !isTokenExpired(userAuth)) {
    console.log('TOKEN EXPIRED = '.concat(isTokenExpired(userAuth)));
    return true;
  }

  return false;
}; // getCustomerNumber() {
//   if (this.isAuthenticated()) {
//     const auth = JSON.parse(localStorage.getItem(this.AUTH));
//     return auth.id;
//   }
//   return 0; // TODO should return null ???
// }


exports.isAuthenticated = isAuthenticated;

var setStorageItem = function setStorageItem(item, value) {
  if (item && value) {
    localStorage.setItem(item, value);
  }
};

exports.setStorageItem = setStorageItem;

var getStorageItem = function getStorageItem(item) {
  if (item) {
    return localStorage.getItem(item);
  }

  return undefined;
};

exports.getStorageItem = getStorageItem;

var removeStorageItem = function removeStorageItem(item) {
  if (item) {
    localStorage.removeItem(item);
  }
};

exports.removeStorageItem = removeStorageItem;

var getAuth = function getAuth() {
  return getStorageItem(AUTH);
};
/* Example response
{
    "loginResponse": {
        "tokens": [
            {
                "type": "header",
                "name": "Authorization",
                "value": "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVC... jwt keeps going here",
                "expires": "Tue Dec 31 2019 19:33:33 GMT+1100"
            }
        ],
        "lastLoginTime": "unknown",
        "tokenIdleTime": "unknown"
    }
}
*/


exports.getAuth = getAuth;

var setAuth = function setAuth(auth) {
  var _auth$loginResponse, _auth$loginResponse$t, _auth$loginResponse2, _auth$loginResponse2$;

  mockSessionInvalidatedFlag = false;

  if (auth === null || auth === void 0 ? void 0 : (_auth$loginResponse = auth.loginResponse) === null || _auth$loginResponse === void 0 ? void 0 : (_auth$loginResponse$t = _auth$loginResponse.tokens[0]) === null || _auth$loginResponse$t === void 0 ? void 0 : _auth$loginResponse$t.value) {
    var jwt = auth.loginResponse.tokens[0].value;
    setStorageItem(AUTH, jwt);
  }

  if (auth === null || auth === void 0 ? void 0 : (_auth$loginResponse2 = auth.loginResponse) === null || _auth$loginResponse2 === void 0 ? void 0 : (_auth$loginResponse2$ = _auth$loginResponse2.tokens[0]) === null || _auth$loginResponse2$ === void 0 ? void 0 : _auth$loginResponse2$.expires) {
    var expires = auth.loginResponse.tokens[0].expires;
    setStorageItem(AUTH_EXPIRES, expires);
  }
};

exports.setAuth = setAuth;

var setIdentity = function setIdentity(identity) {
  setStorageItem(IDENTITY_ROLE, (identity === null || identity === void 0 ? void 0 : identity.role) || '');
  setStorageItem(IDENTITY_ID, (identity === null || identity === void 0 ? void 0 : identity.id) || '');
  setStorageItem(IDENTITY_ORGID, (identity === null || identity === void 0 ? void 0 : identity.orgid) || '');
  setStorageItem(IDENTITY_NAME, (identity === null || identity === void 0 ? void 0 : identity.name) || '');
};

exports.setIdentity = setIdentity;

var getIdentityRole = function getIdentityRole() {
  return getStorageItem(IDENTITY_ROLE);
};

exports.getIdentityRole = getIdentityRole;

var getIdentityId = function getIdentityId() {
  return getStorageItem(IDENTITY_ID);
};

exports.getIdentityId = getIdentityId;

var getIdentityOrgId = function getIdentityOrgId() {
  return getStorageItem(IDENTITY_ORGID);
};

exports.getIdentityOrgId = getIdentityOrgId;

var getIdentityName = function getIdentityName() {
  return getStorageItem(IDENTITY_NAME);
};

exports.getIdentityName = getIdentityName;

var getSelectedPortfolio = function getSelectedPortfolio() {
  return getStorageItem(SELECTED_PORTFOLIO);
};

exports.getSelectedPortfolio = getSelectedPortfolio;

var invalidateSession =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            removeStorageItem(STATE);
            removeStorageItem(AUTH);
            removeStorageItem(IDENTITY_ROLE);
            removeStorageItem(IDENTITY_ID);
            removeStorageItem(IDENTITY_ORGID);
            removeStorageItem(IDENTITY_NAME);
            removeStorageItem(SELECTED_PORTFOLIO);
            console.log(localStorage);
            mockSessionInvalidatedFlag = true;
            return _context.abrupt("return");

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function invalidateSession() {
    return _ref.apply(this, arguments);
  };
}(); // generateAnonymousJWT() {
//   const payload = {
//     id: '999999999',
//     name: 'anonymous',
//     roles: 'guest',
//     admin: false,
//   };
//   return '';
//   // const token = jwt.sign(payload, this.constKey, this.signOptions);
//   // console.log("Token :" + token);
//   // return token;
// }
// export const tokenExpired = (token) => {
//   var decodedToken = decode(token, { complete: true });
//   var dateNow = new Date().getTime();
//   if (decodedToken.exp < dateNow) {
//     return true;
//   }
//   return false;
// }


exports.invalidateSession = invalidateSession;

var isTokenExpired = function isTokenExpired(token) {
  try {
    // console.log('Checking token is expired for token - '.concat(token))
    var decoded = (0, _jwtDecode["default"])(token);

    if ((decoded === null || decoded === void 0 ? void 0 : decoded.exp) < Date.now() / 1000) {
      // Checking if token is expired.
      return true;
    } else {
      return false;
    }
  } catch (err) {
    console.log('expired check failed due to the error - '.concat(err));
    return false;
  }
}; // the id is returned from post requests - extract the id to put back into the payload


exports.isTokenExpired = isTokenExpired;

var extractTokenId = function extractTokenId(token) {
  try {
    var _decoded$id;

    var decoded = (0, _jwtDecode["default"])(token);

    if (decoded === null || decoded === void 0 ? void 0 : (_decoded$id = decoded.id) === null || _decoded$id === void 0 ? void 0 : _decoded$id.id) {
      return decoded.id.id;
    }
  } catch (err) {
    console.log('getting the token id failed due to the error - '.concat(err));
    return '';
  }
};

exports.extractTokenId = extractTokenId;

var isSuperUser = function isSuperUser() {
  return getIdentityRole() === 'royalty';
};

exports.isSuperUser = isSuperUser;

var isAdmin = function isAdmin() {
  return getIdentityRole() === 'gold';
};

exports.isAdmin = isAdmin;

var isOrg = function isOrg() {
  return getIdentityId() === getIdentityOrgId();
};

exports.isOrg = isOrg;

var getRoleName = function getRoleName() {
  if (isSuperUser()) {
    return 'Super user';
  } else if (isAdmin()) {
    return 'Administrator';
  } else if (isOrg()) {
    return 'Organisation';
  } else {
    return 'Logged in user';
  }
};

exports.getRoleName = getRoleName;

function _pk(s) {
  var p = (Math.random().toString(16) + '000000000').substr(2, 8);
  return s ? '-' + p.substr(0, 4) + '-' + p.substr(4, 4) : p;
}
/*
generate a unique record uid
 */


var generateGuid = function generateGuid() {
  return (_pk(false) + _pk(true) + _pk(true) + new Date().toISOString().slice(0, 10)).replace(/-/g, '');
};

exports.generateGuid = generateGuid;

var getBasicAuthorizationHeader = function getBasicAuthorizationHeader(username, password) {
  if (username && password) {
    var header = 'Basic '.concat(Buffer.from(username.concat(':').concat(password)).toString('base64'));
    return {
      Authorization: header
    };
  }

  return null;
};

exports.getBasicAuthorizationHeader = getBasicAuthorizationHeader;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AUTH, "AUTH", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(AUTH_EXPIRES, "AUTH_EXPIRES", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(IDENTITY_ID, "IDENTITY_ID", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(IDENTITY_ORGID, "IDENTITY_ORGID", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(IDENTITY_NAME, "IDENTITY_NAME", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(IDENTITY_ROLE, "IDENTITY_ROLE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(STATE, "STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(SELECTED_PORTFOLIO, "SELECTED_PORTFOLIO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(mockSessionInvalidatedFlag, "mockSessionInvalidatedFlag", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(isAuthenticated, "isAuthenticated", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(setStorageItem, "setStorageItem", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(getStorageItem, "getStorageItem", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(removeStorageItem, "removeStorageItem", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(getAuth, "getAuth", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(setAuth, "setAuth", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(setIdentity, "setIdentity", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(getIdentityRole, "getIdentityRole", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(getIdentityId, "getIdentityId", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(getIdentityOrgId, "getIdentityOrgId", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(getIdentityName, "getIdentityName", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(getSelectedPortfolio, "getSelectedPortfolio", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(invalidateSession, "invalidateSession", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(isTokenExpired, "isTokenExpired", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(extractTokenId, "extractTokenId", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(isSuperUser, "isSuperUser", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(isAdmin, "isAdmin", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(isOrg, "isOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(getRoleName, "getRoleName", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(_pk, "_pk", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(generateGuid, "generateGuid", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(getBasicAuthorizationHeader, "getBasicAuthorizationHeader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_jwtDecode, "_jwtDecode", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(asyncGeneratorStep, "asyncGeneratorStep", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(_asyncToGenerator, "_asyncToGenerator", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(AUTH, "AUTH", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(AUTH_EXPIRES, "AUTH_EXPIRES", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(IDENTITY_ID, "IDENTITY_ID", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(IDENTITY_ORGID, "IDENTITY_ORGID", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(IDENTITY_NAME, "IDENTITY_NAME", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(IDENTITY_ROLE, "IDENTITY_ROLE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(STATE, "STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(SELECTED_PORTFOLIO, "SELECTED_PORTFOLIO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(mockSessionInvalidatedFlag, "mockSessionInvalidatedFlag", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(isAuthenticated, "isAuthenticated", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(setStorageItem, "setStorageItem", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(getStorageItem, "getStorageItem", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(removeStorageItem, "removeStorageItem", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(getAuth, "getAuth", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(setAuth, "setAuth", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(setIdentity, "setIdentity", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(getIdentityRole, "getIdentityRole", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(getIdentityId, "getIdentityId", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(getIdentityOrgId, "getIdentityOrgId", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(getIdentityName, "getIdentityName", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(getSelectedPortfolio, "getSelectedPortfolio", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(invalidateSession, "invalidateSession", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(isTokenExpired, "isTokenExpired", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(extractTokenId, "extractTokenId", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(isSuperUser, "isSuperUser", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(isAdmin, "isAdmin", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(isOrg, "isOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(getRoleName, "getRoleName", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(_pk, "_pk", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(generateGuid, "generateGuid", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(getBasicAuthorizationHeader, "getBasicAuthorizationHeader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/Authentication.js");
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1242).Buffer))

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDurationAsDaysHrsMins = exports.formatDateGanttChartDefault = exports.formatDateTimeDefault = exports.formatDate = exports.formatDateDefault = exports.DEFAULT_DATE_TIME_GANTT_FORMAT = exports.DEFAULT_DATE_TIME_FORMAT = exports.DEFAULT_DATE_FORMAT = void 0;

var _moment = _interopRequireDefault(__webpack_require__(2));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var DEFAULT_DATE_FORMAT = 'DD/MM/YYYY';
exports.DEFAULT_DATE_FORMAT = DEFAULT_DATE_FORMAT;
var DEFAULT_DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm';
exports.DEFAULT_DATE_TIME_FORMAT = DEFAULT_DATE_TIME_FORMAT;
var DEFAULT_DATE_TIME_GANTT_FORMAT = 'DD-MM-YYYY HH:mm';
/**
 * Format using the default 'DD-MM-YYYY'
 * @param {*} date 
 */

exports.DEFAULT_DATE_TIME_GANTT_FORMAT = DEFAULT_DATE_TIME_GANTT_FORMAT;

var formatDateDefault = function formatDateDefault(date) {
  return formatDate(date, DEFAULT_DATE_FORMAT);
};
/**
 * 
 * @param {*} date
 * @param {*} format 
 */


exports.formatDateDefault = formatDateDefault;

var formatDate = function formatDate(date, format) {
  if (date && format) {
    return (0, _moment["default"])(date).format(format);
  }

  return date;
};
/**
 * Format using the default 'DD/MM/YYYY HH:mm'
 * @param {*} date 
 */


exports.formatDate = formatDate;

var formatDateTimeDefault = function formatDateTimeDefault(date) {
  return formatDate(date, DEFAULT_DATE_TIME_FORMAT);
};
/**
 * Format using the default 'DD/MM/YYYY HH:mm'
 * @param {*} date 
 */


exports.formatDateTimeDefault = formatDateTimeDefault;

var formatDateGanttChartDefault = function formatDateGanttChartDefault(date) {
  return formatDate(date, DEFAULT_DATE_TIME_GANTT_FORMAT);
};
/**
 * i.e converts 1830 to 1 day 6 hrs 30 mins
 * @param {} durationInMinutes 
 */


exports.formatDateGanttChartDefault = formatDateGanttChartDefault;

var formatDurationAsDaysHrsMins = function formatDurationAsDaysHrsMins(durationInMinutes) {
  // const hour = Math.floor(durationInMinutes / 60);
  // const min = Math.floor(durationInMinutes % 60);
  // const displayHour = hour > 0 ? `${hour} hr${hour > 1 ? 's' : ''} ` : '';
  // const displayMin = min > 0 ? `${min} min${min > 1 ? 's' : ''}` : '';
  // return displayHour.concat(displayMin);
  var days = Math.floor(durationInMinutes / 1440);
  var daysRemainder = durationInMinutes / 1440 - Math.floor(durationInMinutes / 1440);
  var hour = Math.floor(daysRemainder * 24);
  var min = Math.floor(durationInMinutes % 60);
  var displayDay = days > 0 ? "".concat(days, " day").concat(days > 1 ? 's' : '', " ") : '';
  var displayHour = hour > 0 ? "".concat(hour, " hr").concat(hour > 1 ? 's' : '', " ") : '';
  var displayMin = min > 0 ? "".concat(min, " min").concat(min > 1 ? 's' : '') : '';
  return displayDay.concat(displayHour).concat(displayMin).trim() || 0;
};

exports.formatDurationAsDaysHrsMins = formatDurationAsDaysHrsMins;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(DEFAULT_DATE_FORMAT, "DEFAULT_DATE_FORMAT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DateFormatters.js");

  __REACT_HOT_LOADER__.register(DEFAULT_DATE_TIME_FORMAT, "DEFAULT_DATE_TIME_FORMAT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DateFormatters.js");

  __REACT_HOT_LOADER__.register(DEFAULT_DATE_TIME_GANTT_FORMAT, "DEFAULT_DATE_TIME_GANTT_FORMAT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DateFormatters.js");

  __REACT_HOT_LOADER__.register(formatDateDefault, "formatDateDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DateFormatters.js");

  __REACT_HOT_LOADER__.register(formatDate, "formatDate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DateFormatters.js");

  __REACT_HOT_LOADER__.register(formatDateTimeDefault, "formatDateTimeDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DateFormatters.js");

  __REACT_HOT_LOADER__.register(formatDateGanttChartDefault, "formatDateGanttChartDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DateFormatters.js");

  __REACT_HOT_LOADER__.register(formatDurationAsDaysHrsMins, "formatDurationAsDaysHrsMins", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DateFormatters.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_moment, "_moment", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DateFormatters.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DateFormatters.js");

  __REACT_HOT_LOADER__.register(DEFAULT_DATE_FORMAT, "DEFAULT_DATE_FORMAT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DateFormatters.js");

  __REACT_HOT_LOADER__.register(DEFAULT_DATE_TIME_FORMAT, "DEFAULT_DATE_TIME_FORMAT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DateFormatters.js");

  __REACT_HOT_LOADER__.register(DEFAULT_DATE_TIME_GANTT_FORMAT, "DEFAULT_DATE_TIME_GANTT_FORMAT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DateFormatters.js");

  __REACT_HOT_LOADER__.register(formatDateDefault, "formatDateDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DateFormatters.js");

  __REACT_HOT_LOADER__.register(formatDate, "formatDate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DateFormatters.js");

  __REACT_HOT_LOADER__.register(formatDateTimeDefault, "formatDateTimeDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DateFormatters.js");

  __REACT_HOT_LOADER__.register(formatDateGanttChartDefault, "formatDateGanttChartDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DateFormatters.js");

  __REACT_HOT_LOADER__.register(formatDurationAsDaysHrsMins, "formatDurationAsDaysHrsMins", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DateFormatters.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DateFormatters.js");
}();

;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = asyncComponent;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _nprogress = _interopRequireDefault(__webpack_require__(1488));

var _reactPlaceholder = _interopRequireDefault(__webpack_require__(1489));

__webpack_require__(1494);

__webpack_require__(1496);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function asyncComponent(importComponent) {
  var AsyncFunc =
  /*#__PURE__*/
  function (_Component) {
    _inherits(AsyncFunc, _Component);

    function AsyncFunc(props) {
      var _this;

      _classCallCheck(this, AsyncFunc);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(AsyncFunc).call(this, props));
      _this.state = {
        component: null
      };
      return _this;
    }

    _createClass(AsyncFunc, [{
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.mounted = false;
      }
    }, {
      key: "componentDidMount",
      value: function () {
        var _componentDidMount = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee() {
          var _ref, Component;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _nprogress["default"].start();

                  this.mounted = true;
                  _context.next = 4;
                  return importComponent();

                case 4:
                  _ref = _context.sent;
                  Component = _ref["default"];

                  _nprogress["default"].done();

                  if (this.mounted) {
                    this.setState({
                      component: _react["default"].createElement(Component, this.props)
                    });
                  }

                case 8:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function componentDidMount() {
          return _componentDidMount.apply(this, arguments);
        }

        return componentDidMount;
      }()
    }, {
      key: "render",
      value: function render() {
        var Component = this.state.component || _react["default"].createElement("div", null);

        return _react["default"].createElement(_reactPlaceholder["default"], {
          type: "text",
          rows: 7,
          ready: Component !== null
        }, Component);
      }
    }]);

    return AsyncFunc;
  }(_react.Component);

  return AsyncFunc;
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(asyncComponent, "asyncComponent", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/asyncComponent.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/asyncComponent.js");

  __REACT_HOT_LOADER__.register(_nprogress, "_nprogress", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/asyncComponent.js");

  __REACT_HOT_LOADER__.register(_reactPlaceholder, "_reactPlaceholder", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/asyncComponent.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/asyncComponent.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/asyncComponent.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/asyncComponent.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/asyncComponent.js");

  __REACT_HOT_LOADER__.register(asyncGeneratorStep, "asyncGeneratorStep", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/asyncComponent.js");

  __REACT_HOT_LOADER__.register(_asyncToGenerator, "_asyncToGenerator", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/asyncComponent.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/asyncComponent.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/asyncComponent.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/asyncComponent.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/asyncComponent.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/asyncComponent.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/asyncComponent.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/asyncComponent.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/asyncComponent.js");

  __REACT_HOT_LOADER__.register(asyncComponent, "asyncComponent", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/asyncComponent.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/util/asyncComponent.js");
}();

;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(272);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1474);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1478);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(272);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateDateFields = exports.isDateTimeBetween = exports.isDateBetween = exports.isDateAfter = exports.isDateBefore = void 0;

var _moment = _interopRequireDefault(__webpack_require__(2));

var _DateFormatters = __webpack_require__(43);

var _Validation = __webpack_require__(14);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Check if dateToCheck is before referenceDate
 * @param {Date} referenceDate - the date to check against - i.e. the current start date
 * @param {Date} dateToCheck - the date to use for the check - i.e. todays date
 */


var isDateBefore = function isDateBefore(dateToCheck, referenceDate) {
  if (referenceDate && dateToCheck) {
    var ref = (0, _moment["default"])(referenceDate, _DateFormatters.DEFAULT_DATE_FORMAT);
    var check = (0, _moment["default"])(dateToCheck, _DateFormatters.DEFAULT_DATE_FORMAT);
    return check.isBefore(ref);
  }

  return false;
};
/**
 * Check if dateToCheck is after referenceDate
 * @param {Date} referenceDate - the date to check against
 * @param {Date} dateToCheck
 */


exports.isDateBefore = isDateBefore;

var isDateAfter = function isDateAfter(dateToCheck, referenceDate) {
  if (referenceDate && dateToCheck) {
    var ref = (0, _moment["default"])(referenceDate, _DateFormatters.DEFAULT_DATE_FORMAT);
    var check = (0, _moment["default"])(dateToCheck, _DateFormatters.DEFAULT_DATE_FORMAT);
    return check.isAfter(ref);
  }

  return false;
};
/**
 * Check if date is between startDate
 * @param {*} startDate 
 * @param {*} endDate 
 */


exports.isDateAfter = isDateAfter;

var isDateBetween = function isDateBetween(startDate, endDate, testDate) {
  if (startDate && endDate) {
    var start = (0, _moment["default"])(startDate, _DateFormatters.DEFAULT_DATE_FORMAT);
    var end = (0, _moment["default"])(endDate, _DateFormatters.DEFAULT_DATE_FORMAT);
    var test = (0, _moment["default"])(testDate, _DateFormatters.DEFAULT_DATE_FORMAT);
    return test.isBetween(start, end, 'days', true); // true means inclusive of both dates
  }

  return false;
};
/**
 * Check if date is between startDate and the enddate using the full datetime
 * @param {*} startDate 
 * @param {*} endDate 
 * @param {*} testDate 
 */


exports.isDateBetween = isDateBetween;

var isDateTimeBetween = function isDateTimeBetween(startDate, endDate, testDate) {
  // console.log('s '.concat(startDate));
  // console.log('e '.concat(endDate));
  // console.log('t '.concat(testDate));
  if (startDate && endDate && testDate) {
    return testDate >= endDate && testDate <= startDate;
  }

  return false;
};
/**
 * check if endDate is before the startDate
 * @param {String} name - a date value - either startDate or endDate
 * @param {String} value the date value
 * @param {String} otherDateValue - the other date value
 */


exports.isDateTimeBetween = isDateTimeBetween;

var validateDateFields = function validateDateFields(name, value, otherDateValue) {
  var formErrors = '';

  switch (name) {
    case 'endDate':
      // check its not before the start date
      if ((0, _Validation.isValueEntered)(value) && (0, _Validation.isValueEntered)(otherDateValue)) {
        if (isDateBefore((0, _moment["default"])(value), (0, _moment["default"])(otherDateValue))) {
          formErrors = ' are invalid. The end date selected cannot be before the start date';
        }
      }

      break;

    case 'startDate':
      // check its not after the end date
      if ((0, _Validation.isValueEntered)(otherDateValue) && (0, _Validation.isValueEntered)(value)) {
        if (isDateBefore((0, _moment["default"])(otherDateValue), (0, _moment["default"])(value))) {
          formErrors = ' are invalid. The start date selected cannot be after the end date';
        }
      }

      break;

    default:
      break;
  }

  return formErrors;
};

exports.validateDateFields = validateDateFields;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(isDateBefore, "isDateBefore", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DateService.js");

  __REACT_HOT_LOADER__.register(isDateAfter, "isDateAfter", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DateService.js");

  __REACT_HOT_LOADER__.register(isDateBetween, "isDateBetween", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DateService.js");

  __REACT_HOT_LOADER__.register(isDateTimeBetween, "isDateTimeBetween", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DateService.js");

  __REACT_HOT_LOADER__.register(validateDateFields, "validateDateFields", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DateService.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_moment, "_moment", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DateService.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DateService.js");

  __REACT_HOT_LOADER__.register(isDateBefore, "isDateBefore", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DateService.js");

  __REACT_HOT_LOADER__.register(isDateAfter, "isDateAfter", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DateService.js");

  __REACT_HOT_LOADER__.register(isDateBetween, "isDateBetween", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DateService.js");

  __REACT_HOT_LOADER__.register(isDateTimeBetween, "isDateTimeBetween", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DateService.js");

  __REACT_HOT_LOADER__.register(validateDateFields, "validateDateFields", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DateService.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DateService.js");
}();

;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(97);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.apiErrorMessageFormatter = void 0;
/**
 * return a formatted error message - if no message is passed a default is returned
 * @param {*} error - the error message in the form of a string or error.messages
 * @param {*} componentName - if applied it is appended to situations where no error message was supplied
 */

var apiErrorMessageFormatter = function apiErrorMessageFormatter(error, componentName) {
  if (typeof error === 'string') {
    return error;
  } else if (error === null || error === void 0 ? void 0 : error.messages) {
    return error.messages;
  }

  var defaultMessage = 'An error occurred, however no error message was specified';
  return componentName ? defaultMessage.concat(' Applies to component ').concat(componentName) : defaultMessage;
};

exports.apiErrorMessageFormatter = apiErrorMessageFormatter;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(apiErrorMessageFormatter, "apiErrorMessageFormatter", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/errorService.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(apiErrorMessageFormatter, "apiErrorMessageFormatter", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/errorService.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/errorService.js");
}();

;

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getValueByDataKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getDomainOfDataByKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return calculateActiveTickIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getMainColorOfGraphicItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getLegendProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getBarSizeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getBarPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return appendOffsetOfLegend; });
/* unused harmony export getDomainOfErrorBars */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return parseErrorBarsOfAxis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getDomainOfItemsWithSameAxis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return isCategorialAxis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getCoordinatesOfGrid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getTicksOfAxis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return combineEventHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return parseScale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return checkDomainOfScale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return findPositionOfBar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return truncateByDomain; });
/* unused harmony export offsetSign */
/* unused harmony export getStackedData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getStackGroupsByAxisId; });
/* unused harmony export calculateDomainOfTicks */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getTicksOfScale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getCateCoordinateOfLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getCateCoordinateOfBar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getBaseValueOfBar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getStackedDataOfItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getDomainOfStackGroups; });
/* unused harmony export MIN_VALUE_REG */
/* unused harmony export MAX_VALUE_REG */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return parseSpecifiedDomain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getBandSizeOfAxis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return parseDomainOfCategoryAxis; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sortBy__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNaN__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNaN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNaN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isString__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isArray__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_max__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_max___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_max__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_min__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_flatMap__ = __webpack_require__(1605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_flatMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_flatMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isFunction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isNil__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_recharts_scale__ = __webpack_require__(1606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_recharts_scale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_recharts_scale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_d3_scale__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_d3_shape__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__DataUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__cartesian_ErrorBar__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__component_Legend__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ReactUtils__ = __webpack_require__(12);












function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var getValueByDataKey = function getValueByDataKey(obj, dataKey, defaultValue) {
  if (__WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(obj) || __WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(dataKey)) {
    return defaultValue;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["g" /* isNumOrStr */])(dataKey)) {
    return __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(obj, dataKey, defaultValue);
  }

  if (__WEBPACK_IMPORTED_MODULE_8_lodash_isFunction___default()(dataKey)) {
    return dataKey(obj);
  }

  return defaultValue;
};
/**
 * Get domain of data by key
 * @param  {Array}   data      The data displayed in the chart
 * @param  {String}  key       The unique key of a group of data
 * @param  {String}  type      The type of axis
 * @param  {Boolean} filterNil Whether or not filter nil values
 * @return {Array} Domain of data
 */

var getDomainOfDataByKey = function getDomainOfDataByKey(data, key, type, filterNil) {
  var flattenData = __WEBPACK_IMPORTED_MODULE_7_lodash_flatMap___default()(data, function (entry) {
    return getValueByDataKey(entry, key);
  });

  if (type === 'number') {
    var domain = flattenData.filter(function (entry) {
      return Object(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["h" /* isNumber */])(entry) || parseFloat(entry, 10);
    });
    return domain.length ? [__WEBPACK_IMPORTED_MODULE_6_lodash_min___default()(domain), __WEBPACK_IMPORTED_MODULE_5_lodash_max___default()(domain)] : [Infinity, -Infinity];
  }

  var validateData = filterNil ? flattenData.filter(function (entry) {
    return !__WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(entry);
  }) : flattenData;
  return validateData.map(function (entry) {
    return Object(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["g" /* isNumOrStr */])(entry) ? entry : '';
  });
};
var calculateActiveTickIndex = function calculateActiveTickIndex(coordinate, ticks, unsortedTicks, axis) {
  var index = -1;
  var len = ticks.length;

  if (len > 1) {
    if (axis && axis.axisType === 'angleAxis' && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
      var range = axis.range; // ticks are distributed in a circle

      for (var i = 0; i < len; i++) {
        var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
        var cur = unsortedTicks[i].coordinate;
        var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
        var sameDirectionCoord = void 0;

        if (Object(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["j" /* mathSign */])(cur - before) !== Object(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["j" /* mathSign */])(after - cur)) {
          var diffInterval = [];

          if (Object(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["j" /* mathSign */])(after - cur) === Object(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["j" /* mathSign */])(range[1] - range[0])) {
            sameDirectionCoord = after;
            var curInRange = cur + range[1] - range[0];
            diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
            diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
          } else {
            sameDirectionCoord = before;
            var afterInRange = after + range[1] - range[0];
            diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
            diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
          }

          var sameInterval = [Math.min(cur, (sameDirectionCoord + cur) / 2), Math.max(cur, (sameDirectionCoord + cur) / 2)];

          if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
            index = unsortedTicks[i].index;
            break;
          }
        } else {
          var min = Math.min(before, after);
          var max = Math.max(before, after);

          if (coordinate > (min + cur) / 2 && coordinate <= (max + cur) / 2) {
            index = unsortedTicks[i].index;
            break;
          }
        }
      }
    } else {
      // ticks are distributed in a single direction
      for (var _i = 0; _i < len; _i++) {
        if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
          index = ticks[_i].index;
          break;
        }
      }
    }
  } else {
    index = 0;
  }

  return index;
};
/**
 * Get the main color of each graphic item
 * @param  {ReactElement} item A graphic item
 * @return {String}            Color
 */

var getMainColorOfGraphicItem = function getMainColorOfGraphicItem(item) {
  var displayName = item.type.displayName;
  var _item$props = item.props,
      stroke = _item$props.stroke,
      fill = _item$props.fill;
  var result;

  switch (displayName) {
    case 'Line':
      result = stroke;
      break;

    case 'Area':
    case 'Radar':
      result = stroke && stroke !== 'none' ? stroke : fill;
      break;

    default:
      result = fill;
      break;
  }

  return result;
};
var getLegendProps = function getLegendProps(_ref) {
  var children = _ref.children,
      formatedGraphicalItems = _ref.formatedGraphicalItems,
      legendWidth = _ref.legendWidth,
      legendContent = _ref.legendContent;
  var legendItem = Object(__WEBPACK_IMPORTED_MODULE_17__ReactUtils__["j" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_16__component_Legend__["a" /* default */]);

  if (!legendItem) {
    return null;
  }

  var legendData;

  if (legendItem.props && legendItem.props.payload) {
    legendData = legendItem.props && legendItem.props.payload;
  } else if (legendContent === 'children') {
    legendData = (formatedGraphicalItems || []).reduce(function (result, _ref2) {
      var item = _ref2.item,
          props = _ref2.props;
      var data = props.sectors || props.data || [];
      return result.concat(data.map(function (entry) {
        return {
          type: legendItem.props.iconType || item.props.legendType,
          value: entry.name,
          color: entry.fill,
          payload: entry
        };
      }));
    }, []);
  } else {
    legendData = (formatedGraphicalItems || []).map(function (_ref3) {
      var item = _ref3.item;
      var _item$props2 = item.props,
          dataKey = _item$props2.dataKey,
          name = _item$props2.name,
          legendType = _item$props2.legendType,
          hide = _item$props2.hide;
      return {
        inactive: hide,
        dataKey: dataKey,
        type: legendItem.props.iconType || legendType || 'square',
        color: getMainColorOfGraphicItem(item),
        value: name || dataKey,
        payload: item.props
      };
    });
  }

  return _objectSpread({}, legendItem.props, {}, __WEBPACK_IMPORTED_MODULE_16__component_Legend__["a" /* default */].getWithHeight(legendItem, legendWidth), {
    payload: legendData,
    item: legendItem
  });
};
/**
 * Calculate the size of all groups for stacked bar graph
 * @param  {Object} stackGroups The items grouped by axisId and stackId
 * @return {Object} The size of all groups
 */

var getBarSizeList = function getBarSizeList(_ref4) {
  var globalSize = _ref4.barSize,
      _ref4$stackGroups = _ref4.stackGroups,
      stackGroups = _ref4$stackGroups === void 0 ? {} : _ref4$stackGroups;

  if (!stackGroups) {
    return {};
  }

  var result = {};
  var numericAxisIds = Object.keys(stackGroups);

  for (var i = 0, len = numericAxisIds.length; i < len; i++) {
    var sgs = stackGroups[numericAxisIds[i]].stackGroups;
    var stackIds = Object.keys(sgs);

    for (var j = 0, sLen = stackIds.length; j < sLen; j++) {
      var _sgs$stackIds$j = sgs[stackIds[j]],
          items = _sgs$stackIds$j.items,
          cateAxisId = _sgs$stackIds$j.cateAxisId;
      var barItems = items.filter(function (item) {
        return Object(__WEBPACK_IMPORTED_MODULE_17__ReactUtils__["k" /* getDisplayName */])(item.type).indexOf('Bar') >= 0;
      });

      if (barItems && barItems.length) {
        var selfSize = barItems[0].props.barSize;
        var cateId = barItems[0].props[cateAxisId];

        if (!result[cateId]) {
          result[cateId] = [];
        }

        result[cateId].push({
          item: barItems[0],
          stackList: barItems.slice(1),
          barSize: __WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(selfSize) ? globalSize : selfSize
        });
      }
    }
  }

  return result;
};
/**
   * Calculate the size of each bar and the gap between two bars
   * @param  {Number} bandSize  The size of each category
   * @param  {sizeList} sizeList  The size of all groups
   * @param  {maxBarSize} maxBarSize The maximum size of bar
   * @return {Number} The size of each bar and the gap between two bars
   */

var getBarPosition = function getBarPosition(_ref5) {
  var barGap = _ref5.barGap,
      barCategoryGap = _ref5.barCategoryGap,
      bandSize = _ref5.bandSize,
      _ref5$sizeList = _ref5.sizeList,
      sizeList = _ref5$sizeList === void 0 ? [] : _ref5$sizeList,
      maxBarSize = _ref5.maxBarSize;
  var len = sizeList.length;
  if (len < 1) return null;
  var realBarGap = Object(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["d" /* getPercentValue */])(barGap, bandSize, 0, true);
  var result; // whether or not is barSize setted by user

  if (sizeList[0].barSize === +sizeList[0].barSize) {
    var useFull = false;
    var fullBarSize = bandSize / len;
    var sum = sizeList.reduce(function (res, entry) {
      return res + entry.barSize || 0;
    }, 0);
    sum += (len - 1) * realBarGap;

    if (sum >= bandSize) {
      sum -= (len - 1) * realBarGap;
      realBarGap = 0;
    }

    if (sum >= bandSize && fullBarSize > 0) {
      useFull = true;
      fullBarSize *= 0.9;
      sum = len * fullBarSize;
    }

    var offset = (bandSize - sum) / 2 >> 0;
    var prev = {
      offset: offset - realBarGap,
      size: 0
    };
    result = sizeList.reduce(function (res, entry) {
      var newRes = [].concat(_toConsumableArray(res), [{
        item: entry.item,
        position: {
          offset: prev.offset + prev.size + realBarGap,
          size: useFull ? fullBarSize : entry.barSize
        }
      }]);
      prev = newRes[newRes.length - 1].position;

      if (entry.stackList && entry.stackList.length) {
        entry.stackList.forEach(function (item) {
          newRes.push({
            item: item,
            position: prev
          });
        });
      }

      return newRes;
    }, []);
  } else {
    var _offset = Object(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["d" /* getPercentValue */])(barCategoryGap, bandSize, 0, true);

    if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) {
      realBarGap = 0;
    }

    var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;

    if (originalSize > 1) {
      originalSize >>= 0;
    }

    var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
    result = sizeList.reduce(function (res, entry, i) {
      var newRes = [].concat(_toConsumableArray(res), [{
        item: entry.item,
        position: {
          offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
          size: size
        }
      }]);

      if (entry.stackList && entry.stackList.length) {
        entry.stackList.forEach(function (item) {
          newRes.push({
            item: item,
            position: newRes[newRes.length - 1].position
          });
        });
      }

      return newRes;
    }, []);
  }

  return result;
};
var appendOffsetOfLegend = function appendOffsetOfLegend(offset, items, props, legendBox) {
  var children = props.children,
      width = props.width,
      height = props.height,
      margin = props.margin;
  var legendWidth = width - (margin.left || 0) - (margin.right || 0);
  var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
  var legendProps = getLegendProps({
    children: children,
    items: items,
    legendWidth: legendWidth,
    legendHeight: legendHeight
  });
  var newOffset = offset;

  if (legendProps) {
    var box = legendBox || {};
    var align = legendProps.align,
        verticalAlign = legendProps.verticalAlign,
        layout = legendProps.layout;

    if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'center') && Object(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["h" /* isNumber */])(offset[align])) {
      newOffset = _objectSpread({}, offset, _defineProperty({}, align, newOffset[align] + (box.width || 0)));
    }

    if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && Object(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["h" /* isNumber */])(offset[verticalAlign])) {
      newOffset = _objectSpread({}, offset, _defineProperty({}, verticalAlign, newOffset[verticalAlign] + (box.height || 0)));
    }
  }

  return newOffset;
};
var getDomainOfErrorBars = function getDomainOfErrorBars(data, item, dataKey, axisType) {
  var children = item.props.children;
  var errorBars = Object(__WEBPACK_IMPORTED_MODULE_17__ReactUtils__["i" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_15__cartesian_ErrorBar__["a" /* default */]).filter(function (errorBarChild) {
    var direction = errorBarChild.props.direction;
    return __WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(direction) || __WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(axisType) ? true : axisType.indexOf(direction) >= 0;
  });

  if (errorBars && errorBars.length) {
    var keys = errorBars.map(function (errorBarChild) {
      return errorBarChild.props.dataKey;
    });
    return data.reduce(function (result, entry) {
      var entryValue = getValueByDataKey(entry, dataKey, 0);
      var mainValue = __WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(entryValue) ? [__WEBPACK_IMPORTED_MODULE_6_lodash_min___default()(entryValue), __WEBPACK_IMPORTED_MODULE_5_lodash_max___default()(entryValue)] : [entryValue, entryValue];
      var errorDomain = keys.reduce(function (prevErrorArr, k) {
        var errorValue = getValueByDataKey(entry, k, 0);
        var lowerValue = mainValue[0] - Math.abs(__WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(errorValue) ? errorValue[0] : errorValue);
        var upperValue = mainValue[1] + Math.abs(__WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(errorValue) ? errorValue[1] : errorValue);
        return [Math.min(lowerValue, prevErrorArr[0]), Math.max(upperValue, prevErrorArr[1])];
      }, [Infinity, -Infinity]);
      return [Math.min(errorDomain[0], result[0]), Math.max(errorDomain[1], result[1])];
    }, [Infinity, -Infinity]);
  }

  return null;
};
var parseErrorBarsOfAxis = function parseErrorBarsOfAxis(data, items, dataKey, axisType) {
  var domains = items.map(function (item) {
    return getDomainOfErrorBars(data, item, dataKey, axisType);
  }).filter(function (entry) {
    return !__WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(entry);
  });

  if (domains && domains.length) {
    return domains.reduce(function (result, entry) {
      return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
    }, [Infinity, -Infinity]);
  }

  return null;
};
/**
 * Get domain of data by the configuration of item element
 * @param  {Array}   data      The data displayed in the chart
 * @param  {Array}   items     The instances of item
 * @param  {String}  type      The type of axis, number - Number Axis, category - Category Axis
 * @param  {Boolean} filterNil Whether or not filter nil values
 * @return {Array}        Domain
 */

var getDomainOfItemsWithSameAxis = function getDomainOfItemsWithSameAxis(data, items, type, filterNil) {
  var domains = items.map(function (item) {
    var dataKey = item.props.dataKey;

    if (type === 'number' && dataKey) {
      return getDomainOfErrorBars(data, item, dataKey) || getDomainOfDataByKey(data, dataKey, type, filterNil);
    }

    return getDomainOfDataByKey(data, dataKey, type, filterNil);
  });

  if (type === 'number') {
    // Calculate the domain of number axis
    return domains.reduce(function (result, entry) {
      return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
    }, [Infinity, -Infinity]);
  }

  var tag = {}; // Get the union set of category axis

  return domains.reduce(function (result, entry) {
    for (var i = 0, len = entry.length; i < len; i++) {
      if (!tag[entry[i]]) {
        tag[entry[i]] = true;
        result.push(entry[i]);
      }
    }

    return result;
  }, []);
};
var isCategorialAxis = function isCategorialAxis(layout, axisType) {
  return layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis' || layout === 'centric' && axisType === 'angleAxis' || layout === 'radial' && axisType === 'radiusAxis';
};
/**
 * Calculate the Coordinates of grid
 * @param  {Array} ticks The ticks in axis
 * @param {Number} min   The minimun value of axis
 * @param {Number} max   The maximun value of axis
 * @return {Array}       Coordinates
 */

var getCoordinatesOfGrid = function getCoordinatesOfGrid(ticks, min, max) {
  var hasMin, hasMax;
  var values = ticks.map(function (entry) {
    if (entry.coordinate === min) {
      hasMin = true;
    }

    if (entry.coordinate === max) {
      hasMax = true;
    }

    return entry.coordinate;
  });

  if (!hasMin) {
    values.push(min);
  }

  if (!hasMax) {
    values.push(max);
  }

  return values;
};
/**
 * Get the ticks of an axis
 * @param  {Object}  axis The configuration of an axis
 * @param {Boolean} isGrid Whether or not are the ticks in grid
 * @param {Boolean} isAll Return the ticks of all the points or not
 * @return {Array}  Ticks
 */

var getTicksOfAxis = function getTicksOfAxis(axis, isGrid, isAll) {
  if (!axis) return null;
  var scale = axis.scale;
  var duplicateDomain = axis.duplicateDomain,
      type = axis.type,
      range = axis.range;
  var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / 2 : 0;
  offset = axis.axisType === 'angleAxis' ? Object(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["j" /* mathSign */])(range[0] - range[1]) * 2 * offset : offset; // The ticks setted by user should only affect the ticks adjacent to axis line

  if (isGrid && (axis.ticks || axis.niceTicks)) {
    return (axis.ticks || axis.niceTicks).map(function (entry) {
      var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
      return {
        coordinate: scale(scaleContent) + offset,
        value: entry,
        offset: offset
      };
    });
  }

  if (axis.isCategorial && axis.categoricalDomain) {
    return axis.categoricalDomain.map(function (entry, index) {
      return {
        coordinate: scale(entry),
        value: entry,
        index: index,
        offset: offset
      };
    });
  }

  if (scale.ticks && !isAll) {
    return scale.ticks(axis.tickCount).map(function (entry) {
      return {
        coordinate: scale(entry) + offset,
        value: entry,
        offset: offset
      };
    });
  } // When axis has duplicated text, serial numbers are used to generate scale


  return scale.domain().map(function (entry, index) {
    return {
      coordinate: scale(entry) + offset,
      value: duplicateDomain ? duplicateDomain[entry] : entry,
      index: index,
      offset: offset
    };
  });
};
/**
 * combine the handlers
 * @param  {Function} defaultHandler Internal private handler
 * @param  {Function} parentHandler  Handler function specified in parent component
 * @param  {Function} childHandler   Handler function specified in child component
 * @return {Function}                The combined handler
 */

var combineEventHandlers = function combineEventHandlers(defaultHandler, parentHandler, childHandler) {
  var customizedHandler;

  if (__WEBPACK_IMPORTED_MODULE_8_lodash_isFunction___default()(childHandler)) {
    customizedHandler = childHandler;
  } else if (__WEBPACK_IMPORTED_MODULE_8_lodash_isFunction___default()(parentHandler)) {
    customizedHandler = parentHandler;
  }

  if (__WEBPACK_IMPORTED_MODULE_8_lodash_isFunction___default()(defaultHandler) || customizedHandler) {
    return function (arg1, arg2, arg3, arg4) {
      if (__WEBPACK_IMPORTED_MODULE_8_lodash_isFunction___default()(defaultHandler)) {
        defaultHandler(arg1, arg2, arg3, arg4);
      }

      if (__WEBPACK_IMPORTED_MODULE_8_lodash_isFunction___default()(customizedHandler)) {
        customizedHandler(arg1, arg2, arg3, arg4);
      }
    };
  }

  return null;
};
/**
 * Parse the scale function of axis
 * @param  {Object}   axis          The option of axis
 * @param  {String}   chartType     The displayName of chart
 * @return {Function}               The scale funcion
 */

var parseScale = function parseScale(axis, chartType) {
  var scale = axis.scale,
      type = axis.type,
      layout = axis.layout,
      axisType = axis.axisType;

  if (scale === 'auto') {
    if (layout === 'radial' && axisType === 'radiusAxis') {
      return {
        scale: __WEBPACK_IMPORTED_MODULE_12_d3_scale__["scaleBand"](),
        realScaleType: 'band'
      };
    }

    if (layout === 'radial' && axisType === 'angleAxis') {
      return {
        scale: __WEBPACK_IMPORTED_MODULE_12_d3_scale__["scaleLinear"](),
        realScaleType: 'linear'
      };
    }

    if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0)) {
      return {
        scale: __WEBPACK_IMPORTED_MODULE_12_d3_scale__["scalePoint"](),
        realScaleType: 'point'
      };
    }

    if (type === 'category') {
      return {
        scale: __WEBPACK_IMPORTED_MODULE_12_d3_scale__["scaleBand"](),
        realScaleType: 'band'
      };
    }

    return {
      scale: __WEBPACK_IMPORTED_MODULE_12_d3_scale__["scaleLinear"](),
      realScaleType: 'linear'
    };
  }

  if (__WEBPACK_IMPORTED_MODULE_3_lodash_isString___default()(scale)) {
    var name = "scale".concat(scale.slice(0, 1).toUpperCase()).concat(scale.slice(1));
    return {
      scale: (__WEBPACK_IMPORTED_MODULE_12_d3_scale__[name] || __WEBPACK_IMPORTED_MODULE_12_d3_scale__["scalePoint"])(),
      realScaleType: __WEBPACK_IMPORTED_MODULE_12_d3_scale__[name] ? name : 'point'
    };
  }

  return __WEBPACK_IMPORTED_MODULE_8_lodash_isFunction___default()(scale) ? {
    scale: scale
  } : {
    scale: __WEBPACK_IMPORTED_MODULE_12_d3_scale__["scalePoint"](),
    realScaleType: 'point'
  };
};
var EPS = 1e-4;
var checkDomainOfScale = function checkDomainOfScale(scale) {
  var domain = scale.domain();

  if (!domain || domain.length <= 2) {
    return;
  }

  var len = domain.length;
  var range = scale.range();
  var min = Math.min(range[0], range[1]) - EPS;
  var max = Math.max(range[0], range[1]) + EPS;
  var first = scale(domain[0]);
  var last = scale(domain[len - 1]);

  if (first < min || first > max || last < min || last > max) {
    scale.domain([domain[0], domain[len - 1]]);
  }
};
var findPositionOfBar = function findPositionOfBar(barPosition, child) {
  if (!barPosition) {
    return null;
  }

  for (var i = 0, len = barPosition.length; i < len; i++) {
    if (barPosition[i].item === child) {
      return barPosition[i].position;
    }
  }

  return null;
};
var truncateByDomain = function truncateByDomain(value, domain) {
  if (!domain || domain.length !== 2 || !Object(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["h" /* isNumber */])(domain[0]) || !Object(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["h" /* isNumber */])(domain[1])) {
    return value;
  }

  var min = Math.min(domain[0], domain[1]);
  var max = Math.max(domain[0], domain[1]);
  var result = [value[0], value[1]];

  if (!Object(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["h" /* isNumber */])(value[0]) || value[0] < min) {
    result[0] = min;
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["h" /* isNumber */])(value[1]) || value[1] > max) {
    result[1] = max;
  }

  if (result[0] > max) {
    result[0] = max;
  }

  if (result[1] < min) {
    result[1] = min;
  }

  return result;
};
/* eslint no-param-reassign: 0 */

var offsetSign = function offsetSign(series) {
  var n = series.length;

  if (n <= 0) {
    return;
  }

  for (var j = 0, m = series[0].length; j < m; ++j) {
    var positive = 0;
    var negative = 0;

    for (var i = 0; i < n; ++i) {
      var value = __WEBPACK_IMPORTED_MODULE_2_lodash_isNaN___default()(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
      /* eslint-disable prefer-destructuring */

      if (value >= 0) {
        series[i][j][0] = positive;
        series[i][j][1] = positive + value;
        positive = series[i][j][1];
      } else {
        series[i][j][0] = negative;
        series[i][j][1] = negative + value;
        negative = series[i][j][1];
      }
      /* eslint-enable prefer-destructuring */

    }
  }
};
var STACK_OFFSET_MAP = {
  sign: offsetSign,
  expand: __WEBPACK_IMPORTED_MODULE_13_d3_shape__["o" /* stackOffsetExpand */],
  none: __WEBPACK_IMPORTED_MODULE_13_d3_shape__["p" /* stackOffsetNone */],
  silhouette: __WEBPACK_IMPORTED_MODULE_13_d3_shape__["q" /* stackOffsetSilhouette */],
  wiggle: __WEBPACK_IMPORTED_MODULE_13_d3_shape__["r" /* stackOffsetWiggle */]
};
var getStackedData = function getStackedData(data, stackItems, offsetType) {
  var dataKeys = stackItems.map(function (item) {
    return item.props.dataKey;
  });
  var stack = Object(__WEBPACK_IMPORTED_MODULE_13_d3_shape__["n" /* stack */])().keys(dataKeys).value(function (d, key) {
    return +getValueByDataKey(d, key, 0);
  }).order(__WEBPACK_IMPORTED_MODULE_13_d3_shape__["s" /* stackOrderNone */]).offset(STACK_OFFSET_MAP[offsetType]);
  return stack(data);
};
var getStackGroupsByAxisId = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
  if (!data) {
    return null;
  } // reversing items to affect render order (for layering)


  var items = reverseStackOrder ? _items.reverse() : _items;
  var stackGroups = items.reduce(function (result, item) {
    var _item$props3 = item.props,
        stackId = _item$props3.stackId,
        hide = _item$props3.hide;

    if (hide) {
      return result;
    }

    var axisId = item.props[numericAxisId];
    var parentGroup = result[axisId] || {
      hasStack: false,
      stackGroups: {}
    };

    if (Object(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["g" /* isNumOrStr */])(stackId)) {
      var childGroup = parentGroup.stackGroups[stackId] || {
        numericAxisId: numericAxisId,
        cateAxisId: cateAxisId,
        items: []
      };
      childGroup.items.push(item);
      parentGroup.hasStack = true;
      parentGroup.stackGroups[stackId] = childGroup;
    } else {
      parentGroup.stackGroups[Object(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["k" /* uniqueId */])('_stackId_')] = {
        numericAxisId: numericAxisId,
        cateAxisId: cateAxisId,
        items: [item]
      };
    }

    return _objectSpread({}, result, _defineProperty({}, axisId, parentGroup));
  }, {});
  return Object.keys(stackGroups).reduce(function (result, axisId) {
    var group = stackGroups[axisId];

    if (group.hasStack) {
      group.stackGroups = Object.keys(group.stackGroups).reduce(function (res, stackId) {
        var g = group.stackGroups[stackId];
        return _objectSpread({}, res, _defineProperty({}, stackId, {
          numericAxisId: numericAxisId,
          cateAxisId: cateAxisId,
          items: g.items,
          stackedData: getStackedData(data, g.items, offsetType)
        }));
      }, {});
    }

    return _objectSpread({}, result, _defineProperty({}, axisId, group));
  }, {});
};
/**
 * get domain of ticks
 * @param  {Array} ticks Ticks of axis
 * @param  {String} type  The type of axis
 * @return {Array} domain
 */

var calculateDomainOfTicks = function calculateDomainOfTicks(ticks, type) {
  if (type === 'number') {
    return [__WEBPACK_IMPORTED_MODULE_6_lodash_min___default()(ticks), __WEBPACK_IMPORTED_MODULE_5_lodash_max___default()(ticks)];
  }

  return ticks;
};
/**
 * Configure the scale function of axis
 * @param {Object} scale The scale function
 * @param {Object} opts  The configuration of axis
 * @return {Object}      null
 */

var getTicksOfScale = function getTicksOfScale(scale, opts) {
  var realScaleType = opts.realScaleType,
      type = opts.type,
      tickCount = opts.tickCount,
      originalDomain = opts.originalDomain,
      allowDecimals = opts.allowDecimals;
  var scaleType = realScaleType || opts.scale;

  if (scaleType !== 'auto' && scaleType !== 'linear') {
    return null;
  }

  if (tickCount && type === 'number' && originalDomain && (originalDomain[0] === 'auto' || originalDomain[1] === 'auto')) {
    // Calculate the ticks by the number of grid when the axis is a number axis
    var domain = scale.domain();
    var tickValues = Object(__WEBPACK_IMPORTED_MODULE_11_recharts_scale__["getNiceTickValues"])(domain, tickCount, allowDecimals);
    scale.domain(calculateDomainOfTicks(tickValues, type));
    return {
      niceTicks: tickValues
    };
  }

  if (tickCount && type === 'number') {
    var _domain = scale.domain();

    var _tickValues = Object(__WEBPACK_IMPORTED_MODULE_11_recharts_scale__["getTickValuesFixedDomain"])(_domain, tickCount, allowDecimals);

    return {
      niceTicks: _tickValues
    };
  }

  return null;
};
var getCateCoordinateOfLine = function getCateCoordinateOfLine(_ref6) {
  var axis = _ref6.axis,
      ticks = _ref6.ticks,
      bandSize = _ref6.bandSize,
      entry = _ref6.entry,
      index = _ref6.index,
      dataKey = _ref6.dataKey;

  if (axis.type === 'category') {
    // find coordinate of category axis by the value of category
    if (!axis.allowDuplicatedCategory && axis.dataKey && !__WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(entry[axis.dataKey])) {
      var matchedTick = Object(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["a" /* findEntryInArray */])(ticks, 'value', entry[axis.dataKey]);

      if (matchedTick) {
        return matchedTick.coordinate + bandSize / 2;
      }
    }

    return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
  }

  var value = getValueByDataKey(entry, !__WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(dataKey) ? dataKey : axis.dataKey);
  return !__WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(value) ? axis.scale(value) : null;
};
var getCateCoordinateOfBar = function getCateCoordinateOfBar(_ref7) {
  var axis = _ref7.axis,
      ticks = _ref7.ticks,
      offset = _ref7.offset,
      bandSize = _ref7.bandSize,
      entry = _ref7.entry,
      index = _ref7.index;

  if (axis.type === 'category') {
    return ticks[index] ? ticks[index].coordinate + offset : null;
  }

  var value = getValueByDataKey(entry, axis.dataKey, axis.domain[index]);
  return !__WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(value) ? axis.scale(value) - bandSize / 2 + offset : null;
};
var getBaseValueOfBar = function getBaseValueOfBar(_ref8) {
  var numericAxis = _ref8.numericAxis;
  var domain = numericAxis.scale.domain();

  if (numericAxis.type === 'number') {
    var min = Math.min(domain[0], domain[1]);
    var max = Math.max(domain[0], domain[1]);

    if (min <= 0 && max >= 0) {
      return 0;
    }

    if (max < 0) {
      return max;
    }

    return min;
  }

  return domain[0];
};
var getStackedDataOfItem = function getStackedDataOfItem(item, stackGroups) {
  var stackId = item.props.stackId;

  if (Object(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["g" /* isNumOrStr */])(stackId)) {
    var group = stackGroups[stackId];

    if (group && group.items.length) {
      var itemIndex = -1;

      for (var i = 0, len = group.items.length; i < len; i++) {
        if (group.items[i] === item) {
          itemIndex = i;
          break;
        }
      }

      return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
    }
  }

  return null;
};

var getDomainOfSingle = function getDomainOfSingle(data) {
  return data.reduce(function (result, entry) {
    return [__WEBPACK_IMPORTED_MODULE_6_lodash_min___default()(entry.concat([result[0]]).filter(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["h" /* isNumber */])), __WEBPACK_IMPORTED_MODULE_5_lodash_max___default()(entry.concat([result[1]]).filter(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["h" /* isNumber */]))];
  }, [Infinity, -Infinity]);
};

var getDomainOfStackGroups = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
  return Object.keys(stackGroups).reduce(function (result, stackId) {
    var group = stackGroups[stackId];
    var stackedData = group.stackedData;
    var domain = stackedData.reduce(function (res, entry) {
      var s = getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
      return [Math.min(res[0], s[0]), Math.max(res[1], s[1])];
    }, [Infinity, -Infinity]);
    return [Math.min(domain[0], result[0]), Math.max(domain[1], result[1])];
  }, [Infinity, -Infinity]).map(function (result) {
    return result === Infinity || result === -Infinity ? 0 : result;
  });
};
var MIN_VALUE_REG = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var MAX_VALUE_REG = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var parseSpecifiedDomain = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
  if (!__WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(specifiedDomain)) {
    return dataDomain;
  }

  var domain = [];
  /* eslint-disable prefer-destructuring */

  if (Object(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["h" /* isNumber */])(specifiedDomain[0])) {
    domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
  } else if (MIN_VALUE_REG.test(specifiedDomain[0])) {
    var value = +MIN_VALUE_REG.exec(specifiedDomain[0])[1];
    domain[0] = dataDomain[0] - value;
  } else if (__WEBPACK_IMPORTED_MODULE_8_lodash_isFunction___default()(specifiedDomain[0])) {
    domain[0] = specifiedDomain[0](dataDomain[0]);
  } else {
    domain[0] = dataDomain[0];
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["h" /* isNumber */])(specifiedDomain[1])) {
    domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
  } else if (MAX_VALUE_REG.test(specifiedDomain[1])) {
    var _value = +MAX_VALUE_REG.exec(specifiedDomain[1])[1];

    domain[1] = dataDomain[1] + _value;
  } else if (__WEBPACK_IMPORTED_MODULE_8_lodash_isFunction___default()(specifiedDomain[1])) {
    domain[1] = specifiedDomain[1](dataDomain[1]);
  } else {
    domain[1] = dataDomain[1];
  }
  /* eslint-enable prefer-destructuring */


  return domain;
};
/**
 * Calculate the size between two category
 * @param  {Object} axis  The options of axis
 * @param  {Array}  ticks The ticks of axis
 * @return {Number} Size
 */

var getBandSizeOfAxis = function getBandSizeOfAxis(axis, ticks) {
  if (axis && axis.scale && axis.scale.bandwidth) {
    return axis.scale.bandwidth();
  }

  if (axis && ticks && ticks.length >= 2) {
    var orderedTicks = __WEBPACK_IMPORTED_MODULE_1_lodash_sortBy___default()(ticks, function (o) {
      return o.coordinate;
    });

    var bandSize = Infinity;

    for (var i = 1, len = orderedTicks.length; i < len; i++) {
      var cur = orderedTicks[i];
      var prev = orderedTicks[i - 1];
      bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
    }

    return bandSize === Infinity ? 0 : bandSize;
  }

  return 0;
};
/**
 * parse the domain of a category axis when a domain is specified
 * @param   {Array}        specifiedDomain  The domain specified by users
 * @param   {Array}        calculatedDomain The domain calculated by dateKey
 * @param   {ReactElement} axisChild        The axis element
 * @returns {Array}        domains
 */

var parseDomainOfCategoryAxis = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
  if (!specifiedDomain || !specifiedDomain.length) {
    return calculatedDomain;
  }

  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(specifiedDomain, __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(axisChild, 'type.defaultProps.domain'))) {
    return calculatedDomain;
  }

  return specifiedDomain;
};

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = newInterval;
var t0 = new Date,
    t1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
  }

  interval.floor = function(date) {
    return floori(date = new Date(+date)), date;
  };

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [], previous;
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
    while (previous < start && start < stop);
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1448);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = configureStore;
exports.history = void 0;

var _redux = __webpack_require__(249);

var _reduxDevtoolsExtension = __webpack_require__(1108);

var _index = _interopRequireDefault(__webpack_require__(1109));

var _createHashHistory = _interopRequireDefault(__webpack_require__(1207));

var _reduxSaga = _interopRequireDefault(__webpack_require__(1211));

var _index2 = _interopRequireDefault(__webpack_require__(1218));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var history = (0, _createHashHistory["default"])();
exports.history = history;
var sagaMiddleware = (0, _reduxSaga["default"])();
var middlewares = [sagaMiddleware];

function configureStore(initialState) {
  var store = (0, _redux.createStore)(_index["default"], initialState, (0, _reduxDevtoolsExtension.composeWithDevTools)(_redux.applyMiddleware.apply(void 0, middlewares)));
  sagaMiddleware.run(_index2["default"]);

  if (false) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers/index', function () {
      var nextRootReducer = require('../reducers/index');

      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(history, "history", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/store/index.js");

  __REACT_HOT_LOADER__.register(sagaMiddleware, "sagaMiddleware", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/store/index.js");

  __REACT_HOT_LOADER__.register(middlewares, "middlewares", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/store/index.js");

  __REACT_HOT_LOADER__.register(configureStore, "configureStore", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/store/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/store/index.js");

  __REACT_HOT_LOADER__.register(_createHashHistory, "_createHashHistory", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/store/index.js");

  __REACT_HOT_LOADER__.register(_reduxSaga, "_reduxSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/store/index.js");

  __REACT_HOT_LOADER__.register(_index2, "_index2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/store/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/store/index.js");

  __REACT_HOT_LOADER__.register(history, "history", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/store/index.js");

  __REACT_HOT_LOADER__.register(sagaMiddleware, "sagaMiddleware", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/store/index.js");

  __REACT_HOT_LOADER__.register(middlewares, "middlewares", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/store/index.js");

  __REACT_HOT_LOADER__.register(configureStore, "configureStore", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/store/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/store/index.js");
}();

;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TABLE_NAME_FIELD_TIGHT_FIT_WIDTH = exports.TABLE_NAME_FIELD_WIDTH = exports.TIGHT_FIT_PARAM = exports.EMP_COLLECTION_NAME = exports.ORG_COLLECTION_NAME = exports.MOCK_DATA = void 0;
var MOCK_DATA = false;
exports.MOCK_DATA = MOCK_DATA;
var ORG_COLLECTION_NAME = 'organisations';
exports.ORG_COLLECTION_NAME = ORG_COLLECTION_NAME;
var EMP_COLLECTION_NAME = 'organisations'; // magic number to change the layout for smaller devices (mobiles)

exports.EMP_COLLECTION_NAME = EMP_COLLECTION_NAME;
var TIGHT_FIT_PARAM = 450;
exports.TIGHT_FIT_PARAM = TIGHT_FIT_PARAM;
var TABLE_NAME_FIELD_WIDTH = 500;
exports.TABLE_NAME_FIELD_WIDTH = TABLE_NAME_FIELD_WIDTH;
var TABLE_NAME_FIELD_TIGHT_FIT_WIDTH = 150;
exports.TABLE_NAME_FIELD_TIGHT_FIT_WIDTH = TABLE_NAME_FIELD_TIGHT_FIT_WIDTH;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MOCK_DATA, "MOCK_DATA", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/System.js");

  __REACT_HOT_LOADER__.register(ORG_COLLECTION_NAME, "ORG_COLLECTION_NAME", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/System.js");

  __REACT_HOT_LOADER__.register(EMP_COLLECTION_NAME, "EMP_COLLECTION_NAME", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/System.js");

  __REACT_HOT_LOADER__.register(TIGHT_FIT_PARAM, "TIGHT_FIT_PARAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/System.js");

  __REACT_HOT_LOADER__.register(TABLE_NAME_FIELD_WIDTH, "TABLE_NAME_FIELD_WIDTH", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/System.js");

  __REACT_HOT_LOADER__.register(TABLE_NAME_FIELD_TIGHT_FIT_WIDTH, "TABLE_NAME_FIELD_TIGHT_FIT_WIDTH", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/System.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MOCK_DATA, "MOCK_DATA", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/System.js");

  __REACT_HOT_LOADER__.register(ORG_COLLECTION_NAME, "ORG_COLLECTION_NAME", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/System.js");

  __REACT_HOT_LOADER__.register(EMP_COLLECTION_NAME, "EMP_COLLECTION_NAME", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/System.js");

  __REACT_HOT_LOADER__.register(TIGHT_FIT_PARAM, "TIGHT_FIT_PARAM", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/System.js");

  __REACT_HOT_LOADER__.register(TABLE_NAME_FIELD_WIDTH, "TABLE_NAME_FIELD_WIDTH", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/System.js");

  __REACT_HOT_LOADER__.register(TABLE_NAME_FIELD_TIGHT_FIT_WIDTH, "TABLE_NAME_FIELD_TIGHT_FIT_WIDTH", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/System.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/System.js");
}();

;

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = initRange;
/* harmony export (immutable) */ __webpack_exports__["a"] = initInterpolator;
function initRange(domain, range) {
  switch (arguments.length) {
    case 0: break;
    case 1: this.range(domain); break;
    default: this.range(range).domain(domain); break;
  }
  return this;
}

function initInterpolator(domain, interpolator) {
  switch (arguments.length) {
    case 0: break;
    case 1: this.interpolator(domain); break;
    default: this.interpolator(interpolator).domain(domain); break;
  }
  return this;
}


/***/ }),
/* 57 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 58 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(17);
var hide = __webpack_require__(69);
var has = __webpack_require__(68);
var SRC = __webpack_require__(132)('src');
var $toString = __webpack_require__(894);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(36).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
var fails = __webpack_require__(18);
var defined = __webpack_require__(97);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 61 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.10' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 62 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var getDisplayString = function getDisplayString(sub) {
  var arr = sub.split("-");

  if (arr.length > 1) {
    return arr[0].charAt(0).toUpperCase() + arr[0].slice(1) + " " + arr[1].charAt(0).toUpperCase() + arr[1].slice(1);
  } else {
    return sub.charAt(0).toUpperCase() + sub.slice(1);
  }
};

var getUrlString = function getUrlString(path, sub, index) {
  if (index === 0) {
    return '#/';
  } else {
    return '#/' + path.split(sub)[0] + sub;
  }
};

var ContainerHeader = function ContainerHeader(_ref) {
  var title = _ref.title,
      match = _ref.match; // const path = match.path.substr(1);
  // const subPath = path.split('/');

  return _react["default"].createElement("div", {
    className: "page-heading d-sm-flex justify-content-sm-between align-items-sm-center"
  }, _react["default"].createElement("h2", {
    className: "title mb-3 mb-sm-0"
  }, title));
};

var _default = ContainerHeader;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(getDisplayString, "getDisplayString", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ContainerHeader/index.js");

  __REACT_HOT_LOADER__.register(getUrlString, "getUrlString", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ContainerHeader/index.js");

  __REACT_HOT_LOADER__.register(ContainerHeader, "ContainerHeader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ContainerHeader/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ContainerHeader/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ContainerHeader/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ContainerHeader/index.js");

  __REACT_HOT_LOADER__.register(getDisplayString, "getDisplayString", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ContainerHeader/index.js");

  __REACT_HOT_LOADER__.register(getUrlString, "getUrlString", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ContainerHeader/index.js");

  __REACT_HOT_LOADER__.register(ContainerHeader, "ContainerHeader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ContainerHeader/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ContainerHeader/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ContainerHeader/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ContainerHeader/index.js");
}();

;

/***/ }),
/* 64 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			memo[selector] = fn.call(this, selector);
		}

		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(1305);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _SearchBox = _interopRequireDefault(__webpack_require__(427));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var AppModuleHeader =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AppModuleHeader, _React$Component);

  _createClass(AppModuleHeader, [{
    key: "__onSearchBoxSelect__REACT_HOT_LOADER__",
    value: function __onSearchBoxSelect__REACT_HOT_LOADER__() {
      this.setState({
        searchBox: !this.state.searchBox
      });
    }
  }]);

  function AppModuleHeader() {
    var _this;

    _classCallCheck(this, AppModuleHeader);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AppModuleHeader).call(this));

    _defineProperty(_assertThisInitialized(_this), "onSearchBoxSelect", function () {
      var _this2;

      return (_this2 = _this).__onSearchBoxSelect__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    _this.state = {
      searchBox: false,
      popoverOpen: false
    };
    _this.toggle = _this.toggle.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(AppModuleHeader, [{
    key: "toggle",
    value: function toggle() {
      this.setState({
        popoverOpen: !this.state.popoverOpen
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$searchBar = _this$props.searchBar,
          searchBar = _this$props$searchBar === void 0 ? true : _this$props$searchBar,
          placeholder = _this$props.placeholder,
          onChange = _this$props.onChange,
          value = _this$props.value,
          user = _this$props.user,
          notification = _this$props.notification,
          apps = _this$props.apps;
      return _react["default"].createElement("div", {
        className: "module-box-header-inner"
      }, _react["default"].createElement("div", {
        className: "search-bar right-side-icon bg-transparent d-none d-sm-block"
      }, searchBar ? _react["default"].createElement("div", {
        className: "form-group d-inline-block"
      }, _react["default"].createElement("input", {
        className: "form-control border-0",
        type: "search",
        placeholder: placeholder,
        onChange: onChange,
        value: value
      }), _react["default"].createElement("button", {
        className: "search-icon"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-search zmdi-hc-lg"
      }))) : null), _react["default"].createElement(_reactstrap.Popover, {
        className: "p-3",
        placement: "bottom",
        isOpen: this.state.popoverOpen,
        target: "Popover1",
        toggle: this.toggle
      }, _react["default"].createElement("h3", null, user.name)), _react["default"].createElement("div", {
        className: "d-inline-block d-sm-none"
      }, _react["default"].createElement(_reactstrap.Dropdown, {
        className: "quick-menu nav-searchbox",
        isOpen: this.state.searchBox,
        toggle: this.onSearchBoxSelect.bind(this)
      }, _react["default"].createElement(_reactstrap.DropdownToggle, {
        className: "d-inline-block",
        tag: "span",
        "data-toggle": "dropdown"
      }, _react["default"].createElement("span", {
        className: "icon-btn"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-search zmdi-hc-fw text-grey"
      }))), _react["default"].createElement(_reactstrap.DropdownMenu, {
        className: "p-0"
      }, _react["default"].createElement(_SearchBox["default"], {
        styleName: "search-dropdown",
        placeholder: "",
        onChange: onChange,
        value: value
      })))), _react["default"].createElement("div", {
        className: "module-box-header-right"
      }, apps && _react["default"].createElement("span", {
        className: "icon-btn "
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-apps zmdi-hc-lg "
      })), notification && _react["default"].createElement("span", {
        className: "icon-btn "
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-notifications-none zmdi-hc-lg "
      })), _react["default"].createElement("img", {
        className: "ml-2 rounded-circle size-40 pointer",
        id: "Popover1",
        alt: user.name,
        onMouseEnter: this.toggle,
        onMouseLeave: this.toggle,
        onClick: this.toggle,
        src: user.avatar
      })));
    }
  }]);

  return AppModuleHeader;
}(_react["default"].Component);

var _default = AppModuleHeader;
var _default2 = _default;
exports["default"] = _default2;
AppModuleHeader.defaultProps = {
  styleName: '',
  value: '',
  notification: true,
  apps: true
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AppModuleHeader, "AppModuleHeader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppModuleHeader/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppModuleHeader/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppModuleHeader/index.js");

  __REACT_HOT_LOADER__.register(_SearchBox, "_SearchBox", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppModuleHeader/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppModuleHeader/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppModuleHeader/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppModuleHeader/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppModuleHeader/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppModuleHeader/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppModuleHeader/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppModuleHeader/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppModuleHeader/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppModuleHeader/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppModuleHeader/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppModuleHeader/index.js");

  __REACT_HOT_LOADER__.register(AppModuleHeader, "AppModuleHeader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppModuleHeader/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppModuleHeader/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppModuleHeader/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppModuleHeader/index.js");
}();

;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(1119),
    baseMatchesProperty = __webpack_require__(1164),
    identity = __webpack_require__(158),
    isArray = __webpack_require__(26),
    property = __webpack_require__(1169);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 68 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(41);
var createDesc = __webpack_require__(131);
module.exports = __webpack_require__(40) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(204);
var defined = __webpack_require__(97);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return sym; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TASK; });
/* unused harmony export HELPER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MATCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SAGA_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SELF_CANCELLATION; });
/* unused harmony export konst */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return kTrue; });
/* unused harmony export kFalse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return noop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ident; });
/* harmony export (immutable) */ __webpack_exports__["h"] = check;
/* unused harmony export hasOwn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return is; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return object; });
/* harmony export (immutable) */ __webpack_exports__["w"] = remove;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return array; });
/* harmony export (immutable) */ __webpack_exports__["l"] = deferred;
/* harmony export (immutable) */ __webpack_exports__["g"] = arrayOfDeffered;
/* harmony export (immutable) */ __webpack_exports__["m"] = delay;
/* harmony export (immutable) */ __webpack_exports__["j"] = createMockTask;
/* unused harmony export autoInc */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return uid; });
/* harmony export (immutable) */ __webpack_exports__["t"] = makeIterator;
/* harmony export (immutable) */ __webpack_exports__["s"] = log;
/* harmony export (immutable) */ __webpack_exports__["n"] = deprecate;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return updateIncentive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return internalErr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return createSetContextWarning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return wrapSagaDispatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return cloneableGenerator; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var sym = function sym(id) {
  return '@@redux-saga/' + id;
};

var TASK = /*#__PURE__*/sym('TASK');
var HELPER = /*#__PURE__*/sym('HELPER');
var MATCH = /*#__PURE__*/sym('MATCH');
var CANCEL = /*#__PURE__*/sym('CANCEL_PROMISE');
var SAGA_ACTION = /*#__PURE__*/sym('SAGA_ACTION');
var SELF_CANCELLATION = /*#__PURE__*/sym('SELF_CANCELLATION');
var konst = function konst(v) {
  return function () {
    return v;
  };
};
var kTrue = /*#__PURE__*/konst(true);
var kFalse = /*#__PURE__*/konst(false);
var noop = function noop() {};
var ident = function ident(v) {
  return v;
};

function check(value, predicate, error) {
  if (!predicate(value)) {
    log('error', 'uncaught at check', error);
    throw new Error(error);
  }
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(object, property) {
  return is.notUndef(object) && hasOwnProperty.call(object, property);
}

var is = {
  undef: function undef(v) {
    return v === null || v === undefined;
  },
  notUndef: function notUndef(v) {
    return v !== null && v !== undefined;
  },
  func: function func(f) {
    return typeof f === 'function';
  },
  number: function number(n) {
    return typeof n === 'number';
  },
  string: function string(s) {
    return typeof s === 'string';
  },
  array: Array.isArray,
  object: function object(obj) {
    return obj && !is.array(obj) && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
  },
  promise: function promise(p) {
    return p && is.func(p.then);
  },
  iterator: function iterator(it) {
    return it && is.func(it.next) && is.func(it.throw);
  },
  iterable: function iterable(it) {
    return it && is.func(Symbol) ? is.func(it[Symbol.iterator]) : is.array(it);
  },
  task: function task(t) {
    return t && t[TASK];
  },
  observable: function observable(ob) {
    return ob && is.func(ob.subscribe);
  },
  buffer: function buffer(buf) {
    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
  },
  pattern: function pattern(pat) {
    return pat && (is.string(pat) || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
  },
  channel: function channel(ch) {
    return ch && is.func(ch.take) && is.func(ch.close);
  },
  helper: function helper(it) {
    return it && it[HELPER];
  },
  stringableFunc: function stringableFunc(f) {
    return is.func(f) && hasOwn(f, 'toString');
  }
};

var object = {
  assign: function assign(target, source) {
    for (var i in source) {
      if (hasOwn(source, i)) {
        target[i] = source[i];
      }
    }
  }
};

function remove(array, item) {
  var index = array.indexOf(item);
  if (index >= 0) {
    array.splice(index, 1);
  }
}

var array = {
  from: function from(obj) {
    var arr = Array(obj.length);
    for (var i in obj) {
      if (hasOwn(obj, i)) {
        arr[i] = obj[i];
      }
    }
    return arr;
  }
};

function deferred() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var def = _extends({}, props);
  var promise = new Promise(function (resolve, reject) {
    def.resolve = resolve;
    def.reject = reject;
  });
  def.promise = promise;
  return def;
}

function arrayOfDeffered(length) {
  var arr = [];
  for (var i = 0; i < length; i++) {
    arr.push(deferred());
  }
  return arr;
}

function delay(ms) {
  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var timeoutId = void 0;
  var promise = new Promise(function (resolve) {
    timeoutId = setTimeout(function () {
      return resolve(val);
    }, ms);
  });

  promise[CANCEL] = function () {
    return clearTimeout(timeoutId);
  };

  return promise;
}

function createMockTask() {
  var _ref;

  var running = true;
  var _result = void 0,
      _error = void 0;

  return _ref = {}, _ref[TASK] = true, _ref.isRunning = function isRunning() {
    return running;
  }, _ref.result = function result() {
    return _result;
  }, _ref.error = function error() {
    return _error;
  }, _ref.setRunning = function setRunning(b) {
    return running = b;
  }, _ref.setResult = function setResult(r) {
    return _result = r;
  }, _ref.setError = function setError(e) {
    return _error = e;
  }, _ref;
}

function autoInc() {
  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return function () {
    return ++seed;
  };
}

var uid = /*#__PURE__*/autoInc();

var kThrow = function kThrow(err) {
  throw err;
};
var kReturn = function kReturn(value) {
  return { value: value, done: true };
};
function makeIterator(next) {
  var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var isHelper = arguments[3];

  var iterator = { name: name, next: next, throw: thro, return: kReturn };

  if (isHelper) {
    iterator[HELPER] = true;
  }
  if (typeof Symbol !== 'undefined') {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }
  return iterator;
}

/**
  Print error in a useful way whether in a browser environment
  (with expandable error stack traces), or in a node.js environment
  (text-only log output)
 **/
function log(level, message) {
  var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  /*eslint-disable no-console*/
  if (typeof window === 'undefined') {
    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
  } else {
    console[level](message, error);
  }
}

function deprecate(fn, deprecationWarning) {
  return function () {
    if (false) log('warn', deprecationWarning);
    return fn.apply(undefined, arguments);
  };
}

var updateIncentive = function updateIncentive(deprecated, preferred) {
  return deprecated + ' has been deprecated in favor of ' + preferred + ', please update your code';
};

var internalErr = function internalErr(err) {
  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
};

var createSetContextWarning = function createSetContextWarning(ctx, props) {
  return (ctx ? ctx + '.' : '') + 'setContext(props): argument ' + props + ' is not a plain object';
};

var wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
  return function (action) {
    return dispatch(Object.defineProperty(action, SAGA_ACTION, { value: true }));
  };
};

var cloneableGenerator = function cloneableGenerator(generatorFunc) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var history = [];
    var gen = generatorFunc.apply(undefined, args);
    return {
      next: function next(arg) {
        history.push(arg);
        return gen.next(arg);
      },
      clone: function clone() {
        var clonedGen = cloneableGenerator(generatorFunc).apply(undefined, args);
        history.forEach(function (arg) {
          return clonedGen.next(arg);
        });
        return clonedGen;
      },
      return: function _return(value) {
        return gen.return(value);
      },
      throw: function _throw(exception) {
        return gen.throw(exception);
      }
    };
  };
};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.15';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // with lookup (in case of e.g. prototype pollution), and strip newlines if any.
      // A newline wouldn't be a valid sourceURL anyway, and it'd enable code injection.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/[\r\n]/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      // Like with sourceURL, we take care to not check the option's prototype,
      // as this configuration is a code injection vector.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57), __webpack_require__(209)(module)))

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(650);
var isBuffer = __webpack_require__(1226);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty__ = __webpack_require__(1358);

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty__["a" /* default */])(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Animate__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__easing__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AnimateGroup__ = __webpack_require__(1586);
/* unused harmony reexport configSpring */
/* unused harmony reexport configBezier */
/* unused harmony reexport AnimateGroup */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__util__["e"]; });





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Animate__["a" /* default */]);

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(687);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(627);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 79 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1772);

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(18);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RADIAN; });
/* unused harmony export degreeToRadian */
/* unused harmony export radianToDegree */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return polarToCartesian; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getMaxRadius; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatAxisMap; });
/* unused harmony export distanceBetweenPoints */
/* unused harmony export getAngleOfPoint */
/* unused harmony export formatAngleOfSector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return inRangeOfSector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DataUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChartUtils__ = __webpack_require__(51);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }



var RADIAN = Math.PI / 180;
var degreeToRadian = function degreeToRadian(angle) {
  return angle * Math.PI / 180;
};
var radianToDegree = function radianToDegree(angleInRadian) {
  return angleInRadian * 180 / Math.PI;
};
var polarToCartesian = function polarToCartesian(cx, cy, radius, angle) {
  return {
    x: cx + Math.cos(-RADIAN * angle) * radius,
    y: cy + Math.sin(-RADIAN * angle) * radius
  };
};
var getMaxRadius = function getMaxRadius(width, height) {
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
};
/**
 * Calculate the scale function, position, width, height of axes
 * @param  {Object} props     Latest props
 * @param  {Object} axisMap   The configuration of axes
 * @param  {Object} offset    The offset of main part in the svg element
 * @param  {Object} axisType  The type of axes, radius-axis or angle-axis
 * @param  {String} chartName The name of chart
 * @return {Object} Configuration
 */

var formatAxisMap = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
  var width = props.width,
      height = props.height;
  var startAngle = props.startAngle,
      endAngle = props.endAngle;
  var cx = Object(__WEBPACK_IMPORTED_MODULE_1__DataUtils__["d" /* getPercentValue */])(props.cx, width, width / 2);
  var cy = Object(__WEBPACK_IMPORTED_MODULE_1__DataUtils__["d" /* getPercentValue */])(props.cy, height, height / 2);
  var maxRadius = getMaxRadius(width, height, offset);
  var innerRadius = Object(__WEBPACK_IMPORTED_MODULE_1__DataUtils__["d" /* getPercentValue */])(props.innerRadius, maxRadius, 0);
  var outerRadius = Object(__WEBPACK_IMPORTED_MODULE_1__DataUtils__["d" /* getPercentValue */])(props.outerRadius, maxRadius, maxRadius * 0.8);
  var ids = Object.keys(axisMap);
  return ids.reduce(function (result, id) {
    var axis = axisMap[id];
    var domain = axis.domain,
        reversed = axis.reversed;
    var range;

    if (__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(axis.range)) {
      if (axisType === 'angleAxis') {
        range = [startAngle, endAngle];
      } else if (axisType === 'radiusAxis') {
        range = [innerRadius, outerRadius];
      }

      if (reversed) {
        range = [range[1], range[0]];
      }
    } else {
      range = axis.range;
      var _range = range;

      var _range2 = _slicedToArray(_range, 2);

      startAngle = _range2[0];
      endAngle = _range2[1];
    }

    var _parseScale = Object(__WEBPACK_IMPORTED_MODULE_2__ChartUtils__["z" /* parseScale */])(axis, chartName),
        realScaleType = _parseScale.realScaleType,
        scale = _parseScale.scale;

    scale.domain(domain).range(range);
    Object(__WEBPACK_IMPORTED_MODULE_2__ChartUtils__["c" /* checkDomainOfScale */])(scale);
    var ticks = Object(__WEBPACK_IMPORTED_MODULE_2__ChartUtils__["u" /* getTicksOfScale */])(scale, _objectSpread({}, axis, {
      realScaleType: realScaleType
    }));

    var finalAxis = _objectSpread({}, axis, {}, ticks, {
      range: range,
      radius: outerRadius,
      realScaleType: realScaleType,
      scale: scale,
      cx: cx,
      cy: cy,
      innerRadius: innerRadius,
      outerRadius: outerRadius,
      startAngle: startAngle,
      endAngle: endAngle
    });

    return _objectSpread({}, result, _defineProperty({}, id, finalAxis));
  }, {});
};
var distanceBetweenPoints = function distanceBetweenPoints(point, anotherPoint) {
  var x1 = point.x,
      y1 = point.y;
  var x2 = anotherPoint.x,
      y2 = anotherPoint.y;
  return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
};
var getAngleOfPoint = function getAngleOfPoint(_ref, _ref2) {
  var x = _ref.x,
      y = _ref.y;
  var cx = _ref2.cx,
      cy = _ref2.cy;
  var radius = distanceBetweenPoints({
    x: x,
    y: y
  }, {
    x: cx,
    y: cy
  });

  if (radius <= 0) {
    return {
      radius: radius
    };
  }

  var cos = (x - cx) / radius;
  var angleInRadian = Math.acos(cos);

  if (y > cy) {
    angleInRadian = 2 * Math.PI - angleInRadian;
  }

  return {
    radius: radius,
    angle: radianToDegree(angleInRadian),
    angleInRadian: angleInRadian
  };
};
var formatAngleOfSector = function formatAngleOfSector(_ref3) {
  var startAngle = _ref3.startAngle,
      endAngle = _ref3.endAngle;
  var startCnt = Math.floor(startAngle / 360);
  var endCnt = Math.floor(endAngle / 360);
  var min = Math.min(startCnt, endCnt);
  return {
    startAngle: startAngle - min * 360,
    endAngle: endAngle - min * 360
  };
};

var reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
  var startAngle = _ref4.startAngle,
      endAngle = _ref4.endAngle;
  var startCnt = Math.floor(startAngle / 360);
  var endCnt = Math.floor(endAngle / 360);
  var min = Math.min(startCnt, endCnt);
  return angle + min * 360;
};

var inRangeOfSector = function inRangeOfSector(_ref5, sector) {
  var x = _ref5.x,
      y = _ref5.y;

  var _getAngleOfPoint = getAngleOfPoint({
    x: x,
    y: y
  }, sector),
      radius = _getAngleOfPoint.radius,
      angle = _getAngleOfPoint.angle;

  var innerRadius = sector.innerRadius,
      outerRadius = sector.outerRadius;

  if (radius < innerRadius || radius > outerRadius) {
    return false;
  }

  if (radius === 0) {
    return true;
  }

  var _formatAngleOfSector = formatAngleOfSector(sector),
      startAngle = _formatAngleOfSector.startAngle,
      endAngle = _formatAngleOfSector.endAngle;

  var formatAngle = angle;
  var inRange;

  if (startAngle <= endAngle) {
    while (formatAngle > endAngle) {
      formatAngle -= 360;
    }

    while (formatAngle < startAngle) {
      formatAngle += 360;
    }

    inRange = formatAngle >= startAngle && formatAngle <= endAngle;
  } else {
    while (formatAngle > startAngle) {
      formatAngle -= 360;
    }

    while (formatAngle < endAngle) {
      formatAngle += 360;
    }

    inRange = formatAngle >= endAngle && formatAngle <= startAngle;
  }

  if (inRange) {
    return _objectSpread({}, sector, {
      radius: radius,
      angle: reverseFormatAngleOfSetor(formatAngle, sector)
    });
  }

  return null;
};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(350);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(85);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 86 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(205);
var createDesc = __webpack_require__(131);
var toIObject = __webpack_require__(70);
var toPrimitive = __webpack_require__(109);
var has = __webpack_require__(68);
var IE8_DOM_DEFINE = __webpack_require__(448);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(40) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(5);
var core = __webpack_require__(36);
var fails = __webpack_require__(18);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(84);
var IObject = __webpack_require__(204);
var toObject = __webpack_require__(49);
var toLength = __webpack_require__(32);
var asc = __webpack_require__(464);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(376)('wks');
var uid = __webpack_require__(270);
var Symbol = __webpack_require__(119).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bisect__ = __webpack_require__(740);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__bisect__["a"]; });
/* unused harmony reexport bisectRight */
/* unused harmony reexport bisectLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(190);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__ascending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bisector__ = __webpack_require__(741);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__bisector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cross__ = __webpack_require__(1610);
/* unused harmony reexport cross */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__descending__ = __webpack_require__(1611);
/* unused harmony reexport descending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__deviation__ = __webpack_require__(743);
/* unused harmony reexport deviation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__extent__ = __webpack_require__(745);
/* unused harmony reexport extent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__histogram__ = __webpack_require__(1612);
/* unused harmony reexport histogram */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__threshold_freedmanDiaconis__ = __webpack_require__(1615);
/* unused harmony reexport thresholdFreedmanDiaconis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__threshold_scott__ = __webpack_require__(1616);
/* unused harmony reexport thresholdScott */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__threshold_sturges__ = __webpack_require__(749);
/* unused harmony reexport thresholdSturges */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__max__ = __webpack_require__(1617);
/* unused harmony reexport max */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mean__ = __webpack_require__(1618);
/* unused harmony reexport mean */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__median__ = __webpack_require__(1619);
/* unused harmony reexport median */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__merge__ = __webpack_require__(1620);
/* unused harmony reexport merge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__min__ = __webpack_require__(750);
/* unused harmony reexport min */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pairs__ = __webpack_require__(742);
/* unused harmony reexport pairs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__permute__ = __webpack_require__(1621);
/* unused harmony reexport permute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__quantile__ = __webpack_require__(401);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_18__quantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__range__ = __webpack_require__(747);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_19__range__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__scan__ = __webpack_require__(1622);
/* unused harmony reexport scan */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__shuffle__ = __webpack_require__(1623);
/* unused harmony reexport shuffle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__sum__ = __webpack_require__(1624);
/* unused harmony reexport sum */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ticks__ = __webpack_require__(748);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_23__ticks__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_23__ticks__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_23__ticks__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__transpose__ = __webpack_require__(751);
/* unused harmony reexport transpose */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__variance__ = __webpack_require__(744);
/* unused harmony reexport variance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__zip__ = __webpack_require__(1625);
/* unused harmony reexport zip */





























/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(687);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReactTableDefaults", function() { return ReactTableDefaults; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lifecycle__ = __webpack_require__(1792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__methods__ = __webpack_require__(1793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__defaultProps__ = __webpack_require__(1794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__propTypes__ = __webpack_require__(1796);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



//






var ReactTableDefaults = __WEBPACK_IMPORTED_MODULE_5__defaultProps__["a" /* default */];

var ReactTable = function (_Methods) {
  _inherits(ReactTable, _Methods);

  function ReactTable(props) {
    _classCallCheck(this, ReactTable);

    var _this = _possibleConstructorReturn(this, (ReactTable.__proto__ || Object.getPrototypeOf(ReactTable)).call(this));

    _this.getResolvedState = _this.getResolvedState.bind(_this);
    _this.getDataModel = _this.getDataModel.bind(_this);
    _this.getSortedData = _this.getSortedData.bind(_this);
    _this.fireFetchData = _this.fireFetchData.bind(_this);
    _this.getPropOrState = _this.getPropOrState.bind(_this);
    _this.getStateOrProp = _this.getStateOrProp.bind(_this);
    _this.filterData = _this.filterData.bind(_this);
    _this.sortData = _this.sortData.bind(_this);
    _this.getMinRows = _this.getMinRows.bind(_this);
    _this.onPageChange = _this.onPageChange.bind(_this);
    _this.onPageSizeChange = _this.onPageSizeChange.bind(_this);
    _this.sortColumn = _this.sortColumn.bind(_this);
    _this.filterColumn = _this.filterColumn.bind(_this);
    _this.resizeColumnStart = _this.resizeColumnStart.bind(_this);
    _this.resizeColumnEnd = _this.resizeColumnEnd.bind(_this);
    _this.resizeColumnMoving = _this.resizeColumnMoving.bind(_this);

    _this.state = {
      page: props.defaultPage,
      pageSize: props.defaultPageSize,
      sorted: props.defaultSorted,
      expanded: props.defaultExpanded,
      filtered: props.defaultFiltered,
      resized: props.defaultResized,
      currentlyResizing: false,
      skipNextSort: false
    };
    return _this;
  }

  _createClass(ReactTable, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var resolvedState = this.getResolvedState();
      var children = resolvedState.children,
          className = resolvedState.className,
          style = resolvedState.style,
          getProps = resolvedState.getProps,
          getTableProps = resolvedState.getTableProps,
          getTheadGroupProps = resolvedState.getTheadGroupProps,
          getTheadGroupTrProps = resolvedState.getTheadGroupTrProps,
          getTheadGroupThProps = resolvedState.getTheadGroupThProps,
          getTheadProps = resolvedState.getTheadProps,
          getTheadTrProps = resolvedState.getTheadTrProps,
          getTheadThProps = resolvedState.getTheadThProps,
          getTheadFilterProps = resolvedState.getTheadFilterProps,
          getTheadFilterTrProps = resolvedState.getTheadFilterTrProps,
          getTheadFilterThProps = resolvedState.getTheadFilterThProps,
          getTbodyProps = resolvedState.getTbodyProps,
          getTrGroupProps = resolvedState.getTrGroupProps,
          getTrProps = resolvedState.getTrProps,
          getTdProps = resolvedState.getTdProps,
          getTfootProps = resolvedState.getTfootProps,
          getTfootTrProps = resolvedState.getTfootTrProps,
          getTfootTdProps = resolvedState.getTfootTdProps,
          getPaginationProps = resolvedState.getPaginationProps,
          getLoadingProps = resolvedState.getLoadingProps,
          getNoDataProps = resolvedState.getNoDataProps,
          getResizerProps = resolvedState.getResizerProps,
          showPagination = resolvedState.showPagination,
          showPaginationTop = resolvedState.showPaginationTop,
          showPaginationBottom = resolvedState.showPaginationBottom,
          manual = resolvedState.manual,
          loadingText = resolvedState.loadingText,
          noDataText = resolvedState.noDataText,
          sortable = resolvedState.sortable,
          multiSort = resolvedState.multiSort,
          resizable = resolvedState.resizable,
          filterable = resolvedState.filterable,
          pivotIDKey = resolvedState.pivotIDKey,
          pivotValKey = resolvedState.pivotValKey,
          pivotBy = resolvedState.pivotBy,
          subRowsKey = resolvedState.subRowsKey,
          aggregatedKey = resolvedState.aggregatedKey,
          originalKey = resolvedState.originalKey,
          indexKey = resolvedState.indexKey,
          groupedByPivotKey = resolvedState.groupedByPivotKey,
          loading = resolvedState.loading,
          pageSize = resolvedState.pageSize,
          page = resolvedState.page,
          sorted = resolvedState.sorted,
          filtered = resolvedState.filtered,
          resized = resolvedState.resized,
          expanded = resolvedState.expanded,
          pages = resolvedState.pages,
          onExpandedChange = resolvedState.onExpandedChange,
          TableComponent = resolvedState.TableComponent,
          TheadComponent = resolvedState.TheadComponent,
          TbodyComponent = resolvedState.TbodyComponent,
          TrGroupComponent = resolvedState.TrGroupComponent,
          TrComponent = resolvedState.TrComponent,
          ThComponent = resolvedState.ThComponent,
          TdComponent = resolvedState.TdComponent,
          TfootComponent = resolvedState.TfootComponent,
          PaginationComponent = resolvedState.PaginationComponent,
          LoadingComponent = resolvedState.LoadingComponent,
          SubComponent = resolvedState.SubComponent,
          NoDataComponent = resolvedState.NoDataComponent,
          ResizerComponent = resolvedState.ResizerComponent,
          ExpanderComponent = resolvedState.ExpanderComponent,
          PivotValueComponent = resolvedState.PivotValueComponent,
          PivotComponent = resolvedState.PivotComponent,
          AggregatedComponent = resolvedState.AggregatedComponent,
          FilterComponent = resolvedState.FilterComponent,
          PadRowComponent = resolvedState.PadRowComponent,
          resolvedData = resolvedState.resolvedData,
          allVisibleColumns = resolvedState.allVisibleColumns,
          headerGroups = resolvedState.headerGroups,
          hasHeaderGroups = resolvedState.hasHeaderGroups,
          sortedData = resolvedState.sortedData,
          currentlyResizing = resolvedState.currentlyResizing;

      // Pagination

      var startRow = pageSize * page;
      var endRow = startRow + pageSize;
      var pageRows = manual ? resolvedData : sortedData.slice(startRow, endRow);
      var minRows = this.getMinRows();
      var padRows = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].range(Math.max(minRows - pageRows.length, 0));

      var hasColumnFooter = allVisibleColumns.some(function (d) {
        return d.Footer;
      });
      var hasFilters = filterable || allVisibleColumns.some(function (d) {
        return d.filterable;
      });

      var recurseRowsViewIndex = function recurseRowsViewIndex(rows) {
        var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
        return [rows.map(function (row, i) {
          index += 1;
          var rowWithViewIndex = _extends({}, row, {
            _viewIndex: index
          });
          var newPath = path.concat([i]);
          if (rowWithViewIndex[subRowsKey] && __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].get(expanded, newPath)) {
            var _recurseRowsViewIndex = recurseRowsViewIndex(rowWithViewIndex[subRowsKey], newPath, index);

            var _recurseRowsViewIndex2 = _slicedToArray(_recurseRowsViewIndex, 2);

            rowWithViewIndex[subRowsKey] = _recurseRowsViewIndex2[0];
            index = _recurseRowsViewIndex2[1];
          }
          return rowWithViewIndex;
        }), index];
      };

      var _recurseRowsViewIndex3 = recurseRowsViewIndex(pageRows);

      var _recurseRowsViewIndex4 = _slicedToArray(_recurseRowsViewIndex3, 1);

      pageRows = _recurseRowsViewIndex4[0];


      var canPrevious = page > 0;
      var canNext = page + 1 < pages;

      var rowMinWidth = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].sum(allVisibleColumns.map(function (d) {
        var resizedColumn = resized.find(function (x) {
          return x.id === d.id;
        }) || {};
        return __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getFirstDefined(resizedColumn.value, d.width, d.minWidth);
      }));

      var rowIndex = -1;

      var finalState = _extends({}, resolvedState, {
        startRow: startRow,
        endRow: endRow,
        pageRows: pageRows,
        minRows: minRows,
        padRows: padRows,
        hasColumnFooter: hasColumnFooter,
        canPrevious: canPrevious,
        canNext: canNext,
        rowMinWidth: rowMinWidth
      });

      var rootProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getProps(finalState, undefined, undefined, this));
      var tableProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getTableProps(finalState, undefined, undefined, this));
      var tBodyProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getTbodyProps(finalState, undefined, undefined, this));
      var loadingProps = getLoadingProps(finalState, undefined, undefined, this);
      var noDataProps = getNoDataProps(finalState, undefined, undefined, this);

      // Visual Components

      var makeHeaderGroup = function makeHeaderGroup(column, i) {
        var resizedValue = function resizedValue(col) {
          return (resized.find(function (x) {
            return x.id === col.id;
          }) || {}).value;
        };
        var flex = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].sum(column.columns.map(function (col) {
          return col.width || resizedValue(col) ? 0 : col.minWidth;
        }));
        var width = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].sum(column.columns.map(function (col) {
          return __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getFirstDefined(resizedValue(col), col.width, col.minWidth);
        }));
        var maxWidth = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].sum(column.columns.map(function (col) {
          return __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getFirstDefined(resizedValue(col), col.width, col.maxWidth);
        }));

        var theadGroupThProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getTheadGroupThProps(finalState, undefined, column, _this2));
        var columnHeaderProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(column.getHeaderProps(finalState, undefined, column, _this2));

        var classes = [column.headerClassName, theadGroupThProps.className, columnHeaderProps.className];

        var styles = _extends({}, column.headerStyle, theadGroupThProps.style, columnHeaderProps.style);

        var rest = _extends({}, theadGroupThProps.rest, columnHeaderProps.rest);

        var flexStyles = {
          flex: flex + ' 0 auto',
          width: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].asPx(width),
          maxWidth: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].asPx(maxWidth)
        };

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          ThComponent,
          _extends({
            key: i + '-' + column.id,
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(classes),
            style: _extends({}, styles, flexStyles)
          }, rest),
          __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].normalizeComponent(column.Header, {
            data: sortedData,
            column: column
          })
        );
      };

      var makeHeaderGroups = function makeHeaderGroups() {
        var theadGroupProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getTheadGroupProps(finalState, undefined, undefined, _this2));
        var theadGroupTrProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getTheadGroupTrProps(finalState, undefined, undefined, _this2));
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          TheadComponent,
          _extends({
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('-headerGroups', theadGroupProps.className),
            style: _extends({}, theadGroupProps.style, {
              minWidth: rowMinWidth + 'px'
            })
          }, theadGroupProps.rest),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            TrComponent,
            _extends({
              className: theadGroupTrProps.className,
              style: theadGroupTrProps.style
            }, theadGroupTrProps.rest),
            headerGroups.map(makeHeaderGroup)
          )
        );
      };

      var makeHeader = function makeHeader(column, i) {
        var resizedCol = resized.find(function (x) {
          return x.id === column.id;
        }) || {};
        var sort = sorted.find(function (d) {
          return d.id === column.id;
        });
        var show = typeof column.show === 'function' ? column.show() : column.show;
        var width = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getFirstDefined(resizedCol.value, column.width, column.minWidth);
        var maxWidth = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getFirstDefined(resizedCol.value, column.width, column.maxWidth);
        var theadThProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getTheadThProps(finalState, undefined, column, _this2));
        var columnHeaderProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(column.getHeaderProps(finalState, undefined, column, _this2));

        var classes = [column.headerClassName, theadThProps.className, columnHeaderProps.className];

        var styles = _extends({}, column.headerStyle, theadThProps.style, columnHeaderProps.style);

        var rest = _extends({}, theadThProps.rest, columnHeaderProps.rest);

        var isResizable = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getFirstDefined(column.resizable, resizable, false);
        var resizer = isResizable ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResizerComponent, _extends({
          onMouseDown: function onMouseDown(e) {
            return _this2.resizeColumnStart(e, column, false);
          },
          onTouchStart: function onTouchStart(e) {
            return _this2.resizeColumnStart(e, column, true);
          }
        }, getResizerProps('finalState', undefined, column, _this2))) : null;

        var isSortable = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getFirstDefined(column.sortable, sortable, false);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          ThComponent,
          _extends({
            key: i + '-' + column.id,
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(classes, isResizable && 'rt-resizable-header', sort ? sort.desc ? '-sort-desc' : '-sort-asc' : '', isSortable && '-cursor-pointer', !show && '-hidden', pivotBy && pivotBy.slice(0, -1).includes(column.id) && 'rt-header-pivot'),
            style: _extends({}, styles, {
              flex: width + ' 0 auto',
              width: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].asPx(width),
              maxWidth: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].asPx(maxWidth)
            }),
            toggleSort: function toggleSort(e) {
              if (isSortable) _this2.sortColumn(column, multiSort ? e.shiftKey : false);
            }
          }, rest),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(isResizable && 'rt-resizable-header-content') },
            __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].normalizeComponent(column.Header, {
              data: sortedData,
              column: column
            })
          ),
          resizer
        );
      };

      var makeHeaders = function makeHeaders() {
        var theadProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getTheadProps(finalState, undefined, undefined, _this2));
        var theadTrProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getTheadTrProps(finalState, undefined, undefined, _this2));
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          TheadComponent,
          _extends({
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('-header', theadProps.className),
            style: _extends({}, theadProps.style, {
              minWidth: rowMinWidth + 'px'
            })
          }, theadProps.rest),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            TrComponent,
            _extends({
              className: theadTrProps.className,
              style: theadTrProps.style
            }, theadTrProps.rest),
            allVisibleColumns.map(makeHeader)
          )
        );
      };

      var makeFilter = function makeFilter(column, i) {
        var resizedCol = resized.find(function (x) {
          return x.id === column.id;
        }) || {};
        var width = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getFirstDefined(resizedCol.value, column.width, column.minWidth);
        var maxWidth = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getFirstDefined(resizedCol.value, column.width, column.maxWidth);
        var theadFilterThProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getTheadFilterThProps(finalState, undefined, column, _this2));
        var columnHeaderProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(column.getHeaderProps(finalState, undefined, column, _this2));

        var classes = [column.headerClassName, theadFilterThProps.className, columnHeaderProps.className];

        var styles = _extends({}, column.headerStyle, theadFilterThProps.style, columnHeaderProps.style);

        var rest = _extends({}, theadFilterThProps.rest, columnHeaderProps.rest);

        var filter = filtered.find(function (filter) {
          return filter.id === column.id;
        });

        var ResolvedFilterComponent = column.Filter || FilterComponent;

        var isFilterable = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getFirstDefined(column.filterable, filterable, false);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          ThComponent,
          _extends({
            key: i + '-' + column.id,
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(classes),
            style: _extends({}, styles, {
              flex: width + ' 0 auto',
              width: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].asPx(width),
              maxWidth: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].asPx(maxWidth)
            })
          }, rest),
          isFilterable ? __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].normalizeComponent(ResolvedFilterComponent, {
            column: column,
            filter: filter,
            onChange: function onChange(value) {
              return _this2.filterColumn(column, value);
            }
          }, __WEBPACK_IMPORTED_MODULE_5__defaultProps__["a" /* default */].column.Filter) : null
        );
      };

      var makeFilters = function makeFilters() {
        var theadFilterProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getTheadFilterProps(finalState, undefined, undefined, _this2));
        var theadFilterTrProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getTheadFilterTrProps(finalState, undefined, undefined, _this2));
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          TheadComponent,
          _extends({
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('-filters', theadFilterProps.className),
            style: _extends({}, theadFilterProps.style, {
              minWidth: rowMinWidth + 'px'
            })
          }, theadFilterProps.rest),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            TrComponent,
            _extends({
              className: theadFilterTrProps.className,
              style: theadFilterTrProps.style
            }, theadFilterTrProps.rest),
            allVisibleColumns.map(makeFilter)
          )
        );
      };

      var makePageRow = function makePageRow(row, i) {
        var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

        var rowInfo = {
          original: row[originalKey],
          row: row,
          index: row[indexKey],
          viewIndex: rowIndex += 1,
          pageSize: pageSize,
          page: page,
          level: path.length,
          nestingPath: path.concat([i]),
          aggregated: row[aggregatedKey],
          groupedByPivot: row[groupedByPivotKey],
          subRows: row[subRowsKey]
        };
        var isExpanded = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].get(expanded, rowInfo.nestingPath);
        var trGroupProps = getTrGroupProps(finalState, rowInfo, undefined, _this2);
        var trProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getTrProps(finalState, rowInfo, undefined, _this2));
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          TrGroupComponent,
          _extends({ key: rowInfo.nestingPath.join('_') }, trGroupProps),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            TrComponent,
            _extends({
              className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(trProps.className, row._viewIndex % 2 ? '-even' : '-odd'),
              style: trProps.style
            }, trProps.rest),
            allVisibleColumns.map(function (column, i2) {
              var resizedCol = resized.find(function (x) {
                return x.id === column.id;
              }) || {};
              var show = typeof column.show === 'function' ? column.show() : column.show;
              var width = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getFirstDefined(resizedCol.value, column.width, column.minWidth);
              var maxWidth = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getFirstDefined(resizedCol.value, column.width, column.maxWidth);
              var tdProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getTdProps(finalState, rowInfo, column, _this2));
              var columnProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(column.getProps(finalState, rowInfo, column, _this2));

              var classes = [tdProps.className, column.className, columnProps.className];

              var styles = _extends({}, tdProps.style, column.style, columnProps.style);

              var cellInfo = _extends({}, rowInfo, {
                isExpanded: isExpanded,
                column: _extends({}, column),
                value: rowInfo.row[column.id],
                pivoted: column.pivoted,
                expander: column.expander,
                resized: resized,
                show: show,
                width: width,
                maxWidth: maxWidth,
                tdProps: tdProps,
                columnProps: columnProps,
                classes: classes,
                styles: styles
              });

              var value = cellInfo.value;

              var useOnExpanderClick = void 0;
              var isBranch = void 0;
              var isPreview = void 0;

              var onExpanderClick = function onExpanderClick(e) {
                var newExpanded = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].clone(expanded);
                if (isExpanded) {
                  newExpanded = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].set(newExpanded, cellInfo.nestingPath, false);
                } else {
                  newExpanded = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].set(newExpanded, cellInfo.nestingPath, {});
                }

                return _this2.setStateWithData({
                  expanded: newExpanded
                }, function () {
                  return onExpandedChange && onExpandedChange(newExpanded, cellInfo.nestingPath, e, cellInfo);
                });
              };

              // Default to a standard cell
              var resolvedCell = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].normalizeComponent(column.Cell, cellInfo, value);

              // Resolve Renderers
              var ResolvedAggregatedComponent = column.Aggregated || (!column.aggregate ? AggregatedComponent : column.Cell);
              var ResolvedExpanderComponent = column.Expander || ExpanderComponent;
              var ResolvedPivotValueComponent = column.PivotValue || PivotValueComponent;
              var DefaultResolvedPivotComponent = PivotComponent || function (props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResolvedExpanderComponent, props),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResolvedPivotValueComponent, props)
                );
              };
              var ResolvedPivotComponent = column.Pivot || DefaultResolvedPivotComponent;

              // Is this cell expandable?
              if (cellInfo.pivoted || cellInfo.expander) {
                // Make it expandable by defualt
                cellInfo.expandable = true;
                useOnExpanderClick = true;
                // If pivoted, has no subRows, and does not have a subComponent,
                // do not make expandable
                if (cellInfo.pivoted && !cellInfo.subRows && !SubComponent) {
                  cellInfo.expandable = false;
                }
              }

              if (cellInfo.pivoted) {
                // Is this column a branch?
                isBranch = rowInfo.row[pivotIDKey] === column.id && cellInfo.subRows;
                // Should this column be blank?
                isPreview = pivotBy.indexOf(column.id) > pivotBy.indexOf(rowInfo.row[pivotIDKey]) && cellInfo.subRows;
                // Pivot Cell Render Override
                if (isBranch) {
                  // isPivot
                  resolvedCell = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].normalizeComponent(ResolvedPivotComponent, _extends({}, cellInfo, {
                    value: row[pivotValKey]
                  }), row[pivotValKey]);
                } else if (isPreview) {
                  // Show the pivot preview
                  resolvedCell = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].normalizeComponent(ResolvedAggregatedComponent, cellInfo, value);
                } else {
                  resolvedCell = null;
                }
              } else if (cellInfo.aggregated) {
                resolvedCell = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].normalizeComponent(ResolvedAggregatedComponent, cellInfo, value);
              }

              if (cellInfo.expander) {
                resolvedCell = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].normalizeComponent(ResolvedExpanderComponent, cellInfo, row[pivotValKey]);
                if (pivotBy) {
                  if (cellInfo.groupedByPivot) {
                    resolvedCell = null;
                  }
                  if (!cellInfo.subRows && !SubComponent) {
                    resolvedCell = null;
                  }
                }
              }

              var resolvedOnExpanderClick = useOnExpanderClick ? onExpanderClick : function () {};

              // If there are multiple onClick events, make sure they don't
              // override eachother. This should maybe be expanded to handle all
              // function attributes
              var interactionProps = {
                onClick: resolvedOnExpanderClick
              };

              if (tdProps.rest.onClick) {
                interactionProps.onClick = function (e) {
                  tdProps.rest.onClick(e, function () {
                    return resolvedOnExpanderClick(e);
                  });
                };
              }

              if (columnProps.rest.onClick) {
                interactionProps.onClick = function (e) {
                  columnProps.rest.onClick(e, function () {
                    return resolvedOnExpanderClick(e);
                  });
                };
              }

              // Return the cell
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                TdComponent
                // eslint-disable-next-line react/no-array-index-key
                ,
                _extends({ key: i2 + '-' + column.id,
                  className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(classes, !cellInfo.expandable && !show && 'hidden', cellInfo.expandable && 'rt-expandable', (isBranch || isPreview) && 'rt-pivot'),
                  style: _extends({}, styles, {
                    flex: width + ' 0 auto',
                    width: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].asPx(width),
                    maxWidth: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].asPx(maxWidth)
                  })
                }, tdProps.rest, columnProps.rest, interactionProps),
                resolvedCell
              );
            })
          ),
          rowInfo.subRows && isExpanded && rowInfo.subRows.map(function (d, i) {
            return makePageRow(d, i, rowInfo.nestingPath);
          }),
          SubComponent && !rowInfo.subRows && isExpanded && SubComponent(rowInfo, function () {
            var newExpanded = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].clone(expanded);

            __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].set(newExpanded, rowInfo.nestingPath, false);
          })
        );
      };

      var makePadColumn = function makePadColumn(column, i) {
        var resizedCol = resized.find(function (x) {
          return x.id === column.id;
        }) || {};
        var show = typeof column.show === 'function' ? column.show() : column.show;
        var width = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getFirstDefined(resizedCol.value, column.width, column.minWidth);
        var flex = width;
        var maxWidth = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getFirstDefined(resizedCol.value, column.width, column.maxWidth);
        var tdProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getTdProps(finalState, undefined, column, _this2));
        var columnProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(column.getProps(finalState, undefined, column, _this2));

        var classes = [tdProps.className, column.className, columnProps.className];

        var styles = _extends({}, tdProps.style, column.style, columnProps.style);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          TdComponent,
          _extends({
            key: i + '-' + column.id,
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(classes, !show && 'hidden'),
            style: _extends({}, styles, {
              flex: flex + ' 0 auto',
              width: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].asPx(width),
              maxWidth: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].asPx(maxWidth)
            })
          }, tdProps.rest),
          __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].normalizeComponent(PadRowComponent)
        );
      };

      var makePadRow = function makePadRow(row, i) {
        var trGroupProps = getTrGroupProps(finalState, undefined, undefined, _this2);
        var trProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getTrProps(finalState, undefined, undefined, _this2));
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          TrGroupComponent,
          _extends({ key: 'pad-' + i }, trGroupProps),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            TrComponent,
            {
              className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('-padRow', (pageRows.length + i) % 2 ? '-even' : '-odd', trProps.className),
              style: trProps.style || {}
            },
            allVisibleColumns.map(makePadColumn)
          )
        );
      };

      var makeColumnFooter = function makeColumnFooter(column, i) {
        var resizedCol = resized.find(function (x) {
          return x.id === column.id;
        }) || {};
        var show = typeof column.show === 'function' ? column.show() : column.show;
        var width = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getFirstDefined(resizedCol.value, column.width, column.minWidth);
        var maxWidth = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getFirstDefined(resizedCol.value, column.width, column.maxWidth);
        var tFootTdProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getTfootTdProps(finalState, undefined, column, _this2));
        var columnProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(column.getProps(finalState, undefined, column, _this2));
        var columnFooterProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(column.getFooterProps(finalState, undefined, column, _this2));

        var classes = [tFootTdProps.className, column.className, columnProps.className, columnFooterProps.className];

        var styles = _extends({}, tFootTdProps.style, column.style, columnProps.style, columnFooterProps.style);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          TdComponent,
          _extends({
            key: i + '-' + column.id,
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(classes, !show && 'hidden'),
            style: _extends({}, styles, {
              flex: width + ' 0 auto',
              width: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].asPx(width),
              maxWidth: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].asPx(maxWidth)
            })
          }, columnProps.rest, tFootTdProps.rest, columnFooterProps.rest),
          __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].normalizeComponent(column.Footer, {
            data: sortedData,
            column: column
          })
        );
      };

      var makeColumnFooters = function makeColumnFooters() {
        var tFootProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getTfootProps(finalState, undefined, undefined, _this2));
        var tFootTrProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getTfootTrProps(finalState, undefined, undefined, _this2));
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          TfootComponent,
          _extends({
            className: tFootProps.className,
            style: _extends({}, tFootProps.style, {
              minWidth: rowMinWidth + 'px'
            })
          }, tFootProps.rest),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            TrComponent,
            _extends({
              className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(tFootTrProps.className),
              style: tFootTrProps.style
            }, tFootTrProps.rest),
            allVisibleColumns.map(makeColumnFooter)
          )
        );
      };

      var makePagination = function makePagination(isTop) {
        var paginationProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getPaginationProps(finalState, undefined, undefined, _this2));
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PaginationComponent, _extends({}, resolvedState, {
          pages: pages,
          canPrevious: canPrevious,
          canNext: canNext,
          onPageChange: _this2.onPageChange,
          onPageSizeChange: _this2.onPageSizeChange,
          className: paginationProps.className,
          style: paginationProps.style,
          isTop: isTop
        }, paginationProps.rest));
      };

      var makeTable = function makeTable() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          _extends({
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ReactTable', className, rootProps.className),
            style: _extends({}, style, rootProps.style)
          }, rootProps.rest),
          showPagination && showPaginationTop ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'pagination-top' },
            makePagination(true)
          ) : null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            TableComponent,
            _extends({
              className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(tableProps.className, currentlyResizing ? 'rt-resizing' : ''),
              style: tableProps.style
            }, tableProps.rest),
            hasHeaderGroups ? makeHeaderGroups() : null,
            makeHeaders(),
            hasFilters ? makeFilters() : null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              TbodyComponent,
              _extends({
                className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(tBodyProps.className),
                style: _extends({}, tBodyProps.style, {
                  minWidth: rowMinWidth + 'px'
                })
              }, tBodyProps.rest),
              pageRows.map(function (d, i) {
                return makePageRow(d, i);
              }),
              padRows.map(makePadRow)
            ),
            hasColumnFooter ? makeColumnFooters() : null
          ),
          showPagination && showPaginationBottom ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'pagination-bottom' },
            makePagination(false)
          ) : null,
          !pageRows.length && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            NoDataComponent,
            noDataProps,
            __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].normalizeComponent(noDataText)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LoadingComponent, _extends({ loading: loading, loadingText: loadingText }, loadingProps))
        );
      };

      // childProps are optionally passed to a function-as-a-child
      return children ? children(finalState, makeTable, this) : makeTable();
    }
  }]);

  return ReactTable;
}(Object(__WEBPACK_IMPORTED_MODULE_4__methods__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__lifecycle__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_react__["Component"])));

ReactTable.propTypes = __WEBPACK_IMPORTED_MODULE_6__propTypes__["a" /* default */];
ReactTable.defaultProps = __WEBPACK_IMPORTED_MODULE_5__defaultProps__["a" /* default */];
/* harmony default export */ __webpack_exports__["default"] = (ReactTable);
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1797);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(65)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../css-loader/index.js!./react-table.css", function() {
			var newContent = require("!!../css-loader/index.js!./react-table.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rankings", function() { return rankings; });
function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var diacritics = createCommonjsModule(function (module) {
// Diacritics.js
// 
// Started as something to be an equivalent of the Google Java Library diacritics library for JavaScript.
// Found this: http://jsperf.com/diacritics/6 and converted it into a reusable module.
// 
// @author Nijiko Yonskai
// @license MIT
// @copyright Nijikokun 2013 <nijikokun@gmail.com>
(function (name, definition) {
  if ('object' != 'undefined' && module.exports) module.exports = definition();
  else if (false) undefined(definition);
  else this[name] = definition();
})('Diacritics', function () {
  // Create public object
  var output = {
    map: {}
  };

  // Create private reference map.
  var reference = [
    {'base':' ',    'letters':'\u00A0'},
    {'base':'A',    'letters':'\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'},
    {'base':'AA',   'letters':'\uA732'},
    {'base':'AE',   'letters':'\u00C6\u01FC\u01E2'},
    {'base':'AO',   'letters':'\uA734'},
    {'base':'AU',   'letters':'\uA736'},
    {'base':'AV',   'letters':'\uA738\uA73A'},
    {'base':'AY',   'letters':'\uA73C'},
    {'base':'B',    'letters':'\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'},
    {'base':'C',    'letters':'\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'},
    {'base':'D',    'letters':'\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'},
    {'base':'DZ',   'letters':'\u01F1\u01C4'},
    {'base':'Dz',   'letters':'\u01F2\u01C5'},
    {'base':'E',    'letters':'\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'},
    {'base':'F',    'letters':'\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'},
    {'base':'G',    'letters':'\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'},
    {'base':'H',    'letters':'\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'},
    {'base':'I',    'letters':'\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'},
    {'base':'J',    'letters':'\u004A\u24BF\uFF2A\u0134\u0248'},
    {'base':'K',    'letters':'\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'},
    {'base':'L',    'letters':'\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'},
    {'base':'LJ',   'letters':'\u01C7'},
    {'base':'Lj',   'letters':'\u01C8'},
    {'base':'M',    'letters':'\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'},
    {'base':'N',    'letters':'\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'},
    {'base':'NJ',   'letters':'\u01CA'},
    {'base':'Nj',   'letters':'\u01CB'},
    {'base':'O',    'letters':'\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'},
    {'base':'OI',   'letters':'\u01A2'},
    {'base':'OO',   'letters':'\uA74E'},
    {'base':'OU',   'letters':'\u0222'},
    {'base':'P',    'letters':'\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'},
    {'base':'Q',    'letters':'\u0051\u24C6\uFF31\uA756\uA758\u024A'},
    {'base':'R',    'letters':'\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'},
    {'base':'S',    'letters':'\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'},
    {'base':'T',    'letters':'\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'},
    {'base':'Th',   'letters':'\u00DE'},
    {'base':'TZ',   'letters':'\uA728'},
    {'base':'U',    'letters':'\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'},
    {'base':'V',    'letters':'\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'},
    {'base':'VY',   'letters':'\uA760'},
    {'base':'W',    'letters':'\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'},
    {'base':'X',    'letters':'\u0058\u24CD\uFF38\u1E8A\u1E8C'},
    {'base':'Y',    'letters':'\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'},
    {'base':'Z',    'letters':'\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'},
    {'base':'a',    'letters':'\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250\u0251'},
    {'base':'aa',   'letters':'\uA733'},
    {'base':'ae',   'letters':'\u00E6\u01FD\u01E3'},
    {'base':'ao',   'letters':'\uA735'},
    {'base':'au',   'letters':'\uA737'},
    {'base':'av',   'letters':'\uA739\uA73B'},
    {'base':'ay',   'letters':'\uA73D'},
    {'base':'b',    'letters':'\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'},
    {'base':'c',    'letters':'\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'},
    {'base':'d',    'letters':'\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'},
    {'base':'dz',   'letters':'\u01F3\u01C6'},
    {'base':'e',    'letters':'\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'},
    {'base':'f',    'letters':'\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'},
    {'base':'ff',   'letters':'\uFB00'},
    {'base':'fi',   'letters':'\uFB01'},
    {'base':'fl',   'letters':'\uFB02'},
    {'base':'ffi',  'letters':'\uFB03'},
    {'base':'ffl',  'letters':'\uFB04'},
    {'base':'g',    'letters':'\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'},
    {'base':'h',    'letters':'\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'},
    {'base':'hv',   'letters':'\u0195'},
    {'base':'i',    'letters':'\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'},
    {'base':'j',    'letters':'\u006A\u24D9\uFF4A\u0135\u01F0\u0249'},
    {'base':'k',    'letters':'\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'},
    {'base':'l',    'letters':'\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'},
    {'base':'lj',   'letters':'\u01C9'},
    {'base':'m',    'letters':'\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'},
    {'base':'n',    'letters':'\x6E\xF1\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5\u043B\u0509'},
    {'base':'nj',   'letters':'\u01CC'},
    {'base':'o',    'letters':'\u07C0\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'},
    {'base':'oe',   'letters':'\u0152\u0153'},
    {'base':'oi',   'letters':'\u01A3'},
    {'base':'ou',   'letters':'\u0223'},
    {'base':'oo',   'letters':'\uA74F'},
    {'base':'p',    'letters':'\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'},
    {'base':'q',    'letters':'\u0071\u24E0\uFF51\u024B\uA757\uA759'},
    {'base':'r',    'letters':'\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'},
    {'base':'s',    'letters':'\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'},
    {'base':'ss',   'letters':'\xDF'},
    {'base':'t',    'letters':'\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'},
    {'base':'th',   'letters':'\u00FE'},
    {'base':'tz',   'letters':'\uA729'},
    {'base':'u',    'letters': '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'},
    {'base':'v',    'letters':'\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'},
    {'base':'vy',   'letters':'\uA761'},
    {'base':'w',    'letters':'\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'},
    {'base':'x',    'letters':'\u0078\u24E7\uFF58\u1E8B\u1E8D'},
    {'base':'y',    'letters':'\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'},
    {'base':'z',    'letters':'\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'}
  ];

  // Generate reference mapping
  for (var i = 0, refLength = reference.length; i < refLength; i++){
    var letters = reference[i].letters.split("");

    for (var j = 0, letLength = letters.length; j < letLength; j++){
      output.map[letters[j]] = reference[i].base;
    }
  }

  /**
   * Clean accents (diacritics) from string.
   * 
   * @param  {String} input String to be cleaned of diacritics.
   * @return {String}
   */
  output.clean = function (input) {
    if (!input || !input.length || input.length < 1) {
      return "";
    }

    var string = "";
    var letters = input.split("");
    var index = 0;
    var length = letters.length;
    var letter;

    for (; index < length; index++) {
      letter = letters[index];
      string += letter in output.map ? output.map[letter] : letter;
    }

    return string;
  };

  return output;
});
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * @name match-sorter
 * @license MIT license.
 * @copyright (c) 2017 Kent C. Dodds
 * @author Kent C. Dodds <kent@doddsfamily.us>
 */

var rankings = {
  CASE_SENSITIVE_EQUAL: 9,
  EQUAL: 8,
  STARTS_WITH: 7,
  WORD_STARTS_WITH: 6,
  STRING_CASE: 5,
  STRING_CASE_ACRONYM: 4,
  CONTAINS: 3,
  ACRONYM: 2,
  MATCHES: 1,
  NO_MATCH: 0
};

var caseRankings = {
  CAMEL: 0.8,
  PASCAL: 0.6,
  KEBAB: 0.4,
  SNAKE: 0.2,
  NO_CASE: 0
};

matchSorter.rankings = rankings;
matchSorter.caseRankings = caseRankings;

/**
 * Takes an array of items and a value and returns a new array with the items that match the given value
 * @param {Array} items - the items to sort
 * @param {String} value - the value to use for ranking
 * @param {Object} options - Some options to configure the sorter
 * @return {Array} - the new sorted array
 */
function matchSorter(items, value) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  // not performing any search/sort if value(search term) is empty
  if (!value) return items;

  var keys = options.keys,
      _options$threshold = options.threshold,
      threshold = _options$threshold === undefined ? rankings.MATCHES : _options$threshold;

  var matchedItems = items.reduce(function (matches, item, index) {
    var _getHighestRanking = getHighestRanking(item, keys, value, options),
        rank = _getHighestRanking.rank,
        keyIndex = _getHighestRanking.keyIndex,
        _getHighestRanking$ke = _getHighestRanking.keyThreshold,
        keyThreshold = _getHighestRanking$ke === undefined ? threshold : _getHighestRanking$ke;

    if (rank >= keyThreshold) {
      matches.push({ item: item, rank: rank, index: index, keyIndex: keyIndex });
    }
    return matches;
  }, []);
  return matchedItems.sort(sortRankedItems).map(function (_ref) {
    var item = _ref.item;
    return item;
  });
}

/**
 * Gets the highest ranking for value for the given item based on its values for the given keys
 * @param {*} item - the item to rank
 * @param {Array} keys - the keys to get values from the item for the ranking
 * @param {String} value - the value to rank against
 * @param {Object} options - options to control the ranking
 * @return {{rank: Number, keyIndex: Number, keyThreshold: Number}} - the highest ranking
 */
function getHighestRanking(item, keys, value, options) {
  if (!keys) {
    return {
      rank: getMatchRanking(item, value, options),
      keyIndex: -1,
      keyThreshold: options.threshold
    };
  }
  var valuesToRank = getAllValuesToRank(item, keys);
  return valuesToRank.reduce(function (_ref2, _ref3, i) {
    var rank = _ref2.rank,
        keyIndex = _ref2.keyIndex,
        keyThreshold = _ref2.keyThreshold;
    var itemValue = _ref3.itemValue,
        attributes = _ref3.attributes;

    var newRank = getMatchRanking(itemValue, value, options);
    var minRanking = attributes.minRanking,
        maxRanking = attributes.maxRanking,
        threshold = attributes.threshold;

    if (newRank < minRanking && newRank >= rankings.MATCHES) {
      newRank = minRanking;
    } else if (newRank > maxRanking) {
      newRank = maxRanking;
    }
    if (newRank > rank) {
      rank = newRank;
      keyIndex = i;
      keyThreshold = threshold;
    }
    return { rank: rank, keyIndex: keyIndex, keyThreshold: keyThreshold };
  }, { rank: rankings.NO_MATCH, keyIndex: -1, keyThreshold: options.threshold });
}

/**
 * Gives a rankings score based on how well the two strings match.
 * @param {String} testString - the string to test against
 * @param {String} stringToRank - the string to rank
 * @param {Object} options - options for the match (like keepDiacritics for comparison)
 * @returns {Number} the ranking for how well stringToRank matches testString
 */
function getMatchRanking(testString, stringToRank, options) {
  /* eslint complexity:[2, 12] */
  testString = prepareValueForComparison(testString, options);
  stringToRank = prepareValueForComparison(stringToRank, options);

  // too long
  if (stringToRank.length > testString.length) {
    return rankings.NO_MATCH;
  }

  // case sensitive equals
  if (testString === stringToRank) {
    return rankings.CASE_SENSITIVE_EQUAL;
  }

  var caseRank = getCaseRanking(testString);
  var isPartial = isPartialOfCase(testString, stringToRank, caseRank);
  var isCasedAcronym = isCaseAcronym(testString, stringToRank, caseRank);

  // Lower casing before further comparison
  testString = testString.toLowerCase();
  stringToRank = stringToRank.toLowerCase();

  // case insensitive equals
  if (testString === stringToRank) {
    return rankings.EQUAL + caseRank;
  }

  // starts with
  if (testString.indexOf(stringToRank) === 0) {
    return rankings.STARTS_WITH + caseRank;
  }

  // word starts with
  if (testString.indexOf(' ' + stringToRank) !== -1) {
    return rankings.WORD_STARTS_WITH + caseRank;
  }

  // is a part inside a cased string
  if (isPartial) {
    return rankings.STRING_CASE + caseRank;
  }

  // is acronym for a cased string
  if (caseRank > 0 && isCasedAcronym) {
    return rankings.STRING_CASE_ACRONYM + caseRank;
  }

  // contains
  if (testString.indexOf(stringToRank) !== -1) {
    return rankings.CONTAINS + caseRank;
  } else if (stringToRank.length === 1) {
    // If the only character in the given stringToRank
    //   isn't even contained in the testString, then
    //   it's definitely not a match.
    return rankings.NO_MATCH;
  }

  // acronym
  if (getAcronym(testString).indexOf(stringToRank) !== -1) {
    return rankings.ACRONYM + caseRank;
  }

  // will return a number between rankings.MATCHES and
  // rankings.MATCHES + 1 depending  on how close of a match it is.
  return getClosenessRanking(testString, stringToRank);
}

/**
 * Generates an acronym for a string.
 *
 * @param {String} string the string for which to produce the acronym
 * @returns {String} the acronym
 */
function getAcronym(string) {
  var acronym = '';
  var wordsInString = string.split(' ');
  wordsInString.forEach(function (wordInString) {
    var splitByHyphenWords = wordInString.split('-');
    splitByHyphenWords.forEach(function (splitByHyphenWord) {
      acronym += splitByHyphenWord.substr(0, 1);
    });
  });
  return acronym;
}

/**
 * Returns a score base on the case of the testString
 * @param {String} testString - the string to test against
 * @returns {Number} the number of the ranking,
 * based on the case between 0 and 1 for how the testString matches the case
 */
function getCaseRanking(testString) {
  var containsUpperCase = testString.toLowerCase() !== testString;
  var containsDash = testString.indexOf('-') >= 0;
  var containsUnderscore = testString.indexOf('_') >= 0;

  if (!containsUpperCase && !containsUnderscore && containsDash) {
    return caseRankings.KEBAB;
  }

  if (!containsUpperCase && containsUnderscore && !containsDash) {
    return caseRankings.SNAKE;
  }

  if (containsUpperCase && !containsDash && !containsUnderscore) {
    var startsWithUpperCase = testString[0].toUpperCase() === testString[0];
    if (startsWithUpperCase) {
      return caseRankings.PASCAL;
    }

    return caseRankings.CAMEL;
  }

  return caseRankings.NO_CASE;
}

/**
 * Returns whether the stringToRank is one of the case parts in the testString (works with any string case)
 * @example
 * // returns true
 * isPartialOfCase('helloWorld', 'world', caseRankings.CAMEL)
 * @example
 * // returns false
 * isPartialOfCase('helloWorld', 'oworl', caseRankings.CAMEL)
 * @param {String} testString - the string to test against
 * @param {String} stringToRank - the string to rank
 * @param {Number} caseRanking - the ranking score based on case of testString
 * @returns {Boolean} whether the stringToRank is one of the case parts in the testString
 */
function isPartialOfCase(testString, stringToRank, caseRanking) {
  var testIndex = testString.toLowerCase().indexOf(stringToRank.toLowerCase());

  switch (caseRanking) {
    case caseRankings.SNAKE:
      return testString[testIndex - 1] === '_';
    case caseRankings.KEBAB:
      return testString[testIndex - 1] === '-';
    case caseRankings.PASCAL:
    case caseRankings.CAMEL:
      return testIndex !== -1 && testString[testIndex] === testString[testIndex].toUpperCase();
    default:
      return false;
  }
}

/**
 * Check if stringToRank is an acronym for a partial case
 * @example
 * // returns true
 * isCaseAcronym('super_duper_file', 'sdf', caseRankings.SNAKE)
 * @param {String} testString - the string to test against
 * @param {String} stringToRank - the acronym to test
 * @param {Number} caseRank - the ranking of the case
 * @returns {Boolean} whether the stringToRank is an acronym for the testString
 */
function isCaseAcronym(testString, stringToRank, caseRank) {
  var splitValue = null;
  switch (caseRank) {
    case caseRankings.SNAKE:
      splitValue = '_';
      break;
    case caseRankings.KEBAB:
      splitValue = '-';
      break;
    case caseRankings.PASCAL:
    case caseRankings.CAMEL:
      splitValue = /(?=[A-Z])/;
      break;
    default:
      splitValue = null;
  }

  var splitTestString = testString.split(splitValue);
  return stringToRank.toLowerCase().split('').reduce(function (correct, char, charIndex) {
    var splitItem = splitTestString[charIndex];
    return correct && splitItem && splitItem[0].toLowerCase() === char;
  }, true);
}

/**
 * Returns a score based on how spread apart the
 * characters from the stringToRank are within the testString.
 * A number close to rankings.MATCHES represents a loose match. A number close
 * to rankings.MATCHES + 1 represents a loose match.
 * @param {String} testString - the string to test against
 * @param {String} stringToRank - the string to rank
 * @returns {Number} the number between rankings.MATCHES and
 * rankings.MATCHES + 1 for how well stringToRank matches testString
 */
function getClosenessRanking(testString, stringToRank) {
  var charNumber = 0;
  function findMatchingCharacter(matchChar, string, index) {
    for (var j = index; j < string.length; j++) {
      var stringChar = string[j];
      if (stringChar === matchChar) {
        return j + 1;
      }
    }
    return -1;
  }

  var firstIndex = findMatchingCharacter(stringToRank[0], testString, 0);
  if (firstIndex < 0) {
    return rankings.NO_MATCH;
  }
  charNumber = firstIndex;
  for (var i = 1; i < stringToRank.length; i++) {
    var matchChar = stringToRank[i];
    charNumber = findMatchingCharacter(matchChar, testString, charNumber);
    var found = charNumber > -1;
    if (!found) {
      return rankings.NO_MATCH;
    }
  }

  var spread = charNumber - firstIndex;
  return function (spread) {
    var matching = spread - stringToRank.length + 1;
    var ranking = rankings.MATCHES + 1 / matching;
    return ranking;
  }(spread);
}

/**
 * Sorts items that have a rank, index, and keyIndex
 * @param {Object} a - the first item to sort
 * @param {Object} b - the second item to sort
 * @return {Number} -1 if a should come first, 1 if b should come first
 * Note: will never return 0
 */
function sortRankedItems(a, b) {
  var aFirst = -1;
  var bFirst = 1;
  var aRank = a.rank,
      aIndex = a.index,
      aKeyIndex = a.keyIndex;
  var bRank = b.rank,
      bIndex = b.index,
      bKeyIndex = b.keyIndex;

  if (aRank === bRank) {
    if (aKeyIndex === bKeyIndex) {
      return aIndex < bIndex ? aFirst : bFirst;
    } else {
      return aKeyIndex < bKeyIndex ? aFirst : bFirst;
    }
  } else {
    return aRank > bRank ? aFirst : bFirst;
  }
}

/**
 * Prepares value for comparison by stringifying it, removing diacritics (if specified)
 * @param {String} value - the value to clean
 * @param {Object} options - {keepDiacritics: whether to remove diacritics}
 * @return {String} the prepared value
 */
function prepareValueForComparison(value, _ref4) {
  var keepDiacritics = _ref4.keepDiacritics;

  value = '' + value; // toString
  if (!keepDiacritics) {
    value = diacritics.clean(value);
  }
  return value;
}

/**
 * Gets value for key in item at arbitrarily nested keypath
 * @param {Object} item - the item
 * @param {Object|Function} key - the potentially nested keypath or property callback
 * @return {Array} - an array containing the value(s) at the nested keypath
 */
function getItemValues(item, key) {
  if ((typeof key === 'undefined' ? 'undefined' : _typeof(key)) === 'object') {
    key = key.key;
  }
  var value = void 0;
  if (typeof key === 'function') {
    value = key(item);
    // eslint-disable-next-line no-negated-condition
  } else if (key.indexOf('.') !== -1) {
    // handle nested keys
    value = key.split('.').reduce(function (itemObj, nestedKey) {
      return itemObj ? itemObj[nestedKey] : null;
    }, item);
  } else {
    value = item[key];
  }
  // concat because `value` can be a string or an array
  // eslint-disable-next-line
  return value != null ? [].concat(value) : null;
}

/**
 * Gets all the values for the given keys in the given item and returns an array of those values
 * @param {Object} item - the item from which the values will be retrieved
 * @param {Array} keys - the keys to use to retrieve the values
 * @return {Array} objects with {itemValue, attributes}
 */
function getAllValuesToRank(item, keys) {
  return keys.reduce(function (allVals, key) {
    var values = getItemValues(item, key);
    if (values) {
      values.forEach(function (itemValue) {
        allVals.push({
          itemValue: itemValue,
          attributes: getKeyAttributes(key)
        });
      });
    }
    return allVals;
  }, []);
}

/**
 * Gets all the attributes for the given key
 * @param {Object|String} key - the key from which the attributes will be retrieved
 * @return {Object} object containing the key's attributes
 */
function getKeyAttributes(key) {
  if (typeof key === 'string') {
    key = { key: key };
  }
  return _extends({
    maxRanking: Infinity,
    minRanking: -Infinity
  }, key);
}

/* harmony default export */ __webpack_exports__["default"] = (matchSorter);



/***/ }),
/* 96 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 97 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(40)) {
  var LIBRARY = __webpack_require__(133);
  var global = __webpack_require__(17);
  var fails = __webpack_require__(18);
  var $export = __webpack_require__(5);
  var $typed = __webpack_require__(248);
  var $buffer = __webpack_require__(342);
  var ctx = __webpack_require__(84);
  var anInstance = __webpack_require__(166);
  var propertyDesc = __webpack_require__(131);
  var hide = __webpack_require__(69);
  var redefineAll = __webpack_require__(167);
  var toInteger = __webpack_require__(86);
  var toLength = __webpack_require__(32);
  var toIndex = __webpack_require__(475);
  var toAbsoluteIndex = __webpack_require__(135);
  var toPrimitive = __webpack_require__(109);
  var has = __webpack_require__(68);
  var classof = __webpack_require__(206);
  var isObject = __webpack_require__(20);
  var toObject = __webpack_require__(49);
  var isArrayIter = __webpack_require__(334);
  var create = __webpack_require__(136);
  var getPrototypeOf = __webpack_require__(138);
  var gOPN = __webpack_require__(137).f;
  var getIterFn = __webpack_require__(336);
  var uid = __webpack_require__(132);
  var wks = __webpack_require__(28);
  var createArrayMethod = __webpack_require__(89);
  var createArrayIncludes = __webpack_require__(238);
  var speciesConstructor = __webpack_require__(207);
  var ArrayIterators = __webpack_require__(338);
  var Iterators = __webpack_require__(164);
  var $iterDetect = __webpack_require__(241);
  var setSpecies = __webpack_require__(165);
  var arrayFill = __webpack_require__(337);
  var arrayCopyWithin = __webpack_require__(466);
  var $DP = __webpack_require__(41);
  var $GOPD = __webpack_require__(87);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertForAccessibility = exports.formatNumberAsDigits = exports.formatBalanceNoFixed = exports.padLeadingZero = exports.formatPercentageRounded = exports.formatPercentage = exports.formatBalance = void 0;
/**
 * Utility class for handling number formatting
 */

var formatBalance = function formatBalance(balance) {
  var typeCheckedBalance = Number(balance);
  var prefix = '$';

  if (typeCheckedBalance < 0) {
    prefix = '-$';
    typeCheckedBalance = Math.abs(typeCheckedBalance);
  }

  return prefix.concat(typeCheckedBalance.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'));
};

exports.formatBalance = formatBalance;

var formatPercentage = function formatPercentage(percentage) {
  var typeCheckedPercentage = Number(percentage);

  if (typeCheckedPercentage && !Number.isNaN(typeCheckedPercentage)) {
    return typeCheckedPercentage.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,').concat('%');
  }

  return '0.00%';
};

exports.formatPercentage = formatPercentage;

var formatPercentageRounded = function formatPercentageRounded(percentage) {
  var typeCheckedPercentage = Number(percentage);

  if (typeCheckedPercentage && !Number.isNaN(typeCheckedPercentage)) {
    return typeCheckedPercentage.toFixed(0).replace(/(\d)(?=(\d{3})+\.)/g, '$1,').concat('%');
  }

  return '0%';
};

exports.formatPercentageRounded = formatPercentageRounded;

var padLeadingZero = function padLeadingZero(number) {
  if (number && number.toString().length === 1) {
    return '0'.concat(number);
  }

  return number ? number.toString() : number;
};

exports.padLeadingZero = padLeadingZero;

var formatBalanceNoFixed = function formatBalanceNoFixed(balance) {
  var typeCheckedBalance = Number(balance);
  var prefix = '$';

  if (typeCheckedBalance < 0) {
    prefix = '-$';
    typeCheckedBalance = Math.abs(typeCheckedBalance);
  }

  return prefix.concat(String(typeCheckedBalance).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'));
};

exports.formatBalanceNoFixed = formatBalanceNoFixed;

var formatNumberAsDigits = function formatNumberAsDigits(inputNum) {
  return inputNum.split('').join(' ');
};

exports.formatNumberAsDigits = formatNumberAsDigits;

var convertForAccessibility = function convertForAccessibility(value) {
  return value && value.startsWith('-') ? 'minus '.concat(value.substring(1)) : value;
};

exports.convertForAccessibility = convertForAccessibility;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(formatBalance, "formatBalance", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/NumberFormatters.js");

  __REACT_HOT_LOADER__.register(formatPercentage, "formatPercentage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/NumberFormatters.js");

  __REACT_HOT_LOADER__.register(formatPercentageRounded, "formatPercentageRounded", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/NumberFormatters.js");

  __REACT_HOT_LOADER__.register(padLeadingZero, "padLeadingZero", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/NumberFormatters.js");

  __REACT_HOT_LOADER__.register(formatBalanceNoFixed, "formatBalanceNoFixed", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/NumberFormatters.js");

  __REACT_HOT_LOADER__.register(formatNumberAsDigits, "formatNumberAsDigits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/NumberFormatters.js");

  __REACT_HOT_LOADER__.register(convertForAccessibility, "convertForAccessibility", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/NumberFormatters.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(formatBalance, "formatBalance", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/NumberFormatters.js");

  __REACT_HOT_LOADER__.register(formatPercentage, "formatPercentage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/NumberFormatters.js");

  __REACT_HOT_LOADER__.register(formatPercentageRounded, "formatPercentageRounded", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/NumberFormatters.js");

  __REACT_HOT_LOADER__.register(padLeadingZero, "padLeadingZero", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/NumberFormatters.js");

  __REACT_HOT_LOADER__.register(formatBalanceNoFixed, "formatBalanceNoFixed", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/NumberFormatters.js");

  __REACT_HOT_LOADER__.register(formatNumberAsDigits, "formatNumberAsDigits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/NumberFormatters.js");

  __REACT_HOT_LOADER__.register(convertForAccessibility, "convertForAccessibility", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/NumberFormatters.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/NumberFormatters.js");
}();

;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideMemberLoader = exports.showMemberLoader = exports.handleMemberRequestClose = exports.onToggleMemberDrawer = exports.updateSearchMember = exports.onAllMemberSelect = exports.getUnselectedAllMember = exports.getAllMember = exports.filterMember = exports.onFilterSelectedMember = exports.onDeleteMemberSuccess = exports.onDeleteMember = exports.onSaveMemberSuccess = exports.onSaveMember = exports.onFilterMemberOptionSelect = exports.onMemberClose = exports.onEditMember = exports.onAddMember = exports.onMemberSelect = exports.addFavouriteMemberSuccess = exports.addFavouriteMember = exports.showMemberMessage = exports.fetchMembersSuccess = exports.fetchMembers = exports.fetchMemberSuccess = exports.fetchMember = void 0;

var _ActionTypes = __webpack_require__(7);

var fetchMember = function fetchMember(payload) {
  return {
    type: _ActionTypes.FETCH_MEMBER,
    payload: payload
  };
};

exports.fetchMember = fetchMember;

var fetchMemberSuccess = function fetchMemberSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_MEMBER_SUCCESS,
    payload: payload
  };
};

exports.fetchMemberSuccess = fetchMemberSuccess;

var fetchMembers = function fetchMembers() {
  return {
    type: _ActionTypes.FETCH_ALL_MEMBER
  };
};

exports.fetchMembers = fetchMembers;

var fetchMembersSuccess = function fetchMembersSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_ALL_MEMBER_SUCCESS,
    payload: payload
  };
};

exports.fetchMembersSuccess = fetchMembersSuccess;

var showMemberMessage = function showMemberMessage(message) {
  return {
    type: _ActionTypes.SHOW_MEMBER_MESSAGE,
    payload: message
  };
};

exports.showMemberMessage = showMemberMessage;

var addFavouriteMember = function addFavouriteMember(payload) {
  return {
    type: _ActionTypes.ADD_FAVOURITE_MEMBER,
    payload: payload
  };
};

exports.addFavouriteMember = addFavouriteMember;

var addFavouriteMemberSuccess = function addFavouriteMemberSuccess(payload) {
  return {
    type: _ActionTypes.ADD_FAVOURITE_MEMBER_SUCCESS,
    payload: payload
  };
};

exports.addFavouriteMemberSuccess = addFavouriteMemberSuccess;

var onMemberSelect = function onMemberSelect(payload) {
  return {
    type: _ActionTypes.ON_MEMBER_SELECT,
    payload: payload
  };
};

exports.onMemberSelect = onMemberSelect;

var onAddMember = function onAddMember() {
  return {
    type: _ActionTypes.ON_ADD_MEMBER
  };
};

exports.onAddMember = onAddMember;

var onEditMember = function onEditMember(payload) {
  return {
    type: _ActionTypes.ON_EDIT_MEMBER,
    payload: payload
  };
};

exports.onEditMember = onEditMember;

var onMemberClose = function onMemberClose() {
  return {
    type: _ActionTypes.ON_MEMBER_CLOSE
  };
};

exports.onMemberClose = onMemberClose;

var onFilterMemberOptionSelect = function onFilterMemberOptionSelect(payload) {
  return {
    type: _ActionTypes.ON_FILTER_MEMBER_OPTION_SELECT,
    payload: payload
  };
};

exports.onFilterMemberOptionSelect = onFilterMemberOptionSelect;

var onSaveMember = function onSaveMember(payload) {
  return {
    type: _ActionTypes.ON_SAVE_MEMBER,
    payload: payload
  };
};

exports.onSaveMember = onSaveMember;

var onSaveMemberSuccess = function onSaveMemberSuccess(data) {
  return {
    type: _ActionTypes.ON_SAVE_MEMBER_SUCCESS,
    payload: data
  };
};

exports.onSaveMemberSuccess = onSaveMemberSuccess;

var onDeleteMember = function onDeleteMember(payload) {
  return {
    type: _ActionTypes.ON_DELETE_MEMBER,
    payload: payload
  };
};

exports.onDeleteMember = onDeleteMember;

var onDeleteMemberSuccess = function onDeleteMemberSuccess(payload) {
  return {
    type: _ActionTypes.ON_DELETE_MEMBER_SUCCESS,
    payload: payload
  };
};

exports.onDeleteMemberSuccess = onDeleteMemberSuccess;

var onFilterSelectedMember = function onFilterSelectedMember() {
  return {
    type: _ActionTypes.ON_FILTER_SELECTED_MEMBER,
    payload: ''
  };
};

exports.onFilterSelectedMember = onFilterSelectedMember;

var filterMember = function filterMember(payload) {
  return {
    type: _ActionTypes.FILTER_MEMBER,
    payload: payload
  };
};

exports.filterMember = filterMember;

var getAllMember = function getAllMember() {
  return {
    type: _ActionTypes.GET_ALL_MEMBER,
    payload: ''
  };
};

exports.getAllMember = getAllMember;

var getUnselectedAllMember = function getUnselectedAllMember() {
  return {
    type: _ActionTypes.GET_UNSELECTED_ALL_MEMBER,
    payload: ''
  };
};

exports.getUnselectedAllMember = getUnselectedAllMember;

var onAllMemberSelect = function onAllMemberSelect() {
  return {
    type: _ActionTypes.ON_ALL_MEMBER_SELECT,
    payload: ''
  };
};

exports.onAllMemberSelect = onAllMemberSelect;

var updateSearchMember = function updateSearchMember(payload) {
  return {
    type: _ActionTypes.UPDATE_SEARCH_MEMBER,
    payload: payload
  };
};

exports.updateSearchMember = updateSearchMember;

var onToggleMemberDrawer = function onToggleMemberDrawer() {
  return {
    type: _ActionTypes.ON_TOGGLE_MEMBER_DRAWER
  };
};

exports.onToggleMemberDrawer = onToggleMemberDrawer;

var handleMemberRequestClose = function handleMemberRequestClose() {
  return {
    type: _ActionTypes.HANDLE_MEMBER_REQUEST_CLOSE
  };
};

exports.handleMemberRequestClose = handleMemberRequestClose;

var showMemberLoader = function showMemberLoader() {
  return {
    type: _ActionTypes.SHOW_MEMBER_LOADER
  };
};

exports.showMemberLoader = showMemberLoader;

var hideMemberLoader = function hideMemberLoader() {
  return {
    type: _ActionTypes.HIDE_MEMBER_LOADER
  };
};

exports.hideMemberLoader = hideMemberLoader;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchMember, "fetchMember", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(fetchMemberSuccess, "fetchMemberSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(fetchMembers, "fetchMembers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(fetchMembersSuccess, "fetchMembersSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(showMemberMessage, "showMemberMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(addFavouriteMember, "addFavouriteMember", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(addFavouriteMemberSuccess, "addFavouriteMemberSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(onMemberSelect, "onMemberSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(onAddMember, "onAddMember", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(onEditMember, "onEditMember", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(onMemberClose, "onMemberClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(onFilterMemberOptionSelect, "onFilterMemberOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(onSaveMember, "onSaveMember", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(onSaveMemberSuccess, "onSaveMemberSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(onDeleteMember, "onDeleteMember", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(onDeleteMemberSuccess, "onDeleteMemberSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(onFilterSelectedMember, "onFilterSelectedMember", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(filterMember, "filterMember", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(getAllMember, "getAllMember", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllMember, "getUnselectedAllMember", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(onAllMemberSelect, "onAllMemberSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(updateSearchMember, "updateSearchMember", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(onToggleMemberDrawer, "onToggleMemberDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(handleMemberRequestClose, "handleMemberRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(showMemberLoader, "showMemberLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(hideMemberLoader, "hideMemberLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchMember, "fetchMember", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(fetchMemberSuccess, "fetchMemberSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(fetchMembers, "fetchMembers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(fetchMembersSuccess, "fetchMembersSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(showMemberMessage, "showMemberMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(addFavouriteMember, "addFavouriteMember", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(addFavouriteMemberSuccess, "addFavouriteMemberSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(onMemberSelect, "onMemberSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(onAddMember, "onAddMember", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(onEditMember, "onEditMember", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(onMemberClose, "onMemberClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(onFilterMemberOptionSelect, "onFilterMemberOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(onSaveMember, "onSaveMember", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(onSaveMemberSuccess, "onSaveMemberSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(onDeleteMember, "onDeleteMember", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(onDeleteMemberSuccess, "onDeleteMemberSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(onFilterSelectedMember, "onFilterSelectedMember", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(filterMember, "filterMember", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(getAllMember, "getAllMember", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllMember, "getUnselectedAllMember", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(onAllMemberSelect, "onAllMemberSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(updateSearchMember, "updateSearchMember", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(onToggleMemberDrawer, "onToggleMemberDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(handleMemberRequestClose, "handleMemberRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(showMemberLoader, "showMemberLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(hideMemberLoader, "hideMemberLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/member.js");
}();

;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideInitiativeLoader = exports.showInitiativeLoader = exports.handleInitiativeRequestClose = exports.onToggleInitiativeDrawer = exports.updateSearchInitiative = exports.onAllInitiativeSelect = exports.getUnselectedAllInitiative = exports.getAllInitiative = exports.filterInitiative = exports.onFilterSelectedInitiative = exports.onDeleteInitiativeSuccess = exports.onDeleteInitiative = exports.onSaveInitiativeSuccess = exports.onSaveInitiative = exports.onFilterInitiativeOptionSelect = exports.onInitiativeClose = exports.onEditInitiative = exports.onAddInitiative = exports.onInitiativeSelect = exports.addFavouriteInitiativeSuccess = exports.addFavouriteInitiative = exports.showInitiativeMessage = exports.fetchInitiativesSuccess = exports.fetchInitiatives = exports.fetchInitiativeSuccess = exports.fetchInitiative = exports.setInitiative = exports.onFetchSelectProductDataSuccess = exports.onFetchSelectProductData = exports.onInitiativeProductUpdate = void 0;

var _ActionTypes = __webpack_require__(7);

var onInitiativeProductUpdate = function onInitiativeProductUpdate() {
  return {
    type: _ActionTypes.ON_INITIATIVE_PRODUCT_UPDATE
  };
};

exports.onInitiativeProductUpdate = onInitiativeProductUpdate;

var onFetchSelectProductData = function onFetchSelectProductData() {
  return {
    type: _ActionTypes.ON_FETCH_SELECT_PRODUCT_DATA
  };
};

exports.onFetchSelectProductData = onFetchSelectProductData;

var onFetchSelectProductDataSuccess = function onFetchSelectProductDataSuccess(payload) {
  return {
    type: _ActionTypes.ON_FETCH_SELECT_PRODUCT_DATA_SUCCESS,
    payload: payload
  };
};

exports.onFetchSelectProductDataSuccess = onFetchSelectProductDataSuccess;

var setInitiative = function setInitiative(payload) {
  return {
    type: _ActionTypes.SET_INITIATIVE,
    payload: payload
  };
};

exports.setInitiative = setInitiative;

var fetchInitiative = function fetchInitiative(payload) {
  return {
    type: _ActionTypes.FETCH_INITIATIVE,
    payload: payload
  };
};

exports.fetchInitiative = fetchInitiative;

var fetchInitiativeSuccess = function fetchInitiativeSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_INITIATIVE_SUCCESS,
    payload: payload
  };
};

exports.fetchInitiativeSuccess = fetchInitiativeSuccess;

var fetchInitiatives = function fetchInitiatives() {
  return {
    type: _ActionTypes.FETCH_ALL_INITIATIVE
  };
};

exports.fetchInitiatives = fetchInitiatives;

var fetchInitiativesSuccess = function fetchInitiativesSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_ALL_INITIATIVE_SUCCESS,
    payload: payload
  };
};

exports.fetchInitiativesSuccess = fetchInitiativesSuccess;

var showInitiativeMessage = function showInitiativeMessage(message) {
  return {
    type: _ActionTypes.SHOW_INITIATIVE_MESSAGE,
    payload: message
  };
};

exports.showInitiativeMessage = showInitiativeMessage;

var addFavouriteInitiative = function addFavouriteInitiative(payload) {
  return {
    type: _ActionTypes.ADD_FAVOURITE_INITIATIVE,
    payload: payload
  };
};

exports.addFavouriteInitiative = addFavouriteInitiative;

var addFavouriteInitiativeSuccess = function addFavouriteInitiativeSuccess(payload) {
  return {
    type: _ActionTypes.ADD_FAVOURITE_INITIATIVE_SUCCESS,
    payload: payload
  };
};

exports.addFavouriteInitiativeSuccess = addFavouriteInitiativeSuccess;

var onInitiativeSelect = function onInitiativeSelect(payload) {
  return {
    type: _ActionTypes.ON_INITIATIVE_SELECT,
    payload: payload
  };
};

exports.onInitiativeSelect = onInitiativeSelect;

var onAddInitiative = function onAddInitiative() {
  return {
    type: _ActionTypes.ON_ADD_INITIATIVE
  };
};

exports.onAddInitiative = onAddInitiative;

var onEditInitiative = function onEditInitiative(payload) {
  return {
    type: _ActionTypes.ON_EDIT_INITIATIVE,
    payload: payload
  };
};

exports.onEditInitiative = onEditInitiative;

var onInitiativeClose = function onInitiativeClose() {
  return {
    type: _ActionTypes.ON_INITIATIVE_CLOSE
  };
};

exports.onInitiativeClose = onInitiativeClose;

var onFilterInitiativeOptionSelect = function onFilterInitiativeOptionSelect(payload) {
  return {
    type: _ActionTypes.ON_FILTER_INITIATIVE_OPTION_SELECT,
    payload: payload
  };
};

exports.onFilterInitiativeOptionSelect = onFilterInitiativeOptionSelect;

var onSaveInitiative = function onSaveInitiative(payload) {
  return {
    type: _ActionTypes.ON_SAVE_INITIATIVE,
    payload: payload
  };
};

exports.onSaveInitiative = onSaveInitiative;

var onSaveInitiativeSuccess = function onSaveInitiativeSuccess(data) {
  return {
    type: _ActionTypes.ON_SAVE_INITIATIVE_SUCCESS,
    payload: data
  };
};

exports.onSaveInitiativeSuccess = onSaveInitiativeSuccess;

var onDeleteInitiative = function onDeleteInitiative(payload) {
  return {
    type: _ActionTypes.ON_DELETE_INITIATIVE,
    payload: payload
  };
};

exports.onDeleteInitiative = onDeleteInitiative;

var onDeleteInitiativeSuccess = function onDeleteInitiativeSuccess(payload) {
  return {
    type: _ActionTypes.ON_DELETE_INITIATIVE_SUCCESS,
    payload: payload
  };
};

exports.onDeleteInitiativeSuccess = onDeleteInitiativeSuccess;

var onFilterSelectedInitiative = function onFilterSelectedInitiative() {
  return {
    type: _ActionTypes.ON_FILTER_SELECTED_INITIATIVE,
    payload: ''
  };
};

exports.onFilterSelectedInitiative = onFilterSelectedInitiative;

var filterInitiative = function filterInitiative(payload) {
  return {
    type: _ActionTypes.FILTER_INITIATIVE,
    payload: payload
  };
};

exports.filterInitiative = filterInitiative;

var getAllInitiative = function getAllInitiative() {
  return {
    type: _ActionTypes.GET_ALL_INITIATIVE,
    payload: ''
  };
};

exports.getAllInitiative = getAllInitiative;

var getUnselectedAllInitiative = function getUnselectedAllInitiative() {
  return {
    type: _ActionTypes.GET_UNSELECTED_ALL_INITIATIVE,
    payload: ''
  };
};

exports.getUnselectedAllInitiative = getUnselectedAllInitiative;

var onAllInitiativeSelect = function onAllInitiativeSelect() {
  return {
    type: _ActionTypes.ON_ALL_INITIATIVE_SELECT,
    payload: ''
  };
};

exports.onAllInitiativeSelect = onAllInitiativeSelect;

var updateSearchInitiative = function updateSearchInitiative(payload) {
  return {
    type: _ActionTypes.UPDATE_SEARCH_INITIATIVE,
    payload: payload
  };
};

exports.updateSearchInitiative = updateSearchInitiative;

var onToggleInitiativeDrawer = function onToggleInitiativeDrawer() {
  return {
    type: _ActionTypes.ON_TOGGLE_INITIATIVE_DRAWER
  };
};

exports.onToggleInitiativeDrawer = onToggleInitiativeDrawer;

var handleInitiativeRequestClose = function handleInitiativeRequestClose() {
  return {
    type: _ActionTypes.HANDLE_INITIATIVE_REQUEST_CLOSE
  };
};

exports.handleInitiativeRequestClose = handleInitiativeRequestClose;

var showInitiativeLoader = function showInitiativeLoader() {
  return {
    type: _ActionTypes.SHOW_INITIATIVE_LOADER
  };
};

exports.showInitiativeLoader = showInitiativeLoader;

var hideInitiativeLoader = function hideInitiativeLoader() {
  return {
    type: _ActionTypes.HIDE_INITIATIVE_LOADER
  };
};

exports.hideInitiativeLoader = hideInitiativeLoader;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(onInitiativeProductUpdate, "onInitiativeProductUpdate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(onFetchSelectProductData, "onFetchSelectProductData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(onFetchSelectProductDataSuccess, "onFetchSelectProductDataSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(setInitiative, "setInitiative", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(fetchInitiative, "fetchInitiative", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(fetchInitiativeSuccess, "fetchInitiativeSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(fetchInitiatives, "fetchInitiatives", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(fetchInitiativesSuccess, "fetchInitiativesSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(showInitiativeMessage, "showInitiativeMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(addFavouriteInitiative, "addFavouriteInitiative", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(addFavouriteInitiativeSuccess, "addFavouriteInitiativeSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(onInitiativeSelect, "onInitiativeSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(onAddInitiative, "onAddInitiative", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(onEditInitiative, "onEditInitiative", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(onInitiativeClose, "onInitiativeClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(onFilterInitiativeOptionSelect, "onFilterInitiativeOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(onSaveInitiative, "onSaveInitiative", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(onSaveInitiativeSuccess, "onSaveInitiativeSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(onDeleteInitiative, "onDeleteInitiative", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(onDeleteInitiativeSuccess, "onDeleteInitiativeSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(onFilterSelectedInitiative, "onFilterSelectedInitiative", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(filterInitiative, "filterInitiative", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(getAllInitiative, "getAllInitiative", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllInitiative, "getUnselectedAllInitiative", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(onAllInitiativeSelect, "onAllInitiativeSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(updateSearchInitiative, "updateSearchInitiative", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(onToggleInitiativeDrawer, "onToggleInitiativeDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(handleInitiativeRequestClose, "handleInitiativeRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(showInitiativeLoader, "showInitiativeLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(hideInitiativeLoader, "hideInitiativeLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(onInitiativeProductUpdate, "onInitiativeProductUpdate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(onFetchSelectProductData, "onFetchSelectProductData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(onFetchSelectProductDataSuccess, "onFetchSelectProductDataSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(setInitiative, "setInitiative", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(fetchInitiative, "fetchInitiative", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(fetchInitiativeSuccess, "fetchInitiativeSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(fetchInitiatives, "fetchInitiatives", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(fetchInitiativesSuccess, "fetchInitiativesSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(showInitiativeMessage, "showInitiativeMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(addFavouriteInitiative, "addFavouriteInitiative", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(addFavouriteInitiativeSuccess, "addFavouriteInitiativeSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(onInitiativeSelect, "onInitiativeSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(onAddInitiative, "onAddInitiative", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(onEditInitiative, "onEditInitiative", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(onInitiativeClose, "onInitiativeClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(onFilterInitiativeOptionSelect, "onFilterInitiativeOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(onSaveInitiative, "onSaveInitiative", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(onSaveInitiativeSuccess, "onSaveInitiativeSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(onDeleteInitiative, "onDeleteInitiative", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(onDeleteInitiativeSuccess, "onDeleteInitiativeSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(onFilterSelectedInitiative, "onFilterSelectedInitiative", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(filterInitiative, "filterInitiative", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(getAllInitiative, "getAllInitiative", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllInitiative, "getUnselectedAllInitiative", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(onAllInitiativeSelect, "onAllInitiativeSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(updateSearchInitiative, "updateSearchInitiative", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(onToggleInitiativeDrawer, "onToggleInitiativeDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(handleInitiativeRequestClose, "handleInitiativeRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(showInitiativeLoader, "showInitiativeLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(hideInitiativeLoader, "hideInitiativeLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/initiative.js");
}();

;

/***/ }),
/* 102 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return durationSecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return durationMinute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return durationHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return durationDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return durationWeek; });
var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationDay = 864e5;
var durationWeek = 6048e5;


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isObject__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_last__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_last__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isArray__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Label__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__container_Layer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_ChartUtils__ = __webpack_require__(51);






function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







var propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  data: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object),
  valueAccessor: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  clockWise: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  dataKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func])
};
var defaultProps = {
  valueAccessor: function valueAccessor(entry) {
    return __WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(entry.value) ? __WEBPACK_IMPORTED_MODULE_3_lodash_last___default()(entry.value) : entry.value;
  }
};

function LabelList(props) {
  var data = props.data,
      valueAccessor = props.valueAccessor,
      dataKey = props.dataKey,
      clockWise = props.clockWise,
      id = props.id,
      others = _objectWithoutProperties(props, ["data", "valueAccessor", "dataKey", "clockWise", "id"]);

  if (!data || !data.length) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */], {
    className: "recharts-label-list"
  }, data.map(function (entry, index) {
    var value = __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(dataKey) ? valueAccessor(entry, index) : Object(__WEBPACK_IMPORTED_MODULE_10__util_ChartUtils__["v" /* getValueByDataKey */])(entry && entry.payload, dataKey);
    var idProps = __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(id) ? {} : {
      id: "".concat(id, "-").concat(index)
    };
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Label__["a" /* default */], _extends({}, Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["l" /* getPresentationAttributes */])(entry), others, idProps, {
      index: index,
      value: value,
      viewBox: __WEBPACK_IMPORTED_MODULE_7__Label__["a" /* default */].parseViewBox(__WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(clockWise) ? entry : _objectSpread({}, entry, {
        clockWise: clockWise
      })),
      key: "label-".concat(index) // eslint-disable-line react/no-array-index-key

    }));
  }));
}

LabelList.propTypes = propTypes;
LabelList.displayName = 'LabelList';

var parseLabelList = function parseLabelList(label, data) {
  if (!label) {
    return null;
  }

  if (label === true) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LabelList, {
      key: "labelList-implicit",
      data: data
    });
  }

  if (__WEBPACK_IMPORTED_MODULE_5_react___default.a.isValidElement(label) || __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(label)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LabelList, {
      key: "labelList-implicit",
      data: data,
      content: label
    });
  }

  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isObject___default()(label)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LabelList, _extends({
      data: data
    }, label, {
      key: "labelList-implicit"
    }));
  }

  return null;
};

var renderCallByParent = function renderCallByParent(parentProps, data) {
  var ckeckPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (!parentProps || !parentProps.children && ckeckPropsLabel && !parentProps.label) {
    return null;
  }

  var children = parentProps.children;
  var explicitChilren = Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["i" /* findAllByType */])(children, LabelList).map(function (child, index) {
    return Object(__WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"])(child, {
      data: data,
      key: "labelList-".concat(index)
    });
  });

  if (!ckeckPropsLabel) {
    return explicitChilren;
  }

  var implicitLabelList = parseLabelList(parentProps.label, data);
  return [implicitLabelList].concat(_toConsumableArray(explicitChilren));
};

LabelList.renderCallByParent = renderCallByParent;
LabelList.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (LabelList);

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_every__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_every___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_every__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_sortBy__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_range__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_throttle__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isNil__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__container_Surface__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__container_Layer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__component_Tooltip__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__component_Legend__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shape_Curve__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shape_Cross__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shape_Sector__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__shape_Dot__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__shape_Rectangle__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__cartesian_CartesianAxis__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__cartesian_Brush__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__util_DOMUtils__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__util_DataUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__util_DetectReferenceElementsDomain__ = __webpack_require__(1692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__util_PolarUtils__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__util_ShallowEqual__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__util_Events__ = __webpack_require__(1693);








function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }























var ORIENT_MAP = {
  xAxis: ['bottom', 'top'],
  yAxis: ['left', 'right']
};
var originCoordinate = {
  x: 0,
  y: 0
};

var generateCategoricalChart = function generateCategoricalChart(_ref) {
  var chartName = _ref.chartName,
      GraphicalChild = _ref.GraphicalChild,
      _ref$eventType = _ref.eventType,
      eventType = _ref$eventType === void 0 ? 'axis' : _ref$eventType,
      axisComponents = _ref.axisComponents,
      legendContent = _ref.legendContent,
      formatAxisMap = _ref.formatAxisMap,
      defaultProps = _ref.defaultProps,
      propTypes = _ref.propTypes;

  var CategoricalChartWrapper =
  /*#__PURE__*/
  function (_Component) {
    _inherits(CategoricalChartWrapper, _Component);

    /**
     * Returns default, reset state for the categorical chart.
     * @param {Object} props Props object to use when creating the default state
     * @return {Object} Whole new state
     */
    function CategoricalChartWrapper(_props) {
      var _this;

      _classCallCheck(this, CategoricalChartWrapper);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(CategoricalChartWrapper).call(this, _props));

      _this.handleLegendBBoxUpdate = function (box) {
        if (box && _this.legendInstance) {
          var _this$state = _this.state,
              dataStartIndex = _this$state.dataStartIndex,
              dataEndIndex = _this$state.dataEndIndex,
              updateId = _this$state.updateId;

          _this.setState(_this.updateStateOfAxisMapsOffsetAndStackGroups({
            props: _this.props,
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex,
            updateId: updateId
          }));
        }
      };

      _this.handleReceiveSyncEvent = function (cId, chartId, data) {
        var _this$props = _this.props,
            syncId = _this$props.syncId,
            layout = _this$props.layout;
        var updateId = _this.state.updateId;

        if (syncId === cId && chartId !== _this.uniqueChartId) {
          var dataStartIndex = data.dataStartIndex,
              dataEndIndex = data.dataEndIndex;

          if (!__WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(data.dataStartIndex) || !__WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(data.dataEndIndex)) {
            _this.setState(_objectSpread({
              dataStartIndex: dataStartIndex,
              dataEndIndex: dataEndIndex
            }, _this.updateStateOfAxisMapsOffsetAndStackGroups({
              props: _this.props,
              dataStartIndex: dataStartIndex,
              dataEndIndex: dataEndIndex,
              updateId: updateId
            })));
          } else if (!__WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(data.activeTooltipIndex)) {
            var chartX = data.chartX,
                chartY = data.chartY,
                activeTooltipIndex = data.activeTooltipIndex;
            var _this$state2 = _this.state,
                offset = _this$state2.offset,
                tooltipTicks = _this$state2.tooltipTicks;

            if (!offset) {
              return;
            }

            var viewBox = _objectSpread({}, offset, {
              x: offset.left,
              y: offset.top
            }); // When a categotical chart is combined with another chart, the value of chartX
            // and chartY may beyond the boundaries.


            var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
            var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
            var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;

            var activePayload = _this.getTooltipContent(activeTooltipIndex);

            var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
              x: layout === 'horizontal' ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
              y: layout === 'horizontal' ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
            } : originCoordinate;

            _this.setState(_objectSpread({}, data, {
              activeLabel: activeLabel,
              activeCoordinate: activeCoordinate,
              activePayload: activePayload
            }));
          } else {
            _this.setState(data);
          }
        }
      };

      _this.handleBrushChange = function (_ref2) {
        var startIndex = _ref2.startIndex,
            endIndex = _ref2.endIndex;

        // Only trigger changes if the extents of the brush have actually changed
        if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
          var updateId = _this.state.updateId;

          _this.setState(function () {
            return _objectSpread({
              dataStartIndex: startIndex,
              dataEndIndex: endIndex
            }, _this.updateStateOfAxisMapsOffsetAndStackGroups({
              props: _this.props,
              dataStartIndex: startIndex,
              dataEndIndex: endIndex,
              updateId: updateId
            }));
          });

          _this.triggerSyncEvent({
            dataStartIndex: startIndex,
            dataEndIndex: endIndex
          });
        }
      };

      _this.handleMouseEnter = function (e) {
        var onMouseEnter = _this.props.onMouseEnter;

        var mouse = _this.getMouseInfo(e);

        if (mouse) {
          var nextState = _objectSpread({}, mouse, {
            isTooltipActive: true
          });

          _this.setState(nextState);

          _this.triggerSyncEvent(nextState);

          if (__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(onMouseEnter)) {
            onMouseEnter(nextState, e);
          }
        }
      };

      _this.triggeredAfterMouseMove = function (e) {
        var onMouseMove = _this.props.onMouseMove;

        var mouse = _this.getMouseInfo(e);

        var nextState = mouse ? _objectSpread({}, mouse, {
          isTooltipActive: true
        }) : {
          isTooltipActive: false
        };

        _this.setState(nextState);

        _this.triggerSyncEvent(nextState);

        if (__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(onMouseMove)) {
          onMouseMove(nextState, e);
        }
      };

      _this.handleItemMouseEnter = function (el) {
        _this.setState(function () {
          return {
            isTooltipActive: true,
            activeItem: el,
            activePayload: el.tooltipPayload,
            activeCoordinate: el.tooltipPosition || {
              x: el.cx,
              y: el.cy
            }
          };
        });
      };

      _this.handleItemMouseLeave = function () {
        _this.setState(function () {
          return {
            isTooltipActive: false
          };
        });
      };

      _this.handleMouseMove = function (e) {
        if (e && __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(e.persist)) {
          e.persist();
        }

        _this.triggeredAfterMouseMove(e);
      };

      _this.handleMouseLeave = function (e) {
        var onMouseLeave = _this.props.onMouseLeave;
        var nextState = {
          isTooltipActive: false
        };

        _this.setState(nextState);

        _this.triggerSyncEvent(nextState);

        if (__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(onMouseLeave)) {
          onMouseLeave(nextState, e);
        }
      };

      _this.handleOuterEvent = function (e) {
        var eventName = Object(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["m" /* getReactEventByType */])(e);

        if (eventName && __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(_this.props[eventName])) {
          var mouse = _this.getMouseInfo(e);

          var handler = _this.props[eventName];
          handler(mouse, e);
        }
      };

      _this.handleClick = function (e) {
        var onClick = _this.props.onClick;

        if (__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(onClick)) {
          var mouse = _this.getMouseInfo(e);

          onClick(mouse, e);
        }
      };

      _this.handleMouseDown = function (e) {
        var onMouseDown = _this.props.onMouseDown;

        if (__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(onMouseDown)) {
          var mouse = _this.getMouseInfo(e);

          onMouseDown(mouse, e);
        }
      };

      _this.handleMouseUp = function (e) {
        var onMouseUp = _this.props.onMouseUp;

        if (__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(onMouseUp)) {
          var mouse = _this.getMouseInfo(e);

          onMouseUp(mouse, e);
        }
      };

      _this.handleTouchMove = function (e) {
        if (e.changedTouches != null && e.changedTouches.length > 0) {
          _this.handleMouseMove(e.changedTouches[0]);
        }
      };

      _this.handleTouchStart = function (e) {
        if (e.changedTouches != null && e.changedTouches.length > 0) {
          _this.handleMouseDown(e.changedTouches[0]);
        }
      };

      _this.handleTouchEnd = function (e) {
        if (e.changedTouches != null && e.changedTouches.length > 0) {
          _this.handleMouseUp(e.changedTouches[0]);
        }
      };

      _this.verticalCoordinatesGenerator = function (_ref3) {
        var xAxis = _ref3.xAxis,
            width = _ref3.width,
            height = _ref3.height,
            offset = _ref3.offset;
        return Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["l" /* getCoordinatesOfGrid */])(__WEBPACK_IMPORTED_MODULE_20__cartesian_CartesianAxis__["a" /* default */].getTicks(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_20__cartesian_CartesianAxis__["a" /* default */].defaultProps, {}, xAxis, {
          ticks: Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["t" /* getTicksOfAxis */])(xAxis, true),
          viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
          }
        })), offset.left, offset.left + offset.width);
      };

      _this.horizontalCoordinatesGenerator = function (_ref4) {
        var yAxis = _ref4.yAxis,
            width = _ref4.width,
            height = _ref4.height,
            offset = _ref4.offset;
        return Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["l" /* getCoordinatesOfGrid */])(__WEBPACK_IMPORTED_MODULE_20__cartesian_CartesianAxis__["a" /* default */].getTicks(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_20__cartesian_CartesianAxis__["a" /* default */].defaultProps, {}, yAxis, {
          ticks: Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["t" /* getTicksOfAxis */])(yAxis, true),
          viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
          }
        })), offset.top, offset.top + offset.height);
      };

      _this.axesTicksGenerator = function (axis) {
        return Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["t" /* getTicksOfAxis */])(axis, true);
      };

      _this.tooltipTicksGenerator = function (axisMap) {
        var axis = Object(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["b" /* getAnyElementOfObject */])(axisMap);
        var tooltipTicks = Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["t" /* getTicksOfAxis */])(axis, false, true);
        return {
          tooltipTicks: tooltipTicks,
          orderedTooltipTicks: __WEBPACK_IMPORTED_MODULE_2_lodash_sortBy___default()(tooltipTicks, function (o) {
            return o.coordinate;
          }),
          tooltipAxis: axis,
          tooltipAxisBandSize: Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["f" /* getBandSizeOfAxis */])(axis)
        };
      };

      _this.renderCursor = function (element) {
        var _this$state3 = _this.state,
            isTooltipActive = _this$state3.isTooltipActive,
            activeCoordinate = _this$state3.activeCoordinate,
            activePayload = _this$state3.activePayload,
            offset = _this$state3.offset;

        if (!element || !element.props.cursor || !isTooltipActive || !activeCoordinate) {
          return null;
        }

        var layout = _this.props.layout;
        var restProps;
        var cursorComp = __WEBPACK_IMPORTED_MODULE_14__shape_Curve__["a" /* default */];

        if (chartName === 'ScatterChart') {
          restProps = activeCoordinate;
          cursorComp = __WEBPACK_IMPORTED_MODULE_15__shape_Cross__["a" /* default */];
        } else if (chartName === 'BarChart') {
          restProps = _this.getCursorRectangle();
          cursorComp = __WEBPACK_IMPORTED_MODULE_18__shape_Rectangle__["a" /* default */];
        } else if (layout === 'radial') {
          var _this$getCursorPoints = _this.getCursorPoints(),
              cx = _this$getCursorPoints.cx,
              cy = _this$getCursorPoints.cy,
              radius = _this$getCursorPoints.radius,
              startAngle = _this$getCursorPoints.startAngle,
              endAngle = _this$getCursorPoints.endAngle;

          restProps = {
            cx: cx,
            cy: cy,
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: radius,
            outerRadius: radius
          };
          cursorComp = __WEBPACK_IMPORTED_MODULE_16__shape_Sector__["a" /* default */];
        } else {
          restProps = {
            points: _this.getCursorPoints()
          };
          cursorComp = __WEBPACK_IMPORTED_MODULE_14__shape_Curve__["a" /* default */];
        }

        var key = element.key || '_recharts-cursor';

        var cursorProps = _objectSpread({
          stroke: '#ccc',
          pointerEvents: 'none'
        }, offset, {}, restProps, {}, Object(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["l" /* getPresentationAttributes */])(element.props.cursor), {
          payload: activePayload,
          key: key,
          className: 'recharts-tooltip-cursor'
        });

        return Object(__WEBPACK_IMPORTED_MODULE_7_react__["isValidElement"])(element.props.cursor) ? Object(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(element.props.cursor, cursorProps) : Object(__WEBPACK_IMPORTED_MODULE_7_react__["createElement"])(cursorComp, cursorProps);
      };

      _this.renderPolarAxis = function (element, displayName, index) {
        var axisType = element.type.axisType;

        var axisMap = _this.state["".concat(axisType, "Map")];

        var axisOption = axisMap[element.props["".concat(axisType, "Id")]];
        return Object(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(element, _objectSpread({}, axisOption, {
          className: axisType,
          key: element.key || "".concat(displayName, "-").concat(index),
          ticks: Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["t" /* getTicksOfAxis */])(axisOption, true)
        }));
      };

      _this.renderXAxis = function (element, displayName, index) {
        var xAxisMap = _this.state.xAxisMap;
        var axisObj = xAxisMap[element.props.xAxisId];
        return _this.renderAxis(axisObj, element, displayName, index);
      };

      _this.renderYAxis = function (element, displayName, index) {
        var yAxisMap = _this.state.yAxisMap;
        var axisObj = yAxisMap[element.props.yAxisId];
        return _this.renderAxis(axisObj, element, displayName, index);
      };

      _this.renderGrid = function (element) {
        var _this$state4 = _this.state,
            xAxisMap = _this$state4.xAxisMap,
            yAxisMap = _this$state4.yAxisMap,
            offset = _this$state4.offset;
        var _this$props2 = _this.props,
            width = _this$props2.width,
            height = _this$props2.height;
        var xAxis = Object(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["b" /* getAnyElementOfObject */])(xAxisMap);

        var yAxisWithFiniteDomain = __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(yAxisMap, function (axis) {
          return __WEBPACK_IMPORTED_MODULE_0_lodash_every___default()(axis.domain, Number.isFinite);
        });

        var yAxis = yAxisWithFiniteDomain || Object(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["b" /* getAnyElementOfObject */])(yAxisMap);
        var props = element.props || {};
        return Object(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(element, {
          key: element.key || 'grid',
          x: Object(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["h" /* isNumber */])(props.x) ? props.x : offset.left,
          y: Object(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["h" /* isNumber */])(props.y) ? props.y : offset.top,
          width: Object(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["h" /* isNumber */])(props.width) ? props.width : offset.width,
          height: Object(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["h" /* isNumber */])(props.height) ? props.height : offset.height,
          xAxis: xAxis,
          yAxis: yAxis,
          offset: offset,
          chartWidth: width,
          chartHeight: height,
          verticalCoordinatesGenerator: props.verticalCoordinatesGenerator || _this.verticalCoordinatesGenerator,
          horizontalCoordinatesGenerator: props.horizontalCoordinatesGenerator || _this.horizontalCoordinatesGenerator
        });
      };

      _this.renderPolarGrid = function (element) {
        var _this$state5 = _this.state,
            radiusAxisMap = _this$state5.radiusAxisMap,
            angleAxisMap = _this$state5.angleAxisMap;
        var radiusAxis = Object(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["b" /* getAnyElementOfObject */])(radiusAxisMap);
        var angleAxis = Object(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["b" /* getAnyElementOfObject */])(angleAxisMap);
        var cx = angleAxis.cx,
            cy = angleAxis.cy,
            innerRadius = angleAxis.innerRadius,
            outerRadius = angleAxis.outerRadius;
        return Object(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(element, {
          polarAngles: Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["t" /* getTicksOfAxis */])(angleAxis, true).map(function (entry) {
            return entry.coordinate;
          }),
          polarRadius: Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["t" /* getTicksOfAxis */])(radiusAxis, true).map(function (entry) {
            return entry.coordinate;
          }),
          cx: cx,
          cy: cy,
          innerRadius: innerRadius,
          outerRadius: outerRadius,
          key: element.key || 'polar-grid'
        });
      };

      _this.renderBrush = function (element) {
        var _this$props3 = _this.props,
            margin = _this$props3.margin,
            data = _this$props3.data;
        var _this$state6 = _this.state,
            offset = _this$state6.offset,
            dataStartIndex = _this$state6.dataStartIndex,
            dataEndIndex = _this$state6.dataEndIndex,
            updateId = _this$state6.updateId; // TODO: update brush when children update

        return Object(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(element, {
          key: element.key || '_recharts-brush',
          onChange: Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["d" /* combineEventHandlers */])(_this.handleBrushChange, null, element.props.onChange),
          data: data,
          x: Object(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["h" /* isNumber */])(element.props.x) ? element.props.x : offset.left,
          y: Object(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["h" /* isNumber */])(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
          width: Object(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["h" /* isNumber */])(element.props.width) ? element.props.width : offset.width,
          startIndex: dataStartIndex,
          endIndex: dataEndIndex,
          updateId: "brush-".concat(updateId)
        });
      };

      _this.renderReferenceElement = function (element, displayName, index) {
        if (!element) {
          return null;
        }

        var _assertThisInitialize = _assertThisInitialized(_this),
            clipPathId = _assertThisInitialize.clipPathId;

        var _this$state7 = _this.state,
            xAxisMap = _this$state7.xAxisMap,
            yAxisMap = _this$state7.yAxisMap,
            offset = _this$state7.offset;
        var _element$props = element.props,
            xAxisId = _element$props.xAxisId,
            yAxisId = _element$props.yAxisId;
        return Object(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(element, {
          key: element.key || "".concat(displayName, "-").concat(index),
          xAxis: xAxisMap[xAxisId],
          yAxis: yAxisMap[yAxisId],
          viewBox: {
            x: offset.left,
            y: offset.top,
            width: offset.width,
            height: offset.height
          },
          clipPathId: clipPathId
        });
      };

      _this.renderGraphicChild = function (element, displayName, index) {
        var item = _this.filterFormatItem(element, displayName, index);

        if (!item) {
          return null;
        }

        var graphicalItem = Object(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(element, item.props);
        var _this$state8 = _this.state,
            isTooltipActive = _this$state8.isTooltipActive,
            tooltipAxis = _this$state8.tooltipAxis,
            activeTooltipIndex = _this$state8.activeTooltipIndex,
            activeLabel = _this$state8.activeLabel;
        var children = _this.props.children;
        var tooltipItem = Object(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["j" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_12__component_Tooltip__["a" /* default */]);
        var _item$props = item.props,
            points = _item$props.points,
            isRange = _item$props.isRange,
            baseLine = _item$props.baseLine;
        var _item$item$props = item.item.props,
            activeDot = _item$item$props.activeDot,
            hide = _item$item$props.hide;
        var hasActive = !hide && isTooltipActive && tooltipItem && activeDot && activeTooltipIndex >= 0;

        function findWithPayload(entry) {
          return tooltipAxis.dataKey(entry.payload);
        }

        if (hasActive) {
          var activePoint, basePoint;

          if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
            var specifiedKey = typeof tooltipAxis.dataKey === 'function' ? findWithPayload : 'payload.'.concat(tooltipAxis.dataKey);
            activePoint = Object(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["a" /* findEntryInArray */])(points, specifiedKey, activeLabel);
            basePoint = isRange && baseLine && Object(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["a" /* findEntryInArray */])(baseLine, specifiedKey, activeLabel);
          } else {
            activePoint = points[activeTooltipIndex];
            basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
          }

          if (!__WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(activePoint)) {
            return [graphicalItem].concat(_toConsumableArray(_this.renderActivePoints({
              item: item,
              activePoint: activePoint,
              basePoint: basePoint,
              childIndex: activeTooltipIndex,
              isRange: isRange
            })));
          }
        }

        if (isRange) {
          return [graphicalItem, null, null];
        }

        return [graphicalItem, null];
      };

      _this.renderCustomized = function (element) {
        return Object(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(element, _objectSpread({}, _this.props, {}, _this.state));
      };

      var defaultState = _this.constructor.createDefaultState(_props);

      var _updateId = 0;
      _this.state = _objectSpread({}, defaultState, {
        updateId: 0
      }, _this.updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread({
        props: _props
      }, defaultState, {
        updateId: _updateId
      })));
      _this.uniqueChartId = __WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(_props.id) ? Object(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["k" /* uniqueId */])('recharts') : _props.id;
      _this.clipPathId = "".concat(_this.uniqueChartId, "-clip");

      if (_props.throttleDelay) {
        _this.triggeredAfterMouseMove = __WEBPACK_IMPORTED_MODULE_5_lodash_throttle___default()(_this.triggeredAfterMouseMove, _props.throttleDelay);
      }

      return _this;
    }
    /* eslint-disable  react/no-did-mount-set-state */


    _createClass(CategoricalChartWrapper, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (!__WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(this.props.syncId)) {
          this.addListener();
        }
      } // eslint-disable-next-line camelcase

    }, {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        var _this2 = this;

        var _this$props4 = this.props,
            data = _this$props4.data,
            children = _this$props4.children,
            width = _this$props4.width,
            height = _this$props4.height,
            layout = _this$props4.layout,
            stackOffset = _this$props4.stackOffset,
            margin = _this$props4.margin;
        var updateId = this.state.updateId;

        if (nextProps.data !== data || nextProps.width !== width || nextProps.height !== height || nextProps.layout !== layout || nextProps.stackOffset !== stackOffset || !Object(__WEBPACK_IMPORTED_MODULE_27__util_ShallowEqual__["a" /* shallowEqual */])(nextProps.margin, margin)) {
          var defaultState = this.constructor.createDefaultState(nextProps);
          this.setState(_objectSpread({}, defaultState, {
            updateId: updateId + 1
          }, this.updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread({
            props: nextProps
          }, defaultState, {
            updateId: updateId + 1
          }))));
        } else if (!Object(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["n" /* isChildrenEqual */])(nextProps.children, children)) {
          // update configuration in chilren
          var hasGlobalData = !__WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(nextProps.data);
          var newUpdateId = hasGlobalData ? updateId : updateId + 1;
          this.setState(function (prevState) {
            return _objectSpread({
              updateId: newUpdateId
            }, _this2.updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread({
              props: nextProps
            }, prevState, {
              updateId: newUpdateId
            })));
          });
        } // add syncId


        if (__WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(this.props.syncId) && !__WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(nextProps.syncId)) {
          this.addListener();
        } // remove syncId


        if (!__WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(this.props.syncId) && __WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(nextProps.syncId)) {
          this.removeListener();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (!__WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(this.props.syncId)) {
          this.removeListener();
        }

        if (typeof this.triggeredAfterMouseMove.cancel === 'function') {
          this.triggeredAfterMouseMove.cancel();
        }
      }
      /**
      * Get the configuration of all x-axis or y-axis
      * @param  {Object} props          Latest props
      * @param  {String} axisType       The type of axis
      * @param  {Array}  graphicalItems The instances of item
      * @param  {Object} stackGroups    The items grouped by axisId and stackId
      * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
      * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
      * @return {Object}          Configuration
      */

    }, {
      key: "getAxisMap",
      value: function getAxisMap(props, _ref5) {
        var _ref5$axisType = _ref5.axisType,
            axisType = _ref5$axisType === void 0 ? 'xAxis' : _ref5$axisType,
            AxisComp = _ref5.AxisComp,
            graphicalItems = _ref5.graphicalItems,
            stackGroups = _ref5.stackGroups,
            dataStartIndex = _ref5.dataStartIndex,
            dataEndIndex = _ref5.dataEndIndex;
        var children = props.children;
        var axisIdKey = "".concat(axisType, "Id"); // Get all the instance of Axis

        var axes = Object(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["i" /* findAllByType */])(children, AxisComp);
        var axisMap = {};

        if (axes && axes.length) {
          axisMap = this.getAxisMapByAxes(props, {
            axes: axes,
            graphicalItems: graphicalItems,
            axisType: axisType,
            axisIdKey: axisIdKey,
            stackGroups: stackGroups,
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
          });
        } else if (graphicalItems && graphicalItems.length) {
          axisMap = this.getAxisMapByItems(props, {
            Axis: AxisComp,
            graphicalItems: graphicalItems,
            axisType: axisType,
            axisIdKey: axisIdKey,
            stackGroups: stackGroups,
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
          });
        }

        return axisMap;
      }
      /**
       * Get the configuration of axis by the options of axis instance
       * @param  {Object} props         Latest props
       * @param {Array}  axes           The instance of axes
       * @param  {Array} graphicalItems The instances of item
       * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
       * @param  {String} axisIdKey     The unique id of an axis
       * @param  {Object} stackGroups   The items grouped by axisId and stackId
       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
       * @return {Object}      Configuration
       */

    }, {
      key: "getAxisMapByAxes",
      value: function getAxisMapByAxes(props, _ref6) {
        var _this3 = this;

        var axes = _ref6.axes,
            graphicalItems = _ref6.graphicalItems,
            axisType = _ref6.axisType,
            axisIdKey = _ref6.axisIdKey,
            stackGroups = _ref6.stackGroups,
            dataStartIndex = _ref6.dataStartIndex,
            dataEndIndex = _ref6.dataEndIndex;
        var layout = props.layout,
            children = props.children,
            stackOffset = props.stackOffset;
        var isCategorial = Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["w" /* isCategorialAxis */])(layout, axisType); // Eliminate duplicated axes

        var axisMap = axes.reduce(function (result, child) {
          var _child$props = child.props,
              type = _child$props.type,
              dataKey = _child$props.dataKey,
              allowDataOverflow = _child$props.allowDataOverflow,
              allowDuplicatedCategory = _child$props.allowDuplicatedCategory,
              scale = _child$props.scale,
              ticks = _child$props.ticks;
          var axisId = child.props[axisIdKey];

          var displayedData = _this3.constructor.getDisplayedData(props, {
            graphicalItems: graphicalItems.filter(function (item) {
              return item.props[axisIdKey] === axisId;
            }),
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
          });

          var len = displayedData.length;

          if (!result[axisId]) {
            var domain, duplicateDomain, categoricalDomain;

            if (dataKey) {
              domain = Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["m" /* getDomainOfDataByKey */])(displayedData, dataKey, type);

              if (type === 'category' && isCategorial) {
                var duplicate = Object(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["e" /* hasDuplicate */])(domain);

                if (allowDuplicatedCategory && duplicate) {
                  duplicateDomain = domain; // When category axis has duplicated text, serial numbers are used to generate scale

                  domain = __WEBPACK_IMPORTED_MODULE_4_lodash_range___default()(0, len);
                } else if (!allowDuplicatedCategory) {
                  // remove duplicated category
                  domain = Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["x" /* parseDomainOfCategoryAxis */])(child.props.domain, domain, child).reduce(function (finalDomain, entry) {
                    return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat(_toConsumableArray(finalDomain), [entry]);
                  }, []);
                }
              } else if (type === 'category') {
                if (!allowDuplicatedCategory) {
                  domain = Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["x" /* parseDomainOfCategoryAxis */])(child.props.domain, domain, child).reduce(function (finalDomain, entry) {
                    return finalDomain.indexOf(entry) >= 0 || entry === '' || __WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(entry) ? finalDomain : [].concat(_toConsumableArray(finalDomain), [entry]);
                  }, []);
                } else {
                  // eliminate undefined or null or empty string
                  domain = domain.filter(function (entry) {
                    return entry !== '' && !__WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(entry);
                  });
                }
              } else if (type === 'number') {
                var errorBarsDomain = Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["y" /* parseErrorBarsOfAxis */])(displayedData, graphicalItems.filter(function (item) {
                  return item.props[axisIdKey] === axisId && !item.props.hide;
                }), dataKey, axisType);

                if (errorBarsDomain) {
                  domain = errorBarsDomain;
                }
              }

              if (isCategorial && (type === 'number' || scale !== 'auto')) {
                categoricalDomain = Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["m" /* getDomainOfDataByKey */])(displayedData, dataKey, 'category');
              }
            } else if (isCategorial) {
              domain = __WEBPACK_IMPORTED_MODULE_4_lodash_range___default()(0, len);
            } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === 'number') {
              // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
              domain = stackOffset === 'expand' ? [0, 1] : Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["o" /* getDomainOfStackGroups */])(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
            } else {
              domain = Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["n" /* getDomainOfItemsWithSameAxis */])(displayedData, graphicalItems.filter(function (item) {
                return item.props[axisIdKey] === axisId && !item.props.hide;
              }), type, true);
            }

            if (type === 'number') {
              // To detect wether there is any reference lines whose props alwaysShow is true
              domain = Object(__WEBPACK_IMPORTED_MODULE_25__util_DetectReferenceElementsDomain__["a" /* detectReferenceElementsDomain */])(children, domain, axisId, axisType, ticks);

              if (child.props.domain) {
                domain = Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["A" /* parseSpecifiedDomain */])(child.props.domain, domain, allowDataOverflow);
              }
            }

            return _objectSpread({}, result, _defineProperty({}, axisId, _objectSpread({}, child.props, {
              axisType: axisType,
              domain: domain,
              categoricalDomain: categoricalDomain,
              duplicateDomain: duplicateDomain,
              originalDomain: child.props.domain,
              isCategorial: isCategorial,
              layout: layout
            })));
          }

          return result;
        }, {});
        return axisMap;
      }
      /**
       * Get the configuration of axis by the options of item,
       * this kind of axis does not display in chart
       * @param  {Object} props         Latest props
       * @param  {Array} graphicalItems The instances of item
       * @param  {ReactElement} Axis    Axis Component
       * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
       * @param  {String} axisIdKey     The unique id of an axis
       * @param  {Object} stackGroups   The items grouped by axisId and stackId
       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
       * @return {Object}               Configuration
       */

    }, {
      key: "getAxisMapByItems",
      value: function getAxisMapByItems(props, _ref7) {
        var graphicalItems = _ref7.graphicalItems,
            Axis = _ref7.Axis,
            axisType = _ref7.axisType,
            axisIdKey = _ref7.axisIdKey,
            stackGroups = _ref7.stackGroups,
            dataStartIndex = _ref7.dataStartIndex,
            dataEndIndex = _ref7.dataEndIndex;
        var layout = props.layout,
            children = props.children;
        var displayedData = this.constructor.getDisplayedData(props, {
          graphicalItems: graphicalItems,
          dataStartIndex: dataStartIndex,
          dataEndIndex: dataEndIndex
        });
        var len = displayedData.length;
        var isCategorial = Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["w" /* isCategorialAxis */])(layout, axisType);
        var index = -1; // The default type of x-axis is category axis,
        // The default contents of x-axis is the serial numbers of data
        // The default type of y-axis is number axis
        // The default contents of y-axis is the domain of data

        var axisMap = graphicalItems.reduce(function (result, child) {
          var axisId = child.props[axisIdKey];

          if (!result[axisId]) {
            index++;
            var domain;

            if (isCategorial) {
              domain = __WEBPACK_IMPORTED_MODULE_4_lodash_range___default()(0, len);
            } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
              domain = Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["o" /* getDomainOfStackGroups */])(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
              domain = Object(__WEBPACK_IMPORTED_MODULE_25__util_DetectReferenceElementsDomain__["a" /* detectReferenceElementsDomain */])(children, domain, axisId, axisType);
            } else {
              domain = Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["A" /* parseSpecifiedDomain */])(Axis.defaultProps.domain, Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["n" /* getDomainOfItemsWithSameAxis */])(displayedData, graphicalItems.filter(function (item) {
                return item.props[axisIdKey] === axisId && !item.props.hide;
              }), 'number'), Axis.defaultProps.allowDataOverflow);
              domain = Object(__WEBPACK_IMPORTED_MODULE_25__util_DetectReferenceElementsDomain__["a" /* detectReferenceElementsDomain */])(children, domain, axisId, axisType);
            }

            return _objectSpread({}, result, _defineProperty({}, axisId, _objectSpread({
              axisType: axisType
            }, Axis.defaultProps, {
              hide: true,
              orientation: ORIENT_MAP[axisType] && ORIENT_MAP[axisType][index % 2],
              domain: domain,
              originalDomain: Axis.defaultProps.domain,
              isCategorial: isCategorial,
              layout: layout // specify scale when no Axis
              // scale: isCategorial ? 'band' : 'linear',

            })));
          }

          return result;
        }, {});
        return axisMap;
      }
    }, {
      key: "getActiveCoordinate",
      value: function getActiveCoordinate(tooltipTicks, activeIndex, rangeObj) {
        var layout = this.props.layout;
        var entry = tooltipTicks.find(function (tick) {
          return tick && tick.index === activeIndex;
        });

        if (entry) {
          if (layout === 'horizontal') {
            return {
              x: entry.coordinate,
              y: rangeObj.y
            };
          }

          if (layout === 'vertical') {
            return {
              x: rangeObj.x,
              y: entry.coordinate
            };
          }

          if (layout === 'centric') {
            var _angle = entry.coordinate;
            var _radius = rangeObj.radius;
            return _objectSpread({}, rangeObj, {}, Object(__WEBPACK_IMPORTED_MODULE_26__util_PolarUtils__["e" /* polarToCartesian */])(rangeObj.cx, rangeObj.cy, _radius, _angle), {
              angle: _angle,
              radius: _radius
            });
          }

          var radius = entry.coordinate;
          var angle = rangeObj.angle;
          return _objectSpread({}, rangeObj, {}, Object(__WEBPACK_IMPORTED_MODULE_26__util_PolarUtils__["e" /* polarToCartesian */])(rangeObj.cx, rangeObj.cy, radius, angle), {
            angle: angle,
            radius: radius
          });
        }

        return originCoordinate;
      }
      /**
       * Get the information of mouse in chart, return null when the mouse is not in the chart
       * @param  {Object} event    The event object
       * @return {Object}          Mouse data
       */

    }, {
      key: "getMouseInfo",
      value: function getMouseInfo(event) {
        if (!this.container) {
          return null;
        }

        var containerOffset = Object(__WEBPACK_IMPORTED_MODULE_22__util_DOMUtils__["b" /* getOffset */])(this.container);
        var e = Object(__WEBPACK_IMPORTED_MODULE_22__util_DOMUtils__["a" /* calculateChartCoordinate */])(event, containerOffset);
        var rangeObj = this.inRange(e.chartX, e.chartY);

        if (!rangeObj) {
          return null;
        }

        var _this$state9 = this.state,
            xAxisMap = _this$state9.xAxisMap,
            yAxisMap = _this$state9.yAxisMap;

        if (eventType !== 'axis' && xAxisMap && yAxisMap) {
          var xScale = Object(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["b" /* getAnyElementOfObject */])(xAxisMap).scale;
          var yScale = Object(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["b" /* getAnyElementOfObject */])(yAxisMap).scale;
          var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
          var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
          return _objectSpread({}, e, {
            xValue: xValue,
            yValue: yValue
          });
        }

        var _this$state10 = this.state,
            ticks = _this$state10.orderedTooltipTicks,
            axis = _this$state10.tooltipAxis,
            tooltipTicks = _this$state10.tooltipTicks;
        var pos = this.calculateTooltipPos(rangeObj);
        var activeIndex = Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["b" /* calculateActiveTickIndex */])(pos, ticks, tooltipTicks, axis);

        if (activeIndex >= 0 && tooltipTicks) {
          var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
          var activePayload = this.getTooltipContent(activeIndex, activeLabel);
          var activeCoordinate = this.getActiveCoordinate(ticks, activeIndex, rangeObj);
          return _objectSpread({}, e, {
            activeTooltipIndex: activeIndex,
            activeLabel: activeLabel,
            activePayload: activePayload,
            activeCoordinate: activeCoordinate
          });
        }

        return null;
      }
      /**
       * Get the content to be displayed in the tooltip
       * @param  {Number} activeIndex    Active index of data
       * @param  {String} activeLabel    Active label of data
       * @return {Array}                 The content of tooltip
       */

    }, {
      key: "getTooltipContent",
      value: function getTooltipContent(activeIndex, activeLabel) {
        var _this$state11 = this.state,
            graphicalItems = _this$state11.graphicalItems,
            tooltipAxis = _this$state11.tooltipAxis;
        var displayedData = this.constructor.getDisplayedData(this.props, this.state);

        if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) {
          return null;
        } // get data by activeIndex when the axis don't allow duplicated category


        return graphicalItems.reduce(function (result, child) {
          var hide = child.props.hide;

          if (hide) {
            return result;
          }

          var _child$props2 = child.props,
              dataKey = _child$props2.dataKey,
              name = _child$props2.name,
              unit = _child$props2.unit,
              formatter = _child$props2.formatter,
              data = _child$props2.data,
              tooltipType = _child$props2.tooltipType;
          var payload;

          if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
            // graphic child has data props
            payload = Object(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["a" /* findEntryInArray */])(data || displayedData, tooltipAxis.dataKey, activeLabel);
          } else {
            payload = data && data[activeIndex] || displayedData[activeIndex];
          }

          if (!payload) {
            return result;
          }

          return [].concat(_toConsumableArray(result), [_objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["l" /* getPresentationAttributes */])(child), {
            dataKey: dataKey,
            unit: unit,
            formatter: formatter,
            name: name || dataKey,
            color: Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["q" /* getMainColorOfGraphicItem */])(child),
            value: Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["v" /* getValueByDataKey */])(payload, dataKey),
            type: tooltipType,
            payload: payload
          })]);
        }, []);
      }
    }, {
      key: "getFormatItems",
      value: function getFormatItems(props, currentState) {
        var _this4 = this;

        var graphicalItems = currentState.graphicalItems,
            stackGroups = currentState.stackGroups,
            offset = currentState.offset,
            updateId = currentState.updateId,
            dataStartIndex = currentState.dataStartIndex,
            dataEndIndex = currentState.dataEndIndex;
        var barSize = props.barSize,
            layout = props.layout,
            barGap = props.barGap,
            barCategoryGap = props.barCategoryGap,
            globalMaxBarSize = props.maxBarSize;

        var _this$constructor$get = this.constructor.getAxisNameByLayout(layout),
            numericAxisName = _this$constructor$get.numericAxisName,
            cateAxisName = _this$constructor$get.cateAxisName;

        var hasBar = this.constructor.hasBar(graphicalItems);
        var sizeList = hasBar && Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["h" /* getBarSizeList */])({
          barSize: barSize,
          stackGroups: stackGroups
        });
        var formatedItems = [];
        graphicalItems.forEach(function (item, index) {
          var displayedData = _this4.constructor.getDisplayedData(props, {
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
          }, item);

          var _item$props2 = item.props,
              dataKey = _item$props2.dataKey,
              childMaxBarSize = _item$props2.maxBarSize;
          var numericAxisId = item.props["".concat(numericAxisName, "Id")];
          var cateAxisId = item.props["".concat(cateAxisName, "Id")];
          var axisObj = axisComponents.reduce(function (result, entry) {
            var _objectSpread4;

            var axisMap = currentState["".concat(entry.axisType, "Map")];
            var id = item.props["".concat(entry.axisType, "Id")];
            var axis = axisMap && axisMap[id];
            return _objectSpread({}, result, (_objectSpread4 = {}, _defineProperty(_objectSpread4, entry.axisType, axis), _defineProperty(_objectSpread4, "".concat(entry.axisType, "Ticks"), Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["t" /* getTicksOfAxis */])(axis)), _objectSpread4));
          }, {});
          var cateAxis = axisObj[cateAxisName];
          var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
          var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["s" /* getStackedDataOfItem */])(item, stackGroups[numericAxisId].stackGroups);
          var bandSize = Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["f" /* getBandSizeOfAxis */])(cateAxis, cateTicks);
          var maxBarSize = __WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
          var barPosition = hasBar && Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["g" /* getBarPosition */])({
            barGap: barGap,
            barCategoryGap: barCategoryGap,
            bandSize: bandSize,
            sizeList: sizeList[cateAxisId],
            maxBarSize: maxBarSize
          });
          var componsedFn = item && item.type && item.type.getComposedData;

          if (componsedFn) {
            var _objectSpread5;

            formatedItems.push({
              props: _objectSpread({}, componsedFn(_objectSpread({}, axisObj, {
                displayedData: displayedData,
                props: props,
                dataKey: dataKey,
                item: item,
                bandSize: bandSize,
                barPosition: barPosition,
                offset: offset,
                stackedData: stackedData,
                layout: layout,
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex,
                onItemMouseLeave: Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["d" /* combineEventHandlers */])(_this4.handleItemMouseLeave, null, item.props.onMouseLeave),
                onItemMouseEnter: Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["d" /* combineEventHandlers */])(_this4.handleItemMouseEnter, null, item.props.onMouseEnter)
              })), (_objectSpread5 = {
                key: item.key || "item-".concat(index)
              }, _defineProperty(_objectSpread5, numericAxisName, axisObj[numericAxisName]), _defineProperty(_objectSpread5, cateAxisName, axisObj[cateAxisName]), _defineProperty(_objectSpread5, "animationId", updateId), _objectSpread5)),
              childIndex: Object(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["p" /* parseChildIndex */])(item, props.children),
              item: item
            });
          }
        });
        return formatedItems;
      }
    }, {
      key: "getCursorRectangle",
      value: function getCursorRectangle() {
        var layout = this.props.layout;
        var _this$state12 = this.state,
            activeCoordinate = _this$state12.activeCoordinate,
            offset = _this$state12.offset,
            tooltipAxisBandSize = _this$state12.tooltipAxisBandSize;
        var halfSize = tooltipAxisBandSize / 2;
        return {
          stroke: 'none',
          fill: '#ccc',
          x: layout === 'horizontal' ? activeCoordinate.x - halfSize : offset.left + 0.5,
          y: layout === 'horizontal' ? offset.top + 0.5 : activeCoordinate.y - halfSize,
          width: layout === 'horizontal' ? tooltipAxisBandSize : offset.width - 1,
          height: layout === 'horizontal' ? offset.height - 1 : tooltipAxisBandSize
        };
      }
    }, {
      key: "getCursorPoints",
      value: function getCursorPoints() {
        var layout = this.props.layout;
        var _this$state13 = this.state,
            activeCoordinate = _this$state13.activeCoordinate,
            offset = _this$state13.offset;
        var x1, y1, x2, y2;

        if (layout === 'horizontal') {
          x1 = activeCoordinate.x;
          x2 = x1;
          y1 = offset.top;
          y2 = offset.top + offset.height;
        } else if (layout === 'vertical') {
          y1 = activeCoordinate.y;
          y2 = y1;
          x1 = offset.left;
          x2 = offset.left + offset.width;
        } else if (!__WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(activeCoordinate.cx) || !__WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(activeCoordinate.cy)) {
          if (layout === 'centric') {
            var cx = activeCoordinate.cx,
                cy = activeCoordinate.cy,
                innerRadius = activeCoordinate.innerRadius,
                outerRadius = activeCoordinate.outerRadius,
                angle = activeCoordinate.angle;
            var innerPoint = Object(__WEBPACK_IMPORTED_MODULE_26__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, innerRadius, angle);
            var outerPoint = Object(__WEBPACK_IMPORTED_MODULE_26__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, outerRadius, angle);
            x1 = innerPoint.x;
            y1 = innerPoint.y;
            x2 = outerPoint.x;
            y2 = outerPoint.y;
          } else {
            var _cx = activeCoordinate.cx,
                _cy = activeCoordinate.cy,
                radius = activeCoordinate.radius,
                startAngle = activeCoordinate.startAngle,
                endAngle = activeCoordinate.endAngle;
            var startPoint = Object(__WEBPACK_IMPORTED_MODULE_26__util_PolarUtils__["e" /* polarToCartesian */])(_cx, _cy, radius, startAngle);
            var endPoint = Object(__WEBPACK_IMPORTED_MODULE_26__util_PolarUtils__["e" /* polarToCartesian */])(_cx, _cy, radius, endAngle);
            return {
              points: [startPoint, endPoint],
              cx: _cx,
              cy: _cy,
              radius: radius,
              startAngle: startAngle,
              endAngle: endAngle
            };
          }
        }

        return [{
          x: x1,
          y: y1
        }, {
          x: x2,
          y: y2
        }];
      }
    }, {
      key: "calculateTooltipPos",
      value: function calculateTooltipPos(rangeObj) {
        var layout = this.props.layout;

        if (layout === 'horizontal') {
          return rangeObj.x;
        }

        if (layout === 'vertical') {
          return rangeObj.y;
        }

        if (layout === 'centric') {
          return rangeObj.angle;
        }

        return rangeObj.radius;
      }
    }, {
      key: "inRange",
      value: function inRange(x, y) {
        var layout = this.props.layout;

        if (layout === 'horizontal' || layout === 'vertical') {
          var offset = this.state.offset;
          var isInRange = x >= offset.left && x <= offset.left + offset.width && y >= offset.top && y <= offset.top + offset.height;
          return isInRange ? {
            x: x,
            y: y
          } : null;
        }

        var _this$state14 = this.state,
            angleAxisMap = _this$state14.angleAxisMap,
            radiusAxisMap = _this$state14.radiusAxisMap;

        if (angleAxisMap && radiusAxisMap) {
          var angleAxis = Object(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["b" /* getAnyElementOfObject */])(angleAxisMap);
          return Object(__WEBPACK_IMPORTED_MODULE_26__util_PolarUtils__["d" /* inRangeOfSector */])({
            x: x,
            y: y
          }, angleAxis);
        }

        return null;
      }
    }, {
      key: "parseEventsOfWrapper",
      value: function parseEventsOfWrapper() {
        var children = this.props.children;
        var tooltipItem = Object(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["j" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_12__component_Tooltip__["a" /* default */]);
        var tooltipEvents = tooltipItem && eventType === 'axis' ? {
          onMouseEnter: this.handleMouseEnter,
          onMouseMove: this.handleMouseMove,
          onMouseLeave: this.handleMouseLeave,
          onTouchMove: this.handleTouchMove,
          onTouchStart: this.handleTouchStart,
          onTouchEnd: this.handleTouchEnd
        } : {};
        var outerEvents = Object(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["f" /* filterEventAttributes */])(this.props, this.handleOuterEvent);
        return _objectSpread({}, outerEvents, {}, tooltipEvents);
      }
      /**
       * The AxisMaps are expensive to render on large data sets
       * so provide the ability to store them in state and only update them when necessary
       * they are dependent upon the start and end index of
       * the brush so it's important that this method is called _after_
       * the state is updated with any new start/end indices
       *
       * @param {Object} props          The props object to be used for updating the axismaps
       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
       * @param {Number} updateId       The update id
       * @return {Object} state New state to set
       */

    }, {
      key: "updateStateOfAxisMapsOffsetAndStackGroups",
      value: function updateStateOfAxisMapsOffsetAndStackGroups(_ref8) {
        var _this5 = this;

        var props = _ref8.props,
            dataStartIndex = _ref8.dataStartIndex,
            dataEndIndex = _ref8.dataEndIndex,
            updateId = _ref8.updateId;

        if (!Object(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["r" /* validateWidthHeight */])({
          props: props
        })) {
          return null;
        }

        var children = props.children,
            layout = props.layout,
            stackOffset = props.stackOffset,
            data = props.data,
            reverseStackOrder = props.reverseStackOrder;

        var _this$constructor$get2 = this.constructor.getAxisNameByLayout(layout),
            numericAxisName = _this$constructor$get2.numericAxisName,
            cateAxisName = _this$constructor$get2.cateAxisName;

        var graphicalItems = Object(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["i" /* findAllByType */])(children, GraphicalChild);
        var stackGroups = Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["r" /* getStackGroupsByAxisId */])(data, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
        var axisObj = axisComponents.reduce(function (result, entry) {
          var name = "".concat(entry.axisType, "Map");
          return _objectSpread({}, result, _defineProperty({}, name, _this5.getAxisMap(props, _objectSpread({}, entry, {
            graphicalItems: graphicalItems,
            stackGroups: entry.axisType === numericAxisName && stackGroups,
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
          }))));
        }, {});
        var offset = this.calculateOffset(_objectSpread({}, axisObj, {
          props: props,
          graphicalItems: graphicalItems
        }));
        Object.keys(axisObj).forEach(function (key) {
          axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace('Map', ''), chartName);
        });
        var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
        var ticksObj = this.tooltipTicksGenerator(cateAxisMap);
        var formatedGraphicalItems = this.getFormatItems(props, _objectSpread({}, axisObj, {
          dataStartIndex: dataStartIndex,
          dataEndIndex: dataEndIndex,
          updateId: updateId,
          graphicalItems: graphicalItems,
          stackGroups: stackGroups,
          offset: offset
        }));
        return _objectSpread({
          formatedGraphicalItems: formatedGraphicalItems,
          graphicalItems: graphicalItems,
          offset: offset,
          stackGroups: stackGroups
        }, ticksObj, {}, axisObj);
      }
      /* eslint-disable  no-underscore-dangle */

    }, {
      key: "addListener",
      value: function addListener() {
        __WEBPACK_IMPORTED_MODULE_28__util_Events__["b" /* eventCenter */].on(__WEBPACK_IMPORTED_MODULE_28__util_Events__["a" /* SYNC_EVENT */], this.handleReceiveSyncEvent);

        if (__WEBPACK_IMPORTED_MODULE_28__util_Events__["b" /* eventCenter */].setMaxListeners && __WEBPACK_IMPORTED_MODULE_28__util_Events__["b" /* eventCenter */]._maxListeners) {
          __WEBPACK_IMPORTED_MODULE_28__util_Events__["b" /* eventCenter */].setMaxListeners(__WEBPACK_IMPORTED_MODULE_28__util_Events__["b" /* eventCenter */]._maxListeners + 1);
        }
      }
    }, {
      key: "removeListener",
      value: function removeListener() {
        __WEBPACK_IMPORTED_MODULE_28__util_Events__["b" /* eventCenter */].removeListener(__WEBPACK_IMPORTED_MODULE_28__util_Events__["a" /* SYNC_EVENT */], this.handleReceiveSyncEvent);

        if (__WEBPACK_IMPORTED_MODULE_28__util_Events__["b" /* eventCenter */].setMaxListeners && __WEBPACK_IMPORTED_MODULE_28__util_Events__["b" /* eventCenter */]._maxListeners) {
          __WEBPACK_IMPORTED_MODULE_28__util_Events__["b" /* eventCenter */].setMaxListeners(__WEBPACK_IMPORTED_MODULE_28__util_Events__["b" /* eventCenter */]._maxListeners - 1);
        }
      }
      /**
       * Calculate the offset of main part in the svg element
       * @param  {Object} props          Latest props
       * @param  {Array}  graphicalItems The instances of item
       * @param  {Object} xAxisMap       The configuration of x-axis
       * @param  {Object} yAxisMap       The configuration of y-axis
       * @return {Object} The offset of main part in the svg element
       */

    }, {
      key: "calculateOffset",
      value: function calculateOffset(_ref9) {
        var props = _ref9.props,
            graphicalItems = _ref9.graphicalItems,
            _ref9$xAxisMap = _ref9.xAxisMap,
            xAxisMap = _ref9$xAxisMap === void 0 ? {} : _ref9$xAxisMap,
            _ref9$yAxisMap = _ref9.yAxisMap,
            yAxisMap = _ref9$yAxisMap === void 0 ? {} : _ref9$yAxisMap;
        var width = props.width,
            height = props.height,
            children = props.children;
        var margin = props.margin || {};
        var brushItem = Object(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["j" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_21__cartesian_Brush__["a" /* default */]);
        var legendItem = Object(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["j" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_13__component_Legend__["a" /* default */]);
        var offsetH = Object.keys(yAxisMap).reduce(function (result, id) {
          var entry = yAxisMap[id];
          var orientation = entry.orientation;

          if (!entry.mirror && !entry.hide) {
            return _objectSpread({}, result, _defineProperty({}, orientation, result[orientation] + entry.width));
          }

          return result;
        }, {
          left: margin.left || 0,
          right: margin.right || 0
        });
        var offsetV = Object.keys(xAxisMap).reduce(function (result, id) {
          var entry = xAxisMap[id];
          var orientation = entry.orientation;

          if (!entry.mirror && !entry.hide) {
            return _objectSpread({}, result, _defineProperty({}, orientation, result[orientation] + entry.height));
          }

          return result;
        }, {
          top: margin.top || 0,
          bottom: margin.bottom || 0
        });

        var offset = _objectSpread({}, offsetV, {}, offsetH);

        var brushBottom = offset.bottom;

        if (brushItem) {
          offset.bottom += brushItem.props.height || __WEBPACK_IMPORTED_MODULE_21__cartesian_Brush__["a" /* default */].defaultProps.height;
        }

        if (legendItem && this.legendInstance) {
          var legendBox = this.legendInstance.getBBox();
          offset = Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["a" /* appendOffsetOfLegend */])(offset, graphicalItems, props, legendBox);
        }

        return _objectSpread({
          brushBottom: brushBottom
        }, offset, {
          width: width - offset.left - offset.right,
          height: height - offset.top - offset.bottom
        });
      }
    }, {
      key: "triggerSyncEvent",
      value: function triggerSyncEvent(data) {
        var syncId = this.props.syncId;

        if (!__WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(syncId)) {
          __WEBPACK_IMPORTED_MODULE_28__util_Events__["b" /* eventCenter */].emit(__WEBPACK_IMPORTED_MODULE_28__util_Events__["a" /* SYNC_EVENT */], syncId, this.uniqueChartId, data);
        }
      }
    }, {
      key: "filterFormatItem",
      value: function filterFormatItem(item, displayName, childIndex) {
        var formatedGraphicalItems = this.state.formatedGraphicalItems;

        for (var i = 0, len = formatedGraphicalItems.length; i < len; i++) {
          var entry = formatedGraphicalItems[i];

          if (entry.item === item || entry.props.key === item.key || displayName === Object(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["k" /* getDisplayName */])(entry.item.type) && childIndex === entry.childIndex) {
            return entry;
          }
        }

        return null;
      }
    }, {
      key: "renderAxis",

      /**
       * Draw axis
       * @param {Object} axisOptions The options of axis
       * @param {Object} element      The axis element
       * @param {String} displayName  The display name of axis
       * @param {Number} index        The index of element
       * @return {ReactElement}       The instance of x-axes
       */
      value: function renderAxis(axisOptions, element, displayName, index) {
        var _this$props5 = this.props,
            width = _this$props5.width,
            height = _this$props5.height;
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__cartesian_CartesianAxis__["a" /* default */], _extends({}, axisOptions, {
          className: "recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType),
          key: element.key || "".concat(displayName, "-").concat(index),
          viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
          },
          ticksGenerator: this.axesTicksGenerator
        }));
      }
      /**
       * Draw grid
       * @param  {ReactElement} element the grid item
       * @return {ReactElement} The instance of grid
       */

    }, {
      key: "renderLegend",

      /**
       * Draw legend
       * @return {ReactElement}            The instance of Legend
       */
      value: function renderLegend() {
        var _this6 = this;

        var formatedGraphicalItems = this.state.formatedGraphicalItems;
        var _this$props6 = this.props,
            children = _this$props6.children,
            width = _this$props6.width,
            height = _this$props6.height;
        var margin = this.props.margin || {};
        var legendWidth = width - (margin.left || 0) - (margin.right || 0);
        var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
        var props = Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["p" /* getLegendProps */])({
          children: children,
          formatedGraphicalItems: formatedGraphicalItems,
          legendWidth: legendWidth,
          legendHeight: legendHeight,
          legendContent: legendContent
        });

        if (!props) {
          return null;
        }

        var item = props.item,
            otherProps = _objectWithoutProperties(props, ["item"]);

        return Object(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(item, _objectSpread({}, otherProps, {
          chartWidth: width,
          chartHeight: height,
          margin: margin,
          ref: function ref(legend) {
            _this6.legendInstance = legend;
          },
          onBBoxUpdate: this.handleLegendBBoxUpdate
        }));
      }
      /**
       * Draw Tooltip
       * @return {ReactElement}  The instance of Tooltip
       */

    }, {
      key: "renderTooltip",
      value: function renderTooltip() {
        var children = this.props.children;
        var tooltipItem = Object(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["j" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_12__component_Tooltip__["a" /* default */]);

        if (!tooltipItem) {
          return null;
        }

        var _this$state15 = this.state,
            isTooltipActive = _this$state15.isTooltipActive,
            activeCoordinate = _this$state15.activeCoordinate,
            activePayload = _this$state15.activePayload,
            activeLabel = _this$state15.activeLabel,
            offset = _this$state15.offset;
        return Object(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(tooltipItem, {
          viewBox: _objectSpread({}, offset, {
            x: offset.left,
            y: offset.top
          }),
          active: isTooltipActive,
          label: activeLabel,
          payload: isTooltipActive ? activePayload : [],
          coordinate: activeCoordinate
        });
      }
    }, {
      key: "renderActivePoints",
      value: function renderActivePoints(_ref10) {
        var item = _ref10.item,
            activePoint = _ref10.activePoint,
            basePoint = _ref10.basePoint,
            childIndex = _ref10.childIndex,
            isRange = _ref10.isRange;
        var result = [];
        var key = item.props.key;
        var _item$item$props2 = item.item.props,
            activeDot = _item$item$props2.activeDot,
            dataKey = _item$item$props2.dataKey;

        var dotProps = _objectSpread({
          index: childIndex,
          dataKey: dataKey,
          cx: activePoint.x,
          cy: activePoint.y,
          r: 4,
          fill: Object(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["q" /* getMainColorOfGraphicItem */])(item.item),
          strokeWidth: 2,
          stroke: '#fff',
          payload: activePoint.payload,
          value: activePoint.value,
          key: "".concat(key, "-activePoint-").concat(childIndex)
        }, Object(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["l" /* getPresentationAttributes */])(activeDot), {}, Object(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["f" /* filterEventAttributes */])(activeDot));

        result.push(this.constructor.renderActiveDot(activeDot, dotProps, childIndex));

        if (basePoint) {
          result.push(this.constructor.renderActiveDot(activeDot, _objectSpread({}, dotProps, {
            cx: basePoint.x,
            cy: basePoint.y,
            key: "".concat(key, "-basePoint-").concat(childIndex)
          }), childIndex));
        } else if (isRange) {
          result.push(null);
        }

        return result;
      }
    }, {
      key: "renderClipPath",
      value: function renderClipPath() {
        var clipPathId = this.clipPathId;
        var _this$state$offset = this.state.offset,
            left = _this$state$offset.left,
            top = _this$state$offset.top,
            height = _this$state$offset.height,
            width = _this$state$offset.width;
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("defs", null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("clipPath", {
          id: clipPathId
        }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("rect", {
          x: left,
          y: top,
          height: height,
          width: width
        })));
      }
    }, {
      key: "render",
      value: function render() {
        var _this7 = this;

        if (!Object(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["r" /* validateWidthHeight */])(this)) {
          return null;
        }

        var _this$props7 = this.props,
            children = _this$props7.children,
            className = _this$props7.className,
            width = _this$props7.width,
            height = _this$props7.height,
            style = _this$props7.style,
            compact = _this$props7.compact,
            others = _objectWithoutProperties(_this$props7, ["children", "className", "width", "height", "style", "compact"]);

        var attrs = Object(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["l" /* getPresentationAttributes */])(others);
        var map = {
          CartesianGrid: {
            handler: this.renderGrid,
            once: true
          },
          ReferenceArea: {
            handler: this.renderReferenceElement
          },
          ReferenceLine: {
            handler: this.renderReferenceElement
          },
          ReferenceDot: {
            handler: this.renderReferenceElement
          },
          XAxis: {
            handler: this.renderXAxis
          },
          YAxis: {
            handler: this.renderYAxis
          },
          Brush: {
            handler: this.renderBrush,
            once: true
          },
          Bar: {
            handler: this.renderGraphicChild
          },
          Line: {
            handler: this.renderGraphicChild
          },
          Area: {
            handler: this.renderGraphicChild
          },
          Radar: {
            handler: this.renderGraphicChild
          },
          RadialBar: {
            handler: this.renderGraphicChild
          },
          Scatter: {
            handler: this.renderGraphicChild
          },
          Pie: {
            handler: this.renderGraphicChild
          },
          Funnel: {
            handler: this.renderGraphicChild
          },
          Tooltip: {
            handler: this.renderCursor,
            once: true
          },
          PolarGrid: {
            handler: this.renderPolarGrid,
            once: true
          },
          PolarAngleAxis: {
            handler: this.renderPolarAxis
          },
          PolarRadiusAxis: {
            handler: this.renderPolarAxis
          },
          Customized: {
            handler: this.renderCustomized
          }
        }; // The "compact" mode is mainly used as the panorama within Brush

        if (compact) {
          return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__container_Surface__["a" /* default */], _extends({}, attrs, {
            width: width,
            height: height
          }), this.renderClipPath(), Object(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["q" /* renderByOrder */])(children, map));
        }

        var events = this.parseEventsOfWrapper();
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div", _extends({
          className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()('recharts-wrapper', className),
          style: _objectSpread({
            position: 'relative',
            cursor: 'default',
            width: width,
            height: height
          }, style)
        }, events, {
          ref: function ref(node) {
            _this7.container = node;
          }
        }), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__container_Surface__["a" /* default */], _extends({}, attrs, {
          width: width,
          height: height
        }), this.renderClipPath(), Object(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["q" /* renderByOrder */])(children, map)), this.renderLegend(), this.renderTooltip());
      }
    }], [{
      key: "getAxisNameByLayout",
      value: function getAxisNameByLayout(layout) {
        if (layout === 'horizontal') {
          return {
            numericAxisName: 'yAxis',
            cateAxisName: 'xAxis'
          };
        }

        if (layout === 'vertical') {
          return {
            numericAxisName: 'xAxis',
            cateAxisName: 'yAxis'
          };
        }

        if (layout === 'centric') {
          return {
            numericAxisName: 'radiusAxis',
            cateAxisName: 'angleAxis'
          };
        }

        return {
          numericAxisName: 'angleAxis',
          cateAxisName: 'radiusAxis'
        };
      }
    }, {
      key: "renderActiveDot",
      value: function renderActiveDot(option, props) {
        var dot;

        if (Object(__WEBPACK_IMPORTED_MODULE_7_react__["isValidElement"])(option)) {
          dot = Object(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(option, props);
        } else if (__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(option)) {
          dot = option(props);
        } else {
          dot = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shape_Dot__["a" /* default */], props);
        }

        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__container_Layer__["a" /* default */], {
          className: "recharts-active-dot",
          key: props.key
        }, dot);
      }
    }]);

    return CategoricalChartWrapper;
  }(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

  CategoricalChartWrapper.displayName = chartName;
  CategoricalChartWrapper.propTypes = _objectSpread({
    syncId: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number]),
    compact: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
    width: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
    height: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
    data: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object),
    layout: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(['horizontal', 'vertical']),
    stackOffset: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(['sign', 'expand', 'none', 'wiggle', 'silhouette']),
    throttleDelay: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
    margin: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.shape({
      top: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
      right: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
      bottom: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
      left: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number
    }),
    barCategoryGap: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string]),
    barGap: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string]),
    barSize: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string]),
    maxBarSize: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
    style: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
    className: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
    children: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node]),
    defaultShowTooltip: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
    onClick: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    onMouseLeave: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    onMouseEnter: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    onMouseMove: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    onMouseDown: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    onMouseUp: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    reverseStackOrder: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
    id: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
  }, propTypes);
  CategoricalChartWrapper.defaultProps = _objectSpread({
    layout: 'horizontal',
    stackOffset: 'none',
    barCategoryGap: '10%',
    barGap: 4,
    margin: {
      top: 5,
      right: 5,
      bottom: 5,
      left: 5
    },
    reverseStackOrder: false
  }, defaultProps);

  CategoricalChartWrapper.createDefaultState = function (props) {
    var children = props.children,
        defaultShowTooltip = props.defaultShowTooltip;
    var brushItem = Object(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["j" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_21__cartesian_Brush__["a" /* default */]);
    var startIndex = brushItem && brushItem.props && brushItem.props.startIndex || 0;
    var endIndex = brushItem && brushItem.props && brushItem.props.endIndex || props.data && props.data.length - 1 || 0;
    return {
      chartX: 0,
      chartY: 0,
      dataStartIndex: startIndex,
      dataEndIndex: endIndex,
      activeTooltipIndex: -1,
      isTooltipActive: !__WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(defaultShowTooltip) ? defaultShowTooltip : false
    };
  };

  CategoricalChartWrapper.hasBar = function (graphicalItems) {
    if (!graphicalItems || !graphicalItems.length) {
      return false;
    }

    return graphicalItems.some(function (item) {
      var name = Object(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["k" /* getDisplayName */])(item && item.type);
      return name && name.indexOf('Bar') >= 0;
    });
  };

  CategoricalChartWrapper.getDisplayedData = function (props, _ref11, item) {
    var graphicalItems = _ref11.graphicalItems,
        dataStartIndex = _ref11.dataStartIndex,
        dataEndIndex = _ref11.dataEndIndex;
    var itemsData = (graphicalItems || []).reduce(function (result, child) {
      var itemData = child.props.data;

      if (itemData && itemData.length) {
        return [].concat(_toConsumableArray(result), _toConsumableArray(itemData));
      }

      return result;
    }, []);

    if (itemsData && itemsData.length > 0) {
      return itemsData;
    }

    if (item && item.props && item.props.data && item.props.data.length > 0) {
      return item.props.data;
    }

    var data = props.data;

    if (data && data.length && Object(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["h" /* isNumber */])(dataStartIndex) && Object(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["h" /* isNumber */])(dataEndIndex)) {
      return data.slice(dataStartIndex, dataEndIndex + 1);
    }

    return [];
  };

  return CategoricalChartWrapper;
};

/* harmony default export */ __webpack_exports__["a"] = (generateCategoricalChart);

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports = {
	overlay: {
		backgroundColor: 'rgba(0, 0, 0, 0.4)',
		position: 'fixed',
		left: 0,
		right: 0,
		top: 0,
		bottom: 0,
		zIndex: 5000
	},
	sweetAlert: {
		backgroundColor: '#fff',
		outline: 'none',
		width: 478,
		padding: 17,
		borderRadius: 5,
		textAlign: 'center',
		position: 'fixed',
		left: '50%',
		top: '50%',
		marginLeft: -256,
		marginTop: -200,
		overflow: 'hidden',
		zIndex: 5500,
		animation: 'showSweetAlert 0.3s'
	},
	sweetAlertMobile: {
		width: 'auto',
		marginLeft: 0,
		marginRight: 0,
		left: 15,
		right: 15
	},
	icon: {
		width: 80,
		height: 80,
		borderWidth: 4,
		borderStyle: 'solid',
		borderColor: 'gray',
		borderRadius: '50%',
		margin: '20px auto',
		position: 'relative',
		boxSizing: 'content-box'
	},
	iconError: {
		borderColor: '#d43f3a',
		animation: 'animateErrorIcon 0.5s'
	},
	iconErrorX: {
		position: 'relative',
		display: 'block',
		animation: 'animateXMark 0.5s'
	},
	iconErrorLine: {
		position: 'absolute',
		height: 5,
		width: 47,
		backgroundColor: '#d9534f',
		display: 'block',
		top: 37,
		borderRadius: 2
	},
	iconErrorLineLeft: {
		transform: 'rotate(45deg)',
		left: 17
	},
	iconErrorLineRight: {
		transform: 'rotate(-45deg)',
		right: 16
	},
	iconWarning: {
		borderColor: '#eea236',
		animation: 'pulseWarning 0.75s infinite alternate'
	},
	iconWarningBody: {
		position: 'absolute',
		width: 5,
		height: 47,
		left: '50%',
		top: 10,
		borderRadius: 2,
		marginLeft: -2,
		backgroundColor: '#f0ad4e',
		animation: 'pulseWarningIns 0.75s infinite alternate'
	},
	iconWarningDot: {
		position: 'absolute',
		width: 7,
		height: 7,
		borderRadius: '50%',
		marginLeft: -3,
		left: '50%',
		bottom: 10,
		backgroundColor: '#f0ad4e',
		animation: 'pulseWarningIns 0.75s infinite alternate'
	},
	iconInfo: {
		borderColor: '#46b8da'
	},
	iconInfoBefore: {
		content: "",
		position: 'absolute',
		width: 5,
		height: 29,
		left: '50%',
		bottom: 17,
		borderRadius: 2,
		marginLeft: -2,
		backgroundColor: '#5bc0de'
	},
	iconInfoAfter: {
		content: "",
		position: 'absolute',
		width: 7,
		height: 7,
		borderRadius: '50%',
		marginLeft: -3,
		left: '50%',
		top: 19,
		backgroundColor: '#5bc0de'
	},
	iconSuccess: {
		borderColor: '#4cae4c'
	},
	iconSuccessBeforeAfter: {
		content: '',
		borderRadius: '50%',
		position: 'absolute',
		width: 60,
		height: 120,
		background: 'white',
		transform: 'rotate(45deg)'
	},
	iconSuccessBefore: {
		borderRadius: '120px 0 0 120px',
		height: 100,
		top: -7,
		left: -33,
		transform: 'rotate(-45deg)',
		transformOrigin: '60px 60px'
	},
	iconSuccessAfter: {
		borderRadius: '0 120px 120px 0',
		top: -11,
		left: 30,
		transform: 'rotate(-45deg)',
		transformOrigin: '0px 60px',
		animation: 'rotatePlaceholder 4.25s ease-in'
	},
	iconSuccessPlaceholder: {
		width: 80,
		height: 80,
		border: '4px solid rgba(92, 184, 92, 0.2)',
		borderRadius: '50%',
		boxSizing: 'content-box',
		position: 'absolute',
		left: -4,
		top: -4,
		zIndex: 2
	},
	iconSuccessFix: {
		width: 5,
		height: 90,
		backgroundColor: '#fff',
		position: 'absolute',
		left: 28,
		top: 8,
		zIndex: 1,
		transform: 'rotate(-45deg)'
	},
	iconSuccessLine: {
		height: 5,
		backgroundColor: '#5cb85c',
		display: 'block',
		borderRadius: 2,
		position: 'absolute',
		zIndex: 2
	},
	iconSuccessLineTip: {
		width: 25,
		left: 14,
		top: 46,
		transform: 'rotate(45deg)',
		animation: 'animateSuccessTip 0.75s'
	},
	iconSuccessLineLong: {
		width: 47,
		right: 8,
		top: 38,
		transform: 'rotate(-45deg)',
		animation: 'animateSuccessLong 0.75s'
	},
	iconCustom: {
		backgroundSize: 'contain',
		borderRadius: 0,
		border: 'none',
		backgroundPosition: 'center center',
		backgroundRepeat: 'no-repeat'
	},
	button: {
		marginRight: 8
	},
	validationMessage: {
		display: 'block',
		backgroundColor: '#f1f1f1',
	    marginLeft: -17,
	    marginRight: -17,
	    marginTop: 20,
	    overflow: 'hidden',
	    padding: 10,
	    maxHeight: 100,
	    transition: 'padding 0.25s, max-height 0.25s',
	    color: '#797979',
	    fontSize: 16,
	    textAlign: 'center',
	    fontWeight: 300
	},
	exclamationIcon: {
		display: 'inline-block',
	    width: 24,
	    height: 24,
	    borderRadius: '50%',
	    backgroundColor: '#ea7d7d',
	    color: 'white',
	    lineHeight: '24px',
	    textAlign: 'center',
	    marginRight: 5
	},
	inputErrorIcon: {
		position: 'absolute',
	    top: 8,
	    right: 8,
	    width: 20,
	    height: 20,
	    opacity: 0,
	    transform: 'scale(0.5)',
	    transformOrigin: '50% 50%',
	    transition: 'all 0.1s',
	    opacity: 1,
	    transform: 'scale(1)'
	},
	inputErrorIconBeforeAfter: {
		content: "",
	    width: 20,
	    height: 6,
	    backgroundColor: '#f06e57',
	    borderRadius: 3,
	    position: 'absolute',
	    top: '50%',
	    marginTop: -4,
	    left: '50%',
	    marginLeft: -9
	},
	inputErrorIconBefore: {
		transform: 'rotate(-45deg)'
	},
	inputErrorIconAfter: {
		transform: 'rotate(45deg)'
	}
};

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ListRowCheckbox = function ListRowCheckbox(_ref) {
  var selected = _ref.selected,
      onClick = _ref.onClick;
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("div", {
    className: "form-control-checkbox d-flex"
  }, _react["default"].createElement("div", {
    className: "form-checkbox"
  }, _react["default"].createElement("input", {
    type: "checkbox",
    checked: selected,
    value: "checked",
    onClick: onClick,
    onChange: function onChange() {}
  }), _react["default"].createElement("span", {
    className: "check"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-check zmdi-hc-lg"
  })))));
};

var _default = ListRowCheckbox;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ListRowCheckbox, "ListRowCheckbox", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ListRowCheckbox/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ListRowCheckbox/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ListRowCheckbox/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ListRowCheckbox/index.js");

  __REACT_HOT_LOADER__.register(ListRowCheckbox, "ListRowCheckbox", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ListRowCheckbox/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ListRowCheckbox/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ListRowCheckbox/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ListRowCheckbox/index.js");
}();

;

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfill__ = __webpack_require__(1498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__container_Surface__ = __webpack_require__(219);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Surface", function() { return __WEBPACK_IMPORTED_MODULE_1__container_Surface__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__container_Layer__ = __webpack_require__(33);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Layer", function() { return __WEBPACK_IMPORTED_MODULE_2__container_Layer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component_Legend__ = __webpack_require__(394);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Legend", function() { return __WEBPACK_IMPORTED_MODULE_3__component_Legend__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__component_Tooltip__ = __webpack_require__(283);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_4__component_Tooltip__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component_ResponsiveContainer__ = __webpack_require__(1589);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ResponsiveContainer", function() { return __WEBPACK_IMPORTED_MODULE_5__component_ResponsiveContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component_Cell__ = __webpack_require__(189);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Cell", function() { return __WEBPACK_IMPORTED_MODULE_6__component_Cell__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component_Text__ = __webpack_require__(151);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Text", function() { return __WEBPACK_IMPORTED_MODULE_7__component_Text__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__component_Label__ = __webpack_require__(123);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Label", function() { return __WEBPACK_IMPORTED_MODULE_8__component_Label__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__component_LabelList__ = __webpack_require__(104);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LabelList", function() { return __WEBPACK_IMPORTED_MODULE_9__component_LabelList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__component_Customized__ = __webpack_require__(1681);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Customized", function() { return __WEBPACK_IMPORTED_MODULE_10__component_Customized__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shape_Sector__ = __webpack_require__(289);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Sector", function() { return __WEBPACK_IMPORTED_MODULE_11__shape_Sector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shape_Curve__ = __webpack_require__(193);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Curve", function() { return __WEBPACK_IMPORTED_MODULE_12__shape_Curve__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shape_Rectangle__ = __webpack_require__(194);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Rectangle", function() { return __WEBPACK_IMPORTED_MODULE_13__shape_Rectangle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shape_Polygon__ = __webpack_require__(290);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Polygon", function() { return __WEBPACK_IMPORTED_MODULE_14__shape_Polygon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shape_Dot__ = __webpack_require__(154);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Dot", function() { return __WEBPACK_IMPORTED_MODULE_15__shape_Dot__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shape_Cross__ = __webpack_require__(774);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Cross", function() { return __WEBPACK_IMPORTED_MODULE_16__shape_Cross__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__shape_Symbols__ = __webpack_require__(395);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Symbols", function() { return __WEBPACK_IMPORTED_MODULE_17__shape_Symbols__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__polar_PolarGrid__ = __webpack_require__(1682);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PolarGrid", function() { return __WEBPACK_IMPORTED_MODULE_18__polar_PolarGrid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__polar_PolarRadiusAxis__ = __webpack_require__(291);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PolarRadiusAxis", function() { return __WEBPACK_IMPORTED_MODULE_19__polar_PolarRadiusAxis__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__polar_PolarAngleAxis__ = __webpack_require__(292);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PolarAngleAxis", function() { return __WEBPACK_IMPORTED_MODULE_20__polar_PolarAngleAxis__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__polar_Pie__ = __webpack_require__(776);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Pie", function() { return __WEBPACK_IMPORTED_MODULE_21__polar_Pie__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__polar_Radar__ = __webpack_require__(777);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Radar", function() { return __WEBPACK_IMPORTED_MODULE_22__polar_Radar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__polar_RadialBar__ = __webpack_require__(778);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RadialBar", function() { return __WEBPACK_IMPORTED_MODULE_23__polar_RadialBar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__cartesian_Brush__ = __webpack_require__(779);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Brush", function() { return __WEBPACK_IMPORTED_MODULE_24__cartesian_Brush__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__cartesian_ReferenceLine__ = __webpack_require__(780);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ReferenceLine", function() { return __WEBPACK_IMPORTED_MODULE_25__cartesian_ReferenceLine__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__cartesian_ReferenceDot__ = __webpack_require__(782);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ReferenceDot", function() { return __WEBPACK_IMPORTED_MODULE_26__cartesian_ReferenceDot__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__cartesian_ReferenceArea__ = __webpack_require__(783);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ReferenceArea", function() { return __WEBPACK_IMPORTED_MODULE_27__cartesian_ReferenceArea__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__cartesian_CartesianAxis__ = __webpack_require__(784);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CartesianAxis", function() { return __WEBPACK_IMPORTED_MODULE_28__cartesian_CartesianAxis__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__cartesian_CartesianGrid__ = __webpack_require__(1690);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CartesianGrid", function() { return __WEBPACK_IMPORTED_MODULE_29__cartesian_CartesianGrid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__cartesian_Line__ = __webpack_require__(413);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Line", function() { return __WEBPACK_IMPORTED_MODULE_30__cartesian_Line__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__cartesian_Area__ = __webpack_require__(414);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Area", function() { return __WEBPACK_IMPORTED_MODULE_31__cartesian_Area__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__cartesian_Bar__ = __webpack_require__(415);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Bar", function() { return __WEBPACK_IMPORTED_MODULE_32__cartesian_Bar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__cartesian_Scatter__ = __webpack_require__(416);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scatter", function() { return __WEBPACK_IMPORTED_MODULE_33__cartesian_Scatter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__cartesian_XAxis__ = __webpack_require__(195);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "XAxis", function() { return __WEBPACK_IMPORTED_MODULE_34__cartesian_XAxis__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__cartesian_YAxis__ = __webpack_require__(196);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "YAxis", function() { return __WEBPACK_IMPORTED_MODULE_35__cartesian_YAxis__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__cartesian_ZAxis__ = __webpack_require__(294);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ZAxis", function() { return __WEBPACK_IMPORTED_MODULE_36__cartesian_ZAxis__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__cartesian_ErrorBar__ = __webpack_require__(225);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ErrorBar", function() { return __WEBPACK_IMPORTED_MODULE_37__cartesian_ErrorBar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__chart_LineChart__ = __webpack_require__(1691);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LineChart", function() { return __WEBPACK_IMPORTED_MODULE_38__chart_LineChart__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__chart_BarChart__ = __webpack_require__(1694);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BarChart", function() { return __WEBPACK_IMPORTED_MODULE_39__chart_BarChart__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__chart_PieChart__ = __webpack_require__(1695);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PieChart", function() { return __WEBPACK_IMPORTED_MODULE_40__chart_PieChart__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__chart_Treemap__ = __webpack_require__(1696);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Treemap", function() { return __WEBPACK_IMPORTED_MODULE_41__chart_Treemap__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__chart_Sankey__ = __webpack_require__(1717);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Sankey", function() { return __WEBPACK_IMPORTED_MODULE_42__chart_Sankey__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__chart_RadarChart__ = __webpack_require__(1720);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RadarChart", function() { return __WEBPACK_IMPORTED_MODULE_43__chart_RadarChart__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__chart_ScatterChart__ = __webpack_require__(1721);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ScatterChart", function() { return __WEBPACK_IMPORTED_MODULE_44__chart_ScatterChart__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__chart_AreaChart__ = __webpack_require__(1722);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AreaChart", function() { return __WEBPACK_IMPORTED_MODULE_45__chart_AreaChart__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__chart_RadialBarChart__ = __webpack_require__(1723);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RadialBarChart", function() { return __WEBPACK_IMPORTED_MODULE_46__chart_RadialBarChart__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__chart_ComposedChart__ = __webpack_require__(1724);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ComposedChart", function() { return __WEBPACK_IMPORTED_MODULE_47__chart_ComposedChart__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__numberAxis_Funnel__ = __webpack_require__(788);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Funnel", function() { return __WEBPACK_IMPORTED_MODULE_48__numberAxis_Funnel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__chart_FunnelChart__ = __webpack_require__(1725);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FunnelChart", function() { return __WEBPACK_IMPORTED_MODULE_49__chart_FunnelChart__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__shape_Trapezoid__ = __webpack_require__(789);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Trapezoid", function() { return __WEBPACK_IMPORTED_MODULE_50__shape_Trapezoid__["a"]; });






































































































/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(20);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(132)('meta');
var isObject = __webpack_require__(20);
var has = __webpack_require__(68);
var setDesc = __webpack_require__(41).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(18)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(168),
    getRawTag = __webpack_require__(1132),
    objectToString = __webpack_require__(1133);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return detach; });
/* harmony export (immutable) */ __webpack_exports__["s"] = take;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return takem; });
/* harmony export (immutable) */ __webpack_exports__["n"] = put;
/* harmony export (immutable) */ __webpack_exports__["b"] = all;
/* harmony export (immutable) */ __webpack_exports__["o"] = race;
/* harmony export (immutable) */ __webpack_exports__["e"] = call;
/* harmony export (immutable) */ __webpack_exports__["c"] = apply;
/* harmony export (immutable) */ __webpack_exports__["h"] = cps;
/* harmony export (immutable) */ __webpack_exports__["k"] = fork;
/* harmony export (immutable) */ __webpack_exports__["r"] = spawn;
/* harmony export (immutable) */ __webpack_exports__["m"] = join;
/* harmony export (immutable) */ __webpack_exports__["f"] = cancel;
/* harmony export (immutable) */ __webpack_exports__["p"] = select;
/* harmony export (immutable) */ __webpack_exports__["a"] = actionChannel;
/* harmony export (immutable) */ __webpack_exports__["g"] = cancelled;
/* harmony export (immutable) */ __webpack_exports__["j"] = flush;
/* harmony export (immutable) */ __webpack_exports__["l"] = getContext;
/* harmony export (immutable) */ __webpack_exports__["q"] = setContext;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return asEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(71);


var IO = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["x" /* sym */])('IO');
var TAKE = 'TAKE';
var PUT = 'PUT';
var ALL = 'ALL';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var CANCEL = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED = 'CANCELLED';
var FLUSH = 'FLUSH';
var GET_CONTEXT = 'GET_CONTEXT';
var SET_CONTEXT = 'SET_CONTEXT';

var TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)';

var effect = function effect(type, payload) {
  var _ref;

  return _ref = {}, _ref[IO] = true, _ref[type] = payload, _ref;
};

var detach = function detach(eff) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(asEffect.fork(eff), __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].object, 'detach(eff): argument must be a fork effect');
  eff[FORK].detached = true;
  return eff;
};

function take() {
  var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';

  if (arguments.length) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(arguments[0], __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].pattern(patternOrChannel)) {
    return effect(TAKE, { pattern: patternOrChannel });
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].channel(patternOrChannel)) {
    return effect(TAKE, { channel: patternOrChannel });
  }
  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
}

take.maybe = function () {
  var eff = take.apply(undefined, arguments);
  eff[TAKE].maybe = true;
  return eff;
};

var takem = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* deprecate */])(take.maybe, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["z" /* updateIncentive */])('takem', 'take.maybe'));

function put(channel, action) {
  if (arguments.length > 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'put(channel, action): argument channel is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(action, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'put(channel, action): argument action is undefined');
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'put(action): argument action is undefined');
    action = channel;
    channel = null;
  }
  return effect(PUT, { channel: channel, action: action });
}

put.resolve = function () {
  var eff = put.apply(undefined, arguments);
  eff[PUT].resolve = true;
  return eff;
};

put.sync = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* deprecate */])(put.resolve, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["z" /* updateIncentive */])('put.sync', 'put.resolve'));

function all(effects) {
  return effect(ALL, effects);
}

function race(effects) {
  return effect(RACE, effects);
}

function getFnCallDesc(meth, fn, args) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, meth + ': argument fn is undefined');

  var context = null;
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].array(fn)) {
    var _fn = fn;
    context = _fn[0];
    fn = _fn[1];
  } else if (fn.fn) {
    var _fn2 = fn;
    context = _fn2.context;
    fn = _fn2.fn;
  }
  if (context && __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].string(fn) && __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(context[fn])) {
    fn = context[fn];
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func, meth + ': argument ' + fn + ' is not a function');

  return { context: context, fn: fn, args: args };
}

function call(fn) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return effect(CALL, getFnCallDesc('call', fn, args));
}

function apply(context, fn) {
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
}

function cps(fn) {
  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return effect(CPS, getFnCallDesc('cps', fn, args));
}

function fork(fn) {
  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return effect(FORK, getFnCallDesc('fork', fn, args));
}

function spawn(fn) {
  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  return detach(fork.apply(undefined, [fn].concat(args)));
}

function join() {
  for (var _len5 = arguments.length, tasks = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    tasks[_key5] = arguments[_key5];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return join(t);
    }));
  }
  var task = tasks[0];
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'join(task): argument task is undefined');
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].task, 'join(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  return effect(JOIN, task);
}

function cancel() {
  for (var _len6 = arguments.length, tasks = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    tasks[_key6] = arguments[_key6];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return cancel(t);
    }));
  }
  var task = tasks[0];
  if (tasks.length === 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'cancel(task): argument task is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].task, 'cancel(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  }
  return effect(CANCEL, task || __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* SELF_CANCELLATION */]);
}

function select(selector) {
  for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    args[_key7 - 1] = arguments[_key7];
  }

  if (arguments.length === 0) {
    selector = __WEBPACK_IMPORTED_MODULE_0__utils__["o" /* ident */];
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'select(selector,[...]): argument selector is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func, 'select(selector,[...]): argument ' + selector + ' is not a function');
  }
  return effect(SELECT, { selector: selector, args: args });
}

/**
  channel(pattern, [buffer])    => creates an event channel for store actions
**/
function actionChannel(pattern, buffer) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(pattern, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
  if (arguments.length > 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].buffer, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
  }
  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
}

function cancelled() {
  return effect(CANCELLED, {});
}

function flush(channel) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].channel, 'flush(channel): argument ' + channel + ' is not valid channel');
  return effect(FLUSH, channel);
}

function getContext(prop) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(prop, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].string, 'getContext(prop): argument ' + prop + ' is not a string');
  return effect(GET_CONTEXT, prop);
}

function setContext(props) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* createSetContextWarning */])(null, props));
  return effect(SET_CONTEXT, props);
}

var createAsEffectType = function createAsEffectType(type) {
  return function (effect) {
    return effect && effect[IO] && effect[type];
  };
};

var asEffect = {
  take: /*#__PURE__*/createAsEffectType(TAKE),
  put: /*#__PURE__*/createAsEffectType(PUT),
  all: /*#__PURE__*/createAsEffectType(ALL),
  race: /*#__PURE__*/createAsEffectType(RACE),
  call: /*#__PURE__*/createAsEffectType(CALL),
  cps: /*#__PURE__*/createAsEffectType(CPS),
  fork: /*#__PURE__*/createAsEffectType(FORK),
  join: /*#__PURE__*/createAsEffectType(JOIN),
  cancel: /*#__PURE__*/createAsEffectType(CANCEL),
  select: /*#__PURE__*/createAsEffectType(SELECT),
  actionChannel: /*#__PURE__*/createAsEffectType(ACTION_CHANNEL),
  cancelled: /*#__PURE__*/createAsEffectType(CANCELLED),
  flush: /*#__PURE__*/createAsEffectType(FLUSH),
  getContext: /*#__PURE__*/createAsEffectType(GET_CONTEXT),
  setContext: /*#__PURE__*/createAsEffectType(SET_CONTEXT)
};

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hidePortfolioLoader = exports.showPortfolioLoader = exports.handlePortfolioRequestClose = exports.onTogglePortfolioDrawer = exports.updateSearchPortfolio = exports.onAllPortfolioSelect = exports.getUnselectedAllPortfolio = exports.getAllPortfolio = exports.filterPortfolio = exports.onFilterSelectedPortfolio = exports.onDeletePortfolioSuccess = exports.onDeletePortfolio = exports.onSavePortfolioSuccess = exports.onSavePortfolio = exports.onFilterPortfolioOptionSelect = exports.onPortfolioClose = exports.onEditPortfolio = exports.onAddPortfolio = exports.onPortfolioSelect = exports.addFavouritePortfolioSuccess = exports.addFavouritePortfolio = exports.showPortfolioMessage = exports.fetchPortfoliosSuccess = exports.fetchPortfolios = exports.fetchPortfolioSuccess = exports.fetchPortfolio = exports.onPortfolioDashboardSuccess = exports.onPortfolioDashboard = exports.selectPortfolio = void 0;

var _ActionTypes = __webpack_require__(7);

var selectPortfolio = function selectPortfolio(payload) {
  return {
    type: _ActionTypes.SELECT_PORTFOLIO,
    payload: payload
  };
};

exports.selectPortfolio = selectPortfolio;

var onPortfolioDashboard = function onPortfolioDashboard(payload) {
  return {
    type: _ActionTypes.ON_PORTFOLIO_DASHBOARD,
    payload: payload
  };
};

exports.onPortfolioDashboard = onPortfolioDashboard;

var onPortfolioDashboardSuccess = function onPortfolioDashboardSuccess(payload) {
  return {
    type: _ActionTypes.ON_PORTFOLIO_DASHBOARD_SUCCESS,
    payload: payload
  };
};

exports.onPortfolioDashboardSuccess = onPortfolioDashboardSuccess;

var fetchPortfolio = function fetchPortfolio(payload) {
  return {
    type: _ActionTypes.FETCH_PORTFOLIO,
    payload: payload
  };
};

exports.fetchPortfolio = fetchPortfolio;

var fetchPortfolioSuccess = function fetchPortfolioSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_PORTFOLIO_SUCCESS,
    payload: payload
  };
};

exports.fetchPortfolioSuccess = fetchPortfolioSuccess;

var fetchPortfolios = function fetchPortfolios() {
  return {
    type: _ActionTypes.FETCH_ALL_PORTFOLIO
  };
};

exports.fetchPortfolios = fetchPortfolios;

var fetchPortfoliosSuccess = function fetchPortfoliosSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_ALL_PORTFOLIO_SUCCESS,
    payload: payload
  };
};

exports.fetchPortfoliosSuccess = fetchPortfoliosSuccess;

var showPortfolioMessage = function showPortfolioMessage(message) {
  return {
    type: _ActionTypes.SHOW_PORTFOLIO_MESSAGE,
    payload: message
  };
};

exports.showPortfolioMessage = showPortfolioMessage;

var addFavouritePortfolio = function addFavouritePortfolio(payload) {
  return {
    type: _ActionTypes.ADD_FAVOURITE_PORTFOLIO,
    payload: payload
  };
};

exports.addFavouritePortfolio = addFavouritePortfolio;

var addFavouritePortfolioSuccess = function addFavouritePortfolioSuccess(payload) {
  return {
    type: _ActionTypes.ADD_FAVOURITE_PORTFOLIO_SUCCESS,
    payload: payload
  };
};

exports.addFavouritePortfolioSuccess = addFavouritePortfolioSuccess;

var onPortfolioSelect = function onPortfolioSelect(payload) {
  return {
    type: _ActionTypes.ON_PORTFOLIO_SELECT,
    payload: payload
  };
};

exports.onPortfolioSelect = onPortfolioSelect;

var onAddPortfolio = function onAddPortfolio() {
  return {
    type: _ActionTypes.ON_ADD_PORTFOLIO
  };
};

exports.onAddPortfolio = onAddPortfolio;

var onEditPortfolio = function onEditPortfolio(payload) {
  return {
    type: _ActionTypes.ON_EDIT_PORTFOLIO,
    payload: payload
  };
};

exports.onEditPortfolio = onEditPortfolio;

var onPortfolioClose = function onPortfolioClose() {
  return {
    type: _ActionTypes.ON_PORTFOLIO_CLOSE
  };
};

exports.onPortfolioClose = onPortfolioClose;

var onFilterPortfolioOptionSelect = function onFilterPortfolioOptionSelect(payload) {
  return {
    type: _ActionTypes.ON_FILTER_PORTFOLIO_OPTION_SELECT,
    payload: payload
  };
};

exports.onFilterPortfolioOptionSelect = onFilterPortfolioOptionSelect;

var onSavePortfolio = function onSavePortfolio(payload) {
  return {
    type: _ActionTypes.ON_SAVE_PORTFOLIO,
    payload: payload
  };
};

exports.onSavePortfolio = onSavePortfolio;

var onSavePortfolioSuccess = function onSavePortfolioSuccess(data) {
  return {
    type: _ActionTypes.ON_SAVE_PORTFOLIO_SUCCESS,
    payload: data
  };
};

exports.onSavePortfolioSuccess = onSavePortfolioSuccess;

var onDeletePortfolio = function onDeletePortfolio(payload) {
  return {
    type: _ActionTypes.ON_DELETE_PORTFOLIO,
    payload: payload
  };
};

exports.onDeletePortfolio = onDeletePortfolio;

var onDeletePortfolioSuccess = function onDeletePortfolioSuccess(payload) {
  return {
    type: _ActionTypes.ON_DELETE_PORTFOLIO_SUCCESS,
    payload: payload
  };
};

exports.onDeletePortfolioSuccess = onDeletePortfolioSuccess;

var onFilterSelectedPortfolio = function onFilterSelectedPortfolio() {
  return {
    type: _ActionTypes.ON_FILTER_SELECTED_PORTFOLIO,
    payload: ''
  };
};

exports.onFilterSelectedPortfolio = onFilterSelectedPortfolio;

var filterPortfolio = function filterPortfolio(payload) {
  return {
    type: _ActionTypes.FILTER_PORTFOLIO,
    payload: payload
  };
};

exports.filterPortfolio = filterPortfolio;

var getAllPortfolio = function getAllPortfolio() {
  return {
    type: _ActionTypes.GET_ALL_PORTFOLIO,
    payload: ''
  };
};

exports.getAllPortfolio = getAllPortfolio;

var getUnselectedAllPortfolio = function getUnselectedAllPortfolio() {
  return {
    type: _ActionTypes.GET_UNSELECTED_ALL_PORTFOLIO,
    payload: ''
  };
};

exports.getUnselectedAllPortfolio = getUnselectedAllPortfolio;

var onAllPortfolioSelect = function onAllPortfolioSelect() {
  return {
    type: _ActionTypes.ON_ALL_PORTFOLIO_SELECT,
    payload: ''
  };
};

exports.onAllPortfolioSelect = onAllPortfolioSelect;

var updateSearchPortfolio = function updateSearchPortfolio(payload) {
  return {
    type: _ActionTypes.UPDATE_SEARCH_PORTFOLIO,
    payload: payload
  };
};

exports.updateSearchPortfolio = updateSearchPortfolio;

var onTogglePortfolioDrawer = function onTogglePortfolioDrawer() {
  return {
    type: _ActionTypes.ON_TOGGLE_PORTFOLIO_DRAWER
  };
};

exports.onTogglePortfolioDrawer = onTogglePortfolioDrawer;

var handlePortfolioRequestClose = function handlePortfolioRequestClose() {
  return {
    type: _ActionTypes.HANDLE_PORTFOLIO_REQUEST_CLOSE
  };
};

exports.handlePortfolioRequestClose = handlePortfolioRequestClose;

var showPortfolioLoader = function showPortfolioLoader() {
  return {
    type: _ActionTypes.SHOW_PORTFOLIO_LOADER
  };
};

exports.showPortfolioLoader = showPortfolioLoader;

var hidePortfolioLoader = function hidePortfolioLoader() {
  return {
    type: _ActionTypes.HIDE_PORTFOLIO_LOADER
  };
};

exports.hidePortfolioLoader = hidePortfolioLoader;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(selectPortfolio, "selectPortfolio", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(onPortfolioDashboard, "onPortfolioDashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(onPortfolioDashboardSuccess, "onPortfolioDashboardSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(fetchPortfolio, "fetchPortfolio", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(fetchPortfolioSuccess, "fetchPortfolioSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(fetchPortfolios, "fetchPortfolios", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(fetchPortfoliosSuccess, "fetchPortfoliosSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(showPortfolioMessage, "showPortfolioMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(addFavouritePortfolio, "addFavouritePortfolio", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(addFavouritePortfolioSuccess, "addFavouritePortfolioSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(onPortfolioSelect, "onPortfolioSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(onAddPortfolio, "onAddPortfolio", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(onEditPortfolio, "onEditPortfolio", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(onPortfolioClose, "onPortfolioClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(onFilterPortfolioOptionSelect, "onFilterPortfolioOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(onSavePortfolio, "onSavePortfolio", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(onSavePortfolioSuccess, "onSavePortfolioSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(onDeletePortfolio, "onDeletePortfolio", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(onDeletePortfolioSuccess, "onDeletePortfolioSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(onFilterSelectedPortfolio, "onFilterSelectedPortfolio", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(filterPortfolio, "filterPortfolio", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(getAllPortfolio, "getAllPortfolio", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllPortfolio, "getUnselectedAllPortfolio", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(onAllPortfolioSelect, "onAllPortfolioSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(updateSearchPortfolio, "updateSearchPortfolio", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(onTogglePortfolioDrawer, "onTogglePortfolioDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(handlePortfolioRequestClose, "handlePortfolioRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(showPortfolioLoader, "showPortfolioLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(hidePortfolioLoader, "hidePortfolioLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(selectPortfolio, "selectPortfolio", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(onPortfolioDashboard, "onPortfolioDashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(onPortfolioDashboardSuccess, "onPortfolioDashboardSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(fetchPortfolio, "fetchPortfolio", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(fetchPortfolioSuccess, "fetchPortfolioSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(fetchPortfolios, "fetchPortfolios", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(fetchPortfoliosSuccess, "fetchPortfoliosSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(showPortfolioMessage, "showPortfolioMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(addFavouritePortfolio, "addFavouritePortfolio", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(addFavouritePortfolioSuccess, "addFavouritePortfolioSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(onPortfolioSelect, "onPortfolioSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(onAddPortfolio, "onAddPortfolio", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(onEditPortfolio, "onEditPortfolio", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(onPortfolioClose, "onPortfolioClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(onFilterPortfolioOptionSelect, "onFilterPortfolioOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(onSavePortfolio, "onSavePortfolio", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(onSavePortfolioSuccess, "onSavePortfolioSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(onDeletePortfolio, "onDeletePortfolio", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(onDeletePortfolioSuccess, "onDeletePortfolioSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(onFilterSelectedPortfolio, "onFilterSelectedPortfolio", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(filterPortfolio, "filterPortfolio", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(getAllPortfolio, "getAllPortfolio", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllPortfolio, "getUnselectedAllPortfolio", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(onAllPortfolioSelect, "onAllPortfolioSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(updateSearchPortfolio, "updateSearchPortfolio", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(onTogglePortfolioDrawer, "onTogglePortfolioDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(handlePortfolioRequestClose, "handlePortfolioRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(showPortfolioLoader, "showPortfolioLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(hidePortfolioLoader, "hidePortfolioLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/portfolio.js");
}();

;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideFeatureLoader = exports.showFeatureLoader = exports.handleFeatureRequestClose = exports.onToggleFeatureDrawer = exports.updateSearchFeature = exports.onAllFeatureSelect = exports.getUnselectedAllFeature = exports.getAllFeature = exports.filterFeature = exports.onFilterSelectedFeature = exports.onDeleteFeatureSuccess = exports.onDeleteFeature = exports.onSaveFeatureSuccess = exports.onSaveFeature = exports.onFilterFeatureOptionSelect = exports.onFeatureClose = exports.onEditFeature = exports.onAddFeature = exports.onFeatureSelect = exports.addFavouriteFeatureSuccess = exports.addFavouriteFeature = exports.showFeatureMessage = exports.fetchFeaturesSuccess = exports.fetchFeatures = exports.setFeature = exports.fetchFeatureSuccess = exports.fetchFeature = exports.onFeatureDependencyUpdateSuccess = exports.onFeatureOutwardDependencyUpdate = exports.onFeatureInwardDependencyUpdate = exports.onFetchSelectFeatureDependenciesSuccess = exports.onFetchSelectFeatureOutwardDependencies = exports.onFetchSelectFeatureInwardDependencies = void 0;

var _ActionTypes = __webpack_require__(7);

var onFetchSelectFeatureInwardDependencies = function onFetchSelectFeatureInwardDependencies() {
  return {
    type: _ActionTypes.ON_FETCH_SELECT_FEATURE_INWARD_DEPENDENCIES
  };
};

exports.onFetchSelectFeatureInwardDependencies = onFetchSelectFeatureInwardDependencies;

var onFetchSelectFeatureOutwardDependencies = function onFetchSelectFeatureOutwardDependencies() {
  return {
    type: _ActionTypes.ON_FETCH_SELECT_FEATURE_OUTWARD_DEPENDENCIES
  };
};

exports.onFetchSelectFeatureOutwardDependencies = onFetchSelectFeatureOutwardDependencies;

var onFetchSelectFeatureDependenciesSuccess = function onFetchSelectFeatureDependenciesSuccess(payload) {
  return {
    type: _ActionTypes.ON_FETCH_SELECT_FEATURE_DEPENDENCIES_SUCCESS,
    payload: payload
  };
};

exports.onFetchSelectFeatureDependenciesSuccess = onFetchSelectFeatureDependenciesSuccess;

var onFeatureInwardDependencyUpdate = function onFeatureInwardDependencyUpdate(payload) {
  return {
    type: _ActionTypes.ON_FEATURE_INWARD_DEPENDENCY_UPDATE,
    payload: payload
  };
};

exports.onFeatureInwardDependencyUpdate = onFeatureInwardDependencyUpdate;

var onFeatureOutwardDependencyUpdate = function onFeatureOutwardDependencyUpdate(payload) {
  return {
    type: _ActionTypes.ON_FEATURE_OUTWARD_DEPENDENCY_UPDATE,
    payload: payload
  };
};

exports.onFeatureOutwardDependencyUpdate = onFeatureOutwardDependencyUpdate;

var onFeatureDependencyUpdateSuccess = function onFeatureDependencyUpdateSuccess(payload) {
  return {
    type: _ActionTypes.ON_FEATURE_DEPENDENCY_UPDATE_SUCCESS,
    payload: payload
  };
};

exports.onFeatureDependencyUpdateSuccess = onFeatureDependencyUpdateSuccess;

var fetchFeature = function fetchFeature(payload) {
  return {
    type: _ActionTypes.FETCH_FEATURE,
    payload: payload
  };
};

exports.fetchFeature = fetchFeature;

var fetchFeatureSuccess = function fetchFeatureSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_FEATURE_SUCCESS,
    payload: payload
  };
};

exports.fetchFeatureSuccess = fetchFeatureSuccess;

var setFeature = function setFeature(payload) {
  return {
    type: _ActionTypes.SET_FEATURE,
    payload: payload
  };
};

exports.setFeature = setFeature;

var fetchFeatures = function fetchFeatures() {
  return {
    type: _ActionTypes.FETCH_ALL_FEATURE
  };
};

exports.fetchFeatures = fetchFeatures;

var fetchFeaturesSuccess = function fetchFeaturesSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_ALL_FEATURE_SUCCESS,
    payload: payload
  };
};

exports.fetchFeaturesSuccess = fetchFeaturesSuccess;

var showFeatureMessage = function showFeatureMessage(message) {
  return {
    type: _ActionTypes.SHOW_FEATURE_MESSAGE,
    payload: message
  };
};

exports.showFeatureMessage = showFeatureMessage;

var addFavouriteFeature = function addFavouriteFeature(payload) {
  return {
    type: _ActionTypes.ADD_FAVOURITE_FEATURE,
    payload: payload
  };
};

exports.addFavouriteFeature = addFavouriteFeature;

var addFavouriteFeatureSuccess = function addFavouriteFeatureSuccess(payload) {
  return {
    type: _ActionTypes.ADD_FAVOURITE_FEATURE_SUCCESS,
    payload: payload
  };
};

exports.addFavouriteFeatureSuccess = addFavouriteFeatureSuccess;

var onFeatureSelect = function onFeatureSelect(payload) {
  return {
    type: _ActionTypes.ON_FEATURE_SELECT,
    payload: payload
  };
};

exports.onFeatureSelect = onFeatureSelect;

var onAddFeature = function onAddFeature() {
  return {
    type: _ActionTypes.ON_ADD_FEATURE,
    payload: ''
  };
};

exports.onAddFeature = onAddFeature;

var onEditFeature = function onEditFeature() {
  return {
    type: _ActionTypes.ON_EDIT_FEATURE,
    payload: ''
  };
};

exports.onEditFeature = onEditFeature;

var onFeatureClose = function onFeatureClose() {
  return {
    type: _ActionTypes.ON_FEATURE_CLOSE,
    payload: ''
  };
};

exports.onFeatureClose = onFeatureClose;

var onFilterFeatureOptionSelect = function onFilterFeatureOptionSelect(payload) {
  return {
    type: _ActionTypes.ON_FILTER_FEATURE_OPTION_SELECT,
    payload: payload
  };
};

exports.onFilterFeatureOptionSelect = onFilterFeatureOptionSelect;

var onSaveFeature = function onSaveFeature(payload) {
  return {
    type: _ActionTypes.ON_SAVE_FEATURE,
    payload: payload
  };
};

exports.onSaveFeature = onSaveFeature;

var onSaveFeatureSuccess = function onSaveFeatureSuccess(data) {
  return {
    type: _ActionTypes.ON_SAVE_FEATURE_SUCCESS,
    payload: data
  };
};

exports.onSaveFeatureSuccess = onSaveFeatureSuccess;

var onDeleteFeature = function onDeleteFeature(payload) {
  return {
    type: _ActionTypes.ON_DELETE_FEATURE,
    payload: payload
  };
};

exports.onDeleteFeature = onDeleteFeature;

var onDeleteFeatureSuccess = function onDeleteFeatureSuccess(payload) {
  return {
    type: _ActionTypes.ON_DELETE_FEATURE_SUCCESS,
    payload: payload
  };
};

exports.onDeleteFeatureSuccess = onDeleteFeatureSuccess;

var onFilterSelectedFeature = function onFilterSelectedFeature() {
  return {
    type: _ActionTypes.ON_FILTER_SELECTED_FEATURE,
    payload: ''
  };
};

exports.onFilterSelectedFeature = onFilterSelectedFeature;

var filterFeature = function filterFeature(payload) {
  return {
    type: _ActionTypes.FILTER_FEATURE,
    payload: payload
  };
};

exports.filterFeature = filterFeature;

var getAllFeature = function getAllFeature() {
  return {
    type: _ActionTypes.GET_ALL_FEATURE,
    payload: ''
  };
};

exports.getAllFeature = getAllFeature;

var getUnselectedAllFeature = function getUnselectedAllFeature() {
  return {
    type: _ActionTypes.GET_UNSELECTED_ALL_FEATURE,
    payload: ''
  };
};

exports.getUnselectedAllFeature = getUnselectedAllFeature;

var onAllFeatureSelect = function onAllFeatureSelect() {
  return {
    type: _ActionTypes.ON_ALL_FEATURE_SELECT,
    payload: ''
  };
};

exports.onAllFeatureSelect = onAllFeatureSelect;

var updateSearchFeature = function updateSearchFeature(payload) {
  return {
    type: _ActionTypes.UPDATE_SEARCH_FEATURE,
    payload: payload
  };
};

exports.updateSearchFeature = updateSearchFeature;

var onToggleFeatureDrawer = function onToggleFeatureDrawer() {
  return {
    type: _ActionTypes.ON_TOGGLE_FEATURE_DRAWER
  };
};

exports.onToggleFeatureDrawer = onToggleFeatureDrawer;

var handleFeatureRequestClose = function handleFeatureRequestClose() {
  return {
    type: _ActionTypes.HANDLE_FEATURE_REQUEST_CLOSE
  };
};

exports.handleFeatureRequestClose = handleFeatureRequestClose;

var showFeatureLoader = function showFeatureLoader() {
  return {
    type: _ActionTypes.SHOW_FEATURE_LOADER
  };
};

exports.showFeatureLoader = showFeatureLoader;

var hideFeatureLoader = function hideFeatureLoader() {
  return {
    type: _ActionTypes.HIDE_FEATURE_LOADER
  };
};

exports.hideFeatureLoader = hideFeatureLoader;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(onFetchSelectFeatureInwardDependencies, "onFetchSelectFeatureInwardDependencies", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(onFetchSelectFeatureOutwardDependencies, "onFetchSelectFeatureOutwardDependencies", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(onFetchSelectFeatureDependenciesSuccess, "onFetchSelectFeatureDependenciesSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(onFeatureInwardDependencyUpdate, "onFeatureInwardDependencyUpdate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(onFeatureOutwardDependencyUpdate, "onFeatureOutwardDependencyUpdate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(onFeatureDependencyUpdateSuccess, "onFeatureDependencyUpdateSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(fetchFeature, "fetchFeature", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(fetchFeatureSuccess, "fetchFeatureSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(setFeature, "setFeature", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(fetchFeatures, "fetchFeatures", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(fetchFeaturesSuccess, "fetchFeaturesSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(showFeatureMessage, "showFeatureMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(addFavouriteFeature, "addFavouriteFeature", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(addFavouriteFeatureSuccess, "addFavouriteFeatureSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(onFeatureSelect, "onFeatureSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(onAddFeature, "onAddFeature", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(onEditFeature, "onEditFeature", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(onFeatureClose, "onFeatureClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(onFilterFeatureOptionSelect, "onFilterFeatureOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(onSaveFeature, "onSaveFeature", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(onSaveFeatureSuccess, "onSaveFeatureSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(onDeleteFeature, "onDeleteFeature", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(onDeleteFeatureSuccess, "onDeleteFeatureSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(onFilterSelectedFeature, "onFilterSelectedFeature", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(filterFeature, "filterFeature", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(getAllFeature, "getAllFeature", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllFeature, "getUnselectedAllFeature", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(onAllFeatureSelect, "onAllFeatureSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(updateSearchFeature, "updateSearchFeature", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(onToggleFeatureDrawer, "onToggleFeatureDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(handleFeatureRequestClose, "handleFeatureRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(showFeatureLoader, "showFeatureLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(hideFeatureLoader, "hideFeatureLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(onFetchSelectFeatureInwardDependencies, "onFetchSelectFeatureInwardDependencies", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(onFetchSelectFeatureOutwardDependencies, "onFetchSelectFeatureOutwardDependencies", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(onFetchSelectFeatureDependenciesSuccess, "onFetchSelectFeatureDependenciesSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(onFeatureInwardDependencyUpdate, "onFeatureInwardDependencyUpdate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(onFeatureOutwardDependencyUpdate, "onFeatureOutwardDependencyUpdate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(onFeatureDependencyUpdateSuccess, "onFeatureDependencyUpdateSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(fetchFeature, "fetchFeature", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(fetchFeatureSuccess, "fetchFeatureSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(setFeature, "setFeature", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(fetchFeatures, "fetchFeatures", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(fetchFeaturesSuccess, "fetchFeaturesSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(showFeatureMessage, "showFeatureMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(addFavouriteFeature, "addFavouriteFeature", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(addFavouriteFeatureSuccess, "addFavouriteFeatureSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(onFeatureSelect, "onFeatureSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(onAddFeature, "onAddFeature", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(onEditFeature, "onEditFeature", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(onFeatureClose, "onFeatureClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(onFilterFeatureOptionSelect, "onFilterFeatureOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(onSaveFeature, "onSaveFeature", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(onSaveFeatureSuccess, "onSaveFeatureSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(onDeleteFeature, "onDeleteFeature", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(onDeleteFeatureSuccess, "onDeleteFeatureSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(onFilterSelectedFeature, "onFilterSelectedFeature", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(filterFeature, "filterFeature", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(getAllFeature, "getAllFeature", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllFeature, "getUnselectedAllFeature", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(onAllFeatureSelect, "onAllFeatureSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(updateSearchFeature, "updateSearchFeature", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(onToggleFeatureDrawer, "onToggleFeatureDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(handleFeatureRequestClose, "handleFeatureRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(showFeatureLoader, "showFeatureLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(hideFeatureLoader, "hideFeatureLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/feature.js");
}();

;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideValueStreamLoader = exports.showValueStreamLoader = exports.handleValueStreamRequestClose = exports.onToggleValueStreamDrawer = exports.updateSearchValueStream = exports.onAllValueStreamSelect = exports.getUnselectedAllValueStream = exports.getAllValueStream = exports.filterValueStream = exports.onFilterSelectedValueStream = exports.onDeleteValueStreamSuccess = exports.onDeleteValueStream = exports.onSaveValueStreamSuccess = exports.onSaveValueStream = exports.onFilterValueStreamOptionSelect = exports.onValueStreamClose = exports.onEditValueStream = exports.onAddValueStream = exports.onValueStreamSelect = exports.addFavouriteValueStreamSuccess = exports.addFavouriteValueStream = exports.showValueStreamMessage = exports.fetchValueStreamsSuccess = exports.fetchValueStreams = exports.fetchValueStreamSuccess = exports.fetchValueStream = exports.setValueStream = exports.onFetchSelectTeamDataSuccess = exports.onFetchSelectTeamData = exports.onValueStreamTeamUpdate = void 0;

var _ActionTypes = __webpack_require__(7);

var onValueStreamTeamUpdate = function onValueStreamTeamUpdate() {
  return {
    type: _ActionTypes.ON_VALUE_STREAM_TEAM_UPDATE
  };
};

exports.onValueStreamTeamUpdate = onValueStreamTeamUpdate;

var onFetchSelectTeamData = function onFetchSelectTeamData() {
  return {
    type: _ActionTypes.ON_FETCH_SELECT_TEAM_DATA
  };
};

exports.onFetchSelectTeamData = onFetchSelectTeamData;

var onFetchSelectTeamDataSuccess = function onFetchSelectTeamDataSuccess(payload) {
  return {
    type: _ActionTypes.ON_FETCH_SELECT_TEAM_DATA_SUCCESS,
    payload: payload
  };
};

exports.onFetchSelectTeamDataSuccess = onFetchSelectTeamDataSuccess;

var setValueStream = function setValueStream(payload) {
  return {
    type: _ActionTypes.SET_VALUE_STREAM,
    payload: payload
  };
};

exports.setValueStream = setValueStream;

var fetchValueStream = function fetchValueStream(payload) {
  return {
    type: _ActionTypes.FETCH_VALUE_STREAM,
    payload: payload
  };
};

exports.fetchValueStream = fetchValueStream;

var fetchValueStreamSuccess = function fetchValueStreamSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_VALUE_STREAM_SUCCESS,
    payload: payload
  };
};

exports.fetchValueStreamSuccess = fetchValueStreamSuccess;

var fetchValueStreams = function fetchValueStreams() {
  return {
    type: _ActionTypes.FETCH_ALL_VALUE_STREAM
  };
};

exports.fetchValueStreams = fetchValueStreams;

var fetchValueStreamsSuccess = function fetchValueStreamsSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_ALL_VALUE_STREAM_SUCCESS,
    payload: payload
  };
};

exports.fetchValueStreamsSuccess = fetchValueStreamsSuccess;

var showValueStreamMessage = function showValueStreamMessage(message) {
  return {
    type: _ActionTypes.SHOW_VALUE_STREAM_MESSAGE,
    payload: message
  };
};

exports.showValueStreamMessage = showValueStreamMessage;

var addFavouriteValueStream = function addFavouriteValueStream(payload) {
  return {
    type: _ActionTypes.ADD_FAVOURITE_VALUE_STREAM,
    payload: payload
  };
};

exports.addFavouriteValueStream = addFavouriteValueStream;

var addFavouriteValueStreamSuccess = function addFavouriteValueStreamSuccess(payload) {
  return {
    type: _ActionTypes.ADD_FAVOURITE_VALUE_STREAM_SUCCESS,
    payload: payload
  };
};

exports.addFavouriteValueStreamSuccess = addFavouriteValueStreamSuccess;

var onValueStreamSelect = function onValueStreamSelect(payload) {
  return {
    type: _ActionTypes.ON_VALUE_STREAM_SELECT,
    payload: payload
  };
};

exports.onValueStreamSelect = onValueStreamSelect;

var onAddValueStream = function onAddValueStream() {
  return {
    type: _ActionTypes.ON_ADD_VALUE_STREAM
  };
};

exports.onAddValueStream = onAddValueStream;

var onEditValueStream = function onEditValueStream(payload) {
  return {
    type: _ActionTypes.ON_EDIT_VALUE_STREAM,
    payload: payload
  };
};

exports.onEditValueStream = onEditValueStream;

var onValueStreamClose = function onValueStreamClose() {
  return {
    type: _ActionTypes.ON_VALUE_STREAM_CLOSE
  };
};

exports.onValueStreamClose = onValueStreamClose;

var onFilterValueStreamOptionSelect = function onFilterValueStreamOptionSelect(payload) {
  return {
    type: _ActionTypes.ON_FILTER_VALUE_STREAM_OPTION_SELECT,
    payload: payload
  };
};

exports.onFilterValueStreamOptionSelect = onFilterValueStreamOptionSelect;

var onSaveValueStream = function onSaveValueStream(payload) {
  return {
    type: _ActionTypes.ON_SAVE_VALUE_STREAM,
    payload: payload
  };
};

exports.onSaveValueStream = onSaveValueStream;

var onSaveValueStreamSuccess = function onSaveValueStreamSuccess(data) {
  return {
    type: _ActionTypes.ON_SAVE_VALUE_STREAM_SUCCESS,
    payload: data
  };
};

exports.onSaveValueStreamSuccess = onSaveValueStreamSuccess;

var onDeleteValueStream = function onDeleteValueStream(payload) {
  return {
    type: _ActionTypes.ON_DELETE_VALUE_STREAM,
    payload: payload
  };
};

exports.onDeleteValueStream = onDeleteValueStream;

var onDeleteValueStreamSuccess = function onDeleteValueStreamSuccess(payload) {
  return {
    type: _ActionTypes.ON_DELETE_VALUE_STREAM_SUCCESS,
    payload: payload
  };
};

exports.onDeleteValueStreamSuccess = onDeleteValueStreamSuccess;

var onFilterSelectedValueStream = function onFilterSelectedValueStream() {
  return {
    type: _ActionTypes.ON_FILTER_SELECTED_VALUE_STREAM,
    payload: ''
  };
};

exports.onFilterSelectedValueStream = onFilterSelectedValueStream;

var filterValueStream = function filterValueStream(payload) {
  return {
    type: _ActionTypes.FILTER_VALUE_STREAM,
    payload: payload
  };
};

exports.filterValueStream = filterValueStream;

var getAllValueStream = function getAllValueStream() {
  return {
    type: _ActionTypes.GET_ALL_VALUE_STREAM,
    payload: ''
  };
};

exports.getAllValueStream = getAllValueStream;

var getUnselectedAllValueStream = function getUnselectedAllValueStream() {
  return {
    type: _ActionTypes.GET_UNSELECTED_ALL_VALUE_STREAM,
    payload: ''
  };
};

exports.getUnselectedAllValueStream = getUnselectedAllValueStream;

var onAllValueStreamSelect = function onAllValueStreamSelect() {
  return {
    type: _ActionTypes.ON_ALL_VALUE_STREAM_SELECT,
    payload: ''
  };
};

exports.onAllValueStreamSelect = onAllValueStreamSelect;

var updateSearchValueStream = function updateSearchValueStream(payload) {
  return {
    type: _ActionTypes.UPDATE_SEARCH_VALUE_STREAM,
    payload: payload
  };
};

exports.updateSearchValueStream = updateSearchValueStream;

var onToggleValueStreamDrawer = function onToggleValueStreamDrawer() {
  return {
    type: _ActionTypes.ON_TOGGLE_VALUE_STREAM_DRAWER
  };
};

exports.onToggleValueStreamDrawer = onToggleValueStreamDrawer;

var handleValueStreamRequestClose = function handleValueStreamRequestClose() {
  return {
    type: _ActionTypes.HANDLE_VALUE_STREAM_REQUEST_CLOSE
  };
};

exports.handleValueStreamRequestClose = handleValueStreamRequestClose;

var showValueStreamLoader = function showValueStreamLoader() {
  return {
    type: _ActionTypes.SHOW_VALUE_STREAM_LOADER
  };
};

exports.showValueStreamLoader = showValueStreamLoader;

var hideValueStreamLoader = function hideValueStreamLoader() {
  return {
    type: _ActionTypes.HIDE_VALUE_STREAM_LOADER
  };
};

exports.hideValueStreamLoader = hideValueStreamLoader;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(onValueStreamTeamUpdate, "onValueStreamTeamUpdate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(onFetchSelectTeamData, "onFetchSelectTeamData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(onFetchSelectTeamDataSuccess, "onFetchSelectTeamDataSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(setValueStream, "setValueStream", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(fetchValueStream, "fetchValueStream", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(fetchValueStreamSuccess, "fetchValueStreamSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(fetchValueStreams, "fetchValueStreams", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(fetchValueStreamsSuccess, "fetchValueStreamsSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(showValueStreamMessage, "showValueStreamMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(addFavouriteValueStream, "addFavouriteValueStream", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(addFavouriteValueStreamSuccess, "addFavouriteValueStreamSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(onValueStreamSelect, "onValueStreamSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(onAddValueStream, "onAddValueStream", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(onEditValueStream, "onEditValueStream", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(onValueStreamClose, "onValueStreamClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(onFilterValueStreamOptionSelect, "onFilterValueStreamOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(onSaveValueStream, "onSaveValueStream", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(onSaveValueStreamSuccess, "onSaveValueStreamSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(onDeleteValueStream, "onDeleteValueStream", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(onDeleteValueStreamSuccess, "onDeleteValueStreamSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(onFilterSelectedValueStream, "onFilterSelectedValueStream", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(filterValueStream, "filterValueStream", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(getAllValueStream, "getAllValueStream", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllValueStream, "getUnselectedAllValueStream", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(onAllValueStreamSelect, "onAllValueStreamSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(updateSearchValueStream, "updateSearchValueStream", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(onToggleValueStreamDrawer, "onToggleValueStreamDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(handleValueStreamRequestClose, "handleValueStreamRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(showValueStreamLoader, "showValueStreamLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(hideValueStreamLoader, "hideValueStreamLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(onValueStreamTeamUpdate, "onValueStreamTeamUpdate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(onFetchSelectTeamData, "onFetchSelectTeamData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(onFetchSelectTeamDataSuccess, "onFetchSelectTeamDataSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(setValueStream, "setValueStream", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(fetchValueStream, "fetchValueStream", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(fetchValueStreamSuccess, "fetchValueStreamSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(fetchValueStreams, "fetchValueStreams", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(fetchValueStreamsSuccess, "fetchValueStreamsSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(showValueStreamMessage, "showValueStreamMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(addFavouriteValueStream, "addFavouriteValueStream", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(addFavouriteValueStreamSuccess, "addFavouriteValueStreamSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(onValueStreamSelect, "onValueStreamSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(onAddValueStream, "onAddValueStream", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(onEditValueStream, "onEditValueStream", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(onValueStreamClose, "onValueStreamClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(onFilterValueStreamOptionSelect, "onFilterValueStreamOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(onSaveValueStream, "onSaveValueStream", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(onSaveValueStreamSuccess, "onSaveValueStreamSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(onDeleteValueStream, "onDeleteValueStream", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(onDeleteValueStreamSuccess, "onDeleteValueStreamSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(onFilterSelectedValueStream, "onFilterSelectedValueStream", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(filterValueStream, "filterValueStream", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(getAllValueStream, "getAllValueStream", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllValueStream, "getUnselectedAllValueStream", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(onAllValueStreamSelect, "onAllValueStreamSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(updateSearchValueStream, "updateSearchValueStream", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(onToggleValueStreamDrawer, "onToggleValueStreamDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(handleValueStreamRequestClose, "handleValueStreamRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(showValueStreamLoader, "showValueStreamLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(hideValueStreamLoader, "hideValueStreamLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/valueStream.js");
}();

;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideTeamLoader = exports.showTeamLoader = exports.handleTeamRequestClose = exports.onToggleTeamDrawer = exports.updateSearchTeam = exports.onAllTeamSelect = exports.getUnselectedAllTeam = exports.getAllTeam = exports.filterTeam = exports.onFilterSelectedTeam = exports.onDeleteTeamSuccess = exports.onDeleteTeam = exports.onSaveTeamSuccess = exports.onSaveTeam = exports.onFilterTeamOptionSelect = exports.onTeamClose = exports.onEditTeam = exports.onAddTeam = exports.onTeamSelect = exports.addFavouriteTeamSuccess = exports.addFavouriteTeam = exports.showTeamMessage = exports.fetchTeamsSuccess = exports.fetchTeams = exports.fetchTeamSuccess = exports.fetchTeam = exports.setTeam = exports.onFetchSelectMemberDataSuccess = exports.onFetchSelectMemberData = exports.onTeamMemberUpdate = void 0;

var _ActionTypes = __webpack_require__(7);

var onTeamMemberUpdate = function onTeamMemberUpdate() {
  return {
    type: _ActionTypes.ON_TEAM_MEMBER_UPDATE
  };
};

exports.onTeamMemberUpdate = onTeamMemberUpdate;

var onFetchSelectMemberData = function onFetchSelectMemberData() {
  return {
    type: _ActionTypes.ON_FETCH_SELECT_MEMBER_DATA
  };
};

exports.onFetchSelectMemberData = onFetchSelectMemberData;

var onFetchSelectMemberDataSuccess = function onFetchSelectMemberDataSuccess(payload) {
  return {
    type: _ActionTypes.ON_FETCH_SELECT_MEMBER_DATA_SUCCESS,
    payload: payload
  };
};

exports.onFetchSelectMemberDataSuccess = onFetchSelectMemberDataSuccess;

var setTeam = function setTeam(payload) {
  return {
    type: _ActionTypes.SET_TEAM,
    payload: payload
  };
};

exports.setTeam = setTeam;

var fetchTeam = function fetchTeam(payload) {
  return {
    type: _ActionTypes.FETCH_TEAM,
    payload: payload
  };
};

exports.fetchTeam = fetchTeam;

var fetchTeamSuccess = function fetchTeamSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_TEAM_SUCCESS,
    payload: payload
  };
};

exports.fetchTeamSuccess = fetchTeamSuccess;

var fetchTeams = function fetchTeams() {
  return {
    type: _ActionTypes.FETCH_ALL_TEAM
  };
};

exports.fetchTeams = fetchTeams;

var fetchTeamsSuccess = function fetchTeamsSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_ALL_TEAM_SUCCESS,
    payload: payload
  };
};

exports.fetchTeamsSuccess = fetchTeamsSuccess;

var showTeamMessage = function showTeamMessage(message) {
  return {
    type: _ActionTypes.SHOW_TEAM_MESSAGE,
    payload: message
  };
};

exports.showTeamMessage = showTeamMessage;

var addFavouriteTeam = function addFavouriteTeam(payload) {
  return {
    type: _ActionTypes.ADD_FAVOURITE_TEAM,
    payload: payload
  };
};

exports.addFavouriteTeam = addFavouriteTeam;

var addFavouriteTeamSuccess = function addFavouriteTeamSuccess(payload) {
  return {
    type: _ActionTypes.ADD_FAVOURITE_TEAM_SUCCESS,
    payload: payload
  };
};

exports.addFavouriteTeamSuccess = addFavouriteTeamSuccess;

var onTeamSelect = function onTeamSelect(payload) {
  return {
    type: _ActionTypes.ON_TEAM_SELECT,
    payload: payload
  };
};

exports.onTeamSelect = onTeamSelect;

var onAddTeam = function onAddTeam() {
  return {
    type: _ActionTypes.ON_ADD_TEAM
  };
};

exports.onAddTeam = onAddTeam;

var onEditTeam = function onEditTeam(payload) {
  return {
    type: _ActionTypes.ON_EDIT_TEAM,
    payload: payload
  };
};

exports.onEditTeam = onEditTeam;

var onTeamClose = function onTeamClose() {
  return {
    type: _ActionTypes.ON_TEAM_CLOSE
  };
};

exports.onTeamClose = onTeamClose;

var onFilterTeamOptionSelect = function onFilterTeamOptionSelect(payload) {
  return {
    type: _ActionTypes.ON_FILTER_TEAM_OPTION_SELECT,
    payload: payload
  };
};

exports.onFilterTeamOptionSelect = onFilterTeamOptionSelect;

var onSaveTeam = function onSaveTeam(payload) {
  return {
    type: _ActionTypes.ON_SAVE_TEAM,
    payload: payload
  };
};

exports.onSaveTeam = onSaveTeam;

var onSaveTeamSuccess = function onSaveTeamSuccess(data) {
  return {
    type: _ActionTypes.ON_SAVE_TEAM_SUCCESS,
    payload: data
  };
};

exports.onSaveTeamSuccess = onSaveTeamSuccess;

var onDeleteTeam = function onDeleteTeam(payload) {
  return {
    type: _ActionTypes.ON_DELETE_TEAM,
    payload: payload
  };
};

exports.onDeleteTeam = onDeleteTeam;

var onDeleteTeamSuccess = function onDeleteTeamSuccess(payload) {
  return {
    type: _ActionTypes.ON_DELETE_TEAM_SUCCESS,
    payload: payload
  };
};

exports.onDeleteTeamSuccess = onDeleteTeamSuccess;

var onFilterSelectedTeam = function onFilterSelectedTeam() {
  return {
    type: _ActionTypes.ON_FILTER_SELECTED_TEAM,
    payload: ''
  };
};

exports.onFilterSelectedTeam = onFilterSelectedTeam;

var filterTeam = function filterTeam(payload) {
  return {
    type: _ActionTypes.FILTER_TEAM,
    payload: payload
  };
};

exports.filterTeam = filterTeam;

var getAllTeam = function getAllTeam() {
  return {
    type: _ActionTypes.GET_ALL_TEAM,
    payload: ''
  };
};

exports.getAllTeam = getAllTeam;

var getUnselectedAllTeam = function getUnselectedAllTeam() {
  return {
    type: _ActionTypes.GET_UNSELECTED_ALL_TEAM,
    payload: ''
  };
};

exports.getUnselectedAllTeam = getUnselectedAllTeam;

var onAllTeamSelect = function onAllTeamSelect() {
  return {
    type: _ActionTypes.ON_ALL_TEAM_SELECT,
    payload: ''
  };
};

exports.onAllTeamSelect = onAllTeamSelect;

var updateSearchTeam = function updateSearchTeam(payload) {
  return {
    type: _ActionTypes.UPDATE_SEARCH_TEAM,
    payload: payload
  };
};

exports.updateSearchTeam = updateSearchTeam;

var onToggleTeamDrawer = function onToggleTeamDrawer() {
  return {
    type: _ActionTypes.ON_TOGGLE_TEAM_DRAWER
  };
};

exports.onToggleTeamDrawer = onToggleTeamDrawer;

var handleTeamRequestClose = function handleTeamRequestClose() {
  return {
    type: _ActionTypes.HANDLE_TEAM_REQUEST_CLOSE
  };
};

exports.handleTeamRequestClose = handleTeamRequestClose;

var showTeamLoader = function showTeamLoader() {
  return {
    type: _ActionTypes.SHOW_TEAM_LOADER
  };
};

exports.showTeamLoader = showTeamLoader;

var hideTeamLoader = function hideTeamLoader() {
  return {
    type: _ActionTypes.HIDE_TEAM_LOADER
  };
};

exports.hideTeamLoader = hideTeamLoader;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(onTeamMemberUpdate, "onTeamMemberUpdate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(onFetchSelectMemberData, "onFetchSelectMemberData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(onFetchSelectMemberDataSuccess, "onFetchSelectMemberDataSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(setTeam, "setTeam", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(fetchTeam, "fetchTeam", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(fetchTeamSuccess, "fetchTeamSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(fetchTeams, "fetchTeams", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(fetchTeamsSuccess, "fetchTeamsSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(showTeamMessage, "showTeamMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(addFavouriteTeam, "addFavouriteTeam", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(addFavouriteTeamSuccess, "addFavouriteTeamSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(onTeamSelect, "onTeamSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(onAddTeam, "onAddTeam", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(onEditTeam, "onEditTeam", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(onTeamClose, "onTeamClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(onFilterTeamOptionSelect, "onFilterTeamOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(onSaveTeam, "onSaveTeam", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(onSaveTeamSuccess, "onSaveTeamSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(onDeleteTeam, "onDeleteTeam", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(onDeleteTeamSuccess, "onDeleteTeamSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(onFilterSelectedTeam, "onFilterSelectedTeam", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(filterTeam, "filterTeam", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(getAllTeam, "getAllTeam", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllTeam, "getUnselectedAllTeam", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(onAllTeamSelect, "onAllTeamSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(updateSearchTeam, "updateSearchTeam", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(onToggleTeamDrawer, "onToggleTeamDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(handleTeamRequestClose, "handleTeamRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(showTeamLoader, "showTeamLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(hideTeamLoader, "hideTeamLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(onTeamMemberUpdate, "onTeamMemberUpdate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(onFetchSelectMemberData, "onFetchSelectMemberData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(onFetchSelectMemberDataSuccess, "onFetchSelectMemberDataSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(setTeam, "setTeam", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(fetchTeam, "fetchTeam", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(fetchTeamSuccess, "fetchTeamSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(fetchTeams, "fetchTeams", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(fetchTeamsSuccess, "fetchTeamsSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(showTeamMessage, "showTeamMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(addFavouriteTeam, "addFavouriteTeam", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(addFavouriteTeamSuccess, "addFavouriteTeamSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(onTeamSelect, "onTeamSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(onAddTeam, "onAddTeam", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(onEditTeam, "onEditTeam", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(onTeamClose, "onTeamClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(onFilterTeamOptionSelect, "onFilterTeamOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(onSaveTeam, "onSaveTeam", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(onSaveTeamSuccess, "onSaveTeamSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(onDeleteTeam, "onDeleteTeam", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(onDeleteTeamSuccess, "onDeleteTeamSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(onFilterSelectedTeam, "onFilterSelectedTeam", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(filterTeam, "filterTeam", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(getAllTeam, "getAllTeam", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllTeam, "getUnselectedAllTeam", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(onAllTeamSelect, "onAllTeamSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(updateSearchTeam, "updateSearchTeam", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(onToggleTeamDrawer, "onToggleTeamDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(handleTeamRequestClose, "handleTeamRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(showTeamLoader, "showTeamLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(hideTeamLoader, "hideTeamLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/team.js");
}();

;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideProductLoader = exports.showProductLoader = exports.handleProductRequestClose = exports.onToggleProductDrawer = exports.updateSearchProduct = exports.onAllProductSelect = exports.getUnselectedAllProduct = exports.getAllProduct = exports.filterProduct = exports.onFilterSelectedProduct = exports.onDeleteProductSuccess = exports.onDeleteProduct = exports.onSaveProductSuccess = exports.onSaveProduct = exports.onFilterProductOptionSelect = exports.onProductClose = exports.onEditProduct = exports.onAddProduct = exports.onProductSelect = exports.addFavouriteProductSuccess = exports.addFavouriteProduct = exports.showProductMessage = exports.fetchProductsSuccess = exports.fetchProducts = exports.fetchProductSuccess = exports.fetchProduct = exports.setProduct = exports.onFetchSelectValueStreamDataSuccess = exports.onFetchSelectValueStreamData = exports.onProductValueStreamUpdate = exports.fetchProductLookupData = void 0;

var _ActionTypes = __webpack_require__(7);

var fetchProductLookupData = function fetchProductLookupData() {
  return {
    type: _ActionTypes.FETCH_PRODUCT_LOOKUP_DATA
  };
};

exports.fetchProductLookupData = fetchProductLookupData;

var onProductValueStreamUpdate = function onProductValueStreamUpdate() {
  return {
    type: _ActionTypes.ON_PRODUCT_VALUESTREAM_UPDATE
  };
};

exports.onProductValueStreamUpdate = onProductValueStreamUpdate;

var onFetchSelectValueStreamData = function onFetchSelectValueStreamData() {
  return {
    type: _ActionTypes.ON_FETCH_SELECT_VALUESTREAM_DATA
  };
};

exports.onFetchSelectValueStreamData = onFetchSelectValueStreamData;

var onFetchSelectValueStreamDataSuccess = function onFetchSelectValueStreamDataSuccess(payload) {
  return {
    type: _ActionTypes.ON_FETCH_SELECT_VALUESTREAM_DATA_SUCCESS,
    payload: payload
  };
};

exports.onFetchSelectValueStreamDataSuccess = onFetchSelectValueStreamDataSuccess;

var setProduct = function setProduct(payload) {
  return {
    type: _ActionTypes.SET_PRODUCT,
    payload: payload
  };
};

exports.setProduct = setProduct;

var fetchProduct = function fetchProduct(payload) {
  return {
    type: _ActionTypes.FETCH_PRODUCT,
    payload: payload
  };
};

exports.fetchProduct = fetchProduct;

var fetchProductSuccess = function fetchProductSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_PRODUCT_SUCCESS,
    payload: payload
  };
};

exports.fetchProductSuccess = fetchProductSuccess;

var fetchProducts = function fetchProducts() {
  return {
    type: _ActionTypes.FETCH_ALL_PRODUCT
  };
};

exports.fetchProducts = fetchProducts;

var fetchProductsSuccess = function fetchProductsSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_ALL_PRODUCT_SUCCESS,
    payload: payload
  };
};

exports.fetchProductsSuccess = fetchProductsSuccess;

var showProductMessage = function showProductMessage(message) {
  return {
    type: _ActionTypes.SHOW_PRODUCT_MESSAGE,
    payload: message
  };
};

exports.showProductMessage = showProductMessage;

var addFavouriteProduct = function addFavouriteProduct(payload) {
  return {
    type: _ActionTypes.ADD_FAVOURITE_PRODUCT,
    payload: payload
  };
};

exports.addFavouriteProduct = addFavouriteProduct;

var addFavouriteProductSuccess = function addFavouriteProductSuccess(payload) {
  return {
    type: _ActionTypes.ADD_FAVOURITE_PRODUCT_SUCCESS,
    payload: payload
  };
};

exports.addFavouriteProductSuccess = addFavouriteProductSuccess;

var onProductSelect = function onProductSelect(payload) {
  return {
    type: _ActionTypes.ON_PRODUCT_SELECT,
    payload: payload
  };
};

exports.onProductSelect = onProductSelect;

var onAddProduct = function onAddProduct() {
  return {
    type: _ActionTypes.ON_ADD_PRODUCT
  };
};

exports.onAddProduct = onAddProduct;

var onEditProduct = function onEditProduct(payload) {
  return {
    type: _ActionTypes.ON_EDIT_PRODUCT,
    payload: payload
  };
};

exports.onEditProduct = onEditProduct;

var onProductClose = function onProductClose() {
  return {
    type: _ActionTypes.ON_PRODUCT_CLOSE
  };
};

exports.onProductClose = onProductClose;

var onFilterProductOptionSelect = function onFilterProductOptionSelect(payload) {
  return {
    type: _ActionTypes.ON_FILTER_PRODUCT_OPTION_SELECT,
    payload: payload
  };
};

exports.onFilterProductOptionSelect = onFilterProductOptionSelect;

var onSaveProduct = function onSaveProduct(payload) {
  return {
    type: _ActionTypes.ON_SAVE_PRODUCT,
    payload: payload
  };
};

exports.onSaveProduct = onSaveProduct;

var onSaveProductSuccess = function onSaveProductSuccess(data) {
  return {
    type: _ActionTypes.ON_SAVE_PRODUCT_SUCCESS,
    payload: data
  };
};

exports.onSaveProductSuccess = onSaveProductSuccess;

var onDeleteProduct = function onDeleteProduct(payload) {
  return {
    type: _ActionTypes.ON_DELETE_PRODUCT,
    payload: payload
  };
};

exports.onDeleteProduct = onDeleteProduct;

var onDeleteProductSuccess = function onDeleteProductSuccess(payload) {
  return {
    type: _ActionTypes.ON_DELETE_PRODUCT_SUCCESS,
    payload: payload
  };
};

exports.onDeleteProductSuccess = onDeleteProductSuccess;

var onFilterSelectedProduct = function onFilterSelectedProduct() {
  return {
    type: _ActionTypes.ON_FILTER_SELECTED_PRODUCT,
    payload: ''
  };
};

exports.onFilterSelectedProduct = onFilterSelectedProduct;

var filterProduct = function filterProduct(payload) {
  return {
    type: _ActionTypes.FILTER_PRODUCT,
    payload: payload
  };
};

exports.filterProduct = filterProduct;

var getAllProduct = function getAllProduct() {
  return {
    type: _ActionTypes.GET_ALL_PRODUCT,
    payload: ''
  };
};

exports.getAllProduct = getAllProduct;

var getUnselectedAllProduct = function getUnselectedAllProduct() {
  return {
    type: _ActionTypes.GET_UNSELECTED_ALL_PRODUCT,
    payload: ''
  };
};

exports.getUnselectedAllProduct = getUnselectedAllProduct;

var onAllProductSelect = function onAllProductSelect() {
  return {
    type: _ActionTypes.ON_ALL_PRODUCT_SELECT,
    payload: ''
  };
};

exports.onAllProductSelect = onAllProductSelect;

var updateSearchProduct = function updateSearchProduct(payload) {
  return {
    type: _ActionTypes.UPDATE_SEARCH_PRODUCT,
    payload: payload
  };
};

exports.updateSearchProduct = updateSearchProduct;

var onToggleProductDrawer = function onToggleProductDrawer() {
  return {
    type: _ActionTypes.ON_TOGGLE_PRODUCT_DRAWER
  };
};

exports.onToggleProductDrawer = onToggleProductDrawer;

var handleProductRequestClose = function handleProductRequestClose() {
  return {
    type: _ActionTypes.HANDLE_PRODUCT_REQUEST_CLOSE
  };
};

exports.handleProductRequestClose = handleProductRequestClose;

var showProductLoader = function showProductLoader() {
  return {
    type: _ActionTypes.SHOW_PRODUCT_LOADER
  };
};

exports.showProductLoader = showProductLoader;

var hideProductLoader = function hideProductLoader() {
  return {
    type: _ActionTypes.HIDE_PRODUCT_LOADER
  };
};

exports.hideProductLoader = hideProductLoader;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchProductLookupData, "fetchProductLookupData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(onProductValueStreamUpdate, "onProductValueStreamUpdate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(onFetchSelectValueStreamData, "onFetchSelectValueStreamData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(onFetchSelectValueStreamDataSuccess, "onFetchSelectValueStreamDataSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(setProduct, "setProduct", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(fetchProduct, "fetchProduct", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(fetchProductSuccess, "fetchProductSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(fetchProducts, "fetchProducts", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(fetchProductsSuccess, "fetchProductsSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(showProductMessage, "showProductMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(addFavouriteProduct, "addFavouriteProduct", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(addFavouriteProductSuccess, "addFavouriteProductSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(onProductSelect, "onProductSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(onAddProduct, "onAddProduct", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(onEditProduct, "onEditProduct", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(onProductClose, "onProductClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(onFilterProductOptionSelect, "onFilterProductOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(onSaveProduct, "onSaveProduct", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(onSaveProductSuccess, "onSaveProductSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(onDeleteProduct, "onDeleteProduct", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(onDeleteProductSuccess, "onDeleteProductSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(onFilterSelectedProduct, "onFilterSelectedProduct", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(filterProduct, "filterProduct", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(getAllProduct, "getAllProduct", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllProduct, "getUnselectedAllProduct", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(onAllProductSelect, "onAllProductSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(updateSearchProduct, "updateSearchProduct", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(onToggleProductDrawer, "onToggleProductDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(handleProductRequestClose, "handleProductRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(showProductLoader, "showProductLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(hideProductLoader, "hideProductLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchProductLookupData, "fetchProductLookupData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(onProductValueStreamUpdate, "onProductValueStreamUpdate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(onFetchSelectValueStreamData, "onFetchSelectValueStreamData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(onFetchSelectValueStreamDataSuccess, "onFetchSelectValueStreamDataSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(setProduct, "setProduct", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(fetchProduct, "fetchProduct", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(fetchProductSuccess, "fetchProductSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(fetchProducts, "fetchProducts", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(fetchProductsSuccess, "fetchProductsSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(showProductMessage, "showProductMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(addFavouriteProduct, "addFavouriteProduct", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(addFavouriteProductSuccess, "addFavouriteProductSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(onProductSelect, "onProductSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(onAddProduct, "onAddProduct", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(onEditProduct, "onEditProduct", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(onProductClose, "onProductClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(onFilterProductOptionSelect, "onFilterProductOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(onSaveProduct, "onSaveProduct", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(onSaveProductSuccess, "onSaveProductSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(onDeleteProduct, "onDeleteProduct", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(onDeleteProductSuccess, "onDeleteProductSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(onFilterSelectedProduct, "onFilterSelectedProduct", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(filterProduct, "filterProduct", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(getAllProduct, "getAllProduct", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllProduct, "getUnselectedAllProduct", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(onAllProductSelect, "onAllProductSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(updateSearchProduct, "updateSearchProduct", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(onToggleProductDrawer, "onToggleProductDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(handleProductRequestClose, "handleProductRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(showProductLoader, "showProductLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(hideProductLoader, "hideProductLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/product.js");
}();

;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(119);
var core = __webpack_require__(61);
var ctx = __webpack_require__(370);
var hide = __webpack_require__(182);
var has = __webpack_require__(148);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 119 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(183);
var IE8_DOM_DEFINE = __webpack_require__(688);
var toPrimitive = __webpack_require__(371);
var dP = Object.defineProperty;

exports.f = __webpack_require__(121) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(185)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isObject__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Text__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_DataUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_PolarUtils__ = __webpack_require__(82);




function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var cartesianViewBoxShape = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
  x: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  y: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number
});
var polarViewBoxShape = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
  cx: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  cy: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  innerRadius: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  outerRadius: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  startAngle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  endAngle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number
});

var propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  viewBox: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([cartesianViewBoxShape, polarViewBoxShape]),
  formatter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string]),
  offset: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  position: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['top', 'left', 'right', 'bottom', 'inside', 'outside', 'insideLeft', 'insideRight', 'insideTop', 'insideBottom', 'insideTopLeft', 'insideBottomLeft', 'insideTopRight', 'insideBottomRight', 'insideStart', 'insideEnd', 'end', 'center', 'centerTop', 'centerBottom']),
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node]),
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  content: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func])
});

var defaultProps = {
  offset: 5
};

var getLabel = function getLabel(props) {
  var value = props.value,
      formatter = props.formatter;
  var label = __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(props.children) ? value : props.children;

  if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(formatter)) {
    return formatter(label);
  }

  return label;
};

var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
  var sign = Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["j" /* mathSign */])(endAngle - startAngle);
  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
  return sign * deltaAngle;
};

var renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
  var position = labelProps.position,
      viewBox = labelProps.viewBox,
      offset = labelProps.offset,
      className = labelProps.className;
  var cx = viewBox.cx,
      cy = viewBox.cy,
      innerRadius = viewBox.innerRadius,
      outerRadius = viewBox.outerRadius,
      startAngle = viewBox.startAngle,
      endAngle = viewBox.endAngle,
      clockWise = viewBox.clockWise;
  var radius = (innerRadius + outerRadius) / 2;
  var deltaAngle = getDeltaAngle(startAngle, endAngle);
  var sign = deltaAngle >= 0 ? 1 : -1;
  var labelAngle, direction;

  if (position === 'insideStart') {
    labelAngle = startAngle + sign * offset;
    direction = clockWise;
  } else if (position === 'insideEnd') {
    labelAngle = endAngle - sign * offset;
    direction = !clockWise;
  } else if (position === 'end') {
    labelAngle = endAngle + sign * offset;
    direction = clockWise;
  }

  direction = deltaAngle <= 0 ? direction : !direction;
  var startPoint = Object(__WEBPACK_IMPORTED_MODULE_9__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, radius, labelAngle);
  var endPoint = Object(__WEBPACK_IMPORTED_MODULE_9__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
  var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
  var id = __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(labelProps.id) ? Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["k" /* uniqueId */])('recharts-radial-line-') : labelProps.id;
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("text", _extends({}, attrs, {
    dominantBaseline: "central",
    className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()('recharts-radial-bar-label', className)
  }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("defs", null, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("path", {
    id: id,
    d: path
  })), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("textPath", {
    xlinkHref: "#".concat(id)
  }, label));
};

var getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
  var viewBox = props.viewBox,
      offset = props.offset,
      position = props.position;
  var cx = viewBox.cx,
      cy = viewBox.cy,
      innerRadius = viewBox.innerRadius,
      outerRadius = viewBox.outerRadius,
      startAngle = viewBox.startAngle,
      endAngle = viewBox.endAngle;
  var midAngle = (startAngle + endAngle) / 2;

  if (position === 'outside') {
    var _polarToCartesian = Object(__WEBPACK_IMPORTED_MODULE_9__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, outerRadius + offset, midAngle),
        _x = _polarToCartesian.x,
        _y = _polarToCartesian.y;

    return {
      x: _x,
      y: _y,
      textAnchor: _x >= cx ? 'start' : 'end',
      verticalAnchor: 'middle'
    };
  }

  if (position === 'center') {
    return {
      x: cx,
      y: cy,
      textAnchor: 'middle',
      verticalAnchor: 'middle'
    };
  }

  if (position === 'centerTop') {
    return {
      x: cx,
      y: cy,
      textAnchor: 'middle',
      verticalAnchor: 'start'
    };
  }

  if (position === 'centerBottom') {
    return {
      x: cx,
      y: cy,
      textAnchor: 'middle',
      verticalAnchor: 'end'
    };
  }

  var r = (innerRadius + outerRadius) / 2;

  var _polarToCartesian2 = Object(__WEBPACK_IMPORTED_MODULE_9__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, r, midAngle),
      x = _polarToCartesian2.x,
      y = _polarToCartesian2.y;

  return {
    x: x,
    y: y,
    textAnchor: 'middle',
    verticalAnchor: 'middle'
  };
};

var getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
  var viewBox = props.viewBox,
      offset = props.offset,
      position = props.position;
  var x = viewBox.x,
      y = viewBox.y,
      width = viewBox.width,
      height = viewBox.height;
  var sign = height >= 0 ? 1 : -1;

  if (position === 'top') {
    return {
      x: x + width / 2,
      y: y - sign * offset,
      textAnchor: 'middle',
      verticalAnchor: sign > 0 ? 'end' : 'start'
    };
  }

  if (position === 'bottom') {
    return {
      x: x + width / 2,
      y: y + height + sign * offset,
      textAnchor: 'middle',
      verticalAnchor: 'start'
    };
  }

  if (position === 'left') {
    return {
      x: x - offset,
      y: y + height / 2,
      textAnchor: 'end',
      verticalAnchor: 'middle'
    };
  }

  if (position === 'right') {
    return {
      x: x + width + offset,
      y: y + height / 2,
      textAnchor: 'start',
      verticalAnchor: 'middle'
    };
  }

  if (position === 'insideLeft') {
    return {
      x: x + offset,
      y: y + height / 2,
      textAnchor: 'start',
      verticalAnchor: 'middle'
    };
  }

  if (position === 'insideRight') {
    return {
      x: x + width - offset,
      y: y + height / 2,
      textAnchor: 'end',
      verticalAnchor: 'middle'
    };
  }

  if (position === 'insideTop') {
    return {
      x: x + width / 2,
      y: y + sign * offset,
      textAnchor: 'middle',
      verticalAnchor: 'start'
    };
  }

  if (position === 'insideBottom') {
    return {
      x: x + width / 2,
      y: y + height - sign * offset,
      textAnchor: 'middle',
      verticalAnchor: 'end'
    };
  }

  if (position === 'insideTopLeft') {
    return {
      x: x + offset,
      y: y + sign * offset,
      textAnchor: 'start',
      verticalAnchor: 'start'
    };
  }

  if (position === 'insideTopRight') {
    return {
      x: x + width - offset,
      y: y + sign * offset,
      textAnchor: 'end',
      verticalAnchor: 'start'
    };
  }

  if (position === 'insideBottomLeft') {
    return {
      x: x + offset,
      y: y + height - sign * offset,
      textAnchor: 'start',
      verticalAnchor: 'end'
    };
  }

  if (position === 'insideBottomRight') {
    return {
      x: x + width - offset,
      y: y + height - sign * offset,
      textAnchor: 'end',
      verticalAnchor: 'end'
    };
  }

  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isObject___default()(position) && (Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["h" /* isNumber */])(position.x) || Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["i" /* isPercent */])(position.x)) && (Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["h" /* isNumber */])(position.y) || Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["i" /* isPercent */])(position.y))) {
    return {
      x: x + Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["d" /* getPercentValue */])(position.x, width),
      y: y + Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["d" /* getPercentValue */])(position.y, height),
      textAnchor: 'end',
      verticalAnchor: 'end'
    };
  }

  return {
    x: x + width / 2,
    y: y + height / 2,
    textAnchor: 'middle',
    verticalAnchor: 'middle'
  };
};

var isPolar = function isPolar(viewBox) {
  return Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["h" /* isNumber */])(viewBox.cx);
};

function Label(props) {
  var viewBox = props.viewBox,
      position = props.position,
      value = props.value,
      children = props.children,
      content = props.content,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className;

  if (!viewBox || __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(value) && __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(children) && !Object(__WEBPACK_IMPORTED_MODULE_3_react__["isValidElement"])(content) && !__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(content)) {
    return null;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_3_react__["isValidElement"])(content)) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"])(content, props);
  }

  var label;

  if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(content)) {
    label = content(props);

    if (Object(__WEBPACK_IMPORTED_MODULE_3_react__["isValidElement"])(label)) {
      return label;
    }
  } else {
    label = getLabel(props);
  }

  var isPolarLabel = isPolar(viewBox);
  var attrs = Object(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["l" /* getPresentationAttributes */])(props);
  var events = Object(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["f" /* filterEventAttributes */])(props);

  if (isPolarLabel && (position === 'insideStart' || position === 'insideEnd' || position === 'end')) {
    return renderRadialLabel(props, label, attrs);
  }

  var positionAttrs = isPolarLabel ? getAttrsOfPolarLabel(props) : getAttrsOfCartesianLabel(props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Text__["a" /* default */], _extends({
    className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()('recharts-label', className)
  }, attrs, positionAttrs, events), label);
}

Label.displayName = 'Label';
Label.defaultProps = defaultProps;
Label.propTypes = propTypes;

var parseViewBox = function parseViewBox(props) {
  var cx = props.cx,
      cy = props.cy,
      angle = props.angle,
      startAngle = props.startAngle,
      endAngle = props.endAngle,
      r = props.r,
      radius = props.radius,
      innerRadius = props.innerRadius,
      outerRadius = props.outerRadius,
      x = props.x,
      y = props.y,
      top = props.top,
      left = props.left,
      width = props.width,
      height = props.height,
      clockWise = props.clockWise;

  if (Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["h" /* isNumber */])(width) && Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["h" /* isNumber */])(height)) {
    if (Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["h" /* isNumber */])(x) && Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["h" /* isNumber */])(y)) {
      return {
        x: x,
        y: y,
        width: width,
        height: height
      };
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["h" /* isNumber */])(top) && Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["h" /* isNumber */])(left)) {
      return {
        x: top,
        y: left,
        width: width,
        height: height
      };
    }
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["h" /* isNumber */])(x) && Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["h" /* isNumber */])(y)) {
    return {
      x: x,
      y: y,
      width: 0,
      height: 0
    };
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["h" /* isNumber */])(cx) && Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["h" /* isNumber */])(cy)) {
    return {
      cx: cx,
      cy: cy,
      startAngle: startAngle || angle || 0,
      endAngle: endAngle || angle || 0,
      innerRadius: innerRadius || 0,
      outerRadius: outerRadius || radius || r || 0,
      clockWise: clockWise
    };
  }

  if (props.viewBox) {
    return props.viewBox;
  }

  return {};
};

var parseLabel = function parseLabel(label, viewBox) {
  if (!label) {
    return null;
  }

  if (label === true) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Label, {
      key: "label-implicit",
      viewBox: viewBox
    });
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["g" /* isNumOrStr */])(label)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Label, {
      key: "label-implicit",
      viewBox: viewBox,
      value: label
    });
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_3_react__["isValidElement"])(label)) {
    if (label.type === Label) {
      return Object(__WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"])(label, {
        key: 'label-implicit',
        viewBox: viewBox
      });
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Label, {
      key: "label-implicit",
      content: label,
      viewBox: viewBox
    });
  }

  if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(label)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Label, {
      key: "label-implicit",
      content: label,
      viewBox: viewBox
    });
  }

  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isObject___default()(label)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Label, _extends({
      viewBox: viewBox
    }, label, {
      key: "label-implicit"
    }));
  }

  return null;
};

var renderCallByParent = function renderCallByParent(parentProps, viewBox) {
  var ckeckPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (!parentProps || !parentProps.children && ckeckPropsLabel && !parentProps.label) {
    return null;
  }

  var children = parentProps.children;
  var parentViewBox = parseViewBox(parentProps);
  var explicitChilren = Object(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["i" /* findAllByType */])(children, Label).map(function (child, index) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"])(child, {
      viewBox: viewBox || parentViewBox,
      key: "label-".concat(index)
    });
  });

  if (!ckeckPropsLabel) {
    return explicitChilren;
  }

  var implicitLabel = parseLabel(parentProps.label, viewBox || parentViewBox);
  return [implicitLabel].concat(_toConsumableArray(explicitChilren));
};

Label.parseViewBox = parseViewBox;
Label.renderCallByParent = renderCallByParent;
/* harmony default export */ __webpack_exports__["a"] = (Label);

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = identity;
/* harmony export (immutable) */ __webpack_exports__["a"] = copy;
/* harmony export (immutable) */ __webpack_exports__["d"] = transformer;
/* harmony export (immutable) */ __webpack_exports__["b"] = continuous;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(1633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(1649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(761);






var unit = [0, 1];

function identity(x) {
  return x;
}

function normalize(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(isNaN(b) ? NaN : 0.5);
}

function clamper(domain) {
  var a = domain[0], b = domain[domain.length - 1], t;
  if (a > b) t = a, a = b, b = t;
  return function(x) { return Math.max(a, Math.min(b, x)); };
}

// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function bimap(domain, range, interpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
  else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, interpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = normalize(domain[i], domain[i + 1]);
    r[i] = interpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp())
      .unknown(source.unknown());
}

function transformer() {
  var domain = unit,
      range = unit,
      interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["a" /* interpolate */],
      transform,
      untransform,
      unknown,
      clamp = identity,
      piecewise,
      output,
      input;

  function rescale() {
    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
  }

  scale.invert = function(y) {
    return clamp(untransform((input || (input = piecewise(range, domain.map(transform), __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolateNumber */])))(y)));
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_2__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]), clamp === identity || (clamp = clamper(domain)), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["c" /* interpolateRound */], rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = _ ? clamper(domain) : identity, scale) : clamp !== identity;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  return function(t, u) {
    transform = t, untransform = u;
    return rescale();
  };
}

function continuous(transform, untransform) {
  return transformer()(transform, untransform);
}


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatAxisMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return rectWithPoints; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return rectWithCoords; });
/* unused harmony export ScaleHelper */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LabeledScaleHelper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_every__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_every___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_every__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_mapValues__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_mapValues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChartUtils__ = __webpack_require__(51);



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


/**
 * Calculate the scale function, position, width, height of axes
 * @param  {Object} props     Latest props
 * @param  {Object} axisMap   The configuration of axes
 * @param  {Object} offset    The offset of main part in the svg element
 * @param  {String} axisType  The type of axes, x-axis or y-axis
 * @param  {String} chartName The name of chart
 * @return {Object} Configuration
 */

var formatAxisMap = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
  var width = props.width,
      height = props.height,
      layout = props.layout;
  var ids = Object.keys(axisMap);
  var steps = {
    left: offset.left,
    leftMirror: offset.left,
    right: width - offset.right,
    rightMirror: width - offset.right,
    top: offset.top,
    topMirror: offset.top,
    bottom: height - offset.bottom,
    bottomMirror: height - offset.bottom
  };
  return ids.reduce(function (result, id) {
    var axis = axisMap[id];
    var orientation = axis.orientation,
        domain = axis.domain,
        _axis$padding = axis.padding,
        padding = _axis$padding === void 0 ? {} : _axis$padding,
        mirror = axis.mirror,
        reversed = axis.reversed;
    var offsetKey = "".concat(orientation).concat(mirror ? 'Mirror' : '');
    var range, x, y, needSpace;

    if (axisType === 'xAxis') {
      range = [offset.left + (padding.left || 0), offset.left + offset.width - (padding.right || 0)];
    } else if (axisType === 'yAxis') {
      range = layout === 'horizontal' ? [offset.top + offset.height - (padding.bottom || 0), offset.top + (padding.top || 0)] : [offset.top + (padding.top || 0), offset.top + offset.height - (padding.bottom || 0)];
    } else {
      range = axis.range;
    }

    if (reversed) {
      range = [range[1], range[0]];
    }

    var _parseScale = Object(__WEBPACK_IMPORTED_MODULE_2__ChartUtils__["z" /* parseScale */])(axis, chartName),
        scale = _parseScale.scale,
        realScaleType = _parseScale.realScaleType;

    scale.domain(domain).range(range);
    Object(__WEBPACK_IMPORTED_MODULE_2__ChartUtils__["c" /* checkDomainOfScale */])(scale);
    var ticks = Object(__WEBPACK_IMPORTED_MODULE_2__ChartUtils__["u" /* getTicksOfScale */])(scale, _objectSpread({}, axis, {
      realScaleType: realScaleType
    }));

    if (axisType === 'xAxis') {
      needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
      x = offset.left;
      y = steps[offsetKey] - needSpace * axis.height;
    } else if (axisType === 'yAxis') {
      needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
      x = steps[offsetKey] - needSpace * axis.width;
      y = offset.top;
    }

    var finalAxis = _objectSpread({}, axis, {}, ticks, {
      realScaleType: realScaleType,
      x: x,
      y: y,
      scale: scale,
      width: axisType === 'xAxis' ? offset.width : axis.width,
      height: axisType === 'yAxis' ? offset.height : axis.height
    });

    finalAxis.bandSize = Object(__WEBPACK_IMPORTED_MODULE_2__ChartUtils__["f" /* getBandSizeOfAxis */])(finalAxis, ticks);

    if (!axis.hide && axisType === 'xAxis') {
      steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
    } else if (!axis.hide) {
      steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
    }

    return _objectSpread({}, result, _defineProperty({}, id, finalAxis));
  }, {});
};
var rectWithPoints = function rectWithPoints(_ref, _ref2) {
  var x1 = _ref.x,
      y1 = _ref.y;
  var x2 = _ref2.x,
      y2 = _ref2.y;
  return {
    x: Math.min(x1, x2),
    y: Math.min(y1, y2),
    width: Math.abs(x2 - x1),
    height: Math.abs(y2 - y1)
  };
};
/**
 * Compute the x, y, width, and height of a box from two reference points.
 * @param  {Object} coords     x1, x2, y1, and y2
 * @return {Object} object
 */

var rectWithCoords = function rectWithCoords(_ref3) {
  var x1 = _ref3.x1,
      y1 = _ref3.y1,
      x2 = _ref3.x2,
      y2 = _ref3.y2;
  return rectWithPoints({
    x: x1,
    y: y1
  }, {
    x: x2,
    y: y2
  });
};
var ScaleHelper =
/*#__PURE__*/
function () {
  _createClass(ScaleHelper, null, [{
    key: "create",
    value: function create(obj) {
      return new ScaleHelper(obj);
    }
  }]);

  function ScaleHelper(scale) {
    _classCallCheck(this, ScaleHelper);

    this.scale = scale;
  }

  _createClass(ScaleHelper, [{
    key: "apply",
    value: function apply(value) {
      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          bandAware = _ref4.bandAware,
          position = _ref4.position;

      if (value === undefined) {
        return undefined;
      }

      if (position) {
        switch (position) {
          case 'start':
            {
              return this.scale(value);
            }

          case 'middle':
            {
              var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
              return this.scale(value) + offset;
            }

          case 'end':
            {
              var _offset = this.bandwidth ? this.bandwidth() : 0;

              return this.scale(value) + _offset;
            }

          default:
            {
              return this.scale(value);
            }
        }
      }

      if (bandAware) {
        var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;

        return this.scale(value) + _offset2;
      }

      return this.scale(value);
    }
  }, {
    key: "isInRange",
    value: function isInRange(value) {
      var range = this.range();
      var first = range[0];
      var last = range[range.length - 1];
      return first <= last ? value >= first && value <= last : value >= last && value <= first;
    }
  }, {
    key: "domain",
    get: function get() {
      return this.scale.domain;
    }
  }, {
    key: "range",
    get: function get() {
      return this.scale.range;
    }
  }, {
    key: "rangeMin",
    get: function get() {
      return this.range()[0];
    }
  }, {
    key: "rangeMax",
    get: function get() {
      return this.range()[1];
    }
  }, {
    key: "bandwidth",
    get: function get() {
      return this.scale.bandwidth;
    }
  }]);

  return ScaleHelper;
}();
ScaleHelper.EPS = 1e-4;
var LabeledScaleHelper =
/*#__PURE__*/
function () {
  _createClass(LabeledScaleHelper, null, [{
    key: "create",
    value: function create(obj) {
      return new this(obj);
    }
  }]);

  function LabeledScaleHelper(scales) {
    _classCallCheck(this, LabeledScaleHelper);

    this.scales = __WEBPACK_IMPORTED_MODULE_1_lodash_mapValues___default()(scales, ScaleHelper.create);
    Object.assign(this, this.scales);
  }

  _createClass(LabeledScaleHelper, [{
    key: "apply",
    value: function apply(coords) {
      var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          bandAware = _ref5.bandAware;

      var scales = this.scales;
      return __WEBPACK_IMPORTED_MODULE_1_lodash_mapValues___default()(coords, function (value, label) {
        return scales[label].apply(value, {
          bandAware: bandAware
        });
      });
    }
  }, {
    key: "isInRange",
    value: function isInRange(coords) {
      var scales = this.scales;
      return __WEBPACK_IMPORTED_MODULE_0_lodash_every___default()(coords, function (value, label) {
        return scales[label].isInRange(value);
      });
    }
  }]);

  return LabeledScaleHelper;
}();

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _System = __webpack_require__(55);

var _Validation = __webpack_require__(14);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ListRowImage = function ListRowImage(_ref) {
  var width = _ref.width,
      data = _ref.data;
  var name = data.name,
      thumb = data.thumb;

  if (width > _System.TIGHT_FIT_PARAM) {
    if ((0, _Validation.isEmpty)(thumb)) {
      return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("div", {
        className: "rounded-circle size-40 bg-blue text-center text-white mx-1 mx-md-3",
        style: {
          fontSize: 20
        }
      }, name ? name.charAt(0).toUpperCase() : ''));
    } else {
      return _react["default"].createElement("img", {
        className: "rounded-circle size-40 mx-1 mx-md-3",
        alt: name,
        src: thumb
      });
    }
  } else {
    return null;
  }
};

var _default = ListRowImage;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ListRowImage, "ListRowImage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/listRowImage/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/listRowImage/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/listRowImage/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/listRowImage/index.js");

  __REACT_HOT_LOADER__.register(ListRowImage, "ListRowImage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/listRowImage/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/listRowImage/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/listRowImage/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/listRowImage/index.js");
}();

;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _System = __webpack_require__(55);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ListRowFavourite = function ListRowFavourite(_ref) {
  var width = _ref.width,
      starred = _ref.starred,
      onClick = _ref.onClick;
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("div", {
    className: "col-auto px-1 actions d-sm-flex"
  }, _react["default"].createElement("span", {
    className: "icon-btn",
    style: {
      width: width > _System.TIGHT_FIT_PARAM ? 48 : 18
    },
    onClick: onClick
  }, starred ? _react["default"].createElement("i", {
    className: "zmdi zmdi-star"
  }) : _react["default"].createElement("i", {
    className: "zmdi zmdi-star-outline"
  }))));
};

var _default = ListRowFavourite;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ListRowFavourite, "ListRowFavourite", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ListRowFavourite/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ListRowFavourite/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ListRowFavourite/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ListRowFavourite/index.js");

  __REACT_HOT_LOADER__.register(ListRowFavourite, "ListRowFavourite", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ListRowFavourite/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ListRowFavourite/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ListRowFavourite/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ListRowFavourite/index.js");
}();

;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ListRowDropdown = function ListRowDropdown(_ref) {
  var menuState = _ref.menuState,
      toggle = _ref.toggle,
      dropdownItems = _ref.dropdownItems;
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("div", {
    className: "col-auto px-1 actions d-sm-flex"
  }, _react["default"].createElement(_reactstrap.Dropdown, {
    isOpen: menuState,
    toggle: toggle
  }, _react["default"].createElement(_reactstrap.DropdownToggle, {
    tag: "span"
  }, _react["default"].createElement("span", {
    className: "icon-btn text-grey pointer"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-more-vert zmdi-hc-lg"
  }))), _react["default"].createElement(_reactstrap.DropdownMenu, null, dropdownItems))));
};

var _default = ListRowDropdown;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ListRowDropdown, "ListRowDropdown", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ListRowDropdown/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ListRowDropdown/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ListRowDropdown/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ListRowDropdown/index.js");

  __REACT_HOT_LOADER__.register(ListRowDropdown, "ListRowDropdown", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ListRowDropdown/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ListRowDropdown/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ListRowDropdown/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ListRowDropdown/index.js");
}();

;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ListRowData = function ListRowData(_ref) {
  var lineOne = _ref.lineOne,
      lineTwoLeft = _ref.lineTwoLeft,
      lineTwoRight = _ref.lineTwoRight;
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("div", {
    className: "col"
  }, _react["default"].createElement("p", {
    className: "mb-0"
  }, _react["default"].createElement("span", {
    className: "contact-name"
  }, lineOne)), lineTwoLeft || lineTwoRight ? _react["default"].createElement("div", null, _react["default"].createElement("span", {
    className: "email d-inline-block mr-2"
  }, lineTwoLeft), _react["default"].createElement("span", {
    className: "phone d-inline-block"
  }, lineTwoRight)) : null));
};

var _default = ListRowData;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ListRowData, "ListRowData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ListRowData/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ListRowData/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ListRowData/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ListRowData/index.js");

  __REACT_HOT_LOADER__.register(ListRowData, "ListRowData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ListRowData/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ListRowData/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ListRowData/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/ListRowData/index.js");
}();

;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(21),
    isLength = __webpack_require__(354);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 131 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 132 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 133 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(450);
var enumBugKeys = __webpack_require__(321);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(86);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(19);
var dPs = __webpack_require__(451);
var enumBugKeys = __webpack_require__(321);
var IE_PROTO = __webpack_require__(320)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(318)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(322).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(450);
var hiddenKeys = __webpack_require__(321).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(68);
var toObject = __webpack_require__(49);
var IE_PROTO = __webpack_require__(320)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(28)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(69)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReactReduxContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ReactReduxContext =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null);

if (false) {
  ReactReduxContext.displayName = 'ReactRedux';
}

/* unused harmony default export */ var _unused_webpack_default_export = (ReactReduxContext);

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(1131),
    getValue = __webpack_require__(1136);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideAuthLoader = exports.showAuthLoader = exports.hideMessage = exports.userGithubSignInSuccess = exports.userGithubSignIn = exports.userTwitterSignInSuccess = exports.userTwitterSignIn = exports.setInitUrl = exports.userFacebookSignInSuccess = exports.userFacebookSignIn = exports.userGoogleSignInSuccess = exports.userGoogleSignIn = exports.showAuthMessage = exports.userSignOutSuccess = exports.userSignInSuccess = exports.userSignUpSuccess = exports.userSignOut = exports.userRequestSignInCodeSuccess = exports.userRequestSignInCode = exports.userSignInPasswordless = exports.userSignIn = exports.userSignUp = exports.identitySuccess = void 0;

var _ActionTypes = __webpack_require__(7);

var identitySuccess = function identitySuccess(identity) {
  return {
    type: _ActionTypes.IDENTITY_SUCCESS,
    payload: identity
  };
};

exports.identitySuccess = identitySuccess;

var userSignUp = function userSignUp(user) {
  return {
    type: _ActionTypes.SIGNUP_USER,
    payload: user
  };
};

exports.userSignUp = userSignUp;

var userSignIn = function userSignIn(payload) {
  return {
    type: _ActionTypes.SIGNIN_USER,
    payload: payload
  };
};

exports.userSignIn = userSignIn;

var userSignInPasswordless = function userSignInPasswordless(payload) {
  return {
    type: _ActionTypes.SIGNIN_USER_PASSWORDLESS,
    payload: payload
  };
};

exports.userSignInPasswordless = userSignInPasswordless;

var userRequestSignInCode = function userRequestSignInCode(username) {
  return {
    type: _ActionTypes.REQUEST_SIGNIN_ACCESS_CODE,
    payload: username
  };
};

exports.userRequestSignInCode = userRequestSignInCode;

var userRequestSignInCodeSuccess = function userRequestSignInCodeSuccess(payload) {
  return {
    type: _ActionTypes.REQUEST_SIGNIN_ACCESS_CODE_SUCCESS,
    payload: payload
  };
};

exports.userRequestSignInCodeSuccess = userRequestSignInCodeSuccess;

var userSignOut = function userSignOut() {
  return {
    type: _ActionTypes.SIGNOUT_USER
  };
};

exports.userSignOut = userSignOut;

var userSignUpSuccess = function userSignUpSuccess(authUser) {
  return {
    type: _ActionTypes.SIGNUP_USER_SUCCESS,
    payload: authUser
  };
};

exports.userSignUpSuccess = userSignUpSuccess;

var userSignInSuccess = function userSignInSuccess(authUser) {
  return {
    type: _ActionTypes.SIGNIN_USER_SUCCESS,
    payload: authUser
  };
};

exports.userSignInSuccess = userSignInSuccess;

var userSignOutSuccess = function userSignOutSuccess() {
  return {
    type: _ActionTypes.SIGNOUT_USER_SUCCESS
  };
};

exports.userSignOutSuccess = userSignOutSuccess;

var showAuthMessage = function showAuthMessage(message) {
  return {
    type: _ActionTypes.SHOW_MESSAGE,
    payload: message
  };
};

exports.showAuthMessage = showAuthMessage;

var userGoogleSignIn = function userGoogleSignIn() {
  return {
    type: _ActionTypes.SIGNIN_GOOGLE_USER
  };
};

exports.userGoogleSignIn = userGoogleSignIn;

var userGoogleSignInSuccess = function userGoogleSignInSuccess(authUser) {
  return {
    type: _ActionTypes.SIGNIN_GOOGLE_USER_SUCCESS,
    payload: authUser
  };
};

exports.userGoogleSignInSuccess = userGoogleSignInSuccess;

var userFacebookSignIn = function userFacebookSignIn() {
  return {
    type: _ActionTypes.SIGNIN_FACEBOOK_USER
  };
};

exports.userFacebookSignIn = userFacebookSignIn;

var userFacebookSignInSuccess = function userFacebookSignInSuccess(authUser) {
  return {
    type: _ActionTypes.SIGNIN_FACEBOOK_USER_SUCCESS,
    payload: authUser
  };
};

exports.userFacebookSignInSuccess = userFacebookSignInSuccess;

var setInitUrl = function setInitUrl(url) {
  return {
    type: _ActionTypes.INIT_URL,
    payload: url
  };
};

exports.setInitUrl = setInitUrl;

var userTwitterSignIn = function userTwitterSignIn() {
  return {
    type: _ActionTypes.SIGNIN_TWITTER_USER
  };
};

exports.userTwitterSignIn = userTwitterSignIn;

var userTwitterSignInSuccess = function userTwitterSignInSuccess(authUser) {
  return {
    type: _ActionTypes.SIGNIN_TWITTER_USER_SUCCESS,
    payload: authUser
  };
};

exports.userTwitterSignInSuccess = userTwitterSignInSuccess;

var userGithubSignIn = function userGithubSignIn() {
  return {
    type: _ActionTypes.SIGNIN_GITHUB_USER
  };
};

exports.userGithubSignIn = userGithubSignIn;

var userGithubSignInSuccess = function userGithubSignInSuccess(authUser) {
  return {
    type: _ActionTypes.SIGNIN_GITHUB_USER_SUCCESS,
    payload: authUser
  };
};

exports.userGithubSignInSuccess = userGithubSignInSuccess;

var hideMessage = function hideMessage() {
  return {
    type: _ActionTypes.HIDE_MESSAGE
  };
};

exports.hideMessage = hideMessage;

var showAuthLoader = function showAuthLoader() {
  return {
    type: _ActionTypes.ON_SHOW_LOADER
  };
};

exports.showAuthLoader = showAuthLoader;

var hideAuthLoader = function hideAuthLoader() {
  return {
    type: _ActionTypes.ON_HIDE_LOADER
  };
};

exports.hideAuthLoader = hideAuthLoader;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(identitySuccess, "identitySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(userSignUp, "userSignUp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(userSignIn, "userSignIn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(userSignInPasswordless, "userSignInPasswordless", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(userRequestSignInCode, "userRequestSignInCode", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(userRequestSignInCodeSuccess, "userRequestSignInCodeSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(userSignOut, "userSignOut", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(userSignUpSuccess, "userSignUpSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(userSignInSuccess, "userSignInSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(userSignOutSuccess, "userSignOutSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(showAuthMessage, "showAuthMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(userGoogleSignIn, "userGoogleSignIn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(userGoogleSignInSuccess, "userGoogleSignInSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(userFacebookSignIn, "userFacebookSignIn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(userFacebookSignInSuccess, "userFacebookSignInSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(setInitUrl, "setInitUrl", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(userTwitterSignIn, "userTwitterSignIn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(userTwitterSignInSuccess, "userTwitterSignInSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(userGithubSignIn, "userGithubSignIn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(userGithubSignInSuccess, "userGithubSignInSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(hideMessage, "hideMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(showAuthLoader, "showAuthLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(hideAuthLoader, "hideAuthLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(identitySuccess, "identitySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(userSignUp, "userSignUp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(userSignIn, "userSignIn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(userSignInPasswordless, "userSignInPasswordless", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(userRequestSignInCode, "userRequestSignInCode", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(userRequestSignInCodeSuccess, "userRequestSignInCodeSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(userSignOut, "userSignOut", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(userSignUpSuccess, "userSignUpSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(userSignInSuccess, "userSignInSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(userSignOutSuccess, "userSignOutSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(showAuthMessage, "showAuthMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(userGoogleSignIn, "userGoogleSignIn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(userGoogleSignInSuccess, "userGoogleSignInSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(userFacebookSignIn, "userFacebookSignIn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(userFacebookSignInSuccess, "userFacebookSignInSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(setInitUrl, "setInitUrl", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(userTwitterSignIn, "userTwitterSignIn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(userTwitterSignInSuccess, "userTwitterSignInSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(userGithubSignIn, "userGithubSignIn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(userGithubSignInSuccess, "userGithubSignInSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(hideMessage, "hideMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(showAuthLoader, "showAuthLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(hideAuthLoader, "hideAuthLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Auth.js");
}();

;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideOrgLoader = exports.showOrgLoader = exports.handleOrgRequestClose = exports.onToggleOrgDrawer = exports.updateSearchOrg = exports.onAllOrgSelect = exports.getUnselectedAllOrg = exports.getAllOrg = exports.filterOrg = exports.onDeleteSelectedOrg = exports.onDeleteOrg = exports.onSaveOrgSuccess = exports.onSaveOrg = exports.onFilterOrgOptionSelect = exports.onOrgClose = exports.onAddOrg = exports.onOrgSurveyCompareDashboard = exports.onOrgSurveyDashboard = exports.onImpersonateOrg = exports.onProjectDashboard = exports.onEmpDashboard = exports.onOrgSelect = exports.addFavouriteOrg = exports.showOrgMessage = exports.fetchOrgsSuccess = exports.fetchOrgs = exports.onOrgDashboardSuccess = exports.fetchOrgsAndSelectOrg = exports.fetchOrgsSelectOrg = exports.fetchOrgSuccess = exports.fetchOrg = exports.onOrgDashboard = exports.fetchOrgStatisticsSuccess = exports.fetchOrgStatistics = void 0;

var _ActionTypes = __webpack_require__(7);

var fetchOrgStatistics = function fetchOrgStatistics(payload) {
  return {
    type: _ActionTypes.FETCH_ORG_STATISTICS,
    payload: payload
  };
};

exports.fetchOrgStatistics = fetchOrgStatistics;

var fetchOrgStatisticsSuccess = function fetchOrgStatisticsSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_ORG_STATISTICS_SUCCESS,
    payload: payload
  };
};

exports.fetchOrgStatisticsSuccess = fetchOrgStatisticsSuccess;

var onOrgDashboard = function onOrgDashboard() {
  return {
    type: _ActionTypes.ON_ORG_DASHBOARD
  };
};

exports.onOrgDashboard = onOrgDashboard;

var fetchOrg = function fetchOrg(orgid) {
  return {
    type: _ActionTypes.FETCH_ORG,
    payload: orgid
  };
};

exports.fetchOrg = fetchOrg;

var fetchOrgSuccess = function fetchOrgSuccess(org) {
  return {
    type: _ActionTypes.FETCH_ORG_SUCCESS,
    payload: org
  };
};

exports.fetchOrgSuccess = fetchOrgSuccess;

var fetchOrgsSelectOrg = function fetchOrgsSelectOrg(orgid) {
  return {
    type: _ActionTypes.FETCH_ORGS_SELECT_ORG,
    payload: orgid
  };
};

exports.fetchOrgsSelectOrg = fetchOrgsSelectOrg;

var fetchOrgsAndSelectOrg = function fetchOrgsAndSelectOrg(orgid) {
  return {
    type: _ActionTypes.FETCH_ORGS_SELECT_ORG,
    payload: orgid
  };
};

exports.fetchOrgsAndSelectOrg = fetchOrgsAndSelectOrg;

var onOrgDashboardSuccess = function onOrgDashboardSuccess(payload) {
  return {
    type: _ActionTypes.ON_ORG_DASHBOARD_SUCCESS,
    payload: payload
  };
};

exports.onOrgDashboardSuccess = onOrgDashboardSuccess;

var fetchOrgs = function fetchOrgs() {
  return {
    type: _ActionTypes.FETCH_ALL_ORG
  };
};

exports.fetchOrgs = fetchOrgs;

var fetchOrgsSuccess = function fetchOrgsSuccess(orgs) {
  return {
    type: _ActionTypes.FETCH_ALL_ORG_SUCCESS,
    payload: orgs
  };
};

exports.fetchOrgsSuccess = fetchOrgsSuccess;

var showOrgMessage = function showOrgMessage(message) {
  return {
    type: _ActionTypes.SHOW_ORG_MESSAGE,
    payload: message
  };
};

exports.showOrgMessage = showOrgMessage;

var addFavouriteOrg = function addFavouriteOrg(data) {
  return {
    type: _ActionTypes.ADD_FAVOURITE_ORG,
    payload: data
  };
};

exports.addFavouriteOrg = addFavouriteOrg;

var onOrgSelect = function onOrgSelect(data) {
  return {
    type: _ActionTypes.ON_ORG_SELECT,
    payload: data
  };
};

exports.onOrgSelect = onOrgSelect;

var onEmpDashboard = function onEmpDashboard(data) {
  return {
    type: _ActionTypes.ON_EMP_DASHBOARD,
    payload: data
  };
};

exports.onEmpDashboard = onEmpDashboard;

var onProjectDashboard = function onProjectDashboard(data) {
  return {
    type: _ActionTypes.ON_PROJECT_DASHBOARD,
    payload: data
  };
};

exports.onProjectDashboard = onProjectDashboard;

var onImpersonateOrg = function onImpersonateOrg(data) {
  return {
    type: _ActionTypes.ON_IMPERSONATE_DASHBOARD,
    payload: data
  };
};

exports.onImpersonateOrg = onImpersonateOrg;

var onOrgSurveyDashboard = function onOrgSurveyDashboard(data) {
  return {
    type: _ActionTypes.ON_ORG_SURVEY_DASHBOARD,
    payload: data
  };
};

exports.onOrgSurveyDashboard = onOrgSurveyDashboard;

var onOrgSurveyCompareDashboard = function onOrgSurveyCompareDashboard(data) {
  return {
    type: _ActionTypes.ON_ORG_SURVEY_COMPARE_DASHBOARD,
    payload: data
  };
};

exports.onOrgSurveyCompareDashboard = onOrgSurveyCompareDashboard;

var onAddOrg = function onAddOrg() {
  return {
    type: _ActionTypes.ON_ADD_ORG,
    payload: ''
  };
};

exports.onAddOrg = onAddOrg;

var onOrgClose = function onOrgClose() {
  return {
    type: _ActionTypes.ON_ORG_CLOSE,
    payload: ''
  };
};

exports.onOrgClose = onOrgClose;

var onFilterOrgOptionSelect = function onFilterOrgOptionSelect(option) {
  return {
    type: _ActionTypes.ON_FILTER_ORG_OPTION_SELECT,
    payload: option
  };
};

exports.onFilterOrgOptionSelect = onFilterOrgOptionSelect;

var onSaveOrg = function onSaveOrg(data) {
  return {
    type: _ActionTypes.ON_SAVE_ORG,
    payload: data
  };
};

exports.onSaveOrg = onSaveOrg;

var onSaveOrgSuccess = function onSaveOrgSuccess(data) {
  return {
    type: _ActionTypes.ON_SAVE_ORG_SUCCESS,
    payload: data
  };
};

exports.onSaveOrgSuccess = onSaveOrgSuccess;

var onDeleteOrg = function onDeleteOrg(data) {
  return {
    type: _ActionTypes.ON_DELETE_ORG,
    payload: data
  };
};

exports.onDeleteOrg = onDeleteOrg;

var onDeleteSelectedOrg = function onDeleteSelectedOrg() {
  return {
    type: _ActionTypes.ON_DELETE_SELECTED_ORG,
    payload: ''
  };
};

exports.onDeleteSelectedOrg = onDeleteSelectedOrg;

var filterOrg = function filterOrg(userName) {
  return {
    type: _ActionTypes.FILTER_ORG,
    payload: userName
  };
};

exports.filterOrg = filterOrg;

var getAllOrg = function getAllOrg() {
  return {
    type: _ActionTypes.GET_ALL_ORG,
    payload: ''
  };
};

exports.getAllOrg = getAllOrg;

var getUnselectedAllOrg = function getUnselectedAllOrg() {
  return {
    type: _ActionTypes.GET_UNSELECTED_ALL_ORG,
    payload: ''
  };
};

exports.getUnselectedAllOrg = getUnselectedAllOrg;

var onAllOrgSelect = function onAllOrgSelect() {
  return {
    type: _ActionTypes.ON_ALL_ORG_SELECT,
    payload: ''
  };
};

exports.onAllOrgSelect = onAllOrgSelect;

var updateSearchOrg = function updateSearchOrg(userName) {
  return {
    type: _ActionTypes.UPDATE_SEARCH_ORG,
    payload: userName
  };
};

exports.updateSearchOrg = updateSearchOrg;

var onToggleOrgDrawer = function onToggleOrgDrawer() {
  return {
    type: _ActionTypes.ON_TOGGLE_ORG_DRAWER
  };
};

exports.onToggleOrgDrawer = onToggleOrgDrawer;

var handleOrgRequestClose = function handleOrgRequestClose() {
  return {
    type: _ActionTypes.HANDLE_ORG_REQUEST_CLOSE
  };
};

exports.handleOrgRequestClose = handleOrgRequestClose;

var showOrgLoader = function showOrgLoader() {
  return {
    type: _ActionTypes.SHOW_ORG_LOADER
  };
};

exports.showOrgLoader = showOrgLoader;

var hideOrgLoader = function hideOrgLoader() {
  return {
    type: _ActionTypes.HIDE_ORG_LOADER
  };
};

exports.hideOrgLoader = hideOrgLoader;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchOrgStatistics, "fetchOrgStatistics", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(fetchOrgStatisticsSuccess, "fetchOrgStatisticsSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(onOrgDashboard, "onOrgDashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(fetchOrg, "fetchOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(fetchOrgSuccess, "fetchOrgSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(fetchOrgsSelectOrg, "fetchOrgsSelectOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(fetchOrgsAndSelectOrg, "fetchOrgsAndSelectOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(onOrgDashboardSuccess, "onOrgDashboardSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(fetchOrgs, "fetchOrgs", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(fetchOrgsSuccess, "fetchOrgsSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(showOrgMessage, "showOrgMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(addFavouriteOrg, "addFavouriteOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(onOrgSelect, "onOrgSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(onEmpDashboard, "onEmpDashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(onProjectDashboard, "onProjectDashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(onImpersonateOrg, "onImpersonateOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(onOrgSurveyDashboard, "onOrgSurveyDashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(onOrgSurveyCompareDashboard, "onOrgSurveyCompareDashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(onAddOrg, "onAddOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(onOrgClose, "onOrgClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(onFilterOrgOptionSelect, "onFilterOrgOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(onSaveOrg, "onSaveOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(onSaveOrgSuccess, "onSaveOrgSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(onDeleteOrg, "onDeleteOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(onDeleteSelectedOrg, "onDeleteSelectedOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(filterOrg, "filterOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(getAllOrg, "getAllOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllOrg, "getUnselectedAllOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(onAllOrgSelect, "onAllOrgSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(updateSearchOrg, "updateSearchOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(onToggleOrgDrawer, "onToggleOrgDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(handleOrgRequestClose, "handleOrgRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(showOrgLoader, "showOrgLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(hideOrgLoader, "hideOrgLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchOrgStatistics, "fetchOrgStatistics", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(fetchOrgStatisticsSuccess, "fetchOrgStatisticsSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(onOrgDashboard, "onOrgDashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(fetchOrg, "fetchOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(fetchOrgSuccess, "fetchOrgSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(fetchOrgsSelectOrg, "fetchOrgsSelectOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(fetchOrgsAndSelectOrg, "fetchOrgsAndSelectOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(onOrgDashboardSuccess, "onOrgDashboardSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(fetchOrgs, "fetchOrgs", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(fetchOrgsSuccess, "fetchOrgsSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(showOrgMessage, "showOrgMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(addFavouriteOrg, "addFavouriteOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(onOrgSelect, "onOrgSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(onEmpDashboard, "onEmpDashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(onProjectDashboard, "onProjectDashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(onImpersonateOrg, "onImpersonateOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(onOrgSurveyDashboard, "onOrgSurveyDashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(onOrgSurveyCompareDashboard, "onOrgSurveyCompareDashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(onAddOrg, "onAddOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(onOrgClose, "onOrgClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(onFilterOrgOptionSelect, "onFilterOrgOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(onSaveOrg, "onSaveOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(onSaveOrgSuccess, "onSaveOrgSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(onDeleteOrg, "onDeleteOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(onDeleteSelectedOrg, "onDeleteSelectedOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(filterOrg, "filterOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(getAllOrg, "getAllOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllOrg, "getUnselectedAllOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(onAllOrgSelect, "onAllOrgSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(updateSearchOrg, "updateSearchOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(onToggleOrgDrawer, "onToggleOrgDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(handleOrgRequestClose, "handleOrgRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(showOrgLoader, "showOrgLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(hideOrgLoader, "hideOrgLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Organisation.js");
}();

;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.apiConfig = exports.apiKey = exports.replaceEndpointPathParams = exports.endpoint = exports.isMockData = exports.API_CONFIG = exports.retries = exports.timeout = void 0;

var _axios = _interopRequireDefault(__webpack_require__(1224));

var _Authentication = __webpack_require__(42);

var _environment = __webpack_require__(360);

var _promise = _interopRequireDefault(__webpack_require__(655));

var _qs = _interopRequireDefault(__webpack_require__(1255));

var _ApiService = __webpack_require__(16);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var timeout = 3000;
exports.timeout = timeout;
var retries = 2; // two more after the original request
// TODO constants please for these parameters

exports.retries = retries;
var API_CONFIG = {
  apiEndpoints: {
    endpoints: {
      projectCostPriority: {
        method: 'GET',
        name: 'projectCostPriority',
        uri: '/orgcostpriorities/{orgid}/projectCostPriorities/{projectCostPriorityId}'
      },
      projectCostPrioritys: {
        method: 'GET',
        name: 'projectCostPrioritys',
        uri: '/orgcostpriorities/{orgid}/projectCostPriorities'
      },
      updateProjectCostPriority: {
        method: 'PUT',
        name: 'updateProjectCostPriority',
        uri: '/orgcostpriorities/{orgid}/projectCostPriorities'
      },
      addProjectCostPriority: {
        method: 'POST',
        name: 'addProjectCostPriority',
        uri: '/orgcostpriorities/{orgid}/projectCostPriorities'
      },
      deleteProjectCostPriority: {
        method: 'DELETE',
        name: 'deleteProjectCostPriority',
        uri: '/orgcostpriorities/{orgid}/projectCostPriorities/{projectCostPriorityId}'
      },
      projectBusPriority: {
        method: 'GET',
        name: 'projectBusPriority',
        uri: '/orgbuspriorities/{orgid}/projectBusPriorities/{projectBusPriorityId}'
      },
      projectBusPrioritys: {
        method: 'GET',
        name: 'projectBusPrioritys',
        uri: '/orgbuspriorities/{orgid}/projectBusPriorities'
      },
      updateProjectBusPriority: {
        method: 'PUT',
        name: 'updateProjectBusPriority',
        uri: '/orgbuspriorities/{orgid}/projectBusPriorities'
      },
      addProjectBusPriority: {
        method: 'POST',
        name: 'addProjectBusPriority',
        uri: '/orgbuspriorities/{orgid}/projectBusPriorities'
      },
      deleteProjectBusPriority: {
        method: 'DELETE',
        name: 'deleteProjectBusPriority',
        uri: '/orgbuspriorities/{orgid}/projectBusPriorities/{projectBusPriorityId}'
      },
      issueDisplayData: {
        method: 'GET',
        name: 'issueDisplayData',
        uri: '/orgissue/{orgid}/issue/{issueId}/displayData'
      },
      issue: {
        method: 'GET',
        name: 'issue',
        uri: '/orgissue/{orgid}/issue/{issueId}'
      },
      issues: {
        method: 'GET',
        name: 'issues',
        uri: '/orgissue/{orgid}/issues'
      },
      updateIssue: {
        method: 'PUT',
        name: 'updateIssue',
        uri: '/orgissue/{orgid}/issue'
      },
      addIssue: {
        method: 'POST',
        name: 'addIssue',
        uri: '/orgissue/{orgid}/issue'
      },
      deleteIssue: {
        method: 'DELETE',
        name: 'deleteIssue',
        uri: '/orgissue/{orgid}/issue/{issueId}'
      },
      initiativeDisplayData: {
        method: 'GET',
        name: 'initiative',
        uri: '/orginitiative/{orgid}/initiative/{initiativeId}/displayData'
      },
      initiative: {
        method: 'GET',
        name: 'initiative',
        uri: '/orginitiative/{orgid}/initiative/{initiativeId}'
      },
      initiatives: {
        method: 'GET',
        name: 'initiatives',
        uri: '/orginitiative/{orgid}/initiatives'
      },
      updateInitiative: {
        method: 'PUT',
        name: 'updateInitiative',
        uri: '/orginitiative/{orgid}/initiative'
      },
      addInitiative: {
        method: 'POST',
        name: 'addInitiative',
        uri: '/orginitiative/{orgid}/initiative'
      },
      deleteInitiative: {
        method: 'DELETE',
        name: 'deleteInitiative',
        uri: '/orginitiative/{orgid}/initiative/{initiativeId}'
      },
      productDisplayData: {
        method: 'GET',
        name: 'productDisplayData',
        uri: '/orgproduct/{orgid}/product/{productId}/displayData'
      },
      product: {
        method: 'GET',
        name: 'product',
        uri: '/orgproduct/{orgid}/product/{productId}'
      },
      products: {
        method: 'GET',
        name: 'products',
        uri: '/orgproduct/{orgid}/products'
      },
      updateProduct: {
        method: 'PUT',
        name: 'updateProduct',
        uri: '/orgproduct/{orgid}/product'
      },
      addProduct: {
        method: 'POST',
        name: 'addProduct',
        uri: '/orgproduct/{orgid}/product'
      },
      deleteProduct: {
        method: 'DELETE',
        name: 'deleteProduct',
        uri: '/orgproduct/{orgid}/product/{productId}'
      },
      team: {
        method: 'GET',
        name: 'team',
        uri: '/orgteam/{orgid}/team/{teamId}'
      },
      teams: {
        method: 'GET',
        name: 'teams',
        uri: '/orgteam/{orgid}/teams'
      },
      updateTeam: {
        method: 'PUT',
        name: 'updateTeam',
        uri: '/orgteam/{orgid}/team'
      },
      addTeam: {
        method: 'POST',
        name: 'addTeam',
        uri: '/orgteam/{orgid}/team'
      },
      deleteTeam: {
        method: 'DELETE',
        name: 'deleteTeam',
        uri: '/orgteam/{orgid}/team/{teamId}'
      },
      member: {
        method: 'GET',
        name: 'member',
        uri: '/orgmember/{orgid}/member/{memberId}'
      },
      members: {
        method: 'GET',
        name: 'members',
        uri: '/orgmember/{orgid}/members'
      },
      updateMember: {
        method: 'PUT',
        name: 'updateMember',
        uri: '/orgmember/{orgid}/member'
      },
      addMember: {
        method: 'POST',
        name: 'addMember',
        uri: '/orgmember/{orgid}/member'
      },
      deleteMember: {
        method: 'DELETE',
        name: 'deleteMember',
        uri: '/orgmember/{orgid}/member/{memberId}'
      },
      valueStreamDisplayData: {
        method: 'GET',
        name: 'valueStreamDisplayData',
        uri: '/orgvaluestream/{orgid}/valueStream/{valueStreamId}/displayData'
      },
      valueStream: {
        method: 'GET',
        name: 'valueStream',
        uri: '/orgvaluestream/{orgid}/valueStream/{valueStreamId}'
      },
      valueStreams: {
        method: 'GET',
        name: 'valueStreams',
        uri: '/orgvaluestream/{orgid}/valueStreams'
      },
      updateValueStream: {
        method: 'PUT',
        name: 'updateValueStream',
        uri: '/orgvaluestream/{orgid}/valueStream'
      },
      addValueStream: {
        method: 'POST',
        name: 'addValueStream',
        uri: '/orgvaluestream/{orgid}/valueStream'
      },
      deleteValueStream: {
        method: 'DELETE',
        name: 'deleteValueStream',
        uri: '/orgvaluestream/{orgid}/valueStream/{valueStreamId}'
      },
      featureDisplayData: {
        method: 'GET',
        name: 'featureDisplayData',
        uri: '/orgfeature/{orgid}/feature/{featureId}/displayData'
      },
      feature: {
        method: 'GET',
        name: 'feature',
        uri: '/orgfeature/{orgid}/feature/{featureId}'
      },
      features: {
        method: 'GET',
        name: 'features',
        uri: '/orgfeature/{orgid}/features'
      },
      updateFeature: {
        method: 'PUT',
        name: 'updateFeature',
        uri: '/orgfeature/{orgid}/feature'
      },
      updateFeatures: {
        method: 'PUT',
        name: 'updateFeatures',
        uri: '/orgfeature/{orgid}/features'
      },
      addFeature: {
        method: 'POST',
        name: 'addFeature',
        uri: '/orgfeature/{orgid}/feature'
      },
      deleteFeature: {
        method: 'DELETE',
        name: 'deleteFeature',
        uri: '/orgfeature/{orgid}/feature/{featureId}'
      },
      projectIssue: {
        method: 'GET',
        name: 'projectIssue',
        uri: '/orgprojectissues/{orgid}/project/{projectId}/issue/{projectIssueId}'
      },
      projectIssues: {
        method: 'GET',
        name: 'projectIssues',
        uri: '/orgprojectissues/{orgid}/project/{projectId}/issues'
      },
      updateProjectIssue: {
        method: 'PUT',
        name: 'updateProjectIssue',
        uri: '/orgprojectissues/{orgid}/project/{projectId}/issue'
      },
      addProjectIssue: {
        method: 'POST',
        name: 'addProjectIssue',
        uri: '/orgprojectissues/{orgid}/project/{projectId}/issue'
      },
      deleteProjectIssue: {
        method: 'DELETE',
        name: 'deleteProjectIssue',
        uri: '/orgprojectissues/{orgid}/project/{projectId}/issue/{projectIssueId}'
      },
      projects: {
        method: 'GET',
        name: 'projects',
        uri: '/orgproject/{orgid}/projects'
      },
      updateProject: {
        method: 'PUT',
        name: 'updateProject',
        uri: '/orgproject/{orgid}/project'
      },
      addProject: {
        method: 'POST',
        name: 'addProject',
        uri: '/orgproject/{orgid}/project'
      },
      addProjects: {
        method: 'POST',
        name: 'addProjects',
        uri: '/orgproject/{orgid}/projects'
      },
      deleteProject: {
        method: 'DELETE',
        name: 'deleteProject',
        uri: '/orgproject/{orgid}/project/{id}'
      },
      importJiraProjects: {
        method: 'GET',
        name: 'importJiraProjects',
        uri: '/orgproject/{orgid}/importProjects'
      },
      signIn: {
        method: 'POST',
        name: 'signIn',
        uri: '/authorisation/auth/login'
      },
      identity: {
        method: 'GET',
        name: 'identity',
        uri: '/organisation/auth/identity'
      },
      organisations: {
        method: 'GET',
        name: 'organisations',
        uri: '/organisation/organisations'
      },
      updateOrganisation: {
        method: 'PUT',
        name: 'updateOrganisation',
        uri: '/organisation/organisation'
      },
      addOrganisation: {
        method: 'POST',
        name: 'addOrganisation',
        uri: '/authorisation/auth/register'
      },
      organisationSurveyAnswers: {
        method: 'GET',
        name: 'organisationSurveyAnswers',
        uri: '/orgsurveyanswers/{orgid}/survey/{orgSurveyId}/answers'
      },
      addOrgSurveyAnswers: {
        method: 'POST',
        name: 'addOrgSurveyAnswers',
        uri: '/orgsurveyanswers/{orgid}/survey/answers'
      },
      updateOrgSurveyAnswers: {
        method: 'PUT',
        name: 'updateOrgSurveyAnswers',
        uri: '/orgsurveyanswers/{orgid}/survey/answers'
      },
      compareOrgSurveyAnswers: {
        method: 'POST',
        name: 'compareOrgSurveyAnswers',
        uri: '/orgsurveyanswers/{orgid}/survey/answersCompareData'
      },
      employees: {
        method: 'GET',
        name: 'employees',
        uri: '/organisation/{orgid}/persons'
      },
      organisationStatistics: {
        method: 'GET',
        name: 'employees',
        uri: '/organisation/{orgid}/statistics'
      },
      updateEmployee: {
        method: 'PUT',
        name: 'updateEmployee',
        uri: '/organisation/{orgid}/person'
      },
      addEmployee: {
        method: 'POST',
        name: 'addEmployee',
        uri: '/authorisation/auth/register'
      },
      surveyQuestions: {
        method: 'GET',
        name: 'surveyQuestions',
        uri: '/survey/survey-questions'
      },
      surveys: {
        method: 'GET',
        name: 'surveys',
        uri: '/survey/surveys'
      },
      updateSurvey: {
        method: 'PUT',
        name: 'updateSurvey',
        uri: '/survey/survey'
      },
      addSurvey: {
        method: 'POST',
        name: 'addSurvey',
        uri: '/survey/survey'
      },
      surveyGroups: {
        method: 'GET',
        name: 'surveyGroups',
        uri: '/survey/survey-groups'
      },
      updateSurveyGroup: {
        method: 'PUT',
        name: 'updateSurveyGroup',
        uri: '/survey/survey-group'
      },
      addSurveyGroup: {
        method: 'POST',
        name: 'addSurveyGroup',
        uri: '/survey/survey-group'
      },
      surveyGroupQuestions: {
        method: 'GET',
        name: 'surveyGroupQuestions',
        uri: '/survey/{surveyGroupId}/survey-group-questions'
      },
      addSurveyGroupQuestion: {
        method: 'POST',
        name: 'addSurveyGroupQuestion',
        uri: '/survey/{surveyGroupId}/survey-group-question'
      },
      deleteSurveyGroupQuestion: {
        method: 'DELETE',
        name: 'addSurveyGroupQuestion',
        uri: '/survey/{surveyGroupId}/survey-group-question'
      },
      projectPrioritys: {
        method: 'GET',
        name: 'projectPrioritys',
        uri: '/orgproject/{orgid}/project/{projectId}/prioritys'
      },
      updateProjectPriority: {
        method: 'PUT',
        name: 'updateProjectPriority',
        uri: '/orgproject/{orgid}/project/{projectId}/priority'
      },
      addProjectPriority: {
        method: 'POST',
        name: 'addProjectPriority',
        uri: '/orgproject/{orgid}/project/{projectId}/priority'
      },
      deleteProjectPriority: {
        method: 'DELETE',
        name: 'deleteProjectPriority',
        uri: '/orgproject/{orgid}/project/{projectId}/priority/{id}'
      },
      updateBusPriorities: {
        method: 'PUT',
        name: 'updateBusPriorities',
        uri: '/orgproject/{orgid}/project/busPriorities'
      },
      updateCostPriorities: {
        method: 'PUT',
        name: 'updateCostPriorities',
        uri: '/orgproject/{orgid}/project/costPriorities'
      },
      security: {
        method: 'GET',
        name: 'security',
        uri: '/orgsecurity/{orgid}/security/{securityId}'
      },
      securitys: {
        method: 'GET',
        name: 'securitys',
        uri: '/orgsecurity/{orgid}/securitys'
      },
      updateSecurity: {
        method: 'PUT',
        name: 'updateSecurity',
        uri: '/orgsecurity/{orgid}/security'
      },
      addSecurity: {
        method: 'POST',
        name: 'addSecurity',
        uri: '/orgsecurity/{orgid}/security'
      },
      deleteSecurity: {
        method: 'DELETE',
        name: 'deleteSecurity',
        uri: '/orgsecurity/{orgid}/security/{securityId}'
      },
      businessUnit: {
        method: 'GET',
        name: 'businessUnit',
        uri: '/orgbusunit/{orgid}/businessUnit/{businessUnitId}'
      },
      businessUnits: {
        method: 'GET',
        name: 'businessUnits',
        uri: '/orgbusunit/{orgid}/businessUnits'
      },
      updateBusinessUnit: {
        method: 'PUT',
        name: 'updateBusinessUnit',
        uri: '/orgbusunit/{orgid}/businessUnit'
      },
      addBusinessUnit: {
        method: 'POST',
        name: 'addBusinessUnit',
        uri: '/orgbusunit/{orgid}/businessUnit'
      },
      deleteBusinessUnit: {
        method: 'DELETE',
        name: 'deleteBusinessUnit',
        uri: '/orgbusunit/{orgid}/businessUnit/{businessUnitId}'
      },
      portfolioDashboard: {
        method: 'GET',
        name: 'portfolioDashboard',
        uri: '/orgportfolio/{orgid}/portfolio/{portfolioId}/dashboard'
      },
      portfolio: {
        method: 'GET',
        name: 'portfolio',
        uri: '/orgportfolio/{orgid}/portfolio/{portfolioId}'
      },
      portfolios: {
        method: 'GET',
        name: 'portfolios',
        uri: '/orgportfolio/{orgid}/portfolios'
      },
      updatePortfolio: {
        method: 'PUT',
        name: 'updatePortfolio',
        uri: '/orgportfolio/{orgid}/portfolio'
      },
      addPortfolio: {
        method: 'POST',
        name: 'addPortfolio',
        uri: '/orgportfolio/{orgid}/portfolio'
      },
      deletePortfolio: {
        method: 'DELETE',
        name: 'deletePortfolio',
        uri: '/orgportfolio/{orgid}/portfolio/{portfolioId}'
      }
    },
    //baseUrl: 'http://localhost:8882',
    baseUrl: 'https://lambda.dyn.theoctoguide.com',
    // baseUrl: 'https://kevxw9ogqj.execute-api.ap-southeast-2.amazonaws.com/dev',
    apiKeys: {}
  }
};
exports.API_CONFIG = API_CONFIG;

var instance = _axios["default"].create({
  // baseURL: API_CONFIG.apiEndpoints.baseUrl,
  timeout: timeout,
  paramsSerializer: function paramsSerializer(params) {
    return _qs["default"].stringify(params, {
      indices: false
    });
  }
}); // request header


instance.interceptors.request.use(function (config) {
  // Do something before request is sent
  // TODO move x-api-key to config
  var apiToken = (0, _Authentication.getAuth)();
  var apiKey;
  config.baseURL = API_CONFIG.apiEndpoints.baseUrl; // need to set the apiKey for each gateway group and change the baseURL if connected to sls-offline

  if (config.url.indexOf('/authorisation/') !== -1) {
    if ((0, _environment.isSlsOffline)()) {
      config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.AUTH_OFFLINE_PORT);
    }

    apiKey = "dhJqGm5R7t3txqPDHZtPO3NXisYMNyYU4SEyZU90";
  }

  if (config.url.indexOf('/orgsecurity/') !== -1) {
    if ((0, _environment.isSlsOffline)()) {
      config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.SECURITY_OFFLINE_PORT);
    }

    apiKey = "BqKiHaIvhv5VS6mEgkEkY4sijVTpOD8K7zLUbpR6";
  }

  if (config.url.indexOf('/orgprojectissues/') !== -1) {
    if ((0, _environment.isSlsOffline)()) {
      config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.PROJECT_ISSUE_OFFLINE_PORT);
    }

    apiKey = "fbD9aQKxQh8UWCkVGV73v9LIxIwjQgsx2GMT5mZZ";
  }

  if (config.url.indexOf('/orgbusunit/') !== -1) {
    if ((0, _environment.isSlsOffline)()) {
      config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.BUSINESS_UNIT_OFFLINE_PORT);
    }

    apiKey = "Mi6aK0u7nD8h5XPlicXId1w2ymlLesq49EmfZvXB";
  }

  if (config.url.indexOf('/orgportfolio/') !== -1) {
    if ((0, _environment.isSlsOffline)()) {
      config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.PORTFOLIO_OFFLINE_PORT);
    }

    apiKey = "yHSAPZv5u92HnJ4J2kcQz2ZAzmbKKzi26UQGeur6";
  }

  if (config.url.indexOf('/orgfeature/') !== -1) {
    if ((0, _environment.isSlsOffline)()) {
      config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.FEATURE_OFFLINE_PORT);
    }

    apiKey = "Nx2WOwnI9F9sg2FdXXCZ22HT5mzSB3rm62oh26k5";
  }

  if (config.url.indexOf('/orgvaluestream/') !== -1) {
    if ((0, _environment.isSlsOffline)()) {
      config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.VALUE_STREAM_OFFLINE_PORT);
    }

    apiKey = "0X8XJe9dpU2SyzFb4JIEZ7wwOBYBtXX2aKpo109S";
  }

  if (config.url.indexOf('/orgmember/') !== -1) {
    if ((0, _environment.isSlsOffline)()) {
      config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.MEMBER_OFFLINE_PORT);
    }

    apiKey = "dLp2SSykZfaDSK8y1JqA1aEBTvBCbrV86CJLq0zv";
  }

  if (config.url.indexOf('/orgteam/') !== -1) {
    if ((0, _environment.isSlsOffline)()) {
      config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.TEAM_OFFLINE_PORT);
    }

    apiKey = "9kXVLzhNB9a8h2R2mgwz56tiZujGAcjB6ofbq5HF";
  }

  if (config.url.indexOf('/orgproduct/') !== -1) {
    if ((0, _environment.isSlsOffline)()) {
      config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.PRODUCT_OFFLINE_PORT);
    }

    apiKey = "05PXM3BIgD5WPBwMEcyrn5yv7KwSYfSXazGNVzqu";
  }

  if (config.url.indexOf('/orginitiative/') !== -1) {
    if ((0, _environment.isSlsOffline)()) {
      config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.INITIATIVE_OFFLINE_PORT);
    }

    apiKey = "MFTjQ6HDYV9QwbUtybJYr9ZRsEcjEOzD8oX5tf2e";
  }

  if (config.url.indexOf('/orgissue/') !== -1) {
    if ((0, _environment.isSlsOffline)()) {
      config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.ISSUE_OFFLINE_PORT);
    }

    apiKey = "HSpJodjZrv6lNqaDQc1Wv1w9Ba4XkRiS854nOnSy";
  }

  if (config.url.indexOf('/orgbuspriorities/') !== -1) {
    if ((0, _environment.isSlsOffline)()) {
      config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.PROJECT_BUS_PRIORITIES_OFFLINE_PORT);
    }

    apiKey = "7V9l11CTqv1EZO7qTlRLQ3P2z7BSOxw37KA2yCCn";
  }

  if (config.url.indexOf('/orgcostpriorities/') !== -1) {
    if ((0, _environment.isSlsOffline)()) {
      config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.PROJECT_COST_PRIORITY_OFFLINE_PORT);
    }

    apiKey = "SRwcRE0YKv24Khd4bXlsa6up3Vf8oATc8GpXyS9i";
  } // organisation hosts survey/answers so check for that first otherwise either org or survey endpoint
  // i.e any url that starts with /organisation/ should go here


  if (config.url.indexOf('/orgsurveyanswers/') !== -1) {
    if ((0, _environment.isSlsOffline)()) {
      config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.ORG_SURVEY_ANSWERS_OFFLINE_PORT);
    }

    apiKey = "AYTLQb71YV6t3mgj5TqlcaZtymkPRxHB15mhZdkV";
  } else if (config.url.indexOf('/orgproject/') !== -1) {
    if ((0, _environment.isSlsOffline)()) {
      config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.PROJECT_OFFLINE_PORT);
    }

    apiKey = "EF4e3MUoW58vMfwd2Xlmg81gTtu35sib2VtyxmXr";
  } else {
    if (config.url.indexOf('/organisation/') !== -1) {
      if ((0, _environment.isSlsOffline)()) {
        config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.ORG_OFFLINE_PORT);
      }

      apiKey = "g2TOFthlj51lxpWyRROSz4Z4XFtBgVcg1H8fF7VZ";
    }

    if (config.url.indexOf('/survey/') !== -1) {
      if ((0, _environment.isSlsOffline)()) {
        config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.SURVEY_OFFLINE_PORT);
      }

      apiKey = "cv7ugEk5R45FtrUmUZ2YfyvereLVyBt198bjgqi4";
    }
  } // add to any headers that already exist


  var currentHeaders = config.headers;
  config.headers = _objectSpread({}, currentHeaders, {
    'Content-Type': 'application/json',
    'x-api-key': apiKey,
    Authorization: apiToken ? apiToken : null,
    uuid: (0, _Authentication.getIdentityId)(),
    correlationid: (0, _Authentication.generateGuid)()
  });
  console.log('Starting Request', config); // TODO should not show this on live site

  return config;
}, function (error) {
  return _promise["default"].reject(error);
}); // response parse

instance.interceptors.response.use(function (response) {
  console.log('Request was successful ', JSON.stringify(response.data));
  return (0, _ApiService.parseBody)(response);
}, function (error) {
  if (error.response) {
    console.warn('Error status', error.response.status);
    console.warn('Error message', (0, _ApiService.parseError)(error.response.data));
    return (0, _ApiService.parseError)(error.response.data);
  } else {
    return _promise["default"].reject(error);
  }
});

var isMockData = function isMockData() {
  return (0, _environment.isSlsOffline)() && API_CONFIG.apiEndpoints.baseUrl === 'https://lambda.dyn.theoctoguide.com';
};

exports.isMockData = isMockData;

var endpoint = function endpoint(name) {
  var endpointConfig = API_CONFIG.apiEndpoints.endpoints[name];

  if (endpointConfig) {
    var uri = endpointConfig.uri;
    return {
      uri: uri,
      method: endpointConfig.method,
      name: endpointConfig.name
    };
  }

  return {
    uri: '',
    name: name,
    method: 'GET'
  };
};
/**
 * replace all the endpoint path parameters with their corresponding path parameter values
 * @param {*} endpoint
 * @param {*} pathParams
 * @param {*} pathParamValues
 */


exports.endpoint = endpoint;

var replaceEndpointPathParams = function replaceEndpointPathParams(endpoint, pathParams, pathParamValues) {
  var uri = endpoint;

  if (uri && pathParams && pathParamValues && (pathParams === null || pathParams === void 0 ? void 0 : pathParams.length) === (pathParamValues === null || pathParamValues === void 0 ? void 0 : pathParamValues.length)) {
    // replace all the params in the uri with corresponding values
    var count = 0;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = pathParams[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var pathParam = _step.value;

        if (pathParam) {
          uri = uri.replace('{'.concat(pathParam).concat('}'), pathParamValues[count++]);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  return uri;
};

exports.replaceEndpointPathParams = replaceEndpointPathParams;

var apiKey = function apiKey(name) {
  return API_CONFIG.apiKeys[name];
}; // export after the instance is created


exports.apiKey = apiKey;
var apiConfig = instance;
exports.apiConfig = apiConfig;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(timeout, "timeout", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiConfig.js");

  __REACT_HOT_LOADER__.register(retries, "retries", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiConfig.js");

  __REACT_HOT_LOADER__.register(API_CONFIG, "API_CONFIG", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiConfig.js");

  __REACT_HOT_LOADER__.register(instance, "instance", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiConfig.js");

  __REACT_HOT_LOADER__.register(isMockData, "isMockData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiConfig.js");

  __REACT_HOT_LOADER__.register(endpoint, "endpoint", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiConfig.js");

  __REACT_HOT_LOADER__.register(replaceEndpointPathParams, "replaceEndpointPathParams", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiConfig.js");

  __REACT_HOT_LOADER__.register(apiKey, "apiKey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiConfig.js");

  __REACT_HOT_LOADER__.register(apiConfig, "apiConfig", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiConfig.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_axios, "_axios", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiConfig.js");

  __REACT_HOT_LOADER__.register(_promise, "_promise", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiConfig.js");

  __REACT_HOT_LOADER__.register(_qs, "_qs", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiConfig.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiConfig.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiConfig.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiConfig.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiConfig.js");

  __REACT_HOT_LOADER__.register(timeout, "timeout", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiConfig.js");

  __REACT_HOT_LOADER__.register(retries, "retries", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiConfig.js");

  __REACT_HOT_LOADER__.register(API_CONFIG, "API_CONFIG", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiConfig.js");

  __REACT_HOT_LOADER__.register(instance, "instance", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiConfig.js");

  __REACT_HOT_LOADER__.register(isMockData, "isMockData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiConfig.js");

  __REACT_HOT_LOADER__.register(endpoint, "endpoint", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiConfig.js");

  __REACT_HOT_LOADER__.register(replaceEndpointPathParams, "replaceEndpointPathParams", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiConfig.js");

  __REACT_HOT_LOADER__.register(apiKey, "apiKey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiConfig.js");

  __REACT_HOT_LOADER__.register(apiConfig, "apiConfig", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiConfig.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiConfig.js");
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(315)))

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDataToSelectionData = exports.selectorByIdBuilder = void 0;

var _lodash = __webpack_require__(72);

var _sorting = __webpack_require__(259);
/**
 * Take each entry and convert it into objects that can be used by components (i.e. selectByIdModal)
 * @param {Array} source the source array
 * @param {string} idField the id field to use
 * @param {string} nameField the name field to use
 * @param {boolean} selected is the item selected
 * @returns {Array} An array of objects that contain {id: string, name: string, selected: boolean, originalValue: boolean} or the source if input params are invalid
 */


var selectorByIdBuilder = function selectorByIdBuilder(source, idField, nameField, selected) {
  try {
    if (Array.isArray(source) && idField && nameField) {
      return source.map(function (entry) {
        var id = (0, _lodash.has)(entry, idField) ? (0, _lodash.get)(entry, idField) : null;
        var name = (0, _lodash.has)(entry, nameField) ? (0, _lodash.get)(entry, nameField) : null;
        return {
          id: id,
          name: name,
          selected: selected || false,
          originalValue: selected || false
        };
      });
    }
  } catch (error) {
    console.error('Something went wrong trying to convert the source to a selectable by id array '.concat(error));
    return [];
  }

  return [];
};
/**
 * 
 * @param {*} availableSelections Array of objects that contain id, name fields
 * @param {*} currentSelections Array of id's, used to determine what is selected in availableSelections
 */


exports.selectorByIdBuilder = selectorByIdBuilder;

var mapDataToSelectionData = function mapDataToSelectionData(availableSelections, currentSelections) {
  var selectionList;
  var result = new Array();

  if (Array.isArray(availableSelections) && (availableSelections === null || availableSelections === void 0 ? void 0 : availableSelections.length) > 0) {
    var selectedList = new Array();
    var notSelectedList = new Array();

    if (Array.isArray(currentSelections) && (currentSelections === null || currentSelections === void 0 ? void 0 : currentSelections.length) > 0) {
      availableSelections === null || availableSelections === void 0 ? void 0 : availableSelections.forEach(function (selection) {
        var found = currentSelections === null || currentSelections === void 0 ? void 0 : currentSelections.find(function (element) {
          return element === (selection === null || selection === void 0 ? void 0 : selection.id);
        });

        if (found) {
          selectedList.push(selection);
        } else {
          notSelectedList.push(selection);
        }
      });
    } else {
      notSelectedList = availableSelections.slice();
    }

    selectionList = selectorByIdBuilder(selectedList, 'id', 'name', true); // sort the selections for display

    var notSelectedListSorted = (0, _sorting.sortByField)(notSelectedList, 'name');
    var mappedNotLinkedSelections = selectorByIdBuilder(notSelectedListSorted, 'id', 'name', false);
    result = selectionList.concat(mappedNotLinkedSelections);
  }

  return result;
};

exports.mapDataToSelectionData = mapDataToSelectionData;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(selectorByIdBuilder, "selectorByIdBuilder", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/selectors.js");

  __REACT_HOT_LOADER__.register(mapDataToSelectionData, "mapDataToSelectionData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/selectors.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(selectorByIdBuilder, "selectorByIdBuilder", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/selectors.js");

  __REACT_HOT_LOADER__.register(mapDataToSelectionData, "mapDataToSelectionData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/selectors.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/selectors.js");
}();

;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideIssueLoader = exports.showIssueLoader = exports.handleIssueRequestClose = exports.onToggleIssueDrawer = exports.updateSearchIssue = exports.onAllIssueSelect = exports.getUnselectedAllIssue = exports.getAllIssue = exports.filterIssue = exports.onFilterSelectedIssue = exports.onDeleteIssueSuccess = exports.onDeleteIssue = exports.onSaveIssueSuccess = exports.onSaveIssue = exports.onFilterIssueOptionSelect = exports.onIssueClose = exports.onEditIssue = exports.onAddIssue = exports.onIssueSelect = exports.addFavouriteIssueSuccess = exports.addFavouriteIssue = exports.showIssueMessage = exports.fetchIssuesSuccess = exports.fetchIssues = exports.fetchIssueSuccess = exports.fetchIssue = exports.setIssue = exports.onFetchSelectFeatureDataSuccess = exports.onFetchSelectFeatureData = exports.onIssueFeatureUpdate = void 0;

var _ActionTypes = __webpack_require__(7);

var onIssueFeatureUpdate = function onIssueFeatureUpdate() {
  return {
    type: _ActionTypes.ON_ISSUE_FEATURE_UPDATE
  };
};

exports.onIssueFeatureUpdate = onIssueFeatureUpdate;

var onFetchSelectFeatureData = function onFetchSelectFeatureData() {
  return {
    type: _ActionTypes.ON_FETCH_SELECT_FEATURE_DATA
  };
};

exports.onFetchSelectFeatureData = onFetchSelectFeatureData;

var onFetchSelectFeatureDataSuccess = function onFetchSelectFeatureDataSuccess(payload) {
  return {
    type: _ActionTypes.ON_FETCH_SELECT_FEATURE_DATA_SUCCESS,
    payload: payload
  };
};

exports.onFetchSelectFeatureDataSuccess = onFetchSelectFeatureDataSuccess;

var setIssue = function setIssue(payload) {
  return {
    type: _ActionTypes.SET_ISSUE,
    payload: payload
  };
};

exports.setIssue = setIssue;

var fetchIssue = function fetchIssue(payload) {
  return {
    type: _ActionTypes.FETCH_ISSUE,
    payload: payload
  };
};

exports.fetchIssue = fetchIssue;

var fetchIssueSuccess = function fetchIssueSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_ISSUE_SUCCESS,
    payload: payload
  };
};

exports.fetchIssueSuccess = fetchIssueSuccess;

var fetchIssues = function fetchIssues() {
  return {
    type: _ActionTypes.FETCH_ALL_ISSUE
  };
};

exports.fetchIssues = fetchIssues;

var fetchIssuesSuccess = function fetchIssuesSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_ALL_ISSUE_SUCCESS,
    payload: payload
  };
};

exports.fetchIssuesSuccess = fetchIssuesSuccess;

var showIssueMessage = function showIssueMessage(message) {
  return {
    type: _ActionTypes.SHOW_ISSUE_MESSAGE,
    payload: message
  };
};

exports.showIssueMessage = showIssueMessage;

var addFavouriteIssue = function addFavouriteIssue(payload) {
  return {
    type: _ActionTypes.ADD_FAVOURITE_ISSUE,
    payload: payload
  };
};

exports.addFavouriteIssue = addFavouriteIssue;

var addFavouriteIssueSuccess = function addFavouriteIssueSuccess(payload) {
  return {
    type: _ActionTypes.ADD_FAVOURITE_ISSUE_SUCCESS,
    payload: payload
  };
};

exports.addFavouriteIssueSuccess = addFavouriteIssueSuccess;

var onIssueSelect = function onIssueSelect(payload) {
  return {
    type: _ActionTypes.ON_ISSUE_SELECT,
    payload: payload
  };
};

exports.onIssueSelect = onIssueSelect;

var onAddIssue = function onAddIssue() {
  return {
    type: _ActionTypes.ON_ADD_ISSUE
  };
};

exports.onAddIssue = onAddIssue;

var onEditIssue = function onEditIssue(payload) {
  return {
    type: _ActionTypes.ON_EDIT_ISSUE,
    payload: payload
  };
};

exports.onEditIssue = onEditIssue;

var onIssueClose = function onIssueClose() {
  return {
    type: _ActionTypes.ON_ISSUE_CLOSE
  };
};

exports.onIssueClose = onIssueClose;

var onFilterIssueOptionSelect = function onFilterIssueOptionSelect(payload) {
  return {
    type: _ActionTypes.ON_FILTER_ISSUE_OPTION_SELECT,
    payload: payload
  };
};

exports.onFilterIssueOptionSelect = onFilterIssueOptionSelect;

var onSaveIssue = function onSaveIssue(payload) {
  return {
    type: _ActionTypes.ON_SAVE_ISSUE,
    payload: payload
  };
};

exports.onSaveIssue = onSaveIssue;

var onSaveIssueSuccess = function onSaveIssueSuccess(data) {
  return {
    type: _ActionTypes.ON_SAVE_ISSUE_SUCCESS,
    payload: data
  };
};

exports.onSaveIssueSuccess = onSaveIssueSuccess;

var onDeleteIssue = function onDeleteIssue(payload) {
  return {
    type: _ActionTypes.ON_DELETE_ISSUE,
    payload: payload
  };
};

exports.onDeleteIssue = onDeleteIssue;

var onDeleteIssueSuccess = function onDeleteIssueSuccess(payload) {
  return {
    type: _ActionTypes.ON_DELETE_ISSUE_SUCCESS,
    payload: payload
  };
};

exports.onDeleteIssueSuccess = onDeleteIssueSuccess;

var onFilterSelectedIssue = function onFilterSelectedIssue() {
  return {
    type: _ActionTypes.ON_FILTER_SELECTED_ISSUE,
    payload: ''
  };
};

exports.onFilterSelectedIssue = onFilterSelectedIssue;

var filterIssue = function filterIssue(payload) {
  return {
    type: _ActionTypes.FILTER_ISSUE,
    payload: payload
  };
};

exports.filterIssue = filterIssue;

var getAllIssue = function getAllIssue() {
  return {
    type: _ActionTypes.GET_ALL_ISSUE,
    payload: ''
  };
};

exports.getAllIssue = getAllIssue;

var getUnselectedAllIssue = function getUnselectedAllIssue() {
  return {
    type: _ActionTypes.GET_UNSELECTED_ALL_ISSUE,
    payload: ''
  };
};

exports.getUnselectedAllIssue = getUnselectedAllIssue;

var onAllIssueSelect = function onAllIssueSelect() {
  return {
    type: _ActionTypes.ON_ALL_ISSUE_SELECT,
    payload: ''
  };
};

exports.onAllIssueSelect = onAllIssueSelect;

var updateSearchIssue = function updateSearchIssue(payload) {
  return {
    type: _ActionTypes.UPDATE_SEARCH_ISSUE,
    payload: payload
  };
};

exports.updateSearchIssue = updateSearchIssue;

var onToggleIssueDrawer = function onToggleIssueDrawer() {
  return {
    type: _ActionTypes.ON_TOGGLE_ISSUE_DRAWER
  };
};

exports.onToggleIssueDrawer = onToggleIssueDrawer;

var handleIssueRequestClose = function handleIssueRequestClose() {
  return {
    type: _ActionTypes.HANDLE_ISSUE_REQUEST_CLOSE
  };
};

exports.handleIssueRequestClose = handleIssueRequestClose;

var showIssueLoader = function showIssueLoader() {
  return {
    type: _ActionTypes.SHOW_ISSUE_LOADER
  };
};

exports.showIssueLoader = showIssueLoader;

var hideIssueLoader = function hideIssueLoader() {
  return {
    type: _ActionTypes.HIDE_ISSUE_LOADER
  };
};

exports.hideIssueLoader = hideIssueLoader;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(onIssueFeatureUpdate, "onIssueFeatureUpdate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(onFetchSelectFeatureData, "onFetchSelectFeatureData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(onFetchSelectFeatureDataSuccess, "onFetchSelectFeatureDataSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(setIssue, "setIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(fetchIssue, "fetchIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(fetchIssueSuccess, "fetchIssueSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(fetchIssues, "fetchIssues", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(fetchIssuesSuccess, "fetchIssuesSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(showIssueMessage, "showIssueMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(addFavouriteIssue, "addFavouriteIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(addFavouriteIssueSuccess, "addFavouriteIssueSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(onIssueSelect, "onIssueSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(onAddIssue, "onAddIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(onEditIssue, "onEditIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(onIssueClose, "onIssueClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(onFilterIssueOptionSelect, "onFilterIssueOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(onSaveIssue, "onSaveIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(onSaveIssueSuccess, "onSaveIssueSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(onDeleteIssue, "onDeleteIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(onDeleteIssueSuccess, "onDeleteIssueSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(onFilterSelectedIssue, "onFilterSelectedIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(filterIssue, "filterIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(getAllIssue, "getAllIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllIssue, "getUnselectedAllIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(onAllIssueSelect, "onAllIssueSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(updateSearchIssue, "updateSearchIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(onToggleIssueDrawer, "onToggleIssueDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(handleIssueRequestClose, "handleIssueRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(showIssueLoader, "showIssueLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(hideIssueLoader, "hideIssueLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(onIssueFeatureUpdate, "onIssueFeatureUpdate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(onFetchSelectFeatureData, "onFetchSelectFeatureData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(onFetchSelectFeatureDataSuccess, "onFetchSelectFeatureDataSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(setIssue, "setIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(fetchIssue, "fetchIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(fetchIssueSuccess, "fetchIssueSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(fetchIssues, "fetchIssues", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(fetchIssuesSuccess, "fetchIssuesSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(showIssueMessage, "showIssueMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(addFavouriteIssue, "addFavouriteIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(addFavouriteIssueSuccess, "addFavouriteIssueSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(onIssueSelect, "onIssueSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(onAddIssue, "onAddIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(onEditIssue, "onEditIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(onIssueClose, "onIssueClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(onFilterIssueOptionSelect, "onFilterIssueOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(onSaveIssue, "onSaveIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(onSaveIssueSuccess, "onSaveIssueSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(onDeleteIssue, "onDeleteIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(onDeleteIssueSuccess, "onDeleteIssueSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(onFilterSelectedIssue, "onFilterSelectedIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(filterIssue, "filterIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(getAllIssue, "getAllIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllIssue, "getUnselectedAllIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(onAllIssueSelect, "onAllIssueSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(updateSearchIssue, "updateSearchIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(onToggleIssueDrawer, "onToggleIssueDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(handleIssueRequestClose, "handleIssueRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(showIssueLoader, "showIssueLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(hideIssueLoader, "hideIssueLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/issue.js");
}();

;

/***/ }),
/* 148 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(691);
var defined = __webpack_require__(373);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function constant() {
    return x;
  };
});


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reduce_css_calc__ = __webpack_require__(1596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reduce_css_calc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reduce_css_calc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_DataUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_DOMUtils__ = __webpack_require__(285);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }








var BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;

var calculateWordWidths = function calculateWordWidths(props) {
  try {
    var words = !__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(props.children) ? props.children.toString().split(BREAKING_SPACES) : [];
    var wordsWithComputedWidth = words.map(function (word) {
      return {
        word: word,
        width: Object(__WEBPACK_IMPORTED_MODULE_7__util_DOMUtils__["c" /* getStringSize */])(word, props.style).width
      };
    });
    var spaceWidth = Object(__WEBPACK_IMPORTED_MODULE_7__util_DOMUtils__["c" /* getStringSize */])("\xA0", props.style).width;
    return {
      wordsWithComputedWidth: wordsWithComputedWidth,
      spaceWidth: spaceWidth
    };
  } catch (e) {
    return null;
  }
};

var Text =
/*#__PURE__*/
function (_Component) {
  _inherits(Text, _Component);

  function Text(_props) {
    var _this;

    _classCallCheck(this, Text);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Text).call(this, _props));

    _this.getWordsWithoutCalculate = function (props) {
      var words = !__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(props.children) ? props.children.toString().split(BREAKING_SPACES) : [];
      return [{
        words: words
      }];
    };

    _this.state = {
      wordsByLines: _this.getWordsByLines(_props, true)
    };
    return _this;
  }

  _createClass(Text, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateWordsByLines(this.props, true);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.width !== this.props.width || prevProps.scaleToFit !== this.props.scaleToFit || prevProps.children !== this.props.children || prevProps.style !== this.props.style) {
        var needCalculate = this.props.children !== prevProps.children || this.props.style !== prevProps.style;
        this.updateWordsByLines(this.props, needCalculate);
      }
    }
  }, {
    key: "updateWordsByLines",
    value: function updateWordsByLines(props, needCalculate) {
      this.setState({
        wordsByLines: this.getWordsByLines(props, needCalculate)
      });
    }
  }, {
    key: "getWordsByLines",
    value: function getWordsByLines(props, needCalculate) {
      // Only perform calculations if using features that require them (multiline, scaleToFit)
      if ((props.width || props.scaleToFit) && !Object(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["o" /* isSsr */])()) {
        if (needCalculate) {
          var wordWidths = calculateWordWidths(props);

          if (wordWidths) {
            var wordsWithComputedWidth = wordWidths.wordsWithComputedWidth,
                spaceWidth = wordWidths.spaceWidth;
            this.wordsWithComputedWidth = wordsWithComputedWidth;
            this.spaceWidth = spaceWidth;
          } else {
            return this.getWordsWithoutCalculate(props);
          }
        }

        return this.calculateWordsByLines(this.wordsWithComputedWidth, this.spaceWidth, props.width);
      }

      return this.getWordsWithoutCalculate(props);
    }
  }, {
    key: "calculateWordsByLines",
    value: function calculateWordsByLines(wordsWithComputedWidth, spaceWidth, lineWidth) {
      var scaleToFit = this.props.scaleToFit;
      return (wordsWithComputedWidth || []).reduce(function (result, _ref) {
        var word = _ref.word,
            width = _ref.width;
        var currentLine = result[result.length - 1];

        if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < lineWidth)) {
          // Word can be added to an existing line
          currentLine.words.push(word);
          currentLine.width += width + spaceWidth;
        } else {
          // Add first word to line or word is too long to scaleToFit on existing line
          var newLine = {
            words: [word],
            width: width
          };
          result.push(newLine);
        }

        return result;
      }, []);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          dx = _this$props.dx,
          dy = _this$props.dy,
          textAnchor = _this$props.textAnchor,
          verticalAnchor = _this$props.verticalAnchor,
          scaleToFit = _this$props.scaleToFit,
          angle = _this$props.angle,
          lineHeight = _this$props.lineHeight,
          capHeight = _this$props.capHeight,
          className = _this$props.className,
          textProps = _objectWithoutProperties(_this$props, ["dx", "dy", "textAnchor", "verticalAnchor", "scaleToFit", "angle", "lineHeight", "capHeight", "className"]);

      var wordsByLines = this.state.wordsByLines;

      if (!Object(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["g" /* isNumOrStr */])(textProps.x) || !Object(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["g" /* isNumOrStr */])(textProps.y)) {
        return null;
      }

      var x = textProps.x + (Object(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["h" /* isNumber */])(dx) ? dx : 0);
      var y = textProps.y + (Object(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["h" /* isNumber */])(dy) ? dy : 0);
      var startDy;

      switch (verticalAnchor) {
        case 'start':
          startDy = __WEBPACK_IMPORTED_MODULE_3_reduce_css_calc___default()("calc(".concat(capHeight, ")"));
          break;

        case 'middle':
          startDy = __WEBPACK_IMPORTED_MODULE_3_reduce_css_calc___default()("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
          break;

        default:
          startDy = __WEBPACK_IMPORTED_MODULE_3_reduce_css_calc___default()("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
          break;
      }

      var transforms = [];

      if (scaleToFit) {
        var lineWidth = wordsByLines[0].width;
        transforms.push("scale(".concat(this.props.width / lineWidth, ")"));
      }

      if (angle) {
        transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
      }

      if (transforms.length) {
        textProps.transform = transforms.join(' ');
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text", _extends({}, Object(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["l" /* getPresentationAttributes */])(textProps), Object(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["f" /* filterEventAttributes */])(textProps), {
        x: x,
        y: y,
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('recharts-text', className),
        textAnchor: textAnchor
      }), wordsByLines.map(function (line, index) {
        return (// eslint-disable-next-line react/no-array-index-key
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan", {
            x: x,
            dy: index === 0 ? startDy : lineHeight,
            key: index
          }, line.words.join(' '))
        );
      }));
    }
  }]);

  return Text;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Text.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  scaleToFit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  angle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  textAnchor: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['start', 'middle', 'end', 'inherit']),
  verticalAnchor: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['start', 'middle', 'end']),
  style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
});
Text.defaultProps = {
  x: 0,
  y: 0,
  lineHeight: '1em',
  capHeight: '0.71em',
  // Magic number from d3
  scaleToFit: false,
  textAnchor: 'start',
  verticalAnchor: 'end' // Maintain compat with existing charts / default SVG behavior

};
/* harmony default export */ __webpack_exports__["a"] = (Text);

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
var array = Array.prototype;

var map = array.map;
var slice = array.slice;


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = linearish;
/* harmony export (immutable) */ __webpack_exports__["a"] = linear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__continuous__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__init__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tickFormat__ = __webpack_require__(762);





function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["h" /* ticks */])(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    var d = domain();
    return Object(__WEBPACK_IMPORTED_MODULE_3__tickFormat__["a" /* default */])(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain(),
        i0 = 0,
        i1 = d.length - 1,
        start = d[i0],
        stop = d[i1],
        step;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }

    step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["f" /* tickIncrement */])(start, stop, count);

    if (step > 0) {
      start = Math.floor(start / step) * step;
      stop = Math.ceil(stop / step) * step;
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["f" /* tickIncrement */])(start, stop, count);
    } else if (step < 0) {
      start = Math.ceil(start * step) / step;
      stop = Math.floor(stop * step) / step;
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["f" /* tickIncrement */])(start, stop, count);
    }

    if (step > 0) {
      d[i0] = Math.floor(start / step) * step;
      d[i1] = Math.ceil(stop / step) * step;
      domain(d);
    } else if (step < 0) {
      d[i0] = Math.ceil(start * step) / step;
      d[i1] = Math.floor(stop * step) / step;
      domain(d);
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_1__continuous__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_1__continuous__["c" /* identity */], __WEBPACK_IMPORTED_MODULE_1__continuous__["c" /* identity */]);

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_1__continuous__["a" /* copy */])(scale, linear());
  };

  __WEBPACK_IMPORTED_MODULE_2__init__["b" /* initRange */].apply(scale, arguments);

  return linearish(scale);
}


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__ = __webpack_require__(12);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Dot
 */





var Dot =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Dot, _PureComponent);

  function Dot() {
    _classCallCheck(this, Dot);

    return _possibleConstructorReturn(this, _getPrototypeOf(Dot).apply(this, arguments));
  }

  _createClass(Dot, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          cx = _this$props.cx,
          cy = _this$props.cy,
          r = _this$props.r,
          className = _this$props.className;
      var layerClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('recharts-dot', className);

      if (cx === +cx && cy === +cy && r === +r) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", _extends({}, Object(__WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["l" /* getPresentationAttributes */])(this.props), Object(__WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["f" /* filterEventAttributes */])(this.props, null, true), {
          className: layerClass,
          cx: cx,
          cy: cy,
          r: r
        }));
      }

      return null;
    }
  }]);

  return Dot;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Dot.displayName = 'Dot';
Dot.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cx: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  cy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  r: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};
/* harmony default export */ __webpack_exports__["a"] = (Dot);

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__propertyUtils__ = __webpack_require__(1752);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;

var getComputedStyleX = void 0;

// https://stackoverflow.com/a/3485654/3040605
function forceRelayout(elem) {
  var originalStyle = elem.style.display;
  elem.style.display = 'none';
  elem.offsetHeight; // eslint-disable-line
  elem.style.display = originalStyle;
}

function css(el, name, v) {
  var value = v;
  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }
    return undefined;
  }
  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value = value + 'px';
    }
    el.style[name] = value;
    return undefined;
  }
  return getComputedStyleX(el, name);
}

function getClientPosition(elem) {
  var box = void 0;
  var x = void 0;
  var y = void 0;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
  box = elem.getBoundingClientRect();

  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = box.left;
  y = box.top;

  // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.

  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.

  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;

  return {
    left: x,
    top: y
  };
}

function getScroll(w, top) {
  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
  var method = 'scroll' + (top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    // ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}

function getScrollLeft(w) {
  return getScroll(w);
}

function getScrollTop(w) {
  return getScroll(w, true);
}

function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}

/**
 * A crude way of determining if an object is a window
 * @member util
 */
function isWindow(obj) {
  // must use == for ie8
  /* eslint eqeqeq:0 */
  return obj !== null && obj !== undefined && obj == obj.window;
}

function getDocument(node) {
  if (isWindow(node)) {
    return node.document;
  }
  if (node.nodeType === 9) {
    return node;
  }
  return node.ownerDocument;
}

function _getComputedStyle(elem, name, cs) {
  var computedStyle = cs;
  var val = '';
  var d = getDocument(elem);
  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);

  // https://github.com/kissyteam/kissy/issues/61
  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }

  return val;
}

var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';

function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];

  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了

  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity
  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT];

    // prevent flashing of content
    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];

    // Put in the new values to get a computed value out
    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX;

    // Revert the changed values
    style[LEFT] = left;

    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }
  return ret === '' ? 'auto' : ret;
}

if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}

function getOffsetDirection(dir, option) {
  if (dir === 'left') {
    return option.useCssRight ? 'right' : dir;
  }
  return option.useCssBottom ? 'bottom' : dir;
}

function oppositeOffsetDirection(dir) {
  if (dir === 'left') {
    return 'right';
  } else if (dir === 'right') {
    return 'left';
  } else if (dir === 'top') {
    return 'bottom';
  } else if (dir === 'bottom') {
    return 'top';
  }
}

// 设置 elem 相对 elem.ownerDocument 的坐标
function setLeftTop(elem, offset, option) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }
  var presetH = -999;
  var presetV = -999;
  var horizontalProperty = getOffsetDirection('left', option);
  var verticalProperty = getOffsetDirection('top', option);
  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);

  if (horizontalProperty !== 'left') {
    presetH = 999;
  }

  if (verticalProperty !== 'top') {
    presetV = 999;
  }
  var originalTransition = '';
  var originalOffset = getOffset(elem);
  if ('left' in offset || 'top' in offset) {
    originalTransition = Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["c" /* getTransitionProperty */])(elem) || '';
    Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["e" /* setTransitionProperty */])(elem, 'none');
  }
  if ('left' in offset) {
    elem.style[oppositeHorizontalProperty] = '';
    elem.style[horizontalProperty] = presetH + 'px';
  }
  if ('top' in offset) {
    elem.style[oppositeVerticalProperty] = '';
    elem.style[verticalProperty] = presetV + 'px';
  }
  // force relayout
  forceRelayout(elem);
  var old = getOffset(elem);
  var originalStyle = {};
  for (var key in offset) {
    if (offset.hasOwnProperty(key)) {
      var dir = getOffsetDirection(key, option);
      var preset = key === 'left' ? presetH : presetV;
      var off = originalOffset[key] - old[key];
      if (dir === key) {
        originalStyle[dir] = preset + off;
      } else {
        originalStyle[dir] = preset - off;
      }
    }
  }
  css(elem, originalStyle);
  // force relayout
  forceRelayout(elem);
  if ('left' in offset || 'top' in offset) {
    Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["e" /* setTransitionProperty */])(elem, originalTransition);
  }
  var ret = {};
  for (var _key in offset) {
    if (offset.hasOwnProperty(_key)) {
      var _dir = getOffsetDirection(_key, option);
      var _off = offset[_key] - originalOffset[_key];
      if (_key === _dir) {
        ret[_dir] = originalStyle[_dir] + _off;
      } else {
        ret[_dir] = originalStyle[_dir] - _off;
      }
    }
  }
  css(elem, ret);
}

function setTransform(elem, offset) {
  var originalOffset = getOffset(elem);
  var originalXY = Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["b" /* getTransformXY */])(elem);
  var resultXY = { x: originalXY.x, y: originalXY.y };
  if ('left' in offset) {
    resultXY.x = originalXY.x + offset.left - originalOffset.left;
  }
  if ('top' in offset) {
    resultXY.y = originalXY.y + offset.top - originalOffset.top;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["d" /* setTransformXY */])(elem, resultXY);
}

function setOffset(elem, offset, option) {
  if (option.ignoreShake) {
    var oriOffset = getOffset(elem);

    var oLeft = oriOffset.left.toFixed(0);
    var oTop = oriOffset.top.toFixed(0);
    var tLeft = offset.left.toFixed(0);
    var tTop = offset.top.toFixed(0);

    if (oLeft === tLeft && oTop === tTop) {
      return;
    }
  }

  if (option.useCssRight || option.useCssBottom) {
    setLeftTop(elem, offset, option);
  } else if (option.useCssTransform && Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["a" /* getTransformName */])() in document.body.style) {
    setTransform(elem, offset, option);
  } else {
    setLeftTop(elem, offset, option);
  }
}

function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}

function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}

var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;

function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name = void 0;

  // Remember the old values, and insert the new ones
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }

  callback.call(elem);

  // Revert the old values
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}

function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop = void 0;
  var j = void 0;
  var i = void 0;
  for (j = 0; j < props.length; j++) {
    prop = props[j];
    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = void 0;
        if (prop === 'border') {
          cssProp = '' + prop + which[i] + 'Width';
        } else {
          cssProp = prop + which[i];
        }
        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }
  return value;
}

var domUtils = {};

each(['Width', 'Height'], function (name) {
  domUtils['doc' + name] = function (refWin) {
    var d = refWin.document;
    return Math.max(
    // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement['scroll' + name],
    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body['scroll' + name], domUtils['viewport' + name](d));
  };

  domUtils['viewport' + name] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = 'client' + name;
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop];
    // 标准模式取 documentElement
    // backcompat 取 body
    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});

/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */
function getWH(elem, name, ex) {
  var extra = ex;
  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? elem.getBoundingClientRect().width : elem.getBoundingClientRect().height;
  var computedStyle = getComputedStyleX(elem);
  var isBorderBox = isBorderBoxFn(elem, computedStyle);
  var cssBoxValue = 0;
  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
    borderBoxValue = undefined;
    // Fall back to computed then un computed css if necessary
    cssBoxValue = getComputedStyleX(elem, name);
    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    }
    // Normalize '', auto, and prepare for extra
    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }
  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }
  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;
  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which, computedStyle);
    }
    return cssBoxValue;
  } else if (borderBoxValueOrIsBorderBox) {
    if (extra === BORDER_INDEX) {
      return val;
    }
    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which, computedStyle) : getPBMWidth(elem, ['margin'], which, computedStyle));
  }
  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which, computedStyle);
}

var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
};

// fix #119 : https://github.com/kissyteam/kissy/issues/119
function getWHIgnoreDisplay() {
  for (var _len = arguments.length, args = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var val = void 0;
  var elem = args[0];
  // in case elem is window
  // elem.offsetWidth === undefined
  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }
  return val;
}

each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);
  domUtils['outer' + first] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

  domUtils[name] = function (elem, v) {
    var val = v;
    if (val !== undefined) {
      if (elem) {
        var computedStyle = getComputedStyleX(elem);
        var isBorderBox = isBorderBoxFn(elem);
        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
        }
        return css(elem, name, val);
      }
      return undefined;
    }
    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});

function mix(to, from) {
  for (var i in from) {
    if (from.hasOwnProperty(i)) {
      to[i] = from[i];
    }
  }
  return to;
}

var utils = {
  getWindow: function getWindow(node) {
    if (node && node.document && node.setTimeout) {
      return node;
    }
    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },

  getDocument: getDocument,
  offset: function offset(el, value, option) {
    if (typeof value !== 'undefined') {
      setOffset(el, value, option || {});
    } else {
      return getOffset(el);
    }
  },

  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var i = void 0;
    var ret = {};
    for (i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }
    var overflow = obj.overflow;
    if (overflow) {
      for (i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }
    return ret;
  },

  mix: mix,
  getWindowScrollLeft: function getWindowScrollLeft(w) {
    return getScrollLeft(w);
  },
  getWindowScrollTop: function getWindowScrollTop(w) {
    return getScrollTop(w);
  },
  merge: function merge() {
    var ret = {};

    for (var _len2 = arguments.length, args = Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
      args[_key3] = arguments[_key3];
    }

    for (var i = 0; i < args.length; i++) {
      utils.mix(ret, args[i]);
    }
    return ret;
  },

  viewportWidth: 0,
  viewportHeight: 0
};

mix(utils, domUtils);

/* harmony default export */ __webpack_exports__["a"] = (utils);

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clone = clone;
exports.isDate = isDate;
exports.addMonths = addMonths;
exports.isSameDay = isSameDay;
exports.isSameMonth = isSameMonth;
exports.isDayBefore = isDayBefore;
exports.isDayAfter = isDayAfter;
exports.isPastDay = isPastDay;
exports.isFutureDay = isFutureDay;
exports.isDayBetween = isDayBetween;
exports.addDayToRange = addDayToRange;
exports.isDayInRange = isDayInRange;
exports.getWeekNumber = getWeekNumber;
/**
 * Clone a date object.
 *
 * @export
 * @param  {Date} d The date to clone
 * @return {Date} The cloned date
 */
function clone(d) {
  return new Date(d.getTime());
}

/**
 * Return `true` if the passed value is a valid JavaScript Date object.
 *
 * @export
 * @param {any} value
 * @returns {Boolean}
 */
function isDate(value) {
  return value instanceof Date && !isNaN(value.valueOf());
}

/**
 * Return `d` as a new date with `n` months added.
 *
 * @export
 * @param {Date} d
 * @param {number} n
 */
function addMonths(d, n) {
  var newDate = clone(d);
  newDate.setMonth(d.getMonth() + n);
  return newDate;
}

/**
 * Return `true` if two dates are the same day, ignoring the time.
 *
 * @export
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */
function isSameDay(d1, d2) {
  if (!d1 || !d2) {
    return false;
  }
  return d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
}

/**
 * Return `true` if two dates fall in the same month.
 *
 * @export
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */
function isSameMonth(d1, d2) {
  if (!d1 || !d2) {
    return false;
  }
  return d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
}

/**
 * Returns `true` if the first day is before the second day.
 *
 * @export
 * @param {Date} d1
 * @param {Date} d2
 * @returns {Boolean}
 */
function isDayBefore(d1, d2) {
  var day1 = clone(d1).setHours(0, 0, 0, 0);
  var day2 = clone(d2).setHours(0, 0, 0, 0);
  return day1 < day2;
}

/**
 * Returns `true` if the first day is after the second day.
 *
 * @export
 * @param {Date} d1
 * @param {Date} d2
 * @returns {Boolean}
 */
function isDayAfter(d1, d2) {
  var day1 = clone(d1).setHours(0, 0, 0, 0);
  var day2 = clone(d2).setHours(0, 0, 0, 0);
  return day1 > day2;
}

/**
 * Return `true` if a day is in the past, e.g. yesterday or any day
 * before yesterday.
 *
 * @export
 * @param  {Date}  d
 * @return {Boolean}
 */
function isPastDay(d) {
  var today = new Date();
  today.setHours(0, 0, 0, 0);
  return isDayBefore(d, today);
}

/**
 * Return `true` if a day is in the future, e.g. tomorrow or any day
 * after tomorrow.
 *
 * @export
 * @param  {Date}  d
 * @return {Boolean}
 */
function isFutureDay(d) {
  var tomorrow = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
  tomorrow.setHours(0, 0, 0, 0);
  return d >= tomorrow;
}

/**
 * Return `true` if day `d` is between days `d1` and `d2`,
 * without including them.
 *
 * @export
 * @param  {Date}  d
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */
function isDayBetween(d, d1, d2) {
  var date = clone(d);
  date.setHours(0, 0, 0, 0);
  return isDayAfter(date, d1) && isDayBefore(date, d2) || isDayAfter(date, d2) && isDayBefore(date, d1);
}

/**
 * Add a day to a range and return a new range. A range is an object with
 * `from` and `to` days.
 *
 * @export
 * @param {Date} day
 * @param {Object} range
 * @return {Object} Returns a new range object
 */
function addDayToRange(day) {
  var range = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { from: null, to: null };
  var from = range.from,
      to = range.to;

  if (!from) {
    from = day;
  } else if (from && to && isSameDay(from, to) && isSameDay(day, from)) {
    from = null;
    to = null;
  } else if (to && isDayBefore(day, from)) {
    from = day;
  } else if (to && isSameDay(day, to)) {
    from = day;
    to = day;
  } else {
    to = day;
    if (isDayBefore(to, from)) {
      to = from;
      from = day;
    }
  }

  return { from: from, to: to };
}

/**
 * Return `true` if a day is included in a range of days.
 *
 * @export
 * @param  {Date}  day
 * @param  {Object}  range
 * @return {Boolean}
 */
function isDayInRange(day, range) {
  var from = range.from,
      to = range.to;

  return from && isSameDay(day, from) || to && isSameDay(day, to) || from && to && isDayBetween(day, from, to);
}

/**
 * Return the year's week number (as per ISO, i.e. with the week starting from monday)
 * for the given day.
 *
 * @export
 * @param {Date} day
 * @returns {Number}
 */
function getWeekNumber(day) {
  var date = clone(day);
  date.setHours(0, 0, 0);
  date.setDate(date.getDate() + 4 - (date.getDay() || 7));
  return Math.ceil(((date - new Date(date.getFullYear(), 0, 1)) / 8.64e7 + 1) / 7);
}

exports.default = {
  addDayToRange: addDayToRange,
  addMonths: addMonths,
  clone: clone,
  getWeekNumber: getWeekNumber,
  isDate: isDate,
  isDayAfter: isDayAfter,
  isDayBefore: isDayBefore,
  isDayBetween: isDayBetween,
  isDayInRange: isDayInRange,
  isFutureDay: isFutureDay,
  isPastDay: isPastDay,
  isSameDay: isSameDay,
  isSameMonth: isSameMonth
};
//# sourceMappingURL=DateUtils.js.map

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var BasicDetailRow = function BasicDetailRow(_ref) {
  var label = _ref.label,
      description = _ref.description;
  return _react["default"].createElement("tr", null, _react["default"].createElement("td", null, _react["default"].createElement("div", {
    className: "user-profile d-flex flex-row align-items-center"
  }, _react["default"].createElement("div", {
    className: "user-detail"
  }, _react["default"].createElement("h5", {
    className: "user-name"
  }, label, " ")))), _react["default"].createElement("td", {
    className: "text-right"
  }, _react["default"].createElement("div", null, description)));
};

var _default = BasicDetailRow;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(BasicDetailRow, "BasicDetailRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/basicDetailRow/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/basicDetailRow/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/basicDetailRow/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/basicDetailRow/index.js");

  __REACT_HOT_LOADER__.register(BasicDetailRow, "BasicDetailRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/basicDetailRow/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/basicDetailRow/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/basicDetailRow/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/basicDetailRow/index.js");
}();

;

/***/ }),
/* 158 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(635),
    baseKeys = __webpack_require__(1159),
    isArrayLike = __webpack_require__(130);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 160 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Collapsible = function (_Component) {
  _inherits(Collapsible, _Component);

  function Collapsible(props) {
    _classCallCheck(this, Collapsible);

    var _this = _possibleConstructorReturn(this, (Collapsible.__proto__ || Object.getPrototypeOf(Collapsible)).call(this, props));

    _this.timeout = undefined;

    // Bind class methods
    _this.handleTriggerClick = _this.handleTriggerClick.bind(_this);
    _this.handleTransitionEnd = _this.handleTransitionEnd.bind(_this);
    _this.continueOpenCollapsible = _this.continueOpenCollapsible.bind(_this);
    _this.setInnerRef = _this.setInnerRef.bind(_this);

    // Defaults the dropdown to be closed
    if (props.open) {
      _this.state = {
        isClosed: false,
        shouldSwitchAutoOnNextCycle: false,
        height: 'auto',
        transition: 'none',
        hasBeenOpened: true,
        overflow: props.overflowWhenOpen,
        inTransition: false
      };
    } else {
      _this.state = {
        isClosed: true,
        shouldSwitchAutoOnNextCycle: false,
        height: 0,
        transition: 'height ' + props.transitionTime + 'ms ' + props.easing,
        hasBeenOpened: false,
        overflow: 'hidden',
        inTransition: false
      };
    }
    return _this;
  }

  _createClass(Collapsible, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      if (this.state.shouldOpenOnNextCycle) {
        this.continueOpenCollapsible();
      }

      if (prevState.height === 'auto' && this.state.shouldSwitchAutoOnNextCycle === true) {
        window.clearTimeout(this.timeout);
        this.timeout = window.setTimeout(function () {
          // Set small timeout to ensure a true re-render
          _this2.setState({
            height: 0,
            overflow: 'hidden',
            isClosed: true,
            shouldSwitchAutoOnNextCycle: false
          });
        }, 50);
      }

      // If there has been a change in the open prop (controlled by accordion)
      if (prevProps.open !== this.props.open) {
        if (this.props.open === true) {
          this.openCollapsible();
          this.props.onOpening();
        } else {
          this.closeCollapsible();
          this.props.onClosing();
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.clearTimeout(this.timeout);
    }
  }, {
    key: 'closeCollapsible',
    value: function closeCollapsible() {
      this.setState({
        shouldSwitchAutoOnNextCycle: true,
        height: this.innerRef.scrollHeight,
        transition: 'height ' + (this.props.transitionCloseTime ? this.props.transitionCloseTime : this.props.transitionTime) + 'ms ' + this.props.easing,
        inTransition: true
      });
    }
  }, {
    key: 'openCollapsible',
    value: function openCollapsible() {
      this.setState({
        inTransition: true,
        shouldOpenOnNextCycle: true
      });
    }
  }, {
    key: 'continueOpenCollapsible',
    value: function continueOpenCollapsible() {
      this.setState({
        height: this.innerRef.scrollHeight,
        transition: 'height ' + this.props.transitionTime + 'ms ' + this.props.easing,
        isClosed: false,
        hasBeenOpened: true,
        inTransition: true,
        shouldOpenOnNextCycle: false
      });
    }
  }, {
    key: 'handleTriggerClick',
    value: function handleTriggerClick(event) {
      if (this.props.triggerDisabled) {
        return;
      }

      event.preventDefault();

      if (this.props.handleTriggerClick) {
        this.props.handleTriggerClick(this.props.accordionPosition);
      } else {
        if (this.state.isClosed === true) {
          this.openCollapsible();
          this.props.onOpening();
        } else {
          this.closeCollapsible();
          this.props.onClosing();
        }
      }
    }
  }, {
    key: 'renderNonClickableTriggerElement',
    value: function renderNonClickableTriggerElement() {
      if (this.props.triggerSibling && typeof this.props.triggerSibling === 'string') {
        return _react2.default.createElement(
          'span',
          { className: this.props.classParentString + '__trigger-sibling' },
          this.props.triggerSibling
        );
      } else if (this.props.triggerSibling) {
        return _react2.default.createElement(this.props.triggerSibling, null);
      }

      return null;
    }
  }, {
    key: 'handleTransitionEnd',
    value: function handleTransitionEnd() {
      // Switch to height auto to make the container responsive
      if (!this.state.isClosed) {
        this.setState({ height: 'auto', overflow: this.props.overflowWhenOpen, inTransition: false });
        this.props.onOpen();
      } else {
        this.setState({ inTransition: false });
        this.props.onClose();
      }
    }
  }, {
    key: 'setInnerRef',
    value: function setInnerRef(ref) {
      this.innerRef = ref;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var dropdownStyle = {
        height: this.state.height,
        WebkitTransition: this.state.transition,
        msTransition: this.state.transition,
        transition: this.state.transition,
        overflow: this.state.overflow
      };

      var openClass = this.state.isClosed ? 'is-closed' : 'is-open';
      var disabledClass = this.props.triggerDisabled ? 'is-disabled' : '';

      //If user wants different text when tray is open
      var trigger = this.state.isClosed === false && this.props.triggerWhenOpen !== undefined ? this.props.triggerWhenOpen : this.props.trigger;

      var ContentContainerElement = this.props.contentContainerTagName;

      // If user wants a trigger wrapping element different than 'span'
      var TriggerElement = this.props.triggerTagName;

      // Don't render children until the first opening of the Collapsible if lazy rendering is enabled
      var children = this.props.lazyRender && !this.state.hasBeenOpened && this.state.isClosed && !this.state.inTransition ? null : this.props.children;

      // Construct CSS classes strings
      var triggerClassString = this.props.classParentString + '__trigger ' + openClass + ' ' + disabledClass + ' ' + (this.state.isClosed ? this.props.triggerClassName : this.props.triggerOpenedClassName);
      var parentClassString = this.props.classParentString + ' ' + (this.state.isClosed ? this.props.className : this.props.openedClassName);
      var outerClassString = this.props.classParentString + '__contentOuter ' + this.props.contentOuterClassName;
      var innerClassString = this.props.classParentString + '__contentInner ' + this.props.contentInnerClassName;

      return _react2.default.createElement(
        ContentContainerElement,
        { className: parentClassString.trim() },
        _react2.default.createElement(
          TriggerElement,
          {
            className: triggerClassString.trim(),
            onClick: this.handleTriggerClick,
            style: this.props.triggerStyle && this.props.triggerStyle,
            onKeyPress: function onKeyPress(event) {
              var key = event.key;

              if (key === ' ' || key === 'Enter') {
                _this3.handleTriggerClick(event);
              }
            },
            tabIndex: this.props.tabIndex && this.props.tabIndex
          },
          trigger
        ),
        this.renderNonClickableTriggerElement(),
        _react2.default.createElement(
          'div',
          {
            className: outerClassString.trim(),
            style: dropdownStyle,
            onTransitionEnd: this.handleTransitionEnd,
            ref: this.setInnerRef
          },
          _react2.default.createElement(
            'div',
            {
              className: innerClassString.trim()
            },
            children
          )
        )
      );
    }
  }]);

  return Collapsible;
}(_react.Component);

Collapsible.propTypes = {
  transitionTime: _propTypes2.default.number,
  transitionCloseTime: _propTypes2.default.number,
  triggerTagName: _propTypes2.default.string,
  easing: _propTypes2.default.string,
  open: _propTypes2.default.bool,
  classParentString: _propTypes2.default.string,
  openedClassName: _propTypes2.default.string,
  triggerStyle: _propTypes2.default.object,
  triggerClassName: _propTypes2.default.string,
  triggerOpenedClassName: _propTypes2.default.string,
  contentOuterClassName: _propTypes2.default.string,
  contentInnerClassName: _propTypes2.default.string,
  accordionPosition: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  handleTriggerClick: _propTypes2.default.func,
  onOpen: _propTypes2.default.func,
  onClose: _propTypes2.default.func,
  onOpening: _propTypes2.default.func,
  onClosing: _propTypes2.default.func,
  trigger: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  triggerWhenOpen: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  triggerDisabled: _propTypes2.default.bool,
  lazyRender: _propTypes2.default.bool,
  overflowWhenOpen: _propTypes2.default.oneOf(['hidden', 'visible', 'auto', 'scroll', 'inherit', 'initial', 'unset']),
  triggerSibling: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
  tabIndex: _propTypes2.default.number,
  contentContainerTagName: _propTypes2.default.string
};

Collapsible.defaultProps = {
  transitionTime: 400,
  transitionCloseTime: null,
  triggerTagName: 'span',
  easing: 'linear',
  open: false,
  classParentString: 'Collapsible',
  triggerDisabled: false,
  lazyRender: false,
  overflowWhenOpen: 'hidden',
  openedClassName: '',
  triggerStyle: null,
  triggerClassName: '',
  triggerOpenedClassName: '',
  contentOuterClassName: '',
  contentInnerClassName: '',
  className: '',
  triggerSibling: null,
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  onOpening: function onOpening() {},
  onClosing: function onClosing() {},
  tabIndex: null,
  contentContainerTagName: 'div'
};

exports.default = Collapsible;



/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(41).f;
var has = __webpack_require__(68);
var TAG = __webpack_require__(28)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
var defined = __webpack_require__(97);
var fails = __webpack_require__(18);
var spaces = __webpack_require__(324);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(17);
var dP = __webpack_require__(41);
var DESCRIPTORS = __webpack_require__(40);
var SPECIES = __webpack_require__(28)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(59);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(78);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(314);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(111),
    isObjectLike = __webpack_require__(79);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ISSUE_TYPE_RELEASE = exports.NO_PROJECTS_TO_IMPORT = exports.HAS_PROJECTS_TO_IMPORT = exports.SETUP_IMPORT = exports.PROJECT_ISSUES_STALE_HOUR_LIMIT = exports.MAX_PROJECT_PRIORITIES = void 0;
var MAX_PROJECT_PRIORITIES = 10;
exports.MAX_PROJECT_PRIORITIES = MAX_PROJECT_PRIORITIES;
var PROJECT_ISSUES_STALE_HOUR_LIMIT = 1; // the hours that the data can sit in the local store - after this the data will be refreshed

exports.PROJECT_ISSUES_STALE_HOUR_LIMIT = PROJECT_ISSUES_STALE_HOUR_LIMIT;
var SETUP_IMPORT = 'Select a security key and then import projects';
exports.SETUP_IMPORT = SETUP_IMPORT;
var HAS_PROJECTS_TO_IMPORT = 'You have projects to import';
exports.HAS_PROJECTS_TO_IMPORT = HAS_PROJECTS_TO_IMPORT;
var NO_PROJECTS_TO_IMPORT = 'There are no new projects to import - the current list is up to date';
exports.NO_PROJECTS_TO_IMPORT = NO_PROJECTS_TO_IMPORT;
var ISSUE_TYPE_RELEASE = 'Release';
exports.ISSUE_TYPE_RELEASE = ISSUE_TYPE_RELEASE;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MAX_PROJECT_PRIORITIES, "MAX_PROJECT_PRIORITIES", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/project.js");

  __REACT_HOT_LOADER__.register(PROJECT_ISSUES_STALE_HOUR_LIMIT, "PROJECT_ISSUES_STALE_HOUR_LIMIT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/project.js");

  __REACT_HOT_LOADER__.register(SETUP_IMPORT, "SETUP_IMPORT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/project.js");

  __REACT_HOT_LOADER__.register(HAS_PROJECTS_TO_IMPORT, "HAS_PROJECTS_TO_IMPORT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/project.js");

  __REACT_HOT_LOADER__.register(NO_PROJECTS_TO_IMPORT, "NO_PROJECTS_TO_IMPORT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/project.js");

  __REACT_HOT_LOADER__.register(ISSUE_TYPE_RELEASE, "ISSUE_TYPE_RELEASE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/project.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MAX_PROJECT_PRIORITIES, "MAX_PROJECT_PRIORITIES", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/project.js");

  __REACT_HOT_LOADER__.register(PROJECT_ISSUES_STALE_HOUR_LIMIT, "PROJECT_ISSUES_STALE_HOUR_LIMIT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/project.js");

  __REACT_HOT_LOADER__.register(SETUP_IMPORT, "SETUP_IMPORT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/project.js");

  __REACT_HOT_LOADER__.register(HAS_PROJECTS_TO_IMPORT, "HAS_PROJECTS_TO_IMPORT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/project.js");

  __REACT_HOT_LOADER__.register(NO_PROJECTS_TO_IMPORT, "NO_PROJECTS_TO_IMPORT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/project.js");

  __REACT_HOT_LOADER__.register(ISSUE_TYPE_RELEASE, "ISSUE_TYPE_RELEASE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/project.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/project.js");
}();

;

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isEnd; });
/* harmony export (immutable) */ __webpack_exports__["c"] = emitter;
/* unused harmony export INVALID_BUFFER */
/* unused harmony export UNDEFINED_INPUT_ERROR */
/* harmony export (immutable) */ __webpack_exports__["b"] = channel;
/* harmony export (immutable) */ __webpack_exports__["d"] = eventChannel;
/* harmony export (immutable) */ __webpack_exports__["f"] = stdChannel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buffers__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler__ = __webpack_require__(645);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
var END = { type: CHANNEL_END_TYPE };
var isEnd = function isEnd(a) {
  return a && a.type === CHANNEL_END_TYPE;
};

function emitter() {
  var subscribers = [];

  function subscribe(sub) {
    subscribers.push(sub);
    return function () {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* remove */])(subscribers, sub);
    };
  }

  function emit(item) {
    var arr = subscribers.slice();
    for (var i = 0, len = arr.length; i < len; i++) {
      arr[i](item);
    }
  }

  return {
    subscribe: subscribe,
    emit: emit
  };
}

var INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';

if (false) {
  UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
}

function channel() {
  var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].fixed();

  var closed = false;
  var takers = [];

  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].buffer, INVALID_BUFFER);

  function checkForbiddenStates() {
    if (closed && takers.length) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__utils__["p" /* internalErr */])('Cannot have a closed channel with pending takers');
    }
    if (takers.length && !buffer.isEmpty()) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__utils__["p" /* internalErr */])('Cannot have pending takers with non empty buffer');
    }
  }

  function put(input) {
    checkForbiddenStates();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(input, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, UNDEFINED_INPUT_ERROR);
    if (closed) {
      return;
    }
    if (!takers.length) {
      return buffer.put(input);
    }
    for (var i = 0; i < takers.length; i++) {
      var cb = takers[i];
      if (!cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]] || cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]](input)) {
        takers.splice(i, 1);
        return cb(input);
      }
    }
  }

  function take(cb) {
    checkForbiddenStates();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func, "channel.take's callback must be a function");

    if (closed && buffer.isEmpty()) {
      cb(END);
    } else if (!buffer.isEmpty()) {
      cb(buffer.take());
    } else {
      takers.push(cb);
      cb.cancel = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* remove */])(takers, cb);
      };
    }
  }

  function flush(cb) {
    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func, "channel.flush' callback must be a function");
    if (closed && buffer.isEmpty()) {
      cb(END);
      return;
    }
    cb(buffer.flush());
  }

  function close() {
    checkForbiddenStates();
    if (!closed) {
      closed = true;
      if (takers.length) {
        var arr = takers;
        takers = [];
        for (var i = 0, len = arr.length; i < len; i++) {
          arr[i](END);
        }
      }
    }
  }

  return {
    take: take,
    put: put,
    flush: flush,
    close: close,
    get __takers__() {
      return takers;
    },
    get __closed__() {
      return closed;
    }
  };
}

function eventChannel(subscribe) {
  var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].none();
  var matcher = arguments[2];

  /**
    should be if(typeof matcher !== undefined) instead?
    see PR #273 for a background discussion
  **/
  if (arguments.length > 2) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func, 'Invalid match function passed to eventChannel');
  }

  var chan = channel(buffer);
  var close = function close() {
    if (!chan.__closed__) {
      if (unsubscribe) {
        unsubscribe();
      }
      chan.close();
    }
  };
  var unsubscribe = subscribe(function (input) {
    if (isEnd(input)) {
      close();
      return;
    }
    if (matcher && !matcher(input)) {
      return;
    }
    chan.put(input);
  });
  if (chan.__closed__) {
    unsubscribe();
  }

  if (!__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(unsubscribe)) {
    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
  }

  return {
    take: chan.take,
    flush: chan.flush,
    close: close
  };
}

function stdChannel(subscribe) {
  var chan = eventChannel(function (cb) {
    return subscribe(function (input) {
      if (input[__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* SAGA_ACTION */]]) {
        cb(input);
        return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_2__scheduler__["a" /* asap */])(function () {
        return cb(input);
      });
    });
  });

  return _extends({}, chan, {
    take: function take(cb, matcher) {
      if (arguments.length > 1) {
        Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func, "channel.take's matcher argument must be a function");
        cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]] = matcher;
      }
      chan.take(cb);
    }
  });
}

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideEmpDashboardLoader = exports.showEmpDashboardLoader = exports.saveEmpSurveyAnswers = exports.fetchEmpSurveyAnswersSuccess = exports.fetchEmpSurveyAnswers = exports.hideEmpLoader = exports.showEmpLoader = exports.handleEmpRequestClose = exports.onToggleEmpDrawer = exports.updateSearchEmp = exports.onAllEmpSelect = exports.getUnselectedAllEmp = exports.getAllEmp = exports.filterEmp = exports.onDeleteSelectedEmp = exports.onDeleteEmp = exports.onSaveEmpSuccess = exports.onSaveEmp = exports.onFilterEmpOptionSelect = exports.onEmpClose = exports.onAddEmp = exports.onEmpSelect = exports.addFavouriteEmpSuccess = exports.addFavouriteEmp = exports.showEmpMessage = exports.fetchEmpsSuccess = exports.fetchEmps = exports.fetchNotificationsSuccess = exports.fetchNotifications = void 0;

var _ActionTypes = __webpack_require__(7);

var fetchNotifications = function fetchNotifications(payload) {
  return {
    type: _ActionTypes.FETCH_NOTIFICATIONS,
    payload: payload
  };
};

exports.fetchNotifications = fetchNotifications;

var fetchNotificationsSuccess = function fetchNotificationsSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_NOTIFICATIONS_SUCCESS,
    payload: payload
  };
};

exports.fetchNotificationsSuccess = fetchNotificationsSuccess;

var fetchEmps = function fetchEmps() {
  return {
    type: _ActionTypes.FETCH_ALL_EMP
  };
};

exports.fetchEmps = fetchEmps;

var fetchEmpsSuccess = function fetchEmpsSuccess(emps) {
  return {
    type: _ActionTypes.FETCH_ALL_EMP_SUCCESS,
    payload: emps
  };
};

exports.fetchEmpsSuccess = fetchEmpsSuccess;

var showEmpMessage = function showEmpMessage(message) {
  return {
    type: _ActionTypes.SHOW_EMP_MESSAGE,
    payload: message
  };
};

exports.showEmpMessage = showEmpMessage;

var addFavouriteEmp = function addFavouriteEmp(data) {
  return {
    type: _ActionTypes.ADD_FAVOURITE_EMP,
    payload: data
  };
};

exports.addFavouriteEmp = addFavouriteEmp;

var addFavouriteEmpSuccess = function addFavouriteEmpSuccess(payload) {
  return {
    type: _ActionTypes.ADD_FAVOURITE_EMP_SUCCESS,
    payload: payload
  };
};

exports.addFavouriteEmpSuccess = addFavouriteEmpSuccess;

var onEmpSelect = function onEmpSelect(data) {
  return {
    type: _ActionTypes.ON_EMP_SELECT,
    payload: data
  };
};

exports.onEmpSelect = onEmpSelect;

var onAddEmp = function onAddEmp() {
  return {
    type: _ActionTypes.ON_ADD_EMP,
    payload: ''
  };
};

exports.onAddEmp = onAddEmp;

var onEmpClose = function onEmpClose() {
  return {
    type: _ActionTypes.ON_EMP_CLOSE,
    payload: ''
  };
};

exports.onEmpClose = onEmpClose;

var onFilterEmpOptionSelect = function onFilterEmpOptionSelect(option) {
  return {
    type: _ActionTypes.ON_FILTER_EMP_OPTION_SELECT,
    payload: option
  };
};

exports.onFilterEmpOptionSelect = onFilterEmpOptionSelect;

var onSaveEmp = function onSaveEmp(data) {
  return {
    type: _ActionTypes.ON_SAVE_EMP,
    payload: data
  };
};

exports.onSaveEmp = onSaveEmp;

var onSaveEmpSuccess = function onSaveEmpSuccess(data) {
  return {
    type: _ActionTypes.ON_SAVE_EMP_SUCCESS,
    payload: data
  };
};

exports.onSaveEmpSuccess = onSaveEmpSuccess;

var onDeleteEmp = function onDeleteEmp(data) {
  return {
    type: _ActionTypes.ON_DELETE_EMP,
    payload: data
  };
};

exports.onDeleteEmp = onDeleteEmp;

var onDeleteSelectedEmp = function onDeleteSelectedEmp() {
  return {
    type: _ActionTypes.ON_DELETE_SELECTED_EMP,
    payload: ''
  };
};

exports.onDeleteSelectedEmp = onDeleteSelectedEmp;

var filterEmp = function filterEmp(userName) {
  return {
    type: _ActionTypes.FILTER_EMP,
    payload: userName
  };
};

exports.filterEmp = filterEmp;

var getAllEmp = function getAllEmp() {
  return {
    type: _ActionTypes.GET_ALL_EMP,
    payload: ''
  };
};

exports.getAllEmp = getAllEmp;

var getUnselectedAllEmp = function getUnselectedAllEmp() {
  return {
    type: _ActionTypes.GET_UNSELECTED_ALL_EMP,
    payload: ''
  };
};

exports.getUnselectedAllEmp = getUnselectedAllEmp;

var onAllEmpSelect = function onAllEmpSelect() {
  return {
    type: _ActionTypes.ON_ALL_EMP_SELECT,
    payload: ''
  };
};

exports.onAllEmpSelect = onAllEmpSelect;

var updateSearchEmp = function updateSearchEmp(userName) {
  return {
    type: _ActionTypes.UPDATE_SEARCH_EMP,
    payload: userName
  };
};

exports.updateSearchEmp = updateSearchEmp;

var onToggleEmpDrawer = function onToggleEmpDrawer() {
  return {
    type: _ActionTypes.ON_TOGGLE_EMP_DRAWER
  };
};

exports.onToggleEmpDrawer = onToggleEmpDrawer;

var handleEmpRequestClose = function handleEmpRequestClose() {
  return {
    type: _ActionTypes.HANDLE_EMP_REQUEST_CLOSE
  };
};

exports.handleEmpRequestClose = handleEmpRequestClose;

var showEmpLoader = function showEmpLoader() {
  return {
    type: _ActionTypes.SHOW_EMP_LOADER
  };
};

exports.showEmpLoader = showEmpLoader;

var hideEmpLoader = function hideEmpLoader() {
  return {
    type: _ActionTypes.HIDE_EMP_LOADER
  };
};

exports.hideEmpLoader = hideEmpLoader;

var fetchEmpSurveyAnswers = function fetchEmpSurveyAnswers(payload) {
  return {
    type: _ActionTypes.FETCH_EMP_SURVEY_ANSWERS,
    payload: payload
  };
};

exports.fetchEmpSurveyAnswers = fetchEmpSurveyAnswers;

var fetchEmpSurveyAnswersSuccess = function fetchEmpSurveyAnswersSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_EMP_SURVEY_ANSWERS_SUCCESS,
    payload: payload
  };
};

exports.fetchEmpSurveyAnswersSuccess = fetchEmpSurveyAnswersSuccess;

var saveEmpSurveyAnswers = function saveEmpSurveyAnswers(payload) {
  return {
    type: _ActionTypes.SAVE_EMP_SURVEY_ANSWERS,
    payload: payload
  };
};

exports.saveEmpSurveyAnswers = saveEmpSurveyAnswers;

var showEmpDashboardLoader = function showEmpDashboardLoader() {
  return {
    type: _ActionTypes.SHOW_EMP_DASHBOARD_LOADER
  };
};

exports.showEmpDashboardLoader = showEmpDashboardLoader;

var hideEmpDashboardLoader = function hideEmpDashboardLoader() {
  return {
    type: _ActionTypes.HIDE_EMP_DASHBOARD_LOADER
  };
}; // use onSaveOrgSuveryAnswers to save employee survey results


exports.hideEmpDashboardLoader = hideEmpDashboardLoader;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchNotifications, "fetchNotifications", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(fetchNotificationsSuccess, "fetchNotificationsSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(fetchEmps, "fetchEmps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(fetchEmpsSuccess, "fetchEmpsSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(showEmpMessage, "showEmpMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(addFavouriteEmp, "addFavouriteEmp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(addFavouriteEmpSuccess, "addFavouriteEmpSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(onEmpSelect, "onEmpSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(onAddEmp, "onAddEmp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(onEmpClose, "onEmpClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(onFilterEmpOptionSelect, "onFilterEmpOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(onSaveEmp, "onSaveEmp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(onSaveEmpSuccess, "onSaveEmpSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(onDeleteEmp, "onDeleteEmp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(onDeleteSelectedEmp, "onDeleteSelectedEmp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(filterEmp, "filterEmp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(getAllEmp, "getAllEmp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllEmp, "getUnselectedAllEmp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(onAllEmpSelect, "onAllEmpSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(updateSearchEmp, "updateSearchEmp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(onToggleEmpDrawer, "onToggleEmpDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(handleEmpRequestClose, "handleEmpRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(showEmpLoader, "showEmpLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(hideEmpLoader, "hideEmpLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(fetchEmpSurveyAnswers, "fetchEmpSurveyAnswers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(fetchEmpSurveyAnswersSuccess, "fetchEmpSurveyAnswersSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(saveEmpSurveyAnswers, "saveEmpSurveyAnswers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(showEmpDashboardLoader, "showEmpDashboardLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(hideEmpDashboardLoader, "hideEmpDashboardLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchNotifications, "fetchNotifications", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(fetchNotificationsSuccess, "fetchNotificationsSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(fetchEmps, "fetchEmps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(fetchEmpsSuccess, "fetchEmpsSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(showEmpMessage, "showEmpMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(addFavouriteEmp, "addFavouriteEmp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(addFavouriteEmpSuccess, "addFavouriteEmpSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(onEmpSelect, "onEmpSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(onAddEmp, "onAddEmp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(onEmpClose, "onEmpClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(onFilterEmpOptionSelect, "onFilterEmpOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(onSaveEmp, "onSaveEmp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(onSaveEmpSuccess, "onSaveEmpSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(onDeleteEmp, "onDeleteEmp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(onDeleteSelectedEmp, "onDeleteSelectedEmp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(filterEmp, "filterEmp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(getAllEmp, "getAllEmp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllEmp, "getUnselectedAllEmp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(onAllEmpSelect, "onAllEmpSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(updateSearchEmp, "updateSearchEmp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(onToggleEmpDrawer, "onToggleEmpDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(handleEmpRequestClose, "handleEmpRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(showEmpLoader, "showEmpLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(hideEmpLoader, "hideEmpLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(fetchEmpSurveyAnswers, "fetchEmpSurveyAnswers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(fetchEmpSurveyAnswersSuccess, "fetchEmpSurveyAnswersSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(saveEmpSurveyAnswers, "saveEmpSurveyAnswers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(showEmpDashboardLoader, "showEmpDashboardLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(hideEmpDashboardLoader, "hideEmpDashboardLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Employee.js");
}();

;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(656);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._40 = 0;
  this._65 = 0;
  this._55 = null;
  this._72 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._37 = null;
Promise._87 = null;
Promise._61 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._65 === 3) {
    self = self._55;
  }
  if (Promise._37) {
    Promise._37(self);
  }
  if (self._65 === 0) {
    if (self._40 === 0) {
      self._40 = 1;
      self._72 = deferred;
      return;
    }
    if (self._40 === 1) {
      self._40 = 2;
      self._72 = [self._72, deferred];
      return;
    }
    self._72.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._65 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._65 === 1) {
        resolve(deferred.promise, self._55);
      } else {
        reject(deferred.promise, self._55);
      }
      return;
    }
    var ret = tryCallOne(cb, self._55);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._65 = 3;
      self._55 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._65 = 1;
  self._55 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._65 = 2;
  self._55 = newValue;
  if (Promise._87) {
    Promise._87(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._40 === 1) {
    handle(self, self._72);
    self._72 = null;
  }
  if (self._40 === 2) {
    for (var i = 0; i < self._72.length; i++) {
      handle(self, self._72[i]);
    }
    self._72 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapProjectDependenciesToSelectionData = exports.mapProjectOutwardDependenciesToSelectionData = exports.mapProjectInwardDependenciesToSelectionData = exports.mapIssuesDependenciesToDisplayData = exports.mapIssuesOutwardDependenciesToDisplayData = exports.mapIssuesInwardDependenciesToDisplayData = exports.sanitizeProjectCache = exports.projectCacheExpired = exports.getProjectDisplayData = exports.getActiveProjects = exports.getImportProjectList = exports.sortProjectPrioritiesByValue = exports.sortProjectsByWeight = exports.calculateWeight = void 0;

var _lodash = __webpack_require__(72);

var _DateFormatters = __webpack_require__(43);

var _NumberFormatters = __webpack_require__(99);

var _DateService = __webpack_require__(48);

var _environment = __webpack_require__(360);

var _selectors = __webpack_require__(146);

var _arrayService = __webpack_require__(34);

var _sorting = __webpack_require__(259);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 * calculate the new weight based on the project priorities
 * TODO - move calc to the server - done on saveProject and deleteProjectPriorities
 * @param {*} project 
 */


var calculateWeight = function calculateWeight(project) {
  var updatedProject;

  if (project) {
    // calculate the new weight here
    updatedProject = _objectSpread({}, project, {
      weight: 50
    });
  }

  return updatedProject;
};
/**
 * sort project by weight - lowest first - call Array.reverse() to reverse the order
 * @param {*} projects 
 */


exports.calculateWeight = calculateWeight;

var sortProjectsByWeight = function sortProjectsByWeight(projects) {
  var sortedData = [];

  if (projects) {
    sortedData = (0, _lodash.sortBy)(projects, [function (o) {
      return o.weight;
    }]);
  }

  return sortedData;
};

exports.sortProjectsByWeight = sortProjectsByWeight;

var sortProjectPrioritiesByValue = function sortProjectPrioritiesByValue(priorities) {
  var sortedData = [];

  if (priorities) {
    sortedData = (0, _lodash.sortBy)(priorities, [function (o) {
      return o.value;
    }]);
  }

  return sortedData;
};

exports.sortProjectPrioritiesByValue = sortProjectPrioritiesByValue;

var getImportProjectList = function getImportProjectList(importedProjects, allProjects) {
  if (Array.isArray(importedProjects) && Array.isArray(allProjects)) {
    return importedProjects.filter(function (imported) {
      return !allProjects.find(function (project) {
        var _project$jiraProjectA;

        return (imported === null || imported === void 0 ? void 0 : imported.id) === (project === null || project === void 0 ? void 0 : (_project$jiraProjectA = project.jiraProjectAttributes) === null || _project$jiraProjectA === void 0 ? void 0 : _project$jiraProjectA.id);
      });
    });
  }

  return [];
};
/**
 * Active if the end date is before the current date
 * @param {*} projectList 
 */


exports.getImportProjectList = getImportProjectList;

var getActiveProjects = function getActiveProjects(projectList) {
  var currentDateFormatted = (0, _DateFormatters.formatDateDefault)(new Date());
  var activeProjects = projectList === null || projectList === void 0 ? void 0 : projectList.filter(function (project) {
    var endDateFormatted = (0, _DateFormatters.formatDateDefault)(project.endDate);
    var startDateFormatted = (0, _DateFormatters.formatDateDefault)(project === null || project === void 0 ? void 0 : project.startDate);
    var datesEqual = endDateFormatted === startDateFormatted;
    var dateBefore = (0, _DateService.isDateBefore)(endDateFormatted, currentDateFormatted);
    return dateBefore || datesEqual;
  });
  return activeProjects;
};

exports.getActiveProjects = getActiveProjects;

var getProjectDisplayData = function getProjectDisplayData(project) {
  var displayData = {};

  if (project) {
    displayData = {
      id: project === null || project === void 0 ? void 0 : project.id,
      summary: (project === null || project === void 0 ? void 0 : project.name) ? project === null || project === void 0 ? void 0 : project.name : 'No name specified',
      description: (project === null || project === void 0 ? void 0 : project.description) ? project === null || project === void 0 ? void 0 : project.description : 'No description specified',
      weight: project === null || project === void 0 ? void 0 : project.weight,
      startDate: (0, _DateFormatters.formatDateDefault)(project === null || project === void 0 ? void 0 : project.startDate),
      endDate: (project === null || project === void 0 ? void 0 : project.endDate) ? (0, _DateFormatters.formatDateDefault)(project === null || project === void 0 ? void 0 : project.endDate) : 'This project has no end date specified',
      budget: (project === null || project === void 0 ? void 0 : project.budget) ? (0, _NumberFormatters.formatBalance)(project === null || project === void 0 ? void 0 : project.budget) : (0, _NumberFormatters.formatBalance)(0),
      businessValue: (project === null || project === void 0 ? void 0 : project.businessValue) ? project === null || project === void 0 ? void 0 : project.businessValue : 'Not specifed'
    };
  }

  return displayData;
};
/**
 * Check if date is between now and an expiry date that is set in the env prop PROJECT_CACHE_EXPIRY
 * @param {*} testDateTime 
 */


exports.getProjectDisplayData = getProjectDisplayData;

var projectCacheExpired =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(testDateTime) {
    var now, expiryDate;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!testDateTime) {
              _context.next = 4;
              break;
            }

            now = new Date();
            expiryDate = new Date().setMinutes(now.getMinutes() - (0, _environment.getProjectCacheExpiry)());
            return _context.abrupt("return", !(0, _DateService.isDateTimeBetween)(now, expiryDate, testDateTime));

          case 4:
            return _context.abrupt("return", true);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function projectCacheExpired(_x) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * Check each project cache entry if the date is between now and an expiry date that is set in the env prop PROJECT_CACHE_EXPIRY
 * @param {Array} cache 
 */


exports.projectCacheExpired = projectCacheExpired;

var sanitizeProjectCache =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(cache) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!Array.isArray(cache)) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", cache.filter(function (cacheEntry) {
              return !projectCacheExpired(cacheEntry === null || cacheEntry === void 0 ? void 0 : cacheEntry.lastUpdated);
            }));

          case 2:
            return _context2.abrupt("return", []);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function sanitizeProjectCache(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

exports.sanitizeProjectCache = sanitizeProjectCache;

var mapIssuesInwardDependenciesToDisplayData = function mapIssuesInwardDependenciesToDisplayData(allProjects, project) {
  return mapIssuesDependenciesToDisplayData(allProjects, project, true);
};

exports.mapIssuesInwardDependenciesToDisplayData = mapIssuesInwardDependenciesToDisplayData;

var mapIssuesOutwardDependenciesToDisplayData = function mapIssuesOutwardDependenciesToDisplayData(allProjects, project) {
  return mapIssuesDependenciesToDisplayData(allProjects, project, false);
};

exports.mapIssuesOutwardDependenciesToDisplayData = mapIssuesOutwardDependenciesToDisplayData;

var mapIssuesDependenciesToDisplayData = function mapIssuesDependenciesToDisplayData(allProjects, project, inward) {
  var _project$projectlinks;

  var projectDependencyData;

  if (Array.isArray(project === null || project === void 0 ? void 0 : project.projectlinks) && (project === null || project === void 0 ? void 0 : (_project$projectlinks = project.projectlinks) === null || _project$projectlinks === void 0 ? void 0 : _project$projectlinks.length) > 0) {
    var _project$projectlinks2;

    projectDependencyData = new Array();
    project === null || project === void 0 ? void 0 : (_project$projectlinks2 = project.projectlinks) === null || _project$projectlinks2 === void 0 ? void 0 : _project$projectlinks2.map(function (link) {
      var linkedProjectId = 0;

      if (inward) {
        if ((link === null || link === void 0 ? void 0 : link.inwardProject) !== undefined) {
          var _link$inwardProject;

          linkedProjectId = link === null || link === void 0 ? void 0 : (_link$inwardProject = link.inwardProject) === null || _link$inwardProject === void 0 ? void 0 : _link$inwardProject.id;
        }
      } else {
        if ((link === null || link === void 0 ? void 0 : link.outwardProject) !== undefined) {
          var _link$outwardProject;

          linkedProjectId = link === null || link === void 0 ? void 0 : (_link$outwardProject = link.outwardProject) === null || _link$outwardProject === void 0 ? void 0 : _link$outwardProject.id;
        }
      }

      var foundProject = allProjects === null || allProjects === void 0 ? void 0 : allProjects.find(function (element) {
        return (element === null || element === void 0 ? void 0 : element.id) === linkedProjectId;
      });

      if (foundProject) {
        projectDependencyData.push(getProjectDisplayData(foundProject));
      }
    });
  }

  return projectDependencyData;
};

exports.mapIssuesDependenciesToDisplayData = mapIssuesDependenciesToDisplayData;

var mapProjectInwardDependenciesToSelectionData = function mapProjectInwardDependenciesToSelectionData(allProjects, project) {
  return mapProjectDependenciesToSelectionData(allProjects, project, true);
};

exports.mapProjectInwardDependenciesToSelectionData = mapProjectInwardDependenciesToSelectionData;

var mapProjectOutwardDependenciesToSelectionData = function mapProjectOutwardDependenciesToSelectionData(allProjects, project) {
  return mapProjectDependenciesToSelectionData(allProjects, project, false);
};
/**
 * turn project dependencies into a selectable list for use in the project select dependency screens
 * UPDATE - projects will not be linked in this way - code may be redundant - TBC
 * @param {*} allProjects 
 * @param {*} project 
 * @param {*} inward 
 */


exports.mapProjectOutwardDependenciesToSelectionData = mapProjectOutwardDependenciesToSelectionData;

var mapProjectDependenciesToSelectionData = function mapProjectDependenciesToSelectionData(allProjects, project, inward) {
  var _project$issuelinks;

  var projectSelectionList;
  var result;

  if (Array.isArray(project === null || project === void 0 ? void 0 : project.issuelinks) && (project === null || project === void 0 ? void 0 : (_project$issuelinks = project.issuelinks) === null || _project$issuelinks === void 0 ? void 0 : _project$issuelinks.length) > 0) {
    var _project$issuelinks2;

    var projectLinkedList = new Array();
    project === null || project === void 0 ? void 0 : (_project$issuelinks2 = project.issuelinks) === null || _project$issuelinks2 === void 0 ? void 0 : _project$issuelinks2.map(function (link) {
      var linkedId;

      if (inward) {
        if ((0, _lodash.has)(link, 'inwardProject')) {
          var _link$inwardProject2;

          linkedId = link === null || link === void 0 ? void 0 : (_link$inwardProject2 = link.inwardProject) === null || _link$inwardProject2 === void 0 ? void 0 : _link$inwardProject2.id;
        }
      } else {
        if ((0, _lodash.has)(link, 'outwardProject')) {
          var _link$outwardProject2;

          linkedId = link === null || link === void 0 ? void 0 : (_link$outwardProject2 = link.outwardProject) === null || _link$outwardProject2 === void 0 ? void 0 : _link$outwardProject2.id;
        }
      }

      if (linkedId) {
        var foundProject = allProjects === null || allProjects === void 0 ? void 0 : allProjects.find(function (element) {
          return (element === null || element === void 0 ? void 0 : element.id) === linkedId;
        });
        projectLinkedList.push(foundProject);
      }

      projectSelectionList = (0, _selectors.selectorByIdBuilder)(projectLinkedList, 'id', 'name', true);
    }); // need to remove the current project from the allProjects list

    var selectableProjects = allProjects.filter(function (entry) {
      return (entry === null || entry === void 0 ? void 0 : entry.id) !== (project === null || project === void 0 ? void 0 : project.id);
    });
    var nonLinkedProjects = (0, _arrayService.uniqueSymmetricDifference)(selectableProjects, projectSelectionList); // sort the projects for display

    var nonLinkedprojectsSorted = (0, _sorting.sortByName)(nonLinkedProjects); // now convert for selection

    var mappedNoLinkedProjects = (0, _selectors.selectorByIdBuilder)(nonLinkedprojectsSorted, 'id', 'name', false);
    result = projectSelectionList.concat(mappedNoLinkedProjects);
  }

  return result;
};

exports.mapProjectDependenciesToSelectionData = mapProjectDependenciesToSelectionData;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(calculateWeight, "calculateWeight", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectService.js");

  __REACT_HOT_LOADER__.register(sortProjectsByWeight, "sortProjectsByWeight", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectService.js");

  __REACT_HOT_LOADER__.register(sortProjectPrioritiesByValue, "sortProjectPrioritiesByValue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectService.js");

  __REACT_HOT_LOADER__.register(getImportProjectList, "getImportProjectList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectService.js");

  __REACT_HOT_LOADER__.register(getActiveProjects, "getActiveProjects", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectService.js");

  __REACT_HOT_LOADER__.register(getProjectDisplayData, "getProjectDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectService.js");

  __REACT_HOT_LOADER__.register(projectCacheExpired, "projectCacheExpired", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectService.js");

  __REACT_HOT_LOADER__.register(sanitizeProjectCache, "sanitizeProjectCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectService.js");

  __REACT_HOT_LOADER__.register(mapIssuesInwardDependenciesToDisplayData, "mapIssuesInwardDependenciesToDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectService.js");

  __REACT_HOT_LOADER__.register(mapIssuesOutwardDependenciesToDisplayData, "mapIssuesOutwardDependenciesToDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectService.js");

  __REACT_HOT_LOADER__.register(mapIssuesDependenciesToDisplayData, "mapIssuesDependenciesToDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectService.js");

  __REACT_HOT_LOADER__.register(mapProjectInwardDependenciesToSelectionData, "mapProjectInwardDependenciesToSelectionData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectService.js");

  __REACT_HOT_LOADER__.register(mapProjectOutwardDependenciesToSelectionData, "mapProjectOutwardDependenciesToSelectionData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectService.js");

  __REACT_HOT_LOADER__.register(mapProjectDependenciesToSelectionData, "mapProjectDependenciesToSelectionData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectService.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(asyncGeneratorStep, "asyncGeneratorStep", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectService.js");

  __REACT_HOT_LOADER__.register(_asyncToGenerator, "_asyncToGenerator", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectService.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectService.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectService.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectService.js");

  __REACT_HOT_LOADER__.register(calculateWeight, "calculateWeight", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectService.js");

  __REACT_HOT_LOADER__.register(sortProjectsByWeight, "sortProjectsByWeight", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectService.js");

  __REACT_HOT_LOADER__.register(sortProjectPrioritiesByValue, "sortProjectPrioritiesByValue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectService.js");

  __REACT_HOT_LOADER__.register(getImportProjectList, "getImportProjectList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectService.js");

  __REACT_HOT_LOADER__.register(getActiveProjects, "getActiveProjects", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectService.js");

  __REACT_HOT_LOADER__.register(getProjectDisplayData, "getProjectDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectService.js");

  __REACT_HOT_LOADER__.register(projectCacheExpired, "projectCacheExpired", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectService.js");

  __REACT_HOT_LOADER__.register(sanitizeProjectCache, "sanitizeProjectCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectService.js");

  __REACT_HOT_LOADER__.register(mapIssuesInwardDependenciesToDisplayData, "mapIssuesInwardDependenciesToDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectService.js");

  __REACT_HOT_LOADER__.register(mapIssuesOutwardDependenciesToDisplayData, "mapIssuesOutwardDependenciesToDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectService.js");

  __REACT_HOT_LOADER__.register(mapIssuesDependenciesToDisplayData, "mapIssuesDependenciesToDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectService.js");

  __REACT_HOT_LOADER__.register(mapProjectInwardDependenciesToSelectionData, "mapProjectInwardDependenciesToSelectionData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectService.js");

  __REACT_HOT_LOADER__.register(mapProjectOutwardDependenciesToSelectionData, "mapProjectOutwardDependenciesToSelectionData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectService.js");

  __REACT_HOT_LOADER__.register(mapProjectDependenciesToSelectionData, "mapProjectDependenciesToSelectionData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectService.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectService.js");
}();

;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCompareOrgSurveyAnswers = exports.prepareOrgSurveyAnswerSagaCall = exports.prepareOrgSurveyAnswerSagaCalls = exports.sortBottomEngagementData = exports.sortTopEngagementData = exports.extractOrgSurveySimpleChartData = exports.extractOrgSurveyResponseData = exports.extractOrgSurveyBottomResponseData = exports.extractOrgSurveyTopResponseData = exports.extractOrgSurveyDistributionsData = exports.extractOrgSurveyRadarData = exports.extractOrgSurveyCommonChartData = exports.extractOrgSurveyCompareData = exports.initialiseOrgSurveysCompareList = exports.surveyActive = exports.surveyComplete = exports.empSurveySummaryStatistics = exports.getEmpSurveyAnswers = exports.createDefaultOrgSurveyAnswers = exports.buildEmpSurveyAnswers = exports.getOrgSurveyPercentCompleteByEmployee = exports.getOrgSurveyPercentComplete = exports.getSurveyById = exports.getActiveSurveyById = exports.getActiveSurveysCount = exports.getInactiveSurveysCount = exports.getInactiveSurveys = exports.getActiveSurveys = void 0;

var _effects = __webpack_require__(15);

var _NumberFormatters = __webpack_require__(99);

var _DateService = __webpack_require__(48);

var _DateFormatters = __webpack_require__(43);

var _lodash = __webpack_require__(72);

var _ApiService = __webpack_require__(16);

var _api = __webpack_require__(25);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var TOP_BOTTOM_THRESHOLD = 5; // {
//     "surveys": [
//         {
//             "id": "634d1475334f91eeedf1e03b20190525",
//             "name": "Happy survey time",
//             "surveyId": "dc00cc7175004a68df46359b20190618",
//             "endDate": "08/08/2020",
//             "startDate": "07/07/2018"
//         }
//     ],
//     "id": "634d1475334f91eeedf1e03b20190524",
//     "email": "cpsolutions28@gmail.com",
//     "name": "Super Happy Org ADMIN",
// }
// [
//     {
//         "id": "883r1475334f91eeedf1e03b20190999",
//         "orgid": "634d1475334f91eeedf1e03b20190524",
//         "surveyId": "dc00cc7175004a68df46359b20190618",
//         "questionAnswers": [
//             {
//                 "empId": "634d1475334f91eeedf1e03b20190525",
//                 "answers": [
//                     {"questionId": "mission_and_purpose_v1", "answer": 4},
//                     {"questionId": "agile_planning_v1", "answer": 7}
//                 ]
//             }
//         ]
//     }
// ]

/**
 * Extract the active surveys (check end and start date) from the org survey list
 * @param {*} surveys - org surveys array of all surveys
 */

var getActiveSurveys = function getActiveSurveys(surveys) {
  if (surveys) {
    return surveys.filter(function (survey) {
      return (0, _DateService.isDateBetween)((0, _DateFormatters.formatDateDefault)(survey.startDate), (0, _DateFormatters.formatDateDefault)(survey.endDate), new Date());
    });
  }

  return [];
};
/**
 * Extract the inactive surveys (current date > end date) from the org survey list - note dont check each employee entry
 * (ie. if all individual emp surveys have been completed which could constitute that the survey is finished)
 * as new employees may join, etc
 * @param {*} surveys - org surveys array of all surveys
 */


exports.getActiveSurveys = getActiveSurveys;

var getInactiveSurveys = function getInactiveSurveys(surveys) {
  if (surveys) {
    return surveys.filter(function (survey) {
      return (0, _DateService.isDateAfter)(new Date(), (0, _DateFormatters.formatDateDefault)(survey.endDate));
    });
  }

  return [];
};
/**
 * Extract the inactive surveys (check end and start date) from the org survey list and return the count
 * @param {*} surveys - org surveys array of all surveys
 */


exports.getInactiveSurveys = getInactiveSurveys;

var getInactiveSurveysCount = function getInactiveSurveysCount(surveys) {
  if (surveys) {
    var list = getInactiveSurveys(surveys);
    return list ? list.length : 0;
  }

  return 0;
};
/**
 * Extract the active surveys (check end and start date) from the org survey list and return the count
 * @param {*} surveys - org surveys array of all surveys
 */


exports.getInactiveSurveysCount = getInactiveSurveysCount;

var getActiveSurveysCount = function getActiveSurveysCount(surveys) {
  if (surveys) {
    var list = surveys.filter(function (survey) {
      return (0, _DateService.isDateBetween)(survey.startDate, survey.endDate, new Date());
    });
    return list ? list.length : 0;
  }

  return 0;
};
/**
 * Get a survey from the active survey list
 * @param {Array} surveys - org surveys array of all surveys - contains start and end date
 * @param {String} surveyId - the survey id to retrieve
 */


exports.getActiveSurveysCount = getActiveSurveysCount;

var getActiveSurveyById = function getActiveSurveyById(surveys, surveyId) {
  if ((surveys === null || surveys === void 0 ? void 0 : surveys.length) > 0 && surveyId) {
    var activeSurveys = getActiveSurveys(surveys).filter(function (survey) {
      return survey.surveyId === surveyId;
    });

    if ((activeSurveys === null || activeSurveys === void 0 ? void 0 : activeSurveys.length) > 0) {
      return activeSurveys[0]; // should only be one
    }
  }

  return undefined;
};
/**
 * Get a survey from the survey list - get survey groups and then the questions
 * @param {Array} surveys - array of all surveys
 * @param {String} surveyId - the survey id to retrieve
 */


exports.getActiveSurveyById = getActiveSurveyById;

var getSurveyById = function getSurveyById(surveys, surveyId) {
  if ((surveys === null || surveys === void 0 ? void 0 : surveys.length) > 0 && surveyId) {
    var survey = surveys.filter(function (survey) {
      return survey.id === surveyId;
    });

    if ((survey === null || survey === void 0 ? void 0 : survey.length) > 0) {
      return survey[0]; // should only be one
    }
  }

  return undefined;
};
/**
 * Calculate the percent complete for the whole organisation per survey
 * @param {Array} survey
 * @param {Array} surveyAnswers
 */


exports.getSurveyById = getSurveyById;

var getOrgSurveyPercentComplete = function getOrgSurveyPercentComplete(survey, surveyAnswers) {
  if (survey && surveyAnswers) {
    return (0, _NumberFormatters.formatPercentage)(100);
  }

  return 0;
};
/**
 * Calculate the percent complete for an employee for a given survey
 * @param {Array} survey
 * @param {Array} surveyAnswers
 */


exports.getOrgSurveyPercentComplete = getOrgSurveyPercentComplete;

var getOrgSurveyPercentCompleteByEmployee = function getOrgSurveyPercentCompleteByEmployee(surveyId, empId, surveyAnswers) {
  if (surveyId && empId && surveyAnswers) {
    return (0, _NumberFormatters.formatPercentage)(100);
  }

  return 0;
};
/**
 *
 * @param {*} survey
 * @param {*} surveyGroups
 * @param {*} surveyQuestions
 */


exports.getOrgSurveyPercentCompleteByEmployee = getOrgSurveyPercentCompleteByEmployee;

var buildEmpSurveyAnswers = function buildEmpSurveyAnswers(survey, surveyGroups) {
  var empSurveyAnswers = [];

  if (survey === null || survey === void 0 ? void 0 : survey.groups) {
    survey.groups.forEach(function (group) {
      surveyGroups.forEach(function (surveyGroup) {
        if ((surveyGroup === null || surveyGroup === void 0 ? void 0 : surveyGroup.id) && surveyGroup.id === group) {
          if (surveyGroup === null || surveyGroup === void 0 ? void 0 : surveyGroup.questions) {
            surveyGroup.questions.forEach(function (question) {
              // add the question/ answer to the response
              var answer = {
                questionId: question,
                answer: 0
              };
              empSurveyAnswers.push(answer);
            });
          }
        }
      });
    });
  }

  return empSurveyAnswers;
};

exports.buildEmpSurveyAnswers = buildEmpSurveyAnswers;

var createDefaultOrgSurveyAnswers = function createDefaultOrgSurveyAnswers(id, orgid, surveyId) {
  return {
    id: id,
    orgid: orgid,
    surveyId: surveyId,
    questionAnswers: []
  };
};
/**
 * extract the employee survey answers from the org survey answers object
 * @param {*} orgSurveyAnswers
 * @param {*} empId
 */


exports.createDefaultOrgSurveyAnswers = createDefaultOrgSurveyAnswers;

var getEmpSurveyAnswers = function getEmpSurveyAnswers(orgSurveyAnswers, empId) {
  var _orgSurveyAnswers$que;

  return (orgSurveyAnswers === null || orgSurveyAnswers === void 0 ? void 0 : (_orgSurveyAnswers$que = orgSurveyAnswers.questionAnswers) === null || _orgSurveyAnswers$que === void 0 ? void 0 : _orgSurveyAnswers$que.filter(function (questionAnswer) {
    return questionAnswer.empId === empId;
  })) || [];
};

exports.getEmpSurveyAnswers = getEmpSurveyAnswers;

var empSurveySummaryStatistics = function empSurveySummaryStatistics(empSurveyAnswers) {
  var summaryStatistics = {};
  var initSummaryStatistics = {
    percentCompleted: 0,
    percentToComplete: 100,
    numberOfQuestions: 0,
    questionsCompleted: 0,
    questionsToComplete: 0,
    answerAverage: 0
  };
  var totalQuestions = 0;
  var totalQuestionsAnswered = 0;
  var answerTotal = 0;

  if (empSurveyAnswers === null || empSurveyAnswers === void 0 ? void 0 : empSurveyAnswers.answers) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = empSurveyAnswers.answers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var empSurveyAnswer = _step.value;
        totalQuestions++;

        if ((empSurveyAnswer === null || empSurveyAnswer === void 0 ? void 0 : empSurveyAnswer.answer) > 0) {
          totalQuestionsAnswered++;
          answerTotal += empSurveyAnswer.answer;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  summaryStatistics = _objectSpread({}, initSummaryStatistics, {}, {
    percentCompleted: totalQuestions > 0 ? totalQuestionsAnswered / totalQuestions * 100 : 0
  }, {}, {
    percentToComplete: 100 - (totalQuestions > 0 ? totalQuestionsAnswered / totalQuestions * 100 : 0)
  }, {}, {
    numberOfQuestions: totalQuestions
  }, {}, {
    questionsCompleted: totalQuestionsAnswered
  }, {}, {
    questionsToComplete: totalQuestions - totalQuestionsAnswered
  }, {}, {
    answerAverage: totalQuestionsAnswered > 0 ? answerTotal / totalQuestionsAnswered : 0
  });
  return summaryStatistics;
};
/**
 * Checks if the survey questions have answers - if all are answered then the survey is complete
 * This allows the option to close the survey
 * NOTE - the user can still change the answers up until they close the survey
 */


exports.empSurveySummaryStatistics = empSurveySummaryStatistics;

var surveyComplete = function surveyComplete(empSurveyAnswers) {
  var _empSurveyAnswers$ans;

  var surveyCompleted = true;

  if ((empSurveyAnswers === null || empSurveyAnswers === void 0 ? void 0 : (_empSurveyAnswers$ans = empSurveyAnswers.answers) === null || _empSurveyAnswers$ans === void 0 ? void 0 : _empSurveyAnswers$ans.length) > 0) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = empSurveyAnswers.answers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var empSurveyAnswer = _step2.value;

        if ((empSurveyAnswer === null || empSurveyAnswer === void 0 ? void 0 : empSurveyAnswer.answer) === 0) {
          surveyCompleted = false;
          break;
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
          _iterator2["return"]();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  } else {
    return false;
  }

  return surveyCompleted;
};

exports.surveyComplete = surveyComplete;

var surveyActive = function surveyActive(empSurveyAnswers) {
  return (empSurveyAnswers === null || empSurveyAnswers === void 0 ? void 0 : empSurveyAnswers.surveyClosedDate) === null || typeof (empSurveyAnswers === null || empSurveyAnswers === void 0 ? void 0 : empSurveyAnswers.surveyClosedDate) === 'undefined';
};

exports.surveyActive = surveyActive;

var initialiseOrgSurveysCompareList = function initialiseOrgSurveysCompareList(orgSurveysCompareList) {
  return (orgSurveysCompareList === null || orgSurveysCompareList === void 0 ? void 0 : orgSurveysCompareList.length) > 0 ? orgSurveysCompareList.map(function (orgSurvey) {
    return _objectSpread({}, orgSurvey, {
      selected: false
    });
  }) : [];
};
/**
 * Transform the emp survey answers into data required for other services - i.e. charting
 * @param {Array} orgSurveyAnswers - can be 1 or 2 entries
 */


exports.initialiseOrgSurveysCompareList = initialiseOrgSurveysCompareList;

var extractOrgSurveyCompareData = function extractOrgSurveyCompareData(orgSurveyAnswers) {
  var INIT_QUESTION = {
    question: '',
    data: []
  };
  var INIT_DATA = {
    id: '',
    values: {},
    engagementData: {}
  };
  var INIT_VALUES = {
    totalValue: 0,
    answeredCount: 0
  }; // answers grouped 1-2, 3-4, 5-6-7, 8-9

  var INIT_ENGAGEMENT_DATA = {
    activelyDisengaged: 0,
    // answers of 1-2
    passive: 0,
    // answers of 3-4
    moderatelyEngaged: 0,
    // answers of 5-6-7
    highlyEngaged: 0 // answers of 8-9

  }; // only work with 2 surveys (more than 1 may be selected)
  // TODO need to select the 2 most recent surveys in the list to compare as the list can be in any order

  var compareData = [];

  while ((orgSurveyAnswers === null || orgSurveyAnswers === void 0 ? void 0 : orgSurveyAnswers.length) > 2) {
    // only keep 2 entries (TODO should be the latest 2 if more than 2 are selected)
    orgSurveyAnswers.pop();
  }

  var commonQuestions = compareSurveysCommonQuestions(orgSurveyAnswers);
  (orgSurveyAnswers === null || orgSurveyAnswers === void 0 ? void 0 : orgSurveyAnswers.length) > 0 ? orgSurveyAnswers.forEach(function (orgSurveyAnswer) {
    var _orgSurveyAnswer$ques;

    if ((orgSurveyAnswer === null || orgSurveyAnswer === void 0 ? void 0 : (_orgSurveyAnswer$ques = orgSurveyAnswer.questionAnswers) === null || _orgSurveyAnswer$ques === void 0 ? void 0 : _orgSurveyAnswer$ques.length) > 0) {
      orgSurveyAnswer.questionAnswers.forEach(function (questionAnswer) {
        var _questionAnswer$answe; // TODO take all answers or only if the survey has been completed ??? to be answered
        // i.e. emp may have completed some question without finalising the survey


        if ((questionAnswer === null || questionAnswer === void 0 ? void 0 : (_questionAnswer$answe = questionAnswer.answers) === null || _questionAnswer$answe === void 0 ? void 0 : _questionAnswer$answe.length) > 0) {
          questionAnswer.answers.forEach(function (answer) {
            // first check if the question is in the common question list (between both surveys) before adding to the results
            if ((answer === null || answer === void 0 ? void 0 : answer.answer) > 0 && (0, _lodash.indexOf)(commonQuestions, answer.questionId) > -1) {
              var foundQuestionEntry = compareData.find(function (item) {
                return item.question === answer.questionId;
              });

              if (foundQuestionEntry === undefined) {
                // no entry found so initialise and add to the array
                var initValues = _objectSpread({}, INIT_VALUES, {
                  totalValue: answer.answer,
                  answeredCount: 1
                });

                var initEngagement = updateEngagementData(_objectSpread({}, INIT_ENGAGEMENT_DATA), answer.answer);

                var initData = _objectSpread({}, INIT_DATA, {
                  id: orgSurveyAnswer.id,
                  values: _objectSpread({}, initValues),
                  engagementData: _objectSpread({}, initEngagement)
                });

                var initQuestion = _objectSpread({}, INIT_QUESTION, {
                  question: answer.questionId,
                  data: [initData]
                });

                compareData.push(initQuestion);
              } else {
                // found the question - need to check if the survey exists - if so add the value otherwise create a new entry
                var foundDataSurveyEntry = foundQuestionEntry.data.find(function (item) {
                  return item.id === orgSurveyAnswer.id;
                });

                if (foundDataSurveyEntry === undefined) {
                  var _initValues = _objectSpread({}, INIT_VALUES, {
                    totalValue: answer.answer,
                    answeredCount: 1
                  });

                  var _initEngagement = updateEngagementData(_objectSpread({}, INIT_ENGAGEMENT_DATA), answer.answer);

                  var _initData = _objectSpread({}, INIT_DATA, {
                    id: orgSurveyAnswer.id,
                    values: _objectSpread({}, _initValues),
                    engagementData: _objectSpread({}, _initEngagement)
                  });

                  foundQuestionEntry.data.push(_initData);
                } else {
                  // found the data survey entry so update the value
                  var _initEngagement2 = updateEngagementData(_objectSpread({}, foundDataSurveyEntry.engagementData), answer.answer);

                  foundDataSurveyEntry.engagementData = _objectSpread({}, _initEngagement2);
                  foundDataSurveyEntry.values.totalValue = foundDataSurveyEntry.values.totalValue + answer.answer;
                  foundDataSurveyEntry.values.answeredCount = foundDataSurveyEntry.values.answeredCount + 1;
                }
              }
            }
          });
        }
      });
    } // return {
    //     ...orgSurveyAnswer,
    //     selected: false
    // };

  }) : []; // console.log(JSON.stringify(compareData));

  return compareData;
};
/**
 * compare 2 surveys and return the common question from both - uses the first as the
 * if only 1 survey is passed then use all the questions as the base for the compare list
 * @param {Array} orgSurveyAnswers - must be only 1 or 2 entries
 */


exports.extractOrgSurveyCompareData = extractOrgSurveyCompareData;

var compareSurveysCommonQuestions = function compareSurveysCommonQuestions(orgSurveyAnswers) {
  if ((orgSurveyAnswers === null || orgSurveyAnswers === void 0 ? void 0 : orgSurveyAnswers.length) == 1) {
    var _orgSurveyAnswers$, _orgSurveyAnswers$$qu;

    var questionsBase = Array.from((_orgSurveyAnswers$ = orgSurveyAnswers[0]) === null || _orgSurveyAnswers$ === void 0 ? void 0 : (_orgSurveyAnswers$$qu = _orgSurveyAnswers$.questionAnswers[0]) === null || _orgSurveyAnswers$$qu === void 0 ? void 0 : _orgSurveyAnswers$$qu.answers, function (answer) {
      return answer.questionId;
    });
    return questionsBase;
  }

  if ((orgSurveyAnswers === null || orgSurveyAnswers === void 0 ? void 0 : orgSurveyAnswers.length) == 2) {
    var _orgSurveyAnswers$2, _orgSurveyAnswers$2$q, _orgSurveyAnswers$3, _orgSurveyAnswers$3$q; //console.log(Array.from([1, 2, 3], x => x + x));
    // expected output: Array [2, 4, 6]


    var _questionsBase = Array.from((_orgSurveyAnswers$2 = orgSurveyAnswers[0]) === null || _orgSurveyAnswers$2 === void 0 ? void 0 : (_orgSurveyAnswers$2$q = _orgSurveyAnswers$2.questionAnswers[0]) === null || _orgSurveyAnswers$2$q === void 0 ? void 0 : _orgSurveyAnswers$2$q.answers, function (answer) {
      return answer.questionId;
    });

    var questionsCompare = Array.from((_orgSurveyAnswers$3 = orgSurveyAnswers[1]) === null || _orgSurveyAnswers$3 === void 0 ? void 0 : (_orgSurveyAnswers$3$q = _orgSurveyAnswers$3.questionAnswers[0]) === null || _orgSurveyAnswers$3$q === void 0 ? void 0 : _orgSurveyAnswers$3$q.answers, function (answer) {
      return answer.questionId;
    });
    return (0, _lodash.intersection)(_questionsBase, questionsCompare);
  }

  return [];
};
/**
 * increment the correct entry
 * @param {INIT_ENGAGEMENT_DATA} data
 * @param {*} answer
 */


var updateEngagementData = function updateEngagementData(data, answer) {
  if (data) {
    if (answer === 1 || answer === 2) {
      data.activelyDisengaged = data.activelyDisengaged + 1;
    } else if (answer === 3 || answer === 4) {
      data.passive = data.passive + 1;
    } else if (answer === 5 || answer === 6 || answer === 7) {
      data.moderatelyEngaged = data.moderatelyEngaged + 1;
    } else {
      data.highlyEngaged = data.highlyEngaged + 1;
    }
  }

  return data;
};
/**
 * Transform the emp survey answers into data required for radar, bar charts
 * NOTE - the first entry contains the unique keys to construct the charts
 * @param {Array} orgSurveyAnswers
 */


var extractOrgSurveyCommonChartData = function extractOrgSurveyCommonChartData(orgSurveyData) {
  var surveyResponseData = [];
  var uniqueKeys = [];
  var compareData = extractOrgSurveyCompareData(orgSurveyData);

  if (compareData) {
    compareData.forEach(function (entry) {
      // eslint-disable-next-line no-undef
      var transformedMap = new Map();
      transformedMap.set('question', entry.question);
      entry.data.forEach(function (dataEntry) {
        var aveValue = getAverageValue(dataEntry.values);
        transformedMap.set(dataEntry.id, aveValue); // check if the id exisits in the unique

        if (!uniqueKeys.includes(dataEntry.id)) {
          uniqueKeys.push(dataEntry.id);
        }
      });
      var transformedObject = {};
      transformedMap.forEach(function (v, k) {
        transformedObject = _objectSpread({}, transformedObject, {}, _defineProperty({}, "".concat(k), v));
      });
      surveyResponseData.push(transformedObject);
    });
  }

  surveyResponseData.unshift(uniqueKeys); // console.log(JSON.stringify(surveyResponseData));

  return surveyResponseData;
};

exports.extractOrgSurveyCommonChartData = extractOrgSurveyCommonChartData;

var extractOrgSurveyRadarData = function extractOrgSurveyRadarData(orgSurveyData) {
  return extractOrgSurveyCommonChartData(orgSurveyData);
};

exports.extractOrgSurveyRadarData = extractOrgSurveyRadarData;

var extractOrgSurveyDistributionsData = function extractOrgSurveyDistributionsData(orgSurveyData) {
  return extractOrgSurveyCommonChartData(orgSurveyData);
};
/**
 * Extract the top responses from the survey answers based on a weighted algorithm
 * @param {Array} orgSurveyData - OrgSurveyAnswers list
 * @param {*} surveyId
 */


exports.extractOrgSurveyDistributionsData = extractOrgSurveyDistributionsData;

var extractOrgSurveyTopResponseData = function extractOrgSurveyTopResponseData(orgSurveyData, surveyId) {
  var surveyResponseData = extractOrgSurveyResponseData(orgSurveyData, surveyId);
  var sortedData = sortTopEngagementData(surveyResponseData).reverse();

  while ((sortedData === null || sortedData === void 0 ? void 0 : sortedData.length) > TOP_BOTTOM_THRESHOLD) {
    // only keep the top TOP_BOTTOM_THRESHOLD entries
    sortedData.pop();
  } // console.log(JSON.stringify(sortedData));


  return sortedData;
};
/**
 * Extract the bottom responses from the survey answers based on a weighted algorithm
 * @param {Array} orgSurveyData - OrgSurveyAnswers list
 * @param {*} surveyId
 */


exports.extractOrgSurveyTopResponseData = extractOrgSurveyTopResponseData;

var extractOrgSurveyBottomResponseData = function extractOrgSurveyBottomResponseData(orgSurveyData, surveyId) {
  var surveyResponseData = extractOrgSurveyResponseData(orgSurveyData, surveyId);
  var sortedData = sortBottomEngagementData(surveyResponseData).reverse();

  while ((sortedData === null || sortedData === void 0 ? void 0 : sortedData.length) > TOP_BOTTOM_THRESHOLD) {
    // only keep the top TOP_BOTTOM_THRESHOLD entries
    sortedData.pop();
  } // console.log(JSON.stringify(sortedData));


  return sortedData;
};

exports.extractOrgSurveyBottomResponseData = extractOrgSurveyBottomResponseData;

var extractOrgSurveyResponseData = function extractOrgSurveyResponseData(orgSurveyData, surveyId) {
  var surveyResponseData = [];
  var compareData = extractOrgSurveyCompareData(orgSurveyData);

  if (compareData) {
    compareData.forEach(function (answer) {
      var questionId = answer === null || answer === void 0 ? void 0 : answer.question;
      answer === null || answer === void 0 ? void 0 : answer.data.forEach(function (surveyResult) {
        if ((surveyResult === null || surveyResult === void 0 ? void 0 : surveyResult.id) === surveyId) {
          // push the object to the final list
          surveyResponseData.push(_objectSpread({
            question: questionId
          }, surveyResult));
        }
      });
    });
  }

  return surveyResponseData;
};
/**
 * extract org survey answers and produce an array of {orgId: number, surveyId: number, data: [{name: string, amt: number}] } objects
 * @param {*} orgSurveyData - OrgSurveyAnswers list
 */


exports.extractOrgSurveyResponseData = extractOrgSurveyResponseData;

var extractOrgSurveySimpleChartData = function extractOrgSurveySimpleChartData(orgSurveyData) {
  var simpleChartResponseData = [];

  if (orgSurveyData) {
    orgSurveyData.forEach(function (survey) {
      var surveyChartData = [];
      var data = extractOrgSurveyResponseData(orgSurveyData, survey.id);
      data.forEach(function (question) {
        // push the object to the final list
        var aveValue = getAverageValue(question.values);
        surveyChartData.push({
          name: question === null || question === void 0 ? void 0 : question.question,
          amt: aveValue
        });
      });
      simpleChartResponseData.push({
        orgId: survey.orgid,
        surveyId: survey.surveyId,
        data: surveyChartData
      });
    });
  }

  return simpleChartResponseData;
};
/**
 * Apply a weighting to each grouping in the engagementData to sort the results
 * @param {Array} data
 */


exports.extractOrgSurveySimpleChartData = extractOrgSurveySimpleChartData;

var sortTopEngagementData = function sortTopEngagementData(data) {
  var sortedData;

  if (data) {
    sortedData = (0, _lodash.sortBy)(data, [function (o) {
      return o.engagementData.highlyEngaged * 8 + o.engagementData.moderatelyEngaged * 6 + o.engagementData.passive * 4 + o.engagementData.activelyDisengaged * 2;
    }]);
    return sortedData;
  }

  return data;
};
/**
 * Apply a weighting to each grouping in the engagementData to sort the results
 * @param {Array} data
 */


exports.sortTopEngagementData = sortTopEngagementData;

var sortBottomEngagementData = function sortBottomEngagementData(data) {
  var sortedData;

  if (data) {
    sortedData = (0, _lodash.sortBy)(data, [function (o) {
      return o.engagementData.highlyEngaged * 2 + o.engagementData.moderatelyEngaged * 4 + o.engagementData.passive * 6 + o.engagementData.activelyDisengaged * 8;
    }]);
    return sortedData;
  }

  return data;
};

exports.sortBottomEngagementData = sortBottomEngagementData;

var prepareOrgSurveyAnswerSagaCalls = function prepareOrgSurveyAnswerSagaCalls(orgSurveysCompareList, selectedOrg) {
  var orgSurveyAnswerCalls = (orgSurveysCompareList === null || orgSurveysCompareList === void 0 ? void 0 : orgSurveysCompareList.length) > 0 ? orgSurveysCompareList.filter(function (orgSurvey) {
    return orgSurvey === null || orgSurvey === void 0 ? void 0 : orgSurvey.selected;
  }).map(function (orgSurvey) {
    if (orgSurvey === null || orgSurvey === void 0 ? void 0 : orgSurvey.selected) {
      return (0, _effects.call)(_ApiService.fetchDataRequest, _api.ORG_SURVEY_ANSWERS_ENDPOINT, [_api.ORGID_PATH_PARAM, 'orgSurveyId'], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id, orgSurvey === null || orgSurvey === void 0 ? void 0 : orgSurvey.id]) || {};
    }
  }) : [];
  return orgSurveyAnswerCalls;
};

exports.prepareOrgSurveyAnswerSagaCalls = prepareOrgSurveyAnswerSagaCalls;

var prepareOrgSurveyAnswerSagaCall = function prepareOrgSurveyAnswerSagaCall(orgSurveysCompareList, selectedOrgId) {
  if (Array.isArray(orgSurveysCompareList)) {
    var surveys = orgSurveysCompareList.map(function (survey) {
      return survey === null || survey === void 0 ? void 0 : survey.surveyId;
    });
    var payload = {
      orgid: selectedOrgId,
      compareSurveyIds: surveys
    };
    return (0, _effects.call)(_ApiService.postDataRequest, _api.COMPARE_ORG_SURVEY_ANSWERS_ENDPOINT, payload, null, [_api.ORGID_PATH_PARAM], [selectedOrgId]) || {};
  }

  return null;
};

exports.prepareOrgSurveyAnswerSagaCall = prepareOrgSurveyAnswerSagaCall;

var getCompareOrgSurveyAnswers =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(orgSurveysCompareList, selectedOrgId) {
    var surveys, payload, result;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!Array.isArray(orgSurveysCompareList)) {
              _context.next = 7;
              break;
            }

            surveys = orgSurveysCompareList.filter(function (survey) {
              return survey === null || survey === void 0 ? void 0 : survey.selected;
            }).map(function (survey) {
              return survey === null || survey === void 0 ? void 0 : survey.id;
            });
            payload = {
              orgid: selectedOrgId,
              compareSurveyIds: surveys
            };
            _context.next = 5;
            return (0, _ApiService.postDataRequest)(_api.COMPARE_ORG_SURVEY_ANSWERS_ENDPOINT, payload, null, [_api.ORGID_PATH_PARAM], [selectedOrgId]);

          case 5:
            result = _context.sent;
            return _context.abrupt("return", result || []);

          case 7:
            return _context.abrupt("return", []);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getCompareOrgSurveyAnswers(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
/**
 *
 * @param {*} values object that contains {answeredCount: number, totalvalue: number}
 */


exports.getCompareOrgSurveyAnswers = getCompareOrgSurveyAnswers;

var getAverageValue = function getAverageValue(values) {
  return (values === null || values === void 0 ? void 0 : values.answeredCount) > 0 ? (0, _lodash.round)(values.totalValue / values.answeredCount, 1) : 0;
};

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TOP_BOTTOM_THRESHOLD, "TOP_BOTTOM_THRESHOLD", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(getActiveSurveys, "getActiveSurveys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(getInactiveSurveys, "getInactiveSurveys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(getInactiveSurveysCount, "getInactiveSurveysCount", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(getActiveSurveysCount, "getActiveSurveysCount", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(getActiveSurveyById, "getActiveSurveyById", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(getSurveyById, "getSurveyById", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(getOrgSurveyPercentComplete, "getOrgSurveyPercentComplete", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(getOrgSurveyPercentCompleteByEmployee, "getOrgSurveyPercentCompleteByEmployee", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(buildEmpSurveyAnswers, "buildEmpSurveyAnswers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(createDefaultOrgSurveyAnswers, "createDefaultOrgSurveyAnswers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(getEmpSurveyAnswers, "getEmpSurveyAnswers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(empSurveySummaryStatistics, "empSurveySummaryStatistics", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(surveyComplete, "surveyComplete", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(surveyActive, "surveyActive", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(initialiseOrgSurveysCompareList, "initialiseOrgSurveysCompareList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(extractOrgSurveyCompareData, "extractOrgSurveyCompareData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(compareSurveysCommonQuestions, "compareSurveysCommonQuestions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(updateEngagementData, "updateEngagementData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(extractOrgSurveyCommonChartData, "extractOrgSurveyCommonChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(extractOrgSurveyRadarData, "extractOrgSurveyRadarData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(extractOrgSurveyDistributionsData, "extractOrgSurveyDistributionsData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(extractOrgSurveyTopResponseData, "extractOrgSurveyTopResponseData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(extractOrgSurveyBottomResponseData, "extractOrgSurveyBottomResponseData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(extractOrgSurveyResponseData, "extractOrgSurveyResponseData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(extractOrgSurveySimpleChartData, "extractOrgSurveySimpleChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(sortTopEngagementData, "sortTopEngagementData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(sortBottomEngagementData, "sortBottomEngagementData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(prepareOrgSurveyAnswerSagaCalls, "prepareOrgSurveyAnswerSagaCalls", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(prepareOrgSurveyAnswerSagaCall, "prepareOrgSurveyAnswerSagaCall", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(getCompareOrgSurveyAnswers, "getCompareOrgSurveyAnswers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(getAverageValue, "getAverageValue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(asyncGeneratorStep, "asyncGeneratorStep", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(_asyncToGenerator, "_asyncToGenerator", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(TOP_BOTTOM_THRESHOLD, "TOP_BOTTOM_THRESHOLD", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(getActiveSurveys, "getActiveSurveys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(getInactiveSurveys, "getInactiveSurveys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(getInactiveSurveysCount, "getInactiveSurveysCount", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(getActiveSurveysCount, "getActiveSurveysCount", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(getActiveSurveyById, "getActiveSurveyById", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(getSurveyById, "getSurveyById", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(getOrgSurveyPercentComplete, "getOrgSurveyPercentComplete", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(getOrgSurveyPercentCompleteByEmployee, "getOrgSurveyPercentCompleteByEmployee", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(buildEmpSurveyAnswers, "buildEmpSurveyAnswers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(createDefaultOrgSurveyAnswers, "createDefaultOrgSurveyAnswers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(getEmpSurveyAnswers, "getEmpSurveyAnswers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(empSurveySummaryStatistics, "empSurveySummaryStatistics", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(surveyComplete, "surveyComplete", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(surveyActive, "surveyActive", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(initialiseOrgSurveysCompareList, "initialiseOrgSurveysCompareList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(extractOrgSurveyCompareData, "extractOrgSurveyCompareData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(compareSurveysCommonQuestions, "compareSurveysCommonQuestions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(updateEngagementData, "updateEngagementData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(extractOrgSurveyCommonChartData, "extractOrgSurveyCommonChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(extractOrgSurveyRadarData, "extractOrgSurveyRadarData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(extractOrgSurveyDistributionsData, "extractOrgSurveyDistributionsData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(extractOrgSurveyTopResponseData, "extractOrgSurveyTopResponseData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(extractOrgSurveyBottomResponseData, "extractOrgSurveyBottomResponseData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(extractOrgSurveyResponseData, "extractOrgSurveyResponseData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(extractOrgSurveySimpleChartData, "extractOrgSurveySimpleChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(sortTopEngagementData, "sortTopEngagementData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(sortBottomEngagementData, "sortBottomEngagementData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(prepareOrgSurveyAnswerSagaCalls, "prepareOrgSurveyAnswerSagaCalls", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(prepareOrgSurveyAnswerSagaCall, "prepareOrgSurveyAnswerSagaCall", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(getCompareOrgSurveyAnswers, "getCompareOrgSurveyAnswers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(getAverageValue, "getAverageValue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/SurveyService.js");
}();

;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideSurveyGroupLoader = exports.showSurveyGroupLoader = exports.handleSurveyGroupRequestClose = exports.onToggleSurveyGroupDrawer = exports.updateSearchSurveyGroup = exports.onAllSurveyGroupSelect = exports.getUnselectedAllSurveyGroup = exports.getAllSurveyGroup = exports.filterSurveyGroup = exports.onDeleteSelectedSurveyGroup = exports.onDeleteSurveyGroup = exports.onSaveSurveyGroupSuccess = exports.onSaveSurveyGroup = exports.onFilterSurveyGroupOptionSelect = exports.onSurveyGroupClose = exports.onAddSurveyGroup = exports.onSurveyGroupSelect = exports.addFavouriteSurveyGroup = exports.showSurveyGroupMessage = exports.fetchSurveyGroupsSuccess = exports.fetchSurveyGroups = exports.onSurveyGroupQuestions = void 0;

var _ActionTypes = __webpack_require__(7);

var onSurveyGroupQuestions = function onSurveyGroupQuestions(data) {
  return {
    type: _ActionTypes.ON_SURVEY_GROUP_QUESTIONS,
    payload: data
  };
};

exports.onSurveyGroupQuestions = onSurveyGroupQuestions;

var fetchSurveyGroups = function fetchSurveyGroups() {
  return {
    type: _ActionTypes.FETCH_ALL_SURVEY_GROUP
  };
};

exports.fetchSurveyGroups = fetchSurveyGroups;

var fetchSurveyGroupsSuccess = function fetchSurveyGroupsSuccess(data) {
  return {
    type: _ActionTypes.FETCH_ALL_SURVEY_GROUP_SUCCESS,
    payload: data
  };
};

exports.fetchSurveyGroupsSuccess = fetchSurveyGroupsSuccess;

var showSurveyGroupMessage = function showSurveyGroupMessage(message) {
  return {
    type: _ActionTypes.SHOW_SURVEY_GROUP_MESSAGE,
    payload: message
  };
};

exports.showSurveyGroupMessage = showSurveyGroupMessage;

var addFavouriteSurveyGroup = function addFavouriteSurveyGroup(data) {
  return {
    type: _ActionTypes.ADD_FAVOURITE_SURVEY_GROUP,
    payload: data
  };
};

exports.addFavouriteSurveyGroup = addFavouriteSurveyGroup;

var onSurveyGroupSelect = function onSurveyGroupSelect(data) {
  return {
    type: _ActionTypes.ON_SURVEY_GROUP_SELECT,
    payload: data
  };
};

exports.onSurveyGroupSelect = onSurveyGroupSelect;

var onAddSurveyGroup = function onAddSurveyGroup() {
  return {
    type: _ActionTypes.ON_ADD_SURVEY_GROUP,
    payload: ''
  };
};

exports.onAddSurveyGroup = onAddSurveyGroup;

var onSurveyGroupClose = function onSurveyGroupClose() {
  return {
    type: _ActionTypes.ON_SURVEY_GROUP_CLOSE,
    payload: ''
  };
};

exports.onSurveyGroupClose = onSurveyGroupClose;

var onFilterSurveyGroupOptionSelect = function onFilterSurveyGroupOptionSelect(option) {
  return {
    type: _ActionTypes.ON_FILTER_SURVEY_GROUP_OPTION_SELECT,
    payload: option
  };
};

exports.onFilterSurveyGroupOptionSelect = onFilterSurveyGroupOptionSelect;

var onSaveSurveyGroup = function onSaveSurveyGroup(data) {
  return {
    type: _ActionTypes.ON_SAVE_SURVEY_GROUP,
    payload: data
  };
};

exports.onSaveSurveyGroup = onSaveSurveyGroup;

var onSaveSurveyGroupSuccess = function onSaveSurveyGroupSuccess(data) {
  return {
    type: _ActionTypes.ON_SAVE_SURVEY_GROUP_SUCCESS,
    payload: data
  };
};

exports.onSaveSurveyGroupSuccess = onSaveSurveyGroupSuccess;

var onDeleteSurveyGroup = function onDeleteSurveyGroup(data) {
  return {
    type: _ActionTypes.ON_DELETE_SURVEY_GROUP,
    payload: data
  };
};

exports.onDeleteSurveyGroup = onDeleteSurveyGroup;

var onDeleteSelectedSurveyGroup = function onDeleteSelectedSurveyGroup() {
  return {
    type: _ActionTypes.ON_DELETE_SELECTED_SURVEY_GROUP,
    payload: ''
  };
};

exports.onDeleteSelectedSurveyGroup = onDeleteSelectedSurveyGroup;

var filterSurveyGroup = function filterSurveyGroup(userName) {
  return {
    type: _ActionTypes.FILTER_SURVEY_GROUP,
    payload: userName
  };
};

exports.filterSurveyGroup = filterSurveyGroup;

var getAllSurveyGroup = function getAllSurveyGroup() {
  return {
    type: _ActionTypes.GET_ALL_SURVEY_GROUP,
    payload: ''
  };
};

exports.getAllSurveyGroup = getAllSurveyGroup;

var getUnselectedAllSurveyGroup = function getUnselectedAllSurveyGroup() {
  return {
    type: _ActionTypes.GET_UNSELECTED_ALL_SURVEY_GROUP,
    payload: ''
  };
};

exports.getUnselectedAllSurveyGroup = getUnselectedAllSurveyGroup;

var onAllSurveyGroupSelect = function onAllSurveyGroupSelect() {
  return {
    type: _ActionTypes.ON_ALL_SURVEY_GROUP_SELECT,
    payload: ''
  };
};

exports.onAllSurveyGroupSelect = onAllSurveyGroupSelect;

var updateSearchSurveyGroup = function updateSearchSurveyGroup(userName) {
  return {
    type: _ActionTypes.UPDATE_SEARCH_SURVEY_GROUP,
    payload: userName
  };
};

exports.updateSearchSurveyGroup = updateSearchSurveyGroup;

var onToggleSurveyGroupDrawer = function onToggleSurveyGroupDrawer() {
  return {
    type: _ActionTypes.ON_TOGGLE_SURVEY_GROUP_DRAWER
  };
};

exports.onToggleSurveyGroupDrawer = onToggleSurveyGroupDrawer;

var handleSurveyGroupRequestClose = function handleSurveyGroupRequestClose() {
  return {
    type: _ActionTypes.HANDLE_SURVEY_GROUP_REQUEST_CLOSE
  };
};

exports.handleSurveyGroupRequestClose = handleSurveyGroupRequestClose;

var showSurveyGroupLoader = function showSurveyGroupLoader() {
  return {
    type: _ActionTypes.SHOW_SURVEY_GROUP_LOADER
  };
};

exports.showSurveyGroupLoader = showSurveyGroupLoader;

var hideSurveyGroupLoader = function hideSurveyGroupLoader() {
  return {
    type: _ActionTypes.HIDE_SURVEY_GROUP_LOADER
  };
};

exports.hideSurveyGroupLoader = hideSurveyGroupLoader;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(onSurveyGroupQuestions, "onSurveyGroupQuestions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(fetchSurveyGroups, "fetchSurveyGroups", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(fetchSurveyGroupsSuccess, "fetchSurveyGroupsSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(showSurveyGroupMessage, "showSurveyGroupMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(addFavouriteSurveyGroup, "addFavouriteSurveyGroup", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(onSurveyGroupSelect, "onSurveyGroupSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(onAddSurveyGroup, "onAddSurveyGroup", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(onSurveyGroupClose, "onSurveyGroupClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(onFilterSurveyGroupOptionSelect, "onFilterSurveyGroupOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(onSaveSurveyGroup, "onSaveSurveyGroup", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(onSaveSurveyGroupSuccess, "onSaveSurveyGroupSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(onDeleteSurveyGroup, "onDeleteSurveyGroup", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(onDeleteSelectedSurveyGroup, "onDeleteSelectedSurveyGroup", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(filterSurveyGroup, "filterSurveyGroup", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(getAllSurveyGroup, "getAllSurveyGroup", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllSurveyGroup, "getUnselectedAllSurveyGroup", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(onAllSurveyGroupSelect, "onAllSurveyGroupSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(updateSearchSurveyGroup, "updateSearchSurveyGroup", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(onToggleSurveyGroupDrawer, "onToggleSurveyGroupDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(handleSurveyGroupRequestClose, "handleSurveyGroupRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(showSurveyGroupLoader, "showSurveyGroupLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(hideSurveyGroupLoader, "hideSurveyGroupLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(onSurveyGroupQuestions, "onSurveyGroupQuestions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(fetchSurveyGroups, "fetchSurveyGroups", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(fetchSurveyGroupsSuccess, "fetchSurveyGroupsSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(showSurveyGroupMessage, "showSurveyGroupMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(addFavouriteSurveyGroup, "addFavouriteSurveyGroup", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(onSurveyGroupSelect, "onSurveyGroupSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(onAddSurveyGroup, "onAddSurveyGroup", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(onSurveyGroupClose, "onSurveyGroupClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(onFilterSurveyGroupOptionSelect, "onFilterSurveyGroupOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(onSaveSurveyGroup, "onSaveSurveyGroup", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(onSaveSurveyGroupSuccess, "onSaveSurveyGroupSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(onDeleteSurveyGroup, "onDeleteSurveyGroup", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(onDeleteSelectedSurveyGroup, "onDeleteSelectedSurveyGroup", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(filterSurveyGroup, "filterSurveyGroup", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(getAllSurveyGroup, "getAllSurveyGroup", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllSurveyGroup, "getUnselectedAllSurveyGroup", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(onAllSurveyGroupSelect, "onAllSurveyGroupSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(updateSearchSurveyGroup, "updateSearchSurveyGroup", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(onToggleSurveyGroupDrawer, "onToggleSurveyGroupDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(handleSurveyGroupRequestClose, "handleSurveyGroupRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(showSurveyGroupLoader, "showSurveyGroupLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(hideSurveyGroupLoader, "hideSurveyGroupLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroup.js");
}();

;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideOrgSurveyLoader = exports.showOrgSurveyLoader = exports.handleOrgSurveyRequestClose = exports.onToggleOrgSurveyDrawer = exports.updateSearchOrgSurvey = exports.onAllOrgSurveySelect = exports.getUnselectedAllOrgSurvey = exports.getAllOrgSurvey = exports.filterOrgSurvey = exports.onDeleteSelectedOrgSurvey = exports.onDeleteOrgSurvey = exports.onSaveOrgSurveySuccess = exports.onSaveOrgSurvey = exports.onFilterOrgSurveyOptionSelect = exports.onOrgSurveyClose = exports.onAddOrgSurvey = exports.fetchOrgSurveysCompareRadarChartDataSuccess = exports.fetchOrgSurveysCompareBottomResultsChartDataSuccess = exports.fetchOrgSurveysBottomResultsChartData = exports.fetchOrgSurveysCompareTopResultsChartDataSuccess = exports.fetchOrgSurveysTopResultsChartData = exports.fetchOrgSurveysCompareDistributionsChartDataSuccess = exports.fetchOrgSurveysDistributionsChartData = exports.fetchOrgSurveysEngagementReportChartDataSuccess = exports.fetchOrgSurveysEngagementReportChartData = exports.fetchOrgSurveysCompareRadarChartData = exports.fetchOrgSurveysCompareSuccess = exports.fetchOrgSurveysCompare = exports.onOrgSurveyCompareSelect = exports.onOrgSurveySelect = exports.addFavouriteOrgSurvey = exports.showOrgSurveyMessage = exports.fetchOrgSurveysSuccess = exports.fetchOrgSurveys = exports.onOrgSurveyQuestions = void 0;

var _ActionTypes = __webpack_require__(7);

var onOrgSurveyQuestions = function onOrgSurveyQuestions(data) {
  return {
    type: _ActionTypes.ON_ORG_SURVEY_QUESTIONS,
    payload: data
  };
};

exports.onOrgSurveyQuestions = onOrgSurveyQuestions;

var fetchOrgSurveys = function fetchOrgSurveys() {
  return {
    type: _ActionTypes.FETCH_ALL_ORG_SURVEY
  };
};

exports.fetchOrgSurveys = fetchOrgSurveys;

var fetchOrgSurveysSuccess = function fetchOrgSurveysSuccess(data) {
  return {
    type: _ActionTypes.FETCH_ALL_ORG_SURVEY_SUCCESS,
    payload: data
  };
};

exports.fetchOrgSurveysSuccess = fetchOrgSurveysSuccess;

var showOrgSurveyMessage = function showOrgSurveyMessage(message) {
  return {
    type: _ActionTypes.SHOW_ORG_SURVEY_MESSAGE,
    payload: message
  };
};

exports.showOrgSurveyMessage = showOrgSurveyMessage;

var addFavouriteOrgSurvey = function addFavouriteOrgSurvey(data) {
  return {
    type: _ActionTypes.ADD_FAVOURITE_ORG_SURVEY,
    payload: data
  };
};

exports.addFavouriteOrgSurvey = addFavouriteOrgSurvey;

var onOrgSurveySelect = function onOrgSurveySelect(data) {
  return {
    type: _ActionTypes.ON_ORG_SURVEY_SELECT,
    payload: data
  };
};

exports.onOrgSurveySelect = onOrgSurveySelect;

var onOrgSurveyCompareSelect = function onOrgSurveyCompareSelect(data) {
  return {
    type: _ActionTypes.ON_ORG_SURVEY_COMPARE_SELECT,
    payload: data
  };
};

exports.onOrgSurveyCompareSelect = onOrgSurveyCompareSelect;

var fetchOrgSurveysCompare = function fetchOrgSurveysCompare() {
  return {
    type: _ActionTypes.FETCH_ALL_ORG_SURVEY_COMPARE
  };
};

exports.fetchOrgSurveysCompare = fetchOrgSurveysCompare;

var fetchOrgSurveysCompareSuccess = function fetchOrgSurveysCompareSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_ALL_ORG_SURVEY_COMPARE_SUCCESS,
    payload: payload
  };
};

exports.fetchOrgSurveysCompareSuccess = fetchOrgSurveysCompareSuccess;

var fetchOrgSurveysCompareRadarChartData = function fetchOrgSurveysCompareRadarChartData() {
  return {
    type: _ActionTypes.FETCH_ALL_ORG_SURVEY_COMPARE_RADAR_CHART_DATA
  };
};

exports.fetchOrgSurveysCompareRadarChartData = fetchOrgSurveysCompareRadarChartData;

var fetchOrgSurveysEngagementReportChartData = function fetchOrgSurveysEngagementReportChartData() {
  return {
    type: _ActionTypes.FETCH_ALL_ORG_SURVEY_ENGAGEMENT_REPORT_CHART_DATA
  };
};

exports.fetchOrgSurveysEngagementReportChartData = fetchOrgSurveysEngagementReportChartData;

var fetchOrgSurveysEngagementReportChartDataSuccess = function fetchOrgSurveysEngagementReportChartDataSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_ALL_ORG_SURVEY_ENGAGEMENT_REPORT_CHART_DATA_SUCCESS,
    payload: payload
  };
};

exports.fetchOrgSurveysEngagementReportChartDataSuccess = fetchOrgSurveysEngagementReportChartDataSuccess;

var fetchOrgSurveysDistributionsChartData = function fetchOrgSurveysDistributionsChartData() {
  return {
    type: _ActionTypes.FETCH_ALL_ORG_SURVEY_COMPARE_DISTRIBUTIONS_CHART_DATA
  };
};

exports.fetchOrgSurveysDistributionsChartData = fetchOrgSurveysDistributionsChartData;

var fetchOrgSurveysCompareDistributionsChartDataSuccess = function fetchOrgSurveysCompareDistributionsChartDataSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_ALL_ORG_SURVEY_COMPARE_DISTRIBUTIONS_CHART_DATA_SUCCESS,
    payload: payload
  };
};

exports.fetchOrgSurveysCompareDistributionsChartDataSuccess = fetchOrgSurveysCompareDistributionsChartDataSuccess;

var fetchOrgSurveysTopResultsChartData = function fetchOrgSurveysTopResultsChartData() {
  return {
    type: _ActionTypes.FETCH_ALL_ORG_SURVEY_COMPARE_TOP_RESULTS_CHART_DATA
  };
};

exports.fetchOrgSurveysTopResultsChartData = fetchOrgSurveysTopResultsChartData;

var fetchOrgSurveysCompareTopResultsChartDataSuccess = function fetchOrgSurveysCompareTopResultsChartDataSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_ALL_ORG_SURVEY_COMPARE_TOP_RESULTS_CHART_DATA_SUCCESS,
    payload: payload
  };
};

exports.fetchOrgSurveysCompareTopResultsChartDataSuccess = fetchOrgSurveysCompareTopResultsChartDataSuccess;

var fetchOrgSurveysBottomResultsChartData = function fetchOrgSurveysBottomResultsChartData() {
  return {
    type: _ActionTypes.FETCH_ALL_ORG_SURVEY_COMPARE_BOTTOM_RESULTS_CHART_DATA
  };
};

exports.fetchOrgSurveysBottomResultsChartData = fetchOrgSurveysBottomResultsChartData;

var fetchOrgSurveysCompareBottomResultsChartDataSuccess = function fetchOrgSurveysCompareBottomResultsChartDataSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_ALL_ORG_SURVEY_COMPARE_BOTTOM_RESULTS_CHART_DATA_SUCCESS,
    payload: payload
  };
};

exports.fetchOrgSurveysCompareBottomResultsChartDataSuccess = fetchOrgSurveysCompareBottomResultsChartDataSuccess;

var fetchOrgSurveysCompareRadarChartDataSuccess = function fetchOrgSurveysCompareRadarChartDataSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_ALL_ORG_SURVEY_COMPARE_RADAR_CHART_DATA_SUCCESS,
    payload: payload
  };
};

exports.fetchOrgSurveysCompareRadarChartDataSuccess = fetchOrgSurveysCompareRadarChartDataSuccess;

var onAddOrgSurvey = function onAddOrgSurvey() {
  return {
    type: _ActionTypes.ON_ADD_ORG_SURVEY,
    payload: ''
  };
};

exports.onAddOrgSurvey = onAddOrgSurvey;

var onOrgSurveyClose = function onOrgSurveyClose() {
  return {
    type: _ActionTypes.ON_ORG_SURVEY_CLOSE,
    payload: ''
  };
};

exports.onOrgSurveyClose = onOrgSurveyClose;

var onFilterOrgSurveyOptionSelect = function onFilterOrgSurveyOptionSelect(option) {
  return {
    type: _ActionTypes.ON_FILTER_ORG_SURVEY_OPTION_SELECT,
    payload: option
  };
};

exports.onFilterOrgSurveyOptionSelect = onFilterOrgSurveyOptionSelect;

var onSaveOrgSurvey = function onSaveOrgSurvey(data) {
  return {
    type: _ActionTypes.ON_SAVE_ORG_SURVEY,
    payload: data
  };
};

exports.onSaveOrgSurvey = onSaveOrgSurvey;

var onSaveOrgSurveySuccess = function onSaveOrgSurveySuccess(data) {
  return {
    type: _ActionTypes.ON_SAVE_ORG_SURVEY_SUCCESS,
    payload: data
  };
};

exports.onSaveOrgSurveySuccess = onSaveOrgSurveySuccess;

var onDeleteOrgSurvey = function onDeleteOrgSurvey(data) {
  return {
    type: _ActionTypes.ON_DELETE_ORG_SURVEY,
    payload: data
  };
};

exports.onDeleteOrgSurvey = onDeleteOrgSurvey;

var onDeleteSelectedOrgSurvey = function onDeleteSelectedOrgSurvey() {
  return {
    type: _ActionTypes.ON_DELETE_SELECTED_ORG_SURVEY,
    payload: ''
  };
};

exports.onDeleteSelectedOrgSurvey = onDeleteSelectedOrgSurvey;

var filterOrgSurvey = function filterOrgSurvey(userName) {
  return {
    type: _ActionTypes.FILTER_ORG_SURVEY,
    payload: userName
  };
};

exports.filterOrgSurvey = filterOrgSurvey;

var getAllOrgSurvey = function getAllOrgSurvey() {
  return {
    type: _ActionTypes.GET_ALL_ORG_SURVEY,
    payload: ''
  };
};

exports.getAllOrgSurvey = getAllOrgSurvey;

var getUnselectedAllOrgSurvey = function getUnselectedAllOrgSurvey() {
  return {
    type: _ActionTypes.GET_UNSELECTED_ALL_ORG_SURVEY,
    payload: ''
  };
};

exports.getUnselectedAllOrgSurvey = getUnselectedAllOrgSurvey;

var onAllOrgSurveySelect = function onAllOrgSurveySelect() {
  return {
    type: _ActionTypes.ON_ALL_ORG_SURVEY_SELECT,
    payload: ''
  };
};

exports.onAllOrgSurveySelect = onAllOrgSurveySelect;

var updateSearchOrgSurvey = function updateSearchOrgSurvey(userName) {
  return {
    type: _ActionTypes.UPDATE_SEARCH_ORG_SURVEY,
    payload: userName
  };
};

exports.updateSearchOrgSurvey = updateSearchOrgSurvey;

var onToggleOrgSurveyDrawer = function onToggleOrgSurveyDrawer() {
  return {
    type: _ActionTypes.ON_TOGGLE_ORG_SURVEY_DRAWER
  };
};

exports.onToggleOrgSurveyDrawer = onToggleOrgSurveyDrawer;

var handleOrgSurveyRequestClose = function handleOrgSurveyRequestClose() {
  return {
    type: _ActionTypes.HANDLE_ORG_SURVEY_REQUEST_CLOSE
  };
};

exports.handleOrgSurveyRequestClose = handleOrgSurveyRequestClose;

var showOrgSurveyLoader = function showOrgSurveyLoader() {
  return {
    type: _ActionTypes.SHOW_ORG_SURVEY_LOADER
  };
};

exports.showOrgSurveyLoader = showOrgSurveyLoader;

var hideOrgSurveyLoader = function hideOrgSurveyLoader() {
  return {
    type: _ActionTypes.HIDE_ORG_SURVEY_LOADER
  };
};

exports.hideOrgSurveyLoader = hideOrgSurveyLoader;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(onOrgSurveyQuestions, "onOrgSurveyQuestions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveys, "fetchOrgSurveys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysSuccess, "fetchOrgSurveysSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(showOrgSurveyMessage, "showOrgSurveyMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(addFavouriteOrgSurvey, "addFavouriteOrgSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(onOrgSurveySelect, "onOrgSurveySelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(onOrgSurveyCompareSelect, "onOrgSurveyCompareSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysCompare, "fetchOrgSurveysCompare", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysCompareSuccess, "fetchOrgSurveysCompareSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysCompareRadarChartData, "fetchOrgSurveysCompareRadarChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysEngagementReportChartData, "fetchOrgSurveysEngagementReportChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysEngagementReportChartDataSuccess, "fetchOrgSurveysEngagementReportChartDataSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysDistributionsChartData, "fetchOrgSurveysDistributionsChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysCompareDistributionsChartDataSuccess, "fetchOrgSurveysCompareDistributionsChartDataSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysTopResultsChartData, "fetchOrgSurveysTopResultsChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysCompareTopResultsChartDataSuccess, "fetchOrgSurveysCompareTopResultsChartDataSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysBottomResultsChartData, "fetchOrgSurveysBottomResultsChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysCompareBottomResultsChartDataSuccess, "fetchOrgSurveysCompareBottomResultsChartDataSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysCompareRadarChartDataSuccess, "fetchOrgSurveysCompareRadarChartDataSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(onAddOrgSurvey, "onAddOrgSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(onOrgSurveyClose, "onOrgSurveyClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(onFilterOrgSurveyOptionSelect, "onFilterOrgSurveyOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(onSaveOrgSurvey, "onSaveOrgSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(onSaveOrgSurveySuccess, "onSaveOrgSurveySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(onDeleteOrgSurvey, "onDeleteOrgSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(onDeleteSelectedOrgSurvey, "onDeleteSelectedOrgSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(filterOrgSurvey, "filterOrgSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(getAllOrgSurvey, "getAllOrgSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllOrgSurvey, "getUnselectedAllOrgSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(onAllOrgSurveySelect, "onAllOrgSurveySelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(updateSearchOrgSurvey, "updateSearchOrgSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(onToggleOrgSurveyDrawer, "onToggleOrgSurveyDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(handleOrgSurveyRequestClose, "handleOrgSurveyRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(showOrgSurveyLoader, "showOrgSurveyLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(hideOrgSurveyLoader, "hideOrgSurveyLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(onOrgSurveyQuestions, "onOrgSurveyQuestions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveys, "fetchOrgSurveys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysSuccess, "fetchOrgSurveysSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(showOrgSurveyMessage, "showOrgSurveyMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(addFavouriteOrgSurvey, "addFavouriteOrgSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(onOrgSurveySelect, "onOrgSurveySelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(onOrgSurveyCompareSelect, "onOrgSurveyCompareSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysCompare, "fetchOrgSurveysCompare", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysCompareSuccess, "fetchOrgSurveysCompareSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysCompareRadarChartData, "fetchOrgSurveysCompareRadarChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysEngagementReportChartData, "fetchOrgSurveysEngagementReportChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysEngagementReportChartDataSuccess, "fetchOrgSurveysEngagementReportChartDataSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysDistributionsChartData, "fetchOrgSurveysDistributionsChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysCompareDistributionsChartDataSuccess, "fetchOrgSurveysCompareDistributionsChartDataSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysTopResultsChartData, "fetchOrgSurveysTopResultsChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysCompareTopResultsChartDataSuccess, "fetchOrgSurveysCompareTopResultsChartDataSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysBottomResultsChartData, "fetchOrgSurveysBottomResultsChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysCompareBottomResultsChartDataSuccess, "fetchOrgSurveysCompareBottomResultsChartDataSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysCompareRadarChartDataSuccess, "fetchOrgSurveysCompareRadarChartDataSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(onAddOrgSurvey, "onAddOrgSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(onOrgSurveyClose, "onOrgSurveyClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(onFilterOrgSurveyOptionSelect, "onFilterOrgSurveyOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(onSaveOrgSurvey, "onSaveOrgSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(onSaveOrgSurveySuccess, "onSaveOrgSurveySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(onDeleteOrgSurvey, "onDeleteOrgSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(onDeleteSelectedOrgSurvey, "onDeleteSelectedOrgSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(filterOrgSurvey, "filterOrgSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(getAllOrgSurvey, "getAllOrgSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllOrgSurvey, "getUnselectedAllOrgSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(onAllOrgSurveySelect, "onAllOrgSurveySelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(updateSearchOrgSurvey, "updateSearchOrgSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(onToggleOrgSurveyDrawer, "onToggleOrgSurveyDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(handleOrgSurveyRequestClose, "handleOrgSurveyRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(showOrgSurveyLoader, "showOrgSurveyLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(hideOrgSurveyLoader, "hideOrgSurveyLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurvey.js");
}();

;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideProjectLoader = exports.showProjectLoader = exports.handleProjectRequestClose = exports.onToggleProjectDrawer = exports.updateSearchProject = exports.onAllProjectSelect = exports.getUnselectedAllProject = exports.getAllProject = exports.filterProject = exports.onDeleteSelectedProject = exports.onDeleteProjectSuccess = exports.onDeleteProject = exports.onSaveProjectSuccess = exports.onSaveProject = exports.onFilterProjectOptionSelect = exports.onProjectClose = exports.onAddProject = exports.onProjectSelect = exports.addFavouriteProjectSuccess = exports.addFavouriteProject = exports.showProjectMessage = exports.fetchProjectsSuccess = exports.fetchProjects = exports.fetchProjectSuccess = exports.fetchProject = exports.onGlobalProjectBusinessPrioritiesDashboard = exports.onGlobalProjectCostPrioritiesDashboard = exports.onProjectBusinessPrioritiesDashboard = exports.onProjectCostPrioritiesDashboard = exports.onProjectPrioritiesDashboard = exports.onProjectIssuesDashboard = exports.hideImportProjectsLoader = exports.showImportProjectsLoader = exports.fetchImportProjectsSuccess = exports.fetchImportProjects = exports.onImportProjectsSuccess = exports.onImportProjects = exports.onSaveProjectCacheSuccess = exports.setProject = void 0;

var _ActionTypes = __webpack_require__(7);

var setProject = function setProject(payload) {
  return {
    type: _ActionTypes.SET_PROJECT,
    payload: payload
  };
};

exports.setProject = setProject;

var onSaveProjectCacheSuccess = function onSaveProjectCacheSuccess(payload) {
  return {
    type: _ActionTypes.ON_SAVE_PROJECT_CACHE_SUCCESS,
    payload: payload
  };
};

exports.onSaveProjectCacheSuccess = onSaveProjectCacheSuccess;

var onImportProjects = function onImportProjects() {
  return {
    type: _ActionTypes.ON_IMPORT_PROJECTS
  };
};

exports.onImportProjects = onImportProjects;

var onImportProjectsSuccess = function onImportProjectsSuccess(payload) {
  return {
    type: _ActionTypes.ON_IMPORT_PROJECTS_SUCCESS,
    payload: payload
  };
};

exports.onImportProjectsSuccess = onImportProjectsSuccess;

var fetchImportProjects = function fetchImportProjects(payload) {
  return {
    type: _ActionTypes.FETCH_IMPORT_PROJECTS,
    payload: payload
  };
};

exports.fetchImportProjects = fetchImportProjects;

var fetchImportProjectsSuccess = function fetchImportProjectsSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_IMPORT_PROJECTS_SUCCESS,
    payload: payload
  };
};

exports.fetchImportProjectsSuccess = fetchImportProjectsSuccess;

var showImportProjectsLoader = function showImportProjectsLoader() {
  return {
    type: _ActionTypes.SHOW_IMPORT_PROJECTS_LOADER
  };
};

exports.showImportProjectsLoader = showImportProjectsLoader;

var hideImportProjectsLoader = function hideImportProjectsLoader() {
  return {
    type: _ActionTypes.HIDE_IMPORT_PROJECTS_LOADER
  };
};

exports.hideImportProjectsLoader = hideImportProjectsLoader;

var onProjectIssuesDashboard = function onProjectIssuesDashboard(payload) {
  return {
    type: _ActionTypes.ON_PROJECT_ISSUES_DASHBOARD,
    payload: payload
  };
};

exports.onProjectIssuesDashboard = onProjectIssuesDashboard;

var onProjectPrioritiesDashboard = function onProjectPrioritiesDashboard(payload) {
  return {
    type: _ActionTypes.ON_PROJECT_PRIORITY_DASHBOARD,
    payload: payload
  };
};

exports.onProjectPrioritiesDashboard = onProjectPrioritiesDashboard;

var onProjectCostPrioritiesDashboard = function onProjectCostPrioritiesDashboard(payload) {
  return {
    type: _ActionTypes.ON_PROJECT_COST_PRIORITIES_DASHBOARD,
    payload: payload
  };
};

exports.onProjectCostPrioritiesDashboard = onProjectCostPrioritiesDashboard;

var onProjectBusinessPrioritiesDashboard = function onProjectBusinessPrioritiesDashboard(payload) {
  return {
    type: _ActionTypes.ON_PROJECT_BUSINESS_PRIORITIES_DASHBOARD,
    payload: payload
  };
};

exports.onProjectBusinessPrioritiesDashboard = onProjectBusinessPrioritiesDashboard;

var onGlobalProjectCostPrioritiesDashboard = function onGlobalProjectCostPrioritiesDashboard(payload) {
  return {
    type: _ActionTypes.ON_GLOBAL_PROJECT_COST_PRIORITIES_DASHBOARD,
    payload: payload
  };
};

exports.onGlobalProjectCostPrioritiesDashboard = onGlobalProjectCostPrioritiesDashboard;

var onGlobalProjectBusinessPrioritiesDashboard = function onGlobalProjectBusinessPrioritiesDashboard(payload) {
  return {
    type: _ActionTypes.ON_GLOBAL_PROJECT_BUSINESS_PRIORITIES_DASHBOARD,
    payload: payload
  };
};

exports.onGlobalProjectBusinessPrioritiesDashboard = onGlobalProjectBusinessPrioritiesDashboard;

var fetchProject = function fetchProject(payload) {
  return {
    type: _ActionTypes.FETCH_PROJECT,
    payload: payload
  };
};

exports.fetchProject = fetchProject;

var fetchProjectSuccess = function fetchProjectSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_PROJECT_SUCCESS,
    payload: payload
  };
};

exports.fetchProjectSuccess = fetchProjectSuccess;

var fetchProjects = function fetchProjects(payload) {
  return {
    type: _ActionTypes.FETCH_ALL_PROJECT,
    payload: payload
  };
};

exports.fetchProjects = fetchProjects;

var fetchProjectsSuccess = function fetchProjectsSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_ALL_PROJECT_SUCCESS,
    payload: payload
  };
};

exports.fetchProjectsSuccess = fetchProjectsSuccess;

var showProjectMessage = function showProjectMessage(message) {
  return {
    type: _ActionTypes.SHOW_PROJECT_MESSAGE,
    payload: message
  };
};

exports.showProjectMessage = showProjectMessage;

var addFavouriteProject = function addFavouriteProject(payload) {
  return {
    type: _ActionTypes.ADD_FAVOURITE_PROJECT,
    payload: payload
  };
};

exports.addFavouriteProject = addFavouriteProject;

var addFavouriteProjectSuccess = function addFavouriteProjectSuccess(payload) {
  return {
    type: _ActionTypes.ADD_FAVOURITE_PROJECT_SUCCESS,
    payload: payload
  };
};

exports.addFavouriteProjectSuccess = addFavouriteProjectSuccess;

var onProjectSelect = function onProjectSelect(payload) {
  return {
    type: _ActionTypes.ON_PROJECT_SELECT,
    payload: payload
  };
};

exports.onProjectSelect = onProjectSelect;

var onAddProject = function onAddProject() {
  return {
    type: _ActionTypes.ON_ADD_PROJECT,
    payload: ''
  };
};

exports.onAddProject = onAddProject;

var onProjectClose = function onProjectClose() {
  return {
    type: _ActionTypes.ON_PROJECT_CLOSE,
    payload: ''
  };
};

exports.onProjectClose = onProjectClose;

var onFilterProjectOptionSelect = function onFilterProjectOptionSelect(payload) {
  return {
    type: _ActionTypes.ON_FILTER_PROJECT_OPTION_SELECT,
    payload: payload
  };
};

exports.onFilterProjectOptionSelect = onFilterProjectOptionSelect;

var onSaveProject = function onSaveProject(payload) {
  return {
    type: _ActionTypes.ON_SAVE_PROJECT,
    payload: payload
  };
};

exports.onSaveProject = onSaveProject;

var onSaveProjectSuccess = function onSaveProjectSuccess(payload) {
  return {
    type: _ActionTypes.ON_SAVE_PROJECT_SUCCESS,
    payload: payload
  };
};

exports.onSaveProjectSuccess = onSaveProjectSuccess;

var onDeleteProject = function onDeleteProject(payload) {
  return {
    type: _ActionTypes.ON_DELETE_PROJECT,
    payload: payload
  };
};

exports.onDeleteProject = onDeleteProject;

var onDeleteProjectSuccess = function onDeleteProjectSuccess(payload) {
  return {
    type: _ActionTypes.ON_DELETE_PROJECT_SUCCESS,
    payload: payload
  };
};

exports.onDeleteProjectSuccess = onDeleteProjectSuccess;

var onDeleteSelectedProject = function onDeleteSelectedProject() {
  return {
    type: _ActionTypes.ON_DELETE_SELECTED_PROJECT,
    payload: ''
  };
};

exports.onDeleteSelectedProject = onDeleteSelectedProject;

var filterProject = function filterProject(payload) {
  return {
    type: _ActionTypes.FILTER_PROJECT,
    payload: payload
  };
};

exports.filterProject = filterProject;

var getAllProject = function getAllProject() {
  return {
    type: _ActionTypes.GET_ALL_PROJECT,
    payload: ''
  };
};

exports.getAllProject = getAllProject;

var getUnselectedAllProject = function getUnselectedAllProject() {
  return {
    type: _ActionTypes.GET_UNSELECTED_ALL_PROJECT,
    payload: ''
  };
};

exports.getUnselectedAllProject = getUnselectedAllProject;

var onAllProjectSelect = function onAllProjectSelect() {
  return {
    type: _ActionTypes.ON_ALL_PROJECT_SELECT,
    payload: ''
  };
};

exports.onAllProjectSelect = onAllProjectSelect;

var updateSearchProject = function updateSearchProject(payload) {
  return {
    type: _ActionTypes.UPDATE_SEARCH_PROJECT,
    payload: payload
  };
};

exports.updateSearchProject = updateSearchProject;

var onToggleProjectDrawer = function onToggleProjectDrawer() {
  return {
    type: _ActionTypes.ON_TOGGLE_PROJECT_DRAWER
  };
};

exports.onToggleProjectDrawer = onToggleProjectDrawer;

var handleProjectRequestClose = function handleProjectRequestClose() {
  return {
    type: _ActionTypes.HANDLE_PROJECT_REQUEST_CLOSE
  };
};

exports.handleProjectRequestClose = handleProjectRequestClose;

var showProjectLoader = function showProjectLoader() {
  return {
    type: _ActionTypes.SHOW_PROJECT_LOADER
  };
};

exports.showProjectLoader = showProjectLoader;

var hideProjectLoader = function hideProjectLoader() {
  return {
    type: _ActionTypes.HIDE_PROJECT_LOADER
  };
};

exports.hideProjectLoader = hideProjectLoader;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(setProject, "setProject", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onSaveProjectCacheSuccess, "onSaveProjectCacheSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onImportProjects, "onImportProjects", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onImportProjectsSuccess, "onImportProjectsSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(fetchImportProjects, "fetchImportProjects", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(fetchImportProjectsSuccess, "fetchImportProjectsSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(showImportProjectsLoader, "showImportProjectsLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(hideImportProjectsLoader, "hideImportProjectsLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onProjectIssuesDashboard, "onProjectIssuesDashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onProjectPrioritiesDashboard, "onProjectPrioritiesDashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onProjectCostPrioritiesDashboard, "onProjectCostPrioritiesDashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onProjectBusinessPrioritiesDashboard, "onProjectBusinessPrioritiesDashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onGlobalProjectCostPrioritiesDashboard, "onGlobalProjectCostPrioritiesDashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onGlobalProjectBusinessPrioritiesDashboard, "onGlobalProjectBusinessPrioritiesDashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(fetchProject, "fetchProject", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(fetchProjectSuccess, "fetchProjectSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(fetchProjects, "fetchProjects", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(fetchProjectsSuccess, "fetchProjectsSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(showProjectMessage, "showProjectMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(addFavouriteProject, "addFavouriteProject", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(addFavouriteProjectSuccess, "addFavouriteProjectSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onProjectSelect, "onProjectSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onAddProject, "onAddProject", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onProjectClose, "onProjectClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onFilterProjectOptionSelect, "onFilterProjectOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onSaveProject, "onSaveProject", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onSaveProjectSuccess, "onSaveProjectSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onDeleteProject, "onDeleteProject", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onDeleteProjectSuccess, "onDeleteProjectSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onDeleteSelectedProject, "onDeleteSelectedProject", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(filterProject, "filterProject", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(getAllProject, "getAllProject", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllProject, "getUnselectedAllProject", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onAllProjectSelect, "onAllProjectSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(updateSearchProject, "updateSearchProject", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onToggleProjectDrawer, "onToggleProjectDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(handleProjectRequestClose, "handleProjectRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(showProjectLoader, "showProjectLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(hideProjectLoader, "hideProjectLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(setProject, "setProject", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onSaveProjectCacheSuccess, "onSaveProjectCacheSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onImportProjects, "onImportProjects", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onImportProjectsSuccess, "onImportProjectsSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(fetchImportProjects, "fetchImportProjects", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(fetchImportProjectsSuccess, "fetchImportProjectsSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(showImportProjectsLoader, "showImportProjectsLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(hideImportProjectsLoader, "hideImportProjectsLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onProjectIssuesDashboard, "onProjectIssuesDashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onProjectPrioritiesDashboard, "onProjectPrioritiesDashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onProjectCostPrioritiesDashboard, "onProjectCostPrioritiesDashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onProjectBusinessPrioritiesDashboard, "onProjectBusinessPrioritiesDashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onGlobalProjectCostPrioritiesDashboard, "onGlobalProjectCostPrioritiesDashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onGlobalProjectBusinessPrioritiesDashboard, "onGlobalProjectBusinessPrioritiesDashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(fetchProject, "fetchProject", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(fetchProjectSuccess, "fetchProjectSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(fetchProjects, "fetchProjects", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(fetchProjectsSuccess, "fetchProjectsSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(showProjectMessage, "showProjectMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(addFavouriteProject, "addFavouriteProject", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(addFavouriteProjectSuccess, "addFavouriteProjectSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onProjectSelect, "onProjectSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onAddProject, "onAddProject", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onProjectClose, "onProjectClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onFilterProjectOptionSelect, "onFilterProjectOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onSaveProject, "onSaveProject", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onSaveProjectSuccess, "onSaveProjectSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onDeleteProject, "onDeleteProject", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onDeleteProjectSuccess, "onDeleteProjectSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onDeleteSelectedProject, "onDeleteSelectedProject", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(filterProject, "filterProject", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(getAllProject, "getAllProject", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllProject, "getUnselectedAllProject", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onAllProjectSelect, "onAllProjectSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(updateSearchProject, "updateSearchProject", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(onToggleProjectDrawer, "onToggleProjectDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(handleProjectRequestClose, "handleProjectRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(showProjectLoader, "showProjectLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(hideProjectLoader, "hideProjectLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/project.js");
}();

;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideProjectBusPriorityLoader = exports.showProjectBusPriorityLoader = exports.handleProjectBusPriorityRequestClose = exports.onToggleProjectBusPriorityDrawer = exports.updateSearchProjectBusPriority = exports.onAllProjectBusPrioritySelect = exports.getUnselectedAllProjectBusPriority = exports.getAllProjectBusPriority = exports.filterProjectBusPriority = exports.onFilterSelectedProjectBusPriority = exports.onDeleteProjectBusPrioritySuccess = exports.onDeleteProjectBusPriority = exports.onSaveProjectBusPrioritySuccess = exports.onSaveProjectBusPriority = exports.onFilterProjectBusPriorityOptionSelect = exports.onProjectBusPriorityClose = exports.onEditProjectBusPriority = exports.onAddProjectBusPriority = exports.onProjectBusPrioritySelect = exports.addFavouriteProjectBusPrioritySuccess = exports.addFavouriteProjectBusPriority = exports.showProjectBusPriorityMessage = exports.fetchProjectBusPrioritysSuccess = exports.fetchProjectBusPrioritys = exports.fetchProjectBusPrioritySuccess = exports.fetchProjectBusPriority = void 0;

var _ActionTypes = __webpack_require__(7);

var fetchProjectBusPriority = function fetchProjectBusPriority(payload) {
  return {
    type: _ActionTypes.FETCH_PROJECT_BUS_PRIORITY,
    payload: payload
  };
};

exports.fetchProjectBusPriority = fetchProjectBusPriority;

var fetchProjectBusPrioritySuccess = function fetchProjectBusPrioritySuccess(payload) {
  return {
    type: _ActionTypes.FETCH_PROJECT_BUS_PRIORITY_SUCCESS,
    payload: payload
  };
};

exports.fetchProjectBusPrioritySuccess = fetchProjectBusPrioritySuccess;

var fetchProjectBusPrioritys = function fetchProjectBusPrioritys() {
  return {
    type: _ActionTypes.FETCH_ALL_PROJECT_BUS_PRIORITY
  };
};

exports.fetchProjectBusPrioritys = fetchProjectBusPrioritys;

var fetchProjectBusPrioritysSuccess = function fetchProjectBusPrioritysSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_ALL_PROJECT_BUS_PRIORITY_SUCCESS,
    payload: payload
  };
};

exports.fetchProjectBusPrioritysSuccess = fetchProjectBusPrioritysSuccess;

var showProjectBusPriorityMessage = function showProjectBusPriorityMessage(message) {
  return {
    type: _ActionTypes.SHOW_PROJECT_BUS_PRIORITY_MESSAGE,
    payload: message
  };
};

exports.showProjectBusPriorityMessage = showProjectBusPriorityMessage;

var addFavouriteProjectBusPriority = function addFavouriteProjectBusPriority(payload) {
  return {
    type: _ActionTypes.ADD_FAVOURITE_PROJECT_BUS_PRIORITY,
    payload: payload
  };
};

exports.addFavouriteProjectBusPriority = addFavouriteProjectBusPriority;

var addFavouriteProjectBusPrioritySuccess = function addFavouriteProjectBusPrioritySuccess(payload) {
  return {
    type: _ActionTypes.ADD_FAVOURITE_PROJECT_BUS_PRIORITY_SUCCESS,
    payload: payload
  };
};

exports.addFavouriteProjectBusPrioritySuccess = addFavouriteProjectBusPrioritySuccess;

var onProjectBusPrioritySelect = function onProjectBusPrioritySelect(payload) {
  return {
    type: _ActionTypes.ON_PROJECT_BUS_PRIORITY_SELECT,
    payload: payload
  };
};

exports.onProjectBusPrioritySelect = onProjectBusPrioritySelect;

var onAddProjectBusPriority = function onAddProjectBusPriority() {
  return {
    type: _ActionTypes.ON_ADD_PROJECT_BUS_PRIORITY
  };
};

exports.onAddProjectBusPriority = onAddProjectBusPriority;

var onEditProjectBusPriority = function onEditProjectBusPriority(payload) {
  return {
    type: _ActionTypes.ON_EDIT_PROJECT_BUS_PRIORITY,
    payload: payload
  };
};

exports.onEditProjectBusPriority = onEditProjectBusPriority;

var onProjectBusPriorityClose = function onProjectBusPriorityClose() {
  return {
    type: _ActionTypes.ON_PROJECT_BUS_PRIORITY_CLOSE
  };
};

exports.onProjectBusPriorityClose = onProjectBusPriorityClose;

var onFilterProjectBusPriorityOptionSelect = function onFilterProjectBusPriorityOptionSelect(payload) {
  return {
    type: _ActionTypes.ON_FILTER_PROJECT_BUS_PRIORITY_OPTION_SELECT,
    payload: payload
  };
};

exports.onFilterProjectBusPriorityOptionSelect = onFilterProjectBusPriorityOptionSelect;

var onSaveProjectBusPriority = function onSaveProjectBusPriority(payload) {
  return {
    type: _ActionTypes.ON_SAVE_PROJECT_BUS_PRIORITY,
    payload: payload
  };
};

exports.onSaveProjectBusPriority = onSaveProjectBusPriority;

var onSaveProjectBusPrioritySuccess = function onSaveProjectBusPrioritySuccess(data) {
  return {
    type: _ActionTypes.ON_SAVE_PROJECT_BUS_PRIORITY_SUCCESS,
    payload: data
  };
};

exports.onSaveProjectBusPrioritySuccess = onSaveProjectBusPrioritySuccess;

var onDeleteProjectBusPriority = function onDeleteProjectBusPriority(payload) {
  return {
    type: _ActionTypes.ON_DELETE_PROJECT_BUS_PRIORITY,
    payload: payload
  };
};

exports.onDeleteProjectBusPriority = onDeleteProjectBusPriority;

var onDeleteProjectBusPrioritySuccess = function onDeleteProjectBusPrioritySuccess(payload) {
  return {
    type: _ActionTypes.ON_DELETE_PROJECT_BUS_PRIORITY_SUCCESS,
    payload: payload
  };
};

exports.onDeleteProjectBusPrioritySuccess = onDeleteProjectBusPrioritySuccess;

var onFilterSelectedProjectBusPriority = function onFilterSelectedProjectBusPriority() {
  return {
    type: _ActionTypes.ON_FILTER_SELECTED_PROJECT_BUS_PRIORITY,
    payload: ''
  };
};

exports.onFilterSelectedProjectBusPriority = onFilterSelectedProjectBusPriority;

var filterProjectBusPriority = function filterProjectBusPriority(payload) {
  return {
    type: _ActionTypes.FILTER_PROJECT_BUS_PRIORITY,
    payload: payload
  };
};

exports.filterProjectBusPriority = filterProjectBusPriority;

var getAllProjectBusPriority = function getAllProjectBusPriority() {
  return {
    type: _ActionTypes.GET_ALL_PROJECT_BUS_PRIORITY,
    payload: ''
  };
};

exports.getAllProjectBusPriority = getAllProjectBusPriority;

var getUnselectedAllProjectBusPriority = function getUnselectedAllProjectBusPriority() {
  return {
    type: _ActionTypes.GET_UNSELECTED_ALL_PROJECT_BUS_PRIORITY,
    payload: ''
  };
};

exports.getUnselectedAllProjectBusPriority = getUnselectedAllProjectBusPriority;

var onAllProjectBusPrioritySelect = function onAllProjectBusPrioritySelect() {
  return {
    type: _ActionTypes.ON_ALL_PROJECT_BUS_PRIORITY_SELECT,
    payload: ''
  };
};

exports.onAllProjectBusPrioritySelect = onAllProjectBusPrioritySelect;

var updateSearchProjectBusPriority = function updateSearchProjectBusPriority(payload) {
  return {
    type: _ActionTypes.UPDATE_SEARCH_PROJECT_BUS_PRIORITY,
    payload: payload
  };
};

exports.updateSearchProjectBusPriority = updateSearchProjectBusPriority;

var onToggleProjectBusPriorityDrawer = function onToggleProjectBusPriorityDrawer() {
  return {
    type: _ActionTypes.ON_TOGGLE_PROJECT_BUS_PRIORITY_DRAWER
  };
};

exports.onToggleProjectBusPriorityDrawer = onToggleProjectBusPriorityDrawer;

var handleProjectBusPriorityRequestClose = function handleProjectBusPriorityRequestClose() {
  return {
    type: _ActionTypes.HANDLE_PROJECT_BUS_PRIORITY_REQUEST_CLOSE
  };
};

exports.handleProjectBusPriorityRequestClose = handleProjectBusPriorityRequestClose;

var showProjectBusPriorityLoader = function showProjectBusPriorityLoader() {
  return {
    type: _ActionTypes.SHOW_PROJECT_BUS_PRIORITY_LOADER
  };
};

exports.showProjectBusPriorityLoader = showProjectBusPriorityLoader;

var hideProjectBusPriorityLoader = function hideProjectBusPriorityLoader() {
  return {
    type: _ActionTypes.HIDE_PROJECT_BUS_PRIORITY_LOADER
  };
};

exports.hideProjectBusPriorityLoader = hideProjectBusPriorityLoader;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchProjectBusPriority, "fetchProjectBusPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(fetchProjectBusPrioritySuccess, "fetchProjectBusPrioritySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(fetchProjectBusPrioritys, "fetchProjectBusPrioritys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(fetchProjectBusPrioritysSuccess, "fetchProjectBusPrioritysSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(showProjectBusPriorityMessage, "showProjectBusPriorityMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(addFavouriteProjectBusPriority, "addFavouriteProjectBusPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(addFavouriteProjectBusPrioritySuccess, "addFavouriteProjectBusPrioritySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(onProjectBusPrioritySelect, "onProjectBusPrioritySelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(onAddProjectBusPriority, "onAddProjectBusPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(onEditProjectBusPriority, "onEditProjectBusPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(onProjectBusPriorityClose, "onProjectBusPriorityClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(onFilterProjectBusPriorityOptionSelect, "onFilterProjectBusPriorityOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(onSaveProjectBusPriority, "onSaveProjectBusPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(onSaveProjectBusPrioritySuccess, "onSaveProjectBusPrioritySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(onDeleteProjectBusPriority, "onDeleteProjectBusPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(onDeleteProjectBusPrioritySuccess, "onDeleteProjectBusPrioritySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(onFilterSelectedProjectBusPriority, "onFilterSelectedProjectBusPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(filterProjectBusPriority, "filterProjectBusPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(getAllProjectBusPriority, "getAllProjectBusPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllProjectBusPriority, "getUnselectedAllProjectBusPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(onAllProjectBusPrioritySelect, "onAllProjectBusPrioritySelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(updateSearchProjectBusPriority, "updateSearchProjectBusPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(onToggleProjectBusPriorityDrawer, "onToggleProjectBusPriorityDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(handleProjectBusPriorityRequestClose, "handleProjectBusPriorityRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(showProjectBusPriorityLoader, "showProjectBusPriorityLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(hideProjectBusPriorityLoader, "hideProjectBusPriorityLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchProjectBusPriority, "fetchProjectBusPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(fetchProjectBusPrioritySuccess, "fetchProjectBusPrioritySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(fetchProjectBusPrioritys, "fetchProjectBusPrioritys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(fetchProjectBusPrioritysSuccess, "fetchProjectBusPrioritysSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(showProjectBusPriorityMessage, "showProjectBusPriorityMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(addFavouriteProjectBusPriority, "addFavouriteProjectBusPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(addFavouriteProjectBusPrioritySuccess, "addFavouriteProjectBusPrioritySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(onProjectBusPrioritySelect, "onProjectBusPrioritySelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(onAddProjectBusPriority, "onAddProjectBusPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(onEditProjectBusPriority, "onEditProjectBusPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(onProjectBusPriorityClose, "onProjectBusPriorityClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(onFilterProjectBusPriorityOptionSelect, "onFilterProjectBusPriorityOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(onSaveProjectBusPriority, "onSaveProjectBusPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(onSaveProjectBusPrioritySuccess, "onSaveProjectBusPrioritySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(onDeleteProjectBusPriority, "onDeleteProjectBusPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(onDeleteProjectBusPrioritySuccess, "onDeleteProjectBusPrioritySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(onFilterSelectedProjectBusPriority, "onFilterSelectedProjectBusPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(filterProjectBusPriority, "filterProjectBusPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(getAllProjectBusPriority, "getAllProjectBusPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllProjectBusPriority, "getUnselectedAllProjectBusPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(onAllProjectBusPrioritySelect, "onAllProjectBusPrioritySelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(updateSearchProjectBusPriority, "updateSearchProjectBusPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(onToggleProjectBusPriorityDrawer, "onToggleProjectBusPriorityDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(handleProjectBusPriorityRequestClose, "handleProjectBusPriorityRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(showProjectBusPriorityLoader, "showProjectBusPriorityLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(hideProjectBusPriorityLoader, "hideProjectBusPriorityLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectBusPriority.js");
}();

;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideProjectCostPriorityLoader = exports.showProjectCostPriorityLoader = exports.handleProjectCostPriorityRequestClose = exports.onToggleProjectCostPriorityDrawer = exports.updateSearchProjectCostPriority = exports.onAllProjectCostPrioritySelect = exports.getUnselectedAllProjectCostPriority = exports.getAllProjectCostPriority = exports.filterProjectCostPriority = exports.onFilterSelectedProjectCostPriority = exports.onDeleteProjectCostPrioritySuccess = exports.onDeleteProjectCostPriority = exports.onSaveProjectCostPrioritySuccess = exports.onSaveProjectCostPriority = exports.onFilterProjectCostPriorityOptionSelect = exports.onProjectCostPriorityClose = exports.onEditProjectCostPriority = exports.onAddProjectCostPriority = exports.onProjectCostPrioritySelect = exports.addFavouriteProjectCostPrioritySuccess = exports.addFavouriteProjectCostPriority = exports.showProjectCostPriorityMessage = exports.fetchProjectCostPrioritysSuccess = exports.fetchProjectCostPrioritys = exports.fetchProjectCostPrioritySuccess = exports.fetchProjectCostPriority = void 0;

var _ActionTypes = __webpack_require__(7);

var fetchProjectCostPriority = function fetchProjectCostPriority(payload) {
  return {
    type: _ActionTypes.FETCH_PROJECT_COST_PRIORITY,
    payload: payload
  };
};

exports.fetchProjectCostPriority = fetchProjectCostPriority;

var fetchProjectCostPrioritySuccess = function fetchProjectCostPrioritySuccess(payload) {
  return {
    type: _ActionTypes.FETCH_PROJECT_COST_PRIORITY_SUCCESS,
    payload: payload
  };
};

exports.fetchProjectCostPrioritySuccess = fetchProjectCostPrioritySuccess;

var fetchProjectCostPrioritys = function fetchProjectCostPrioritys() {
  return {
    type: _ActionTypes.FETCH_ALL_PROJECT_COST_PRIORITY
  };
};

exports.fetchProjectCostPrioritys = fetchProjectCostPrioritys;

var fetchProjectCostPrioritysSuccess = function fetchProjectCostPrioritysSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_ALL_PROJECT_COST_PRIORITY_SUCCESS,
    payload: payload
  };
};

exports.fetchProjectCostPrioritysSuccess = fetchProjectCostPrioritysSuccess;

var showProjectCostPriorityMessage = function showProjectCostPriorityMessage(message) {
  return {
    type: _ActionTypes.SHOW_PROJECT_COST_PRIORITY_MESSAGE,
    payload: message
  };
};

exports.showProjectCostPriorityMessage = showProjectCostPriorityMessage;

var addFavouriteProjectCostPriority = function addFavouriteProjectCostPriority(payload) {
  return {
    type: _ActionTypes.ADD_FAVOURITE_PROJECT_COST_PRIORITY,
    payload: payload
  };
};

exports.addFavouriteProjectCostPriority = addFavouriteProjectCostPriority;

var addFavouriteProjectCostPrioritySuccess = function addFavouriteProjectCostPrioritySuccess(payload) {
  return {
    type: _ActionTypes.ADD_FAVOURITE_PROJECT_COST_PRIORITY_SUCCESS,
    payload: payload
  };
};

exports.addFavouriteProjectCostPrioritySuccess = addFavouriteProjectCostPrioritySuccess;

var onProjectCostPrioritySelect = function onProjectCostPrioritySelect(payload) {
  return {
    type: _ActionTypes.ON_PROJECT_COST_PRIORITY_SELECT,
    payload: payload
  };
};

exports.onProjectCostPrioritySelect = onProjectCostPrioritySelect;

var onAddProjectCostPriority = function onAddProjectCostPriority() {
  return {
    type: _ActionTypes.ON_ADD_PROJECT_COST_PRIORITY
  };
};

exports.onAddProjectCostPriority = onAddProjectCostPriority;

var onEditProjectCostPriority = function onEditProjectCostPriority(payload) {
  return {
    type: _ActionTypes.ON_EDIT_PROJECT_COST_PRIORITY,
    payload: payload
  };
};

exports.onEditProjectCostPriority = onEditProjectCostPriority;

var onProjectCostPriorityClose = function onProjectCostPriorityClose() {
  return {
    type: _ActionTypes.ON_PROJECT_COST_PRIORITY_CLOSE
  };
};

exports.onProjectCostPriorityClose = onProjectCostPriorityClose;

var onFilterProjectCostPriorityOptionSelect = function onFilterProjectCostPriorityOptionSelect(payload) {
  return {
    type: _ActionTypes.ON_FILTER_PROJECT_COST_PRIORITY_OPTION_SELECT,
    payload: payload
  };
};

exports.onFilterProjectCostPriorityOptionSelect = onFilterProjectCostPriorityOptionSelect;

var onSaveProjectCostPriority = function onSaveProjectCostPriority(payload) {
  return {
    type: _ActionTypes.ON_SAVE_PROJECT_COST_PRIORITY,
    payload: payload
  };
};

exports.onSaveProjectCostPriority = onSaveProjectCostPriority;

var onSaveProjectCostPrioritySuccess = function onSaveProjectCostPrioritySuccess(data) {
  return {
    type: _ActionTypes.ON_SAVE_PROJECT_COST_PRIORITY_SUCCESS,
    payload: data
  };
};

exports.onSaveProjectCostPrioritySuccess = onSaveProjectCostPrioritySuccess;

var onDeleteProjectCostPriority = function onDeleteProjectCostPriority(payload) {
  return {
    type: _ActionTypes.ON_DELETE_PROJECT_COST_PRIORITY,
    payload: payload
  };
};

exports.onDeleteProjectCostPriority = onDeleteProjectCostPriority;

var onDeleteProjectCostPrioritySuccess = function onDeleteProjectCostPrioritySuccess(payload) {
  return {
    type: _ActionTypes.ON_DELETE_PROJECT_COST_PRIORITY_SUCCESS,
    payload: payload
  };
};

exports.onDeleteProjectCostPrioritySuccess = onDeleteProjectCostPrioritySuccess;

var onFilterSelectedProjectCostPriority = function onFilterSelectedProjectCostPriority() {
  return {
    type: _ActionTypes.ON_FILTER_SELECTED_PROJECT_COST_PRIORITY,
    payload: ''
  };
};

exports.onFilterSelectedProjectCostPriority = onFilterSelectedProjectCostPriority;

var filterProjectCostPriority = function filterProjectCostPriority(payload) {
  return {
    type: _ActionTypes.FILTER_PROJECT_COST_PRIORITY,
    payload: payload
  };
};

exports.filterProjectCostPriority = filterProjectCostPriority;

var getAllProjectCostPriority = function getAllProjectCostPriority() {
  return {
    type: _ActionTypes.GET_ALL_PROJECT_COST_PRIORITY,
    payload: ''
  };
};

exports.getAllProjectCostPriority = getAllProjectCostPriority;

var getUnselectedAllProjectCostPriority = function getUnselectedAllProjectCostPriority() {
  return {
    type: _ActionTypes.GET_UNSELECTED_ALL_PROJECT_COST_PRIORITY,
    payload: ''
  };
};

exports.getUnselectedAllProjectCostPriority = getUnselectedAllProjectCostPriority;

var onAllProjectCostPrioritySelect = function onAllProjectCostPrioritySelect() {
  return {
    type: _ActionTypes.ON_ALL_PROJECT_COST_PRIORITY_SELECT,
    payload: ''
  };
};

exports.onAllProjectCostPrioritySelect = onAllProjectCostPrioritySelect;

var updateSearchProjectCostPriority = function updateSearchProjectCostPriority(payload) {
  return {
    type: _ActionTypes.UPDATE_SEARCH_PROJECT_COST_PRIORITY,
    payload: payload
  };
};

exports.updateSearchProjectCostPriority = updateSearchProjectCostPriority;

var onToggleProjectCostPriorityDrawer = function onToggleProjectCostPriorityDrawer() {
  return {
    type: _ActionTypes.ON_TOGGLE_PROJECT_COST_PRIORITY_DRAWER
  };
};

exports.onToggleProjectCostPriorityDrawer = onToggleProjectCostPriorityDrawer;

var handleProjectCostPriorityRequestClose = function handleProjectCostPriorityRequestClose() {
  return {
    type: _ActionTypes.HANDLE_PROJECT_COST_PRIORITY_REQUEST_CLOSE
  };
};

exports.handleProjectCostPriorityRequestClose = handleProjectCostPriorityRequestClose;

var showProjectCostPriorityLoader = function showProjectCostPriorityLoader() {
  return {
    type: _ActionTypes.SHOW_PROJECT_COST_PRIORITY_LOADER
  };
};

exports.showProjectCostPriorityLoader = showProjectCostPriorityLoader;

var hideProjectCostPriorityLoader = function hideProjectCostPriorityLoader() {
  return {
    type: _ActionTypes.HIDE_PROJECT_COST_PRIORITY_LOADER
  };
};

exports.hideProjectCostPriorityLoader = hideProjectCostPriorityLoader;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchProjectCostPriority, "fetchProjectCostPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(fetchProjectCostPrioritySuccess, "fetchProjectCostPrioritySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(fetchProjectCostPrioritys, "fetchProjectCostPrioritys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(fetchProjectCostPrioritysSuccess, "fetchProjectCostPrioritysSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(showProjectCostPriorityMessage, "showProjectCostPriorityMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(addFavouriteProjectCostPriority, "addFavouriteProjectCostPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(addFavouriteProjectCostPrioritySuccess, "addFavouriteProjectCostPrioritySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(onProjectCostPrioritySelect, "onProjectCostPrioritySelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(onAddProjectCostPriority, "onAddProjectCostPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(onEditProjectCostPriority, "onEditProjectCostPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(onProjectCostPriorityClose, "onProjectCostPriorityClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(onFilterProjectCostPriorityOptionSelect, "onFilterProjectCostPriorityOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(onSaveProjectCostPriority, "onSaveProjectCostPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(onSaveProjectCostPrioritySuccess, "onSaveProjectCostPrioritySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(onDeleteProjectCostPriority, "onDeleteProjectCostPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(onDeleteProjectCostPrioritySuccess, "onDeleteProjectCostPrioritySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(onFilterSelectedProjectCostPriority, "onFilterSelectedProjectCostPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(filterProjectCostPriority, "filterProjectCostPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(getAllProjectCostPriority, "getAllProjectCostPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllProjectCostPriority, "getUnselectedAllProjectCostPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(onAllProjectCostPrioritySelect, "onAllProjectCostPrioritySelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(updateSearchProjectCostPriority, "updateSearchProjectCostPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(onToggleProjectCostPriorityDrawer, "onToggleProjectCostPriorityDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(handleProjectCostPriorityRequestClose, "handleProjectCostPriorityRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(showProjectCostPriorityLoader, "showProjectCostPriorityLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(hideProjectCostPriorityLoader, "hideProjectCostPriorityLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchProjectCostPriority, "fetchProjectCostPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(fetchProjectCostPrioritySuccess, "fetchProjectCostPrioritySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(fetchProjectCostPrioritys, "fetchProjectCostPrioritys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(fetchProjectCostPrioritysSuccess, "fetchProjectCostPrioritysSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(showProjectCostPriorityMessage, "showProjectCostPriorityMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(addFavouriteProjectCostPriority, "addFavouriteProjectCostPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(addFavouriteProjectCostPrioritySuccess, "addFavouriteProjectCostPrioritySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(onProjectCostPrioritySelect, "onProjectCostPrioritySelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(onAddProjectCostPriority, "onAddProjectCostPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(onEditProjectCostPriority, "onEditProjectCostPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(onProjectCostPriorityClose, "onProjectCostPriorityClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(onFilterProjectCostPriorityOptionSelect, "onFilterProjectCostPriorityOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(onSaveProjectCostPriority, "onSaveProjectCostPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(onSaveProjectCostPrioritySuccess, "onSaveProjectCostPrioritySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(onDeleteProjectCostPriority, "onDeleteProjectCostPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(onDeleteProjectCostPrioritySuccess, "onDeleteProjectCostPrioritySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(onFilterSelectedProjectCostPriority, "onFilterSelectedProjectCostPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(filterProjectCostPriority, "filterProjectCostPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(getAllProjectCostPriority, "getAllProjectCostPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllProjectCostPriority, "getUnselectedAllProjectCostPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(onAllProjectCostPrioritySelect, "onAllProjectCostPrioritySelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(updateSearchProjectCostPriority, "updateSearchProjectCostPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(onToggleProjectCostPriorityDrawer, "onToggleProjectCostPriorityDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(handleProjectCostPriorityRequestClose, "handleProjectCostPriorityRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(showProjectCostPriorityLoader, "showProjectCostPriorityLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(hideProjectCostPriorityLoader, "hideProjectCostPriorityLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectCostPriority.js");
}();

;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(120);
var createDesc = __webpack_require__(215);
module.exports = __webpack_require__(121) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(184);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 184 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 185 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(122)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return warn; });
/* eslint no-console: 0 */
var isDev = "production" !== 'production';
var warn = function warn(condition, format, a, b, c, d, e, f) {
  if (isDev && typeof console !== 'undefined' && console.warn) {
    if (format === undefined) {
      console.warn('LogUtils requires an error message argument');
    }

    if (!condition) {
      if (format === undefined) {
        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
      } else {
        var args = [a, b, c, d, e, f];
        var argIndex = 0;
        console.warn(format.replace(/%s/g, function () {
          return args[argIndex++];
        }));
      }
    }
  }
};

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_ReactUtils__ = __webpack_require__(12);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @fileOverview Cross
 */


function Cell() {
  return null;
}

Cell.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_0__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */]);
Cell.displayName = 'Cell';
/* harmony default export */ __webpack_exports__["a"] = (Cell);

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
});


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color_js__ = __webpack_require__(404);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__color_js__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__color_js__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__color_js__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lab_js__ = __webpack_require__(1634);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__lab_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__lab_js__["b"]; });
/* unused harmony reexport lch */
/* unused harmony reexport gray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cubehelix_js__ = __webpack_require__(1635);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__cubehelix_js__["a"]; });





/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = hue;
/* harmony export (immutable) */ __webpack_exports__["b"] = gamma;
/* harmony export (immutable) */ __webpack_exports__["a"] = nogamma;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(756);


function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isArray__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_shape__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_DataUtils__ = __webpack_require__(23);



function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Curve
 */






var CURVE_FACTORIES = {
  curveBasisClosed: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["c" /* curveBasisClosed */],
  curveBasisOpen: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["d" /* curveBasisOpen */],
  curveBasis: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["b" /* curveBasis */],
  curveLinearClosed: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["f" /* curveLinearClosed */],
  curveLinear: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["e" /* curveLinear */],
  curveMonotoneX: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["g" /* curveMonotoneX */],
  curveMonotoneY: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["h" /* curveMonotoneY */],
  curveNatural: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["i" /* curveNatural */],
  curveStep: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["j" /* curveStep */],
  curveStepAfter: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["k" /* curveStepAfter */],
  curveStepBefore: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["l" /* curveStepBefore */]
};

var defined = function defined(p) {
  return p.x === +p.x && p.y === +p.y;
};

var getX = function getX(p) {
  return p.x;
};

var getY = function getY(p) {
  return p.y;
};

var getCurveFactory = function getCurveFactory(type, layout) {
  if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(type)) {
    return type;
  }

  var name = "curve".concat(type.slice(0, 1).toUpperCase()).concat(type.slice(1));

  if (name === 'curveMonotone' && layout) {
    return CURVE_FACTORIES["".concat(name).concat(layout === 'vertical' ? 'Y' : 'X')];
  }

  return CURVE_FACTORIES[name] || __WEBPACK_IMPORTED_MODULE_4_d3_shape__["e" /* curveLinear */];
};

var Curve =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Curve, _PureComponent);

  function Curve() {
    _classCallCheck(this, Curve);

    return _possibleConstructorReturn(this, _getPrototypeOf(Curve).apply(this, arguments));
  }

  _createClass(Curve, [{
    key: "getPath",

    /**
     * Calculate the path of curve
     * @return {String} path
     */
    value: function getPath() {
      var _this$props = this.props,
          type = _this$props.type,
          points = _this$props.points,
          baseLine = _this$props.baseLine,
          layout = _this$props.layout,
          connectNulls = _this$props.connectNulls;
      var curveFactory = getCurveFactory(type, layout);
      var formatPoints = connectNulls ? points.filter(function (entry) {
        return defined(entry);
      }) : points;
      var lineFunction;

      if (__WEBPACK_IMPORTED_MODULE_0_lodash_isArray___default()(baseLine)) {
        var formatBaseLine = connectNulls ? baseLine.filter(function (base) {
          return defined(base);
        }) : baseLine;
        var areaPoints = formatPoints.map(function (entry, index) {
          return _objectSpread({}, entry, {
            base: formatBaseLine[index]
          });
        });

        if (layout === 'vertical') {
          lineFunction = Object(__WEBPACK_IMPORTED_MODULE_4_d3_shape__["a" /* area */])().y(getY).x1(getX).x0(function (d) {
            return d.base.x;
          });
        } else {
          lineFunction = Object(__WEBPACK_IMPORTED_MODULE_4_d3_shape__["a" /* area */])().x(getX).y1(getY).y0(function (d) {
            return d.base.y;
          });
        }

        lineFunction.defined(defined).curve(curveFactory);
        return lineFunction(areaPoints);
      }

      if (layout === 'vertical' && Object(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["h" /* isNumber */])(baseLine)) {
        lineFunction = Object(__WEBPACK_IMPORTED_MODULE_4_d3_shape__["a" /* area */])().y(getY).x1(getX).x0(baseLine);
      } else if (Object(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["h" /* isNumber */])(baseLine)) {
        lineFunction = Object(__WEBPACK_IMPORTED_MODULE_4_d3_shape__["a" /* area */])().x(getX).y1(getY).y0(baseLine);
      } else {
        lineFunction = Object(__WEBPACK_IMPORTED_MODULE_4_d3_shape__["m" /* line */])().x(getX).y(getY);
      }

      lineFunction.defined(defined).curve(curveFactory);
      return lineFunction(formatPoints);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          points = _this$props2.points,
          path = _this$props2.path,
          pathRef = _this$props2.pathRef;

      if ((!points || !points.length) && !path) {
        return null;
      }

      var realPath = points && points.length ? this.getPath() : path;
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("path", _extends({}, Object(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["l" /* getPresentationAttributes */])(this.props), Object(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["f" /* filterEventAttributes */])(this.props, null, true), {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()('recharts-curve', className),
        d: realPath,
        ref: pathRef
      }));
    }
  }]);

  return Curve;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);

Curve.displayName = 'Curve';
Curve.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func]),
  layout: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['horizontal', 'vertical']),
  baseLine: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array]),
  points: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object),
  connectNulls: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  pathRef: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
});
Curve.defaultProps = {
  type: 'linear',
  points: [],
  connectNulls: false
};
/* harmony default export */ __webpack_exports__["a"] = (Curve);

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_smooth__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__ = __webpack_require__(12);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Rectangle
 */






var getRectangePath = function getRectangePath(x, y, width, height, radius) {
  var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
  var ySign = height >= 0 ? 1 : -1;
  var xSign = width >= 0 ? 1 : -1;
  var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
  var path;

  if (maxRadius > 0 && radius instanceof Array) {
    var newRadius = [];

    for (var i = 0, len = 4; i < len; i++) {
      newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
    }

    path = "M".concat(x, ",").concat(y + ySign * newRadius[0]);

    if (newRadius[0] > 0) {
      path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x + xSign * newRadius[0], ",").concat(y);
    }

    path += "L ".concat(x + width - xSign * newRadius[1], ",").concat(y);

    if (newRadius[1] > 0) {
      path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x + width, ",").concat(y + ySign * newRadius[1]);
    }

    path += "L ".concat(x + width, ",").concat(y + height - ySign * newRadius[2]);

    if (newRadius[2] > 0) {
      path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x + width - xSign * newRadius[2], ",").concat(y + height);
    }

    path += "L ".concat(x + xSign * newRadius[3], ",").concat(y + height);

    if (newRadius[3] > 0) {
      path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x, ",").concat(y + height - ySign * newRadius[3]);
    }

    path += 'Z';
  } else if (maxRadius > 0 && radius === +radius && radius > 0) {
    var _newRadius = Math.min(maxRadius, radius);

    path = "M ".concat(x, ",").concat(y + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + xSign * _newRadius, ",").concat(y, "\n            L ").concat(x + width - xSign * _newRadius, ",").concat(y, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width, ",").concat(y + ySign * _newRadius, "\n            L ").concat(x + width, ",").concat(y + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width - xSign * _newRadius, ",").concat(y + height, "\n            L ").concat(x + xSign * _newRadius, ",").concat(y + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x, ",").concat(y + height - ySign * _newRadius, " Z");
  } else {
    path = "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
  }

  return path;
};

var Rectangle =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Rectangle, _PureComponent);

  function Rectangle() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Rectangle);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Rectangle)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      totalLength: -1
    };
    return _this;
  }

  _createClass(Rectangle, [{
    key: "componentDidMount",

    /* eslint-disable  react/no-did-mount-set-state */
    value: function componentDidMount() {
      if (this.node && this.node.getTotalLength) {
        try {
          var totalLength = this.node.getTotalLength();

          if (totalLength) {
            this.setState({
              totalLength: totalLength
            });
          }
        } catch (err) {// calculate total length error
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          x = _this$props.x,
          y = _this$props.y,
          width = _this$props.width,
          height = _this$props.height,
          radius = _this$props.radius,
          className = _this$props.className;
      var totalLength = this.state.totalLength;
      var _this$props2 = this.props,
          animationEasing = _this$props2.animationEasing,
          animationDuration = _this$props2.animationDuration,
          animationBegin = _this$props2.animationBegin,
          isAnimationActive = _this$props2.isAnimationActive,
          isUpdateAnimationActive = _this$props2.isUpdateAnimationActive;

      if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) {
        return null;
      }

      var layerClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('recharts-rectangle', className);

      if (!isUpdateAnimationActive) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", _extends({}, Object(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["l" /* getPresentationAttributes */])(this.props), Object(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["f" /* filterEventAttributes */])(this.props), {
          className: layerClass,
          d: getRectangePath(x, y, width, height, radius)
        }));
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_smooth__["a" /* default */], {
        canBegin: totalLength > 0,
        from: {
          width: width,
          height: height,
          x: x,
          y: y
        },
        to: {
          width: width,
          height: height,
          x: x,
          y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
      }, function (_ref) {
        var currWidth = _ref.width,
            currHeight = _ref.height,
            currX = _ref.x,
            currY = _ref.y;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_smooth__["a" /* default */], {
          canBegin: totalLength > 0,
          from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
          to: "".concat(totalLength, "px 0px"),
          attributeName: "strokeDasharray",
          begin: animationBegin,
          duration: animationDuration,
          isActive: isAnimationActive,
          easing: animationEasing
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", _extends({}, Object(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["l" /* getPresentationAttributes */])(_this2.props), Object(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["f" /* filterEventAttributes */])(_this2.props), {
          className: layerClass,
          d: getRectangePath(currX, currY, currWidth, currHeight, radius),
          ref: function ref(node) {
            _this2.node = node;
          }
        })));
      });
    }
  }]);

  return Rectangle;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Rectangle.displayName = 'Rectangle';
Rectangle.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {}, __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["a" /* EVENT_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  x: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  y: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  radius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]),
  isAnimationActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isUpdateAnimationActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  animationBegin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
});
Rectangle.defaultProps = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  // The radius of border
  // The radius of four corners when radius is a number
  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
  radius: 0,
  isAnimationActive: false,
  isUpdateAnimationActive: false,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease'
};
/* harmony default export */ __webpack_exports__["a"] = (Rectangle);

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_ReactUtils__ = __webpack_require__(12);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview X Axis
 */




var XAxis =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(XAxis, _PureComponent);

  function XAxis() {
    _classCallCheck(this, XAxis);

    return _possibleConstructorReturn(this, _getPrototypeOf(XAxis).apply(this, arguments));
  }

  _createClass(XAxis, [{
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return XAxis;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

XAxis.displayName = 'XAxis';
XAxis.propTypes = {
  allowDecimals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  allowDuplicatedCategory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  // The name of data displayed in the axis
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  // The unit of data displayed in the axis
  unit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  // The unique id of x-axis
  xAxisId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  domain: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['auto', 'dataMin', 'dataMax'])])),
  // The key of data displayed in the axis
  dataKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  // The width of axis which is usually calculated internally
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  // The height of axis, which need to be setted by user
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  mirror: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  // The orientation of axis
  orientation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['top', 'bottom']),
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['number', 'category']),
  // Ticks can be any type when the axis is the type of category
  // Ticks must be numbers when the axis is the type of number
  ticks: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  // The count of ticks
  tickCount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  // The formatter function of tick
  tickFormatter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  padding: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    right: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  allowDataOverflow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_2__util_ReactUtils__["d" /* SCALE_TYPES */]), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  tick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]),
  axisLine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
  tickLine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
  minTickGap: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  tickSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  interval: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])]),
  reversed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
XAxis.defaultProps = {
  allowDecimals: true,
  hide: false,
  orientation: 'bottom',
  width: 0,
  height: 30,
  mirror: false,
  xAxisId: 0,
  tickCount: 5,
  type: 'category',
  domain: [0, 'auto'],
  padding: {
    left: 0,
    right: 0
  },
  allowDataOverflow: false,
  scale: 'auto',
  reversed: false,
  allowDuplicatedCategory: true
};
/* harmony default export */ __webpack_exports__["a"] = (XAxis);

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Y Axis
 */



var YAxis =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(YAxis, _PureComponent);

  function YAxis() {
    _classCallCheck(this, YAxis);

    return _possibleConstructorReturn(this, _getPrototypeOf(YAxis).apply(this, arguments));
  }

  _createClass(YAxis, [{
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return YAxis;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

YAxis.displayName = 'YAxis';
YAxis.propTypes = {
  allowDecimals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  allowDuplicatedCategory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  // The name of data displayed in the axis
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  // The unit of data displayed in the axis
  unit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  // The unique id of y-axis
  yAxisId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  domain: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['auto', 'dataMin', 'dataMax'])])),
  // The key of data displayed in the axis
  dataKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  // Ticks can be any type when the axis is the type of category
  // Ticks must be numbers when the axis is the type of number
  ticks: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  // The count of ticks
  tickCount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  // The formatter function of tick
  tickFormatter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  // The width of axis, which need to be setted by user
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  // The height of axis which is usually calculated in Chart
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  mirror: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  // The orientation of axis
  orientation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['left', 'right']),
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['number', 'category']),
  padding: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  allowDataOverflow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utc', 'sequential', 'threshold']), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  tick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]),
  axisLine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
  tickLine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
  minTickGap: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  tickSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  interval: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])]),
  reversed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
YAxis.defaultProps = {
  allowDuplicatedCategory: true,
  allowDecimals: true,
  hide: false,
  orientation: 'left',
  width: 60,
  height: 0,
  mirror: false,
  yAxisId: 0,
  tickCount: 5,
  type: 'number',
  domain: [0, 'auto'],
  padding: {
    top: 0,
    bottom: 0
  },
  allowDataOverflow: false,
  scale: 'auto',
  reversed: false
};
/* harmony default export */ __webpack_exports__["a"] = (YAxis);

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1765);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(65)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js!./style.css", function() {
			var newContent = require("!!../../css-loader/index.js!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(429),
    baseAssignValue = __webpack_require__(317);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1080);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

/*
  Used to import DayPickerInput. e.g. `import DayPickerInput from 'react-day-picker/DayPickerInput'`
*/

/* eslint-disable no-var */
/* eslint-env node */

var DayPickerInput = __webpack_require__(1766);

module.exports = DayPickerInput;


/***/ }),
/* 202 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(170);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(96);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 205 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(96);
var TAG = __webpack_require__(28)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(19);
var aFunction = __webpack_require__(85);
var SPECIES = __webpack_require__(28)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* harmony default export */ __webpack_exports__["default"] = (warning);


/***/ }),
/* 209 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.remove = exports.request = exports.update = exports.post = exports.get = void 0;

var _ApiConfig = __webpack_require__(145);

var _lodash = __webpack_require__(72);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 * 
 * @param {*} url 
 * @param {*} headers 
 */


var get = function get(url, headers) {
  if (headers && !Array.isArray(headers) && (0, _lodash.isObject)(headers)) {
    return _ApiConfig.apiConfig.get(url, headers);
  } else {
    return _ApiConfig.apiConfig.get(url);
  }
};
/**
 * 
 * @param {string} url 
 * @param {data object} params 
 * @param {object} headers - optional headers to be added to the post (i.e. audit).
 * see instance.interceptors.request.use in ApiConfig for std headers that are added by default
 */


exports.get = get;

var post = function post(url, params, headers) {
  if (headers && !Array.isArray(headers) && (0, _lodash.isObject)(headers)) {
    return _ApiConfig.apiConfig.post(url, _objectSpread({}, params), {
      'headers': headers
    });
  } else {
    return _ApiConfig.apiConfig.post(url, _objectSpread({}, params));
  }
};
/**
 * 
 * @param {string} url 
 * @param {data object} params 
 * @param {object} headers - optional headers to be added to the update (i.e. audit).
 * see instance.interceptors.request.use in ApiConfig for std headers that are added by default
 */


exports.post = post;

var update = function update(url, params, headers) {
  if (headers && !Array.isArray(headers) && (0, _lodash.isObject)(headers)) {
    return _ApiConfig.apiConfig.put(url, _objectSpread({}, params), {
      'headers': headers
    });
  } else {
    return _ApiConfig.apiConfig.put(url, _objectSpread({}, params));
  }
};
/**
 * 
 * @param {string} url 
 * @param {data object} params 
 * @param {object} headers - optional headers to be added to the request (i.e. audit).
 * see instance.interceptors.request.use in ApiConfig for std headers that are added by default
 */


exports.update = update;

var request = function request(url, params, headers) {
  if (headers && !Array.isArray(headers)) {
    return _ApiConfig.apiConfig.request(url, _objectSpread({}, params), {
      'headers': headers
    });
  } else {
    return _ApiConfig.apiConfig.request(url, _objectSpread({}, params));
  }
};
/**
 * 
 * @param {string} url 
 * @param {object} headers - optional headers to be added to the request (i.e. audit).
 * see instance.interceptors.request.use in ApiConfig for std headers that are added by default
 */


exports.request = request;

var remove = function remove(url, headers) {
  if (headers && !Array.isArray(headers)) {
    return _ApiConfig.apiConfig["delete"](url, {
      'headers': headers
    });
  } else {
    return _ApiConfig.apiConfig["delete"](url);
  }
};

exports.remove = remove;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(get, "get", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiClient.js");

  __REACT_HOT_LOADER__.register(post, "post", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiClient.js");

  __REACT_HOT_LOADER__.register(update, "update", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiClient.js");

  __REACT_HOT_LOADER__.register(request, "request", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiClient.js");

  __REACT_HOT_LOADER__.register(remove, "remove", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiClient.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiClient.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiClient.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiClient.js");

  __REACT_HOT_LOADER__.register(get, "get", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiClient.js");

  __REACT_HOT_LOADER__.register(post, "post", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiClient.js");

  __REACT_HOT_LOADER__.register(update, "update", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiClient.js");

  __REACT_HOT_LOADER__.register(request, "request", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiClient.js");

  __REACT_HOT_LOADER__.register(remove, "remove", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiClient.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/ApiClient.js");
}();

;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleAnswersMessageClose = exports.hideOrgSurveyAnswersLoader = exports.showOrgSurveyAnswersLoader = exports.onSaveOrgSurveyAnswersSuccess = exports.onSaveOrgSurveyAnswers = exports.showOrgSurveyAnswersMessage = exports.fetchOrgSurveyAnswersSuccess = exports.fetchOrgSurveyAnswers = void 0;

var _ActionTypes = __webpack_require__(7);

var fetchOrgSurveyAnswers = function fetchOrgSurveyAnswers(payload) {
  return {
    type: _ActionTypes.FETCH_ORG_SURVEY_ANSWERS,
    payload: payload
  };
};

exports.fetchOrgSurveyAnswers = fetchOrgSurveyAnswers;

var fetchOrgSurveyAnswersSuccess = function fetchOrgSurveyAnswersSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_ORG_SURVEY_ANSWERS_SUCCESS,
    payload: payload
  };
};

exports.fetchOrgSurveyAnswersSuccess = fetchOrgSurveyAnswersSuccess;

var showOrgSurveyAnswersMessage = function showOrgSurveyAnswersMessage(message) {
  return {
    type: _ActionTypes.SHOW_ORG_SURVEY_ANSWERS_MESSAGE,
    payload: message
  };
};

exports.showOrgSurveyAnswersMessage = showOrgSurveyAnswersMessage;

var onSaveOrgSurveyAnswers = function onSaveOrgSurveyAnswers(payload) {
  return {
    type: _ActionTypes.ON_SAVE_ORG_SURVEY_ANSWERS,
    payload: payload
  };
};

exports.onSaveOrgSurveyAnswers = onSaveOrgSurveyAnswers;

var onSaveOrgSurveyAnswersSuccess = function onSaveOrgSurveyAnswersSuccess(data) {
  return {
    type: _ActionTypes.ON_SAVE_ORG_SURVEY_ANSWERS_SUCCESS,
    payload: data
  };
};

exports.onSaveOrgSurveyAnswersSuccess = onSaveOrgSurveyAnswersSuccess;

var showOrgSurveyAnswersLoader = function showOrgSurveyAnswersLoader() {
  return {
    type: _ActionTypes.SHOW_ORG_SURVEY_ANSWERS_LOADER
  };
};

exports.showOrgSurveyAnswersLoader = showOrgSurveyAnswersLoader;

var hideOrgSurveyAnswersLoader = function hideOrgSurveyAnswersLoader() {
  return {
    type: _ActionTypes.HIDE_ORG_SURVEY_ANSWERS_LOADER
  };
};

exports.hideOrgSurveyAnswersLoader = hideOrgSurveyAnswersLoader;

var handleAnswersMessageClose = function handleAnswersMessageClose() {
  return {
    type: _ActionTypes.HANDLE_ORG_SURVEY_ANSWER_MESSAGE_CLOSE
  };
};

exports.handleAnswersMessageClose = handleAnswersMessageClose;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchOrgSurveyAnswers, "fetchOrgSurveyAnswers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurveyAnswers.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveyAnswersSuccess, "fetchOrgSurveyAnswersSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurveyAnswers.js");

  __REACT_HOT_LOADER__.register(showOrgSurveyAnswersMessage, "showOrgSurveyAnswersMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurveyAnswers.js");

  __REACT_HOT_LOADER__.register(onSaveOrgSurveyAnswers, "onSaveOrgSurveyAnswers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurveyAnswers.js");

  __REACT_HOT_LOADER__.register(onSaveOrgSurveyAnswersSuccess, "onSaveOrgSurveyAnswersSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurveyAnswers.js");

  __REACT_HOT_LOADER__.register(showOrgSurveyAnswersLoader, "showOrgSurveyAnswersLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurveyAnswers.js");

  __REACT_HOT_LOADER__.register(hideOrgSurveyAnswersLoader, "hideOrgSurveyAnswersLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurveyAnswers.js");

  __REACT_HOT_LOADER__.register(handleAnswersMessageClose, "handleAnswersMessageClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurveyAnswers.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchOrgSurveyAnswers, "fetchOrgSurveyAnswers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurveyAnswers.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveyAnswersSuccess, "fetchOrgSurveyAnswersSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurveyAnswers.js");

  __REACT_HOT_LOADER__.register(showOrgSurveyAnswersMessage, "showOrgSurveyAnswersMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurveyAnswers.js");

  __REACT_HOT_LOADER__.register(onSaveOrgSurveyAnswers, "onSaveOrgSurveyAnswers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurveyAnswers.js");

  __REACT_HOT_LOADER__.register(onSaveOrgSurveyAnswersSuccess, "onSaveOrgSurveyAnswersSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurveyAnswers.js");

  __REACT_HOT_LOADER__.register(showOrgSurveyAnswersLoader, "showOrgSurveyAnswersLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurveyAnswers.js");

  __REACT_HOT_LOADER__.register(hideOrgSurveyAnswersLoader, "hideOrgSurveyAnswersLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurveyAnswers.js");

  __REACT_HOT_LOADER__.register(handleAnswersMessageClose, "handleAnswersMessageClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurveyAnswers.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/OrgSurveyAnswers.js");
}();

;

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_popper__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(9);





/* eslint react/no-find-dom-node: 0 */
// https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/no-find-dom-node.md






var propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  dropup: Object(__WEBPACK_IMPORTED_MODULE_9__utils__["deprecated"])(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool, 'Please use the prop "direction" with the value "up".'),
  direction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['up', 'down', 'left', 'right']),
  group: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  isOpen: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  nav: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  addonType: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['prepend', 'append'])]),
  size: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_9__utils__["tagPropType"],
  toggle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  inNavbar: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  setActiveFromChild: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var defaultProps = {
  isOpen: false,
  direction: 'down',
  nav: false,
  active: false,
  addonType: false,
  inNavbar: false,
  setActiveFromChild: false
};
var childContextTypes = {
  toggle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  isOpen: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired,
  direction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['up', 'down', 'left', 'right']).isRequired,
  inNavbar: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired
};

var Dropdown =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Dropdown, _React$Component);

  function Dropdown(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.addEvents = _this.addEvents.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleDocumentClick = _this.handleDocumentClick.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleKeyDown = _this.handleKeyDown.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.removeEvents = _this.removeEvents.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.toggle = _this.toggle.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = Dropdown.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      toggle: this.props.toggle,
      isOpen: this.props.isOpen,
      direction: this.props.direction === 'down' && this.props.dropup ? 'up' : this.props.direction,
      inNavbar: this.props.inNavbar
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.handleProps();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.isOpen !== prevProps.isOpen) {
      this.handleProps();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.removeEvents();
  };

  _proto.getContainer = function getContainer() {
    if (this._$container) return this._$container;
    this._$container = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this);
    return __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this);
  };

  _proto.getMenuCtrl = function getMenuCtrl() {
    if (this._$menuCtrl) return this._$menuCtrl;
    this._$menuCtrl = this.getContainer().querySelector('[aria-expanded]');
    return this._$menuCtrl;
  };

  _proto.getMenuItems = function getMenuItems() {
    return [].slice.call(this.getContainer().querySelectorAll('[role="menuitem"]'));
  };

  _proto.addEvents = function addEvents() {
    var _this2 = this;

    ['click', 'touchstart', 'keyup'].forEach(function (event) {
      return document.addEventListener(event, _this2.handleDocumentClick, true);
    });
  };

  _proto.removeEvents = function removeEvents() {
    var _this3 = this;

    ['click', 'touchstart', 'keyup'].forEach(function (event) {
      return document.removeEventListener(event, _this3.handleDocumentClick, true);
    });
  };

  _proto.handleDocumentClick = function handleDocumentClick(e) {
    if (e && (e.which === 3 || e.type === 'keyup' && e.which !== __WEBPACK_IMPORTED_MODULE_9__utils__["keyCodes"].tab)) return;
    var container = this.getContainer();

    if (container.contains(e.target) && container !== e.target && (e.type !== 'keyup' || e.which === __WEBPACK_IMPORTED_MODULE_9__utils__["keyCodes"].tab)) {
      return;
    }

    this.toggle(e);
  };

  _proto.handleKeyDown = function handleKeyDown(e) {
    var _this4 = this;

    if (/input|textarea/i.test(e.target.tagName) || __WEBPACK_IMPORTED_MODULE_9__utils__["keyCodes"].tab === e.which && e.target.getAttribute('role') !== 'menuitem') {
      return;
    }

    e.preventDefault();
    if (this.props.disabled) return;

    if (this.getMenuCtrl() === e.target) {
      if (!this.props.isOpen && [__WEBPACK_IMPORTED_MODULE_9__utils__["keyCodes"].space, __WEBPACK_IMPORTED_MODULE_9__utils__["keyCodes"].enter, __WEBPACK_IMPORTED_MODULE_9__utils__["keyCodes"].up, __WEBPACK_IMPORTED_MODULE_9__utils__["keyCodes"].down].indexOf(e.which) > -1) {
        this.toggle(e);
        setTimeout(function () {
          return _this4.getMenuItems()[0].focus();
        });
      }
    }

    if (this.props.isOpen && e.target.getAttribute('role') === 'menuitem') {
      if ([__WEBPACK_IMPORTED_MODULE_9__utils__["keyCodes"].tab, __WEBPACK_IMPORTED_MODULE_9__utils__["keyCodes"].esc].indexOf(e.which) > -1) {
        this.toggle(e);
        this.getMenuCtrl().focus();
      } else if ([__WEBPACK_IMPORTED_MODULE_9__utils__["keyCodes"].space, __WEBPACK_IMPORTED_MODULE_9__utils__["keyCodes"].enter].indexOf(e.which) > -1) {
        e.target.click();
        this.getMenuCtrl().focus();
      } else if ([__WEBPACK_IMPORTED_MODULE_9__utils__["keyCodes"].down, __WEBPACK_IMPORTED_MODULE_9__utils__["keyCodes"].up].indexOf(e.which) > -1 || [__WEBPACK_IMPORTED_MODULE_9__utils__["keyCodes"].n, __WEBPACK_IMPORTED_MODULE_9__utils__["keyCodes"].p].indexOf(e.which) > -1 && e.ctrlKey) {
        var $menuitems = this.getMenuItems();
        var index = $menuitems.indexOf(e.target);

        if (__WEBPACK_IMPORTED_MODULE_9__utils__["keyCodes"].up === e.which || __WEBPACK_IMPORTED_MODULE_9__utils__["keyCodes"].p === e.which && e.ctrlKey) {
          index = index !== 0 ? index - 1 : $menuitems.length - 1;
        } else if (__WEBPACK_IMPORTED_MODULE_9__utils__["keyCodes"].down === e.which || __WEBPACK_IMPORTED_MODULE_9__utils__["keyCodes"].n === e.which && e.ctrlKey) {
          index = index === $menuitems.length - 1 ? 0 : index + 1;
        }

        $menuitems[index].focus();
      } else if (__WEBPACK_IMPORTED_MODULE_9__utils__["keyCodes"].end === e.which) {
        var _$menuitems = this.getMenuItems();

        _$menuitems[_$menuitems.length - 1].focus();
      } else if (__WEBPACK_IMPORTED_MODULE_9__utils__["keyCodes"].home === e.which) {
        var _$menuitems2 = this.getMenuItems();

        _$menuitems2[0].focus();
      } else if (e.which >= 48 && e.which <= 90) {
        var _$menuitems3 = this.getMenuItems();

        var charPressed = String.fromCharCode(e.which).toLowerCase();

        for (var i = 0; i < _$menuitems3.length; i += 1) {
          var firstLetter = _$menuitems3[i].textContent && _$menuitems3[i].textContent[0].toLowerCase();

          if (firstLetter === charPressed) {
            _$menuitems3[i].focus();

            break;
          }
        }
      }
    }
  };

  _proto.handleProps = function handleProps() {
    if (this.props.isOpen) {
      this.addEvents();
    } else {
      this.removeEvents();
    }
  };

  _proto.toggle = function toggle(e) {
    if (this.props.disabled) {
      return e && e.preventDefault();
    }

    return this.props.toggle(e);
  };

  _proto.render = function render() {
    var _classNames;

    var _omit = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["omit"])(this.props, ['toggle', 'disabled', 'inNavbar', 'direction']),
        className = _omit.className,
        cssModule = _omit.cssModule,
        dropup = _omit.dropup,
        isOpen = _omit.isOpen,
        group = _omit.group,
        size = _omit.size,
        nav = _omit.nav,
        setActiveFromChild = _omit.setActiveFromChild,
        active = _omit.active,
        addonType = _omit.addonType,
        attrs = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_omit, ["className", "cssModule", "dropup", "isOpen", "group", "size", "nav", "setActiveFromChild", "active", "addonType"]);

    var direction = this.props.direction === 'down' && dropup ? 'up' : this.props.direction;
    attrs.tag = attrs.tag || (nav ? 'li' : 'div');
    var subItemIsActive = false;

    if (setActiveFromChild) {
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.map(this.props.children[1].props.children, function (dropdownItem) {
        if (dropdownItem && dropdownItem.props.active) subItemIsActive = true;
      });
    }

    var classes = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_8_classnames___default()(className, direction !== 'down' && "drop" + direction, nav && active ? 'active' : false, setActiveFromChild && subItemIsActive ? 'active' : false, (_classNames = {}, _classNames["input-group-" + addonType] = addonType, _classNames['btn-group'] = group, _classNames["btn-group-" + size] = !!size, _classNames.dropdown = !group && !addonType, _classNames.show = isOpen, _classNames['nav-item'] = nav, _classNames)), cssModule);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_popper__["b" /* Manager */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attrs, {
      className: classes,
      onKeyDown: this.handleKeyDown
    }));
  };

  return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Dropdown.propTypes = propTypes;
Dropdown.defaultProps = defaultProps;
Dropdown.childContextTypes = childContextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Dropdown);

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = _interopRequireDefault(__webpack_require__(1360));

var _ReplaceTransition = _interopRequireDefault(__webpack_require__(1363));

var _TransitionGroup = _interopRequireDefault(__webpack_require__(667));

var _Transition = _interopRequireDefault(__webpack_require__(665));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition.default,
  TransitionGroup: _TransitionGroup.default,
  ReplaceTransition: _ReplaceTransition.default,
  CSSTransition: _CSSTransition.default
};

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1361)();
}


/***/ }),
/* 215 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(373);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 217 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 218 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.10' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__ = __webpack_require__(12);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * @fileOverview Surface
 */




var propTypes = {
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  viewBox: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node])
};

function Surface(props) {
  var children = props.children,
      width = props.width,
      height = props.height,
      viewBox = props.viewBox,
      className = props.className,
      style = props.style,
      others = _objectWithoutProperties(props, ["children", "width", "height", "viewBox", "className", "style"]);

  var svgView = viewBox || {
    width: width,
    height: height,
    x: 0,
    y: 0
  };
  var layerClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('recharts-surface', className);
  var attrs = Object(__WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["l" /* getPresentationAttributes */])(others);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({}, attrs, {
    className: layerClass,
    width: width,
    height: height,
    style: style,
    viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height),
    version: "1.1"
  }), children);
}

Surface.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (Surface);

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__path__ = __webpack_require__(1555);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__path__["a"]; });



/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return abs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return atan2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return cos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return max; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return min; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return sin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return sqrt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return pi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return tau; });
/* harmony export (immutable) */ __webpack_exports__["b"] = acos;
/* harmony export (immutable) */ __webpack_exports__["c"] = asin;
var abs = Math.abs;
var atan2 = Math.atan2;
var cos = Math.cos;
var max = Math.max;
var min = Math.min;
var sin = Math.sin;
var sqrt = Math.sqrt;

var epsilon = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = 2 * pi;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}


/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
});


/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
});


/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x === null ? NaN : +x;
});


/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__container_Layer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__ = __webpack_require__(12);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Render a group of error bar
*/





var ErrorBar =
/*#__PURE__*/
function (_Component) {
  _inherits(ErrorBar, _Component);

  function ErrorBar() {
    _classCallCheck(this, ErrorBar);

    return _possibleConstructorReturn(this, _getPrototypeOf(ErrorBar).apply(this, arguments));
  }

  _createClass(ErrorBar, [{
    key: "renderErrorBars",
    value: function renderErrorBars() {
      var _this$props = this.props,
          offset = _this$props.offset,
          layout = _this$props.layout,
          width = _this$props.width,
          dataKey = _this$props.dataKey,
          data = _this$props.data,
          dataPointFormatter = _this$props.dataPointFormatter,
          xAxis = _this$props.xAxis,
          yAxis = _this$props.yAxis,
          others = _objectWithoutProperties(_this$props, ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"]);

      var props = Object(__WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["l" /* getPresentationAttributes */])(others);
      return data.map(function (entry, i) {
        var _dataPointFormatter = dataPointFormatter(entry, dataKey),
            x = _dataPointFormatter.x,
            y = _dataPointFormatter.y,
            value = _dataPointFormatter.value,
            errorVal = _dataPointFormatter.errorVal;

        if (!errorVal) {
          return null;
        }

        var xMid, yMid, xMin, yMin, xMax, yMax, scale, coordsTop, coordsMid, coordsBot, lowBound, highBound;

        if (Array.isArray(errorVal)) {
          var _errorVal = _slicedToArray(errorVal, 2);

          lowBound = _errorVal[0];
          highBound = _errorVal[1];
        } else {
          lowBound = highBound = errorVal;
        }

        if (layout === 'vertical') {
          scale = xAxis.scale;
          xMid = value;
          yMid = y + offset;
          xMin = scale(xMid - lowBound);
          yMin = yMid + width;
          xMax = scale(xMid + highBound);
          yMax = yMid - width;
          coordsTop = {
            x1: xMax,
            y1: yMin,
            x2: xMax,
            y2: yMax
          };
          coordsMid = {
            x1: xMin,
            y1: yMid,
            x2: xMax,
            y2: yMid
          };
          coordsBot = {
            x1: xMin,
            y1: yMin,
            x2: xMin,
            y2: yMax
          };
        } else if (layout === 'horizontal') {
          scale = yAxis.scale;
          xMid = x + offset;
          yMid = value;
          xMin = xMid - width;
          xMax = xMid + width;
          yMin = scale(yMid - lowBound);
          yMax = scale(yMid + highBound);
          coordsTop = {
            x1: xMin,
            y1: yMax,
            x2: xMax,
            y2: yMax
          };
          coordsMid = {
            x1: xMid,
            y1: yMin,
            x2: xMid,
            y2: yMax
          };
          coordsBot = {
            x1: xMin,
            y1: yMin,
            x2: xMax,
            y2: yMin
          };
        }

        return (// eslint-disable-next-line react/no-array-index-key
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__container_Layer__["a" /* default */], _extends({
            className: "recharts-errorBar",
            key: "bar-".concat(i)
          }, props), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("line", coordsTop), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("line", coordsMid), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("line", coordsBot))
        );
      });
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__container_Layer__["a" /* default */], {
        className: "recharts-errorBars"
      }, this.renderErrorBars());
    }
  }]);

  return ErrorBar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ErrorBar.propTypes = {
  dataKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]).isRequired,
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  xAxis: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  yAxis: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  layout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  dataPointFormatter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  stroke: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  strokeWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  offset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};
ErrorBar.defaultProps = {
  stroke: 'black',
  strokeWidth: 1.5,
  width: 5,
  offset: 0,
  layout: 'horizontal'
};
/* harmony default export */ __webpack_exports__["a"] = (ErrorBar);

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LEFT = exports.LEFT = 37;
var UP = exports.UP = 38;
var RIGHT = exports.RIGHT = 39;
var DOWN = exports.DOWN = 40;
var ENTER = exports.ENTER = 13;
var SPACE = exports.SPACE = 32;
var ESC = exports.ESC = 27;
var TAB = exports.TAB = 9;
//# sourceMappingURL=keys.js.map

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _reactBootstrapSweetalert = _interopRequireDefault(__webpack_require__(80));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var DeleteItemCheck = function DeleteItemCheck(_ref) {
  var id = _ref.id,
      _onConfirm = _ref.onConfirm,
      alertMessage = _ref.alertMessage;
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      alert = _useState2[0],
      setAlert = _useState2[1];

  var toggle = function toggle() {
    setAlert(!alert);
  };

  return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(_reactstrap.Button, {
    size: "sm",
    color: "primary",
    onClick: function onClick() {
      return toggle();
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-edit zmdi-hc-fw"
  }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.delete"
  }))), _react["default"].createElement(_reactBootstrapSweetalert["default"], {
    show: alert,
    warning: true,
    showCancel: true,
    confirmBtnText: _react["default"].createElement(_IntlMessages["default"], {
      id: "button.yesDeleteIt"
    }),
    cancelBtnText: _react["default"].createElement(_IntlMessages["default"], {
      id: "button.cancel"
    }),
    confirmBtnBsStyle: "danger",
    cancelBtnBsStyle: "default",
    title: _react["default"].createElement("span", {
      style: {
        fontWeight: 'bold',
        color: 'grey',
        fontSize: '200%'
      }
    }, _react["default"].createElement(_IntlMessages["default"], {
      id: "general.areYouSure"
    })),
    onConfirm: function onConfirm() {
      dispatch(_onConfirm(id));
      toggle();
    },
    onCancel: function onCancel() {
      return toggle();
    }
  }, alertMessage));
};

var _default = DeleteItemCheck;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(DeleteItemCheck, "DeleteItemCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/deleteItemCheck/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/deleteItemCheck/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/deleteItemCheck/index.js");

  __REACT_HOT_LOADER__.register(_reactBootstrapSweetalert, "_reactBootstrapSweetalert", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/deleteItemCheck/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/deleteItemCheck/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/deleteItemCheck/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/deleteItemCheck/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/deleteItemCheck/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/deleteItemCheck/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/deleteItemCheck/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/deleteItemCheck/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/deleteItemCheck/index.js");

  __REACT_HOT_LOADER__.register(DeleteItemCheck, "DeleteItemCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/deleteItemCheck/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/deleteItemCheck/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/deleteItemCheck/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/deleteItemCheck/index.js");
}();

;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var CardBox = function CardBox(_ref) {
  var heading = _ref.heading,
      children = _ref.children,
      styleName = _ref.styleName,
      cardStyle = _ref.cardStyle,
      childrenStyle = _ref.childrenStyle,
      headerOutside = _ref.headerOutside;
  return _react["default"].createElement("div", {
    className: "".concat(styleName)
  }, headerOutside && _react["default"].createElement("div", {
    className: "jr-entry-header"
  }, _react["default"].createElement("h3", {
    className: "entry-heading heading"
  }, heading), children.length > 1 && _react["default"].createElement("div", {
    className: "entry-description"
  }, children[0])), _react["default"].createElement("div", {
    className: "jr-card ".concat(cardStyle)
  }, !headerOutside && heading && _react["default"].createElement("div", {
    className: "jr-card-header"
  }, _react["default"].createElement("h3", {
    className: "card-heading"
  }, heading), children.length > 1 && _react["default"].createElement("div", {
    className: "sub-heading"
  }, children[0])), _react["default"].createElement("div", {
    className: "jr-card-body ".concat(childrenStyle)
  }, children.length > 1 ? children[1] : children)));
};

var _default = CardBox;
var _default2 = _default;
exports["default"] = _default2;
CardBox.defaultProps = {
  cardStyle: '',
  childrenStyle: '',
  styleName: 'col-lg-6 col-sm-12'
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CardBox, "CardBox", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/CardBox/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/CardBox/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/CardBox/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/CardBox/index.js");

  __REACT_HOT_LOADER__.register(CardBox, "CardBox", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/CardBox/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/CardBox/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/CardBox/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/CardBox/index.js");
}();

;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(435),
    createBaseEach = __webpack_require__(1175);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(234),
    isArrayLike = __webpack_require__(130),
    isIndex = __webpack_require__(304),
    isObject = __webpack_require__(58);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ChartCard = function ChartCard(_ref) {
  var styleName = _ref.styleName,
      children = _ref.children;
  return _react["default"].createElement("div", {
    className: "card border-0 ".concat(styleName)
  }, _react["default"].createElement("div", {
    className: "chart-header"
  }, children[0]), children[1]);
};

var _default = ChartCard;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ChartCard, "ChartCard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/Common/ChartCard.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/Common/ChartCard.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/Common/ChartCard.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/Common/ChartCard.js");

  __REACT_HOT_LOADER__.register(ChartCard, "ChartCard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/Common/ChartCard.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/Common/ChartCard.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/Common/ChartCard.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/Common/ChartCard.js");
}();

;

/***/ }),
/* 234 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(26),
    isKey = __webpack_require__(356),
    stringToPath = __webpack_require__(1165),
    toString = __webpack_require__(842);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(111),
    isArray = __webpack_require__(26),
    isObjectLike = __webpack_require__(79);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(36);
var global = __webpack_require__(17);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(133) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(70);
var toLength = __webpack_require__(32);
var toAbsoluteIndex = __webpack_require__(135);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 239 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(96);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(28)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(19);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(206);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(468);
var redefine = __webpack_require__(59);
var hide = __webpack_require__(69);
var fails = __webpack_require__(18);
var defined = __webpack_require__(97);
var wks = __webpack_require__(28);
var regexpExec = __webpack_require__(339);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(84);
var call = __webpack_require__(463);
var isArrayIter = __webpack_require__(334);
var anObject = __webpack_require__(19);
var toLength = __webpack_require__(32);
var getIterFn = __webpack_require__(336);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(17);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(17);
var $export = __webpack_require__(5);
var redefine = __webpack_require__(59);
var redefineAll = __webpack_require__(167);
var meta = __webpack_require__(110);
var forOf = __webpack_require__(245);
var anInstance = __webpack_require__(166);
var isObject = __webpack_require__(20);
var fails = __webpack_require__(18);
var $iterDetect = __webpack_require__(241);
var setToStringTag = __webpack_require__(162);
var inheritIfRequired = __webpack_require__(325);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(17);
var hide = __webpack_require__(69);
var uid = __webpack_require__(132);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(488);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  } else {
    throw new Error(prefix + ": " + (message || ''));
  }
}

/* harmony default export */ __webpack_exports__["default"] = (invariant);


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrayMove = arrayMove;
exports.omit = omit;
exports.closest = closest;
exports.limit = limit;
exports.getElementMargin = getElementMargin;
exports.provideDisplayName = provideDisplayName;
function arrayMove(arr, previousIndex, newIndex) {
  var array = arr.slice(0);
  if (newIndex >= array.length) {
    var k = newIndex - array.length;
    while (k-- + 1) {
      array.push(undefined);
    }
  }
  array.splice(newIndex, 0, array.splice(previousIndex, 1)[0]);
  return array;
}

function omit(obj) {
  for (var _len = arguments.length, keysToOmit = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keysToOmit[_key - 1] = arguments[_key];
  }

  return Object.keys(obj).reduce(function (acc, key) {
    if (keysToOmit.indexOf(key) === -1) acc[key] = obj[key];
    return acc;
  }, {});
}

var events = exports.events = {
  start: ['touchstart', 'mousedown'],
  move: ['touchmove', 'mousemove'],
  end: ['touchend', 'touchcancel', 'mouseup']
};

var vendorPrefix = exports.vendorPrefix = function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return ''; // server environment
  // fix for:
  //    https://bugzilla.mozilla.org/show_bug.cgi?id=548397
  //    window.getComputedStyle() returns null inside an iframe with display: none
  // in this case return an array with a fake mozilla style in it.
  var styles = window.getComputedStyle(document.documentElement, '') || ['-moz-hidden-iframe'];
  var pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || styles.OLink === '' && ['', 'o'])[1];

  switch (pre) {
    case 'ms':
      return 'ms';
    default:
      return pre && pre.length ? pre[0].toUpperCase() + pre.substr(1) : '';
  }
}();

function closest(el, fn) {
  while (el) {
    if (fn(el)) return el;
    el = el.parentNode;
  }
}

function limit(min, max, value) {
  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }
  return value;
}

function getCSSPixelValue(stringValue) {
  if (stringValue.substr(-2) === 'px') {
    return parseFloat(stringValue);
  }
  return 0;
}

function getElementMargin(element) {
  var style = window.getComputedStyle(element);

  return {
    top: getCSSPixelValue(style.marginTop),
    right: getCSSPixelValue(style.marginRight),
    bottom: getCSSPixelValue(style.marginBottom),
    left: getCSSPixelValue(style.marginLeft)
  };
}

function provideDisplayName(prefix, Component) {
  var componentName = Component.displayName || Component.name;

  return componentName ? prefix + '(' + componentName + ')' : prefix;
}

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1121),
    listCacheDelete = __webpack_require__(1122),
    listCacheGet = __webpack_require__(1123),
    listCacheHas = __webpack_require__(1124),
    listCacheSet = __webpack_require__(1125);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(234);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(142);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1145);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(1161),
    Map = __webpack_require__(348),
    Promise = __webpack_require__(1162),
    Set = __webpack_require__(637),
    WeakMap = __webpack_require__(847),
    baseGetTag = __webpack_require__(111),
    toSource = __webpack_require__(628);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(308),
    baseOrderBy = __webpack_require__(1173),
    baseRest = __webpack_require__(424),
    isIterateeCall = __webpack_require__(231);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BUFFER_OVERFLOW */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buffers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(71);


var BUFFER_OVERFLOW = "Channel's Buffer overflow!";

var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;

var zeroBuffer = { isEmpty: __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* kTrue */], put: __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */], take: __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */] };

function ringBuffer() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var overflowAction = arguments[1];

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];
    while (length) {
      items.push(take());
    }
    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit = void 0;
        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);
          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;
          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;

            arr = flush();

            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;

            arr.length = doubledLimit;
            limit = doubledLimit;

            push(it);
            break;
          default:
          // DROP
        }
      }
    },
    take: take,
    flush: flush
  };
}

var buffers = {
  none: function none() {
    return zeroBuffer;
  },
  fixed: function fixed(limit) {
    return ringBuffer(limit, ON_OVERFLOW_THROW);
  },
  dropping: function dropping(limit) {
    return ringBuffer(limit, ON_OVERFLOW_DROP);
  },
  sliding: function sliding(limit) {
    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
  },
  expanding: function expanding(initialSize) {
    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
  }
};

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortByField = exports.sortByDate = exports.sortByName = void 0;

var _lodash = __webpack_require__(72);
/**
 * sort the objects by the name field // TODO - make more generic - pass in field path and use lodash get
 * @param {Array} source the source array..
 * @returns {Array} of objects sorted by name
 */


var sortByName = function sortByName(source) {
  try {
    if (Array.isArray(source)) {
      return source.sort(function (a, b) {
        var nameA = a === null || a === void 0 ? void 0 : a.name.toUpperCase(); // ignore upper and lowercase

        var nameB = b === null || b === void 0 ? void 0 : b.name.toUpperCase(); // ignore upper and lowercase

        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      });
    }
  } catch (error) {
    console.error('Something went wrong trying to sort the array by name '.concat(error));
    return source;
  }

  return source;
};

exports.sortByName = sortByName;

var sortByDate = function sortByDate(source, sortField) {
  try {
    if (Array.isArray(source) && sortField) {
      return source.sort(function (a, b) {
        var dateA = (0, _lodash.has)(a, sortField) ? new Date((0, _lodash.get)(a, sortField)) : null;
        var dateB = (0, _lodash.has)(b, sortField) ? new Date((0, _lodash.get)(b, sortField)) : null;
        if (dateA < dateB) return -1;
        if (dateA > dateB) return 1;
        return 0;
      });
    }
  } catch (error) {
    console.error('Something went wrong trying to sort the array by date '.concat(error));
    return source;
  }

  return source;
};

exports.sortByDate = sortByDate;

var sortByField = function sortByField(source, sortField) {
  try {
    if (Array.isArray(source) && sortField) {
      return source.sort(function (a, b) {
        var valueA = (0, _lodash.has)(a, sortField) ? (0, _lodash.get)(a, sortField) : null;
        var valueB = (0, _lodash.has)(b, sortField) ? (0, _lodash.get)(b, sortField) : null;
        if (valueA < valueB) return -1;
        if (valueA > valueB) return 1;
        return 0;
      });
    }
  } catch (error) {
    console.error('Something went wrong trying to sort the array by field '.concat(error));
    return source;
  }

  return source;
};

exports.sortByField = sortByField;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(sortByName, "sortByName", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/sorting.js");

  __REACT_HOT_LOADER__.register(sortByDate, "sortByDate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/sorting.js");

  __REACT_HOT_LOADER__.register(sortByField, "sortByField", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/sorting.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(sortByName, "sortByName", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/sorting.js");

  __REACT_HOT_LOADER__.register(sortByDate, "sortByDate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/sorting.js");

  __REACT_HOT_LOADER__.register(sortByField, "sortByField", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/sorting.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/sorting.js");
}();

;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideSurveyLoader = exports.showSurveyLoader = exports.handleSurveyRequestClose = exports.onToggleSurveyDrawer = exports.updateSearchSurvey = exports.onAllSurveySelect = exports.getUnselectedAllSurvey = exports.getAllSurvey = exports.filterSurvey = exports.onDeleteSelectedSurvey = exports.onDeleteSurvey = exports.onSaveSurveySuccess = exports.onSaveSurvey = exports.onFilterSurveyOptionSelect = exports.onSurveyClose = exports.onAddSurvey = exports.onSurveySelect = exports.addFavouriteSurvey = exports.showSurveyMessage = exports.fetchSurveysSuccess = exports.fetchSurveys = exports.onSurveyQuestions = void 0;

var _ActionTypes = __webpack_require__(7);

var onSurveyQuestions = function onSurveyQuestions(data) {
  return {
    type: _ActionTypes.ON_SURVEY_QUESTIONS,
    payload: data
  };
};

exports.onSurveyQuestions = onSurveyQuestions;

var fetchSurveys = function fetchSurveys() {
  return {
    type: _ActionTypes.FETCH_ALL_SURVEY
  };
};

exports.fetchSurveys = fetchSurveys;

var fetchSurveysSuccess = function fetchSurveysSuccess(data) {
  return {
    type: _ActionTypes.FETCH_ALL_SURVEY_SUCCESS,
    payload: data
  };
};

exports.fetchSurveysSuccess = fetchSurveysSuccess;

var showSurveyMessage = function showSurveyMessage(message) {
  return {
    type: _ActionTypes.SHOW_SURVEY_MESSAGE,
    payload: message
  };
};

exports.showSurveyMessage = showSurveyMessage;

var addFavouriteSurvey = function addFavouriteSurvey(data) {
  return {
    type: _ActionTypes.ADD_FAVOURITE_SURVEY,
    payload: data
  };
};

exports.addFavouriteSurvey = addFavouriteSurvey;

var onSurveySelect = function onSurveySelect(data) {
  return {
    type: _ActionTypes.ON_SURVEY_SELECT,
    payload: data
  };
};

exports.onSurveySelect = onSurveySelect;

var onAddSurvey = function onAddSurvey() {
  return {
    type: _ActionTypes.ON_ADD_SURVEY,
    payload: ''
  };
};

exports.onAddSurvey = onAddSurvey;

var onSurveyClose = function onSurveyClose() {
  return {
    type: _ActionTypes.ON_SURVEY_CLOSE,
    payload: ''
  };
};

exports.onSurveyClose = onSurveyClose;

var onFilterSurveyOptionSelect = function onFilterSurveyOptionSelect(option) {
  return {
    type: _ActionTypes.ON_FILTER_SURVEY_OPTION_SELECT,
    payload: option
  };
};

exports.onFilterSurveyOptionSelect = onFilterSurveyOptionSelect;

var onSaveSurvey = function onSaveSurvey(data) {
  return {
    type: _ActionTypes.ON_SAVE_SURVEY,
    payload: data
  };
};

exports.onSaveSurvey = onSaveSurvey;

var onSaveSurveySuccess = function onSaveSurveySuccess(data) {
  return {
    type: _ActionTypes.ON_SAVE_SURVEY_SUCCESS,
    payload: data
  };
};

exports.onSaveSurveySuccess = onSaveSurveySuccess;

var onDeleteSurvey = function onDeleteSurvey(data) {
  return {
    type: _ActionTypes.ON_DELETE_SURVEY,
    payload: data
  };
};

exports.onDeleteSurvey = onDeleteSurvey;

var onDeleteSelectedSurvey = function onDeleteSelectedSurvey() {
  return {
    type: _ActionTypes.ON_DELETE_SELECTED_SURVEY,
    payload: ''
  };
};

exports.onDeleteSelectedSurvey = onDeleteSelectedSurvey;

var filterSurvey = function filterSurvey(survey) {
  return {
    type: _ActionTypes.FILTER_SURVEY,
    payload: survey
  };
};

exports.filterSurvey = filterSurvey;

var getAllSurvey = function getAllSurvey() {
  return {
    type: _ActionTypes.GET_ALL_SURVEY,
    payload: ''
  };
};

exports.getAllSurvey = getAllSurvey;

var getUnselectedAllSurvey = function getUnselectedAllSurvey() {
  return {
    type: _ActionTypes.GET_UNSELECTED_ALL_SURVEY,
    payload: ''
  };
};

exports.getUnselectedAllSurvey = getUnselectedAllSurvey;

var onAllSurveySelect = function onAllSurveySelect() {
  return {
    type: _ActionTypes.ON_ALL_SURVEY_SELECT,
    payload: ''
  };
};

exports.onAllSurveySelect = onAllSurveySelect;

var updateSearchSurvey = function updateSearchSurvey(survey) {
  return {
    type: _ActionTypes.UPDATE_SEARCH_SURVEY,
    payload: survey
  };
};

exports.updateSearchSurvey = updateSearchSurvey;

var onToggleSurveyDrawer = function onToggleSurveyDrawer() {
  return {
    type: _ActionTypes.ON_TOGGLE_SURVEY_DRAWER
  };
};

exports.onToggleSurveyDrawer = onToggleSurveyDrawer;

var handleSurveyRequestClose = function handleSurveyRequestClose() {
  return {
    type: _ActionTypes.HANDLE_SURVEY_REQUEST_CLOSE
  };
};

exports.handleSurveyRequestClose = handleSurveyRequestClose;

var showSurveyLoader = function showSurveyLoader() {
  return {
    type: _ActionTypes.SHOW_SURVEY_LOADER
  };
};

exports.showSurveyLoader = showSurveyLoader;

var hideSurveyLoader = function hideSurveyLoader() {
  return {
    type: _ActionTypes.HIDE_SURVEY_LOADER
  };
};

exports.hideSurveyLoader = hideSurveyLoader;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(onSurveyQuestions, "onSurveyQuestions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(fetchSurveys, "fetchSurveys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(fetchSurveysSuccess, "fetchSurveysSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(showSurveyMessage, "showSurveyMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(addFavouriteSurvey, "addFavouriteSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(onSurveySelect, "onSurveySelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(onAddSurvey, "onAddSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(onSurveyClose, "onSurveyClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(onFilterSurveyOptionSelect, "onFilterSurveyOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(onSaveSurvey, "onSaveSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(onSaveSurveySuccess, "onSaveSurveySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(onDeleteSurvey, "onDeleteSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(onDeleteSelectedSurvey, "onDeleteSelectedSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(filterSurvey, "filterSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(getAllSurvey, "getAllSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllSurvey, "getUnselectedAllSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(onAllSurveySelect, "onAllSurveySelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(updateSearchSurvey, "updateSearchSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(onToggleSurveyDrawer, "onToggleSurveyDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(handleSurveyRequestClose, "handleSurveyRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(showSurveyLoader, "showSurveyLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(hideSurveyLoader, "hideSurveyLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(onSurveyQuestions, "onSurveyQuestions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(fetchSurveys, "fetchSurveys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(fetchSurveysSuccess, "fetchSurveysSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(showSurveyMessage, "showSurveyMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(addFavouriteSurvey, "addFavouriteSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(onSurveySelect, "onSurveySelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(onAddSurvey, "onAddSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(onSurveyClose, "onSurveyClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(onFilterSurveyOptionSelect, "onFilterSurveyOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(onSaveSurvey, "onSaveSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(onSaveSurveySuccess, "onSaveSurveySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(onDeleteSurvey, "onDeleteSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(onDeleteSelectedSurvey, "onDeleteSelectedSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(filterSurvey, "filterSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(getAllSurvey, "getAllSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllSurvey, "getUnselectedAllSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(onAllSurveySelect, "onAllSurveySelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(updateSearchSurvey, "updateSearchSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(onToggleSurveyDrawer, "onToggleSurveyDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(handleSurveyRequestClose, "handleSurveyRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(showSurveyLoader, "showSurveyLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(hideSurveyLoader, "hideSurveyLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Survey.js");
}();

;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideSurveyQuestionLoader = exports.showSurveyQuestionLoader = exports.showSurveyQuestionMessage = exports.fetchSurveyQuestionsSuccess = exports.fetchSurveyQuestions = void 0;

var _ActionTypes = __webpack_require__(7);

var fetchSurveyQuestions = function fetchSurveyQuestions() {
  return {
    type: _ActionTypes.FETCH_ALL_SURVEY_QUESTION
  };
};

exports.fetchSurveyQuestions = fetchSurveyQuestions;

var fetchSurveyQuestionsSuccess = function fetchSurveyQuestionsSuccess(data) {
  return {
    type: _ActionTypes.FETCH_ALL_SURVEY_QUESTION_SUCCESS,
    payload: data
  };
};

exports.fetchSurveyQuestionsSuccess = fetchSurveyQuestionsSuccess;

var showSurveyQuestionMessage = function showSurveyQuestionMessage(message) {
  return {
    type: _ActionTypes.SHOW_SURVEY_QUESTION_MESSAGE,
    payload: message
  };
};

exports.showSurveyQuestionMessage = showSurveyQuestionMessage;

var showSurveyQuestionLoader = function showSurveyQuestionLoader() {
  return {
    type: _ActionTypes.SHOW_SURVEY_QUESTION_LOADER
  };
};

exports.showSurveyQuestionLoader = showSurveyQuestionLoader;

var hideSurveyQuestionLoader = function hideSurveyQuestionLoader() {
  return {
    type: _ActionTypes.HIDE_SURVEY_QUESTION_LOADER
  };
};

exports.hideSurveyQuestionLoader = hideSurveyQuestionLoader;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchSurveyQuestions, "fetchSurveyQuestions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyQuestion.js");

  __REACT_HOT_LOADER__.register(fetchSurveyQuestionsSuccess, "fetchSurveyQuestionsSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyQuestion.js");

  __REACT_HOT_LOADER__.register(showSurveyQuestionMessage, "showSurveyQuestionMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyQuestion.js");

  __REACT_HOT_LOADER__.register(showSurveyQuestionLoader, "showSurveyQuestionLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyQuestion.js");

  __REACT_HOT_LOADER__.register(hideSurveyQuestionLoader, "hideSurveyQuestionLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyQuestion.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchSurveyQuestions, "fetchSurveyQuestions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyQuestion.js");

  __REACT_HOT_LOADER__.register(fetchSurveyQuestionsSuccess, "fetchSurveyQuestionsSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyQuestion.js");

  __REACT_HOT_LOADER__.register(showSurveyQuestionMessage, "showSurveyQuestionMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyQuestion.js");

  __REACT_HOT_LOADER__.register(showSurveyQuestionLoader, "showSurveyQuestionLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyQuestion.js");

  __REACT_HOT_LOADER__.register(hideSurveyQuestionLoader, "hideSurveyQuestionLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyQuestion.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyQuestion.js");
}();

;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideSecurityLoader = exports.showSecurityLoader = exports.handleSecurityRequestClose = exports.onToggleSecurityDrawer = exports.updateSearchSecurity = exports.onAllSecuritySelect = exports.getUnselectedAllSecurity = exports.getAllSecurity = exports.filterSecurity = exports.onFilterSelectedSecurity = exports.onDeleteSecuritySuccess = exports.onDeleteSecurity = exports.onSaveSecuritySuccess = exports.onSaveSecurity = exports.onFilterSecurityOptionSelect = exports.onSecurityClose = exports.onAddSecurity = exports.onSecuritySelect = exports.addFavouriteSecuritySuccess = exports.addFavouriteSecurity = exports.showSecurityMessage = exports.fetchSecuritysSuccess = exports.fetchSecuritys = exports.fetchSecuritySuccess = exports.fetchSecurity = void 0;

var _ActionTypes = __webpack_require__(7);

var fetchSecurity = function fetchSecurity(payload) {
  return {
    type: _ActionTypes.FETCH_SECURITY,
    payload: payload
  };
};

exports.fetchSecurity = fetchSecurity;

var fetchSecuritySuccess = function fetchSecuritySuccess(payload) {
  return {
    type: _ActionTypes.FETCH_SECURITY_SUCCESS,
    payload: payload
  };
};

exports.fetchSecuritySuccess = fetchSecuritySuccess;

var fetchSecuritys = function fetchSecuritys() {
  return {
    type: _ActionTypes.FETCH_ALL_SECURITY
  };
};

exports.fetchSecuritys = fetchSecuritys;

var fetchSecuritysSuccess = function fetchSecuritysSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_ALL_SECURITY_SUCCESS,
    payload: payload
  };
};

exports.fetchSecuritysSuccess = fetchSecuritysSuccess;

var showSecurityMessage = function showSecurityMessage(message) {
  return {
    type: _ActionTypes.SHOW_SECURITY_MESSAGE,
    payload: message
  };
};

exports.showSecurityMessage = showSecurityMessage;

var addFavouriteSecurity = function addFavouriteSecurity(payload) {
  return {
    type: _ActionTypes.ADD_FAVOURITE_SECURITY,
    payload: payload
  };
};

exports.addFavouriteSecurity = addFavouriteSecurity;

var addFavouriteSecuritySuccess = function addFavouriteSecuritySuccess(payload) {
  return {
    type: _ActionTypes.ADD_FAVOURITE_SECURITY_SUCCESS,
    payload: payload
  };
};

exports.addFavouriteSecuritySuccess = addFavouriteSecuritySuccess;

var onSecuritySelect = function onSecuritySelect(payload) {
  return {
    type: _ActionTypes.ON_SECURITY_SELECT,
    payload: payload
  };
};

exports.onSecuritySelect = onSecuritySelect;

var onAddSecurity = function onAddSecurity() {
  return {
    type: _ActionTypes.ON_ADD_SECURITY,
    payload: ''
  };
};

exports.onAddSecurity = onAddSecurity;

var onSecurityClose = function onSecurityClose() {
  return {
    type: _ActionTypes.ON_SECURITY_CLOSE,
    payload: ''
  };
};

exports.onSecurityClose = onSecurityClose;

var onFilterSecurityOptionSelect = function onFilterSecurityOptionSelect(payload) {
  return {
    type: _ActionTypes.ON_FILTER_SECURITY_OPTION_SELECT,
    payload: payload
  };
};

exports.onFilterSecurityOptionSelect = onFilterSecurityOptionSelect;

var onSaveSecurity = function onSaveSecurity(payload) {
  return {
    type: _ActionTypes.ON_SAVE_SECURITY,
    payload: payload
  };
};

exports.onSaveSecurity = onSaveSecurity;

var onSaveSecuritySuccess = function onSaveSecuritySuccess(data) {
  return {
    type: _ActionTypes.ON_SAVE_SECURITY_SUCCESS,
    payload: data
  };
};

exports.onSaveSecuritySuccess = onSaveSecuritySuccess;

var onDeleteSecurity = function onDeleteSecurity(payload) {
  return {
    type: _ActionTypes.ON_DELETE_SECURITY,
    payload: payload
  };
};

exports.onDeleteSecurity = onDeleteSecurity;

var onDeleteSecuritySuccess = function onDeleteSecuritySuccess(payload) {
  return {
    type: _ActionTypes.ON_DELETE_SECURITY_SUCCESS,
    payload: payload
  };
};

exports.onDeleteSecuritySuccess = onDeleteSecuritySuccess;

var onFilterSelectedSecurity = function onFilterSelectedSecurity() {
  return {
    type: _ActionTypes.ON_FILTER_SELECTED_SECURITY,
    payload: ''
  };
};

exports.onFilterSelectedSecurity = onFilterSelectedSecurity;

var filterSecurity = function filterSecurity(payload) {
  return {
    type: _ActionTypes.FILTER_SECURITY,
    payload: payload
  };
};

exports.filterSecurity = filterSecurity;

var getAllSecurity = function getAllSecurity() {
  return {
    type: _ActionTypes.GET_ALL_SECURITY,
    payload: ''
  };
};

exports.getAllSecurity = getAllSecurity;

var getUnselectedAllSecurity = function getUnselectedAllSecurity() {
  return {
    type: _ActionTypes.GET_UNSELECTED_ALL_SECURITY,
    payload: ''
  };
};

exports.getUnselectedAllSecurity = getUnselectedAllSecurity;

var onAllSecuritySelect = function onAllSecuritySelect() {
  return {
    type: _ActionTypes.ON_ALL_SECURITY_SELECT,
    payload: ''
  };
};

exports.onAllSecuritySelect = onAllSecuritySelect;

var updateSearchSecurity = function updateSearchSecurity(payload) {
  return {
    type: _ActionTypes.UPDATE_SEARCH_SECURITY,
    payload: payload
  };
};

exports.updateSearchSecurity = updateSearchSecurity;

var onToggleSecurityDrawer = function onToggleSecurityDrawer() {
  return {
    type: _ActionTypes.ON_TOGGLE_SECURITY_DRAWER
  };
};

exports.onToggleSecurityDrawer = onToggleSecurityDrawer;

var handleSecurityRequestClose = function handleSecurityRequestClose() {
  return {
    type: _ActionTypes.HANDLE_SECURITY_REQUEST_CLOSE
  };
};

exports.handleSecurityRequestClose = handleSecurityRequestClose;

var showSecurityLoader = function showSecurityLoader() {
  return {
    type: _ActionTypes.SHOW_SECURITY_LOADER
  };
};

exports.showSecurityLoader = showSecurityLoader;

var hideSecurityLoader = function hideSecurityLoader() {
  return {
    type: _ActionTypes.HIDE_SECURITY_LOADER
  };
};

exports.hideSecurityLoader = hideSecurityLoader;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchSecurity, "fetchSecurity", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(fetchSecuritySuccess, "fetchSecuritySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(fetchSecuritys, "fetchSecuritys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(fetchSecuritysSuccess, "fetchSecuritysSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(showSecurityMessage, "showSecurityMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(addFavouriteSecurity, "addFavouriteSecurity", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(addFavouriteSecuritySuccess, "addFavouriteSecuritySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(onSecuritySelect, "onSecuritySelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(onAddSecurity, "onAddSecurity", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(onSecurityClose, "onSecurityClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(onFilterSecurityOptionSelect, "onFilterSecurityOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(onSaveSecurity, "onSaveSecurity", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(onSaveSecuritySuccess, "onSaveSecuritySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(onDeleteSecurity, "onDeleteSecurity", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(onDeleteSecuritySuccess, "onDeleteSecuritySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(onFilterSelectedSecurity, "onFilterSelectedSecurity", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(filterSecurity, "filterSecurity", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(getAllSecurity, "getAllSecurity", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllSecurity, "getUnselectedAllSecurity", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(onAllSecuritySelect, "onAllSecuritySelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(updateSearchSecurity, "updateSearchSecurity", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(onToggleSecurityDrawer, "onToggleSecurityDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(handleSecurityRequestClose, "handleSecurityRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(showSecurityLoader, "showSecurityLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(hideSecurityLoader, "hideSecurityLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchSecurity, "fetchSecurity", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(fetchSecuritySuccess, "fetchSecuritySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(fetchSecuritys, "fetchSecuritys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(fetchSecuritysSuccess, "fetchSecuritysSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(showSecurityMessage, "showSecurityMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(addFavouriteSecurity, "addFavouriteSecurity", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(addFavouriteSecuritySuccess, "addFavouriteSecuritySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(onSecuritySelect, "onSecuritySelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(onAddSecurity, "onAddSecurity", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(onSecurityClose, "onSecurityClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(onFilterSecurityOptionSelect, "onFilterSecurityOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(onSaveSecurity, "onSaveSecurity", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(onSaveSecuritySuccess, "onSaveSecuritySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(onDeleteSecurity, "onDeleteSecurity", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(onDeleteSecuritySuccess, "onDeleteSecuritySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(onFilterSelectedSecurity, "onFilterSelectedSecurity", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(filterSecurity, "filterSecurity", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(getAllSecurity, "getAllSecurity", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllSecurity, "getUnselectedAllSecurity", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(onAllSecuritySelect, "onAllSecuritySelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(updateSearchSecurity, "updateSearchSecurity", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(onToggleSecurityDrawer, "onToggleSecurityDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(handleSecurityRequestClose, "handleSecurityRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(showSecurityLoader, "showSecurityLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(hideSecurityLoader, "hideSecurityLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/security.js");
}();

;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideBusinessUnitLoader = exports.showBusinessUnitLoader = exports.handleBusinessUnitRequestClose = exports.onToggleBusinessUnitDrawer = exports.updateSearchBusinessUnit = exports.onAllBusinessUnitSelect = exports.getUnselectedAllBusinessUnit = exports.getAllBusinessUnit = exports.filterBusinessUnit = exports.onFilterSelectedBusinessUnit = exports.onDeleteBusinessUnitSuccess = exports.onDeleteBusinessUnit = exports.onSaveBusinessUnitSuccess = exports.onSaveBusinessUnit = exports.onFilterBusinessUnitOptionSelect = exports.onBusinessUnitClose = exports.onAddBusinessUnit = exports.onBusinessUnitSelect = exports.addFavouriteBusinessUnitSuccess = exports.addFavouriteBusinessUnit = exports.showBusinessUnitMessage = exports.fetchBusinessUnitsSuccess = exports.fetchBusinessUnits = exports.fetchBusinessUnitSuccess = exports.fetchBusinessUnit = void 0;

var _ActionTypes = __webpack_require__(7);

var fetchBusinessUnit = function fetchBusinessUnit(payload) {
  return {
    type: _ActionTypes.FETCH_BUSINESS_UNIT,
    payload: payload
  };
};

exports.fetchBusinessUnit = fetchBusinessUnit;

var fetchBusinessUnitSuccess = function fetchBusinessUnitSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_BUSINESS_UNIT_SUCCESS,
    payload: payload
  };
};

exports.fetchBusinessUnitSuccess = fetchBusinessUnitSuccess;

var fetchBusinessUnits = function fetchBusinessUnits() {
  return {
    type: _ActionTypes.FETCH_ALL_BUSINESS_UNIT
  };
};

exports.fetchBusinessUnits = fetchBusinessUnits;

var fetchBusinessUnitsSuccess = function fetchBusinessUnitsSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_ALL_BUSINESS_UNIT_SUCCESS,
    payload: payload
  };
};

exports.fetchBusinessUnitsSuccess = fetchBusinessUnitsSuccess;

var showBusinessUnitMessage = function showBusinessUnitMessage(message) {
  return {
    type: _ActionTypes.SHOW_BUSINESS_UNIT_MESSAGE,
    payload: message
  };
};

exports.showBusinessUnitMessage = showBusinessUnitMessage;

var addFavouriteBusinessUnit = function addFavouriteBusinessUnit(payload) {
  return {
    type: _ActionTypes.ADD_FAVOURITE_BUSINESS_UNIT,
    payload: payload
  };
};

exports.addFavouriteBusinessUnit = addFavouriteBusinessUnit;

var addFavouriteBusinessUnitSuccess = function addFavouriteBusinessUnitSuccess(payload) {
  return {
    type: _ActionTypes.ADD_FAVOURITE_BUSINESS_UNIT_SUCCESS,
    payload: payload
  };
};

exports.addFavouriteBusinessUnitSuccess = addFavouriteBusinessUnitSuccess;

var onBusinessUnitSelect = function onBusinessUnitSelect(payload) {
  return {
    type: _ActionTypes.ON_BUSINESS_UNIT_SELECT,
    payload: payload
  };
};

exports.onBusinessUnitSelect = onBusinessUnitSelect;

var onAddBusinessUnit = function onAddBusinessUnit() {
  return {
    type: _ActionTypes.ON_ADD_BUSINESS_UNIT,
    payload: ''
  };
};

exports.onAddBusinessUnit = onAddBusinessUnit;

var onBusinessUnitClose = function onBusinessUnitClose() {
  return {
    type: _ActionTypes.ON_BUSINESS_UNIT_CLOSE,
    payload: ''
  };
};

exports.onBusinessUnitClose = onBusinessUnitClose;

var onFilterBusinessUnitOptionSelect = function onFilterBusinessUnitOptionSelect(payload) {
  return {
    type: _ActionTypes.ON_FILTER_BUSINESS_UNIT_OPTION_SELECT,
    payload: payload
  };
};

exports.onFilterBusinessUnitOptionSelect = onFilterBusinessUnitOptionSelect;

var onSaveBusinessUnit = function onSaveBusinessUnit(payload) {
  return {
    type: _ActionTypes.ON_SAVE_BUSINESS_UNIT,
    payload: payload
  };
};

exports.onSaveBusinessUnit = onSaveBusinessUnit;

var onSaveBusinessUnitSuccess = function onSaveBusinessUnitSuccess(data) {
  return {
    type: _ActionTypes.ON_SAVE_BUSINESS_UNIT_SUCCESS,
    payload: data
  };
};

exports.onSaveBusinessUnitSuccess = onSaveBusinessUnitSuccess;

var onDeleteBusinessUnit = function onDeleteBusinessUnit(payload) {
  return {
    type: _ActionTypes.ON_DELETE_BUSINESS_UNIT,
    payload: payload
  };
};

exports.onDeleteBusinessUnit = onDeleteBusinessUnit;

var onDeleteBusinessUnitSuccess = function onDeleteBusinessUnitSuccess(payload) {
  return {
    type: _ActionTypes.ON_DELETE_BUSINESS_UNIT_SUCCESS,
    payload: payload
  };
};

exports.onDeleteBusinessUnitSuccess = onDeleteBusinessUnitSuccess;

var onFilterSelectedBusinessUnit = function onFilterSelectedBusinessUnit() {
  return {
    type: _ActionTypes.ON_FILTER_SELECTED_BUSINESS_UNIT,
    payload: ''
  };
};

exports.onFilterSelectedBusinessUnit = onFilterSelectedBusinessUnit;

var filterBusinessUnit = function filterBusinessUnit(payload) {
  return {
    type: _ActionTypes.FILTER_BUSINESS_UNIT,
    payload: payload
  };
};

exports.filterBusinessUnit = filterBusinessUnit;

var getAllBusinessUnit = function getAllBusinessUnit() {
  return {
    type: _ActionTypes.GET_ALL_BUSINESS_UNIT,
    payload: ''
  };
};

exports.getAllBusinessUnit = getAllBusinessUnit;

var getUnselectedAllBusinessUnit = function getUnselectedAllBusinessUnit() {
  return {
    type: _ActionTypes.GET_UNSELECTED_ALL_BUSINESS_UNIT,
    payload: ''
  };
};

exports.getUnselectedAllBusinessUnit = getUnselectedAllBusinessUnit;

var onAllBusinessUnitSelect = function onAllBusinessUnitSelect() {
  return {
    type: _ActionTypes.ON_ALL_BUSINESS_UNIT_SELECT,
    payload: ''
  };
};

exports.onAllBusinessUnitSelect = onAllBusinessUnitSelect;

var updateSearchBusinessUnit = function updateSearchBusinessUnit(payload) {
  return {
    type: _ActionTypes.UPDATE_SEARCH_BUSINESS_UNIT,
    payload: payload
  };
};

exports.updateSearchBusinessUnit = updateSearchBusinessUnit;

var onToggleBusinessUnitDrawer = function onToggleBusinessUnitDrawer() {
  return {
    type: _ActionTypes.ON_TOGGLE_BUSINESS_UNIT_DRAWER
  };
};

exports.onToggleBusinessUnitDrawer = onToggleBusinessUnitDrawer;

var handleBusinessUnitRequestClose = function handleBusinessUnitRequestClose() {
  return {
    type: _ActionTypes.HANDLE_BUSINESS_UNIT_REQUEST_CLOSE
  };
};

exports.handleBusinessUnitRequestClose = handleBusinessUnitRequestClose;

var showBusinessUnitLoader = function showBusinessUnitLoader() {
  return {
    type: _ActionTypes.SHOW_BUSINESS_UNIT_LOADER
  };
};

exports.showBusinessUnitLoader = showBusinessUnitLoader;

var hideBusinessUnitLoader = function hideBusinessUnitLoader() {
  return {
    type: _ActionTypes.HIDE_BUSINESS_UNIT_LOADER
  };
};

exports.hideBusinessUnitLoader = hideBusinessUnitLoader;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchBusinessUnit, "fetchBusinessUnit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(fetchBusinessUnitSuccess, "fetchBusinessUnitSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(fetchBusinessUnits, "fetchBusinessUnits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(fetchBusinessUnitsSuccess, "fetchBusinessUnitsSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(showBusinessUnitMessage, "showBusinessUnitMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(addFavouriteBusinessUnit, "addFavouriteBusinessUnit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(addFavouriteBusinessUnitSuccess, "addFavouriteBusinessUnitSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(onBusinessUnitSelect, "onBusinessUnitSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(onAddBusinessUnit, "onAddBusinessUnit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(onBusinessUnitClose, "onBusinessUnitClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(onFilterBusinessUnitOptionSelect, "onFilterBusinessUnitOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(onSaveBusinessUnit, "onSaveBusinessUnit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(onSaveBusinessUnitSuccess, "onSaveBusinessUnitSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(onDeleteBusinessUnit, "onDeleteBusinessUnit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(onDeleteBusinessUnitSuccess, "onDeleteBusinessUnitSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(onFilterSelectedBusinessUnit, "onFilterSelectedBusinessUnit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(filterBusinessUnit, "filterBusinessUnit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(getAllBusinessUnit, "getAllBusinessUnit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllBusinessUnit, "getUnselectedAllBusinessUnit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(onAllBusinessUnitSelect, "onAllBusinessUnitSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(updateSearchBusinessUnit, "updateSearchBusinessUnit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(onToggleBusinessUnitDrawer, "onToggleBusinessUnitDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(handleBusinessUnitRequestClose, "handleBusinessUnitRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(showBusinessUnitLoader, "showBusinessUnitLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(hideBusinessUnitLoader, "hideBusinessUnitLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchBusinessUnit, "fetchBusinessUnit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(fetchBusinessUnitSuccess, "fetchBusinessUnitSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(fetchBusinessUnits, "fetchBusinessUnits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(fetchBusinessUnitsSuccess, "fetchBusinessUnitsSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(showBusinessUnitMessage, "showBusinessUnitMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(addFavouriteBusinessUnit, "addFavouriteBusinessUnit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(addFavouriteBusinessUnitSuccess, "addFavouriteBusinessUnitSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(onBusinessUnitSelect, "onBusinessUnitSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(onAddBusinessUnit, "onAddBusinessUnit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(onBusinessUnitClose, "onBusinessUnitClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(onFilterBusinessUnitOptionSelect, "onFilterBusinessUnitOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(onSaveBusinessUnit, "onSaveBusinessUnit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(onSaveBusinessUnitSuccess, "onSaveBusinessUnitSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(onDeleteBusinessUnit, "onDeleteBusinessUnit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(onDeleteBusinessUnitSuccess, "onDeleteBusinessUnitSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(onFilterSelectedBusinessUnit, "onFilterSelectedBusinessUnit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(filterBusinessUnit, "filterBusinessUnit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(getAllBusinessUnit, "getAllBusinessUnit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllBusinessUnit, "getUnselectedAllBusinessUnit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(onAllBusinessUnitSelect, "onAllBusinessUnitSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(updateSearchBusinessUnit, "updateSearchBusinessUnit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(onToggleBusinessUnitDrawer, "onToggleBusinessUnitDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(handleBusinessUnitRequestClose, "handleBusinessUnitRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(showBusinessUnitLoader, "showBusinessUnitLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(hideBusinessUnitLoader, "hideBusinessUnitLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/businessUnit.js");
}();

;

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Manager__ = __webpack_require__(1347);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Manager__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Target__ = __webpack_require__(1348);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__Target__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Popper__ = __webpack_require__(1349);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__Popper__["a"]; });
/* unused harmony reexport placements */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Arrow__ = __webpack_require__(1350);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__Arrow__["a"]; });





/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleCollapsedNav = toggleCollapsedNav;
exports.setDrawerType = setDrawerType;
exports.updateWindowWidth = updateWindowWidth;
exports.updateWindowHeight = updateWindowHeight;
exports.setThemeColor = setThemeColor;
exports.setDarkTheme = setDarkTheme;
exports.changeDirection = changeDirection;
exports.showHideColorOptionsModal = showHideColorOptionsModal;
exports.showHideUserInfoModal = showHideUserInfoModal;
exports.changeNavigationStyle = changeNavigationStyle;
exports.setHorizontalMenuPosition = setHorizontalMenuPosition;
exports.switchLanguage = switchLanguage;

var _ActionTypes = __webpack_require__(7);

function toggleCollapsedNav(isNavCollapsed) {
  return {
    type: _ActionTypes.TOGGLE_COLLAPSED_NAV,
    isNavCollapsed: isNavCollapsed
  };
}

function setDrawerType(drawerType) {
  return {
    type: _ActionTypes.DRAWER_TYPE,
    drawerType: drawerType
  };
}

function updateWindowWidth(width) {
  return {
    type: _ActionTypes.WINDOW_WIDTH,
    width: width
  };
}

function updateWindowHeight(height) {
  return {
    type: _ActionTypes.WINDOW_HEIGHT,
    height: height
  };
}

function setThemeColor(color) {
  return {
    type: _ActionTypes.THEME_COLOR,
    color: color
  };
}

function setDarkTheme() {
  return {
    type: _ActionTypes.DARK_THEME
  };
}

function changeDirection() {
  return {
    type: _ActionTypes.CHANGE_DIRECTION
  };
}

function showHideColorOptionsModal() {
  return {
    type: _ActionTypes.COLOR_OPTIONS_MODAL
  };
}

function showHideUserInfoModal() {
  return {
    type: _ActionTypes.USER_INFO_MODAL
  };
}

function changeNavigationStyle(layoutType) {
  return {
    type: _ActionTypes.CHANGE_NAVIGATION_STYLE,
    payload: layoutType
  };
}

function setHorizontalMenuPosition(navigationPosition) {
  return {
    type: _ActionTypes.HORIZONTAL_MENU_POSITION,
    payload: navigationPosition
  };
}

function switchLanguage(locale) {
  return {
    type: _ActionTypes.SWITCH_LANGUAGE,
    payload: locale
  };
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(toggleCollapsedNav, "toggleCollapsedNav", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Setting.js");

  __REACT_HOT_LOADER__.register(setDrawerType, "setDrawerType", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Setting.js");

  __REACT_HOT_LOADER__.register(updateWindowWidth, "updateWindowWidth", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Setting.js");

  __REACT_HOT_LOADER__.register(updateWindowHeight, "updateWindowHeight", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Setting.js");

  __REACT_HOT_LOADER__.register(setThemeColor, "setThemeColor", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Setting.js");

  __REACT_HOT_LOADER__.register(setDarkTheme, "setDarkTheme", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Setting.js");

  __REACT_HOT_LOADER__.register(changeDirection, "changeDirection", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Setting.js");

  __REACT_HOT_LOADER__.register(showHideColorOptionsModal, "showHideColorOptionsModal", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Setting.js");

  __REACT_HOT_LOADER__.register(showHideUserInfoModal, "showHideUserInfoModal", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Setting.js");

  __REACT_HOT_LOADER__.register(changeNavigationStyle, "changeNavigationStyle", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Setting.js");

  __REACT_HOT_LOADER__.register(setHorizontalMenuPosition, "setHorizontalMenuPosition", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Setting.js");

  __REACT_HOT_LOADER__.register(switchLanguage, "switchLanguage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Setting.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(toggleCollapsedNav, "toggleCollapsedNav", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Setting.js");

  __REACT_HOT_LOADER__.register(setDrawerType, "setDrawerType", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Setting.js");

  __REACT_HOT_LOADER__.register(updateWindowWidth, "updateWindowWidth", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Setting.js");

  __REACT_HOT_LOADER__.register(updateWindowHeight, "updateWindowHeight", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Setting.js");

  __REACT_HOT_LOADER__.register(setThemeColor, "setThemeColor", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Setting.js");

  __REACT_HOT_LOADER__.register(setDarkTheme, "setDarkTheme", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Setting.js");

  __REACT_HOT_LOADER__.register(changeDirection, "changeDirection", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Setting.js");

  __REACT_HOT_LOADER__.register(showHideColorOptionsModal, "showHideColorOptionsModal", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Setting.js");

  __REACT_HOT_LOADER__.register(showHideUserInfoModal, "showHideUserInfoModal", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Setting.js");

  __REACT_HOT_LOADER__.register(changeNavigationStyle, "changeNavigationStyle", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Setting.js");

  __REACT_HOT_LOADER__.register(setHorizontalMenuPosition, "setHorizontalMenuPosition", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Setting.js");

  __REACT_HOT_LOADER__.register(switchLanguage, "switchLanguage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Setting.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Setting.js");
}();

;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

/*! @license DOMPurify | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.0.8/LICENSE */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.DOMPurify = factory());
}(this, function () { 'use strict';

  function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

  var hasOwnProperty = Object.hasOwnProperty,
      setPrototypeOf = Object.setPrototypeOf,
      isFrozen = Object.isFrozen,
      objectKeys = Object.keys;
  var freeze = Object.freeze,
      seal = Object.seal; // eslint-disable-line import/no-mutable-exports

  var _ref = typeof Reflect !== 'undefined' && Reflect,
      apply = _ref.apply,
      construct = _ref.construct;

  if (!apply) {
    apply = function apply(fun, thisValue, args) {
      return fun.apply(thisValue, args);
    };
  }

  if (!freeze) {
    freeze = function freeze(x) {
      return x;
    };
  }

  if (!seal) {
    seal = function seal(x) {
      return x;
    };
  }

  if (!construct) {
    construct = function construct(Func, args) {
      return new (Function.prototype.bind.apply(Func, [null].concat(_toConsumableArray(args))))();
    };
  }

  var arrayForEach = unapply(Array.prototype.forEach);
  var arrayIndexOf = unapply(Array.prototype.indexOf);
  var arrayJoin = unapply(Array.prototype.join);
  var arrayPop = unapply(Array.prototype.pop);
  var arrayPush = unapply(Array.prototype.push);
  var arraySlice = unapply(Array.prototype.slice);

  var stringToLowerCase = unapply(String.prototype.toLowerCase);
  var stringMatch = unapply(String.prototype.match);
  var stringReplace = unapply(String.prototype.replace);
  var stringIndexOf = unapply(String.prototype.indexOf);
  var stringTrim = unapply(String.prototype.trim);

  var regExpTest = unapply(RegExp.prototype.test);
  var regExpCreate = unconstruct(RegExp);

  var typeErrorCreate = unconstruct(TypeError);

  function unapply(func) {
    return function (thisArg) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return apply(func, thisArg, args);
    };
  }

  function unconstruct(func) {
    return function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return construct(func, args);
    };
  }

  /* Add properties to a lookup table */
  function addToSet(set, array) {
    if (setPrototypeOf) {
      // Make 'in' and truthy checks like Boolean(set.constructor)
      // independent of any properties defined on Object.prototype.
      // Prevent prototype setters from intercepting set as a this value.
      setPrototypeOf(set, null);
    }

    var l = array.length;
    while (l--) {
      var element = array[l];
      if (typeof element === 'string') {
        var lcElement = stringToLowerCase(element);
        if (lcElement !== element) {
          // Config presets (e.g. tags.js, attrs.js) are immutable.
          if (!isFrozen(array)) {
            array[l] = lcElement;
          }

          element = lcElement;
        }
      }

      set[element] = true;
    }

    return set;
  }

  /* Shallow clone an object */
  function clone(object) {
    var newObject = {};

    var property = void 0;
    for (property in object) {
      if (apply(hasOwnProperty, object, [property])) {
        newObject[property] = object[property];
      }
    }

    return newObject;
  }

  var html = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']);

  // SVG
  var svg = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'audio', 'canvas', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'video', 'view', 'vkern']);

  var svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']);

  var mathMl = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover']);

  var text = freeze(['#text']);

  var html$1 = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns']);

  var svg$1 = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'tabindex', 'targetx', 'targety', 'transform', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);

  var mathMl$1 = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);

  var xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

  // eslint-disable-next-line unicorn/better-regex
  var MUSTACHE_EXPR = seal(/\{\{[\s\S]*|[\s\S]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
  var ERB_EXPR = seal(/<%[\s\S]*|[\s\S]*%>/gm);
  var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
  var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
  var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
  );
  var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
  var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g // eslint-disable-line no-control-regex
  );

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

  function _toConsumableArray$1(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

  var getGlobal = function getGlobal() {
    return typeof window === 'undefined' ? null : window;
  };

  /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */
  var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
    if ((typeof trustedTypes === 'undefined' ? 'undefined' : _typeof(trustedTypes)) !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
      return null;
    }

    // Allow the callers to control the unique policy name
    // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
    // Policy creation with duplicate names throws in Trusted Types.
    var suffix = null;
    var ATTR_NAME = 'data-tt-policy-suffix';
    if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) {
      suffix = document.currentScript.getAttribute(ATTR_NAME);
    }

    var policyName = 'dompurify' + (suffix ? '#' + suffix : '');

    try {
      return trustedTypes.createPolicy(policyName, {
        createHTML: function createHTML(html$$1) {
          return html$$1;
        }
      });
    } catch (_) {
      // Policy creation failed (most likely another DOMPurify script has
      // already run). Skip creating the policy, as this will only cause errors
      // if TT are enforced.
      console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
      return null;
    }
  };

  function createDOMPurify() {
    var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();

    var DOMPurify = function DOMPurify(root) {
      return createDOMPurify(root);
    };

    /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */
    DOMPurify.version = '2.0.12';

    /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */
    DOMPurify.removed = [];

    if (!window || !window.document || window.document.nodeType !== 9) {
      // Not running in a browser, provide a factory function
      // so that you can pass your own Window
      DOMPurify.isSupported = false;

      return DOMPurify;
    }

    var originalDocument = window.document;
    var removeTitle = false;

    var document = window.document;
    var DocumentFragment = window.DocumentFragment,
        HTMLTemplateElement = window.HTMLTemplateElement,
        Node = window.Node,
        NodeFilter = window.NodeFilter,
        _window$NamedNodeMap = window.NamedNodeMap,
        NamedNodeMap = _window$NamedNodeMap === undefined ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap,
        Text = window.Text,
        Comment = window.Comment,
        DOMParser = window.DOMParser,
        trustedTypes = window.trustedTypes;

    // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.

    if (typeof HTMLTemplateElement === 'function') {
      var template = document.createElement('template');
      if (template.content && template.content.ownerDocument) {
        document = template.content.ownerDocument;
      }
    }

    var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
    var emptyHTML = trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML('') : '';

    var _document = document,
        implementation = _document.implementation,
        createNodeIterator = _document.createNodeIterator,
        getElementsByTagName = _document.getElementsByTagName,
        createDocumentFragment = _document.createDocumentFragment;
    var importNode = originalDocument.importNode;


    var hooks = {};

    /**
     * Expose whether this browser supports running the full DOMPurify.
     */
    DOMPurify.isSupported = implementation && typeof implementation.createHTMLDocument !== 'undefined' && document.documentMode !== 9;

    var MUSTACHE_EXPR$$1 = MUSTACHE_EXPR,
        ERB_EXPR$$1 = ERB_EXPR,
        DATA_ATTR$$1 = DATA_ATTR,
        ARIA_ATTR$$1 = ARIA_ATTR,
        IS_SCRIPT_OR_DATA$$1 = IS_SCRIPT_OR_DATA,
        ATTR_WHITESPACE$$1 = ATTR_WHITESPACE;
    var IS_ALLOWED_URI$$1 = IS_ALLOWED_URI;

    /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */

    /* allowed element names */

    var ALLOWED_TAGS = null;
    var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray$1(html), _toConsumableArray$1(svg), _toConsumableArray$1(svgFilters), _toConsumableArray$1(mathMl), _toConsumableArray$1(text)));

    /* Allowed attribute names */
    var ALLOWED_ATTR = null;
    var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray$1(html$1), _toConsumableArray$1(svg$1), _toConsumableArray$1(mathMl$1), _toConsumableArray$1(xml)));

    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */
    var FORBID_TAGS = null;

    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */
    var FORBID_ATTR = null;

    /* Decide if ARIA attributes are okay */
    var ALLOW_ARIA_ATTR = true;

    /* Decide if custom data attributes are okay */
    var ALLOW_DATA_ATTR = true;

    /* Decide if unknown protocols are okay */
    var ALLOW_UNKNOWN_PROTOCOLS = false;

    /* Output should be safe for jQuery's $() factory? */
    var SAFE_FOR_JQUERY = false;

    /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */
    var SAFE_FOR_TEMPLATES = false;

    /* Decide if document with <html>... should be returned */
    var WHOLE_DOCUMENT = false;

    /* Track whether config is already set on this instance of DOMPurify. */
    var SET_CONFIG = false;

    /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */
    var FORCE_BODY = false;

    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */
    var RETURN_DOM = false;

    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */
    var RETURN_DOM_FRAGMENT = false;

    /* If `RETURN_DOM` or `RETURN_DOM_FRAGMENT` is enabled, decide if the returned DOM
     * `Node` is imported into the current `Document`. If this flag is not enabled the
     * `Node` will belong (its ownerDocument) to a fresh `HTMLDocument`, created by
     * DOMPurify. */
    var RETURN_DOM_IMPORT = false;

    /* Try to return a Trusted Type object instead of a string, retrun a string in
     * case Trusted Types are not supported  */
    var RETURN_TRUSTED_TYPE = false;

    /* Output should be free from DOM clobbering attacks? */
    var SANITIZE_DOM = true;

    /* Keep element content when removing element? */
    var KEEP_CONTENT = true;

    /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */
    var IN_PLACE = false;

    /* Allow usage of profiles like html, svg and mathMl */
    var USE_PROFILES = {};

    /* Tags to ignore content of when KEEP_CONTENT is true */
    var FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);

    /* Tags that are safe for data: URIs */
    var DATA_URI_TAGS = null;
    var DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);

    /* Attributes safe for values like "javascript:" */
    var URI_SAFE_ATTRIBUTES = null;
    var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'summary', 'title', 'value', 'style', 'xmlns']);

    /* Keep a reference to config to pass to hooks */
    var CONFIG = null;

    /* Ideally, do not touch anything below this line */
    /* ______________________________________________ */

    var formElement = document.createElement('form');

    /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */
    // eslint-disable-next-line complexity
    var _parseConfig = function _parseConfig(cfg) {
      if (CONFIG && CONFIG === cfg) {
        return;
      }

      /* Shield configuration object from tampering */
      if (!cfg || (typeof cfg === 'undefined' ? 'undefined' : _typeof(cfg)) !== 'object') {
        cfg = {};
      }

      /* Set configuration parameters */
      ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS) : DEFAULT_ALLOWED_TAGS;
      ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR) : DEFAULT_ALLOWED_ATTR;
      URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR) : DEFAULT_URI_SAFE_ATTRIBUTES;
      DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS) : DEFAULT_DATA_URI_TAGS;
      FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS) : {};
      FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR) : {};
      USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
      ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
      ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
      ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
      SAFE_FOR_JQUERY = cfg.SAFE_FOR_JQUERY || false; // Default false
      SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
      WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
      RETURN_DOM = cfg.RETURN_DOM || false; // Default false
      RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
      RETURN_DOM_IMPORT = cfg.RETURN_DOM_IMPORT || false; // Default false
      RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
      FORCE_BODY = cfg.FORCE_BODY || false; // Default false
      SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
      KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
      IN_PLACE = cfg.IN_PLACE || false; // Default false
      IS_ALLOWED_URI$$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$$1;
      if (SAFE_FOR_TEMPLATES) {
        ALLOW_DATA_ATTR = false;
      }

      if (RETURN_DOM_FRAGMENT) {
        RETURN_DOM = true;
      }

      /* Parse profile info */
      if (USE_PROFILES) {
        ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray$1(text)));
        ALLOWED_ATTR = [];
        if (USE_PROFILES.html === true) {
          addToSet(ALLOWED_TAGS, html);
          addToSet(ALLOWED_ATTR, html$1);
        }

        if (USE_PROFILES.svg === true) {
          addToSet(ALLOWED_TAGS, svg);
          addToSet(ALLOWED_ATTR, svg$1);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.svgFilters === true) {
          addToSet(ALLOWED_TAGS, svgFilters);
          addToSet(ALLOWED_ATTR, svg$1);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.mathMl === true) {
          addToSet(ALLOWED_TAGS, mathMl);
          addToSet(ALLOWED_ATTR, mathMl$1);
          addToSet(ALLOWED_ATTR, xml);
        }
      }

      /* Merge configuration parameters */
      if (cfg.ADD_TAGS) {
        if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
          ALLOWED_TAGS = clone(ALLOWED_TAGS);
        }

        addToSet(ALLOWED_TAGS, cfg.ADD_TAGS);
      }

      if (cfg.ADD_ATTR) {
        if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
          ALLOWED_ATTR = clone(ALLOWED_ATTR);
        }

        addToSet(ALLOWED_ATTR, cfg.ADD_ATTR);
      }

      if (cfg.ADD_URI_SAFE_ATTR) {
        addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR);
      }

      /* Add #text in case KEEP_CONTENT is set to true */
      if (KEEP_CONTENT) {
        ALLOWED_TAGS['#text'] = true;
      }

      /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */
      if (WHOLE_DOCUMENT) {
        addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
      }

      /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */
      if (ALLOWED_TAGS.table) {
        addToSet(ALLOWED_TAGS, ['tbody']);
        delete FORBID_TAGS.tbody;
      }

      // Prevent further manipulation of configuration.
      // Not available in IE8, Safari 5, etc.
      if (freeze) {
        freeze(cfg);
      }

      CONFIG = cfg;
    };

    /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */
    var _forceRemove = function _forceRemove(node) {
      arrayPush(DOMPurify.removed, { element: node });
      try {
        // eslint-disable-next-line unicorn/prefer-node-remove
        node.parentNode.removeChild(node);
      } catch (_) {
        node.outerHTML = emptyHTML;
      }
    };

    /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */
    var _removeAttribute = function _removeAttribute(name, node) {
      try {
        arrayPush(DOMPurify.removed, {
          attribute: node.getAttributeNode(name),
          from: node
        });
      } catch (_) {
        arrayPush(DOMPurify.removed, {
          attribute: null,
          from: node
        });
      }

      node.removeAttribute(name);
    };

    /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */
    var _initDocument = function _initDocument(dirty) {
      /* Create a HTML document */
      var doc = void 0;
      var leadingWhitespace = void 0;

      if (FORCE_BODY) {
        dirty = '<remove></remove>' + dirty;
      } else {
        /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
        var matches = stringMatch(dirty, /^[\r\n\t ]+/);
        leadingWhitespace = matches && matches[0];
      }

      var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
      /* Use the DOMParser API by default, fallback later if needs be */
      try {
        doc = new DOMParser().parseFromString(dirtyPayload, 'text/html');
      } catch (_) {}

      /* Remove title to fix a mXSS bug in older MS Edge */
      if (removeTitle) {
        addToSet(FORBID_TAGS, ['title']);
      }

      /* Use createHTMLDocument in case DOMParser is not available */
      if (!doc || !doc.documentElement) {
        doc = implementation.createHTMLDocument('');
        var _doc = doc,
            body = _doc.body;

        body.parentNode.removeChild(body.parentNode.firstElementChild);
        body.outerHTML = dirtyPayload;
      }

      if (dirty && leadingWhitespace) {
        doc.body.insertBefore(document.createTextNode(leadingWhitespace), doc.body.childNodes[0] || null);
      }

      /* Work on whole document or just its body */
      return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
    };

    /* Here we test for a broken feature in Edge that might cause mXSS */
    if (DOMPurify.isSupported) {
      (function () {
        try {
          var doc = _initDocument('<x/><title>&lt;/title&gt;&lt;img&gt;');
          if (regExpTest(/<\/title/, doc.querySelector('title').innerHTML)) {
            removeTitle = true;
          }
        } catch (_) {}
      })();
    }

    /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */
    var _createIterator = function _createIterator(root) {
      return createNodeIterator.call(root.ownerDocument || root, root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, function () {
        return NodeFilter.FILTER_ACCEPT;
      }, false);
    };

    /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */
    var _isClobbered = function _isClobbered(elm) {
      if (elm instanceof Text || elm instanceof Comment) {
        return false;
      }

      if (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string') {
        return true;
      }

      return false;
    };

    /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */
    var _isNode = function _isNode(object) {
      return (typeof Node === 'undefined' ? 'undefined' : _typeof(Node)) === 'object' ? object instanceof Node : object && (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
    };

    /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */
    var _executeHook = function _executeHook(entryPoint, currentNode, data) {
      if (!hooks[entryPoint]) {
        return;
      }

      arrayForEach(hooks[entryPoint], function (hook) {
        hook.call(DOMPurify, currentNode, data, CONFIG);
      });
    };

    /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */
    // eslint-disable-next-line complexity
    var _sanitizeElements = function _sanitizeElements(currentNode) {
      var content = void 0;

      /* Execute a hook if present */
      _executeHook('beforeSanitizeElements', currentNode, null);

      /* Check if element is clobbered or can clobber */
      if (_isClobbered(currentNode)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Now let's check the element's type and name */
      var tagName = stringToLowerCase(currentNode.nodeName);

      /* Execute a hook if present */
      _executeHook('uponSanitizeElement', currentNode, {
        tagName: tagName,
        allowedTags: ALLOWED_TAGS
      });

      /* Take care of an mXSS pattern using p, br inside svg, math */
      if ((tagName === 'svg' || tagName === 'math') && currentNode.querySelectorAll('p, br').length !== 0) {
        _forceRemove(currentNode);
        return true;
      }

      /* Remove element if anything forbids its presence */
      if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
        /* Keep content except for bad-listed elements */
        if (KEEP_CONTENT && !FORBID_CONTENTS[tagName] && typeof currentNode.insertAdjacentHTML === 'function') {
          try {
            var htmlToInsert = currentNode.innerHTML;
            currentNode.insertAdjacentHTML('AfterEnd', trustedTypesPolicy ? trustedTypesPolicy.createHTML(htmlToInsert) : htmlToInsert);
          } catch (_) {}
        }

        _forceRemove(currentNode);
        return true;
      }

      /* Remove in case a noscript/noembed XSS is suspected */
      if (tagName === 'noscript' && regExpTest(/<\/noscript/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);
        return true;
      }

      if (tagName === 'noembed' && regExpTest(/<\/noembed/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Convert markup to cover jQuery behavior */
      if (SAFE_FOR_JQUERY && !currentNode.firstElementChild && (!currentNode.content || !currentNode.content.firstElementChild) && regExpTest(/</g, currentNode.textContent)) {
        arrayPush(DOMPurify.removed, { element: currentNode.cloneNode() });
        if (currentNode.innerHTML) {
          currentNode.innerHTML = stringReplace(currentNode.innerHTML, /</g, '&lt;');
        } else {
          currentNode.innerHTML = stringReplace(currentNode.textContent, /</g, '&lt;');
        }
      }

      /* Sanitize element content to be template-safe */
      if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
        /* Get the element's text content */
        content = currentNode.textContent;
        content = stringReplace(content, MUSTACHE_EXPR$$1, ' ');
        content = stringReplace(content, ERB_EXPR$$1, ' ');
        if (currentNode.textContent !== content) {
          arrayPush(DOMPurify.removed, { element: currentNode.cloneNode() });
          currentNode.textContent = content;
        }
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeElements', currentNode, null);

      return false;
    };

    /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */
    // eslint-disable-next-line complexity
    var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
      /* Make sure attribute cannot clobber */
      if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
        return false;
      }

      /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */
      if (ALLOW_DATA_ATTR && regExpTest(DATA_ATTR$$1, lcName)) ; else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$$1, lcName)) ; else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
        return false;

        /* Check value is safe. First, is attr inert? If so, is safe */
      } else if (URI_SAFE_ATTRIBUTES[lcName]) ; else if (regExpTest(IS_ALLOWED_URI$$1, stringReplace(value, ATTR_WHITESPACE$$1, ''))) ; else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ; else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$$1, stringReplace(value, ATTR_WHITESPACE$$1, ''))) ; else if (!value) ; else {
        return false;
      }

      return true;
    };

    /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */
    // eslint-disable-next-line complexity
    var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
      var attr = void 0;
      var value = void 0;
      var lcName = void 0;
      var idAttr = void 0;
      var l = void 0;
      /* Execute a hook if present */
      _executeHook('beforeSanitizeAttributes', currentNode, null);

      var attributes = currentNode.attributes;

      /* Check if we have attributes; if not we might have a text node */

      if (!attributes) {
        return;
      }

      var hookEvent = {
        attrName: '',
        attrValue: '',
        keepAttr: true,
        allowedAttributes: ALLOWED_ATTR
      };
      l = attributes.length;

      /* Go backwards over all attributes; safely remove bad ones */
      while (l--) {
        attr = attributes[l];
        var _attr = attr,
            name = _attr.name,
            namespaceURI = _attr.namespaceURI;

        value = stringTrim(attr.value);
        lcName = stringToLowerCase(name);

        /* Execute a hook if present */
        hookEvent.attrName = lcName;
        hookEvent.attrValue = value;
        hookEvent.keepAttr = true;
        hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
        _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
        value = hookEvent.attrValue;
        /* Did the hooks approve of the attribute? */
        if (hookEvent.forceKeepAttr) {
          continue;
        }

        /* Remove attribute */
        // Safari (iOS + Mac), last tested v8.0.5, crashes if you try to
        // remove a "name" attribute from an <img> tag that has an "id"
        // attribute at the time.
        if (lcName === 'name' && currentNode.nodeName === 'IMG' && attributes.id) {
          idAttr = attributes.id;
          attributes = arraySlice(attributes, []);
          _removeAttribute('id', currentNode);
          _removeAttribute(name, currentNode);
          if (arrayIndexOf(attributes, idAttr) > l) {
            currentNode.setAttribute('id', idAttr.value);
          }
        } else if (
        // This works around a bug in Safari, where input[type=file]
        // cannot be dynamically set after type has been removed
        currentNode.nodeName === 'INPUT' && lcName === 'type' && value === 'file' && hookEvent.keepAttr && (ALLOWED_ATTR[lcName] || !FORBID_ATTR[lcName])) {
          continue;
        } else {
          // This avoids a crash in Safari v9.0 with double-ids.
          // The trick is to first set the id to be empty and then to
          // remove the attribute
          if (name === 'id') {
            currentNode.setAttribute(name, '');
          }

          _removeAttribute(name, currentNode);
        }

        /* Did the hooks approve of the attribute? */
        if (!hookEvent.keepAttr) {
          continue;
        }

        /* Work around a security issue in jQuery 3.0 */
        if (SAFE_FOR_JQUERY && regExpTest(/\/>/i, value)) {
          _removeAttribute(name, currentNode);
          continue;
        }

        /* Take care of an mXSS pattern using namespace switches */
        if (regExpTest(/svg|math/i, currentNode.namespaceURI) && regExpTest(regExpCreate('</(' + arrayJoin(objectKeys(FORBID_CONTENTS), '|') + ')', 'i'), value)) {
          _removeAttribute(name, currentNode);
          continue;
        }

        /* Sanitize attribute content to be template-safe */
        if (SAFE_FOR_TEMPLATES) {
          value = stringReplace(value, MUSTACHE_EXPR$$1, ' ');
          value = stringReplace(value, ERB_EXPR$$1, ' ');
        }

        /* Is `value` valid for this attribute? */
        var lcTag = currentNode.nodeName.toLowerCase();
        if (!_isValidAttribute(lcTag, lcName, value)) {
          continue;
        }

        /* Handle invalid data-* attribute set by try-catching it */
        try {
          if (namespaceURI) {
            currentNode.setAttributeNS(namespaceURI, name, value);
          } else {
            /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
            currentNode.setAttribute(name, value);
          }

          arrayPop(DOMPurify.removed);
        } catch (_) {}
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeAttributes', currentNode, null);
    };

    /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */
    var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
      var shadowNode = void 0;
      var shadowIterator = _createIterator(fragment);

      /* Execute a hook if present */
      _executeHook('beforeSanitizeShadowDOM', fragment, null);

      while (shadowNode = shadowIterator.nextNode()) {
        /* Execute a hook if present */
        _executeHook('uponSanitizeShadowNode', shadowNode, null);

        /* Sanitize tags and elements */
        if (_sanitizeElements(shadowNode)) {
          continue;
        }

        /* Deep shadow DOM detected */
        if (shadowNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(shadowNode.content);
        }

        /* Check attributes, sanitize if necessary */
        _sanitizeAttributes(shadowNode);
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeShadowDOM', fragment, null);
    };

    /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */
    // eslint-disable-next-line complexity
    DOMPurify.sanitize = function (dirty, cfg) {
      var body = void 0;
      var importedNode = void 0;
      var currentNode = void 0;
      var oldNode = void 0;
      var returnNode = void 0;
      /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */
      if (!dirty) {
        dirty = '<!-->';
      }

      /* Stringify, in case dirty is an object */
      if (typeof dirty !== 'string' && !_isNode(dirty)) {
        // eslint-disable-next-line no-negated-condition
        if (typeof dirty.toString !== 'function') {
          throw typeErrorCreate('toString is not a function');
        } else {
          dirty = dirty.toString();
          if (typeof dirty !== 'string') {
            throw typeErrorCreate('dirty is not a string, aborting');
          }
        }
      }

      /* Check we can run. Otherwise fall back or ignore */
      if (!DOMPurify.isSupported) {
        if (_typeof(window.toStaticHTML) === 'object' || typeof window.toStaticHTML === 'function') {
          if (typeof dirty === 'string') {
            return window.toStaticHTML(dirty);
          }

          if (_isNode(dirty)) {
            return window.toStaticHTML(dirty.outerHTML);
          }
        }

        return dirty;
      }

      /* Assign config vars */
      if (!SET_CONFIG) {
        _parseConfig(cfg);
      }

      /* Clean up removed elements */
      DOMPurify.removed = [];

      /* Check if dirty is correctly typed for IN_PLACE */
      if (typeof dirty === 'string') {
        IN_PLACE = false;
      }

      if (IN_PLACE) ; else if (dirty instanceof Node) {
        /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */
        body = _initDocument('<!-->');
        importedNode = body.ownerDocument.importNode(dirty, true);
        if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
          /* Node is already a body, use as is */
          body = importedNode;
        } else if (importedNode.nodeName === 'HTML') {
          body = importedNode;
        } else {
          // eslint-disable-next-line unicorn/prefer-node-append
          body.appendChild(importedNode);
        }
      } else {
        /* Exit directly if we have nothing to do */
        if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT &&
        // eslint-disable-next-line unicorn/prefer-includes
        dirty.indexOf('<') === -1) {
          return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
        }

        /* Initialize the document to work on */
        body = _initDocument(dirty);

        /* Check we have a DOM node from the data */
        if (!body) {
          return RETURN_DOM ? null : emptyHTML;
        }
      }

      /* Remove first element node (ours) if FORCE_BODY is set */
      if (body && FORCE_BODY) {
        _forceRemove(body.firstChild);
      }

      /* Get node iterator */
      var nodeIterator = _createIterator(IN_PLACE ? dirty : body);

      /* Now start iterating over the created document */
      while (currentNode = nodeIterator.nextNode()) {
        /* Fix IE's strange behavior with manipulated textNodes #89 */
        if (currentNode.nodeType === 3 && currentNode === oldNode) {
          continue;
        }

        /* Sanitize tags and elements */
        if (_sanitizeElements(currentNode)) {
          continue;
        }

        /* Shadow DOM detected, sanitize it */
        if (currentNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(currentNode.content);
        }

        /* Check attributes, sanitize if necessary */
        _sanitizeAttributes(currentNode);

        oldNode = currentNode;
      }

      oldNode = null;

      /* If we sanitized `dirty` in-place, return it. */
      if (IN_PLACE) {
        return dirty;
      }

      /* Return sanitized string or DOM */
      if (RETURN_DOM) {
        if (RETURN_DOM_FRAGMENT) {
          returnNode = createDocumentFragment.call(body.ownerDocument);

          while (body.firstChild) {
            // eslint-disable-next-line unicorn/prefer-node-append
            returnNode.appendChild(body.firstChild);
          }
        } else {
          returnNode = body;
        }

        if (RETURN_DOM_IMPORT) {
          /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */
          returnNode = importNode.call(originalDocument, returnNode, true);
        }

        return returnNode;
      }

      var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;

      /* Sanitize final string template-safe */
      if (SAFE_FOR_TEMPLATES) {
        serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$$1, ' ');
        serializedHTML = stringReplace(serializedHTML, ERB_EXPR$$1, ' ');
      }

      return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
    };

    /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */
    DOMPurify.setConfig = function (cfg) {
      _parseConfig(cfg);
      SET_CONFIG = true;
    };

    /**
     * Public method to remove the configuration
     * clearConfig
     *
     */
    DOMPurify.clearConfig = function () {
      CONFIG = null;
      SET_CONFIG = false;
    };

    /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */
    DOMPurify.isValidAttribute = function (tag, attr, value) {
      /* Initialize shared config vars if necessary. */
      if (!CONFIG) {
        _parseConfig({});
      }

      var lcTag = stringToLowerCase(tag);
      var lcName = stringToLowerCase(attr);
      return _isValidAttribute(lcTag, lcName, value);
    };

    /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */
    DOMPurify.addHook = function (entryPoint, hookFunction) {
      if (typeof hookFunction !== 'function') {
        return;
      }

      hooks[entryPoint] = hooks[entryPoint] || [];
      arrayPush(hooks[entryPoint], hookFunction);
    };

    /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     */
    DOMPurify.removeHook = function (entryPoint) {
      if (hooks[entryPoint]) {
        arrayPop(hooks[entryPoint]);
      }
    };

    /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */
    DOMPurify.removeHooks = function (entryPoint) {
      if (hooks[entryPoint]) {
        hooks[entryPoint] = [];
      }
    };

    /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */
    DOMPurify.removeAllHooks = function () {
      hooks = {};
    };

    return DOMPurify;
  }

  var purify = createDOMPurify();

  return purify;

}));
//# sourceMappingURL=purify.js.map


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Setting = __webpack_require__(265);

Object.keys(_Setting).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Setting[key];
    }
  });
});

var _Chat = __webpack_require__(441);

Object.keys(_Chat).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Chat[key];
    }
  });
});

var _Contact = __webpack_require__(440);

Object.keys(_Contact).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Contact[key];
    }
  });
});

var _Mail = __webpack_require__(438);

Object.keys(_Mail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Mail[key];
    }
  });
});

var _ToDo = __webpack_require__(439);

Object.keys(_ToDo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ToDo[key];
    }
  });
});

var _Auth = __webpack_require__(143);

Object.keys(_Auth).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Auth[key];
    }
  });
});

var _Organisation = __webpack_require__(144);

Object.keys(_Organisation).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Organisation[key];
    }
  });
});

var _Employee = __webpack_require__(173);

Object.keys(_Employee).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Employee[key];
    }
  });
});

var _OrgSurvey = __webpack_require__(178);

Object.keys(_OrgSurvey).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _OrgSurvey[key];
    }
  });
});

var _OrgSurveyAnswers = __webpack_require__(211);

Object.keys(_OrgSurveyAnswers).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _OrgSurveyAnswers[key];
    }
  });
});

var _Survey = __webpack_require__(260);

Object.keys(_Survey).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Survey[key];
    }
  });
});

var _SurveyGroup = __webpack_require__(177);

Object.keys(_SurveyGroup).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SurveyGroup[key];
    }
  });
});

var _SurveyGroupQuestion = __webpack_require__(363);

Object.keys(_SurveyGroupQuestion).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SurveyGroupQuestion[key];
    }
  });
});

var _SurveyQuestion = __webpack_require__(261);

Object.keys(_SurveyQuestion).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SurveyQuestion[key];
    }
  });
});

var _project = __webpack_require__(179);

Object.keys(_project).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _project[key];
    }
  });
});

var _projectPriority = __webpack_require__(364);

Object.keys(_projectPriority).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _projectPriority[key];
    }
  });
});

var _security = __webpack_require__(262);

Object.keys(_security).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _security[key];
    }
  });
});

var _projectIssue = __webpack_require__(365);

Object.keys(_projectIssue).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _projectIssue[key];
    }
  });
});

var _businessUnit = __webpack_require__(263);

Object.keys(_businessUnit).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _businessUnit[key];
    }
  });
});

var _portfolio = __webpack_require__(113);

Object.keys(_portfolio).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _portfolio[key];
    }
  });
});

var _feature = __webpack_require__(114);

Object.keys(_feature).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _feature[key];
    }
  });
});

var _valueStream = __webpack_require__(115);

Object.keys(_valueStream).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _valueStream[key];
    }
  });
});

var _member = __webpack_require__(100);

Object.keys(_member).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _member[key];
    }
  });
});

var _team = __webpack_require__(116);

Object.keys(_team).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _team[key];
    }
  });
});

var _product = __webpack_require__(117);

Object.keys(_product).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _product[key];
    }
  });
});

var _initiative = __webpack_require__(101);

Object.keys(_initiative).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _initiative[key];
    }
  });
});

var _issue = __webpack_require__(147);

Object.keys(_issue).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _issue[key];
    }
  });
});

var _projectBusPriority = __webpack_require__(180);

Object.keys(_projectBusPriority).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _projectBusPriority[key];
    }
  });
});

var _projectCostPriority = __webpack_require__(181);

Object.keys(_projectCostPriority).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _projectCostPriority[key];
    }
  });
});
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/index.js");
}();

;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(690);
var enumBugKeys = __webpack_require__(377);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 269 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 270 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 271 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1454);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1464);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(186);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 274 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 275 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

var isNumber = __webpack_require__(277);

/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */
function isNaN(value) {
  // An `NaN` primitive is the only value that is not equal to itself.
  // Perform the `toStringTag` check first to avoid errors with some
  // ActiveX objects in IE.
  return isNumber(value) && value != +value;
}

module.exports = isNaN;


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(111),
    isObjectLike = __webpack_require__(79);

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
function shallowEqual(a, b) {
  /* eslint-disable no-restricted-syntax */
  for (var key in a) {
    if ({}.hasOwnProperty.call(a, key) && (!{}.hasOwnProperty.call(b, key) || a[key] !== b[key])) {
      return false;
    }
  }

  for (var _key in b) {
    if ({}.hasOwnProperty.call(b, _key) && !{}.hasOwnProperty.call(a, _key)) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: this._context.lineTo(x, y); break;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Linear(context);
});


/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {});


/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = point;
/* harmony export (immutable) */ __webpack_exports__["a"] = Basis;
function point(that, x, y) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x) / 6,
    (that._y0 + 4 * that._y1 + y) / 6
  );
}

function Basis(context) {
  this._context = context;
}

Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3: point(this, this._x1, this._y1); // proceed
      case 2: this._context.lineTo(this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = (function(context) {
  return new Basis(context);
});


/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = point;
/* harmony export (immutable) */ __webpack_exports__["a"] = Cardinal;
function point(that, x, y) {
  that._context.bezierCurveTo(
    that._x1 + that._k * (that._x2 - that._x0),
    that._y1 + that._k * (that._y2 - that._y0),
    that._x2 + that._k * (that._x1 - x),
    that._y2 + that._k * (that._y1 - y),
    that._x2,
    that._y2
  );
}

function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

Cardinal.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: point(this, this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(tension) {

  function cardinal(context) {
    return new Cardinal(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniqBy__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_smooth__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DefaultTooltipContent__ = __webpack_require__(1588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_DataUtils__ = __webpack_require__(23);




function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Tooltip
 */







var CLS_PREFIX = 'recharts-tooltip-wrapper';
var EPS = 1;

var defaultUniqBy = function defaultUniqBy(entry) {
  return entry.dataKey;
};

var getUniqPaylod = function getUniqPaylod(option, payload) {
  if (option === true) {
    return __WEBPACK_IMPORTED_MODULE_2_lodash_uniqBy___default()(payload, defaultUniqBy);
  }

  if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(option)) {
    return __WEBPACK_IMPORTED_MODULE_2_lodash_uniqBy___default()(payload, option);
  }

  return payload;
};

var propTypes = {
  allowEscapeViewBox: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a["boolean"],
    y: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a["boolean"]
  }),
  content: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]),
  viewBox: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    width: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    height: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number
  }),
  active: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  separator: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  formatter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  offset: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  itemStyle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  labelStyle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  wrapperStyle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  contentStyle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  cursor: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object]),
  coordinate: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number
  }),
  position: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number
  }),
  label: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
  payload: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    name: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
    value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array]),
    unit: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
    type: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["e" /* TOOLTIP_TYPES */])
  })),
  paylodUniqBy: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool]),
  isAnimationActive: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  animationDuration: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
  itemSorter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  filterNull: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  useTranslate3d: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
};
var defaultProps = {
  active: false,
  allowEscapeViewBox: {
    x: false,
    y: false
  },
  offset: 10,
  viewBox: {
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 0
  },
  coordinate: {
    x: 0,
    y: 0
  },
  cursorStyle: {},
  separator: ' : ',
  wrapperStyle: {},
  contentStyle: {},
  itemStyle: {},
  labelStyle: {},
  cursor: true,
  isAnimationActive: !Object(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["o" /* isSsr */])(),
  animationEasing: 'ease',
  animationDuration: 400,
  filterNull: true,
  useTranslate3d: false
};

var renderContent = function renderContent(content, props) {
  if (__WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(content)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(content, props);
  }

  if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(content)) {
    return content(props);
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__DefaultTooltipContent__["a" /* default */], props);
};

var Tooltip =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Tooltip, _PureComponent);

  function Tooltip() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Tooltip)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      boxWidth: -1,
      boxHeight: -1
    };

    _this.getTranslate = function (_ref) {
      var key = _ref.key,
          tooltipDimension = _ref.tooltipDimension,
          viewBoxDimension = _ref.viewBoxDimension;
      var _this$props = _this.props,
          allowEscapeViewBox = _this$props.allowEscapeViewBox,
          coordinate = _this$props.coordinate,
          offset = _this$props.offset,
          position = _this$props.position,
          viewBox = _this$props.viewBox;

      if (position && Object(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["h" /* isNumber */])(position[key])) {
        return position[key];
      }

      var restricted = coordinate[key] - tooltipDimension - offset;
      var unrestricted = coordinate[key] + offset;

      if (allowEscapeViewBox[key]) {
        return unrestricted;
      }

      var tooltipBoundary = coordinate[key] + tooltipDimension + offset;
      var viewBoxBoundary = viewBox[key] + viewBoxDimension;

      if (tooltipBoundary > viewBoxBoundary) {
        return Math.max(restricted, viewBox[key]);
      }

      return Math.max(unrestricted, viewBox[key]);
    };

    return _this;
  }

  _createClass(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateBBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateBBox();
    }
  }, {
    key: "updateBBox",
    value: function updateBBox() {
      var _this$state = this.state,
          boxWidth = _this$state.boxWidth,
          boxHeight = _this$state.boxHeight;

      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var box = this.wrapperNode.getBoundingClientRect();

        if (Math.abs(box.width - boxWidth) > EPS || Math.abs(box.height - boxHeight) > EPS) {
          this.setState({
            boxWidth: box.width,
            boxHeight: box.height
          });
        }
      } else if (boxWidth !== -1 || boxHeight !== -1) {
        this.setState({
          boxWidth: -1,
          boxHeight: -1
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this2 = this;

      var _this$props2 = this.props,
          payload = _this$props2.payload,
          isAnimationActive = _this$props2.isAnimationActive,
          animationDuration = _this$props2.animationDuration,
          animationEasing = _this$props2.animationEasing,
          filterNull = _this$props2.filterNull,
          paylodUniqBy = _this$props2.paylodUniqBy;
      var finalPayload = getUniqPaylod(paylodUniqBy, filterNull && payload && payload.length ? payload.filter(function (entry) {
        return !__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(entry.value);
      }) : payload);
      var hasPayload = finalPayload && finalPayload.length;
      var _this$props3 = this.props,
          content = _this$props3.content,
          viewBox = _this$props3.viewBox,
          coordinate = _this$props3.coordinate,
          position = _this$props3.position,
          active = _this$props3.active,
          wrapperStyle = _this$props3.wrapperStyle;

      var outerStyle = _objectSpread({
        pointerEvents: 'none',
        visibility: active && hasPayload ? 'visible' : 'hidden',
        position: 'absolute',
        top: 0
      }, wrapperStyle);

      var translateX, translateY;

      if (position && Object(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["h" /* isNumber */])(position.x) && Object(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["h" /* isNumber */])(position.y)) {
        translateX = position.x;
        translateY = position.y;
      } else {
        var _this$state2 = this.state,
            boxWidth = _this$state2.boxWidth,
            boxHeight = _this$state2.boxHeight;

        if (boxWidth > 0 && boxHeight > 0 && coordinate) {
          translateX = this.getTranslate({
            key: 'x',
            tooltipDimension: boxWidth,
            viewBoxDimension: viewBox.width
          });
          translateY = this.getTranslate({
            key: 'y',
            tooltipDimension: boxHeight,
            viewBoxDimension: viewBox.height
          });
        } else {
          outerStyle.visibility = 'hidden';
        }
      }

      outerStyle = _objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_5_react_smooth__["b" /* translateStyle */])({
        transform: this.props.useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
      }), {}, outerStyle);

      if (isAnimationActive && active) {
        outerStyle = _objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_5_react_smooth__["b" /* translateStyle */])({
          transition: "transform ".concat(animationDuration, "ms ").concat(animationEasing)
        }), {}, outerStyle);
      }

      var cls = __WEBPACK_IMPORTED_MODULE_6_classnames___default()(CLS_PREFIX, (_classNames = {}, _defineProperty(_classNames, "".concat(CLS_PREFIX, "-right"), Object(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["h" /* isNumber */])(translateX) && coordinate && Object(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["h" /* isNumber */])(coordinate.x) && translateX >= coordinate.x), _defineProperty(_classNames, "".concat(CLS_PREFIX, "-left"), Object(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["h" /* isNumber */])(translateX) && coordinate && Object(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["h" /* isNumber */])(coordinate.x) && translateX < coordinate.x), _defineProperty(_classNames, "".concat(CLS_PREFIX, "-bottom"), Object(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["h" /* isNumber */])(translateY) && coordinate && Object(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["h" /* isNumber */])(coordinate.y) && translateY >= coordinate.y), _defineProperty(_classNames, "".concat(CLS_PREFIX, "-top"), Object(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["h" /* isNumber */])(translateY) && coordinate && Object(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["h" /* isNumber */])(coordinate.y) && translateY < coordinate.y), _classNames));
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
        className: cls,
        style: outerStyle,
        ref: function ref(node) {
          _this2.wrapperNode = node;
        }
      }, renderContent(content, _objectSpread({}, this.props, {
        payload: finalPayload
      })));
    }
  }]);

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_3_react__["PureComponent"]);

Tooltip.displayName = 'Tooltip';
Tooltip.propTypes = propTypes;
Tooltip.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Tooltip);

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getIntersectionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return identity; });
/* unused harmony export getDashCase */
/* unused harmony export generatePrefixStyle */
/* unused harmony export log */
/* unused harmony export debug */
/* unused harmony export debugf */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mapObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return translateStyle; });
/* unused harmony export compose */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getTransitionVal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return warn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_intersection__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_intersection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_intersection__);


function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint no-console: 0 */
var PREFIX_LIST = ['Webkit', 'Moz', 'O', 'ms'];
var IN_LINE_PREFIX_LIST = ['-webkit-', '-moz-', '-o-', '-ms-'];
var IN_COMPATIBLE_PROPERTY = ['transform', 'transformOrigin', 'transition'];
var getIntersectionKeys = function getIntersectionKeys(preObj, nextObj) {
  return __WEBPACK_IMPORTED_MODULE_0_lodash_intersection___default()(Object.keys(preObj), Object.keys(nextObj));
};
var identity = function identity(param) {
  return param;
};
/*
 * @description: convert camel case to dash case
 * string => string
 */

var getDashCase = function getDashCase(name) {
  return name.replace(/([A-Z])/g, function (v) {
    return "-".concat(v.toLowerCase());
  });
};
/*
 * @description: add compatible style prefix
 * (string, string) => object
 */

var generatePrefixStyle = function generatePrefixStyle(name, value) {
  if (IN_COMPATIBLE_PROPERTY.indexOf(name) === -1) {
    return _defineProperty({}, name, value);
  }

  var isTransition = name === 'transition';
  var camelName = name.replace(/(\w)/, function (v) {
    return v.toUpperCase();
  });
  var styleVal = value;
  return PREFIX_LIST.reduce(function (result, property, i) {
    if (isTransition) {
      styleVal = value.replace(/(transform|transform-origin)/gim, "".concat(IN_LINE_PREFIX_LIST[i], "$1"));
    }

    return _objectSpread({}, result, _defineProperty({}, property + camelName, styleVal));
  }, {});
};
var log = function log() {
  var _console;

  (_console = console).log.apply(_console, arguments);
};
/*
 * @description: log the value of a varible
 * string => any => any
 */

var debug = function debug(name) {
  return function (item) {
    log(name, item);
    return item;
  };
};
/*
 * @description: log name, args, return value of a function
 * function => function
 */

var debugf = function debugf(tag, f) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var res = f.apply(void 0, args);
    var name = tag || f.name || 'anonymous function';
    var argNames = "(".concat(args.map(JSON.stringify).join(', '), ")");
    log("".concat(name, ": ").concat(argNames, " => ").concat(JSON.stringify(res)));
    return res;
  };
};
/*
 * @description: map object on every element in this object.
 * (function, object) => object
 */

var mapObject = function mapObject(fn, obj) {
  return Object.keys(obj).reduce(function (res, key) {
    return _objectSpread({}, res, _defineProperty({}, key, fn(key, obj[key])));
  }, {});
};
/*
 * @description: add compatible prefix to style
 * object => object
 */

var translateStyle = function translateStyle(style) {
  return Object.keys(style).reduce(function (res, key) {
    return _objectSpread({}, res, generatePrefixStyle(key, res[key]));
  }, style);
};
var compose = function compose() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (!args.length) {
    return identity;
  }

  var fns = args.reverse(); // first function can receive multiply arguments

  var firstFn = fns[0];
  var tailsFn = fns.slice(1);
  return function () {
    return tailsFn.reduce(function (res, fn) {
      return fn(res);
    }, firstFn.apply(void 0, arguments));
  };
};
var getTransitionVal = function getTransitionVal(props, duration, easing) {
  return props.map(function (prop) {
    return "".concat(getDashCase(prop), " ").concat(duration, "ms ").concat(easing);
  }).join(',');
};
var isDev = "production" !== 'production';
var warn = function warn(condition, format, a, b, c, d, e, f) {
  if (isDev && typeof console !== 'undefined' && console.warn) {
    if (format === undefined) {
      console.warn('LogUtils requires an error message argument');
    }

    if (!condition) {
      if (format === undefined) {
        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
      } else {
        var args = [a, b, c, d, e, f];
        var argIndex = 0;
        console.warn(format.replace(/%s/g, function () {
          return args[argIndex++];
        }));
      }
    }
  }
};

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getStyleString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getStringSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getOffset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculateChartCoordinate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReactUtils__ = __webpack_require__(12);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }


var stringCache = {
  widthCache: {},
  cacheCount: 0
};
var MAX_CACHE_NUM = 2000;
var SPAN_STYLE = {
  position: 'absolute',
  top: '-20000px',
  left: 0,
  padding: 0,
  margin: 0,
  border: 'none',
  whiteSpace: 'pre'
};
var STYLE_LIST = ['minWidth', 'maxWidth', 'width', 'minHeight', 'maxHeight', 'height', 'top', 'left', 'fontSize', 'lineHeight', 'padding', 'margin', 'paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom', 'marginLeft', 'marginRight', 'marginTop', 'marginBottom'];
var MEASUREMENT_SPAN_ID = 'recharts_measurement_span';

function autoCompleteStyle(name, value) {
  if (STYLE_LIST.indexOf(name) >= 0 && value === +value) {
    return "".concat(value, "px");
  }

  return value;
}

function camelToMiddleLine(text) {
  var strs = text.split('');
  var formatStrs = strs.reduce(function (result, entry) {
    if (entry === entry.toUpperCase()) {
      return [].concat(_toConsumableArray(result), ['-', entry.toLowerCase()]);
    }

    return [].concat(_toConsumableArray(result), [entry]);
  }, []);
  return formatStrs.join('');
}

var getStyleString = function getStyleString(style) {
  return Object.keys(style).reduce(function (result, s) {
    return "".concat(result).concat(camelToMiddleLine(s), ":").concat(autoCompleteStyle(s, style[s]), ";");
  }, '');
};
var getStringSize = function getStringSize(text) {
  var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (text === undefined || text === null || Object(__WEBPACK_IMPORTED_MODULE_0__ReactUtils__["o" /* isSsr */])()) {
    return {
      width: 0,
      height: 0
    };
  }

  var str = "".concat(text);
  var styleString = getStyleString(style);
  var cacheKey = "".concat(str, "-").concat(styleString);

  if (stringCache.widthCache[cacheKey]) {
    return stringCache.widthCache[cacheKey];
  }

  try {
    var measurementSpan = document.getElementById(MEASUREMENT_SPAN_ID);

    if (!measurementSpan) {
      measurementSpan = document.createElement('span');
      measurementSpan.setAttribute('id', MEASUREMENT_SPAN_ID);
      document.body.appendChild(measurementSpan);
    } // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
    // https://en.wikipedia.org/wiki/Content_Security_Policy


    var measurementSpanStyle = _objectSpread({}, SPAN_STYLE, {}, style);

    Object.keys(measurementSpanStyle).map(function (styleKey) {
      measurementSpan.style[styleKey] = measurementSpanStyle[styleKey];
      return styleKey;
    });
    measurementSpan.textContent = str;
    var rect = measurementSpan.getBoundingClientRect();
    var result = {
      width: rect.width,
      height: rect.height
    };
    stringCache.widthCache[cacheKey] = result;

    if (++stringCache.cacheCount > MAX_CACHE_NUM) {
      stringCache.cacheCount = 0;
      stringCache.widthCache = {};
    }

    return result;
  } catch (e) {
    return {
      width: 0,
      height: 0
    };
  }
};
var getOffset = function getOffset(el) {
  var html = el.ownerDocument.documentElement;
  var box = {
    top: 0,
    left: 0
  }; // If we don't have gBCR, just use 0,0 rather than error
  // BlackBerry 5, iOS 3 (original iPhone)

  if (typeof el.getBoundingClientRect !== 'undefined') {
    box = el.getBoundingClientRect();
  }

  return {
    top: box.top + window.pageYOffset - html.clientTop,
    left: box.left + window.pageXOffset - html.clientLeft
  };
};
/**
 * Calculate coordinate of cursor in chart
 * @param  {Object} event  Event object
 * @param  {Object} offset The offset of main part in the svg element
 * @return {Object}        {chartX, chartY}
 */

var calculateChartCoordinate = function calculateChartCoordinate(event, offset) {
  return {
    chartX: Math.round(event.pageX - offset.left),
    chartY: Math.round(event.pageY - offset.top)
  };
};

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(170);

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */
function baseExtremum(array, iteratee, comparator) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    var value = array[index],
        current = iteratee(value);

    if (current != null && (computed === undefined
          ? (current === current && !isSymbol(current))
          : comparator(current, computed)
        )) {
      var computed = current,
          result = value;
    }
  }
  return result;
}

module.exports = baseExtremum;


/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return a + b * t;
  };
});


/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__ = __webpack_require__(407);


/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__["a" /* default */])(Math.abs(x)), x ? x[1] : NaN;
});


/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_PolarUtils__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_DataUtils__ = __webpack_require__(23);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Sector
 */







var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
  var sign = Object(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["j" /* mathSign */])(endAngle - startAngle);
  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
  return sign * deltaAngle;
};

var getTangentCircle = function getTangentCircle(_ref) {
  var cx = _ref.cx,
      cy = _ref.cy,
      radius = _ref.radius,
      angle = _ref.angle,
      sign = _ref.sign,
      isExternal = _ref.isExternal,
      cornerRadius = _ref.cornerRadius,
      cornerIsExternal = _ref.cornerIsExternal;
  var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
  var theta = Math.asin(cornerRadius / centerRadius) / __WEBPACK_IMPORTED_MODULE_4__util_PolarUtils__["a" /* RADIAN */];
  var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
  var center = Object(__WEBPACK_IMPORTED_MODULE_4__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, centerRadius, centerAngle); // The coordinate of point which is tangent to the circle

  var circleTangency = Object(__WEBPACK_IMPORTED_MODULE_4__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, radius, centerAngle); // The coordinate of point which is tangent to the radius line

  var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
  var lineTangency = Object(__WEBPACK_IMPORTED_MODULE_4__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, centerRadius * Math.cos(theta * __WEBPACK_IMPORTED_MODULE_4__util_PolarUtils__["a" /* RADIAN */]), lineTangencyAngle);
  return {
    center: center,
    circleTangency: circleTangency,
    lineTangency: lineTangency,
    theta: theta
  };
};

var getSectorPath = function getSectorPath(_ref2) {
  var cx = _ref2.cx,
      cy = _ref2.cy,
      innerRadius = _ref2.innerRadius,
      outerRadius = _ref2.outerRadius,
      startAngle = _ref2.startAngle,
      endAngle = _ref2.endAngle;
  var angle = getDeltaAngle(startAngle, endAngle); // When the angle of sector equals to 360, star point and end point coincide

  var tempEndAngle = startAngle + angle;
  var outerStartPoint = Object(__WEBPACK_IMPORTED_MODULE_4__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, outerRadius, startAngle);
  var outerEndPoint = Object(__WEBPACK_IMPORTED_MODULE_4__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, outerRadius, tempEndAngle);
  var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");

  if (innerRadius > 0) {
    var innerStartPoint = Object(__WEBPACK_IMPORTED_MODULE_4__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, innerRadius, startAngle);
    var innerEndPoint = Object(__WEBPACK_IMPORTED_MODULE_4__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, innerRadius, tempEndAngle);
    path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
  } else {
    path += "L ".concat(cx, ",").concat(cy, " Z");
  }

  return path;
};

var getSectorWithCorner = function getSectorWithCorner(_ref3) {
  var cx = _ref3.cx,
      cy = _ref3.cy,
      innerRadius = _ref3.innerRadius,
      outerRadius = _ref3.outerRadius,
      cornerRadius = _ref3.cornerRadius,
      forceCornerRadius = _ref3.forceCornerRadius,
      cornerIsExternal = _ref3.cornerIsExternal,
      startAngle = _ref3.startAngle,
      endAngle = _ref3.endAngle;
  var sign = Object(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["j" /* mathSign */])(endAngle - startAngle);

  var _getTangentCircle = getTangentCircle({
    cx: cx,
    cy: cy,
    radius: outerRadius,
    angle: startAngle,
    sign: sign,
    cornerRadius: cornerRadius,
    cornerIsExternal: cornerIsExternal
  }),
      soct = _getTangentCircle.circleTangency,
      solt = _getTangentCircle.lineTangency,
      sot = _getTangentCircle.theta;

  var _getTangentCircle2 = getTangentCircle({
    cx: cx,
    cy: cy,
    radius: outerRadius,
    angle: endAngle,
    sign: -sign,
    cornerRadius: cornerRadius,
    cornerIsExternal: cornerIsExternal
  }),
      eoct = _getTangentCircle2.circleTangency,
      eolt = _getTangentCircle2.lineTangency,
      eot = _getTangentCircle2.theta;

  var outerArcAngle = Math.abs(startAngle - endAngle) - sot - eot;

  if (outerArcAngle < 0) {
    if (forceCornerRadius) {
      return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
    }

    return getSectorPath({
      cx: cx,
      cy: cy,
      innerRadius: innerRadius,
      outerRadius: outerRadius,
      startAngle: startAngle,
      endAngle: endAngle
    });
  }

  var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");

  if (innerRadius > 0) {
    var _getTangentCircle3 = getTangentCircle({
      cx: cx,
      cy: cy,
      radius: innerRadius,
      angle: startAngle,
      sign: sign,
      isExternal: true,
      cornerRadius: cornerRadius,
      cornerIsExternal: cornerIsExternal
    }),
        sict = _getTangentCircle3.circleTangency,
        silt = _getTangentCircle3.lineTangency,
        sit = _getTangentCircle3.theta;

    var _getTangentCircle4 = getTangentCircle({
      cx: cx,
      cy: cy,
      radius: innerRadius,
      angle: endAngle,
      sign: -sign,
      isExternal: true,
      cornerRadius: cornerRadius,
      cornerIsExternal: cornerIsExternal
    }),
        eict = _getTangentCircle4.circleTangency,
        eilt = _getTangentCircle4.lineTangency,
        eit = _getTangentCircle4.theta;

    var innerArcAngle = Math.abs(startAngle - endAngle) - sit - eit;

    if (innerArcAngle < 0) {
      return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
    }

    path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
  } else {
    path += "L".concat(cx, ",").concat(cy, "Z");
  }

  return path;
};

var Sector =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Sector, _PureComponent);

  function Sector() {
    _classCallCheck(this, Sector);

    return _possibleConstructorReturn(this, _getPrototypeOf(Sector).apply(this, arguments));
  }

  _createClass(Sector, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          cx = _this$props.cx,
          cy = _this$props.cy,
          innerRadius = _this$props.innerRadius,
          outerRadius = _this$props.outerRadius,
          cornerRadius = _this$props.cornerRadius,
          forceCornerRadius = _this$props.forceCornerRadius,
          cornerIsExternal = _this$props.cornerIsExternal,
          startAngle = _this$props.startAngle,
          endAngle = _this$props.endAngle,
          className = _this$props.className;

      if (outerRadius < innerRadius || startAngle === endAngle) {
        return null;
      }

      var layerClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('recharts-sector', className);
      var deltaRadius = outerRadius - innerRadius;
      var cr = Object(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["d" /* getPercentValue */])(cornerRadius, deltaRadius, 0, true);
      var path;

      if (cr > 0 && Math.abs(startAngle - endAngle) < 360) {
        path = getSectorWithCorner({
          cx: cx,
          cy: cy,
          innerRadius: innerRadius,
          outerRadius: outerRadius,
          cornerRadius: Math.min(cr, deltaRadius / 2),
          forceCornerRadius: forceCornerRadius,
          cornerIsExternal: cornerIsExternal,
          startAngle: startAngle,
          endAngle: endAngle
        });
      } else {
        path = getSectorPath({
          cx: cx,
          cy: cy,
          innerRadius: innerRadius,
          outerRadius: outerRadius,
          startAngle: startAngle,
          endAngle: endAngle
        });
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", _extends({}, Object(__WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["l" /* getPresentationAttributes */])(this.props), Object(__WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["f" /* filterEventAttributes */])(this.props), {
        className: layerClass,
        d: path
      }));
    }
  }]);

  return Sector;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Sector.displayName = 'Sector';
Sector.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cx: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  cy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  innerRadius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  outerRadius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  startAngle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  endAngle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  cornerRadius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  forceCornerRadius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cornerIsExternal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
});
Sector.defaultProps = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0,
  forceCornerRadius: false,
  cornerIsExternal: false
};
/* harmony default export */ __webpack_exports__["a"] = (Sector);

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__ = __webpack_require__(12);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Polygon
 */





var getPolygonPoints = function getPolygonPoints(points) {
  return points.reduce(function (result, entry) {
    if (entry.x === +entry.x && entry.y === +entry.y) {
      result.push([entry.x, entry.y]);
    }

    return result;
  }, []).join(' ');
};

var Polygon =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Polygon, _PureComponent);

  function Polygon() {
    _classCallCheck(this, Polygon);

    return _possibleConstructorReturn(this, _getPrototypeOf(Polygon).apply(this, arguments));
  }

  _createClass(Polygon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          points = _this$props.points,
          className = _this$props.className;

      if (!points || !points.length) {
        return null;
      }

      var layerClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('recharts-polygon', className);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon", _extends({}, Object(__WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["l" /* getPresentationAttributes */])(this.props), Object(__WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["f" /* filterEventAttributes */])(this.props), {
        className: layerClass,
        points: getPolygonPoints(points)
      }));
    }
  }]);

  return Polygon;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Polygon.displayName = 'Polygon';
Polygon.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  points: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }))
});
/* harmony default export */ __webpack_exports__["a"] = (Polygon);

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_minBy__ = __webpack_require__(1683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_minBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_minBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_maxBy__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_maxBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component_Text__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component_Label__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__container_Layer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_PolarUtils__ = __webpack_require__(82);




function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview The axis of polar coordinate system
 */








var PolarRadiusAxis =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(PolarRadiusAxis, _PureComponent);

  function PolarRadiusAxis() {
    _classCallCheck(this, PolarRadiusAxis);

    return _possibleConstructorReturn(this, _getPrototypeOf(PolarRadiusAxis).apply(this, arguments));
  }

  _createClass(PolarRadiusAxis, [{
    key: "getTickValueCoord",

    /**
     * Calculate the coordinate of tick
     * @param  {Number} coordinate The radius of tick
     * @return {Object} (x, y)
     */
    value: function getTickValueCoord(_ref) {
      var coordinate = _ref.coordinate;
      var _this$props = this.props,
          angle = _this$props.angle,
          cx = _this$props.cx,
          cy = _this$props.cy;
      return Object(__WEBPACK_IMPORTED_MODULE_9__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, coordinate, angle);
    }
  }, {
    key: "getTickTextAnchor",
    value: function getTickTextAnchor() {
      var orientation = this.props.orientation;
      var textAnchor;

      switch (orientation) {
        case 'left':
          textAnchor = 'end';
          break;

        case 'right':
          textAnchor = 'start';
          break;

        default:
          textAnchor = 'middle';
          break;
      }

      return textAnchor;
    }
  }, {
    key: "getViewBox",
    value: function getViewBox() {
      var _this$props2 = this.props,
          cx = _this$props2.cx,
          cy = _this$props2.cy,
          angle = _this$props2.angle,
          ticks = _this$props2.ticks;

      var maxRadiusTick = __WEBPACK_IMPORTED_MODULE_2_lodash_maxBy___default()(ticks, function (entry) {
        return entry.coordinate || 0;
      });

      var minRadiusTick = __WEBPACK_IMPORTED_MODULE_1_lodash_minBy___default()(ticks, function (entry) {
        return entry.coordinate || 0;
      });

      return {
        cx: cx,
        cy: cy,
        startAngle: angle,
        endAngle: angle,
        innerRadius: minRadiusTick.coordinate || 0,
        outerRadius: maxRadiusTick.coordinate || 0
      };
    }
  }, {
    key: "renderAxisLine",
    value: function renderAxisLine() {
      var _this$props3 = this.props,
          cx = _this$props3.cx,
          cy = _this$props3.cy,
          angle = _this$props3.angle,
          ticks = _this$props3.ticks,
          axisLine = _this$props3.axisLine,
          others = _objectWithoutProperties(_this$props3, ["cx", "cy", "angle", "ticks", "axisLine"]);

      var extent = ticks.reduce(function (result, entry) {
        return [Math.min(result[0], entry.coordinate), Math.max(result[1], entry.coordinate)];
      }, [Infinity, -Infinity]);
      var point0 = Object(__WEBPACK_IMPORTED_MODULE_9__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, extent[0], angle);
      var point1 = Object(__WEBPACK_IMPORTED_MODULE_9__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, extent[1], angle);

      var props = _objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["l" /* getPresentationAttributes */])(others), {
        fill: 'none'
      }, Object(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["l" /* getPresentationAttributes */])(axisLine), {
        x1: point0.x,
        y1: point0.y,
        x2: point1.x,
        y2: point1.y
      });

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("line", _extends({
        className: "recharts-polar-radius-axis-line"
      }, props));
    }
  }, {
    key: "renderTicks",
    value: function renderTicks() {
      var _this = this;

      var _this$props4 = this.props,
          ticks = _this$props4.ticks,
          tick = _this$props4.tick,
          angle = _this$props4.angle,
          tickFormatter = _this$props4.tickFormatter,
          stroke = _this$props4.stroke,
          others = _objectWithoutProperties(_this$props4, ["ticks", "tick", "angle", "tickFormatter", "stroke"]);

      var textAnchor = this.getTickTextAnchor();
      var axisProps = Object(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["l" /* getPresentationAttributes */])(others);
      var customTickProps = Object(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["l" /* getPresentationAttributes */])(tick);
      var items = ticks.map(function (entry, i) {
        var coord = _this.getTickValueCoord(entry);

        var tickProps = _objectSpread({
          textAnchor: textAnchor,
          transform: "rotate(".concat(90 - angle, ", ").concat(coord.x, ", ").concat(coord.y, ")")
        }, axisProps, {
          stroke: 'none',
          fill: stroke
        }, customTickProps, {
          index: i
        }, coord, {
          payload: entry
        });

        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__container_Layer__["a" /* default */], _extends({
          className: "recharts-polar-radius-axis-tick",
          key: "tick-".concat(i) // eslint-disable-line react/no-array-index-key

        }, Object(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["g" /* filterEventsOfChild */])(_this.props, entry, i)), _this.constructor.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value) : entry.value));
      });
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__container_Layer__["a" /* default */], {
        className: "recharts-polar-radius-axis-ticks"
      }, items);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          ticks = _this$props5.ticks,
          axisLine = _this$props5.axisLine,
          tick = _this$props5.tick;

      if (!ticks || !ticks.length) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__container_Layer__["a" /* default */], {
        className: "recharts-polar-radius-axis"
      }, axisLine && this.renderAxisLine(), tick && this.renderTicks(), __WEBPACK_IMPORTED_MODULE_6__component_Label__["a" /* default */].renderCallByParent(this.props, this.getViewBox()));
    }
  }], [{
    key: "renderTickItem",
    value: function renderTickItem(option, props, value) {
      var tickItem;

      if (__WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(option)) {
        tickItem = __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        tickItem = option(props);
      } else {
        tickItem = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__component_Text__["a" /* default */], _extends({}, props, {
          className: "recharts-polar-radius-axis-tick-value"
        }), value);
      }

      return tickItem;
    }
  }]);

  return PolarRadiusAxis;
}(__WEBPACK_IMPORTED_MODULE_3_react__["PureComponent"]);

PolarRadiusAxis.displayName = 'PolarRadiusAxis';
PolarRadiusAxis.axisType = 'radiusAxis';
PolarRadiusAxis.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {}, __WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["a" /* EVENT_ATTRIBUTES */], {
  type: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['number', 'category']),
  cx: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  cy: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  hide: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  radiusAxisId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  angle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  tickCount: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  ticks: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
    coordinate: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number
  })),
  orientation: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['left', 'right', 'middle']),
  axisLine: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object]),
  tick: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]),
  stroke: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  tickFormatter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  domain: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['auto', 'dataMin', 'dataMax'])])),
  scale: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utc', 'sequential', 'threshold']), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]),
  allowDataOverflow: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  allowDuplicatedCategory: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
});
PolarRadiusAxis.defaultProps = {
  type: 'number',
  radiusAxisId: 0,
  cx: 0,
  cy: 0,
  angle: 0,
  orientation: 'right',
  stroke: '#ccc',
  axisLine: true,
  tick: true,
  tickCount: 5,
  domain: [0, 'auto'],
  allowDataOverflow: false,
  scale: 'auto',
  allowDuplicatedCategory: true
};
/* harmony default export */ __webpack_exports__["a"] = (PolarRadiusAxis);

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__container_Layer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shape_Dot__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shape_Polygon__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component_Text__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_PolarUtils__ = __webpack_require__(82);


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Axis of radial direction
 */








var RADIAN = Math.PI / 180;
var eps = 1e-5;

var PolarAngleAxis =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(PolarAngleAxis, _PureComponent);

  function PolarAngleAxis() {
    _classCallCheck(this, PolarAngleAxis);

    return _possibleConstructorReturn(this, _getPrototypeOf(PolarAngleAxis).apply(this, arguments));
  }

  _createClass(PolarAngleAxis, [{
    key: "getTickLineCoord",

    /**
     * Calculate the coordinate of line endpoint
     * @param  {Object} data The Data if ticks
     * @return {Object} (x0, y0): The start point of text,
     *                  (x1, y1): The end point close to text,
     *                  (x2, y2): The end point close to axis
     */
    value: function getTickLineCoord(data) {
      var _this$props = this.props,
          cx = _this$props.cx,
          cy = _this$props.cy,
          radius = _this$props.radius,
          orientation = _this$props.orientation,
          tickLine = _this$props.tickLine;
      var tickLineSize = tickLine && tickLine.size || 8;
      var p1 = Object(__WEBPACK_IMPORTED_MODULE_8__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, radius, data.coordinate);
      var p2 = Object(__WEBPACK_IMPORTED_MODULE_8__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, radius + (orientation === 'inner' ? -1 : 1) * tickLineSize, data.coordinate);
      return {
        x1: p1.x,
        y1: p1.y,
        x2: p2.x,
        y2: p2.y
      };
    }
    /**
     * Get the text-anchor of each tick
     * @param  {Object} data Data of ticks
     * @return {String} text-anchor
     */

  }, {
    key: "getTickTextAnchor",
    value: function getTickTextAnchor(data) {
      var orientation = this.props.orientation;
      var cos = Math.cos(-data.coordinate * RADIAN);
      var textAnchor;

      if (cos > eps) {
        textAnchor = orientation === 'outer' ? 'start' : 'end';
      } else if (cos < -eps) {
        textAnchor = orientation === 'outer' ? 'end' : 'start';
      } else {
        textAnchor = 'middle';
      }

      return textAnchor;
    }
  }, {
    key: "renderAxisLine",
    value: function renderAxisLine() {
      var _this$props2 = this.props,
          cx = _this$props2.cx,
          cy = _this$props2.cy,
          radius = _this$props2.radius,
          axisLine = _this$props2.axisLine,
          axisLineType = _this$props2.axisLineType;

      var props = _objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["l" /* getPresentationAttributes */])(this.props), {
        fill: 'none'
      }, Object(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["l" /* getPresentationAttributes */])(axisLine));

      if (axisLineType === 'circle') {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shape_Dot__["a" /* default */], _extends({
          className: "recharts-polar-angle-axis-line"
        }, props, {
          cx: cx,
          cy: cy,
          r: radius
        }));
      }

      var ticks = this.props.ticks;
      var points = ticks.map(function (entry) {
        return Object(__WEBPACK_IMPORTED_MODULE_8__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, radius, entry.coordinate);
      });
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shape_Polygon__["a" /* default */], _extends({
        className: "recharts-polar-angle-axis-line"
      }, props, {
        points: points
      }));
    }
  }, {
    key: "renderTicks",
    value: function renderTicks() {
      var _this = this;

      var _this$props3 = this.props,
          ticks = _this$props3.ticks,
          tick = _this$props3.tick,
          tickLine = _this$props3.tickLine,
          tickFormatter = _this$props3.tickFormatter,
          stroke = _this$props3.stroke;
      var axisProps = Object(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["l" /* getPresentationAttributes */])(this.props);
      var customTickProps = Object(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["l" /* getPresentationAttributes */])(tick);

      var tickLineProps = _objectSpread({}, axisProps, {
        fill: 'none'
      }, Object(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["l" /* getPresentationAttributes */])(tickLine));

      var items = ticks.map(function (entry, i) {
        var lineCoord = _this.getTickLineCoord(entry);

        var textAnchor = _this.getTickTextAnchor(entry);

        var tickProps = _objectSpread({
          textAnchor: textAnchor
        }, axisProps, {
          stroke: 'none',
          fill: stroke
        }, customTickProps, {
          index: i,
          payload: entry,
          x: lineCoord.x2,
          y: lineCoord.y2
        });

        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__container_Layer__["a" /* default */], _extends({
          className: "recharts-polar-angle-axis-tick",
          key: "tick-".concat(i) // eslint-disable-line react/no-array-index-key

        }, Object(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["g" /* filterEventsOfChild */])(_this.props, entry, i)), tickLine && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line", _extends({
          className: "recharts-polar-angle-axis-tick-line"
        }, tickLineProps, lineCoord)), tick && _this.constructor.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value) : entry.value));
      });
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__container_Layer__["a" /* default */], {
        className: "recharts-polar-angle-axis-ticks"
      }, items);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          ticks = _this$props4.ticks,
          radius = _this$props4.radius,
          axisLine = _this$props4.axisLine;

      if (radius <= 0 || !ticks || !ticks.length) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__container_Layer__["a" /* default */], {
        className: "recharts-polar-angle-axis"
      }, axisLine && this.renderAxisLine(), this.renderTicks());
    }
  }], [{
    key: "renderTickItem",
    value: function renderTickItem(option, props, value) {
      var tickItem;

      if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(option)) {
        tickItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        tickItem = option(props);
      } else {
        tickItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__component_Text__["a" /* default */], _extends({}, props, {
          className: "recharts-polar-angle-axis-tick-value"
        }), value);
      }

      return tickItem;
    }
  }]);

  return PolarAngleAxis;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

PolarAngleAxis.displayName = 'PolarAngleAxis';
PolarAngleAxis.axisType = 'angleAxis';
PolarAngleAxis.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {}, __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["a" /* EVENT_ATTRIBUTES */], {
  type: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['number', 'category']),
  angleAxisId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  dataKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func]),
  cx: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  cy: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  radius: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  hide: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  scale: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["d" /* SCALE_TYPES */]), __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func]),
  axisLine: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object]),
  axisLineType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['polygon', 'circle']),
  tickLine: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object]),
  tick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element]),
  ticks: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
    coordinate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
  })),
  stroke: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  orientation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['inner', 'outer']),
  tickFormatter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  allowDuplicatedCategory: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
});
PolarAngleAxis.defaultProps = {
  type: 'category',
  angleAxisId: 0,
  scale: 'auto',
  cx: 0,
  cy: 0,
  domain: [0, 'auto'],
  orientation: 'outer',
  axisLine: true,
  tickLine: true,
  tick: true,
  hide: false,
  allowDuplicatedCategory: true
};
/* harmony default export */ __webpack_exports__["a"] = (PolarAngleAxis);

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ifOverflowMatches; });
var ifOverflowMatches = function ifOverflowMatches(props, value) {
  var alwaysShow = props.alwaysShow;
  var ifOverflow = props.ifOverflow;

  if (alwaysShow) {
    ifOverflow = 'extendDomain';
  }

  return ifOverflow === value;
};

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Z Axis
 */



var ZAxis =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ZAxis, _PureComponent);

  function ZAxis() {
    _classCallCheck(this, ZAxis);

    return _possibleConstructorReturn(this, _getPrototypeOf(ZAxis).apply(this, arguments));
  }

  _createClass(ZAxis, [{
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return ZAxis;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

ZAxis.displayName = 'ZAxis';
ZAxis.propTypes = {
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['number', 'category']),
  // The name of data displayed in the axis
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  // The unit of data displayed in the axis
  unit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  // The unique id of z-axis
  zAxisId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  // The key of data displayed in the axis
  dataKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  // The range of axis
  range: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number),
  scale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utc', 'sequential', 'threshold']), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
ZAxis.defaultProps = {
  zAxisId: 0,
  range: [64, 64],
  scale: 'auto',
  type: 'number'
};
/* harmony default export */ __webpack_exports__["a"] = (ZAxis);

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addEventListenerWrap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__ = __webpack_require__(1742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);



function addEventListenerWrap(target, eventType, cb, option) {
  /* eslint camelcase: 2 */
  var callback = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates ? function run(e) {
    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates(cb, e);
  } : cb;
  return __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default()(target, eventType, callback, option);
}

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDay = formatDay;
exports.formatMonthTitle = formatMonthTitle;
exports.formatWeekdayShort = formatWeekdayShort;
exports.formatWeekdayLong = formatWeekdayLong;
exports.getFirstDayOfWeek = getFirstDayOfWeek;
exports.getMonths = getMonths;
var WEEKDAYS_LONG = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

var WEEKDAYS_SHORT = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

function formatDay(day) {
  return day.toDateString();
}

function formatMonthTitle(d) {
  return MONTHS[d.getMonth()] + ' ' + d.getFullYear();
}

function formatWeekdayShort(i) {
  return WEEKDAYS_SHORT[i];
}

function formatWeekdayLong(i) {
  return WEEKDAYS_LONG[i];
}

function getFirstDayOfWeek() {
  return 0;
}

function getMonths() {
  return MONTHS;
}

exports.default = {
  formatDay: formatDay,
  formatMonthTitle: formatMonthTitle,
  formatWeekdayShort: formatWeekdayShort,
  formatWeekdayLong: formatWeekdayLong,
  getFirstDayOfWeek: getFirstDayOfWeek,
  getMonths: getMonths
};
//# sourceMappingURL=LocaleUtils.js.map

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Proxy object to map classnames when css modules are not used

exports.default = {
  container: 'DayPicker',
  wrapper: 'DayPicker-wrapper',
  interactionDisabled: 'DayPicker--interactionDisabled',
  months: 'DayPicker-Months',
  month: 'DayPicker-Month',

  navBar: 'DayPicker-NavBar',
  navButtonPrev: 'DayPicker-NavButton DayPicker-NavButton--prev',
  navButtonNext: 'DayPicker-NavButton DayPicker-NavButton--next',
  navButtonInteractionDisabled: 'DayPicker-NavButton--interactionDisabled',

  caption: 'DayPicker-Caption',
  weekdays: 'DayPicker-Weekdays',
  weekdaysRow: 'DayPicker-WeekdaysRow',
  weekday: 'DayPicker-Weekday',
  body: 'DayPicker-Body',
  week: 'DayPicker-Week',
  weekNumber: 'DayPicker-WeekNumber',
  day: 'DayPicker-Day',
  footer: 'DayPicker-Footer',
  todayButton: 'DayPicker-TodayButton',

  // default modifiers
  today: 'today',
  selected: 'selected',
  disabled: 'disabled',
  outside: 'outside'
};
//# sourceMappingURL=classNames.js.map

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.cancelEvent = cancelEvent;
exports.getFirstDayOfMonth = getFirstDayOfMonth;
exports.getDaysInMonth = getDaysInMonth;
exports.getModifiersFromProps = getModifiersFromProps;
exports.getFirstDayOfWeekFromProps = getFirstDayOfWeekFromProps;
exports.isRangeOfDates = isRangeOfDates;
exports.getMonthsDiff = getMonthsDiff;
exports.getWeekArray = getWeekArray;
exports.startOfMonth = startOfMonth;
exports.getDayNodes = getDayNodes;
exports.nodeListToArray = nodeListToArray;
exports.hasOwnProp = hasOwnProp;

var _DateUtils = __webpack_require__(156);

var _LocaleUtils = __webpack_require__(296);

var _classNames = __webpack_require__(297);

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function cancelEvent(e) {
  e.preventDefault();
  e.stopPropagation();
}

function getFirstDayOfMonth(d) {
  return new Date(d.getFullYear(), d.getMonth(), 1, 12);
}

function getDaysInMonth(d) {
  var resultDate = getFirstDayOfMonth(d);

  resultDate.setMonth(resultDate.getMonth() + 1);
  resultDate.setDate(resultDate.getDate() - 1);

  return resultDate.getDate();
}

function getModifiersFromProps(props) {
  var modifiers = _extends({}, props.modifiers);
  if (props.selectedDays) {
    modifiers[props.classNames.selected] = props.selectedDays;
  }
  if (props.disabledDays) {
    modifiers[props.classNames.disabled] = props.disabledDays;
  }
  return modifiers;
}

function getFirstDayOfWeekFromProps(props) {
  var firstDayOfWeek = props.firstDayOfWeek,
      _props$locale = props.locale,
      locale = _props$locale === undefined ? 'en' : _props$locale,
      _props$localeUtils = props.localeUtils,
      localeUtils = _props$localeUtils === undefined ? {} : _props$localeUtils;

  if (!isNaN(firstDayOfWeek)) {
    return firstDayOfWeek;
  }
  if (localeUtils.getFirstDayOfWeek) {
    return localeUtils.getFirstDayOfWeek(locale);
  }
  return 0;
}

function isRangeOfDates(value) {
  return !!(value && value.from && value.to);
}

function getMonthsDiff(d1, d2) {
  return d2.getMonth() - d1.getMonth() + 12 * (d2.getFullYear() - d1.getFullYear());
}

function getWeekArray(d) {
  var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _LocaleUtils.getFirstDayOfWeek)();
  var fixedWeeks = arguments[2];

  var daysInMonth = getDaysInMonth(d);
  var dayArray = [];

  var week = [];
  var weekArray = [];

  for (var i = 1; i <= daysInMonth; i += 1) {
    dayArray.push(new Date(d.getFullYear(), d.getMonth(), i, 12));
  }

  dayArray.forEach(function (day) {
    if (week.length > 0 && day.getDay() === firstDayOfWeek) {
      weekArray.push(week);
      week = [];
    }
    week.push(day);
    if (dayArray.indexOf(day) === dayArray.length - 1) {
      weekArray.push(week);
    }
  });

  // unshift days to start the first week
  var firstWeek = weekArray[0];
  for (var _i = 7 - firstWeek.length; _i > 0; _i -= 1) {
    var outsideDate = (0, _DateUtils.clone)(firstWeek[0]);
    outsideDate.setDate(firstWeek[0].getDate() - 1);
    firstWeek.unshift(outsideDate);
  }

  // push days until the end of the last week
  var lastWeek = weekArray[weekArray.length - 1];
  for (var _i2 = lastWeek.length; _i2 < 7; _i2 += 1) {
    var _outsideDate = (0, _DateUtils.clone)(lastWeek[lastWeek.length - 1]);
    _outsideDate.setDate(lastWeek[lastWeek.length - 1].getDate() + 1);
    lastWeek.push(_outsideDate);
  }

  // add extra weeks to reach 6 weeks
  if (fixedWeeks && weekArray.length < 6) {
    var lastExtraWeek = void 0;

    for (var _i3 = weekArray.length; _i3 < 6; _i3 += 1) {
      lastExtraWeek = weekArray[weekArray.length - 1];
      var lastDay = lastExtraWeek[lastExtraWeek.length - 1];
      var extraWeek = [];

      for (var j = 0; j < 7; j += 1) {
        var _outsideDate2 = (0, _DateUtils.clone)(lastDay);
        _outsideDate2.setDate(lastDay.getDate() + j + 1);
        extraWeek.push(_outsideDate2);
      }

      weekArray.push(extraWeek);
    }
  }

  return weekArray;
}

function startOfMonth(d) {
  var newDate = (0, _DateUtils.clone)(d);
  newDate.setDate(1);
  newDate.setHours(12, 0, 0, 0); // always set noon to avoid time zone issues
  return newDate;
}

function getDayNodes(node, classNames) {
  var outsideClassName = void 0;
  if (classNames === _classNames2.default) {
    // When using CSS modules prefix the modifier as required by the BEM syntax
    outsideClassName = classNames.day + '--' + classNames.outside;
  } else {
    outsideClassName = '' + classNames.outside;
  }
  var dayQuery = classNames.day.replace(/ /g, '.');
  var outsideDayQuery = outsideClassName.replace(/ /g, '.');
  var selector = '.' + dayQuery + ':not(.' + outsideDayQuery + ')';
  return node.querySelectorAll(selector);
}

function nodeListToArray(nodeList) {
  return Array.prototype.slice.call(nodeList, 0);
}

function hasOwnProp(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
//# sourceMappingURL=Helpers.js.map

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dayMatchesModifier = dayMatchesModifier;
exports.getModifiersForDay = getModifiersForDay;

var _DateUtils = __webpack_require__(156);

var _Helpers = __webpack_require__(298);

/**
 * Return `true` if a date matches the specified modifier.
 *
 * @export
 * @param {Date} day
 * @param {Any} modifier
 * @return {Boolean}
 */
function dayMatchesModifier(day, modifier) {
  if (!modifier) {
    return false;
  }
  var arr = Array.isArray(modifier) ? modifier : [modifier];
  return arr.some(function (mod) {
    if (!mod) {
      return false;
    }
    if (mod instanceof Date) {
      return (0, _DateUtils.isSameDay)(day, mod);
    }
    if ((0, _Helpers.isRangeOfDates)(mod)) {
      return (0, _DateUtils.isDayInRange)(day, mod);
    }
    if (mod.after && mod.before && (0, _DateUtils.isDayAfter)(mod.before, mod.after)) {
      return (0, _DateUtils.isDayAfter)(day, mod.after) && (0, _DateUtils.isDayBefore)(day, mod.before);
    }
    if (mod.after && mod.before && ((0, _DateUtils.isDayAfter)(mod.after, mod.before) || (0, _DateUtils.isSameDay)(mod.after, mod.before))) {
      return (0, _DateUtils.isDayAfter)(day, mod.after) || (0, _DateUtils.isDayBefore)(day, mod.before);
    }
    if (mod.after) {
      return (0, _DateUtils.isDayAfter)(day, mod.after);
    }
    if (mod.before) {
      return (0, _DateUtils.isDayBefore)(day, mod.before);
    }
    if (mod.daysOfWeek) {
      return mod.daysOfWeek.some(function (dayOfWeek) {
        return day.getDay() === dayOfWeek;
      });
    }
    if (typeof mod === 'function') {
      return mod(day);
    }
    return false;
  });
}

/**
 * Return the modifiers matching the given day for the given
 * object of modifiers.
 *
 * @export
 * @param {Date} day
 * @param {Object} [modifiersObj={}]
 * @return {Array}
 */
function getModifiersForDay(day) {
  var modifiersObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.keys(modifiersObj).reduce(function (modifiers, modifierName) {
    var value = modifiersObj[modifierName];
    if (dayMatchesModifier(day, value)) {
      modifiers.push(modifierName);
    }
    return modifiers;
  }, []);
}

exports.default = { dayMatchesModifier: dayMatchesModifier, getModifiersForDay: getModifiersForDay };
//# sourceMappingURL=ModifiersUtils.js.map

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ISSUE_TYPES = exports.INITIATIVE_STATUS = exports.PRODUCT_TYPES = exports.PRIORITIES = void 0;
var PRIORITIES = ['Low', 'Medium', 'High'];
exports.PRIORITIES = PRIORITIES;
var PRODUCT_TYPES = ['ProdType1', 'ProdType2', 'ProdType3'];
exports.PRODUCT_TYPES = PRODUCT_TYPES;
var INITIATIVE_STATUS = ['Created', 'Approved', 'Implemented', 'Done'];
exports.INITIATIVE_STATUS = INITIATIVE_STATUS;
var ISSUE_TYPES = ['Release', 'Marketing', 'Change Mgmt'];
exports.ISSUE_TYPES = ISSUE_TYPES;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PRIORITIES, "PRIORITIES", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/lists.js");

  __REACT_HOT_LOADER__.register(PRODUCT_TYPES, "PRODUCT_TYPES", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/lists.js");

  __REACT_HOT_LOADER__.register(INITIATIVE_STATUS, "INITIATIVE_STATUS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/lists.js");

  __REACT_HOT_LOADER__.register(ISSUE_TYPES, "ISSUE_TYPES", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/lists.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PRIORITIES, "PRIORITIES", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/lists.js");

  __REACT_HOT_LOADER__.register(PRODUCT_TYPES, "PRODUCT_TYPES", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/lists.js");

  __REACT_HOT_LOADER__.register(INITIATIVE_STATUS, "INITIATIVE_STATUS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/lists.js");

  __REACT_HOT_LOADER__.register(ISSUE_TYPES, "ISSUE_TYPES", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/lists.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/lists.js");
}();

;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _selectByIdTable = _interopRequireDefault(__webpack_require__(1935));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
} // Pass any array of objects that have an id key field. Also need a name field to display
// Pass the action required to update the store entries.
// Pass the action required to perform the final update.


var SelectByIdModal = function SelectByIdModal(props) {
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      modal = _useState2[0],
      setModal = _useState2[1];

  var _toggle = function toggle() {
    setModal(!modal);
  };

  var modalTitle = props.modalTitle,
      onUpdateHandler = props.onUpdateHandler,
      onSelectRowHandler = props.onSelectRowHandler,
      onClickButtonHandler = props.onClickButtonHandler,
      className = props.className,
      selectLoader = props.selectLoader,
      data = props.data,
      width = props.width,
      actionButtonTextId = props.actionButtonTextId;
  return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(_reactstrap.Button, {
    size: "sm",
    color: "primary",
    onClick: function onClick() {
      dispatch(onClickButtonHandler());

      _toggle();
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-accounts-add zmdi-hc-fw"
  }), _react["default"].createElement("span", null, actionButtonTextId)), _react["default"].createElement(_reactstrap.Modal, {
    isOpen: modal,
    toggle: function toggle() {
      return _toggle();
    },
    className: className
  }, _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(_reactstrap.ModalHeader, null, modalTitle), _react["default"].createElement(_reactstrap.ModalBody, null, _react["default"].createElement("div", {
    className: "modal-box-content"
  }, _react["default"].createElement(_selectByIdTable["default"], {
    data: data,
    width: width,
    dispatchOnClick: onSelectRowHandler
  }))), _react["default"].createElement(_reactstrap.ModalFooter, null, _react["default"].createElement("div", null, _react["default"].createElement(_reactstrap.Button, {
    size: "sm",
    color: "secondary",
    onClick: function onClick() {
      return _toggle();
    }
  }, "Close"), _react["default"].createElement(_reactstrap.Button, {
    size: "sm",
    color: "primary",
    onClick: function onClick() {
      selectLoader();
      dispatch(onUpdateHandler());

      _toggle();
    }
  }, _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
    id: "general.updateSelections"
  }))))))));
};

var _default = SelectByIdModal;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SelectByIdModal, "SelectByIdModal", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/selectByIdModal/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/selectByIdModal/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/selectByIdModal/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/selectByIdModal/index.js");

  __REACT_HOT_LOADER__.register(_selectByIdTable, "_selectByIdTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/selectByIdModal/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/selectByIdModal/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/selectByIdModal/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/selectByIdModal/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/selectByIdModal/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/selectByIdModal/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/selectByIdModal/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/selectByIdModal/index.js");

  __REACT_HOT_LOADER__.register(SelectByIdModal, "SelectByIdModal", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/selectByIdModal/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/selectByIdModal/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/selectByIdModal/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/selectByIdModal/index.js");
}();

;

/***/ }),
/* 302 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(111),
    getPrototype = __webpack_require__(316),
    isObjectLike = __webpack_require__(79);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 304 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 305 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(1423)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)))

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(78),
    stubFalse = __webpack_require__(1157);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(209)(module)))

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(352),
    isFlattenable = __webpack_require__(1172);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(252),
    stackClear = __webpack_require__(1126),
    stackDelete = __webpack_require__(1127),
    stackGet = __webpack_require__(1128),
    stackHas = __webpack_require__(1129),
    stackSet = __webpack_require__(1130);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(349),
    setCacheAdd = __webpack_require__(1150),
    setCacheHas = __webpack_require__(1151);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 312 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1156),
    isObjectLike = __webpack_require__(79);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(235),
    toKey = __webpack_require__(203);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 315 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(636);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(644);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
var document = __webpack_require__(17).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(28);


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(237)('keys');
var uid = __webpack_require__(132);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 321 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(17).document;
module.exports = document && document.documentElement;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(20);
var anObject = __webpack_require__(19);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(84)(Function.call, __webpack_require__(87).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 324 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
var setPrototypeOf = __webpack_require__(323).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(86);
var defined = __webpack_require__(97);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 327 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 328 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(86);
var defined = __webpack_require__(97);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(133);
var $export = __webpack_require__(5);
var redefine = __webpack_require__(59);
var hide = __webpack_require__(69);
var Iterators = __webpack_require__(164);
var $iterCreate = __webpack_require__(462);
var setToStringTag = __webpack_require__(162);
var getPrototypeOf = __webpack_require__(138);
var ITERATOR = __webpack_require__(28)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(332);
var defined = __webpack_require__(97);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(20);
var cof = __webpack_require__(96);
var MATCH = __webpack_require__(28)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(28)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(164);
var ITERATOR = __webpack_require__(28)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(41);
var createDesc = __webpack_require__(131);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(206);
var ITERATOR = __webpack_require__(28)('iterator');
var Iterators = __webpack_require__(164);
module.exports = __webpack_require__(36).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(49);
var toAbsoluteIndex = __webpack_require__(135);
var toLength = __webpack_require__(32);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(139);
var step = __webpack_require__(467);
var Iterators = __webpack_require__(164);
var toIObject = __webpack_require__(70);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(330)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(242);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(329)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(84);
var invoke = __webpack_require__(456);
var html = __webpack_require__(322);
var cel = __webpack_require__(318);
var global = __webpack_require__(17);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(96)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(17);
var DESCRIPTORS = __webpack_require__(40);
var LIBRARY = __webpack_require__(133);
var $typed = __webpack_require__(248);
var hide = __webpack_require__(69);
var redefineAll = __webpack_require__(167);
var fails = __webpack_require__(18);
var anInstance = __webpack_require__(166);
var toInteger = __webpack_require__(86);
var toLength = __webpack_require__(32);
var toIndex = __webpack_require__(475);
var gOPN = __webpack_require__(137).f;
var dP = __webpack_require__(41).f;
var arrayFill = __webpack_require__(337);
var setToStringTag = __webpack_require__(162);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 343 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 344 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(480)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__batch__ = __webpack_require__(481);
 // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  var batch = Object(__WEBPACK_IMPORTED_MODULE_0__batch__["a" /* getBatch */])();
  var first = null;
  var last = null;
  return {
    clear: function clear() {
      first = null;
      last = null;
    },
    notify: function notify() {
      batch(function () {
        var listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get: function get() {
      var listeners = [];
      var listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },
    subscribe: function subscribe(callback) {
      var isSubscribed = true;
      var listener = last = {
        callback: callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub) {
    this.store = store;
    this.parentSub = parentSub;
    this.unsubscribe = null;
    this.listeners = nullListeners;
    this.handleChangeWrapper = this.handleChangeWrapper.bind(this);
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.handleChangeWrapper = function handleChangeWrapper() {
    if (this.onStateChange) {
      this.onStateChange();
    }
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.handleChangeWrapper) : this.store.subscribe(this.handleChangeWrapper);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DARK_THEME_COLOR = exports.DARK_GREEN = exports.DARK_DEEP_PURPLE = exports.DARK_BLUE = exports.DARK_PINK = exports.DARK_DEEP_ORANGE = exports.DARK_AMBER = exports.DARK_CYAN = exports.DARK_INDIGO = exports.GREEN = exports.DEEP_PURPLE = exports.BLUE = exports.PINK = exports.DEEP_ORANGE = exports.AMBER = exports.CYAN = exports.INDIGO = void 0;
var INDIGO = 'indigo';
exports.INDIGO = INDIGO;
var CYAN = 'cyan';
exports.CYAN = CYAN;
var AMBER = 'amber';
exports.AMBER = AMBER;
var DEEP_ORANGE = 'deep-orange';
exports.DEEP_ORANGE = DEEP_ORANGE;
var PINK = 'pink';
exports.PINK = PINK;
var BLUE = 'blue';
exports.BLUE = BLUE;
var DEEP_PURPLE = 'deep-purple';
exports.DEEP_PURPLE = DEEP_PURPLE;
var GREEN = 'green';
exports.GREEN = GREEN;
var DARK_INDIGO = 'dark-indigo';
exports.DARK_INDIGO = DARK_INDIGO;
var DARK_CYAN = 'dark-cyan';
exports.DARK_CYAN = DARK_CYAN;
var DARK_AMBER = 'dark-amber';
exports.DARK_AMBER = DARK_AMBER;
var DARK_DEEP_ORANGE = 'dark-deep-orange';
exports.DARK_DEEP_ORANGE = DARK_DEEP_ORANGE;
var DARK_PINK = 'dark-pink';
exports.DARK_PINK = DARK_PINK;
var DARK_BLUE = 'dark-blue';
exports.DARK_BLUE = DARK_BLUE;
var DARK_DEEP_PURPLE = 'dark-deep-purple';
exports.DARK_DEEP_PURPLE = DARK_DEEP_PURPLE;
var DARK_GREEN = 'dark-green';
exports.DARK_GREEN = DARK_GREEN;
var DARK_THEME_COLOR = 'dark-theme';
exports.DARK_THEME_COLOR = DARK_THEME_COLOR;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(INDIGO, "INDIGO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(CYAN, "CYAN", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(AMBER, "AMBER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DEEP_ORANGE, "DEEP_ORANGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(PINK, "PINK", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(BLUE, "BLUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DEEP_PURPLE, "DEEP_PURPLE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(GREEN, "GREEN", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_INDIGO, "DARK_INDIGO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_CYAN, "DARK_CYAN", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_AMBER, "DARK_AMBER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_DEEP_ORANGE, "DARK_DEEP_ORANGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_PINK, "DARK_PINK", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_BLUE, "DARK_BLUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_DEEP_PURPLE, "DARK_DEEP_PURPLE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_GREEN, "DARK_GREEN", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_THEME_COLOR, "DARK_THEME_COLOR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ThemeColors.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(INDIGO, "INDIGO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(CYAN, "CYAN", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(AMBER, "AMBER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DEEP_ORANGE, "DEEP_ORANGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(PINK, "PINK", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(BLUE, "BLUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DEEP_PURPLE, "DEEP_PURPLE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(GREEN, "GREEN", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_INDIGO, "DARK_INDIGO", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_CYAN, "DARK_CYAN", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_AMBER, "DARK_AMBER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_DEEP_ORANGE, "DARK_DEEP_ORANGE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_PINK, "DARK_PINK", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_BLUE, "DARK_BLUE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_DEEP_PURPLE, "DARK_DEEP_PURPLE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_GREEN, "DARK_GREEN", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_THEME_COLOR, "DARK_THEME_COLOR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/ThemeColors.js");
}();

;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(142),
    root = __webpack_require__(78);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(1137),
    mapCacheDelete = __webpack_require__(1144),
    mapCacheGet = __webpack_require__(1146),
    mapCacheHas = __webpack_require__(1147),
    mapCacheSet = __webpack_require__(1148);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1149),
    isObjectLike = __webpack_require__(79);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 351 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 352 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(437),
    stubArray = __webpack_require__(634);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 354 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(627);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(209)(module)))

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(26),
    isSymbol = __webpack_require__(170);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return qEnd; });
/* harmony export (immutable) */ __webpack_exports__["c"] = safeName;
/* harmony export (immutable) */ __webpack_exports__["a"] = fsmIterator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(71);


var done = { done: true, value: undefined };
var qEnd = {};

function safeName(patternOrChannel) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].channel(patternOrChannel)) {
    return 'channel';
  } else if (Array.isArray(patternOrChannel)) {
    return String(patternOrChannel.map(function (entry) {
      return String(entry);
    }));
  } else {
    return String(patternOrChannel);
  }
}

function fsmIterator(fsm, q0) {
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';

  var updateState = void 0,
      qNext = q0;

  function next(arg, error) {
    if (qNext === qEnd) {
      return done;
    }

    if (error) {
      qNext = qEnd;
      throw error;
    } else {
      updateState && updateState(arg);

      var _fsm$qNext = fsm[qNext](),
          q = _fsm$qNext[0],
          output = _fsm$qNext[1],
          _updateState = _fsm$qNext[2];

      qNext = q;
      updateState = _updateState;
      return qNext === qEnd ? done : output;
    }
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* makeIterator */])(next, function (error) {
    return next(null, error);
  }, name, true);
}

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.auditLogHeaderEntry = exports.objectStateComparator = void 0;

var objectStateComparator = function objectStateComparator(oldState, newState) {
  var result = [];

  try {
    var _oldState, _newState;

    if (!oldState || !Array.isArray(oldState) || ((_oldState = oldState) === null || _oldState === void 0 ? void 0 : _oldState.length) === 0) {
      return result;
    }

    if (!newState || !Array.isArray(newState) || ((_newState = newState) === null || _newState === void 0 ? void 0 : _newState.length) === 0) {
      return result;
    } // Create new copies 


    oldState = oldState.slice(0);
    newState = newState.slice(0); // Deleted Objects

    mismatchingObjects(oldState, newState, result);
    oldState.forEach(function (object) {
      var report = {};
      report.id = object === null || object === void 0 ? void 0 : object.id;
      var matches = newState.filter(function (item) {
        return (item === null || item === void 0 ? void 0 : item.id) === (object === null || object === void 0 ? void 0 : object.id);
      });
      var mlen = matches.length;

      if (mlen) {
        if (mlen === 1 && stringMatch(object, matches[0])) {
          return;
        }

        if (mlen > 1) {
          report.hasDuplicate = true;
        }

        matches.forEach(function (match, index) {
          if (stringMatch(object, match)) return;
          keyMatches(object, match, index, report);
          matchValue(null, object, match, index, report);
        });
      }

      if (Object.keys(report).length > 1) {
        result.push(report);
      }
    });
    return result;
  } catch (error) {
    return error; // dont want the update to fail due to a processing error here - do not throw the error
  }
};

exports.objectStateComparator = objectStateComparator;

var stringMatch = function stringMatch(sourceObject, updatedObject) {
  return JSON.stringify(sourceObject) === JSON.stringify(updatedObject);
};

var keyMatches = function keyMatches(sourceObject, updatedObject, index, report) {
  var k1 = Object.keys(sourceObject);
  var k2 = Object.keys(updatedObject);

  if (k1.join() !== k2.join()) {
    report.keysRemoved = report.keysRemoved || [];
    var removed = k1.filter(function (key) {
      return k2.indexOf(key) < 0;
    });

    if ((removed === null || removed === void 0 ? void 0 : removed.length) > 0) {
      report.keysRemoved.push({
        keys: removed
      });
    }

    report.keysAdded = report.keysAdded || [];
    var added = k2.filter(function (key) {
      return k1.indexOf(key) < 0;
    });

    if ((added === null || added === void 0 ? void 0 : added.length) > 0) {
      var values = added.map(function (entry) {
        return updatedObject[entry];
      });
      report.keysAdded.push({
        keys: added,
        values: values
      });
    }
  }
};

var matchValue = function matchValue(parentKey, sourceObject, updatedObject, index, report) {
  report.keysChanged = report.keysChanged || [];
  var keys = [];

  for (var key in sourceObject) {
    if (sourceObject[key] !== updatedObject[key] && updatedObject[key]) {
      if (Array.isArray(sourceObject[key])) {
        mismatchingObjects(sourceObject[key], updatedObject[key], keys);

        if (Array.isArray(updatedObject[key]) && updatedObject[key].length > 0) {
          sourceObject[key].forEach(function (entry, index) {
            matchValue(key, entry, updatedObject[key][index], index, report);
          });
        }
      } else {
        keys.push(key.concat(' updated from ').concat(sourceObject[key]).concat(' to ').concat(updatedObject[key]));
      }
    }
  }

  if ((keys === null || keys === void 0 ? void 0 : keys.length) > 0) {
    var objectId = (sourceObject === null || sourceObject === void 0 ? void 0 : sourceObject.id) ? sourceObject === null || sourceObject === void 0 ? void 0 : sourceObject.id : index;
    report.keysChanged.push({
      keys: keys,
      objectId: objectId
    });
  }
};

var mismatchingObjects = function mismatchingObjects(sourceObject, updatedObject, result) {
  var ids1 = sourceObject.map(function (object) {
    return object.id;
  });
  var ids2 = updatedObject.map(function (object) {
    return object.id;
  });
  ids1.forEach(function (id) {
    if (ids2.indexOf(id) < 0) result.push({
      id: id,
      status: 'Object Deleted '.concat(JSON.stringify(sourceObject))
    });
  });
  ids2.forEach(function (id) {
    if (ids1.indexOf(id) < 0) result.push({
      id: id,
      status: 'Object Added'.concat(JSON.stringify(updatedObject))
    });
  });
};

var auditLogHeaderEntry = function auditLogHeaderEntry(auditEntry) {
  if (auditEntry) {
    return {
      auditLogEntry: JSON.stringify(auditEntry)
    };
  }

  return null;
};

exports.auditLogHeaderEntry = auditLogHeaderEntry;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(objectStateComparator, "objectStateComparator", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/auditService.js");

  __REACT_HOT_LOADER__.register(stringMatch, "stringMatch", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/auditService.js");

  __REACT_HOT_LOADER__.register(keyMatches, "keyMatches", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/auditService.js");

  __REACT_HOT_LOADER__.register(matchValue, "matchValue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/auditService.js");

  __REACT_HOT_LOADER__.register(mismatchingObjects, "mismatchingObjects", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/auditService.js");

  __REACT_HOT_LOADER__.register(auditLogHeaderEntry, "auditLogHeaderEntry", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/auditService.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(objectStateComparator, "objectStateComparator", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/auditService.js");

  __REACT_HOT_LOADER__.register(stringMatch, "stringMatch", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/auditService.js");

  __REACT_HOT_LOADER__.register(keyMatches, "keyMatches", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/auditService.js");

  __REACT_HOT_LOADER__.register(matchValue, "matchValue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/auditService.js");

  __REACT_HOT_LOADER__.register(mismatchingObjects, "mismatchingObjects", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/auditService.js");

  __REACT_HOT_LOADER__.register(auditLogHeaderEntry, "auditLogHeaderEntry", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/auditService.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/auditService.js");
}();

;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(73);
var normalizeHeaderName = __webpack_require__(1228);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(651);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(651);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(315)))

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProjectCacheExpiry = exports.getProjectIssueCacheExpiry = exports.isSlsOffline = void 0;

var isSlsOffline = function isSlsOffline() {
  return "false" === 'true' || false;
}; // get the value in minutes


exports.isSlsOffline = isSlsOffline;

var getProjectIssueCacheExpiry = function getProjectIssueCacheExpiry() {
  return "60" || 0;
}; // get the value in minutes


exports.getProjectIssueCacheExpiry = getProjectIssueCacheExpiry;

var getProjectCacheExpiry = function getProjectCacheExpiry() {
  return "1440" || 0;
};

exports.getProjectCacheExpiry = getProjectCacheExpiry;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(isSlsOffline, "isSlsOffline", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/environment.js");

  __REACT_HOT_LOADER__.register(getProjectIssueCacheExpiry, "getProjectIssueCacheExpiry", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/environment.js");

  __REACT_HOT_LOADER__.register(getProjectCacheExpiry, "getProjectCacheExpiry", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/environment.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(isSlsOffline, "isSlsOffline", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/environment.js");

  __REACT_HOT_LOADER__.register(getProjectIssueCacheExpiry, "getProjectIssueCacheExpiry", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/environment.js");

  __REACT_HOT_LOADER__.register(getProjectCacheExpiry, "getProjectCacheExpiry", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/environment.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/environment.js");
}();

;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    merge: merge
};


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DATA_NOT_CHANGED_SO_NOT_UPDATED = void 0;
var DATA_NOT_CHANGED_SO_NOT_UPDATED = 'Nothing to update as no changes were made to the data';
exports.DATA_NOT_CHANGED_SO_NOT_UPDATED = DATA_NOT_CHANGED_SO_NOT_UPDATED;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(DATA_NOT_CHANGED_SO_NOT_UPDATED, "DATA_NOT_CHANGED_SO_NOT_UPDATED", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/messages.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(DATA_NOT_CHANGED_SO_NOT_UPDATED, "DATA_NOT_CHANGED_SO_NOT_UPDATED", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/messages.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/messages.js");
}();

;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideSurveyGroupQuestionLoader = exports.showSurveyGroupQuestionLoader = exports.handleSurveyGroupQuestionRequestClose = exports.onToggleSurveyGroupQuestionDrawer = exports.onDeleteSurveyGroupQuestion = exports.onSaveSurveyGroupQuestion = exports.onSurveyGroupQuestionClose = exports.onAddSurveyGroupQuestion = void 0;

var _ActionTypes = __webpack_require__(7);

var onAddSurveyGroupQuestion = function onAddSurveyGroupQuestion() {
  return {
    type: _ActionTypes.ON_ADD_SURVEY_GROUP_QUESTION,
    payload: ''
  };
};

exports.onAddSurveyGroupQuestion = onAddSurveyGroupQuestion;

var onSurveyGroupQuestionClose = function onSurveyGroupQuestionClose() {
  return {
    type: _ActionTypes.ON_SURVEY_GROUP_QUESTION_CLOSE,
    payload: ''
  };
};

exports.onSurveyGroupQuestionClose = onSurveyGroupQuestionClose;

var onSaveSurveyGroupQuestion = function onSaveSurveyGroupQuestion(data) {
  return {
    type: _ActionTypes.ON_SAVE_SURVEY_GROUP_QUESTION,
    payload: data
  };
};

exports.onSaveSurveyGroupQuestion = onSaveSurveyGroupQuestion;

var onDeleteSurveyGroupQuestion = function onDeleteSurveyGroupQuestion(data) {
  return {
    type: _ActionTypes.ON_DELETE_SURVEY_GROUP_QUESTION,
    payload: data
  };
};

exports.onDeleteSurveyGroupQuestion = onDeleteSurveyGroupQuestion;

var onToggleSurveyGroupQuestionDrawer = function onToggleSurveyGroupQuestionDrawer() {
  return {
    type: _ActionTypes.ON_TOGGLE_SURVEY_GROUP_QUESTION_DRAWER
  };
};

exports.onToggleSurveyGroupQuestionDrawer = onToggleSurveyGroupQuestionDrawer;

var handleSurveyGroupQuestionRequestClose = function handleSurveyGroupQuestionRequestClose() {
  return {
    type: _ActionTypes.HANDLE_SURVEY_GROUP_QUESTION_REQUEST_CLOSE
  };
};

exports.handleSurveyGroupQuestionRequestClose = handleSurveyGroupQuestionRequestClose;

var showSurveyGroupQuestionLoader = function showSurveyGroupQuestionLoader() {
  return {
    type: _ActionTypes.SHOW_SURVEY_GROUP_QUESTION_LOADER
  };
};

exports.showSurveyGroupQuestionLoader = showSurveyGroupQuestionLoader;

var hideSurveyGroupQuestionLoader = function hideSurveyGroupQuestionLoader() {
  return {
    type: _ActionTypes.HIDE_SURVEY_GROUP_QUESTION_LOADER
  };
};

exports.hideSurveyGroupQuestionLoader = hideSurveyGroupQuestionLoader;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(onAddSurveyGroupQuestion, "onAddSurveyGroupQuestion", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(onSurveyGroupQuestionClose, "onSurveyGroupQuestionClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(onSaveSurveyGroupQuestion, "onSaveSurveyGroupQuestion", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(onDeleteSurveyGroupQuestion, "onDeleteSurveyGroupQuestion", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(onToggleSurveyGroupQuestionDrawer, "onToggleSurveyGroupQuestionDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(handleSurveyGroupQuestionRequestClose, "handleSurveyGroupQuestionRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(showSurveyGroupQuestionLoader, "showSurveyGroupQuestionLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(hideSurveyGroupQuestionLoader, "hideSurveyGroupQuestionLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroupQuestion.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(onAddSurveyGroupQuestion, "onAddSurveyGroupQuestion", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(onSurveyGroupQuestionClose, "onSurveyGroupQuestionClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(onSaveSurveyGroupQuestion, "onSaveSurveyGroupQuestion", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(onDeleteSurveyGroupQuestion, "onDeleteSurveyGroupQuestion", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(onToggleSurveyGroupQuestionDrawer, "onToggleSurveyGroupQuestionDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(handleSurveyGroupQuestionRequestClose, "handleSurveyGroupQuestionRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(showSurveyGroupQuestionLoader, "showSurveyGroupQuestionLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(hideSurveyGroupQuestionLoader, "hideSurveyGroupQuestionLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/SurveyGroupQuestion.js");
}();

;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideProjectPriorityLoader = exports.showProjectPriorityLoader = exports.handleProjectPriorityRequestClose = exports.onToggleProjectPriorityDrawer = exports.updateSearchProjectPriority = exports.onAllProjectPrioritySelect = exports.getUnselectedAllProjectPriority = exports.getAllProjectPriority = exports.filterProjectPriority = exports.onDeleteSelectedProjectPriority = exports.onDeleteProjectPrioritySuccess = exports.onDeleteProjectPriority = exports.onSaveProjectPrioritySuccess = exports.onSaveProjectPriority = exports.onFilterProjectPriorityOptionSelect = exports.onProjectPriorityClose = exports.onAddProjectPriority = exports.onProjectPrioritySelect = exports.addFavouriteProjectPriority = exports.showProjectPriorityMessage = exports.fetchProjectPrioritysSuccess = exports.fetchProjectPrioritys = exports.fetchProjectPrioritySuccess = exports.fetchProjectPriority = exports.onUpdateProjectPriorities = void 0;

var _ActionTypes = __webpack_require__(7);

var onUpdateProjectPriorities = function onUpdateProjectPriorities(payload) {
  return {
    type: _ActionTypes.ON_UPDATE_PROJECT_PRIORITIES,
    payload: payload
  };
};

exports.onUpdateProjectPriorities = onUpdateProjectPriorities;

var fetchProjectPriority = function fetchProjectPriority(payload) {
  return {
    type: _ActionTypes.FETCH_PROJECT_PRIORITY,
    payload: payload
  };
};

exports.fetchProjectPriority = fetchProjectPriority;

var fetchProjectPrioritySuccess = function fetchProjectPrioritySuccess(payload) {
  return {
    type: _ActionTypes.FETCH_PROJECT_PRIORITY_SUCCESS,
    payload: payload
  };
};

exports.fetchProjectPrioritySuccess = fetchProjectPrioritySuccess;

var fetchProjectPrioritys = function fetchProjectPrioritys() {
  return {
    type: _ActionTypes.FETCH_ALL_PROJECT_PRIORITY
  };
};

exports.fetchProjectPrioritys = fetchProjectPrioritys;

var fetchProjectPrioritysSuccess = function fetchProjectPrioritysSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_ALL_PROJECT_PRIORITY_SUCCESS,
    payload: payload
  };
};

exports.fetchProjectPrioritysSuccess = fetchProjectPrioritysSuccess;

var showProjectPriorityMessage = function showProjectPriorityMessage(message) {
  return {
    type: _ActionTypes.SHOW_PROJECT_PRIORITY_MESSAGE,
    payload: message
  };
};

exports.showProjectPriorityMessage = showProjectPriorityMessage;

var addFavouriteProjectPriority = function addFavouriteProjectPriority(payload) {
  return {
    type: _ActionTypes.ADD_FAVOURITE_PROJECT_PRIORITY,
    payload: payload
  };
};

exports.addFavouriteProjectPriority = addFavouriteProjectPriority;

var onProjectPrioritySelect = function onProjectPrioritySelect(payload) {
  return {
    type: _ActionTypes.ON_PROJECT_PRIORITY_SELECT,
    payload: payload
  };
};

exports.onProjectPrioritySelect = onProjectPrioritySelect;

var onAddProjectPriority = function onAddProjectPriority() {
  return {
    type: _ActionTypes.ON_ADD_PROJECT_PRIORITY,
    payload: ''
  };
};

exports.onAddProjectPriority = onAddProjectPriority;

var onProjectPriorityClose = function onProjectPriorityClose() {
  return {
    type: _ActionTypes.ON_PROJECT_PRIORITY_CLOSE,
    payload: ''
  };
};

exports.onProjectPriorityClose = onProjectPriorityClose;

var onFilterProjectPriorityOptionSelect = function onFilterProjectPriorityOptionSelect(payload) {
  return {
    type: _ActionTypes.ON_FILTER_PROJECT_PRIORITY_OPTION_SELECT,
    payload: payload
  };
};

exports.onFilterProjectPriorityOptionSelect = onFilterProjectPriorityOptionSelect;

var onSaveProjectPriority = function onSaveProjectPriority(payload) {
  return {
    type: _ActionTypes.ON_SAVE_PROJECT_PRIORITY,
    payload: payload
  };
};

exports.onSaveProjectPriority = onSaveProjectPriority;

var onSaveProjectPrioritySuccess = function onSaveProjectPrioritySuccess(data) {
  return {
    type: _ActionTypes.ON_SAVE_PROJECT_PRIORITY_SUCCESS,
    payload: data
  };
};

exports.onSaveProjectPrioritySuccess = onSaveProjectPrioritySuccess;

var onDeleteProjectPriority = function onDeleteProjectPriority(payload) {
  return {
    type: _ActionTypes.ON_DELETE_PROJECT_PRIORITY,
    payload: payload
  };
};

exports.onDeleteProjectPriority = onDeleteProjectPriority;

var onDeleteProjectPrioritySuccess = function onDeleteProjectPrioritySuccess(payload) {
  return {
    type: _ActionTypes.ON_DELETE_PROJECT_PRIORITY_SUCCESS,
    payload: payload
  };
};

exports.onDeleteProjectPrioritySuccess = onDeleteProjectPrioritySuccess;

var onDeleteSelectedProjectPriority = function onDeleteSelectedProjectPriority() {
  return {
    type: _ActionTypes.ON_DELETE_SELECTED_PROJECT_PRIORITY,
    payload: ''
  };
};

exports.onDeleteSelectedProjectPriority = onDeleteSelectedProjectPriority;

var filterProjectPriority = function filterProjectPriority(payload) {
  return {
    type: _ActionTypes.FILTER_PROJECT_PRIORITY,
    payload: payload
  };
};

exports.filterProjectPriority = filterProjectPriority;

var getAllProjectPriority = function getAllProjectPriority() {
  return {
    type: _ActionTypes.GET_ALL_PROJECT_PRIORITY,
    payload: ''
  };
};

exports.getAllProjectPriority = getAllProjectPriority;

var getUnselectedAllProjectPriority = function getUnselectedAllProjectPriority() {
  return {
    type: _ActionTypes.GET_UNSELECTED_ALL_PROJECT_PRIORITY,
    payload: ''
  };
};

exports.getUnselectedAllProjectPriority = getUnselectedAllProjectPriority;

var onAllProjectPrioritySelect = function onAllProjectPrioritySelect() {
  return {
    type: _ActionTypes.ON_ALL_PROJECT_PRIORITY_SELECT,
    payload: ''
  };
};

exports.onAllProjectPrioritySelect = onAllProjectPrioritySelect;

var updateSearchProjectPriority = function updateSearchProjectPriority(payload) {
  return {
    type: _ActionTypes.UPDATE_SEARCH_PROJECT_PRIORITY,
    payload: payload
  };
};

exports.updateSearchProjectPriority = updateSearchProjectPriority;

var onToggleProjectPriorityDrawer = function onToggleProjectPriorityDrawer() {
  return {
    type: _ActionTypes.ON_TOGGLE_PROJECT_PRIORITY_DRAWER
  };
};

exports.onToggleProjectPriorityDrawer = onToggleProjectPriorityDrawer;

var handleProjectPriorityRequestClose = function handleProjectPriorityRequestClose() {
  return {
    type: _ActionTypes.HANDLE_PROJECT_PRIORITY_REQUEST_CLOSE
  };
};

exports.handleProjectPriorityRequestClose = handleProjectPriorityRequestClose;

var showProjectPriorityLoader = function showProjectPriorityLoader() {
  return {
    type: _ActionTypes.SHOW_PROJECT_PRIORITY_LOADER
  };
};

exports.showProjectPriorityLoader = showProjectPriorityLoader;

var hideProjectPriorityLoader = function hideProjectPriorityLoader() {
  return {
    type: _ActionTypes.HIDE_PROJECT_PRIORITY_LOADER
  };
};

exports.hideProjectPriorityLoader = hideProjectPriorityLoader;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(onUpdateProjectPriorities, "onUpdateProjectPriorities", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(fetchProjectPriority, "fetchProjectPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(fetchProjectPrioritySuccess, "fetchProjectPrioritySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(fetchProjectPrioritys, "fetchProjectPrioritys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(fetchProjectPrioritysSuccess, "fetchProjectPrioritysSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(showProjectPriorityMessage, "showProjectPriorityMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(addFavouriteProjectPriority, "addFavouriteProjectPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(onProjectPrioritySelect, "onProjectPrioritySelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(onAddProjectPriority, "onAddProjectPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(onProjectPriorityClose, "onProjectPriorityClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(onFilterProjectPriorityOptionSelect, "onFilterProjectPriorityOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(onSaveProjectPriority, "onSaveProjectPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(onSaveProjectPrioritySuccess, "onSaveProjectPrioritySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(onDeleteProjectPriority, "onDeleteProjectPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(onDeleteProjectPrioritySuccess, "onDeleteProjectPrioritySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(onDeleteSelectedProjectPriority, "onDeleteSelectedProjectPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(filterProjectPriority, "filterProjectPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(getAllProjectPriority, "getAllProjectPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllProjectPriority, "getUnselectedAllProjectPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(onAllProjectPrioritySelect, "onAllProjectPrioritySelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(updateSearchProjectPriority, "updateSearchProjectPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(onToggleProjectPriorityDrawer, "onToggleProjectPriorityDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(handleProjectPriorityRequestClose, "handleProjectPriorityRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(showProjectPriorityLoader, "showProjectPriorityLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(hideProjectPriorityLoader, "hideProjectPriorityLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(onUpdateProjectPriorities, "onUpdateProjectPriorities", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(fetchProjectPriority, "fetchProjectPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(fetchProjectPrioritySuccess, "fetchProjectPrioritySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(fetchProjectPrioritys, "fetchProjectPrioritys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(fetchProjectPrioritysSuccess, "fetchProjectPrioritysSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(showProjectPriorityMessage, "showProjectPriorityMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(addFavouriteProjectPriority, "addFavouriteProjectPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(onProjectPrioritySelect, "onProjectPrioritySelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(onAddProjectPriority, "onAddProjectPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(onProjectPriorityClose, "onProjectPriorityClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(onFilterProjectPriorityOptionSelect, "onFilterProjectPriorityOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(onSaveProjectPriority, "onSaveProjectPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(onSaveProjectPrioritySuccess, "onSaveProjectPrioritySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(onDeleteProjectPriority, "onDeleteProjectPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(onDeleteProjectPrioritySuccess, "onDeleteProjectPrioritySuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(onDeleteSelectedProjectPriority, "onDeleteSelectedProjectPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(filterProjectPriority, "filterProjectPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(getAllProjectPriority, "getAllProjectPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllProjectPriority, "getUnselectedAllProjectPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(onAllProjectPrioritySelect, "onAllProjectPrioritySelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(updateSearchProjectPriority, "updateSearchProjectPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(onToggleProjectPriorityDrawer, "onToggleProjectPriorityDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(handleProjectPriorityRequestClose, "handleProjectPriorityRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(showProjectPriorityLoader, "showProjectPriorityLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(hideProjectPriorityLoader, "hideProjectPriorityLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectPriority.js");
}();

;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideProjectIssueLoader = exports.showProjectIssueLoader = exports.handleProjectIssueRequestClose = exports.onToggleProjectIssueDrawer = exports.updateSearchProjectIssue = exports.onAllProjectIssueSelect = exports.getUnselectedAllProjectIssue = exports.getAllProjectIssue = exports.filterProjectIssue = exports.onFilterSelectedProjectIssue = exports.onDeleteProjectIssueSuccess = exports.onDeleteProjectIssue = exports.onSaveProjectIssueSuccess = exports.onSaveJiraProjectIssue = exports.onSaveProjectIssue = exports.onFilterProjectIssueOptionSelect = exports.onJiraProjectIssueClose = exports.onProjectIssueClose = exports.onAddJiraProjectIssue = exports.onAddProjectIssue = exports.onProjectIssueSelect = exports.addFavouriteProjectIssueSuccess = exports.addFavouriteProjectIssue = exports.showProjectIssueMessage = exports.fetchProjectIssuesSuccess = exports.fetchProjectIssues = exports.fetchProjectIssueSuccess = exports.setProjectIssue = exports.fetchProjectIssue = exports.onSaveProjectIssueCacheSuccess = void 0;

var _ActionTypes = __webpack_require__(7);

var onSaveProjectIssueCacheSuccess = function onSaveProjectIssueCacheSuccess(payload) {
  return {
    type: _ActionTypes.ON_SAVE_PROJECT_ISSUE_CACHE_SUCCESS,
    payload: payload
  };
};

exports.onSaveProjectIssueCacheSuccess = onSaveProjectIssueCacheSuccess;

var fetchProjectIssue = function fetchProjectIssue(payload) {
  return {
    type: _ActionTypes.FETCH_PROJECT_ISSUE,
    payload: payload
  };
};

exports.fetchProjectIssue = fetchProjectIssue;

var setProjectIssue = function setProjectIssue(payload) {
  return {
    type: _ActionTypes.SET_PROJECT_ISSUE,
    payload: payload
  };
};

exports.setProjectIssue = setProjectIssue;

var fetchProjectIssueSuccess = function fetchProjectIssueSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_PROJECT_ISSUE_SUCCESS,
    payload: payload
  };
}; // payload is boolesn - true is to use the cache - false - retrieve from api every time


exports.fetchProjectIssueSuccess = fetchProjectIssueSuccess;

var fetchProjectIssues = function fetchProjectIssues(payload) {
  return {
    type: _ActionTypes.FETCH_ALL_PROJECT_ISSUE,
    payload: payload
  };
};

exports.fetchProjectIssues = fetchProjectIssues;

var fetchProjectIssuesSuccess = function fetchProjectIssuesSuccess(payload) {
  return {
    type: _ActionTypes.FETCH_ALL_PROJECT_ISSUE_SUCCESS,
    payload: payload
  };
};

exports.fetchProjectIssuesSuccess = fetchProjectIssuesSuccess;

var showProjectIssueMessage = function showProjectIssueMessage(message) {
  return {
    type: _ActionTypes.SHOW_PROJECT_ISSUE_MESSAGE,
    payload: message
  };
};

exports.showProjectIssueMessage = showProjectIssueMessage;

var addFavouriteProjectIssue = function addFavouriteProjectIssue(payload) {
  return {
    type: _ActionTypes.ADD_FAVOURITE_PROJECT_ISSUE,
    payload: payload
  };
};

exports.addFavouriteProjectIssue = addFavouriteProjectIssue;

var addFavouriteProjectIssueSuccess = function addFavouriteProjectIssueSuccess(payload) {
  return {
    type: _ActionTypes.ADD_FAVOURITE_PROJECT_ISSUE_SUCCESS,
    payload: payload
  };
};

exports.addFavouriteProjectIssueSuccess = addFavouriteProjectIssueSuccess;

var onProjectIssueSelect = function onProjectIssueSelect(payload) {
  return {
    type: _ActionTypes.ON_PROJECT_ISSUE_SELECT,
    payload: payload
  };
};

exports.onProjectIssueSelect = onProjectIssueSelect;

var onAddProjectIssue = function onAddProjectIssue() {
  return {
    type: _ActionTypes.ON_ADD_PROJECT_ISSUE,
    payload: ''
  };
};

exports.onAddProjectIssue = onAddProjectIssue;

var onAddJiraProjectIssue = function onAddJiraProjectIssue() {
  return {
    type: _ActionTypes.ON_ADD_JIRA_PROJECT_ISSUE,
    payload: ''
  };
};

exports.onAddJiraProjectIssue = onAddJiraProjectIssue;

var onProjectIssueClose = function onProjectIssueClose() {
  return {
    type: _ActionTypes.ON_PROJECT_ISSUE_CLOSE,
    payload: ''
  };
};

exports.onProjectIssueClose = onProjectIssueClose;

var onJiraProjectIssueClose = function onJiraProjectIssueClose() {
  return {
    type: _ActionTypes.ON_JIRA_PROJECT_ISSUE_CLOSE,
    payload: ''
  };
};

exports.onJiraProjectIssueClose = onJiraProjectIssueClose;

var onFilterProjectIssueOptionSelect = function onFilterProjectIssueOptionSelect(payload) {
  return {
    type: _ActionTypes.ON_FILTER_PROJECT_ISSUE_OPTION_SELECT,
    payload: payload
  };
};

exports.onFilterProjectIssueOptionSelect = onFilterProjectIssueOptionSelect;

var onSaveProjectIssue = function onSaveProjectIssue(payload) {
  return {
    type: _ActionTypes.ON_SAVE_PROJECT_ISSUE,
    payload: payload
  };
};

exports.onSaveProjectIssue = onSaveProjectIssue;

var onSaveJiraProjectIssue = function onSaveJiraProjectIssue(payload) {
  return {
    type: _ActionTypes.ON_SAVE_JIRA_PROJECT_ISSUE,
    payload: payload
  };
};

exports.onSaveJiraProjectIssue = onSaveJiraProjectIssue;

var onSaveProjectIssueSuccess = function onSaveProjectIssueSuccess(data) {
  return {
    type: _ActionTypes.ON_SAVE_PROJECT_ISSUE_SUCCESS,
    payload: data
  };
};

exports.onSaveProjectIssueSuccess = onSaveProjectIssueSuccess;

var onDeleteProjectIssue = function onDeleteProjectIssue(payload) {
  return {
    type: _ActionTypes.ON_DELETE_PROJECT_ISSUE,
    payload: payload
  };
};

exports.onDeleteProjectIssue = onDeleteProjectIssue;

var onDeleteProjectIssueSuccess = function onDeleteProjectIssueSuccess(payload) {
  return {
    type: _ActionTypes.ON_DELETE_PROJECT_ISSUE_SUCCESS,
    payload: payload
  };
};

exports.onDeleteProjectIssueSuccess = onDeleteProjectIssueSuccess;

var onFilterSelectedProjectIssue = function onFilterSelectedProjectIssue() {
  return {
    type: _ActionTypes.ON_FILTER_SELECTED_PROJECT_ISSUE,
    payload: ''
  };
};

exports.onFilterSelectedProjectIssue = onFilterSelectedProjectIssue;

var filterProjectIssue = function filterProjectIssue(payload) {
  return {
    type: _ActionTypes.FILTER_PROJECT_ISSUE,
    payload: payload
  };
};

exports.filterProjectIssue = filterProjectIssue;

var getAllProjectIssue = function getAllProjectIssue() {
  return {
    type: _ActionTypes.GET_ALL_PROJECT_ISSUE,
    payload: ''
  };
};

exports.getAllProjectIssue = getAllProjectIssue;

var getUnselectedAllProjectIssue = function getUnselectedAllProjectIssue() {
  return {
    type: _ActionTypes.GET_UNSELECTED_ALL_PROJECT_ISSUE,
    payload: ''
  };
};

exports.getUnselectedAllProjectIssue = getUnselectedAllProjectIssue;

var onAllProjectIssueSelect = function onAllProjectIssueSelect() {
  return {
    type: _ActionTypes.ON_ALL_PROJECT_ISSUE_SELECT,
    payload: ''
  };
};

exports.onAllProjectIssueSelect = onAllProjectIssueSelect;

var updateSearchProjectIssue = function updateSearchProjectIssue(payload) {
  return {
    type: _ActionTypes.UPDATE_SEARCH_PROJECT_ISSUE,
    payload: payload
  };
};

exports.updateSearchProjectIssue = updateSearchProjectIssue;

var onToggleProjectIssueDrawer = function onToggleProjectIssueDrawer() {
  return {
    type: _ActionTypes.ON_TOGGLE_PROJECT_ISSUE_DRAWER
  };
};

exports.onToggleProjectIssueDrawer = onToggleProjectIssueDrawer;

var handleProjectIssueRequestClose = function handleProjectIssueRequestClose() {
  return {
    type: _ActionTypes.HANDLE_PROJECT_ISSUE_REQUEST_CLOSE
  };
};

exports.handleProjectIssueRequestClose = handleProjectIssueRequestClose;

var showProjectIssueLoader = function showProjectIssueLoader() {
  return {
    type: _ActionTypes.SHOW_PROJECT_ISSUE_LOADER
  };
};

exports.showProjectIssueLoader = showProjectIssueLoader;

var hideProjectIssueLoader = function hideProjectIssueLoader() {
  return {
    type: _ActionTypes.HIDE_PROJECT_ISSUE_LOADER
  };
};

exports.hideProjectIssueLoader = hideProjectIssueLoader;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(onSaveProjectIssueCacheSuccess, "onSaveProjectIssueCacheSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(fetchProjectIssue, "fetchProjectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(setProjectIssue, "setProjectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(fetchProjectIssueSuccess, "fetchProjectIssueSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(fetchProjectIssues, "fetchProjectIssues", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(fetchProjectIssuesSuccess, "fetchProjectIssuesSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(showProjectIssueMessage, "showProjectIssueMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(addFavouriteProjectIssue, "addFavouriteProjectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(addFavouriteProjectIssueSuccess, "addFavouriteProjectIssueSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(onProjectIssueSelect, "onProjectIssueSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(onAddProjectIssue, "onAddProjectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(onAddJiraProjectIssue, "onAddJiraProjectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(onProjectIssueClose, "onProjectIssueClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(onJiraProjectIssueClose, "onJiraProjectIssueClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(onFilterProjectIssueOptionSelect, "onFilterProjectIssueOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(onSaveProjectIssue, "onSaveProjectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(onSaveJiraProjectIssue, "onSaveJiraProjectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(onSaveProjectIssueSuccess, "onSaveProjectIssueSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(onDeleteProjectIssue, "onDeleteProjectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(onDeleteProjectIssueSuccess, "onDeleteProjectIssueSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(onFilterSelectedProjectIssue, "onFilterSelectedProjectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(filterProjectIssue, "filterProjectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(getAllProjectIssue, "getAllProjectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllProjectIssue, "getUnselectedAllProjectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(onAllProjectIssueSelect, "onAllProjectIssueSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(updateSearchProjectIssue, "updateSearchProjectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(onToggleProjectIssueDrawer, "onToggleProjectIssueDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(handleProjectIssueRequestClose, "handleProjectIssueRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(showProjectIssueLoader, "showProjectIssueLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(hideProjectIssueLoader, "hideProjectIssueLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(onSaveProjectIssueCacheSuccess, "onSaveProjectIssueCacheSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(fetchProjectIssue, "fetchProjectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(setProjectIssue, "setProjectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(fetchProjectIssueSuccess, "fetchProjectIssueSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(fetchProjectIssues, "fetchProjectIssues", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(fetchProjectIssuesSuccess, "fetchProjectIssuesSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(showProjectIssueMessage, "showProjectIssueMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(addFavouriteProjectIssue, "addFavouriteProjectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(addFavouriteProjectIssueSuccess, "addFavouriteProjectIssueSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(onProjectIssueSelect, "onProjectIssueSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(onAddProjectIssue, "onAddProjectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(onAddJiraProjectIssue, "onAddJiraProjectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(onProjectIssueClose, "onProjectIssueClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(onJiraProjectIssueClose, "onJiraProjectIssueClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(onFilterProjectIssueOptionSelect, "onFilterProjectIssueOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(onSaveProjectIssue, "onSaveProjectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(onSaveJiraProjectIssue, "onSaveJiraProjectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(onSaveProjectIssueSuccess, "onSaveProjectIssueSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(onDeleteProjectIssue, "onDeleteProjectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(onDeleteProjectIssueSuccess, "onDeleteProjectIssueSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(onFilterSelectedProjectIssue, "onFilterSelectedProjectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(filterProjectIssue, "filterProjectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(getAllProjectIssue, "getAllProjectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllProjectIssue, "getUnselectedAllProjectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(onAllProjectIssueSelect, "onAllProjectIssueSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(updateSearchProjectIssue, "updateSearchProjectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(onToggleProjectIssueDrawer, "onToggleProjectIssueDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(handleProjectIssueRequestClose, "handleProjectIssueRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(showProjectIssueLoader, "showProjectIssueLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(hideProjectIssueLoader, "hideProjectIssueLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/projectIssue.js");
}();

;

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addLocaleData", function() { return addLocaleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intlShape", function() { return intlShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectIntl", function() { return injectIntl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defineMessages", function() { return defineMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntlProvider", function() { return IntlProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedDate", function() { return FormattedDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedTime", function() { return FormattedTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedRelative", function() { return FormattedRelative; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedNumber", function() { return FormattedNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedPlural", function() { return FormattedPlural; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedMessage", function() { return FormattedMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedHTMLMessage", function() { return FormattedHTMLMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_intl_format_cache__ = __webpack_require__(1302);
/*
 * Copyright 2019, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */










// GENERATED FILE
var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
    var s = String(n).split("."),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function addLocaleData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var locales = Array.isArray(data) ? data : [data];

  locales.forEach(function (localeData) {
    if (localeData && localeData.locale) {
      __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__addLocaleData(localeData);
      __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__addLocaleData(localeData);
    }
  });
}

function hasLocaleData(locale) {
  var localeParts = (locale || '').split('-');

  while (localeParts.length > 0) {
    if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
      return true;
    }

    localeParts.pop();
  }

  return false;
}

function hasIMFAndIRFLocaleData(locale) {
  var normalizedLocale = locale && locale.toLowerCase();

  return !!(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__localeData__[normalizedLocale] && __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__localeData__[normalizedLocale]);
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var bool = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool;
var number = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number;
var string = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string;
var func = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func;
var object = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object;
var oneOf = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf;
var shape = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape;
var any = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any;
var oneOfType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType;

var localeMatcher = oneOf(['best fit', 'lookup']);
var narrowShortLong = oneOf(['narrow', 'short', 'long']);
var numeric2digit = oneOf(['numeric', '2-digit']);
var funcReq = func.isRequired;

var intlConfigPropTypes = {
  locale: string,
  timeZone: string,
  formats: object,
  messages: object,
  textComponent: any,

  defaultLocale: string,
  defaultFormats: object,

  onError: func
};

var intlFormatPropTypes = {
  formatDate: funcReq,
  formatTime: funcReq,
  formatRelative: funcReq,
  formatNumber: funcReq,
  formatPlural: funcReq,
  formatMessage: funcReq,
  formatHTMLMessage: funcReq
};

var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
  formatters: object,
  now: funcReq
}));

var messageDescriptorPropTypes = {
  id: string.isRequired,
  description: oneOfType([string, object]),
  defaultMessage: string
};

var dateTimeFormatPropTypes = {
  localeMatcher: localeMatcher,
  formatMatcher: oneOf(['basic', 'best fit']),

  timeZone: string,
  hour12: bool,

  weekday: narrowShortLong,
  era: narrowShortLong,
  year: numeric2digit,
  month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
  day: numeric2digit,
  hour: numeric2digit,
  minute: numeric2digit,
  second: numeric2digit,
  timeZoneName: oneOf(['short', 'long'])
};

var numberFormatPropTypes = {
  localeMatcher: localeMatcher,

  style: oneOf(['decimal', 'currency', 'percent']),
  currency: string,
  currencyDisplay: oneOf(['symbol', 'code', 'name']),
  useGrouping: bool,

  minimumIntegerDigits: number,
  minimumFractionDigits: number,
  maximumFractionDigits: number,
  minimumSignificantDigits: number,
  maximumSignificantDigits: number
};

var relativeFormatPropTypes = {
  style: oneOf(['best fit', 'numeric']),
  units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year', 'second-short', 'minute-short', 'hour-short', 'day-short', 'month-short', 'year-short'])
};

var pluralFormatPropTypes = {
  style: oneOf(['cardinal', 'ordinal'])
};

/*
HTML escaping and shallow-equals implementations are the same as React's
(on purpose.) Therefore, it has the following Copyright and Licensing:

Copyright 2013-2014, Facebook, Inc.
All rights reserved.

This source code is licensed under the BSD-style license found in the LICENSE
file in the root directory of React's source tree.
*/

var intlConfigPropNames = Object.keys(intlConfigPropTypes);

var ESCAPED_CHARS = {
  '&': '&amp;',
  '>': '&gt;',
  '<': '&lt;',
  '"': '&quot;',
  "'": '&#x27;'
};

var UNSAFE_CHARS_REGEX = /[&><"']/g;

function escape(str) {
  return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
    return ESCAPED_CHARS[match];
  });
}

function filterProps(props, whitelist) {
  var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return whitelist.reduce(function (filtered, name) {
    if (props.hasOwnProperty(name)) {
      filtered[name] = props[name];
    } else if (defaults$$1.hasOwnProperty(name)) {
      filtered[name] = defaults$$1[name];
    }

    return filtered;
  }, {});
}

function invariantIntlContext() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      intl = _ref.intl;

  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
}

function shallowEquals(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
  var props = _ref2.props,
      state = _ref2.state,
      _ref2$context = _ref2.context,
      context = _ref2$context === undefined ? {} : _ref2$context;
  var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _context$intl = context.intl,
      intl = _context$intl === undefined ? {} : _context$intl;
  var _nextContext$intl = nextContext.intl,
      nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;


  return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
}

function createError(message, exception) {
  var eMsg = exception ? '\n' + exception : '';
  return '[React Intl] ' + message + eMsg;
}

function defaultErrorHandler(error) {
  if (false) {
    console.error(error);
  }
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// Inspired by react-redux's `connect()` HOC factory function implementation:
// https://github.com/rackt/react-redux

function getDisplayName(Component$$1) {
  return Component$$1.displayName || Component$$1.name || 'Component';
}

function injectIntl(WrappedComponent) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$intlPropName = options.intlPropName,
      intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
      _options$withRef = options.withRef,
      withRef = _options$withRef === undefined ? false : _options$withRef;

  var InjectIntl = function (_Component) {
    inherits(InjectIntl, _Component);

    function InjectIntl(props, context) {
      classCallCheck(this, InjectIntl);

      var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));

      invariantIntlContext(context);
      return _this;
    }

    createClass(InjectIntl, [{
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_6_invariant___default()(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');

        return this._wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
          ref: withRef ? /* istanbul ignore next */function (ref) {
            return _this2._wrappedInstance = ref;
          } : null
        }));
      }
    }]);
    return InjectIntl;
  }(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

  InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
  InjectIntl.contextTypes = {
    intl: intlShape
  };
  InjectIntl.WrappedComponent = WrappedComponent;


  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(InjectIntl, WrappedComponent);
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function defineMessages(messageDescriptors) {
  // This simply returns what's passed-in because it's meant to be a hook for
  // babel-plugin-react-intl.
  return messageDescriptors;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// This is a "hack" until a proper `intl-pluralformat` package is created.

function resolveLocale(locales) {
  // IntlMessageFormat#_resolveLocale() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._resolveLocale(locales);
}

function findPluralFunction(locale) {
  // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._findPluralRuleFunction(locale);
}

var IntlPluralFormat = function IntlPluralFormat(locales) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  classCallCheck(this, IntlPluralFormat);

  var useOrdinal = options.style === 'ordinal';
  var pluralFn = findPluralFunction(resolveLocale(locales));

  this.format = function (value) {
    return pluralFn(value, useOrdinal);
  };
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);

var RELATIVE_FORMAT_THRESHOLDS = {
  second: 60, // seconds to minute
  minute: 60, // minutes to hour
  hour: 24, // hours to day
  day: 30, // days to month
  month: 12 };

function updateRelativeFormatThresholds(newThresholds) {
  var thresholds = __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds;
  thresholds.second = newThresholds.second;
  thresholds.minute = newThresholds.minute;
  thresholds.hour = newThresholds.hour;
  thresholds.day = newThresholds.day;
  thresholds.month = newThresholds.month;
  thresholds['second-short'] = newThresholds['second-short'];
  thresholds['minute-short'] = newThresholds['minute-short'];
  thresholds['hour-short'] = newThresholds['hour-short'];
  thresholds['day-short'] = newThresholds['day-short'];
  thresholds['month-short'] = newThresholds['month-short'];
}

function getNamedFormat(formats, type, name, onError) {
  var format = formats && formats[type] && formats[type][name];
  if (format) {
    return format;
  }

  onError(createError('No ' + type + ' format named: ' + name));
}

function formatDate(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      timeZone = config.timeZone;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'date', format, onError));
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    onError(createError('Error formatting date.', e));
  }

  return String(date);
}

function formatTime(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      timeZone = config.timeZone;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'time', format, onError));
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
    // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
  }

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    onError(createError('Error formatting time.', e));
  }

  return String(date);
}

function formatRelative(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var now = new Date(options.now);
  var defaults$$1 = format && getNamedFormat(formats, 'relative', format, onError);
  var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);

  // Capture the current threshold values, then temporarily override them with
  // specific values just for this render.
  var oldThresholds = _extends({}, __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds);
  updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);

  try {
    return state.getRelativeFormat(locale, filteredOptions).format(date, {
      now: isFinite(now) ? now : state.now()
    });
  } catch (e) {
    onError(createError('Error formatting relative time.', e));
  } finally {
    updateRelativeFormatThresholds(oldThresholds);
  }

  return String(date);
}

function formatNumber(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var defaults$$1 = format && getNamedFormat(formats, 'number', format, onError);
  var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getNumberFormat(locale, filteredOptions).format(value);
  } catch (e) {
    onError(createError('Error formatting number.', e));
  }

  return String(value);
}

function formatPlural(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale;


  var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);
  var onError = config.onError || defaultErrorHandler;

  try {
    return state.getPluralFormat(locale, filteredOptions).format(value);
  } catch (e) {
    onError(createError('Error formatting plural.', e));
  }

  return 'other';
}

function formatMessage(config, state) {
  var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      messages = config.messages,
      defaultLocale = config.defaultLocale,
      defaultFormats = config.defaultFormats;
  var id = messageDescriptor.id,
      defaultMessage = messageDescriptor.defaultMessage;

  // Produce a better error if the user calls `intl.formatMessage(element)`

  if (false) {
    invariant(!isValidElement(config), '[React Intl] Don\'t pass React elements to ' + 'formatMessage(), pass `.props`.');
  }

  // `id` is a required field of a Message Descriptor.
  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(id, '[React Intl] An `id` must be provided to format a message.');

  var message = messages && messages[id];
  var hasValues = Object.keys(values).length > 0;

  // Avoid expensive message formatting for simple messages without values. In
  // development messages will always be formatted in case of missing values.
  if (!hasValues && "production" === 'production') {
    return message || defaultMessage || id;
  }

  var formattedMessage = void 0;
  var onError = config.onError || defaultErrorHandler;

  if (message) {
    try {
      var formatter = state.getMessageFormat(message, locale, formats);

      formattedMessage = formatter.format(values);
    } catch (e) {
      onError(createError('Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''), e));
    }
  } else {
    // This prevents warnings from littering the console in development
    // when no `messages` are passed into the <IntlProvider> for the
    // default locale, and a default message is in the source.
    if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
      onError(createError('Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '')));
    }
  }

  if (!formattedMessage && defaultMessage) {
    try {
      var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);

      formattedMessage = _formatter.format(values);
    } catch (e) {
      onError(createError('Error formatting the default message for: "' + id + '"', e));
    }
  }

  if (!formattedMessage) {
    onError(createError('Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.')));
  }

  return formattedMessage || message || defaultMessage || id;
}

function formatHTMLMessage(config, state, messageDescriptor) {
  var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  // Process all the values before they are used when formatting the ICU
  // Message string. Since the formatted message might be injected via
  // `innerHTML`, all String-based values need to be HTML-escaped.
  var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
    var value = rawValues[name];
    escaped[name] = typeof value === 'string' ? escape(value) : value;
    return escaped;
  }, {});

  return formatMessage(config, state, messageDescriptor, escapedValues);
}



var format = Object.freeze({
	formatDate: formatDate,
	formatTime: formatTime,
	formatRelative: formatRelative,
	formatNumber: formatNumber,
	formatPlural: formatPlural,
	formatMessage: formatMessage,
	formatHTMLMessage: formatHTMLMessage
});

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
var intlFormatPropNames = Object.keys(intlFormatPropTypes);

// These are not a static property on the `IntlProvider` class so the intl
// config values can be inherited from an <IntlProvider> ancestor.
var defaultProps = {
  formats: {},
  messages: {},
  timeZone: null,
  textComponent: 'span',

  defaultLocale: 'en',
  defaultFormats: {},

  onError: defaultErrorHandler
};

var IntlProvider = function (_Component) {
  inherits(IntlProvider, _Component);

  function IntlProvider(props) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, IntlProvider);

    var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));

    __WEBPACK_IMPORTED_MODULE_6_invariant___default()(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');

    var intlContext = context.intl;

    // Used to stabilize time when performing an initial rendering so that
    // all relative times use the same reference "now" time.

    var initialNow = void 0;
    if (isFinite(props.initialNow)) {
      initialNow = Number(props.initialNow);
    } else {
      // When an `initialNow` isn't provided via `props`, look to see an
      // <IntlProvider> exists in the ancestry and call its `now()`
      // function to propagate its value for "now".
      initialNow = intlContext ? intlContext.now() : Date.now();
    }

    // Creating `Intl*` formatters is expensive. If there's a parent
    // `<IntlProvider>`, then its formatters will be used. Otherwise, this
    // memoize the `Intl*` constructors and cache them for the lifecycle of
    // this IntlProvider instance.

    var _ref = intlContext || {},
        _ref$formatters = _ref.formatters,
        formatters = _ref$formatters === undefined ? {
      getDateTimeFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(Intl.DateTimeFormat),
      getNumberFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(Intl.NumberFormat),
      getMessageFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a),
      getRelativeFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a),
      getPluralFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(IntlPluralFormat)
    } : _ref$formatters;

    _this.state = _extends({}, formatters, {

      // Wrapper to provide stable "now" time for initial render.
      now: function now() {
        return _this._didDisplay ? Date.now() : initialNow;
      }
    });
    return _this;
  }

  createClass(IntlProvider, [{
    key: 'getConfig',
    value: function getConfig() {
      var intlContext = this.context.intl;

      // Build a whitelisted config object from `props`, defaults, and
      // `context.intl`, if an <IntlProvider> exists in the ancestry.

      var config = filterProps(this.props, intlConfigPropNames$1, intlContext);

      // Apply default props. This must be applied last after the props have
      // been resolved and inherited from any <IntlProvider> in the ancestry.
      // This matches how React resolves `defaultProps`.
      for (var propName in defaultProps) {
        if (config[propName] === undefined) {
          config[propName] = defaultProps[propName];
        }
      }

      if (!hasLocaleData(config.locale)) {
        var _config = config,
            locale = _config.locale,
            defaultLocale = _config.defaultLocale,
            defaultFormats = _config.defaultFormats,
            onError = _config.onError;


        onError(createError('Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.')));

        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        config = _extends({}, config, {
          locale: defaultLocale,
          formats: defaultFormats,
          messages: defaultProps.messages
        });
      }

      return config;
    }
  }, {
    key: 'getBoundFormatFns',
    value: function getBoundFormatFns(config, state) {
      return intlFormatPropNames.reduce(function (boundFormatFns, name) {
        boundFormatFns[name] = format[name].bind(null, config, state);
        return boundFormatFns;
      }, {});
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      var config = this.getConfig();

      // Bind intl factories and current config to the format functions.
      var boundFormatFns = this.getBoundFormatFns(config, this.state);

      var _state = this.state,
          now = _state.now,
          formatters = objectWithoutProperties(_state, ['now']);


      return {
        intl: _extends({}, config, boundFormatFns, {
          formatters: formatters,
          now: now
        })
      };
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._didDisplay = true;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react__["Children"].only(this.props.children);
    }
  }]);
  return IntlProvider;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

IntlProvider.displayName = 'IntlProvider';
IntlProvider.contextTypes = {
  intl: intlShape
};
IntlProvider.childContextTypes = {
  intl: intlShape.isRequired
};
 false ? IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
  children: PropTypes.element.isRequired,
  initialNow: PropTypes.any
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedDate = function (_Component) {
  inherits(FormattedDate, _Component);

  function FormattedDate(props, context) {
    classCallCheck(this, FormattedDate);

    var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedDate, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatDate = _context$intl.formatDate,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedDate = formatDate(value, this.props);

      if (typeof children === 'function') {
        return children(formattedDate);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedDate
      );
    }
  }]);
  return FormattedDate;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedDate.displayName = 'FormattedDate';
FormattedDate.contextTypes = {
  intl: intlShape
};
 false ? FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedTime = function (_Component) {
  inherits(FormattedTime, _Component);

  function FormattedTime(props, context) {
    classCallCheck(this, FormattedTime);

    var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedTime, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatTime = _context$intl.formatTime,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedTime = formatTime(value, this.props);

      if (typeof children === 'function') {
        return children(formattedTime);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedTime
      );
    }
  }]);
  return FormattedTime;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedTime.displayName = 'FormattedTime';
FormattedTime.contextTypes = {
  intl: intlShape
};
 false ? FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var SECOND = 1000;
var MINUTE = 1000 * 60;
var HOUR = 1000 * 60 * 60;
var DAY = 1000 * 60 * 60 * 24;

// The maximum timer delay value is a 32-bit signed integer.
// See: https://mdn.io/setTimeout
var MAX_TIMER_DELAY = 2147483647;

function selectUnits(delta) {
  var absDelta = Math.abs(delta);

  if (absDelta < MINUTE) {
    return 'second';
  }

  if (absDelta < HOUR) {
    return 'minute';
  }

  if (absDelta < DAY) {
    return 'hour';
  }

  // The maximum scheduled delay will be measured in days since the maximum
  // timer delay is less than the number of milliseconds in 25 days.
  return 'day';
}

function getUnitDelay(units) {
  switch (units) {
    case 'second':
      return SECOND;
    case 'minute':
      return MINUTE;
    case 'hour':
      return HOUR;
    case 'day':
      return DAY;
    default:
      return MAX_TIMER_DELAY;
  }
}

function isSameDate(a, b) {
  if (a === b) {
    return true;
  }

  var aTime = new Date(a).getTime();
  var bTime = new Date(b).getTime();

  return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
}

var FormattedRelative = function (_Component) {
  inherits(FormattedRelative, _Component);

  function FormattedRelative(props, context) {
    classCallCheck(this, FormattedRelative);

    var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));

    invariantIntlContext(context);

    var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();

    // `now` is stored as state so that `render()` remains a function of
    // props + state, instead of accessing `Date.now()` inside `render()`.
    _this.state = { now: now };
    return _this;
  }

  createClass(FormattedRelative, [{
    key: 'scheduleNextUpdate',
    value: function scheduleNextUpdate(props, state) {
      var _this2 = this;

      // Cancel and pending update because we're scheduling a new update.
      clearTimeout(this._timer);

      var value = props.value,
          units = props.units,
          updateInterval = props.updateInterval;

      var time = new Date(value).getTime();

      // If the `updateInterval` is falsy, including `0` or we don't have a
      // valid date, then auto updates have been turned off, so we bail and
      // skip scheduling an update.
      if (!updateInterval || !isFinite(time)) {
        return;
      }

      var delta = time - state.now;
      var unitDelay = getUnitDelay(units || selectUnits(delta));
      var unitRemainder = Math.abs(delta % unitDelay);

      // We want the largest possible timer delay which will still display
      // accurate information while reducing unnecessary re-renders. The delay
      // should be until the next "interesting" moment, like a tick from
      // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
      var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);

      this._timer = setTimeout(function () {
        _this2.setState({ now: _this2.context.intl.now() });
      }, delay);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scheduleNextUpdate(this.props, this.state);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var nextValue = _ref.value;

      // When the `props.value` date changes, `state.now` needs to be updated,
      // and the next update can be rescheduled.
      if (!isSameDate(nextValue, this.props.value)) {
        this.setState({ now: this.context.intl.now() });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      this.scheduleNextUpdate(nextProps, nextState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this._timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatRelative = _context$intl.formatRelative,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));

      if (typeof children === 'function') {
        return children(formattedRelative);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedRelative
      );
    }
  }]);
  return FormattedRelative;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedRelative.displayName = 'FormattedRelative';
FormattedRelative.contextTypes = {
  intl: intlShape
};
FormattedRelative.defaultProps = {
  updateInterval: 1000 * 10
};
 false ? FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  updateInterval: PropTypes.number,
  initialNow: PropTypes.any,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedNumber = function (_Component) {
  inherits(FormattedNumber, _Component);

  function FormattedNumber(props, context) {
    classCallCheck(this, FormattedNumber);

    var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedNumber, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatNumber = _context$intl.formatNumber,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedNumber = formatNumber(value, this.props);

      if (typeof children === 'function') {
        return children(formattedNumber);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedNumber
      );
    }
  }]);
  return FormattedNumber;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedNumber.displayName = 'FormattedNumber';
FormattedNumber.contextTypes = {
  intl: intlShape
};
 false ? FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedPlural = function (_Component) {
  inherits(FormattedPlural, _Component);

  function FormattedPlural(props, context) {
    classCallCheck(this, FormattedPlural);

    var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedPlural, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatPlural = _context$intl.formatPlural,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          other = _props.other,
          children = _props.children;


      var pluralCategory = formatPlural(value, this.props);
      var formattedPlural = this.props[pluralCategory] || other;

      if (typeof children === 'function') {
        return children(formattedPlural);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedPlural
      );
    }
  }]);
  return FormattedPlural;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedPlural.displayName = 'FormattedPlural';
FormattedPlural.contextTypes = {
  intl: intlShape
};
FormattedPlural.defaultProps = {
  style: 'cardinal'
};
 false ? FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
  value: PropTypes.any.isRequired,

  other: PropTypes.node.isRequired,
  zero: PropTypes.node,
  one: PropTypes.node,
  two: PropTypes.node,
  few: PropTypes.node,
  many: PropTypes.node,

  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var defaultFormatMessage = function defaultFormatMessage(descriptor, values) {
  if (false) {
    console.error('[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry. Using default message as fallback.');
  }
  return formatMessage({}, { getMessageFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a) }, descriptor, values);
};

var FormattedMessage = function (_Component) {
  inherits(FormattedMessage, _Component);

  function FormattedMessage(props, context) {
    classCallCheck(this, FormattedMessage);

    var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));

    if (!props.defaultMessage) {
      invariantIntlContext(context);
    }
    return _this;
  }

  createClass(FormattedMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _ref = this.context.intl || {},
          _ref$formatMessage = _ref.formatMessage,
          formatMessage$$1 = _ref$formatMessage === undefined ? defaultFormatMessage : _ref$formatMessage,
          _ref$textComponent = _ref.textComponent,
          Text = _ref$textComponent === undefined ? 'span' : _ref$textComponent;

      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          values = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var tokenDelimiter = void 0;
      var tokenizedValues = void 0;
      var elements = void 0;

      var hasValues = values && Object.keys(values).length > 0;
      if (hasValues) {
        // Creates a token with a random UID that should not be guessable or
        // conflict with other parts of the `message` string.
        var uid = Math.floor(Math.random() * 0x10000000000).toString(16);

        var generateToken = function () {
          var counter = 0;
          return function () {
            return 'ELEMENT-' + uid + '-' + (counter += 1);
          };
        }();

        // Splitting with a delimiter to support IE8. When using a regex
        // with a capture group IE8 does not include the capture group in
        // the resulting array.
        tokenDelimiter = '@__' + uid + '__@';
        tokenizedValues = {};
        elements = {};

        // Iterates over the `props` to keep track of any React Element
        // values so they can be represented by the `token` as a placeholder
        // when the `message` is formatted. This allows the formatted
        // message to then be broken-up into parts with references to the
        // React Elements inserted back in.
        Object.keys(values).forEach(function (name) {
          var value = values[name];

          if (Object(__WEBPACK_IMPORTED_MODULE_4_react__["isValidElement"])(value)) {
            var token = generateToken();
            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
            elements[token] = value;
          } else {
            tokenizedValues[name] = value;
          }
        });
      }

      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedMessage = formatMessage$$1(descriptor, tokenizedValues || values);

      var nodes = void 0;

      var hasElements = elements && Object.keys(elements).length > 0;
      if (hasElements) {
        // Split the message into parts so the React Element values captured
        // above can be inserted back into the rendered message. This
        // approach allows messages to render with React Elements while
        // keeping React's virtual diffing working properly.
        nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
          return !!part;
        }).map(function (part) {
          return elements[part] || part;
        });
      } else {
        nodes = [formattedMessage];
      }

      if (typeof children === 'function') {
        return children.apply(undefined, toConsumableArray(nodes));
      }

      // Needs to use `createElement()` instead of JSX, otherwise React will
      // warn about a missing `key` prop with rich-text message formatting.
      return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"].apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
    }
  }]);
  return FormattedMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedMessage.displayName = 'FormattedMessage';
FormattedMessage.contextTypes = {
  intl: intlShape
};
FormattedMessage.defaultProps = {
  values: {}
};
 false ? FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedHTMLMessage = function (_Component) {
  inherits(FormattedHTMLMessage, _Component);

  function FormattedHTMLMessage(props, context) {
    classCallCheck(this, FormattedHTMLMessage);

    var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedHTMLMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatHTMLMessage = _context$intl.formatHTMLMessage,
          Text = _context$intl.textComponent;
      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          rawValues = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);

      if (typeof children === 'function') {
        return children(formattedHTMLMessage);
      }

      // Since the message presumably has HTML in it, we need to set
      // `innerHTML` in order for it to be rendered and not escaped by React.
      // To be safe, all string prop values were escaped when formatting the
      // message. It is assumed that the message is not UGC, and came from the
      // developer making it more like a template.
      //
      // Note: There's a perf impact of using this component since there's no
      // way for React to do its virtual DOM diffing.
      var html = { __html: formattedHTMLMessage };
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component$$1, { dangerouslySetInnerHTML: html });
    }
  }]);
  return FormattedHTMLMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
FormattedHTMLMessage.contextTypes = {
  intl: intlShape
};
FormattedHTMLMessage.defaultProps = {
  values: {}
};
 false ? FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(defaultLocaleData);

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default.a);




/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(9);








var propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  'aria-label': __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  block: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  outline: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_7__utils__["tagPropType"],
  innerRef: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),
  onClick: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  size: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  close: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var defaultProps = {
  color: 'secondary',
  tag: 'button'
};

var Button =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Button, _React$Component);

  function Button(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.onClick = _this.onClick.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = Button.prototype;

  _proto.onClick = function onClick(e) {
    if (this.props.disabled) {
      e.preventDefault();
      return;
    }

    if (this.props.onClick) {
      this.props.onClick(e);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        active = _this$props.active,
        ariaLabel = _this$props['aria-label'],
        block = _this$props.block,
        className = _this$props.className,
        close = _this$props.close,
        cssModule = _this$props.cssModule,
        color = _this$props.color,
        outline = _this$props.outline,
        size = _this$props.size,
        Tag = _this$props.tag,
        innerRef = _this$props.innerRef,
        attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["active", "aria-label", "block", "className", "close", "cssModule", "color", "outline", "size", "tag", "innerRef"]);

    if (close && typeof attributes.children === 'undefined') {
      attributes.children = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", {
        "aria-hidden": true
      }, "\xD7");
    }

    var btnOutlineColor = "btn" + (outline ? '-outline' : '') + "-" + color;
    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, {
      close: close
    }, close || 'btn', close || btnOutlineColor, size ? "btn-" + size : false, block ? 'btn-block' : false, {
      active: active,
      disabled: this.props.disabled
    }), cssModule);

    if (attributes.href && Tag === 'button') {
      Tag = 'a';
    }

    var defaultAriaLabel = close ? 'Close' : null;
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      type: Tag === 'button' && attributes.onClick ? 'button' : undefined
    }, attributes, {
      className: classes,
      ref: innerRef,
      onClick: this.onClick,
      "aria-label": ariaLabel || defaultAriaLabel
    }));
  };

  return Button;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_transition_group__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(9);









var propTypes = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_6_react_transition_group__["Transition"].propTypes, {
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node]),
  tag: __WEBPACK_IMPORTED_MODULE_7__utils__["tagPropType"],
  baseClass: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  baseClassActive: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  innerRef: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func])
});

var defaultProps = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_6_react_transition_group__["Transition"].defaultProps, {
  tag: 'div',
  baseClass: 'fade',
  baseClassActive: 'show',
  timeout: __WEBPACK_IMPORTED_MODULE_7__utils__["TransitionTimeouts"].Fade,
  appear: true,
  enter: true,
  exit: true,
  in: true
});

function Fade(props) {
  var Tag = props.tag,
      baseClass = props.baseClass,
      baseClassActive = props.baseClassActive,
      className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      innerRef = props.innerRef,
      otherProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["tag", "baseClass", "baseClassActive", "className", "cssModule", "children", "innerRef"]);

  var transitionProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils__["pick"])(otherProps, __WEBPACK_IMPORTED_MODULE_7__utils__["TransitionPropTypeKeys"]);
  var childProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils__["omit"])(otherProps, __WEBPACK_IMPORTED_MODULE_7__utils__["TransitionPropTypeKeys"]);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_transition_group__["Transition"], transitionProps, function (status) {
    var isActive = status === 'entered';
    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, baseClass, isActive && baseClassActive), cssModule);
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      className: classes
    }, childProps, {
      ref: innerRef
    }), children);
  });
}

Fade.propTypes = propTypes;
Fade.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Fade);

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_transition_group__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(9);











var CarouselItem =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(CarouselItem, _React$Component);

  function CarouselItem(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      startAnimation: false
    };
    _this.onEnter = _this.onEnter.bind(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.onEntering = _this.onEntering.bind(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.onExit = _this.onExit.bind(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.onExiting = _this.onExiting.bind(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.onExited = _this.onExited.bind(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = CarouselItem.prototype;

  _proto.onEnter = function onEnter(node, isAppearing) {
    this.setState({
      startAnimation: false
    });
    this.props.onEnter(node, isAppearing);
  };

  _proto.onEntering = function onEntering(node, isAppearing) {
    // getting this variable triggers a reflow
    var offsetHeight = node.offsetHeight;
    this.setState({
      startAnimation: true
    });
    this.props.onEntering(node, isAppearing);
    return offsetHeight;
  };

  _proto.onExit = function onExit(node) {
    this.setState({
      startAnimation: false
    });
    this.props.onExit(node);
  };

  _proto.onExiting = function onExiting(node) {
    this.setState({
      startAnimation: true
    });
    node.dispatchEvent(new CustomEvent('slide.bs.carousel'));
    this.props.onExiting(node);
  };

  _proto.onExited = function onExited(node) {
    node.dispatchEvent(new CustomEvent('slid.bs.carousel'));
    this.props.onExited(node);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        isIn = _this$props.in,
        children = _this$props.children,
        cssModule = _this$props.cssModule,
        slide = _this$props.slide,
        Tag = _this$props.tag,
        className = _this$props.className,
        transitionProps = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["in", "children", "cssModule", "slide", "tag", "className"]);

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_transition_group__["Transition"], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, transitionProps, {
      enter: slide,
      exit: slide,
      in: isIn,
      onEnter: this.onEnter,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }), function (status) {
      var direction = _this2.context.direction;
      var isActive = status === __WEBPACK_IMPORTED_MODULE_9__utils__["TransitionStatuses"].ENTERED || status === __WEBPACK_IMPORTED_MODULE_9__utils__["TransitionStatuses"].EXITING;
      var directionClassName = (status === __WEBPACK_IMPORTED_MODULE_9__utils__["TransitionStatuses"].ENTERING || status === __WEBPACK_IMPORTED_MODULE_9__utils__["TransitionStatuses"].EXITING) && _this2.state.startAnimation && (direction === 'right' ? 'carousel-item-left' : 'carousel-item-right');
      var orderClassName = status === __WEBPACK_IMPORTED_MODULE_9__utils__["TransitionStatuses"].ENTERING && (direction === 'right' ? 'carousel-item-next' : 'carousel-item-prev');
      var itemClasses = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_7_classnames___default()(className, 'carousel-item', isActive && 'active', directionClassName, orderClassName), cssModule);
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Tag, {
        className: itemClasses
      }, children);
    });
  };

  return CarouselItem;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

CarouselItem.propTypes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_8_react_transition_group__["Transition"].propTypes, {
  tag: __WEBPACK_IMPORTED_MODULE_9__utils__["tagPropType"],
  in: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
  slide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
});
CarouselItem.defaultProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_8_react_transition_group__["Transition"].defaultProps, {
  tag: 'div',
  timeout: __WEBPACK_IMPORTED_MODULE_9__utils__["TransitionTimeouts"].Carousel,
  slide: true
});
CarouselItem.contextTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (CarouselItem);

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(1447);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(184);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 372 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 373 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 374 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(376)('keys');
var uid = __webpack_require__(270);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(61);
var global = __webpack_require__(119);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(269) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 377 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 378 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(183);
var dPs = __webpack_require__(1458);
var enumBugKeys = __webpack_require__(377);
var IE_PROTO = __webpack_require__(375)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(689)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(1459).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(120).f;
var has = __webpack_require__(148);
var TAG = __webpack_require__(90)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(90);


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(119);
var core = __webpack_require__(61);
var LIBRARY = __webpack_require__(269);
var wksExt = __webpack_require__(381);
var defineProperty = __webpack_require__(120).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(271);
var createDesc = __webpack_require__(215);
var toIObject = __webpack_require__(149);
var toPrimitive = __webpack_require__(371);
var has = __webpack_require__(148);
var IE8_DOM_DEFINE = __webpack_require__(688);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(121) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(273);
var IE8_DOM_DEFINE = __webpack_require__(702);
var toPrimitive = __webpack_require__(385);
var dP = Object.defineProperty;

exports.f = __webpack_require__(187) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(186);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 386 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 387 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 388 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(1526);
var defined = __webpack_require__(390);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 390 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 391 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(22);
var defined = __webpack_require__(390);
var fails = __webpack_require__(122);
var spaces = __webpack_require__(393);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 393 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniqBy__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DefaultLegendContent__ = __webpack_require__(1553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_DataUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__ = __webpack_require__(12);



function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Legend
 */






var defaultUniqBy = function defaultUniqBy(entry) {
  return entry.value;
};

var getUniqPaylod = function getUniqPaylod(option, payload) {
  if (option === true) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_uniqBy___default()(payload, defaultUniqBy);
  }

  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_uniqBy___default()(payload, option);
  }

  return payload;
};

var renderContent = function renderContent(content, props) {
  if (__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(content)) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(content, props);
  }

  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(content)) {
    return content(props);
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DefaultLegendContent__["a" /* default */], props);
};

var EPS = 1;
var ICON_TYPES = __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["b" /* LEGEND_TYPES */].filter(function (type) {
  return type !== 'none';
});

var Legend =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Legend, _PureComponent);

  function Legend() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Legend);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Legend)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      boxWidth: -1,
      boxHeight: -1
    };
    return _this;
  }

  _createClass(Legend, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateBBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateBBox();
    }
  }, {
    key: "getBBox",
    value: function getBBox() {
      var _this$state = this.state,
          boxWidth = _this$state.boxWidth,
          boxHeight = _this$state.boxHeight;

      if (boxWidth >= 0 && boxHeight >= 0) {
        return {
          width: boxWidth,
          height: boxHeight
        };
      }

      return null;
    }
  }, {
    key: "getDefaultPosition",
    value: function getDefaultPosition(style) {
      var _this$props = this.props,
          layout = _this$props.layout,
          align = _this$props.align,
          verticalAlign = _this$props.verticalAlign,
          margin = _this$props.margin,
          chartWidth = _this$props.chartWidth,
          chartHeight = _this$props.chartHeight;
      var hPos, vPos;

      if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
        if (align === 'center' && layout === 'vertical') {
          var box = this.getBBox() || {
            width: 0
          };
          hPos = {
            left: ((chartWidth || 0) - box.width) / 2
          };
        } else {
          hPos = align === 'right' ? {
            right: margin && margin.right || 0
          } : {
            left: margin && margin.left || 0
          };
        }
      }

      if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
        if (verticalAlign === 'middle') {
          var _box = this.getBBox() || {
            height: 0
          };

          vPos = {
            top: ((chartHeight || 0) - _box.height) / 2
          };
        } else {
          vPos = verticalAlign === 'bottom' ? {
            bottom: margin && margin.bottom || 0
          } : {
            top: margin && margin.top || 0
          };
        }
      }

      return _objectSpread({}, hPos, {}, vPos);
    }
  }, {
    key: "updateBBox",
    value: function updateBBox() {
      var _this$state2 = this.state,
          boxWidth = _this$state2.boxWidth,
          boxHeight = _this$state2.boxHeight;
      var onBBoxUpdate = this.props.onBBoxUpdate;

      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var box = this.wrapperNode.getBoundingClientRect();

        if (Math.abs(box.width - boxWidth) > EPS || Math.abs(box.height - boxHeight) > EPS) {
          this.setState({
            boxWidth: box.width,
            boxHeight: box.height
          }, function () {
            if (onBBoxUpdate) {
              onBBoxUpdate(box);
            }
          });
        }
      } else if (boxWidth !== -1 || boxHeight !== -1) {
        this.setState({
          boxWidth: -1,
          boxHeight: -1
        }, function () {
          if (onBBoxUpdate) {
            onBBoxUpdate(null);
          }
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          content = _this$props2.content,
          width = _this$props2.width,
          height = _this$props2.height,
          wrapperStyle = _this$props2.wrapperStyle,
          paylodUniqBy = _this$props2.paylodUniqBy,
          payload = _this$props2.payload;

      var outerStyle = _objectSpread({
        position: 'absolute',
        width: width || 'auto',
        height: height || 'auto'
      }, this.getDefaultPosition(wrapperStyle), {}, wrapperStyle);

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
        className: "recharts-legend-wrapper",
        style: outerStyle,
        ref: function ref(node) {
          _this2.wrapperNode = node;
        }
      }, renderContent(content, _objectSpread({}, this.props, {
        payload: getUniqPaylod(paylodUniqBy, payload)
      })));
    }
  }], [{
    key: "getWithHeight",
    value: function getWithHeight(item, chartWidth) {
      var layout = item.props.layout;

      if (layout === 'vertical' && Object(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["h" /* isNumber */])(item.props.height)) {
        return {
          height: item.props.height
        };
      }

      if (layout === 'horizontal') {
        return {
          width: item.props.width || chartWidth
        };
      }

      return null;
    }
  }]);

  return Legend;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);

Legend.displayName = 'Legend';
Legend.propTypes = {
  content: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func]),
  wrapperStyle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  chartWidth: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  chartHeight: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  iconSize: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  iconType: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(ICON_TYPES),
  layout: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['horizontal', 'vertical']),
  align: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['center', 'left', 'right']),
  verticalAlign: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['top', 'bottom', 'middle']),
  margin: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    top: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    left: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    bottom: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    right: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number
  }),
  payload: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    value: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,
    id: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,
    type: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["b" /* LEGEND_TYPES */])
  })),
  paylodUniqBy: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool]),
  formatter: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onBBoxUpdate: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
};
Legend.defaultProps = {
  iconSize: 14,
  layout: 'horizontal',
  align: 'center',
  verticalAlign: 'bottom'
};
/* harmony default export */ __webpack_exports__["a"] = (Legend);

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_shape__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__ = __webpack_require__(12);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Curve
 */





var SYMBOL_FACTORIES = {
  symbolCircle: __WEBPACK_IMPORTED_MODULE_2_d3_shape__["u" /* symbolCircle */],
  symbolCross: __WEBPACK_IMPORTED_MODULE_2_d3_shape__["v" /* symbolCross */],
  symbolDiamond: __WEBPACK_IMPORTED_MODULE_2_d3_shape__["w" /* symbolDiamond */],
  symbolSquare: __WEBPACK_IMPORTED_MODULE_2_d3_shape__["x" /* symbolSquare */],
  symbolStar: __WEBPACK_IMPORTED_MODULE_2_d3_shape__["y" /* symbolStar */],
  symbolTriangle: __WEBPACK_IMPORTED_MODULE_2_d3_shape__["z" /* symbolTriangle */],
  symbolWye: __WEBPACK_IMPORTED_MODULE_2_d3_shape__["A" /* symbolWye */]
};
var RADIAN = Math.PI / 180;

var getSymbolFactory = function getSymbolFactory(type) {
  var name = "symbol".concat(type.slice(0, 1).toUpperCase()).concat(type.slice(1));
  return SYMBOL_FACTORIES[name] || __WEBPACK_IMPORTED_MODULE_2_d3_shape__["u" /* symbolCircle */];
};

var calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
  if (sizeType === 'area') {
    return size;
  }

  switch (type) {
    case 'cross':
      return 5 * size * size / 9;

    case 'diamond':
      return 0.5 * size * size / Math.sqrt(3);

    case 'square':
      return size * size;

    case 'star':
      {
        var angle = 18 * RADIAN;
        return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
      }

    case 'triangle':
      return Math.sqrt(3) * size * size / 4;

    case 'wye':
      return (21 - 10 * Math.sqrt(3)) * size * size / 8;

    default:
      return Math.PI * size * size / 4;
  }
};

var Symbols =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Symbols, _PureComponent);

  function Symbols() {
    _classCallCheck(this, Symbols);

    return _possibleConstructorReturn(this, _getPrototypeOf(Symbols).apply(this, arguments));
  }

  _createClass(Symbols, [{
    key: "getPath",

    /**
     * Calculate the path of curve
     * @return {String} path
     */
    value: function getPath() {
      var _this$props = this.props,
          size = _this$props.size,
          sizeType = _this$props.sizeType,
          type = _this$props.type;
      var symbolFactory = getSymbolFactory(type);
      var symbol = Object(__WEBPACK_IMPORTED_MODULE_2_d3_shape__["t" /* symbol */])().type(symbolFactory).size(calculateAreaSize(size, sizeType, type));
      return symbol();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          cx = _this$props2.cx,
          cy = _this$props2.cy,
          size = _this$props2.size;

      if (cx === +cx && cy === +cy && size === +size) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", _extends({}, Object(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["l" /* getPresentationAttributes */])(this.props), Object(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["f" /* filterEventAttributes */])(this.props), {
          className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('recharts-symbols', className),
          transform: "translate(".concat(cx, ", ").concat(cy, ")"),
          d: this.getPath()
        }));
      }

      return null;
    }
  }]);

  return Symbols;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Symbols.displayName = 'Symbols';
Symbols.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']),
  cx: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  cy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  sizeType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['area', 'diameter'])
});
Symbols.defaultProps = {
  type: 'circle',
  size: 64,
  sizeType: 'area'
};
/* harmony default export */ __webpack_exports__["a"] = (Symbols);

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arc__ = __webpack_require__(1554);
/* unused harmony reexport arc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__area__ = __webpack_require__(716);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__area__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__line__ = __webpack_require__(397);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_2__line__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pie__ = __webpack_require__(1556);
/* unused harmony reexport pie */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__areaRadial__ = __webpack_require__(1559);
/* unused harmony reexport areaRadial */
/* unused harmony reexport radialArea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lineRadial__ = __webpack_require__(718);
/* unused harmony reexport lineRadial */
/* unused harmony reexport radialLine */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pointRadial__ = __webpack_require__(719);
/* unused harmony reexport pointRadial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__link_index__ = __webpack_require__(1560);
/* unused harmony reexport linkHorizontal */
/* unused harmony reexport linkVertical */
/* unused harmony reexport linkRadial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__symbol__ = __webpack_require__(1561);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_8__symbol__["a"]; });
/* unused harmony reexport symbols */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__symbol_circle__ = __webpack_require__(721);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_9__symbol_circle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__symbol_cross__ = __webpack_require__(722);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_10__symbol_cross__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__symbol_diamond__ = __webpack_require__(723);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_11__symbol_diamond__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__symbol_square__ = __webpack_require__(725);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_12__symbol_square__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__symbol_star__ = __webpack_require__(724);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_13__symbol_star__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__symbol_triangle__ = __webpack_require__(726);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_14__symbol_triangle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__symbol_wye__ = __webpack_require__(727);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_15__symbol_wye__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__curve_basisClosed__ = __webpack_require__(1562);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_16__curve_basisClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__curve_basisOpen__ = __webpack_require__(1563);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_17__curve_basisOpen__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__curve_basis__ = __webpack_require__(281);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_18__curve_basis__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__curve_bundle__ = __webpack_require__(1564);
/* unused harmony reexport curveBundle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__curve_cardinalClosed__ = __webpack_require__(728);
/* unused harmony reexport curveCardinalClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__curve_cardinalOpen__ = __webpack_require__(729);
/* unused harmony reexport curveCardinalOpen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__curve_cardinal__ = __webpack_require__(282);
/* unused harmony reexport curveCardinal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__curve_catmullRomClosed__ = __webpack_require__(1565);
/* unused harmony reexport curveCatmullRomClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__curve_catmullRomOpen__ = __webpack_require__(1566);
/* unused harmony reexport curveCatmullRomOpen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__curve_catmullRom__ = __webpack_require__(399);
/* unused harmony reexport curveCatmullRom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__curve_linearClosed__ = __webpack_require__(1567);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_26__curve_linearClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__curve_linear__ = __webpack_require__(279);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_27__curve_linear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__curve_monotone__ = __webpack_require__(1568);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_28__curve_monotone__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_28__curve_monotone__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__curve_natural__ = __webpack_require__(1569);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_29__curve_natural__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__curve_step__ = __webpack_require__(1570);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_30__curve_step__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_30__curve_step__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_30__curve_step__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__stack__ = __webpack_require__(1571);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_31__stack__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__offset_expand__ = __webpack_require__(1572);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_32__offset_expand__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__offset_diverging__ = __webpack_require__(1573);
/* unused harmony reexport stackOffsetDiverging */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__offset_none__ = __webpack_require__(222);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_34__offset_none__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__offset_silhouette__ = __webpack_require__(1574);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_35__offset_silhouette__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__offset_wiggle__ = __webpack_require__(1575);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_36__offset_wiggle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__order_appearance__ = __webpack_require__(730);
/* unused harmony reexport stackOrderAppearance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__order_ascending__ = __webpack_require__(400);
/* unused harmony reexport stackOrderAscending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__order_descending__ = __webpack_require__(1576);
/* unused harmony reexport stackOrderDescending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__order_insideOut__ = __webpack_require__(1577);
/* unused harmony reexport stackOrderInsideOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__order_none__ = __webpack_require__(223);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_41__order_none__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__order_reverse__ = __webpack_require__(1578);
/* unused harmony reexport stackOrderReverse */




 // Note: radialArea is deprecated!
 // Note: radialLine is deprecated!










































/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__point__ = __webpack_require__(398);





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x = __WEBPACK_IMPORTED_MODULE_3__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_3__point__["b" /* y */],
      defined = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear__["a" /* default */],
      output = null;

  function line(data) {
    var i,
        n = data.length,
        d,
        defined0 = false,
        buffer;

    if (context == null) output = curve(buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x(d, i, data), +y(d, i, data));
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  line.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), line) : x;
  };

  line.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), line) : y;
  };

  line.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(!!_), line) : defined;
  };

  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };

  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };

  return line;
});


/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = x;
/* harmony export (immutable) */ __webpack_exports__["b"] = y;
function x(p) {
  return p[0];
}

function y(p) {
  return p[1];
}


/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = point;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal__ = __webpack_require__(282);



function point(that, x, y) {
  var x1 = that._x1,
      y1 = that._y1,
      x2 = that._x2,
      y2 = that._y2;

  if (that._l01_a > __WEBPACK_IMPORTED_MODULE_0__math__["f" /* epsilon */]) {
    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
  }

  if (that._l23_a > __WEBPACK_IMPORTED_MODULE_0__math__["f" /* epsilon */]) {
    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
  }

  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}

function CatmullRom(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRom.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: this.point(this._x2, this._y2); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRom(context, alpha) : new __WEBPACK_IMPORTED_MODULE_1__cardinal__["a" /* Cardinal */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = sum;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(223);


/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var sums = series.map(sum);
  return Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).sort(function(a, b) { return sums[a] - sums[b]; });
});

function sum(series) {
  var s = 0, i = -1, n = series.length, v;
  while (++i < n) if (v = +series[i][1]) s += v;
  return s;
}


/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(224);


/* harmony default export */ __webpack_exports__["a"] = (function(values, p, valueof) {
  if (valueof == null) valueof = __WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */];
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
});


/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefix; });
var prefix = "$";

function Map() {}

Map.prototype = map.prototype = {
  constructor: Map,
  has: function(key) {
    return (prefix + key) in this;
  },
  get: function(key) {
    return this[prefix + key];
  },
  set: function(key, value) {
    this[prefix + key] = value;
    return this;
  },
  remove: function(key) {
    var property = prefix + key;
    return property in this && delete this[property];
  },
  clear: function() {
    for (var property in this) if (property[0] === prefix) delete this[property];
  },
  keys: function() {
    var keys = [];
    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
    return keys;
  },
  values: function() {
    var values = [];
    for (var property in this) if (property[0] === prefix) values.push(this[property]);
    return values;
  },
  entries: function() {
    var entries = [];
    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
    return entries;
  },
  size: function() {
    var size = 0;
    for (var property in this) if (property[0] === prefix) ++size;
    return size;
  },
  empty: function() {
    for (var property in this) if (property[0] === prefix) return false;
    return true;
  },
  each: function(f) {
    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
  }
};

function map(object, f) {
  var map = new Map;

  // Copy constructor.
  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });

  // Index array by numeric index or specified key function.
  else if (Array.isArray(object)) {
    var i = -1,
        n = object.length,
        o;

    if (f == null) while (++i < n) map.set(i, object[i]);
    else while (++i < n) map.set(f(o = object[i], i, object), o);
  }

  // Convert object to map.
  else if (object) for (var key in object) map.set(key, object[key]);

  return map;
}

/* harmony default export */ __webpack_exports__["a"] = (map);


/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rgb__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__date__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__object__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__string__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constant__ = __webpack_require__(756);









/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? Object(__WEBPACK_IMPORTED_MODULE_7__constant__["a" /* default */])(b)
      : (t === "number" ? __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]
      : t === "string" ? ((c = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]) : __WEBPACK_IMPORTED_MODULE_6__string__["a" /* default */])
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */] ? __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]
      : b instanceof Date ? __WEBPACK_IMPORTED_MODULE_3__date__["a" /* default */]
      : Array.isArray(b) ? __WEBPACK_IMPORTED_MODULE_2__array__["a" /* default */]
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? __WEBPACK_IMPORTED_MODULE_5__object__["a" /* default */]
      : __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */])(a, b);
});


/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Color;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return darker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return brighter; });
/* harmony export (immutable) */ __webpack_exports__["e"] = color;
/* harmony export (immutable) */ __webpack_exports__["h"] = rgbConvert;
/* harmony export (immutable) */ __webpack_exports__["g"] = rgb;
/* harmony export (immutable) */ __webpack_exports__["b"] = Rgb;
/* unused harmony export hslConvert */
/* harmony export (immutable) */ __webpack_exports__["f"] = hsl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define_js__ = __webpack_require__(405);


function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex = /^#([0-9a-f]{3,8})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Color, color, {
  copy: function(channels) {
    return Object.assign(new this.constructor, this, channels);
  },
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: color_formatHex, // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});

function color_formatHex() {
  return this.rgb().formatHex();
}

function color_formatHsl() {
  return hslConvert(this).formatHsl();
}

function color_formatRgb() {
  return this.rgb().formatRgb();
}

function color(format) {
  var m, l;
  format = (format + "").trim().toLowerCase();
  return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
      : l === 3 ? new Rgb((m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1) // #f00
      : l === 8 ? new Rgb(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
      : l === 4 ? new Rgb((m >> 12 & 0xf) | (m >> 8 & 0xf0), (m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), (((m & 0xf) << 4) | (m & 0xf)) / 0xff) // #f000
      : null) // invalid hex
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Rgb, rgb, Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (-0.5 <= this.r && this.r < 255.5)
        && (-0.5 <= this.g && this.g < 255.5)
        && (-0.5 <= this.b && this.b < 255.5)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: rgb_formatHex, // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));

function rgb_formatHex() {
  return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}

function rgb_formatRgb() {
  var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
  return (a === 1 ? "rgb(" : "rgba(")
      + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
      + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
      + Math.max(0, Math.min(255, Math.round(this.b) || 0))
      + (a === 1 ? ")" : ", " + a + ")");
}

function hex(value) {
  value = Math.max(0, Math.min(255, Math.round(value) || 0));
  return (value < 16 ? "0" : "") + value.toString(16);
}

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Hsl, hsl, Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  formatHsl: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "hsl(" : "hsla(")
        + (this.h || 0) + ", "
        + (this.s || 0) * 100 + "%, "
        + (this.l || 0) * 100 + "%"
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}


/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extend;
/* harmony default export */ __webpack_exports__["a"] = (function(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
});

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}


/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = basis;
function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

/* harmony default export */ __webpack_exports__["b"] = (function(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimal(1.23) returns ["123", 0].
/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
});


/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = loggish;
/* harmony export (immutable) */ __webpack_exports__["a"] = log;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nice__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__continuous__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__init__ = __webpack_require__(56);






function transformLog(x) {
  return Math.log(x);
}

function transformExp(x) {
  return Math.exp(x);
}

function transformLogn(x) {
  return -Math.log(-x);
}

function transformExpn(x) {
  return -Math.exp(-x);
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10
      : base === Math.E ? Math.exp
      : function(x) { return Math.pow(base, x); };
}

function logp(base) {
  return base === Math.E ? Math.log
      : base === 10 && Math.log10
      || base === 2 && Math.log2
      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
}

function reflect(f) {
  return function(x) {
    return -f(-x);
  };
}

function loggish(transform) {
  var scale = transform(transformLog, transformExp),
      domain = scale.domain,
      base = 10,
      logs,
      pows;

  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) {
      logs = reflect(logs), pows = reflect(pows);
      transform(transformLogn, transformExpn);
    } else {
      transform(transformLog, transformExp);
    }
    return scale;
  }

  scale.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = function(count) {
    var d = domain(),
        u = d[0],
        v = d[d.length - 1],
        r;

    if (r = v < u) i = u, u = v, v = i;

    var i = logs(u),
        j = logs(v),
        p,
        k,
        t,
        n = count == null ? 10 : +count,
        z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.round(i) - 1, j = Math.round(j) + 1;
      if (u > 0) for (; i < j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i < j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
    } else {
      z = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["h" /* ticks */])(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = function(count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* format */])(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function(d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = function() {
    return domain(Object(__WEBPACK_IMPORTED_MODULE_2__nice__["a" /* default */])(domain(), {
      floor: function(x) { return pows(Math.floor(logs(x))); },
      ceil: function(x) { return pows(Math.ceil(logs(x))); }
    }));
  };

  return scale;
}

function log() {
  var scale = loggish(Object(__WEBPACK_IMPORTED_MODULE_3__continuous__["d" /* transformer */])()).domain([1, 10]);

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_3__continuous__["a" /* copy */])(scale, log()).base(scale.base());
  };

  __WEBPACK_IMPORTED_MODULE_4__init__["b" /* initRange */].apply(scale, arguments);

  return scale;
}


/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = symlogish;
/* harmony export (immutable) */ __webpack_exports__["a"] = symlog;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__continuous__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__init__ = __webpack_require__(56);




function transformSymlog(c) {
  return function(x) {
    return Math.sign(x) * Math.log1p(Math.abs(x / c));
  };
}

function transformSymexp(c) {
  return function(x) {
    return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
  };
}

function symlogish(transform) {
  var c = 1, scale = transform(transformSymlog(c), transformSymexp(c));

  scale.constant = function(_) {
    return arguments.length ? transform(transformSymlog(c = +_), transformSymexp(c)) : c;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__linear__["b" /* linearish */])(scale);
}

function symlog() {
  var scale = symlogish(Object(__WEBPACK_IMPORTED_MODULE_1__continuous__["d" /* transformer */])());

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_1__continuous__["a" /* copy */])(scale, symlog()).constant(scale.constant());
  };

  return __WEBPACK_IMPORTED_MODULE_2__init__["b" /* initRange */].apply(scale, arguments);
}


/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = powish;
/* harmony export (immutable) */ __webpack_exports__["a"] = pow;
/* harmony export (immutable) */ __webpack_exports__["c"] = sqrt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__continuous__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__init__ = __webpack_require__(56);




function transformPow(exponent) {
  return function(x) {
    return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
  };
}

function transformSqrt(x) {
  return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}

function transformSquare(x) {
  return x < 0 ? -x * x : x * x;
}

function powish(transform) {
  var scale = transform(__WEBPACK_IMPORTED_MODULE_1__continuous__["c" /* identity */], __WEBPACK_IMPORTED_MODULE_1__continuous__["c" /* identity */]),
      exponent = 1;

  function rescale() {
    return exponent === 1 ? transform(__WEBPACK_IMPORTED_MODULE_1__continuous__["c" /* identity */], __WEBPACK_IMPORTED_MODULE_1__continuous__["c" /* identity */])
        : exponent === 0.5 ? transform(transformSqrt, transformSquare)
        : transform(transformPow(exponent), transformPow(1 / exponent));
  }

  scale.exponent = function(_) {
    return arguments.length ? (exponent = +_, rescale()) : exponent;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__linear__["b" /* linearish */])(scale);
}

function pow() {
  var scale = powish(Object(__WEBPACK_IMPORTED_MODULE_1__continuous__["d" /* transformer */])());

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_1__continuous__["a" /* copy */])(scale, pow()).exponent(scale.exponent());
  };

  __WEBPACK_IMPORTED_MODULE_2__init__["b" /* initRange */].apply(scale, arguments);

  return scale;
}

function sqrt() {
  return pow.apply(null, arguments).exponent(0.5);
}


/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(52);
/* unused harmony reexport timeInterval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__millisecond_js__ = __webpack_require__(1663);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__millisecond_js__["a"]; });
/* unused harmony reexport timeMilliseconds */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_1__millisecond_js__["a"]; });
/* unused harmony reexport utcMilliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__second_js__ = __webpack_require__(1664);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__second_js__["a"]; });
/* unused harmony reexport timeSeconds */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_2__second_js__["a"]; });
/* unused harmony reexport utcSeconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__minute_js__ = __webpack_require__(1665);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__minute_js__["a"]; });
/* unused harmony reexport timeMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hour_js__ = __webpack_require__(1666);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__hour_js__["a"]; });
/* unused harmony reexport timeHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__day_js__ = __webpack_require__(1667);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__day_js__["a"]; });
/* unused harmony reexport timeDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__week_js__ = __webpack_require__(1668);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__week_js__["b"]; });
/* unused harmony reexport timeWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_6__week_js__["b"]; });
/* unused harmony reexport timeSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__week_js__["a"]; });
/* unused harmony reexport timeMondays */
/* unused harmony reexport timeTuesday */
/* unused harmony reexport timeTuesdays */
/* unused harmony reexport timeWednesday */
/* unused harmony reexport timeWednesdays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_6__week_js__["c"]; });
/* unused harmony reexport timeThursdays */
/* unused harmony reexport timeFriday */
/* unused harmony reexport timeFridays */
/* unused harmony reexport timeSaturday */
/* unused harmony reexport timeSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__month_js__ = __webpack_require__(1669);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_7__month_js__["a"]; });
/* unused harmony reexport timeMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__year_js__ = __webpack_require__(1670);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_8__year_js__["a"]; });
/* unused harmony reexport timeYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utcMinute_js__ = __webpack_require__(1671);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_9__utcMinute_js__["a"]; });
/* unused harmony reexport utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utcHour_js__ = __webpack_require__(1672);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_10__utcHour_js__["a"]; });
/* unused harmony reexport utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utcDay_js__ = __webpack_require__(1673);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_11__utcDay_js__["a"]; });
/* unused harmony reexport utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utcWeek_js__ = __webpack_require__(1674);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek_js__["b"]; });
/* unused harmony reexport utcWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek_js__["b"]; });
/* unused harmony reexport utcSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek_js__["a"]; });
/* unused harmony reexport utcMondays */
/* unused harmony reexport utcTuesday */
/* unused harmony reexport utcTuesdays */
/* unused harmony reexport utcWednesday */
/* unused harmony reexport utcWednesdays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek_js__["c"]; });
/* unused harmony reexport utcThursdays */
/* unused harmony reexport utcFriday */
/* unused harmony reexport utcFridays */
/* unused harmony reexport utcSaturday */
/* unused harmony reexport utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utcMonth_js__ = __webpack_require__(1675);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_13__utcMonth_js__["a"]; });
/* unused harmony reexport utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utcYear_js__ = __webpack_require__(1676);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_14__utcYear_js__["a"]; });
/* unused harmony reexport utcYears */































/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return timeFormat; });
/* unused harmony export timeParse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return utcParse; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_js__ = __webpack_require__(770);


var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;

defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale(definition) {
  locale = Object(__WEBPACK_IMPORTED_MODULE_0__locale_js__["a" /* default */])(definition);
  timeFormat = locale.format;
  timeParse = locale.parse;
  utcFormat = locale.utcFormat;
  utcParse = locale.utcParse;
  return locale;
}


/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_smooth__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shape_Curve__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shape_Dot__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__container_Layer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__component_LabelList__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ErrorBar__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_DataUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_ChartUtils__ = __webpack_require__(51);




function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Line
 */













var Line =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Line, _PureComponent);

  function Line() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Line);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Line)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      isAnimationFinished: true,
      totalLength: 0
    };
    _this.id = Object(__WEBPACK_IMPORTED_MODULE_12__util_DataUtils__["k" /* uniqueId */])('recharts-line-');

    _this.cachePrevData = function (points) {
      _this.setState({
        prevPoints: points
      });
    };

    _this.pathRef = function (node) {
      _this.mainCurve = node;
    };

    _this.handleAnimationEnd = function () {
      _this.setState({
        isAnimationFinished: true
      });

      _this.props.onAnimationEnd();
    };

    _this.handleAnimationStart = function () {
      _this.setState({
        isAnimationFinished: false
      });

      _this.props.onAnimationStart();
    };

    return _this;
  }

  _createClass(Line, [{
    key: "componentDidMount",

    /* eslint-disable  react/no-did-mount-set-state */
    value: function componentDidMount() {
      if (!this.props.isAnimationActive) {
        return;
      }

      var totalLength = this.getTotalLength();
      this.setState({
        totalLength: totalLength
      });
    } // eslint-disable-next-line camelcase

  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this$props = this.props,
          animationId = _this$props.animationId,
          points = _this$props.points;

      if (nextProps.animationId !== animationId) {
        this.cachePrevData(points);
      }
    }
  }, {
    key: "getTotalLength",
    value: function getTotalLength() {
      var curveDom = this.mainCurve;

      try {
        return curveDom && curveDom.getTotalLength && curveDom.getTotalLength() || 0;
      } catch (err) {
        return 0;
      }
    }
  }, {
    key: "getStrokeDasharray",
    value: function getStrokeDasharray(length, totalLength, lines) {
      var lineLength = lines.reduce(function (pre, next) {
        return pre + next;
      });
      var count = parseInt(length / lineLength, 10);
      var remainLength = length % lineLength;
      var restLength = totalLength - length;
      var remainLines = [];

      for (var i = 0, sum = 0;; sum += lines[i], ++i) {
        if (sum + lines[i] > remainLength) {
          remainLines = [].concat(_toConsumableArray(lines.slice(0, i)), [remainLength - sum]);
          break;
        }
      }

      var emptyLines = remainLines.length % 2 === 0 ? [0, restLength] : [restLength];
      return [].concat(_toConsumableArray(this.constructor.repeat(lines, count)), _toConsumableArray(remainLines), emptyLines).map(function (line) {
        return "".concat(line, "px");
      }).join(', ');
    }
  }, {
    key: "renderErrorBar",
    value: function renderErrorBar() {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }

      var _this$props2 = this.props,
          points = _this$props2.points,
          xAxis = _this$props2.xAxis,
          yAxis = _this$props2.yAxis,
          layout = _this$props2.layout,
          children = _this$props2.children;
      var errorBarItems = Object(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["i" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_11__ErrorBar__["a" /* default */]);

      if (!errorBarItems) {
        return null;
      }

      function dataPointFormatter(dataPoint, dataKey) {
        return {
          x: dataPoint.x,
          y: dataPoint.y,
          value: dataPoint.value,
          errorVal: Object(__WEBPACK_IMPORTED_MODULE_14__util_ChartUtils__["v" /* getValueByDataKey */])(dataPoint.payload, dataKey)
        };
      }

      return errorBarItems.map(function (item, i) {
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(item, {
          key: i,
          // eslint-disable-line react/no-array-index-key
          data: points,
          xAxis: xAxis,
          yAxis: yAxis,
          layout: layout,
          dataPointFormatter: dataPointFormatter
        });
      });
    }
  }, {
    key: "renderDots",
    value: function renderDots(needClip, clipPathId) {
      var _this2 = this;

      var isAnimationActive = this.props.isAnimationActive;

      if (isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }

      var _this$props3 = this.props,
          dot = _this$props3.dot,
          points = _this$props3.points,
          dataKey = _this$props3.dataKey;
      var lineProps = Object(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["l" /* getPresentationAttributes */])(this.props);
      var customDotProps = Object(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["l" /* getPresentationAttributes */])(dot);
      var dotEvents = Object(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["f" /* filterEventAttributes */])(dot);
      var dots = points.map(function (entry, i) {
        var dotProps = _objectSpread({
          key: "dot-".concat(i),
          r: 3
        }, lineProps, {}, customDotProps, {}, dotEvents, {
          value: entry.value,
          dataKey: dataKey,
          cx: entry.x,
          cy: entry.y,
          index: i,
          payload: entry.payload
        });

        return _this2.constructor.renderDotItem(dot, dotProps);
      });
      var dotsProps = {
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
      };
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */], _extends({
        className: "recharts-line-dots",
        key: "dots"
      }, dotsProps), dots);
    }
  }, {
    key: "renderCurveStatically",
    value: function renderCurveStatically(points, needClip, clipPathId, props) {
      var _this$props4 = this.props,
          type = _this$props4.type,
          layout = _this$props4.layout,
          connectNulls = _this$props4.connectNulls;

      var curveProps = _objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["l" /* getPresentationAttributes */])(this.props), {}, Object(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["f" /* filterEventAttributes */])(this.props), {
        fill: 'none',
        className: 'recharts-line-curve',
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null,
        points: points
      }, props, {
        type: type,
        layout: layout,
        connectNulls: connectNulls
      });

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shape_Curve__["a" /* default */], _extends({}, curveProps, {
        pathRef: this.pathRef
      }));
    }
  }, {
    key: "renderCurveWithAnimation",
    value: function renderCurveWithAnimation(needClip, clipPathId) {
      var _this3 = this;

      var _this$props5 = this.props,
          points = _this$props5.points,
          strokeDasharray = _this$props5.strokeDasharray,
          isAnimationActive = _this$props5.isAnimationActive,
          animationBegin = _this$props5.animationBegin,
          animationDuration = _this$props5.animationDuration,
          animationEasing = _this$props5.animationEasing,
          animationId = _this$props5.animationId,
          width = _this$props5.width,
          height = _this$props5.height;
      var _this$state = this.state,
          prevPoints = _this$state.prevPoints,
          totalLength = _this$state.totalLength;
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_smooth__["a" /* default */], {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "line-".concat(animationId),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function (_ref) {
        var t = _ref.t;

        if (prevPoints) {
          var prevPointsDiffFactor = prevPoints.length / points.length;
          var stepData = points.map(function (entry, index) {
            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);

            if (prevPoints[prevPointIndex]) {
              var prev = prevPoints[prevPointIndex];
              var interpolatorX = Object(__WEBPACK_IMPORTED_MODULE_12__util_DataUtils__["f" /* interpolateNumber */])(prev.x, entry.x);
              var interpolatorY = Object(__WEBPACK_IMPORTED_MODULE_12__util_DataUtils__["f" /* interpolateNumber */])(prev.y, entry.y);
              return _objectSpread({}, entry, {
                x: interpolatorX(t),
                y: interpolatorY(t)
              });
            } // magic number of faking previous x and y location


            if (_this3.animateNewValues) {
              var _interpolatorX = Object(__WEBPACK_IMPORTED_MODULE_12__util_DataUtils__["f" /* interpolateNumber */])(width * 2, entry.x);

              var _interpolatorY = Object(__WEBPACK_IMPORTED_MODULE_12__util_DataUtils__["f" /* interpolateNumber */])(height / 2, entry.y);

              return _objectSpread({}, entry, {
                x: _interpolatorX(t),
                y: _interpolatorY(t)
              });
            }

            return _objectSpread({}, entry, {
              x: entry.x,
              y: entry.y
            });
          });
          return _this3.renderCurveStatically(stepData, needClip, clipPathId);
        }

        var interpolator = Object(__WEBPACK_IMPORTED_MODULE_12__util_DataUtils__["f" /* interpolateNumber */])(0, totalLength);
        var curLength = interpolator(t);
        var currentStrokeDasharray;

        if (strokeDasharray) {
          var lines = strokeDasharray.split(/[,\s]+/gim).map(function (num) {
            return parseFloat(num);
          });
          currentStrokeDasharray = _this3.getStrokeDasharray(curLength, totalLength, lines);
        } else {
          currentStrokeDasharray = "".concat(curLength, "px ").concat(totalLength - curLength, "px");
        }

        return _this3.renderCurveStatically(points, needClip, clipPathId, {
          strokeDasharray: currentStrokeDasharray
        });
      });
    }
  }, {
    key: "renderCurve",
    value: function renderCurve(needClip, clipPathId) {
      var _this$props6 = this.props,
          points = _this$props6.points,
          isAnimationActive = _this$props6.isAnimationActive;
      var _this$state2 = this.state,
          prevPoints = _this$state2.prevPoints,
          totalLength = _this$state2.totalLength;

      if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevPoints, points))) {
        return this.renderCurveWithAnimation(needClip, clipPathId);
      }

      return this.renderCurveStatically(points, needClip, clipPathId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          hide = _this$props7.hide,
          dot = _this$props7.dot,
          points = _this$props7.points,
          className = _this$props7.className,
          xAxis = _this$props7.xAxis,
          yAxis = _this$props7.yAxis,
          top = _this$props7.top,
          left = _this$props7.left,
          width = _this$props7.width,
          height = _this$props7.height,
          isAnimationActive = _this$props7.isAnimationActive,
          id = _this$props7.id;

      if (hide || !points || !points.length) {
        return null;
      }

      var isAnimationFinished = this.state.isAnimationFinished;
      var hasSinglePoint = points.length === 1;
      var layerClass = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('recharts-line', className);
      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
      var clipPathId = __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(id) ? this.id : id;
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */], {
        className: layerClass
      }, needClip ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("defs", null, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("clipPath", {
        id: "clipPath-".concat(clipPathId)
      }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("rect", {
        x: left,
        y: top,
        width: width,
        height: height
      }))) : null, !hasSinglePoint && this.renderCurve(needClip, clipPathId), this.renderErrorBar(), (hasSinglePoint || dot) && this.renderDots(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && __WEBPACK_IMPORTED_MODULE_10__component_LabelList__["a" /* default */].renderCallByParent(this.props, points));
    }
  }], [{
    key: "repeat",
    value: function repeat(lines, count) {
      var linesUnit = lines.length % 2 !== 0 ? [].concat(_toConsumableArray(lines), [0]) : lines;
      var result = [];

      for (var i = 0; i < count; ++i) {
        result = [].concat(_toConsumableArray(result), _toConsumableArray(linesUnit));
      }

      return result;
    }
  }, {
    key: "renderDotItem",
    value: function renderDotItem(option, props) {
      var dotItem;

      if (__WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(option)) {
        dotItem = __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(option)) {
        dotItem = option(props);
      } else {
        var className = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('recharts-line-dot', option ? option.className : '');
        dotItem = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shape_Dot__["a" /* default */], _extends({}, props, {
          className: className
        }));
      }

      return dotItem;
    }
  }]);

  return Line;
}(__WEBPACK_IMPORTED_MODULE_3_react__["PureComponent"]);

Line.displayName = 'Line';
Line.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {}, __WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["a" /* EVENT_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]),
  unit: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  name: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  yAxisId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  xAxisId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  yAxis: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  xAxis: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  legendType: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["b" /* LEGEND_TYPES */]),
  tooltipType: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["e" /* TOOLTIP_TYPES */]),
  layout: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['horizontal', 'vertical']),
  connectNulls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  hide: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  // whether have dot in line
  activeDot: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool]),
  dot: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool]),
  top: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  left: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  points: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.value
  })),
  onAnimationStart: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onAnimationEnd: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  isAnimationActive: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  animateNewValues: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  animationBegin: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
  animationId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  id: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string
});
Line.defaultProps = {
  xAxisId: 0,
  yAxisId: 0,
  connectNulls: false,
  activeDot: true,
  dot: true,
  legendType: 'line',
  stroke: '#3182bd',
  strokeWidth: 1,
  fill: '#fff',
  points: [],
  isAnimationActive: !Object(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["o" /* isSsr */])(),
  animateNewValues: true,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease',
  hide: false,
  onAnimationStart: function onAnimationStart() {},
  onAnimationEnd: function onAnimationEnd() {}
};

Line.getComposedData = function (_ref2) {
  var props = _ref2.props,
      xAxis = _ref2.xAxis,
      yAxis = _ref2.yAxis,
      xAxisTicks = _ref2.xAxisTicks,
      yAxisTicks = _ref2.yAxisTicks,
      dataKey = _ref2.dataKey,
      bandSize = _ref2.bandSize,
      displayedData = _ref2.displayedData,
      offset = _ref2.offset;
  var layout = props.layout;
  var points = displayedData.map(function (entry, index) {
    var value = Object(__WEBPACK_IMPORTED_MODULE_14__util_ChartUtils__["v" /* getValueByDataKey */])(entry, dataKey);

    if (layout === 'horizontal') {
      return {
        x: Object(__WEBPACK_IMPORTED_MODULE_14__util_ChartUtils__["k" /* getCateCoordinateOfLine */])({
          axis: xAxis,
          ticks: xAxisTicks,
          bandSize: bandSize,
          entry: entry,
          index: index
        }),
        y: __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(value) ? null : yAxis.scale(value),
        value: value,
        payload: entry
      };
    }

    return {
      x: __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(value) ? null : xAxis.scale(value),
      y: Object(__WEBPACK_IMPORTED_MODULE_14__util_ChartUtils__["k" /* getCateCoordinateOfLine */])({
        axis: yAxis,
        ticks: yAxisTicks,
        bandSize: bandSize,
        entry: entry,
        index: index
      }),
      value: value,
      payload: entry
    };
  });
  return _objectSpread({
    points: points,
    layout: layout
  }, offset);
};

/* harmony default export */ __webpack_exports__["a"] = (Line);

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNaN__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNaN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isNaN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_max__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_max___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_max__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_get__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isNil__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isArray__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_smooth__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shape_Curve__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shape_Dot__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__container_Layer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__component_LabelList__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_ReactUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_DataUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_ChartUtils__ = __webpack_require__(51);








function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Area
 */












var Area =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Area, _PureComponent);

  function Area() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Area);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Area)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      isAnimationFinished: true
    };
    _this.id = Object(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["k" /* uniqueId */])('recharts-area-');

    _this.cachePrevData = function (points, baseLine) {
      _this.setState({
        prevPoints: points,
        prevBaseLine: baseLine
      });
    };

    _this.handleAnimationEnd = function () {
      var onAnimationEnd = _this.props.onAnimationEnd;

      _this.setState({
        isAnimationFinished: true
      });

      if (__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(onAnimationEnd)) {
        onAnimationEnd();
      }
    };

    _this.handleAnimationStart = function () {
      var onAnimationStart = _this.props.onAnimationStart;

      _this.setState({
        isAnimationFinished: false
      });

      if (__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(onAnimationStart)) {
        onAnimationStart();
      }
    };

    return _this;
  }

  _createClass(Area, [{
    key: "componentWillReceiveProps",
    // eslint-disable-next-line camelcase
    value: function componentWillReceiveProps(nextProps) {
      var _this$props = this.props,
          animationId = _this$props.animationId,
          points = _this$props.points,
          baseLine = _this$props.baseLine;

      if (nextProps.animationId !== animationId) {
        this.cachePrevData(points, baseLine);
      }
    }
  }, {
    key: "renderDots",
    value: function renderDots(needClip, clipPathId) {
      var _this2 = this;

      var isAnimationActive = this.props.isAnimationActive;
      var isAnimationFinished = this.state.isAnimationFinished;

      if (isAnimationActive && !isAnimationFinished) {
        return null;
      }

      var _this$props2 = this.props,
          dot = _this$props2.dot,
          points = _this$props2.points,
          dataKey = _this$props2.dataKey;
      var areaProps = Object(__WEBPACK_IMPORTED_MODULE_15__util_ReactUtils__["l" /* getPresentationAttributes */])(this.props);
      var customDotProps = Object(__WEBPACK_IMPORTED_MODULE_15__util_ReactUtils__["l" /* getPresentationAttributes */])(dot);
      var dotEvents = Object(__WEBPACK_IMPORTED_MODULE_15__util_ReactUtils__["f" /* filterEventAttributes */])(dot);
      var dots = points.map(function (entry, i) {
        var dotProps = _objectSpread({
          key: "dot-".concat(i),
          r: 3
        }, areaProps, {}, customDotProps, {}, dotEvents, {
          dataKey: dataKey,
          cx: entry.x,
          cy: entry.y,
          index: i,
          value: entry.value,
          payload: entry.payload
        });

        return _this2.constructor.renderDotItem(dot, dotProps);
      });
      var dotsProps = {
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
      };
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__container_Layer__["a" /* default */], _extends({
        className: "recharts-area-dots"
      }, dotsProps), dots);
    }
  }, {
    key: "renderHorizontalRect",
    value: function renderHorizontalRect(alpha) {
      var _this$props3 = this.props,
          baseLine = _this$props3.baseLine,
          points = _this$props3.points,
          strokeWidth = _this$props3.strokeWidth;
      var startX = points[0].x;
      var endX = points[points.length - 1].x;
      var width = alpha * Math.abs(startX - endX);

      var maxY = __WEBPACK_IMPORTED_MODULE_2_lodash_max___default()(points.map(function (entry) {
        return entry.y || 0;
      }));

      if (Object(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["h" /* isNumber */])(baseLine)) {
        maxY = Math.max(baseLine, maxY);
      } else if (baseLine && __WEBPACK_IMPORTED_MODULE_6_lodash_isArray___default()(baseLine) && baseLine.length) {
        maxY = Math.max(__WEBPACK_IMPORTED_MODULE_2_lodash_max___default()(baseLine.map(function (entry) {
          return entry.y || 0;
        })), maxY);
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["h" /* isNumber */])(maxY)) {
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("rect", {
          x: startX < endX ? startX : startX - width,
          y: 0,
          width: width,
          height: parseInt(maxY + (strokeWidth || 1), 10)
        });
      }

      return null;
    }
  }, {
    key: "renderVerticalRect",
    value: function renderVerticalRect(alpha) {
      var _this$props4 = this.props,
          baseLine = _this$props4.baseLine,
          points = _this$props4.points,
          strokeWidth = _this$props4.strokeWidth;
      var startY = points[0].y;
      var endY = points[points.length - 1].y;
      var height = alpha * Math.abs(startY - endY);

      var maxX = __WEBPACK_IMPORTED_MODULE_2_lodash_max___default()(points.map(function (entry) {
        return entry.x || 0;
      }));

      if (Object(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["h" /* isNumber */])(baseLine)) {
        maxX = Math.max(baseLine, maxX);
      } else if (baseLine && __WEBPACK_IMPORTED_MODULE_6_lodash_isArray___default()(baseLine) && baseLine.length) {
        maxX = Math.max(__WEBPACK_IMPORTED_MODULE_2_lodash_max___default()(baseLine.map(function (entry) {
          return entry.x || 0;
        })), maxX);
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["h" /* isNumber */])(maxX)) {
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("rect", {
          x: 0,
          y: startY < endY ? startY : startY - height,
          width: maxX + (strokeWidth || 1),
          height: parseInt(height, 10)
        });
      }

      return null;
    }
  }, {
    key: "renderClipRect",
    value: function renderClipRect(alpha) {
      var layout = this.props.layout;

      if (layout === 'vertical') {
        return this.renderVerticalRect(alpha);
      }

      return this.renderHorizontalRect(alpha);
    }
  }, {
    key: "renderAreaStatically",
    value: function renderAreaStatically(points, baseLine, needClip, clipPathId) {
      var _this$props5 = this.props,
          layout = _this$props5.layout,
          type = _this$props5.type,
          stroke = _this$props5.stroke,
          connectNulls = _this$props5.connectNulls,
          isRange = _this$props5.isRange;
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__container_Layer__["a" /* default */], {
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
      }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shape_Curve__["a" /* default */], _extends({}, this.props, {
        points: points,
        baseLine: baseLine,
        stroke: "none",
        className: "recharts-area-area"
      })), stroke !== 'none' && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shape_Curve__["a" /* default */], _extends({}, Object(__WEBPACK_IMPORTED_MODULE_15__util_ReactUtils__["l" /* getPresentationAttributes */])(this.props), {
        className: "recharts-area-curve",
        layout: layout,
        type: type,
        connectNulls: connectNulls,
        fill: "none",
        points: points
      })), stroke !== 'none' && isRange && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shape_Curve__["a" /* default */], _extends({}, Object(__WEBPACK_IMPORTED_MODULE_15__util_ReactUtils__["l" /* getPresentationAttributes */])(this.props), {
        className: "recharts-area-curve",
        layout: layout,
        type: type,
        connectNulls: connectNulls,
        fill: "none",
        points: baseLine
      })));
    }
  }, {
    key: "renderAreaWithAnimation",
    value: function renderAreaWithAnimation(needClip, clipPathId) {
      var _this3 = this;

      var _this$props6 = this.props,
          points = _this$props6.points,
          baseLine = _this$props6.baseLine,
          isAnimationActive = _this$props6.isAnimationActive,
          animationBegin = _this$props6.animationBegin,
          animationDuration = _this$props6.animationDuration,
          animationEasing = _this$props6.animationEasing,
          animationId = _this$props6.animationId;
      var _this$state = this.state,
          prevPoints = _this$state.prevPoints,
          prevBaseLine = _this$state.prevBaseLine; // const clipPathId = _.isNil(id) ? this.id : id;

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_smooth__["a" /* default */], {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "area-".concat(animationId),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function (_ref) {
        var t = _ref.t;

        if (prevPoints) {
          var prevPointsDiffFactor = prevPoints.length / points.length; // update animtaion

          var stepPoints = points.map(function (entry, index) {
            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);

            if (prevPoints[prevPointIndex]) {
              var prev = prevPoints[prevPointIndex];
              var interpolatorX = Object(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["f" /* interpolateNumber */])(prev.x, entry.x);
              var interpolatorY = Object(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["f" /* interpolateNumber */])(prev.y, entry.y);
              return _objectSpread({}, entry, {
                x: interpolatorX(t),
                y: interpolatorY(t)
              });
            }

            return entry;
          });
          var stepBaseLine;

          if (Object(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["h" /* isNumber */])(baseLine)) {
            var interpolator = Object(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["f" /* interpolateNumber */])(prevBaseLine, baseLine);
            stepBaseLine = interpolator(t);
          } else if (__WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(baseLine) || __WEBPACK_IMPORTED_MODULE_1_lodash_isNaN___default()(baseLine)) {
            var _interpolator = Object(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["f" /* interpolateNumber */])(prevBaseLine, 0);

            stepBaseLine = _interpolator(t);
          } else {
            stepBaseLine = baseLine.map(function (entry, index) {
              var prevPointIndex = Math.floor(index * prevPointsDiffFactor);

              if (prevBaseLine[prevPointIndex]) {
                var prev = prevBaseLine[prevPointIndex];
                var interpolatorX = Object(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["f" /* interpolateNumber */])(prev.x, entry.x);
                var interpolatorY = Object(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["f" /* interpolateNumber */])(prev.y, entry.y);
                return _objectSpread({}, entry, {
                  x: interpolatorX(t),
                  y: interpolatorY(t)
                });
              }

              return entry;
            });
          }

          return _this3.renderAreaStatically(stepPoints, stepBaseLine, needClip, clipPathId);
        }

        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__container_Layer__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("defs", null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("clipPath", {
          id: "animationClipPath-".concat(clipPathId)
        }, _this3.renderClipRect(t))), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__container_Layer__["a" /* default */], {
          clipPath: "url(#animationClipPath-".concat(clipPathId, ")")
        }, _this3.renderAreaStatically(points, baseLine, needClip, clipPathId)));
      });
    }
  }, {
    key: "renderArea",
    value: function renderArea(needClip, clipPathId) {
      var _this$props7 = this.props,
          points = _this$props7.points,
          baseLine = _this$props7.baseLine,
          isAnimationActive = _this$props7.isAnimationActive;
      var _this$state2 = this.state,
          prevPoints = _this$state2.prevPoints,
          prevBaseLine = _this$state2.prevBaseLine,
          totalLength = _this$state2.totalLength;

      if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevPoints, points) || !__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevBaseLine, baseLine))) {
        return this.renderAreaWithAnimation(needClip, clipPathId);
      }

      return this.renderAreaStatically(points, baseLine, needClip, clipPathId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props8 = this.props,
          hide = _this$props8.hide,
          dot = _this$props8.dot,
          points = _this$props8.points,
          className = _this$props8.className,
          top = _this$props8.top,
          left = _this$props8.left,
          xAxis = _this$props8.xAxis,
          yAxis = _this$props8.yAxis,
          width = _this$props8.width,
          height = _this$props8.height,
          isAnimationActive = _this$props8.isAnimationActive,
          id = _this$props8.id;

      if (hide || !points || !points.length) {
        return null;
      }

      var isAnimationFinished = this.state.isAnimationFinished;
      var hasSinglePoint = points.length === 1;
      var layerClass = __WEBPACK_IMPORTED_MODULE_9_classnames___default()('recharts-area', className);
      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
      var clipPathId = __WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(id) ? this.id : id;
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__container_Layer__["a" /* default */], {
        className: layerClass
      }, needClip ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("defs", null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("clipPath", {
        id: "clipPath-".concat(clipPathId)
      }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("rect", {
        x: left,
        y: top,
        width: width,
        height: parseInt(height, 10)
      }))) : null, !hasSinglePoint ? this.renderArea(needClip, clipPathId) : null, (dot || hasSinglePoint) && this.renderDots(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && __WEBPACK_IMPORTED_MODULE_14__component_LabelList__["a" /* default */].renderCallByParent(this.props, points));
    }
  }]);

  return Area;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);

Area.displayName = 'Area';
Area.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_15__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {}, __WEBPACK_IMPORTED_MODULE_15__util_ReactUtils__["a" /* EVENT_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  dataKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func]).isRequired,
  type: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func]),
  unit: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number]),
  name: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number]),
  yAxisId: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number]),
  xAxisId: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number]),
  yAxis: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  xAxis: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  stackId: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string]),
  legendType: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_15__util_ReactUtils__["b" /* LEGEND_TYPES */]),
  tooltipType: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_15__util_ReactUtils__["e" /* TOOLTIP_TYPES */]),
  connectNulls: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  activeDot: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool]),
  // dot configuration
  dot: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool]),
  label: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool]),
  hide: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  // have curve configuration
  layout: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(['horizontal', 'vertical']),
  baseLine: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.array]),
  isRange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  points: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
    value: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.array])
  })),
  onAnimationStart: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onAnimationEnd: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  animationId: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  isAnimationActive: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  animationBegin: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
  id: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
});
Area.defaultProps = {
  stroke: '#3182bd',
  fill: '#3182bd',
  fillOpacity: 0.6,
  xAxisId: 0,
  yAxisId: 0,
  legendType: 'line',
  connectNulls: false,
  // points of area
  points: [],
  dot: false,
  activeDot: true,
  hide: false,
  isAnimationActive: !Object(__WEBPACK_IMPORTED_MODULE_15__util_ReactUtils__["o" /* isSsr */])(),
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease'
};

Area.getBaseValue = function (props, xAxis, yAxis) {
  var layout = props.layout,
      baseValue = props.baseValue;

  if (Object(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["h" /* isNumber */])(baseValue)) {
    return baseValue;
  }

  var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
  var domain = numericAxis.scale.domain();

  if (numericAxis.type === 'number') {
    var max = Math.max(domain[0], domain[1]);
    var min = Math.min(domain[0], domain[1]);

    if (baseValue === 'dataMin') {
      return min;
    }

    if (baseValue === 'dataMax') {
      return max;
    }

    return max < 0 ? max : Math.max(Math.min(domain[0], domain[1]), 0);
  }

  if (baseValue === 'dataMin') {
    return domain[0];
  }

  if (baseValue === 'dataMax') {
    return domain[1];
  }

  return domain[0];
};

Area.getComposedData = function (_ref2) {
  var props = _ref2.props,
      xAxis = _ref2.xAxis,
      yAxis = _ref2.yAxis,
      xAxisTicks = _ref2.xAxisTicks,
      yAxisTicks = _ref2.yAxisTicks,
      bandSize = _ref2.bandSize,
      dataKey = _ref2.dataKey,
      stackedData = _ref2.stackedData,
      dataStartIndex = _ref2.dataStartIndex,
      displayedData = _ref2.displayedData,
      offset = _ref2.offset;
  var layout = props.layout;
  var hasStack = stackedData && stackedData.length;
  var baseValue = Area.getBaseValue(props, xAxis, yAxis);
  var isRange = false;
  var points = displayedData.map(function (entry, index) {
    var value;

    if (hasStack) {
      value = stackedData[dataStartIndex + index];
    } else {
      value = Object(__WEBPACK_IMPORTED_MODULE_17__util_ChartUtils__["v" /* getValueByDataKey */])(entry, dataKey);

      if (!__WEBPACK_IMPORTED_MODULE_6_lodash_isArray___default()(value)) {
        value = [baseValue, value];
      } else {
        isRange = true;
      }
    }

    if (layout === 'horizontal') {
      return {
        x: Object(__WEBPACK_IMPORTED_MODULE_17__util_ChartUtils__["k" /* getCateCoordinateOfLine */])({
          axis: xAxis,
          ticks: xAxisTicks,
          bandSize: bandSize,
          entry: entry,
          index: index
        }),
        y: __WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(value[1]) ? null : yAxis.scale(value[1]),
        value: value,
        payload: entry
      };
    }

    return {
      x: __WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(value[1]) ? null : xAxis.scale(value[1]),
      y: Object(__WEBPACK_IMPORTED_MODULE_17__util_ChartUtils__["k" /* getCateCoordinateOfLine */])({
        axis: yAxis,
        ticks: yAxisTicks,
        bandSize: bandSize,
        entry: entry,
        index: index
      }),
      value: value,
      payload: entry
    };
  });
  var baseLine;

  if (hasStack || isRange) {
    baseLine = points.map(function (entry) {
      if (layout === 'horizontal') {
        return {
          x: entry.x,
          y: !__WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(__WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(entry, 'value[0]')) ? yAxis.scale(__WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(entry, 'value[0]')) : null
        };
      }

      return {
        x: !__WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(__WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(entry, 'value[0]')) ? xAxis.scale(__WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(entry, 'value[0]')) : null,
        y: entry.y
      };
    });
  } else if (layout === 'horizontal') {
    baseLine = yAxis.scale(baseValue);
  } else {
    baseLine = xAxis.scale(baseValue);
  }

  return _objectSpread({
    points: points,
    baseLine: baseLine,
    layout: layout,
    isRange: isRange
  }, offset);
};

Area.renderDotItem = function (option, props) {
  var dotItem;

  if (__WEBPACK_IMPORTED_MODULE_7_react___default.a.isValidElement(option)) {
    dotItem = __WEBPACK_IMPORTED_MODULE_7_react___default.a.cloneElement(option, props);
  } else if (__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(option)) {
    dotItem = option(props);
  } else {
    dotItem = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shape_Dot__["a" /* default */], _extends({}, props, {
      className: "recharts-area-dot"
    }));
  }

  return dotItem;
};

/* harmony default export */ __webpack_exports__["a"] = (Area);

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEqual__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isFunction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_smooth__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shape_Rectangle__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__container_Layer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ErrorBar__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__component_Cell__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__component_LabelList__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_DataUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_ChartUtils__ = __webpack_require__(51);





function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Render a group of bar
 */













var Bar =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Bar, _PureComponent);

  function Bar() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Bar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Bar)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      isAnimationFinished: false
    };
    _this.id = Object(__WEBPACK_IMPORTED_MODULE_13__util_DataUtils__["k" /* uniqueId */])('recharts-bar-');

    _this.cachePrevData = function (data) {
      _this.setState({
        prevData: data
      });
    };

    _this.handleAnimationEnd = function () {
      _this.setState({
        isAnimationFinished: true
      });

      _this.props.onAnimationEnd();
    };

    _this.handleAnimationStart = function () {
      _this.setState({
        isAnimationFinished: false
      });

      _this.props.onAnimationStart();
    };

    return _this;
  }

  _createClass(Bar, [{
    key: "componentWillReceiveProps",
    // eslint-disable-next-line camelcase
    value: function componentWillReceiveProps(nextProps) {
      var _this$props = this.props,
          animationId = _this$props.animationId,
          data = _this$props.data;

      if (nextProps.animationId !== animationId) {
        this.cachePrevData(data);
      }
    }
  }, {
    key: "renderRectanglesStatically",
    value: function renderRectanglesStatically(data) {
      var _this2 = this;

      var shape = this.props.shape;
      var baseProps = Object(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["l" /* getPresentationAttributes */])(this.props);
      return data && data.map(function (entry, i) {
        var props = _objectSpread({}, baseProps, {}, entry, {
          index: i
        });

        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */], _extends({
          className: "recharts-bar-rectangle"
        }, Object(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["g" /* filterEventsOfChild */])(_this2.props, entry, i), {
          key: "rectangle-".concat(i) // eslint-disable-line react/no-array-index-key

        }), _this2.constructor.renderRectangle(shape, props));
      });
    }
  }, {
    key: "renderRectanglesWithAnimation",
    value: function renderRectanglesWithAnimation() {
      var _this3 = this;

      var _this$props2 = this.props,
          data = _this$props2.data,
          layout = _this$props2.layout,
          isAnimationActive = _this$props2.isAnimationActive,
          animationBegin = _this$props2.animationBegin,
          animationDuration = _this$props2.animationDuration,
          animationEasing = _this$props2.animationEasing,
          animationId = _this$props2.animationId;
      var prevData = this.state.prevData;
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_smooth__["a" /* default */], {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "bar-".concat(animationId),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function (_ref) {
        var t = _ref.t;
        var stepData = data.map(function (entry, index) {
          var prev = prevData && prevData[index];

          if (prev) {
            var interpolatorX = Object(__WEBPACK_IMPORTED_MODULE_13__util_DataUtils__["f" /* interpolateNumber */])(prev.x, entry.x);
            var interpolatorY = Object(__WEBPACK_IMPORTED_MODULE_13__util_DataUtils__["f" /* interpolateNumber */])(prev.y, entry.y);
            var interpolatorWidth = Object(__WEBPACK_IMPORTED_MODULE_13__util_DataUtils__["f" /* interpolateNumber */])(prev.width, entry.width);
            var interpolatorHeight = Object(__WEBPACK_IMPORTED_MODULE_13__util_DataUtils__["f" /* interpolateNumber */])(prev.height, entry.height);
            return _objectSpread({}, entry, {
              x: interpolatorX(t),
              y: interpolatorY(t),
              width: interpolatorWidth(t),
              height: interpolatorHeight(t)
            });
          }

          if (layout === 'horizontal') {
            var _interpolatorHeight = Object(__WEBPACK_IMPORTED_MODULE_13__util_DataUtils__["f" /* interpolateNumber */])(0, entry.height);

            var h = _interpolatorHeight(t);

            return _objectSpread({}, entry, {
              y: entry.y + entry.height - h,
              height: h
            });
          }

          var interpolator = Object(__WEBPACK_IMPORTED_MODULE_13__util_DataUtils__["f" /* interpolateNumber */])(0, entry.width);
          var w = interpolator(t);
          return _objectSpread({}, entry, {
            width: w
          });
        });
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */], null, _this3.renderRectanglesStatically(stepData));
      });
    }
  }, {
    key: "renderRectangles",
    value: function renderRectangles() {
      var _this$props3 = this.props,
          data = _this$props3.data,
          isAnimationActive = _this$props3.isAnimationActive;
      var prevData = this.state.prevData;

      if (isAnimationActive && data && data.length && (!prevData || !__WEBPACK_IMPORTED_MODULE_1_lodash_isEqual___default()(prevData, data))) {
        return this.renderRectanglesWithAnimation();
      }

      return this.renderRectanglesStatically(data);
    }
  }, {
    key: "renderBackground",
    value: function renderBackground() {
      var _this4 = this;

      var data = this.props.data;
      var backgroundProps = Object(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["l" /* getPresentationAttributes */])(this.props.background);
      return data.map(function (entry, i) {
        // eslint-disable-next-line no-unused-vars
        var value = entry.value,
            background = entry.background,
            rest = _objectWithoutProperties(entry, ["value", "background"]);

        if (!background) {
          return null;
        }

        var props = _objectSpread({}, rest, {
          fill: '#eee'
        }, background, {}, backgroundProps, {}, Object(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["g" /* filterEventsOfChild */])(_this4.props, entry, i), {
          index: i,
          key: "background-bar-".concat(i),
          className: 'recharts-bar-background-rectangle'
        });

        return _this4.constructor.renderRectangle(_this4.props.background, props);
      });
    }
  }, {
    key: "renderErrorBar",
    value: function renderErrorBar() {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }

      var _this$props4 = this.props,
          data = _this$props4.data,
          xAxis = _this$props4.xAxis,
          yAxis = _this$props4.yAxis,
          layout = _this$props4.layout,
          children = _this$props4.children;
      var errorBarItems = Object(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["i" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_10__ErrorBar__["a" /* default */]);

      if (!errorBarItems) {
        return null;
      }

      var offset = layout === 'vertical' ? data[0].height / 2 : data[0].width / 2;

      function dataPointFormatter(dataPoint, dataKey) {
        return {
          x: dataPoint.x,
          y: dataPoint.y,
          value: dataPoint.value,
          errorVal: Object(__WEBPACK_IMPORTED_MODULE_15__util_ChartUtils__["v" /* getValueByDataKey */])(dataPoint, dataKey)
        };
      }

      return errorBarItems.map(function (item, i) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(item, {
          key: "error-bar-".concat(i),
          // eslint-disable-line react/no-array-index-key
          data: data,
          xAxis: xAxis,
          yAxis: yAxis,
          layout: layout,
          offset: offset,
          dataPointFormatter: dataPointFormatter
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          hide = _this$props5.hide,
          data = _this$props5.data,
          className = _this$props5.className,
          xAxis = _this$props5.xAxis,
          yAxis = _this$props5.yAxis,
          left = _this$props5.left,
          top = _this$props5.top,
          width = _this$props5.width,
          height = _this$props5.height,
          isAnimationActive = _this$props5.isAnimationActive,
          background = _this$props5.background,
          id = _this$props5.id;

      if (hide || !data || !data.length) {
        return null;
      }

      var isAnimationFinished = this.state.isAnimationFinished;
      var layerClass = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('recharts-bar', className);
      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
      var clipPathId = __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(id) ? this.id : id;
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */], {
        className: layerClass
      }, needClip ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("defs", null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("clipPath", {
        id: "clipPath-".concat(clipPathId)
      }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("rect", {
        x: left,
        y: top,
        width: width,
        height: height
      }))) : null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */], {
        className: "recharts-bar-rectangles",
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
      }, background ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(), (!isAnimationActive || isAnimationFinished) && __WEBPACK_IMPORTED_MODULE_12__component_LabelList__["a" /* default */].renderCallByParent(this.props, data));
    }
  }], [{
    key: "renderRectangle",
    value: function renderRectangle(option, props) {
      var rectangle;

      if (__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(option)) {
        rectangle = __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default()(option)) {
        rectangle = option(props);
      } else {
        rectangle = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shape_Rectangle__["a" /* default */], props);
      }

      return rectangle;
    }
  }]);

  return Bar;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

Bar.displayName = 'Bar';
Bar.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {}, __WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["a" /* EVENT_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  layout: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['vertical', 'horizontal']),
  xAxisId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),
  yAxisId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),
  yAxis: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  xAxis: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  stackId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),
  barSize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  unit: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number]),
  name: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number]),
  dataKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]).isRequired,
  legendType: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["b" /* LEGEND_TYPES */]),
  tooltipType: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["e" /* TOOLTIP_TYPES */]),
  minPointSize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  maxBarSize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  hide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  shape: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.element]),
  data: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    width: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    height: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    radius: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array]),
    value: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array])
  })),
  onAnimationStart: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onAnimationEnd: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  animationId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  isAnimationActive: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  animationBegin: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
  id: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
});
Bar.defaultProps = {
  xAxisId: 0,
  yAxisId: 0,
  legendType: 'rect',
  minPointSize: 0,
  hide: false,
  // data of bar
  data: [],
  layout: 'vertical',
  isAnimationActive: !Object(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["o" /* isSsr */])(),
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: 'ease',
  onAnimationStart: function onAnimationStart() {},
  onAnimationEnd: function onAnimationEnd() {}
};

Bar.getComposedData = function (_ref2) {
  var props = _ref2.props,
      item = _ref2.item,
      barPosition = _ref2.barPosition,
      bandSize = _ref2.bandSize,
      xAxis = _ref2.xAxis,
      yAxis = _ref2.yAxis,
      xAxisTicks = _ref2.xAxisTicks,
      yAxisTicks = _ref2.yAxisTicks,
      stackedData = _ref2.stackedData,
      dataStartIndex = _ref2.dataStartIndex,
      displayedData = _ref2.displayedData,
      offset = _ref2.offset;
  var pos = Object(__WEBPACK_IMPORTED_MODULE_15__util_ChartUtils__["e" /* findPositionOfBar */])(barPosition, item);

  if (!pos) {
    return [];
  }

  var layout = props.layout;
  var _item$props = item.props,
      dataKey = _item$props.dataKey,
      children = _item$props.children,
      minPointSize = _item$props.minPointSize;
  var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
  var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
  var baseValue = Object(__WEBPACK_IMPORTED_MODULE_15__util_ChartUtils__["i" /* getBaseValueOfBar */])({
    props: props,
    numericAxis: numericAxis
  });
  var cells = Object(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["i" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_11__component_Cell__["a" /* default */]);
  var rects = displayedData.map(function (entry, index) {
    var value, x, y, width, height, background;

    if (stackedData) {
      value = Object(__WEBPACK_IMPORTED_MODULE_15__util_ChartUtils__["B" /* truncateByDomain */])(stackedData[dataStartIndex + index], stackedDomain);
    } else {
      value = Object(__WEBPACK_IMPORTED_MODULE_15__util_ChartUtils__["v" /* getValueByDataKey */])(entry, dataKey);

      if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default()(value)) {
        value = [baseValue, value];
      }
    }

    if (layout === 'horizontal') {
      x = Object(__WEBPACK_IMPORTED_MODULE_15__util_ChartUtils__["j" /* getCateCoordinateOfBar */])({
        axis: xAxis,
        ticks: xAxisTicks,
        bandSize: bandSize,
        offset: pos.offset,
        entry: entry,
        index: index
      });
      y = yAxis.scale(value[1]);
      width = pos.size;
      height = yAxis.scale(value[0]) - yAxis.scale(value[1]);
      background = {
        x: x,
        y: yAxis.y,
        width: width,
        height: yAxis.height
      };

      if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
        var delta = Object(__WEBPACK_IMPORTED_MODULE_13__util_DataUtils__["j" /* mathSign */])(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
        y -= delta;
        height += delta;
      }
    } else {
      x = xAxis.scale(value[0]);
      y = Object(__WEBPACK_IMPORTED_MODULE_15__util_ChartUtils__["j" /* getCateCoordinateOfBar */])({
        axis: yAxis,
        ticks: yAxisTicks,
        bandSize: bandSize,
        offset: pos.offset,
        entry: entry,
        index: index
      });
      width = xAxis.scale(value[1]) - xAxis.scale(value[0]);
      height = pos.size;
      background = {
        x: xAxis.x,
        y: y,
        width: xAxis.width,
        height: height
      };

      if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
        var _delta = Object(__WEBPACK_IMPORTED_MODULE_13__util_DataUtils__["j" /* mathSign */])(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));

        width += _delta;
      }
    }

    return _objectSpread({}, entry, {
      x: x,
      y: y,
      width: width,
      height: height,
      value: stackedData ? value : value[1],
      payload: entry,
      background: background
    }, cells && cells[index] && cells[index].props);
  });
  return _objectSpread({
    data: rects,
    layout: layout
  }, offset);
};

/* harmony default export */ __webpack_exports__["a"] = (Bar);

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_smooth__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__container_Layer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__component_LabelList__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ZAxis__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shape_Curve__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shape_Symbols__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ErrorBar__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__component_Cell__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_DataUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_ChartUtils__ = __webpack_require__(51);




function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Render a group of scatters
 */















var Scatter =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Scatter, _PureComponent);

  function Scatter() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Scatter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Scatter)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      isAnimationFinished: false
    };

    _this.cachePrevPoints = function (points) {
      _this.setState({
        prevPoints: points
      });
    };

    _this.handleAnimationEnd = function () {
      _this.setState({
        isAnimationFinished: true
      });
    };

    _this.handleAnimationStart = function () {
      _this.setState({
        isAnimationFinished: false
      });
    };

    _this.id = Object(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["k" /* uniqueId */])('recharts-scatter-');
    return _this;
  }

  _createClass(Scatter, [{
    key: "componentWillReceiveProps",
    // eslint-disable-next-line camelcase
    value: function componentWillReceiveProps(nextProps) {
      var _this$props = this.props,
          animationId = _this$props.animationId,
          points = _this$props.points;

      if (nextProps.animationId !== animationId) {
        this.cachePrevPoints(points);
      }
    }
  }, {
    key: "renderSymbolsStatically",
    value: function renderSymbolsStatically(points) {
      var _this2 = this;

      var _this$props2 = this.props,
          shape = _this$props2.shape,
          activeShape = _this$props2.activeShape,
          activeIndex = _this$props2.activeIndex;
      var baseProps = Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["l" /* getPresentationAttributes */])(this.props);
      return points.map(function (entry, i) {
        var props = _objectSpread({
          key: "symbol-".concat(i)
        }, baseProps, {}, entry);

        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__container_Layer__["a" /* default */], _extends({
          className: "recharts-scatter-symbol"
        }, Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["g" /* filterEventsOfChild */])(_this2.props, entry, i), {
          key: "symbol-".concat(i) // eslint-disable-line react/no-array-index-key

        }), _this2.constructor.renderSymbolItem(activeIndex === i ? activeShape : shape, props));
      });
    }
  }, {
    key: "renderSymbolsWithAnimation",
    value: function renderSymbolsWithAnimation() {
      var _this3 = this;

      var _this$props3 = this.props,
          points = _this$props3.points,
          isAnimationActive = _this$props3.isAnimationActive,
          animationBegin = _this$props3.animationBegin,
          animationDuration = _this$props3.animationDuration,
          animationEasing = _this$props3.animationEasing,
          animationId = _this$props3.animationId;
      var prevPoints = this.state.prevPoints;
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_smooth__["a" /* default */], {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "pie-".concat(animationId),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function (_ref) {
        var t = _ref.t;
        var stepData = points.map(function (entry, index) {
          var prev = prevPoints && prevPoints[index];

          if (prev) {
            var interpolatorCx = Object(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["f" /* interpolateNumber */])(prev.cx, entry.cx);
            var interpolatorCy = Object(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["f" /* interpolateNumber */])(prev.cy, entry.cy);
            var interpolatorSize = Object(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["f" /* interpolateNumber */])(prev.size, entry.size);
            return _objectSpread({}, entry, {
              cx: interpolatorCx(t),
              cy: interpolatorCy(t),
              size: interpolatorSize(t)
            });
          }

          var interpolator = Object(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["f" /* interpolateNumber */])(0, entry.size);
          return _objectSpread({}, entry, {
            size: interpolator(t)
          });
        });
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__container_Layer__["a" /* default */], null, _this3.renderSymbolsStatically(stepData));
      });
    }
  }, {
    key: "renderSymbols",
    value: function renderSymbols() {
      var _this$props4 = this.props,
          points = _this$props4.points,
          isAnimationActive = _this$props4.isAnimationActive;
      var prevPoints = this.state.prevPoints;

      if (isAnimationActive && points && points.length && (!prevPoints || !__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevPoints, points))) {
        return this.renderSymbolsWithAnimation();
      }

      return this.renderSymbolsStatically(points);
    }
  }, {
    key: "renderErrorBar",
    value: function renderErrorBar() {
      var isAnimationActive = this.props.isAnimationActive;

      if (isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }

      var _this$props5 = this.props,
          points = _this$props5.points,
          xAxis = _this$props5.xAxis,
          yAxis = _this$props5.yAxis,
          children = _this$props5.children;
      var errorBarItems = Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["i" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_13__ErrorBar__["a" /* default */]);

      if (!errorBarItems) {
        return null;
      }

      function dataPointFormatterY(dataPoint, dataKey) {
        return {
          x: dataPoint.cx,
          y: dataPoint.cy,
          value: dataPoint.node.y,
          errorVal: Object(__WEBPACK_IMPORTED_MODULE_16__util_ChartUtils__["v" /* getValueByDataKey */])(dataPoint, dataKey)
        };
      }

      function dataPointFormatterX(dataPoint, dataKey) {
        return {
          x: dataPoint.cx,
          y: dataPoint.cy,
          value: dataPoint.node.x,
          errorVal: Object(__WEBPACK_IMPORTED_MODULE_16__util_ChartUtils__["v" /* getValueByDataKey */])(dataPoint, dataKey)
        };
      }

      return errorBarItems.map(function (item, i) {
        var direction = item.props.direction;
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(item, {
          key: i,
          // eslint-disable-line react/no-array-index-key
          data: points,
          xAxis: xAxis,
          yAxis: yAxis,
          layout: direction === 'x' ? 'vertical' : 'horizontal',
          dataPointFormatter: direction === 'x' ? dataPointFormatterX : dataPointFormatterY
        });
      });
    }
  }, {
    key: "renderLine",
    value: function renderLine() {
      var _this$props6 = this.props,
          points = _this$props6.points,
          line = _this$props6.line,
          lineType = _this$props6.lineType,
          lineJointType = _this$props6.lineJointType;
      var scatterProps = Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["l" /* getPresentationAttributes */])(this.props);
      var customLineProps = Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["l" /* getPresentationAttributes */])(line);
      var linePoints, lineItem;

      if (lineType === 'joint') {
        linePoints = points.map(function (entry) {
          return {
            x: entry.cx,
            y: entry.cy
          };
        });
      } else if (lineType === 'fitting') {
        var _getLinearRegression = Object(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["c" /* getLinearRegression */])(points),
            xmin = _getLinearRegression.xmin,
            xmax = _getLinearRegression.xmax,
            a = _getLinearRegression.a,
            b = _getLinearRegression.b;

        var linearExp = function linearExp(x) {
          return a * x + b;
        };

        linePoints = [{
          x: xmin,
          y: linearExp(xmin)
        }, {
          x: xmax,
          y: linearExp(xmax)
        }];
      }

      var lineProps = _objectSpread({}, scatterProps, {
        fill: 'none',
        stroke: scatterProps && scatterProps.fill
      }, customLineProps, {
        points: linePoints
      });

      if (__WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(line)) {
        lineItem = __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(line, lineProps);
      } else if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(line)) {
        lineItem = line(lineProps);
      } else {
        lineItem = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shape_Curve__["a" /* default */], _extends({}, lineProps, {
          type: lineJointType
        }));
      }

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__container_Layer__["a" /* default */], {
        className: "recharts-scatter-line",
        key: "recharts-scatter-line"
      }, lineItem);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          hide = _this$props7.hide,
          points = _this$props7.points,
          line = _this$props7.line,
          className = _this$props7.className,
          xAxis = _this$props7.xAxis,
          yAxis = _this$props7.yAxis,
          left = _this$props7.left,
          top = _this$props7.top,
          width = _this$props7.width,
          height = _this$props7.height,
          id = _this$props7.id;

      if (hide || !points || !points.length) {
        return null;
      }

      var _this$state = this.state,
          isAnimationActive = _this$state.isAnimationActive,
          isAnimationFinished = _this$state.isAnimationFinished;
      var layerClass = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('recharts-scatter', className);
      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
      var clipPathId = __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(id) ? this.id : id;
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__container_Layer__["a" /* default */], {
        className: layerClass,
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
      }, needClip ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("defs", null, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("clipPath", {
        id: "clipPath-".concat(clipPathId)
      }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("rect", {
        x: left,
        y: top,
        width: width,
        height: height
      }))) : null, line && this.renderLine(), this.renderErrorBar(), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__container_Layer__["a" /* default */], {
        key: "recharts-scatter-symbols"
      }, this.renderSymbols()), (!isAnimationActive || isAnimationFinished) && __WEBPACK_IMPORTED_MODULE_8__component_LabelList__["a" /* default */].renderCallByParent(this.props, points));
    }
  }], [{
    key: "renderSymbolItem",
    value: function renderSymbolItem(option, props) {
      var symbol;

      if (__WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(option)) {
        symbol = __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(option)) {
        symbol = option(props);
      } else {
        symbol = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shape_Symbols__["a" /* default */], _extends({}, props, {
          type: option
        }));
      }

      return symbol;
    }
  }]);

  return Scatter;
}(__WEBPACK_IMPORTED_MODULE_3_react__["PureComponent"]);

Scatter.displayName = 'Scatter';
Scatter.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["a" /* EVENT_ATTRIBUTES */], {}, __WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  xAxisId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  yAxisId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  zAxisId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  line: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element]),
  lineType: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['fitting', 'joint']),
  lineJointType: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]),
  legendType: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["b" /* LEGEND_TYPES */]),
  tooltipType: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["e" /* TOOLTIP_TYPES */]),
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  name: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  activeIndex: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  activeShape: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element]),
  shape: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]),
  points: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    cx: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    cy: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    size: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    node: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
      x: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string]),
      y: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string]),
      z: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string])
    }),
    payload: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
  })),
  hide: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  isAnimationActive: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  animationId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  animationBegin: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
});
Scatter.defaultProps = {
  xAxisId: 0,
  yAxisId: 0,
  zAxisId: 0,
  legendType: 'circle',
  lineType: 'joint',
  lineJointType: 'linear',
  data: [],
  shape: 'circle',
  hide: false,
  isAnimationActive: !Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["o" /* isSsr */])(),
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: 'linear'
};

Scatter.getComposedData = function (_ref2) {
  var xAxis = _ref2.xAxis,
      yAxis = _ref2.yAxis,
      zAxis = _ref2.zAxis,
      item = _ref2.item,
      displayedData = _ref2.displayedData,
      onItemMouseLeave = _ref2.onItemMouseLeave,
      onItemMouseEnter = _ref2.onItemMouseEnter,
      offset = _ref2.offset,
      xAxisTicks = _ref2.xAxisTicks,
      yAxisTicks = _ref2.yAxisTicks;
  var tooltipType = item.props.tooltipType;
  var cells = Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["i" /* findAllByType */])(item.props.children, __WEBPACK_IMPORTED_MODULE_14__component_Cell__["a" /* default */]);
  var xAxisDataKey = __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(xAxis.dataKey) ? item.props.dataKey : xAxis.dataKey;
  var yAxisDataKey = __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(yAxis.dataKey) ? item.props.dataKey : yAxis.dataKey;
  var zAxisDataKey = zAxis && zAxis.dataKey;
  var defaultRangeZ = zAxis ? zAxis.range : __WEBPACK_IMPORTED_MODULE_10__ZAxis__["a" /* default */].defaultProps.range;
  var defaultZ = defaultRangeZ && defaultRangeZ[0];
  var xBandSize = xAxis.scale.bandwidth ? xAxis.scale.bandwidth() : 0;
  var yBandSize = yAxis.scale.bandwidth ? yAxis.scale.bandwidth() : 0;
  var points = displayedData.map(function (entry, index) {
    var x = entry[xAxisDataKey];
    var y = entry[yAxisDataKey];
    var z = !__WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(zAxisDataKey) && entry[zAxisDataKey] || '-';
    var tooltipPayload = [{
      name: xAxis.name || xAxis.dataKey,
      unit: xAxis.unit || '',
      value: x,
      payload: entry,
      dataKey: xAxisDataKey,
      type: tooltipType
    }, {
      name: yAxis.name || yAxis.dataKey,
      unit: yAxis.unit || '',
      value: y,
      payload: entry,
      dataKey: yAxisDataKey,
      type: tooltipType
    }];

    if (z !== '-') {
      tooltipPayload.push({
        name: zAxis.name || zAxis.dataKey,
        unit: zAxis.unit || '',
        value: z,
        payload: entry,
        dataKey: zAxisDataKey,
        type: tooltipType
      });
    }

    var cx = Object(__WEBPACK_IMPORTED_MODULE_16__util_ChartUtils__["k" /* getCateCoordinateOfLine */])({
      axis: xAxis,
      ticks: xAxisTicks,
      bandSize: xBandSize,
      entry: entry,
      index: index,
      dataKey: xAxisDataKey
    });
    var cy = Object(__WEBPACK_IMPORTED_MODULE_16__util_ChartUtils__["k" /* getCateCoordinateOfLine */])({
      axis: yAxis,
      ticks: yAxisTicks,
      bandSize: yBandSize,
      entry: entry,
      index: index,
      dataKey: yAxisDataKey
    });
    var size = z !== '-' ? zAxis.scale(z) : defaultZ;
    var radius = Math.sqrt(Math.max(size, 0) / Math.PI);
    return _objectSpread({}, entry, {
      cx: cx,
      cy: cy,
      x: cx - radius,
      y: cy - radius,
      xAxis: xAxis,
      yAxis: yAxis,
      zAxis: zAxis,
      width: 2 * radius,
      height: 2 * radius,
      size: size,
      node: {
        x: x,
        y: y,
        z: z
      },
      tooltipPayload: tooltipPayload,
      tooltipPosition: {
        x: cx,
        y: cy
      },
      payload: entry
    }, cells && cells[index] && cells[index].props);
  });
  return _objectSpread({
    onMouseLeave: onItemMouseLeave,
    onMouseEnter: onItemMouseEnter,
    points: points
  }, offset);
};

/* harmony default export */ __webpack_exports__["a"] = (Scatter);

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(631);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



//
/* harmony default export */ __webpack_exports__["a"] = ({
  get: get,
  set: set,
  takeRight: takeRight,
  last: last,
  orderBy: orderBy,
  range: range,
  remove: remove,
  clone: clone,
  getFirstDefined: getFirstDefined,
  sum: sum,
  makeTemplateComponent: makeTemplateComponent,
  groupBy: groupBy,
  isArray: isArray,
  splitProps: splitProps,
  compactObject: compactObject,
  isSortingDesc: isSortingDesc,
  normalizeComponent: normalizeComponent,
  asPx: asPx
});

function get(obj, path, def) {
  if (!path) {
    return obj;
  }
  var pathObj = makePathArray(path);
  var val = void 0;
  try {
    val = pathObj.reduce(function (current, pathPart) {
      return current[pathPart];
    }, obj);
  } catch (e) {
    // continue regardless of error
  }
  return typeof val !== 'undefined' ? val : def;
}

function set() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var path = arguments[1];
  var value = arguments[2];

  var keys = makePathArray(path);
  var keyPart = void 0;
  var cursor = obj;
  while ((keyPart = keys.shift()) && keys.length) {
    if (!cursor[keyPart]) {
      cursor[keyPart] = {};
    }
    cursor = cursor[keyPart];
  }
  cursor[keyPart] = value;
  return obj;
}

function takeRight(arr, n) {
  var start = n > arr.length ? 0 : arr.length - n;
  return arr.slice(start);
}

function last(arr) {
  return arr[arr.length - 1];
}

function range(n) {
  var arr = [];
  for (var i = 0; i < n; i += 1) {
    arr.push(n);
  }
  return arr;
}

function orderBy(arr, funcs, dirs, indexKey) {
  return arr.sort(function (rowA, rowB) {
    for (var i = 0; i < funcs.length; i += 1) {
      var comp = funcs[i];
      var desc = dirs[i] === false || dirs[i] === 'desc';
      var sortInt = comp(rowA, rowB);
      if (sortInt) {
        return desc ? -sortInt : sortInt;
      }
    }
    // Use the row index for tie breakers
    return dirs[0] ? rowA[indexKey] - rowB[indexKey] : rowB[indexKey] - rowA[indexKey];
  });
}

function remove(a, b) {
  return a.filter(function (o, i) {
    var r = b(o);
    if (r) {
      a.splice(i, 1);
      return true;
    }
    return false;
  });
}

function clone(a) {
  try {
    return JSON.parse(JSON.stringify(a, function (key, value) {
      if (typeof value === 'function') {
        return value.toString();
      }
      return value;
    }));
  } catch (e) {
    return a;
  }
}

function getFirstDefined() {
  for (var i = 0; i < arguments.length; i += 1) {
    if (typeof (arguments.length <= i ? undefined : arguments[i]) !== 'undefined') {
      return arguments.length <= i ? undefined : arguments[i];
    }
  }
}

function sum(arr) {
  return arr.reduce(function (a, b) {
    return a + b;
  }, 0);
}

function makeTemplateComponent(compClass, displayName) {
  if (!displayName) {
    throw new Error('No displayName found for template component:', compClass);
  }
  var cmp = function cmp(_ref) {
    var children = _ref.children,
        className = _ref.className,
        rest = _objectWithoutProperties(_ref, ['children', 'className']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      _extends({ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(compClass, className) }, rest),
      children
    );
  };
  cmp.displayName = displayName;
  return cmp;
}

function groupBy(xs, key) {
  return xs.reduce(function (rv, x, i) {
    var resKey = typeof key === 'function' ? key(x, i) : x[key];
    rv[resKey] = isArray(rv[resKey]) ? rv[resKey] : [];
    rv[resKey].push(x);
    return rv;
  }, {});
}

function asPx(value) {
  value = Number(value);
  return Number.isNaN(value) ? null : value + 'px';
}

function isArray(a) {
  return Array.isArray(a);
}

// ########################################################################
// Non-exported Helpers
// ########################################################################

function makePathArray(obj) {
  return flattenDeep(obj).join('.').replace(/\[/g, '.').replace(/\]/g, '').split('.');
}

function flattenDeep(arr) {
  var newArr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (!isArray(arr)) {
    newArr.push(arr);
  } else {
    for (var i = 0; i < arr.length; i += 1) {
      flattenDeep(arr[i], newArr);
    }
  }
  return newArr;
}

function splitProps(_ref2) {
  var className = _ref2.className,
      style = _ref2.style,
      rest = _objectWithoutProperties(_ref2, ['className', 'style']);

  return {
    className: className,
    style: style,
    rest: rest || {}
  };
}

function compactObject(obj) {
  var newObj = {};
  if (obj) {
    Object.keys(obj).map(function (key) {
      if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key] !== undefined && typeof obj[key] !== 'undefined') {
        newObj[key] = obj[key];
      }
      return true;
    });
  }
  return newObj;
}

function isSortingDesc(d) {
  return !!(d.sort === 'desc' || d.desc === true || d.asc === false);
}

function normalizeComponent(Comp, props) {
  var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Comp;

  return isReactComponent(Comp) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Comp, props) : typeof Comp === 'function' ? Comp(props) : fallback;
}

function isClassComponent(component) {
  return typeof component === 'function' && !!Object.getPrototypeOf(component).isReactComponent;
}

function isFunctionComponent(component) {
  return typeof component === 'function' && String(component).includes('.createElement');
}

function isReactComponent(component) {
  return isClassComponent(component) || isFunctionComponent(component);
}
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _dompurify = _interopRequireDefault(__webpack_require__(266));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var SimpleModal = function SimpleModal(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      modal = _useState2[0],
      setModal = _useState2[1];

  var toggle = function toggle() {
    setModal(!modal);
  };

  var modalTitle = props.modalTitle,
      buttonText = props.buttonText,
      modalBody = props.modalBody,
      actionClassName = props.actionClassName,
      modalClassName = props.modalClassName,
      modalBodyOverride = props.modalBodyOverride;
  return _react["default"].createElement("div", null, _react["default"].createElement("a", {
    className: actionClassName ? actionClassName : 'btn btn-light jr-btn-rounded',
    href: "javascript:void(0)",
    onClick: toggle
  }, buttonText), _react["default"].createElement("div", {
    className: "text-center"
  }, _react["default"].createElement(_reactstrap.Modal, {
    isOpen: modal,
    toggle: toggle,
    className: modalClassName
  }, _react["default"].createElement(_reactstrap.ModalHeader, null, modalTitle), _react["default"].createElement(_reactstrap.ModalBody, null, modalBodyOverride ? modalBodyOverride : _react["default"].createElement("div", {
    dangerouslySetInnerHTML: {
      __html: _dompurify["default"].sanitize(modalBody)
    }
  })), _react["default"].createElement(_reactstrap.ModalFooter, null, _react["default"].createElement(_reactstrap.Button, {
    color: "primary",
    onClick: toggle
  }, "Close")))));
};

var _default = SimpleModal;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SimpleModal, "SimpleModal", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/simpleModal/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/simpleModal/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/simpleModal/index.js");

  __REACT_HOT_LOADER__.register(_dompurify, "_dompurify", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/simpleModal/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/simpleModal/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/simpleModal/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/simpleModal/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/simpleModal/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/simpleModal/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/simpleModal/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/simpleModal/index.js");

  __REACT_HOT_LOADER__.register(SimpleModal, "SimpleModal", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/simpleModal/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/simpleModal/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/simpleModal/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/simpleModal/index.js");
}();

;

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_Dom_addEventListener__ = __webpack_require__(295);












var Handle = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Handle, _React$Component);

  function Handle() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Handle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Handle.__proto__ || Object.getPrototypeOf(Handle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      clickFocused: false
    }, _this.setHandleRef = function (node) {
      _this.handle = node;
    }, _this.handleMouseUp = function () {
      if (document.activeElement === _this.handle) {
        _this.setClickFocus(true);
      }
    }, _this.handleMouseDown = function () {
      // fix https://github.com/ant-design/ant-design/issues/15324
      _this.focus();
    }, _this.handleBlur = function () {
      _this.setClickFocus(false);
    }, _this.handleKeyDown = function () {
      _this.setClickFocus(false);
    }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Handle, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // mouseup won't trigger if mouse moved out of handle,
      // so we listen on document here.
      this.onMouseUpListener = Object(__WEBPACK_IMPORTED_MODULE_10_rc_util_es_Dom_addEventListener__["a" /* default */])(document, 'mouseup', this.handleMouseUp);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.onMouseUpListener) {
        this.onMouseUpListener.remove();
      }
    }
  }, {
    key: 'setClickFocus',
    value: function setClickFocus(focused) {
      this.setState({ clickFocused: focused });
    }
  }, {
    key: 'clickFocus',
    value: function clickFocus() {
      this.setClickFocus(true);
      this.focus();
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.handle.focus();
    }
  }, {
    key: 'blur',
    value: function blur() {
      this.handle.blur();
    }
  }, {
    key: 'render',
    value: function render() {
      var _ref2, _ref3;

      var _props = this.props,
          prefixCls = _props.prefixCls,
          vertical = _props.vertical,
          reverse = _props.reverse,
          offset = _props.offset,
          style = _props.style,
          disabled = _props.disabled,
          min = _props.min,
          max = _props.max,
          value = _props.value,
          tabIndex = _props.tabIndex,
          restProps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['prefixCls', 'vertical', 'reverse', 'offset', 'style', 'disabled', 'min', 'max', 'value', 'tabIndex']);

      var className = __WEBPACK_IMPORTED_MODULE_9_classnames___default()(this.props.className, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, prefixCls + '-handle-click-focused', this.state.clickFocused));
      var positionStyle = vertical ? (_ref2 = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref2, reverse ? 'top' : 'bottom', offset + '%'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref2, reverse ? 'bottom' : 'top', 'auto'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref2, 'transform', 'translateY(+50%)'), _ref2) : (_ref3 = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref3, reverse ? 'right' : 'left', offset + '%'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref3, reverse ? 'left' : 'right', 'auto'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref3, 'transform', 'translateX(' + (reverse ? '+' : '-') + '50%)'), _ref3);
      var elStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, positionStyle);

      var _tabIndex = tabIndex || 0;
      if (disabled || tabIndex === null) {
        _tabIndex = null;
      }

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        ref: this.setHandleRef,
        tabIndex: _tabIndex
      }, restProps, {
        className: className,
        style: elStyle,
        onBlur: this.handleBlur,
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleMouseDown

        // aria attribute
        , role: 'slider',
        'aria-valuemin': min,
        'aria-valuemax': max,
        'aria-valuenow': value,
        'aria-disabled': !!disabled
      }));
    }
  }]);

  return Handle;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Handle);


Handle.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  vertical: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  offset: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  style: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  disabled: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  min: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  max: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  value: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  tabIndex: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  reverse: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = isEventFromHandle;
/* harmony export (immutable) */ __webpack_exports__["i"] = isValueOutOfRange;
/* harmony export (immutable) */ __webpack_exports__["h"] = isNotTouchEvent;
/* unused harmony export getClosestPoint */
/* unused harmony export getPrecision */
/* harmony export (immutable) */ __webpack_exports__["e"] = getMousePosition;
/* harmony export (immutable) */ __webpack_exports__["f"] = getTouchPosition;
/* harmony export (immutable) */ __webpack_exports__["c"] = getHandleCenterPosition;
/* harmony export (immutable) */ __webpack_exports__["a"] = ensureValueInRange;
/* harmony export (immutable) */ __webpack_exports__["b"] = ensureValuePrecision;
/* harmony export (immutable) */ __webpack_exports__["j"] = pauseEvent;
/* unused harmony export calculateNextValue */
/* harmony export (immutable) */ __webpack_exports__["d"] = getKeyboardValueMutator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__ = __webpack_require__(1859);




function isEventFromHandle(e, handles) {
  try {
    return Object.keys(handles).some(function (key) {
      return e.target === Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(handles[key]);
    });
  } catch (error) {
    return false;
  }
}

function isValueOutOfRange(value, _ref) {
  var min = _ref.min,
      max = _ref.max;

  return value < min || value > max;
}

function isNotTouchEvent(e) {
  return e.touches.length > 1 || e.type.toLowerCase() === 'touchend' && e.touches.length > 0;
}

function getClosestPoint(val, _ref2) {
  var marks = _ref2.marks,
      step = _ref2.step,
      min = _ref2.min,
      max = _ref2.max;

  var points = Object.keys(marks).map(parseFloat);
  if (step !== null) {
    var maxSteps = Math.floor((max - min) / step);
    var steps = Math.min((val - min) / step, maxSteps);
    var closestStep = Math.round(steps) * step + min;
    points.push(closestStep);
  }
  var diffs = points.map(function (point) {
    return Math.abs(val - point);
  });
  return points[diffs.indexOf(Math.min.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(diffs)))];
}

function getPrecision(step) {
  var stepString = step.toString();
  var precision = 0;
  if (stepString.indexOf('.') >= 0) {
    precision = stepString.length - stepString.indexOf('.') - 1;
  }
  return precision;
}

function getMousePosition(vertical, e) {
  return vertical ? e.clientY : e.pageX;
}

function getTouchPosition(vertical, e) {
  return vertical ? e.touches[0].clientY : e.touches[0].pageX;
}

function getHandleCenterPosition(vertical, handle) {
  var coords = handle.getBoundingClientRect();
  return vertical ? coords.top + coords.height * 0.5 : window.pageXOffset + coords.left + coords.width * 0.5;
}

function ensureValueInRange(val, _ref3) {
  var max = _ref3.max,
      min = _ref3.min;

  if (val <= min) {
    return min;
  }
  if (val >= max) {
    return max;
  }
  return val;
}

function ensureValuePrecision(val, props) {
  var step = props.step;

  var closestPoint = isFinite(getClosestPoint(val, props)) ? getClosestPoint(val, props) : 0; // eslint-disable-line
  return step === null ? closestPoint : parseFloat(closestPoint.toFixed(getPrecision(step)));
}

function pauseEvent(e) {
  e.stopPropagation();
  e.preventDefault();
}

function calculateNextValue(func, value, props) {
  var operations = {
    increase: function increase(a, b) {
      return a + b;
    },
    decrease: function decrease(a, b) {
      return a - b;
    }
  };

  var indexToGet = operations[func](Object.keys(props.marks).indexOf(JSON.stringify(value)), 1);
  var keyToGet = Object.keys(props.marks)[indexToGet];

  if (props.step) {
    return operations[func](value, props.step);
  } else if (!!Object.keys(props.marks).length && !!props.marks[keyToGet]) {
    return props.marks[keyToGet];
  }
  return value;
}

function getKeyboardValueMutator(e, vertical, reverse) {
  var increase = 'increase';
  var decrease = 'decrease';
  var method = increase;
  switch (e.keyCode) {
    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].UP:
      method = vertical && reverse ? decrease : increase;break;
    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].RIGHT:
      method = !vertical && reverse ? decrease : increase;break;
    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].DOWN:
      method = vertical && reverse ? increase : decrease;break;
    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].LEFT:
      method = !vertical && reverse ? increase : decrease;break;

    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].END:
      return function (value, props) {
        return props.max;
      };
    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].HOME:
      return function (value, props) {
        return props.min;
      };
    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].PAGE_UP:
      return function (value, props) {
        return value + props.step * 2;
      };
    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].PAGE_DOWN:
      return function (value, props) {
        return value - props.step * 2;
      };

    default:
      return undefined;
  }
  return function (value, props) {
    return calculateNextValue(method, value, props);
  };
}

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _featureDetailRow = _interopRequireDefault(__webpack_require__(1932));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var FeatureDetailTable = function FeatureDetailTable(_ref) {
  var displayData = _ref.displayData;

  if (displayData) {
    return _react["default"].createElement("table", {
      className: "default-table table table-sm table-responsive-sm table-hover"
    }, _react["default"].createElement("tbody", null, _react["default"].createElement(_featureDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.description"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.description
    }), _react["default"].createElement(_featureDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.priority"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.priority
    }), _react["default"].createElement(_featureDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "feature.successIndicators"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.succcessIndicators
    }), _react["default"].createElement(_featureDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.startDate"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.startDate
    }), _react["default"].createElement(_featureDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.endDate"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.endDate
    })));
  } else {
    return _react["default"].createElement(_react.Fragment, null);
  }
};

var _default = FeatureDetailTable;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(FeatureDetailTable, "FeatureDetailTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/featureDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/featureDetailTable/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/featureDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/featureDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_featureDetailRow, "_featureDetailRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/featureDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/featureDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/featureDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/featureDetailTable/index.js");

  __REACT_HOT_LOADER__.register(FeatureDetailTable, "FeatureDetailTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/featureDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/featureDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/featureDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/featureDetailTable/index.js");
}();

;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactCollapsible = _interopRequireDefault(__webpack_require__(161));

var _ContainerHeader = _interopRequireDefault(__webpack_require__(63));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _basicDetailRow = _interopRequireDefault(__webpack_require__(157));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var BasicDetailDrillDown = function BasicDetailDrillDown(_ref) {
  var entries = _ref.entries,
      title = _ref.title;

  if (entries && Array.isArray(entries) && entries.length > 0) {
    return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(_ContainerHeader["default"], {
      title: title
    }), _react["default"].createElement("div", {
      className: "row"
    }, _react["default"].createElement("div", {
      className: "col-md-12 col-sm-12 col-12"
    }, entries.map(function (entry, index) {
      return _react["default"].createElement(_reactCollapsible["default"], {
        trigger: entry === null || entry === void 0 ? void 0 : entry.name,
        key: index,
        triggerStyle: {
          afterTop: 2,
          backgroundColor: 'black',
          paddingTop: 8,
          paddingBottom: 8
        }
      }, _react["default"].createElement("div", {
        className: "col-sm-12 text-center text-sm-left"
      }, _react["default"].createElement("table", {
        className: "default-table table table-sm table-responsive-sm table-hover"
      }, _react["default"].createElement("tbody", null, _react["default"].createElement(_basicDetailRow["default"], {
        label: _react["default"].createElement(_IntlMessages["default"], {
          id: "label.description"
        }),
        description: entry === null || entry === void 0 ? void 0 : entry.description
      })))));
    }))));
  } else {
    return _react["default"].createElement("div", {
      className: "row"
    }, _react["default"].createElement("div", {
      className: "col-md-12 col-12"
    }, _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(_ContainerHeader["default"], {
      title: title
    }), _react["default"].createElement("div", {
      className: "mr-auto"
    }, _react["default"].createElement("h3", {
      className: "card-heading"
    }, "No entries found here")))));
  }
};

var _default = BasicDetailDrillDown;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(BasicDetailDrillDown, "BasicDetailDrillDown", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/basicDetailDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/basicDetailDrillDown/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/basicDetailDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_reactCollapsible, "_reactCollapsible", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/basicDetailDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_ContainerHeader, "_ContainerHeader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/basicDetailDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/basicDetailDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_basicDetailRow, "_basicDetailRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/basicDetailDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/basicDetailDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/basicDetailDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/basicDetailDrillDown/index.js");

  __REACT_HOT_LOADER__.register(BasicDetailDrillDown, "BasicDetailDrillDown", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/basicDetailDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/basicDetailDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/basicDetailDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/basicDetailDrillDown/index.js");
}();

;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(158),
    overRest = __webpack_require__(643),
    setToString = __webpack_require__(431);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var CardHeader =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CardHeader, _React$Component);

  function CardHeader() {
    _classCallCheck(this, CardHeader);

    return _possibleConstructorReturn(this, _getPrototypeOf(CardHeader).apply(this, arguments));
  }

  _createClass(CardHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          heading = _this$props.heading,
          subHeading = _this$props.subHeading;
      var styleName = this.props.styleName;
      return _react["default"].createElement("div", {
        className: "jr-card-header d-flex ".concat(styleName)
      }, _react["default"].createElement("div", {
        className: "mr-auto"
      }, _react["default"].createElement("h3", {
        className: "card-heading"
      }, heading), subHeading && _react["default"].createElement("p", {
        className: "sub-heading"
      }, subHeading)), _react["default"].createElement("span", {
        className: "icon-btn size-30"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-chevron-down"
      })));
    }
  }]);

  return CardHeader;
}(_react["default"].Component);

var _default = CardHeader;
var _default2 = _default;
exports["default"] = _default2;
CardHeader.defaultProps = {
  styleName: '',
  subHeading: ''
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CardHeader, "CardHeader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/Common/CardHeader/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/Common/CardHeader/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/Common/CardHeader/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/Common/CardHeader/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/Common/CardHeader/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/Common/CardHeader/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/Common/CardHeader/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/Common/CardHeader/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/Common/CardHeader/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/Common/CardHeader/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/Common/CardHeader/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/Common/CardHeader/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/Common/CardHeader/index.js");

  __REACT_HOT_LOADER__.register(CardHeader, "CardHeader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/Common/CardHeader/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/Common/CardHeader/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/Common/CardHeader/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/Common/CardHeader/index.js");
}();

;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var SearchBox = function SearchBox(_ref) {
  var styleName = _ref.styleName,
      placeholder = _ref.placeholder,
      onChange = _ref.onChange,
      value = _ref.value;
  return _react["default"].createElement("div", {
    className: "search-bar right-side-icon bg-transparent ".concat(styleName)
  }, _react["default"].createElement("div", {
    className: "form-group"
  }, _react["default"].createElement("input", {
    className: "form-control border-0",
    type: "search",
    placeholder: placeholder,
    onChange: onChange,
    value: value
  }), _react["default"].createElement("button", {
    className: "search-icon"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-search zmdi-hc-lg"
  }))));
};

var _default = SearchBox;
var _default2 = _default;
exports["default"] = _default2;
SearchBox.defaultProps = {
  styleName: "",
  value: "",
  placeholder: "Search here.."
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SearchBox, "SearchBox", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/SearchBox/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/SearchBox/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/SearchBox/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/SearchBox/index.js");

  __REACT_HOT_LOADER__.register(SearchBox, "SearchBox", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/SearchBox/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/SearchBox/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/SearchBox/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/SearchBox/index.js");
}();

;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(1549);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(317),
    eq = __webpack_require__(234);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(58),
    isSymbol = __webpack_require__(170);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(1179),
    shortOut = __webpack_require__(849);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(635),
    baseKeysIn = __webpack_require__(1699),
    isArrayLike = __webpack_require__(130);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(1728);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1158),
    baseUnary = __webpack_require__(202),
    nodeUtil = __webpack_require__(355);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(867),
    keys = __webpack_require__(159);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(58),
    now = __webpack_require__(1590),
    toNumber = __webpack_require__(430);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 437 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onComposeMail = exports.setCurrentMailNull = exports.hideMailLoader = exports.onDeleteMail = exports.onMailToggleDrawer = exports.updateMailSearch = exports.getNavFolders = exports.onMailSelect = exports.onMailSend = exports.onImportantSelect = exports.onStartSelect = exports.onAllMailSelect = exports.onMailChecked = exports.onSearchMail = exports.getMailNavLabels = exports.getUnimportantMail = exports.getImportantMail = exports.getUnStarredMail = exports.getStarredMail = exports.getUnreadMail = exports.getReadMail = exports.getUnselectedAllMail = exports.getAllMail = exports.onOptionMenuItemSelect = exports.onMailOptionMenuSelect = exports.onMailLabelSelect = exports.onFolderSelect = exports.getMailNavFilters = exports.handleMailRequestClose = exports.onMailLabelMenuItemSelect = exports.onFolderMenuItemSelect = exports.showMailMessage = exports.fetchMailsSuccess = exports.fetchMails = void 0;

var _ActionTypes = __webpack_require__(7);

var _ActionTypes2 = __webpack_require__(7);

var fetchMails = function fetchMails() {
  return {
    type: _ActionTypes.FETCH_ALL_MAIL
  };
};

exports.fetchMails = fetchMails;

var fetchMailsSuccess = function fetchMailsSuccess(mails) {
  return {
    type: _ActionTypes2.FETCH_ALL_MAIL_SUCCESS,
    payload: mails
  };
};

exports.fetchMailsSuccess = fetchMailsSuccess;

var showMailMessage = function showMailMessage(message) {
  return {
    type: _ActionTypes2.SHOW_MESSAGE,
    payload: message
  };
};

exports.showMailMessage = showMailMessage;

var onFolderMenuItemSelect = function onFolderMenuItemSelect(folderId) {
  return {
    type: _ActionTypes.ON_FOLDER_MENU_ITEM_SELECT,
    payload: folderId
  };
};

exports.onFolderMenuItemSelect = onFolderMenuItemSelect;

var onMailLabelMenuItemSelect = function onMailLabelMenuItemSelect(label) {
  return {
    type: _ActionTypes.ON_LABEL_MENU_ITEM_SELECT,
    payload: label
  };
};

exports.onMailLabelMenuItemSelect = onMailLabelMenuItemSelect;

var handleMailRequestClose = function handleMailRequestClose() {
  return {
    type: _ActionTypes.HANDLE_REQUEST_CLOSE
  };
};

exports.handleMailRequestClose = handleMailRequestClose;

var getMailNavFilters = function getMailNavFilters(filter) {
  return {
    type: _ActionTypes.GET_NAV_FILTERS,
    payload: filter
  };
};

exports.getMailNavFilters = getMailNavFilters;

var onFolderSelect = function onFolderSelect() {
  return {
    type: _ActionTypes.ON_FOLDER_SELECT
  };
};

exports.onFolderSelect = onFolderSelect;

var onMailLabelSelect = function onMailLabelSelect() {
  return {
    type: _ActionTypes.ON_LABEL_SELECT
  };
};

exports.onMailLabelSelect = onMailLabelSelect;

var onMailOptionMenuSelect = function onMailOptionMenuSelect() {
  return {
    type: _ActionTypes.ON_OPTION_MENU_SELECT
  };
};

exports.onMailOptionMenuSelect = onMailOptionMenuSelect;

var onOptionMenuItemSelect = function onOptionMenuItemSelect(option) {
  return {
    type: _ActionTypes.ON_OPTION_MENU_ITEM_SELECT,
    payload: option
  };
};

exports.onOptionMenuItemSelect = onOptionMenuItemSelect;

var getAllMail = function getAllMail() {
  return {
    type: _ActionTypes.GET_ALL_MAIL
  };
};

exports.getAllMail = getAllMail;

var getUnselectedAllMail = function getUnselectedAllMail() {
  return {
    type: _ActionTypes.GET_UNSELECTED_ALL_MAIL
  };
};

exports.getUnselectedAllMail = getUnselectedAllMail;

var getReadMail = function getReadMail() {
  return {
    type: _ActionTypes.GET_READ_MAIL
  };
};

exports.getReadMail = getReadMail;

var getUnreadMail = function getUnreadMail() {
  return {
    type: _ActionTypes.GET_UNREAD_MAIL
  };
};

exports.getUnreadMail = getUnreadMail;

var getStarredMail = function getStarredMail() {
  return {
    type: _ActionTypes.GET_STARRED_MAIL
  };
};

exports.getStarredMail = getStarredMail;

var getUnStarredMail = function getUnStarredMail() {
  return {
    type: _ActionTypes.GET_UNSTARRED_MAIL
  };
};

exports.getUnStarredMail = getUnStarredMail;

var getImportantMail = function getImportantMail() {
  return {
    type: _ActionTypes.GET_IMPORTANT_MAIL
  };
};

exports.getImportantMail = getImportantMail;

var getUnimportantMail = function getUnimportantMail() {
  return {
    type: _ActionTypes.GET_UNIMPORTANT_MAIL
  };
};

exports.getUnimportantMail = getUnimportantMail;

var getMailNavLabels = function getMailNavLabels(label) {
  return {
    type: _ActionTypes.GET_NAV_LABELS,
    payload: label
  };
};

exports.getMailNavLabels = getMailNavLabels;

var onSearchMail = function onSearchMail(searchText) {
  return {
    type: _ActionTypes.SEARCH_MAIL,
    payload: searchText
  };
};

exports.onSearchMail = onSearchMail;

var onMailChecked = function onMailChecked(data) {
  return {
    type: _ActionTypes.ON_MAIL_CHECKED,
    payload: data
  };
};

exports.onMailChecked = onMailChecked;

var onAllMailSelect = function onAllMailSelect() {
  return {
    type: _ActionTypes.ON_ALL_MAIL_SELECT
  };
};

exports.onAllMailSelect = onAllMailSelect;

var onStartSelect = function onStartSelect(data) {
  return {
    type: _ActionTypes.ON_START_SELECT,
    payload: data
  };
};

exports.onStartSelect = onStartSelect;

var onImportantSelect = function onImportantSelect(data) {
  return {
    type: _ActionTypes.ON_IMPORTANT_SELECT,
    payload: data
  };
};

exports.onImportantSelect = onImportantSelect;

var onMailSend = function onMailSend(data) {
  return {
    type: _ActionTypes.ON_MAIL_SEND,
    payload: data
  };
};

exports.onMailSend = onMailSend;

var onMailSelect = function onMailSelect(mail) {
  return {
    type: _ActionTypes.ON_MAIL_SELECT,
    payload: mail
  };
};

exports.onMailSelect = onMailSelect;

var getNavFolders = function getNavFolders(folder) {
  return {
    type: _ActionTypes.GET_NAV_FOLDER,
    payload: folder
  };
};

exports.getNavFolders = getNavFolders;

var updateMailSearch = function updateMailSearch(searchText) {
  return {
    type: _ActionTypes.UPDATE_SEARCH,
    payload: searchText
  };
};

exports.updateMailSearch = updateMailSearch;

var onMailToggleDrawer = function onMailToggleDrawer() {
  return {
    type: _ActionTypes.ON_TOGGLE_DRAWER
  };
};

exports.onMailToggleDrawer = onMailToggleDrawer;

var onDeleteMail = function onDeleteMail() {
  return {
    type: _ActionTypes.ON_DELETE_MAIL
  };
};

exports.onDeleteMail = onDeleteMail;

var hideMailLoader = function hideMailLoader() {
  return {
    type: _ActionTypes.ON_HIDE_LOADER
  };
};

exports.hideMailLoader = hideMailLoader;

var setCurrentMailNull = function setCurrentMailNull() {
  return {
    type: _ActionTypes.SET_CURRENT_MAIL_NULL
  };
};

exports.setCurrentMailNull = setCurrentMailNull;

var onComposeMail = function onComposeMail() {
  return {
    type: _ActionTypes.ON_COMPOSE_MAIL
  };
};

exports.onComposeMail = onComposeMail;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchMails, "fetchMails", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(fetchMailsSuccess, "fetchMailsSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(showMailMessage, "showMailMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(onFolderMenuItemSelect, "onFolderMenuItemSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(onMailLabelMenuItemSelect, "onMailLabelMenuItemSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(handleMailRequestClose, "handleMailRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(getMailNavFilters, "getMailNavFilters", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(onFolderSelect, "onFolderSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(onMailLabelSelect, "onMailLabelSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(onMailOptionMenuSelect, "onMailOptionMenuSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(onOptionMenuItemSelect, "onOptionMenuItemSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(getAllMail, "getAllMail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllMail, "getUnselectedAllMail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(getReadMail, "getReadMail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(getUnreadMail, "getUnreadMail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(getStarredMail, "getStarredMail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(getUnStarredMail, "getUnStarredMail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(getImportantMail, "getImportantMail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(getUnimportantMail, "getUnimportantMail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(getMailNavLabels, "getMailNavLabels", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(onSearchMail, "onSearchMail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(onMailChecked, "onMailChecked", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(onAllMailSelect, "onAllMailSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(onStartSelect, "onStartSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(onImportantSelect, "onImportantSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(onMailSend, "onMailSend", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(onMailSelect, "onMailSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(getNavFolders, "getNavFolders", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(updateMailSearch, "updateMailSearch", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(onMailToggleDrawer, "onMailToggleDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(onDeleteMail, "onDeleteMail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(hideMailLoader, "hideMailLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(setCurrentMailNull, "setCurrentMailNull", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(onComposeMail, "onComposeMail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchMails, "fetchMails", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(fetchMailsSuccess, "fetchMailsSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(showMailMessage, "showMailMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(onFolderMenuItemSelect, "onFolderMenuItemSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(onMailLabelMenuItemSelect, "onMailLabelMenuItemSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(handleMailRequestClose, "handleMailRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(getMailNavFilters, "getMailNavFilters", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(onFolderSelect, "onFolderSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(onMailLabelSelect, "onMailLabelSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(onMailOptionMenuSelect, "onMailOptionMenuSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(onOptionMenuItemSelect, "onOptionMenuItemSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(getAllMail, "getAllMail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllMail, "getUnselectedAllMail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(getReadMail, "getReadMail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(getUnreadMail, "getUnreadMail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(getStarredMail, "getStarredMail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(getUnStarredMail, "getUnStarredMail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(getImportantMail, "getImportantMail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(getUnimportantMail, "getUnimportantMail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(getMailNavLabels, "getMailNavLabels", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(onSearchMail, "onSearchMail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(onMailChecked, "onMailChecked", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(onAllMailSelect, "onAllMailSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(onStartSelect, "onStartSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(onImportantSelect, "onImportantSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(onMailSend, "onMailSend", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(onMailSelect, "onMailSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(getNavFolders, "getNavFolders", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(updateMailSearch, "updateMailSearch", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(onMailToggleDrawer, "onMailToggleDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(onDeleteMail, "onDeleteMail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(hideMailLoader, "hideMailLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(setCurrentMailNull, "setCurrentMailNull", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(onComposeMail, "onComposeMail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Mail.js");
}();

;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleToDoMenuRequestClose = exports.hideToDoLoader = exports.updateSearch = exports.toDoToggleDrawer = exports.setCurrentToDoNull = exports.onTodoSelect = exports.onTodoAdd = exports.onTodoChecked = exports.onSearchTodo = exports.getNavLabels = exports.getNavFilters = exports.onDeleteToDo = exports.onToDoUpdate = exports.onMarkAsStart = exports.onLabelUpdate = exports.onLabelMenuItemSelect = exports.getUnimportantToDo = exports.getImportantToDo = exports.getUnStarredTodo = exports.getStarredToDo = exports.getUnselectedAllTodo = exports.getAllTodo = exports.selectAllTodo = exports.onLabelSelect = exports.onOptionMenuSelect = exports.onSortEnd = exports.showTodoMessage = exports.fetchTodosConversationSuccess = exports.fetchTodosSuccess = exports.fetchTodoConversation = exports.fetchTodo = void 0;

var _ActionTypes = __webpack_require__(7);

var fetchTodo = function fetchTodo() {
  return {
    type: _ActionTypes.FETCH_ALL_TODO
  };
};

exports.fetchTodo = fetchTodo;

var fetchTodoConversation = function fetchTodoConversation() {
  return {
    type: _ActionTypes.FETCH_ALL_TODO_CONVERSATION
  };
};

exports.fetchTodoConversation = fetchTodoConversation;

var fetchTodosSuccess = function fetchTodosSuccess(mails) {
  return {
    type: _ActionTypes.FETCH_ALL_TODO_SUCCESS,
    payload: mails
  };
};

exports.fetchTodosSuccess = fetchTodosSuccess;

var fetchTodosConversationSuccess = function fetchTodosConversationSuccess(mails) {
  return {
    type: _ActionTypes.FETCH_ALL_TODO_CONVERSATION_SUCCESS,
    payload: mails
  };
};

exports.fetchTodosConversationSuccess = fetchTodosConversationSuccess;

var showTodoMessage = function showTodoMessage(message) {
  return {
    type: _ActionTypes.SHOW_MESSAGE,
    payload: message
  };
};

exports.showTodoMessage = showTodoMessage;

var onSortEnd = function onSortEnd(data) {
  return {
    type: _ActionTypes.ON_SORTEND,
    payload: data
  };
};

exports.onSortEnd = onSortEnd;

var onOptionMenuSelect = function onOptionMenuSelect() {
  return {
    type: _ActionTypes.ON_OPTION_MENU_SELECT
  };
};

exports.onOptionMenuSelect = onOptionMenuSelect;

var onLabelSelect = function onLabelSelect() {
  return {
    type: _ActionTypes.ON_LABEL_SELECT
  };
};

exports.onLabelSelect = onLabelSelect;

var selectAllTodo = function selectAllTodo() {
  return {
    type: _ActionTypes.SELECT_ALL_TODO
  };
};

exports.selectAllTodo = selectAllTodo;

var getAllTodo = function getAllTodo() {
  return {
    type: _ActionTypes.GET_ALL_TODO
  };
};

exports.getAllTodo = getAllTodo;

var getUnselectedAllTodo = function getUnselectedAllTodo() {
  return {
    type: _ActionTypes.GET_UNSELECTED_ALL_TODO
  };
};

exports.getUnselectedAllTodo = getUnselectedAllTodo;

var getStarredToDo = function getStarredToDo() {
  return {
    type: _ActionTypes.GET_STARRED_TODO
  };
};

exports.getStarredToDo = getStarredToDo;

var getUnStarredTodo = function getUnStarredTodo() {
  return {
    type: _ActionTypes.GET_UNSTARRED_TODO
  };
};

exports.getUnStarredTodo = getUnStarredTodo;

var getImportantToDo = function getImportantToDo() {
  return {
    type: _ActionTypes.GET_IMPORTANT_TODO
  };
};

exports.getImportantToDo = getImportantToDo;

var getUnimportantToDo = function getUnimportantToDo() {
  return {
    type: _ActionTypes.GET_UNIMPORTANT_TODO
  };
};

exports.getUnimportantToDo = getUnimportantToDo;

var onLabelMenuItemSelect = function onLabelMenuItemSelect(label) {
  return {
    type: _ActionTypes.ON_LABEL_MENU_ITEM_SELECT,
    payload: label
  };
};

exports.onLabelMenuItemSelect = onLabelMenuItemSelect;

var onLabelUpdate = function onLabelUpdate(data) {
  return {
    type: _ActionTypes.ON_LABEL_UPDATE,
    payload: data
  };
};

exports.onLabelUpdate = onLabelUpdate;

var onMarkAsStart = function onMarkAsStart(data) {
  return {
    type: _ActionTypes.GET_MARK_AS_START,
    payload: data
  };
};

exports.onMarkAsStart = onMarkAsStart;

var onToDoUpdate = function onToDoUpdate(data) {
  return {
    type: _ActionTypes.ON_TODO_UPDATE,
    payload: data
  };
};

exports.onToDoUpdate = onToDoUpdate;

var onDeleteToDo = function onDeleteToDo(data) {
  return {
    type: _ActionTypes.ON_DELETE_TODO,
    payload: data
  };
};

exports.onDeleteToDo = onDeleteToDo;

var getNavFilters = function getNavFilters(data) {
  return {
    type: _ActionTypes.GET_NAV_FILTERS,
    payload: data
  };
};

exports.getNavFilters = getNavFilters;

var getNavLabels = function getNavLabels(data) {
  return {
    type: _ActionTypes.GET_NAV_LABELS,
    payload: data
  };
};

exports.getNavLabels = getNavLabels;

var onSearchTodo = function onSearchTodo(searchText) {
  return {
    type: _ActionTypes.SEARCH_TODO,
    payload: searchText
  };
};

exports.onSearchTodo = onSearchTodo;

var onTodoChecked = function onTodoChecked(data) {
  return {
    type: _ActionTypes.ON_TODO_CHECKED,
    payload: data
  };
};

exports.onTodoChecked = onTodoChecked;

var onTodoAdd = function onTodoAdd(data) {
  return {
    type: _ActionTypes.ON_TODO_ADD,
    payload: data
  };
};

exports.onTodoAdd = onTodoAdd;

var onTodoSelect = function onTodoSelect(todo) {
  return {
    type: _ActionTypes.ON_TODO_SELECT,
    payload: todo
  };
};

exports.onTodoSelect = onTodoSelect;

var setCurrentToDoNull = function setCurrentToDoNull() {
  return {
    type: _ActionTypes.SET_CURRENT_TODO_NULL
  };
};

exports.setCurrentToDoNull = setCurrentToDoNull;

var toDoToggleDrawer = function toDoToggleDrawer() {
  return {
    type: _ActionTypes.ON_TOGGLE_DRAWER
  };
};

exports.toDoToggleDrawer = toDoToggleDrawer;

var updateSearch = function updateSearch(searchTodo) {
  return {
    type: _ActionTypes.UPDATE_SEARCH,
    payload: searchTodo
  };
};

exports.updateSearch = updateSearch;

var hideToDoLoader = function hideToDoLoader() {
  return {
    type: _ActionTypes.ON_HIDE_LOADER
  };
};

exports.hideToDoLoader = hideToDoLoader;

var handleToDoMenuRequestClose = function handleToDoMenuRequestClose() {
  return {
    type: _ActionTypes.HANDLE_REQUEST_CLOSE
  };
};

exports.handleToDoMenuRequestClose = handleToDoMenuRequestClose;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchTodo, "fetchTodo", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(fetchTodoConversation, "fetchTodoConversation", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(fetchTodosSuccess, "fetchTodosSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(fetchTodosConversationSuccess, "fetchTodosConversationSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(showTodoMessage, "showTodoMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(onSortEnd, "onSortEnd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(onOptionMenuSelect, "onOptionMenuSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(onLabelSelect, "onLabelSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(selectAllTodo, "selectAllTodo", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(getAllTodo, "getAllTodo", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllTodo, "getUnselectedAllTodo", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(getStarredToDo, "getStarredToDo", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(getUnStarredTodo, "getUnStarredTodo", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(getImportantToDo, "getImportantToDo", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(getUnimportantToDo, "getUnimportantToDo", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(onLabelMenuItemSelect, "onLabelMenuItemSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(onLabelUpdate, "onLabelUpdate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(onMarkAsStart, "onMarkAsStart", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(onToDoUpdate, "onToDoUpdate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(onDeleteToDo, "onDeleteToDo", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(getNavFilters, "getNavFilters", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(getNavLabels, "getNavLabels", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(onSearchTodo, "onSearchTodo", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(onTodoChecked, "onTodoChecked", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(onTodoAdd, "onTodoAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(onTodoSelect, "onTodoSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(setCurrentToDoNull, "setCurrentToDoNull", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(toDoToggleDrawer, "toDoToggleDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(updateSearch, "updateSearch", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(hideToDoLoader, "hideToDoLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(handleToDoMenuRequestClose, "handleToDoMenuRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchTodo, "fetchTodo", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(fetchTodoConversation, "fetchTodoConversation", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(fetchTodosSuccess, "fetchTodosSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(fetchTodosConversationSuccess, "fetchTodosConversationSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(showTodoMessage, "showTodoMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(onSortEnd, "onSortEnd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(onOptionMenuSelect, "onOptionMenuSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(onLabelSelect, "onLabelSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(selectAllTodo, "selectAllTodo", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(getAllTodo, "getAllTodo", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllTodo, "getUnselectedAllTodo", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(getStarredToDo, "getStarredToDo", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(getUnStarredTodo, "getUnStarredTodo", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(getImportantToDo, "getImportantToDo", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(getUnimportantToDo, "getUnimportantToDo", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(onLabelMenuItemSelect, "onLabelMenuItemSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(onLabelUpdate, "onLabelUpdate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(onMarkAsStart, "onMarkAsStart", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(onToDoUpdate, "onToDoUpdate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(onDeleteToDo, "onDeleteToDo", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(getNavFilters, "getNavFilters", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(getNavLabels, "getNavLabels", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(onSearchTodo, "onSearchTodo", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(onTodoChecked, "onTodoChecked", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(onTodoAdd, "onTodoAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(onTodoSelect, "onTodoSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(setCurrentToDoNull, "setCurrentToDoNull", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(toDoToggleDrawer, "toDoToggleDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(updateSearch, "updateSearch", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(hideToDoLoader, "hideToDoLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(handleToDoMenuRequestClose, "handleToDoMenuRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/ToDo.js");
}();

;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideContactLoader = exports.handleRequestClose = exports.onToggleDrawer = exports.updateContactUser = exports.onAllContactSelect = exports.getUnselectedAllContact = exports.getAllContact = exports.filterContact = exports.onDeleteSelectedContact = exports.onDeleteContact = exports.onSaveContact = exports.onFilterOptionSelect = exports.onContactClose = exports.onAddContact = exports.onContactSelect = exports.addFavourite = exports.showContactMessage = exports.fetchContactsSuccess = exports.fetchContacts = void 0;

var _ActionTypes = __webpack_require__(7);

var fetchContacts = function fetchContacts() {
  return {
    type: _ActionTypes.FETCH_ALL_CONTACT
  };
};

exports.fetchContacts = fetchContacts;

var fetchContactsSuccess = function fetchContactsSuccess(contact) {
  return {
    type: _ActionTypes.FETCH_ALL_CONTACT_SUCCESS,
    payload: contact
  };
};

exports.fetchContactsSuccess = fetchContactsSuccess;

var showContactMessage = function showContactMessage(message) {
  return {
    type: _ActionTypes.SHOW_MESSAGE,
    payload: message
  };
};

exports.showContactMessage = showContactMessage;

var addFavourite = function addFavourite(data) {
  return {
    type: _ActionTypes.ADD_FAVOURITE,
    payload: data
  };
};

exports.addFavourite = addFavourite;

var onContactSelect = function onContactSelect(data) {
  return {
    type: _ActionTypes.ON_CONTACT_SELECT,
    payload: data
  };
};

exports.onContactSelect = onContactSelect;

var onAddContact = function onAddContact() {
  return {
    type: _ActionTypes.ON_ADD_CONTACT,
    payload: ''
  };
};

exports.onAddContact = onAddContact;

var onContactClose = function onContactClose() {
  return {
    type: _ActionTypes.ON_CONTACT_CLOSE,
    payload: ''
  };
};

exports.onContactClose = onContactClose;

var onFilterOptionSelect = function onFilterOptionSelect(option) {
  return {
    type: _ActionTypes.ON_FILTER_OPTION_SELECT,
    payload: option
  };
};

exports.onFilterOptionSelect = onFilterOptionSelect;

var onSaveContact = function onSaveContact(data) {
  return {
    type: _ActionTypes.ON_SAVE_CONTACT,
    payload: data
  };
};

exports.onSaveContact = onSaveContact;

var onDeleteContact = function onDeleteContact(data) {
  return {
    type: _ActionTypes.ON_DELETE_CONTACT,
    payload: data
  };
};

exports.onDeleteContact = onDeleteContact;

var onDeleteSelectedContact = function onDeleteSelectedContact() {
  return {
    type: _ActionTypes.ON_DELETE_SELECTED_CONTACT,
    payload: ''
  };
};

exports.onDeleteSelectedContact = onDeleteSelectedContact;

var filterContact = function filterContact(userName) {
  return {
    type: _ActionTypes.FILTER_CONTACT,
    payload: userName
  };
};

exports.filterContact = filterContact;

var getAllContact = function getAllContact() {
  return {
    type: _ActionTypes.GET_ALL_CONTACT,
    payload: ''
  };
};

exports.getAllContact = getAllContact;

var getUnselectedAllContact = function getUnselectedAllContact() {
  return {
    type: _ActionTypes.GET_UNSELECTED_ALL_CONTACT,
    payload: ''
  };
};

exports.getUnselectedAllContact = getUnselectedAllContact;

var onAllContactSelect = function onAllContactSelect() {
  return {
    type: _ActionTypes.ON_ALL_CONTACT_SELECT,
    payload: ''
  };
};

exports.onAllContactSelect = onAllContactSelect;

var updateContactUser = function updateContactUser(userName) {
  return {
    type: _ActionTypes.UPDATE_SEARCH_USER,
    payload: userName
  };
};

exports.updateContactUser = updateContactUser;

var onToggleDrawer = function onToggleDrawer() {
  return {
    type: _ActionTypes.ON_TOGGLE_DRAWER
  };
};

exports.onToggleDrawer = onToggleDrawer;

var handleRequestClose = function handleRequestClose() {
  return {
    type: _ActionTypes.HANDLE_REQUEST_CLOSE
  };
};

exports.handleRequestClose = handleRequestClose;

var hideContactLoader = function hideContactLoader() {
  return {
    type: _ActionTypes.HIDE_CONTACT_LOADER
  };
};

exports.hideContactLoader = hideContactLoader;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchContacts, "fetchContacts", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(fetchContactsSuccess, "fetchContactsSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(showContactMessage, "showContactMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(addFavourite, "addFavourite", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(onContactSelect, "onContactSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(onAddContact, "onAddContact", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(onContactClose, "onContactClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(onFilterOptionSelect, "onFilterOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(onSaveContact, "onSaveContact", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(onDeleteContact, "onDeleteContact", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(onDeleteSelectedContact, "onDeleteSelectedContact", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(filterContact, "filterContact", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(getAllContact, "getAllContact", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllContact, "getUnselectedAllContact", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(onAllContactSelect, "onAllContactSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(updateContactUser, "updateContactUser", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(onToggleDrawer, "onToggleDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(handleRequestClose, "handleRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(hideContactLoader, "hideContactLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchContacts, "fetchContacts", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(fetchContactsSuccess, "fetchContactsSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(showContactMessage, "showContactMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(addFavourite, "addFavourite", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(onContactSelect, "onContactSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(onAddContact, "onAddContact", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(onContactClose, "onContactClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(onFilterOptionSelect, "onFilterOptionSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(onSaveContact, "onSaveContact", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(onDeleteContact, "onDeleteContact", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(onDeleteSelectedContact, "onDeleteSelectedContact", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(filterContact, "filterContact", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(getAllContact, "getAllContact", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(getUnselectedAllContact, "getUnselectedAllContact", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(onAllContactSelect, "onAllContactSelect", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(updateContactUser, "updateContactUser", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(onToggleDrawer, "onToggleDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(handleRequestClose, "handleRequestClose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(hideContactLoader, "hideContactLoader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Contact.js");
}();

;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onChatToggleDrawer = exports.updateSearchChatUser = exports.updateMessageValue = exports.userInfoState = exports.submitComment = exports.onSelectUser = exports.filterUsers = exports.filterContacts = exports.showChatMessage = exports.fetchChatUserConversationSuccess = exports.fetchChatUserSuccess = exports.fetchChatUserConversation = exports.fetchChatUser = void 0;

var _ActionTypes = __webpack_require__(7);

var fetchChatUser = function fetchChatUser() {
  return {
    type: _ActionTypes.FETCH_ALL_CHAT_USER
  };
};

exports.fetchChatUser = fetchChatUser;

var fetchChatUserConversation = function fetchChatUserConversation() {
  return {
    type: _ActionTypes.FETCH_ALL_CHAT_USER_CONVERSATION
  };
};

exports.fetchChatUserConversation = fetchChatUserConversation;

var fetchChatUserSuccess = function fetchChatUserSuccess(mails) {
  return {
    type: _ActionTypes.FETCH_ALL_CHAT_USER_SUCCESS,
    payload: mails
  };
};

exports.fetchChatUserSuccess = fetchChatUserSuccess;

var fetchChatUserConversationSuccess = function fetchChatUserConversationSuccess(mails) {
  return {
    type: _ActionTypes.FETCH_ALL_CHAT_USER_CONVERSATION_SUCCESS,
    payload: mails
  };
};

exports.fetchChatUserConversationSuccess = fetchChatUserConversationSuccess;

var showChatMessage = function showChatMessage(message) {
  return {
    type: _ActionTypes.SHOW_MESSAGE,
    payload: message
  };
};

exports.showChatMessage = showChatMessage;

var filterContacts = function filterContacts(userName) {
  return {
    type: _ActionTypes.FILTER_CONTACT,
    payload: userName
  };
};

exports.filterContacts = filterContacts;

var filterUsers = function filterUsers(userName) {
  return {
    type: _ActionTypes.FILTER_USERS,
    payload: userName
  };
};

exports.filterUsers = filterUsers;

var onSelectUser = function onSelectUser(user) {
  return {
    type: _ActionTypes.ON_SELECT_USER,
    payload: user
  };
};

exports.onSelectUser = onSelectUser;

var submitComment = function submitComment() {
  return {
    type: _ActionTypes.SUBMIT_COMMENT
  };
};

exports.submitComment = submitComment;

var userInfoState = function userInfoState(state) {
  return {
    type: _ActionTypes.USER_INFO_STATE,
    payload: state
  };
};

exports.userInfoState = userInfoState;

var updateMessageValue = function updateMessageValue(message) {
  return {
    type: _ActionTypes.UPDATE_MESSAGE_VALUE,
    payload: message
  };
};

exports.updateMessageValue = updateMessageValue;

var updateSearchChatUser = function updateSearchChatUser(userName) {
  return {
    type: _ActionTypes.UPDATE_SEARCH_CHAT_USER,
    payload: userName
  };
};

exports.updateSearchChatUser = updateSearchChatUser;

var onChatToggleDrawer = function onChatToggleDrawer() {
  return {
    type: _ActionTypes.ON_TOGGLE_DRAWER
  };
};

exports.onChatToggleDrawer = onChatToggleDrawer;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchChatUser, "fetchChatUser", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Chat.js");

  __REACT_HOT_LOADER__.register(fetchChatUserConversation, "fetchChatUserConversation", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Chat.js");

  __REACT_HOT_LOADER__.register(fetchChatUserSuccess, "fetchChatUserSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Chat.js");

  __REACT_HOT_LOADER__.register(fetchChatUserConversationSuccess, "fetchChatUserConversationSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Chat.js");

  __REACT_HOT_LOADER__.register(showChatMessage, "showChatMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Chat.js");

  __REACT_HOT_LOADER__.register(filterContacts, "filterContacts", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Chat.js");

  __REACT_HOT_LOADER__.register(filterUsers, "filterUsers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Chat.js");

  __REACT_HOT_LOADER__.register(onSelectUser, "onSelectUser", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Chat.js");

  __REACT_HOT_LOADER__.register(submitComment, "submitComment", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Chat.js");

  __REACT_HOT_LOADER__.register(userInfoState, "userInfoState", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Chat.js");

  __REACT_HOT_LOADER__.register(updateMessageValue, "updateMessageValue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Chat.js");

  __REACT_HOT_LOADER__.register(updateSearchChatUser, "updateSearchChatUser", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Chat.js");

  __REACT_HOT_LOADER__.register(onChatToggleDrawer, "onChatToggleDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Chat.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchChatUser, "fetchChatUser", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Chat.js");

  __REACT_HOT_LOADER__.register(fetchChatUserConversation, "fetchChatUserConversation", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Chat.js");

  __REACT_HOT_LOADER__.register(fetchChatUserSuccess, "fetchChatUserSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Chat.js");

  __REACT_HOT_LOADER__.register(fetchChatUserConversationSuccess, "fetchChatUserConversationSuccess", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Chat.js");

  __REACT_HOT_LOADER__.register(showChatMessage, "showChatMessage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Chat.js");

  __REACT_HOT_LOADER__.register(filterContacts, "filterContacts", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Chat.js");

  __REACT_HOT_LOADER__.register(filterUsers, "filterUsers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Chat.js");

  __REACT_HOT_LOADER__.register(onSelectUser, "onSelectUser", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Chat.js");

  __REACT_HOT_LOADER__.register(submitComment, "submitComment", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Chat.js");

  __REACT_HOT_LOADER__.register(userInfoState, "userInfoState", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Chat.js");

  __REACT_HOT_LOADER__.register(updateMessageValue, "updateMessageValue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Chat.js");

  __REACT_HOT_LOADER__.register(updateSearchChatUser, "updateSearchChatUser", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Chat.js");

  __REACT_HOT_LOADER__.register(onChatToggleDrawer, "onChatToggleDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Chat.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/Chat.js");
}();

;

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(302);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(870));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 444 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var createRange = __webpack_require__(1684);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(436),
    isObject = __webpack_require__(58);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(160),
    baseClone = __webpack_require__(874),
    baseUnset = __webpack_require__(1712),
    castPath = __webpack_require__(235),
    copyObject = __webpack_require__(199),
    customOmitClone = __webpack_require__(1714),
    flatRest = __webpack_require__(878),
    getAllKeysIn = __webpack_require__(787);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(40) && !__webpack_require__(18)(function () {
  return Object.defineProperty(__webpack_require__(318)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(17);
var core = __webpack_require__(36);
var LIBRARY = __webpack_require__(133);
var wksExt = __webpack_require__(319);
var defineProperty = __webpack_require__(41).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(68);
var toIObject = __webpack_require__(70);
var arrayIndexOf = __webpack_require__(238)(false);
var IE_PROTO = __webpack_require__(320)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(41);
var anObject = __webpack_require__(19);
var getKeys = __webpack_require__(134);

module.exports = __webpack_require__(40) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(70);
var gOPN = __webpack_require__(137).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(40);
var getKeys = __webpack_require__(134);
var gOPS = __webpack_require__(239);
var pIE = __webpack_require__(205);
var toObject = __webpack_require__(49);
var IObject = __webpack_require__(204);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(18)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 454 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(85);
var isObject = __webpack_require__(20);
var invoke = __webpack_require__(456);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 456 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(17).parseInt;
var $trim = __webpack_require__(163).trim;
var ws = __webpack_require__(324);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(17).parseFloat;
var $trim = __webpack_require__(163).trim;

module.exports = 1 / $parseFloat(__webpack_require__(324) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(96);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(20);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 461 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(136);
var descriptor = __webpack_require__(131);
var setToStringTag = __webpack_require__(162);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(69)(IteratorPrototype, __webpack_require__(28)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(19);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(984);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(85);
var toObject = __webpack_require__(49);
var IObject = __webpack_require__(204);
var toLength = __webpack_require__(32);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(49);
var toAbsoluteIndex = __webpack_require__(135);
var toLength = __webpack_require__(32);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 467 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(339);
__webpack_require__(5)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(40) && /./g.flags != 'g') __webpack_require__(41).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(242)
});


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(133);
var global = __webpack_require__(17);
var ctx = __webpack_require__(84);
var classof = __webpack_require__(206);
var $export = __webpack_require__(5);
var isObject = __webpack_require__(20);
var aFunction = __webpack_require__(85);
var anInstance = __webpack_require__(166);
var forOf = __webpack_require__(245);
var speciesConstructor = __webpack_require__(207);
var task = __webpack_require__(341).set;
var microtask = __webpack_require__(1004)();
var newPromiseCapabilityModule = __webpack_require__(471);
var perform = __webpack_require__(1005);
var userAgent = __webpack_require__(246);
var promiseResolve = __webpack_require__(472);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(28)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(167)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(162)($Promise, PROMISE);
__webpack_require__(165)(PROMISE);
Wrapper = __webpack_require__(36)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(241)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(85);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(19);
var isObject = __webpack_require__(20);
var newPromiseCapability = __webpack_require__(471);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(41).f;
var create = __webpack_require__(136);
var redefineAll = __webpack_require__(167);
var ctx = __webpack_require__(84);
var anInstance = __webpack_require__(166);
var forOf = __webpack_require__(245);
var $iterDefine = __webpack_require__(330);
var step = __webpack_require__(467);
var setSpecies = __webpack_require__(165);
var DESCRIPTORS = __webpack_require__(40);
var fastKey = __webpack_require__(110).fastKey;
var validate = __webpack_require__(140);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(167);
var getWeak = __webpack_require__(110).getWeak;
var anObject = __webpack_require__(19);
var isObject = __webpack_require__(20);
var anInstance = __webpack_require__(166);
var forOf = __webpack_require__(245);
var createArrayMethod = __webpack_require__(89);
var $has = __webpack_require__(68);
var validate = __webpack_require__(140);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(86);
var toLength = __webpack_require__(32);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(137);
var gOPS = __webpack_require__(239);
var anObject = __webpack_require__(19);
var Reflect = __webpack_require__(17).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(32);
var repeat = __webpack_require__(326);
var defined = __webpack_require__(97);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(40);
var getKeys = __webpack_require__(134);
var toIObject = __webpack_require__(70);
var isEnum = __webpack_require__(205).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 479 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.10' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 480 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setBatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBatch; });
// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings

var getBatch = function getBatch() {
  return batch;
};

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_is__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_Subscription__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_useIsomorphicLayoutEffect__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Context__ = __webpack_require__(141);







 // Define some constant arrays just to avoid re-creating these

var EMPTY_ARRAY = [];
var NO_SUBSCRIPTION_ARRAY = [null, null];

var stringifyComponent = function stringifyComponent(Comp) {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

function storeStateUpdatesReducer(state, action) {
  var updateCount = state[1];
  return [action.payload, updateCount + 1];
}

function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
  Object(__WEBPACK_IMPORTED_MODULE_6__utils_useIsomorphicLayoutEffect__["a" /* useIsomorphicLayoutEffect */])(function () {
    return effectFunc.apply(void 0, effectArgs);
  }, dependencies);
}

function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
  // We want to capture the wrapper props and child props we used for later comparisons
  lastWrapperProps.current = wrapperProps;
  lastChildProps.current = actualChildProps;
  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

  if (childPropsFromStoreUpdate.current) {
    childPropsFromStoreUpdate.current = null;
    notifyNestedSubs();
  }
}

function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
  // If we're not subscribed to the store, nothing to do here
  if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts

  var didUnsubscribe = false;
  var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

  var checkForUpdates = function checkForUpdates() {
    if (didUnsubscribe) {
      // Don't run stale listeners.
      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
      return;
    }

    var latestStoreState = store.getState();
    var newChildProps, error;

    try {
      // Actually run the selector with the most recent store state and wrapper props
      // to determine what the child props should be
      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
    } catch (e) {
      error = e;
      lastThrownError = e;
    }

    if (!error) {
      lastThrownError = null;
    } // If the child props haven't changed, nothing to do here - cascade the subscription update


    if (newChildProps === lastChildProps.current) {
      if (!renderIsScheduled.current) {
        notifyNestedSubs();
      }
    } else {
      // Save references to the new child props.  Note that we track the "child props from store update"
      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
      // forcing another re-render, which we don't want.
      lastChildProps.current = newChildProps;
      childPropsFromStoreUpdate.current = newChildProps;
      renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render

      forceComponentUpdateDispatch({
        type: 'STORE_UPDATED',
        payload: {
          error: error
        }
      });
    }
  }; // Actually subscribe to the nearest connected ancestor (or store)


  subscription.onStateChange = checkForUpdates;
  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
  // changed since we began.

  checkForUpdates();

  var unsubscribeWrapper = function unsubscribeWrapper() {
    didUnsubscribe = true;
    subscription.tryUnsubscribe();
    subscription.onStateChange = null;

    if (lastThrownError) {
      // It's possible that we caught an error due to a bad mapState function, but the
      // parent re-rendered without this component and we're about to unmount.
      // This shouldn't happen as long as we do top-down subscriptions correctly, but
      // if we ever do those wrong, this throw will surface the error in our tests.
      // In that case, throw the error from here so it doesn't get lost.
      throw lastThrownError;
    }
  };

  return unsubscribeWrapper;
}

var initStateUpdates = function initStateUpdates() {
  return [null, 0];
};

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? __WEBPACK_IMPORTED_MODULE_7__Context__["a" /* ReactReduxContext */] : _ref2$context,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"]);

  if (false) {
    if (renderCountProp !== undefined) {
      throw new Error("renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
    }

    if (withRef) {
      throw new Error('withRef is removed. To access the wrapped instance, use a ref on the connected component');
    }

    var customStoreWarningMessage = 'To use a custom Redux store for specific components, create a custom React context with ' + "React.createContext(), and pass the context object to React Redux's Provider and specific components" + ' like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';

    if (storeKey !== 'store') {
      throw new Error('storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
    }
  }

  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    if (false) {
      throw new Error("You must pass a component to the function returned by " + (methodName + ". Instead received " + stringifyComponent(WrappedComponent)));
    }

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var pure = connectOptions.pure;

    function createChildSelector(store) {
      return selectorFactory(store.dispatch, selectorFactoryOptions);
    } // If we aren't running in "pure" mode, we don't want to memoize values.
    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
    // that just executes the given callback immediately.


    var usePureOnlyMemo = pure ? __WEBPACK_IMPORTED_MODULE_3_react__["useMemo"] : function (callback) {
      return callback();
    };

    function ConnectFunction(props) {
      var _useMemo = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        var forwardedRef = props.forwardedRef,
            wrapperProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["forwardedRef"]);

        return [props.context, forwardedRef, wrapperProps];
      }, [props]),
          propsContext = _useMemo[0],
          forwardedRef = _useMemo[1],
          wrapperProps = _useMemo[2];

      var ContextToUse = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && Object(__WEBPACK_IMPORTED_MODULE_4_react_is__["isContextConsumer"])(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      var contextValue = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(ContextToUse); // The store _must_ exist as either a prop or in context.
      // We'll check to see if it _looks_ like a Redux store first.
      // This allows us to pass through a `store` prop that is just a plain value.

      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);

      if (false) {
        throw new Error("Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
      } // Based on the previous check, one of these must be true


      var store = didStoreComeFromProps ? props.store : contextValue.store;
      var childPropsSelector = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return createChildSelector(store);
      }, [store]);

      var _useMemo2 = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var subscription = new __WEBPACK_IMPORTED_MODULE_5__utils_Subscription__["a" /* default */](store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]),
          subscription = _useMemo2[0],
          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.


      var overriddenContextValue = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, contextValue, {
          subscription: subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
      // causes a change to the calculated child component props (or we caught an error in mapState)

      var _useReducer = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useReducer"])(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
          _useReducer$ = _useReducer[0],
          previousStateUpdateResult = _useReducer$[0],
          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards


      if (previousStateUpdateResult && previousStateUpdateResult.error) {
        throw previousStateUpdateResult.error;
      } // Set up refs to coordinate values between the subscription effect and the render logic


      var lastChildProps = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])();
      var lastWrapperProps = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])(wrapperProps);
      var childPropsFromStoreUpdate = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])();
      var renderIsScheduled = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])(false);
      var actualChildProps = usePureOnlyMemo(function () {
        // Tricky logic here:
        // - This render may have been triggered by a Redux store update that produced new child props
        // - However, we may have gotten new wrapper props after that
        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
          return childPropsFromStoreUpdate.current;
        } // TODO We're reading the store directly in render() here. Bad idea?
        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
        // to determine what the child props should be.


        return childPropsSelector(store.getState(), wrapperProps);
      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]); // Our re-subscribe logic only runs when the store/subscription setup changes

      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      var renderedWrappedComponent = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(WrappedComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, actualChildProps, {
          ref: forwardedRef
        }));
      }, [forwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      var renderedChild = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.


    var Connect = pure ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.memo(ConnectFunction) : ConnectFunction;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;

    if (forwardRef) {
      var forwarded = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function forwardConnectRef(props, ref) {
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Connect, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
          forwardedRef: ref
        }));
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(forwarded, WrappedComponent);
    }

    return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useIsomorphicLayoutEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"];

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(841);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["default"]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["default"]] = observable, _ref2;
}

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(1090);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(1084);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(491);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(492);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createStoreHook;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Context__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__useReduxContext__ = __webpack_require__(494);



/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */

function createStoreHook(context) {
  if (context === void 0) {
    context = __WEBPACK_IMPORTED_MODULE_1__components_Context__["a" /* ReactReduxContext */];
  }

  var useReduxContext = context === __WEBPACK_IMPORTED_MODULE_1__components_Context__["a" /* ReactReduxContext */] ? __WEBPACK_IMPORTED_MODULE_2__useReduxContext__["a" /* useReduxContext */] : function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(context);
  };
  return function useStore() {
    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store;

    return store;
  };
}
/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */

var useStore =
/*#__PURE__*/
createStoreHook();

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useReduxContext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Context__ = __webpack_require__(141);


/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */

function useReduxContext() {
  var contextValue = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__components_Context__["a" /* ReactReduxContext */]);

  if (false) {
    throw new Error('could not find react-redux context value; please ensure the component is wrapped in a <Provider>');
  }

  return contextValue;
}

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MemoryRouter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Prompt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Redirect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Router; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return StaticRouter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Switch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return context; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return generatePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return matchPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return useHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return useLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return useParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return useRouteMatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return withRouter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_warning__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mini_create_react_context__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tiny_invariant__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_path_to_regexp__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_path_to_regexp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__);













// TODO: Replace with React.createContext once we can assume React 16+

var createNamedContext = function createNamedContext(name) {
  var context = Object(__WEBPACK_IMPORTED_MODULE_5_mini_create_react_context__["a" /* default */])();
  context.displayName = name;
  return context;
};

var context =
/*#__PURE__*/
createNamedContext("Router");

/**
 * The public API for putting history on context.
 */

var Router =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Router, _React$Component);

  Router.computeRootMatch = function computeRootMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  function Router(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      location: props.history.location
    }; // This is a bit of a hack. We have to start listening for location
    // changes here in the constructor in case there are any <Redirect>s
    // on the initial render. If there are, they will replace/push when
    // they mount and since cDM fires in children before parents, we may
    // get a new location before the <Router> is mounted.

    _this._isMounted = false;
    _this._pendingLocation = null;

    if (!props.staticContext) {
      _this.unlisten = props.history.listen(function (location) {
        if (_this._isMounted) {
          _this.setState({
            location: location
          });
        } else {
          _this._pendingLocation = location;
        }
      });
    }

    return _this;
  }

  var _proto = Router.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;

    if (this._pendingLocation) {
      this.setState({
        location: this._pendingLocation
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.unlisten) this.unlisten();
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Provider, {
      children: this.props.children || null,
      value: {
        history: this.props.history,
        location: this.state.location,
        match: Router.computeRootMatch(this.state.location.pathname),
        staticContext: this.props.staticContext
      }
    });
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Router.propTypes = {
    children: PropTypes.node,
    history: PropTypes.object.isRequired,
    staticContext: PropTypes.object
  };

  Router.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(prevProps.history === this.props.history, "You cannot change <Router history>") : void 0;
  };
}

/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props);
    return _this;
  }

  var _proto = MemoryRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  MemoryRouter.propTypes = {
    initialEntries: PropTypes.array,
    initialIndex: PropTypes.number,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number,
    children: PropTypes.node
  };

  MemoryRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.") : void 0;
  };
}

var Lifecycle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Lifecycle, _React$Component);

  function Lifecycle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Lifecycle.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.onMount) this.props.onMount.call(this, this);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.onUnmount) this.props.onUnmount.call(this, this);
  };

  _proto.render = function render() {
    return null;
  };

  return Lifecycle;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

/**
 * The public API for prompting the user before navigating away from a screen.
 */

function Prompt(_ref) {
  var message = _ref.message,
      _ref$when = _ref.when,
      when = _ref$when === void 0 ? true : _ref$when;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Prompt> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["default"])(false) : void 0;
    if (!when || context.staticContext) return null;
    var method = context.history.block;
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Lifecycle, {
      onMount: function onMount(self) {
        self.release = method(message);
      },
      onUpdate: function onUpdate(self, prevProps) {
        if (prevProps.message !== message) {
          self.release();
          self.release = method(message);
        }
      },
      onUnmount: function onUnmount(self) {
        self.release();
      },
      message: message
    });
  });
}

if (false) {
  var messageType = PropTypes.oneOfType([PropTypes.func, PropTypes.string]);
  Prompt.propTypes = {
    when: PropTypes.bool,
    message: messageType.isRequired
  };
}

var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;

function compilePath(path) {
  if (cache[path]) return cache[path];
  var generator = __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default.a.compile(path);

  if (cacheCount < cacheLimit) {
    cache[path] = generator;
    cacheCount++;
  }

  return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */


function generatePath(path, params) {
  if (path === void 0) {
    path = "/";
  }

  if (params === void 0) {
    params = {};
  }

  return path === "/" ? path : compilePath(path)(params, {
    pretty: true
  });
}

/**
 * The public API for navigating programmatically with a component.
 */

function Redirect(_ref) {
  var computedMatch = _ref.computedMatch,
      to = _ref.to,
      _ref$push = _ref.push,
      push = _ref$push === void 0 ? false : _ref$push;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Redirect> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["default"])(false) : void 0;
    var history = context.history,
        staticContext = context.staticContext;
    var method = push ? history.push : history.replace;
    var location = Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(computedMatch ? typeof to === "string" ? generatePath(to, computedMatch.params) : Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, to, {
      pathname: generatePath(to.pathname, computedMatch.params)
    }) : to); // When rendering in a static context,
    // set the new location immediately.

    if (staticContext) {
      method(location);
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Lifecycle, {
      onMount: function onMount() {
        method(location);
      },
      onUpdate: function onUpdate(self, prevProps) {
        var prevLocation = Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(prevProps.to);

        if (!Object(__WEBPACK_IMPORTED_MODULE_3_history__["f" /* locationsAreEqual */])(prevLocation, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
          key: prevLocation.key
        }))) {
          method(location);
        }
      },
      to: to
    });
  });
}

if (false) {
  Redirect.propTypes = {
    push: PropTypes.bool,
    from: PropTypes.string,
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
  };
}

var cache$1 = {};
var cacheLimit$1 = 10000;
var cacheCount$1 = 0;

function compilePath$1(path, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var pathCache = cache$1[cacheKey] || (cache$1[cacheKey] = {});
  if (pathCache[path]) return pathCache[path];
  var keys = [];
  var regexp = __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default()(path, keys, options);
  var result = {
    regexp: regexp,
    keys: keys
  };

  if (cacheCount$1 < cacheLimit$1) {
    pathCache[path] = result;
    cacheCount$1++;
  }

  return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */


function matchPath(pathname, options) {
  if (options === void 0) {
    options = {};
  }

  if (typeof options === "string" || Array.isArray(options)) {
    options = {
      path: options
    };
  }

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === void 0 ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === void 0 ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
  var paths = [].concat(path);
  return paths.reduce(function (matched, path) {
    if (!path && path !== "") return null;
    if (matched) return matched;

    var _compilePath = compilePath$1(path, {
      end: exact,
      strict: strict,
      sensitive: sensitive
    }),
        regexp = _compilePath.regexp,
        keys = _compilePath.keys;

    var match = regexp.exec(pathname);
    if (!match) return null;
    var url = match[0],
        values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
      path: path,
      // the path used to match
      url: path === "/" && url === "" ? "/" : url,
      // the matched portion of the URL
      isExact: isExact,
      // whether or not we matched exactly
      params: keys.reduce(function (memo, key, index) {
        memo[key.name] = values[index];
        return memo;
      }, {})
    };
  }, null);
}

function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.count(children) === 0;
}

function evalChildrenDev(children, props, path) {
  var value = children(props);
   false ? warning(value !== undefined, "You returned `undefined` from the `children` function of " + ("<Route" + (path ? " path=\"" + path + "\"" : "") + ">, but you ") + "should have returned a React element or `null`") : void 0;
  return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */


var Route =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Route, _React$Component);

  function Route() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Route.prototype;

  _proto.render = function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context$1) {
      !context$1 ?  false ? invariant(false, "You should not use <Route> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["default"])(false) : void 0;
      var location = _this.props.location || context$1.location;
      var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
      : _this.props.path ? matchPath(location.pathname, _this.props) : context$1.match;

      var props = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, context$1, {
        location: location,
        match: match
      });

      var _this$props = _this.props,
          children = _this$props.children,
          component = _this$props.component,
          render = _this$props.render; // Preact uses an empty array as children by
      // default, so use null if that's the case.

      if (Array.isArray(children) && children.length === 0) {
        children = null;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Provider, {
        value: props
      }, props.match ? children ? typeof children === "function" ?  false ? evalChildrenDev(children, props, _this.props.path) : children(props) : children : component ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(component, props) : render ? render(props) : null : typeof children === "function" ?  false ? evalChildrenDev(children, props, _this.props.path) : children(props) : null);
    });
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Route.propTypes = {
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
    component: function component(props, propName) {
      if (props[propName] && !isValidElementType(props[propName])) {
        return new Error("Invalid prop 'component' supplied to 'Route': the prop is not a valid React component");
      }
    },
    exact: PropTypes.bool,
    location: PropTypes.object,
    path: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    render: PropTypes.func,
    sensitive: PropTypes.bool,
    strict: PropTypes.bool
  };

  Route.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.component), "You should not use <Route component> and <Route children> in the same route; <Route component> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.render), "You should not use <Route render> and <Route children> in the same route; <Route render> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored") : void 0;
  };

  Route.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
}

function addBasename(basename, location) {
  if (!basename) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
}

function stripBasename(basename, location) {
  if (!basename) return location;
  var base = addLeadingSlash(basename);
  if (location.pathname.indexOf(base) !== 0) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: location.pathname.substr(base.length)
  });
}

function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_3_history__["e" /* createPath */])(location);
}

function staticHandler(methodName) {
  return function () {
      false ? invariant(false, "You cannot %s with <StaticRouter>", methodName) : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["default"])(false) ;
  };
}

function noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */


var StaticRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(StaticRouter, _React$Component);

  function StaticRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handlePush = function (location) {
      return _this.navigateTo(location, "PUSH");
    };

    _this.handleReplace = function (location) {
      return _this.navigateTo(location, "REPLACE");
    };

    _this.handleListen = function () {
      return noop;
    };

    _this.handleBlock = function () {
      return noop;
    };

    return _this;
  }

  var _proto = StaticRouter.prototype;

  _proto.navigateTo = function navigateTo(location, action) {
    var _this$props = this.props,
        _this$props$basename = _this$props.basename,
        basename = _this$props$basename === void 0 ? "" : _this$props$basename,
        _this$props$context = _this$props.context,
        context = _this$props$context === void 0 ? {} : _this$props$context;
    context.action = action;
    context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(location));
    context.url = createURL(context.location);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        _this$props2$basename = _this$props2.basename,
        basename = _this$props2$basename === void 0 ? "" : _this$props2$basename,
        _this$props2$context = _this$props2.context,
        context = _this$props2$context === void 0 ? {} : _this$props2$context,
        _this$props2$location = _this$props2.location,
        location = _this$props2$location === void 0 ? "/" : _this$props2$location,
        rest = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["basename", "context", "location"]);

    var history = {
      createHref: function createHref(path) {
        return addLeadingSlash(basename + createURL(path));
      },
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Router, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      history: history,
      staticContext: context
    }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  StaticRouter.propTypes = {
    basename: PropTypes.string,
    context: PropTypes.object,
    location: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  };

  StaticRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Switch, _React$Component);

  function Switch() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Switch.prototype;

  _proto.render = function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
      !context ?  false ? invariant(false, "You should not use <Switch> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["default"])(false) : void 0;
      var location = _this.props.location || context.location;
      var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
      // here because toArray adds keys to all child elements and we do not want
      // to trigger an unmount/remount for two <Route>s that render the same
      // component at different URLs.

      __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.forEach(_this.props.children, function (child) {
        if (match == null && __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(child)) {
          element = child;
          var path = child.props.path || child.props.from;
          match = path ? matchPath(location.pathname, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, child.props, {
            path: path
          })) : context.match;
        }
      });
      return match ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(element, {
        location: location,
        computedMatch: match
      }) : null;
    });
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Switch.propTypes = {
    children: PropTypes.node,
    location: PropTypes.object
  };

  Switch.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

/**
 * A public higher-order component to access the imperative API
 */

function withRouter(Component) {
  var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";

  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
      !context ?  false ? invariant(false, "You should not use <" + displayName + " /> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["default"])(false) : void 0;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, remainingProps, context, {
        ref: wrappedComponentRef
      }));
    });
  };

  C.displayName = displayName;
  C.WrappedComponent = Component;

  if (false) {
    C.propTypes = {
      wrappedComponentRef: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object])
    };
  }

  return __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default()(C, Component);
}

var useContext = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useContext;
function useHistory() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useHistory()") : invariant(false) : void 0;
  }

  return useContext(context).history;
}
function useLocation() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useLocation()") : invariant(false) : void 0;
  }

  return useContext(context).location;
}
function useParams() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useParams()") : invariant(false) : void 0;
  }

  var match = useContext(context).match;
  return match ? match.params : {};
}
function useRouteMatch(path) {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useRouteMatch()") : invariant(false) : void 0;
  }

  return path ? matchPath(useLocation().pathname, path) : useContext(context).match;
}

if (false) {
  if (typeof window !== "undefined") {
    var global = window;
    var key = "__react_router_build__";
    var buildNames = {
      cjs: "CommonJS",
      esm: "ES modules",
      umd: "UMD"
    };

    if (global[key] && global[key] !== "esm") {
      var initialBuildName = buildNames[global[key]];
      var secondaryBuildName = buildNames["esm"]; // TODO: Add link to article that explains in detail how to avoid
      // loading 2 different builds.

      throw new Error("You are loading the " + secondaryBuildName + " build of React Router " + ("on a page that is already running the " + initialBuildName + " ") + "build, so things won't work right.");
    }

    global[key] = "esm";
  }
}


//# sourceMappingURL=react-router.js.map


/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(250);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["default"])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["default"])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["default"])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["default"])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);


/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var af = moment.defineLocale('af', {
        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM : function (input) {
            return /^nm$/i.test(input);
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Vandag om] LT',
            nextDay : '[Môre om] LT',
            nextWeek : 'dddd [om] LT',
            lastDay : '[Gister om] LT',
            lastWeek : '[Laas] dddd [om] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'oor %s',
            past : '%s gelede',
            s : '\'n paar sekondes',
            ss : '%d sekondes',
            m : '\'n minuut',
            mm : '%d minute',
            h : '\'n uur',
            hh : '%d ure',
            d : '\'n dag',
            dd : '%d dae',
            M : '\'n maand',
            MM : '%d maande',
            y : '\'n jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week : {
            dow : 1, // Maandag is die eerste dag van die week.
            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        }
    });

    return af;

})));


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    }, numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    }, pluralForm = function (n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    }, plurals = {
        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    }, pluralize = function (u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    }, months = [
        'يناير',
        'فبراير',
        'مارس',
        'أبريل',
        'مايو',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمبر',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر'
    ];

    var ar = moment.defineLocale('ar', {
        months : months,
        monthsShort : months,
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/\u200FM/\u200FYYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'بعد %s',
            past : 'منذ %s',
            s : pluralize('s'),
            ss : pluralize('s'),
            m : pluralize('m'),
            mm : pluralize('m'),
            h : pluralize('h'),
            hh : pluralize('h'),
            d : pluralize('d'),
            dd : pluralize('d'),
            M : pluralize('M'),
            MM : pluralize('M'),
            y : pluralize('y'),
            yy : pluralize('y')
        },
        preparse: function (string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return ar;

})));


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arDz = moment.defineLocale('ar-dz', {
        months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return arDz;

})));


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arKw = moment.defineLocale('ar-kw', {
        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return arKw;

})));


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0'
    }, pluralForm = function (n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    }, plurals = {
        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    }, pluralize = function (u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    }, months = [
        'يناير',
        'فبراير',
        'مارس',
        'أبريل',
        'مايو',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمبر',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر'
    ];

    var arLy = moment.defineLocale('ar-ly', {
        months : months,
        monthsShort : months,
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/\u200FM/\u200FYYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'بعد %s',
            past : 'منذ %s',
            s : pluralize('s'),
            ss : pluralize('s'),
            m : pluralize('m'),
            mm : pluralize('m'),
            h : pluralize('h'),
            hh : pluralize('h'),
            d : pluralize('d'),
            dd : pluralize('d'),
            M : pluralize('M'),
            MM : pluralize('M'),
            y : pluralize('y'),
            yy : pluralize('y')
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return arLy;

})));


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arMa = moment.defineLocale('ar-ma', {
        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return arMa;

})));


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    }, numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    };

    var arSa = moment.defineLocale('ar-sa', {
        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        preparse: function (string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return arSa;

})));


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss : '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return arTn;

})));


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı'
    };

    var az = moment.defineLocale('az', {
        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[bugün saat] LT',
            nextDay : '[sabah saat] LT',
            nextWeek : '[gələn həftə] dddd [saat] LT',
            lastDay : '[dünən] LT',
            lastWeek : '[keçən həftə] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s sonra',
            past : '%s əvvəl',
            s : 'birneçə saniyə',
            ss : '%d saniyə',
            m : 'bir dəqiqə',
            mm : '%d dəqiqə',
            h : 'bir saat',
            hh : '%d saat',
            d : 'bir gün',
            dd : '%d gün',
            M : 'bir ay',
            MM : '%d ay',
            y : 'bir il',
            yy : '%d il'
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM : function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal : function (number) {
            if (number === 0) {  // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = number % 100 - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return az;

})));


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            'dd': 'дзень_дні_дзён',
            'MM': 'месяц_месяцы_месяцаў',
            'yy': 'год_гады_гадоў'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        }
        else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months : {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
        },
        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
        weekdays : {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
        },
        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY г.',
            LLL : 'D MMMM YYYY г., HH:mm',
            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
        },
        calendar : {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'праз %s',
            past : '%s таму',
            s : 'некалькі секунд',
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : relativeTimeWithPlural,
            hh : relativeTimeWithPlural,
            d : 'дзень',
            dd : relativeTimeWithPlural,
            M : 'месяц',
            MM : relativeTimeWithPlural,
            y : 'год',
            yy : relativeTimeWithPlural
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM : function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return be;

})));


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var bg = moment.defineLocale('bg', {
        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'D.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay : '[Днес в] LT',
            nextDay : '[Утре в] LT',
            nextWeek : 'dddd [в] LT',
            lastDay : '[Вчера в] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[В изминалата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[В изминалия] dddd [в] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'след %s',
            past : 'преди %s',
            s : 'няколко секунди',
            ss : '%d секунди',
            m : 'минута',
            mm : '%d минути',
            h : 'час',
            hh : '%d часа',
            d : 'ден',
            dd : '%d дни',
            M : 'месец',
            MM : '%d месеца',
            y : 'година',
            yy : '%d години'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal : function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return bg;

})));


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var bm = moment.defineLocale('bm', {
        months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
        monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'MMMM [tile] D [san] YYYY',
            LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
        },
        calendar : {
            sameDay : '[Bi lɛrɛ] LT',
            nextDay : '[Sini lɛrɛ] LT',
            nextWeek : 'dddd [don lɛrɛ] LT',
            lastDay : '[Kunu lɛrɛ] LT',
            lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s kɔnɔ',
            past : 'a bɛ %s bɔ',
            s : 'sanga dama dama',
            ss : 'sekondi %d',
            m : 'miniti kelen',
            mm : 'miniti %d',
            h : 'lɛrɛ kelen',
            hh : 'lɛrɛ %d',
            d : 'tile kelen',
            dd : 'tile %d',
            M : 'kalo kelen',
            MM : 'kalo %d',
            y : 'san kelen',
            yy : 'san %d'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return bm;

})));


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '১',
        '2': '২',
        '3': '৩',
        '4': '৪',
        '5': '৫',
        '6': '৬',
        '7': '৭',
        '8': '৮',
        '9': '৯',
        '0': '০'
    },
    numberMap = {
        '১': '1',
        '২': '2',
        '৩': '3',
        '৪': '4',
        '৫': '5',
        '৬': '6',
        '৭': '7',
        '৮': '8',
        '৯': '9',
        '০': '0'
    };

    var bn = moment.defineLocale('bn', {
        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
        longDateFormat : {
            LT : 'A h:mm সময়',
            LTS : 'A h:mm:ss সময়',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm সময়',
            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
        },
        calendar : {
            sameDay : '[আজ] LT',
            nextDay : '[আগামীকাল] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[গতকাল] LT',
            lastWeek : '[গত] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s পরে',
            past : '%s আগে',
            s : 'কয়েক সেকেন্ড',
            ss : '%d সেকেন্ড',
            m : 'এক মিনিট',
            mm : '%d মিনিট',
            h : 'এক ঘন্টা',
            hh : '%d ঘন্টা',
            d : 'এক দিন',
            dd : '%d দিন',
            M : 'এক মাস',
            MM : '%d মাস',
            y : 'এক বছর',
            yy : '%d বছর'
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'রাত' && hour >= 4) ||
                    (meridiem === 'দুপুর' && hour < 5) ||
                    meridiem === 'বিকাল') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return bn;

})));


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '༡',
        '2': '༢',
        '3': '༣',
        '4': '༤',
        '5': '༥',
        '6': '༦',
        '7': '༧',
        '8': '༨',
        '9': '༩',
        '0': '༠'
    },
    numberMap = {
        '༡': '1',
        '༢': '2',
        '༣': '3',
        '༤': '4',
        '༥': '5',
        '༦': '6',
        '༧': '7',
        '༨': '8',
        '༩': '9',
        '༠': '0'
    };

    var bo = moment.defineLocale('bo', {
        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[དི་རིང] LT',
            nextDay : '[སང་ཉིན] LT',
            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay : '[ཁ་སང] LT',
            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ལ་',
            past : '%s སྔན་ལ',
            s : 'ལམ་སང',
            ss : '%d སྐར་ཆ།',
            m : 'སྐར་མ་གཅིག',
            mm : '%d སྐར་མ',
            h : 'ཆུ་ཚོད་གཅིག',
            hh : '%d ཆུ་ཚོད',
            d : 'ཉིན་གཅིག',
            dd : '%d ཉིན་',
            M : 'ཟླ་བ་གཅིག',
            MM : '%d ཟླ་བ',
            y : 'ལོ་གཅིག',
            yy : '%d ལོ'
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
                    meridiem === 'དགོང་དག') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return bo;

})));


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            'mm': 'munutenn',
            'MM': 'miz',
            'dd': 'devezh'
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            'm': 'v',
            'b': 'v',
            'd': 'z'
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var br = moment.defineLocale('br', {
        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h[e]mm A',
            LTS : 'h[e]mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D [a viz] MMMM YYYY',
            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
        },
        calendar : {
            sameDay : '[Hiziv da] LT',
            nextDay : '[Warc\'hoazh da] LT',
            nextWeek : 'dddd [da] LT',
            lastDay : '[Dec\'h da] LT',
            lastWeek : 'dddd [paset da] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'a-benn %s',
            past : '%s \'zo',
            s : 'un nebeud segondennoù',
            ss : '%d eilenn',
            m : 'ur vunutenn',
            mm : relativeTimeWithMutation,
            h : 'un eur',
            hh : '%d eur',
            d : 'un devezh',
            dd : relativeTimeWithMutation,
            M : 'ur miz',
            MM : relativeTimeWithMutation,
            y : 'ur bloaz',
            yy : specialMutationForYears
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal : function (number) {
            var output = (number === 1) ? 'añ' : 'vet';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return br;

})));


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danas u] LT',
            nextDay  : '[sutra u] LT',
            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[jučer u] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'par sekundi',
            ss     : translate,
            m      : translate,
            mm     : translate,
            h      : translate,
            hh     : translate,
            d      : 'dan',
            dd     : translate,
            M      : 'mjesec',
            MM     : translate,
            y      : 'godinu',
            yy     : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return bs;

})));


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ca = moment.defineLocale('ca', {
        months : {
            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
            isFormat: /D[oD]?(\s)+MMMM/
        },
        monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
        monthsParseExact : true,
        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM [de] YYYY',
            ll : 'D MMM YYYY',
            LLL : 'D MMMM [de] YYYY [a les] H:mm',
            lll : 'D MMM YYYY, H:mm',
            LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll : 'ddd D MMM YYYY, H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            nextDay : function () {
                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            lastDay : function () {
                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'd\'aquí %s',
            past : 'fa %s',
            s : 'uns segons',
            ss : '%d segons',
            m : 'un minut',
            mm : '%d minuts',
            h : 'una hora',
            hh : '%d hores',
            d : 'un dia',
            dd : '%d dies',
            M : 'un mes',
            MM : '%d mesos',
            y : 'un any',
            yy : '%d anys'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal : function (number, period) {
            var output = (number === 1) ? 'r' :
                (number === 2) ? 'n' :
                (number === 3) ? 'r' :
                (number === 4) ? 't' : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ca;

})));


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');

    var monthsParse = [/^led/i, /^úno/i, /^bře/i, /^dub/i, /^kvě/i, /^(čvn|červen$|června)/i, /^(čvc|červenec|července)/i, /^srp/i, /^zář/i, /^říj/i, /^lis/i, /^pro/i];
    // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
    // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
    var monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

    function plural(n) {
        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':  // a few seconds / in a few seconds / a few seconds ago
                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
                break;
            case 'm':  // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
                break;
            case 'h':  // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
                break;
            case 'd':  // a day / in a day / a day ago
                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
                break;
            case 'M':  // a month / in a month / a month ago
                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
                break;
            case 'y':  // a year / in a year / a year ago
                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
                break;
        }
    }

    var cs = moment.defineLocale('cs', {
        months : months,
        monthsShort : monthsShort,
        monthsRegex : monthsRegex,
        monthsShortRegex : monthsRegex,
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsStrictRegex : /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex : /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,
        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat : {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd D. MMMM YYYY H:mm',
            l : 'D. M. YYYY'
        },
        calendar : {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : 'před %s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse : /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return cs;

})));


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var cv = moment.defineLocale('cv', {
        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
        },
        calendar : {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L'
        },
        relativeTime : {
            future : function (output) {
                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
                return output + affix;
            },
            past : '%s каялла',
            s : 'пӗр-ик ҫеккунт',
            ss : '%d ҫеккунт',
            m : 'пӗр минут',
            mm : '%d минут',
            h : 'пӗр сехет',
            hh : '%d сехет',
            d : 'пӗр кун',
            dd : '%d кун',
            M : 'пӗр уйӑх',
            MM : '%d уйӑх',
            y : 'пӗр ҫул',
            yy : '%d ҫул'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal : '%d-мӗш',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return cv;

})));


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact : true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS : 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return cy;

})));


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var da = moment.defineLocale('da', {
        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay : '[i dag kl.] LT',
            nextDay : '[i morgen kl.] LT',
            nextWeek : 'på dddd [kl.] LT',
            lastDay : '[i går kl.] LT',
            lastWeek : '[i] dddd[s kl.] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s siden',
            s : 'få sekunder',
            ss : '%d sekunder',
            m : 'et minut',
            mm : '%d minutter',
            h : 'en time',
            hh : '%d timer',
            d : 'en dag',
            dd : '%d dage',
            M : 'en måned',
            MM : '%d måneder',
            y : 'et år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return da;

})));


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return de;

})));


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return deAt;

})));


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return deCh;

})));


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'ޖެނުއަރީ',
        'ފެބްރުއަރީ',
        'މާރިޗު',
        'އޭޕްރީލު',
        'މޭ',
        'ޖޫން',
        'ޖުލައި',
        'އޯގަސްޓު',
        'ސެޕްޓެމްބަރު',
        'އޮކްޓޯބަރު',
        'ނޮވެމްބަރު',
        'ޑިސެމްބަރު'
    ], weekdays = [
        'އާދިއްތަ',
        'ހޯމަ',
        'އަންގާރަ',
        'ބުދަ',
        'ބުރާސްފަތި',
        'ހުކުރު',
        'ހޮނިހިރު'
    ];

    var dv = moment.defineLocale('dv', {
        months : months,
        monthsShort : months,
        weekdays : weekdays,
        weekdaysShort : weekdays,
        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat : {

            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/M/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /މކ|މފ/,
        isPM : function (input) {
            return 'މފ' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar : {
            sameDay : '[މިއަދު] LT',
            nextDay : '[މާދަމާ] LT',
            nextWeek : 'dddd LT',
            lastDay : '[އިއްޔެ] LT',
            lastWeek : '[ފާއިތުވި] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ތެރޭގައި %s',
            past : 'ކުރިން %s',
            s : 'ސިކުންތުކޮޅެއް',
            ss : 'd% ސިކުންތު',
            m : 'މިނިޓެއް',
            mm : 'މިނިޓު %d',
            h : 'ގަޑިއިރެއް',
            hh : 'ގަޑިއިރު %d',
            d : 'ދުވަހެއް',
            dd : 'ދުވަސް %d',
            M : 'މަހެއް',
            MM : 'މަސް %d',
            y : 'އަހަރެއް',
            yy : 'އަހަރު %d'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 7,  // Sunday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return dv;

})));


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }


    var el = moment.defineLocale('el', {
        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
        months : function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM : function (input) {
            return ((input + '').toLowerCase()[0] === 'μ');
        },
        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendarEl : {
            sameDay : '[Σήμερα {}] LT',
            nextDay : '[Αύριο {}] LT',
            nextWeek : 'dddd [{}] LT',
            lastDay : '[Χθες {}] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse : 'L'
        },
        calendar : function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
        },
        relativeTime : {
            future : 'σε %s',
            past : '%s πριν',
            s : 'λίγα δευτερόλεπτα',
            ss : '%d δευτερόλεπτα',
            m : 'ένα λεπτό',
            mm : '%d λεπτά',
            h : 'μία ώρα',
            hh : '%d ώρες',
            d : 'μία μέρα',
            dd : '%d μέρες',
            M : 'ένας μήνας',
            MM : '%d μήνες',
            y : 'ένας χρόνος',
            yy : '%d χρόνια'
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4st is the first week of the year.
        }
    });

    return el;

})));


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enSG = moment.defineLocale('en-SG', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enSG;

})));


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enAu = moment.defineLocale('en-au', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enAu;

})));


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enCa = moment.defineLocale('en-ca', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'YYYY-MM-DD',
            LL : 'MMMM D, YYYY',
            LLL : 'MMMM D, YYYY h:mm A',
            LLLL : 'dddd, MMMM D, YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    return enCa;

})));


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enGb = moment.defineLocale('en-gb', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enGb;

})));


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enIe = moment.defineLocale('en-ie', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enIe;

})));


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enIl = moment.defineLocale('en-il', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    return enIl;

})));


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enNz = moment.defineLocale('en-nz', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enNz;

})));


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var eo = moment.defineLocale('eo', {
        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
        weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D[-a de] MMMM, YYYY',
            LLL : 'D[-a de] MMMM, YYYY HH:mm',
            LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar : {
            sameDay : '[Hodiaŭ je] LT',
            nextDay : '[Morgaŭ je] LT',
            nextWeek : 'dddd [je] LT',
            lastDay : '[Hieraŭ je] LT',
            lastWeek : '[pasinta] dddd [je] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'post %s',
            past : 'antaŭ %s',
            s : 'sekundoj',
            ss : '%d sekundoj',
            m : 'minuto',
            mm : '%d minutoj',
            h : 'horo',
            hh : '%d horoj',
            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
            dd : '%d tagoj',
            M : 'monato',
            MM : '%d monatoj',
            y : 'jaro',
            yy : '%d jaroj'
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal : '%da',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return eo;

})));


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex : monthsRegex,
        monthsShortRegex : monthsRegex,
        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return es;

})));


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY h:mm A',
            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return esDo;

})));


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esUs = moment.defineLocale('es-us', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'MM/DD/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY h:mm A',
            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return esUs;

})));


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            'ss': [number + 'sekundi', number + 'sekundit'],
            'm' : ['ühe minuti', 'üks minut'],
            'mm': [number + ' minuti', number + ' minutit'],
            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
            'hh': [number + ' tunni', number + ' tundi'],
            'd' : ['ühe päeva', 'üks päev'],
            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
            'MM': [number + ' kuu', number + ' kuud'],
            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
            'yy': [number + ' aasta', number + ' aastat']
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat : {
            LT   : 'H:mm',
            LTS : 'H:mm:ss',
            L    : 'DD.MM.YYYY',
            LL   : 'D. MMMM YYYY',
            LLL  : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[Täna,] LT',
            nextDay  : '[Homme,] LT',
            nextWeek : '[Järgmine] dddd LT',
            lastDay  : '[Eile,] LT',
            lastWeek : '[Eelmine] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s pärast',
            past   : '%s tagasi',
            s      : processRelativeTime,
            ss     : processRelativeTime,
            m      : processRelativeTime,
            mm     : processRelativeTime,
            h      : processRelativeTime,
            hh     : processRelativeTime,
            d      : processRelativeTime,
            dd     : '%d päeva',
            M      : processRelativeTime,
            MM     : processRelativeTime,
            y      : processRelativeTime,
            yy     : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return et;

})));


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var eu = moment.defineLocale('eu', {
        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
        monthsParseExact : true,
        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY[ko] MMMM[ren] D[a]',
            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l : 'YYYY-M-D',
            ll : 'YYYY[ko] MMM D[a]',
            lll : 'YYYY[ko] MMM D[a] HH:mm',
            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
        },
        calendar : {
            sameDay : '[gaur] LT[etan]',
            nextDay : '[bihar] LT[etan]',
            nextWeek : 'dddd LT[etan]',
            lastDay : '[atzo] LT[etan]',
            lastWeek : '[aurreko] dddd LT[etan]',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s barru',
            past : 'duela %s',
            s : 'segundo batzuk',
            ss : '%d segundo',
            m : 'minutu bat',
            mm : '%d minutu',
            h : 'ordu bat',
            hh : '%d ordu',
            d : 'egun bat',
            dd : '%d egun',
            M : 'hilabete bat',
            MM : '%d hilabete',
            y : 'urte bat',
            yy : '%d urte'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return eu;

})));


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '۱',
        '2': '۲',
        '3': '۳',
        '4': '۴',
        '5': '۵',
        '6': '۶',
        '7': '۷',
        '8': '۸',
        '9': '۹',
        '0': '۰'
    }, numberMap = {
        '۱': '1',
        '۲': '2',
        '۳': '3',
        '۴': '4',
        '۵': '5',
        '۶': '6',
        '۷': '7',
        '۸': '8',
        '۹': '9',
        '۰': '0'
    };

    var fa = moment.defineLocale('fa', {
        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar : {
            sameDay : '[امروز ساعت] LT',
            nextDay : '[فردا ساعت] LT',
            nextWeek : 'dddd [ساعت] LT',
            lastDay : '[دیروز ساعت] LT',
            lastWeek : 'dddd [پیش] [ساعت] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'در %s',
            past : '%s پیش',
            s : 'چند ثانیه',
            ss : 'ثانیه d%',
            m : 'یک دقیقه',
            mm : '%d دقیقه',
            h : 'یک ساعت',
            hh : '%d ساعت',
            d : 'یک روز',
            dd : '%d روز',
            M : 'یک ماه',
            MM : '%d ماه',
            y : 'یک سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/[۰-۹]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal : '%dم',
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12 // The week that contains Jan 12th is the first week of the year.
        }
    });

    return fa;

})));


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
        numbersFuture = [
            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
            numbersPast[7], numbersPast[8], numbersPast[9]
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                return isFuture ? 'sekunnin' : 'sekuntia';
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
    }

    var fi = moment.defineLocale('fi', {
        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD.MM.YYYY',
            LL : 'Do MMMM[ta] YYYY',
            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l : 'D.M.YYYY',
            ll : 'Do MMM YYYY',
            lll : 'Do MMM YYYY, [klo] HH.mm',
            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
        },
        calendar : {
            sameDay : '[tänään] [klo] LT',
            nextDay : '[huomenna] [klo] LT',
            nextWeek : 'dddd [klo] LT',
            lastDay : '[eilen] [klo] LT',
            lastWeek : '[viime] dddd[na] [klo] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s päästä',
            past : '%s sitten',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fi;

})));


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var fo = moment.defineLocale('fo', {
        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D. MMMM, YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Í dag kl.] LT',
            nextDay : '[Í morgin kl.] LT',
            nextWeek : 'dddd [kl.] LT',
            lastDay : '[Í gjár kl.] LT',
            lastWeek : '[síðstu] dddd [kl] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'um %s',
            past : '%s síðani',
            s : 'fá sekund',
            ss : '%d sekundir',
            m : 'ein minuttur',
            mm : '%d minuttir',
            h : 'ein tími',
            hh : '%d tímar',
            d : 'ein dagur',
            dd : '%d dagar',
            M : 'ein mánaður',
            MM : '%d mánaðir',
            y : 'eitt ár',
            yy : '%d ár'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fo;

})));


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var fr = moment.defineLocale('fr', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal : function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fr;

})));


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var frCa = moment.defineLocale('fr-ca', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal : function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        }
    });

    return frCa;

})));


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var frCh = moment.defineLocale('fr-ch', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal : function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return frCh;

})));


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

    var fy = moment.defineLocale('fy', {
        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact : true,
        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'oer %s',
            past : '%s lyn',
            s : 'in pear sekonden',
            ss : '%d sekonden',
            m : 'ien minút',
            mm : '%d minuten',
            h : 'ien oere',
            hh : '%d oeren',
            d : 'ien dei',
            dd : '%d dagen',
            M : 'ien moanne',
            MM : '%d moannen',
            y : 'ien jier',
            yy : '%d jierren'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fy;

})));


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



    var months = [
        'Eanáir', 'Feabhra', 'Márta', 'Aibreán', 'Bealtaine', 'Méitheamh', 'Iúil', 'Lúnasa', 'Meán Fómhair', 'Deaireadh Fómhair', 'Samhain', 'Nollaig'
    ];

    var monthsShort = ['Eaná', 'Feab', 'Márt', 'Aibr', 'Beal', 'Méit', 'Iúil', 'Lúna', 'Meán', 'Deai', 'Samh', 'Noll'];

    var weekdays = ['Dé Domhnaigh', 'Dé Luain', 'Dé Máirt', 'Dé Céadaoin', 'Déardaoin', 'Dé hAoine', 'Dé Satharn'];

    var weekdaysShort = ['Dom', 'Lua', 'Mái', 'Céa', 'Déa', 'hAo', 'Sat'];

    var weekdaysMin = ['Do', 'Lu', 'Má', 'Ce', 'Dé', 'hA', 'Sa'];

    var ga = moment.defineLocale('ga', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Inniu ag] LT',
            nextDay: '[Amárach ag] LT',
            nextWeek: 'dddd [ag] LT',
            lastDay: '[Inné aig] LT',
            lastWeek: 'dddd [seo caite] [ag] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'i %s',
            past: '%s ó shin',
            s: 'cúpla soicind',
            ss: '%d soicind',
            m: 'nóiméad',
            mm: '%d nóiméad',
            h: 'uair an chloig',
            hh: '%d uair an chloig',
            d: 'lá',
            dd: '%d lá',
            M: 'mí',
            MM: '%d mí',
            y: 'bliain',
            yy: '%d bliain'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ga;

})));


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
    ];

    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];

    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];

    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];

    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months : months,
        monthsShort : monthsShort,
        monthsParseExact : true,
        weekdays : weekdays,
        weekdaysShort : weekdaysShort,
        weekdaysMin : weekdaysMin,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[An-diugh aig] LT',
            nextDay : '[A-màireach aig] LT',
            nextWeek : 'dddd [aig] LT',
            lastDay : '[An-dè aig] LT',
            lastWeek : 'dddd [seo chaidh] [aig] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ann an %s',
            past : 'bho chionn %s',
            s : 'beagan diogan',
            ss : '%d diogan',
            m : 'mionaid',
            mm : '%d mionaidean',
            h : 'uair',
            hh : '%d uairean',
            d : 'latha',
            dd : '%d latha',
            M : 'mìos',
            MM : '%d mìosan',
            y : 'bliadhna',
            yy : '%d bliadhna'
        },
        dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
        ordinal : function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return gd;

})));


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var gl = moment.defineLocale('gl', {
        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
            },
            nextDay : function () {
                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
            },
            lastDay : function () {
                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
            },
            lastWeek : function () {
                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past : 'hai %s',
            s : 'uns segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'unha hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return gl;

})));


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's': ['thodde secondanim', 'thodde second'],
            'ss': [number + ' secondanim', number + ' second'],
            'm': ['eka mintan', 'ek minute'],
            'mm': [number + ' mintanim', number + ' mintam'],
            'h': ['eka voran', 'ek vor'],
            'hh': [number + ' voranim', number + ' voram'],
            'd': ['eka disan', 'ek dis'],
            'dd': [number + ' disanim', number + ' dis'],
            'M': ['eka mhoinean', 'ek mhoino'],
            'MM': [number + ' mhoineanim', number + ' mhoine'],
            'y': ['eka vorsan', 'ek voros'],
            'yy': [number + ' vorsanim', number + ' vorsam']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
        monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
        weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'A h:mm [vazta]',
            LTS : 'A h:mm:ss [vazta]',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY A h:mm [vazta]',
            LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
        },
        calendar : {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Ieta to] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fatlo] dddd[,] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s',
            past : '%s adim',
            s : processRelativeTime,
            ss : processRelativeTime,
            m : processRelativeTime,
            mm : processRelativeTime,
            h : processRelativeTime,
            hh : processRelativeTime,
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse : /\d{1,2}(er)/,
        ordinal : function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /rati|sokalli|donparam|sanje/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokalli') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokalli';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        }
    });

    return gomLatn;

})));


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
            '1': '૧',
            '2': '૨',
            '3': '૩',
            '4': '૪',
            '5': '૫',
            '6': '૬',
            '7': '૭',
            '8': '૮',
            '9': '૯',
            '0': '૦'
        },
        numberMap = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0'
        };

    var gu = moment.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પેહલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ'
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return gu;

})));


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var he = moment.defineLocale('he', {
        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [ב]MMMM YYYY',
            LLL : 'D [ב]MMMM YYYY HH:mm',
            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
            l : 'D/M/YYYY',
            ll : 'D MMM YYYY',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd, D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[היום ב־]LT',
            nextDay : '[מחר ב־]LT',
            nextWeek : 'dddd [בשעה] LT',
            lastDay : '[אתמול ב־]LT',
            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'בעוד %s',
            past : 'לפני %s',
            s : 'מספר שניות',
            ss : '%d שניות',
            m : 'דקה',
            mm : '%d דקות',
            h : 'שעה',
            hh : function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d : 'יום',
            dd : function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M : 'חודש',
            MM : function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y : 'שנה',
            yy : function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            }
        },
        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM : function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        }
    });

    return he;

})));


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    var hi = moment.defineLocale('hi', {
        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
        monthsParseExact: true,
        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat : {
            LT : 'A h:mm बजे',
            LTS : 'A h:mm:ss बजे',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm बजे',
            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[कल] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[कल] LT',
            lastWeek : '[पिछले] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s में',
            past : '%s पहले',
            s : 'कुछ ही क्षण',
            ss : '%d सेकंड',
            m : 'एक मिनट',
            mm : '%d मिनट',
            h : 'एक घंटा',
            hh : '%d घंटे',
            d : 'एक दिन',
            dd : '%d दिन',
            M : 'एक महीने',
            MM : '%d महीने',
            y : 'एक वर्ष',
            yy : '%d वर्ष'
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return hi;

})));


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months : {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
        },
        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danas u] LT',
            nextDay  : '[sutra u] LT',
            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[jučer u] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'par sekundi',
            ss     : translate,
            m      : translate,
            mm     : translate,
            h      : translate,
            hh     : translate,
            d      : 'dan',
            dd     : translate,
            M      : 'mjesec',
            MM     : translate,
            y      : 'godinu',
            yy     : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return hr;

})));


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
    }

    var hu = moment.defineLocale('hu', {
        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'YYYY.MM.DD.',
            LL : 'YYYY. MMMM D.',
            LLL : 'YYYY. MMMM D. H:mm',
            LLLL : 'YYYY. MMMM D., dddd H:mm'
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar : {
            sameDay : '[ma] LT[-kor]',
            nextDay : '[holnap] LT[-kor]',
            nextWeek : function () {
                return week.call(this, true);
            },
            lastDay : '[tegnap] LT[-kor]',
            lastWeek : function () {
                return week.call(this, false);
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s múlva',
            past : '%s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return hu;

})));


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var hyAm = moment.defineLocale('hy-am', {
        months : {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
        },
        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY թ.',
            LLL : 'D MMMM YYYY թ., HH:mm',
            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
        },
        calendar : {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s հետո',
            past : '%s առաջ',
            s : 'մի քանի վայրկյան',
            ss : '%d վայրկյան',
            m : 'րոպե',
            mm : '%d րոպե',
            h : 'ժամ',
            hh : '%d ժամ',
            d : 'օր',
            dd : '%d օր',
            M : 'ամիս',
            MM : '%d ամիս',
            y : 'տարի',
            yy : '%d տարի'
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem : function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return hyAm;

})));


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var id = moment.defineLocale('id', {
        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Besok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kemarin pukul] LT',
            lastWeek : 'dddd [lalu pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lalu',
            s : 'beberapa detik',
            ss : '%d detik',
            m : 'semenit',
            mm : '%d menit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return id;

})));


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
            case 'ss':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] H:mm',
            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
        },
        calendar : {
            sameDay : '[í dag kl.] LT',
            nextDay : '[á morgun kl.] LT',
            nextWeek : 'dddd [kl.] LT',
            lastDay : '[í gær kl.] LT',
            lastWeek : '[síðasta] dddd [kl.] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'eftir %s',
            past : 'fyrir %s síðan',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : 'klukkustund',
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return is;

})));


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var it = moment.defineLocale('it', {
        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : function (s) {
                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past : '%s fa',
            s : 'alcuni secondi',
            ss : '%d secondi',
            m : 'un minuto',
            mm : '%d minuti',
            h : 'un\'ora',
            hh : '%d ore',
            d : 'un giorno',
            dd : '%d giorni',
            M : 'un mese',
            MM : '%d mesi',
            y : 'un anno',
            yy : '%d anni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return it;

})));


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var itCh = moment.defineLocale('it-ch', {
        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : function (s) {
                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past : '%s fa',
            s : 'alcuni secondi',
            ss : '%d secondi',
            m : 'un minuto',
            mm : '%d minuti',
            h : 'un\'ora',
            hh : '%d ore',
            d : 'un giorno',
            dd : '%d giorni',
            M : 'un mese',
            MM : '%d mesi',
            y : 'un anno',
            yy : '%d anni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return itCh;

})));


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ja = moment.defineLocale('ja', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日 dddd HH:mm',
            l : 'YYYY/MM/DD',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日(ddd) HH:mm'
        },
        meridiemParse: /午前|午後/i,
        isPM : function (input) {
            return input === '午後';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar : {
            sameDay : '[今日] LT',
            nextDay : '[明日] LT',
            nextWeek : function (now) {
                if (now.week() < this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay : '[昨日] LT',
            lastWeek : function (now) {
                if (this.week() < now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse : /\d{1,2}日/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime : {
            future : '%s後',
            past : '%s前',
            s : '数秒',
            ss : '%d秒',
            m : '1分',
            mm : '%d分',
            h : '1時間',
            hh : '%d時間',
            d : '1日',
            dd : '%d日',
            M : '1ヶ月',
            MM : '%dヶ月',
            y : '1年',
            yy : '%d年'
        }
    });

    return ja;

})));


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var jv = moment.defineLocale('jv', {
        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar : {
            sameDay : '[Dinten puniko pukul] LT',
            nextDay : '[Mbenjang pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kala wingi pukul] LT',
            lastWeek : 'dddd [kepengker pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'wonten ing %s',
            past : '%s ingkang kepengker',
            s : 'sawetawis detik',
            ss : '%d detik',
            m : 'setunggal menit',
            mm : '%d menit',
            h : 'setunggal jam',
            hh : '%d jam',
            d : 'sedinten',
            dd : '%d dinten',
            M : 'sewulan',
            MM : '%d wulan',
            y : 'setaun',
            yy : '%d taun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return jv;

})));


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ka = moment.defineLocale('ka', {
        months : {
            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
        },
        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays : {
            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
            isFormat: /(წინა|შემდეგ)/
        },
        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[დღეს] LT[-ზე]',
            nextDay : '[ხვალ] LT[-ზე]',
            lastDay : '[გუშინ] LT[-ზე]',
            nextWeek : '[შემდეგ] dddd LT[-ზე]',
            lastWeek : '[წინა] dddd LT-ზე',
            sameElse : 'L'
        },
        relativeTime : {
            future : function (s) {
                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
                    s.replace(/ი$/, 'ში') :
                    s + 'ში';
            },
            past : function (s) {
                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if ((/წელი/).test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
            },
            s : 'რამდენიმე წამი',
            ss : '%d წამი',
            m : 'წუთი',
            mm : '%d წუთი',
            h : 'საათი',
            hh : '%d საათი',
            d : 'დღე',
            dd : '%d დღე',
            M : 'თვე',
            MM : '%d თვე',
            y : 'წელი',
            yy : '%d წელი'
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal : function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week : {
            dow : 1,
            doy : 7
        }
    });

    return ka;

})));


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші'
    };

    var kk = moment.defineLocale('kk', {
        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Бүгін сағат] LT',
            nextDay : '[Ертең сағат] LT',
            nextWeek : 'dddd [сағат] LT',
            lastDay : '[Кеше сағат] LT',
            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ішінде',
            past : '%s бұрын',
            s : 'бірнеше секунд',
            ss : '%d секунд',
            m : 'бір минут',
            mm : '%d минут',
            h : 'бір сағат',
            hh : '%d сағат',
            d : 'бір күн',
            dd : '%d күн',
            M : 'бір ай',
            MM : '%d ай',
            y : 'бір жыл',
            yy : '%d жыл'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal : function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return kk;

})));


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '១',
        '2': '២',
        '3': '៣',
        '4': '៤',
        '5': '៥',
        '6': '៦',
        '7': '៧',
        '8': '៨',
        '9': '៩',
        '0': '០'
    }, numberMap = {
        '១': '1',
        '២': '2',
        '៣': '3',
        '៤': '4',
        '៥': '5',
        '៦': '6',
        '៧': '7',
        '៨': '8',
        '៩': '9',
        '០': '0'
    };

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ'
        },
        dayOfMonthOrdinalParse : /ទី\d{1,2}/,
        ordinal : 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return km;

})));


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '೧',
        '2': '೨',
        '3': '೩',
        '4': '೪',
        '5': '೫',
        '6': '೬',
        '7': '೭',
        '8': '೮',
        '9': '೯',
        '0': '೦'
    },
    numberMap = {
        '೧': '1',
        '೨': '2',
        '೩': '3',
        '೪': '4',
        '೫': '5',
        '೬': '6',
        '೭': '7',
        '೮': '8',
        '೯': '9',
        '೦': '0'
    };

    var kn = moment.defineLocale('kn', {
        months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
        monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
        monthsParseExact: true,
        weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
        weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[ಇಂದು] LT',
            nextDay : '[ನಾಳೆ] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[ನಿನ್ನೆ] LT',
            lastWeek : '[ಕೊನೆಯ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ನಂತರ',
            past : '%s ಹಿಂದೆ',
            s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss : '%d ಸೆಕೆಂಡುಗಳು',
            m : 'ಒಂದು ನಿಮಿಷ',
            mm : '%d ನಿಮಿಷ',
            h : 'ಒಂದು ಗಂಟೆ',
            hh : '%d ಗಂಟೆ',
            d : 'ಒಂದು ದಿನ',
            dd : '%d ದಿನ',
            M : 'ಒಂದು ತಿಂಗಳು',
            MM : '%d ತಿಂಗಳು',
            y : 'ಒಂದು ವರ್ಷ',
            yy : '%d ವರ್ಷ'
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal : function (number) {
            return number + 'ನೇ';
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return kn;

})));


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ko = moment.defineLocale('ko', {
        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'YYYY.MM.DD.',
            LL : 'YYYY년 MMMM D일',
            LLL : 'YYYY년 MMMM D일 A h:mm',
            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
            l : 'YYYY.MM.DD.',
            ll : 'YYYY년 MMMM D일',
            lll : 'YYYY년 MMMM D일 A h:mm',
            llll : 'YYYY년 MMMM D일 dddd A h:mm'
        },
        calendar : {
            sameDay : '오늘 LT',
            nextDay : '내일 LT',
            nextWeek : 'dddd LT',
            lastDay : '어제 LT',
            lastWeek : '지난주 dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s 후',
            past : '%s 전',
            s : '몇 초',
            ss : '%d초',
            m : '1분',
            mm : '%d분',
            h : '한 시간',
            hh : '%d시간',
            d : '하루',
            dd : '%d일',
            M : '한 달',
            MM : '%d달',
            y : '일 년',
            yy : '%d년'
        },
        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse : /오전|오후/,
        isPM : function (token) {
            return token === '오후';
        },
        meridiem : function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        }
    });

    return ko;

})));


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    }, numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    },
    months = [
        'کانونی دووەم',
        'شوبات',
        'ئازار',
        'نیسان',
        'ئایار',
        'حوزەیران',
        'تەمموز',
        'ئاب',
        'ئەیلوول',
        'تشرینی یەكەم',
        'تشرینی دووەم',
        'كانونی یەکەم'
    ];


    var ku = moment.defineLocale('ku', {
        months : months,
        monthsShort : months,
        weekdays : 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split('_'),
        weekdaysShort : 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
        weekdaysMin : 'ی_د_س_چ_پ_ه_ش'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function (input) {
            return /ئێواره‌/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'به‌یانی';
            } else {
                return 'ئێواره‌';
            }
        },
        calendar : {
            sameDay : '[ئه‌مرۆ كاتژمێر] LT',
            nextDay : '[به‌یانی كاتژمێر] LT',
            nextWeek : 'dddd [كاتژمێر] LT',
            lastDay : '[دوێنێ كاتژمێر] LT',
            lastWeek : 'dddd [كاتژمێر] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'له‌ %s',
            past : '%s',
            s : 'چه‌ند چركه‌یه‌ك',
            ss : 'چركه‌ %d',
            m : 'یه‌ك خوله‌ك',
            mm : '%d خوله‌ك',
            h : 'یه‌ك كاتژمێر',
            hh : '%d كاتژمێر',
            d : 'یه‌ك ڕۆژ',
            dd : '%d ڕۆژ',
            M : 'یه‌ك مانگ',
            MM : '%d مانگ',
            y : 'یه‌ك ساڵ',
            yy : '%d ساڵ'
        },
        preparse: function (string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12 // The week that contains Jan 12th is the first week of the year.
        }
    });

    return ku;

})));


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү'
    };

    var ky = moment.defineLocale('ky', {
        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Бүгүн саат] LT',
            nextDay : '[Эртең саат] LT',
            nextWeek : 'dddd [саат] LT',
            lastDay : '[Кечээ саат] LT',
            lastWeek : '[Өткөн аптанын] dddd [күнү] [саат] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ичинде',
            past : '%s мурун',
            s : 'бирнече секунд',
            ss : '%d секунд',
            m : 'бир мүнөт',
            mm : '%d мүнөт',
            h : 'бир саат',
            hh : '%d саат',
            d : 'бир күн',
            dd : '%d күн',
            M : 'бир ай',
            MM : '%d ай',
            y : 'бир жыл',
            yy : '%d жыл'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal : function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return ky;

})));


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eng Minutt', 'enger Minutt'],
            'h': ['eng Stonn', 'enger Stonn'],
            'd': ['een Dag', 'engem Dag'],
            'M': ['ee Mount', 'engem Mount'],
            'y': ['ee Joer', 'engem Joer']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10, firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            }
        },
        relativeTime : {
            future : processFutureTime,
            past : processPastTime,
            s : 'e puer Sekonnen',
            ss : '%d Sekonnen',
            m : processRelativeTime,
            mm : '%d Minutten',
            h : processRelativeTime,
            hh : '%d Stonnen',
            d : processRelativeTime,
            dd : '%d Deeg',
            M : processRelativeTime,
            MM : '%d Méint',
            y : processRelativeTime,
            yy : '%d Joer'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lb;

})));


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var lo = moment.defineLocale('lo', {
        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar : {
            sameDay : '[ມື້ນີ້ເວລາ] LT',
            nextDay : '[ມື້ອື່ນເວລາ] LT',
            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ອີກ %s',
            past : '%sຜ່ານມາ',
            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss : '%d ວິນາທີ' ,
            m : '1 ນາທີ',
            mm : '%d ນາທີ',
            h : '1 ຊົ່ວໂມງ',
            hh : '%d ຊົ່ວໂມງ',
            d : '1 ມື້',
            dd : '%d ມື້',
            M : '1 ເດືອນ',
            MM : '%d ເດືອນ',
            y : '1 ປີ',
            yy : '%d ປີ'
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal : function (number) {
            return 'ທີ່' + number;
        }
    });

    return lo;

})));


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var units = {
        'ss' : 'sekundė_sekundžių_sekundes',
        'm' : 'minutė_minutės_minutę',
        'mm': 'minutės_minučių_minutes',
        'h' : 'valanda_valandos_valandą',
        'hh': 'valandos_valandų_valandas',
        'd' : 'diena_dienos_dieną',
        'dd': 'dienos_dienų_dienas',
        'M' : 'mėnuo_mėnesio_mėnesį',
        'MM': 'mėnesiai_mėnesių_mėnesius',
        'y' : 'metai_metų_metus',
        'yy': 'metai_metų_metus'
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months : {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
        },
        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays : {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
            isFormat: /dddd HH:mm/
        },
        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY [m.] MMMM D [d.]',
            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l : 'YYYY-MM-DD',
            ll : 'YYYY [m.] MMMM D [d.]',
            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
        },
        calendar : {
            sameDay : '[Šiandien] LT',
            nextDay : '[Rytoj] LT',
            nextWeek : 'dddd LT',
            lastDay : '[Vakar] LT',
            lastWeek : '[Praėjusį] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'po %s',
            past : 'prieš %s',
            s : translateSeconds,
            ss : translate,
            m : translateSingular,
            mm : translate,
            h : translateSingular,
            hh : translate,
            d : translateSingular,
            dd : translate,
            M : translateSingular,
            MM : translate,
            y : translateSingular,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal : function (number) {
            return number + '-oji';
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lt;

})));


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var units = {
        'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        'h': 'stundas_stundām_stunda_stundas'.split('_'),
        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
        'd': 'dienas_dienām_diena_dienas'.split('_'),
        'dd': 'dienas_dienām_diena_dienas'.split('_'),
        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        'y': 'gada_gadiem_gads_gadi'.split('_'),
        'yy': 'gada_gadiem_gads_gadi'.split('_')
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY.',
            LL : 'YYYY. [gada] D. MMMM',
            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
        },
        calendar : {
            sameDay : '[Šodien pulksten] LT',
            nextDay : '[Rīt pulksten] LT',
            nextWeek : 'dddd [pulksten] LT',
            lastDay : '[Vakar pulksten] LT',
            lastWeek : '[Pagājušā] dddd [pulksten] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'pēc %s',
            past : 'pirms %s',
            s : relativeSeconds,
            ss : relativeTimeWithPlural,
            m : relativeTimeWithSingular,
            mm : relativeTimeWithPlural,
            h : relativeTimeWithSingular,
            hh : relativeTimeWithPlural,
            d : relativeTimeWithSingular,
            dd : relativeTimeWithPlural,
            M : relativeTimeWithSingular,
            MM : relativeTimeWithPlural,
            y : relativeTimeWithSingular,
            yy : relativeTimeWithPlural
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lv;

})));


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact : true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[juče u] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'nekoliko sekundi',
            ss     : translator.translate,
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'dan',
            dd     : translator.translate,
            M      : 'mjesec',
            MM     : translator.translate,
            y      : 'godinu',
            yy     : translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return me;

})));


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return mi;

})));


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var mk = moment.defineLocale('mk', {
        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'D.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay : '[Денес во] LT',
            nextDay : '[Утре во] LT',
            nextWeek : '[Во] dddd [во] LT',
            lastDay : '[Вчера во] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'после %s',
            past : 'пред %s',
            s : 'неколку секунди',
            ss : '%d секунди',
            m : 'минута',
            mm : '%d минути',
            h : 'час',
            hh : '%d часа',
            d : 'ден',
            dd : '%d дена',
            M : 'месец',
            MM : '%d месеци',
            y : 'година',
            yy : '%d години'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal : function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return mk;

})));


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ml = moment.defineLocale('ml', {
        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
        monthsParseExact : true,
        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm -നു',
            LTS : 'A h:mm:ss -നു',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm -നു',
            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
        },
        calendar : {
            sameDay : '[ഇന്ന്] LT',
            nextDay : '[നാളെ] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[ഇന്നലെ] LT',
            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s കഴിഞ്ഞ്',
            past : '%s മുൻപ്',
            s : 'അൽപ നിമിഷങ്ങൾ',
            ss : '%d സെക്കൻഡ്',
            m : 'ഒരു മിനിറ്റ്',
            mm : '%d മിനിറ്റ്',
            h : 'ഒരു മണിക്കൂർ',
            hh : '%d മണിക്കൂർ',
            d : 'ഒരു ദിവസം',
            dd : '%d ദിവസം',
            M : 'ഒരു മാസം',
            MM : '%d മാസം',
            y : 'ഒരു വർഷം',
            yy : '%d വർഷം'
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'രാത്രി' && hour >= 4) ||
                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                    meridiem === 'വൈകുന്നേരം') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        }
    });

    return ml;

})));


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function translate(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    var mn = moment.defineLocale('mn', {
        months : 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
        monthsShort : '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
        monthsParseExact : true,
        weekdays : 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort : 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin : 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY оны MMMMын D',
            LLL : 'YYYY оны MMMMын D HH:mm',
            LLLL : 'dddd, YYYY оны MMMMын D HH:mm'
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM : function (input) {
            return input === 'ҮХ';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar : {
            sameDay : '[Өнөөдөр] LT',
            nextDay : '[Маргааш] LT',
            nextWeek : '[Ирэх] dddd LT',
            lastDay : '[Өчигдөр] LT',
            lastWeek : '[Өнгөрсөн] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s дараа',
            past : '%s өмнө',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        }
    });

    return mn;

})));


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    function relativeTimeMr(number, withoutSuffix, string, isFuture)
    {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's': output = 'काही सेकंद'; break;
                case 'ss': output = '%d सेकंद'; break;
                case 'm': output = 'एक मिनिट'; break;
                case 'mm': output = '%d मिनिटे'; break;
                case 'h': output = 'एक तास'; break;
                case 'hh': output = '%d तास'; break;
                case 'd': output = 'एक दिवस'; break;
                case 'dd': output = '%d दिवस'; break;
                case 'M': output = 'एक महिना'; break;
                case 'MM': output = '%d महिने'; break;
                case 'y': output = 'एक वर्ष'; break;
                case 'yy': output = '%d वर्षे'; break;
            }
        }
        else {
            switch (string) {
                case 's': output = 'काही सेकंदां'; break;
                case 'ss': output = '%d सेकंदां'; break;
                case 'm': output = 'एका मिनिटा'; break;
                case 'mm': output = '%d मिनिटां'; break;
                case 'h': output = 'एका तासा'; break;
                case 'hh': output = '%d तासां'; break;
                case 'd': output = 'एका दिवसा'; break;
                case 'dd': output = '%d दिवसां'; break;
                case 'M': output = 'एका महिन्या'; break;
                case 'MM': output = '%d महिन्यां'; break;
                case 'y': output = 'एका वर्षा'; break;
                case 'yy': output = '%d वर्षां'; break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
        monthsParseExact : true,
        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat : {
            LT : 'A h:mm वाजता',
            LTS : 'A h:mm:ss वाजता',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm वाजता',
            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[उद्या] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात्री') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळी') {
                return hour;
            } else if (meridiem === 'दुपारी') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'सायंकाळी') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात्री';
            } else if (hour < 10) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return mr;

})));


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ms = moment.defineLocale('ms', {
        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Esok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kelmarin pukul] LT',
            lastWeek : 'dddd [lepas pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lepas',
            s : 'beberapa saat',
            ss : '%d saat',
            m : 'seminit',
            mm : '%d minit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return ms;

})));


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var msMy = moment.defineLocale('ms-my', {
        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Esok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kelmarin pukul] LT',
            lastWeek : 'dddd [lepas pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lepas',
            s : 'beberapa saat',
            ss : '%d saat',
            m : 'seminit',
            mm : '%d minit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return msMy;

})));


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var mt = moment.defineLocale('mt', {
        months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
        monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
        weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Illum fil-]LT',
            nextDay : '[Għada fil-]LT',
            nextWeek : 'dddd [fil-]LT',
            lastDay : '[Il-bieraħ fil-]LT',
            lastWeek : 'dddd [li għadda] [fil-]LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'f’ %s',
            past : '%s ilu',
            s : 'ftit sekondi',
            ss : '%d sekondi',
            m : 'minuta',
            mm : '%d minuti',
            h : 'siegħa',
            hh : '%d siegħat',
            d : 'ġurnata',
            dd : '%d ġranet',
            M : 'xahar',
            MM : '%d xhur',
            y : 'sena',
            yy : '%d sni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return mt;

})));


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '၁',
        '2': '၂',
        '3': '၃',
        '4': '၄',
        '5': '၅',
        '6': '၆',
        '7': '၇',
        '8': '၈',
        '9': '၉',
        '0': '၀'
    }, numberMap = {
        '၁': '1',
        '၂': '2',
        '၃': '3',
        '၄': '4',
        '၅': '5',
        '၆': '6',
        '၇': '7',
        '၈': '8',
        '၉': '9',
        '၀': '0'
    };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss : '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်'
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return my;

})));


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var nb = moment.defineLocale('nb', {
        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact : true,
        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] HH:mm',
            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s siden',
            s : 'noen sekunder',
            ss : '%d sekunder',
            m : 'ett minutt',
            mm : '%d minutter',
            h : 'en time',
            hh : '%d timer',
            d : 'en dag',
            dd : '%d dager',
            M : 'en måned',
            MM : '%d måneder',
            y : 'ett år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nb;

})));


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    var ne = moment.defineLocale('ne', {
        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
        monthsParseExact : true,
        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'Aको h:mm बजे',
            LTS : 'Aको h:mm:ss बजे',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, Aको h:mm बजे',
            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[भोलि] LT',
            nextWeek : '[आउँदो] dddd[,] LT',
            lastDay : '[हिजो] LT',
            lastWeek : '[गएको] dddd[,] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%sमा',
            past : '%s अगाडि',
            s : 'केही क्षण',
            ss : '%d सेकेण्ड',
            m : 'एक मिनेट',
            mm : '%d मिनेट',
            h : 'एक घण्टा',
            hh : '%d घण्टा',
            d : 'एक दिन',
            dd : '%d दिन',
            M : 'एक महिना',
            MM : '%d महिना',
            y : 'एक बर्ष',
            yy : '%d बर्ष'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return ne;

})));


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'over %s',
            past : '%s geleden',
            s : 'een paar seconden',
            ss : '%d seconden',
            m : 'één minuut',
            mm : '%d minuten',
            h : 'één uur',
            hh : '%d uur',
            d : 'één dag',
            dd : '%d dagen',
            M : 'één maand',
            MM : '%d maanden',
            y : 'één jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nl;

})));


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'over %s',
            past : '%s geleden',
            s : 'een paar seconden',
            ss : '%d seconden',
            m : 'één minuut',
            mm : '%d minuten',
            h : 'één uur',
            hh : '%d uur',
            d : 'één dag',
            dd : '%d dagen',
            M : 'één maand',
            MM : '%d maanden',
            y : 'één jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nlBe;

})));


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var nn = moment.defineLocale('nn', {
        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] H:mm',
            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s sidan',
            s : 'nokre sekund',
            ss : '%d sekund',
            m : 'eit minutt',
            mm : '%d minutt',
            h : 'ein time',
            hh : '%d timar',
            d : 'ein dag',
            dd : '%d dagar',
            M : 'ein månad',
            MM : '%d månader',
            y : 'eit år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nn;

})));


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '੧',
        '2': '੨',
        '3': '੩',
        '4': '੪',
        '5': '੫',
        '6': '੬',
        '7': '੭',
        '8': '੮',
        '9': '੯',
        '0': '੦'
    },
    numberMap = {
        '੧': '1',
        '੨': '2',
        '੩': '3',
        '੪': '4',
        '੫': '5',
        '੬': '6',
        '੭': '7',
        '੮': '8',
        '੯': '9',
        '੦': '0'
    };

    var paIn = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm ਵਜੇ',
            LTS : 'A h:mm:ss ਵਜੇ',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
        },
        calendar : {
            sameDay : '[ਅਜ] LT',
            nextDay : '[ਕਲ] LT',
            nextWeek : '[ਅਗਲਾ] dddd, LT',
            lastDay : '[ਕਲ] LT',
            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ਵਿੱਚ',
            past : '%s ਪਿਛਲੇ',
            s : 'ਕੁਝ ਸਕਿੰਟ',
            ss : '%d ਸਕਿੰਟ',
            m : 'ਇਕ ਮਿੰਟ',
            mm : '%d ਮਿੰਟ',
            h : 'ਇੱਕ ਘੰਟਾ',
            hh : '%d ਘੰਟੇ',
            d : 'ਇੱਕ ਦਿਨ',
            dd : '%d ਦਿਨ',
            M : 'ਇੱਕ ਮਹੀਨਾ',
            MM : '%d ਮਹੀਨੇ',
            y : 'ਇੱਕ ਸਾਲ',
            yy : '%d ਸਾਲ'
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return paIn;

})));


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
    function plural(n) {
        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix  ? 'godzina'  : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months : function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (format === '') {
                // Hack: if format empty we know this is used to generate
                // RegExp by moment. Give then back both valid forms of months
                // in RegExp ready format.
                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : '%s temu',
            s : 'kilka sekund',
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : '1 dzień',
            dd : '%d dni',
            M : 'miesiąc',
            MM : translate,
            y : 'rok',
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return pl;

})));


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var pt = moment.defineLocale('pt', {
        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY HH:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'em %s',
            past : 'há %s',
            s : 'segundos',
            ss : '%d segundos',
            m : 'um minuto',
            mm : '%d minutos',
            h : 'uma hora',
            hh : '%d horas',
            d : 'um dia',
            dd : '%d dias',
            M : 'um mês',
            MM : '%d meses',
            y : 'um ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return pt;

})));


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ptBr = moment.defineLocale('pt-br', {
        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'em %s',
            past : 'há %s',
            s : 'poucos segundos',
            ss : '%d segundos',
            m : 'um minuto',
            mm : '%d minutos',
            h : 'uma hora',
            hh : '%d horas',
            d : 'um dia',
            dd : '%d dias',
            M : 'um mês',
            MM : '%d meses',
            y : 'um ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal : '%dº'
    });

    return ptBr;

})));


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
                'ss': 'secunde',
                'mm': 'minute',
                'hh': 'ore',
                'dd': 'zile',
                'MM': 'luni',
                'yy': 'ani'
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'peste %s',
            past : '%s în urmă',
            s : 'câteva secunde',
            ss : relativeTimeWithPlural,
            m : 'un minut',
            mm : relativeTimeWithPlural,
            h : 'o oră',
            hh : relativeTimeWithPlural,
            d : 'o zi',
            dd : relativeTimeWithPlural,
            M : 'o lună',
            MM : relativeTimeWithPlural,
            y : 'un an',
            yy : relativeTimeWithPlural
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return ro;

})));


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            'hh': 'час_часа_часов',
            'dd': 'день_дня_дней',
            'MM': 'месяц_месяца_месяцев',
            'yy': 'год_года_лет'
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months : {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
        },
        monthsShort : {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
        },
        weekdays : {
            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
        },
        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соотвествует только сокращённым формам
        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY г.',
            LLL : 'D MMMM YYYY г., H:mm',
            LLLL : 'dddd, D MMMM YYYY г., H:mm'
        },
        calendar : {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'через %s',
            past : '%s назад',
            s : 'несколько секунд',
            ss : relativeTimeWithPlural,
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : 'час',
            hh : relativeTimeWithPlural,
            d : 'день',
            dd : relativeTimeWithPlural,
            M : 'месяц',
            MM : relativeTimeWithPlural,
            y : 'год',
            yy : relativeTimeWithPlural
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM : function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ru;

})));


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'جنوري',
        'فيبروري',
        'مارچ',
        'اپريل',
        'مئي',
        'جون',
        'جولاءِ',
        'آگسٽ',
        'سيپٽمبر',
        'آڪٽوبر',
        'نومبر',
        'ڊسمبر'
    ];
    var days = [
        'آچر',
        'سومر',
        'اڱارو',
        'اربع',
        'خميس',
        'جمع',
        'ڇنڇر'
    ];

    var sd = moment.defineLocale('sd', {
        months : months,
        monthsShort : months,
        weekdays : days,
        weekdaysShort : days,
        weekdaysMin : days,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd، D MMMM YYYY HH:mm'
        },
        meridiemParse: /صبح|شام/,
        isPM : function (input) {
            return 'شام' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar : {
            sameDay : '[اڄ] LT',
            nextDay : '[سڀاڻي] LT',
            nextWeek : 'dddd [اڳين هفتي تي] LT',
            lastDay : '[ڪالهه] LT',
            lastWeek : '[گزريل هفتي] dddd [تي] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s پوء',
            past : '%s اڳ',
            s : 'چند سيڪنڊ',
            ss : '%d سيڪنڊ',
            m : 'هڪ منٽ',
            mm : '%d منٽ',
            h : 'هڪ ڪلاڪ',
            hh : '%d ڪلاڪ',
            d : 'هڪ ڏينهن',
            dd : '%d ڏينهن',
            M : 'هڪ مهينو',
            MM : '%d مهينا',
            y : 'هڪ سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sd;

})));


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var se = moment.defineLocale('se', {
        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'MMMM D. [b.] YYYY',
            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
        },
        calendar : {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s geažes',
            past : 'maŋit %s',
            s : 'moadde sekunddat',
            ss: '%d sekunddat',
            m : 'okta minuhta',
            mm : '%d minuhtat',
            h : 'okta diimmu',
            hh : '%d diimmut',
            d : 'okta beaivi',
            dd : '%d beaivvit',
            M : 'okta mánnu',
            MM : '%d mánut',
            y : 'okta jahki',
            yy : '%d jagit'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return se;

})));


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    /*jshint -W100*/
    var si = moment.defineLocale('si', {
        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'a h:mm',
            LTS : 'a h:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY MMMM D',
            LLL : 'YYYY MMMM D, a h:mm',
            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
        },
        calendar : {
            sameDay : '[අද] LT[ට]',
            nextDay : '[හෙට] LT[ට]',
            nextWeek : 'dddd LT[ට]',
            lastDay : '[ඊයේ] LT[ට]',
            lastWeek : '[පසුගිය] dddd LT[ට]',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%sකින්',
            past : '%sකට පෙර',
            s : 'තත්පර කිහිපය',
            ss : 'තත්පර %d',
            m : 'මිනිත්තුව',
            mm : 'මිනිත්තු %d',
            h : 'පැය',
            hh : 'පැය %d',
            d : 'දිනය',
            dd : 'දින %d',
            M : 'මාසය',
            MM : 'මාස %d',
            y : 'වසර',
            yy : 'වසර %d'
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal : function (number) {
            return number + ' වැනි';
        },
        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM : function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        }
    });

    return si;

})));


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return (n > 1) && (n < 5);
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':  // a few seconds / in a few seconds / a few seconds ago
                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
                break;
            case 'm':  // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
                break;
            case 'h':  // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
                break;
            case 'd':  // a day / in a day / a day ago
                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
                break;
            case 'M':  // a month / in a month / a month ago
                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
                break;
            case 'y':  // a year / in a year / a year ago
                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
                break;
        }
    }

    var sk = moment.defineLocale('sk', {
        months : months,
        monthsShort : monthsShort,
        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat : {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : 'pred %s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sk;

})));


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danes ob] LT',
            nextDay  : '[jutri ob] LT',

            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay  : '[včeraj ob] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'čez %s',
            past   : 'pred %s',
            s      : processRelativeTime,
            ss     : processRelativeTime,
            m      : processRelativeTime,
            mm     : processRelativeTime,
            h      : processRelativeTime,
            hh     : processRelativeTime,
            d      : processRelativeTime,
            dd     : processRelativeTime,
            M      : processRelativeTime,
            MM     : processRelativeTime,
            y      : processRelativeTime,
            yy     : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return sl;

})));


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sq = moment.defineLocale('sq', {
        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact : true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem : function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Sot në] LT',
            nextDay : '[Nesër në] LT',
            nextWeek : 'dddd [në] LT',
            lastDay : '[Dje në] LT',
            lastWeek : 'dddd [e kaluar në] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'në %s',
            past : '%s më parë',
            s : 'disa sekonda',
            ss : '%d sekonda',
            m : 'një minutë',
            mm : '%d minuta',
            h : 'një orë',
            hh : '%d orë',
            d : 'një ditë',
            dd : '%d ditë',
            M : 'një muaj',
            MM : '%d muaj',
            y : 'një vit',
            yy : '%d vite'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sq;

})));


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jedne minute'],
            mm: ['minut', 'minute', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mesec', 'meseca', 'meseci'],
            yy: ['godina', 'godine', 'godina']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[juče u] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'pre %s',
            s      : 'nekoliko sekundi',
            ss     : translator.translate,
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'dan',
            dd     : translator.translate,
            M      : 'mesec',
            MM     : translator.translate,
            y      : 'godinu',
            yy     : translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return sr;

})));


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једне минуте'],
            mm: ['минут', 'минуте', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            dd: ['дан', 'дана', 'дана'],
            MM: ['месец', 'месеца', 'месеци'],
            yy: ['година', 'године', 'година']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay  : '[јуче у] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'за %s',
            past   : 'пре %s',
            s      : 'неколико секунди',
            ss     : translator.translate,
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'дан',
            dd     : translator.translate,
            M      : 'месец',
            MM     : translator.translate,
            y      : 'годину',
            yy     : translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return srCyrl;

})));


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ss = moment.defineLocale('ss', {
        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Namuhla nga] LT',
            nextDay : '[Kusasa nga] LT',
            nextWeek : 'dddd [nga] LT',
            lastDay : '[Itolo nga] LT',
            lastWeek : 'dddd [leliphelile] [nga] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'nga %s',
            past : 'wenteka nga %s',
            s : 'emizuzwana lomcane',
            ss : '%d mzuzwana',
            m : 'umzuzu',
            mm : '%d emizuzu',
            h : 'lihora',
            hh : '%d emahora',
            d : 'lilanga',
            dd : '%d emalanga',
            M : 'inyanga',
            MM : '%d tinyanga',
            y : 'umnyaka',
            yy : '%d iminyaka'
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : '%d',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ss;

})));


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sv = moment.defineLocale('sv', {
        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [kl.] HH:mm',
            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : 'för %s sedan',
            s : 'några sekunder',
            ss : '%d sekunder',
            m : 'en minut',
            mm : '%d minuter',
            h : 'en timme',
            hh : '%d timmar',
            d : 'en dag',
            dd : '%d dagar',
            M : 'en månad',
            MM : '%d månader',
            y : 'ett år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'e' :
                (b === 1) ? 'a' :
                (b === 2) ? 'a' :
                (b === 3) ? 'e' : 'e';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sv;

})));


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sw = moment.defineLocale('sw', {
        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[leo saa] LT',
            nextDay : '[kesho saa] LT',
            nextWeek : '[wiki ijayo] dddd [saat] LT',
            lastDay : '[jana] LT',
            lastWeek : '[wiki iliyopita] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s baadaye',
            past : 'tokea %s',
            s : 'hivi punde',
            ss : 'sekunde %d',
            m : 'dakika moja',
            mm : 'dakika %d',
            h : 'saa limoja',
            hh : 'masaa %d',
            d : 'siku moja',
            dd : 'masiku %d',
            M : 'mwezi mmoja',
            MM : 'miezi %d',
            y : 'mwaka mmoja',
            yy : 'miaka %d'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return sw;

})));


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '௧',
        '2': '௨',
        '3': '௩',
        '4': '௪',
        '5': '௫',
        '6': '௬',
        '7': '௭',
        '8': '௮',
        '9': '௯',
        '0': '௦'
    }, numberMap = {
        '௧': '1',
        '௨': '2',
        '௩': '3',
        '௪': '4',
        '௫': '5',
        '௬': '6',
        '௭': '7',
        '௮': '8',
        '௯': '9',
        '௦': '0'
    };

    var ta = moment.defineLocale('ta', {
        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, HH:mm',
            LLLL : 'dddd, D MMMM YYYY, HH:mm'
        },
        calendar : {
            sameDay : '[இன்று] LT',
            nextDay : '[நாளை] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[நேற்று] LT',
            lastWeek : '[கடந்த வாரம்] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s இல்',
            past : '%s முன்',
            s : 'ஒரு சில விநாடிகள்',
            ss : '%d விநாடிகள்',
            m : 'ஒரு நிமிடம்',
            mm : '%d நிமிடங்கள்',
            h : 'ஒரு மணி நேரம்',
            hh : '%d மணி நேரம்',
            d : 'ஒரு நாள்',
            dd : '%d நாட்கள்',
            M : 'ஒரு மாதம்',
            MM : '%d மாதங்கள்',
            y : 'ஒரு வருடம்',
            yy : '%d ஆண்டுகள்'
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal : function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem : function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை';  // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return ta;

})));


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var te = moment.defineLocale('te', {
        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
        monthsParseExact : true,
        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[నేడు] LT',
            nextDay : '[రేపు] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[నిన్న] LT',
            lastWeek : '[గత] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s లో',
            past : '%s క్రితం',
            s : 'కొన్ని క్షణాలు',
            ss : '%d సెకన్లు',
            m : 'ఒక నిమిషం',
            mm : '%d నిమిషాలు',
            h : 'ఒక గంట',
            hh : '%d గంటలు',
            d : 'ఒక రోజు',
            dd : '%d రోజులు',
            M : 'ఒక నెల',
            MM : '%d నెలలు',
            y : 'ఒక సంవత్సరం',
            yy : '%d సంవత్సరాలు'
        },
        dayOfMonthOrdinalParse : /\d{1,2}వ/,
        ordinal : '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return te;

})));


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tet = moment.defineLocale('tet', {
        months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'iha %s',
            past : '%s liuba',
            s : 'minutu balun',
            ss : 'minutu %d',
            m : 'minutu ida',
            mm : 'minutu %d',
            h : 'oras ida',
            hh : 'oras %d',
            d : 'loron ida',
            dd : 'loron %d',
            M : 'fulan ida',
            MM : 'fulan %d',
            y : 'tinan ida',
            yy : 'tinan %d'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tet;

})));


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум'
    };

    var tg = moment.defineLocale('tg', {
        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
        weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Имрӯз соати] LT',
            nextDay : '[Пагоҳ соати] LT',
            lastDay : '[Дирӯз соати] LT',
            nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'баъди %s',
            past : '%s пеш',
            s : 'якчанд сония',
            m : 'як дақиқа',
            mm : '%d дақиқа',
            h : 'як соат',
            hh : '%d соат',
            d : 'як рӯз',
            dd : '%d рӯз',
            M : 'як моҳ',
            MM : '%d моҳ',
            y : 'як сол',
            yy : '%d сол'
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1th is the first week of the year.
        }
    });

    return tg;

})));


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var th = moment.defineLocale('th', {
        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
        monthsParseExact: true,
        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY เวลา H:mm',
            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar : {
            sameDay : '[วันนี้ เวลา] LT',
            nextDay : '[พรุ่งนี้ เวลา] LT',
            nextWeek : 'dddd[หน้า เวลา] LT',
            lastDay : '[เมื่อวานนี้ เวลา] LT',
            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'อีก %s',
            past : '%sที่แล้ว',
            s : 'ไม่กี่วินาที',
            ss : '%d วินาที',
            m : '1 นาที',
            mm : '%d นาที',
            h : '1 ชั่วโมง',
            hh : '%d ชั่วโมง',
            d : '1 วัน',
            dd : '%d วัน',
            M : '1 เดือน',
            MM : '%d เดือน',
            y : '1 ปี',
            yy : '%d ปี'
        }
    });

    return th;

})));


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tlPh = moment.defineLocale('tl-ph', {
        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'MM/D/YYYY',
            LL : 'MMMM D, YYYY',
            LLL : 'MMMM D, YYYY HH:mm',
            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
        },
        calendar : {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'sa loob ng %s',
            past : '%s ang nakalipas',
            s : 'ilang segundo',
            ss : '%d segundo',
            m : 'isang minuto',
            mm : '%d minuto',
            h : 'isang oras',
            hh : '%d oras',
            d : 'isang araw',
            dd : '%d araw',
            M : 'isang buwan',
            MM : '%d buwan',
            y : 'isang taon',
            yy : '%d taon'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : function (number) {
            return number;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tlPh;

})));


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time = (output.indexOf('jaj') !== -1) ?
        time.slice(0, -3) + 'leS' :
        (output.indexOf('jar') !== -1) ?
        time.slice(0, -3) + 'waQ' :
        (output.indexOf('DIS') !== -1) ?
        time.slice(0, -3) + 'nem' :
        time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time = (output.indexOf('jaj') !== -1) ?
        time.slice(0, -3) + 'Hu’' :
        (output.indexOf('jar') !== -1) ?
        time.slice(0, -3) + 'wen' :
        (output.indexOf('DIS') !== -1) ?
        time.slice(0, -3) + 'ben' :
        time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
        ten = Math.floor((number % 100) / 10),
        one = number % 10,
        word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
        }
        return (word === '') ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
        monthsParseExact : true,
        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L'
        },
        relativeTime : {
            future : translateFuture,
            past : translatePast,
            s : 'puS lup',
            ss : translate,
            m : 'wa’ tup',
            mm : translate,
            h : 'wa’ rep',
            hh : translate,
            d : 'wa’ jaj',
            dd : translate,
            M : 'wa’ jar',
            MM : translate,
            y : 'wa’ DIS',
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tlh;

})));


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {


;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    var suffixes = {
        1: '\'inci',
        5: '\'inci',
        8: '\'inci',
        70: '\'inci',
        80: '\'inci',
        2: '\'nci',
        7: '\'nci',
        20: '\'nci',
        50: '\'nci',
        3: '\'üncü',
        4: '\'üncü',
        100: '\'üncü',
        6: '\'ncı',
        9: '\'uncu',
        10: '\'uncu',
        30: '\'uncu',
        60: '\'ıncı',
        90: '\'ıncı'
    };

    var tr = moment.defineLocale('tr', {
        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[bugün saat] LT',
            nextDay : '[yarın saat] LT',
            nextWeek : '[gelecek] dddd [saat] LT',
            lastDay : '[dün] LT',
            lastWeek : '[geçen] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s sonra',
            past : '%s önce',
            s : 'birkaç saniye',
            ss : '%d saniye',
            m : 'bir dakika',
            mm : '%d dakika',
            h : 'bir saat',
            hh : '%d saat',
            d : 'bir gün',
            dd : '%d gün',
            M : 'bir ay',
            MM : '%d ay',
            y : 'bir yıl',
            yy : '%d yıl'
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {  // special case for zero
                        return number + '\'ıncı';
                    }
                    var a = number % 10,
                        b = number % 100 - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return tr;

})));


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    var tzl = moment.defineLocale('tzl', {
        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM [dallas] YYYY',
            LLL : 'D. MMMM [dallas] YYYY HH.mm',
            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM : function (input) {
            return 'd\'o' === input.toLowerCase();
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'd\'o' : 'D\'O';
            } else {
                return isLower ? 'd\'a' : 'D\'A';
            }
        },
        calendar : {
            sameDay : '[oxhi à] LT',
            nextDay : '[demà à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[ieiri à] LT',
            lastWeek : '[sür el] dddd [lasteu à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'osprei %s',
            past : 'ja%s',
            s : processRelativeTime,
            ss : processRelativeTime,
            m : processRelativeTime,
            mm : processRelativeTime,
            h : processRelativeTime,
            hh : processRelativeTime,
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's': ['viensas secunds', '\'iensas secunds'],
            'ss': [number + ' secunds', '' + number + ' secunds'],
            'm': ['\'n míut', '\'iens míut'],
            'mm': [number + ' míuts', '' + number + ' míuts'],
            'h': ['\'n þora', '\'iensa þora'],
            'hh': [number + ' þoras', '' + number + ' þoras'],
            'd': ['\'n ziua', '\'iensa ziua'],
            'dd': [number + ' ziuas', '' + number + ' ziuas'],
            'M': ['\'n mes', '\'iens mes'],
            'MM': [number + ' mesen', '' + number + ' mesen'],
            'y': ['\'n ar', '\'iens ar'],
            'yy': [number + ' ars', '' + number + ' ars']
        };
        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
    }

    return tzl;

})));


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tzm = moment.defineLocale('tzm', {
        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past : 'ⵢⴰⵏ %s',
            s : 'ⵉⵎⵉⴽ',
            ss : '%d ⵉⵎⵉⴽ',
            m : 'ⵎⵉⵏⵓⴺ',
            mm : '%d ⵎⵉⵏⵓⴺ',
            h : 'ⵙⴰⵄⴰ',
            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d : 'ⴰⵙⵙ',
            dd : '%d oⵙⵙⴰⵏ',
            M : 'ⴰⵢoⵓⵔ',
            MM : '%d ⵉⵢⵢⵉⵔⵏ',
            y : 'ⴰⵙⴳⴰⵙ',
            yy : '%d ⵉⵙⴳⴰⵙⵏ'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return tzm;

})));


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tzmLatn = moment.defineLocale('tzm-latn', {
        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'dadkh s yan %s',
            past : 'yan %s',
            s : 'imik',
            ss : '%d imik',
            m : 'minuḍ',
            mm : '%d minuḍ',
            h : 'saɛa',
            hh : '%d tassaɛin',
            d : 'ass',
            dd : '%d ossan',
            M : 'ayowr',
            MM : '%d iyyirn',
            y : 'asgas',
            yy : '%d isgasn'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return tzmLatn;

})));


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js language configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ugCn = moment.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل'
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ugCn;

})));


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            'dd': 'день_дні_днів',
            'MM': 'місяць_місяці_місяців',
            'yy': 'рік_роки_років'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        }
        else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
        };

        if (m === true) {
            return weekdays['nominative'].slice(1, 7).concat(weekdays['nominative'].slice(0, 1));
        }
        if (!m) {
            return weekdays['nominative'];
        }

        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
            'accusative' :
            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
                'genitive' :
                'nominative');
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months : {
            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
        },
        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
        weekdays : weekdaysCaseReplace,
        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY р.',
            LLL : 'D MMMM YYYY р., HH:mm',
            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
        },
        calendar : {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'за %s',
            past : '%s тому',
            s : 'декілька секунд',
            ss : relativeTimeWithPlural,
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : 'годину',
            hh : relativeTimeWithPlural,
            d : 'день',
            dd : relativeTimeWithPlural,
            M : 'місяць',
            MM : relativeTimeWithPlural,
            y : 'рік',
            yy : relativeTimeWithPlural
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return uk;

})));


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'جنوری',
        'فروری',
        'مارچ',
        'اپریل',
        'مئی',
        'جون',
        'جولائی',
        'اگست',
        'ستمبر',
        'اکتوبر',
        'نومبر',
        'دسمبر'
    ];
    var days = [
        'اتوار',
        'پیر',
        'منگل',
        'بدھ',
        'جمعرات',
        'جمعہ',
        'ہفتہ'
    ];

    var ur = moment.defineLocale('ur', {
        months : months,
        monthsShort : months,
        weekdays : days,
        weekdaysShort : days,
        weekdaysMin : days,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd، D MMMM YYYY HH:mm'
        },
        meridiemParse: /صبح|شام/,
        isPM : function (input) {
            return 'شام' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar : {
            sameDay : '[آج بوقت] LT',
            nextDay : '[کل بوقت] LT',
            nextWeek : 'dddd [بوقت] LT',
            lastDay : '[گذشتہ روز بوقت] LT',
            lastWeek : '[گذشتہ] dddd [بوقت] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s بعد',
            past : '%s قبل',
            s : 'چند سیکنڈ',
            ss : '%d سیکنڈ',
            m : 'ایک منٹ',
            mm : '%d منٹ',
            h : 'ایک گھنٹہ',
            hh : '%d گھنٹے',
            d : 'ایک دن',
            dd : '%d دن',
            M : 'ایک ماہ',
            MM : '%d ماہ',
            y : 'ایک سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ur;

})));


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var uz = moment.defineLocale('uz', {
        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'D MMMM YYYY, dddd HH:mm'
        },
        calendar : {
            sameDay : '[Бугун соат] LT [да]',
            nextDay : '[Эртага] LT [да]',
            nextWeek : 'dddd [куни соат] LT [да]',
            lastDay : '[Кеча соат] LT [да]',
            lastWeek : '[Утган] dddd [куни соат] LT [да]',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'Якин %s ичида',
            past : 'Бир неча %s олдин',
            s : 'фурсат',
            ss : '%d фурсат',
            m : 'бир дакика',
            mm : '%d дакика',
            h : 'бир соат',
            hh : '%d соат',
            d : 'бир кун',
            dd : '%d кун',
            M : 'бир ой',
            MM : '%d ой',
            y : 'бир йил',
            yy : '%d йил'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return uz;

})));


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var uzLatn = moment.defineLocale('uz-latn', {
        months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
        monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
        weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'D MMMM YYYY, dddd HH:mm'
        },
        calendar : {
            sameDay : '[Bugun soat] LT [da]',
            nextDay : '[Ertaga] LT [da]',
            nextWeek : 'dddd [kuni soat] LT [da]',
            lastDay : '[Kecha soat] LT [da]',
            lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'Yaqin %s ichida',
            past : 'Bir necha %s oldin',
            s : 'soniya',
            ss : '%d soniya',
            m : 'bir daqiqa',
            mm : '%d daqiqa',
            h : 'bir soat',
            hh : '%d soat',
            d : 'bir kun',
            dd : '%d kun',
            M : 'bir oy',
            MM : '%d oy',
            y : 'bir yil',
            yy : '%d yil'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return uzLatn;

})));


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var vi = moment.defineLocale('vi', {
        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
        monthsParseExact : true,
        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact : true,
        meridiemParse: /sa|ch/i,
        isPM : function (input) {
            return /^ch$/i.test(input);
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM [năm] YYYY',
            LLL : 'D MMMM [năm] YYYY HH:mm',
            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
            l : 'DD/M/YYYY',
            ll : 'D MMM YYYY',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd, D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần rồi lúc] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s tới',
            past : '%s trước',
            s : 'vài giây',
            ss : '%d giây' ,
            m : 'một phút',
            mm : '%d phút',
            h : 'một giờ',
            hh : '%d giờ',
            d : 'một ngày',
            dd : '%d ngày',
            M : 'một tháng',
            MM : '%d tháng',
            y : 'một năm',
            yy : '%d năm'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : function (number) {
            return number;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return vi;

})));


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var xPseudo = moment.defineLocale('x-pseudo', {
        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
        monthsParseExact : true,
        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[T~ódá~ý át] LT',
            nextDay : '[T~ómó~rró~w át] LT',
            nextWeek : 'dddd [át] LT',
            lastDay : '[Ý~ést~érdá~ý át] LT',
            lastWeek : '[L~ást] dddd [át] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'í~ñ %s',
            past : '%s á~gó',
            s : 'á ~féw ~sécó~ñds',
            ss : '%d s~écóñ~ds',
            m : 'á ~míñ~úté',
            mm : '%d m~íñú~tés',
            h : 'á~ñ hó~úr',
            hh : '%d h~óúrs',
            d : 'á ~dáý',
            dd : '%d d~áýs',
            M : 'á ~móñ~th',
            MM : '%d m~óñt~hs',
            y : 'á ~ýéár',
            yy : '%d ý~éárs'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return xPseudo;

})));


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var yo = moment.defineLocale('yo', {
        months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
        monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Ònì ni] LT',
            nextDay : '[Ọ̀la ni] LT',
            nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
            lastDay : '[Àna ni] LT',
            lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ní %s',
            past : '%s kọjá',
            s : 'ìsẹjú aayá die',
            ss :'aayá %d',
            m : 'ìsẹjú kan',
            mm : 'ìsẹjú %d',
            h : 'wákati kan',
            hh : 'wákati %d',
            d : 'ọjọ́ kan',
            dd : 'ọjọ́ %d',
            M : 'osù kan',
            MM : 'osù %d',
            y : 'ọdún kan',
            yy : 'ọdún %d'
        },
        dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
        ordinal : 'ọjọ́ %d',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return yo;

})));


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhCn = moment.defineLocale('zh-cn', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日Ah点mm分',
            LLLL : 'YYYY年M月D日ddddAh点mm分',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' ||
                    meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天]LT',
            nextDay : '[明天]LT',
            nextWeek : '[下]ddddLT',
            lastDay : '[昨天]LT',
            lastWeek : '[上]ddddLT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime : {
            future : '%s内',
            past : '%s前',
            s : '几秒',
            ss : '%d 秒',
            m : '1 分钟',
            mm : '%d 分钟',
            h : '1 小时',
            hh : '%d 小时',
            d : '1 天',
            dd : '%d 天',
            M : '1 个月',
            MM : '%d 个月',
            y : '1 年',
            yy : '%d 年'
        },
        week : {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return zhCn;

})));


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhHk = moment.defineLocale('zh-hk', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日dddd HH:mm',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天]LT',
            nextDay : '[明天]LT',
            nextWeek : '[下]ddddLT',
            lastDay : '[昨天]LT',
            lastWeek : '[上]ddddLT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd' :
                case 'D' :
                case 'DDD' :
                    return number + '日';
                case 'M' :
                    return number + '月';
                case 'w' :
                case 'W' :
                    return number + '週';
                default :
                    return number;
            }
        },
        relativeTime : {
            future : '%s內',
            past : '%s前',
            s : '幾秒',
            ss : '%d 秒',
            m : '1 分鐘',
            mm : '%d 分鐘',
            h : '1 小時',
            hh : '%d 小時',
            d : '1 天',
            dd : '%d 天',
            M : '1 個月',
            MM : '%d 個月',
            y : '1 年',
            yy : '%d 年'
        }
    });

    return zhHk;

})));


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhTw = moment.defineLocale('zh-tw', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日dddd HH:mm',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天] LT',
            nextDay : '[明天] LT',
            nextWeek : '[下]dddd LT',
            lastDay : '[昨天] LT',
            lastWeek : '[上]dddd LT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd' :
                case 'D' :
                case 'DDD' :
                    return number + '日';
                case 'M' :
                    return number + '月';
                case 'w' :
                case 'W' :
                    return number + '週';
                default :
                    return number;
            }
        },
        relativeTime : {
            future : '%s內',
            past : '%s前',
            s : '幾秒',
            ss : '%d 秒',
            m : '1 分鐘',
            mm : '%d 分鐘',
            h : '1 小時',
            hh : '%d 小時',
            d : '1 天',
            dd : '%d 天',
            M : '1 個月',
            MM : '%d 個月',
            y : '1 年',
            yy : '%d 年'
        }
    });

    return zhTw;

})));


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(1118),
    findIndex = __webpack_require__(866);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)))

/***/ }),
/* 628 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(311),
    arraySome = __webpack_require__(630),
    cacheHas = __webpack_require__(312);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 630 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(78);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(633),
    getSymbols = __webpack_require__(353),
    keys = __webpack_require__(159);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(352),
    isArray = __webpack_require__(26);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 634 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1155),
    isArguments = __webpack_require__(313),
    isArray = __webpack_require__(26),
    isBuffer = __webpack_require__(307),
    isIndex = __webpack_require__(304),
    isTypedArray = __webpack_require__(434);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 636 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(142),
    root = __webpack_require__(78);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(58);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 639 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 640 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(430);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(230),
    isArrayLike = __webpack_require__(130);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(840);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(142);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = asap;
/* harmony export (immutable) */ __webpack_exports__["c"] = suspend;
/* harmony export (immutable) */ __webpack_exports__["b"] = flush;
var queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/
var semaphore = 0;

/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/
function exec(task) {
  try {
    suspend();
    task();
  } finally {
    release();
  }
}

/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/
function asap(task) {
  queue.push(task);

  if (!semaphore) {
    suspend();
    flush();
  }
}

/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/
function suspend() {
  semaphore++;
}

/**
  Puts the scheduler in a `released` state.
**/
function release() {
  semaphore--;
}

/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/
function flush() {
  release();

  var task = void 0;
  while (!semaphore && (task = queue.shift()) !== undefined) {
    exec(task);
  }
}

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = runSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__proc__ = __webpack_require__(647);



var RUN_SAGA_SIGNATURE = 'runSaga(storeInterface, saga, ...args)';
var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ': saga argument must be a Generator function!';

function runSaga(storeInterface, saga) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var iterator = void 0;

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].iterator(storeInterface)) {
    if (false) {
      log('warn', 'runSaga(iterator, storeInterface) has been deprecated in favor of ' + RUN_SAGA_SIGNATURE);
    }
    iterator = storeInterface;
    storeInterface = saga;
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(saga, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func, NON_GENERATOR_ERR);
    iterator = saga.apply(undefined, args);
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(iterator, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].iterator, NON_GENERATOR_ERR);
  }

  var _storeInterface = storeInterface,
      subscribe = _storeInterface.subscribe,
      dispatch = _storeInterface.dispatch,
      getState = _storeInterface.getState,
      context = _storeInterface.context,
      sagaMonitor = _storeInterface.sagaMonitor,
      logger = _storeInterface.logger,
      onError = _storeInterface.onError;


  var effectId = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["y" /* uid */])();

  if (sagaMonitor) {
    // monitors are expected to have a certain interface, let's fill-in any missing ones
    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
    sagaMonitor.effectResolved = sagaMonitor.effectResolved || __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
    sagaMonitor.effectRejected = sagaMonitor.effectRejected || __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];

    sagaMonitor.effectTriggered({ effectId: effectId, root: true, parentEffectId: 0, effect: { root: true, saga: saga, args: args } });
  }

  var task = Object(__WEBPACK_IMPORTED_MODULE_1__proc__["b" /* default */])(iterator, subscribe, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["A" /* wrapSagaDispatch */])(dispatch), getState, context, { sagaMonitor: sagaMonitor, logger: logger, onError: onError }, effectId, saga.name);

  if (sagaMonitor) {
    sagaMonitor.effectResolved(effectId, task);
  }

  return task;
}

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NOT_ITERATOR_ERROR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANNEL_END; });
/* unused harmony export TASK_CANCEL */
/* harmony export (immutable) */ __webpack_exports__["b"] = proc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scheduler__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__io__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__channel__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__buffers__ = __webpack_require__(258);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }







var NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';

var CHANNEL_END = {
  toString: function toString() {
    return '@@redux-saga/CHANNEL_END';
  }
};
var TASK_CANCEL = {
  toString: function toString() {
    return '@@redux-saga/TASK_CANCEL';
  }
};

var matchers = {
  wildcard: function wildcard() {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* kTrue */];
  },
  default: function _default(pattern) {
    return (typeof pattern === 'undefined' ? 'undefined' : _typeof(pattern)) === 'symbol' ? function (input) {
      return input.type === pattern;
    } : function (input) {
      return input.type === String(pattern);
    };
  },
  array: function array(patterns) {
    return function (input) {
      return patterns.some(function (p) {
        return matcher(p)(input);
      });
    };
  },
  predicate: function predicate(_predicate) {
    return function (input) {
      return _predicate(input);
    };
  }
};

function matcher(pattern) {
  // prettier-ignore
  return (pattern === '*' ? matchers.wildcard : __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].array(pattern) ? matchers.array : __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].stringableFunc(pattern) ? matchers.default : __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(pattern) ? matchers.predicate : matchers.default)(pattern);
}

/**
  Used to track a parent task and its forks
  In the new fork model, forked tasks are attached by default to their parent
  We model this using the concept of Parent task && main Task
  main task is the main flow of the current Generator, the parent tasks is the
  aggregation of the main tasks + all its forked tasks.
  Thus the whole model represents an execution tree with multiple branches (vs the
  linear execution tree in sequential (non parallel) programming)

  A parent tasks has the following semantics
  - It completes if all its forks either complete or all cancelled
  - If it's cancelled, all forks are cancelled as well
  - It aborts if any uncaught error bubbles up from forks
  - If it completes, the return value is the one returned by the main task
**/
function forkQueue(name, mainTask, cb) {
  var tasks = [],
      result = void 0,
      completed = false;
  addTask(mainTask);

  function abort(err) {
    cancelAll();
    cb(err, true);
  }

  function addTask(task) {
    tasks.push(task);
    task.cont = function (res, isErr) {
      if (completed) {
        return;
      }

      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* remove */])(tasks, task);
      task.cont = __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
      if (isErr) {
        abort(res);
      } else {
        if (task === mainTask) {
          result = res;
        }
        if (!tasks.length) {
          completed = true;
          cb(result);
        }
      }
    };
    // task.cont.cancel = task.cancel
  }

  function cancelAll() {
    if (completed) {
      return;
    }
    completed = true;
    tasks.forEach(function (t) {
      t.cont = __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
      t.cancel();
    });
    tasks = [];
  }

  return {
    addTask: addTask,
    cancelAll: cancelAll,
    abort: abort,
    getTasks: function getTasks() {
      return tasks;
    },
    taskNames: function taskNames() {
      return tasks.map(function (t) {
        return t.name;
      });
    }
  };
}

function createTaskIterator(_ref) {
  var context = _ref.context,
      fn = _ref.fn,
      args = _ref.args;

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].iterator(fn)) {
    return fn;
  }

  // catch synchronous failures; see #152 and #441
  var result = void 0,
      error = void 0;
  try {
    result = fn.apply(context, args);
  } catch (err) {
    error = err;
  }

  // i.e. a generator function returns an iterator
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].iterator(result)) {
    return result;
  }

  // do not bubble up synchronous failures for detached forks
  // instead create a failed task. See #152 and #441
  return error ? Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* makeIterator */])(function () {
    throw error;
  }) : Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* makeIterator */])(function () {
    var pc = void 0;
    var eff = { done: false, value: result };
    var ret = function ret(value) {
      return { done: true, value: value };
    };
    return function (arg) {
      if (!pc) {
        pc = true;
        return eff;
      } else {
        return ret(arg);
      }
    };
  }());
}

var wrapHelper = function wrapHelper(helper) {
  return { fn: helper };
};

function proc(iterator) {
  var subscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
  };
  var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
  var getState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
  var parentContext = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var parentEffectId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  var name = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'anonymous';
  var cont = arguments[8];

  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(iterator, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].iterator, NOT_ITERATOR_ERROR);

  var effectsString = '[...effects]';
  var runParallelEffect = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* deprecate */])(runAllEffect, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["z" /* updateIncentive */])(effectsString, 'all(' + effectsString + ')'));

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;

  var log = logger || __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* log */];
  var logError = function logError(err) {
    var message = err.sagaStack;

    if (!message && err.stack) {
      message = err.stack.split('\n')[0].indexOf(err.message) !== -1 ? err.stack : 'Error: ' + err.message + '\n' + err.stack;
    }

    log('error', 'uncaught at ' + name, message || err.message || err);
  };
  var stdChannel = Object(__WEBPACK_IMPORTED_MODULE_3__channel__["f" /* stdChannel */])(subscribe);
  var taskContext = Object.create(parentContext);
  /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/
  next.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];

  /**
    Creates a new task descriptor for this generator, We'll also create a main task
    to track the main flow (besides other forked tasks)
  **/
  var task = newTask(parentEffectId, name, iterator, cont);
  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
  var taskQueue = forkQueue(name, mainTask, end);

  /**
    cancellation of the main task. We'll simply resume the Generator with a Cancel
  **/
  function cancelMain() {
    if (mainTask.isRunning && !mainTask.isCancelled) {
      mainTask.isCancelled = true;
      next(TASK_CANCEL);
    }
  }

  /**
    This may be called by a parent generator to trigger/propagate cancellation
    cancel all pending tasks (including the main task), then end the current task.
     Cancellation propagates down to the whole execution tree holded by this Parent task
    It's also propagated to all joiners of this task and their execution tree/joiners
     Cancellation is noop for terminated/Cancelled tasks tasks
  **/
  function cancel() {
    /**
      We need to check both Running and Cancelled status
      Tasks can be Cancelled but still Running
    **/
    if (iterator._isRunning && !iterator._isCancelled) {
      iterator._isCancelled = true;
      taskQueue.cancelAll();
      /**
        Ending with a Never result will propagate the Cancellation to all joiners
      **/
      end(TASK_CANCEL);
    }
  }
  /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/
  cont && (cont.cancel = cancel);

  // tracks the running status
  iterator._isRunning = true;

  // kicks up the generator
  next();

  // then return the task descriptor to the caller
  return task;

  /**
    This is the generator driver
    It's a recursive async/continuation function which calls itself
    until the generator terminates or throws
  **/
  function next(arg, isErr) {
    // Preventive measure. If we end up here, then there is really something wrong
    if (!mainTask.isRunning) {
      throw new Error('Trying to resume an already finished generator');
    }

    try {
      var result = void 0;
      if (isErr) {
        result = iterator.throw(arg);
      } else if (arg === TASK_CANCEL) {
        /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/
        mainTask.isCancelled = true;
        /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/
        next.cancel();
        /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/
        result = __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
      } else if (arg === CHANNEL_END) {
        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
        result = __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(iterator.return) ? iterator.return() : { done: true };
      } else {
        result = iterator.next(arg);
      }

      if (!result.done) {
        runEffect(result.value, parentEffectId, '', next);
      } else {
        /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/
        mainTask.isMainRunning = false;
        mainTask.cont && mainTask.cont(result.value);
      }
    } catch (error) {
      if (mainTask.isCancelled) {
        logError(error);
      }
      mainTask.isMainRunning = false;
      mainTask.cont(error, true);
    }
  }

  function end(result, isErr) {
    iterator._isRunning = false;
    stdChannel.close();
    if (!isErr) {
      iterator._result = result;
      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
    } else {
      if (result instanceof Error) {
        Object.defineProperty(result, 'sagaStack', {
          value: 'at ' + name + ' \n ' + (result.sagaStack || result.stack),
          configurable: true
        });
      }
      if (!task.cont) {
        if (result instanceof Error && onError) {
          onError(result);
        } else {
          logError(result);
        }
      }
      iterator._error = result;
      iterator._isAborted = true;
      iterator._deferredEnd && iterator._deferredEnd.reject(result);
    }
    task.cont && task.cont(result, isErr);
    task.joiners.forEach(function (j) {
      return j.cb(result, isErr);
    });
    task.joiners = null;
  }

  function runEffect(effect, parentEffectId) {
    var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var cb = arguments[3];

    var effectId = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["y" /* uid */])();
    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });

    /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/
    var effectSettled = void 0;

    // Completion callback passed to the appropriate effect runner
    function currCb(res, isErr) {
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      cb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */]; // defensive measure
      if (sagaMonitor) {
        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
      }
      cb(res, isErr);
    }
    // tracks down the current cancel
    currCb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];

    // setup cancellation logic on the parent cb
    cb.cancel = function () {
      // prevents cancelling an already completed effect
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      /**
        propagates cancel downward
        catch uncaught cancellations errors; since we can no longer call the completion
        callback, log errors raised during cancellations into the console
      **/
      try {
        currCb.cancel();
      } catch (err) {
        logError(err);
      }
      currCb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */]; // defensive measure

      sagaMonitor && sagaMonitor.effectCancelled(effectId);
    };

    /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      for completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/
    var data = void 0;
    // prettier-ignore
    return (
      // Non declarative effect
      __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].promise(effect) ? resolvePromise(effect, currCb) : __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].iterator(effect) ? resolveIterator(effect, effectId, name, currCb)

      // declarative effects
      : __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].array(effect) ? runParallelEffect(effect, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].take(effect)) ? runTakeEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].put(effect)) ? runPutEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].all(effect)) ? runAllEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].race(effect)) ? runRaceEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].call(effect)) ? runCallEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].cps(effect)) ? runCPSEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].fork(effect)) ? runForkEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].join(effect)) ? runJoinEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].cancel(effect)) ? runCancelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].select(effect)) ? runSelectEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].actionChannel(effect)) ? runChannelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].flush(effect)) ? runFlushEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].cancelled(effect)) ? runCancelledEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].getContext(effect)) ? runGetContextEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].setContext(effect)) ? runSetContextEffect(data, currCb) : /* anything else returned as is */currCb(effect)
    );
  }

  function resolvePromise(promise, cb) {
    var cancelPromise = promise[__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* CANCEL */]];
    if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(cancelPromise)) {
      cb.cancel = cancelPromise;
    } else if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(promise.abort)) {
      cb.cancel = function () {
        return promise.abort();
      };
      // TODO: add support for the fetch API, whenever they get around to
      // adding cancel support
    }
    promise.then(cb, function (error) {
      return cb(error, true);
    });
  }

  function resolveIterator(iterator, effectId, name, cb) {
    proc(iterator, subscribe, dispatch, getState, taskContext, options, effectId, name, cb);
  }

  function runTakeEffect(_ref2, cb) {
    var channel = _ref2.channel,
        pattern = _ref2.pattern,
        maybe = _ref2.maybe;

    channel = channel || stdChannel;
    var takeCb = function takeCb(inp) {
      return inp instanceof Error ? cb(inp, true) : Object(__WEBPACK_IMPORTED_MODULE_3__channel__["e" /* isEnd */])(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
    };
    try {
      channel.take(takeCb, matcher(pattern));
    } catch (err) {
      return cb(err, true);
    }
    cb.cancel = takeCb.cancel;
  }

  function runPutEffect(_ref3, cb) {
    var channel = _ref3.channel,
        action = _ref3.action,
        resolve = _ref3.resolve;

    /**
      Schedule the put in case another saga is holding a lock.
      The put will be executed atomically. ie nested puts will execute after
      this put has terminated.
    **/
    Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["a" /* asap */])(function () {
      var result = void 0;
      try {
        result = (channel ? channel.put : dispatch)(action);
      } catch (error) {
        // If we have a channel or `put.resolve` was used then bubble up the error.
        if (channel || resolve) return cb(error, true);
        logError(error);
      }

      if (resolve && __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].promise(result)) {
        resolvePromise(result, cb);
      } else {
        return cb(result);
      }
    });
    // Put effects are non cancellables
  }

  function runCallEffect(_ref4, effectId, cb) {
    var context = _ref4.context,
        fn = _ref4.fn,
        args = _ref4.args;

    var result = void 0;
    // catch synchronous failures; see #152
    try {
      result = fn.apply(context, args);
    } catch (error) {
      return cb(error, true);
    }
    return __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].promise(result) ? resolvePromise(result, cb) : __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
  }

  function runCPSEffect(_ref5, cb) {
    var context = _ref5.context,
        fn = _ref5.fn,
        args = _ref5.args;

    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb

    // catch synchronous failures; see #152
    try {
      var cpsCb = function cpsCb(err, res) {
        return __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].undef(err) ? cb(res) : cb(err, true);
      };
      fn.apply(context, args.concat(cpsCb));
      if (cpsCb.cancel) {
        cb.cancel = function () {
          return cpsCb.cancel();
        };
      }
    } catch (error) {
      return cb(error, true);
    }
  }

  function runForkEffect(_ref6, effectId, cb) {
    var context = _ref6.context,
        fn = _ref6.fn,
        args = _ref6.args,
        detached = _ref6.detached;

    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });

    try {
      Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["c" /* suspend */])();
      var _task = proc(taskIterator, subscribe, dispatch, getState, taskContext, options, effectId, fn.name, detached ? null : __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */]);

      if (detached) {
        cb(_task);
      } else {
        if (taskIterator._isRunning) {
          taskQueue.addTask(_task);
          cb(_task);
        } else if (taskIterator._error) {
          taskQueue.abort(taskIterator._error);
        } else {
          cb(_task);
        }
      }
    } finally {
      Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["b" /* flush */])();
    }
    // Fork effects are non cancellables
  }

  function runJoinEffect(t, cb) {
    if (t.isRunning()) {
      var joiner = { task: task, cb: cb };
      cb.cancel = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* remove */])(t.joiners, joiner);
      };
      t.joiners.push(joiner);
    } else {
      t.isAborted() ? cb(t.error(), true) : cb(t.result());
    }
  }

  function runCancelEffect(taskToCancel, cb) {
    if (taskToCancel === __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* SELF_CANCELLATION */]) {
      taskToCancel = task;
    }
    if (taskToCancel.isRunning()) {
      taskToCancel.cancel();
    }
    cb();
    // cancel effects are non cancellables
  }

  function runAllEffect(effects, effectId, cb) {
    var keys = Object.keys(effects);

    if (!keys.length) {
      return cb(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].array(effects) ? [] : {});
    }

    var completedCount = 0;
    var completed = void 0;
    var results = {};
    var childCbs = {};

    function checkEffectEnd() {
      if (completedCount === keys.length) {
        completed = true;
        cb(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].array(effects) ? __WEBPACK_IMPORTED_MODULE_0__utils__["f" /* array */].from(_extends({}, results, { length: keys.length })) : results);
      }
    }

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }
        if (isErr || Object(__WEBPACK_IMPORTED_MODULE_3__channel__["e" /* isEnd */])(res) || res === CHANNEL_END || res === TASK_CANCEL) {
          cb.cancel();
          cb(res, isErr);
        } else {
          results[key] = res;
          completedCount++;
          checkEffectEnd();
        }
      };
      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };

    keys.forEach(function (key) {
      return runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runRaceEffect(effects, effectId, cb) {
    var completed = void 0;
    var keys = Object.keys(effects);
    var childCbs = {};

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }

        if (isErr) {
          // Race Auto cancellation
          cb.cancel();
          cb(res, true);
        } else if (!Object(__WEBPACK_IMPORTED_MODULE_3__channel__["e" /* isEnd */])(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
          var _response;

          cb.cancel();
          completed = true;
          var response = (_response = {}, _response[key] = res, _response);
          cb(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].array(effects) ? [].slice.call(_extends({}, response, { length: keys.length })) : response);
        }
      };
      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      // prevents unnecessary cancellation
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };
    keys.forEach(function (key) {
      if (completed) {
        return;
      }
      runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runSelectEffect(_ref7, cb) {
    var selector = _ref7.selector,
        args = _ref7.args;

    try {
      var state = selector.apply(undefined, [getState()].concat(args));
      cb(state);
    } catch (error) {
      cb(error, true);
    }
  }

  function runChannelEffect(_ref8, cb) {
    var pattern = _ref8.pattern,
        buffer = _ref8.buffer;

    var match = matcher(pattern);
    match.pattern = pattern;
    cb(Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* eventChannel */])(subscribe, buffer || __WEBPACK_IMPORTED_MODULE_4__buffers__["a" /* buffers */].fixed(), match));
  }

  function runCancelledEffect(data, cb) {
    cb(!!mainTask.isCancelled);
  }

  function runFlushEffect(channel, cb) {
    channel.flush(cb);
  }

  function runGetContextEffect(prop, cb) {
    cb(taskContext[prop]);
  }

  function runSetContextEffect(props, cb) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["v" /* object */].assign(taskContext, props);
    cb();
  }

  function newTask(id, name, iterator, cont) {
    var _done, _ref9, _mutatorMap;

    iterator._deferredEnd = null;
    return _ref9 = {}, _ref9[__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* TASK */]] = true, _ref9.id = id, _ref9.name = name, _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
      if (iterator._deferredEnd) {
        return iterator._deferredEnd.promise;
      } else {
        var def = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["l" /* deferred */])();
        iterator._deferredEnd = def;
        if (!iterator._isRunning) {
          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
        }
        return def.promise;
      }
    }, _ref9.cont = cont, _ref9.joiners = [], _ref9.cancel = cancel, _ref9.isRunning = function isRunning() {
      return iterator._isRunning;
    }, _ref9.isCancelled = function isCancelled() {
      return iterator._isCancelled;
    }, _ref9.isAborted = function isAborted() {
      return iterator._isAborted;
    }, _ref9.result = function result() {
      return iterator._result;
    }, _ref9.error = function error() {
      return iterator._error;
    }, _ref9.setContext = function setContext(props) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* createSetContextWarning */])('task', props));
      __WEBPACK_IMPORTED_MODULE_0__utils__["v" /* object */].assign(taskContext, props);
    }, _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
  }
}

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return takeEvery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return takeLatest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return throttle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__takeEvery__ = __webpack_require__(1213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__takeLatest__ = __webpack_require__(1214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__throttle__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(71);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__takeEvery__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__takeLatest__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__throttle__["a"]; });






var deprecationWarning = function deprecationWarning(helperName) {
  return 'import { ' + helperName + ' } from \'redux-saga\' has been deprecated in favor of import { ' + helperName + ' } from \'redux-saga/effects\'.\nThe latter will not work with yield*, as helper effects are wrapped automatically for you in fork effect.\nTherefore yield ' + helperName + ' will return task descriptor to your saga and execute next lines of code.';
};

var takeEvery = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["n" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_0__takeEvery__["a" /* default */], /*#__PURE__*/deprecationWarning('takeEvery'));
var takeLatest = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["n" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_1__takeLatest__["a" /* default */], /*#__PURE__*/deprecationWarning('takeLatest'));
var throttle = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["n" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_2__throttle__["a" /* default */], /*#__PURE__*/deprecationWarning('throttle'));



/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearSelectedObjects = exports.clearSession = void 0;

var _ActionTypes = __webpack_require__(7);

var clearSession = function clearSession() {
  return {
    type: _ActionTypes.CLEAR_SESSION
  };
};

exports.clearSession = clearSession;

var clearSelectedObjects = function clearSelectedObjects() {
  return {
    type: _ActionTypes.CLEAR_SELECTED_OBJECTS
  };
};

exports.clearSelectedObjects = clearSelectedObjects;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(clearSession, "clearSession", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/session.js");

  __REACT_HOT_LOADER__.register(clearSelectedObjects, "clearSelectedObjects", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/session.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(clearSession, "clearSession", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/session.js");

  __REACT_HOT_LOADER__.register(clearSelectedObjects, "clearSelectedObjects", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/session.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/actions/session.js");
}();

;

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(73);
var settle = __webpack_require__(1229);
var buildURL = __webpack_require__(1231);
var parseHeaders = __webpack_require__(1232);
var isURLSameOrigin = __webpack_require__(1233);
var createError = __webpack_require__(652);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(1234);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(1230);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1249)


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)))

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var util = __webpack_require__(361);

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = util.assign(
    {
        'default': Format.RFC3986,
        formatters: {
            RFC1738: function (value) {
                return replace.call(value, percentTwenties, '+');
            },
            RFC3986: function (value) {
                return String(value);
            }
        }
    },
    Format
);


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getObjectNameById = exports.removeEmptyEntries = exports.omitBy = void 0;

var _Validation = __webpack_require__(14);
/**
 * remove all key, value pairs from the object that match the comparator (fn)
 * @param {*} obj 
 * @param {*} comparator 
 */


var omitBy = function omitBy(obj, comparator) {
  return Object.keys(obj).filter(function (key) {
    return !comparator(obj[key], key);
  }).reduce(function (acc, key) {
    return acc[key] = obj[key], acc;
  }, {});
};

exports.omitBy = omitBy;

var removeEmptyEntries = function removeEmptyEntries(obj) {
  return omitBy(obj, function (x) {
    return (0, _Validation.isEmpty)(x);
  });
};
/**
 * get the name field from the array of objects using the id
 * @param {String} id 
 * @param {Array} list objects that have an id and name field
 */


exports.removeEmptyEntries = removeEmptyEntries;

var getObjectNameById = function getObjectNameById(id, list) {
  if (Array.isArray(list) && id) {
    var entry = list.find(function (obj) {
      return (obj === null || obj === void 0 ? void 0 : obj.id) === id;
    });
    return (entry === null || entry === void 0 ? void 0 : entry.name) ? entry === null || entry === void 0 ? void 0 : entry.name : '';
  }

  return '';
};

exports.getObjectNameById = getObjectNameById;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(omitBy, "omitBy", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/objectService.js");

  __REACT_HOT_LOADER__.register(removeEmptyEntries, "removeEmptyEntries", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/objectService.js");

  __REACT_HOT_LOADER__.register(getObjectNameById, "getObjectNameById", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/objectService.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(omitBy, "omitBy", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/objectService.js");

  __REACT_HOT_LOADER__.register(removeEmptyEntries, "removeEmptyEntries", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/objectService.js");

  __REACT_HOT_LOADER__.register(getObjectNameById, "getObjectNameById", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/objectService.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/objectService.js");
}();

;

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitizeProjectIssueCache = exports.projectIssueCacheExpired = exports.getIssueDisplayData = exports.mapIssuesDependenciesToDisplayData = exports.mapIssuesOutwardDependenciesToDisplayData = exports.mapIssuesInwardDependenciesToDisplayData = void 0;

var _DateFormatters = __webpack_require__(43);

var _DateService = __webpack_require__(48);

var _environment = __webpack_require__(360);

var _jiraService = __webpack_require__(1271);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var mapIssuesInwardDependenciesToDisplayData = function mapIssuesInwardDependenciesToDisplayData(allProjectIssues, projectIssue) {
  return mapIssuesDependenciesToDisplayData(allProjectIssues, projectIssue, true);
};

exports.mapIssuesInwardDependenciesToDisplayData = mapIssuesInwardDependenciesToDisplayData;

var mapIssuesOutwardDependenciesToDisplayData = function mapIssuesOutwardDependenciesToDisplayData(allProjectIssues, projectIssue) {
  return mapIssuesDependenciesToDisplayData(allProjectIssues, projectIssue, false);
};

exports.mapIssuesOutwardDependenciesToDisplayData = mapIssuesOutwardDependenciesToDisplayData;

var mapIssuesDependenciesToDisplayData = function mapIssuesDependenciesToDisplayData(allProjectIssues, projectIssue, inward) {
  var _projectIssue$fields, _projectIssue$fields2, _projectIssue$fields3;

  var projectDependencyData;

  if (Array.isArray(projectIssue === null || projectIssue === void 0 ? void 0 : (_projectIssue$fields = projectIssue.fields) === null || _projectIssue$fields === void 0 ? void 0 : _projectIssue$fields.issuelinks) && (projectIssue === null || projectIssue === void 0 ? void 0 : (_projectIssue$fields2 = projectIssue.fields) === null || _projectIssue$fields2 === void 0 ? void 0 : (_projectIssue$fields3 = _projectIssue$fields2.issuelinks) === null || _projectIssue$fields3 === void 0 ? void 0 : _projectIssue$fields3.length) > 0) {
    var _projectIssue$fields4, _projectIssue$fields5;

    projectDependencyData = new Array();
    projectIssue === null || projectIssue === void 0 ? void 0 : (_projectIssue$fields4 = projectIssue.fields) === null || _projectIssue$fields4 === void 0 ? void 0 : (_projectIssue$fields5 = _projectIssue$fields4.issuelinks) === null || _projectIssue$fields5 === void 0 ? void 0 : _projectIssue$fields5.map(function (link) {
      var linkedIssueId = 0;

      if (inward) {
        if ((link === null || link === void 0 ? void 0 : link.inwardIssue) !== undefined) {
          var _link$inwardIssue;

          linkedIssueId = link === null || link === void 0 ? void 0 : (_link$inwardIssue = link.inwardIssue) === null || _link$inwardIssue === void 0 ? void 0 : _link$inwardIssue.id;
        }
      } else {
        if ((link === null || link === void 0 ? void 0 : link.outwardIssue) !== undefined) {
          var _link$outwardIssue;

          linkedIssueId = link === null || link === void 0 ? void 0 : (_link$outwardIssue = link.outwardIssue) === null || _link$outwardIssue === void 0 ? void 0 : _link$outwardIssue.id;
        }
      }

      var foundIssue = allProjectIssues === null || allProjectIssues === void 0 ? void 0 : allProjectIssues.find(function (element) {
        return (element === null || element === void 0 ? void 0 : element.id) === linkedIssueId;
      });

      if (foundIssue) {
        projectDependencyData.push(getIssueDisplayData(foundIssue));
      }
    });
  }

  return projectDependencyData;
};

exports.mapIssuesDependenciesToDisplayData = mapIssuesDependenciesToDisplayData;

var getIssueDisplayData = function getIssueDisplayData(projectIssue) {
  var fields = _objectSpread({}, projectIssue === null || projectIssue === void 0 ? void 0 : projectIssue.fields);

  if (fields) {
    var _fields$issuetype, _fields$priority, _fields$status, _fields$progress, _fields$progress2, _fields$resolution, _fields$resolution2, _fields$resolution3, _fields$resolution4, _fields$subtasks;

    return {
      id: projectIssue === null || projectIssue === void 0 ? void 0 : projectIssue.id,
      summary: (fields === null || fields === void 0 ? void 0 : fields.summary) ? fields === null || fields === void 0 ? void 0 : fields.summary : 'No summary specified',
      description: (0, _jiraService.getDescriptionContent)(fields === null || fields === void 0 ? void 0 : fields.description),
      issueType: fields === null || fields === void 0 ? void 0 : (_fields$issuetype = fields.issuetype) === null || _fields$issuetype === void 0 ? void 0 : _fields$issuetype.name,
      priority: fields === null || fields === void 0 ? void 0 : (_fields$priority = fields.priority) === null || _fields$priority === void 0 ? void 0 : _fields$priority.name,
      status: fields === null || fields === void 0 ? void 0 : (_fields$status = fields.status) === null || _fields$status === void 0 ? void 0 : _fields$status.name,
      progress: (0, _DateFormatters.formatDurationAsDaysHrsMins)(fields === null || fields === void 0 ? void 0 : (_fields$progress = fields.progress) === null || _fields$progress === void 0 ? void 0 : _fields$progress.progress),
      progressTotal: (0, _DateFormatters.formatDurationAsDaysHrsMins)(fields === null || fields === void 0 ? void 0 : (_fields$progress2 = fields.progress) === null || _fields$progress2 === void 0 ? void 0 : _fields$progress2.total),
      created: (0, _DateFormatters.formatDateDefault)(fields === null || fields === void 0 ? void 0 : fields.created),
      resolutionDate: (fields === null || fields === void 0 ? void 0 : fields.resolutiondate) ? (0, _DateFormatters.formatDateDefault)(fields === null || fields === void 0 ? void 0 : fields.resolutiondate) : 'This issue has not been resolved',
      resolution: (fields === null || fields === void 0 ? void 0 : fields.resolution) ? true : false,
      resolutionType: (fields === null || fields === void 0 ? void 0 : (_fields$resolution = fields.resolution) === null || _fields$resolution === void 0 ? void 0 : _fields$resolution.name) ? fields === null || fields === void 0 ? void 0 : (_fields$resolution2 = fields.resolution) === null || _fields$resolution2 === void 0 ? void 0 : _fields$resolution2.name : null,
      resolutionDescription: (fields === null || fields === void 0 ? void 0 : (_fields$resolution3 = fields.resolution) === null || _fields$resolution3 === void 0 ? void 0 : _fields$resolution3.description) ? fields === null || fields === void 0 ? void 0 : (_fields$resolution4 = fields.resolution) === null || _fields$resolution4 === void 0 ? void 0 : _fields$resolution4.description : null,
      subtasks: (fields === null || fields === void 0 ? void 0 : (_fields$subtasks = fields.subtasks) === null || _fields$subtasks === void 0 ? void 0 : _fields$subtasks.length) > 0 ? (0, _jiraService.getSubtasksReduced)(fields === null || fields === void 0 ? void 0 : fields.subtasks) : null
    };
  }
};
/**
 * Check if date is between now and an expiry date that is set in the env prop PROJECT_ISSUE_CACHE_EXPIRY
 * @param {*} testDateTime 
 */


exports.getIssueDisplayData = getIssueDisplayData;

var projectIssueCacheExpired = function projectIssueCacheExpired(testDateTime) {
  if (testDateTime) {
    var now = new Date();
    var expiryDate = new Date().setMinutes(now.getMinutes() - (0, _environment.getProjectIssueCacheExpiry)());
    return !(0, _DateService.isDateTimeBetween)(now, expiryDate, testDateTime);
  }

  return true;
};
/**
 * Check each project issue cache entry if the date is between now and an expiry date that is set in the env prop PROJECT_ISSUE_CACHE_EXPIRY
 * @param {Array} issueCache 
 */


exports.projectIssueCacheExpired = projectIssueCacheExpired;

var sanitizeProjectIssueCache =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(issueCache) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!Array.isArray(issueCache)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", issueCache.filter(function (cacheEntry) {
              return !projectIssueCacheExpired(cacheEntry === null || cacheEntry === void 0 ? void 0 : cacheEntry.lastUpdated);
            }));

          case 2:
            return _context.abrupt("return", []);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function sanitizeProjectIssueCache(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.sanitizeProjectIssueCache = sanitizeProjectIssueCache;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapIssuesInwardDependenciesToDisplayData, "mapIssuesInwardDependenciesToDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectIssueService.js");

  __REACT_HOT_LOADER__.register(mapIssuesOutwardDependenciesToDisplayData, "mapIssuesOutwardDependenciesToDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectIssueService.js");

  __REACT_HOT_LOADER__.register(mapIssuesDependenciesToDisplayData, "mapIssuesDependenciesToDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectIssueService.js");

  __REACT_HOT_LOADER__.register(getIssueDisplayData, "getIssueDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectIssueService.js");

  __REACT_HOT_LOADER__.register(projectIssueCacheExpired, "projectIssueCacheExpired", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectIssueService.js");

  __REACT_HOT_LOADER__.register(sanitizeProjectIssueCache, "sanitizeProjectIssueCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectIssueService.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(asyncGeneratorStep, "asyncGeneratorStep", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectIssueService.js");

  __REACT_HOT_LOADER__.register(_asyncToGenerator, "_asyncToGenerator", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectIssueService.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectIssueService.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectIssueService.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectIssueService.js");

  __REACT_HOT_LOADER__.register(mapIssuesInwardDependenciesToDisplayData, "mapIssuesInwardDependenciesToDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectIssueService.js");

  __REACT_HOT_LOADER__.register(mapIssuesOutwardDependenciesToDisplayData, "mapIssuesOutwardDependenciesToDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectIssueService.js");

  __REACT_HOT_LOADER__.register(mapIssuesDependenciesToDisplayData, "mapIssuesDependenciesToDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectIssueService.js");

  __REACT_HOT_LOADER__.register(getIssueDisplayData, "getIssueDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectIssueService.js");

  __REACT_HOT_LOADER__.register(projectIssueCacheExpired, "projectIssueCacheExpired", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectIssueService.js");

  __REACT_HOT_LOADER__.register(sanitizeProjectIssueCache, "sanitizeProjectIssueCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectIssueService.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/projectIssueService.js");
}();

;

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMockDrillDownData = exports.getIssueDisplayData = exports.getDisplayData = void 0;

var _DateFormatters = __webpack_require__(43);

var _ApiService = __webpack_require__(16);

var _api = __webpack_require__(25);

var _Validation = __webpack_require__(14);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}
/**
 * get basic issue data - no api call
 * @param {*} issue 
 */


var getDisplayData = function getDisplayData(issue) {
  return {
    id: (issue === null || issue === void 0 ? void 0 : issue.id) ? issue === null || issue === void 0 ? void 0 : issue.id : 0,
    name: (issue === null || issue === void 0 ? void 0 : issue.name) ? issue === null || issue === void 0 ? void 0 : issue.name : 'No name specified',
    description: (issue === null || issue === void 0 ? void 0 : issue.description) ? issue === null || issue === void 0 ? void 0 : issue.description : 'No description specified'
  };
};
/**
 * Get more detailed information - makes an api call
 * @param {*} issueId 
 * @param {*} orgid 
 */


exports.getDisplayData = getDisplayData;

var getIssueDisplayData =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(issueId, orgid) {
    var fetchedData;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _ApiService.fetchDataRequest)('issueDisplayData', [_api.ORGID_PATH_PARAM, _api.ISSUEID_PATH_PARAM], [orgid, issueId]);

          case 2:
            _context.t0 = _context.sent;

            if (_context.t0) {
              _context.next = 5;
              break;
            }

            _context.t0 = [];

          case 5:
            fetchedData = _context.t0;
            return _context.abrupt("return", {
              id: (fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.id) ? fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.id : 0,
              name: (fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.name) ? fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.name : 'No name specified',
              description: (fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.description) ? fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.description : 'No description specified',
              type: (fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.type) ? fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.type : 'No type specified',
              assigneeName: (0, _Validation.isValueEntered)(fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.assigneeName) ? fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.assigneeName : 'No assignee specified',
              featureName: (0, _Validation.isValueEntered)(fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.featureName) ? fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.featureName : 'No feature specified',
              startDate: (fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.startDate) ? (0, _DateFormatters.formatDateDefault)(fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.startDate) : 'No start date specified',
              endDate: (fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.endDate) ? (0, _DateFormatters.formatDateDefault)(fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.endDate) : 'No end date specified',
              releaseEnv: (fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.releaseEnv) ? fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.releaseEnv : 'No release environment specified',
              releaseDate: (fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.releaseDate) ? (0, _DateFormatters.formatDateDefault)(fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.releaseDate) : 'No release date specified',
              releaseCutoffDate: (fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.releaseCutoffDate) ? (0, _DateFormatters.formatDateDefault)(fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.releaseCutoffDate) : 'No release cutoff specified',
              releaseVersion: (fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.releaseVersion) ? fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.releaseVersion : 'No release version specified'
            });

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getIssueDisplayData(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}(); // temp solution to mock drill down data after component generation - data may not exist
// makes it easy to clean up mock data and use real data when available (just search for this functions usage)


exports.getIssueDisplayData = getIssueDisplayData;

var getMockDrillDownData = function getMockDrillDownData() {
  return [{
    id: '2578cb65923bb7ba0845014820190617',
    name: 'fake feature number 1',
    description: 'description number 1'
  }, {
    id: '9876cb65923bb7ba0845014820190617',
    name: 'fake feature number 2',
    description: 'description number 2'
  }];
};

exports.getMockDrillDownData = getMockDrillDownData;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(getDisplayData, "getDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/issueService.js");

  __REACT_HOT_LOADER__.register(getIssueDisplayData, "getIssueDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/issueService.js");

  __REACT_HOT_LOADER__.register(getMockDrillDownData, "getMockDrillDownData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/issueService.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(asyncGeneratorStep, "asyncGeneratorStep", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/issueService.js");

  __REACT_HOT_LOADER__.register(_asyncToGenerator, "_asyncToGenerator", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/issueService.js");

  __REACT_HOT_LOADER__.register(getDisplayData, "getDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/issueService.js");

  __REACT_HOT_LOADER__.register(getIssueDisplayData, "getIssueDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/issueService.js");

  __REACT_HOT_LOADER__.register(getMockDrillDownData, "getMockDrillDownData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/issueService.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/issueService.js");
}();

;

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlMessageFormat = __webpack_require__(1286)['default'];

// Add all locale data to `IntlMessageFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(1293);

// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlMessageFormat;
exports['default'] = exports;


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports.extend = extend;
var hop = Object.prototype.hasOwnProperty;

function extend(obj) {
    var sources = Array.prototype.slice.call(arguments, 1),
        i, len, source, key;

    for (i = 0, len = sources.length; i < len; i += 1) {
        source = sources[i];
        if (!source) { continue; }

        for (key in source) {
            if (hop.call(source, key)) {
                obj[key] = source[key];
            }
        }
    }

    return obj;
}
exports.hop = hop;

//# sourceMappingURL=utils.js.map

/***/ }),
/* 663 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dropdown__ = __webpack_require__(212);




var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};

var ButtonDropdown = function ButtonDropdown(props) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Dropdown__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    group: true
  }, props));
};

ButtonDropdown.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (ButtonDropdown);

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(214));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(35));

var _reactLifecyclesCompat = __webpack_require__(232);

var _PropTypes = __webpack_require__(666);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(214));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number,
  appear: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(214));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(232);

var _ChildMapping = __webpack_require__(1364);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
    this.mounted = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes.default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: _propTypes.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes.default.func
} : {};
TransitionGroup.defaultProps = defaultProps;

var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  innerRef: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func])
};
var defaultProps = {
  tag: 'div'
};

var CardBody = function CardBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      innerRef = props.innerRef,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "innerRef", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card-body'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes,
    ref: innerRef
  }));
};

CardBody.propTypes = propTypes;
CardBody.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (CardBody);

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CarouselItem__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(9);








var Carousel =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Carousel, _React$Component);

  function Carousel(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.handleKeyPress = _this.handleKeyPress.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.renderItems = _this.renderItems.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.hoverStart = _this.hoverStart.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.hoverEnd = _this.hoverEnd.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.state = {
      direction: 'right',
      indicatorClicked: false
    };
    return _this;
  }

  var _proto = Carousel.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      direction: this.state.direction
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    // Set up the cycle
    if (this.props.ride === 'carousel') {
      this.setInterval();
    } // TODO: move this to the specific carousel like bootstrap. Currently it will trigger ALL carousels on the page.


    document.addEventListener('keyup', this.handleKeyPress);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this.setInterval(nextProps); // Calculate the direction to turn

    if (this.props.activeIndex + 1 === nextProps.activeIndex) {
      this.setState({
        direction: 'right'
      });
    } else if (this.props.activeIndex - 1 === nextProps.activeIndex) {
      this.setState({
        direction: 'left'
      });
    } else if (this.props.activeIndex > nextProps.activeIndex) {
      this.setState({
        direction: this.state.indicatorClicked ? 'left' : 'right'
      });
    } else if (this.props.activeIndex !== nextProps.activeIndex) {
      this.setState({
        direction: this.state.indicatorClicked ? 'right' : 'left'
      });
    }

    this.setState({
      indicatorClicked: false
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.clearInterval();
    document.removeEventListener('keyup', this.handleKeyPress);
  };

  _proto.setInterval = function (_setInterval) {
    function setInterval() {
      return _setInterval.apply(this, arguments);
    }

    setInterval.toString = function () {
      return _setInterval.toString();
    };

    return setInterval;
  }(function (props) {
    if (props === void 0) {
      props = this.props;
    }

    // make sure not to have multiple intervals going...
    this.clearInterval();

    if (props.interval) {
      this.cycleInterval = setInterval(function () {
        props.next();
      }, parseInt(props.interval, 10));
    }
  });

  _proto.clearInterval = function (_clearInterval) {
    function clearInterval() {
      return _clearInterval.apply(this, arguments);
    }

    clearInterval.toString = function () {
      return _clearInterval.toString();
    };

    return clearInterval;
  }(function () {
    clearInterval(this.cycleInterval);
  });

  _proto.hoverStart = function hoverStart() {
    if (this.props.pause === 'hover') {
      this.clearInterval();
    }

    if (this.props.mouseEnter) {
      var _this$props;

      (_this$props = this.props).mouseEnter.apply(_this$props, arguments);
    }
  };

  _proto.hoverEnd = function hoverEnd() {
    if (this.props.pause === 'hover') {
      this.setInterval();
    }

    if (this.props.mouseLeave) {
      var _this$props2;

      (_this$props2 = this.props).mouseLeave.apply(_this$props2, arguments);
    }
  };

  _proto.handleKeyPress = function handleKeyPress(evt) {
    if (this.props.keyboard) {
      if (evt.keyCode === 37) {
        this.props.previous();
      } else if (evt.keyCode === 39) {
        this.props.next();
      }
    }
  };

  _proto.renderItems = function renderItems(carouselItems, className) {
    var _this2 = this;

    var slide = this.props.slide;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
      role: "listbox",
      className: className
    }, carouselItems.map(function (item, index) {
      var isIn = index === _this2.props.activeIndex;
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(item, {
        in: isIn,
        slide: slide
      });
    }));
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props3 = this.props,
        cssModule = _this$props3.cssModule,
        slide = _this$props3.slide,
        className = _this$props3.className;
    var outerClasses = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'carousel', slide && 'slide'), cssModule);
    var innerClasses = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()('carousel-inner'), cssModule); // filter out booleans, null, or undefined

    var children = this.props.children.filter(function (child) {
      return child !== null && child !== undefined && typeof child !== 'boolean';
    });
    var slidesOnly = children.every(function (child) {
      return child.type === __WEBPACK_IMPORTED_MODULE_5__CarouselItem__["a" /* default */];
    }); // Rendering only slides

    if (slidesOnly) {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
        className: outerClasses,
        onMouseEnter: this.hoverStart,
        onMouseLeave: this.hoverEnd
      }, this.renderItems(children, innerClasses));
    } // Rendering slides and controls


    if (children[0] instanceof Array) {
      var _carouselItems = children[0];
      var _controlLeft = children[1];
      var _controlRight = children[2];
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
        className: outerClasses,
        onMouseEnter: this.hoverStart,
        onMouseLeave: this.hoverEnd
      }, this.renderItems(_carouselItems, innerClasses), _controlLeft, _controlRight);
    } // Rendering indicators, slides and controls


    var indicators = children[0];

    var wrappedOnClick = function wrappedOnClick(e) {
      if (typeof indicators.props.onClickHandler === 'function') {
        _this3.setState({
          indicatorClicked: true
        }, function () {
          return indicators.props.onClickHandler(e);
        });
      }
    };

    var wrappedIndicators = __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(indicators, {
      onClickHandler: wrappedOnClick
    });
    var carouselItems = children[1];
    var controlLeft = children[2];
    var controlRight = children[3];
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
      className: outerClasses,
      onMouseEnter: this.hoverStart,
      onMouseLeave: this.hoverEnd
    }, wrappedIndicators, this.renderItems(carouselItems, innerClasses), controlLeft, controlRight);
  };

  return Carousel;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Carousel.propTypes = {
  // the current active slide of the carousel
  activeIndex: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  // a function which should advance the carousel to the next slide (via activeIndex)
  next: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  // a function which should advance the carousel to the previous slide (via activeIndex)
  previous: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  // controls if the left and right arrow keys should control the carousel
  keyboard: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

  /* If set to "hover", pauses the cycling of the carousel on mouseenter and resumes the cycling of the carousel on
   * mouseleave. If set to false, hovering over the carousel won't pause it. (default: "hover")
   */
  pause: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['hover', false]),
  // Autoplays the carousel after the user manually cycles the first item. If "carousel", autoplays the carousel on load.
  // This is how bootstrap defines it... I would prefer a bool named autoplay or something...
  ride: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['carousel']),
  // the interval at which the carousel automatically cycles (default: 5000)
  // eslint-disable-next-line react/no-unused-prop-types
  interval: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool]),
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,
  // called when the mouse enters the Carousel
  mouseEnter: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  // called when the mouse exits the Carousel
  mouseLeave: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  // controls whether the slide animation on the Carousel works or not
  slide: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};
Carousel.defaultProps = {
  interval: 5000,
  pause: 'hover',
  keyboard: true,
  slide: true
};
Carousel.childContextTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (Carousel);

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(9);





var CarouselControl = function CarouselControl(props) {
  var direction = props.direction,
      onClickHandler = props.onClickHandler,
      cssModule = props.cssModule,
      directionText = props.directionText,
      className = props.className;
  var anchorClasses = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, "carousel-control-" + direction), cssModule);
  var iconClasses = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_2_classnames___default()("carousel-control-" + direction + "-icon"), cssModule);
  var screenReaderClasses = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('sr-only'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    className: anchorClasses,
    role: "button",
    tabIndex: "0",
    onClick: function onClick(e) {
      e.preventDefault();
      onClickHandler();
    }
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: iconClasses,
    "aria-hidden": "true"
  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: screenReaderClasses
  }, directionText || direction));
};

CarouselControl.propTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prev', 'next']).isRequired,
  onClickHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  directionText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (CarouselControl);

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(9);





var CarouselIndicators = function CarouselIndicators(props) {
  var items = props.items,
      activeIndex = props.activeIndex,
      cssModule = props.cssModule,
      onClickHandler = props.onClickHandler,
      className = props.className;
  var listClasses = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-indicators'), cssModule);
  var indicators = items.map(function (item, idx) {
    var indicatorClasses = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_2_classnames___default()({
      active: activeIndex === idx
    }), cssModule);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
      key: "" + (item.key || Object.values(item).join('')),
      onClick: function onClick(e) {
        e.preventDefault();
        onClickHandler(idx);
      },
      className: indicatorClasses
    });
  });
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol", {
    className: listClasses
  }, indicators);
};

CarouselIndicators.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  activeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onClickHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (CarouselIndicators);

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(9);





var CarouselCaption = function CarouselCaption(props) {
  var captionHeader = props.captionHeader,
      captionText = props.captionText,
      cssModule = props.cssModule,
      className = props.className;
  var classes = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-caption', 'd-none', 'd-md-block'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: classes
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3", null, captionHeader), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, captionText));
};

CarouselCaption.propTypes = {
  captionHeader: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  captionText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (CarouselCaption);

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_popper__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(9);











var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  placement: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  placementPrefix: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  arrowClassName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  hideArrow: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_10__utils__["tagPropType"],
  isOpen: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  offset: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number]),
  fallbackPlacement: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array]),
  flip: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  container: __WEBPACK_IMPORTED_MODULE_10__utils__["targetPropType"],
  target: __WEBPACK_IMPORTED_MODULE_10__utils__["targetPropType"].isRequired,
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  boundariesElement: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_10__utils__["DOMElement"]])
};
var defaultProps = {
  boundariesElement: 'scrollParent',
  placement: 'auto',
  hideArrow: false,
  isOpen: false,
  offset: 0,
  fallbackPlacement: 'flip',
  flip: true,
  container: 'body',
  modifiers: {}
};
var childContextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired
};

var PopperContent =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(PopperContent, _React$Component);

  function PopperContent(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.handlePlacementChange = _this.handlePlacementChange.bind(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.setTargetNode = _this.setTargetNode.bind(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.getTargetNode = _this.getTargetNode.bind(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.getRef = _this.getRef.bind(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.state = {};
    return _this;
  }

  var _proto = PopperContent.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      popperManager: {
        setTargetNode: this.setTargetNode,
        getTargetNode: this.getTargetNode
      }
    };
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this._element && this._element.childNodes && this._element.childNodes[0] && this._element.childNodes[0].focus) {
      this._element.childNodes[0].focus();
    }
  };

  _proto.setTargetNode = function setTargetNode(node) {
    this.targetNode = node;
  };

  _proto.getTargetNode = function getTargetNode() {
    return this.targetNode;
  };

  _proto.getContainerNode = function getContainerNode() {
    return Object(__WEBPACK_IMPORTED_MODULE_10__utils__["getTarget"])(this.props.container);
  };

  _proto.getRef = function getRef(ref) {
    this._element = ref;
  };

  _proto.handlePlacementChange = function handlePlacementChange(data) {
    if (this.state.placement !== data.placement) {
      this.setState({
        placement: data.placement
      });
    }

    return data;
  };

  _proto.renderChildren = function renderChildren() {
    var _this$props = this.props,
        cssModule = _this$props.cssModule,
        children = _this$props.children,
        isOpen = _this$props.isOpen,
        flip = _this$props.flip,
        target = _this$props.target,
        offset = _this$props.offset,
        fallbackPlacement = _this$props.fallbackPlacement,
        placementPrefix = _this$props.placementPrefix,
        _arrowClassName = _this$props.arrowClassName,
        hideArrow = _this$props.hideArrow,
        className = _this$props.className,
        tag = _this$props.tag,
        container = _this$props.container,
        modifiers = _this$props.modifiers,
        boundariesElement = _this$props.boundariesElement,
        attrs = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["cssModule", "children", "isOpen", "flip", "target", "offset", "fallbackPlacement", "placementPrefix", "arrowClassName", "hideArrow", "className", "tag", "container", "modifiers", "boundariesElement"]);

    var arrowClassName = Object(__WEBPACK_IMPORTED_MODULE_10__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_8_classnames___default()('arrow', _arrowClassName), cssModule);
    var placement = (this.state.placement || attrs.placement).split('-')[0];
    var popperClassName = Object(__WEBPACK_IMPORTED_MODULE_10__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_8_classnames___default()(className, placementPrefix ? placementPrefix + "-" + placement : placement), this.props.cssModule);

    var extendedModifiers = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({
      offset: {
        offset: offset
      },
      flip: {
        enabled: flip,
        behavior: fallbackPlacement
      },
      preventOverflow: {
        boundariesElement: boundariesElement
      },
      update: {
        enabled: true,
        order: 950,
        fn: this.handlePlacementChange
      }
    }, modifiers);

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_popper__["c" /* Popper */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      modifiers: extendedModifiers
    }, attrs, {
      component: tag,
      className: popperClassName,
      "x-placement": this.state.placement || attrs.placement
    }), children, !hideArrow && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_popper__["a" /* Arrow */], {
      className: arrowClassName
    }));
  };

  _proto.render = function render() {
    this.setTargetNode(Object(__WEBPACK_IMPORTED_MODULE_10__utils__["getTarget"])(this.props.target));

    if (this.props.isOpen) {
      return this.props.container === 'inline' ? this.renderChildren() : __WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.createPortal(__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", {
        ref: this.getRef
      }, this.renderChildren()), this.getContainerNode());
    }

    return null;
  };

  return PopperContent;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

PopperContent.propTypes = propTypes;
PopperContent.defaultProps = defaultProps;
PopperContent.childContextTypes = childContextTypes;
/* harmony default export */ __webpack_exports__["a"] = (PopperContent);

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TooltipPopoverWrapper__ = __webpack_require__(675);




var defaultProps = {
  placement: 'right',
  placementPrefix: 'bs-popover',
  trigger: 'click'
};

var Popover = function Popover(props) {
  var popperClasses = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('popover', 'show', props.className);
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('popover-inner', props.innerClassName);
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TooltipPopoverWrapper__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    className: popperClasses,
    innerClassName: classes
  }));
};

Popover.propTypes = __WEBPACK_IMPORTED_MODULE_3__TooltipPopoverWrapper__["b" /* propTypes */];
Popover.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Popover);

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return propTypes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PopperContent__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(9);







var propTypes = {
  placement: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_6__utils__["PopperPlacements"]),
  target: __WEBPACK_IMPORTED_MODULE_6__utils__["targetPropType"].isRequired,
  container: __WEBPACK_IMPORTED_MODULE_6__utils__["targetPropType"],
  isOpen: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  hideArrow: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  boundariesElement: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6__utils__["DOMElement"]]),
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  innerClassName: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  arrowClassName: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  toggle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  autohide: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  placementPrefix: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  delay: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    show: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    hide: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number
  }), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  modifiers: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  offset: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  innerRef: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object]),
  trigger: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string
};
var DEFAULT_DELAYS = {
  show: 0,
  hide: 250
};
var defaultProps = {
  isOpen: false,
  hideArrow: false,
  autohide: false,
  delay: DEFAULT_DELAYS,
  toggle: function toggle() {},
  trigger: 'click'
};

function isInDOMSubtree(element, subtreeRoot) {
  return subtreeRoot && (element === subtreeRoot || subtreeRoot.contains(element));
}

var TooltipPopoverWrapper =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(TooltipPopoverWrapper, _React$Component);

  function TooltipPopoverWrapper(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this._target = null;
    _this.addTargetEvents = _this.addTargetEvents.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleDocumentClick = _this.handleDocumentClick.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.removeTargetEvents = _this.removeTargetEvents.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.toggle = _this.toggle.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.showWithDelay = _this.showWithDelay.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.hideWithDelay = _this.hideWithDelay.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.onMouseOverTooltipContent = _this.onMouseOverTooltipContent.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.onMouseLeaveTooltipContent = _this.onMouseLeaveTooltipContent.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.show = _this.show.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.hide = _this.hide.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.onEscKeyDown = _this.onEscKeyDown.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.getRef = _this.getRef.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = TooltipPopoverWrapper.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateTarget();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.removeTargetEvents();
  };

  _proto.onMouseOverTooltipContent = function onMouseOverTooltipContent() {
    if (this.props.trigger.indexOf('hover') > -1 && !this.props.autohide) {
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }
    }
  };

  _proto.onMouseLeaveTooltipContent = function onMouseLeaveTooltipContent(e) {
    if (this.props.trigger.indexOf('hover') > -1 && !this.props.autohide) {
      if (this._showTimeout) {
        this.clearShowTimeout();
      }

      e.persist();
      this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay('hide'));
    }
  };

  _proto.onEscKeyDown = function onEscKeyDown(e) {
    if (e.key === 'Escape') {
      this.hide(e);
    }
  };

  _proto.getRef = function getRef(ref) {
    var innerRef = this.props.innerRef;

    if (innerRef) {
      if (typeof innerRef === 'function') {
        innerRef(ref);
      } else if (typeof innerRef === 'object') {
        innerRef.current = ref;
      }
    }

    this._popover = ref;
  };

  _proto.getDelay = function getDelay(key) {
    var delay = this.props.delay;

    if (typeof delay === 'object') {
      return isNaN(delay[key]) ? DEFAULT_DELAYS[key] : delay[key];
    }

    return delay;
  };

  _proto.show = function show(e) {
    if (!this.props.isOpen) {
      this.clearShowTimeout();
      this.toggle(e);
    }
  };

  _proto.showWithDelay = function showWithDelay(e) {
    if (this._hideTimeout) {
      this.clearHideTimeout();
    }

    this._showTimeout = setTimeout(this.show.bind(this, e), this.getDelay('show'));
  };

  _proto.hide = function hide(e) {
    if (this.props.isOpen) {
      this.clearHideTimeout();
      this.toggle(e);
    }
  };

  _proto.hideWithDelay = function hideWithDelay(e) {
    if (this._showTimeout) {
      this.clearShowTimeout();
    }

    this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay('hide'));
  };

  _proto.clearShowTimeout = function clearShowTimeout() {
    clearTimeout(this._showTimeout);
    this._showTimeout = undefined;
  };

  _proto.clearHideTimeout = function clearHideTimeout() {
    clearTimeout(this._hideTimeout);
    this._hideTimeout = undefined;
  };

  _proto.handleDocumentClick = function handleDocumentClick(e) {
    var triggers = this.props.trigger.split(' ');

    if (triggers.indexOf('legacy') > -1 && (this.props.isOpen || isInDOMSubtree(e.target, this._target))) {
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }

      if (this.props.isOpen && !isInDOMSubtree(e.target, this._popover)) {
        this.hideWithDelay(e);
      } else {
        this.showWithDelay(e);
      }
    } else if (triggers.indexOf('click') > -1 && isInDOMSubtree(e.target, this._target)) {
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }

      if (!this.props.isOpen) {
        this.showWithDelay(e);
      } else {
        this.hideWithDelay(e);
      }
    }
  };

  _proto.addTargetEvents = function addTargetEvents() {
    var _this2 = this;

    if (this.props.trigger) {
      var triggers = this.props.trigger.split(' ');

      if (triggers.indexOf('manual') === -1) {
        if (triggers.indexOf('click') > -1 || triggers.indexOf('legacy') > -1) {
          ['click', 'touchstart'].forEach(function (event) {
            return document.addEventListener(event, _this2.handleDocumentClick, true);
          });
        }

        if (this._target) {
          if (triggers.indexOf('hover') > -1) {
            this._target.addEventListener('mouseover', this.showWithDelay, true);

            this._target.addEventListener('mouseout', this.hideWithDelay, true);
          }

          if (triggers.indexOf('focus') > -1) {
            this._target.addEventListener('focusin', this.show, true);

            this._target.addEventListener('focusout', this.hide, true);
          }

          this._target.addEventListener('keydown', this.onEscKeyDown, true);
        }
      }
    }
  };

  _proto.removeTargetEvents = function removeTargetEvents() {
    var _this3 = this;

    if (this._target) {
      this._target.removeEventListener('mouseover', this.showWithDelay, true);

      this._target.removeEventListener('mouseout', this.hideWithDelay, true);

      this._target.removeEventListener('keydown', this.onEscKeyDown, true);

      this._target.removeEventListener('focusin', this.show, true);

      this._target.removeEventListener('focusout', this.hide, true);
    }

    ['click', 'touchstart'].forEach(function (event) {
      return document.removeEventListener(event, _this3.handleDocumentClick, true);
    });
  };

  _proto.updateTarget = function updateTarget() {
    var newTarget = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["getTarget"])(this.props.target);

    if (newTarget !== this._target) {
      this.removeTargetEvents();
      this._target = newTarget;
      this.addTargetEvents();
    }
  };

  _proto.toggle = function toggle(e) {
    if (this.props.disabled) {
      return e && e.preventDefault();
    }

    return this.props.toggle(e);
  };

  _proto.render = function render() {
    if (!this.props.isOpen) {
      return null;
    }

    this.updateTarget();
    var _this$props = this.props,
        className = _this$props.className,
        cssModule = _this$props.cssModule,
        innerClassName = _this$props.innerClassName,
        target = _this$props.target,
        isOpen = _this$props.isOpen,
        hideArrow = _this$props.hideArrow,
        boundariesElement = _this$props.boundariesElement,
        placement = _this$props.placement,
        placementPrefix = _this$props.placementPrefix,
        arrowClassName = _this$props.arrowClassName,
        container = _this$props.container,
        modifiers = _this$props.modifiers,
        offset = _this$props.offset;
    var attributes = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["omit"])(this.props, Object.keys(propTypes));
    var popperClasses = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["mapToCssModules"])(className, cssModule);
    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["mapToCssModules"])(innerClassName, cssModule);
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__PopperContent__["a" /* default */], {
      className: popperClasses,
      target: target,
      isOpen: isOpen,
      hideArrow: hideArrow,
      boundariesElement: boundariesElement,
      placement: placement,
      placementPrefix: placementPrefix,
      arrowClassName: arrowClassName,
      container: container,
      modifiers: modifiers,
      offset: offset,
      cssModule: cssModule
    }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
      ref: this.getRef,
      className: classes,
      role: "tooltip",
      "aria-hidden": isOpen,
      onMouseOver: this.onMouseOverTooltipContent,
      onMouseLeave: this.onMouseLeaveTooltipContent,
      onKeyDown: this.onEscKeyDown
    })));
  };

  return TooltipPopoverWrapper;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

TooltipPopoverWrapper.propTypes = propTypes;
TooltipPopoverWrapper.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (TooltipPopoverWrapper);

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'h3'
};

var PopoverHeader = function PopoverHeader(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'popover-header'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

PopoverHeader.propTypes = propTypes;
PopoverHeader.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (PopoverHeader);

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div'
};

var PopoverBody = function PopoverBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'popover-body'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

PopoverBody.propTypes = propTypes;
PopoverBody.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (PopoverBody);

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TooltipPopoverWrapper__ = __webpack_require__(675);




var defaultProps = {
  placement: 'top',
  autohide: true,
  placementPrefix: 'bs-tooltip',
  trigger: 'click hover focus'
};

var Tooltip = function Tooltip(props) {
  var popperClasses = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('tooltip', 'show', props.className);
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('tooltip-inner', props.innerClassName);
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TooltipPopoverWrapper__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    className: popperClasses,
    innerClassName: classes
  }));
};

Tooltip.propTypes = __WEBPACK_IMPORTED_MODULE_3__TooltipPopoverWrapper__["b" /* propTypes */];
Tooltip.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Tooltip);

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InputGroupText__ = __webpack_require__(680);







var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  addonType: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['prepend', 'append']).isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div'
};

var InputGroupAddon = function InputGroupAddon(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      addonType = props.addonType,
      children = props.children,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag", "addonType", "children"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'input-group-' + addonType), cssModule); // Convenience to assist with transition

  if (typeof children === 'string') {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
      className: classes
    }), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__InputGroupText__["a" /* default */], {
      children: children
    }));
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes,
    children: children
  }));
};

InputGroupAddon.propTypes = propTypes;
InputGroupAddon.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (InputGroupAddon);

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'span'
};

var InputGroupText = function InputGroupText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'input-group-text'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

InputGroupText.propTypes = propTypes;
InputGroupText.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (InputGroupText);

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Fade__ = __webpack_require__(368);








var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  closeClassName: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  closeAriaLabel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  color: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  fade: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  isOpen: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  toggle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  tag: __WEBPACK_IMPORTED_MODULE_6__utils__["tagPropType"],
  transition: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_7__Fade__["a" /* default */].propTypes),
  innerRef: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func])
};
var defaultProps = {
  color: 'success',
  isOpen: true,
  tag: 'div',
  closeAriaLabel: 'Close',
  fade: true,
  transition: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_7__Fade__["a" /* default */].defaultProps, {
    unmountOnExit: true
  })
};

function Alert(props) {
  var className = props.className,
      closeClassName = props.closeClassName,
      closeAriaLabel = props.closeAriaLabel,
      cssModule = props.cssModule,
      Tag = props.tag,
      color = props.color,
      isOpen = props.isOpen,
      toggle = props.toggle,
      children = props.children,
      transition = props.transition,
      fade = props.fade,
      innerRef = props.innerRef,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "closeClassName", "closeAriaLabel", "cssModule", "tag", "color", "isOpen", "toggle", "children", "transition", "fade", "innerRef"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, 'alert', "alert-" + color, {
    'alert-dismissible': toggle
  }), cssModule);
  var closeClasses = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_5_classnames___default()('close', closeClassName), cssModule);

  var alertTransition = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_7__Fade__["a" /* default */].defaultProps, transition, {
    baseClass: fade ? transition.baseClass : '',
    timeout: fade ? transition.timeout : 0
  });

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Fade__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, alertTransition, {
    tag: Tag,
    className: classes,
    in: isOpen,
    role: "alert",
    innerRef: innerRef
  }), toggle ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("button", {
    type: "button",
    className: closeClasses,
    "aria-label": closeAriaLabel,
    onClick: toggle
  }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")) : null, children);
}

Alert.propTypes = propTypes;
Alert.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Alert);

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_transition_group__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(9);






var _transitionStatusToCl;







var propTypes = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_8_react_transition_group__["Transition"].propTypes, {
  isOpen: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node]),
  tag: __WEBPACK_IMPORTED_MODULE_9__utils__["tagPropType"],
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
  navbar: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  innerRef: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object])
});

var defaultProps = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_8_react_transition_group__["Transition"].defaultProps, {
  isOpen: false,
  appear: false,
  enter: true,
  exit: true,
  tag: 'div',
  timeout: __WEBPACK_IMPORTED_MODULE_9__utils__["TransitionTimeouts"].Collapse
});

var transitionStatusToClassHash = (_transitionStatusToCl = {}, _transitionStatusToCl[__WEBPACK_IMPORTED_MODULE_9__utils__["TransitionStatuses"].ENTERING] = 'collapsing', _transitionStatusToCl[__WEBPACK_IMPORTED_MODULE_9__utils__["TransitionStatuses"].ENTERED] = 'collapse show', _transitionStatusToCl[__WEBPACK_IMPORTED_MODULE_9__utils__["TransitionStatuses"].EXITING] = 'collapsing', _transitionStatusToCl[__WEBPACK_IMPORTED_MODULE_9__utils__["TransitionStatuses"].EXITED] = 'collapse', _transitionStatusToCl);

function getTransitionClass(status) {
  return transitionStatusToClassHash[status] || 'collapse';
}

function getHeight(node) {
  return node.scrollHeight;
}

var Collapse =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Collapse, _Component);

  function Collapse(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      height: null
    };
    ['onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'].forEach(function (name) {
      _this[name] = _this[name].bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    });
    return _this;
  }

  var _proto = Collapse.prototype;

  _proto.onEntering = function onEntering(node, isAppearing) {
    this.setState({
      height: getHeight(node)
    });
    this.props.onEntering(node, isAppearing);
  };

  _proto.onEntered = function onEntered(node, isAppearing) {
    this.setState({
      height: null
    });
    this.props.onEntered(node, isAppearing);
  };

  _proto.onExit = function onExit(node) {
    this.setState({
      height: getHeight(node)
    });
    this.props.onExit(node);
  };

  _proto.onExiting = function onExiting(node) {
    // getting this variable triggers a reflow
    var _unused = node.offsetHeight; // eslint-disable-line no-unused-vars

    this.setState({
      height: 0
    });
    this.props.onExiting(node);
  };

  _proto.onExited = function onExited(node) {
    this.setState({
      height: null
    });
    this.props.onExited(node);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        Tag = _this$props.tag,
        isOpen = _this$props.isOpen,
        className = _this$props.className,
        navbar = _this$props.navbar,
        cssModule = _this$props.cssModule,
        children = _this$props.children,
        innerRef = _this$props.innerRef,
        otherProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["tag", "isOpen", "className", "navbar", "cssModule", "children", "innerRef"]);

    var height = this.state.height;
    var transitionProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["pick"])(otherProps, __WEBPACK_IMPORTED_MODULE_9__utils__["TransitionPropTypeKeys"]);
    var childProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["omit"])(otherProps, __WEBPACK_IMPORTED_MODULE_9__utils__["TransitionPropTypeKeys"]);
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_transition_group__["Transition"], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, transitionProps, {
      in: isOpen,
      onEntering: this.onEntering,
      onEntered: this.onEntered,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }), function (status) {
      var collapseClass = getTransitionClass(status);
      var classes = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_7_classnames___default()(className, collapseClass, navbar && 'navbar-collapse'), cssModule);
      var style = height === null ? null : {
        height: height
      };
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, childProps, {
        style: Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, childProps.style, style),
        className: classes,
        ref: _this2.props.innerRef
      }), children);
    });
  };

  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Collapse.propTypes = propTypes;
Collapse.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Collapse);

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UncontrolledDropdown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Dropdown__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(9);








var omitKeys = ['defaultOpen'];

var UncontrolledDropdown =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(UncontrolledDropdown, _Component);

  function UncontrolledDropdown(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      isOpen: props.defaultOpen || false
    };
    _this.toggle = _this.toggle.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = UncontrolledDropdown.prototype;

  _proto.toggle = function toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      isOpen: this.state.isOpen,
      toggle: this.toggle
    }, Object(__WEBPACK_IMPORTED_MODULE_7__utils__["omit"])(this.props, omitKeys)));
  };

  return UncontrolledDropdown;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);


UncontrolledDropdown.propTypes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({
  defaultOpen: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
}, __WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */].propTypes);

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

var prefix = __webpack_require__(1424)
var toCamelCase = __webpack_require__(1425)
var cache = { 'float': 'cssFloat' }
var addPxToStyle = __webpack_require__(1428)

function style (element, property, value) {
  var camel = cache[property]
  if (typeof camel === 'undefined') {
    camel = detect(property)
  }

  // may be false if CSS prop is unsupported
  if (camel) {
    if (value === undefined) {
      return element.style[camel]
    }

    element.style[camel] = addPxToStyle(camel, value)
  }
}

function each (element, properties) {
  for (var k in properties) {
    if (properties.hasOwnProperty(k)) {
      style(element, k, properties[k])
    }
  }
}

function detect (cssProp) {
  var camel = toCamelCase(cssProp)
  var result = prefix(camel)
  cache[camel] = cache[cssProp] = cache[result] = result
  return result
}

function set () {
  if (arguments.length === 2) {
    if (typeof arguments[1] === 'string') {
      arguments[0].style.cssText = arguments[1]
    } else {
      each(arguments[0], arguments[1])
    }
  } else {
    style(arguments[0], arguments[1], arguments[2])
  }
}

module.exports = set
module.exports.set = set

module.exports.get = function (element, properties) {
  if (Array.isArray(properties)) {
    return properties.reduce(function (obj, prop) {
      obj[prop] = style(element, prop || '')
      return obj
    }, {})
  } else {
    return style(element, properties || '')
  }
}


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _reactRedux = __webpack_require__(10);

var _reactRouterDom = __webpack_require__(13);

var _SideNavOption = _interopRequireDefault(__webpack_require__(1441));

var _reactToggleSwitch = _interopRequireDefault(__webpack_require__(1442));

var _index = __webpack_require__(267);

var _ThemeColors = __webpack_require__(347);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ColorOptionsModal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ColorOptionsModal, _React$Component);

  function ColorOptionsModal(props) {
    var _this;

    _classCallCheck(this, ColorOptionsModal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ColorOptionsModal).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleThemeColor", function () {
      var _this2;

      return (_this2 = _this).__handleThemeColor__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "handleDarkTheme", function () {
      var _this3;

      return (_this3 = _this).__handleDarkTheme__REACT_HOT_LOADER__.apply(_this3, arguments);
    });

    _this.toggle = _this.toggle.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ColorOptionsModal, [{
    key: "toggle",
    value: function toggle() {
      var showHideColorOptionsModal = this.props.showHideColorOptionsModal;
      showHideColorOptionsModal();
    }
  }, {
    key: "__handleThemeColor__REACT_HOT_LOADER__",
    value: function __handleThemeColor__REACT_HOT_LOADER__(colorCode) {
      this.props.setThemeColor(colorCode);
      var body = document.body.classList;
      body.remove(this.props.themeColor);
      body.remove('dark-theme');
      body.add(colorCode);
    }
  }, {
    key: "__handleDarkTheme__REACT_HOT_LOADER__",
    value: function __handleDarkTheme__REACT_HOT_LOADER__() {
      this.props.setDarkTheme();
      var body = document.body.classList;
      body.toggle(this.props.themeColor);
      body.toggle('dark-theme');
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.classList.add(this.props.themeColor);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          themeColor = _this$props.themeColor,
          darkTheme = _this$props.darkTheme,
          isDirectionRTL = _this$props.isDirectionRTL,
          classname = _this$props.classname,
          actionComponent = _this$props.actionComponent,
          colorOptionsModal = _this$props.colorOptionsModal;
      return _react["default"].createElement(_react["default"].Fragment, null, actionComponent ? actionComponent : _react["default"].createElement("div", {
        className: "media media-list"
      }, _react["default"].createElement("div", {
        className: "media-body"
      }, _react["default"].createElement("div", {
        className: "my-2 btn-group-mins"
      }, _react["default"].createElement(_reactstrap.Button, {
        size: "lg",
        color: "primary",
        className: classname ? classname : 'btn jr-btn-sm btn-primary',
        onClick: function onClick() {
          _this4.toggle();
        }
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-accounts-add zmdi-hc-fw"
      }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "options.action"
      })))))), _react["default"].createElement("div", {
        className: "text-center"
      }, _react["default"].createElement(_reactstrap.Modal, {
        style: {
          maxHeight: 400,
          width: 300
        },
        isOpen: colorOptionsModal,
        toggle: this.toggle
      }, _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_reactstrap.ModalHeader, null, _react["default"].createElement(_IntlMessages["default"], {
        id: "options.lookAndFeelCustomizer"
      })), _react["default"].createElement(_reactstrap.ModalBody, null, _react["default"].createElement("div", {
        className: "color-theme"
      }, _react["default"].createElement("div", {
        className: "color-theme-header"
      }, _react["default"].createElement("h3", {
        className: "color-theme-title"
      }, "Service Panel "), _react["default"].createElement("span", {
        className: "icon-btn size-30",
        onClick: this.toggle
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-close text-white"
      }))), _react["default"].createElement("div", {
        className: "color-theme-body"
      }, _react["default"].createElement("h3", null, "Light Sidenav"), _react["default"].createElement("ul", {
        className: "color-option"
      }, _react["default"].createElement("li", null, _react["default"].createElement("a", {
        href: "javascript:void(0)",
        onClick: this.handleThemeColor.bind(this, _ThemeColors.INDIGO),
        className: "bg-indigo ".concat(themeColor === _ThemeColors.INDIGO && 'active')
      })), _react["default"].createElement("li", null, _react["default"].createElement("a", {
        href: "javascript:void(0)",
        onClick: this.handleThemeColor.bind(this, _ThemeColors.CYAN),
        className: "bg-cyan ".concat(themeColor === _ThemeColors.CYAN && 'active')
      })), _react["default"].createElement("li", null, _react["default"].createElement("a", {
        href: "javascript:void(0)",
        onClick: this.handleThemeColor.bind(this, _ThemeColors.AMBER),
        className: "bg-amber ".concat(themeColor === _ThemeColors.AMBER && 'active')
      })), _react["default"].createElement("li", null, _react["default"].createElement("a", {
        href: "javascript:void(0)",
        onClick: this.handleThemeColor.bind(this, _ThemeColors.DEEP_ORANGE),
        className: "bg-deep-orange ".concat(themeColor === _ThemeColors.DEEP_ORANGE && 'active')
      })), _react["default"].createElement("li", null, _react["default"].createElement("a", {
        href: "javascript:void(0)",
        onClick: this.handleThemeColor.bind(this, _ThemeColors.PINK),
        className: "bg-pink ".concat(themeColor === _ThemeColors.PINK && 'active')
      })), _react["default"].createElement("li", null, _react["default"].createElement("a", {
        href: "javascript:void(0)",
        onClick: this.handleThemeColor.bind(this, _ThemeColors.BLUE),
        className: "bg-blue ".concat(themeColor === _ThemeColors.BLUE && 'active')
      })), _react["default"].createElement("li", null, _react["default"].createElement("a", {
        href: "javascript:void(0)",
        onClick: this.handleThemeColor.bind(this, _ThemeColors.DEEP_PURPLE),
        className: "bg-deep-purple ".concat(themeColor === _ThemeColors.DEEP_PURPLE && 'active')
      })), _react["default"].createElement("li", null, _react["default"].createElement("a", {
        href: "javascript:void(0)",
        onClick: this.handleThemeColor.bind(this, _ThemeColors.GREEN),
        className: "bg-green ".concat(themeColor === _ThemeColors.GREEN && 'active')
      }))), _react["default"].createElement("h3", null, "Dark Sidenav"), _react["default"].createElement("ul", {
        className: "color-option cr-op-dark-sidebar"
      }, _react["default"].createElement("li", null, _react["default"].createElement("a", {
        href: "javascript:void(0)",
        onClick: this.handleThemeColor.bind(this, _ThemeColors.DARK_INDIGO),
        className: "bg-indigo ".concat(themeColor === _ThemeColors.DARK_INDIGO && 'active')
      })), _react["default"].createElement("li", null, _react["default"].createElement("a", {
        href: "javascript:void(0)",
        onClick: this.handleThemeColor.bind(this, _ThemeColors.DARK_CYAN),
        className: "bg-cyan ".concat(themeColor === _ThemeColors.DARK_CYAN && 'active')
      })), _react["default"].createElement("li", null, _react["default"].createElement("a", {
        href: "javascript:void(0)",
        onClick: this.handleThemeColor.bind(this, _ThemeColors.DARK_AMBER),
        className: "bg-amber ".concat(themeColor === _ThemeColors.DARK_AMBER && 'active')
      })), _react["default"].createElement("li", null, _react["default"].createElement("a", {
        href: "javascript:void(0)",
        onClick: this.handleThemeColor.bind(this, _ThemeColors.DARK_DEEP_ORANGE),
        className: "bg-deep-orange ".concat(themeColor === _ThemeColors.DARK_DEEP_ORANGE && 'active')
      })), _react["default"].createElement("li", null, _react["default"].createElement("a", {
        href: "javascript:void(0)",
        onClick: this.handleThemeColor.bind(this, _ThemeColors.DARK_PINK),
        className: "bg-pink ".concat(themeColor === _ThemeColors.DARK_PINK && 'active')
      })), _react["default"].createElement("li", null, _react["default"].createElement("a", {
        href: "javascript:void(0)",
        onClick: this.handleThemeColor.bind(this, _ThemeColors.DARK_BLUE),
        className: "bg-blue ".concat(themeColor === _ThemeColors.DARK_BLUE && 'active')
      })), _react["default"].createElement("li", null, _react["default"].createElement("a", {
        href: "javascript:void(0)",
        onClick: this.handleThemeColor.bind(this, _ThemeColors.DARK_DEEP_PURPLE),
        className: "bg-deep-purple ".concat(themeColor === _ThemeColors.DARK_DEEP_PURPLE && 'active')
      })), _react["default"].createElement("li", null, _react["default"].createElement("a", {
        href: "javascript:void(0)",
        onClick: this.handleThemeColor.bind(this, _ThemeColors.DARK_GREEN),
        className: "bg-green ".concat(themeColor === _ThemeColors.DARK_GREEN && 'active')
      }))), _react["default"].createElement("div", {
        className: "row text-left"
      }, _react["default"].createElement("div", {
        className: "col-6"
      }, _react["default"].createElement("h3", {
        className: "mb-1"
      }, "RTL"), _react["default"].createElement(_reactToggleSwitch["default"], {
        onClick: function onClick() {
          _this4.toggle();

          _this4.props.changeDirection();
        },
        on: isDirectionRTL
      })), _react["default"].createElement("div", {
        className: "d-none d-sm-block col-6"
      }, _react["default"].createElement("h3", {
        className: "mb-1"
      }, "Dark Theme"), _react["default"].createElement(_reactToggleSwitch["default"], {
        onClick: this.handleDarkTheme,
        on: darkTheme
      }))), _react["default"].createElement("div", {
        className: "d-none d-sm-block mt-3"
      }, _react["default"].createElement(_SideNavOption["default"], null))))), _react["default"].createElement(_reactstrap.ModalFooter, null, _react["default"].createElement("div", null, _react["default"].createElement(_reactstrap.Button, {
        color: "primary",
        onClick: this.toggle
      }, "Close")))))));
    }
  }]);

  return ColorOptionsModal;
}(_react["default"].Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var settings = _ref.settings;
  var themeColor = settings.themeColor,
      darkTheme = settings.darkTheme,
      isDirectionRTL = settings.isDirectionRTL,
      navigationStyle = settings.navigationStyle,
      colorOptionsModal = settings.colorOptionsModal;
  return {
    themeColor: themeColor,
    darkTheme: darkTheme,
    isDirectionRTL: isDirectionRTL,
    navigationStyle: navigationStyle,
    colorOptionsModal: colorOptionsModal
  };
};

var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, {
  setThemeColor: _index.setThemeColor,
  changeDirection: _index.changeDirection,
  setDarkTheme: _index.setDarkTheme,
  showHideColorOptionsModal: _index.showHideColorOptionsModal
})(ColorOptionsModal));

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ColorOptionsModal, "ColorOptionsModal", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/colorOptionsModal/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/colorOptionsModal/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/colorOptionsModal/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/colorOptionsModal/index.js");

  __REACT_HOT_LOADER__.register(_SideNavOption, "_SideNavOption", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/colorOptionsModal/index.js");

  __REACT_HOT_LOADER__.register(_reactToggleSwitch, "_reactToggleSwitch", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/colorOptionsModal/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/colorOptionsModal/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/colorOptionsModal/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/colorOptionsModal/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/colorOptionsModal/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/colorOptionsModal/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/colorOptionsModal/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/colorOptionsModal/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/colorOptionsModal/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/colorOptionsModal/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/colorOptionsModal/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/colorOptionsModal/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/colorOptionsModal/index.js");

  __REACT_HOT_LOADER__.register(ColorOptionsModal, "ColorOptionsModal", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/colorOptionsModal/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/colorOptionsModal/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/colorOptionsModal/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/colorOptionsModal/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/colorOptionsModal/index.js");
}();

;

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRouterDom = __webpack_require__(13);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var Menu =
/*#__PURE__*/
function (_Component) {
  _inherits(Menu, _Component);

  function Menu() {
    _classCallCheck(this, Menu);

    return _possibleConstructorReturn(this, _getPrototypeOf(Menu).apply(this, arguments));
  }

  _createClass(Menu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var history = this.props.history;
      var pathname = "#".concat(history.location.pathname); // get current path

      var mainMenu = document.getElementsByClassName('nav-item');

      for (var i = 0; i < mainMenu.length; i++) {
        mainMenu[i].onclick = function () {
          for (var j = 0; j < mainMenu.length; j++) {
            if (mainMenu[j].classList.contains('active')) {
              mainMenu[j].classList.remove('active');
            }
          }

          this.classList.toggle('active');
        };
      }

      var subMenuLi = document.getElementsByClassName('nav-arrow');

      for (var _i = 0; _i < subMenuLi.length; _i++) {
        subMenuLi[_i].onclick = function () {
          for (var j = 0; j < subMenuLi.length; j++) {
            if (subMenuLi[j].classList.contains('active')) {
              subMenuLi[j].classList.remove('active');
            }
          }

          this.classList.toggle('active');
        };
      }

      var activeLi = document.querySelector('a[href="' + pathname + '"]'); // select current a element

      try {
        var activeNav = this.closest(activeLi, 'ul'); // select closest ul

        if (activeNav.classList.contains('sub-menu')) {
          this.closest(activeNav, 'li').classList.add('active');
        } else {
          this.closest(activeLi, 'li').classList.add('active');
        }

        var parentNav = this.closest(activeNav, '.nav-item');

        if (parentNav) {
          parentNav.classList.add('active');
        }
      } catch (e) {}
    }
  }, {
    key: "closest",
    value: function closest(el, selector) {
      try {
        var matchesFn; // find vendor prefix

        ['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'].some(function (fn) {
          if (typeof document.body[fn] == 'function') {
            matchesFn = fn;
            return true;
          }

          return false;
        });
        var parent; // traverse parents

        while (el) {
          parent = el.parentElement;

          if (parent && parent[matchesFn](selector)) {
            return parent;
          }

          el = parent;
        }
      } catch (e) {}

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      return _react["default"].createElement("div", {
        className: "app-main-menu d-none d-md-block"
      }, _react["default"].createElement("ul", {
        className: "navbar-nav navbar-nav-mega"
      }, _react["default"].createElement("li", {
        className: "nav-item"
      }, _react["default"].createElement("a", {
        href: "javascript:void(0)"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.main"
      })), _react["default"].createElement("ul", {
        className: "sub-menu"
      }, _react["default"].createElement("li", {
        className: "nav-arrow"
      }, _react["default"].createElement("a", {
        role: "button",
        href: "javascript:void(0)"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-view-dashboard zmdi-hc-fw"
      }), _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.dashboard"
      }))), _react["default"].createElement("ul", {
        className: "sub-menu "
      }, _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/dashboard/default"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.dashboard.default"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/dashboard/eCommerce"
      }, _react["default"].createElement("span", {
        className: "nav-text text-transform-none"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.dashboard.ecommerce"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/dashboard/news"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.dashboard.news"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/dashboard/intranet"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.dashboard.intranet"
      })))))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        to: "/app/widgets"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-widgets zmdi-hc-fw"
      }), _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.widgets"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        to: "/app/metrics"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-trending-up zmdi-hc-fw"
      }), _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.metrics"
      })))))), _react["default"].createElement("li", {
        className: "nav-item mega-menu"
      }, _react["default"].createElement("a", {
        href: "javascript:void(0)"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.components"
      })), _react["default"].createElement("ul", {
        className: "sub-menu"
      }, _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/components/alerts"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.components.alerts"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/components/appbar"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.components.appbar"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/components/auto-complete"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.components.autocomplete"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/components/avatars"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.components.avatars"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/components/badges"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.components.badge"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/components/breadcrumbs"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.components.breadcrumbs"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/components/buttons"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.components.buttons"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/components/button-group"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.components.buttonGroup"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/components/cards"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.components.cards"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/components/carousel"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.components.carousel"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/components/color-picker"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.components.colorPicker"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/components/dividers"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.components.dividers"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/components/drawer"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.components.drawer"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/components/expansion-panel"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.components.expansionPanel"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/components/grid-list"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.components.gridList"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/components/list"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.components.lists"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/components/modals"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.components.modals"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/components/pickers"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.components.pickers"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/components/popovers"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.components.popovers"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/components/progressbar"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.components.progress"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/components/selection"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.components.selectionControl"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/components/selects"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.components.selects"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/components/tabs"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.components.tabs"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/components/text-fields"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.components.textFields"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/components/tooltips"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.components.tooltips"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/components/typography"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.components.typography"
      })))))), _react["default"].createElement("li", {
        className: "nav-item"
      }, _react["default"].createElement("a", {
        href: "javascript:void(0)"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.extensions"
      })), _react["default"].createElement("ul", {
        className: "sub-menu"
      }, _react["default"].createElement("li", {
        className: "nav-arrow"
      }, _react["default"].createElement("a", {
        role: "button",
        href: "javascript:void(0)"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-code-setting zmdi-hc-fw"
      }), _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.editors"
      }))), _react["default"].createElement("ul", {
        className: "sub-menu"
      }, _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/editor/ck"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.editors.CKEditor"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/editor/wysiswyg"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.editors.WYSISWYGEditor"
      })))))), _react["default"].createElement("li", {
        className: "nav-arrow"
      }, _react["default"].createElement("a", {
        role: "button",
        href: "javascript:void(0)"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-brush zmdi-hc-fw"
      }), _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.pickers"
      }))), _react["default"].createElement("ul", {
        className: "sub-menu"
      }, _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/pickers/date-time"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.pickers.dateTimePickers"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/pickers/color"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.pickers.colorPickers"
      })))))), _react["default"].createElement("li", {
        className: "nav-arrow"
      }, _react["default"].createElement("a", {
        role: "button",
        href: "javascript:void(0)"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-key zmdi-hc-fw"
      }), _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.extensions"
      }))), _react["default"].createElement("ul", {
        className: "sub-menu"
      }, _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/extensions/dnd"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.extensions.dragNDrop"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/extensions/dropzone"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.extensions.dropzone"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/extensions/sweet-alert"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.extensions.sweetAlert"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/extensions/notification"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.extensions.notification"
      })))))), _react["default"].createElement("li", {
        className: "nav-arrow"
      }, _react["default"].createElement("a", {
        role: "button",
        href: "javascript:void(0)"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-chart zmdi-hc-fw"
      }), _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.chart"
      }))), _react["default"].createElement("ul", {
        className: "sub-menu"
      }, _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/chart/line"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.chart.line"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/chart/bar"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.chart.bar"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/chart/area"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.chart.area"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/chart/composed"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.chart.composed"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/chart/scatter"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.chart.scatter"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/chart/pie"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.chart.pie"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/chart/radial"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.chart.radial"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/chart/radar"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.chart.radar"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/chart/treemap"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.chart.tree"
      })))))), _react["default"].createElement("li", {
        className: "nav-arrow"
      }, _react["default"].createElement("a", {
        role: "button",
        href: "javascript:void(0)"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-google-maps zmdi-hc-fw"
      }), _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.map"
      }))), _react["default"].createElement("ul", {
        className: "sub-menu sub-menu-half"
      }, _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/map/simple"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.map.simple"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/map/styled"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.map.styled"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/map/geo-location"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.map.geoLocation"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/map/directions"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.map.mapDirection"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/map/overlay"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.map.overlay"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/map/kml"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.map.kmLayer"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/map/popup-info"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.map.popupInfo"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/map/traffic"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.map.trafficLayer"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/map/street-view"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.map.streetView"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/map/event"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.map.eventListener"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/map/drawing"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.map.mapDrawing"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/map/clustering"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.map.mapClustering"
      })))))), _react["default"].createElement("li", {
        className: "nav-arrow"
      }, _react["default"].createElement("a", {
        role: "button",
        href: "javascript:void(0)"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-calendar zmdi-hc-fw"
      }), _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.calendar"
      }))), _react["default"].createElement("ul", {
        className: "sub-menu"
      }, _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/calendar/basic"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.calendar.basic"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/calendar/cultures"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.calendar.cultures"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/calendar/dnd"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.calendar.dnd"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/calendar/popup"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.calendar.popup"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/calendar/rendering"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.calendar.rendering"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/calendar/selectable"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.calendar.selectable"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/calendar/timeslots"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.calendar.timeslots"
      })))))), _react["default"].createElement("li", {
        className: "nav-arrow"
      }, _react["default"].createElement("a", {
        role: "button",
        href: "javascript:void(0)"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-shopping-cart zmdi-hc-fw"
      }), _react["default"].createElement("span", {
        className: "nav-text text-transform-none"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.eCommerce"
      }))), _react["default"].createElement("ul", {
        className: "sub-menu"
      }, _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/ecommerce/products-list"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.eCommerce.productsList"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/ecommerce/products-grid"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.eCommerce.productsGrid"
      })))))), _react["default"].createElement("li", {
        className: "nav-arrow"
      }, _react["default"].createElement("a", {
        role: "button",
        href: "javascript:void(0)"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-collection-item-8 zmdi-hc-fw"
      }), _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.appModule"
      }))), _react["default"].createElement("ul", {
        className: "sub-menu"
      }, _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/app-module/login"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.appModule.login"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/app-module/sign-up"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.appModule.signup"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/app-module/forgot-password"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.appModule.forgotPassword"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/app-module/lock-screen"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.appModule.lock"
      })))))))), _react["default"].createElement("li", {
        className: "nav-item"
      }, _react["default"].createElement("a", {
        href: "javascript:void(0)"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.modules"
      })), _react["default"].createElement("ul", {
        className: "sub-menu"
      }, _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        to: "/app/to-do"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-check-square zmdi-hc-fw"
      }), _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.appModule.toDo"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        to: "/app/to-do-redux"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-check-square zmdi-hc-fw"
      }), _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.appModule.toDoRedux"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        to: "/app/mail"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-email zmdi-hc-fw"
      }), _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.appModule.mail"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        to: "/app/mail-redux"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-email zmdi-hc-fw"
      }), _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.appModule.mailRedux"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        to: "/app/chat"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-comment zmdi-hc-fw"
      }), _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.appModule.chat"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        to: "/app/chat-redux"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-comment zmdi-hc-fw"
      }), _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.appModule.chatRedux"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        to: "/app/contact"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-account-box zmdi-hc-fw"
      }), _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.appModule.contact"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        to: "/app/contact-redux"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-account-box zmdi-hc-fw"
      }), _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.appModule.contactRedux"
      })))))), _react["default"].createElement("li", {
        className: "nav-item"
      }, _react["default"].createElement("a", {
        href: "javascript:void(0)"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.extras"
      })), _react["default"].createElement("ul", {
        className: "sub-menu"
      }, _react["default"].createElement("li", {
        className: "nav-arrow"
      }, _react["default"].createElement("a", {
        role: "button",
        href: "javascript:void(0)"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-view-web zmdi-hc-fw"
      }), _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.tables"
      }))), _react["default"].createElement("ul", {
        className: "sub-menu"
      }, _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/table/basic"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.tables.basicTable"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/table/data"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.tables.dataTable"
      })))))), _react["default"].createElement("li", {
        className: "nav-arrow"
      }, _react["default"].createElement("a", {
        role: "button",
        href: "javascript:void(0)"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-swap-alt zmdi-hc-fw zmdi-hc-rotate-90"
      }), _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.timeLine"
      }))), _react["default"].createElement("ul", {
        className: "sub-menu"
      }, _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/time-line/default"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.timeLine.default"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/time-line/default-with-icon"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.timeLine.defaultwithIcons"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/time-line/left-align"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.timeLine.leftAligned"
      })))))), _react["default"].createElement("li", {
        className: "nav-arrow"
      }, _react["default"].createElement("a", {
        role: "button",
        href: "javascript:void(0)"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-view-list zmdi-hc-fw"
      }), _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.customViews"
      }))), _react["default"].createElement("ul", {
        className: "sub-menu"
      }, _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/custom-views/simple-list"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.customViews.plainListView"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/custom-views/strip-list"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.customViews.withDivider"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/custom-views/card-list"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.customViews.cardListView"
      })))))), _react["default"].createElement("li", {
        className: "nav-arrow"
      }, _react["default"].createElement("a", {
        role: "button",
        href: "javascript:void(0)"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-book-image zmdi-hc-fw"
      }), _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.forms"
      }))), _react["default"].createElement("ul", {
        className: "sub-menu"
      }, _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/form/components"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.forms.components"
      })))))), _react["default"].createElement("li", {
        className: "nav-arrow"
      }, _react["default"].createElement("a", {
        role: "button",
        href: "javascript:void(0)"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-view-web zmdi-hc-fw"
      }), _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.icons"
      }))), _react["default"].createElement("ul", {
        className: "sub-menu"
      }, _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/icons/material"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.icons.material"
      })))))), _react["default"].createElement("li", {
        className: "nav-arrow"
      }, _react["default"].createElement("a", {
        role: "button",
        href: "javascript:void(0)"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-collection-bookmark zmdi-hc-fw zmdi-hc-rotate-90"
      }), _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.extraElements"
      }))), _react["default"].createElement("ul", {
        className: "sub-menu"
      }, _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/extra-elements/pricing-table"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.extraElements.pricingTable"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/extra-elements/callouts"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.extraElements.callouts"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/extra-elements/testimonials"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.extraElements.testimonials"
      })))))), _react["default"].createElement("li", {
        className: "nav-arrow"
      }, _react["default"].createElement("a", {
        role: "button",
        href: "javascript:void(0)"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-pages zmdi-hc-fw"
      }), _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.extraPages"
      }))), _react["default"].createElement("ul", {
        className: "sub-menu sub-menu-half"
      }, _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/extra-pages/about-us"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.extraPages.aboutUs"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/extra-pages/contact-us"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.extraPages.contactUs"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/extra-pages/blog"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.extraPages.blog"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/extra-pages/faq"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.extraPages.faq"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/extra-pages/portfolio"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.extraPages.portfolio"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/extra-pages/error-404"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.extraPages.404"
      })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
        className: "prepend-icon",
        to: "/app/extra-pages/error-500"
      }, _react["default"].createElement("span", {
        className: "nav-text"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.extraPages.500"
      }))))))))));
    }
  }]);

  return Menu;
}(_react.Component);

var _default = (0, _reactRouterDom.withRouter)(Menu);

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Menu, "Menu", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/Menu.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/Menu.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/Menu.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/Menu.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/Menu.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/Menu.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/Menu.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/Menu.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/Menu.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/Menu.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/Menu.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/Menu.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/Menu.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/Menu.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/Menu.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/Menu.js");

  __REACT_HOT_LOADER__.register(Menu, "Menu", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/Menu.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/Menu.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/Menu.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/Menu.js");
}();

;

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1445), __esModule: true };

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(121) && !__webpack_require__(185)(function () {
  return Object.defineProperty(__webpack_require__(689)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(184);
var document = __webpack_require__(119).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(148);
var toIObject = __webpack_require__(149);
var arrayIndexOf = __webpack_require__(1452)(false);
var IE_PROTO = __webpack_require__(375)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(372);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(374);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(1456)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(694)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(269);
var $export = __webpack_require__(118);
var redefine = __webpack_require__(695);
var hide = __webpack_require__(182);
var Iterators = __webpack_require__(217);
var $iterCreate = __webpack_require__(1457);
var setToStringTag = __webpack_require__(380);
var getPrototypeOf = __webpack_require__(696);
var ITERATOR = __webpack_require__(90)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(182);


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(148);
var toObject = __webpack_require__(216);
var IE_PROTO = __webpack_require__(375)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(690);
var hiddenKeys = __webpack_require__(377).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextRow = (_temp = _class = function (_React$Component) {
  _inherits(TextRow, _React$Component);

  function TextRow() {
    _classCallCheck(this, TextRow);

    return _possibleConstructorReturn(this, (TextRow.__proto__ || Object.getPrototypeOf(TextRow)).apply(this, arguments));
  }

  _createClass(TextRow, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          maxHeight = _props.maxHeight,
          color = _props.color,
          lineSpacing = _props.lineSpacing,
          style = _props.style;


      var defaultStyles = {
        maxHeight: maxHeight,
        width: '100%',
        height: '1em',
        backgroundColor: color,
        marginTop: lineSpacing
      };

      var classes = ['text-row', className].filter(function (c) {
        return c;
      }).join(' ');

      return _react2.default.createElement('div', {
        className: classes,
        style: _extends({}, defaultStyles, style)
      });
    }
  }]);

  return TextRow;
}(_react2.default.Component), _class.propTypes = {
  className: _propTypes2.default.string,
  color: _propTypes2.default.string,
  lineSpacing: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  style: _propTypes2.default.object
}, _class.defaultProps = {
  lineSpacing: '0.7em'
}, _temp);
exports.default = TextRow;

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RoundShape = (_temp = _class = function (_React$Component) {
  _inherits(RoundShape, _React$Component);

  function RoundShape() {
    _classCallCheck(this, RoundShape);

    return _possibleConstructorReturn(this, (RoundShape.__proto__ || Object.getPrototypeOf(RoundShape)).apply(this, arguments));
  }

  _createClass(RoundShape, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          style = _props.style,
          color = _props.color;


      var defaultStyles = {
        backgroundColor: color,
        borderRadius: '500rem',
        width: '100%',
        height: '100%'
      };

      var classes = ['round-shape', className].filter(function (c) {
        return c;
      }).join(' ');

      return _react2.default.createElement('div', { className: classes, style: _extends({}, defaultStyles, style) });
    }
  }]);

  return RoundShape;
}(_react2.default.Component), _class.propTypes = {
  color: _propTypes2.default.string,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object
}, _temp);
exports.default = RoundShape;

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TextRow = __webpack_require__(698);

var _TextRow2 = _interopRequireDefault(_TextRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextBlock = (_temp2 = _class = function (_React$Component) {
  _inherits(TextBlock, _React$Component);

  function TextBlock() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TextBlock);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TextBlock.__proto__ || Object.getPrototypeOf(TextBlock)).call.apply(_ref, [this].concat(args))), _this), _this.getRowStyle = function (i) {
      var _this$props = _this.props,
          rows = _this$props.rows,
          color = _this$props.color,
          widths = _this$props.widths;


      return {
        backgroundColor: color,
        maxHeight: 100 / (rows * 2 - 1) + '%',
        width: widths[(i + widths.length) % widths.length] + '%'
      };
    }, _this.getRows = function () {
      var _this$props2 = _this.props,
          rows = _this$props2.rows,
          lineSpacing = _this$props2.lineSpacing;

      var range = [].concat(_toConsumableArray(Array(rows)));
      return range.map(function (x, i) {
        return _react2.default.createElement(_TextRow2.default, {
          style: _this.getRowStyle(i),
          lineSpacing: i !== 0 ? lineSpacing : 0,
          key: i
        });
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TextBlock, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          style = _props.style,
          className = _props.className;


      var classes = ['text-block', className].filter(function (c) {
        return c;
      }).join(' ');

      return _react2.default.createElement(
        'div',
        { className: classes, style: _extends({}, style, { width: '100%' }) },
        this.getRows()
      );
    }
  }]);

  return TextBlock;
}(_react2.default.Component), _class.propTypes = {
  rows: _propTypes2.default.number.isRequired,
  color: _propTypes2.default.string.isRequired,
  lineSpacing: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  widths: _propTypes2.default.arrayOf(_propTypes2.default.number),
  style: _propTypes2.default.object,
  className: _propTypes2.default.string
}, _class.defaultProps = {
  widths: [97, 100, 94, 90, 98, 95, 98, 40]
}, _temp2);
exports.default = TextBlock;

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(384);
var createDesc = __webpack_require__(704);
module.exports = __webpack_require__(187) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(187) && !__webpack_require__(122)(function () {
  return Object.defineProperty(__webpack_require__(703)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(186);
var document = __webpack_require__(102).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 704 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(102);
var hide = __webpack_require__(701);
var has = __webpack_require__(274);
var SRC = __webpack_require__(706)('src');
var $toString = __webpack_require__(1501);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(218).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 706 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(218);
var global = __webpack_require__(102);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(1502) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(1503);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 709 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(1525);
var createDesc = __webpack_require__(704);
var toIObject = __webpack_require__(389);
var toPrimitive = __webpack_require__(385);
var has = __webpack_require__(274);
var IE8_DOM_DEFINE = __webpack_require__(702);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(187) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(274);
var toIObject = __webpack_require__(389);
var arrayIndexOf = __webpack_require__(1528)(false);
var IE_PROTO = __webpack_require__(712)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(707)('keys');
var uid = __webpack_require__(706);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(388);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(186);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(67),
    baseUniq = __webpack_require__(854);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__line__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__point__ = __webpack_require__(398);






/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x0 = __WEBPACK_IMPORTED_MODULE_4__point__["a" /* x */],
      x1 = null,
      y0 = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(0),
      y1 = __WEBPACK_IMPORTED_MODULE_4__point__["b" /* y */],
      defined = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear__["a" /* default */],
      output = null;

  function area(data) {
    var i,
        j,
        k,
        n = data.length,
        d,
        defined0 = false,
        buffer,
        x0z = new Array(n),
        y0z = new Array(n);

    if (context == null) output = curve(buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  function arealine() {
    return Object(__WEBPACK_IMPORTED_MODULE_3__line__["a" /* default */])().defined(defined).curve(curve).context(context);
  }

  area.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), x1 = null, area) : x0;
  };

  area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : x0;
  };

  area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : x1;
  };

  area.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), y1 = null, area) : y0;
  };

  area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : y0;
  };

  area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : y1;
  };

  area.lineX0 =
  area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };

  area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };

  area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };

  area.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(!!_), area) : defined;
  };

  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };

  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };

  return area;
});


/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return curveRadialLinear; });
/* harmony export (immutable) */ __webpack_exports__["b"] = curveRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(279);


var curveRadialLinear = curveRadial(__WEBPACK_IMPORTED_MODULE_0__linear__["a" /* default */]);

function Radial(curve) {
  this._curve = curve;
}

Radial.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(a, r) {
    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
  }
};

function curveRadial(curve) {

  function radial(context) {
    return new Radial(curve(context));
  }

  radial._curve = curve;

  return radial;
}


/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lineRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__line__ = __webpack_require__(397);



function lineRadial(l) {
  var c = l.curve;

  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;

  l.curve = function(_) {
    return arguments.length ? c(Object(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["b" /* default */])(_)) : c()._curve;
  };

  return l;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return lineRadial(Object(__WEBPACK_IMPORTED_MODULE_1__line__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["a" /* curveRadialLinear */]));
});


/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, y) {
  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
});


/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = Array.prototype.slice;


/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(221);


/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / __WEBPACK_IMPORTED_MODULE_0__math__["j" /* pi */]);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, __WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */]);
  }
});


/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / 5) / 2;
    context.moveTo(-3 * r, -r);
    context.lineTo(-r, -r);
    context.lineTo(-r, -3 * r);
    context.lineTo(r, -3 * r);
    context.lineTo(r, -r);
    context.lineTo(3 * r, -r);
    context.lineTo(3 * r, r);
    context.lineTo(r, r);
    context.lineTo(r, 3 * r);
    context.lineTo(-r, 3 * r);
    context.lineTo(-r, r);
    context.lineTo(-3 * r, r);
    context.closePath();
  }
});


/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var tan30 = Math.sqrt(1 / 3),
    tan30_2 = tan30 * 2;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = Math.sqrt(size / tan30_2),
        x = y * tan30;
    context.moveTo(0, -y);
    context.lineTo(x, 0);
    context.lineTo(0, y);
    context.lineTo(-x, 0);
    context.closePath();
  }
});


/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(221);


var ka = 0.89081309152928522810,
    kr = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math__["j" /* pi */] / 10) / Math.sin(7 * __WEBPACK_IMPORTED_MODULE_0__math__["j" /* pi */] / 10),
    kx = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */] / 10) * kr,
    ky = -Math.cos(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */] / 10) * kr;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size * ka),
        x = kx * r,
        y = ky * r;
    context.moveTo(0, -r);
    context.lineTo(x, y);
    for (var i = 1; i < 5; ++i) {
      var a = __WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */] * i / 5,
          c = Math.cos(a),
          s = Math.sin(a);
      context.lineTo(s * r, -c * r);
      context.lineTo(c * x - s * y, s * x + c * y);
    }
    context.closePath();
  }
});


/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var w = Math.sqrt(size),
        x = -w / 2;
    context.rect(x, x, w, w);
  }
});


/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var sqrt3 = Math.sqrt(3);

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = -Math.sqrt(size / (sqrt3 * 3));
    context.moveTo(0, y * 2);
    context.lineTo(-sqrt3 * y, -y);
    context.lineTo(sqrt3 * y, -y);
    context.closePath();
  }
});


/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var c = -0.5,
    s = Math.sqrt(3) / 2,
    k = 1 / Math.sqrt(12),
    a = (k / 2 + 1) * 3;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / a),
        x0 = r / 2,
        y0 = r * k,
        x1 = x0,
        y1 = r * k + r,
        x2 = -x1,
        y2 = y1;
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    context.lineTo(x2, y2);
    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
    context.closePath();
  }
});


/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardinalClosed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal__ = __webpack_require__(282);



function CardinalClosed(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: Object(__WEBPACK_IMPORTED_MODULE_1__cardinal__["b" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalClosed(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardinalOpen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinal__ = __webpack_require__(282);


function CardinalOpen(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_0__cardinal__["b" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalOpen(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(223);


/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var peaks = series.map(peak);
  return Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).sort(function(a, b) { return peaks[a] - peaks[b]; });
});

function peak(series) {
  var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
  while (++i < n) if ((vi = +series[i][1]) > vj) vj = vi, j = i;
  return j;
}


/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AnimateManager__ = __webpack_require__(1579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__easing__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configUpdate__ = __webpack_require__(1583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(284);


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }








var Animate =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Animate, _PureComponent);

  function Animate(props, context) {
    var _this;

    _classCallCheck(this, Animate);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Animate).call(this, props, context));
    var _this$props = _this.props,
        isActive = _this$props.isActive,
        attributeName = _this$props.attributeName,
        from = _this$props.from,
        to = _this$props.to,
        steps = _this$props.steps,
        children = _this$props.children;
    _this.handleStyleChange = _this.handleStyleChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.changeStyle = _this.changeStyle.bind(_assertThisInitialized(_assertThisInitialized(_this)));

    if (!isActive) {
      _this.state = {
        style: {}
      }; // if children is a function and animation is not active, set style to 'to'

      if (typeof children === 'function') {
        _this.state = {
          style: to
        };
      }

      return _possibleConstructorReturn(_this);
    }

    if (steps && steps.length) {
      _this.state = {
        style: steps[0].style
      };
    } else if (from) {
      if (typeof children === 'function') {
        _this.state = {
          style: from
        };
        return _possibleConstructorReturn(_this);
      }

      _this.state = {
        style: attributeName ? _defineProperty({}, attributeName, from) : from
      };
    } else {
      _this.state = {
        style: {}
      };
    }

    return _this;
  }

  _createClass(Animate, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          isActive = _this$props2.isActive,
          canBegin = _this$props2.canBegin;
      this.mounted = true;

      if (!isActive || !canBegin) {
        return;
      }

      this.runAnimation(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props,
          isActive = _this$props3.isActive,
          canBegin = _this$props3.canBegin,
          attributeName = _this$props3.attributeName,
          shouldReAnimate = _this$props3.shouldReAnimate;

      if (!canBegin) {
        return;
      }

      if (!isActive) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          style: attributeName ? _defineProperty({}, attributeName, this.props.to) : this.props.to
        });
        return;
      }

      if (__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevProps.to, this.props.to) && prevProps.canBegin && prevProps.isActive) {
        return;
      }

      var isTriggered = !prevProps.canBegin || !prevProps.isActive;

      if (this.manager) {
        this.manager.stop();
      }

      if (this.stopJSAnimation) {
        this.stopJSAnimation();
      }

      var from = isTriggered || shouldReAnimate ? this.props.from : prevProps.to; // eslint-disable-next-line react/no-did-update-set-state

      this.setState({
        style: attributeName ? _defineProperty({}, attributeName, from) : from
      });
      this.runAnimation(_objectSpread({}, this.props, {
        from: from,
        begin: 0
      }));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;

      if (this.unSubscribe) {
        this.unSubscribe();
      }

      if (this.manager) {
        this.manager.stop();
        this.manager = null;
      }

      if (this.stopJSAnimation) {
        this.stopJSAnimation();
      }
    }
  }, {
    key: "runJSAnimation",
    value: function runJSAnimation(props) {
      var _this2 = this;

      var from = props.from,
          to = props.to,
          duration = props.duration,
          easing = props.easing,
          begin = props.begin,
          onAnimationEnd = props.onAnimationEnd,
          onAnimationStart = props.onAnimationStart;
      var startAnimation = Object(__WEBPACK_IMPORTED_MODULE_5__configUpdate__["a" /* default */])(from, to, Object(__WEBPACK_IMPORTED_MODULE_4__easing__["a" /* configEasing */])(easing), duration, this.changeStyle);

      var finalStartAnimation = function finalStartAnimation() {
        _this2.stopJSAnimation = startAnimation();
      };

      this.manager.start([onAnimationStart, begin, finalStartAnimation, duration, onAnimationEnd]);
    }
  }, {
    key: "runStepAnimation",
    value: function runStepAnimation(props) {
      var _this3 = this;

      var steps = props.steps,
          begin = props.begin,
          onAnimationStart = props.onAnimationStart;
      var _steps$ = steps[0],
          initialStyle = _steps$.style,
          _steps$$duration = _steps$.duration,
          initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;

      var addStyle = function addStyle(sequence, nextItem, index) {
        if (index === 0) {
          return sequence;
        }

        var duration = nextItem.duration,
            _nextItem$easing = nextItem.easing,
            easing = _nextItem$easing === void 0 ? 'ease' : _nextItem$easing,
            style = nextItem.style,
            nextProperties = nextItem.properties,
            onAnimationEnd = nextItem.onAnimationEnd;
        var preItem = index > 0 ? steps[index - 1] : nextItem;
        var properties = nextProperties || Object.keys(style);

        if (typeof easing === 'function' || easing === 'spring') {
          return _toConsumableArray(sequence).concat([_this3.runJSAnimation.bind(_this3, {
            from: preItem.style,
            to: style,
            duration: duration,
            easing: easing
          }), duration]);
        }

        var transition = Object(__WEBPACK_IMPORTED_MODULE_6__util__["b" /* getTransitionVal */])(properties, duration, easing);

        var newStyle = _objectSpread({}, preItem.style, style, {
          transition: transition
        });

        return _toConsumableArray(sequence).concat([newStyle, duration, onAnimationEnd]).filter(__WEBPACK_IMPORTED_MODULE_6__util__["c" /* identity */]);
      };

      return this.manager.start([onAnimationStart].concat(_toConsumableArray(steps.reduce(addStyle, [initialStyle, Math.max(initialTime, begin)])), [props.onAnimationEnd]));
    }
  }, {
    key: "runAnimation",
    value: function runAnimation(props) {
      if (!this.manager) {
        this.manager = Object(__WEBPACK_IMPORTED_MODULE_3__AnimateManager__["a" /* default */])();
      }

      var begin = props.begin,
          duration = props.duration,
          attributeName = props.attributeName,
          propsTo = props.to,
          easing = props.easing,
          onAnimationStart = props.onAnimationStart,
          onAnimationEnd = props.onAnimationEnd,
          steps = props.steps,
          children = props.children;
      var manager = this.manager;
      this.unSubscribe = manager.subscribe(this.handleStyleChange);

      if (typeof easing === 'function' || typeof children === 'function' || easing === 'spring') {
        this.runJSAnimation(props);
        return;
      }

      if (steps.length > 1) {
        this.runStepAnimation(props);
        return;
      }

      var to = attributeName ? _defineProperty({}, attributeName, propsTo) : propsTo;
      var transition = Object(__WEBPACK_IMPORTED_MODULE_6__util__["b" /* getTransitionVal */])(Object.keys(to), duration, easing);
      manager.start([onAnimationStart, begin, _objectSpread({}, to, {
        transition: transition
      }), duration, onAnimationEnd]);
    }
  }, {
    key: "handleStyleChange",
    value: function handleStyleChange(style) {
      this.changeStyle(style);
    }
  }, {
    key: "changeStyle",
    value: function changeStyle(style) {
      if (this.mounted) {
        this.setState({
          style: style
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          children = _this$props4.children,
          begin = _this$props4.begin,
          duration = _this$props4.duration,
          attributeName = _this$props4.attributeName,
          easing = _this$props4.easing,
          isActive = _this$props4.isActive,
          steps = _this$props4.steps,
          from = _this$props4.from,
          to = _this$props4.to,
          canBegin = _this$props4.canBegin,
          onAnimationEnd = _this$props4.onAnimationEnd,
          shouldReAnimate = _this$props4.shouldReAnimate,
          onAnimationReStart = _this$props4.onAnimationReStart,
          others = _objectWithoutProperties(_this$props4, ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"]);

      var count = __WEBPACK_IMPORTED_MODULE_1_react__["Children"].count(children);
      var stateStyle = Object(__WEBPACK_IMPORTED_MODULE_6__util__["e" /* translateStyle */])(this.state.style);

      if (typeof children === 'function') {
        return children(stateStyle);
      }

      if (!isActive || count === 0) {
        return children;
      }

      var cloneContainer = function cloneContainer(container) {
        var _container$props = container.props,
            _container$props$styl = _container$props.style,
            style = _container$props$styl === void 0 ? {} : _container$props$styl,
            className = _container$props.className;
        var res = Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(container, _objectSpread({}, others, {
          style: _objectSpread({}, style, stateStyle),
          className: className
        }));
        return res;
      };

      if (count === 1) {
        return cloneContainer(__WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(children));
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_1_react__["Children"].map(children, function (child) {
        return cloneContainer(child);
      }));
    }
  }]);

  return Animate;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

Animate.displayName = 'Animate';
Animate.propTypes = {
  from: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  to: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  attributeName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  // animation duration
  duration: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  begin: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  easing: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func]),
  steps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    duration: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,
    style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    easing: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']), __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func]),
    // transition css properties(dash case), optional
    properties: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf('string'),
    onAnimationEnd: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
  })),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func]),
  isActive: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  canBegin: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  onAnimationEnd: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  // decide if it should reanimate with initial from style when props change
  shouldReAnimate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  onAnimationStart: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onAnimationReStart: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};
Animate.defaultProps = {
  begin: 0,
  duration: 1000,
  from: '',
  to: '',
  attributeName: '',
  easing: 'ease',
  isActive: true,
  canBegin: true,
  steps: [],
  onAnimationEnd: function onAnimationEnd() {},
  onAnimationStart: function onAnimationStart() {}
};
/* harmony default export */ __webpack_exports__["a"] = (Animate);

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export configBezier */
/* unused harmony export configSpring */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return configEasing; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(284);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }


var ACCURACY = 1e-4;

var cubicBezierFactor = function cubicBezierFactor(c1, c2) {
  return [0, 3 * c1, 3 * c2 - 6 * c1, 3 * c1 - 3 * c2 + 1];
};

var multyTime = function multyTime(params, t) {
  return params.map(function (param, i) {
    return param * Math.pow(t, i);
  }).reduce(function (pre, curr) {
    return pre + curr;
  });
};

var cubicBezier = function cubicBezier(c1, c2) {
  return function (t) {
    var params = cubicBezierFactor(c1, c2);
    return multyTime(params, t);
  };
};

var derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
  return function (t) {
    var params = cubicBezierFactor(c1, c2);

    var newParams = _toConsumableArray(params.map(function (param, i) {
      return param * i;
    }).slice(1)).concat([0]);

    return multyTime(newParams, t);
  };
}; // calculate cubic-bezier using Newton's method


var configBezier = function configBezier() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var x1 = args[0],
      y1 = args[1],
      x2 = args[2],
      y2 = args[3];

  if (args.length === 1) {
    switch (args[0]) {
      case 'linear':
        x1 = 0.0;
        y1 = 0.0;
        x2 = 1.0;
        y2 = 1.0;
        break;

      case 'ease':
        x1 = 0.25;
        y1 = 0.1;
        x2 = 0.25;
        y2 = 1.0;
        break;

      case 'ease-in':
        x1 = 0.42;
        y1 = 0.0;
        x2 = 1.0;
        y2 = 1.0;
        break;

      case 'ease-out':
        x1 = 0.42;
        y1 = 0.0;
        x2 = 0.58;
        y2 = 1.0;
        break;

      case 'ease-in-out':
        x1 = 0.0;
        y1 = 0.0;
        x2 = 0.58;
        y2 = 1.0;
        break;

      default:
        {
          var easing = args[0].split('(');

          if (easing[0] === 'cubic-bezier' && easing[1].split(')')[0].split(',').length === 4) {
            var _easing$1$split$0$spl = easing[1].split(')')[0].split(',').map(function (x) {
              return parseFloat(x);
            });

            var _easing$1$split$0$spl2 = _slicedToArray(_easing$1$split$0$spl, 4);

            x1 = _easing$1$split$0$spl2[0];
            y1 = _easing$1$split$0$spl2[1];
            x2 = _easing$1$split$0$spl2[2];
            y2 = _easing$1$split$0$spl2[3];
          } else {
            Object(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* warn */])(false, '[configBezier]: arguments should be one of ' + 'oneOf \'linear\', \'ease\', \'ease-in\', \'ease-out\', ' + '\'ease-in-out\',\'cubic-bezier(x1,y1,x2,y2)\', instead received %s', args);
          }
        }
    }
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* warn */])([x1, x2, y1, y2].every(function (num) {
    return typeof num === 'number' && num >= 0 && num <= 1;
  }), '[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s', args);
  var curveX = cubicBezier(x1, x2);
  var curveY = cubicBezier(y1, y2);
  var derCurveX = derivativeCubicBezier(x1, x2);

  var rangeValue = function rangeValue(value) {
    if (value > 1) {
      return 1;
    } else if (value < 0) {
      return 0;
    }

    return value;
  };

  var bezier = function bezier(_t) {
    var t = _t > 1 ? 1 : _t;
    var x = t;

    for (var i = 0; i < 8; ++i) {
      var evalT = curveX(x) - t;
      var derVal = derCurveX(x);

      if (Math.abs(evalT - t) < ACCURACY || derVal < ACCURACY) {
        return curveY(x);
      }

      x = rangeValue(x - evalT / derVal);
    }

    return curveY(x);
  };

  bezier.isStepper = false;
  return bezier;
};
var configSpring = function configSpring() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config$stiff = config.stiff,
      stiff = _config$stiff === void 0 ? 100 : _config$stiff,
      _config$damping = config.damping,
      damping = _config$damping === void 0 ? 8 : _config$damping,
      _config$dt = config.dt,
      dt = _config$dt === void 0 ? 17 : _config$dt;

  var stepper = function stepper(currX, destX, currV) {
    var FSpring = -(currX - destX) * stiff;
    var FDamping = currV * damping;
    var newV = currV + (FSpring - FDamping) * dt / 1000;
    var newX = currV * dt / 1000 + currX;

    if (Math.abs(newX - destX) < ACCURACY && Math.abs(newV) < ACCURACY) {
      return [destX, 0];
    }

    return [newX, newV];
  };

  stepper.isStepper = true;
  stepper.dt = dt;
  return stepper;
};
var configEasing = function configEasing() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var easing = args[0];

  if (typeof easing === 'string') {
    switch (easing) {
      case 'ease':
      case 'ease-in-out':
      case 'ease-out':
      case 'ease-in':
      case 'linear':
        return configBezier(easing);

      case 'spring':
        return configSpring();

      default:
        if (easing.split('(')[0] === 'cubic-bezier') {
          return configBezier(easing);
        }

        Object(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* warn */])(false, '[configEasing]: first argument should be one of \'ease\', \'ease-in\', ' + '\'ease-out\', \'ease-in-out\',\'cubic-bezier(x1,y1,x2,y2)\', \'linear\' and \'spring\', instead  received %s', args);
    }
  }

  if (typeof easing === 'function') {
    return easing;
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* warn */])(false, '[configEasing]: first argument type should be function or ' + 'string, instead received %s', args);
  return null;
};

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

var baseExtremum = __webpack_require__(286),
    baseGt = __webpack_require__(734),
    identity = __webpack_require__(158);

/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */
function max(array) {
  return (array && array.length)
    ? baseExtremum(array, identity, baseGt)
    : undefined;
}

module.exports = max;


/***/ }),
/* 734 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */
function baseGt(value, other) {
  return value > other;
}

module.exports = baseGt;


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

var baseExtremum = __webpack_require__(286),
    baseLt = __webpack_require__(736),
    identity = __webpack_require__(158);

/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */
function min(array) {
  return (array && array.length)
    ? baseExtremum(array, identity, baseLt)
    : undefined;
}

module.exports = min;


/***/ }),
/* 736 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */
function baseLt(value, other) {
  return value < other;
}

module.exports = baseLt;


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! decimal.js-light v2.5.0 https://github.com/MikeMcl/decimal.js-light/LICENCE */
;(function (globalScope) {
  'use strict';


  /*
   *  decimal.js-light v2.5.0
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js-light
   *  Copyright (c) 2018 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Expat Licence
   */


  // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //


    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
  var MAX_DIGITS = 1e9,                        // 0 to 1e9


    // The initial configuration properties of the Decimal constructor.
    Decimal = {

      // These values must be integers within the stated ranges (inclusive).
      // Most of these values can be changed during run-time using `Decimal.config`.

      // The maximum number of significant digits of the result of a calculation or base conversion.
      // E.g. `Decimal.config({ precision: 20 });`
      precision: 20,                         // 1 to MAX_DIGITS

      // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
      // `toFixed`, `toPrecision` and `toSignificantDigits`.
      //
      // ROUND_UP         0 Away from zero.
      // ROUND_DOWN       1 Towards zero.
      // ROUND_CEIL       2 Towards +Infinity.
      // ROUND_FLOOR      3 Towards -Infinity.
      // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
      // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
      // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
      // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
      // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
      //
      // E.g.
      // `Decimal.rounding = 4;`
      // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
      rounding: 4,                           // 0 to 8

      // The exponent value at and beneath which `toString` returns exponential notation.
      // JavaScript numbers: -7
      toExpNeg: -7,                          // 0 to -MAX_E

      // The exponent value at and above which `toString` returns exponential notation.
      // JavaScript numbers: 21
      toExpPos:  21,                         // 0 to MAX_E

      // The natural logarithm of 10.
      // 115 digits
      LN10: '2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286'
    },


  // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //


    external = true,

    decimalError = '[DecimalError] ',
    invalidArgument = decimalError + 'Invalid argument: ',
    exponentOutOfRange = decimalError + 'Exponent out of range: ',

    mathfloor = Math.floor,
    mathpow = Math.pow,

    isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,

    ONE,
    BASE = 1e7,
    LOG_BASE = 7,
    MAX_SAFE_INTEGER = 9007199254740991,
    MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE),    // 1286742750677284

    // Decimal.prototype object
    P = {};


  // Decimal prototype methods


  /*
   *  absoluteValue                       abs
   *  comparedTo                          cmp
   *  decimalPlaces                       dp
   *  dividedBy                           div
   *  dividedToIntegerBy                  idiv
   *  equals                              eq
   *  exponent
   *  greaterThan                         gt
   *  greaterThanOrEqualTo                gte
   *  isInteger                           isint
   *  isNegative                          isneg
   *  isPositive                          ispos
   *  isZero
   *  lessThan                            lt
   *  lessThanOrEqualTo                   lte
   *  logarithm                           log
   *  minus                               sub
   *  modulo                              mod
   *  naturalExponential                  exp
   *  naturalLogarithm                    ln
   *  negated                             neg
   *  plus                                add
   *  precision                           sd
   *  squareRoot                          sqrt
   *  times                               mul
   *  toDecimalPlaces                     todp
   *  toExponential
   *  toFixed
   *  toInteger                           toint
   *  toNumber
   *  toPower                             pow
   *  toPrecision
   *  toSignificantDigits                 tosd
   *  toString
   *  valueOf                             val
   */


  /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */
  P.absoluteValue = P.abs = function () {
    var x = new this.constructor(this);
    if (x.s) x.s = 1;
    return x;
  };


  /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value
   *
   */
  P.comparedTo = P.cmp = function (y) {
    var i, j, xdL, ydL,
      x = this;

    y = new x.constructor(y);

    // Signs differ?
    if (x.s !== y.s) return x.s || -y.s;

    // Compare exponents.
    if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;

    xdL = x.d.length;
    ydL = y.d.length;

    // Compare digit by digit.
    for (i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i) {
      if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
    }

    // Compare lengths.
    return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
  };


  /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */
  P.decimalPlaces = P.dp = function () {
    var x = this,
      w = x.d.length - 1,
      dp = (w - x.e) * LOG_BASE;

    // Subtract the number of trailing zeros of the last word.
    w = x.d[w];
    if (w) for (; w % 10 == 0; w /= 10) dp--;

    return dp < 0 ? 0 : dp;
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
   * `precision` significant digits.
   *
   */
  P.dividedBy = P.div = function (y) {
    return divide(this, new this.constructor(y));
  };


  /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, truncated to `precision` significant digits.
   *
   */
  P.dividedToIntegerBy = P.idiv = function (y) {
    var x = this,
      Ctor = x.constructor;
    return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
  };


  /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */
  P.equals = P.eq = function (y) {
    return !this.cmp(y);
  };


  /*
   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
   *
   */
  P.exponent = function () {
    return getBase10Exponent(this);
  };


  /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */
  P.greaterThan = P.gt = function (y) {
    return this.cmp(y) > 0;
  };


  /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */
  P.greaterThanOrEqualTo = P.gte = function (y) {
    return this.cmp(y) >= 0;
  };


  /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */
  P.isInteger = P.isint = function () {
    return this.e > this.d.length - 2;
  };


  /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */
  P.isNegative = P.isneg = function () {
    return this.s < 0;
  };


  /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */
  P.isPositive = P.ispos = function () {
    return this.s > 0;
  };


  /*
   * Return true if the value of this Decimal is 0, otherwise return false.
   *
   */
  P.isZero = function () {
    return this.s === 0;
  };


  /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */
  P.lessThan = P.lt = function (y) {
    return this.cmp(y) < 0;
  };


  /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */
  P.lessThanOrEqualTo = P.lte = function (y) {
    return this.cmp(y) < 1;
  };


  /*
   * Return the logarithm of the value of this Decimal to the specified base, truncated to
   * `precision` significant digits.
   *
   * If no base is specified, return log[10](x).
   *
   * log[base](x) = ln(x) / ln(base)
   *
   * The maximum error of the result is 1 ulp (unit in the last place).
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */
  P.logarithm = P.log = function (base) {
    var r,
      x = this,
      Ctor = x.constructor,
      pr = Ctor.precision,
      wpr = pr + 5;

    // Default base is 10.
    if (base === void 0) {
      base = new Ctor(10);
    } else {
      base = new Ctor(base);

      // log[-b](x) = NaN
      // log[0](x)  = NaN
      // log[1](x)  = NaN
      if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + 'NaN');
    }

    // log[b](-x) = NaN
    // log[b](0) = -Infinity
    if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));

    // log[b](1) = 0
    if (x.eq(ONE)) return new Ctor(0);

    external = false;
    r = divide(ln(x, wpr), ln(base, wpr), wpr);
    external = true;

    return round(r, pr);
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
   * `precision` significant digits.
   *
   */
  P.minus = P.sub = function (y) {
    var x = this;
    y = new x.constructor(y);
    return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
   * `precision` significant digits.
   *
   */
  P.modulo = P.mod = function (y) {
    var q,
      x = this,
      Ctor = x.constructor,
      pr = Ctor.precision;

    y = new Ctor(y);

    // x % 0 = NaN
    if (!y.s) throw Error(decimalError + 'NaN');

    // Return x if x is 0.
    if (!x.s) return round(new Ctor(x), pr);

    // Prevent rounding of intermediate calculations.
    external = false;
    q = divide(x, y, 0, 1).times(y);
    external = true;

    return x.minus(q);
  };


  /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
   * significant digits.
   *
   */
  P.naturalExponential = P.exp = function () {
    return exp(this);
  };


  /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * truncated to `precision` significant digits.
   *
   */
  P.naturalLogarithm = P.ln = function () {
    return ln(this);
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */
  P.negated = P.neg = function () {
    var x = new this.constructor(this);
    x.s = -x.s || 0;
    return x;
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
   * `precision` significant digits.
   *
   */
  P.plus = P.add = function (y) {
    var x = this;
    y = new x.constructor(y);
    return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
  };


  /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */
  P.precision = P.sd = function (z) {
    var e, sd, w,
      x = this;

    if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);

    e = getBase10Exponent(x) + 1;
    w = x.d.length - 1;
    sd = w * LOG_BASE + 1;
    w = x.d[w];

    // If non-zero...
    if (w) {

      // Subtract the number of trailing zeros of the last word.
      for (; w % 10 == 0; w /= 10) sd--;

      // Add the number of digits of the first word.
      for (w = x.d[0]; w >= 10; w /= 10) sd++;
    }

    return z && e > sd ? e : sd;
  };


  /*
   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
   * significant digits.
   *
   */
  P.squareRoot = P.sqrt = function () {
    var e, n, pr, r, s, t, wpr,
      x = this,
      Ctor = x.constructor;

    // Negative or zero?
    if (x.s < 1) {
      if (!x.s) return new Ctor(0);

      // sqrt(-x) = NaN
      throw Error(decimalError + 'NaN');
    }

    e = getBase10Exponent(x);
    external = false;

    // Initial estimate.
    s = Math.sqrt(+x);

    // Math.sqrt underflow/overflow?
    // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
    if (s == 0 || s == 1 / 0) {
      n = digitsToString(x.d);
      if ((n.length + e) % 2 == 0) n += '0';
      s = Math.sqrt(n);
      e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);

      if (s == 1 / 0) {
        n = '1e' + e;
      } else {
        n = s.toExponential();
        n = n.slice(0, n.indexOf('e') + 1) + e;
      }

      r = new Ctor(n);
    } else {
      r = new Ctor(s.toString());
    }

    pr = Ctor.precision;
    s = wpr = pr + 3;

    // Newton-Raphson iteration.
    for (;;) {
      t = r;
      r = t.plus(divide(x, t, wpr + 2)).times(0.5);

      if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
        n = n.slice(wpr - 3, wpr + 1);

        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
        // 4999, i.e. approaching a rounding boundary, continue the iteration.
        if (s == wpr && n == '4999') {

          // On the first iteration only, check to see if rounding up gives the exact result as the
          // nines may infinitely repeat.
          round(t, pr + 1, 0);

          if (t.times(t).eq(x)) {
            r = t;
            break;
          }
        } else if (n != '9999') {
          break;
        }

        wpr += 4;
      }
    }

    external = true;

    return round(r, pr);
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
   * `precision` significant digits.
   *
   */
  P.times = P.mul = function (y) {
    var carry, e, i, k, r, rL, t, xdL, ydL,
      x = this,
      Ctor = x.constructor,
      xd = x.d,
      yd = (y = new Ctor(y)).d;

    // Return 0 if either is 0.
    if (!x.s || !y.s) return new Ctor(0);

    y.s *= x.s;
    e = x.e + y.e;
    xdL = xd.length;
    ydL = yd.length;

    // Ensure xd points to the longer array.
    if (xdL < ydL) {
      r = xd;
      xd = yd;
      yd = r;
      rL = xdL;
      xdL = ydL;
      ydL = rL;
    }

    // Initialise the result array with zeros.
    r = [];
    rL = xdL + ydL;
    for (i = rL; i--;) r.push(0);

    // Multiply!
    for (i = ydL; --i >= 0;) {
      carry = 0;
      for (k = xdL + i; k > i;) {
        t = r[k] + yd[i] * xd[k - i - 1] + carry;
        r[k--] = t % BASE | 0;
        carry = t / BASE | 0;
      }

      r[k] = (r[k] + carry) % BASE | 0;
    }

    // Remove trailing zeros.
    for (; !r[--rL];) r.pop();

    if (carry) ++e;
    else r.shift();

    y.d = r;
    y.e = e;

    return external ? round(y, Ctor.precision) : y;
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */
  P.toDecimalPlaces = P.todp = function (dp, rm) {
    var x = this,
      Ctor = x.constructor;

    x = new Ctor(x);
    if (dp === void 0) return x;

    checkInt32(dp, 0, MAX_DIGITS);

    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);

    return round(x, dp + getBase10Exponent(x) + 1, rm);
  };


  /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */
  P.toExponential = function (dp, rm) {
    var str,
      x = this,
      Ctor = x.constructor;

    if (dp === void 0) {
      str = toString(x, true);
    } else {
      checkInt32(dp, 0, MAX_DIGITS);

      if (rm === void 0) rm = Ctor.rounding;
      else checkInt32(rm, 0, 8);

      x = round(new Ctor(x), dp + 1, rm);
      str = toString(x, true, dp + 1);
    }

    return str;
  };


  /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */
  P.toFixed = function (dp, rm) {
    var str, y,
      x = this,
      Ctor = x.constructor;

    if (dp === void 0) return toString(x);

    checkInt32(dp, 0, MAX_DIGITS);

    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);

    y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
    str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);

    // To determine whether to add the minus sign look at the value before it was rounded,
    // i.e. look at `x` rather than `y`.
    return x.isneg() && !x.isZero() ? '-' + str : str;
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */
  P.toInteger = P.toint = function () {
    var x = this,
      Ctor = x.constructor;
    return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
  };


  /*
   * Return the value of this Decimal converted to a number primitive.
   *
   */
  P.toNumber = function () {
    return +this;
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
   * truncated to `precision` significant digits.
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * The maximum error is 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */
  P.toPower = P.pow = function (y) {
    var e, k, pr, r, sign, yIsInt,
      x = this,
      Ctor = x.constructor,
      guard = 12,
      yn = +(y = new Ctor(y));

    // pow(x, 0) = 1
    if (!y.s) return new Ctor(ONE);

    x = new Ctor(x);

    // pow(0, y > 0) = 0
    // pow(0, y < 0) = Infinity
    if (!x.s) {
      if (y.s < 1) throw Error(decimalError + 'Infinity');
      return x;
    }

    // pow(1, y) = 1
    if (x.eq(ONE)) return x;

    pr = Ctor.precision;

    // pow(x, 1) = x
    if (y.eq(ONE)) return round(x, pr);

    e = y.e;
    k = y.d.length - 1;
    yIsInt = e >= k;
    sign = x.s;

    if (!yIsInt) {

      // pow(x < 0, y non-integer) = NaN
      if (sign < 0) throw Error(decimalError + 'NaN');

    // If y is a small integer use the 'exponentiation by squaring' algorithm.
    } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
      r = new Ctor(ONE);

      // Max k of 9007199254740991 takes 53 loop iterations.
      // Maximum digits array length; leaves [28, 34] guard digits.
      e = Math.ceil(pr / LOG_BASE + 4);

      external = false;

      for (;;) {
        if (k % 2) {
          r = r.times(x);
          truncate(r.d, e);
        }

        k = mathfloor(k / 2);
        if (k === 0) break;

        x = x.times(x);
        truncate(x.d, e);
      }

      external = true;

      return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
    }

    // Result is negative if x is negative and the last digit of integer y is odd.
    sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;

    x.s = 1;
    external = false;
    r = y.times(ln(x, pr + guard));
    external = true;
    r = exp(r);
    r.s = sign;

    return r;
  };


  /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */
  P.toPrecision = function (sd, rm) {
    var e, str,
      x = this,
      Ctor = x.constructor;

    if (sd === void 0) {
      e = getBase10Exponent(x);
      str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    } else {
      checkInt32(sd, 1, MAX_DIGITS);

      if (rm === void 0) rm = Ctor.rounding;
      else checkInt32(rm, 0, 8);

      x = round(new Ctor(x), sd, rm);
      e = getBase10Exponent(x);
      str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
    }

    return str;
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */
  P.toSignificantDigits = P.tosd = function (sd, rm) {
    var x = this,
      Ctor = x.constructor;

    if (sd === void 0) {
      sd = Ctor.precision;
      rm = Ctor.rounding;
    } else {
      checkInt32(sd, 1, MAX_DIGITS);

      if (rm === void 0) rm = Ctor.rounding;
      else checkInt32(rm, 0, 8);
    }

    return round(new Ctor(x), sd, rm);
  };


  /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */
  P.toString = P.valueOf = P.val = P.toJSON = function () {
    var x = this,
      e = getBase10Exponent(x),
      Ctor = x.constructor;

    return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
  };


  // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.


  /*
   *  add                 P.minus, P.plus
   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
   *  exp                 P.exp, P.pow
   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
   *                      P.toString, divide, round, toString, exp, ln
   *  getLn10             P.log, ln
   *  getZeroString       digitsToString, toString
   *  ln                  P.log, P.ln, P.pow, exp
   *  parseDecimal        Decimal
   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
   *                      divide, getLn10, exp, ln
   *  subtract            P.minus, P.plus
   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
   *  truncate            P.pow
   *
   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
   *                      getLn10, exp, ln, parseDecimal, Decimal, config
   */


  function add(x, y) {
    var carry, d, e, i, k, len, xd, yd,
      Ctor = x.constructor,
      pr = Ctor.precision;

    // If either is zero...
    if (!x.s || !y.s) {

      // Return x if y is zero.
      // Return y if y is non-zero.
      if (!y.s) y = new Ctor(x);
      return external ? round(y, pr) : y;
    }

    xd = x.d;
    yd = y.d;

    // x and y are finite, non-zero numbers with the same sign.

    k = x.e;
    e = y.e;
    xd = xd.slice();
    i = k - e;

    // If base 1e7 exponents differ...
    if (i) {
      if (i < 0) {
        d = xd;
        i = -i;
        len = yd.length;
      } else {
        d = yd;
        e = k;
        len = xd.length;
      }

      // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
      k = Math.ceil(pr / LOG_BASE);
      len = k > len ? k + 1 : len + 1;

      if (i > len) {
        i = len;
        d.length = 1;
      }

      // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
      d.reverse();
      for (; i--;) d.push(0);
      d.reverse();
    }

    len = xd.length;
    i = yd.length;

    // If yd is longer than xd, swap xd and yd so xd points to the longer array.
    if (len - i < 0) {
      i = len;
      d = yd;
      yd = xd;
      xd = d;
    }

    // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
    for (carry = 0; i;) {
      carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
      xd[i] %= BASE;
    }

    if (carry) {
      xd.unshift(carry);
      ++e;
    }

    // Remove trailing zeros.
    // No need to check for zero, as +x + +y != 0 && -x + -y != 0
    for (len = xd.length; xd[--len] == 0;) xd.pop();

    y.d = xd;
    y.e = e;

    return external ? round(y, pr) : y;
  }


  function checkInt32(i, min, max) {
    if (i !== ~~i || i < min || i > max) {
      throw Error(invalidArgument + i);
    }
  }


  function digitsToString(d) {
    var i, k, ws,
      indexOfLastWord = d.length - 1,
      str = '',
      w = d[0];

    if (indexOfLastWord > 0) {
      str += w;
      for (i = 1; i < indexOfLastWord; i++) {
        ws = d[i] + '';
        k = LOG_BASE - ws.length;
        if (k) str += getZeroString(k);
        str += ws;
      }

      w = d[i];
      ws = w + '';
      k = LOG_BASE - ws.length;
      if (k) str += getZeroString(k);
    } else if (w === 0) {
      return '0';
    }

    // Remove trailing zeros of last w.
    for (; w % 10 === 0;) w /= 10;

    return str + w;
  }


  var divide = (function () {

    // Assumes non-zero x and k, and hence non-zero result.
    function multiplyInteger(x, k) {
      var temp,
        carry = 0,
        i = x.length;

      for (x = x.slice(); i--;) {
        temp = x[i] * k + carry;
        x[i] = temp % BASE | 0;
        carry = temp / BASE | 0;
      }

      if (carry) x.unshift(carry);

      return x;
    }

    function compare(a, b, aL, bL) {
      var i, r;

      if (aL != bL) {
        r = aL > bL ? 1 : -1;
      } else {
        for (i = r = 0; i < aL; i++) {
          if (a[i] != b[i]) {
            r = a[i] > b[i] ? 1 : -1;
            break;
          }
        }
      }

      return r;
    }

    function subtract(a, b, aL) {
      var i = 0;

      // Subtract b from a.
      for (; aL--;) {
        a[aL] -= i;
        i = a[aL] < b[aL] ? 1 : 0;
        a[aL] = i * BASE + a[aL] - b[aL];
      }

      // Remove leading zeros.
      for (; !a[0] && a.length > 1;) a.shift();
    }

    return function (x, y, pr, dp) {
      var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz,
        Ctor = x.constructor,
        sign = x.s == y.s ? 1 : -1,
        xd = x.d,
        yd = y.d;

      // Either 0?
      if (!x.s) return new Ctor(x);
      if (!y.s) throw Error(decimalError + 'Division by zero');

      e = x.e - y.e;
      yL = yd.length;
      xL = xd.length;
      q = new Ctor(sign);
      qd = q.d = [];

      // Result exponent may be one less than e.
      for (i = 0; yd[i] == (xd[i] || 0); ) ++i;
      if (yd[i] > (xd[i] || 0)) --e;

      if (pr == null) {
        sd = pr = Ctor.precision;
      } else if (dp) {
        sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
      } else {
        sd = pr;
      }

      if (sd < 0) return new Ctor(0);

      // Convert precision in number of base 10 digits to base 1e7 digits.
      sd = sd / LOG_BASE + 2 | 0;
      i = 0;

      // divisor < 1e7
      if (yL == 1) {
        k = 0;
        yd = yd[0];
        sd++;

        // k is the carry.
        for (; (i < xL || k) && sd--; i++) {
          t = k * BASE + (xd[i] || 0);
          qd[i] = t / yd | 0;
          k = t % yd | 0;
        }

      // divisor >= 1e7
      } else {

        // Normalise xd and yd so highest order digit of yd is >= BASE/2
        k = BASE / (yd[0] + 1) | 0;

        if (k > 1) {
          yd = multiplyInteger(yd, k);
          xd = multiplyInteger(xd, k);
          yL = yd.length;
          xL = xd.length;
        }

        xi = yL;
        rem = xd.slice(0, yL);
        remL = rem.length;

        // Add zeros to make remainder as long as divisor.
        for (; remL < yL;) rem[remL++] = 0;

        yz = yd.slice();
        yz.unshift(0);
        yd0 = yd[0];

        if (yd[1] >= BASE / 2) ++yd0;

        do {
          k = 0;

          // Compare divisor and remainder.
          cmp = compare(yd, rem, yL, remL);

          // If divisor < remainder.
          if (cmp < 0) {

            // Calculate trial digit, k.
            rem0 = rem[0];
            if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);

            // k will be how many times the divisor goes into the current remainder.
            k = rem0 / yd0 | 0;

            //  Algorithm:
            //  1. product = divisor * trial digit (k)
            //  2. if product > remainder: product -= divisor, k--
            //  3. remainder -= product
            //  4. if product was < remainder at 2:
            //    5. compare new remainder and divisor
            //    6. If remainder > divisor: remainder -= divisor, k++

            if (k > 1) {
              if (k >= BASE) k = BASE - 1;

              // product = divisor * trial digit.
              prod = multiplyInteger(yd, k);
              prodL = prod.length;
              remL = rem.length;

              // Compare product and remainder.
              cmp = compare(prod, rem, prodL, remL);

              // product > remainder.
              if (cmp == 1) {
                k--;

                // Subtract divisor from product.
                subtract(prod, yL < prodL ? yz : yd, prodL);
              }
            } else {

              // cmp is -1.
              // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
              // to avoid it. If k is 1 there is a need to compare yd and rem again below.
              if (k == 0) cmp = k = 1;
              prod = yd.slice();
            }

            prodL = prod.length;
            if (prodL < remL) prod.unshift(0);

            // Subtract product from remainder.
            subtract(rem, prod, remL);

            // If product was < previous remainder.
            if (cmp == -1) {
              remL = rem.length;

              // Compare divisor and new remainder.
              cmp = compare(yd, rem, yL, remL);

              // If divisor < new remainder, subtract divisor from remainder.
              if (cmp < 1) {
                k++;

                // Subtract divisor from remainder.
                subtract(rem, yL < remL ? yz : yd, remL);
              }
            }

            remL = rem.length;
          } else if (cmp === 0) {
            k++;
            rem = [0];
          }    // if cmp === 1, k will be 0

          // Add the next digit, k, to the result array.
          qd[i++] = k;

          // Update the remainder.
          if (cmp && rem[0]) {
            rem[remL++] = xd[xi] || 0;
          } else {
            rem = [xd[xi]];
            remL = 1;
          }

        } while ((xi++ < xL || rem[0] !== void 0) && sd--);
      }

      // Leading zero?
      if (!qd[0]) qd.shift();

      q.e = e;

      return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
    };
  })();


  /*
   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
   * significant digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   */
  function exp(x, sd) {
    var denominator, guard, pow, sum, t, wpr,
      i = 0,
      k = 0,
      Ctor = x.constructor,
      pr = Ctor.precision;

    if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));

    // exp(0) = 1
    if (!x.s) return new Ctor(ONE);

    if (sd == null) {
      external = false;
      wpr = pr;
    } else {
      wpr = sd;
    }

    t = new Ctor(0.03125);

    while (x.abs().gte(0.1)) {
      x = x.times(t);    // x = x / 2^5
      k += 5;
    }

    // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
    guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
    wpr += guard;
    denominator = pow = sum = new Ctor(ONE);
    Ctor.precision = wpr;

    for (;;) {
      pow = round(pow.times(x), wpr);
      denominator = denominator.times(++i);
      t = sum.plus(divide(pow, denominator, wpr));

      if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
        while (k--) sum = round(sum.times(sum), wpr);
        Ctor.precision = pr;
        return sd == null ? (external = true, round(sum, pr)) : sum;
      }

      sum = t;
    }
  }


  // Calculate the base 10 exponent from the base 1e7 exponent.
  function getBase10Exponent(x) {
    var e = x.e * LOG_BASE,
      w = x.d[0];

    // Add the number of digits of the first word of the digits array.
    for (; w >= 10; w /= 10) e++;
    return e;
  }


  function getLn10(Ctor, sd, pr) {

    if (sd > Ctor.LN10.sd()) {


      // Reset global state in case the exception is caught.
      external = true;
      if (pr) Ctor.precision = pr;
      throw Error(decimalError + 'LN10 precision limit exceeded');
    }

    return round(new Ctor(Ctor.LN10), sd);
  }


  function getZeroString(k) {
    var zs = '';
    for (; k--;) zs += '0';
    return zs;
  }


  /*
   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
   * digits.
   *
   *  ln(n) is non-terminating (n != 1)
   *
   */
  function ln(y, sd) {
    var c, c0, denominator, e, numerator, sum, t, wpr, x2,
      n = 1,
      guard = 10,
      x = y,
      xd = x.d,
      Ctor = x.constructor,
      pr = Ctor.precision;

    // ln(-x) = NaN
    // ln(0) = -Infinity
    if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));

    // ln(1) = 0
    if (x.eq(ONE)) return new Ctor(0);

    if (sd == null) {
      external = false;
      wpr = pr;
    } else {
      wpr = sd;
    }

    if (x.eq(10)) {
      if (sd == null) external = true;
      return getLn10(Ctor, wpr);
    }

    wpr += guard;
    Ctor.precision = wpr;
    c = digitsToString(xd);
    c0 = c.charAt(0);
    e = getBase10Exponent(x);

    if (Math.abs(e) < 1.5e15) {

      // Argument reduction.
      // The series converges faster the closer the argument is to 1, so using
      // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
      // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
      // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
      // later be divided by this number, then separate out the power of 10 using
      // ln(a*10^b) = ln(a) + b*ln(10).

      // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
      //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
      // max n is 6 (gives 0.7 - 1.3)
      while (c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3) {
        x = x.times(y);
        c = digitsToString(x.d);
        c0 = c.charAt(0);
        n++;
      }

      e = getBase10Exponent(x);

      if (c0 > 1) {
        x = new Ctor('0.' + c);
        e++;
      } else {
        x = new Ctor(c0 + '.' + c.slice(1));
      }
    } else {

      // The argument reduction method above may result in overflow if the argument y is a massive
      // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
      // function using ln(x*10^e) = ln(x) + e*ln(10).
      t = getLn10(Ctor, wpr + 2, pr).times(e + '');
      x = ln(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);

      Ctor.precision = pr;
      return sd == null ? (external = true, round(x, pr)) : x;
    }

    // x is reduced to a value near 1.

    // Taylor series.
    // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
    // where x = (y - 1)/(y + 1)    (|x| < 1)
    sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
    x2 = round(x.times(x), wpr);
    denominator = 3;

    for (;;) {
      numerator = round(numerator.times(x2), wpr);
      t = sum.plus(divide(numerator, new Ctor(denominator), wpr));

      if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
        sum = sum.times(2);

        // Reverse the argument reduction.
        if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
        sum = divide(sum, new Ctor(n), wpr);

        Ctor.precision = pr;
        return sd == null ? (external = true, round(sum, pr)) : sum;
      }

      sum = t;
      denominator += 2;
    }
  }


  /*
   * Parse the value of a new Decimal `x` from string `str`.
   */
  function parseDecimal(x, str) {
    var e, i, len;

    // Decimal point?
    if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');

    // Exponential form?
    if ((i = str.search(/e/i)) > 0) {

      // Determine exponent.
      if (e < 0) e = i;
      e += +str.slice(i + 1);
      str = str.substring(0, i);
    } else if (e < 0) {

      // Integer.
      e = str.length;
    }

    // Determine leading zeros.
    for (i = 0; str.charCodeAt(i) === 48;) ++i;

    // Determine trailing zeros.
    for (len = str.length; str.charCodeAt(len - 1) === 48;) --len;
    str = str.slice(i, len);

    if (str) {
      len -= i;
      e = e - i - 1;
      x.e = mathfloor(e / LOG_BASE);
      x.d = [];

      // Transform base

      // e is the base 10 exponent.
      // i is where to slice str to get the first word of the digits array.
      i = (e + 1) % LOG_BASE;
      if (e < 0) i += LOG_BASE;

      if (i < len) {
        if (i) x.d.push(+str.slice(0, i));
        for (len -= LOG_BASE; i < len;) x.d.push(+str.slice(i, i += LOG_BASE));
        str = str.slice(i);
        i = LOG_BASE - str.length;
      } else {
        i -= len;
      }

      for (; i--;) str += '0';
      x.d.push(+str);

      if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
    } else {

      // Zero.
      x.s = 0;
      x.e = 0;
      x.d = [0];
    }

    return x;
  }


  /*
   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
   */
   function round(x, sd, rm) {
    var i, j, k, n, rd, doRound, w, xdi,
      xd = x.d;

    // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
    // w: the word of xd which contains the rounding digit, a base 1e7 number.
    // xdi: the index of w within xd.
    // n: the number of digits of w.
    // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
    // they had leading zeros)
    // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).

    // Get the length of the first word of the digits array xd.
    for (n = 1, k = xd[0]; k >= 10; k /= 10) n++;
    i = sd - n;

    // Is the rounding digit in the first word of xd?
    if (i < 0) {
      i += LOG_BASE;
      j = sd;
      w = xd[xdi = 0];
    } else {
      xdi = Math.ceil((i + 1) / LOG_BASE);
      k = xd.length;
      if (xdi >= k) return x;
      w = k = xd[xdi];

      // Get the number of digits of w.
      for (n = 1; k >= 10; k /= 10) n++;

      // Get the index of rd within w.
      i %= LOG_BASE;

      // Get the index of rd within w, adjusted for leading zeros.
      // The number of leading zeros of w is given by LOG_BASE - n.
      j = i - LOG_BASE + n;
    }

    if (rm !== void 0) {
      k = mathpow(10, n - j - 1);

      // Get the rounding digit at index j of w.
      rd = w / k % 10 | 0;

      // Are there any non-zero digits after the rounding digit?
      doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;

      // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
      // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
      // 714.

      doRound = rm < 4
        ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2))
        : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 &&

          // Check whether the digit to the left of the rounding digit is odd.
          ((i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10) & 1 ||
            rm == (x.s < 0 ? 8 : 7));
    }

    if (sd < 1 || !xd[0]) {
      if (doRound) {
        k = getBase10Exponent(x);
        xd.length = 1;

        // Convert sd to decimal places.
        sd = sd - k - 1;

        // 1, 0.1, 0.01, 0.001, 0.0001 etc.
        xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
        x.e = mathfloor(-sd / LOG_BASE) || 0;
      } else {
        xd.length = 1;

        // Zero.
        xd[0] = x.e = x.s = 0;
      }

      return x;
    }

    // Remove excess digits.
    if (i == 0) {
      xd.length = xdi;
      k = 1;
      xdi--;
    } else {
      xd.length = xdi + 1;
      k = mathpow(10, LOG_BASE - i);

      // E.g. 56700 becomes 56000 if 7 is the rounding digit.
      // j > 0 means i > number of leading zeros of w.
      xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
    }

    if (doRound) {
      for (;;) {

        // Is the digit to be rounded up in the first word of xd?
        if (xdi == 0) {
          if ((xd[0] += k) == BASE) {
            xd[0] = 1;
            ++x.e;
          }

          break;
        } else {
          xd[xdi] += k;
          if (xd[xdi] != BASE) break;
          xd[xdi--] = 0;
          k = 1;
        }
      }
    }

    // Remove trailing zeros.
    for (i = xd.length; xd[--i] === 0;) xd.pop();

    if (external && (x.e > MAX_E || x.e < -MAX_E)) {
      throw Error(exponentOutOfRange + getBase10Exponent(x));
    }

    return x;
  }


  function subtract(x, y) {
    var d, e, i, j, k, len, xd, xe, xLTy, yd,
      Ctor = x.constructor,
      pr = Ctor.precision;

    // Return y negated if x is zero.
    // Return x if y is zero and x is non-zero.
    if (!x.s || !y.s) {
      if (y.s) y.s = -y.s;
      else y = new Ctor(x);
      return external ? round(y, pr) : y;
    }

    xd = x.d;
    yd = y.d;

    // x and y are non-zero numbers with the same sign.

    e = y.e;
    xe = x.e;
    xd = xd.slice();
    k = xe - e;

    // If exponents differ...
    if (k) {
      xLTy = k < 0;

      if (xLTy) {
        d = xd;
        k = -k;
        len = yd.length;
      } else {
        d = yd;
        e = xe;
        len = xd.length;
      }

      // Numbers with massively different exponents would result in a very high number of zeros
      // needing to be prepended, but this can be avoided while still ensuring correct rounding by
      // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
      i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;

      if (k > i) {
        k = i;
        d.length = 1;
      }

      // Prepend zeros to equalise exponents.
      d.reverse();
      for (i = k; i--;) d.push(0);
      d.reverse();

    // Base 1e7 exponents equal.
    } else {

      // Check digits to determine which is the bigger number.

      i = xd.length;
      len = yd.length;
      xLTy = i < len;
      if (xLTy) len = i;

      for (i = 0; i < len; i++) {
        if (xd[i] != yd[i]) {
          xLTy = xd[i] < yd[i];
          break;
        }
      }

      k = 0;
    }

    if (xLTy) {
      d = xd;
      xd = yd;
      yd = d;
      y.s = -y.s;
    }

    len = xd.length;

    // Append zeros to xd if shorter.
    // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
    for (i = yd.length - len; i > 0; --i) xd[len++] = 0;

    // Subtract yd from xd.
    for (i = yd.length; i > k;) {
      if (xd[--i] < yd[i]) {
        for (j = i; j && xd[--j] === 0;) xd[j] = BASE - 1;
        --xd[j];
        xd[i] += BASE;
      }

      xd[i] -= yd[i];
    }

    // Remove trailing zeros.
    for (; xd[--len] === 0;) xd.pop();

    // Remove leading zeros and adjust exponent accordingly.
    for (; xd[0] === 0; xd.shift()) --e;

    // Zero?
    if (!xd[0]) return new Ctor(0);

    y.d = xd;
    y.e = e;

    //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
    return external ? round(y, pr) : y;
  }


  function toString(x, isExp, sd) {
    var k,
      e = getBase10Exponent(x),
      str = digitsToString(x.d),
      len = str.length;

    if (isExp) {
      if (sd && (k = sd - len) > 0) {
        str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
      } else if (len > 1) {
        str = str.charAt(0) + '.' + str.slice(1);
      }

      str = str + (e < 0 ? 'e' : 'e+') + e;
    } else if (e < 0) {
      str = '0.' + getZeroString(-e - 1) + str;
      if (sd && (k = sd - len) > 0) str += getZeroString(k);
    } else if (e >= len) {
      str += getZeroString(e + 1 - len);
      if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
    } else {
      if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
      if (sd && (k = sd - len) > 0) {
        if (e + 1 === len) str += '.';
        str += getZeroString(k);
      }
    }

    return x.s < 0 ? '-' + str : str;
  }


  // Does not strip trailing zeros.
  function truncate(arr, len) {
    if (arr.length > len) {
      arr.length = len;
      return true;
    }
  }


  // Decimal methods


  /*
   *  clone
   *  config/set
   */


  /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */
  function clone(obj) {
    var i, p, ps;

    /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * value {number|string|Decimal} A numeric value.
     *
     */
    function Decimal(value) {
      var x = this;

      // Decimal called without new.
      if (!(x instanceof Decimal)) return new Decimal(value);

      // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
      // which points to Object.
      x.constructor = Decimal;

      // Duplicate.
      if (value instanceof Decimal) {
        x.s = value.s;
        x.e = value.e;
        x.d = (value = value.d) ? value.slice() : value;
        return;
      }

      if (typeof value === 'number') {

        // Reject Infinity/NaN.
        if (value * 0 !== 0) {
          throw Error(invalidArgument + value);
        }

        if (value > 0) {
          x.s = 1;
        } else if (value < 0) {
          value = -value;
          x.s = -1;
        } else {
          x.s = 0;
          x.e = 0;
          x.d = [0];
          return;
        }

        // Fast path for small integers.
        if (value === ~~value && value < 1e7) {
          x.e = 0;
          x.d = [value];
          return;
        }

        return parseDecimal(x, value.toString());
      } else if (typeof value !== 'string') {
        throw Error(invalidArgument + value);
      }

      // Minus sign?
      if (value.charCodeAt(0) === 45) {
        value = value.slice(1);
        x.s = -1;
      } else {
        x.s = 1;
      }

      if (isDecimal.test(value)) parseDecimal(x, value);
      else throw Error(invalidArgument + value);
    }

    Decimal.prototype = P;

    Decimal.ROUND_UP = 0;
    Decimal.ROUND_DOWN = 1;
    Decimal.ROUND_CEIL = 2;
    Decimal.ROUND_FLOOR = 3;
    Decimal.ROUND_HALF_UP = 4;
    Decimal.ROUND_HALF_DOWN = 5;
    Decimal.ROUND_HALF_EVEN = 6;
    Decimal.ROUND_HALF_CEIL = 7;
    Decimal.ROUND_HALF_FLOOR = 8;

    Decimal.clone = clone;
    Decimal.config = Decimal.set = config;

    if (obj === void 0) obj = {};
    if (obj) {
      ps = ['precision', 'rounding', 'toExpNeg', 'toExpPos', 'LN10'];
      for (i = 0; i < ps.length;) if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
    }

    Decimal.config(obj);

    return Decimal;
  }


  /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */
  function config(obj) {
    if (!obj || typeof obj !== 'object') {
      throw Error(decimalError + 'Object expected');
    }
    var i, p, v,
      ps = [
        'precision', 1, MAX_DIGITS,
        'rounding', 0, 8,
        'toExpNeg', -1 / 0, 0,
        'toExpPos', 0, 1 / 0
      ];

    for (i = 0; i < ps.length; i += 3) {
      if ((v = obj[p = ps[i]]) !== void 0) {
        if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
        else throw Error(invalidArgument + p + ': ' + v);
      }
    }

    if ((v = obj[p = 'LN10']) !== void 0) {
        if (v == Math.LN10) this[p] = new this(v);
        else throw Error(invalidArgument + p + ': ' + v);
    }

    return this;
  }


  // Create and configure initial Decimal constructor.
  Decimal = clone(Decimal);

  Decimal['default'] = Decimal.Decimal = Decimal;

  // Internal constant.
  ONE = new Decimal(1);


  // Export.


  // AMD.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return Decimal;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

  // Node and other environments that support module.exports.
  } else if (typeof module != 'undefined' && module.exports) {
    module.exports = Decimal;

    // Browser.
  } else {
    if (!globalScope) {
      globalScope = typeof self != 'undefined' && self && self.self == self
        ? self : Function('return this')();
    }

    globalScope.Decimal = Decimal;
  }
})(this);


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.memoize = exports.reverse = exports.compose = exports.map = exports.range = exports.curry = exports.PLACE_HOLDER = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var identity = function identity(i) {
  return i;
};

var PLACE_HOLDER = {
  '@@functional/placeholder': true
};
exports.PLACE_HOLDER = PLACE_HOLDER;

var isPlaceHolder = function isPlaceHolder(val) {
  return val === PLACE_HOLDER;
};

var curry0 = function curry0(fn) {
  return function _curried() {
    if (arguments.length === 0 || arguments.length === 1 && isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) {
      return _curried;
    }

    return fn.apply(void 0, arguments);
  };
};

var curryN = function curryN(n, fn) {
  if (n === 1) {
    return fn;
  }

  return curry0(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var argsLength = args.filter(function (arg) {
      return arg !== PLACE_HOLDER;
    }).length;

    if (argsLength >= n) {
      return fn.apply(void 0, args);
    }

    return curryN(n - argsLength, curry0(function () {
      for (var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        restArgs[_key2] = arguments[_key2];
      }

      var newArgs = args.map(function (arg) {
        return isPlaceHolder(arg) ? restArgs.shift() : arg;
      });
      return fn.apply(void 0, _toConsumableArray(newArgs).concat(restArgs));
    }));
  });
};

var curry = function curry(fn) {
  return curryN(fn.length, fn);
};

exports.curry = curry;

var range = function range(begin, end) {
  var arr = [];

  for (var i = begin; i < end; ++i) {
    arr[i - begin] = i;
  }

  return arr;
};

exports.range = range;
var map = curry(function (fn, arr) {
  if (Array.isArray(arr)) {
    return arr.map(fn);
  }

  return Object.keys(arr).map(function (key) {
    return arr[key];
  }).map(fn);
});
exports.map = map;

var compose = function compose() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  if (!args.length) {
    return identity;
  }

  var fns = args.reverse(); // first function can receive multiply arguments

  var firstFn = fns[0];
  var tailsFn = fns.slice(1);
  return function () {
    return tailsFn.reduce(function (res, fn) {
      return fn(res);
    }, firstFn.apply(void 0, arguments));
  };
};

exports.compose = compose;

var reverse = function reverse(arr) {
  if (Array.isArray(arr)) {
    return arr.reverse();
  } // can be string


  return arr.split('').reverse.join('');
};

exports.reverse = reverse;

var memoize = function memoize(fn) {
  var lastArgs = null;
  var lastResult = null;
  return function () {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    if (lastArgs && args.every(function (val, i) {
      return val === lastArgs[i];
    })) {
      return lastResult;
    }

    lastArgs = args;
    lastResult = fn.apply(void 0, args);
    return lastResult;
  };
};

exports.memoize = memoize;

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__band__ = __webpack_require__(1609);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleBand", function() { return __WEBPACK_IMPORTED_MODULE_0__band__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scalePoint", function() { return __WEBPACK_IMPORTED_MODULE_0__band__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__identity__ = __webpack_require__(1632);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleIdentity", function() { return __WEBPACK_IMPORTED_MODULE_1__identity__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__(153);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleLinear", function() { return __WEBPACK_IMPORTED_MODULE_2__linear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__log__ = __webpack_require__(408);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleLog", function() { return __WEBPACK_IMPORTED_MODULE_3__log__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__symlog__ = __webpack_require__(409);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSymlog", function() { return __WEBPACK_IMPORTED_MODULE_4__symlog__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ordinal__ = __webpack_require__(752);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleOrdinal", function() { return __WEBPACK_IMPORTED_MODULE_5__ordinal__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleImplicit", function() { return __WEBPACK_IMPORTED_MODULE_5__ordinal__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pow__ = __webpack_require__(410);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scalePow", function() { return __WEBPACK_IMPORTED_MODULE_6__pow__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSqrt", function() { return __WEBPACK_IMPORTED_MODULE_6__pow__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__quantile__ = __webpack_require__(1660);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleQuantile", function() { return __WEBPACK_IMPORTED_MODULE_7__quantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__quantize__ = __webpack_require__(1661);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleQuantize", function() { return __WEBPACK_IMPORTED_MODULE_8__quantize__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__threshold__ = __webpack_require__(1662);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleThreshold", function() { return __WEBPACK_IMPORTED_MODULE_9__threshold__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__time__ = __webpack_require__(768);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleTime", function() { return __WEBPACK_IMPORTED_MODULE_10__time__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utcTime__ = __webpack_require__(1678);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleUtc", function() { return __WEBPACK_IMPORTED_MODULE_11__utcTime__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__sequential__ = __webpack_require__(772);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSequential", function() { return __WEBPACK_IMPORTED_MODULE_12__sequential__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSequentialLog", function() { return __WEBPACK_IMPORTED_MODULE_12__sequential__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSequentialPow", function() { return __WEBPACK_IMPORTED_MODULE_12__sequential__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSequentialSqrt", function() { return __WEBPACK_IMPORTED_MODULE_12__sequential__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSequentialSymlog", function() { return __WEBPACK_IMPORTED_MODULE_12__sequential__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__sequentialQuantile__ = __webpack_require__(1679);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSequentialQuantile", function() { return __WEBPACK_IMPORTED_MODULE_13__sequentialQuantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__diverging__ = __webpack_require__(1680);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleDiverging", function() { return __WEBPACK_IMPORTED_MODULE_14__diverging__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleDivergingLog", function() { return __WEBPACK_IMPORTED_MODULE_14__diverging__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleDivergingPow", function() { return __WEBPACK_IMPORTED_MODULE_14__diverging__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleDivergingSqrt", function() { return __WEBPACK_IMPORTED_MODULE_14__diverging__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleDivergingSymlog", function() { return __WEBPACK_IMPORTED_MODULE_14__diverging__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__tickFormat__ = __webpack_require__(762);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tickFormat", function() { return __WEBPACK_IMPORTED_MODULE_15__tickFormat__["a"]; });

































/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bisectRight */
/* unused harmony export bisectLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisector__ = __webpack_require__(741);



var ascendingBisect = Object(__WEBPACK_IMPORTED_MODULE_1__bisector__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]);
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;
/* harmony default export */ __webpack_exports__["a"] = (bisectRight);


/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(190);


/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  if (compare.length === 1) compare = ascendingComparator(compare);
  return {
    left: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      }
      return lo;
    },
    right: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;
        else lo = mid + 1;
      }
      return lo;
    }
  };
});

function ascendingComparator(f) {
  return function(d, x) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */])(f(d), x);
  };
}


/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pair;
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, f) {
  if (f == null) f = pair;
  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
  while (i < n) pairs[i] = f(p, p = array[++i]);
  return pairs;
});

function pair(a, b) {
  return [a, b];
}


/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__variance__ = __webpack_require__(744);


/* harmony default export */ __webpack_exports__["a"] = (function(array, f) {
  var v = Object(__WEBPACK_IMPORTED_MODULE_0__variance__["a" /* default */])(array, f);
  return v ? Math.sqrt(v) : v;
});


/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(224);


/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      m = 0,
      i = -1,
      mean = 0,
      value,
      delta,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  if (m > 1) return sum / (m - 1);
});


/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  return [min, max];
});


/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
var array = Array.prototype;

var slice = array.slice;
var map = array.map;


/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
});


/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = tickIncrement;
/* harmony export (immutable) */ __webpack_exports__["c"] = tickStep;
var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, count) {
  var reverse,
      i = -1,
      n,
      ticks,
      step;

  stop = +stop, start = +start, count = +count;
  if (start === stop && count > 0) return [start];
  if (reverse = stop < start) n = start, start = stop, stop = n;
  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    start = Math.ceil(start / step);
    stop = Math.floor(stop / step);
    ticks = new Array(n = Math.ceil(stop - start + 1));
    while (++i < n) ticks[i] = (start + i) * step;
  } else {
    start = Math.floor(start * step);
    stop = Math.ceil(stop * step);
    ticks = new Array(n = Math.ceil(start - stop + 1));
    while (++i < n) ticks[i] = (start - i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
});

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}


/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
});


/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  return min;
});


/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__min__ = __webpack_require__(750);


/* harmony default export */ __webpack_exports__["a"] = (function(matrix) {
  if (!(n = matrix.length)) return [];
  for (var i = -1, m = Object(__WEBPACK_IMPORTED_MODULE_0__min__["a" /* default */])(matrix, length), transpose = new Array(m); ++i < m;) {
    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
      row[j] = matrix[j][i];
    }
  }
  return transpose;
});

function length(d) {
  return d.length;
}


/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return implicit; });
/* harmony export (immutable) */ __webpack_exports__["a"] = ordinal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_collection__ = __webpack_require__(1626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__init__ = __webpack_require__(56);




var implicit = {name: "implicit"};

function ordinal() {
  var index = Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["a" /* map */])(),
      domain = [],
      range = [],
      unknown = implicit;

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["a" /* map */])();
    var i = -1, n = _.length, d, key;
    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal(domain, range).unknown(unknown);
  };

  __WEBPACK_IMPORTED_MODULE_2__init__["b" /* initRange */].apply(scale, arguments);

  return scale;
}


/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deg2rad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rad2deg; });
var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;


/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export rgbBasis */
/* unused harmony export rgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basisClosed__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__color__ = __webpack_require__(192);





/* harmony default export */ __webpack_exports__["a"] = ((function rgbGamma(y) {
  var color = Object(__WEBPACK_IMPORTED_MODULE_3__color__["b" /* gamma */])(y);

  function rgb(start, end) {
    var r = color((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(start)).r, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_3__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1));

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color;
    for (i = 0; i < n; ++i) {
      color = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function(t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}

var rgbBasis = rgbSpline(__WEBPACK_IMPORTED_MODULE_1__basis__["b" /* default */]);
var rgbBasisClosed = rgbSpline(__WEBPACK_IMPORTED_MODULE_2__basisClosed__["a" /* default */]);


/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(406);


/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return Object(__WEBPACK_IMPORTED_MODULE_0__basis__["a" /* basis */])((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(403);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = Object(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
});


/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var d = new Date;
  return a = +a, b -= a, function(t) {
    return d.setTime(a + b * t), d;
  };
});


/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(403);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = Object(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
});


/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(287);


var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
});


/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return +x;
});


/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(763);



/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, count, specifier) {
  var step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["g" /* tickStep */])(start, stop, count),
      precision;
  specifier = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["c" /* formatSpecifier */])(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["e" /* precisionPrefix */])(step, value))) specifier.precision = precision;
      return Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["b" /* formatPrefix */])(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["f" /* precisionRound */])(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["d" /* precisionFixed */])(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* format */])(specifier);
});


/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__ = __webpack_require__(1650);
/* unused harmony reexport formatDefaultLocale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale_js__ = __webpack_require__(764);
/* unused harmony reexport formatLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatSpecifier_js__ = __webpack_require__(765);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__formatSpecifier_js__["a"]; });
/* unused harmony reexport FormatSpecifier */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__precisionFixed_js__ = __webpack_require__(1657);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__precisionFixed_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__precisionPrefix_js__ = __webpack_require__(1658);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__precisionPrefix_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__precisionRound_js__ = __webpack_require__(1659);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__precisionRound_js__["a"]; });








/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent_js__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatGroup_js__ = __webpack_require__(1651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatNumerals_js__ = __webpack_require__(1652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__formatSpecifier_js__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__formatTrim_js__ = __webpack_require__(1653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__formatTypes_js__ = __webpack_require__(1654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__formatPrefixAuto_js__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__identity_js__ = __webpack_require__(1656);









var map = Array.prototype.map,
    prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

/* harmony default export */ __webpack_exports__["a"] = (function(locale) {
  var group = locale.grouping === undefined || locale.thousands === undefined ? __WEBPACK_IMPORTED_MODULE_7__identity_js__["a" /* default */] : Object(__WEBPACK_IMPORTED_MODULE_1__formatGroup_js__["a" /* default */])(map.call(locale.grouping, Number), locale.thousands + ""),
      currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "",
      currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "",
      decimal = locale.decimal === undefined ? "." : locale.decimal + "",
      numerals = locale.numerals === undefined ? __WEBPACK_IMPORTED_MODULE_7__identity_js__["a" /* default */] : Object(__WEBPACK_IMPORTED_MODULE_2__formatNumerals_js__["a" /* default */])(map.call(locale.numerals, String)),
      percent = locale.percent === undefined ? "%" : locale.percent + "",
      minus = locale.minus === undefined ? "-" : locale.minus + "",
      nan = locale.nan === undefined ? "NaN" : locale.nan + "";

  function newFormat(specifier) {
    specifier = Object(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier_js__["a" /* default */])(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        trim = specifier.trim,
        type = specifier.type;

    // The "n" type is an alias for ",g".
    if (type === "n") comma = true, type = "g";

    // The "" type, and any invalid type, is an alias for ".12~g".
    else if (!__WEBPACK_IMPORTED_MODULE_5__formatTypes_js__["a" /* default */][type]) precision === undefined && (precision = 12), trim = true, type = "g";

    // If zero fill is specified, padding goes after sign and before digits.
    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = __WEBPACK_IMPORTED_MODULE_5__formatTypes_js__["a" /* default */][type],
        maybeSuffix = /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision === undefined ? 6
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Perform the initial formatting.
        var valueNegative = value < 0;
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);

        // Trim insignificant zeros.
        if (trim) value = Object(__WEBPACK_IMPORTED_MODULE_4__formatTrim_js__["a" /* default */])(value);

        // If a negative value rounds to zero during formatting, treat as positive.
        if (valueNegative && +value === 0) valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : minus) : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;

        valueSuffix = (type === "s" ? prefixes[8 + __WEBPACK_IMPORTED_MODULE_6__formatPrefixAuto_js__["b" /* prefixExponent */] / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = Object(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier_js__["a" /* default */])(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a" /* default */])(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
});


/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatSpecifier;
/* unused harmony export FormatSpecifier */
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match;
  return new FormatSpecifier({
    fill: match[1],
    align: match[2],
    sign: match[3],
    symbol: match[4],
    zero: match[5],
    width: match[6],
    comma: match[7],
    precision: match[8] && match[8].slice(1),
    trim: match[9],
    type: match[10]
  });
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
  this.align = specifier.align === undefined ? ">" : specifier.align + "";
  this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === undefined ? undefined : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === undefined ? "" : specifier.type + "";
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width === undefined ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0))
      + (this.trim ? "~" : "")
      + this.type;
};


/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefixExponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__ = __webpack_require__(407);


var prefixExponent;

/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__["a" /* default */])(x, Math.max(0, p + i - 1))[0]; // less than 1y!
});


/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
});


/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calendar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_time__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time_format__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__array__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__continuous__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__init__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nice__ = __webpack_require__(767);








var durationSecond = 1000,
    durationMinute = durationSecond * 60,
    durationHour = durationMinute * 60,
    durationDay = durationHour * 24,
    durationWeek = durationDay * 7,
    durationMonth = durationDay * 30,
    durationYear = durationDay * 365;

function date(t) {
  return new Date(t);
}

function number(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_4__continuous__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_4__continuous__["c" /* identity */], __WEBPACK_IMPORTED_MODULE_4__continuous__["c" /* identity */]),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  var tickIntervals = [
    [second,  1,      durationSecond],
    [second,  5,  5 * durationSecond],
    [second, 15, 15 * durationSecond],
    [second, 30, 30 * durationSecond],
    [minute,  1,      durationMinute],
    [minute,  5,  5 * durationMinute],
    [minute, 15, 15 * durationMinute],
    [minute, 30, 30 * durationMinute],
    [  hour,  1,      durationHour  ],
    [  hour,  3,  3 * durationHour  ],
    [  hour,  6,  6 * durationHour  ],
    [  hour, 12, 12 * durationHour  ],
    [   day,  1,      durationDay   ],
    [   day,  2,  2 * durationDay   ],
    [  week,  1,      durationWeek  ],
    [ month,  1,      durationMonth ],
    [ month,  3,  3 * durationMonth ],
    [  year,  1,      durationYear  ]
  ];

  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond
        : minute(date) < date ? formatSecond
        : hour(date) < date ? formatMinute
        : day(date) < date ? formatHour
        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
        : year(date) < date ? formatMonth
        : formatYear)(date);
  }

  function tickInterval(interval, start, stop, step) {
    if (interval == null) interval = 10;

    // If a desired tick count is specified, pick a reasonable tick interval
    // based on the extent of the domain and a rough estimate of tick size.
    // Otherwise, assume interval is already a time interval and use it.
    if (typeof interval === "number") {
      var target = Math.abs(stop - start) / interval,
          i = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c" /* bisector */])(function(i) { return i[2]; }).right(tickIntervals, target);
      if (i === tickIntervals.length) {
        step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["g" /* tickStep */])(start / durationYear, stop / durationYear, interval);
        interval = year;
      } else if (i) {
        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        step = i[1];
        interval = i[0];
      } else {
        step = Math.max(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["g" /* tickStep */])(start, stop, interval), 1);
        interval = millisecond;
      }
    }

    return step == null ? interval : interval.every(step);
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(__WEBPACK_IMPORTED_MODULE_3__array__["a" /* map */].call(_, number)) : domain().map(date);
  };

  scale.ticks = function(interval, step) {
    var d = domain(),
        t0 = d[0],
        t1 = d[d.length - 1],
        r = t1 < t0,
        t;
    if (r) t = t0, t0 = t1, t1 = t;
    t = tickInterval(interval, t0, t1, step);
    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
    return r ? t.reverse() : t;
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval, step) {
    var d = domain();
    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
        ? domain(Object(__WEBPACK_IMPORTED_MODULE_6__nice__["a" /* default */])(d, interval))
        : scale;
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_4__continuous__["a" /* copy */])(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
  };

  return scale;
}

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return __WEBPACK_IMPORTED_MODULE_5__init__["b" /* initRange */].apply(calendar(__WEBPACK_IMPORTED_MODULE_1_d3_time__["k" /* timeYear */], __WEBPACK_IMPORTED_MODULE_1_d3_time__["f" /* timeMonth */], __WEBPACK_IMPORTED_MODULE_1_d3_time__["j" /* timeWeek */], __WEBPACK_IMPORTED_MODULE_1_d3_time__["a" /* timeDay */], __WEBPACK_IMPORTED_MODULE_1_d3_time__["b" /* timeHour */], __WEBPACK_IMPORTED_MODULE_1_d3_time__["d" /* timeMinute */], __WEBPACK_IMPORTED_MODULE_1_d3_time__["g" /* timeSecond */], __WEBPACK_IMPORTED_MODULE_1_d3_time__["c" /* timeMillisecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time_format__["a" /* timeFormat */]).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]), arguments);
});


/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__ = __webpack_require__(412);
/* unused harmony reexport timeFormatDefaultLocale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__["a"]; });
/* unused harmony reexport timeParse */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__["b"]; });
/* unused harmony reexport utcParse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale_js__ = __webpack_require__(770);
/* unused harmony reexport timeFormatLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isoFormat_js__ = __webpack_require__(771);
/* unused harmony reexport isoFormat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isoParse_js__ = __webpack_require__(1677);
/* unused harmony reexport isoParse */






/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_time__ = __webpack_require__(411);


function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newDate(y, m, d) {
  return {y: y, m: m, d: d, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "q": formatQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "q": formatUTCQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "q": parseQuarter,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, Z) {
    return function(string) {
      var d = newDate(1900, undefined, 1),
          i = parseSpecifier(d, specifier, string += "", 0),
          week, day;
      if (i != string.length) return null;

      // If a UNIX timestamp is specified, return it.
      if ("Q" in d) return new Date(d.Q);
      if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));

      // If this is utcParse, never use the local timezone.
      if (Z && !("Z" in d)) d.Z = 0;

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // If the month was not specified, inherit from the quarter.
      if (d.m === undefined) d.m = "q" in d ? d.q : 0;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcMonday */].ceil(week) : Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcMonday */])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* utcDay */].offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeMonday */].ceil(week) : Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeMonday */])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* timeDay */].offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return localDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatQuarter(d) {
    return 1 + ~~(d.getMonth() / 3);
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  function formatUTCQuarter(d) {
    return 1 + ~~(d.getUTCMonth() / 3);
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", false);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier += "", true);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"},
    numberRe = /^\s*\d+/, // note: ignores next directive
    percentRe = /^%/,
    requoteRe = /[\\^$*+?|[\]().{}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  var map = {}, i = -1, n = names.length;
  while (++i < n) map[names[i].toLowerCase()] = i;
  return map;
}

function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseQuarter(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}

function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.s = +n[0], i + n[0].length) : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* timeDay */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}

function formatWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["h" /* timeSunday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d) - 1, d), p, 2);
}

function formatWeekNumberISO(d, p) {
  var day = d.getDay();
  d = (day >= 4 || day === 0) ? Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* timeThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* timeThursday */].ceil(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* timeThursday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d), d) + (Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d).getDay() === 4), p, 2);
}

function formatWeekdayNumberSunday(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeMonday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d) - 1, d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad(z / 60 | 0, "0", 2)
      + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* utcDay */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["s" /* utcSunday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d) - 1, d), p, 2);
}

function formatUTCWeekNumberISO(d, p) {
  var day = d.getUTCDay();
  d = (day >= 4 || day === 0) ? Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["t" /* utcThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["t" /* utcThursday */].ceil(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["t" /* utcThursday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d), d) + (Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d).getUTCDay() === 4), p, 2);
}

function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcMonday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d) - 1, d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

function formatUnixTimestamp(d) {
  return +d;
}

function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1000);
}


/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isoSpecifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__ = __webpack_require__(412);


var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";

function formatIsoNative(date) {
  return date.toISOString();
}

var formatIso = Date.prototype.toISOString
    ? formatIsoNative
    : Object(__WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__["b" /* utcFormat */])(isoSpecifier);

/* unused harmony default export */ var _unused_webpack_default_export = (formatIso);


/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = copy;
/* harmony export (immutable) */ __webpack_exports__["b"] = sequential;
/* harmony export (immutable) */ __webpack_exports__["c"] = sequentialLog;
/* harmony export (immutable) */ __webpack_exports__["f"] = sequentialSymlog;
/* harmony export (immutable) */ __webpack_exports__["d"] = sequentialPow;
/* harmony export (immutable) */ __webpack_exports__["e"] = sequentialSqrt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__continuous__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__init__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__log__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__symlog__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pow__ = __webpack_require__(410);







function transformer() {
  var x0 = 0,
      x1 = 1,
      t0,
      t1,
      k10,
      transform,
      interpolator = __WEBPACK_IMPORTED_MODULE_0__continuous__["c" /* identity */],
      clamp = false,
      unknown;

  function scale(x) {
    return isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
  }

  scale.domain = function(_) {
    return arguments.length ? (t0 = transform(x0 = +_[0]), t1 = transform(x1 = +_[1]), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [x0, x1];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  return function(t) {
    transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
    return scale;
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .interpolator(source.interpolator())
      .clamp(source.clamp())
      .unknown(source.unknown());
}

function sequential() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_2__linear__["b" /* linearish */])(transformer()(__WEBPACK_IMPORTED_MODULE_0__continuous__["c" /* identity */]));

  scale.copy = function() {
    return copy(scale, sequential());
  };

  return __WEBPACK_IMPORTED_MODULE_1__init__["a" /* initInterpolator */].apply(scale, arguments);
}

function sequentialLog() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_3__log__["b" /* loggish */])(transformer()).domain([1, 10]);

  scale.copy = function() {
    return copy(scale, sequentialLog()).base(scale.base());
  };

  return __WEBPACK_IMPORTED_MODULE_1__init__["a" /* initInterpolator */].apply(scale, arguments);
}

function sequentialSymlog() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_4__symlog__["b" /* symlogish */])(transformer());

  scale.copy = function() {
    return copy(scale, sequentialSymlog()).constant(scale.constant());
  };

  return __WEBPACK_IMPORTED_MODULE_1__init__["a" /* initInterpolator */].apply(scale, arguments);
}

function sequentialPow() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_5__pow__["b" /* powish */])(transformer());

  scale.copy = function() {
    return copy(scale, sequentialPow()).exponent(scale.exponent());
  };

  return __WEBPACK_IMPORTED_MODULE_1__init__["a" /* initInterpolator */].apply(scale, arguments);
}

function sequentialSqrt() {
  return sequentialPow.apply(null, arguments).exponent(0.5);
}


/***/ }),
/* 773 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_DataUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__ = __webpack_require__(12);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Cross
 */






var Cross =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Cross, _PureComponent);

  function Cross() {
    _classCallCheck(this, Cross);

    return _possibleConstructorReturn(this, _getPrototypeOf(Cross).apply(this, arguments));
  }

  _createClass(Cross, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          x = _this$props.x,
          y = _this$props.y,
          width = _this$props.width,
          height = _this$props.height,
          top = _this$props.top,
          left = _this$props.left,
          className = _this$props.className;

      if (!Object(__WEBPACK_IMPORTED_MODULE_3__util_DataUtils__["h" /* isNumber */])(x) || !Object(__WEBPACK_IMPORTED_MODULE_3__util_DataUtils__["h" /* isNumber */])(y) || !Object(__WEBPACK_IMPORTED_MODULE_3__util_DataUtils__["h" /* isNumber */])(width) || !Object(__WEBPACK_IMPORTED_MODULE_3__util_DataUtils__["h" /* isNumber */])(height) || !Object(__WEBPACK_IMPORTED_MODULE_3__util_DataUtils__["h" /* isNumber */])(top) || !Object(__WEBPACK_IMPORTED_MODULE_3__util_DataUtils__["h" /* isNumber */])(left)) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", _extends({}, Object(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["l" /* getPresentationAttributes */])(this.props), {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('recharts-cross', className),
        d: this.constructor.getPath(x, y, width, height, top, left)
      }));
    }
  }], [{
    key: "getPath",
    value: function getPath(x, y, width, height, top, left) {
      return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
    }
  }]);

  return Cross;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Cross.displayName = 'Cross';
Cross.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  x: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  y: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
});
Cross.defaultProps = {
  x: 0,
  y: 0,
  top: 0,
  left: 0,
  width: 0,
  height: 0
};
/* harmony default export */ __webpack_exports__["a"] = (Cross);

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

var baseExtremum = __webpack_require__(286),
    baseGt = __webpack_require__(734),
    baseIteratee = __webpack_require__(67);

/**
 * This method is like `_.max` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.maxBy(objects, function(o) { return o.n; });
 * // => { 'n': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.maxBy(objects, 'n');
 * // => { 'n': 2 }
 */
function maxBy(array, iteratee) {
  return (array && array.length)
    ? baseExtremum(array, baseIteratee(iteratee, 2), baseGt)
    : undefined;
}

module.exports = maxBy;


/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isPlainObject__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isPlainObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isPlainObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isNil__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_smooth__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__container_Layer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shape_Sector__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shape_Curve__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__component_Text__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__component_Label__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__component_LabelList__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__component_Cell__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_ReactUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_PolarUtils__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__util_DataUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__util_ChartUtils__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__util_LogUtils__ = __webpack_require__(188);






function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Render sectors of a pie
 */

















var Pie =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Pie, _PureComponent);

  function Pie() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Pie);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Pie)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      isAnimationFinished: false
    };
    _this.id = Object(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["k" /* uniqueId */])('recharts-pie-');

    _this.cachePrevData = function (sectors) {
      _this.setState({
        prevSectors: sectors
      });
    };

    _this.handleAnimationEnd = function () {
      var onAnimationEnd = _this.props.onAnimationEnd;

      _this.setState({
        isAnimationFinished: true
      });

      if (__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(onAnimationEnd)) {
        onAnimationEnd();
      }
    };

    _this.handleAnimationStart = function () {
      var onAnimationStart = _this.props.onAnimationStart;

      _this.setState({
        isAnimationFinished: false
      });

      if (__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(onAnimationStart)) {
        onAnimationStart();
      }
    };

    return _this;
  }

  _createClass(Pie, [{
    key: "componentWillReceiveProps",
    // eslint-disable-next-line camelcase
    value: function componentWillReceiveProps(nextProps) {
      var _this$props = this.props,
          animationId = _this$props.animationId,
          sectors = _this$props.sectors;

      if (nextProps.isAnimationActive !== this.props.isAnimationActive) {
        this.cachePrevData([]);
      } else if (nextProps.animationId !== animationId) {
        this.cachePrevData(sectors);
      }
    }
  }, {
    key: "isActiveIndex",
    value: function isActiveIndex(i) {
      var activeIndex = this.props.activeIndex;

      if (Array.isArray(activeIndex)) {
        return activeIndex.indexOf(i) !== -1;
      }

      return i === activeIndex;
    }
  }, {
    key: "renderLabels",
    value: function renderLabels(sectors) {
      var _this2 = this;

      var isAnimationActive = this.props.isAnimationActive;

      if (isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }

      var _this$props2 = this.props,
          label = _this$props2.label,
          labelLine = _this$props2.labelLine,
          dataKey = _this$props2.dataKey,
          valueKey = _this$props2.valueKey;
      var pieProps = Object(__WEBPACK_IMPORTED_MODULE_16__util_ReactUtils__["l" /* getPresentationAttributes */])(this.props);
      var customLabelProps = Object(__WEBPACK_IMPORTED_MODULE_16__util_ReactUtils__["l" /* getPresentationAttributes */])(label);
      var customLabelLineProps = Object(__WEBPACK_IMPORTED_MODULE_16__util_ReactUtils__["l" /* getPresentationAttributes */])(labelLine);
      var offsetRadius = label && label.offsetRadius || 20;
      var labels = sectors.map(function (entry, i) {
        var midAngle = (entry.startAngle + entry.endAngle) / 2;
        var endPoint = Object(__WEBPACK_IMPORTED_MODULE_17__util_PolarUtils__["e" /* polarToCartesian */])(entry.cx, entry.cy, entry.outerRadius + offsetRadius, midAngle);

        var labelProps = _objectSpread({}, pieProps, {}, entry, {
          stroke: 'none'
        }, customLabelProps, {
          index: i,
          textAnchor: _this2.constructor.getTextAnchor(endPoint.x, entry.cx)
        }, endPoint);

        var lineProps = _objectSpread({}, pieProps, {}, entry, {
          fill: 'none',
          stroke: entry.fill
        }, customLabelLineProps, {
          index: i,
          points: [Object(__WEBPACK_IMPORTED_MODULE_17__util_PolarUtils__["e" /* polarToCartesian */])(entry.cx, entry.cy, entry.outerRadius, midAngle), endPoint],
          key: 'line'
        });

        var realDataKey = dataKey; // TODO: compatible to lower versions

        if (__WEBPACK_IMPORTED_MODULE_4_lodash_isNil___default()(dataKey) && __WEBPACK_IMPORTED_MODULE_4_lodash_isNil___default()(valueKey)) {
          realDataKey = 'value';
        } else if (__WEBPACK_IMPORTED_MODULE_4_lodash_isNil___default()(dataKey)) {
          realDataKey = valueKey;
        }

        return (// eslint-disable-next-line react/no-array-index-key
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */], {
            key: "label-".concat(i)
          }, labelLine && _this2.constructor.renderLabelLineItem(labelLine, lineProps), _this2.constructor.renderLabelItem(label, labelProps, Object(__WEBPACK_IMPORTED_MODULE_19__util_ChartUtils__["v" /* getValueByDataKey */])(entry, realDataKey)))
        );
      });
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */], {
        className: "recharts-pie-labels"
      }, labels);
    }
  }, {
    key: "renderSectorsStatically",
    value: function renderSectorsStatically(sectors) {
      var _this3 = this;

      var _this$props3 = this.props,
          activeShape = _this$props3.activeShape,
          blendStroke = _this$props3.blendStroke;
      return sectors.map(function (entry, i) {
        var sectorOptions = _this3.isActiveIndex(i) ? activeShape : null;

        var sectorProps = _objectSpread({}, entry, {
          stroke: blendStroke ? entry.fill : entry.stroke
        });

        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */], _extends({
          className: "recharts-pie-sector"
        }, Object(__WEBPACK_IMPORTED_MODULE_16__util_ReactUtils__["g" /* filterEventsOfChild */])(_this3.props, entry, i), {
          key: "sector-".concat(i) // eslint-disable-line react/no-array-index-key

        }), _this3.constructor.renderSectorItem(sectorOptions, sectorProps));
      });
    }
  }, {
    key: "renderSectorsWithAnimation",
    value: function renderSectorsWithAnimation() {
      var _this4 = this;

      var _this$props4 = this.props,
          sectors = _this$props4.sectors,
          isAnimationActive = _this$props4.isAnimationActive,
          animationBegin = _this$props4.animationBegin,
          animationDuration = _this$props4.animationDuration,
          animationEasing = _this$props4.animationEasing,
          animationId = _this$props4.animationId;
      var prevSectors = this.state.prevSectors;
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_smooth__["a" /* default */], {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "pie-".concat(animationId),
        onAnimationStart: this.handleAnimationStart,
        onAnimationEnd: this.handleAnimationEnd
      }, function (_ref) {
        var t = _ref.t;
        var stepData = [];
        var first = sectors && sectors[0];
        var curAngle = first.startAngle;
        sectors.forEach(function (entry, index) {
          var prev = prevSectors && prevSectors[index];
          var paddingAngle = index > 0 ? __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(entry, 'paddingAngle', 0) : 0;

          if (prev) {
            var angleIp = Object(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["f" /* interpolateNumber */])(prev.endAngle - prev.startAngle, entry.endAngle - entry.startAngle);

            var latest = _objectSpread({}, entry, {
              startAngle: curAngle + paddingAngle,
              endAngle: curAngle + angleIp(t) + paddingAngle
            });

            stepData.push(latest);
            curAngle = latest.endAngle;
          } else {
            var endAngle = entry.endAngle,
                startAngle = entry.startAngle;
            var interpolatorAngle = Object(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["f" /* interpolateNumber */])(0, endAngle - startAngle);
            var deltaAngle = interpolatorAngle(t);

            var _latest = _objectSpread({}, entry, {
              startAngle: curAngle + paddingAngle,
              endAngle: curAngle + deltaAngle + paddingAngle
            });

            stepData.push(_latest);
            curAngle = _latest.endAngle;
          }
        });
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */], null, _this4.renderSectorsStatically(stepData));
      });
    }
  }, {
    key: "renderSectors",
    value: function renderSectors() {
      var _this$props5 = this.props,
          sectors = _this$props5.sectors,
          isAnimationActive = _this$props5.isAnimationActive;
      var prevSectors = this.state.prevSectors;

      if (isAnimationActive && sectors && sectors.length && (!prevSectors || !__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevSectors, sectors))) {
        return this.renderSectorsWithAnimation();
      }

      return this.renderSectorsStatically(sectors);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          hide = _this$props6.hide,
          sectors = _this$props6.sectors,
          className = _this$props6.className,
          label = _this$props6.label,
          cx = _this$props6.cx,
          cy = _this$props6.cy,
          innerRadius = _this$props6.innerRadius,
          outerRadius = _this$props6.outerRadius,
          isAnimationActive = _this$props6.isAnimationActive,
          prevSectors = _this$props6.prevSectors;

      if (hide || !sectors || !sectors.length || !Object(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["h" /* isNumber */])(cx) || !Object(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["h" /* isNumber */])(cy) || !Object(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["h" /* isNumber */])(innerRadius) || !Object(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["h" /* isNumber */])(outerRadius)) {
        return null;
      }

      var layerClass = __WEBPACK_IMPORTED_MODULE_8_classnames___default()('recharts-pie', className);
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */], {
        className: layerClass
      }, this.renderSectors(), label && this.renderLabels(sectors), __WEBPACK_IMPORTED_MODULE_13__component_Label__["a" /* default */].renderCallByParent(this.props, null, false), (!isAnimationActive || prevSectors && __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevSectors, sectors)) && __WEBPACK_IMPORTED_MODULE_14__component_LabelList__["a" /* default */].renderCallByParent(this.props, sectors, false));
    }
  }], [{
    key: "getTextAnchor",
    value: function getTextAnchor(x, cx) {
      if (x > cx) {
        return 'start';
      }

      if (x < cx) {
        return 'end';
      }

      return 'middle';
    }
  }, {
    key: "renderLabelLineItem",
    value: function renderLabelLineItem(option, props) {
      if (__WEBPACK_IMPORTED_MODULE_5_react___default.a.isValidElement(option)) {
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(option, props);
      }

      if (__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(option)) {
        return option(props);
      }

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shape_Curve__["a" /* default */], _extends({}, props, {
        type: "linear",
        className: "recharts-pie-label-line"
      }));
    }
  }, {
    key: "renderLabelItem",
    value: function renderLabelItem(option, props, value) {
      if (__WEBPACK_IMPORTED_MODULE_5_react___default.a.isValidElement(option)) {
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(option, props);
      }

      var label = value;

      if (__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(option)) {
        label = option(props);

        if (__WEBPACK_IMPORTED_MODULE_5_react___default.a.isValidElement(label)) {
          return label;
        }
      }

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__component_Text__["a" /* default */], _extends({}, props, {
        alignmentBaseline: "middle",
        className: "recharts-pie-label-text"
      }), label);
    }
  }, {
    key: "renderSectorItem",
    value: function renderSectorItem(option, props) {
      if (__WEBPACK_IMPORTED_MODULE_5_react___default.a.isValidElement(option)) {
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(option, props);
      }

      if (__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(option)) {
        return option(props);
      }

      if (__WEBPACK_IMPORTED_MODULE_2_lodash_isPlainObject___default()(option)) {
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shape_Sector__["a" /* default */], _extends({}, props, option));
      }

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shape_Sector__["a" /* default */], props);
    }
  }]);

  return Pie;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

Pie.displayName = 'Pie';
Pie.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_16__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {}, __WEBPACK_IMPORTED_MODULE_16__util_ReactUtils__["a" /* EVENT_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  animationId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  cx: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  cy: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  startAngle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  endAngle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  paddingAngle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  innerRadius: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  outerRadius: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  cornerRadius: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  dataKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]).isRequired,
  nameKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]),
  valueKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]),
  data: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object),
  blendStroke: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  minAngle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  legendType: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_16__util_ReactUtils__["b" /* LEGEND_TYPES */]),
  tooltipType: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_16__util_ReactUtils__["e" /* TOOLTIP_TYPES */]),
  maxRadius: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  sectors: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object),
  hide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  labelLine: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool]),
  label: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    offsetRadius: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number
  }), __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool]),
  activeShape: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.element]),
  activeIndex: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number)]),
  onAnimationStart: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onAnimationEnd: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  isAnimationActive: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  animationBegin: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'spring', 'linear']),
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
});
Pie.defaultProps = {
  stroke: '#fff',
  fill: '#808080',
  legendType: 'rect',
  // The abscissa of pole
  cx: '50%',
  // The ordinate of pole
  cy: '50%',
  // The start angle of first sector
  startAngle: 0,
  // The direction of drawing sectors
  endAngle: 360,
  // The inner radius of sectors
  innerRadius: 0,
  // The outer radius of sectors
  outerRadius: '80%',
  paddingAngle: 0,
  labelLine: true,
  hide: false,
  minAngle: 0,
  isAnimationActive: !Object(__WEBPACK_IMPORTED_MODULE_16__util_ReactUtils__["o" /* isSsr */])(),
  animationBegin: 400,
  animationDuration: 1500,
  animationEasing: 'ease',
  nameKey: 'name',
  // Match each sector's stroke color to it's fill color
  blendStroke: false
};

Pie.parseDeltaAngle = function (_ref2) {
  var startAngle = _ref2.startAngle,
      endAngle = _ref2.endAngle;
  var sign = Object(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["j" /* mathSign */])(endAngle - startAngle);
  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
  return sign * deltaAngle;
};

Pie.getRealPieData = function (item) {
  var _item$props = item.props,
      data = _item$props.data,
      children = _item$props.children;
  var presentationProps = Object(__WEBPACK_IMPORTED_MODULE_16__util_ReactUtils__["l" /* getPresentationAttributes */])(item.props);
  var cells = Object(__WEBPACK_IMPORTED_MODULE_16__util_ReactUtils__["i" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_15__component_Cell__["a" /* default */]);

  if (data && data.length) {
    return data.map(function (entry, index) {
      return _objectSpread({
        payload: entry
      }, presentationProps, {}, entry, {}, cells && cells[index] && cells[index].props);
    });
  }

  if (cells && cells.length) {
    return cells.map(function (cell) {
      return _objectSpread({}, presentationProps, {}, cell.props);
    });
  }

  return [];
};

Pie.parseCoordinateOfPie = function (item, offset) {
  var top = offset.top,
      left = offset.left,
      width = offset.width,
      height = offset.height;
  var maxPieRadius = Object(__WEBPACK_IMPORTED_MODULE_17__util_PolarUtils__["c" /* getMaxRadius */])(width, height);
  var cx = left + Object(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["d" /* getPercentValue */])(item.props.cx, width, width / 2);
  var cy = top + Object(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["d" /* getPercentValue */])(item.props.cy, height, height / 2);
  var innerRadius = Object(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["d" /* getPercentValue */])(item.props.innerRadius, maxPieRadius, 0);
  var outerRadius = Object(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["d" /* getPercentValue */])(item.props.outerRadius, maxPieRadius, maxPieRadius * 0.8);
  var maxRadius = item.props.maxRadius || Math.sqrt(width * width + height * height) / 2;
  return {
    cx: cx,
    cy: cy,
    innerRadius: innerRadius,
    outerRadius: outerRadius,
    maxRadius: maxRadius
  };
};

Pie.getComposedData = function (_ref3) {
  var item = _ref3.item,
      offset = _ref3.offset,
      onItemMouseLeave = _ref3.onItemMouseLeave,
      onItemMouseEnter = _ref3.onItemMouseEnter;
  var pieData = Pie.getRealPieData(item);

  if (!pieData || !pieData.length) {
    return [];
  }

  var _item$props2 = item.props,
      cornerRadius = _item$props2.cornerRadius,
      startAngle = _item$props2.startAngle,
      endAngle = _item$props2.endAngle,
      paddingAngle = _item$props2.paddingAngle,
      dataKey = _item$props2.dataKey,
      nameKey = _item$props2.nameKey,
      valueKey = _item$props2.valueKey,
      tooltipType = _item$props2.tooltipType;
  var minAngle = Math.abs(item.props.minAngle);
  var coordinate = Pie.parseCoordinateOfPie(item, offset);
  var len = pieData.length;
  var deltaAngle = Pie.parseDeltaAngle({
    startAngle: startAngle,
    endAngle: endAngle
  });
  var absDeltaAngle = Math.abs(deltaAngle);
  var totalPadingAngle = (absDeltaAngle >= 360 ? len : len - 1) * paddingAngle;
  var realTotalAngle = absDeltaAngle - len * minAngle - totalPadingAngle;
  var realDataKey = dataKey;

  if (__WEBPACK_IMPORTED_MODULE_4_lodash_isNil___default()(dataKey) && __WEBPACK_IMPORTED_MODULE_4_lodash_isNil___default()(valueKey)) {
    Object(__WEBPACK_IMPORTED_MODULE_20__util_LogUtils__["a" /* warn */])(false, "Use \"dataKey\" to specify the value of pie,\n      the props \"valueKey\" will be deprecated in 1.1.0");
    realDataKey = 'value';
  } else if (__WEBPACK_IMPORTED_MODULE_4_lodash_isNil___default()(dataKey)) {
    Object(__WEBPACK_IMPORTED_MODULE_20__util_LogUtils__["a" /* warn */])(false, "Use \"dataKey\" to specify the value of pie,\n      the props \"valueKey\" will be deprecated in 1.1.0");
    realDataKey = valueKey;
  }

  var sum = pieData.reduce(function (result, entry) {
    var val = Object(__WEBPACK_IMPORTED_MODULE_19__util_ChartUtils__["v" /* getValueByDataKey */])(entry, realDataKey, 0);
    return result + (Object(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["h" /* isNumber */])(val) ? val : 0);
  }, 0);
  var sectors;

  if (sum > 0) {
    var prev;
    sectors = pieData.map(function (entry, i) {
      var val = Object(__WEBPACK_IMPORTED_MODULE_19__util_ChartUtils__["v" /* getValueByDataKey */])(entry, realDataKey, 0);
      var name = Object(__WEBPACK_IMPORTED_MODULE_19__util_ChartUtils__["v" /* getValueByDataKey */])(entry, nameKey, i);
      var percent = (Object(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["h" /* isNumber */])(val) ? val : 0) / sum;
      var tempStartAngle;

      if (i) {
        tempStartAngle = prev.endAngle + Object(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["j" /* mathSign */])(deltaAngle) * paddingAngle;
      } else {
        tempStartAngle = startAngle;
      }

      var tempEndAngle = tempStartAngle + Object(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["j" /* mathSign */])(deltaAngle) * (minAngle + percent * realTotalAngle);
      var midAngle = (tempStartAngle + tempEndAngle) / 2;
      var middleRadius = (coordinate.innerRadius + coordinate.outerRadius) / 2;
      var tooltipPayload = [{
        name: name,
        value: val,
        payload: entry,
        dataKey: realDataKey,
        type: tooltipType
      }];
      var tooltipPosition = Object(__WEBPACK_IMPORTED_MODULE_17__util_PolarUtils__["e" /* polarToCartesian */])(coordinate.cx, coordinate.cy, middleRadius, midAngle);
      prev = _objectSpread({
        percent: percent,
        cornerRadius: cornerRadius,
        name: name,
        tooltipPayload: tooltipPayload,
        midAngle: midAngle,
        middleRadius: middleRadius,
        tooltipPosition: tooltipPosition
      }, entry, {}, coordinate, {
        value: Object(__WEBPACK_IMPORTED_MODULE_19__util_ChartUtils__["v" /* getValueByDataKey */])(entry, realDataKey),
        startAngle: tempStartAngle,
        endAngle: tempEndAngle,
        payload: entry,
        paddingAngle: Object(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["j" /* mathSign */])(deltaAngle) * paddingAngle
      });
      return prev;
    });
  }

  return _objectSpread({}, coordinate, {
    sectors: sectors,
    data: pieData,
    onMouseLeave: onItemMouseLeave,
    onMouseEnter: onItemMouseEnter
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Pie);

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_smooth__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_DataUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_PolarUtils__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_ChartUtils__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shape_Polygon__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shape_Dot__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__container_Layer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__component_LabelList__ = __webpack_require__(104);



function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Radar
 */













var Radar =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Radar, _PureComponent);

  function Radar() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Radar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Radar)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      isAnimationFinished: false
    };

    _this.cachePrevData = function (points) {
      _this.setState({
        prevPoints: points
      });
    };

    _this.handleAnimationEnd = function () {
      var onAnimationEnd = _this.props.onAnimationEnd;

      _this.setState({
        isAnimationFinished: true
      });

      if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(onAnimationEnd)) {
        onAnimationEnd();
      }
    };

    _this.handleAnimationStart = function () {
      var onAnimationStart = _this.props.onAnimationStart;

      _this.setState({
        isAnimationFinished: false
      });

      if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(onAnimationStart)) {
        onAnimationStart();
      }
    };

    _this.handleMouseEnter = function (e) {
      var onMouseEnter = _this.props.onMouseEnter;

      if (onMouseEnter) {
        onMouseEnter(_this.props, e);
      }
    };

    _this.handleMouseLeave = function (e) {
      var onMouseLeave = _this.props.onMouseLeave;

      if (onMouseLeave) {
        onMouseLeave(_this.props, e);
      }
    };

    return _this;
  }

  _createClass(Radar, [{
    key: "componentWillReceiveProps",
    // eslint-disable-next-line camelcase
    value: function componentWillReceiveProps(nextProps) {
      var _this$props = this.props,
          animationId = _this$props.animationId,
          points = _this$props.points;

      if (nextProps.animationId !== animationId) {
        this.cachePrevData(points);
      }
    }
  }, {
    key: "renderDots",
    value: function renderDots(points) {
      var _this2 = this;

      var _this$props2 = this.props,
          dot = _this$props2.dot,
          dataKey = _this$props2.dataKey;
      var baseProps = Object(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["l" /* getPresentationAttributes */])(this.props);
      var customDotProps = Object(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["l" /* getPresentationAttributes */])(dot);
      var dots = points.map(function (entry, i) {
        var dotProps = _objectSpread({
          key: "dot-".concat(i),
          r: 3
        }, baseProps, {}, customDotProps, {
          dataKey: dataKey,
          cx: entry.x,
          cy: entry.y,
          index: i,
          payload: entry
        });

        return _this2.constructor.renderDotItem(dot, dotProps);
      });
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__container_Layer__["a" /* default */], {
        className: "recharts-radar-dots"
      }, dots);
    }
  }, {
    key: "renderPolygonStatically",
    value: function renderPolygonStatically(points) {
      var _this$props3 = this.props,
          shape = _this$props3.shape,
          dot = _this$props3.dot;
      var radar;

      if (__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(shape)) {
        radar = __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(shape, _objectSpread({}, this.props, {
          points: points
        }));
      } else if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(shape)) {
        radar = shape(_objectSpread({}, this.props, {
          points: points
        }));
      } else {
        radar = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shape_Polygon__["a" /* default */], _extends({}, Object(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["f" /* filterEventAttributes */])(this.props), {
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave
        }, Object(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["l" /* getPresentationAttributes */])(this.props), {
          points: points
        }));
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__container_Layer__["a" /* default */], {
        className: "recharts-radar-polygon"
      }, radar, dot ? this.renderDots(points) : null);
    }
  }, {
    key: "renderPolygonWithAnimation",
    value: function renderPolygonWithAnimation() {
      var _this3 = this;

      var _this$props4 = this.props,
          points = _this$props4.points,
          isAnimationActive = _this$props4.isAnimationActive,
          animationBegin = _this$props4.animationBegin,
          animationDuration = _this$props4.animationDuration,
          animationEasing = _this$props4.animationEasing,
          animationId = _this$props4.animationId;
      var prevPoints = this.state.prevPoints;
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_smooth__["a" /* default */], {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "radar-".concat(animationId),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function (_ref) {
        var t = _ref.t;
        var prevPointsDiffFactor = prevPoints && prevPoints.length / points.length;
        var stepData = points.map(function (entry, index) {
          var prev = prevPoints && prevPoints[Math.floor(index * prevPointsDiffFactor)];

          if (prev) {
            var _interpolatorX = Object(__WEBPACK_IMPORTED_MODULE_6__util_DataUtils__["f" /* interpolateNumber */])(prev.x, entry.x);

            var _interpolatorY = Object(__WEBPACK_IMPORTED_MODULE_6__util_DataUtils__["f" /* interpolateNumber */])(prev.y, entry.y);

            return _objectSpread({}, entry, {
              x: _interpolatorX(t),
              y: _interpolatorY(t)
            });
          }

          var interpolatorX = Object(__WEBPACK_IMPORTED_MODULE_6__util_DataUtils__["f" /* interpolateNumber */])(entry.cx, entry.x);
          var interpolatorY = Object(__WEBPACK_IMPORTED_MODULE_6__util_DataUtils__["f" /* interpolateNumber */])(entry.cy, entry.y);
          return _objectSpread({}, entry, {
            x: interpolatorX(t),
            y: interpolatorY(t)
          });
        });
        return _this3.renderPolygonStatically(stepData);
      });
    }
  }, {
    key: "renderPolygon",
    value: function renderPolygon() {
      var _this$props5 = this.props,
          points = _this$props5.points,
          isAnimationActive = _this$props5.isAnimationActive;
      var prevPoints = this.state.prevPoints;

      if (isAnimationActive && points && points.length && (!prevPoints || !__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevPoints, points))) {
        return this.renderPolygonWithAnimation();
      }

      return this.renderPolygonStatically(points);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          hide = _this$props6.hide,
          className = _this$props6.className,
          points = _this$props6.points,
          isAnimationActive = _this$props6.isAnimationActive;

      if (hide || !points || !points.length) {
        return null;
      }

      var isAnimationFinished = this.state.isAnimationFinished;
      var layerClass = __WEBPACK_IMPORTED_MODULE_5_classnames___default()('recharts-radar', className);
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__container_Layer__["a" /* default */], {
        className: layerClass
      }, this.renderPolygon(), (!isAnimationActive || isAnimationFinished) && __WEBPACK_IMPORTED_MODULE_13__component_LabelList__["a" /* default */].renderCallByParent(this.props, points));
    }
  }], [{
    key: "renderDotItem",
    value: function renderDotItem(option, props) {
      var dotItem;

      if (__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(option)) {
        dotItem = __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(option)) {
        dotItem = option(props);
      } else {
        dotItem = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shape_Dot__["a" /* default */], _extends({}, props, {
          className: "recharts-radar-dot"
        }));
      }

      return dotItem;
    }
  }]);

  return Radar;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);

Radar.displayName = 'Radar';
Radar.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  dataKey: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func]).isRequired,
  angleAxisId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]),
  radiusAxisId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]),
  points: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    cx: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    cy: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    angle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    radius: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    value: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    payload: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })),
  shape: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func]),
  activeDot: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool]),
  // whether have dot in poly line
  dot: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool]),
  label: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool]),
  legendType: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["b" /* LEGEND_TYPES */]),
  tooltipType: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["e" /* TOOLTIP_TYPES */]),
  hide: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  onAnimationStart: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onAnimationEnd: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  isAnimationActive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  animationId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  animationBegin: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
});
Radar.defaultProps = {
  angleAxisId: 0,
  radiusAxisId: 0,
  hide: false,
  activeDot: true,
  dot: false,
  legendType: 'rect',
  isAnimationActive: !Object(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["o" /* isSsr */])(),
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease'
};

Radar.getComposedData = function (_ref2) {
  var radiusAxis = _ref2.radiusAxis,
      angleAxis = _ref2.angleAxis,
      displayedData = _ref2.displayedData,
      dataKey = _ref2.dataKey,
      bandSize = _ref2.bandSize;
  var cx = angleAxis.cx,
      cy = angleAxis.cy;
  var points = displayedData.map(function (entry, i) {
    var name = Object(__WEBPACK_IMPORTED_MODULE_9__util_ChartUtils__["v" /* getValueByDataKey */])(entry, angleAxis.dataKey, i);
    var value = Object(__WEBPACK_IMPORTED_MODULE_9__util_ChartUtils__["v" /* getValueByDataKey */])(entry, dataKey, 0);
    var angle = angleAxis.scale(name) + (bandSize || 0);
    var radius = radiusAxis.scale(value);
    return _objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_8__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, radius, angle), {
      name: name,
      value: value,
      cx: cx,
      cy: cy,
      radius: radius,
      angle: angle,
      payload: entry
    });
  });
  return {
    points: points
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Radar);

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isArray__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_smooth__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shape_Sector__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__container_Layer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__component_LabelList__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__component_Cell__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_DataUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_ChartUtils__ = __webpack_require__(51);




function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Render a group of radial bar
 */












var RadialBar =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(RadialBar, _PureComponent);

  function RadialBar() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, RadialBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(RadialBar)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      isAnimationFinished: false
    };

    _this.cachePrevData = function (data) {
      _this.setState({
        prevData: data
      });
    };

    _this.handleAnimationEnd = function () {
      var onAnimationEnd = _this.props.onAnimationEnd;

      _this.setState({
        isAnimationFinished: true
      });

      if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(onAnimationEnd)) {
        onAnimationEnd();
      }
    };

    _this.handleAnimationStart = function () {
      var onAnimationStart = _this.props.onAnimationStart;

      _this.setState({
        isAnimationFinished: false
      });

      if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(onAnimationStart)) {
        onAnimationStart();
      }
    };

    return _this;
  }

  _createClass(RadialBar, [{
    key: "componentWillReceiveProps",
    // eslint-disable-next-line camelcase
    value: function componentWillReceiveProps(nextProps) {
      var _this$props = this.props,
          animationId = _this$props.animationId,
          data = _this$props.data;

      if (nextProps.animationId !== animationId) {
        this.cachePrevData(data);
      }
    }
  }, {
    key: "getDeltaAngle",
    value: function getDeltaAngle() {
      var _this$props2 = this.props,
          startAngle = _this$props2.startAngle,
          endAngle = _this$props2.endAngle;
      var sign = Object(__WEBPACK_IMPORTED_MODULE_12__util_DataUtils__["j" /* mathSign */])(endAngle - startAngle);
      var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
      return sign * deltaAngle;
    }
  }, {
    key: "renderSectorsStatically",
    value: function renderSectorsStatically(sectors) {
      var _this2 = this;

      var _this$props3 = this.props,
          shape = _this$props3.shape,
          activeShape = _this$props3.activeShape,
          activeIndex = _this$props3.activeIndex,
          cornerRadius = _this$props3.cornerRadius,
          others = _objectWithoutProperties(_this$props3, ["shape", "activeShape", "activeIndex", "cornerRadius"]);

      var baseProps = Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["l" /* getPresentationAttributes */])(others);
      return sectors.map(function (entry, i) {
        var props = _objectSpread({}, baseProps, {
          cornerRadius: cornerRadius
        }, entry, {}, Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["g" /* filterEventsOfChild */])(_this2.props, entry, i), {
          key: "sector-".concat(i),
          className: 'recharts-radial-bar-sector',
          forceCornerRadius: others.forceCornerRadius,
          cornerIsExternal: others.cornerIsExternal
        });

        return _this2.constructor.renderSectorShape(i === activeIndex ? activeShape : shape, props);
      });
    }
  }, {
    key: "renderSectorsWithAnimation",
    value: function renderSectorsWithAnimation() {
      var _this3 = this;

      var _this$props4 = this.props,
          data = _this$props4.data,
          isAnimationActive = _this$props4.isAnimationActive,
          animationBegin = _this$props4.animationBegin,
          animationDuration = _this$props4.animationDuration,
          animationEasing = _this$props4.animationEasing,
          animationId = _this$props4.animationId;
      var prevData = this.state.prevData;
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_smooth__["a" /* default */], {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "radialBar-".concat(animationId),
        onAnimationStart: this.handleAnimationStart,
        onAnimationEnd: this.handleAnimationEnd
      }, function (_ref) {
        var t = _ref.t;
        var stepData = data.map(function (entry, index) {
          var prev = prevData && prevData[index];

          if (prev) {
            var interpolatorStartAngle = Object(__WEBPACK_IMPORTED_MODULE_12__util_DataUtils__["f" /* interpolateNumber */])(prev.startAngle, entry.startAngle);
            var interpolatorEndAngle = Object(__WEBPACK_IMPORTED_MODULE_12__util_DataUtils__["f" /* interpolateNumber */])(prev.endAngle, entry.endAngle);
            return _objectSpread({}, entry, {
              startAngle: interpolatorStartAngle(t),
              endAngle: interpolatorEndAngle(t)
            });
          }

          var endAngle = entry.endAngle,
              startAngle = entry.startAngle;
          var interpolator = Object(__WEBPACK_IMPORTED_MODULE_12__util_DataUtils__["f" /* interpolateNumber */])(startAngle, endAngle);
          return _objectSpread({}, entry, {
            endAngle: interpolator(t)
          });
        });
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */], null, _this3.renderSectorsStatically(stepData));
      });
    }
  }, {
    key: "renderSectors",
    value: function renderSectors() {
      var _this$props5 = this.props,
          data = _this$props5.data,
          isAnimationActive = _this$props5.isAnimationActive;
      var prevData = this.state.prevData;

      if (isAnimationActive && data && data.length && (!prevData || !__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevData, data))) {
        return this.renderSectorsWithAnimation();
      }

      return this.renderSectorsStatically(data);
    }
  }, {
    key: "renderBackground",
    value: function renderBackground(sectors) {
      var _this4 = this;

      var cornerRadius = this.props.cornerRadius;
      var backgroundProps = Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["l" /* getPresentationAttributes */])(this.props.background);
      return sectors.map(function (entry, i) {
        // eslint-disable-next-line no-unused-vars
        var value = entry.value,
            background = entry.background,
            rest = _objectWithoutProperties(entry, ["value", "background"]);

        if (!background) {
          return null;
        }

        var props = _objectSpread({
          cornerRadius: cornerRadius
        }, rest, {
          fill: '#eee'
        }, background, {}, backgroundProps, {}, Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["g" /* filterEventsOfChild */])(_this4.props, entry, i), {
          index: i,
          key: "sector-".concat(i),
          className: 'recharts-radial-bar-background-sector'
        });

        return _this4.constructor.renderSectorShape(background, props);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          hide = _this$props6.hide,
          data = _this$props6.data,
          className = _this$props6.className,
          background = _this$props6.background,
          isAnimationActive = _this$props6.isAnimationActive;

      if (hide || !data || !data.length) {
        return null;
      }

      var isAnimationFinished = this.state.isAnimationFinished;
      var layerClass = __WEBPACK_IMPORTED_MODULE_5_classnames___default()('recharts-area', className);
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */], {
        className: layerClass
      }, background && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */], {
        className: "recharts-radial-bar-background"
      }, this.renderBackground(data)), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */], {
        className: "recharts-radial-bar-sectors"
      }, this.renderSectors(data)), (!isAnimationActive || isAnimationFinished) && __WEBPACK_IMPORTED_MODULE_10__component_LabelList__["a" /* default */].renderCallByParent(_objectSpread({}, this.props, {
        clockWise: this.getDeltaAngle() < 0
      }), data));
    }
  }], [{
    key: "renderSectorShape",
    value: function renderSectorShape(shape, props) {
      var sectorShape;

      if (__WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(shape)) {
        sectorShape = __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(shape, props);
      } else if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(shape)) {
        sectorShape = shape(props);
      } else {
        sectorShape = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shape_Sector__["a" /* default */], props);
      }

      return sectorShape;
    }
  }]);

  return RadialBar;
}(__WEBPACK_IMPORTED_MODULE_3_react__["PureComponent"]);

RadialBar.displayName = 'RadialBar';
RadialBar.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  angleAxisId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  radiusAxisId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  shape: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element]),
  activeShape: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element]),
  activeIndex: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  dataKey: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]).isRequired,
  cornerRadius: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string]),
  forceCornerRadius: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  cornerIsExternal: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  minPointSize: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  maxBarSize: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  data: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    cx: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    cy: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    innerRadius: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    outerRadius: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.value
  })),
  legendType: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["b" /* LEGEND_TYPES */]),
  tooltipType: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["e" /* TOOLTIP_TYPES */]),
  label: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object]),
  background: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element]),
  hide: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  onAnimationStart: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onAnimationEnd: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  isAnimationActive: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  animationBegin: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear', 'spring'])
});
RadialBar.defaultProps = {
  angleAxisId: 0,
  radiusAxisId: 0,
  minPointSize: 0,
  hide: false,
  legendType: 'rect',
  data: [],
  isAnimationActive: !Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["o" /* isSsr */])(),
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease',
  forceCornerRadius: false,
  cornerIsExternal: false
};

RadialBar.getComposedData = function (_ref2) {
  var item = _ref2.item,
      props = _ref2.props,
      radiusAxis = _ref2.radiusAxis,
      radiusAxisTicks = _ref2.radiusAxisTicks,
      angleAxis = _ref2.angleAxis,
      angleAxisTicks = _ref2.angleAxisTicks,
      displayedData = _ref2.displayedData,
      dataKey = _ref2.dataKey,
      stackedData = _ref2.stackedData,
      barPosition = _ref2.barPosition,
      bandSize = _ref2.bandSize,
      dataStartIndex = _ref2.dataStartIndex;
  var pos = Object(__WEBPACK_IMPORTED_MODULE_13__util_ChartUtils__["e" /* findPositionOfBar */])(barPosition, item);

  if (!pos) {
    return [];
  }

  var cx = angleAxis.cx,
      cy = angleAxis.cy;
  var layout = props.layout;
  var _item$props = item.props,
      children = _item$props.children,
      minPointSize = _item$props.minPointSize;
  var numericAxis = layout === 'radial' ? angleAxis : radiusAxis;
  var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
  var baseValue = Object(__WEBPACK_IMPORTED_MODULE_13__util_ChartUtils__["i" /* getBaseValueOfBar */])({
    props: props,
    numericAxis: numericAxis
  });
  var cells = Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["i" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_11__component_Cell__["a" /* default */]);
  var sectors = displayedData.map(function (entry, index) {
    var value, innerRadius, outerRadius, startAngle, endAngle, backgroundSector;

    if (stackedData) {
      value = Object(__WEBPACK_IMPORTED_MODULE_13__util_ChartUtils__["B" /* truncateByDomain */])(stackedData[dataStartIndex + index], stackedDomain);
    } else {
      value = Object(__WEBPACK_IMPORTED_MODULE_13__util_ChartUtils__["v" /* getValueByDataKey */])(entry, dataKey);

      if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isArray___default()(value)) {
        value = [baseValue, value];
      }
    }

    if (layout === 'radial') {
      innerRadius = Object(__WEBPACK_IMPORTED_MODULE_13__util_ChartUtils__["j" /* getCateCoordinateOfBar */])({
        axis: radiusAxis,
        ticks: radiusAxisTicks,
        bandSize: bandSize,
        offset: pos.offset,
        entry: entry,
        index: index
      });
      endAngle = angleAxis.scale(value[1]);
      startAngle = angleAxis.scale(value[0]);
      outerRadius = innerRadius + pos.size;
      var deltaAngle = endAngle - startAngle;

      if (Math.abs(minPointSize) > 0 && Math.abs(deltaAngle) < Math.abs(minPointSize)) {
        var delta = Object(__WEBPACK_IMPORTED_MODULE_12__util_DataUtils__["j" /* mathSign */])(deltaAngle || minPointSize) * (Math.abs(minPointSize) - Math.abs(deltaAngle));
        endAngle += delta;
      }

      backgroundSector = {
        background: {
          cx: cx,
          cy: cy,
          innerRadius: innerRadius,
          outerRadius: outerRadius,
          startAngle: props.startAngle,
          endAngle: props.endAngle
        }
      };
    } else {
      innerRadius = radiusAxis.scale(value[0]);
      outerRadius = radiusAxis.scale(value[1]);
      startAngle = Object(__WEBPACK_IMPORTED_MODULE_13__util_ChartUtils__["j" /* getCateCoordinateOfBar */])({
        axis: angleAxis,
        ticks: angleAxisTicks,
        bandSize: bandSize,
        offset: pos.offset,
        entry: entry,
        index: index
      });
      endAngle = startAngle + pos.size;
      var deltaRadius = outerRadius - innerRadius;

      if (Math.abs(minPointSize) > 0 && Math.abs(deltaRadius) < Math.abs(minPointSize)) {
        var _delta = Object(__WEBPACK_IMPORTED_MODULE_12__util_DataUtils__["j" /* mathSign */])(deltaRadius || minPointSize) * (Math.abs(minPointSize) - Math.abs(deltaRadius));

        outerRadius += _delta;
      }
    }

    return _objectSpread({}, entry, {}, backgroundSector, {
      payload: entry,
      value: stackedData ? value : value[1],
      cx: cx,
      cy: cy,
      innerRadius: innerRadius,
      outerRadius: outerRadius,
      startAngle: startAngle,
      endAngle: endAngle
    }, cells && cells[index] && cells[index].props);
  });
  return {
    data: sectors,
    layout: layout
  };
};

/* harmony default export */ __webpack_exports__["a"] = (RadialBar);

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_range__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_d3_scale__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_ChartUtils__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__container_Layer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__component_Text__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_DataUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_CssPrefixUtils__ = __webpack_require__(1686);



function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Brush
 */










var Brush =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Brush, _PureComponent);

  function Brush(props) {
    var _this;

    _classCallCheck(this, Brush);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Brush).call(this, props));

    _this.handleDrag = function (e) {
      if (_this.leaveTimer) {
        clearTimeout(_this.leaveTimer);
        _this.leaveTimer = null;
      }

      if (_this.state.isTravellerMoving) {
        _this.handleTravellerMove(e);
      } else if (_this.state.isSlideMoving) {
        _this.handleSlideDrag(e);
      }
    };

    _this.handleTouchMove = function (e) {
      if (e.changedTouches != null && e.changedTouches.length > 0) {
        _this.handleDrag(e.changedTouches[0]);
      }
    };

    _this.handleDragEnd = function () {
      _this.setState({
        isTravellerMoving: false,
        isSlideMoving: false
      });
    };

    _this.handleLeaveWrapper = function () {
      if (_this.state.isTravellerMoving || _this.state.isSlideMoving) {
        _this.leaveTimer = setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
      }
    };

    _this.handleEnterSlideOrTraveller = function () {
      _this.setState({
        isTextActive: true
      });
    };

    _this.handleLeaveSlideOrTraveller = function () {
      _this.setState({
        isTextActive: false
      });
    };

    _this.handleSlideDragStart = function (e) {
      var event = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e;

      _this.setState({
        isTravellerMoving: false,
        isSlideMoving: true,
        slideMoveStartX: event.pageX
      });
    };

    _this.travellerDragStartHandlers = {
      startX: _this.handleTravellerDragStart.bind(_assertThisInitialized(_this), 'startX'),
      endX: _this.handleTravellerDragStart.bind(_assertThisInitialized(_this), 'endX')
    };
    _this.state = props.data && props.data.length ? _this.updateScale(props) : {};
    return _this;
  } // eslint-disable-next-line camelcase


  _createClass(Brush, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var _this$props = this.props,
          data = _this$props.data,
          width = _this$props.width,
          x = _this$props.x,
          travellerWidth = _this$props.travellerWidth,
          updateId = _this$props.updateId;

      if ((nextProps.data !== data || nextProps.updateId !== updateId) && nextProps.data && nextProps.data.length) {
        this.setState(this.updateScale(nextProps));
      } else if (nextProps.width !== width || nextProps.x !== x || nextProps.travellerWidth !== travellerWidth) {
        this.scale.range([nextProps.x, nextProps.x + nextProps.width - nextProps.travellerWidth]);
        this.scaleValues = this.scale.domain().map(function (entry) {
          return _this2.scale(entry);
        });
        this.setState({
          startX: this.scale(nextProps.startIndex),
          endX: this.scale(nextProps.endIndex)
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.scale = null;
      this.scaleValues = null;

      if (this.leaveTimer) {
        clearTimeout(this.leaveTimer);
        this.leaveTimer = null;
      }
    }
  }, {
    key: "getIndex",
    value: function getIndex(_ref) {
      var startX = _ref.startX,
          endX = _ref.endX;
      var _this$props2 = this.props,
          gap = _this$props2.gap,
          data = _this$props2.data;
      var lastIndex = data.length - 1;
      var min = Math.min(startX, endX);
      var max = Math.max(startX, endX);
      var minIndex = this.constructor.getIndexInRange(this.scaleValues, min);
      var maxIndex = this.constructor.getIndexInRange(this.scaleValues, max);
      return {
        startIndex: minIndex - minIndex % gap,
        endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
      };
    }
  }, {
    key: "getTextOfTick",
    value: function getTextOfTick(index) {
      var _this$props3 = this.props,
          data = _this$props3.data,
          tickFormatter = _this$props3.tickFormatter,
          dataKey = _this$props3.dataKey;
      var text = Object(__WEBPACK_IMPORTED_MODULE_6__util_ChartUtils__["v" /* getValueByDataKey */])(data[index], dataKey, index);
      return __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(tickFormatter) ? tickFormatter(text) : text;
    }
  }, {
    key: "handleSlideDrag",
    value: function handleSlideDrag(e) {
      var _this$state = this.state,
          slideMoveStartX = _this$state.slideMoveStartX,
          startX = _this$state.startX,
          endX = _this$state.endX;
      var _this$props4 = this.props,
          x = _this$props4.x,
          width = _this$props4.width,
          travellerWidth = _this$props4.travellerWidth,
          startIndex = _this$props4.startIndex,
          endIndex = _this$props4.endIndex,
          onChange = _this$props4.onChange;
      var delta = e.pageX - slideMoveStartX;

      if (delta > 0) {
        delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
      } else if (delta < 0) {
        delta = Math.max(delta, x - startX, x - endX);
      }

      var newIndex = this.getIndex({
        startX: startX + delta,
        endX: endX + delta
      });

      if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) {
        onChange(newIndex);
      }

      this.setState({
        startX: startX + delta,
        endX: endX + delta,
        slideMoveStartX: e.pageX
      });
    }
  }, {
    key: "handleTravellerDragStart",
    value: function handleTravellerDragStart(id, e) {
      var event = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e;
      this.setState({
        isSlideMoving: false,
        isTravellerMoving: true,
        movingTravellerId: id,
        brushMoveStartX: event.pageX
      });
    }
  }, {
    key: "handleTravellerMove",
    value: function handleTravellerMove(e) {
      var _this$setState;

      var _this$state2 = this.state,
          brushMoveStartX = _this$state2.brushMoveStartX,
          movingTravellerId = _this$state2.movingTravellerId,
          endX = _this$state2.endX,
          startX = _this$state2.startX;
      var prevValue = this.state[movingTravellerId];
      var _this$props5 = this.props,
          x = _this$props5.x,
          width = _this$props5.width,
          travellerWidth = _this$props5.travellerWidth,
          onChange = _this$props5.onChange,
          gap = _this$props5.gap,
          data = _this$props5.data;
      var params = {
        startX: this.state.startX,
        endX: this.state.endX
      };
      var delta = e.pageX - brushMoveStartX;

      if (delta > 0) {
        delta = Math.min(delta, x + width - travellerWidth - prevValue);
      } else if (delta < 0) {
        delta = Math.max(delta, x - prevValue);
      }

      params[movingTravellerId] = prevValue + delta;
      var newIndex = this.getIndex(params);
      var startIndex = newIndex.startIndex,
          endIndex = newIndex.endIndex;

      var isFullGap = function isFullGap() {
        var lastIndex = data.length - 1;

        if (movingTravellerId === 'startX' && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === 'endX' && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) {
          return true;
        }

        return false;
      };

      this.setState((_this$setState = {}, _defineProperty(_this$setState, movingTravellerId, prevValue + delta), _defineProperty(_this$setState, "brushMoveStartX", e.pageX), _this$setState), function () {
        if (onChange) {
          if (isFullGap()) {
            onChange(newIndex);
          }
        }
      });
    }
  }, {
    key: "updateScale",
    value: function updateScale(props) {
      var _this3 = this;

      var data = props.data,
          startIndex = props.startIndex,
          endIndex = props.endIndex,
          x = props.x,
          width = props.width,
          travellerWidth = props.travellerWidth;
      var len = data.length;
      this.scale = Object(__WEBPACK_IMPORTED_MODULE_5_d3_scale__["scalePoint"])().domain(__WEBPACK_IMPORTED_MODULE_0_lodash_range___default()(0, len)).range([x, x + width - travellerWidth]);
      this.scaleValues = this.scale.domain().map(function (entry) {
        return _this3.scale(entry);
      });
      return {
        isTextActive: false,
        isSlideMoving: false,
        isTravellerMoving: false,
        startX: this.scale(startIndex),
        endX: this.scale(endIndex)
      };
    }
  }, {
    key: "renderBackground",
    value: function renderBackground() {
      var _this$props6 = this.props,
          x = _this$props6.x,
          y = _this$props6.y,
          width = _this$props6.width,
          height = _this$props6.height,
          fill = _this$props6.fill,
          stroke = _this$props6.stroke;
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("rect", {
        stroke: stroke,
        fill: fill,
        x: x,
        y: y,
        width: width,
        height: height
      });
    }
  }, {
    key: "renderPanorama",
    value: function renderPanorama() {
      var _this$props7 = this.props,
          x = _this$props7.x,
          y = _this$props7.y,
          width = _this$props7.width,
          height = _this$props7.height,
          data = _this$props7.data,
          children = _this$props7.children,
          padding = _this$props7.padding;
      var chartElement = __WEBPACK_IMPORTED_MODULE_2_react__["Children"].only(children);

      if (!chartElement) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(chartElement, {
        x: x,
        y: y,
        width: width,
        height: height,
        margin: padding,
        compact: true,
        data: data
      });
    }
  }, {
    key: "renderTraveller",
    value: function renderTraveller(travellerX, id) {
      var _this$props8 = this.props,
          y = _this$props8.y,
          travellerWidth = _this$props8.travellerWidth,
          height = _this$props8.height,
          stroke = _this$props8.stroke;
      var lineY = Math.floor(y + height / 2) - 1;
      var x = Math.max(travellerX, this.props.x);
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__container_Layer__["a" /* default */], {
        className: "recharts-brush-traveller",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.travellerDragStartHandlers[id],
        onTouchStart: this.travellerDragStartHandlers[id],
        style: {
          cursor: 'col-resize'
        }
      }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("rect", {
        x: x,
        y: y,
        width: travellerWidth,
        height: height,
        fill: stroke,
        stroke: "none"
      }), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("line", {
        x1: x + 1,
        y1: lineY,
        x2: x + travellerWidth - 1,
        y2: lineY,
        fill: "none",
        stroke: "#fff"
      }), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("line", {
        x1: x + 1,
        y1: lineY + 2,
        x2: x + travellerWidth - 1,
        y2: lineY + 2,
        fill: "none",
        stroke: "#fff"
      }));
    }
  }, {
    key: "renderSlide",
    value: function renderSlide(startX, endX) {
      var _this$props9 = this.props,
          y = _this$props9.y,
          height = _this$props9.height,
          stroke = _this$props9.stroke;
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("rect", {
        className: "recharts-brush-slide",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.handleSlideDragStart,
        onTouchStart: this.handleSlideDragStart,
        style: {
          cursor: 'move'
        },
        stroke: "none",
        fill: stroke,
        fillOpacity: 0.2,
        x: Math.min(startX, endX),
        y: y,
        width: Math.abs(endX - startX),
        height: height
      });
    }
  }, {
    key: "renderText",
    value: function renderText() {
      var _this$props10 = this.props,
          startIndex = _this$props10.startIndex,
          endIndex = _this$props10.endIndex,
          y = _this$props10.y,
          height = _this$props10.height,
          travellerWidth = _this$props10.travellerWidth,
          stroke = _this$props10.stroke;
      var _this$state3 = this.state,
          startX = _this$state3.startX,
          endX = _this$state3.endX;
      var offset = 5;
      var attrs = {
        pointerEvents: 'none',
        fill: stroke
      };
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__container_Layer__["a" /* default */], {
        className: "recharts-brush-texts"
      }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__component_Text__["a" /* default */], _extends({
        textAnchor: "end",
        verticalAnchor: "middle",
        x: Math.min(startX, endX) - offset,
        y: y + height / 2
      }, attrs), this.getTextOfTick(startIndex)), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__component_Text__["a" /* default */], _extends({
        textAnchor: "start",
        verticalAnchor: "middle",
        x: Math.max(startX, endX) + travellerWidth + offset,
        y: y + height / 2
      }, attrs), this.getTextOfTick(endIndex)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props11 = this.props,
          data = _this$props11.data,
          className = _this$props11.className,
          children = _this$props11.children,
          x = _this$props11.x,
          y = _this$props11.y,
          width = _this$props11.width,
          height = _this$props11.height,
          alwaysShowText = _this$props11.alwaysShowText;
      var _this$state4 = this.state,
          startX = _this$state4.startX,
          endX = _this$state4.endX,
          isTextActive = _this$state4.isTextActive,
          isSlideMoving = _this$state4.isSlideMoving,
          isTravellerMoving = _this$state4.isTravellerMoving;

      if (!data || !data.length || !Object(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["h" /* isNumber */])(x) || !Object(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["h" /* isNumber */])(y) || !Object(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["h" /* isNumber */])(width) || !Object(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["h" /* isNumber */])(height) || width <= 0 || height <= 0) {
        return null;
      }

      var layerClass = __WEBPACK_IMPORTED_MODULE_4_classnames___default()('recharts-brush', className);
      var isPanoramic = __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1;
      var style = Object(__WEBPACK_IMPORTED_MODULE_10__util_CssPrefixUtils__["a" /* generatePrefixStyle */])('userSelect', 'none');
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__container_Layer__["a" /* default */], {
        className: layerClass,
        onMouseMove: this.handleDrag,
        onMouseLeave: this.handleLeaveWrapper,
        onMouseUp: this.handleDragEnd,
        onTouchEnd: this.handleDragEnd,
        onTouchMove: this.handleTouchMove,
        style: style
      }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTraveller(startX, 'startX'), this.renderTraveller(endX, 'endX'), (isTextActive || isSlideMoving || isTravellerMoving || alwaysShowText) && this.renderText());
    }
  }], [{
    key: "getIndexInRange",
    value: function getIndexInRange(range, x) {
      var len = range.length;
      var start = 0;
      var end = len - 1;

      while (end - start > 1) {
        var middle = Math.floor((start + end) / 2);

        if (range[middle] > x) {
          end = middle;
        } else {
          start = middle;
        }
      }

      return x >= range[end] ? end : start;
    }
  }]);

  return Brush;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);

Brush.displayName = 'Brush';
Brush.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  fill: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  stroke: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  x: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  y: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
  travellerWidth: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  gap: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  padding: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    top: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    right: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    bottom: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    left: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number
  }),
  dataKey: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func]),
  data: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,
  startIndex: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  endIndex: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  tickFormatter: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  onChange: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  updateId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]),
  leaveTimeOut: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  alwaysShowText: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};
Brush.defaultProps = {
  height: 40,
  travellerWidth: 5,
  gap: 1,
  fill: '#fff',
  stroke: '#666',
  padding: {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  },
  leaveTimeOut: 1000,
  alwaysShowText: false
};
/* harmony default export */ __webpack_exports__["a"] = (Brush);

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_some__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__container_Layer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component_Label__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_IfOverflowMatches__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_DataUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_CartesianUtils__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_LogUtils__ = __webpack_require__(188);



function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * @fileOverview Reference Line
 */











var renderLine = function renderLine(option, props) {
  var line;

  if (__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(option)) {
    line = __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(option, props);
  } else if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(option)) {
    line = option(props);
  } else {
    line = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("line", _extends({}, props, {
      className: "recharts-reference-line-line"
    }));
  }

  return line;
};

var ReferenceLine =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ReferenceLine, _PureComponent);

  function ReferenceLine() {
    _classCallCheck(this, ReferenceLine);

    return _possibleConstructorReturn(this, _getPrototypeOf(ReferenceLine).apply(this, arguments));
  }

  _createClass(ReferenceLine, [{
    key: "getEndPoints",
    value: function getEndPoints(scales, isFixedX, isFixedY, isSegment) {
      var _this$props = this.props,
          _this$props$viewBox = _this$props.viewBox,
          x = _this$props$viewBox.x,
          y = _this$props$viewBox.y,
          width = _this$props$viewBox.width,
          height = _this$props$viewBox.height,
          position = _this$props.position;

      if (isFixedY) {
        var _this$props2 = this.props,
            yCoord = _this$props2.y,
            orientation = _this$props2.yAxis.orientation;
        var coord = scales.y.apply(yCoord, {
          position: position
        });

        if (Object(__WEBPACK_IMPORTED_MODULE_8__util_IfOverflowMatches__["a" /* ifOverflowMatches */])(this.props, 'discard') && !scales.y.isInRange(coord)) {
          return null;
        }

        var points = [{
          x: x + width,
          y: coord
        }, {
          x: x,
          y: coord
        }];
        return orientation === 'left' ? points.reverse() : points;
      }

      if (isFixedX) {
        var _this$props3 = this.props,
            xCoord = _this$props3.x,
            _orientation = _this$props3.xAxis.orientation;

        var _coord = scales.x.apply(xCoord, {
          position: position
        });

        if (Object(__WEBPACK_IMPORTED_MODULE_8__util_IfOverflowMatches__["a" /* ifOverflowMatches */])(this.props, 'discard') && !scales.x.isInRange(_coord)) {
          return null;
        }

        var _points = [{
          x: _coord,
          y: y + height
        }, {
          x: _coord,
          y: y
        }];
        return _orientation === 'top' ? _points.reverse() : _points;
      }

      if (isSegment) {
        var segment = this.props.segment;

        var _points2 = segment.map(function (p) {
          return scales.apply(p, {
            position: position
          });
        });

        if (Object(__WEBPACK_IMPORTED_MODULE_8__util_IfOverflowMatches__["a" /* ifOverflowMatches */])(this.props, 'discard') && __WEBPACK_IMPORTED_MODULE_0_lodash_some___default()(_points2, function (p) {
          return !scales.isInRange(p);
        })) {
          return null;
        }

        return _points2;
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          fixedX = _this$props4.x,
          fixedY = _this$props4.y,
          segment = _this$props4.segment,
          xAxis = _this$props4.xAxis,
          yAxis = _this$props4.yAxis,
          shape = _this$props4.shape,
          className = _this$props4.className,
          alwaysShow = _this$props4.alwaysShow,
          clipPathId = _this$props4.clipPathId;
      Object(__WEBPACK_IMPORTED_MODULE_11__util_LogUtils__["a" /* warn */])(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
      var scales = __WEBPACK_IMPORTED_MODULE_10__util_CartesianUtils__["a" /* LabeledScaleHelper */].create({
        x: xAxis.scale,
        y: yAxis.scale
      });
      var isX = Object(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["g" /* isNumOrStr */])(fixedX);
      var isY = Object(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["g" /* isNumOrStr */])(fixedY);
      var isSegment = segment && segment.length === 2;
      var endPoints = this.getEndPoints(scales, isX, isY, isSegment);

      if (!endPoints) {
        return null;
      }

      var _endPoints = _slicedToArray(endPoints, 2),
          _endPoints$ = _endPoints[0],
          x1 = _endPoints$.x,
          y1 = _endPoints$.y,
          _endPoints$2 = _endPoints[1],
          x2 = _endPoints$2.x,
          y2 = _endPoints$2.y;

      var clipPath = Object(__WEBPACK_IMPORTED_MODULE_8__util_IfOverflowMatches__["a" /* ifOverflowMatches */])(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;

      var props = _objectSpread({
        clipPath: clipPath
      }, Object(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["l" /* getPresentationAttributes */])(this.props), {}, Object(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["f" /* filterEventAttributes */])(this.props), {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
      });

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__container_Layer__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('recharts-reference-line', className)
      }, renderLine(shape, props), __WEBPACK_IMPORTED_MODULE_7__component_Label__["a" /* default */].renderCallByParent(this.props, Object(__WEBPACK_IMPORTED_MODULE_10__util_CartesianUtils__["c" /* rectWithCoords */])({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
      })));
    }
  }]);

  return ReferenceLine;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);

ReferenceLine.displayName = 'ReferenceLine';
ReferenceLine.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  viewBox: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    width: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    height: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number
  }),
  xAxis: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  yAxis: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  isFront: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  alwaysShow: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  ifOverflow: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['hidden', 'visible', 'discard', 'extendDomain']),
  x: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),
  y: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),
  segment: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),
    y: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string])
  })),
  position: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['middle', 'start', 'end']),
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),
  yAxisId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]),
  xAxisId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]),
  shape: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
});
ReferenceLine.defaultProps = {
  isFront: false,
  ifOverflow: 'discard',
  xAxisId: 0,
  yAxisId: 0,
  fill: 'none',
  stroke: '#ccc',
  fillOpacity: 1,
  strokeWidth: 1,
  position: 'middle'
};
/* harmony default export */ __webpack_exports__["a"] = (ReferenceLine);

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEvery = __webpack_require__(1688),
    baseEvery = __webpack_require__(1689),
    baseIteratee = __webpack_require__(67),
    isArray = __webpack_require__(26),
    isIterateeCall = __webpack_require__(231);

/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */
function every(collection, predicate, guard) {
  var func = isArray(collection) ? arrayEvery : baseEvery;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = every;


/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__container_Layer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shape_Dot__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component_Label__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_DataUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_IfOverflowMatches__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_CartesianUtils__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_LogUtils__ = __webpack_require__(188);


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Reference Dot
 */












var ReferenceDot =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ReferenceDot, _PureComponent);

  function ReferenceDot() {
    _classCallCheck(this, ReferenceDot);

    return _possibleConstructorReturn(this, _getPrototypeOf(ReferenceDot).apply(this, arguments));
  }

  _createClass(ReferenceDot, [{
    key: "getCoordinate",
    value: function getCoordinate() {
      var _this$props = this.props,
          x = _this$props.x,
          y = _this$props.y,
          xAxis = _this$props.xAxis,
          yAxis = _this$props.yAxis;
      var scales = __WEBPACK_IMPORTED_MODULE_10__util_CartesianUtils__["a" /* LabeledScaleHelper */].create({
        x: xAxis.scale,
        y: yAxis.scale
      });
      var result = scales.apply({
        x: x,
        y: y
      }, {
        bandAware: true
      });

      if (Object(__WEBPACK_IMPORTED_MODULE_9__util_IfOverflowMatches__["a" /* ifOverflowMatches */])(this.props, 'discard') && !scales.isInRange(result)) {
        return null;
      }

      return result;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          x = _this$props2.x,
          y = _this$props2.y,
          r = _this$props2.r,
          alwaysShow = _this$props2.alwaysShow,
          clipPathId = _this$props2.clipPathId;
      var isX = Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["g" /* isNumOrStr */])(x);
      var isY = Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["g" /* isNumOrStr */])(y);
      Object(__WEBPACK_IMPORTED_MODULE_11__util_LogUtils__["a" /* warn */])(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');

      if (!isX || !isY) {
        return null;
      }

      var coordinate = this.getCoordinate();

      if (!coordinate) {
        return null;
      }

      var cx = coordinate.x,
          cy = coordinate.y;
      var _this$props3 = this.props,
          shape = _this$props3.shape,
          className = _this$props3.className;
      var clipPath = Object(__WEBPACK_IMPORTED_MODULE_9__util_IfOverflowMatches__["a" /* ifOverflowMatches */])(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;

      var dotProps = _objectSpread({
        clipPath: clipPath
      }, Object(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["l" /* getPresentationAttributes */])(this.props), {}, Object(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["f" /* filterEventAttributes */])(this.props), {
        cx: cx,
        cy: cy
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__container_Layer__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('recharts-reference-dot', className)
      }, this.constructor.renderDot(shape, dotProps), __WEBPACK_IMPORTED_MODULE_7__component_Label__["a" /* default */].renderCallByParent(this.props, {
        x: cx - r,
        y: cy - r,
        width: 2 * r,
        height: 2 * r
      }));
    }
  }], [{
    key: "renderDot",
    value: function renderDot(option, props) {
      var dot;

      if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(option)) {
        dot = __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        dot = option(props);
      } else {
        dot = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shape_Dot__["a" /* default */], _extends({}, props, {
          cx: props.cx,
          cy: props.cy,
          className: "recharts-reference-dot-dot"
        }));
      }

      return dot;
    }
  }]);

  return ReferenceDot;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

ReferenceDot.displayName = 'ReferenceDot';
ReferenceDot.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {}, __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["a" /* EVENT_ATTRIBUTES */], {
  r: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  xAxis: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    scale: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
  }),
  yAxis: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    scale: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
  }),
  isFront: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  alwaysShow: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  ifOverflow: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['hidden', 'visible', 'discard', 'extendDomain']),
  x: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  y: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  yAxisId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  xAxisId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  shape: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element]),
  clipPathId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
});
ReferenceDot.defaultProps = {
  isFront: false,
  ifOverflow: 'discard',
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: '#fff',
  stroke: '#ccc',
  fillOpacity: 1,
  strokeWidth: 1
};
/* harmony default export */ __webpack_exports__["a"] = (ReferenceDot);

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__container_Layer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component_Label__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_CartesianUtils__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_IfOverflowMatches__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_DataUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_LogUtils__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_ReactUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shape_Rectangle__ = __webpack_require__(194);


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Reference Line
 */












var ReferenceArea =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ReferenceArea, _PureComponent);

  function ReferenceArea() {
    _classCallCheck(this, ReferenceArea);

    return _possibleConstructorReturn(this, _getPrototypeOf(ReferenceArea).apply(this, arguments));
  }

  _createClass(ReferenceArea, [{
    key: "getRect",
    value: function getRect(hasX1, hasX2, hasY1, hasY2) {
      var _this$props = this.props,
          xValue1 = _this$props.x1,
          xValue2 = _this$props.x2,
          yValue1 = _this$props.y1,
          yValue2 = _this$props.y2,
          xAxis = _this$props.xAxis,
          yAxis = _this$props.yAxis;
      var scale = __WEBPACK_IMPORTED_MODULE_6__util_CartesianUtils__["a" /* LabeledScaleHelper */].create({
        x: xAxis.scale,
        y: yAxis.scale
      });
      var p1 = {
        x: hasX1 ? scale.x.apply(xValue1) : scale.x.rangeMin,
        y: hasY1 ? scale.y.apply(yValue1) : scale.y.rangeMin
      };
      var p2 = {
        x: hasX2 ? scale.x.apply(xValue2) : scale.x.rangeMax,
        y: hasY2 ? scale.y.apply(yValue2) : scale.y.rangeMax
      };

      if (Object(__WEBPACK_IMPORTED_MODULE_7__util_IfOverflowMatches__["a" /* ifOverflowMatches */])(this.props, 'discard') && (!scale.isInRange(p1) || !scale.isInRange(p2))) {
        return null;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_6__util_CartesianUtils__["d" /* rectWithPoints */])(p1, p2);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          x1 = _this$props2.x1,
          x2 = _this$props2.x2,
          y1 = _this$props2.y1,
          y2 = _this$props2.y2,
          className = _this$props2.className,
          alwaysShow = _this$props2.alwaysShow,
          clipPathId = _this$props2.clipPathId;
      Object(__WEBPACK_IMPORTED_MODULE_9__util_LogUtils__["a" /* warn */])(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
      var hasX1 = Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["g" /* isNumOrStr */])(x1);
      var hasX2 = Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["g" /* isNumOrStr */])(x2);
      var hasY1 = Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["g" /* isNumOrStr */])(y1);
      var hasY2 = Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["g" /* isNumOrStr */])(y2);
      var shape = this.props.shape;

      if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) {
        return null;
      }

      var rect = this.getRect(hasX1, hasX2, hasY1, hasY2);

      if (!rect && !shape) {
        return null;
      }

      var clipPath = Object(__WEBPACK_IMPORTED_MODULE_7__util_IfOverflowMatches__["a" /* ifOverflowMatches */])(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__container_Layer__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('recharts-reference-area', className)
      }, this.constructor.renderRect(shape, _objectSpread({
        clipPath: clipPath
      }, this.props, {}, rect)), __WEBPACK_IMPORTED_MODULE_5__component_Label__["a" /* default */].renderCallByParent(this.props, rect));
    }
  }], [{
    key: "renderRect",
    value: function renderRect(option, props) {
      var rect;

      if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(option)) {
        rect = __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        rect = option(props);
      } else {
        rect = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shape_Rectangle__["a" /* default */], _extends({}, props, {
          className: "recharts-reference-area-rect"
        }));
      }

      return rect;
    }
  }]);

  return ReferenceArea;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

ReferenceArea.displayName = 'ReferenceArea';
ReferenceArea.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_10__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  viewBox: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    width: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    height: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
  }),
  xAxis: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  yAxis: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  isFront: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  alwaysShow: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  ifOverflow: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['hidden', 'visible', 'discard', 'extendDomain']),
  x1: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  x2: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  y1: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  y2: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  yAxisId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  xAxisId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  shape: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element])
});
ReferenceArea.defaultProps = {
  isFront: false,
  ifOverflow: 'discard',
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: '#ccc',
  fillOpacity: 0.5,
  stroke: 'none',
  strokeWidth: 1
};
/* harmony default export */ __webpack_exports__["a"] = (ReferenceArea);

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_ShallowEqual__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_DOMUtils__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__container_Layer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component_Text__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__component_Label__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_DataUtils__ = __webpack_require__(23);


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Cartesian Axis
 */











var CartesianAxis =
/*#__PURE__*/
function (_Component) {
  _inherits(CartesianAxis, _Component);

  function CartesianAxis() {
    _classCallCheck(this, CartesianAxis);

    return _possibleConstructorReturn(this, _getPrototypeOf(CartesianAxis).apply(this, arguments));
  }

  _createClass(CartesianAxis, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(_ref, state) {
      var viewBox = _ref.viewBox,
          restProps = _objectWithoutProperties(_ref, ["viewBox"]);

      // props.viewBox is sometimes generated every time -
      // check that specially as object equality is likely to fail
      var _this$props = this.props,
          viewBoxOld = _this$props.viewBox,
          restPropsOld = _objectWithoutProperties(_this$props, ["viewBox"]);

      return !Object(__WEBPACK_IMPORTED_MODULE_4__util_ShallowEqual__["a" /* shallowEqual */])(viewBox, viewBoxOld) || !Object(__WEBPACK_IMPORTED_MODULE_4__util_ShallowEqual__["a" /* shallowEqual */])(restProps, restPropsOld) || !Object(__WEBPACK_IMPORTED_MODULE_4__util_ShallowEqual__["a" /* shallowEqual */])(state, this.state);
    }
    /**
     * Calculate the coordinates of endpoints in ticks
     * @param  {Object} data The data of a simple tick
     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
     *  (x2, y2): The coordinate of endpoint close to axis
     */

  }, {
    key: "getTickLineCoord",
    value: function getTickLineCoord(data) {
      var _this$props2 = this.props,
          x = _this$props2.x,
          y = _this$props2.y,
          width = _this$props2.width,
          height = _this$props2.height,
          orientation = _this$props2.orientation,
          tickSize = _this$props2.tickSize,
          mirror = _this$props2.mirror,
          tickMargin = _this$props2.tickMargin;
      var x1, x2, y1, y2, tx, ty;
      var sign = mirror ? -1 : 1;
      var finalTickSize = data.tickSize || tickSize;
      var tickCoord = Object(__WEBPACK_IMPORTED_MODULE_10__util_DataUtils__["h" /* isNumber */])(data.tickCoord) ? data.tickCoord : data.coordinate;

      switch (orientation) {
        case 'top':
          x1 = x2 = data.coordinate;
          y2 = y + !mirror * height;
          y1 = y2 - sign * finalTickSize;
          ty = y1 - sign * tickMargin;
          tx = tickCoord;
          break;

        case 'left':
          y1 = y2 = data.coordinate;
          x2 = x + !mirror * width;
          x1 = x2 - sign * finalTickSize;
          tx = x1 - sign * tickMargin;
          ty = tickCoord;
          break;

        case 'right':
          y1 = y2 = data.coordinate;
          x2 = x + mirror * width;
          x1 = x2 + sign * finalTickSize;
          tx = x1 + sign * tickMargin;
          ty = tickCoord;
          break;

        default:
          x1 = x2 = data.coordinate;
          y2 = y + mirror * height;
          y1 = y2 + sign * finalTickSize;
          ty = y1 + sign * tickMargin;
          tx = tickCoord;
          break;
      }

      return {
        line: {
          x1: x1,
          y1: y1,
          x2: x2,
          y2: y2
        },
        tick: {
          x: tx,
          y: ty
        }
      };
    }
  }, {
    key: "getTickTextAnchor",
    value: function getTickTextAnchor() {
      var _this$props3 = this.props,
          orientation = _this$props3.orientation,
          mirror = _this$props3.mirror;
      var textAnchor;

      switch (orientation) {
        case 'left':
          textAnchor = mirror ? 'start' : 'end';
          break;

        case 'right':
          textAnchor = mirror ? 'end' : 'start';
          break;

        default:
          textAnchor = 'middle';
          break;
      }

      return textAnchor;
    }
  }, {
    key: "getTickVerticalAnchor",
    value: function getTickVerticalAnchor() {
      var _this$props4 = this.props,
          orientation = _this$props4.orientation,
          mirror = _this$props4.mirror;
      var verticalAnchor = 'end';

      switch (orientation) {
        case 'left':
        case 'right':
          verticalAnchor = 'middle';
          break;

        case 'top':
          verticalAnchor = mirror ? 'start' : 'end';
          break;

        default:
          verticalAnchor = mirror ? 'end' : 'start';
          break;
      }

      return verticalAnchor;
    }
  }, {
    key: "renderAxisLine",
    value: function renderAxisLine() {
      var _this$props5 = this.props,
          x = _this$props5.x,
          y = _this$props5.y,
          width = _this$props5.width,
          height = _this$props5.height,
          orientation = _this$props5.orientation,
          axisLine = _this$props5.axisLine,
          mirror = _this$props5.mirror;

      var props = _objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["l" /* getPresentationAttributes */])(this.props), {
        fill: 'none'
      }, Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["l" /* getPresentationAttributes */])(axisLine));

      if (orientation === 'top' || orientation === 'bottom') {
        var needHeight = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
        props = _objectSpread({}, props, {
          x1: x,
          y1: y + needHeight * height,
          x2: x + width,
          y2: y + needHeight * height
        });
      } else {
        var needWidth = orientation === 'left' && !mirror || orientation === 'right' && mirror;
        props = _objectSpread({}, props, {
          x1: x + needWidth * width,
          y1: y,
          x2: x + needWidth * width,
          y2: y + height
        });
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line", _extends({
        className: "recharts-cartesian-axis-line"
      }, props));
    }
  }, {
    key: "renderTicks",

    /**
     * render the ticks
     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
     * @return {ReactComponent} renderedTicks
     */
    value: function renderTicks(ticks) {
      var _this = this;

      var _this$props6 = this.props,
          tickLine = _this$props6.tickLine,
          stroke = _this$props6.stroke,
          tick = _this$props6.tick,
          tickFormatter = _this$props6.tickFormatter,
          unit = _this$props6.unit;
      var finalTicks = CartesianAxis.getTicks(_objectSpread({}, this.props, {
        ticks: ticks
      }));
      var textAnchor = this.getTickTextAnchor();
      var verticalAnchor = this.getTickVerticalAnchor();
      var axisProps = Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["l" /* getPresentationAttributes */])(this.props);
      var customTickProps = Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["l" /* getPresentationAttributes */])(tick);

      var tickLineProps = _objectSpread({}, axisProps, {
        fill: 'none'
      }, Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["l" /* getPresentationAttributes */])(tickLine));

      var items = finalTicks.map(function (entry, i) {
        var _this$getTickLineCoor = _this.getTickLineCoord(entry),
            lineCoord = _this$getTickLineCoor.line,
            tickCoord = _this$getTickLineCoor.tick;

        var tickProps = _objectSpread({
          textAnchor: textAnchor,
          verticalAnchor: verticalAnchor
        }, axisProps, {
          stroke: 'none',
          fill: stroke
        }, customTickProps, {}, tickCoord, {
          index: i,
          payload: entry,
          visibleTicksCount: finalTicks.length
        });

        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__container_Layer__["a" /* default */], _extends({
          className: "recharts-cartesian-axis-tick",
          key: "tick-".concat(i) // eslint-disable-line react/no-array-index-key

        }, Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["g" /* filterEventsOfChild */])(_this.props, entry, i)), tickLine && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line", _extends({
          className: "recharts-cartesian-axis-tick-line"
        }, tickLineProps, lineCoord)), tick && _this.constructor.renderTickItem(tick, tickProps, "".concat(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(tickFormatter) ? tickFormatter(entry.value) : entry.value).concat(unit || '')));
      });
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g", {
        className: "recharts-cartesian-axis-ticks"
      }, items);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          axisLine = _this$props7.axisLine,
          width = _this$props7.width,
          height = _this$props7.height,
          ticksGenerator = _this$props7.ticksGenerator,
          className = _this$props7.className,
          hide = _this$props7.hide;

      if (hide) {
        return null;
      }

      var _this$props8 = this.props,
          ticks = _this$props8.ticks,
          noTicksProps = _objectWithoutProperties(_this$props8, ["ticks"]);

      var finalTicks = ticks;

      if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(ticksGenerator)) {
        finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
      }

      if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__container_Layer__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('recharts-cartesian-axis', className)
      }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks), __WEBPACK_IMPORTED_MODULE_8__component_Label__["a" /* default */].renderCallByParent(this.props));
    }
  }], [{
    key: "getTicks",
    value: function getTicks(props) {
      var tick = props.tick,
          ticks = props.ticks,
          viewBox = props.viewBox,
          minTickGap = props.minTickGap,
          orientation = props.orientation,
          interval = props.interval,
          tickFormatter = props.tickFormatter,
          unit = props.unit;

      if (!ticks || !ticks.length || !tick) {
        return [];
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_10__util_DataUtils__["h" /* isNumber */])(interval) || Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["o" /* isSsr */])()) {
        return CartesianAxis.getNumberIntervalTicks(ticks, Object(__WEBPACK_IMPORTED_MODULE_10__util_DataUtils__["h" /* isNumber */])(interval) ? interval : 0);
      }

      if (interval === 'preserveStartEnd') {
        return CartesianAxis.getTicksStart({
          ticks: ticks,
          tickFormatter: tickFormatter,
          viewBox: viewBox,
          orientation: orientation,
          minTickGap: minTickGap,
          unit: unit
        }, true);
      }

      if (interval === 'preserveStart') {
        return CartesianAxis.getTicksStart({
          ticks: ticks,
          tickFormatter: tickFormatter,
          viewBox: viewBox,
          orientation: orientation,
          minTickGap: minTickGap,
          unit: unit
        });
      }

      return CartesianAxis.getTicksEnd({
        ticks: ticks,
        tickFormatter: tickFormatter,
        viewBox: viewBox,
        orientation: orientation,
        minTickGap: minTickGap,
        unit: unit
      });
    }
  }, {
    key: "getNumberIntervalTicks",
    value: function getNumberIntervalTicks(ticks, interval) {
      return ticks.filter(function (entry, i) {
        return i % (interval + 1) === 0;
      });
    }
  }, {
    key: "getTicksStart",
    value: function getTicksStart(_ref2, preserveEnd) {
      var ticks = _ref2.ticks,
          tickFormatter = _ref2.tickFormatter,
          viewBox = _ref2.viewBox,
          orientation = _ref2.orientation,
          minTickGap = _ref2.minTickGap,
          unit = _ref2.unit;
      var x = viewBox.x,
          y = viewBox.y,
          width = viewBox.width,
          height = viewBox.height;
      var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
      var result = (ticks || []).slice(); // we need add the width of 'unit' only when sizeKey === 'width'

      var unitSize = unit && sizeKey === 'width' ? Object(__WEBPACK_IMPORTED_MODULE_5__util_DOMUtils__["c" /* getStringSize */])(unit)[sizeKey] : 0;
      var len = result.length;
      var sign = len >= 2 ? Object(__WEBPACK_IMPORTED_MODULE_10__util_DataUtils__["j" /* mathSign */])(result[1].coordinate - result[0].coordinate) : 1;
      var start, end;

      if (sign === 1) {
        start = sizeKey === 'width' ? x : y;
        end = sizeKey === 'width' ? x + width : y + height;
      } else {
        start = sizeKey === 'width' ? x + width : y + height;
        end = sizeKey === 'width' ? x : y;
      }

      if (preserveEnd) {
        // Try to guarantee the tail to be displayed
        var tail = ticks[len - 1];
        var tailContent = __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(tickFormatter) ? tickFormatter(tail.value) : tail.value;
        var tailSize = Object(__WEBPACK_IMPORTED_MODULE_5__util_DOMUtils__["c" /* getStringSize */])(tailContent)[sizeKey] + unitSize;
        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
        result[len - 1] = tail = _objectSpread({}, tail, {
          tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
        });
        var isTailShow = sign * (tail.tickCoord - sign * tailSize / 2 - start) >= 0 && sign * (tail.tickCoord + sign * tailSize / 2 - end) <= 0;

        if (isTailShow) {
          end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
          result[len - 1] = _objectSpread({}, tail, {
            isShow: true
          });
        }
      }

      var count = preserveEnd ? len - 1 : len;

      for (var _i = 0; _i < count; _i++) {
        var entry = result[_i];
        var content = __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(tickFormatter) ? tickFormatter(entry.value) : entry.value;
        var size = Object(__WEBPACK_IMPORTED_MODULE_5__util_DOMUtils__["c" /* getStringSize */])(content)[sizeKey] + unitSize;

        if (_i === 0) {
          var gap = sign * (entry.coordinate - sign * size / 2 - start);
          result[_i] = entry = _objectSpread({}, entry, {
            tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
          });
        } else {
          result[_i] = entry = _objectSpread({}, entry, {
            tickCoord: entry.coordinate
          });
        }

        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;

        if (isShow) {
          start = entry.tickCoord + sign * (size / 2 + minTickGap);
          result[_i] = _objectSpread({}, entry, {
            isShow: true
          });
        }
      }

      return result.filter(function (entry) {
        return entry.isShow;
      });
    }
  }, {
    key: "getTicksEnd",
    value: function getTicksEnd(_ref3) {
      var ticks = _ref3.ticks,
          tickFormatter = _ref3.tickFormatter,
          viewBox = _ref3.viewBox,
          orientation = _ref3.orientation,
          minTickGap = _ref3.minTickGap,
          unit = _ref3.unit;
      var x = viewBox.x,
          y = viewBox.y,
          width = viewBox.width,
          height = viewBox.height;
      var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height'; // we need add the width of 'unit' only when sizeKey === 'width'

      var unitSize = unit && sizeKey === 'width' ? Object(__WEBPACK_IMPORTED_MODULE_5__util_DOMUtils__["c" /* getStringSize */])(unit)[sizeKey] : 0;
      var result = (ticks || []).slice();
      var len = result.length;
      var sign = len >= 2 ? Object(__WEBPACK_IMPORTED_MODULE_10__util_DataUtils__["j" /* mathSign */])(result[1].coordinate - result[0].coordinate) : 1;
      var start, end;

      if (sign === 1) {
        start = sizeKey === 'width' ? x : y;
        end = sizeKey === 'width' ? x + width : y + height;
      } else {
        start = sizeKey === 'width' ? x + width : y + height;
        end = sizeKey === 'width' ? x : y;
      }

      for (var _i2 = len - 1; _i2 >= 0; _i2--) {
        var entry = result[_i2];
        var content = __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(tickFormatter) ? tickFormatter(entry.value) : entry.value;
        var size = Object(__WEBPACK_IMPORTED_MODULE_5__util_DOMUtils__["c" /* getStringSize */])(content)[sizeKey] + unitSize;

        if (_i2 === len - 1) {
          var gap = sign * (entry.coordinate + sign * size / 2 - end);
          result[_i2] = entry = _objectSpread({}, entry, {
            tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
          });
        } else {
          result[_i2] = entry = _objectSpread({}, entry, {
            tickCoord: entry.coordinate
          });
        }

        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;

        if (isShow) {
          end = entry.tickCoord - sign * (size / 2 + minTickGap);
          result[_i2] = _objectSpread({}, entry, {
            isShow: true
          });
        }
      }

      return result.filter(function (entry) {
        return entry.isShow;
      });
    }
  }, {
    key: "renderTickItem",
    value: function renderTickItem(option, props, value) {
      var tickItem;

      if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(option)) {
        tickItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        tickItem = option(props);
      } else {
        tickItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__component_Text__["a" /* default */], _extends({}, props, {
          className: "recharts-cartesian-axis-tick-value"
        }), value);
      }

      return tickItem;
    }
  }]);

  return CartesianAxis;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

CartesianAxis.displayName = 'CartesianAxis';
CartesianAxis.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {}, __WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["a" /* EVENT_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  x: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  y: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  orientation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['top', 'bottom', 'left', 'right']),
  // The viewBox of svg
  viewBox: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    width: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    height: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
  }),
  tick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element]),
  axisLine: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object]),
  tickLine: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object]),
  mirror: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  tickMargin: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,
  minTickGap: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  ticks: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  tickSize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  stroke: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  tickFormatter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  ticksGenerator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  interval: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])])
});
CartesianAxis.defaultProps = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  // The orientation of axis
  orientation: 'bottom',
  // The ticks
  ticks: [],
  stroke: '#666',
  tickLine: true,
  axisLine: true,
  tick: true,
  mirror: false,
  minTickGap: 5,
  // The width or height of tick
  tickSize: 6,
  tickMargin: 2,
  interval: 'preserveEnd'
};
/* harmony default export */ __webpack_exports__["a"] = (CartesianAxis);

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function $getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = $getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  var args = [];
  for (var i = 0; i < arguments.length; i++) args.push(arguments[i]);
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    ReflectApply(this.listener, this.target, args);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      if (typeof listener !== 'function') {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
      }
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      if (typeof listener !== 'function') {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
      }

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(352),
    getPrototype = __webpack_require__(316),
    getSymbols = __webpack_require__(353),
    stubArray = __webpack_require__(634);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(633),
    getSymbolsIn = __webpack_require__(786),
    keysIn = __webpack_require__(432);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isPlainObject__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isPlainObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isPlainObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isFunction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_omit__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isString__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isNumber__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isNumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_smooth__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__container_Layer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shape_Trapezoid__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__component_LabelList__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__component_Cell__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_DataUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_ChartUtils__ = __webpack_require__(51);







function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Render sectors of a funnel
 */












var Funnel =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Funnel, _PureComponent);

  function Funnel() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Funnel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Funnel)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      isAnimationFinished: false
    };

    _this.cachePrevData = function (trapezoids) {
      _this.setState({
        prevTrapezoids: trapezoids
      });
    };

    _this.handleAnimationEnd = function () {
      var onAnimationEnd = _this.props.onAnimationEnd;

      _this.setState({
        isAnimationFinished: true
      });

      if (__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default()(onAnimationEnd)) {
        onAnimationEnd();
      }
    };

    _this.handleAnimationStart = function () {
      var onAnimationStart = _this.props.onAnimationStart;

      _this.setState({
        isAnimationFinished: false
      });

      if (__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default()(onAnimationStart)) {
        onAnimationStart();
      }
    };

    return _this;
  }

  _createClass(Funnel, [{
    key: "componentWillReceiveProps",
    // eslint-disable-next-line camelcase
    value: function componentWillReceiveProps(nextProps) {
      var _this$props = this.props,
          animationId = _this$props.animationId,
          trapezoids = _this$props.trapezoids;

      if (nextProps.isAnimationActive !== this.props.isAnimationActive) {
        this.cachePrevData([]);
      } else if (nextProps.animationId !== animationId) {
        this.cachePrevData(trapezoids);
      }
    }
  }, {
    key: "isActiveIndex",
    value: function isActiveIndex(i) {
      var activeIndex = this.props.activeIndex;

      if (Array.isArray(activeIndex)) {
        return activeIndex.indexOf(i) !== -1;
      }

      return i === activeIndex;
    }
  }, {
    key: "renderTrapezoidsStatically",
    value: function renderTrapezoidsStatically(trapezoids) {
      var _this2 = this;

      var activeShape = this.props.activeShape;
      return trapezoids.map(function (entry, i) {
        var trapezoidOptions = _this2.isActiveIndex(i) ? activeShape : null;

        var trapezoidProps = _objectSpread({}, entry, {
          stroke: entry.stroke
        });

        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__container_Layer__["a" /* default */], _extends({
          className: "recharts-funnel-trapezoid"
        }, Object(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["g" /* filterEventsOfChild */])(_this2.props, entry, i), {
          key: "trapezoid-".concat(i) // eslint-disable-line react/no-array-index-key

        }), _this2.constructor.renderTrapezoidItem(trapezoidOptions, trapezoidProps));
      });
    }
  }, {
    key: "renderTrapezoidsWithAnimation",
    value: function renderTrapezoidsWithAnimation() {
      var _this3 = this;

      var _this$props2 = this.props,
          trapezoids = _this$props2.trapezoids,
          isAnimationActive = _this$props2.isAnimationActive,
          animationBegin = _this$props2.animationBegin,
          animationDuration = _this$props2.animationDuration,
          animationEasing = _this$props2.animationEasing,
          animationId = _this$props2.animationId;
      var prevTrapezoids = this.state.prevTrapezoids;
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_smooth__["a" /* default */], {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "funnel-".concat(animationId),
        onAnimationStart: this.handleAnimationStart,
        onAnimationEnd: this.handleAnimationEnd
      }, function (_ref) {
        var t = _ref.t;
        var stepData = trapezoids.map(function (entry, index) {
          var prev = prevTrapezoids && prevTrapezoids[index];

          if (prev) {
            var _interpolatorX = Object(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["f" /* interpolateNumber */])(prev.x, entry.x);

            var _interpolatorY = Object(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["f" /* interpolateNumber */])(prev.y, entry.y);

            var _interpolatorUpperWidth = Object(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["f" /* interpolateNumber */])(prev.upperWidth, entry.upperWidth);

            var _interpolatorLowerWidth = Object(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["f" /* interpolateNumber */])(prev.lowerWidth, entry.lowerWidth);

            var _interpolatorHeight = Object(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["f" /* interpolateNumber */])(prev.height, entry.height);

            return _objectSpread({}, entry, {
              x: _interpolatorX(t),
              y: _interpolatorY(t),
              upperWidth: _interpolatorUpperWidth(t),
              lowerWidth: _interpolatorLowerWidth(t),
              height: _interpolatorHeight(t)
            });
          }

          var interpolatorX = Object(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["f" /* interpolateNumber */])(entry.x + entry.upperWidth / 2, entry.x);
          var interpolatorY = Object(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["f" /* interpolateNumber */])(entry.y + entry.height / 2, entry.y);
          var interpolatorUpperWidth = Object(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["f" /* interpolateNumber */])(0, entry.upperWidth);
          var interpolatorLowerWidth = Object(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["f" /* interpolateNumber */])(0, entry.lowerWidth);
          var interpolatorHeight = Object(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["f" /* interpolateNumber */])(0, entry.height);
          return _objectSpread({}, entry, {
            x: interpolatorX(t),
            y: interpolatorY(t),
            upperWidth: interpolatorUpperWidth(t),
            lowerWidth: interpolatorLowerWidth(t),
            height: interpolatorHeight(t)
          });
        });
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__container_Layer__["a" /* default */], null, _this3.renderTrapezoidsStatically(stepData));
      });
    }
  }, {
    key: "renderTrapezoids",
    value: function renderTrapezoids() {
      var _this$props3 = this.props,
          trapezoids = _this$props3.trapezoids,
          isAnimationActive = _this$props3.isAnimationActive;
      var prevTrapezoids = this.state.prevTrapezoids;

      if (isAnimationActive && trapezoids && trapezoids.length && (!prevTrapezoids || !__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevTrapezoids, trapezoids))) {
        return this.renderTrapezoidsWithAnimation();
      }

      return this.renderTrapezoidsStatically(trapezoids);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          hide = _this$props4.hide,
          trapezoids = _this$props4.trapezoids,
          className = _this$props4.className,
          isAnimationActive = _this$props4.isAnimationActive;
      var isAnimationFinished = this.state.isAnimationFinished;

      if (hide || !trapezoids || !trapezoids.length) {
        return null;
      }

      var layerClass = __WEBPACK_IMPORTED_MODULE_9_classnames___default()('recharts-trapezoids', className);
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__container_Layer__["a" /* default */], {
        className: layerClass
      }, this.renderTrapezoids(), (!isAnimationActive || isAnimationFinished) && __WEBPACK_IMPORTED_MODULE_12__component_LabelList__["a" /* default */].renderCallByParent(this.props, trapezoids));
    }
  }], [{
    key: "renderTrapezoidItem",
    value: function renderTrapezoidItem(option, props) {
      if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(option)) {
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(option, props);
      }

      if (__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default()(option)) {
        return option(props);
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash_isPlainObject___default()(option)) {
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shape_Trapezoid__["a" /* default */], _extends({}, props, option));
      }

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shape_Trapezoid__["a" /* default */], props);
    }
  }]);

  return Funnel;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

Funnel.displayName = 'Funnel';
Funnel.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {}, __WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["a" /* EVENT_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  animationId: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  dataKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func]).isRequired,
  nameKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func]),
  data: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object),
  trapezoids: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object),
  hide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  activeShape: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.element]),
  legendType: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["b" /* LEGEND_TYPES */]),
  tooltipType: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["e" /* TOOLTIP_TYPES */]),
  activeIndex: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number)]),
  onAnimationStart: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onAnimationEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  isAnimationActive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  animationBegin: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'spring', 'linear'])
});
Funnel.defaultProps = {
  stroke: '#fff',
  fill: '#808080',
  legendType: 'rect',
  labelLine: true,
  hide: false,
  isAnimationActive: !Object(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["o" /* isSsr */])(),
  animationBegin: 400,
  animationDuration: 1500,
  animationEasing: 'ease',
  nameKey: 'name'
};

Funnel.getRealFunnelData = function (item) {
  var _item$props = item.props,
      data = _item$props.data,
      children = _item$props.children;
  var presentationProps = Object(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["l" /* getPresentationAttributes */])(item.props);
  var cells = Object(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["i" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_13__component_Cell__["a" /* default */]);

  if (data && data.length) {
    return data.map(function (entry, index) {
      return _objectSpread({
        payload: entry
      }, presentationProps, {}, entry, {}, cells && cells[index] && cells[index].props);
    });
  }

  if (cells && cells.length) {
    return cells.map(function (cell) {
      return _objectSpread({}, presentationProps, {}, cell.props);
    });
  }

  return [];
};

Funnel.getRealWidthHeight = function (item, offset) {
  var customWidth = item.props.width;
  var width = offset.width,
      height = offset.height,
      left = offset.left,
      right = offset.right,
      top = offset.top,
      bottom = offset.bottom;
  var realHeight = height;
  var realWidth = width;

  if (__WEBPACK_IMPORTED_MODULE_5_lodash_isNumber___default()(customWidth)) {
    realWidth = customWidth;
  } else if (__WEBPACK_IMPORTED_MODULE_4_lodash_isString___default()(customWidth)) {
    realWidth = realWidth * parseFloat(customWidth) / 100;
  }

  return {
    realWidth: realWidth - left - right - 50,
    realHeight: realHeight - bottom - top,
    offsetX: (width - realWidth) / 2,
    offsetY: (height - realHeight) / 2
  };
};

Funnel.getComposedData = function (_ref2) {
  var item = _ref2.item,
      offset = _ref2.offset,
      onItemMouseLeave = _ref2.onItemMouseLeave,
      onItemMouseEnter = _ref2.onItemMouseEnter;
  var funnelData = Funnel.getRealFunnelData(item);
  var _item$props2 = item.props,
      dataKey = _item$props2.dataKey,
      nameKey = _item$props2.nameKey,
      tooltipType = _item$props2.tooltipType;
  var left = offset.left,
      top = offset.top;

  var _Funnel$getRealWidthH = Funnel.getRealWidthHeight(item, offset),
      realHeight = _Funnel$getRealWidthH.realHeight,
      realWidth = _Funnel$getRealWidthH.realWidth,
      offsetX = _Funnel$getRealWidthH.offsetX,
      offsetY = _Funnel$getRealWidthH.offsetY;

  var maxValue = Object(__WEBPACK_IMPORTED_MODULE_16__util_ChartUtils__["v" /* getValueByDataKey */])(funnelData[0], dataKey, 0);
  var len = funnelData.length;
  var rowHeight = realHeight / len;
  var trapezoids = funnelData.map(function (entry, i) {
    var val = Object(__WEBPACK_IMPORTED_MODULE_16__util_ChartUtils__["v" /* getValueByDataKey */])(entry, dataKey, 0);
    var name = Object(__WEBPACK_IMPORTED_MODULE_16__util_ChartUtils__["v" /* getValueByDataKey */])(entry, nameKey, i);
    var nextVal = 0;

    if (i !== len - 1) {
      nextVal = Object(__WEBPACK_IMPORTED_MODULE_16__util_ChartUtils__["v" /* getValueByDataKey */])(funnelData[i + 1], dataKey, 0);
    }

    var x = (maxValue - val) * realWidth / (2 * maxValue) + top + 25 + offsetX;
    var y = realHeight / len * i + left + offsetY;
    var upperWidth = val / maxValue * realWidth;
    var lowerWidth = nextVal / maxValue * realWidth;
    var tooltipPayload = [{
      name: name,
      value: val,
      payload: entry,
      dataKey: dataKey,
      type: tooltipType
    }];
    var tooltipPosition = {
      x: x + upperWidth / 2,
      y: y + rowHeight / 2
    };
    return _objectSpread({
      x: x,
      y: y,
      width: Math.max(upperWidth, lowerWidth),
      upperWidth: upperWidth,
      lowerWidth: lowerWidth,
      height: rowHeight,
      name: name,
      val: val,
      tooltipPayload: tooltipPayload,
      tooltipPosition: tooltipPosition
    }, __WEBPACK_IMPORTED_MODULE_3_lodash_omit___default()(entry, 'width'), {
      payload: entry
    });
  });
  return {
    trapezoids: trapezoids,
    data: funnelData,
    onMouseLeave: onItemMouseLeave,
    onMouseEnter: onItemMouseEnter
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Funnel);

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_smooth__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__ = __webpack_require__(12);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Rectangle
 */






var getTrapezoidPath = function getTrapezoidPath(x, y, upperWidth, lowerWidth, height) {
  var widthGap = upperWidth - lowerWidth;
  var path;
  path = "M ".concat(x, ",").concat(y);
  path += "L ".concat(x + upperWidth, ",").concat(y);
  path += "L ".concat(x + upperWidth - widthGap / 2, ",").concat(y + height);
  path += "L ".concat(x + upperWidth - widthGap / 2 - lowerWidth, ",").concat(y + height);
  path += "L ".concat(x, ",").concat(y, " Z");
  return path;
};

var Trapezoid =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Trapezoid, _PureComponent);

  function Trapezoid() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Trapezoid);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Trapezoid)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      totalLength: -1
    };
    return _this;
  }

  _createClass(Trapezoid, [{
    key: "componentDidMount",

    /* eslint-disable  react/no-did-mount-set-state */
    value: function componentDidMount() {
      if (this.node && this.node.getTotalLength) {
        try {
          var totalLength = this.node.getTotalLength();

          if (totalLength) {
            this.setState({
              totalLength: totalLength
            });
          }
        } catch (err) {// calculate total length error
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          x = _this$props.x,
          y = _this$props.y,
          upperWidth = _this$props.upperWidth,
          lowerWidth = _this$props.lowerWidth,
          height = _this$props.height,
          className = _this$props.className;
      var totalLength = this.state.totalLength;
      var _this$props2 = this.props,
          animationEasing = _this$props2.animationEasing,
          animationDuration = _this$props2.animationDuration,
          animationBegin = _this$props2.animationBegin,
          isUpdateAnimationActive = _this$props2.isUpdateAnimationActive;

      if (x !== +x || y !== +y || upperWidth !== +upperWidth || lowerWidth !== +lowerWidth || height !== +height || upperWidth === 0 && lowerWidth === 0 || height === 0) {
        return null;
      }

      var layerClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('recharts-trapezoid', className);

      if (!isUpdateAnimationActive) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", _extends({}, Object(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["l" /* getPresentationAttributes */])(this.props), Object(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["f" /* filterEventAttributes */])(this.props), {
          className: layerClass,
          d: getTrapezoidPath(x, y, upperWidth, lowerWidth, height)
        })));
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_smooth__["a" /* default */], {
        canBegin: totalLength > 0,
        from: {
          upperWidth: 0,
          lowerWidth: 0,
          height: height,
          x: x,
          y: y
        },
        to: {
          upperWidth: upperWidth,
          lowerWidth: lowerWidth,
          height: height,
          x: x,
          y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
      }, function (_ref) {
        var currUpperWidth = _ref.upperWidth,
            currLowerWidth = _ref.lowerWidth,
            currHeight = _ref.height,
            currX = _ref.x,
            currY = _ref.y;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_smooth__["a" /* default */], {
          canBegin: totalLength > 0,
          from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
          to: "".concat(totalLength, "px 0px"),
          attributeName: "strokeDasharray",
          begin: animationBegin,
          duration: animationDuration,
          easing: animationEasing
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", _extends({}, Object(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["l" /* getPresentationAttributes */])(_this2.props), Object(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["f" /* filterEventAttributes */])(_this2.props), {
          className: layerClass,
          d: getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
          ref: function ref(node) {
            _this2.node = node;
          }
        })));
      });
    }
  }]);

  return Trapezoid;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Trapezoid.displayName = 'Trapezoid';
Trapezoid.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {}, __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["a" /* EVENT_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  x: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  y: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  upperWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  lowerWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  isUpdateAnimationActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  animationBegin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
});
Trapezoid.defaultProps = {
  x: 0,
  y: 0,
  upperWidth: 0,
  lowerWidth: 0,
  height: 0,
  isUpdateAnimationActive: false,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease'
};
/* harmony default export */ __webpack_exports__["a"] = (Trapezoid);

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(118);
var core = __webpack_require__(61);
var fails = __webpack_require__(185);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 791 */
/***/ (function(module, exports) {

module.exports = function(arr, obj){
  if (arr.indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util = {
  isAppearSupported: function isAppearSupported(props) {
    return props.transitionName && props.transitionAppear || props.animation.appear;
  },
  isEnterSupported: function isEnterSupported(props) {
    return props.transitionName && props.transitionEnter || props.animation.enter;
  },
  isLeaveSupported: function isLeaveSupported(props) {
    return props.transitionName && props.transitionLeave || props.animation.leave;
  },
  allowAppearCallback: function allowAppearCallback(props) {
    return props.transitionAppear || props.animation.appear;
  },
  allowEnterCallback: function allowEnterCallback(props) {
    return props.transitionEnter || props.animation.enter;
  },
  allowLeaveCallback: function allowLeaveCallback(props) {
    return props.transitionLeave || props.animation.leave;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contains;
function contains(root, n) {
  var node = n;
  while (node) {
    if (node === root) {
      return true;
    }
    node = node.parentNode;
  }

  return false;
}

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAlignFromPlacement;
/* harmony export (immutable) */ __webpack_exports__["b"] = getAlignPopupClassName;
/* harmony export (immutable) */ __webpack_exports__["c"] = saveRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function isPointsEq(a1, a2, isAlignPoint) {
  if (isAlignPoint) {
    return a1[0] === a2[0];
  }
  return a1[0] === a2[0] && a1[1] === a2[1];
}

function getAlignFromPlacement(builtinPlacements, placementStr, align) {
  var baseAlign = builtinPlacements[placementStr] || {};
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, baseAlign, align);
}

function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
  var points = align.points;
  for (var placement in builtinPlacements) {
    if (builtinPlacements.hasOwnProperty(placement)) {
      if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
        return prefixCls + '-placement-' + placement;
      }
    }
  }
  return '';
}

function saveRef(name, component) {
  this[name] = component;
}

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getVisibleRectForElement__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__adjustForViewport__ = __webpack_require__(1754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getRegion__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getElFuturePos__ = __webpack_require__(1755);
/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */







// http://yiminghe.iteye.com/blog/1124720

function isFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}

function isFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}

function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}

function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}

function flip(points, reg, map) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].each(points, function (p) {
    ret.push(p.replace(reg, function (m) {
      return map[m];
    }));
  });
  return ret;
}

function flipOffset(offset, index) {
  offset[index] = -offset[index];
  return offset;
}

function convertOffset(str, offsetLen) {
  var n = void 0;
  if (/%$/.test(str)) {
    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
  } else {
    n = parseInt(str, 10);
  }
  return n || 0;
}

function normalizeOffset(offset, el) {
  offset[0] = convertOffset(offset[0], el.width);
  offset[1] = convertOffset(offset[1], el.height);
}

/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */
function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
  var points = align.points;
  var offset = align.offset || [0, 0];
  var targetOffset = align.targetOffset || [0, 0];
  var overflow = align.overflow;
  var source = align.source || el;
  offset = [].concat(offset);
  targetOffset = [].concat(targetOffset);
  overflow = overflow || {};
  var newOverflowCfg = {};
  var fail = 0;
  // 当前节点可以被放置的显示区域
  var visibleRect = Object(__WEBPACK_IMPORTED_MODULE_1__getVisibleRectForElement__["a" /* default */])(source);
  // 当前节点所占的区域, left/top/width/height
  var elRegion = Object(__WEBPACK_IMPORTED_MODULE_3__getRegion__["a" /* default */])(source);
  // 将 offset 转换成数值，支持百分比
  normalizeOffset(offset, elRegion);
  normalizeOffset(targetOffset, tgtRegion);
  // 当前节点将要被放置的位置
  var elFuturePos = Object(__WEBPACK_IMPORTED_MODULE_4__getElFuturePos__["a" /* default */])(elRegion, tgtRegion, points, offset, targetOffset);
  // 当前节点将要所处的区域
  var newElRegion = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].merge(elRegion, elFuturePos);

  // 如果可视区域不能完全放置当前节点时允许调整
  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
    if (overflow.adjustX) {
      // 如果横向不能放下
      if (isFailX(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var newPoints = flip(points, /[lr]/ig, {
          l: 'r',
          r: 'l'
        });
        // 偏移量也反下
        var newOffset = flipOffset(offset, 0);
        var newTargetOffset = flipOffset(targetOffset, 0);
        var newElFuturePos = Object(__WEBPACK_IMPORTED_MODULE_4__getElFuturePos__["a" /* default */])(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);

        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = newPoints;
          offset = newOffset;
          targetOffset = newTargetOffset;
        }
      }
    }

    if (overflow.adjustY) {
      // 如果纵向不能放下
      if (isFailY(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var _newPoints = flip(points, /[tb]/ig, {
          t: 'b',
          b: 't'
        });
        // 偏移量也反下
        var _newOffset = flipOffset(offset, 1);
        var _newTargetOffset = flipOffset(targetOffset, 1);
        var _newElFuturePos = Object(__WEBPACK_IMPORTED_MODULE_4__getElFuturePos__["a" /* default */])(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);

        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = _newPoints;
          offset = _newOffset;
          targetOffset = _newTargetOffset;
        }
      }
    }

    // 如果失败，重新计算当前节点将要被放置的位置
    if (fail) {
      elFuturePos = Object(__WEBPACK_IMPORTED_MODULE_4__getElFuturePos__["a" /* default */])(elRegion, tgtRegion, points, offset, targetOffset);
      __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].mix(newElRegion, elFuturePos);
    }
    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect);
    // 检查反下后的位置是否可以放下了，如果仍然放不下：
    // 1. 复原修改过的定位参数
    if (isStillFailX || isStillFailY) {
      points = align.points;
      offset = align.offset || [0, 0];
      targetOffset = align.targetOffset || [0, 0];
    }
    // 2. 只有指定了可以调整当前方向才调整
    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;

    // 确实要调整，甚至可能会调整高度宽度
    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
      newElRegion = Object(__WEBPACK_IMPORTED_MODULE_2__adjustForViewport__["a" /* default */])(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
  }

  // need judge to in case set fixed with in css on height auto element
  if (newElRegion.width !== elRegion.width) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(source, 'width', __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].width(source) + newElRegion.width - elRegion.width);
  }

  if (newElRegion.height !== elRegion.height) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(source, 'height', __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].height(source) + newElRegion.height - elRegion.height);
  }

  // https://github.com/kissyteam/kissy/issues/190
  // 相对于屏幕位置没变，而 left/top 变了
  // 例如 <div 'relative'><el absolute></div>
  __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].offset(source, {
    left: newElRegion.left,
    top: newElRegion.top
  }, {
    useCssRight: align.useCssRight,
    useCssBottom: align.useCssBottom,
    useCssTransform: align.useCssTransform,
    ignoreShake: align.ignoreShake
  });

  return {
    points: points,
    offset: offset,
    targetOffset: targetOffset,
    overflow: newOverflowCfg
  };
}

/* harmony default export */ __webpack_exports__["a"] = (doAlign);
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getOffsetParent__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isAncestorFixed__ = __webpack_require__(1753);




/**
 * 获得元素的显示部分的区域
 */
function getVisibleRectForElement(element) {
  var visibleRect = {
    left: 0,
    right: Infinity,
    top: 0,
    bottom: Infinity
  };
  var el = Object(__WEBPACK_IMPORTED_MODULE_1__getOffsetParent__["a" /* default */])(element);
  var doc = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getDocument(element);
  var win = doc.defaultView || doc.parentWindow;
  var body = doc.body;
  var documentElement = doc.documentElement;

  // Determine the size of the visible rect by climbing the dom accounting for
  // all scrollable containers.
  while (el) {
    // clientWidth is zero for inline block elements in ie.
    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) &&
    // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    el !== body && el !== documentElement && __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(el, 'overflow') !== 'visible') {
      var pos = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].offset(el);
      // add border
      pos.left += el.clientLeft;
      pos.top += el.clientTop;
      visibleRect.top = Math.max(visibleRect.top, pos.top);
      visibleRect.right = Math.min(visibleRect.right,
      // consider area without scrollBar
      pos.left + el.clientWidth);
      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
      visibleRect.left = Math.max(visibleRect.left, pos.left);
    } else if (el === body || el === documentElement) {
      break;
    }
    el = Object(__WEBPACK_IMPORTED_MODULE_1__getOffsetParent__["a" /* default */])(el);
  }

  // Set element position to fixed
  // make sure absolute element itself don't affect it's visible area
  // https://github.com/ant-design/ant-design/issues/7601
  var originalPosition = null;
  if (!__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].isWindow(element) && element.nodeType !== 9) {
    originalPosition = element.style.position;
    var position = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(element, 'position');
    if (position === 'absolute') {
      element.style.position = 'fixed';
    }
  }

  var scrollX = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollLeft(win);
  var scrollY = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollTop(win);
  var viewportWidth = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportWidth(win);
  var viewportHeight = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportHeight(win);
  var documentWidth = documentElement.scrollWidth;
  var documentHeight = documentElement.scrollHeight;

  // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
  // We should cut this ourself.
  var bodyStyle = window.getComputedStyle(body);
  if (bodyStyle.overflowX === 'hidden') {
    documentWidth = win.innerWidth;
  }
  if (bodyStyle.overflowY === 'hidden') {
    documentHeight = win.innerHeight;
  }

  // Reset element position after calculate the visible area
  if (element.style) {
    element.style.position = originalPosition;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_2__isAncestorFixed__["a" /* default */])(element)) {
    // Clip by viewport's size.
    visibleRect.left = Math.max(visibleRect.left, scrollX);
    visibleRect.top = Math.max(visibleRect.top, scrollY);
    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
  } else {
    // Clip by document's size.
    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);

    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
  }

  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}

/* harmony default export */ __webpack_exports__["a"] = (getVisibleRectForElement);

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(155);


/**
 * 得到会导致元素显示不全的祖先元素
 */

function getOffsetParent(element) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].isWindow(element) || element.nodeType === 9) {
    return null;
  }
  // ie 这个也不是完全可行
  /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */
  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
  //  In other browsers it only includes elements with position absolute, relative or
  // fixed, not elements with overflow set to auto or scroll.
  //        if (UA.ie && ieMode < 8) {
  //            return element.offsetParent;
  //        }
  // 统一的 offsetParent 方法
  var doc = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getDocument(element);
  var body = doc.body;
  var parent = void 0;
  var positionStyle = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(element, 'position');
  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';

  if (!skipStatic) {
    return element.nodeName.toLowerCase() === 'html' ? null : element.parentNode;
  }

  for (parent = element.parentNode; parent && parent !== body; parent = parent.parentNode) {
    positionStyle = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(parent, 'position');
    if (positionStyle !== 'static') {
      return parent;
    }
  }
  return null;
}

/* harmony default export */ __webpack_exports__["a"] = (getOffsetParent);

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(155);


function getRegion(node) {
  var offset = void 0;
  var w = void 0;
  var h = void 0;
  if (!__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].isWindow(node) && node.nodeType !== 9) {
    offset = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].offset(node);
    w = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].outerWidth(node);
    h = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].outerHeight(node);
  } else {
    var win = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindow(node);
    offset = {
      left: __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollLeft(win),
      top: __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollTop(win)
    };
    w = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportWidth(win);
    h = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportHeight(win);
  }
  offset.width = w;
  offset.height = h;
  return offset;
}

/* harmony default export */ __webpack_exports__["a"] = (getRegion);

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var LazyRenderBox = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(LazyRenderBox, _Component);

  function LazyRenderBox() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LazyRenderBox);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return nextProps.hiddenClassName || nextProps.visible;
  };

  LazyRenderBox.prototype.render = function render() {
    var _props = this.props,
        hiddenClassName = _props.hiddenClassName,
        visible = _props.visible,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['hiddenClassName', 'visible']);

    if (hiddenClassName || __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.count(props.children) > 1) {
      if (!visible && hiddenClassName) {
        props.className += ' ' + hiddenClassName;
      }
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', props);
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(props.children);
  };

  return LazyRenderBox;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

LazyRenderBox.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (LazyRenderBox);

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModifiersUtils = exports.LocaleUtils = exports.DateUtils = exports.DayPicker = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Caption = __webpack_require__(1760);

var _Caption2 = _interopRequireDefault(_Caption);

var _Navbar = __webpack_require__(801);

var _Navbar2 = _interopRequireDefault(_Navbar);

var _Month = __webpack_require__(1761);

var _Month2 = _interopRequireDefault(_Month);

var _Weekday = __webpack_require__(802);

var _Weekday2 = _interopRequireDefault(_Weekday);

var _Helpers = __webpack_require__(298);

var Helpers = _interopRequireWildcard(_Helpers);

var _DateUtils = __webpack_require__(156);

var DateUtils = _interopRequireWildcard(_DateUtils);

var _LocaleUtils = __webpack_require__(296);

var LocaleUtils = _interopRequireWildcard(_LocaleUtils);

var _ModifiersUtils = __webpack_require__(299);

var ModifiersUtils = _interopRequireWildcard(_ModifiersUtils);

var _classNames = __webpack_require__(297);

var _classNames2 = _interopRequireDefault(_classNames);

var _keys = __webpack_require__(226);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DayPicker = exports.DayPicker = function (_Component) {
  _inherits(DayPicker, _Component);

  function DayPicker(props) {
    _classCallCheck(this, DayPicker);

    var _this = _possibleConstructorReturn(this, (DayPicker.__proto__ || Object.getPrototypeOf(DayPicker)).call(this, props));

    _this.dayPicker = null;

    _this.showNextMonth = function (callback) {
      if (!_this.allowNextMonth()) {
        return;
      }
      var deltaMonths = _this.props.pagedNavigation ? _this.props.numberOfMonths : 1;
      var nextMonth = DateUtils.addMonths(_this.state.currentMonth, deltaMonths);
      _this.showMonth(nextMonth, callback);
    };

    _this.showPreviousMonth = function (callback) {
      if (!_this.allowPreviousMonth()) {
        return;
      }
      var deltaMonths = _this.props.pagedNavigation ? _this.props.numberOfMonths : 1;
      var previousMonth = DateUtils.addMonths(_this.state.currentMonth, -deltaMonths);
      _this.showMonth(previousMonth, callback);
    };

    _this.handleKeyDown = function (e) {
      e.persist();

      switch (e.keyCode) {
        case _keys.LEFT:
          if (_this.props.dir === 'rtl') {
            _this.showNextMonth();
          } else {
            _this.showPreviousMonth();
          }
          Helpers.cancelEvent(e);
          break;
        case _keys.RIGHT:
          if (_this.props.dir === 'rtl') {
            _this.showPreviousMonth();
          } else {
            _this.showNextMonth();
          }
          Helpers.cancelEvent(e);
          break;
        case _keys.UP:
          _this.showPreviousYear();
          Helpers.cancelEvent(e);
          break;
        case _keys.DOWN:
          _this.showNextYear();
          Helpers.cancelEvent(e);
          break;
        default:
          break;
      }

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(e);
      }
    };

    _this.handleDayKeyDown = function (day, modifiers, e) {
      e.persist();

      switch (e.keyCode) {
        case _keys.LEFT:
          Helpers.cancelEvent(e);
          if (_this.props.dir === 'rtl') {
            _this.focusNextDay(e.target);
          } else {
            _this.focusPreviousDay(e.target);
          }
          break;
        case _keys.RIGHT:
          Helpers.cancelEvent(e);
          if (_this.props.dir === 'rtl') {
            _this.focusPreviousDay(e.target);
          } else {
            _this.focusNextDay(e.target);
          }
          break;
        case _keys.UP:
          Helpers.cancelEvent(e);
          _this.focusPreviousWeek(e.target);
          break;
        case _keys.DOWN:
          Helpers.cancelEvent(e);
          _this.focusNextWeek(e.target);
          break;
        case _keys.ENTER:
        case _keys.SPACE:
          Helpers.cancelEvent(e);
          if (_this.props.onDayClick) {
            _this.handleDayClick(day, modifiers, e);
          }
          break;
        default:
          break;
      }
      if (_this.props.onDayKeyDown) {
        _this.props.onDayKeyDown(day, modifiers, e);
      }
    };

    _this.handleDayClick = function (day, modifiers, e) {
      e.persist();

      if (modifiers[_this.props.classNames.outside] && _this.props.enableOutsideDaysClick) {
        _this.handleOutsideDayClick(day);
      }
      if (_this.props.onDayClick) {
        _this.props.onDayClick(day, modifiers, e);
      }
    };

    _this.handleTodayButtonClick = function (e) {
      var today = new Date();
      var month = new Date(today.getFullYear(), today.getMonth());
      _this.showMonth(month);
      e.target.blur();
      if (_this.props.onTodayButtonClick) {
        e.persist();
        _this.props.onTodayButtonClick(new Date(today.getFullYear(), today.getMonth(), today.getDate()), ModifiersUtils.getModifiersForDay(today, _this.props.modifiers), e);
      }
    };

    var currentMonth = _this.getCurrentMonthFromProps(props);
    _this.state = { currentMonth: currentMonth };
    return _this;
  }

  _createClass(DayPicker, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      // Changing the `month` props means changing the current displayed month
      if (prevProps.month !== this.props.month && !DateUtils.isSameMonth(prevProps.month, this.props.month)) {
        var currentMonth = this.getCurrentMonthFromProps(this.props);
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ currentMonth: currentMonth });
      }
    }

    /**
     * Return the month to be shown in the calendar based on the component props.
     *
     * @param {Object} props
     * @returns Date
     * @memberof DayPicker
     * @private
     */

  }, {
    key: 'getCurrentMonthFromProps',
    value: function getCurrentMonthFromProps(props) {
      var initialMonth = Helpers.startOfMonth(props.month || props.initialMonth);
      var currentMonth = initialMonth;

      if (props.pagedNavigation && props.numberOfMonths > 1 && props.fromMonth) {
        var fromMonth = Helpers.startOfMonth(props.fromMonth);
        var diffInMonths = Helpers.getMonthsDiff(fromMonth, currentMonth);
        currentMonth = DateUtils.addMonths(fromMonth, Math.floor(diffInMonths / props.numberOfMonths) * props.numberOfMonths);
      } else if (props.toMonth && props.numberOfMonths > 1 && Helpers.getMonthsDiff(currentMonth, props.toMonth) <= 0) {
        currentMonth = DateUtils.addMonths(Helpers.startOfMonth(props.toMonth), 1 - this.props.numberOfMonths);
      }
      return currentMonth;
    }
  }, {
    key: 'getNextNavigableMonth',
    value: function getNextNavigableMonth() {
      return DateUtils.addMonths(this.state.currentMonth, this.props.numberOfMonths);
    }
  }, {
    key: 'getPreviousNavigableMonth',
    value: function getPreviousNavigableMonth() {
      return DateUtils.addMonths(this.state.currentMonth, -1);
    }
  }, {
    key: 'allowPreviousMonth',
    value: function allowPreviousMonth() {
      var previousMonth = DateUtils.addMonths(this.state.currentMonth, -1);
      return this.allowMonth(previousMonth);
    }
  }, {
    key: 'allowNextMonth',
    value: function allowNextMonth() {
      var nextMonth = DateUtils.addMonths(this.state.currentMonth, this.props.numberOfMonths);
      return this.allowMonth(nextMonth);
    }
  }, {
    key: 'allowMonth',
    value: function allowMonth(d) {
      var _props = this.props,
          fromMonth = _props.fromMonth,
          toMonth = _props.toMonth,
          canChangeMonth = _props.canChangeMonth;

      if (!canChangeMonth || fromMonth && Helpers.getMonthsDiff(fromMonth, d) < 0 || toMonth && Helpers.getMonthsDiff(toMonth, d) > 0) {
        return false;
      }
      return true;
    }
  }, {
    key: 'allowYearChange',
    value: function allowYearChange() {
      return this.props.canChangeMonth;
    }
  }, {
    key: 'showMonth',
    value: function showMonth(d, callback) {
      var _this2 = this;

      if (!this.allowMonth(d)) {
        return;
      }
      this.setState({ currentMonth: Helpers.startOfMonth(d) }, function () {
        if (callback) {
          callback();
        }
        if (_this2.props.onMonthChange) {
          _this2.props.onMonthChange(_this2.state.currentMonth);
        }
      });
    }
  }, {
    key: 'showNextYear',
    value: function showNextYear() {
      if (!this.allowYearChange()) {
        return;
      }
      var nextMonth = DateUtils.addMonths(this.state.currentMonth, 12);
      this.showMonth(nextMonth);
    }
  }, {
    key: 'showPreviousYear',
    value: function showPreviousYear() {
      if (!this.allowYearChange()) {
        return;
      }
      var nextMonth = DateUtils.addMonths(this.state.currentMonth, -12);
      this.showMonth(nextMonth);
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.wrapper.focus();
    }
  }, {
    key: 'focusFirstDayOfMonth',
    value: function focusFirstDayOfMonth() {
      Helpers.getDayNodes(this.dayPicker, this.props.classNames)[0].focus();
    }
  }, {
    key: 'focusLastDayOfMonth',
    value: function focusLastDayOfMonth() {
      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      dayNodes[dayNodes.length - 1].focus();
    }
  }, {
    key: 'focusPreviousDay',
    value: function focusPreviousDay(dayNode) {
      var _this3 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
      if (dayNodeIndex === -1) return;
      if (dayNodeIndex === 0) {
        this.showPreviousMonth(function () {
          return _this3.focusLastDayOfMonth();
        });
      } else {
        dayNodes[dayNodeIndex - 1].focus();
      }
    }
  }, {
    key: 'focusNextDay',
    value: function focusNextDay(dayNode) {
      var _this4 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
      if (dayNodeIndex === -1) return;
      if (dayNodeIndex === dayNodes.length - 1) {
        this.showNextMonth(function () {
          return _this4.focusFirstDayOfMonth();
        });
      } else {
        dayNodes[dayNodeIndex + 1].focus();
      }
    }
  }, {
    key: 'focusNextWeek',
    value: function focusNextWeek(dayNode) {
      var _this5 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
      var isInLastWeekOfMonth = dayNodeIndex > dayNodes.length - 8;

      if (isInLastWeekOfMonth) {
        this.showNextMonth(function () {
          var daysAfterIndex = dayNodes.length - dayNodeIndex;
          var nextMonthDayNodeIndex = 7 - daysAfterIndex;
          Helpers.getDayNodes(_this5.dayPicker, _this5.props.classNames)[nextMonthDayNodeIndex].focus();
        });
      } else {
        dayNodes[dayNodeIndex + 7].focus();
      }
    }
  }, {
    key: 'focusPreviousWeek',
    value: function focusPreviousWeek(dayNode) {
      var _this6 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
      var isInFirstWeekOfMonth = dayNodeIndex <= 6;

      if (isInFirstWeekOfMonth) {
        this.showPreviousMonth(function () {
          var previousMonthDayNodes = Helpers.getDayNodes(_this6.dayPicker, _this6.props.classNames);
          var startOfLastWeekOfMonth = previousMonthDayNodes.length - 7;
          var previousMonthDayNodeIndex = startOfLastWeekOfMonth + dayNodeIndex;
          previousMonthDayNodes[previousMonthDayNodeIndex].focus();
        });
      } else {
        dayNodes[dayNodeIndex - 7].focus();
      }
    }

    // Event handlers

  }, {
    key: 'handleOutsideDayClick',
    value: function handleOutsideDayClick(day) {
      var currentMonth = this.state.currentMonth;
      var numberOfMonths = this.props.numberOfMonths;

      var diffInMonths = Helpers.getMonthsDiff(currentMonth, day);
      if (diffInMonths > 0 && diffInMonths >= numberOfMonths) {
        this.showNextMonth();
      } else if (diffInMonths < 0) {
        this.showPreviousMonth();
      }
    }
  }, {
    key: 'renderNavbar',
    value: function renderNavbar() {
      var _props2 = this.props,
          labels = _props2.labels,
          locale = _props2.locale,
          localeUtils = _props2.localeUtils,
          canChangeMonth = _props2.canChangeMonth,
          navbarElement = _props2.navbarElement,
          attributes = _objectWithoutProperties(_props2, ['labels', 'locale', 'localeUtils', 'canChangeMonth', 'navbarElement']);

      if (!canChangeMonth) return null;

      var props = {
        month: this.state.currentMonth,
        classNames: this.props.classNames,
        className: this.props.classNames.navBar,
        nextMonth: this.getNextNavigableMonth(),
        previousMonth: this.getPreviousNavigableMonth(),
        showPreviousButton: this.allowPreviousMonth(),
        showNextButton: this.allowNextMonth(),
        onNextClick: this.showNextMonth,
        onPreviousClick: this.showPreviousMonth,
        dir: attributes.dir,
        labels: labels,
        locale: locale,
        localeUtils: localeUtils
      };
      return _react2.default.isValidElement(navbarElement) ? _react2.default.cloneElement(navbarElement, props) : _react2.default.createElement(navbarElement, props);
    }
  }, {
    key: 'renderMonths',
    value: function renderMonths() {
      var months = [];
      var firstDayOfWeek = Helpers.getFirstDayOfWeekFromProps(this.props);
      for (var i = 0; i < this.props.numberOfMonths; i += 1) {
        var month = DateUtils.addMonths(this.state.currentMonth, i);
        months.push(_react2.default.createElement(_Month2.default, _extends({
          key: i
        }, this.props, {
          month: month,
          firstDayOfWeek: firstDayOfWeek,
          onDayKeyDown: this.handleDayKeyDown,
          onDayClick: this.handleDayClick
        })));
      }

      if (this.props.reverseMonths) {
        months.reverse();
      }
      return months;
    }
  }, {
    key: 'renderFooter',
    value: function renderFooter() {
      if (this.props.todayButton) {
        return _react2.default.createElement(
          'div',
          { className: this.props.classNames.footer },
          this.renderTodayButton()
        );
      }
      return null;
    }
  }, {
    key: 'renderTodayButton',
    value: function renderTodayButton() {
      return _react2.default.createElement(
        'button',
        {
          type: 'button',
          tabIndex: 0,
          className: this.props.classNames.todayButton,
          'aria-label': this.props.todayButton,
          onClick: this.handleTodayButtonClick
        },
        this.props.todayButton
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      var className = this.props.classNames.container;

      if (!this.props.onDayClick) {
        className = className + ' ' + this.props.classNames.interactionDisabled;
      }
      if (this.props.className) {
        className = className + ' ' + this.props.className;
      }
      return _react2.default.createElement(
        'div',
        _extends({}, this.props.containerProps, {
          className: className,
          ref: function ref(el) {
            return _this7.dayPicker = el;
          },
          lang: this.props.locale
        }),
        _react2.default.createElement(
          'div',
          {
            className: this.props.classNames.wrapper,
            ref: function ref(el) {
              return _this7.wrapper = el;
            },
            tabIndex: this.props.canChangeMonth && typeof this.props.tabIndex !== 'undefined' ? this.props.tabIndex : -1,
            onKeyDown: this.handleKeyDown,
            onFocus: this.props.onFocus,
            onBlur: this.props.onBlur
          },
          this.renderNavbar(),
          _react2.default.createElement(
            'div',
            { className: this.props.classNames.months },
            this.renderMonths()
          ),
          this.renderFooter()
        )
      );
    }
  }]);

  return DayPicker;
}(_react.Component);

DayPicker.VERSION = '7.4.0';
DayPicker.propTypes = {
  // Rendering months
  initialMonth: _propTypes2.default.instanceOf(Date),
  month: _propTypes2.default.instanceOf(Date),
  numberOfMonths: _propTypes2.default.number,
  fromMonth: _propTypes2.default.instanceOf(Date),
  toMonth: _propTypes2.default.instanceOf(Date),
  canChangeMonth: _propTypes2.default.bool,
  reverseMonths: _propTypes2.default.bool,
  pagedNavigation: _propTypes2.default.bool,
  todayButton: _propTypes2.default.string,
  showWeekNumbers: _propTypes2.default.bool,
  showWeekDays: _propTypes2.default.bool,

  // Modifiers
  selectedDays: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.array]),
  disabledDays: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.array]),

  modifiers: _propTypes2.default.object,
  modifiersStyles: _propTypes2.default.object,

  // Localization
  dir: _propTypes2.default.string,
  firstDayOfWeek: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5, 6]),
  labels: _propTypes2.default.shape({
    nextMonth: _propTypes2.default.string.isRequired,
    previousMonth: _propTypes2.default.string.isRequired
  }),
  locale: _propTypes2.default.string,
  localeUtils: _propTypes2.default.shape({
    formatMonthTitle: _propTypes2.default.func,
    formatWeekdayShort: _propTypes2.default.func,
    formatWeekdayLong: _propTypes2.default.func,
    getFirstDayOfWeek: _propTypes2.default.func
  }),
  months: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),

  // Customization
  showOutsideDays: _propTypes2.default.bool,
  enableOutsideDaysClick: _propTypes2.default.bool,
  fixedWeeks: _propTypes2.default.bool,

  // CSS and HTML
  classNames: _propTypes2.default.shape({
    body: _propTypes2.default.string,
    container: _propTypes2.default.string,
    day: _propTypes2.default.string.isRequired,
    disabled: _propTypes2.default.string.isRequired,
    footer: _propTypes2.default.string,
    interactionDisabled: _propTypes2.default.string,
    months: _propTypes2.default.string,
    month: _propTypes2.default.string,
    navBar: _propTypes2.default.string,
    outside: _propTypes2.default.string.isRequired,
    selected: _propTypes2.default.string.isRequired,
    today: _propTypes2.default.string.isRequired,
    todayButton: _propTypes2.default.string,
    week: _propTypes2.default.string,
    wrapper: _propTypes2.default.string
  }),
  className: _propTypes2.default.string,
  containerProps: _propTypes2.default.object,
  tabIndex: _propTypes2.default.number,

  // Custom elements
  renderDay: _propTypes2.default.func,
  renderWeek: _propTypes2.default.func,
  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),
  navbarElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),
  captionElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),

  // Events
  onBlur: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onDayClick: _propTypes2.default.func,
  onDayKeyDown: _propTypes2.default.func,
  onDayMouseEnter: _propTypes2.default.func,
  onDayMouseLeave: _propTypes2.default.func,
  onDayMouseDown: _propTypes2.default.func,
  onDayMouseUp: _propTypes2.default.func,
  onDayTouchStart: _propTypes2.default.func,
  onDayTouchEnd: _propTypes2.default.func,
  onDayFocus: _propTypes2.default.func,
  onMonthChange: _propTypes2.default.func,
  onCaptionClick: _propTypes2.default.func,
  onWeekClick: _propTypes2.default.func,
  onTodayButtonClick: _propTypes2.default.func
};
DayPicker.defaultProps = {
  classNames: _classNames2.default,
  tabIndex: 0,
  initialMonth: new Date(),
  numberOfMonths: 1,
  labels: {
    previousMonth: 'Previous Month',
    nextMonth: 'Next Month'
  },
  locale: 'en',
  localeUtils: LocaleUtils,
  showOutsideDays: false,
  enableOutsideDaysClick: true,
  fixedWeeks: false,
  canChangeMonth: true,
  reverseMonths: false,
  pagedNavigation: false,
  showWeekNumbers: false,
  showWeekDays: true,
  renderDay: function renderDay(day) {
    return day.getDate();
  },
  renderWeek: function renderWeek(weekNumber) {
    return weekNumber;
  },
  weekdayElement: _react2.default.createElement(_Weekday2.default, null),
  navbarElement: _react2.default.createElement(_Navbar2.default, { classNames: _classNames2.default }),
  captionElement: _react2.default.createElement(_Caption2.default, { classNames: _classNames2.default })
};


DayPicker.DateUtils = DateUtils;
DayPicker.LocaleUtils = LocaleUtils;
DayPicker.ModifiersUtils = ModifiersUtils;

exports.DateUtils = DateUtils;
exports.LocaleUtils = LocaleUtils;
exports.ModifiersUtils = ModifiersUtils;
exports.default = DayPicker;
//# sourceMappingURL=DayPicker.js.map

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classNames = __webpack_require__(297);

var _classNames2 = _interopRequireDefault(_classNames);

var _keys = __webpack_require__(226);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Navbar = function (_Component) {
  _inherits(Navbar, _Component);

  function Navbar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Navbar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Navbar.__proto__ || Object.getPrototypeOf(Navbar)).call.apply(_ref, [this].concat(args))), _this), _this.handleNextClick = function () {
      if (_this.props.onNextClick) {
        _this.props.onNextClick();
      }
    }, _this.handlePreviousClick = function () {
      if (_this.props.onPreviousClick) {
        _this.props.onPreviousClick();
      }
    }, _this.handleNextKeyDown = function (e) {
      if (e.keyCode !== _keys.ENTER && e.keyCode !== _keys.SPACE) {
        return;
      }
      e.preventDefault();
      _this.handleNextClick();
    }, _this.handlePreviousKeyDown = function (e) {
      if (e.keyCode !== _keys.ENTER && e.keyCode !== _keys.SPACE) {
        return;
      }
      e.preventDefault();
      _this.handlePreviousClick();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Navbar, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.labels !== this.props.labels || nextProps.dir !== this.props.dir || this.props.showPreviousButton !== nextProps.showPreviousButton || this.props.showNextButton !== nextProps.showNextButton;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          className = _props.className,
          showPreviousButton = _props.showPreviousButton,
          showNextButton = _props.showNextButton,
          labels = _props.labels,
          dir = _props.dir;


      var previousClickHandler = void 0;
      var nextClickHandler = void 0;
      var previousKeyDownHandler = void 0;
      var nextKeyDownHandler = void 0;
      var shouldShowPrevious = void 0;
      var shouldShowNext = void 0;

      if (dir === 'rtl') {
        previousClickHandler = this.handleNextClick;
        nextClickHandler = this.handlePreviousClick;
        previousKeyDownHandler = this.handleNextKeyDown;
        nextKeyDownHandler = this.handlePreviousKeyDown;
        shouldShowNext = showPreviousButton;
        shouldShowPrevious = showNextButton;
      } else {
        previousClickHandler = this.handlePreviousClick;
        nextClickHandler = this.handleNextClick;
        previousKeyDownHandler = this.handlePreviousKeyDown;
        nextKeyDownHandler = this.handleNextKeyDown;
        shouldShowNext = showNextButton;
        shouldShowPrevious = showPreviousButton;
      }

      var previousClassName = shouldShowPrevious ? classNames.navButtonPrev : classNames.navButtonPrev + ' ' + classNames.navButtonInteractionDisabled;

      var nextClassName = shouldShowNext ? classNames.navButtonNext : classNames.navButtonNext + ' ' + classNames.navButtonInteractionDisabled;

      var previousButton = _react2.default.createElement('span', {
        tabIndex: '0',
        role: 'button',
        'aria-label': labels.previousMonth,
        key: 'previous',
        className: previousClassName,
        onKeyDown: shouldShowPrevious ? previousKeyDownHandler : undefined,
        onClick: shouldShowPrevious ? previousClickHandler : undefined
      });

      var nextButton = _react2.default.createElement('span', {
        tabIndex: '0',
        role: 'button',
        'aria-label': labels.nextMonth,
        key: 'right',
        className: nextClassName,
        onKeyDown: shouldShowNext ? nextKeyDownHandler : undefined,
        onClick: shouldShowNext ? nextClickHandler : undefined
      });

      return _react2.default.createElement(
        'div',
        { className: className || classNames.navBar },
        dir === 'rtl' ? [nextButton, previousButton] : [previousButton, nextButton]
      );
    }
  }]);

  return Navbar;
}(_react.Component);

Navbar.propTypes = {
  classNames: _propTypes2.default.shape({
    navBar: _propTypes2.default.string.isRequired,
    navButtonPrev: _propTypes2.default.string.isRequired,
    navButtonNext: _propTypes2.default.string.isRequired,
    navButtonInteractionDisabled: _propTypes2.default.string.isRequired
  }),
  className: _propTypes2.default.string,
  showPreviousButton: _propTypes2.default.bool,
  showNextButton: _propTypes2.default.bool,
  onPreviousClick: _propTypes2.default.func,
  onNextClick: _propTypes2.default.func,
  dir: _propTypes2.default.string,
  labels: _propTypes2.default.shape({
    previousMonth: _propTypes2.default.string.isRequired,
    nextMonth: _propTypes2.default.string.isRequired
  })
};
Navbar.defaultProps = {
  classNames: _classNames2.default,
  dir: 'ltr',
  labels: {
    previousMonth: 'Previous Month',
    nextMonth: 'Next Month'
  },
  showPreviousButton: true,
  showNextButton: true
};
exports.default = Navbar;
//# sourceMappingURL=Navbar.js.map

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Weekday = function (_Component) {
  _inherits(Weekday, _Component);

  function Weekday() {
    _classCallCheck(this, Weekday);

    return _possibleConstructorReturn(this, (Weekday.__proto__ || Object.getPrototypeOf(Weekday)).apply(this, arguments));
  }

  _createClass(Weekday, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props !== nextProps;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          weekday = _props.weekday,
          className = _props.className,
          weekdaysLong = _props.weekdaysLong,
          weekdaysShort = _props.weekdaysShort,
          localeUtils = _props.localeUtils,
          locale = _props.locale;

      var title = void 0;
      if (weekdaysLong) {
        title = weekdaysLong[weekday];
      } else {
        title = localeUtils.formatWeekdayLong(weekday, locale);
      }
      var content = void 0;
      if (weekdaysShort) {
        content = weekdaysShort[weekday];
      } else {
        content = localeUtils.formatWeekdayShort(weekday, locale);
      }

      return _react2.default.createElement(
        'div',
        { className: className, role: 'columnheader' },
        _react2.default.createElement(
          'abbr',
          { title: title },
          content
        )
      );
    }
  }]);

  return Weekday;
}(_react.Component);

Weekday.propTypes = {
  weekday: _propTypes2.default.number,
  className: _propTypes2.default.string,
  locale: _propTypes2.default.string,
  localeUtils: _propTypes2.default.object,

  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string)
};
exports.default = Weekday;
//# sourceMappingURL=Weekday.js.map

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTransitionGroup = __webpack_require__(1783);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _Notification = __webpack_require__(1789);

var _Notification2 = _interopRequireDefault(_Notification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Notifications = function (_React$Component) {
  _inherits(Notifications, _React$Component);

  function Notifications() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Notifications);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Notifications.__proto__ || Object.getPrototypeOf(Notifications)).call.apply(_ref, [this].concat(args))), _this), _this.handleRequestHide = function (notification) {
      return function () {
        var onRequestHide = _this.props.onRequestHide;

        if (onRequestHide) {
          onRequestHide(notification);
        }
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Notifications, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          notifications = _props.notifications,
          enterTimeout = _props.enterTimeout,
          leaveTimeout = _props.leaveTimeout;

      var className = (0, _classnames2.default)('notification-container', {
        'notification-container-empty': notifications.length === 0
      });
      return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
          _reactTransitionGroup.CSSTransitionGroup,
          {
            transitionName: 'notification',
            transitionEnterTimeout: enterTimeout,
            transitionLeaveTimeout: leaveTimeout
          },
          notifications.map(function (notification) {
            var key = notification.id || new Date().getTime();
            return _react2.default.createElement(_Notification2.default, {
              key: key,
              type: notification.type,
              title: notification.title,
              message: notification.message,
              timeOut: notification.timeOut,
              onClick: notification.onClick,
              onRequestHide: _this2.handleRequestHide(notification)
            });
          })
        )
      );
    }
  }]);

  return Notifications;
}(_react2.default.Component);

Notifications.propTypes = {
  notifications: _propTypes2.default.array.isRequired,
  onRequestHide: _propTypes2.default.func,
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};
Notifications.defaultProps = {
  notifications: [],
  onRequestHide: function onRequestHide() {},
  enterTimeout: 400,
  leaveTimeout: 400
};
exports.default = Notifications;
module.exports = exports['default'];

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _chainFunction = __webpack_require__(1785);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(1786);

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__(1787);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.nameShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  leaveActive: _propTypes2.default.string,
  appear: _propTypes2.default.string,
  appearActive: _propTypes2.default.string
})]);

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = __webpack_require__(785);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var createUUID = function createUUID() {
  var pattern = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
  return pattern.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
};

var Constants = {
  CHANGE: 'change',
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error'
};

var NotificationManager = function (_EventEmitter) {
  _inherits(NotificationManager, _EventEmitter);

  function NotificationManager() {
    _classCallCheck(this, NotificationManager);

    var _this = _possibleConstructorReturn(this, (NotificationManager.__proto__ || Object.getPrototypeOf(NotificationManager)).call(this));

    _this.listNotify = [];
    return _this;
  }

  _createClass(NotificationManager, [{
    key: 'create',
    value: function create(notify) {
      var defaultNotify = {
        id: createUUID(),
        type: 'info',
        title: null,
        message: null,
        timeOut: 5000
      };
      if (notify.priority) {
        this.listNotify.unshift(Object.assign(defaultNotify, notify));
      } else {
        this.listNotify.push(Object.assign(defaultNotify, notify));
      }
      this.emitChange();
    }
  }, {
    key: 'info',
    value: function info(message, title, timeOut, onClick, priority) {
      this.create({
        type: Constants.INFO,
        message: message,
        title: title,
        timeOut: timeOut,
        onClick: onClick,
        priority: priority
      });
    }
  }, {
    key: 'success',
    value: function success(message, title, timeOut, onClick, priority) {
      this.create({
        type: Constants.SUCCESS,
        message: message,
        title: title,
        timeOut: timeOut,
        onClick: onClick,
        priority: priority
      });
    }
  }, {
    key: 'warning',
    value: function warning(message, title, timeOut, onClick, priority) {
      this.create({
        type: Constants.WARNING,
        message: message,
        title: title,
        timeOut: timeOut,
        onClick: onClick,
        priority: priority
      });
    }
  }, {
    key: 'error',
    value: function error(message, title, timeOut, onClick, priority) {
      this.create({
        type: Constants.ERROR,
        message: message,
        title: title,
        timeOut: timeOut,
        onClick: onClick,
        priority: priority
      });
    }
  }, {
    key: 'remove',
    value: function remove(notification) {
      this.listNotify = this.listNotify.filter(function (n) {
        return notification.id !== n.id;
      });
      this.emitChange();
    }
  }, {
    key: 'emitChange',
    value: function emitChange() {
      this.emit(Constants.CHANGE, this.listNotify);
    }
  }, {
    key: 'addChangeListener',
    value: function addChangeListener(callback) {
      this.addListener(Constants.CHANGE, callback);
    }
  }, {
    key: 'removeChangeListener',
    value: function removeChangeListener(callback) {
      this.removeListener(Constants.CHANGE, callback);
    }
  }]);

  return NotificationManager;
}(_events.EventEmitter);

exports.default = new NotificationManager();
module.exports = exports['default'];

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _FormErrors = _interopRequireDefault(__webpack_require__(38));

var _Validation = __webpack_require__(14);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var AddOrg =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AddOrg, _React$Component);

  function AddOrg(props) {
    var _this;

    _classCallCheck(this, AddOrg);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AddOrg).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleUserInput", function () {
      var _this2;

      return (_this2 = _this).__handleUserInput__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    var _props$organisation = props.organisation,
        id = _props$organisation.id,
        thumb = _props$organisation.thumb,
        name = _props$organisation.name,
        email = _props$organisation.email,
        phone = _props$organisation.phone,
        designation = _props$organisation.designation,
        selected = _props$organisation.selected,
        starred = _props$organisation.starred,
        frequently = _props$organisation.frequently,
        role = _props$organisation.role,
        surveys = _props$organisation.surveys;
    _this.state = {
      id: id,
      thumb: thumb,
      name: name,
      email: email,
      phone: phone,
      designation: designation,
      selected: selected,
      starred: starred,
      frequently: frequently,
      role: role,
      surveys: surveys,
      nameValid: (0, _Validation.isNameValid)(name),
      emailValid: (0, _Validation.isEmailValid)(email),
      formErrors: {
        name: '',
        email: ''
      },
      formValid: false
    };
    return _this;
  }

  _createClass(AddOrg, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.validateForm();
    }
  }, {
    key: "__handleUserInput__REACT_HOT_LOADER__",
    value: function __handleUserInput__REACT_HOT_LOADER__(e) {
      var _this3 = this;

      var name = e.target.name;
      var value = e.target.value;
      this.setState(_defineProperty({}, name, value), function () {
        _this3.validateField(name, value);
      } // run this call back on state change
      );
    }
  }, {
    key: "validateField",
    value: function validateField(fieldName, value) {
      var fieldValidationErrors = this.state.formErrors;
      var nameValid = this.state.nameValid;
      var emailValid = this.state.emailValid;

      switch (fieldName) {
        case 'name':
          nameValid = (0, _Validation.isNameValid)(value);
          fieldValidationErrors.name = nameValid ? '' : ' is invalid';
          break;

        case 'email':
          emailValid = (0, _Validation.isEmailValid)(value);
          fieldValidationErrors.email = emailValid ? '' : ' is invalid';
          break;

        default:
          break;
      }

      this.setState({
        formErrors: fieldValidationErrors,
        nameValid: nameValid,
        emailValid: emailValid
      }, this.validateForm);
    }
  }, {
    key: "validateForm",
    value: function validateForm() {
      this.setState({
        formValid: this.state.nameValid && this.state.emailValid
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          onSaveOrg = _this$props.onSaveOrg,
          showOrgLoader = _this$props.showOrgLoader,
          onOrgClose = _this$props.onOrgClose,
          open = _this$props.open,
          organisation = _this$props.organisation;
      var _this$state = this.state,
          id = _this$state.id,
          name = _this$state.name,
          email = _this$state.email,
          phone = _this$state.phone,
          role = _this$state.role,
          surveys = _this$state.surveys,
          designation = _this$state.designation,
          selected = _this$state.selected,
          starred = _this$state.starred,
          frequently = _this$state.frequently;
      var isNew = organisation.name === '';
      var thumb = this.state.thumb;
      return _react["default"].createElement(_reactstrap.Modal, {
        className: "modal-box",
        toggle: onOrgClose,
        isOpen: open
      }, _react["default"].createElement(_reactstrap.ModalHeader, {
        className: "modal-box-header bg-primary"
      }, isNew ? _react["default"].createElement(_IntlMessages["default"], {
        id: "org.addOrg"
      }) : _react["default"].createElement(_IntlMessages["default"], {
        id: "org.saveOrg"
      }), _react["default"].createElement("span", {
        className: "text-white pointer"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-close zmdi-hc-lg",
        onClick: onOrgClose
      }))), _react["default"].createElement("div", {
        className: "modal-box-content"
      }, _react["default"].createElement("div", {
        className: "row no-gutters"
      }, _react["default"].createElement("div", {
        className: "col-lg-3 text-center text-lg-right order-lg-2"
      }, _react["default"].createElement("img", {
        className: "ml-lg-3 mb-4 mb-lg-0 avatar size-120",
        src: thumb
      })), _react["default"].createElement("div", {
        className: "panel panel-default"
      }, _react["default"].createElement(_FormErrors["default"], {
        formErrors: this.state.formErrors
      })), _react["default"].createElement("div", {
        className: "col-lg-9 d-flex flex-column order-lg-1"
      }, _react["default"].createElement("input", {
        type: "text",
        className: "form-control mb-2",
        placeholder: "Organisation Name",
        onChange: function onChange(event) {
          return _this4.handleUserInput(event);
        },
        defaultValue: name,
        name: "name"
      }), _react["default"].createElement("input", {
        type: "text",
        className: "form-control mb-2",
        placeholder: "Administrators Email",
        onChange: function onChange(event) {
          return _this4.handleUserInput(event);
        },
        value: email,
        name: "email"
      }), _react["default"].createElement("input", {
        type: "text",
        className: "form-control mb-2",
        placeholder: "Adminstrators Phone",
        onChange: function onChange(event) {
          return _this4.setState({
            phone: event.target.value
          });
        },
        value: phone,
        name: "phone"
      }), _react["default"].createElement("input", {
        type: "text",
        className: "form-control mb-2",
        placeholder: "Department/ Position",
        onChange: function onChange(event) {
          return _this4.setState({
            designation: event.target.value
          });
        },
        value: designation,
        name: "desgination"
      })))), _react["default"].createElement("div", {
        className: "modal-box-footer d-flex flex-row"
      }, _react["default"].createElement(_reactstrap.Button, {
        className: "text-uppercase",
        disabled: !this.state.formValid,
        color: "primary",
        onClick: function onClick() {
          showOrgLoader();
          onOrgClose();
          onSaveOrg({
            'id': id,
            'name': name,
            'thumb': null,
            'email': email,
            'phone': phone,
            'designation': designation,
            'selected': selected,
            'starred': starred,
            'frequently': frequently,
            'role': role,
            'surveys': surveys
          });

          _this4.setState({
            id: '',
            name: '',
            thumb: null,
            email: '',
            phone: '',
            designation: '',
            selected: false,
            starred: false,
            frequently: false,
            role: '',
            surveys: [],
            formErrors: {
              name: '',
              email: ''
            },
            formValid: false
          });
        }
      }, isNew ? _react["default"].createElement(_IntlMessages["default"], {
        id: "org.addOrg"
      }) : _react["default"].createElement(_IntlMessages["default"], {
        id: "org.saveOrg"
      }))));
    }
  }]);

  return AddOrg;
}(_react["default"].Component);

var _default = AddOrg;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AddOrg, "AddOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/AddOrg/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/AddOrg/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/AddOrg/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/AddOrg/index.js");

  __REACT_HOT_LOADER__.register(_FormErrors, "_FormErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/AddOrg/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/AddOrg/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/AddOrg/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/AddOrg/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/AddOrg/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/AddOrg/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/AddOrg/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/AddOrg/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/AddOrg/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/AddOrg/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/AddOrg/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/AddOrg/index.js");

  __REACT_HOT_LOADER__.register(AddOrg, "AddOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/AddOrg/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/AddOrg/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/AddOrg/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/AddOrg/index.js");
}();

;

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _FormErrors = _interopRequireDefault(__webpack_require__(38));

var _Validation = __webpack_require__(14);

var _Authentication = __webpack_require__(42);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var AddEmp =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AddEmp, _React$Component);

  function AddEmp(props) {
    var _this;

    _classCallCheck(this, AddEmp);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AddEmp).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleUserInput", function () {
      var _this2;

      return (_this2 = _this).__handleUserInput__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "handleRoleChange", function () {
      var _this3;

      return (_this3 = _this).__handleRoleChange__REACT_HOT_LOADER__.apply(_this3, arguments);
    });

    var _props$employee = props.employee,
        id = _props$employee.id,
        orgid = _props$employee.orgid,
        thumb = _props$employee.thumb,
        name = _props$employee.name,
        email = _props$employee.email,
        phone = _props$employee.phone,
        designation = _props$employee.designation,
        selected = _props$employee.selected,
        starred = _props$employee.starred,
        frequently = _props$employee.frequently,
        role = _props$employee.role;
    _this.state = {
      id: id,
      orgid: orgid,
      thumb: thumb,
      name: name,
      email: email,
      phone: phone,
      designation: designation,
      selected: selected,
      starred: starred,
      frequently: frequently,
      role: role,
      checked: role === 'gold',
      nameValid: (0, _Validation.isNameValid)(name),
      emailValid: (0, _Validation.isEmailValid)(email),
      formErrors: {
        name: '',
        email: ''
      },
      formValid: false
    };
    return _this;
  }

  _createClass(AddEmp, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.validateForm();
    }
  }, {
    key: "__handleUserInput__REACT_HOT_LOADER__",
    value: function __handleUserInput__REACT_HOT_LOADER__(e) {
      var _this4 = this;

      var name = e.target.name;
      var value = e.target.value;
      this.setState(_defineProperty({}, name, value), function () {
        _this4.validateField(name, value);
      } // run this call back on state change
      );
    }
  }, {
    key: "__handleRoleChange__REACT_HOT_LOADER__",
    value: function __handleRoleChange__REACT_HOT_LOADER__() {
      // toggle the checked prop
      this.setState({
        checked: !this.state.checked
      });
    }
  }, {
    key: "validateField",
    value: function validateField(fieldName, value) {
      var fieldValidationErrors = this.state.formErrors;
      var nameValid = this.state.nameValid;
      var emailValid = this.state.emailValid;

      switch (fieldName) {
        case 'name':
          nameValid = (0, _Validation.isNameValid)(value);
          fieldValidationErrors.name = nameValid ? '' : ' is invalid';
          break;

        case 'email':
          emailValid = (0, _Validation.isEmailValid)(value);
          fieldValidationErrors.email = emailValid ? '' : ' is invalid';
          break;

        default:
          break;
      }

      this.setState({
        formErrors: fieldValidationErrors,
        nameValid: nameValid,
        emailValid: emailValid
      }, this.validateForm);
    }
  }, {
    key: "validateForm",
    value: function validateForm() {
      this.setState({
        formValid: this.state.nameValid && this.state.emailValid
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$props = this.props,
          onSaveEmp = _this$props.onSaveEmp,
          showEmpLoader = _this$props.showEmpLoader,
          onEmpClose = _this$props.onEmpClose,
          open = _this$props.open,
          employee = _this$props.employee;
      var _this$state = this.state,
          id = _this$state.id,
          orgid = _this$state.orgid,
          name = _this$state.name,
          email = _this$state.email,
          phone = _this$state.phone,
          designation = _this$state.designation,
          selected = _this$state.selected,
          starred = _this$state.starred,
          frequently = _this$state.frequently,
          checked = _this$state.checked;
      var isNew = employee.name === '';
      var thumb = this.state.thumb;
      return _react["default"].createElement(_reactstrap.Modal, {
        className: "modal-box",
        toggle: onEmpClose,
        isOpen: open
      }, _react["default"].createElement(_reactstrap.ModalHeader, {
        className: "modal-box-header bg-primary"
      }, isNew ? _react["default"].createElement(_IntlMessages["default"], {
        id: "emp.addEmp"
      }) : _react["default"].createElement(_IntlMessages["default"], {
        id: "emp.saveEmp"
      }), _react["default"].createElement("span", {
        className: "text-white pointer"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-close zmdi-hc-lg",
        onClick: onEmpClose
      }))), _react["default"].createElement("div", {
        className: "modal-box-content"
      }, _react["default"].createElement("div", {
        className: "row no-gutters"
      }, _react["default"].createElement("div", {
        className: "col-lg-3 text-center text-lg-right order-lg-2"
      }, _react["default"].createElement("img", {
        className: "ml-lg-3 mb-4 mb-lg-0 avatar size-120",
        src: thumb
      })), _react["default"].createElement("div", {
        className: "panel panel-default"
      }, _react["default"].createElement(_FormErrors["default"], {
        formErrors: this.state.formErrors
      })), _react["default"].createElement("div", {
        className: "col-lg-9 d-flex flex-column order-lg-1"
      }, _react["default"].createElement("h3", {
        className: "card-heading"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "label.name"
      })), _react["default"].createElement("input", {
        type: "text",
        className: "form-control mb-2 ".concat(name ? 'is-valid' : 'is-invalid'),
        onChange: function onChange(event) {
          return _this5.handleUserInput(event);
        },
        defaultValue: name,
        name: "name"
      }), _react["default"].createElement("h3", {
        className: "card-heading"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "label.email"
      })), _react["default"].createElement("input", {
        type: "text",
        className: "form-control mb-2 ".concat(email ? 'is-valid' : 'is-invalid'),
        onChange: function onChange(event) {
          return _this5.handleUserInput(event);
        },
        value: email,
        name: "email"
      }), _react["default"].createElement("h3", {
        className: "card-heading"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "label.phone"
      })), _react["default"].createElement("input", {
        type: "text",
        className: "form-control mb-2",
        placeholder: "Employee Phone",
        onChange: function onChange(event) {
          return _this5.setState({
            phone: event.target.value
          });
        },
        value: phone,
        name: "phone"
      }), _react["default"].createElement("h3", {
        className: "card-heading"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "label.department"
      })), _react["default"].createElement("input", {
        type: "text",
        className: "form-control mb-2",
        onChange: function onChange(event) {
          return _this5.setState({
            designation: event.target.value
          });
        },
        value: designation,
        name: "designation"
      }), _Authentication.isAdmin ? _react["default"].createElement("div", {
        className: "custom-control custom-checkbox my-1 mr-sm-2"
      }, _react["default"].createElement("input", {
        type: "checkbox",
        className: "custom-control-input",
        id: "adminCheckbox1",
        defaultChecked: checked,
        onChange: this.handleRoleChange
      }), _react["default"].createElement("label", {
        className: "custom-control-label",
        htmlFor: "adminCheckbox1"
      }, "Administrator access")) : null))), _react["default"].createElement("div", {
        className: "modal-box-footer d-flex flex-row"
      }, _react["default"].createElement(_reactstrap.Button, {
        className: "text-uppercase",
        disabled: !this.state.formValid,
        color: "primary",
        onClick: function onClick() {
          showEmpLoader();
          onEmpClose();
          onSaveEmp({
            'id': id,
            'orgid': orgid,
            'name': name,
            'thumb': null,
            'email': email,
            'phone': phone,
            'designation': designation,
            'selected': selected,
            'starred': starred,
            'frequently': frequently,
            'role': checked ? 'gold' : 'silver'
          });

          _this5.setState({
            id: '',
            orgid: '',
            name: '',
            thumb: null,
            email: '',
            phone: '',
            designation: '',
            selected: false,
            starred: false,
            frequently: false,
            role: '',
            formErrors: {
              name: '',
              email: ''
            },
            formValid: false
          });
        }
      }, isNew ? _react["default"].createElement(_IntlMessages["default"], {
        id: "emp.addEmp"
      }) : _react["default"].createElement(_IntlMessages["default"], {
        id: "emp.saveEmp"
      }))));
    }
  }]);

  return AddEmp;
}(_react["default"].Component);

var _default = AddEmp;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AddEmp, "AddEmp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/AddEmp/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/AddEmp/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/AddEmp/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/AddEmp/index.js");

  __REACT_HOT_LOADER__.register(_FormErrors, "_FormErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/AddEmp/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/AddEmp/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/AddEmp/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/AddEmp/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/AddEmp/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/AddEmp/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/AddEmp/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/AddEmp/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/AddEmp/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/AddEmp/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/AddEmp/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/AddEmp/index.js");

  __REACT_HOT_LOADER__.register(AddEmp, "AddEmp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/AddEmp/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/AddEmp/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/AddEmp/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/AddEmp/index.js");
}();

;

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _reactDayPicker = _interopRequireDefault(__webpack_require__(846));

__webpack_require__(198);

var _CardBox = _interopRequireDefault(__webpack_require__(228));

var _FormErrors = _interopRequireDefault(__webpack_require__(38));

var _Validation = __webpack_require__(14);

var _DateService = __webpack_require__(48);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var AddOrgSurvey =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AddOrgSurvey, _React$Component);

  function AddOrgSurvey(props) {
    var _this;

    _classCallCheck(this, AddOrgSurvey);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AddOrgSurvey).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleUserInput", function () {
      var _this2;

      return (_this2 = _this).__handleUserInput__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    _this.handleStartDateClick = _this.handleStartDateClick.bind(_assertThisInitialized(_this));
    _this.handleEndDateClick = _this.handleEndDateClick.bind(_assertThisInitialized(_this));
    var _props$orgSurvey = props.orgSurvey,
        id = _props$orgSurvey.id,
        surveyId = _props$orgSurvey.surveyId,
        name = _props$orgSurvey.name,
        startDate = _props$orgSurvey.startDate,
        endDate = _props$orgSurvey.endDate;
    _this.state = {
      id: id,
      surveyId: surveyId,
      name: name,
      startDate: startDate,
      endDate: endDate,
      nameValid: (0, _Validation.isNameValid)(name),
      idValid: (0, _Validation.isValueEntered)(surveyId),
      startDateValid: (0, _Validation.isValueEntered)(startDate),
      endDateValid: (0, _Validation.isValueEntered)(endDate),
      formErrors: {
        surveyId: '',
        name: '',
        startDate: '',
        endDate: '',
        dates: ''
      },
      datesValid: false,
      formValid: false
    };
    return _this;
  }

  _createClass(AddOrgSurvey, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.validateForm();
    }
  }, {
    key: "__handleUserInput__REACT_HOT_LOADER__",
    value: function __handleUserInput__REACT_HOT_LOADER__(e) {
      var _this3 = this;

      var name = e.target.name;
      var value = e.target.value;
      this.setState(_defineProperty({}, name, value), function () {
        _this3.validateField(name, value);
      } // run this call back on state change
      );
    }
  }, {
    key: "validateField",
    value: function validateField(fieldName, value) {
      var fieldValidationErrors = this.state.formErrors;
      var idValid = this.state.idValid;
      var nameValid = this.state.nameValid;
      var startDateValid = this.state.startDateValid;
      var endDateValid = this.state.endDateValid;

      switch (fieldName) {
        case 'surveyId':
          idValid = (0, _Validation.isValueEntered)(value);
          fieldValidationErrors.surveyId = idValid ? '' : ' is invalid';
          break;

        case 'name':
          nameValid = (0, _Validation.isNameValid)(value);
          fieldValidationErrors.name = nameValid ? '' : ' is invalid';
          break;

        case 'startDate':
          startDateValid = (0, _Validation.isValueEntered)(value);
          fieldValidationErrors.startDate = startDateValid ? '' : ' is invalid';
          break;

        case 'endDate':
          endDateValid = (0, _Validation.isValueEntered)(value);
          fieldValidationErrors.endDate = endDateValid ? '' : ' is invalid';
          break;

        default:
          break;
      }

      this.setState({
        formErrors: fieldValidationErrors,
        idValid: idValid,
        nameValid: nameValid,
        startDateValid: startDateValid,
        endDateValid: endDateValid
      }, this.validateForm);
    }
  }, {
    key: "validateForm",
    value: function validateForm() {
      var datesAreValid = this.datesValid();
      this.setState({
        formValid: this.state.idValid && this.state.nameValid && datesAreValid
      });
    }
  }, {
    key: "datesValid",
    value: function datesValid() {
      var _this$state = this.state,
          startDate = _this$state.startDate,
          endDate = _this$state.endDate;
      var fieldValidationErrors = this.state.formErrors;

      if ((0, _Validation.isValueEntered)(startDate) && (0, _Validation.isValueEntered)(endDate)) {
        if ((0, _DateService.isDateBefore)(endDate, startDate)) {
          fieldValidationErrors.dates = ' are invalid. The end date selected cannot be before the start date';
          this.setState({
            formErrors: fieldValidationErrors
          });
          return false;
        }

        fieldValidationErrors.dates = '';
        this.setState({
          formErrors: fieldValidationErrors
        });
        return true;
      }

      return false;
    }
  }, {
    key: "handleStartDateClick",
    value: function handleStartDateClick(day, _ref) {
      var _this4 = this;

      var selected = _ref.selected;
      var value = selected ? undefined : day;
      this.setState({
        startDate: value
      }, function () {
        _this4.validateField('startDate', value);
      });
    }
  }, {
    key: "handleEndDateClick",
    value: function handleEndDateClick(day, _ref2) {
      var _this5 = this;

      var selected = _ref2.selected;
      var value = selected ? undefined : day;
      this.setState({
        endDate: value
      }, function () {
        _this5.validateField('endDate', value);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var _this$props = this.props,
          onSaveOrgSurvey = _this$props.onSaveOrgSurvey,
          showOrgSurveyLoader = _this$props.showOrgSurveyLoader,
          onOrgSurveyClose = _this$props.onOrgSurveyClose,
          open = _this$props.open,
          surveys = _this$props.surveys;
      var _this$state2 = this.state,
          id = _this$state2.id,
          surveyId = _this$state2.surveyId,
          name = _this$state2.name,
          startDate = _this$state2.startDate,
          endDate = _this$state2.endDate;
      var isNew = name === '';
      return _react["default"].createElement(_reactstrap.Modal, {
        className: "modal-box",
        toggle: onOrgSurveyClose,
        isOpen: open
      }, _react["default"].createElement(_reactstrap.ModalHeader, {
        className: "modal-box-header bg-primary"
      }, isNew ? _react["default"].createElement(_IntlMessages["default"], {
        id: "orgSurvey.addOrgSurvey"
      }) : _react["default"].createElement(_IntlMessages["default"], {
        id: "orgSurvey.saveOrgSurvey"
      }), _react["default"].createElement("span", {
        className: "text-white pointer"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-close zmdi-hc-lg",
        onClick: onOrgSurveyClose
      }))), _react["default"].createElement("div", {
        className: "modal-box-content"
      }, _react["default"].createElement("div", {
        className: "row no-gutters"
      }, _react["default"].createElement(_FormErrors["default"], {
        formErrors: this.state.formErrors
      }), _react["default"].createElement("div", {
        className: "col-lg-12 d-flex flex-column order-lg-1"
      }, _react["default"].createElement(_reactstrap.Input, {
        type: "select",
        name: "surveyId",
        id: "surveySelect",
        onChange: function onChange(event) {
          return _this6.handleUserInput(event);
        },
        className: "form-control mb-2",
        value: surveyId
      }, _react["default"].createElement("option", {
        key: "emptySelect"
      }, "-- select survey --"), surveys.map(function (survey) {
        return _react["default"].createElement("option", {
          key: survey.id,
          value: survey.id
        }, survey.name);
      })), _react["default"].createElement("input", {
        type: "text",
        className: "form-control mb-2",
        placeholder: "Survey Name",
        onChange: function onChange(event) {
          return _this6.handleUserInput(event);
        },
        defaultValue: name,
        name: "name"
      }), _react["default"].createElement("div", {
        className: "row"
      }, _react["default"].createElement(_CardBox["default"], {
        styleName: "col-lg-6 col-sm-6",
        heading: _react["default"].createElement(_IntlMessages["default"], {
          id: "orgSurvey.addOrgSurveyStartDate"
        })
      }, _react["default"].createElement(_reactDayPicker["default"], {
        selectedDays: startDate,
        onDayClick: this.handleStartDateClick
      })), _react["default"].createElement(_CardBox["default"], {
        styleName: "col-lg-6 col-sm-6",
        heading: _react["default"].createElement(_IntlMessages["default"], {
          id: "orgSurvey.addOrgSurveyEndDate"
        })
      }, _react["default"].createElement(_reactDayPicker["default"], {
        selectedDays: endDate,
        onDayClick: this.handleEndDateClick
      }))))), _react["default"].createElement("div", {
        className: "modal-box-footer d-flex flex-row"
      }, _react["default"].createElement(_reactstrap.Button, {
        className: "text-uppercase",
        disabled: !this.state.formValid,
        color: "primary",
        onClick: function onClick() {
          showOrgSurveyLoader();
          onOrgSurveyClose();
          onSaveOrgSurvey({
            'name': name,
            'id': id,
            'surveyId': surveyId,
            'startDate': startDate,
            'endDate': endDate
          });

          _this6.setState({
            name: '',
            id: '',
            surveyId: '',
            startDate: '',
            endDate: '',
            formErrors: {
              surveyId: '',
              name: '',
              startDate: '',
              endDate: '',
              dates: ''
            },
            datesValid: false,
            formValid: false
          });
        }
      }, isNew ? _react["default"].createElement(_IntlMessages["default"], {
        id: "orgSurvey.addOrgSurvey"
      }) : _react["default"].createElement(_IntlMessages["default"], {
        id: "orgSurvey.saveOrgSurvey"
      })))));
    }
  }]);

  return AddOrgSurvey;
}(_react["default"].Component);

var _default = AddOrgSurvey;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AddOrgSurvey, "AddOrgSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/AddOrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/AddOrgSurvey/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/AddOrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/AddOrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_reactDayPicker, "_reactDayPicker", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/AddOrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_CardBox, "_CardBox", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/AddOrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_FormErrors, "_FormErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/AddOrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/AddOrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/AddOrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/AddOrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/AddOrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/AddOrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/AddOrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/AddOrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/AddOrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/AddOrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/AddOrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/AddOrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(AddOrgSurvey, "AddOrgSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/AddOrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/AddOrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/AddOrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/AddOrgSurvey/index.js");
}();

;

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);


/* eslint-disable react/prop-types */


var Track = function Track(props) {
  var _ref, _ref2;

  var className = props.className,
      included = props.included,
      vertical = props.vertical,
      offset = props.offset,
      length = props.length,
      style = props.style,
      reverse = props.reverse;

  var positonStyle = vertical ? (_ref = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, reverse ? 'top' : 'bottom', offset + '%'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, reverse ? 'bottom' : 'top', 'auto'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'height', length + '%'), _ref) : (_ref2 = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref2, reverse ? 'right' : 'left', offset + '%'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref2, reverse ? 'left' : 'right', 'auto'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref2, 'width', length + '%'), _ref2);

  var elStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, positonStyle);
  return included ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: className, style: elStyle }) : null;
};

/* harmony default export */ __webpack_exports__["a"] = (Track);

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSlider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get__ = __webpack_require__(1853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_Dom_addEventListener__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_warning__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Steps__ = __webpack_require__(1857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Marks__ = __webpack_require__(1858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Handle__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils__ = __webpack_require__(421);


















function noop() {}

function createSlider(Component) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(ComponentEnhancer, _Component);

    function ComponentEnhancer(props) {
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ComponentEnhancer);

      var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ComponentEnhancer.__proto__ || Object.getPrototypeOf(ComponentEnhancer)).call(this, props));

      _this.onMouseDown = function (e) {
        if (e.button !== 0) {
          return;
        }

        var isVertical = _this.props.vertical;
        var position = __WEBPACK_IMPORTED_MODULE_16__utils__["e" /* getMousePosition */](isVertical, e);
        if (!__WEBPACK_IMPORTED_MODULE_16__utils__["g" /* isEventFromHandle */](e, _this.handlesRefs)) {
          _this.dragOffset = 0;
        } else {
          var handlePosition = __WEBPACK_IMPORTED_MODULE_16__utils__["c" /* getHandleCenterPosition */](isVertical, e.target);
          _this.dragOffset = position - handlePosition;
          position = handlePosition;
        }
        _this.removeDocumentEvents();
        _this.onStart(position);
        _this.addDocumentMouseEvents();
      };

      _this.onTouchStart = function (e) {
        if (__WEBPACK_IMPORTED_MODULE_16__utils__["h" /* isNotTouchEvent */](e)) return;

        var isVertical = _this.props.vertical;
        var position = __WEBPACK_IMPORTED_MODULE_16__utils__["f" /* getTouchPosition */](isVertical, e);
        if (!__WEBPACK_IMPORTED_MODULE_16__utils__["g" /* isEventFromHandle */](e, _this.handlesRefs)) {
          _this.dragOffset = 0;
        } else {
          var handlePosition = __WEBPACK_IMPORTED_MODULE_16__utils__["c" /* getHandleCenterPosition */](isVertical, e.target);
          _this.dragOffset = position - handlePosition;
          position = handlePosition;
        }
        _this.onStart(position);
        _this.addDocumentTouchEvents();
        __WEBPACK_IMPORTED_MODULE_16__utils__["j" /* pauseEvent */](e);
      };

      _this.onFocus = function (e) {
        var _this$props = _this.props,
            onFocus = _this$props.onFocus,
            vertical = _this$props.vertical;

        if (__WEBPACK_IMPORTED_MODULE_16__utils__["g" /* isEventFromHandle */](e, _this.handlesRefs)) {
          var handlePosition = __WEBPACK_IMPORTED_MODULE_16__utils__["c" /* getHandleCenterPosition */](vertical, e.target);
          _this.dragOffset = 0;
          _this.onStart(handlePosition);
          __WEBPACK_IMPORTED_MODULE_16__utils__["j" /* pauseEvent */](e);
          if (onFocus) {
            onFocus(e);
          }
        }
      };

      _this.onBlur = function (e) {
        var onBlur = _this.props.onBlur;

        _this.onEnd();
        if (onBlur) {
          onBlur(e);
        }
      };

      _this.onMouseUp = function () {
        if (_this.handlesRefs[_this.prevMovedHandleIndex]) {
          _this.handlesRefs[_this.prevMovedHandleIndex].clickFocus();
        }
      };

      _this.onMouseMove = function (e) {
        if (!_this.sliderRef) {
          _this.onEnd();
          return;
        }
        var position = __WEBPACK_IMPORTED_MODULE_16__utils__["e" /* getMousePosition */](_this.props.vertical, e);
        _this.onMove(e, position - _this.dragOffset);
      };

      _this.onTouchMove = function (e) {
        if (__WEBPACK_IMPORTED_MODULE_16__utils__["h" /* isNotTouchEvent */](e) || !_this.sliderRef) {
          _this.onEnd();
          return;
        }

        var position = __WEBPACK_IMPORTED_MODULE_16__utils__["f" /* getTouchPosition */](_this.props.vertical, e);
        _this.onMove(e, position - _this.dragOffset);
      };

      _this.onKeyDown = function (e) {
        if (_this.sliderRef && __WEBPACK_IMPORTED_MODULE_16__utils__["g" /* isEventFromHandle */](e, _this.handlesRefs)) {
          _this.onKeyboard(e);
        }
      };

      _this.onClickMarkLabel = function (e, value) {
        e.stopPropagation();
        _this.onChange({ value: value });
        _this.setState({ value: value }, function () {
          return _this.onEnd(true);
        });
      };

      _this.saveSlider = function (slider) {
        _this.sliderRef = slider;
      };

      var step = props.step,
          max = props.max,
          min = props.min;

      var isPointDiffEven = isFinite(max - min) ? (max - min) % step === 0 : true; // eslint-disable-line
      __WEBPACK_IMPORTED_MODULE_12_warning___default()(step && Math.floor(step) === step ? isPointDiffEven : true, 'Slider[max] - Slider[min] (%s) should be a multiple of Slider[step] (%s)', max - min, step);
      _this.handlesRefs = {};
      return _this;
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ComponentEnhancer, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        // Snapshot testing cannot handle refs, so be sure to null-check this.
        this.document = this.sliderRef && this.sliderRef.ownerDocument;

        var _props = this.props,
            autoFocus = _props.autoFocus,
            disabled = _props.disabled;

        if (autoFocus && !disabled) {
          this.focus();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default()(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'componentWillUnmount', this)) __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default()(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'componentWillUnmount', this).call(this);
        this.removeDocumentEvents();
      }
    }, {
      key: 'getSliderStart',
      value: function getSliderStart() {
        var slider = this.sliderRef;
        var _props2 = this.props,
            vertical = _props2.vertical,
            reverse = _props2.reverse;

        var rect = slider.getBoundingClientRect();
        if (vertical) {
          return reverse ? rect.bottom : rect.top;
        }
        return window.pageXOffset + (reverse ? rect.right : rect.left);
      }
    }, {
      key: 'getSliderLength',
      value: function getSliderLength() {
        var slider = this.sliderRef;
        if (!slider) {
          return 0;
        }

        var coords = slider.getBoundingClientRect();
        return this.props.vertical ? coords.height : coords.width;
      }
    }, {
      key: 'addDocumentTouchEvents',
      value: function addDocumentTouchEvents() {
        // just work for Chrome iOS Safari and Android Browser
        this.onTouchMoveListener = Object(__WEBPACK_IMPORTED_MODULE_10_rc_util_es_Dom_addEventListener__["a" /* default */])(this.document, 'touchmove', this.onTouchMove);
        this.onTouchUpListener = Object(__WEBPACK_IMPORTED_MODULE_10_rc_util_es_Dom_addEventListener__["a" /* default */])(this.document, 'touchend', this.onEnd);
      }
    }, {
      key: 'addDocumentMouseEvents',
      value: function addDocumentMouseEvents() {
        this.onMouseMoveListener = Object(__WEBPACK_IMPORTED_MODULE_10_rc_util_es_Dom_addEventListener__["a" /* default */])(this.document, 'mousemove', this.onMouseMove);
        this.onMouseUpListener = Object(__WEBPACK_IMPORTED_MODULE_10_rc_util_es_Dom_addEventListener__["a" /* default */])(this.document, 'mouseup', this.onEnd);
      }
    }, {
      key: 'removeDocumentEvents',
      value: function removeDocumentEvents() {
        /* eslint-disable no-unused-expressions */
        this.onTouchMoveListener && this.onTouchMoveListener.remove();
        this.onTouchUpListener && this.onTouchUpListener.remove();

        this.onMouseMoveListener && this.onMouseMoveListener.remove();
        this.onMouseUpListener && this.onMouseUpListener.remove();
        /* eslint-enable no-unused-expressions */
      }
    }, {
      key: 'focus',
      value: function focus() {
        if (!this.props.disabled) {
          this.handlesRefs[0].focus();
        }
      }
    }, {
      key: 'blur',
      value: function blur() {
        var _this2 = this;

        if (!this.props.disabled) {
          Object.keys(this.handlesRefs).forEach(function (key) {
            if (_this2.handlesRefs[key] && _this2.handlesRefs[key].blur) {
              _this2.handlesRefs[key].blur();
            }
          });
        }
      }
    }, {
      key: 'calcValue',
      value: function calcValue(offset) {
        var _props3 = this.props,
            vertical = _props3.vertical,
            min = _props3.min,
            max = _props3.max;

        var ratio = Math.abs(Math.max(offset, 0) / this.getSliderLength());
        var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
        return value;
      }
    }, {
      key: 'calcValueByPos',
      value: function calcValueByPos(position) {
        var sign = this.props.reverse ? -1 : +1;
        var pixelOffset = sign * (position - this.getSliderStart());
        var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
        return nextValue;
      }
    }, {
      key: 'calcOffset',
      value: function calcOffset(value) {
        var _props4 = this.props,
            min = _props4.min,
            max = _props4.max;

        var ratio = (value - min) / (max - min);
        return ratio * 100;
      }
    }, {
      key: 'saveHandle',
      value: function saveHandle(index, handle) {
        this.handlesRefs[index] = handle;
      }
    }, {
      key: 'render',
      value: function render() {
        var _classNames;

        var _props5 = this.props,
            prefixCls = _props5.prefixCls,
            className = _props5.className,
            marks = _props5.marks,
            dots = _props5.dots,
            step = _props5.step,
            included = _props5.included,
            disabled = _props5.disabled,
            vertical = _props5.vertical,
            reverse = _props5.reverse,
            min = _props5.min,
            max = _props5.max,
            children = _props5.children,
            maximumTrackStyle = _props5.maximumTrackStyle,
            style = _props5.style,
            railStyle = _props5.railStyle,
            dotStyle = _props5.dotStyle,
            activeDotStyle = _props5.activeDotStyle;

        var _get$call = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default()(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'render', this).call(this),
            tracks = _get$call.tracks,
            handles = _get$call.handles;

        var sliderClassName = __WEBPACK_IMPORTED_MODULE_11_classnames___default()(prefixCls, (_classNames = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-with-marks', Object.keys(marks).length), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-disabled', disabled), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-vertical', vertical), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_classNames, className, className), _classNames));
        return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          'div',
          {
            ref: this.saveSlider,
            className: sliderClassName,
            onTouchStart: disabled ? noop : this.onTouchStart,
            onMouseDown: disabled ? noop : this.onMouseDown,
            onMouseUp: disabled ? noop : this.onMouseUp,
            onKeyDown: disabled ? noop : this.onKeyDown,
            onFocus: disabled ? noop : this.onFocus,
            onBlur: disabled ? noop : this.onBlur,
            style: style
          },
          __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', {
            className: prefixCls + '-rail',
            style: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, maximumTrackStyle, railStyle)
          }),
          tracks,
          __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Steps__["a" /* default */], {
            prefixCls: prefixCls,
            vertical: vertical,
            reverse: reverse,
            marks: marks,
            dots: dots,
            step: step,
            included: included,
            lowerBound: this.getLowerBound(),
            upperBound: this.getUpperBound(),
            max: max,
            min: min,
            dotStyle: dotStyle,
            activeDotStyle: activeDotStyle
          }),
          handles,
          __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Marks__["a" /* default */], {
            className: prefixCls + '-mark',
            onClickLabel: disabled ? noop : this.onClickMarkLabel,
            vertical: vertical,
            marks: marks,
            included: included,
            lowerBound: this.getLowerBound(),
            upperBound: this.getUpperBound(),
            max: max,
            min: min,
            reverse: reverse
          }),
          children
        );
      }
    }]);

    return ComponentEnhancer;
  }(Component), _class.displayName = 'ComponentEnhancer(' + Component.displayName + ')', _class.propTypes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Component.propTypes, {
    min: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
    max: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
    step: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
    marks: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
    included: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
    className: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,
    prefixCls: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,
    disabled: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
    children: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.any,
    onBeforeChange: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
    onChange: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
    onAfterChange: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
    handle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
    dots: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
    vertical: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
    style: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
    reverse: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
    minimumTrackStyle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object, // just for compatibility, will be deperecate
    maximumTrackStyle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object, // just for compatibility, will be deperecate
    handleStyle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object)]),
    trackStyle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object)]),
    railStyle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
    dotStyle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
    activeDotStyle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
    autoFocus: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
    onFocus: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
    onBlur: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func
  }), _class.defaultProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Component.defaultProps, {
    prefixCls: 'rc-slider',
    className: '',
    min: 0,
    max: 100,
    step: 1,
    marks: {},
    handle: function handle(_ref) {
      var index = _ref.index,
          restProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['index']);

      delete restProps.dragging;
      if (restProps.value === null) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Handle__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, restProps, { key: index }));
    },

    onBeforeChange: noop,
    onChange: noop,
    onAfterChange: noop,
    included: true,
    disabled: false,
    dots: false,
    vertical: false,
    reverse: false,
    trackStyle: [{}],
    handleStyle: [{}],
    railStyle: {},
    dotStyle: {},
    activeDotStyle: {}
  }), _temp;
}

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _FormErrors = _interopRequireDefault(__webpack_require__(38));

var _Validation = __webpack_require__(14);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var AddSurveyGroup =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AddSurveyGroup, _React$Component);

  function AddSurveyGroup(props) {
    var _this;

    _classCallCheck(this, AddSurveyGroup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AddSurveyGroup).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleUserInput", function () {
      var _this2;

      return (_this2 = _this).__handleUserInput__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    var _props$surveyGroup = props.surveyGroup,
        id = _props$surveyGroup.id,
        thumb = _props$surveyGroup.thumb,
        name = _props$surveyGroup.name,
        selected = _props$surveyGroup.selected,
        starred = _props$surveyGroup.starred,
        frequently = _props$surveyGroup.frequently;
    _this.state = {
      id: id,
      thumb: thumb,
      name: name,
      selected: selected,
      starred: starred,
      frequently: frequently,
      nameValid: (0, _Validation.isNameValid)(name),
      formErrors: {
        name: ''
      },
      formValid: false
    };
    return _this;
  }

  _createClass(AddSurveyGroup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.validateForm();
    }
  }, {
    key: "__handleUserInput__REACT_HOT_LOADER__",
    value: function __handleUserInput__REACT_HOT_LOADER__(e) {
      var _this3 = this;

      var name = e.target.name;
      var value = e.target.value;
      this.setState(_defineProperty({}, name, value), function () {
        _this3.validateField(name, value);
      } // run this call back on state change
      );
    }
  }, {
    key: "validateField",
    value: function validateField(fieldName, value) {
      var fieldValidationErrors = this.state.formErrors;
      var nameValid = this.state.nameValid;

      switch (fieldName) {
        case 'name':
          nameValid = (0, _Validation.isNameValid)(value);
          fieldValidationErrors.name = nameValid ? '' : ' is invalid';
          break;

        default:
          break;
      }

      this.setState({
        formErrors: fieldValidationErrors,
        nameValid: nameValid
      }, this.validateForm);
    }
  }, {
    key: "validateForm",
    value: function validateForm() {
      this.setState({
        formValid: this.state.nameValid
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          onSaveSurveyGroup = _this$props.onSaveSurveyGroup,
          showSurveyGroupLoader = _this$props.showSurveyGroupLoader,
          onSurveyGroupClose = _this$props.onSurveyGroupClose,
          open = _this$props.open,
          surveyGroup = _this$props.surveyGroup;
      var _this$state = this.state,
          name = _this$state.name,
          selected = _this$state.selected,
          starred = _this$state.starred,
          frequently = _this$state.frequently;
      var isNew = surveyGroup.name === '';
      var thumb = this.state.thumb;
      return _react["default"].createElement(_reactstrap.Modal, {
        className: "modal-box",
        toggle: onSurveyGroupClose,
        isOpen: open
      }, _react["default"].createElement(_reactstrap.ModalHeader, {
        className: "modal-box-header bg-primary"
      }, isNew ? _react["default"].createElement(_IntlMessages["default"], {
        id: "surveyGroup.addSurveyGroup"
      }) : _react["default"].createElement(_IntlMessages["default"], {
        id: "surveyGroup.saveSurveyGroup"
      }), _react["default"].createElement("span", {
        className: "text-white pointer"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-close zmdi-hc-lg",
        onClick: onSurveyGroupClose
      }))), _react["default"].createElement("div", {
        className: "modal-box-content"
      }, _react["default"].createElement("div", {
        className: "row no-gutters"
      }, _react["default"].createElement("div", {
        className: "col-lg-3 text-center text-lg-right order-lg-2"
      }, _react["default"].createElement("img", {
        className: "ml-lg-3 mb-4 mb-lg-0 avatar size-120",
        src: thumb
      })), _react["default"].createElement("div", {
        className: "panel panel-default"
      }, _react["default"].createElement(_FormErrors["default"], {
        formErrors: this.state.formErrors
      })), _react["default"].createElement("div", {
        className: "col-lg-9 d-flex flex-column order-lg-1"
      }, _react["default"].createElement("input", {
        type: "text",
        className: "form-control mb-2",
        placeholder: "Survey Group Name",
        onChange: function onChange(event) {
          return _this4.handleUserInput(event);
        },
        defaultValue: name,
        name: "name"
      })))), _react["default"].createElement("div", {
        className: "modal-box-footer d-flex flex-row"
      }, _react["default"].createElement(_reactstrap.Button, {
        className: "text-uppercase",
        disabled: !this.state.formValid,
        color: "primary",
        onClick: function onClick() {
          showSurveyGroupLoader();
          onSurveyGroupClose();
          onSaveSurveyGroup({
            'name': name,
            'thumb': null,
            'selected': selected,
            'starred': starred,
            'frequently': frequently
          });

          _this4.setState({
            name: '',
            thumb: null,
            selected: false,
            starred: false,
            frequently: false,
            formErrors: {
              name: ''
            },
            formValid: false
          });
        }
      }, isNew ? _react["default"].createElement(_IntlMessages["default"], {
        id: "surveyGroup.addSurveyGroup"
      }) : _react["default"].createElement(_IntlMessages["default"], {
        id: "surveyGroup.saveSurveyGroup"
      }))));
    }
  }]);

  return AddSurveyGroup;
}(_react["default"].Component);

var _default = AddSurveyGroup;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AddSurveyGroup, "AddSurveyGroup", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/AddSurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/AddSurveyGroup/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/AddSurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/AddSurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_FormErrors, "_FormErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/AddSurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/AddSurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/AddSurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/AddSurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/AddSurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/AddSurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/AddSurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/AddSurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/AddSurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/AddSurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/AddSurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/AddSurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(AddSurveyGroup, "AddSurveyGroup", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/AddSurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/AddSurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/AddSurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/AddSurveyGroup/index.js");
}();

;

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _DayPickerInput = _interopRequireDefault(__webpack_require__(201));

__webpack_require__(198);

var _CardBox = _interopRequireDefault(__webpack_require__(228));

var _FormErrors = _interopRequireDefault(__webpack_require__(38));

var _Validation = __webpack_require__(14);

var _DateService = __webpack_require__(48);

var _DateFormatters = __webpack_require__(43);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ProjectAdd =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ProjectAdd, _React$Component);

  function ProjectAdd(props) {
    var _this;

    _classCallCheck(this, ProjectAdd);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProjectAdd).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleUserInput", function () {
      var _this2;

      return (_this2 = _this).__handleUserInput__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "handleNumberInput", function () {
      var _this3;

      return (_this3 = _this).__handleNumberInput__REACT_HOT_LOADER__.apply(_this3, arguments);
    });

    _this.handleStartDateChange = _this.handleStartDateChange.bind(_assertThisInitialized(_this));
    _this.handleEndDateChange = _this.handleEndDateChange.bind(_assertThisInitialized(_this));
    var _props$project = props.project,
        id = _props$project.id,
        orgid = _props$project.orgid,
        thumb = _props$project.thumb,
        name = _props$project.name,
        description = _props$project.description,
        startDate = _props$project.startDate,
        endDate = _props$project.endDate,
        jiraProjectAttributes = _props$project.jiraProjectAttributes,
        costImplPriorityParams = _props$project.costImplPriorityParams,
        busValPriorityParams = _props$project.busValPriorityParams,
        weight = _props$project.weight,
        budget = _props$project.budget,
        initiative = _props$project.initiative,
        businessValue = _props$project.businessValue,
        starred = _props$project.starred,
        selected = _props$project.selected,
        frequently = _props$project.frequently;
    _this.state = {
      id: id,
      orgid: orgid,
      thumb: thumb,
      name: name,
      description: description,
      startDate: startDate,
      endDate: endDate,
      jiraProjectAttributes: jiraProjectAttributes,
      costImplPriorityParams: costImplPriorityParams,
      busValPriorityParams: busValPriorityParams,
      weight: weight,
      budget: budget,
      initiative: initiative,
      businessValue: businessValue,
      starred: starred,
      selected: selected,
      frequently: frequently,
      nameValid: (0, _Validation.isNameValid)(name),
      startDateValid: (0, _Validation.isValueEntered)(startDate),
      endDateValid: (0, _Validation.isValueEntered)(endDate),
      budgetValid: (0, _Validation.isNumberValid)(budget),
      formErrors: {
        name: '',
        startDate: '',
        endDate: '',
        dates: '',
        budget: ''
      },
      datesValid: false,
      formValid: false
    };
    return _this;
  }

  _createClass(ProjectAdd, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.validateForm();
    }
  }, {
    key: "__handleUserInput__REACT_HOT_LOADER__",
    value: function __handleUserInput__REACT_HOT_LOADER__(e) {
      var _this4 = this;

      var name = e.target.name;
      var value = e.target.value;
      this.setState(_defineProperty({}, name, value), function () {
        _this4.validateField(name, value);
      } // run this call back on state change
      );
    }
  }, {
    key: "__handleNumberInput__REACT_HOT_LOADER__",
    value: function __handleNumberInput__REACT_HOT_LOADER__(e) {
      var _this5 = this;

      var name = e.target.name;
      var value = parseInt(e.target.value);
      this.setState(_defineProperty({}, name, value), function () {
        _this5.validateField(name, value);
      } // run this call back on state change
      );
    }
  }, {
    key: "validateField",
    value: function validateField(fieldName, value) {
      var fieldValidationErrors = this.state.formErrors;
      var nameValid = this.state.nameValid;
      var startDateValid = this.state.startDateValid;
      var endDateValid = this.state.endDateValid;
      var budgetValid = this.state.budgetValid;

      switch (fieldName) {
        case 'name':
          nameValid = (0, _Validation.isNameValid)(value);
          fieldValidationErrors.name = nameValid ? '' : ' is invalid';
          break;

        case 'startDate':
          startDateValid = (0, _Validation.isValueEntered)(value);
          fieldValidationErrors.startDate = startDateValid ? '' : ' is invalid';
          break;

        case 'endDate':
          endDateValid = (0, _Validation.isValueEntered)(value);
          fieldValidationErrors.endDate = endDateValid ? '' : ' is invalid';
          break;

        case 'budget':
          budgetValid = (0, _Validation.isNumberValid)(value);
          fieldValidationErrors.budget = budgetValid ? '' : ' is invalid';
          break;

        default:
          break;
      }

      this.setState({
        formErrors: fieldValidationErrors,
        nameValid: nameValid,
        startDateValid: startDateValid,
        endDateValid: endDateValid,
        budgetValid: budgetValid
      }, this.validateForm);
    }
  }, {
    key: "validateForm",
    value: function validateForm() {
      var datesAreValid = this.datesValid();
      this.setState({
        formValid: this.state.nameValid && datesAreValid && this.state.budgetValid
      });
    }
  }, {
    key: "datesValid",
    value: function datesValid() {
      var _this$state = this.state,
          startDate = _this$state.startDate,
          endDate = _this$state.endDate;
      var fieldValidationErrors = this.state.formErrors;

      if ((0, _Validation.isValueEntered)(startDate) && (0, _Validation.isValueEntered)(endDate)) {
        if ((0, _DateService.isDateBefore)(endDate, startDate)) {
          fieldValidationErrors.dates = ' are invalid. The end date selected cannot be before the start date';
          this.setState({
            formErrors: fieldValidationErrors
          });
          return false;
        }

        fieldValidationErrors.dates = '';
        this.setState({
          formErrors: fieldValidationErrors
        });
        return true;
      }

      return false;
    }
  }, {
    key: "handleStartDateChange",
    value: function handleStartDateChange(selectedDay) {
      var _this6 = this;

      this.setState({
        startDate: selectedDay
      }, function () {
        _this6.validateField('startDate', selectedDay);
      });
    }
  }, {
    key: "handleEndDateChange",
    value: function handleEndDateChange(selectedDay) {
      var _this7 = this;

      this.setState({
        endDate: selectedDay
      }, function () {
        _this7.validateField('endDate', selectedDay);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this8 = this;

      var _this$props = this.props,
          onSaveProject = _this$props.onSaveProject,
          showProjectLoader = _this$props.showProjectLoader,
          onProjectClose = _this$props.onProjectClose,
          open = _this$props.open,
          project = _this$props.project,
          initiatives = _this$props.initiatives;
      var _this$state2 = this.state,
          id = _this$state2.id,
          orgid = _this$state2.orgid,
          name = _this$state2.name,
          description = _this$state2.description,
          startDate = _this$state2.startDate,
          endDate = _this$state2.endDate,
          jiraProjectAttributes = _this$state2.jiraProjectAttributes,
          costImplPriorityParams = _this$state2.costImplPriorityParams,
          busValPriorityParams = _this$state2.busValPriorityParams,
          weight = _this$state2.weight,
          budget = _this$state2.budget,
          initiative = _this$state2.initiative,
          businessValue = _this$state2.businessValue,
          starred = _this$state2.starred,
          selected = _this$state2.selected,
          frequently = _this$state2.frequently;
      var isNew = project.name === '';
      var thumb = this.state.thumb;
      return _react["default"].createElement(_reactstrap.Modal, {
        className: "modal-box",
        toggle: onProjectClose,
        isOpen: open
      }, _react["default"].createElement(_reactstrap.ModalHeader, {
        className: "modal-box-header bg-primary"
      }, isNew ? _react["default"].createElement(_IntlMessages["default"], {
        id: "project.addProject"
      }) : _react["default"].createElement(_IntlMessages["default"], {
        id: "project.saveProject"
      }), _react["default"].createElement("span", {
        className: "text-white pointer"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-close zmdi-hc-lg",
        onClick: onProjectClose
      }))), _react["default"].createElement("div", {
        className: "modal-box-content"
      }, _react["default"].createElement("div", {
        className: "row no-gutters"
      }, _react["default"].createElement("div", {
        className: "col-lg-3 text-center text-lg-right order-lg-2"
      }, _react["default"].createElement("img", {
        className: "ml-lg-3 mb-4 mb-lg-0 avatar size-120",
        src: "assets/images/project-1_225_225.jpg"
      })), _react["default"].createElement("div", {
        className: "panel panel-default"
      }, _react["default"].createElement(_FormErrors["default"], {
        formErrors: this.state.formErrors
      })), _react["default"].createElement("div", {
        className: "col-lg-9 d-flex flex-column order-lg-1"
      }, _react["default"].createElement("h3", {
        className: "card-heading"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "label.name"
      })), _react["default"].createElement("input", {
        type: "text",
        className: "form-control mb-2 ".concat(name ? 'is-valid' : 'is-invalid'),
        onChange: function onChange(event) {
          return _this8.handleUserInput(event);
        },
        defaultValue: name,
        name: "name"
      }), _react["default"].createElement("h3", {
        className: "card-heading"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "label.description"
      })), _react["default"].createElement("input", {
        type: "text",
        className: "form-control mb-2",
        onChange: function onChange(event) {
          return _this8.handleUserInput(event);
        },
        defaultValue: description,
        name: "description"
      }), _react["default"].createElement("h3", {
        className: "card-heading"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "label.budget"
      })), _react["default"].createElement(_reactstrap.Input, {
        type: "number",
        className: "form-control mb-2 ".concat(budget ? 'is-valid' : 'is-invalid'),
        onChange: function onChange(event) {
          return _this8.handleNumberInput(event);
        },
        defaultValue: budget,
        name: "budget"
      }), _react["default"].createElement("h3", {
        className: "card-heading"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "label.initiative"
      })), _react["default"].createElement(_reactstrap.Input, {
        type: "select",
        name: "initiative",
        id: "initiativeSelect",
        onChange: function onChange(event) {
          return _this8.handleUserInput(event);
        }
      }, _react["default"].createElement("option", {
        key: "emptySelect",
        value: ""
      }, "-- select initiative --"), initiatives.map(function (initiative) {
        return _react["default"].createElement("option", {
          key: initiative.id,
          value: initiative.id
        }, initiative.name);
      })), _react["default"].createElement("h3", {
        className: "card-heading mt-2"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "label.startDate"
      })), _react["default"].createElement("div", {
        className: "form-control ".concat(startDate ? 'is-valid' : 'is-invalid')
      }, _react["default"].createElement(_DayPickerInput["default"], {
        value: (0, _DateFormatters.formatDateDefault)(startDate),
        onDayChange: this.handleStartDateChange,
        dayPickerProps: {
          selectedDays: new Date(startDate)
        }
      })), _react["default"].createElement("h3", {
        className: "card-heading mt-2"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "label.endDate"
      })), _react["default"].createElement("div", {
        className: "form-control ".concat(endDate ? 'is-valid' : 'is-invalid')
      }, _react["default"].createElement(_DayPickerInput["default"], {
        value: (0, _DateFormatters.formatDateDefault)(endDate),
        onDayChange: this.handleEndDateChange,
        dayPickerProps: {
          selectedDays: new Date(endDate)
        }
      })), _react["default"].createElement("h3", {
        className: "card-heading mt-2"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "project.projectBusinessValueIndicator"
      })), _react["default"].createElement(_reactstrap.Input, {
        type: "text",
        className: "form-control",
        onChange: function onChange(event) {
          return _this8.handleUserInput(event);
        },
        defaultValue: businessValue,
        name: "businessValue"
      })))), _react["default"].createElement("div", {
        className: "modal-box-footer d-flex flex-row"
      }, _react["default"].createElement(_reactstrap.Button, {
        className: "text-uppercase",
        disabled: !this.state.formValid,
        color: "primary",
        onClick: function onClick() {
          showProjectLoader();
          onProjectClose();
          onSaveProject({
            'id': id,
            'orgid': orgid,
            'name': name,
            'description': description,
            'startDate': startDate,
            'endDate': endDate,
            'jiraProjectAttributes': jiraProjectAttributes,
            'costImplPriorityParams': costImplPriorityParams,
            'busValPriorityParams': busValPriorityParams,
            'weight': weight,
            'budget': budget,
            'initiative': initiative,
            'businessValue': businessValue,
            'starred': starred,
            'selected': selected,
            'frequently': frequently,
            'thumb': null
          });

          _this8.setState({
            id: '',
            orgid: '',
            name: '',
            description: '',
            startDate: '',
            endDate: '',
            budget: '',
            initiative: '',
            businessValue: '',
            starred: false,
            selected: false,
            frequently: false,
            thumb: null,
            formErrors: {
              name: '',
              startDate: '',
              endDate: '',
              dates: '',
              budget: ''
            },
            datesValid: false,
            formValid: false
          });
        }
      }, isNew ? _react["default"].createElement(_IntlMessages["default"], {
        id: "project.addProject"
      }) : _react["default"].createElement(_IntlMessages["default"], {
        id: "project.saveProject"
      }))));
    }
  }]);

  return ProjectAdd;
}(_react["default"].Component);

var _default = ProjectAdd;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProjectAdd, "ProjectAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectAdd/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectAdd/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectAdd/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectAdd/index.js");

  __REACT_HOT_LOADER__.register(_DayPickerInput, "_DayPickerInput", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectAdd/index.js");

  __REACT_HOT_LOADER__.register(_CardBox, "_CardBox", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectAdd/index.js");

  __REACT_HOT_LOADER__.register(_FormErrors, "_FormErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectAdd/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectAdd/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectAdd/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectAdd/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectAdd/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectAdd/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectAdd/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectAdd/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectAdd/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectAdd/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectAdd/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectAdd/index.js");

  __REACT_HOT_LOADER__.register(ProjectAdd, "ProjectAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectAdd/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectAdd/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectAdd/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectAdd/index.js");
}();

;

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ProjectDetailRow = function ProjectDetailRow(_ref) {
  var label = _ref.label,
      description = _ref.description;
  return _react["default"].createElement("tr", null, _react["default"].createElement("td", null, _react["default"].createElement("div", {
    className: "user-profile d-flex flex-row align-items-center"
  }, _react["default"].createElement("div", {
    className: "user-detail"
  }, _react["default"].createElement("h5", {
    className: "user-name"
  }, label, " ")))), _react["default"].createElement("td", {
    className: "text-right"
  }, _react["default"].createElement("div", null, description)));
};

var _default = ProjectDetailRow;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProjectDetailRow, "ProjectDetailRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectDetailRow/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectDetailRow/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectDetailRow/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectDetailRow/index.js");

  __REACT_HOT_LOADER__.register(ProjectDetailRow, "ProjectDetailRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectDetailRow/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectDetailRow/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectDetailRow/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectDetailRow/index.js");
}();

;

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _FormErrors = _interopRequireDefault(__webpack_require__(38));

var _Validation = __webpack_require__(14);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var MIN_PRIORITY = 0;
var MAX_PRIORITY = 100;

var ProjectPriorityAdd =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ProjectPriorityAdd, _React$Component);

  function ProjectPriorityAdd(props) {
    var _this;

    _classCallCheck(this, ProjectPriorityAdd);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProjectPriorityAdd).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleUserNumberInput", function () {
      var _this2;

      return (_this2 = _this).__handleUserNumberInput__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "handleUserInput", function () {
      var _this3;

      return (_this3 = _this).__handleUserInput__REACT_HOT_LOADER__.apply(_this3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "updateProjectPriority", function () {
      var _this4;

      return (_this4 = _this).__updateProjectPriority__REACT_HOT_LOADER__.apply(_this4, arguments);
    });

    var updatingGlobalPriorities = _this.props.updatingGlobalPriorities;
    var _props$projectPriorit = props.projectPriority,
        id = _props$projectPriorit.id,
        name = _props$projectPriorit.name,
        description = _props$projectPriorit.description,
        value = _props$projectPriorit.value;
    _this.state = {
      id: id,
      name: name,
      description: description,
      value: value,
      nameValid: updatingGlobalPriorities ? true : (0, _Validation.isNameValid)(name),
      valueValid: updatingGlobalPriorities ? (0, _Validation.isNumberEnteredValid)(value, MIN_PRIORITY, MAX_PRIORITY) : true,
      formErrors: {
        name: '',
        value: '',
        number: ''
      },
      formValid: false
    };
    return _this;
  }

  _createClass(ProjectPriorityAdd, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.validateForm();
    }
  }, {
    key: "__handleUserNumberInput__REACT_HOT_LOADER__",
    value: function __handleUserNumberInput__REACT_HOT_LOADER__(e) {
      var _this5 = this;

      var fieldValidationErrors = this.state.formErrors;
      var name = e.target.name;
      var value = Number(e.target.value); // TODO injects NaN into the field so need to display message and revert/block the change

      if (isNaN(value)) {
        fieldValidationErrors.number = ' - the entry must be a number.';
        var origValue = this.state[name];
        this.setState(_defineProperty({}, name, origValue));
      } else {
        fieldValidationErrors.number = '';
        this.setState(_defineProperty({}, name, value), function () {
          _this5.validateField(name, value);
        } // run this call back on state change
        );
      }
    }
  }, {
    key: "__handleUserInput__REACT_HOT_LOADER__",
    value: function __handleUserInput__REACT_HOT_LOADER__(e) {
      var _this6 = this;

      var name = e.target.name;
      var value = e.target.value;
      this.setState(_defineProperty({}, name, value), function () {
        _this6.validateField(name, value);
      } // run this call back on state change
      );
    }
  }, {
    key: "validateField",
    value: function validateField(fieldName, value) {
      var fieldValidationErrors = this.state.formErrors;
      var nameValid = this.state.nameValid;
      var valueValid = this.state.valueValid;
      var updatingGlobalPriorities = this.props.updatingGlobalPriorities;

      switch (fieldName) {
        case 'name':
          if (updatingGlobalPriorities) {
            nameValid = (0, _Validation.isNameValid)(value);
            fieldValidationErrors.name = nameValid ? '' : ' is invalid';
          } else {
            nameValid = true; // not required when changing individual project priorities - only the value can be changed

            fieldValidationErrors.name = '';
          }

          break;

        case 'value':
          if (!updatingGlobalPriorities) {
            valueValid = (0, _Validation.isNumberEnteredValid)(value, MIN_PRIORITY, MAX_PRIORITY);
            fieldValidationErrors.value = valueValid ? '' : ' is invalid. It must be a number > '.concat(MIN_PRIORITY).concat(' and <= ').concat(MAX_PRIORITY);
          } else {
            valueValid = true; // not required when changing all the project priorities - just the name is required

            fieldValidationErrors.value = '';
          }

          break;

        default:
          break;
      }

      this.setState({
        formErrors: fieldValidationErrors,
        nameValid: nameValid,
        valueValid: valueValid
      }, this.validateForm);
    }
  }, {
    key: "validateForm",
    value: function validateForm() {
      this.setState({
        formValid: this.state.nameValid && this.state.valueValid
      });
    }
  }, {
    key: "__updateProjectPriority__REACT_HOT_LOADER__",
    value: function __updateProjectPriority__REACT_HOT_LOADER__() {
      var _this$state = this.state,
          id = _this$state.id,
          name = _this$state.name,
          description = _this$state.description,
          value = _this$state.value;
      var _this$props = this.props,
          showProjectPriorityLoader = _this$props.showProjectPriorityLoader,
          onSaveProjectPriority = _this$props.onSaveProjectPriority,
          updatingGlobalPriorities = _this$props.updatingGlobalPriorities,
          onProjectPriorityClose = _this$props.onProjectPriorityClose,
          showProjectLoader = _this$props.showProjectLoader,
          onUpdateProjectPriorities = _this$props.onUpdateProjectPriorities;
      var data = {
        'id': id,
        'name': name,
        'description': description,
        'value': value
      };
      onProjectPriorityClose();

      if (updatingGlobalPriorities) {
        showProjectLoader();
        onUpdateProjectPriorities(data); // calls the api to update all corresponding priorities
      } else {
        showProjectPriorityLoader();
        onSaveProjectPriority(data); // just update the one instance - not all
      }

      this.setState({
        id: '',
        name: '',
        active: true,
        value: 0,
        formErrors: {
          name: '',
          value: '',
          number: ''
        },
        formValid: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      var _this$props2 = this.props,
          onProjectPriorityClose = _this$props2.onProjectPriorityClose,
          open = _this$props2.open,
          projectPriority = _this$props2.projectPriority,
          updatingGlobalPriorities = _this$props2.updatingGlobalPriorities;
      var _this$state2 = this.state,
          name = _this$state2.name,
          description = _this$state2.description,
          value = _this$state2.value;
      var isNew = projectPriority.id === '';
      var thumb = this.state.thumb;
      return _react["default"].createElement(_reactstrap.Modal, {
        className: "modal-box",
        toggle: onProjectPriorityClose,
        isOpen: open
      }, _react["default"].createElement(_reactstrap.ModalHeader, {
        className: "modal-box-header bg-primary"
      }, isNew ? _react["default"].createElement(_IntlMessages["default"], {
        id: "projectPriority.addProjectPriority"
      }) : _react["default"].createElement(_IntlMessages["default"], {
        id: "projectPriority.saveProjectPriority"
      }), _react["default"].createElement("span", {
        className: "text-white pointer"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-close zmdi-hc-lg",
        onClick: onProjectPriorityClose
      }))), _react["default"].createElement("div", {
        className: "modal-box-content"
      }, _react["default"].createElement("div", {
        className: "row no-gutters"
      }, _react["default"].createElement("div", {
        className: "col-lg-3 text-center text-lg-right order-lg-2"
      }, _react["default"].createElement("img", {
        className: "ml-lg-3 mb-4 mb-lg-0 avatar size-120",
        src: thumb
      })), _react["default"].createElement("div", {
        className: "panel panel-default"
      }, _react["default"].createElement(_FormErrors["default"], {
        formErrors: this.state.formErrors
      })), _react["default"].createElement("div", {
        className: "col-lg-9 d-flex flex-column order-lg-1"
      }, _react["default"].createElement("input", {
        type: "text",
        className: "form-control mb-2",
        placeholder: "Name",
        onChange: function onChange(event) {
          return _this7.handleUserInput(event);
        },
        defaultValue: name,
        name: "name",
        disabled: !updatingGlobalPriorities
      }), _react["default"].createElement("input", {
        type: "text",
        className: "form-control mb-2",
        placeholder: "Description",
        onChange: function onChange(event) {
          return _this7.handleUserInput(event);
        },
        defaultValue: description,
        name: "description",
        disabled: !updatingGlobalPriorities
      }), updatingGlobalPriorities ? null : _react["default"].createElement("input", {
        type: "text",
        className: "form-control mb-2",
        placeholder: "Value",
        onChange: function onChange(event) {
          return _this7.handleUserNumberInput(event);
        },
        value: value,
        name: "value"
      })))), _react["default"].createElement("div", {
        className: "modal-box-footer d-flex flex-row"
      }, _react["default"].createElement(_reactstrap.Button, {
        className: "text-uppercase",
        disabled: !this.state.formValid,
        color: "primary",
        onClick: function onClick() {
          _this7.updateProjectPriority();
        }
      }, isNew ? _react["default"].createElement(_IntlMessages["default"], {
        id: "projectPriority.addProjectPriority"
      }) : _react["default"].createElement(_IntlMessages["default"], {
        id: "projectPriority.saveProjectPriority"
      }))));
    }
  }]);

  return ProjectPriorityAdd;
}(_react["default"].Component);

var _default = ProjectPriorityAdd;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MIN_PRIORITY, "MIN_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(MAX_PRIORITY, "MAX_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(ProjectPriorityAdd, "ProjectPriorityAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityAdd/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_FormErrors, "_FormErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(MIN_PRIORITY, "MIN_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(MAX_PRIORITY, "MAX_PRIORITY", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(ProjectPriorityAdd, "ProjectPriorityAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityAdd/index.js");
}();

;

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _FormErrors = _interopRequireDefault(__webpack_require__(38));

var _Validation = __webpack_require__(14);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SecurityAdd =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SecurityAdd, _React$Component);

  function SecurityAdd(props) {
    var _this;

    _classCallCheck(this, SecurityAdd);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SecurityAdd).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleUserInput", function () {
      var _this2;

      return (_this2 = _this).__handleUserInput__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    var _props$security = props.security,
        id = _props$security.id,
        orgid = _props$security.orgid,
        thumb = _props$security.thumb,
        name = _props$security.name,
        key = _props$security.key,
        url = _props$security.url,
        account = _props$security.account,
        selected = _props$security.selected,
        starred = _props$security.starred,
        frequently = _props$security.frequently;
    _this.state = {
      id: id,
      orgid: orgid,
      thumb: thumb,
      name: name,
      key: key,
      url: url,
      account: account,
      selected: selected,
      starred: starred,
      frequently: frequently,
      nameValid: (0, _Validation.isNameValid)(name),
      keyValid: (0, _Validation.isValueEntered)(key),
      urlValid: (0, _Validation.isValueEntered)(url),
      accountValid: (0, _Validation.isValueEntered)(account),
      formErrors: {
        name: '',
        key: '',
        url: '',
        account: ''
      },
      formValid: false
    };
    return _this;
  }

  _createClass(SecurityAdd, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.validateForm();
    }
  }, {
    key: "__handleUserInput__REACT_HOT_LOADER__",
    value: function __handleUserInput__REACT_HOT_LOADER__(e) {
      var _this3 = this;

      var name = e.target.name;
      var value = e.target.value;
      this.setState(_defineProperty({}, name, value), function () {
        _this3.validateField(name, value);
      } // run this call back on state change
      );
    }
  }, {
    key: "validateField",
    value: function validateField(fieldName, value) {
      var fieldValidationErrors = this.state.formErrors;
      var nameValid = this.state.nameValid;
      var keyValid = this.state.keyValid;
      var urlValid = this.state.urlValid;
      var accountValid = this.state.accountValid;

      switch (fieldName) {
        case 'name':
          nameValid = (0, _Validation.isNameValid)(value);
          fieldValidationErrors.name = nameValid ? '' : ' is invalid';
          break;

        case 'key':
          keyValid = (0, _Validation.isValueEntered)(value);
          fieldValidationErrors.key = keyValid ? '' : ' is invalid';
          break;

        case 'url':
          urlValid = (0, _Validation.isValueEntered)(value);
          fieldValidationErrors.url = urlValid ? '' : ' is invalid';
          break;

        case 'account':
          accountValid = (0, _Validation.isValueEntered)(value);
          fieldValidationErrors.account = accountValid ? '' : ' is invalid';
          break;

        default:
          break;
      }

      this.setState({
        formErrors: fieldValidationErrors,
        nameValid: nameValid,
        keyValid: keyValid,
        urlValid: urlValid,
        accountValid: accountValid
      }, this.validateForm);
    }
  }, {
    key: "validateForm",
    value: function validateForm() {
      this.setState({
        formValid: this.state.nameValid && this.state.keyValid && this.state.urlValid && this.state.accountValid
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          onSaveSecurity = _this$props.onSaveSecurity,
          showSecurityLoader = _this$props.showSecurityLoader,
          onSecurityClose = _this$props.onSecurityClose,
          open = _this$props.open,
          security = _this$props.security;
      var _this$state = this.state,
          id = _this$state.id,
          orgid = _this$state.orgid,
          name = _this$state.name,
          key = _this$state.key,
          url = _this$state.url,
          account = _this$state.account,
          selected = _this$state.selected,
          starred = _this$state.starred,
          frequently = _this$state.frequently;
      var isNew = security.name === '';
      var thumb = this.state.thumb;
      return _react["default"].createElement(_reactstrap.Modal, {
        className: "modal-box",
        toggle: onSecurityClose,
        isOpen: open
      }, _react["default"].createElement(_reactstrap.ModalHeader, {
        className: "modal-box-header bg-primary"
      }, isNew ? _react["default"].createElement(_IntlMessages["default"], {
        id: "security.addSecurity"
      }) : _react["default"].createElement(_IntlMessages["default"], {
        id: "security.saveSecurity"
      }), _react["default"].createElement("span", {
        className: "text-white pointer"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-close zmdi-hc-lg",
        onClick: onSecurityClose
      }))), _react["default"].createElement("div", {
        className: "modal-box-content"
      }, _react["default"].createElement("div", {
        className: "row no-gutters"
      }, _react["default"].createElement("div", {
        className: "col-lg-3 text-center text-lg-right order-lg-2"
      }, _react["default"].createElement("img", {
        id: "thumb",
        className: "ml-lg-3 mb-4 mb-lg-0 avatar size-120",
        src: thumb
      })), _react["default"].createElement("div", {
        className: "panel panel-default"
      }, _react["default"].createElement(_FormErrors["default"], {
        formErrors: this.state.formErrors
      })), _react["default"].createElement("div", {
        className: "col-lg-9 d-flex flex-column order-lg-1"
      }, _react["default"].createElement("h3", {
        className: "card-heading"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "label.name"
      })), _react["default"].createElement("input", {
        id: "name",
        type: "text",
        className: "form-control mb-2 ".concat(name ? 'is-valid' : 'is-invalid'),
        onChange: function onChange(event) {
          return _this4.handleUserInput(event);
        },
        defaultValue: name,
        name: "name"
      }), _react["default"].createElement("h3", {
        className: "card-heading"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "label.key"
      })), _react["default"].createElement("input", {
        id: "key",
        type: "text",
        className: "form-control mb-2 ".concat(key ? 'is-valid' : 'is-invalid'),
        onChange: function onChange(event) {
          return _this4.handleUserInput(event);
        },
        defaultValue: key,
        name: "key"
      }), _react["default"].createElement("h3", {
        className: "card-heading"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "label.url"
      })), _react["default"].createElement("input", {
        id: "url",
        type: "text",
        className: "form-control mb-2 ".concat(url ? 'is-valid' : 'is-invalid'),
        onChange: function onChange(event) {
          return _this4.handleUserInput(event);
        },
        value: url,
        name: "url"
      }), _react["default"].createElement("h3", {
        className: "card-heading"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "label.account"
      })), _react["default"].createElement("input", {
        id: "account",
        type: "text",
        className: "form-control mb-2 ".concat(account ? 'is-valid' : 'is-invalid'),
        onChange: function onChange(event) {
          return _this4.handleUserInput(event);
        },
        value: account,
        name: "account"
      })))), _react["default"].createElement("div", {
        className: "modal-box-footer d-flex flex-row"
      }, _react["default"].createElement(_reactstrap.Button, {
        className: "text-uppercase",
        disabled: !this.state.formValid,
        color: "primary",
        onClick: function onClick() {
          showSecurityLoader();
          onSecurityClose();
          onSaveSecurity({
            'id': id,
            'orgid': orgid,
            'name': name,
            'key': key,
            'url': url,
            'account': account,
            'thumb': null,
            'selected': selected,
            'starred': starred,
            'frequently': frequently
          });

          _this4.setState({
            id: '',
            orgid: '',
            name: '',
            key: '',
            url: '',
            account: '',
            thumb: null,
            selected: false,
            starred: false,
            frequently: false,
            formErrors: {
              name: '',
              key: '',
              url: '',
              account: ''
            },
            formValid: false
          });
        }
      }, isNew ? _react["default"].createElement(_IntlMessages["default"], {
        id: "security.addSecurity"
      }) : _react["default"].createElement(_IntlMessages["default"], {
        id: "security.saveSecurity"
      }))));
    }
  }]);

  return SecurityAdd;
}(_react["default"].Component);

var _default = SecurityAdd;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SecurityAdd, "SecurityAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityAdd/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityAdd/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityAdd/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityAdd/index.js");

  __REACT_HOT_LOADER__.register(_FormErrors, "_FormErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityAdd/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityAdd/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityAdd/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityAdd/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityAdd/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityAdd/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityAdd/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityAdd/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityAdd/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityAdd/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityAdd/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityAdd/index.js");

  __REACT_HOT_LOADER__.register(SecurityAdd, "SecurityAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityAdd/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityAdd/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityAdd/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityAdd/index.js");
}();

;

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _projectIssueDetailRow = _interopRequireDefault(__webpack_require__(1902));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var ProjectIssueDetailTable = function ProjectIssueDetailTable(_ref) {
  var displayData = _ref.displayData;

  if (displayData) {
    return _react["default"].createElement("table", {
      className: "default-table table table-sm table-responsive-sm table-hover"
    }, _react["default"].createElement("tbody", null, _react["default"].createElement(_projectIssueDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.priority"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.priority
    }), _react["default"].createElement(_projectIssueDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.status"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.status
    }), _react["default"].createElement(_projectIssueDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.progress.total"
      }),
      description: "".concat(displayData === null || displayData === void 0 ? void 0 : displayData.progress, "/ ").concat(displayData === null || displayData === void 0 ? void 0 : displayData.progressTotal)
    }), _react["default"].createElement(_projectIssueDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.createdDate"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.created
    }), _react["default"].createElement(_projectIssueDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.resolutionDate"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.resolutionDate
    }), (displayData === null || displayData === void 0 ? void 0 : displayData.resolution) ? _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(_projectIssueDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.resolution.type"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.resolutionType
    }), _react["default"].createElement(_projectIssueDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.resolution.description"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.resolutionDescription
    })) : null, (displayData === null || displayData === void 0 ? void 0 : displayData.subtasks) ? _react["default"].createElement(_projectIssueDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.sub.tasks"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.subtasks
    }) : null));
  } else {
    return _react["default"].createElement(_react.Fragment, null);
  }
};

var _default = ProjectIssueDetailTable;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProjectIssueDetailTable, "ProjectIssueDetailTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/projectIssueDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/projectIssueDetailTable/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/projectIssueDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/projectIssueDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_projectIssueDetailRow, "_projectIssueDetailRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/projectIssueDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/projectIssueDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/projectIssueDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/projectIssueDetailTable/index.js");

  __REACT_HOT_LOADER__.register(ProjectIssueDetailTable, "ProjectIssueDetailTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/projectIssueDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/projectIssueDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/projectIssueDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/projectIssueDetailTable/index.js");
}();

;

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _FormErrors = _interopRequireDefault(__webpack_require__(38));

var _Validation = __webpack_require__(14);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var BusinessUnitAdd =
/*#__PURE__*/
function (_React$Component) {
  _inherits(BusinessUnitAdd, _React$Component);

  function BusinessUnitAdd(props) {
    var _this;

    _classCallCheck(this, BusinessUnitAdd);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BusinessUnitAdd).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleUserInput", function () {
      var _this2;

      return (_this2 = _this).__handleUserInput__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    var _props$businessUnit = props.businessUnit,
        id = _props$businessUnit.id,
        orgid = _props$businessUnit.orgid,
        thumb = _props$businessUnit.thumb,
        name = _props$businessUnit.name,
        description = _props$businessUnit.description,
        selected = _props$businessUnit.selected,
        starred = _props$businessUnit.starred,
        frequently = _props$businessUnit.frequently;
    _this.state = {
      id: id,
      orgid: orgid,
      thumb: thumb,
      name: name,
      description: description,
      selected: selected,
      starred: starred,
      frequently: frequently,
      nameValid: (0, _Validation.isNameValid)(name),
      formErrors: {
        name: ''
      },
      formValid: false
    };
    return _this;
  }

  _createClass(BusinessUnitAdd, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.validateForm();
    }
  }, {
    key: "__handleUserInput__REACT_HOT_LOADER__",
    value: function __handleUserInput__REACT_HOT_LOADER__(e) {
      var _this3 = this;

      var name = e.target.name;
      var value = e.target.value;
      this.setState(_defineProperty({}, name, value), function () {
        _this3.validateField(name, value);
      } // run this call back on state change
      );
    }
  }, {
    key: "validateField",
    value: function validateField(fieldName, value) {
      var fieldValidationErrors = this.state.formErrors;
      var nameValid = this.state.nameValid;

      switch (fieldName) {
        case 'name':
          nameValid = (0, _Validation.isNameValid)(value);
          fieldValidationErrors.name = nameValid ? '' : ' is invalid';
          break;

        default:
          break;
      }

      this.setState({
        formErrors: fieldValidationErrors,
        nameValid: nameValid
      }, this.validateForm);
    }
  }, {
    key: "validateForm",
    value: function validateForm() {
      this.setState({
        formValid: this.state.nameValid
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          onSaveBusinessUnit = _this$props.onSaveBusinessUnit,
          showBusinessUnitLoader = _this$props.showBusinessUnitLoader,
          onBusinessUnitClose = _this$props.onBusinessUnitClose,
          open = _this$props.open,
          businessUnit = _this$props.businessUnit;
      var _this$state = this.state,
          id = _this$state.id,
          orgid = _this$state.orgid,
          name = _this$state.name,
          description = _this$state.description,
          selected = _this$state.selected,
          starred = _this$state.starred,
          frequently = _this$state.frequently;
      var isNew = businessUnit.name === '';
      var thumb = this.state.thumb;
      return _react["default"].createElement(_reactstrap.Modal, {
        className: "modal-box",
        toggle: onBusinessUnitClose,
        isOpen: open
      }, _react["default"].createElement(_reactstrap.ModalHeader, {
        className: "modal-box-header bg-primary"
      }, isNew ? _react["default"].createElement(_IntlMessages["default"], {
        id: "businessUnit.addBusinessUnit"
      }) : _react["default"].createElement(_IntlMessages["default"], {
        id: "businessUnit.saveBusinessUnit"
      }), _react["default"].createElement("span", {
        className: "text-white pointer"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-close zmdi-hc-lg",
        onClick: onBusinessUnitClose
      }))), _react["default"].createElement("div", {
        className: "modal-box-content"
      }, _react["default"].createElement("div", {
        className: "row no-gutters"
      }, _react["default"].createElement("div", {
        className: "col-lg-3 text-center text-lg-right order-lg-2"
      }, _react["default"].createElement("img", {
        id: "thumb",
        className: "ml-lg-3 mb-4 mb-lg-0 avatar size-120",
        src: thumb
      })), _react["default"].createElement("div", {
        className: "panel panel-default"
      }, _react["default"].createElement(_FormErrors["default"], {
        formErrors: this.state.formErrors
      })), _react["default"].createElement("div", {
        className: "col-lg-9 d-flex flex-column order-lg-1"
      }, _react["default"].createElement("h3", {
        className: "card-heading"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "label.name"
      })), _react["default"].createElement("input", {
        id: "name",
        type: "text",
        className: "form-control mb-2 ".concat(name ? 'is-valid' : 'is-invalid'),
        onChange: function onChange(event) {
          return _this4.handleUserInput(event);
        },
        defaultValue: name,
        name: "name"
      }), _react["default"].createElement("h3", {
        className: "card-heading"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "label.description"
      })), _react["default"].createElement("input", {
        id: "description",
        type: "text",
        className: "form-control mb-2",
        onChange: function onChange(event) {
          return _this4.handleUserInput(event);
        },
        defaultValue: description,
        name: "description"
      })))), _react["default"].createElement("div", {
        className: "modal-box-footer d-flex flex-row"
      }, _react["default"].createElement(_reactstrap.Button, {
        className: "text-uppercase",
        disabled: !this.state.formValid,
        color: "primary",
        onClick: function onClick() {
          showBusinessUnitLoader();
          onBusinessUnitClose();
          onSaveBusinessUnit({
            'id': id,
            'orgid': orgid,
            'name': name,
            'description': description,
            'thumb': thumb,
            'selected': selected,
            'starred': starred,
            'frequently': frequently
          });

          _this4.setState({
            id: '',
            orgid: '',
            name: '',
            description: '',
            thumb: null,
            selected: false,
            starred: false,
            frequently: false,
            formErrors: {
              name: ''
            },
            formValid: false
          });
        }
      }, isNew ? _react["default"].createElement(_IntlMessages["default"], {
        id: "businessUnit.addBusinessUnit"
      }) : _react["default"].createElement(_IntlMessages["default"], {
        id: "businessUnit.saveBusinessUnit"
      }))));
    }
  }]);

  return BusinessUnitAdd;
}(_react["default"].Component);

var _default = BusinessUnitAdd;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(BusinessUnitAdd, "BusinessUnitAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitAdd/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitAdd/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitAdd/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitAdd/index.js");

  __REACT_HOT_LOADER__.register(_FormErrors, "_FormErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitAdd/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitAdd/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitAdd/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitAdd/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitAdd/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitAdd/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitAdd/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitAdd/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitAdd/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitAdd/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitAdd/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitAdd/index.js");

  __REACT_HOT_LOADER__.register(BusinessUnitAdd, "BusinessUnitAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitAdd/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitAdd/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitAdd/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitAdd/index.js");
}();

;

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initProps = exports.modalHeader = exports.showErrors = exports.displayedImage = exports.inputFields = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _FormErrors = _interopRequireDefault(__webpack_require__(38));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var inputFields = function inputFields(data, handleUserInput) {
  return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
    className: "col-lg-9 d-flex flex-column order-lg-1"
  }, _react["default"].createElement("h3", {
    className: "card-heading"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.name"
  })), _react["default"].createElement(_reactstrap.Input, {
    id: "name",
    type: "text",
    className: "form-control mb-2 ".concat((data === null || data === void 0 ? void 0 : data.name) ? 'is-valid' : 'is-invalid'),
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    defaultValue: data === null || data === void 0 ? void 0 : data.name,
    name: "name"
  }), _react["default"].createElement("h3", {
    className: "card-heading"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.description"
  })), _react["default"].createElement(_reactstrap.Input, {
    id: "description",
    type: "text",
    className: "form-control mb-2",
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    defaultValue: data === null || data === void 0 ? void 0 : data.description,
    name: "description"
  })));
};

exports.inputFields = inputFields;

var displayedImage = function displayedImage(selectedPortfolio) {
  return _react["default"].createElement("div", {
    className: "col-lg-3 text-center text-lg-right order-lg-2"
  }, _react["default"].createElement("img", {
    id: "thumb",
    className: "ml-lg-3 mb-4 mb-lg-0 avatar size-120",
    src: (selectedPortfolio === null || selectedPortfolio === void 0 ? void 0 : selectedPortfolio.thumb) || 'assets/images/portfolios-1_225_225.jpg'
  }));
};

exports.displayedImage = displayedImage;

var showErrors = function showErrors(formErrors) {
  if (formErrors) {
    return _react["default"].createElement("div", {
      className: "panel panel-default"
    }, _react["default"].createElement(_FormErrors["default"], {
      formErrors: formErrors
    }));
  }

  return null;
};

exports.showErrors = showErrors;

var modalHeader = function modalHeader(title, modalHeaderOnClick) {
  return _react["default"].createElement(_reactstrap.ModalHeader, {
    className: "modal-box-header bg-primary"
  }, title, _react["default"].createElement("span", {
    className: "text-white pointer"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-close zmdi-hc-lg",
    onClick: modalHeaderOnClick()
  })));
};

exports.modalHeader = modalHeader;

var initProps = function initProps() {
  return {
    id: '',
    orgid: '',
    name: '',
    description: '',
    starred: false,
    frequently: false
  };
};

exports.initProps = initProps;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(inputFields, "inputFields", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/common.js");

  __REACT_HOT_LOADER__.register(displayedImage, "displayedImage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/common.js");

  __REACT_HOT_LOADER__.register(showErrors, "showErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/common.js");

  __REACT_HOT_LOADER__.register(modalHeader, "modalHeader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/common.js");

  __REACT_HOT_LOADER__.register(initProps, "initProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/common.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_FormErrors, "_FormErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/common.js");

  __REACT_HOT_LOADER__.register(inputFields, "inputFields", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/common.js");

  __REACT_HOT_LOADER__.register(displayedImage, "displayedImage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/common.js");

  __REACT_HOT_LOADER__.register(showErrors, "showErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/common.js");

  __REACT_HOT_LOADER__.register(modalHeader, "modalHeader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/common.js");

  __REACT_HOT_LOADER__.register(initProps, "initProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/common.js");
}();

;

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactCollapsible = _interopRequireDefault(__webpack_require__(161));

var _ContainerHeader = _interopRequireDefault(__webpack_require__(63));

var _basicDetailRow = _interopRequireDefault(__webpack_require__(157));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/**
 * Pass in an array that has the format
 * const entries = [
    {
        name: 'name 1',
        drillDownData: [
            { label: 'label 1', description: 'description 1' },
            { label: 'label 2', description: 'description 2' },
            { label: 'label 3', description: 'description 3' }
        ]
    },
    {
        name: 'name 2',
        drillDownData: [
            { label: 'label 1', description: 'description 1' },
            { label: 'label 2', description: 'description 2' },
            { label: 'label 3', description: 'description 3' }
        ]
    }
];
 * @param {Array} Array of objects that contain the keys, name: string and drillDownData: array
 */


var MultiDetailDrillDown = function MultiDetailDrillDown(_ref) {
  var entries = _ref.entries,
      title = _ref.title;

  if (entries && Array.isArray(entries) && entries.length > 0) {
    return _react["default"].createElement(_react.Fragment, null, title ? _react["default"].createElement(_ContainerHeader["default"], {
      title: title
    }) : null, _react["default"].createElement("div", {
      className: "row"
    }, _react["default"].createElement("div", {
      className: "col-md-12 col-sm-12 col-12"
    }, entries.map(function (entry, index) {
      return _react["default"].createElement(_reactCollapsible["default"], {
        trigger: entry === null || entry === void 0 ? void 0 : entry.name,
        key: index,
        triggerStyle: {
          afterTop: 2,
          backgroundColor: 'black',
          paddingTop: 8,
          paddingBottom: 8
        }
      }, _react["default"].createElement("div", {
        className: "col-sm-12 text-center text-sm-left"
      }, _react["default"].createElement("table", {
        className: "default-table table table-sm table-responsive-sm table-hover"
      }, _react["default"].createElement("tbody", null, entry === null || entry === void 0 ? void 0 : entry.drillDownData.map(function (drillDown) {
        return _react["default"].createElement(_basicDetailRow["default"], {
          label: drillDown === null || drillDown === void 0 ? void 0 : drillDown.label,
          description: drillDown === null || drillDown === void 0 ? void 0 : drillDown.description
        });
      })))));
    }))));
  } else {
    return _react["default"].createElement("div", {
      className: "row"
    }, _react["default"].createElement("div", {
      className: "col-md-12 col-12"
    }, _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(_ContainerHeader["default"], {
      title: title
    }), _react["default"].createElement("div", {
      className: "mr-auto"
    }, _react["default"].createElement("h3", {
      className: "card-heading"
    }, "No entries found here")))));
  }
};

var _default = MultiDetailDrillDown;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MultiDetailDrillDown, "MultiDetailDrillDown", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/multiDetailDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/multiDetailDrillDown/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/multiDetailDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_reactCollapsible, "_reactCollapsible", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/multiDetailDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_ContainerHeader, "_ContainerHeader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/multiDetailDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_basicDetailRow, "_basicDetailRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/multiDetailDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/multiDetailDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/multiDetailDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/multiDetailDrillDown/index.js");

  __REACT_HOT_LOADER__.register(MultiDetailDrillDown, "MultiDetailDrillDown", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/multiDetailDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/multiDetailDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/multiDetailDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/multiDetailDrillDown/index.js");
}();

;

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modalHeader = exports.showErrors = exports.displayedImage = exports.inputFields = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _DayPickerInput = _interopRequireDefault(__webpack_require__(201));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _FormErrors = _interopRequireDefault(__webpack_require__(38));

var _DateFormatters = __webpack_require__(43);

var _lists = __webpack_require__(300);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var inputFields = function inputFields(data, initiatives, handleUserInput, handleDateInput) {
  return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
    className: "col-lg-9 d-flex flex-column order-lg-1"
  }, _react["default"].createElement("h3", {
    className: "card-heading"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.name"
  })), _react["default"].createElement(_reactstrap.Input, {
    id: "name",
    type: "text",
    className: "form-control mb-2 ".concat((data === null || data === void 0 ? void 0 : data.name) ? 'is-valid' : 'is-invalid'),
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    defaultValue: data === null || data === void 0 ? void 0 : data.name,
    name: "name"
  }), _react["default"].createElement("h3", {
    className: "card-heading"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.description"
  })), _react["default"].createElement(_reactstrap.Input, {
    id: "description",
    type: "text",
    className: "form-control mb-2",
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    defaultValue: data === null || data === void 0 ? void 0 : data.description,
    name: "description"
  }), _react["default"].createElement("h3", {
    className: "card-heading"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.initiative"
  })), _react["default"].createElement(_reactstrap.Input, {
    type: "select",
    name: "initiativeId",
    id: "initiative",
    className: (data === null || data === void 0 ? void 0 : data.initiativeId) ? 'is-valid' : 'is-invalid',
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    value: data === null || data === void 0 ? void 0 : data.initiativeId
  }, _react["default"].createElement("option", {
    key: "emptySelect",
    value: ""
  }, "-- select initiative --"), initiatives.map(function (initiative) {
    return _react["default"].createElement("option", {
      key: initiative.id,
      value: initiative.id
    }, initiative.name);
  })), _react["default"].createElement("h3", {
    className: "card-heading mt-2"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.priority"
  })), _react["default"].createElement(_reactstrap.Input, {
    type: "select",
    name: "priority",
    id: "priority",
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    value: data === null || data === void 0 ? void 0 : data.priority
  }, _react["default"].createElement("option", {
    key: "emptySelect",
    value: ""
  }, "-- select priority --"), _lists.PRIORITIES.map(function (priority) {
    return _react["default"].createElement("option", {
      key: priority,
      value: priority
    }, priority);
  })), _react["default"].createElement("h3", {
    className: "card-heading mt-2"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.successIndicators"
  })), _react["default"].createElement(_reactstrap.Input, {
    id: "succcessIndicators",
    type: "text",
    className: "form-control mb-2",
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    defaultValue: data === null || data === void 0 ? void 0 : data.succcessIndicators,
    name: "succcessIndicators"
  }), _react["default"].createElement("h3", {
    className: "card-heading mt-2"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.startDate"
  })), _react["default"].createElement("div", {
    className: "form-control"
  }, _react["default"].createElement(_DayPickerInput["default"], {
    id: "startDate",
    value: (0, _DateFormatters.formatDateDefault)(data === null || data === void 0 ? void 0 : data.startDate),
    placeholder: _DateFormatters.DEFAULT_DATE_FORMAT,
    onDayChange: function onDayChange(selectedDay) {
      return handleDateInput('startDate', selectedDay);
    },
    dayPickerProps: {
      selectedDays: new Date(data === null || data === void 0 ? void 0 : data.startDate)
    }
  })), _react["default"].createElement("h3", {
    className: "card-heading mt-2"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.endDate"
  })), _react["default"].createElement("div", {
    className: "form-control"
  }, _react["default"].createElement(_DayPickerInput["default"], {
    id: "endDate",
    value: (0, _DateFormatters.formatDateDefault)(data === null || data === void 0 ? void 0 : data.endDate),
    placeholder: _DateFormatters.DEFAULT_DATE_FORMAT,
    onDayChange: function onDayChange(selectedDay) {
      return handleDateInput('endDate', selectedDay);
    },
    dayPickerProps: {
      selectedDays: new Date(data === null || data === void 0 ? void 0 : data.endDate)
    }
  }))));
};

exports.inputFields = inputFields;

var displayedImage = function displayedImage(selectedFeature) {
  return _react["default"].createElement("div", {
    className: "col-lg-3 text-center text-lg-right order-lg-2"
  }, _react["default"].createElement("img", {
    id: "thumb",
    className: "ml-lg-3 mb-4 mb-lg-0 avatar size-120",
    src: (selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.thumb) || 'assets/images/features-1_225_225.jpg'
  }));
};

exports.displayedImage = displayedImage;

var showErrors = function showErrors(formErrors) {
  if (formErrors) {
    return _react["default"].createElement("div", {
      className: "panel panel-default"
    }, _react["default"].createElement(_FormErrors["default"], {
      formErrors: formErrors
    }));
  }

  return null;
};

exports.showErrors = showErrors;

var modalHeader = function modalHeader(title, modalHeaderOnClick) {
  return _react["default"].createElement(_reactstrap.ModalHeader, {
    className: "modal-box-header bg-primary"
  }, title, _react["default"].createElement("span", {
    className: "text-white pointer"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-close zmdi-hc-lg",
    onClick: modalHeaderOnClick()
  })));
};

exports.modalHeader = modalHeader;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(inputFields, "inputFields", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/common.js");

  __REACT_HOT_LOADER__.register(displayedImage, "displayedImage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/common.js");

  __REACT_HOT_LOADER__.register(showErrors, "showErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/common.js");

  __REACT_HOT_LOADER__.register(modalHeader, "modalHeader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/common.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_DayPickerInput, "_DayPickerInput", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_FormErrors, "_FormErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/common.js");

  __REACT_HOT_LOADER__.register(inputFields, "inputFields", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/common.js");

  __REACT_HOT_LOADER__.register(displayedImage, "displayedImage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/common.js");

  __REACT_HOT_LOADER__.register(showErrors, "showErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/common.js");

  __REACT_HOT_LOADER__.register(modalHeader, "modalHeader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/common.js");
}();

;

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFeatureDisplayData = exports.getDisplayData = exports.mapDependenciesToDisplayData = exports.mapOutwardDependenciesToDisplayData = exports.mapInwardDependenciesToDisplayData = void 0;

var _DateFormatters = __webpack_require__(43);

var _ApiService = __webpack_require__(16);

var _api = __webpack_require__(25);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var mapInwardDependenciesToDisplayData = function mapInwardDependenciesToDisplayData(allFeatures, feature) {
  return mapDependenciesToDisplayData(allFeatures, feature, true);
};

exports.mapInwardDependenciesToDisplayData = mapInwardDependenciesToDisplayData;

var mapOutwardDependenciesToDisplayData = function mapOutwardDependenciesToDisplayData(allFeatures, feature) {
  return mapDependenciesToDisplayData(allFeatures, feature, false);
};

exports.mapOutwardDependenciesToDisplayData = mapOutwardDependenciesToDisplayData;

var mapDependenciesToDisplayData = function mapDependenciesToDisplayData(allFeatures, feature, inward) {
  var _feature$dependencies;

  var dependencyData = new Array();

  if (Array.isArray(feature === null || feature === void 0 ? void 0 : feature.dependencies) && (feature === null || feature === void 0 ? void 0 : (_feature$dependencies = feature.dependencies) === null || _feature$dependencies === void 0 ? void 0 : _feature$dependencies.length) > 0) {
    var _feature$dependencies2;

    feature === null || feature === void 0 ? void 0 : (_feature$dependencies2 = feature.dependencies) === null || _feature$dependencies2 === void 0 ? void 0 : _feature$dependencies2.map(function (link) {
      var linkedId = 0;

      if (inward) {
        if ((link === null || link === void 0 ? void 0 : link.inward) !== undefined) {
          var _link$inward;

          linkedId = link === null || link === void 0 ? void 0 : (_link$inward = link.inward) === null || _link$inward === void 0 ? void 0 : _link$inward.id;
        }
      } else {
        if ((link === null || link === void 0 ? void 0 : link.outward) !== undefined) {
          var _link$outward;

          linkedId = link === null || link === void 0 ? void 0 : (_link$outward = link.outward) === null || _link$outward === void 0 ? void 0 : _link$outward.id;
        }
      }

      var found = allFeatures === null || allFeatures === void 0 ? void 0 : allFeatures.find(function (element) {
        return (element === null || element === void 0 ? void 0 : element.id) === linkedId;
      });

      if (found) {
        dependencyData.push(getDisplayData(found));
      }
    });
  }

  return dependencyData;
};

exports.mapDependenciesToDisplayData = mapDependenciesToDisplayData;

var getDisplayData = function getDisplayData(feature) {
  return {
    id: feature === null || feature === void 0 ? void 0 : feature.id,
    name: (feature === null || feature === void 0 ? void 0 : feature.name) ? feature === null || feature === void 0 ? void 0 : feature.name : 'No summary specified',
    description: (feature === null || feature === void 0 ? void 0 : feature.description) ? feature === null || feature === void 0 ? void 0 : feature.description : 'No description specified',
    succcessIndicators: feature === null || feature === void 0 ? void 0 : feature.succcessIndicators,
    startDate: (0, _DateFormatters.formatDateDefault)(feature === null || feature === void 0 ? void 0 : feature.startDate),
    endDate: (0, _DateFormatters.formatDateDefault)(feature === null || feature === void 0 ? void 0 : feature.endDate),
    priority: feature === null || feature === void 0 ? void 0 : feature.priority
  };
};

exports.getDisplayData = getDisplayData;

var getFeatureDisplayData =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(featureId, orgid) {
    var fetchedData;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _ApiService.fetchDataRequest)('featureDisplayData', [_api.ORGID_PATH_PARAM, _api.FEATUREID_PATH_PARAM], [orgid, featureId]);

          case 2:
            _context.t0 = _context.sent;

            if (_context.t0) {
              _context.next = 5;
              break;
            }

            _context.t0 = [];

          case 5:
            fetchedData = _context.t0;
            return _context.abrupt("return", {
              id: (fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.id) ? fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.id : 0,
              name: (fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.name) ? fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.name : 'No name specified',
              description: (fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.description) ? fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.description : 'No description specified',
              type: (fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.type) ? fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.type : 'No type specified',
              priority: (fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.priority) ? fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.priority : 'No priority specified',
              succcessIndicators: (fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.succcessIndicators) ? fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.succcessIndicators : 'No success indicators specified',
              startDate: (fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.startDate) ? (0, _DateFormatters.formatDateDefault)(fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.startDate) : 'No start date specified',
              endDate: (fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.endDate) ? (0, _DateFormatters.formatDateDefault)(fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.endDate) : 'No end date specified',
              initiative: (fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.initiativeName) ? fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.initiativeName : 'No initiative specified'
            });

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getFeatureDisplayData(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.getFeatureDisplayData = getFeatureDisplayData;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapInwardDependenciesToDisplayData, "mapInwardDependenciesToDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/featureService.js");

  __REACT_HOT_LOADER__.register(mapOutwardDependenciesToDisplayData, "mapOutwardDependenciesToDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/featureService.js");

  __REACT_HOT_LOADER__.register(mapDependenciesToDisplayData, "mapDependenciesToDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/featureService.js");

  __REACT_HOT_LOADER__.register(getDisplayData, "getDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/featureService.js");

  __REACT_HOT_LOADER__.register(getFeatureDisplayData, "getFeatureDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/featureService.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(asyncGeneratorStep, "asyncGeneratorStep", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/featureService.js");

  __REACT_HOT_LOADER__.register(_asyncToGenerator, "_asyncToGenerator", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/featureService.js");

  __REACT_HOT_LOADER__.register(mapInwardDependenciesToDisplayData, "mapInwardDependenciesToDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/featureService.js");

  __REACT_HOT_LOADER__.register(mapOutwardDependenciesToDisplayData, "mapOutwardDependenciesToDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/featureService.js");

  __REACT_HOT_LOADER__.register(mapDependenciesToDisplayData, "mapDependenciesToDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/featureService.js");

  __REACT_HOT_LOADER__.register(getDisplayData, "getDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/featureService.js");

  __REACT_HOT_LOADER__.register(getFeatureDisplayData, "getFeatureDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/featureService.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/featureService.js");
}();

;

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _basicDetailRow = _interopRequireDefault(__webpack_require__(157));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var ValueStreamDetailTable = function ValueStreamDetailTable(_ref) {
  var displayData = _ref.displayData;

  if (displayData) {
    return _react["default"].createElement("table", {
      className: "default-table table table-sm table-responsive-sm table-hover"
    }, _react["default"].createElement("tbody", null, _react["default"].createElement(_basicDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.description"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.description
    }), _react["default"].createElement(_basicDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.portfolio"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.portfolio
    }), _react["default"].createElement(_basicDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.valueProposition"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.valueProposition
    }), _react["default"].createElement(_basicDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.budget"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.budget
    }), _react["default"].createElement(_basicDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.kpi"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.kpi
    }), _react["default"].createElement(_basicDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.systems"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.systems
    }), _react["default"].createElement(_basicDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.owner"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.owner
    }), _react["default"].createElement(_basicDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.theme"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.theme
    })));
  } else {
    return _react["default"].createElement(_react.Fragment, null);
  }
};

var _default = ValueStreamDetailTable;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ValueStreamDetailTable, "ValueStreamDetailTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamDetail/valueStreamDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamDetail/valueStreamDetailTable/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamDetail/valueStreamDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamDetail/valueStreamDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_basicDetailRow, "_basicDetailRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamDetail/valueStreamDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamDetail/valueStreamDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamDetail/valueStreamDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamDetail/valueStreamDetailTable/index.js");

  __REACT_HOT_LOADER__.register(ValueStreamDetailTable, "ValueStreamDetailTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamDetail/valueStreamDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamDetail/valueStreamDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamDetail/valueStreamDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamDetail/valueStreamDetailTable/index.js");
}();

;

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFormError = exports.isFormValid = exports.modalHeader = exports.showErrors = exports.displayedImage = exports.inputFields = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _FormErrors = _interopRequireDefault(__webpack_require__(38));

var _Validation = __webpack_require__(14);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var inputFields = function inputFields(data, portfolios, handleUserInput) {
  return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
    className: "col-lg-9 d-flex flex-column order-lg-1"
  }, _react["default"].createElement("h3", {
    className: "card-heading"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.name"
  })), _react["default"].createElement(_reactstrap.Input, {
    id: "name",
    type: "text",
    className: "form-control mb-2 ".concat((data === null || data === void 0 ? void 0 : data.name) ? 'is-valid' : 'is-invalid'),
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    defaultValue: data === null || data === void 0 ? void 0 : data.name,
    name: "name"
  }), _react["default"].createElement("h3", {
    className: "card-heading"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.description"
  })), _react["default"].createElement(_reactstrap.Input, {
    id: "description",
    type: "text",
    className: "form-control mb-2",
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    defaultValue: data === null || data === void 0 ? void 0 : data.description,
    name: "description"
  }), _react["default"].createElement("h3", {
    className: "card-heading"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.portfolio"
  })), _react["default"].createElement(_reactstrap.Input, {
    type: "select",
    name: "portfolioId",
    id: "portfolioSelect",
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    value: data === null || data === void 0 ? void 0 : data.portfolioId
  }, _react["default"].createElement("option", {
    key: "emptySelect",
    value: ""
  }, "-- select portfolio --"), portfolios.map(function (portfolio) {
    return _react["default"].createElement("option", {
      key: portfolio.id,
      value: portfolio.id
    }, portfolio.name);
  })), _react["default"].createElement("h3", {
    className: "card-heading mt-2"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.budget"
  })), _react["default"].createElement(_reactstrap.Input, {
    id: "budget",
    type: "text",
    className: "form-control mb-2 ".concat((data === null || data === void 0 ? void 0 : data.buget) ? 'is-valid' : 'is-invalid'),
    onChange: function onChange(event) {
      return handleUserInput(event, true);
    },
    defaultValue: data === null || data === void 0 ? void 0 : data.budget,
    name: "budget"
  }), _react["default"].createElement("h3", {
    className: "card-heading"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.valueProposition"
  })), _react["default"].createElement(_reactstrap.Input, {
    id: "valueProposition",
    type: "text",
    className: "form-control mb-2 ".concat((data === null || data === void 0 ? void 0 : data.valueProposition) ? 'is-valid' : 'is-invalid'),
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    defaultValue: data === null || data === void 0 ? void 0 : data.valueProposition,
    name: "valueProposition"
  }), _react["default"].createElement("h3", {
    className: "card-heading"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.kpi"
  })), _react["default"].createElement(_reactstrap.Input, {
    id: "kpi",
    type: "text",
    className: "form-control mb-2 ".concat((data === null || data === void 0 ? void 0 : data.kpi) ? 'is-valid' : 'is-invalid'),
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    defaultValue: data === null || data === void 0 ? void 0 : data.kpi,
    name: "kpi"
  }), _react["default"].createElement("h3", {
    className: "card-heading"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.systems"
  })), _react["default"].createElement(_reactstrap.Input, {
    id: "systems",
    type: "text",
    className: "form-control mb-2 ".concat((data === null || data === void 0 ? void 0 : data.systems) ? 'is-valid' : 'is-invalid'),
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    defaultValue: data === null || data === void 0 ? void 0 : data.systems,
    name: "systems"
  }), _react["default"].createElement("h3", {
    className: "card-heading"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.owner"
  })), _react["default"].createElement(_reactstrap.Input, {
    id: "owner",
    type: "text",
    className: "form-control mb-2 ".concat((data === null || data === void 0 ? void 0 : data.owner) ? 'is-valid' : 'is-invalid'),
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    defaultValue: data === null || data === void 0 ? void 0 : data.owner,
    name: "owner"
  }), _react["default"].createElement("h3", {
    className: "card-heading"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.theme"
  })), _react["default"].createElement(_reactstrap.Input, {
    id: "theme",
    type: "text",
    className: "form-control mb-2",
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    defaultValue: data === null || data === void 0 ? void 0 : data.theme,
    name: "theme"
  })));
};

exports.inputFields = inputFields;

var displayedImage = function displayedImage(selectedValueStream) {
  return _react["default"].createElement("div", {
    className: "col-lg-3 text-center text-lg-right order-lg-2"
  }, _react["default"].createElement("img", {
    id: "thumb",
    className: "ml-lg-3 mb-4 mb-lg-0 avatar size-120",
    src: (selectedValueStream === null || selectedValueStream === void 0 ? void 0 : selectedValueStream.thumb) || 'assets/images/valueStreams-1_225_225.jpg'
  }));
};

exports.displayedImage = displayedImage;

var showErrors = function showErrors(formErrors) {
  if (formErrors) {
    return _react["default"].createElement("div", {
      className: "panel panel-default"
    }, _react["default"].createElement(_FormErrors["default"], {
      formErrors: formErrors
    }));
  }

  return null;
};

exports.showErrors = showErrors;

var modalHeader = function modalHeader(title, modalHeaderOnClick) {
  return _react["default"].createElement(_reactstrap.ModalHeader, {
    className: "modal-box-header bg-primary"
  }, title, _react["default"].createElement("span", {
    className: "text-white pointer"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-close zmdi-hc-lg",
    onClick: modalHeaderOnClick()
  })));
};

exports.modalHeader = modalHeader;

var isFormValid = function isFormValid(selectedValueStream) {
  return (0, _Validation.isValueEntered)(selectedValueStream === null || selectedValueStream === void 0 ? void 0 : selectedValueStream.name) && (0, _Validation.isValueEntered)(selectedValueStream === null || selectedValueStream === void 0 ? void 0 : selectedValueStream.valueProposition) && (0, _Validation.isValueEntered)(selectedValueStream === null || selectedValueStream === void 0 ? void 0 : selectedValueStream.kpi) && (0, _Validation.isValueEntered)(selectedValueStream === null || selectedValueStream === void 0 ? void 0 : selectedValueStream.systems) && (0, _Validation.isValueEntered)(selectedValueStream === null || selectedValueStream === void 0 ? void 0 : selectedValueStream.owner) && (0, _Validation.isNumberValid)(selectedValueStream === null || selectedValueStream === void 0 ? void 0 : selectedValueStream.budget);
};

exports.isFormValid = isFormValid;

var getFormError = function getFormError(fieldName, value) {
  var formError = '';

  switch (fieldName) {
    case 'name':
    case 'valueProposition':
    case 'kpi':
    case 'systems':
    case 'owner':
      formError = (0, _Validation.isValueEntered)(value) ? '' : ' is invalid';
      break;

    case 'budget':
      formError = (0, _Validation.isNumberValid)(value) ? '' : ' is invalid. It must be a number';
      break;

    default:
      break;
  }

  return formError;
};

exports.getFormError = getFormError;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(inputFields, "inputFields", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/common.js");

  __REACT_HOT_LOADER__.register(displayedImage, "displayedImage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/common.js");

  __REACT_HOT_LOADER__.register(showErrors, "showErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/common.js");

  __REACT_HOT_LOADER__.register(modalHeader, "modalHeader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/common.js");

  __REACT_HOT_LOADER__.register(isFormValid, "isFormValid", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/common.js");

  __REACT_HOT_LOADER__.register(getFormError, "getFormError", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/common.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_FormErrors, "_FormErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/common.js");

  __REACT_HOT_LOADER__.register(inputFields, "inputFields", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/common.js");

  __REACT_HOT_LOADER__.register(displayedImage, "displayedImage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/common.js");

  __REACT_HOT_LOADER__.register(showErrors, "showErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/common.js");

  __REACT_HOT_LOADER__.register(modalHeader, "modalHeader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/common.js");

  __REACT_HOT_LOADER__.register(isFormValid, "isFormValid", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/common.js");

  __REACT_HOT_LOADER__.register(getFormError, "getFormError", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/common.js");
}();

;

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMockDrillDownData = exports.getValueStreamDisplayData = void 0;

var _ApiService = __webpack_require__(16);

var _api = __webpack_require__(25);

var _NumberFormatters = __webpack_require__(99);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var getValueStreamDisplayData =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(valueStreamId, orgid) {
    var fetchedValueStream;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _ApiService.fetchDataRequest)('valueStreamDisplayData', [_api.ORGID_PATH_PARAM, _api.VALUESTREAMID_PATH_PARAM], [orgid, valueStreamId]);

          case 2:
            _context.t0 = _context.sent;

            if (_context.t0) {
              _context.next = 5;
              break;
            }

            _context.t0 = [];

          case 5:
            fetchedValueStream = _context.t0;
            return _context.abrupt("return", {
              id: (fetchedValueStream === null || fetchedValueStream === void 0 ? void 0 : fetchedValueStream.id) ? fetchedValueStream === null || fetchedValueStream === void 0 ? void 0 : fetchedValueStream.id : 0,
              name: (fetchedValueStream === null || fetchedValueStream === void 0 ? void 0 : fetchedValueStream.name) ? fetchedValueStream === null || fetchedValueStream === void 0 ? void 0 : fetchedValueStream.name : 'No name specified',
              description: (fetchedValueStream === null || fetchedValueStream === void 0 ? void 0 : fetchedValueStream.description) ? fetchedValueStream === null || fetchedValueStream === void 0 ? void 0 : fetchedValueStream.description : 'No description specified',
              valueProposition: (fetchedValueStream === null || fetchedValueStream === void 0 ? void 0 : fetchedValueStream.valueProposition) ? fetchedValueStream === null || fetchedValueStream === void 0 ? void 0 : fetchedValueStream.valueProposition : 'No value proposition specified',
              budget: (fetchedValueStream === null || fetchedValueStream === void 0 ? void 0 : fetchedValueStream.budget) ? (0, _NumberFormatters.formatBalance)(fetchedValueStream === null || fetchedValueStream === void 0 ? void 0 : fetchedValueStream.budget) : (0, _NumberFormatters.formatBalance)(0),
              kpi: (fetchedValueStream === null || fetchedValueStream === void 0 ? void 0 : fetchedValueStream.kpi) ? fetchedValueStream === null || fetchedValueStream === void 0 ? void 0 : fetchedValueStream.kpi : 'No KPI specified',
              systems: (fetchedValueStream === null || fetchedValueStream === void 0 ? void 0 : fetchedValueStream.systems) ? fetchedValueStream === null || fetchedValueStream === void 0 ? void 0 : fetchedValueStream.systems : 'No systems specified',
              owner: (fetchedValueStream === null || fetchedValueStream === void 0 ? void 0 : fetchedValueStream.owner) ? fetchedValueStream === null || fetchedValueStream === void 0 ? void 0 : fetchedValueStream.owner : 'No owner specified',
              theme: (fetchedValueStream === null || fetchedValueStream === void 0 ? void 0 : fetchedValueStream.theme) ? fetchedValueStream === null || fetchedValueStream === void 0 ? void 0 : fetchedValueStream.theme : 'No theme specified',
              portfolio: (fetchedValueStream === null || fetchedValueStream === void 0 ? void 0 : fetchedValueStream.portfolioName) ? fetchedValueStream === null || fetchedValueStream === void 0 ? void 0 : fetchedValueStream.portfolioName : 'No portfolio specified'
            });

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getValueStreamDisplayData(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}(); // temp solution to mock drill down data after component generation - data may not exist
// makes it easy to clean up mock data and use real data when available (just search for this functions usage)


exports.getValueStreamDisplayData = getValueStreamDisplayData;

var getMockDrillDownData = function getMockDrillDownData() {
  return [{
    id: '2578cb65923bb7ba0845014820190617',
    name: 'fake team number 1',
    description: 'description number 1'
  }, {
    id: '9876cb65923bb7ba0845014820190617',
    name: 'fake team number 2',
    description: 'description number 1'
  }];
};

exports.getMockDrillDownData = getMockDrillDownData;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(getValueStreamDisplayData, "getValueStreamDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/valueStreamService.js");

  __REACT_HOT_LOADER__.register(getMockDrillDownData, "getMockDrillDownData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/valueStreamService.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(asyncGeneratorStep, "asyncGeneratorStep", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/valueStreamService.js");

  __REACT_HOT_LOADER__.register(_asyncToGenerator, "_asyncToGenerator", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/valueStreamService.js");

  __REACT_HOT_LOADER__.register(getValueStreamDisplayData, "getValueStreamDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/valueStreamService.js");

  __REACT_HOT_LOADER__.register(getMockDrillDownData, "getMockDrillDownData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/valueStreamService.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/valueStreamService.js");
}();

;

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFormError = exports.isFormValid = exports.modalHeader = exports.showErrors = exports.displayedImage = exports.inputFields = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _FormErrors = _interopRequireDefault(__webpack_require__(38));

var _Validation = __webpack_require__(14);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var inputFields = function inputFields(data, handleUserInput) {
  return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
    className: "col-lg-9 d-flex flex-column order-lg-1"
  }, _react["default"].createElement("h3", {
    className: "card-heading"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.name"
  })), _react["default"].createElement(_reactstrap.Input, {
    id: "name",
    type: "text",
    className: "form-control mb-2 ".concat((data === null || data === void 0 ? void 0 : data.name) ? 'is-valid' : 'is-invalid'),
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    defaultValue: data === null || data === void 0 ? void 0 : data.name,
    name: "name"
  }), _react["default"].createElement("h3", {
    className: "card-heading"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.description"
  })), _react["default"].createElement(_reactstrap.Input, {
    id: "description",
    type: "text",
    className: "form-control mb-2",
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    defaultValue: data === null || data === void 0 ? void 0 : data.description,
    name: "description"
  }), _react["default"].createElement("h3", {
    className: "card-heading"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.role"
  })), _react["default"].createElement(_reactstrap.Input, {
    id: "role",
    type: "text",
    className: "form-control mb-2",
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    defaultValue: data === null || data === void 0 ? void 0 : data.role,
    name: "role"
  }), _react["default"].createElement("h3", {
    className: "card-heading"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.rate"
  })), _react["default"].createElement(_reactstrap.Input, {
    id: "rate",
    type: "text",
    className: "form-control mb-2",
    onChange: function onChange(event) {
      return handleUserInput(event, true);
    },
    defaultValue: data === null || data === void 0 ? void 0 : data.rate,
    name: "rate"
  }), _react["default"].createElement("h3", {
    className: "card-heading"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.allocation"
  })), _react["default"].createElement(_reactstrap.Input, {
    id: "allocation",
    type: "text",
    className: "form-control mb-2",
    onChange: function onChange(event) {
      return handleUserInput(event, true);
    },
    defaultValue: data === null || data === void 0 ? void 0 : data.allocation,
    name: "allocation"
  })));
};

exports.inputFields = inputFields;

var displayedImage = function displayedImage(selectedMember) {
  return _react["default"].createElement("div", {
    className: "col-lg-3 text-center text-lg-right order-lg-2"
  }, _react["default"].createElement("img", {
    id: "thumb",
    className: "ml-lg-3 mb-4 mb-lg-0 avatar size-120",
    src: (selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.thumb) || 'assets/images/members-1_225_225.jpg'
  }));
};

exports.displayedImage = displayedImage;

var showErrors = function showErrors(formErrors) {
  if (formErrors) {
    return _react["default"].createElement("div", {
      className: "panel panel-default"
    }, _react["default"].createElement(_FormErrors["default"], {
      formErrors: formErrors
    }));
  }

  return null;
};

exports.showErrors = showErrors;

var modalHeader = function modalHeader(title, modalHeaderOnClick) {
  return _react["default"].createElement(_reactstrap.ModalHeader, {
    className: "modal-box-header bg-primary"
  }, title, _react["default"].createElement("span", {
    className: "text-white pointer"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-close zmdi-hc-lg",
    onClick: modalHeaderOnClick()
  })));
};

exports.modalHeader = modalHeader;

var isFormValid = function isFormValid(selectedMember) {
  return (0, _Validation.isValueEntered)(selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.name);
};

exports.isFormValid = isFormValid;

var getFormError = function getFormError(fieldName, value) {
  var formError = '';

  switch (fieldName) {
    case 'name':
    case 'role':
      formError = (0, _Validation.isValueEntered)(value) ? '' : ' is invalid';
      break;

    case 'rate':
      formError = (0, _Validation.isNumberValid)(value) ? '' : ' is invalid. It must be a number';
      break;

    case 'allocation':
      formError = (0, _Validation.is0to100NumberValid)(value) ? '' : ' is invalid. It must be a number from 0 to 100';
      break;

    default:
      break;
  }

  return formError;
};

exports.getFormError = getFormError;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(inputFields, "inputFields", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/common.js");

  __REACT_HOT_LOADER__.register(displayedImage, "displayedImage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/common.js");

  __REACT_HOT_LOADER__.register(showErrors, "showErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/common.js");

  __REACT_HOT_LOADER__.register(modalHeader, "modalHeader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/common.js");

  __REACT_HOT_LOADER__.register(isFormValid, "isFormValid", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/common.js");

  __REACT_HOT_LOADER__.register(getFormError, "getFormError", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/common.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_FormErrors, "_FormErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/common.js");

  __REACT_HOT_LOADER__.register(inputFields, "inputFields", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/common.js");

  __REACT_HOT_LOADER__.register(displayedImage, "displayedImage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/common.js");

  __REACT_HOT_LOADER__.register(showErrors, "showErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/common.js");

  __REACT_HOT_LOADER__.register(modalHeader, "modalHeader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/common.js");

  __REACT_HOT_LOADER__.register(isFormValid, "isFormValid", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/common.js");

  __REACT_HOT_LOADER__.register(getFormError, "getFormError", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/common.js");
}();

;

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFormError = exports.isFormValid = exports.modalHeader = exports.showErrors = exports.displayedImage = exports.inputFields = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _FormErrors = _interopRequireDefault(__webpack_require__(38));

var _Validation = __webpack_require__(14);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var inputFields = function inputFields(data, handleUserInput) {
  return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
    className: "col-lg-9 d-flex flex-column order-lg-1"
  }, _react["default"].createElement("h3", {
    className: "card-heading"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.name"
  })), _react["default"].createElement(_reactstrap.Input, {
    id: "name",
    type: "text",
    className: "form-control mb-2 ".concat((data === null || data === void 0 ? void 0 : data.name) ? 'is-valid' : 'is-invalid'),
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    defaultValue: data === null || data === void 0 ? void 0 : data.name,
    name: "name"
  }), _react["default"].createElement("h3", {
    className: "card-heading"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.description"
  })), _react["default"].createElement(_reactstrap.Input, {
    id: "description",
    type: "text",
    className: "form-control mb-2",
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    defaultValue: data === null || data === void 0 ? void 0 : data.description,
    name: "description"
  })));
};

exports.inputFields = inputFields;

var displayedImage = function displayedImage(selectedTeam) {
  return _react["default"].createElement("div", {
    className: "col-lg-3 text-center text-lg-right order-lg-2"
  }, _react["default"].createElement("img", {
    id: "thumb",
    className: "ml-lg-3 mb-4 mb-lg-0 avatar size-120",
    src: (selectedTeam === null || selectedTeam === void 0 ? void 0 : selectedTeam.thumb) || 'assets/images/teams-1_225_225.jpg'
  }));
};

exports.displayedImage = displayedImage;

var showErrors = function showErrors(formErrors) {
  if (formErrors) {
    return _react["default"].createElement("div", {
      className: "panel panel-default"
    }, _react["default"].createElement(_FormErrors["default"], {
      formErrors: formErrors
    }));
  }

  return null;
};

exports.showErrors = showErrors;

var modalHeader = function modalHeader(title, modalHeaderOnClick) {
  return _react["default"].createElement(_reactstrap.ModalHeader, {
    className: "modal-box-header bg-primary"
  }, title, _react["default"].createElement("span", {
    className: "text-white pointer"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-close zmdi-hc-lg",
    onClick: modalHeaderOnClick()
  })));
};

exports.modalHeader = modalHeader;

var isFormValid = function isFormValid(selectedTeam) {
  return (0, _Validation.isValueEntered)(selectedTeam === null || selectedTeam === void 0 ? void 0 : selectedTeam.name);
};

exports.isFormValid = isFormValid;

var getFormError = function getFormError(fieldName, value) {
  var formError = '';

  switch (fieldName) {
    case 'name':
      formError = (0, _Validation.isValueEntered)(value) ? '' : ' is invalid';
      break;

    default:
      break;
  }

  return formError;
};

exports.getFormError = getFormError;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(inputFields, "inputFields", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/common.js");

  __REACT_HOT_LOADER__.register(displayedImage, "displayedImage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/common.js");

  __REACT_HOT_LOADER__.register(showErrors, "showErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/common.js");

  __REACT_HOT_LOADER__.register(modalHeader, "modalHeader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/common.js");

  __REACT_HOT_LOADER__.register(isFormValid, "isFormValid", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/common.js");

  __REACT_HOT_LOADER__.register(getFormError, "getFormError", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/common.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_FormErrors, "_FormErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/common.js");

  __REACT_HOT_LOADER__.register(inputFields, "inputFields", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/common.js");

  __REACT_HOT_LOADER__.register(displayedImage, "displayedImage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/common.js");

  __REACT_HOT_LOADER__.register(showErrors, "showErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/common.js");

  __REACT_HOT_LOADER__.register(modalHeader, "modalHeader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/common.js");

  __REACT_HOT_LOADER__.register(isFormValid, "isFormValid", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/common.js");

  __REACT_HOT_LOADER__.register(getFormError, "getFormError", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/common.js");
}();

;

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFormError = exports.isFormValid = exports.modalHeader = exports.showErrors = exports.displayedImage = exports.inputFields = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _FormErrors = _interopRequireDefault(__webpack_require__(38));

var _Validation = __webpack_require__(14);

var _lists = __webpack_require__(300);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var inputFields = function inputFields(data, allValueStreams, allBusinessUnits, allMembers, handleUserInput) {
  return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
    className: "col-lg-9 d-flex flex-column order-lg-1"
  }, _react["default"].createElement("h3", {
    className: "card-heading"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.name"
  })), _react["default"].createElement(_reactstrap.Input, {
    id: "name",
    type: "text",
    className: "form-control mb-2 ".concat((data === null || data === void 0 ? void 0 : data.name) ? 'is-valid' : 'is-invalid'),
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    defaultValue: data === null || data === void 0 ? void 0 : data.name,
    name: "name"
  }), _react["default"].createElement("h3", {
    className: "card-heading"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.description"
  })), _react["default"].createElement(_reactstrap.Input, {
    id: "description",
    type: "text",
    className: "form-control mb-2",
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    defaultValue: data === null || data === void 0 ? void 0 : data.description,
    name: "description"
  }), _react["default"].createElement("h3", {
    className: "card-heading mt-2"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.valueStream"
  })), _react["default"].createElement(_reactstrap.Input, {
    type: "select",
    name: "valueStreamId",
    id: "valueStreamSelect",
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    value: data === null || data === void 0 ? void 0 : data.valueStreamId
  }, _react["default"].createElement("option", {
    key: "emptySelect",
    value: ""
  }, "-- select value stream --"), allValueStreams.map(function (valueStream) {
    return _react["default"].createElement("option", {
      key: valueStream.id,
      value: valueStream.id
    }, valueStream.name);
  })), _react["default"].createElement("h3", {
    className: "card-heading mt-2"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.businessUnit"
  })), _react["default"].createElement(_reactstrap.Input, {
    type: "select",
    name: "businessUnitId",
    id: "businessUnitSelect",
    className: (data === null || data === void 0 ? void 0 : data.businessUnitId) ? 'is-valid' : 'is-invalid',
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    value: data === null || data === void 0 ? void 0 : data.businessUnitId
  }, _react["default"].createElement("option", {
    key: "emptySelect",
    value: ""
  }, "-- select business unit --"), allBusinessUnits.map(function (businessUnit) {
    return _react["default"].createElement("option", {
      key: businessUnit.id,
      value: businessUnit.id
    }, businessUnit.name);
  })), _react["default"].createElement("h3", {
    className: "card-heading mt-2"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.manager"
  })), _react["default"].createElement(_reactstrap.Input, {
    type: "select",
    name: "manager",
    id: "managerSelect",
    className: (data === null || data === void 0 ? void 0 : data.manager) ? 'is-valid' : 'is-invalid',
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    value: data === null || data === void 0 ? void 0 : data.manager
  }, _react["default"].createElement("option", {
    key: "emptySelect",
    value: ""
  }, "-- select manager --"), allMembers.map(function (member) {
    return _react["default"].createElement("option", {
      key: member.id,
      value: member.id
    }, member.name);
  })), _react["default"].createElement("h3", {
    className: "card-heading mt-2"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.fyBudget"
  })), _react["default"].createElement(_reactstrap.Input, {
    id: "fyBudget",
    type: "text",
    className: "form-control mb-2 ".concat((data === null || data === void 0 ? void 0 : data.fyBudget) ? 'is-valid' : 'is-invalid'),
    onChange: function onChange(event) {
      return handleUserInput(event, true);
    },
    defaultValue: data === null || data === void 0 ? void 0 : data.fyBudget,
    name: "fyBudget"
  }), _react["default"].createElement("h3", {
    className: "card-heading"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.productType"
  })), _react["default"].createElement(_reactstrap.Input, {
    type: "select",
    name: "productType",
    id: "productTypeSelect",
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    value: data === null || data === void 0 ? void 0 : data.productType
  }, _react["default"].createElement("option", {
    key: "emptySelect",
    value: ""
  }, "-- select product type --"), _lists.PRODUCT_TYPES.map(function (productType) {
    return _react["default"].createElement("option", {
      key: productType,
      value: productType
    }, productType);
  }))));
};

exports.inputFields = inputFields;

var displayedImage = function displayedImage(selectedProduct) {
  return _react["default"].createElement("div", {
    className: "col-lg-3 text-center text-lg-right order-lg-2"
  }, _react["default"].createElement("img", {
    id: "thumb",
    className: "ml-lg-3 mb-4 mb-lg-0 avatar size-120",
    src: (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.thumb) || 'assets/images/products-1_225_225.jpg'
  }));
};

exports.displayedImage = displayedImage;

var showErrors = function showErrors(formErrors) {
  if (formErrors) {
    return _react["default"].createElement("div", {
      className: "panel panel-default"
    }, _react["default"].createElement(_FormErrors["default"], {
      formErrors: formErrors
    }));
  }

  return null;
};

exports.showErrors = showErrors;

var modalHeader = function modalHeader(title, modalHeaderOnClick) {
  return _react["default"].createElement(_reactstrap.ModalHeader, {
    className: "modal-box-header bg-primary"
  }, title, _react["default"].createElement("span", {
    className: "text-white pointer"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-close zmdi-hc-lg",
    onClick: modalHeaderOnClick()
  })));
};

exports.modalHeader = modalHeader;

var isFormValid = function isFormValid(selectedProduct) {
  return (0, _Validation.isValueEntered)(selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.name) && (0, _Validation.isValueEntered)(selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.manager) && (0, _Validation.isValueEntered)(selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.businessUnitId) && (0, _Validation.isNumberValid)(selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.fyBudget);
};

exports.isFormValid = isFormValid;

var getFormError = function getFormError(fieldName, value) {
  var formError = '';

  switch (fieldName) {
    case 'name':
      formError = (0, _Validation.isValueEntered)(value) ? '' : ' is invalid';
      break;

    default:
      break;
  }

  return formError;
};

exports.getFormError = getFormError;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(inputFields, "inputFields", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/common.js");

  __REACT_HOT_LOADER__.register(displayedImage, "displayedImage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/common.js");

  __REACT_HOT_LOADER__.register(showErrors, "showErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/common.js");

  __REACT_HOT_LOADER__.register(modalHeader, "modalHeader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/common.js");

  __REACT_HOT_LOADER__.register(isFormValid, "isFormValid", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/common.js");

  __REACT_HOT_LOADER__.register(getFormError, "getFormError", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/common.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_FormErrors, "_FormErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/common.js");

  __REACT_HOT_LOADER__.register(inputFields, "inputFields", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/common.js");

  __REACT_HOT_LOADER__.register(displayedImage, "displayedImage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/common.js");

  __REACT_HOT_LOADER__.register(showErrors, "showErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/common.js");

  __REACT_HOT_LOADER__.register(modalHeader, "modalHeader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/common.js");

  __REACT_HOT_LOADER__.register(isFormValid, "isFormValid", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/common.js");

  __REACT_HOT_LOADER__.register(getFormError, "getFormError", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/common.js");
}();

;

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkDatesValid = exports.getFormError = exports.isFormValid = exports.modalHeader = exports.showErrors = exports.displayedImage = exports.inputFields = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _DayPickerInput = _interopRequireDefault(__webpack_require__(201));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _FormErrors = _interopRequireDefault(__webpack_require__(38));

var _DateFormatters = __webpack_require__(43);

var _Validation = __webpack_require__(14);

var _moment = _interopRequireDefault(__webpack_require__(2));

var _DateService = __webpack_require__(48);

var _lists = __webpack_require__(300);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var inputFields = function inputFields(data, allProjects, handleUserInput, handleDateInput) {
  return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
    className: "col-lg-9 d-flex flex-column order-lg-1"
  }, _react["default"].createElement("h3", {
    className: "card-heading"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.status"
  })), _react["default"].createElement(_reactstrap.Input, {
    type: "select",
    name: "status",
    id: "statusSelect",
    className: (data === null || data === void 0 ? void 0 : data.status) ? 'is-valid' : 'is-invalid',
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    value: data === null || data === void 0 ? void 0 : data.status
  }, _react["default"].createElement("option", {
    key: "emptySelect",
    value: ""
  }, "-- select status --"), _lists.INITIATIVE_STATUS.map(function (status) {
    return _react["default"].createElement("option", {
      key: status,
      value: status
    }, status);
  })), _react["default"].createElement("h3", {
    className: "card-heading",
    style: {
      marginTop: 10
    }
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.name"
  })), _react["default"].createElement(_reactstrap.Input, {
    id: "name",
    type: "text",
    className: "form-control mb-2 ".concat((data === null || data === void 0 ? void 0 : data.name) ? 'is-valid' : 'is-invalid'),
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    defaultValue: data === null || data === void 0 ? void 0 : data.name,
    name: "name"
  }), _react["default"].createElement("h3", {
    className: "card-heading"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.description"
  })), _react["default"].createElement(_reactstrap.Input, {
    id: "description",
    type: "text",
    className: "form-control mb-2",
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    defaultValue: data === null || data === void 0 ? void 0 : data.description,
    name: "description"
  }), _react["default"].createElement("h3", {
    className: "card-heading"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.project"
  })), _react["default"].createElement(_reactstrap.Input, {
    type: "select",
    name: "projectId",
    id: "projectSelect",
    className: (data === null || data === void 0 ? void 0 : data.projectId) ? 'is-valid' : 'is-invalid',
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    value: data === null || data === void 0 ? void 0 : data.projectId
  }, _react["default"].createElement("option", {
    key: "emptySelect",
    value: ""
  }, "-- select project --"), allProjects.map(function (project) {
    return _react["default"].createElement("option", {
      key: project.id,
      value: project.id
    }, project.name);
  })), _react["default"].createElement("h3", {
    className: "card-heading mt-2"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.startDate"
  })), _react["default"].createElement("div", {
    className: "form-control"
  }, _react["default"].createElement(_DayPickerInput["default"], {
    id: "startDate",
    value: (0, _DateFormatters.formatDateDefault)(data === null || data === void 0 ? void 0 : data.startDate),
    placeholder: _DateFormatters.DEFAULT_DATE_FORMAT,
    onDayChange: function onDayChange(selectedDay) {
      return handleDateInput('startDate', selectedDay);
    },
    dayPickerProps: {
      selectedDays: new Date(data === null || data === void 0 ? void 0 : data.startDate)
    }
  })), _react["default"].createElement("h3", {
    className: "card-heading mt-2"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.endDate"
  })), _react["default"].createElement("div", {
    className: "form-control"
  }, _react["default"].createElement(_DayPickerInput["default"], {
    id: "endDate",
    value: (0, _DateFormatters.formatDateDefault)(data === null || data === void 0 ? void 0 : data.endDate),
    placeholder: _DateFormatters.DEFAULT_DATE_FORMAT,
    onDayChange: function onDayChange(selectedDay) {
      return handleDateInput('endDate', selectedDay);
    },
    dayPickerProps: {
      selectedDays: new Date(data === null || data === void 0 ? void 0 : data.endDate)
    }
  })), _react["default"].createElement("h3", {
    className: "card-heading mt-2"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.budget"
  })), _react["default"].createElement(_reactstrap.Input, {
    id: "budget",
    type: "text",
    className: "form-control mb-2 ".concat((data === null || data === void 0 ? void 0 : data.budget) ? 'is-valid' : 'is-invalid'),
    onChange: function onChange(event) {
      return handleUserInput(event, true);
    },
    defaultValue: data === null || data === void 0 ? void 0 : data.budget,
    name: "budget"
  })));
};

exports.inputFields = inputFields;

var displayedImage = function displayedImage(selectedInitiative) {
  return _react["default"].createElement("div", {
    className: "col-lg-3 text-center text-lg-right order-lg-2"
  }, _react["default"].createElement("img", {
    id: "thumb",
    className: "ml-lg-3 mb-4 mb-lg-0 avatar size-120",
    src: (selectedInitiative === null || selectedInitiative === void 0 ? void 0 : selectedInitiative.thumb) || 'assets/images/initiative-1_225_225.jpg'
  }));
};

exports.displayedImage = displayedImage;

var showErrors = function showErrors(formErrors) {
  if (formErrors) {
    return _react["default"].createElement("div", {
      className: "panel panel-default"
    }, _react["default"].createElement(_FormErrors["default"], {
      formErrors: formErrors
    }));
  }

  return null;
};

exports.showErrors = showErrors;

var modalHeader = function modalHeader(title, modalHeaderOnClick) {
  return _react["default"].createElement(_reactstrap.ModalHeader, {
    className: "modal-box-header bg-primary"
  }, title, _react["default"].createElement("span", {
    className: "text-white pointer"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-close zmdi-hc-lg",
    onClick: modalHeaderOnClick()
  })));
};

exports.modalHeader = modalHeader;

var isFormValid = function isFormValid(selectedInitiative) {
  return (0, _Validation.isValueEntered)(selectedInitiative === null || selectedInitiative === void 0 ? void 0 : selectedInitiative.name) && (0, _Validation.isValueEntered)(selectedInitiative === null || selectedInitiative === void 0 ? void 0 : selectedInitiative.projectId) && (0, _Validation.isValueEntered)(selectedInitiative === null || selectedInitiative === void 0 ? void 0 : selectedInitiative.status) && (0, _Validation.isNumberValid)(selectedInitiative === null || selectedInitiative === void 0 ? void 0 : selectedInitiative.budget);
};

exports.isFormValid = isFormValid;

var getFormError = function getFormError(fieldName, value) {
  var formError = '';

  switch (fieldName) {
    case 'name':
      formError = (0, _Validation.isValueEntered)(value) ? '' : ' is invalid';
      break;

    default:
      break;
  }

  return formError;
};

exports.getFormError = getFormError;

var checkDatesValid = function checkDatesValid(selectedInitiative) {
  // console.log('checkDatesValid start');
  if ((0, _Validation.isValueEntered)(selectedInitiative === null || selectedInitiative === void 0 ? void 0 : selectedInitiative.endDate) && (0, _Validation.isValueEntered)(selectedInitiative === null || selectedInitiative === void 0 ? void 0 : selectedInitiative.startDate)) {
    // DayPickerInput gives a format that DateService does not like so utilise moment as the default before passing to the date check
    if ((0, _DateService.isDateBefore)((0, _moment["default"])(selectedInitiative === null || selectedInitiative === void 0 ? void 0 : selectedInitiative.endDate), (0, _moment["default"])(selectedInitiative === null || selectedInitiative === void 0 ? void 0 : selectedInitiative.startDate))) {
      // console.log('checkDatesValid start ERRORS');
      return false;
    } // console.log('checkDatesValid start ALL GOOD');


    return true;
  }

  return true; // dates are not mandatory on features so dont return false - just check start is before end date
};

exports.checkDatesValid = checkDatesValid;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(inputFields, "inputFields", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/common.js");

  __REACT_HOT_LOADER__.register(displayedImage, "displayedImage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/common.js");

  __REACT_HOT_LOADER__.register(showErrors, "showErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/common.js");

  __REACT_HOT_LOADER__.register(modalHeader, "modalHeader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/common.js");

  __REACT_HOT_LOADER__.register(isFormValid, "isFormValid", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/common.js");

  __REACT_HOT_LOADER__.register(getFormError, "getFormError", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/common.js");

  __REACT_HOT_LOADER__.register(checkDatesValid, "checkDatesValid", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/common.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_DayPickerInput, "_DayPickerInput", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_FormErrors, "_FormErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_moment, "_moment", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/common.js");

  __REACT_HOT_LOADER__.register(inputFields, "inputFields", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/common.js");

  __REACT_HOT_LOADER__.register(displayedImage, "displayedImage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/common.js");

  __REACT_HOT_LOADER__.register(showErrors, "showErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/common.js");

  __REACT_HOT_LOADER__.register(modalHeader, "modalHeader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/common.js");

  __REACT_HOT_LOADER__.register(isFormValid, "isFormValid", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/common.js");

  __REACT_HOT_LOADER__.register(getFormError, "getFormError", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/common.js");

  __REACT_HOT_LOADER__.register(checkDatesValid, "checkDatesValid", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/common.js");
}();

;

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkDatesValid = exports.getFormError = exports.isFormValid = exports.modalHeader = exports.showErrors = exports.displayedImage = exports.inputFields = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _DayPickerInput = _interopRequireDefault(__webpack_require__(201));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _FormErrors = _interopRequireDefault(__webpack_require__(38));

var _Validation = __webpack_require__(14);

var _lists = __webpack_require__(300);

var _project = __webpack_require__(171);

var _DateFormatters = __webpack_require__(43);

var _moment = _interopRequireDefault(__webpack_require__(2));

var _DateService = __webpack_require__(48);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var inputFields = function inputFields(data, features, members, handleUserInput, handleDateInput) {
  return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
    className: "col-lg-9 d-flex flex-column order-lg-1"
  }, _react["default"].createElement("h3", {
    className: "card-heading"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.name"
  })), _react["default"].createElement(_reactstrap.Input, {
    id: "name",
    type: "text",
    className: "form-control mb-2 ".concat((data === null || data === void 0 ? void 0 : data.name) ? 'is-valid' : 'is-invalid'),
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    defaultValue: data === null || data === void 0 ? void 0 : data.name,
    name: "name"
  }), _react["default"].createElement("h3", {
    className: "card-heading"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.description"
  })), _react["default"].createElement(_reactstrap.Input, {
    id: "description",
    type: "text",
    className: "form-control mb-2 ".concat((data === null || data === void 0 ? void 0 : data.description) ? 'is-valid' : 'is-invalid'),
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    defaultValue: data === null || data === void 0 ? void 0 : data.description,
    name: "description"
  }), _react["default"].createElement("h3", {
    className: "card-heading"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.type"
  })), _react["default"].createElement(_reactstrap.Input, {
    type: "select",
    name: "type",
    id: "type",
    className: (data === null || data === void 0 ? void 0 : data.type) ? 'is-valid' : 'is-invalid',
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    value: data === null || data === void 0 ? void 0 : data.type
  }, _react["default"].createElement("option", {
    key: "emptySelect",
    value: ""
  }, "-- select issue type --"), _lists.ISSUE_TYPES.map(function (type) {
    return _react["default"].createElement("option", {
      key: type,
      value: type
    }, type);
  })), _react["default"].createElement("h3", {
    className: "card-heading mt-2"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.feature"
  })), _react["default"].createElement(_reactstrap.Input, {
    type: "select",
    name: "featureId",
    id: "feature",
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    value: data === null || data === void 0 ? void 0 : data.featureId
  }, _react["default"].createElement("option", {
    key: "emptySelect",
    value: ""
  }, "-- select feature --"), features.map(function (feature) {
    return _react["default"].createElement("option", {
      key: feature.id,
      value: feature.id
    }, feature.name);
  })), _react["default"].createElement("h3", {
    className: "card-heading mt-2"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.assignee"
  })), _react["default"].createElement(_reactstrap.Input, {
    type: "select",
    name: "assigneeId",
    id: "assignee",
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    value: data === null || data === void 0 ? void 0 : data.assigneeId
  }, _react["default"].createElement("option", {
    key: "emptySelect",
    value: ""
  }, "-- select assignee --"), members.map(function (assignee) {
    return _react["default"].createElement("option", {
      key: assignee.id,
      value: assignee.id
    }, assignee.name);
  })), _react["default"].createElement("h3", {
    className: "card-heading mt-2"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.startDate"
  })), _react["default"].createElement("div", {
    className: "form-control"
  }, _react["default"].createElement(_DayPickerInput["default"], {
    id: "startDate",
    value: (0, _DateFormatters.formatDateDefault)(data === null || data === void 0 ? void 0 : data.startDate),
    placeholder: _DateFormatters.DEFAULT_DATE_FORMAT,
    onDayChange: function onDayChange(selectedDay) {
      return handleDateInput('startDate', selectedDay);
    },
    dayPickerProps: {
      selectedDays: new Date(data === null || data === void 0 ? void 0 : data.startDate)
    }
  })), _react["default"].createElement("h3", {
    className: "card-heading mt-2"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.endDate"
  })), _react["default"].createElement("div", {
    className: "form-control"
  }, _react["default"].createElement(_DayPickerInput["default"], {
    id: "endDate",
    value: (0, _DateFormatters.formatDateDefault)(data === null || data === void 0 ? void 0 : data.endDate),
    placeholder: _DateFormatters.DEFAULT_DATE_FORMAT,
    onDayChange: function onDayChange(selectedDay) {
      return handleDateInput('endDate', selectedDay);
    },
    dayPickerProps: {
      selectedDays: new Date(data === null || data === void 0 ? void 0 : data.endDate)
    }
  })), (data === null || data === void 0 ? void 0 : data.type) === _project.ISSUE_TYPE_RELEASE ? _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("h3", {
    className: "card-heading mt-2"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.releaseEnv"
  })), _react["default"].createElement(_reactstrap.Input, {
    id: "releaseEnv",
    type: "text",
    className: "form-control mb-2 ".concat((data === null || data === void 0 ? void 0 : data.releaseEnv) ? 'is-valid' : 'is-invalid'),
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    defaultValue: data === null || data === void 0 ? void 0 : data.releaseEnv,
    name: "releaseEnv"
  }), _react["default"].createElement("h3", {
    className: "card-heading mt-2"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.releaseDate"
  })), _react["default"].createElement("div", {
    className: "form-control ".concat((data === null || data === void 0 ? void 0 : data.releaseDate) ? 'is-valid' : 'is-invalid')
  }, _react["default"].createElement(_DayPickerInput["default"], {
    id: "releaseDate",
    value: (0, _DateFormatters.formatDateDefault)(data === null || data === void 0 ? void 0 : data.releaseDate),
    placeholder: _DateFormatters.DEFAULT_DATE_FORMAT,
    onDayChange: function onDayChange(selectedDay) {
      return handleDateInput('releaseDate', selectedDay);
    },
    dayPickerProps: {
      selectedDays: new Date(data === null || data === void 0 ? void 0 : data.releaseDate)
    }
  })), _react["default"].createElement("h3", {
    className: "card-heading mt-2"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.releaseCutoffDate"
  })), _react["default"].createElement("div", {
    className: "form-control"
  }, _react["default"].createElement(_DayPickerInput["default"], {
    id: "releaseCutoffDate",
    value: (0, _DateFormatters.formatDateDefault)(data === null || data === void 0 ? void 0 : data.releaseCutoffDate),
    placeholder: _DateFormatters.DEFAULT_DATE_FORMAT,
    onDayChange: function onDayChange(selectedDay) {
      return handleDateInput('releaseCutoffDate', selectedDay);
    },
    dayPickerProps: {
      selectedDays: new Date(data === null || data === void 0 ? void 0 : data.releaseCutoffDate)
    }
  })), _react["default"].createElement("h3", {
    className: "card-heading mt-2"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.releaseVersion"
  })), _react["default"].createElement(_reactstrap.Input, {
    id: "releaseVersion",
    type: "text",
    className: "form-control mb-2 ".concat((data === null || data === void 0 ? void 0 : data.releaseVersion) ? 'is-valid' : 'is-invalid'),
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    defaultValue: data === null || data === void 0 ? void 0 : data.releaseVersion,
    name: "releaseVersion"
  })) : null));
};

exports.inputFields = inputFields;

var displayedImage = function displayedImage(selectedIssue) {
  return _react["default"].createElement("div", {
    className: "col-lg-3 text-center text-lg-right order-lg-2"
  }, _react["default"].createElement("img", {
    id: "thumb",
    className: "ml-lg-3 mb-4 mb-lg-0 avatar size-120",
    src: (selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.thumb) || 'assets/images/issues-1_225_225.jpg'
  }));
};

exports.displayedImage = displayedImage;

var showErrors = function showErrors(formErrors) {
  if (formErrors) {
    return _react["default"].createElement("div", {
      className: "panel panel-default"
    }, _react["default"].createElement(_FormErrors["default"], {
      formErrors: formErrors
    }));
  }

  return null;
};

exports.showErrors = showErrors;

var modalHeader = function modalHeader(title, modalHeaderOnClick) {
  return _react["default"].createElement(_reactstrap.ModalHeader, {
    className: "modal-box-header bg-primary"
  }, title, _react["default"].createElement("span", {
    className: "text-white pointer"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-close zmdi-hc-lg",
    onClick: modalHeaderOnClick()
  })));
};

exports.modalHeader = modalHeader;

var isFormValid = function isFormValid(selectedIssue) {
  var valid = (0, _Validation.isValueEntered)(selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.name) && (0, _Validation.isValueEntered)(selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.description) && (0, _Validation.isValueEntered)(selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.type);

  if ((selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.type) === _project.ISSUE_TYPE_RELEASE) {
    valid = valid && (0, _Validation.isValueEntered)(selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.releaseDate) && (0, _Validation.isValueEntered)(selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.releaseEnv) && (0, _Validation.isValueEntered)(selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.releaseVersion);
  }

  return valid;
};

exports.isFormValid = isFormValid;

var getFormError = function getFormError(fieldName, value, selectedIssue) {
  var formError = '';

  switch (fieldName) {
    case 'name':
    case 'description':
    case 'type':
      formError = (0, _Validation.isValueEntered)(value) ? '' : ' is invalid';
      break;

    case 'releaseEnv':
    case 'releaseDate':
    case 'releaseVersion':
      if ((selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.type) === _project.ISSUE_TYPE_RELEASE) {
        formError = (0, _Validation.isValueEntered)(value) ? '' : ' is invalid';
      }

      break;

    default:
      break;
  }

  return formError;
};

exports.getFormError = getFormError;

var checkDatesValid = function checkDatesValid(selectedIssue) {
  // console.log('checkDatesValid start');
  if ((0, _Validation.isValueEntered)(selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.endDate) && (0, _Validation.isValueEntered)(selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.startDate)) {
    // DayPickerInput gives a format that DateService does not like so utilise moment as the default before passing to the date check
    if ((0, _DateService.isDateBefore)((0, _moment["default"])(selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.endDate), (0, _moment["default"])(selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.startDate))) {
      // console.log('checkDatesValid start ERRORS');
      return false;
    } // console.log('checkDatesValid start ALL GOOD');


    return true;
  }

  if ((selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.type) === _project.ISSUE_TYPE_RELEASE) {
    if ((0, _Validation.isValueEntered)(selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.releaseDate) && (0, _Validation.isValueEntered)(selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.releaseCutoffDate)) {
      // DayPickerInput gives a format that DateService does not like so utilise moment as the default before passing to the date check
      if ((0, _DateService.isDateBefore)((0, _moment["default"])(selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.releaseDate), (0, _moment["default"])(selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.releaseCutoffDate))) {
        // console.log('checkDatesValid start ERRORS');
        return false;
      } // console.log('checkDatesValid start ALL GOOD');


      return true;
    }
  }

  return true; // mandatory dates are checked in getFormError
};

exports.checkDatesValid = checkDatesValid;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(inputFields, "inputFields", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/common.js");

  __REACT_HOT_LOADER__.register(displayedImage, "displayedImage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/common.js");

  __REACT_HOT_LOADER__.register(showErrors, "showErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/common.js");

  __REACT_HOT_LOADER__.register(modalHeader, "modalHeader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/common.js");

  __REACT_HOT_LOADER__.register(isFormValid, "isFormValid", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/common.js");

  __REACT_HOT_LOADER__.register(getFormError, "getFormError", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/common.js");

  __REACT_HOT_LOADER__.register(checkDatesValid, "checkDatesValid", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/common.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_DayPickerInput, "_DayPickerInput", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_FormErrors, "_FormErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_moment, "_moment", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/common.js");

  __REACT_HOT_LOADER__.register(inputFields, "inputFields", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/common.js");

  __REACT_HOT_LOADER__.register(displayedImage, "displayedImage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/common.js");

  __REACT_HOT_LOADER__.register(showErrors, "showErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/common.js");

  __REACT_HOT_LOADER__.register(modalHeader, "modalHeader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/common.js");

  __REACT_HOT_LOADER__.register(isFormValid, "isFormValid", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/common.js");

  __REACT_HOT_LOADER__.register(getFormError, "getFormError", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/common.js");

  __REACT_HOT_LOADER__.register(checkDatesValid, "checkDatesValid", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/common.js");
}();

;

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initProps = exports.getFormError = exports.isFormValid = exports.modalHeader = exports.showErrors = exports.displayedImage = exports.inputFields = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _FormErrors = _interopRequireDefault(__webpack_require__(38));

var _Validation = __webpack_require__(14);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var inputFields = function inputFields(data, handleUserInput) {
  return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
    className: "col-lg-9 d-flex flex-column order-lg-1"
  }, _react["default"].createElement("h3", {
    className: "card-heading"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.name"
  })), _react["default"].createElement(_reactstrap.Input, {
    id: "name",
    type: "text",
    className: "form-control mb-2 ".concat((data === null || data === void 0 ? void 0 : data.name) ? 'is-valid' : 'is-invalid'),
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    defaultValue: data === null || data === void 0 ? void 0 : data.name,
    name: "name"
  }), _react["default"].createElement("h3", {
    className: "card-heading"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.description"
  })), _react["default"].createElement(_reactstrap.Input, {
    id: "description",
    type: "text",
    className: "form-control mb-2",
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    defaultValue: data === null || data === void 0 ? void 0 : data.description,
    name: "description"
  })));
};

exports.inputFields = inputFields;

var displayedImage = function displayedImage(selectedProjectBusPriority) {
  return _react["default"].createElement("div", {
    className: "col-lg-3 text-center text-lg-right order-lg-2"
  }, _react["default"].createElement("img", {
    id: "thumb",
    className: "ml-lg-3 mb-4 mb-lg-0 avatar size-120",
    src: (selectedProjectBusPriority === null || selectedProjectBusPriority === void 0 ? void 0 : selectedProjectBusPriority.thumb) || 'assets/images/projectBusPrioritys-1_225_225.jpg'
  }));
};

exports.displayedImage = displayedImage;

var showErrors = function showErrors(formErrors) {
  if (formErrors) {
    return _react["default"].createElement("div", {
      className: "panel panel-default"
    }, _react["default"].createElement(_FormErrors["default"], {
      formErrors: formErrors
    }));
  }

  return null;
};

exports.showErrors = showErrors;

var modalHeader = function modalHeader(title, modalHeaderOnClick) {
  return _react["default"].createElement(_reactstrap.ModalHeader, {
    className: "modal-box-header bg-primary"
  }, title, _react["default"].createElement("span", {
    className: "text-white pointer"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-close zmdi-hc-lg",
    onClick: modalHeaderOnClick()
  })));
};

exports.modalHeader = modalHeader;

var isFormValid = function isFormValid(selectedProjectBusPriority) {
  return (0, _Validation.isValueEntered)(selectedProjectBusPriority === null || selectedProjectBusPriority === void 0 ? void 0 : selectedProjectBusPriority.name);
};

exports.isFormValid = isFormValid;

var getFormError = function getFormError(fieldName, value) {
  var formError = '';

  switch (fieldName) {
    case 'name':
      formError = (0, _Validation.isValueEntered)(value) ? '' : ' is invalid';
      break;

    default:
      break;
  }

  return formError;
};

exports.getFormError = getFormError;

var initProps = function initProps() {
  return {
    id: '',
    orgid: '',
    name: '',
    description: '',
    starred: false,
    frequently: false
  };
};

exports.initProps = initProps;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(inputFields, "inputFields", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(displayedImage, "displayedImage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(showErrors, "showErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(modalHeader, "modalHeader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(isFormValid, "isFormValid", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(getFormError, "getFormError", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(initProps, "initProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/common.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_FormErrors, "_FormErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(inputFields, "inputFields", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(displayedImage, "displayedImage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(showErrors, "showErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(modalHeader, "modalHeader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(isFormValid, "isFormValid", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(getFormError, "getFormError", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(initProps, "initProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/common.js");
}();

;

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initProps = exports.getFormError = exports.isFormValid = exports.modalHeader = exports.showErrors = exports.displayedImage = exports.inputFields = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _FormErrors = _interopRequireDefault(__webpack_require__(38));

var _Validation = __webpack_require__(14);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var inputFields = function inputFields(data, handleUserInput) {
  return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
    className: "col-lg-9 d-flex flex-column order-lg-1"
  }, _react["default"].createElement("h3", {
    className: "card-heading"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.name"
  })), _react["default"].createElement(_reactstrap.Input, {
    id: "name",
    type: "text",
    className: "form-control mb-2 ".concat((data === null || data === void 0 ? void 0 : data.name) ? 'is-valid' : 'is-invalid'),
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    defaultValue: data === null || data === void 0 ? void 0 : data.name,
    name: "name"
  }), _react["default"].createElement("h3", {
    className: "card-heading"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.description"
  })), _react["default"].createElement(_reactstrap.Input, {
    id: "description",
    type: "text",
    className: "form-control mb-2",
    onChange: function onChange(event) {
      return handleUserInput(event);
    },
    defaultValue: data === null || data === void 0 ? void 0 : data.description,
    name: "description"
  })));
};

exports.inputFields = inputFields;

var displayedImage = function displayedImage(selectedProjectCostPriority) {
  return _react["default"].createElement("div", {
    className: "col-lg-3 text-center text-lg-right order-lg-2"
  }, _react["default"].createElement("img", {
    id: "thumb",
    className: "ml-lg-3 mb-4 mb-lg-0 avatar size-120",
    src: (selectedProjectCostPriority === null || selectedProjectCostPriority === void 0 ? void 0 : selectedProjectCostPriority.thumb) || 'assets/images/projectCostPrioritys-1_225_225.jpg'
  }));
};

exports.displayedImage = displayedImage;

var showErrors = function showErrors(formErrors) {
  if (formErrors) {
    return _react["default"].createElement("div", {
      className: "panel panel-default"
    }, _react["default"].createElement(_FormErrors["default"], {
      formErrors: formErrors
    }));
  }

  return null;
};

exports.showErrors = showErrors;

var modalHeader = function modalHeader(title, modalHeaderOnClick) {
  return _react["default"].createElement(_reactstrap.ModalHeader, {
    className: "modal-box-header bg-primary"
  }, title, _react["default"].createElement("span", {
    className: "text-white pointer"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-close zmdi-hc-lg",
    onClick: modalHeaderOnClick()
  })));
};

exports.modalHeader = modalHeader;

var isFormValid = function isFormValid(selectedProjectCostPriority) {
  return (0, _Validation.isValueEntered)(selectedProjectCostPriority === null || selectedProjectCostPriority === void 0 ? void 0 : selectedProjectCostPriority.name);
};

exports.isFormValid = isFormValid;

var getFormError = function getFormError(fieldName, value) {
  var formError = '';

  switch (fieldName) {
    case 'name':
      formError = (0, _Validation.isValueEntered)(value) ? '' : ' is invalid';
      break;

    default:
      break;
  }

  return formError;
};

exports.getFormError = getFormError;

var initProps = function initProps() {
  return {
    id: '',
    orgid: '',
    name: '',
    description: '',
    starred: false,
    frequently: false
  };
};

exports.initProps = initProps;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(inputFields, "inputFields", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(displayedImage, "displayedImage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(showErrors, "showErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(modalHeader, "modalHeader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(isFormValid, "isFormValid", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(getFormError, "getFormError", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(initProps, "initProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/common.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_FormErrors, "_FormErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(inputFields, "inputFields", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(displayedImage, "displayedImage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(showErrors, "showErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(modalHeader, "modalHeader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(isFormValid, "isFormValid", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(getFormError, "getFormError", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(initProps, "initProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/common.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/common.js");
}();

;

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1726), __esModule: true };

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(58);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 835 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(160),
    baseIteratee = __webpack_require__(67),
    baseMap = __webpack_require__(642),
    isArray = __webpack_require__(26);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 837 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrayMove = exports.sortableHandle = exports.sortableElement = exports.sortableContainer = exports.SortableHandle = exports.SortableElement = exports.SortableContainer = undefined;

var _utils = __webpack_require__(251);

Object.defineProperty(exports, 'arrayMove', {
  enumerable: true,
  get: function get() {
    return _utils.arrayMove;
  }
});

var _SortableContainer2 = __webpack_require__(1116);

var _SortableContainer3 = _interopRequireDefault(_SortableContainer2);

var _SortableElement2 = __webpack_require__(1181);

var _SortableElement3 = _interopRequireDefault(_SortableElement2);

var _SortableHandle2 = __webpack_require__(1182);

var _SortableHandle3 = _interopRequireDefault(_SortableHandle2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.SortableContainer = _SortableContainer3.default;
exports.SortableElement = _SortableElement3.default;
exports.SortableHandle = _SortableHandle3.default;
exports.sortableContainer = _SortableContainer3.default;
exports.sortableElement = _SortableElement3.default;
exports.sortableHandle = _SortableHandle3.default;

/***/ }),
/* 839 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 840 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(1092);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["default"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(57), __webpack_require__(1091)(module)))

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(1167);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(641);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(130),
    isObjectLike = __webpack_require__(79);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 845 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

/*
  Used as main file in package.json
*/

/* eslint-disable no-var */
/* eslint-env node */

var DayPicker = __webpack_require__(800);
var DateUtils = __webpack_require__(156);
var LocaleUtils = __webpack_require__(296);
var ModifiersUtils = __webpack_require__(299);
var Weekday = __webpack_require__(802);
var Navbar = __webpack_require__(801);
var PropTypes = __webpack_require__(1764);

module.exports = DayPicker;
module.exports.DateUtils = DateUtils;
module.exports.LocaleUtils = LocaleUtils;
module.exports.ModifiersUtils = ModifiersUtils;
module.exports.WeekdayPropTypes = Weekday.propTypes;
module.exports.NavbarPropTypes = Navbar.propTypes;
module.exports.PropTypes = PropTypes;


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(142),
    root = __webpack_require__(78);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(235),
    isArguments = __webpack_require__(313),
    isArray = __webpack_require__(26),
    isIndex = __webpack_require__(304),
    isLength = __webpack_require__(354),
    toKey = __webpack_require__(203);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 849 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.marketingData = exports.announcementsNotification = exports.appNotification = exports.customers = exports.products = exports.radialData = exports.lineChartData = exports.pieChartData = exports.chartDataWithoutAxis = exports.chartData = exports.radarChartData = exports.data2 = exports.data1 = exports.data = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var data = [{
  name: 'Let A',
  uv: 0,
  pv: 0,
  amt: 20
}, {
  name: 'Let B',
  uv: 30,
  pv: 13,
  amt: 21
}, {
  name: 'Let C',
  uv: 20,
  pv: 98,
  amt: 29
}, {
  name: 'Let D',
  uv: 27,
  pv: 39,
  amt: 20
}, {
  name: 'Let E',
  uv: 18,
  pv: 48,
  amt: 28
}, {
  name: 'Let F',
  uv: 23,
  pv: 38,
  amt: 20
}, {
  name: 'Let G',
  uv: 0,
  pv: 0,
  amt: 20
}];
exports.data = data;
var data1 = [{
  name: 'Let A',
  uv: 40,
  pv: 24,
  amt: 20
}, {
  name: 'Let B',
  uv: 30,
  pv: 13,
  amt: 21
}, {
  name: 'Let C',
  uv: 60,
  pv: 98,
  amt: 29
}, {
  name: 'Let D',
  uv: 27,
  pv: 39,
  amt: 20
}, {
  name: 'Let E',
  uv: 78,
  pv: 48,
  amt: 28
}, {
  name: 'Let F',
  uv: 23,
  pv: 38,
  amt: 20
}, {
  name: 'Let G',
  uv: 56,
  pv: 43,
  amt: 20
}];
exports.data1 = data1;
var data2 = [{
  name: 'Let A',
  uv: 40,
  pv: 24,
  amt: 20
}, {
  name: 'Let B',
  uv: 10,
  pv: 13,
  amt: 21
}, {
  name: 'Let C',
  uv: 60,
  pv: 98,
  amt: 29
}, {
  name: 'Let D',
  uv: 27,
  pv: 15,
  amt: 20
}, {
  name: 'Let E',
  uv: 56,
  pv: 45,
  amt: 28
}, {
  name: 'Let F',
  uv: 23,
  pv: 56,
  amt: 20
}, {
  name: 'Let G',
  uv: 56,
  pv: 43,
  amt: 20
}];
exports.data2 = data2;
var radarChartData = [{
  subject: 'Math',
  A: 120,
  B: 110,
  fullMark: 150
}, {
  subject: 'Chinese',
  A: 98,
  B: 130,
  fullMark: 150
}, {
  subject: 'English',
  A: 86,
  B: 130,
  fullMark: 150
}, {
  subject: 'Geography',
  A: 99,
  B: 100,
  fullMark: 150
}, {
  subject: 'Physics',
  A: 85,
  B: 90,
  fullMark: 150
}, {
  subject: 'History',
  A: 65,
  B: 85,
  fullMark: 150
}];
exports.radarChartData = radarChartData;
var chartData = [{
  name: 'J',
  amt: 1400
}, {
  name: 'F',
  amt: 2210
}, {
  name: 'M',
  amt: 1000
}, {
  name: 'A',
  amt: 2000
}, {
  name: 'M',
  amt: 1400
}, {
  name: 'J',
  amt: 2300
}, {
  name: 'J',
  amt: 500
}, {
  name: 'A',
  amt: 2000
}, {
  name: 'S',
  amt: 1500
}, {
  name: 'S',
  amt: 1500
}, {
  name: 'O',
  amt: 1000
}, {
  name: 'N',
  amt: 2000
}, {
  name: 'D',
  amt: 500
}];
exports.chartData = chartData;
var chartDataWithoutAxis = [{
  name: 'J',
  amt: 1400
}, {
  name: 'F',
  amt: 2210
}, {
  name: 'M',
  amt: 1000
}, {
  name: 'A',
  amt: 2000
}, {
  name: 'M',
  amt: 1400
}, {
  name: 'J',
  amt: 2300
}, {
  name: 'J',
  amt: 500
}, {
  name: 'A',
  amt: 2000
}, {
  name: 'S',
  amt: 1500
}, {
  name: 'O',
  amt: 1000
}, {
  name: 'N',
  amt: 2000
}, {
  name: 'D',
  amt: 500
}, {
  name: 'M',
  amt: 1000
}, {
  name: 'A',
  amt: 2000
}, {
  name: 'M',
  amt: 1400
}];
exports.chartDataWithoutAxis = chartDataWithoutAxis;
var pieChartData = [{
  name: 'J',
  amt: 24
}, {
  name: 'F',
  amt: 18
}, {
  name: 'M',
  amt: 22
}, {
  name: 'A',
  amt: 17
}, {
  name: 'M',
  amt: 25
}, {
  name: 'J',
  amt: 12
}, {
  name: 'J',
  amt: 21
}];
exports.pieChartData = pieChartData;
var lineChartData = [{
  name: 'J',
  amt: 24244
}, {
  name: 'F',
  amt: 18123
}, {
  name: 'M',
  amt: 22765
}, {
  name: 'A',
  amt: 17097
}, {
  name: 'M',
  amt: 25529
}, {
  name: 'J',
  amt: 18669
}, {
  name: 'J',
  amt: 21812
}, {
  name: 'S',
  amt: 14988
}, {
  name: 'O',
  amt: 18693
}, {
  name: 'N',
  amt: 22900
}, {
  name: 'D',
  amt: 25313
}];
exports.lineChartData = lineChartData;
var radialData = [{
  name: 'Monthly Data',
  data: 48845,
  fill: '#3367d6'
}, {
  name: 'Orders Weekly',
  data: 8875,
  fill: '#83a6ed'
}, {
  name: 'Average Revenue',
  data: 21342,
  fill: '#8dd1e1'
}, {
  name: 'Total Revenue',
  data: 51875,
  fill: '#ffc658'
}, {
  name: 'Total Orders',
  data: 9223,
  fill: '#a4de6c'
}, {
  name: 'Past Orders',
  data: 8543,
  fill: '#d0ed57'
}];
exports.radialData = radialData;
var products = [{
  image: 'http://via.placeholder.com/600x450',
  title: "Up unpacked friendly",
  description: "Contrary to popular belief, Lorem Ipsum is not simply random text.",
  mrp: 250,
  offerPrice: 200
}, {
  image: 'http://via.placeholder.com/500x330',
  title: "It allowance prevailed",
  description: "It is a long established fact that a reader will be distracted",
  mrp: 250,
  offerPrice: 200
}, {
  image: 'http://via.placeholder.com/500x330',
  title: "Case read they must",
  description: "There are many variations of passages of Lorem Ipsum available",
  mrp: 250,
  offerPrice: 200
}, {
  image: 'http://via.placeholder.com/500x330',
  title: "Too carriage attended",
  description: "The standard chunk of Lorem Ipsum used since the 1500s",
  mrp: 250,
  offerPrice: 200
}];
exports.products = products;
var customers = [{
  id: 1,
  image: 'http://via.placeholder.com/150x150',
  name: "John Smith",
  about: "@john.s",
  detail: "3 orders",
  color: "success"
}, {
  id: 2,
  image: 'http://via.placeholder.com/150x150',
  name: "alex dolgove",
  about: "@Alex.Dolgove",
  detail: "2 orders",
  color: "primary"
}, {
  id: 3,
  image: 'http://via.placeholder.com/150x150',
  name: "Domnic Brown",
  about: "@domnic.brown",
  detail: "0 orders",
  color: "danger"
}, {
  id: 4,
  image: 'http://via.placeholder.com/150x150',
  name: "Jimmy jo",
  about: "@jimmy.jo",
  detail: "1 orders",
  color: "primary"
}];
exports.customers = customers;
var appNotification = [{
  id: 1,
  title: "NEW ORDER",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Stella"), " has placed an order for 3 items of $234.0"],
  image: 'http://via.placeholder.com/150x150'
}, {
  id: 2,
  title: "Support ticket",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Jeson Born"), " raised a support ticket"],
  image: 'http://via.placeholder.com/150x150'
}, {
  id: 3,
  title: "new enquiry",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Guptil"), " has placed an order for 5 items of $425.0"],
  image: 'http://via.placeholder.com/150x150'
}, {
  id: 4,
  title: "NEW ORDER",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Alex Dolgove"), " raised a support ticket"],
  image: 'http://via.placeholder.com/150x150'
}];
exports.appNotification = appNotification;
var announcementsNotification = [{
  id: 5,
  title: "NEW ORDER",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Alex Dolgove"), " raised a support ticket"],
  image: 'http://via.placeholder.com/150x150'
}, {
  id: 6,
  title: "Support ticket",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Jeson Born"), " raised a support ticket"],
  image: 'http://via.placeholder.com/150x150'
}, {
  id: 7,
  title: "NEW ORDER",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Stella"), " has placed an order for 3 items of $234.0"],
  image: 'http://via.placeholder.com/150x150'
}, {
  id: 8,
  title: "new enquiry",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Guptil"), " has placed an order for 5 items of $425.0"],
  image: 'http://via.placeholder.com/150x150'
}];
exports.announcementsNotification = announcementsNotification;
var marketingData = [{
  id: 1,
  name: 'Facebook Ads',
  desc: '63 Likes, 387 Shares',
  icon: 'facebook',
  color: 'bg-indigo lighten-1',
  budget: 570,
  growth: 20
}, {
  id: 2,
  name: 'Twitter Ads',
  desc: '43 Likes, 545 Shares',
  icon: 'twitter',
  color: 'bg-light-blue accent-2',
  budget: 811,
  growth: -5
}, {
  id: 3,
  name: 'Instagram',
  desc: '83 Follows, 210 Likes',
  icon: 'instagram',
  color: 'bg-brown lighten-1',
  budget: 685,
  growth: 20
}, {
  id: 4,
  name: 'LinkedIn',
  desc: '23 Shares, 764 Likes',
  icon: 'linkedin',
  color: 'bg-light-blue darken-3',
  budget: 868,
  growth: 25
}, {
  id: 5,
  name: 'Youtube',
  desc: '1.2k subscribe, 1.8M Likes',
  icon: 'youtube',
  color: 'bg-red accent-4',
  budget: 780,
  growth: 45
}, {
  id: 6,
  name: 'Dribbble',
  desc: '23 Shares, 1.4k Likes',
  icon: 'dribbble',
  color: 'bg-pink lighten-2',
  budget: 868,
  growth: 25
}];
exports.marketingData = marketingData;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(data, "data", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/routes/ECommerce/data.js");

  __REACT_HOT_LOADER__.register(data1, "data1", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/routes/ECommerce/data.js");

  __REACT_HOT_LOADER__.register(data2, "data2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/routes/ECommerce/data.js");

  __REACT_HOT_LOADER__.register(radarChartData, "radarChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/routes/ECommerce/data.js");

  __REACT_HOT_LOADER__.register(chartData, "chartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/routes/ECommerce/data.js");

  __REACT_HOT_LOADER__.register(chartDataWithoutAxis, "chartDataWithoutAxis", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/routes/ECommerce/data.js");

  __REACT_HOT_LOADER__.register(pieChartData, "pieChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/routes/ECommerce/data.js");

  __REACT_HOT_LOADER__.register(lineChartData, "lineChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/routes/ECommerce/data.js");

  __REACT_HOT_LOADER__.register(radialData, "radialData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/routes/ECommerce/data.js");

  __REACT_HOT_LOADER__.register(products, "products", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/routes/ECommerce/data.js");

  __REACT_HOT_LOADER__.register(customers, "customers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/routes/ECommerce/data.js");

  __REACT_HOT_LOADER__.register(appNotification, "appNotification", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/routes/ECommerce/data.js");

  __REACT_HOT_LOADER__.register(announcementsNotification, "announcementsNotification", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/routes/ECommerce/data.js");

  __REACT_HOT_LOADER__.register(marketingData, "marketingData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/routes/ECommerce/data.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/routes/ECommerce/data.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/routes/ECommerce/data.js");

  __REACT_HOT_LOADER__.register(data, "data", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/routes/ECommerce/data.js");

  __REACT_HOT_LOADER__.register(data1, "data1", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/routes/ECommerce/data.js");

  __REACT_HOT_LOADER__.register(data2, "data2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/routes/ECommerce/data.js");

  __REACT_HOT_LOADER__.register(radarChartData, "radarChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/routes/ECommerce/data.js");

  __REACT_HOT_LOADER__.register(chartData, "chartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/routes/ECommerce/data.js");

  __REACT_HOT_LOADER__.register(chartDataWithoutAxis, "chartDataWithoutAxis", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/routes/ECommerce/data.js");

  __REACT_HOT_LOADER__.register(pieChartData, "pieChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/routes/ECommerce/data.js");

  __REACT_HOT_LOADER__.register(lineChartData, "lineChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/routes/ECommerce/data.js");

  __REACT_HOT_LOADER__.register(radialData, "radialData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/routes/ECommerce/data.js");

  __REACT_HOT_LOADER__.register(products, "products", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/routes/ECommerce/data.js");

  __REACT_HOT_LOADER__.register(customers, "customers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/routes/ECommerce/data.js");

  __REACT_HOT_LOADER__.register(appNotification, "appNotification", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/routes/ECommerce/data.js");

  __REACT_HOT_LOADER__.register(announcementsNotification, "announcementsNotification", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/routes/ECommerce/data.js");

  __REACT_HOT_LOADER__.register(marketingData, "marketingData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/routes/ECommerce/data.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/routes/ECommerce/data.js");
}();

;

/***/ }),
/* 851 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 852 */
/***/ (function(module, exports) {

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = [{
  'id': 1457690400,
  'name': 'Stella Johnson',
  'thumb': 'http://via.placeholder.com/150x150',
  'email': 'stella.johnson@example.com',
  'phone': '+1-215-659-7529',
  'designation': 'CEO',
  'selected': false,
  'starred': false,
  'frequently': true
}, {
  'id': 1457690401,
  'name': 'Garry Sobars',
  'thumb': 'http://via.placeholder.com/150x150',
  'email': 'garry.sobars@example.com',
  'phone': '+1-215-745-7529',
  'designation': 'CFO',
  'selected': false,
  'starred': false,
  'frequently': true
}, {
  'id': 1457690402,
  'name': 'Alex Dolgove',
  'thumb': 'http://via.placeholder.com/150x150',
  'email': 'alex.dolgove@example.com',
  'phone': '+1-215-748-7855',
  'designation': 'Designer',
  'selected': false,
  'starred': false,
  'frequently': true
}, {
  'id': 1457690403,
  'name': 'Domnic Brown',
  'thumb': 'http://via.placeholder.com/150x150',
  'email': 'domnic.brown@example.com',
  'phone': '+1-215-756-4579',
  'designation': 'PHP Developer',
  'selected': false,
  'starred': false,
  'frequently': true
}, {
  'id': 1457690404,
  'name': 'Kadir M',
  'thumb': 'http://via.placeholder.com/150x150',
  'email': 'kadir.m@example.com',
  'phone': '+1-215-659-7586',
  'designation': 'HR Manager',
  'selected': false,
  'starred': false,
  'frequently': false
}, {
  'id': 1457690405,
  'name': 'John Smith',
  'thumb': 'http://via.placeholder.com/150x150',
  'email': 'john.smith@example.com',
  'phone': '+1-215-876-8596',
  'designation': 'Marketing Head',
  'selected': false,
  'starred': false,
  'frequently': false
}, {
  'id': 1457690406,
  'name': 'Domnic Harris',
  'thumb': 'http://via.placeholder.com/150x150',
  'email': 'domnic.harris@example.com',
  'phone': '+1-215-785-3841',
  'designation': 'BDO',
  'selected': false,
  'starred': true,
  'frequently': false
}, {
  'id': 1457690407,
  'name': 'Jimmy Jo',
  'thumb': 'http://via.placeholder.com/150x150',
  'email': 'jimmy.jo@example.com',
  'phone': '+1-215-456-5863',
  'designation': 'CCO',
  'selected': false,
  'starred': false,
  'frequently': false
}, {
  'id': 1457690408,
  'name': 'Jimmy Jon',
  'thumb': 'http://via.placeholder.com/150x150',
  'email': 'jimmy.jon@example.com',
  'phone': '+1-215-278-4558',
  'designation': 'Developer',
  'selected': false,
  'starred': true,
  'frequently': false
}, {
  'id': 1457690409,
  'name': 'Jeson Born',
  'thumb': 'http://via.placeholder.com/150x150',
  'email': 'jeson.born@example.com',
  'phone': '+1-215-286-7551',
  'designation': 'UI-UX Designer',
  'selected': false,
  'starred': false,
  'frequently': false
}, {
  'id': 1457690410,
  'name': 'Steve Smith',
  'thumb': 'http://via.placeholder.com/150x150',
  'email': 'steve.smith@example.com',
  'phone': '+1-215-586-5862',
  'designation': 'CEO',
  'selected': false,
  'starred': false,
  'frequently': false
}, {
  'id': 1457690500,
  'name': 'Stella Johnson',
  'thumb': 'http://via.placeholder.com/150x150',
  'email': 'stella.johnson@example.com',
  'phone': '+1-215-659-7529',
  'designation': 'CEO',
  'selected': false,
  'starred': false,
  'frequently': true
}, {
  'id': 1457690501,
  'name': 'Garry Sobars',
  'thumb': 'http://via.placeholder.com/150x150',
  'email': 'garry.sobars@example.com',
  'phone': '+1-215-745-7529',
  'designation': 'CFO',
  'selected': false,
  'starred': false,
  'frequently': true
}, {
  'id': 1457690502,
  'name': 'Alex Dolgove',
  'thumb': 'http://via.placeholder.com/150x150',
  'email': 'alex.dolgove@example.com',
  'phone': '+1-215-748-7855',
  'designation': 'Designer',
  'selected': false,
  'starred': false,
  'frequently': true
}, {
  'id': 1457690503,
  'name': 'Domnic Brown',
  'thumb': 'http://via.placeholder.com/150x150',
  'email': 'domnic.brown@example.com',
  'phone': '+1-215-756-4579',
  'designation': 'PHP Developer',
  'selected': false,
  'starred': false,
  'frequently': true
}, {
  'id': 1457690404,
  'name': 'Kadir M',
  'thumb': 'http://via.placeholder.com/150x150',
  'email': 'kadir.m@example.com',
  'phone': '+1-215-659-7586',
  'designation': 'HR Manager',
  'selected': false,
  'starred': false,
  'frequently': false
}, {
  'id': 1457690505,
  'name': 'John Smith',
  'thumb': 'http://via.placeholder.com/150x150',
  'email': 'john.smith@example.com',
  'phone': '+1-215-876-8596',
  'designation': 'Marketing Head',
  'selected': false,
  'starred': false,
  'frequently': false
}, {
  'id': 1457690506,
  'name': 'Domnic Harris',
  'thumb': 'http://via.placeholder.com/150x150',
  'email': 'domnic.harris@example.com',
  'phone': '+1-215-785-3841',
  'designation': 'BDO',
  'selected': false,
  'starred': true,
  'frequently': false
}, {
  'id': 1457690507,
  'name': 'Jimmy Jo',
  'thumb': 'http://via.placeholder.com/150x150',
  'email': 'jimmy.jo@example.com',
  'phone': '+1-215-456-5863',
  'designation': 'CCO',
  'selected': false,
  'starred': false,
  'frequently': false
}, {
  'id': 1457690508,
  'name': 'Jimmy Jon',
  'thumb': 'http://via.placeholder.com/150x150',
  'email': 'jimmy.jon@example.com',
  'phone': '+1-215-278-4558',
  'designation': 'Developer',
  'selected': false,
  'starred': true,
  'frequently': false
}, {
  'id': 1457690509,
  'name': 'Jeson Born',
  'thumb': 'http://via.placeholder.com/150x150',
  'email': 'jeson.born@example.com',
  'phone': '+1-215-286-7551',
  'designation': 'UI-UX Designer',
  'selected': false,
  'starred': false,
  'frequently': false
}, {
  'id': 1457690510,
  'name': 'Steve Smith',
  'thumb': 'http://via.placeholder.com/150x150',
  'email': 'steve.smith@example.com',
  'phone': '+1-215-586-5862',
  'designation': 'CEO',
  'selected': false,
  'starred': false,
  'frequently': false
}];
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/contact/data/contactList.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/contact/data/contactList.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/contact/data/contactList.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/contact/data/contactList.js");
}();

;

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(311),
    arrayIncludes = __webpack_require__(428),
    arrayIncludesWith = __webpack_require__(444),
    cacheHas = __webpack_require__(312),
    createSet = __webpack_require__(1552),
    setToArray = __webpack_require__(351);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.4.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2019-05-01T21:04Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};




	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.4.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a global context
	globalEval: function( code, options ) {
		DOMEval( code, { nonce: options && options.nonce } );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.4
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2019-04-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rhtml = /HTML$/i,
	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!nonnativeSelectorCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) &&

				// Support: IE 8 only
				// Exclude object elements
				(nodeType !== 1 || context.nodeName.toLowerCase() !== "object") ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 && rdescend.test( selector ) ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	var namespace = elem.namespaceURI,
		docElem = (elem.ownerDocument || elem).documentElement;

	// Support: IE <=8
	// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	// https://bugs.jquery.com/ticket/4833
	return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	if ( support.matchesSelector && documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ?
				argument + length :
				argument > length ?
					length :
					argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( typeof elem.contentDocument !== "undefined" ) {
			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();


var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
function expectSync( elem, type ) {
	return ( elem === safeActiveElement() ) === ( type === "focus" );
}

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", returnTrue );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, expectSync ) {

	// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
	if ( !expectSync ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var notAsync, result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				// Saved data should be false in such cases, but might be a leftover capture object
				// from an async native handler (gh-4350)
				if ( !saved.length ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					// Support: IE <=9 - 11+
					// focus() and blur() are asynchronous
					notAsync = expectSync( this, type );
					this[ type ]();
					result = dataPriv.get( this, type );
					if ( saved !== result || notAsync ) {
						dataPriv.set( this, type, false );
					} else {
						result = {};
					}
					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();
						return result.value;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering the
				// native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved.length ) {

				// ...and capture the result
				dataPriv.set( this, type, {
					value: jQuery.event.trigger(

						// Support: IE <=9 - 11+
						// Extend with the prototype to reset the above stopImmediatePropagation()
						jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
						saved.slice( 1 ),
						this
					)
				} );

				// Abort handling of the native event
				event.stopImmediatePropagation();
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, expectSync );

			// Return false to allow normal processing in the caller
			return false;
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		delegateType: delegateType
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								} );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Fall back to offsetWidth/offsetHeight when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	// Support: Android <=4.1 - 4.3 only
	// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
	// Support: IE 9-11 only
	// Also use offsetWidth/offsetHeight for when box sizing is unreliable
	// We use getClientRects() to check for hidden/disconnected.
	// In those cases, the computed value can be trusted to be border-box
	if ( ( !support.boxSizingReliable() && isBorderBox ||
		val === "auto" ||
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"gridArea": true,
		"gridColumn": true,
		"gridColumnEnd": true,
		"gridColumnStart": true,
		"gridRow": true,
		"gridRowEnd": true,
		"gridRowStart": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = Date.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url, options ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_contains__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_ContainerRender__ = __webpack_require__(1745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_Portal__ = __webpack_require__(1746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Popup__ = __webpack_require__(1747);
















function noop() {}

function returnEmptyString() {
  return '';
}

function returnDocument() {
  return window.document;
}

var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];

var IS_REACT_16 = !!__WEBPACK_IMPORTED_MODULE_6_react_dom__["createPortal"];

var contextTypes = {
  rcTrigger: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    onPopupMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
  })
};

var Trigger = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Trigger, _React$Component);

  function Trigger(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Trigger);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var popupVisible = void 0;
    if ('popupVisible' in props) {
      popupVisible = !!props.popupVisible;
    } else {
      popupVisible = !!props.defaultPopupVisible;
    }

    _this.prevPopupVisible = popupVisible;

    _this.state = {
      popupVisible: popupVisible
    };
    return _this;
  }

  Trigger.prototype.getChildContext = function getChildContext() {
    return {
      rcTrigger: {
        onPopupMouseDown: this.onPopupMouseDown
      }
    };
  };

  Trigger.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    ALL_HANDLERS.forEach(function (h) {
      _this2['fire' + h] = function (e) {
        _this2.fireEvents(h, e);
      };
    });
  };

  Trigger.prototype.componentDidMount = function componentDidMount() {
    this.componentDidUpdate({}, {
      popupVisible: this.state.popupVisible
    });
  };

  Trigger.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var popupVisible = _ref.popupVisible;

    if (popupVisible !== undefined) {
      this.setState({
        popupVisible: popupVisible
      });
    }
  };

  Trigger.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
    var props = this.props;
    var state = this.state;
    var triggerAfterPopupVisibleChange = function triggerAfterPopupVisibleChange() {
      if (prevState.popupVisible !== state.popupVisible) {
        props.afterPopupVisibleChange(state.popupVisible);
      }
    };
    if (!IS_REACT_16) {
      this.renderComponent(null, triggerAfterPopupVisibleChange);
    }

    this.prevPopupVisible = prevState.popupVisible;

    // We must listen to `mousedown` or `touchstart`, edge case:
    // https://github.com/ant-design/ant-design/issues/5804
    // https://github.com/react-component/calendar/issues/250
    // https://github.com/react-component/trigger/issues/50
    if (state.popupVisible) {
      var currentDocument = void 0;
      if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
        currentDocument = props.getDocument();
        this.clickOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'mousedown', this.onDocumentClick);
      }
      // always hide on mobile
      if (!this.touchOutsideHandler) {
        currentDocument = currentDocument || props.getDocument();
        this.touchOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'touchstart', this.onDocumentClick);
      }
      // close popup when trigger type contains 'onContextMenu' and document is scrolling.
      if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
        currentDocument = currentDocument || props.getDocument();
        this.contextMenuOutsideHandler1 = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'scroll', this.onContextMenuClose);
      }
      // close popup when trigger type contains 'onContextMenu' and window is blur.
      if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
        this.contextMenuOutsideHandler2 = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'blur', this.onContextMenuClose);
      }
      return;
    }

    this.clearOutsideHandler();
  };

  Trigger.prototype.componentWillUnmount = function componentWillUnmount() {
    this.clearDelayTimer();
    this.clearOutsideHandler();
    clearTimeout(this.mouseDownTimeout);
  };

  Trigger.prototype.getPopupDomNode = function getPopupDomNode() {
    // for test
    if (this._component && this._component.getPopupDomNode) {
      return this._component.getPopupDomNode();
    }
    return null;
  };

  Trigger.prototype.getPopupAlign = function getPopupAlign() {
    var props = this.props;
    var popupPlacement = props.popupPlacement,
        popupAlign = props.popupAlign,
        builtinPlacements = props.builtinPlacements;

    if (popupPlacement && builtinPlacements) {
      return Object(__WEBPACK_IMPORTED_MODULE_12__utils__["a" /* getAlignFromPlacement */])(builtinPlacements, popupPlacement, popupAlign);
    }
    return popupAlign;
  };

  /**
   * @param popupVisible    Show or not the popup element
   * @param event           SyntheticEvent, used for `pointAlign`
   */
  Trigger.prototype.setPopupVisible = function setPopupVisible(popupVisible, event) {
    var alignPoint = this.props.alignPoint;


    this.clearDelayTimer();

    if (this.state.popupVisible !== popupVisible) {
      if (!('popupVisible' in this.props)) {
        this.setState({ popupVisible: popupVisible });
      }
      this.props.onPopupVisibleChange(popupVisible);
    }

    // Always record the point position since mouseEnterDelay will delay the show
    if (alignPoint && event) {
      this.setPoint(event);
    }
  };

  Trigger.prototype.delaySetPopupVisible = function delaySetPopupVisible(visible, delayS, event) {
    var _this3 = this;

    var delay = delayS * 1000;
    this.clearDelayTimer();
    if (delay) {
      var point = event ? { pageX: event.pageX, pageY: event.pageY } : null;
      this.delayTimer = setTimeout(function () {
        _this3.setPopupVisible(visible, point);
        _this3.clearDelayTimer();
      }, delay);
    } else {
      this.setPopupVisible(visible, event);
    }
  };

  Trigger.prototype.clearDelayTimer = function clearDelayTimer() {
    if (this.delayTimer) {
      clearTimeout(this.delayTimer);
      this.delayTimer = null;
    }
  };

  Trigger.prototype.clearOutsideHandler = function clearOutsideHandler() {
    if (this.clickOutsideHandler) {
      this.clickOutsideHandler.remove();
      this.clickOutsideHandler = null;
    }

    if (this.contextMenuOutsideHandler1) {
      this.contextMenuOutsideHandler1.remove();
      this.contextMenuOutsideHandler1 = null;
    }

    if (this.contextMenuOutsideHandler2) {
      this.contextMenuOutsideHandler2.remove();
      this.contextMenuOutsideHandler2 = null;
    }

    if (this.touchOutsideHandler) {
      this.touchOutsideHandler.remove();
      this.touchOutsideHandler = null;
    }
  };

  Trigger.prototype.createTwoChains = function createTwoChains(event) {
    var childPros = this.props.children.props;
    var props = this.props;
    if (childPros[event] && props[event]) {
      return this['fire' + event];
    }
    return childPros[event] || props[event];
  };

  Trigger.prototype.isClickToShow = function isClickToShow() {
    var _props = this.props,
        action = _props.action,
        showAction = _props.showAction;

    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isContextMenuToShow = function isContextMenuToShow() {
    var _props2 = this.props,
        action = _props2.action,
        showAction = _props2.showAction;

    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
  };

  Trigger.prototype.isClickToHide = function isClickToHide() {
    var _props3 = this.props,
        action = _props3.action,
        hideAction = _props3.hideAction;

    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isMouseEnterToShow = function isMouseEnterToShow() {
    var _props4 = this.props,
        action = _props4.action,
        showAction = _props4.showAction;

    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
  };

  Trigger.prototype.isMouseLeaveToHide = function isMouseLeaveToHide() {
    var _props5 = this.props,
        action = _props5.action,
        hideAction = _props5.hideAction;

    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
  };

  Trigger.prototype.isFocusToShow = function isFocusToShow() {
    var _props6 = this.props,
        action = _props6.action,
        showAction = _props6.showAction;

    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
  };

  Trigger.prototype.isBlurToHide = function isBlurToHide() {
    var _props7 = this.props,
        action = _props7.action,
        hideAction = _props7.hideAction;

    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
  };

  Trigger.prototype.forcePopupAlign = function forcePopupAlign() {
    if (this.state.popupVisible && this._component && this._component.alignInstance) {
      this._component.alignInstance.forceAlign();
    }
  };

  Trigger.prototype.fireEvents = function fireEvents(type, e) {
    var childCallback = this.props.children.props[type];
    if (childCallback) {
      childCallback(e);
    }
    var callback = this.props[type];
    if (callback) {
      callback(e);
    }
  };

  Trigger.prototype.close = function close() {
    this.setPopupVisible(false);
  };

  Trigger.prototype.render = function render() {
    var _this4 = this;

    var popupVisible = this.state.popupVisible;
    var _props8 = this.props,
        children = _props8.children,
        forceRender = _props8.forceRender,
        alignPoint = _props8.alignPoint,
        className = _props8.className;

    var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
    var newChildProps = { key: 'trigger' };

    if (this.isContextMenuToShow()) {
      newChildProps.onContextMenu = this.onContextMenu;
    } else {
      newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
    }

    if (this.isClickToHide() || this.isClickToShow()) {
      newChildProps.onClick = this.onClick;
      newChildProps.onMouseDown = this.onMouseDown;
      newChildProps.onTouchStart = this.onTouchStart;
    } else {
      newChildProps.onClick = this.createTwoChains('onClick');
      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
    }
    if (this.isMouseEnterToShow()) {
      newChildProps.onMouseEnter = this.onMouseEnter;
      if (alignPoint) {
        newChildProps.onMouseMove = this.onMouseMove;
      }
    } else {
      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
    }
    if (this.isMouseLeaveToHide()) {
      newChildProps.onMouseLeave = this.onMouseLeave;
    } else {
      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
    }
    if (this.isFocusToShow() || this.isBlurToHide()) {
      newChildProps.onFocus = this.onFocus;
      newChildProps.onBlur = this.onBlur;
    } else {
      newChildProps.onFocus = this.createTwoChains('onFocus');
      newChildProps.onBlur = this.createTwoChains('onBlur');
    }

    var childrenClassName = __WEBPACK_IMPORTED_MODULE_11_classnames___default()(child && child.props && child.props.className, className);
    if (childrenClassName) {
      newChildProps.className = childrenClassName;
    }
    var trigger = __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newChildProps);

    if (!IS_REACT_16) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_rc_util_es_ContainerRender__["a" /* default */],
        {
          parent: this,
          visible: popupVisible,
          autoMount: false,
          forceRender: forceRender,
          getComponent: this.getComponent,
          getContainer: this.getContainer
        },
        function (_ref2) {
          var renderComponent = _ref2.renderComponent;

          _this4.renderComponent = renderComponent;
          return trigger;
        }
      );
    }

    var portal = void 0;
    // prevent unmounting after it's rendered
    if (popupVisible || this._component || forceRender) {
      portal = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_rc_util_es_Portal__["a" /* default */],
        {
          key: 'portal',
          getContainer: this.getContainer,
          didUpdate: this.handlePortalUpdate
        },
        this.getComponent()
      );
    }

    return [trigger, portal];
  };

  return Trigger;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Trigger.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  action: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string)]),
  showAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  hideAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  getPopupClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  onPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  afterPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]).isRequired,
  popupStyle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupPlacement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  builtinPlacements: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  popupAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  zIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  focusDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  blurDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  getPopupContainer: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getDocument: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  forceRender: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  mask: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskClosable: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  onPopupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  defaultPopupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  maskAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  alignPoint: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool // Maybe we can support user pass position in the future
};
Trigger.contextTypes = contextTypes;
Trigger.childContextTypes = contextTypes;
Trigger.defaultProps = {
  prefixCls: 'rc-trigger-popup',
  getPopupClassNameFromAlign: returnEmptyString,
  getDocument: returnDocument,
  onPopupVisibleChange: noop,
  afterPopupVisibleChange: noop,
  onPopupAlign: noop,
  popupClassName: '',
  mouseEnterDelay: 0,
  mouseLeaveDelay: 0.1,
  focusDelay: 0,
  blurDelay: 0.15,
  popupStyle: {},
  destroyPopupOnHide: false,
  popupAlign: {},
  defaultPopupVisible: false,
  mask: false,
  maskClosable: true,
  action: [],
  showAction: [],
  hideAction: []
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.onMouseEnter = function (e) {
    var mouseEnterDelay = _this5.props.mouseEnterDelay;

    _this5.fireEvents('onMouseEnter', e);
    _this5.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
  };

  this.onMouseMove = function (e) {
    _this5.fireEvents('onMouseMove', e);
    _this5.setPoint(e);
  };

  this.onMouseLeave = function (e) {
    _this5.fireEvents('onMouseLeave', e);
    _this5.delaySetPopupVisible(false, _this5.props.mouseLeaveDelay);
  };

  this.onPopupMouseEnter = function () {
    _this5.clearDelayTimer();
  };

  this.onPopupMouseLeave = function (e) {
    // https://github.com/react-component/trigger/pull/13
    // react bug?
    if (e.relatedTarget && !e.relatedTarget.setTimeout && _this5._component && _this5._component.getPopupDomNode && Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_contains__["a" /* default */])(_this5._component.getPopupDomNode(), e.relatedTarget)) {
      return;
    }
    _this5.delaySetPopupVisible(false, _this5.props.mouseLeaveDelay);
  };

  this.onFocus = function (e) {
    _this5.fireEvents('onFocus', e);
    // incase focusin and focusout
    _this5.clearDelayTimer();
    if (_this5.isFocusToShow()) {
      _this5.focusTime = Date.now();
      _this5.delaySetPopupVisible(true, _this5.props.focusDelay);
    }
  };

  this.onMouseDown = function (e) {
    _this5.fireEvents('onMouseDown', e);
    _this5.preClickTime = Date.now();
  };

  this.onTouchStart = function (e) {
    _this5.fireEvents('onTouchStart', e);
    _this5.preTouchTime = Date.now();
  };

  this.onBlur = function (e) {
    _this5.fireEvents('onBlur', e);
    _this5.clearDelayTimer();
    if (_this5.isBlurToHide()) {
      _this5.delaySetPopupVisible(false, _this5.props.blurDelay);
    }
  };

  this.onContextMenu = function (e) {
    e.preventDefault();
    _this5.fireEvents('onContextMenu', e);
    _this5.setPopupVisible(true, e);
  };

  this.onContextMenuClose = function () {
    if (_this5.isContextMenuToShow()) {
      _this5.close();
    }
  };

  this.onClick = function (event) {
    _this5.fireEvents('onClick', event);
    // focus will trigger click
    if (_this5.focusTime) {
      var preTime = void 0;
      if (_this5.preClickTime && _this5.preTouchTime) {
        preTime = Math.min(_this5.preClickTime, _this5.preTouchTime);
      } else if (_this5.preClickTime) {
        preTime = _this5.preClickTime;
      } else if (_this5.preTouchTime) {
        preTime = _this5.preTouchTime;
      }
      if (Math.abs(preTime - _this5.focusTime) < 20) {
        return;
      }
      _this5.focusTime = 0;
    }
    _this5.preClickTime = 0;
    _this5.preTouchTime = 0;
    if (event && event.preventDefault) {
      event.preventDefault();
    }
    var nextVisible = !_this5.state.popupVisible;
    if (_this5.isClickToHide() && !nextVisible || nextVisible && _this5.isClickToShow()) {
      _this5.setPopupVisible(!_this5.state.popupVisible, event);
    }
  };

  this.onPopupMouseDown = function () {
    var _context$rcTrigger = _this5.context.rcTrigger,
        rcTrigger = _context$rcTrigger === undefined ? {} : _context$rcTrigger;

    _this5.hasPopupMouseDown = true;

    clearTimeout(_this5.mouseDownTimeout);
    _this5.mouseDownTimeout = setTimeout(function () {
      _this5.hasPopupMouseDown = false;
    }, 0);

    if (rcTrigger.onPopupMouseDown) {
      rcTrigger.onPopupMouseDown.apply(rcTrigger, arguments);
    }
  };

  this.onDocumentClick = function (event) {
    if (_this5.props.mask && !_this5.props.maskClosable) {
      return;
    }

    var target = event.target;
    var root = Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this5);
    if (!Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_contains__["a" /* default */])(root, target) && !_this5.hasPopupMouseDown) {
      _this5.close();
    }
  };

  this.getRootDomNode = function () {
    return Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this5);
  };

  this.getPopupClassNameFromAlign = function (align) {
    var className = [];
    var _props9 = _this5.props,
        popupPlacement = _props9.popupPlacement,
        builtinPlacements = _props9.builtinPlacements,
        prefixCls = _props9.prefixCls,
        alignPoint = _props9.alignPoint,
        getPopupClassNameFromAlign = _props9.getPopupClassNameFromAlign;

    if (popupPlacement && builtinPlacements) {
      className.push(Object(__WEBPACK_IMPORTED_MODULE_12__utils__["b" /* getAlignPopupClassName */])(builtinPlacements, prefixCls, align, alignPoint));
    }
    if (getPopupClassNameFromAlign) {
      className.push(getPopupClassNameFromAlign(align));
    }
    return className.join(' ');
  };

  this.getComponent = function () {
    var _props10 = _this5.props,
        prefixCls = _props10.prefixCls,
        destroyPopupOnHide = _props10.destroyPopupOnHide,
        popupClassName = _props10.popupClassName,
        action = _props10.action,
        onPopupAlign = _props10.onPopupAlign,
        popupAnimation = _props10.popupAnimation,
        popupTransitionName = _props10.popupTransitionName,
        popupStyle = _props10.popupStyle,
        mask = _props10.mask,
        maskAnimation = _props10.maskAnimation,
        maskTransitionName = _props10.maskTransitionName,
        zIndex = _props10.zIndex,
        popup = _props10.popup,
        stretch = _props10.stretch,
        alignPoint = _props10.alignPoint;
    var _state = _this5.state,
        popupVisible = _state.popupVisible,
        point = _state.point;


    var align = _this5.getPopupAlign();

    var mouseProps = {};
    if (_this5.isMouseEnterToShow()) {
      mouseProps.onMouseEnter = _this5.onPopupMouseEnter;
    }
    if (_this5.isMouseLeaveToHide()) {
      mouseProps.onMouseLeave = _this5.onPopupMouseLeave;
    }

    mouseProps.onMouseDown = _this5.onPopupMouseDown;
    mouseProps.onTouchStart = _this5.onPopupMouseDown;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_13__Popup__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        prefixCls: prefixCls,
        destroyPopupOnHide: destroyPopupOnHide,
        visible: popupVisible,
        point: alignPoint && point,
        className: popupClassName,
        action: action,
        align: align,
        onAlign: onPopupAlign,
        animation: popupAnimation,
        getClassNameFromAlign: _this5.getPopupClassNameFromAlign
      }, mouseProps, {
        stretch: stretch,
        getRootDomNode: _this5.getRootDomNode,
        style: popupStyle,
        mask: mask,
        zIndex: zIndex,
        transitionName: popupTransitionName,
        maskAnimation: maskAnimation,
        maskTransitionName: maskTransitionName,
        ref: _this5.savePopup
      }),
      typeof popup === 'function' ? popup() : popup
    );
  };

  this.getContainer = function () {
    var props = _this5.props;

    var popupContainer = document.createElement('div');
    // Make sure default popup container will never cause scrollbar appearing
    // https://github.com/react-component/trigger/issues/41
    popupContainer.style.position = 'absolute';
    popupContainer.style.top = '0';
    popupContainer.style.left = '0';
    popupContainer.style.width = '100%';
    var mountNode = props.getPopupContainer ? props.getPopupContainer(Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this5)) : props.getDocument().body;
    mountNode.appendChild(popupContainer);
    return popupContainer;
  };

  this.setPoint = function (point) {
    var alignPoint = _this5.props.alignPoint;

    if (!alignPoint || !point) return;

    _this5.setState({
      point: {
        pageX: point.pageX,
        pageY: point.pageY
      }
    });
  };

  this.handlePortalUpdate = function () {
    if (_this5.prevPopupVisible !== _this5.state.popupVisible) {
      _this5.props.afterPopupVisibleChange(_this5.state.popupVisible);
    }
  };

  this.savePopup = function (node) {
    _this5._component = node;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Trigger);

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)))

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = [{
  id: 1,
  name: 'Alex Dolgove',
  thumb: 'http://via.placeholder.com/150x150',
  status: 'away',
  mood: 'English versions from the 1914 translation by H. Rackham',
  lastMessage: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem',
  unreadMessage: '',
  lastMessageTime: '20 min ago',
  recent: false
}, {
  id: 2,
  name: 'Domnic Brown',
  thumb: 'http://via.placeholder.com/150x150',
  status: 'online',
  mood: 'English versions from the 1914 translation by H. Rackham',
  lastMessage: 'It is a long established fact',
  unreadMessage: '4',
  lastMessageTime: 'Yesterday',
  recent: true
}, {
  id: 3,
  name: 'Domnic Harris',
  thumb: 'http://via.placeholder.com/150x150',
  status: 'offline',
  mood: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem',
  lastMessage: 'There are many variations of passages of ',
  unreadMessage: '',
  lastMessageTime: '20/11/17',
  recent: false
}, {
  id: 4,
  name: 'Garry Sobars',
  thumb: 'http://via.placeholder.com/150x150',
  status: 'away',
  mood: 'It is a long established fact',
  lastMessage: 'English versions from the 1914 translation by H. Rackham',
  unreadMessage: '3',
  lastMessageTime: 'Yesterday',
  recent: true
}, {
  id: 5,
  name: 'Jeson Born',
  thumb: 'http://via.placeholder.com/150x150',
  status: 'away',
  mood: 'I must explain to you how all this mistaken idea of denouncing ',
  lastMessage: 'It is a long established fact',
  unreadMessage: '',
  lastMessageTime: 'Monday',
  recent: true
}, {
  id: 6,
  name: 'Jimmy Jo',
  thumb: 'http://via.placeholder.com/150x150',
  status: 'online',
  mood: 'The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested',
  lastMessage: 'All the Lorem Ipsum generators on the',
  unreadMessage: '',
  lastMessageTime: 'Friday',
  recent: false
}, {
  id: 7,
  name: 'John Smith',
  thumb: 'http://via.placeholder.com/150x150',
  status: 'away',
  mood: 'There are many variations of passages of ',
  lastMessage: 'The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested',
  unreadMessage: '',
  lastMessageTime: 'Tuesday',
  recent: true
}, {
  id: 8,
  name: 'Kadir M',
  thumb: 'http://via.placeholder.com/150x150',
  status: 'online',
  mood: 'All the Lorem Ipsum generators on the',
  lastMessage: 'I must explain to you how all this mistaken idea of denouncing ',
  unreadMessage: '5',
  lastMessageTime: 'Monday',
  recent: false
}, {
  id: 9,
  name: 'Jimmy Jon',
  thumb: 'http://via.placeholder.com/150x150',
  status: 'offline',
  mood: 'There are many variations of passages of ',
  lastMessage: 'There are many variations of passages of ',
  unreadMessage: '',
  lastMessageTime: '30 Min ago',
  recent: false
}, {
  id: 10,
  name: 'Stella Johnson',
  thumb: 'http://via.placeholder.com/150x150',
  status: 'offline',
  mood: 'It is a long established fact',
  lastMessage: 'English versions from the 1914 translation by H. Rackham',
  unreadMessage: '',
  lastMessageTime: 'Yesterday',
  recent: false
}, {
  id: 11,
  name: 'Steve Smith',
  thumb: 'http://via.placeholder.com/150x150',
  status: 'online',
  mood: 'The standard chunk of Lorem Ipsum used since the 1500s',
  lastMessage: 'The standard chunk of Lorem Ipsum used since the 1500s',
  unreadMessage: '2',
  lastMessageTime: 'Monday',
  recent: false
}];
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/chatPanel/data/chatUsers.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/chatPanel/data/chatUsers.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/chatPanel/data/chatUsers.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/chatPanel/data/chatUsers.js");
}();

;

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = [{
  'id': 1,
  'conversationData': [{
    'type': 'sent',
    'message': 'It is a long established fact',
    'sentAt': '3:08:35 PM'
  }, {
    'type': 'received',
    'message': 'I must explain to you how all this mistaken idea of denouncing ',
    'sentAt': '3:10:28 PM'
  }, {
    'type': 'sent',
    'message': 'The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested',
    'sentAt': '3:11:25 PM'
  }, {
    'type': 'received',
    'message': 'There are many variations of passages of ',
    'sentAt': '3:12:36 PM'
  }, {
    'type': 'received',
    'message': 'All the Lorem Ipsum generators on the',
    'sentAt': '3:12:45 PM'
  }, {
    'type': 'sent',
    'message': 'There are many variations of passages of ',
    'sentAt': '3:13:04 PM'
  }, {
    'type': 'received',
    'message': 'It is a long established fact',
    'sentAt': '3:13:28 PM'
  }, {
    'type': 'sent',
    'message': 'The standard chunk of Lorem Ipsum used since the 1500s',
    'sentAt': '3:15:45 PM'
  }]
}, {
  'id': 2,
  'conversationData': [{
    'type': 'sent',
    'message': 'English versions from the 1914 translation by H. Rackham',
    'sentAt': '3:03:28 PM'
  }, {
    'type': 'received',
    'message': 'English versions from the 1914 translation by H. Rackham',
    'sentAt': '3:05:47 PM'
  }, {
    'type': 'sent',
    'message': 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem',
    'sentAt': '3:07:52 PM'
  }, {
    'type': 'received',
    'message': 'There are many variations of passages of ',
    'sentAt': '3:12:36 PM'
  }, {
    'type': 'received',
    'message': 'All the Lorem Ipsum generators on the',
    'sentAt': '3:12:45 PM'
  }, {
    'type': 'sent',
    'message': 'There are many variations of passages of ',
    'sentAt': '3:13:04 PM'
  }]
}, {
  'id': 3,
  'conversationData': [{
    'type': 'sent',
    'message': 'It is a long established fact',
    'sentAt': '3:08:35 PM'
  }, {
    'type': 'received',
    'message': 'I must explain to you how all this mistaken idea of denouncing ',
    'sentAt': '3:10:28 PM'
  }, {
    'type': 'sent',
    'message': 'The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested',
    'sentAt': '3:11:25 PM'
  }, {
    'type': 'received',
    'message': 'There are many variations of passages of ',
    'sentAt': '3:12:36 PM'
  }, {
    'type': 'received',
    'message': 'All the Lorem Ipsum generators on the',
    'sentAt': '3:12:45 PM'
  }, {
    'type': 'sent',
    'message': 'There are many variations of passages of ',
    'sentAt': '3:13:04 PM'
  }, {
    'type': 'received',
    'message': 'It is a long established fact',
    'sentAt': '3:13:28 PM'
  }]
}, {
  'id': 4,
  'conversationData': [{
    'type': 'sent',
    'message': 'English versions from the 1914 translation by H. Rackham',
    'sentAt': '3:03:28 PM'
  }, {
    'type': 'received',
    'message': 'English versions from the 1914 translation by H. Rackham',
    'sentAt': '3:05:47 PM'
  }, {
    'type': 'sent',
    'message': 'The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested',
    'sentAt': '3:11:25 PM'
  }, {
    'type': 'received',
    'message': 'There are many variations of passages of ',
    'sentAt': '3:12:36 PM'
  }, {
    'type': 'received',
    'message': 'All the Lorem Ipsum generators on the',
    'sentAt': '3:12:45 PM'
  }, {
    'type': 'sent',
    'message': 'There are many variations of passages of ',
    'sentAt': '3:13:04 PM'
  }, {
    'type': 'received',
    'message': 'It is a long established fact',
    'sentAt': '3:13:28 PM'
  }, {
    'type': 'sent',
    'message': 'The standard chunk of Lorem Ipsum used since the 1500s',
    'sentAt': '3:15:45 PM'
  }]
}, {
  'id': 5,
  'conversationData': [{
    'type': 'sent',
    'message': 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem',
    'sentAt': '3:07:52 PM'
  }, {
    'type': 'sent',
    'message': 'It is a long established fact',
    'sentAt': '3:08:35 PM'
  }, {
    'type': 'received',
    'message': 'I must explain to you how all this mistaken idea of denouncing ',
    'sentAt': '3:10:28 PM'
  }, {
    'type': 'sent',
    'message': 'The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested',
    'sentAt': '3:11:25 PM'
  }, {
    'type': 'received',
    'message': 'There are many variations of passages of ',
    'sentAt': '3:12:36 PM'
  }, {
    'type': 'received',
    'message': 'It is a long established fact',
    'sentAt': '3:13:28 PM'
  }, {
    'type': 'sent',
    'message': 'The standard chunk of Lorem Ipsum used since the 1500s',
    'sentAt': '3:15:45 PM'
  }]
}, {
  'id': 6,
  'conversationData': [{
    'type': 'sent',
    'message': 'It is a long established fact',
    'sentAt': '3:08:35 PM'
  }, {
    'type': 'received',
    'message': 'I must explain to you how all this mistaken idea of denouncing ',
    'sentAt': '3:10:28 PM'
  }, {
    'type': 'sent',
    'message': 'The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested',
    'sentAt': '3:11:25 PM'
  }, {
    'type': 'received',
    'message': 'There are many variations of passages of ',
    'sentAt': '3:12:36 PM'
  }, {
    'type': 'received',
    'message': 'It is a long established fact',
    'sentAt': '3:13:28 PM'
  }, {
    'type': 'sent',
    'message': 'The standard chunk of Lorem Ipsum used since the 1500s',
    'sentAt': '3:15:45 PM'
  }]
}, {
  'id': 7,
  'conversationData': [{
    'type': 'received',
    'message': 'English versions from the 1914 translation by H. Rackham',
    'sentAt': '3:05:47 PM'
  }, {
    'type': 'sent',
    'message': 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem',
    'sentAt': '3:07:52 PM'
  }, {
    'type': 'sent',
    'message': 'It is a long established fact',
    'sentAt': '3:08:35 PM'
  }, {
    'type': 'received',
    'message': 'There are many variations of passages of ',
    'sentAt': '3:12:36 PM'
  }, {
    'type': 'received',
    'message': 'All the Lorem Ipsum generators on the',
    'sentAt': '3:12:45 PM'
  }, {
    'type': 'sent',
    'message': 'There are many variations of passages of ',
    'sentAt': '3:13:04 PM'
  }, {
    'type': 'received',
    'message': 'It is a long established fact',
    'sentAt': '3:13:28 PM'
  }]
}, {
  'id': 8,
  'conversationData': [{
    'type': 'sent',
    'message': 'English versions from the 1914 translation by H. Rackham',
    'sentAt': '3:03:28 PM'
  }, {
    'type': 'sent',
    'message': 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem',
    'sentAt': '3:07:52 PM'
  }, {
    'type': 'sent',
    'message': 'It is a long established fact',
    'sentAt': '3:08:35 PM'
  }, {
    'type': 'received',
    'message': 'I must explain to you how all this mistaken idea of denouncing ',
    'sentAt': '3:10:28 PM'
  }, {
    'type': 'received',
    'message': 'There are many variations of passages of ',
    'sentAt': '3:12:36 PM'
  }, {
    'type': 'received',
    'message': 'All the Lorem Ipsum generators on the',
    'sentAt': '3:12:45 PM'
  }, {
    'type': 'received',
    'message': 'It is a long established fact',
    'sentAt': '3:13:28 PM'
  }, {
    'type': 'sent',
    'message': 'The standard chunk of Lorem Ipsum used since the 1500s',
    'sentAt': '3:15:45 PM'
  }]
}, {
  'id': 9,
  'conversationData': [{
    'type': 'received',
    'message': 'English versions from the 1914 translation by H. Rackham',
    'sentAt': '3:05:47 PM'
  }, {
    'type': 'sent',
    'message': 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem',
    'sentAt': '3:07:52 PM'
  }, {
    'type': 'received',
    'message': 'I must explain to you how all this mistaken idea of denouncing ',
    'sentAt': '3:10:28 PM'
  }, {
    'type': 'received',
    'message': 'There are many variations of passages of ',
    'sentAt': '3:12:36 PM'
  }, {
    'type': 'sent',
    'message': 'There are many variations of passages of ',
    'sentAt': '3:13:04 PM'
  }, {
    'type': 'received',
    'message': 'It is a long established fact',
    'sentAt': '3:13:28 PM'
  }, {
    'type': 'sent',
    'message': 'The standard chunk of Lorem Ipsum used since the 1500s',
    'sentAt': '3:15:45 PM'
  }]
}, {
  'id': 10,
  'conversationData': [{
    'type': 'sent',
    'message': 'English versions from the 1914 translation by H. Rackham',
    'sentAt': '3:03:28 PM'
  }, {
    'type': 'received',
    'message': 'English versions from the 1914 translation by H. Rackham',
    'sentAt': '3:05:47 PM'
  }, {
    'type': 'sent',
    'message': 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem',
    'sentAt': '3:07:52 PM'
  }, {
    'type': 'sent',
    'message': 'It is a long established fact',
    'sentAt': '3:08:35 PM'
  }, {
    'type': 'received',
    'message': 'I must explain to you how all this mistaken idea of denouncing ',
    'sentAt': '3:10:28 PM'
  }, {
    'type': 'sent',
    'message': 'The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested',
    'sentAt': '3:11:25 PM'
  }, {
    'type': 'received',
    'message': 'There are many variations of passages of ',
    'sentAt': '3:12:36 PM'
  }, {
    'type': 'received',
    'message': 'All the Lorem Ipsum generators on the',
    'sentAt': '3:12:45 PM'
  }, {
    'type': 'sent',
    'message': 'There are many variations of passages of ',
    'sentAt': '3:13:04 PM'
  }, {
    'type': 'received',
    'message': 'It is a long established fact',
    'sentAt': '3:13:28 PM'
  }, {
    'type': 'sent',
    'message': 'The standard chunk of Lorem Ipsum used since the 1500s',
    'sentAt': '3:15:45 PM'
  }]
}, {
  'id': 11,
  'conversationData': [{
    'type': 'received',
    'message': 'There are many variations of passages of ',
    'sentAt': '3:12:36 PM'
  }, {
    'type': 'received',
    'message': 'All the Lorem Ipsum generators on the',
    'sentAt': '3:12:45 PM'
  }, {
    'type': 'sent',
    'message': 'There are many variations of passages of ',
    'sentAt': '3:13:04 PM'
  }]
}];
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/chatPanel/data/conversationList.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/chatPanel/data/conversationList.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/chatPanel/data/conversationList.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/chatPanel/data/conversationList.js");
}();

;

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = [{
  'id': '15453ba60d3baa5daaf',
  'from': {
    'name': 'Domnic Harris',
    'avatar': 'http://via.placeholder.com/150x150',
    'email': 'domnicharris@example.com'
  },
  'to': [{
    'name': 'me',
    'email': 'robert.johnson@example.com'
  }, {
    'name': 'me',
    'email': 'robert.johnson@example.com'
  }],
  'subject': 'Fusce a libero pellentesque',
  'message': 'Maecenas sem arcu, scelerisque in odio vel, porttitor dignissim purus. Sed vehicula commodo porta. Etiam nec dictum mauris. Ut imperdiet maximus orci vitae ornare. Nullam et libero sit amet tellus ultricies rutrum et sit amet nisl. Pellentesque condimentum diam sed hendrerit facilisis. Suspendisse bibendum convallis quam, sit amet rutrum nisi pulvinar et. Nunc placerat, diam at scelerisque viverra, mi velit auctor nibh, at rhoncus erat ex vitae felis. Integer sed ante eget est rutrum ultrices ut non ipsum.',
  'read': true,
  'starred': false,
  'important': false,
  'hasAttachments': false,
  'labels': [3, 2],
  'selected': false,
  'folder': 0
}, {
  'id': '15453a06c08fb021776',
  'from': {
    'name': 'Garry Sobars',
    'avatar': 'http://via.placeholder.com/150x150',
    'email': 'danielleobrien@example.com'
  },
  'to': [{
    'name': 'me',
    'email': 'robert.johnson@example.com'
  }],
  'subject': 'Nullam id ex at augue pharetra vestibulum eget id mauris.',
  'message': 'Cras bibendum tortor tortor, eu luctus risus gravida ut. Suspendisse nisi tortor, consequat at pellentesque quis, dapibus vel risus. Praesent aliquam sit amet diam quis luctus. Nulla facilisi. Maecenas id molestie tortor. Nulla eget pretium nulla. Etiam consequat dictum velit, at egestas lacus laoreet ac. Ut facilisis massa vel mi fringilla, non blandit eros dictum. Integer in tellus vitae nisi tincidunt pulvinar. Maecenas ac ante ut felis feugiat ornare id a quam. Quisque feugiat ante quis ornare placerat.',
  'time': '4 Dec',
  'read': true,
  'starred': true,
  'important': false,
  'hasAttachments': false,
  'labels': [1, 3],
  'selected': false,
  'folder': 0
}, {
  'id': '1541ca7af66da284177',
  'from': {
    'name': 'Stella Brown',
    'avatar': '',
    'email': 'stellgrown@example.com'
  },
  'to': [{
    'name': 'me',
    'email': 'robert.johnson@example.com'
  }],
  'subject': 'Vivamus venenatis tempus ipsum, id finibus libero aliquet convallis.',
  'message': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce lorem diam, pulvinar id nisl non, ultrices maximus nibh. Suspendisse ut justo velit. Nullam ac ultrices risus, quis auctor orci. Vestibulum volutpat nisi et neque porta ullamcorper. Maecenas porttitor porta erat ac suscipit. Sed cursus leo ut elementum fringilla. Maecenas semper viverra erat, vel ullamcorper dui efficitur in. Vestibulum placerat imperdiet tellus, et tincidunt eros posuere eget. Proin sit amet facilisis libero. Nulla eget est ut erat aliquet rhoncus. Quisque ac urna vitae dui hendrerit sollicitudin vel id sem.  In eget ante sapien. Quisque consequat velit non ante finibus, vel placerat erat ultricies. Aliquam bibendum justo erat, ultrices vehicula dolor elementum a. Mauris eu nisl feugiat ligula molestie eleifend.\n Aliquam efficitur venenatis velit ac porta. Vivamus vitae pulvinar tellus. Donec odio enim, auctor eget nibh mattis, ultricies dignissim lacus. Phasellus non tincidunt dui. Nulla eu arcu lorem.  Donec non hendrerit augue, lobortis sollicitudin odio. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Duis sit amet euismod enim, eget vestibulum justo. Fusce a placerat lectus, eget feugiat purus. Cras risus ante, faucibus eget justo commodo, volutpat tempor ante. Donec sit amet leo venenatis, gravida quam sit amet, blandit dui. In quam ante, elementum ut faucibus nec, tristique vitae dui.  \n \n Praesent vel erat at enim placerat luctus vel ut ipsum. In congue tempor mi, non ornare lectus condimentum at. Aenean libero diam, finibus eget sapien et, tristique fermentum lorem.  ',
  'time': '3 Dec',
  'read': true,
  'starred': false,
  'important': false,
  'hasAttachments': false,
  'labels': [],
  'selected': false,
  'folder': 0
}, {
  'id': '154297167e781781745',
  'from': {
    'name': 'Steve Jonson',
    'avatar': '',
    'email': 'stevejonson@example.com'
  },
  'to': [{
    'name': 'me',
    'email': 'robert.johnson@example.com'
  }],
  'subject': 'Donec ut ante tristique, gravida justo vitae',
  'message': 'dictum at ligula vitae, posuere sagittis augue. Nam vitae eros quis felis consectetur egestas vitae vitae massa. Vestibulum tincidunt nisi neque, eu ullamcorper risus aliquet vel. Nunc ut lorem dapibus, interdum nulla vel, euismod elit. Fusce a mollis erat, non egestas dui. Fusce eu rutrum orci. Aliquam hendrerit metus sit amet interdum iaculis. Morbi eget nibh ut nibh convallis fermentum vitae ac mauris. Phasellus ligula purus, eleifend vel massa ut, interdum pulvinar sapien. Nullam a ex nec elit condimentum mattis. Nullam sit amet dictum neque, vel sagittis eros. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. ',
  'time': '3 Dec',
  'read': true,
  'starred': false,
  'important': false,
  'hasAttachments': false,
  'labels': [],
  'selected': false,
  'folder': 0
}, {
  'id': '15427f4c1b7f3953234',
  'from': {
    'name': 'Ira Shorter',
    'avatar': '',
    'email': 'irashorter@example.com'
  },
  'to': [{
    'name': 'me',
    'email': 'robert.johnson@example.com'
  }],
  'subject': 'Commits that need to be pushed lorem ipsum dolor sit amet',
  'message': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce lorem diam, pulvinar id nisl non, ultrices maximus nibh. Suspendisse ut justo velit. Nullam ac ultrices risus, quis auctor orci. Vestibulum volutpat nisi et neque porta ullamcorper. Maecenas porttitor porta erat ac suscipit. Sed cursus leo ut elementum fringilla. Maecenas semper viverra erat, vel ullamcorper dui efficitur in. Vestibulum placerat imperdiet tellus, et tincidunt eros posuere eget. Proin sit amet facilisis libero. Nulla eget est ut erat aliquet rhoncus. Quisque ac urna vitae dui hendrerit sollicitudin vel id sem.  In eget ante sapien. Quisque consequat velit non ante finibus, vel placerat erat ultricies. Aliquam bibendum justo erat, ultrices vehicula dolor elementum a. Mauris eu nisl feugiat ligula molestie eleifend.\n Aliquam efficitur venenatis velit ac porta. Vivamus vitae pulvinar tellus. Donec odio enim, auctor eget nibh mattis, ultricies dignissim lacus. Phasellus non tincidunt dui. Nulla eu arcu lorem.  Donec non hendrerit augue, lobortis sollicitudin odio. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Duis sit amet euismod enim, eget vestibulum justo. Fusce a placerat lectus, eget feugiat purus. Cras risus ante, faucibus eget justo commodo, volutpat tempor ante. Donec sit amet leo venenatis, gravida quam sit amet, blandit dui. In quam ante, elementum ut faucibus nec, tristique vitae dui.  \n \n Praesent vel erat at enim placerat luctus vel ut ipsum. In congue tempor mi, non ornare lectus condimentum at. Aenean libero diam, finibus eget sapien et, tristique fermentum lorem.  ',
  'time': '2 Dec',
  'read': true,
  'starred': false,
  'important': false,
  'hasAttachments': false,
  'labels': [],
  'selected': false,
  'folder': 3
}, {
  'id': '15459251a6d6b397565',
  'from': {
    'name': 'Alex Dolgove',
    'avatar': 'http://via.placeholder.com/150x150',
    'email': 'alexdolgove@example.com'
  },
  'to': [{
    'name': 'me',
    'email': 'robert.johnson@example.com'
  }],
  'subject': 'Ut tincidunt massa non elementum fermentum..',
  'message': 'Nullam vel ipsum eget odio viverra pellentesque. Nulla auctor eu felis eget vulputate. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Quisque quam nisi, pulvinar vitae nulla sed, blandit auctor lacus. Vestibulum et semper lorem. Suspendisse interdum est neque, ut tempus eros ultricies et. Proin ultricies elit ac est egestas pharetra. Praesent id mollis enim. Suspendisse quis arcu nec lacus molestie pharetra sit amet in mauris.',
  'time': '2 Dec',
  'read': false,
  'starred': false,
  'important': true,
  'hasAttachments': true,
  'attachments': [{
    'type': 'image',
    'fileName': 'bike',
    'preview': 'http://via.placeholder.com/500x330',
    'url': '',
    'size': '1.1Mb'
  }, {
    'type': 'image',
    'fileName': 'burgers',
    'preview': 'http://via.placeholder.com/500x330',
    'url': '',
    'size': '380kb'
  }, {
    'type': 'image',
    'fileName': 'camera',
    'preview': 'http://via.placeholder.com/600x400',
    'url': 'http://via.placeholder.com/600x400',
    'size': '17Mb'
  }],
  'labels': [1],
  'selected': false,
  'folder': 0
}, {
  'id': '154588a0864d2881124',
  'from': {
    'name': 'Domnic Brown',
    'avatar': 'http://via.placeholder.com/150x150',
    'email': 'domnicbrown@example.com'
  },
  'to': [{
    'name': 'me',
    'email': 'robert.johnson@example.com'
  }],
  'subject': 'Fusce eu rutrum orci. Aliquam hendrerit metus sit amet interdum ',
  'message': 'Phasellus ligula purus, eleifend vel massa ut, interdum pulvinar sapien. Nullam a ex nec elit condimentum mattis. Nullam sit amet dictum neque, vel sagittis eros. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas..',
  'time': '1 Dec',
  'read': false,
  'starred': false,
  'important': false,
  'hasAttachments': false,
  'labels': [],
  'selected': false,
  'folder': 0
}, {
  'id': '154537435d5b32bf11a',
  'from': {
    'name': 'Brian Lara',
    'avatar': '',
    'email': 'brianlara@example.com'
  },
  'to': [{
    'name': 'me',
    'email': 'robert.johnson@example.com'
  }],
  'subject': 'Quisque felis nisi, iaculis at lacinia et.',
  'message': 'Aenean facilisis, lorem eget interdum tristique, velit odio tempus orci, sed molestie felis ipsum dignissim leo. Praesent volutpat convallis molestie. Praesent eu massa gravida, semper lacus id, blandit turpis. Nullam posuere sodales dignissim. Nunc commodo dui sit amet posuere lobortis. Aliquam placerat mi at felis laoreet, non aliquam odio varius. Nulla ultrices leo vel metus finibus, tempor feugiat velit mattis. Donec et commodo nisl, sit amet dignissim mi. Ut ullamcorper lacus sed magna pretium commodo. Sed dictum auctor sem vitae tincidunt. Morbi ut justo sit amet tortor tincidunt aliquet. Aenean at est in lorem pulvinar fermentum.',
  'time': '1 Dec',
  'read': true,
  'starred': false,
  'important': false,
  'hasAttachments': false,
  'labels': [],
  'selected': false,
  'folder': 0
}, {
  'id': '1544e43dcdae6ebf876',
  'from': {
    'name': 'Jeson Born',
    'avatar': 'http://via.placeholder.com/150x150',
    'email': 'jesonborn@example.com'
  },
  'to': [{
    'name': 'me',
    'email': 'robert.johnson@example.com'
  }],
  'subject': 'The standard Lorem Ipsum passage',
  'message': 'On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire, that they cannot foresee the pain and trouble that are bound to ensue; and equal blame belongs to those who fail in their duty through weakness of will, which is the same as saying through shrinking from toil and pain. These cases are perfectly simple and easy to distinguish. In a free hour, when our power of choice is untrammelled and when nothing prevents our being able to do what we like best, every pleasure is to be welcomed and every pain avoided.\n But in certain circumstances and owing to the claims of duty or the obligations of business it will frequently occur that pleasures have to be repudiated and annoyances accepted. The wise man therefore always holds in these matters to this principle of selection: he rejects pleasures to secure other greater pleasures, or else he endures pains to avoid worse painsAt vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. ',
  'time': '30 Nov',
  'read': true,
  'starred': false,
  'important': true,
  'hasAttachments': false,
  'labels': [2],
  'selected': false,
  'folder': 0
}, {
  'id': '1543ee3a5b43e0f9f45',
  'from': {
    'name': 'Domnic White',
    'avatar': '',
    'email': 'domnicwhite@example.com'
  },
  'to': [{
    'name': 'me',
    'email': 'robert.johnson@example.com'
  }],
  'subject': 'Cras bibendum tortor tortor.',
  'message': 'Cras bibendum tortor tortor, eu luctus risus gravida ut. Suspendisse nisi tortor, consequat at pellentesque quis, dapibus vel risus. Praesent aliquam sit amet diam quis luctus. Nulla facilisi. Maecenas id molestie tortor. Nulla eget pretium nulla. Etiam consequat dictum velit, at egestas lacus laoreet ac. Ut facilisis massa vel mi fringilla, non blandit eros dictum. Integer in tellus vitae nisi tincidunt pulvinar. Maecenas ac ante ut felis feugiat ornare id a quam. Quisque feugiat ante quis ornare placerat.',
  'time': '30 Nov',
  'read': true,
  'starred': false,
  'important': false,
  'hasAttachments': false,
  'labels': [],
  'selected': false,
  'folder': 0
}, {
  'id': '1543cc4515df3146112',
  'from': {
    'name': 'Jimmy Jo',
    'avatar': 'http://via.placeholder.com/150x150',
    'email': 'jimmy.jo@example.com'
  },
  'to': [{
    'name': 'me',
    'email': 'robert.johnson@example.com'
  }],
  'subject': 'Contrary to popular belief. ',
  'message': 'ontrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC.\n This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32',
  'time': '29 Nov',
  'read': true,
  'starred': false,
  'important': false,
  'hasAttachments': false,
  'labels': [],
  'selected': false,
  'folder': 0
}, {
  'id': '154398a4770d7aaf9a2',
  'from': {
    'name': 'John Smith',
    'avatar': 'http://via.placeholder.com/150x150',
    'email': 'johnsmith@example.com'
  },
  'to': [{
    'name': 'me',
    'email': 'robert.johnson@example.com'
  }],
  'subject': 'Ut elementum rhoncus nisl.',
  'message': ['Suspendisse congue ipsum tincidunt justo dictum, sit amet finibus lectus egestas. Proin fermentum nec risus vitae accumsan. Vivamus non ligula eu urna mattis feugiat." ,<br/>," Pellentesque ex felis, commodo sed sem a, pharetra semper purus. Curabitur in quam rhoncus, blandit eros tempor, sodales metus. Pellentesque vel luctus ex. Quisque blandit nisl at tincidunt viverra. Phasellus elementum faucibus leo ac molestie.'],
  'time': '1 Dec',
  'read': true,
  'starred': false,
  'important': false,
  'hasAttachments': false,
  'labels': [],
  'selected': false,
  'folder': 0
}, {
  'id': '15438351f87dcd68567',
  'from': {
    'name': 'Jonny Brown',
    'avatar': '',
    'email': 'jonnnybrown@example.com'
  },
  'to': [{
    'name': 'me',
    'email': 'robert.johnson@example.com'
  }],
  'subject': 'Integer nec tempus eros.',
  'message': 'Vestibulum ornare orci hendrerit elit egestas, nec consectetur mi lobortis. Mauris porttitor dolor in neque aliquam, in sollicitudin enim consequat. Fusce pharetra venenatis fermentum.\n \n Maecenas semper nisi quis lectus dictum, vel fermentum purus malesuada. Nunc tincidunt sit amet nunc sit amet eleifend. Sed tellus risus, sagittis id magna in, commodo feugiat risus. Donec commodo pretium dolor non hendrerit. Nullam id leo et quam cursus vestibulum. Ut id aliquet diam, id varius libero. Ut et felis et est eleifend dignissim vitae condimentum ex. Ut a ullamcorper ante, ac laoreet erat. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.',
  'time': '28 Nov',
  'read': true,
  'starred': false,
  'important': false,
  'hasAttachments': false,
  'labels': [],
  'selected': false,
  'folder': 0
}, {
  'id': '1542d75d929a603125',
  'from': {
    'name': 'Rahim Kadir',
    'avatar': '',
    'email': 'rahimkadir@example.com'
  },
  'to': [{
    'name': 'me',
    'email': 'robert.johnson@example.com'
  }],
  'subject': 'Praesent tortor odio, laoreet.',
  'message': 'Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Sed id eros sit amet lorem viverra tincidunt eget id dolor. Morbi egestas bibendum ipsum at efficitur. Suspendisse at mauris justo. Curabitur elementum ante et lacus blandit, quis faucibus lorem pellentesque. Duis et auctor quam, sed lacinia ante. Nam placerat lacus eu mollis lobortis. Sed placerat, ipsum eu vestibulum gravida, magna sapien feugiat felis, non varius leo mauris vitae ligula. Suspendisse tincidunt nec enim eu porttitor.',
  'time': '27 Nov',
  'read': true,
  'starred': false,
  'important': false,
  'hasAttachments': false,
  'labels': [],
  'selected': false,
  'folder': 0
}, {
  'id': '154204e45a59b168453',
  'from': {
    'name': 'Kadir',
    'avatar': 'http://via.placeholder.com/150x150',
    'email': 'kadirm@example.com'
  },
  'to': [{
    'name': 'me',
    'email': 'robert.johnson@example.com'
  }],
  'subject': 'Many desktop publishing packages',
  'message': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce lorem diam, pulvinar id nisl non, ultrices maximus nibh. Suspendisse ut justo velit. Nullam ac ultrices risus, quis auctor orci. Vestibulum volutpat nisi et neque porta ullamcorper. Maecenas porttitor porta erat ac suscipit. Sed cursus leo ut elementum fringilla. Maecenas semper viverra erat, vel ullamcorper dui efficitur in. Vestibulum placerat imperdiet tellus, et tincidunt eros posuere eget. Proin sit amet facilisis libero. Nulla eget est ut erat aliquet rhoncus. Quisque ac urna vitae dui hendrerit sollicitudin vel id sem.  In eget ante sapien. Quisque consequat velit non ante finibus, vel placerat erat ultricies. Aliquam bibendum justo erat, ultrices vehicula dolor elementum a.  \n \n Mauris eu nisl feugiat ligula molestie eleifend. Aliquam efficitur venenatis velit ac porta. Vivamus vitae pulvinar tellus. Donec odio enim, auctor eget nibh mattis, ultricies dignissim lacus.\n Phasellus non tincidunt dui. Nulla eu arcu lorem.  Donec non hendrerit augue, lobortis sollicitudin odio. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Duis sit amet euismod enim, eget vestibulum justo. Fusce a placerat lectus, eget feugiat purus. Cras risus ante, faucibus eget justo commodo, volutpat tempor ante. Donec sit amet leo venenatis, gravida quam sit amet, blandit dui. In quam ante, elementum ut faucibus nec, tristique vitae dui. Praesent vel erat at enim placerat luctus vel ut ipsum. \n \n In congue tempor mi, non ornare lectus condimentum at. Aenean libero diam, finibus eget sapien et, tristique fermentum lorem.  ',
  'time': '26 Nov',
  'read': true,
  'starred': false,
  'important': false,
  'hasAttachments': false,
  'labels': [],
  'selected': false,
  'folder': 3
}, {
  'id': '1541dd1e05dfc439216',
  'from': {
    'name': 'Stella Johnson',
    'avatar': 'http://via.placeholder.com/150x150',
    'email': 'stella-johnson@example.com'
  },
  'to': [{
    'name': 'me',
    'email': 'robert.johnson@example.com'
  }],
  'subject': 'Section 1.10.32 of "de',
  'message': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce lorem diam, pulvinar id nisl non, ultrices maximus nibh. Suspendisse ut justo velit. Nullam ac ultrices risus, quis auctor orci. Vestibulum volutpat nisi et neque porta ullamcorper. Maecenas porttitor porta erat ac suscipit. Sed cursus leo ut elementum fringilla. \n \n Maecenas semper viverra erat, vel ullamcorper dui efficitur in. Vestibulum placerat imperdiet tellus, et tincidunt eros posuere eget. Proin sit amet facilisis libero. Nulla eget est ut erat aliquet rhoncus. Quisque ac urna vitae dui hendrerit sollicitudin vel id sem.  In eget ante sapien. Quisque consequat velit non ante finibus, vel placerat erat ultricies. Aliquam bibendum justo erat, ultrices vehicula dolor elementum a. Mauris eu nisl feugiat ligula molestie eleifend. Aliquam efficitur venenatis velit ac porta. Vivamus vitae pulvinar tellus. Donec odio enim, auctor eget nibh mattis, ultricies dignissim lacus.\n Phasellus non tincidunt dui. Nulla eu arcu lorem.  Donec non hendrerit augue, lobortis sollicitudin odio. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Duis sit amet euismod enim, eget vestibulum justo. Fusce a placerat lectus, eget feugiat purus. Cras risus ante, faucibus eget justo commodo, volutpat tempor ante. Donec sit amet leo venenatis, gravida quam sit amet, blandit dui. In quam ante, elementum ut faucibus nec, tristique vitae dui. Praesent vel erat at enim placerat luctus vel ut ipsum. In congue tempor mi, non ornare lectus condimentum at. Aenean libero diam, finibus eget sapien et, tristique fermentum lorem.  ',
  'time': '25 Nov',
  'read': true,
  'starred': false,
  'important': false,
  'hasAttachments': false,
  'labels': [],
  'selected': false,
  'folder': 3
}, {
  'id': '1541dd1e05dfc439217',
  'from': {
    'name': 'Steve Smith',
    'avatar': 'http://via.placeholder.com/150x150',
    'email': 'stevesmith@example.com'
  },
  'to': [{
    'name': 'me',
    'email': 'robert.johnson@example.com'
  }],
  'subject': 'Integer nec tempus eros.',
  'message': 'Curabitur id rutrum ex. Morbi tempus libero eget mauris ultricies venenatis. Curabitur eget pellentesque lorem. Morbi in tempor sem, vel posuere odio. Vivamus sit amet efficitur tortor. Fusce in tortor non lorem blandit eleifend quis eu risus. Donec lobortis ex justo, sed suscipit dolor posuere eget.',
  'time': '24 Nov',
  'read': true,
  'starred': false,
  'important': false,
  'hasAttachments': false,
  'labels': [],
  'selected': false,
  'folder': 3
}];
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/mail/data/mails.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/mail/data/mails.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/mail/data/mails.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/mail/data/mails.js");
}();

;

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = [{
  'id': '561551bd7fe2ff461101c192',
  'conversationData': [{
    'name': 'Alex Dolgove',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'It is a long established fact',
    'sentAt': 'Nov 22, 2017, 3:08:35 PM'
  }, {
    'name': 'Domnic Brown',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'I must explain to you how all this mistaken idea of denouncing ',
    'sentAt': 'Nov 22, 2017, 3:10:28 PM'
  }, {
    'name': 'John Smith',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested',
    'sentAt': 'Nov 22, 2017, 3:11:25 PM'
  }, {
    'name': 'Steve Smith',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'There are many variations of passages of ',
    'sentAt': 'Nov 22, 2017, 3:12:36 PM'
  }, {
    'name': 'Kadir',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'All the Lorem Ipsum generators on the',
    'sentAt': 'Nov 22, 2017, 3:12:45 PM'
  }, {
    'name': 'Jimmy Jo',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'There are many variations of passages of ',
    'sentAt': 'Nov 22, 2017, 3:13:04 PM'
  }, {
    'name': 'Jeson Born',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'It is a long established fact',
    'sentAt': 'Nov 22, 2017, 3:13:28 PM'
  }, {
    'name': 'Stella Johnson',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'The standard chunk of Lorem Ipsum used since the 1500s',
    'sentAt': 'Nov 22, 2017, 3:15:45 PM'
  }]
}, {
  'id': '561551bd4ac1e7eb77a3a750',
  'conversationData': [{
    'name': 'Alex Dolgove',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'English versions from the 1914 translation by H. Rackham',
    'sentAt': 'Nov 22, 2017, 3:03:28 PM'
  }, {
    'name': 'Domnic Brown',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'English versions from the 1914 translation by H. Rackham',
    'sentAt': 'Nov 22, 2017, 3:05:47 PM'
  }, {
    'name': 'John Smith',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem',
    'sentAt': 'Nov 22, 2017, 3:07:52 PM'
  }, {
    'name': 'Steve Smith',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'There are many variations of passages of ',
    'sentAt': 'Nov 22, 2017, 3:12:36 PM'
  }, {
    'name': 'Kadir',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'All the Lorem Ipsum generators on the',
    'sentAt': 'Nov 22, 2017, 3:12:45 PM'
  }, {
    'name': 'Jimmy Jo',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'There are many variations of passages of ',
    'sentAt': 'Nov 22, 2017, 3:13:04 PM'
  }]
}, {
  'id': '561551bdeeb2fd6877e18c29',
  'conversationData': [{
    'name': 'Jeson Born',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'It is a long established fact',
    'sentAt': 'Nov 22, 2017, 3:08:35 PM'
  }, {
    'name': 'Stella Johnson',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'I must explain to you how all this mistaken idea of denouncing ',
    'sentAt': 'Nov 22, 2017, 3:10:28 PM'
  }, {
    'name': 'Alex Dolgove',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested',
    'sentAt': 'Nov 22, 2017, 3:11:25 PM'
  }, {
    'name': 'Domnic Brown',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'There are many variations of passages of ',
    'sentAt': 'Nov 22, 2017, 3:12:36 PM'
  }, {
    'name': 'John Smith',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'All the Lorem Ipsum generators on the',
    'sentAt': 'Nov 22, 2017, 3:12:45 PM'
  }, {
    'name': 'Steve Smith',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'There are many variations of passages of ',
    'sentAt': 'Nov 22, 2017, 3:13:04 PM'
  }, {
    'name': 'Kadir',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'It is a long established fact',
    'sentAt': 'Nov 22, 2017, 3:13:28 PM'
  }]
}, {
  'id': '561551bdf38eae0134ae43d4',
  'conversationData': [{
    'name': 'Jimmy Jo',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'English versions from the 1914 translation by H. Rackham',
    'sentAt': 'Nov 22, 2017, 3:03:28 PM'
  }, {
    'name': 'Jeson Born',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'English versions from the 1914 translation by H. Rackham',
    'sentAt': 'Nov 22, 2017, 3:05:47 PM'
  }, {
    'name': 'Stella Johnson',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested',
    'sentAt': 'Nov 22, 2017, 3:11:25 PM'
  }, {
    'name': 'Alex Dolgove',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'There are many variations of passages of ',
    'sentAt': 'Nov 22, 2017, 3:12:36 PM'
  }, {
    'name': 'Domnic Brown',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'All the Lorem Ipsum generators on the',
    'sentAt': 'Nov 22, 2017, 3:12:45 PM'
  }, {
    'name': 'John Smith',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'There are many variations of passages of ',
    'sentAt': 'Nov 22, 2017, 3:13:04 PM'
  }, {
    'name': 'Steve Smith',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'It is a long established fact',
    'sentAt': 'Nov 22, 2017, 3:13:28 PM'
  }, {
    'name': 'Kadir',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'The standard chunk of Lorem Ipsum used since the 1500s',
    'sentAt': 'Nov 22, 2017, 3:15:45 PM'
  }]
}, {
  'id': '561551bd32f1588c814a0ccd',
  'conversationData': [{
    'name': 'Jimmy Jo',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem',
    'sentAt': 'Nov 22, 2017, 3:07:52 PM'
  }, {
    'name': 'Stella Johnson',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'It is a long established fact',
    'sentAt': 'Nov 22, 2017, 3:08:35 PM'
  }, {
    'name': 'Jeson Born',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'I must explain to you how all this mistaken idea of denouncing ',
    'sentAt': 'Nov 22, 2017, 3:10:28 PM'
  }, {
    'name': 'Alex Dolgove',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested',
    'sentAt': 'Nov 22, 2017, 3:11:25 PM'
  }, {
    'name': 'Domnic Brown',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'There are many variations of passages of ',
    'sentAt': 'Nov 22, 2017, 3:12:36 PM'
  }, {
    'name': 'John Smith',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'It is a long established fact',
    'sentAt': 'Nov 22, 2017, 3:13:28 PM'
  }, {
    'name': 'Steve Smith',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'The standard chunk of Lorem Ipsum used since the 1500s',
    'sentAt': 'Nov 22, 2017, 3:15:45 PM'
  }]
}, {
  'id': '561551bd0bb4b08ca77038ef',
  'conversationData': [{
    'name': 'Stella Johnson',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'It is a long established fact',
    'sentAt': 'Nov 22, 2017, 3:08:35 PM'
  }, {
    'message': 'I must explain to you how all this mistaken idea of denouncing ',
    'sentAt': 'Nov 22, 2017, 3:10:28 PM'
  }, {
    'name': 'Jeson Born',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested',
    'sentAt': 'Nov 22, 2017, 3:11:25 PM'
  }, {
    'message': 'There are many variations of passages of ',
    'sentAt': 'Nov 22, 2017, 3:12:36 PM'
  }, {
    'name': 'Jimmy Jo',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'It is a long established fact',
    'sentAt': 'Nov 22, 2017, 3:13:28 PM'
  }, {
    'name': 'Kadir',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'The standard chunk of Lorem Ipsum used since the 1500s',
    'sentAt': 'Nov 22, 2017, 3:15:45 PM'
  }]
}, {
  'id': '561551bdf84eec913835ebe5',
  'conversationData': [{
    'name': 'Steve Smith',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'English versions from the 1914 translation by H. Rackham',
    'sentAt': 'Nov 22, 2017, 3:05:47 PM'
  }, {
    'name': 'John Smith',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem',
    'sentAt': 'Nov 22, 2017, 3:07:52 PM'
  }, {
    'name': 'Domnic Brown',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'It is a long established fact',
    'sentAt': 'Nov 22, 2017, 3:08:35 PM'
  }, {
    'name': 'John Smith',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'There are many variations of passages of ',
    'sentAt': 'Nov 22, 2017, 3:12:36 PM'
  }, {
    'name': 'Steve Smith',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'All the Lorem Ipsum generators on the',
    'sentAt': 'Nov 22, 2017, 3:12:45 PM'
  }, {
    'name': 'Kadir',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'There are many variations of passages of ',
    'sentAt': 'Nov 22, 2017, 3:13:04 PM'
  }, {
    'name': 'Jimmy Jo',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'It is a long established fact',
    'sentAt': 'Nov 22, 2017, 3:13:28 PM'
  }]
}, {
  'id': '561551bd2047cc709af0f670',
  'conversationData': [{
    'name': 'Stella Johnson',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'English versions from the 1914 translation by H. Rackham',
    'sentAt': 'Nov 22, 2017, 3:03:28 PM'
  }, {
    'name': 'Jeson Born',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem',
    'sentAt': 'Nov 22, 2017, 3:07:52 PM'
  }, {
    'name': 'Jimmy Jo',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'It is a long established fact',
    'sentAt': 'Nov 22, 2017, 3:08:35 PM'
  }, {
    'name': 'Kadir',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'I must explain to you how all this mistaken idea of denouncing ',
    'sentAt': 'Nov 22, 2017, 3:10:28 PM'
  }, {
    'name': 'Steve Smith',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'There are many variations of passages of ',
    'sentAt': 'Nov 22, 2017, 3:12:36 PM'
  }, {
    'name': 'John Smith',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'All the Lorem Ipsum generators on the',
    'sentAt': 'Nov 22, 2017, 3:12:45 PM'
  }, {
    'name': 'Domnic Brown',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'It is a long established fact',
    'sentAt': 'Nov 22, 2017, 3:13:28 PM'
  }, {
    'name': 'Alex Dolgove',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'The standard chunk of Lorem Ipsum used since the 1500s',
    'sentAt': 'Nov 22, 2017, 3:15:45 PM'
  }]
}, {
  'id': '561551bd8f7d793ded0a2353',
  'conversationData': [{
    'name': 'Stella Johnson',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'English versions from the 1914 translation by H. Rackham',
    'sentAt': 'Nov 22, 2017, 3:05:47 PM'
  }, {
    'name': 'Jeson Born',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem',
    'sentAt': 'Nov 22, 2017, 3:07:52 PM'
  }, {
    'name': 'Jimmy Jo',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'I must explain to you how all this mistaken idea of denouncing ',
    'sentAt': 'Nov 22, 2017, 3:10:28 PM'
  }, {
    'name': 'Kadir',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'There are many variations of passages of ',
    'sentAt': 'Nov 22, 2017, 3:12:36 PM'
  }, {
    'name': 'Steve Smith',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'There are many variations of passages of ',
    'sentAt': 'Nov 22, 2017, 3:13:04 PM'
  }, {
    'name': 'John Smith',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'It is a long established fact',
    'sentAt': 'Nov 22, 2017, 3:13:28 PM'
  }, {
    'name': 'Domnic Brown',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'The standard chunk of Lorem Ipsum used since the 1500s',
    'sentAt': 'Nov 22, 2017, 3:15:45 PM'
  }]
}, {
  'id': '561551bdaa586f72d0be02cc',
  'conversationData': [{
    'name': 'Stella Johnson',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'English versions from the 1914 translation by H. Rackham',
    'sentAt': 'Nov 22, 2017, 3:03:28 PM'
  }, {
    'name': 'Jeson Born',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'English versions from the 1914 translation by H. Rackham',
    'sentAt': 'Nov 22, 2017, 3:05:47 PM'
  }, {
    'name': 'Jimmy Jo',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem',
    'sentAt': 'Nov 22, 2017, 3:07:52 PM'
  }, {
    'name': 'Kadir',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'It is a long established fact',
    'sentAt': 'Nov 22, 2017, 3:08:35 PM'
  }, {
    'name': 'Steve Smith',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'I must explain to you how all this mistaken idea of denouncing ',
    'sentAt': 'Nov 22, 2017, 3:10:28 PM'
  }, {
    'name': 'John Smith',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested',
    'sentAt': 'Nov 22, 2017, 3:11:25 PM'
  }, {
    'name': 'Domnic Brown',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'There are many variations of passages of ',
    'sentAt': 'Nov 22, 2017, 3:12:36 PM'
  }, {
    'name': 'Alex Dolgove',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'All the Lorem Ipsum generators on the',
    'sentAt': 'Nov 22, 2017, 3:12:45 PM'
  }, {
    'name': 'Stella Johnson',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'There are many variations of passages of ',
    'sentAt': 'Nov 22, 2017, 3:13:04 PM'
  }, {
    'name': 'Jeson Born',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'It is a long established fact',
    'sentAt': 'Nov 22, 2017, 3:13:28 PM'
  }, {
    'name': 'Jimmy Jo',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'The standard chunk of Lorem Ipsum used since the 1500s',
    'sentAt': 'Nov 22, 2017, 3:15:45 PM'
  }]
}, {
  'id': '561551bd9f1c2de5b27f537b',
  'conversationData': [{
    'name': 'Stella Johnson',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'There are many variations of passages of ',
    'sentAt': 'Nov 22, 2017, 3:12:36 PM'
  }, {
    'name': 'Jeson Born',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'All the Lorem Ipsum generators on the',
    'sentAt': 'Nov 22, 2017, 3:12:45 PM'
  }, {
    'name': 'Steve Smith',
    'thumb': 'http://via.placeholder.com/150x150',
    'message': 'There are many variations of passages of ',
    'sentAt': 'Nov 22, 2017, 3:13:04 PM'
  }]
}];
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/todo/data/todoConversation.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/todo/data/todoConversation.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/todo/data/todoConversation.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/todo/data/todoConversation.js");
}();

;

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = [{
  'id': '561551bd7fe2ff461101c192',
  'user': 1,
  'title': 'Proident tempor est nulla irure ad est',
  'notes': 'Id nulla nulla proident deserunt deserunt proident in quis. Cillum reprehenderit labore id anim laborum.',
  'startDate': 'Wednesday, January 29, 2014 3:17 PM',
  'dueDate': null,
  'completed': false,
  'starred': false,
  'important': false,
  'selected': false,
  'deleted': false,
  'labels': [1]
}, {
  'id': '561551bd4ac1e7eb77a3a750',
  'user': 0,
  'title': 'Magna quis irure quis ea pariatur laborum',
  'notes': '',
  'startDate': 'Sunday, February 1, 2015 1:30 PM',
  'dueDate': 'Friday, December 30, 2016 10:07 AM',
  'completed': false,
  'starred': false,
  'important': true,
  'selected': false,
  'deleted': false,
  'labels': [1, 4]
}, {
  'id': '561551bd917bfec2ddef2d49',
  'user': 2,
  'title': 'Ullamco duis commodo sint ad aliqua aute',
  'notes': 'Sunt laborum enim nostrud ea fugiat cillum mollit aliqua exercitation ad elit.',
  'startDate': 'Friday, April 11, 2014 3:43 AM',
  'dueDate': 'Wednesday, July 26, 2017 11:14 AM',
  'completed': false,
  'starred': true,
  'important': true,
  'selected': false,
  'deleted': false,
  'labels': [3]
}, {
  'id': '51551bdeeb2fd6877e18c29',
  'user': 3,
  'title': 'Eiusmod non occaecat pariatur Lorem in ex',
  'notes': 'Nostrud anim mollit incididunt qui qui sit commodo duis. Anim amet irure aliquip duis nostrud sit quis fugiat ullamco non dolor labore. Lorem sunt voluptate laboris culpa proident. Aute eiusmod aliqua exercitation irure exercitation qui laboris mollit occaecat eu occaecat fugiat.',
  'startDate': 'Wednesday, May 7, 2014 4:14 AM',
  'dueDate': 'Friday, December 15, 2017 4:01 AM',
  'completed': true,
  'starred': true,
  'important': false,
  'selected': false,
  'deleted': false,
  'labels': [2]
}, {
  'id': '561551bdf38eae0134ae43d4',
  'user': 2,
  'title': 'Lorem magna cillum consequat consequat mollit',
  'notes': 'Velit ipsum proident ea incididunt et. Consectetur eiusmod laborum voluptate duis occaecat ullamco sint enim proident.',
  'startDate': 'Sunday, August 23, 2015 11:19 PM',
  'dueDate': 'Friday, July 8, 2016 10:49 AM',
  'completed': false,
  'starred': false,
  'important': false,
  'selected': false,
  'deleted': false,
  'labels': [5, 4]
}, {
  'id': '561551bd32f1588c814a0ccd',
  'user': 4,
  'title': 'Quis irure cupidatat ad consequat reprehenderit excepteur',
  'notes': 'Esse nisi mollit aliquip mollit aute consequat adipisicing. Do excepteur dolore proident cupidatat pariatur irure consequat incididunt.',
  'startDate': 'Sunday, June 7, 2015 10:49 AM',
  'dueDate': 'Monday, January 9, 2017 8:34 AM',
  'completed': false,
  'starred': true,
  'important': false,
  'selected': false,
  'deleted': false,
  'labels': [2, 3]
}, {
  'id': '561551bd0bb4b08ca77038ef',
  'user': 5,
  'title': 'Officia voluptate tempor ut mollit ea cillum',
  'notes': 'Deserunt veniam reprehenderit do elit magna ut.',
  'startDate': 'Saturday, October 18, 2014 4:25 AM',
  'dueDate': 'Sunday, August 21, 2016 10:48 PM',
  'completed': true,
  'starred': false,
  'important': false,
  'selected': false,
  'deleted': false,
  'labels': [2, 4]
}, {
  'id': '561551bdf84eec913835ebe5',
  'user': 2,
  'title': 'Sit exercitation cupidatat minim est ipsum excepteur',
  'notes': '',
  'startDate': 'Friday, August 8, 2014 5:45 AM',
  'dueDate': 'Wednesday, June 15, 2016 1:53 PM',
  'completed': true,
  'starred': false,
  'important': true,
  'selected': false,
  'deleted': false,
  'labels': [1, 3]
}, {
  'id': '561551bd2047cc709af0f670',
  'user': 3,
  'title': 'Sunt fugiat officia nisi minim sunt duis',
  'notes': 'Eiusmod eiusmod sint aliquip exercitation cillum. Magna nulla officia ex consectetur ea ad excepteur in qui.',
  'startDate': 'Monday, July 13, 2015 1:55 PM',
  'dueDate': 'Thursday, March 3, 2016 2:26 PM',
  'completed': false,
  'starred': false,
  'important': false,
  'selected': false,
  'deleted': false,
  'labels': [{
    'id': 5,
    'assignTo': 'mobile',
    'label': 'Mobile',
    'color': '#9C27B0'
  }]
}, {
  'id': '561551bd73d1a627e97005ce',
  'user': 4,
  'title': 'Non cupidatat enim quis aliquip minim laborum',
  'notes': 'Qui cillum eiusmod nostrud sunt dolore velit nostrud labore voluptate ad dolore. Eu Lorem anim pariatur aliqua. Ullamco ut dolor velit esse occaecat dolore eu cillum commodo qui. Nulla dolor consequat voluptate magna ut commodo magna consectetur non aute proident.',
  'startDate': 'Tuesday, November 11, 2014 6:36 PM',
  'dueDate': 'Tuesday, August 9, 2016 7:18 AM',
  'completed': false,
  'starred': false,
  'important': false,
  'selected': false,
  'deleted': false,
  'labels': [2]
}, {
  'id': '561551bd8f7d793ded0a2353',
  'user': 2,
  'title': 'Dolor ex occaecat magna labore laboris qui',
  'notes': 'Incididunt qui excepteur eiusmod elit cillum occaecat voluptate cillum nostrud. Dolor ullamco ullamco eiusmod do sunt adipisicing pariatur. In esse esse labore id reprehenderit sint do. Pariatur culpa dolor tempor qui excepteur duis do anim minim ipsum.',
  'startDate': 'Monday, June 9, 2014 3:15 PM',
  'dueDate': 'Wednesday, October 19, 2016 3:38 PM',
  'completed': false,
  'starred': false,
  'important': true,
  'selected': false,
  'deleted': false,
  'labels': [3]
}, {
  'id': '561551bdaa586f72d0be02cc',
  'user': 1,
  'title': 'Ex nisi amet id dolore nostrud esse',
  'notes': '',
  'startDate': 'Thursday, January 15, 2015 6:11 PM',
  'dueDate': 'Sunday, August 20, 2017 10:02 AM',
  'completed': false,
  'starred': true,
  'important': true,
  'selected': false,
  'deleted': false,
  'labels': [4]
}, {
  'id': '561551bd9f1c2de5b27f537b',
  'user': 4,
  'title': 'In dolor velit labore dolore ex eiusmod',
  'notes': '',
  'startDate': 'Monday, March 10, 2014 12:50 AM',
  'dueDate': 'Thursday, January 26, 2017 3:10 PM',
  'completed': false,
  'starred': false,
  'important': false,
  'selected': false,
  'deleted': false,
  'labels': [4]
}, {
  'id': '561551bd26e21bb5e85b35cb',
  'user': 1,
  'title': 'Sunt voluptate aliquip exercitation minim magna sit',
  'notes': '',
  'startDate': 'Tuesday, March 24, 2015 10:54 PM',
  'dueDate': 'Wednesday, August 23, 2017 5:35 PM',
  'completed': false,
  'starred': false,
  'important': false,
  'selected': false,
  'deleted': false,
  'labels': [4]
}, {
  'id': '561551bd719860cf0ad2011a',
  'user': 5,
  'title': 'Nisi et ullamco minim ea proident tempor',
  'notes': 'Dolor veniam dolor cillum Lorem magna nisi in occaecat nulla dolor ea eiusmod.',
  'startDate': 'Friday, February 14, 2014 10:03 AM',
  'dueDate': 'Saturday, July 8, 2017 11:54 PM',
  'completed': false,
  'starred': true,
  'important': false,
  'selected': false,
  'deleted': false,
  'labels': [2, 4]
}, {
  'id': '561551bd49d800c243264a91',
  'user': 3,
  'title': 'Sit ipsum mollit cupidatat adipisicing officia aliquip',
  'notes': '',
  'startDate': 'Wednesday, December 10, 2014 9:25 AM',
  'dueDate': 'Friday, March 25, 2016 12:29 AM',
  'completed': true,
  'starred': false,
  'important': false,
  'selected': false,
  'deleted': false,
  'labels': [1]
}, {
  'id': '561551bd061990eaf40fb64f',
  'user': 1,
  'title': 'Amet sunt et quis amet commodo quis',
  'notes': 'Nulla dolore consequat aliqua sint consequat elit qui occaecat et.',
  'startDate': 'Saturday, March 1, 2014 3:59 PM',
  'dueDate': 'Saturday, November 7, 2015 2:00 PM',
  'completed': false,
  'starred': false,
  'important': true,
  'selected': false,
  'deleted': false,
  'labels': [1]
}, {
  'id': '561551be81d05fa94711e7f3',
  'user': 2,
  'title': 'Ut eiusmod ex ea eiusmod culpa incididunt',
  'notes': 'Fugiat non incididunt officia ex incididunt occaecat. Voluptate nostrud culpa aliquip mollit incididunt non dolore.',
  'startDate': 'Monday, February 2, 2015 3:07 PM',
  'dueDate': 'Saturday, October 14, 2017 6:57 AM',
  'completed': false,
  'starred': false,
  'important': false,
  'selected': false,
  'deleted': false,
  'labels': [2]
}, {
  'id': '561551be05c093a80e0c8d05',
  'user': 3,
  'title': 'Proident reprehenderit laboris pariatur ut et nisi',
  'notes': 'Reprehenderit proident ut ad cillum quis velit quis aliqua ut aliquip tempor ullamco.',
  'startDate': 'Sunday, June 14, 2015 4:40 AM',
  'dueDate': 'Wednesday, February 10, 2016 10:47 AM',
  'completed': true,
  'starred': true,
  'important': true,
  'selected': false,
  'deleted': false,
  'labels': [5]
}, {
  'id': '561551be3bb43a5bd431c2fc',
  'user': 4,
  'title': 'Aliqua aliquip aliquip aliquip et exercitation aute',
  'notes': 'Adipisicing Lorem tempor ex anim. Labore tempor laboris nostrud dolore voluptate ullamco. Fugiat ex deserunt anim minim esse velit laboris aute ea duis incididunt. Elit irure id Lorem incididunt laborum aliquip consectetur est irure sunt. Ut labore anim nisi aliqua tempor laborum nulla cillum. Duis irure consequat cillum magna cillum eiusmod ut. Et exercitation voluptate quis deserunt elit quis dolor deserunt ex ex esse ex.',
  'startDate': 'Saturday, May 3, 2014 1:32 AM',
  'dueDate': 'Monday, September 12, 2016 9:16 PM',
  'completed': true,
  'starred': false,
  'important': true,
  'selected': false,
  'deleted': true,
  'labels': [3]
}];
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/todo/data/todo.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/todo/data/todo.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/todo/data/todo.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/todo/data/todo.js");
}();

;

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(349);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(1168),
    hasPath = __webpack_require__(848);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(640),
    baseIteratee = __webpack_require__(67),
    toInteger = __webpack_require__(843);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(1174);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// rawAsap provides everything we need except exception management.
var rawAsap = __webpack_require__(656);
// RawTasks are recycled to reduce GC churn.
var freeTasks = [];
// We queue errors to ensure they are thrown in right order (FIFO).
// Array-as-queue is good enough here, since we are just dealing with exceptions.
var pendingErrors = [];
var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);

function throwFirstError() {
    if (pendingErrors.length) {
        throw pendingErrors.shift();
    }
}

/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */
module.exports = asap;
function asap(task) {
    var rawTask;
    if (freeTasks.length) {
        rawTask = freeTasks.pop();
    } else {
        rawTask = new RawTask();
    }
    rawTask.task = task;
    rawAsap(rawTask);
}

// We wrap tasks with recyclable task objects.  A task object implements
// `call`, just like a function.
function RawTask() {
    this.task = null;
}

// The sole purpose of wrapping the task is to catch the exception and recycle
// the task object after its single use.
RawTask.prototype.call = function () {
    try {
        this.task.call();
    } catch (error) {
        if (asap.onerror) {
            // This hook exists purely for testing purposes.
            // Its name will be periodically randomized to break any code that
            // depends on its existence.
            asap.onerror(error);
        } else {
            // In a web browser, exceptions are not fatal. However, to avoid
            // slowing down the queue of pending tasks, we rethrow the error in a
            // lower priority turn.
            pendingErrors.push(error);
            requestErrorThrow();
        }
    } finally {
        this.task = null;
        freeTasks[freeTasks.length] = this;
    }
};


/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.0
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["default"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(57)))

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(160),
    baseIntersection = __webpack_require__(1581),
    baseRest = __webpack_require__(424),
    castArrayLikeObject = __webpack_require__(1582);

/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = baseRest(function(arrays) {
  var mapped = arrayMap(arrays, castArrayLikeObject);
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped)
    : [];
});

module.exports = intersection;


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__(630),
    baseIteratee = __webpack_require__(67),
    baseSome = __webpack_require__(1687),
    isArray = __webpack_require__(26),
    isIterateeCall = __webpack_require__(231);

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = some;


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(317),
    baseForOwn = __webpack_require__(435),
    baseIteratee = __webpack_require__(67);

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(310),
    arrayEach = __webpack_require__(837),
    assignValue = __webpack_require__(429),
    baseAssign = __webpack_require__(1697),
    baseAssignIn = __webpack_require__(1698),
    cloneBuffer = __webpack_require__(875),
    copyArray = __webpack_require__(839),
    copySymbols = __webpack_require__(1701),
    copySymbolsIn = __webpack_require__(1702),
    getAllKeys = __webpack_require__(632),
    getAllKeysIn = __webpack_require__(787),
    getTag = __webpack_require__(256),
    initCloneArray = __webpack_require__(1703),
    initCloneByTag = __webpack_require__(1704),
    initCloneObject = __webpack_require__(877),
    isArray = __webpack_require__(26),
    isBuffer = __webpack_require__(307),
    isMap = __webpack_require__(1708),
    isObject = __webpack_require__(58),
    isSet = __webpack_require__(1710),
    keys = __webpack_require__(159);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(78);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(209)(module)))

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(417);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(834),
    getPrototype = __webpack_require__(316),
    isPrototype = __webpack_require__(305);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(1715),
    overRest = __webpack_require__(643),
    setToString = __webpack_require__(431);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _recharts = __webpack_require__(108);

var _data = __webpack_require__(850);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var SalesStatistic = function SalesStatistic() {
  return _react["default"].createElement("div", {
    className: "jr-card"
  }, _react["default"].createElement("div", {
    className: "jr-card-header d-flex align-items-center"
  }, _react["default"].createElement("h3", {
    className: "mb-0"
  }, "Sales Statistic")), _react["default"].createElement("div", {
    className: "row mb-3"
  }, _react["default"].createElement("div", {
    className: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, _react["default"].createElement("span", {
    className: "d-flex align-items-center mb-2"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-calendar-check text-muted chart-f20"
  }), _react["default"].createElement("span", {
    className: "ml-3 text-dark"
  }, "48548")), _react["default"].createElement("p", {
    className: "text-muted"
  }, "Orders Monthly")), _react["default"].createElement("div", {
    className: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, _react["default"].createElement("span", {
    className: "d-flex align-items-center mb-2"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-calendar-note text-muted chart-f20"
  }), _react["default"].createElement("span", {
    className: "ml-3 text-dark"
  }, "6,875")), _react["default"].createElement("p", {
    className: "text-muted"
  }, "Orders Weekly")), _react["default"].createElement("div", {
    className: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, _react["default"].createElement("span", {
    className: "d-flex align-items-center mb-2"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-money-box text-muted chart-f20"
  }), _react["default"].createElement("span", {
    className: "ml-3 text-dark"
  }, "$210,213")), _react["default"].createElement("p", {
    className: "text-muted"
  }, "Average Revenue")), _react["default"].createElement("div", {
    className: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, _react["default"].createElement("span", {
    className: "d-flex align-items-center mb-2"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-money-box text-muted chart-f20"
  }), _react["default"].createElement("span", {
    className: "ml-3 text-dark"
  }, "$692,874")), _react["default"].createElement("p", {
    className: "text-muted"
  }, "Total Revenue")), _react["default"].createElement("div", {
    className: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, _react["default"].createElement("span", {
    className: "d-flex align-items-center mb-2"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-calendar text-muted chart-f20"
  }), _react["default"].createElement("span", {
    className: "ml-3 text-dark"
  }, "9,223")), _react["default"].createElement("p", {
    className: "text-muted"
  }, "Total Orders")), _react["default"].createElement("div", {
    className: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, _react["default"].createElement("span", {
    className: "d-flex align-items-center mb-2"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-calendar-alt text-muted chart-f20"
  }), _react["default"].createElement("span", {
    className: "ml-3 text-dark"
  }, "8,543")), _react["default"].createElement("p", {
    className: "text-muted"
  }, "Past Orders"))), _react["default"].createElement("div", {
    className: "row"
  }, _react["default"].createElement("div", {
    className: "col-lg-6 col-12 mb-5 mb-lg-1"
  }, _react["default"].createElement(_recharts.ResponsiveContainer, {
    width: "100%",
    height: 350
  }, _react["default"].createElement(_recharts.LineChart, {
    data: _data.lineChartData,
    margin: {
      top: 0,
      right: 0,
      left: 0,
      bottom: 0
    }
  }, _react["default"].createElement(_recharts.XAxis, {
    dataKey: "name"
  }), _react["default"].createElement(_recharts.YAxis, null), _react["default"].createElement(_recharts.CartesianGrid, {
    strokeDasharray: "3 3"
  }), _react["default"].createElement(_recharts.Tooltip, null), _react["default"].createElement(_recharts.Line, {
    type: "monotone",
    dataKey: "amt",
    stackId: "1",
    stroke: "#59AA2B",
    fill: "#59AA2B"
  })))), _react["default"].createElement("div", {
    className: "col-lg-6 col-12"
  }, _react["default"].createElement(_recharts.ResponsiveContainer, {
    width: "100%",
    height: 350
  }, _react["default"].createElement(_recharts.RadialBarChart, {
    innerRadius: 20,
    outerRadius: 120,
    barSize: 10,
    data: _data.radialData
  }, _react["default"].createElement(_recharts.RadialBar, {
    minAngle: 15,
    label: true,
    background: true,
    clockWise: true,
    dataKey: "data"
  }), _react["default"].createElement(_recharts.Legend, {
    iconSize: 10,
    width: 120,
    height: 140,
    layout: "vertical",
    verticalAlign: "top",
    wrapperStyle: {
      top: 0,
      left: 20,
      lineHeight: '24px'
    }
  }))))));
};

var _default = SalesStatistic;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SalesStatistic, "SalesStatistic", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/eCommerce/SalesStatistic.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/eCommerce/SalesStatistic.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/eCommerce/SalesStatistic.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/eCommerce/SalesStatistic.js");

  __REACT_HOT_LOADER__.register(SalesStatistic, "SalesStatistic", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/eCommerce/SalesStatistic.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/eCommerce/SalesStatistic.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/eCommerce/SalesStatistic.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/eCommerce/SalesStatistic.js");
}();

;

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__ = __webpack_require__(1738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AnimateChild__ = __webpack_require__(1739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_animate__ = __webpack_require__(792);












var defaultKey = 'rc_animate_' + Date.now();

function getChildrenFromProps(props) {
  var children = props.children;
  if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(children)) {
    if (!children.key) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, {
        key: defaultKey
      });
    }
  }
  return children;
}

function noop() {}

var Animate = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Animate, _React$Component);

  // eslint-disable-line

  function Animate(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Animate);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));

    _initialiseProps.call(_this);

    _this.currentlyAnimatingKeys = {};
    _this.keysToEnter = [];
    _this.keysToLeave = [];

    _this.state = {
      children: Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props))
    };

    _this.childrenRefs = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var showProp = this.props.showProp;
      var children = this.state.children;
      if (showProp) {
        children = children.filter(function (child) {
          return !!child.props[showProp];
        });
      }
      children.forEach(function (child) {
        if (child) {
          _this2.performAppear(child.key);
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this.nextProps = nextProps;
      var nextChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(nextProps));
      var props = this.props;
      // exclusive needs immediate response
      if (props.exclusive) {
        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
          _this3.stop(key);
        });
      }
      var showProp = props.showProp;
      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
      // last props children if exclusive
      var currentChildren = props.exclusive ? Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props)) : this.state.children;
      // in case destroy in showProp mode
      var newChildren = [];
      if (showProp) {
        currentChildren.forEach(function (currentChild) {
          var nextChild = currentChild && Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, currentChild.key);
          var newChild = void 0;
          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
            newChild = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(nextChild || currentChild, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, showProp, true));
          } else {
            newChild = nextChild;
          }
          if (newChild) {
            newChildren.push(newChild);
          }
        });
        nextChildren.forEach(function (nextChild) {
          if (!nextChild || !Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, nextChild.key)) {
            newChildren.push(nextChild);
          }
        });
      } else {
        newChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["d" /* mergeChildren */])(currentChildren, nextChildren);
      }

      // need render to avoid update
      this.setState({
        children: newChildren
      });

      nextChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasPrev = child && Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
        if (showProp) {
          var showInNext = child.props[showProp];
          if (hasPrev) {
            var showInNow = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
            if (!showInNow && showInNext) {
              _this3.keysToEnter.push(key);
            }
          } else if (showInNext) {
            _this3.keysToEnter.push(key);
          }
        } else if (!hasPrev) {
          _this3.keysToEnter.push(key);
        }
      });

      currentChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasNext = child && Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, key);
        if (showProp) {
          var showInNow = child.props[showProp];
          if (hasNext) {
            var showInNext = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(nextChildren, key, showProp);
            if (!showInNext && showInNow) {
              _this3.keysToLeave.push(key);
            }
          } else if (showInNow) {
            _this3.keysToLeave.push(key);
          }
        } else if (!hasNext) {
          _this3.keysToLeave.push(key);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var keysToEnter = this.keysToEnter;
      this.keysToEnter = [];
      keysToEnter.forEach(this.performEnter);
      var keysToLeave = this.keysToLeave;
      this.keysToLeave = [];
      keysToLeave.forEach(this.performLeave);
    }
  }, {
    key: 'isValidChildByKey',
    value: function isValidChildByKey(currentChildren, key) {
      var showProp = this.props.showProp;
      if (showProp) {
        return Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
      }
      return Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
    }
  }, {
    key: 'stop',
    value: function stop(key) {
      delete this.currentlyAnimatingKeys[key];
      var component = this.childrenRefs[key];
      if (component) {
        component.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var props = this.props;
      this.nextProps = props;
      var stateChildren = this.state.children;
      var children = null;
      if (stateChildren) {
        children = stateChildren.map(function (child) {
          if (child === null || child === undefined) {
            return child;
          }
          if (!child.key) {
            throw new Error('must set key for <rc-animate> children');
          }
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__AnimateChild__["a" /* default */],
            {
              key: child.key,
              ref: function ref(node) {
                _this4.childrenRefs[child.key] = node;
              },
              animation: props.animation,
              transitionName: props.transitionName,
              transitionEnter: props.transitionEnter,
              transitionAppear: props.transitionAppear,
              transitionLeave: props.transitionLeave
            },
            child
          );
        });
      }
      var Component = props.component;
      if (Component) {
        var passedProps = props;
        if (typeof Component === 'string') {
          passedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            className: props.className,
            style: props.style
          }, props.componentProps);
        }
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          Component,
          passedProps,
          children
        );
      }
      return children[0] || null;
    }
  }]);

  return Animate;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Animate.isAnimate = true;
Animate.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  componentProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  transitionName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
  transitionEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  exclusive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  showProp: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};
Animate.defaultProps = {
  animation: {},
  component: 'span',
  componentProps: {},
  transitionEnter: true,
  transitionLeave: true,
  transitionAppear: false,
  onEnd: noop,
  onEnter: noop,
  onLeave: noop,
  onAppear: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.performEnter = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
    }
  };

  this.performAppear = function (key) {
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
    }
  };

  this.handleDoneAdding = function (key, type) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    if (!_this5.isValidChildByKey(currentChildren, key)) {
      // exclusive will not need this
      _this5.performLeave(key);
    } else if (type === 'appear') {
      if (__WEBPACK_IMPORTED_MODULE_10__util_animate__["a" /* default */].allowAppearCallback(props)) {
        props.onAppear(key);
        props.onEnd(key, true);
      }
    } else if (__WEBPACK_IMPORTED_MODULE_10__util_animate__["a" /* default */].allowEnterCallback(props)) {
      props.onEnter(key);
      props.onEnd(key, true);
    }
  };

  this.performLeave = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
    }
  };

  this.handleDoneLeaving = function (key) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    // in case state change is too fast
    if (_this5.isValidChildByKey(currentChildren, key)) {
      _this5.performEnter(key);
    } else {
      var end = function end() {
        if (__WEBPACK_IMPORTED_MODULE_10__util_animate__["a" /* default */].allowLeaveCallback(props)) {
          props.onLeave(key);
          props.onEnd(key, false);
        }
      };
      if (!Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["c" /* isSameChildren */])(_this5.state.children, currentChildren, props.showProp)) {
        _this5.setState({
          children: currentChildren
        }, end);
      } else {
        end();
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Animate);

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isCssAnimationSupported; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Event__ = __webpack_require__(1740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes__ = __webpack_require__(1741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_component_classes__);




var isCssAnimationSupported = __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].endEvents.length !== 0;
var capitalPrefixes = ['Webkit', 'Moz', 'O',
// ms is special .... !
'ms'];
var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];

function getStyleProperty(node, name) {
  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
  var style = window.getComputedStyle(node, null);
  var ret = '';
  for (var i = 0; i < prefixes.length; i++) {
    ret = style.getPropertyValue(prefixes[i] + name);
    if (ret) {
      break;
    }
  }
  return ret;
}

function fixBrowserByTimeout(node) {
  if (isCssAnimationSupported) {
    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
    // sometimes, browser bug
    node.rcEndAnimTimeout = setTimeout(function () {
      node.rcEndAnimTimeout = null;
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }, time * 1000 + 200);
  }
}

function clearBrowserBugTimeout(node) {
  if (node.rcEndAnimTimeout) {
    clearTimeout(node.rcEndAnimTimeout);
    node.rcEndAnimTimeout = null;
  }
}

var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(transitionName)) === 'object';
  var className = nameIsObj ? transitionName.name : transitionName;
  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
  var end = endCallback;
  var start = void 0;
  var active = void 0;
  var nodeClasses = __WEBPACK_IMPORTED_MODULE_2_component_classes___default()(node);

  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
    end = endCallback.end;
    start = endCallback.start;
    active = endCallback.active;
  }

  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    nodeClasses.remove(className);
    nodeClasses.remove(activeClassName);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional end is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (end) {
      end();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  if (start) {
    start();
  }
  nodeClasses.add(className);

  node.rcAnimTimeout = setTimeout(function () {
    node.rcAnimTimeout = null;
    nodeClasses.add(activeClassName);
    if (active) {
      setTimeout(active, 0);
    }
    fixBrowserByTimeout(node);
    // 30ms for firefox
  }, 30);

  return {
    stop: function stop() {
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }
  };
};

cssAnimation.style = function (node, style, callback) {
  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional callback is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (callback) {
      callback();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  node.rcAnimTimeout = setTimeout(function () {
    for (var s in style) {
      if (style.hasOwnProperty(s)) {
        node.style[s] = style[s];
      }
    }
    node.rcAnimTimeout = null;
    fixBrowserByTimeout(node);
  }, 0);
};

cssAnimation.setTransition = function (node, p, value) {
  var property = p;
  var v = value;
  if (value === undefined) {
    v = property;
    property = '';
  }
  property = property || '';
  capitalPrefixes.forEach(function (prefix) {
    node.style[prefix + 'Transition' + property] = v;
  });
};

cssAnimation.isCssAnimationSupported = isCssAnimationSupported;



/* harmony default export */ __webpack_exports__["a"] = (cssAnimation);

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(302);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(425));

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}
/* https://github.com/component/raf */


var prev = new Date().getTime();

function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);
  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};

compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};

var _default = compatRaf;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(302);

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(425));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(885);


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(35));

__webpack_require__(890);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var rootEl = document.getElementById('app-site'); // Create a reusable render method that we can call more than once

var render = function render() {
  // Dynamically import our main App component, and render it
  var MainApp = __webpack_require__(1076)["default"];

  _reactDom["default"].render(_react["default"].createElement(MainApp, null), rootEl);
};

if (false) {
  module.hot.accept('./MainApp', function () {
    var NextApp = require('./MainApp')["default"];

    render(_react["default"].createElement(NextApp, null), rootEl);
  });
}

render();
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(rootEl, "rootEl", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/index.js");

  __REACT_HOT_LOADER__.register(render, "render", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/index.js");

  __REACT_HOT_LOADER__.register(_reactDom, "_reactDom", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/index.js");

  __REACT_HOT_LOADER__.register(rootEl, "rootEl", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/index.js");

  __REACT_HOT_LOADER__.register(render, "render", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/index.js");
}();

;

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.11.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var h=__webpack_require__(77),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113;n&&Symbol.for("react.suspense_list");
var z=n?Symbol.for("react.memo"):60115,aa=n?Symbol.for("react.lazy"):60116;n&&Symbol.for("react.fundamental");n&&Symbol.for("react.responder");n&&Symbol.for("react.scope");var A="function"===typeof Symbol&&Symbol.iterator;
function B(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
function E(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(B(85));this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}var H=G.prototype=new F;
H.constructor=G;h(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,l=null;if(null!=b)for(e in void 0!==b.ref&&(l=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var k=Array(f),m=0;m<f;m++)k[m]=arguments[m+2];d.children=k}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:l,props:d,_owner:J.current}}
function ba(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,c,e){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var l=0;l<a.length;l++){d=a[l];var f=b+T(d,l);g+=S(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),l=
0;!(d=a.next()).done;)d=d.value,f=b+T(d,l++),g+=S(d,f,c,e);else if("object"===d)throw c=""+a,Error(B(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function U(a,b,c){return null==a?0:S(a,"",b,c)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ca(a,b){a.func.call(a.context,b,a.count++)}
function da(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,e,c,function(a){return a}):null!=a&&(N(a)&&(a=ba(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+c)),e.push(a))}function V(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(O,"$&/")+"/");b=Q(b,g,e,d);U(a,da,b);R(b)}function W(){var a=I.current;if(null===a)throw Error(B(321));return a}
var X={Children:{map:function(a,b,c){if(null==a)return a;var e=[];V(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=Q(null,null,b,c);U(a,ca,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){if(!N(a))throw Error(B(143));return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:x,render:a}},lazy:function(a){return{$$typeof:aa,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
b,c){return W().useImperativeHandle(a,b,c)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,c){return W().useReducer(a,b,c)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,Profiler:u,StrictMode:t,Suspense:y,createElement:M,cloneElement:function(a,b,c){if(null===a||void 0===a)throw Error(B(267,a));var e=h({},a.props),d=a.key,g=a.ref,l=a._owner;
if(null!=b){void 0!==b.ref&&(g=b.ref,l=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(k in b)K.call(b,k)&&!L.hasOwnProperty(k)&&(e[k]=void 0===b[k]&&void 0!==f?f[k]:b[k])}var k=arguments.length-2;if(1===k)e.children=c;else if(1<k){f=Array(k);for(var m=0;m<k;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,key:d,ref:g,props:e,_owner:l}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.11.0",
__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:h}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.11.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(77),q=__webpack_require__(888);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));var ba=null,ca={};
function da(){if(ba)for(var a in ca){var b=ca[a],c=ba.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!ea[c]){if(!b.extractEvents)throw Error(u(97,a));ea[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(fa.hasOwnProperty(h))throw Error(u(99,h));fa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ha(k[e],g,h);e=!0}else f.registrationName?(ha(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ha(a,b,c){if(ia[a])throw Error(u(100,a));ia[a]=b;ja[a]=b.eventTypes[c].dependencies}var ea=[],fa={},ia={},ja={};function ka(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var la=!1,ma=null,na=!1,oa=null,pa={onError:function(a){la=!0;ma=a}};function qa(a,b,c,d,e,f,g,h,k){la=!1;ma=null;ka.apply(pa,arguments)}
function ra(a,b,c,d,e,f,g,h,k){qa.apply(this,arguments);if(la){if(la){var l=ma;la=!1;ma=null}else throw Error(u(198));na||(na=!0,oa=l)}}var sa=null,ua=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ra(d,b,void 0,a);a.currentTarget=null}function xa(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ba(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a){ya(a,Aa);if(za)throw Error(u(95));if(na)throw a=oa,na=!1,oa=null,a;}}
var Ca={injectEventPluginOrder:function(a){if(ba)throw Error(u(101));ba=Array.prototype.slice.call(a);da()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!ca.hasOwnProperty(c)||ca[c]!==d){if(ca[c])throw Error(u(102,c));ca[c]=d;b=!0}}b&&da()}};
function Da(a,b){var c=a.stateNode;if(!c)return null;var d=sa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,b,typeof c));
return c}var Ea=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Ea.hasOwnProperty("ReactCurrentDispatcher")||(Ea.ReactCurrentDispatcher={current:null});Ea.hasOwnProperty("ReactCurrentBatchConfig")||(Ea.ReactCurrentBatchConfig={suspense:null});
var Fa=/^(.*)[\\\/]/,w="function"===typeof Symbol&&Symbol.for,Ga=w?Symbol.for("react.element"):60103,Ha=w?Symbol.for("react.portal"):60106,Ia=w?Symbol.for("react.fragment"):60107,Ja=w?Symbol.for("react.strict_mode"):60108,Ka=w?Symbol.for("react.profiler"):60114,La=w?Symbol.for("react.provider"):60109,Ma=w?Symbol.for("react.context"):60110,Na=w?Symbol.for("react.concurrent_mode"):60111,Oa=w?Symbol.for("react.forward_ref"):60112,Pa=w?Symbol.for("react.suspense"):60113,Qa=w?Symbol.for("react.suspense_list"):
60120,Ra=w?Symbol.for("react.memo"):60115,Sa=w?Symbol.for("react.lazy"):60116;w&&Symbol.for("react.fundamental");w&&Symbol.for("react.responder");w&&Symbol.for("react.scope");var Ta="function"===typeof Symbol&&Symbol.iterator;function Ua(a){if(null===a||"object"!==typeof a)return null;a=Ta&&a[Ta]||a["@@iterator"];return"function"===typeof a?a:null}
function Va(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function Wa(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case Ia:return"Fragment";case Ha:return"Portal";case Ka:return"Profiler";case Ja:return"StrictMode";case Pa:return"Suspense";case Qa:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case Ma:return"Context.Consumer";case La:return"Context.Provider";case Oa:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case Ra:return Wa(a.type);case Sa:if(a=1===a._status?a._result:null)return Wa(a)}return null}function Xa(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=Wa(a.type);c=null;d&&(c=Wa(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Fa,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
var Ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),Za=null,$a=null,ab=null;function bb(a){if(a=ua(a)){if("function"!==typeof Za)throw Error(u(280));var b=sa(a.stateNode);Za(a.stateNode,a.type,b)}}function cb(a){$a?ab?ab.push(a):ab=[a]:$a=a}function db(){if($a){var a=$a,b=ab;ab=$a=null;bb(a);if(b)for(a=0;a<b.length;a++)bb(b[a])}}function eb(a,b){return a(b)}function fb(a,b,c,d){return a(b,c,d)}function gb(){}
var hb=eb,ib=!1,jb=!1;function kb(){if(null!==$a||null!==ab)gb(),db()}new Map;var lb=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,mb=Object.prototype.hasOwnProperty,nb={},ob={};
function pb(a){if(mb.call(ob,a))return!0;if(mb.call(nb,a))return!1;if(lb.test(a))return ob[a]=!0;nb[a]=!0;return!1}function qb(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function rb(a,b,c,d){if(null===b||"undefined"===typeof b||qb(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function B(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var D={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new B(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new B(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new B(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new B(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new B(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){D[a]=new B(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){D[a]=new B(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){D[a]=new B(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){D[a]=new B(a,5,!1,a.toLowerCase(),null,!1)});var sb=/[\-:]([a-z])/g;function tb(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(sb,
tb);D[b]=new B(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(sb,tb);D[b]=new B(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(sb,tb);D[b]=new B(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!1)});
D.xlinkHref=new B("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!0)});function ub(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}
function vb(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(rb(b,c,e,d)&&(c=null),d||null===e?pb(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function wb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function xb(a){var b=wb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function yb(a){a._valueTracker||(a._valueTracker=xb(a))}function zb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=wb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function Ab(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Bb(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=ub(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Cb(a,b){b=b.checked;null!=b&&vb(a,"checked",b,!1)}
function Eb(a,b){Cb(a,b);var c=ub(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Fb(a,b.type,c):b.hasOwnProperty("defaultValue")&&Fb(a,b.type,ub(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Gb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Fb(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Hb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Ib(a,b){a=n({children:void 0},b);if(b=Hb(b.children))a.children=b;return a}
function Jb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+ub(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Kb(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Lb(a,b){var c=b.value;if(null==c){c=b.defaultValue;b=b.children;if(null!=b){if(null!=c)throw Error(u(92));if(Array.isArray(b)){if(!(1>=b.length))throw Error(u(93));b=b[0]}c=b}null==c&&(c="")}a._wrapperState={initialValue:ub(c)}}
function Mb(a,b){var c=ub(b.value),d=ub(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Nb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Ob={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Pb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Qb(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Pb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Rb,Sb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Ob.svg||"innerHTML"in a)a.innerHTML=b;else{Rb=Rb||document.createElement("div");Rb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Rb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Tb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Ub(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Vb={animationend:Ub("Animation","AnimationEnd"),animationiteration:Ub("Animation","AnimationIteration"),animationstart:Ub("Animation","AnimationStart"),transitionend:Ub("Transition","TransitionEnd")},Wb={},Xb={};
Ya&&(Xb=document.createElement("div").style,"AnimationEvent"in window||(delete Vb.animationend.animation,delete Vb.animationiteration.animation,delete Vb.animationstart.animation),"TransitionEvent"in window||delete Vb.transitionend.transition);function Yb(a){if(Wb[a])return Wb[a];if(!Vb[a])return a;var b=Vb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Xb)return Wb[a]=b[c];return a}var Zb=Yb("animationend"),$b=Yb("animationiteration"),ac=Yb("animationstart"),bc=Yb("transitionend"),dc="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" ");
function ec(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function fc(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function gc(a){if(ec(a)!==a)throw Error(u(188));}
function hc(a){var b=a.alternate;if(!b){b=ec(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return gc(e),a;if(f===d)return gc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function ic(a){a=hc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var jc,kc,lc,mc=!1,nc=[],oc=null,pc=null,qc=null,rc=new Map,sc=new Map,tc=[],uc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),vc="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function wc(a){var b=xc(a);uc.forEach(function(c){yc(c,a,b)});vc.forEach(function(c){yc(c,a,b)})}function zc(a,b,c,d){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:d}}function Ac(a,b){switch(a){case "focus":case "blur":oc=null;break;case "dragenter":case "dragleave":pc=null;break;case "mouseover":case "mouseout":qc=null;break;case "pointerover":case "pointerout":rc.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":sc.delete(b.pointerId)}}
function Bc(a,b,c,d,e){if(null===a||a.nativeEvent!==e)return a=zc(b,c,d,e),null!==b&&(b=Cc(b),null!==b&&kc(b)),a;a.eventSystemFlags|=d;return a}function Dc(a,b,c,d){switch(b){case "focus":return oc=Bc(oc,a,b,c,d),!0;case "dragenter":return pc=Bc(pc,a,b,c,d),!0;case "mouseover":return qc=Bc(qc,a,b,c,d),!0;case "pointerover":var e=d.pointerId;rc.set(e,Bc(rc.get(e)||null,a,b,c,d));return!0;case "gotpointercapture":return e=d.pointerId,sc.set(e,Bc(sc.get(e)||null,a,b,c,d)),!0}return!1}
function Ec(a){var b=Fc(a.target);if(null!==b){var c=ec(b);if(null!==c)if(b=c.tag,13===b){if(b=fc(c),null!==b){a.blockedOn=b;q.unstable_runWithPriority(a.priority,function(){lc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Gc(a){if(null!==a.blockedOn)return!1;var b=Hc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);if(null!==b){var c=Cc(b);null!==c&&kc(c);a.blockedOn=b;return!1}return!0}
function Ic(a,b,c){Gc(a)&&c.delete(b)}function Jc(){for(mc=!1;0<nc.length;){var a=nc[0];if(null!==a.blockedOn){a=Cc(a.blockedOn);null!==a&&jc(a);break}var b=Hc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);null!==b?a.blockedOn=b:nc.shift()}null!==oc&&Gc(oc)&&(oc=null);null!==pc&&Gc(pc)&&(pc=null);null!==qc&&Gc(qc)&&(qc=null);rc.forEach(Ic);sc.forEach(Ic)}function Kc(a,b){a.blockedOn===b&&(a.blockedOn=null,mc||(mc=!0,q.unstable_scheduleCallback(q.unstable_NormalPriority,Jc)))}
function Lc(a){function b(b){return Kc(b,a)}if(0<nc.length){Kc(nc[0],a);for(var c=1;c<nc.length;c++){var d=nc[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==oc&&Kc(oc,a);null!==pc&&Kc(pc,a);null!==qc&&Kc(qc,a);rc.forEach(b);sc.forEach(b);for(c=0;c<tc.length;c++)d=tc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<tc.length&&(c=tc[0],null===c.blockedOn);)Ec(c),null===c.blockedOn&&tc.shift()}
function Mc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Nc(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Oc(a,b,c){if(b=Da(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}
function Pc(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Nc(b);for(b=c.length;0<b--;)Oc(c[b],"captured",a);for(b=0;b<c.length;b++)Oc(c[b],"bubbled",a)}}function Qc(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Da(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Rc(a){a&&a.dispatchConfig.registrationName&&Qc(a._targetInst,null,a)}
function Sc(a){ya(a,Pc)}function Tc(){return!0}function Uc(){return!1}function E(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?Tc:Uc;this.isPropagationStopped=Uc;return this}
n(E.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=Tc)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=Tc)},persist:function(){this.isPersistent=Tc},isPersistent:Uc,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=Uc;this._dispatchInstances=this._dispatchListeners=null}});E.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
E.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;Vc(c);return c};Vc(E);function Wc(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function Xc(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Vc(a){a.eventPool=[];a.getPooled=Wc;a.release=Xc}var Yc=E.extend({animationName:null,elapsedTime:null,pseudoElement:null}),Zc=E.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),$c=E.extend({view:null,detail:null}),ad=$c.extend({relatedTarget:null});
function bd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var cd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},ed={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},fd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function gd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=fd[a])?!!b[a]:!1}function hd(){return gd}
var id=$c.extend({key:function(a){if(a.key){var b=cd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=bd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?ed[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:hd,charCode:function(a){return"keypress"===a.type?bd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?bd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),jd=0,kd=0,ld=!1,md=!1,nd=$c.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:hd,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=jd;jd=a.screenX;return ld?"mousemove"===a.type?a.screenX-
b:0:(ld=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;var b=kd;kd=a.screenY;return md?"mousemove"===a.type?a.screenY-b:0:(md=!0,0)}}),od=nd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),pd=nd.extend({dataTransfer:null}),qd=$c.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:hd}),rd=E.extend({propertyName:null,
elapsedTime:null,pseudoElement:null}),sd=nd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),td=[["blur","blur",0],["cancel","cancel",0],["click","click",0],["close","close",0],["contextmenu","contextMenu",0],["copy","copy",0],["cut","cut",0],["auxclick","auxClick",0],["dblclick","doubleClick",0],["dragend","dragEnd",
0],["dragstart","dragStart",0],["drop","drop",0],["focus","focus",0],["input","input",0],["invalid","invalid",0],["keydown","keyDown",0],["keypress","keyPress",0],["keyup","keyUp",0],["mousedown","mouseDown",0],["mouseup","mouseUp",0],["paste","paste",0],["pause","pause",0],["play","play",0],["pointercancel","pointerCancel",0],["pointerdown","pointerDown",0],["pointerup","pointerUp",0],["ratechange","rateChange",0],["reset","reset",0],["seeked","seeked",0],["submit","submit",0],["touchcancel","touchCancel",
0],["touchend","touchEnd",0],["touchstart","touchStart",0],["volumechange","volumeChange",0],["drag","drag",1],["dragenter","dragEnter",1],["dragexit","dragExit",1],["dragleave","dragLeave",1],["dragover","dragOver",1],["mousemove","mouseMove",1],["mouseout","mouseOut",1],["mouseover","mouseOver",1],["pointermove","pointerMove",1],["pointerout","pointerOut",1],["pointerover","pointerOver",1],["scroll","scroll",1],["toggle","toggle",1],["touchmove","touchMove",1],["wheel","wheel",1],["abort","abort",
2],[Zb,"animationEnd",2],[$b,"animationIteration",2],[ac,"animationStart",2],["canplay","canPlay",2],["canplaythrough","canPlayThrough",2],["durationchange","durationChange",2],["emptied","emptied",2],["encrypted","encrypted",2],["ended","ended",2],["error","error",2],["gotpointercapture","gotPointerCapture",2],["load","load",2],["loadeddata","loadedData",2],["loadedmetadata","loadedMetadata",2],["loadstart","loadStart",2],["lostpointercapture","lostPointerCapture",2],["playing","playing",2],["progress",
"progress",2],["seeking","seeking",2],["stalled","stalled",2],["suspend","suspend",2],["timeupdate","timeUpdate",2],[bc,"transitionEnd",2],["waiting","waiting",2]],ud={},vd={},xd=0;for(;xd<td.length;xd++){var yd=td[xd],zd=yd[0],Ad=yd[1],Bd=yd[2],Cd="on"+(Ad[0].toUpperCase()+Ad.slice(1)),Dd={phasedRegistrationNames:{bubbled:Cd,captured:Cd+"Capture"},dependencies:[zd],eventPriority:Bd};ud[Ad]=Dd;vd[zd]=Dd}
var Ed={eventTypes:ud,getEventPriority:function(a){a=vd[a];return void 0!==a?a.eventPriority:2},extractEvents:function(a,b,c,d){var e=vd[a];if(!e)return null;switch(a){case "keypress":if(0===bd(c))return null;case "keydown":case "keyup":a=id;break;case "blur":case "focus":a=ad;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=nd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
pd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=qd;break;case Zb:case $b:case ac:a=Yc;break;case bc:a=rd;break;case "scroll":a=$c;break;case "wheel":a=sd;break;case "copy":case "cut":case "paste":a=Zc;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=od;break;default:a=E}b=a.getPooled(e,b,c,d);Sc(b);return b}},Fd=q.unstable_UserBlockingPriority,
Gd=q.unstable_runWithPriority,Hd=Ed.getEventPriority,Id=10,Jd=[];
function Kd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=Fc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Mc(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=a.eventSystemFlags,h=null,k=0;k<ea.length;k++){var l=ea[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=xa(h,l))}Ba(h)}}
var Ld=!0;function F(a,b){Md(b,a,!1)}function Md(a,b,c){switch(Hd(b)){case 0:var d=Nd.bind(null,b,1);break;case 1:d=Od.bind(null,b,1);break;default:d=Pd.bind(null,b,1)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function Nd(a,b,c){ib||gb();var d=Pd,e=ib;ib=!0;try{fb(d,a,b,c)}finally{(ib=e)||kb()}}function Od(a,b,c){Gd(Fd,Pd.bind(null,a,b,c))}
function Qd(a,b,c,d){if(Jd.length){var e=Jd.pop();e.topLevelType=a;e.eventSystemFlags=b;e.nativeEvent=c;e.targetInst=d;a=e}else a={topLevelType:a,eventSystemFlags:b,nativeEvent:c,targetInst:d,ancestors:[]};try{if(b=Kd,c=a,jb)b(c,void 0);else{jb=!0;try{hb(b,c,void 0)}finally{jb=!1,kb()}}}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,Jd.length<Id&&Jd.push(a)}}
function Pd(a,b,c){if(Ld)if(0<nc.length&&-1<uc.indexOf(a))a=zc(null,a,b,c),nc.push(a);else{var d=Hc(a,b,c);null===d?Ac(a,c):-1<uc.indexOf(a)?(a=zc(d,a,b,c),nc.push(a)):Dc(d,a,b,c)||(Ac(a,c),Qd(a,b,c,null))}}function Hc(a,b,c){var d=Mc(c);d=Fc(d);if(null!==d){var e=ec(d);if(null===e)d=null;else{var f=e.tag;if(13===f){d=fc(e);if(null!==d)return d;d=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;d=null}else e!==d&&(d=null)}}Qd(a,b,c,d);return null}
function Rd(a){if(!Ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var Sd=new ("function"===typeof WeakMap?WeakMap:Map);function xc(a){var b=Sd.get(a);void 0===b&&(b=new Set,Sd.set(a,b));return b}
function yc(a,b,c){if(!c.has(a)){switch(a){case "scroll":Md(b,"scroll",!0);break;case "focus":case "blur":Md(b,"focus",!0);Md(b,"blur",!0);c.add("blur");c.add("focus");break;case "cancel":case "close":Rd(a)&&Md(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===dc.indexOf(a)&&F(a,b)}c.add(a)}}
var Td={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ud=["Webkit","ms","Moz","O"];Object.keys(Td).forEach(function(a){Ud.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Td[b]=Td[a]})});function Vd(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||Td.hasOwnProperty(a)&&Td[a]?(""+b).trim():b+"px"}
function Wd(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=Vd(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Xd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Yd(a,b){if(b){if(Xd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function Zd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}function $d(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=xc(a);b=ja[b];for(var d=0;d<b.length;d++)yc(b[d],a,c)}function ae(){}
function be(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ce(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function de(a,b){var c=ce(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ce(c)}}
function ee(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?ee(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function fe(){for(var a=window,b=be();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=be(a.document)}return b}
function ge(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var he="$",ie="/$",je="$?",ke="$!",le=null,me=null;function ne(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function oe(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var pe="function"===typeof setTimeout?setTimeout:void 0,qe="function"===typeof clearTimeout?clearTimeout:void 0;function re(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function se(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===he||c===ke||c===je){if(0===b)return a;b--}else c===ie&&b++}a=a.previousSibling}return null}var te=Math.random().toString(36).slice(2),ue="__reactInternalInstance$"+te,ve="__reactEventHandlers$"+te,we="__reactContainere$"+te;
function Fc(a){var b=a[ue];if(b)return b;for(var c=a.parentNode;c;){if(b=c[we]||c[ue]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=se(a);null!==a;){if(c=a[ue])return c;a=se(a)}return b}a=c;c=a.parentNode}return null}function Cc(a){a=a[ue]||a[we];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function xe(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function ye(a){return a[ve]||null}var ze=null,Ae=null,Be=null;
function Ce(){if(Be)return Be;var a,b=Ae,c=b.length,d,e="value"in ze?ze.value:ze.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return Be=e.slice(a,1<d?1-d:void 0)}var De=E.extend({data:null}),Ee=E.extend({data:null}),Fe=[9,13,27,32],Ge=Ya&&"CompositionEvent"in window,He=null;Ya&&"documentMode"in document&&(He=document.documentMode);
var Ie=Ya&&"TextEvent"in window&&!He,Je=Ya&&(!Ge||He&&8<He&&11>=He),Ke=String.fromCharCode(32),Le={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Me=!1;
function Ne(a,b){switch(a){case "keyup":return-1!==Fe.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Oe(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Pe=!1;function Qe(a,b){switch(a){case "compositionend":return Oe(b);case "keypress":if(32!==b.which)return null;Me=!0;return Ke;case "textInput":return a=b.data,a===Ke&&Me?null:a;default:return null}}
function Re(a,b){if(Pe)return"compositionend"===a||!Ge&&Ne(a,b)?(a=Ce(),Be=Ae=ze=null,Pe=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return Je&&"ko"!==b.locale?null:b.data;default:return null}}
var Se={eventTypes:Le,extractEvents:function(a,b,c,d){var e;if(Ge)b:{switch(a){case "compositionstart":var f=Le.compositionStart;break b;case "compositionend":f=Le.compositionEnd;break b;case "compositionupdate":f=Le.compositionUpdate;break b}f=void 0}else Pe?Ne(a,c)&&(f=Le.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=Le.compositionStart);f?(Je&&"ko"!==c.locale&&(Pe||f!==Le.compositionStart?f===Le.compositionEnd&&Pe&&(e=Ce()):(ze=d,Ae="value"in ze?ze.value:ze.textContent,Pe=!0)),f=De.getPooled(f,
b,c,d),e?f.data=e:(e=Oe(c),null!==e&&(f.data=e)),Sc(f),e=f):e=null;(a=Ie?Qe(a,c):Re(a,c))?(b=Ee.getPooled(Le.beforeInput,b,c,d),b.data=a,Sc(b)):b=null;return null===e?b:null===b?e:[e,b]}},Te={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Ue(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Te[a.type]:"textarea"===b?!0:!1}
var Ve={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function We(a,b,c){a=E.getPooled(Ve.change,a,b,c);a.type="change";cb(c);Sc(a);return a}var Xe=null,Ye=null;function Ze(a){Ba(a)}function $e(a){var b=xe(a);if(zb(b))return a}function af(a,b){if("change"===a)return b}var bf=!1;Ya&&(bf=Rd("input")&&(!document.documentMode||9<document.documentMode));
function cf(){Xe&&(Xe.detachEvent("onpropertychange",df),Ye=Xe=null)}function df(a){if("value"===a.propertyName&&$e(Ye))if(a=We(Ye,a,Mc(a)),ib)Ba(a);else{ib=!0;try{eb(Ze,a)}finally{ib=!1,kb()}}}function ef(a,b,c){"focus"===a?(cf(),Xe=b,Ye=c,Xe.attachEvent("onpropertychange",df)):"blur"===a&&cf()}function ff(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return $e(Ye)}function gf(a,b){if("click"===a)return $e(b)}function hf(a,b){if("input"===a||"change"===a)return $e(b)}
var jf={eventTypes:Ve,_isInputEventSupported:bf,extractEvents:function(a,b,c,d){var e=b?xe(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=af;else if(Ue(e))if(bf)g=hf;else{g=ff;var h=ef}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=gf);if(g&&(g=g(a,b)))return We(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Fb(e,"number",e.value)}},kf={mouseEnter:{registrationName:"onMouseEnter",
dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},lf,mf={eventTypes:kf,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;
e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?Fc(b):null,null!==b&&(f=ec(b),b!==f||5!==b.tag&&6!==b.tag))b=null}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===a){var h=nd;var k=kf.mouseLeave;var l=kf.mouseEnter;var m="mouse"}else if("pointerout"===a||"pointerover"===a)h=od,k=kf.pointerLeave,l=kf.pointerEnter,m="pointer";a=null==g?e:xe(g);e=null==b?e:xe(b);k=h.getPooled(k,g,c,d);k.type=m+"leave";k.target=
a;k.relatedTarget=e;d=h.getPooled(l,b,c,d);d.type=m+"enter";d.target=e;d.relatedTarget=a;h=g;m=b;if(h&&m)a:{l=h;a=m;g=0;for(b=l;b;b=Nc(b))g++;b=0;for(e=a;e;e=Nc(e))b++;for(;0<g-b;)l=Nc(l),g--;for(;0<b-g;)a=Nc(a),b--;for(;g--;){if(l===a||l===a.alternate)break a;l=Nc(l);a=Nc(a)}l=null}else l=null;a=l;for(l=[];h&&h!==a;){g=h.alternate;if(null!==g&&g===a)break;l.push(h);h=Nc(h)}for(h=[];m&&m!==a;){g=m.alternate;if(null!==g&&g===a)break;h.push(m);m=Nc(m)}for(m=0;m<l.length;m++)Qc(l[m],"bubbled",k);for(m=
h.length;0<m--;)Qc(h[m],"captured",d);if(c===lf)return lf=null,[k];lf=c;return[k,d]}};function nf(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var of="function"===typeof Object.is?Object.is:nf,pf=Object.prototype.hasOwnProperty;function qf(a,b){if(of(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!pf.call(b,c[d])||!of(a[c[d]],b[c[d]]))return!1;return!0}
var rf=Ya&&"documentMode"in document&&11>=document.documentMode,sf={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},tf=null,uf=null,vf=null,wf=!1;
function xf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(wf||null==tf||tf!==be(c))return null;c=tf;"selectionStart"in c&&ge(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return vf&&qf(vf,c)?null:(vf=c,a=E.getPooled(sf.select,uf,a,b),a.type="select",a.target=tf,Sc(a),a)}
var yf={eventTypes:sf,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=xc(e);f=ja.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?xe(b):window;switch(a){case "focus":if(Ue(e)||"true"===e.contentEditable)tf=e,uf=b,vf=null;break;case "blur":vf=uf=tf=null;break;case "mousedown":wf=!0;break;case "contextmenu":case "mouseup":case "dragend":return wf=!1,xf(c,d);case "selectionchange":if(rf)break;
case "keydown":case "keyup":return xf(c,d)}return null}};Ca.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));var zf=Cc;sa=ye;ua=zf;va=xe;Ca.injectEventPluginsByName({SimpleEventPlugin:Ed,EnterLeaveEventPlugin:mf,ChangeEventPlugin:jf,SelectEventPlugin:yf,BeforeInputEventPlugin:Se});new Set;var Af=[],Bf=-1;function G(a){0>Bf||(a.current=Af[Bf],Af[Bf]=null,Bf--)}
function I(a,b){Bf++;Af[Bf]=a.current;a.current=b}var Cf={},J={current:Cf},K={current:!1},Df=Cf;function Ef(a,b){var c=a.type.contextTypes;if(!c)return Cf;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Ff(a){G(K,a);G(J,a)}function Gf(a){G(K,a);G(J,a)}function Hf(a,b,c){if(J.current!==Cf)throw Error(u(168));I(J,b,a);I(K,c,a)}function If(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,Wa(b)||"Unknown",e));return n({},c,{},d)}function Jf(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||Cf;Df=J.current;I(J,b,a);I(K,K.current,a);return!0}
function Kf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(b=If(a,b,Df),d.__reactInternalMemoizedMergedChildContext=b,G(K,a),G(J,a),I(J,b,a)):G(K,a);I(K,c,a)}
var Lf=q.unstable_runWithPriority,Mf=q.unstable_scheduleCallback,Nf=q.unstable_cancelCallback,Of=q.unstable_shouldYield,Pf=q.unstable_requestPaint,Qf=q.unstable_now,Rf=q.unstable_getCurrentPriorityLevel,Sf=q.unstable_ImmediatePriority,Tf=q.unstable_UserBlockingPriority,Uf=q.unstable_NormalPriority,Vf=q.unstable_LowPriority,Wf=q.unstable_IdlePriority,Xf={},Yf=void 0!==Pf?Pf:function(){},Zf=null,$f=null,ag=!1,bg=Qf(),cg=1E4>bg?Qf:function(){return Qf()-bg};
function dg(){switch(Rf()){case Sf:return 99;case Tf:return 98;case Uf:return 97;case Vf:return 96;case Wf:return 95;default:throw Error(u(332));}}function eg(a){switch(a){case 99:return Sf;case 98:return Tf;case 97:return Uf;case 96:return Vf;case 95:return Wf;default:throw Error(u(332));}}function fg(a,b){a=eg(a);return Lf(a,b)}function gg(a,b,c){a=eg(a);return Mf(a,b,c)}function hg(a){null===Zf?(Zf=[a],$f=Mf(Sf,ig)):Zf.push(a);return Xf}function jg(){if(null!==$f){var a=$f;$f=null;Nf(a)}ig()}
function ig(){if(!ag&&null!==Zf){ag=!0;var a=0;try{var b=Zf;fg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Zf=null}catch(c){throw null!==Zf&&(Zf=Zf.slice(a+1)),Mf(Sf,jg),c;}finally{ag=!1}}}var kg=3;function lg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function mg(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var ng={current:null},og=null,pg=null,qg=null;function rg(){qg=pg=og=null}
function sg(a,b){var c=a.type._context;I(ng,c._currentValue,a);c._currentValue=b}function tg(a){var b=ng.current;G(ng,a);a.type._context._currentValue=b}function ug(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}
function vg(a,b){og=a;qg=pg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(wg=!0),a.firstContext=null)}function xg(a,b){if(qg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)qg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===pg){if(null===og)throw Error(u(308));pg=b;og.dependencies={expirationTime:0,firstContext:b,responders:null}}else pg=pg.next=b}return a._currentValue}var yg=!1;
function zg(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Ag(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Bg(a,b){return{expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Cg(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function Dg(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=zg(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=zg(a.memoizedState),e=c.updateQueue=zg(c.memoizedState)):d=a.updateQueue=Ag(e):null===e&&(e=c.updateQueue=Ag(d));null===e||d===e?Cg(d,b):null===d.lastUpdate||null===e.lastUpdate?(Cg(d,b),Cg(e,b)):(Cg(d,b),e.lastUpdate=b)}
function Eg(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=zg(a.memoizedState):Fg(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function Fg(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Ag(b));return b}
function Gg(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-4097|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case 2:yg=!0}return d}
function Hg(a,b,c,d,e){yg=!1;b=Fg(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,l=f;null!==k;){var m=k.expirationTime;m<e?(null===g&&(g=k,f=l),h<m&&(h=m)):(Ig(m,k.suspenseConfig),l=Gg(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k)));k=k.next}m=null;for(k=b.firstCapturedUpdate;null!==k;){var C=k.expirationTime;C<e?(null===m&&(m=k,null===g&&(f=l)),h<C&&(h=C)):(l=Gg(a,b,k,l,c,d),null!==
k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k)));k=k.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=l);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;Jg(h);a.expirationTime=h;a.memoizedState=l}
function Kg(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);Lg(b.firstEffect,c);b.firstEffect=b.lastEffect=null;Lg(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function Lg(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;if("function"!==typeof c)throw Error(u(191,c));c.call(d)}a=a.nextEffect}}
var Mg=Ea.ReactCurrentBatchConfig,Ng=(new aa.Component).refs;function Og(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var Sg={isMounted:function(a){return(a=a._reactInternalFiber)?ec(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Pg(),e=Mg.suspense;d=Qg(d,a,e);e=Bg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Dg(a,e);Rg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Pg(),e=Mg.suspense;d=Qg(d,a,e);e=Bg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Dg(a,e);Rg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Pg(),d=Mg.suspense;
c=Qg(c,a,d);d=Bg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);Dg(a,d);Rg(a,c)}};function Tg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!qf(c,d)||!qf(e,f):!0}
function Ug(a,b,c){var d=!1,e=Cf;var f=b.contextType;"object"===typeof f&&null!==f?f=xg(f):(e=L(b)?Df:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Ef(a,e):Cf);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Sg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Vg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Sg.enqueueReplaceState(b,b.state,null)}
function Wg(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Ng;var f=b.contextType;"object"===typeof f&&null!==f?e.context=xg(f):(f=L(b)?Df:J.current,e.context=Ef(a,f));f=a.updateQueue;null!==f&&(Hg(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(Og(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Sg.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(Hg(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Xg=Array.isArray;
function Yg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Ng&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Zg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function $g(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=ah(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=bh(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Yg(a,b,c),d.return=a,d;d=ch(c.type,c.key,c.props,null,a.mode,d);d.ref=Yg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=dh(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=eh(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function C(a,b,c){if("string"===typeof b||"number"===typeof b)return b=bh(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Ga:return c=ch(b.type,b.key,b.props,null,a.mode,c),c.ref=Yg(a,null,b),c.return=a,c;case Ha:return b=dh(b,a.mode,c),b.return=a,b}if(Xg(b)||
Ua(b))return b=eh(b,a.mode,c,null),b.return=a,b;Zg(a,b)}return null}function y(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Ga:return c.key===e?c.type===Ia?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case Ha:return c.key===e?l(a,b,c,d):null}if(Xg(c)||Ua(c))return null!==e?null:m(a,b,c,d,null);Zg(a,c)}return null}function H(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Ga:return a=a.get(null===d.key?c:d.key)||null,d.type===Ia?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case Ha:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Xg(d)||Ua(d))return a=a.get(c)||null,m(b,a,d,e,null);Zg(b,d)}return null}function z(e,g,h,k){for(var l=null,m=null,r=g,x=g=0,A=null;null!==r&&x<h.length;x++){r.index>x?(A=r,r=null):A=r.sibling;var p=y(e,r,h[x],k);if(null===p){null===r&&(r=A);break}a&&
r&&null===p.alternate&&b(e,r);g=f(p,g,x);null===m?l=p:m.sibling=p;m=p;r=A}if(x===h.length)return c(e,r),l;if(null===r){for(;x<h.length;x++)r=C(e,h[x],k),null!==r&&(g=f(r,g,x),null===m?l=r:m.sibling=r,m=r);return l}for(r=d(e,r);x<h.length;x++)A=H(r,e,x,h[x],k),null!==A&&(a&&null!==A.alternate&&r.delete(null===A.key?x:A.key),g=f(A,g,x),null===m?l=A:m.sibling=A,m=A);a&&r.forEach(function(a){return b(e,a)});return l}function ta(e,g,h,k){var l=Ua(h);if("function"!==typeof l)throw Error(u(150));h=l.call(h);
if(null==h)throw Error(u(151));for(var m=l=null,r=g,x=g=0,A=null,p=h.next();null!==r&&!p.done;x++,p=h.next()){r.index>x?(A=r,r=null):A=r.sibling;var z=y(e,r,p.value,k);if(null===z){null===r&&(r=A);break}a&&r&&null===z.alternate&&b(e,r);g=f(z,g,x);null===m?l=z:m.sibling=z;m=z;r=A}if(p.done)return c(e,r),l;if(null===r){for(;!p.done;x++,p=h.next())p=C(e,p.value,k),null!==p&&(g=f(p,g,x),null===m?l=p:m.sibling=p,m=p);return l}for(r=d(e,r);!p.done;x++,p=h.next())p=H(r,e,x,p.value,k),null!==p&&(a&&null!==
p.alternate&&r.delete(null===p.key?x:p.key),g=f(p,g,x),null===m?l=p:m.sibling=p,m=p);a&&r.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Ia&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Ga:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===Ia:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Ia?f.props.children:f.props,h);d.ref=Yg(a,k,f);d.return=a;a=d;break a}else{c(a,
k);break}else b(a,k);k=k.sibling}f.type===Ia?(d=eh(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=ch(f.type,f.key,f.props,null,a.mode,h),h.ref=Yg(a,d,f),h.return=a,a=h)}return g(a);case Ha:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=dh(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===
typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=bh(f,a.mode,h),d.return=a,a=d),g(a);if(Xg(f))return z(a,d,f,h);if(Ua(f))return ta(a,d,f,h);l&&Zg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var fh=$g(!0),gh=$g(!1),hh={},ih={current:hh},jh={current:hh},kh={current:hh};function lh(a){if(a===hh)throw Error(u(174));return a}
function mh(a,b){I(kh,b,a);I(jh,a,a);I(ih,hh,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Qb(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=Qb(b,c)}G(ih,a);I(ih,b,a)}function nh(a){G(ih,a);G(jh,a);G(kh,a)}function oh(a){lh(kh.current);var b=lh(ih.current);var c=Qb(b,a.type);b!==c&&(I(jh,a,a),I(ih,c,a))}function ph(a){jh.current===a&&(G(ih,a),G(jh,a))}var M={current:0};
function qh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===je||c.data===ke))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function rh(a,b){return{responder:a,props:b}}
var sh=Ea.ReactCurrentDispatcher,N=Ea.ReactCurrentBatchConfig,th=0,uh=null,O=null,vh=null,wh=null,P=null,xh=null,yh=0,zh=null,Ah=0,Bh=!1,Ch=null,Gh=0;function Q(){throw Error(u(321));}function Hh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!of(a[c],b[c]))return!1;return!0}
function Ih(a,b,c,d,e,f){th=f;uh=b;vh=null!==a?a.memoizedState:null;sh.current=null===vh?Jh:Kh;b=c(d,e);if(Bh){do Bh=!1,Gh+=1,vh=null!==a?a.memoizedState:null,xh=wh,zh=P=O=null,sh.current=Kh,b=c(d,e);while(Bh);Ch=null;Gh=0}sh.current=Lh;a=uh;a.memoizedState=wh;a.expirationTime=yh;a.updateQueue=zh;a.effectTag|=Ah;a=null!==O&&null!==O.next;th=0;xh=P=wh=vh=O=uh=null;yh=0;zh=null;Ah=0;if(a)throw Error(u(300));return b}
function Mh(){sh.current=Lh;th=0;xh=P=wh=vh=O=uh=null;yh=0;zh=null;Ah=0;Bh=!1;Ch=null;Gh=0}function Nh(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===P?wh=P=a:P=P.next=a;return P}function Oh(){if(null!==xh)P=xh,xh=P.next,O=vh,vh=null!==O?O.next:null;else{if(null===vh)throw Error(u(310));O=vh;var a={memoizedState:O.memoizedState,baseState:O.baseState,queue:O.queue,baseUpdate:O.baseUpdate,next:null};P=null===P?wh=a:P.next=a;vh=O.next}return P}
function Ph(a,b){return"function"===typeof b?b(a):b}
function Qh(a){var b=Oh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;if(0<Gh){var d=c.dispatch;if(null!==Ch){var e=Ch.get(c);if(void 0!==e){Ch.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);of(f,b.memoizedState)||(wg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
d){var h=e=null,k=d,l=!1;do{var m=k.expirationTime;m<th?(l||(l=!0,h=g,e=f),m>yh&&(yh=m,Jg(yh))):(Ig(m,k.suspenseConfig),f=k.eagerReducer===a?k.eagerState:a(f,k.action));g=k;k=k.next}while(null!==k&&k!==d);l||(h=g,e=f);of(f,b.memoizedState)||(wg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
function Rh(a){var b=Nh();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,lastRenderedReducer:Ph,lastRenderedState:a};a=a.dispatch=Sh.bind(null,uh,a);return[b.memoizedState,a]}function Th(a){return Qh(Ph,a)}function Uh(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===zh?(zh={lastEffect:null},zh.lastEffect=a.next=a):(b=zh.lastEffect,null===b?zh.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,zh.lastEffect=a));return a}
function Vh(a,b,c,d){var e=Nh();Ah|=a;e.memoizedState=Uh(b,c,void 0,void 0===d?null:d)}function Wh(a,b,c,d){var e=Oh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&Hh(d,g.deps)){Uh(0,c,f,d);return}}Ah|=a;e.memoizedState=Uh(b,c,f,d)}function Xh(a,b){return Vh(516,192,a,b)}function Yh(a,b){return Wh(516,192,a,b)}
function Zh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function $h(){}function ai(a,b){Nh().memoizedState=[a,void 0===b?null:b];return a}function bi(a,b){var c=Oh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Hh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Sh(a,b,c){if(!(25>Gh))throw Error(u(301));var d=a.alternate;if(a===uh||null!==d&&d===uh)if(Bh=!0,a={expirationTime:th,suspenseConfig:null,action:c,eagerReducer:null,eagerState:null,next:null},null===Ch&&(Ch=new Map),c=Ch.get(b),void 0===c)Ch.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{var e=Pg(),f=Mg.suspense;e=Qg(e,a,f);f={expirationTime:e,suspenseConfig:f,action:c,eagerReducer:null,eagerState:null,next:null};var g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&
(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var k=b.lastRenderedState,l=d(k,c);f.eagerReducer=d;f.eagerState=l;if(of(l,k))return}catch(m){}finally{}Rg(a,e)}}
var Lh={readContext:xg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},Jh={readContext:xg,useCallback:ai,useContext:xg,useEffect:Xh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Vh(4,36,Zh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Vh(4,36,a,b)},useMemo:function(a,b){var c=Nh();b=void 0===b?null:b;a=a();c.memoizedState=
[a,b];return a},useReducer:function(a,b,c){var d=Nh();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=Sh.bind(null,uh,a);return[d.memoizedState,a]},useRef:function(a){var b=Nh();a={current:a};return b.memoizedState=a},useState:Rh,useDebugValue:$h,useResponder:rh,useDeferredValue:function(a,b){var c=Rh(a),d=c[0],e=c[1];Xh(function(){q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===b?null:b;try{e(a)}finally{N.suspense=
c}})},[a,b]);return d},useTransition:function(a){var b=Rh(!1),c=b[0],d=b[1];return[ai(function(b){d(!0);q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===a?null:a;try{d(!1),b()}finally{N.suspense=c}})},[a,c]),c]}},Kh={readContext:xg,useCallback:bi,useContext:xg,useEffect:Yh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Wh(4,36,Zh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Wh(4,36,a,b)},useMemo:function(a,b){var c=Oh();b=void 0===b?
null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Hh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:Qh,useRef:function(){return Oh().memoizedState},useState:Th,useDebugValue:$h,useResponder:rh,useDeferredValue:function(a,b){var c=Th(a),d=c[0],e=c[1];Yh(function(){q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===b?null:b;try{e(a)}finally{N.suspense=c}})},[a,b]);return d},useTransition:function(a){var b=Th(!1),c=b[0],d=b[1];return[bi(function(b){d(!0);q.unstable_next(function(){var c=
N.suspense;N.suspense=void 0===a?null:a;try{d(!1),b()}finally{N.suspense=c}})},[a,c]),c]}},ci=null,di=null,ei=!1;function fi(a,b){var c=gi(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function hi(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function ii(a){if(ei){var b=di;if(b){var c=b;if(!hi(a,b)){b=re(c.nextSibling);if(!b||!hi(a,b)){a.effectTag=a.effectTag&-1025|2;ei=!1;ci=a;return}fi(ci,c)}ci=a;di=re(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,ei=!1,ci=a}}function ji(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;ci=a}
function ki(a){if(a!==ci)return!1;if(!ei)return ji(a),ei=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!oe(b,a.memoizedProps))for(b=di;b;)fi(a,b),b=re(b.nextSibling);ji(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===ie){if(0===b){di=re(a.nextSibling);break a}b--}else c!==he&&c!==ke&&c!==je||b++}a=a.nextSibling}di=null}}else di=ci?re(a.stateNode.nextSibling):null;return!0}
function li(){di=ci=null;ei=!1}var mi=Ea.ReactCurrentOwner,wg=!1;function R(a,b,c,d){b.child=null===a?gh(b,null,c,d):fh(b,a.child,c,d)}function ni(a,b,c,d,e){c=c.render;var f=b.ref;vg(b,e);d=Ih(a,b,c,d,f,e);if(null!==a&&!wg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),oi(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function pi(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!qi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ri(a,b,g,d,e,f);a=ch(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:qf,c(e,d)&&a.ref===b.ref))return oi(a,b,f);b.effectTag|=1;a=ah(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function ri(a,b,c,d,e,f){return null!==a&&qf(a.memoizedProps,d)&&a.ref===b.ref&&(wg=!1,e<f)?oi(a,b,f):si(a,b,c,d,f)}function ti(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function si(a,b,c,d,e){var f=L(c)?Df:J.current;f=Ef(b,f);vg(b,e);c=Ih(a,b,c,d,f,e);if(null!==a&&!wg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),oi(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function ui(a,b,c,d,e){if(L(c)){var f=!0;Jf(b)}else f=!1;vg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Ug(b,c,d,e),Wg(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=xg(l):(l=L(c)?Df:J.current,l=Ef(b,l));var m=c.getDerivedStateFromProps,C="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;C||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Vg(b,g,d,l);yg=!1;var y=b.memoizedState;k=g.state=y;var H=b.updateQueue;null!==H&&(Hg(b,H,d,g,e),k=b.memoizedState);h!==d||y!==k||K.current||yg?("function"===typeof m&&(Og(b,c,m,d),k=b.memoizedState),(h=yg||Tg(b,c,h,d,y,k,l))?(C||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:mg(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=xg(l):(l=L(c)?Df:J.current,l=Ef(b,l)),m=c.getDerivedStateFromProps,(C=
"function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Vg(b,g,d,l),yg=!1,k=b.memoizedState,y=g.state=k,H=b.updateQueue,null!==H&&(Hg(b,H,d,g,e),y=b.memoizedState),h!==d||k!==y||K.current||yg?("function"===typeof m&&(Og(b,c,m,d),y=b.memoizedState),(m=yg||Tg(b,c,h,d,k,y,l))?(C||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||
("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,y,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,y,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=
d,b.memoizedState=y),g.props=d,g.state=y,g.context=l,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return vi(a,b,c,d,f,e)}
function vi(a,b,c,d,e,f){ti(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Kf(b,c,!1),oi(a,b,f);d=b.stateNode;mi.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=fh(b,a.child,null,f),b.child=fh(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Kf(b,c,!0);return b.child}function wi(a){var b=a.stateNode;b.pendingContext?Hf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Hf(a,b.context,!1);mh(a,b.containerInfo)}
var xi={dehydrated:null,retryTime:0};
function yi(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1,b);if(null===a){void 0!==e.fallback&&ii(b);if(g){g=e.fallback;e=eh(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=eh(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=xi;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=gh(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=ah(a,a.pendingProps,0);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=ah(d,e,d.expirationTime);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=xi;b.child=c;return d}c=fh(b,a.child,e.children,c);b.memoizedState=
null;return b.child=c}a=a.child;if(g){g=e.fallback;e=eh(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=eh(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=xi;b.child=e;return c}b.memoizedState=null;return b.child=fh(b,a,e.children,c)}
function zi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);ug(a.return,b)}function Ai(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function Bi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&zi(a,c);else if(19===a.tag)zi(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d,b);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===qh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);Ai(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===qh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}Ai(b,!0,c,null,f,b.lastEffect);break;case "together":Ai(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function oi(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Jg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=ah(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=ah(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}function Ci(a){a.effectTag|=4}var Hi,Ii,Ji,Ki;
Hi=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Ii=function(){};
Ji=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;lh(ih.current);a=null;switch(c){case "input":f=Ab(g,f);d=Ab(g,d);a=[];break;case "option":f=Ib(g,f);d=Ib(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Kb(g,f);d=Kb(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=ae)}Yd(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,""+l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(ia.hasOwnProperty(h)?(null!=l&&$d(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;(b.updateQueue=e)&&Ci(b)}};Ki=function(a,b,c,d){c!==d&&Ci(b)};
function Li(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function Mi(a){switch(a.tag){case 1:L(a.type)&&Ff(a);var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:nh(a);Gf(a);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return ph(a),null;case 13:return G(M,a),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return G(M,a),null;case 4:return nh(a),null;case 10:return tg(a),null;default:return null}}function Ni(a,b){return{value:a,source:b,stack:Xa(b)}}
var Oi="function"===typeof WeakSet?WeakSet:Set;function Pi(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=Xa(c));null!==c&&Wa(c.type);b=b.value;null!==a&&1===a.tag&&Wa(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Qi(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ri(a,c)}}function Si(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ri(a,c)}else b.current=null}
function Ti(a,b){switch(b.tag){case 0:case 11:case 15:Ui(2,0,b);break;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:mg(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break;case 3:case 5:case 6:case 4:case 17:break;default:throw Error(u(163));}}
function Ui(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if(0!==(d.tag&a)){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}0!==(d.tag&b)&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
function Vi(a,b,c){"function"===typeof Wi&&Wi(b);switch(b.tag){case 0:case 11:case 14:case 15:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;fg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ri(g,h)}}a=a.next}while(a!==d)})}break;case 1:Si(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Qi(b,c);break;case 5:Si(b);break;case 4:Xi(a,b,c)}}
function Yi(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;null!==b&&Yi(b)}function Zi(a){return 5===a.tag||3===a.tag||4===a.tag}
function $i(a){a:{for(var b=a.return;null!==b;){if(Zi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Tb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Zi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){var f=5===e.tag||6===e.tag;if(f){var g=f?e.stateNode:e.stateNode.instance;if(c)if(d){f=b;var h=g;g=c;8===f.nodeType?f.parentNode.insertBefore(h,g):f.insertBefore(h,g)}else b.insertBefore(g,c);else d?(h=b,8===h.nodeType?(f=h.parentNode,f.insertBefore(g,h)):(f=h,f.appendChild(g)),h=h._reactRootContainer,null!==h&&void 0!==h||null!==f.onclick||(f.onclick=ae)):b.appendChild(g)}else if(4!==
e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function Xi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Vi(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Vi(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function aj(a,b){switch(b.tag){case 0:case 11:case 14:case 15:Ui(4,8,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[ve]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Cb(c,d);Zd(a,e);b=Zd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?Wd(c,h):"dangerouslySetInnerHTML"===g?Sb(c,h):"children"===g?Tb(c,h):vb(c,g,h,b)}switch(a){case "input":Eb(c,d);break;case "textarea":Mb(c,
d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Jb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Jb(c,!!d.multiple,d.defaultValue,!0):Jb(c,!!d.multiple,d.multiple?[]:"",!1))}}}break;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;break;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Lc(b.containerInfo));break;case 12:break;case 13:c=b;null===b.memoizedState?d=!1:(d=!0,c=b.child,bj=cg());
if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=Vd("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=f;continue}else if(null!==a.child){a.child.return=
a;a=a.child;continue}if(a===c)break a;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}cj(b);break;case 19:cj(b);break;case 17:break;case 20:break;case 21:break;default:throw Error(u(163));}}function cj(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Oi);b.forEach(function(b){var d=dj.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}var ej="function"===typeof WeakMap?WeakMap:Map;
function fj(a,b,c){c=Bg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){gj||(gj=!0,hj=d);Pi(a,b)};return c}
function ij(a,b,c){c=Bg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Pi(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===jj?jj=new Set([this]):jj.add(this),Pi(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var kj=Math.ceil,lj=Ea.ReactCurrentDispatcher,mj=Ea.ReactCurrentOwner,S=0,nj=8,oj=16,pj=32,qj=0,rj=1,sj=2,tj=3,uj=4,vj=5,T=S,U=null,V=null,W=0,X=qj,wj=null,xj=1073741823,yj=1073741823,zj=null,Aj=0,Bj=!1,bj=0,Cj=500,Y=null,gj=!1,hj=null,jj=null,Dj=!1,Ej=null,Fj=90,Gj=null,Hj=0,Ij=null,Jj=0;function Pg(){return(T&(oj|pj))!==S?1073741821-(cg()/10|0):0!==Jj?Jj:Jj=1073741821-(cg()/10|0)}
function Qg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=dg();if(0===(b&4))return 99===d?1073741823:1073741822;if((T&oj)!==S)return W;if(null!==c)a=lg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=lg(a,150,100);break;case 97:case 96:a=lg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==U&&a===W&&--a;return a}
function Rg(a,b){if(50<Hj)throw Hj=0,Ij=null,Error(u(185));a=Kj(a,b);if(null!==a){var c=dg();1073741823===b?(T&nj)!==S&&(T&(oj|pj))===S?Lj(a):(Z(a),T===S&&jg()):Z(a);(T&4)===S||98!==c&&99!==c||(null===Gj?Gj=new Map([[a,b]]):(c=Gj.get(a),(void 0===c||c>b)&&Gj.set(a,b)))}}
function Kj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(U===e&&(Jg(b),X===uj&&Mj(e,W)),Nj(e,b));return e}
function Oj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Pj(a,b))return b;b=a.lastPingedTime;a=a.nextKnownPendingLevel;return b>a?b:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=hg(Lj.bind(null,a));else{var b=Oj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Pg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Xf&&Nf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?hg(Lj.bind(null,a)):gg(d,Qj.bind(null,a),{timeout:10*(1073741821-b)-cg()});a.callbackNode=b}}}
function Qj(a,b){Jj=0;if(b)return b=Pg(),Rj(a,b),Z(a),null;var c=Oj(a);if(0!==c){b=a.callbackNode;if((T&(oj|pj))!==S)throw Error(u(327));Sj();a===U&&c===W||Tj(a,c);if(null!==V){var d=T;T|=oj;var e=Uj(a);do try{Vj();break}catch(h){Wj(a,h)}while(1);rg();T=d;lj.current=e;if(X===rj)throw b=wj,Tj(a,c),Mj(a,c),Z(a),b;if(null===V)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=X,U=null,d){case qj:case rj:throw Error(u(345));case sj:Rj(a,2<c?2:c);break;case tj:Mj(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Xj(e));if(1073741823===xj&&(e=bj+Cj-cg(),10<e)){if(Bj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Tj(a,c);break}}f=Oj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=pe(Yj.bind(null,a),e);break}Yj(a);break;case uj:Mj(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Xj(e));if(Bj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Tj(a,c);break}e=Oj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==yj?d=10*(1073741821-yj)-cg():1073741823===xj?d=0:(d=10*(1073741821-xj)-5E3,e=cg(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*kj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=pe(Yj.bind(null,a),d);break}Yj(a);break;case vj:if(1073741823!==xj&&null!==zj){f=xj;var g=zj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=cg()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){Mj(a,c);a.timeoutHandle=
pe(Yj.bind(null,a),d);break}}Yj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Qj.bind(null,a)}}return null}
function Lj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if(a.finishedExpirationTime===b)Yj(a);else{if((T&(oj|pj))!==S)throw Error(u(327));Sj();a===U&&b===W||Tj(a,b);if(null!==V){var c=T;T|=oj;var d=Uj(a);do try{Zj();break}catch(e){Wj(a,e)}while(1);rg();T=c;lj.current=d;if(X===rj)throw c=wj,Tj(a,b),Mj(a,b),Z(a),c;if(null!==V)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;U=null;Yj(a);Z(a)}}return null}
function ak(){if(null!==Gj){var a=Gj;Gj=null;a.forEach(function(a,c){Rj(c,a);Z(c)});jg()}}function bk(a,b){var c=T;T|=1;try{return a(b)}finally{T=c,T===S&&jg()}}function ck(a,b){var c=T;T&=-2;T|=nj;try{return a(b)}finally{T=c,T===S&&jg()}}
function Tj(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,qe(c));if(null!==V)for(c=V.return;null!==c;){var d=c;switch(d.tag){case 1:var e=d.type.childContextTypes;null!==e&&void 0!==e&&Ff(d);break;case 3:nh(d);Gf(d);break;case 5:ph(d);break;case 4:nh(d);break;case 13:G(M,d);break;case 19:G(M,d);break;case 10:tg(d)}c=c.return}U=a;V=ah(a.current,null,b);W=b;X=qj;wj=null;yj=xj=1073741823;zj=null;Aj=0;Bj=!1}
function Wj(a,b){do{try{rg();Mh();if(null===V||null===V.return)return X=rj,wj=b,null;a:{var c=a,d=V.return,e=V,f=b;b=W;e.effectTag|=2048;e.firstEffect=e.lastEffect=null;if(null!==f&&"object"===typeof f&&"function"===typeof f.then){var g=f,h=0!==(M.current&1),k=d;do{var l;if(l=13===k.tag){var m=k.memoizedState;if(null!==m)l=null!==m.dehydrated?!0:!1;else{var C=k.memoizedProps;l=void 0===C.fallback?!1:!0!==C.unstable_avoidThisFallback?!0:h?!1:!0}}if(l){var y=k.updateQueue;if(null===y){var H=new Set;
H.add(g);k.updateQueue=H}else y.add(g);if(0===(k.mode&2)){k.effectTag|=64;e.effectTag&=-2981;if(1===e.tag)if(null===e.alternate)e.tag=17;else{var z=Bg(1073741823,null);z.tag=2;Dg(e,z)}e.expirationTime=1073741823;break a}f=void 0;e=b;var ta=c.pingCache;null===ta?(ta=c.pingCache=new ej,f=new Set,ta.set(g,f)):(f=ta.get(g),void 0===f&&(f=new Set,ta.set(g,f)));if(!f.has(e)){f.add(e);var r=dk.bind(null,c,g,e);g.then(r,r)}k.effectTag|=4096;k.expirationTime=b;break a}k=k.return}while(null!==k);f=Error((Wa(e.type)||
"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+Xa(e))}X!==vj&&(X=sj);f=Ni(f,e);k=d;do{switch(k.tag){case 3:g=f;k.effectTag|=4096;k.expirationTime=b;var x=fj(k,g,b);Eg(k,x);break a;case 1:g=f;var A=k.type,p=k.stateNode;if(0===(k.effectTag&64)&&("function"===typeof A.getDerivedStateFromError||null!==p&&"function"===typeof p.componentDidCatch&&
(null===jj||!jj.has(p)))){k.effectTag|=4096;k.expirationTime=b;var t=ij(k,g,b);Eg(k,t);break a}}k=k.return}while(null!==k)}V=ek(V)}catch(v){b=v;continue}break}while(1)}function Uj(){var a=lj.current;lj.current=Lh;return null===a?Lh:a}function Ig(a,b){a<xj&&2<a&&(xj=a);null!==b&&a<yj&&2<a&&(yj=a,zj=b)}function Jg(a){a>Aj&&(Aj=a)}function Zj(){for(;null!==V;)V=fk(V)}function Vj(){for(;null!==V&&!Of();)V=fk(V)}
function fk(a){var b=gk(a.alternate,a,W);a.memoizedProps=a.pendingProps;null===b&&(b=ek(a));mj.current=null;return b}
function ek(a){V=a;do{var b=V.alternate;a=V.return;if(0===(V.effectTag&2048)){a:{var c=b;b=V;var d=W;var e=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:L(b.type)&&Ff(b);break;case 3:nh(b);Gf(b);e=b.stateNode;e.pendingContext&&(e.context=e.pendingContext,e.pendingContext=null);(null===c||null===c.child)&&ki(b)&&Ci(b);Ii(b);break;case 5:ph(b);d=lh(kh.current);var f=b.type;if(null!==c&&null!=b.stateNode)Ji(c,b,f,e,d),c.ref!==b.ref&&(b.effectTag|=128);else if(e){var g=
lh(ih.current);if(ki(b)){e=b;var h=e.stateNode;c=e.type;var k=e.memoizedProps,l=d;h[ue]=e;h[ve]=k;f=void 0;d=h;switch(c){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(h=0;h<dc.length;h++)F(dc[h],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Bb(d,k);F("invalid",d);$d(l,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!k.multiple};F("invalid",d);$d(l,"onChange");break;case "textarea":Lb(d,k),F("invalid",d),$d(l,"onChange")}Yd(c,k);h=null;for(f in k)k.hasOwnProperty(f)&&(g=k[f],"children"===f?"string"===typeof g?d.textContent!==g&&(h=["children",g]):"number"===typeof g&&d.textContent!==""+g&&(h=["children",""+g]):ia.hasOwnProperty(f)&&null!=g&&$d(l,f));switch(c){case "input":yb(d);Gb(d,k,!0);break;case "textarea":yb(d);Nb(d,k);break;case "select":case "option":break;default:"function"===typeof k.onClick&&
(d.onclick=ae)}f=h;e.updateQueue=f;e=null!==f?!0:!1;e&&Ci(b)}else{c=b;l=f;k=e;h=9===d.nodeType?d:d.ownerDocument;g===Ob.html&&(g=Pb(l));g===Ob.html?"script"===l?(k=h.createElement("div"),k.innerHTML="<script>\x3c/script>",h=k.removeChild(k.firstChild)):"string"===typeof k.is?h=h.createElement(l,{is:k.is}):(h=h.createElement(l),"select"===l&&(l=h,k.multiple?l.multiple=!0:k.size&&(l.size=k.size))):h=h.createElementNS(g,l);k=h;k[ue]=c;k[ve]=e;Hi(k,b,!1,!1);b.stateNode=k;l=f;c=e;var m=d,C=Zd(l,c);switch(l){case "iframe":case "object":case "embed":F("load",
k);d=c;break;case "video":case "audio":for(d=0;d<dc.length;d++)F(dc[d],k);d=c;break;case "source":F("error",k);d=c;break;case "img":case "image":case "link":F("error",k);F("load",k);d=c;break;case "form":F("reset",k);F("submit",k);d=c;break;case "details":F("toggle",k);d=c;break;case "input":Bb(k,c);d=Ab(k,c);F("invalid",k);$d(m,"onChange");break;case "option":d=Ib(k,c);break;case "select":k._wrapperState={wasMultiple:!!c.multiple};d=n({},c,{value:void 0});F("invalid",k);$d(m,"onChange");break;case "textarea":Lb(k,
c);d=Kb(k,c);F("invalid",k);$d(m,"onChange");break;default:d=c}Yd(l,d);h=void 0;g=l;var y=k,H=d;for(h in H)if(H.hasOwnProperty(h)){var z=H[h];"style"===h?Wd(y,z):"dangerouslySetInnerHTML"===h?(z=z?z.__html:void 0,null!=z&&Sb(y,z)):"children"===h?"string"===typeof z?("textarea"!==g||""!==z)&&Tb(y,z):"number"===typeof z&&Tb(y,""+z):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?null!=z&&$d(m,h):null!=z&&vb(y,h,z,C))}switch(l){case "input":yb(k);
Gb(k,c,!1);break;case "textarea":yb(k);Nb(k,c);break;case "option":null!=c.value&&k.setAttribute("value",""+ub(c.value));break;case "select":d=k;d.multiple=!!c.multiple;k=c.value;null!=k?Jb(d,!!c.multiple,k,!1):null!=c.defaultValue&&Jb(d,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof d.onClick&&(k.onclick=ae)}(e=ne(f,e))&&Ci(b)}null!==b.ref&&(b.effectTag|=128)}else if(null===b.stateNode)throw Error(u(166));break;case 6:if(c&&null!=b.stateNode)Ki(c,b,c.memoizedProps,e);else{if("string"!==
typeof e&&null===b.stateNode)throw Error(u(166));d=lh(kh.current);lh(ih.current);ki(b)?(e=b,f=e.stateNode,d=e.memoizedProps,f[ue]=e,(e=f.nodeValue!==d)&&Ci(b)):(f=b,e=(9===d.nodeType?d:d.ownerDocument).createTextNode(e),e[ue]=f,b.stateNode=e)}break;case 11:break;case 13:G(M,b);e=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=d;break a}e=null!==e;f=!1;null===c?void 0!==b.memoizedProps.fallback&&ki(b):(d=c.memoizedState,f=null!==d,e||null===d||(d=c.child.sibling,null!==d&&(k=b.firstEffect,
null!==k?(b.firstEffect=d,d.nextEffect=k):(b.firstEffect=b.lastEffect=d,d.nextEffect=null),d.effectTag=8)));if(e&&!f&&0!==(b.mode&2))if(null===c&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))X===qj&&(X=tj);else{if(X===qj||X===tj)X=uj;0!==Aj&&null!==U&&(Mj(U,W),Nj(U,Aj))}if(e||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:nh(b);Ii(b);break;case 10:tg(b);break;case 9:break;case 14:break;case 17:L(b.type)&&Ff(b);break;case 19:G(M,b);e=b.memoizedState;if(null===
e)break;f=0!==(b.effectTag&64);k=e.rendering;if(null===k)if(f)Li(e,!1);else{if(X!==qj||null!==c&&0!==(c.effectTag&64))for(c=b.child;null!==c;){k=qh(c);if(null!==k){b.effectTag|=64;Li(e,!1);f=k.updateQueue;null!==f&&(b.updateQueue=f,b.effectTag|=4);null===e.lastEffect&&(b.firstEffect=null);b.lastEffect=e.lastEffect;e=d;for(f=b.child;null!==f;)d=f,c=e,d.effectTag&=2,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null,k=d.alternate,null===k?(d.childExpirationTime=0,d.expirationTime=c,d.child=null,
d.memoizedProps=null,d.memoizedState=null,d.updateQueue=null,d.dependencies=null):(d.childExpirationTime=k.childExpirationTime,d.expirationTime=k.expirationTime,d.child=k.child,d.memoizedProps=k.memoizedProps,d.memoizedState=k.memoizedState,d.updateQueue=k.updateQueue,c=k.dependencies,d.dependencies=null===c?null:{expirationTime:c.expirationTime,firstContext:c.firstContext,responders:c.responders}),f=f.sibling;I(M,M.current&1|2,b);b=b.child;break a}c=c.sibling}}else{if(!f)if(c=qh(k),null!==c){if(b.effectTag|=
64,f=!0,d=c.updateQueue,null!==d&&(b.updateQueue=d,b.effectTag|=4),Li(e,!0),null===e.tail&&"hidden"===e.tailMode){b=b.lastEffect=e.lastEffect;null!==b&&(b.nextEffect=null);break}}else cg()>e.tailExpiration&&1<d&&(b.effectTag|=64,f=!0,Li(e,!1),b.expirationTime=b.childExpirationTime=d-1);e.isBackwards?(k.sibling=b.child,b.child=k):(d=e.last,null!==d?d.sibling=k:b.child=k,e.last=k)}if(null!==e.tail){0===e.tailExpiration&&(e.tailExpiration=cg()+500);d=e.tail;e.rendering=d;e.tail=d.sibling;e.lastEffect=
b.lastEffect;d.sibling=null;e=M.current;e=f?e&1|2:e&1;I(M,e,b);b=d;break a}break;case 20:break;case 21:break;default:throw Error(u(156,b.tag));}b=null}e=V;if(1===W||1!==e.childExpirationTime){f=0;for(d=e.child;null!==d;)c=d.expirationTime,k=d.childExpirationTime,c>f&&(f=c),k>f&&(f=k),d=d.sibling;e.childExpirationTime=f}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=V.firstEffect),null!==V.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=V.firstEffect),
a.lastEffect=V.lastEffect),1<V.effectTag&&(null!==a.lastEffect?a.lastEffect.nextEffect=V:a.firstEffect=V,a.lastEffect=V))}else{b=Mi(V,W);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=V.sibling;if(null!==b)return b;V=a}while(null!==V);X===qj&&(X=vj);return null}function Xj(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Yj(a){var b=dg();fg(99,ik.bind(null,a,b));return null}
function ik(a,b){Sj();if((T&(oj|pj))!==S)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Xj(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=d-1);d<=a.lastPingedTime&&
(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===U&&(V=U=null,W=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=T;T|=pj;mj.current=null;le=Ld;var g=fe();if(ge(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,m=k.focusNode;k=k.focusOffset;
try{h.nodeType,m.nodeType}catch(Db){h=null;break a}var C=0,y=-1,H=-1,z=0,ta=0,r=g,x=null;b:for(;;){for(var A;;){r!==h||0!==l&&3!==r.nodeType||(y=C+l);r!==m||0!==k&&3!==r.nodeType||(H=C+k);3===r.nodeType&&(C+=r.nodeValue.length);if(null===(A=r.firstChild))break;x=r;r=A}for(;;){if(r===g)break b;x===h&&++z===l&&(y=C);x===m&&++ta===k&&(H=C);if(null!==(A=r.nextSibling))break;r=x;x=r.parentNode}r=A}h=-1===y||-1===H?null:{start:y,end:H}}else h=null}h=h||{start:0,end:0}}else h=null;me={focusedElem:g,selectionRange:h};
Ld=!1;Y=e;do try{jk()}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var p=Y.effectTag;p&16&&Tb(Y.stateNode,"");if(p&128){var t=Y.alternate;if(null!==t){var v=t.ref;null!==v&&("function"===typeof v?v(null):v.current=null)}}switch(p&1038){case 2:$i(Y);Y.effectTag&=-3;break;case 6:$i(Y);Y.effectTag&=-3;aj(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=-1025;aj(Y.alternate,Y);break;case 4:aj(Y.alternate,
Y);break;case 8:l=Y,Xi(g,l,h),Yi(l)}Y=Y.nextEffect}}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);v=me;t=fe();p=v.focusedElem;h=v.selectionRange;if(t!==p&&p&&p.ownerDocument&&ee(p.ownerDocument.documentElement,p)){null!==h&&ge(p)&&(t=h.start,v=h.end,void 0===v&&(v=t),"selectionStart"in p?(p.selectionStart=t,p.selectionEnd=Math.min(v,p.value.length)):(v=(t=p.ownerDocument||document)&&t.defaultView||window,v.getSelection&&(v=v.getSelection(),l=p.textContent.length,
g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!v.extend&&g>h&&(l=h,h=g,g=l),l=de(p,g),m=de(p,h),l&&m&&(1!==v.rangeCount||v.anchorNode!==l.node||v.anchorOffset!==l.offset||v.focusNode!==m.node||v.focusOffset!==m.offset)&&(t=t.createRange(),t.setStart(l.node,l.offset),v.removeAllRanges(),g>h?(v.addRange(t),v.extend(m.node,m.offset)):(t.setEnd(m.node,m.offset),v.addRange(t))))));t=[];for(v=p;v=v.parentNode;)1===v.nodeType&&t.push({element:v,left:v.scrollLeft,top:v.scrollTop});"function"===
typeof p.focus&&p.focus();for(p=0;p<t.length;p++)v=t[p],v.element.scrollLeft=v.left,v.element.scrollTop=v.top}me=null;Ld=!!le;le=null;a.current=c;Y=e;do try{for(p=d;null!==Y;){var Dh=Y.effectTag;if(Dh&36){var cc=Y.alternate;t=Y;v=p;switch(t.tag){case 0:case 11:case 15:Ui(16,32,t);break;case 1:var dd=t.stateNode;if(t.effectTag&4)if(null===cc)dd.componentDidMount();else{var hk=t.elementType===t.type?cc.memoizedProps:mg(t.type,cc.memoizedProps);dd.componentDidUpdate(hk,cc.memoizedState,dd.__reactInternalSnapshotBeforeUpdate)}var Eh=
t.updateQueue;null!==Eh&&Kg(t,Eh,dd,v);break;case 3:var Fh=t.updateQueue;if(null!==Fh){g=null;if(null!==t.child)switch(t.child.tag){case 5:g=t.child.stateNode;break;case 1:g=t.child.stateNode}Kg(t,Fh,g,v)}break;case 5:var xk=t.stateNode;null===cc&&t.effectTag&4&&ne(t.type,t.memoizedProps)&&xk.focus();break;case 6:break;case 4:break;case 12:break;case 13:if(null===t.memoizedState){var Di=t.alternate;if(null!==Di){var Ei=Di.memoizedState;if(null!==Ei){var Fi=Ei.dehydrated;null!==Fi&&Lc(Fi)}}}break;
case 19:case 17:case 20:case 21:break;default:throw Error(u(163));}}if(Dh&128){t=void 0;var wd=Y.ref;if(null!==wd){var Gi=Y.stateNode;switch(Y.tag){case 5:t=Gi;break;default:t=Gi}"function"===typeof wd?wd(t):wd.current=t}}Y=Y.nextEffect}}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);Y=null;Yf();T=f}else a.current=c;if(Dj)Dj=!1,Ej=a,Fj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(jj=null);1073741823===b?a===Ij?Hj++:(Hj=
0,Ij=a):Hj=0;"function"===typeof kk&&kk(c.stateNode,d);Z(a);if(gj)throw gj=!1,a=hj,hj=null,a;if((T&nj)!==S)return null;jg();return null}function jk(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Ti(Y.alternate,Y);0===(a&512)||Dj||(Dj=!0,gg(97,function(){Sj();return null}));Y=Y.nextEffect}}function Sj(){if(90!==Fj){var a=97<Fj?97:Fj;Fj=90;return fg(a,lk)}}
function lk(){if(null===Ej)return!1;var a=Ej;Ej=null;if((T&(oj|pj))!==S)throw Error(u(331));var b=T;T|=pj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:Ui(128,0,c),Ui(0,64,c)}}catch(d){if(null===a)throw Error(u(330));Ri(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}T=b;jg();return!0}function mk(a,b,c){b=Ni(c,b);b=fj(a,b,1073741823);Dg(a,b);a=Kj(a,1073741823);null!==a&&Z(a)}
function Ri(a,b){if(3===a.tag)mk(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){mk(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===jj||!jj.has(d))){a=Ni(b,a);a=ij(c,a,1073741823);Dg(c,a);c=Kj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function dk(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);U===a&&W===c?X===uj||X===tj&&1073741823===xj&&cg()-bj<Cj?Tj(a,W):Bj=!0:Pj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,a.finishedExpirationTime===c&&(a.finishedExpirationTime=0,a.finishedWork=null),Z(a)))}function dj(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Pg(),b=Qg(b,a,null));a=Kj(a,b);null!==a&&Z(a)}var gk;
gk=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)wg=!0;else{if(d<c){wg=!1;switch(b.tag){case 3:wi(b);li();break;case 5:oh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Jf(b);break;case 4:mh(b,b.stateNode.containerInfo);break;case 10:sg(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return yi(a,b,c);I(M,M.current&
1,b);b=oi(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1,b);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return Bi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current,b);if(!d)return null}return oi(a,b,c)}wg=!1}}else wg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Ef(b,J.current);vg(b,c);e=Ih(null,b,d,a,e,c);b.effectTag|=1;if("object"===
typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;Mh();if(L(d)){var f=!0;Jf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&Og(b,d,g,a);e.updater=Sg;b.stateNode=e;e._reactInternalFiber=b;Wg(b,d,a,c);b=vi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;Va(e);if(1!==e._status)throw e._result;
e=e._result;b.type=e;f=b.tag=nk(e);a=mg(e,a);switch(f){case 0:b=si(null,b,e,a,c);break;case 1:b=ui(null,b,e,a,c);break;case 11:b=ni(null,b,e,a,c);break;case 14:b=pi(null,b,e,mg(e.type,a),d,c);break;default:throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),si(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),ui(a,b,d,e,c);case 3:wi(b);d=b.updateQueue;if(null===d)throw Error(u(282));e=b.memoizedState;e=null!==e?e.element:
null;Hg(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)li(),b=oi(a,b,c);else{if(e=b.stateNode.hydrate)di=re(b.stateNode.containerInfo.firstChild),ci=b,e=ei=!0;if(e)for(c=gh(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),li();b=b.child}return b;case 5:return oh(b),null===a&&ii(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,oe(d,e)?g=null:null!==f&&oe(d,f)&&(b.effectTag|=16),ti(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=
b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&ii(b),null;case 13:return yi(a,b,c);case 4:return mh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=fh(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),ni(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;
e=b.pendingProps;g=b.memoizedProps;f=e.value;sg(b,f);if(null!==g){var h=g.value;f=of(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!K.current){b=oi(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=Bg(c,null),l.tag=2,Dg(h,l));h.expirationTime<c&&(h.expirationTime=
c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);ug(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,vg(b,c),e=xg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;
case 14:return e=b.type,f=mg(e,b.pendingProps),f=mg(e.type,f),pi(a,b,e,f,d,c);case 15:return ri(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Jf(b)):a=!1,vg(b,c),Ug(b,d,e,c),Wg(b,d,e,c),vi(null,b,d,!0,a,c);case 19:return Bi(a,b,c)}throw Error(u(156,b.tag));};var kk=null,Wi=null;
function ok(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);kk=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Wi=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function pk(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function gi(a,b,c,d){return new pk(a,b,c,d)}
function qi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function nk(a){if("function"===typeof a)return qi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===Oa)return 11;if(a===Ra)return 14}return 2}
function ah(a,b){var c=a.alternate;null===c?(c=gi(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function ch(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)qi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Ia:return eh(c.children,e,f,b);case Na:g=8;e|=7;break;case Ja:g=8;e|=1;break;case Ka:return a=gi(12,c,b,e|8),a.elementType=Ka,a.type=Ka,a.expirationTime=f,a;case Pa:return a=gi(13,c,b,e),a.type=Pa,a.elementType=Pa,a.expirationTime=f,a;case Qa:return a=gi(19,c,b,e),a.elementType=Qa,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case La:g=
10;break a;case Ma:g=9;break a;case Oa:g=11;break a;case Ra:g=14;break a;case Sa:g=16;d=null;break a}throw Error(u(130,null==a?a:typeof a,""));}b=gi(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function eh(a,b,c,d){a=gi(7,a,d,b);a.expirationTime=c;return a}function bh(a,b,c){a=gi(6,a,null,b);a.expirationTime=c;return a}
function dh(a,b,c){b=gi(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function qk(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Pj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function Mj(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function Nj(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Rj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function rk(a,b,c,d){var e=b.current,f=Pg(),g=Mg.suspense;f=Qg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(ec(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=If(c,k,h);break a}}c=h}else c=Cf;null===b.context?b.context=c:b.pendingContext=c;b=Bg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);Dg(e,b);Rg(e,f);return f}function sk(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function tk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function uk(a,b){tk(a,b);(a=a.alternate)&&tk(a,b)}
function vk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ha,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}jc=function(a){if(13===a.tag){var b=lg(Pg(),150,100);Rg(a,b);uk(a,b)}};kc=function(a){if(13===a.tag){Pg();var b=kg++;Rg(a,b);uk(a,b)}};lc=function(a){if(13===a.tag){var b=Pg();b=Qg(b,a,null);Rg(a,b);uk(a,b)}};
Za=function(a,b,c){switch(b){case "input":Eb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=ye(d);if(!e)throw Error(u(90));zb(d);Eb(d,e)}}}break;case "textarea":Mb(a,c);break;case "select":b=c.value,null!=b&&Jb(a,!!c.multiple,b,!1)}};
function wk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new qk(a,b,c),e=gi(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;a[we]=d.current;c&&0!==b&&wc(9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}wk.prototype.render=function(a,b){var c=this._internalRoot;rk(a,c,null,void 0===b?null:b)};wk.prototype.unmount=function(a){var b=this._internalRoot;rk(null,b,null,void 0===a?null:a)};
function yk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}eb=bk;fb=function(a,b,c,d){var e=T;T|=4;try{return fg(98,a.bind(null,b,c,d))}finally{T=e,T===S&&jg()}};gb=function(){(T&(1|oj|pj))===S&&(ak(),Sj())};hb=function(a,b){var c=T;T|=2;try{return a(b)}finally{T=c,T===S&&jg()}};
function zk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new wk(a,0,b?{hydrate:!0}:void 0)}
function Ak(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=sk(g);h.call(a)}}rk(b,g,a,e)}else{f=c._reactRootContainer=zk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=sk(g);k.call(a)}}ck(function(){rk(b,g,a,e)})}return sk(g)}function Bk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!yk(b))throw Error(u(200));return vk(a,b,null,c)}
var Ck={createPortal:Bk,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=ic(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){if(!yk(b))throw Error(u(200));return Ak(null,a,b,!0,c)},render:function(a,b,c){if(!yk(b))throw Error(u(200));return Ak(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){if(!yk(c))throw Error(u(200));
if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return Ak(a,b,c,!1,d)},unmountComponentAtNode:function(a){if(!yk(a))throw Error(u(40));return a._reactRootContainer?(ck(function(){Ak(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Bk.apply(void 0,arguments)},unstable_batchedUpdates:bk,flushSync:function(a,b){if((T&(oj|pj))!==S)throw Error(u(187));var c=T;T|=1;try{return fg(99,a.bind(null,b))}finally{T=c,jg()}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Cc,
xe,ye,Ca.injectEventPluginsByName,fa,Sc,function(a){ya(a,Rc)},cb,db,Pd,Ba,Sj,{current:!1}]}};
(function(a){var b=a.findFiberByHostInstance;return ok(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Ea.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=ic(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:Fc,bundleType:0,version:"16.11.0",
rendererPackageName:"react-dom"});var Dk={default:Ck},Ek=Dk&&Ck||Dk;module.exports=Ek.default||Ek;


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(889);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.17.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout,A=window.requestAnimationFrame,B=window.cancelAnimationFrame;"undefined"!==typeof console&&("function"!==typeof A&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),"function"!==typeof B&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));if("object"===typeof w&&
"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var C=x.now();exports.unstable_now=function(){return x.now()-C}}var D=!1,E=null,F=-1,G=5,H=0;k=function(){return exports.unstable_now()>=H};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):G=0<a?Math.floor(1E3/a):33.33};var I=new MessageChannel,J=I.port2;I.port1.onmessage=
function(){if(null!==E){var a=exports.unstable_now();H=a+G;try{E(!0,a)?J.postMessage(null):(D=!1,E=null)}catch(b){throw J.postMessage(null),b;}}else D=!1};f=function(a){E=a;D||(D=!0,J.postMessage(null))};g=function(a,b){F=y(function(){a(exports.unstable_now())},b)};h=function(){z(F);F=-1}}function K(a,b){var c=a.length;a.push(b);a:for(;;){var d=Math.floor((c-1)/2),e=a[d];if(void 0!==e&&0<L(e,b))a[d]=b,a[c]=e,c=d;else break a}}function M(a){a=a[0];return void 0===a?null:a}
function N(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>L(n,c))void 0!==r&&0>L(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>L(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function L(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var O=[],P=[],Q=1,R=null,S=3,T=!1,U=!1,V=!1;
function W(a){for(var b=M(P);null!==b;){if(null===b.callback)N(P);else if(b.startTime<=a)N(P),b.sortIndex=b.expirationTime,K(O,b);else break;b=M(P)}}function X(a){V=!1;W(a);if(!U)if(null!==M(O))U=!0,f(Y);else{var b=M(P);null!==b&&g(X,b.startTime-a)}}
function Y(a,b){U=!1;V&&(V=!1,h());T=!0;var c=S;try{W(b);for(R=M(O);null!==R&&(!(R.expirationTime>b)||a&&!k());){var d=R.callback;if(null!==d){R.callback=null;S=R.priorityLevel;var e=d(R.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?R.callback=e:R===M(O)&&N(O);W(b)}else N(O);R=M(O)}if(null!==R)var m=!0;else{var n=M(P);null!==n&&g(X,n.startTime-b);m=!1}return m}finally{R=null,S=c,T=!1}}
function Z(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var aa=l;exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=S;S=a;try{return b()}finally{S=c}};
exports.unstable_next=function(a){switch(S){case 1:case 2:case 3:var b=3;break;default:b=S}var c=S;S=b;try{return a()}finally{S=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Z(a)}else c=Z(a),e=d;c=e+c;a={id:Q++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,K(P,a),null===M(O)&&a===M(P)&&(V?h():V=!0,g(X,e-d))):(a.sortIndex=c,K(O,a),U||T||(U=!0,f(Y)));return a};exports.unstable_cancelCallback=function(a){a.callback=null};
exports.unstable_wrapCallback=function(a){var b=S;return function(){var c=S;S=b;try{return a.apply(this,arguments)}finally{S=c}}};exports.unstable_getCurrentPriorityLevel=function(){return S};exports.unstable_shouldYield=function(){var a=exports.unstable_now();W(a);var b=M(O);return b!==R&&null!==R&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<R.expirationTime||k()};exports.unstable_requestPaint=aa;exports.unstable_continueExecution=function(){U||T||(U=!0,f(Y))};
exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return M(O)};exports.unstable_Profiling=null;


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(891);

var _global = _interopRequireDefault(__webpack_require__(1063));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

if (_global["default"]._babelPolyfill && typeof console !== "undefined" && console.warn) {
  console.warn("@babel/polyfill is loaded more than once on this page. This is probably not desirable/intended " + "and may have consequences if different versions of the polyfills are applied sequentially. " + "If you do need to load the polyfill more than once, use @babel/polyfill/noConflict " + "instead to bypass the warning.");
}

_global["default"]._babelPolyfill = true;

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(892);

__webpack_require__(1035);

__webpack_require__(1037);

__webpack_require__(1040);

__webpack_require__(1042);

__webpack_require__(1044);

__webpack_require__(1046);

__webpack_require__(1048);

__webpack_require__(1050);

__webpack_require__(1052);

__webpack_require__(1054);

__webpack_require__(1056);

__webpack_require__(1058);

__webpack_require__(1062);

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(893);
__webpack_require__(896);
__webpack_require__(897);
__webpack_require__(898);
__webpack_require__(899);
__webpack_require__(900);
__webpack_require__(901);
__webpack_require__(902);
__webpack_require__(903);
__webpack_require__(904);
__webpack_require__(905);
__webpack_require__(906);
__webpack_require__(907);
__webpack_require__(908);
__webpack_require__(909);
__webpack_require__(910);
__webpack_require__(911);
__webpack_require__(912);
__webpack_require__(913);
__webpack_require__(914);
__webpack_require__(915);
__webpack_require__(916);
__webpack_require__(917);
__webpack_require__(918);
__webpack_require__(919);
__webpack_require__(920);
__webpack_require__(921);
__webpack_require__(922);
__webpack_require__(923);
__webpack_require__(924);
__webpack_require__(925);
__webpack_require__(926);
__webpack_require__(927);
__webpack_require__(928);
__webpack_require__(929);
__webpack_require__(930);
__webpack_require__(931);
__webpack_require__(932);
__webpack_require__(933);
__webpack_require__(934);
__webpack_require__(935);
__webpack_require__(936);
__webpack_require__(937);
__webpack_require__(939);
__webpack_require__(940);
__webpack_require__(941);
__webpack_require__(942);
__webpack_require__(943);
__webpack_require__(944);
__webpack_require__(945);
__webpack_require__(946);
__webpack_require__(947);
__webpack_require__(948);
__webpack_require__(949);
__webpack_require__(950);
__webpack_require__(951);
__webpack_require__(952);
__webpack_require__(953);
__webpack_require__(954);
__webpack_require__(955);
__webpack_require__(956);
__webpack_require__(957);
__webpack_require__(958);
__webpack_require__(959);
__webpack_require__(960);
__webpack_require__(961);
__webpack_require__(962);
__webpack_require__(963);
__webpack_require__(964);
__webpack_require__(965);
__webpack_require__(966);
__webpack_require__(967);
__webpack_require__(968);
__webpack_require__(969);
__webpack_require__(970);
__webpack_require__(971);
__webpack_require__(972);
__webpack_require__(974);
__webpack_require__(975);
__webpack_require__(977);
__webpack_require__(978);
__webpack_require__(979);
__webpack_require__(980);
__webpack_require__(981);
__webpack_require__(982);
__webpack_require__(983);
__webpack_require__(985);
__webpack_require__(986);
__webpack_require__(987);
__webpack_require__(988);
__webpack_require__(989);
__webpack_require__(990);
__webpack_require__(991);
__webpack_require__(992);
__webpack_require__(993);
__webpack_require__(994);
__webpack_require__(995);
__webpack_require__(996);
__webpack_require__(997);
__webpack_require__(338);
__webpack_require__(998);
__webpack_require__(468);
__webpack_require__(999);
__webpack_require__(469);
__webpack_require__(1000);
__webpack_require__(1001);
__webpack_require__(1002);
__webpack_require__(1003);
__webpack_require__(470);
__webpack_require__(1006);
__webpack_require__(1007);
__webpack_require__(1008);
__webpack_require__(1009);
__webpack_require__(1010);
__webpack_require__(1011);
__webpack_require__(1012);
__webpack_require__(1013);
__webpack_require__(1014);
__webpack_require__(1015);
__webpack_require__(1016);
__webpack_require__(1017);
__webpack_require__(1018);
__webpack_require__(1019);
__webpack_require__(1020);
__webpack_require__(1021);
__webpack_require__(1022);
__webpack_require__(1023);
__webpack_require__(1024);
__webpack_require__(1025);
__webpack_require__(1026);
__webpack_require__(1027);
__webpack_require__(1028);
__webpack_require__(1029);
__webpack_require__(1030);
__webpack_require__(1031);
__webpack_require__(1032);
__webpack_require__(1033);
__webpack_require__(1034);
module.exports = __webpack_require__(36);


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(17);
var has = __webpack_require__(68);
var DESCRIPTORS = __webpack_require__(40);
var $export = __webpack_require__(5);
var redefine = __webpack_require__(59);
var META = __webpack_require__(110).KEY;
var $fails = __webpack_require__(18);
var shared = __webpack_require__(237);
var setToStringTag = __webpack_require__(162);
var uid = __webpack_require__(132);
var wks = __webpack_require__(28);
var wksExt = __webpack_require__(319);
var wksDefine = __webpack_require__(449);
var enumKeys = __webpack_require__(895);
var isArray = __webpack_require__(240);
var anObject = __webpack_require__(19);
var isObject = __webpack_require__(20);
var toObject = __webpack_require__(49);
var toIObject = __webpack_require__(70);
var toPrimitive = __webpack_require__(109);
var createDesc = __webpack_require__(131);
var _create = __webpack_require__(136);
var gOPNExt = __webpack_require__(452);
var $GOPD = __webpack_require__(87);
var $GOPS = __webpack_require__(239);
var $DP = __webpack_require__(41);
var $keys = __webpack_require__(134);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(137).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(205).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(133)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(69)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(237)('native-function-to-string', Function.toString);


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(134);
var gOPS = __webpack_require__(239);
var pIE = __webpack_require__(205);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(136) });


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(40), 'Object', { defineProperty: __webpack_require__(41).f });


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(40), 'Object', { defineProperties: __webpack_require__(451) });


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(70);
var $getOwnPropertyDescriptor = __webpack_require__(87).f;

__webpack_require__(88)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(49);
var $getPrototypeOf = __webpack_require__(138);

__webpack_require__(88)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(49);
var $keys = __webpack_require__(134);

__webpack_require__(88)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(88)('getOwnPropertyNames', function () {
  return __webpack_require__(452).f;
});


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(20);
var meta = __webpack_require__(110).onFreeze;

__webpack_require__(88)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(20);
var meta = __webpack_require__(110).onFreeze;

__webpack_require__(88)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(20);
var meta = __webpack_require__(110).onFreeze;

__webpack_require__(88)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(20);

__webpack_require__(88)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(20);

__webpack_require__(88)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(20);

__webpack_require__(88)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(5);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(453) });


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(5);
$export($export.S, 'Object', { is: __webpack_require__(454) });


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(5);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(323).set });


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(206);
var test = {};
test[__webpack_require__(28)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(59)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(5);

$export($export.P, 'Function', { bind: __webpack_require__(455) });


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(41).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(40) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(20);
var getPrototypeOf = __webpack_require__(138);
var HAS_INSTANCE = __webpack_require__(28)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(41).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
var $parseInt = __webpack_require__(457);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
var $parseFloat = __webpack_require__(458);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(17);
var has = __webpack_require__(68);
var cof = __webpack_require__(96);
var inheritIfRequired = __webpack_require__(325);
var toPrimitive = __webpack_require__(109);
var fails = __webpack_require__(18);
var gOPN = __webpack_require__(137).f;
var gOPD = __webpack_require__(87).f;
var dP = __webpack_require__(41).f;
var $trim = __webpack_require__(163).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(136)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(40) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(59)(global, NUMBER, $Number);
}


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var toInteger = __webpack_require__(86);
var aNumberValue = __webpack_require__(459);
var repeat = __webpack_require__(326);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(18)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $fails = __webpack_require__(18);
var aNumberValue = __webpack_require__(459);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(5);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(5);
var _isFinite = __webpack_require__(17).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(5);

$export($export.S, 'Number', { isInteger: __webpack_require__(460) });


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(5);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(5);
var isInteger = __webpack_require__(460);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(5);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(5);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
var $parseFloat = __webpack_require__(458);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
var $parseInt = __webpack_require__(457);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(5);
var log1p = __webpack_require__(461);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(5);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(5);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(5);
var sign = __webpack_require__(327);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(5);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(5);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(5);
var $expm1 = __webpack_require__(328);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(5);

$export($export.S, 'Math', { fround: __webpack_require__(938) });


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(327);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(5);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(5);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(18)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(5);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(5);

$export($export.S, 'Math', { log1p: __webpack_require__(461) });


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(5);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(5);

$export($export.S, 'Math', { sign: __webpack_require__(327) });


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(5);
var expm1 = __webpack_require__(328);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(18)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(5);
var expm1 = __webpack_require__(328);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(5);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
var toAbsoluteIndex = __webpack_require__(135);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
var toIObject = __webpack_require__(70);
var toLength = __webpack_require__(32);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(163)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(329)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(330)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $at = __webpack_require__(329)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(5);
var toLength = __webpack_require__(32);
var context = __webpack_require__(331);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(333)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(5);
var context = __webpack_require__(331);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(333)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(326)
});


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(5);
var toLength = __webpack_require__(32);
var context = __webpack_require__(331);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(333)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(60)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(60)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(60)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(60)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(60)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(60)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(60)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(60)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(60)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(60)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(60)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(60)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(60)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(5);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var toObject = __webpack_require__(49);
var toPrimitive = __webpack_require__(109);

$export($export.P + $export.F * __webpack_require__(18)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(5);
var toISOString = __webpack_require__(973);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(18);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(59)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(28)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(69)(proto, TO_PRIMITIVE, __webpack_require__(976));


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(19);
var toPrimitive = __webpack_require__(109);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(5);

$export($export.S, 'Array', { isArray: __webpack_require__(240) });


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(84);
var $export = __webpack_require__(5);
var toObject = __webpack_require__(49);
var call = __webpack_require__(463);
var isArrayIter = __webpack_require__(334);
var toLength = __webpack_require__(32);
var createProperty = __webpack_require__(335);
var getIterFn = __webpack_require__(336);

$export($export.S + $export.F * !__webpack_require__(241)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var createProperty = __webpack_require__(335);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(18)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(5);
var toIObject = __webpack_require__(70);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(204) != Object || !__webpack_require__(81)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var html = __webpack_require__(322);
var cof = __webpack_require__(96);
var toAbsoluteIndex = __webpack_require__(135);
var toLength = __webpack_require__(32);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(18)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var aFunction = __webpack_require__(85);
var toObject = __webpack_require__(49);
var fails = __webpack_require__(18);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(81)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $forEach = __webpack_require__(89)(0);
var STRICT = __webpack_require__(81)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
var isArray = __webpack_require__(240);
var SPECIES = __webpack_require__(28)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $map = __webpack_require__(89)(1);

$export($export.P + $export.F * !__webpack_require__(81)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $filter = __webpack_require__(89)(2);

$export($export.P + $export.F * !__webpack_require__(81)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $some = __webpack_require__(89)(3);

$export($export.P + $export.F * !__webpack_require__(81)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $every = __webpack_require__(89)(4);

$export($export.P + $export.F * !__webpack_require__(81)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $reduce = __webpack_require__(465);

$export($export.P + $export.F * !__webpack_require__(81)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $reduce = __webpack_require__(465);

$export($export.P + $export.F * !__webpack_require__(81)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $indexOf = __webpack_require__(238)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(81)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var toIObject = __webpack_require__(70);
var toInteger = __webpack_require__(86);
var toLength = __webpack_require__(32);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(81)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(5);

$export($export.P, 'Array', { copyWithin: __webpack_require__(466) });

__webpack_require__(139)('copyWithin');


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(5);

$export($export.P, 'Array', { fill: __webpack_require__(337) });

__webpack_require__(139)('fill');


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(5);
var $find = __webpack_require__(89)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(139)(KEY);


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(5);
var $find = __webpack_require__(89)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(139)(KEY);


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(165)('Array');


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(17);
var inheritIfRequired = __webpack_require__(325);
var dP = __webpack_require__(41).f;
var gOPN = __webpack_require__(137).f;
var isRegExp = __webpack_require__(332);
var $flags = __webpack_require__(242);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(40) && (!CORRECT_NEW || __webpack_require__(18)(function () {
  re2[__webpack_require__(28)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(59)(global, 'RegExp', $RegExp);
}

__webpack_require__(165)('RegExp');


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(469);
var anObject = __webpack_require__(19);
var $flags = __webpack_require__(242);
var DESCRIPTORS = __webpack_require__(40);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(59)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(18)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(19);
var toLength = __webpack_require__(32);
var advanceStringIndex = __webpack_require__(340);
var regExpExec = __webpack_require__(243);

// @@match logic
__webpack_require__(244)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(19);
var toObject = __webpack_require__(49);
var toLength = __webpack_require__(32);
var toInteger = __webpack_require__(86);
var advanceStringIndex = __webpack_require__(340);
var regExpExec = __webpack_require__(243);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(244)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(19);
var sameValue = __webpack_require__(454);
var regExpExec = __webpack_require__(243);

// @@search logic
__webpack_require__(244)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(332);
var anObject = __webpack_require__(19);
var speciesConstructor = __webpack_require__(207);
var advanceStringIndex = __webpack_require__(340);
var toLength = __webpack_require__(32);
var callRegExpExec = __webpack_require__(243);
var regexpExec = __webpack_require__(339);
var fails = __webpack_require__(18);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(244)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(17);
var macrotask = __webpack_require__(341).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(96)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 1005 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(473);
var validate = __webpack_require__(140);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(247)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(473);
var validate = __webpack_require__(140);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(247)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(17);
var each = __webpack_require__(89)(0);
var redefine = __webpack_require__(59);
var meta = __webpack_require__(110);
var assign = __webpack_require__(453);
var weak = __webpack_require__(474);
var isObject = __webpack_require__(20);
var validate = __webpack_require__(140);
var NATIVE_WEAK_MAP = __webpack_require__(140);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(247)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(474);
var validate = __webpack_require__(140);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(247)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $typed = __webpack_require__(248);
var buffer = __webpack_require__(342);
var anObject = __webpack_require__(19);
var toAbsoluteIndex = __webpack_require__(135);
var toLength = __webpack_require__(32);
var isObject = __webpack_require__(20);
var ArrayBuffer = __webpack_require__(17).ArrayBuffer;
var speciesConstructor = __webpack_require__(207);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(18)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(165)(ARRAY_BUFFER);


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
$export($export.G + $export.W + $export.F * !__webpack_require__(248).ABV, {
  DataView: __webpack_require__(342).DataView
});


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(98)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(98)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(98)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(98)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(98)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(98)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(98)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(98)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(98)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(5);
var aFunction = __webpack_require__(85);
var anObject = __webpack_require__(19);
var rApply = (__webpack_require__(17).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(18)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(5);
var create = __webpack_require__(136);
var aFunction = __webpack_require__(85);
var anObject = __webpack_require__(19);
var isObject = __webpack_require__(20);
var fails = __webpack_require__(18);
var bind = __webpack_require__(455);
var rConstruct = (__webpack_require__(17).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(41);
var $export = __webpack_require__(5);
var anObject = __webpack_require__(19);
var toPrimitive = __webpack_require__(109);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(18)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(5);
var gOPD = __webpack_require__(87).f;
var anObject = __webpack_require__(19);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(5);
var anObject = __webpack_require__(19);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(462)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(87);
var getPrototypeOf = __webpack_require__(138);
var has = __webpack_require__(68);
var $export = __webpack_require__(5);
var isObject = __webpack_require__(20);
var anObject = __webpack_require__(19);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(87);
var $export = __webpack_require__(5);
var anObject = __webpack_require__(19);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(5);
var getProto = __webpack_require__(138);
var anObject = __webpack_require__(19);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(5);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(5);
var anObject = __webpack_require__(19);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(5);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(476) });


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(5);
var anObject = __webpack_require__(19);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(41);
var gOPD = __webpack_require__(87);
var getPrototypeOf = __webpack_require__(138);
var has = __webpack_require__(68);
var $export = __webpack_require__(5);
var createDesc = __webpack_require__(131);
var anObject = __webpack_require__(19);
var isObject = __webpack_require__(20);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(5);
var setProto = __webpack_require__(323);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1036);
module.exports = __webpack_require__(36).Array.includes;


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(5);
var $includes = __webpack_require__(238)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(139)('includes');


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1038);
module.exports = __webpack_require__(36).Array.flatMap;


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(5);
var flattenIntoArray = __webpack_require__(1039);
var toObject = __webpack_require__(49);
var toLength = __webpack_require__(32);
var aFunction = __webpack_require__(85);
var arraySpeciesCreate = __webpack_require__(464);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(139)('flatMap');


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(240);
var isObject = __webpack_require__(20);
var toLength = __webpack_require__(32);
var ctx = __webpack_require__(84);
var IS_CONCAT_SPREADABLE = __webpack_require__(28)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1041);
module.exports = __webpack_require__(36).String.padStart;


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(5);
var $pad = __webpack_require__(477);
var userAgent = __webpack_require__(246);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1043);
module.exports = __webpack_require__(36).String.padEnd;


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(5);
var $pad = __webpack_require__(477);
var userAgent = __webpack_require__(246);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1045);
module.exports = __webpack_require__(36).String.trimLeft;


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(163)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1047);
module.exports = __webpack_require__(36).String.trimRight;


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(163)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1049);
module.exports = __webpack_require__(319).f('asyncIterator');


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(449)('asyncIterator');


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1051);
module.exports = __webpack_require__(36).Object.getOwnPropertyDescriptors;


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(5);
var ownKeys = __webpack_require__(476);
var toIObject = __webpack_require__(70);
var gOPD = __webpack_require__(87);
var createProperty = __webpack_require__(335);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1053);
module.exports = __webpack_require__(36).Object.values;


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(5);
var $values = __webpack_require__(478)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1055);
module.exports = __webpack_require__(36).Object.entries;


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(5);
var $entries = __webpack_require__(478)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(470);
__webpack_require__(1057);
module.exports = __webpack_require__(36).Promise['finally'];


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(5);
var core = __webpack_require__(36);
var global = __webpack_require__(17);
var speciesConstructor = __webpack_require__(207);
var promiseResolve = __webpack_require__(472);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1059);
__webpack_require__(1060);
__webpack_require__(1061);
module.exports = __webpack_require__(36);


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(17);
var $export = __webpack_require__(5);
var userAgent = __webpack_require__(246);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
var $task = __webpack_require__(341);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(338);
var getKeys = __webpack_require__(134);
var redefine = __webpack_require__(59);
var global = __webpack_require__(17);
var hide = __webpack_require__(69);
var Iterators = __webpack_require__(164);
var wks = __webpack_require__(28);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : {}
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1064);
module.exports = __webpack_require__(479).global;


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(1065);

$export($export.G, { global: __webpack_require__(343) });


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(343);
var core = __webpack_require__(479);
var ctx = __webpack_require__(1066);
var hide = __webpack_require__(1068);
var has = __webpack_require__(1075);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(1067);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 1067 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(1069);
var createDesc = __webpack_require__(1074);
module.exports = __webpack_require__(345) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(1070);
var IE8_DOM_DEFINE = __webpack_require__(1071);
var toPrimitive = __webpack_require__(1073);
var dP = Object.defineProperty;

exports.f = __webpack_require__(345) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(344);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(345) && !__webpack_require__(480)(function () {
  return Object.defineProperty(__webpack_require__(1072)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(344);
var document = __webpack_require__(343).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(344);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 1074 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 1075 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.store = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactRouterDom = __webpack_require__(13);

var _store = _interopRequireWildcard(__webpack_require__(54));

var _App = _interopRequireDefault(__webpack_require__(1284));

var _throttle = _interopRequireDefault(__webpack_require__(446));

var _Authentication = __webpack_require__(42);

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // import createStore, { history } from './store';


var loadState = function loadState() {
  try {
    var serializedState = (0, _Authentication.getStorageItem)(_Authentication.STATE);

    if (serializedState === null) {
      return undefined;
    }

    return JSON.parse(serializedState);
  } catch (e) {
    return undefined;
  }
};

var saveState = function saveState(state) {
  try {
    var serializedState = JSON.stringify(state);
    (0, _Authentication.setStorageItem)(_Authentication.STATE, serializedState);
  } catch (e) {// Ignore write errors;
  }
};

var persistedState = loadState();
var store = (0, _store["default"])(persistedState); // export const store = configureStore();
// SUBSCRIBE - Adds a change listener. It will be called any time an action is dispatched,
// and some part of the state tree may potentially have changed. 
// You may then call getState() to read the current state tree inside the callback.
// Serialization is an expensive operation. 
// Using the throttle function (by lodash) to limit the number of saves

exports.store = store;
store.subscribe((0, _throttle["default"])(function () {
  saveState(store.getState());
}, 1000));

var MainApp = function MainApp() {
  return _react["default"].createElement(_reactRedux.Provider, {
    store: store
  }, _react["default"].createElement(_reactRouterDom.Router, {
    history: _store.history
  }, _react["default"].createElement(_reactRouterDom.Switch, null, _react["default"].createElement(_reactRouterDom.Route, {
    path: "/",
    component: _App["default"]
  }))));
};

var _default = MainApp;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(loadState, "loadState", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/MainApp.js");

  __REACT_HOT_LOADER__.register(saveState, "saveState", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/MainApp.js");

  __REACT_HOT_LOADER__.register(persistedState, "persistedState", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/MainApp.js");

  __REACT_HOT_LOADER__.register(store, "store", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/MainApp.js");

  __REACT_HOT_LOADER__.register(MainApp, "MainApp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/MainApp.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/MainApp.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/MainApp.js");

  __REACT_HOT_LOADER__.register(_store, "_store", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/MainApp.js");

  __REACT_HOT_LOADER__.register(_App, "_App", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/MainApp.js");

  __REACT_HOT_LOADER__.register(_throttle, "_throttle", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/MainApp.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/MainApp.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/MainApp.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/MainApp.js");

  __REACT_HOT_LOADER__.register(loadState, "loadState", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/MainApp.js");

  __REACT_HOT_LOADER__.register(saveState, "saveState", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/MainApp.js");

  __REACT_HOT_LOADER__.register(persistedState, "persistedState", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/MainApp.js");

  __REACT_HOT_LOADER__.register(store, "store", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/MainApp.js");

  __REACT_HOT_LOADER__.register(MainApp, "MainApp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/MainApp.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/MainApp.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/MainApp.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/MainApp.js");
}();

;

/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Context__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(346);





function Provider(_ref) {
  var store = _ref.store,
      context = _ref.context,
      children = _ref.children;
  var contextValue = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    var subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](store);
    subscription.onStateChange = subscription.notifyNestedSubs;
    return {
      store: store,
      subscription: subscription
    };
  }, [store]);
  var previousState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return store.getState();
  }, [store]);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var subscription = contextValue.subscription;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return function () {
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;
    };
  }, [contextValue, previousState]);
  var Context = context || __WEBPACK_IMPORTED_MODULE_2__Context__["a" /* ReactReduxContext */];
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Context.Provider, {
    value: contextValue
  }, children);
}

if (false) {
  Provider.propTypes = {
    store: PropTypes.shape({
      subscribe: PropTypes.func.isRequired,
      dispatch: PropTypes.func.isRequired,
      getState: PropTypes.func.isRequired
    }),
    context: PropTypes.object,
    children: PropTypes.any
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Provider);

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(857);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(200);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.11.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118,x=b?Symbol.for("react.scope"):60119;function y(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case t:case r:case d:return u}}}function z(a){return y(a)===m}
exports.typeOf=y;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w||a.$$typeof===x)};exports.isAsyncMode=function(a){return z(a)||y(a)===l};exports.isConcurrentMode=z;exports.isContextConsumer=function(a){return y(a)===k};exports.isContextProvider=function(a){return y(a)===h};
exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return y(a)===n};exports.isFragment=function(a){return y(a)===e};exports.isLazy=function(a){return y(a)===t};exports.isMemo=function(a){return y(a)===r};exports.isPortal=function(a){return y(a)===d};exports.isProfiler=function(a){return y(a)===g};exports.isStrictMode=function(a){return y(a)===f};exports.isSuspense=function(a){return y(a)===p};


/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(1099);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(490);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(1086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(1087);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(1085);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(57)))

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(487);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(1089);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 1091 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(488);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(489);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(490);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(491);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, {}, stateProps, {}, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(1100);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(492);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createDispatchHook;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useDispatch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Context__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__useStore__ = __webpack_require__(493);


/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */

function createDispatchHook(context) {
  if (context === void 0) {
    context = __WEBPACK_IMPORTED_MODULE_0__components_Context__["a" /* ReactReduxContext */];
  }

  var useStore = context === __WEBPACK_IMPORTED_MODULE_0__components_Context__["a" /* ReactReduxContext */] ? __WEBPACK_IMPORTED_MODULE_1__useStore__["b" /* useStore */] : Object(__WEBPACK_IMPORTED_MODULE_1__useStore__["a" /* createStoreHook */])(context);
  return function useDispatch() {
    var store = useStore();
    return store.dispatch;
  };
}
/**
 * A hook to access the redux `dispatch` function.
 *
 * @returns {any|function} redux store's `dispatch` function
 *
 * @example
 *
 * import React, { useCallback } from 'react'
 * import { useDispatch } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const dispatch = useDispatch()
 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={increaseCounter}>Increase counter</button>
 *     </div>
 *   )
 * }
 */

var useDispatch =
/*#__PURE__*/
createDispatchHook();

/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSelectorHook;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__useReduxContext__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_Subscription__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_useIsomorphicLayoutEffect__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Context__ = __webpack_require__(141);






var refEquality = function refEquality(a, b) {
  return a === b;
};

function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
  var _useReducer = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(function (s) {
    return s + 1;
  }, 0),
      forceRender = _useReducer[1];

  var subscription = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return new __WEBPACK_IMPORTED_MODULE_2__utils_Subscription__["a" /* default */](store, contextSub);
  }, [store, contextSub]);
  var latestSubscriptionCallbackError = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var latestSelector = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var latestSelectedState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var selectedState;

  try {
    if (selector !== latestSelector.current || latestSubscriptionCallbackError.current) {
      selectedState = selector(store.getState());
    } else {
      selectedState = latestSelectedState.current;
    }
  } catch (err) {
    if (latestSubscriptionCallbackError.current) {
      err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
    }

    throw err;
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_useIsomorphicLayoutEffect__["a" /* useIsomorphicLayoutEffect */])(function () {
    latestSelector.current = selector;
    latestSelectedState.current = selectedState;
    latestSubscriptionCallbackError.current = undefined;
  });
  Object(__WEBPACK_IMPORTED_MODULE_3__utils_useIsomorphicLayoutEffect__["a" /* useIsomorphicLayoutEffect */])(function () {
    function checkForUpdates() {
      try {
        var newSelectedState = latestSelector.current(store.getState());

        if (equalityFn(newSelectedState, latestSelectedState.current)) {
          return;
        }

        latestSelectedState.current = newSelectedState;
      } catch (err) {
        // we ignore all errors here, since when the component
        // is re-rendered, the selectors are called again, and
        // will throw again, if neither props nor store state
        // changed
        latestSubscriptionCallbackError.current = err;
      }

      forceRender({});
    }

    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    return function () {
      return subscription.tryUnsubscribe();
    };
  }, [store, subscription]);
  return selectedState;
}
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */


function createSelectorHook(context) {
  if (context === void 0) {
    context = __WEBPACK_IMPORTED_MODULE_4__components_Context__["a" /* ReactReduxContext */];
  }

  var useReduxContext = context === __WEBPACK_IMPORTED_MODULE_4__components_Context__["a" /* ReactReduxContext */] ? __WEBPACK_IMPORTED_MODULE_1__useReduxContext__["a" /* useReduxContext */] : function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(context);
  };
  return function useSelector(selector, equalityFn) {
    if (equalityFn === void 0) {
      equalityFn = refEquality;
    }

    if (false) {
      throw new Error("You must pass a selector to useSelectors");
    }

    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store,
        contextSub = _useReduxContext.subscription;

    return useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
  };
}
/**
 * A hook to access the redux store's state. This hook takes a selector function
 * as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter
 * that allows you to customize the way the selected state is compared to determine
 * whether the component needs to be re-rendered.
 *
 * @param {Function} selector the selector function
 * @param {Function=} equalityFn the function that will be used to determine equality
 *
 * @returns {any} the selected state
 *
 * @example
 *
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector(state => state.counter)
 *   return <div>{counter}</div>
 * }
 */

var useSelector =
/*#__PURE__*/
createSelectorHook();

/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_react_dom__, "unstable_batchedUpdates")) __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_dom__["unstable_batchedUpdates"]; });
/* eslint-disable import/no-unresolved */


/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gud__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_gud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_warning__ = __webpack_require__(208);






var MAX_SIGNED_31_BIT_INT = 1073741823;

function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + __WEBPACK_IMPORTED_MODULE_3_gud___default()() + '__';

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default()(Provider, _Component);

    function Provider() {
      var _this;

      _this = _Component.apply(this, arguments) || this;
      _this.emitter = createEventEmitter(_this.props.value);
      return _this;
    }

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0;
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;

          if (false) {
            warning((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: ' + changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    _proto.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired, _Provider$childContex);

  var Consumer =
  /*#__PURE__*/
  function (_Component2) {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default()(Consumer, _Component2);

    function Consumer() {
      var _this2;

      _this2 = _Component2.apply(this, arguments) || this;
      _this2.state = {
        value: _this2.getValue()
      };

      _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;

        if ((observedBits & changedBits) !== 0) {
          _this2.setState({
            value: _this2.getValue()
          });
        }
      };

      return _this2;
    }

    var _proto2 = Consumer.prototype;

    _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }

      var observedBits = this.props.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    _proto2.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    _proto2.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, _Consumer$contextType);
  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

var index = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext || createReactContext;

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(1106)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 1106 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var ReactIs = __webpack_require__(200);
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};

var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};

var TYPE_STATICS = {};
TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
    if (ReactIs.isMemo(component)) {
        return MEMO_STATICS;
    }
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var compose = __webpack_require__(249).compose;

exports.__esModule = true;
exports.composeWithDevTools = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
    function() {
      if (arguments.length === 0) return undefined;
      if (typeof arguments[0] === 'object') return compose;
      return compose.apply(null, arguments);
    }
);

exports.devToolsEnhancer = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ?
    window.__REDUX_DEVTOOLS_EXTENSION__ :
    function() { return function(noop) { return noop; } }
);


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _redux = __webpack_require__(249);

var _Settings = _interopRequireDefault(__webpack_require__(1110));

var _Chat = _interopRequireDefault(__webpack_require__(1111));

var _Contact = _interopRequireDefault(__webpack_require__(1113));

var _Mail = _interopRequireDefault(__webpack_require__(1114));

var _ToDo = _interopRequireDefault(__webpack_require__(1115));

var _Auth = _interopRequireDefault(__webpack_require__(1183));

var _Organisation = _interopRequireDefault(__webpack_require__(1184));

var _Employee = _interopRequireDefault(__webpack_require__(1185));

var _OrgSurvey = _interopRequireDefault(__webpack_require__(1186));

var _OrgSurveyAnswer = _interopRequireDefault(__webpack_require__(1187));

var _SurveyGroup = _interopRequireDefault(__webpack_require__(1188));

var _Survey = _interopRequireDefault(__webpack_require__(1189));

var _SurveyQuestion = _interopRequireDefault(__webpack_require__(1190));

var _SurveyGroupQuestion = _interopRequireDefault(__webpack_require__(1191));

var _project = _interopRequireDefault(__webpack_require__(1192));

var _projectPriority = _interopRequireDefault(__webpack_require__(1193));

var _security = _interopRequireDefault(__webpack_require__(1194));

var _projectIssue = _interopRequireDefault(__webpack_require__(1195));

var _businessUnit = _interopRequireDefault(__webpack_require__(1196));

var _portfolio = _interopRequireDefault(__webpack_require__(1197));

var _feature = _interopRequireDefault(__webpack_require__(1198));

var _valueStream = _interopRequireDefault(__webpack_require__(1199));

var _member = _interopRequireDefault(__webpack_require__(1200));

var _team = _interopRequireDefault(__webpack_require__(1201));

var _product = _interopRequireDefault(__webpack_require__(1202));

var _initiative = _interopRequireDefault(__webpack_require__(1203));

var _issue = _interopRequireDefault(__webpack_require__(1204));

var _projectBusPriority = _interopRequireDefault(__webpack_require__(1205));

var _projectCostPriority = _interopRequireDefault(__webpack_require__(1206));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var reducers = (0, _redux.combineReducers)({
  settings: _Settings["default"],
  chatData: _Chat["default"],
  contacts: _Contact["default"],
  mail: _Mail["default"],
  toDo: _ToDo["default"],
  auth: _Auth["default"],
  orgs: _Organisation["default"],
  emps: _Employee["default"],
  orgSurveys: _OrgSurvey["default"],
  orgSurveyAnswers: _OrgSurveyAnswer["default"],
  surveys: _Survey["default"],
  surveyGroups: _SurveyGroup["default"],
  surveyQuestions: _SurveyQuestion["default"],
  surveyGroupQuestions: _SurveyGroupQuestion["default"],
  projects: _project["default"],
  projectPrioritys: _projectPriority["default"],
  securitys: _security["default"],
  projectIssues: _projectIssue["default"],
  businessUnits: _businessUnit["default"],
  portfolios: _portfolio["default"],
  features: _feature["default"],
  valueStreams: _valueStream["default"],
  members: _member["default"],
  teams: _team["default"],
  products: _product["default"],
  initiatives: _initiative["default"],
  issues: _issue["default"],
  projectBusPrioritys: _projectBusPriority["default"],
  projectCostPrioritys: _projectCostPriority["default"]
});
var _default = reducers;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(reducers, "reducers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_Settings, "_Settings", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");

  __REACT_HOT_LOADER__.register(_Chat, "_Chat", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");

  __REACT_HOT_LOADER__.register(_Contact, "_Contact", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");

  __REACT_HOT_LOADER__.register(_Mail, "_Mail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");

  __REACT_HOT_LOADER__.register(_ToDo, "_ToDo", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");

  __REACT_HOT_LOADER__.register(_Auth, "_Auth", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");

  __REACT_HOT_LOADER__.register(_Organisation, "_Organisation", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");

  __REACT_HOT_LOADER__.register(_Employee, "_Employee", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");

  __REACT_HOT_LOADER__.register(_OrgSurvey, "_OrgSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");

  __REACT_HOT_LOADER__.register(_OrgSurveyAnswer, "_OrgSurveyAnswer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");

  __REACT_HOT_LOADER__.register(_SurveyGroup, "_SurveyGroup", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");

  __REACT_HOT_LOADER__.register(_Survey, "_Survey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");

  __REACT_HOT_LOADER__.register(_SurveyQuestion, "_SurveyQuestion", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");

  __REACT_HOT_LOADER__.register(_SurveyGroupQuestion, "_SurveyGroupQuestion", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");

  __REACT_HOT_LOADER__.register(_project, "_project", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");

  __REACT_HOT_LOADER__.register(_projectPriority, "_projectPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");

  __REACT_HOT_LOADER__.register(_security, "_security", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");

  __REACT_HOT_LOADER__.register(_projectIssue, "_projectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");

  __REACT_HOT_LOADER__.register(_businessUnit, "_businessUnit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");

  __REACT_HOT_LOADER__.register(_portfolio, "_portfolio", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");

  __REACT_HOT_LOADER__.register(_feature, "_feature", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");

  __REACT_HOT_LOADER__.register(_valueStream, "_valueStream", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");

  __REACT_HOT_LOADER__.register(_member, "_member", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");

  __REACT_HOT_LOADER__.register(_team, "_team", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");

  __REACT_HOT_LOADER__.register(_product, "_product", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");

  __REACT_HOT_LOADER__.register(_initiative, "_initiative", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");

  __REACT_HOT_LOADER__.register(_issue, "_issue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");

  __REACT_HOT_LOADER__.register(_projectBusPriority, "_projectBusPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");

  __REACT_HOT_LOADER__.register(_projectCostPriority, "_projectCostPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");

  __REACT_HOT_LOADER__.register(reducers, "reducers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/index.js");
}();

;

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ActionTypes = __webpack_require__(7);

var _ThemeColors = __webpack_require__(347);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var rltLocale = ['ar'];
var initialSettings = {
  navCollapsed: false,
  drawerType: _ActionTypes.COLLAPSED_DRAWER,
  themeColor: _ThemeColors.DARK_CYAN,
  darkTheme: false,
  width: window.innerWidth,
  height: window.innerHeight,
  isDirectionRTL: false,
  navigationStyle: _ActionTypes.VERTICAL_NAVIGATION,
  horizontalNavPosition: _ActionTypes.ABOVE_THE_HEADER,
  locale: {
    languageId: 'english',
    locale: 'en',
    name: 'English',
    icon: 'us'
  },
  colorOptionsModal: false,
  userInfoModal: false
};

var settings = function settings() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialSettings;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
      return _objectSpread({}, state, {
        navCollapsed: false
      });

    case _ActionTypes.CLEAR_SESSION:
      {
        return _objectSpread({}, initialSettings);
      }

    case _ActionTypes.TOGGLE_COLLAPSED_NAV:
      return _objectSpread({}, state, {
        navCollapsed: action.isNavCollapsed
      });

    case _ActionTypes.DRAWER_TYPE:
      return _objectSpread({}, state, {
        drawerType: action.drawerType
      });

    case _ActionTypes.WINDOW_WIDTH:
      return _objectSpread({}, state, {
        width: action.width
      });

    case _ActionTypes.WINDOW_HEIGHT:
      return _objectSpread({}, state, {
        height: action.height
      });

    case _ActionTypes.THEME_COLOR:
      return _objectSpread({}, state, {
        darkTheme: false,
        themeColor: action.color
      });

    case _ActionTypes.DARK_THEME:
      return _objectSpread({}, state, {
        darkTheme: !state.darkTheme
      });

    case _ActionTypes.SWITCH_LANGUAGE:
      return _objectSpread({}, state, {
        locale: action.payload,
        isDirectionRTL: rltLocale.includes(action.payload.locale)
      });

    case _ActionTypes.CHANGE_DIRECTION:
      return _objectSpread({}, state, {
        isDirectionRTL: !state.isDirectionRTL
      });

    case _ActionTypes.CHANGE_NAVIGATION_STYLE:
      return _objectSpread({}, state, {
        navigationStyle: action.payload
      });

    case _ActionTypes.HORIZONTAL_MENU_POSITION:
      return _objectSpread({}, state, {
        horizontalNavPosition: action.payload
      });

    case _ActionTypes.COLOR_OPTIONS_MODAL:
      return _objectSpread({}, state, {
        colorOptionsModal: !state.colorOptionsModal
      });

    case _ActionTypes.USER_INFO_MODAL:
      return _objectSpread({}, state, {
        userInfoModal: !state.userInfoModal
      });

    default:
      return state;
  }
};

var _default = settings;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(rltLocale, "rltLocale", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Settings.js");

  __REACT_HOT_LOADER__.register(initialSettings, "initialSettings", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Settings.js");

  __REACT_HOT_LOADER__.register(settings, "settings", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Settings.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Settings.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Settings.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Settings.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Settings.js");

  __REACT_HOT_LOADER__.register(rltLocale, "rltLocale", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Settings.js");

  __REACT_HOT_LOADER__.register(initialSettings, "initialSettings", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Settings.js");

  __REACT_HOT_LOADER__.register(settings, "settings", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Settings.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Settings.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Settings.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Settings.js");
}();

;

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _moment = _interopRequireDefault(__webpack_require__(2));

var _chatUsers = _interopRequireDefault(__webpack_require__(859));

var _conversationList = _interopRequireDefault(__webpack_require__(860));

var _ActionTypes = __webpack_require__(7);

var _ActionTypes2 = __webpack_require__(7);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var INIT_STATE = {
  loader: true,
  userNotFound: 'No user found',
  drawerState: false,
  selectedSectionId: '',
  userState: 1,
  searchChatUser: '',
  // contactList: [], onlt for production
  contactList: _chatUsers["default"].filter(function (user) {
    return !user.recent;
  }),
  selectedUser: null,
  message: '',
  // chatUsers: [],
  // conversationList: [], //ony for prod
  chatUsers: _chatUsers["default"].filter(function (user) {
    return user.recent;
  }),
  conversationList: _conversationList["default"],
  conversation: null
};

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.FILTER_CONTACT:
      {
        if (action.payload === '') {
          return _objectSpread({}, state, {
            contactList: _chatUsers["default"].filter(function (user) {
              return !user.recent;
            })
          });
        } else {
          return _objectSpread({}, state, {
            contactList: _chatUsers["default"].filter(function (user) {
              return !user.recent && user.name.toLowerCase().indexOf(action.payload.toLowerCase()) > -1;
            })
          });
        }
      }

    case _ActionTypes.FILTER_USERS:
      {
        if (action.payload === '') {
          return _objectSpread({}, state, {
            chatUsers: _chatUsers["default"].filter(function (user) {
              return !user.recent;
            })
          });
        } else {
          return _objectSpread({}, state, {
            chatUsers: _chatUsers["default"].filter(function (user) {
              return !user.recent && user.name.toLowerCase().indexOf(action.payload.toLowerCase()) > -1;
            })
          });
        }
      }

    case _ActionTypes.ON_SELECT_USER:
      {
        return _objectSpread({}, state, {
          loader: true,
          drawerState: false,
          selectedSectionId: action.payload.id,
          selectedUser: action.payload,
          conversation: state.conversationList.find(function (data) {
            return data.id === action.payload.id;
          })
        });
      }

    case _ActionTypes.ON_TOGGLE_DRAWER:
      {
        return _objectSpread({}, state, {
          drawerState: !state.drawerState
        });
      }

    case _ActionTypes.ON_HIDE_LOADER:
      {
        return _objectSpread({}, state, {
          loader: false
        });
      }

    case _ActionTypes2.USER_INFO_STATE:
      {
        return _objectSpread({}, state, {
          userState: action.payload
        });
      }

    case _ActionTypes.SUBMIT_COMMENT:
      {
        var updatedConversation = state.conversation.conversationData.concat({
          'type': 'sent',
          'message': state.message,
          'sentAt': (0, _moment["default"])(new Date()).format('hh:mm:ss A')
        });
        return _objectSpread({}, state, {
          conversation: _objectSpread({}, state.conversation, {
            conversationData: updatedConversation
          }),
          message: '',
          conversationList: state.conversationList.map(function (conversationData) {
            if (conversationData.id === state.conversation.id) {
              return _objectSpread({}, state.conversation, {
                conversationData: updatedConversation
              });
            } else {
              return conversationData;
            }
          })
        });
      }

    case _ActionTypes.UPDATE_MESSAGE_VALUE:
      {
        return _objectSpread({}, state, {
          message: action.payload
        });
      }

    case _ActionTypes.UPDATE_SEARCH_CHAT_USER:
      {
        return _objectSpread({}, state, {
          searchChatUser: action.payload
        });
      }

    case _ActionTypes.FETCH_ALL_CHAT_USER_SUCCESS:
      {
        return _objectSpread({}, state, {
          contactList: action.payload.filter(function (user) {
            return !user.recent;
          }),
          chatUsers: action.payload.filter(function (user) {
            return user.recent;
          }),
          loader: false
        });
      }

    case _ActionTypes.FETCH_ALL_CHAT_USER_CONVERSATION_SUCCESS:
      {
        return _objectSpread({}, state, {
          conversationList: _conversationList["default"]
        });
      }

    case _ActionTypes.SHOW_MESSAGE:
      {
        return _objectSpread({}, state, {
          alertMessage: action.payload,
          showMessage: true,
          loader: false
        });
      }

    default:
      return state;
  }
};

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Chat.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Chat.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_moment, "_moment", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Chat.js");

  __REACT_HOT_LOADER__.register(_chatUsers, "_chatUsers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Chat.js");

  __REACT_HOT_LOADER__.register(_conversationList, "_conversationList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Chat.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Chat.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Chat.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Chat.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Chat.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Chat.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Chat.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Chat.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Chat.js");
}();

;

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 499,
	"./af.js": 499,
	"./ar": 500,
	"./ar-dz": 501,
	"./ar-dz.js": 501,
	"./ar-kw": 502,
	"./ar-kw.js": 502,
	"./ar-ly": 503,
	"./ar-ly.js": 503,
	"./ar-ma": 504,
	"./ar-ma.js": 504,
	"./ar-sa": 505,
	"./ar-sa.js": 505,
	"./ar-tn": 506,
	"./ar-tn.js": 506,
	"./ar.js": 500,
	"./az": 507,
	"./az.js": 507,
	"./be": 508,
	"./be.js": 508,
	"./bg": 509,
	"./bg.js": 509,
	"./bm": 510,
	"./bm.js": 510,
	"./bn": 511,
	"./bn.js": 511,
	"./bo": 512,
	"./bo.js": 512,
	"./br": 513,
	"./br.js": 513,
	"./bs": 514,
	"./bs.js": 514,
	"./ca": 515,
	"./ca.js": 515,
	"./cs": 516,
	"./cs.js": 516,
	"./cv": 517,
	"./cv.js": 517,
	"./cy": 518,
	"./cy.js": 518,
	"./da": 519,
	"./da.js": 519,
	"./de": 520,
	"./de-at": 521,
	"./de-at.js": 521,
	"./de-ch": 522,
	"./de-ch.js": 522,
	"./de.js": 520,
	"./dv": 523,
	"./dv.js": 523,
	"./el": 524,
	"./el.js": 524,
	"./en-SG": 525,
	"./en-SG.js": 525,
	"./en-au": 526,
	"./en-au.js": 526,
	"./en-ca": 527,
	"./en-ca.js": 527,
	"./en-gb": 528,
	"./en-gb.js": 528,
	"./en-ie": 529,
	"./en-ie.js": 529,
	"./en-il": 530,
	"./en-il.js": 530,
	"./en-nz": 531,
	"./en-nz.js": 531,
	"./eo": 532,
	"./eo.js": 532,
	"./es": 533,
	"./es-do": 534,
	"./es-do.js": 534,
	"./es-us": 535,
	"./es-us.js": 535,
	"./es.js": 533,
	"./et": 536,
	"./et.js": 536,
	"./eu": 537,
	"./eu.js": 537,
	"./fa": 538,
	"./fa.js": 538,
	"./fi": 539,
	"./fi.js": 539,
	"./fo": 540,
	"./fo.js": 540,
	"./fr": 541,
	"./fr-ca": 542,
	"./fr-ca.js": 542,
	"./fr-ch": 543,
	"./fr-ch.js": 543,
	"./fr.js": 541,
	"./fy": 544,
	"./fy.js": 544,
	"./ga": 545,
	"./ga.js": 545,
	"./gd": 546,
	"./gd.js": 546,
	"./gl": 547,
	"./gl.js": 547,
	"./gom-latn": 548,
	"./gom-latn.js": 548,
	"./gu": 549,
	"./gu.js": 549,
	"./he": 550,
	"./he.js": 550,
	"./hi": 551,
	"./hi.js": 551,
	"./hr": 552,
	"./hr.js": 552,
	"./hu": 553,
	"./hu.js": 553,
	"./hy-am": 554,
	"./hy-am.js": 554,
	"./id": 555,
	"./id.js": 555,
	"./is": 556,
	"./is.js": 556,
	"./it": 557,
	"./it-ch": 558,
	"./it-ch.js": 558,
	"./it.js": 557,
	"./ja": 559,
	"./ja.js": 559,
	"./jv": 560,
	"./jv.js": 560,
	"./ka": 561,
	"./ka.js": 561,
	"./kk": 562,
	"./kk.js": 562,
	"./km": 563,
	"./km.js": 563,
	"./kn": 564,
	"./kn.js": 564,
	"./ko": 565,
	"./ko.js": 565,
	"./ku": 566,
	"./ku.js": 566,
	"./ky": 567,
	"./ky.js": 567,
	"./lb": 568,
	"./lb.js": 568,
	"./lo": 569,
	"./lo.js": 569,
	"./lt": 570,
	"./lt.js": 570,
	"./lv": 571,
	"./lv.js": 571,
	"./me": 572,
	"./me.js": 572,
	"./mi": 573,
	"./mi.js": 573,
	"./mk": 574,
	"./mk.js": 574,
	"./ml": 575,
	"./ml.js": 575,
	"./mn": 576,
	"./mn.js": 576,
	"./mr": 577,
	"./mr.js": 577,
	"./ms": 578,
	"./ms-my": 579,
	"./ms-my.js": 579,
	"./ms.js": 578,
	"./mt": 580,
	"./mt.js": 580,
	"./my": 581,
	"./my.js": 581,
	"./nb": 582,
	"./nb.js": 582,
	"./ne": 583,
	"./ne.js": 583,
	"./nl": 584,
	"./nl-be": 585,
	"./nl-be.js": 585,
	"./nl.js": 584,
	"./nn": 586,
	"./nn.js": 586,
	"./pa-in": 587,
	"./pa-in.js": 587,
	"./pl": 588,
	"./pl.js": 588,
	"./pt": 589,
	"./pt-br": 590,
	"./pt-br.js": 590,
	"./pt.js": 589,
	"./ro": 591,
	"./ro.js": 591,
	"./ru": 592,
	"./ru.js": 592,
	"./sd": 593,
	"./sd.js": 593,
	"./se": 594,
	"./se.js": 594,
	"./si": 595,
	"./si.js": 595,
	"./sk": 596,
	"./sk.js": 596,
	"./sl": 597,
	"./sl.js": 597,
	"./sq": 598,
	"./sq.js": 598,
	"./sr": 599,
	"./sr-cyrl": 600,
	"./sr-cyrl.js": 600,
	"./sr.js": 599,
	"./ss": 601,
	"./ss.js": 601,
	"./sv": 602,
	"./sv.js": 602,
	"./sw": 603,
	"./sw.js": 603,
	"./ta": 604,
	"./ta.js": 604,
	"./te": 605,
	"./te.js": 605,
	"./tet": 606,
	"./tet.js": 606,
	"./tg": 607,
	"./tg.js": 607,
	"./th": 608,
	"./th.js": 608,
	"./tl-ph": 609,
	"./tl-ph.js": 609,
	"./tlh": 610,
	"./tlh.js": 610,
	"./tr": 611,
	"./tr.js": 611,
	"./tzl": 612,
	"./tzl.js": 612,
	"./tzm": 613,
	"./tzm-latn": 614,
	"./tzm-latn.js": 614,
	"./tzm.js": 613,
	"./ug-cn": 615,
	"./ug-cn.js": 615,
	"./uk": 616,
	"./uk.js": 616,
	"./ur": 617,
	"./ur.js": 617,
	"./uz": 618,
	"./uz-latn": 619,
	"./uz-latn.js": 619,
	"./uz.js": 618,
	"./vi": 620,
	"./vi.js": 620,
	"./x-pseudo": 621,
	"./x-pseudo.js": 621,
	"./yo": 622,
	"./yo.js": 622,
	"./zh-cn": 623,
	"./zh-cn.js": 623,
	"./zh-hk": 624,
	"./zh-hk.js": 624,
	"./zh-tw": 625,
	"./zh-tw.js": 625
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1112;

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ActionTypes = __webpack_require__(7);

var _contactList7 = _interopRequireDefault(__webpack_require__(853));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var INIT_STATE = {
  alertMessage: '',
  showMessage: false,
  loader: true,
  noContentFoundMessage: 'No contact found in selected folder',
  selectedSectionId: 1,
  drawerState: false,
  user: {
    name: 'Robert Johnson',
    email: 'robert.johnson@example.com',
    avatar: 'http://via.placeholder.com/150x150'
  },
  searchUser: '',
  filterOption: 'All contacts',
  // allContact: [],
  // contactList: [], //only for prod
  allContact: _contactList7["default"],
  contactList: _contactList7["default"],
  selectedContact: null,
  selectedContacts: 0,
  addContactState: false
};

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.ADD_FAVOURITE:
      {
        return _objectSpread({}, state, {
          alertMessage: action.payload.starred ? 'Contact removed as star' : 'Contact marked as star',
          showMessage: true,
          contactList: state.contactList.map(function (contact) {
            return contact.id === action.payload.id ? _objectSpread({}, contact, {
              starred: !action.payload.starred
            }) : contact;
          }),
          allContact: state.allContact.map(function (contact) {
            return contact.id === action.payload.id ? _objectSpread({}, contact, {
              starred: !action.payload.starred
            }) : contact;
          })
        });
      }

    case _ActionTypes.FETCH_ALL_CONTACT_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          allContact: action.payload,
          contactList: action.payload
        });
      }

    case _ActionTypes.SHOW_MESSAGE:
      {
        return _objectSpread({}, state, {
          alertMessage: action.payload,
          showMessage: true,
          loader: false
        });
      }

    case _ActionTypes.ON_CONTACT_SELECT:
      {
        action.payload.selected = !action.payload.selected;
        var selectedContacts = 0;
        var contactList = state.contactList.map(function (contact) {
          if (contact.selected) {
            selectedContacts++;
          }

          if (contact.id === action.payload.id) {
            if (contact.selected) {
              selectedContacts++;
            }

            return action.payload;
          } else {
            return contact;
          }
        });
        return _objectSpread({}, state, {
          INIT_STATE: INIT_STATE,
          selectedContacts: selectedContacts,
          contactList: contactList
        });
      }

    case _ActionTypes.ON_ADD_CONTACT:
      {
        return _objectSpread({}, state, {
          addContactState: true
        });
      }

    case _ActionTypes.ON_CONTACT_CLOSE:
      {
        return _objectSpread({}, state, {
          addContactState: false
        });
      }

    case _ActionTypes.ON_FILTER_OPTION_SELECT:
      {
        var selectedSectionId = 0;
        var filterOption = '';
        var _contactList = [];

        switch (action.payload.name) {
          case 'All contacts':
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              _contactList = state.allContact;
              break;
            }

          case 'Frequently contacted':
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              _contactList = state.allContact.filter(function (contact) {
                return contact.frequently;
              });
              break;
            }

          case 'Starred contacts':
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              _contactList = state.allContact.filter(function (contact) {
                return contact.starred;
              });
              break;
            }
        }

        return _objectSpread({}, state, {
          selectedSectionId: selectedSectionId,
          filterOption: filterOption,
          contactList: _contactList,
          drawerState: false
        });
      }

    case _ActionTypes.ON_SAVE_CONTACT:
      {
        var isNew = true;

        var _contactList2 = state.allContact.map(function (contact) {
          if (contact.id === action.payload.id) {
            isNew = false;
            return action.payload;
          } else {
            return contact;
          }
        });

        if (isNew) {
          _contactList2.push(action.payload);
        }

        return _objectSpread({}, state, {
          alertMessage: isNew ? 'Contact Added Successfully' : 'Contact Updated Successfully',
          showMessage: true,
          contactList: _contactList2,
          allContact: _contactList2
        });
      }

    case _ActionTypes.ON_DELETE_CONTACT:
      {
        return _objectSpread({}, state, {
          alertMessage: 'Contact Deleted Successfully',
          showMessage: true,
          allContact: state.allContact.filter(function (contact) {
            return contact.id !== action.payload.id;
          }),
          contactList: state.allContact.filter(function (contact) {
            return contact.id !== action.payload.id;
          })
        });
      }

    case _ActionTypes.ON_DELETE_SELECTED_CONTACT:
      {
        var contacts = state.allContact.filter(function (contact) {
          return !contact.selected;
        });
        return _objectSpread({}, state, {
          alertMessage: 'Contact Deleted Successfully',
          showMessage: true,
          allContact: contacts,
          contactList: contacts,
          selectedContacts: 0
        });
      }

    case _ActionTypes.FILTER_CONTACT:
      {
        var _filterOption = state.filterOption;
        var _contactList3 = [];

        if (action.payload === '') {
          _contactList3 = state.allContact;
        } else {
          var filterContact = state.allContact.filter(function (contact) {
            return contact.name.toLowerCase().indexOf(action.payload.toLowerCase()) > -1;
          });

          if (_filterOption === 'All contacts') {
            _contactList3 = filterContact;
          } else if (_filterOption === 'Frequently contacted') {
            _contactList3 = filterContact.filter(function (contact) {
              return contact.frequently;
            });
          } else if (_filterOption === 'Starred contacts') {
            _contactList3 = filterContact.filter(function (contact) {
              return contact.starred;
            });
          }
        }

        return _objectSpread({}, state, {
          contactList: _contactList3
        });
      }

    case _ActionTypes.GET_ALL_CONTACT:
      {
        var _contactList4 = state.allContact.map(function (contact) {
          return contact ? _objectSpread({}, contact, {
            selected: true
          }) : contact;
        });

        return _objectSpread({}, state, {
          selectedContacts: _contactList4.length,
          allContact: _contactList4,
          contactList: _contactList4
        });
      }

    case _ActionTypes.GET_UNSELECTED_ALL_CONTACT:
      {
        var _contactList5 = state.allContact.map(function (contact) {
          return contact ? _objectSpread({}, contact, {
            selected: false
          }) : contact;
        });

        return _objectSpread({}, state, {
          selectedContacts: 0,
          allContact: _contactList5,
          contactList: _contactList5
        });
      }

    case _ActionTypes.ON_ALL_CONTACT_SELECT:
      {
        var selectAll = state.selectedContacts < state.contactList.length;
        var _selectedContacts = 0;
        var _contactList6 = [];

        if (selectAll) {
          _contactList6 = state.allContact.map(function (contact) {
            return contact ? _objectSpread({}, contact, {
              selected: true
            }) : contact;
          });
          _selectedContacts = _contactList6.length;
        } else {
          _contactList6 = state.allContact.map(function (contact) {
            return contact ? _objectSpread({}, contact, {
              selected: true
            }) : contact;
          });
          _selectedContacts = 0;
        }

        return _objectSpread({}, state, {
          selectedContacts: _selectedContacts,
          allContact: _contactList6,
          contactList: _contactList6
        });
      }

    case _ActionTypes.UPDATE_SEARCH_USER:
      {
        return _objectSpread({}, state, {
          searchUser: action.payload
        });
      }

    case _ActionTypes.HANDLE_REQUEST_CLOSE:
      {
        return _objectSpread({}, state, {
          showMessage: false
        });
      }

    case _ActionTypes.ON_TOGGLE_DRAWER:
      {
        return _objectSpread({}, state, {
          drawerState: !state.drawerState
        });
      }

    case _ActionTypes.HIDE_CONTACT_LOADER:
      {
        return _objectSpread({}, state, {
          loader: false
        });
      }

    default:
      return state;
  }
};

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Contact.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Contact.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_contactList7, "_contactList7", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Contact.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Contact.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Contact.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Contact.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Contact.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Contact.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Contact.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Contact.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Contact.js");
}();

;

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ActionTypes = __webpack_require__(7);

var _mails13 = _interopRequireDefault(__webpack_require__(861));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var INIT_STATE = {
  searchMail: '',
  noContentFoundMessage: 'No mail found in selected folder',
  alertMessage: '',
  showMessage: false,
  drawerState: false,
  // allMail: [], only for prod
  allMail: _mails13["default"],
  optionName: 'None',
  loader: true,
  currentMail: null,
  user: {
    name: 'Robert Johnson',
    email: 'robert@example.com',
    avatar: 'http://via.placeholder.com/150x150'
  },
  selectedMails: 0,
  selectedFolder: 0,
  composeMail: false,
  labelMenuState: false,
  folderMenuState: false,
  optionMenuState: false,
  // folderMails: [], //only for prod
  folderMails: _mails13["default"].filter(function (mail) {
    return mail.folder === 0;
  })
};

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.GET_ALL_MAIL:
      {
        var _mails = state.allMail.map(function (mail) {
          return mail.folder === state.selectedFolder ? _objectSpread({}, mail, {
            selected: true
          }) : mail;
        });

        return _objectSpread({}, state, {
          selectedMails: _mails.length,
          optionName: 'All',
          allMail: _mails,
          folderMails: _mails.filter(function (mail) {
            return mail.folder === state.selectedFolder;
          })
        });
      }

    case _ActionTypes.FETCH_ALL_MAIL_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          allMail: action.payload,
          folderMails: action.payload.filter(function (mail) {
            return mail.folder === 0;
          })
        });
      }

    case _ActionTypes.GET_IMPORTANT_MAIL:
      {
        var selectedMail = 0;

        var _mails2 = state.allMail.filter(function (mail) {
          return mail.folder === state.selectedFolder;
        });

        _mails2 = _mails2.map(function (mail) {
          if (mail.important) {
            selectedMail++;
            return _objectSpread({}, mail, {
              selected: true
            });
          }

          return _objectSpread({}, mail, {
            selected: false
          });
        });
        return _objectSpread({}, state, {
          selectedMails: selectedMail,
          optionName: 'Important',
          allMail: _mails2,
          folderMails: _mails2.filter(function (mail) {
            return mail.folder === state.selectedFolder;
          })
        });
      }

    case _ActionTypes.GET_NAV_FILTERS:
      {
        var filterMails = state.allMail.filter(function (mail) {
          if (action.payload.id === 0 && mail.starred) {
            return mail;
          } else if (action.payload.id === 1 && mail.important) {
            return mail;
          }
        });
        return _objectSpread({}, state, {
          noContentFoundMessage: 'No mail found in selected filter',
          loader: true,
          folderMails: filterMails
        });
      }

    case _ActionTypes.ON_FOLDER_SELECT:
      {
        return _objectSpread({}, state, {
          folderMenuState: !state.folderMenuState
        });
      }

    case _ActionTypes.GET_NAV_LABELS:
      {
        var _filterMails = state.allMail.filter(function (mail) {
          return mail.labels.includes(action.payload.id);
        });

        return _objectSpread({}, state, {
          loader: true,
          noContentFoundMessage: 'No mail found in selected label',
          folderMails: _filterMails
        });
      }

    case _ActionTypes.GET_READ_MAIL:
      {
        var _selectedMail = 0;

        var _mails3 = state.allMail.filter(function (mail) {
          return mail.folder === state.selectedFolder;
        });

        _mails3 = _mails3.map(function (mail) {
          if (mail.read) {
            _selectedMail++;
            return _objectSpread({}, mail, {
              selected: true
            });
          }

          return _objectSpread({}, mail, {
            selected: false
          });
        });
        return _objectSpread({}, state, {
          selectedMails: _selectedMail,
          allMail: _mails3,
          optionName: 'Read',
          folderMails: _mails3.filter(function (mail) {
            return mail.folder === state.selectedFolder;
          })
        });
      }

    case _ActionTypes.GET_STARRED_MAIL:
      {
        var _selectedMail2 = 0;

        var _mails4 = state.allMail.filter(function (mail) {
          return mail.folder === state.selectedFolder;
        });

        _mails4 = _mails4.map(function (mail) {
          if (mail.starred) {
            _selectedMail2++;
            return _objectSpread({}, mail, {
              selected: true
            });
          }

          return _objectSpread({}, mail, {
            selected: false
          });
        });
        return _objectSpread({}, state, {
          selectedMails: _selectedMail2,
          allMail: _mails4,
          optionName: 'Stared',
          folderMails: _mails4.filter(function (mail) {
            return mail.folder === state.selectedFolder;
          })
        });
      }

    case _ActionTypes.GET_UNIMPORTANT_MAIL:
      {
        var _selectedMail3 = 0;

        var _mails5 = state.allMail.filter(function (mail) {
          return mail.folder === state.selectedFolder;
        });

        _mails5 = _mails5.map(function (mail) {
          if (!mail.important) {
            _selectedMail3++;
            return _objectSpread({}, mail, {
              selected: true
            });
          }

          return _objectSpread({}, mail, {
            selected: false
          });
        });
        return _objectSpread({}, state, {
          selectedMails: _selectedMail3,
          allMail: _mails5,
          optionName: 'Unimportant',
          noContentFoundMessage: 'No Mail found in selected Label',
          folderMails: _mails5.filter(function (mail) {
            return mail.folder === state.selectedFolder;
          })
        });
      }

    case _ActionTypes.GET_UNREAD_MAIL:
      {
        var _selectedMail4 = 0;

        var _mails6 = state.allMail.filter(function (mail) {
          return mail.folder === state.selectedFolder;
        });

        _mails6 = _mails6.map(function (mail) {
          if (!mail.read) {
            _selectedMail4++;
            return _objectSpread({}, mail, {
              selected: true
            });
          }

          return _objectSpread({}, mail, {
            selected: false
          });
        });
        return _objectSpread({}, state, {
          selectedMails: _selectedMail4,
          allMail: _mails6,
          optionName: 'Unread',
          folderMails: _mails6.filter(function (mail) {
            return mail.folder === state.selectedFolder;
          })
        });
      }

    case _ActionTypes.GET_UNSELECTED_ALL_MAIL:
      {
        var _mails7 = state.allMail.map(function (mail) {
          return mail.folder === state.selectedFolder ? _objectSpread({}, mail, {
            selected: false
          }) : mail;
        });

        return _objectSpread({}, state, {
          selectedMails: 0,
          optionName: 'None',
          allMail: _mails7,
          folderMails: _mails7.filter(function (mail) {
            return mail.folder === state.selectedFolder;
          })
        });
      }

    case _ActionTypes.GET_UNSTARRED_MAIL:
      {
        var _selectedMail5 = 0;

        var _mails8 = state.allMail.filter(function (mail) {
          return mail.folder === state.selectedFolder;
        });

        _mails8 = _mails8.map(function (mail) {
          if (!mail.starred) {
            _selectedMail5++;
            return _objectSpread({}, mail, {
              selected: true
            });
          }

          return _objectSpread({}, mail, {
            selected: false
          });
        });
        return _objectSpread({}, state, {
          selectedMails: _selectedMail5,
          optionName: 'UnStarred',
          allMail: _mails8,
          folderMails: _mails8.filter(function (mail) {
            return mail.folder === state.selectedFolder;
          })
        });
      }

    case _ActionTypes.HANDLE_REQUEST_CLOSE:
      {
        return _objectSpread({}, state, {
          composeMail: false,
          showMessage: false,
          folderMenuState: false,
          labelMenuState: false,
          optionMenuState: false
        });
      }

    case _ActionTypes.ON_ALL_MAIL_SELECT:
      {
        return _objectSpread({}, state);
      }

    case _ActionTypes.ON_FOLDER_MENU_ITEM_SELECT:
      {
        var _mails9 = state.allMail.map(function (mail) {
          return mail.selected && mail.folder === state.selectedFolder ? _objectSpread({}, mail, {
            folder: action.payload,
            selected: false
          }) : mail;
        });

        return _objectSpread({}, state, {
          selectedMails: 0,
          allMail: _mails9,
          noContentFoundMessage: 'No mail found in selected folder',
          alertMessage: 'Mail has been moved successfully',
          showMessage: true,
          folderMails: _mails9.filter(function (mail) {
            return mail.folder === state.selectedFolder;
          })
        });
      }

    case _ActionTypes.ON_IMPORTANT_SELECT:
      {
        action.payload.important = !action.payload.important;
        return _objectSpread({}, state, {
          alertMessage: action.payload.important ? 'Mail Mark as Important' : 'Mail Remove as Important',
          showMessage: true,
          folderMails: state.folderMails.map(function (mail) {
            return mail.id === action.payload.id ? action.payload : mail;
          })
        });
      }

    case _ActionTypes.ON_LABEL_MENU_ITEM_SELECT:
      {
        var currentMail = state.currentMail;

        var _mails10 = state.allMail.map(function (mail) {
          if (mail.selected && mail.folder === state.selectedFolder) {
            if (mail.labels.includes(action.payload.id)) {
              mail.labels.splice(mail.labels.indexOf(action.payload.id), 1);

              if (currentMail !== null && mail.id === currentMail.id) {
                currentMail.labels = mail.labels;
              }

              return _objectSpread({}, mail, {
                labels: mail.labels
              });
            } else {
              mail.labels = mail.labels.concat(action.payload.id);

              if (currentMail !== null && mail.id === currentMail.id) {
                currentMail.labels = mail.labels;
              }

              return _objectSpread({}, mail, {
                labels: mail.labels
              });
            }
          } else {
            return mail;
          }
        });

        return _objectSpread({}, state, {
          currentMail: currentMail,
          noContentFoundMessage: 'No mail found in selected label',
          alertMessage: 'Label Updated Successfully',
          showMessage: true,
          allMail: _mails10,
          folderMails: _mails10.filter(function (mail) {
            return mail.folder === state.selectedFolder;
          })
        });
      }

    case _ActionTypes.ON_LABEL_SELECT:
      {
        return _objectSpread({}, state, {
          labelMenuState: !state.labelMenuState
        });
      }

    case _ActionTypes.ON_MAIL_CHECKED:
      {
        action.payload.selected = !action.payload.selected;
        var _selectedMail6 = 0;

        var _mails11 = state.folderMails.map(function (mail) {
          if (mail.selected) {
            _selectedMail6++;
          }

          if (mail.id === action.payload.id) {
            if (mail.selected) {
              _selectedMail6++;
            }

            return action.payload;
          } else {
            return mail;
          }
        });

        return _objectSpread({}, state, {
          selectedMails: _selectedMail6,
          folderMails: _mails11
        });
      }

    case _ActionTypes.ON_MAIL_SELECT:
      {
        return _objectSpread({}, state, {
          loader: true,
          currentMail: action.payload
        });
      }

    case _ActionTypes.ON_MAIL_SEND:
      {
        return _objectSpread({}, state, {
          alertMessage: 'Mail Sent Successfully',
          showMessage: true,
          folderMails: state.allMail.concat(action.payload),
          allMail: state.allMail.concat(action.payload)
        });
      }

    case _ActionTypes.ON_OPTION_MENU_SELECT:
      {
        return _objectSpread({}, state, {
          optionMenuState: !state.optionMenuState
        });
      }

    case _ActionTypes.GET_NAV_FOLDER:
      {
        var _filterMails2 = state.allMail.filter(function (mail) {
          return mail.folder === action.payload.id;
        });

        return _objectSpread({}, state, {
          selectedFolder: action.payload.id,
          noContentFoundMessage: 'No mail found in selected folder',
          currentMail: null,
          loader: true,
          folderMails: _filterMails2
        });
      }

    case _ActionTypes.ON_START_SELECT:
      {
        action.payload.starred = !action.payload.starred;
        return _objectSpread({}, state, {
          alertMessage: action.payload.starred ? 'Mail Mark as Star' : 'Mail Remove as Star',
          showMessage: true,
          folderMails: state.folderMails.map(function (mail) {
            return mail.id === action.payload.id ? action.payload : mail;
          })
        });
      }

    case _ActionTypes.SEARCH_MAIL:
      {
        if (action.payload === '') {
          return _objectSpread({}, state, {
            folderMails: state.allMail.filter(function (mail) {
              return !mail.deleted;
            })
          });
        } else {
          var searchMails = state.allMail.filter(function (mail) {
            return !mail.deleted && mail.subject.toLowerCase().indexOf(action.payload.toLowerCase()) > -1;
          });
          return _objectSpread({}, state, {
            folderMails: searchMails
          });
        }
      }

    case _ActionTypes.UPDATE_SEARCH:
      {
        return _objectSpread({}, state, {
          searchMail: action.payload
        });
      }

    case _ActionTypes.ON_HIDE_LOADER:
      {
        return _objectSpread({}, state, {
          loader: false
        });
      }

    case _ActionTypes.ON_TOGGLE_DRAWER:
      {
        return _objectSpread({}, state, {
          drawerState: !state.drawerState
        });
      }

    case _ActionTypes.SET_CURRENT_MAIL_NULL:
      {
        return _objectSpread({}, state, {
          currentMail: null
        });
      }

    case _ActionTypes.ON_DELETE_MAIL:
      {
        var _mails12 = state.allMail.map(function (mail) {
          return mail.selected && mail.folder === state.selectedFolder ? _objectSpread({}, mail, {
            folder: 4,
            selected: false
          }) : mail;
        });

        return _objectSpread({}, state, {
          alertMessage: 'Mail Deleted Successfully',
          showMessage: true,
          selectedMails: 0,
          allMail: _mails12,
          folderMails: _mails12.filter(function (mail) {
            return mail.folder === state.selectedFolder;
          })
        });
      }

    case _ActionTypes.ON_COMPOSE_MAIL:
      {
        return _objectSpread({}, state, {
          composeMail: true
        });
      }

    case _ActionTypes.SHOW_MESSAGE:
      {
        return _objectSpread({}, state, {
          alertMessage: action.payload,
          showMessage: true,
          loader: false
        });
      }

    default:
      return state;
  }
};

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Mail.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Mail.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_mails13, "_mails13", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Mail.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Mail.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Mail.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Mail.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Mail.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Mail.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Mail.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Mail.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Mail.js");
}();

;

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _todoConversation = _interopRequireDefault(__webpack_require__(862));

var _todo = _interopRequireDefault(__webpack_require__(863));

var _reactSortableHoc = __webpack_require__(838);

var _ActionTypes = __webpack_require__(7);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var INIT_STATE = {
  searchTodo: '',
  alertMessage: '',
  loader: true,
  showMessage: false,
  optionName: 'None',
  drawerState: false,
  // allToDos: [],
  allToDos: _todo["default"],
  currentTodo: null,
  user: {
    name: 'Robert Johnson',
    email: 'robert.johnson@example.com',
    avatar: 'http://via.placeholder.com/150x150'
  },
  selectedToDos: 0,
  labelMenuState: false,
  optionMenuState: false,
  // toDos: [],
  toDos: _todo["default"],
  filter: -1,
  // todoConversation: [],
  todoConversation: _todoConversation["default"],
  conversation: null
};

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.ON_SORTEND:
      {
        return _objectSpread({}, state, {
          toDos: (0, _reactSortableHoc.arrayMove)(state.toDos, action.payload.oldIndex, action.payload.newIndex)
        });
      }

    case _ActionTypes.ON_LABEL_SELECT:
      {
        return _objectSpread({}, state, {
          labelMenuState: !state.labelMenuState
        });
      }

    case _ActionTypes.ON_OPTION_MENU_SELECT:
      {
        return _objectSpread({}, state, {
          optionMenuState: !state.optionMenuState
        });
      }

    case _ActionTypes.ON_OPTION_MENU_ITEM_SELECT:
      {
        return _objectSpread({}, state);
      }

    case _ActionTypes.SELECT_ALL_TODO:
      {
        var _toDos = state.allToDos.map(function (todo) {
          return todo ? _objectSpread({}, todo, {
            selected: true
          }) : todo;
        });

        return _objectSpread({}, state, {
          selectedToDos: _toDos.length,
          allToDos: _toDos,
          optionName: 'All',
          toDos: _toDos
        });
      }

    case _ActionTypes.GET_ALL_TODO:
      {
        return _objectSpread({}, state, {
          currentTodo: null,
          toDos: state.allToDos
        });
      }

    case _ActionTypes.GET_UNSELECTED_ALL_TODO:
      {
        var _toDos2 = state.allToDos.map(function (todo) {
          return todo ? _objectSpread({}, todo, {
            selected: false
          }) : todo;
        });

        return _objectSpread({}, state, {
          selectedToDos: 0,
          allToDos: _toDos2,
          optionName: 'None',
          toDos: _toDos2
        });
      }

    case _ActionTypes.GET_STARRED_TODO:
      {
        var selectedToDos = 0;

        var _toDos3 = state.allToDos.map(function (todo) {
          if (todo.starred) {
            selectedToDos++;
            return _objectSpread({}, todo, {
              selected: true
            });
          }

          return _objectSpread({}, todo, {
            selected: false
          });
        });

        return _objectSpread({}, state, {
          selectedToDos: selectedToDos,
          allToDos: _toDos3,
          optionName: 'Stared',
          toDos: _toDos3.filter(function (todo) {
            return !todo.deleted;
          })
        });
      }

    case _ActionTypes.GET_UNSTARRED_TODO:
      {
        var _selectedToDos = 0;

        var _toDos4 = state.allToDos.map(function (todo) {
          if (!todo.starred) {
            _selectedToDos++;
            return _objectSpread({}, todo, {
              selected: true
            });
          }

          return _objectSpread({}, todo, {
            selected: false
          });
        });

        return _objectSpread({}, state, {
          selectedToDos: _selectedToDos,
          allToDos: _toDos4,
          optionName: 'UnStarred',
          toDos: _toDos4.filter(function (todo) {
            return !todo.deleted;
          })
        });
      }

    case _ActionTypes.GET_IMPORTANT_TODO:
      {
        var _selectedToDos2 = 0;

        var _toDos5 = state.allToDos.map(function (todo) {
          if (todo.important) {
            _selectedToDos2++;
            return _objectSpread({}, todo, {
              selected: true
            });
          }

          return _objectSpread({}, todo, {
            selected: false
          });
        });

        return _objectSpread({}, state, {
          selectedToDos: _selectedToDos2,
          allToDos: _toDos5,
          optionName: 'Important',
          toDos: _toDos5.filter(function (todo) {
            return !todo.deleted;
          })
        });
      }

    case _ActionTypes.GET_MARK_AS_START:
      {
        var _toDos6 = state.allToDos.map(function (todo) {
          if (todo.id === action.payload.id) {
            return action.payload;
          } else {
            return todo;
          }
        });

        return _objectSpread({}, state, {
          alertMessage: 'ToDo Updated Successfully',
          showMessage: true,
          allToDos: _toDos6,
          toDos: _toDos6
        });
      }

    case _ActionTypes.GET_UNIMPORTANT_TODO:
      {
        var _selectedToDos3 = 0;

        var _toDos7 = state.allToDos.map(function (todo) {
          if (!todo.important) {
            _selectedToDos3++;
            return _objectSpread({}, todo, {
              selected: true
            });
          }

          return _objectSpread({}, todo, {
            selected: false
          });
        });

        return _objectSpread({}, state, {
          selectedToDos: _selectedToDos3,
          allToDos: _toDos7,
          optionName: 'Unimportant',
          toDos: _toDos7.filter(function (todo) {
            return !todo.deleted;
          })
        });
      }

    case _ActionTypes.ON_LABEL_MENU_ITEM_SELECT:
      {
        var _toDos8 = state.allToDos.map(function (todo) {
          if (todo.selected) {
            if (todo.labels.includes(action.payload.id)) {
              todo.labels.splice(todo.labels.indexOf(action.payload.id), 1);
              return _objectSpread({}, todo, {
                labels: todo.labels
              });
            } else {
              return _objectSpread({}, todo, {
                labels: todo.labels.concat(action.payload.id)
              });
            }
          } else {
            return todo;
          }
        });

        return _objectSpread({}, state, {
          alertMessage: 'Label Updated Successfully',
          showMessage: true,
          allToDos: _toDos8,
          toDos: _toDos8
        });
      }

    case _ActionTypes.ON_LABEL_UPDATE:
      {
        if (action.payload.data.labels.includes(action.payload.label.id)) {
          action.payload.data.labels.splice(action.payload.data.labels.indexOf(action.payload.label.id), 1);
        } else {
          action.payload.data.labels = action.payload.data.labels.concat(action.payload.label.id);
        }

        var _toDos9 = state.allToDos.map(function (todo) {
          if (todo.id === action.payload.data.id) {
            return action.payload.data;
          } else {
            return todo;
          }
        });

        return _objectSpread({}, state, {
          alertMessage: 'Label Updated Successfully',
          showMessage: true,
          currentTodo: action.payload,
          allToDos: _toDos9,
          toDos: _toDos9
        });
      }

    case _ActionTypes.ON_TODO_UPDATE:
      {
        var _toDos10 = state.allToDos.map(function (todo) {
          if (todo.id === action.payload.id) {
            return action.payload;
          } else {
            return todo;
          }
        });

        return _objectSpread({}, state, {
          alertMessage: 'ToDo Updated Successfully',
          showMessage: true,
          currentTodo: action.payload,
          allToDos: _toDos10,
          toDos: _toDos10
        });
      }

    case _ActionTypes.ON_DELETE_TODO:
      {
        var _selectedToDos4 = 0;

        var _toDos11 = state.allToDos.map(function (todo) {
          if (todo.selected) {
            _selectedToDos4++;
          }

          if (action.payload.id === todo.id) {
            if (todo.selected) {
              _selectedToDos4--;
            }

            return _objectSpread({}, todo, {
              deleted: true
            });
          } else {
            return todo;
          }
        });

        return _objectSpread({}, state, {
          alertMessage: 'ToDo Deleted Successfully',
          showMessage: true,
          allToDos: _toDos11,
          currentTodo: null,
          selectedToDos: _selectedToDos4,
          toDos: _toDos11.filter(function (todo) {
            return !todo.deleted;
          })
        });
      }

    case _ActionTypes.GET_NAV_LABELS:
      {
        var filterMails = state.allToDos.filter(function (todo) {
          return todo.labels.includes(action.payload.id);
        });
        return _objectSpread({}, state, {
          loader: true,
          currentTodo: null,
          toDos: filterMails
        });
      }

    case _ActionTypes.GET_NAV_FILTERS:
      {
        var _filterMails = state.allToDos.filter(function (todo) {
          if (action.payload.id === 0 && todo.starred) {
            return todo;
          } else if (action.payload.id === 1 && todo.important) {
            return todo;
          } else if (action.payload.id === 2 && todo.important) {
            return todo;
          } else if (action.payload.id === 3 && todo.important) {
            return todo;
          } else if (action.payload.id === 4 && todo.completed) {
            return todo;
          } else if (action.payload.id === 5 && todo.deleted) {
            return todo;
          }
        });

        return _objectSpread({}, state, {
          loader: true,
          currentTodo: null,
          filter: action.payload.id,
          toDos: _filterMails
        });
      }

    case _ActionTypes.SEARCH_TODO:
      {
        if (action.payload === '') {
          return _objectSpread({}, state, {
            toDos: state.allToDos.filter(function (todo) {
              return !todo.deleted;
            })
          });
        } else {
          var searchToDos = state.allToDos.filter(function (todo) {
            return !todo.deleted && todo.title.toLowerCase().indexOf(action.payload.toLowerCase()) > -1;
          });
          return _objectSpread({}, state, {
            toDos: searchToDos
          });
        }
      }

    case _ActionTypes.SHOW_TODOS:
      {
        return _objectSpread({}, state);
      }

    case _ActionTypes.GET_TODO_CONVERSATION:
      {
        return _objectSpread({}, state);
      }

    case _ActionTypes.ON_TODO_CHECKED:
      {
        action.payload.selected = !action.payload.selected;
        var _selectedToDos5 = 0;

        var _toDos12 = state.toDos.map(function (todo) {
          if (todo.selected) {
            _selectedToDos5++;
          }

          if (todo.id === action.payload.id) {
            if (todo.selected) {
              _selectedToDos5++;
            }

            return action.payload;
          } else {
            return todo;
          }
        });

        return _objectSpread({}, state, {
          selectedToDos: _selectedToDos5,
          toDos: _toDos12
        });
      }

    case _ActionTypes.ON_TODO_ADD:
      {
        return _objectSpread({}, state, {
          toDos: state.allToDos.concat(action.payload),
          allToDos: state.allToDos.concat(action.payload)
        });
      }

    case _ActionTypes.ON_TODO_SELECT:
      {
        var conversationList = state.todoConversation.find(function (conversation) {
          return conversation.id === action.payload.id;
        });

        if (conversationList) {
          conversationList = conversationList.conversationData;
        } else {
          conversationList = [];
        }

        return _objectSpread({}, state, {
          currentTodo: action.payload,
          loader: true,
          conversation: conversationList
        });
      }

    case _ActionTypes.SET_CURRENT_TODO_NULL:
      {
        return _objectSpread({}, state, {
          currentTodo: null
        });
      }

    case _ActionTypes.UPDATE_SEARCH:
      {
        return _objectSpread({}, state, {
          searchTodo: action.payload
        });
      }

    case _ActionTypes.ON_TOGGLE_DRAWER:
      {
        return _objectSpread({}, state, {
          drawerState: !state.drawerState
        });
      }

    case _ActionTypes.HANDLE_REQUEST_CLOSE:
      {
        return _objectSpread({}, state, {
          showMessage: false,
          addTodo: false,
          labelMenuState: false,
          optionMenuState: false
        });
      }

    case _ActionTypes.ON_HIDE_LOADER:
      {
        return _objectSpread({}, state, {
          loader: false
        });
      }

    case _ActionTypes.FETCH_ALL_TODO_SUCCESS:
      {
        return _objectSpread({}, state, {
          allToDos: action.payload,
          toDos: action.payload,
          loader: false
        });
      }

    case _ActionTypes.FETCH_ALL_TODO_CONVERSATION_SUCCESS:
      {
        return _objectSpread({}, state, {
          todoConversation: action.payload
        });
      }

    case _ActionTypes.SHOW_MESSAGE:
      {
        return _objectSpread({}, state, {
          alertMessage: action.payload,
          showMessage: true,
          loader: false
        });
      }

    default:
      return state;
  }
};

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/ToDo.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/ToDo.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_todoConversation, "_todoConversation", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/ToDo.js");

  __REACT_HOT_LOADER__.register(_todo, "_todo", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/ToDo.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/ToDo.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/ToDo.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/ToDo.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/ToDo.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/ToDo.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/ToDo.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/ToDo.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/ToDo.js");
}();

;

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = sortableContainer;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(35);

var _invariant = __webpack_require__(229);

var _invariant2 = _interopRequireDefault(_invariant);

var _Manager = __webpack_require__(1117);

var _Manager2 = _interopRequireDefault(_Manager);

var _utils = __webpack_require__(251);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Export Higher Order Sortable Container Component
function sortableContainer(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };

  return _temp = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class(props) {
      _classCallCheck(this, _class);

      var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

      _this.handleStart = function (e) {
        var _this$props = _this.props,
            distance = _this$props.distance,
            shouldCancelStart = _this$props.shouldCancelStart;


        if (e.button === 2 || shouldCancelStart(e)) {
          return false;
        }

        _this._touched = true;
        _this._pos = {
          x: e.pageX,
          y: e.pageY
        };

        var node = (0, _utils.closest)(e.target, function (el) {
          return el.sortableInfo != null;
        });

        if (node && node.sortableInfo && _this.nodeIsChild(node) && !_this.state.sorting) {
          var useDragHandle = _this.props.useDragHandle;
          var _node$sortableInfo = node.sortableInfo,
              index = _node$sortableInfo.index,
              collection = _node$sortableInfo.collection;


          if (useDragHandle && !(0, _utils.closest)(e.target, function (el) {
            return el.sortableHandle != null;
          })) return;

          _this.manager.active = { index: index, collection: collection };

          /*
          * Fixes a bug in Firefox where the :active state of anchor tags
          * prevent subsequent 'mousemove' events from being fired
          * (see https://github.com/clauderic/react-sortable-hoc/issues/118)
          */
          if (e.target.tagName.toLowerCase() === 'a') {
            e.preventDefault();
          }

          if (!distance) {
            if (_this.props.pressDelay === 0) {
              _this.handlePress(e);
            } else {
              _this.pressTimer = setTimeout(function () {
                return _this.handlePress(e);
              }, _this.props.pressDelay);
            }
          }
        }
      };

      _this.nodeIsChild = function (node) {
        return node.sortableInfo.manager === _this.manager;
      };

      _this.handleMove = function (e) {
        var _this$props2 = _this.props,
            distance = _this$props2.distance,
            pressThreshold = _this$props2.pressThreshold;


        if (!_this.state.sorting && _this._touched) {
          _this._delta = {
            x: _this._pos.x - e.pageX,
            y: _this._pos.y - e.pageY
          };
          var delta = Math.abs(_this._delta.x) + Math.abs(_this._delta.y);

          if (!distance && (!pressThreshold || pressThreshold && delta >= pressThreshold)) {
            clearTimeout(_this.cancelTimer);
            _this.cancelTimer = setTimeout(_this.cancel, 0);
          } else if (distance && delta >= distance && _this.manager.isActive()) {
            _this.handlePress(e);
          }
        }
      };

      _this.handleEnd = function () {
        var distance = _this.props.distance;


        _this._touched = false;

        if (!distance) {
          _this.cancel();
        }
      };

      _this.cancel = function () {
        if (!_this.state.sorting) {
          clearTimeout(_this.pressTimer);
          _this.manager.active = null;
        }
      };

      _this.handlePress = function (e) {
        var active = _this.manager.getActive();

        if (active) {
          var _this$props3 = _this.props,
              axis = _this$props3.axis,
              getHelperDimensions = _this$props3.getHelperDimensions,
              helperClass = _this$props3.helperClass,
              hideSortableGhost = _this$props3.hideSortableGhost,
              onSortStart = _this$props3.onSortStart,
              useWindowAsScrollContainer = _this$props3.useWindowAsScrollContainer;
          var node = active.node,
              collection = active.collection;
          var index = node.sortableInfo.index;

          var margin = (0, _utils.getElementMargin)(node);

          var containerBoundingRect = _this.container.getBoundingClientRect();
          var dimensions = getHelperDimensions({ index: index, node: node, collection: collection });

          _this.node = node;
          _this.margin = margin;
          _this.width = dimensions.width;
          _this.height = dimensions.height;
          _this.marginOffset = {
            x: _this.margin.left + _this.margin.right,
            y: Math.max(_this.margin.top, _this.margin.bottom)
          };
          _this.boundingClientRect = node.getBoundingClientRect();
          _this.containerBoundingRect = containerBoundingRect;
          _this.index = index;
          _this.newIndex = index;

          _this.axis = {
            x: axis.indexOf('x') >= 0,
            y: axis.indexOf('y') >= 0
          };
          _this.offsetEdge = _this.getEdgeOffset(node);
          _this.initialOffset = _this.getOffset(e);
          _this.initialScroll = {
            top: _this.scrollContainer.scrollTop,
            left: _this.scrollContainer.scrollLeft
          };

          _this.initialWindowScroll = {
            top: window.pageYOffset,
            left: window.pageXOffset
          };

          var fields = node.querySelectorAll('input, textarea, select');
          var clonedNode = node.cloneNode(true);
          var clonedFields = [].concat(_toConsumableArray(clonedNode.querySelectorAll('input, textarea, select'))); // Convert NodeList to Array

          clonedFields.forEach(function (field, index) {
            if (field.type !== 'file' && fields[index]) {
              field.value = fields[index].value;
            }
          });

          _this.helper = _this.document.body.appendChild(clonedNode);

          _this.helper.style.position = 'fixed';
          _this.helper.style.top = _this.boundingClientRect.top - margin.top + 'px';
          _this.helper.style.left = _this.boundingClientRect.left - margin.left + 'px';
          _this.helper.style.width = _this.width + 'px';
          _this.helper.style.height = _this.height + 'px';
          _this.helper.style.boxSizing = 'border-box';
          _this.helper.style.pointerEvents = 'none';

          if (hideSortableGhost) {
            _this.sortableGhost = node;
            node.style.visibility = 'hidden';
            node.style.opacity = 0;
          }

          _this.minTranslate = {};
          _this.maxTranslate = {};
          if (_this.axis.x) {
            _this.minTranslate.x = (useWindowAsScrollContainer ? 0 : containerBoundingRect.left) - _this.boundingClientRect.left - _this.width / 2;
            _this.maxTranslate.x = (useWindowAsScrollContainer ? _this.contentWindow.innerWidth : containerBoundingRect.left + containerBoundingRect.width) - _this.boundingClientRect.left - _this.width / 2;
          }
          if (_this.axis.y) {
            _this.minTranslate.y = (useWindowAsScrollContainer ? 0 : containerBoundingRect.top) - _this.boundingClientRect.top - _this.height / 2;
            _this.maxTranslate.y = (useWindowAsScrollContainer ? _this.contentWindow.innerHeight : containerBoundingRect.top + containerBoundingRect.height) - _this.boundingClientRect.top - _this.height / 2;
          }

          if (helperClass) {
            var _this$helper$classLis;

            (_this$helper$classLis = _this.helper.classList).add.apply(_this$helper$classLis, _toConsumableArray(helperClass.split(' ')));
          }

          _this.listenerNode = e.touches ? node : _this.contentWindow;
          _utils.events.move.forEach(function (eventName) {
            return _this.listenerNode.addEventListener(eventName, _this.handleSortMove, false);
          });
          _utils.events.end.forEach(function (eventName) {
            return _this.listenerNode.addEventListener(eventName, _this.handleSortEnd, false);
          });

          _this.setState({
            sorting: true,
            sortingIndex: index
          });

          if (onSortStart) onSortStart({ node: node, index: index, collection: collection }, e);
        }
      };

      _this.handleSortMove = function (e) {
        var onSortMove = _this.props.onSortMove;

        e.preventDefault(); // Prevent scrolling on mobile

        _this.updatePosition(e);
        _this.animateNodes();
        _this.autoscroll();

        if (onSortMove) onSortMove(e);
      };

      _this.handleSortEnd = function (e) {
        var _this$props4 = _this.props,
            hideSortableGhost = _this$props4.hideSortableGhost,
            onSortEnd = _this$props4.onSortEnd;
        var collection = _this.manager.active.collection;

        // Remove the event listeners if the node is still in the DOM

        if (_this.listenerNode) {
          _utils.events.move.forEach(function (eventName) {
            return _this.listenerNode.removeEventListener(eventName, _this.handleSortMove);
          });
          _utils.events.end.forEach(function (eventName) {
            return _this.listenerNode.removeEventListener(eventName, _this.handleSortEnd);
          });
        }

        // Remove the helper from the DOM
        _this.helper.parentNode.removeChild(_this.helper);

        if (hideSortableGhost && _this.sortableGhost) {
          _this.sortableGhost.style.visibility = '';
          _this.sortableGhost.style.opacity = '';
        }

        var nodes = _this.manager.refs[collection];
        for (var i = 0, len = nodes.length; i < len; i++) {
          var node = nodes[i];
          var el = node.node;

          // Clear the cached offsetTop / offsetLeft value
          node.edgeOffset = null;

          // Remove the transforms / transitions
          el.style[_utils.vendorPrefix + 'Transform'] = '';
          el.style[_utils.vendorPrefix + 'TransitionDuration'] = '';
        }

        // Stop autoscroll
        clearInterval(_this.autoscrollInterval);
        _this.autoscrollInterval = null;

        // Update state
        _this.manager.active = null;

        _this.setState({
          sorting: false,
          sortingIndex: null
        });

        if (typeof onSortEnd === 'function') {
          onSortEnd({
            oldIndex: _this.index,
            newIndex: _this.newIndex,
            collection: collection
          }, e);
        }

        _this._touched = false;
      };

      _this.autoscroll = function () {
        var translate = _this.translate;
        var direction = {
          x: 0,
          y: 0
        };
        var speed = {
          x: 1,
          y: 1
        };
        var acceleration = {
          x: 10,
          y: 10
        };

        if (translate.y >= _this.maxTranslate.y - _this.height / 2) {
          direction.y = 1; // Scroll Down
          speed.y = acceleration.y * Math.abs((_this.maxTranslate.y - _this.height / 2 - translate.y) / _this.height);
        } else if (translate.x >= _this.maxTranslate.x - _this.width / 2) {
          direction.x = 1; // Scroll Right
          speed.x = acceleration.x * Math.abs((_this.maxTranslate.x - _this.width / 2 - translate.x) / _this.width);
        } else if (translate.y <= _this.minTranslate.y + _this.height / 2) {
          direction.y = -1; // Scroll Up
          speed.y = acceleration.y * Math.abs((translate.y - _this.height / 2 - _this.minTranslate.y) / _this.height);
        } else if (translate.x <= _this.minTranslate.x + _this.width / 2) {
          direction.x = -1; // Scroll Left
          speed.x = acceleration.x * Math.abs((translate.x - _this.width / 2 - _this.minTranslate.x) / _this.width);
        }

        if (_this.autoscrollInterval) {
          clearInterval(_this.autoscrollInterval);
          _this.autoscrollInterval = null;
          _this.isAutoScrolling = false;
        }

        if (direction.x !== 0 || direction.y !== 0) {
          _this.autoscrollInterval = setInterval(function () {
            _this.isAutoScrolling = true;
            var offset = {
              left: 1 * speed.x * direction.x,
              top: 1 * speed.y * direction.y
            };
            _this.scrollContainer.scrollTop += offset.top;
            _this.scrollContainer.scrollLeft += offset.left;
            _this.translate.x += offset.left;
            _this.translate.y += offset.top;
            _this.animateNodes();
          }, 5);
        }
      };

      _this.manager = new _Manager2.default();
      _this.events = {
        start: _this.handleStart,
        move: _this.handleMove,
        end: _this.handleEnd
      };

      (0, _invariant2.default)(!(props.distance && props.pressDelay), 'Attempted to set both `pressDelay` and `distance` on SortableContainer, you may only use one or the other, not both at the same time.');

      _this.state = {};
      return _this;
    }

    _createClass(_class, [{
      key: 'getChildContext',
      value: function getChildContext() {
        return {
          manager: this.manager
        };
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        var _props = this.props,
            getContainer = _props.getContainer,
            useWindowAsScrollContainer = _props.useWindowAsScrollContainer;

        /*
         *  Set our own default rather than using defaultProps because Jest
         *  snapshots will serialize window, causing a RangeError
         *  https://github.com/clauderic/react-sortable-hoc/issues/249
         */

        var contentWindow = this.props.contentWindow || window;

        this.container = typeof getContainer === 'function' ? getContainer(this.getWrappedInstance()) : (0, _reactDom.findDOMNode)(this);
        this.document = this.container.ownerDocument || document;
        this.scrollContainer = useWindowAsScrollContainer ? this.document.body : this.container;
        this.contentWindow = typeof contentWindow === 'function' ? contentWindow() : contentWindow;

        var _loop = function _loop(key) {
          if (_this2.events.hasOwnProperty(key)) {
            _utils.events[key].forEach(function (eventName) {
              return _this2.container.addEventListener(eventName, _this2.events[key], false);
            });
          }
        };

        for (var key in this.events) {
          _loop(key);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var _this3 = this;

        var _loop2 = function _loop2(key) {
          if (_this3.events.hasOwnProperty(key)) {
            _utils.events[key].forEach(function (eventName) {
              return _this3.container.removeEventListener(eventName, _this3.events[key]);
            });
          }
        };

        for (var key in this.events) {
          _loop2(key);
        }
      }
    }, {
      key: 'getEdgeOffset',
      value: function getEdgeOffset(node) {
        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { top: 0, left: 0 };

        // Get the actual offsetTop / offsetLeft value, no matter how deep the node is nested
        if (node) {
          var nodeOffset = {
            top: offset.top + node.offsetTop,
            left: offset.left + node.offsetLeft
          };
          if (node.parentNode !== this.container) {
            return this.getEdgeOffset(node.parentNode, nodeOffset);
          } else {
            return nodeOffset;
          }
        }
      }
    }, {
      key: 'getOffset',
      value: function getOffset(e) {
        return {
          x: e.touches ? e.touches[0].pageX : e.pageX,
          y: e.touches ? e.touches[0].pageY : e.pageY
        };
      }
    }, {
      key: 'getLockPixelOffsets',
      value: function getLockPixelOffsets() {
        var lockOffset = this.props.lockOffset;


        if (!Array.isArray(lockOffset)) {
          lockOffset = [lockOffset, lockOffset];
        }

        (0, _invariant2.default)(lockOffset.length === 2, 'lockOffset prop of SortableContainer should be a single ' + 'value or an array of exactly two values. Given %s', lockOffset);

        var _lockOffset = lockOffset,
            _lockOffset2 = _slicedToArray(_lockOffset, 2),
            minLockOffset = _lockOffset2[0],
            maxLockOffset = _lockOffset2[1];

        return [this.getLockPixelOffset(minLockOffset), this.getLockPixelOffset(maxLockOffset)];
      }
    }, {
      key: 'getLockPixelOffset',
      value: function getLockPixelOffset(lockOffset) {
        var offsetX = lockOffset;
        var offsetY = lockOffset;
        var unit = 'px';

        if (typeof lockOffset === 'string') {
          var match = /^[+-]?\d*(?:\.\d*)?(px|%)$/.exec(lockOffset);

          (0, _invariant2.default)(match !== null, 'lockOffset value should be a number or a string of a ' + 'number followed by "px" or "%". Given %s', lockOffset);

          offsetX = offsetY = parseFloat(lockOffset);
          unit = match[1];
        }

        (0, _invariant2.default)(isFinite(offsetX) && isFinite(offsetY), 'lockOffset value should be a finite. Given %s', lockOffset);

        if (unit === '%') {
          offsetX = offsetX * this.width / 100;
          offsetY = offsetY * this.height / 100;
        }

        return {
          x: offsetX,
          y: offsetY
        };
      }
    }, {
      key: 'updatePosition',
      value: function updatePosition(e) {
        var _props2 = this.props,
            lockAxis = _props2.lockAxis,
            lockToContainerEdges = _props2.lockToContainerEdges;


        var offset = this.getOffset(e);
        var translate = {
          x: offset.x - this.initialOffset.x,
          y: offset.y - this.initialOffset.y
        };
        // Adjust for window scroll
        translate.y -= window.pageYOffset - this.initialWindowScroll.top;
        translate.x -= window.pageXOffset - this.initialWindowScroll.left;

        this.translate = translate;

        if (lockToContainerEdges) {
          var _getLockPixelOffsets = this.getLockPixelOffsets(),
              _getLockPixelOffsets2 = _slicedToArray(_getLockPixelOffsets, 2),
              minLockOffset = _getLockPixelOffsets2[0],
              maxLockOffset = _getLockPixelOffsets2[1];

          var minOffset = {
            x: this.width / 2 - minLockOffset.x,
            y: this.height / 2 - minLockOffset.y
          };
          var maxOffset = {
            x: this.width / 2 - maxLockOffset.x,
            y: this.height / 2 - maxLockOffset.y
          };

          translate.x = (0, _utils.limit)(this.minTranslate.x + minOffset.x, this.maxTranslate.x - maxOffset.x, translate.x);
          translate.y = (0, _utils.limit)(this.minTranslate.y + minOffset.y, this.maxTranslate.y - maxOffset.y, translate.y);
        }

        if (lockAxis === 'x') {
          translate.y = 0;
        } else if (lockAxis === 'y') {
          translate.x = 0;
        }

        this.helper.style[_utils.vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px, 0)';
      }
    }, {
      key: 'animateNodes',
      value: function animateNodes() {
        var _props3 = this.props,
            transitionDuration = _props3.transitionDuration,
            hideSortableGhost = _props3.hideSortableGhost;

        var nodes = this.manager.getOrderedRefs();
        var deltaScroll = {
          left: this.scrollContainer.scrollLeft - this.initialScroll.left,
          top: this.scrollContainer.scrollTop - this.initialScroll.top
        };
        var sortingOffset = {
          left: this.offsetEdge.left + this.translate.x + deltaScroll.left,
          top: this.offsetEdge.top + this.translate.y + deltaScroll.top
        };
        var scrollDifference = {
          top: window.pageYOffset - this.initialWindowScroll.top,
          left: window.pageXOffset - this.initialWindowScroll.left
        };
        this.newIndex = null;

        for (var i = 0, len = nodes.length; i < len; i++) {
          var node = nodes[i].node;

          var index = node.sortableInfo.index;
          var width = node.offsetWidth;
          var height = node.offsetHeight;
          var offset = {
            width: this.width > width ? width / 2 : this.width / 2,
            height: this.height > height ? height / 2 : this.height / 2
          };

          var translate = {
            x: 0,
            y: 0
          };
          var edgeOffset = nodes[i].edgeOffset;

          // If we haven't cached the node's offsetTop / offsetLeft value

          if (!edgeOffset) {
            nodes[i].edgeOffset = edgeOffset = this.getEdgeOffset(node);
          }

          // Get a reference to the next and previous node
          var nextNode = i < nodes.length - 1 && nodes[i + 1];
          var prevNode = i > 0 && nodes[i - 1];

          // Also cache the next node's edge offset if needed.
          // We need this for calculating the animation in a grid setup
          if (nextNode && !nextNode.edgeOffset) {
            nextNode.edgeOffset = this.getEdgeOffset(nextNode.node);
          }

          // If the node is the one we're currently animating, skip it
          if (index === this.index) {
            if (hideSortableGhost) {
              /*
              * With windowing libraries such as `react-virtualized`, the sortableGhost
              * node may change while scrolling down and then back up (or vice-versa),
              * so we need to update the reference to the new node just to be safe.
              */
              this.sortableGhost = node;
              node.style.visibility = 'hidden';
              node.style.opacity = 0;
            }
            continue;
          }

          if (transitionDuration) {
            node.style[_utils.vendorPrefix + 'TransitionDuration'] = transitionDuration + 'ms';
          }

          if (this.axis.x) {
            if (this.axis.y) {
              // Calculations for a grid setup
              if (index < this.index && (sortingOffset.left + scrollDifference.left - offset.width <= edgeOffset.left && sortingOffset.top + scrollDifference.top <= edgeOffset.top + offset.height || sortingOffset.top + scrollDifference.top + offset.height <= edgeOffset.top)) {
                // If the current node is to the left on the same row, or above the node that's being dragged
                // then move it to the right
                translate.x = this.width + this.marginOffset.x;
                if (edgeOffset.left + translate.x > this.containerBoundingRect.width - offset.width) {
                  // If it moves passed the right bounds, then animate it to the first position of the next row.
                  // We just use the offset of the next node to calculate where to move, because that node's original position
                  // is exactly where we want to go
                  translate.x = nextNode.edgeOffset.left - edgeOffset.left;
                  translate.y = nextNode.edgeOffset.top - edgeOffset.top;
                }
                if (this.newIndex === null) {
                  this.newIndex = index;
                }
              } else if (index > this.index && (sortingOffset.left + scrollDifference.left + offset.width >= edgeOffset.left && sortingOffset.top + scrollDifference.top + offset.height >= edgeOffset.top || sortingOffset.top + scrollDifference.top + offset.height >= edgeOffset.top + height)) {
                // If the current node is to the right on the same row, or below the node that's being dragged
                // then move it to the left
                translate.x = -(this.width + this.marginOffset.x);
                if (edgeOffset.left + translate.x < this.containerBoundingRect.left + offset.width) {
                  // If it moves passed the left bounds, then animate it to the last position of the previous row.
                  // We just use the offset of the previous node to calculate where to move, because that node's original position
                  // is exactly where we want to go
                  translate.x = prevNode.edgeOffset.left - edgeOffset.left;
                  translate.y = prevNode.edgeOffset.top - edgeOffset.top;
                }
                this.newIndex = index;
              }
            } else {
              if (index > this.index && sortingOffset.left + scrollDifference.left + offset.width >= edgeOffset.left) {
                translate.x = -(this.width + this.marginOffset.x);
                this.newIndex = index;
              } else if (index < this.index && sortingOffset.left + scrollDifference.left <= edgeOffset.left + offset.width) {
                translate.x = this.width + this.marginOffset.x;
                if (this.newIndex == null) {
                  this.newIndex = index;
                }
              }
            }
          } else if (this.axis.y) {
            if (index > this.index && sortingOffset.top + scrollDifference.top + offset.height >= edgeOffset.top) {
              translate.y = -(this.height + this.marginOffset.y);
              this.newIndex = index;
            } else if (index < this.index && sortingOffset.top + scrollDifference.top <= edgeOffset.top + offset.height) {
              translate.y = this.height + this.marginOffset.y;
              if (this.newIndex == null) {
                this.newIndex = index;
              }
            }
          }
          node.style[_utils.vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px,0)';
        }

        if (this.newIndex == null) {
          this.newIndex = this.index;
        }
      }
    }, {
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableContainer() call');
        return this.refs.wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;

        return _react2.default.createElement(WrappedComponent, _extends({
          ref: ref
        }, (0, _utils.omit)(this.props, 'contentWindow', 'useWindowAsScrollContainer', 'distance', 'helperClass', 'hideSortableGhost', 'transitionDuration', 'useDragHandle', 'pressDelay', 'pressThreshold', 'shouldCancelStart', 'onSortStart', 'onSortMove', 'onSortEnd', 'axis', 'lockAxis', 'lockOffset', 'lockToContainerEdges', 'getContainer', 'getHelperDimensions')));
      }
    }]);

    return _class;
  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableList', WrappedComponent), _class.defaultProps = {
    axis: 'y',
    transitionDuration: 300,
    pressDelay: 0,
    pressThreshold: 5,
    distance: 0,
    useWindowAsScrollContainer: false,
    hideSortableGhost: true,
    shouldCancelStart: function shouldCancelStart(e) {
      // Cancel sorting if the event target is an `input`, `textarea`, `select` or `option`
      var disabledElements = ['input', 'textarea', 'select', 'option', 'button'];

      if (disabledElements.indexOf(e.target.tagName.toLowerCase()) !== -1) {
        return true; // Return true to cancel sorting
      }
    },
    lockToContainerEdges: false,
    lockOffset: '50%',
    getHelperDimensions: function getHelperDimensions(_ref) {
      var node = _ref.node;
      return {
        width: node.offsetWidth,
        height: node.offsetHeight
      };
    }
  }, _class.propTypes = {
    axis: _propTypes2.default.oneOf(['x', 'y', 'xy']),
    distance: _propTypes2.default.number,
    lockAxis: _propTypes2.default.string,
    helperClass: _propTypes2.default.string,
    transitionDuration: _propTypes2.default.number,
    contentWindow: _propTypes2.default.any,
    onSortStart: _propTypes2.default.func,
    onSortMove: _propTypes2.default.func,
    onSortEnd: _propTypes2.default.func,
    shouldCancelStart: _propTypes2.default.func,
    pressDelay: _propTypes2.default.number,
    useDragHandle: _propTypes2.default.bool,
    useWindowAsScrollContainer: _propTypes2.default.bool,
    hideSortableGhost: _propTypes2.default.bool,
    lockToContainerEdges: _propTypes2.default.bool,
    lockOffset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]))]),
    getContainer: _propTypes2.default.func,
    getHelperDimensions: _propTypes2.default.func
  }, _class.childContextTypes = {
    manager: _propTypes2.default.object.isRequired
  }, _temp;
}

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _find = __webpack_require__(626);

var _find2 = _interopRequireDefault(_find);

var _sortBy = __webpack_require__(257);

var _sortBy2 = _interopRequireDefault(_sortBy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Manager = function () {
  function Manager() {
    _classCallCheck(this, Manager);

    this.refs = {};
  }

  _createClass(Manager, [{
    key: 'add',
    value: function add(collection, ref) {
      if (!this.refs[collection]) {
        this.refs[collection] = [];
      }

      this.refs[collection].push(ref);
    }
  }, {
    key: 'remove',
    value: function remove(collection, ref) {
      var index = this.getIndex(collection, ref);

      if (index !== -1) {
        this.refs[collection].splice(index, 1);
      }
    }
  }, {
    key: 'isActive',
    value: function isActive() {
      return this.active;
    }
  }, {
    key: 'getActive',
    value: function getActive() {
      var _this = this;

      return (0, _find2.default)(this.refs[this.active.collection],
      // eslint-disable-next-line eqeqeq
      function (_ref) {
        var node = _ref.node;
        return node.sortableInfo.index == _this.active.index;
      });
    }
  }, {
    key: 'getIndex',
    value: function getIndex(collection, ref) {
      return this.refs[collection].indexOf(ref);
    }
  }, {
    key: 'getOrderedRefs',
    value: function getOrderedRefs() {
      var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.active.collection;

      return (0, _sortBy2.default)(this.refs[collection], function (_ref2) {
        var node = _ref2.node;
        return node.sortableInfo.index;
      });
    }
  }]);

  return Manager;
}();

exports.default = Manager;

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(67),
    isArrayLike = __webpack_require__(130),
    keys = __webpack_require__(159);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(1120),
    getMatchData = __webpack_require__(1163),
    matchesStrictComparable = __webpack_require__(639);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(310),
    baseIsEqual = __webpack_require__(350);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 1121 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(253);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(253);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(253);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(253);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(252);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 1127 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 1128 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 1129 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(252),
    Map = __webpack_require__(348),
    MapCache = __webpack_require__(349);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(21),
    isMasked = __webpack_require__(1134),
    isObject = __webpack_require__(58),
    toSource = __webpack_require__(628);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(168);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 1133 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(1135);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(78);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 1136 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1138),
    ListCache = __webpack_require__(252),
    Map = __webpack_require__(348);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1139),
    hashDelete = __webpack_require__(1140),
    hashGet = __webpack_require__(1141),
    hashHas = __webpack_require__(1142),
    hashSet = __webpack_require__(1143);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(254);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 1140 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(254);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(254);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(254);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(255);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 1145 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(255);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(255);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(255);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(310),
    equalArrays = __webpack_require__(629),
    equalByTag = __webpack_require__(1152),
    equalObjects = __webpack_require__(1154),
    getTag = __webpack_require__(256),
    isArray = __webpack_require__(26),
    isBuffer = __webpack_require__(307),
    isTypedArray = __webpack_require__(434);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 1150 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 1151 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(168),
    Uint8Array = __webpack_require__(631),
    eq = __webpack_require__(234),
    equalArrays = __webpack_require__(629),
    mapToArray = __webpack_require__(1153),
    setToArray = __webpack_require__(351);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 1153 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(632);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 1155 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(111),
    isObjectLike = __webpack_require__(79);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 1157 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(111),
    isLength = __webpack_require__(354),
    isObjectLike = __webpack_require__(79);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(305),
    nativeKeys = __webpack_require__(1160);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(636);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(142),
    root = __webpack_require__(78);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(142),
    root = __webpack_require__(78);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(638),
    keys = __webpack_require__(159);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(350),
    get = __webpack_require__(169),
    hasIn = __webpack_require__(865),
    isKey = __webpack_require__(356),
    isStrictComparable = __webpack_require__(638),
    matchesStrictComparable = __webpack_require__(639),
    toKey = __webpack_require__(203);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(1166);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(864);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(168),
    arrayMap = __webpack_require__(160),
    isArray = __webpack_require__(26),
    isSymbol = __webpack_require__(170);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 1168 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(1170),
    basePropertyDeep = __webpack_require__(1171),
    isKey = __webpack_require__(356),
    toKey = __webpack_require__(203);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 1170 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(314);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(168),
    isArguments = __webpack_require__(313),
    isArray = __webpack_require__(26);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(160),
    baseIteratee = __webpack_require__(67),
    baseMap = __webpack_require__(642),
    baseSortBy = __webpack_require__(1176),
    baseUnary = __webpack_require__(202),
    compareMultiple = __webpack_require__(1177),
    identity = __webpack_require__(158);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  var index = -1;
  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),
/* 1174 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(130);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 1176 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__(1178);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(170);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(1180),
    defineProperty = __webpack_require__(644),
    identity = __webpack_require__(158);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 1180 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = sortableElement;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(35);

var _invariant = __webpack_require__(229);

var _invariant2 = _interopRequireDefault(_invariant);

var _utils = __webpack_require__(251);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Export Higher Order Sortable Element Component
function sortableElement(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };

  return _temp = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _props = this.props,
            collection = _props.collection,
            disabled = _props.disabled,
            index = _props.index;


        if (!disabled) {
          this.setDraggable(collection, index);
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.index !== nextProps.index && this.node) {
          this.node.sortableInfo.index = nextProps.index;
        }
        if (this.props.disabled !== nextProps.disabled) {
          var collection = nextProps.collection,
              disabled = nextProps.disabled,
              index = nextProps.index;

          if (disabled) {
            this.removeDraggable(collection);
          } else {
            this.setDraggable(collection, index);
          }
        } else if (this.props.collection !== nextProps.collection) {
          this.removeDraggable(this.props.collection);
          this.setDraggable(nextProps.collection, nextProps.index);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var _props2 = this.props,
            collection = _props2.collection,
            disabled = _props2.disabled;


        if (!disabled) this.removeDraggable(collection);
      }
    }, {
      key: 'setDraggable',
      value: function setDraggable(collection, index) {
        var node = this.node = (0, _reactDom.findDOMNode)(this);

        node.sortableInfo = {
          index: index,
          collection: collection,
          manager: this.context.manager
        };

        this.ref = { node: node };
        this.context.manager.add(collection, this.ref);
      }
    }, {
      key: 'removeDraggable',
      value: function removeDraggable(collection) {
        this.context.manager.remove(collection, this.ref);
      }
    }, {
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableElement() call');
        return this.refs.wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;

        return _react2.default.createElement(WrappedComponent, _extends({
          ref: ref
        }, (0, _utils.omit)(this.props, 'collection', 'disabled', 'index')));
      }
    }]);

    return _class;
  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableElement', WrappedComponent), _class.contextTypes = {
    manager: _propTypes2.default.object.isRequired
  }, _class.propTypes = {
    index: _propTypes2.default.number.isRequired,
    collection: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    disabled: _propTypes2.default.bool
  }, _class.defaultProps = {
    collection: 0
  }, _temp;
}

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = sortableHandle;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(35);

var _invariant = __webpack_require__(229);

var _invariant2 = _interopRequireDefault(_invariant);

var _utils = __webpack_require__(251);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Export Higher Order Sortable Element Component
function sortableHandle(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };

  return _temp = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var node = (0, _reactDom.findDOMNode)(this);
        node.sortableHandle = true;
      }
    }, {
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableHandle() call');
        return this.refs.wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;

        return _react2.default.createElement(WrappedComponent, _extends({ ref: ref }, this.props));
      }
    }]);

    return _class;
  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableHandle', WrappedComponent), _temp;
}

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ActionTypes = __webpack_require__(7);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var INIT_STATE = {
  loader: false,
  alertMessage: '',
  showMessage: false,
  initURL: '',
  authUser: localStorage.getItem('user_auth'),
  authUserCode: ''
};

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.CLEAR_SESSION:
      {
        return _objectSpread({}, INIT_STATE);
      }

    case _ActionTypes.IDENTITY_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          identity: action.payload
        });
      }

    case _ActionTypes.SIGNUP_USER_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          authUser: action.payload
        });
      }

    case _ActionTypes.SIGNIN_USER_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          authUser: action.payload
        });
      }

    case _ActionTypes.REQUEST_SIGNIN_ACCESS_CODE_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          authUserCode: action.payload
        });
      }

    case _ActionTypes.INIT_URL:
      {
        return _objectSpread({}, state, {
          initURL: action.payload
        });
      }

    case _ActionTypes.SIGNOUT_USER_SUCCESS:
      {
        return _objectSpread({}, state, {
          authUser: null,
          authUserCode: null,
          initURL: '/',
          loader: false
        });
      }

    case _ActionTypes.SHOW_MESSAGE:
      {
        return _objectSpread({}, state, {
          alertMessage: action.payload,
          showMessage: true,
          loader: false
        });
      }

    case _ActionTypes.HIDE_MESSAGE:
      {
        return _objectSpread({}, state, {
          alertMessage: '',
          showMessage: false,
          loader: false
        });
      }

    case _ActionTypes.SIGNIN_GOOGLE_USER_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          authUser: action.payload
        });
      }

    case _ActionTypes.SIGNIN_FACEBOOK_USER_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          authUser: action.payload
        });
      }

    case _ActionTypes.SIGNIN_TWITTER_USER_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          authUser: action.payload
        });
      }

    case _ActionTypes.SIGNIN_GITHUB_USER_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          authUser: action.payload
        });
      }

    case _ActionTypes.ON_SHOW_LOADER:
      {
        return _objectSpread({}, state, {
          loader: true
        });
      }

    case _ActionTypes.ON_HIDE_LOADER:
      {
        return _objectSpread({}, state, {
          loader: false
        });
      }

    default:
      return state;
  }
};

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Auth.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Auth.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Auth.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Auth.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Auth.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Auth.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Auth.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Auth.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Auth.js");
}();

;

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.INIT_STATE = void 0;

var _ActionTypes = __webpack_require__(7);

var _arrayService = __webpack_require__(34);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var INIT_STATE = {
  alertMessage: '',
  showMessage: false,
  loader: false,
  noContentFoundMessage: 'No organisations found in selected folder',
  selectedSectionId: 1,
  drawerState: false,
  filterOption: 'All orgs',
  allOrg: [],
  orgList: [],
  selectedOrg: null,
  selectedOrgs: 0,
  addOrgState: false,
  searchOrg: '',
  orgDashboardData: {},
  orgStatisticsData: {},
  org: {
    name: 'ACME Inc',
    email: 'road.runner@example.com',
    avatar: 'assets/images/organisation-150_150.jpg'
  }
};
exports.INIT_STATE = INIT_STATE;

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.CLEAR_SESSION:
      {
        return _objectSpread({}, INIT_STATE);
      }

    case _ActionTypes.CLEAR_SELECTED_OBJECTS:
      {
        return _objectSpread({}, state, {
          selectedOrg: null
        });
      }

    case _ActionTypes.FETCH_ORG_STATISTICS_SUCCESS:
      {
        return _objectSpread({}, state, {
          orgStatisticsData: action.payload
        });
      }

    case _ActionTypes.ON_EMP_DASHBOARD:
    case _ActionTypes.ON_PROJECT_DASHBOARD:
    case _ActionTypes.ON_IMPERSONATE_DASHBOARD:
    case _ActionTypes.ON_ORG_SURVEY_DASHBOARD:
    case _ActionTypes.ON_ORG_SURVEY_COMPARE_DASHBOARD:
      {
        var _action$payload;

        return _objectSpread({}, state, {
          loader: false,
          selectedOrg: action.payload,
          org: _objectSpread({}, state.org, {
            name: (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.name
          })
        });
      }

    case _ActionTypes.ON_ORG_DASHBOARD_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          orgDashboardData: action.payload
        });
      }

    case _ActionTypes.ADD_FAVOURITE_ORG:
      {
        return _objectSpread({}, state, {
          alertMessage: action.payload.starred ? 'Organisation removed as star' : 'Organisation marked as star',
          showMessage: true,
          orgList: state.orgList.map(function (org) {
            return org.id === action.payload.id ? _objectSpread({}, org, {
              starred: !action.payload.starred
            }) : org;
          }),
          allOrg: state.allOrg.map(function (org) {
            return org.id === action.payload.id ? _objectSpread({}, org, {
              starred: !action.payload.starred
            }) : org;
          })
        });
      }

    case _ActionTypes.FETCH_ORG_SUCCESS:
      {
        var _action$payload2;

        return _objectSpread({}, state, {
          loader: false,
          selectedOrg: action.payload,
          org: _objectSpread({}, state.org, {
            name: (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.name
          })
        });
      }

    case _ActionTypes.FETCH_ALL_ORG_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          allOrg: action.payload,
          orgList: action.payload
        });
      }

    case _ActionTypes.SHOW_ORG_MESSAGE:
      {
        return _objectSpread({}, state, {
          alertMessage: action.payload,
          showMessage: true,
          loader: false
        });
      }

    case _ActionTypes.ON_ORG_SELECT:
      {
        action.payload.selected = !action.payload.selected;
        var selectedOrgs = 0;
        var orgList = state.orgList.map(function (org) {
          if (org.selected) {
            selectedOrgs++;
          }

          if (org.id === action.payload.id) {
            if (org.selected) {
              selectedOrgs++;
            }

            return action.payload;
          } else {
            return org;
          }
        });
        return _objectSpread({}, state, {
          INIT_STATE: INIT_STATE,
          selectedOrgs: selectedOrgs,
          orgList: orgList
        });
      }

    case _ActionTypes.ON_ADD_ORG:
      {
        return _objectSpread({}, state, {
          addOrgState: true
        });
      }

    case _ActionTypes.ON_ORG_CLOSE:
      {
        return _objectSpread({}, state, {
          addOrgState: false
        });
      }

    case _ActionTypes.ON_FILTER_ORG_OPTION_SELECT:
      {
        var selectedSectionId = 0;
        var filterOption = '';
        var _orgList = [];

        switch (action.payload.name) {
          case 'All organisations':
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              _orgList = state.allOrg;
              break;
            }

          case 'Frequently accessed':
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              _orgList = state.allOrg.filter(function (org) {
                return org.frequently;
              });
              break;
            }

          case 'Starred organisations':
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              _orgList = state.allOrg.filter(function (org) {
                return org.starred;
              });
              break;
            }
        }

        return _objectSpread({}, state, {
          selectedSectionId: selectedSectionId,
          filterOption: filterOption,
          orgList: _orgList,
          drawerState: false
        });
      }

    case _ActionTypes.ON_SAVE_ORG_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: 'Organisation Updated Successfully',
          showMessage: true,
          orgList: (0, _arrayService.addOrUpdateEntry)(state.orgList, action.payload),
          allOrg: (0, _arrayService.addOrUpdateEntry)(state.allOrg, action.payload),
          loader: false
        });
      }

    case _ActionTypes.ON_DELETE_ORG:
      {
        return _objectSpread({}, state, {
          alertMessage: 'Organisation Deleted Successfully',
          showMessage: true,
          allOrg: state.allOrg.filter(function (org) {
            return org.id !== action.payload.id;
          }),
          orgList: state.allOrg.filter(function (org) {
            return org.id !== action.payload.id;
          })
        });
      }

    case _ActionTypes.ON_DELETE_SELECTED_ORG:
      {
        var orgs = state.allOrg.filter(function (org) {
          return !org.selected;
        });
        return _objectSpread({}, state, {
          alertMessage: 'Organisation Deleted Successfully',
          showMessage: true,
          allOrg: orgs,
          orgList: orgs,
          selectedOrgs: 0
        });
      }

    case _ActionTypes.FILTER_ORG:
      {
        var _filterOption = state.filterOption;
        var _orgList2 = [];

        if (action.payload === '') {
          _orgList2 = state.allOrg;
        } else {
          var filterOrganisation = state.allOrg.filter(function (org) {
            return org.name.toLowerCase().indexOf(action.payload.toLowerCase()) > -1;
          });

          if (_filterOption === 'All organisations') {
            _orgList2 = filterOrganisation;
          } else if (_filterOption === 'Frequently accessed') {
            _orgList2 = filterOrganisation.filter(function (org) {
              return org.frequently;
            });
          } else if (_filterOption === 'Starred organisations') {
            _orgList2 = filterOrganisation.filter(function (org) {
              return org.starred;
            });
          }
        }

        return _objectSpread({}, state, {
          orgList: _orgList2
        });
      }

    case _ActionTypes.GET_ALL_ORG:
      {
        var _orgList3 = state.allOrg.map(function (org) {
          return org ? _objectSpread({}, org, {
            selected: true
          }) : org;
        });

        return _objectSpread({}, state, {
          selectedOrgs: _orgList3.length,
          allOrg: _orgList3,
          orgList: _orgList3
        });
      }

    case _ActionTypes.GET_UNSELECTED_ALL_ORG:
      {
        var _orgList4 = state.allOrg.map(function (org) {
          return org ? _objectSpread({}, org, {
            selected: false
          }) : org;
        });

        return _objectSpread({}, state, {
          selectedOrgs: 0,
          allOrg: _orgList4,
          orgList: _orgList4
        });
      }

    case _ActionTypes.ON_ALL_ORG_SELECT:
      {
        var selectAll = state.selectedOrgs < state.orgList.length;
        var _selectedOrgs = 0;
        var _orgList5 = [];

        if (selectAll) {
          _orgList5 = state.allOrg.map(function (org) {
            return org ? _objectSpread({}, org, {
              selected: true
            }) : org;
          });
          _selectedOrgs = _orgList5.length;
        } else {
          _orgList5 = state.allOrg.map(function (org) {
            return org ? _objectSpread({}, org, {
              selected: true
            }) : org;
          });
          _selectedOrgs = 0;
        }

        return _objectSpread({}, state, {
          selectedOrgs: _selectedOrgs,
          allOrg: _orgList5,
          orgList: _orgList5
        });
      }

    case _ActionTypes.UPDATE_SEARCH_ORG:
      {
        return _objectSpread({}, state, {
          searchOrg: action.payload
        });
      }

    case _ActionTypes.HANDLE_ORG_REQUEST_CLOSE:
      {
        return _objectSpread({}, state, {
          showMessage: false
        });
      }

    case _ActionTypes.ON_TOGGLE_ORG_DRAWER:
      {
        return _objectSpread({}, state, {
          drawerState: !state.drawerState
        });
      }

    case _ActionTypes.SHOW_ORG_LOADER:
      {
        return _objectSpread({}, state, {
          loader: true
        });
      }

    case _ActionTypes.HIDE_ORG_LOADER:
      {
        return _objectSpread({}, state, {
          loader: false
        });
      }

    default:
      return state;
  }
};

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Organisation.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Organisation.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Organisation.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Organisation.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Organisation.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Organisation.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Organisation.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Organisation.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Organisation.js");
}();

;

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ActionTypes = __webpack_require__(7);

var _arrayService = __webpack_require__(34);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var INIT_STATE = {
  alertMessage: '',
  showMessage: false,
  loader: false,
  noContentFoundMessage: 'No employees found in selected folder',
  selectedSectionId: 1,
  drawerState: false,
  filterOption: 'All employees',
  allEmp: [],
  empList: [],
  selectedEmp: null,
  selectedEmps: 0,
  addEmpState: false,
  searchEmp: '',
  empSurveyAnswers: {},
  notifications: [],
  loadingDashboard: false,
  emp: {
    name: 'ACME Inc',
    email: 'road.runner@example.com',
    avatar: 'assets/images/organisation-150_150.jpg'
  }
};

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.FETCH_NOTIFICATIONS_SUCCESS:
      {
        return _objectSpread({}, state, {
          notifications: action.payload
        });
      }

    case _ActionTypes.ADD_FAVOURITE_EMP_SUCCESS:
      {
        var allEmpUpdated = state.allEmp.map(function (emp) {
          var _action$payload, _action$payload2;

          return (emp === null || emp === void 0 ? void 0 : emp.id) === (action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.id) ? _objectSpread({}, emp, {
            starred: !(action === null || action === void 0 ? void 0 : (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.starred)
          }) : emp;
        });
        var empListUpdated = {};

        switch (state.filterOption) {
          case 'All employees':
            {
              empListUpdated = allEmpUpdated;
              break;
            }

          case 'Starred employees':
            {
              empListUpdated = allEmpUpdated.filter(function (emp) {
                return emp.starred;
              });
              break;
            }
        }

        return _objectSpread({}, state, {
          alertMessage: action.payload.starred ? 'Employee removed as star' : 'Employee marked as star',
          showMessage: true,
          empList: empListUpdated,
          allEmp: allEmpUpdated
        });
      }

    case _ActionTypes.FETCH_ALL_EMP_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          allEmp: action.payload,
          empList: action.payload,
          selectedSectionId: 1,
          searchEmp: '',
          filterOption: 'All employees'
        });
      }

    case _ActionTypes.FETCH_EMP_SURVEY_ANSWERS_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          empSurveyAnswers: action.payload
        });
      }

    case _ActionTypes.SHOW_EMP_MESSAGE:
      {
        return _objectSpread({}, state, {
          alertMessage: action.payload,
          showMessage: true,
          loader: false
        });
      }

    case _ActionTypes.ON_EMP_SELECT:
      {
        action.payload.selected = !action.payload.selected;
        var selectedEmps = 0;
        var empList = state.empList.map(function (emp) {
          if (emp.selected) {
            selectedEmps++;
          }

          if (emp.id === action.payload.id) {
            if (emp.selected) {
              selectedEmps++;
            }

            return action.payload;
          } else {
            return emp;
          }
        });
        return _objectSpread({}, state, {
          INIT_STATE: INIT_STATE,
          selectedEmps: selectedEmps,
          empList: empList
        });
      }

    case _ActionTypes.ON_ADD_EMP:
      {
        return _objectSpread({}, state, {
          addEmpState: true
        });
      }

    case _ActionTypes.ON_EMP_CLOSE:
      {
        return _objectSpread({}, state, {
          addEmpState: false
        });
      }

    case _ActionTypes.ON_FILTER_EMP_OPTION_SELECT:
      {
        var selectedSectionId = 0;
        var filterOption = '';
        var _empList = [];

        switch (action.payload.name) {
          case 'All employees':
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              _empList = state.allEmp;
              break;
            }

          case 'Starred employees':
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              _empList = state.allEmp.filter(function (emp) {
                return emp.starred;
              });
              break;
            }
        }

        return _objectSpread({}, state, {
          selectedSectionId: selectedSectionId,
          filterOption: filterOption,
          empList: _empList,
          drawerState: false
        });
      }

    case _ActionTypes.ON_SAVE_EMP_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: 'Employee Updated Successfully',
          showMessage: true,
          empList: (0, _arrayService.addOrUpdateEntry)(state.empList, action.payload),
          allEmp: (0, _arrayService.addOrUpdateEntry)(state.allEmp, action.payload),
          loader: false
        });
      }

    case _ActionTypes.ON_DELETE_EMP:
      {
        return _objectSpread({}, state, {
          alertMessage: 'Employee Deleted Successfully',
          showMessage: true,
          allEmp: state.allEmp.filter(function (emp) {
            return emp.id !== action.payload.id;
          }),
          empList: state.allEmp.filter(function (emp) {
            return emp.id !== action.payload.id;
          })
        });
      }

    case _ActionTypes.ON_DELETE_SELECTED_EMP:
      {
        var emps = state.allEmp.filter(function (emp) {
          return !emp.selected;
        });
        return _objectSpread({}, state, {
          alertMessage: 'Employee Filtered Successfully',
          showMessage: true,
          allEmp: emps,
          empList: emps,
          selectedEmps: 0
        });
      }

    case _ActionTypes.FILTER_EMP:
      {
        var _filterOption = state.filterOption;
        var _empList2 = [];

        if (action.payload === '') {
          _empList2 = state.allEmp;
        } else {
          var filterEmployee = state.allEmp.filter(function (emp) {
            return emp.name.toLowerCase().indexOf(action.payload.toLowerCase()) > -1;
          });

          if (_filterOption === 'All emps') {
            _empList2 = filterEmployee;
          } else if (_filterOption === 'Frequently accessed') {
            _empList2 = filterEmployee.filter(function (emp) {
              return emp.frequently;
            });
          } else if (_filterOption === 'Starred employees') {
            _empList2 = filterEmployee.filter(function (emp) {
              return emp.starred;
            });
          }
        }

        return _objectSpread({}, state, {
          empList: _empList2
        });
      }

    case _ActionTypes.GET_ALL_EMP:
      {
        var _empList3 = state.allEmp.map(function (emp) {
          return emp ? _objectSpread({}, emp, {
            selected: true
          }) : emp;
        });

        return _objectSpread({}, state, {
          selectedEmps: _empList3.length,
          allEmp: _empList3,
          empList: _empList3
        });
      }

    case _ActionTypes.GET_UNSELECTED_ALL_EMP:
      {
        var _empList4 = state.allEmp.map(function (emp) {
          return emp ? _objectSpread({}, emp, {
            selected: false
          }) : emp;
        });

        return _objectSpread({}, state, {
          selectedEmps: 0,
          allEmp: _empList4,
          empList: _empList4
        });
      }

    case _ActionTypes.ON_ALL_EMP_SELECT:
      {
        var selectAll = state.selectedEmps < state.empList.length;
        var _selectedEmps = 0;
        var _empList5 = [];

        if (selectAll) {
          _empList5 = state.allEmp.map(function (emp) {
            return emp ? _objectSpread({}, emp, {
              selected: true
            }) : emp;
          });
          _selectedEmps = _empList5.length;
        } else {
          _empList5 = state.allEmp.map(function (emp) {
            return emp ? _objectSpread({}, emp, {
              selected: true
            }) : emp;
          });
          _selectedEmps = 0;
        }

        return _objectSpread({}, state, {
          selectedEmps: _selectedEmps,
          allEmp: _empList5,
          empList: _empList5
        });
      }

    case _ActionTypes.UPDATE_SEARCH_EMP:
      {
        return _objectSpread({}, state, {
          searchEmp: action.payload
        });
      }

    case _ActionTypes.HANDLE_EMP_REQUEST_CLOSE:
      {
        return _objectSpread({}, state, {
          showMessage: false
        });
      }

    case _ActionTypes.ON_TOGGLE_EMP_DRAWER:
      {
        return _objectSpread({}, state, {
          drawerState: !state.drawerState
        });
      }

    case _ActionTypes.SHOW_EMP_LOADER:
      {
        return _objectSpread({}, state, {
          loader: true
        });
      }

    case _ActionTypes.HIDE_EMP_LOADER:
      {
        return _objectSpread({}, state, {
          loader: false
        });
      }

    case _ActionTypes.SHOW_EMP_DASHBOARD_LOADER:
      {
        return _objectSpread({}, state, {
          loadingDashboard: true
        });
      }

    case _ActionTypes.HIDE_EMP_DASHBOARD_LOADER:
      {
        return _objectSpread({}, state, {
          loadingDashboard: false
        });
      }

    default:
      return state;
  }
};

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Employee.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Employee.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Employee.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Employee.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Employee.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Employee.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Employee.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Employee.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Employee.js");
}();

;

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ActionTypes = __webpack_require__(7);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var INIT_STATE = {
  alertMessage: '',
  showMessage: false,
  loader: false,
  noContentFoundMessage: 'No surveys found in selected folder',
  selectedSectionId: 1,
  drawerState: false,
  filterOption: 'All surveys',
  allOrgSurvey: [],
  orgSurveyList: [],
  orgSurveyCompareRadarChartData: [],
  orgSurveyCompareDistributionsChartData: [],
  orgSurveyCompareTopResultsChartData: [],
  orgSurveyCompareBottomResultsChartData: [],
  orgSurveyCompareList: [],
  selectedOrgSurveysCompare: [],
  selectedOrgSurvey: null,
  selectedOrgSurveys: [],
  addOrgSurveyState: false,
  searchOrgSurvey: '',
  orgSurvey: {
    name: 'ACME Inc',
    email: 'road.runner@example.com',
    avatar: 'http://via.placeholder.com/150x150'
  }
};

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.CLEAR_SESSION:
      {
        return _objectSpread({}, INIT_STATE);
      }

    case _ActionTypes.CLEAR_SELECTED_OBJECTS:
      {
        return _objectSpread({}, state, {
          selectedOrgSurvey: null
        });
      }

    case _ActionTypes.FETCH_ALL_ORG_SURVEY_COMPARE_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          orgSurveyCompareList: action.payload
        });
      }

    case _ActionTypes.FETCH_ALL_ORG_SURVEY_ENGAGEMENT_REPORT_CHART_DATA_SUCCESS:
      {
        var payload = action.payload;
        var topResultsChartData = payload.topResultsChartData,
            bottomResultsChartData = payload.bottomResultsChartData,
            distributionsReportData = payload.distributionsReportData;
        return _objectSpread({}, state, {
          loader: false,
          orgSurveyCompareDistributionsChartData: distributionsReportData,
          orgSurveyCompareTopResultsChartData: topResultsChartData,
          orgSurveyCompareBottomResultsChartData: bottomResultsChartData
        });
      }

    case _ActionTypes.FETCH_ALL_ORG_SURVEY_COMPARE_RADAR_CHART_DATA_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          orgSurveyCompareRadarChartData: action.payload
        });
      }

    case _ActionTypes.FETCH_ALL_ORG_SURVEY_COMPARE_DISTRIBUTIONS_CHART_DATA_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          orgSurveyCompareDistributionsChartData: action.payload
        });
      }

    case _ActionTypes.FETCH_ALL_ORG_SURVEY_COMPARE_TOP_RESULTS_CHART_DATA_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          orgSurveyCompareTopResultsChartData: action.payload
        });
      }

    case _ActionTypes.FETCH_ALL_ORG_SURVEY_COMPARE_BOTTOM_RESULTS_CHART_DATA_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          orgSurveyCompareBottomResultsChartData: action.payload
        });
      }

    case _ActionTypes.ON_ORG_SURVEY_COMPARE_SELECT:
      {
        var _payload2;

        var _payload = action.payload;

        if ((_payload2 = _payload) === null || _payload2 === void 0 ? void 0 : _payload2.selected) {
          _payload.selected = !_payload.selected;
        } else {
          // add selected to the payload
          _payload = _objectSpread({}, _payload, {
            selected: true
          });
        }

        var selectedOrgSurveysCompare = state.orgSurveyCompareList.map(function (orgSurvey) {
          if (orgSurvey.id === _payload.id) {
            return _payload;
          } else {
            return orgSurvey;
          }
        });
        return _objectSpread({}, state, {
          INIT_STATE: INIT_STATE,
          orgSurveyCompareList: selectedOrgSurveysCompare
        });
      }

    case _ActionTypes.ADD_FAVOURITE_ORG_SURVEY:
      {
        return _objectSpread({}, state, {
          alertMessage: action.payload.starred ? 'Survey removed as star' : 'Survey marked as star',
          showMessage: true,
          orgSurveyList: state.orgSurveyList.map(function (orgSurvey) {
            return orgSurvey.id === action.payload.id ? _objectSpread({}, orgSurvey, {
              starred: !action.payload.starred
            }) : orgSurvey;
          }),
          allOrgSurvey: state.allOrgSurvey.map(function (orgSurvey) {
            return orgSurvey.id === action.payload.id ? _objectSpread({}, orgSurvey, {
              starred: !action.payload.starred
            }) : orgSurvey;
          })
        });
      }

    case _ActionTypes.FETCH_ALL_ORG_SURVEY_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          allOrgSurvey: action.payload,
          orgSurveyList: action.payload
        });
      }

    case _ActionTypes.SHOW_ORG_SURVEY_MESSAGE:
      {
        return _objectSpread({}, state, {
          alertMessage: action.payload,
          showMessage: true,
          loader: false
        });
      }

    case _ActionTypes.ON_ORG_SURVEY_SELECT:
      {
        action.payload.selected = !action.payload.selected;
        var selectedOrgSurveys = 0;
        var orgSurveyList = state.orgSurveyList.map(function (orgSurvey) {
          if (orgSurvey.selected) {
            selectedOrgSurveys++;
          }

          if (orgSurvey.id === action.payload.id) {
            if (orgSurvey.selected) {
              selectedOrgSurveys++;
            }

            return action.payload;
          } else {
            return orgSurvey;
          }
        });
        return _objectSpread({}, state, {
          INIT_STATE: INIT_STATE,
          selectedOrgSurveys: selectedOrgSurveys,
          orgSurveyList: orgSurveyList
        });
      }

    case _ActionTypes.ON_ADD_ORG_SURVEY:
      {
        return _objectSpread({}, state, {
          addOrgSurveyState: true
        });
      }

    case _ActionTypes.ON_ORG_SURVEY_CLOSE:
      {
        return _objectSpread({}, state, {
          addOrgSurveyState: false
        });
      }

    case _ActionTypes.ON_FILTER_ORG_SURVEY_OPTION_SELECT:
      {
        var selectedSectionId = 0;
        var filterOption = '';
        var _orgSurveyList = [];

        switch (action.payload.name) {
          case 'All surveys':
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              _orgSurveyList = state.allOrgSurvey;
              break;
            }

          case 'Frequently accessed':
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              _orgSurveyList = state.allOrgSurvey.filter(function (orgSurvey) {
                return orgSurvey.frequently;
              });
              break;
            }

          case 'Starred surveys':
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              _orgSurveyList = state.allOrgSurvey.filter(function (orgSurvey) {
                return orgSurvey.starred;
              });
              break;
            }
        }

        return _objectSpread({}, state, {
          selectedSectionId: selectedSectionId,
          filterOption: filterOption,
          orgSurveyList: _orgSurveyList,
          drawerState: false
        });
      }

    case _ActionTypes.ON_SAVE_ORG_SURVEY_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: 'Survey Updated Successfully',
          showMessage: true,
          orgSurveyList: action.payload,
          allOrgSurvey: action.payload,
          loader: false
        });
      }

    case _ActionTypes.ON_DELETE_ORG_SURVEY:
      {
        return _objectSpread({}, state, {
          alertMessage: 'Survey Deleted Successfully',
          showMessage: true,
          allOrgSurvey: state.allOrgSurvey.filter(function (orgSurvey) {
            return orgSurvey.id !== action.payload.id;
          }),
          orgSurveyList: state.allOrgSurvey.filter(function (orgSurvey) {
            return orgSurvey.id !== action.payload.id;
          })
        });
      }

    case _ActionTypes.ON_DELETE_SELECTED_ORG_SURVEY:
      {
        var orgSurveys = state.allOrgSurvey.filter(function (orgSurvey) {
          return !orgSurvey.selected;
        });
        return _objectSpread({}, state, {
          alertMessage: 'Survey Deleted Successfully',
          showMessage: true,
          allOrgSurvey: orgSurveys,
          orgSurveyList: orgSurveys,
          selectedOrgSurveys: 0
        });
      }

    case _ActionTypes.FILTER_ORG_SURVEY:
      {
        var _filterOption = state.filterOption;
        var _orgSurveyList2 = [];

        if (action.payload === '') {
          _orgSurveyList2 = state.allOrgSurvey;
        } else {
          var filterOrgSurvey = state.allOrgSurvey.filter(function (orgSurvey) {
            return orgSurvey.name.toLowerCase().indexOf(action.payload.toLowerCase()) > -1;
          });

          if (_filterOption === 'All surveys') {
            _orgSurveyList2 = filterOrgSurvey;
          } else if (_filterOption === 'Frequently accessed') {
            _orgSurveyList2 = filterOrgSurvey.filter(function (orgSurvey) {
              return orgSurvey.frequently;
            });
          } else if (_filterOption === 'Starred surveys') {
            _orgSurveyList2 = filterOrgSurvey.filter(function (orgSurvey) {
              return orgSurvey.starred;
            });
          }
        }

        return _objectSpread({}, state, {
          orgSurveyList: _orgSurveyList2
        });
      }

    case _ActionTypes.GET_ALL_ORG_SURVEY:
      {
        var _orgSurveyList3 = state.allOrgSurvey.map(function (orgSurvey) {
          return orgSurvey ? _objectSpread({}, orgSurvey, {
            selected: true
          }) : orgSurvey;
        });

        return _objectSpread({}, state, {
          selectedOrgSurveys: _orgSurveyList3.length,
          allOrgSurvey: _orgSurveyList3,
          orgSurveyList: _orgSurveyList3
        });
      }

    case _ActionTypes.GET_UNSELECTED_ALL_ORG_SURVEY:
      {
        var _orgSurveyList4 = state.allOrgSurvey.map(function (orgSurvey) {
          return orgSurvey ? _objectSpread({}, orgSurvey, {
            selected: false
          }) : orgSurvey;
        });

        return _objectSpread({}, state, {
          selectedOrgSurveys: 0,
          allOrgSurvey: _orgSurveyList4,
          orgSurveyList: _orgSurveyList4
        });
      }

    case _ActionTypes.ON_ALL_ORG_SURVEY_SELECT:
      {
        var selectAll = state.selectedOrgSurveys < state.orgSurveyList.length;
        var _selectedOrgSurveys = 0;
        var _orgSurveyList5 = [];

        if (selectAll) {
          _orgSurveyList5 = state.allOrgSurvey.map(function (orgSurvey) {
            return orgSurvey ? _objectSpread({}, orgSurvey, {
              selected: true
            }) : orgSurvey;
          });
          _selectedOrgSurveys = _orgSurveyList5.length;
        } else {
          _orgSurveyList5 = state.allOrgSurvey.map(function (orgSurvey) {
            return orgSurvey ? _objectSpread({}, orgSurvey, {
              selected: true
            }) : orgSurvey;
          });
          _selectedOrgSurveys = 0;
        }

        return _objectSpread({}, state, {
          selectedOrgSurveys: _selectedOrgSurveys,
          allOrgSurvey: _orgSurveyList5,
          orgSurveyList: _orgSurveyList5
        });
      }

    case _ActionTypes.UPDATE_SEARCH_ORG_SURVEY:
      {
        return _objectSpread({}, state, {
          searchOrgSurvey: action.payload
        });
      }

    case _ActionTypes.HANDLE_ORG_SURVEY_REQUEST_CLOSE:
      {
        return _objectSpread({}, state, {
          showMessage: false
        });
      }

    case _ActionTypes.ON_TOGGLE_ORG_SURVEY_DRAWER:
      {
        return _objectSpread({}, state, {
          drawerState: !state.drawerState
        });
      }

    case _ActionTypes.SHOW_ORG_SURVEY_LOADER:
      {
        return _objectSpread({}, state, {
          loader: true
        });
      }

    case _ActionTypes.HIDE_ORG_SURVEY_LOADER:
      {
        return _objectSpread({}, state, {
          loader: false
        });
      }

    case _ActionTypes.ON_ORG_SURVEY_QUESTIONS:
      {
        return _objectSpread({}, state, {
          loader: false,
          selectedOrgSurvey: action.payload
        });
      }

    default:
      return state;
  }
};

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/OrgSurvey.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/OrgSurvey.js");
}();

;

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ActionTypes = __webpack_require__(7);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var INIT_STATE = {
  alertMessage: '',
  showMessage: false,
  loader: false,
  orgSurveyAnswers: {}
};

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.CLEAR_SESSION:
      {
        return _objectSpread({}, INIT_STATE);
      }

    case _ActionTypes.FETCH_ORG_SURVEY_ANSWERS_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          orgSurveyAnswers: action.payload
        });
      }

    case _ActionTypes.ON_SAVE_ORG_SURVEY_ANSWERS_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: 'Org Survey Answers Updated Successfully',
          showMessage: true,
          orgSurveyAnswers: action.payload,
          loader: false
        });
      }

    case _ActionTypes.SHOW_ORG_SURVEY_ANSWERS_MESSAGE:
      {
        return _objectSpread({}, state, {
          alertMessage: action.payload,
          showMessage: true,
          loader: false
        });
      }

    case _ActionTypes.SHOW_ORG_SURVEY_ANSWERS_LOADER:
      {
        return _objectSpread({}, state, {
          loader: true
        });
      }

    case _ActionTypes.HIDE_ORG_SURVEY_ANSWERS_LOADER:
      {
        return _objectSpread({}, state, {
          loader: false
        });
      }

    case _ActionTypes.HANDLE_ORG_SURVEY_ANSWER_MESSAGE_CLOSE:
      {
        return _objectSpread({}, state, {
          showMessage: false
        });
      }

    default:
      return state;
  }
};

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/OrgSurveyAnswer.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/OrgSurveyAnswer.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/OrgSurveyAnswer.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/OrgSurveyAnswer.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/OrgSurveyAnswer.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/OrgSurveyAnswer.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/OrgSurveyAnswer.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/OrgSurveyAnswer.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/OrgSurveyAnswer.js");
}();

;

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ActionTypes = __webpack_require__(7);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var INIT_STATE = {
  alertMessage: '',
  showMessage: false,
  loader: false,
  noContentFoundMessage: 'No survey groups found in selected folder',
  selectedSectionId: 1,
  drawerState: false,
  filterOption: 'All survey groups',
  allSurveyGroup: [],
  surveyGroupList: [],
  selectedSurveyGroup: null,
  selectedSurveyGroups: 0,
  addSurveyGroupState: false,
  searchSurveyGroup: '',
  surveyGroup: {
    name: 'ACME Inc',
    email: 'road.runner@example.com',
    avatar: 'http://via.placeholder.com/150x150'
  }
};

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.CLEAR_SESSION:
      {
        return _objectSpread({}, INIT_STATE);
      }

    case _ActionTypes.ADD_FAVOURITE_SURVEY_GROUP:
      {
        return _objectSpread({}, state, {
          alertMessage: action.payload.starred ? 'Survey Group removed as star' : 'Survey Group marked as star',
          showMessage: true,
          surveyGroupList: state.surveyGroupList.map(function (surveyGroup) {
            return surveyGroup.id === action.payload.id ? _objectSpread({}, surveyGroup, {
              starred: !action.payload.starred
            }) : surveyGroup;
          }),
          allSurveyGroup: state.allSurveyGroup.map(function (surveyGroup) {
            return surveyGroup.id === action.payload.id ? _objectSpread({}, surveyGroup, {
              starred: !action.payload.starred
            }) : surveyGroup;
          })
        });
      }

    case _ActionTypes.FETCH_ALL_SURVEY_GROUP_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          allSurveyGroup: action.payload,
          surveyGroupList: action.payload
        });
      }

    case _ActionTypes.SHOW_SURVEY_GROUP_MESSAGE:
      {
        return _objectSpread({}, state, {
          alertMessage: action.payload,
          showMessage: true,
          loader: false
        });
      }

    case _ActionTypes.ON_SURVEY_GROUP_SELECT:
      {
        action.payload.selected = !action.payload.selected;
        var selectedSurveyGroups = 0;
        var surveyGroupList = state.surveyGroupList.map(function (surveyGroup) {
          if (surveyGroup.selected) {
            selectedSurveyGroups++;
          }

          if (surveyGroup.id === action.payload.id) {
            if (surveyGroup.selected) {
              selectedSurveyGroups++;
            }

            return action.payload;
          } else {
            return surveyGroup;
          }
        });
        return _objectSpread({}, state, {
          INIT_STATE: INIT_STATE,
          selectedSurveyGroups: selectedSurveyGroups,
          surveyGroupList: surveyGroupList
        });
      }

    case _ActionTypes.ON_ADD_SURVEY_GROUP:
      {
        return _objectSpread({}, state, {
          addSurveyGroupState: true
        });
      }

    case _ActionTypes.ON_SURVEY_GROUP_CLOSE:
      {
        return _objectSpread({}, state, {
          addSurveyGroupState: false
        });
      }

    case _ActionTypes.ON_FILTER_SURVEY_GROUP_OPTION_SELECT:
      {
        var selectedSectionId = 0;
        var filterOption = '';
        var _surveyGroupList = [];

        switch (action.payload.name) {
          case 'All survey groups':
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              _surveyGroupList = state.allSurveyGroup;
              break;
            }

          case 'Frequently accessed':
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              _surveyGroupList = state.allSurveyGroup.filter(function (surveyGroup) {
                return surveyGroup.frequently;
              });
              break;
            }

          case 'Starred survey groups':
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              _surveyGroupList = state.allSurveyGroup.filter(function (surveyGroup) {
                return surveyGroup.starred;
              });
              break;
            }
        }

        return _objectSpread({}, state, {
          selectedSectionId: selectedSectionId,
          filterOption: filterOption,
          surveyGroupList: _surveyGroupList,
          drawerState: false
        });
      }

    case _ActionTypes.ON_SAVE_SURVEY_GROUP_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: 'Survey Group Updated Successfully',
          showMessage: true,
          surveyGroupList: action.payload,
          allSurveyGroup: action.payload,
          loader: false
        });
      }

    case _ActionTypes.ON_DELETE_SURVEY_GROUP:
      {
        return _objectSpread({}, state, {
          alertMessage: 'Survey Group Deleted Successfully',
          showMessage: true,
          allSurveyGroup: state.allSurveyGroup.filter(function (surveyGroup) {
            return surveyGroup.id !== action.payload.id;
          }),
          surveyGroupList: state.allSurveyGroup.filter(function (surveyGroup) {
            return surveyGroup.id !== action.payload.id;
          })
        });
      }

    case _ActionTypes.ON_DELETE_SELECTED_SURVEY_GROUP:
      {
        var surveyGroups = state.allSurveyGroup.filter(function (surveyGroup) {
          return !surveyGroup.selected;
        });
        return _objectSpread({}, state, {
          alertMessage: 'Survey Group Deleted Successfully',
          showMessage: true,
          allSurveyGroup: surveyGroups,
          surveyGroupList: surveyGroups,
          selectedSurveyGroups: 0
        });
      }

    case _ActionTypes.FILTER_SURVEY_GROUP:
      {
        var _filterOption = state.filterOption;
        var _surveyGroupList2 = [];

        if (action.payload === '') {
          _surveyGroupList2 = state.allSurveyGroup;
        } else {
          var filterSurveyGroup = state.allSurveyGroup.filter(function (surveyGroup) {
            return surveyGroup.name.toLowerCase().indexOf(action.payload.toLowerCase()) > -1;
          });

          if (_filterOption === 'All survey groups') {
            _surveyGroupList2 = filterSurveyGroup;
          } else if (_filterOption === 'Frequently accessed') {
            _surveyGroupList2 = filterSurveyGroup.filter(function (surveyGroup) {
              return surveyGroup.frequently;
            });
          } else if (_filterOption === 'Starred survey groups') {
            _surveyGroupList2 = filterSurveyGroup.filter(function (surveyGroup) {
              return surveyGroup.starred;
            });
          }
        }

        return _objectSpread({}, state, {
          surveyGroupList: _surveyGroupList2
        });
      }

    case _ActionTypes.GET_ALL_SURVEY_GROUP:
      {
        var _surveyGroupList3 = state.allSurveyGroup.map(function (surveyGroup) {
          return surveyGroup ? _objectSpread({}, surveyGroup, {
            selected: true
          }) : surveyGroup;
        });

        return _objectSpread({}, state, {
          selectedSurveyGroups: _surveyGroupList3.length,
          allSurveyGroup: _surveyGroupList3,
          surveyGroupList: _surveyGroupList3
        });
      }

    case _ActionTypes.GET_UNSELECTED_ALL_SURVEY_GROUP:
      {
        var _surveyGroupList4 = state.allSurveyGroup.map(function (surveyGroup) {
          return surveyGroup ? _objectSpread({}, surveyGroup, {
            selected: false
          }) : surveyGroup;
        });

        return _objectSpread({}, state, {
          selectedSurveyGroups: 0,
          allSurveyGroup: _surveyGroupList4,
          surveyGroupList: _surveyGroupList4
        });
      }

    case _ActionTypes.ON_ALL_SURVEY_GROUP_SELECT:
      {
        var selectAll = state.selectedSurveyGroups < state.surveyGroupList.length;
        var _selectedSurveyGroups = 0;
        var _surveyGroupList5 = [];

        if (selectAll) {
          _surveyGroupList5 = state.allSurveyGroup.map(function (surveyGroup) {
            return surveyGroup ? _objectSpread({}, surveyGroup, {
              selected: true
            }) : surveyGroup;
          });
          _selectedSurveyGroups = _surveyGroupList5.length;
        } else {
          _surveyGroupList5 = state.allSurveyGroup.map(function (surveyGroup) {
            return surveyGroup ? _objectSpread({}, surveyGroup, {
              selected: true
            }) : surveyGroup;
          });
          _selectedSurveyGroups = 0;
        }

        return _objectSpread({}, state, {
          selectedSurveyGroups: _selectedSurveyGroups,
          allSurveyGroup: _surveyGroupList5,
          surveyGroupList: _surveyGroupList5
        });
      }

    case _ActionTypes.UPDATE_SEARCH_SURVEY_GROUP:
      {
        return _objectSpread({}, state, {
          searchSurveyGroup: action.payload
        });
      }

    case _ActionTypes.HANDLE_SURVEY_GROUP_REQUEST_CLOSE:
      {
        return _objectSpread({}, state, {
          showMessage: false
        });
      }

    case _ActionTypes.ON_TOGGLE_SURVEY_GROUP_DRAWER:
      {
        return _objectSpread({}, state, {
          drawerState: !state.drawerState
        });
      }

    case _ActionTypes.SHOW_SURVEY_GROUP_LOADER:
      {
        return _objectSpread({}, state, {
          loader: true
        });
      }

    case _ActionTypes.HIDE_SURVEY_GROUP_LOADER:
      {
        return _objectSpread({}, state, {
          loader: false
        });
      }

    case _ActionTypes.ON_SURVEY_GROUP_QUESTIONS:
      {
        return _objectSpread({}, state, {
          loader: false,
          selectedSurveyGroup: action.payload
        });
      }

    default:
      return state;
  }
};

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/SurveyGroup.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/SurveyGroup.js");
}();

;

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ActionTypes = __webpack_require__(7);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var INIT_STATE = {
  alertMessage: '',
  showMessage: false,
  loader: false,
  noContentFoundMessage: 'No surveys found in selected folder',
  selectedSectionId: 1,
  drawerState: false,
  filterOption: 'All surveys',
  allSurvey: [],
  surveyList: [],
  selectedSurvey: null,
  selectedSurveys: 0,
  addSurveyState: false,
  searchSurvey: '',
  survey: {
    name: 'ACME Inc',
    email: 'road.runner@example.com',
    avatar: 'http://via.placeholder.com/150x150'
  }
};

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.CLEAR_SESSION:
      {
        return _objectSpread({}, INIT_STATE);
      }

    case _ActionTypes.ADD_FAVOURITE_SURVEY:
      {
        return _objectSpread({}, state, {
          alertMessage: action.payload.starred ? 'Survey removed as star' : 'Survey marked as star',
          showMessage: true,
          surveyList: state.surveyList.map(function (survey) {
            return survey.id === action.payload.id ? _objectSpread({}, survey, {
              starred: !action.payload.starred
            }) : survey;
          }),
          allSurvey: state.allSurvey.map(function (survey) {
            return survey.id === action.payload.id ? _objectSpread({}, survey, {
              starred: !action.payload.starred
            }) : survey;
          })
        });
      }

    case _ActionTypes.FETCH_ALL_SURVEY_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          allSurvey: action.payload,
          surveyList: action.payload
        });
      }

    case _ActionTypes.SHOW_SURVEY_MESSAGE:
      {
        return _objectSpread({}, state, {
          alertMessage: action.payload,
          showMessage: true,
          loader: false
        });
      }

    case _ActionTypes.ON_SURVEY_SELECT:
      {
        action.payload.selected = !action.payload.selected;
        var selectedSurveys = 0;
        var surveyList = state.surveyList.map(function (survey) {
          if (survey.selected) {
            selectedSurveys++;
          }

          if (survey.id === action.payload.id) {
            if (survey.selected) {
              selectedSurveys++;
            }

            return action.payload;
          } else {
            return survey;
          }
        });
        return _objectSpread({}, state, {
          INIT_STATE: INIT_STATE,
          selectedSurveys: selectedSurveys,
          surveyList: surveyList
        });
      }

    case _ActionTypes.ON_ADD_SURVEY:
      {
        return _objectSpread({}, state, {
          addSurveyState: true
        });
      }

    case _ActionTypes.ON_SURVEY_CLOSE:
      {
        return _objectSpread({}, state, {
          addSurveyState: false
        });
      }

    case _ActionTypes.ON_FILTER_SURVEY_OPTION_SELECT:
      {
        var selectedSectionId = 0;
        var filterOption = '';
        var _surveyList = [];

        switch (action.payload.name) {
          case 'All surveys':
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              _surveyList = state.allSurvey;
              break;
            }

          case 'Frequently accessed':
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              _surveyList = state.allSurvey.filter(function (survey) {
                return survey.frequently;
              });
              break;
            }

          case 'Starred surveys':
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              _surveyList = state.allSurvey.filter(function (survey) {
                return survey.starred;
              });
              break;
            }
        }

        return _objectSpread({}, state, {
          selectedSectionId: selectedSectionId,
          filterOption: filterOption,
          surveyList: _surveyList,
          drawerState: false
        });
      }

    case _ActionTypes.ON_SAVE_SURVEY_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: 'Survey Updated Successfully',
          showMessage: true,
          surveyList: action.payload,
          allSurvey: action.payload,
          loader: false
        });
      }

    case _ActionTypes.ON_DELETE_SURVEY:
      {
        return _objectSpread({}, state, {
          alertMessage: 'Survey Deleted Successfully',
          showMessage: true,
          allSurvey: state.allSurvey.filter(function (survey) {
            return survey.id !== action.payload.id;
          }),
          surveyList: state.allSurvey.filter(function (survey) {
            return survey.id !== action.payload.id;
          })
        });
      }

    case _ActionTypes.ON_DELETE_SELECTED_SURVEY:
      {
        var surveys = state.allSurvey.filter(function (survey) {
          return !survey.selected;
        });
        return _objectSpread({}, state, {
          alertMessage: 'Survey Deleted Successfully',
          showMessage: true,
          allSurvey: surveys,
          surveyList: surveys,
          selectedSurveys: 0
        });
      }

    case _ActionTypes.FILTER_SURVEY:
      {
        var _filterOption = state.filterOption;
        var _surveyList2 = [];

        if (action.payload === '') {
          _surveyList2 = state.allSurvey;
        } else {
          var filterSurvey = state.allSurvey.filter(function (survey) {
            return survey.name.toLowerCase().indexOf(action.payload.toLowerCase()) > -1;
          });

          if (_filterOption === 'All surveys') {
            _surveyList2 = filterSurvey;
          } else if (_filterOption === 'Frequently accessed') {
            _surveyList2 = filterSurvey.filter(function (survey) {
              return survey.frequently;
            });
          } else if (_filterOption === 'Starred surveys') {
            _surveyList2 = filterSurvey.filter(function (survey) {
              return survey.starred;
            });
          }
        }

        return _objectSpread({}, state, {
          surveyList: _surveyList2
        });
      }

    case _ActionTypes.GET_ALL_SURVEY:
      {
        var _surveyList3 = state.allSurvey.map(function (survey) {
          return survey ? _objectSpread({}, survey, {
            selected: true
          }) : survey;
        });

        return _objectSpread({}, state, {
          selectedSurveys: _surveyList3.length,
          allSurvey: _surveyList3,
          surveyList: _surveyList3
        });
      }

    case _ActionTypes.GET_UNSELECTED_ALL_SURVEY:
      {
        var _surveyList4 = state.allSurvey.map(function (survey) {
          return survey ? _objectSpread({}, survey, {
            selected: false
          }) : survey;
        });

        return _objectSpread({}, state, {
          selectedSurveys: 0,
          allSurvey: _surveyList4,
          surveyList: _surveyList4
        });
      }

    case _ActionTypes.ON_ALL_SURVEY_SELECT:
      {
        var selectAll = state.selectedSurveys < state.surveyList.length;
        var _selectedSurveys = 0;
        var _surveyList5 = [];

        if (selectAll) {
          _surveyList5 = state.allSurvey.map(function (survey) {
            return survey ? _objectSpread({}, survey, {
              selected: true
            }) : survey;
          });
          _selectedSurveys = _surveyList5.length;
        } else {
          _surveyList5 = state.allSurvey.map(function (survey) {
            return survey ? _objectSpread({}, survey, {
              selected: true
            }) : survey;
          });
          _selectedSurveys = 0;
        }

        return _objectSpread({}, state, {
          selectedSurveys: _selectedSurveys,
          allSurvey: _surveyList5,
          surveyList: _surveyList5
        });
      }

    case _ActionTypes.UPDATE_SEARCH_SURVEY:
      {
        return _objectSpread({}, state, {
          searchSurvey: action.payload
        });
      }

    case _ActionTypes.HANDLE_SURVEY_REQUEST_CLOSE:
      {
        return _objectSpread({}, state, {
          showMessage: false
        });
      }

    case _ActionTypes.ON_TOGGLE_SURVEY_DRAWER:
      {
        return _objectSpread({}, state, {
          drawerState: !state.drawerState
        });
      }

    case _ActionTypes.SHOW_SURVEY_LOADER:
      {
        return _objectSpread({}, state, {
          loader: true
        });
      }

    case _ActionTypes.HIDE_SURVEY_LOADER:
      {
        return _objectSpread({}, state, {
          loader: false
        });
      }

    case _ActionTypes.ON_SURVEY_QUESTIONS:
      {
        return _objectSpread({}, state, {
          loader: false,
          selectedSurvey: action.payload
        });
      }

    default:
      return state;
  }
};

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Survey.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Survey.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Survey.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Survey.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Survey.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Survey.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Survey.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Survey.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/Survey.js");
}();

;

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ActionTypes = __webpack_require__(7);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var INIT_STATE = {
  loader: false,
  alertMessage: '',
  showMessage: false,
  allSurveyQuestion: [],
  surveyQuestionList: []
};

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.CLEAR_SESSION:
      {
        return _objectSpread({}, INIT_STATE);
      }

    case _ActionTypes.FETCH_ALL_SURVEY_QUESTION_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          allSurveyQuestion: action.payload,
          surveyQuestionList: action.payload
        });
      }

    case _ActionTypes.SHOW_SURVEY_QUESTION_MESSAGE:
      {
        return _objectSpread({}, state, {
          alertMessage: action.payload,
          showMessage: true,
          loader: false
        });
      }

    case _ActionTypes.SHOW_SURVEY_QUESTION_LOADER:
      {
        return _objectSpread({}, state, {
          loader: true
        });
      }

    case _ActionTypes.HIDE_SURVEY_QUESTION_LOADER:
      {
        return _objectSpread({}, state, {
          loader: false
        });
      }

    default:
      return state;
  }
};

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/SurveyQuestion.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/SurveyQuestion.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/SurveyQuestion.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/SurveyQuestion.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/SurveyQuestion.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/SurveyQuestion.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/SurveyQuestion.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/SurveyQuestion.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/SurveyQuestion.js");
}();

;

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ActionTypes = __webpack_require__(7);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var INIT_STATE = {
  alertMessage: '',
  showMessage: false,
  loader: false,
  noContentFoundMessage: 'No survey groups found in selected folder',
  selectedSectionId: 1,
  drawerState: false,
  filterOption: 'All survey groups',
  allSurveyGroupQuestion: [],
  surveyGroupQuestionList: [],
  selectedSurveyGroupQuestion: null,
  selectedSurveyGroupQuestions: 0,
  addSurveyGroupQuestionState: false,
  searchSurveyGroupQuestion: '',
  surveyGroupQuestion: {
    name: 'ACME Inc',
    email: 'road.runner@example.com',
    avatar: 'http://via.placeholder.com/150x150'
  }
};

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.CLEAR_SESSION:
      {
        return _objectSpread({}, INIT_STATE);
      }

    case _ActionTypes.ON_ADD_SURVEY_GROUP_QUESTION:
      {
        return _objectSpread({}, state, {
          addSurveyGroupQuestionState: true
        });
      }

    case _ActionTypes.ON_SURVEY_GROUP_QUESTION_CLOSE:
      {
        return _objectSpread({}, state, {
          addSurveyGroupQuestionState: false
        });
      }

    case _ActionTypes.ON_DELETE_SURVEY_GROUP_QUESTION:
      {
        return _objectSpread({}, state, {
          alertMessage: 'Survey Group Question Deleted Successfully',
          showMessage: true,
          allSurveyGroupQuestion: state.allSurveyGroupQuestion.filter(function (surveyGroupQuestion) {
            return surveyGroupQuestion.id !== action.payload.id;
          }),
          surveyGroupQuestionList: state.allSurveyGroupQuestion.filter(function (surveyGroupQuestion) {
            return surveyGroupQuestion.id !== action.payload.id;
          })
        });
      }

    case _ActionTypes.HANDLE_SURVEY_GROUP_QUESTION_REQUEST_CLOSE:
      {
        return _objectSpread({}, state, {
          showMessage: false
        });
      }

    case _ActionTypes.ON_TOGGLE_SURVEY_GROUP_QUESTION_DRAWER:
      {
        return _objectSpread({}, state, {
          drawerState: !state.drawerState
        });
      }

    case _ActionTypes.SHOW_SURVEY_GROUP_QUESTION_LOADER:
      {
        return _objectSpread({}, state, {
          loader: true
        });
      }

    case _ActionTypes.HIDE_SURVEY_GROUP_QUESTION_LOADER:
      {
        return _objectSpread({}, state, {
          loader: false
        });
      }

    default:
      return state;
  }
};

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/SurveyGroupQuestion.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/SurveyGroupQuestion.js");
}();

;

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.INIT_STATE = void 0;

var _ActionTypes = __webpack_require__(7);

var _project = __webpack_require__(171);

var _arrayService = __webpack_require__(34);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var INIT_STATE = {
  alertMessage: '',
  showMessage: false,
  loader: false,
  noContentFoundMessage: 'No projects found in selected folder',
  importProjectMessage: _project.SETUP_IMPORT,
  selectedSectionId: 1,
  drawerState: false,
  filterOption: 'All projects',
  allProject: [],
  projectList: [],
  selectedProject: null,
  selectedProjects: 0,
  addProjectState: false,
  searchProject: '',
  importLoader: false,
  importedProjects: [],
  // this list is filtered in the saga - its not the whole list from JIRA
  projectCacheList: [],
  projectDependencyList: [],
  selectedDependencyProjects: 0,
  project: {
    name: 'ACME Inc',
    email: 'road.runner@example.com',
    avatar: 'http://via.placeholder.com/150x150'
  }
};
exports.INIT_STATE = INIT_STATE;

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.CLEAR_SESSION:
      {
        return _objectSpread({}, INIT_STATE);
      }

    case _ActionTypes.CLEAR_SELECTED_OBJECTS:
      {
        return _objectSpread({}, state, {
          selectedProject: null
        });
      }

    case _ActionTypes.ON_SAVE_PROJECT_CACHE_SUCCESS:
      {
        return _objectSpread({}, state, {
          projectCacheList: action.payload
        });
      }

    case _ActionTypes.ON_PROJECT_ISSUES_DASHBOARD:
      {
        return _objectSpread({}, state, {
          loader: false,
          selectedProject: action.payload
        });
      }

    case _ActionTypes.ON_PROJECT_PRIORITY_DASHBOARD:
      {
        return _objectSpread({}, state, {
          loader: false,
          selectedProject: action.payload
        });
      }

    case _ActionTypes.ADD_FAVOURITE_PROJECT_SUCCESS:
      {
        var allUpdated = state.allProject.map(function (entry) {
          var _action$payload, _action$payload2;

          return (entry === null || entry === void 0 ? void 0 : entry.id) === (action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.id) ? _objectSpread({}, entry, {
            starred: !(action === null || action === void 0 ? void 0 : (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.starred)
          }) : entry;
        });
        var listUpdated = {};

        switch (state.filterOption) {
          case 'All projects':
            {
              listUpdated = allUpdated;
              break;
            }

          case 'Starred projects':
            {
              listUpdated = allUpdated.filter(function (entry) {
                return entry.starred;
              });
              break;
            }
        }

        return _objectSpread({}, state, {
          alertMessage: action.payload.starred ? 'Project removed as star' : 'Project marked as star',
          showMessage: true,
          projectList: listUpdated,
          allProject: allUpdated
        });
      }

    case _ActionTypes.SET_PROJECT:
      {
        var project = state.allProject.filter(function (entry) {
          return (entry === null || entry === void 0 ? void 0 : entry.id) === (action === null || action === void 0 ? void 0 : action.payload);
        });
        return _objectSpread({}, state, {
          loader: false,
          selectedProject: (project === null || project === void 0 ? void 0 : project.length) > 0 ? project[0] : []
        });
      }

    case _ActionTypes.FETCH_IMPORT_PROJECTS_SUCCESS:
      {
        var _action$payload3;

        return _objectSpread({}, state, {
          importLoader: false,
          importedProjects: action.payload,
          importProjectMessage: ((_action$payload3 = action.payload) === null || _action$payload3 === void 0 ? void 0 : _action$payload3.length) > 0 ? _project.HAS_PROJECTS_TO_IMPORT : _project.NO_PROJECTS_TO_IMPORT
        });
      }

    case _ActionTypes.ON_IMPORT_PROJECTS_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          importLoader: false,
          allProject: action.payload,
          projectList: action.payload,
          importedProjects: [],
          importProjectMessage: _project.SETUP_IMPORT
        });
      }

    case _ActionTypes.FETCH_PROJECT_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          selectedProject: action.payload
        });
      }

    case _ActionTypes.FETCH_ALL_PROJECT_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          importLoader: false,
          allProject: action.payload,
          projectList: action.payload,
          selectedSectionId: 1,
          searchProject: '',
          filterOption: 'All projects',
          importedProjects: [],
          importProjectMessage: _project.SETUP_IMPORT
        });
      }

    case _ActionTypes.SHOW_PROJECT_MESSAGE:
      {
        return _objectSpread({}, state, {
          alertMessage: action.payload,
          showMessage: true,
          importLoader: false,
          loader: false
        });
      }

    case _ActionTypes.ON_PROJECT_SELECT:
      {
        // invoked when selecting dependant projects (blocking and blocked by)
        // set the selectable project list property for the update
        action.payload.selected = !action.payload.selected;
        var selectedDependencyProjects = 0;
        var projectDependencyList = state.projectDependencyList.map(function (project) {
          if (project.selected) {
            selectedDependencyProjects++;
          }

          if (project.id === action.payload.id) {
            if (project.selected) {
              selectedDependencyProjects++;
            }

            return action.payload;
          } else {
            return project;
          }
        });
        return _objectSpread({}, state, {
          INIT_STATE: INIT_STATE,
          selectedDependencyProjects: selectedDependencyProjects,
          projectDependencyList: projectDependencyList
        });
      }

    case _ActionTypes.ON_ADD_PROJECT:
      {
        return _objectSpread({}, state, {
          addProjectState: true
        });
      }

    case _ActionTypes.ON_PROJECT_CLOSE:
      {
        return _objectSpread({}, state, {
          addProjectState: false
        });
      }

    case _ActionTypes.ON_FILTER_PROJECT_OPTION_SELECT:
      {
        var selectedSectionId = 0;
        var filterOption = '';
        var projectList = [];

        switch (action.payload.name) {
          case 'All projects':
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              projectList = state.allProject;
              break;
            }

          case 'Starred projects':
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              projectList = state.allProject.filter(function (project) {
                return project.starred;
              });
              break;
            }
        }

        return _objectSpread({}, state, {
          selectedSectionId: selectedSectionId,
          filterOption: filterOption,
          projectList: projectList,
          drawerState: false
        });
      }

    case _ActionTypes.ON_SAVE_PROJECT_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: 'Project Updated Successfully',
          showMessage: true,
          projectList: (0, _arrayService.addOrUpdateEntry)(state.projectList, action.payload),
          allProject: (0, _arrayService.addOrUpdateEntry)(state.allProject, action.payload),
          selectedProject: action.payload,
          loader: false
        });
      }

    case _ActionTypes.ON_DELETE_PROJECT_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: 'Project Deleted Successfully',
          showMessage: true,
          allProject: state.allProject.filter(function (project) {
            return project.id !== action.payload.id;
          }),
          projectList: state.allProject.filter(function (project) {
            return project.id !== action.payload.id;
          }),
          selectedProject: null
        });
      }
    // this is not ctually deleting the project - just filtering from the view

    case _ActionTypes.ON_DELETE_SELECTED_PROJECT:
      {
        var projects = state.allProject.filter(function (project) {
          return !project.selected;
        });
        return _objectSpread({}, state, {
          alertMessage: 'Project(s) Filtered Successfully',
          showMessage: true,
          projectList: projects,
          selectedProjects: 0
        });
      }

    case _ActionTypes.FILTER_PROJECT:
      {
        var _filterOption = state.filterOption;
        var _projectList = [];

        if (action.payload === '') {
          _projectList = state.allProject;
        } else {
          var filterProject = state.allProject.filter(function (project) {
            return project.name.toLowerCase().indexOf(action.payload.toLowerCase()) > -1;
          });

          if (_filterOption === 'All projects') {
            _projectList = filterProject;
          } else if (_filterOption === 'Starred projects') {
            _projectList = filterProject.filter(function (project) {
              return project.starred;
            });
          }
        }

        return _objectSpread({}, state, {
          projectList: _projectList
        });
      }

    case _ActionTypes.GET_ALL_PROJECT:
      {
        var _projectList2 = state.allProject.map(function (project) {
          return project ? _objectSpread({}, project, {
            selected: true
          }) : project;
        });

        return _objectSpread({}, state, {
          selectedProjects: _projectList2.length,
          allProject: _projectList2,
          projectList: _projectList2
        });
      }

    case _ActionTypes.GET_UNSELECTED_ALL_PROJECT:
      {
        var _projectList3 = state.allProject.map(function (project) {
          return project ? _objectSpread({}, project, {
            selected: false
          }) : project;
        });

        return _objectSpread({}, state, {
          selectedProjects: 0,
          allProject: _projectList3,
          projectList: _projectList3
        });
      }

    case _ActionTypes.ON_ALL_PROJECT_SELECT:
      {
        var selectAll = state.selectedProjects < state.projectList.length;
        var selectedProjects = 0;
        var _projectList4 = [];

        if (selectAll) {
          _projectList4 = state.allProject.map(function (project) {
            return project ? _objectSpread({}, project, {
              selected: true
            }) : project;
          });
          selectedProjects = _projectList4.length;
        } else {
          _projectList4 = state.allProject.map(function (project) {
            return project ? _objectSpread({}, project, {
              selected: true
            }) : project;
          });
          selectedProjects = 0;
        }

        return _objectSpread({}, state, {
          selectedProjects: selectedProjects,
          allProject: _projectList4,
          projectList: _projectList4
        });
      }

    case _ActionTypes.UPDATE_SEARCH_PROJECT:
      {
        return _objectSpread({}, state, {
          searchProject: action.payload
        });
      }

    case _ActionTypes.HANDLE_PROJECT_REQUEST_CLOSE:
      {
        return _objectSpread({}, state, {
          showMessage: false
        });
      }

    case _ActionTypes.ON_TOGGLE_PROJECT_DRAWER:
      {
        return _objectSpread({}, state, {
          drawerState: !state.drawerState
        });
      }

    case _ActionTypes.SHOW_PROJECT_LOADER:
      {
        return _objectSpread({}, state, {
          loader: true
        });
      }

    case _ActionTypes.HIDE_PROJECT_LOADER:
      {
        return _objectSpread({}, state, {
          loader: false
        });
      }

    case _ActionTypes.SHOW_IMPORT_PROJECTS_LOADER:
      {
        return _objectSpread({}, state, {
          importLoader: true
        });
      }

    case _ActionTypes.HIDE_IMPORT_PROJECTS_LOADER:
      {
        return _objectSpread({}, state, {
          importLoader: false
        });
      }

    default:
      return state;
  }
};

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/project.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/project.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/project.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/project.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/project.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/project.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/project.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/project.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/project.js");
}();

;

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.INIT_STATE = exports.STARRED_FILTER = exports.ALL_FILTER = void 0;

var _ActionTypes = __webpack_require__(7);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ALL_FILTER = 'All project prioritys';
exports.ALL_FILTER = ALL_FILTER;
var STARRED_FILTER = 'Starred project prioritys';
exports.STARRED_FILTER = STARRED_FILTER;
var INIT_STATE = {
  alertMessage: '',
  showMessage: false,
  loader: false,
  noContentFoundMessage: 'No project priorities found in selected folder',
  selectedSectionId: 1,
  drawerState: false,
  filterOption: ALL_FILTER,
  allProjectPriority: [],
  projectPriorityList: [],
  updatingProjectCostPriorities: false,
  updatingProjectBusinessPriorities: false,
  selectedProjectPriority: null,
  selectedProjectPrioritys: 0,
  addProjectPriorityState: false,
  searchProjectPriority: '',
  updatingGlobalPriorities: false,
  projectPriority: {
    name: 'ACME Inc',
    email: 'road.runner@example.com',
    avatar: 'assets/images/priorities-150_150.jpg'
  }
};
exports.INIT_STATE = INIT_STATE;

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.CLEAR_SESSION:
      {
        return _objectSpread({}, INIT_STATE);
      }

    case _ActionTypes.CLEAR_SELECTED_OBJECTS:
      {
        return _objectSpread({}, state, {
          selectedProjectPriority: null
        });
      }

    case _ActionTypes.ON_PROJECT_COST_PRIORITIES_DASHBOARD:
      {
        var _action$payload, _action$payload2, _action$payload3;

        return _objectSpread({}, state, {
          loader: false,
          projectPriorityList: ((_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.costImplPriorityParams) || [],
          allProjectPriority: ((_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.costImplPriorityParams) || [],
          updatingProjectCostPriorities: true,
          updatingProjectBusinessPriorities: false,
          updatingGlobalPriorities: false,
          projectPriority: _objectSpread({}, state.projectPriority, {
            name: (_action$payload3 = action.payload) === null || _action$payload3 === void 0 ? void 0 : _action$payload3.name
          })
        });
      }

    case _ActionTypes.ON_PROJECT_BUSINESS_PRIORITIES_DASHBOARD:
      {
        var _action$payload4, _action$payload5, _action$payload6;

        return _objectSpread({}, state, {
          loader: false,
          projectPriorityList: ((_action$payload4 = action.payload) === null || _action$payload4 === void 0 ? void 0 : _action$payload4.busValPriorityParams) || [],
          allProjectPriority: ((_action$payload5 = action.payload) === null || _action$payload5 === void 0 ? void 0 : _action$payload5.busValPriorityParams) || [],
          updatingProjectCostPriorities: false,
          updatingProjectBusinessPriorities: true,
          updatingGlobalPriorities: false,
          projectPriority: _objectSpread({}, state.projectPriority, {
            name: (_action$payload6 = action.payload) === null || _action$payload6 === void 0 ? void 0 : _action$payload6.name
          })
        });
      }

    case _ActionTypes.ON_GLOBAL_PROJECT_COST_PRIORITIES_DASHBOARD:
      {
        var _action$payload7;

        return _objectSpread({}, state, {
          loader: false,
          projectPriorityList: action.payload || [],
          allProjectPriority: action.payload || [],
          updatingProjectCostPriorities: true,
          updatingProjectBusinessPriorities: false,
          updatingGlobalPriorities: true,
          projectPriority: _objectSpread({}, state.projectPriority, {
            name: (_action$payload7 = action.payload) === null || _action$payload7 === void 0 ? void 0 : _action$payload7.name
          })
        });
      }

    case _ActionTypes.ON_GLOBAL_PROJECT_BUSINESS_PRIORITIES_DASHBOARD:
      {
        var _action$payload8, _action$payload9;

        return _objectSpread({}, state, {
          loader: false,
          projectPriorityList: action.payload || [],
          allProjectPriority: ((_action$payload8 = action.payload) === null || _action$payload8 === void 0 ? void 0 : _action$payload8.busValPriorityParams) || [],
          updatingProjectCostPriorities: false,
          updatingProjectBusinessPriorities: true,
          updatingGlobalPriorities: true,
          projectPriority: _objectSpread({}, state.projectPriority, {
            name: (_action$payload9 = action.payload) === null || _action$payload9 === void 0 ? void 0 : _action$payload9.name
          })
        });
      }

    case _ActionTypes.ADD_FAVOURITE_PROJECT_PRIORITY:
      {
        return _objectSpread({}, state, {
          alertMessage: action.payload.starred ? 'Project priority removed as star' : 'Project priority marked as star',
          showMessage: true,
          projectPriorityList: state.projectPriorityList.map(function (projectPriority) {
            return projectPriority.id === action.payload.id ? _objectSpread({}, projectPriority, {
              starred: !action.payload.starred
            }) : projectPriority;
          }),
          allProjectPriority: state.allProjectPriority.map(function (projectPriority) {
            return projectPriority.id === action.payload.id ? _objectSpread({}, projectPriority, {
              starred: !action.payload.starred
            }) : projectPriority;
          })
        });
      }

    case _ActionTypes.FETCH_PROJECT_PRIORITY_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          selectedProjectPriority: action.payload
        });
      }

    case _ActionTypes.FETCH_ALL_PROJECT_PRIORITY_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          allProjectPriority: action.payload,
          projectPriorityList: action.payload,
          selectedSectionId: 1,
          searchProject: '',
          filterOption: ALL_FILTER
        });
      }

    case _ActionTypes.SHOW_PROJECT_PRIORITY_MESSAGE:
      {
        return _objectSpread({}, state, {
          alertMessage: action.payload,
          showMessage: true,
          loader: false
        });
      }

    case _ActionTypes.ON_PROJECT_PRIORITY_SELECT:
      {
        action.payload.selected = !action.payload.selected;
        var selectedProjectPrioritys = 0;
        var projectPriorityList = state.projectPriorityList.map(function (projectPriority) {
          if (projectPriority.selected) {
            selectedProjectPrioritys++;
          }

          if (projectPriority.id === action.payload.id) {
            if (projectPriority.selected) {
              selectedProjectPrioritys++;
            }

            return action.payload;
          } else {
            return projectPriority;
          }
        });
        return _objectSpread({}, state, {
          INIT_STATE: INIT_STATE,
          selectedProjectPrioritys: selectedProjectPrioritys,
          projectPriorityList: projectPriorityList
        });
      }

    case _ActionTypes.ON_ADD_PROJECT_PRIORITY:
      {
        return _objectSpread({}, state, {
          addProjectPriorityState: true
        });
      }

    case _ActionTypes.ON_PROJECT_PRIORITY_CLOSE:
      {
        return _objectSpread({}, state, {
          addProjectPriorityState: false
        });
      }

    case _ActionTypes.ON_FILTER_PROJECT_PRIORITY_OPTION_SELECT:
      {
        var selectedSectionId = 0;
        var filterOption = '';
        var _projectPriorityList = [];

        switch (action.payload.name) {
          case ALL_FILTER:
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              _projectPriorityList = state.allProjectPriority;
              break;
            }

          case STARRED_FILTER:
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              _projectPriorityList = state.allProjectPriority.filter(function (projectPriority) {
                return projectPriority.starred;
              });
              break;
            }
        }

        return _objectSpread({}, state, {
          selectedSectionId: selectedSectionId,
          filterOption: filterOption,
          projectPriorityList: _projectPriorityList,
          drawerState: false
        });
      }

    case _ActionTypes.ON_SAVE_PROJECT_PRIORITY_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: 'Project Priority Updated Successfully',
          showMessage: true,
          projectPriorityList: action.payload,
          allProjectPriority: action.payload,
          loader: false
        });
      }

    case _ActionTypes.ON_DELETE_PROJECT_PRIORITY_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: 'Project Priority Filtered Successfully',
          showMessage: true,
          allProjectPriority: state.allProjectPriority.filter(function (projectPriority) {
            return projectPriority.id !== action.payload.id;
          }),
          projectPriorityList: state.allProjectPriority.filter(function (projectPriority) {
            return projectPriority.id !== action.payload.id;
          }),
          loader: false
        });
      }

    case _ActionTypes.ON_DELETE_SELECTED_PROJECT_PRIORITY:
      {
        var projectPrioritys = state.allProjectPriority.filter(function (projectPriority) {
          return !projectPriority.selected;
        });
        return _objectSpread({}, state, {
          alertMessage: 'Project Priority Deleted Successfully',
          showMessage: true,
          allProjectPriority: projectPrioritys,
          projectPriorityList: projectPrioritys,
          selectedProjectPrioritys: 0
        });
      }

    case _ActionTypes.FILTER_PROJECT_PRIORITY:
      {
        var _filterOption = state.filterOption;
        var _projectPriorityList2 = [];

        if (action.payload === '') {
          _projectPriorityList2 = state.allProjectPriority;
        } else {
          var filterProjectPriority = state.allProjectPriority.filter(function (projectPriority) {
            return projectPriority.name.toLowerCase().indexOf(action.payload.toLowerCase()) > -1;
          });

          if (_filterOption === ALL_FILTER) {
            _projectPriorityList2 = filterProjectPriority;
          } else if (_filterOption === STARRED_FILTER) {
            _projectPriorityList2 = filterProjectPriority.filter(function (project) {
              return project.starred;
            });
          }
        }

        return _objectSpread({}, state, {
          projectPriorityList: _projectPriorityList2
        });
      }

    case _ActionTypes.GET_ALL_PROJECT_PRIORITY:
      {
        var _projectPriorityList3 = state.allProjectPriority.map(function (projectPriority) {
          return projectPriority ? _objectSpread({}, projectPriority, {
            selected: true
          }) : projectPriority;
        });

        return _objectSpread({}, state, {
          selectedProjectPrioritys: _projectPriorityList3.length,
          allProjectPriority: _projectPriorityList3,
          projectPriorityList: _projectPriorityList3
        });
      }

    case _ActionTypes.GET_UNSELECTED_ALL_PROJECT_PRIORITY:
      {
        var _projectPriorityList4 = state.allProjectPriority.map(function (projectPriority) {
          return projectPriority ? _objectSpread({}, projectPriority, {
            selected: false
          }) : projectPriority;
        });

        return _objectSpread({}, state, {
          selectedProjectPrioritys: 0,
          allProjectPriority: _projectPriorityList4,
          projectPriorityList: _projectPriorityList4
        });
      }

    case _ActionTypes.ON_ALL_PROJECT_PRIORITY_SELECT:
      {
        var selectAll = state.selectedProjectPrioritys < state.projectPriorityList.length;
        var _selectedProjectPrioritys = 0;
        var _projectPriorityList5 = [];

        if (selectAll) {
          _projectPriorityList5 = state.allProjectPriority.map(function (projectPriority) {
            return projectPriority ? _objectSpread({}, projectPriority, {
              selected: true
            }) : projectPriority;
          });
          _selectedProjectPrioritys = _projectPriorityList5.length;
        } else {
          _projectPriorityList5 = state.allProjectPriority.map(function (projectPriority) {
            return projectPriority ? _objectSpread({}, projectPriority, {
              selected: true
            }) : projectPriority;
          });
          _selectedProjectPrioritys = 0;
        }

        return _objectSpread({}, state, {
          selectedProjectPrioritys: _selectedProjectPrioritys,
          allProjectPriority: _projectPriorityList5,
          projectPriorityList: _projectPriorityList5
        });
      }

    case _ActionTypes.UPDATE_SEARCH_PROJECT_PRIORITY:
      {
        return _objectSpread({}, state, {
          searchProjectPriority: action.payload
        });
      }

    case _ActionTypes.HANDLE_PROJECT_PRIORITY_REQUEST_CLOSE:
      {
        return _objectSpread({}, state, {
          showMessage: false
        });
      }

    case _ActionTypes.ON_TOGGLE_PROJECT_PRIORITY_DRAWER:
      {
        return _objectSpread({}, state, {
          drawerState: !state.drawerState
        });
      }

    case _ActionTypes.SHOW_PROJECT_PRIORITY_LOADER:
      {
        return _objectSpread({}, state, {
          loader: true
        });
      }

    case _ActionTypes.HIDE_PROJECT_PRIORITY_LOADER:
      {
        return _objectSpread({}, state, {
          loader: false
        });
      }

    default:
      return state;
  }
};

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ALL_FILTER, "ALL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectPriority.js");

  __REACT_HOT_LOADER__.register(STARRED_FILTER, "STARRED_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectPriority.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectPriority.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectPriority.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectPriority.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectPriority.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectPriority.js");

  __REACT_HOT_LOADER__.register(ALL_FILTER, "ALL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectPriority.js");

  __REACT_HOT_LOADER__.register(STARRED_FILTER, "STARRED_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectPriority.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectPriority.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectPriority.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectPriority.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectPriority.js");
}();

;

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.INIT_STATE = exports.MARKED_AS_STAR = exports.REMOVED_AS_STAR = exports.SUCCESSFUL_DELETE = exports.SUCCESSFUL_FILTER = exports.SUCCESSFUL_UPDATE = exports.STARRED_FILTER = exports.ALL_FILTER = void 0;

var _ActionTypes = __webpack_require__(7);

var _arrayService = __webpack_require__(34);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ALL_FILTER = 'All securities';
exports.ALL_FILTER = ALL_FILTER;
var STARRED_FILTER = 'Starred securities';
exports.STARRED_FILTER = STARRED_FILTER;
var SUCCESSFUL_UPDATE = 'Security Updated Successfully';
exports.SUCCESSFUL_UPDATE = SUCCESSFUL_UPDATE;
var SUCCESSFUL_FILTER = 'Security Filtered Successfully';
exports.SUCCESSFUL_FILTER = SUCCESSFUL_FILTER;
var SUCCESSFUL_DELETE = 'Security Deleted Successfully';
exports.SUCCESSFUL_DELETE = SUCCESSFUL_DELETE;
var REMOVED_AS_STAR = 'Security removed as star';
exports.REMOVED_AS_STAR = REMOVED_AS_STAR;
var MARKED_AS_STAR = 'Security marked as star';
exports.MARKED_AS_STAR = MARKED_AS_STAR;
var INIT_STATE = {
  alertMessage: '',
  showMessage: false,
  loader: false,
  noContentFoundMessage: 'No securities found in selected folder',
  selectedSectionId: 1,
  drawerState: false,
  filterOption: ALL_FILTER,
  allSecurity: [],
  securityList: [],
  selectedSecurity: null,
  selectedSecuritys: 0,
  addSecurityState: false,
  searchSecurity: '',
  security: {
    name: 'ACME Inc',
    email: 'road.runner@example.com',
    avatar: 'http://via.placeholder.com/150x150'
  }
};
exports.INIT_STATE = INIT_STATE;

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.CLEAR_SESSION:
      {
        return _objectSpread({}, INIT_STATE);
      }

    case _ActionTypes.CLEAR_SELECTED_OBJECTS:
      {
        return _objectSpread({}, state, {
          selectedSecurity: null
        });
      }

    case _ActionTypes.ADD_FAVOURITE_SECURITY_SUCCESS:
      {
        var allUpdated = state.allSecurity.map(function (entry) {
          var _action$payload, _action$payload2;

          return (entry === null || entry === void 0 ? void 0 : entry.id) === (action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.id) ? _objectSpread({}, entry, {
            starred: !(action === null || action === void 0 ? void 0 : (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.starred)
          }) : entry;
        });
        var listUpdated = {};

        switch (state.filterOption) {
          case ALL_FILTER:
            {
              listUpdated = allUpdated;
              break;
            }

          case STARRED_FILTER:
            {
              listUpdated = allUpdated.filter(function (entry) {
                return entry.starred;
              });
              break;
            }
        }

        return _objectSpread({}, state, {
          alertMessage: action.payload.starred ? REMOVED_AS_STAR : MARKED_AS_STAR,
          showMessage: true,
          securityList: listUpdated,
          allSecurity: allUpdated
        });
      }

    case _ActionTypes.FETCH_SECURITY_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          selectedSecurity: action.payload
        });
      }

    case _ActionTypes.FETCH_ALL_SECURITY_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          allSecurity: action.payload,
          securityList: action.payload,
          selectedSectionId: 1,
          searchEmp: '',
          filterOption: ALL_FILTER
        });
      }

    case _ActionTypes.SHOW_SECURITY_MESSAGE:
      {
        return _objectSpread({}, state, {
          alertMessage: action.payload,
          showMessage: true,
          loader: false
        });
      }

    case _ActionTypes.ON_SECURITY_SELECT:
      {
        action.payload.selected = !action.payload.selected;
        var selectedSecuritys = 0;
        var securityList = state.securityList.map(function (security) {
          if (security.selected) {
            selectedSecuritys++;
          }

          if (security.id === action.payload.id) {
            if (security.selected) {
              selectedSecuritys++;
            }

            return action.payload;
          } else {
            return security;
          }
        });
        return _objectSpread({}, state, {
          INIT_STATE: INIT_STATE,
          selectedSecuritys: selectedSecuritys,
          securityList: securityList
        });
      }

    case _ActionTypes.ON_ADD_SECURITY:
      {
        return _objectSpread({}, state, {
          addSecurityState: true
        });
      }

    case _ActionTypes.ON_SECURITY_CLOSE:
      {
        return _objectSpread({}, state, {
          addSecurityState: false
        });
      }

    case _ActionTypes.ON_FILTER_SECURITY_OPTION_SELECT:
      {
        var selectedSectionId = 0;
        var filterOption = '';
        var _securityList = [];

        switch (action.payload.name) {
          case ALL_FILTER:
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              _securityList = state.allSecurity;
              break;
            }

          case STARRED_FILTER:
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              _securityList = state.allSecurity.filter(function (security) {
                return security.starred;
              });
              break;
            }
        }

        return _objectSpread({}, state, {
          selectedSectionId: selectedSectionId,
          filterOption: filterOption,
          securityList: _securityList,
          drawerState: false
        });
      }

    case _ActionTypes.ON_SAVE_SECURITY_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_UPDATE,
          showMessage: true,
          securityList: (0, _arrayService.addOrUpdateEntry)(state.securityList, action.payload),
          allSecurity: (0, _arrayService.addOrUpdateEntry)(state.allSecurity, action.payload),
          loader: false
        });
      }
    // called after a delete from the db operation to keep the current state up to date

    case _ActionTypes.ON_DELETE_SECURITY_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_DELETE,
          showMessage: true,
          allSecurity: state.allSecurity.filter(function (security) {
            return security.id !== action.payload;
          }),
          securityList: state.allSecurity.filter(function (security) {
            return security.id !== action.payload;
          }),
          selectedSecurity: null
        });
      }
    // not a delete but a filter of the UI

    case _ActionTypes.ON_FILTER_SELECTED_SECURITY:
      {
        var securitys = state.allSecurity.filter(function (security) {
          return !security.selected;
        });
        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_FILTER,
          showMessage: true,
          securityList: securitys,
          selectedSecuritys: 0
        });
      }

    case _ActionTypes.FILTER_SECURITY:
      {
        var _filterOption = state.filterOption;
        var _securityList2 = [];

        if (action.payload === '') {
          _securityList2 = state.allSecurity;
        } else {
          var filterSecurity = state.allSecurity.filter(function (security) {
            return security.name.toLowerCase().indexOf(action.payload.toLowerCase()) > -1;
          });

          if (_filterOption === ALL_FILTER) {
            _securityList2 = filterSecurity;
          } else if (_filterOption === STARRED_FILTER) {
            _securityList2 = filterSecurity.filter(function (security) {
              return security.starred;
            });
          }
        }

        return _objectSpread({}, state, {
          securityList: _securityList2
        });
      }

    case _ActionTypes.GET_ALL_SECURITY:
      {
        var _securityList3 = state.allSecurity.map(function (security) {
          return security ? _objectSpread({}, security, {
            selected: true
          }) : security;
        });

        return _objectSpread({}, state, {
          selectedSecuritys: _securityList3.length,
          allSecurity: _securityList3,
          securityList: _securityList3
        });
      }

    case _ActionTypes.GET_UNSELECTED_ALL_SECURITY:
      {
        var _securityList4 = state.allSecurity.map(function (security) {
          return security ? _objectSpread({}, security, {
            selected: false
          }) : security;
        });

        return _objectSpread({}, state, {
          selectedSecuritys: 0,
          allSecurity: _securityList4,
          securityList: _securityList4
        });
      }

    case _ActionTypes.ON_ALL_SECURITY_SELECT:
      {
        var selectAll = state.selectedSecuritys < state.securityList.length;
        var _selectedSecuritys = 0;
        var _securityList5 = [];

        if (selectAll) {
          _securityList5 = state.allSecurity.map(function (security) {
            return security ? _objectSpread({}, security, {
              selected: true
            }) : security;
          });
          _selectedSecuritys = _securityList5.length;
        } else {
          _securityList5 = state.allSecurity.map(function (security) {
            return security ? _objectSpread({}, security, {
              selected: true
            }) : security;
          });
          _selectedSecuritys = 0;
        }

        return _objectSpread({}, state, {
          selectedSecuritys: _selectedSecuritys,
          allSecurity: _securityList5,
          securityList: _securityList5
        });
      }

    case _ActionTypes.UPDATE_SEARCH_SECURITY:
      {
        return _objectSpread({}, state, {
          searchSecurity: action.payload
        });
      }

    case _ActionTypes.HANDLE_SECURITY_REQUEST_CLOSE:
      {
        return _objectSpread({}, state, {
          showMessage: false
        });
      }

    case _ActionTypes.ON_TOGGLE_SECURITY_DRAWER:
      {
        return _objectSpread({}, state, {
          drawerState: !state.drawerState
        });
      }

    case _ActionTypes.SHOW_SECURITY_LOADER:
      {
        return _objectSpread({}, state, {
          loader: true
        });
      }

    case _ActionTypes.HIDE_SECURITY_LOADER:
      {
        return _objectSpread({}, state, {
          loader: false
        });
      }

    default:
      return state;
  }
};

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ALL_FILTER, "ALL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/security.js");

  __REACT_HOT_LOADER__.register(STARRED_FILTER, "STARRED_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/security.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_UPDATE, "SUCCESSFUL_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/security.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_FILTER, "SUCCESSFUL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/security.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_DELETE, "SUCCESSFUL_DELETE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/security.js");

  __REACT_HOT_LOADER__.register(REMOVED_AS_STAR, "REMOVED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/security.js");

  __REACT_HOT_LOADER__.register(MARKED_AS_STAR, "MARKED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/security.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/security.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/security.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/security.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/security.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/security.js");

  __REACT_HOT_LOADER__.register(ALL_FILTER, "ALL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/security.js");

  __REACT_HOT_LOADER__.register(STARRED_FILTER, "STARRED_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/security.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_UPDATE, "SUCCESSFUL_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/security.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_FILTER, "SUCCESSFUL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/security.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_DELETE, "SUCCESSFUL_DELETE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/security.js");

  __REACT_HOT_LOADER__.register(REMOVED_AS_STAR, "REMOVED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/security.js");

  __REACT_HOT_LOADER__.register(MARKED_AS_STAR, "MARKED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/security.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/security.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/security.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/security.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/security.js");
}();

;

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.INIT_STATE = exports.MARKED_AS_STAR = exports.REMOVED_AS_STAR = exports.SUCCESSFUL_DELETE = exports.SUCCESSFUL_FILTER = exports.SUCCESSFUL_UPDATE = exports.STARRED_FILTER = exports.ALL_FILTER = void 0;

var _ActionTypes = __webpack_require__(7);

var _arrayService = __webpack_require__(34);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ALL_FILTER = 'All project issues';
exports.ALL_FILTER = ALL_FILTER;
var STARRED_FILTER = 'Starred project issues';
exports.STARRED_FILTER = STARRED_FILTER;
var SUCCESSFUL_UPDATE = 'Project issue Updated Successfully';
exports.SUCCESSFUL_UPDATE = SUCCESSFUL_UPDATE;
var SUCCESSFUL_FILTER = 'Project issue Filtered Successfully';
exports.SUCCESSFUL_FILTER = SUCCESSFUL_FILTER;
var SUCCESSFUL_DELETE = 'Project issue Deleted Successfully';
exports.SUCCESSFUL_DELETE = SUCCESSFUL_DELETE;
var REMOVED_AS_STAR = 'Project issue removed as star';
exports.REMOVED_AS_STAR = REMOVED_AS_STAR;
var MARKED_AS_STAR = 'Project issue marked as star';
exports.MARKED_AS_STAR = MARKED_AS_STAR;
var INIT_STATE = {
  alertMessage: '',
  showMessage: false,
  loader: false,
  noContentFoundMessage: 'No project issues found in selected folder',
  selectedSectionId: 1,
  drawerState: false,
  filterOption: ALL_FILTER,
  allProjectIssue: [],
  projectIssueList: [],
  selectedProjectIssue: null,
  selectedProjectIssues: 0,
  addProjectIssueState: false,
  addJiraProjectIssueState: false,
  searchProjectIssue: '',
  projectIssueCacheList: [],
  projectIssue: {
    name: 'ACME Inc',
    email: 'road.runner@example.com',
    avatar: 'http://via.placeholder.com/150x150'
  }
};
exports.INIT_STATE = INIT_STATE;

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.CLEAR_SESSION:
      {
        return _objectSpread({}, INIT_STATE);
      }

    case _ActionTypes.ON_SAVE_PROJECT_ISSUE_CACHE_SUCCESS:
      {
        return _objectSpread({}, state, {
          projectIssueCacheList: action.payload
        });
      }

    case _ActionTypes.FETCH_PROJECT_ISSUE_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          selectedProjectIssue: action.payload
        });
      }

    case _ActionTypes.SET_PROJECT_ISSUE:
      {
        var projectIssue = state.allProjectIssue.filter(function (entry) {
          return (entry === null || entry === void 0 ? void 0 : entry.id) === (action === null || action === void 0 ? void 0 : action.payload);
        });
        return _objectSpread({}, state, {
          loader: false,
          selectedProjectIssue: (projectIssue === null || projectIssue === void 0 ? void 0 : projectIssue.length) > 0 ? projectIssue[0] : []
        });
      }

    case _ActionTypes.FETCH_ALL_PROJECT_ISSUE_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          allProjectIssue: action.payload,
          projectIssueList: action.payload,
          selectedSectionId: 1,
          searchEmp: '',
          filterOption: ALL_FILTER,
          selectedProjectIssue: null
        });
      }

    case _ActionTypes.SHOW_PROJECT_ISSUE_MESSAGE:
      {
        return _objectSpread({}, state, {
          alertMessage: action.payload,
          showMessage: true,
          loader: false
        });
      }

    case _ActionTypes.ON_ADD_PROJECT_ISSUE:
      {
        return _objectSpread({}, state, {
          addProjectIssueState: true
        });
      }

    case _ActionTypes.ON_ADD_JIRA_PROJECT_ISSUE:
      {
        return _objectSpread({}, state, {
          addJiraProjectIssueState: true
        });
      }

    case _ActionTypes.ON_PROJECT_ISSUE_CLOSE:
      {
        return _objectSpread({}, state, {
          addProjectIssueState: false
        });
      }

    case _ActionTypes.ON_FILTER_PROJECT_ISSUE_OPTION_SELECT:
      {
        var selectedSectionId = 0;
        var filterOption = '';
        var projectIssueList = [];

        switch (action.payload.name) {
          case ALL_FILTER:
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              projectIssueList = state.allProjectIssue;
              break;
            }

          case STARRED_FILTER:
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              projectIssueList = state.allProjectIssue.filter(function (projectIssue) {
                return projectIssue.starred;
              });
              break;
            }
        }

        return _objectSpread({}, state, {
          selectedSectionId: selectedSectionId,
          filterOption: filterOption,
          projectIssueList: projectIssueList,
          drawerState: false
        });
      }

    case _ActionTypes.ON_SAVE_PROJECT_ISSUE_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_UPDATE,
          showMessage: true,
          projectIssueList: (0, _arrayService.addOrUpdateEntry)(state.projectIssueList, action.payload),
          allProjectIssue: (0, _arrayService.addOrUpdateEntry)(state.allProjectIssue, action.payload),
          selectedProjectIssue: action.payload,
          loader: false
        });
      }
    // called after a delete from the db operation to keep the current state up to date

    case _ActionTypes.ON_DELETE_PROJECT_ISSUE_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_DELETE,
          showMessage: true,
          allProjectIssue: state.allProjectIssue.filter(function (projectIssue) {
            return projectIssue.id !== action.payload;
          }),
          projectIssueList: state.allProjectIssue.filter(function (projectIssue) {
            return projectIssue.id !== action.payload;
          }),
          selectedProjectIssue: null
        });
      }

    case _ActionTypes.ON_FILTER_SELECTED_PROJECT_ISSUE:
      {
        var projectIssues = state.allProjectIssue.filter(function (projectIssue) {
          return !projectIssue.selected;
        });
        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_FILTER,
          showMessage: true,
          allProjectIssue: projectIssues,
          projectIssueList: projectIssues,
          selectedProjectIssues: 0
        });
      }

    case _ActionTypes.FILTER_PROJECT_ISSUE:
      {
        var _filterOption = state.filterOption;
        var _projectIssueList = [];

        if (action.payload === '') {
          _projectIssueList = state.allProjectIssue;
        } else {
          var filterProjectIssue = state.allProjectIssue.filter(function (projectIssue) {
            return projectIssue.name.toLowerCase().indexOf(action.payload.toLowerCase()) > -1;
          });

          if (_filterOption === ALL_FILTER) {
            _projectIssueList = filterProjectIssue;
          } else if (_filterOption === STARRED_FILTER) {
            _projectIssueList = filterProjectIssue.filter(function (projectIssue) {
              return projectIssue.starred;
            });
          }
        }

        return _objectSpread({}, state, {
          projectIssueList: _projectIssueList
        });
      }

    case _ActionTypes.GET_ALL_PROJECT_ISSUE:
      {
        var _projectIssueList2 = state.allProjectIssue.map(function (projectIssue) {
          return projectIssue ? _objectSpread({}, projectIssue, {
            selected: true
          }) : projectIssue;
        });

        return _objectSpread({}, state, {
          selectedProjectIssues: _projectIssueList2.length,
          allProjectIssue: _projectIssueList2,
          projectIssueList: _projectIssueList2
        });
      }

    case _ActionTypes.GET_UNSELECTED_ALL_PROJECT_ISSUE:
      {
        var _projectIssueList3 = state.allProjectIssue.map(function (projectIssue) {
          return projectIssue ? _objectSpread({}, projectIssue, {
            selected: false
          }) : projectIssue;
        });

        return _objectSpread({}, state, {
          selectedProjectIssues: 0,
          allProjectIssue: _projectIssueList3,
          projectIssueList: _projectIssueList3
        });
      }

    case _ActionTypes.UPDATE_SEARCH_PROJECT_ISSUE:
      {
        return _objectSpread({}, state, {
          searchProjectIssue: action.payload
        });
      }

    case _ActionTypes.HANDLE_PROJECT_ISSUE_REQUEST_CLOSE:
      {
        return _objectSpread({}, state, {
          showMessage: false
        });
      }

    case _ActionTypes.ON_TOGGLE_PROJECT_ISSUE_DRAWER:
      {
        return _objectSpread({}, state, {
          drawerState: !state.drawerState
        });
      }

    case _ActionTypes.SHOW_PROJECT_ISSUE_LOADER:
      {
        return _objectSpread({}, state, {
          loader: true
        });
      }

    case _ActionTypes.HIDE_PROJECT_ISSUE_LOADER:
      {
        return _objectSpread({}, state, {
          loader: false
        });
      }

    default:
      return state;
  }
};

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ALL_FILTER, "ALL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectIssue.js");

  __REACT_HOT_LOADER__.register(STARRED_FILTER, "STARRED_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectIssue.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_UPDATE, "SUCCESSFUL_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectIssue.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_FILTER, "SUCCESSFUL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectIssue.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_DELETE, "SUCCESSFUL_DELETE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectIssue.js");

  __REACT_HOT_LOADER__.register(REMOVED_AS_STAR, "REMOVED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectIssue.js");

  __REACT_HOT_LOADER__.register(MARKED_AS_STAR, "MARKED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectIssue.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectIssue.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectIssue.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectIssue.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectIssue.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectIssue.js");

  __REACT_HOT_LOADER__.register(ALL_FILTER, "ALL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectIssue.js");

  __REACT_HOT_LOADER__.register(STARRED_FILTER, "STARRED_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectIssue.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_UPDATE, "SUCCESSFUL_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectIssue.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_FILTER, "SUCCESSFUL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectIssue.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_DELETE, "SUCCESSFUL_DELETE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectIssue.js");

  __REACT_HOT_LOADER__.register(REMOVED_AS_STAR, "REMOVED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectIssue.js");

  __REACT_HOT_LOADER__.register(MARKED_AS_STAR, "MARKED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectIssue.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectIssue.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectIssue.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectIssue.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectIssue.js");
}();

;

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.INIT_STATE = exports.MARKED_AS_STAR = exports.REMOVED_AS_STAR = exports.SUCCESSFUL_DELETE = exports.SUCCESSFUL_FILTER = exports.SUCCESSFUL_UPDATE = exports.STARRED_FILTER = exports.ALL_FILTER = void 0;

var _ActionTypes = __webpack_require__(7);

var _arrayService = __webpack_require__(34);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ALL_FILTER = 'All business units';
exports.ALL_FILTER = ALL_FILTER;
var STARRED_FILTER = 'Starred business units';
exports.STARRED_FILTER = STARRED_FILTER;
var SUCCESSFUL_UPDATE = 'Business Unit Updated Successfully';
exports.SUCCESSFUL_UPDATE = SUCCESSFUL_UPDATE;
var SUCCESSFUL_FILTER = 'Business Unit Filtered Successfully';
exports.SUCCESSFUL_FILTER = SUCCESSFUL_FILTER;
var SUCCESSFUL_DELETE = 'Business Unit Deleted Successfully';
exports.SUCCESSFUL_DELETE = SUCCESSFUL_DELETE;
var REMOVED_AS_STAR = 'Business Unit removed as star';
exports.REMOVED_AS_STAR = REMOVED_AS_STAR;
var MARKED_AS_STAR = 'Business Unit marked as star';
exports.MARKED_AS_STAR = MARKED_AS_STAR;
var INIT_STATE = {
  alertMessage: '',
  showMessage: false,
  loader: false,
  noContentFoundMessage: 'No business units found in selected folder',
  selectedSectionId: 1,
  drawerState: false,
  filterOption: ALL_FILTER,
  allBusinessUnit: [],
  businessUnitList: [],
  selectedBusinessUnit: null,
  selectedBusinessUnits: 0,
  addBusinessUnitState: false,
  searchBusinessUnit: '',
  businessUnit: {
    name: 'ACME Inc',
    email: 'road.runner@example.com',
    avatar: 'http://via.placeholder.com/150x150'
  }
};
exports.INIT_STATE = INIT_STATE;

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.CLEAR_SESSION:
      {
        return _objectSpread({}, INIT_STATE);
      }

    case _ActionTypes.CLEAR_SELECTED_OBJECTS:
      {
        return _objectSpread({}, state, {
          selectedBusinessUnit: null
        });
      }

    case _ActionTypes.ADD_FAVOURITE_BUSINESS_UNIT_SUCCESS:
      {
        var allUpdated = state.allBusinessUnit.map(function (entry) {
          var _action$payload, _action$payload2;

          return (entry === null || entry === void 0 ? void 0 : entry.id) === (action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.id) ? _objectSpread({}, entry, {
            starred: !(action === null || action === void 0 ? void 0 : (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.starred)
          }) : entry;
        });
        var listUpdated = {};

        switch (state.filterOption) {
          case ALL_FILTER:
            {
              listUpdated = allUpdated;
              break;
            }

          case STARRED_FILTER:
            {
              listUpdated = allUpdated.filter(function (entry) {
                return entry.starred;
              });
              break;
            }
        }

        return _objectSpread({}, state, {
          alertMessage: action.payload.starred ? REMOVED_AS_STAR : MARKED_AS_STAR,
          showMessage: true,
          businessUnitList: listUpdated,
          allBusinessUnit: allUpdated
        });
      }

    case _ActionTypes.FETCH_BUSINESS_UNIT_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          selectedBusinessUnit: action.payload
        });
      }

    case _ActionTypes.FETCH_ALL_BUSINESS_UNIT_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          allBusinessUnit: action.payload,
          businessUnitList: action.payload,
          selectedSectionId: 1,
          searchEmp: '',
          filterOption: ALL_FILTER
        });
      }

    case _ActionTypes.SHOW_BUSINESS_UNIT_MESSAGE:
      {
        return _objectSpread({}, state, {
          alertMessage: action.payload,
          showMessage: true,
          loader: false
        });
      }

    case _ActionTypes.ON_BUSINESS_UNIT_SELECT:
      {
        action.payload.selected = !action.payload.selected;
        var selectedBusinessUnits = 0;
        var businessUnitList = state.businessUnitList.map(function (businessUnit) {
          if (businessUnit.selected) {
            selectedBusinessUnits++;
          }

          if (businessUnit.id === action.payload.id) {
            if (businessUnit.selected) {
              selectedBusinessUnits++;
            }

            return action.payload;
          } else {
            return businessUnit;
          }
        });
        return _objectSpread({}, state, {
          INIT_STATE: INIT_STATE,
          selectedBusinessUnits: selectedBusinessUnits,
          businessUnitList: businessUnitList
        });
      }

    case _ActionTypes.ON_ADD_BUSINESS_UNIT:
      {
        return _objectSpread({}, state, {
          addBusinessUnitState: true
        });
      }

    case _ActionTypes.ON_BUSINESS_UNIT_CLOSE:
      {
        return _objectSpread({}, state, {
          addBusinessUnitState: false
        });
      }

    case _ActionTypes.ON_FILTER_BUSINESS_UNIT_OPTION_SELECT:
      {
        var selectedSectionId = 0;
        var filterOption = '';
        var _businessUnitList = [];

        switch (action.payload.name) {
          case ALL_FILTER:
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              _businessUnitList = state.allBusinessUnit;
              break;
            }

          case STARRED_FILTER:
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              _businessUnitList = state.allBusinessUnit.filter(function (businessUnit) {
                return businessUnit.starred;
              });
              break;
            }
        }

        return _objectSpread({}, state, {
          selectedSectionId: selectedSectionId,
          filterOption: filterOption,
          businessUnitList: _businessUnitList,
          drawerState: false
        });
      }

    case _ActionTypes.ON_SAVE_BUSINESS_UNIT_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_UPDATE,
          showMessage: true,
          businessUnitList: (0, _arrayService.addOrUpdateEntry)(state.businessUnitList, action.payload),
          allBusinessUnit: (0, _arrayService.addOrUpdateEntry)(state.allBusinessUnit, action.payload),
          loader: false
        });
      }
    // called after a delete from the db operation to keep the current state up to date

    case _ActionTypes.ON_DELETE_BUSINESS_UNIT_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_DELETE,
          showMessage: true,
          allBusinessUnit: state.allBusinessUnit.filter(function (businessUnit) {
            return businessUnit.id !== action.payload;
          }),
          businessUnitList: state.allBusinessUnit.filter(function (businessUnit) {
            return businessUnit.id !== action.payload;
          }),
          selectedBusinessUnit: null
        });
      }

    case _ActionTypes.ON_FILTER_SELECTED_BUSINESS_UNIT:
      {
        var businessUnits = state.allBusinessUnit.filter(function (businessUnit) {
          return !businessUnit.selected;
        });
        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_FILTER,
          showMessage: true,
          businessUnitList: businessUnits,
          selectedBusinessUnits: 0
        });
      }

    case _ActionTypes.FILTER_BUSINESS_UNIT:
      {
        var _filterOption = state.filterOption;
        var _businessUnitList2 = [];

        if (action.payload === '') {
          _businessUnitList2 = state.allBusinessUnit;
        } else {
          var filterBusinessUnit = state.allBusinessUnit.filter(function (businessUnit) {
            return businessUnit.name.toLowerCase().indexOf(action.payload.toLowerCase()) > -1;
          });

          if (_filterOption === ALL_FILTER) {
            _businessUnitList2 = filterBusinessUnit;
          } else if (_filterOption === STARRED_FILTER) {
            _businessUnitList2 = filterBusinessUnit.filter(function (businessUnit) {
              return businessUnit.starred;
            });
          }
        }

        return _objectSpread({}, state, {
          businessUnitList: _businessUnitList2
        });
      }

    case _ActionTypes.GET_ALL_BUSINESS_UNIT:
      {
        var _businessUnitList3 = state.allBusinessUnit.map(function (businessUnit) {
          return businessUnit ? _objectSpread({}, businessUnit, {
            selected: true
          }) : businessUnit;
        });

        return _objectSpread({}, state, {
          selectedBusinessUnits: _businessUnitList3.length,
          allBusinessUnit: _businessUnitList3,
          businessUnitList: _businessUnitList3
        });
      }

    case _ActionTypes.GET_UNSELECTED_ALL_BUSINESS_UNIT:
      {
        var _businessUnitList4 = state.allBusinessUnit.map(function (businessUnit) {
          return businessUnit ? _objectSpread({}, businessUnit, {
            selected: false
          }) : businessUnit;
        });

        return _objectSpread({}, state, {
          selectedBusinessUnits: 0,
          allBusinessUnit: _businessUnitList4,
          businessUnitList: _businessUnitList4
        });
      }

    case _ActionTypes.ON_ALL_BUSINESS_UNIT_SELECT:
      {
        var selectAll = state.selectedBusinessUnits < state.businessUnitList.length;
        var _selectedBusinessUnits = 0;
        var _businessUnitList5 = [];

        if (selectAll) {
          _businessUnitList5 = state.allBusinessUnit.map(function (businessUnit) {
            return businessUnit ? _objectSpread({}, businessUnit, {
              selected: true
            }) : businessUnit;
          });
          _selectedBusinessUnits = _businessUnitList5.length;
        } else {
          _businessUnitList5 = state.allBusinessUnit.map(function (businessUnit) {
            return businessUnit ? _objectSpread({}, businessUnit, {
              selected: true
            }) : businessUnit;
          });
          _selectedBusinessUnits = 0;
        }

        return _objectSpread({}, state, {
          selectedBusinessUnits: _selectedBusinessUnits,
          allBusinessUnit: _businessUnitList5,
          businessUnitList: _businessUnitList5
        });
      }

    case _ActionTypes.UPDATE_SEARCH_BUSINESS_UNIT:
      {
        return _objectSpread({}, state, {
          searchBusinessUnit: action.payload
        });
      }

    case _ActionTypes.HANDLE_BUSINESS_UNIT_REQUEST_CLOSE:
      {
        return _objectSpread({}, state, {
          showMessage: false
        });
      }

    case _ActionTypes.ON_TOGGLE_BUSINESS_UNIT_DRAWER:
      {
        return _objectSpread({}, state, {
          drawerState: !state.drawerState
        });
      }

    case _ActionTypes.SHOW_BUSINESS_UNIT_LOADER:
      {
        return _objectSpread({}, state, {
          loader: true
        });
      }

    case _ActionTypes.HIDE_BUSINESS_UNIT_LOADER:
      {
        return _objectSpread({}, state, {
          loader: false
        });
      }

    default:
      return state;
  }
};

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ALL_FILTER, "ALL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/businessUnit.js");

  __REACT_HOT_LOADER__.register(STARRED_FILTER, "STARRED_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/businessUnit.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_UPDATE, "SUCCESSFUL_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/businessUnit.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_FILTER, "SUCCESSFUL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/businessUnit.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_DELETE, "SUCCESSFUL_DELETE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/businessUnit.js");

  __REACT_HOT_LOADER__.register(REMOVED_AS_STAR, "REMOVED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/businessUnit.js");

  __REACT_HOT_LOADER__.register(MARKED_AS_STAR, "MARKED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/businessUnit.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/businessUnit.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/businessUnit.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/businessUnit.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/businessUnit.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/businessUnit.js");

  __REACT_HOT_LOADER__.register(ALL_FILTER, "ALL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/businessUnit.js");

  __REACT_HOT_LOADER__.register(STARRED_FILTER, "STARRED_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/businessUnit.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_UPDATE, "SUCCESSFUL_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/businessUnit.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_FILTER, "SUCCESSFUL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/businessUnit.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_DELETE, "SUCCESSFUL_DELETE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/businessUnit.js");

  __REACT_HOT_LOADER__.register(REMOVED_AS_STAR, "REMOVED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/businessUnit.js");

  __REACT_HOT_LOADER__.register(MARKED_AS_STAR, "MARKED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/businessUnit.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/businessUnit.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/businessUnit.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/businessUnit.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/businessUnit.js");
}();

;

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.INIT_STATE = exports.MARKED_AS_STAR = exports.REMOVED_AS_STAR = exports.SUCCESSFUL_DELETE = exports.SUCCESSFUL_FILTER = exports.SUCCESSFUL_UPDATE = exports.STARRED_FILTER = exports.ALL_FILTER = void 0;

var _ActionTypes = __webpack_require__(7);

var _arrayService = __webpack_require__(34);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ALL_FILTER = 'All portfolios';
exports.ALL_FILTER = ALL_FILTER;
var STARRED_FILTER = 'Starred portfolios';
exports.STARRED_FILTER = STARRED_FILTER;
var SUCCESSFUL_UPDATE = 'Portfolio Updated Successfully';
exports.SUCCESSFUL_UPDATE = SUCCESSFUL_UPDATE;
var SUCCESSFUL_FILTER = 'Portfolio Filtered Successfully';
exports.SUCCESSFUL_FILTER = SUCCESSFUL_FILTER;
var SUCCESSFUL_DELETE = 'Portfolio Deleted Successfully';
exports.SUCCESSFUL_DELETE = SUCCESSFUL_DELETE;
var REMOVED_AS_STAR = 'Portfolio removed as star';
exports.REMOVED_AS_STAR = REMOVED_AS_STAR;
var MARKED_AS_STAR = 'Portfolio marked as star';
exports.MARKED_AS_STAR = MARKED_AS_STAR;
var INIT_STATE = {
  alertMessage: '',
  showMessage: false,
  loader: false,
  noContentFoundMessage: 'No portfolios found in selected folder',
  selectedSectionId: 1,
  drawerState: false,
  filterOption: ALL_FILTER,
  allPortfolio: [],
  portfolioList: [],
  selectedPortfolio: null,
  selectedPortfolios: 0,
  addPortfolioState: false,
  editPortfolioState: false,
  searchPortfolio: '',
  selectedDashboardPortfolio: null,
  portfolio: {
    name: 'ACME Inc',
    email: 'road.runner@example.com',
    avatar: 'http://via.placeholder.com/150x150'
  }
};
exports.INIT_STATE = INIT_STATE;

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.CLEAR_SESSION:
      {
        return _objectSpread({}, INIT_STATE);
      }

    case _ActionTypes.CLEAR_SELECTED_OBJECTS:
      {
        return _objectSpread({}, state, {
          selectedPortfolio: null
        });
      }

    case _ActionTypes.ADD_FAVOURITE_PORTFOLIO_SUCCESS:
      {
        var allUpdated = state.allPortfolio.map(function (entry) {
          var _action$payload, _action$payload2;

          return (entry === null || entry === void 0 ? void 0 : entry.id) === (action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.id) ? _objectSpread({}, entry, {
            starred: !(action === null || action === void 0 ? void 0 : (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.starred)
          }) : entry;
        });
        var listUpdated = {};

        switch (state.filterOption) {
          case ALL_FILTER:
            {
              listUpdated = allUpdated;
              break;
            }

          case STARRED_FILTER:
            {
              listUpdated = allUpdated.filter(function (entry) {
                return entry.starred;
              });
              break;
            }
        }

        return _objectSpread({}, state, {
          alertMessage: action.payload.starred ? REMOVED_AS_STAR : MARKED_AS_STAR,
          showMessage: true,
          portfolioList: listUpdated,
          allPortfolio: allUpdated
        });
      }

    case _ActionTypes.ON_PORTFOLIO_DASHBOARD_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          selectedDashboardPortfolio: action.payload
        });
      }

    case _ActionTypes.FETCH_PORTFOLIO_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          selectedPortfolio: action.payload,
          addPortfolioState: false,
          editPortfolioState: false
        });
      }

    case _ActionTypes.FETCH_ALL_PORTFOLIO_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          allPortfolio: action.payload,
          portfolioList: action.payload,
          selectedSectionId: 1,
          searchEmp: '',
          filterOption: ALL_FILTER,
          addPortfolioState: false,
          editPortfolioState: false
        });
      }

    case _ActionTypes.SHOW_PORTFOLIO_MESSAGE:
      {
        return _objectSpread({}, state, {
          alertMessage: action.payload,
          showMessage: true,
          loader: false
        });
      }

    case _ActionTypes.ON_PORTFOLIO_SELECT:
      {
        action.payload.selected = !action.payload.selected;
        var selectedPortfolios = 0;
        var portfolioList = state.portfolioList.map(function (portfolio) {
          if (portfolio.selected) {
            selectedPortfolios++;
          }

          if (portfolio.id === action.payload.id) {
            if (portfolio.selected) {
              selectedPortfolios++;
            }

            return action.payload;
          } else {
            return portfolio;
          }
        });
        return _objectSpread({}, state, {
          INIT_STATE: INIT_STATE,
          selectedPortfolios: selectedPortfolios,
          portfolioList: portfolioList
        });
      }

    case _ActionTypes.ON_ADD_PORTFOLIO:
      {
        return _objectSpread({}, state, {
          addPortfolioState: true,
          editPortfolioState: false
        });
      }

    case _ActionTypes.ON_EDIT_PORTFOLIO:
      {
        return _objectSpread({}, state, {
          selectedPortfolio: action.payload,
          editPortfolioState: true,
          addPortfolioState: false
        });
      }

    case _ActionTypes.ON_PORTFOLIO_CLOSE:
      {
        return _objectSpread({}, state, {
          addPortfolioState: false,
          editPortfolioState: false
        });
      }

    case _ActionTypes.ON_FILTER_PORTFOLIO_OPTION_SELECT:
      {
        var selectedSectionId = 0;
        var filterOption = '';
        var _portfolioList = [];

        switch (action.payload.name) {
          case ALL_FILTER:
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              _portfolioList = state.allPortfolio;
              break;
            }

          case STARRED_FILTER:
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              _portfolioList = state.allPortfolio.filter(function (portfolio) {
                return portfolio.starred;
              });
              break;
            }
        }

        return _objectSpread({}, state, {
          selectedSectionId: selectedSectionId,
          filterOption: filterOption,
          portfolioList: _portfolioList,
          drawerState: false
        });
      }

    case _ActionTypes.ON_SAVE_PORTFOLIO_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_UPDATE,
          showMessage: true,
          portfolioList: (0, _arrayService.addOrUpdateEntry)(state.portfolioList, action.payload),
          allPortfolio: (0, _arrayService.addOrUpdateEntry)(state.allPortfolio, action.payload),
          loader: false
        });
      }
    // called after a delete from the db operation to keep the current state up to date

    case _ActionTypes.ON_DELETE_PORTFOLIO_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_DELETE,
          showMessage: true,
          allPortfolio: state.allPortfolio.filter(function (portfolio) {
            return portfolio.id !== action.payload;
          }),
          portfolioList: state.allPortfolio.filter(function (portfolio) {
            return portfolio.id !== action.payload;
          }),
          selectedPortfolio: null
        });
      }

    case _ActionTypes.ON_FILTER_SELECTED_PORTFOLIO:
      {
        var portfolios = state.allPortfolio.filter(function (portfolio) {
          return !portfolio.selected;
        });
        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_FILTER,
          showMessage: true,
          portfolioList: portfolios,
          selectedPortfolios: 0
        });
      }

    case _ActionTypes.FILTER_PORTFOLIO:
      {
        var _filterOption = state.filterOption;
        var _portfolioList2 = [];

        if (action.payload === '') {
          _portfolioList2 = state.allPortfolio;
        } else {
          var filterPortfolio = state.allPortfolio.filter(function (portfolio) {
            return portfolio.name.toLowerCase().indexOf(action.payload.toLowerCase()) > -1;
          });

          if (_filterOption === ALL_FILTER) {
            _portfolioList2 = filterPortfolio;
          } else if (_filterOption === STARRED_FILTER) {
            _portfolioList2 = filterPortfolio.filter(function (portfolio) {
              return portfolio.starred;
            });
          }
        }

        return _objectSpread({}, state, {
          portfolioList: _portfolioList2
        });
      }

    case _ActionTypes.GET_ALL_PORTFOLIO:
      {
        var _portfolioList3 = state.allPortfolio.map(function (portfolio) {
          return portfolio ? _objectSpread({}, portfolio, {
            selected: true
          }) : portfolio;
        });

        return _objectSpread({}, state, {
          selectedPortfolios: _portfolioList3.length,
          allPortfolio: _portfolioList3,
          portfolioList: _portfolioList3
        });
      }

    case _ActionTypes.GET_UNSELECTED_ALL_PORTFOLIO:
      {
        var _portfolioList4 = state.allPortfolio.map(function (portfolio) {
          return portfolio ? _objectSpread({}, portfolio, {
            selected: false
          }) : portfolio;
        });

        return _objectSpread({}, state, {
          selectedPortfolios: 0,
          allPortfolio: _portfolioList4,
          portfolioList: _portfolioList4
        });
      }

    case _ActionTypes.ON_ALL_PORTFOLIO_SELECT:
      {
        var selectAll = state.selectedPortfolios < state.portfolioList.length;
        var _selectedPortfolios = 0;
        var _portfolioList5 = [];

        if (selectAll) {
          _portfolioList5 = state.allPortfolio.map(function (portfolio) {
            return portfolio ? _objectSpread({}, portfolio, {
              selected: true
            }) : portfolio;
          });
          _selectedPortfolios = _portfolioList5.length;
        } else {
          _portfolioList5 = state.allPortfolio.map(function (portfolio) {
            return portfolio ? _objectSpread({}, portfolio, {
              selected: true
            }) : portfolio;
          });
          _selectedPortfolios = 0;
        }

        return _objectSpread({}, state, {
          selectedPortfolios: _selectedPortfolios,
          allPortfolio: _portfolioList5,
          portfolioList: _portfolioList5
        });
      }

    case _ActionTypes.UPDATE_SEARCH_PORTFOLIO:
      {
        return _objectSpread({}, state, {
          searchPortfolio: action.payload
        });
      }

    case _ActionTypes.HANDLE_PORTFOLIO_REQUEST_CLOSE:
      {
        return _objectSpread({}, state, {
          showMessage: false
        });
      }

    case _ActionTypes.ON_TOGGLE_PORTFOLIO_DRAWER:
      {
        return _objectSpread({}, state, {
          drawerState: !state.drawerState
        });
      }

    case _ActionTypes.SHOW_PORTFOLIO_LOADER:
      {
        return _objectSpread({}, state, {
          loader: true
        });
      }

    case _ActionTypes.HIDE_PORTFOLIO_LOADER:
      {
        return _objectSpread({}, state, {
          loader: false
        });
      }

    default:
      return state;
  }
};

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ALL_FILTER, "ALL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/portfolio.js");

  __REACT_HOT_LOADER__.register(STARRED_FILTER, "STARRED_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/portfolio.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_UPDATE, "SUCCESSFUL_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/portfolio.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_FILTER, "SUCCESSFUL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/portfolio.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_DELETE, "SUCCESSFUL_DELETE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/portfolio.js");

  __REACT_HOT_LOADER__.register(REMOVED_AS_STAR, "REMOVED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/portfolio.js");

  __REACT_HOT_LOADER__.register(MARKED_AS_STAR, "MARKED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/portfolio.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/portfolio.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/portfolio.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/portfolio.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/portfolio.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/portfolio.js");

  __REACT_HOT_LOADER__.register(ALL_FILTER, "ALL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/portfolio.js");

  __REACT_HOT_LOADER__.register(STARRED_FILTER, "STARRED_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/portfolio.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_UPDATE, "SUCCESSFUL_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/portfolio.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_FILTER, "SUCCESSFUL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/portfolio.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_DELETE, "SUCCESSFUL_DELETE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/portfolio.js");

  __REACT_HOT_LOADER__.register(REMOVED_AS_STAR, "REMOVED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/portfolio.js");

  __REACT_HOT_LOADER__.register(MARKED_AS_STAR, "MARKED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/portfolio.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/portfolio.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/portfolio.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/portfolio.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/portfolio.js");
}();

;

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.INIT_STATE = exports.MARKED_AS_STAR = exports.REMOVED_AS_STAR = exports.SUCCESSFUL_DELETE = exports.SUCCESSFUL_FILTER = exports.SUCCESSFUL_UPDATE = exports.STARRED_FILTER = exports.ALL_FILTER = void 0;

var _ActionTypes = __webpack_require__(7);

var _arrayService = __webpack_require__(34);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ALL_FILTER = 'All features';
exports.ALL_FILTER = ALL_FILTER;
var STARRED_FILTER = 'Starred features';
exports.STARRED_FILTER = STARRED_FILTER;
var SUCCESSFUL_UPDATE = 'Feature Updated Successfully';
exports.SUCCESSFUL_UPDATE = SUCCESSFUL_UPDATE;
var SUCCESSFUL_FILTER = 'Feature Filtered Successfully';
exports.SUCCESSFUL_FILTER = SUCCESSFUL_FILTER;
var SUCCESSFUL_DELETE = 'Feature Deleted Successfully';
exports.SUCCESSFUL_DELETE = SUCCESSFUL_DELETE;
var REMOVED_AS_STAR = 'Feature removed as star';
exports.REMOVED_AS_STAR = REMOVED_AS_STAR;
var MARKED_AS_STAR = 'Feature marked as star';
exports.MARKED_AS_STAR = MARKED_AS_STAR;
var INIT_STATE = {
  alertMessage: '',
  showMessage: false,
  loader: false,
  noContentFoundMessage: 'No features found in selected folder',
  selectedSectionId: 1,
  drawerState: false,
  filterOption: ALL_FILTER,
  allFeature: [],
  featureList: [],
  selectedFeature: null,
  selectedFeatures: 0,
  addFeatureState: false,
  searchFeature: '',
  editFeatureState: false,
  dependencyList: [],
  selectedDependencies: 0,
  dependency: {
    name: 'ACME Inc',
    email: 'road.runner@example.com',
    avatar: 'http://via.placeholder.com/150x150'
  }
};
exports.INIT_STATE = INIT_STATE;

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.CLEAR_SESSION:
      {
        return _objectSpread({}, INIT_STATE);
      }

    case _ActionTypes.CLEAR_SELECTED_OBJECTS:
      {
        return _objectSpread({}, state, {
          selectedFeature: null
        });
      }

    case _ActionTypes.ON_FETCH_SELECT_FEATURE_DEPENDENCIES_SUCCESS:
      {
        return _objectSpread({}, state, {
          dependencyList: action === null || action === void 0 ? void 0 : action.payload,
          loader: false
        });
      }

    case _ActionTypes.ON_FEATURE_DEPENDENCY_UPDATE_SUCCESS:
      {
        var _action$payload;

        var updatedSelectedFeature = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.find(function (updated) {
          var _state$selectedFeatur;

          return (updated === null || updated === void 0 ? void 0 : updated.id) === (state === null || state === void 0 ? void 0 : (_state$selectedFeatur = state.selectedFeature) === null || _state$selectedFeatur === void 0 ? void 0 : _state$selectedFeatur.id);
        });
        return _objectSpread({}, state, {
          loader: false,
          selectedFeature: updatedSelectedFeature,
          featureList: action === null || action === void 0 ? void 0 : action.payload,
          allFeature: action === null || action === void 0 ? void 0 : action.payload
        });
      }

    case _ActionTypes.SET_FEATURE:
      {
        var features = state.allFeature.filter(function (entry) {
          return (entry === null || entry === void 0 ? void 0 : entry.id) === (action === null || action === void 0 ? void 0 : action.payload);
        });
        return _objectSpread({}, state, {
          loader: false,
          selectedFeature: (features === null || features === void 0 ? void 0 : features.length) > 0 ? features[0] : []
        });
      }

    case _ActionTypes.ADD_FAVOURITE_FEATURE_SUCCESS:
      {
        var allUpdated = state.allFeature.map(function (entry) {
          var _action$payload2, _action$payload3;

          return (entry === null || entry === void 0 ? void 0 : entry.id) === (action === null || action === void 0 ? void 0 : (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.id) ? _objectSpread({}, entry, {
            starred: !(action === null || action === void 0 ? void 0 : (_action$payload3 = action.payload) === null || _action$payload3 === void 0 ? void 0 : _action$payload3.starred)
          }) : entry;
        });
        var listUpdated = {};

        switch (state.filterOption) {
          case ALL_FILTER:
            {
              listUpdated = allUpdated;
              break;
            }

          case STARRED_FILTER:
            {
              listUpdated = allUpdated.filter(function (entry) {
                return entry.starred;
              });
              break;
            }
        }

        return _objectSpread({}, state, {
          alertMessage: action.payload.starred ? REMOVED_AS_STAR : MARKED_AS_STAR,
          showMessage: true,
          featureList: listUpdated,
          allFeature: allUpdated
        });
      }

    case _ActionTypes.FETCH_FEATURE_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          selectedFeature: action.payload
        });
      }

    case _ActionTypes.FETCH_ALL_FEATURE_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          allFeature: action.payload,
          featureList: action.payload,
          selectedSectionId: 1,
          searchEmp: '',
          filterOption: ALL_FILTER,
          addFeatureState: false,
          editFeatureState: false
        });
      }

    case _ActionTypes.SHOW_FEATURE_MESSAGE:
      {
        return _objectSpread({}, state, {
          alertMessage: action.payload,
          showMessage: true,
          loader: false
        });
      }

    case _ActionTypes.ON_FEATURE_SELECT:
      {
        action.payload.selected = !action.payload.selected;
        var selectedDependencies = 0;
        var dependencyList = state.dependencyList.map(function (dependency) {
          if (dependency.selected) {
            selectedDependencies++;
          }

          if (dependency.id === action.payload.id) {
            if (dependency.selected) {
              selectedDependencies++;
            }

            return action.payload;
          } else {
            return dependency;
          }
        });
        return _objectSpread({}, state, {
          INIT_STATE: INIT_STATE,
          selectedDependencies: selectedDependencies,
          dependencyList: dependencyList
        });
      }

    case _ActionTypes.ON_ADD_FEATURE:
      {
        return _objectSpread({}, state, {
          addFeatureState: true,
          editFeatureState: false
        });
      }

    case _ActionTypes.ON_EDIT_FEATURE:
      {
        return _objectSpread({}, state, {
          addFeatureState: false,
          editFeatureState: true
        });
      }

    case _ActionTypes.ON_FEATURE_CLOSE:
      {
        return _objectSpread({}, state, {
          addFeatureState: false,
          editFeatureState: false
        });
      }

    case _ActionTypes.ON_FILTER_FEATURE_OPTION_SELECT:
      {
        var selectedSectionId = 0;
        var filterOption = '';
        var featureList = [];

        switch (action.payload.name) {
          case ALL_FILTER:
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              featureList = state.allFeature;
              break;
            }

          case STARRED_FILTER:
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              featureList = state.allFeature.filter(function (dependency) {
                return dependency.starred;
              });
              break;
            }
        }

        return _objectSpread({}, state, {
          selectedSectionId: selectedSectionId,
          filterOption: filterOption,
          featureList: featureList,
          drawerState: false
        });
      }

    case _ActionTypes.ON_SAVE_FEATURE_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_UPDATE,
          showMessage: true,
          featureList: (0, _arrayService.addOrUpdateEntry)(state.featureList, action.payload),
          allFeature: (0, _arrayService.addOrUpdateEntry)(state.allFeature, action.payload),
          selectedFeature: action.payload,
          loader: false
        });
      }
    // called after a delete from the db operation to keep the current state up to date

    case _ActionTypes.ON_DELETE_FEATURE_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_DELETE,
          showMessage: true,
          allFeature: state.allFeature.filter(function (dependency) {
            return dependency.id !== action.payload;
          }),
          featureList: state.allFeature.filter(function (dependency) {
            return dependency.id !== action.payload;
          }),
          selectedFeature: null
        });
      }

    case _ActionTypes.ON_FILTER_SELECTED_FEATURE:
      {
        var _features = state.allFeature.filter(function (dependency) {
          return !dependency.selected;
        });

        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_FILTER,
          showMessage: true,
          featureList: _features,
          selectedFeatures: 0
        });
      }

    case _ActionTypes.FILTER_FEATURE:
      {
        var _filterOption = state.filterOption;
        var _featureList = [];

        if (action.payload === '') {
          _featureList = state.allFeature;
        } else {
          var filterFeature = state.allFeature.filter(function (dependency) {
            return dependency.name.toLowerCase().indexOf(action.payload.toLowerCase()) > -1;
          });

          if (_filterOption === ALL_FILTER) {
            _featureList = filterFeature;
          } else if (_filterOption === STARRED_FILTER) {
            _featureList = filterFeature.filter(function (dependency) {
              return dependency.starred;
            });
          }
        }

        return _objectSpread({}, state, {
          featureList: _featureList
        });
      }

    case _ActionTypes.GET_ALL_FEATURE:
      {
        var _featureList2 = state.allFeature.map(function (dependency) {
          return dependency ? _objectSpread({}, dependency, {
            selected: true
          }) : dependency;
        });

        return _objectSpread({}, state, {
          selectedFeatures: _featureList2.length,
          allFeature: _featureList2,
          featureList: _featureList2
        });
      }

    case _ActionTypes.GET_UNSELECTED_ALL_FEATURE:
      {
        var _featureList3 = state.allFeature.map(function (dependency) {
          return dependency ? _objectSpread({}, dependency, {
            selected: false
          }) : dependency;
        });

        return _objectSpread({}, state, {
          selectedFeatures: 0,
          allFeature: _featureList3,
          featureList: _featureList3
        });
      }

    case _ActionTypes.ON_ALL_FEATURE_SELECT:
      {
        var selectAll = state.selectedFeatures < state.featureList.length;
        var selectedFeatures = 0;
        var _featureList4 = [];

        if (selectAll) {
          _featureList4 = state.allFeature.map(function (dependency) {
            return dependency ? _objectSpread({}, dependency, {
              selected: true
            }) : dependency;
          });
          selectedFeatures = _featureList4.length;
        } else {
          _featureList4 = state.allFeature.map(function (dependency) {
            return dependency ? _objectSpread({}, dependency, {
              selected: true
            }) : dependency;
          });
          selectedFeatures = 0;
        }

        return _objectSpread({}, state, {
          selectedFeatures: selectedFeatures,
          allFeature: _featureList4,
          featureList: _featureList4
        });
      }

    case _ActionTypes.UPDATE_SEARCH_FEATURE:
      {
        return _objectSpread({}, state, {
          searchFeature: action.payload
        });
      }

    case _ActionTypes.HANDLE_FEATURE_REQUEST_CLOSE:
      {
        return _objectSpread({}, state, {
          showMessage: false
        });
      }

    case _ActionTypes.ON_TOGGLE_FEATURE_DRAWER:
      {
        return _objectSpread({}, state, {
          drawerState: !state.drawerState
        });
      }

    case _ActionTypes.SHOW_FEATURE_LOADER:
      {
        return _objectSpread({}, state, {
          loader: true
        });
      }

    case _ActionTypes.HIDE_FEATURE_LOADER:
      {
        return _objectSpread({}, state, {
          loader: false
        });
      }

    default:
      return state;
  }
};

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ALL_FILTER, "ALL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/feature.js");

  __REACT_HOT_LOADER__.register(STARRED_FILTER, "STARRED_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/feature.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_UPDATE, "SUCCESSFUL_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/feature.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_FILTER, "SUCCESSFUL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/feature.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_DELETE, "SUCCESSFUL_DELETE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/feature.js");

  __REACT_HOT_LOADER__.register(REMOVED_AS_STAR, "REMOVED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/feature.js");

  __REACT_HOT_LOADER__.register(MARKED_AS_STAR, "MARKED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/feature.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/feature.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/feature.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/feature.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/feature.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/feature.js");

  __REACT_HOT_LOADER__.register(ALL_FILTER, "ALL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/feature.js");

  __REACT_HOT_LOADER__.register(STARRED_FILTER, "STARRED_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/feature.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_UPDATE, "SUCCESSFUL_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/feature.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_FILTER, "SUCCESSFUL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/feature.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_DELETE, "SUCCESSFUL_DELETE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/feature.js");

  __REACT_HOT_LOADER__.register(REMOVED_AS_STAR, "REMOVED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/feature.js");

  __REACT_HOT_LOADER__.register(MARKED_AS_STAR, "MARKED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/feature.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/feature.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/feature.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/feature.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/feature.js");
}();

;

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.INIT_STATE = exports.MARKED_AS_STAR = exports.REMOVED_AS_STAR = exports.SUCCESSFUL_DELETE = exports.SUCCESSFUL_FILTER = exports.SUCCESSFUL_UPDATE = exports.STARRED_FILTER = exports.ALL_FILTER = void 0;

var _ActionTypes = __webpack_require__(7);

var _arrayService = __webpack_require__(34);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ALL_FILTER = 'All value streams';
exports.ALL_FILTER = ALL_FILTER;
var STARRED_FILTER = 'Starred value streams';
exports.STARRED_FILTER = STARRED_FILTER;
var SUCCESSFUL_UPDATE = 'Value stream Updated Successfully';
exports.SUCCESSFUL_UPDATE = SUCCESSFUL_UPDATE;
var SUCCESSFUL_FILTER = 'Value stream Filtered Successfully';
exports.SUCCESSFUL_FILTER = SUCCESSFUL_FILTER;
var SUCCESSFUL_DELETE = 'Value stream Deleted Successfully';
exports.SUCCESSFUL_DELETE = SUCCESSFUL_DELETE;
var REMOVED_AS_STAR = 'Value stream removed as star';
exports.REMOVED_AS_STAR = REMOVED_AS_STAR;
var MARKED_AS_STAR = 'Value stream marked as star';
exports.MARKED_AS_STAR = MARKED_AS_STAR;
var INIT_STATE = {
  alertMessage: '',
  showMessage: false,
  loader: false,
  noContentFoundMessage: 'No value streams found in selected folder',
  selectedSectionId: 1,
  drawerState: false,
  filterOption: ALL_FILTER,
  allValueStream: [],
  valueStreamList: [],
  selectedValueStream: null,
  selectedValueStreams: 0,
  addValueStreamState: false,
  editValueStreamState: false,
  searchValueStream: '',
  teamSelectionList: [],
  selectedTeams: 0,
  valueStream: {
    name: 'ACME Inc',
    email: 'road.runner@example.com',
    avatar: 'http://via.placeholder.com/150x150'
  }
};
exports.INIT_STATE = INIT_STATE;

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.CLEAR_SESSION:
      {
        return _objectSpread({}, INIT_STATE);
      }

    case _ActionTypes.CLEAR_SELECTED_OBJECTS:
      {
        return _objectSpread({}, state, {
          selectedValueStream: null
        });
      }

    case _ActionTypes.ON_FETCH_SELECT_TEAM_DATA_SUCCESS:
      {
        return _objectSpread({}, state, {
          teamSelectionList: action === null || action === void 0 ? void 0 : action.payload,
          loader: false
        });
      }

    case _ActionTypes.SET_VALUE_STREAM:
      {
        var valueStreams = state.allValueStream.filter(function (entry) {
          return (entry === null || entry === void 0 ? void 0 : entry.id) === (action === null || action === void 0 ? void 0 : action.payload);
        });
        return _objectSpread({}, state, {
          loader: false,
          selectedValueStream: (valueStreams === null || valueStreams === void 0 ? void 0 : valueStreams.length) > 0 ? valueStreams[0] : []
        });
      }

    case _ActionTypes.ADD_FAVOURITE_VALUE_STREAM_SUCCESS:
      {
        var allUpdated = state.allValueStream.map(function (entry) {
          var _action$payload, _action$payload2;

          return (entry === null || entry === void 0 ? void 0 : entry.id) === (action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.id) ? _objectSpread({}, entry, {
            starred: !(action === null || action === void 0 ? void 0 : (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.starred)
          }) : entry;
        });
        var listUpdated = {};

        switch (state.filterOption) {
          case ALL_FILTER:
            {
              listUpdated = allUpdated;
              break;
            }

          case STARRED_FILTER:
            {
              listUpdated = allUpdated.filter(function (entry) {
                return entry.starred;
              });
              break;
            }
        }

        return _objectSpread({}, state, {
          alertMessage: action.payload.starred ? REMOVED_AS_STAR : MARKED_AS_STAR,
          showMessage: true,
          valueStreamList: listUpdated,
          allValueStream: allUpdated
        });
      }

    case _ActionTypes.FETCH_VALUE_STREAM_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          selectedValueStream: action.payload,
          addValueStreamState: false,
          editValueStreamState: false
        });
      }

    case _ActionTypes.FETCH_ALL_VALUE_STREAM_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          allValueStream: action.payload,
          valueStreamList: action.payload,
          selectedSectionId: 1,
          searchEmp: '',
          filterOption: ALL_FILTER,
          addValueStreamState: false,
          editValueStreamState: false
        });
      }

    case _ActionTypes.SHOW_VALUE_STREAM_MESSAGE:
      {
        return _objectSpread({}, state, {
          alertMessage: action.payload,
          showMessage: true,
          loader: false
        });
      }

    case _ActionTypes.ON_VALUE_STREAM_SELECT:
      {
        action.payload.selected = !action.payload.selected;
        var selectedTeams = 0;
        var teamSelectionList = state.teamSelectionList.map(function (team) {
          if (team.selected) {
            selectedTeams++;
          }

          if (team.id === action.payload.id) {
            if (team.selected) {
              selectedTeams++;
            }

            return action.payload;
          } else {
            return team;
          }
        });
        return _objectSpread({}, state, {
          INIT_STATE: INIT_STATE,
          selectedTeams: selectedTeams,
          teamSelectionList: teamSelectionList
        });
      }

    case _ActionTypes.ON_ADD_VALUE_STREAM:
      {
        return _objectSpread({}, state, {
          addValueStreamState: true,
          editValueStreamState: false
        });
      }

    case _ActionTypes.ON_EDIT_VALUE_STREAM:
      {
        return _objectSpread({}, state, {
          selectedValueStream: action.payload,
          editValueStreamState: true,
          addValueStreamState: false
        });
      }

    case _ActionTypes.ON_VALUE_STREAM_CLOSE:
      {
        return _objectSpread({}, state, {
          addValueStreamState: false,
          editValueStreamState: false
        });
      }

    case _ActionTypes.ON_FILTER_VALUE_STREAM_OPTION_SELECT:
      {
        var selectedSectionId = 0;
        var filterOption = '';
        var valueStreamList = [];

        switch (action.payload.name) {
          case ALL_FILTER:
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              valueStreamList = state.allValueStream;
              break;
            }

          case STARRED_FILTER:
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              valueStreamList = state.allValueStream.filter(function (valueStream) {
                return valueStream.starred;
              });
              break;
            }
        }

        return _objectSpread({}, state, {
          selectedSectionId: selectedSectionId,
          filterOption: filterOption,
          valueStreamList: valueStreamList,
          drawerState: false
        });
      }

    case _ActionTypes.ON_SAVE_VALUE_STREAM_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_UPDATE,
          showMessage: true,
          valueStreamList: (0, _arrayService.addOrUpdateEntry)(state.valueStreamList, action.payload),
          allValueStream: (0, _arrayService.addOrUpdateEntry)(state.allValueStream, action.payload),
          selectedValueStream: action.payload,
          loader: false
        });
      }
    // called after a delete from the db operation to keep the current state up to date

    case _ActionTypes.ON_DELETE_VALUE_STREAM_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_DELETE,
          showMessage: true,
          allValueStream: state.allValueStream.filter(function (valueStream) {
            return valueStream.id !== action.payload;
          }),
          valueStreamList: state.allValueStream.filter(function (valueStream) {
            return valueStream.id !== action.payload;
          }),
          selectedValueStream: null
        });
      }

    case _ActionTypes.ON_FILTER_SELECTED_VALUE_STREAM:
      {
        var _valueStreams = state.allValueStream.filter(function (valueStream) {
          return !valueStream.selected;
        });

        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_FILTER,
          showMessage: true,
          valueStreamList: _valueStreams,
          selectedValueStreams: 0
        });
      }

    case _ActionTypes.FILTER_VALUE_STREAM:
      {
        var _filterOption = state.filterOption;
        var _valueStreamList = [];

        if (action.payload === '') {
          _valueStreamList = state.allValueStream;
        } else {
          var filterValueStream = state.allValueStream.filter(function (valueStream) {
            return valueStream.name.toLowerCase().indexOf(action.payload.toLowerCase()) > -1;
          });

          if (_filterOption === ALL_FILTER) {
            _valueStreamList = filterValueStream;
          } else if (_filterOption === STARRED_FILTER) {
            _valueStreamList = filterValueStream.filter(function (valueStream) {
              return valueStream.starred;
            });
          }
        }

        return _objectSpread({}, state, {
          valueStreamList: _valueStreamList
        });
      }

    case _ActionTypes.GET_ALL_VALUE_STREAM:
      {
        var _valueStreamList2 = state.allValueStream.map(function (valueStream) {
          return valueStream ? _objectSpread({}, valueStream, {
            selected: true
          }) : valueStream;
        });

        return _objectSpread({}, state, {
          selectedValueStreams: _valueStreamList2.length,
          allValueStream: _valueStreamList2,
          valueStreamList: _valueStreamList2
        });
      }

    case _ActionTypes.GET_UNSELECTED_ALL_VALUE_STREAM:
      {
        var _valueStreamList3 = state.allValueStream.map(function (valueStream) {
          return valueStream ? _objectSpread({}, valueStream, {
            selected: false
          }) : valueStream;
        });

        return _objectSpread({}, state, {
          selectedValueStreams: 0,
          allValueStream: _valueStreamList3,
          valueStreamList: _valueStreamList3
        });
      }

    case _ActionTypes.ON_ALL_VALUE_STREAM_SELECT:
      {
        var selectAll = state.selectedValueStreams < state.valueStreamList.length;
        var selectedValueStreams = 0;
        var _valueStreamList4 = [];

        if (selectAll) {
          _valueStreamList4 = state.allValueStream.map(function (valueStream) {
            return valueStream ? _objectSpread({}, valueStream, {
              selected: true
            }) : valueStream;
          });
          selectedValueStreams = _valueStreamList4.length;
        } else {
          _valueStreamList4 = state.allValueStream.map(function (valueStream) {
            return valueStream ? _objectSpread({}, valueStream, {
              selected: true
            }) : valueStream;
          });
          selectedValueStreams = 0;
        }

        return _objectSpread({}, state, {
          selectedValueStreams: selectedValueStreams,
          allValueStream: _valueStreamList4,
          valueStreamList: _valueStreamList4
        });
      }

    case _ActionTypes.UPDATE_SEARCH_VALUE_STREAM:
      {
        return _objectSpread({}, state, {
          searchValueStream: action.payload
        });
      }

    case _ActionTypes.HANDLE_VALUE_STREAM_REQUEST_CLOSE:
      {
        return _objectSpread({}, state, {
          showMessage: false
        });
      }

    case _ActionTypes.ON_TOGGLE_VALUE_STREAM_DRAWER:
      {
        return _objectSpread({}, state, {
          drawerState: !state.drawerState
        });
      }

    case _ActionTypes.SHOW_VALUE_STREAM_LOADER:
      {
        return _objectSpread({}, state, {
          loader: true
        });
      }

    case _ActionTypes.HIDE_VALUE_STREAM_LOADER:
      {
        return _objectSpread({}, state, {
          loader: false
        });
      }

    default:
      return state;
  }
};

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ALL_FILTER, "ALL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/valueStream.js");

  __REACT_HOT_LOADER__.register(STARRED_FILTER, "STARRED_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/valueStream.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_UPDATE, "SUCCESSFUL_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/valueStream.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_FILTER, "SUCCESSFUL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/valueStream.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_DELETE, "SUCCESSFUL_DELETE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/valueStream.js");

  __REACT_HOT_LOADER__.register(REMOVED_AS_STAR, "REMOVED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/valueStream.js");

  __REACT_HOT_LOADER__.register(MARKED_AS_STAR, "MARKED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/valueStream.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/valueStream.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/valueStream.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/valueStream.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/valueStream.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/valueStream.js");

  __REACT_HOT_LOADER__.register(ALL_FILTER, "ALL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/valueStream.js");

  __REACT_HOT_LOADER__.register(STARRED_FILTER, "STARRED_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/valueStream.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_UPDATE, "SUCCESSFUL_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/valueStream.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_FILTER, "SUCCESSFUL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/valueStream.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_DELETE, "SUCCESSFUL_DELETE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/valueStream.js");

  __REACT_HOT_LOADER__.register(REMOVED_AS_STAR, "REMOVED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/valueStream.js");

  __REACT_HOT_LOADER__.register(MARKED_AS_STAR, "MARKED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/valueStream.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/valueStream.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/valueStream.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/valueStream.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/valueStream.js");
}();

;

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.INIT_STATE = exports.MARKED_AS_STAR = exports.REMOVED_AS_STAR = exports.SUCCESSFUL_DELETE = exports.SUCCESSFUL_FILTER = exports.SUCCESSFUL_UPDATE = exports.STARRED_FILTER = exports.ALL_FILTER = void 0;

var _ActionTypes = __webpack_require__(7);

var _arrayService = __webpack_require__(34);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ALL_FILTER = 'All members';
exports.ALL_FILTER = ALL_FILTER;
var STARRED_FILTER = 'Starred members';
exports.STARRED_FILTER = STARRED_FILTER;
var SUCCESSFUL_UPDATE = 'Member Updated Successfully';
exports.SUCCESSFUL_UPDATE = SUCCESSFUL_UPDATE;
var SUCCESSFUL_FILTER = 'Member Filtered Successfully';
exports.SUCCESSFUL_FILTER = SUCCESSFUL_FILTER;
var SUCCESSFUL_DELETE = 'Member Deleted Successfully';
exports.SUCCESSFUL_DELETE = SUCCESSFUL_DELETE;
var REMOVED_AS_STAR = 'Member removed as star';
exports.REMOVED_AS_STAR = REMOVED_AS_STAR;
var MARKED_AS_STAR = 'Member marked as star';
exports.MARKED_AS_STAR = MARKED_AS_STAR;
var INIT_STATE = {
  alertMessage: '',
  showMessage: false,
  loader: false,
  noContentFoundMessage: 'No members found in selected folder',
  selectedSectionId: 1,
  drawerState: false,
  filterOption: ALL_FILTER,
  allMember: [],
  memberList: [],
  selectedMember: null,
  selectedMembers: 0,
  addMemberState: false,
  editMemberState: false,
  searchMember: '',
  member: {
    name: 'ACME Inc',
    email: 'road.runner@example.com',
    avatar: 'http://via.placeholder.com/150x150'
  }
};
exports.INIT_STATE = INIT_STATE;

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.CLEAR_SESSION:
      {
        return _objectSpread({}, INIT_STATE);
      }

    case _ActionTypes.CLEAR_SELECTED_OBJECTS:
      {
        return _objectSpread({}, state, {
          selectedMember: null
        });
      }

    case _ActionTypes.ADD_FAVOURITE_MEMBER_SUCCESS:
      {
        var allUpdated = state.allMember.map(function (entry) {
          var _action$payload, _action$payload2;

          return (entry === null || entry === void 0 ? void 0 : entry.id) === (action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.id) ? _objectSpread({}, entry, {
            starred: !(action === null || action === void 0 ? void 0 : (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.starred)
          }) : entry;
        });
        var listUpdated = {};

        switch (state.filterOption) {
          case ALL_FILTER:
            {
              listUpdated = allUpdated;
              break;
            }

          case STARRED_FILTER:
            {
              listUpdated = allUpdated.filter(function (entry) {
                return entry.starred;
              });
              break;
            }
        }

        return _objectSpread({}, state, {
          alertMessage: action.payload.starred ? REMOVED_AS_STAR : MARKED_AS_STAR,
          showMessage: true,
          memberList: listUpdated,
          allMember: allUpdated
        });
      }

    case _ActionTypes.FETCH_MEMBER_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          selectedMember: action.payload,
          addMemberState: false,
          editMemberState: false
        });
      }

    case _ActionTypes.FETCH_ALL_MEMBER_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          allMember: action.payload,
          memberList: action.payload,
          selectedSectionId: 1,
          searchEmp: '',
          filterOption: ALL_FILTER,
          addMemberState: false,
          editMemberState: false
        });
      }

    case _ActionTypes.SHOW_MEMBER_MESSAGE:
      {
        return _objectSpread({}, state, {
          alertMessage: action.payload,
          showMessage: true,
          loader: false
        });
      }

    case _ActionTypes.ON_MEMBER_SELECT:
      {
        action.payload.selected = !action.payload.selected;
        var selectedMembers = 0;
        var memberList = state.memberList.map(function (member) {
          if (member.selected) {
            selectedMembers++;
          }

          if (member.id === action.payload.id) {
            if (member.selected) {
              selectedMembers++;
            }

            return action.payload;
          } else {
            return member;
          }
        });
        return _objectSpread({}, state, {
          INIT_STATE: INIT_STATE,
          selectedMembers: selectedMembers,
          memberList: memberList
        });
      }

    case _ActionTypes.ON_ADD_MEMBER:
      {
        return _objectSpread({}, state, {
          addMemberState: true,
          editMemberState: false
        });
      }

    case _ActionTypes.ON_EDIT_MEMBER:
      {
        return _objectSpread({}, state, {
          selectedMember: action.payload,
          editMemberState: true,
          addMemberState: false
        });
      }

    case _ActionTypes.ON_MEMBER_CLOSE:
      {
        return _objectSpread({}, state, {
          addMemberState: false,
          editMemberState: false
        });
      }

    case _ActionTypes.ON_FILTER_MEMBER_OPTION_SELECT:
      {
        var selectedSectionId = 0;
        var filterOption = '';
        var _memberList = [];

        switch (action.payload.name) {
          case ALL_FILTER:
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              _memberList = state.allMember;
              break;
            }

          case STARRED_FILTER:
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              _memberList = state.allMember.filter(function (member) {
                return member.starred;
              });
              break;
            }
        }

        return _objectSpread({}, state, {
          selectedSectionId: selectedSectionId,
          filterOption: filterOption,
          memberList: _memberList,
          drawerState: false
        });
      }

    case _ActionTypes.ON_SAVE_MEMBER_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_UPDATE,
          showMessage: true,
          memberList: (0, _arrayService.addOrUpdateEntry)(state.memberList, action.payload),
          allMember: (0, _arrayService.addOrUpdateEntry)(state.allMember, action.payload),
          loader: false
        });
      }
    // called after a delete from the db operation to keep the current state up to date

    case _ActionTypes.ON_DELETE_MEMBER_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_DELETE,
          showMessage: true,
          allMember: state.allMember.filter(function (member) {
            return member.id !== action.payload;
          }),
          memberList: state.allMember.filter(function (member) {
            return member.id !== action.payload;
          }),
          selectedMember: null
        });
      }

    case _ActionTypes.ON_FILTER_SELECTED_MEMBER:
      {
        var members = state.allMember.filter(function (member) {
          return !member.selected;
        });
        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_FILTER,
          showMessage: true,
          memberList: members,
          selectedMembers: 0
        });
      }

    case _ActionTypes.FILTER_MEMBER:
      {
        var _filterOption = state.filterOption;
        var _memberList2 = [];

        if (action.payload === '') {
          _memberList2 = state.allMember;
        } else {
          var filterMember = state.allMember.filter(function (member) {
            return member.name.toLowerCase().indexOf(action.payload.toLowerCase()) > -1;
          });

          if (_filterOption === ALL_FILTER) {
            _memberList2 = filterMember;
          } else if (_filterOption === STARRED_FILTER) {
            _memberList2 = filterMember.filter(function (member) {
              return member.starred;
            });
          }
        }

        return _objectSpread({}, state, {
          memberList: _memberList2
        });
      }

    case _ActionTypes.GET_ALL_MEMBER:
      {
        var _memberList3 = state.allMember.map(function (member) {
          return member ? _objectSpread({}, member, {
            selected: true
          }) : member;
        });

        return _objectSpread({}, state, {
          selectedMembers: _memberList3.length,
          allMember: _memberList3,
          memberList: _memberList3
        });
      }

    case _ActionTypes.GET_UNSELECTED_ALL_MEMBER:
      {
        var _memberList4 = state.allMember.map(function (member) {
          return member ? _objectSpread({}, member, {
            selected: false
          }) : member;
        });

        return _objectSpread({}, state, {
          selectedMembers: 0,
          allMember: _memberList4,
          memberList: _memberList4
        });
      }

    case _ActionTypes.ON_ALL_MEMBER_SELECT:
      {
        var selectAll = state.selectedMembers < state.memberList.length;
        var _selectedMembers = 0;
        var _memberList5 = [];

        if (selectAll) {
          _memberList5 = state.allMember.map(function (member) {
            return member ? _objectSpread({}, member, {
              selected: true
            }) : member;
          });
          _selectedMembers = _memberList5.length;
        } else {
          _memberList5 = state.allMember.map(function (member) {
            return member ? _objectSpread({}, member, {
              selected: true
            }) : member;
          });
          _selectedMembers = 0;
        }

        return _objectSpread({}, state, {
          selectedMembers: _selectedMembers,
          allMember: _memberList5,
          memberList: _memberList5
        });
      }

    case _ActionTypes.UPDATE_SEARCH_MEMBER:
      {
        return _objectSpread({}, state, {
          searchMember: action.payload
        });
      }

    case _ActionTypes.HANDLE_MEMBER_REQUEST_CLOSE:
      {
        return _objectSpread({}, state, {
          showMessage: false
        });
      }

    case _ActionTypes.ON_TOGGLE_MEMBER_DRAWER:
      {
        return _objectSpread({}, state, {
          drawerState: !state.drawerState
        });
      }

    case _ActionTypes.SHOW_MEMBER_LOADER:
      {
        return _objectSpread({}, state, {
          loader: true
        });
      }

    case _ActionTypes.HIDE_MEMBER_LOADER:
      {
        return _objectSpread({}, state, {
          loader: false
        });
      }

    default:
      return state;
  }
};

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ALL_FILTER, "ALL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/member.js");

  __REACT_HOT_LOADER__.register(STARRED_FILTER, "STARRED_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/member.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_UPDATE, "SUCCESSFUL_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/member.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_FILTER, "SUCCESSFUL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/member.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_DELETE, "SUCCESSFUL_DELETE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/member.js");

  __REACT_HOT_LOADER__.register(REMOVED_AS_STAR, "REMOVED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/member.js");

  __REACT_HOT_LOADER__.register(MARKED_AS_STAR, "MARKED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/member.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/member.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/member.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/member.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/member.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/member.js");

  __REACT_HOT_LOADER__.register(ALL_FILTER, "ALL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/member.js");

  __REACT_HOT_LOADER__.register(STARRED_FILTER, "STARRED_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/member.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_UPDATE, "SUCCESSFUL_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/member.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_FILTER, "SUCCESSFUL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/member.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_DELETE, "SUCCESSFUL_DELETE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/member.js");

  __REACT_HOT_LOADER__.register(REMOVED_AS_STAR, "REMOVED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/member.js");

  __REACT_HOT_LOADER__.register(MARKED_AS_STAR, "MARKED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/member.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/member.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/member.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/member.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/member.js");
}();

;

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.INIT_STATE = exports.MARKED_AS_STAR = exports.REMOVED_AS_STAR = exports.SUCCESSFUL_DELETE = exports.SUCCESSFUL_FILTER = exports.SUCCESSFUL_UPDATE = exports.STARRED_FILTER = exports.ALL_FILTER = void 0;

var _ActionTypes = __webpack_require__(7);

var _arrayService = __webpack_require__(34);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ALL_FILTER = 'All teams';
exports.ALL_FILTER = ALL_FILTER;
var STARRED_FILTER = 'Starred teams';
exports.STARRED_FILTER = STARRED_FILTER;
var SUCCESSFUL_UPDATE = 'Team Updated Successfully';
exports.SUCCESSFUL_UPDATE = SUCCESSFUL_UPDATE;
var SUCCESSFUL_FILTER = 'Team Filtered Successfully';
exports.SUCCESSFUL_FILTER = SUCCESSFUL_FILTER;
var SUCCESSFUL_DELETE = 'Team Deleted Successfully';
exports.SUCCESSFUL_DELETE = SUCCESSFUL_DELETE;
var REMOVED_AS_STAR = 'Team removed as star';
exports.REMOVED_AS_STAR = REMOVED_AS_STAR;
var MARKED_AS_STAR = 'Team marked as star';
exports.MARKED_AS_STAR = MARKED_AS_STAR;
var INIT_STATE = {
  alertMessage: '',
  showMessage: false,
  loader: false,
  noContentFoundMessage: 'No teams found in selected folder',
  selectedSectionId: 1,
  drawerState: false,
  filterOption: ALL_FILTER,
  allTeam: [],
  teamList: [],
  selectedTeam: null,
  selectedTeams: 0,
  addTeamState: false,
  editTeamState: false,
  searchTeam: '',
  memberSelectionList: [],
  selectedMembers: 0,
  team: {
    name: 'ACME Inc',
    email: 'road.runner@example.com',
    avatar: 'http://via.placeholder.com/150x150'
  }
};
exports.INIT_STATE = INIT_STATE;

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.CLEAR_SESSION:
      {
        return _objectSpread({}, INIT_STATE);
      }

    case _ActionTypes.CLEAR_SELECTED_OBJECTS:
      {
        return _objectSpread({}, state, {
          selectedTeam: null
        });
      }

    case _ActionTypes.ON_FETCH_SELECT_MEMBER_DATA_SUCCESS:
      {
        return _objectSpread({}, state, {
          memberSelectionList: action === null || action === void 0 ? void 0 : action.payload,
          loader: false
        });
      }

    case _ActionTypes.SET_TEAM:
      {
        var teams = state.allTeam.filter(function (entry) {
          return (entry === null || entry === void 0 ? void 0 : entry.id) === (action === null || action === void 0 ? void 0 : action.payload);
        });
        return _objectSpread({}, state, {
          loader: false,
          selectedTeam: (teams === null || teams === void 0 ? void 0 : teams.length) > 0 ? teams[0] : []
        });
      }

    case _ActionTypes.ADD_FAVOURITE_TEAM_SUCCESS:
      {
        var allUpdated = state.allTeam.map(function (entry) {
          var _action$payload, _action$payload2;

          return (entry === null || entry === void 0 ? void 0 : entry.id) === (action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.id) ? _objectSpread({}, entry, {
            starred: !(action === null || action === void 0 ? void 0 : (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.starred)
          }) : entry;
        });
        var listUpdated = {};

        switch (state.filterOption) {
          case ALL_FILTER:
            {
              listUpdated = allUpdated;
              break;
            }

          case STARRED_FILTER:
            {
              listUpdated = allUpdated.filter(function (entry) {
                return entry.starred;
              });
              break;
            }
        }

        return _objectSpread({}, state, {
          alertMessage: action.payload.starred ? REMOVED_AS_STAR : MARKED_AS_STAR,
          showMessage: true,
          teamList: listUpdated,
          allTeam: allUpdated
        });
      }

    case _ActionTypes.FETCH_TEAM_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          selectedTeam: action.payload,
          addTeamState: false,
          editTeamState: false
        });
      }

    case _ActionTypes.FETCH_ALL_TEAM_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          allTeam: action.payload,
          teamList: action.payload,
          selectedSectionId: 1,
          searchEmp: '',
          filterOption: ALL_FILTER,
          addTeamState: false,
          editTeamState: false
        });
      }

    case _ActionTypes.SHOW_TEAM_MESSAGE:
      {
        return _objectSpread({}, state, {
          alertMessage: action.payload,
          showMessage: true,
          loader: false
        });
      }

    case _ActionTypes.ON_TEAM_SELECT:
      {
        action.payload.selected = !action.payload.selected;
        var selectedMembers = 0;
        var memberSelectionList = state.memberSelectionList.map(function (member) {
          if (member.selected) {
            selectedMembers++;
          }

          if (member.id === action.payload.id) {
            if (member.selected) {
              selectedMembers++;
            }

            return action.payload;
          } else {
            return member;
          }
        });
        return _objectSpread({}, state, {
          INIT_STATE: INIT_STATE,
          selectedMembers: selectedMembers,
          memberSelectionList: memberSelectionList
        });
      }

    case _ActionTypes.ON_ADD_TEAM:
      {
        return _objectSpread({}, state, {
          addTeamState: true,
          editTeamState: false
        });
      }

    case _ActionTypes.ON_EDIT_TEAM:
      {
        return _objectSpread({}, state, {
          selectedTeam: action.payload,
          editTeamState: true,
          addTeamState: false
        });
      }

    case _ActionTypes.ON_TEAM_CLOSE:
      {
        return _objectSpread({}, state, {
          addTeamState: false,
          editTeamState: false
        });
      }

    case _ActionTypes.ON_FILTER_TEAM_OPTION_SELECT:
      {
        var selectedSectionId = 0;
        var filterOption = '';
        var teamList = [];

        switch (action.payload.name) {
          case ALL_FILTER:
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              teamList = state.allTeam;
              break;
            }

          case STARRED_FILTER:
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              teamList = state.allTeam.filter(function (team) {
                return team.starred;
              });
              break;
            }
        }

        return _objectSpread({}, state, {
          selectedSectionId: selectedSectionId,
          filterOption: filterOption,
          teamList: teamList,
          drawerState: false
        });
      }

    case _ActionTypes.ON_SAVE_TEAM_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_UPDATE,
          showMessage: true,
          teamList: (0, _arrayService.addOrUpdateEntry)(state.teamList, action.payload),
          allTeam: (0, _arrayService.addOrUpdateEntry)(state.allTeam, action.payload),
          selectedTeam: action.payload,
          loader: false
        });
      }
    // called after a delete from the db operation to keep the current state up to date

    case _ActionTypes.ON_DELETE_TEAM_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_DELETE,
          showMessage: true,
          allTeam: state.allTeam.filter(function (team) {
            return team.id !== action.payload;
          }),
          teamList: state.allTeam.filter(function (team) {
            return team.id !== action.payload;
          }),
          selectedTeam: null
        });
      }

    case _ActionTypes.ON_FILTER_SELECTED_TEAM:
      {
        var _teams = state.allTeam.filter(function (team) {
          return !team.selected;
        });

        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_FILTER,
          showMessage: true,
          teamList: _teams,
          selectedTeams: 0
        });
      }

    case _ActionTypes.FILTER_TEAM:
      {
        var _filterOption = state.filterOption;
        var _teamList = [];

        if (action.payload === '') {
          _teamList = state.allTeam;
        } else {
          var filterTeam = state.allTeam.filter(function (team) {
            return team.name.toLowerCase().indexOf(action.payload.toLowerCase()) > -1;
          });

          if (_filterOption === ALL_FILTER) {
            _teamList = filterTeam;
          } else if (_filterOption === STARRED_FILTER) {
            _teamList = filterTeam.filter(function (team) {
              return team.starred;
            });
          }
        }

        return _objectSpread({}, state, {
          teamList: _teamList
        });
      }

    case _ActionTypes.GET_ALL_TEAM:
      {
        var _teamList2 = state.allTeam.map(function (team) {
          return team ? _objectSpread({}, team, {
            selected: true
          }) : team;
        });

        return _objectSpread({}, state, {
          selectedTeams: _teamList2.length,
          allTeam: _teamList2,
          teamList: _teamList2
        });
      }

    case _ActionTypes.GET_UNSELECTED_ALL_TEAM:
      {
        var _teamList3 = state.allTeam.map(function (team) {
          return team ? _objectSpread({}, team, {
            selected: false
          }) : team;
        });

        return _objectSpread({}, state, {
          selectedTeams: 0,
          allTeam: _teamList3,
          teamList: _teamList3
        });
      }

    case _ActionTypes.ON_ALL_TEAM_SELECT:
      {
        var selectAll = state.selectedTeams < state.teamList.length;
        var selectedTeams = 0;
        var _teamList4 = [];

        if (selectAll) {
          _teamList4 = state.allTeam.map(function (team) {
            return team ? _objectSpread({}, team, {
              selected: true
            }) : team;
          });
          selectedTeams = _teamList4.length;
        } else {
          _teamList4 = state.allTeam.map(function (team) {
            return team ? _objectSpread({}, team, {
              selected: true
            }) : team;
          });
          selectedTeams = 0;
        }

        return _objectSpread({}, state, {
          selectedTeams: selectedTeams,
          allTeam: _teamList4,
          teamList: _teamList4
        });
      }

    case _ActionTypes.UPDATE_SEARCH_TEAM:
      {
        return _objectSpread({}, state, {
          searchTeam: action.payload
        });
      }

    case _ActionTypes.HANDLE_TEAM_REQUEST_CLOSE:
      {
        return _objectSpread({}, state, {
          showMessage: false
        });
      }

    case _ActionTypes.ON_TOGGLE_TEAM_DRAWER:
      {
        return _objectSpread({}, state, {
          drawerState: !state.drawerState
        });
      }

    case _ActionTypes.SHOW_TEAM_LOADER:
      {
        return _objectSpread({}, state, {
          loader: true
        });
      }

    case _ActionTypes.HIDE_TEAM_LOADER:
      {
        return _objectSpread({}, state, {
          loader: false
        });
      }

    default:
      return state;
  }
};

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ALL_FILTER, "ALL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/team.js");

  __REACT_HOT_LOADER__.register(STARRED_FILTER, "STARRED_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/team.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_UPDATE, "SUCCESSFUL_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/team.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_FILTER, "SUCCESSFUL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/team.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_DELETE, "SUCCESSFUL_DELETE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/team.js");

  __REACT_HOT_LOADER__.register(REMOVED_AS_STAR, "REMOVED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/team.js");

  __REACT_HOT_LOADER__.register(MARKED_AS_STAR, "MARKED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/team.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/team.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/team.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/team.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/team.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/team.js");

  __REACT_HOT_LOADER__.register(ALL_FILTER, "ALL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/team.js");

  __REACT_HOT_LOADER__.register(STARRED_FILTER, "STARRED_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/team.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_UPDATE, "SUCCESSFUL_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/team.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_FILTER, "SUCCESSFUL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/team.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_DELETE, "SUCCESSFUL_DELETE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/team.js");

  __REACT_HOT_LOADER__.register(REMOVED_AS_STAR, "REMOVED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/team.js");

  __REACT_HOT_LOADER__.register(MARKED_AS_STAR, "MARKED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/team.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/team.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/team.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/team.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/team.js");
}();

;

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.INIT_STATE = exports.MARKED_AS_STAR = exports.REMOVED_AS_STAR = exports.SUCCESSFUL_DELETE = exports.SUCCESSFUL_FILTER = exports.SUCCESSFUL_UPDATE = exports.STARRED_FILTER = exports.ALL_FILTER = void 0;

var _ActionTypes = __webpack_require__(7);

var _arrayService = __webpack_require__(34);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ALL_FILTER = 'All products';
exports.ALL_FILTER = ALL_FILTER;
var STARRED_FILTER = 'Starred products';
exports.STARRED_FILTER = STARRED_FILTER;
var SUCCESSFUL_UPDATE = 'Product Updated Successfully';
exports.SUCCESSFUL_UPDATE = SUCCESSFUL_UPDATE;
var SUCCESSFUL_FILTER = 'Product Filtered Successfully';
exports.SUCCESSFUL_FILTER = SUCCESSFUL_FILTER;
var SUCCESSFUL_DELETE = 'Product Deleted Successfully';
exports.SUCCESSFUL_DELETE = SUCCESSFUL_DELETE;
var REMOVED_AS_STAR = 'Product removed as star';
exports.REMOVED_AS_STAR = REMOVED_AS_STAR;
var MARKED_AS_STAR = 'Product marked as star';
exports.MARKED_AS_STAR = MARKED_AS_STAR;
var INIT_STATE = {
  alertMessage: '',
  showMessage: false,
  loader: false,
  noContentFoundMessage: 'No products found in selected folder',
  selectedSectionId: 1,
  drawerState: false,
  filterOption: ALL_FILTER,
  allProduct: [],
  productList: [],
  selectedProduct: null,
  selectedProducts: 0,
  addProductState: false,
  editProductState: false,
  searchProduct: '',
  valueStreamSelectionList: [],
  selectedValueStreams: 0,
  product: {
    name: 'ACME Inc',
    email: 'road.runner@example.com',
    avatar: 'http://via.placeholder.com/150x150'
  }
};
exports.INIT_STATE = INIT_STATE;

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.CLEAR_SESSION:
      {
        return _objectSpread({}, INIT_STATE);
      }

    case _ActionTypes.CLEAR_SELECTED_OBJECTS:
      {
        return _objectSpread({}, state, {
          selectedProduct: null
        });
      }

    case _ActionTypes.ON_FETCH_SELECT_VALUESTREAM_DATA_SUCCESS:
      {
        return _objectSpread({}, state, {
          valueStreamSelectionList: action === null || action === void 0 ? void 0 : action.payload,
          loader: false
        });
      }

    case _ActionTypes.SET_PRODUCT:
      {
        var products = state.allProduct.filter(function (entry) {
          return (entry === null || entry === void 0 ? void 0 : entry.id) === (action === null || action === void 0 ? void 0 : action.payload);
        });
        return _objectSpread({}, state, {
          loader: false,
          selectedProduct: (products === null || products === void 0 ? void 0 : products.length) > 0 ? products[0] : []
        });
      }

    case _ActionTypes.ADD_FAVOURITE_PRODUCT_SUCCESS:
      {
        var allUpdated = state.allProduct.map(function (entry) {
          var _action$payload, _action$payload2;

          return (entry === null || entry === void 0 ? void 0 : entry.id) === (action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.id) ? _objectSpread({}, entry, {
            starred: !(action === null || action === void 0 ? void 0 : (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.starred)
          }) : entry;
        });
        var listUpdated = {};

        switch (state.filterOption) {
          case ALL_FILTER:
            {
              listUpdated = allUpdated;
              break;
            }

          case STARRED_FILTER:
            {
              listUpdated = allUpdated.filter(function (entry) {
                return entry.starred;
              });
              break;
            }
        }

        return _objectSpread({}, state, {
          alertMessage: action.payload.starred ? REMOVED_AS_STAR : MARKED_AS_STAR,
          showMessage: true,
          productList: listUpdated,
          allProduct: allUpdated
        });
      }

    case _ActionTypes.FETCH_PRODUCT_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          selectedProduct: action.payload,
          addProductState: false,
          editProductState: false
        });
      }

    case _ActionTypes.FETCH_ALL_PRODUCT_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          allProduct: action.payload,
          productList: action.payload,
          selectedSectionId: 1,
          searchEmp: '',
          filterOption: ALL_FILTER,
          addProductState: false,
          editProductState: false
        });
      }

    case _ActionTypes.SHOW_PRODUCT_MESSAGE:
      {
        return _objectSpread({}, state, {
          alertMessage: action.payload,
          showMessage: true,
          loader: false
        });
      }

    case _ActionTypes.ON_PRODUCT_SELECT:
      {
        action.payload.selected = !action.payload.selected;
        var selectedValueStreams = 0;
        var valueStreamSelectionList = state.valueStreamSelectionList.map(function (valueStream) {
          if (valueStream.selected) {
            selectedValueStreams++;
          }

          if (valueStream.id === action.payload.id) {
            if (valueStream.selected) {
              selectedValueStreams++;
            }

            return action.payload;
          } else {
            return valueStream;
          }
        });
        return _objectSpread({}, state, {
          INIT_STATE: INIT_STATE,
          selectedValueStreams: selectedValueStreams,
          valueStreamSelectionList: valueStreamSelectionList
        });
      }

    case _ActionTypes.ON_ADD_PRODUCT:
      {
        return _objectSpread({}, state, {
          addProductState: true,
          editProductState: false
        });
      }

    case _ActionTypes.ON_EDIT_PRODUCT:
      {
        return _objectSpread({}, state, {
          selectedProduct: action.payload,
          editProductState: true,
          addProductState: false
        });
      }

    case _ActionTypes.ON_PRODUCT_CLOSE:
      {
        return _objectSpread({}, state, {
          addProductState: false,
          editProductState: false
        });
      }

    case _ActionTypes.ON_FILTER_PRODUCT_OPTION_SELECT:
      {
        var selectedSectionId = 0;
        var filterOption = '';
        var productList = [];

        switch (action.payload.name) {
          case ALL_FILTER:
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              productList = state.allProduct;
              break;
            }

          case STARRED_FILTER:
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              productList = state.allProduct.filter(function (product) {
                return product.starred;
              });
              break;
            }
        }

        return _objectSpread({}, state, {
          selectedSectionId: selectedSectionId,
          filterOption: filterOption,
          productList: productList,
          drawerState: false
        });
      }

    case _ActionTypes.ON_SAVE_PRODUCT_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_UPDATE,
          showMessage: true,
          productList: (0, _arrayService.addOrUpdateEntry)(state.productList, action.payload),
          allProduct: (0, _arrayService.addOrUpdateEntry)(state.allProduct, action.payload),
          selectedProduct: action.payload,
          loader: false
        });
      }
    // called after a delete from the db operation to keep the current state up to date

    case _ActionTypes.ON_DELETE_PRODUCT_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_DELETE,
          showMessage: true,
          allProduct: state.allProduct.filter(function (product) {
            return product.id !== action.payload;
          }),
          productList: state.allProduct.filter(function (product) {
            return product.id !== action.payload;
          }),
          selectedProduct: null
        });
      }

    case _ActionTypes.ON_FILTER_SELECTED_PRODUCT:
      {
        var _products = state.allProduct.filter(function (product) {
          return !product.selected;
        });

        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_FILTER,
          showMessage: true,
          productList: _products,
          selectedProducts: 0
        });
      }

    case _ActionTypes.FILTER_PRODUCT:
      {
        var _filterOption = state.filterOption;
        var _productList = [];

        if (action.payload === '') {
          _productList = state.allProduct;
        } else {
          var filterProduct = state.allProduct.filter(function (product) {
            return product.name.toLowerCase().indexOf(action.payload.toLowerCase()) > -1;
          });

          if (_filterOption === ALL_FILTER) {
            _productList = filterProduct;
          } else if (_filterOption === STARRED_FILTER) {
            _productList = filterProduct.filter(function (product) {
              return product.starred;
            });
          }
        }

        return _objectSpread({}, state, {
          productList: _productList
        });
      }

    case _ActionTypes.GET_ALL_PRODUCT:
      {
        var _productList2 = state.allProduct.map(function (product) {
          return product ? _objectSpread({}, product, {
            selected: true
          }) : product;
        });

        return _objectSpread({}, state, {
          selectedProducts: _productList2.length,
          allProduct: _productList2,
          productList: _productList2
        });
      }

    case _ActionTypes.GET_UNSELECTED_ALL_PRODUCT:
      {
        var _productList3 = state.allProduct.map(function (product) {
          return product ? _objectSpread({}, product, {
            selected: false
          }) : product;
        });

        return _objectSpread({}, state, {
          selectedProducts: 0,
          allProduct: _productList3,
          productList: _productList3
        });
      }

    case _ActionTypes.ON_ALL_PRODUCT_SELECT:
      {
        var selectAll = state.selectedProducts < state.productList.length;
        var selectedProducts = 0;
        var _productList4 = [];

        if (selectAll) {
          _productList4 = state.allProduct.map(function (product) {
            return product ? _objectSpread({}, product, {
              selected: true
            }) : product;
          });
          selectedProducts = _productList4.length;
        } else {
          _productList4 = state.allProduct.map(function (product) {
            return product ? _objectSpread({}, product, {
              selected: true
            }) : product;
          });
          selectedProducts = 0;
        }

        return _objectSpread({}, state, {
          selectedProducts: selectedProducts,
          allProduct: _productList4,
          productList: _productList4
        });
      }

    case _ActionTypes.UPDATE_SEARCH_PRODUCT:
      {
        return _objectSpread({}, state, {
          searchProduct: action.payload
        });
      }

    case _ActionTypes.HANDLE_PRODUCT_REQUEST_CLOSE:
      {
        return _objectSpread({}, state, {
          showMessage: false
        });
      }

    case _ActionTypes.ON_TOGGLE_PRODUCT_DRAWER:
      {
        return _objectSpread({}, state, {
          drawerState: !state.drawerState
        });
      }

    case _ActionTypes.SHOW_PRODUCT_LOADER:
      {
        return _objectSpread({}, state, {
          loader: true
        });
      }

    case _ActionTypes.HIDE_PRODUCT_LOADER:
      {
        return _objectSpread({}, state, {
          loader: false
        });
      }

    default:
      return state;
  }
};

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ALL_FILTER, "ALL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/product.js");

  __REACT_HOT_LOADER__.register(STARRED_FILTER, "STARRED_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/product.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_UPDATE, "SUCCESSFUL_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/product.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_FILTER, "SUCCESSFUL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/product.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_DELETE, "SUCCESSFUL_DELETE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/product.js");

  __REACT_HOT_LOADER__.register(REMOVED_AS_STAR, "REMOVED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/product.js");

  __REACT_HOT_LOADER__.register(MARKED_AS_STAR, "MARKED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/product.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/product.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/product.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/product.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/product.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/product.js");

  __REACT_HOT_LOADER__.register(ALL_FILTER, "ALL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/product.js");

  __REACT_HOT_LOADER__.register(STARRED_FILTER, "STARRED_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/product.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_UPDATE, "SUCCESSFUL_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/product.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_FILTER, "SUCCESSFUL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/product.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_DELETE, "SUCCESSFUL_DELETE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/product.js");

  __REACT_HOT_LOADER__.register(REMOVED_AS_STAR, "REMOVED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/product.js");

  __REACT_HOT_LOADER__.register(MARKED_AS_STAR, "MARKED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/product.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/product.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/product.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/product.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/product.js");
}();

;

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.INIT_STATE = exports.MARKED_AS_STAR = exports.REMOVED_AS_STAR = exports.SUCCESSFUL_DELETE = exports.SUCCESSFUL_FILTER = exports.SUCCESSFUL_UPDATE = exports.STARRED_FILTER = exports.ALL_FILTER = void 0;

var _ActionTypes = __webpack_require__(7);

var _arrayService = __webpack_require__(34);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ALL_FILTER = 'All initiatives';
exports.ALL_FILTER = ALL_FILTER;
var STARRED_FILTER = 'Starred initiatives';
exports.STARRED_FILTER = STARRED_FILTER;
var SUCCESSFUL_UPDATE = 'Initiative Updated Successfully';
exports.SUCCESSFUL_UPDATE = SUCCESSFUL_UPDATE;
var SUCCESSFUL_FILTER = 'Initiative Filtered Successfully';
exports.SUCCESSFUL_FILTER = SUCCESSFUL_FILTER;
var SUCCESSFUL_DELETE = 'Initiative Deleted Successfully';
exports.SUCCESSFUL_DELETE = SUCCESSFUL_DELETE;
var REMOVED_AS_STAR = 'Initiative removed as star';
exports.REMOVED_AS_STAR = REMOVED_AS_STAR;
var MARKED_AS_STAR = 'Initiative marked as star';
exports.MARKED_AS_STAR = MARKED_AS_STAR;
var INIT_STATE = {
  alertMessage: '',
  showMessage: false,
  loader: false,
  noContentFoundMessage: 'No initiatives found in selected folder',
  selectedSectionId: 1,
  drawerState: false,
  filterOption: ALL_FILTER,
  allInitiative: [],
  initiativeList: [],
  selectedInitiative: null,
  selectedInitiatives: 0,
  addInitiativeState: false,
  editInitiativeState: false,
  searchInitiative: '',
  productSelectionList: [],
  selectedProducts: 0,
  initiative: {
    name: 'ACME Inc',
    email: 'road.runner@example.com',
    avatar: 'http://via.placeholder.com/150x150'
  }
};
exports.INIT_STATE = INIT_STATE;

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.CLEAR_SESSION:
      {
        return _objectSpread({}, INIT_STATE);
      }

    case _ActionTypes.CLEAR_SELECTED_OBJECTS:
      {
        return _objectSpread({}, state, {
          selectedInitiative: null
        });
      }

    case _ActionTypes.ON_FETCH_SELECT_PRODUCT_DATA_SUCCESS:
      {
        return _objectSpread({}, state, {
          productSelectionList: action === null || action === void 0 ? void 0 : action.payload,
          loader: false
        });
      }

    case _ActionTypes.SET_INITIATIVE:
      {
        var initiatives = state.allInitiative.filter(function (entry) {
          return (entry === null || entry === void 0 ? void 0 : entry.id) === (action === null || action === void 0 ? void 0 : action.payload);
        });
        return _objectSpread({}, state, {
          loader: false,
          selectedInitiative: (initiatives === null || initiatives === void 0 ? void 0 : initiatives.length) > 0 ? initiatives[0] : []
        });
      }

    case _ActionTypes.ADD_FAVOURITE_INITIATIVE_SUCCESS:
      {
        var allUpdated = state.allInitiative.map(function (entry) {
          var _action$payload, _action$payload2;

          return (entry === null || entry === void 0 ? void 0 : entry.id) === (action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.id) ? _objectSpread({}, entry, {
            starred: !(action === null || action === void 0 ? void 0 : (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.starred)
          }) : entry;
        });
        var listUpdated = {};

        switch (state.filterOption) {
          case ALL_FILTER:
            {
              listUpdated = allUpdated;
              break;
            }

          case STARRED_FILTER:
            {
              listUpdated = allUpdated.filter(function (entry) {
                return entry.starred;
              });
              break;
            }
        }

        return _objectSpread({}, state, {
          alertMessage: action.payload.starred ? REMOVED_AS_STAR : MARKED_AS_STAR,
          showMessage: true,
          initiativeList: listUpdated,
          allInitiative: allUpdated
        });
      }

    case _ActionTypes.FETCH_INITIATIVE_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          selectedInitiative: action.payload,
          addInitiativeState: false,
          editInitiativeState: false
        });
      }

    case _ActionTypes.FETCH_ALL_INITIATIVE_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          allInitiative: action.payload,
          initiativeList: action.payload,
          selectedSectionId: 1,
          searchEmp: '',
          filterOption: ALL_FILTER,
          addInitiativeState: false,
          editInitiativeState: false
        });
      }

    case _ActionTypes.SHOW_INITIATIVE_MESSAGE:
      {
        return _objectSpread({}, state, {
          alertMessage: action.payload,
          showMessage: true,
          loader: false
        });
      }

    case _ActionTypes.ON_INITIATIVE_SELECT:
      {
        action.payload.selected = !action.payload.selected;
        var selectedProducts = 0;
        var productSelectionList = state.productSelectionList.map(function (product) {
          if (product.selected) {
            selectedProducts++;
          }

          if (product.id === action.payload.id) {
            if (product.selected) {
              selectedProducts++;
            }

            return action.payload;
          } else {
            return product;
          }
        });
        return _objectSpread({}, state, {
          INIT_STATE: INIT_STATE,
          selectedProducts: selectedProducts,
          productSelectionList: productSelectionList
        });
      }

    case _ActionTypes.ON_ADD_INITIATIVE:
      {
        return _objectSpread({}, state, {
          addInitiativeState: true,
          editInitiativeState: false
        });
      }

    case _ActionTypes.ON_EDIT_INITIATIVE:
      {
        return _objectSpread({}, state, {
          selectedInitiative: action.payload,
          editInitiativeState: true,
          addInitiativeState: false
        });
      }

    case _ActionTypes.ON_INITIATIVE_CLOSE:
      {
        return _objectSpread({}, state, {
          addInitiativeState: false,
          editInitiativeState: false
        });
      }

    case _ActionTypes.ON_FILTER_INITIATIVE_OPTION_SELECT:
      {
        var selectedSectionId = 0;
        var filterOption = '';
        var initiativeList = [];

        switch (action.payload.name) {
          case ALL_FILTER:
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              initiativeList = state.allInitiative;
              break;
            }

          case STARRED_FILTER:
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              initiativeList = state.allInitiative.filter(function (initiative) {
                return initiative.starred;
              });
              break;
            }
        }

        return _objectSpread({}, state, {
          selectedSectionId: selectedSectionId,
          filterOption: filterOption,
          initiativeList: initiativeList,
          drawerState: false
        });
      }

    case _ActionTypes.ON_SAVE_INITIATIVE_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_UPDATE,
          showMessage: true,
          initiativeList: (0, _arrayService.addOrUpdateEntry)(state.initiativeList, action.payload),
          allInitiative: (0, _arrayService.addOrUpdateEntry)(state.allInitiative, action.payload),
          selectedInitiative: action.payload,
          loader: false
        });
      }
    // called after a delete from the db operation to keep the current state up to date

    case _ActionTypes.ON_DELETE_INITIATIVE_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_DELETE,
          showMessage: true,
          allInitiative: state.allInitiative.filter(function (initiative) {
            return initiative.id !== action.payload;
          }),
          initiativeList: state.allInitiative.filter(function (initiative) {
            return initiative.id !== action.payload;
          }),
          selectedInitiative: null
        });
      }

    case _ActionTypes.ON_FILTER_SELECTED_INITIATIVE:
      {
        var _initiatives = state.allInitiative.filter(function (initiative) {
          return !initiative.selected;
        });

        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_FILTER,
          showMessage: true,
          initiativeList: _initiatives,
          selectedInitiatives: 0
        });
      }

    case _ActionTypes.FILTER_INITIATIVE:
      {
        var _filterOption = state.filterOption;
        var _initiativeList = [];

        if (action.payload === '') {
          _initiativeList = state.allInitiative;
        } else {
          var filterInitiative = state.allInitiative.filter(function (initiative) {
            return initiative.name.toLowerCase().indexOf(action.payload.toLowerCase()) > -1;
          });

          if (_filterOption === ALL_FILTER) {
            _initiativeList = filterInitiative;
          } else if (_filterOption === STARRED_FILTER) {
            _initiativeList = filterInitiative.filter(function (initiative) {
              return initiative.starred;
            });
          }
        }

        return _objectSpread({}, state, {
          initiativeList: _initiativeList
        });
      }

    case _ActionTypes.GET_ALL_INITIATIVE:
      {
        var _initiativeList2 = state.allInitiative.map(function (initiative) {
          return initiative ? _objectSpread({}, initiative, {
            selected: true
          }) : initiative;
        });

        return _objectSpread({}, state, {
          selectedInitiatives: _initiativeList2.length,
          allInitiative: _initiativeList2,
          initiativeList: _initiativeList2
        });
      }

    case _ActionTypes.GET_UNSELECTED_ALL_INITIATIVE:
      {
        var _initiativeList3 = state.allInitiative.map(function (initiative) {
          return initiative ? _objectSpread({}, initiative, {
            selected: false
          }) : initiative;
        });

        return _objectSpread({}, state, {
          selectedInitiatives: 0,
          allInitiative: _initiativeList3,
          initiativeList: _initiativeList3
        });
      }

    case _ActionTypes.ON_ALL_INITIATIVE_SELECT:
      {
        var selectAll = state.selectedInitiatives < state.initiativeList.length;
        var selectedInitiatives = 0;
        var _initiativeList4 = [];

        if (selectAll) {
          _initiativeList4 = state.allInitiative.map(function (initiative) {
            return initiative ? _objectSpread({}, initiative, {
              selected: true
            }) : initiative;
          });
          selectedInitiatives = _initiativeList4.length;
        } else {
          _initiativeList4 = state.allInitiative.map(function (initiative) {
            return initiative ? _objectSpread({}, initiative, {
              selected: true
            }) : initiative;
          });
          selectedInitiatives = 0;
        }

        return _objectSpread({}, state, {
          selectedInitiatives: selectedInitiatives,
          allInitiative: _initiativeList4,
          initiativeList: _initiativeList4
        });
      }

    case _ActionTypes.UPDATE_SEARCH_INITIATIVE:
      {
        return _objectSpread({}, state, {
          searchInitiative: action.payload
        });
      }

    case _ActionTypes.HANDLE_INITIATIVE_REQUEST_CLOSE:
      {
        return _objectSpread({}, state, {
          showMessage: false
        });
      }

    case _ActionTypes.ON_TOGGLE_INITIATIVE_DRAWER:
      {
        return _objectSpread({}, state, {
          drawerState: !state.drawerState
        });
      }

    case _ActionTypes.SHOW_INITIATIVE_LOADER:
      {
        return _objectSpread({}, state, {
          loader: true
        });
      }

    case _ActionTypes.HIDE_INITIATIVE_LOADER:
      {
        return _objectSpread({}, state, {
          loader: false
        });
      }

    default:
      return state;
  }
};

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ALL_FILTER, "ALL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/initiative.js");

  __REACT_HOT_LOADER__.register(STARRED_FILTER, "STARRED_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/initiative.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_UPDATE, "SUCCESSFUL_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/initiative.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_FILTER, "SUCCESSFUL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/initiative.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_DELETE, "SUCCESSFUL_DELETE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/initiative.js");

  __REACT_HOT_LOADER__.register(REMOVED_AS_STAR, "REMOVED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/initiative.js");

  __REACT_HOT_LOADER__.register(MARKED_AS_STAR, "MARKED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/initiative.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/initiative.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/initiative.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/initiative.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/initiative.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/initiative.js");

  __REACT_HOT_LOADER__.register(ALL_FILTER, "ALL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/initiative.js");

  __REACT_HOT_LOADER__.register(STARRED_FILTER, "STARRED_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/initiative.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_UPDATE, "SUCCESSFUL_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/initiative.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_FILTER, "SUCCESSFUL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/initiative.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_DELETE, "SUCCESSFUL_DELETE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/initiative.js");

  __REACT_HOT_LOADER__.register(REMOVED_AS_STAR, "REMOVED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/initiative.js");

  __REACT_HOT_LOADER__.register(MARKED_AS_STAR, "MARKED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/initiative.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/initiative.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/initiative.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/initiative.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/initiative.js");
}();

;

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.INIT_STATE = exports.MARKED_AS_STAR = exports.REMOVED_AS_STAR = exports.SUCCESSFUL_DELETE = exports.SUCCESSFUL_FILTER = exports.SUCCESSFUL_UPDATE = exports.STARRED_FILTER = exports.ALL_FILTER = void 0;

var _ActionTypes = __webpack_require__(7);

var _arrayService = __webpack_require__(34);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ALL_FILTER = 'All issues';
exports.ALL_FILTER = ALL_FILTER;
var STARRED_FILTER = 'Starred issues';
exports.STARRED_FILTER = STARRED_FILTER;
var SUCCESSFUL_UPDATE = 'Issue Updated Successfully';
exports.SUCCESSFUL_UPDATE = SUCCESSFUL_UPDATE;
var SUCCESSFUL_FILTER = 'Issue Filtered Successfully';
exports.SUCCESSFUL_FILTER = SUCCESSFUL_FILTER;
var SUCCESSFUL_DELETE = 'Issue Deleted Successfully';
exports.SUCCESSFUL_DELETE = SUCCESSFUL_DELETE;
var REMOVED_AS_STAR = 'Issue removed as star';
exports.REMOVED_AS_STAR = REMOVED_AS_STAR;
var MARKED_AS_STAR = 'Issue marked as star';
exports.MARKED_AS_STAR = MARKED_AS_STAR;
var INIT_STATE = {
  alertMessage: '',
  showMessage: false,
  loader: false,
  noContentFoundMessage: 'No issues found in selected folder',
  selectedSectionId: 1,
  drawerState: false,
  filterOption: ALL_FILTER,
  allIssue: [],
  issueList: [],
  selectedIssue: null,
  selectedIssues: 0,
  addIssueState: false,
  editIssueState: false,
  searchIssue: '',
  featureSelectionList: [],
  selectedFeatures: 0,
  issue: {
    name: 'ACME Inc',
    email: 'road.runner@example.com',
    avatar: 'http://via.placeholder.com/150x150'
  }
};
exports.INIT_STATE = INIT_STATE;

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.CLEAR_SESSION:
      {
        return _objectSpread({}, INIT_STATE);
      }

    case _ActionTypes.CLEAR_SELECTED_OBJECTS:
      {
        return _objectSpread({}, state, {
          selectedIssue: null
        });
      }

    case _ActionTypes.ON_FETCH_SELECT_FEATURE_DATA_SUCCESS:
      {
        return _objectSpread({}, state, {
          featureSelectionList: action === null || action === void 0 ? void 0 : action.payload,
          loader: false
        });
      }

    case _ActionTypes.SET_ISSUE:
      {
        var issues = state.allIssue.filter(function (entry) {
          return (entry === null || entry === void 0 ? void 0 : entry.id) === (action === null || action === void 0 ? void 0 : action.payload);
        });
        return _objectSpread({}, state, {
          loader: false,
          selectedIssue: (issues === null || issues === void 0 ? void 0 : issues.length) > 0 ? issues[0] : []
        });
      }

    case _ActionTypes.ADD_FAVOURITE_ISSUE_SUCCESS:
      {
        var allUpdated = state.allIssue.map(function (entry) {
          var _action$payload, _action$payload2;

          return (entry === null || entry === void 0 ? void 0 : entry.id) === (action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.id) ? _objectSpread({}, entry, {
            starred: !(action === null || action === void 0 ? void 0 : (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.starred)
          }) : entry;
        });
        var listUpdated = {};

        switch (state.filterOption) {
          case ALL_FILTER:
            {
              listUpdated = allUpdated;
              break;
            }

          case STARRED_FILTER:
            {
              listUpdated = allUpdated.filter(function (entry) {
                return entry.starred;
              });
              break;
            }
        }

        return _objectSpread({}, state, {
          alertMessage: action.payload.starred ? REMOVED_AS_STAR : MARKED_AS_STAR,
          showMessage: true,
          issueList: listUpdated,
          allIssue: allUpdated
        });
      }

    case _ActionTypes.FETCH_ISSUE_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          selectedIssue: action.payload,
          addIssueState: false,
          editIssueState: false
        });
      }

    case _ActionTypes.FETCH_ALL_ISSUE_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          allIssue: action.payload,
          issueList: action.payload,
          selectedSectionId: 1,
          searchEmp: '',
          filterOption: ALL_FILTER,
          addIssueState: false,
          editIssueState: false
        });
      }

    case _ActionTypes.SHOW_ISSUE_MESSAGE:
      {
        return _objectSpread({}, state, {
          alertMessage: action.payload,
          showMessage: true,
          loader: false
        });
      }

    case _ActionTypes.ON_ISSUE_SELECT:
      {
        action.payload.selected = !action.payload.selected;
        var selectedFeatures = 0;
        var featureSelectionList = state.featureSelectionList.map(function (feature) {
          if (feature.selected) {
            selectedFeatures++;
          }

          if (feature.id === action.payload.id) {
            if (feature.selected) {
              selectedFeatures++;
            }

            return action.payload;
          } else {
            return feature;
          }
        });
        return _objectSpread({}, state, {
          INIT_STATE: INIT_STATE,
          selectedFeatures: selectedFeatures,
          featureSelectionList: featureSelectionList
        });
      }

    case _ActionTypes.ON_ADD_ISSUE:
      {
        return _objectSpread({}, state, {
          addIssueState: true,
          editIssueState: false
        });
      }

    case _ActionTypes.ON_EDIT_ISSUE:
      {
        return _objectSpread({}, state, {
          selectedIssue: action.payload,
          editIssueState: true,
          addIssueState: false
        });
      }

    case _ActionTypes.ON_ISSUE_CLOSE:
      {
        return _objectSpread({}, state, {
          addIssueState: false,
          editIssueState: false
        });
      }

    case _ActionTypes.ON_FILTER_ISSUE_OPTION_SELECT:
      {
        var selectedSectionId = 0;
        var filterOption = '';
        var issueList = [];

        switch (action.payload.name) {
          case ALL_FILTER:
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              issueList = state.allIssue;
              break;
            }

          case STARRED_FILTER:
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              issueList = state.allIssue.filter(function (issue) {
                return issue.starred;
              });
              break;
            }
        }

        return _objectSpread({}, state, {
          selectedSectionId: selectedSectionId,
          filterOption: filterOption,
          issueList: issueList,
          drawerState: false
        });
      }

    case _ActionTypes.ON_SAVE_ISSUE_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_UPDATE,
          showMessage: true,
          issueList: (0, _arrayService.addOrUpdateEntry)(state.issueList, action.payload),
          allIssue: (0, _arrayService.addOrUpdateEntry)(state.allIssue, action.payload),
          selectedIssue: action.payload,
          loader: false
        });
      }
    // called after a delete from the db operation to keep the current state up to date

    case _ActionTypes.ON_DELETE_ISSUE_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_DELETE,
          showMessage: true,
          allIssue: state.allIssue.filter(function (issue) {
            return issue.id !== action.payload;
          }),
          issueList: state.allIssue.filter(function (issue) {
            return issue.id !== action.payload;
          }),
          selectedIssue: null
        });
      }

    case _ActionTypes.ON_FILTER_SELECTED_ISSUE:
      {
        var _issues = state.allIssue.filter(function (issue) {
          return !issue.selected;
        });

        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_FILTER,
          showMessage: true,
          issueList: _issues,
          selectedIssues: 0
        });
      }

    case _ActionTypes.FILTER_ISSUE:
      {
        var _filterOption = state.filterOption;
        var _issueList = [];

        if (action.payload === '') {
          _issueList = state.allIssue;
        } else {
          var filterIssue = state.allIssue.filter(function (issue) {
            return issue.name.toLowerCase().indexOf(action.payload.toLowerCase()) > -1;
          });

          if (_filterOption === ALL_FILTER) {
            _issueList = filterIssue;
          } else if (_filterOption === STARRED_FILTER) {
            _issueList = filterIssue.filter(function (issue) {
              return issue.starred;
            });
          }
        }

        return _objectSpread({}, state, {
          issueList: _issueList
        });
      }

    case _ActionTypes.GET_ALL_ISSUE:
      {
        var _issueList2 = state.allIssue.map(function (issue) {
          return issue ? _objectSpread({}, issue, {
            selected: true
          }) : issue;
        });

        return _objectSpread({}, state, {
          selectedIssues: _issueList2.length,
          allIssue: _issueList2,
          issueList: _issueList2
        });
      }

    case _ActionTypes.GET_UNSELECTED_ALL_ISSUE:
      {
        var _issueList3 = state.allIssue.map(function (issue) {
          return issue ? _objectSpread({}, issue, {
            selected: false
          }) : issue;
        });

        return _objectSpread({}, state, {
          selectedIssues: 0,
          allIssue: _issueList3,
          issueList: _issueList3
        });
      }

    case _ActionTypes.ON_ALL_ISSUE_SELECT:
      {
        var selectAll = state.selectedIssues < state.issueList.length;
        var selectedIssues = 0;
        var _issueList4 = [];

        if (selectAll) {
          _issueList4 = state.allIssue.map(function (issue) {
            return issue ? _objectSpread({}, issue, {
              selected: true
            }) : issue;
          });
          selectedIssues = _issueList4.length;
        } else {
          _issueList4 = state.allIssue.map(function (issue) {
            return issue ? _objectSpread({}, issue, {
              selected: true
            }) : issue;
          });
          selectedIssues = 0;
        }

        return _objectSpread({}, state, {
          selectedIssues: selectedIssues,
          allIssue: _issueList4,
          issueList: _issueList4
        });
      }

    case _ActionTypes.UPDATE_SEARCH_ISSUE:
      {
        return _objectSpread({}, state, {
          searchIssue: action.payload
        });
      }

    case _ActionTypes.HANDLE_ISSUE_REQUEST_CLOSE:
      {
        return _objectSpread({}, state, {
          showMessage: false
        });
      }

    case _ActionTypes.ON_TOGGLE_ISSUE_DRAWER:
      {
        return _objectSpread({}, state, {
          drawerState: !state.drawerState
        });
      }

    case _ActionTypes.SHOW_ISSUE_LOADER:
      {
        return _objectSpread({}, state, {
          loader: true
        });
      }

    case _ActionTypes.HIDE_ISSUE_LOADER:
      {
        return _objectSpread({}, state, {
          loader: false
        });
      }

    default:
      return state;
  }
};

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ALL_FILTER, "ALL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/issue.js");

  __REACT_HOT_LOADER__.register(STARRED_FILTER, "STARRED_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/issue.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_UPDATE, "SUCCESSFUL_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/issue.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_FILTER, "SUCCESSFUL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/issue.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_DELETE, "SUCCESSFUL_DELETE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/issue.js");

  __REACT_HOT_LOADER__.register(REMOVED_AS_STAR, "REMOVED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/issue.js");

  __REACT_HOT_LOADER__.register(MARKED_AS_STAR, "MARKED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/issue.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/issue.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/issue.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/issue.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/issue.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/issue.js");

  __REACT_HOT_LOADER__.register(ALL_FILTER, "ALL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/issue.js");

  __REACT_HOT_LOADER__.register(STARRED_FILTER, "STARRED_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/issue.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_UPDATE, "SUCCESSFUL_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/issue.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_FILTER, "SUCCESSFUL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/issue.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_DELETE, "SUCCESSFUL_DELETE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/issue.js");

  __REACT_HOT_LOADER__.register(REMOVED_AS_STAR, "REMOVED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/issue.js");

  __REACT_HOT_LOADER__.register(MARKED_AS_STAR, "MARKED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/issue.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/issue.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/issue.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/issue.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/issue.js");
}();

;

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.INIT_STATE = exports.MARKED_AS_STAR = exports.REMOVED_AS_STAR = exports.SUCCESSFUL_DELETE = exports.SUCCESSFUL_FILTER = exports.SUCCESSFUL_UPDATE = exports.STARRED_FILTER = exports.ALL_FILTER = void 0;

var _ActionTypes = __webpack_require__(7);

var _arrayService = __webpack_require__(34);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ALL_FILTER = 'All Priorities';
exports.ALL_FILTER = ALL_FILTER;
var STARRED_FILTER = 'Starred priorities';
exports.STARRED_FILTER = STARRED_FILTER;
var SUCCESSFUL_UPDATE = 'Priorities Updated Successfully';
exports.SUCCESSFUL_UPDATE = SUCCESSFUL_UPDATE;
var SUCCESSFUL_FILTER = 'Priorities Filtered Successfully';
exports.SUCCESSFUL_FILTER = SUCCESSFUL_FILTER;
var SUCCESSFUL_DELETE = 'Priorities Deleted Successfully';
exports.SUCCESSFUL_DELETE = SUCCESSFUL_DELETE;
var REMOVED_AS_STAR = 'Priorities removed as star';
exports.REMOVED_AS_STAR = REMOVED_AS_STAR;
var MARKED_AS_STAR = 'Priorities marked as star';
exports.MARKED_AS_STAR = MARKED_AS_STAR;
var INIT_STATE = {
  alertMessage: '',
  showMessage: false,
  loader: false,
  noContentFoundMessage: 'No priorities found in selected folder',
  selectedSectionId: 1,
  drawerState: false,
  filterOption: ALL_FILTER,
  allProjectBusPriority: [],
  projectBusPriorityList: [],
  selectedProjectBusPriority: null,
  selectedProjectBusPrioritys: 0,
  addProjectBusPriorityState: false,
  editProjectBusPriorityState: false,
  searchProjectBusPriority: '',
  projectBusPriority: {
    name: 'ACME Inc',
    email: 'road.runner@example.com',
    avatar: 'http://via.placeholder.com/150x150'
  }
};
exports.INIT_STATE = INIT_STATE;

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.CLEAR_SESSION:
      {
        return _objectSpread({}, INIT_STATE);
      }

    case _ActionTypes.CLEAR_SELECTED_OBJECTS:
      {
        return _objectSpread({}, state, {
          selectedProjectBusPriority: null
        });
      }

    case _ActionTypes.ADD_FAVOURITE_PROJECT_BUS_PRIORITY_SUCCESS:
      {
        var allUpdated = state.allProjectBusPriority.map(function (entry) {
          var _action$payload, _action$payload2;

          return (entry === null || entry === void 0 ? void 0 : entry.id) === (action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.id) ? _objectSpread({}, entry, {
            starred: !(action === null || action === void 0 ? void 0 : (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.starred)
          }) : entry;
        });
        var listUpdated = {};

        switch (state.filterOption) {
          case ALL_FILTER:
            {
              listUpdated = allUpdated;
              break;
            }

          case STARRED_FILTER:
            {
              listUpdated = allUpdated.filter(function (entry) {
                return entry.starred;
              });
              break;
            }
        }

        return _objectSpread({}, state, {
          alertMessage: action.payload.starred ? REMOVED_AS_STAR : MARKED_AS_STAR,
          showMessage: true,
          projectBusPriorityList: listUpdated,
          allProjectBusPriority: allUpdated
        });
      }

    case _ActionTypes.FETCH_PROJECT_BUS_PRIORITY_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          selectedProjectBusPriority: action.payload,
          addProjectBusPriorityState: false,
          editProjectBusPriorityState: false
        });
      }

    case _ActionTypes.FETCH_ALL_PROJECT_BUS_PRIORITY_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          allProjectBusPriority: action.payload,
          projectBusPriorityList: action.payload,
          selectedSectionId: 1,
          searchEmp: '',
          filterOption: ALL_FILTER,
          addProjectBusPriorityState: false,
          editProjectBusPriorityState: false
        });
      }

    case _ActionTypes.SHOW_PROJECT_BUS_PRIORITY_MESSAGE:
      {
        return _objectSpread({}, state, {
          alertMessage: action.payload,
          showMessage: true,
          loader: false
        });
      }

    case _ActionTypes.ON_PROJECT_BUS_PRIORITY_SELECT:
      {
        action.payload.selected = !action.payload.selected;
        var selectedProjectBusPrioritys = 0;
        var projectBusPriorityList = state.projectBusPriorityList.map(function (projectBusPriority) {
          if (projectBusPriority.selected) {
            selectedProjectBusPrioritys++;
          }

          if (projectBusPriority.id === action.payload.id) {
            if (projectBusPriority.selected) {
              selectedProjectBusPrioritys++;
            }

            return action.payload;
          } else {
            return projectBusPriority;
          }
        });
        return _objectSpread({}, state, {
          INIT_STATE: INIT_STATE,
          selectedProjectBusPrioritys: selectedProjectBusPrioritys,
          projectBusPriorityList: projectBusPriorityList
        });
      }

    case _ActionTypes.ON_ADD_PROJECT_BUS_PRIORITY:
      {
        return _objectSpread({}, state, {
          addProjectBusPriorityState: true,
          editProjectBusPriorityState: false
        });
      }

    case _ActionTypes.ON_EDIT_PROJECT_BUS_PRIORITY:
      {
        return _objectSpread({}, state, {
          selectedProjectBusPriority: action.payload,
          editProjectBusPriorityState: true,
          addProjectBusPriorityState: false
        });
      }

    case _ActionTypes.ON_PROJECT_BUS_PRIORITY_CLOSE:
      {
        return _objectSpread({}, state, {
          addProjectBusPriorityState: false,
          editProjectBusPriorityState: false
        });
      }

    case _ActionTypes.ON_FILTER_PROJECT_BUS_PRIORITY_OPTION_SELECT:
      {
        var selectedSectionId = 0;
        var filterOption = '';
        var _projectBusPriorityList = [];

        switch (action.payload.name) {
          case ALL_FILTER:
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              _projectBusPriorityList = state.allProjectBusPriority;
              break;
            }

          case STARRED_FILTER:
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              _projectBusPriorityList = state.allProjectBusPriority.filter(function (projectBusPriority) {
                return projectBusPriority.starred;
              });
              break;
            }
        }

        return _objectSpread({}, state, {
          selectedSectionId: selectedSectionId,
          filterOption: filterOption,
          projectBusPriorityList: _projectBusPriorityList,
          drawerState: false
        });
      }

    case _ActionTypes.ON_SAVE_PROJECT_BUS_PRIORITY_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_UPDATE,
          showMessage: true,
          projectBusPriorityList: (0, _arrayService.addOrUpdateEntry)(state.projectBusPriorityList, action.payload),
          allProjectBusPriority: (0, _arrayService.addOrUpdateEntry)(state.allProjectBusPriority, action.payload),
          loader: false
        });
      }
    // called after a delete from the db operation to keep the current state up to date

    case _ActionTypes.ON_DELETE_PROJECT_BUS_PRIORITY_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_DELETE,
          showMessage: true,
          allProjectBusPriority: state.allProjectBusPriority.filter(function (projectBusPriority) {
            return projectBusPriority.id !== action.payload;
          }),
          projectBusPriorityList: state.allProjectBusPriority.filter(function (projectBusPriority) {
            return projectBusPriority.id !== action.payload;
          })
        });
      }

    case _ActionTypes.ON_FILTER_SELECTED_PROJECT_BUS_PRIORITY:
      {
        var projectBusPrioritys = state.allProjectBusPriority.filter(function (projectBusPriority) {
          return !projectBusPriority.selected;
        });
        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_FILTER,
          showMessage: true,
          projectBusPriorityList: projectBusPrioritys,
          selectedProjectBusPrioritys: 0
        });
      }

    case _ActionTypes.FILTER_PROJECT_BUS_PRIORITY:
      {
        var _filterOption = state.filterOption;
        var _projectBusPriorityList2 = [];

        if (action.payload === '') {
          _projectBusPriorityList2 = state.allProjectBusPriority;
        } else {
          var filterProjectBusPriority = state.allProjectBusPriority.filter(function (projectBusPriority) {
            return projectBusPriority.name.toLowerCase().indexOf(action.payload.toLowerCase()) > -1;
          });

          if (_filterOption === ALL_FILTER) {
            _projectBusPriorityList2 = filterProjectBusPriority;
          } else if (_filterOption === STARRED_FILTER) {
            _projectBusPriorityList2 = filterProjectBusPriority.filter(function (projectBusPriority) {
              return projectBusPriority.starred;
            });
          }
        }

        return _objectSpread({}, state, {
          projectBusPriorityList: _projectBusPriorityList2
        });
      }

    case _ActionTypes.GET_ALL_PROJECT_BUS_PRIORITY:
      {
        var _projectBusPriorityList3 = state.allProjectBusPriority.map(function (projectBusPriority) {
          return projectBusPriority ? _objectSpread({}, projectBusPriority, {
            selected: true
          }) : projectBusPriority;
        });

        return _objectSpread({}, state, {
          selectedProjectBusPrioritys: _projectBusPriorityList3.length,
          allProjectBusPriority: _projectBusPriorityList3,
          projectBusPriorityList: _projectBusPriorityList3
        });
      }

    case _ActionTypes.GET_UNSELECTED_ALL_PROJECT_BUS_PRIORITY:
      {
        var _projectBusPriorityList4 = state.allProjectBusPriority.map(function (projectBusPriority) {
          return projectBusPriority ? _objectSpread({}, projectBusPriority, {
            selected: false
          }) : projectBusPriority;
        });

        return _objectSpread({}, state, {
          selectedProjectBusPrioritys: 0,
          allProjectBusPriority: _projectBusPriorityList4,
          projectBusPriorityList: _projectBusPriorityList4
        });
      }

    case _ActionTypes.ON_ALL_PROJECT_BUS_PRIORITY_SELECT:
      {
        var selectAll = state.selectedProjectBusPrioritys < state.projectBusPriorityList.length;
        var _selectedProjectBusPrioritys = 0;
        var _projectBusPriorityList5 = [];

        if (selectAll) {
          _projectBusPriorityList5 = state.allProjectBusPriority.map(function (projectBusPriority) {
            return projectBusPriority ? _objectSpread({}, projectBusPriority, {
              selected: true
            }) : projectBusPriority;
          });
          _selectedProjectBusPrioritys = _projectBusPriorityList5.length;
        } else {
          _projectBusPriorityList5 = state.allProjectBusPriority.map(function (projectBusPriority) {
            return projectBusPriority ? _objectSpread({}, projectBusPriority, {
              selected: true
            }) : projectBusPriority;
          });
          _selectedProjectBusPrioritys = 0;
        }

        return _objectSpread({}, state, {
          selectedProjectBusPrioritys: _selectedProjectBusPrioritys,
          allProjectBusPriority: _projectBusPriorityList5,
          projectBusPriorityList: _projectBusPriorityList5
        });
      }

    case _ActionTypes.UPDATE_SEARCH_PROJECT_BUS_PRIORITY:
      {
        return _objectSpread({}, state, {
          searchProjectBusPriority: action.payload
        });
      }

    case _ActionTypes.HANDLE_PROJECT_BUS_PRIORITY_REQUEST_CLOSE:
      {
        return _objectSpread({}, state, {
          showMessage: false
        });
      }

    case _ActionTypes.ON_TOGGLE_PROJECT_BUS_PRIORITY_DRAWER:
      {
        return _objectSpread({}, state, {
          drawerState: !state.drawerState
        });
      }

    case _ActionTypes.SHOW_PROJECT_BUS_PRIORITY_LOADER:
      {
        return _objectSpread({}, state, {
          loader: true
        });
      }

    case _ActionTypes.HIDE_PROJECT_BUS_PRIORITY_LOADER:
      {
        return _objectSpread({}, state, {
          loader: false
        });
      }

    default:
      return state;
  }
};

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ALL_FILTER, "ALL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(STARRED_FILTER, "STARRED_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_UPDATE, "SUCCESSFUL_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_FILTER, "SUCCESSFUL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_DELETE, "SUCCESSFUL_DELETE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(REMOVED_AS_STAR, "REMOVED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(MARKED_AS_STAR, "MARKED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectBusPriority.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(ALL_FILTER, "ALL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(STARRED_FILTER, "STARRED_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_UPDATE, "SUCCESSFUL_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_FILTER, "SUCCESSFUL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_DELETE, "SUCCESSFUL_DELETE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(REMOVED_AS_STAR, "REMOVED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(MARKED_AS_STAR, "MARKED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectBusPriority.js");
}();

;

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.INIT_STATE = exports.MARKED_AS_STAR = exports.REMOVED_AS_STAR = exports.SUCCESSFUL_DELETE = exports.SUCCESSFUL_FILTER = exports.SUCCESSFUL_UPDATE = exports.STARRED_FILTER = exports.ALL_FILTER = void 0;

var _ActionTypes = __webpack_require__(7);

var _arrayService = __webpack_require__(34);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ALL_FILTER = 'All priorities';
exports.ALL_FILTER = ALL_FILTER;
var STARRED_FILTER = 'Starred priorities';
exports.STARRED_FILTER = STARRED_FILTER;
var SUCCESSFUL_UPDATE = 'Priorities Updated Successfully';
exports.SUCCESSFUL_UPDATE = SUCCESSFUL_UPDATE;
var SUCCESSFUL_FILTER = 'Priorities Filtered Successfully';
exports.SUCCESSFUL_FILTER = SUCCESSFUL_FILTER;
var SUCCESSFUL_DELETE = 'Priorities Deleted Successfully';
exports.SUCCESSFUL_DELETE = SUCCESSFUL_DELETE;
var REMOVED_AS_STAR = 'Priorities removed as star';
exports.REMOVED_AS_STAR = REMOVED_AS_STAR;
var MARKED_AS_STAR = 'Priorities marked as star';
exports.MARKED_AS_STAR = MARKED_AS_STAR;
var INIT_STATE = {
  alertMessage: '',
  showMessage: false,
  loader: false,
  noContentFoundMessage: 'No priorities found in selected folder',
  selectedSectionId: 1,
  drawerState: false,
  filterOption: ALL_FILTER,
  allProjectCostPriority: [],
  projectCostPriorityList: [],
  selectedProjectCostPriority: null,
  selectedProjectCostPrioritys: 0,
  addProjectCostPriorityState: false,
  editProjectCostPriorityState: false,
  searchProjectCostPriority: '',
  projectCostPriority: {
    name: 'ACME Inc',
    email: 'road.runner@example.com',
    avatar: 'http://via.placeholder.com/150x150'
  }
};
exports.INIT_STATE = INIT_STATE;

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.CLEAR_SESSION:
      {
        return _objectSpread({}, INIT_STATE);
      }

    case _ActionTypes.CLEAR_SELECTED_OBJECTS:
      {
        return _objectSpread({}, state, {
          selectedProjectCostPriority: null
        });
      }

    case _ActionTypes.ADD_FAVOURITE_PROJECT_COST_PRIORITY_SUCCESS:
      {
        var allUpdated = state.allProjectCostPriority.map(function (entry) {
          var _action$payload, _action$payload2;

          return (entry === null || entry === void 0 ? void 0 : entry.id) === (action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.id) ? _objectSpread({}, entry, {
            starred: !(action === null || action === void 0 ? void 0 : (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.starred)
          }) : entry;
        });
        var listUpdated = {};

        switch (state.filterOption) {
          case ALL_FILTER:
            {
              listUpdated = allUpdated;
              break;
            }

          case STARRED_FILTER:
            {
              listUpdated = allUpdated.filter(function (entry) {
                return entry.starred;
              });
              break;
            }
        }

        return _objectSpread({}, state, {
          alertMessage: action.payload.starred ? REMOVED_AS_STAR : MARKED_AS_STAR,
          showMessage: true,
          projectCostPriorityList: listUpdated,
          allProjectCostPriority: allUpdated
        });
      }

    case _ActionTypes.FETCH_PROJECT_COST_PRIORITY_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          selectedProjectCostPriority: action.payload,
          addProjectCostPriorityState: false,
          editProjectCostPriorityState: false
        });
      }

    case _ActionTypes.FETCH_ALL_PROJECT_COST_PRIORITY_SUCCESS:
      {
        return _objectSpread({}, state, {
          loader: false,
          allProjectCostPriority: action.payload,
          projectCostPriorityList: action.payload,
          selectedSectionId: 1,
          searchEmp: '',
          filterOption: ALL_FILTER,
          addProjectCostPriorityState: false,
          editProjectCostPriorityState: false
        });
      }

    case _ActionTypes.SHOW_PROJECT_COST_PRIORITY_MESSAGE:
      {
        return _objectSpread({}, state, {
          alertMessage: action.payload,
          showMessage: true,
          loader: false
        });
      }

    case _ActionTypes.ON_PROJECT_COST_PRIORITY_SELECT:
      {
        action.payload.selected = !action.payload.selected;
        var selectedProjectCostPrioritys = 0;
        var projectCostPriorityList = state.projectCostPriorityList.map(function (projectCostPriority) {
          if (projectCostPriority.selected) {
            selectedProjectCostPrioritys++;
          }

          if (projectCostPriority.id === action.payload.id) {
            if (projectCostPriority.selected) {
              selectedProjectCostPrioritys++;
            }

            return action.payload;
          } else {
            return projectCostPriority;
          }
        });
        return _objectSpread({}, state, {
          INIT_STATE: INIT_STATE,
          selectedProjectCostPrioritys: selectedProjectCostPrioritys,
          projectCostPriorityList: projectCostPriorityList
        });
      }

    case _ActionTypes.ON_ADD_PROJECT_COST_PRIORITY:
      {
        return _objectSpread({}, state, {
          addProjectCostPriorityState: true,
          editProjectCostPriorityState: false
        });
      }

    case _ActionTypes.ON_EDIT_PROJECT_COST_PRIORITY:
      {
        return _objectSpread({}, state, {
          selectedProjectCostPriority: action.payload,
          editProjectCostPriorityState: true,
          addProjectCostPriorityState: false
        });
      }

    case _ActionTypes.ON_PROJECT_COST_PRIORITY_CLOSE:
      {
        return _objectSpread({}, state, {
          addProjectCostPriorityState: false,
          editProjectCostPriorityState: false
        });
      }

    case _ActionTypes.ON_FILTER_PROJECT_COST_PRIORITY_OPTION_SELECT:
      {
        var selectedSectionId = 0;
        var filterOption = '';
        var _projectCostPriorityList = [];

        switch (action.payload.name) {
          case ALL_FILTER:
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              _projectCostPriorityList = state.allProjectCostPriority;
              break;
            }

          case STARRED_FILTER:
            {
              selectedSectionId = action.payload.id;
              filterOption = action.payload.name;
              _projectCostPriorityList = state.allProjectCostPriority.filter(function (projectCostPriority) {
                return projectCostPriority.starred;
              });
              break;
            }
        }

        return _objectSpread({}, state, {
          selectedSectionId: selectedSectionId,
          filterOption: filterOption,
          projectCostPriorityList: _projectCostPriorityList,
          drawerState: false
        });
      }

    case _ActionTypes.ON_SAVE_PROJECT_COST_PRIORITY_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_UPDATE,
          showMessage: true,
          projectCostPriorityList: (0, _arrayService.addOrUpdateEntry)(state.projectCostPriorityList, action.payload),
          allProjectCostPriority: (0, _arrayService.addOrUpdateEntry)(state.allProjectCostPriority, action.payload),
          loader: false
        });
      }
    // called after a delete from the db operation to keep the current state up to date

    case _ActionTypes.ON_DELETE_PROJECT_COST_PRIORITY_SUCCESS:
      {
        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_DELETE,
          showMessage: true,
          allProjectCostPriority: state.allProjectCostPriority.filter(function (projectCostPriority) {
            return projectCostPriority.id !== action.payload;
          }),
          projectCostPriorityList: state.allProjectCostPriority.filter(function (projectCostPriority) {
            return projectCostPriority.id !== action.payload;
          })
        });
      }

    case _ActionTypes.ON_FILTER_SELECTED_PROJECT_COST_PRIORITY:
      {
        var projectCostPrioritys = state.allProjectCostPriority.filter(function (projectCostPriority) {
          return !projectCostPriority.selected;
        });
        return _objectSpread({}, state, {
          alertMessage: SUCCESSFUL_FILTER,
          showMessage: true,
          projectCostPriorityList: projectCostPrioritys,
          selectedProjectCostPrioritys: 0
        });
      }

    case _ActionTypes.FILTER_PROJECT_COST_PRIORITY:
      {
        var _filterOption = state.filterOption;
        var _projectCostPriorityList2 = [];

        if (action.payload === '') {
          _projectCostPriorityList2 = state.allProjectCostPriority;
        } else {
          var filterProjectCostPriority = state.allProjectCostPriority.filter(function (projectCostPriority) {
            return projectCostPriority.name.toLowerCase().indexOf(action.payload.toLowerCase()) > -1;
          });

          if (_filterOption === ALL_FILTER) {
            _projectCostPriorityList2 = filterProjectCostPriority;
          } else if (_filterOption === STARRED_FILTER) {
            _projectCostPriorityList2 = filterProjectCostPriority.filter(function (projectCostPriority) {
              return projectCostPriority.starred;
            });
          }
        }

        return _objectSpread({}, state, {
          projectCostPriorityList: _projectCostPriorityList2
        });
      }

    case _ActionTypes.GET_ALL_PROJECT_COST_PRIORITY:
      {
        var _projectCostPriorityList3 = state.allProjectCostPriority.map(function (projectCostPriority) {
          return projectCostPriority ? _objectSpread({}, projectCostPriority, {
            selected: true
          }) : projectCostPriority;
        });

        return _objectSpread({}, state, {
          selectedProjectCostPrioritys: _projectCostPriorityList3.length,
          allProjectCostPriority: _projectCostPriorityList3,
          projectCostPriorityList: _projectCostPriorityList3
        });
      }

    case _ActionTypes.GET_UNSELECTED_ALL_PROJECT_COST_PRIORITY:
      {
        var _projectCostPriorityList4 = state.allProjectCostPriority.map(function (projectCostPriority) {
          return projectCostPriority ? _objectSpread({}, projectCostPriority, {
            selected: false
          }) : projectCostPriority;
        });

        return _objectSpread({}, state, {
          selectedProjectCostPrioritys: 0,
          allProjectCostPriority: _projectCostPriorityList4,
          projectCostPriorityList: _projectCostPriorityList4
        });
      }

    case _ActionTypes.ON_ALL_PROJECT_COST_PRIORITY_SELECT:
      {
        var selectAll = state.selectedProjectCostPrioritys < state.projectCostPriorityList.length;
        var _selectedProjectCostPrioritys = 0;
        var _projectCostPriorityList5 = [];

        if (selectAll) {
          _projectCostPriorityList5 = state.allProjectCostPriority.map(function (projectCostPriority) {
            return projectCostPriority ? _objectSpread({}, projectCostPriority, {
              selected: true
            }) : projectCostPriority;
          });
          _selectedProjectCostPrioritys = _projectCostPriorityList5.length;
        } else {
          _projectCostPriorityList5 = state.allProjectCostPriority.map(function (projectCostPriority) {
            return projectCostPriority ? _objectSpread({}, projectCostPriority, {
              selected: true
            }) : projectCostPriority;
          });
          _selectedProjectCostPrioritys = 0;
        }

        return _objectSpread({}, state, {
          selectedProjectCostPrioritys: _selectedProjectCostPrioritys,
          allProjectCostPriority: _projectCostPriorityList5,
          projectCostPriorityList: _projectCostPriorityList5
        });
      }

    case _ActionTypes.UPDATE_SEARCH_PROJECT_COST_PRIORITY:
      {
        return _objectSpread({}, state, {
          searchProjectCostPriority: action.payload
        });
      }

    case _ActionTypes.HANDLE_PROJECT_COST_PRIORITY_REQUEST_CLOSE:
      {
        return _objectSpread({}, state, {
          showMessage: false
        });
      }

    case _ActionTypes.ON_TOGGLE_PROJECT_COST_PRIORITY_DRAWER:
      {
        return _objectSpread({}, state, {
          drawerState: !state.drawerState
        });
      }

    case _ActionTypes.SHOW_PROJECT_COST_PRIORITY_LOADER:
      {
        return _objectSpread({}, state, {
          loader: true
        });
      }

    case _ActionTypes.HIDE_PROJECT_COST_PRIORITY_LOADER:
      {
        return _objectSpread({}, state, {
          loader: false
        });
      }

    default:
      return state;
  }
};

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ALL_FILTER, "ALL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(STARRED_FILTER, "STARRED_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_UPDATE, "SUCCESSFUL_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_FILTER, "SUCCESSFUL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_DELETE, "SUCCESSFUL_DELETE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(REMOVED_AS_STAR, "REMOVED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(MARKED_AS_STAR, "MARKED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectCostPriority.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(ALL_FILTER, "ALL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(STARRED_FILTER, "STARRED_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_UPDATE, "SUCCESSFUL_UPDATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_FILTER, "SUCCESSFUL_FILTER", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(SUCCESSFUL_DELETE, "SUCCESSFUL_DELETE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(REMOVED_AS_STAR, "REMOVED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(MARKED_AS_STAR, "MARKED_AS_STAR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(INIT_STATE, "INIT_STATE", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/reducers/projectCostPriority.js");
}();

;

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(1208)('createHashHistory');
module.exports = __webpack_require__(1209).createHashHistory;


/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var printWarning = function() {};

if (false) {
  printWarning = function(format, subs) {
    var index = 0;
    var message =
      'Warning: ' +
      (subs.length > 0
        ? format.replace(/%s/g, function() {
            return subs[index++];
          })
        : format);

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging history ---
      // This error was thrown as a convenience so that you can use the
      // stack trace to find the callsite that triggered this warning.
      throw new Error(message);
    } catch (e) {}
  };
}

module.exports = function(member) {
  printWarning(
    'Please use `require("history").%s` instead of `require("history/%s")`. ' +
      'Support for the latter will be removed in the next major release.',
    [member, member]
  );
};


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1210);
} else {
  module.exports = require('./cjs/history.js');
}


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__(497)),valueEqual=_interopDefault(__webpack_require__(498));__webpack_require__(208);var invariant=_interopDefault(__webpack_require__(250));function _extends(){return(_extends=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(t[a]=e[a])}return t}).apply(this,arguments)}function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function stripLeadingSlash(t){return"/"===t.charAt(0)?t.substr(1):t}function hasBasename(t,n){return 0===t.toLowerCase().indexOf(n.toLowerCase())&&-1!=="/?#".indexOf(t.charAt(n.length))}function stripBasename(t,n){return hasBasename(t,n)?t.substr(n.length):t}function stripTrailingSlash(t){return"/"===t.charAt(t.length-1)?t.slice(0,-1):t}function parsePath(t){var n=t||"/",e="",a="",r=n.indexOf("#");-1!==r&&(a=n.substr(r),n=n.substr(0,r));var o=n.indexOf("?");return-1!==o&&(e=n.substr(o),n=n.substr(0,o)),{pathname:n,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(t){var n=t.pathname,e=t.search,a=t.hash,r=n||"/";return e&&"?"!==e&&(r+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(r+="#"===a.charAt(0)?a:"#"+a),r}function createLocation(t,n,e,a){var r;"string"==typeof t?(r=parsePath(t)).state=n:(void 0===(r=_extends({},t)).pathname&&(r.pathname=""),r.search?"?"!==r.search.charAt(0)&&(r.search="?"+r.search):r.search="",r.hash?"#"!==r.hash.charAt(0)&&(r.hash="#"+r.hash):r.hash="",void 0!==n&&void 0===r.state&&(r.state=n));try{r.pathname=decodeURI(r.pathname)}catch(t){throw t instanceof URIError?new URIError('Pathname "'+r.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):t}return e&&(r.key=e),a?r.pathname?"/"!==r.pathname.charAt(0)&&(r.pathname=resolvePathname(r.pathname,a.pathname)):r.pathname=a.pathname:r.pathname||(r.pathname="/"),r}function locationsAreEqual(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash&&t.key===n.key&&valueEqual(t.state,n.state)}function createTransitionManager(){var o=null;var a=[];return{setPrompt:function(t){return o=t,function(){o===t&&(o=null)}},confirmTransitionTo:function(t,n,e,a){if(null!=o){var r="function"==typeof o?o(t,n):o;"string"==typeof r?"function"==typeof e?e(r,a):a(!0):a(!1!==r)}else a(!0)},appendListener:function(t){var n=!0;function e(){n&&t.apply(void 0,arguments)}return a.push(e),function(){n=!1,a=a.filter(function(t){return t!==e})}},notifyListeners:function(){for(var t=arguments.length,n=new Array(t),e=0;e<t;e++)n[e]=arguments[e];a.forEach(function(t){return t.apply(void 0,n)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(t,n){n(window.confirm(t))}function supportsHistory(){var t=window.navigator.userAgent;return(-1===t.indexOf("Android 2.")&&-1===t.indexOf("Android 4.0")||-1===t.indexOf("Mobile Safari")||-1!==t.indexOf("Chrome")||-1!==t.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(t){return void 0===t.state&&-1===navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(t){return{}}}function createBrowserHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var s=window.history,c=supportsHistory(),n=!supportsPopStateOnHashChange(),e=t,a=e.forceRefresh,h=void 0!==a&&a,r=e.getUserConfirmation,u=void 0===r?getConfirmation:r,o=e.keyLength,i=void 0===o?6:o,f=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"";function l(t){var n=t||{},e=n.key,a=n.state,r=window.location,o=r.pathname+r.search+r.hash;return f&&(o=stripBasename(o,f)),createLocation(o,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(t){_extends(T,t),T.length=s.length,v.notifyListeners(T.location,T.action)}function g(t){isExtraneousPopstateEvent(t)||w(l(t.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(n){if(m)m=!1,p();else{v.confirmTransitionTo(n,"POP",u,function(t){t?p({action:"POP",location:n}):function(t){var n=T.location,e=H.indexOf(n.key);-1===e&&(e=0);var a=H.indexOf(t.key);-1===a&&(a=0);var r=e-a;r&&(m=!0,L(r))}(n)})}}var y=l(getHistoryState()),H=[y.key];function x(t){return f+createPath(t)}function L(t){s.go(t)}var O=0;function E(t){1===(O+=t)&&1===t?(window.addEventListener(PopStateEvent,g),n&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),n&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:s.length,action:"POP",location:y,createHref:x,push:function(t,n){var i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.pushState({key:e,state:a},null,n),h)window.location.href=n;else{var r=H.indexOf(T.location.key),o=H.slice(0,r+1);o.push(i.key),H=o,p({action:"PUSH",location:i})}else window.location.href=n}})},replace:function(t,n){var o="REPLACE",i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,o,u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.replaceState({key:e,state:a},null,n),h)window.location.replace(n);else{var r=H.indexOf(T.location.key);-1!==r&&(H[r]=i.key),p({action:o,location:i})}else window.location.replace(n)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(t){void 0===t&&(t=!1);var n=v.setPrompt(t);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),n()}},listen:function(t){var n=v.appendListener(t);return E(1),function(){E(-1),n()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(t){return"!"===t.charAt(0)?t:"!/"+stripLeadingSlash(t)},decodePath:function(t){return"!"===t.charAt(0)?t.substr(1):t}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function stripHash(t){var n=t.indexOf("#");return-1===n?t:t.slice(0,n)}function getHashPath(){var t=window.location.href,n=t.indexOf("#");return-1===n?"":t.substring(n+1)}function pushHashPath(t){window.location.hash=t}function replaceHashPath(t){window.location.replace(stripHash(window.location.href)+"#"+t)}function createHashHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var n=window.history,e=(supportsGoWithoutReloadUsingHash(),t),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,r=e.hashType,o=void 0===r?"slash":r,s=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"",c=HashPathCoders[o],h=c.encodePath,u=c.decodePath;function f(){var t=u(getHashPath());return s&&(t=stripBasename(t,s)),createLocation(t)}var l=createTransitionManager();function d(t){_extends(E,t),E.length=n.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var t=getHashPath(),n=h(t);if(t!==n)replaceHashPath(n);else{var e=f(),a=E.location;if(!v&&function(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash}(a,e))return;if(p===createPath(e))return;p=null,function(n){if(v)v=!1,d();else{l.confirmTransitionTo(n,"POP",i,function(t){t?d({action:"POP",location:n}):function(t){var n=E.location,e=y.lastIndexOf(createPath(n));-1===e&&(e=0);var a=y.lastIndexOf(createPath(t));-1===a&&(a=0);var r=e-a;r&&(v=!0,H(r))}(n)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(t){n.go(t)}var x=0;function L(t){1===(x+=t)&&1===t?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:n.length,action:"POP",location:w,createHref:function(t){var n=document.querySelector("base"),e="";return n&&n.getAttribute("href")&&(e=stripHash(window.location.href)),e+"#"+h(s+createPath(t))},push:function(t,n){var o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,"PUSH",i,function(t){if(t){var n=createPath(o),e=h(s+n);if(getHashPath()!==e){p=n,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),r=y.slice(0,a+1);r.push(n),y=r,d({action:"PUSH",location:o})}else d()}})},replace:function(t,n){var r="REPLACE",o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,r,i,function(t){if(t){var n=createPath(o),e=h(s+n);getHashPath()!==e&&(p=n,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=n),d({action:r,location:o})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(t){void 0===t&&(t=!1);var n=l.setPrompt(t);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),n()}},listen:function(t){var n=l.appendListener(t);return L(1),function(){L(-1),n()}}};return E}function clamp(t,n,e){return Math.min(Math.max(t,n),e)}function createMemoryHistory(t){void 0===t&&(t={});var n=t,r=n.getUserConfirmation,e=n.initialEntries,a=void 0===e?["/"]:e,o=n.initialIndex,i=void 0===o?0:o,s=n.keyLength,c=void 0===s?6:s,h=createTransitionManager();function u(t){_extends(g,t),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,c)}var l=clamp(i,0,a.length-1),d=a.map(function(t){return createLocation(t,void 0,"string"==typeof t?f():t.key||f())}),v=createPath;function p(t){var n=clamp(g.index+t,0,g.entries.length-1),e=g.entries[n];h.confirmTransitionTo(e,"POP",r,function(t){t?u({action:"POP",location:e,index:n}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(t,n){var a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,"PUSH",r,function(t){if(t){var n=g.index+1,e=g.entries.slice(0);e.length>n?e.splice(n,e.length-n,a):e.push(a),u({action:"PUSH",location:a,index:n,entries:e})}})},replace:function(t,n){var e="REPLACE",a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,e,r,function(t){t&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(t){var n=g.index+t;return 0<=n&&n<g.entries.length},block:function(t){return void 0===t&&(t=!1),h.setPrompt(t)},listen:function(t){return h.appendListener(t)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_middleware__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_runSaga__ = __webpack_require__(646);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "runSaga", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_runSaga__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_channel__ = __webpack_require__(172);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "END", function() { return __WEBPACK_IMPORTED_MODULE_2__internal_channel__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "eventChannel", function() { return __WEBPACK_IMPORTED_MODULE_2__internal_channel__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "channel", function() { return __WEBPACK_IMPORTED_MODULE_2__internal_channel__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_buffers__ = __webpack_require__(258);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "buffers", function() { return __WEBPACK_IMPORTED_MODULE_3__internal_buffers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_sagaHelpers__ = __webpack_require__(648);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "takeEvery", function() { return __WEBPACK_IMPORTED_MODULE_4__internal_sagaHelpers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "takeLatest", function() { return __WEBPACK_IMPORTED_MODULE_4__internal_sagaHelpers__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "throttle", function() { return __WEBPACK_IMPORTED_MODULE_4__internal_sagaHelpers__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_utils__ = __webpack_require__(71);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "delay", function() { return __WEBPACK_IMPORTED_MODULE_5__internal_utils__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CANCEL", function() { return __WEBPACK_IMPORTED_MODULE_5__internal_utils__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_io__ = __webpack_require__(112);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "detach", function() { return __WEBPACK_IMPORTED_MODULE_6__internal_io__["i"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__effects__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(1217);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "effects", function() { return __WEBPACK_IMPORTED_MODULE_7__effects__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "utils", function() { return __WEBPACK_IMPORTED_MODULE_8__utils__; });

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__internal_middleware__["a" /* default */]);













/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sagaMiddlewareFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__channel__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__runSaga__ = __webpack_require__(646);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






function sagaMiddlewareFactory() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref$context = _ref.context,
      context = _ref$context === undefined ? {} : _ref$context,
      options = _objectWithoutProperties(_ref, ['context']);

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;


  if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(options)) {
    if (true) {
      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
    } else {
      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
    }
  }

  if (logger && !__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(logger)) {
    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
  }

  if (false) {
    throw new Error('`options.onerror` was removed. Use `options.onError` instead.');
  }

  if (onError && !__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(onError)) {
    throw new Error('`options.onError` passed to the Saga middleware is not a function!');
  }

  if (options.emitter && !__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(options.emitter)) {
    throw new Error('`options.emitter` passed to the Saga middleware is not a function!');
  }

  function sagaMiddleware(_ref2) {
    var getState = _ref2.getState,
        dispatch = _ref2.dispatch;

    var sagaEmitter = Object(__WEBPACK_IMPORTED_MODULE_1__channel__["c" /* emitter */])();
    sagaEmitter.emit = (options.emitter || __WEBPACK_IMPORTED_MODULE_0__utils__["o" /* ident */])(sagaEmitter.emit);

    sagaMiddleware.run = __WEBPACK_IMPORTED_MODULE_2__runSaga__["a" /* runSaga */].bind(null, {
      context: context,
      subscribe: sagaEmitter.subscribe,
      dispatch: dispatch,
      getState: getState,
      sagaMonitor: sagaMonitor,
      logger: logger,
      onError: onError
    });

    return function (next) {
      return function (action) {
        if (sagaMonitor && sagaMonitor.actionDispatched) {
          sagaMonitor.actionDispatched(action);
        }
        var result = next(action); // hit reducers
        sagaEmitter.emit(action);
        return result;
      };
    };
  }

  sagaMiddleware.run = function () {
    throw new Error('Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
  };

  sagaMiddleware.setContext = function (props) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* createSetContextWarning */])('sagaMiddleware', props));
    __WEBPACK_IMPORTED_MODULE_0__utils__["v" /* object */].assign(context, props);
  };

  return sagaMiddleware;
}

/***/ }),
/* 1213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeEvery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(172);




function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["s" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["k" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };

  var action = void 0,
      setAction = function setAction(ac) {
    return action = ac;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q1', yFork(action)];
    }
  }, 'q1', 'takeEvery(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ', ' + worker.name + ')');
}

/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeLatest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(172);




function takeLatest(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["s" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["k" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yCancel = function yCancel(task) {
    return { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["f" /* cancel */])(task) };
  };

  var task = void 0,
      action = void 0;
  var setTask = function setTask(t) {
    return task = t;
  };
  var setAction = function setAction(ac) {
    return action = ac;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
    },
    q3: function q3() {
      return ['q1', yFork(action), setTask];
    }
  }, 'q1', 'takeLatest(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ', ' + worker.name + ')');
}

/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = throttle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__buffers__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(71);






function throttle(delayLength, pattern, worker) {
  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var action = void 0,
      channel = void 0;

  var yActionChannel = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["a" /* actionChannel */])(pattern, __WEBPACK_IMPORTED_MODULE_3__buffers__["a" /* buffers */].sliding(1)) };
  var yTake = function yTake() {
    return { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["s" /* take */])(channel) };
  };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["k" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yDelay = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["e" /* call */])(__WEBPACK_IMPORTED_MODULE_4__utils__["m" /* delay */], delayLength) };

  var setAction = function setAction(ac) {
    return action = ac;
  };
  var setChannel = function setChannel(ch) {
    return channel = ch;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yActionChannel, setChannel];
    },
    q2: function q2() {
      return ['q3', yTake(), setAction];
    },
    q3: function q3() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q4', yFork(action)];
    },
    q4: function q4() {
      return ['q2', yDelay];
    }
  }, 'q1', 'throttle(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(pattern) + ', ' + worker.name + ')');
}

/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeEvery;
/* harmony export (immutable) */ __webpack_exports__["b"] = takeLatest;
/* harmony export (immutable) */ __webpack_exports__["c"] = throttle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__io__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sagaHelpers__ = __webpack_require__(648);



function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return __WEBPACK_IMPORTED_MODULE_0__io__["k" /* fork */].apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["b" /* takeEveryHelper */], patternOrChannel, worker].concat(args));
}

function takeLatest(patternOrChannel, worker) {
  for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }

  return __WEBPACK_IMPORTED_MODULE_0__io__["k" /* fork */].apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["d" /* takeLatestHelper */], patternOrChannel, worker].concat(args));
}

function throttle(ms, pattern, worker) {
  for (var _len3 = arguments.length, args = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
    args[_key3 - 3] = arguments[_key3];
  }

  return __WEBPACK_IMPORTED_MODULE_0__io__["k" /* fork */].apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["f" /* throttleHelper */], ms, pattern, worker].concat(args));
}

/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_utils__ = __webpack_require__(71);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TASK", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SAGA_ACTION", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "noop", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["u"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "is", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["q"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "deferred", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "arrayOfDeffered", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createMockTask", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cloneableGenerator", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["i"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_io__ = __webpack_require__(112);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "asEffect", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_io__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_proc__ = __webpack_require__(647);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CHANNEL_END", function() { return __WEBPACK_IMPORTED_MODULE_2__internal_proc__["a"]; });




/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = rootSaga;

var _effects = __webpack_require__(15);

var _Mail = _interopRequireDefault(__webpack_require__(1219));

var _Todo = _interopRequireDefault(__webpack_require__(1220));

var _Contact = _interopRequireDefault(__webpack_require__(1221));

var _Chat = _interopRequireDefault(__webpack_require__(1222));

var _Auth = _interopRequireDefault(__webpack_require__(1223));

var _Organisation = _interopRequireDefault(__webpack_require__(1259));

var _Employee = _interopRequireDefault(__webpack_require__(1260));

var _OrgSurvey = _interopRequireDefault(__webpack_require__(1261));

var _OrgSurveyAnswer = _interopRequireDefault(__webpack_require__(1262));

var _Survey = _interopRequireDefault(__webpack_require__(1263));

var _SurveyGroup = _interopRequireDefault(__webpack_require__(1264));

var _SurveyGroupQuestion = _interopRequireDefault(__webpack_require__(1265));

var _SurveyQuestion = _interopRequireDefault(__webpack_require__(1266));

var _project = _interopRequireDefault(__webpack_require__(1267));

var _projectPriority = _interopRequireDefault(__webpack_require__(1268));

var _security = _interopRequireDefault(__webpack_require__(1269));

var _projectIssue = _interopRequireDefault(__webpack_require__(1270));

var _businessUnit = _interopRequireDefault(__webpack_require__(1272));

var _portfolio = _interopRequireDefault(__webpack_require__(1273));

var _feature = _interopRequireDefault(__webpack_require__(1274));

var _valueStream = _interopRequireDefault(__webpack_require__(1276));

var _member = _interopRequireDefault(__webpack_require__(1277));

var _team = _interopRequireDefault(__webpack_require__(1278));

var _product = _interopRequireDefault(__webpack_require__(1279));

var _initiative = _interopRequireDefault(__webpack_require__(1280));

var _issue = _interopRequireDefault(__webpack_require__(1281));

var _projectBusPriority = _interopRequireDefault(__webpack_require__(1282));

var _projectCostPriority = _interopRequireDefault(__webpack_require__(1283));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(rootSaga);

function rootSaga() {
  return regeneratorRuntime.wrap(function rootSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.all)([(0, _Mail["default"])(), (0, _Todo["default"])(), (0, _Contact["default"])(), (0, _Chat["default"])(), (0, _Auth["default"])(), (0, _Organisation["default"])(), (0, _Employee["default"])(), (0, _OrgSurvey["default"])(), (0, _OrgSurveyAnswer["default"])(), (0, _Survey["default"])(), (0, _SurveyGroup["default"])(), (0, _SurveyGroupQuestion["default"])(), (0, _SurveyQuestion["default"])(), (0, _project["default"])(), (0, _projectPriority["default"])(), (0, _security["default"])(), (0, _projectIssue["default"])(), (0, _businessUnit["default"])(), (0, _portfolio["default"])(), (0, _feature["default"])(), (0, _valueStream["default"])(), (0, _member["default"])(), (0, _team["default"])(), (0, _product["default"])(), (0, _initiative["default"])(), (0, _issue["default"])(), (0, _projectBusPriority["default"])(), (0, _projectCostPriority["default"])()]);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_Mail, "_Mail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/index.js");

  __REACT_HOT_LOADER__.register(_Todo, "_Todo", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/index.js");

  __REACT_HOT_LOADER__.register(_Contact, "_Contact", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/index.js");

  __REACT_HOT_LOADER__.register(_Chat, "_Chat", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/index.js");

  __REACT_HOT_LOADER__.register(_Auth, "_Auth", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/index.js");

  __REACT_HOT_LOADER__.register(_Organisation, "_Organisation", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/index.js");

  __REACT_HOT_LOADER__.register(_Employee, "_Employee", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/index.js");

  __REACT_HOT_LOADER__.register(_OrgSurvey, "_OrgSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/index.js");

  __REACT_HOT_LOADER__.register(_OrgSurveyAnswer, "_OrgSurveyAnswer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/index.js");

  __REACT_HOT_LOADER__.register(_Survey, "_Survey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/index.js");

  __REACT_HOT_LOADER__.register(_SurveyGroup, "_SurveyGroup", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/index.js");

  __REACT_HOT_LOADER__.register(_SurveyGroupQuestion, "_SurveyGroupQuestion", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/index.js");

  __REACT_HOT_LOADER__.register(_SurveyQuestion, "_SurveyQuestion", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/index.js");

  __REACT_HOT_LOADER__.register(_project, "_project", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/index.js");

  __REACT_HOT_LOADER__.register(_projectPriority, "_projectPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/index.js");

  __REACT_HOT_LOADER__.register(_security, "_security", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/index.js");

  __REACT_HOT_LOADER__.register(_projectIssue, "_projectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/index.js");

  __REACT_HOT_LOADER__.register(_businessUnit, "_businessUnit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/index.js");

  __REACT_HOT_LOADER__.register(_portfolio, "_portfolio", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/index.js");

  __REACT_HOT_LOADER__.register(_feature, "_feature", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/index.js");

  __REACT_HOT_LOADER__.register(_valueStream, "_valueStream", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/index.js");

  __REACT_HOT_LOADER__.register(_member, "_member", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/index.js");

  __REACT_HOT_LOADER__.register(_team, "_team", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/index.js");

  __REACT_HOT_LOADER__.register(_product, "_product", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/index.js");

  __REACT_HOT_LOADER__.register(_initiative, "_initiative", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/index.js");

  __REACT_HOT_LOADER__.register(_issue, "_issue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/index.js");

  __REACT_HOT_LOADER__.register(_projectBusPriority, "_projectBusPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/index.js");

  __REACT_HOT_LOADER__.register(_projectCostPriority, "_projectCostPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/index.js");

  __REACT_HOT_LOADER__.register(_marked, "_marked", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/index.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/index.js");
}();

;

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = rootSaga;

var _effects = __webpack_require__(15);

var _Mail = __webpack_require__(438);

var _ActionTypes = __webpack_require__(7);

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(fetchMailRequest),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(rootSaga); // const getMails = async () =>
//     await database.ref ('mail').once ('value')
//         .then ((snapshot) => {
//             const mails = [];
//             snapshot.forEach ((rawData) => {
//                 const mail = rawData.val ();
//                 // change object to array
//                 const labels = [];
//                 if (mail.labels) {
//                     mail.labels.forEach ((label) =>
//                         labels.push (label)
//                     );
//                 }
//                 // change object to array
//                 const tos = [];
//                 mail.to.forEach ((to) =>
//                     tos.push (to)
//                 );
//                 mail.to = tos;
//                 mail.labels = labels;
//                 mails.push (mail);
//             });
//             return mails;
//         })
//         .catch (error => error);


function fetchMailRequest() {
  return regeneratorRuntime.wrap(function fetchMailRequest$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 7;
          break;

        case 3:
          _context.prev = 3;
          _context.t0 = _context["catch"](0);
          _context.next = 7;
          return (0, _effects.put)((0, _Mail.showMailMessage)(_context.t0));

        case 7:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 3]]);
}

function rootSaga() {
  return regeneratorRuntime.wrap(function rootSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.all)([(0, _effects.takeEvery)(_ActionTypes.FETCH_ALL_MAIL, fetchMailRequest)]);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchMailRequest, "fetchMailRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Mail.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Mail.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_marked, "_marked", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Mail.js");

  __REACT_HOT_LOADER__.register(_marked2, "_marked2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Mail.js");

  __REACT_HOT_LOADER__.register(fetchMailRequest, "fetchMailRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Mail.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Mail.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Mail.js");
}();

;

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchTodos = fetchTodos;
exports.fetchTodoConversation = fetchTodoConversation;
exports["default"] = rootSaga;

var _effects = __webpack_require__(15);

var _ToDo = __webpack_require__(439);

var _ActionTypes = __webpack_require__(7);

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(fetchTodoRequest),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchTodoConversationRequest),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchTodos),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchTodoConversation),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(rootSaga); // const getTodos = async () =>
// await database.ref ('todo/todos').once ('value')
//     .then ((snapshot) => {
//         const todos = [];
//         snapshot.forEach ((rawData) => {
//             const todo = rawData.val ();
//             // change object to array
//             const labels = [];
//             if (todo.labels) {
//                 todo.labels.forEach ((label) =>
//                     labels.push (label)
//                 );
//             }
//             todo.labels = labels;
//             todos.push (todo);
//         });
//         return todos;
//     })
//     .catch (error => error);
// const getTodosConversation = async () =>
// await database.ref ('todo/conversation').once ('value')
//     .then ((snapshot) => {
//         const conversations = [];
//         snapshot.forEach ((rawData) => {
//             const conversation = rawData.val ();
//             // change object to array
//             const conversationDatas = [];
//             if (conversation.conversationData) {
//                 conversation.conversationData.forEach ((conversationData) =>
//                     conversationDatas.push (conversationData)
//                 );
//             }
//             conversation.conversationData = conversationDatas;
//             conversations.push (conversation);
//         });
//         return conversations;
//     })
//     .catch (error => error);


function fetchTodoRequest() {
  return regeneratorRuntime.wrap(function fetchTodoRequest$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 7;
          break;

        case 3:
          _context.prev = 3;
          _context.t0 = _context["catch"](0);
          _context.next = 7;
          return (0, _effects.put)((0, _ToDo.showTodoMessage)(_context.t0));

        case 7:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 3]]);
}

function fetchTodoConversationRequest() {
  return regeneratorRuntime.wrap(function fetchTodoConversationRequest$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 7;
          break;

        case 3:
          _context2.prev = 3;
          _context2.t0 = _context2["catch"](0);
          _context2.next = 7;
          return (0, _effects.put)((0, _ToDo.showTodoMessage)(_context2.t0));

        case 7:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[0, 3]]);
}

function fetchTodos() {
  return regeneratorRuntime.wrap(function fetchTodos$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_ALL_TODO, fetchTodoRequest);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}

function fetchTodoConversation() {
  return regeneratorRuntime.wrap(function fetchTodoConversation$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_ALL_TODO_CONVERSATION, fetchTodoConversationRequest);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}

function rootSaga() {
  return regeneratorRuntime.wrap(function rootSaga$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.all)([(0, _effects.fork)(fetchTodoConversation), (0, _effects.fork)(fetchTodos)]);

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchTodoRequest, "fetchTodoRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Todo.js");

  __REACT_HOT_LOADER__.register(fetchTodoConversationRequest, "fetchTodoConversationRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Todo.js");

  __REACT_HOT_LOADER__.register(fetchTodos, "fetchTodos", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Todo.js");

  __REACT_HOT_LOADER__.register(fetchTodoConversation, "fetchTodoConversation", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Todo.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Todo.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_marked, "_marked", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Todo.js");

  __REACT_HOT_LOADER__.register(_marked2, "_marked2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Todo.js");

  __REACT_HOT_LOADER__.register(_marked3, "_marked3", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Todo.js");

  __REACT_HOT_LOADER__.register(_marked4, "_marked4", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Todo.js");

  __REACT_HOT_LOADER__.register(_marked5, "_marked5", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Todo.js");

  __REACT_HOT_LOADER__.register(fetchTodoRequest, "fetchTodoRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Todo.js");

  __REACT_HOT_LOADER__.register(fetchTodoConversationRequest, "fetchTodoConversationRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Todo.js");

  __REACT_HOT_LOADER__.register(fetchTodos, "fetchTodos", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Todo.js");

  __REACT_HOT_LOADER__.register(fetchTodoConversation, "fetchTodoConversation", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Todo.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Todo.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Todo.js");
}();

;

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = rootSaga;

var _effects = __webpack_require__(15);

var _Contact = __webpack_require__(440);

var _ActionTypes = __webpack_require__(7);

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(fetchContactRequest),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(rootSaga); // const getContacts = async () =>
//     await database.ref ('contacts').once ('value')
//         .then ((snapshot) => {
//             const contacts = [];
//             snapshot.forEach ((rawData) => {
//                 contacts.push (rawData.val ());
//             });
//             return contacts;
//         })
//         .catch (error => error);


function fetchContactRequest() {
  return regeneratorRuntime.wrap(function fetchContactRequest$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 7;
          break;

        case 3:
          _context.prev = 3;
          _context.t0 = _context["catch"](0);
          _context.next = 7;
          return (0, _effects.put)((0, _Contact.showContactMessage)(_context.t0));

        case 7:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 3]]);
}

function rootSaga() {
  return regeneratorRuntime.wrap(function rootSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.all)([(0, _effects.takeEvery)(_ActionTypes.FETCH_ALL_CONTACT, fetchContactRequest)]);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchContactRequest, "fetchContactRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Contact.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Contact.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_marked, "_marked", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Contact.js");

  __REACT_HOT_LOADER__.register(_marked2, "_marked2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Contact.js");

  __REACT_HOT_LOADER__.register(fetchContactRequest, "fetchContactRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Contact.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Contact.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Contact.js");
}();

;

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchChatUser = fetchChatUser;
exports.fetchChatUserConversation = fetchChatUserConversation;
exports["default"] = rootSaga;

var _effects = __webpack_require__(15);

var _ActionTypes = __webpack_require__(7);

var _Chat = __webpack_require__(441);

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(fetchChatUserRequest),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchChatUserConversationRequest),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchChatUser),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchChatUserConversation),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(rootSaga); // const getChatUsers = async () =>
//     await database.ref ('chat/users').once ('value')
//         .then ((snapshot) => {
//             const chatUsers = [];
//             snapshot.forEach ((rawData) => {
//                 chatUsers.push (rawData.val ());
//             });
//             return chatUsers;
//         })
//         .catch (error => error);
// const getUsersConversation = async () =>
//     await database.ref ('chat/conversation').once ('value')
//         .then ((snapshot) => {
//             const conversations = [];
//             snapshot.forEach ((rawData) => {
//                 const conversation = rawData.val ();
//                 // change object to array
//                 const conversationDatas = [];
//                 if (conversation.conversationData) {
//                     conversation.conversationData.forEach ((conversationData) =>
//                         conversationDatas.push (conversationData)
//                     );
//                 }
//                 conversation.conversationData = conversationDatas;
//                 conversations.push (conversation);
//             });
//             return conversations;
//         })
//         .catch (error => error);


function fetchChatUserRequest() {
  return regeneratorRuntime.wrap(function fetchChatUserRequest$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 7;
          break;

        case 3:
          _context.prev = 3;
          _context.t0 = _context["catch"](0);
          _context.next = 7;
          return (0, _effects.put)((0, _Chat.showChatMessage)(_context.t0));

        case 7:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 3]]);
}

function fetchChatUserConversationRequest() {
  return regeneratorRuntime.wrap(function fetchChatUserConversationRequest$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 7;
          break;

        case 3:
          _context2.prev = 3;
          _context2.t0 = _context2["catch"](0);
          _context2.next = 7;
          return (0, _effects.put)((0, _Chat.showChatMessage)(_context2.t0));

        case 7:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[0, 3]]);
}

function fetchChatUser() {
  return regeneratorRuntime.wrap(function fetchChatUser$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_ALL_CHAT_USER, fetchChatUserRequest);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}

function fetchChatUserConversation() {
  return regeneratorRuntime.wrap(function fetchChatUserConversation$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_ALL_CHAT_USER_CONVERSATION, fetchChatUserConversationRequest);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}

function rootSaga() {
  return regeneratorRuntime.wrap(function rootSaga$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.all)([(0, _effects.fork)(fetchChatUserConversation), (0, _effects.fork)(fetchChatUser)]);

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchChatUserRequest, "fetchChatUserRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Chat.js");

  __REACT_HOT_LOADER__.register(fetchChatUserConversationRequest, "fetchChatUserConversationRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Chat.js");

  __REACT_HOT_LOADER__.register(fetchChatUser, "fetchChatUser", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Chat.js");

  __REACT_HOT_LOADER__.register(fetchChatUserConversation, "fetchChatUserConversation", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Chat.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Chat.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_marked, "_marked", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Chat.js");

  __REACT_HOT_LOADER__.register(_marked2, "_marked2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Chat.js");

  __REACT_HOT_LOADER__.register(_marked3, "_marked3", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Chat.js");

  __REACT_HOT_LOADER__.register(_marked4, "_marked4", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Chat.js");

  __REACT_HOT_LOADER__.register(_marked5, "_marked5", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Chat.js");

  __REACT_HOT_LOADER__.register(fetchChatUserRequest, "fetchChatUserRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Chat.js");

  __REACT_HOT_LOADER__.register(fetchChatUserConversationRequest, "fetchChatUserConversationRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Chat.js");

  __REACT_HOT_LOADER__.register(fetchChatUser, "fetchChatUser", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Chat.js");

  __REACT_HOT_LOADER__.register(fetchChatUserConversation, "fetchChatUserConversation", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Chat.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Chat.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Chat.js");
}();

;

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.signInUserSaga = signInUserSaga;
exports.signInUserPasswordlessSaga = signInUserPasswordlessSaga;
exports.requestSignInAccessCodeSaga = requestSignInAccessCodeSaga;
exports.signOutUserSaga = signOutUserSaga;
exports["default"] = rootSaga;

var _effects = __webpack_require__(15);

var _ActionTypes = __webpack_require__(7);

var _Auth = __webpack_require__(143);

var _session = __webpack_require__(649);

var _Organisation = __webpack_require__(144);

var _Employee = __webpack_require__(173);

var _ApiService = __webpack_require__(16);

var _Authentication = __webpack_require__(42);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(signInUserWithUsernamePassword),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(requestSignInAccessCode),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(signInUserPasswordless),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(signOut),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(signInUserSaga),
    _marked6 =
/*#__PURE__*/
regeneratorRuntime.mark(signInUserPasswordlessSaga),
    _marked7 =
/*#__PURE__*/
regeneratorRuntime.mark(requestSignInAccessCodeSaga),
    _marked8 =
/*#__PURE__*/
regeneratorRuntime.mark(signOutUserSaga),
    _marked9 =
/*#__PURE__*/
regeneratorRuntime.mark(rootSaga);

function signInUserWithUsernamePassword(_ref) {
  var payload, username, password, credentials, signInUser, identity;
  return regeneratorRuntime.wrap(function signInUserWithUsernamePassword$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _ref.payload;
          username = payload.username, password = payload.password;
          credentials = {
            username: username,
            password: password
          };
          _context.prev = 3;
          _context.next = 6;
          return (0, _effects.call)(_ApiService.postDataRequest, 'signIn', credentials);

        case 6:
          signInUser = _context.sent;
          (0, _Authentication.setAuth)(signInUser);
          _context.next = 10;
          return (0, _effects.call)(_ApiService.getDataRequest, 'identity');

        case 10:
          identity = _context.sent;
          (0, _Authentication.setIdentity)(identity);
          _context.next = 14;
          return (0, _effects.put)((0, _Employee.fetchNotifications)(identity));

        case 14:
          _context.next = 16;
          return (0, _effects.put)((0, _Auth.userSignInSuccess)(signInUser));

        case 16:
          _context.next = 18;
          return (0, _effects.put)((0, _session.clearSelectedObjects)());

        case 18:
          _context.next = 24;
          break;

        case 20:
          _context.prev = 20;
          _context.t0 = _context["catch"](3);
          _context.next = 24;
          return (0, _effects.put)((0, _Auth.showAuthMessage)(_context.t0.messages));

        case 24:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[3, 20]]);
}

function requestSignInAccessCode(_ref2) {
  var payload, username, credentials, signInUserAccessCode;
  return regeneratorRuntime.wrap(function requestSignInAccessCode$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _ref2.payload;
          username = payload.username;
          credentials = {
            username: username,
            passwordless: true
          };
          _context2.prev = 3;
          _context2.next = 6;
          return (0, _effects.call)(_ApiService.postDataRequest, 'signIn', credentials);

        case 6:
          signInUserAccessCode = _context2.sent;
          _context2.next = 9;
          return (0, _effects.put)((0, _Auth.userRequestSignInCodeSuccess)(signInUserAccessCode));

        case 9:
          _context2.next = 15;
          break;

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](3);
          _context2.next = 15;
          return (0, _effects.put)((0, _Auth.showAuthMessage)(_context2.t0.messages));

        case 15:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[3, 11]]);
}

var getAuthUserCode = function getAuthUserCode(state) {
  return state.auth.authUserCode;
};

function signInUserPasswordless(_ref3) {
  var payload, username, code, credentials, authUserCode, privateChallengeParameter, challengeMetadata, authHeader, signInUser, identity;
  return regeneratorRuntime.wrap(function signInUserPasswordless$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _ref3.payload;
          username = payload.username, code = payload.code;
          credentials = {
            username: username,
            code: code,
            passwordless: true
          };
          _context3.prev = 3;
          _context3.next = 6;
          return (0, _effects.select)(getAuthUserCode);

        case 6:
          authUserCode = _context3.sent;
          privateChallengeParameter = authUserCode.privateChallengeParameter, challengeMetadata = authUserCode.challengeMetadata;
          authHeader = {
            privateChallengeParameter: privateChallengeParameter,
            challengeMetadata: challengeMetadata
          };
          _context3.next = 11;
          return (0, _effects.call)(_ApiService.postDataRequest, 'signIn', credentials, authHeader);

        case 11:
          signInUser = _context3.sent;
          (0, _Authentication.setAuth)(signInUser);
          _context3.next = 15;
          return (0, _effects.call)(_ApiService.getDataRequest, 'identity');

        case 15:
          identity = _context3.sent;
          (0, _Authentication.setIdentity)(identity);
          _context3.next = 19;
          return (0, _effects.put)((0, _Organisation.fetchOrgsAndSelectOrg)(identity === null || identity === void 0 ? void 0 : identity.orgid));

        case 19:
          _context3.next = 21;
          return (0, _effects.put)((0, _Employee.fetchNotifications)(identity));

        case 21:
          _context3.next = 23;
          return (0, _effects.put)((0, _Auth.userSignInSuccess)(signInUser));

        case 23:
          _context3.next = 25;
          return (0, _effects.put)((0, _session.clearSelectedObjects)());

        case 25:
          _context3.next = 31;
          break;

        case 27:
          _context3.prev = 27;
          _context3.t0 = _context3["catch"](3);
          _context3.next = 31;
          return (0, _effects.put)((0, _Auth.showAuthMessage)(_context3.t0.messages));

        case 31:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[3, 27]]);
} // const signInUserPasswordlessRequest = async (credentials, authHeader) => {
//     return postDataRequest('signIn', credentials, authHeader);
// };


var signOutRequest =
/*#__PURE__*/
function () {
  var _ref4 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return (0, _Authentication.invalidateSession)();

          case 2:
            return _context4.abrupt("return");

          case 3:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee);
  }));

  return function signOutRequest() {
    return _ref4.apply(this, arguments);
  };
}();

function signOut() {
  var signOutUser;
  return regeneratorRuntime.wrap(function signOut$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return (0, _effects.call)(signOutRequest);

        case 3:
          signOutUser = _context5.sent;

          if (!(signOutUser && signOutUser.message)) {
            _context5.next = 9;
            break;
          }

          _context5.next = 7;
          return (0, _effects.put)((0, _Auth.showAuthMessage)(signOutUser.messages));

        case 7:
          _context5.next = 13;
          break;

        case 9:
          _context5.next = 11;
          return (0, _effects.put)((0, _Auth.userSignOutSuccess)(signOutUser));

        case 11:
          _context5.next = 13;
          return (0, _effects.put)((0, _session.clearSelectedObjects)());

        case 13:
          _context5.next = 19;
          break;

        case 15:
          _context5.prev = 15;
          _context5.t0 = _context5["catch"](0);
          _context5.next = 19;
          return (0, _effects.put)((0, _Auth.showAuthMessage)(_context5.t0.messages));

        case 19:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked4, null, [[0, 15]]);
}

function signInUserSaga() {
  return regeneratorRuntime.wrap(function signInUserSaga$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.SIGNIN_USER, signInUserWithUsernamePassword);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked5);
}

function signInUserPasswordlessSaga() {
  return regeneratorRuntime.wrap(function signInUserPasswordlessSaga$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.SIGNIN_USER_PASSWORDLESS, signInUserPasswordless);

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked6);
}

function requestSignInAccessCodeSaga() {
  return regeneratorRuntime.wrap(function requestSignInAccessCodeSaga$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.REQUEST_SIGNIN_ACCESS_CODE, requestSignInAccessCode);

        case 2:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked7);
}

function signOutUserSaga() {
  return regeneratorRuntime.wrap(function signOutUserSaga$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.SIGNOUT_USER, signOut);

        case 2:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked8);
}

function rootSaga() {
  return regeneratorRuntime.wrap(function rootSaga$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.all)([(0, _effects.fork)(signInUserSaga), (0, _effects.fork)(signInUserPasswordlessSaga), (0, _effects.fork)(requestSignInAccessCodeSaga), (0, _effects.fork)(signOutUserSaga)]);

        case 2:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked9);
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(signInUserWithUsernamePassword, "signInUserWithUsernamePassword", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Auth.js");

  __REACT_HOT_LOADER__.register(requestSignInAccessCode, "requestSignInAccessCode", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Auth.js");

  __REACT_HOT_LOADER__.register(getAuthUserCode, "getAuthUserCode", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Auth.js");

  __REACT_HOT_LOADER__.register(signInUserPasswordless, "signInUserPasswordless", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Auth.js");

  __REACT_HOT_LOADER__.register(signOutRequest, "signOutRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Auth.js");

  __REACT_HOT_LOADER__.register(signOut, "signOut", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Auth.js");

  __REACT_HOT_LOADER__.register(signInUserSaga, "signInUserSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Auth.js");

  __REACT_HOT_LOADER__.register(signInUserPasswordlessSaga, "signInUserPasswordlessSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Auth.js");

  __REACT_HOT_LOADER__.register(requestSignInAccessCodeSaga, "requestSignInAccessCodeSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Auth.js");

  __REACT_HOT_LOADER__.register(signOutUserSaga, "signOutUserSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Auth.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Auth.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(asyncGeneratorStep, "asyncGeneratorStep", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Auth.js");

  __REACT_HOT_LOADER__.register(_asyncToGenerator, "_asyncToGenerator", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Auth.js");

  __REACT_HOT_LOADER__.register(_marked, "_marked", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Auth.js");

  __REACT_HOT_LOADER__.register(_marked2, "_marked2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Auth.js");

  __REACT_HOT_LOADER__.register(_marked3, "_marked3", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Auth.js");

  __REACT_HOT_LOADER__.register(_marked4, "_marked4", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Auth.js");

  __REACT_HOT_LOADER__.register(_marked5, "_marked5", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Auth.js");

  __REACT_HOT_LOADER__.register(_marked6, "_marked6", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Auth.js");

  __REACT_HOT_LOADER__.register(_marked7, "_marked7", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Auth.js");

  __REACT_HOT_LOADER__.register(_marked8, "_marked8", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Auth.js");

  __REACT_HOT_LOADER__.register(_marked9, "_marked9", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Auth.js");

  __REACT_HOT_LOADER__.register(signInUserWithUsernamePassword, "signInUserWithUsernamePassword", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Auth.js");

  __REACT_HOT_LOADER__.register(requestSignInAccessCode, "requestSignInAccessCode", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Auth.js");

  __REACT_HOT_LOADER__.register(getAuthUserCode, "getAuthUserCode", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Auth.js");

  __REACT_HOT_LOADER__.register(signInUserPasswordless, "signInUserPasswordless", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Auth.js");

  __REACT_HOT_LOADER__.register(signOutRequest, "signOutRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Auth.js");

  __REACT_HOT_LOADER__.register(signOut, "signOut", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Auth.js");

  __REACT_HOT_LOADER__.register(signInUserSaga, "signInUserSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Auth.js");

  __REACT_HOT_LOADER__.register(signInUserPasswordlessSaga, "signInUserPasswordlessSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Auth.js");

  __REACT_HOT_LOADER__.register(requestSignInAccessCodeSaga, "requestSignInAccessCodeSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Auth.js");

  __REACT_HOT_LOADER__.register(signOutUserSaga, "signOutUserSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Auth.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Auth.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Auth.js");
}();

;

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1225);

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(73);
var bind = __webpack_require__(650);
var Axios = __webpack_require__(1227);
var defaults = __webpack_require__(359);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(654);
axios.CancelToken = __webpack_require__(1240);
axios.isCancel = __webpack_require__(653);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(1241);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 1226 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(359);
var utils = __webpack_require__(73);
var InterceptorManager = __webpack_require__(1235);
var dispatchRequest = __webpack_require__(1236);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(73);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(652);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(73);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(73);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(73);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(73);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(73);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(73);
var transformData = __webpack_require__(1237);
var isCancel = __webpack_require__(653);
var defaults = __webpack_require__(359);
var isAbsoluteURL = __webpack_require__(1238);
var combineURLs = __webpack_require__(1239);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(73);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(654);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(1243)
var ieee754 = __webpack_require__(1244)
var isArray = __webpack_require__(1245)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)))

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 1244 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 1245 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var base64_url_decode = __webpack_require__(1247);

function InvalidTokenError(message) {
  this.message = message;
}

InvalidTokenError.prototype = new Error();
InvalidTokenError.prototype.name = 'InvalidTokenError';

module.exports = function (token,options) {
  if (typeof token !== 'string') {
    throw new InvalidTokenError('Invalid token specified');
  }

  options = options || {};
  var pos = options.header === true ? 0 : 1;
  try {
    return JSON.parse(base64_url_decode(token.split('.')[pos]));
  } catch (e) {
    throw new InvalidTokenError('Invalid token specified: ' + e.message);
  }
};

module.exports.InvalidTokenError = InvalidTokenError;


/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

var atob = __webpack_require__(1248);

function b64DecodeUnicode(str) {
  return decodeURIComponent(atob(str).replace(/(.)/g, function (m, p) {
    var code = p.charCodeAt(0).toString(16).toUpperCase();
    if (code.length < 2) {
      code = '0' + code;
    }
    return '%' + code;
  }));
}

module.exports = function(str) {
  var output = str.replace(/-/g, "+").replace(/_/g, "/");
  switch (output.length % 4) {
    case 0:
      break;
    case 2:
      output += "==";
      break;
    case 3:
      output += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }

  try{
    return b64DecodeUnicode(output);
  } catch (err) {
    return atob(output);
  }
};


/***/ }),
/* 1248 */
/***/ (function(module, exports) {

/**
 * The code was extracted from:
 * https://github.com/davidchambers/Base64.js
 */

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function InvalidCharacterError(message) {
  this.message = message;
}

InvalidCharacterError.prototype = new Error();
InvalidCharacterError.prototype.name = 'InvalidCharacterError';

function polyfill (input) {
  var str = String(input).replace(/=+$/, '');
  if (str.length % 4 == 1) {
    throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
  }
  for (
    // initialize result and counters
    var bc = 0, bs, buffer, idx = 0, output = '';
    // get next character
    buffer = str.charAt(idx++);
    // character found in table? initialize bit storage and add its ascii value;
    ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
      // and if not first of each 4 characters,
      // convert the first 8 bits to one ascii character
      bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
  ) {
    // try to find character in table (0-63, not found => -1)
    buffer = chars.indexOf(buffer);
  }
  return output;
}


module.exports = typeof window !== 'undefined' && window.atob && window.atob.bind(window) || polyfill;


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(174);
__webpack_require__(1250);
__webpack_require__(1251);
__webpack_require__(1252);
__webpack_require__(1253);
__webpack_require__(1254);


/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(174);

module.exports = Promise;
Promise.prototype.done = function (onFulfilled, onRejected) {
  var self = arguments.length ? this.then.apply(this, arguments) : this;
  self.then(null, function (err) {
    setTimeout(function () {
      throw err;
    }, 0);
  });
};


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(174);

module.exports = Promise;
Promise.prototype['finally'] = function (f) {
  return this.then(function (value) {
    return Promise.resolve(f()).then(function () {
      return value;
    });
  }, function (err) {
    return Promise.resolve(f()).then(function () {
      throw err;
    });
  });
};


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(174);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._61);
  p._65 = 1;
  p._55 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._65 === 3) {
            val = val._55;
          }
          if (val._65 === 1) return res(i, val._55);
          if (val._65 === 2) reject(val._55);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// This file contains then/promise specific extensions that are only useful
// for node.js interop

var Promise = __webpack_require__(174);
var asap = __webpack_require__(868);

module.exports = Promise;

/* Static Functions */

Promise.denodeify = function (fn, argumentCount) {
  if (
    typeof argumentCount === 'number' && argumentCount !== Infinity
  ) {
    return denodeifyWithCount(fn, argumentCount);
  } else {
    return denodeifyWithoutCount(fn);
  }
};

var callbackFn = (
  'function (err, res) {' +
  'if (err) { rj(err); } else { rs(res); }' +
  '}'
);
function denodeifyWithCount(fn, argumentCount) {
  var args = [];
  for (var i = 0; i < argumentCount; i++) {
    args.push('a' + i);
  }
  var body = [
    'return function (' + args.join(',') + ') {',
    'var self = this;',
    'return new Promise(function (rs, rj) {',
    'var res = fn.call(',
    ['self'].concat(args).concat([callbackFn]).join(','),
    ');',
    'if (res &&',
    '(typeof res === "object" || typeof res === "function") &&',
    'typeof res.then === "function"',
    ') {rs(res);}',
    '});',
    '};'
  ].join('');
  return Function(['Promise', 'fn'], body)(Promise, fn);
}
function denodeifyWithoutCount(fn) {
  var fnLength = Math.max(fn.length - 1, 3);
  var args = [];
  for (var i = 0; i < fnLength; i++) {
    args.push('a' + i);
  }
  var body = [
    'return function (' + args.join(',') + ') {',
    'var self = this;',
    'var args;',
    'var argLength = arguments.length;',
    'if (arguments.length > ' + fnLength + ') {',
    'args = new Array(arguments.length + 1);',
    'for (var i = 0; i < arguments.length; i++) {',
    'args[i] = arguments[i];',
    '}',
    '}',
    'return new Promise(function (rs, rj) {',
    'var cb = ' + callbackFn + ';',
    'var res;',
    'switch (argLength) {',
    args.concat(['extra']).map(function (_, index) {
      return (
        'case ' + (index) + ':' +
        'res = fn.call(' + ['self'].concat(args.slice(0, index)).concat('cb').join(',') + ');' +
        'break;'
      );
    }).join(''),
    'default:',
    'args[argLength] = cb;',
    'res = fn.apply(self, args);',
    '}',
    
    'if (res &&',
    '(typeof res === "object" || typeof res === "function") &&',
    'typeof res.then === "function"',
    ') {rs(res);}',
    '});',
    '};'
  ].join('');

  return Function(
    ['Promise', 'fn'],
    body
  )(Promise, fn);
}

Promise.nodeify = function (fn) {
  return function () {
    var args = Array.prototype.slice.call(arguments);
    var callback =
      typeof args[args.length - 1] === 'function' ? args.pop() : null;
    var ctx = this;
    try {
      return fn.apply(this, arguments).nodeify(callback, ctx);
    } catch (ex) {
      if (callback === null || typeof callback == 'undefined') {
        return new Promise(function (resolve, reject) {
          reject(ex);
        });
      } else {
        asap(function () {
          callback.call(ctx, ex);
        })
      }
    }
  }
};

Promise.prototype.nodeify = function (callback, ctx) {
  if (typeof callback != 'function') return this;

  this.then(function (value) {
    asap(function () {
      callback.call(ctx, null, value);
    });
  }, function (err) {
    asap(function () {
      callback.call(ctx, err);
    });
  });
};


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(174);

module.exports = Promise;
Promise.enableSynchronous = function () {
  Promise.prototype.isPending = function() {
    return this.getState() == 0;
  };

  Promise.prototype.isFulfilled = function() {
    return this.getState() == 1;
  };

  Promise.prototype.isRejected = function() {
    return this.getState() == 2;
  };

  Promise.prototype.getValue = function () {
    if (this._65 === 3) {
      return this._55.getValue();
    }

    if (!this.isFulfilled()) {
      throw new Error('Cannot get a value of an unfulfilled promise.');
    }

    return this._55;
  };

  Promise.prototype.getReason = function () {
    if (this._65 === 3) {
      return this._55.getReason();
    }

    if (!this.isRejected()) {
      throw new Error('Cannot get a rejection reason of a non-rejected promise.');
    }

    return this._55;
  };

  Promise.prototype.getState = function () {
    if (this._65 === 3) {
      return this._55.getState();
    }
    if (this._65 === -1 || this._65 === -2) {
      return 0;
    }

    return this._65;
  };
};

Promise.disableSynchronous = function() {
  Promise.prototype.isPending = undefined;
  Promise.prototype.isFulfilled = undefined;
  Promise.prototype.isRejected = undefined;
  Promise.prototype.getValue = undefined;
  Promise.prototype.getReason = undefined;
  Promise.prototype.getState = undefined;
};


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(1256);
var parse = __webpack_require__(1257);
var formats = __webpack_require__(657);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(361);
var formats = __webpack_require__(657);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    formatter,
    encodeValuesOnly,
    charset
) {
    var obj = object;
    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = obj.join(',');
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key') : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key');
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value'))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        if (isArray(obj)) {
            pushToArray(values, stringify(
                obj[key],
                typeof generateArrayPrefix === 'function' ? generateArrayPrefix(prefix, key) : prefix,
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly,
                charset
            ));
        } else {
            pushToArray(values, stringify(
                obj[key],
                prefix + (allowDots ? '.' + key : '[' + key + ']'),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly,
                charset
            ));
        }
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.encoder !== null && opts.encoder !== undefined && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.formatter,
            options.encodeValuesOnly,
            options.charset
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(361);

var has = Object.prototype.hasOwnProperty;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = options.decoder(part.slice(pos + 1), defaults.decoder, charset, 'value');
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (val && options.comma && val.indexOf(',') > -1) {
            val = val.split(',');
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options) {
    var leaf = val;

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new Error('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options);
        obj = utils.merge(obj, newObj, options);
    }

    return utils.compact(obj);
};


/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_PRIORITY_100 = exports.MIN_PRIORITY_0 = void 0;
var MIN_PRIORITY_0 = 0;
exports.MIN_PRIORITY_0 = MIN_PRIORITY_0;
var MAX_PRIORITY_100 = 100;
exports.MAX_PRIORITY_100 = MAX_PRIORITY_100;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MIN_PRIORITY_0, "MIN_PRIORITY_0", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/validation.js");

  __REACT_HOT_LOADER__.register(MAX_PRIORITY_100, "MAX_PRIORITY_100", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/validation.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MIN_PRIORITY_0, "MIN_PRIORITY_0", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/validation.js");

  __REACT_HOT_LOADER__.register(MAX_PRIORITY_100, "MAX_PRIORITY_100", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/validation.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/constants/validation.js");
}();

;

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchOrganisations = fetchOrganisations;
exports.fetchStatistics = fetchStatistics;
exports.fetchOrganisation = fetchOrganisation;
exports.fetchOrgsSelectOrg = fetchOrgsSelectOrg;
exports.onOrganisationDashboard = onOrganisationDashboard;
exports.saveOrganisation = saveOrganisation;
exports.fetchOrganisationSaga = fetchOrganisationSaga;
exports.fetchOrgsSelectOrgSaga = fetchOrgsSelectOrgSaga;
exports.fetchOrganisationsSaga = fetchOrganisationsSaga;
exports.saveOrganisationSaga = saveOrganisationSaga;
exports.organisationDashboardSaga = organisationDashboardSaga;
exports.organisationStatisticsSaga = organisationStatisticsSaga;
exports["default"] = rootSaga;

var _effects = __webpack_require__(15);

var _Organisation = __webpack_require__(144);

var _ActionTypes = __webpack_require__(7);

var _ApiClient = __webpack_require__(210);

var _ApiConfig = __webpack_require__(145);

var _ApiService = __webpack_require__(16);

var _Authentication = __webpack_require__(42);

var _SurveyService = __webpack_require__(176);

var _auditService = __webpack_require__(358);

var _lodash = __webpack_require__(72);

var _messages = __webpack_require__(362);

var _api = __webpack_require__(25);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(fetchOrganisations),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchStatistics),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchOrganisation),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchOrgsSelectOrg),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(onOrganisationDashboard),
    _marked6 =
/*#__PURE__*/
regeneratorRuntime.mark(saveOrganisation),
    _marked7 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchOrganisationSaga),
    _marked8 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchOrgsSelectOrgSaga),
    _marked9 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchOrganisationsSaga),
    _marked10 =
/*#__PURE__*/
regeneratorRuntime.mark(saveOrganisationSaga),
    _marked11 =
/*#__PURE__*/
regeneratorRuntime.mark(organisationDashboardSaga),
    _marked12 =
/*#__PURE__*/
regeneratorRuntime.mark(organisationStatisticsSaga),
    _marked13 =
/*#__PURE__*/
regeneratorRuntime.mark(rootSaga);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var fetchOrganisationsRequest =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee() {
    var organisations;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _ApiService.fetchDataRequest)('organisations');

          case 2:
            organisations = _context.sent;
            return _context.abrupt("return", organisations);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchOrganisationsRequest() {
    return _ref.apply(this, arguments);
  };
}();

function fetchOrganisations() {
  var fetchedOrganisations;
  return regeneratorRuntime.wrap(function fetchOrganisations$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.call)(fetchOrganisationsRequest) || [];

        case 3:
          fetchedOrganisations = _context2.sent;
          _context2.next = 6;
          return (0, _effects.put)((0, _Organisation.fetchOrgsSuccess)(fetchedOrganisations));

        case 6:
          _context2.next = 12;
          break;

        case 8:
          _context2.prev = 8;
          _context2.t0 = _context2["catch"](0);
          _context2.next = 12;
          return (0, _effects.put)((0, _Organisation.showOrgMessage)(_context2.t0.messages));

        case 12:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked, null, [[0, 8]]);
}

var fetchStatisticsRequest =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(selectedOrgId) {
    var statistics;
    return regeneratorRuntime.wrap(function _callee2$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return (0, _ApiService.fetchDataRequest)(_api.ORGANISATION_STATISTICS, ['orgid'], [selectedOrgId]);

          case 2:
            statistics = _context3.sent;
            return _context3.abrupt("return", statistics);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchStatisticsRequest(_x) {
    return _ref2.apply(this, arguments);
  };
}();

function fetchStatistics(_ref3) {
  var payload, fetchedStatistics;
  return regeneratorRuntime.wrap(function fetchStatistics$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _ref3.payload;
          _context4.prev = 1;
          _context4.next = 4;
          return (0, _effects.call)(fetchStatisticsRequest, payload) || {};

        case 4:
          fetchedStatistics = _context4.sent;
          _context4.next = 7;
          return (0, _effects.put)((0, _Organisation.fetchOrgStatisticsSuccess)(fetchedStatistics));

        case 7:
          _context4.next = 13;
          break;

        case 9:
          _context4.prev = 9;
          _context4.t0 = _context4["catch"](1);
          _context4.next = 13;
          return (0, _effects.put)((0, _Organisation.showOrgMessage)(_context4.t0.messages));

        case 13:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked2, null, [[1, 9]]);
}

var fetchOrganisationRequest =
/*#__PURE__*/
function () {
  var _ref4 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(orgid) {
    var orgs, filteredByOrgid;
    return regeneratorRuntime.wrap(function _callee3$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return fetchOrganisationsRequest();

          case 2:
            orgs = _context5.sent;

            if (!orgs) {
              _context5.next = 7;
              break;
            }

            filteredByOrgid = orgs.filter(function (org) {
              return org.id === orgid;
            });

            if (!(filteredByOrgid && filteredByOrgid.length > 0)) {
              _context5.next = 7;
              break;
            }

            return _context5.abrupt("return", filteredByOrgid[0]);

          case 7:
            return _context5.abrupt("return", {});

          case 8:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee3);
  }));

  return function fetchOrganisationRequest(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

function fetchOrganisation(_ref5) {
  var payload, fetchedOrganisation;
  return regeneratorRuntime.wrap(function fetchOrganisation$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          payload = _ref5.payload;
          _context6.prev = 1;
          _context6.next = 4;
          return (0, _effects.call)(fetchOrganisationRequest, payload) || {};

        case 4:
          fetchedOrganisation = _context6.sent;
          _context6.next = 7;
          return (0, _effects.put)((0, _Organisation.fetchOrgSuccess)(fetchedOrganisation));

        case 7:
          _context6.next = 13;
          break;

        case 9:
          _context6.prev = 9;
          _context6.t0 = _context6["catch"](1);
          _context6.next = 13;
          return (0, _effects.put)((0, _Organisation.showOrgMessage)(_context6.t0.messages));

        case 13:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked3, null, [[1, 9]]);
}

function fetchOrgsSelectOrg(_ref6) {
  var payload, fetchedOrganisation, fetchedOrganisations, filteredByOrgid;
  return regeneratorRuntime.wrap(function fetchOrgsSelectOrg$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          payload = _ref6.payload;
          _context7.prev = 1;
          fetchedOrganisation = {};
          _context7.next = 5;
          return (0, _effects.call)(fetchOrganisationsRequest) || [];

        case 5:
          fetchedOrganisations = _context7.sent;

          if (fetchedOrganisations) {
            filteredByOrgid = fetchedOrganisations.filter(function (org) {
              return org.id === payload;
            });

            if (filteredByOrgid && filteredByOrgid.length > 0) {
              fetchedOrganisation = filteredByOrgid[0];
            }
          }

          _context7.next = 9;
          return (0, _effects.put)((0, _Organisation.fetchOrgsSuccess)(fetchedOrganisations));

        case 9:
          _context7.next = 11;
          return (0, _effects.put)((0, _Organisation.fetchOrgSuccess)(fetchedOrganisation));

        case 11:
          _context7.next = 17;
          break;

        case 13:
          _context7.prev = 13;
          _context7.t0 = _context7["catch"](1);
          _context7.next = 17;
          return (0, _effects.put)((0, _Organisation.showOrgMessage)(_context7.t0.messages));

        case 17:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked4, null, [[1, 13]]);
}

var currentOrg = function currentOrg(state) {
  return state.orgs.selectedOrg;
};

function onOrganisationDashboard() {
  var selectedOrg, inactiveSurveys, activeSurveys, activeOrgSurveysSimpleChartData, inactiveOrgSurveysSimpleChartData, orgSurveyAnswerSagaCall, orgSurveyAnswers, simpleChartData, _orgSurveyAnswerSagaCall, _orgSurveyAnswers, _simpleChartData, orgDashboardData;

  return regeneratorRuntime.wrap(function onOrganisationDashboard$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.prev = 0;
          _context8.next = 3;
          return (0, _effects.select)(currentOrg);

        case 3:
          selectedOrg = _context8.sent;
          inactiveSurveys = (0, _SurveyService.getInactiveSurveys)(selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.surveys);
          activeSurveys = (0, _SurveyService.getActiveSurveys)(selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.surveys);
          activeOrgSurveysSimpleChartData = [];
          inactiveOrgSurveysSimpleChartData = [];

          if (!((activeSurveys === null || activeSurveys === void 0 ? void 0 : activeSurveys.length) > 0)) {
            _context8.next = 22;
            break;
          }

          _context8.next = 11;
          return (0, _effects.call)(_SurveyService.prepareOrgSurveyAnswerSagaCall, activeSurveys, selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id);

        case 11:
          orgSurveyAnswerSagaCall = _context8.sent;

          if (!orgSurveyAnswerSagaCall) {
            _context8.next = 18;
            break;
          }

          _context8.next = 15;
          return orgSurveyAnswerSagaCall;

        case 15:
          _context8.t0 = _context8.sent;
          _context8.next = 19;
          break;

        case 18:
          _context8.t0 = [];

        case 19:
          orgSurveyAnswers = _context8.t0;
          simpleChartData = (0, _SurveyService.extractOrgSurveySimpleChartData)(orgSurveyAnswers); // now add the other survey statistics for the reports/ graphs
          // TODO get real data for the graphs

          activeOrgSurveysSimpleChartData = simpleChartData.map(function (chartData) {
            return {
              surveyName: 'test',
              surveyEndDate: '08/08/2020',
              surveyStartDate: '07/07/2018',
              noEmployeesInvited: 1,
              noQuestionsCompleted: 194,
              noQuestionsToComplete: 395,
              simpleChartData: chartData === null || chartData === void 0 ? void 0 : chartData.data,
              surveyActive: true
            };
          });

        case 22:
          if (!((inactiveSurveys === null || inactiveSurveys === void 0 ? void 0 : inactiveSurveys.length) > 0)) {
            _context8.next = 36;
            break;
          }

          _context8.next = 25;
          return (0, _effects.call)(_SurveyService.prepareOrgSurveyAnswerSagaCall, inactiveSurveys, selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id);

        case 25:
          _orgSurveyAnswerSagaCall = _context8.sent;

          if (!_orgSurveyAnswerSagaCall) {
            _context8.next = 32;
            break;
          }

          _context8.next = 29;
          return _orgSurveyAnswerSagaCall;

        case 29:
          _context8.t1 = _context8.sent;
          _context8.next = 33;
          break;

        case 32:
          _context8.t1 = [];

        case 33:
          _orgSurveyAnswers = _context8.t1;
          _simpleChartData = (0, _SurveyService.extractOrgSurveySimpleChartData)(_orgSurveyAnswers); // now add the other survey statistics for the reports/ graphs

          inactiveOrgSurveysSimpleChartData = _simpleChartData.map(function (chartData) {
            return {
              surveyName: 'test',
              surveyEndDate: '08/08/2020',
              surveyStartDate: '07/07/2018',
              noEmployeesInvited: 1,
              noQuestionsCompleted: 194,
              noQuestionsToComplete: 395,
              simpleChartData: chartData === null || chartData === void 0 ? void 0 : chartData.data,
              surveyActive: false
            };
          });

        case 36:
          // get the linechart data and the survey takeup data and present as one object for the dashboard to consume
          orgDashboardData = {
            activeOrgSurveysSimpleChartData: activeOrgSurveysSimpleChartData,
            inactiveOrgSurveysSimpleChartData: inactiveOrgSurveysSimpleChartData
          };
          _context8.next = 39;
          return (0, _effects.put)((0, _Organisation.onOrgDashboardSuccess)(orgDashboardData));

        case 39:
          _context8.next = 45;
          break;

        case 41:
          _context8.prev = 41;
          _context8.t2 = _context8["catch"](0);
          _context8.next = 45;
          return (0, _effects.put)((0, _Organisation.showOrgMessage)(_context8.t2.messages));

        case 45:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked5, null, [[0, 41]]);
}

var getOrgList = function getOrgList(state) {
  return state.orgs.orgList;
};

function saveOrganisation(_ref7) {
  var payload, allOrgs, savedOrganisations;
  return regeneratorRuntime.wrap(function saveOrganisation$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          payload = _ref7.payload;
          _context9.prev = 1;
          _context9.next = 4;
          return (0, _effects.select)(getOrgList);

        case 4:
          allOrgs = _context9.sent;
          _context9.next = 7;
          return (0, _effects.call)(saveOrganisationRequest, allOrgs, payload);

        case 7:
          savedOrganisations = _context9.sent;
          _context9.next = 10;
          return (0, _effects.put)((0, _Organisation.onSaveOrgSuccess)(savedOrganisations));

        case 10:
          _context9.next = 21;
          break;

        case 12:
          _context9.prev = 12;
          _context9.t0 = _context9["catch"](1);

          if (!(typeof _context9.t0 === 'string')) {
            _context9.next = 19;
            break;
          }

          _context9.next = 17;
          return (0, _effects.put)((0, _Organisation.showOrgMessage)(_context9.t0));

        case 17:
          _context9.next = 21;
          break;

        case 19:
          _context9.next = 21;
          return (0, _effects.put)((0, _Organisation.showOrgMessage)(_context9.t0.messages));

        case 21:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked6, null, [[1, 12]]);
}

var saveOrganisationRequest =
/*#__PURE__*/
function () {
  var _ref8 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee4(allOrgs, payload) {
    var isNew, currentOrgState, updatedPayload, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, org, endpointConfig, newPayload, changedState;

    return regeneratorRuntime.wrap(function _callee4$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.prev = 0;
            isNew = true;
            currentOrgState = {};
            updatedPayload = _objectSpread({}, payload);
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context10.prev = 7;
            _iterator = allOrgs[Symbol.iterator]();

          case 9:
            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
              _context10.next = 17;
              break;
            }

            org = _step.value;

            if (!(org.id === payload.id)) {
              _context10.next = 14;
              break;
            }

            isNew = false;
            return _context10.abrupt("break", 17);

          case 14:
            _iteratorNormalCompletion = true;
            _context10.next = 9;
            break;

          case 17:
            _context10.next = 23;
            break;

          case 19:
            _context10.prev = 19;
            _context10.t0 = _context10["catch"](7);
            _didIteratorError = true;
            _iteratorError = _context10.t0;

          case 23:
            _context10.prev = 23;
            _context10.prev = 24;

            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
              _iterator["return"]();
            }

          case 26:
            _context10.prev = 26;

            if (!_didIteratorError) {
              _context10.next = 29;
              break;
            }

            throw _iteratorError;

          case 29:
            return _context10.finish(26);

          case 30:
            return _context10.finish(23);

          case 31:
            endpointConfig = isNew ? (0, _ApiConfig.endpoint)(_api.ADD_ORGANISATION) : (0, _ApiConfig.endpoint)(_api.UPDATE_ORGANISATION);

            if (!isNew) {
              _context10.next = 39;
              break;
            } // const _id = new Date().getUTCMilliseconds().toString().concat(new Date().getTime().toString()).toString();
            // eslint-disable-next-line no-unused-vars
            // const { password, ...noPassword } = payload


            newPayload = _objectSpread({}, payload, {
              password: 'testtest',
              registerorg: true
            }); // will be using passwordless so dummy password will work

            if (!endpointConfig) {
              _context10.next = 37;
              break;
            }

            _context10.next = 37;
            return (0, _ApiClient.post)(endpointConfig.uri, newPayload).then(function (response) {
              // the response will return a token with the id so place it back into the local object
              var id = response ? (0, _Authentication.extractTokenId)(response.token) : 'addOrgResponseError';
              updatedPayload = _objectSpread({}, newPayload, {
                id: id
              }); // orgList.push(updatedPayload);
            })["catch"](function (error) {
              throw error;
            });

          case 37:
            _context10.next = 47;
            break;

          case 39:
            if (!endpointConfig) {
              _context10.next = 47;
              break;
            }

            if ((0, _lodash.isEqual)(currentOrgState, payload)) {
              _context10.next = 46;
              break;
            }

            changedState = (0, _auditService.objectStateComparator)([currentOrgState], [payload]);
            _context10.next = 44;
            return (0, _ApiClient.update)(endpointConfig.uri, payload, (0, _auditService.auditLogHeaderEntry)(changedState)).then(function (payload) {
              return payload;
            }) // already in orgList
            ["catch"](function (error) {
              throw error;
            });

          case 44:
            _context10.next = 47;
            break;

          case 46:
            throw _messages.DATA_NOT_CHANGED_SO_NOT_UPDATED;

          case 47:
            return _context10.abrupt("return", updatedPayload);

          case 50:
            _context10.prev = 50;
            _context10.t1 = _context10["catch"](0);
            throw _context10.t1;

          case 53:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee4, null, [[0, 50], [7, 19, 23, 31], [24,, 26, 30]]);
  }));

  return function saveOrganisationRequest(_x3, _x4) {
    return _ref8.apply(this, arguments);
  };
}();

function fetchOrganisationSaga() {
  return regeneratorRuntime.wrap(function fetchOrganisationSaga$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_ORG, fetchOrganisation);

        case 2:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked7);
}

function fetchOrgsSelectOrgSaga() {
  return regeneratorRuntime.wrap(function fetchOrgsSelectOrgSaga$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_ORGS_SELECT_ORG, fetchOrgsSelectOrg);

        case 2:
        case "end":
          return _context12.stop();
      }
    }
  }, _marked8);
}

function fetchOrganisationsSaga() {
  return regeneratorRuntime.wrap(function fetchOrganisationsSaga$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_ALL_ORG, fetchOrganisations);

        case 2:
        case "end":
          return _context13.stop();
      }
    }
  }, _marked9);
}

function saveOrganisationSaga() {
  return regeneratorRuntime.wrap(function saveOrganisationSaga$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_SAVE_ORG, saveOrganisation);

        case 2:
        case "end":
          return _context14.stop();
      }
    }
  }, _marked10);
}

function organisationDashboardSaga() {
  return regeneratorRuntime.wrap(function organisationDashboardSaga$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_ORG_DASHBOARD, onOrganisationDashboard);

        case 2:
        case "end":
          return _context15.stop();
      }
    }
  }, _marked11);
}

function organisationStatisticsSaga() {
  return regeneratorRuntime.wrap(function organisationStatisticsSaga$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_ORG_STATISTICS, fetchStatistics);

        case 2:
        case "end":
          return _context16.stop();
      }
    }
  }, _marked12);
}

function rootSaga() {
  return regeneratorRuntime.wrap(function rootSaga$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return (0, _effects.all)([(0, _effects.fork)(organisationStatisticsSaga), (0, _effects.fork)(fetchOrganisationsSaga), (0, _effects.fork)(saveOrganisationSaga), (0, _effects.fork)(fetchOrganisationSaga), (0, _effects.fork)(organisationDashboardSaga), (0, _effects.fork)(fetchOrgsSelectOrgSaga)]);

        case 2:
        case "end":
          return _context17.stop();
      }
    }
  }, _marked13);
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchOrganisationsRequest, "fetchOrganisationsRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(fetchOrganisations, "fetchOrganisations", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(fetchStatisticsRequest, "fetchStatisticsRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(fetchStatistics, "fetchStatistics", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(fetchOrganisationRequest, "fetchOrganisationRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(fetchOrganisation, "fetchOrganisation", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(fetchOrgsSelectOrg, "fetchOrgsSelectOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(onOrganisationDashboard, "onOrganisationDashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(getOrgList, "getOrgList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(saveOrganisation, "saveOrganisation", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(saveOrganisationRequest, "saveOrganisationRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(fetchOrganisationSaga, "fetchOrganisationSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(fetchOrgsSelectOrgSaga, "fetchOrgsSelectOrgSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(fetchOrganisationsSaga, "fetchOrganisationsSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(saveOrganisationSaga, "saveOrganisationSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(organisationDashboardSaga, "organisationDashboardSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(organisationStatisticsSaga, "organisationStatisticsSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(_marked, "_marked", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(_marked2, "_marked2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(_marked3, "_marked3", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(_marked4, "_marked4", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(_marked5, "_marked5", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(_marked6, "_marked6", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(_marked7, "_marked7", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(_marked8, "_marked8", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(_marked9, "_marked9", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(_marked10, "_marked10", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(_marked11, "_marked11", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(_marked12, "_marked12", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(_marked13, "_marked13", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(asyncGeneratorStep, "asyncGeneratorStep", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(_asyncToGenerator, "_asyncToGenerator", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(fetchOrganisationsRequest, "fetchOrganisationsRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(fetchOrganisations, "fetchOrganisations", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(fetchStatisticsRequest, "fetchStatisticsRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(fetchStatistics, "fetchStatistics", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(fetchOrganisationRequest, "fetchOrganisationRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(fetchOrganisation, "fetchOrganisation", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(fetchOrgsSelectOrg, "fetchOrgsSelectOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(onOrganisationDashboard, "onOrganisationDashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(getOrgList, "getOrgList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(saveOrganisation, "saveOrganisation", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(saveOrganisationRequest, "saveOrganisationRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(fetchOrganisationSaga, "fetchOrganisationSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(fetchOrgsSelectOrgSaga, "fetchOrgsSelectOrgSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(fetchOrganisationsSaga, "fetchOrganisationsSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(saveOrganisationSaga, "saveOrganisationSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(organisationDashboardSaga, "organisationDashboardSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(organisationStatisticsSaga, "organisationStatisticsSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Organisation.js");
}();

;

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchNotifications = fetchNotifications;
exports.fetchEmployeesSaga = fetchEmployeesSaga;
exports.saveEmployeeSaga = saveEmployeeSaga;
exports.fetchEmpSurveyAnswersSaga = fetchEmpSurveyAnswersSaga;
exports.saveEmpSurveyAnswersSaga = saveEmpSurveyAnswersSaga;
exports.fetchEmpNotificationsSaga = fetchEmpNotificationsSaga;
exports.addFavouriteEmployeeSaga = addFavouriteEmployeeSaga;
exports["default"] = rootSaga;

var _effects = __webpack_require__(15);

var _Employee = __webpack_require__(173);

var _OrgSurveyAnswers = __webpack_require__(211);

var _Survey = __webpack_require__(260);

var _SurveyGroup = __webpack_require__(177);

var _SurveyQuestion = __webpack_require__(261);

var _ActionTypes = __webpack_require__(7);

var _ApiClient = __webpack_require__(210);

var _ApiConfig = __webpack_require__(145);

var _Authentication = __webpack_require__(42);

var _SurveyService = __webpack_require__(176);

var _ApiService = __webpack_require__(16);

var _auditService = __webpack_require__(358);

var _lodash = __webpack_require__(72);

var _messages = __webpack_require__(362);

var _api = __webpack_require__(25);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(fetchNotifications),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchEmployees),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(saveEmployee),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchEmpSurveyAnswers),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(saveEmpSurveyAnswers),
    _marked6 =
/*#__PURE__*/
regeneratorRuntime.mark(addFavouriteEmployee),
    _marked7 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchEmployeesSaga),
    _marked8 =
/*#__PURE__*/
regeneratorRuntime.mark(saveEmployeeSaga),
    _marked9 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchEmpSurveyAnswersSaga),
    _marked10 =
/*#__PURE__*/
regeneratorRuntime.mark(saveEmpSurveyAnswersSaga),
    _marked11 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchEmpNotificationsSaga),
    _marked12 =
/*#__PURE__*/
regeneratorRuntime.mark(addFavouriteEmployeeSaga),
    _marked13 =
/*#__PURE__*/
regeneratorRuntime.mark(rootSaga);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var orgStatisticsData = function orgStatisticsData(state) {
  return state.orgs.orgStatisticsData;
};

var currentOrg = function currentOrg(state) {
  return state.orgs.selectedOrg;
}; // TODO add defaults if null passed for time and icon


var createNotification = function createNotification(image, title, time, icon) {
  return {
    image: image,
    title: title,
    time: time,
    icon: icon
  };
};

var fetchNotificationsRequest =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(identity, orgStatistics) {
    var notifications;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            notifications = []; // const statistics = await fetchDataRequest('organisationNotifications', ['orgid'], [selectedOrgId]);

            notifications.push(createNotification('assets/images/notification-150_150.jpg', identity.name, '1:20 PM', 'zmdi-view-day text-grey'));

            if ((0, _Authentication.isAdmin)()) {
              notifications.push(createNotification('assets/images/notification-150_150.jpg', 'Number of current projects = '.concat((orgStatistics === null || orgStatistics === void 0 ? void 0 : orgStatistics.projectCount) || 0), '1:20 PM', 'zmdi-comment-text text-grey'));

              if ((orgStatistics === null || orgStatistics === void 0 ? void 0 : orgStatistics.projectsWithSameDate) === 0) {
                notifications.push(createNotification('assets/images/notification-150_150.jpg', 'Number of imported projects that have not been updated = '.concat(orgStatistics === null || orgStatistics === void 0 ? void 0 : orgStatistics.projectsWithSameDate), '1:20 PM', 'zmdi-calendar text-grey'));
              }

              if ((orgStatistics === null || orgStatistics === void 0 ? void 0 : orgStatistics.projectsWithNoPriorities) === 0) {
                notifications.push(createNotification('assets/images/notification-150_150.jpg', 'Number of projects without priorities = '.concat(orgStatistics === null || orgStatistics === void 0 ? void 0 : orgStatistics.projectsWithNoPriorities), '1:20 PM', 'zmdi-blur-off text-grey'));
              }
            }

            return _context.abrupt("return", notifications);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchNotificationsRequest(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

function fetchNotifications(_ref2) {
  var payload, orgStatistics, fetchedNotifications;
  return regeneratorRuntime.wrap(function fetchNotifications$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _ref2.payload;
          _context2.prev = 1;
          _context2.next = 4;
          return (0, _effects.select)(orgStatisticsData);

        case 4:
          orgStatistics = _context2.sent;
          _context2.next = 7;
          return (0, _effects.call)(fetchNotificationsRequest, payload, orgStatistics) || {};

        case 7:
          fetchedNotifications = _context2.sent;
          _context2.next = 10;
          return (0, _effects.put)((0, _Employee.fetchNotificationsSuccess)(fetchedNotifications));

        case 10:
          _context2.next = 16;
          break;

        case 12:
          _context2.prev = 12;
          _context2.t0 = _context2["catch"](1);
          _context2.next = 16;
          return (0, _effects.put)((0, _Employee.showEmpMessage)(_context2.t0.messages));

        case 16:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked, null, [[1, 12]]);
}

var fetchEmployeesRequest =
/*#__PURE__*/
function () {
  var _ref3 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(selectedOrgId) {
    var employees;
    return regeneratorRuntime.wrap(function _callee2$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return (0, _ApiService.fetchDataRequest)(_api.EMPLOYEE_FETCH_ENDPOINT, [_api.ORGID_PATH_PARAM], [selectedOrgId]);

          case 2:
            employees = _context3.sent;
            return _context3.abrupt("return", employees);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchEmployeesRequest(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

function fetchEmployees() {
  var selectedOrg, fetchedEmployees;
  return regeneratorRuntime.wrap(function fetchEmployees$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return (0, _effects.select)(currentOrg);

        case 3:
          selectedOrg = _context4.sent;
          _context4.next = 6;
          return (0, _effects.call)(fetchEmployeesRequest, selectedOrg.id) || [];

        case 6:
          fetchedEmployees = _context4.sent;
          _context4.next = 9;
          return (0, _effects.put)((0, _Employee.fetchEmpsSuccess)(fetchedEmployees));

        case 9:
          _context4.next = 15;
          break;

        case 11:
          _context4.prev = 11;
          _context4.t0 = _context4["catch"](0);
          _context4.next = 15;
          return (0, _effects.put)((0, _Employee.showEmpMessage)(_context4.t0.messages));

        case 15:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked2, null, [[0, 11]]);
}

var getEmpList = function getEmpList(state) {
  return state.emps.empList;
};

function saveEmployee(_ref4) {
  var payload, selectedOrg, allEmps, savedEmployees;
  return regeneratorRuntime.wrap(function saveEmployee$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = _ref4.payload;
          _context5.prev = 1;
          _context5.next = 4;
          return (0, _effects.select)(currentOrg);

        case 4:
          selectedOrg = _context5.sent;
          _context5.next = 7;
          return (0, _effects.select)(getEmpList);

        case 7:
          allEmps = _context5.sent;
          _context5.next = 10;
          return (0, _effects.call)(saveEmployeeRequest, allEmps, selectedOrg, payload);

        case 10:
          savedEmployees = _context5.sent;
          _context5.next = 13;
          return (0, _effects.put)((0, _Employee.onSaveEmpSuccess)(savedEmployees));

        case 13:
          _context5.next = 19;
          break;

        case 15:
          _context5.prev = 15;
          _context5.t0 = _context5["catch"](1);
          _context5.next = 19;
          return (0, _effects.put)((0, _Employee.showEmpMessage)(_context5.t0.messages));

        case 19:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked3, null, [[1, 15]]);
}

var saveEmployeeRequest =
/*#__PURE__*/
function () {
  var _ref5 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(allEmps, selectedOrg, payload) {
    var isNew, currentEmpState, updatedPayload, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, emp, endpointConfig, newPayload, changedState, uri;

    return regeneratorRuntime.wrap(function _callee3$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            isNew = true;
            currentEmpState = {};
            updatedPayload = _objectSpread({}, payload);
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context6.prev = 7;
            _iterator = allEmps[Symbol.iterator]();

          case 9:
            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
              _context6.next = 17;
              break;
            }

            emp = _step.value;

            if (!(emp.id === payload.id)) {
              _context6.next = 14;
              break;
            }

            isNew = false;
            return _context6.abrupt("break", 17);

          case 14:
            _iteratorNormalCompletion = true;
            _context6.next = 9;
            break;

          case 17:
            _context6.next = 23;
            break;

          case 19:
            _context6.prev = 19;
            _context6.t0 = _context6["catch"](7);
            _didIteratorError = true;
            _iteratorError = _context6.t0;

          case 23:
            _context6.prev = 23;
            _context6.prev = 24;

            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
              _iterator["return"]();
            }

          case 26:
            _context6.prev = 26;

            if (!_didIteratorError) {
              _context6.next = 29;
              break;
            }

            throw _iteratorError;

          case 29:
            return _context6.finish(26);

          case 30:
            return _context6.finish(23);

          case 31:
            endpointConfig = isNew ? (0, _ApiConfig.endpoint)(_api.EMPLOYEE_ADD_ENDPOINT) : (0, _ApiConfig.endpoint)(_api.EMPLOYEE_UPDATE_ENDPOINT);

            if (!isNew) {
              _context6.next = 39;
              break;
            } // eslint-disable-next-line no-unused-vars


            newPayload = _objectSpread({}, payload, {
              password: (0, _Authentication.generateGuid)(),
              registerorg: false,
              orgid: selectedOrg.id
            }); // will be using passwordless so password wont do anything

            if (!endpointConfig) {
              _context6.next = 37;
              break;
            }

            _context6.next = 37;
            return (0, _ApiClient.post)(endpointConfig.uri, newPayload).then(function (response) {
              // the response will return a token with the id so place it back into the local object
              var id = response ? (0, _Authentication.extractTokenId)(response.token) : 'addEmpResponseError';
              updatedPayload = _objectSpread({}, newPayload, {
                id: id
              }); // empList.push(updatedPayload);
            })["catch"](function (error) {
              throw error;
            });

          case 37:
            _context6.next = 48;
            break;

          case 39:
            if (!endpointConfig) {
              _context6.next = 48;
              break;
            }

            if ((0, _lodash.isEqual)(currentEmpState, payload)) {
              _context6.next = 47;
              break;
            }

            changedState = (0, _auditService.objectStateComparator)([currentEmpState], [payload]);
            uri = endpointConfig.uri.replace('{orgid}', selectedOrg.id);
            _context6.next = 45;
            return (0, _ApiClient.update)(uri, payload, (0, _auditService.auditLogHeaderEntry)(changedState)).then(function (payload) {
              return payload;
            }) // already in empList
            ["catch"](function (error) {
              throw error;
            });

          case 45:
            _context6.next = 48;
            break;

          case 47:
            throw _messages.DATA_NOT_CHANGED_SO_NOT_UPDATED;

          case 48:
            return _context6.abrupt("return", updatedPayload);

          case 51:
            _context6.prev = 51;
            _context6.t1 = _context6["catch"](0);
            throw _context6.t1;

          case 54:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee3, null, [[0, 51], [7, 19, 23, 31], [24,, 26, 30]]);
  }));

  return function saveEmployeeRequest(_x4, _x5, _x6) {
    return _ref5.apply(this, arguments);
  };
}();

var fetchSurveys =
/*#__PURE__*/
function () {
  var _ref6 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee4() {
    return regeneratorRuntime.wrap(function _callee4$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return (0, _ApiService.fetchDataRequest)('surveys');

          case 2:
            return _context7.abrupt("return", _context7.sent);

          case 3:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee4);
  }));

  return function fetchSurveys() {
    return _ref6.apply(this, arguments);
  };
}();

var fetchSurveyGroups =
/*#__PURE__*/
function () {
  var _ref7 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee5() {
    return regeneratorRuntime.wrap(function _callee5$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return (0, _ApiService.fetchDataRequest)('surveyGroups');

          case 2:
            return _context8.abrupt("return", _context8.sent);

          case 3:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee5);
  }));

  return function fetchSurveyGroups() {
    return _ref7.apply(this, arguments);
  };
}();

var fetchSurveyQuestions =
/*#__PURE__*/
function () {
  var _ref8 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee6() {
    return regeneratorRuntime.wrap(function _callee6$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return (0, _ApiService.fetchDataRequest)('surveyQuestions');

          case 2:
            return _context9.abrupt("return", _context9.sent);

          case 3:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee6);
  }));

  return function fetchSurveyQuestions() {
    return _ref8.apply(this, arguments);
  };
}();
/**
 * called when the survey starts - NOTE the survey will exist in the org
 * if the emp answers do not exist then they will be created (on first time accessed for an org)
 * then update the selected org survey answers for a future update
 * return the questionAnswers object
 * @param {*} param0 - action.payload = { orgSurveyId, surveyId }
 */


function fetchEmpSurveyAnswers(_ref9) {
  var payload, orgId, empId, orgSurveyId, surveyId, surveys, surveyGroups, surveyQuestions, answers, orgSurveyAnswers, empSurveyAnswers, filteredEmpSurveyAnswers, survey, builtEmpSurveyAnswers, updatedOrgSurveyAnswers;
  return regeneratorRuntime.wrap(function fetchEmpSurveyAnswers$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          payload = _ref9.payload; // payload = surveyId

          orgId = (0, _Authentication.getIdentityOrgId)();
          empId = (0, _Authentication.getIdentityId)();
          orgSurveyId = payload.orgSurveyId, surveyId = payload.surveyId;
          _context10.prev = 4;
          _context10.next = 7;
          return (0, _effects.call)(fetchSurveys);

        case 7:
          surveys = _context10.sent;
          _context10.next = 10;
          return (0, _effects.put)((0, _Survey.fetchSurveysSuccess)(surveys));

        case 10:
          _context10.next = 12;
          return (0, _effects.call)(fetchSurveyGroups);

        case 12:
          surveyGroups = _context10.sent;
          _context10.next = 15;
          return (0, _effects.put)((0, _SurveyGroup.fetchSurveyGroupsSuccess)(surveyGroups));

        case 15:
          _context10.next = 17;
          return (0, _effects.call)(fetchSurveyQuestions);

        case 17:
          surveyQuestions = _context10.sent;
          _context10.next = 20;
          return (0, _effects.put)((0, _SurveyQuestion.fetchSurveyQuestionsSuccess)(surveyQuestions));

        case 20:
          _context10.next = 22;
          return (0, _effects.call)(_ApiService.fetchDataRequest, _api.ORG_SURVEY_ANSWERS_ENDPOINT, [_api.ORGID_PATH_PARAM, 'orgSurveyId'], [orgId, orgSurveyId]) || {};

        case 22:
          answers = _context10.sent;
          orgSurveyAnswers = (answers === null || answers === void 0 ? void 0 : answers.length) > 0 ? answers[0] : answers;

          if (!(Object.keys(orgSurveyAnswers).length > 0)) {
            _context10.next = 55;
            break;
          } // need to extract the employees answers from the org survey answers and add to the store


          empSurveyAnswers = {};

          if (!(orgSurveyAnswers === null || orgSurveyAnswers === void 0 ? void 0 : orgSurveyAnswers.questionAnswers)) {
            _context10.next = 49;
            break;
          }

          _context10.next = 29;
          return (0, _effects.call)(_SurveyService.getEmpSurveyAnswers, orgSurveyAnswers, empId);

        case 29:
          filteredEmpSurveyAnswers = _context10.sent;

          if (!((filteredEmpSurveyAnswers === null || filteredEmpSurveyAnswers === void 0 ? void 0 : filteredEmpSurveyAnswers.length) === 0)) {
            _context10.next = 48;
            break;
          }

          _context10.next = 33;
          return (0, _effects.call)(_SurveyService.getSurveyById, surveys, surveyId);

        case 33:
          survey = _context10.sent;
          builtEmpSurveyAnswers = {};

          if (!survey) {
            _context10.next = 39;
            break;
          }

          _context10.next = 38;
          return (0, _effects.call)(_SurveyService.buildEmpSurveyAnswers, survey, surveyGroups);

        case 38:
          builtEmpSurveyAnswers = _context10.sent;

        case 39:
          empSurveyAnswers = {
            empId: empId,
            answers: builtEmpSurveyAnswers
          }; // add to the local object and then update the org survey answers data table

          orgSurveyAnswers.questionAnswers.push(empSurveyAnswers);
          _context10.next = 43;
          return (0, _effects.call)(saveEmpSurveyAnswerRequest, orgSurveyAnswers, empSurveyAnswers);

        case 43:
          updatedOrgSurveyAnswers = _context10.sent;
          _context10.next = 46;
          return (0, _effects.put)((0, _OrgSurveyAnswers.onSaveOrgSurveyAnswers)(updatedOrgSurveyAnswers));

        case 46:
          _context10.next = 49;
          break;

        case 48:
          empSurveyAnswers = filteredEmpSurveyAnswers[0];

        case 49:
          _context10.next = 51;
          return (0, _effects.put)((0, _OrgSurveyAnswers.fetchOrgSurveyAnswersSuccess)(orgSurveyAnswers));

        case 51:
          _context10.next = 53;
          return (0, _effects.put)((0, _Employee.fetchEmpSurveyAnswersSuccess)(empSurveyAnswers));

        case 53:
          _context10.next = 63;
          break;

        case 55:
          _context10.next = 57;
          return (0, _effects.put)((0, _OrgSurveyAnswers.showOrgSurveyAnswersMessage)('Org Survey Answers were not initialised correctly!'));

        case 57:
          _context10.next = 59;
          return (0, _effects.put)((0, _Employee.showEmpMessage)(Array.fill('Org Survey Answers were not initialised correctly!')));

        case 59:
          _context10.next = 61;
          return (0, _effects.put)((0, _OrgSurveyAnswers.hideOrgSurveyAnswersLoader)());

        case 61:
          _context10.next = 63;
          return (0, _effects.put)((0, _Employee.hideEmpLoader)());

        case 63:
          _context10.next = 75;
          break;

        case 65:
          _context10.prev = 65;
          _context10.t0 = _context10["catch"](4);
          _context10.next = 69;
          return (0, _effects.put)((0, _OrgSurveyAnswers.hideOrgSurveyAnswersLoader)());

        case 69:
          _context10.next = 71;
          return (0, _effects.put)((0, _Employee.hideEmpLoader)());

        case 71:
          _context10.next = 73;
          return (0, _effects.put)((0, _OrgSurveyAnswers.showOrgSurveyAnswersMessage)(_context10.t0.messages));

        case 73:
          _context10.next = 75;
          return (0, _effects.put)((0, _Employee.showEmpMessage)(_context10.t0.messages));

        case 75:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked4, null, [[4, 65]]);
}

var getOrgSurveyAnswers = function getOrgSurveyAnswers(state) {
  return state.orgSurveyAnswers.orgSurveyAnswers;
};
/**
 * Simply sets up the payload to pass onto saveOrgSurveyAnswers
 * @param {payload} param0 
 * {
    "empId": "634d1475334f91eeedf1e03b20190525",
    "answers": [
      {
        "questionId": "mission_and_purpose_v1",
        "answer": 4
      },
      ...
    ]
  }
 */


function saveEmpSurveyAnswers(_ref10) {
  var payload, currentOrgSurveyAnswers, updatedOrgSurveyAnswers;
  return regeneratorRuntime.wrap(function saveEmpSurveyAnswers$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          payload = _ref10.payload;
          _context11.prev = 1;
          _context11.next = 4;
          return (0, _effects.select)(getOrgSurveyAnswers);

        case 4:
          currentOrgSurveyAnswers = _context11.sent;
          _context11.next = 7;
          return (0, _effects.call)(saveEmpSurveyAnswerRequest, currentOrgSurveyAnswers, payload);

        case 7:
          updatedOrgSurveyAnswers = _context11.sent;
          _context11.next = 10;
          return (0, _effects.put)((0, _OrgSurveyAnswers.onSaveOrgSurveyAnswers)(updatedOrgSurveyAnswers));

        case 10:
          _context11.next = 16;
          break;

        case 12:
          _context11.prev = 12;
          _context11.t0 = _context11["catch"](1);
          _context11.next = 16;
          return (0, _effects.put)((0, _Employee.showEmpMessage)(_context11.t0.messages));

        case 16:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked5, null, [[1, 12]]);
}
/**
 * 
 * @param {*} currentOrgSurveyAnswers 
 * orgSurveyAnswers
[
    {
        "id": "883r1475334f91eeedf1e03b20190999",
        "orgid": "634d1475334f91eeedf1e03b20190524",
        "surveyId": "dc00cc7175004a68df46359b20190618",
        "questionAnswers": [
            {
                "empId": "634d1475334f91eeedf1e03b20190525",
                "answers": [
                    {"questionId": "mission_and_purpose_v1", "answer": 4},
                    {"questionId": "agile_planning_v1", "answer": 7}
                ]
            }
        ]
    }
]
 * @param {*} payload orgSurveyAnswers.questionAnswers[entry] - entry to replace
 */


var saveEmpSurveyAnswerRequest =
/*#__PURE__*/
function () {
  var _ref11 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee7(currentOrgSurveyAnswers, payload) {
    var orgSurveyAnswersList;
    return regeneratorRuntime.wrap(function _callee7$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.prev = 0;
            orgSurveyAnswersList = currentOrgSurveyAnswers.questionAnswers.map(function (questionAnswer) {
              if (questionAnswer.empId === payload.empId) {
                return payload;
              } else {
                return questionAnswer;
              }
            });
            return _context12.abrupt("return", _objectSpread({}, currentOrgSurveyAnswers, {
              questionAnswers: orgSurveyAnswersList
            }));

          case 5:
            _context12.prev = 5;
            _context12.t0 = _context12["catch"](0);
            throw _context12.t0;

          case 8:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee7, null, [[0, 5]]);
  }));

  return function saveEmpSurveyAnswerRequest(_x7, _x8) {
    return _ref11.apply(this, arguments);
  };
}();
/**
 * This is when the user selects the star on the list page - update the starred attribute of the entity
 * @param {*} param0
 */


function addFavouriteEmployee(_ref12) {
  var payload, allEmps, selectedOrg, filtered, emp, updatedEmp, auditMsg;
  return regeneratorRuntime.wrap(function addFavouriteEmployee$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          payload = _ref12.payload;
          _context13.prev = 1;
          _context13.next = 4;
          return (0, _effects.select)(getEmpList);

        case 4:
          allEmps = _context13.sent;
          _context13.next = 7;
          return (0, _effects.select)(currentOrg);

        case 7:
          selectedOrg = _context13.sent;
          filtered = allEmps.filter(function (emp) {
            return (emp === null || emp === void 0 ? void 0 : emp.id) === (payload === null || payload === void 0 ? void 0 : payload.id);
          });

          if (!((filtered === null || filtered === void 0 ? void 0 : filtered.length) > 0)) {
            _context13.next = 17;
            break;
          }

          emp = filtered[0];
          updatedEmp = _objectSpread({}, emp, {
            starred: !payload.starred
          });
          auditMsg = 'Updating starred setting to '.concat(updatedEmp === null || updatedEmp === void 0 ? void 0 : updatedEmp.starred).concat(' for employee ').concat(updatedEmp === null || updatedEmp === void 0 ? void 0 : updatedEmp.id);
          _context13.next = 15;
          return (0, _effects.call)(_ApiService.updateDataRequest, updatedEmp, _api.EMPLOYEE_UPDATE_ENDPOINT, auditMsg, [_api.ORGID_PATH_PARAM], [selectedOrg.id]);

        case 15:
          _context13.next = 17;
          return (0, _effects.put)((0, _Employee.addFavouriteEmpSuccess)(payload));

        case 17:
          _context13.next = 23;
          break;

        case 19:
          _context13.prev = 19;
          _context13.t0 = _context13["catch"](1);
          _context13.next = 23;
          return (0, _effects.put)((0, _Employee.showEmpMessage)(_context13.t0.messages));

        case 23:
        case "end":
          return _context13.stop();
      }
    }
  }, _marked6, null, [[1, 19]]);
} // TODO delete employees


function fetchEmployeesSaga() {
  return regeneratorRuntime.wrap(function fetchEmployeesSaga$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_ALL_EMP, fetchEmployees);

        case 2:
        case "end":
          return _context14.stop();
      }
    }
  }, _marked7);
}

function saveEmployeeSaga() {
  return regeneratorRuntime.wrap(function saveEmployeeSaga$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_SAVE_EMP, saveEmployee);

        case 2:
        case "end":
          return _context15.stop();
      }
    }
  }, _marked8);
}

function fetchEmpSurveyAnswersSaga() {
  return regeneratorRuntime.wrap(function fetchEmpSurveyAnswersSaga$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_EMP_SURVEY_ANSWERS, fetchEmpSurveyAnswers);

        case 2:
        case "end":
          return _context16.stop();
      }
    }
  }, _marked9);
}

function saveEmpSurveyAnswersSaga() {
  return regeneratorRuntime.wrap(function saveEmpSurveyAnswersSaga$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.SAVE_EMP_SURVEY_ANSWERS, saveEmpSurveyAnswers);

        case 2:
        case "end":
          return _context17.stop();
      }
    }
  }, _marked10);
}

function fetchEmpNotificationsSaga() {
  return regeneratorRuntime.wrap(function fetchEmpNotificationsSaga$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_NOTIFICATIONS, fetchNotifications);

        case 2:
        case "end":
          return _context18.stop();
      }
    }
  }, _marked11);
}

function addFavouriteEmployeeSaga() {
  return regeneratorRuntime.wrap(function addFavouriteEmployeeSaga$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          _context19.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ADD_FAVOURITE_EMP, addFavouriteEmployee);

        case 2:
        case "end":
          return _context19.stop();
      }
    }
  }, _marked12);
}

function rootSaga() {
  return regeneratorRuntime.wrap(function rootSaga$(_context20) {
    while (1) {
      switch (_context20.prev = _context20.next) {
        case 0:
          _context20.next = 2;
          return (0, _effects.all)([(0, _effects.fork)(fetchEmpNotificationsSaga), (0, _effects.fork)(addFavouriteEmployeeSaga), (0, _effects.fork)(fetchEmployeesSaga), (0, _effects.fork)(saveEmployeeSaga), (0, _effects.fork)(fetchEmpSurveyAnswersSaga), (0, _effects.fork)(saveEmpSurveyAnswersSaga)]);

        case 2:
        case "end":
          return _context20.stop();
      }
    }
  }, _marked13);
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(orgStatisticsData, "orgStatisticsData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(createNotification, "createNotification", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(fetchNotificationsRequest, "fetchNotificationsRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(fetchNotifications, "fetchNotifications", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(fetchEmployeesRequest, "fetchEmployeesRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(fetchEmployees, "fetchEmployees", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(getEmpList, "getEmpList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(saveEmployee, "saveEmployee", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(saveEmployeeRequest, "saveEmployeeRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(fetchSurveys, "fetchSurveys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(fetchSurveyGroups, "fetchSurveyGroups", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(fetchSurveyQuestions, "fetchSurveyQuestions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(fetchEmpSurveyAnswers, "fetchEmpSurveyAnswers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(getOrgSurveyAnswers, "getOrgSurveyAnswers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(saveEmpSurveyAnswers, "saveEmpSurveyAnswers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(saveEmpSurveyAnswerRequest, "saveEmpSurveyAnswerRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(addFavouriteEmployee, "addFavouriteEmployee", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(fetchEmployeesSaga, "fetchEmployeesSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(saveEmployeeSaga, "saveEmployeeSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(fetchEmpSurveyAnswersSaga, "fetchEmpSurveyAnswersSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(saveEmpSurveyAnswersSaga, "saveEmpSurveyAnswersSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(fetchEmpNotificationsSaga, "fetchEmpNotificationsSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(addFavouriteEmployeeSaga, "addFavouriteEmployeeSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(_marked, "_marked", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(_marked2, "_marked2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(_marked3, "_marked3", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(_marked4, "_marked4", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(_marked5, "_marked5", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(_marked6, "_marked6", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(_marked7, "_marked7", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(_marked8, "_marked8", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(_marked9, "_marked9", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(_marked10, "_marked10", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(_marked11, "_marked11", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(_marked12, "_marked12", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(_marked13, "_marked13", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(asyncGeneratorStep, "asyncGeneratorStep", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(_asyncToGenerator, "_asyncToGenerator", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(orgStatisticsData, "orgStatisticsData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(createNotification, "createNotification", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(fetchNotificationsRequest, "fetchNotificationsRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(fetchNotifications, "fetchNotifications", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(fetchEmployeesRequest, "fetchEmployeesRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(fetchEmployees, "fetchEmployees", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(getEmpList, "getEmpList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(saveEmployee, "saveEmployee", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(saveEmployeeRequest, "saveEmployeeRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(fetchSurveys, "fetchSurveys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(fetchSurveyGroups, "fetchSurveyGroups", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(fetchSurveyQuestions, "fetchSurveyQuestions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(fetchEmpSurveyAnswers, "fetchEmpSurveyAnswers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(getOrgSurveyAnswers, "getOrgSurveyAnswers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(saveEmpSurveyAnswers, "saveEmpSurveyAnswers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(saveEmpSurveyAnswerRequest, "saveEmpSurveyAnswerRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(addFavouriteEmployee, "addFavouriteEmployee", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(fetchEmployeesSaga, "fetchEmployeesSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(saveEmployeeSaga, "saveEmployeeSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(fetchEmpSurveyAnswersSaga, "fetchEmpSurveyAnswersSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(saveEmpSurveyAnswersSaga, "saveEmpSurveyAnswersSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(fetchEmpNotificationsSaga, "fetchEmpNotificationsSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(addFavouriteEmployeeSaga, "addFavouriteEmployeeSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Employee.js");
}();

;

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchOrgSurveysSaga = fetchOrgSurveysSaga;
exports.fetchOrgSurveysCompareSaga = fetchOrgSurveysCompareSaga;
exports.fetchOrgSurveysCompareRadarChartDataSaga = fetchOrgSurveysCompareRadarChartDataSaga;
exports.fetchOrgSurveysDistributionsChartDataSaga = fetchOrgSurveysDistributionsChartDataSaga;
exports.fetchOrgSurveysTopResultsChartDataSaga = fetchOrgSurveysTopResultsChartDataSaga;
exports.fetchOrgSurveysBottomResultsChartDataSaga = fetchOrgSurveysBottomResultsChartDataSaga;
exports.fetchOrgSurveysEngagementReportDataSaga = fetchOrgSurveysEngagementReportDataSaga;
exports.saveOrgSurveySaga = saveOrgSurveySaga;
exports["default"] = rootSaga;

var _effects = __webpack_require__(15);

var _OrgSurvey = __webpack_require__(178);

var _OrgSurveyAnswers = __webpack_require__(211);

var _Survey = __webpack_require__(260);

var _Organisation = __webpack_require__(144);

var _ActionTypes = __webpack_require__(7);

var _ApiService = __webpack_require__(16);

var _Authentication = __webpack_require__(42);

var _SurveyService = __webpack_require__(176);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(fetchOrgSurveys),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchOrgSurveysCompare),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchOrgSurveysCompareRadarChartData),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchOrgSurveysEngagementReportData),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchOrgSurveysDistributionsChartData),
    _marked6 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchOrgSurveysTopResultsChartData),
    _marked7 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchOrgSurveysBottomResultsChartData),
    _marked8 =
/*#__PURE__*/
regeneratorRuntime.mark(saveOrgSurvey),
    _marked9 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchOrgSurveysSaga),
    _marked10 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchOrgSurveysCompareSaga),
    _marked11 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchOrgSurveysCompareRadarChartDataSaga),
    _marked12 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchOrgSurveysDistributionsChartDataSaga),
    _marked13 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchOrgSurveysTopResultsChartDataSaga),
    _marked14 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchOrgSurveysBottomResultsChartDataSaga),
    _marked15 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchOrgSurveysEngagementReportDataSaga),
    _marked16 =
/*#__PURE__*/
regeneratorRuntime.mark(saveOrgSurveySaga),
    _marked17 =
/*#__PURE__*/
regeneratorRuntime.mark(rootSaga);
/**
 * An organisation should have been selected so just need to retrieve the survey list here
 */


function fetchOrgSurveys() {
  var fetchedSurveys;
  return regeneratorRuntime.wrap(function fetchOrgSurveys$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(_ApiService.fetchDataRequest, 'surveys') || [];

        case 3:
          fetchedSurveys = _context.sent;
          _context.next = 6;
          return (0, _effects.put)((0, _Survey.fetchSurveysSuccess)(fetchedSurveys));

        case 6:
          _context.next = 8;
          return (0, _effects.put)((0, _OrgSurvey.hideOrgSurveyLoader)());

        case 8:
          _context.next = 14;
          break;

        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](0);
          _context.next = 14;
          return (0, _effects.put)((0, _OrgSurvey.showOrgSurveyMessage)(_context.t0.messages));

        case 14:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 10]]);
}

var getSelectedOrg = function getSelectedOrg(state) {
  return state.orgs.selectedOrg;
};
/**
 * For the selected org - get all the inactive/ finished surveys (i.e. past the end date)
 */


function fetchOrgSurveysCompare() {
  var selectedOrg, inactiveSurveys;
  return regeneratorRuntime.wrap(function fetchOrgSurveysCompare$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.select)(getSelectedOrg);

        case 3:
          selectedOrg = _context2.sent;
          inactiveSurveys = (0, _SurveyService.getInactiveSurveys)(selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.surveys);
          _context2.next = 7;
          return (0, _effects.put)((0, _OrgSurvey.fetchOrgSurveysCompareSuccess)((0, _SurveyService.initialiseOrgSurveysCompareList)(inactiveSurveys)));

        case 7:
          _context2.next = 13;
          break;

        case 9:
          _context2.prev = 9;
          _context2.t0 = _context2["catch"](0);
          _context2.next = 13;
          return (0, _effects.put)((0, _OrgSurvey.showOrgSurveyMessage)(_context2.t0.messages));

        case 13:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[0, 9]]);
}

var getSelectedOrgSurveyCompareList = function getSelectedOrgSurveyCompareList(state) {
  return state.orgSurveys.orgSurveyCompareList;
};
/**
 * 
 * From the selected surveys used to compare results - build the chart data required for the visualisations
 * TODO - rename to fetchOrgSurveysRadarChartData  - along with actions etc
 */


function fetchOrgSurveysCompareRadarChartData() {
  var selectedOrg, orgSurveysCompareList, orgSurveyAnswerSagaCall, orgSurveyAnswers, orgSurveysCompareRadarChartData;
  return regeneratorRuntime.wrap(function fetchOrgSurveysCompareRadarChartData$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.select)(getSelectedOrg);

        case 3:
          selectedOrg = _context3.sent;
          _context3.next = 6;
          return (0, _effects.select)(getSelectedOrgSurveyCompareList);

        case 6:
          orgSurveysCompareList = _context3.sent;
          _context3.next = 9;
          return (0, _effects.call)(_SurveyService.prepareOrgSurveyAnswerSagaCall, orgSurveysCompareList, selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id);

        case 9:
          orgSurveyAnswerSagaCall = _context3.sent;

          if (!orgSurveyAnswerSagaCall) {
            _context3.next = 16;
            break;
          }

          _context3.next = 13;
          return orgSurveyAnswerSagaCall;

        case 13:
          _context3.t0 = _context3.sent;
          _context3.next = 17;
          break;

        case 16:
          _context3.t0 = [];

        case 17:
          orgSurveyAnswers = _context3.t0; // extract the different types of chart data and thne update the store

          orgSurveysCompareRadarChartData = (0, _SurveyService.extractOrgSurveyRadarData)(orgSurveyAnswers); // surveyService call

          _context3.next = 21;
          return (0, _effects.put)((0, _OrgSurvey.fetchOrgSurveysCompareRadarChartDataSuccess)(orgSurveysCompareRadarChartData));

        case 21:
          _context3.next = 27;
          break;

        case 23:
          _context3.prev = 23;
          _context3.t1 = _context3["catch"](0);
          _context3.next = 27;
          return (0, _effects.put)((0, _OrgSurvey.showOrgSurveyMessage)(_context3.t1.messages));

        case 27:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[0, 23]]);
}
/**
 * 
 * From the selected surveys used to compare results - build the chart data required for the visualisations
 * 
 */


function fetchOrgSurveysEngagementReportData() {
  var selectedOrg, orgSurveysCompareList, orgSurveyAnswers, orgSurveysCompareDistributionsChartData, orgSurveysCompareTopResultsChartData, orgSurveysCompareBottomResultsChartData, engagementReportData;
  return regeneratorRuntime.wrap(function fetchOrgSurveysEngagementReportData$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return (0, _effects.select)(getSelectedOrg);

        case 3:
          selectedOrg = _context4.sent;
          _context4.next = 6;
          return (0, _effects.select)(getSelectedOrgSurveyCompareList);

        case 6:
          orgSurveysCompareList = _context4.sent;
          _context4.next = 9;
          return (0, _effects.call)(_SurveyService.getCompareOrgSurveyAnswers, orgSurveysCompareList, selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id);

        case 9:
          orgSurveyAnswers = _context4.sent; // extract the different types of chart data and then update the store

          orgSurveysCompareDistributionsChartData = (0, _SurveyService.extractOrgSurveyDistributionsData)(orgSurveyAnswers); // surveyService call

          orgSurveysCompareTopResultsChartData = orgSurveyAnswers.map(function (answer) {
            return (0, _SurveyService.extractOrgSurveyTopResponseData)(orgSurveyAnswers, answer === null || answer === void 0 ? void 0 : answer.id);
          });
          orgSurveysCompareBottomResultsChartData = orgSurveyAnswers.map(function (answer) {
            return (0, _SurveyService.extractOrgSurveyBottomResponseData)(orgSurveyAnswers, answer === null || answer === void 0 ? void 0 : answer.id);
          });
          engagementReportData = {
            topResultsChartData: orgSurveysCompareTopResultsChartData,
            bottomResultsChartData: orgSurveysCompareBottomResultsChartData,
            distributionsReportData: orgSurveysCompareDistributionsChartData
          };
          _context4.next = 16;
          return (0, _effects.put)((0, _OrgSurvey.fetchOrgSurveysEngagementReportChartDataSuccess)(engagementReportData));

        case 16:
          _context4.next = 22;
          break;

        case 18:
          _context4.prev = 18;
          _context4.t0 = _context4["catch"](0);
          _context4.next = 22;
          return (0, _effects.put)((0, _OrgSurvey.showOrgSurveyMessage)(_context4.t0.messages));

        case 22:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[0, 18]]);
}
/**
 * 
 * From the selected surveys used to compare results - build the chart data required for the visualisations
 * 
 */


function fetchOrgSurveysDistributionsChartData() {
  var selectedOrg, orgSurveysCompareList, orgSurveyAnswers, orgSurveysCompareDistributionsChartData;
  return regeneratorRuntime.wrap(function fetchOrgSurveysDistributionsChartData$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return (0, _effects.select)(getSelectedOrg);

        case 3:
          selectedOrg = _context5.sent;
          _context5.next = 6;
          return (0, _effects.select)(getSelectedOrgSurveyCompareList);

        case 6:
          orgSurveysCompareList = _context5.sent;
          _context5.next = 9;
          return (0, _effects.call)(_SurveyService.getCompareOrgSurveyAnswers, orgSurveysCompareList, selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id);

        case 9:
          orgSurveyAnswers = _context5.sent; // extract the different types of chart data and then update the store

          orgSurveysCompareDistributionsChartData = (0, _SurveyService.extractOrgSurveyDistributionsData)(orgSurveyAnswers); // surveyService call

          _context5.next = 13;
          return (0, _effects.put)((0, _OrgSurvey.fetchOrgSurveysCompareDistributionsChartDataSuccess)(orgSurveysCompareDistributionsChartData));

        case 13:
          _context5.next = 19;
          break;

        case 15:
          _context5.prev = 15;
          _context5.t0 = _context5["catch"](0);
          _context5.next = 19;
          return (0, _effects.put)((0, _OrgSurvey.showOrgSurveyMessage)(_context5.t0.messages));

        case 19:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, null, [[0, 15]]);
}
/**
 * 
 * From the selected surveys used to compare results - build the chart data required for the visualisations
 * 
 */


function fetchOrgSurveysTopResultsChartData() {
  var selectedOrg, orgSurveysCompareList, orgSurveyAnswers, orgSurveysCompareTopResultsChartData;
  return regeneratorRuntime.wrap(function fetchOrgSurveysTopResultsChartData$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return (0, _effects.select)(getSelectedOrg);

        case 3:
          selectedOrg = _context6.sent;
          _context6.next = 6;
          return (0, _effects.select)(getSelectedOrgSurveyCompareList);

        case 6:
          orgSurveysCompareList = _context6.sent;
          _context6.next = 9;
          return (0, _effects.call)(_SurveyService.getCompareOrgSurveyAnswers, orgSurveysCompareList, selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id);

        case 9:
          orgSurveyAnswers = _context6.sent;
          orgSurveysCompareTopResultsChartData = orgSurveyAnswers.map(function (answer) {
            return (0, _SurveyService.extractOrgSurveyTopResponseData)(orgSurveyAnswers, answer === null || answer === void 0 ? void 0 : answer.id);
          });
          _context6.next = 13;
          return (0, _effects.put)((0, _OrgSurvey.fetchOrgSurveysCompareTopResultsChartDataSuccess)(orgSurveysCompareTopResultsChartData));

        case 13:
          _context6.next = 19;
          break;

        case 15:
          _context6.prev = 15;
          _context6.t0 = _context6["catch"](0);
          _context6.next = 19;
          return (0, _effects.put)((0, _OrgSurvey.showOrgSurveyMessage)(_context6.t0.messages));

        case 19:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6, null, [[0, 15]]);
}
/**
 * 
 * From the selected surveys used to compare results - build the chart data required for the visualisations
 * 
 */


function fetchOrgSurveysBottomResultsChartData() {
  var selectedOrg, orgSurveysCompareList, orgSurveyAnswers, orgSurveysCompareBottomResultsChartData;
  return regeneratorRuntime.wrap(function fetchOrgSurveysBottomResultsChartData$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return (0, _effects.select)(getSelectedOrg);

        case 3:
          selectedOrg = _context7.sent;
          _context7.next = 6;
          return (0, _effects.select)(getSelectedOrgSurveyCompareList);

        case 6:
          orgSurveysCompareList = _context7.sent;
          _context7.next = 9;
          return (0, _effects.call)(_SurveyService.getCompareOrgSurveyAnswers, orgSurveysCompareList, selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id);

        case 9:
          orgSurveyAnswers = _context7.sent;
          orgSurveysCompareBottomResultsChartData = orgSurveyAnswers.map(function (answer) {
            return (0, _SurveyService.extractOrgSurveyBottomResponseData)(orgSurveyAnswers, answer === null || answer === void 0 ? void 0 : answer.id);
          });
          _context7.next = 13;
          return (0, _effects.put)((0, _OrgSurvey.fetchOrgSurveysCompareBottomResultsChartDataSuccess)(orgSurveysCompareBottomResultsChartData));

        case 13:
          _context7.next = 19;
          break;

        case 15:
          _context7.prev = 15;
          _context7.t0 = _context7["catch"](0);
          _context7.next = 19;
          return (0, _effects.put)((0, _OrgSurvey.showOrgSurveyMessage)(_context7.t0.messages));

        case 19:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7, null, [[0, 15]]);
}

function saveOrgSurvey(_ref) {
  var payload, selectedOrg, surveyId, generatedId, orgSurveyPayload;
  return regeneratorRuntime.wrap(function saveOrgSurvey$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          payload = _ref.payload;
          _context8.prev = 1;
          _context8.next = 4;
          return (0, _effects.select)(getSelectedOrg);

        case 4:
          selectedOrg = _context8.sent;
          surveyId = payload === null || payload === void 0 ? void 0 : payload.surveyId;
          generatedId = (0, _Authentication.generateGuid)();
          _context8.next = 9;
          return (0, _effects.call)(orgSurveyPayloadRequest, selectedOrg, payload, generatedId);

        case 9:
          orgSurveyPayload = _context8.sent;
          _context8.next = 12;
          return (0, _effects.put)((0, _Organisation.onSaveOrg)(orgSurveyPayload));

        case 12:
          _context8.next = 14;
          return (0, _effects.put)((0, _OrgSurveyAnswers.onSaveOrgSurveyAnswers)((0, _SurveyService.createDefaultOrgSurveyAnswers)(generatedId, selectedOrg.id, surveyId)));

        case 14:
          _context8.next = 16;
          return (0, _effects.put)((0, _OrgSurvey.hideOrgSurveyLoader)());

        case 16:
          _context8.next = 22;
          break;

        case 18:
          _context8.prev = 18;
          _context8.t0 = _context8["catch"](1);
          _context8.next = 22;
          return (0, _effects.put)((0, _OrgSurvey.showOrgSurveyMessage)(_context8.t0.messages));

        case 22:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8, null, [[1, 18]]);
}
/**
 * builds the org survey payload adding the new payload to the list
 * @param {*} selectedOrg 
 * @param {*} payload - will add the survey or replace if it exists in the org survey list
 * @param {*} id - need to pass in as we are using the same id for the corresponding org survey answers data entry 
 */


var orgSurveyPayloadRequest =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(selectedOrg, payload, id) {
    var isNew, surveyList, newPayload, surveys, _newPayload;

    return regeneratorRuntime.wrap(function _callee$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;

            if (selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.surveys) {
              // check if the survey already exists
              isNew = true;
              surveyList = selectedOrg.surveys.map(function (survey) {
                if (survey.id === payload.id) {
                  isNew = false;
                  return payload;
                } else {
                  return survey;
                }
              });

              if (isNew) {
                // payload not injected into the list so add an id and push
                newPayload = _objectSpread({}, payload, {
                  id: id
                });
                surveyList.push(newPayload);
              }

              selectedOrg.surveys = surveyList;
            } else {
              // no surveys created so add the first
              surveys = [];
              _newPayload = _objectSpread({}, payload, {
                id: id
              });
              surveys.push(_newPayload);
              selectedOrg.surveys = surveys;
            }

            return _context9.abrupt("return", selectedOrg);

          case 5:
            _context9.prev = 5;
            _context9.t0 = _context9["catch"](0);
            throw _context9.t0;

          case 8:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee, null, [[0, 5]]);
  }));

  return function orgSurveyPayloadRequest(_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

function fetchOrgSurveysSaga() {
  return regeneratorRuntime.wrap(function fetchOrgSurveysSaga$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_ALL_ORG_SURVEY, fetchOrgSurveys);

        case 2:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked9);
}

function fetchOrgSurveysCompareSaga() {
  return regeneratorRuntime.wrap(function fetchOrgSurveysCompareSaga$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_ALL_ORG_SURVEY_COMPARE, fetchOrgSurveysCompare);

        case 2:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked10);
}

function fetchOrgSurveysCompareRadarChartDataSaga() {
  return regeneratorRuntime.wrap(function fetchOrgSurveysCompareRadarChartDataSaga$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_ALL_ORG_SURVEY_COMPARE_RADAR_CHART_DATA, fetchOrgSurveysCompareRadarChartData);

        case 2:
        case "end":
          return _context12.stop();
      }
    }
  }, _marked11);
}

function fetchOrgSurveysDistributionsChartDataSaga() {
  return regeneratorRuntime.wrap(function fetchOrgSurveysDistributionsChartDataSaga$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_ALL_ORG_SURVEY_COMPARE_DISTRIBUTIONS_CHART_DATA, fetchOrgSurveysDistributionsChartData);

        case 2:
        case "end":
          return _context13.stop();
      }
    }
  }, _marked12);
}

function fetchOrgSurveysTopResultsChartDataSaga() {
  return regeneratorRuntime.wrap(function fetchOrgSurveysTopResultsChartDataSaga$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_ALL_ORG_SURVEY_COMPARE_TOP_RESULTS_CHART_DATA, fetchOrgSurveysTopResultsChartData);

        case 2:
        case "end":
          return _context14.stop();
      }
    }
  }, _marked13);
}

function fetchOrgSurveysBottomResultsChartDataSaga() {
  return regeneratorRuntime.wrap(function fetchOrgSurveysBottomResultsChartDataSaga$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_ALL_ORG_SURVEY_COMPARE_BOTTOM_RESULTS_CHART_DATA, fetchOrgSurveysBottomResultsChartData);

        case 2:
        case "end":
          return _context15.stop();
      }
    }
  }, _marked14);
}

function fetchOrgSurveysEngagementReportDataSaga() {
  return regeneratorRuntime.wrap(function fetchOrgSurveysEngagementReportDataSaga$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_ALL_ORG_SURVEY_ENGAGEMENT_REPORT_CHART_DATA, fetchOrgSurveysEngagementReportData);

        case 2:
        case "end":
          return _context16.stop();
      }
    }
  }, _marked15);
}

function saveOrgSurveySaga() {
  return regeneratorRuntime.wrap(function saveOrgSurveySaga$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_SAVE_ORG_SURVEY, saveOrgSurvey);

        case 2:
        case "end":
          return _context17.stop();
      }
    }
  }, _marked16);
}

function rootSaga() {
  return regeneratorRuntime.wrap(function rootSaga$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return (0, _effects.all)([(0, _effects.fork)(fetchOrgSurveysSaga), (0, _effects.fork)(saveOrgSurveySaga), (0, _effects.fork)(fetchOrgSurveysCompareSaga), (0, _effects.fork)(fetchOrgSurveysCompareRadarChartDataSaga), (0, _effects.fork)(fetchOrgSurveysDistributionsChartDataSaga), (0, _effects.fork)(fetchOrgSurveysTopResultsChartDataSaga), (0, _effects.fork)(fetchOrgSurveysBottomResultsChartDataSaga), (0, _effects.fork)(fetchOrgSurveysEngagementReportDataSaga)]);

        case 2:
        case "end":
          return _context18.stop();
      }
    }
  }, _marked17);
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchOrgSurveys, "fetchOrgSurveys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(getSelectedOrg, "getSelectedOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysCompare, "fetchOrgSurveysCompare", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(getSelectedOrgSurveyCompareList, "getSelectedOrgSurveyCompareList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysCompareRadarChartData, "fetchOrgSurveysCompareRadarChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysEngagementReportData, "fetchOrgSurveysEngagementReportData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysDistributionsChartData, "fetchOrgSurveysDistributionsChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysTopResultsChartData, "fetchOrgSurveysTopResultsChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysBottomResultsChartData, "fetchOrgSurveysBottomResultsChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(saveOrgSurvey, "saveOrgSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(orgSurveyPayloadRequest, "orgSurveyPayloadRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysSaga, "fetchOrgSurveysSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysCompareSaga, "fetchOrgSurveysCompareSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysCompareRadarChartDataSaga, "fetchOrgSurveysCompareRadarChartDataSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysDistributionsChartDataSaga, "fetchOrgSurveysDistributionsChartDataSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysTopResultsChartDataSaga, "fetchOrgSurveysTopResultsChartDataSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysBottomResultsChartDataSaga, "fetchOrgSurveysBottomResultsChartDataSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysEngagementReportDataSaga, "fetchOrgSurveysEngagementReportDataSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(saveOrgSurveySaga, "saveOrgSurveySaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(asyncGeneratorStep, "asyncGeneratorStep", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(_asyncToGenerator, "_asyncToGenerator", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(_marked, "_marked", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(_marked2, "_marked2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(_marked3, "_marked3", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(_marked4, "_marked4", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(_marked5, "_marked5", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(_marked6, "_marked6", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(_marked7, "_marked7", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(_marked8, "_marked8", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(_marked9, "_marked9", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(_marked10, "_marked10", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(_marked11, "_marked11", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(_marked12, "_marked12", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(_marked13, "_marked13", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(_marked14, "_marked14", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(_marked15, "_marked15", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(_marked16, "_marked16", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(_marked17, "_marked17", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveys, "fetchOrgSurveys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(getSelectedOrg, "getSelectedOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysCompare, "fetchOrgSurveysCompare", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(getSelectedOrgSurveyCompareList, "getSelectedOrgSurveyCompareList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysCompareRadarChartData, "fetchOrgSurveysCompareRadarChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysEngagementReportData, "fetchOrgSurveysEngagementReportData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysDistributionsChartData, "fetchOrgSurveysDistributionsChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysTopResultsChartData, "fetchOrgSurveysTopResultsChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysBottomResultsChartData, "fetchOrgSurveysBottomResultsChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(saveOrgSurvey, "saveOrgSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(orgSurveyPayloadRequest, "orgSurveyPayloadRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysSaga, "fetchOrgSurveysSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysCompareSaga, "fetchOrgSurveysCompareSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysCompareRadarChartDataSaga, "fetchOrgSurveysCompareRadarChartDataSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysDistributionsChartDataSaga, "fetchOrgSurveysDistributionsChartDataSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysTopResultsChartDataSaga, "fetchOrgSurveysTopResultsChartDataSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysBottomResultsChartDataSaga, "fetchOrgSurveysBottomResultsChartDataSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveysEngagementReportDataSaga, "fetchOrgSurveysEngagementReportDataSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(saveOrgSurveySaga, "saveOrgSurveySaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurvey.js");
}();

;

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchOrgSurveyAnswersSaga = fetchOrgSurveyAnswersSaga;
exports.saveOrgSurveyAnswersSaga = saveOrgSurveyAnswersSaga;
exports["default"] = rootSaga;

var _effects = __webpack_require__(15);

var _OrgSurveyAnswers = __webpack_require__(211);

var _ActionTypes = __webpack_require__(7);

var _ApiService = __webpack_require__(16);

var _api = __webpack_require__(25);

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(fetchOrgSurveyAnswers),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(saveOrgSurveyAnswers),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchOrgSurveyAnswersSaga),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(saveOrgSurveyAnswersSaga),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(rootSaga);

var currentOrg = function currentOrg(state) {
  return state.orgs.selectedOrg;
};

function fetchOrgSurveyAnswers(_ref) {
  var payload, selectedOrg, answers;
  return regeneratorRuntime.wrap(function fetchOrgSurveyAnswers$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _ref.payload;
          _context.prev = 1;
          _context.next = 4;
          return (0, _effects.select)(currentOrg);

        case 4:
          selectedOrg = _context.sent;

          if (!(payload === null || payload === void 0 ? void 0 : payload.orgSurveyId)) {
            _context.next = 11;
            break;
          }

          _context.next = 8;
          return (0, _effects.call)(_ApiService.fetchDataRequest, _api.ORG_SURVEY_ANSWERS_ENDPOINT, [_api.ORGID_PATH_PARAM, 'orgSurveyId'], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id, payload.orgSurveyId]) || {};

        case 8:
          answers = _context.sent;
          _context.next = 11;
          return (0, _effects.put)((0, _OrgSurveyAnswers.fetchOrgSurveyAnswersSuccess)((answers === null || answers === void 0 ? void 0 : answers.length) > 0 ? answers[0] : answers));

        case 11:
          _context.next = 17;
          break;

        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](1);
          _context.next = 17;
          return (0, _effects.put)((0, _OrgSurveyAnswers.showOrgSurveyAnswersMessage)(_context.t0.messages));

        case 17:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[1, 13]]);
}

function saveOrgSurveyAnswers(_ref2) {
  var payload, selectedOrg, isNew, savedOrgSurveyAnswers;
  return regeneratorRuntime.wrap(function saveOrgSurveyAnswers$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _ref2.payload;
          _context2.prev = 1;
          _context2.next = 4;
          return (0, _effects.select)(currentOrg);

        case 4:
          selectedOrg = _context2.sent;
          isNew = !(payload === null || payload === void 0 ? void 0 : payload.id) || !(payload === null || payload === void 0 ? void 0 : payload.id.trim().length) > 0;
          _context2.next = 8;
          return (0, _effects.call)(_ApiService.addOrUpdateDataRequest, isNew ? [] : [{
            id: payload === null || payload === void 0 ? void 0 : payload.id
          }], // so the addOrUpdateDataRequest will treat it as an add or update
          payload, 'addOrgSurveyAnswers', 'updateOrgSurveyAnswers', [_api.ORGID_PATH_PARAM], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id]);

        case 8:
          savedOrgSurveyAnswers = _context2.sent;
          _context2.next = 11;
          return (0, _effects.put)((0, _OrgSurveyAnswers.onSaveOrgSurveyAnswersSuccess)(savedOrgSurveyAnswers));

        case 11:
          _context2.next = 17;
          break;

        case 13:
          _context2.prev = 13;
          _context2.t0 = _context2["catch"](1);
          _context2.next = 17;
          return (0, _effects.put)((0, _OrgSurveyAnswers.showOrgSurveyAnswersMessage)(_context2.t0.messages));

        case 17:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 13]]);
}

function fetchOrgSurveyAnswersSaga() {
  return regeneratorRuntime.wrap(function fetchOrgSurveyAnswersSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_ORG_SURVEY_ANSWERS, fetchOrgSurveyAnswers);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}

function saveOrgSurveyAnswersSaga() {
  return regeneratorRuntime.wrap(function saveOrgSurveyAnswersSaga$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_SAVE_ORG_SURVEY_ANSWERS, saveOrgSurveyAnswers);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}

function rootSaga() {
  return regeneratorRuntime.wrap(function rootSaga$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.all)([(0, _effects.fork)(fetchOrgSurveyAnswersSaga), (0, _effects.fork)(saveOrgSurveyAnswersSaga)]);

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurveyAnswer.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveyAnswers, "fetchOrgSurveyAnswers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurveyAnswer.js");

  __REACT_HOT_LOADER__.register(saveOrgSurveyAnswers, "saveOrgSurveyAnswers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurveyAnswer.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveyAnswersSaga, "fetchOrgSurveyAnswersSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurveyAnswer.js");

  __REACT_HOT_LOADER__.register(saveOrgSurveyAnswersSaga, "saveOrgSurveyAnswersSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurveyAnswer.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurveyAnswer.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_marked, "_marked", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurveyAnswer.js");

  __REACT_HOT_LOADER__.register(_marked2, "_marked2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurveyAnswer.js");

  __REACT_HOT_LOADER__.register(_marked3, "_marked3", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurveyAnswer.js");

  __REACT_HOT_LOADER__.register(_marked4, "_marked4", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurveyAnswer.js");

  __REACT_HOT_LOADER__.register(_marked5, "_marked5", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurveyAnswer.js");

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurveyAnswer.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveyAnswers, "fetchOrgSurveyAnswers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurveyAnswer.js");

  __REACT_HOT_LOADER__.register(saveOrgSurveyAnswers, "saveOrgSurveyAnswers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurveyAnswer.js");

  __REACT_HOT_LOADER__.register(fetchOrgSurveyAnswersSaga, "fetchOrgSurveyAnswersSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurveyAnswer.js");

  __REACT_HOT_LOADER__.register(saveOrgSurveyAnswersSaga, "saveOrgSurveyAnswersSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurveyAnswer.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurveyAnswer.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/OrgSurveyAnswer.js");
}();

;

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchSurveysSaga = fetchSurveysSaga;
exports.saveSurveySaga = saveSurveySaga;
exports["default"] = rootSaga;

var _effects = __webpack_require__(15);

var _Survey = __webpack_require__(260);

var _ActionTypes = __webpack_require__(7);

var _ApiClient = __webpack_require__(210);

var _ApiConfig = __webpack_require__(145);

var _ApiService = __webpack_require__(16);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(fetchSurveys),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(saveSurvey),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchSurveysSaga),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(saveSurveySaga),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(rootSaga);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var fetchSurveysRequest =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", (0, _ApiService.fetchDataRequest)('surveys'));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchSurveysRequest() {
    return _ref.apply(this, arguments);
  };
}();

function fetchSurveys() {
  var fetchedSurveys;
  return regeneratorRuntime.wrap(function fetchSurveys$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.call)(fetchSurveysRequest) || [];

        case 3:
          fetchedSurveys = _context2.sent;
          _context2.next = 6;
          return (0, _effects.put)((0, _Survey.fetchSurveysSuccess)(fetchedSurveys));

        case 6:
          _context2.next = 12;
          break;

        case 8:
          _context2.prev = 8;
          _context2.t0 = _context2["catch"](0);
          _context2.next = 12;
          return (0, _effects.put)((0, _Survey.showSurveyMessage)(_context2.t0.messages));

        case 12:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked, null, [[0, 8]]);
}

var getSurveyList = function getSurveyList(state) {
  return state.surveys.surveyList;
};

function saveSurvey(_ref2) {
  var payload, allSurveys, savedSurveys;
  return regeneratorRuntime.wrap(function saveSurvey$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _ref2.payload;
          _context3.prev = 1;
          _context3.next = 4;
          return (0, _effects.select)(getSurveyList);

        case 4:
          allSurveys = _context3.sent;
          _context3.next = 7;
          return (0, _effects.call)(saveSurveyRequest, allSurveys, payload);

        case 7:
          savedSurveys = _context3.sent;
          _context3.next = 10;
          return (0, _effects.put)((0, _Survey.onSaveSurveySuccess)(savedSurveys));

        case 10:
          _context3.next = 16;
          break;

        case 12:
          _context3.prev = 12;
          _context3.t0 = _context3["catch"](1);
          _context3.next = 16;
          return (0, _effects.put)((0, _Survey.showSurveyMessage)(_context3.t0.messages));

        case 16:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked2, null, [[1, 12]]);
}

var saveSurveyRequest =
/*#__PURE__*/
function () {
  var _ref3 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(allSurveys, payload) {
    var isNew, surveyList, endpointConfig;
    return regeneratorRuntime.wrap(function _callee2$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            isNew = true;
            surveyList = allSurveys.map(function (survey) {
              if (survey.id === payload.id) {
                isNew = false;
                return payload;
              } else {
                return survey;
              }
            });
            endpointConfig = isNew ? (0, _ApiConfig.endpoint)('addSurvey') : (0, _ApiConfig.endpoint)('updateSurvey');

            if (!isNew) {
              _context4.next = 10;
              break;
            }

            if (!endpointConfig) {
              _context4.next = 8;
              break;
            }

            _context4.next = 8;
            return (0, _ApiClient.post)(endpointConfig.uri, payload).then(function (response) {
              // the response will return the id so place it back into the local object
              var id = response ? response.id : 'addSurveyResponseError';

              var updatedPayload = _objectSpread({}, payload, {
                id: id
              });

              surveyList.push(updatedPayload);
            })["catch"](function (error) {
              throw error;
            });

          case 8:
            _context4.next = 13;
            break;

          case 10:
            if (!endpointConfig) {
              _context4.next = 13;
              break;
            }

            _context4.next = 13;
            return (0, _ApiClient.update)(endpointConfig.uri, payload).then(function (payload) {
              return payload;
            }) // already in list
            ["catch"](function (error) {
              throw error;
            });

          case 13:
            return _context4.abrupt("return", surveyList);

          case 16:
            _context4.prev = 16;
            _context4.t0 = _context4["catch"](0);
            throw _context4.t0;

          case 19:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee2, null, [[0, 16]]);
  }));

  return function saveSurveyRequest(_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}();

function fetchSurveysSaga() {
  return regeneratorRuntime.wrap(function fetchSurveysSaga$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_ALL_SURVEY, fetchSurveys);

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked3);
}

function saveSurveySaga() {
  return regeneratorRuntime.wrap(function saveSurveySaga$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_SAVE_SURVEY, saveSurvey);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked4);
}

function rootSaga() {
  return regeneratorRuntime.wrap(function rootSaga$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.all)([(0, _effects.fork)(fetchSurveysSaga), (0, _effects.fork)(saveSurveySaga)]);

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked5);
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchSurveysRequest, "fetchSurveysRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Survey.js");

  __REACT_HOT_LOADER__.register(fetchSurveys, "fetchSurveys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Survey.js");

  __REACT_HOT_LOADER__.register(getSurveyList, "getSurveyList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Survey.js");

  __REACT_HOT_LOADER__.register(saveSurvey, "saveSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Survey.js");

  __REACT_HOT_LOADER__.register(saveSurveyRequest, "saveSurveyRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Survey.js");

  __REACT_HOT_LOADER__.register(fetchSurveysSaga, "fetchSurveysSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Survey.js");

  __REACT_HOT_LOADER__.register(saveSurveySaga, "saveSurveySaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Survey.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Survey.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Survey.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Survey.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Survey.js");

  __REACT_HOT_LOADER__.register(_marked, "_marked", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Survey.js");

  __REACT_HOT_LOADER__.register(_marked2, "_marked2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Survey.js");

  __REACT_HOT_LOADER__.register(_marked3, "_marked3", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Survey.js");

  __REACT_HOT_LOADER__.register(_marked4, "_marked4", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Survey.js");

  __REACT_HOT_LOADER__.register(_marked5, "_marked5", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Survey.js");

  __REACT_HOT_LOADER__.register(asyncGeneratorStep, "asyncGeneratorStep", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Survey.js");

  __REACT_HOT_LOADER__.register(_asyncToGenerator, "_asyncToGenerator", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Survey.js");

  __REACT_HOT_LOADER__.register(fetchSurveysRequest, "fetchSurveysRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Survey.js");

  __REACT_HOT_LOADER__.register(fetchSurveys, "fetchSurveys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Survey.js");

  __REACT_HOT_LOADER__.register(getSurveyList, "getSurveyList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Survey.js");

  __REACT_HOT_LOADER__.register(saveSurvey, "saveSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Survey.js");

  __REACT_HOT_LOADER__.register(saveSurveyRequest, "saveSurveyRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Survey.js");

  __REACT_HOT_LOADER__.register(fetchSurveysSaga, "fetchSurveysSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Survey.js");

  __REACT_HOT_LOADER__.register(saveSurveySaga, "saveSurveySaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Survey.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Survey.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/Survey.js");
}();

;

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchSurveyGroupsSaga = fetchSurveyGroupsSaga;
exports.saveSurveyGroupSaga = saveSurveyGroupSaga;
exports["default"] = rootSaga;

var _effects = __webpack_require__(15);

var _SurveyGroup = __webpack_require__(177);

var _ActionTypes = __webpack_require__(7);

var _ApiClient = __webpack_require__(210);

var _ApiConfig = __webpack_require__(145);

var _ApiService = __webpack_require__(16);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(fetchSurveyGroups),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(saveSurveyGroup),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchSurveyGroupsSaga),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(saveSurveyGroupSaga),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(rootSaga);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var fetchSurveyGroupsRequest =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", (0, _ApiService.fetchDataRequest)('surveyGroups'));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchSurveyGroupsRequest() {
    return _ref.apply(this, arguments);
  };
}();

function fetchSurveyGroups() {
  var fetchedSurveyGroups;
  return regeneratorRuntime.wrap(function fetchSurveyGroups$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.call)(fetchSurveyGroupsRequest) || [];

        case 3:
          fetchedSurveyGroups = _context2.sent;
          _context2.next = 6;
          return (0, _effects.put)((0, _SurveyGroup.fetchSurveyGroupsSuccess)(fetchedSurveyGroups));

        case 6:
          _context2.next = 12;
          break;

        case 8:
          _context2.prev = 8;
          _context2.t0 = _context2["catch"](0);
          _context2.next = 12;
          return (0, _effects.put)((0, _SurveyGroup.showSurveyGroupMessage)(_context2.t0.messages));

        case 12:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked, null, [[0, 8]]);
}

var getSurveyGroupList = function getSurveyGroupList(state) {
  return state.surveyGroups.surveyGroupList;
};

function saveSurveyGroup(_ref2) {
  var payload, allSurveyGroups, savedSurveyGroups;
  return regeneratorRuntime.wrap(function saveSurveyGroup$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _ref2.payload;
          _context3.prev = 1;
          _context3.next = 4;
          return (0, _effects.select)(getSurveyGroupList);

        case 4:
          allSurveyGroups = _context3.sent;
          _context3.next = 7;
          return (0, _effects.call)(saveSurveyGroupRequest, allSurveyGroups, payload);

        case 7:
          savedSurveyGroups = _context3.sent;
          _context3.next = 10;
          return (0, _effects.put)((0, _SurveyGroup.onSaveSurveyGroupSuccess)(savedSurveyGroups));

        case 10:
          _context3.next = 16;
          break;

        case 12:
          _context3.prev = 12;
          _context3.t0 = _context3["catch"](1);
          _context3.next = 16;
          return (0, _effects.put)((0, _SurveyGroup.showSurveyGroupMessage)(_context3.t0.messages));

        case 16:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked2, null, [[1, 12]]);
}

var saveSurveyGroupRequest =
/*#__PURE__*/
function () {
  var _ref3 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(allSurveyGroups, payload) {
    var isNew, surveyGroupList, endpointConfig;
    return regeneratorRuntime.wrap(function _callee2$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            isNew = true;
            surveyGroupList = allSurveyGroups.map(function (surveyGroup) {
              if (surveyGroup.id === payload.id) {
                isNew = false;
                return payload;
              } else {
                return surveyGroup;
              }
            });
            endpointConfig = isNew ? (0, _ApiConfig.endpoint)('addSurveyGroup') : (0, _ApiConfig.endpoint)('updateSurveyGroup');

            if (!isNew) {
              _context4.next = 10;
              break;
            }

            if (!endpointConfig) {
              _context4.next = 8;
              break;
            }

            _context4.next = 8;
            return (0, _ApiClient.post)(endpointConfig.uri, payload).then(function (response) {
              // the response will return the id so place it back into the local object
              var id = response ? response.id : 'addSurveyGroupResponseError';

              var updatedPayload = _objectSpread({}, payload, {
                id: id
              });

              surveyGroupList.push(updatedPayload);
            })["catch"](function (error) {
              throw error;
            });

          case 8:
            _context4.next = 13;
            break;

          case 10:
            if (!endpointConfig) {
              _context4.next = 13;
              break;
            }

            _context4.next = 13;
            return (0, _ApiClient.update)(endpointConfig.uri, payload).then(function (payload) {
              return payload;
            }) // already in list
            ["catch"](function (error) {
              throw error;
            });

          case 13:
            return _context4.abrupt("return", surveyGroupList);

          case 16:
            _context4.prev = 16;
            _context4.t0 = _context4["catch"](0);
            throw _context4.t0;

          case 19:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee2, null, [[0, 16]]);
  }));

  return function saveSurveyGroupRequest(_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}();

function fetchSurveyGroupsSaga() {
  return regeneratorRuntime.wrap(function fetchSurveyGroupsSaga$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_ALL_SURVEY_GROUP, fetchSurveyGroups);

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked3);
}

function saveSurveyGroupSaga() {
  return regeneratorRuntime.wrap(function saveSurveyGroupSaga$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_SAVE_SURVEY_GROUP, saveSurveyGroup);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked4);
}

function rootSaga() {
  return regeneratorRuntime.wrap(function rootSaga$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.all)([(0, _effects.fork)(fetchSurveyGroupsSaga), (0, _effects.fork)(saveSurveyGroupSaga)]);

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked5);
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchSurveyGroupsRequest, "fetchSurveyGroupsRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(fetchSurveyGroups, "fetchSurveyGroups", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(getSurveyGroupList, "getSurveyGroupList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(saveSurveyGroup, "saveSurveyGroup", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(saveSurveyGroupRequest, "saveSurveyGroupRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(fetchSurveyGroupsSaga, "fetchSurveyGroupsSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(saveSurveyGroupSaga, "saveSurveyGroupSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroup.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(_marked, "_marked", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(_marked2, "_marked2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(_marked3, "_marked3", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(_marked4, "_marked4", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(_marked5, "_marked5", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(asyncGeneratorStep, "asyncGeneratorStep", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(_asyncToGenerator, "_asyncToGenerator", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(fetchSurveyGroupsRequest, "fetchSurveyGroupsRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(fetchSurveyGroups, "fetchSurveyGroups", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(getSurveyGroupList, "getSurveyGroupList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(saveSurveyGroup, "saveSurveyGroup", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(saveSurveyGroupRequest, "saveSurveyGroupRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(fetchSurveyGroupsSaga, "fetchSurveyGroupsSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(saveSurveyGroupSaga, "saveSurveyGroupSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroup.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroup.js");
}();

;

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveSurveyGroupQuestionSaga = saveSurveyGroupQuestionSaga;
exports["default"] = rootSaga;

var _effects = __webpack_require__(15);

var _SurveyGroupQuestion = __webpack_require__(363);

var _SurveyGroup = __webpack_require__(177);

var _ActionTypes = __webpack_require__(7);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(saveSurveyGroupQuestion),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(saveSurveyGroupQuestionSaga),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(rootSaga);

var getSelectedSurveyGroup = function getSelectedSurveyGroup(state) {
  return state.surveyGroups.selectedSurveyGroup;
};

function saveSurveyGroupQuestion(_ref) {
  var payload, selectedSurveyGroup, savedSurveyGroupQuestions;
  return regeneratorRuntime.wrap(function saveSurveyGroupQuestion$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _ref.payload;
          _context.prev = 1;
          _context.next = 4;
          return (0, _effects.select)(getSelectedSurveyGroup);

        case 4:
          selectedSurveyGroup = _context.sent;
          _context.next = 7;
          return (0, _effects.call)(saveSurveyGroupQuestionRequest, selectedSurveyGroup, payload);

        case 7:
          savedSurveyGroupQuestions = _context.sent;
          _context.next = 10;
          return (0, _effects.put)((0, _SurveyGroup.onSaveSurveyGroup)(savedSurveyGroupQuestions));

        case 10:
          _context.next = 16;
          break;

        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](1);
          _context.next = 16;
          return (0, _effects.put)((0, _SurveyGroupQuestion.showSurveyGroupQuestionMessage)(_context.t0.messages));

        case 16:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[1, 12]]);
}

var saveSurveyGroupQuestionRequest =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(selectedSurveyGroup, payload) {
    var questions;
    return regeneratorRuntime.wrap(function _callee$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;

            if (selectedSurveyGroup && selectedSurveyGroup.questions) {
              selectedSurveyGroup.questions.push(payload.id);
            } else {
              questions = [];
              questions.push(payload.id);
              selectedSurveyGroup.questions = questions;
            }

            return _context2.abrupt("return", selectedSurveyGroup);

          case 5:
            _context2.prev = 5;
            _context2.t0 = _context2["catch"](0);
            throw _context2.t0;

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee, null, [[0, 5]]);
  }));

  return function saveSurveyGroupQuestionRequest(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();

function saveSurveyGroupQuestionSaga() {
  return regeneratorRuntime.wrap(function saveSurveyGroupQuestionSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_SAVE_SURVEY_GROUP_QUESTION, saveSurveyGroupQuestion);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked2);
}

function rootSaga() {
  return regeneratorRuntime.wrap(function rootSaga$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.all)([(0, _effects.fork)(saveSurveyGroupQuestionSaga)]);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked3);
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(getSelectedSurveyGroup, "getSelectedSurveyGroup", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(saveSurveyGroupQuestion, "saveSurveyGroupQuestion", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(saveSurveyGroupQuestionRequest, "saveSurveyGroupQuestionRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(saveSurveyGroupQuestionSaga, "saveSurveyGroupQuestionSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroupQuestion.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(asyncGeneratorStep, "asyncGeneratorStep", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(_asyncToGenerator, "_asyncToGenerator", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(_marked, "_marked", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(_marked2, "_marked2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(_marked3, "_marked3", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(getSelectedSurveyGroup, "getSelectedSurveyGroup", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(saveSurveyGroupQuestion, "saveSurveyGroupQuestion", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(saveSurveyGroupQuestionRequest, "saveSurveyGroupQuestionRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(saveSurveyGroupQuestionSaga, "saveSurveyGroupQuestionSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroupQuestion.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyGroupQuestion.js");
}();

;

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchSurveyQuestionsSaga = fetchSurveyQuestionsSaga;
exports["default"] = rootSaga;

var _effects = __webpack_require__(15);

var _SurveyQuestion = __webpack_require__(261);

var _ActionTypes = __webpack_require__(7);

var _ApiService = __webpack_require__(16);

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(fetchSurveyQuestions),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchSurveyQuestionsSaga),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(rootSaga);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var fetchSurveyQuestionsRequest =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", (0, _ApiService.fetchDataRequest)('surveyQuestions'));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchSurveyQuestionsRequest() {
    return _ref.apply(this, arguments);
  };
}();

function fetchSurveyQuestions() {
  var fetchedSurveyQuestions;
  return regeneratorRuntime.wrap(function fetchSurveyQuestions$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.call)(fetchSurveyQuestionsRequest) || [];

        case 3:
          fetchedSurveyQuestions = _context2.sent;
          _context2.next = 6;
          return (0, _effects.put)((0, _SurveyQuestion.fetchSurveyQuestionsSuccess)(fetchedSurveyQuestions));

        case 6:
          _context2.next = 12;
          break;

        case 8:
          _context2.prev = 8;
          _context2.t0 = _context2["catch"](0);
          _context2.next = 12;
          return (0, _effects.put)((0, _SurveyQuestion.showSurveyQuestionMessage)(_context2.t0.messages));

        case 12:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked, null, [[0, 8]]);
}

function fetchSurveyQuestionsSaga() {
  return regeneratorRuntime.wrap(function fetchSurveyQuestionsSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_ALL_SURVEY_QUESTION, fetchSurveyQuestions);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked2);
}

function rootSaga() {
  return regeneratorRuntime.wrap(function rootSaga$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.all)([(0, _effects.fork)(fetchSurveyQuestionsSaga)]);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked3);
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchSurveyQuestionsRequest, "fetchSurveyQuestionsRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyQuestion.js");

  __REACT_HOT_LOADER__.register(fetchSurveyQuestions, "fetchSurveyQuestions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyQuestion.js");

  __REACT_HOT_LOADER__.register(fetchSurveyQuestionsSaga, "fetchSurveyQuestionsSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyQuestion.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyQuestion.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_marked, "_marked", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyQuestion.js");

  __REACT_HOT_LOADER__.register(_marked2, "_marked2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyQuestion.js");

  __REACT_HOT_LOADER__.register(_marked3, "_marked3", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyQuestion.js");

  __REACT_HOT_LOADER__.register(asyncGeneratorStep, "asyncGeneratorStep", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyQuestion.js");

  __REACT_HOT_LOADER__.register(_asyncToGenerator, "_asyncToGenerator", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyQuestion.js");

  __REACT_HOT_LOADER__.register(fetchSurveyQuestionsRequest, "fetchSurveyQuestionsRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyQuestion.js");

  __REACT_HOT_LOADER__.register(fetchSurveyQuestions, "fetchSurveyQuestions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyQuestion.js");

  __REACT_HOT_LOADER__.register(fetchSurveyQuestionsSaga, "fetchSurveyQuestionsSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyQuestion.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyQuestion.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/SurveyQuestion.js");
}();

;

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchProjects = fetchProjects;
exports.onImportProjects = onImportProjects;
exports.deleteProject = deleteProject;
exports.saveProject = saveProject;
exports.addFavouriteProject = addFavouriteProject;
exports.fetchProjectsSaga = fetchProjectsSaga;
exports.saveProjectSaga = saveProjectSaga;
exports.deleteProjectSaga = deleteProjectSaga;
exports.onImportProjectsSaga = onImportProjectsSaga;
exports.addFavouriteProjectSaga = addFavouriteProjectSaga;
exports["default"] = rootSaga;

var _effects = __webpack_require__(15);

var _project = __webpack_require__(179);

var _ActionTypes = __webpack_require__(7);

var _ApiService = __webpack_require__(16);

var _DateFormatters = __webpack_require__(43);

var _errorService = __webpack_require__(50);

var _projectService = __webpack_require__(175);

var _api = __webpack_require__(25);

var _Authentication = __webpack_require__(42);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(fetchProjects),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(onImportProjects),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(deleteProject),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(saveProject),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(addFavouriteProject),
    _marked6 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchProjectsSaga),
    _marked7 =
/*#__PURE__*/
regeneratorRuntime.mark(saveProjectSaga),
    _marked8 =
/*#__PURE__*/
regeneratorRuntime.mark(deleteProjectSaga),
    _marked9 =
/*#__PURE__*/
regeneratorRuntime.mark(onImportProjectsSaga),
    _marked10 =
/*#__PURE__*/
regeneratorRuntime.mark(addFavouriteProjectSaga),
    _marked11 =
/*#__PURE__*/
regeneratorRuntime.mark(rootSaga);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var currentOrg = function currentOrg(state) {
  return state.orgs.selectedOrg;
};

var importedProjects = function importedProjects(state) {
  return state.projects.importedProjects;
};

var getProjectList = function getProjectList(state) {
  return state.projects.allProject;
};

var getProjectCacheList = function getProjectCacheList(state) {
  return state.projects.projectCacheList || [];
}; // export function* fetchProjectsDeprecated({ payload }) {
//     try {
//         // payload should be the orgid
//         const fetchedProjects = yield call(fetchProjectsRequest, payload) || [];
//         yield put(fetchProjectsSuccess(fetchedProjects));
//     } catch (error) {
//         yield put(showProjectMessage(error.messages));
//     }
// }


var fetchProjectsRequest =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(orgid) {
    var projects;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _ApiService.fetchDataRequest)(_api.PROJECTS_FETCH_ENDPOINT, [_api.ORGID_PATH_PARAM], [orgid]);

          case 2:
            projects = _context.sent;
            return _context.abrupt("return", projects);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchProjectsRequest(_x) {
    return _ref.apply(this, arguments);
  };
}();

var fetchImportProjectsRequest =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(orgid) {
    var fetchedProjects;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return (0, _ApiService.fetchDataRequest)(_api.JIRA_GET_PROJECTS_ENDPOINT, [_api.ORGID_PATH_PARAM], [orgid]);

          case 3:
            _context2.t0 = _context2.sent;

            if (_context2.t0) {
              _context2.next = 6;
              break;
            }

            _context2.t0 = [];

          case 6:
            fetchedProjects = _context2.t0;
            return _context2.abrupt("return", fetchedProjects);

          case 10:
            _context2.prev = 10;
            _context2.t1 = _context2["catch"](0); // continue processing as most likely the jira call could fail - can still show the local project data

            console.error('An error occurred importing projects - '.concat(_context2.t1.messages));

          case 13:
            return _context2.abrupt("return", []);

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 10]]);
  }));

  return function fetchImportProjectsRequest(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

function fetchProjects(_ref3) {
  var payload, orgid, useCache, allProjectCache, sanitizedCache, cacheEntry, now, fetchedProjects, replaceCachedEntry, addCachedEntry, refreshLocalProjectCacheDataOnly;
  return regeneratorRuntime.wrap(function fetchProjects$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _ref3.payload; // we pass in the orgId as this may be called from the dashboard and a race condition may occur where the selected org isnt set upon making this call !!

          orgid = payload.orgid, useCache = payload.useCache;
          _context3.prev = 2;
          _context3.next = 5;
          return (0, _effects.select)(getProjectCacheList);

        case 5:
          allProjectCache = _context3.sent;
          _context3.next = 8;
          return (0, _effects.call)(_projectService.sanitizeProjectCache, allProjectCache);

        case 8:
          sanitizedCache = _context3.sent;
          cacheEntry = sanitizedCache.find(function (entry) {
            return (entry === null || entry === void 0 ? void 0 : entry.id) === orgid;
          });
          now = new Date();
          fetchedProjects = {};
          replaceCachedEntry = false;
          addCachedEntry = false;
          refreshLocalProjectCacheDataOnly = false; // only update local project data in the cache - dont update jira data

          if (!cacheEntry) {
            _context3.next = 29;
            break;
          }

          if (!useCache) {
            _context3.next = 26;
            break;
          }

          _context3.next = 19;
          return (0, _effects.call)(_projectService.projectCacheExpired, cacheEntry === null || cacheEntry === void 0 ? void 0 : cacheEntry.lastUpdated);

        case 19:
          if (!_context3.sent) {
            _context3.next = 23;
            break;
          } // entry has expired so retrieve and set


          replaceCachedEntry = true;
          _context3.next = 24;
          break;

        case 23:
          refreshLocalProjectCacheDataOnly = true;
        // hasnt expired so only replace the local project data - do not make jira project rest api call

        case 24:
          _context3.next = 27;
          break;

        case 26:
          // have cache entry but force refresh so retrieve and set
          replaceCachedEntry = true;

        case 27:
          _context3.next = 30;
          break;

        case 29:
          // no cache entry so fetch and add to cache
          addCachedEntry = true;

        case 30:
          if (!refreshLocalProjectCacheDataOnly) {
            _context3.next = 36;
            break;
          }

          _context3.next = 33;
          return (0, _effects.call)(fetchProjectsRequest, orgid);

        case 33:
          fetchedProjects = _context3.sent;
          _context3.next = 39;
          break;

        case 36:
          _context3.next = 38;
          return (0, _effects.call)(fetchImportProjectsRequest, orgid);

        case 38:
          fetchedProjects = _context3.sent;

        case 39:
          if (!(replaceCachedEntry || addCachedEntry)) {
            _context3.next = 43;
            break;
          } // only 1 entry in the cahce so just replace it


          sanitizedCache = new Array({
            id: orgid,
            lastUpdated: now,
            data: fetchedProjects
          });
          _context3.next = 43;
          return (0, _effects.put)((0, _project.onSaveProjectCacheSuccess)(sanitizedCache));

        case 43:
          _context3.next = 45;
          return (0, _effects.put)((0, _project.fetchProjectsSuccess)(fetchedProjects));

        case 45:
          _context3.next = 51;
          break;

        case 47:
          _context3.prev = 47;
          _context3.t0 = _context3["catch"](2);
          _context3.next = 51;
          return (0, _effects.put)((0, _project.showProjectMessage)(_context3.t0.messages));

        case 51:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked, null, [[2, 47]]);
}
/**
 * Deprecated
 * Not being used - works with improtProjectsModal that calls fetchImportProjects - waits for user confirmation then this is called
 */


function onImportProjects() {
  var allProjects, allImportedProjects, selectedOrg, newProjects, _newPayload$projects, newPayload, combinedProjects;

  return regeneratorRuntime.wrap(function onImportProjects$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.select)(getProjectList);

        case 2:
          allProjects = _context4.sent;
          _context4.next = 5;
          return (0, _effects.select)(importedProjects);

        case 5:
          allImportedProjects = _context4.sent;
          _context4.next = 8;
          return (0, _effects.select)(currentOrg);

        case 8:
          selectedOrg = _context4.sent;
          _context4.prev = 9;
          _context4.next = 12;
          return (0, _effects.call)(onImportProjectsRequest, allImportedProjects, selectedOrg) || [];

        case 12:
          newProjects = _context4.sent;

          if (!((newProjects === null || newProjects === void 0 ? void 0 : newProjects.length) > 0)) {
            _context4.next = 22;
            break;
          } // change the payload to include the orgid for security reasons - checks against the path param


          newPayload = {
            orgid: selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id,
            projects: newProjects
          }; // only send new projects

          _context4.next = 17;
          return (0, _effects.call)(_ApiService.updateDataRequest, newPayload, _api.PROJECTS_ADD_ENDPOINT, 'Adding '.concat(newPayload === null || newPayload === void 0 ? void 0 : (_newPayload$projects = newPayload.projects) === null || _newPayload$projects === void 0 ? void 0 : _newPayload$projects.length).concat(' projects'), [_api.ORGID_PATH_PARAM], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id]);

        case 17:
          // TODO - change the response into messages for the client
          // TODO - put message in normal place or another spot to display on a larger alert
          // response is {messages: [{successMsg: ''}, {errorMsg: ''}], errorCount: 0, successCount: 0}
          // yield put(showProjectMessage(error.messages));
          combinedProjects = allProjects.concat(newProjects); // put all projects back into the store

          _context4.next = 20;
          return (0, _effects.put)((0, _project.onImportProjectsSuccess)(combinedProjects));

        case 20:
          _context4.next = 28;
          break;

        case 22:
          _context4.next = 24;
          return (0, _effects.put)((0, _project.showProjectMessage)('No projects were imported!'));

        case 24:
          _context4.next = 26;
          return (0, _effects.put)((0, _project.hideProjectLoader)());

        case 26:
          _context4.next = 28;
          return (0, _effects.put)((0, _project.hideImportProjectsLoader)());

        case 28:
          _context4.next = 34;
          break;

        case 30:
          _context4.prev = 30;
          _context4.t0 = _context4["catch"](9);
          _context4.next = 34;
          return (0, _effects.put)((0, _project.showProjectMessage)(_context4.t0.messages));

        case 34:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked2, null, [[9, 30]]);
}

var onImportProjectsRequest =
/*#__PURE__*/
function () {
  var _ref4 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(importProjects, selectedOrg) {
    var today, convertedProjectsToImport;
    return regeneratorRuntime.wrap(function _callee3$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            today = new Date();

            if (!(Array.isArray(importProjects) && importProjects.length > 0)) {
              _context5.next = 5;
              break;
            } // create transformed objects to use for the update


            convertedProjectsToImport = importProjects.map(function (project) {
              return {
                id: (0, _Authentication.generateGuid)(),
                orgid: selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id,
                name: project === null || project === void 0 ? void 0 : project.name,
                description: 'JIRA project '.concat(project === null || project === void 0 ? void 0 : project.name).concat(' imported on ').concat((0, _DateFormatters.formatDateDefault)(today)),
                startDate: today,
                endDate: today,
                weight: 0,
                busValPriorityParams: [],
                costImplPriorityParams: [],
                jiraProjectAttributes: _objectSpread({}, project),
                budget: 0,
                selected: false,
                starred: false,
                frequently: false,
                thumb: null
              };
            });
            return _context5.abrupt("return", convertedProjectsToImport);

          case 5:
            return _context5.abrupt("return", []);

          case 8:
            _context5.prev = 8;
            _context5.t0 = _context5["catch"](0);
            throw _context5.t0;

          case 11:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee3, null, [[0, 8]]);
  }));

  return function onImportProjectsRequest(_x3, _x4) {
    return _ref4.apply(this, arguments);
  };
}();
/**
 * Deprecated
 * Not being used - works with improtProjectsModal that calls this method - waits for user confirmation then this is called
 */
// export function* fetchImportProjectsDeprecated({ payload }) {
//     try {
//         // const allSecuritys = yield select(getSecurityList);
//         // let securityParams = {};
//         // for (const security of allSecuritys) {
//         //     if (security?.id === payload) {
//         //         securityParams = security;
//         //         break;
//         //     }
//         // }
//         const selectedOrg = yield select(currentOrg);
//         const fetchedProjects = yield call(fetchImportProjectsRequest, selectedOrg, payload) || [];
//         yield put(fetchImportProjectsSuccess(fetchedProjects));
//     } catch (error) {
//         yield put(showProjectMessage(error.messages));
//     }
// }
// const fetchImportProjectsRequest = async (securityId) => {
// need a call to the JIRA apis for the rest call
// 1. create api token in JIRA - https://confluence.atlassian.com/cloud/api-tokens-938839638.html
// 2. get projects - https://developer.atlassian.com/cloud/jira/platform/rest/v3/?utm_source=%2Fcloud%2Fjira%2Fplatform%2Frest%2F&utm_medium=302#api-rest-api-3-project-get
// TODO fetch via the JIRA API
//     const importProjectList = [
//         {
//             'self': 'http://your-domain.atlassian.net/rest/api/3/project/EX',
//             'id': '10058',
//             'key': 'EX',
//             'name': 'NEW-Example',
//             'avatarUrls': {
//                 '48x48': 'http://your-domain.atlassian.net/secure/projectavatar?size=large&pid=10000',
//                 '24x24': 'http://your-domain.atlassian.net/secure/projectavatar?size=small&pid=10000',
//                 '16x16': 'http://your-domain.atlassian.net/secure/projectavatar?size=xsmall&pid=10000',
//                 '32x32': 'http://your-domain.atlassian.net/secure/projectavatar?size=medium&pid=10000'
//             },
//             'projectCategory': {
//                 'self': 'http://your-domain.atlassian.net/rest/api/3/projectCategory/10000',
//                 'id': '10000',
//                 'name': 'FIRST',
//                 'description': 'First Project Category'
//             },
//             'simplified': false,
//             'style': 'classic'
//         },
//         {
//             'self': 'http://your-domain.atlassian.net/rest/api/3/project/ABC',
//             'id': '10007',
//             'key': 'KABC',
//             'name': 'KAlphabetical',
//             'avatarUrls': {
//                 '48x48': 'http://your-domain.atlassian.net/secure/projectavatar?size=large&pid=10001',
//                 '24x24': 'http://your-domain.atlassian.net/secure/projectavatar?size=small&pid=10001',
//                 '16x16': 'http://your-domain.atlassian.net/secure/projectavatar?size=xsmall&pid=10001',
//                 '32x32': 'http://your-domain.atlassian.net/secure/projectavatar?size=medium&pid=10001'
//             },
//             'projectCategory': {
//                 'self': 'http://your-domain.atlassian.net/rest/api/3/projectCategory/10000',
//                 'id': '10000',
//                 'name': 'FIRST',
//                 'description': 'First Project Category'
//             },
//             'simplified': false,
//             'style': 'netx-gen'
//         }
//     ];
//     return importProjectList;
// };

/**
 * Not in effect at the moment. Set the end date to finalise the project life
 * @param {*} param0 
 */


function deleteProject(_ref5) {
  var payload;
  return regeneratorRuntime.wrap(function deleteProject$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          payload = _ref5.payload;
          _context6.prev = 1;
          _context6.next = 4;
          return (0, _effects.call)(deleteProjectRequest, payload === null || payload === void 0 ? void 0 : payload.id);

        case 4:
          _context6.next = 6;
          return (0, _effects.put)((0, _project.onDeleteProjectSuccess)(payload === null || payload === void 0 ? void 0 : payload.id));

        case 6:
          _context6.next = 12;
          break;

        case 8:
          _context6.prev = 8;
          _context6.t0 = _context6["catch"](1);
          _context6.next = 12;
          return (0, _effects.put)((0, _project.showProjectMessage)(_context6.t0.messages));

        case 12:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked3, null, [[1, 8]]);
}

var deleteProjectRequest =
/*#__PURE__*/
function () {
  var _ref6 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee4() {
    return regeneratorRuntime.wrap(function _callee4$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee4);
  }));

  return function deleteProjectRequest() {
    return _ref6.apply(this, arguments);
  };
}();

function saveProject(_ref7) {
  var payload, allProjects, selectedOrg, savedProject;
  return regeneratorRuntime.wrap(function saveProject$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          payload = _ref7.payload;
          _context8.prev = 1;
          _context8.next = 4;
          return (0, _effects.select)(getProjectList);

        case 4:
          allProjects = _context8.sent;
          _context8.next = 7;
          return (0, _effects.select)(currentOrg);

        case 7:
          selectedOrg = _context8.sent;
          _context8.next = 10;
          return (0, _effects.call)(_ApiService.addOrUpdateDataRequest, allProjects, payload, _api.PROJECT_ADD_ENDPOINT, _api.PROJECT_UPDATE_ENDPOINT, [_api.ORGID_PATH_PARAM], [selectedOrg.id]);

        case 10:
          savedProject = _context8.sent;
          _context8.next = 13;
          return (0, _effects.put)((0, _project.onSaveProjectSuccess)(savedProject));

        case 13:
          _context8.next = 19;
          break;

        case 15:
          _context8.prev = 15;
          _context8.t0 = _context8["catch"](1);
          _context8.next = 19;
          return (0, _effects.put)((0, _project.showProjectMessage)((0, _errorService.apiErrorMessageFormatter)(_context8.t0)));

        case 19:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked4, null, [[1, 15]]);
}
/**
 * This is when the user selects the star on the list page - update the starred attribute of the entity
 * @param {*} param0 
 */


function addFavouriteProject(_ref8) {
  var payload, allProjects, selectedOrg, filtered, entry, updated, auditMsg;
  return regeneratorRuntime.wrap(function addFavouriteProject$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          payload = _ref8.payload;
          _context9.prev = 1;
          _context9.next = 4;
          return (0, _effects.select)(getProjectList);

        case 4:
          allProjects = _context9.sent;
          _context9.next = 7;
          return (0, _effects.select)(currentOrg);

        case 7:
          selectedOrg = _context9.sent;
          filtered = allProjects === null || allProjects === void 0 ? void 0 : allProjects.filter(function (entry) {
            return (entry === null || entry === void 0 ? void 0 : entry.id) === (payload === null || payload === void 0 ? void 0 : payload.id);
          });

          if (!((filtered === null || filtered === void 0 ? void 0 : filtered.length) > 0)) {
            _context9.next = 17;
            break;
          }

          entry = filtered[0];
          updated = _objectSpread({}, entry, {
            starred: !payload.starred
          });
          auditMsg = 'Updating starred setting to '.concat(updated === null || updated === void 0 ? void 0 : updated.starred).concat(' for project id ').concat(updated === null || updated === void 0 ? void 0 : updated.id);
          _context9.next = 15;
          return (0, _effects.call)(_ApiService.updateDataRequest, updated, _api.PROJECT_UPDATE_ENDPOINT, auditMsg, [_api.ORGID_PATH_PARAM], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id]);

        case 15:
          _context9.next = 17;
          return (0, _effects.put)((0, _project.addFavouriteProjectSuccess)(payload));

        case 17:
          _context9.next = 23;
          break;

        case 19:
          _context9.prev = 19;
          _context9.t0 = _context9["catch"](1);
          _context9.next = 23;
          return (0, _effects.put)((0, _project.showProjectMessage)(_context9.t0.messages));

        case 23:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked5, null, [[1, 19]]);
}

function fetchProjectsSaga() {
  return regeneratorRuntime.wrap(function fetchProjectsSaga$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_ALL_PROJECT, fetchProjects);

        case 2:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked6);
}

function saveProjectSaga() {
  return regeneratorRuntime.wrap(function saveProjectSaga$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_SAVE_PROJECT, saveProject);

        case 2:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked7);
}

function deleteProjectSaga() {
  return regeneratorRuntime.wrap(function deleteProjectSaga$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_DELETE_PROJECT, deleteProject);

        case 2:
        case "end":
          return _context12.stop();
      }
    }
  }, _marked8);
} // export function* fetchImportProjectsSaga() {
//     yield takeEvery(FETCH_IMPORT_PROJECTS, fetchImportProjects);
// }


function onImportProjectsSaga() {
  return regeneratorRuntime.wrap(function onImportProjectsSaga$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_IMPORT_PROJECTS, onImportProjects);

        case 2:
        case "end":
          return _context13.stop();
      }
    }
  }, _marked9);
}

function addFavouriteProjectSaga() {
  return regeneratorRuntime.wrap(function addFavouriteProjectSaga$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ADD_FAVOURITE_PROJECT, addFavouriteProject);

        case 2:
        case "end":
          return _context14.stop();
      }
    }
  }, _marked10);
}

function rootSaga() {
  return regeneratorRuntime.wrap(function rootSaga$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return (0, _effects.all)([(0, _effects.fork)(fetchProjectsSaga), (0, _effects.fork)(addFavouriteProjectSaga), (0, _effects.fork)(saveProjectSaga), (0, _effects.fork)(deleteProjectSaga), // fork(fetchImportProjectsSaga),
          (0, _effects.fork)(onImportProjectsSaga)]);

        case 2:
        case "end":
          return _context15.stop();
      }
    }
  }, _marked11);
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(importedProjects, "importedProjects", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(getProjectList, "getProjectList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(getProjectCacheList, "getProjectCacheList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(fetchProjectsRequest, "fetchProjectsRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(fetchImportProjectsRequest, "fetchImportProjectsRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(fetchProjects, "fetchProjects", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(onImportProjects, "onImportProjects", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(onImportProjectsRequest, "onImportProjectsRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(deleteProject, "deleteProject", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(deleteProjectRequest, "deleteProjectRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(saveProject, "saveProject", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(addFavouriteProject, "addFavouriteProject", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(fetchProjectsSaga, "fetchProjectsSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(saveProjectSaga, "saveProjectSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(deleteProjectSaga, "deleteProjectSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(onImportProjectsSaga, "onImportProjectsSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(addFavouriteProjectSaga, "addFavouriteProjectSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(_marked, "_marked", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(_marked2, "_marked2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(_marked3, "_marked3", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(_marked4, "_marked4", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(_marked5, "_marked5", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(_marked6, "_marked6", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(_marked7, "_marked7", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(_marked8, "_marked8", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(_marked9, "_marked9", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(_marked10, "_marked10", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(_marked11, "_marked11", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(asyncGeneratorStep, "asyncGeneratorStep", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(_asyncToGenerator, "_asyncToGenerator", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(importedProjects, "importedProjects", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(getProjectList, "getProjectList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(getProjectCacheList, "getProjectCacheList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(fetchProjectsRequest, "fetchProjectsRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(fetchImportProjectsRequest, "fetchImportProjectsRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(fetchProjects, "fetchProjects", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(onImportProjects, "onImportProjects", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(onImportProjectsRequest, "onImportProjectsRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(deleteProject, "deleteProject", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(deleteProjectRequest, "deleteProjectRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(saveProject, "saveProject", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(addFavouriteProject, "addFavouriteProject", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(fetchProjectsSaga, "fetchProjectsSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(saveProjectSaga, "saveProjectSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(deleteProjectSaga, "deleteProjectSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(onImportProjectsSaga, "onImportProjectsSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(addFavouriteProjectSaga, "addFavouriteProjectSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/project.js");
}();

;

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteProjectPriority = deleteProjectPriority;
exports.saveProjectPriority = saveProjectPriority;
exports.saveProjectPrioritySaga = saveProjectPrioritySaga;
exports.deleteProjectPrioritySaga = deleteProjectPrioritySaga;
exports.updateProjectPrioritiesSaga = updateProjectPrioritiesSaga;
exports["default"] = rootSaga;
exports.saveProjectPriorityRequest = void 0;

var _effects = __webpack_require__(15);

var _projectPriority = __webpack_require__(364);

var _project = __webpack_require__(179);

var _ActionTypes = __webpack_require__(7);

var _Authentication = __webpack_require__(42);

var _ApiService = __webpack_require__(16);

var _errorService = __webpack_require__(50);

var _projectService = __webpack_require__(175);

var _api = __webpack_require__(25);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(updateProjectPriorities),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(deleteProjectPriority),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(saveProjectPriority),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(saveProjectPrioritySaga),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(deleteProjectPrioritySaga),
    _marked6 =
/*#__PURE__*/
regeneratorRuntime.mark(updateProjectPrioritiesSaga),
    _marked7 =
/*#__PURE__*/
regeneratorRuntime.mark(rootSaga);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var currentOrg = function currentOrg(state) {
  return state.orgs.selectedOrg;
};

var getProjectList = function getProjectList(state) {
  return state.projects.allProject;
};

var getSelectedProject = function getSelectedProject(state) {
  return state.projects.selectedProject;
};

var getProjectPriorityList = function getProjectPriorityList(state) {
  return state.projectPrioritys.allProjectPriority;
}; // get all active and inactive


var updatingProjectCostPriorities = function updatingProjectCostPriorities(state) {
  return state.projectPrioritys.updatingProjectCostPriorities;
};

var updatingProjectBusinessPriorities = function updatingProjectBusinessPriorities(state) {
  return state.projectPrioritys.updatingProjectBusinessPriorities;
};

var updatingGlobalPrioritiesState = function updatingGlobalPrioritiesState(state) {
  return state.projectPrioritys.updatingGlobalPriorities;
};
/**
 * Per project - go through the param list being changed - then update all corresponding entries and then save the project as a whole
 * This will either update an existing entry (name and desc only) or add a new entry if it doesnt exist - used by the priority update and add priority
 * NOTE 1 - just pass the payload as the api does all the hard work (could be multiple updates so reduce the noise on the network)
 * NOTE 2 - the value of the priority cannot be changed so no need to recalculate the weight of the project
 * @param {*} payload {id, name, descrition, weight} 
 */


function updateProjectPriorities(_ref) {
  var payload, _selectedProject$busV, selectedOrg, updatingBusinessPriorities, newPayload, auditLogMessage, auditLog, endpointConfig, newProjectList, selectedProject, updatedPayload;

  return regeneratorRuntime.wrap(function updateProjectPriorities$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _ref.payload;
          _context.prev = 1;
          _context.next = 4;
          return (0, _effects.select)(currentOrg);

        case 4:
          selectedOrg = _context.sent;
          _context.next = 7;
          return (0, _effects.select)(updatingProjectBusinessPriorities);

        case 7:
          updatingBusinessPriorities = _context.sent; // change the payload to include the orgid for security reasons - checks against the path param

          newPayload = {
            orgid: selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id,
            priority: _objectSpread({}, payload)
          };
          auditLogMessage = updatingBusinessPriorities ? 'Updating business priorities name and description' : 'Updating cost priorities name and description';
          auditLog = {
            message: auditLogMessage,
            name: payload.name,
            description: payload.description
          };
          endpointConfig = updatingBusinessPriorities ? _api.PROJECT_BUS_PRIORITIES_UPDATE_ENDPOINT : _api.PROJECT_COST_PRIORITIES_UPDATE_ENDPOINT;
          _context.next = 14;
          return (0, _effects.call)(_ApiService.updateDataRequest, newPayload, endpointConfig, auditLog, [_api.ORGID_PATH_PARAM], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id]);

        case 14:
          newProjectList = _context.sent; // need to update the store with the updated priorities

          selectedProject = (newProjectList === null || newProjectList === void 0 ? void 0 : newProjectList.length) > 0 ? newProjectList[0] : [];
          updatedPayload = selectedProject && (selectedProject === null || selectedProject === void 0 ? void 0 : (_selectedProject$busV = selectedProject.busValPriorityParams) === null || _selectedProject$busV === void 0 ? void 0 : _selectedProject$busV.length) > 0 ? selectedProject.busValPriorityParams : [];
          _context.next = 19;
          return (0, _effects.put)((0, _project.onProjectPrioritiesDashboard)(selectedProject));

        case 19:
          if (!updatingBusinessPriorities) {
            _context.next = 24;
            break;
          }

          _context.next = 22;
          return (0, _effects.put)((0, _project.onGlobalProjectBusinessPrioritiesDashboard)(updatedPayload));

        case 22:
          _context.next = 26;
          break;

        case 24:
          _context.next = 26;
          return (0, _effects.put)((0, _project.onGlobalProjectCostPrioritiesDashboard)(updatedPayload));

        case 26:
          _context.next = 28;
          return (0, _effects.put)((0, _project.onSaveProjectSuccess)(newProjectList));

        case 28:
          _context.next = 34;
          break;

        case 30:
          _context.prev = 30;
          _context.t0 = _context["catch"](1);
          _context.next = 34;
          return (0, _effects.put)((0, _projectPriority.showProjectPriorityMessage)((0, _errorService.apiErrorMessageFormatter)(_context.t0)));

        case 34:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[1, 30]]);
}
/**
 * delete will remove all corresponding entries in all projects - done via the api - Will get the updated payload to put back in the store
 * @param {*} param0 
 */


function deleteProjectPriority(_ref2) {
  var payload, _selectedProject$busV2, selectedOrg, updatingBusinessPriorities, newPayload, auditLogMessage, auditLog, endpointConfig, newProjectList, selectedProject, updatedPayload;

  return regeneratorRuntime.wrap(function deleteProjectPriority$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _ref2.payload;
          _context2.prev = 1;
          _context2.next = 4;
          return (0, _effects.select)(currentOrg);

        case 4:
          selectedOrg = _context2.sent;
          _context2.next = 7;
          return (0, _effects.select)(updatingProjectBusinessPriorities);

        case 7:
          updatingBusinessPriorities = _context2.sent; // change the payload to include the orgid for security reasons - checks against the path param

          newPayload = {
            orgid: selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id,
            priority: _objectSpread({}, payload)
          };
          auditLogMessage = updatingBusinessPriorities ? 'Deleting business priorities by name match' : 'Deleting cost priorities by name match';
          auditLog = {
            message: auditLogMessage,
            name: payload.name
          };
          endpointConfig = updatingBusinessPriorities ? _api.PROJECT_BUS_PRIORITIES_DELETE_ENDPOINT : _api.PROJECT_COST_PRIORITIES_DELETE_ENDPOINT;
          _context2.next = 14;
          return (0, _effects.call)(_ApiService.updateDataRequest, newPayload, endpointConfig, auditLog, [_api.ORGID_PATH_PARAM], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id]);

        case 14:
          newProjectList = _context2.sent; // need to update the store with the updated priorities

          selectedProject = (newProjectList === null || newProjectList === void 0 ? void 0 : newProjectList.length) > 0 ? newProjectList[0] : [];
          updatedPayload = selectedProject && (selectedProject === null || selectedProject === void 0 ? void 0 : (_selectedProject$busV2 = selectedProject.busValPriorityParams) === null || _selectedProject$busV2 === void 0 ? void 0 : _selectedProject$busV2.length) > 0 ? selectedProject.busValPriorityParams : [];
          _context2.next = 19;
          return (0, _effects.put)((0, _project.onProjectPrioritiesDashboard)(selectedProject));

        case 19:
          if (!updatingBusinessPriorities) {
            _context2.next = 24;
            break;
          }

          _context2.next = 22;
          return (0, _effects.put)((0, _project.onGlobalProjectBusinessPrioritiesDashboard)(updatedPayload));

        case 22:
          _context2.next = 26;
          break;

        case 24:
          _context2.next = 26;
          return (0, _effects.put)((0, _project.onGlobalProjectCostPrioritiesDashboard)(updatedPayload));

        case 26:
          _context2.next = 28;
          return (0, _effects.put)((0, _project.onSaveProjectSuccess)(newProjectList));

        case 28:
          _context2.next = 34;
          break;

        case 30:
          _context2.prev = 30;
          _context2.t0 = _context2["catch"](1);
          _context2.next = 34;
          return (0, _effects.put)((0, _projectPriority.showProjectPriorityMessage)((0, _errorService.apiErrorMessageFormatter)(_context2.t0)));

        case 34:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 30]]);
}

function saveProjectPriority(_ref3) {
  var payload, selectedOrg, projectList, selectedProject, allProjectPrioritys, updatingCostPriorities, updatingBusinessPriorities, updatingGlobalPriorities, updatedProject, savedProject;
  return regeneratorRuntime.wrap(function saveProjectPriority$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _ref3.payload;
          _context3.prev = 1;
          _context3.next = 4;
          return (0, _effects.select)(currentOrg);

        case 4:
          selectedOrg = _context3.sent;
          _context3.next = 7;
          return (0, _effects.select)(getProjectList);

        case 7:
          projectList = _context3.sent;
          _context3.next = 10;
          return (0, _effects.select)(getSelectedProject);

        case 10:
          selectedProject = _context3.sent;
          _context3.next = 13;
          return (0, _effects.select)(getProjectPriorityList);

        case 13:
          allProjectPrioritys = _context3.sent;
          _context3.next = 16;
          return (0, _effects.select)(updatingProjectCostPriorities);

        case 16:
          updatingCostPriorities = _context3.sent;
          _context3.next = 19;
          return (0, _effects.select)(updatingProjectBusinessPriorities);

        case 19:
          updatingBusinessPriorities = _context3.sent;
          _context3.next = 22;
          return (0, _effects.select)(updatingGlobalPrioritiesState);

        case 22:
          updatingGlobalPriorities = _context3.sent;
          _context3.next = 25;
          return (0, _effects.call)(saveProjectPriorityRequest, selectedProject, allProjectPrioritys, updatingCostPriorities, updatingBusinessPriorities, updatingGlobalPriorities, payload);

        case 25:
          updatedProject = _context3.sent;
          _context3.next = 28;
          return (0, _effects.call)(_ApiService.addOrUpdateDataRequest, projectList, updatedProject, _api.PROJECT_ADD_ENDPOINT, _api.PROJECT_UPDATE_ENDPOINT, [_api.ORGID_PATH_PARAM], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id]);

        case 28:
          savedProject = _context3.sent;
          _context3.next = 31;
          return (0, _effects.put)((0, _project.onSaveProjectSuccess)(savedProject));

        case 31:
          _context3.next = 33;
          return (0, _effects.put)((0, _projectPriority.onSaveProjectPrioritySuccess)(updatingCostPriorities ? updatedProject === null || updatedProject === void 0 ? void 0 : updatedProject.costImplPriorityParams : updatedProject === null || updatedProject === void 0 ? void 0 : updatedProject.busValPriorityParams));

        case 33:
          _context3.next = 39;
          break;

        case 35:
          _context3.prev = 35;
          _context3.t0 = _context3["catch"](1);
          _context3.next = 39;
          return (0, _effects.put)((0, _projectPriority.showProjectPriorityMessage)((0, _errorService.apiErrorMessageFormatter)(_context3.t0)));

        case 39:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[1, 35]]);
}
/**
 * This simply sets up the selectedProject with the new or edited priority - then call saveProject to do the actual call
 * @param {*} selectedProject 
 * @param {*} allProjectPrioritys 
 * @param {*} updatingCostPriorities 
 * @param {*} updatingBusinessPriorities
 * @param {*} updatingGlobalPriorities 
 * @param {*} payload 
 */


var saveProjectPriorityRequest =
/*#__PURE__*/
function () {
  var _ref4 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(selectedProject, allProjectPrioritys, updatingCostPriorities, updatingBusinessPriorities, updatingGlobalPriorities, payload) {
    var isNew, updatedProject, projectPriorityList, generatedId, updatedPayload, updatedProjectWeightRecalculated;
    return regeneratorRuntime.wrap(function _callee$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            isNew = true;
            updatedProject = {};
            projectPriorityList = allProjectPrioritys.map(function (projectPriority) {
              if (projectPriority.id === payload.id) {
                isNew = false;
                return payload;
              } else {
                return projectPriority;
              }
            }); // payload is not in the list if the id is empty so add an id (not added by the api call) and add to the list

            if (isNew) {
              generatedId = (0, _Authentication.generateGuid)();
              updatedPayload = _objectSpread({}, payload, {
                id: generatedId
              });
              projectPriorityList.push(updatedPayload);
            } // now update the correct params array object in the selectedProject object


            if (updatingCostPriorities) {
              updatedProject = _objectSpread({}, selectedProject, {
                costImplPriorityParams: projectPriorityList
              });
            } else if (updatingBusinessPriorities) {
              updatedProject = _objectSpread({}, selectedProject, {
                busValPriorityParams: projectPriorityList
              });
            } // TODO api should recalc the weight on save project - used by delete priority which is done on the server


            updatedProjectWeightRecalculated = (0, _projectService.calculateWeight)(updatedProject);
            return _context4.abrupt("return", updatedProjectWeightRecalculated);

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee);
  }));

  return function saveProjectPriorityRequest(_x, _x2, _x3, _x4, _x5, _x6) {
    return _ref4.apply(this, arguments);
  };
}();

exports.saveProjectPriorityRequest = saveProjectPriorityRequest;

function saveProjectPrioritySaga() {
  return regeneratorRuntime.wrap(function saveProjectPrioritySaga$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_SAVE_PROJECT_PRIORITY, saveProjectPriority);

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked4);
}

function deleteProjectPrioritySaga() {
  return regeneratorRuntime.wrap(function deleteProjectPrioritySaga$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_DELETE_PROJECT_PRIORITY, deleteProjectPriority);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked5);
}

function updateProjectPrioritiesSaga() {
  return regeneratorRuntime.wrap(function updateProjectPrioritiesSaga$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_UPDATE_PROJECT_PRIORITIES, updateProjectPriorities);

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked6);
}

function rootSaga() {
  return regeneratorRuntime.wrap(function rootSaga$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.all)([(0, _effects.fork)(saveProjectPrioritySaga), (0, _effects.fork)(deleteProjectPrioritySaga), (0, _effects.fork)(updateProjectPrioritiesSaga)]);

        case 2:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked7);
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(getProjectList, "getProjectList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(getSelectedProject, "getSelectedProject", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(getProjectPriorityList, "getProjectPriorityList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(updatingProjectCostPriorities, "updatingProjectCostPriorities", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(updatingProjectBusinessPriorities, "updatingProjectBusinessPriorities", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(updatingGlobalPrioritiesState, "updatingGlobalPrioritiesState", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(updateProjectPriorities, "updateProjectPriorities", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(deleteProjectPriority, "deleteProjectPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(saveProjectPriority, "saveProjectPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(saveProjectPriorityRequest, "saveProjectPriorityRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(saveProjectPrioritySaga, "saveProjectPrioritySaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(deleteProjectPrioritySaga, "deleteProjectPrioritySaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(updateProjectPrioritiesSaga, "updateProjectPrioritiesSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(asyncGeneratorStep, "asyncGeneratorStep", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(_asyncToGenerator, "_asyncToGenerator", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(_marked, "_marked", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(_marked2, "_marked2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(_marked3, "_marked3", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(_marked4, "_marked4", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(_marked5, "_marked5", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(_marked6, "_marked6", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(_marked7, "_marked7", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(getProjectList, "getProjectList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(getSelectedProject, "getSelectedProject", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(getProjectPriorityList, "getProjectPriorityList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(updatingProjectCostPriorities, "updatingProjectCostPriorities", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(updatingProjectBusinessPriorities, "updatingProjectBusinessPriorities", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(updatingGlobalPrioritiesState, "updatingGlobalPrioritiesState", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(updateProjectPriorities, "updateProjectPriorities", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(deleteProjectPriority, "deleteProjectPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(saveProjectPriority, "saveProjectPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(saveProjectPriorityRequest, "saveProjectPriorityRequest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(saveProjectPrioritySaga, "saveProjectPrioritySaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(deleteProjectPrioritySaga, "deleteProjectPrioritySaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(updateProjectPrioritiesSaga, "updateProjectPrioritiesSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectPriority.js");
}();

;

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchSecuritys = fetchSecuritys;
exports.deleteSecurity = deleteSecurity;
exports.saveSecurity = saveSecurity;
exports.addFavouriteSecurity = addFavouriteSecurity;
exports.fetchSecuritysSaga = fetchSecuritysSaga;
exports.saveSecuritySaga = saveSecuritySaga;
exports.deleteSecuritySaga = deleteSecuritySaga;
exports.addFavouriteSecuritySaga = addFavouriteSecuritySaga;
exports["default"] = rootSaga;

var _effects = __webpack_require__(15);

var _security = __webpack_require__(262);

var _ActionTypes = __webpack_require__(7);

var _ApiService = __webpack_require__(16);

var _errorService = __webpack_require__(50);

var _api = __webpack_require__(25);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(fetchSecuritys),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(deleteSecurity),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(saveSecurity),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(addFavouriteSecurity),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchSecuritysSaga),
    _marked6 =
/*#__PURE__*/
regeneratorRuntime.mark(saveSecuritySaga),
    _marked7 =
/*#__PURE__*/
regeneratorRuntime.mark(deleteSecuritySaga),
    _marked8 =
/*#__PURE__*/
regeneratorRuntime.mark(addFavouriteSecuritySaga),
    _marked9 =
/*#__PURE__*/
regeneratorRuntime.mark(rootSaga);

var currentOrg = function currentOrg(state) {
  return state.orgs.selectedOrg;
};

var getSecurityList = function getSecurityList(state) {
  return state.securitys.allSecurity;
};

function fetchSecuritys() {
  var selectedOrg, fetchedSecuritys;
  return regeneratorRuntime.wrap(function fetchSecuritys$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.select)(currentOrg);

        case 3:
          selectedOrg = _context.sent;
          _context.next = 6;
          return (0, _effects.call)(_ApiService.fetchDataRequest, 'securitys', [_api.ORGID_PATH_PARAM], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id]) || [];

        case 6:
          fetchedSecuritys = _context.sent;
          _context.next = 9;
          return (0, _effects.put)((0, _security.fetchSecuritysSuccess)(fetchedSecuritys));

        case 9:
          _context.next = 15;
          break;

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](0);
          _context.next = 15;
          return (0, _effects.put)((0, _security.showSecurityMessage)((0, _errorService.apiErrorMessageFormatter)(_context.t0)));

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 11]]);
}

function deleteSecurity(_ref) {
  var payload, selectedOrg;
  return regeneratorRuntime.wrap(function deleteSecurity$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _ref.payload;
          _context2.prev = 1;
          _context2.next = 4;
          return (0, _effects.select)(currentOrg);

        case 4:
          selectedOrg = _context2.sent;
          _context2.next = 7;
          return (0, _effects.call)(_ApiService.deleteDataRequest, 'deleteSecurity', 'Deleting security '.concat(payload), [_api.ORGID_PATH_PARAM, 'securityId'], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id, payload]) || [];

        case 7:
          _context2.next = 9;
          return (0, _effects.put)((0, _security.onDeleteSecuritySuccess)(payload));

        case 9:
          _context2.next = 15;
          break;

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](1);
          _context2.next = 15;
          return (0, _effects.put)((0, _security.showSecurityMessage)((0, _errorService.apiErrorMessageFormatter)(_context2.t0)));

        case 15:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 11]]);
}

function saveSecurity(_ref2) {
  var payload, selectedOrg, allSecuritys, finalPayload, savedSecurity;
  return regeneratorRuntime.wrap(function saveSecurity$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _ref2.payload;
          _context3.prev = 1;
          _context3.next = 4;
          return (0, _effects.select)(currentOrg);

        case 4:
          selectedOrg = _context3.sent;
          _context3.next = 7;
          return (0, _effects.select)(getSecurityList);

        case 7:
          allSecuritys = _context3.sent;
          finalPayload = _objectSpread({}, payload); // check the orgid of the payload - it will be empty for a new payload - populate from the selectedOrg - otherwise leave it as is

          if (!(payload === null || payload === void 0 ? void 0 : payload.orgid)) {
            finalPayload = _objectSpread({}, payload, {
              orgid: selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id
            });
          }

          _context3.next = 12;
          return (0, _effects.call)(_ApiService.addOrUpdateDataRequest, allSecuritys, finalPayload, 'addSecurity', 'updateSecurity', [_api.ORGID_PATH_PARAM], [selectedOrg.id]);

        case 12:
          savedSecurity = _context3.sent;
          _context3.next = 15;
          return (0, _effects.put)((0, _security.onSaveSecuritySuccess)(savedSecurity));

        case 15:
          _context3.next = 21;
          break;

        case 17:
          _context3.prev = 17;
          _context3.t0 = _context3["catch"](1);
          _context3.next = 21;
          return (0, _effects.put)((0, _security.showSecurityMessage)((0, _errorService.apiErrorMessageFormatter)(_context3.t0)));

        case 21:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[1, 17]]);
}
/**
 * This is when the user selects the star on the list page - update the starred attribute of the entity
 * @param {*} param0 
 */


function addFavouriteSecurity(_ref3) {
  var payload, allSecuritys, selectedOrg, filtered, entry, updatedSecurity, auditMsg;
  return regeneratorRuntime.wrap(function addFavouriteSecurity$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _ref3.payload;
          _context4.prev = 1;
          _context4.next = 4;
          return (0, _effects.select)(getSecurityList);

        case 4:
          allSecuritys = _context4.sent;
          _context4.next = 7;
          return (0, _effects.select)(currentOrg);

        case 7:
          selectedOrg = _context4.sent;
          filtered = allSecuritys.filter(function (entry) {
            return (entry === null || entry === void 0 ? void 0 : entry.id) === (payload === null || payload === void 0 ? void 0 : payload.id);
          });

          if (!((filtered === null || filtered === void 0 ? void 0 : filtered.length) > 0)) {
            _context4.next = 17;
            break;
          }

          entry = filtered[0];
          updatedSecurity = _objectSpread({}, entry, {
            starred: !payload.starred
          });
          auditMsg = 'Updating starred setting to '.concat(updatedSecurity === null || updatedSecurity === void 0 ? void 0 : updatedSecurity.starred).concat(' for security ').concat(updatedSecurity === null || updatedSecurity === void 0 ? void 0 : updatedSecurity.id);
          _context4.next = 15;
          return (0, _effects.call)(_ApiService.updateDataRequest, updatedSecurity, 'updateSecurity', auditMsg, [_api.ORGID_PATH_PARAM], [selectedOrg.id]);

        case 15:
          _context4.next = 17;
          return (0, _effects.put)((0, _security.addFavouriteSecuritySuccess)(payload));

        case 17:
          _context4.next = 23;
          break;

        case 19:
          _context4.prev = 19;
          _context4.t0 = _context4["catch"](1);
          _context4.next = 23;
          return (0, _effects.put)((0, _security.showSecurityMessage)(_context4.t0.messages));

        case 23:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[1, 19]]);
}

function fetchSecuritysSaga() {
  return regeneratorRuntime.wrap(function fetchSecuritysSaga$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_ALL_SECURITY, fetchSecuritys);

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

function saveSecuritySaga() {
  return regeneratorRuntime.wrap(function saveSecuritySaga$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_SAVE_SECURITY, saveSecurity);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}

function deleteSecuritySaga() {
  return regeneratorRuntime.wrap(function deleteSecuritySaga$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_DELETE_SECURITY, deleteSecurity);

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}

function addFavouriteSecuritySaga() {
  return regeneratorRuntime.wrap(function addFavouriteSecuritySaga$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ADD_FAVOURITE_SECURITY, addFavouriteSecurity);

        case 2:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}

function rootSaga() {
  return regeneratorRuntime.wrap(function rootSaga$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.all)([(0, _effects.fork)(fetchSecuritysSaga), (0, _effects.fork)(saveSecuritySaga), (0, _effects.fork)(deleteSecuritySaga), (0, _effects.fork)(addFavouriteSecuritySaga)]);

        case 2:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/security.js");

  __REACT_HOT_LOADER__.register(getSecurityList, "getSecurityList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/security.js");

  __REACT_HOT_LOADER__.register(fetchSecuritys, "fetchSecuritys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/security.js");

  __REACT_HOT_LOADER__.register(deleteSecurity, "deleteSecurity", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/security.js");

  __REACT_HOT_LOADER__.register(saveSecurity, "saveSecurity", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/security.js");

  __REACT_HOT_LOADER__.register(addFavouriteSecurity, "addFavouriteSecurity", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/security.js");

  __REACT_HOT_LOADER__.register(fetchSecuritysSaga, "fetchSecuritysSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/security.js");

  __REACT_HOT_LOADER__.register(saveSecuritySaga, "saveSecuritySaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/security.js");

  __REACT_HOT_LOADER__.register(deleteSecuritySaga, "deleteSecuritySaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/security.js");

  __REACT_HOT_LOADER__.register(addFavouriteSecuritySaga, "addFavouriteSecuritySaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/security.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/security.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/security.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/security.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/security.js");

  __REACT_HOT_LOADER__.register(_marked, "_marked", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/security.js");

  __REACT_HOT_LOADER__.register(_marked2, "_marked2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/security.js");

  __REACT_HOT_LOADER__.register(_marked3, "_marked3", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/security.js");

  __REACT_HOT_LOADER__.register(_marked4, "_marked4", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/security.js");

  __REACT_HOT_LOADER__.register(_marked5, "_marked5", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/security.js");

  __REACT_HOT_LOADER__.register(_marked6, "_marked6", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/security.js");

  __REACT_HOT_LOADER__.register(_marked7, "_marked7", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/security.js");

  __REACT_HOT_LOADER__.register(_marked8, "_marked8", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/security.js");

  __REACT_HOT_LOADER__.register(_marked9, "_marked9", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/security.js");

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/security.js");

  __REACT_HOT_LOADER__.register(getSecurityList, "getSecurityList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/security.js");

  __REACT_HOT_LOADER__.register(fetchSecuritys, "fetchSecuritys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/security.js");

  __REACT_HOT_LOADER__.register(deleteSecurity, "deleteSecurity", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/security.js");

  __REACT_HOT_LOADER__.register(saveSecurity, "saveSecurity", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/security.js");

  __REACT_HOT_LOADER__.register(addFavouriteSecurity, "addFavouriteSecurity", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/security.js");

  __REACT_HOT_LOADER__.register(fetchSecuritysSaga, "fetchSecuritysSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/security.js");

  __REACT_HOT_LOADER__.register(saveSecuritySaga, "saveSecuritySaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/security.js");

  __REACT_HOT_LOADER__.register(deleteSecuritySaga, "deleteSecuritySaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/security.js");

  __REACT_HOT_LOADER__.register(addFavouriteSecuritySaga, "addFavouriteSecuritySaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/security.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/security.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/security.js");
}();

;

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchProjectIssues = fetchProjectIssues;
exports.deleteProjectIssue = deleteProjectIssue;
exports.saveProjectIssue = saveProjectIssue;
exports.saveJiraProjectIssue = saveJiraProjectIssue;
exports.addFavouriteProjectIssue = addFavouriteProjectIssue;
exports.fetchProjectIssuesSaga = fetchProjectIssuesSaga;
exports.saveProjectIssueSaga = saveProjectIssueSaga;
exports.saveJiraProjectIssueSaga = saveJiraProjectIssueSaga;
exports.deleteProjectIssueSaga = deleteProjectIssueSaga;
exports.addFavouriteProjectIssueSaga = addFavouriteProjectIssueSaga;
exports["default"] = rootSaga;

var _effects = __webpack_require__(15);

var _projectIssue = __webpack_require__(365);

var _ActionTypes = __webpack_require__(7);

var _ApiService = __webpack_require__(16);

var _errorService = __webpack_require__(50);

var _projectIssueService = __webpack_require__(659);

var _api = __webpack_require__(25);

var _lodash = __webpack_require__(72);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(fetchProjectIssues),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(deleteProjectIssue),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(saveProjectIssue),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(saveJiraProjectIssue),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(addFavouriteProjectIssue),
    _marked6 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchProjectIssuesSaga),
    _marked7 =
/*#__PURE__*/
regeneratorRuntime.mark(saveProjectIssueSaga),
    _marked8 =
/*#__PURE__*/
regeneratorRuntime.mark(saveJiraProjectIssueSaga),
    _marked9 =
/*#__PURE__*/
regeneratorRuntime.mark(deleteProjectIssueSaga),
    _marked10 =
/*#__PURE__*/
regeneratorRuntime.mark(addFavouriteProjectIssueSaga),
    _marked11 =
/*#__PURE__*/
regeneratorRuntime.mark(rootSaga);

var currentOrg = function currentOrg(state) {
  return state.orgs.selectedOrg || {};
};

var getProjectIssueList = function getProjectIssueList(state) {
  return state.projectIssues.allProjectIssue || [];
};

var getProjectIssueCacheList = function getProjectIssueCacheList(state) {
  return state.projectIssues.projectIssueCacheList || [];
};

var getSelectedProject = function getSelectedProject(state) {
  return state.projects.selectedProject || {};
};
/**
 * On going to the dashboard - check if the project issue data is stale (they have the option refresh) - if so re-retrieve
 * @param {boolean} param0 - use cache which is true or false to use the cache or direct retrieve from api 
 */


function fetchProjectIssues(_ref) {
  var payload, useCache, selectedOrg, selectedProject, allProjectCacheIssues, sanitizedCacheIssues, cacheEntry, now, _fetchProjectIssues, fetchedProjectIssues, replaceCachedEntry, addCachedEntry, _payload$jiraProjectA, importProjectId, index, newCacheEntry, _newCacheEntry;

  return regeneratorRuntime.wrap(function fetchProjectIssues$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _ref.payload;
          _context.prev = 1;
          useCache = payload; // for readability - dont judge me :->

          _context.next = 5;
          return (0, _effects.select)(currentOrg);

        case 5:
          selectedOrg = _context.sent;
          _context.next = 8;
          return (0, _effects.select)(getSelectedProject);

        case 8:
          selectedProject = _context.sent;
          _context.next = 11;
          return (0, _effects.select)(getProjectIssueCacheList);

        case 11:
          allProjectCacheIssues = _context.sent;
          _context.next = 14;
          return (0, _effects.call)(_projectIssueService.sanitizeProjectIssueCache, allProjectCacheIssues);

        case 14:
          sanitizedCacheIssues = _context.sent;
          cacheEntry = sanitizedCacheIssues.find(function (entry) {
            return (entry === null || entry === void 0 ? void 0 : entry.id) === (selectedProject === null || selectedProject === void 0 ? void 0 : selectedProject.id);
          });
          now = new Date(); // TODO - do we check project issue metadata to see if < 500 if so forget the cache and retrieve every time ?

          _fetchProjectIssues = false;
          fetchedProjectIssues = {};
          replaceCachedEntry = false;
          addCachedEntry = false;

          if (!cacheEntry) {
            _context.next = 36;
            break;
          }

          if (!useCache) {
            _context.next = 32;
            break;
          }

          if (!(0, _projectIssueService.projectIssueCacheExpired)(cacheEntry === null || cacheEntry === void 0 ? void 0 : cacheEntry.lastUpdated)) {
            _context.next = 28;
            break;
          } // entry has expired so retrieve and set


          _fetchProjectIssues = true;
          replaceCachedEntry = true;
          _context.next = 30;
          break;

        case 28:
          _context.next = 30;
          return (0, _effects.put)((0, _projectIssue.fetchProjectIssuesSuccess)(cacheEntry === null || cacheEntry === void 0 ? void 0 : cacheEntry.issueData));

        case 30:
          _context.next = 34;
          break;

        case 32:
          // have cache entry but force refresh so retrieve and set
          _fetchProjectIssues = true;
          replaceCachedEntry = true;

        case 34:
          _context.next = 38;
          break;

        case 36:
          // no cache entry so fetch and add to cache
          _fetchProjectIssues = true;
          addCachedEntry = true;

        case 38:
          if (!_fetchProjectIssues) {
            _context.next = 45;
            break;
          }

          importProjectId = payload === null || payload === void 0 ? void 0 : (_payload$jiraProjectA = payload.jiraProjectAttributes) === null || _payload$jiraProjectA === void 0 ? void 0 : _payload$jiraProjectA.key;
          _context.next = 42;
          return (0, _effects.call)(_ApiService.fetchDataRequest, 'projectIssues', [_api.ORGID_PATH_PARAM, _api.PROJECTID_PATH_PARAM], // [selectedOrg?.id, payload?.jiraProjectAttributes?.key]
          [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id, importProjectId]) || [];

        case 42:
          fetchedProjectIssues = _context.sent;
          _context.next = 45;
          return (0, _effects.put)((0, _projectIssue.fetchProjectIssuesSuccess)(fetchedProjectIssues));

        case 45:
          if (!replaceCachedEntry) {
            _context.next = 53;
            break;
          }

          index = (0, _lodash.findIndex)(sanitizedCacheIssues, {
            id: cacheEntry === null || cacheEntry === void 0 ? void 0 : cacheEntry.id
          });
          newCacheEntry = {
            id: cacheEntry === null || cacheEntry === void 0 ? void 0 : cacheEntry.id,
            lastUpdated: now,
            issueData: fetchedProjectIssues
          };
          sanitizedCacheIssues.splice(index, 1, newCacheEntry);
          _context.next = 51;
          return (0, _effects.put)((0, _projectIssue.onSaveProjectIssueCacheSuccess)(sanitizedCacheIssues));

        case 51:
          _context.next = 58;
          break;

        case 53:
          if (!addCachedEntry) {
            _context.next = 58;
            break;
          }

          _newCacheEntry = {
            id: selectedProject === null || selectedProject === void 0 ? void 0 : selectedProject.id,
            lastUpdated: now,
            issueData: fetchedProjectIssues
          };
          sanitizedCacheIssues.push(_newCacheEntry);
          _context.next = 58;
          return (0, _effects.put)((0, _projectIssue.onSaveProjectIssueCacheSuccess)(sanitizedCacheIssues));

        case 58:
          _context.next = 64;
          break;

        case 60:
          _context.prev = 60;
          _context.t0 = _context["catch"](1);
          _context.next = 64;
          return (0, _effects.put)((0, _projectIssue.showProjectIssueMessage)((0, _errorService.apiErrorMessageFormatter)(_context.t0)));

        case 64:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[1, 60]]);
}

function deleteProjectIssue(_ref2) {
  var payload, selectedOrg;
  return regeneratorRuntime.wrap(function deleteProjectIssue$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _ref2.payload;
          _context2.prev = 1;
          _context2.next = 4;
          return (0, _effects.select)(currentOrg);

        case 4:
          selectedOrg = _context2.sent;
          _context2.next = 7;
          return (0, _effects.call)(_ApiService.deleteDataRequest, 'deleteProjectIssue', 'Deleting project issue '.concat(payload), [_api.ORGID_PATH_PARAM, 'projectIssueId'], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id, payload]) || [];

        case 7:
          _context2.next = 9;
          return (0, _effects.put)((0, _projectIssue.onDeleteProjectIssueSuccess)(payload));

        case 9:
          _context2.next = 15;
          break;

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](1);
          _context2.next = 15;
          return (0, _effects.put)((0, _projectIssue.showProjectIssueMessage)((0, _errorService.apiErrorMessageFormatter)(_context2.t0)));

        case 15:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 11]]);
}

function saveProjectIssue(_ref3) {
  var payload, selectedOrg, allProjectIssues, selectedProject, finalPayload, savedProjectIssue;
  return regeneratorRuntime.wrap(function saveProjectIssue$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _ref3.payload;
          _context3.prev = 1;
          _context3.next = 4;
          return (0, _effects.select)(currentOrg);

        case 4:
          selectedOrg = _context3.sent;
          _context3.next = 7;
          return (0, _effects.select)(getProjectIssueList);

        case 7:
          allProjectIssues = _context3.sent;
          _context3.next = 10;
          return (0, _effects.select)(getSelectedProject);

        case 10:
          selectedProject = _context3.sent;
          finalPayload = _objectSpread({}, payload); // check the orgid of the payload - it will be empty for a new payload - populate from the selectedOrg - otherwise leave it as is

          if ((payload === null || payload === void 0 ? void 0 : payload.orgid) === '') {
            finalPayload = _objectSpread({}, payload, {
              orgid: selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id
            });
          }

          _context3.next = 15;
          return (0, _effects.call)(_ApiService.addOrUpdateDataRequest, allProjectIssues, finalPayload, 'addProjectIssue', 'updateProjectIssue', [_api.ORGID_PATH_PARAM, 'projectId'], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id, selectedProject === null || selectedProject === void 0 ? void 0 : selectedProject.id]);

        case 15:
          savedProjectIssue = _context3.sent;
          _context3.next = 18;
          return (0, _effects.put)((0, _projectIssue.onSaveProjectIssueSuccess)(savedProjectIssue));

        case 18:
          _context3.next = 24;
          break;

        case 20:
          _context3.prev = 20;
          _context3.t0 = _context3["catch"](1);
          _context3.next = 24;
          return (0, _effects.put)((0, _projectIssue.showProjectIssueMessage)((0, _errorService.apiErrorMessageFormatter)(_context3.t0)));

        case 24:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[1, 20]]);
}

function saveJiraProjectIssue(_ref4) {
  var payload, selectedOrg, allProjectIssues, finalPayload, savedProjectIssues;
  return regeneratorRuntime.wrap(function saveJiraProjectIssue$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _ref4.payload;
          _context4.prev = 1;
          _context4.next = 4;
          return (0, _effects.select)(currentOrg);

        case 4:
          selectedOrg = _context4.sent;
          _context4.next = 7;
          return (0, _effects.select)(getProjectIssueList);

        case 7:
          allProjectIssues = _context4.sent;
          finalPayload = _objectSpread({}, payload); // check the orgid of the payload - it will be empty for a new payload - populate from the selectedOrg - otherwise leave it as is

          if ((payload === null || payload === void 0 ? void 0 : payload.orgid) === '') {
            finalPayload = _objectSpread({}, payload, {
              orgid: selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id
            });
          }

          _context4.next = 12;
          return (0, _effects.call)(_ApiService.addOrUpdateDataRequest, allProjectIssues, finalPayload, 'addProjectIssue', 'updateProjectIssue', [_api.ORGID_PATH_PARAM], [selectedOrg.id]);

        case 12:
          savedProjectIssues = _context4.sent;
          _context4.next = 15;
          return (0, _effects.put)((0, _projectIssue.onSaveProjectIssueSuccess)(savedProjectIssues));

        case 15:
          _context4.next = 21;
          break;

        case 17:
          _context4.prev = 17;
          _context4.t0 = _context4["catch"](1);
          _context4.next = 21;
          return (0, _effects.put)((0, _projectIssue.showProjectIssueMessage)((0, _errorService.apiErrorMessageFormatter)(_context4.t0)));

        case 21:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[1, 17]]);
}
/**
 * This is when the user selects the star on the list page - update the starred attribute of the entity
 * NOTE - we do not store issues in the db so only update the local store which is refereshed as required
 * @param {*} param0 
 */


function addFavouriteProjectIssue(_ref5) {
  var payload, allProjectIssues, filtered;
  return regeneratorRuntime.wrap(function addFavouriteProjectIssue$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = _ref5.payload;
          _context5.prev = 1;
          _context5.next = 4;
          return (0, _effects.select)(getProjectIssueList);

        case 4:
          allProjectIssues = _context5.sent;
          filtered = allProjectIssues.filter(function (entry) {
            return (entry === null || entry === void 0 ? void 0 : entry.id) === (payload === null || payload === void 0 ? void 0 : payload.id);
          });

          if (!((filtered === null || filtered === void 0 ? void 0 : filtered.length) > 0)) {
            _context5.next = 9;
            break;
          }

          _context5.next = 9;
          return (0, _effects.put)((0, _projectIssue.addFavouriteProjectIssueSuccess)(payload));

        case 9:
          _context5.next = 15;
          break;

        case 11:
          _context5.prev = 11;
          _context5.t0 = _context5["catch"](1);
          _context5.next = 15;
          return (0, _effects.put)((0, _projectIssue.showProjectIssueMessage)(_context5.t0.messages));

        case 15:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, null, [[1, 11]]);
}

function fetchProjectIssuesSaga() {
  return regeneratorRuntime.wrap(function fetchProjectIssuesSaga$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_ALL_PROJECT_ISSUE, fetchProjectIssues);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}

function saveProjectIssueSaga() {
  return regeneratorRuntime.wrap(function saveProjectIssueSaga$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_SAVE_PROJECT_ISSUE, saveProjectIssue);

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}

function saveJiraProjectIssueSaga() {
  return regeneratorRuntime.wrap(function saveJiraProjectIssueSaga$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_SAVE_JIRA_PROJECT_ISSUE, saveJiraProjectIssue);

        case 2:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}

function deleteProjectIssueSaga() {
  return regeneratorRuntime.wrap(function deleteProjectIssueSaga$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_DELETE_PROJECT_ISSUE, deleteProjectIssue);

        case 2:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}

function addFavouriteProjectIssueSaga() {
  return regeneratorRuntime.wrap(function addFavouriteProjectIssueSaga$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ADD_FAVOURITE_PROJECT_ISSUE, addFavouriteProjectIssue);

        case 2:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked10);
}

function rootSaga() {
  return regeneratorRuntime.wrap(function rootSaga$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.all)([(0, _effects.fork)(fetchProjectIssuesSaga), (0, _effects.fork)(saveProjectIssueSaga), (0, _effects.fork)(deleteProjectIssueSaga), (0, _effects.fork)(addFavouriteProjectIssueSaga)]);

        case 2:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked11);
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(getProjectIssueList, "getProjectIssueList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(getProjectIssueCacheList, "getProjectIssueCacheList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(getSelectedProject, "getSelectedProject", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(fetchProjectIssues, "fetchProjectIssues", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(deleteProjectIssue, "deleteProjectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(saveProjectIssue, "saveProjectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(saveJiraProjectIssue, "saveJiraProjectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(addFavouriteProjectIssue, "addFavouriteProjectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(fetchProjectIssuesSaga, "fetchProjectIssuesSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(saveProjectIssueSaga, "saveProjectIssueSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(saveJiraProjectIssueSaga, "saveJiraProjectIssueSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(deleteProjectIssueSaga, "deleteProjectIssueSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(addFavouriteProjectIssueSaga, "addFavouriteProjectIssueSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(_marked, "_marked", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(_marked2, "_marked2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(_marked3, "_marked3", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(_marked4, "_marked4", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(_marked5, "_marked5", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(_marked6, "_marked6", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(_marked7, "_marked7", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(_marked8, "_marked8", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(_marked9, "_marked9", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(_marked10, "_marked10", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(_marked11, "_marked11", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(getProjectIssueList, "getProjectIssueList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(getProjectIssueCacheList, "getProjectIssueCacheList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(getSelectedProject, "getSelectedProject", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(fetchProjectIssues, "fetchProjectIssues", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(deleteProjectIssue, "deleteProjectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(saveProjectIssue, "saveProjectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(saveJiraProjectIssue, "saveJiraProjectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(addFavouriteProjectIssue, "addFavouriteProjectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(fetchProjectIssuesSaga, "fetchProjectIssuesSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(saveProjectIssueSaga, "saveProjectIssueSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(saveJiraProjectIssueSaga, "saveJiraProjectIssueSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(deleteProjectIssueSaga, "deleteProjectIssueSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(addFavouriteProjectIssueSaga, "addFavouriteProjectIssueSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectIssue.js");
}();

;

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSubtasksReduced = exports.getDescriptionContent = void 0;

var getDescriptionContent = function getDescriptionContent(description) {
  var _description$content;

  if ((description === null || description === void 0 ? void 0 : (_description$content = description.content) === null || _description$content === void 0 ? void 0 : _description$content.length) > 0) {
    var _description$content$, _description$content$2; // have some content


    if ((description === null || description === void 0 ? void 0 : (_description$content$ = description.content[0]) === null || _description$content$ === void 0 ? void 0 : (_description$content$2 = _description$content$.content) === null || _description$content$2 === void 0 ? void 0 : _description$content$2.length) > 0) {
      var _description$content$3;

      return description === null || description === void 0 ? void 0 : (_description$content$3 = description.content[0]) === null || _description$content$3 === void 0 ? void 0 : _description$content$3.content[0].text;
    }
  }

  return 'No description specified';
};

exports.getDescriptionContent = getDescriptionContent;

var getSubtasksReduced = function getSubtasksReduced(subtasks) {
  if (Array.isArray(subtasks)) {
    return subtasks.map(function (entry) {
      var _entry$fields;

      return entry === null || entry === void 0 ? void 0 : (_entry$fields = entry.fields) === null || _entry$fields === void 0 ? void 0 : _entry$fields.summary;
    }).join(', ');
  }

  return '';
};

exports.getSubtasksReduced = getSubtasksReduced;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(getDescriptionContent, "getDescriptionContent", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/jiraService.js");

  __REACT_HOT_LOADER__.register(getSubtasksReduced, "getSubtasksReduced", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/jiraService.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(getDescriptionContent, "getDescriptionContent", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/jiraService.js");

  __REACT_HOT_LOADER__.register(getSubtasksReduced, "getSubtasksReduced", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/jiraService.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/jiraService.js");
}();

;

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchBusinessUnits = fetchBusinessUnits;
exports.deleteBusinessUnit = deleteBusinessUnit;
exports.saveBusinessUnit = saveBusinessUnit;
exports.addFavouriteBusinessUnit = addFavouriteBusinessUnit;
exports.fetchBusinessUnitsSaga = fetchBusinessUnitsSaga;
exports.saveBusinessUnitSaga = saveBusinessUnitSaga;
exports.deleteBusinessUnitSaga = deleteBusinessUnitSaga;
exports.addFavouriteBusinessUnitSaga = addFavouriteBusinessUnitSaga;
exports["default"] = rootSaga;

var _effects = __webpack_require__(15);

var _businessUnit = __webpack_require__(263);

var _ActionTypes = __webpack_require__(7);

var _ApiService = __webpack_require__(16);

var _errorService = __webpack_require__(50);

var _api = __webpack_require__(25);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(fetchBusinessUnits),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(deleteBusinessUnit),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(saveBusinessUnit),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(addFavouriteBusinessUnit),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchBusinessUnitsSaga),
    _marked6 =
/*#__PURE__*/
regeneratorRuntime.mark(saveBusinessUnitSaga),
    _marked7 =
/*#__PURE__*/
regeneratorRuntime.mark(deleteBusinessUnitSaga),
    _marked8 =
/*#__PURE__*/
regeneratorRuntime.mark(addFavouriteBusinessUnitSaga),
    _marked9 =
/*#__PURE__*/
regeneratorRuntime.mark(rootSaga);

var currentOrg = function currentOrg(state) {
  return state.orgs.selectedOrg;
};

var getBusinessUnitList = function getBusinessUnitList(state) {
  return state.businessUnits.allBusinessUnit;
};

function fetchBusinessUnits() {
  var selectedOrg, fetchedBusinessUnits;
  return regeneratorRuntime.wrap(function fetchBusinessUnits$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.select)(currentOrg);

        case 3:
          selectedOrg = _context.sent;
          _context.next = 6;
          return (0, _effects.call)(_ApiService.fetchDataRequest, 'businessUnits', [_api.ORGID_PATH_PARAM], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id]) || [];

        case 6:
          fetchedBusinessUnits = _context.sent;
          _context.next = 9;
          return (0, _effects.put)((0, _businessUnit.fetchBusinessUnitsSuccess)(fetchedBusinessUnits));

        case 9:
          _context.next = 15;
          break;

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](0);
          _context.next = 15;
          return (0, _effects.put)((0, _businessUnit.showBusinessUnitMessage)((0, _errorService.apiErrorMessageFormatter)(_context.t0)));

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 11]]);
}

function deleteBusinessUnit(_ref) {
  var payload, selectedOrg;
  return regeneratorRuntime.wrap(function deleteBusinessUnit$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _ref.payload;
          _context2.prev = 1;
          _context2.next = 4;
          return (0, _effects.select)(currentOrg);

        case 4:
          selectedOrg = _context2.sent;
          _context2.next = 7;
          return (0, _effects.call)(_ApiService.deleteDataRequest, 'deleteBusinessUnit', 'Deleting business unit '.concat(payload), [_api.ORGID_PATH_PARAM, 'businessUnitId'], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id, payload]) || [];

        case 7:
          _context2.next = 9;
          return (0, _effects.put)((0, _businessUnit.onDeleteBusinessUnitSuccess)(payload));

        case 9:
          _context2.next = 15;
          break;

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](1);
          _context2.next = 15;
          return (0, _effects.put)((0, _businessUnit.showBusinessUnitMessage)((0, _errorService.apiErrorMessageFormatter)(_context2.t0)));

        case 15:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 11]]);
}

function saveBusinessUnit(_ref2) {
  var payload, selectedOrg, allBusinessUnits, finalPayload, savedBusinessUnit;
  return regeneratorRuntime.wrap(function saveBusinessUnit$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _ref2.payload;
          _context3.prev = 1;
          _context3.next = 4;
          return (0, _effects.select)(currentOrg);

        case 4:
          selectedOrg = _context3.sent;
          _context3.next = 7;
          return (0, _effects.select)(getBusinessUnitList);

        case 7:
          allBusinessUnits = _context3.sent;
          finalPayload = _objectSpread({}, payload); // check the orgid of the payload - it will be empty for a new payload - populate from the selectedOrg - otherwise leave it as is

          if ((payload === null || payload === void 0 ? void 0 : payload.orgid) === '') {
            finalPayload = _objectSpread({}, payload, {
              orgid: selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id
            });
          }

          _context3.next = 12;
          return (0, _effects.call)(_ApiService.addOrUpdateDataRequest, allBusinessUnits, finalPayload, 'addBusinessUnit', 'updateBusinessUnit', [_api.ORGID_PATH_PARAM], [selectedOrg.id]);

        case 12:
          savedBusinessUnit = _context3.sent;
          _context3.next = 15;
          return (0, _effects.put)((0, _businessUnit.onSaveBusinessUnitSuccess)(savedBusinessUnit));

        case 15:
          _context3.next = 21;
          break;

        case 17:
          _context3.prev = 17;
          _context3.t0 = _context3["catch"](1);
          _context3.next = 21;
          return (0, _effects.put)((0, _businessUnit.showBusinessUnitMessage)((0, _errorService.apiErrorMessageFormatter)(_context3.t0)));

        case 21:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[1, 17]]);
}
/**
 * This is when the user selects the star on the list page - update the starred attribute of the entity
 * @param {*} param0 
 */


function addFavouriteBusinessUnit(_ref3) {
  var payload, allBusinessUnits, selectedOrg, filtered, entry, updatedBusinessUnit, auditMsg;
  return regeneratorRuntime.wrap(function addFavouriteBusinessUnit$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _ref3.payload;
          _context4.prev = 1;
          _context4.next = 4;
          return (0, _effects.select)(getBusinessUnitList);

        case 4:
          allBusinessUnits = _context4.sent;
          _context4.next = 7;
          return (0, _effects.select)(currentOrg);

        case 7:
          selectedOrg = _context4.sent;
          filtered = allBusinessUnits.filter(function (entry) {
            return (entry === null || entry === void 0 ? void 0 : entry.id) === (payload === null || payload === void 0 ? void 0 : payload.id);
          });

          if (!((filtered === null || filtered === void 0 ? void 0 : filtered.length) > 0)) {
            _context4.next = 17;
            break;
          }

          entry = filtered[0];
          updatedBusinessUnit = _objectSpread({}, entry, {
            starred: !payload.starred
          });
          auditMsg = 'Updating starred setting to '.concat(updatedBusinessUnit === null || updatedBusinessUnit === void 0 ? void 0 : updatedBusinessUnit.starred).concat(' for businessUnit ').concat(updatedBusinessUnit === null || updatedBusinessUnit === void 0 ? void 0 : updatedBusinessUnit.id);
          _context4.next = 15;
          return (0, _effects.call)(_ApiService.updateDataRequest, updatedBusinessUnit, 'updateBusinessUnit', auditMsg, [_api.ORGID_PATH_PARAM], [selectedOrg.id]);

        case 15:
          _context4.next = 17;
          return (0, _effects.put)((0, _businessUnit.addFavouriteBusinessUnitSuccess)(payload));

        case 17:
          _context4.next = 23;
          break;

        case 19:
          _context4.prev = 19;
          _context4.t0 = _context4["catch"](1);
          _context4.next = 23;
          return (0, _effects.put)((0, _businessUnit.showBusinessUnitMessage)(_context4.t0.messages));

        case 23:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[1, 19]]);
}

function fetchBusinessUnitsSaga() {
  return regeneratorRuntime.wrap(function fetchBusinessUnitsSaga$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_ALL_BUSINESS_UNIT, fetchBusinessUnits);

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

function saveBusinessUnitSaga() {
  return regeneratorRuntime.wrap(function saveBusinessUnitSaga$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_SAVE_BUSINESS_UNIT, saveBusinessUnit);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}

function deleteBusinessUnitSaga() {
  return regeneratorRuntime.wrap(function deleteBusinessUnitSaga$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_DELETE_BUSINESS_UNIT, deleteBusinessUnit);

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}

function addFavouriteBusinessUnitSaga() {
  return regeneratorRuntime.wrap(function addFavouriteBusinessUnitSaga$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ADD_FAVOURITE_BUSINESS_UNIT, addFavouriteBusinessUnit);

        case 2:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}

function rootSaga() {
  return regeneratorRuntime.wrap(function rootSaga$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.all)([(0, _effects.fork)(fetchBusinessUnitsSaga), (0, _effects.fork)(saveBusinessUnitSaga), (0, _effects.fork)(deleteBusinessUnitSaga), (0, _effects.fork)(addFavouriteBusinessUnitSaga)]);

        case 2:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/businessUnit.js");

  __REACT_HOT_LOADER__.register(getBusinessUnitList, "getBusinessUnitList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/businessUnit.js");

  __REACT_HOT_LOADER__.register(fetchBusinessUnits, "fetchBusinessUnits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/businessUnit.js");

  __REACT_HOT_LOADER__.register(deleteBusinessUnit, "deleteBusinessUnit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/businessUnit.js");

  __REACT_HOT_LOADER__.register(saveBusinessUnit, "saveBusinessUnit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/businessUnit.js");

  __REACT_HOT_LOADER__.register(addFavouriteBusinessUnit, "addFavouriteBusinessUnit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/businessUnit.js");

  __REACT_HOT_LOADER__.register(fetchBusinessUnitsSaga, "fetchBusinessUnitsSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/businessUnit.js");

  __REACT_HOT_LOADER__.register(saveBusinessUnitSaga, "saveBusinessUnitSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/businessUnit.js");

  __REACT_HOT_LOADER__.register(deleteBusinessUnitSaga, "deleteBusinessUnitSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/businessUnit.js");

  __REACT_HOT_LOADER__.register(addFavouriteBusinessUnitSaga, "addFavouriteBusinessUnitSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/businessUnit.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/businessUnit.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/businessUnit.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/businessUnit.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/businessUnit.js");

  __REACT_HOT_LOADER__.register(_marked, "_marked", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/businessUnit.js");

  __REACT_HOT_LOADER__.register(_marked2, "_marked2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/businessUnit.js");

  __REACT_HOT_LOADER__.register(_marked3, "_marked3", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/businessUnit.js");

  __REACT_HOT_LOADER__.register(_marked4, "_marked4", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/businessUnit.js");

  __REACT_HOT_LOADER__.register(_marked5, "_marked5", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/businessUnit.js");

  __REACT_HOT_LOADER__.register(_marked6, "_marked6", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/businessUnit.js");

  __REACT_HOT_LOADER__.register(_marked7, "_marked7", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/businessUnit.js");

  __REACT_HOT_LOADER__.register(_marked8, "_marked8", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/businessUnit.js");

  __REACT_HOT_LOADER__.register(_marked9, "_marked9", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/businessUnit.js");

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/businessUnit.js");

  __REACT_HOT_LOADER__.register(getBusinessUnitList, "getBusinessUnitList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/businessUnit.js");

  __REACT_HOT_LOADER__.register(fetchBusinessUnits, "fetchBusinessUnits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/businessUnit.js");

  __REACT_HOT_LOADER__.register(deleteBusinessUnit, "deleteBusinessUnit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/businessUnit.js");

  __REACT_HOT_LOADER__.register(saveBusinessUnit, "saveBusinessUnit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/businessUnit.js");

  __REACT_HOT_LOADER__.register(addFavouriteBusinessUnit, "addFavouriteBusinessUnit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/businessUnit.js");

  __REACT_HOT_LOADER__.register(fetchBusinessUnitsSaga, "fetchBusinessUnitsSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/businessUnit.js");

  __REACT_HOT_LOADER__.register(saveBusinessUnitSaga, "saveBusinessUnitSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/businessUnit.js");

  __REACT_HOT_LOADER__.register(deleteBusinessUnitSaga, "deleteBusinessUnitSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/businessUnit.js");

  __REACT_HOT_LOADER__.register(addFavouriteBusinessUnitSaga, "addFavouriteBusinessUnitSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/businessUnit.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/businessUnit.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/businessUnit.js");
}();

;

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onPortfolioDashboard = onPortfolioDashboard;
exports.fetchPortfolios = fetchPortfolios;
exports.deletePortfolio = deletePortfolio;
exports.savePortfolio = savePortfolio;
exports.addFavouritePortfolio = addFavouritePortfolio;
exports.fetchPortfoliosSaga = fetchPortfoliosSaga;
exports.savePortfolioSaga = savePortfolioSaga;
exports.deletePortfolioSaga = deletePortfolioSaga;
exports.addFavouritePortfolioSaga = addFavouritePortfolioSaga;
exports.onPortfolioDashboardSaga = onPortfolioDashboardSaga;
exports["default"] = rootSaga;

var _effects = __webpack_require__(15);

var _portfolio = __webpack_require__(113);

var _ActionTypes = __webpack_require__(7);

var _ApiService = __webpack_require__(16);

var _errorService = __webpack_require__(50);

var _api = __webpack_require__(25);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(onPortfolioDashboard),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchPortfolios),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(deletePortfolio),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(savePortfolio),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(addFavouritePortfolio),
    _marked6 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchPortfoliosSaga),
    _marked7 =
/*#__PURE__*/
regeneratorRuntime.mark(savePortfolioSaga),
    _marked8 =
/*#__PURE__*/
regeneratorRuntime.mark(deletePortfolioSaga),
    _marked9 =
/*#__PURE__*/
regeneratorRuntime.mark(addFavouritePortfolioSaga),
    _marked10 =
/*#__PURE__*/
regeneratorRuntime.mark(onPortfolioDashboardSaga),
    _marked11 =
/*#__PURE__*/
regeneratorRuntime.mark(rootSaga);

var currentOrg = function currentOrg(state) {
  return state.orgs.selectedOrg;
};

var getPortfolioList = function getPortfolioList(state) {
  return state.portfolios.allPortfolio;
};

function onPortfolioDashboard(_ref) {
  var payload, selectedOrg, fetchedPortfolio;
  return regeneratorRuntime.wrap(function onPortfolioDashboard$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _ref.payload;
          _context.prev = 1;
          _context.next = 4;
          return (0, _effects.select)(currentOrg);

        case 4:
          selectedOrg = _context.sent;
          _context.next = 7;
          return (0, _effects.call)(_ApiService.fetchDataRequest, 'portfolioDashboard', [_api.ORGID_PATH_PARAM, 'portfolioId'], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id, payload]) || [];

        case 7:
          fetchedPortfolio = _context.sent;
          _context.next = 10;
          return (0, _effects.put)((0, _portfolio.onPortfolioDashboardSuccess)(fetchedPortfolio));

        case 10:
          _context.next = 16;
          break;

        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](1);
          _context.next = 16;
          return (0, _effects.put)((0, _portfolio.showPortfolioMessage)((0, _errorService.apiErrorMessageFormatter)(_context.t0)));

        case 16:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[1, 12]]);
}

function fetchPortfolios() {
  var selectedOrg, fetchedPortfolios;
  return regeneratorRuntime.wrap(function fetchPortfolios$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.select)(currentOrg);

        case 3:
          selectedOrg = _context2.sent;
          _context2.next = 6;
          return (0, _effects.call)(_ApiService.fetchDataRequest, 'portfolios', [_api.ORGID_PATH_PARAM], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id]) || [];

        case 6:
          fetchedPortfolios = _context2.sent;
          _context2.next = 9;
          return (0, _effects.put)((0, _portfolio.fetchPortfoliosSuccess)(fetchedPortfolios));

        case 9:
          _context2.next = 15;
          break;

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](0);
          _context2.next = 15;
          return (0, _effects.put)((0, _portfolio.showPortfolioMessage)((0, _errorService.apiErrorMessageFormatter)(_context2.t0)));

        case 15:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[0, 11]]);
}

function deletePortfolio(_ref2) {
  var payload, selectedOrg;
  return regeneratorRuntime.wrap(function deletePortfolio$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _ref2.payload;
          _context3.prev = 1;
          _context3.next = 4;
          return (0, _effects.select)(currentOrg);

        case 4:
          selectedOrg = _context3.sent;
          _context3.next = 7;
          return (0, _effects.call)(_ApiService.deleteDataRequest, 'deletePortfolio', 'Deleting portfolio '.concat(payload), [_api.ORGID_PATH_PARAM, 'portfolioId'], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id, payload]) || [];

        case 7:
          _context3.next = 9;
          return (0, _effects.put)((0, _portfolio.onDeletePortfolioSuccess)(payload));

        case 9:
          _context3.next = 15;
          break;

        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3["catch"](1);
          _context3.next = 15;
          return (0, _effects.put)((0, _portfolio.showPortfolioMessage)((0, _errorService.apiErrorMessageFormatter)(_context3.t0)));

        case 15:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[1, 11]]);
}

function savePortfolio(_ref3) {
  var payload, selectedOrg, allPortfolios, finalPayload, savedPortfolio;
  return regeneratorRuntime.wrap(function savePortfolio$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _ref3.payload;
          _context4.prev = 1;
          _context4.next = 4;
          return (0, _effects.select)(currentOrg);

        case 4:
          selectedOrg = _context4.sent;
          _context4.next = 7;
          return (0, _effects.select)(getPortfolioList);

        case 7:
          allPortfolios = _context4.sent;
          finalPayload = _objectSpread({}, payload); // check the orgid of the payload - it will be empty for a new payload - populate from the selectedOrg - otherwise leave it as is

          if ((payload === null || payload === void 0 ? void 0 : payload.orgid) === '') {
            finalPayload = _objectSpread({}, payload, {
              orgid: selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id
            });
          }

          _context4.next = 12;
          return (0, _effects.call)(_ApiService.addOrUpdateDataRequest, allPortfolios, finalPayload, 'addPortfolio', 'updatePortfolio', [_api.ORGID_PATH_PARAM], [selectedOrg.id]);

        case 12:
          savedPortfolio = _context4.sent;
          _context4.next = 15;
          return (0, _effects.put)((0, _portfolio.onSavePortfolioSuccess)(savedPortfolio));

        case 15:
          _context4.next = 21;
          break;

        case 17:
          _context4.prev = 17;
          _context4.t0 = _context4["catch"](1);
          _context4.next = 21;
          return (0, _effects.put)((0, _portfolio.showPortfolioMessage)((0, _errorService.apiErrorMessageFormatter)(_context4.t0)));

        case 21:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[1, 17]]);
}
/**
 * This is when the user selects the star on the list page - update the starred attribute of the entity
 * @param {*} param0 
 */


function addFavouritePortfolio(_ref4) {
  var payload, allPortfolios, selectedOrg, filtered, entry, updatedPortfolio, auditMsg;
  return regeneratorRuntime.wrap(function addFavouritePortfolio$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = _ref4.payload;
          _context5.prev = 1;
          _context5.next = 4;
          return (0, _effects.select)(getPortfolioList);

        case 4:
          allPortfolios = _context5.sent;
          _context5.next = 7;
          return (0, _effects.select)(currentOrg);

        case 7:
          selectedOrg = _context5.sent;
          filtered = allPortfolios.filter(function (entry) {
            return (entry === null || entry === void 0 ? void 0 : entry.id) === (payload === null || payload === void 0 ? void 0 : payload.id);
          });

          if (!((filtered === null || filtered === void 0 ? void 0 : filtered.length) > 0)) {
            _context5.next = 17;
            break;
          }

          entry = filtered[0];
          updatedPortfolio = _objectSpread({}, entry, {
            starred: !payload.starred
          });
          auditMsg = 'Updating starred setting to '.concat(updatedPortfolio === null || updatedPortfolio === void 0 ? void 0 : updatedPortfolio.starred).concat(' for portfolio ').concat(updatedPortfolio === null || updatedPortfolio === void 0 ? void 0 : updatedPortfolio.id);
          _context5.next = 15;
          return (0, _effects.call)(_ApiService.updateDataRequest, updatedPortfolio, 'updatePortfolio', auditMsg, [_api.ORGID_PATH_PARAM], [selectedOrg.id]);

        case 15:
          _context5.next = 17;
          return (0, _effects.put)((0, _portfolio.addFavouritePortfolioSuccess)(payload));

        case 17:
          _context5.next = 23;
          break;

        case 19:
          _context5.prev = 19;
          _context5.t0 = _context5["catch"](1);
          _context5.next = 23;
          return (0, _effects.put)((0, _portfolio.showPortfolioMessage)(_context5.t0.messages));

        case 23:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, null, [[1, 19]]);
}

function fetchPortfoliosSaga() {
  return regeneratorRuntime.wrap(function fetchPortfoliosSaga$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_ALL_PORTFOLIO, fetchPortfolios);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}

function savePortfolioSaga() {
  return regeneratorRuntime.wrap(function savePortfolioSaga$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_SAVE_PORTFOLIO, savePortfolio);

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}

function deletePortfolioSaga() {
  return regeneratorRuntime.wrap(function deletePortfolioSaga$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_DELETE_PORTFOLIO, deletePortfolio);

        case 2:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}

function addFavouritePortfolioSaga() {
  return regeneratorRuntime.wrap(function addFavouritePortfolioSaga$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ADD_FAVOURITE_PORTFOLIO, addFavouritePortfolio);

        case 2:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}

function onPortfolioDashboardSaga() {
  return regeneratorRuntime.wrap(function onPortfolioDashboardSaga$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_PORTFOLIO_DASHBOARD, onPortfolioDashboard);

        case 2:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked10);
}

function rootSaga() {
  return regeneratorRuntime.wrap(function rootSaga$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.all)([(0, _effects.fork)(fetchPortfoliosSaga), (0, _effects.fork)(savePortfolioSaga), (0, _effects.fork)(deletePortfolioSaga), (0, _effects.fork)(addFavouritePortfolioSaga), (0, _effects.fork)(onPortfolioDashboardSaga)]);

        case 2:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked11);
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(getPortfolioList, "getPortfolioList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(onPortfolioDashboard, "onPortfolioDashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(fetchPortfolios, "fetchPortfolios", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(deletePortfolio, "deletePortfolio", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(savePortfolio, "savePortfolio", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(addFavouritePortfolio, "addFavouritePortfolio", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(fetchPortfoliosSaga, "fetchPortfoliosSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(savePortfolioSaga, "savePortfolioSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(deletePortfolioSaga, "deletePortfolioSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(addFavouritePortfolioSaga, "addFavouritePortfolioSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(onPortfolioDashboardSaga, "onPortfolioDashboardSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(_marked, "_marked", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(_marked2, "_marked2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(_marked3, "_marked3", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(_marked4, "_marked4", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(_marked5, "_marked5", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(_marked6, "_marked6", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(_marked7, "_marked7", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(_marked8, "_marked8", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(_marked9, "_marked9", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(_marked10, "_marked10", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(_marked11, "_marked11", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(getPortfolioList, "getPortfolioList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(onPortfolioDashboard, "onPortfolioDashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(fetchPortfolios, "fetchPortfolios", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(deletePortfolio, "deletePortfolio", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(savePortfolio, "savePortfolio", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(addFavouritePortfolio, "addFavouritePortfolio", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(fetchPortfoliosSaga, "fetchPortfoliosSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(savePortfolioSaga, "savePortfolioSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(deletePortfolioSaga, "deletePortfolioSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(addFavouritePortfolioSaga, "addFavouritePortfolioSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(onPortfolioDashboardSaga, "onPortfolioDashboardSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/portfolio.js");
}();

;

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchFeatures = fetchFeatures;
exports.deleteFeature = deleteFeature;
exports.saveFeature = saveFeature;
exports.addFavouriteFeature = addFavouriteFeature;
exports.onFeatureInwardDependencyUpdate = onFeatureInwardDependencyUpdate;
exports.onFeatureOutwardDependencyUpdate = onFeatureOutwardDependencyUpdate;
exports.onFetchSelectFeatureInwardDependencies = onFetchSelectFeatureInwardDependencies;
exports.onFetchSelectFeatureOutwardDependencies = onFetchSelectFeatureOutwardDependencies;
exports.fetchFeaturesSaga = fetchFeaturesSaga;
exports.saveFeatureSaga = saveFeatureSaga;
exports.deleteFeatureSaga = deleteFeatureSaga;
exports.addFavouriteFeatureSaga = addFavouriteFeatureSaga;
exports.onFeatureInwardDependencyUpdateSaga = onFeatureInwardDependencyUpdateSaga;
exports.onFeatureOutwardDependencyUpdateSaga = onFeatureOutwardDependencyUpdateSaga;
exports.onFetchSelectFeatureInwardDependenciesSaga = onFetchSelectFeatureInwardDependenciesSaga;
exports.onFetchSelectFeatureOutwardDependenciesSaga = onFetchSelectFeatureOutwardDependenciesSaga;
exports["default"] = rootSaga;

var _effects = __webpack_require__(15);

var _feature = __webpack_require__(114);

var _ActionTypes = __webpack_require__(7);

var _ApiService = __webpack_require__(16);

var _errorService = __webpack_require__(50);

var _objectService = __webpack_require__(658);

var _api = __webpack_require__(25);

var _dependencyService = __webpack_require__(1275);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(fetchFeatures),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(deleteFeature),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(saveFeature),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(addFavouriteFeature),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(onFeatureInwardDependencyUpdate),
    _marked6 =
/*#__PURE__*/
regeneratorRuntime.mark(onFeatureOutwardDependencyUpdate),
    _marked7 =
/*#__PURE__*/
regeneratorRuntime.mark(onFetchSelectFeatureInwardDependencies),
    _marked8 =
/*#__PURE__*/
regeneratorRuntime.mark(onFetchSelectFeatureOutwardDependencies),
    _marked9 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchFeaturesSaga),
    _marked10 =
/*#__PURE__*/
regeneratorRuntime.mark(saveFeatureSaga),
    _marked11 =
/*#__PURE__*/
regeneratorRuntime.mark(deleteFeatureSaga),
    _marked12 =
/*#__PURE__*/
regeneratorRuntime.mark(addFavouriteFeatureSaga),
    _marked13 =
/*#__PURE__*/
regeneratorRuntime.mark(onFeatureInwardDependencyUpdateSaga),
    _marked14 =
/*#__PURE__*/
regeneratorRuntime.mark(onFeatureOutwardDependencyUpdateSaga),
    _marked15 =
/*#__PURE__*/
regeneratorRuntime.mark(onFetchSelectFeatureInwardDependenciesSaga),
    _marked16 =
/*#__PURE__*/
regeneratorRuntime.mark(onFetchSelectFeatureOutwardDependenciesSaga),
    _marked17 =
/*#__PURE__*/
regeneratorRuntime.mark(rootSaga);

var currentOrg = function currentOrg(state) {
  return state.orgs.selectedOrg;
};

var getFeatureList = function getFeatureList(state) {
  return state.features.allFeature;
};

var getSelectedFeature = function getSelectedFeature(state) {
  return state.features.selectedFeature;
};

var getDependencyList = function getDependencyList(state) {
  return state.features.dependencyList;
};

function fetchFeatures() {
  var selectedOrg, fetchedFeatures;
  return regeneratorRuntime.wrap(function fetchFeatures$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.select)(currentOrg);

        case 3:
          selectedOrg = _context.sent;
          _context.next = 6;
          return (0, _effects.call)(_ApiService.fetchDataRequest, 'features', [_api.ORGID_PATH_PARAM], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id]) || [];

        case 6:
          fetchedFeatures = _context.sent;
          _context.next = 9;
          return (0, _effects.put)((0, _feature.fetchFeaturesSuccess)(fetchedFeatures));

        case 9:
          _context.next = 15;
          break;

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](0);
          _context.next = 15;
          return (0, _effects.put)((0, _feature.showFeatureMessage)((0, _errorService.apiErrorMessageFormatter)(_context.t0)));

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 11]]);
}

function deleteFeature(_ref) {
  var payload, selectedOrg;
  return regeneratorRuntime.wrap(function deleteFeature$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _ref.payload;
          _context2.prev = 1;
          _context2.next = 4;
          return (0, _effects.select)(currentOrg);

        case 4:
          selectedOrg = _context2.sent;
          _context2.next = 7;
          return (0, _effects.call)(_ApiService.deleteDataRequest, 'deleteFeature', 'Deleting feature '.concat(payload), [_api.ORGID_PATH_PARAM, 'featureId'], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id, payload]) || [];

        case 7:
          _context2.next = 9;
          return (0, _effects.put)((0, _feature.onDeleteFeatureSuccess)(payload));

        case 9:
          _context2.next = 15;
          break;

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](1);
          _context2.next = 15;
          return (0, _effects.put)((0, _feature.showFeatureMessage)((0, _errorService.apiErrorMessageFormatter)(_context2.t0)));

        case 15:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 11]]);
}

function saveFeature(_ref2) {
  var payload, selectedOrg, allFeatures, finalPayload, savedFeatures;
  return regeneratorRuntime.wrap(function saveFeature$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _ref2.payload;
          _context3.prev = 1;
          _context3.next = 4;
          return (0, _effects.select)(currentOrg);

        case 4:
          selectedOrg = _context3.sent;
          _context3.next = 7;
          return (0, _effects.select)(getFeatureList);

        case 7:
          allFeatures = _context3.sent;
          finalPayload = _objectSpread({}, payload); // check the orgid of the payload - it will be empty for a new payload - populate from the selectedOrg - otherwise leave it as is

          if ((payload === null || payload === void 0 ? void 0 : payload.orgid) === '') {
            finalPayload = _objectSpread({}, payload, {
              orgid: selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id
            });
          }

          finalPayload = (0, _objectService.removeEmptyEntries)(finalPayload); // NOTE - if adding a new feature - the id would not have been populated yet

          _context3.next = 13;
          return (0, _effects.call)(_ApiService.addOrUpdateDataRequest, allFeatures, finalPayload, 'addFeature', 'updateFeature', [_api.ORGID_PATH_PARAM], [selectedOrg.id]);

        case 13:
          savedFeatures = _context3.sent;
          _context3.next = 16;
          return (0, _effects.put)((0, _feature.onSaveFeatureSuccess)(savedFeatures));

        case 16:
          _context3.next = 22;
          break;

        case 18:
          _context3.prev = 18;
          _context3.t0 = _context3["catch"](1);
          _context3.next = 22;
          return (0, _effects.put)((0, _feature.showFeatureMessage)((0, _errorService.apiErrorMessageFormatter)(_context3.t0)));

        case 22:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[1, 18]]);
}
/**
 * This is when the user selects the star on the list page - update the starred attribute of the entity
 * @param {*} param0 
 */


function addFavouriteFeature(_ref3) {
  var payload, allFeatures, selectedOrg, filtered, entry, updatedFeature, auditMsg;
  return regeneratorRuntime.wrap(function addFavouriteFeature$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _ref3.payload;
          _context4.prev = 1;
          _context4.next = 4;
          return (0, _effects.select)(getFeatureList);

        case 4:
          allFeatures = _context4.sent;
          _context4.next = 7;
          return (0, _effects.select)(currentOrg);

        case 7:
          selectedOrg = _context4.sent;
          filtered = allFeatures.filter(function (entry) {
            return (entry === null || entry === void 0 ? void 0 : entry.id) === (payload === null || payload === void 0 ? void 0 : payload.id);
          });

          if (!((filtered === null || filtered === void 0 ? void 0 : filtered.length) > 0)) {
            _context4.next = 17;
            break;
          }

          entry = filtered[0];
          updatedFeature = _objectSpread({}, entry, {
            starred: !payload.starred
          });
          auditMsg = 'Updating starred setting to '.concat(updatedFeature === null || updatedFeature === void 0 ? void 0 : updatedFeature.starred).concat(' for feature ').concat(updatedFeature === null || updatedFeature === void 0 ? void 0 : updatedFeature.id);
          _context4.next = 15;
          return (0, _effects.call)(_ApiService.updateDataRequest, updatedFeature, 'updateFeature', auditMsg, [_api.ORGID_PATH_PARAM], [selectedOrg.id]);

        case 15:
          _context4.next = 17;
          return (0, _effects.put)((0, _feature.addFavouriteFeatureSuccess)(payload));

        case 17:
          _context4.next = 23;
          break;

        case 19:
          _context4.prev = 19;
          _context4.t0 = _context4["catch"](1);
          _context4.next = 23;
          return (0, _effects.put)((0, _feature.showFeatureMessage)((0, _errorService.apiErrorMessageFormatter)(_context4.t0)));

        case 23:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[1, 19]]);
}
/**
 * 
 * @param {Array[Object]} payload - an array of selection objects (refer to selectorByIdBuilder)
 * [{id:otherfeatureId,
 *   name:'name',
 *   selected:true,
 *   originalValue:false}, ...]
 * 
 * "dependencies": [
            {
                "outward": {
                    "id": "9648cb65923bb7ba0845014820190617"
                },
                "id": "2578cb65923bb7ba0845014820176298"
            },
            {
                "id": "2578cb65923bb7ba0845014820176435",
                "inward": {
                    "id": "3875cb65923bb7ba0845014820190617"
                }
            }
        ],
 */


function onFeatureInwardDependencyUpdate() {
  var selectedOrg, featureList, selectedFeature, dependencyList, updateFeatureList;
  return regeneratorRuntime.wrap(function onFeatureInwardDependencyUpdate$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return (0, _effects.select)(currentOrg);

        case 3:
          selectedOrg = _context5.sent;
          _context5.next = 6;
          return (0, _effects.select)(getFeatureList);

        case 6:
          featureList = _context5.sent;
          _context5.next = 9;
          return (0, _effects.select)(getSelectedFeature);

        case 9:
          selectedFeature = _context5.sent;
          _context5.next = 12;
          return (0, _effects.select)(getDependencyList);

        case 12:
          dependencyList = _context5.sent;
          _context5.next = 15;
          return (0, _effects.call)(updateFeatureDependencies, selectedOrg, featureList, selectedFeature, dependencyList, true);

        case 15:
          updateFeatureList = _context5.sent;

          if (!(Array.isArray(updateFeatureList) && updateFeatureList.length > 0)) {
            _context5.next = 23;
            break;
          }

          _context5.next = 19;
          return (0, _effects.put)((0, _feature.onFeatureDependencyUpdateSuccess)(updateFeatureList));

        case 19:
          _context5.next = 21;
          return (0, _effects.put)((0, _feature.showFeatureMessage)('Feature dependency selections updated successfully.'));

        case 21:
          _context5.next = 25;
          break;

        case 23:
          _context5.next = 25;
          return (0, _effects.put)((0, _feature.showFeatureMessage)('No changes were made to the dependency selections.'));

        case 25:
          _context5.next = 31;
          break;

        case 27:
          _context5.prev = 27;
          _context5.t0 = _context5["catch"](0);
          _context5.next = 31;
          return (0, _effects.put)((0, _feature.showFeatureMessage)((0, _errorService.apiErrorMessageFormatter)(_context5.t0)));

        case 31:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, null, [[0, 27]]);
}

function onFeatureOutwardDependencyUpdate() {
  var selectedOrg, featureList, selectedFeature, dependencyList, updateFeatureList;
  return regeneratorRuntime.wrap(function onFeatureOutwardDependencyUpdate$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return (0, _effects.select)(currentOrg);

        case 3:
          selectedOrg = _context6.sent;
          _context6.next = 6;
          return (0, _effects.select)(getFeatureList);

        case 6:
          featureList = _context6.sent;
          _context6.next = 9;
          return (0, _effects.select)(getSelectedFeature);

        case 9:
          selectedFeature = _context6.sent;
          _context6.next = 12;
          return (0, _effects.select)(getDependencyList);

        case 12:
          dependencyList = _context6.sent;
          _context6.next = 15;
          return (0, _effects.call)(updateFeatureDependencies, selectedOrg, featureList, selectedFeature, dependencyList, false);

        case 15:
          updateFeatureList = _context6.sent;

          if (!(Array.isArray(updateFeatureList) && updateFeatureList.length > 0)) {
            _context6.next = 23;
            break;
          }

          _context6.next = 19;
          return (0, _effects.put)((0, _feature.onFeatureDependencyUpdateSuccess)(updateFeatureList));

        case 19:
          _context6.next = 21;
          return (0, _effects.put)((0, _feature.showFeatureMessage)('Feature dependency selections updated successfully.'));

        case 21:
          _context6.next = 25;
          break;

        case 23:
          _context6.next = 25;
          return (0, _effects.put)((0, _feature.showFeatureMessage)('No changes were made to the dependency selections.'));

        case 25:
          _context6.next = 31;
          break;

        case 27:
          _context6.prev = 27;
          _context6.t0 = _context6["catch"](0);
          _context6.next = 31;
          return (0, _effects.put)((0, _feature.showFeatureMessage)((0, _errorService.apiErrorMessageFormatter)(_context6.t0)));

        case 31:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6, null, [[0, 27]]);
}

var updateFeatureDependencies =
/*#__PURE__*/
function () {
  var _ref4 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(selectedOrg, featureList, selectedFeature, dependencyList, inward) {
    var updatedFeatures, updateFeatureList, newPayload, auditLogMessage, auditLog;
    return regeneratorRuntime.wrap(function _callee$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            updatedFeatures = (0, _dependencyService.mapSelectionsToDependencyData)(featureList, selectedFeature, dependencyList, inward);

            if (!(Array.isArray(updatedFeatures) && updatedFeatures.length > 0)) {
              _context7.next = 9;
              break;
            } // update the feature list to put back into the store


            updateFeatureList = featureList.map(function (feature) {
              var currentIndex = updatedFeatures.findIndex(function (updated) {
                return (updated === null || updated === void 0 ? void 0 : updated.id) === (feature === null || feature === void 0 ? void 0 : feature.id);
              });

              if (currentIndex === -1) {
                // not updated so return the current value
                return feature;
              } else {
                return updatedFeatures[currentIndex];
              }
            }); // change the payload to include the orgid for security reasons - checks against the path param

            newPayload = {
              orgid: selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id,
              features: updatedFeatures
            };
            auditLogMessage = 'Updating feature '.concat(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.id).concat(' ').concat(inward ? 'inward' : 'outward').concat(' dependencies');
            auditLog = {
              message: auditLogMessage,
              name: selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.name,
              description: JSON.stringify(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.dependencies)
            };
            _context7.next = 8;
            return (0, _ApiService.updateDataRequest)(newPayload, 'updateFeatures', auditLog, [_api.ORGID_PATH_PARAM], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id]);

          case 8:
            return _context7.abrupt("return", updateFeatureList);

          case 9:
            return _context7.abrupt("return", []);

          case 10:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee);
  }));

  return function updateFeatureDependencies(_x, _x2, _x3, _x4, _x5) {
    return _ref4.apply(this, arguments);
  };
}();

function onFetchSelectFeatureInwardDependencies() {
  var featureList, selectedFeature, selectionDependencies;
  return regeneratorRuntime.wrap(function onFetchSelectFeatureInwardDependencies$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.select)(getFeatureList);

        case 2:
          featureList = _context8.sent;
          _context8.next = 5;
          return (0, _effects.select)(getSelectedFeature);

        case 5:
          selectedFeature = _context8.sent;
          selectionDependencies = (0, _dependencyService.mapInwardDependenciesToSelectionData)(featureList, selectedFeature) || null;
          _context8.next = 9;
          return (0, _effects.put)((0, _feature.onFetchSelectFeatureDependenciesSuccess)(selectionDependencies));

        case 9:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked7);
}

function onFetchSelectFeatureOutwardDependencies() {
  var featureList, selectedFeature, selectionDependencies;
  return regeneratorRuntime.wrap(function onFetchSelectFeatureOutwardDependencies$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.select)(getFeatureList);

        case 2:
          featureList = _context9.sent;
          _context9.next = 5;
          return (0, _effects.select)(getSelectedFeature);

        case 5:
          selectedFeature = _context9.sent;
          selectionDependencies = (0, _dependencyService.mapOutwardDependenciesToSelectionData)(featureList, selectedFeature) || null;
          _context9.next = 9;
          return (0, _effects.put)((0, _feature.onFetchSelectFeatureDependenciesSuccess)(selectionDependencies));

        case 9:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked8);
}

function fetchFeaturesSaga() {
  return regeneratorRuntime.wrap(function fetchFeaturesSaga$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_ALL_FEATURE, fetchFeatures);

        case 2:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked9);
}

function saveFeatureSaga() {
  return regeneratorRuntime.wrap(function saveFeatureSaga$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_SAVE_FEATURE, saveFeature);

        case 2:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked10);
}

function deleteFeatureSaga() {
  return regeneratorRuntime.wrap(function deleteFeatureSaga$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_DELETE_FEATURE, deleteFeature);

        case 2:
        case "end":
          return _context12.stop();
      }
    }
  }, _marked11);
}

function addFavouriteFeatureSaga() {
  return regeneratorRuntime.wrap(function addFavouriteFeatureSaga$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ADD_FAVOURITE_FEATURE, addFavouriteFeature);

        case 2:
        case "end":
          return _context13.stop();
      }
    }
  }, _marked12);
}

function onFeatureInwardDependencyUpdateSaga() {
  return regeneratorRuntime.wrap(function onFeatureInwardDependencyUpdateSaga$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_FEATURE_INWARD_DEPENDENCY_UPDATE, onFeatureInwardDependencyUpdate);

        case 2:
        case "end":
          return _context14.stop();
      }
    }
  }, _marked13);
}

function onFeatureOutwardDependencyUpdateSaga() {
  return regeneratorRuntime.wrap(function onFeatureOutwardDependencyUpdateSaga$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_FEATURE_OUTWARD_DEPENDENCY_UPDATE, onFeatureOutwardDependencyUpdate);

        case 2:
        case "end":
          return _context15.stop();
      }
    }
  }, _marked14);
}

function onFetchSelectFeatureInwardDependenciesSaga() {
  return regeneratorRuntime.wrap(function onFetchSelectFeatureInwardDependenciesSaga$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_FETCH_SELECT_FEATURE_INWARD_DEPENDENCIES, onFetchSelectFeatureInwardDependencies);

        case 2:
        case "end":
          return _context16.stop();
      }
    }
  }, _marked15);
}

function onFetchSelectFeatureOutwardDependenciesSaga() {
  return regeneratorRuntime.wrap(function onFetchSelectFeatureOutwardDependenciesSaga$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_FETCH_SELECT_FEATURE_OUTWARD_DEPENDENCIES, onFetchSelectFeatureOutwardDependencies);

        case 2:
        case "end":
          return _context17.stop();
      }
    }
  }, _marked16);
}

function rootSaga() {
  return regeneratorRuntime.wrap(function rootSaga$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return (0, _effects.all)([(0, _effects.fork)(fetchFeaturesSaga), (0, _effects.fork)(saveFeatureSaga), (0, _effects.fork)(deleteFeatureSaga), (0, _effects.fork)(addFavouriteFeatureSaga), (0, _effects.fork)(onFeatureInwardDependencyUpdateSaga), (0, _effects.fork)(onFeatureOutwardDependencyUpdateSaga), (0, _effects.fork)(onFetchSelectFeatureInwardDependenciesSaga), (0, _effects.fork)(onFetchSelectFeatureOutwardDependenciesSaga)]);

        case 2:
        case "end":
          return _context18.stop();
      }
    }
  }, _marked17);
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(getFeatureList, "getFeatureList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(getSelectedFeature, "getSelectedFeature", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(getDependencyList, "getDependencyList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(fetchFeatures, "fetchFeatures", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(deleteFeature, "deleteFeature", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(saveFeature, "saveFeature", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(addFavouriteFeature, "addFavouriteFeature", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(onFeatureInwardDependencyUpdate, "onFeatureInwardDependencyUpdate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(onFeatureOutwardDependencyUpdate, "onFeatureOutwardDependencyUpdate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(updateFeatureDependencies, "updateFeatureDependencies", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(onFetchSelectFeatureInwardDependencies, "onFetchSelectFeatureInwardDependencies", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(onFetchSelectFeatureOutwardDependencies, "onFetchSelectFeatureOutwardDependencies", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(fetchFeaturesSaga, "fetchFeaturesSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(saveFeatureSaga, "saveFeatureSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(deleteFeatureSaga, "deleteFeatureSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(addFavouriteFeatureSaga, "addFavouriteFeatureSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(onFeatureInwardDependencyUpdateSaga, "onFeatureInwardDependencyUpdateSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(onFeatureOutwardDependencyUpdateSaga, "onFeatureOutwardDependencyUpdateSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(onFetchSelectFeatureInwardDependenciesSaga, "onFetchSelectFeatureInwardDependenciesSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(onFetchSelectFeatureOutwardDependenciesSaga, "onFetchSelectFeatureOutwardDependenciesSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(asyncGeneratorStep, "asyncGeneratorStep", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(_asyncToGenerator, "_asyncToGenerator", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(_marked, "_marked", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(_marked2, "_marked2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(_marked3, "_marked3", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(_marked4, "_marked4", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(_marked5, "_marked5", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(_marked6, "_marked6", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(_marked7, "_marked7", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(_marked8, "_marked8", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(_marked9, "_marked9", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(_marked10, "_marked10", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(_marked11, "_marked11", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(_marked12, "_marked12", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(_marked13, "_marked13", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(_marked14, "_marked14", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(_marked15, "_marked15", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(_marked16, "_marked16", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(_marked17, "_marked17", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(getFeatureList, "getFeatureList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(getSelectedFeature, "getSelectedFeature", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(getDependencyList, "getDependencyList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(fetchFeatures, "fetchFeatures", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(deleteFeature, "deleteFeature", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(saveFeature, "saveFeature", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(addFavouriteFeature, "addFavouriteFeature", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(onFeatureInwardDependencyUpdate, "onFeatureInwardDependencyUpdate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(onFeatureOutwardDependencyUpdate, "onFeatureOutwardDependencyUpdate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(updateFeatureDependencies, "updateFeatureDependencies", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(onFetchSelectFeatureInwardDependencies, "onFetchSelectFeatureInwardDependencies", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(onFetchSelectFeatureOutwardDependencies, "onFetchSelectFeatureOutwardDependencies", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(fetchFeaturesSaga, "fetchFeaturesSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(saveFeatureSaga, "saveFeatureSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(deleteFeatureSaga, "deleteFeatureSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(addFavouriteFeatureSaga, "addFavouriteFeatureSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(onFeatureInwardDependencyUpdateSaga, "onFeatureInwardDependencyUpdateSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(onFeatureOutwardDependencyUpdateSaga, "onFeatureOutwardDependencyUpdateSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(onFetchSelectFeatureInwardDependenciesSaga, "onFetchSelectFeatureInwardDependenciesSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(onFetchSelectFeatureOutwardDependenciesSaga, "onFetchSelectFeatureOutwardDependenciesSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/feature.js");
}();

;

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapSelectionsToDependencyData = exports.mapDependenciesToSelectionData = exports.mapOutwardDependenciesToSelectionData = exports.mapInwardDependenciesToSelectionData = void 0;

var _selectors = __webpack_require__(146);

var _arrayService = __webpack_require__(34);

var _sorting = __webpack_require__(259);

var _Authentication = __webpack_require__(42);

var _lodash = __webpack_require__(72);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var mapInwardDependenciesToSelectionData = function mapInwardDependenciesToSelectionData(availableSelections, currentSelection, dependencyKey) {
  return mapDependenciesToSelectionData(availableSelections, currentSelection, dependencyKey, true);
};

exports.mapInwardDependenciesToSelectionData = mapInwardDependenciesToSelectionData;

var mapOutwardDependenciesToSelectionData = function mapOutwardDependenciesToSelectionData(availableSelections, currentSelection, dependencyKey) {
  return mapDependenciesToSelectionData(availableSelections, currentSelection, dependencyKey, false);
};
/**
 * turn currentSelection dependencies into a selectable list for use in the currentSelection select dependency screens
 * NOTE - only works for data in this structure
 * "dependencies": [
    {
        "outward": {
            "id": "9648cb65923bb7ba0845014820190617"
        },
        "id": "2578cb65923bb7ba0845014820176298"
    },
    {
        "id": "2578cb65923bb7ba0845014820176435",
        "inward": {
            "id": "3875cb65923bb7ba0845014820190617"
        }
    }
],
 * @param {*} availableSelections - the full list to select from
 * @param {*} currentSelection - the current selection (filter from the available list)
 * @param {*} dependencyKey - the object entry that contains the dependency data - defaults to 'dependencies'
 * @param {*} inward 
 */


exports.mapOutwardDependenciesToSelectionData = mapOutwardDependenciesToSelectionData;

var mapDependenciesToSelectionData = function mapDependenciesToSelectionData(availableSelections, currentSelection) {
  var dependencyKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'dependencies';
  var inward = arguments.length > 3 ? arguments[3] : undefined;
  var selectionList;
  var result = new Array();

  if ((0, _lodash.has)(currentSelection, dependencyKey)) {
    var dependencies = (0, _lodash.get)(currentSelection, dependencyKey);

    if (Array.isArray(dependencies) && (dependencies === null || dependencies === void 0 ? void 0 : dependencies.length) > 0) {
      var linkedList = new Array();
      dependencies === null || dependencies === void 0 ? void 0 : dependencies.map(function (dependency) {
        var linkedId;

        if (inward) {
          if ((0, _lodash.has)(dependency, 'inward')) {
            var _dependency$inward;

            linkedId = dependency === null || dependency === void 0 ? void 0 : (_dependency$inward = dependency.inward) === null || _dependency$inward === void 0 ? void 0 : _dependency$inward.id;
          }
        } else {
          if ((0, _lodash.has)(dependency, 'outward')) {
            var _dependency$outward;

            linkedId = dependency === null || dependency === void 0 ? void 0 : (_dependency$outward = dependency.outward) === null || _dependency$outward === void 0 ? void 0 : _dependency$outward.id;
          }
        }

        if (linkedId) {
          var foundDependency = availableSelections === null || availableSelections === void 0 ? void 0 : availableSelections.find(function (element) {
            return (element === null || element === void 0 ? void 0 : element.id) === linkedId;
          });

          if (foundDependency) {
            linkedList.push(foundDependency);
          }
        }
      });
      selectionList = (0, _selectors.selectorByIdBuilder)(linkedList, 'id', 'name', true);
    } // need to remove the current currentSelection from the availableSelections list


    var selectable = availableSelections.filter(function (entry) {
      return (entry === null || entry === void 0 ? void 0 : entry.id) !== (currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.id);
    });
    var nonLinkedSelections = (0, _arrayService.uniqueSymmetricDifference)(selectable, selectionList); // sort the selections for display

    var nonLinkedSelectionsSorted = (0, _sorting.sortByField)(nonLinkedSelections, 'name'); // now convert for currentSelection

    var mappedNoLinkedSelections = (0, _selectors.selectorByIdBuilder)(nonLinkedSelectionsSorted, 'id', 'name', false);

    if (Array.isArray(mappedNoLinkedSelections) && Array.isArray(selectionList)) {
      result = selectionList.concat(mappedNoLinkedSelections);
    } else if (Array.isArray(mappedNoLinkedSelections)) {
      result = mappedNoLinkedSelections;
    } else if (Array.isArray(selectionList)) {
      result = selectionList;
    }
  }

  return result;
};
/**
 * take the selections and work out which items need to be updated
 * @param {Array} allItems - the full list of items that could be selected from
 * @param {*} selectedItem - the actual item being changed (adding or removed dependencies)
 * @param {*} dependencyList 
 * @param {*} inward 
 */


exports.mapDependenciesToSelectionData = mapDependenciesToSelectionData;

var mapSelectionsToDependencyData = function mapSelectionsToDependencyData(allItems, selectedItem, dependencyList, inward) {
  var updatedItems = new Array();
  var updated = false;
  var selectedDirection = inward ? 'inward' : 'outward';
  var relatedDependencyDirection = inward ? 'outward' : 'inward';

  if (Array.isArray(dependencyList)) {
    dependencyList.forEach(function (selection) {
      if ((selection === null || selection === void 0 ? void 0 : selection.selected) !== (selection === null || selection === void 0 ? void 0 : selection.originalValue)) {
        var _selectedItem; // have a change so process the update


        var selectedItemDependency = (_selectedItem = selectedItem) === null || _selectedItem === void 0 ? void 0 : _selectedItem.dependencies.filter(function (dependency) {
          return dependency[selectedDirection];
        }).find(function (element) {
          var _element$selectedDire;

          return ((_element$selectedDire = element[selectedDirection]) === null || _element$selectedDire === void 0 ? void 0 : _element$selectedDire.id) === (selection === null || selection === void 0 ? void 0 : selection.id);
        });
        var foundSelectedDependency = selectedItemDependency !== undefined;
        var relatedItem = allItems.find(function (element) {
          return (element === null || element === void 0 ? void 0 : element.id) === (selection === null || selection === void 0 ? void 0 : selection.id);
        });
        var relatedItemDependency = relatedItem === null || relatedItem === void 0 ? void 0 : relatedItem.dependencies.filter(function (dependency) {
          return dependency[relatedDependencyDirection];
        }).find(function (element) {
          var _selectedItem2;

          return element[relatedDependencyDirection].id === ((_selectedItem2 = selectedItem) === null || _selectedItem2 === void 0 ? void 0 : _selectedItem2.id);
        });

        if (selection === null || selection === void 0 ? void 0 : selection.selected) {
          // add the incoming dependency to the selected feature
          if (!foundSelectedDependency) {
            var _selectedItem3; // add to the selected feature dependencies


            var newDependency = {
              id: (0, _Authentication.generateGuid)()
            };
            newDependency[selectedDirection] = {
              id: selection === null || selection === void 0 ? void 0 : selection.id
            };
            (_selectedItem3 = selectedItem) === null || _selectedItem3 === void 0 ? void 0 : _selectedItem3.dependencies.push(newDependency);
            updated = true;
          }

          if (relatedItem) {
            var foundRelatedItemDependency = relatedItemDependency !== undefined; // should not be found

            if (!foundRelatedItemDependency) {
              var _selectedItem4; // add to the selected feature dependencies


              var _newDependency = {
                id: (0, _Authentication.generateGuid)()
              };
              _newDependency[relatedDependencyDirection] = {
                id: (_selectedItem4 = selectedItem) === null || _selectedItem4 === void 0 ? void 0 : _selectedItem4.id
              };
              relatedItem === null || relatedItem === void 0 ? void 0 : relatedItem.dependencies.push(_newDependency);
              var currentIndex = updatedItems.findIndex(function (element) {
                return (element === null || element === void 0 ? void 0 : element.id) === (relatedItem === null || relatedItem === void 0 ? void 0 : relatedItem.id);
              });

              if (currentIndex === -1) {
                updatedItems.push(relatedItem);
              } else {
                updatedItems.splice(currentIndex, 1).push(relatedItem);
              }

              updated = true;
            }
          }
        } else {
          if (foundSelectedDependency) {
            var _selectedItem5, _selectedItem5$depend; // need to remove dependencies from selected and item in the list


            var filteredSelectedDependencies = (_selectedItem5 = selectedItem) === null || _selectedItem5 === void 0 ? void 0 : (_selectedItem5$depend = _selectedItem5.dependencies) === null || _selectedItem5$depend === void 0 ? void 0 : _selectedItem5$depend.filter(function (dependency) {
              return (dependency === null || dependency === void 0 ? void 0 : dependency.id) !== (selectedItemDependency === null || selectedItemDependency === void 0 ? void 0 : selectedItemDependency.id);
            });
            selectedItem = _objectSpread({}, selectedItem, {
              dependencies: filteredSelectedDependencies
            });
            updated = true;
          }

          if (relatedItem) {
            var _foundRelatedItemDependency = relatedItemDependency !== undefined; // should be found


            if (_foundRelatedItemDependency) {
              var _relatedItem$dependen;

              var filteredRelatedItemDependencies = relatedItem === null || relatedItem === void 0 ? void 0 : (_relatedItem$dependen = relatedItem.dependencies) === null || _relatedItem$dependen === void 0 ? void 0 : _relatedItem$dependen.filter(function (dependency) {
                return (dependency === null || dependency === void 0 ? void 0 : dependency.id) !== (relatedItemDependency === null || relatedItemDependency === void 0 ? void 0 : relatedItemDependency.id);
              });

              var updatedRelatedItem = _objectSpread({}, relatedItem, {
                dependencies: filteredRelatedItemDependencies
              });

              var _currentIndex = updatedItems.findIndex(function (element) {
                return (element === null || element === void 0 ? void 0 : element.id) === (relatedItem === null || relatedItem === void 0 ? void 0 : relatedItem.id);
              });

              if (_currentIndex === -1) {
                updatedItems.push(updatedRelatedItem);
              } else {
                updatedItems.splice(_currentIndex, 1).push(updatedRelatedItem);
              }

              updated = true;
            }
          }
        }
      }
    });

    if (updated) {
      // send updatedFeatures for update via the api
      updatedItems = updatedItems.concat(selectedItem);
    }
  }

  return updatedItems;
};

exports.mapSelectionsToDependencyData = mapSelectionsToDependencyData;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapInwardDependenciesToSelectionData, "mapInwardDependenciesToSelectionData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/dependencyService.js");

  __REACT_HOT_LOADER__.register(mapOutwardDependenciesToSelectionData, "mapOutwardDependenciesToSelectionData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/dependencyService.js");

  __REACT_HOT_LOADER__.register(mapDependenciesToSelectionData, "mapDependenciesToSelectionData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/dependencyService.js");

  __REACT_HOT_LOADER__.register(mapSelectionsToDependencyData, "mapSelectionsToDependencyData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/dependencyService.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/dependencyService.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/dependencyService.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/dependencyService.js");

  __REACT_HOT_LOADER__.register(mapInwardDependenciesToSelectionData, "mapInwardDependenciesToSelectionData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/dependencyService.js");

  __REACT_HOT_LOADER__.register(mapOutwardDependenciesToSelectionData, "mapOutwardDependenciesToSelectionData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/dependencyService.js");

  __REACT_HOT_LOADER__.register(mapDependenciesToSelectionData, "mapDependenciesToSelectionData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/dependencyService.js");

  __REACT_HOT_LOADER__.register(mapSelectionsToDependencyData, "mapSelectionsToDependencyData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/dependencyService.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/dependencyService.js");
}();

;

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchValueStreams = fetchValueStreams;
exports.deleteValueStream = deleteValueStream;
exports.saveValueStream = saveValueStream;
exports.addFavouriteValueStream = addFavouriteValueStream;
exports.onFetchSelectTeamData = onFetchSelectTeamData;
exports.onValueStreamTeamUpdate = onValueStreamTeamUpdate;
exports.fetchValueStreamsSaga = fetchValueStreamsSaga;
exports.saveValueStreamSaga = saveValueStreamSaga;
exports.deleteValueStreamSaga = deleteValueStreamSaga;
exports.addFavouriteValueStreamSaga = addFavouriteValueStreamSaga;
exports.onFetchSelectTeamDataSaga = onFetchSelectTeamDataSaga;
exports.onValueStreamTeamUpdateSaga = onValueStreamTeamUpdateSaga;
exports["default"] = rootSaga;

var _effects = __webpack_require__(15);

var _valueStream = __webpack_require__(115);

var _ActionTypes = __webpack_require__(7);

var _ApiService = __webpack_require__(16);

var _errorService = __webpack_require__(50);

var _api = __webpack_require__(25);

var _selectors = __webpack_require__(146);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(fetchValueStreams),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(deleteValueStream),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(saveValueStream),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(addFavouriteValueStream),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(onFetchSelectTeamData),
    _marked6 =
/*#__PURE__*/
regeneratorRuntime.mark(onValueStreamTeamUpdate),
    _marked7 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchValueStreamsSaga),
    _marked8 =
/*#__PURE__*/
regeneratorRuntime.mark(saveValueStreamSaga),
    _marked9 =
/*#__PURE__*/
regeneratorRuntime.mark(deleteValueStreamSaga),
    _marked10 =
/*#__PURE__*/
regeneratorRuntime.mark(addFavouriteValueStreamSaga),
    _marked11 =
/*#__PURE__*/
regeneratorRuntime.mark(onFetchSelectTeamDataSaga),
    _marked12 =
/*#__PURE__*/
regeneratorRuntime.mark(onValueStreamTeamUpdateSaga),
    _marked13 =
/*#__PURE__*/
regeneratorRuntime.mark(rootSaga);

var currentOrg = function currentOrg(state) {
  return state.orgs.selectedOrg;
};

var getValueStreamList = function getValueStreamList(state) {
  return state.valueStreams.allValueStream;
};

var getSelectedValueStream = function getSelectedValueStream(state) {
  return state.valueStreams.selectedValueStream;
};

var getTeamList = function getTeamList(state) {
  return state.teams.allTeam;
};

var getSelectedTeams = function getSelectedTeams(state) {
  return state.valueStreams.teamSelectionList;
};

function fetchValueStreams() {
  var selectedOrg, fetchedValueStreams;
  return regeneratorRuntime.wrap(function fetchValueStreams$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.select)(currentOrg);

        case 3:
          selectedOrg = _context.sent;
          _context.next = 6;
          return (0, _effects.call)(_ApiService.fetchDataRequest, 'valueStreams', [_api.ORGID_PATH_PARAM], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id]) || [];

        case 6:
          fetchedValueStreams = _context.sent;
          _context.next = 9;
          return (0, _effects.put)((0, _valueStream.fetchValueStreamsSuccess)(fetchedValueStreams));

        case 9:
          _context.next = 15;
          break;

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](0);
          _context.next = 15;
          return (0, _effects.put)((0, _valueStream.showValueStreamMessage)((0, _errorService.apiErrorMessageFormatter)(_context.t0)));

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 11]]);
}

function deleteValueStream(_ref) {
  var payload, selectedOrg;
  return regeneratorRuntime.wrap(function deleteValueStream$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _ref.payload;
          _context2.prev = 1;
          _context2.next = 4;
          return (0, _effects.select)(currentOrg);

        case 4:
          selectedOrg = _context2.sent;
          _context2.next = 7;
          return (0, _effects.call)(_ApiService.deleteDataRequest, 'deleteValueStream', 'Deleting valueStream '.concat(payload), [_api.ORGID_PATH_PARAM, 'valueStreamId'], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id, payload]) || [];

        case 7:
          _context2.next = 9;
          return (0, _effects.put)((0, _valueStream.onDeleteValueStreamSuccess)(payload));

        case 9:
          _context2.next = 15;
          break;

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](1);
          _context2.next = 15;
          return (0, _effects.put)((0, _valueStream.showValueStreamMessage)((0, _errorService.apiErrorMessageFormatter)(_context2.t0)));

        case 15:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 11]]);
}

function saveValueStream(_ref2) {
  var payload, selectedOrg, allValueStreams, finalPayload, savedValueStream;
  return regeneratorRuntime.wrap(function saveValueStream$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _ref2.payload;
          _context3.prev = 1;
          _context3.next = 4;
          return (0, _effects.select)(currentOrg);

        case 4:
          selectedOrg = _context3.sent;
          _context3.next = 7;
          return (0, _effects.select)(getValueStreamList);

        case 7:
          allValueStreams = _context3.sent;
          finalPayload = _objectSpread({}, payload); // check the orgid of the payload - it will be empty for a new payload - populate from the selectedOrg - otherwise leave it as is

          if ((payload === null || payload === void 0 ? void 0 : payload.orgid) === '') {
            finalPayload = _objectSpread({}, payload, {
              orgid: selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id
            });
          }

          _context3.next = 12;
          return (0, _effects.call)(_ApiService.addOrUpdateDataRequest, allValueStreams, finalPayload, 'addValueStream', 'updateValueStream', [_api.ORGID_PATH_PARAM], [selectedOrg.id]);

        case 12:
          savedValueStream = _context3.sent;
          _context3.next = 15;
          return (0, _effects.put)((0, _valueStream.onSaveValueStreamSuccess)(savedValueStream));

        case 15:
          _context3.next = 21;
          break;

        case 17:
          _context3.prev = 17;
          _context3.t0 = _context3["catch"](1);
          _context3.next = 21;
          return (0, _effects.put)((0, _valueStream.showValueStreamMessage)((0, _errorService.apiErrorMessageFormatter)(_context3.t0)));

        case 21:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[1, 17]]);
}
/**
 * This is when the user selects the star on the list page - update the starred attribute of the entity
 * @param {*} param0 
 */


function addFavouriteValueStream(_ref3) {
  var payload, allValueStreams, selectedOrg, filtered, entry, updatedValueStream, auditMsg;
  return regeneratorRuntime.wrap(function addFavouriteValueStream$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _ref3.payload;
          _context4.prev = 1;
          _context4.next = 4;
          return (0, _effects.select)(getValueStreamList);

        case 4:
          allValueStreams = _context4.sent;
          _context4.next = 7;
          return (0, _effects.select)(currentOrg);

        case 7:
          selectedOrg = _context4.sent;
          filtered = allValueStreams.filter(function (entry) {
            return (entry === null || entry === void 0 ? void 0 : entry.id) === (payload === null || payload === void 0 ? void 0 : payload.id);
          });

          if (!((filtered === null || filtered === void 0 ? void 0 : filtered.length) > 0)) {
            _context4.next = 17;
            break;
          }

          entry = filtered[0];
          updatedValueStream = _objectSpread({}, entry, {
            starred: !payload.starred
          });
          auditMsg = 'Updating starred setting to '.concat(updatedValueStream === null || updatedValueStream === void 0 ? void 0 : updatedValueStream.starred).concat(' for valueStream ').concat(updatedValueStream === null || updatedValueStream === void 0 ? void 0 : updatedValueStream.id);
          _context4.next = 15;
          return (0, _effects.call)(_ApiService.updateDataRequest, updatedValueStream, 'updateValueStream', auditMsg, [_api.ORGID_PATH_PARAM], [selectedOrg.id]);

        case 15:
          _context4.next = 17;
          return (0, _effects.put)((0, _valueStream.addFavouriteValueStreamSuccess)(payload));

        case 17:
          _context4.next = 23;
          break;

        case 19:
          _context4.prev = 19;
          _context4.t0 = _context4["catch"](1);
          _context4.next = 23;
          return (0, _effects.put)((0, _valueStream.showValueStreamMessage)(_context4.t0.messages));

        case 23:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[1, 19]]);
}

function onFetchSelectTeamData() {
  var selectedValueStream, allTeams, selectedDrillDownItems, selections;
  return regeneratorRuntime.wrap(function onFetchSelectTeamData$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.select)(getSelectedValueStream);

        case 2:
          selectedValueStream = _context5.sent;
          _context5.next = 5;
          return (0, _effects.select)(getTeamList);

        case 5:
          allTeams = _context5.sent;
          selectedDrillDownItems = Array.isArray(selectedValueStream === null || selectedValueStream === void 0 ? void 0 : selectedValueStream.teams) ? selectedValueStream === null || selectedValueStream === void 0 ? void 0 : selectedValueStream.teams : [];
          selections = (0, _selectors.mapDataToSelectionData)(allTeams, selectedDrillDownItems) || null;
          _context5.next = 10;
          return (0, _effects.put)((0, _valueStream.onFetchSelectTeamDataSuccess)(selections));

        case 10:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

function onValueStreamTeamUpdate() {
  var selectedOrg, selectedValueStream, selectedTeams, updatedDrillDownSelections, updatedSelectedValueStream, auditMsg;
  return regeneratorRuntime.wrap(function onValueStreamTeamUpdate$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return (0, _effects.select)(currentOrg);

        case 3:
          selectedOrg = _context6.sent;
          _context6.next = 6;
          return (0, _effects.select)(getSelectedValueStream);

        case 6:
          selectedValueStream = _context6.sent;
          _context6.next = 9;
          return (0, _effects.select)(getSelectedTeams);

        case 9:
          selectedTeams = _context6.sent;
          updatedDrillDownSelections = new Array();
          selectedTeams.forEach(function (selection) {
            if (selection === null || selection === void 0 ? void 0 : selection.selected) {
              updatedDrillDownSelections.push(selection === null || selection === void 0 ? void 0 : selection.id);
            }
          });
          updatedSelectedValueStream = _objectSpread({}, selectedValueStream, {
            teams: updatedDrillDownSelections
          });
          auditMsg = 'Updating selected team to '.concat(' for valueStream ').concat(updatedSelectedValueStream === null || updatedSelectedValueStream === void 0 ? void 0 : updatedSelectedValueStream.id);
          _context6.next = 16;
          return (0, _effects.call)(_ApiService.updateDataRequest, updatedSelectedValueStream, 'updateValueStream', auditMsg, [_api.ORGID_PATH_PARAM], [selectedOrg.id]);

        case 16:
          _context6.next = 18;
          return (0, _effects.put)((0, _valueStream.onSaveValueStreamSuccess)(updatedSelectedValueStream));

        case 18:
          _context6.next = 24;
          break;

        case 20:
          _context6.prev = 20;
          _context6.t0 = _context6["catch"](0);
          _context6.next = 24;
          return (0, _effects.put)((0, _valueStream.showValueStreamMessage)((0, _errorService.apiErrorMessageFormatter)(_context6.t0)));

        case 24:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6, null, [[0, 20]]);
}

function fetchValueStreamsSaga() {
  return regeneratorRuntime.wrap(function fetchValueStreamsSaga$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_ALL_VALUE_STREAM, fetchValueStreams);

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}

function saveValueStreamSaga() {
  return regeneratorRuntime.wrap(function saveValueStreamSaga$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_SAVE_VALUE_STREAM, saveValueStream);

        case 2:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}

function deleteValueStreamSaga() {
  return regeneratorRuntime.wrap(function deleteValueStreamSaga$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_DELETE_VALUE_STREAM, deleteValueStream);

        case 2:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}

function addFavouriteValueStreamSaga() {
  return regeneratorRuntime.wrap(function addFavouriteValueStreamSaga$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ADD_FAVOURITE_VALUE_STREAM, addFavouriteValueStream);

        case 2:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked10);
}

function onFetchSelectTeamDataSaga() {
  return regeneratorRuntime.wrap(function onFetchSelectTeamDataSaga$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_FETCH_SELECT_TEAM_DATA, onFetchSelectTeamData);

        case 2:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked11);
}

function onValueStreamTeamUpdateSaga() {
  return regeneratorRuntime.wrap(function onValueStreamTeamUpdateSaga$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_VALUE_STREAM_TEAM_UPDATE, onValueStreamTeamUpdate);

        case 2:
        case "end":
          return _context12.stop();
      }
    }
  }, _marked12);
}

function rootSaga() {
  return regeneratorRuntime.wrap(function rootSaga$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.all)([(0, _effects.fork)(fetchValueStreamsSaga), (0, _effects.fork)(saveValueStreamSaga), (0, _effects.fork)(deleteValueStreamSaga), (0, _effects.fork)(addFavouriteValueStreamSaga), (0, _effects.fork)(onFetchSelectTeamDataSaga), (0, _effects.fork)(onValueStreamTeamUpdateSaga)]);

        case 2:
        case "end":
          return _context13.stop();
      }
    }
  }, _marked13);
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(getValueStreamList, "getValueStreamList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(getSelectedValueStream, "getSelectedValueStream", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(getTeamList, "getTeamList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(getSelectedTeams, "getSelectedTeams", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(fetchValueStreams, "fetchValueStreams", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(deleteValueStream, "deleteValueStream", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(saveValueStream, "saveValueStream", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(addFavouriteValueStream, "addFavouriteValueStream", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(onFetchSelectTeamData, "onFetchSelectTeamData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(onValueStreamTeamUpdate, "onValueStreamTeamUpdate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(fetchValueStreamsSaga, "fetchValueStreamsSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(saveValueStreamSaga, "saveValueStreamSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(deleteValueStreamSaga, "deleteValueStreamSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(addFavouriteValueStreamSaga, "addFavouriteValueStreamSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(onFetchSelectTeamDataSaga, "onFetchSelectTeamDataSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(onValueStreamTeamUpdateSaga, "onValueStreamTeamUpdateSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(_marked, "_marked", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(_marked2, "_marked2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(_marked3, "_marked3", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(_marked4, "_marked4", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(_marked5, "_marked5", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(_marked6, "_marked6", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(_marked7, "_marked7", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(_marked8, "_marked8", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(_marked9, "_marked9", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(_marked10, "_marked10", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(_marked11, "_marked11", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(_marked12, "_marked12", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(_marked13, "_marked13", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(getValueStreamList, "getValueStreamList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(getSelectedValueStream, "getSelectedValueStream", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(getTeamList, "getTeamList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(getSelectedTeams, "getSelectedTeams", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(fetchValueStreams, "fetchValueStreams", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(deleteValueStream, "deleteValueStream", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(saveValueStream, "saveValueStream", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(addFavouriteValueStream, "addFavouriteValueStream", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(onFetchSelectTeamData, "onFetchSelectTeamData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(onValueStreamTeamUpdate, "onValueStreamTeamUpdate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(fetchValueStreamsSaga, "fetchValueStreamsSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(saveValueStreamSaga, "saveValueStreamSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(deleteValueStreamSaga, "deleteValueStreamSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(addFavouriteValueStreamSaga, "addFavouriteValueStreamSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(onFetchSelectTeamDataSaga, "onFetchSelectTeamDataSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(onValueStreamTeamUpdateSaga, "onValueStreamTeamUpdateSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/valueStream.js");
}();

;

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchMembers = fetchMembers;
exports.deleteMember = deleteMember;
exports.saveMember = saveMember;
exports.addFavouriteMember = addFavouriteMember;
exports.fetchMembersSaga = fetchMembersSaga;
exports.saveMemberSaga = saveMemberSaga;
exports.deleteMemberSaga = deleteMemberSaga;
exports.addFavouriteMemberSaga = addFavouriteMemberSaga;
exports["default"] = rootSaga;

var _effects = __webpack_require__(15);

var _member = __webpack_require__(100);

var _ActionTypes = __webpack_require__(7);

var _ApiService = __webpack_require__(16);

var _errorService = __webpack_require__(50);

var _api = __webpack_require__(25);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(fetchMembers),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(deleteMember),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(saveMember),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(addFavouriteMember),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchMembersSaga),
    _marked6 =
/*#__PURE__*/
regeneratorRuntime.mark(saveMemberSaga),
    _marked7 =
/*#__PURE__*/
regeneratorRuntime.mark(deleteMemberSaga),
    _marked8 =
/*#__PURE__*/
regeneratorRuntime.mark(addFavouriteMemberSaga),
    _marked9 =
/*#__PURE__*/
regeneratorRuntime.mark(rootSaga);

var currentOrg = function currentOrg(state) {
  return state.orgs.selectedOrg;
};

var getMemberList = function getMemberList(state) {
  return state.members.allMember;
};

function fetchMembers() {
  var selectedOrg, fetchedMembers;
  return regeneratorRuntime.wrap(function fetchMembers$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.select)(currentOrg);

        case 3:
          selectedOrg = _context.sent;
          _context.next = 6;
          return (0, _effects.call)(_ApiService.fetchDataRequest, 'members', [_api.ORGID_PATH_PARAM], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id]) || [];

        case 6:
          fetchedMembers = _context.sent;
          _context.next = 9;
          return (0, _effects.put)((0, _member.fetchMembersSuccess)(fetchedMembers));

        case 9:
          _context.next = 15;
          break;

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](0);
          _context.next = 15;
          return (0, _effects.put)((0, _member.showMemberMessage)((0, _errorService.apiErrorMessageFormatter)(_context.t0)));

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 11]]);
}

function deleteMember(_ref) {
  var payload, selectedOrg;
  return regeneratorRuntime.wrap(function deleteMember$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _ref.payload;
          _context2.prev = 1;
          _context2.next = 4;
          return (0, _effects.select)(currentOrg);

        case 4:
          selectedOrg = _context2.sent;
          _context2.next = 7;
          return (0, _effects.call)(_ApiService.deleteDataRequest, 'deleteMember', 'Deleting member '.concat(payload), [_api.ORGID_PATH_PARAM, 'memberId'], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id, payload]) || [];

        case 7:
          _context2.next = 9;
          return (0, _effects.put)((0, _member.onDeleteMemberSuccess)(payload));

        case 9:
          _context2.next = 15;
          break;

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](1);
          _context2.next = 15;
          return (0, _effects.put)((0, _member.showMemberMessage)((0, _errorService.apiErrorMessageFormatter)(_context2.t0)));

        case 15:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 11]]);
}

function saveMember(_ref2) {
  var payload, selectedOrg, allMembers, finalPayload, savedMember;
  return regeneratorRuntime.wrap(function saveMember$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _ref2.payload;
          _context3.prev = 1;
          _context3.next = 4;
          return (0, _effects.select)(currentOrg);

        case 4:
          selectedOrg = _context3.sent;
          _context3.next = 7;
          return (0, _effects.select)(getMemberList);

        case 7:
          allMembers = _context3.sent;
          finalPayload = _objectSpread({}, payload); // check the orgid of the payload - it will be empty for a new payload - populate from the selectedOrg - otherwise leave it as is

          if ((payload === null || payload === void 0 ? void 0 : payload.orgid) === '') {
            finalPayload = _objectSpread({}, payload, {
              orgid: selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id
            });
          }

          _context3.next = 12;
          return (0, _effects.call)(_ApiService.addOrUpdateDataRequest, allMembers, finalPayload, 'addMember', 'updateMember', [_api.ORGID_PATH_PARAM], [selectedOrg.id]);

        case 12:
          savedMember = _context3.sent;
          _context3.next = 15;
          return (0, _effects.put)((0, _member.onSaveMemberSuccess)(savedMember));

        case 15:
          _context3.next = 21;
          break;

        case 17:
          _context3.prev = 17;
          _context3.t0 = _context3["catch"](1);
          _context3.next = 21;
          return (0, _effects.put)((0, _member.showMemberMessage)((0, _errorService.apiErrorMessageFormatter)(_context3.t0)));

        case 21:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[1, 17]]);
}
/**
 * This is when the user selects the star on the list page - update the starred attribute of the entity
 * @param {*} param0 
 */


function addFavouriteMember(_ref3) {
  var payload, allMembers, selectedOrg, filtered, entry, updatedMember, auditMsg;
  return regeneratorRuntime.wrap(function addFavouriteMember$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _ref3.payload;
          _context4.prev = 1;
          _context4.next = 4;
          return (0, _effects.select)(getMemberList);

        case 4:
          allMembers = _context4.sent;
          _context4.next = 7;
          return (0, _effects.select)(currentOrg);

        case 7:
          selectedOrg = _context4.sent;
          filtered = allMembers.filter(function (entry) {
            return (entry === null || entry === void 0 ? void 0 : entry.id) === (payload === null || payload === void 0 ? void 0 : payload.id);
          });

          if (!((filtered === null || filtered === void 0 ? void 0 : filtered.length) > 0)) {
            _context4.next = 17;
            break;
          }

          entry = filtered[0];
          updatedMember = _objectSpread({}, entry, {
            starred: !payload.starred
          });
          auditMsg = 'Updating starred setting to '.concat(updatedMember === null || updatedMember === void 0 ? void 0 : updatedMember.starred).concat(' for member ').concat(updatedMember === null || updatedMember === void 0 ? void 0 : updatedMember.id);
          _context4.next = 15;
          return (0, _effects.call)(_ApiService.updateDataRequest, updatedMember, 'updateMember', auditMsg, [_api.ORGID_PATH_PARAM], [selectedOrg.id]);

        case 15:
          _context4.next = 17;
          return (0, _effects.put)((0, _member.addFavouriteMemberSuccess)(payload));

        case 17:
          _context4.next = 23;
          break;

        case 19:
          _context4.prev = 19;
          _context4.t0 = _context4["catch"](1);
          _context4.next = 23;
          return (0, _effects.put)((0, _member.showMemberMessage)(_context4.t0.messages));

        case 23:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[1, 19]]);
}

function fetchMembersSaga() {
  return regeneratorRuntime.wrap(function fetchMembersSaga$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_ALL_MEMBER, fetchMembers);

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

function saveMemberSaga() {
  return regeneratorRuntime.wrap(function saveMemberSaga$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_SAVE_MEMBER, saveMember);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}

function deleteMemberSaga() {
  return regeneratorRuntime.wrap(function deleteMemberSaga$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_DELETE_MEMBER, deleteMember);

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}

function addFavouriteMemberSaga() {
  return regeneratorRuntime.wrap(function addFavouriteMemberSaga$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ADD_FAVOURITE_MEMBER, addFavouriteMember);

        case 2:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}

function rootSaga() {
  return regeneratorRuntime.wrap(function rootSaga$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.all)([(0, _effects.fork)(fetchMembersSaga), (0, _effects.fork)(saveMemberSaga), (0, _effects.fork)(deleteMemberSaga), (0, _effects.fork)(addFavouriteMemberSaga)]);

        case 2:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/member.js");

  __REACT_HOT_LOADER__.register(getMemberList, "getMemberList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/member.js");

  __REACT_HOT_LOADER__.register(fetchMembers, "fetchMembers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/member.js");

  __REACT_HOT_LOADER__.register(deleteMember, "deleteMember", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/member.js");

  __REACT_HOT_LOADER__.register(saveMember, "saveMember", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/member.js");

  __REACT_HOT_LOADER__.register(addFavouriteMember, "addFavouriteMember", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/member.js");

  __REACT_HOT_LOADER__.register(fetchMembersSaga, "fetchMembersSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/member.js");

  __REACT_HOT_LOADER__.register(saveMemberSaga, "saveMemberSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/member.js");

  __REACT_HOT_LOADER__.register(deleteMemberSaga, "deleteMemberSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/member.js");

  __REACT_HOT_LOADER__.register(addFavouriteMemberSaga, "addFavouriteMemberSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/member.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/member.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/member.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/member.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/member.js");

  __REACT_HOT_LOADER__.register(_marked, "_marked", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/member.js");

  __REACT_HOT_LOADER__.register(_marked2, "_marked2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/member.js");

  __REACT_HOT_LOADER__.register(_marked3, "_marked3", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/member.js");

  __REACT_HOT_LOADER__.register(_marked4, "_marked4", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/member.js");

  __REACT_HOT_LOADER__.register(_marked5, "_marked5", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/member.js");

  __REACT_HOT_LOADER__.register(_marked6, "_marked6", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/member.js");

  __REACT_HOT_LOADER__.register(_marked7, "_marked7", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/member.js");

  __REACT_HOT_LOADER__.register(_marked8, "_marked8", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/member.js");

  __REACT_HOT_LOADER__.register(_marked9, "_marked9", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/member.js");

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/member.js");

  __REACT_HOT_LOADER__.register(getMemberList, "getMemberList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/member.js");

  __REACT_HOT_LOADER__.register(fetchMembers, "fetchMembers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/member.js");

  __REACT_HOT_LOADER__.register(deleteMember, "deleteMember", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/member.js");

  __REACT_HOT_LOADER__.register(saveMember, "saveMember", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/member.js");

  __REACT_HOT_LOADER__.register(addFavouriteMember, "addFavouriteMember", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/member.js");

  __REACT_HOT_LOADER__.register(fetchMembersSaga, "fetchMembersSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/member.js");

  __REACT_HOT_LOADER__.register(saveMemberSaga, "saveMemberSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/member.js");

  __REACT_HOT_LOADER__.register(deleteMemberSaga, "deleteMemberSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/member.js");

  __REACT_HOT_LOADER__.register(addFavouriteMemberSaga, "addFavouriteMemberSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/member.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/member.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/member.js");
}();

;

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchTeams = fetchTeams;
exports.deleteTeam = deleteTeam;
exports.saveTeam = saveTeam;
exports.addFavouriteTeam = addFavouriteTeam;
exports.onFetchSelectMemberData = onFetchSelectMemberData;
exports.onTeamMemberUpdate = onTeamMemberUpdate;
exports.fetchTeamsSaga = fetchTeamsSaga;
exports.saveTeamSaga = saveTeamSaga;
exports.deleteTeamSaga = deleteTeamSaga;
exports.addFavouriteTeamSaga = addFavouriteTeamSaga;
exports.onFetchSelectMemberDataSaga = onFetchSelectMemberDataSaga;
exports.onTeamMemberUpdateSaga = onTeamMemberUpdateSaga;
exports["default"] = rootSaga;

var _effects = __webpack_require__(15);

var _team = __webpack_require__(116);

var _ActionTypes = __webpack_require__(7);

var _ApiService = __webpack_require__(16);

var _errorService = __webpack_require__(50);

var _api = __webpack_require__(25);

var _selectors = __webpack_require__(146);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(fetchTeams),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(deleteTeam),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(saveTeam),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(addFavouriteTeam),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(onFetchSelectMemberData),
    _marked6 =
/*#__PURE__*/
regeneratorRuntime.mark(onTeamMemberUpdate),
    _marked7 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchTeamsSaga),
    _marked8 =
/*#__PURE__*/
regeneratorRuntime.mark(saveTeamSaga),
    _marked9 =
/*#__PURE__*/
regeneratorRuntime.mark(deleteTeamSaga),
    _marked10 =
/*#__PURE__*/
regeneratorRuntime.mark(addFavouriteTeamSaga),
    _marked11 =
/*#__PURE__*/
regeneratorRuntime.mark(onFetchSelectMemberDataSaga),
    _marked12 =
/*#__PURE__*/
regeneratorRuntime.mark(onTeamMemberUpdateSaga),
    _marked13 =
/*#__PURE__*/
regeneratorRuntime.mark(rootSaga);

var currentOrg = function currentOrg(state) {
  return state.orgs.selectedOrg;
};

var getTeamList = function getTeamList(state) {
  return state.teams.allTeam;
};

var getSelectedTeam = function getSelectedTeam(state) {
  return state.teams.selectedTeam;
};

var getMemberList = function getMemberList(state) {
  return state.members.allMember;
};

var getSelectedMembers = function getSelectedMembers(state) {
  return state.teams.memberSelectionList;
};

function fetchTeams() {
  var selectedOrg, fetchedTeams;
  return regeneratorRuntime.wrap(function fetchTeams$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.select)(currentOrg);

        case 3:
          selectedOrg = _context.sent;
          _context.next = 6;
          return (0, _effects.call)(_ApiService.fetchDataRequest, 'teams', [_api.ORGID_PATH_PARAM], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id]) || [];

        case 6:
          fetchedTeams = _context.sent;
          _context.next = 9;
          return (0, _effects.put)((0, _team.fetchTeamsSuccess)(fetchedTeams));

        case 9:
          _context.next = 15;
          break;

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](0);
          _context.next = 15;
          return (0, _effects.put)((0, _team.showTeamMessage)((0, _errorService.apiErrorMessageFormatter)(_context.t0)));

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 11]]);
}

function deleteTeam(_ref) {
  var payload, selectedOrg;
  return regeneratorRuntime.wrap(function deleteTeam$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _ref.payload;
          _context2.prev = 1;
          _context2.next = 4;
          return (0, _effects.select)(currentOrg);

        case 4:
          selectedOrg = _context2.sent;
          _context2.next = 7;
          return (0, _effects.call)(_ApiService.deleteDataRequest, 'deleteTeam', 'Deleting team '.concat(payload), [_api.ORGID_PATH_PARAM, 'teamId'], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id, payload]) || [];

        case 7:
          _context2.next = 9;
          return (0, _effects.put)((0, _team.onDeleteTeamSuccess)(payload));

        case 9:
          _context2.next = 15;
          break;

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](1);
          _context2.next = 15;
          return (0, _effects.put)((0, _team.showTeamMessage)((0, _errorService.apiErrorMessageFormatter)(_context2.t0)));

        case 15:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 11]]);
}

function saveTeam(_ref2) {
  var payload, selectedOrg, allTeams, finalPayload, savedTeam;
  return regeneratorRuntime.wrap(function saveTeam$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _ref2.payload;
          _context3.prev = 1;
          _context3.next = 4;
          return (0, _effects.select)(currentOrg);

        case 4:
          selectedOrg = _context3.sent;
          _context3.next = 7;
          return (0, _effects.select)(getTeamList);

        case 7:
          allTeams = _context3.sent;
          finalPayload = _objectSpread({}, payload); // check the orgid of the payload - it will be empty for a new payload - populate from the selectedOrg - otherwise leave it as is

          if ((payload === null || payload === void 0 ? void 0 : payload.orgid) === '') {
            finalPayload = _objectSpread({}, payload, {
              orgid: selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id
            });
          }

          _context3.next = 12;
          return (0, _effects.call)(_ApiService.addOrUpdateDataRequest, allTeams, finalPayload, 'addTeam', 'updateTeam', [_api.ORGID_PATH_PARAM], [selectedOrg.id]);

        case 12:
          savedTeam = _context3.sent;
          _context3.next = 15;
          return (0, _effects.put)((0, _team.onSaveTeamSuccess)(savedTeam));

        case 15:
          _context3.next = 21;
          break;

        case 17:
          _context3.prev = 17;
          _context3.t0 = _context3["catch"](1);
          _context3.next = 21;
          return (0, _effects.put)((0, _team.showTeamMessage)((0, _errorService.apiErrorMessageFormatter)(_context3.t0)));

        case 21:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[1, 17]]);
}
/**
 * This is when the user selects the star on the list page - update the starred attribute of the entity
 * @param {*} param0 
 */


function addFavouriteTeam(_ref3) {
  var payload, allTeams, selectedOrg, filtered, entry, updatedTeam, auditMsg;
  return regeneratorRuntime.wrap(function addFavouriteTeam$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _ref3.payload;
          _context4.prev = 1;
          _context4.next = 4;
          return (0, _effects.select)(getTeamList);

        case 4:
          allTeams = _context4.sent;
          _context4.next = 7;
          return (0, _effects.select)(currentOrg);

        case 7:
          selectedOrg = _context4.sent;
          filtered = allTeams.filter(function (entry) {
            return (entry === null || entry === void 0 ? void 0 : entry.id) === (payload === null || payload === void 0 ? void 0 : payload.id);
          });

          if (!((filtered === null || filtered === void 0 ? void 0 : filtered.length) > 0)) {
            _context4.next = 17;
            break;
          }

          entry = filtered[0];
          updatedTeam = _objectSpread({}, entry, {
            starred: !payload.starred
          });
          auditMsg = 'Updating starred setting to '.concat(updatedTeam === null || updatedTeam === void 0 ? void 0 : updatedTeam.starred).concat(' for team ').concat(updatedTeam === null || updatedTeam === void 0 ? void 0 : updatedTeam.id);
          _context4.next = 15;
          return (0, _effects.call)(_ApiService.updateDataRequest, updatedTeam, 'updateTeam', auditMsg, [_api.ORGID_PATH_PARAM], [selectedOrg.id]);

        case 15:
          _context4.next = 17;
          return (0, _effects.put)((0, _team.addFavouriteTeamSuccess)(payload));

        case 17:
          _context4.next = 23;
          break;

        case 19:
          _context4.prev = 19;
          _context4.t0 = _context4["catch"](1);
          _context4.next = 23;
          return (0, _effects.put)((0, _team.showTeamMessage)(_context4.t0.messages));

        case 23:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[1, 19]]);
}

function onFetchSelectMemberData() {
  var selectedTeam, allMembers, selectedDrillDownItems, selections;
  return regeneratorRuntime.wrap(function onFetchSelectMemberData$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.select)(getSelectedTeam);

        case 2:
          selectedTeam = _context5.sent;
          _context5.next = 5;
          return (0, _effects.select)(getMemberList);

        case 5:
          allMembers = _context5.sent;
          selectedDrillDownItems = Array.isArray(selectedTeam === null || selectedTeam === void 0 ? void 0 : selectedTeam.members) ? selectedTeam === null || selectedTeam === void 0 ? void 0 : selectedTeam.members : [];
          selections = (0, _selectors.mapDataToSelectionData)(allMembers, selectedDrillDownItems) || null;
          _context5.next = 10;
          return (0, _effects.put)((0, _team.onFetchSelectMemberDataSuccess)(selections));

        case 10:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

function onTeamMemberUpdate() {
  var selectedOrg, selectedTeam, selectedMembers, updatedDrillDownSelections, updatedSelectedTeam, auditMsg;
  return regeneratorRuntime.wrap(function onTeamMemberUpdate$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return (0, _effects.select)(currentOrg);

        case 3:
          selectedOrg = _context6.sent;
          _context6.next = 6;
          return (0, _effects.select)(getSelectedTeam);

        case 6:
          selectedTeam = _context6.sent;
          _context6.next = 9;
          return (0, _effects.select)(getSelectedMembers);

        case 9:
          selectedMembers = _context6.sent;
          updatedDrillDownSelections = new Array();
          selectedMembers.forEach(function (selection) {
            if (selection === null || selection === void 0 ? void 0 : selection.selected) {
              updatedDrillDownSelections.push(selection === null || selection === void 0 ? void 0 : selection.id);
            }
          });
          updatedSelectedTeam = _objectSpread({}, selectedTeam, {
            members: updatedDrillDownSelections
          });
          auditMsg = 'Updating selected member to '.concat(' for team ').concat(updatedSelectedTeam === null || updatedSelectedTeam === void 0 ? void 0 : updatedSelectedTeam.id);
          _context6.next = 16;
          return (0, _effects.call)(_ApiService.updateDataRequest, updatedSelectedTeam, 'updateTeam', auditMsg, [_api.ORGID_PATH_PARAM], [selectedOrg.id]);

        case 16:
          _context6.next = 18;
          return (0, _effects.put)((0, _team.onSaveTeamSuccess)(updatedSelectedTeam));

        case 18:
          _context6.next = 24;
          break;

        case 20:
          _context6.prev = 20;
          _context6.t0 = _context6["catch"](0);
          _context6.next = 24;
          return (0, _effects.put)((0, _team.showTeamMessage)((0, _errorService.apiErrorMessageFormatter)(_context6.t0)));

        case 24:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6, null, [[0, 20]]);
}

function fetchTeamsSaga() {
  return regeneratorRuntime.wrap(function fetchTeamsSaga$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_ALL_TEAM, fetchTeams);

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}

function saveTeamSaga() {
  return regeneratorRuntime.wrap(function saveTeamSaga$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_SAVE_TEAM, saveTeam);

        case 2:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}

function deleteTeamSaga() {
  return regeneratorRuntime.wrap(function deleteTeamSaga$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_DELETE_TEAM, deleteTeam);

        case 2:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}

function addFavouriteTeamSaga() {
  return regeneratorRuntime.wrap(function addFavouriteTeamSaga$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ADD_FAVOURITE_TEAM, addFavouriteTeam);

        case 2:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked10);
}

function onFetchSelectMemberDataSaga() {
  return regeneratorRuntime.wrap(function onFetchSelectMemberDataSaga$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_FETCH_SELECT_MEMBER_DATA, onFetchSelectMemberData);

        case 2:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked11);
}

function onTeamMemberUpdateSaga() {
  return regeneratorRuntime.wrap(function onTeamMemberUpdateSaga$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_TEAM_MEMBER_UPDATE, onTeamMemberUpdate);

        case 2:
        case "end":
          return _context12.stop();
      }
    }
  }, _marked12);
}

function rootSaga() {
  return regeneratorRuntime.wrap(function rootSaga$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.all)([(0, _effects.fork)(fetchTeamsSaga), (0, _effects.fork)(saveTeamSaga), (0, _effects.fork)(deleteTeamSaga), (0, _effects.fork)(addFavouriteTeamSaga), (0, _effects.fork)(onFetchSelectMemberDataSaga), (0, _effects.fork)(onTeamMemberUpdateSaga)]);

        case 2:
        case "end":
          return _context13.stop();
      }
    }
  }, _marked13);
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(getTeamList, "getTeamList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(getSelectedTeam, "getSelectedTeam", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(getMemberList, "getMemberList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(getSelectedMembers, "getSelectedMembers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(fetchTeams, "fetchTeams", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(deleteTeam, "deleteTeam", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(saveTeam, "saveTeam", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(addFavouriteTeam, "addFavouriteTeam", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(onFetchSelectMemberData, "onFetchSelectMemberData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(onTeamMemberUpdate, "onTeamMemberUpdate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(fetchTeamsSaga, "fetchTeamsSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(saveTeamSaga, "saveTeamSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(deleteTeamSaga, "deleteTeamSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(addFavouriteTeamSaga, "addFavouriteTeamSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(onFetchSelectMemberDataSaga, "onFetchSelectMemberDataSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(onTeamMemberUpdateSaga, "onTeamMemberUpdateSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(_marked, "_marked", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(_marked2, "_marked2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(_marked3, "_marked3", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(_marked4, "_marked4", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(_marked5, "_marked5", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(_marked6, "_marked6", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(_marked7, "_marked7", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(_marked8, "_marked8", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(_marked9, "_marked9", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(_marked10, "_marked10", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(_marked11, "_marked11", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(_marked12, "_marked12", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(_marked13, "_marked13", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(getTeamList, "getTeamList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(getSelectedTeam, "getSelectedTeam", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(getMemberList, "getMemberList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(getSelectedMembers, "getSelectedMembers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(fetchTeams, "fetchTeams", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(deleteTeam, "deleteTeam", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(saveTeam, "saveTeam", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(addFavouriteTeam, "addFavouriteTeam", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(onFetchSelectMemberData, "onFetchSelectMemberData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(onTeamMemberUpdate, "onTeamMemberUpdate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(fetchTeamsSaga, "fetchTeamsSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(saveTeamSaga, "saveTeamSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(deleteTeamSaga, "deleteTeamSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(addFavouriteTeamSaga, "addFavouriteTeamSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(onFetchSelectMemberDataSaga, "onFetchSelectMemberDataSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(onTeamMemberUpdateSaga, "onTeamMemberUpdateSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/team.js");
}();

;

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchProductLookupData = fetchProductLookupData;
exports.fetchProducts = fetchProducts;
exports.deleteProduct = deleteProduct;
exports.saveProduct = saveProduct;
exports.addFavouriteProduct = addFavouriteProduct;
exports.onFetchSelectValueStreamData = onFetchSelectValueStreamData;
exports.onProductValueStreamUpdate = onProductValueStreamUpdate;
exports.fetchProductLookupDataSaga = fetchProductLookupDataSaga;
exports.fetchProductsSaga = fetchProductsSaga;
exports.saveProductSaga = saveProductSaga;
exports.deleteProductSaga = deleteProductSaga;
exports.addFavouriteProductSaga = addFavouriteProductSaga;
exports.onFetchSelectValueStreamDataSaga = onFetchSelectValueStreamDataSaga;
exports.onProductValueStreamUpdateSaga = onProductValueStreamUpdateSaga;
exports["default"] = rootSaga;

var _effects = __webpack_require__(15);

var _product = __webpack_require__(117);

var _valueStream = __webpack_require__(115);

var _member = __webpack_require__(100);

var _businessUnit = __webpack_require__(263);

var _ActionTypes = __webpack_require__(7);

var _ApiService = __webpack_require__(16);

var _errorService = __webpack_require__(50);

var _api = __webpack_require__(25);

var _selectors = __webpack_require__(146);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(fetchProductLookupData),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchProducts),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(deleteProduct),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(saveProduct),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(addFavouriteProduct),
    _marked6 =
/*#__PURE__*/
regeneratorRuntime.mark(onFetchSelectValueStreamData),
    _marked7 =
/*#__PURE__*/
regeneratorRuntime.mark(onProductValueStreamUpdate),
    _marked8 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchProductLookupDataSaga),
    _marked9 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchProductsSaga),
    _marked10 =
/*#__PURE__*/
regeneratorRuntime.mark(saveProductSaga),
    _marked11 =
/*#__PURE__*/
regeneratorRuntime.mark(deleteProductSaga),
    _marked12 =
/*#__PURE__*/
regeneratorRuntime.mark(addFavouriteProductSaga),
    _marked13 =
/*#__PURE__*/
regeneratorRuntime.mark(onFetchSelectValueStreamDataSaga),
    _marked14 =
/*#__PURE__*/
regeneratorRuntime.mark(onProductValueStreamUpdateSaga),
    _marked15 =
/*#__PURE__*/
regeneratorRuntime.mark(rootSaga);

var currentOrg = function currentOrg(state) {
  return state.orgs.selectedOrg;
};

var getProductList = function getProductList(state) {
  return state.products.allProduct;
};

var getSelectedProduct = function getSelectedProduct(state) {
  return state.products.selectedProduct;
};

var getValueStreamList = function getValueStreamList(state) {
  return state.valueStreams.allValueStream;
};

var getSelectedValueStreams = function getSelectedValueStreams(state) {
  return state.products.valueStreamSelectionList;
};

function fetchProductLookupData() {
  return regeneratorRuntime.wrap(function fetchProductLookupData$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)((0, _valueStream.fetchValueStreams)());

        case 2:
          _context.next = 4;
          return (0, _effects.put)((0, _member.fetchMembers)());

        case 4:
          _context.next = 6;
          return (0, _effects.put)((0, _businessUnit.fetchBusinessUnits)());

        case 6:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function fetchProducts() {
  var selectedOrg, fetchedProducts;
  return regeneratorRuntime.wrap(function fetchProducts$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.select)(currentOrg);

        case 3:
          selectedOrg = _context2.sent;
          _context2.next = 6;
          return (0, _effects.call)(_ApiService.fetchDataRequest, 'products', [_api.ORGID_PATH_PARAM], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id]) || [];

        case 6:
          fetchedProducts = _context2.sent;
          _context2.next = 9;
          return (0, _effects.put)((0, _product.fetchProductsSuccess)(fetchedProducts));

        case 9:
          _context2.next = 15;
          break;

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](0);
          _context2.next = 15;
          return (0, _effects.put)((0, _product.showProductMessage)((0, _errorService.apiErrorMessageFormatter)(_context2.t0)));

        case 15:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[0, 11]]);
}

function deleteProduct(_ref) {
  var payload, selectedOrg;
  return regeneratorRuntime.wrap(function deleteProduct$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _ref.payload;
          _context3.prev = 1;
          _context3.next = 4;
          return (0, _effects.select)(currentOrg);

        case 4:
          selectedOrg = _context3.sent;
          _context3.next = 7;
          return (0, _effects.call)(_ApiService.deleteDataRequest, 'deleteProduct', 'Deleting product '.concat(payload), [_api.ORGID_PATH_PARAM, 'productId'], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id, payload]) || [];

        case 7:
          _context3.next = 9;
          return (0, _effects.put)((0, _product.onDeleteProductSuccess)(payload));

        case 9:
          _context3.next = 15;
          break;

        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3["catch"](1);
          _context3.next = 15;
          return (0, _effects.put)((0, _product.showProductMessage)((0, _errorService.apiErrorMessageFormatter)(_context3.t0)));

        case 15:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[1, 11]]);
}

function saveProduct(_ref2) {
  var payload, selectedOrg, allProducts, finalPayload, savedProduct;
  return regeneratorRuntime.wrap(function saveProduct$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _ref2.payload;
          _context4.prev = 1;
          _context4.next = 4;
          return (0, _effects.select)(currentOrg);

        case 4:
          selectedOrg = _context4.sent;
          _context4.next = 7;
          return (0, _effects.select)(getProductList);

        case 7:
          allProducts = _context4.sent;
          finalPayload = _objectSpread({}, payload); // check the orgid of the payload - it will be empty for a new payload - populate from the selectedOrg - otherwise leave it as is

          if ((payload === null || payload === void 0 ? void 0 : payload.orgid) === '') {
            finalPayload = _objectSpread({}, payload, {
              orgid: selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id
            });
          }

          _context4.next = 12;
          return (0, _effects.call)(_ApiService.addOrUpdateDataRequest, allProducts, finalPayload, 'addProduct', 'updateProduct', [_api.ORGID_PATH_PARAM], [selectedOrg.id]);

        case 12:
          savedProduct = _context4.sent;
          _context4.next = 15;
          return (0, _effects.put)((0, _product.onSaveProductSuccess)(savedProduct));

        case 15:
          _context4.next = 21;
          break;

        case 17:
          _context4.prev = 17;
          _context4.t0 = _context4["catch"](1);
          _context4.next = 21;
          return (0, _effects.put)((0, _product.showProductMessage)((0, _errorService.apiErrorMessageFormatter)(_context4.t0)));

        case 21:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[1, 17]]);
}
/**
 * This is when the user selects the star on the list page - update the starred attribute of the entity
 * @param {*} param0 
 */


function addFavouriteProduct(_ref3) {
  var payload, allProducts, selectedOrg, filtered, entry, updatedProduct, auditMsg;
  return regeneratorRuntime.wrap(function addFavouriteProduct$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = _ref3.payload;
          _context5.prev = 1;
          _context5.next = 4;
          return (0, _effects.select)(getProductList);

        case 4:
          allProducts = _context5.sent;
          _context5.next = 7;
          return (0, _effects.select)(currentOrg);

        case 7:
          selectedOrg = _context5.sent;
          filtered = allProducts.filter(function (entry) {
            return (entry === null || entry === void 0 ? void 0 : entry.id) === (payload === null || payload === void 0 ? void 0 : payload.id);
          });

          if (!((filtered === null || filtered === void 0 ? void 0 : filtered.length) > 0)) {
            _context5.next = 17;
            break;
          }

          entry = filtered[0];
          updatedProduct = _objectSpread({}, entry, {
            starred: !payload.starred
          });
          auditMsg = 'Updating starred setting to '.concat(updatedProduct === null || updatedProduct === void 0 ? void 0 : updatedProduct.starred).concat(' for product ').concat(updatedProduct === null || updatedProduct === void 0 ? void 0 : updatedProduct.id);
          _context5.next = 15;
          return (0, _effects.call)(_ApiService.updateDataRequest, updatedProduct, 'updateProduct', auditMsg, [_api.ORGID_PATH_PARAM], [selectedOrg.id]);

        case 15:
          _context5.next = 17;
          return (0, _effects.put)((0, _product.addFavouriteProductSuccess)(payload));

        case 17:
          _context5.next = 23;
          break;

        case 19:
          _context5.prev = 19;
          _context5.t0 = _context5["catch"](1);
          _context5.next = 23;
          return (0, _effects.put)((0, _product.showProductMessage)(_context5.t0.messages));

        case 23:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, null, [[1, 19]]);
}

function onFetchSelectValueStreamData() {
  var selectedProduct, allValueStreams, selectedDrillDownItems, selections;
  return regeneratorRuntime.wrap(function onFetchSelectValueStreamData$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.select)(getSelectedProduct);

        case 2:
          selectedProduct = _context6.sent;
          _context6.next = 5;
          return (0, _effects.select)(getValueStreamList);

        case 5:
          allValueStreams = _context6.sent;
          selectedDrillDownItems = Array.isArray(selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.valueStreams) ? selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.valueStreams : [];
          selections = (0, _selectors.mapDataToSelectionData)(allValueStreams, selectedDrillDownItems) || null;
          _context6.next = 10;
          return (0, _effects.put)((0, _product.onFetchSelectValueStreamDataSuccess)(selections));

        case 10:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}

function onProductValueStreamUpdate() {
  var selectedOrg, selectedProduct, selectedValueStreams, updatedDrillDownSelections, updatedSelectedProduct, auditMsg;
  return regeneratorRuntime.wrap(function onProductValueStreamUpdate$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return (0, _effects.select)(currentOrg);

        case 3:
          selectedOrg = _context7.sent;
          _context7.next = 6;
          return (0, _effects.select)(getSelectedProduct);

        case 6:
          selectedProduct = _context7.sent;
          _context7.next = 9;
          return (0, _effects.select)(getSelectedValueStreams);

        case 9:
          selectedValueStreams = _context7.sent;
          updatedDrillDownSelections = new Array();
          selectedValueStreams.forEach(function (selection) {
            if (selection === null || selection === void 0 ? void 0 : selection.selected) {
              updatedDrillDownSelections.push(selection === null || selection === void 0 ? void 0 : selection.id);
            }
          });
          updatedSelectedProduct = _objectSpread({}, selectedProduct, {
            valueStreams: updatedDrillDownSelections
          });
          auditMsg = 'Updating selected valueStream to '.concat(' for product ').concat(updatedSelectedProduct === null || updatedSelectedProduct === void 0 ? void 0 : updatedSelectedProduct.id);
          _context7.next = 16;
          return (0, _effects.call)(_ApiService.updateDataRequest, updatedSelectedProduct, 'updateProduct', auditMsg, [_api.ORGID_PATH_PARAM], [selectedOrg.id]);

        case 16:
          _context7.next = 18;
          return (0, _effects.put)((0, _product.onSaveProductSuccess)(updatedSelectedProduct));

        case 18:
          _context7.next = 24;
          break;

        case 20:
          _context7.prev = 20;
          _context7.t0 = _context7["catch"](0);
          _context7.next = 24;
          return (0, _effects.put)((0, _product.showProductMessage)((0, _errorService.apiErrorMessageFormatter)(_context7.t0)));

        case 24:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7, null, [[0, 20]]);
}

function fetchProductLookupDataSaga() {
  return regeneratorRuntime.wrap(function fetchProductLookupDataSaga$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_PRODUCT_LOOKUP_DATA, fetchProductLookupData);

        case 2:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}

function fetchProductsSaga() {
  return regeneratorRuntime.wrap(function fetchProductsSaga$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_ALL_PRODUCT, fetchProducts);

        case 2:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}

function saveProductSaga() {
  return regeneratorRuntime.wrap(function saveProductSaga$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_SAVE_PRODUCT, saveProduct);

        case 2:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked10);
}

function deleteProductSaga() {
  return regeneratorRuntime.wrap(function deleteProductSaga$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_DELETE_PRODUCT, deleteProduct);

        case 2:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked11);
}

function addFavouriteProductSaga() {
  return regeneratorRuntime.wrap(function addFavouriteProductSaga$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ADD_FAVOURITE_PRODUCT, addFavouriteProduct);

        case 2:
        case "end":
          return _context12.stop();
      }
    }
  }, _marked12);
}

function onFetchSelectValueStreamDataSaga() {
  return regeneratorRuntime.wrap(function onFetchSelectValueStreamDataSaga$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_FETCH_SELECT_VALUESTREAM_DATA, onFetchSelectValueStreamData);

        case 2:
        case "end":
          return _context13.stop();
      }
    }
  }, _marked13);
}

function onProductValueStreamUpdateSaga() {
  return regeneratorRuntime.wrap(function onProductValueStreamUpdateSaga$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_PRODUCT_VALUESTREAM_UPDATE, onProductValueStreamUpdate);

        case 2:
        case "end":
          return _context14.stop();
      }
    }
  }, _marked14);
}

function rootSaga() {
  return regeneratorRuntime.wrap(function rootSaga$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return (0, _effects.all)([(0, _effects.fork)(fetchProductsSaga), (0, _effects.fork)(saveProductSaga), (0, _effects.fork)(deleteProductSaga), (0, _effects.fork)(addFavouriteProductSaga), (0, _effects.fork)(onFetchSelectValueStreamDataSaga), (0, _effects.fork)(onProductValueStreamUpdateSaga), (0, _effects.fork)(fetchProductLookupDataSaga)]);

        case 2:
        case "end":
          return _context15.stop();
      }
    }
  }, _marked15);
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(getProductList, "getProductList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(getSelectedProduct, "getSelectedProduct", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(getValueStreamList, "getValueStreamList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(getSelectedValueStreams, "getSelectedValueStreams", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(fetchProductLookupData, "fetchProductLookupData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(fetchProducts, "fetchProducts", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(deleteProduct, "deleteProduct", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(saveProduct, "saveProduct", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(addFavouriteProduct, "addFavouriteProduct", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(onFetchSelectValueStreamData, "onFetchSelectValueStreamData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(onProductValueStreamUpdate, "onProductValueStreamUpdate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(fetchProductLookupDataSaga, "fetchProductLookupDataSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(fetchProductsSaga, "fetchProductsSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(saveProductSaga, "saveProductSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(deleteProductSaga, "deleteProductSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(addFavouriteProductSaga, "addFavouriteProductSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(onFetchSelectValueStreamDataSaga, "onFetchSelectValueStreamDataSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(onProductValueStreamUpdateSaga, "onProductValueStreamUpdateSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(_marked, "_marked", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(_marked2, "_marked2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(_marked3, "_marked3", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(_marked4, "_marked4", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(_marked5, "_marked5", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(_marked6, "_marked6", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(_marked7, "_marked7", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(_marked8, "_marked8", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(_marked9, "_marked9", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(_marked10, "_marked10", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(_marked11, "_marked11", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(_marked12, "_marked12", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(_marked13, "_marked13", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(_marked14, "_marked14", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(_marked15, "_marked15", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(getProductList, "getProductList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(getSelectedProduct, "getSelectedProduct", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(getValueStreamList, "getValueStreamList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(getSelectedValueStreams, "getSelectedValueStreams", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(fetchProductLookupData, "fetchProductLookupData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(fetchProducts, "fetchProducts", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(deleteProduct, "deleteProduct", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(saveProduct, "saveProduct", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(addFavouriteProduct, "addFavouriteProduct", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(onFetchSelectValueStreamData, "onFetchSelectValueStreamData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(onProductValueStreamUpdate, "onProductValueStreamUpdate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(fetchProductLookupDataSaga, "fetchProductLookupDataSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(fetchProductsSaga, "fetchProductsSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(saveProductSaga, "saveProductSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(deleteProductSaga, "deleteProductSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(addFavouriteProductSaga, "addFavouriteProductSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(onFetchSelectValueStreamDataSaga, "onFetchSelectValueStreamDataSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(onProductValueStreamUpdateSaga, "onProductValueStreamUpdateSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/product.js");
}();

;

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchInitiatives = fetchInitiatives;
exports.deleteInitiative = deleteInitiative;
exports.saveInitiative = saveInitiative;
exports.addFavouriteInitiative = addFavouriteInitiative;
exports.onFetchSelectProductData = onFetchSelectProductData;
exports.onInitiativeProductUpdate = onInitiativeProductUpdate;
exports.fetchInitiativesSaga = fetchInitiativesSaga;
exports.saveInitiativeSaga = saveInitiativeSaga;
exports.deleteInitiativeSaga = deleteInitiativeSaga;
exports.addFavouriteInitiativeSaga = addFavouriteInitiativeSaga;
exports.onFetchSelectProductDataSaga = onFetchSelectProductDataSaga;
exports.onInitiativeProductUpdateSaga = onInitiativeProductUpdateSaga;
exports["default"] = rootSaga;

var _effects = __webpack_require__(15);

var _initiative = __webpack_require__(101);

var _ActionTypes = __webpack_require__(7);

var _ApiService = __webpack_require__(16);

var _errorService = __webpack_require__(50);

var _api = __webpack_require__(25);

var _selectors = __webpack_require__(146);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(fetchInitiatives),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(deleteInitiative),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(saveInitiative),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(addFavouriteInitiative),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(onFetchSelectProductData),
    _marked6 =
/*#__PURE__*/
regeneratorRuntime.mark(onInitiativeProductUpdate),
    _marked7 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchInitiativesSaga),
    _marked8 =
/*#__PURE__*/
regeneratorRuntime.mark(saveInitiativeSaga),
    _marked9 =
/*#__PURE__*/
regeneratorRuntime.mark(deleteInitiativeSaga),
    _marked10 =
/*#__PURE__*/
regeneratorRuntime.mark(addFavouriteInitiativeSaga),
    _marked11 =
/*#__PURE__*/
regeneratorRuntime.mark(onFetchSelectProductDataSaga),
    _marked12 =
/*#__PURE__*/
regeneratorRuntime.mark(onInitiativeProductUpdateSaga),
    _marked13 =
/*#__PURE__*/
regeneratorRuntime.mark(rootSaga);

var currentOrg = function currentOrg(state) {
  return state.orgs.selectedOrg;
};

var getInitiativeList = function getInitiativeList(state) {
  return state.initiatives.allInitiative;
};

var getSelectedInitiative = function getSelectedInitiative(state) {
  return state.initiatives.selectedInitiative;
};

var getProductList = function getProductList(state) {
  return state.products.allProduct;
};

var getSelectedProducts = function getSelectedProducts(state) {
  return state.initiatives.productSelectionList;
};

function fetchInitiatives() {
  var selectedOrg, fetchedInitiatives;
  return regeneratorRuntime.wrap(function fetchInitiatives$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.select)(currentOrg);

        case 3:
          selectedOrg = _context.sent;
          _context.next = 6;
          return (0, _effects.call)(_ApiService.fetchDataRequest, 'initiatives', [_api.ORGID_PATH_PARAM], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id]) || [];

        case 6:
          fetchedInitiatives = _context.sent;
          _context.next = 9;
          return (0, _effects.put)((0, _initiative.fetchInitiativesSuccess)(fetchedInitiatives));

        case 9:
          _context.next = 15;
          break;

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](0);
          _context.next = 15;
          return (0, _effects.put)((0, _initiative.showInitiativeMessage)((0, _errorService.apiErrorMessageFormatter)(_context.t0)));

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 11]]);
}

function deleteInitiative(_ref) {
  var payload, selectedOrg;
  return regeneratorRuntime.wrap(function deleteInitiative$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _ref.payload;
          _context2.prev = 1;
          _context2.next = 4;
          return (0, _effects.select)(currentOrg);

        case 4:
          selectedOrg = _context2.sent;
          _context2.next = 7;
          return (0, _effects.call)(_ApiService.deleteDataRequest, 'deleteInitiative', 'Deleting initiative '.concat(payload), [_api.ORGID_PATH_PARAM, 'initiativeId'], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id, payload]) || [];

        case 7:
          _context2.next = 9;
          return (0, _effects.put)((0, _initiative.onDeleteInitiativeSuccess)(payload));

        case 9:
          _context2.next = 15;
          break;

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](1);
          _context2.next = 15;
          return (0, _effects.put)((0, _initiative.showInitiativeMessage)((0, _errorService.apiErrorMessageFormatter)(_context2.t0)));

        case 15:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 11]]);
}

function saveInitiative(_ref2) {
  var payload, selectedOrg, allInitiatives, finalPayload, savedInitiative;
  return regeneratorRuntime.wrap(function saveInitiative$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _ref2.payload;
          _context3.prev = 1;
          _context3.next = 4;
          return (0, _effects.select)(currentOrg);

        case 4:
          selectedOrg = _context3.sent;
          _context3.next = 7;
          return (0, _effects.select)(getInitiativeList);

        case 7:
          allInitiatives = _context3.sent;
          finalPayload = _objectSpread({}, payload); // check the orgid of the payload - it will be empty for a new payload - populate from the selectedOrg - otherwise leave it as is

          if ((payload === null || payload === void 0 ? void 0 : payload.orgid) === '') {
            finalPayload = _objectSpread({}, payload, {
              orgid: selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id
            });
          }

          _context3.next = 12;
          return (0, _effects.call)(_ApiService.addOrUpdateDataRequest, allInitiatives, finalPayload, 'addInitiative', 'updateInitiative', [_api.ORGID_PATH_PARAM], [selectedOrg.id]);

        case 12:
          savedInitiative = _context3.sent;
          _context3.next = 15;
          return (0, _effects.put)((0, _initiative.onSaveInitiativeSuccess)(savedInitiative));

        case 15:
          _context3.next = 21;
          break;

        case 17:
          _context3.prev = 17;
          _context3.t0 = _context3["catch"](1);
          _context3.next = 21;
          return (0, _effects.put)((0, _initiative.showInitiativeMessage)((0, _errorService.apiErrorMessageFormatter)(_context3.t0)));

        case 21:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[1, 17]]);
}
/**
 * This is when the user selects the star on the list page - update the starred attribute of the entity
 * @param {*} param0 
 */


function addFavouriteInitiative(_ref3) {
  var payload, allInitiatives, selectedOrg, filtered, entry, updatedInitiative, auditMsg;
  return regeneratorRuntime.wrap(function addFavouriteInitiative$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _ref3.payload;
          _context4.prev = 1;
          _context4.next = 4;
          return (0, _effects.select)(getInitiativeList);

        case 4:
          allInitiatives = _context4.sent;
          _context4.next = 7;
          return (0, _effects.select)(currentOrg);

        case 7:
          selectedOrg = _context4.sent;
          filtered = allInitiatives.filter(function (entry) {
            return (entry === null || entry === void 0 ? void 0 : entry.id) === (payload === null || payload === void 0 ? void 0 : payload.id);
          });

          if (!((filtered === null || filtered === void 0 ? void 0 : filtered.length) > 0)) {
            _context4.next = 17;
            break;
          }

          entry = filtered[0];
          updatedInitiative = _objectSpread({}, entry, {
            starred: !payload.starred
          });
          auditMsg = 'Updating starred setting to '.concat(updatedInitiative === null || updatedInitiative === void 0 ? void 0 : updatedInitiative.starred).concat(' for initiative ').concat(updatedInitiative === null || updatedInitiative === void 0 ? void 0 : updatedInitiative.id);
          _context4.next = 15;
          return (0, _effects.call)(_ApiService.updateDataRequest, updatedInitiative, 'updateInitiative', auditMsg, [_api.ORGID_PATH_PARAM], [selectedOrg.id]);

        case 15:
          _context4.next = 17;
          return (0, _effects.put)((0, _initiative.addFavouriteInitiativeSuccess)(payload));

        case 17:
          _context4.next = 23;
          break;

        case 19:
          _context4.prev = 19;
          _context4.t0 = _context4["catch"](1);
          _context4.next = 23;
          return (0, _effects.put)((0, _initiative.showInitiativeMessage)(_context4.t0.messages));

        case 23:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[1, 19]]);
}

function onFetchSelectProductData() {
  var selectedInitiative, allProducts, selectedDrillDownItems, selections;
  return regeneratorRuntime.wrap(function onFetchSelectProductData$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.select)(getSelectedInitiative);

        case 2:
          selectedInitiative = _context5.sent;
          _context5.next = 5;
          return (0, _effects.select)(getProductList);

        case 5:
          allProducts = _context5.sent;
          selectedDrillDownItems = Array.isArray(selectedInitiative === null || selectedInitiative === void 0 ? void 0 : selectedInitiative.products) ? selectedInitiative === null || selectedInitiative === void 0 ? void 0 : selectedInitiative.products : [];
          selections = (0, _selectors.mapDataToSelectionData)(allProducts, selectedDrillDownItems) || null;
          _context5.next = 10;
          return (0, _effects.put)((0, _initiative.onFetchSelectProductDataSuccess)(selections));

        case 10:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

function onInitiativeProductUpdate() {
  var selectedOrg, selectedInitiative, selectedProducts, updatedDrillDownSelections, updatedSelectedInitiative, auditMsg;
  return regeneratorRuntime.wrap(function onInitiativeProductUpdate$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return (0, _effects.select)(currentOrg);

        case 3:
          selectedOrg = _context6.sent;
          _context6.next = 6;
          return (0, _effects.select)(getSelectedInitiative);

        case 6:
          selectedInitiative = _context6.sent;
          _context6.next = 9;
          return (0, _effects.select)(getSelectedProducts);

        case 9:
          selectedProducts = _context6.sent;
          updatedDrillDownSelections = new Array();
          selectedProducts.forEach(function (selection) {
            if (selection === null || selection === void 0 ? void 0 : selection.selected) {
              updatedDrillDownSelections.push(selection === null || selection === void 0 ? void 0 : selection.id);
            }
          });
          updatedSelectedInitiative = _objectSpread({}, selectedInitiative, {
            products: updatedDrillDownSelections
          });
          auditMsg = 'Updating selected product to '.concat(' for initiative ').concat(updatedSelectedInitiative === null || updatedSelectedInitiative === void 0 ? void 0 : updatedSelectedInitiative.id);
          _context6.next = 16;
          return (0, _effects.call)(_ApiService.updateDataRequest, updatedSelectedInitiative, 'updateInitiative', auditMsg, [_api.ORGID_PATH_PARAM], [selectedOrg.id]);

        case 16:
          _context6.next = 18;
          return (0, _effects.put)((0, _initiative.onSaveInitiativeSuccess)(updatedSelectedInitiative));

        case 18:
          _context6.next = 24;
          break;

        case 20:
          _context6.prev = 20;
          _context6.t0 = _context6["catch"](0);
          _context6.next = 24;
          return (0, _effects.put)((0, _initiative.showInitiativeMessage)((0, _errorService.apiErrorMessageFormatter)(_context6.t0)));

        case 24:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6, null, [[0, 20]]);
}

function fetchInitiativesSaga() {
  return regeneratorRuntime.wrap(function fetchInitiativesSaga$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_ALL_INITIATIVE, fetchInitiatives);

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}

function saveInitiativeSaga() {
  return regeneratorRuntime.wrap(function saveInitiativeSaga$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_SAVE_INITIATIVE, saveInitiative);

        case 2:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}

function deleteInitiativeSaga() {
  return regeneratorRuntime.wrap(function deleteInitiativeSaga$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_DELETE_INITIATIVE, deleteInitiative);

        case 2:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}

function addFavouriteInitiativeSaga() {
  return regeneratorRuntime.wrap(function addFavouriteInitiativeSaga$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ADD_FAVOURITE_INITIATIVE, addFavouriteInitiative);

        case 2:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked10);
}

function onFetchSelectProductDataSaga() {
  return regeneratorRuntime.wrap(function onFetchSelectProductDataSaga$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_FETCH_SELECT_PRODUCT_DATA, onFetchSelectProductData);

        case 2:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked11);
}

function onInitiativeProductUpdateSaga() {
  return regeneratorRuntime.wrap(function onInitiativeProductUpdateSaga$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_INITIATIVE_PRODUCT_UPDATE, onInitiativeProductUpdate);

        case 2:
        case "end":
          return _context12.stop();
      }
    }
  }, _marked12);
}

function rootSaga() {
  return regeneratorRuntime.wrap(function rootSaga$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.all)([(0, _effects.fork)(fetchInitiativesSaga), (0, _effects.fork)(saveInitiativeSaga), (0, _effects.fork)(deleteInitiativeSaga), (0, _effects.fork)(addFavouriteInitiativeSaga), (0, _effects.fork)(onFetchSelectProductDataSaga), (0, _effects.fork)(onInitiativeProductUpdateSaga)]);

        case 2:
        case "end":
          return _context13.stop();
      }
    }
  }, _marked13);
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(getInitiativeList, "getInitiativeList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(getSelectedInitiative, "getSelectedInitiative", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(getProductList, "getProductList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(getSelectedProducts, "getSelectedProducts", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(fetchInitiatives, "fetchInitiatives", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(deleteInitiative, "deleteInitiative", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(saveInitiative, "saveInitiative", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(addFavouriteInitiative, "addFavouriteInitiative", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(onFetchSelectProductData, "onFetchSelectProductData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(onInitiativeProductUpdate, "onInitiativeProductUpdate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(fetchInitiativesSaga, "fetchInitiativesSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(saveInitiativeSaga, "saveInitiativeSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(deleteInitiativeSaga, "deleteInitiativeSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(addFavouriteInitiativeSaga, "addFavouriteInitiativeSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(onFetchSelectProductDataSaga, "onFetchSelectProductDataSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(onInitiativeProductUpdateSaga, "onInitiativeProductUpdateSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(_marked, "_marked", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(_marked2, "_marked2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(_marked3, "_marked3", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(_marked4, "_marked4", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(_marked5, "_marked5", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(_marked6, "_marked6", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(_marked7, "_marked7", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(_marked8, "_marked8", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(_marked9, "_marked9", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(_marked10, "_marked10", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(_marked11, "_marked11", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(_marked12, "_marked12", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(_marked13, "_marked13", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(getInitiativeList, "getInitiativeList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(getSelectedInitiative, "getSelectedInitiative", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(getProductList, "getProductList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(getSelectedProducts, "getSelectedProducts", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(fetchInitiatives, "fetchInitiatives", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(deleteInitiative, "deleteInitiative", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(saveInitiative, "saveInitiative", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(addFavouriteInitiative, "addFavouriteInitiative", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(onFetchSelectProductData, "onFetchSelectProductData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(onInitiativeProductUpdate, "onInitiativeProductUpdate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(fetchInitiativesSaga, "fetchInitiativesSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(saveInitiativeSaga, "saveInitiativeSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(deleteInitiativeSaga, "deleteInitiativeSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(addFavouriteInitiativeSaga, "addFavouriteInitiativeSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(onFetchSelectProductDataSaga, "onFetchSelectProductDataSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(onInitiativeProductUpdateSaga, "onInitiativeProductUpdateSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/initiative.js");
}();

;

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchIssues = fetchIssues;
exports.deleteIssue = deleteIssue;
exports.saveIssue = saveIssue;
exports.addFavouriteIssue = addFavouriteIssue;
exports.onFetchSelectFeatureData = onFetchSelectFeatureData;
exports.onIssueFeatureUpdate = onIssueFeatureUpdate;
exports.fetchIssuesSaga = fetchIssuesSaga;
exports.saveIssueSaga = saveIssueSaga;
exports.deleteIssueSaga = deleteIssueSaga;
exports.addFavouriteIssueSaga = addFavouriteIssueSaga;
exports.onFetchSelectFeatureDataSaga = onFetchSelectFeatureDataSaga;
exports.onIssueFeatureUpdateSaga = onIssueFeatureUpdateSaga;
exports["default"] = rootSaga;

var _effects = __webpack_require__(15);

var _issue = __webpack_require__(147);

var _ActionTypes = __webpack_require__(7);

var _ApiService = __webpack_require__(16);

var _errorService = __webpack_require__(50);

var _api = __webpack_require__(25);

var _selectors = __webpack_require__(146);

var _issueService = __webpack_require__(660);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(fetchIssues),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(deleteIssue),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(saveIssue),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(addFavouriteIssue),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(onFetchSelectFeatureData),
    _marked6 =
/*#__PURE__*/
regeneratorRuntime.mark(onIssueFeatureUpdate),
    _marked7 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchIssuesSaga),
    _marked8 =
/*#__PURE__*/
regeneratorRuntime.mark(saveIssueSaga),
    _marked9 =
/*#__PURE__*/
regeneratorRuntime.mark(deleteIssueSaga),
    _marked10 =
/*#__PURE__*/
regeneratorRuntime.mark(addFavouriteIssueSaga),
    _marked11 =
/*#__PURE__*/
regeneratorRuntime.mark(onFetchSelectFeatureDataSaga),
    _marked12 =
/*#__PURE__*/
regeneratorRuntime.mark(onIssueFeatureUpdateSaga),
    _marked13 =
/*#__PURE__*/
regeneratorRuntime.mark(rootSaga);

var currentOrg = function currentOrg(state) {
  return state.orgs.selectedOrg;
};

var getIssueList = function getIssueList(state) {
  return state.issues.allIssue;
};

var getSelectedIssue = function getSelectedIssue(state) {
  return state.issues.selectedIssue;
};

var getSelectedFeatures = function getSelectedFeatures(state) {
  return state.issues.featureSelectionList;
};

function fetchIssues() {
  var selectedOrg, fetchedIssues;
  return regeneratorRuntime.wrap(function fetchIssues$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.select)(currentOrg);

        case 3:
          selectedOrg = _context.sent;
          _context.next = 6;
          return (0, _effects.call)(_ApiService.fetchDataRequest, 'issues', [_api.ORGID_PATH_PARAM], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id]) || [];

        case 6:
          fetchedIssues = _context.sent;
          _context.next = 9;
          return (0, _effects.put)((0, _issue.fetchIssuesSuccess)(fetchedIssues));

        case 9:
          _context.next = 15;
          break;

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](0);
          _context.next = 15;
          return (0, _effects.put)((0, _issue.showIssueMessage)((0, _errorService.apiErrorMessageFormatter)(_context.t0)));

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 11]]);
}

function deleteIssue(_ref) {
  var payload, selectedOrg;
  return regeneratorRuntime.wrap(function deleteIssue$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _ref.payload;
          _context2.prev = 1;
          _context2.next = 4;
          return (0, _effects.select)(currentOrg);

        case 4:
          selectedOrg = _context2.sent;
          _context2.next = 7;
          return (0, _effects.call)(_ApiService.deleteDataRequest, 'deleteIssue', 'Deleting issue '.concat(payload), [_api.ORGID_PATH_PARAM, 'issueId'], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id, payload]) || [];

        case 7:
          _context2.next = 9;
          return (0, _effects.put)((0, _issue.onDeleteIssueSuccess)(payload));

        case 9:
          _context2.next = 15;
          break;

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](1);
          _context2.next = 15;
          return (0, _effects.put)((0, _issue.showIssueMessage)((0, _errorService.apiErrorMessageFormatter)(_context2.t0)));

        case 15:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 11]]);
}

function saveIssue(_ref2) {
  var payload, selectedOrg, allIssues, finalPayload, savedIssue;
  return regeneratorRuntime.wrap(function saveIssue$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _ref2.payload;
          _context3.prev = 1;
          _context3.next = 4;
          return (0, _effects.select)(currentOrg);

        case 4:
          selectedOrg = _context3.sent;
          _context3.next = 7;
          return (0, _effects.select)(getIssueList);

        case 7:
          allIssues = _context3.sent;
          finalPayload = _objectSpread({}, payload); // check the orgid of the payload - it will be empty for a new payload - populate from the selectedOrg - otherwise leave it as is

          if ((payload === null || payload === void 0 ? void 0 : payload.orgid) === '') {
            finalPayload = _objectSpread({}, payload, {
              orgid: selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id
            });
          }

          _context3.next = 12;
          return (0, _effects.call)(_ApiService.addOrUpdateDataRequest, allIssues, finalPayload, 'addIssue', 'updateIssue', [_api.ORGID_PATH_PARAM], [selectedOrg.id]);

        case 12:
          savedIssue = _context3.sent;
          _context3.next = 15;
          return (0, _effects.put)((0, _issue.onSaveIssueSuccess)(savedIssue));

        case 15:
          _context3.next = 21;
          break;

        case 17:
          _context3.prev = 17;
          _context3.t0 = _context3["catch"](1);
          _context3.next = 21;
          return (0, _effects.put)((0, _issue.showIssueMessage)((0, _errorService.apiErrorMessageFormatter)(_context3.t0)));

        case 21:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[1, 17]]);
}
/**
 * This is when the user selects the star on the list page - update the starred attribute of the entity
 * @param {*} param0 
 */


function addFavouriteIssue(_ref3) {
  var payload, allIssues, selectedOrg, filtered, entry, updatedIssue, auditMsg;
  return regeneratorRuntime.wrap(function addFavouriteIssue$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _ref3.payload;
          _context4.prev = 1;
          _context4.next = 4;
          return (0, _effects.select)(getIssueList);

        case 4:
          allIssues = _context4.sent;
          _context4.next = 7;
          return (0, _effects.select)(currentOrg);

        case 7:
          selectedOrg = _context4.sent;
          filtered = allIssues.filter(function (entry) {
            return (entry === null || entry === void 0 ? void 0 : entry.id) === (payload === null || payload === void 0 ? void 0 : payload.id);
          });

          if (!((filtered === null || filtered === void 0 ? void 0 : filtered.length) > 0)) {
            _context4.next = 17;
            break;
          }

          entry = filtered[0];
          updatedIssue = _objectSpread({}, entry, {
            starred: !payload.starred
          });
          auditMsg = 'Updating starred setting to '.concat(updatedIssue === null || updatedIssue === void 0 ? void 0 : updatedIssue.starred).concat(' for issue ').concat(updatedIssue === null || updatedIssue === void 0 ? void 0 : updatedIssue.id);
          _context4.next = 15;
          return (0, _effects.call)(_ApiService.updateDataRequest, updatedIssue, 'updateIssue', auditMsg, [_api.ORGID_PATH_PARAM], [selectedOrg.id]);

        case 15:
          _context4.next = 17;
          return (0, _effects.put)((0, _issue.addFavouriteIssueSuccess)(payload));

        case 17:
          _context4.next = 23;
          break;

        case 19:
          _context4.prev = 19;
          _context4.t0 = _context4["catch"](1);
          _context4.next = 23;
          return (0, _effects.put)((0, _issue.showIssueMessage)(_context4.t0.messages));

        case 23:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[1, 19]]);
}

function onFetchSelectFeatureData() {
  var selectedIssue, allFeatures, selectedDrillDownItems, selections;
  return regeneratorRuntime.wrap(function onFetchSelectFeatureData$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.select)(getSelectedIssue);

        case 2:
          selectedIssue = _context5.sent; // TODO const allFeatures = yield select(getFeatureList);

          allFeatures = (0, _issueService.getMockDrillDownData)();
          selectedDrillDownItems = Array.isArray(selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.features) ? selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.features : [];
          selections = (0, _selectors.mapDataToSelectionData)(allFeatures, selectedDrillDownItems) || null;
          _context5.next = 8;
          return (0, _effects.put)((0, _issue.onFetchSelectFeatureDataSuccess)(selections));

        case 8:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

function onIssueFeatureUpdate() {
  var selectedOrg, selectedIssue, selectedFeatures, updatedDrillDownSelections, updatedSelectedIssue, auditMsg;
  return regeneratorRuntime.wrap(function onIssueFeatureUpdate$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return (0, _effects.select)(currentOrg);

        case 3:
          selectedOrg = _context6.sent;
          _context6.next = 6;
          return (0, _effects.select)(getSelectedIssue);

        case 6:
          selectedIssue = _context6.sent;
          _context6.next = 9;
          return (0, _effects.select)(getSelectedFeatures);

        case 9:
          selectedFeatures = _context6.sent;
          updatedDrillDownSelections = new Array();
          selectedFeatures.forEach(function (selection) {
            if (selection === null || selection === void 0 ? void 0 : selection.selected) {
              updatedDrillDownSelections.push(selection === null || selection === void 0 ? void 0 : selection.id);
            }
          });
          updatedSelectedIssue = _objectSpread({}, selectedIssue, {
            features: updatedDrillDownSelections
          });
          auditMsg = 'Updating selected feature to '.concat(' for issue ').concat(updatedSelectedIssue === null || updatedSelectedIssue === void 0 ? void 0 : updatedSelectedIssue.id);
          _context6.next = 16;
          return (0, _effects.call)(_ApiService.updateDataRequest, updatedSelectedIssue, 'updateIssue', auditMsg, [_api.ORGID_PATH_PARAM], [selectedOrg.id]);

        case 16:
          _context6.next = 18;
          return (0, _effects.put)((0, _issue.onSaveIssueSuccess)(updatedSelectedIssue));

        case 18:
          _context6.next = 24;
          break;

        case 20:
          _context6.prev = 20;
          _context6.t0 = _context6["catch"](0);
          _context6.next = 24;
          return (0, _effects.put)((0, _issue.showIssueMessage)((0, _errorService.apiErrorMessageFormatter)(_context6.t0)));

        case 24:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6, null, [[0, 20]]);
}

function fetchIssuesSaga() {
  return regeneratorRuntime.wrap(function fetchIssuesSaga$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_ALL_ISSUE, fetchIssues);

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}

function saveIssueSaga() {
  return regeneratorRuntime.wrap(function saveIssueSaga$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_SAVE_ISSUE, saveIssue);

        case 2:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}

function deleteIssueSaga() {
  return regeneratorRuntime.wrap(function deleteIssueSaga$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_DELETE_ISSUE, deleteIssue);

        case 2:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}

function addFavouriteIssueSaga() {
  return regeneratorRuntime.wrap(function addFavouriteIssueSaga$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ADD_FAVOURITE_ISSUE, addFavouriteIssue);

        case 2:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked10);
}

function onFetchSelectFeatureDataSaga() {
  return regeneratorRuntime.wrap(function onFetchSelectFeatureDataSaga$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_FETCH_SELECT_FEATURE_DATA, onFetchSelectFeatureData);

        case 2:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked11);
}

function onIssueFeatureUpdateSaga() {
  return regeneratorRuntime.wrap(function onIssueFeatureUpdateSaga$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_ISSUE_FEATURE_UPDATE, onIssueFeatureUpdate);

        case 2:
        case "end":
          return _context12.stop();
      }
    }
  }, _marked12);
}

function rootSaga() {
  return regeneratorRuntime.wrap(function rootSaga$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.all)([(0, _effects.fork)(fetchIssuesSaga), (0, _effects.fork)(saveIssueSaga), (0, _effects.fork)(deleteIssueSaga), (0, _effects.fork)(addFavouriteIssueSaga), (0, _effects.fork)(onFetchSelectFeatureDataSaga), (0, _effects.fork)(onIssueFeatureUpdateSaga)]);

        case 2:
        case "end":
          return _context13.stop();
      }
    }
  }, _marked13);
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(getIssueList, "getIssueList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(getSelectedIssue, "getSelectedIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(getSelectedFeatures, "getSelectedFeatures", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(fetchIssues, "fetchIssues", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(deleteIssue, "deleteIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(saveIssue, "saveIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(addFavouriteIssue, "addFavouriteIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(onFetchSelectFeatureData, "onFetchSelectFeatureData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(onIssueFeatureUpdate, "onIssueFeatureUpdate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(fetchIssuesSaga, "fetchIssuesSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(saveIssueSaga, "saveIssueSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(deleteIssueSaga, "deleteIssueSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(addFavouriteIssueSaga, "addFavouriteIssueSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(onFetchSelectFeatureDataSaga, "onFetchSelectFeatureDataSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(onIssueFeatureUpdateSaga, "onIssueFeatureUpdateSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(_marked, "_marked", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(_marked2, "_marked2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(_marked3, "_marked3", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(_marked4, "_marked4", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(_marked5, "_marked5", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(_marked6, "_marked6", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(_marked7, "_marked7", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(_marked8, "_marked8", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(_marked9, "_marked9", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(_marked10, "_marked10", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(_marked11, "_marked11", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(_marked12, "_marked12", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(_marked13, "_marked13", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(getIssueList, "getIssueList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(getSelectedIssue, "getSelectedIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(getSelectedFeatures, "getSelectedFeatures", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(fetchIssues, "fetchIssues", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(deleteIssue, "deleteIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(saveIssue, "saveIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(addFavouriteIssue, "addFavouriteIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(onFetchSelectFeatureData, "onFetchSelectFeatureData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(onIssueFeatureUpdate, "onIssueFeatureUpdate", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(fetchIssuesSaga, "fetchIssuesSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(saveIssueSaga, "saveIssueSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(deleteIssueSaga, "deleteIssueSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(addFavouriteIssueSaga, "addFavouriteIssueSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(onFetchSelectFeatureDataSaga, "onFetchSelectFeatureDataSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(onIssueFeatureUpdateSaga, "onIssueFeatureUpdateSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/issue.js");
}();

;

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchProjectBusPrioritys = fetchProjectBusPrioritys;
exports.deleteProjectBusPriority = deleteProjectBusPriority;
exports.saveProjectBusPriority = saveProjectBusPriority;
exports.addFavouriteProjectBusPriority = addFavouriteProjectBusPriority;
exports.fetchProjectBusPrioritysSaga = fetchProjectBusPrioritysSaga;
exports.saveProjectBusPrioritySaga = saveProjectBusPrioritySaga;
exports.deleteProjectBusPrioritySaga = deleteProjectBusPrioritySaga;
exports.addFavouriteProjectBusPrioritySaga = addFavouriteProjectBusPrioritySaga;
exports["default"] = rootSaga;

var _effects = __webpack_require__(15);

var _projectBusPriority = __webpack_require__(180);

var _ActionTypes = __webpack_require__(7);

var _ApiService = __webpack_require__(16);

var _errorService = __webpack_require__(50);

var _api = __webpack_require__(25);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(fetchProjectBusPrioritys),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(deleteProjectBusPriority),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(saveProjectBusPriority),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(addFavouriteProjectBusPriority),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchProjectBusPrioritysSaga),
    _marked6 =
/*#__PURE__*/
regeneratorRuntime.mark(saveProjectBusPrioritySaga),
    _marked7 =
/*#__PURE__*/
regeneratorRuntime.mark(deleteProjectBusPrioritySaga),
    _marked8 =
/*#__PURE__*/
regeneratorRuntime.mark(addFavouriteProjectBusPrioritySaga),
    _marked9 =
/*#__PURE__*/
regeneratorRuntime.mark(rootSaga);

var currentOrg = function currentOrg(state) {
  return state.orgs.selectedOrg;
};

var getProjectBusPriorityList = function getProjectBusPriorityList(state) {
  return state.projectBusPrioritys.allProjectBusPriority;
};

function fetchProjectBusPrioritys() {
  var selectedOrg, fetchedProjectBusPrioritys;
  return regeneratorRuntime.wrap(function fetchProjectBusPrioritys$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.select)(currentOrg);

        case 3:
          selectedOrg = _context.sent;
          _context.next = 6;
          return (0, _effects.call)(_ApiService.fetchDataRequest, 'projectBusPrioritys', [_api.ORGID_PATH_PARAM], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id]) || [];

        case 6:
          fetchedProjectBusPrioritys = _context.sent;
          _context.next = 9;
          return (0, _effects.put)((0, _projectBusPriority.fetchProjectBusPrioritysSuccess)(fetchedProjectBusPrioritys));

        case 9:
          _context.next = 15;
          break;

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](0);
          _context.next = 15;
          return (0, _effects.put)((0, _projectBusPriority.showProjectBusPriorityMessage)((0, _errorService.apiErrorMessageFormatter)(_context.t0)));

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 11]]);
}

function deleteProjectBusPriority(_ref) {
  var payload, selectedOrg;
  return regeneratorRuntime.wrap(function deleteProjectBusPriority$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _ref.payload;
          _context2.prev = 1;
          _context2.next = 4;
          return (0, _effects.select)(currentOrg);

        case 4:
          selectedOrg = _context2.sent;
          _context2.next = 7;
          return (0, _effects.call)(_ApiService.deleteDataRequest, 'deleteProjectBusPriority', 'Deleting projectBusPriority '.concat(payload), [_api.ORGID_PATH_PARAM, 'projectBusPriorityId'], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id, payload]) || [];

        case 7:
          _context2.next = 9;
          return (0, _effects.put)((0, _projectBusPriority.onDeleteProjectBusPrioritySuccess)(payload));

        case 9:
          _context2.next = 15;
          break;

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](1);
          _context2.next = 15;
          return (0, _effects.put)((0, _projectBusPriority.showProjectBusPriorityMessage)((0, _errorService.apiErrorMessageFormatter)(_context2.t0)));

        case 15:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 11]]);
}

function saveProjectBusPriority(_ref2) {
  var payload, selectedOrg, allProjectBusPrioritys, finalPayload, savedProjectBusPriority;
  return regeneratorRuntime.wrap(function saveProjectBusPriority$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _ref2.payload;
          _context3.prev = 1;
          _context3.next = 4;
          return (0, _effects.select)(currentOrg);

        case 4:
          selectedOrg = _context3.sent;
          _context3.next = 7;
          return (0, _effects.select)(getProjectBusPriorityList);

        case 7:
          allProjectBusPrioritys = _context3.sent;
          finalPayload = _objectSpread({}, payload); // check the orgid of the payload - it will be empty for a new payload - populate from the selectedOrg - otherwise leave it as is

          if ((payload === null || payload === void 0 ? void 0 : payload.orgid) === '') {
            finalPayload = _objectSpread({}, payload, {
              orgid: selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id
            });
          }

          _context3.next = 12;
          return (0, _effects.call)(_ApiService.addOrUpdateDataRequest, allProjectBusPrioritys, finalPayload, 'addProjectBusPriority', 'updateProjectBusPriority', [_api.ORGID_PATH_PARAM], [selectedOrg.id]);

        case 12:
          savedProjectBusPriority = _context3.sent;
          _context3.next = 15;
          return (0, _effects.put)((0, _projectBusPriority.onSaveProjectBusPrioritySuccess)(savedProjectBusPriority));

        case 15:
          _context3.next = 21;
          break;

        case 17:
          _context3.prev = 17;
          _context3.t0 = _context3["catch"](1);
          _context3.next = 21;
          return (0, _effects.put)((0, _projectBusPriority.showProjectBusPriorityMessage)((0, _errorService.apiErrorMessageFormatter)(_context3.t0)));

        case 21:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[1, 17]]);
}
/**
 * This is when the user selects the star on the list page - update the starred attribute of the entity
 * @param {*} param0 
 */


function addFavouriteProjectBusPriority(_ref3) {
  var payload, allProjectBusPrioritys, selectedOrg, filtered, entry, updatedProjectBusPriority, auditMsg;
  return regeneratorRuntime.wrap(function addFavouriteProjectBusPriority$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _ref3.payload;
          _context4.prev = 1;
          _context4.next = 4;
          return (0, _effects.select)(getProjectBusPriorityList);

        case 4:
          allProjectBusPrioritys = _context4.sent;
          _context4.next = 7;
          return (0, _effects.select)(currentOrg);

        case 7:
          selectedOrg = _context4.sent;
          filtered = allProjectBusPrioritys.filter(function (entry) {
            return (entry === null || entry === void 0 ? void 0 : entry.id) === (payload === null || payload === void 0 ? void 0 : payload.id);
          });

          if (!((filtered === null || filtered === void 0 ? void 0 : filtered.length) > 0)) {
            _context4.next = 17;
            break;
          }

          entry = filtered[0];
          updatedProjectBusPriority = _objectSpread({}, entry, {
            starred: !payload.starred
          });
          auditMsg = 'Updating starred setting to '.concat(updatedProjectBusPriority === null || updatedProjectBusPriority === void 0 ? void 0 : updatedProjectBusPriority.starred).concat(' for projectBusPriority ').concat(updatedProjectBusPriority === null || updatedProjectBusPriority === void 0 ? void 0 : updatedProjectBusPriority.id);
          _context4.next = 15;
          return (0, _effects.call)(_ApiService.updateDataRequest, updatedProjectBusPriority, 'updateProjectBusPriority', auditMsg, [_api.ORGID_PATH_PARAM], [selectedOrg.id]);

        case 15:
          _context4.next = 17;
          return (0, _effects.put)((0, _projectBusPriority.addFavouriteProjectBusPrioritySuccess)(payload));

        case 17:
          _context4.next = 23;
          break;

        case 19:
          _context4.prev = 19;
          _context4.t0 = _context4["catch"](1);
          _context4.next = 23;
          return (0, _effects.put)((0, _projectBusPriority.showProjectBusPriorityMessage)(_context4.t0.messages));

        case 23:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[1, 19]]);
}

function fetchProjectBusPrioritysSaga() {
  return regeneratorRuntime.wrap(function fetchProjectBusPrioritysSaga$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_ALL_PROJECT_BUS_PRIORITY, fetchProjectBusPrioritys);

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

function saveProjectBusPrioritySaga() {
  return regeneratorRuntime.wrap(function saveProjectBusPrioritySaga$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_SAVE_PROJECT_BUS_PRIORITY, saveProjectBusPriority);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}

function deleteProjectBusPrioritySaga() {
  return regeneratorRuntime.wrap(function deleteProjectBusPrioritySaga$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_DELETE_PROJECT_BUS_PRIORITY, deleteProjectBusPriority);

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}

function addFavouriteProjectBusPrioritySaga() {
  return regeneratorRuntime.wrap(function addFavouriteProjectBusPrioritySaga$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ADD_FAVOURITE_PROJECT_BUS_PRIORITY, addFavouriteProjectBusPriority);

        case 2:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}

function rootSaga() {
  return regeneratorRuntime.wrap(function rootSaga$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.all)([(0, _effects.fork)(fetchProjectBusPrioritysSaga), (0, _effects.fork)(saveProjectBusPrioritySaga), (0, _effects.fork)(deleteProjectBusPrioritySaga), (0, _effects.fork)(addFavouriteProjectBusPrioritySaga)]);

        case 2:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(getProjectBusPriorityList, "getProjectBusPriorityList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(fetchProjectBusPrioritys, "fetchProjectBusPrioritys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(deleteProjectBusPriority, "deleteProjectBusPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(saveProjectBusPriority, "saveProjectBusPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(addFavouriteProjectBusPriority, "addFavouriteProjectBusPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(fetchProjectBusPrioritysSaga, "fetchProjectBusPrioritysSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(saveProjectBusPrioritySaga, "saveProjectBusPrioritySaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(deleteProjectBusPrioritySaga, "deleteProjectBusPrioritySaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(addFavouriteProjectBusPrioritySaga, "addFavouriteProjectBusPrioritySaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectBusPriority.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(_marked, "_marked", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(_marked2, "_marked2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(_marked3, "_marked3", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(_marked4, "_marked4", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(_marked5, "_marked5", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(_marked6, "_marked6", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(_marked7, "_marked7", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(_marked8, "_marked8", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(_marked9, "_marked9", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(getProjectBusPriorityList, "getProjectBusPriorityList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(fetchProjectBusPrioritys, "fetchProjectBusPrioritys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(deleteProjectBusPriority, "deleteProjectBusPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(saveProjectBusPriority, "saveProjectBusPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(addFavouriteProjectBusPriority, "addFavouriteProjectBusPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(fetchProjectBusPrioritysSaga, "fetchProjectBusPrioritysSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(saveProjectBusPrioritySaga, "saveProjectBusPrioritySaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(deleteProjectBusPrioritySaga, "deleteProjectBusPrioritySaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(addFavouriteProjectBusPrioritySaga, "addFavouriteProjectBusPrioritySaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectBusPriority.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectBusPriority.js");
}();

;

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchProjectCostPrioritys = fetchProjectCostPrioritys;
exports.deleteProjectCostPriority = deleteProjectCostPriority;
exports.saveProjectCostPriority = saveProjectCostPriority;
exports.addFavouriteProjectCostPriority = addFavouriteProjectCostPriority;
exports.fetchProjectCostPrioritysSaga = fetchProjectCostPrioritysSaga;
exports.saveProjectCostPrioritySaga = saveProjectCostPrioritySaga;
exports.deleteProjectCostPrioritySaga = deleteProjectCostPrioritySaga;
exports.addFavouriteProjectCostPrioritySaga = addFavouriteProjectCostPrioritySaga;
exports["default"] = rootSaga;

var _effects = __webpack_require__(15);

var _projectCostPriority = __webpack_require__(181);

var _ActionTypes = __webpack_require__(7);

var _ApiService = __webpack_require__(16);

var _errorService = __webpack_require__(50);

var _api = __webpack_require__(25);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(fetchProjectCostPrioritys),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(deleteProjectCostPriority),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(saveProjectCostPriority),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(addFavouriteProjectCostPriority),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(fetchProjectCostPrioritysSaga),
    _marked6 =
/*#__PURE__*/
regeneratorRuntime.mark(saveProjectCostPrioritySaga),
    _marked7 =
/*#__PURE__*/
regeneratorRuntime.mark(deleteProjectCostPrioritySaga),
    _marked8 =
/*#__PURE__*/
regeneratorRuntime.mark(addFavouriteProjectCostPrioritySaga),
    _marked9 =
/*#__PURE__*/
regeneratorRuntime.mark(rootSaga);

var currentOrg = function currentOrg(state) {
  return state.orgs.selectedOrg;
};

var getProjectCostPriorityList = function getProjectCostPriorityList(state) {
  return state.projectCostPrioritys.allProjectCostPriority;
};

function fetchProjectCostPrioritys() {
  var selectedOrg, fetchedProjectCostPrioritys;
  return regeneratorRuntime.wrap(function fetchProjectCostPrioritys$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.select)(currentOrg);

        case 3:
          selectedOrg = _context.sent;
          _context.next = 6;
          return (0, _effects.call)(_ApiService.fetchDataRequest, 'projectCostPrioritys', [_api.ORGID_PATH_PARAM], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id]) || [];

        case 6:
          fetchedProjectCostPrioritys = _context.sent;
          _context.next = 9;
          return (0, _effects.put)((0, _projectCostPriority.fetchProjectCostPrioritysSuccess)(fetchedProjectCostPrioritys));

        case 9:
          _context.next = 15;
          break;

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](0);
          _context.next = 15;
          return (0, _effects.put)((0, _projectCostPriority.showProjectCostPriorityMessage)((0, _errorService.apiErrorMessageFormatter)(_context.t0)));

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 11]]);
}

function deleteProjectCostPriority(_ref) {
  var payload, selectedOrg;
  return regeneratorRuntime.wrap(function deleteProjectCostPriority$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _ref.payload;
          _context2.prev = 1;
          _context2.next = 4;
          return (0, _effects.select)(currentOrg);

        case 4:
          selectedOrg = _context2.sent;
          _context2.next = 7;
          return (0, _effects.call)(_ApiService.deleteDataRequest, 'deleteProjectCostPriority', 'Deleting projectCostPriority '.concat(payload), [_api.ORGID_PATH_PARAM, 'projectCostPriorityId'], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id, payload]) || [];

        case 7:
          _context2.next = 9;
          return (0, _effects.put)((0, _projectCostPriority.onDeleteProjectCostPrioritySuccess)(payload));

        case 9:
          _context2.next = 15;
          break;

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](1);
          _context2.next = 15;
          return (0, _effects.put)((0, _projectCostPriority.showProjectCostPriorityMessage)((0, _errorService.apiErrorMessageFormatter)(_context2.t0)));

        case 15:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 11]]);
}

function saveProjectCostPriority(_ref2) {
  var payload, selectedOrg, allProjectCostPrioritys, finalPayload, savedProjectCostPriority;
  return regeneratorRuntime.wrap(function saveProjectCostPriority$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _ref2.payload;
          _context3.prev = 1;
          _context3.next = 4;
          return (0, _effects.select)(currentOrg);

        case 4:
          selectedOrg = _context3.sent;
          _context3.next = 7;
          return (0, _effects.select)(getProjectCostPriorityList);

        case 7:
          allProjectCostPrioritys = _context3.sent;
          finalPayload = _objectSpread({}, payload); // check the orgid of the payload - it will be empty for a new payload - populate from the selectedOrg - otherwise leave it as is

          if ((payload === null || payload === void 0 ? void 0 : payload.orgid) === '') {
            finalPayload = _objectSpread({}, payload, {
              orgid: selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id
            });
          }

          _context3.next = 12;
          return (0, _effects.call)(_ApiService.addOrUpdateDataRequest, allProjectCostPrioritys, finalPayload, 'addProjectCostPriority', 'updateProjectCostPriority', [_api.ORGID_PATH_PARAM], [selectedOrg.id]);

        case 12:
          savedProjectCostPriority = _context3.sent;
          _context3.next = 15;
          return (0, _effects.put)((0, _projectCostPriority.onSaveProjectCostPrioritySuccess)(savedProjectCostPriority));

        case 15:
          _context3.next = 21;
          break;

        case 17:
          _context3.prev = 17;
          _context3.t0 = _context3["catch"](1);
          _context3.next = 21;
          return (0, _effects.put)((0, _projectCostPriority.showProjectCostPriorityMessage)((0, _errorService.apiErrorMessageFormatter)(_context3.t0)));

        case 21:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[1, 17]]);
}
/**
 * This is when the user selects the star on the list page - update the starred attribute of the entity
 * @param {*} param0 
 */


function addFavouriteProjectCostPriority(_ref3) {
  var payload, allProjectCostPrioritys, selectedOrg, filtered, entry, updatedProjectCostPriority, auditMsg;
  return regeneratorRuntime.wrap(function addFavouriteProjectCostPriority$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _ref3.payload;
          _context4.prev = 1;
          _context4.next = 4;
          return (0, _effects.select)(getProjectCostPriorityList);

        case 4:
          allProjectCostPrioritys = _context4.sent;
          _context4.next = 7;
          return (0, _effects.select)(currentOrg);

        case 7:
          selectedOrg = _context4.sent;
          filtered = allProjectCostPrioritys.filter(function (entry) {
            return (entry === null || entry === void 0 ? void 0 : entry.id) === (payload === null || payload === void 0 ? void 0 : payload.id);
          });

          if (!((filtered === null || filtered === void 0 ? void 0 : filtered.length) > 0)) {
            _context4.next = 17;
            break;
          }

          entry = filtered[0];
          updatedProjectCostPriority = _objectSpread({}, entry, {
            starred: !payload.starred
          });
          auditMsg = 'Updating starred setting to '.concat(updatedProjectCostPriority === null || updatedProjectCostPriority === void 0 ? void 0 : updatedProjectCostPriority.starred).concat(' for projectCostPriority ').concat(updatedProjectCostPriority === null || updatedProjectCostPriority === void 0 ? void 0 : updatedProjectCostPriority.id);
          _context4.next = 15;
          return (0, _effects.call)(_ApiService.updateDataRequest, updatedProjectCostPriority, 'updateProjectCostPriority', auditMsg, [_api.ORGID_PATH_PARAM], [selectedOrg.id]);

        case 15:
          _context4.next = 17;
          return (0, _effects.put)((0, _projectCostPriority.addFavouriteProjectCostPrioritySuccess)(payload));

        case 17:
          _context4.next = 23;
          break;

        case 19:
          _context4.prev = 19;
          _context4.t0 = _context4["catch"](1);
          _context4.next = 23;
          return (0, _effects.put)((0, _projectCostPriority.showProjectCostPriorityMessage)(_context4.t0.messages));

        case 23:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[1, 19]]);
}

function fetchProjectCostPrioritysSaga() {
  return regeneratorRuntime.wrap(function fetchProjectCostPrioritysSaga$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.FETCH_ALL_PROJECT_COST_PRIORITY, fetchProjectCostPrioritys);

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

function saveProjectCostPrioritySaga() {
  return regeneratorRuntime.wrap(function saveProjectCostPrioritySaga$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_SAVE_PROJECT_COST_PRIORITY, saveProjectCostPriority);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}

function deleteProjectCostPrioritySaga() {
  return regeneratorRuntime.wrap(function deleteProjectCostPrioritySaga$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ON_DELETE_PROJECT_COST_PRIORITY, deleteProjectCostPriority);

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}

function addFavouriteProjectCostPrioritySaga() {
  return regeneratorRuntime.wrap(function addFavouriteProjectCostPrioritySaga$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.takeEvery)(_ActionTypes.ADD_FAVOURITE_PROJECT_COST_PRIORITY, addFavouriteProjectCostPriority);

        case 2:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}

function rootSaga() {
  return regeneratorRuntime.wrap(function rootSaga$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.all)([(0, _effects.fork)(fetchProjectCostPrioritysSaga), (0, _effects.fork)(saveProjectCostPrioritySaga), (0, _effects.fork)(deleteProjectCostPrioritySaga), (0, _effects.fork)(addFavouriteProjectCostPrioritySaga)]);

        case 2:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(getProjectCostPriorityList, "getProjectCostPriorityList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(fetchProjectCostPrioritys, "fetchProjectCostPrioritys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(deleteProjectCostPriority, "deleteProjectCostPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(saveProjectCostPriority, "saveProjectCostPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(addFavouriteProjectCostPriority, "addFavouriteProjectCostPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(fetchProjectCostPrioritysSaga, "fetchProjectCostPrioritysSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(saveProjectCostPrioritySaga, "saveProjectCostPrioritySaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(deleteProjectCostPrioritySaga, "deleteProjectCostPrioritySaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(addFavouriteProjectCostPrioritySaga, "addFavouriteProjectCostPrioritySaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectCostPriority.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(_marked, "_marked", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(_marked2, "_marked2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(_marked3, "_marked3", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(_marked4, "_marked4", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(_marked5, "_marked5", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(_marked6, "_marked6", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(_marked7, "_marked7", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(_marked8, "_marked8", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(_marked9, "_marked9", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(currentOrg, "currentOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(getProjectCostPriorityList, "getProjectCostPriorityList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(fetchProjectCostPrioritys, "fetchProjectCostPrioritys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(deleteProjectCostPriority, "deleteProjectCostPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(saveProjectCostPriority, "saveProjectCostPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(addFavouriteProjectCostPriority, "addFavouriteProjectCostPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(fetchProjectCostPrioritysSaga, "fetchProjectCostPrioritysSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(saveProjectCostPrioritySaga, "saveProjectCostPrioritySaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(deleteProjectCostPrioritySaga, "deleteProjectCostPrioritySaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(addFavouriteProjectCostPrioritySaga, "addFavouriteProjectCostPrioritySaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(rootSaga, "rootSaga", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectCostPriority.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/sagas/projectCostPriority.js");
}();

;

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRouterDom = __webpack_require__(13);

var _reactRedux = __webpack_require__(10);

var _reactIntl = __webpack_require__(366);

__webpack_require__(1303);

__webpack_require__(1306);

__webpack_require__(1308);

__webpack_require__(1310);

__webpack_require__(1312);

__webpack_require__(1314);

var _lngProvider = _interopRequireDefault(__webpack_require__(1316));

var _index2 = _interopRequireDefault(__webpack_require__(1335));

var _SignIn = _interopRequireDefault(__webpack_require__(1995));

var _SignUp = _interopRequireDefault(__webpack_require__(1997));

var _Auth = __webpack_require__(143);

var _Setting = __webpack_require__(265);

var _asyncComponent = _interopRequireDefault(__webpack_require__(44));

var _Authentication = __webpack_require__(42);

var _Auth2 = __webpack_require__(143);

var _ThemeColors = __webpack_require__(347);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var RestrictedRoute = function RestrictedRoute(_ref) {
  var Component = _ref.component,
      rest = _objectWithoutProperties(_ref, ["component"]);

  var authenticated = (0, _Authentication.isAuthenticated)();
  console.log('Restricted Route isAuthenticated = '.concat(authenticated));
  return _react["default"].createElement(_reactRouterDom.Route, _extends({}, rest, {
    render: function render(props) {
      return authenticated ? _react["default"].createElement(Component, props) : _react["default"].createElement(_reactRouterDom.Redirect, {
        to: {
          pathname: '/signin',
          state: {
            from: props.location
          }
        }
      });
    }
  }));
};

var App =
/*#__PURE__*/
function (_Component) {
  _inherits(App, _Component);

  function App() {
    _classCallCheck(this, App);

    return _possibleConstructorReturn(this, _getPrototypeOf(App).apply(this, arguments));
  }

  _createClass(App, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.initURL === '') {
        this.props.setInitUrl(this.props.history.location.pathname);
      }

      this.props.setThemeColor(_ThemeColors.DARK_CYAN);
      var body = document.body.classList;
      body.remove(this.props.themeColor);
      body.remove('dark-theme');
      body.add(_ThemeColors.DARK_CYAN);
      document.body.classList.add(this.props.themeColor);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          match = _this$props.match,
          location = _this$props.location,
          locale = _this$props.locale,
          initURL = _this$props.initURL,
          isDirectionRTL = _this$props.isDirectionRTL,
          userSignOut = _this$props.userSignOut;

      if (location.pathname === '/web-view') {
        console.log(location === null || location === void 0 ? void 0 : location.search);
      }

      if (location.pathname === '/session/clear') {
        userSignOut(); // clear auth variables as they have become stale

        return _react["default"].createElement(_reactRouterDom.Redirect, {
          to: '/signin'
        });
      }

      if (location.pathname === '/') {
        if (!(0, _Authentication.isAuthenticated)()) {
          userSignOut(); // clear auth variables as they have become stale

          return _react["default"].createElement(_reactRouterDom.Redirect, {
            to: '/signin'
          });
        } else if (initURL === '' || initURL === '/' || initURL === '/signin') {
          // determine which dashboard to go to
          // if SUPER_USER then head to the admin dashboard
          // if an administrator (user with role = gold) head to the organisation dashboard
          // if an employee then head to the employee dashboard
          if ((0, _Authentication.isSuperUser)()) {
            return _react["default"].createElement(_reactRouterDom.Redirect, {
              to: '/app/agile-dashboard/default'
            });
          } else if ((0, _Authentication.isAdmin)()) {
            return _react["default"].createElement(_reactRouterDom.Redirect, {
              to: '/app/org-dashboard/default'
            });
          }

          return _react["default"].createElement(_reactRouterDom.Redirect, {
            to: '/app/emp-dashboard/default'
          });
        } else {
          return _react["default"].createElement(_reactRouterDom.Redirect, {
            to: initURL
          });
        }
      } // for RTL Support


      if (isDirectionRTL) {
        document.body.classList.add('rtl');
      } else {
        document.body.classList.remove('rtl');
      }

      var currentAppLocale = _lngProvider["default"][locale.locale];
      return _react["default"].createElement(_reactIntl.IntlProvider, {
        locale: currentAppLocale.locale,
        messages: currentAppLocale.messages
      }, _react["default"].createElement("div", {
        className: "app-main"
      }, _react["default"].createElement(_reactRouterDom.Switch, null, _react["default"].createElement(RestrictedRoute, {
        path: "".concat(match.url, "app"),
        component: _index2["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "/signin",
        component: _SignIn["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "/signup",
        component: _SignUp["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "/web-view",
        component: _SignIn["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        component: (0, _asyncComponent["default"])(function () {
          return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 39));
        })
      }))));
    }
  }]);

  return App;
}(_react.Component);

var mapStateToProps = function mapStateToProps(_ref2) {
  var settings = _ref2.settings,
      auth = _ref2.auth;
  var locale = settings.locale,
      isDirectionRTL = settings.isDirectionRTL;
  var authUser = auth.authUser,
      initURL = auth.initURL,
      identity = auth.identity;
  return {
    locale: locale,
    isDirectionRTL: isDirectionRTL,
    authUser: authUser,
    initURL: initURL,
    identity: identity
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  setInitUrl: _Auth.setInitUrl,
  setThemeColor: _Setting.setThemeColor,
  userSignOut: _Auth2.userSignOut
})(App);

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RestrictedRoute, "RestrictedRoute", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/App.js");

  __REACT_HOT_LOADER__.register(App, "App", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/App.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/App.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/App.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/App.js");

  __REACT_HOT_LOADER__.register(_lngProvider, "_lngProvider", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/App.js");

  __REACT_HOT_LOADER__.register(_index2, "_index2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/App.js");

  __REACT_HOT_LOADER__.register(_SignIn, "_SignIn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/App.js");

  __REACT_HOT_LOADER__.register(_SignUp, "_SignUp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/App.js");

  __REACT_HOT_LOADER__.register(_asyncComponent, "_asyncComponent", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/App.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/App.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/App.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/App.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/App.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/App.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/App.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/App.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/App.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/App.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/App.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/App.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/App.js");

  __REACT_HOT_LOADER__.register(_extends, "_extends", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/App.js");

  __REACT_HOT_LOADER__.register(_objectWithoutProperties, "_objectWithoutProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/App.js");

  __REACT_HOT_LOADER__.register(_objectWithoutPropertiesLoose, "_objectWithoutPropertiesLoose", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/App.js");

  __REACT_HOT_LOADER__.register(RestrictedRoute, "RestrictedRoute", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/App.js");

  __REACT_HOT_LOADER__.register(App, "App", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/App.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/App.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/App.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/App.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/App.js");
}();

;

/***/ }),
/* 1285 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(1287), src$en$$ = __webpack_require__(1292);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(662), src$es5$$ = __webpack_require__(1288), src$compiler$$ = __webpack_require__(1289), intl$messageformat$parser$$ = __webpack_require__(1290);
exports["default"] = MessageFormat;

// -- MessageFormat --------------------------------------------------------

function MessageFormat(message, locales, formats) {
    // Parse string messages into an AST.
    var ast = typeof message === 'string' ?
            MessageFormat.__parse(message) : message;

    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new TypeError('A message must be provided as a String or AST.');
    }

    // Creates a new object with the specified `formats` merged with the default
    // formats.
    formats = this._mergeFormats(MessageFormat.formats, formats);

    // Defined first because it's used to build the format pattern.
    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});

    // Compile the `ast` to a pattern that is highly optimized for repeated
    // `format()` invocations. **Note:** This passes the `locales` set provided
    // to the constructor instead of just the resolved locale.
    var pluralFn = this._findPluralRuleFunction(this._locale);
    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var messageFormat = this;
    this.format = function (values) {
      try {
        return messageFormat._format(pattern, values);
      } catch (e) {
        if (e.variableId) {
          throw new Error(
            'The intl string context variable \'' + e.variableId + '\'' +
            ' was not provided to the string \'' + message + '\''
          );
        } else {
          throw e;
        }
      }
    };
}

// Default format options used as the prototype of the `formats` provided to the
// constructor. These are used when constructing the internal Intl.NumberFormat
// and Intl.DateTimeFormat instances.
src$es5$$.defineProperty(MessageFormat, 'formats', {
    enumerable: true,

    value: {
        number: {
            'currency': {
                style: 'currency'
            },

            'percent': {
                style: 'percent'
            }
        },

        date: {
            'short': {
                month: 'numeric',
                day  : 'numeric',
                year : '2-digit'
            },

            'medium': {
                month: 'short',
                day  : 'numeric',
                year : 'numeric'
            },

            'long': {
                month: 'long',
                day  : 'numeric',
                year : 'numeric'
            },

            'full': {
                weekday: 'long',
                month  : 'long',
                day    : 'numeric',
                year   : 'numeric'
            }
        },

        time: {
            'short': {
                hour  : 'numeric',
                minute: 'numeric'
            },

            'medium':  {
                hour  : 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },

            'long': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            },

            'full': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            }
        }
    }
});

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlMessageFormat is missing a ' +
            '`locale` property'
        );
    }

    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
}});

// Defines `__parse()` static method as an exposed private.
src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});

// Define public `defaultLocale` property which defaults to English, but can be
// set by the developer.
src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

MessageFormat.prototype.resolvedOptions = function () {
    // TODO: Provide anything else?
    return {
        locale: this._locale
    };
};

MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
    return compiler.compile(ast);
};

MessageFormat.prototype._findPluralRuleFunction = function (locale) {
    var localeData = MessageFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find a `pluralRuleFunction` to return.
    while (data) {
        if (data.pluralRuleFunction) {
            return data.pluralRuleFunction;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlMessageFormat is missing a ' +
        '`pluralRuleFunction` for :' + locale
    );
};

MessageFormat.prototype._format = function (pattern, values) {
    var result = '',
        i, len, part, id, value, err;

    for (i = 0, len = pattern.length; i < len; i += 1) {
        part = pattern[i];

        // Exist early for string parts.
        if (typeof part === 'string') {
            result += part;
            continue;
        }

        id = part.id;

        // Enforce that all required values are provided by the caller.
        if (!(values && src$utils$$.hop.call(values, id))) {
          err = new Error('A value must be provided for: ' + id);
          err.variableId = id;
          throw err;
        }

        value = values[id];

        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (part.options) {
            result += this._format(part.getOption(value), values);
        } else {
            result += part.format(value);
        }
    }

    return result;
};

MessageFormat.prototype._mergeFormats = function (defaults, formats) {
    var mergedFormats = {},
        type, mergedType;

    for (type in defaults) {
        if (!src$utils$$.hop.call(defaults, type)) { continue; }

        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);

        if (formats && src$utils$$.hop.call(formats, type)) {
            src$utils$$.extend(mergedType, formats[type]);
        }
    }

    return mergedFormats;
};

MessageFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(MessageFormat.defaultLocale);

    var localeData = MessageFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlMessageFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(662);

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (src$utils$$.hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports["default"] = Compiler;

function Compiler(locales, formats, pluralFn) {
    this.locales  = locales;
    this.formats  = formats;
    this.pluralFn = pluralFn;
}

Compiler.prototype.compile = function (ast) {
    this.pluralStack        = [];
    this.currentPlural      = null;
    this.pluralNumberFormat = null;

    return this.compileMessage(ast);
};

Compiler.prototype.compileMessage = function (ast) {
    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new Error('Message AST is not of type: "messageFormatPattern"');
    }

    var elements = ast.elements,
        pattern  = [];

    var i, len, element;

    for (i = 0, len = elements.length; i < len; i += 1) {
        element = elements[i];

        switch (element.type) {
            case 'messageTextElement':
                pattern.push(this.compileMessageText(element));
                break;

            case 'argumentElement':
                pattern.push(this.compileArgument(element));
                break;

            default:
                throw new Error('Message element does not have a valid type');
        }
    }

    return pattern;
};

Compiler.prototype.compileMessageText = function (element) {
    // When this `element` is part of plural sub-pattern and its value contains
    // an unescaped '#', use a `PluralOffsetString` helper to properly output
    // the number with the correct offset in the string.
    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
        // Create a cache a NumberFormat instance that can be reused for any
        // PluralOffsetString instance in this message.
        if (!this.pluralNumberFormat) {
            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
        }

        return new PluralOffsetString(
                this.currentPlural.id,
                this.currentPlural.format.offset,
                this.pluralNumberFormat,
                element.value);
    }

    // Unescape the escaped '#'s in the message text.
    return element.value.replace(/\\#/g, '#');
};

Compiler.prototype.compileArgument = function (element) {
    var format = element.format;

    if (!format) {
        return new StringFormat(element.id);
    }

    var formats  = this.formats,
        locales  = this.locales,
        pluralFn = this.pluralFn,
        options;

    switch (format.type) {
        case 'numberFormat':
            options = formats.number[format.style];
            return {
                id    : element.id,
                format: new Intl.NumberFormat(locales, options).format
            };

        case 'dateFormat':
            options = formats.date[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'timeFormat':
            options = formats.time[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'pluralFormat':
            options = this.compileOptions(element);
            return new PluralFormat(
                element.id, format.ordinal, format.offset, options, pluralFn
            );

        case 'selectFormat':
            options = this.compileOptions(element);
            return new SelectFormat(element.id, options);

        default:
            throw new Error('Message element does not have a valid format type');
    }
};

Compiler.prototype.compileOptions = function (element) {
    var format      = element.format,
        options     = format.options,
        optionsHash = {};

    // Save the current plural element, if any, then set it to a new value when
    // compiling the options sub-patterns. This conforms the spec's algorithm
    // for handling `"#"` syntax in message text.
    this.pluralStack.push(this.currentPlural);
    this.currentPlural = format.type === 'pluralFormat' ? element : null;

    var i, len, option;

    for (i = 0, len = options.length; i < len; i += 1) {
        option = options[i];

        // Compile the sub-pattern and save it under the options's selector.
        optionsHash[option.selector] = this.compileMessage(option.value);
    }

    // Pop the plural stack to put back the original current plural value.
    this.currentPlural = this.pluralStack.pop();

    return optionsHash;
};

// -- Compiler Helper Classes --------------------------------------------------

function StringFormat(id) {
    this.id = id;
}

StringFormat.prototype.format = function (value) {
    if (!value && typeof value !== 'number') {
        return '';
    }

    return typeof value === 'string' ? value : String(value);
};

function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
    this.id         = id;
    this.useOrdinal = useOrdinal;
    this.offset     = offset;
    this.options    = options;
    this.pluralFn   = pluralFn;
}

PluralFormat.prototype.getOption = function (value) {
    var options = this.options;

    var option = options['=' + value] ||
            options[this.pluralFn(value - this.offset, this.useOrdinal)];

    return option || options.other;
};

function PluralOffsetString(id, offset, numberFormat, string) {
    this.id           = id;
    this.offset       = offset;
    this.numberFormat = numberFormat;
    this.string       = string;
}

PluralOffsetString.prototype.format = function (value) {
    var number = this.numberFormat.format(value - this.offset);

    return this.string
            .replace(/(^|[^\\])#/g, '$1' + number)
            .replace(/\\#/g, '#');
};

function SelectFormat(id, options) {
    this.id      = id;
    this.options = options;
}

SelectFormat.prototype.getOption = function (value) {
    var options = this.options;
    return options[value] || options.other;
};

//# sourceMappingURL=compiler.js.map

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(1291)['default'];
exports['default'] = exports;


/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports["default"] = (function() {
  "use strict";

  /*
   * Generated by PEG.js 0.9.0.
   *
   * http://pegjs.org/
   */

  function peg$subclass(child, parent) {
    function ctor() { this.constructor = child; }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function peg$SyntaxError(message, expected, found, location) {
    this.message  = message;
    this.expected = expected;
    this.found    = found;
    this.location = location;
    this.name     = "SyntaxError";

    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, peg$SyntaxError);
    }
  }

  peg$subclass(peg$SyntaxError, Error);

  function peg$parse(input) {
    var options = arguments.length > 1 ? arguments[1] : {},
        parser  = this,

        peg$FAILED = {},

        peg$startRuleFunctions = { start: peg$parsestart },
        peg$startRuleFunction  = peg$parsestart,

        peg$c0 = function(elements) {
                return {
                    type    : 'messageFormatPattern',
                    elements: elements,
                    location: location()
                };
            },
        peg$c1 = function(text) {
                var string = '',
                    i, j, outerLen, inner, innerLen;

                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
                    inner = text[i];

                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
                        string += inner[j];
                    }
                }

                return string;
            },
        peg$c2 = function(messageText) {
                return {
                    type : 'messageTextElement',
                    value: messageText,
                    location: location()
                };
            },
        peg$c3 = /^[^ \t\n\r,.+={}#]/,
        peg$c4 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
        peg$c5 = "{",
        peg$c6 = { type: "literal", value: "{", description: "\"{\"" },
        peg$c7 = ",",
        peg$c8 = { type: "literal", value: ",", description: "\",\"" },
        peg$c9 = "}",
        peg$c10 = { type: "literal", value: "}", description: "\"}\"" },
        peg$c11 = function(id, format) {
                return {
                    type  : 'argumentElement',
                    id    : id,
                    format: format && format[2],
                    location: location()
                };
            },
        peg$c12 = "number",
        peg$c13 = { type: "literal", value: "number", description: "\"number\"" },
        peg$c14 = "date",
        peg$c15 = { type: "literal", value: "date", description: "\"date\"" },
        peg$c16 = "time",
        peg$c17 = { type: "literal", value: "time", description: "\"time\"" },
        peg$c18 = function(type, style) {
                return {
                    type : type + 'Format',
                    style: style && style[2],
                    location: location()
                };
            },
        peg$c19 = "plural",
        peg$c20 = { type: "literal", value: "plural", description: "\"plural\"" },
        peg$c21 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: false,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                };
            },
        peg$c22 = "selectordinal",
        peg$c23 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
        peg$c24 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: true,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                }
            },
        peg$c25 = "select",
        peg$c26 = { type: "literal", value: "select", description: "\"select\"" },
        peg$c27 = function(options) {
                return {
                    type   : 'selectFormat',
                    options: options,
                    location: location()
                };
            },
        peg$c28 = "=",
        peg$c29 = { type: "literal", value: "=", description: "\"=\"" },
        peg$c30 = function(selector, pattern) {
                return {
                    type    : 'optionalFormatPattern',
                    selector: selector,
                    value   : pattern,
                    location: location()
                };
            },
        peg$c31 = "offset:",
        peg$c32 = { type: "literal", value: "offset:", description: "\"offset:\"" },
        peg$c33 = function(number) {
                return number;
            },
        peg$c34 = function(offset, options) {
                return {
                    type   : 'pluralFormat',
                    offset : offset,
                    options: options,
                    location: location()
                };
            },
        peg$c35 = { type: "other", description: "whitespace" },
        peg$c36 = /^[ \t\n\r]/,
        peg$c37 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
        peg$c38 = { type: "other", description: "optionalWhitespace" },
        peg$c39 = /^[0-9]/,
        peg$c40 = { type: "class", value: "[0-9]", description: "[0-9]" },
        peg$c41 = /^[0-9a-f]/i,
        peg$c42 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
        peg$c43 = "0",
        peg$c44 = { type: "literal", value: "0", description: "\"0\"" },
        peg$c45 = /^[1-9]/,
        peg$c46 = { type: "class", value: "[1-9]", description: "[1-9]" },
        peg$c47 = function(digits) {
            return parseInt(digits, 10);
        },
        peg$c48 = /^[^{}\\\0-\x1F \t\n\r]/,
        peg$c49 = { type: "class", value: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]" },
        peg$c50 = "\\\\",
        peg$c51 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
        peg$c52 = function() { return '\\'; },
        peg$c53 = "\\#",
        peg$c54 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
        peg$c55 = function() { return '\\#'; },
        peg$c56 = "\\{",
        peg$c57 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
        peg$c58 = function() { return '\u007B'; },
        peg$c59 = "\\}",
        peg$c60 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
        peg$c61 = function() { return '\u007D'; },
        peg$c62 = "\\u",
        peg$c63 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
        peg$c64 = function(digits) {
                return String.fromCharCode(parseInt(digits, 16));
            },
        peg$c65 = function(chars) { return chars.join(''); },

        peg$currPos          = 0,
        peg$savedPos         = 0,
        peg$posDetailsCache  = [{ line: 1, column: 1, seenCR: false }],
        peg$maxFailPos       = 0,
        peg$maxFailExpected  = [],
        peg$silentFails      = 0,

        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$savedPos, peg$currPos);
    }

    function location() {
      return peg$computeLocation(peg$savedPos, peg$currPos);
    }

    function expected(description) {
      throw peg$buildException(
        null,
        [{ type: "other", description: description }],
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function error(message) {
      throw peg$buildException(
        message,
        null,
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function peg$computePosDetails(pos) {
      var details = peg$posDetailsCache[pos],
          p, ch;

      if (details) {
        return details;
      } else {
        p = pos - 1;
        while (!peg$posDetailsCache[p]) {
          p--;
        }

        details = peg$posDetailsCache[p];
        details = {
          line:   details.line,
          column: details.column,
          seenCR: details.seenCR
        };

        while (p < pos) {
          ch = input.charAt(p);
          if (ch === "\n") {
            if (!details.seenCR) { details.line++; }
            details.column = 1;
            details.seenCR = false;
          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
            details.line++;
            details.column = 1;
            details.seenCR = true;
          } else {
            details.column++;
            details.seenCR = false;
          }

          p++;
        }

        peg$posDetailsCache[pos] = details;
        return details;
      }
    }

    function peg$computeLocation(startPos, endPos) {
      var startPosDetails = peg$computePosDetails(startPos),
          endPosDetails   = peg$computePosDetails(endPos);

      return {
        start: {
          offset: startPos,
          line:   startPosDetails.line,
          column: startPosDetails.column
        },
        end: {
          offset: endPos,
          line:   endPosDetails.line,
          column: endPosDetails.column
        }
      };
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) { return; }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildException(message, expected, found, location) {
      function cleanupExpected(expected) {
        var i = 1;

        expected.sort(function(a, b) {
          if (a.description < b.description) {
            return -1;
          } else if (a.description > b.description) {
            return 1;
          } else {
            return 0;
          }
        });

        while (i < expected.length) {
          if (expected[i - 1] === expected[i]) {
            expected.splice(i, 1);
          } else {
            i++;
          }
        }
      }

      function buildMessage(expected, found) {
        function stringEscape(s) {
          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }

          return s
            .replace(/\\/g,   '\\\\')
            .replace(/"/g,    '\\"')
            .replace(/\x08/g, '\\b')
            .replace(/\t/g,   '\\t')
            .replace(/\n/g,   '\\n')
            .replace(/\f/g,   '\\f')
            .replace(/\r/g,   '\\r')
            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
            .replace(/[\u0100-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
            .replace(/[\u1000-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
        }

        var expectedDescs = new Array(expected.length),
            expectedDesc, foundDesc, i;

        for (i = 0; i < expected.length; i++) {
          expectedDescs[i] = expected[i].description;
        }

        expectedDesc = expected.length > 1
          ? expectedDescs.slice(0, -1).join(", ")
              + " or "
              + expectedDescs[expected.length - 1]
          : expectedDescs[0];

        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";

        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
      }

      if (expected !== null) {
        cleanupExpected(expected);
      }

      return new peg$SyntaxError(
        message !== null ? message : buildMessage(expected, found),
        expected,
        found,
        location
      );
    }

    function peg$parsestart() {
      var s0;

      s0 = peg$parsemessageFormatPattern();

      return s0;
    }

    function peg$parsemessageFormatPattern() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsemessageFormatElement();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsemessageFormatElement();
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c0(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsemessageFormatElement() {
      var s0;

      s0 = peg$parsemessageTextElement();
      if (s0 === peg$FAILED) {
        s0 = peg$parseargumentElement();
      }

      return s0;
    }

    function peg$parsemessageText() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$parsechars();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s3 = [s3, s4, s5];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$currPos;
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parsechars();
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s3 = [s3, s4, s5];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c1(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsews();
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parsemessageTextElement() {
      var s0, s1;

      s0 = peg$currPos;
      s1 = peg$parsemessageText();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c2(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parseargument() {
      var s0, s1, s2;

      s0 = peg$parsenumber();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = [];
        if (peg$c3.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c4); }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            if (peg$c3.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c4); }
            }
          }
        } else {
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parseargumentElement() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c5;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c6); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseargument();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$currPos;
              if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c7;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c8); }
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseelementFormat();
                  if (s8 !== peg$FAILED) {
                    s6 = [s6, s7, s8];
                    s5 = s6;
                  } else {
                    peg$currPos = s5;
                    s5 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$FAILED;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$FAILED;
              }
              if (s5 === peg$FAILED) {
                s5 = null;
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 125) {
                    s7 = peg$c9;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c10); }
                  }
                  if (s7 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c11(s3, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseelementFormat() {
      var s0;

      s0 = peg$parsesimpleFormat();
      if (s0 === peg$FAILED) {
        s0 = peg$parsepluralFormat();
        if (s0 === peg$FAILED) {
          s0 = peg$parseselectOrdinalFormat();
          if (s0 === peg$FAILED) {
            s0 = peg$parseselectFormat();
          }
        }
      }

      return s0;
    }

    function peg$parsesimpleFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c12) {
        s1 = peg$c12;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c13); }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 4) === peg$c14) {
          s1 = peg$c14;
          peg$currPos += 4;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c15); }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 4) === peg$c16) {
            s1 = peg$c16;
            peg$currPos += 4;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c17); }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 44) {
            s4 = peg$c7;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parsechars();
              if (s6 !== peg$FAILED) {
                s4 = [s4, s5, s6];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
          if (s3 === peg$FAILED) {
            s3 = null;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c18(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c19) {
        s1 = peg$c19;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c20); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c21(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectOrdinalFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 13) === peg$c22) {
        s1 = peg$c22;
        peg$currPos += 13;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c23); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c24(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c25) {
        s1 = peg$c25;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c26); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = [];
              s6 = peg$parseoptionalFormatPattern();
              if (s6 !== peg$FAILED) {
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$parseoptionalFormatPattern();
                }
              } else {
                s5 = peg$FAILED;
              }
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c27(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselector() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 61) {
        s2 = peg$c28;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c29); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parsenumber();
        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$parsechars();
      }

      return s0;
    }

    function peg$parseoptionalFormatPattern() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseselector();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 123) {
              s4 = peg$c5;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c6); }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s6 = peg$parsemessageFormatPattern();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parse_();
                  if (s7 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 125) {
                      s8 = peg$c9;
                      peg$currPos++;
                    } else {
                      s8 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c10); }
                    }
                    if (s8 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c30(s2, s6);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseoffset() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 7) === peg$c31) {
        s1 = peg$c31;
        peg$currPos += 7;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c32); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsenumber();
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c33(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralStyle() {
      var s0, s1, s2, s3, s4;

      s0 = peg$currPos;
      s1 = peg$parseoffset();
      if (s1 === peg$FAILED) {
        s1 = null;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parseoptionalFormatPattern();
          if (s4 !== peg$FAILED) {
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parseoptionalFormatPattern();
            }
          } else {
            s3 = peg$FAILED;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c34(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsews() {
      var s0, s1;

      peg$silentFails++;
      s0 = [];
      if (peg$c36.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c37); }
      }
      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          if (peg$c36.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c37); }
          }
        }
      } else {
        s0 = peg$FAILED;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c35); }
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1, s2;

      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsews();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsews();
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c38); }
      }

      return s0;
    }

    function peg$parsedigit() {
      var s0;

      if (peg$c39.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c40); }
      }

      return s0;
    }

    function peg$parsehexDigit() {
      var s0;

      if (peg$c41.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c42); }
      }

      return s0;
    }

    function peg$parsenumber() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 48) {
        s1 = peg$c43;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c44); }
      }
      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        s2 = peg$currPos;
        if (peg$c45.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c46); }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parsedigit();
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parsedigit();
          }
          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c47(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsechar() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      if (peg$c48.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c49); }
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c50) {
          s1 = peg$c50;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c51); }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c52();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c53) {
            s1 = peg$c53;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c54); }
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c55();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c56) {
              s1 = peg$c56;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c57); }
            }
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c58();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c59) {
                s1 = peg$c59;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c60); }
              }
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c61();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c62) {
                  s1 = peg$c62;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c63); }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$currPos;
                  s3 = peg$currPos;
                  s4 = peg$parsehexDigit();
                  if (s4 !== peg$FAILED) {
                    s5 = peg$parsehexDigit();
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parsehexDigit();
                      if (s6 !== peg$FAILED) {
                        s7 = peg$parsehexDigit();
                        if (s7 !== peg$FAILED) {
                          s4 = [s4, s5, s6, s7];
                          s3 = s4;
                        } else {
                          peg$currPos = s3;
                          s3 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s3;
                      s3 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                  }
                  if (s3 !== peg$FAILED) {
                    s2 = input.substring(s2, peg$currPos);
                  } else {
                    s2 = s3;
                  }
                  if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c64(s2);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parsechars() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsechar();
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parsechar();
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c65(s1);
      }
      s0 = s1;

      return s0;
    }

    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail({ type: "end", description: "end of input" });
      }

      throw peg$buildException(
        null,
        peg$maxFailExpected,
        peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
        peg$maxFailPos < input.length
          ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
          : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
      );
    }
  }

  return {
    SyntaxError: peg$SyntaxError,
    parse:       peg$parse
  };
})();

//# sourceMappingURL=parser.js.map

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 1293 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlRelativeFormat = __webpack_require__(1295)['default'];

// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(1300);

// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlRelativeFormat;
exports['default'] = exports;


/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* jslint esnext: true */
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1296);
var en_1 = __webpack_require__(1299);
core_1.default.__addLocaleData(en_1.default);
core_1.default.defaultLocale = 'en';
exports.default = core_1.default;
//# sourceMappingURL=main.js.map

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
var intl_messageformat_1 = __webpack_require__(661);
var diff_1 = __webpack_require__(1297);
var es5_1 = __webpack_require__(1298);
exports.default = RelativeFormat;
// -----------------------------------------------------------------------------
var FIELDS = [
    'second', 'second-short',
    'minute', 'minute-short',
    'hour', 'hour-short',
    'day', 'day-short',
    'month', 'month-short',
    'year', 'year-short'
];
var STYLES = ['best fit', 'numeric'];
// -- RelativeFormat -----------------------------------------------------------
function RelativeFormat(locales, options) {
    options = options || {};
    // Make a copy of `locales` if it's an array, so that it doesn't change
    // since it's used lazily.
    if (es5_1.isArray(locales)) {
        locales = locales.concat();
    }
    es5_1.defineProperty(this, '_locale', { value: this._resolveLocale(locales) });
    es5_1.defineProperty(this, '_options', { value: {
            style: this._resolveStyle(options.style),
            units: this._isValidUnits(options.units) && options.units
        } });
    es5_1.defineProperty(this, '_locales', { value: locales });
    es5_1.defineProperty(this, '_fields', { value: this._findFields(this._locale) });
    es5_1.defineProperty(this, '_messages', { value: es5_1.objCreate(null) });
    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var relativeFormat = this;
    this.format = function format(date, options) {
        return relativeFormat._format(date, options);
    };
}
// Define internal private properties for dealing with locale data.
es5_1.defineProperty(RelativeFormat, '__localeData__', { value: es5_1.objCreate(null) });
es5_1.defineProperty(RelativeFormat, '__addLocaleData', { value: function () {
        for (var i = 0; i < arguments.length; i++) {
            var datum = arguments[i];
            if (!(datum && datum.locale)) {
                throw new Error('Locale data provided to IntlRelativeFormat is missing a ' +
                    '`locale` property value');
            }
            RelativeFormat.__localeData__[datum.locale.toLowerCase()] = datum;
            // Add data to IntlMessageFormat.
            intl_messageformat_1.default.__addLocaleData(datum);
        }
    } });
// Define public `defaultLocale` property which can be set by the developer, or
// it will be set when the first RelativeFormat instance is created by
// leveraging the resolved locale from `Intl`.
es5_1.defineProperty(RelativeFormat, 'defaultLocale', {
    enumerable: true,
    writable: true,
    value: undefined
});
// Define public `thresholds` property which can be set by the developer, and
// defaults to relative time thresholds from moment.js.
es5_1.defineProperty(RelativeFormat, 'thresholds', {
    enumerable: true,
    value: {
        second: 45, 'second-short': 45,
        minute: 45, 'minute-short': 45,
        hour: 22, 'hour-short': 22,
        day: 26, 'day-short': 26,
        month: 11, 'month-short': 11 // months to year
    }
});
RelativeFormat.prototype.resolvedOptions = function () {
    return {
        locale: this._locale,
        style: this._options.style,
        units: this._options.units
    };
};
RelativeFormat.prototype._compileMessage = function (units) {
    // `this._locales` is the original set of locales the user specified to the
    // constructor, while `this._locale` is the resolved root locale.
    var locales = this._locales;
    var resolvedLocale = this._locale;
    var field = this._fields[units];
    var relativeTime = field.relativeTime;
    var future = '';
    var past = '';
    var i;
    for (i in relativeTime.future) {
        if (relativeTime.future.hasOwnProperty(i)) {
            future += ' ' + i + ' {' +
                relativeTime.future[i].replace('{0}', '#') + '}';
        }
    }
    for (i in relativeTime.past) {
        if (relativeTime.past.hasOwnProperty(i)) {
            past += ' ' + i + ' {' +
                relativeTime.past[i].replace('{0}', '#') + '}';
        }
    }
    var message = '{when, select, future {{0, plural, ' + future + '}}' +
        'past {{0, plural, ' + past + '}}}';
    // Create the synthetic IntlMessageFormat instance using the original
    // locales value specified by the user when constructing the the parent
    // IntlRelativeFormat instance.
    return new intl_messageformat_1.default(message, locales);
};
RelativeFormat.prototype._getMessage = function (units) {
    var messages = this._messages;
    // Create a new synthetic message based on the locale data from CLDR.
    if (!messages[units]) {
        messages[units] = this._compileMessage(units);
    }
    return messages[units];
};
RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
    var field = this._fields[units];
    if (field.relative) {
        return field.relative[diff];
    }
};
RelativeFormat.prototype._findFields = function (locale) {
    var localeData = RelativeFormat.__localeData__;
    var data = localeData[locale.toLowerCase()];
    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find `fields` to return.
    while (data) {
        if (data.fields) {
            return data.fields;
        }
        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }
    throw new Error('Locale data added to IntlRelativeFormat is missing `fields` for :' +
        locale);
};
RelativeFormat.prototype._format = function (date, options) {
    var now = options && options.now !== undefined ? options.now : es5_1.dateNow();
    if (date === undefined) {
        date = now;
    }
    // Determine if the `date` and optional `now` values are valid, and throw a
    // similar error to what `Intl.DateTimeFormat#format()` would throw.
    if (!isFinite(now)) {
        throw new RangeError('The `now` option provided to IntlRelativeFormat#format() is not ' +
            'in valid range.');
    }
    if (!isFinite(date)) {
        throw new RangeError('The date value provided to IntlRelativeFormat#format() is not ' +
            'in valid range.');
    }
    var diffReport = diff_1.default(now, date);
    var units = this._options.units || this._selectUnits(diffReport);
    var diffInUnits = diffReport[units];
    if (this._options.style !== 'numeric') {
        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
        if (relativeUnits) {
            return relativeUnits;
        }
    }
    return this._getMessage(units).format({
        '0': Math.abs(diffInUnits),
        when: diffInUnits < 0 ? 'past' : 'future'
    });
};
RelativeFormat.prototype._isValidUnits = function (units) {
    if (!units || es5_1.arrIndexOf.call(FIELDS, units) >= 0) {
        return true;
    }
    if (typeof units === 'string') {
        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
        if (suggestion && es5_1.arrIndexOf.call(FIELDS, suggestion) >= 0) {
            throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` ' +
                'value, did you mean: ' + suggestion);
        }
    }
    throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
        'must be one of: "' + FIELDS.join('", "') + '"');
};
RelativeFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }
    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(RelativeFormat.defaultLocale);
    var localeData = RelativeFormat.__localeData__;
    var i, len, localeParts, data;
    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');
        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }
            localeParts.pop();
        }
    }
    var defaultLocale = locales.pop();
    throw new Error('No locale data has been added to IntlRelativeFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale);
};
RelativeFormat.prototype._resolveStyle = function (style) {
    // Default to "best fit" style.
    if (!style) {
        return STYLES[0];
    }
    if (es5_1.arrIndexOf.call(STYLES, style) >= 0) {
        return style;
    }
    throw new Error('"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
        'must be one of: "' + STYLES.join('", "') + '"');
};
RelativeFormat.prototype._selectUnits = function (diffReport) {
    var i, l, units;
    var fields = FIELDS.filter(function (field) {
        return field.indexOf('-short') < 1;
    });
    for (i = 0, l = fields.length; i < l; i += 1) {
        units = fields[i];
        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
            break;
        }
    }
    return units;
};
//# sourceMappingURL=core.js.map

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
var round = Math.round;
function daysToYears(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    return days * 400 / 146097;
}
// Thanks to date-fns
// https://github.com/date-fns/date-fns
// MIT © Sasha Koss
var MILLISECONDS_IN_MINUTE = 60000;
var MILLISECONDS_IN_DAY = 86400000;
function startOfDay(dirtyDate) {
    var date = new Date(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
    var startOfDayLeft = startOfDay(dirtyDateLeft);
    var startOfDayRight = startOfDay(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() -
        startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
    var timestampRight = startOfDayRight.getTime() -
        startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}
function default_1(from, to) {
    // Convert to ms timestamps.
    from = +from;
    to = +to;
    var millisecond = round(to - from), second = round(millisecond / 1000), minute = round(second / 60), hour = round(minute / 60);
    // We expect a more precision in rounding when dealing with
    // days as it feels wrong when something happended 13 hours ago and
    // is regarded as "yesterday" even if the time was this morning.
    var day = differenceInCalendarDays(to, from);
    var week = round(day / 7);
    var rawYears = daysToYears(day), month = round(rawYears * 12), year = round(rawYears);
    return {
        millisecond: millisecond,
        second: second,
        'second-short': second,
        minute: minute,
        'minute-short': minute,
        hour: hour,
        'hour-short': hour,
        day: day,
        'day-short': day,
        week: week,
        'week-short': week,
        month: month,
        'month-short': month,
        year: year,
        'year-short': year
    };
}
exports.default = default_1;
//# sourceMappingURL=diff.js.map

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License
var hop = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;
var realDefineProp = (function () {
    try {
        return !!Object.defineProperty({}, 'a', {});
    }
    catch (e) {
        return false;
    }
})();
var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
var defineProperty = realDefineProp ? Object.defineProperty :
    function (obj, name, desc) {
        if ('get' in desc && obj.__defineGetter__) {
            obj.__defineGetter__(name, desc.get);
        }
        else if (!hop.call(obj, name) || 'value' in desc) {
            obj[name] = desc.value;
        }
    };
exports.defineProperty = defineProperty;
var objCreate = Object.create || function (proto, props) {
    var obj, k;
    function F() { }
    F.prototype = proto;
    obj = new F();
    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }
    return obj;
};
exports.objCreate = objCreate;
var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
    /*jshint validthis:true */
    var arr = this;
    if (!arr.length) {
        return -1;
    }
    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
        if (arr[i] === search) {
            return i;
        }
    }
    return -1;
};
exports.arrIndexOf = arrIndexOf;
var isArray = Array.isArray || function (obj) {
    return toString.call(obj) === '[object Array]';
};
exports.isArray = isArray;
var dateNow = Date.now || function () {
    return new Date().getTime();
};
exports.dateNow = dateNow;
//# sourceMappingURL=es5.js.map

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* @generated */
exports.default = { "locale": "en", "pluralRuleFunction": function (n, ord) {
        var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
        if (ord)
            return (n10 == 1 && n100 != 11) ? 'one'
                : (n10 == 2 && n100 != 12) ? 'two'
                    : (n10 == 3 && n100 != 13) ? 'few'
                        : 'other';
        return (n == 1 && v0) ? 'one' : 'other';
    }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "week": { "displayName": "week", "relativePeriod": "the week of {0}", "relative": { "0": "this week", "1": "next week", "-1": "last week" }, "relativeTime": { "future": { "one": "in {0} week", "other": "in {0} weeks" }, "past": { "one": "{0} week ago", "other": "{0} weeks ago" } } }, "week-short": { "displayName": "wk.", "relativePeriod": "the week of {0}", "relative": { "0": "this wk.", "1": "next wk.", "-1": "last wk." }, "relativeTime": { "future": { "one": "in {0} wk.", "other": "in {0} wk." }, "past": { "one": "{0} wk. ago", "other": "{0} wk. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };
//# sourceMappingURL=en.js.map

/***/ }),
/* 1300 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var ReactIs = __webpack_require__(200);
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};

var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};

var TYPE_STATICS = {};
TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
    if (ReactIs.isMemo(component)) {
        return MEMO_STATICS;
    }
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 1302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
var RelativeTimeFormat;
// -- Utilities ----------------------------------------------------------------
function getCacheId(inputs) {
    return JSON.stringify(inputs.map(function (input) {
        return input && typeof input === 'object' ? orderedProps(input) : input;
    }));
}
function orderedProps(obj) {
    return Object.keys(obj)
        .sort()
        .map(function (k) {
        var _a;
        return (_a = {}, _a[k] = obj[k], _a);
    });
}
var memoizeFormatConstructor = function (FormatConstructor, cache) {
    if (cache === void 0) { cache = {}; }
    return function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var cacheId = getCacheId(args);
        var format = cacheId && cache[cacheId];
        if (!format) {
            format = new ((_a = FormatConstructor).bind.apply(_a, [void 0].concat(args)))();
            if (cacheId) {
                cache[cacheId] = format;
            }
        }
        return format;
    };
};
/* harmony default export */ __webpack_exports__["a"] = (memoizeFormatConstructor);
//# sourceMappingURL=index.js.map

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1304);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(65)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!../../../less-loader/dist/cjs.js!./styles.less", function() {
			var newContent = require("!!../../../css-loader/index.js!../../../less-loader/dist/cjs.js!./styles.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(64)(false);
// imports


// module
exports.push([module.i, ".rbc-btn{color:inherit;font:inherit;margin:0}button.rbc-btn{overflow:visible;text-transform:none;-webkit-appearance:button;cursor:pointer}button[disabled].rbc-btn{cursor:not-allowed}button.rbc-input::-moz-focus-inner{border:0;padding:0}.rbc-calendar{box-sizing:border-box;height:100%;display:flex;flex-direction:column;align-items:stretch}.rbc-calendar *,.rbc-calendar :after,.rbc-calendar :before{box-sizing:inherit}.rbc-abs-full,.rbc-row-bg{overflow:hidden;position:absolute;top:0;left:0;right:0;bottom:0}.rbc-ellipsis,.rbc-event-label,.rbc-row-segment .rbc-event-content,.rbc-show-more{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.rbc-rtl{direction:rtl}.rbc-off-range{color:#999}.rbc-off-range-bg{background:#e5e5e5}.rbc-header{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding:0 3px;text-align:center;vertical-align:middle;font-weight:700;font-size:90%;min-height:0}.rbc-header>a,.rbc-header>a:active,.rbc-header>a:visited{color:inherit;text-decoration:none}.rbc-row-content{position:relative;user-select:none;-webkit-user-select:none;z-index:4}.rbc-today{background-color:#eaf6ff}.rbc-toolbar{display:flex;align-items:center;margin-bottom:10px;font-size:16px}.rbc-toolbar .rbc-toolbar-label{flex-grow:1;padding:0 10px;text-align:center}.rbc-toolbar button{color:#373a3c;display:inline-block;margin:0;text-align:center;vertical-align:middle;background:none;background-image:none;border:1px solid #ccc;padding:.375rem 1rem;border-radius:4px;line-height:normal;white-space:nowrap}.rbc-toolbar button.rbc-active,.rbc-toolbar button:active{background-image:none;box-shadow:inset 0 3px 5px rgba(0,0,0,.125);background-color:#e6e6e6;border-color:#adadad}.rbc-toolbar button.rbc-active:focus,.rbc-toolbar button.rbc-active:hover,.rbc-toolbar button:active:focus,.rbc-toolbar button:active:hover{color:#373a3c;background-color:#d4d4d4;border-color:#8c8c8c}.rbc-toolbar button:focus,.rbc-toolbar button:hover{color:#373a3c;background-color:#e6e6e6;border-color:#adadad}.rbc-btn-group{display:inline-block;white-space:nowrap}.rbc-btn-group>button:first-child:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.rbc-btn-group>button:last-child:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.rbc-rtl .rbc-btn-group>button:first-child:not(:last-child){border-radius:4px;border-top-left-radius:0;border-bottom-left-radius:0}.rbc-rtl .rbc-btn-group>button:last-child:not(:first-child){border-radius:4px;border-top-right-radius:0;border-bottom-right-radius:0}.rbc-btn-group>button:not(:first-child):not(:last-child){border-radius:0}.rbc-btn-group button+button{margin-left:-1px}.rbc-rtl .rbc-btn-group button+button{margin-left:0;margin-right:-1px}.rbc-btn-group+.rbc-btn-group,.rbc-btn-group+button{margin-left:10px}.rbc-event{cursor:pointer;padding:2px 5px;background-color:#3174ad;border-radius:5px;color:#fff}.rbc-event.rbc-selected{background-color:#265985}.rbc-event-label{font-size:80%}.rbc-event-overlaps{box-shadow:-1px 1px 5px 0 rgba(51,51,51,.5)}.rbc-event-continues-prior{border-top-left-radius:0;border-bottom-left-radius:0}.rbc-event-continues-after{border-top-right-radius:0;border-bottom-right-radius:0}.rbc-event-continues-earlier{border-top-left-radius:0;border-top-right-radius:0}.rbc-event-continues-day-after,.rbc-event-continues-later{border-bottom-left-radius:0;border-bottom-right-radius:0}.rbc-event-continues-day-prior{border-top-left-radius:0;border-top-right-radius:0}.rbc-row{display:flex;flex-direction:row}.rbc-row-segment{padding:0 1px 1px}.rbc-selected-cell{background-color:rgba(0,0,0,.1)}.rbc-show-more{background-color:hsla(0,0%,100%,.3);z-index:4;font-weight:700;font-size:85%;height:auto;line-height:normal;white-space:nowrap}.rbc-month-view{position:relative;border:1px solid #ddd;display:flex;flex-direction:column;flex:1 0 0;width:100%;user-select:none;-webkit-user-select:none;height:100%}.rbc-month-view .rbc-header{border-bottom:1px solid #ddd}.rbc-month-view .rbc-header+.rbc-header{border-left:1px solid #ddd}.rbc-rtl .rbc-month-view .rbc-header+.rbc-header{border-left-width:0;border-right:1px solid #ddd}.rbc-month-header{display:flex;flex-direction:row}.rbc-month-row{display:flex;position:relative;flex-direction:column;flex:1 0 0;overflow:hidden;height:100%}.rbc-month-row+.rbc-month-row{border-top:1px solid #ddd}.rbc-date-cell{padding-right:5px;text-align:right}.rbc-date-cell.rbc-now{font-weight:700}.rbc-date-cell>a,.rbc-date-cell>a:active,.rbc-date-cell>a:visited{color:inherit;text-decoration:none}.rbc-row-bg{display:flex;flex-direction:row;flex:1 0 0;overflow:hidden}.rbc-day-bg+.rbc-day-bg{border-left:1px solid #ddd}.rbc-rtl .rbc-day-bg+.rbc-day-bg{border-left-width:0;border-right:1px solid #ddd}.rbc-overlay{position:absolute;z-index:5;border:1px solid #e5e5e5;background-color:#fff;box-shadow:0 5px 15px rgba(0,0,0,.25);padding:10px}.rbc-overlay>*+*{margin-top:1px}.rbc-overlay-header{border-bottom:1px solid #e5e5e5;margin:-10px -10px 5px;padding:2px 10px}.rbc-agenda-view{display:flex;flex-direction:column;flex:1 0 0;overflow:auto}.rbc-agenda-view table{width:100%;border:1px solid #ddd}.rbc-agenda-view table tbody>tr>td{padding:5px 10px;vertical-align:top}.rbc-agenda-view table .rbc-agenda-time-cell{padding-left:15px;padding-right:15px;text-transform:lowercase}.rbc-agenda-view table tbody>tr>td+td{border-left:1px solid #ddd}.rbc-rtl .rbc-agenda-view table tbody>tr>td+td{border-left-width:0;border-right:1px solid #ddd}.rbc-agenda-view table tbody>tr+tr{border-top:1px solid #ddd}.rbc-agenda-view table thead>tr>th{padding:3px 5px;text-align:left;border-bottom:1px solid #ddd}.rbc-rtl .rbc-agenda-view table thead>tr>th{text-align:right}.rbc-agenda-time-cell{text-transform:lowercase}.rbc-agenda-time-cell .rbc-continues-after:after{content:\" \\BB\"}.rbc-agenda-time-cell .rbc-continues-prior:before{content:\"\\AB   \"}.rbc-agenda-date-cell,.rbc-agenda-time-cell{white-space:nowrap}.rbc-agenda-event-cell{width:100%}.rbc-time-column{display:flex;flex-direction:column;min-height:100%}.rbc-time-column .rbc-timeslot-group{flex:1}.rbc-timeslot-group{border-bottom:1px solid #ddd;min-height:40px;display:flex;flex-flow:column nowrap}.rbc-header-gutter,.rbc-time-gutter{flex:none}.rbc-label{padding:0 5px}.rbc-day-slot{position:relative}.rbc-day-slot .rbc-event{border:1px solid #265985;display:flex;max-height:100%;flex-flow:column wrap;align-items:flex-start;overflow:hidden}.rbc-day-slot .rbc-event-label{flex:none;padding-right:5px;width:auto}.rbc-day-slot .rbc-event-content{width:100%;flex:1 1 0;word-wrap:break-word;line-height:1;height:100%;min-height:1em}.rbc-day-slot .rbc-time-slot{border-top:1px solid #f7f7f7}.rbc-time-slot{flex:1 0 0}.rbc-time-slot.rbc-now{font-weight:700}.rbc-day-header{text-align:center}.rbc-day-slot .rbc-event{position:absolute;z-index:2}.rbc-slot-selection{z-index:10;position:absolute;cursor:default;background-color:rgba(0,0,0,.5);color:#fff;font-size:75%;padding:3px}.rbc-time-view{display:flex;flex-direction:column;flex:1;width:100%;border:1px solid #ddd;min-height:0}.rbc-time-view .rbc-time-gutter{white-space:nowrap}.rbc-time-view .rbc-allday-cell{width:100%;position:relative}.rbc-time-view .rbc-allday-events{position:relative;z-index:4}.rbc-time-view .rbc-row{min-height:20px}.rbc-time-header{display:flex;flex:0 0 auto;flex-direction:column}.rbc-time-header.rbc-overflowing{border-right:1px solid #ddd}.rbc-rtl .rbc-time-header.rbc-overflowing{border-right-width:0;border-left:1px solid #ddd}.rbc-time-header>.rbc-row>*+*{border-left:1px solid #ddd}.rbc-rtl .rbc-time-header>.rbc-row>*+*{border-left-width:0;border-right:1px solid #ddd}.rbc-time-header>.rbc-row:first-child{border-bottom:1px solid #ddd}.rbc-time-header .rbc-gutter-cell{flex:none}.rbc-time-header>.rbc-gutter-cell+*{width:100%}.rbc-time-content{display:flex;flex:1 0 0;align-items:flex-start;width:100%;border-top:2px solid #ddd;overflow-y:auto;position:relative}.rbc-time-content>.rbc-time-gutter{flex:none}.rbc-time-content>*+*>*{border-left:1px solid #ddd}.rbc-rtl .rbc-time-content>*+*>*{border-left-width:0;border-right:1px solid #ddd}.rbc-time-content>.rbc-day-slot{width:100%;user-select:none;-webkit-user-select:none}.rbc-current-time-indicator{position:absolute;z-index:1;left:0;height:1px;background-color:#74ad31;pointer-events:none}.rbc-current-time-indicator:before{display:block;position:absolute;left:-3px;top:-3px;content:\" \";background-color:#74ad31;border-radius:50%;width:8px;height:8px}.rbc-rtl .rbc-current-time-indicator:before{left:0;right:-3px}", ""]);

// exports


/***/ }),
/* 1305 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1307);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(65)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!./switch.min.css", function() {
			var newContent = require("!!../../../css-loader/index.js!./switch.min.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(64)(false);
// imports


// module
exports.push([module.i, ".switch{border:1px solid #ccc;width:50px;height:26px;border-radius:13px;cursor:pointer;display:inline-block}.switch-toggle{border:1px solid #999;box-shadow:1px 1px 1px #ccc;width:25px;height:24px;left:0;border-radius:12px;background:#fff;position:relative;transition:left .2s ease-in-out}.switch.on{background:green}.switch.on .switch-toggle{left:23px}.switch.disabled{cursor:not-allowed}", ""]);

// exports


/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1309);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(65)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js!./index.css", function() {
			var newContent = require("!!../../css-loader/index.js!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(64)(false);
// imports


// module
exports.push([module.i, ".rc-drawer{position:absolute;top:0;left:0;right:0;bottom:0;overflow:hidden}.rc-drawer-sidebar{z-index:2;position:absolute;transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out;transition:transform .3s ease-out,-webkit-transform .3s ease-out;will-change:transform;overflow-y:auto}.rc-drawer-draghandle{z-index:1;position:absolute;background-color:rgba(50,50,50,.1)}.rc-drawer-overlay{z-index:1;opacity:0;visibility:hidden;transition:opacity .3s ease-out;background-color:rgba(0,0,0,.3)}.rc-drawer-content,.rc-drawer-overlay{position:absolute;top:0;left:0;right:0;bottom:0}.rc-drawer-content{overflow:auto;transition:left .3s ease-out,right .3s ease-out,top .3s ease-out,bottom .3s ease-out}.rc-drawer.rc-drawer-left .rc-drawer-draghandle,.rc-drawer.rc-drawer-left .rc-drawer-sidebar,.rc-drawer.rc-drawer-right .rc-drawer-draghandle,.rc-drawer.rc-drawer-right .rc-drawer-sidebar{top:0;bottom:0}.rc-drawer.rc-drawer-left .rc-drawer-draghandle,.rc-drawer.rc-drawer-right .rc-drawer-draghandle{width:20px;height:100%}.rc-drawer.rc-drawer-bottom .rc-drawer-draghandle,.rc-drawer.rc-drawer-bottom .rc-drawer-sidebar,.rc-drawer.rc-drawer-top .rc-drawer-draghandle,.rc-drawer.rc-drawer-top .rc-drawer-sidebar{left:0;right:0}.rc-drawer.rc-drawer-bottom .rc-drawer-draghandle,.rc-drawer.rc-drawer-top .rc-drawer-draghandle{width:100%;height:20px}.rc-drawer.rc-drawer-left .rc-drawer-sidebar{left:0;-webkit-transform:translateX(-100%);transform:translateX(-100%)}.rc-drawer-open.rc-drawer.rc-drawer-left .rc-drawer-sidebar{box-shadow:2px 2px 4px rgba(0,0,0,.15)}.rc-drawer.rc-drawer-left .rc-drawer-draghandle{left:0}.rc-drawer.rc-drawer-right .rc-drawer-sidebar{right:0;-webkit-transform:translateX(100%);transform:translateX(100%)}.rc-drawer-open.rc-drawer.rc-drawer-right .rc-drawer-sidebar{box-shadow:-2px 2px 4px rgba(0,0,0,.15)}.rc-drawer.rc-drawer-right .rc-drawer-draghandle{right:0}.rc-drawer.rc-drawer-top .rc-drawer-sidebar{top:0;-webkit-transform:translateY(-100%);transform:translateY(-100%)}.rc-drawer-open.rc-drawer.rc-drawer-top .rc-drawer-sidebar{box-shadow:2px 2px 4px rgba(0,0,0,.15)}.rc-drawer.rc-drawer-top .rc-drawer-draghandle{top:0}.rc-drawer.rc-drawer-bottom .rc-drawer-sidebar{bottom:0;-webkit-transform:translateY(100%);transform:translateY(100%)}.rc-drawer-open.rc-drawer.rc-drawer-bottom .rc-drawer-sidebar{box-shadow:2px -2px 4px rgba(0,0,0,.15)}.rc-drawer.rc-drawer-bottom .rc-drawer-draghandle{bottom:0}", ""]);

// exports


/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1311);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(65)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./bootstrap.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./bootstrap.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(64)(false);
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Nunito+Sans:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i);", ""]);

// module
exports.push([module.i, "/*!\n * Bootstrap v4.0.0 (https://getbootstrap.com)\n * Copyright 2011-2018 The Bootstrap Authors\n * Copyright 2011-2018 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n */:root{--blue:#007bff;--indigo:#6610f2;--purple:#6f42c1;--pink:#e83e8c;--red:#dc3545;--orange:#fd7e14;--yellow:#ffc107;--green:#28a745;--teal:#20c997;--cyan:#17a2b8;--white:#fff;--gray:#6c757d;--gray-dark:#343a40;--primary:#3f51b5;--secondary:#e91e63;--success:#4caf50;--info:#00bcd4;--warning:#ff9800;--danger:#f44336;--light:#e8eaf6;--dark:#343a40;--breakpoint-xs:0;--breakpoint-sm:576px;--breakpoint-md:768px;--breakpoint-lg:992px;--breakpoint-xl:1200px;--font-family-sans-serif:\"Nunito Sans\",sans-serif;--font-family-monospace:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace}*,:after,:before{box-sizing:border-box}html{font-family:sans-serif;line-height:1.15;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;-ms-overflow-style:scrollbar;-webkit-tap-highlight-color:rgba(0,0,0,0)}@-ms-viewport{width:device-width}article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}body{margin:0;font-family:Nunito Sans,sans-serif;font-size:13px;font-weight:400;line-height:1.5;color:#5c5c5c;text-align:left;background-color:#f4f4f4}[tabindex=\"-1\"]:focus{outline:0!important}hr{box-sizing:content-box;height:0;overflow:visible}h1,h2,h3,h4,h5,h6{margin-top:0;margin-bottom:12px}p{margin-top:0;margin-bottom:1rem}abbr[data-original-title],abbr[title]{text-decoration:underline;text-decoration:underline dotted;cursor:help;border-bottom:0}address{font-style:normal;line-height:inherit}address,dl,ol,ul{margin-bottom:1rem}dl,ol,ul{margin-top:0}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}dt{font-weight:700}dd{margin-bottom:.5rem;margin-left:0}blockquote{margin:0 0 1rem}dfn{font-style:italic}b,strong{font-weight:bolder}small{font-size:80%}sub,sup{position:relative;font-size:75%;line-height:0;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}a{color:#3f51b5;text-decoration:none;background-color:transparent;-webkit-text-decoration-skip:objects}a:hover{color:#32408f;text-decoration:underline}a:not([href]):not([tabindex]),a:not([href]):not([tabindex]):focus,a:not([href]):not([tabindex]):hover{color:inherit;text-decoration:none}a:not([href]):not([tabindex]):focus{outline:0}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}pre{margin-top:0;margin-bottom:1rem;overflow:auto;-ms-overflow-style:scrollbar}figure{margin:0 0 1rem}img{vertical-align:middle;border-style:none}svg:not(:root){overflow:hidden}table{border-collapse:collapse}caption{padding-top:.75rem;padding-bottom:.75rem;color:#6c757d;text-align:left;caption-side:bottom}th{text-align:inherit}label{display:inline-block;margin-bottom:.5rem}button{border-radius:0}button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color}button,input,optgroup,select,textarea{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}button,input{overflow:visible}button,select{text-transform:none}[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{padding:0;border-style:none}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=date],input[type=datetime-local],input[type=month],input[type=time]{-webkit-appearance:listbox}textarea{overflow:auto;resize:vertical}fieldset{min-width:0;padding:0;margin:0;border:0}legend{display:block;width:100%;max-width:100%;padding:0;margin-bottom:.5rem;font-size:1.5rem;line-height:inherit;color:inherit;white-space:normal}progress{vertical-align:baseline}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{outline-offset:-2px;-webkit-appearance:none}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}output{display:inline-block}summary{display:list-item;cursor:pointer}template{display:none}[hidden]{display:none!important}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{margin-bottom:12px;font-family:inherit;font-weight:400;line-height:1.2;color:inherit}.h1,h1{font-size:24px}.h2,h2{font-size:18px}.h3,h3{font-size:16px}.h4,h4{font-size:15px}.h5,h5{font-size:13px}.h6,h6{font-size:12px}.lead{font-size:1.25rem;font-weight:300}.display-1{font-size:6rem}.display-1,.display-2{font-weight:300;line-height:1.2}.display-2{font-size:5.5rem}.display-3{font-size:4.5rem}.display-3,.display-4{font-weight:300;line-height:1.2}.display-4{font-size:3.5rem}hr{margin-top:1rem;margin-bottom:1rem;border:0;border-top:1px solid rgba(0,0,0,.1)}.small,small{font-size:80%;font-weight:400}.mark,mark{padding:.2em;background-color:#fcf8e3}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline-item{display:inline-block}.list-inline-item:not(:last-child){margin-right:.5rem}.initialism{font-size:90%;text-transform:uppercase}.blockquote{margin-bottom:1rem;font-size:1.25rem}.blockquote-footer{display:block;font-size:80%;color:#6c757d}.blockquote-footer:before{content:\"\\2014   \\A0\"}.img-fluid,.img-thumbnail{max-width:100%;height:auto}.img-thumbnail{padding:.25rem;background-color:#fff;border:1px solid #dee2e6;border-radius:.25rem;box-shadow:0 1px 2px rgba(0,0,0,.075)}.figure{display:inline-block}.figure-img{margin-bottom:.5rem;line-height:1}.figure-caption{font-size:90%;color:#6c757d}code,kbd,pre,samp{font-family:SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace}code{font-size:87.5%;color:#e83e8c;word-break:break-word}a>code{color:inherit}kbd{padding:.2rem .4rem;font-size:87.5%;color:#fff;background-color:#212529;border-radius:2px;box-shadow:inset 0 -.1rem 0 rgba(0,0,0,.25)}kbd kbd{padding:0;font-size:100%;font-weight:700;box-shadow:none}pre{display:block;font-size:87.5%;color:#212529}pre code{font-size:inherit;color:inherit;word-break:normal}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{width:100%;padding-right:17px;padding-left:17px;margin-right:auto;margin-left:auto}@media (min-width:576px){.container{max-width:540px}}@media (min-width:768px){.container{max-width:720px}}@media (min-width:992px){.container{max-width:960px}}@media (min-width:1200px){.container{max-width:1140px}}.container-fluid{width:100%;padding-right:17px;padding-left:17px;margin-right:auto;margin-left:auto}.row{display:flex;flex-wrap:wrap;margin-right:-17px;margin-left:-17px}.no-gutters{margin-right:0;margin-left:0}.no-gutters>.col,.no-gutters>[class*=col-]{padding-right:0;padding-left:0}.col,.col-1,.col-2,.col-3,.col-4,.col-5,.col-6,.col-7,.col-8,.col-9,.col-10,.col-11,.col-12,.col-auto,.col-lg,.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-lg-auto,.col-md,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-md-auto,.col-sm,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-sm-auto,.col-xl,.col-xl-1,.col-xl-2,.col-xl-3,.col-xl-4,.col-xl-5,.col-xl-6,.col-xl-7,.col-xl-8,.col-xl-9,.col-xl-10,.col-xl-11,.col-xl-12,.col-xl-auto{position:relative;width:100%;min-height:1px;padding-right:17px;padding-left:17px}.col{flex-basis:0;flex-grow:1;max-width:100%}.col-auto{flex:0 0 auto;width:auto;max-width:none}.col-1{flex:0 0 8.33333%;max-width:8.33333%}.col-2{flex:0 0 16.66667%;max-width:16.66667%}.col-3{flex:0 0 25%;max-width:25%}.col-4{flex:0 0 33.33333%;max-width:33.33333%}.col-5{flex:0 0 41.66667%;max-width:41.66667%}.col-6{flex:0 0 50%;max-width:50%}.col-7{flex:0 0 58.33333%;max-width:58.33333%}.col-8{flex:0 0 66.66667%;max-width:66.66667%}.col-9{flex:0 0 75%;max-width:75%}.col-10{flex:0 0 83.33333%;max-width:83.33333%}.col-11{flex:0 0 91.66667%;max-width:91.66667%}.col-12{flex:0 0 100%;max-width:100%}.order-first{order:-1}.order-last{order:13}.order-0{order:0}.order-1{order:1}.order-2{order:2}.order-3{order:3}.order-4{order:4}.order-5{order:5}.order-6{order:6}.order-7{order:7}.order-8{order:8}.order-9{order:9}.order-10{order:10}.order-11{order:11}.order-12{order:12}.offset-1{margin-left:8.33333%}.offset-2{margin-left:16.66667%}.offset-3{margin-left:25%}.offset-4{margin-left:33.33333%}.offset-5{margin-left:41.66667%}.offset-6{margin-left:50%}.offset-7{margin-left:58.33333%}.offset-8{margin-left:66.66667%}.offset-9{margin-left:75%}.offset-10{margin-left:83.33333%}.offset-11{margin-left:91.66667%}@media (min-width:576px){.col-sm{flex-basis:0;flex-grow:1;max-width:100%}.col-sm-auto{flex:0 0 auto;width:auto;max-width:none}.col-sm-1{flex:0 0 8.33333%;max-width:8.33333%}.col-sm-2{flex:0 0 16.66667%;max-width:16.66667%}.col-sm-3{flex:0 0 25%;max-width:25%}.col-sm-4{flex:0 0 33.33333%;max-width:33.33333%}.col-sm-5{flex:0 0 41.66667%;max-width:41.66667%}.col-sm-6{flex:0 0 50%;max-width:50%}.col-sm-7{flex:0 0 58.33333%;max-width:58.33333%}.col-sm-8{flex:0 0 66.66667%;max-width:66.66667%}.col-sm-9{flex:0 0 75%;max-width:75%}.col-sm-10{flex:0 0 83.33333%;max-width:83.33333%}.col-sm-11{flex:0 0 91.66667%;max-width:91.66667%}.col-sm-12{flex:0 0 100%;max-width:100%}.order-sm-first{order:-1}.order-sm-last{order:13}.order-sm-0{order:0}.order-sm-1{order:1}.order-sm-2{order:2}.order-sm-3{order:3}.order-sm-4{order:4}.order-sm-5{order:5}.order-sm-6{order:6}.order-sm-7{order:7}.order-sm-8{order:8}.order-sm-9{order:9}.order-sm-10{order:10}.order-sm-11{order:11}.order-sm-12{order:12}.offset-sm-0{margin-left:0}.offset-sm-1{margin-left:8.33333%}.offset-sm-2{margin-left:16.66667%}.offset-sm-3{margin-left:25%}.offset-sm-4{margin-left:33.33333%}.offset-sm-5{margin-left:41.66667%}.offset-sm-6{margin-left:50%}.offset-sm-7{margin-left:58.33333%}.offset-sm-8{margin-left:66.66667%}.offset-sm-9{margin-left:75%}.offset-sm-10{margin-left:83.33333%}.offset-sm-11{margin-left:91.66667%}}@media (min-width:768px){.col-md{flex-basis:0;flex-grow:1;max-width:100%}.col-md-auto{flex:0 0 auto;width:auto;max-width:none}.col-md-1{flex:0 0 8.33333%;max-width:8.33333%}.col-md-2{flex:0 0 16.66667%;max-width:16.66667%}.col-md-3{flex:0 0 25%;max-width:25%}.col-md-4{flex:0 0 33.33333%;max-width:33.33333%}.col-md-5{flex:0 0 41.66667%;max-width:41.66667%}.col-md-6{flex:0 0 50%;max-width:50%}.col-md-7{flex:0 0 58.33333%;max-width:58.33333%}.col-md-8{flex:0 0 66.66667%;max-width:66.66667%}.col-md-9{flex:0 0 75%;max-width:75%}.col-md-10{flex:0 0 83.33333%;max-width:83.33333%}.col-md-11{flex:0 0 91.66667%;max-width:91.66667%}.col-md-12{flex:0 0 100%;max-width:100%}.order-md-first{order:-1}.order-md-last{order:13}.order-md-0{order:0}.order-md-1{order:1}.order-md-2{order:2}.order-md-3{order:3}.order-md-4{order:4}.order-md-5{order:5}.order-md-6{order:6}.order-md-7{order:7}.order-md-8{order:8}.order-md-9{order:9}.order-md-10{order:10}.order-md-11{order:11}.order-md-12{order:12}.offset-md-0{margin-left:0}.offset-md-1{margin-left:8.33333%}.offset-md-2{margin-left:16.66667%}.offset-md-3{margin-left:25%}.offset-md-4{margin-left:33.33333%}.offset-md-5{margin-left:41.66667%}.offset-md-6{margin-left:50%}.offset-md-7{margin-left:58.33333%}.offset-md-8{margin-left:66.66667%}.offset-md-9{margin-left:75%}.offset-md-10{margin-left:83.33333%}.offset-md-11{margin-left:91.66667%}}@media (min-width:992px){.col-lg{flex-basis:0;flex-grow:1;max-width:100%}.col-lg-auto{flex:0 0 auto;width:auto;max-width:none}.col-lg-1{flex:0 0 8.33333%;max-width:8.33333%}.col-lg-2{flex:0 0 16.66667%;max-width:16.66667%}.col-lg-3{flex:0 0 25%;max-width:25%}.col-lg-4{flex:0 0 33.33333%;max-width:33.33333%}.col-lg-5{flex:0 0 41.66667%;max-width:41.66667%}.col-lg-6{flex:0 0 50%;max-width:50%}.col-lg-7{flex:0 0 58.33333%;max-width:58.33333%}.col-lg-8{flex:0 0 66.66667%;max-width:66.66667%}.col-lg-9{flex:0 0 75%;max-width:75%}.col-lg-10{flex:0 0 83.33333%;max-width:83.33333%}.col-lg-11{flex:0 0 91.66667%;max-width:91.66667%}.col-lg-12{flex:0 0 100%;max-width:100%}.order-lg-first{order:-1}.order-lg-last{order:13}.order-lg-0{order:0}.order-lg-1{order:1}.order-lg-2{order:2}.order-lg-3{order:3}.order-lg-4{order:4}.order-lg-5{order:5}.order-lg-6{order:6}.order-lg-7{order:7}.order-lg-8{order:8}.order-lg-9{order:9}.order-lg-10{order:10}.order-lg-11{order:11}.order-lg-12{order:12}.offset-lg-0{margin-left:0}.offset-lg-1{margin-left:8.33333%}.offset-lg-2{margin-left:16.66667%}.offset-lg-3{margin-left:25%}.offset-lg-4{margin-left:33.33333%}.offset-lg-5{margin-left:41.66667%}.offset-lg-6{margin-left:50%}.offset-lg-7{margin-left:58.33333%}.offset-lg-8{margin-left:66.66667%}.offset-lg-9{margin-left:75%}.offset-lg-10{margin-left:83.33333%}.offset-lg-11{margin-left:91.66667%}}@media (min-width:1200px){.col-xl{flex-basis:0;flex-grow:1;max-width:100%}.col-xl-auto{flex:0 0 auto;width:auto;max-width:none}.col-xl-1{flex:0 0 8.33333%;max-width:8.33333%}.col-xl-2{flex:0 0 16.66667%;max-width:16.66667%}.col-xl-3{flex:0 0 25%;max-width:25%}.col-xl-4{flex:0 0 33.33333%;max-width:33.33333%}.col-xl-5{flex:0 0 41.66667%;max-width:41.66667%}.col-xl-6{flex:0 0 50%;max-width:50%}.col-xl-7{flex:0 0 58.33333%;max-width:58.33333%}.col-xl-8{flex:0 0 66.66667%;max-width:66.66667%}.col-xl-9{flex:0 0 75%;max-width:75%}.col-xl-10{flex:0 0 83.33333%;max-width:83.33333%}.col-xl-11{flex:0 0 91.66667%;max-width:91.66667%}.col-xl-12{flex:0 0 100%;max-width:100%}.order-xl-first{order:-1}.order-xl-last{order:13}.order-xl-0{order:0}.order-xl-1{order:1}.order-xl-2{order:2}.order-xl-3{order:3}.order-xl-4{order:4}.order-xl-5{order:5}.order-xl-6{order:6}.order-xl-7{order:7}.order-xl-8{order:8}.order-xl-9{order:9}.order-xl-10{order:10}.order-xl-11{order:11}.order-xl-12{order:12}.offset-xl-0{margin-left:0}.offset-xl-1{margin-left:8.33333%}.offset-xl-2{margin-left:16.66667%}.offset-xl-3{margin-left:25%}.offset-xl-4{margin-left:33.33333%}.offset-xl-5{margin-left:41.66667%}.offset-xl-6{margin-left:50%}.offset-xl-7{margin-left:58.33333%}.offset-xl-8{margin-left:66.66667%}.offset-xl-9{margin-left:75%}.offset-xl-10{margin-left:83.33333%}.offset-xl-11{margin-left:91.66667%}}.table{width:100%;max-width:100%;margin-bottom:1rem;background-color:transparent}.table td,.table th{padding:.75rem;vertical-align:top;border-top:1px solid #dee2e6}.table thead th{vertical-align:bottom;border-bottom:2px solid #dee2e6}.table tbody+tbody{border-top:2px solid #dee2e6}.table .table{background-color:#f4f4f4}.table-sm td,.table-sm th{padding:.3rem}.table-bordered,.table-bordered td,.table-bordered th{border:1px solid #dee2e6}.table-bordered thead td,.table-bordered thead th{border-bottom-width:2px}.table-striped tbody tr:nth-of-type(odd){background-color:rgba(0,0,0,.05)}.table-hover tbody tr:hover{background-color:rgba(0,0,0,.075)}.table-primary,.table-primary>td,.table-primary>th{background-color:#c9ceea}.table-hover .table-primary:hover,.table-hover .table-primary:hover>td,.table-hover .table-primary:hover>th{background-color:#b7bde3}.table-secondary,.table-secondary>td,.table-secondary>th{background-color:#f9c0d3}.table-hover .table-secondary:hover,.table-hover .table-secondary:hover>td,.table-hover .table-secondary:hover>th{background-color:#f7a9c3}.table-success,.table-success>td,.table-success>th{background-color:#cde9ce}.table-hover .table-success:hover,.table-hover .table-success:hover>td,.table-hover .table-success:hover>th{background-color:#bbe1bd}.table-info,.table-info>td,.table-info>th{background-color:#b8ecf3}.table-hover .table-info:hover,.table-hover .table-info:hover>td,.table-hover .table-info:hover>th{background-color:#a2e6ef}.table-warning,.table-warning>td,.table-warning>th{background-color:#ffe2b8}.table-hover .table-warning:hover,.table-hover .table-warning:hover>td,.table-hover .table-warning:hover>th{background-color:#ffd89f}.table-danger,.table-danger>td,.table-danger>th{background-color:#fccac7}.table-hover .table-danger:hover,.table-hover .table-danger:hover>td,.table-hover .table-danger:hover>th{background-color:#fbb3af}.table-light,.table-light>td,.table-light>th{background-color:#f9f9fc}.table-hover .table-light:hover,.table-hover .table-light:hover>td,.table-hover .table-light:hover>th{background-color:#e8e8f4}.table-dark,.table-dark>td,.table-dark>th{background-color:#c6c8ca}.table-hover .table-dark:hover,.table-hover .table-dark:hover>td,.table-hover .table-dark:hover>th{background-color:#b9bbbe}.table-active,.table-active>td,.table-active>th,.table-hover .table-active:hover,.table-hover .table-active:hover>td,.table-hover .table-active:hover>th{background-color:rgba(0,0,0,.075)}.table .thead-dark th{color:#fff;background-color:#212529;border-color:#32383e}.table .thead-light th{color:#495057;background-color:#e9ecef;border-color:#dee2e6}.table-dark{color:#fff;background-color:#212529}.table-dark td,.table-dark th,.table-dark thead th{border-color:#32383e}.table-dark.table-bordered{border:0}.table-dark.table-striped tbody tr:nth-of-type(odd){background-color:hsla(0,0%,100%,.05)}.table-dark.table-hover tbody tr:hover{background-color:hsla(0,0%,100%,.075)}@media (max-width:575.98px){.table-responsive-sm{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.table-responsive-sm>.table-bordered{border:0}}@media (max-width:767.98px){.table-responsive-md{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.table-responsive-md>.table-bordered{border:0}}@media (max-width:991.98px){.table-responsive-lg{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.table-responsive-lg>.table-bordered{border:0}}@media (max-width:1199.98px){.table-responsive-xl{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.table-responsive-xl>.table-bordered{border:0}}.table-responsive{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.table-responsive>.table-bordered{border:0}.table-middle td,.table-middle thead th{vertical-align:middle}.form-control{display:block;width:100%;padding:.375rem .75rem;font-size:13px;line-height:1.5;color:#495057;background-color:#fff;background-clip:padding-box;border:1px solid #ced4da;border-radius:.25rem;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control::-ms-expand{background-color:transparent;border:0}.form-control:focus{color:#495057;background-color:#fff;border-color:#80bdff;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,123,255,.25)}.form-control::placeholder{color:#6c757d;opacity:1}.form-control:disabled,.form-control[readonly]{background-color:#e9ecef;opacity:1}select.form-control:not([size]):not([multiple]){height:calc(2.25rem + 2px)}select.form-control:focus::-ms-value{color:#495057;background-color:#fff}.form-control-file,.form-control-range{display:block;width:100%}.col-form-label{padding-top:calc(.375rem + 1px);padding-bottom:calc(.375rem + 1px);margin-bottom:0;font-size:inherit;line-height:1.5}.col-form-label-lg{padding-top:calc(.5rem + 1px);padding-bottom:calc(.5rem + 1px);font-size:17px;line-height:1.5}.col-form-label-sm{padding-top:calc(.25rem + 1px);padding-bottom:calc(.25rem + 1px);font-size:13px;line-height:1.5}.form-control-plaintext{display:block;width:100%;padding-top:.375rem;padding-bottom:.375rem;margin-bottom:0;line-height:1.5;background-color:transparent;border:solid transparent;border-width:1px 0}.form-control-plaintext.form-control-lg,.form-control-plaintext.form-control-sm,.input-group-lg>.form-control-plaintext.form-control,.input-group-lg>.input-group-append>.form-control-plaintext.btn,.input-group-lg>.input-group-append>.form-control-plaintext.input-group-text,.input-group-lg>.input-group-prepend>.form-control-plaintext.btn,.input-group-lg>.input-group-prepend>.form-control-plaintext.input-group-text,.input-group-sm>.form-control-plaintext.form-control,.input-group-sm>.input-group-append>.form-control-plaintext.btn,.input-group-sm>.input-group-append>.form-control-plaintext.input-group-text,.input-group-sm>.input-group-prepend>.form-control-plaintext.btn,.input-group-sm>.input-group-prepend>.form-control-plaintext.input-group-text{padding-right:0;padding-left:0}.form-control-sm,.input-group-sm>.form-control,.input-group-sm>.input-group-append>.btn,.input-group-sm>.input-group-append>.input-group-text,.input-group-sm>.input-group-prepend>.btn,.input-group-sm>.input-group-prepend>.input-group-text{padding:.25rem .5rem;font-size:13px;line-height:1.5;border-radius:.2rem}.input-group-sm>.input-group-append>select.btn:not([size]):not([multiple]),.input-group-sm>.input-group-append>select.input-group-text:not([size]):not([multiple]),.input-group-sm>.input-group-prepend>select.btn:not([size]):not([multiple]),.input-group-sm>.input-group-prepend>select.input-group-text:not([size]):not([multiple]),.input-group-sm>select.form-control:not([size]):not([multiple]),select.form-control-sm:not([size]):not([multiple]){height:calc(1.8125rem + 2px)}.form-control-lg,.input-group-lg>.form-control,.input-group-lg>.input-group-append>.btn,.input-group-lg>.input-group-append>.input-group-text,.input-group-lg>.input-group-prepend>.btn,.input-group-lg>.input-group-prepend>.input-group-text{padding:.5rem 1rem;font-size:17px;line-height:1.5;border-radius:.3rem}.input-group-lg>.input-group-append>select.btn:not([size]):not([multiple]),.input-group-lg>.input-group-append>select.input-group-text:not([size]):not([multiple]),.input-group-lg>.input-group-prepend>select.btn:not([size]):not([multiple]),.input-group-lg>.input-group-prepend>select.input-group-text:not([size]):not([multiple]),.input-group-lg>select.form-control:not([size]):not([multiple]),select.form-control-lg:not([size]):not([multiple]){height:calc(2.875rem + 2px)}.form-group{margin-bottom:1rem}.form-text{display:block;margin-top:.25rem}.form-row{display:flex;flex-wrap:wrap;margin-right:-5px;margin-left:-5px}.form-row>.col,.form-row>[class*=col-]{padding-right:5px;padding-left:5px}.form-check{position:relative;display:block;padding-left:1.25rem}.form-check-input{position:absolute;margin-top:.3rem;margin-left:-1.25rem}.form-check-input:disabled~.form-check-label{color:#6c757d}.form-check-label{margin-bottom:0}.form-check-inline{display:inline-flex;align-items:center;padding-left:0;margin-right:.75rem}.form-check-inline .form-check-input{position:static;margin-top:0;margin-right:.3125rem;margin-left:0}.valid-feedback{display:none;width:100%;margin-top:.25rem;font-size:80%;color:#28a745}.valid-tooltip{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.5rem;margin-top:.1rem;font-size:.875rem;line-height:1;color:#fff;background-color:rgba(40,167,69,.8);border-radius:.2rem}.custom-select.is-valid,.form-control.is-valid,.was-validated .custom-select:valid,.was-validated .form-control:valid{border-color:#28a745}.custom-select.is-valid:focus,.form-control.is-valid:focus,.was-validated .custom-select:valid:focus,.was-validated .form-control:valid:focus{border-color:#28a745;box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.custom-select.is-valid~.valid-feedback,.custom-select.is-valid~.valid-tooltip,.form-control.is-valid~.valid-feedback,.form-control.is-valid~.valid-tooltip,.was-validated .custom-select:valid~.valid-feedback,.was-validated .custom-select:valid~.valid-tooltip,.was-validated .form-control:valid~.valid-feedback,.was-validated .form-control:valid~.valid-tooltip{display:block}.form-check-input.is-valid~.form-check-label,.was-validated .form-check-input:valid~.form-check-label{color:#28a745}.form-check-input.is-valid~.valid-feedback,.form-check-input.is-valid~.valid-tooltip,.was-validated .form-check-input:valid~.valid-feedback,.was-validated .form-check-input:valid~.valid-tooltip{display:block}.custom-control-input.is-valid~.custom-control-label,.was-validated .custom-control-input:valid~.custom-control-label{color:#28a745}.custom-control-input.is-valid~.custom-control-label:before,.was-validated .custom-control-input:valid~.custom-control-label:before{background-color:#71dd8a}.custom-control-input.is-valid~.valid-feedback,.custom-control-input.is-valid~.valid-tooltip,.was-validated .custom-control-input:valid~.valid-feedback,.was-validated .custom-control-input:valid~.valid-tooltip{display:block}.custom-control-input.is-valid:checked~.custom-control-label:before,.was-validated .custom-control-input:valid:checked~.custom-control-label:before{background-color:#34ce57}.custom-control-input.is-valid:focus~.custom-control-label:before,.was-validated .custom-control-input:valid:focus~.custom-control-label:before{box-shadow:0 0 0 1px #f4f4f4,0 0 0 .2rem rgba(40,167,69,.25)}.custom-file-input.is-valid~.custom-file-label,.was-validated .custom-file-input:valid~.custom-file-label{border-color:#28a745}.custom-file-input.is-valid~.custom-file-label:before,.was-validated .custom-file-input:valid~.custom-file-label:before{border-color:inherit}.custom-file-input.is-valid~.valid-feedback,.custom-file-input.is-valid~.valid-tooltip,.was-validated .custom-file-input:valid~.valid-feedback,.was-validated .custom-file-input:valid~.valid-tooltip{display:block}.custom-file-input.is-valid:focus~.custom-file-label,.was-validated .custom-file-input:valid:focus~.custom-file-label{box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.invalid-feedback{display:none;width:100%;margin-top:.25rem;font-size:80%;color:#dc3545}.invalid-tooltip{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.5rem;margin-top:.1rem;font-size:.875rem;line-height:1;color:#fff;background-color:rgba(220,53,69,.8);border-radius:.2rem}.custom-select.is-invalid,.form-control.is-invalid,.was-validated .custom-select:invalid,.was-validated .form-control:invalid{border-color:#dc3545}.custom-select.is-invalid:focus,.form-control.is-invalid:focus,.was-validated .custom-select:invalid:focus,.was-validated .form-control:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.custom-select.is-invalid~.invalid-feedback,.custom-select.is-invalid~.invalid-tooltip,.form-control.is-invalid~.invalid-feedback,.form-control.is-invalid~.invalid-tooltip,.was-validated .custom-select:invalid~.invalid-feedback,.was-validated .custom-select:invalid~.invalid-tooltip,.was-validated .form-control:invalid~.invalid-feedback,.was-validated .form-control:invalid~.invalid-tooltip{display:block}.form-check-input.is-invalid~.form-check-label,.was-validated .form-check-input:invalid~.form-check-label{color:#dc3545}.form-check-input.is-invalid~.invalid-feedback,.form-check-input.is-invalid~.invalid-tooltip,.was-validated .form-check-input:invalid~.invalid-feedback,.was-validated .form-check-input:invalid~.invalid-tooltip{display:block}.custom-control-input.is-invalid~.custom-control-label,.was-validated .custom-control-input:invalid~.custom-control-label{color:#dc3545}.custom-control-input.is-invalid~.custom-control-label:before,.was-validated .custom-control-input:invalid~.custom-control-label:before{background-color:#efa2a9}.custom-control-input.is-invalid~.invalid-feedback,.custom-control-input.is-invalid~.invalid-tooltip,.was-validated .custom-control-input:invalid~.invalid-feedback,.was-validated .custom-control-input:invalid~.invalid-tooltip{display:block}.custom-control-input.is-invalid:checked~.custom-control-label:before,.was-validated .custom-control-input:invalid:checked~.custom-control-label:before{background-color:#e4606d}.custom-control-input.is-invalid:focus~.custom-control-label:before,.was-validated .custom-control-input:invalid:focus~.custom-control-label:before{box-shadow:0 0 0 1px #f4f4f4,0 0 0 .2rem rgba(220,53,69,.25)}.custom-file-input.is-invalid~.custom-file-label,.was-validated .custom-file-input:invalid~.custom-file-label{border-color:#dc3545}.custom-file-input.is-invalid~.custom-file-label:before,.was-validated .custom-file-input:invalid~.custom-file-label:before{border-color:inherit}.custom-file-input.is-invalid~.invalid-feedback,.custom-file-input.is-invalid~.invalid-tooltip,.was-validated .custom-file-input:invalid~.invalid-feedback,.was-validated .custom-file-input:invalid~.invalid-tooltip{display:block}.custom-file-input.is-invalid:focus~.custom-file-label,.was-validated .custom-file-input:invalid:focus~.custom-file-label{box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.form-inline{display:flex;flex-flow:row wrap;align-items:center}.form-inline .form-check{width:100%}@media (min-width:576px){.form-inline label{justify-content:center}.form-inline .form-group,.form-inline label{display:flex;align-items:center;margin-bottom:0}.form-inline .form-group{flex:0 0 auto;flex-flow:row wrap}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-plaintext{display:inline-block}.form-inline .input-group{width:auto}.form-inline .form-check{display:flex;align-items:center;justify-content:center;width:auto;padding-left:0}.form-inline .form-check-input{position:relative;margin-top:0;margin-right:.25rem;margin-left:0}.form-inline .custom-control{align-items:center;justify-content:center}.form-inline .custom-control-label{margin-bottom:0}}.btn{display:inline-block;font-weight:400;text-align:center;white-space:nowrap;vertical-align:middle;user-select:none;border:1px solid transparent;padding:.375rem .75rem;font-size:13px;line-height:1.2;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}.btn:focus,.btn:hover{text-decoration:none}.btn.focus,.btn:focus{outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.btn.disabled,.btn:disabled{opacity:.65;box-shadow:none}.btn:not(:disabled):not(.disabled){cursor:pointer}.btn:not(:disabled):not(.disabled).active,.btn:not(:disabled):not(.disabled):active{background-image:none;box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn:not(:disabled):not(.disabled).active:focus,.btn:not(:disabled):not(.disabled):active:focus{box-shadow:0 0 0 .2rem rgba(0,123,255,.25),inset 0 3px 5px rgba(0,0,0,.125)}a.btn.disabled,fieldset:disabled a.btn{pointer-events:none}.btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.btn-primary.focus,.btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.btn-primary.disabled,.btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.btn-primary:not(:disabled):not(.disabled).active,.btn-primary:not(:disabled):not(.disabled):active,.show>.btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.btn-primary:not(:disabled):not(.disabled).active:focus,.btn-primary:not(:disabled):not(.disabled):active:focus,.show>.btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.btn-secondary{color:#fff;background-color:#e91e63;border-color:#e91e63;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.btn-secondary.focus,.btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.btn-secondary.disabled,.btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.btn-secondary:not(:disabled):not(.disabled).active,.btn-secondary:not(:disabled):not(.disabled):active,.show>.btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.btn-secondary:not(:disabled):not(.disabled).active:focus,.btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.btn-success.focus,.btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.btn-success.disabled,.btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.btn-success:not(:disabled):not(.disabled).active,.btn-success:not(:disabled):not(.disabled):active,.show>.btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.btn-success:not(:disabled):not(.disabled).active:focus,.btn-success:not(:disabled):not(.disabled):active:focus,.show>.btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.btn-info.focus,.btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.btn-info.disabled,.btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.btn-info:not(:disabled):not(.disabled).active,.btn-info:not(:disabled):not(.disabled):active,.show>.btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.btn-info:not(:disabled):not(.disabled).active:focus,.btn-info:not(:disabled):not(.disabled):active:focus,.show>.btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.btn-warning.focus,.btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.btn-warning.disabled,.btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.btn-warning:not(:disabled):not(.disabled).active,.btn-warning:not(:disabled):not(.disabled):active,.show>.btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.btn-warning:not(:disabled):not(.disabled).active:focus,.btn-warning:not(:disabled):not(.disabled):active:focus,.show>.btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.btn-danger.focus,.btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.btn-danger.disabled,.btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.btn-danger:not(:disabled):not(.disabled).active,.btn-danger:not(:disabled):not(.disabled):active,.show>.btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.btn-danger:not(:disabled):not(.disabled).active:focus,.btn-danger:not(:disabled):not(.disabled):active:focus,.show>.btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.btn-light.focus,.btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.btn-light.disabled,.btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.btn-light:not(:disabled):not(.disabled).active,.btn-light:not(:disabled):not(.disabled):active,.show>.btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.btn-light:not(:disabled):not(.disabled).active:focus,.btn-light:not(:disabled):not(.disabled):active:focus,.show>.btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.btn-dark.focus,.btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.btn-dark.disabled,.btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.btn-dark:not(:disabled):not(.disabled).active,.btn-dark:not(:disabled):not(.disabled):active,.show>.btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.btn-dark:not(:disabled):not(.disabled).active:focus,.btn-dark:not(:disabled):not(.disabled):active:focus,.show>.btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.btn-outline-primary.focus,.btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.btn-outline-primary.disabled,.btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.btn-outline-primary:not(:disabled):not(.disabled).active,.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.btn-outline-primary:not(:disabled):not(.disabled).active:focus,.btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.btn-outline-secondary.focus,.btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.btn-outline-secondary.disabled,.btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.btn-outline-secondary:not(:disabled):not(.disabled).active,.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.btn-outline-success.focus,.btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.btn-outline-success.disabled,.btn-outline-success:disabled{color:#4caf50;background-color:transparent}.btn-outline-success:not(:disabled):not(.disabled).active,.btn-outline-success:not(:disabled):not(.disabled):active,.show>.btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.btn-outline-success:not(:disabled):not(.disabled).active:focus,.btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.btn-outline-info.focus,.btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.btn-outline-info.disabled,.btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.btn-outline-info:not(:disabled):not(.disabled).active,.btn-outline-info:not(:disabled):not(.disabled):active,.show>.btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.btn-outline-info:not(:disabled):not(.disabled).active:focus,.btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.btn-outline-warning:hover{color:#212529;background-color:#ff9800;border-color:#ff9800}.btn-outline-warning.focus,.btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.btn-outline-warning.disabled,.btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.btn-outline-warning:not(:disabled):not(.disabled).active,.btn-outline-warning:not(:disabled):not(.disabled):active,.show>.btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.btn-outline-warning:not(:disabled):not(.disabled).active:focus,.btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.btn-outline-danger.focus,.btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.btn-outline-danger.disabled,.btn-outline-danger:disabled{color:#f44336;background-color:transparent}.btn-outline-danger:not(:disabled):not(.disabled).active,.btn-outline-danger:not(:disabled):not(.disabled):active,.show>.btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.btn-outline-danger:not(:disabled):not(.disabled).active:focus,.btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.btn-outline-light.focus,.btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.btn-outline-light.disabled,.btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.btn-outline-light:not(:disabled):not(.disabled).active,.btn-outline-light:not(:disabled):not(.disabled):active,.show>.btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.btn-outline-light:not(:disabled):not(.disabled).active:focus,.btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.btn-outline-dark.focus,.btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.btn-outline-dark.disabled,.btn-outline-dark:disabled{color:#343a40;background-color:transparent}.btn-outline-dark:not(:disabled):not(.disabled).active,.btn-outline-dark:not(:disabled):not(.disabled):active,.show>.btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.btn-outline-dark:not(:disabled):not(.disabled).active:focus,.btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.btn-link{font-weight:400;color:#3f51b5;background-color:transparent}.btn-link:hover{color:#32408f;background-color:transparent}.btn-link.focus,.btn-link:focus,.btn-link:hover{text-decoration:underline;border-color:transparent}.btn-link.focus,.btn-link:focus{box-shadow:none}.btn-link.disabled,.btn-link:disabled{color:#6c757d}.btn-group-lg>.btn,.btn-lg{padding:.5rem 1rem;font-size:17px;line-height:1.5;border-radius:.3rem}.btn-group-sm>.btn,.btn-sm{padding:.25rem .5rem;font-size:13px;line-height:1.5;border-radius:.2rem}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:.5rem}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;transition:opacity .15s linear}.fade.show{opacity:1}.collapse{display:none}.collapse.show{display:block}tr.collapse.show{display:table-row}tbody.collapse.show{display:table-row-group}.collapsing{height:0;overflow:hidden;transition:height .35s ease}.collapsing,.dropdown,.dropup{position:relative}.dropdown-toggle:after{display:inline-block;width:0;height:0;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid;border-right:.3em solid transparent;border-bottom:0;border-left:.3em solid transparent}.dropdown-toggle:empty:after{margin-left:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:10rem;padding:.5rem 0;margin:.125rem 0 0;font-size:13px;color:#5c5c5c;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.15);border-radius:.25rem;box-shadow:0 .5rem 1rem rgba(0,0,0,.175)}.dropup .dropdown-menu{margin-top:0;margin-bottom:.125rem}.dropup .dropdown-toggle:after{display:inline-block;width:0;height:0;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:0;border-right:.3em solid transparent;border-bottom:.3em solid;border-left:.3em solid transparent}.dropup .dropdown-toggle:empty:after{margin-left:0}.dropright .dropdown-menu{margin-top:0;margin-left:.125rem}.dropright .dropdown-toggle:after{display:inline-block;width:0;height:0;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-bottom:.3em solid transparent;border-left:.3em solid}.dropright .dropdown-toggle:empty:after{margin-left:0}.dropright .dropdown-toggle:after{vertical-align:0}.dropleft .dropdown-menu{margin-top:0;margin-right:.125rem}.dropleft .dropdown-toggle:after{display:inline-block;width:0;height:0;margin-left:.255em;vertical-align:.255em;content:\"\";display:none}.dropleft .dropdown-toggle:before{display:inline-block;width:0;height:0;margin-right:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:.3em solid;border-bottom:.3em solid transparent}.dropleft .dropdown-toggle:empty:after{margin-left:0}.dropleft .dropdown-toggle:before{vertical-align:0}.dropdown-divider{height:0;margin:.5rem 0;overflow:hidden;border-top:1px solid #e9ecef}.dropdown-item{display:block;width:100%;padding:.25rem 1.5rem;clear:both;font-weight:400;color:#212529;text-align:inherit;white-space:nowrap;background-color:transparent;border:0}.dropdown-item:focus,.dropdown-item:hover{color:#16181b;text-decoration:none;background-color:#f8f9fa}.dropdown-item.active,.dropdown-item:active{color:#fff;text-decoration:none;background-color:#007bff}.dropdown-item.disabled,.dropdown-item:disabled{color:#6c757d;background-color:transparent}.dropdown-menu.show{display:block}.dropdown-header{display:block;padding:.5rem 1.5rem;margin-bottom:0;font-size:13px;color:#6c757d;white-space:nowrap}.btn-group,.btn-group-vertical{position:relative;display:inline-flex;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;flex:0 1 auto}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:1}.btn-group-vertical .btn+.btn,.btn-group-vertical .btn+.btn-group,.btn-group-vertical .btn-group+.btn,.btn-group-vertical .btn-group+.btn-group,.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{display:flex;flex-wrap:wrap;justify-content:flex-start}.btn-toolbar .input-group{width:auto}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn-group:not(:last-child)>.btn,.btn-group>.btn:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:not(:first-child)>.btn,.btn-group>.btn:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.dropdown-toggle-split{padding-right:.5625rem;padding-left:.5625rem}.dropdown-toggle-split:after{margin-left:0}.btn-group-sm>.btn+.dropdown-toggle-split,.btn-sm+.dropdown-toggle-split{padding-right:.375rem;padding-left:.375rem}.btn-group-lg>.btn+.dropdown-toggle-split,.btn-lg+.dropdown-toggle-split{padding-right:.75rem;padding-left:.75rem}.btn-group.show .dropdown-toggle{box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.show .dropdown-toggle.btn-link{box-shadow:none}.btn-group-vertical{flex-direction:column;align-items:flex-start;justify-content:center}.btn-group-vertical .btn,.btn-group-vertical .btn-group{width:100%}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn-group:not(:last-child)>.btn,.btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:not(:first-child)>.btn,.btn-group-vertical>.btn:not(:first-child){border-top-left-radius:0;border-top-right-radius:0}.btn-group-toggle>.btn,.btn-group-toggle>.btn-group>.btn{margin-bottom:0}.btn-group-toggle>.btn-group>.btn input[type=checkbox],.btn-group-toggle>.btn-group>.btn input[type=radio],.btn-group-toggle>.btn input[type=checkbox],.btn-group-toggle>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:flex;flex-wrap:wrap;align-items:stretch;width:100%}.input-group>.custom-file,.input-group>.custom-select,.input-group>.form-control{position:relative;flex:1 1 auto;width:1%;margin-bottom:0}.input-group>.custom-file:focus,.input-group>.custom-select:focus,.input-group>.form-control:focus{z-index:3}.input-group>.custom-file+.custom-file,.input-group>.custom-file+.custom-select,.input-group>.custom-file+.form-control,.input-group>.custom-select+.custom-file,.input-group>.custom-select+.custom-select,.input-group>.custom-select+.form-control,.input-group>.form-control+.custom-file,.input-group>.form-control+.custom-select,.input-group>.form-control+.form-control{margin-left:-1px}.input-group>.custom-select:not(:last-child),.input-group>.form-control:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.input-group>.custom-select:not(:first-child),.input-group>.form-control:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.input-group>.custom-file{display:flex;align-items:center}.input-group>.custom-file:not(:last-child) .custom-file-label,.input-group>.custom-file:not(:last-child) .custom-file-label:before{border-top-right-radius:0;border-bottom-right-radius:0}.input-group>.custom-file:not(:first-child) .custom-file-label,.input-group>.custom-file:not(:first-child) .custom-file-label:before{border-top-left-radius:0;border-bottom-left-radius:0}.input-group-append,.input-group-prepend{display:flex}.input-group-append .btn,.input-group-prepend .btn{position:relative;z-index:2}.input-group-append .btn+.btn,.input-group-append .btn+.input-group-text,.input-group-append .input-group-text+.btn,.input-group-append .input-group-text+.input-group-text,.input-group-prepend .btn+.btn,.input-group-prepend .btn+.input-group-text,.input-group-prepend .input-group-text+.btn,.input-group-prepend .input-group-text+.input-group-text{margin-left:-1px}.input-group-prepend{margin-right:-1px}.input-group-append{margin-left:-1px}.input-group-text{display:flex;align-items:center;padding:.375rem .75rem;margin-bottom:0;font-size:13px;font-weight:400;line-height:1.5;color:#495057;text-align:center;white-space:nowrap;background-color:#e9ecef;border:1px solid #ced4da;border-radius:.25rem}.input-group-text input[type=checkbox],.input-group-text input[type=radio]{margin-top:0}.input-group>.input-group-append:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group>.input-group-append:last-child>.input-group-text:not(:last-child),.input-group>.input-group-append:not(:last-child)>.btn,.input-group>.input-group-append:not(:last-child)>.input-group-text,.input-group>.input-group-prepend>.btn,.input-group>.input-group-prepend>.input-group-text{border-top-right-radius:0;border-bottom-right-radius:0}.input-group>.input-group-append>.btn,.input-group>.input-group-append>.input-group-text,.input-group>.input-group-prepend:first-child>.btn:not(:first-child),.input-group>.input-group-prepend:first-child>.input-group-text:not(:first-child),.input-group>.input-group-prepend:not(:first-child)>.btn,.input-group>.input-group-prepend:not(:first-child)>.input-group-text{border-top-left-radius:0;border-bottom-left-radius:0}.custom-control{position:relative;display:block;min-height:1.5rem;padding-left:1.5rem}.custom-control-inline{display:inline-flex;margin-right:1rem}.custom-control-input{position:absolute;z-index:-1;opacity:0}.custom-control-input:checked~.custom-control-label:before{color:#fff;background-color:#007bff;box-shadow:none}.custom-control-input:focus~.custom-control-label:before{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,.25)}.custom-control-input:active~.custom-control-label:before{color:#fff;background-color:#b3d7ff;box-shadow:none}.custom-control-input:disabled~.custom-control-label{color:#6c757d}.custom-control-input:disabled~.custom-control-label:before{background-color:#e9ecef}.custom-control-label{margin-bottom:0}.custom-control-label:before{pointer-events:none;user-select:none;background-color:#dee2e6;box-shadow:inset 0 .25rem .25rem rgba(0,0,0,.1)}.custom-control-label:after,.custom-control-label:before{position:absolute;top:.25rem;left:0;display:block;width:1rem;height:1rem;content:\"\"}.custom-control-label:after{background-repeat:no-repeat;background-position:50%;background-size:50% 50%}.custom-checkbox .custom-control-label:before{border-radius:.25rem}.custom-checkbox .custom-control-input:checked~.custom-control-label:before{background-color:#007bff}.custom-checkbox .custom-control-input:checked~.custom-control-label:after{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E\")}.custom-checkbox .custom-control-input:indeterminate~.custom-control-label:before{background-color:#007bff;box-shadow:none}.custom-checkbox .custom-control-input:indeterminate~.custom-control-label:after{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 4'%3E%3Cpath stroke='%23fff' d='M0 2h4'/%3E%3C/svg%3E\")}.custom-checkbox .custom-control-input:disabled:checked~.custom-control-label:before{background-color:rgba(0,123,255,.5)}.custom-checkbox .custom-control-input:disabled:indeterminate~.custom-control-label:before{background-color:rgba(0,123,255,.5)}.custom-radio .custom-control-label:before{border-radius:50%}.custom-radio .custom-control-input:checked~.custom-control-label:before{background-color:#007bff}.custom-radio .custom-control-input:checked~.custom-control-label:after{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%23fff'/%3E%3C/svg%3E\")}.custom-radio .custom-control-input:disabled:checked~.custom-control-label:before{background-color:rgba(0,123,255,.5)}.custom-select{display:inline-block;width:100%;height:calc(2.25rem + 2px);padding:.375rem 1.75rem .375rem .75rem;line-height:1.5;color:#495057;vertical-align:middle;background:#fff url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E\") no-repeat right .75rem center;background-size:8px 10px;border:1px solid #ced4da;border-radius:.25rem;appearance:none}.custom-select:focus{border-color:#80bdff;outline:0;box-shadow:inset 0 1px 2px rgba(0,0,0,.075),0 0 5px rgba(128,189,255,.5)}.custom-select:focus::-ms-value{color:#495057;background-color:#fff}.custom-select[multiple],.custom-select[size]:not([size=\"1\"]){height:auto;padding-right:.75rem;background-image:none}.custom-select:disabled{color:#6c757d;background-color:#e9ecef}.custom-select::-ms-expand{opacity:0}.custom-select-sm{height:calc(1.8125rem + 2px);font-size:75%}.custom-select-lg,.custom-select-sm{padding-top:.375rem;padding-bottom:.375rem}.custom-select-lg{height:calc(2.875rem + 2px);font-size:125%}.custom-file{display:inline-block;margin-bottom:0}.custom-file,.custom-file-input{position:relative;width:100%;height:calc(2.25rem + 2px)}.custom-file-input{z-index:2;margin:0;opacity:0}.custom-file-input:focus~.custom-file-control{border-color:#80bdff;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.custom-file-input:focus~.custom-file-control:before{border-color:#80bdff}.custom-file-input:lang(en)~.custom-file-label:after{content:\"Browse\"}.custom-file-label{left:0;z-index:1;height:calc(2.25rem + 2px);background-color:#fff;border:1px solid #ced4da;border-radius:.25rem;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.custom-file-label,.custom-file-label:after{position:absolute;top:0;right:0;padding:.375rem .75rem;line-height:1.5;color:#495057}.custom-file-label:after{bottom:0;z-index:3;display:block;height:calc((2.25rem + 2px) - 1px * 2);content:\"Browse\";background-color:#e9ecef;border-left:1px solid #ced4da;border-radius:0 .25rem .25rem 0}.nav{display:flex;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none}.nav-link{display:block;padding:.5rem 1rem}.nav-link:focus,.nav-link:hover{text-decoration:none}.nav-link.disabled{color:#6c757d}.nav-tabs{border-bottom:1px solid #dee2e6}.nav-tabs .nav-item{margin-bottom:-1px}.nav-tabs .nav-link{border:1px solid transparent;border-top-left-radius:.25rem;border-top-right-radius:.25rem}.nav-tabs .nav-link:focus,.nav-tabs .nav-link:hover{border-color:#e9ecef #e9ecef #dee2e6}.nav-tabs .nav-link.disabled{color:#6c757d;background-color:transparent;border-color:transparent}.nav-tabs .nav-item.show .nav-link,.nav-tabs .nav-link.active{color:#495057;background-color:#fff;border-color:#dee2e6 #dee2e6 #fff}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.nav-pills .nav-link{border-radius:.25rem}.nav-pills .nav-link.active,.nav-pills .show>.nav-link{color:#fff;background-color:#007bff}.nav-fill .nav-item{flex:1 1 auto;text-align:center}.nav-justified .nav-item{flex-basis:0;flex-grow:1;text-align:center}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.navbar{position:relative;padding:.5rem 1rem}.navbar,.navbar>.container,.navbar>.container-fluid{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between}.navbar-brand{display:inline-block;padding-top:.3125rem;padding-bottom:.3125rem;margin-right:1rem;font-size:1.25rem;line-height:inherit;white-space:nowrap}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-nav{display:flex;flex-direction:column;padding-left:0;margin-bottom:0;list-style:none}.navbar-nav .nav-link{padding-right:0;padding-left:0}.navbar-nav .dropdown-menu{position:static;float:none}.navbar-text{display:inline-block;padding-top:.5rem;padding-bottom:.5rem}.navbar-collapse{flex-basis:100%;flex-grow:1;align-items:center}.navbar-toggler{padding:.25rem .75rem;font-size:1.25rem;line-height:1;background-color:transparent;border:1px solid transparent;border-radius:.25rem}.navbar-toggler:focus,.navbar-toggler:hover{text-decoration:none}.navbar-toggler:not(:disabled):not(.disabled){cursor:pointer}.navbar-toggler-icon{display:inline-block;width:1.5em;height:1.5em;vertical-align:middle;content:\"\";background:no-repeat 50%;background-size:100% 100%}@media (max-width:575.98px){.navbar-expand-sm>.container,.navbar-expand-sm>.container-fluid{padding-right:0;padding-left:0}}@media (min-width:576px){.navbar-expand-sm{flex-flow:row nowrap;justify-content:flex-start}.navbar-expand-sm .navbar-nav{flex-direction:row}.navbar-expand-sm .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-sm .navbar-nav .dropdown-menu-right{right:0;left:auto}.navbar-expand-sm .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-sm>.container,.navbar-expand-sm>.container-fluid{flex-wrap:nowrap}.navbar-expand-sm .navbar-collapse{display:flex!important;flex-basis:auto}.navbar-expand-sm .navbar-toggler{display:none}.navbar-expand-sm .dropup .dropdown-menu{top:auto;bottom:100%}}@media (max-width:767.98px){.navbar-expand-md>.container,.navbar-expand-md>.container-fluid{padding-right:0;padding-left:0}}@media (min-width:768px){.navbar-expand-md{flex-flow:row nowrap;justify-content:flex-start}.navbar-expand-md .navbar-nav{flex-direction:row}.navbar-expand-md .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-md .navbar-nav .dropdown-menu-right{right:0;left:auto}.navbar-expand-md .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-md>.container,.navbar-expand-md>.container-fluid{flex-wrap:nowrap}.navbar-expand-md .navbar-collapse{display:flex!important;flex-basis:auto}.navbar-expand-md .navbar-toggler{display:none}.navbar-expand-md .dropup .dropdown-menu{top:auto;bottom:100%}}@media (max-width:991.98px){.navbar-expand-lg>.container,.navbar-expand-lg>.container-fluid{padding-right:0;padding-left:0}}@media (min-width:992px){.navbar-expand-lg{flex-flow:row nowrap;justify-content:flex-start}.navbar-expand-lg .navbar-nav{flex-direction:row}.navbar-expand-lg .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-lg .navbar-nav .dropdown-menu-right{right:0;left:auto}.navbar-expand-lg .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-lg>.container,.navbar-expand-lg>.container-fluid{flex-wrap:nowrap}.navbar-expand-lg .navbar-collapse{display:flex!important;flex-basis:auto}.navbar-expand-lg .navbar-toggler{display:none}.navbar-expand-lg .dropup .dropdown-menu{top:auto;bottom:100%}}@media (max-width:1199.98px){.navbar-expand-xl>.container,.navbar-expand-xl>.container-fluid{padding-right:0;padding-left:0}}@media (min-width:1200px){.navbar-expand-xl{flex-flow:row nowrap;justify-content:flex-start}.navbar-expand-xl .navbar-nav{flex-direction:row}.navbar-expand-xl .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-xl .navbar-nav .dropdown-menu-right{right:0;left:auto}.navbar-expand-xl .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-xl>.container,.navbar-expand-xl>.container-fluid{flex-wrap:nowrap}.navbar-expand-xl .navbar-collapse{display:flex!important;flex-basis:auto}.navbar-expand-xl .navbar-toggler{display:none}.navbar-expand-xl .dropup .dropdown-menu{top:auto;bottom:100%}}.navbar-expand{flex-flow:row nowrap;justify-content:flex-start}.navbar-expand>.container,.navbar-expand>.container-fluid{padding-right:0;padding-left:0}.navbar-expand .navbar-nav{flex-direction:row}.navbar-expand .navbar-nav .dropdown-menu{position:absolute}.navbar-expand .navbar-nav .dropdown-menu-right{right:0;left:auto}.navbar-expand .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand>.container,.navbar-expand>.container-fluid{flex-wrap:nowrap}.navbar-expand .navbar-collapse{display:flex!important;flex-basis:auto}.navbar-expand .navbar-toggler{display:none}.navbar-expand .dropup .dropdown-menu{top:auto;bottom:100%}.navbar-light .navbar-brand,.navbar-light .navbar-brand:focus,.navbar-light .navbar-brand:hover{color:rgba(0,0,0,.9)}.navbar-light .navbar-nav .nav-link{color:rgba(0,0,0,.5)}.navbar-light .navbar-nav .nav-link:focus,.navbar-light .navbar-nav .nav-link:hover{color:rgba(0,0,0,.7)}.navbar-light .navbar-nav .nav-link.disabled{color:rgba(0,0,0,.3)}.navbar-light .navbar-nav .active>.nav-link,.navbar-light .navbar-nav .nav-link.active,.navbar-light .navbar-nav .nav-link.show,.navbar-light .navbar-nav .show>.nav-link{color:rgba(0,0,0,.9)}.navbar-light .navbar-toggler{color:rgba(0,0,0,.5);border-color:rgba(0,0,0,.1)}.navbar-light .navbar-toggler-icon{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(0,0,0,0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\")}.navbar-light .navbar-text{color:rgba(0,0,0,.5)}.navbar-light .navbar-text a,.navbar-light .navbar-text a:focus,.navbar-light .navbar-text a:hover{color:rgba(0,0,0,.9)}.navbar-dark .navbar-brand,.navbar-dark .navbar-brand:focus,.navbar-dark .navbar-brand:hover{color:#fff}.navbar-dark .navbar-nav .nav-link{color:hsla(0,0%,100%,.5)}.navbar-dark .navbar-nav .nav-link:focus,.navbar-dark .navbar-nav .nav-link:hover{color:hsla(0,0%,100%,.75)}.navbar-dark .navbar-nav .nav-link.disabled{color:hsla(0,0%,100%,.25)}.navbar-dark .navbar-nav .active>.nav-link,.navbar-dark .navbar-nav .nav-link.active,.navbar-dark .navbar-nav .nav-link.show,.navbar-dark .navbar-nav .show>.nav-link{color:#fff}.navbar-dark .navbar-toggler{color:hsla(0,0%,100%,.5);border-color:hsla(0,0%,100%,.1)}.navbar-dark .navbar-toggler-icon{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255,255,255,0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\")}.navbar-dark .navbar-text{color:hsla(0,0%,100%,.5)}.navbar-dark .navbar-text a,.navbar-dark .navbar-text a:focus,.navbar-dark .navbar-text a:hover{color:#fff}.card{position:relative;display:flex;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;background-clip:border-box;border:1px solid #dee2e6;border-radius:8px}.card>hr{margin-right:0;margin-left:0}.card>.list-group:first-child .list-group-item:first-child{border-top-left-radius:8px;border-top-right-radius:8px}.card>.list-group:last-child .list-group-item:last-child{border-bottom-right-radius:8px;border-bottom-left-radius:8px}.card-body{flex:1 1 auto;padding:30px}.card-title{margin-bottom:24px}.card-subtitle{margin-top:-12px}.card-subtitle,.card-text:last-child{margin-bottom:0}.card-link:hover{text-decoration:none}.card-link+.card-link{margin-left:30px}.card-header{padding:24px 30px;margin-bottom:0;background-color:rgba(0,0,0,.03);border-bottom:1px solid #dee2e6}.card-header:first-child{border-radius:8px 8px 0 0}.card-header+.list-group .list-group-item:first-child{border-top:0}.card-footer{padding:24px 30px;background-color:rgba(0,0,0,.03);border-top:1px solid #dee2e6}.card-footer:last-child{border-radius:0 0 8px 8px}.card-header-tabs{margin-bottom:-24px;border-bottom:0}.card-header-pills,.card-header-tabs{margin-right:-15px;margin-left:-15px}.card-img-overlay{position:absolute;top:0;right:0;bottom:0;left:0;padding:1.25rem}.card-img{width:100%;border-radius:8px}.card-img-top{width:100%;border-top-left-radius:8px;border-top-right-radius:8px}.card-img-bottom{width:100%;border-bottom-right-radius:8px;border-bottom-left-radius:8px}.card-deck{display:flex;flex-direction:column}.card-deck .card{margin-bottom:15px}@media (min-width:576px){.card-deck{flex-flow:row wrap;margin-right:-15px;margin-left:-15px}.card-deck .card{display:flex;flex:1 0 0%;flex-direction:column;margin-right:15px;margin-bottom:0;margin-left:15px}}.card-group{display:flex;flex-direction:column}.card-group>.card{margin-bottom:15px}@media (min-width:576px){.card-group{flex-flow:row wrap}.card-group>.card{flex:1 0 0%;margin-bottom:0}.card-group>.card+.card{margin-left:0;border-left:0}.card-group>.card:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.card-group>.card:first-child .card-header,.card-group>.card:first-child .card-img-top{border-top-right-radius:0}.card-group>.card:first-child .card-footer,.card-group>.card:first-child .card-img-bottom{border-bottom-right-radius:0}.card-group>.card:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.card-group>.card:last-child .card-header,.card-group>.card:last-child .card-img-top{border-top-left-radius:0}.card-group>.card:last-child .card-footer,.card-group>.card:last-child .card-img-bottom{border-bottom-left-radius:0}.card-group>.card:only-child{border-radius:8px}.card-group>.card:only-child .card-header,.card-group>.card:only-child .card-img-top{border-top-left-radius:8px;border-top-right-radius:8px}.card-group>.card:only-child .card-footer,.card-group>.card:only-child .card-img-bottom{border-bottom-right-radius:8px;border-bottom-left-radius:8px}.card-group>.card:not(:first-child):not(:last-child):not(:only-child),.card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-footer,.card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-header,.card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-img-bottom,.card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-img-top{border-radius:0}}.card-columns .card{margin-bottom:.75rem}@media (min-width:576px){.card-columns{column-count:3;column-gap:1.25rem}.card-columns .card{display:inline-block;width:100%}}.breadcrumb{display:flex;flex-wrap:wrap;padding:.75rem 1rem;margin-bottom:1rem;list-style:none;background-color:#e9ecef;border-radius:4px}.breadcrumb-item+.breadcrumb-item:before{display:inline-block;padding-right:.5rem;padding-left:.5rem;color:#6c757d;content:\"/\"}.breadcrumb-item+.breadcrumb-item:hover:before{text-decoration:underline;text-decoration:none}.breadcrumb-item.active{color:#6c757d}.pagination{display:flex;padding-left:0;list-style:none;border-radius:4px}.page-link{position:relative;display:block;padding:.5rem .75rem;margin-left:-1px;line-height:1.25;color:#007bff;background-color:#fff;border:1px solid #dee2e6}.page-link:hover{color:#0056b3;text-decoration:none;background-color:#e9ecef;border-color:#dee2e6}.page-link:focus{z-index:2;outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.page-link:not(:disabled):not(.disabled){cursor:pointer}.page-item:first-child .page-link{margin-left:0;border-top-left-radius:4px;border-bottom-left-radius:4px}.page-item:last-child .page-link{border-top-right-radius:4px;border-bottom-right-radius:4px}.page-item.active .page-link{z-index:1;color:#fff;background-color:#007bff;border-color:#007bff}.page-item.disabled .page-link{color:#6c757d;pointer-events:none;cursor:auto;background-color:#fff;border-color:#dee2e6}.pagination-lg .page-link{padding:.75rem 1.5rem;font-size:17px;line-height:1.5}.pagination-lg .page-item:first-child .page-link{border-top-left-radius:8px;border-bottom-left-radius:8px}.pagination-lg .page-item:last-child .page-link{border-top-right-radius:8px;border-bottom-right-radius:8px}.pagination-sm .page-link{padding:.25rem .5rem;font-size:13px;line-height:1.5}.pagination-sm .page-item:first-child .page-link{border-top-left-radius:2px;border-bottom-left-radius:2px}.pagination-sm .page-item:last-child .page-link{border-top-right-radius:2px;border-bottom-right-radius:2px}.badge{display:inline-block;padding:.25em .4em;font-size:75%;font-weight:700;line-height:1;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25rem}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.badge-pill{padding-right:.6em;padding-left:.6em;border-radius:10rem}.badge-primary{color:#fff;background-color:#3f51b5}.badge-primary[href]:focus,.badge-primary[href]:hover{color:#fff;text-decoration:none;background-color:#32408f}.badge-secondary{color:#fff;background-color:#e91e63}.badge-secondary[href]:focus,.badge-secondary[href]:hover{color:#fff;text-decoration:none;background-color:#c1134e}.badge-success{color:#fff;background-color:#4caf50}.badge-success[href]:focus,.badge-success[href]:hover{color:#fff;text-decoration:none;background-color:#3d8b40}.badge-info{color:#fff;background-color:#00bcd4}.badge-info[href]:focus,.badge-info[href]:hover{color:#fff;text-decoration:none;background-color:#008fa1}.badge-warning{color:#212529;background-color:#ff9800}.badge-warning[href]:focus,.badge-warning[href]:hover{color:#212529;text-decoration:none;background-color:#cc7a00}.badge-danger{color:#fff;background-color:#f44336}.badge-danger[href]:focus,.badge-danger[href]:hover{color:#fff;text-decoration:none;background-color:#ea1c0d}.badge-light{color:#212529;background-color:#e8eaf6}.badge-light[href]:focus,.badge-light[href]:hover{color:#212529;text-decoration:none;background-color:#c3c9e8}.badge-dark{color:#fff;background-color:#343a40}.badge-dark[href]:focus,.badge-dark[href]:hover{color:#fff;text-decoration:none;background-color:#1d2124}.jumbotron{padding:2rem 1rem;margin-bottom:2rem;background-color:#e9ecef;border-radius:8px}@media (min-width:576px){.jumbotron{padding:4rem 2rem}}.jumbotron-fluid{padding-right:0;padding-left:0;border-radius:0}.alert{position:relative;padding:.75rem 1.25rem;margin-bottom:1rem;border:1px solid transparent;border-radius:.25rem}.alert-heading{color:inherit}.alert-link{font-weight:700}.alert-dismissible{padding-right:4rem}.alert-dismissible .close{position:absolute;top:0;right:0;padding:.75rem 1.25rem;color:inherit}.alert-primary{color:#212a5e;background-color:#d9dcf0;border-color:#c9ceea}.alert-primary hr{border-top-color:#b7bde3}.alert-primary .alert-link{color:#141938}.alert-secondary{color:#791033;background-color:#fbd2e0;border-color:#f9c0d3}.alert-secondary hr{border-top-color:#f7a9c3}.alert-secondary .alert-link{color:#4c0a20}.alert-success{color:#285b2a;background-color:#dbefdc;border-color:#cde9ce}.alert-success hr{border-top-color:#bbe1bd}.alert-success .alert-link{color:#18381a}.alert-info{color:#00626e;background-color:#ccf2f6;border-color:#b8ecf3}.alert-info hr{border-top-color:#a2e6ef}.alert-info .alert-link{color:#00353b}.alert-warning{color:#854f00;background-color:#ffeacc;border-color:#ffe2b8}.alert-warning hr{border-top-color:#ffd89f}.alert-warning .alert-link{color:#523100}.alert-danger{color:#7f231c;background-color:#fdd9d7;border-color:#fccac7}.alert-danger hr{border-top-color:#fbb3af}.alert-danger .alert-link{color:#551713}.alert-light{color:#797a80;background-color:#fafbfd;border-color:#f9f9fc}.alert-light hr{border-top-color:#e8e8f4}.alert-light .alert-link{color:#606166}.alert-dark{color:#1b1e21;background-color:#d6d8d9;border-color:#c6c8ca}.alert-dark hr{border-top-color:#b9bbbe}.alert-dark .alert-link{color:#040505}@keyframes progress-bar-stripes{0%{background-position:1rem 0}to{background-position:0 0}}.progress{display:flex;height:1rem;overflow:hidden;font-size:.75rem;background-color:#e9ecef;border-radius:.25rem;box-shadow:inset 0 .1rem .1rem rgba(0,0,0,.1)}.progress-bar{display:flex;flex-direction:column;justify-content:center;color:#fff;text-align:center;background-color:#007bff;transition:width .6s ease}.progress-bar-striped{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:1rem 1rem}.progress-bar-animated{animation:progress-bar-stripes 1s linear infinite}.media{display:flex;align-items:flex-start}.media-body{flex:1}.social-list-line:not(:last-child){padding-bottom:25px}.survey-list-line:not(:last-child){padding-bottom:1px}.list-group{display:flex;flex-direction:column;padding-left:0;margin-bottom:0}.list-group-item-action{width:100%;color:#495057;text-align:inherit}.list-group-item-action:focus,.list-group-item-action:hover{color:#495057;text-decoration:none;background-color:#f8f9fa}.list-group-item-action:active{color:#212529;background-color:#e9ecef}.list-group-item{position:relative;display:block;padding:.75rem 1.25rem;margin-bottom:-1px;background-color:#fff;border:1px solid rgba(0,0,0,.125)}.list-group-item:first-child{border-top-left-radius:8px;border-top-right-radius:8px}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:8px;border-bottom-left-radius:8px}.list-group-item:focus,.list-group-item:hover{z-index:1;text-decoration:none}.list-group-item.disabled,.list-group-item:disabled{color:#6c757d;background-color:#fff}.list-group-item.active{z-index:2;color:#fff;background-color:#007bff;border-color:#007bff}.list-group-flush .list-group-item{border-right:0;border-left:0;border-radius:0}.list-group-flush:first-child .list-group-item:first-child{border-top:0}.list-group-flush:last-child .list-group-item:last-child{border-bottom:0}.list-group-item-primary{color:#212a5e;background-color:#c9ceea}.list-group-item-primary.list-group-item-action:focus,.list-group-item-primary.list-group-item-action:hover{color:#212a5e;background-color:#b7bde3}.list-group-item-primary.list-group-item-action.active{color:#fff;background-color:#212a5e;border-color:#212a5e}.list-group-item-secondary{color:#791033;background-color:#f9c0d3}.list-group-item-secondary.list-group-item-action:focus,.list-group-item-secondary.list-group-item-action:hover{color:#791033;background-color:#f7a9c3}.list-group-item-secondary.list-group-item-action.active{color:#fff;background-color:#791033;border-color:#791033}.list-group-item-success{color:#285b2a;background-color:#cde9ce}.list-group-item-success.list-group-item-action:focus,.list-group-item-success.list-group-item-action:hover{color:#285b2a;background-color:#bbe1bd}.list-group-item-success.list-group-item-action.active{color:#fff;background-color:#285b2a;border-color:#285b2a}.list-group-item-info{color:#00626e;background-color:#b8ecf3}.list-group-item-info.list-group-item-action:focus,.list-group-item-info.list-group-item-action:hover{color:#00626e;background-color:#a2e6ef}.list-group-item-info.list-group-item-action.active{color:#fff;background-color:#00626e;border-color:#00626e}.list-group-item-warning{color:#854f00;background-color:#ffe2b8}.list-group-item-warning.list-group-item-action:focus,.list-group-item-warning.list-group-item-action:hover{color:#854f00;background-color:#ffd89f}.list-group-item-warning.list-group-item-action.active{color:#fff;background-color:#854f00;border-color:#854f00}.list-group-item-danger{color:#7f231c;background-color:#fccac7}.list-group-item-danger.list-group-item-action:focus,.list-group-item-danger.list-group-item-action:hover{color:#7f231c;background-color:#fbb3af}.list-group-item-danger.list-group-item-action.active{color:#fff;background-color:#7f231c;border-color:#7f231c}.list-group-item-light{color:#797a80;background-color:#f9f9fc}.list-group-item-light.list-group-item-action:focus,.list-group-item-light.list-group-item-action:hover{color:#797a80;background-color:#e8e8f4}.list-group-item-light.list-group-item-action.active{color:#fff;background-color:#797a80;border-color:#797a80}.list-group-item-dark{color:#1b1e21;background-color:#c6c8ca}.list-group-item-dark.list-group-item-action:focus,.list-group-item-dark.list-group-item-action:hover{color:#1b1e21;background-color:#b9bbbe}.list-group-item-dark.list-group-item-action.active{color:#fff;background-color:#1b1e21;border-color:#1b1e21}.close{float:right;font-size:1.5rem;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.5}.close:focus,.close:hover{color:#000;text-decoration:none;opacity:.75}.close:not(:disabled):not(.disabled){cursor:pointer}button.close{padding:0;background-color:transparent;border:0;-webkit-appearance:none}.modal,.modal-open{overflow:hidden}.modal{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;display:none;outline:0}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:.5rem;pointer-events:none}.modal.fade .modal-dialog{transition:transform .3s ease-out;transform:translateY(-25%)}.modal.show .modal-dialog{transform:translate(0)}.modal-dialog-centered{display:flex;align-items:center;min-height:calc(100% - 1rem)}.modal-content{position:relative;display:flex;flex-direction:column;width:100%;pointer-events:auto;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:8px;box-shadow:0 .25rem .5rem rgba(0,0,0,.5);outline:0}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop.show{opacity:.1}.modal-header{display:flex;align-items:flex-start;justify-content:space-between;padding:1rem;border-bottom:1px solid #e9ecef;border-top-left-radius:8px;border-top-right-radius:8px}.modal-header .close{padding:1rem;margin:-1rem -1rem -1rem auto}.modal-title{margin-bottom:0;line-height:1.5}.modal-body{position:relative;flex:1 1 auto;padding:1rem}.modal-footer{display:flex;align-items:center;justify-content:flex-end;padding:1rem;border-top:1px solid #e9ecef}.modal-footer>:not(:first-child){margin-left:.25rem}.modal-footer>:not(:last-child){margin-right:.25rem}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:576px){.modal-dialog{max-width:500px;margin:1.75rem auto}.modal-dialog-centered{min-height:calc(100% - 3.5rem)}.modal-content{box-shadow:0 .5rem 1rem rgba(0,0,0,.5)}.modal-sm{max-width:300px}}@media (min-width:992px){.modal-lg{max-width:800px}}.tooltip{position:absolute;z-index:1070;display:block;margin:0;font-family:Nunito Sans,sans-serif;font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;opacity:0}.tooltip.show{opacity:.9}.tooltip .arrow{position:absolute;display:block;width:.8rem;height:.4rem}.tooltip .arrow:before{position:absolute;content:\"\";border-color:transparent;border-style:solid}.bs-tooltip-auto[x-placement^=top],.bs-tooltip-top{padding:.4rem 0}.bs-tooltip-auto[x-placement^=top] .arrow,.bs-tooltip-top .arrow{bottom:0}.bs-tooltip-auto[x-placement^=top] .arrow:before,.bs-tooltip-top .arrow:before{top:0;border-width:.4rem .4rem 0;border-top-color:#000}.bs-tooltip-auto[x-placement^=right],.bs-tooltip-right{padding:0 .4rem}.bs-tooltip-auto[x-placement^=right] .arrow,.bs-tooltip-right .arrow{left:0;width:.4rem;height:.8rem}.bs-tooltip-auto[x-placement^=right] .arrow:before,.bs-tooltip-right .arrow:before{right:0;border-width:.4rem .4rem .4rem 0;border-right-color:#000}.bs-tooltip-auto[x-placement^=bottom],.bs-tooltip-bottom{padding:.4rem 0}.bs-tooltip-auto[x-placement^=bottom] .arrow,.bs-tooltip-bottom .arrow{top:0}.bs-tooltip-auto[x-placement^=bottom] .arrow:before,.bs-tooltip-bottom .arrow:before{bottom:0;border-width:0 .4rem .4rem;border-bottom-color:#000}.bs-tooltip-auto[x-placement^=left],.bs-tooltip-left{padding:0 .4rem}.bs-tooltip-auto[x-placement^=left] .arrow,.bs-tooltip-left .arrow{right:0;width:.4rem;height:.8rem}.bs-tooltip-auto[x-placement^=left] .arrow:before,.bs-tooltip-left .arrow:before{left:0;border-width:.4rem 0 .4rem .4rem;border-left-color:#000}.tooltip-inner{max-width:200px;padding:.25rem .5rem;color:#fff;text-align:center;background-color:#000;border-radius:.25rem}.popover{top:0;left:0;z-index:1060;max-width:276px;font-family:Nunito Sans,sans-serif;font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem;box-shadow:0 .25rem .5rem rgba(0,0,0,.2)}.popover,.popover .arrow{position:absolute;display:block}.popover .arrow{width:1rem;height:.5rem;margin:0 8px}.popover .arrow:after,.popover .arrow:before{position:absolute;display:block;content:\"\";border-color:transparent;border-style:solid}.bs-popover-auto[x-placement^=top],.bs-popover-top{margin-bottom:.5rem}.bs-popover-auto[x-placement^=top] .arrow,.bs-popover-top .arrow{bottom:calc((.5rem + 1px) * -1)}.bs-popover-auto[x-placement^=top] .arrow:after,.bs-popover-auto[x-placement^=top] .arrow:before,.bs-popover-top .arrow:after,.bs-popover-top .arrow:before{border-width:.5rem .5rem 0}.bs-popover-auto[x-placement^=top] .arrow:before,.bs-popover-top .arrow:before{bottom:0;border-top-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=top] .arrow:after,.bs-popover-top .arrow:after{bottom:1px;border-top-color:#fff}.bs-popover-auto[x-placement^=right],.bs-popover-right{margin-left:.5rem}.bs-popover-auto[x-placement^=right] .arrow,.bs-popover-right .arrow{left:calc((.5rem + 1px) * -1);width:.5rem;height:1rem;margin:8px 0}.bs-popover-auto[x-placement^=right] .arrow:after,.bs-popover-auto[x-placement^=right] .arrow:before,.bs-popover-right .arrow:after,.bs-popover-right .arrow:before{border-width:.5rem .5rem .5rem 0}.bs-popover-auto[x-placement^=right] .arrow:before,.bs-popover-right .arrow:before{left:0;border-right-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=right] .arrow:after,.bs-popover-right .arrow:after{left:1px;border-right-color:#fff}.bs-popover-auto[x-placement^=bottom],.bs-popover-bottom{margin-top:.5rem}.bs-popover-auto[x-placement^=bottom] .arrow,.bs-popover-bottom .arrow{top:calc((.5rem + 1px) * -1)}.bs-popover-auto[x-placement^=bottom] .arrow:after,.bs-popover-auto[x-placement^=bottom] .arrow:before,.bs-popover-bottom .arrow:after,.bs-popover-bottom .arrow:before{border-width:0 .5rem .5rem}.bs-popover-auto[x-placement^=bottom] .arrow:before,.bs-popover-bottom .arrow:before{top:0;border-bottom-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=bottom] .arrow:after,.bs-popover-bottom .arrow:after{top:1px;border-bottom-color:#fff}.bs-popover-auto[x-placement^=bottom] .popover-header:before,.bs-popover-bottom .popover-header:before{position:absolute;top:0;left:50%;display:block;width:1rem;margin-left:-.5rem;content:\"\";border-bottom:1px solid #f7f7f7}.bs-popover-auto[x-placement^=left],.bs-popover-left{margin-right:.5rem}.bs-popover-auto[x-placement^=left] .arrow,.bs-popover-left .arrow{right:calc((.5rem + 1px) * -1);width:.5rem;height:1rem;margin:8px 0}.bs-popover-auto[x-placement^=left] .arrow:after,.bs-popover-auto[x-placement^=left] .arrow:before,.bs-popover-left .arrow:after,.bs-popover-left .arrow:before{border-width:.5rem 0 .5rem .5rem}.bs-popover-auto[x-placement^=left] .arrow:before,.bs-popover-left .arrow:before{right:0;border-left-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=left] .arrow:after,.bs-popover-left .arrow:after{right:1px;border-left-color:#fff}.popover-header{padding:.5rem .75rem;margin-bottom:0;font-size:13px;color:inherit;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-top-left-radius:7px;border-top-right-radius:7px}.popover-header:empty{display:none}.popover-body{padding:.5rem .75rem;color:#212529}.carousel{position:relative}.carousel-inner{position:relative;width:100%;overflow:hidden}.carousel-item{position:relative;display:none;align-items:center;width:100%;transition:transform .6s ease;backface-visibility:hidden;perspective:1000px}.carousel-item-next,.carousel-item-prev,.carousel-item.active{display:block}.carousel-item-next,.carousel-item-prev{position:absolute;top:0}.carousel-item-next.carousel-item-left,.carousel-item-prev.carousel-item-right{transform:translateX(0)}@supports (transform-style:preserve-3d){.carousel-item-next.carousel-item-left,.carousel-item-prev.carousel-item-right{transform:translateZ(0)}}.active.carousel-item-right,.carousel-item-next{transform:translateX(100%)}@supports (transform-style:preserve-3d){.active.carousel-item-right,.carousel-item-next{transform:translate3d(100%,0,0)}}.active.carousel-item-left,.carousel-item-prev{transform:translateX(-100%)}@supports (transform-style:preserve-3d){.active.carousel-item-left,.carousel-item-prev{transform:translate3d(-100%,0,0)}}.carousel-control-next,.carousel-control-prev{position:absolute;top:0;bottom:0;display:flex;align-items:center;justify-content:center;width:15%;color:#fff;text-align:center;opacity:.5}.carousel-control-next:focus,.carousel-control-next:hover,.carousel-control-prev:focus,.carousel-control-prev:hover{color:#fff;text-decoration:none;outline:0;opacity:.9}.carousel-control-prev{left:0}.carousel-control-next{right:0}.carousel-control-next-icon,.carousel-control-prev-icon{display:inline-block;width:20px;height:20px;background:transparent no-repeat 50%;background-size:100% 100%}.carousel-control-prev-icon{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E\")}.carousel-control-next-icon{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3E%3Cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E\")}.carousel-indicators{position:absolute;right:0;bottom:10px;left:0;z-index:15;display:flex;justify-content:center;padding-left:0;margin-right:15%;margin-left:15%;list-style:none}.carousel-indicators li{position:relative;flex:0 1 auto;width:30px;height:3px;margin-right:3px;margin-left:3px;text-indent:-999px;background-color:hsla(0,0%,100%,.5)}.carousel-indicators li:before{top:-10px}.carousel-indicators li:after,.carousel-indicators li:before{position:absolute;left:0;display:inline-block;width:100%;height:10px;content:\"\"}.carousel-indicators li:after{bottom:-10px}.carousel-indicators .active{background-color:#fff}.carousel-caption{position:absolute;right:15%;bottom:20px;left:15%;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center}.align-baseline{vertical-align:baseline!important}.align-top{vertical-align:top!important}.align-middle{vertical-align:middle!important}.align-bottom{vertical-align:bottom!important}.align-text-bottom{vertical-align:text-bottom!important}.align-text-top{vertical-align:text-top!important}.bg-primary{background-color:#3f51b5!important}a.bg-primary:focus,a.bg-primary:hover,button.bg-primary:focus,button.bg-primary:hover{background-color:#32408f!important}.bg-secondary{background-color:#e91e63!important}a.bg-secondary:focus,a.bg-secondary:hover,button.bg-secondary:focus,button.bg-secondary:hover{background-color:#c1134e!important}.bg-success{background-color:#4caf50!important}a.bg-success:focus,a.bg-success:hover,button.bg-success:focus,button.bg-success:hover{background-color:#3d8b40!important}.bg-info{background-color:#00bcd4!important}a.bg-info:focus,a.bg-info:hover,button.bg-info:focus,button.bg-info:hover{background-color:#008fa1!important}.bg-warning{background-color:#ff9800!important}a.bg-warning:focus,a.bg-warning:hover,button.bg-warning:focus,button.bg-warning:hover{background-color:#cc7a00!important}.bg-danger{background-color:#f44336!important}a.bg-danger:focus,a.bg-danger:hover,button.bg-danger:focus,button.bg-danger:hover{background-color:#ea1c0d!important}.bg-light{background-color:#e8eaf6!important}a.bg-light:focus,a.bg-light:hover,button.bg-light:focus,button.bg-light:hover{background-color:#c3c9e8!important}.bg-dark{background-color:#343a40!important}a.bg-dark:focus,a.bg-dark:hover,button.bg-dark:focus,button.bg-dark:hover{background-color:#1d2124!important}.bg-white{background-color:#fff!important}.bg-transparent{background-color:transparent!important}.border{border:1px solid #dee2e6!important}.border-top{border-top:1px solid #dee2e6!important}.border-right{border-right:1px solid #dee2e6!important}.border-bottom{border-bottom:1px solid #dee2e6!important}.border-left{border-left:1px solid #dee2e6!important}.border-0{border:0!important}.border-top-0{border-top:0!important}.border-right-0{border-right:0!important}.border-bottom-0{border-bottom:0!important}.border-left-0{border-left:0!important}.border-primary{border-color:#3f51b5!important}.border-secondary{border-color:#e91e63!important}.border-success{border-color:#4caf50!important}.border-info{border-color:#00bcd4!important}.border-warning{border-color:#ff9800!important}.border-danger{border-color:#f44336!important}.border-light{border-color:#e8eaf6!important}.border-dark{border-color:#343a40!important}.border-white{border-color:#fff!important}.rounded{border-radius:4px!important}.rounded-top{border-top-left-radius:4px!important}.rounded-right,.rounded-top{border-top-right-radius:4px!important}.rounded-bottom,.rounded-right{border-bottom-right-radius:4px!important}.rounded-bottom,.rounded-left{border-bottom-left-radius:4px!important}.rounded-left{border-top-left-radius:4px!important}.rounded-circle{border-radius:50%!important}.rounded-0{border-radius:0!important}.clearfix:after{display:block;clear:both;content:\"\"}.d-none{display:none!important}.d-inline{display:inline!important}.d-inline-block{display:inline-block!important}.d-block{display:block!important}.d-table{display:table!important}.d-table-row{display:table-row!important}.d-table-cell{display:table-cell!important}.d-flex{display:flex!important}.d-inline-flex{display:inline-flex!important}@media (min-width:576px){.d-sm-none{display:none!important}.d-sm-inline{display:inline!important}.d-sm-inline-block{display:inline-block!important}.d-sm-block{display:block!important}.d-sm-table{display:table!important}.d-sm-table-row{display:table-row!important}.d-sm-table-cell{display:table-cell!important}.d-sm-flex{display:flex!important}.d-sm-inline-flex{display:inline-flex!important}}@media (min-width:768px){.d-md-none{display:none!important}.d-md-inline{display:inline!important}.d-md-inline-block{display:inline-block!important}.d-md-block{display:block!important}.d-md-table{display:table!important}.d-md-table-row{display:table-row!important}.d-md-table-cell{display:table-cell!important}.d-md-flex{display:flex!important}.d-md-inline-flex{display:inline-flex!important}}@media (min-width:992px){.d-lg-none{display:none!important}.d-lg-inline{display:inline!important}.d-lg-inline-block{display:inline-block!important}.d-lg-block{display:block!important}.d-lg-table{display:table!important}.d-lg-table-row{display:table-row!important}.d-lg-table-cell{display:table-cell!important}.d-lg-flex{display:flex!important}.d-lg-inline-flex{display:inline-flex!important}}@media (min-width:1200px){.d-xl-none{display:none!important}.d-xl-inline{display:inline!important}.d-xl-inline-block{display:inline-block!important}.d-xl-block{display:block!important}.d-xl-table{display:table!important}.d-xl-table-row{display:table-row!important}.d-xl-table-cell{display:table-cell!important}.d-xl-flex{display:flex!important}.d-xl-inline-flex{display:inline-flex!important}}@media print{.d-print-none{display:none!important}.d-print-inline{display:inline!important}.d-print-inline-block{display:inline-block!important}.d-print-block{display:block!important}.d-print-table{display:table!important}.d-print-table-row{display:table-row!important}.d-print-table-cell{display:table-cell!important}.d-print-flex{display:flex!important}.d-print-inline-flex{display:inline-flex!important}}.embed-responsive{position:relative;display:block;width:100%;padding:0;overflow:hidden}.embed-responsive:before{display:block;content:\"\"}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.embed-responsive-21by9:before{padding-top:42.85714%}.embed-responsive-16by9:before{padding-top:56.25%}.embed-responsive-4by3:before{padding-top:75%}.embed-responsive-1by1:before{padding-top:100%}.flex-row{flex-direction:row!important}.flex-column{flex-direction:column!important}.flex-row-reverse{flex-direction:row-reverse!important}.flex-column-reverse{flex-direction:column-reverse!important}.flex-wrap{flex-wrap:wrap!important}.flex-nowrap{flex-wrap:nowrap!important}.flex-wrap-reverse{flex-wrap:wrap-reverse!important}.justify-content-start{justify-content:flex-start!important}.justify-content-end{justify-content:flex-end!important}.justify-content-center{justify-content:center!important}.justify-content-between{justify-content:space-between!important}.justify-content-around{justify-content:space-around!important}.align-items-start{align-items:flex-start!important}.align-items-end{align-items:flex-end!important}.align-items-center{align-items:center!important}.align-items-baseline{align-items:baseline!important}.align-items-stretch{align-items:stretch!important}.align-content-start{align-content:flex-start!important}.align-content-end{align-content:flex-end!important}.align-content-center{align-content:center!important}.align-content-between{align-content:space-between!important}.align-content-around{align-content:space-around!important}.align-content-stretch{align-content:stretch!important}.align-self-auto{align-self:auto!important}.align-self-start{align-self:flex-start!important}.align-self-end{align-self:flex-end!important}.align-self-center{align-self:center!important}.align-self-baseline{align-self:baseline!important}.align-self-stretch{align-self:stretch!important}@media (min-width:576px){.flex-sm-row{flex-direction:row!important}.flex-sm-column{flex-direction:column!important}.flex-sm-row-reverse{flex-direction:row-reverse!important}.flex-sm-column-reverse{flex-direction:column-reverse!important}.flex-sm-wrap{flex-wrap:wrap!important}.flex-sm-nowrap{flex-wrap:nowrap!important}.flex-sm-wrap-reverse{flex-wrap:wrap-reverse!important}.justify-content-sm-start{justify-content:flex-start!important}.justify-content-sm-end{justify-content:flex-end!important}.justify-content-sm-center{justify-content:center!important}.justify-content-sm-between{justify-content:space-between!important}.justify-content-sm-around{justify-content:space-around!important}.align-items-sm-start{align-items:flex-start!important}.align-items-sm-end{align-items:flex-end!important}.align-items-sm-center{align-items:center!important}.align-items-sm-baseline{align-items:baseline!important}.align-items-sm-stretch{align-items:stretch!important}.align-content-sm-start{align-content:flex-start!important}.align-content-sm-end{align-content:flex-end!important}.align-content-sm-center{align-content:center!important}.align-content-sm-between{align-content:space-between!important}.align-content-sm-around{align-content:space-around!important}.align-content-sm-stretch{align-content:stretch!important}.align-self-sm-auto{align-self:auto!important}.align-self-sm-start{align-self:flex-start!important}.align-self-sm-end{align-self:flex-end!important}.align-self-sm-center{align-self:center!important}.align-self-sm-baseline{align-self:baseline!important}.align-self-sm-stretch{align-self:stretch!important}}@media (min-width:768px){.flex-md-row{flex-direction:row!important}.flex-md-column{flex-direction:column!important}.flex-md-row-reverse{flex-direction:row-reverse!important}.flex-md-column-reverse{flex-direction:column-reverse!important}.flex-md-wrap{flex-wrap:wrap!important}.flex-md-nowrap{flex-wrap:nowrap!important}.flex-md-wrap-reverse{flex-wrap:wrap-reverse!important}.justify-content-md-start{justify-content:flex-start!important}.justify-content-md-end{justify-content:flex-end!important}.justify-content-md-center{justify-content:center!important}.justify-content-md-between{justify-content:space-between!important}.justify-content-md-around{justify-content:space-around!important}.align-items-md-start{align-items:flex-start!important}.align-items-md-end{align-items:flex-end!important}.align-items-md-center{align-items:center!important}.align-items-md-baseline{align-items:baseline!important}.align-items-md-stretch{align-items:stretch!important}.align-content-md-start{align-content:flex-start!important}.align-content-md-end{align-content:flex-end!important}.align-content-md-center{align-content:center!important}.align-content-md-between{align-content:space-between!important}.align-content-md-around{align-content:space-around!important}.align-content-md-stretch{align-content:stretch!important}.align-self-md-auto{align-self:auto!important}.align-self-md-start{align-self:flex-start!important}.align-self-md-end{align-self:flex-end!important}.align-self-md-center{align-self:center!important}.align-self-md-baseline{align-self:baseline!important}.align-self-md-stretch{align-self:stretch!important}}@media (min-width:992px){.flex-lg-row{flex-direction:row!important}.flex-lg-column{flex-direction:column!important}.flex-lg-row-reverse{flex-direction:row-reverse!important}.flex-lg-column-reverse{flex-direction:column-reverse!important}.flex-lg-wrap{flex-wrap:wrap!important}.flex-lg-nowrap{flex-wrap:nowrap!important}.flex-lg-wrap-reverse{flex-wrap:wrap-reverse!important}.justify-content-lg-start{justify-content:flex-start!important}.justify-content-lg-end{justify-content:flex-end!important}.justify-content-lg-center{justify-content:center!important}.justify-content-lg-between{justify-content:space-between!important}.justify-content-lg-around{justify-content:space-around!important}.align-items-lg-start{align-items:flex-start!important}.align-items-lg-end{align-items:flex-end!important}.align-items-lg-center{align-items:center!important}.align-items-lg-baseline{align-items:baseline!important}.align-items-lg-stretch{align-items:stretch!important}.align-content-lg-start{align-content:flex-start!important}.align-content-lg-end{align-content:flex-end!important}.align-content-lg-center{align-content:center!important}.align-content-lg-between{align-content:space-between!important}.align-content-lg-around{align-content:space-around!important}.align-content-lg-stretch{align-content:stretch!important}.align-self-lg-auto{align-self:auto!important}.align-self-lg-start{align-self:flex-start!important}.align-self-lg-end{align-self:flex-end!important}.align-self-lg-center{align-self:center!important}.align-self-lg-baseline{align-self:baseline!important}.align-self-lg-stretch{align-self:stretch!important}}@media (min-width:1200px){.flex-xl-row{flex-direction:row!important}.flex-xl-column{flex-direction:column!important}.flex-xl-row-reverse{flex-direction:row-reverse!important}.flex-xl-column-reverse{flex-direction:column-reverse!important}.flex-xl-wrap{flex-wrap:wrap!important}.flex-xl-nowrap{flex-wrap:nowrap!important}.flex-xl-wrap-reverse{flex-wrap:wrap-reverse!important}.justify-content-xl-start{justify-content:flex-start!important}.justify-content-xl-end{justify-content:flex-end!important}.justify-content-xl-center{justify-content:center!important}.justify-content-xl-between{justify-content:space-between!important}.justify-content-xl-around{justify-content:space-around!important}.align-items-xl-start{align-items:flex-start!important}.align-items-xl-end{align-items:flex-end!important}.align-items-xl-center{align-items:center!important}.align-items-xl-baseline{align-items:baseline!important}.align-items-xl-stretch{align-items:stretch!important}.align-content-xl-start{align-content:flex-start!important}.align-content-xl-end{align-content:flex-end!important}.align-content-xl-center{align-content:center!important}.align-content-xl-between{align-content:space-between!important}.align-content-xl-around{align-content:space-around!important}.align-content-xl-stretch{align-content:stretch!important}.align-self-xl-auto{align-self:auto!important}.align-self-xl-start{align-self:flex-start!important}.align-self-xl-end{align-self:flex-end!important}.align-self-xl-center{align-self:center!important}.align-self-xl-baseline{align-self:baseline!important}.align-self-xl-stretch{align-self:stretch!important}}.float-left{float:left!important}.float-right{float:right!important}.float-none{float:none!important}@media (min-width:576px){.float-sm-left{float:left!important}.float-sm-right{float:right!important}.float-sm-none{float:none!important}}@media (min-width:768px){.float-md-left{float:left!important}.float-md-right{float:right!important}.float-md-none{float:none!important}}@media (min-width:992px){.float-lg-left{float:left!important}.float-lg-right{float:right!important}.float-lg-none{float:none!important}}@media (min-width:1200px){.float-xl-left{float:left!important}.float-xl-right{float:right!important}.float-xl-none{float:none!important}}.position-static{position:static!important}.position-relative{position:relative!important}.position-absolute{position:absolute!important}.position-fixed{position:fixed!important}.position-sticky{position:sticky!important}.fixed-top{top:0}.fixed-bottom,.fixed-top{position:fixed;right:0;left:0;z-index:1030}.fixed-bottom{bottom:0}@supports (position:sticky){.sticky-top{position:sticky;top:0;z-index:1020}}.sr-only{position:absolute;width:1px;height:1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;clip-path:inset(50%);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;overflow:visible;clip:auto;white-space:normal;clip-path:none}.w-25{width:25%!important}.w-50{width:50%!important}.w-75{width:75%!important}.w-100{width:100%!important}.h-25{height:25%!important}.h-50{height:50%!important}.h-75{height:75%!important}.h-100{height:100%!important}.mw-100{max-width:100%!important}.mh-100{max-height:100%!important}.m-0{margin:0!important}.mt-0,.my-0{margin-top:0!important}.mr-0,.mx-0{margin-right:0!important}.mb-0,.my-0{margin-bottom:0!important}.ml-0,.mx-0{margin-left:0!important}.m-1{margin:.25rem!important}.mt-1,.my-1{margin-top:.25rem!important}.mr-1,.mx-1{margin-right:.25rem!important}.mb-1,.my-1{margin-bottom:.25rem!important}.ml-1,.mx-1{margin-left:.25rem!important}.m-2{margin:.5rem!important}.mt-2,.my-2{margin-top:.5rem!important}.mr-2,.mx-2{margin-right:.5rem!important}.mb-2,.my-2{margin-bottom:.5rem!important}.ml-2,.mx-2{margin-left:.5rem!important}.m-3{margin:1rem!important}.mt-3,.my-3{margin-top:1rem!important}.mr-3,.mx-3{margin-right:1rem!important}.mb-3,.my-3{margin-bottom:1rem!important}.ml-3,.mx-3{margin-left:1rem!important}.m-4{margin:1.5rem!important}.mt-4,.my-4{margin-top:1.5rem!important}.mr-4,.mx-4{margin-right:1.5rem!important}.mb-4,.my-4{margin-bottom:1.5rem!important}.ml-4,.mx-4{margin-left:1.5rem!important}.m-5{margin:3rem!important}.mt-5,.my-5{margin-top:3rem!important}.mr-5,.mx-5{margin-right:3rem!important}.mb-5,.my-5{margin-bottom:3rem!important}.ml-5,.mx-5{margin-left:3rem!important}.p-0{padding:0!important}.pt-0,.py-0{padding-top:0!important}.pr-0,.px-0{padding-right:0!important}.pb-0,.py-0{padding-bottom:0!important}.pl-0,.px-0{padding-left:0!important}.p-1{padding:.25rem!important}.pt-1,.py-1{padding-top:.25rem!important}.pr-1,.px-1{padding-right:.25rem!important}.pb-1,.py-1{padding-bottom:.25rem!important}.pl-1,.px-1{padding-left:.25rem!important}.p-2{padding:.5rem!important}.pt-2,.py-2{padding-top:.5rem!important}.pr-2,.px-2{padding-right:.5rem!important}.pb-2,.py-2{padding-bottom:.5rem!important}.pl-2,.px-2{padding-left:.5rem!important}.p-3{padding:1rem!important}.pt-3,.py-3{padding-top:1rem!important}.pr-3,.px-3{padding-right:1rem!important}.pb-3,.py-3{padding-bottom:1rem!important}.pl-3,.px-3{padding-left:1rem!important}.p-4{padding:1.5rem!important}.pt-4,.py-4{padding-top:1.5rem!important}.pr-4,.px-4{padding-right:1.5rem!important}.pb-4,.py-4{padding-bottom:1.5rem!important}.pl-4,.px-4{padding-left:1.5rem!important}.p-5{padding:3rem!important}.pt-5,.py-5{padding-top:3rem!important}.pr-5,.px-5{padding-right:3rem!important}.pb-5,.py-5{padding-bottom:3rem!important}.pl-5,.px-5{padding-left:3rem!important}.m-auto{margin:auto!important}.mt-auto,.my-auto{margin-top:auto!important}.mr-auto,.mx-auto{margin-right:auto!important}.mb-auto,.my-auto{margin-bottom:auto!important}.ml-auto,.mx-auto{margin-left:auto!important}@media (min-width:576px){.m-sm-0{margin:0!important}.mt-sm-0,.my-sm-0{margin-top:0!important}.mr-sm-0,.mx-sm-0{margin-right:0!important}.mb-sm-0,.my-sm-0{margin-bottom:0!important}.ml-sm-0,.mx-sm-0{margin-left:0!important}.m-sm-1{margin:.25rem!important}.mt-sm-1,.my-sm-1{margin-top:.25rem!important}.mr-sm-1,.mx-sm-1{margin-right:.25rem!important}.mb-sm-1,.my-sm-1{margin-bottom:.25rem!important}.ml-sm-1,.mx-sm-1{margin-left:.25rem!important}.m-sm-2{margin:.5rem!important}.mt-sm-2,.my-sm-2{margin-top:.5rem!important}.mr-sm-2,.mx-sm-2{margin-right:.5rem!important}.mb-sm-2,.my-sm-2{margin-bottom:.5rem!important}.ml-sm-2,.mx-sm-2{margin-left:.5rem!important}.m-sm-3{margin:1rem!important}.mt-sm-3,.my-sm-3{margin-top:1rem!important}.mr-sm-3,.mx-sm-3{margin-right:1rem!important}.mb-sm-3,.my-sm-3{margin-bottom:1rem!important}.ml-sm-3,.mx-sm-3{margin-left:1rem!important}.m-sm-4{margin:1.5rem!important}.mt-sm-4,.my-sm-4{margin-top:1.5rem!important}.mr-sm-4,.mx-sm-4{margin-right:1.5rem!important}.mb-sm-4,.my-sm-4{margin-bottom:1.5rem!important}.ml-sm-4,.mx-sm-4{margin-left:1.5rem!important}.m-sm-5{margin:3rem!important}.mt-sm-5,.my-sm-5{margin-top:3rem!important}.mr-sm-5,.mx-sm-5{margin-right:3rem!important}.mb-sm-5,.my-sm-5{margin-bottom:3rem!important}.ml-sm-5,.mx-sm-5{margin-left:3rem!important}.p-sm-0{padding:0!important}.pt-sm-0,.py-sm-0{padding-top:0!important}.pr-sm-0,.px-sm-0{padding-right:0!important}.pb-sm-0,.py-sm-0{padding-bottom:0!important}.pl-sm-0,.px-sm-0{padding-left:0!important}.p-sm-1{padding:.25rem!important}.pt-sm-1,.py-sm-1{padding-top:.25rem!important}.pr-sm-1,.px-sm-1{padding-right:.25rem!important}.pb-sm-1,.py-sm-1{padding-bottom:.25rem!important}.pl-sm-1,.px-sm-1{padding-left:.25rem!important}.p-sm-2{padding:.5rem!important}.pt-sm-2,.py-sm-2{padding-top:.5rem!important}.pr-sm-2,.px-sm-2{padding-right:.5rem!important}.pb-sm-2,.py-sm-2{padding-bottom:.5rem!important}.pl-sm-2,.px-sm-2{padding-left:.5rem!important}.p-sm-3{padding:1rem!important}.pt-sm-3,.py-sm-3{padding-top:1rem!important}.pr-sm-3,.px-sm-3{padding-right:1rem!important}.pb-sm-3,.py-sm-3{padding-bottom:1rem!important}.pl-sm-3,.px-sm-3{padding-left:1rem!important}.p-sm-4{padding:1.5rem!important}.pt-sm-4,.py-sm-4{padding-top:1.5rem!important}.pr-sm-4,.px-sm-4{padding-right:1.5rem!important}.pb-sm-4,.py-sm-4{padding-bottom:1.5rem!important}.pl-sm-4,.px-sm-4{padding-left:1.5rem!important}.p-sm-5{padding:3rem!important}.pt-sm-5,.py-sm-5{padding-top:3rem!important}.pr-sm-5,.px-sm-5{padding-right:3rem!important}.pb-sm-5,.py-sm-5{padding-bottom:3rem!important}.pl-sm-5,.px-sm-5{padding-left:3rem!important}.m-sm-auto{margin:auto!important}.mt-sm-auto,.my-sm-auto{margin-top:auto!important}.mr-sm-auto,.mx-sm-auto{margin-right:auto!important}.mb-sm-auto,.my-sm-auto{margin-bottom:auto!important}.ml-sm-auto,.mx-sm-auto{margin-left:auto!important}}@media (min-width:768px){.m-md-0{margin:0!important}.mt-md-0,.my-md-0{margin-top:0!important}.mr-md-0,.mx-md-0{margin-right:0!important}.mb-md-0,.my-md-0{margin-bottom:0!important}.ml-md-0,.mx-md-0{margin-left:0!important}.m-md-1{margin:.25rem!important}.mt-md-1,.my-md-1{margin-top:.25rem!important}.mr-md-1,.mx-md-1{margin-right:.25rem!important}.mb-md-1,.my-md-1{margin-bottom:.25rem!important}.ml-md-1,.mx-md-1{margin-left:.25rem!important}.m-md-2{margin:.5rem!important}.mt-md-2,.my-md-2{margin-top:.5rem!important}.mr-md-2,.mx-md-2{margin-right:.5rem!important}.mb-md-2,.my-md-2{margin-bottom:.5rem!important}.ml-md-2,.mx-md-2{margin-left:.5rem!important}.m-md-3{margin:1rem!important}.mt-md-3,.my-md-3{margin-top:1rem!important}.mr-md-3,.mx-md-3{margin-right:1rem!important}.mb-md-3,.my-md-3{margin-bottom:1rem!important}.ml-md-3,.mx-md-3{margin-left:1rem!important}.m-md-4{margin:1.5rem!important}.mt-md-4,.my-md-4{margin-top:1.5rem!important}.mr-md-4,.mx-md-4{margin-right:1.5rem!important}.mb-md-4,.my-md-4{margin-bottom:1.5rem!important}.ml-md-4,.mx-md-4{margin-left:1.5rem!important}.m-md-5{margin:3rem!important}.mt-md-5,.my-md-5{margin-top:3rem!important}.mr-md-5,.mx-md-5{margin-right:3rem!important}.mb-md-5,.my-md-5{margin-bottom:3rem!important}.ml-md-5,.mx-md-5{margin-left:3rem!important}.p-md-0{padding:0!important}.pt-md-0,.py-md-0{padding-top:0!important}.pr-md-0,.px-md-0{padding-right:0!important}.pb-md-0,.py-md-0{padding-bottom:0!important}.pl-md-0,.px-md-0{padding-left:0!important}.p-md-1{padding:.25rem!important}.pt-md-1,.py-md-1{padding-top:.25rem!important}.pr-md-1,.px-md-1{padding-right:.25rem!important}.pb-md-1,.py-md-1{padding-bottom:.25rem!important}.pl-md-1,.px-md-1{padding-left:.25rem!important}.p-md-2{padding:.5rem!important}.pt-md-2,.py-md-2{padding-top:.5rem!important}.pr-md-2,.px-md-2{padding-right:.5rem!important}.pb-md-2,.py-md-2{padding-bottom:.5rem!important}.pl-md-2,.px-md-2{padding-left:.5rem!important}.p-md-3{padding:1rem!important}.pt-md-3,.py-md-3{padding-top:1rem!important}.pr-md-3,.px-md-3{padding-right:1rem!important}.pb-md-3,.py-md-3{padding-bottom:1rem!important}.pl-md-3,.px-md-3{padding-left:1rem!important}.p-md-4{padding:1.5rem!important}.pt-md-4,.py-md-4{padding-top:1.5rem!important}.pr-md-4,.px-md-4{padding-right:1.5rem!important}.pb-md-4,.py-md-4{padding-bottom:1.5rem!important}.pl-md-4,.px-md-4{padding-left:1.5rem!important}.p-md-5{padding:3rem!important}.pt-md-5,.py-md-5{padding-top:3rem!important}.pr-md-5,.px-md-5{padding-right:3rem!important}.pb-md-5,.py-md-5{padding-bottom:3rem!important}.pl-md-5,.px-md-5{padding-left:3rem!important}.m-md-auto{margin:auto!important}.mt-md-auto,.my-md-auto{margin-top:auto!important}.mr-md-auto,.mx-md-auto{margin-right:auto!important}.mb-md-auto,.my-md-auto{margin-bottom:auto!important}.ml-md-auto,.mx-md-auto{margin-left:auto!important}}@media (min-width:992px){.m-lg-0{margin:0!important}.mt-lg-0,.my-lg-0{margin-top:0!important}.mr-lg-0,.mx-lg-0{margin-right:0!important}.mb-lg-0,.my-lg-0{margin-bottom:0!important}.ml-lg-0,.mx-lg-0{margin-left:0!important}.m-lg-1{margin:.25rem!important}.mt-lg-1,.my-lg-1{margin-top:.25rem!important}.mr-lg-1,.mx-lg-1{margin-right:.25rem!important}.mb-lg-1,.my-lg-1{margin-bottom:.25rem!important}.ml-lg-1,.mx-lg-1{margin-left:.25rem!important}.m-lg-2{margin:.5rem!important}.mt-lg-2,.my-lg-2{margin-top:.5rem!important}.mr-lg-2,.mx-lg-2{margin-right:.5rem!important}.mb-lg-2,.my-lg-2{margin-bottom:.5rem!important}.ml-lg-2,.mx-lg-2{margin-left:.5rem!important}.m-lg-3{margin:1rem!important}.mt-lg-3,.my-lg-3{margin-top:1rem!important}.mr-lg-3,.mx-lg-3{margin-right:1rem!important}.mb-lg-3,.my-lg-3{margin-bottom:1rem!important}.ml-lg-3,.mx-lg-3{margin-left:1rem!important}.m-lg-4{margin:1.5rem!important}.mt-lg-4,.my-lg-4{margin-top:1.5rem!important}.mr-lg-4,.mx-lg-4{margin-right:1.5rem!important}.mb-lg-4,.my-lg-4{margin-bottom:1.5rem!important}.ml-lg-4,.mx-lg-4{margin-left:1.5rem!important}.m-lg-5{margin:3rem!important}.mt-lg-5,.my-lg-5{margin-top:3rem!important}.mr-lg-5,.mx-lg-5{margin-right:3rem!important}.mb-lg-5,.my-lg-5{margin-bottom:3rem!important}.ml-lg-5,.mx-lg-5{margin-left:3rem!important}.p-lg-0{padding:0!important}.pt-lg-0,.py-lg-0{padding-top:0!important}.pr-lg-0,.px-lg-0{padding-right:0!important}.pb-lg-0,.py-lg-0{padding-bottom:0!important}.pl-lg-0,.px-lg-0{padding-left:0!important}.p-lg-1{padding:.25rem!important}.pt-lg-1,.py-lg-1{padding-top:.25rem!important}.pr-lg-1,.px-lg-1{padding-right:.25rem!important}.pb-lg-1,.py-lg-1{padding-bottom:.25rem!important}.pl-lg-1,.px-lg-1{padding-left:.25rem!important}.p-lg-2{padding:.5rem!important}.pt-lg-2,.py-lg-2{padding-top:.5rem!important}.pr-lg-2,.px-lg-2{padding-right:.5rem!important}.pb-lg-2,.py-lg-2{padding-bottom:.5rem!important}.pl-lg-2,.px-lg-2{padding-left:.5rem!important}.p-lg-3{padding:1rem!important}.pt-lg-3,.py-lg-3{padding-top:1rem!important}.pr-lg-3,.px-lg-3{padding-right:1rem!important}.pb-lg-3,.py-lg-3{padding-bottom:1rem!important}.pl-lg-3,.px-lg-3{padding-left:1rem!important}.p-lg-4{padding:1.5rem!important}.pt-lg-4,.py-lg-4{padding-top:1.5rem!important}.pr-lg-4,.px-lg-4{padding-right:1.5rem!important}.pb-lg-4,.py-lg-4{padding-bottom:1.5rem!important}.pl-lg-4,.px-lg-4{padding-left:1.5rem!important}.p-lg-5{padding:3rem!important}.pt-lg-5,.py-lg-5{padding-top:3rem!important}.pr-lg-5,.px-lg-5{padding-right:3rem!important}.pb-lg-5,.py-lg-5{padding-bottom:3rem!important}.pl-lg-5,.px-lg-5{padding-left:3rem!important}.m-lg-auto{margin:auto!important}.mt-lg-auto,.my-lg-auto{margin-top:auto!important}.mr-lg-auto,.mx-lg-auto{margin-right:auto!important}.mb-lg-auto,.my-lg-auto{margin-bottom:auto!important}.ml-lg-auto,.mx-lg-auto{margin-left:auto!important}}@media (min-width:1200px){.m-xl-0{margin:0!important}.mt-xl-0,.my-xl-0{margin-top:0!important}.mr-xl-0,.mx-xl-0{margin-right:0!important}.mb-xl-0,.my-xl-0{margin-bottom:0!important}.ml-xl-0,.mx-xl-0{margin-left:0!important}.m-xl-1{margin:.25rem!important}.mt-xl-1,.my-xl-1{margin-top:.25rem!important}.mr-xl-1,.mx-xl-1{margin-right:.25rem!important}.mb-xl-1,.my-xl-1{margin-bottom:.25rem!important}.ml-xl-1,.mx-xl-1{margin-left:.25rem!important}.m-xl-2{margin:.5rem!important}.mt-xl-2,.my-xl-2{margin-top:.5rem!important}.mr-xl-2,.mx-xl-2{margin-right:.5rem!important}.mb-xl-2,.my-xl-2{margin-bottom:.5rem!important}.ml-xl-2,.mx-xl-2{margin-left:.5rem!important}.m-xl-3{margin:1rem!important}.mt-xl-3,.my-xl-3{margin-top:1rem!important}.mr-xl-3,.mx-xl-3{margin-right:1rem!important}.mb-xl-3,.my-xl-3{margin-bottom:1rem!important}.ml-xl-3,.mx-xl-3{margin-left:1rem!important}.m-xl-4{margin:1.5rem!important}.mt-xl-4,.my-xl-4{margin-top:1.5rem!important}.mr-xl-4,.mx-xl-4{margin-right:1.5rem!important}.mb-xl-4,.my-xl-4{margin-bottom:1.5rem!important}.ml-xl-4,.mx-xl-4{margin-left:1.5rem!important}.m-xl-5{margin:3rem!important}.mt-xl-5,.my-xl-5{margin-top:3rem!important}.mr-xl-5,.mx-xl-5{margin-right:3rem!important}.mb-xl-5,.my-xl-5{margin-bottom:3rem!important}.ml-xl-5,.mx-xl-5{margin-left:3rem!important}.p-xl-0{padding:0!important}.pt-xl-0,.py-xl-0{padding-top:0!important}.pr-xl-0,.px-xl-0{padding-right:0!important}.pb-xl-0,.py-xl-0{padding-bottom:0!important}.pl-xl-0,.px-xl-0{padding-left:0!important}.p-xl-1{padding:.25rem!important}.pt-xl-1,.py-xl-1{padding-top:.25rem!important}.pr-xl-1,.px-xl-1{padding-right:.25rem!important}.pb-xl-1,.py-xl-1{padding-bottom:.25rem!important}.pl-xl-1,.px-xl-1{padding-left:.25rem!important}.p-xl-2{padding:.5rem!important}.pt-xl-2,.py-xl-2{padding-top:.5rem!important}.pr-xl-2,.px-xl-2{padding-right:.5rem!important}.pb-xl-2,.py-xl-2{padding-bottom:.5rem!important}.pl-xl-2,.px-xl-2{padding-left:.5rem!important}.p-xl-3{padding:1rem!important}.pt-xl-3,.py-xl-3{padding-top:1rem!important}.pr-xl-3,.px-xl-3{padding-right:1rem!important}.pb-xl-3,.py-xl-3{padding-bottom:1rem!important}.pl-xl-3,.px-xl-3{padding-left:1rem!important}.p-xl-4{padding:1.5rem!important}.pt-xl-4,.py-xl-4{padding-top:1.5rem!important}.pr-xl-4,.px-xl-4{padding-right:1.5rem!important}.pb-xl-4,.py-xl-4{padding-bottom:1.5rem!important}.pl-xl-4,.px-xl-4{padding-left:1.5rem!important}.p-xl-5{padding:3rem!important}.pt-xl-5,.py-xl-5{padding-top:3rem!important}.pr-xl-5,.px-xl-5{padding-right:3rem!important}.pb-xl-5,.py-xl-5{padding-bottom:3rem!important}.pl-xl-5,.px-xl-5{padding-left:3rem!important}.m-xl-auto{margin:auto!important}.mt-xl-auto,.my-xl-auto{margin-top:auto!important}.mr-xl-auto,.mx-xl-auto{margin-right:auto!important}.mb-xl-auto,.my-xl-auto{margin-bottom:auto!important}.ml-xl-auto,.mx-xl-auto{margin-left:auto!important}}.text-justify{text-align:justify!important}.text-nowrap{white-space:nowrap!important}.text-truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.text-left{text-align:left!important}.text-right{text-align:right!important}.text-center{text-align:center!important}@media (min-width:576px){.text-sm-left{text-align:left!important}.text-sm-right{text-align:right!important}.text-sm-center{text-align:center!important}}@media (min-width:768px){.text-md-left{text-align:left!important}.text-md-right{text-align:right!important}.text-md-center{text-align:center!important}}@media (min-width:992px){.text-lg-left{text-align:left!important}.text-lg-right{text-align:right!important}.text-lg-center{text-align:center!important}}@media (min-width:1200px){.text-xl-left{text-align:left!important}.text-xl-right{text-align:right!important}.text-xl-center{text-align:center!important}}.text-lowercase{text-transform:lowercase!important}.text-uppercase{text-transform:uppercase!important}.text-capitalize{text-transform:capitalize!important}.font-weight-light{font-weight:300!important}.font-weight-normal{font-weight:400!important}.font-weight-bold{font-weight:700!important}.font-italic{font-style:italic!important}.text-white{color:#fff!important}.text-primary{color:#3f51b5!important}a.text-primary:focus,a.text-primary:hover{color:#32408f!important}.text-secondary{color:#e91e63!important}a.text-secondary:focus,a.text-secondary:hover{color:#c1134e!important}.text-success{color:#4caf50!important}a.text-success:focus,a.text-success:hover{color:#3d8b40!important}.text-info{color:#00bcd4!important}a.text-info:focus,a.text-info:hover{color:#008fa1!important}.text-warning{color:#ff9800!important}a.text-warning:focus,a.text-warning:hover{color:#cc7a00!important}.text-danger{color:#f44336!important}a.text-danger:focus,a.text-danger:hover{color:#ea1c0d!important}.text-light{color:#e8eaf6!important}a.text-light:focus,a.text-light:hover{color:#c3c9e8!important}.text-dark{color:#343a40!important}a.text-dark:focus,a.text-dark:hover{color:#1d2124!important}.text-muted{color:#6c757d!important}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.visible{visibility:visible!important}.invisible{visibility:hidden!important}@media print{*,:after,:before{text-shadow:none!important;box-shadow:none!important}a:not(.btn){text-decoration:underline}abbr[title]:after{content:\" (\" attr(title) \")\"}pre{white-space:pre-wrap!important}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}@page{size:a3}.container,body{min-width:992px!important}.navbar{display:none}.badge{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}", ""]);

// exports


/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1313);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(65)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./app.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./app.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(64)(false);
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Nunito+Sans:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i);", ""]);

// module
exports.push([module.i, ".jr-menu-icon .menu-icon{position:relative;width:70%;background-color:gray;margin:6px 0;cursor:pointer}.jr-menu-icon .menu-icon,.jr-menu-icon .menu-icon:after,.jr-menu-icon .menu-icon:before{height:1px;min-height:1px;color:inherit;display:block;-webkit-transition:all .4s ease;-o-transition:all .4s ease;transition:all .4s ease}.jr-menu-icon .menu-icon:after,.jr-menu-icon .menu-icon:before{position:absolute;background-color:inherit;left:0;content:\"\"}.jr-menu-icon .menu-icon:after{width:120%;bottom:-6px}.jr-menu-icon .menu-icon:before{width:130%;top:-6px}.jr-menu-icon:hover .menu-icon,.jr-menu-icon:hover .menu-icon:after,.jr-menu-icon:hover .menu-icon:before{width:100%}.jr-fab-btn,.size-50,.timeline-badge,.user-avatar,.user-list .user-avatar{height:50px!important;width:50px!important;line-height:50px}.jr-btn-fab-lg,.size-60{height:60px!important;width:60px!important;line-height:60px}.size-80{height:80px!important;width:80px!important;line-height:80px}.size-100{height:100px!important;width:100px!important;line-height:100px}.size-20{height:20px!important;width:20px!important;line-height:20px}.icon,.jr-btn-fab-xs,.jr-menu-icon,.size-30{height:30px!important;width:30px!important;line-height:30px}.jr-btn-fab-sm,.size-40{height:40px!important;width:40px!important;line-height:40px}.profile-intro img.avatar-circle,.size-120{height:120px!important;width:120px!important;line-height:120px}.icon-addon{display:inline-block;text-align:center;background-color:inherit}.jr-card{padding:24px 30px;margin-bottom:34px;background-color:#fff;border-radius:8px;border:1px solid #ced4da;position:relative}.ripple-effect{position:relative;overflow:hidden}.ripple-effect:after{content:\"\";position:absolute;top:50%;left:50%;width:5px;height:5px;background:hsla(0,0%,100%,.5);opacity:0;border-radius:100%;transform:scale(1) translate(-50%);transform-origin:50% 50%}.ripple-effect:hover:after{animation:ripple 1s ease-out}@keyframes ripple{0%{transform:scale(0);opacity:.5}20%{transform:scale(60);opacity:.3}to{opacity:0;transform:scale(100)}}@-webkit-keyframes ripple{0%{transform:scale(0);opacity:.5}20%{transform:scale(60);opacity:.3}to{opacity:0;transform:scale(100)}}.quick-menu .icon-alert:after{-webkit-box-shadow:0 0 0 rgba(244,67,54,.4);-moz-box-shadow:0 0 0 rgba(244,67,54,.4);-o-box-shadow:0 0 0 rgba(244,67,54,.4);box-shadow:0 0 0 rgba(244,67,54,.4);animation:pulse 2s infinite}@-webkit-keyframes pulse{0%{-webkit-box-shadow:0 0 0 0 rgba(244,67,54,.4)}70%{-webkit-box-shadow:0 0 0 10px rgba(244,67,54,0)}to{-webkit-box-shadow:0 0 0 0 rgba(244,67,54,0)}}@keyframes pulse{0%{-moz-box-shadow:0 0 0 0 rgba(244,67,54,.4);box-shadow:0 0 0 0 rgba(244,67,54,.4)}70%{-moz-box-shadow:0 0 0 10px rgba(244,67,54,0);box-shadow:0 0 0 10px rgba(244,67,54,0)}to{-moz-box-shadow:0 0 0 0 rgba(244,67,54,0);box-shadow:0 0 0 0 rgba(244,67,54,0)}}.chat-avatar-mode .chat-mode.offline,.chat-avatar-mode .chat-mode.online{display:block;-webkit-box-shadow:0 0 0 rgba(40,167,69,.4);-moz-box-shadow:0 0 0 rgba(40,167,69,.4);-o-box-shadow:0 0 0 rgba(40,167,69,.4);box-shadow:0 0 0 rgba(40,167,69,.4);animation:online 2s infinite}@-webkit-keyframes online{0%{-webkit-box-shadow:0 0 0 0 rgba(40,167,69,.4)}70%{-webkit-box-shadow:0 0 0 10px rgba(40,167,69,0)}to{-webkit-box-shadow:0 0 0 0 rgba(40,167,69,0)}}@keyframes online{0%{-moz-box-shadow:0 0 0 0 rgba(40,167,69,.4);box-shadow:0 0 0 0 rgba(40,167,69,.4)}70%{-moz-box-shadow:0 0 0 10px rgba(40,167,69,0);box-shadow:0 0 0 10px rgba(40,167,69,0)}to{-moz-box-shadow:0 0 0 0 rgba(40,167,69,0);box-shadow:0 0 0 0 rgba(40,167,69,0)}}.chat-avatar-mode .chat-mode.away{display:block;-webkit-box-shadow:0 0 0 rgba(255,193,7,.4);-moz-box-shadow:0 0 0 rgba(255,193,7,.4);-o-box-shadow:0 0 0 rgba(255,193,7,.4);box-shadow:0 0 0 rgba(255,193,7,.4);animation:away 2s infinite}@-webkit-keyframes away{0%{-webkit-box-shadow:0 0 0 0 rgba(255,193,7,.4)}70%{-webkit-box-shadow:0 0 0 10px rgba(255,193,7,0)}to{-webkit-box-shadow:0 0 0 0 rgba(255,193,7,0)}}@keyframes away{0%{-moz-box-shadow:0 0 0 0 rgba(255,193,7,.4);box-shadow:0 0 0 0 rgba(255,193,7,.4)}70%{-moz-box-shadow:0 0 0 10px rgba(255,193,7,0);box-shadow:0 0 0 10px rgba(255,193,7,0)}to{-moz-box-shadow:0 0 0 0 rgba(255,193,7,0);box-shadow:0 0 0 0 rgba(255,193,7,0)}}.brand-logo,.grid-thumb-equal{position:relative;padding-bottom:68%;height:0;width:100%;overflow:hidden}.brand-logo .brand-logo-inner,.grid-thumb-cover{display:block;position:absolute;width:100%;height:100%}.grid-thumb-cover img{height:auto;max-width:100%;min-height:100%;object-fit:cover;width:100%}a.badge-danger,a.badge-danger:focus,a.badge-danger:hover,a.badge-dark,a.badge-dark:focus,a.badge-dark:hover,a.badge-info,a.badge-info:focus,a.badge-info:hover,a.badge-success,a.badge-success:focus,a.badge-success:hover,a.badge-warning,a.badge-warning:focus,a.badge-warning:hover,a.btn-danger,a.btn-danger:focus,a.btn-danger:hover,a.btn-dark,a.btn-dark:focus,a.btn-dark:hover,a.btn-info,a.btn-info:focus,a.btn-info:hover,a.btn-success,a.btn-success:focus,a.btn-success:hover,a.btn-warning,a.btn-warning:focus,a.btn-warning:hover{color:#fff!important}.carousel-control-next,.carousel-control-prev{cursor:pointer}.btn-danger:not([disabled]):not(.disabled).active,.btn-danger:not([disabled]):not(.disabled):active,.btn-dark:not([disabled]):not(.disabled).active,.btn-dark:not([disabled]):not(.disabled):active,.btn-info:not([disabled]):not(.disabled).active,.btn-info:not([disabled]):not(.disabled):active,.btn-light:not([disabled]):not(.disabled).active,.btn-light:not([disabled]):not(.disabled):active,.btn-primary:not([disabled]):not(.disabled).active,.btn-primary:not([disabled]):not(.disabled):active,.btn-secondary:not([disabled]):not(.disabled).active,.btn-secondary:not([disabled]):not(.disabled):active,.btn-success:not([disabled]):not(.disabled).active,.btn-success:not([disabled]):not(.disabled):active,.btn-warning:not([disabled]):not(.disabled).active,.btn-warning:not([disabled]):not(.disabled):active,.btn:not([disabled]):not(.disabled).active,.btn:not([disabled]):not(.disabled):active{background-image:none;-webkit-box-shadow:none;-moz-box-shadow:none;-o-box-shadow:none;box-shadow:none}.btn-danger:not([disabled]):not(.disabled).active:focus,.btn-danger:not([disabled]):not(.disabled):active:focus,.btn-dark:not([disabled]):not(.disabled).active:focus,.btn-dark:not([disabled]):not(.disabled):active:focus,.btn-info:not([disabled]):not(.disabled).active:focus,.btn-info:not([disabled]):not(.disabled):active:focus,.btn-light:not([disabled]):not(.disabled).active:focus,.btn-light:not([disabled]):not(.disabled):active:focus,.btn-primary:not([disabled]):not(.disabled).active:focus,.btn-primary:not([disabled]):not(.disabled):active:focus,.btn-secondary:not([disabled]):not(.disabled).active:focus,.btn-secondary:not([disabled]):not(.disabled):active:focus,.btn-success:not([disabled]):not(.disabled).active:focus,.btn-success:not([disabled]):not(.disabled):active:focus,.btn-warning:not([disabled]):not(.disabled).active:focus,.btn-warning:not([disabled]):not(.disabled):active:focus,.btn:not([disabled]):not(.disabled).active:focus,.btn:not([disabled]):not(.disabled):active:focus{-webkit-box-shadow:none;-moz-box-shadow:none;-o-box-shadow:none;box-shadow:none}.w-25{width:25%!important}.w-50{width:50%!important}.w-75{width:75%!important}.w-100{width:100%!important}.h-25{height:25%!important}.h-50{height:50%!important}.h-75{height:75%!important}.h-100{height:100%!important}.mw-25{max-width:25%!important}.mw-50{max-width:50%!important}.mw-75{max-width:75%!important}.mw-100{max-width:100%!important}.mh-25{max-height:25%!important}.mh-50{max-height:50%!important}.mh-75{max-height:75%!important}.mh-100{max-height:100%!important}.bg-primary{background-color:#3f51b5!important}.text-primary{color:#3f51b5!important}.text-primary.icon-outline{border-color:#3f51b5!important}.bg-primary.lighten-5{background-color:#e8eaf6!important}.text-primary.text-lighten-5{color:#e8eaf6!important}.text-primary.text-lighten-5.icon-outline{border-color:#e8eaf6!important}.bg-primary.lighten-4{background-color:#c5cae9!important}.text-primary.text-lighten-4{color:#c5cae9!important}.text-primary.text-lighten-4.icon-outline{border-color:#c5cae9!important}.bg-primary.lighten-3{background-color:#9fa8da!important}.text-primary.text-lighten-3{color:#9fa8da!important}.text-primary.text-lighten-3.icon-outline{border-color:#9fa8da!important}.bg-primary.lighten-2{background-color:#7986cb!important}.text-primary.text-lighten-2{color:#7986cb!important}.text-primary.text-lighten-2.icon-outline{border-color:#7986cb!important}.bg-primary.lighten-1{background-color:#5c6bc0!important}.text-primary.text-lighten-1{color:#5c6bc0!important}.text-primary.text-lighten-1.icon-outline{border-color:#5c6bc0!important}.bg-primary.darken-1{background-color:#3949ab!important}.text-primary.text-darken-1{color:#3949ab!important}.text-primary.text-darken-1.icon-outline{border-color:#3949ab!important}.bg-primary.darken-2{background-color:#303f9f!important}.text-primary.text-darken-2{color:#303f9f!important}.text-primary.text-darken-2.icon-outline{border-color:#303f9f!important}.bg-primary.darken-3{background-color:#283593!important}.text-primary.text-darken-3{color:#283593!important}.text-primary.text-darken-3.icon-outline{border-color:#283593!important}.bg-primary.darken-4{background-color:#1a237e!important}.text-primary.text-darken-4{color:#1a237e!important}.text-primary.text-darken-4.icon-outline{border-color:#1a237e!important}.bg-primary.accent-1{background-color:#8c9eff!important}.text-primary.text-accent-1{color:#8c9eff!important}.text-primary.text-accent-1.icon-outline{border-color:#8c9eff!important}.bg-primary.accent-2{background-color:#536dfe!important}.text-primary.text-accent-2{color:#536dfe!important}.text-primary.text-accent-2.icon-outline{border-color:#536dfe!important}.bg-primary.accent-3{background-color:#3d5afe!important}.text-primary.text-accent-3{color:#3d5afe!important}.text-primary.text-accent-3.icon-outline{border-color:#3d5afe!important}.bg-primary.accent-4{background-color:#304ffe!important}.text-primary.text-accent-4{color:#304ffe!important}.text-primary.text-accent-4.icon-outline{border-color:#304ffe!important}.bg-red{background-color:#f44336!important}.text-red{color:#f44336!important}.text-red.icon-outline{border-color:#f44336!important}.bg-red.lighten-5{background-color:#ffebee!important}.text-red.text-lighten-5{color:#ffebee!important}.text-red.text-lighten-5.icon-outline{border-color:#ffebee!important}.bg-red.lighten-4{background-color:#ffcdd2!important}.text-red.text-lighten-4{color:#ffcdd2!important}.text-red.text-lighten-4.icon-outline{border-color:#ffcdd2!important}.bg-red.lighten-3{background-color:#ef9a9a!important}.text-red.text-lighten-3{color:#ef9a9a!important}.text-red.text-lighten-3.icon-outline{border-color:#ef9a9a!important}.bg-red.lighten-2{background-color:#e57373!important}.text-red.text-lighten-2{color:#e57373!important}.text-red.text-lighten-2.icon-outline{border-color:#e57373!important}.bg-red.lighten-1{background-color:#ef5350!important}.text-red.text-lighten-1{color:#ef5350!important}.text-red.text-lighten-1.icon-outline{border-color:#ef5350!important}.bg-red.darken-1{background-color:#e53935!important}.text-red.text-darken-1{color:#e53935!important}.text-red.text-darken-1.icon-outline{border-color:#e53935!important}.bg-red.darken-2{background-color:#d32f2f!important}.text-red.text-darken-2{color:#d32f2f!important}.text-red.text-darken-2.icon-outline{border-color:#d32f2f!important}.bg-red.darken-3{background-color:#c62828!important}.text-red.text-darken-3{color:#c62828!important}.text-red.text-darken-3.icon-outline{border-color:#c62828!important}.bg-red.darken-4{background-color:#b71c1c!important}.text-red.text-darken-4{color:#b71c1c!important}.text-red.text-darken-4.icon-outline{border-color:#b71c1c!important}.bg-red.accent-1{background-color:#ff8a80!important}.text-red.text-accent-1{color:#ff8a80!important}.text-red.text-accent-1.icon-outline{border-color:#ff8a80!important}.bg-red.accent-2{background-color:#ff5252!important}.text-red.text-accent-2{color:#ff5252!important}.text-red.text-accent-2.icon-outline{border-color:#ff5252!important}.bg-red.accent-3{background-color:#ff1744!important}.text-red.text-accent-3{color:#ff1744!important}.text-red.text-accent-3.icon-outline{border-color:#ff1744!important}.bg-red.accent-4{background-color:#d50000!important}.text-red.text-accent-4{color:#d50000!important}.text-red.text-accent-4.icon-outline{border-color:#d50000!important}.bg-pink{background-color:#e91e63!important}.text-pink{color:#e91e63!important}.text-pink.icon-outline{border-color:#e91e63!important}.bg-pink.lighten-5{background-color:#fce4ec!important}.text-pink.text-lighten-5{color:#fce4ec!important}.text-pink.text-lighten-5.icon-outline{border-color:#fce4ec!important}.bg-pink.lighten-4{background-color:#f8bbd0!important}.text-pink.text-lighten-4{color:#f8bbd0!important}.text-pink.text-lighten-4.icon-outline{border-color:#f8bbd0!important}.bg-pink.lighten-3{background-color:#f48fb1!important}.text-pink.text-lighten-3{color:#f48fb1!important}.text-pink.text-lighten-3.icon-outline{border-color:#f48fb1!important}.bg-pink.lighten-2{background-color:#f06292!important}.text-pink.text-lighten-2{color:#f06292!important}.text-pink.text-lighten-2.icon-outline{border-color:#f06292!important}.bg-pink.lighten-1{background-color:#ec407a!important}.text-pink.text-lighten-1{color:#ec407a!important}.text-pink.text-lighten-1.icon-outline{border-color:#ec407a!important}.bg-pink.darken-1{background-color:#d81b60!important}.text-pink.text-darken-1{color:#d81b60!important}.text-pink.text-darken-1.icon-outline{border-color:#d81b60!important}.bg-pink.darken-2{background-color:#c2185b!important}.text-pink.text-darken-2{color:#c2185b!important}.text-pink.text-darken-2.icon-outline{border-color:#c2185b!important}.bg-pink.darken-3{background-color:#ad1457!important}.text-pink.text-darken-3{color:#ad1457!important}.text-pink.text-darken-3.icon-outline{border-color:#ad1457!important}.bg-pink.darken-4{background-color:#880e4f!important}.text-pink.text-darken-4{color:#880e4f!important}.text-pink.text-darken-4.icon-outline{border-color:#880e4f!important}.bg-pink.accent-1{background-color:#ff80ab!important}.text-pink.text-accent-1{color:#ff80ab!important}.text-pink.text-accent-1.icon-outline{border-color:#ff80ab!important}.bg-pink.accent-2{background-color:#ff4081!important}.text-pink.text-accent-2{color:#ff4081!important}.text-pink.text-accent-2.icon-outline{border-color:#ff4081!important}.bg-pink.accent-3{background-color:#f50057!important}.text-pink.text-accent-3{color:#f50057!important}.text-pink.text-accent-3.icon-outline{border-color:#f50057!important}.bg-pink.accent-4{background-color:#c51162!important}.text-pink.text-accent-4{color:#c51162!important}.text-pink.text-accent-4.icon-outline{border-color:#c51162!important}.bg-purple{background-color:#9c27b0!important}.text-purple{color:#9c27b0!important}.text-purple.icon-outline{border-color:#9c27b0!important}.bg-purple.lighten-5{background-color:#f3e5f5!important}.text-purple.text-lighten-5{color:#f3e5f5!important}.text-purple.text-lighten-5.icon-outline{border-color:#f3e5f5!important}.bg-purple.lighten-4{background-color:#e1bee7!important}.text-purple.text-lighten-4{color:#e1bee7!important}.text-purple.text-lighten-4.icon-outline{border-color:#e1bee7!important}.bg-purple.lighten-3{background-color:#ce93d8!important}.text-purple.text-lighten-3{color:#ce93d8!important}.text-purple.text-lighten-3.icon-outline{border-color:#ce93d8!important}.bg-purple.lighten-2{background-color:#ba68c8!important}.text-purple.text-lighten-2{color:#ba68c8!important}.text-purple.text-lighten-2.icon-outline{border-color:#ba68c8!important}.bg-purple.lighten-1{background-color:#ab47bc!important}.text-purple.text-lighten-1{color:#ab47bc!important}.text-purple.text-lighten-1.icon-outline{border-color:#ab47bc!important}.bg-purple.darken-1{background-color:#8e24aa!important}.text-purple.text-darken-1{color:#8e24aa!important}.text-purple.text-darken-1.icon-outline{border-color:#8e24aa!important}.bg-purple.darken-2{background-color:#7b1fa2!important}.text-purple.text-darken-2{color:#7b1fa2!important}.text-purple.text-darken-2.icon-outline{border-color:#7b1fa2!important}.bg-purple.darken-3{background-color:#6a1b9a!important}.text-purple.text-darken-3{color:#6a1b9a!important}.text-purple.text-darken-3.icon-outline{border-color:#6a1b9a!important}.bg-purple.darken-4{background-color:#4a148c!important}.text-purple.text-darken-4{color:#4a148c!important}.text-purple.text-darken-4.icon-outline{border-color:#4a148c!important}.bg-purple.accent-1{background-color:#ea80fc!important}.text-purple.text-accent-1{color:#ea80fc!important}.text-purple.text-accent-1.icon-outline{border-color:#ea80fc!important}.bg-purple.accent-2{background-color:#e040fb!important}.text-purple.text-accent-2{color:#e040fb!important}.text-purple.text-accent-2.icon-outline{border-color:#e040fb!important}.bg-purple.accent-3{background-color:#d500f9!important}.text-purple.text-accent-3{color:#d500f9!important}.text-purple.text-accent-3.icon-outline{border-color:#d500f9!important}.bg-purple.accent-4{background-color:#a0f!important}.text-purple.text-accent-4{color:#a0f!important}.text-purple.text-accent-4.icon-outline{border-color:#a0f!important}.bg-deep-purple{background-color:#673ab7!important}.text-deep-purple{color:#673ab7!important}.text-deep-purple.icon-outline{border-color:#673ab7!important}.bg-deep-purple.lighten-5{background-color:#ede7f6!important}.text-deep-purple.text-lighten-5{color:#ede7f6!important}.text-deep-purple.text-lighten-5.icon-outline{border-color:#ede7f6!important}.bg-deep-purple.lighten-4{background-color:#d1c4e9!important}.text-deep-purple.text-lighten-4{color:#d1c4e9!important}.text-deep-purple.text-lighten-4.icon-outline{border-color:#d1c4e9!important}.bg-deep-purple.lighten-3{background-color:#b39ddb!important}.text-deep-purple.text-lighten-3{color:#b39ddb!important}.text-deep-purple.text-lighten-3.icon-outline{border-color:#b39ddb!important}.bg-deep-purple.lighten-2{background-color:#9575cd!important}.text-deep-purple.text-lighten-2{color:#9575cd!important}.text-deep-purple.text-lighten-2.icon-outline{border-color:#9575cd!important}.bg-deep-purple.lighten-1{background-color:#7e57c2!important}.text-deep-purple.text-lighten-1{color:#7e57c2!important}.text-deep-purple.text-lighten-1.icon-outline{border-color:#7e57c2!important}.bg-deep-purple.darken-1{background-color:#5e35b1!important}.text-deep-purple.text-darken-1{color:#5e35b1!important}.text-deep-purple.text-darken-1.icon-outline{border-color:#5e35b1!important}.bg-deep-purple.darken-2{background-color:#512da8!important}.text-deep-purple.text-darken-2{color:#512da8!important}.text-deep-purple.text-darken-2.icon-outline{border-color:#512da8!important}.bg-deep-purple.darken-3{background-color:#4527a0!important}.text-deep-purple.text-darken-3{color:#4527a0!important}.text-deep-purple.text-darken-3.icon-outline{border-color:#4527a0!important}.bg-deep-purple.darken-4{background-color:#311b92!important}.text-deep-purple.text-darken-4{color:#311b92!important}.text-deep-purple.text-darken-4.icon-outline{border-color:#311b92!important}.bg-deep-purple.accent-1{background-color:#b388ff!important}.text-deep-purple.text-accent-1{color:#b388ff!important}.text-deep-purple.text-accent-1.icon-outline{border-color:#b388ff!important}.bg-deep-purple.accent-2{background-color:#7c4dff!important}.text-deep-purple.text-accent-2{color:#7c4dff!important}.text-deep-purple.text-accent-2.icon-outline{border-color:#7c4dff!important}.bg-deep-purple.accent-3{background-color:#651fff!important}.text-deep-purple.text-accent-3{color:#651fff!important}.text-deep-purple.text-accent-3.icon-outline{border-color:#651fff!important}.bg-deep-purple.accent-4{background-color:#6200ea!important}.text-deep-purple.text-accent-4{color:#6200ea!important}.text-deep-purple.text-accent-4.icon-outline{border-color:#6200ea!important}.bg-indigo{background-color:#3f51b5!important}.text-indigo{color:#3f51b5!important}.text-indigo.icon-outline{border-color:#3f51b5!important}.bg-indigo.lighten-5{background-color:#e8eaf6!important}.text-indigo.text-lighten-5{color:#e8eaf6!important}.text-indigo.text-lighten-5.icon-outline{border-color:#e8eaf6!important}.bg-indigo.lighten-4{background-color:#c5cae9!important}.text-indigo.text-lighten-4{color:#c5cae9!important}.text-indigo.text-lighten-4.icon-outline{border-color:#c5cae9!important}.bg-indigo.lighten-3{background-color:#9fa8da!important}.text-indigo.text-lighten-3{color:#9fa8da!important}.text-indigo.text-lighten-3.icon-outline{border-color:#9fa8da!important}.bg-indigo.lighten-2{background-color:#7986cb!important}.text-indigo.text-lighten-2{color:#7986cb!important}.text-indigo.text-lighten-2.icon-outline{border-color:#7986cb!important}.bg-indigo.lighten-1{background-color:#5c6bc0!important}.text-indigo.text-lighten-1{color:#5c6bc0!important}.text-indigo.text-lighten-1.icon-outline{border-color:#5c6bc0!important}.bg-indigo.darken-1{background-color:#3949ab!important}.text-indigo.text-darken-1{color:#3949ab!important}.text-indigo.text-darken-1.icon-outline{border-color:#3949ab!important}.bg-indigo.darken-2{background-color:#303f9f!important}.text-indigo.text-darken-2{color:#303f9f!important}.text-indigo.text-darken-2.icon-outline{border-color:#303f9f!important}.bg-indigo.darken-3{background-color:#283593!important}.text-indigo.text-darken-3{color:#283593!important}.text-indigo.text-darken-3.icon-outline{border-color:#283593!important}.bg-indigo.darken-4{background-color:#1a237e!important}.text-indigo.text-darken-4{color:#1a237e!important}.text-indigo.text-darken-4.icon-outline{border-color:#1a237e!important}.bg-indigo.accent-1{background-color:#8c9eff!important}.text-indigo.text-accent-1{color:#8c9eff!important}.text-indigo.text-accent-1.icon-outline{border-color:#8c9eff!important}.bg-indigo.accent-2{background-color:#536dfe!important}.text-indigo.text-accent-2{color:#536dfe!important}.text-indigo.text-accent-2.icon-outline{border-color:#536dfe!important}.bg-indigo.accent-3{background-color:#3d5afe!important}.text-indigo.text-accent-3{color:#3d5afe!important}.text-indigo.text-accent-3.icon-outline{border-color:#3d5afe!important}.bg-indigo.accent-4{background-color:#304ffe!important}.text-indigo.text-accent-4{color:#304ffe!important}.text-indigo.text-accent-4.icon-outline{border-color:#304ffe!important}.bg-blue{background-color:#2196f3!important}.text-blue{color:#2196f3!important}.text-blue.icon-outline{border-color:#2196f3!important}.bg-blue.lighten-5{background-color:#e3f2fd!important}.text-blue.text-lighten-5{color:#e3f2fd!important}.text-blue.text-lighten-5.icon-outline{border-color:#e3f2fd!important}.bg-blue.lighten-4{background-color:#bbdefb!important}.text-blue.text-lighten-4{color:#bbdefb!important}.text-blue.text-lighten-4.icon-outline{border-color:#bbdefb!important}.bg-blue.lighten-3{background-color:#90caf9!important}.text-blue.text-lighten-3{color:#90caf9!important}.text-blue.text-lighten-3.icon-outline{border-color:#90caf9!important}.bg-blue.lighten-2{background-color:#64b5f6!important}.text-blue.text-lighten-2{color:#64b5f6!important}.text-blue.text-lighten-2.icon-outline{border-color:#64b5f6!important}.bg-blue.lighten-1{background-color:#42a5f5!important}.text-blue.text-lighten-1{color:#42a5f5!important}.text-blue.text-lighten-1.icon-outline{border-color:#42a5f5!important}.bg-blue.darken-1{background-color:#1e88e5!important}.text-blue.text-darken-1{color:#1e88e5!important}.text-blue.text-darken-1.icon-outline{border-color:#1e88e5!important}.bg-blue.darken-2{background-color:#1976d2!important}.text-blue.text-darken-2{color:#1976d2!important}.text-blue.text-darken-2.icon-outline{border-color:#1976d2!important}.bg-blue.darken-3{background-color:#1565c0!important}.text-blue.text-darken-3{color:#1565c0!important}.text-blue.text-darken-3.icon-outline{border-color:#1565c0!important}.bg-blue.darken-4{background-color:#0d47a1!important}.text-blue.text-darken-4{color:#0d47a1!important}.text-blue.text-darken-4.icon-outline{border-color:#0d47a1!important}.bg-blue.accent-1{background-color:#82b1ff!important}.text-blue.text-accent-1{color:#82b1ff!important}.text-blue.text-accent-1.icon-outline{border-color:#82b1ff!important}.bg-blue.accent-2{background-color:#448aff!important}.text-blue.text-accent-2{color:#448aff!important}.text-blue.text-accent-2.icon-outline{border-color:#448aff!important}.bg-blue.accent-3{background-color:#2979ff!important}.text-blue.text-accent-3{color:#2979ff!important}.text-blue.text-accent-3.icon-outline{border-color:#2979ff!important}.bg-blue.accent-4{background-color:#2962ff!important}.text-blue.text-accent-4{color:#2962ff!important}.text-blue.text-accent-4.icon-outline{border-color:#2962ff!important}.bg-light-blue{background-color:#03a9f4!important}.text-light-blue{color:#03a9f4!important}.text-light-blue.icon-outline{border-color:#03a9f4!important}.bg-light-blue.lighten-5{background-color:#e1f5fe!important}.text-light-blue.text-lighten-5{color:#e1f5fe!important}.text-light-blue.text-lighten-5.icon-outline{border-color:#e1f5fe!important}.bg-light-blue.lighten-4{background-color:#b3e5fc!important}.text-light-blue.text-lighten-4{color:#b3e5fc!important}.text-light-blue.text-lighten-4.icon-outline{border-color:#b3e5fc!important}.bg-light-blue.lighten-3{background-color:#81d4fa!important}.text-light-blue.text-lighten-3{color:#81d4fa!important}.text-light-blue.text-lighten-3.icon-outline{border-color:#81d4fa!important}.bg-light-blue.lighten-2{background-color:#4fc3f7!important}.text-light-blue.text-lighten-2{color:#4fc3f7!important}.text-light-blue.text-lighten-2.icon-outline{border-color:#4fc3f7!important}.bg-light-blue.lighten-1{background-color:#29b6f6!important}.text-light-blue.text-lighten-1{color:#29b6f6!important}.text-light-blue.text-lighten-1.icon-outline{border-color:#29b6f6!important}.bg-light-blue.darken-1{background-color:#039be5!important}.text-light-blue.text-darken-1{color:#039be5!important}.text-light-blue.text-darken-1.icon-outline{border-color:#039be5!important}.bg-light-blue.darken-2{background-color:#0288d1!important}.text-light-blue.text-darken-2{color:#0288d1!important}.text-light-blue.text-darken-2.icon-outline{border-color:#0288d1!important}.bg-light-blue.darken-3{background-color:#0277bd!important}.text-light-blue.text-darken-3{color:#0277bd!important}.text-light-blue.text-darken-3.icon-outline{border-color:#0277bd!important}.bg-light-blue.darken-4{background-color:#01579b!important}.text-light-blue.text-darken-4{color:#01579b!important}.text-light-blue.text-darken-4.icon-outline{border-color:#01579b!important}.bg-light-blue.accent-1{background-color:#80d8ff!important}.text-light-blue.text-accent-1{color:#80d8ff!important}.text-light-blue.text-accent-1.icon-outline{border-color:#80d8ff!important}.bg-light-blue.accent-2{background-color:#40c4ff!important}.text-light-blue.text-accent-2{color:#40c4ff!important}.text-light-blue.text-accent-2.icon-outline{border-color:#40c4ff!important}.bg-light-blue.accent-3{background-color:#00b0ff!important}.text-light-blue.text-accent-3{color:#00b0ff!important}.text-light-blue.text-accent-3.icon-outline{border-color:#00b0ff!important}.bg-light-blue.accent-4{background-color:#0091ea!important}.text-light-blue.text-accent-4{color:#0091ea!important}.text-light-blue.text-accent-4.icon-outline{border-color:#0091ea!important}.bg-cyan{background-color:#00bcd4!important}.text-cyan{color:#00bcd4!important}.text-cyan.icon-outline{border-color:#00bcd4!important}.bg-cyan.lighten-5{background-color:#e0f7fa!important}.text-cyan.text-lighten-5{color:#e0f7fa!important}.text-cyan.text-lighten-5.icon-outline{border-color:#e0f7fa!important}.bg-cyan.lighten-4{background-color:#b2ebf2!important}.text-cyan.text-lighten-4{color:#b2ebf2!important}.text-cyan.text-lighten-4.icon-outline{border-color:#b2ebf2!important}.bg-cyan.lighten-3{background-color:#80deea!important}.text-cyan.text-lighten-3{color:#80deea!important}.text-cyan.text-lighten-3.icon-outline{border-color:#80deea!important}.bg-cyan.lighten-2{background-color:#4dd0e1!important}.text-cyan.text-lighten-2{color:#4dd0e1!important}.text-cyan.text-lighten-2.icon-outline{border-color:#4dd0e1!important}.bg-cyan.lighten-1{background-color:#26c6da!important}.text-cyan.text-lighten-1{color:#26c6da!important}.text-cyan.text-lighten-1.icon-outline{border-color:#26c6da!important}.bg-cyan.darken-1{background-color:#00acc1!important}.text-cyan.text-darken-1{color:#00acc1!important}.text-cyan.text-darken-1.icon-outline{border-color:#00acc1!important}.bg-cyan.darken-2{background-color:#0097a7!important}.text-cyan.text-darken-2{color:#0097a7!important}.text-cyan.text-darken-2.icon-outline{border-color:#0097a7!important}.bg-cyan.darken-3{background-color:#00838f!important}.text-cyan.text-darken-3{color:#00838f!important}.text-cyan.text-darken-3.icon-outline{border-color:#00838f!important}.bg-cyan.darken-4{background-color:#006064!important}.text-cyan.text-darken-4{color:#006064!important}.text-cyan.text-darken-4.icon-outline{border-color:#006064!important}.bg-cyan.accent-1{background-color:#84ffff!important}.text-cyan.text-accent-1{color:#84ffff!important}.text-cyan.text-accent-1.icon-outline{border-color:#84ffff!important}.bg-cyan.accent-2{background-color:#18ffff!important}.text-cyan.text-accent-2{color:#18ffff!important}.text-cyan.text-accent-2.icon-outline{border-color:#18ffff!important}.bg-cyan.accent-3{background-color:#00e5ff!important}.text-cyan.text-accent-3{color:#00e5ff!important}.text-cyan.text-accent-3.icon-outline{border-color:#00e5ff!important}.bg-cyan.accent-4{background-color:#00b8d4!important}.text-cyan.text-accent-4{color:#00b8d4!important}.text-cyan.text-accent-4.icon-outline{border-color:#00b8d4!important}.bg-teal{background-color:#009688!important}.text-teal{color:#009688!important}.text-teal.icon-outline{border-color:#009688!important}.bg-teal.lighten-5{background-color:#e0f2f1!important}.text-teal.text-lighten-5{color:#e0f2f1!important}.text-teal.text-lighten-5.icon-outline{border-color:#e0f2f1!important}.bg-teal.lighten-4{background-color:#b2dfdb!important}.text-teal.text-lighten-4{color:#b2dfdb!important}.text-teal.text-lighten-4.icon-outline{border-color:#b2dfdb!important}.bg-teal.lighten-3{background-color:#80cbc4!important}.text-teal.text-lighten-3{color:#80cbc4!important}.text-teal.text-lighten-3.icon-outline{border-color:#80cbc4!important}.bg-teal.lighten-2{background-color:#4db6ac!important}.text-teal.text-lighten-2{color:#4db6ac!important}.text-teal.text-lighten-2.icon-outline{border-color:#4db6ac!important}.bg-teal.lighten-1{background-color:#26a69a!important}.text-teal.text-lighten-1{color:#26a69a!important}.text-teal.text-lighten-1.icon-outline{border-color:#26a69a!important}.bg-teal.darken-1{background-color:#00897b!important}.text-teal.text-darken-1{color:#00897b!important}.text-teal.text-darken-1.icon-outline{border-color:#00897b!important}.bg-teal.darken-2{background-color:#00796b!important}.text-teal.text-darken-2{color:#00796b!important}.text-teal.text-darken-2.icon-outline{border-color:#00796b!important}.bg-teal.darken-3{background-color:#00695c!important}.text-teal.text-darken-3{color:#00695c!important}.text-teal.text-darken-3.icon-outline{border-color:#00695c!important}.bg-teal.darken-4{background-color:#004d40!important}.text-teal.text-darken-4{color:#004d40!important}.text-teal.text-darken-4.icon-outline{border-color:#004d40!important}.bg-teal.accent-1{background-color:#a7ffeb!important}.text-teal.text-accent-1{color:#a7ffeb!important}.text-teal.text-accent-1.icon-outline{border-color:#a7ffeb!important}.bg-teal.accent-2{background-color:#64ffda!important}.text-teal.text-accent-2{color:#64ffda!important}.text-teal.text-accent-2.icon-outline{border-color:#64ffda!important}.bg-teal.accent-3{background-color:#1de9b6!important}.text-teal.text-accent-3{color:#1de9b6!important}.text-teal.text-accent-3.icon-outline{border-color:#1de9b6!important}.bg-teal.accent-4{background-color:#00bfa5!important}.text-teal.text-accent-4{color:#00bfa5!important}.text-teal.text-accent-4.icon-outline{border-color:#00bfa5!important}.bg-green{background-color:#4caf50!important}.text-green{color:#4caf50!important}.text-green.icon-outline{border-color:#4caf50!important}.bg-green.lighten-5{background-color:#e8f5e9!important}.text-green.text-lighten-5{color:#e8f5e9!important}.text-green.text-lighten-5.icon-outline{border-color:#e8f5e9!important}.bg-green.lighten-4{background-color:#c8e6c9!important}.text-green.text-lighten-4{color:#c8e6c9!important}.text-green.text-lighten-4.icon-outline{border-color:#c8e6c9!important}.bg-green.lighten-3{background-color:#a5d6a7!important}.text-green.text-lighten-3{color:#a5d6a7!important}.text-green.text-lighten-3.icon-outline{border-color:#a5d6a7!important}.bg-green.lighten-2{background-color:#81c784!important}.text-green.text-lighten-2{color:#81c784!important}.text-green.text-lighten-2.icon-outline{border-color:#81c784!important}.bg-green.lighten-1{background-color:#66bb6a!important}.text-green.text-lighten-1{color:#66bb6a!important}.text-green.text-lighten-1.icon-outline{border-color:#66bb6a!important}.bg-green.darken-1{background-color:#43a047!important}.text-green.text-darken-1{color:#43a047!important}.text-green.text-darken-1.icon-outline{border-color:#43a047!important}.bg-green.darken-2{background-color:#388e3c!important}.text-green.text-darken-2{color:#388e3c!important}.text-green.text-darken-2.icon-outline{border-color:#388e3c!important}.bg-green.darken-3{background-color:#2e7d32!important}.text-green.text-darken-3{color:#2e7d32!important}.text-green.text-darken-3.icon-outline{border-color:#2e7d32!important}.bg-green.darken-4{background-color:#1b5e20!important}.text-green.text-darken-4{color:#1b5e20!important}.text-green.text-darken-4.icon-outline{border-color:#1b5e20!important}.bg-green.accent-1{background-color:#b9f6ca!important}.text-green.text-accent-1{color:#b9f6ca!important}.text-green.text-accent-1.icon-outline{border-color:#b9f6ca!important}.bg-green.accent-2{background-color:#69f0ae!important}.text-green.text-accent-2{color:#69f0ae!important}.text-green.text-accent-2.icon-outline{border-color:#69f0ae!important}.bg-green.accent-3{background-color:#00e676!important}.text-green.text-accent-3{color:#00e676!important}.text-green.text-accent-3.icon-outline{border-color:#00e676!important}.bg-green.accent-4{background-color:#00c853!important}.text-green.text-accent-4{color:#00c853!important}.text-green.text-accent-4.icon-outline{border-color:#00c853!important}.bg-light-green{background-color:#8bc34a!important}.text-light-green{color:#8bc34a!important}.text-light-green.icon-outline{border-color:#8bc34a!important}.bg-light-green.lighten-5{background-color:#f1f8e9!important}.text-light-green.text-lighten-5{color:#f1f8e9!important}.text-light-green.text-lighten-5.icon-outline{border-color:#f1f8e9!important}.bg-light-green.lighten-4{background-color:#dcedc8!important}.text-light-green.text-lighten-4{color:#dcedc8!important}.text-light-green.text-lighten-4.icon-outline{border-color:#dcedc8!important}.bg-light-green.lighten-3{background-color:#c5e1a5!important}.text-light-green.text-lighten-3{color:#c5e1a5!important}.text-light-green.text-lighten-3.icon-outline{border-color:#c5e1a5!important}.bg-light-green.lighten-2{background-color:#aed581!important}.text-light-green.text-lighten-2{color:#aed581!important}.text-light-green.text-lighten-2.icon-outline{border-color:#aed581!important}.bg-light-green.lighten-1{background-color:#9ccc65!important}.text-light-green.text-lighten-1{color:#9ccc65!important}.text-light-green.text-lighten-1.icon-outline{border-color:#9ccc65!important}.bg-light-green.darken-1{background-color:#7cb342!important}.text-light-green.text-darken-1{color:#7cb342!important}.text-light-green.text-darken-1.icon-outline{border-color:#7cb342!important}.bg-light-green.darken-2{background-color:#689f38!important}.text-light-green.text-darken-2{color:#689f38!important}.text-light-green.text-darken-2.icon-outline{border-color:#689f38!important}.bg-light-green.darken-3{background-color:#558b2f!important}.text-light-green.text-darken-3{color:#558b2f!important}.text-light-green.text-darken-3.icon-outline{border-color:#558b2f!important}.bg-light-green.darken-4{background-color:#33691e!important}.text-light-green.text-darken-4{color:#33691e!important}.text-light-green.text-darken-4.icon-outline{border-color:#33691e!important}.bg-light-green.accent-1{background-color:#ccff90!important}.text-light-green.text-accent-1{color:#ccff90!important}.text-light-green.text-accent-1.icon-outline{border-color:#ccff90!important}.bg-light-green.accent-2{background-color:#b2ff59!important}.text-light-green.text-accent-2{color:#b2ff59!important}.text-light-green.text-accent-2.icon-outline{border-color:#b2ff59!important}.bg-light-green.accent-3{background-color:#76ff03!important}.text-light-green.text-accent-3{color:#76ff03!important}.text-light-green.text-accent-3.icon-outline{border-color:#76ff03!important}.bg-light-green.accent-4{background-color:#64dd17!important}.text-light-green.text-accent-4{color:#64dd17!important}.text-light-green.text-accent-4.icon-outline{border-color:#64dd17!important}.bg-lime{background-color:#cddc39!important}.text-lime{color:#cddc39!important}.text-lime.icon-outline{border-color:#cddc39!important}.bg-lime.lighten-5{background-color:#f9fbe7!important}.text-lime.text-lighten-5{color:#f9fbe7!important}.text-lime.text-lighten-5.icon-outline{border-color:#f9fbe7!important}.bg-lime.lighten-4{background-color:#f0f4c3!important}.text-lime.text-lighten-4{color:#f0f4c3!important}.text-lime.text-lighten-4.icon-outline{border-color:#f0f4c3!important}.bg-lime.lighten-3{background-color:#e6ee9c!important}.text-lime.text-lighten-3{color:#e6ee9c!important}.text-lime.text-lighten-3.icon-outline{border-color:#e6ee9c!important}.bg-lime.lighten-2{background-color:#dce775!important}.text-lime.text-lighten-2{color:#dce775!important}.text-lime.text-lighten-2.icon-outline{border-color:#dce775!important}.bg-lime.lighten-1{background-color:#d4e157!important}.text-lime.text-lighten-1{color:#d4e157!important}.text-lime.text-lighten-1.icon-outline{border-color:#d4e157!important}.bg-lime.darken-1{background-color:#c0ca33!important}.text-lime.text-darken-1{color:#c0ca33!important}.text-lime.text-darken-1.icon-outline{border-color:#c0ca33!important}.bg-lime.darken-2{background-color:#afb42b!important}.text-lime.text-darken-2{color:#afb42b!important}.text-lime.text-darken-2.icon-outline{border-color:#afb42b!important}.bg-lime.darken-3{background-color:#9e9d24!important}.text-lime.text-darken-3{color:#9e9d24!important}.text-lime.text-darken-3.icon-outline{border-color:#9e9d24!important}.bg-lime.darken-4{background-color:#827717!important}.text-lime.text-darken-4{color:#827717!important}.text-lime.text-darken-4.icon-outline{border-color:#827717!important}.bg-lime.accent-1{background-color:#f4ff81!important}.text-lime.text-accent-1{color:#f4ff81!important}.text-lime.text-accent-1.icon-outline{border-color:#f4ff81!important}.bg-lime.accent-2{background-color:#eeff41!important}.text-lime.text-accent-2{color:#eeff41!important}.text-lime.text-accent-2.icon-outline{border-color:#eeff41!important}.bg-lime.accent-3{background-color:#c6ff00!important}.text-lime.text-accent-3{color:#c6ff00!important}.text-lime.text-accent-3.icon-outline{border-color:#c6ff00!important}.bg-lime.accent-4{background-color:#aeea00!important}.text-lime.text-accent-4{color:#aeea00!important}.text-lime.text-accent-4.icon-outline{border-color:#aeea00!important}.bg-yellow{background-color:#ffeb3b!important}.text-yellow{color:#ffeb3b!important}.text-yellow.icon-outline{border-color:#ffeb3b!important}.bg-yellow.lighten-5{background-color:#fffde7!important}.text-yellow.text-lighten-5{color:#fffde7!important}.text-yellow.text-lighten-5.icon-outline{border-color:#fffde7!important}.bg-yellow.lighten-4{background-color:#fff9c4!important}.text-yellow.text-lighten-4{color:#fff9c4!important}.text-yellow.text-lighten-4.icon-outline{border-color:#fff9c4!important}.bg-yellow.lighten-3{background-color:#fff59d!important}.text-yellow.text-lighten-3{color:#fff59d!important}.text-yellow.text-lighten-3.icon-outline{border-color:#fff59d!important}.bg-yellow.lighten-2{background-color:#fff176!important}.text-yellow.text-lighten-2{color:#fff176!important}.text-yellow.text-lighten-2.icon-outline{border-color:#fff176!important}.bg-yellow.lighten-1{background-color:#ffee58!important}.text-yellow.text-lighten-1{color:#ffee58!important}.text-yellow.text-lighten-1.icon-outline{border-color:#ffee58!important}.bg-yellow.darken-1{background-color:#fdd835!important}.text-yellow.text-darken-1{color:#fdd835!important}.text-yellow.text-darken-1.icon-outline{border-color:#fdd835!important}.bg-yellow.darken-2{background-color:#fbc02d!important}.text-yellow.text-darken-2{color:#fbc02d!important}.text-yellow.text-darken-2.icon-outline{border-color:#fbc02d!important}.bg-yellow.darken-3{background-color:#f9a825!important}.text-yellow.text-darken-3{color:#f9a825!important}.text-yellow.text-darken-3.icon-outline{border-color:#f9a825!important}.bg-yellow.darken-4{background-color:#f57f17!important}.text-yellow.text-darken-4{color:#f57f17!important}.text-yellow.text-darken-4.icon-outline{border-color:#f57f17!important}.bg-yellow.accent-1{background-color:#ffff8d!important}.text-yellow.text-accent-1{color:#ffff8d!important}.text-yellow.text-accent-1.icon-outline{border-color:#ffff8d!important}.bg-yellow.accent-2{background-color:#ff0!important}.text-yellow.text-accent-2{color:#ff0!important}.text-yellow.text-accent-2.icon-outline{border-color:#ff0!important}.bg-yellow.accent-3{background-color:#ffea00!important}.text-yellow.text-accent-3{color:#ffea00!important}.text-yellow.text-accent-3.icon-outline{border-color:#ffea00!important}.bg-yellow.accent-4{background-color:#ffd600!important}.text-yellow.text-accent-4{color:#ffd600!important}.text-yellow.text-accent-4.icon-outline{border-color:#ffd600!important}.bg-amber{background-color:#ffc107!important}.text-amber{color:#ffc107!important}.text-amber.icon-outline{border-color:#ffc107!important}.bg-amber.lighten-5{background-color:#fff8e1!important}.text-amber.text-lighten-5{color:#fff8e1!important}.text-amber.text-lighten-5.icon-outline{border-color:#fff8e1!important}.bg-amber.lighten-4{background-color:#ffecb3!important}.text-amber.text-lighten-4{color:#ffecb3!important}.text-amber.text-lighten-4.icon-outline{border-color:#ffecb3!important}.bg-amber.lighten-3{background-color:#ffe082!important}.text-amber.text-lighten-3{color:#ffe082!important}.text-amber.text-lighten-3.icon-outline{border-color:#ffe082!important}.bg-amber.lighten-2{background-color:#ffd54f!important}.text-amber.text-lighten-2{color:#ffd54f!important}.text-amber.text-lighten-2.icon-outline{border-color:#ffd54f!important}.bg-amber.lighten-1{background-color:#ffca28!important}.text-amber.text-lighten-1{color:#ffca28!important}.text-amber.text-lighten-1.icon-outline{border-color:#ffca28!important}.bg-amber.darken-1{background-color:#ffb300!important}.text-amber.text-darken-1{color:#ffb300!important}.text-amber.text-darken-1.icon-outline{border-color:#ffb300!important}.bg-amber.darken-2{background-color:#ffa000!important}.text-amber.text-darken-2{color:#ffa000!important}.text-amber.text-darken-2.icon-outline{border-color:#ffa000!important}.bg-amber.darken-3{background-color:#ff8f00!important}.text-amber.text-darken-3{color:#ff8f00!important}.text-amber.text-darken-3.icon-outline{border-color:#ff8f00!important}.bg-amber.darken-4{background-color:#ff6f00!important}.text-amber.text-darken-4{color:#ff6f00!important}.text-amber.text-darken-4.icon-outline{border-color:#ff6f00!important}.bg-amber.accent-1{background-color:#ffe57f!important}.text-amber.text-accent-1{color:#ffe57f!important}.text-amber.text-accent-1.icon-outline{border-color:#ffe57f!important}.bg-amber.accent-2{background-color:#ffd740!important}.text-amber.text-accent-2{color:#ffd740!important}.text-amber.text-accent-2.icon-outline{border-color:#ffd740!important}.bg-amber.accent-3{background-color:#ffc400!important}.text-amber.text-accent-3{color:#ffc400!important}.text-amber.text-accent-3.icon-outline{border-color:#ffc400!important}.bg-amber.accent-4{background-color:#ffab00!important}.text-amber.text-accent-4{color:#ffab00!important}.text-amber.text-accent-4.icon-outline{border-color:#ffab00!important}.bg-orange{background-color:#ff9800!important}.text-orange{color:#ff9800!important}.text-orange.icon-outline{border-color:#ff9800!important}.bg-orange.lighten-5{background-color:#fff3e0!important}.text-orange.text-lighten-5{color:#fff3e0!important}.text-orange.text-lighten-5.icon-outline{border-color:#fff3e0!important}.bg-orange.lighten-4{background-color:#ffe0b2!important}.text-orange.text-lighten-4{color:#ffe0b2!important}.text-orange.text-lighten-4.icon-outline{border-color:#ffe0b2!important}.bg-orange.lighten-3{background-color:#ffcc80!important}.text-orange.text-lighten-3{color:#ffcc80!important}.text-orange.text-lighten-3.icon-outline{border-color:#ffcc80!important}.bg-orange.lighten-2{background-color:#ffb74d!important}.text-orange.text-lighten-2{color:#ffb74d!important}.text-orange.text-lighten-2.icon-outline{border-color:#ffb74d!important}.bg-orange.lighten-1{background-color:#ffa726!important}.text-orange.text-lighten-1{color:#ffa726!important}.text-orange.text-lighten-1.icon-outline{border-color:#ffa726!important}.bg-orange.darken-1{background-color:#fb8c00!important}.text-orange.text-darken-1{color:#fb8c00!important}.text-orange.text-darken-1.icon-outline{border-color:#fb8c00!important}.bg-orange.darken-2{background-color:#f57c00!important}.text-orange.text-darken-2{color:#f57c00!important}.text-orange.text-darken-2.icon-outline{border-color:#f57c00!important}.bg-orange.darken-3{background-color:#ef6c00!important}.text-orange.text-darken-3{color:#ef6c00!important}.text-orange.text-darken-3.icon-outline{border-color:#ef6c00!important}.bg-orange.darken-4{background-color:#e65100!important}.text-orange.text-darken-4{color:#e65100!important}.text-orange.text-darken-4.icon-outline{border-color:#e65100!important}.bg-orange.accent-1{background-color:#ffd180!important}.text-orange.text-accent-1{color:#ffd180!important}.text-orange.text-accent-1.icon-outline{border-color:#ffd180!important}.bg-orange.accent-2{background-color:#ffab40!important}.text-orange.text-accent-2{color:#ffab40!important}.text-orange.text-accent-2.icon-outline{border-color:#ffab40!important}.bg-orange.accent-3{background-color:#ff9100!important}.text-orange.text-accent-3{color:#ff9100!important}.text-orange.text-accent-3.icon-outline{border-color:#ff9100!important}.bg-orange.accent-4{background-color:#ff6d00!important}.text-orange.text-accent-4{color:#ff6d00!important}.text-orange.text-accent-4.icon-outline{border-color:#ff6d00!important}.bg-deep-orange{background-color:#ff5722!important}.text-deep-orange{color:#ff5722!important}.text-deep-orange.icon-outline{border-color:#ff5722!important}.bg-deep-orange.lighten-5{background-color:#fbe9e7!important}.text-deep-orange.text-lighten-5{color:#fbe9e7!important}.text-deep-orange.text-lighten-5.icon-outline{border-color:#fbe9e7!important}.bg-deep-orange.lighten-4{background-color:#ffccbc!important}.text-deep-orange.text-lighten-4{color:#ffccbc!important}.text-deep-orange.text-lighten-4.icon-outline{border-color:#ffccbc!important}.bg-deep-orange.lighten-3{background-color:#ffab91!important}.text-deep-orange.text-lighten-3{color:#ffab91!important}.text-deep-orange.text-lighten-3.icon-outline{border-color:#ffab91!important}.bg-deep-orange.lighten-2{background-color:#ff8a65!important}.text-deep-orange.text-lighten-2{color:#ff8a65!important}.text-deep-orange.text-lighten-2.icon-outline{border-color:#ff8a65!important}.bg-deep-orange.lighten-1{background-color:#ff7043!important}.text-deep-orange.text-lighten-1{color:#ff7043!important}.text-deep-orange.text-lighten-1.icon-outline{border-color:#ff7043!important}.bg-deep-orange.darken-1{background-color:#f4511e!important}.text-deep-orange.text-darken-1{color:#f4511e!important}.text-deep-orange.text-darken-1.icon-outline{border-color:#f4511e!important}.bg-deep-orange.darken-2{background-color:#e64a19!important}.text-deep-orange.text-darken-2{color:#e64a19!important}.text-deep-orange.text-darken-2.icon-outline{border-color:#e64a19!important}.bg-deep-orange.darken-3{background-color:#d84315!important}.text-deep-orange.text-darken-3{color:#d84315!important}.text-deep-orange.text-darken-3.icon-outline{border-color:#d84315!important}.bg-deep-orange.darken-4{background-color:#bf360c!important}.text-deep-orange.text-darken-4{color:#bf360c!important}.text-deep-orange.text-darken-4.icon-outline{border-color:#bf360c!important}.bg-deep-orange.accent-1{background-color:#ff9e80!important}.text-deep-orange.text-accent-1{color:#ff9e80!important}.text-deep-orange.text-accent-1.icon-outline{border-color:#ff9e80!important}.bg-deep-orange.accent-2{background-color:#ff6e40!important}.text-deep-orange.text-accent-2{color:#ff6e40!important}.text-deep-orange.text-accent-2.icon-outline{border-color:#ff6e40!important}.bg-deep-orange.accent-3{background-color:#ff3d00!important}.text-deep-orange.text-accent-3{color:#ff3d00!important}.text-deep-orange.text-accent-3.icon-outline{border-color:#ff3d00!important}.bg-deep-orange.accent-4{background-color:#dd2c00!important}.text-deep-orange.text-accent-4{color:#dd2c00!important}.text-deep-orange.text-accent-4.icon-outline{border-color:#dd2c00!important}.bg-brown{background-color:#795548!important}.text-brown{color:#795548!important}.text-brown.icon-outline{border-color:#795548!important}.bg-brown.lighten-5{background-color:#efebe9!important}.text-brown.text-lighten-5{color:#efebe9!important}.text-brown.text-lighten-5.icon-outline{border-color:#efebe9!important}.bg-brown.lighten-4{background-color:#d7ccc8!important}.text-brown.text-lighten-4{color:#d7ccc8!important}.text-brown.text-lighten-4.icon-outline{border-color:#d7ccc8!important}.bg-brown.lighten-3{background-color:#bcaaa4!important}.text-brown.text-lighten-3{color:#bcaaa4!important}.text-brown.text-lighten-3.icon-outline{border-color:#bcaaa4!important}.bg-brown.lighten-2{background-color:#a1887f!important}.text-brown.text-lighten-2{color:#a1887f!important}.text-brown.text-lighten-2.icon-outline{border-color:#a1887f!important}.bg-brown.lighten-1{background-color:#8d6e63!important}.text-brown.text-lighten-1{color:#8d6e63!important}.text-brown.text-lighten-1.icon-outline{border-color:#8d6e63!important}.bg-brown.darken-1{background-color:#6d4c41!important}.text-brown.text-darken-1{color:#6d4c41!important}.text-brown.text-darken-1.icon-outline{border-color:#6d4c41!important}.bg-brown.darken-2{background-color:#5d4037!important}.text-brown.text-darken-2{color:#5d4037!important}.text-brown.text-darken-2.icon-outline{border-color:#5d4037!important}.bg-brown.darken-3{background-color:#4e342e!important}.text-brown.text-darken-3{color:#4e342e!important}.text-brown.text-darken-3.icon-outline{border-color:#4e342e!important}.bg-brown.darken-4{background-color:#3e2723!important}.text-brown.text-darken-4{color:#3e2723!important}.text-brown.text-darken-4.icon-outline{border-color:#3e2723!important}.bg-blue-grey{background-color:#607d8b!important}.text-blue-grey{color:#607d8b!important}.text-blue-grey.icon-outline{border-color:#607d8b!important}.bg-blue-grey.lighten-5{background-color:#eceff1!important}.text-blue-grey.text-lighten-5{color:#eceff1!important}.text-blue-grey.text-lighten-5.icon-outline{border-color:#eceff1!important}.bg-blue-grey.lighten-4{background-color:#cfd8dc!important}.text-blue-grey.text-lighten-4{color:#cfd8dc!important}.text-blue-grey.text-lighten-4.icon-outline{border-color:#cfd8dc!important}.bg-blue-grey.lighten-3{background-color:#b0bec5!important}.text-blue-grey.text-lighten-3{color:#b0bec5!important}.text-blue-grey.text-lighten-3.icon-outline{border-color:#b0bec5!important}.bg-blue-grey.lighten-2{background-color:#90a4ae!important}.text-blue-grey.text-lighten-2{color:#90a4ae!important}.text-blue-grey.text-lighten-2.icon-outline{border-color:#90a4ae!important}.bg-blue-grey.lighten-1{background-color:#78909c!important}.text-blue-grey.text-lighten-1{color:#78909c!important}.text-blue-grey.text-lighten-1.icon-outline{border-color:#78909c!important}.bg-blue-grey.darken-1{background-color:#546e7a!important}.text-blue-grey.text-darken-1{color:#546e7a!important}.text-blue-grey.text-darken-1.icon-outline{border-color:#546e7a!important}.bg-blue-grey.darken-2{background-color:#455a64!important}.text-blue-grey.text-darken-2{color:#455a64!important}.text-blue-grey.text-darken-2.icon-outline{border-color:#455a64!important}.bg-blue-grey.darken-3{background-color:#37474f!important}.text-blue-grey.text-darken-3{color:#37474f!important}.text-blue-grey.text-darken-3.icon-outline{border-color:#37474f!important}.bg-blue-grey.darken-4{background-color:#263238!important}.text-blue-grey.text-darken-4{color:#263238!important}.text-blue-grey.text-darken-4.icon-outline{border-color:#263238!important}.bg-grey{background-color:#9e9e9e!important}.text-grey{color:#9e9e9e!important}.text-grey.icon-outline{border-color:#9e9e9e!important}.bg-grey.lighten-5{background-color:#fafafa!important}.text-grey.text-lighten-5{color:#fafafa!important}.text-grey.text-lighten-5.icon-outline{border-color:#fafafa!important}.bg-grey.lighten-4{background-color:#f5f5f5!important}.text-grey.text-lighten-4{color:#f5f5f5!important}.text-grey.text-lighten-4.icon-outline{border-color:#f5f5f5!important}.bg-grey.lighten-3{background-color:#eee!important}.text-grey.text-lighten-3{color:#eee!important}.text-grey.text-lighten-3.icon-outline{border-color:#eee!important}.bg-grey.lighten-2{background-color:#e0e0e0!important}.text-grey.text-lighten-2{color:#e0e0e0!important}.text-grey.text-lighten-2.icon-outline{border-color:#e0e0e0!important}.bg-grey.lighten-1{background-color:#bdbdbd!important}.text-grey.text-lighten-1{color:#bdbdbd!important}.text-grey.text-lighten-1.icon-outline{border-color:#bdbdbd!important}.bg-grey.darken-1{background-color:#757575!important}.text-grey.text-darken-1{color:#757575!important}.text-grey.text-darken-1.icon-outline{border-color:#757575!important}.bg-grey.darken-2{background-color:#616161!important}.text-grey.text-darken-2{color:#616161!important}.text-grey.text-darken-2.icon-outline{border-color:#616161!important}.bg-grey.darken-3{background-color:#424242!important}.text-grey.text-darken-3{color:#424242!important}.text-grey.text-darken-3.icon-outline{border-color:#424242!important}.bg-grey.darken-4{background-color:#212121!important}.text-grey.text-darken-4{color:#212121!important}.text-grey.text-darken-4.icon-outline{border-color:#212121!important}.bg-black{background-color:#000!important}.text-black{color:#000!important}.text-black.icon-outline{border-color:#000!important}.bg-white{background-color:#fff!important}.text-white{color:#fff!important}.text-white.icon-outline{border-color:#fff!important}.bg-transparent{background-color:transparent!important}.text-transparent{color:transparent!important}.text-transparent.icon-outline{border-color:transparent!important}@keyframes flipCenter{0%{animation-timing-function:ease-in;opacity:0;transform:perspective(100000px) rotateX(90deg)}40%{animation-timing-function:ease-in;transform:perspective(100000px) rotateX(0deg)}60%{opacity:1;transform:perspective(100000px) rotateX(0deg)}80%{transform:perspective(100000px) rotateX(0deg)}to{transform:perspective(100000px)}}@-webkit-keyframes flipCenter{0%{animation-timing-function:ease-in;opacity:0;transform:perspective(100000px) rotateX(90deg)}40%{animation-timing-function:ease-in;transform:perspective(100000px) rotateX(0deg)}60%{opacity:1;transform:perspective(100000px) rotateX(0deg)}80%{transform:perspective(100000px) rotateX(0deg)}to{transform:perspective(100000px)}}.flipCenter{animation-name:flipCenter;backface-visibility:visible}@keyframes desployDown{0%{transform:scaleY(0);transform-origin:center top 0}to{opacity:1;transform:scaleY(1);transform-origin:center top 0}}@-webkit-keyframes desployDown{0%{transform:scaleY(0);transform-origin:center top 0}to{opacity:1;transform:scaleY(1);transform-origin:center top 0}}.desployDown{animation-name:desployDown;backface-visibility:visible}@keyframes fadeInRightTiny{0%{opacity:0;transform:translate3d(30%,0,0)}to{opacity:1;transform:none}}@-webkit-keyframes fadeInRightTiny{0%{opacity:0;transform:translate3d(30%,0,0)}to{opacity:1;transform:none}}.fadeInRightTiny{animation-name:fadeInRightTiny}@keyframes fadeInLeftTiny{0%{opacity:0;transform:translate3d(-30%,0,0)}to{opacity:1;transform:none}}@-webkit-keyframes fadeInLeftTiny{0%{opacity:0;transform:translate3d(-30%,0,0)}to{opacity:1;transform:none}}.fadeInLeftTiny{animation-name:fadeInLeftTiny}@keyframes slideInRightTiny{0%{transform:translate3d(30%,0,0)}to{transform:none}}@-webkit-keyframes slideInRightTiny{0%{transform:translate3d(30%,0,0)}to{transform:none}}.slideInRightTiny{animation-name:slideInRightTiny}@keyframes slideInLeftTiny{0%{transform:translate3d(-30%,0,0)}to{transform:none}}@-webkit-keyframes slideInLeftTiny{0%{transform:translate3d(-30%,0,0)}to{transform:none}}.slideInLeftTiny{animation-name:slideInLeftTiny}@keyframes slideInUpTiny{0%{transform:translate3d(0,5%,0)}to{transform:none}}@-webkit-keyframes slideInUpTiny{0%{transform:translate3d(0,5%,0)}to{transform:none}}.slideInUpTiny{animation-name:slideInUpTiny}.animation-duration-1{animation-duration:.1s}.animation-duration-2{animation-duration:.2s}.animation-duration-3{animation-duration:.3s}.animation-duration-4{animation-duration:.4s}.animation-duration-5{animation-duration:.5s}.animation-duration-6{animation-duration:.6s}.animation-duration-7{animation-duration:.7s}.animation-duration-8{animation-duration:.8s}.animation-duration-9{animation-duration:.9s}.animation-duration-10{animation-duration:1s}.animation-duration-11{animation-duration:1.1s}.animation-duration-12{animation-duration:1.2s}.animation-duration-13{animation-duration:1.3s}.animation-duration-14{animation-duration:1.4s}.animation-duration-15{animation-duration:1.5s}.animation-duration-16{animation-duration:1.6s}.animation-duration-17{animation-duration:1.7s}.animation-duration-18{animation-duration:1.8s}.animation-duration-19{animation-duration:1.9s}.animation-duration-20{animation-duration:2s}.animation-duration-21{animation-duration:2.1s}.animation-duration-22{animation-duration:2.2s}.animation-duration-23{animation-duration:2.3s}.animation-duration-24{animation-duration:2.4s}.animation-duration-25{animation-duration:2.5s}.animation-duration-26{animation-duration:2.6s}.animation-duration-27{animation-duration:2.7s}.animation-duration-28{animation-duration:2.8s}.animation-duration-29{animation-duration:2.9s}.animation-duration-30{animation-duration:3s}.animation-duration-31{animation-duration:3.1s}.animation-duration-32{animation-duration:3.2s}.animation-duration-33{animation-duration:3.3s}.animation-duration-34{animation-duration:3.4s}.animation-duration-35{animation-duration:3.5s}.animation-duration-36{animation-duration:3.6s}.animation-duration-37{animation-duration:3.7s}.animation-duration-38{animation-duration:3.8s}.animation-duration-39{animation-duration:3.9s}.animation-duration-40{animation-duration:4s}.animation-delay-1{animation-delay:.1s}.animation-delay-2{animation-delay:.2s}.animation-delay-3{animation-delay:.3s}.animation-delay-4{animation-delay:.4s}.animation-delay-5{animation-delay:.5s}.animation-delay-6{animation-delay:.6s}.animation-delay-7{animation-delay:.7s}.animation-delay-8{animation-delay:.8s}.animation-delay-9{animation-delay:.9s}.animation-delay-10{animation-delay:1s}.animation-delay-11{animation-delay:1.1s}.animation-delay-12{animation-delay:1.2s}.animation-delay-13{animation-delay:1.3s}.animation-delay-14{animation-delay:1.4s}.animation-delay-15{animation-delay:1.5s}.animation-delay-16{animation-delay:1.6s}.animation-delay-17{animation-delay:1.7s}.animation-delay-18{animation-delay:1.8s}.animation-delay-19{animation-delay:1.9s}.animation-delay-20{animation-delay:2s}.animation-delay-21{animation-delay:2.1s}.animation-delay-22{animation-delay:2.2s}.animation-delay-23{animation-delay:2.3s}.animation-delay-24{animation-delay:2.4s}.animation-delay-25{animation-delay:2.5s}.animation-delay-26,.animation-delay-27{animation-delay:2.6s}.animation-delay-28{animation-delay:2.8s}.animation-delay-29{animation-delay:2.9s}.animation-delay-30{animation-delay:3s}.animation-delay-31{animation-delay:3.1s}.animation-delay-32{animation-delay:3.2s}.animation-delay-33{animation-delay:3.3s}.animation-delay-34{animation-delay:3.4s}.animation-delay-35{animation-delay:3.5s}.animation-delay-36{animation-delay:3.6s}.animation-delay-37{animation-delay:3.7s}.animation-delay-38{animation-delay:3.8s}.animation-delay-39{animation-delay:3.9s}.animation-delay-40{animation-delay:4s}.animation-delay-41{animation-delay:4.1s}.animation-delay-42{animation-delay:4.2s}.animation-delay-43{animation-delay:4.3s}.animation-delay-44{animation-delay:4.4s}.animation-delay-45{animation-delay:4.5s}.animation-delay-46{animation-delay:4.6s}.animation-delay-47{animation-delay:4.7s}.animation-delay-48{animation-delay:4.8s}.animation-delay-49{animation-delay:4.9s}.animation-delay-50{animation-delay:5s}body,html{height:100%}body{font-family:Nunito Sans,sans-serif;font-size:13px;font-weight:400;color:#5c5c5c;background-color:#f4f4f4;overflow:hidden}body.ios-mobile-view-height{height:auto!important;overflow:visible!important}#nprogress .bar{z-index:5000!important;background:#e91e63!important}#nprogress .peg{-webkit-box-shadow:0 0 10px #e91e63,0 0 5px #e91e63!important;-moz-box-shadow:0 0 10px #e91e63,0 0 5px #e91e63!important;-o-box-shadow:0 0 10px #e91e63,0 0 5px #e91e63!important;box-shadow:0 0 10px #e91e63,0 0 5px #e91e63!important}#nprogress .spinner{z-index:5000!important}#nprogress .spinner-icon{border-top-color:#e91e63!important;border-left-color:#e91e63!important}.text-transform-none{text-transform:none}.br-break{word-break:break-all!important}.font-weight-semibold{font-weight:500!important}.z-index-20{z-index:20}.border-bottom{border-bottom:1px solid #dee2e6}.col-with-divider div[class*=col-]{border-left:1px solid #dee2e6}.col-with-divider div[class*=col-]:first-child{border:0 none}.height-100{height:100px!important}.height-150{height:150px!important}.height-130{height:130px!important}.height-200{height:200px!important}.max-width-100{max-width:100px!important}.max-height-120{max-height:120px!important}.right-arrow{display:inline-block;color:#3f51b5;text-transform:capitalize}.right-arrow:after{content:\"\\F30F\";font-family:Material-Design-Iconic-Font;color:#3f51b5;margin-left:8px;font-size:20px;vertical-align:middle}.right-arrow:focus,.right-arrow:hover{text-decoration:none}.letter-spacing-base{letter-spacing:3px}.letter-spacing-lg{letter-spacing:6px}.letter-spacing-xl{letter-spacing:8px}.page-heading{margin-bottom:38px}.page-heading .title{text-transform:capitalize;font-weight:600}.page-heading .breadcrumb{padding:0;background-color:transparent;margin-bottom:0}@media screen and (max-width:575px){.page-heading{margin-bottom:18px}}.sub-heading{font-size:13px;color:#adb5bd;margin-bottom:0}.sub-heading:not(:last-child){margin-bottom:16px!important}.manage-margin{margin-bottom:0}.manage-margin>*{margin-bottom:6px}.manage-margin>:not(:last-child){margin-right:16px}.no-shadow{-webkit-box-shadow:none!important;-moz-box-shadow:none!important;-o-box-shadow:none!important;box-shadow:none!important}.shadow-sm{-webkit-box-shadow:0 1px 2px 0 rgba(0,0,0,.15);-moz-box-shadow:0 1px 2px 0 rgba(0,0,0,.15);-o-box-shadow:0 1px 2px 0 rgba(0,0,0,.15);box-shadow:0 1px 2px 0 rgba(0,0,0,.15)}.shadow{-webkit-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);-moz-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);-o-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);box-shadow:0 1px 4px 0 rgba(0,0,0,.15)}.shadow-lg{-webkit-box-shadow:0 1px 8px -1px rgba(0,0,0,.2);-moz-box-shadow:0 1px 8px -1px rgba(0,0,0,.2);-o-box-shadow:0 1px 8px -1px rgba(0,0,0,.2);box-shadow:0 1px 8px -1px rgba(0,0,0,.2)}.shadow-xl{-webkit-box-shadow:0 0 16px 0 rgba(0,0,0,.2);-moz-box-shadow:0 0 16px 0 rgba(0,0,0,.2);-o-box-shadow:0 0 16px 0 rgba(0,0,0,.2);box-shadow:0 0 16px 0 rgba(0,0,0,.2)}.avatar-shadow{-webkit-box-shadow:0 1px 3px 0 rgba(0,0,0,.5);-moz-box-shadow:0 1px 3px 0 rgba(0,0,0,.5);-o-box-shadow:0 1px 3px 0 rgba(0,0,0,.5);box-shadow:0 1px 3px 0 rgba(0,0,0,.5)}.remove-table-border td,.remove-table-border th{border:0 none}.media-list{margin-bottom:10px}.media-list:not(:last-child){border-bottom:1px solid #e9ecef;padding-bottom:15px;margin-bottom:20px;position:relative}.border-2{border:2px solid #ced4da!important}.border-w2{border-width:2px}.border-primary{border-color:#3f51b5!important}.border-red{border-color:#f44336!important}.border-pink{border-color:#e91e63!important}.border-purple{border-color:#9c27b0!important}.border-deep-purple{border-color:#673ab7!important}.border-indigo{border-color:#3f51b5!important}.border-blue{border-color:#2196f3!important}.border-light-blue{border-color:#03a9f4!important}.border-cyan{border-color:#00bcd4!important}.border-teal{border-color:#009688!important}.border-green{border-color:#4caf50!important}.border-light-green{border-color:#8bc34a!important}.border-lime{border-color:#cddc39!important}.border-yellow{border-color:#ffeb3b!important}.border-amber{border-color:#ffc107!important}.border-orange{border-color:#ff9800!important}.border-deep-orange{border-color:#ff5722!important}.border-brown{border-color:#795548!important}.border-blue-grey{border-color:#607d8b!important}.border-grey{border-color:#9e9e9e!important}.center-crop-img{position:relative;width:100%;min-height:120px;overflow:hidden}.center-crop-img img{position:absolute;left:50%;top:50%;height:100%;width:auto;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.center-crop-img img.portrait{width:100%;height:auto}.icon-btn,.pointer{cursor:pointer}.icon-btn{height:48px;display:flex;align-items:center;width:48px;justify-content:center;font-size:20px;color:#6c757d}.header-notifications .icon-btn{padding:0 4px}.avatar{width:60px;height:60px;line-height:60px}.avatar,.avatar-lg{text-align:center;color:#fafafa}.avatar-lg{width:80px;height:80px;line-height:80px}.avatar-sm{width:40px;height:40px;text-align:center;color:#fafafa}.animated{-webkit-animation-fill-mode:none!important;animation-fill-mode:none!important}.overflow-hidden{overflow:hidden}.icons-showcase>div{cursor:pointer;padding:7px 15px;border-radius:4px;overflow:hidden;text-align:left;text-overflow:ellipsis;white-space:nowrap}.text-decoration{text-decoration:none!important}.row-5{margin-left:-5px;margin-right:-5px}.row-5>[class*=col-]{padding-left:5px;padding-right:5px}.font-size-16{font-size:16px!important}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-weight:400;margin:0 0 12px;color:inherit}.h1,h1{font-size:24px}.h2,h2{font-size:18px}.h3,h3{font-size:16px}.h4,h4{font-size:15px}.h5,h5{font-size:13px}.h6,h6{font-size:12px}.text-strikethrough{text-decoration:line-through!important}@media screen and (max-width:991px){.h1,h1{font-size:18px}.h2,h2{font-size:16px}.h3,h3{font-size:15px}}.desc-list{margin-bottom:0}.desc-list li{padding:24px 30px;border-bottom:1px solid #ced4da;margin-left:-30px;margin-right:-30px}.desc-list li:last-child{border-bottom:0 none}.desc-list li .card-title{margin-bottom:6px}.desc-list.even-odd li{border-bottom:0 none}.desc-list.even-odd li:nth-child(2n){background-color:#dee2e6}#app-site,.app-main{display:flex;width:100%;height:100%}.app-container{-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;width:100%}.app-container,.app-sidebar{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.app-sidebar{width:280px;min-width:280px;max-width:280px}.app-main-container,.app-sidebar{-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column}.app-main-container{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;width:100%;overflow:hidden;position:relative}.app-header{min-height:70px;z-index:99;position:relative}.app-main-content-wrapper{flex:1;display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;width:100%;overflow-x:hidden;overflow-y:auto}.app-container.collapsible-drawer .app-main-header,.app-container.fixed-drawer .app-main-header{width:auto!important;-webkit-transition:all .5s cubic-bezier(0,0,.2,1)!important;-o-transition:all .5s cubic-bezier(0,0,.2,1)!important;transition:all .5s cubic-bezier(0,0,.2,1)!important}.app-container.collapsible-drawer .app-main-container{position:relative}.app-container.mini-drawer .app-main-header{width:auto!important;-webkit-transition:all .5s cubic-bezier(0,0,.2,1)!important;-o-transition:all .5s cubic-bezier(0,0,.2,1)!important;transition:all .5s cubic-bezier(0,0,.2,1)!important}.app-container.mini-drawer .app-sidebar{width:80px;min-width:80px;max-width:80px}.side-nav{width:280px;background-color:#fff!important;color:#868e96!important;border-right:1px solid #e9ecef!important;z-index:1250!important}.side-nav .user-profile{background-color:#f7f7f7;padding:13px 20px!important}.side-nav .user-avatar{margin:0 15px 0 0!important;height:44px!important;width:44px!important;line-height:44px}.side-nav .user-detail .user-name{color:#3f51b5;cursor:pointer;font-size:13px;font-weight:400;white-space:nowrap}.user-detail .user-name{cursor:pointer}ul.nav-menu{position:relative;font-size:13px;list-style:outside none none;margin:0;padding:0;width:100%;height:100%}ul.nav-menu li{position:relative;margin-bottom:1px}ul.nav-menu li.menu+.nav-header{margin-top:40px}ul.nav-menu li.menu .sub-menu{display:none}ul.nav-menu li.menu.open .menu.active>.sub-menu,ul.nav-menu li.menu.open>.sub-menu{display:block}ul.nav-menu li a{color:#868e96;display:block;font-size:14px;font-weight:400;text-transform:capitalize;text-decoration:none;border-radius:0}ul.nav-menu li a .badge{margin-bottom:0;padding:3px 8px 2px}ul.nav-menu .nav-header{color:#868e96;padding:4px 22px;font-size:11px;text-transform:uppercase}ul.nav-menu .nav-header:first-child{margin-top:30px}ul.nav-menu>li.open>a,ul.nav-menu>li.selected>a,ul.nav-menu>li>a:focus,ul.nav-menu>li>a:hover{color:#3f51b5}ul.nav-menu li.menu>a{padding:16px 20px;border-left:2px solid transparent}ul.nav-menu li.menu.open>a{border-color:transparent}ul.nav-menu li.menu>a:focus:before,ul.nav-menu li.menu>a:hover:before{color:#3f51b5}ul.nav-menu li i{margin-right:12px;font-size:15px}ul.nav-menu li ul{list-style:outside none none;margin:0;padding:0;position:relative;overflow:hidden}ul.nav-menu li ul.sub-menu li>a{padding:7px 20px 7px 56px}ul.nav-menu li ul.sub-menu>li>ul>li>a{padding-left:76px}ul.nav-menu li ul.sub-menu>li>ul>li>ul>li>a{padding-left:96px}ul.nav-menu li ul.sub-menu>li>ul>li>ul>li>ul>li>a{padding-left:116px}ul.nav-menu li.menu>a:before{color:#868e96;content:\"\\F2FB\";display:inline-block;float:right;font-family:Material-Design-Iconic-Font;font-size:15px;margin-left:10px;position:relative;-webkit-transition:all .3s ease-in-out;-o-transition:all .3s ease-in-out;transition:all .3s ease-in-out;font-weight:400}ul.nav-menu li.menu.no-arrow>a:before{display:none}ul.nav-menu li.menu.open>a:before,ul.nav-menu li.menu.selected>a:before,ul.nav-menu li.menu>a:focus:before,ul.nav-menu li.menu li>a:hover:before{background-color:transparent;color:#3f51b5}ul.nav-menu li.menu.active>a:before,ul.nav-menu li.menu.open>a:before{-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);-o-transform:rotate(90deg);transform:rotate(90deg)}ul.nav-menu li.menu .sub-menu li>a.active .nav-text{padding:3px 7px;margin-left:-7px;background-color:#3f51b5;color:#fff;border-radius:4px;display:inline-block}ul.nav-menu li.menu.open .sub-menu li>a.active:before,ul.nav-menu li.menu .sub-menu li>a:focus,ul.nav-menu li.menu .sub-menu li>a:focus:before,ul.nav-menu li.menu .sub-menu li>a:hover,ul.nav-menu li.menu .sub-menu li>a:hover:before{color:#3f51b5}.app-container.mini-drawer .side-nav{-webkit-transition:all .2s ease-in-out;-o-transition:all .2s ease-in-out;transition:all .2s ease-in-out;width:80px}.app-container.mini-drawer .side-nav .customizer,.app-container.mini-drawer .side-nav .nav-menu li span.nav-text{display:none}.app-container.mini-drawer .side-nav .nav-menu .menu.open>.sub-menu,.app-container.mini-drawer .side-nav .user-profile .user-detail{display:none!important}.app-container.mini-drawer .side-nav .nav-menu li{text-align:center}.app-container.mini-drawer .side-nav .nav-menu li i{margin-right:0}.app-container.mini-drawer .side-nav .nav-menu li.nav-header{padding:4px 5px}.app-container.mini-drawer .side-nav ul.nav-menu li a{padding:16px 20px}.app-container.mini-drawer .side-nav ul.nav-menu ul.sub-menu li a{padding-left:30px}.app-container.mini-drawer .side-nav .mini-logo-img-hover,.app-container.mini-drawer .side-nav ul.nav-menu>li>a:before{display:none}.app-container.mini-drawer .side-nav:hover{width:280px}.app-container.mini-drawer .side-nav:hover .nav-menu li span.nav-text{display:inline-block!important}.app-container.mini-drawer .side-nav:hover .user-profile .user-detail{display:flex!important}.app-container.mini-drawer .side-nav:hover .nav-menu .menu.open>.sub-menu{display:block!important}.app-container.mini-drawer .side-nav:hover .customizer{display:flex!important}.app-container.mini-drawer .side-nav:hover ul.nav-menu li{text-align:left}.app-container.mini-drawer .side-nav:hover ul.nav-menu li i{margin-right:16px}.app-container.mini-drawer .side-nav:hover ul.nav-menu li a{padding:16px 20px}.app-container.mini-drawer .side-nav:hover ul.nav-menu li.nav-header{padding:4px 22px}.app-container.mini-drawer .side-nav:hover ul.nav-menu ul.sub-menu li a{padding:7px 20px 7px 56px}.app-container.mini-drawer .side-nav:hover ul.nav-menu ul.sub-menu>li>ul>li>a{padding-left:76px}.app-container.mini-drawer .side-nav:hover ul.nav-menu ul.sub-menu>li>ul>li>ul>li>a{padding-left:96px}.app-container.mini-drawer .side-nav:hover ul.nav-menu ul.sub-menu>li>ul>li>ul>li>ul>li>a{padding-left:116px}.app-container.mini-drawer .side-nav:hover ul.nav-menu>li>a:before{display:block}.app-container.mini-drawer .side-nav:hover .mini-logo-img{display:none}.app-container.mini-drawer .side-nav:hover .mini-logo-img-hover{display:block}.customizer{padding:20px 35px}.customizer img{padding:5px;cursor:pointer}.user-info ul li{font-size:15px}.rc-drawer-left .rc-drawer-sidebar,.rc-drawer-right .rc-drawer-sidebar{height:100vh}.rc-drawer-sidebar{position:fixed;transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.rc-drawer.rc-drawer-left .rc-drawer-sidebar{left:0;-webkit-transform:translateX(-100%);transform:translateX(-100%);z-index:903}.rc-drawer.rc-drawer-right .rc-drawer-sidebar{right:0;-webkit-transform:translateX(100%);transform:translateX(100%);z-index:903}.rc-drawer.rc-drawer-bottom .rc-drawer-sidebar,.rc-drawer.rc-drawer-top .rc-drawer-sidebar{z-index:903}.drawer-container{position:relative}.drawer-container .main{position:relative;padding:10px;box-sizing:border-box}.rc-drawer-overlay{z-index:902;position:fixed;top:0;left:0;right:0;bottom:0;opacity:0;visibility:hidden;transition:opacity .3s ease-out;background-color:rgba(0,0,0,.3);height:100vh;min-width:100%!important}.app-sidebar.rc-drawer.rc-drawer-docked{position:relative}.jr-menu-icon{outline:none!important;-webkit-justify-content:flex-start!important;justify-content:flex-start!important;padding:0 5px!important;margin-right:15px;display:flex;cursor:pointer;align-items:center}.app-main-header{background-color:#fff;color:gray;max-height:70px;position:relative}.app-main-header .search-bar input{-webkit-transition:all .2s ease-in-out;-o-transition:all .2s ease-in-out;transition:all .2s ease-in-out;background-color:transparent;color:gray}.app-main-header .search-bar input+.search-icon{top:0}.app-main-header .search-bar input+.search-icon i{color:hsla(0,0%,50%,.8)}.app-main-header .search-bar input:focus{background-color:#f4f4f4;color:gray}.app-main-header .search-bar input:focus+.search-icon i{color:hsla(0,0%,50%,.8)}.app-header .app-main-header{border-bottom:1px solid #dee2e6}.jr-card .app-main-header{border:1px solid #ced4da;border-radius:8px}.app-logo{margin-right:12px}.app-logo img{height:35px}@media screen and (max-width:575px){.app-logo img{height:28px}}.app-header .app-logo{margin-right:20px}@media screen and (max-width:991px){.app-header .app-logo{margin-right:auto}}.react-logo-white.d-block{display:none!important}@media screen and (min-width:992px){.react-logo-white.d-lg-block{display:none!important}}.sidebar-header{min-height:70px;padding:10px 22px;border-bottom:1px solid #dee2e6}.app-toolbar{min-height:70px;padding:0 40px}.app-toolbar .search-bar{margin-right:auto;max-width:320px;width:300px}@media screen and (max-width:1199px){.app-toolbar .search-bar{width:240px}}@media screen and (max-width:1099px){.app-toolbar .search-bar{width:200px}}@media screen and (max-width:767px){.app-toolbar .search-bar{margin-left:40px;width:180px}}@media screen and (max-width:575px){.app-toolbar{padding:0 20px}}.app-top-nav .app-toolbar{min-height:40px}@media screen and (max-width:1199px){.app-header-horizontal .app-toolbar .search-bar{margin-right:10px}}.app-toolbar-special .search-bar{width:200px}@media screen and (max-width:991px){.app-toolbar-special .search-bar{width:280px}}@media screen and (max-width:767px){.app-toolbar-special .search-bar{width:200px}}.app-toolbar .nav-searchbox .search-bar{margin-left:0;width:100%}.app-toolbar .nav-searchbox .search-bar input{-webkit-transition:all .2s ease-in-out;-o-transition:all .2s ease-in-out;transition:all .2s ease-in-out;background-color:#fff;color:#5c5c5c}.app-toolbar .nav-searchbox .search-bar input+.search-icon i{color:rgba(92,92,92,.8)}.app-toolbar .nav-searchbox .search-bar input:focus{background-color:transparent;color:#5c5c5c}.app-toolbar .nav-searchbox .search-bar input:focus+.search-icon i{color:rgba(92,92,92,.8)}.header-notifications{margin-bottom:0}.header-notifications li{vertical-align:middle}@media screen and (max-width:449px){.header-notifications .list-inline-item:not(:last-child){margin-right:0}}.dropdown-menu{-webkit-box-shadow:none;-moz-box-shadow:none;-o-box-shadow:none;box-shadow:none}.quick-menu .dropdown-menu{padding:5px 10px;width:350px}.quick-menu .dropdown-menu .jr-card-header{margin:-5px -10px 5px;padding:10px 10px 10px 20px;border-bottom:1px solid #dee2e6;z-index:10}.quick-menu .dropdown-menu:after{border-bottom:5px solid #fff;top:-9px;height:9px}.quick-menu .dropdown-menu:after,.quick-menu .dropdown-menu:before{border-left:5px solid transparent;border-right:5px solid transparent;content:\"\";position:absolute;right:8px;width:10px}.quick-menu .dropdown-menu:before{border-bottom:5px solid #000;top:-10px;height:10px}@media screen and (max-width:449px){.quick-menu .dropdown-menu{width:230px}}@media screen and (max-width:359px){.quick-menu .dropdown-menu{width:180px}}.quick-menu .messages-list .user-avatar{position:relative}.quick-menu .messages-list .badge{position:absolute;left:-4px;top:-4px;height:16px;width:16px;line-height:16px;text-align:center;padding:0}.app-header .nav-searchbox.quick-menu .dropdown-menu{width:200px;left:0!important;right:auto!important}.app-header .nav-searchbox.quick-menu .dropdown-menu:after,.app-header .nav-searchbox.quick-menu .dropdown-menu:before{right:auto;left:8px}@media screen and (max-width:400px){.app-header .nav-searchbox.quick-menu{display:none}}@media screen and (max-width:575px){.app-header .nav-searchbox.quick-menu .dropdown-menu{width:200px}}@media screen and (max-width:399px){.app-header .nav-searchbox.quick-menu .dropdown-menu{width:100px}}.language-list li{display:block!important}.messages-list.language-list ul li{padding:7px 6px 6px}.messages-list ul li{position:relative;padding:20px 10px 14px;border-bottom:1px solid #dee2e6}.messages-list ul li .user-name a{color:#3f51b5}.messages-list ul li .sub-heading{font-size:11px;margin-bottom:6px!important}.messages-list ul li .sub-heading.mb-0{margin-bottom:0!important}.messages-list ul li:last-child{border-bottom:0 none}.messages-list ul li .jr-btn{margin-right:0!important}.messages-list ul li .jr-btn-xs{font-size:11px!important;padding:5px!important}.quick-menu .icon-btn{color:gray}.quick-menu .icon-alert{position:relative}.quick-menu .icon-alert:after{display:block;position:absolute;content:\"\";right:0;top:0;z-index:10;width:8px;height:8px;background-color:#f44336;border-radius:50%}.quick-menu i.animated.infinite{-moz-animation-iteration-count:25;-webkit-animation-iteration-count:25;-o-animation-iteration-count:25;animation-iteration-count:25}.quick-menu .dropdown-menu{display:block;visibility:hidden;left:auto!important;right:0!important;opacity:0;transform:translate3d(0,100px,0)!important;-webkit-transition:all .2s linear 0ms;-o-transition:all .2s linear 0ms;transition:all .2s linear 0ms}.quick-menu.show .dropdown-menu{opacity:1;transform:translate3d(0,30px,0)!important;visibility:visible}.user-nav .quick-menu .dropdown-menu{width:200px;padding:0 0 15px}.user-nav .quick-menu .dropdown-menu:after{border-bottom-color:#f4f4f4}.user-nav .quick-menu .user-profile{position:relative;padding:20px 25px;background-color:#f4f4f4;margin-bottom:15px;border-radius:.25rem .25rem 0 0}.module-box-header-right{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center}.app-top-header{position:relative;z-index:9999}.app-main-menu .navbar-nav{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap}.navbar-nav,.navbar-nav li{position:relative}.navbar-nav li:focus>ul.sub-menu,.navbar-nav li:hover>ul.sub-menu{opacity:1;visibility:visible;top:100%}.navbar-nav li:focus>a,.navbar-nav li:hover>a{color:#3f51b5}.navbar-nav li a{display:block;color:#868e96;padding:10px 0;font-size:14px}.navbar-nav li a:focus,.navbar-nav li a:hover{text-decoration:none;color:#3f51b5}.navbar-nav li.mega-menu{position:static}.navbar-nav li.mega-menu ul.sub-menu{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;width:85%;margin:0 auto;left:0;right:0}.navbar-nav li.mega-menu ul.sub-menu li{width:25%;padding:0 15px}.navbar-nav>li:last-child ul.sub-menu{left:auto;right:0}.navbar-nav>li:last-child ul.sub-menu ul.sub-menu{left:auto;right:100%;top:50px}.navbar-nav>li:last-child ul.sub-menu li:focus>ul.sub-menu,.navbar-nav>li:last-child ul.sub-menu li:hover>ul.sub-menu{top:0}.navbar-nav li.nav-item{padding:0 10px}.navbar-nav li.nav-item>a{padding:23px 0}.navbar-nav li.nav-item.active>a,.navbar-nav li.nav-item:focus>a,.navbar-nav li.nav-item:hover>a,.navbar-nav li.nav-item>a:focus,.navbar-nav li.nav-item>a:hover{color:#3f51b5}.navbar-nav ul.sub-menu{list-style:none;border:1px solid #ced4da;position:absolute;left:0;top:100px;opacity:0;padding:10px 0;background-color:#fff;visibility:hidden;border-radius:4px;-webkit-transition:all .5s ease-in-out;-o-transition:all .5s ease-in-out;transition:all .5s ease-in-out}.navbar-nav ul.sub-menu li a{padding:5px 15px;width:200px;font-size:14px}.navbar-nav ul.sub-menu li a.active{color:#3f51b5}.navbar-nav ul.sub-menu li>ul.sub-menu{left:100%;right:auto;top:50px}.navbar-nav ul.sub-menu li:focus>ul.sub-menu,.navbar-nav ul.sub-menu li:hover>ul.sub-menu{top:0}.navbar-nav ul.sub-menu li a i{margin-right:10px}.navbar-nav ul.sub-menu li.active>a{color:#3f51b5}.navbar-nav .nav-arrow>a{position:relative}.navbar-nav .nav-arrow>a:before{color:#868e96;content:\"\\F2FB\";display:inline-block;float:right;font-family:Material-Design-Iconic-Font;font-size:15px;margin-left:10px;position:relative;-webkit-transition:all .3s ease-in-out;-o-transition:all .3s ease-in-out;transition:all .3s ease-in-out;font-weight:400}.navbar-nav .nav-arrow.active>a:before,.navbar-nav .nav-arrow:focus>a:before,.navbar-nav .nav-arrow:hover>a:before,.navbar-nav .nav-arrow a:focus:before,.navbar-nav .nav-arrow a:hover:before{color:#3f51b5}.navbar-nav ul.sub-menu-half{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;width:300px}.navbar-nav ul.sub-menu-half li{width:50%}.navbar-nav ul.sub-menu-half li a{width:100%}@media screen and (max-width:1099px){.navbar-nav ul.sub-menu-half li a{font-size:13px}}@media screen and (max-width:1099px){.navbar-nav ul.sub-menu-half{width:262px}}.navbar-nav-mega{position:static!important}.app-top-nav{background-color:#3f51b5}.app-top-nav .navbar-nav li.nav-item{padding:0 30px}.app-top-nav .navbar-nav li.nav-item>a{color:#fff;padding:13px 0}.app-top-nav .navbar-nav li.nav-item.active>a,.app-top-nav .navbar-nav li.nav-item:focus>a,.app-top-nav .navbar-nav li.nav-item:hover>a,.app-top-nav .navbar-nav li.nav-item>a:focus,.app-top-nav .navbar-nav li.nav-item>a:hover{color:#e91e63}.app-top-nav .navbar-nav ul.sub-menu{margin-top:0}.app-main-content{flex:1;width:100%;background-color:#fff}.app-wrapper{padding:36px 40px 0;width:100%;height:100%}@media screen and (max-width:575px){.app-wrapper{padding:20px}}.app-footer{padding:0 40px;border-top:1px solid #dbdbdb;background-color:#f4f4f4;line-height:50px;min-height:50px}.app-footer,.app-footer a{color:#868e96}.app-footer a:hover{color:#3f51b5}@media screen and (max-width:575px){.app-footer{padding:20px}}@media screen and (max-width:400px){.app-footer{font-size:12px}}.color-theme{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;max-width:300px;height:100%}@media screen and (max-width:499px){.color-theme{max-width:250px}}.color-theme-header{background-color:#3f51b5;color:#fff;padding:19px 25px 20px;text-transform:uppercase;display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center;-webkit-justify-content:space-between;justify-content:space-between}.color-theme-header .color-theme-title{margin-bottom:0}.color-theme-body{padding:28px 25px}.color-theme-body h3{margin-bottom:20px}@media screen and (max-width:499px){.color-theme-body{padding:25px 15px}}.color-option{list-style:none;padding-left:0;margin:0 -7px 10px}.color-option li{position:relative;display:inline-block;padding:0 7px;margin-bottom:10px}.color-option li a{height:45px;width:45px;line-height:45px;display:inline-block;color:transparent!important;position:relative}.color-option li a:before{content:\"\\F26B\";font-family:Material-Design-Iconic-Font;font-size:20px;height:45px;width:45px;line-height:45px;position:absolute;top:0;left:0;color:#fff;text-align:center;display:none;z-index:2}.color-option li a.active:before{display:block}.cr-op-dark-sidebar li a:after{content:\"\";position:absolute;left:0;top:0;bottom:0;z-index:1;background-color:#5c5c5c;width:8px}.theme-option{position:fixed;top:12%;right:0;z-index:1500;background-color:#9c27b0;border-top-left-radius:4px;border-bottom-left-radius:4px;-webkit-box-shadow:1px 1px 4px rgba(0,0,0,.5);-moz-box-shadow:1px 1px 4px rgba(0,0,0,.5);-o-box-shadow:1px 1px 4px rgba(0,0,0,.5);box-shadow:1px 1px 4px rgba(0,0,0,.5);color:#fff}.theme-option span.icon-btn{position:relative;z-index:1505}.app-sidebar-content.right-sidebar .rc-drawer-sidebar{z-index:1506;color:#5c5c5c;background-color:#fff}.material-switch{margin-bottom:24px}.material-switch>input[type=checkbox]{display:none}.material-switch>label{cursor:pointer;height:0;position:relative;width:40px}.material-switch>label:before{background:#000;box-shadow:inset 0 0 10px rgba(0,0,0,.5);border-radius:8px;content:\"\";height:16px;margin-top:-8px;position:absolute;opacity:.3;transition:all .4s ease-in-out;width:40px}.material-switch>label:after{background:#fff;border-radius:16px;box-shadow:0 0 5px rgba(0,0,0,.3);content:\"\";height:24px;left:-4px;margin-top:-8px;position:absolute;top:-4px;transition:all .3s ease-in-out;width:24px}.material-switch>input[type=checkbox]:checked+label:before{background:#000;opacity:.5}.material-switch>input[type=checkbox]:checked+label:after{background:#495057;left:20px}@media screen and (max-width:499px){.color-theme .jr-btn{padding:10px 15px!important}}.alert{border:0 none;padding:20px 24px;border-radius:8px;position:relative}.alert .close{line-height:inherit;font-weight:300}.alert .alert-addon{width:60px;background-color:rgba(0,0,0,.2);display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-justify-content:center;justify-content:center;-webkit-align-items:center;align-items:center;position:absolute;left:0;top:0;bottom:0;z-index:1}.alert-dismissible{padding-right:60px}.alert-addon-card{padding-left:80px}.user-avatar{display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;position:relative;overflow:hidden;-webkit-justify-content:center;justify-content:center;-webkit-align-items:center;align-items:center;-webkit-flex-shrink:0;flex-shrink:0;border-radius:50%;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;border:1px solid #ced4da}.user-avatar.avatar-shadow{border:0 none}.user-profile{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:flex-start;align-items:flex-start}.user-profile .user-detail{-webkit-flex:1;flex:1;-ms-flex-align:center;-webkit-align-self:center;align-self:center}.user-detail .user-name{margin-bottom:2px;font-weight:400;text-transform:capitalize}.user-detail .user-description{font-size:12px;margin-bottom:0;color:#adb5bd}.user-thumb{position:relative}.messages-list .user-thumb{margin-right:8px}.badge{font-weight:400;padding:3px 8px;line-height:inherit;margin-bottom:6px;border-radius:2px}.badge:not(:last-child){margin-right:15px}table .badge{margin-bottom:0}.badge-pill{border-radius:20px}.badge-border{border:2px solid!important}.badge-outline{background-color:transparent;border:1px solid #ced4da}blockquote{padding:10px 0 10px 20px}blockquote,blockquote .blockquote-footer{font-size:13px!important}.blockquote{border-left:5px solid #e9ecef}.blockquote-reverse{border-left:0 none;border-right:5px solid #e9ecef;text-align:right;padding-left:0;padding-right:20px}.bottom-navigation button{min-width:10px!important}.breadcrumb{border-radius:2px}.breadcrumb-item+.breadcrumb-item:before{content:\"\\F2FB\";font-family:Material-Design-Iconic-Font;font-size:16px;line-height:1;vertical-align:middle}button{outline:0 none!important;cursor:pointer;border:1px solid transparent}.jr-btn{position:relative;display:inline-block;font-size:13px;font-weight:400;text-transform:capitalize;line-height:1.2;border-radius:4px;vertical-align:top;cursor:pointer;text-align:center}.jr-btn:active,.jr-btn:focus,.jr-btn:hover{outline:0 none;text-decoration:none;-webkit-box-shadow:none!important;-moz-box-shadow:none!important;-o-box-shadow:none!important;box-shadow:none!important}.login-content .jr-btn{padding:10px 35px}.btn:active,.btn:focus,.btn:hover{outline:0 none;text-decoration:none;-webkit-box-shadow:none!important;-moz-box-shadow:none!important;-o-box-shadow:none!important;box-shadow:none!important}.login-content .btn{padding:10px 35px}.btn,.btn-danger,.btn-dark,.btn-info,.btn-light,.btn-primary,.btn-secondary,.btn-success,.btn-warning,.show>.btn-danger.dropdown-toggle:focus,.show>.btn-dark.dropdown-toggle:focus,.show>.btn-info.dropdown-toggle:focus,.show>.btn-light.dropdown-toggle:focus,.show>.btn-primary.dropdown-toggle:focus,.show>.btn-secondary.dropdown-toggle:focus,.show>.btn-success.dropdown-toggle:focus,.show>.btn-warning.dropdown-toggle:focus,.show>.btn.dropdown-toggle:focus{-webkit-box-shadow:none!important;-moz-box-shadow:none!important;-o-box-shadow:none!important;box-shadow:none!important}.btn,.jr-btn,.jr-fab-btn,.jr-flat-btn{margin-bottom:6px;text-transform:capitalize}.btn:not(:last-child),.jr-btn:not(:last-child),.jr-fab-btn:not(:last-child),.jr-flat-btn:not(:last-child){margin-right:15px}.form-inline .btn,.form-inline .jr-btn,.form-inline .jr-fab-btn,.form-inline .jr-flat-btn{margin-bottom:0;min-height:35px}.navbar .btn,.navbar .jr-btn,.navbar .jr-fab-btn,.navbar .jr-flat-btn{margin-bottom:0}.btn-primary.focus,.btn-primary:focus{box-shadow:none!important}.input-group>.input-group-append>.btn,.input-group>.input-group-prepend>.btn{margin-right:0;margin-bottom:0;line-height:inherit}.jr-fab-btn{position:relative;display:inline-flex;border-radius:50%;-webkit-justify-content:center;justify-content:center;-webkit-align-items:center;align-items:center;background-color:#eee;overflow:hidden}.jr-fab-btn:focus,.jr-fab-btn:hover{outline:0 none;text-decoration:none}.jr-btn,.jr-flat-btn{padding:12px 20px}.jr-btn i+span,.jr-btn span+i,.jr-flat-btn i+span,.jr-flat-btn span+i{margin-left:6px}.jr-flat-btn{background-color:transparent;color:#5c5c5c}.jr-flat-btn:active,.jr-flat-btn:focus,.jr-flat-btn:hover{background-color:#f5f5f5;color:#5c5c5c}.jr-btn-group{margin:0 -8px}.jr-btn-group:not(:last-child){margin-bottom:16px}.jr-btn-group .jr-btn,.jr-btn-group .jr-fab-btn{margin:0 8px 18px}.jr-btn-rounded{border-radius:50px!important}.btn-group-lg>.jr-btn,.jr-btn-lg{padding:16px 24px}.btn-group-sm>.jr-btn,.jr-btn-sm{padding:8px 15px}.jr-btn-xs{padding:6px 10px}.btn-group-lg>.jr-btn,.jr-btn-fab-lg,.jr-btn-lg{font-size:17px}.btn-group-lg>.jr-btn i,.jr-btn-fab-lg i,.jr-btn-lg i{font-size:19px}.btn-group-sm>.jr-btn,.btn-group-sm>.jr-btn i,.jr-btn-fab-sm,.jr-btn-fab-sm i,.jr-btn-sm,.jr-btn-sm i{font-size:11px}.jr-btn-fab-xs,.jr-btn-fab-xs i,.jr-btn-xs,.jr-btn-xs i{font-size:10px}.complex-btn-wrapper{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;min-width:200px;width:100%}.complex-btn{position:relative;height:200px;overflow:hidden;width:33.333%;border:0 none}@media screen and (max-width:767px){.complex-btn{width:100%;height:100px}}.complex-btn:hover{z-index:1}.complex-btn:hover .img-btn-overlay{opacity:.15}.complex-btn:hover .img-marked{opacity:0}.complex-btn:hover .img-title{border:4px solid currentColor}.complex-btn .img-btn{display:flex;-webkit-align-items:center;align-items:center;-webkit-justify-content:center;justify-content:center;color:#fff}.complex-btn .img-btn,.complex-btn .img-src{position:absolute;left:0;right:0;top:0;bottom:0}.complex-btn .img-src{background-size:cover;background-position:center 40%}.complex-btn .img-btn-overlay{position:absolute;left:0;right:0;top:0;bottom:0;background:#000;opacity:.4;-webkit-transition:all .5s cubic-bezier(.4,0,.2,1);-o-transition:all .5s cubic-bezier(.4,0,.2,1);transition:all .5s cubic-bezier(.4,0,.2,1)}.complex-btn .img-title{position:relative;padding:16px 32px 14px}.complex-btn .img-marked{height:3px;width:18px;background:#fff;position:absolute;bottom:-2px;left:calc(50% - 9px);-webkit-transition:all .5s cubic-bezier(.4,0,.2,1);-o-transition:all .5s cubic-bezier(.4,0,.2,1);transition:all .5s cubic-bezier(.4,0,.2,1)}.btn-group-mins{margin:0 -5px}.btn-group-mins .btn,.btn-group-mins .jr-btn{margin:0 5px 5px}.jr-btn.jr-btn-label i{background-color:hsla(0,0%,100%,.2);width:40px;height:100%;line-height:42px;text-align:center}.jr-btn.jr-btn-label.left i{position:absolute;top:0;left:0;bottom:0;z-index:1}.jr-btn.jr-btn-label.right i{position:absolute;top:0;right:0;bottom:0;z-index:1}.jr-btn.jr-btn-label.left i+span{margin-left:30px}.jr-btn.jr-btn-label.right i+span{margin-right:30px;margin-left:0}.btn-group-lg>.jr-btn.jr-btn-label i,.jr-btn.jr-btn-label.jr-btn-lg i{line-height:54px}.btn-group-sm>.jr-btn.jr-btn-label i,.jr-btn.jr-btn-label.jr-btn-sm i{line-height:32px}.jr-btn.jr-btn-label.jr-btn-xs i{line-height:24px;width:30px}.btn-primary{background-color:#3f51b5;color:#fff}.btn-primary:focus,.btn-primary:hover{background-color:#3849a2;color:#fff}.btn-red{background-color:#f44336;color:#fff}.btn-red:focus,.btn-red:hover{background-color:#f32c1e;color:#fff}.btn-pink{background-color:#e91e63;color:#fff}.btn-pink:focus,.btn-pink:hover{background-color:#d81558;color:#fff}.btn-purple{background-color:#9c27b0;color:#fff}.btn-purple:focus,.btn-purple:hover{background-color:#89229b;color:#fff}.btn-deep-purple{background-color:#673ab7;color:#fff}.btn-deep-purple:focus,.btn-deep-purple:hover{background-color:#5c34a4;color:#fff}.btn-indigo{background-color:#3f51b5;color:#fff}.btn-indigo:focus,.btn-indigo:hover{background-color:#3849a2;color:#fff}.btn-blue{background-color:#2196f3;color:#fff}.btn-blue:focus,.btn-blue:hover{background-color:#0d8aee;color:#fff}.btn-light-blue{background-color:#03a9f4;color:#fff}.btn-light-blue:focus,.btn-light-blue:hover{background-color:#0398db;color:#fff}.btn-cyan{background-color:#00bcd4;color:#fff}.btn-cyan:focus,.btn-cyan:hover{background-color:#00a5bb;color:#fff}.btn-teal{background-color:#009688;color:#fff}.btn-teal:focus,.btn-teal:hover{background-color:#007d71;color:#fff}.btn-green{background-color:#4caf50;color:#fff}.btn-green:focus,.btn-green:hover{background-color:#449d48;color:#fff}.btn-light-green{background-color:#8bc34a;color:#fff}.btn-light-green:focus,.btn-light-green:hover{background-color:#7eb73d;color:#fff}.btn-lime{background-color:#cddc39;color:#fff}.btn-lime:focus,.btn-lime:hover{background-color:#c6d626;color:#fff}.btn-yellow{background-color:#ffeb3b;color:#fff}.btn-yellow:focus,.btn-yellow:hover{background-color:#ffe822;color:#fff}.btn-amber{background-color:#ffc107;color:#fff}.btn-amber:focus,.btn-amber:hover{background-color:#edb100;color:#fff}.btn-orange{background-color:#ff9800;color:#fff}.btn-orange:focus,.btn-orange:hover{background-color:#e68900;color:#fff}.btn-deep-orange{background-color:#ff5722;color:#fff}.btn-deep-orange:focus,.btn-deep-orange:hover{background-color:#ff4409;color:#fff}.btn-brown{background-color:#795548;color:#fff}.btn-brown:focus,.btn-brown:hover{background-color:#694a3e;color:#fff}.btn-blue-grey{background-color:#607d8b;color:#fff}.btn-blue-grey:focus,.btn-blue-grey:hover{background-color:#566f7c;color:#fff}.btn-grey{background-color:#9e9e9e;color:#fff}.btn-grey:focus,.btn-grey:hover{background-color:#919191;color:#fff}.jr-btn-shadow,.jr-btn-shadow:focus,.jr-btn-shadow:hover{-webkit-box-shadow:0 1px 5px 0 rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.12)!important;-moz-box-shadow:0 1px 5px 0 rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.12)!important;-o-box-shadow:0 1px 5px 0 rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.12)!important;box-shadow:0 1px 5px 0 rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.12)!important}.jr-btn-shadow:active{-webkit-box-shadow:none!important;-moz-box-shadow:none!important;-o-box-shadow:none!important;box-shadow:none!important}.jr-btn.disabled{pointer-events:none;opacity:.65}.jr-btn-default{background-color:#fff;color:#5c5c5c;border:1px solid #dee2e6}.jr-btn-default:focus,.jr-btn-default:hover{background-color:#f2f2f2;color:#5c5c5c}.jr-btn-secondary{background-color:#e91e63;color:#fff}.jr-btn-secondary:focus,.jr-btn-secondary:hover{background-color:#d81558;color:#fff}.jr-flat-btn.jr-btn-primary{background-color:transparent;color:#3f51b5}.jr-flat-btn.jr-btn-primary:focus,.jr-flat-btn.jr-btn-primary:hover{background-color:rgba(63,81,181,.12);color:#3f51b5}.bg-primary .jr-flat-btn.jr-btn-primary{background-color:transparent;color:#fff}.bg-primary .jr-flat-btn.jr-btn-primary:focus,.bg-primary .jr-flat-btn.jr-btn-primary:hover{background-color:hsla(0,0%,100%,.12);color:#fff}.jr-flat-btn.jr-btn-secondary{background-color:transparent;color:#e91e63}.jr-flat-btn.jr-btn-secondary:focus,.jr-flat-btn.jr-btn-secondary:hover{background-color:rgba(233,30,99,.12);color:#e91e63}.bg-secondary .jr-flat-btn.jr-btn-secondary{background-color:transparent;color:#fff}.bg-secondary .jr-flat-btn.jr-btn-secondary:focus,.bg-secondary .jr-flat-btn.jr-btn-secondary:hover{background-color:hsla(0,0%,100%,.12);color:#fff}.jr-btn-hover:hover:after{content:\"\";position:absolute;top:0;bottom:0;left:0;right:0;z-index:1;display:inline-block;background-color:rgba(0,0,0,.06)}.dropdown-toggle-split{padding-right:.5625rem;padding-left:.5625rem}.action-btn{height:40px;width:40px;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;-webkit-align-items:center;align-items:center;-webkit-justify-content:center;justify-content:center;font-size:24px;cursor:pointer;vertical-align:middle;color:rgba(0,0,0,.54)}.action-btn:active,.action-btn:focus,.action-btn:hover{text-decoration:none;color:rgba(0,0,0,.64)}.circle-check .action-btn{height:24px;width:24px;font-size:16px}.chat-main-header .action-btn{color:#fff}.action-replay .jr-btn-default{font-size:14px;padding:5px 10px;border-color:#6c757d!important}.btn-outline-primary:focus,.btn-outline-secondary:focus{-webkit-box-shadow:none!important;-moz-box-shadow:none!important;-o-box-shadow:none!important;box-shadow:none!important}.btn-group,.btn-group-vertical{position:relative;display:inline-flex;vertical-align:middle}.btn-group-vertical>.jr-btn,.btn-group>.jr-btn{position:relative;flex:0 1 auto;border-color:#dee2e6}.btn-group-vertical>.jr-btn.active,.btn-group-vertical>.jr-btn:active,.btn-group-vertical>.jr-btn:focus,.btn-group-vertical>.jr-btn:hover,.btn-group>.jr-btn.active,.btn-group>.jr-btn:active,.btn-group>.jr-btn:focus,.btn-group>.jr-btn:hover{z-index:2}.btn-group-vertical>.jr-btn.active,.btn-group>.jr-btn.active{background-color:#3f51b5;color:#fff;border-color:#3f51b5}.btn-group-vertical>.jr-btn.jr-flat-btn,.btn-group>.jr-btn.jr-flat-btn{border-color:transparent}.btn-group-vertical>.jr-btn.jr-flat-btn.active,.btn-group>.jr-btn.jr-flat-btn.active{background-color:transparent;color:#3f51b5}.btn-group-vertical>.jr-btn.jr-flat-btn.active:focus,.btn-group-vertical>.jr-btn.jr-flat-btn.active:hover,.btn-group>.jr-btn.jr-flat-btn.active:focus,.btn-group>.jr-btn.jr-flat-btn.active:hover{background-color:rgba(63,81,181,.12);color:#3f51b5}.btn-group-vertical .btn-group+.btn-group,.btn-group-vertical .btn-group+.jr-btn,.btn-group-vertical .jr-btn+.btn-group,.btn-group-vertical .jr-btn+.jr-btn,.btn-group .btn-group+.btn-group,.btn-group .btn-group+.jr-btn,.btn-group .jr-btn+.btn-group,.btn-group .jr-btn+.jr-btn{margin-left:-1px}.btn-group-vertical.no-border>.btn-group-vertical>.jr-btn,.btn-group-vertical.no-border>.btn-group>.jr-btn,.btn-group-vertical.no-border>.jr-btn,.btn-group.no-border>.btn-group-vertical>.jr-btn,.btn-group.no-border>.btn-group>.jr-btn,.btn-group.no-border>.jr-btn{border-color:transparent}.btn-toolbar{display:flex;flex-wrap:wrap;justify-content:flex-start}.btn-toolbar .input-group{width:auto}.btn-group>.jr-btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0}.btn-group>.jr-btn:first-child{margin-left:0}.btn-group>.jr-btn:first-child:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.dropdown-toggle:not(:first-child),.btn-group>.jr-btn:last-child:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.btn-group>.btn-group{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.jr-btn{border-radius:0}.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle,.btn-group>.btn-group:first-child:not(:last-child)>.jr-btn:last-child{border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.jr-btn:first-child{border-top-left-radius:0;border-bottom-left-radius:0}.jr-btn+.dropdown-toggle-split{padding-right:.5625rem;padding-left:.5625rem}.jr-btn+.dropdown-toggle-split:after{margin-left:0}.btn-group-sm>.jr-btn+.dropdown-toggle-split,.jr-btn-sm+.dropdown-toggle-split{padding-right:.375rem;padding-left:.375rem}.btn-group-lg>.jr-btn+.dropdown-toggle-split,.jr-btn-lg+.dropdown-toggle-split{padding-right:.75rem;padding-left:.75rem}.btn-group.show .dropdown-toggle{-webkit-box-shadow:inset 0 3px 5px rgba(0,0,0,.125);-moz-box-shadow:inset 0 3px 5px rgba(0,0,0,.125);-o-box-shadow:inset 0 3px 5px rgba(0,0,0,.125);box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.show .dropdown-toggle.btn-link{-webkit-box-shadow:none;-moz-box-shadow:none;-o-box-shadow:none;box-shadow:none}.btn-group-vertical{flex-direction:column;align-items:flex-start;justify-content:center}.btn-group-vertical .btn-group,.btn-group-vertical .jr-btn{width:100%}.btn-group-vertical>.btn-group+.btn-group,.btn-group-vertical>.btn-group+.jr-btn,.btn-group-vertical>.jr-btn+.btn-group,.btn-group-vertical>.jr-btn+.jr-btn{margin-top:-1px;margin-left:0}.btn-group-vertical>.jr-btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.jr-btn:first-child:not(:last-child){border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.jr-btn:last-child:not(:first-child){border-top-left-radius:0;border-top-right-radius:0}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.jr-btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.jr-btn:last-child{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.jr-btn:first-child{border-top-left-radius:0;border-top-right-radius:0}[data-toggle=buttons]>.btn-group>.jr-btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.jr-btn input[type=radio],[data-toggle=buttons]>.jr-btn input[type=checkbox],[data-toggle=buttons]>.jr-btn input[type=radio]{position:absolute;clip:rect(0,0,0,0)}.btn-group-vertical>.btn,.btn-group-vertical>.jr-btn,.btn-group>.btn,.btn-group>.jr-btn{margin-right:0;margin-bottom:0}.card-image .grid-thumb-equal{padding-bottom:82%}.product-row{position:relative;overflow:hidden;display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center;-webkit-justify-content:center;justify-content:center;text-align:right}.product-row.even{text-align:left}.product-col{order:1;width:50%}.odd .product-thumb{order:2}.product-content{padding:20px 55px}.product-row .grid-thumb-equal{padding-bottom:69%}.product-thumb img{width:100%}.product-content h4{margin-bottom:25px}@media screen and (max-width:1230px){.product-row .grid-thumb-equal{padding-bottom:71%}}@media screen and (max-width:1199px){.product-content h4{margin-bottom:10px}.product-content{padding:20px 35px}.product-row .grid-thumb-equal{padding-bottom:85%}}@media screen and (max-width:991px){.card-image .grid-thumb-equal{padding-bottom:120%}}@media screen and (max-width:767px){.product-row{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap}.product-row,.product-row.even{text-align:center}.product-content{padding:20px 0}.odd .product-thumb,.product-col{order:1;width:100%}.card-image .grid-thumb-equal,.product-row .grid-thumb-equal{padding-bottom:44%}}.profile-intro{background-color:#fff;border-radius:8px;overflow:hidden}.profile-intro img.avatar-circle{display:inline-block;border-radius:50%;-webkit-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);-moz-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);-o-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);box-shadow:0 1px 4px 0 rgba(0,0,0,.15);position:relative;margin:0 auto;-webkit-transform:translateY(50px);-ms-transform:translateY(50px);transform:translateY(50px);-webkit-transition:all .4s ease-in-out;-o-transition:all .4s ease-in-out;transition:all .4s ease-in-out;z-index:1}.profile-intro:hover .avatar-circle{-webkit-transition:border-radius .4s ease .1s;-o-transition:border-radius .4s ease .1s;transition:border-radius .4s ease .1s;border-radius:25%}.profile-intro .card-image{position:relative;width:100%;min-height:100%;background-image:url(\"http://via.placeholder.com/1920x1072\");background-position:50%;background-repeat:no-repeat;background-size:cover}.profile-intro .pi-content{padding:70px 40px 24px}.profile-intro .pi-footer{padding:0 40px 24px}.profile-intro .icon{display:inline-block;-webkit-transition:all .2s ease 0s;-o-transition:all .2s ease 0s;transition:all .2s ease 0s;color:#3f51b5}.profile-intro .icon:active,.profile-intro .icon:focus,.profile-intro .icon:hover{-webkit-transform:scale(1.2);-ms-transform:scale(1.2);transform:scale(1.2)}.profile-intro .icon:not(:last-child){margin-right:10px}.layer:before{display:block;content:\"\";background-color:rgba(0,0,0,.3);position:absolute;top:0;bottom:0;left:0;right:0;height:100%;width:100%;z-index:0}.card.jr-card-full-height,.jr-card.jr-card-full-height{height:calc(100% - 34px)}@media screen and (max-width:575px){.card.jr-card-full-height,.jr-card.jr-card-full-height{height:auto}}.jr-card>.jr-card-body:first-child{margin-top:6px}.jr-card.p-0>.jr-card-body:first-child{margin-top:0}.jr-card .jr-card-thumb{margin:-24px -30px 0}.jr-card .jr-card-thumb .card-img{border-radius:8px 8px 0 0}@media screen and (max-width:575px){.jr-card{margin-bottom:18px}}.jr-card-header{margin-bottom:24px}.jr-card-header .card-heading{margin-bottom:4px}.jr-card-header .badge{margin-bottom:0}.jr-card-header .badge:last-child{margin-left:10px}@media screen and (max-width:575px){.jr-card-header{margin-bottom:18px}}.jr-entry-header{margin-bottom:24px}.jr-entry-header .entry-heading{margin-bottom:4px}.jr-entry-header .entry-description{margin-bottom:0;font-size:13px;color:#6c757d}@media screen and (max-width:575px){.jr-entry-header{margin-bottom:18px}}.card{margin-bottom:34px}@media screen and (max-width:575px){.card{margin-bottom:18px}}.card-header{font-size:16px}.card-header .badge{margin-bottom:0}.card-header .badge:last-child{margin-left:10px}.card-title{font-size:16px;text-transform:capitalize}.card-subtitle{font-size:14px;color:#495057}.card-subtitle:not(:last-child){margin-bottom:16px}.card-mt-footer{padding:0 15px 20px;margin-top:-10px}.jr-card-social{font-size:22px;padding-top:26px}.social-link{list-style:none;padding-left:0;display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center;margin:0 -5px 10px}.social-link li{padding:0 5px;margin-bottom:5px}.social-link li a{color:#5c5c5c}.social-link li.active a,.social-link li a:focus,.social-link li a:hover{color:#e91e63}.jr-card-social .social-link{margin-bottom:0}.jr-card-social .social-link,.jr-cart-ab{-webkit-justify-content:space-around;justify-content:space-around}.jr-cart-ab{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center;position:absolute;left:0;top:0;right:0;bottom:0;z-index:1;color:#fff;font-size:16px}.jr-cart-ab i{vertical-align:middle;font-size:25px}.img-overlay-card{border-radius:8px;margin-bottom:34px}@media screen and (max-width:1199px){.img-overlay-card .center-crop-img{min-height:135px}}@media screen and (max-width:767px){.img-overlay-card .center-crop-img{min-height:160px}}@media screen and (max-width:575px){.img-overlay-card{margin-bottom:18px}}.chart-header{padding:15px 18px}.chart-header .card-title h4{color:#fff;margin-bottom:4px}.chart-header .title h4,.chart-header p{margin-bottom:4px}.chip-outline{background-color:transparent!important;border:1px solid #adb5bd!important}.carousel-caption h3{font-size:18px}.cp-color{width:36px;height:14px;border-radius:2px}.cp-swatch{padding:5px;background:#fff;border-radius:1px;-webkit-box-shadow:0 0 0 1px rgba(0,0,0,.1);-moz-box-shadow:0 0 0 1px rgba(0,0,0,.1);-o-box-shadow:0 0 0 1px rgba(0,0,0,.1);box-shadow:0 0 0 1px rgba(0,0,0,.1);display:inline-block;cursor:pointer}.cp-popover{position:absolute;z-index:2}.cp-cover{position:fixed;top:0;right:0;bottom:0;left:0}.alpha-picker,.hue-picker,.material-picker,.photoshop-picker,.swatches-picker{width:100%!important}.material-picker{height:100%!important}.rc-time-picker-input{height:31px!important}.date-btn{display:inline-block;vertical-align:top}.drawer{width:250px}.full-drawer{width:100%}.product-item,.product-item-vertical{overflow:hidden}.product-item-vertical .card-image .grid-thumb-equal{padding-bottom:110%}@media screen and (max-width:1199px){.product-item-vertical .card-image .grid-thumb-equal{padding-bottom:74%}}@media screen and (max-width:991px){.product-item-vertical .card-image .grid-thumb-equal{padding-bottom:110%}}@media screen and (max-width:829px){.product-item-vertical .card-image .grid-thumb-equal{padding-bottom:120%}}@media screen and (max-width:767px){.product-item-vertical .card-image .grid-thumb-equal{padding-bottom:44%}}.gl-advanced,.gl-image,.gl-list,.gl-single-line{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-justify-content:space-around;justify-content:space-around;overflow:hidden}.gl{max-width:100%;max-height:360px;transform:translateZ(0)}.gl.row.no-gutters{margin:0 -2px}.gl.row.no-gutters .col,.gl.row.no-gutters>[class*=col-]{padding-right:2px;padding-left:2px;margin-bottom:4px}.gl-single-line .slg{-ms-flex-wrap:nowrap;-webkit-flex-wrap:nowrap;flex-wrap:nowrap;max-width:100%}.title-gradient{background:-webkit-linear-gradient(180deg,rgba(0,0,0,.7) 0,rgba(0,0,0,.3) 70%,transparent)!important;background:-o-linear-gradient(to bottom,rgba(0,0,0,.7) 0,rgba(0,0,0,.3) 70%,transparent 100%)!important;background:linear-gradient(180deg,rgba(0,0,0,.7) 0,rgba(0,0,0,.3) 70%,transparent)!important}.title-gradient-bottom{background:-webkit-linear-gradient(0deg,rgba(0,0,0,.7) 0,rgba(0,0,0,.3) 70%,transparent)!important;background:linear-gradient(0deg,rgba(0,0,0,.7) 0,rgba(0,0,0,.3) 70%,transparent)!important}.g-title{left:0;right:0;height:48px;display:flex;position:absolute;background:rgba(0,0,0,.4);align-items:center;font-family:Roboto,Helvetica,Arial,sans-serif}.grid{height:100%;display:block;position:relative;overflow:hidden}.grid>img{top:50%;left:50%;position:relative;transform:translate(-50%,-50%)}.g-ul,.grid>img{display:flex;padding:0;flex-wrap:wrap}.g-ul{overflow-y:auto;list-style:none;-webkit-overflow-scrolling:touch}.gradient-text{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:20px;color:#fff}.title-gradient-bottom{padding:20px;bottom:0;background:rgba(0,0,0,.4);background:-webkit-linear-gradient(0deg,rgba(0,0,0,.7),rgba(0,0,0,.3) 70%,transparent)!important;background:-o-linear-gradient(to top,rgba(0,0,0,.7) 0,rgba(0,0,0,.3) 70%,transparent 100%)!important;background:linear-gradient(0deg,rgba(0,0,0,.7),rgba(0,0,0,.3) 70%,transparent)!important}.title-gradient-bottom,.title-gradient-top{left:0;right:0;height:48px;display:flex;position:absolute;align-items:center;font-family:Roboto,Helvetica,Arial,sans-serif}.title-gradient-top{padding:10px;top:0;background:rgba(0,0,0,.4);background:-webkit-linear-gradient(180deg,rgba(0,0,0,.7),rgba(0,0,0,.3) 70%,transparent)!important;background:-o-linear-gradient(to bottom,rgba(0,0,0,.7) 0,rgba(0,0,0,.3) 70%,transparent 100%)!important;background:linear-gradient(180deg,rgba(0,0,0,.7),rgba(0,0,0,.3) 70%,transparent)!important}.grid-thumb img{max-height:185px}.gl-advanced-grid{position:relative}.icon{text-align:center}.icon,.icons-wrapper{display:inline-block}.icons-wrapper+.icons-wrapper{margin-left:25px}label{margin-bottom:0}.pinned-list{position:relative;height:370px;overflow:auto;width:auto}.user-list{width:100%;padding:20px 15px 10px}.user-list.card{padding-left:30px}@media screen and (max-width:575px){.user-list.card{padding-left:15px}}.user-list .user-avatar{margin-right:20px;margin-bottom:10px}.user-list h3{font-weight:700;margin-bottom:8px}.user-list a[class*=meta-] i{margin-right:6px}.user-list a[class*=meta-]:hover{text-decoration:none}.user-list a[class*=meta-]{display:inline-block;color:#5c5c5c;font-size:13px;font-weight:700}.user-list .img-section{width:230px}@media screen and (max-width:649px){.user-list .img-section{width:100%}}.user-list .description{width:calc(100% - 300px)}@media screen and (max-width:649px){.user-list .description{width:100%}}.user-list .jr-btn-list li:not(:last-child){margin-right:10px}.user-list .jr-btn-list .btn-light{background-color:#d3d3d3;border-color:#d3d3d3;color:#5c5c5c;font-weight:600}.user-list .jr-btn-list .btn-light:active,.user-list .jr-btn-list .btn-light:focus,.user-list .jr-btn-list .btn-light:hover{background-color:#c7c7c7;border-color:#c7c7c7}.user-list .jr-btn-list.badge-list li:not(:last-child){margin-right:0}.list-inline{margin-left:-5px;margin-right:-5px}.list-inline li{padding:0 5px;display:inline-block}.list-inline li.media{display:flex}.card-strip{border-bottom:1px solid #dee2e6;margin-bottom:10px}.jr-mbtn-list{margin-left:-20px}.img-res{max-width:100%;height:auto}.nav-link{cursor:pointer;padding:.5rem}.card-header.bg-primary .nav-link{color:#fff}.card-header.bg-primary .nav-link.active,.card-header.bg-primary .nav-link:focus,.card-header.bg-primary .nav-link:hover{color:#000;background-color:#fff}.card-header.bg-primary .nav-link.disabled{color:#f8f9fa}.card-header.bg-primary .nav-link.disabled:hover{color:#212529}.pt-circle .package,.pt-classic .package,.pt-dark .package,.pt-default .package{position:relative;padding:0;overflow:hidden;border-radius:10px;-webkit-transition:all .5s ease-in-out;-o-transition:all .5s ease-in-out;transition:all .5s ease-in-out}.pt-circle .package:active,.pt-circle .package:focus,.pt-circle .package:hover,.pt-classic .package:active,.pt-classic .package:focus,.pt-classic .package:hover,.pt-dark .package:active,.pt-dark .package:focus,.pt-dark .package:hover,.pt-default .package:active,.pt-default .package:focus,.pt-default .package:hover{-webkit-transform:scale(1.05);-ms-transform:scale(1.05);transform:scale(1.05)}.pt-circle .package.highlight,.pt-classic .package.highlight,.pt-dark .package.highlight,.pt-default .package.highlight{-webkit-transform:scale(1.05);-ms-transform:scale(1.05);-o-transform:scale(1.05);transform:scale(1.05);z-index:2}.pt-circle .package-header,.pt-classic .package-header,.pt-dark .package-header,.pt-default .package-header{padding:35px;text-align:center}.pt-circle .package-header>.price,.pt-classic .package-header>.price,.pt-dark .package-header>.price,.pt-default .package-header>.price{display:inline-block;font-size:36px;font-weight:700;margin-left:0;margin-bottom:12px}.pt-circle .package-header>.price>i,.pt-classic .package-header>.price>i,.pt-dark .package-header>.price>i,.pt-default .package-header>.price>i{display:inline-block;margin-right:6px;font-weight:700}.pt-circle .package-header h5,.pt-classic .package-header h5,.pt-dark .package-header h5,.pt-default .package-header h5{color:inherit}.pt-circle .package-items,.pt-classic .package-items,.pt-dark .package-items,.pt-default .package-items{list-style:none;font-size:14px;margin:0;padding:50px 50px 120px}.pt-circle .package-items li,.pt-classic .package-items li,.pt-dark .package-items li,.pt-default .package-items li{margin-bottom:16px;line-height:inherit}.pt-circle .package-items li:after,.pt-circle .package-items li:before,.pt-classic .package-items li:after,.pt-classic .package-items li:before,.pt-dark .package-items li:after,.pt-dark .package-items li:before,.pt-default .package-items li:after,.pt-default .package-items li:before{content:\" \";display:table}.pt-circle .package-items li:after,.pt-classic .package-items li:after,.pt-dark .package-items li:after,.pt-default .package-items li:after{clear:both}.pt-circle .package-items li i,.pt-classic .package-items li i,.pt-dark .package-items li i,.pt-default .package-items li i{float:left;min-width:20px;margin-right:16px;line-height:inherit}.pt-circle .package-items li span,.pt-classic .package-items li span,.pt-dark .package-items li span,.pt-default .package-items li span{display:block;overflow:hidden}.pt-circle .package-footer,.pt-classic .package-footer,.pt-dark .package-footer,.pt-default .package-footer{bottom:0;left:0;position:absolute;right:0;padding:40px 50px;text-align:center}.pt-circle .package-footer .btn,.pt-classic .package-footer .btn,.pt-dark .package-footer .btn,.pt-default .package-footer .btn{color:inherit;padding:10px 30px;border:0 none}.pt-classic .package{border:0 none;border-radius:0}.pt-dark .package:hover{border-radius:20px}.pt-circle .package-header{border-radius:50%;height:224px;width:224px;margin:40px auto 0;-webkit-align-items:center;align-items:center}.pt-circle .package-header .price{margin-top:30px}@media only screen and (max-width:991px){.pt-circle .package-header,.pt-classic .package-header,.pt-dark .package-header,.pt-default .package-header{padding:30px 20px}.pt-circle .package-items,.pt-classic .package-items,.pt-dark .package-items,.pt-default .package-items{padding:30px 20px 120px}.pt-circle .package-header{height:204px;width:204px}}@media only screen and (max-width:767px){.pt-circle .package.highlight,.pt-circle .package:active,.pt-circle .package:focus,.pt-circle .package:hover,.pt-classic .package.highlight,.pt-classic .package:active,.pt-classic .package:focus,.pt-classic .package:hover,.pt-dark .package.highlight,.pt-dark .package:active,.pt-dark .package:focus,.pt-dark .package:hover,.pt-default .package.highlight,.pt-default .package:active,.pt-default .package:focus,.pt-default .package:hover{-webkit-transform:scale(1);-ms-transform:scale(1);transform:scale(1)}}.pb-wrapper{display:flex;align-items:center}.pb-btn-wrapper{margin:8px;position:relative}.pb-btn-wrapper .btn-success{background-color:#4caf50}.pb-btn-wrapper .btn-success:hover{background-color:#388e3c}.fab-progress{top:-6px;left:-6px;z-index:1}.btn-progress,.fab-progress{color:#4caf50;position:absolute}.btn-progress{top:50%;left:50%;margin-top:-12px;margin-left:-12px}.popover{z-index:1510}.popover-header{background-color:transparent;border-bottom:0 none;color:#000;font-size:18px;padding:15px 20px 0}.popover-body{padding:15px 20px}.table-header{padding-right:2px!important;min-height:64px;padding-left:24px;align-items:center}.table-header.highlight-light{color:#616161;background-color:#e0e0e0}.table-header.highlight-dark{color:#fff;background-color:#616161}.spacer{-webkit-flex:1 1 100%;-ms-flex:1 1 100%;flex:1 1 100%}.actions{color:#f44336}.title{-webkit-flex:0 0 auto;-ms-flex:0 0 auto;flex:0 0 auto}.table-hover tbody tr:hover{background-color:rgba(63,81,181,.075)}.table-material{width:100%!important;max-width:100%!important;background-color:transparent!important}.table-material td,.table-material th{padding:.75rem!important;vertical-align:top!important;border-top:1px solid #dee2e6!important}.table-material thead th{vertical-align:bottom!important;border-bottom:2px solid #dee2e6!important}.table-material tbody+tbody{border-top:2px solid #dee2e6!important}.table-material .table-material{background-color:#f4f4f4!important}.d-flex-stretch{-webkit-align-items:stretch;align-items:stretch;display:-webkit-flex;display:-webkit-box;display:-moz-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap}.default-table{margin-bottom:0}.default-table thead th{font-weight:400;font-size:16px}.default-table td{vertical-align:middle}.table-unbordered td,.table-unbordered th{border:0 none!important}.table-unbordered .th-border-b th{border-bottom:2px solid #ced4da!important}.table-responsive-material{min-height:.01%;overflow-x:auto}@media screen and (max-width:767px){.table-responsive-material{width:100%;margin-bottom:15px;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;border:1px solid #ddd}.table-responsive-material>.table{margin-bottom:0}.table-responsive-material>.table>tbody>tr>td,.table-responsive-material>.table>tbody>tr>th,.table-responsive-material>.table>tfoot>tr>td,.table-responsive-material>.table>tfoot>tr>th,.table-responsive-material>.table>thead>tr>td,.table-responsive-material>.table>thead>tr>th{white-space:nowrap}.table-responsive-material>.table-bordered{border:0}.table-responsive-material>.table-bordered>tbody>tr>td:first-child,.table-responsive-material>.table-bordered>tbody>tr>th:first-child,.table-responsive-material>.table-bordered>tfoot>tr>td:first-child,.table-responsive-material>.table-bordered>tfoot>tr>th:first-child,.table-responsive-material>.table-bordered>thead>tr>td:first-child,.table-responsive-material>.table-bordered>thead>tr>th:first-child{border-left:0}.table-responsive-material>.table-bordered>tbody>tr>td:last-child,.table-responsive-material>.table-bordered>tbody>tr>th:last-child,.table-responsive-material>.table-bordered>tfoot>tr>td:last-child,.table-responsive-material>.table-bordered>tfoot>tr>th:last-child,.table-responsive-material>.table-bordered>thead>tr>td:last-child,.table-responsive-material>.table-bordered>thead>tr>th:last-child{border-right:0}.table-responsive-material>.table-bordered>tbody>tr:last-child>td,.table-responsive-material>.table-bordered>tbody>tr:last-child>th,.table-responsive-material>.table-bordered>tfoot>tr:last-child>td,.table-responsive-material>.table-bordered>tfoot>tr:last-child>th{border-bottom:0}}.fst-td-br-tp-0 tr:first-child td{border-top:0 none}.tab{min-width:10px!important}.tab-icon>span{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap}.testimonial-in-bg{background-color:rgba(0,0,0,.8);box-shadow:5px 5px 6px rgba(0,0,0,.06);padding:30px 30px 30px 150px;overflow:hidden;position:relative}@media screen and (max-width:450px){.testimonial-in-bg{padding-left:100px}}.testimonial-in-bg .pic{display:inline-block;width:80px;height:80px;border-radius:50%;overflow:hidden;position:absolute;top:30px;left:20px;border:4px solid #ffa000}@media screen and (max-width:450px){.testimonial-in-bg .pic{width:50px;height:50px}}.testimonial-in-bg .pic img{width:100%;height:auto}.testimonial-in-bg .description{color:#bdbdbd;font-style:italic;font-weight:400;line-height:25px;margin-bottom:15px;position:relative}.testimonial-in-bg .description:before{content:\"\\F1B2\";font-family:Material-Design-Iconic-Font;font-size:24px;-moz-transform:scaleX(-1);-webkit-transform:scaleX(-1);-o-transform:scaleX(-1);transform:scaleX(-1);position:absolute;left:-24px}.testimonial-in-bg .title{color:#ffa000;margin-bottom:2px}.classic-testimonial{text-align:center}.classic-testimonial .pic{margin:0 auto;margin-bottom:30px;width:120px;height:120px}@media screen and (max-width:500px){.classic-testimonial .pic{width:80px;height:80px}}.classic-testimonial .pic img{width:100%;height:100%}.timeline-left{float:left;margin-right:20px}.timeline-right{float:right;margin-left:20px}.timeline-circle{border-radius:50%}.timeline-section{margin-bottom:25px}.timeline-item{padding-bottom:25px;padding-left:80px;position:relative}.timeline-item:before{border-left:2px solid #dee2e6;content:\"\";left:25px;position:absolute;top:25px;bottom:-20px;width:2px;z-index:1}.timeline-item:first-child:before,.timeline-item:last-child:before{border-left-style:dashed}.timeline-badge{position:absolute;left:0;top:16px;z-index:2;font-size:16px;color:#fff;text-align:center;border-radius:50%}.timeline-badge.timeline-img{background-color:transparent}.timeline-badge svg{vertical-align:calc(100% - 56px)}.timeline-badge.timeline-img:after{display:none}.timeline-badge:after{position:absolute;content:\"\";width:42px;height:42px;background-color:transparent;border:4px solid #f4f4f4;border-radius:50%;left:4px;top:4px;z-index:1}.timeline-header-img>img,.timeline-img>img{display:inline-block;max-width:100%;height:auto}.timeline-panel{padding:20px 30px;position:relative;background-color:#fff;border-radius:8px;border:1px solid #e9ecef}.timeline-panel:after,.timeline-panel:before{content:\"\";position:absolute;border-style:solid;display:inline-block}.timeline-panel:before{border-color:transparent #dee2e6;border-width:10px 17px 10px 0;left:-17px;top:30px}.timeline-panel:after{border-color:transparent #fff;border-width:10px 16px 10px 0;left:-16px;top:30px}.timeline-no-padding{padding:0}.timeline-no-shadow{-webkit-box-shadow:none;-moz-box-shadow:none;-o-box-shadow:none;box-shadow:none}.timeline-no-shadow:after,.timeline-no-shadow:before{display:none}.timeline-header-img,.timeline-panel-header{margin-bottom:10px}.timeline-inverted .timeline-left{float:right;margin-right:0;margin-left:20px}.timeline-heading{overflow:hidden;margin-bottom:10px}.timeline-body{clear:both}.timeline-center .timeline-item{clear:both;float:right;width:50%;padding-left:55px}.timeline-center .timeline-item:before{left:0}.timeline-center .timeline-badge{left:-25px;right:auto}.timeline-center .timeline-time{position:absolute;top:32px;left:-150px;right:auto;z-index:2}.timeline-center .timeline-inverted{float:left;text-align:right;padding-left:0;padding-right:55px}.timeline-center .timeline-inverted:before{border-left:0 none;border-right:2px solid #dee2e6;left:auto;right:-2px}.timeline-center .timeline-inverted .timeline-badge{left:auto;right:-25px}.timeline-center .timeline-inverted .timeline-panel:before{border-width:10px 0 10px 17px;left:auto;right:-17px}.timeline-center .timeline-inverted .timeline-panel:after{border-width:10px 0 10px 16px;left:auto;right:-16px}.timeline-center .timeline-inverted .timeline-time{position:absolute;top:32px;right:-150px;left:auto;z-index:2}.timeline-zigzag .timeline-item{padding-left:150px}.timeline-zigzag .timeline-item+.timeline-item{margin-top:-80px}.timeline-zigzag .timeline-img{width:90px;height:90px;left:5px}.timeline-zigzag .timeline-img>img{width:100%}.timeline-zigzag .timeline-inverted .timeline-img{right:5px!important}.timeline-zigzag .timeline-item:before{-webkit-transform:rotate(35deg);-ms-transform:rotate(35deg);-o-transform:rotate(35deg);transform:rotate(35deg);top:20px;bottom:20px}.timeline-zigzag .timeline-inverted{padding-left:0;padding-right:150px}.timeline-zigzag .timeline-inverted:before{-webkit-transform:rotate(-35deg);-ms-transform:rotate(-35deg);-o-transform:rotate(-35deg);transform:rotate(-35deg)}.timeline-zigzag .timeline-item:first-child:before{border-left-style:solid}.timeline-zigzag .timeline-item:last-child:before{display:none}.timeline-item:last-child:before{bottom:25px}@media screen and (max-width:991px){.timeline-zigzag .timeline-item+.timeline-item{margin-top:-60px}.timeline-zigzag .timeline-item:before{bottom:0}.timeline-zigzag .timeline-item{padding-left:120px}.timeline-zigzag .timeline-inverted{padding-right:120px;padding-left:0}}@media screen and (max-width:767px){.timeline-center .timeline-item{float:none;padding-left:80px;width:auto}.timeline-center .timeline-item:before{left:25px}.timeline-center .timeline-badge{left:0}.timeline-center .timeline-inverted{float:none;text-align:left;padding-right:0}.timeline-center .timeline-inverted:before{border-left:2px solid #dee2e6;border-right:0 none;left:24px;right:auto}.timeline-center .timeline-inverted .timeline-badge{right:auto;left:0}.timeline-center .timeline-inverted .timeline-panel:before{border-width:10px 17px 10px 0;left:-17px;right:auto}.timeline-center .timeline-inverted .timeline-panel:after{border-width:10px 16px 10px 0;left:-16px;right:auto}.timeline-inverted .timeline-panel-header{float:none}.timeline-inverted .timeline-left{float:left;margin-left:0;margin-right:20px}.timeline-zigzag .timeline-panel{max-height:none;min-height:10px;overflow-y:visible}.timeline-zigzag .timeline-item{padding-left:100px}.timeline-zigzag .timeline-item+.timeline-item{margin-top:0}.timeline-zigzag .timeline-item:before{transform:none;top:25px;bottom:-25px;left:45px}.timeline-zigzag .timeline-item:last-child:before{bottom:0}.timeline-zigzag .timeline-inverted:before{transform:none}.timeline-center .timeline-inverted .timeline-time,.timeline-center .timeline-time{position:relative;top:auto;left:auto;right:auto;margin-bottom:6px}.timeline-center .timeline-time-item .timeline-panel:before{top:10px}.timeline-center .timeline-time-item .timeline-panel:after{top:11px}}@media screen and (max-width:399px){.timeline-left{float:none;margin-right:0}.timeline-right{float:none;margin-left:0}.timeline-inverted .timeline-left{float:none;margin-right:0}}.joyride-beacon{background-color:transparent;border:0;cursor:pointer;display:inline-block;line-height:1;padding:0;height:36px;position:relative;width:36px;z-index:1500}.joyride-beacon:active,.joyride-beacon:focus,.joyride-beacon:hover{outline:none}.joyride-beacon__inner{animation:joyride-beacon-inner 1.2s infinite ease-in-out;background-color:#f04;border-radius:50%;display:block;height:50%;left:50%;opacity:.7;position:absolute;top:50%;transform:translate(-50%,-50%);width:50%}.joyride-beacon__outer{animation:joyride-beacon-outer 1.2s infinite ease-in-out;background-color:rgba(255,0,68,.2);border:2px solid #f04;border-radius:50%;box-sizing:border-box;display:block;height:100%;left:0;opacity:.9;position:absolute;top:0;transform:translateY(-50%);transform-origin:center;width:100%}.joyride-overlay{bottom:0;left:0;position:absolute;right:0;top:0;z-index:1500}.joyride-hole{border-radius:4px;box-shadow:0 0 0 9999px rgba(0,0,0,.5),0 0 15px rgba(0,0,0,.5);position:absolute}.joyride-hole.safari{box-shadow:0 0 999px 9999px rgba(0,0,0,.5),0 0 15px rgba(0,0,0,.5)}.joyride-tooltip{background-color:#fff;border-radius:4px;color:#555;cursor:default;filter:drop-shadow(-1px -2px 3px rgba(0,0,0,.3)) drop-shadow(1px 2px 3px rgba(0,0,0,.3));opacity:0;padding:20px;transform:translateZ(0);width:290px;z-index:1510}.joyride-tooltip--animate{animation:joyride-tooltip .4s forwards;animation-timing-function:cubic-bezier(0,1.05,.55,1.18)}.joyride-tooltip__triangle{background-repeat:no-repeat;position:absolute}.joyride-tooltip.bottom,.joyride-tooltip.bottom-left,.joyride-tooltip.bottom-right{margin-top:18px}.joyride-tooltip.bottom-left .joyride-tooltip__triangle,.joyride-tooltip.bottom-right .joyride-tooltip__triangle,.joyride-tooltip.bottom .joyride-tooltip__triangle{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='36' height='18' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='%23fff' d='M36 18L18 0 0 18z'/%3E%3C/svg%3E\");height:18px;left:50%;top:-16px;transform:translateX(-50%);width:36px}.joyride-tooltip.top,.joyride-tooltip.top-left,.joyride-tooltip.top-right{margin-bottom:18px}.joyride-tooltip.top-left .joyride-tooltip__triangle,.joyride-tooltip.top-right .joyride-tooltip__triangle,.joyride-tooltip.top .joyride-tooltip__triangle{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='36' height='18' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='%23fff' d='M0 0l18 18L36 0z'/%3E%3C/svg%3E\");bottom:-16px;height:18px;left:50%;transform:translateX(-50%);width:36px}.joyride-tooltip.bottom-left .joyride-tooltip__triangle,.joyride-tooltip.top-left .joyride-tooltip__triangle{left:3%;transform:translateX(0)}@media screen and (min-width:480px){.joyride-tooltip.bottom-left .joyride-tooltip__triangle,.joyride-tooltip.top-left .joyride-tooltip__triangle{left:2%}}.joyride-tooltip.bottom-right .joyride-tooltip__triangle,.joyride-tooltip.top-right .joyride-tooltip__triangle{left:auto;right:3%;transform:translateX(0)}@media screen and (min-width:480px){.joyride-tooltip.bottom-right .joyride-tooltip__triangle,.joyride-tooltip.top-right .joyride-tooltip__triangle{right:2%}}.joyride-tooltip.left{margin-right:18px}.joyride-tooltip.left .joyride-tooltip__triangle{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='18' height='36' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='%23fff' d='M0 36l18-18L0 0z'/%3E%3C/svg%3E\");height:36px;right:-16px;width:18px}.joyride-tooltip.right{margin-left:18px}.joyride-tooltip.right .joyride-tooltip__triangle{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='18' height='36' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='%23fff' d='M18 0L0 18l18 18z'/%3E%3C/svg%3E\");height:36px;left:-16px;width:18px}.joyride-tooltip__close{background-color:transparent;border:0;cursor:pointer;display:inline-block;line-height:1;padding:0;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='12' height='12' viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14.117.323L8.044 6.398 2.595.323a1.105 1.105 0 0 0-1.562 1.562L6.482 7.96.323 14.119a1.105 1.105 0 0 0 1.562 1.562L7.96 9.608l5.449 6.073a1.103 1.103 0 1 0 1.56-1.562L9.517 8.046l6.159-6.161a1.103 1.103 0 1 0-1.56-1.562z' fill='rgba(85,85,85,0.5)'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-size:contain;height:12px;position:absolute;right:10px;text-decoration:none;top:10px;width:12px;z-index:10;display:block}.joyride-tooltip__close:active,.joyride-tooltip__close:focus,.joyride-tooltip__close:hover{outline:none}.joyride-tooltip__close:focus,.joyride-tooltip__close:hover{color:rgba(60,60,60,.5);outline:none}.joyride-tooltip__close--header{right:20px;top:20px}.joyride-tooltip__header{border-bottom:1px solid #f04;color:#555;font-size:16px;padding-bottom:6px;padding-right:18px;position:relative}.joyride-tooltip__header~.joyride-tooltip__main{padding:12px 0 18px}.joyride-tooltip__main{font-size:14px;padding-bottom:18px;padding-right:18px}.joyride-tooltip__footer{text-align:right}.joyride-tooltip__button{background-color:transparent;border:0;cursor:pointer;display:inline-block;line-height:1;padding:0}.joyride-tooltip__button:active,.joyride-tooltip__button:focus,.joyride-tooltip__button:hover{outline:none}.joyride-tooltip__button--primary{background-color:#f04;border-radius:4px;color:#fff;padding:6px 12px;transition:background-color .2s ease-in-out}.joyride-tooltip__button--primary:active,.joyride-tooltip__button--primary:focus,.joyride-tooltip__button--primary:hover{background-color:#ff1f5a;color:#fff}.joyride-tooltip__button--secondary{color:#f04;margin-right:10px}.joyride-tooltip__button--skip{color:#ccc;float:left;margin-right:10px}.joyride-tooltip--standalone .joyride-tooltip__main{padding-bottom:0}.joyride-tooltip--standalone .joyride-tooltip__footer{display:none}@media screen and (min-width:480px){.joyride-tooltip{width:360px}}@media screen and (min-width:960px){.joyride-tooltip{width:450px}}@keyframes joyride-tooltip{0%{transform:scale(.1)}to{opacity:1;transform:perspective(1px) scale(1)}}@keyframes joyride-beacon-inner{20%{opacity:.9}90%{opacity:.7}}@keyframes joyride-beacon-outer{0%{transform:scale(1)}45%{opacity:.7;transform:scale(.75)}to{opacity:.9;transform:scale(1)}}@media screen and (max-width:575px){.horizontal-stepper p,.horizontal-stepper span{opacity:0;visibility:hidden;font-size:12px}.horizontal-stepper.active p,.horizontal-stepper.active span{opacity:1;visibility:visible}.horizontal-stepper>*,.horizontal-stepper>button>*{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.horizontal-stepper .stepperbutton,.horizontal-stepper .stepperbutton span:first-child,.horizontal-stepper .stepperlabel,.horizontal-stepper .stepperlabel span:first-child{opacity:1;visibility:visible}.horizontal-stepper-linear{padding-left:0!important;padding-right:0!important}}.form-checkbox{position:relative;z-index:1}.form-checkbox>input{height:18px;opacity:0;position:absolute;padding:10px;top:0;width:18px;z-index:2;cursor:pointer}.form-control-checkbox .form-checkbox>input{height:24px;width:48px}.form-control-checkbox .form-checkbox{height:24px;display:flex;align-items:center;width:48px;justify-content:center}.form-checkbox>input+.check{height:18px;width:18px}.form-checkbox>input+.check,.form-checkbox>input.sm+.check{border:1px solid #868e96;border-radius:2px;color:#3f51b5;cursor:pointer;display:inline-block;position:relative;z-index:-1}.form-checkbox>input.sm+.check{height:14px;top:3px;width:14px}.form-checkbox>input+.check i,.form-checkbox>input.sm+.check i{display:none;left:1px;opacity:0;position:absolute;top:2px}.form-checkbox>input:checked+span i{display:block;opacity:1}.checkbox-replace{padding-left:20px}.checkbox-replace input[type=checkbox],.radio-replace input[type=radio]{margin-left:-20px;position:absolute}.form-inline .checkbox-replace label{padding-left:5px}.form-inline .checkbox-replace,.form-inline .radio-replace{margin-right:20px}.form-inline .checkbox-replace:last-child{margin-right:0}.checkbox-replace label{display:inline-block;vertical-align:middle;position:relative;padding-left:5px}.checkbox-replace label:before{content:\"\";display:inline-block;position:absolute;width:18px;height:18px;left:0;top:0;margin-left:-20px;margin-top:2px;border:1px solid #868e96;border-radius:3px;background-color:#fff;-webkit-transition:border .15s ease-in-out,color .15s ease-in-out;-o-transition:border .15s ease-in-out,color .15s ease-in-out;transition:border .15s ease-in-out,color .15s ease-in-out}.checkbox-replace label:after{display:inline-block;position:absolute;width:12px;height:12px;left:3px;top:5px;margin-left:-20px;font-size:11px;color:#495057}.checkbox-replace input[type=checkbox]{opacity:0;z-index:1;cursor:pointer}.checkbox-replace input[type=checkbox]:focus+label:before{outline:0 none}.checkbox-replace input[type=checkbox]:checked+label:after{background-color:#ced4da;content:\"\"}.checkbox-replace input[type=checkbox]:disabled+label{opacity:.65}.checkbox-replace input[type=checkbox]:disabled+label:before{background-color:#fff;cursor:not-allowed}.checkbox-replace.checkbox-inline{margin-top:0}.checkbox-primary label:before{border-color:#3f51b5}.checkbox-primary input[type=checkbox]:checked+label:after{background-color:#3f51b5}.checkbox-danger input[type=checkbox]:checked+label:after,.checkbox-danger label:before{border-color:#e91e63}.checkbox-info input[type=checkbox]:checked+label:after,.checkbox-info label:before{border-color:#00bcd4}.checkbox-warning input[type=checkbox]:checked+label:after,.checkbox-warning label:before{border-color:#ff9800}.checkbox-success input[type=checkbox]:checked+label:after,.checkbox-success label:before{border-color:#4caf50}.radio-replace{padding-left:20px}.radio-replace label{display:inline-block;vertical-align:middle;position:relative;padding-left:5px}.radio-replace label:before{content:\"\";width:18px;height:18px;left:0;top:0;margin-top:2px;border:1px solid #ced4da;border-radius:50%;background-color:#fff;-webkit-transition:border .15s ease-in-out;-o-transition:border .15s ease-in-out;transition:border .15s ease-in-out}.radio-replace label:after,.radio-replace label:before{display:inline-block;position:absolute;margin-left:-20px}.radio-replace label:after{content:\" \";width:12px;height:12px;left:3px;top:5px;border-radius:50%;background-color:#ced4da;-webkit-transform:rotate(scale(0,0));-ms-transform:rotate(scale(0,0));-o-transform:rotate(scale(0,0));transform:rotate(scale(0,0));-webkit-transition:transform .1s cubic-bezier(.8,-.33,.2,1.33);-o-transition:transform .1s cubic-bezier(.8,-.33,.2,1.33);transition:transform .1s cubic-bezier(.8,-.33,.2,1.33)}.radio-replace input[type=radio]{opacity:0;z-index:1;cursor:pointer}.radio-replace input[type=radio]:focus+label:before{outline:0 none}.radio-replace input[type=radio]:checked+label:after{-webkit-transform:rotate(scale(1,1));-ms-transform:rotate(scale(1,1));-o-transform:rotate(scale(1,1));transform:rotate(scale(1,1))}.radio-replace input[type=radio]:disabled+label{opacity:.65}.radio-replace input[type=radio]:disabled+label:before{cursor:not-allowed}.radio-replace.radio-inline{margin-top:0}.radio-primary input[type=radio]+label:after{background-color:#3f51b5}.radio-primary input[type=radio]:checked+label:before{border-color:#3f51b5}.radio-primary input[type=radio]:checked+label:after{background-color:#3f51b5}.radio-danger input[type=radio]+label:after{background-color:#e91e63}.radio-danger input[type=radio]:checked+label:before{border-color:#e91e63}.radio-danger input[type=radio]:checked+label:after{background-color:#e91e63}.radio-info input[type=radio]+label:after{background-color:#00bcd4}.radio-info input[type=radio]:checked+label:before{border-color:#00bcd4}.radio-info input[type=radio]:checked+label:after{background-color:#00bcd4}.radio-warning input[type=radio]+label:after{background-color:#ff9800}.radio-warning input[type=radio]:checked+label:before{border-color:#ff9800}.radio-warning input[type=radio]:checked+label:after{background-color:#ff9800}.radio-success input[type=radio]+label:after{background-color:#4caf50}.radio-success input[type=radio]:checked+label:before{border-color:#4caf50}.radio-success input[type=radio]:checked+label:after{background-color:#4caf50}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{padding-top:7px;margin-top:0;margin-bottom:0}.form-horizontal .form-inline .checkbox,.form-horizontal .form-inline .checkbox-inline,.form-horizontal .form-inline .radio,.form-horizontal .form-inline .radio-inline{padding-top:0}.form-horizontal .checkbox,.form-horizontal .radio{min-height:27px}.form-wizard .tab-content .pager.wizard .first a{margin-right:8px}.form-wizard .tab-content .pager.wizard .last a{margin-left:8px}.wizard-navbar{margin:60px auto 20px}.wizard-navbar>ul{display:table;width:100%;text-align:center;margin:0;font-weight:600;padding:0;list-style:none outside none;table-layout:fixed}.wizard-navbar>ul li{display:table-cell;width:1%;position:relative}.wizard-navbar>ul li a{color:#868e96;position:relative;padding:0 10px;display:block;text-decoration:none}.wizard-navbar>ul li a span.wz-number{background-color:#e9ecef;border-radius:50%;color:#adb5bd;display:block;height:40px;left:50%;line-height:40px;margin-left:-20px;margin-top:-50px;position:absolute;text-align:center;-webkit-transition:all .3s ease-in-out 0s;-o-transition:all .3s ease-in-out 0s;transition:all .3s ease-in-out 0s;width:40px;z-index:5}.wizard-navbar>ul li.completed a span.wz-number{background-color:#3f51b5;color:#fff}.wizard-navbar>ul li a.active span.wz-number{background-color:#e91e63;color:#fff}.wizard-navbar>ul li.completed a,.wizard-navbar>ul li a.active{color:#6c757d}.wizard-navbar>ul li a:after,.wizard-navbar>ul li a:before{content:\"\";position:absolute;height:4px;width:50%;background-color:#e9ecef;top:-32px;left:0}.wizard-navbar>ul li a:after{left:auto;right:0}.wizard-navbar>ul li a.active:after,.wizard-navbar>ul li a.active:before{background-color:#e91e63}.wizard-navbar>ul li.completed a:after,.wizard-navbar>ul li.completed a:before{background-color:#3f51b5}label.error{display:block;color:#f44336;font-weight:400;margin:5px 0}@media screen and (max-width:479px){.wizard-navbar>ul li a span.wz-label{visibility:hidden}.wizard-navbar>ul li a.active span.wz-label{visibility:visible}}.form-checkbox-custom{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center;margin-bottom:12px}.form-checkbox-custom .check{margin-right:10px}.react-switch{vertical-align:middle;margin-left:4px}::-webkit-input-placeholder{font-size:12px;color:#dcdcdc}::-moz-placeholder{font-size:12px;color:#dcdcdc}:-ms-input-placeholder{font-size:12px;color:#dcdcdc}:-moz-placeholder{font-size:12px;color:#dcdcdc}.module-box-header ::-webkit-input-placeholder{font-size:14px}.module-box-header ::-moz-placeholder{font-size:14px}.module-box-header :-ms-input-placeholder{font-size:14px}.module-box-header :-moz-placeholder{font-size:14px}.search-bar{background-color:#fff;position:relative}.search-bar .form-group{width:100%;height:100%;margin-bottom:0}.search-bar input[type=search]{padding-right:50px}.search-bar .search-icon{background-color:transparent;border:0 none;color:#868e96;height:36px;width:30px}.search-bar .form-control{box-shadow:none}.search-bar .form-control.form-control-lg+.search-icon{position:absolute;right:14px;top:6px}.search-bar .search-icon{position:absolute;right:14px;top:3px}.search-bar.right-side-icon input[type=search]{padding-right:16px;padding-left:50px}.search-bar.right-side-icon .search-icon{position:absolute;left:14px;top:2px}.search-bar.right-side-icon .form-control{box-shadow:none}.search-bar.right-side-icon .form-control.form-control-lg+.search-icon{position:absolute;left:14px;top:6px}.nav-searchbox .search-bar input+.search-icon i{color:rgba(92,92,92,.8)}@media screen and (max-width:767px){.jr-card .app-main-header .search-bar{width:150px}}.login-container{position:relative;height:100%}.login-content{width:420px;margin:auto;padding:35px 35px 20px;background-color:#fff;border-radius:8px;border:1px solid #ced4da;font-size:14px;max-width:94%}.login-header{margin-bottom:30px}.login-content .form-control{background-color:#f5f5f5}.login-content .form-control:focus{box-shadow:none;border-color:#3f51b5}.login-content .btn,.login-content .jr-btn{padding:10px 35px!important}.app-login-container{position:relative;max-width:680px;width:94%;margin:0 auto}.app-login-container .loader-view{position:absolute;left:0;right:0;text-align:center;top:0;bottom:0;z-index:2}.app-login-main-content{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;background-color:#fff;-webkit-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);-moz-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);-o-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);box-shadow:0 1px 4px 0 rgba(0,0,0,.15);border-radius:10px;font-size:14px;overflow:hidden}.app-login-content{padding:35px 35px 20px;width:60%;order:1}@media screen and (max-width:575px){.app-login-content{width:100%;order:2}}.app-login-header{margin-bottom:30px}.app-login-content .form-control{background-color:#f5f5f5}.app-login-content .form-control:focus{box-shadow:none;border-color:#3f51b5}.app-login-content .btn,.login-content .jr-btn{padding:10px 35px!important}.app-logo-content{background-color:#3f51b5;padding:35px 35px 20px;width:40%;order:2}@media screen and (max-width:575px){.app-logo-content{width:100%;order:1}}.app-social-block{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center;-webkit-justify-content:space-between;justify-content:space-between}.app-social-block .social-link,.app-social-block .social-link li{margin:0}.app-social-block .social-link span{border:1px solid #3f51b5;border-radius:50%;color:#3f51b5}.app-social-block .social-link span:focus,.app-social-block .social-link span:hover{color:#fff;background-color:#3f51b5}.app-social-block p{margin-bottom:0}.page-error-container{padding:30px 0;position:relative}@media screen and (max-width:575px){.page-error-container{padding:15px 0}}.page-error-content{margin:0 auto;padding:20px 0;width:580px;max-width:94%}@media screen and (max-width:767px){.page-error-content{padding:15px 0}}@media screen and (max-width:575px){.page-error-content{padding:0}}.error-code{color:#212529;font-size:160px;text-align:center;line-height:1;font-weight:600;text-shadow:10px 6px 8px hsla(0,0%,46%,.8)}@media screen and (max-width:991px){.error-code{font-size:130px}}@media screen and (max-width:767px){.error-code{font-size:100px}}@media screen and (max-width:575px){.error-code{font-size:80px}}.page-error-content h2{margin-bottom:50px}@media screen and (max-width:767px){.page-error-content h2{margin-bottom:20px}}.rdw-inline-wrapper{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap}.rdw-option-wrapper{margin-bottom:6px}.contact-form{padding:60px}.contact-block .contact-info{list-style:none;padding-left:0;margin-bottom:0;display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center;-webkit-align-content:stretch;-ms-flex-align:stretch;align-content:stretch}.contact-block .contact-info li{-webkit-flex:1 1 0;-ms-flex:1 1 0;flex:1 1 0;overflow:hidden;padding:10px 40px;border-right:2px solid #5c5c5c;word-wrap:break-word}.contact-block .contact-info li:last-child{border:0 none}.contact-block .contact-info li>i{float:left;font-size:16px;margin-right:5px}.contact-block .contact-info li .contact-body{overflow:hidden}.contact-block .contact-info li .contact-body .icons-wrapper{margin-top:15px;margin-left:0}.contact-block .contact-info li .contact-body .icon{background-color:#5c6bc0;color:#fff;border-radius:50%;margin-right:6px;margin-bottom:6px}.contact-block .contact-info li .contact-body .icon:last-child{margin-right:0}.contact-block .contact-info li .contact-body .twitter-icon{background-color:#40c4ff}.contact-block .contact-info li .contact-body .google-icon{background-color:#ef5350}.contact-block .contact-info li .contact-body .linkedin-icon{background-color:#0277bd}.contact-block .contact-info.vertical{display:block;margin-bottom:0}.contact-block .contact-info.vertical li{padding:0 0 24px;border-right:0 none;border-bottom:2px solid #5c5c5c;margin-bottom:24px}.contact-block .contact-info.vertical li:last-child{border:0 none;margin-bottom:0;padding-bottom:0}@media screen and (max-width:767px){.contact-form{padding:30px}.contact-block .contact-info{display:block;margin-bottom:0}.contact-block .contact-info li{padding:0 0 24px;border-right:0 none;border-bottom:2px solid #5c5c5c;margin-bottom:24px}.contact-block .contact-info li:last-child{border:0 none;margin-bottom:0;padding-bottom:0}.content-section{padding:20px 10px 0;text-align:center}.content-section h2{font-size:28px}.content-section p{font-size:18px}}.portfolio-section .card-image{margin-bottom:20px}.portfolio-section .card-image img{width:100%;-webkit-transition:all 1.2s ease;-o-transition:all 1.2s ease;transition:all 1.2s ease}.portfolio-section .card-image:hover img{-webkit-transform:scale(1.08);-ms-transform:scale(1.08);transform:scale(1.08)}.filter-with-bg-color ul{padding-left:0;margin:0 -10px 45px}.filter-with-bg-color ul li{display:inline-block;margin-bottom:10px;padding:0 10px}.filter-with-bg-color ul li a{text-transform:uppercase;font-size:12px;padding:10px 24px;border:1px solid #3f51b5;display:block;text-decoration:none}.filter-with-bg-color ul li a.active,.filter-with-bg-color ul li a:focus,.filter-with-bg-color ul li a:hover{cursor:pointer;background-color:#3f51b5;border-color:#3f51b5;color:#fff}@media screen and (max-width:575px){.filter-with-bg-color ul{margin-bottom:15px}}.Collapsible{margin-bottom:15px}.Collapsible__contentInner{padding:15px 5px;border:1px solid #e9ecef;background-color:#fff;border-top:0}.Collapsible__contentInner p{margin-bottom:10px;font-size:14px;line-height:20px}.Collapsible__contentInner p:last-child{margin-bottom:0}.Collapsible__trigger{display:block;cursor:pointer;font-weight:400;text-decoration:none;position:relative;padding:18px 20px;border-radius:8px;background:#3f51b5;color:#fff}.Collapsible__trigger:after{content:\"\\F2F9\";font-family:Material-Design-Iconic-Font;font-size:20px;position:absolute;right:24px;top:2px;display:block;transition:transform .3s}.Collapsible__trigger.is-open{border-radius:8px 8px 0 0}.Collapsible__trigger.is-open:after{transform:rotate(180deg)}.categories-list{margin-bottom:0}.categories-list li{margin-bottom:10px}.categories-list li:last-child{margin-bottom:0}.categories-list li.active a{color:#3f51b5}.categories-list .badge{font-size:9px}.articles-section .articles{margin-bottom:26px}.articles-section .articles:last-child{margin-bottom:0}.article-image{display:block;margin-bottom:12px}.article-image>img{border-radius:8px;width:100%}.article-description p{font-weight:500;margin-bottom:2px}.meta-wrapper{margin-bottom:10px}.meta-comment,.meta-date{font-size:14px;color:#adb5bd;display:inline-block}.meta-comment i,.meta-date i{display:inline-block;margin-right:6px}.meta-date+.meta-comment{margin-left:10px}.box{position:relative}.box .box-bottom,.box .box-top{height:100px;padding:32px 15px;font-size:40px;line-height:40px;text-align:center;font-weight:300}.box .box-bottom .size-h5,.box .box-top .size-h5{font-size:24px;margin-left:2px}.box .box-bottom .material-icons,.box .box-top .material-icons{font-size:40px;line-height:40px}.box .box-bottom{border-top:1px solid rgba(0,0,0,.15)}.box .box-info{position:absolute;width:100%;top:50%;margin-top:-12px;text-align:center}.box .box-info span{height:24px;display:inline-block;padding:4px 10px;text-transform:uppercase;line-height:14px;background-color:#fff;border:1px solid rgba(0,0,0,.15);font-size:12px;color:#6c757d;border-radius:1em}.box .box-info span .material-icons{line-height:14px;font-size:11px}.contact-list{margin-bottom:14px}.contact-list i{margin-right:14px;color:#3f51b5}.contact-list .media{margin-bottom:10px}.temp-section .detail-icon,.temp-section .temp-point{font-size:54px}.assignment-table tbody tr:nth-child(odd){background-color:#dee2e6!important}.assignment-table td{padding-top:10px;padding-bottom:10px}.status-cell{min-width:100px;max-width:120px;padding-right:24px!important}.status-cell .badge{min-width:70px}.thumbnail-list{margin-bottom:0}.thumbnail-list .thumbnail-item{padding:0 2.5px;display:inline-block;width:33.333%;margin-bottom:5px}@media screen and (max-width:767px){.thumbnail-list .thumbnail-item{width:50%}}@media screen and (max-width:575px){.thumbnail-list .thumbnail-item{width:33.333%}}.post-list .post-image .grid-thumb-equal{padding-bottom:100%}.chart-f30{font-size:30px}@media screen and (max-width:1099px){.chart-f30{font-size:20px}}.chart-f20{font-size:20px}@media screen and (max-width:1099px){.chart-f20{font-size:16px}}.chart-order .col-5{order:2;text-align:center}@media screen and (max-width:575px){.chart-order .col-5{order:1}}.chart-order .col-7{order:1}@media screen and (max-width:575px){.chart-order .col-7{order:2}}.tab-notifications{margin-left:-30px;margin-right:-30px;border-bottom:1px solid #adb5bd}@media screen and (max-width:567px){.tab-notifications button,.tab-notifications button *{font-size:12px!important}}.chart-title h2{font-size:22px;margin-bottom:5px}.img-fluid{width:100%}.comment-footer button{margin-bottom:6px}.net-chart{padding-left:80px;padding-right:15px;min-height:100px;position:relative;overflow:hidden;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap}.net-chart,.net-chart .jr-card-thumb{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-align-items:center;align-items:center}.net-chart .jr-card-thumb{margin:0;width:50px;height:50px;color:#fff;font-size:20px;border-radius:50%;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-justify-content:center;justify-content:center;-webkit-transition:all .1s ease;-o-transition:all .1s ease;transition:all .1s ease;position:absolute;left:15px}.net-chart:hover .jr-card-thumb{width:70px;height:100%;font-size:30px;border-radius:0;position:absolute;left:0}.net-chart-hr{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center;min-height:120px;padding-right:8px;overflow:hidden}.net-chart-hr .jr-card-thumb{margin:-30px 12px -30px -30px;min-width:105px}.net-chart-hr .grid-thumb-equal{padding-bottom:130%}.net-chart-hr .jr-card-body{width:calc(100% - 100px)}.user-profile{padding:10px 0}.mh-120{min-height:120px}.jr-card-header-top{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center;margin-right:-16px}.jr-card-header-color{padding:10px 20px 20px;margin:-24px -30px 25px}.todo-cell-group .todo-cell:not(:last-child){margin-bottom:8px}.social-list-line{position:relative}.social-list-line:not(:last-child):before{border-left:1px solid #adb5bd;content:\"\";left:20px;position:absolute;top:5px;bottom:0;width:1px;z-index:1}.list-line-item{position:relative;padding-left:40px}.list-line-item:not(:last-child):before{border-left:1px solid #adb5bd;content:\"\";left:20px;position:absolute;top:-25px;bottom:-25px;width:1px;z-index:1}.list-line-badge{position:absolute;left:16px;top:15px;z-index:2;border-radius:50%;height:10px;width:10px;background-color:#adb5bd}.circle-shape{display:inline-block;width:8px;height:8px;border-radius:50%}.project-list{line-height:1}.project-list:not(:last-child){margin-bottom:20px}.project-list .circle-shape{margin-top:4px;margin-right:16px}.project-list .project-name{display:block;margin-bottom:4px;color:#5c5c5c}.project-list .project-name:focus,.project-list .project-name:hover{color:#3f51b5;text-decoration:none}.nav-pill-sales li+li{margin-right:-1px}.nav-pill-sales .nav-link{background-color:#e9ecef;border-radius:0;padding:6px 15px;color:#6c757d;font-size:13px;border:1px solid #ced4da}.nav-pill-sales .nav-link.active{background-color:#3f51b5;color:#fff;border-color:#3f51b5}.nav-pill-sales .nav-link.active:focus,.nav-pill-sales .nav-link.active:hover{color:#fff}.nav-pill-sales li:first-child .nav-link{border-top-left-radius:4px;border-bottom-left-radius:4px}.nav-pill-sales li:last-child .nav-link{border-top-right-radius:4px;border-bottom-right-radius:4px}.temp-week-list{list-style:none;padding-left:0;margin-bottom:0;color:#808992}.temp-week-list li:not(:last-child){margin-bottom:10px}@media screen and (max-width:340px){.temp-week-list li:not(:last-child){margin-bottom:20px}}.temp-week-list img{width:24px;height:24px}.temp-week-list span{display:inline-block}.temp-week-list span.temp-point{margin:0 20px}@media screen and (max-width:1199px){.temp-week-list span.temp-point{margin:0 10px}}@media screen and (max-width:1050px){.temp-week-list span.temp-point{margin:0 5px}}@media screen and (max-width:340px){.temp-week-list span.temp-point{margin:0 20px}}.temp-section .temp-point{font-size:36px;font-weight:700;margin-bottom:0}.temp-section .temp-point sub,.temp-section .temp-point sup{font-size:70%}.dropzone-card{position:relative}.dropzone{margin-bottom:20px}.dropzone>div{margin:0 auto;padding:15px;display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-justify-content:center;justify-content:center}.dropzone>div :last-child{margin-bottom:0}.dropzone .btn{margin-top:20px}.upload-file-list{list-style:none;padding-left:0}.upload-file-list li{margin-bottom:5px}.form-group-dropzone label{margin-bottom:6px}.form-group-dropzone .form-control{max-width:200px;margin:0 auto}.brand-logo{border:1px solid #dee2e6;background-color:#fff;border-radius:8px;margin-bottom:20px;padding-bottom:75%}.brand-logo .brand-logo-inner{text-align:center}.brand-logo .brand-logo-inner:before{content:\"\";display:inline-block;height:100%;vertical-align:middle}.brand-logo .brand-logo-inner img{height:auto;max-height:100%;max-width:100%;display:inline-block;vertical-align:middle;width:auto!important}.brand-logo:hover{-webkit-transition:all .4s ease-in-out .1s;-o-transition:all .4s ease-in-out .1s;transition:all .4s ease-in-out .1s;background-color:#f2f2f2}@media screen and (max-width:575px){.brand-logo{margin-bottom:15px}}.owl-app-frame.owl-carousel .owl-item img{display:inline-block;width:auto}.carousel-item img{max-width:100%}.app-wrapper-module{-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-align-items:stretch;align-items:stretch;height:100%}.app-module,.app-wrapper-module{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.app-module{position:relative;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;margin:-36px -40px 0}@media screen and (max-width:575px){.app-module{margin:-20px}}.module-side{position:relative;z-index:2;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-flex:0 1 230px;-ms-flex:0 1 230px;flex:0 1 230px;max-width:230px;min-width:230px}.module-side,.module-side-header{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex}.module-side-header{border-bottom:1px solid #e9ecef;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.module-side-header .user-detail{padding:15px 10px;text-align:center}.module-logo{padding:10px;display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center;-webkit-justify-content:center;justify-content:center;min-height:78px;font-size:20px;background-color:#f9fafb;color:#2f353a}.module-logo .zmdi{font-size:28px}.module-side-content,.module-user-info{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.module-user-detail{font-size:12px}.module-add-task{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;padding:24px}.module-nav{list-style:none;padding-left:0;-webkit-justify-content:center;justify-content:center}.module-nav,.module-nav li{-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.module-nav,.module-nav li,.module-nav li a{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex}.module-nav li a{padding:12px 29px;color:#8f8f8f;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center;text-decoration:none}.module-nav li a:focus,.module-nav li a:hover{color:#5c5c5c}.module-nav li a.active{color:#3f51b5}.module-nav li i{margin-right:16px;font-size:16px}.module-nav li span{display:inline-block;vertical-align:middle}.module-nav li.module-nav-label{padding:12px 29px}.module-box{position:relative;z-index:2;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto;max-width:calc(100% - 231px)}.module-box,.module-box-header{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex}.module-box-header{padding:10px 26px;min-height:79px;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-justify-content:center;justify-content:center;background-color:#fff;border-bottom:1px solid #e9ecef}.module-box-header .search-bar.right-side-icon{min-width:350px}.module-box-header .search-bar.right-side-icon .form-control{border-radius:0;height:46px;padding:10px 18px 10px 40px}.module-box-header .search-bar.right-side-icon .form-control:focus{background-color:#f8f9fa}.module-box-header .search-bar.right-side-icon .search-icon{width:25px;height:46px;font-size:16px;left:10px;top:0;padding:0}.module-box-header-inner{-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center;-webkit-justify-content:space-between;justify-content:space-between}.module-box-content,.module-box-header-inner{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex}.module-box-content{background-color:#fff;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.module-box-topbar{padding:8px 12px;display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;border-bottom:1px solid #e9ecef}.module-box-topbar button+button{border-radius:0}.module-box-topbar-todo{padding-left:64px}@media screen and (max-width:575px){.module-box-topbar-todo{padding-left:27px}}.module-list-icon{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center;padding-right:10px}.bar-icon{margin-right:15px}.toolbar-separator{border-left:1px solid #ced4da;height:100%;width:1px;margin:0 12px}.toolbar-left{margin-left:auto}.module-list{-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-justify-content:center;justify-content:center}.module-list,.module-list-item{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex}.module-list-item{-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center;padding:15px 28px;border-bottom:1px solid #e9ecef;z-index:5;position:relative;cursor:pointer}.module-list-item>.check-label{margin-left:0;margin-bottom:0}.module-list-item.mail-cell{padding-left:12px;-webkit-align-items:start;align-items:start}.module-detail-header{margin-bottom:10px}.module-detail-header>.check-label{margin-right:auto}.module-list-info{-webkit-flex:1 1 0;-ms-flex:1 1 0;flex:1 1 0;display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;max-width:calc(100% - 169px)}.module-todo-content{position:relative}.module-todo-content .subject{margin-bottom:5px}.module-list-actions{text-align:right}.app-module-sidenav{background-color:#fff;border-right:1px solid #e9ecef;position:relative;z-index:9}.app-module-sidenav .chat-sidenav-main{max-width:300px;min-width:300px;width:90%}.module-date{max-width:160px}.module-date>div:before{display:none}.module-detail-item{padding:10px 28px}.task-title{font-size:18px}.chat-todo-avatar{margin-right:15px}.modal-title{-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-justify-content:space-between;justify-content:space-between;width:100%;font-size:18px}.loader-view,.loader-view-block,.modal-title{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-align-items:center;align-items:center}.loader-view,.loader-view-block{-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-justify-content:center;justify-content:center}.module-date>div{-webkit-align-items:center;align-items:center}@media screen and (max-width:1199px){.module-side{display:-webkit-block;display:-moz-block;display:-ms-block;display:-o-block;display:block;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto;max-width:280px;min-width:280px;background-color:#fff}.module-box-header{position:relative;min-height:58px;padding:5px 26px 5px 75px}.module-box-header .drawer-btn{position:absolute;left:0;top:0;z-index:1;border-right:1px solid #e9ecef;height:58px;width:56px;border-radius:0;font-size:22px}.module-box-header .search-bar.right-side-icon .form-control{height:38px;padding:5px 18px 5px 40px}.module-box-header .search-bar.right-side-icon .search-icon{height:38px}.chat-loader-view{height:calc(100vh - 120px)}.module-box{max-width:100%}}@media screen and (min-width:991px){.modal-dialog{max-width:750px}}@media screen and (max-width:991px){.app-module{padding-top:0}}@media screen and (max-width:599px){.module-box-header .search-bar{margin-left:0;max-width:none}.module-box-header .search-bar.right-side-icon{min-width:250px}}@media screen and (max-width:575px){.module-list-item{padding:10px 12px}.module-list-info{max-width:100%}.module-box-header .nav-searchbox.quick-menu .dropdown-menu{right:auto!important;left:0!important}.module-box-header .search-bar.right-side-icon{min-width:200px}.module-box-header .search-bar.right-side-icon .form-control{border-radius:.25rem}.module-box-header .nav-searchbox.quick-menu .dropdown-menu:after,.module-box-header .nav-searchbox.quick-menu .dropdown-menu:before{right:auto;left:9px}.module-box-header .search-bar{padding-right:2px}}@media screen and (max-width:399px){.module-box-header .search-bar.right-side-icon{min-width:100px}}@media screen and (min-width:399px){.d-xs-flex{display:flex!important}}.chat-module{-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto}.chat-module:before{left:-29px}.chat-module-box{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto;background-color:#f8f9fa;position:relative;width:100%}.chat-sidenav{-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-flex:0 1 315px;-ms-flex:0 1 315px;flex:0 1 315px;min-width:315px;border-right:1px solid #e9ecef}.chat-box,.chat-sidenav{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex}.chat-box{-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto;max-width:100%;position:relative;z-index:2}.chat-sidenav-header{-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;padding:25px 20px 12px;background-color:#f9fafb}.chat-sidenav-header,.chat-user-hd{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex}.chat-user-hd{-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-bottom:25px}.chat-sidenav-header .search-wrapper{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;margin-bottom:0}.chat-sidenav-header .search-wrapper .search-bar.right-side-icon{-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto}.chat-sidenav-header .search-wrapper .search-bar.right-side-icon .form-control{-webkit-box-shadow:none;-moz-box-shadow:none;-o-box-shadow:none;box-shadow:none;border-radius:0;padding-left:42px;height:42px}.chat-sidenav-header .search-wrapper .search-bar.right-side-icon .search-icon{left:10px;top:0;height:42px;padding:0}.chat-avatar{min-width:50px}.chat-user-item .chat-avatar{padding:0 5px;min-width:10px}.chat-user-hd .chat-avatar{cursor:pointer}.chat-avatar-mode{position:relative;max-width:50px}.chat-avatar-mode .chat-mode{display:block;position:absolute;left:0;top:2px;z-index:1;width:12px;height:12px;border-radius:50%}.chat-avatar-mode .chat-mode.small{width:8px;height:8px}.chat-avatar-mode .chat-mode.online{background-color:#4caf50}.chat-avatar-mode .chat-mode.offline{background-color:#fff;border:1px solid #4caf50}.chat-avatar-mode .chat-mode.away{background-color:#fdd835}.chat-main-header-info .chat-avatar-mode{max-width:60px}.chat-sidenav-content{background-color:#fff}.chat-sidenav-title{padding:10px 16px;font-size:13px;color:#00bcd4;display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-justify-content:center;justify-content:center}.chat-tabs-header{background-color:#f9fafb!important}.chat-user{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.chat-user.chat-user-center{-webkit-justify-content:center;justify-content:center;-webkit-align-items:center;align-items:center}.chat-user.chat-user-center .chat-avatar{margin-left:auto}.chat-user-item{border-bottom:1px solid #e9ecef;padding:16px;display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-justify-content:center;justify-content:center;cursor:pointer;max-height:96px}.chat-user-item.active,.chat-user-item:hover{background-color:#e4e7f6}.chat-user-row{margin:0 -5px;-webkit-align-items:center;align-items:center}.chat-contact-col,.chat-info{padding:0 5px}.chat-contact-col p,.chat-info p{margin-bottom:0}.chat-contact-col .h4,.chat-info .h4{display:block;margin-bottom:3px}.chat-info-des{color:#6c757d;font-size:13px}.chat-date{padding:0 5px;text-align:right}.chat-box-main,.module-default{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-justify-content:center;justify-content:center;height:100%}.module-default{-webkit-align-items:center;align-items:center;padding:15px}.s-128{font-size:128px!important;width:128px!important;height:128px!important;line-height:128px!important;margin-bottom:12px}.chat-main{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.chat-main-header{border-bottom:1px solid #e9ecef;padding:16px;background-color:#fff;width:100%}.chat-main-header,.chat-main-header-info{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center}.chat-main-header-info{margin-right:auto}.chat-contact-name{font-size:20px;font-weight:500}.chat-main-footer{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;border-top:1px solid #e9ecef;padding:16px;background-color:#fff;width:100%}.chat-main-footer .form-group{margin-bottom:0}.todo-main-footer{padding:6px 16px}.chat-item{padding:16px}.chat-item .bubble{padding:8px 12px;background-color:#fff;border-radius:20px 20px 20px 0;position:relative;margin-left:16px;max-width:600px;border:1px solid #ced4da}.chat-item.flex-row-reverse .bubble{margin-right:16px;margin-left:0;background-color:#e4e7f6;border-radius:20px 20px 0 20px}.chat-btn{font-size:38px!important;margin:0 10px 0 -8px}.chat-textarea{height:40px;-webkit-box-shadow:none;-moz-box-shadow:none;-o-box-shadow:none;box-shadow:none;border-radius:0}.last-message-time{font-size:11px;color:#adb5bd}@media screen and (max-width:1399px){.s-128{font-size:100px!important;width:100px!important;height:100px!important;line-height:100px!important}}@media screen and (max-width:1199px){.chat-module{margin:-24px -29px -23px;padding-top:0}.chat-main-header{padding:8px 24px}.chat-main-header .size-60{height:50px!important;width:50px!important;line-height:50px}.chat-main-header button{margin-bottom:0}.chat-main-header-info .chat-avatar-mode{max-width:50px}.chat-contact-name,.chat-sidenav-title{font-size:16px}.chat-main-footer{padding:8px 16px}.s-128{font-size:128px!important;width:128px!important;height:128px!important;line-height:128px!important}}@media screen and (max-width:991px){.s-128{font-size:100px!important;width:100px!important;height:100px!important;line-height:100px!important;margin-bottom:10px}}@media screen and (max-width:767px){.chat-contact-name,.chat-sidenav-title{font-size:15px}.s-128{font-size:80px!important;width:80px!important;height:80px!important;line-height:80px!important}}@media screen and (max-width:575px){.module-default h1{font-size:17px}.s-128{font-size:40px!important;width:40px!important;height:40px!important;line-height:40px!important}}.module-box-row{-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap}.module-box-column,.module-box-row{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;width:100%}.module-box-column{-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.mail-user-info{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center}.mail-user-info .avatar{margin-right:10px}.mail-user-info .time,.mail-user-info button{margin-left:auto}.mail-user-info .badge{margin-bottom:0}.module-list-item.mail-cell{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap}.mail-detail{padding:24px!important}.mail-header{-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center}.mail-header,.mail-header-content{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex}.mail-header-content{-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.mail-header-content .subject{margin-bottom:5px}.show-detail{cursor:pointer}.module-list-content .message p,.module-list-content .subject,.text-truncate{width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.module-list-content .message{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;color:#919ca6;font-size:13px}.module-list-content .message p{margin-bottom:8px}.size{margin:5px 0}.sender-name{margin-right:0;font-weight:500;font-size:15px}.mail-header-actions{text-align:right;min-width:100px;display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap}.mail-header-actions .icon-btn:not(:last-child){margin-right:3px}@media screen and (max-width:991px){.module-list-item.mail-cell{padding-right:20px}}@media screen and (max-width:576px){.mail-list{border-right:0 none}.mail-detail,.mail-list{-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto;max-width:100%}.mail-detail .module-list-scroll{padding:24px}}@media screen and (max-width:499px){.mail-header{display:block;-webkit-align-items:flex-start;align-items:flex-start;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.mail-header-actions{text-align:left;min-width:10px}.MuiDialog-paperWidthSm-99{max-width:250px!important}}.contact-item{-webkit-align-items:center;align-items:center;display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;border-bottom:1px solid #e9ecef;padding:8px 12px}.contact-name{font-size:15px}.modal-box{position:relative}.modal-w{max-width:400px;min-width:350px}.modal-box-mail .modal-w{min-width:600px}.modal-box-header{color:#fff;border-top-left-radius:4px;border-top-right-radius:4px}.modal-box-header h2{color:#fff;position:relative}.modal-box-header h2 button{position:absolute;right:0;top:-10px;z-index:1;color:#fff}.modal-box-content{padding:24px}.modal-box-content .avatar{margin:0 auto}.modal-box-footer{padding:0 24px 24px}.modal-box-footer .attach-file{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center;margin-bottom:15px}.btn-fixed{position:fixed!important;right:40px;bottom:60px;z-index:100}.draggable-icon{cursor:all-scroll;color:#6c757d}.draggable-icon:active,.draggable-icon:focus,.draggable-icon:hover{cursor:all-scroll;color:#212529}.module-side-nav{padding:20px 0}@media screen and (max-width:767px){.modal-box-mail .modal-w{min-width:500px}.modal-box-header h2{font-size:18px}}@media screen and (max-width:575px){.modal-w{min-width:300px}.modal-box-mail .modal-w{min-width:400px}.modal-box-header h2{font-size:16px}}@media screen and (max-width:419px){.modal-box-mail .modal-w,.modal-w{min-width:250px}}@media screen and (max-width:399px){.con-inf-mw-100{min-width:100%!important}}.app-calendar .rbc-calendar{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto;min-height:calc(100vh - 160px)}.app-cul-calendar .rbc-calendar{min-height:calc(100vh - 200px)}.rbc-event{background-color:#3f51b5}.rbc-event.rbc-selected{background-color:#32408f}.rbc-slot-selection{background-color:rgba(63,81,181,.7)}.rbc-toolbar button.rbc-active,.rbc-toolbar button:active{background-image:none;-webkit-box-shadow:none;-moz-box-shadow:none;-o-box-shadow:none;box-shadow:none}.rbc-toolbar button.rbc-active,.rbc-toolbar button.rbc-active:focus,.rbc-toolbar button.rbc-active:hover,.rbc-toolbar button:active,.rbc-toolbar button:active:focus,.rbc-toolbar button:active:hover,.rbc-toolbar button:focus,.rbc-toolbar button:hover{color:#fff;background-color:rgba(63,81,181,.9);border-color:#3f51b5}.rbc-month-row{min-height:100px}.rbc-event{min-height:50px}@media screen and (max-width:867px){.rbc-toolbar{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-align-items:flex-start;align-items:flex-start}.rbc-toolbar .rbc-toolbar-label{margin:8px 0}}@media screen and (max-height:600px){.app-calendar .rbc-calendar,.app-cul-calendar .rbc-calendar{min-height:400px}}@media screen and (max-width:467px){.rbc-toolbar{font-size:12px}.rbc-toolbar button{padding:5px 10px}}.indigo .right-arrow,.indigo .right-arrow:after{color:#3f51b5}.indigo .btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.indigo .btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.indigo .btn-primary.focus,.indigo .btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.indigo .btn-primary.disabled,.indigo .btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.indigo .btn-primary:not(:disabled):not(.disabled).active,.indigo .btn-primary:not(:disabled):not(.disabled):active,.show>.indigo .btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.indigo .btn-primary:not(:disabled):not(.disabled).active:focus,.indigo .btn-primary:not(:disabled):not(.disabled):active:focus,.show>.indigo .btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.indigo .btn-secondary{background-color:#e91e63;border-color:#e91e63;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.indigo .btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.indigo .btn-secondary.focus,.indigo .btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.indigo .btn-secondary.disabled,.indigo .btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.indigo .btn-secondary:not(:disabled):not(.disabled).active,.indigo .btn-secondary:not(:disabled):not(.disabled):active,.show>.indigo .btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.indigo .btn-secondary:not(:disabled):not(.disabled).active:focus,.indigo .btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.indigo .btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.indigo .btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.indigo .btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.indigo .btn-success.focus,.indigo .btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.indigo .btn-success.disabled,.indigo .btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.indigo .btn-success:not(:disabled):not(.disabled).active,.indigo .btn-success:not(:disabled):not(.disabled):active,.show>.indigo .btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.indigo .btn-success:not(:disabled):not(.disabled).active:focus,.indigo .btn-success:not(:disabled):not(.disabled):active:focus,.show>.indigo .btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.indigo .btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.indigo .btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.indigo .btn-info.focus,.indigo .btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.indigo .btn-info.disabled,.indigo .btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.indigo .btn-info:not(:disabled):not(.disabled).active,.indigo .btn-info:not(:disabled):not(.disabled):active,.show>.indigo .btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.indigo .btn-info:not(:disabled):not(.disabled).active:focus,.indigo .btn-info:not(:disabled):not(.disabled):active:focus,.show>.indigo .btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.indigo .btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.indigo .btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.indigo .btn-warning.focus,.indigo .btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.indigo .btn-warning.disabled,.indigo .btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.indigo .btn-warning:not(:disabled):not(.disabled).active,.indigo .btn-warning:not(:disabled):not(.disabled):active,.show>.indigo .btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.indigo .btn-warning:not(:disabled):not(.disabled).active:focus,.indigo .btn-warning:not(:disabled):not(.disabled):active:focus,.show>.indigo .btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.indigo .btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.indigo .btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.indigo .btn-danger.focus,.indigo .btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.indigo .btn-danger.disabled,.indigo .btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.indigo .btn-danger:not(:disabled):not(.disabled).active,.indigo .btn-danger:not(:disabled):not(.disabled):active,.show>.indigo .btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.indigo .btn-danger:not(:disabled):not(.disabled).active:focus,.indigo .btn-danger:not(:disabled):not(.disabled):active:focus,.show>.indigo .btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.indigo .btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.indigo .btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.indigo .btn-light.focus,.indigo .btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.indigo .btn-light.disabled,.indigo .btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.indigo .btn-light:not(:disabled):not(.disabled).active,.indigo .btn-light:not(:disabled):not(.disabled):active,.show>.indigo .btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.indigo .btn-light:not(:disabled):not(.disabled).active:focus,.indigo .btn-light:not(:disabled):not(.disabled):active:focus,.show>.indigo .btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.indigo .btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.indigo .btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.indigo .btn-dark.focus,.indigo .btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.indigo .btn-dark.disabled,.indigo .btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.indigo .btn-dark:not(:disabled):not(.disabled).active,.indigo .btn-dark:not(:disabled):not(.disabled):active,.show>.indigo .btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.indigo .btn-dark:not(:disabled):not(.disabled).active:focus,.indigo .btn-dark:not(:disabled):not(.disabled):active:focus,.show>.indigo .btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.indigo a.btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.indigo a.btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.indigo a.btn-primary.focus,.indigo a.btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.indigo a.btn-primary.disabled,.indigo a.btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.indigo a.btn-primary:not(:disabled):not(.disabled).active,.indigo a.btn-primary:not(:disabled):not(.disabled):active,.show>.indigo a.btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.indigo a.btn-primary:not(:disabled):not(.disabled).active:focus,.indigo a.btn-primary:not(:disabled):not(.disabled):active:focus,.show>.indigo a.btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.indigo a.btn-secondary{color:#fff;background-color:#e91e63;border-color:#e91e63;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.indigo a.btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.indigo a.btn-secondary.focus,.indigo a.btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.indigo a.btn-secondary.disabled,.indigo a.btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.indigo a.btn-secondary:not(:disabled):not(.disabled).active,.indigo a.btn-secondary:not(:disabled):not(.disabled):active,.show>.indigo a.btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.indigo a.btn-secondary:not(:disabled):not(.disabled).active:focus,.indigo a.btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.indigo a.btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.indigo a.btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.indigo a.btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.indigo a.btn-success.focus,.indigo a.btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.indigo a.btn-success.disabled,.indigo a.btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.indigo a.btn-success:not(:disabled):not(.disabled).active,.indigo a.btn-success:not(:disabled):not(.disabled):active,.show>.indigo a.btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.indigo a.btn-success:not(:disabled):not(.disabled).active:focus,.indigo a.btn-success:not(:disabled):not(.disabled):active:focus,.show>.indigo a.btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.indigo a.btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.indigo a.btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.indigo a.btn-info.focus,.indigo a.btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.indigo a.btn-info.disabled,.indigo a.btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.indigo a.btn-info:not(:disabled):not(.disabled).active,.indigo a.btn-info:not(:disabled):not(.disabled):active,.show>.indigo a.btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.indigo a.btn-info:not(:disabled):not(.disabled).active:focus,.indigo a.btn-info:not(:disabled):not(.disabled):active:focus,.show>.indigo a.btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.indigo a.btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.indigo a.btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.indigo a.btn-warning.focus,.indigo a.btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.indigo a.btn-warning.disabled,.indigo a.btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.indigo a.btn-warning:not(:disabled):not(.disabled).active,.indigo a.btn-warning:not(:disabled):not(.disabled):active,.show>.indigo a.btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.indigo a.btn-warning:not(:disabled):not(.disabled).active:focus,.indigo a.btn-warning:not(:disabled):not(.disabled):active:focus,.show>.indigo a.btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.indigo a.btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.indigo a.btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.indigo a.btn-danger.focus,.indigo a.btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.indigo a.btn-danger.disabled,.indigo a.btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.indigo a.btn-danger:not(:disabled):not(.disabled).active,.indigo a.btn-danger:not(:disabled):not(.disabled):active,.show>.indigo a.btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.indigo a.btn-danger:not(:disabled):not(.disabled).active:focus,.indigo a.btn-danger:not(:disabled):not(.disabled):active:focus,.show>.indigo a.btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.indigo a.btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.indigo a.btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.indigo a.btn-light.focus,.indigo a.btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.indigo a.btn-light.disabled,.indigo a.btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.indigo a.btn-light:not(:disabled):not(.disabled).active,.indigo a.btn-light:not(:disabled):not(.disabled):active,.show>.indigo a.btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.indigo a.btn-light:not(:disabled):not(.disabled).active:focus,.indigo a.btn-light:not(:disabled):not(.disabled):active:focus,.show>.indigo a.btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.indigo a.btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.indigo a.btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.indigo a.btn-dark.focus,.indigo a.btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.indigo a.btn-dark.disabled,.indigo a.btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.indigo a.btn-dark:not(:disabled):not(.disabled).active,.indigo a.btn-dark:not(:disabled):not(.disabled):active,.show>.indigo a.btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.indigo a.btn-dark:not(:disabled):not(.disabled).active:focus,.indigo a.btn-dark:not(:disabled):not(.disabled):active:focus,.show>.indigo a.btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.indigo .btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.indigo .btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.indigo .btn-outline-primary.focus,.indigo .btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.indigo .btn-outline-primary.disabled,.indigo .btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.indigo .btn-outline-primary:not(:disabled):not(.disabled).active,.indigo .btn-outline-primary:not(:disabled):not(.disabled):active,.show>.indigo .btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.indigo .btn-outline-primary:not(:disabled):not(.disabled).active:focus,.indigo .btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.indigo .btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.indigo .btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.indigo .btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.indigo .btn-outline-secondary.focus,.indigo .btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.indigo .btn-outline-secondary.disabled,.indigo .btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.indigo .btn-outline-secondary:not(:disabled):not(.disabled).active,.indigo .btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.indigo .btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.indigo .btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.indigo .btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.indigo .btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.indigo .btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.indigo .btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.indigo .btn-outline-success.focus,.indigo .btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.indigo .btn-outline-success.disabled,.indigo .btn-outline-success:disabled{color:#4caf50;background-color:transparent}.indigo .btn-outline-success:not(:disabled):not(.disabled).active,.indigo .btn-outline-success:not(:disabled):not(.disabled):active,.show>.indigo .btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.indigo .btn-outline-success:not(:disabled):not(.disabled).active:focus,.indigo .btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.indigo .btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.indigo .btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.indigo .btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.indigo .btn-outline-info.focus,.indigo .btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.indigo .btn-outline-info.disabled,.indigo .btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.indigo .btn-outline-info:not(:disabled):not(.disabled).active,.indigo .btn-outline-info:not(:disabled):not(.disabled):active,.show>.indigo .btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.indigo .btn-outline-info:not(:disabled):not(.disabled).active:focus,.indigo .btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.indigo .btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.indigo .btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.indigo .btn-outline-warning:hover{color:#fff;background-color:#ff9800;border-color:#ff9800}.indigo .btn-outline-warning.focus,.indigo .btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.indigo .btn-outline-warning.disabled,.indigo .btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.indigo .btn-outline-warning:not(:disabled):not(.disabled).active,.indigo .btn-outline-warning:not(:disabled):not(.disabled):active,.show>.indigo .btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.indigo .btn-outline-warning:not(:disabled):not(.disabled).active:focus,.indigo .btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.indigo .btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.indigo .btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.indigo .btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.indigo .btn-outline-danger.focus,.indigo .btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.indigo .btn-outline-danger.disabled,.indigo .btn-outline-danger:disabled{color:#f44336;background-color:transparent}.indigo .btn-outline-danger:not(:disabled):not(.disabled).active,.indigo .btn-outline-danger:not(:disabled):not(.disabled):active,.show>.indigo .btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.indigo .btn-outline-danger:not(:disabled):not(.disabled).active:focus,.indigo .btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.indigo .btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.indigo .btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.indigo .btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.indigo .btn-outline-light.focus,.indigo .btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.indigo .btn-outline-light.disabled,.indigo .btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.indigo .btn-outline-light:not(:disabled):not(.disabled).active,.indigo .btn-outline-light:not(:disabled):not(.disabled):active,.show>.indigo .btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.indigo .btn-outline-light:not(:disabled):not(.disabled).active:focus,.indigo .btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.indigo .btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.indigo .btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.indigo .btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.indigo .btn-outline-dark.focus,.indigo .btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.indigo .btn-outline-dark.disabled,.indigo .btn-outline-dark:disabled{color:#343a40;background-color:transparent}.indigo .btn-outline-dark:not(:disabled):not(.disabled).active,.indigo .btn-outline-dark:not(:disabled):not(.disabled):active,.show>.indigo .btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.indigo .btn-outline-dark:not(:disabled):not(.disabled).active:focus,.indigo .btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.indigo .btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.indigo a.btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.indigo a.btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.indigo a.btn-outline-primary.focus,.indigo a.btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.indigo a.btn-outline-primary.disabled,.indigo a.btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.indigo a.btn-outline-primary:not(:disabled):not(.disabled).active,.indigo a.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.indigo a.btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.indigo a.btn-outline-primary:not(:disabled):not(.disabled).active:focus,.indigo a.btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.indigo a.btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.indigo a.btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.indigo a.btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.indigo a.btn-outline-secondary.focus,.indigo a.btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.indigo a.btn-outline-secondary.disabled,.indigo a.btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.indigo a.btn-outline-secondary:not(:disabled):not(.disabled).active,.indigo a.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.indigo a.btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.indigo a.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.indigo a.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.indigo a.btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.indigo a.btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.indigo a.btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.indigo a.btn-outline-success.focus,.indigo a.btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.indigo a.btn-outline-success.disabled,.indigo a.btn-outline-success:disabled{color:#4caf50;background-color:transparent}.indigo a.btn-outline-success:not(:disabled):not(.disabled).active,.indigo a.btn-outline-success:not(:disabled):not(.disabled):active,.show>.indigo a.btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.indigo a.btn-outline-success:not(:disabled):not(.disabled).active:focus,.indigo a.btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.indigo a.btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.indigo a.btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.indigo a.btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.indigo a.btn-outline-info.focus,.indigo a.btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.indigo a.btn-outline-info.disabled,.indigo a.btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.indigo a.btn-outline-info:not(:disabled):not(.disabled).active,.indigo a.btn-outline-info:not(:disabled):not(.disabled):active,.show>.indigo a.btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.indigo a.btn-outline-info:not(:disabled):not(.disabled).active:focus,.indigo a.btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.indigo a.btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.indigo a.btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.indigo a.btn-outline-warning:hover{color:#fff;background-color:#ff9800;border-color:#ff9800}.indigo a.btn-outline-warning.focus,.indigo a.btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.indigo a.btn-outline-warning.disabled,.indigo a.btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.indigo a.btn-outline-warning:not(:disabled):not(.disabled).active,.indigo a.btn-outline-warning:not(:disabled):not(.disabled):active,.show>.indigo a.btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.indigo a.btn-outline-warning:not(:disabled):not(.disabled).active:focus,.indigo a.btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.indigo a.btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.indigo a.btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.indigo a.btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.indigo a.btn-outline-danger.focus,.indigo a.btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.indigo a.btn-outline-danger.disabled,.indigo a.btn-outline-danger:disabled{color:#f44336;background-color:transparent}.indigo a.btn-outline-danger:not(:disabled):not(.disabled).active,.indigo a.btn-outline-danger:not(:disabled):not(.disabled):active,.show>.indigo a.btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.indigo a.btn-outline-danger:not(:disabled):not(.disabled).active:focus,.indigo a.btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.indigo a.btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.indigo a.btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.indigo a.btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.indigo a.btn-outline-light.focus,.indigo a.btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.indigo a.btn-outline-light.disabled,.indigo a.btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.indigo a.btn-outline-light:not(:disabled):not(.disabled).active,.indigo a.btn-outline-light:not(:disabled):not(.disabled):active,.show>.indigo a.btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.indigo a.btn-outline-light:not(:disabled):not(.disabled).active:focus,.indigo a.btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.indigo a.btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.indigo a.btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.indigo a.btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.indigo a.btn-outline-dark.focus,.indigo a.btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.indigo a.btn-outline-dark.disabled,.indigo a.btn-outline-dark:disabled{color:#343a40;background-color:transparent}.indigo a.btn-outline-dark:not(:disabled):not(.disabled).active,.indigo a.btn-outline-dark:not(:disabled):not(.disabled):active,.show>.indigo a.btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.indigo a.btn-outline-dark:not(:disabled):not(.disabled).active:focus,.indigo a.btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.indigo a.btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.indigo .btn-outline-primary,.indigo a.btn-outline-primary{color:#3f51b5;border-color:#3f51b5}.indigo .btn-outline-primary.disabled,.indigo .btn-outline-primary:disabled,.indigo .btn-outline-primary:focus,.indigo .btn-outline-primary:hover,.indigo .btn-outline-primary:not(:disabled):not(.disabled).active,.indigo .btn-outline-primary:not(:disabled):not(.disabled):active,.indigo a.btn-outline-primary.disabled,.indigo a.btn-outline-primary:disabled,.indigo a.btn-outline-primary:focus,.indigo a.btn-outline-primary:hover,.indigo a.btn-outline-primary:not(:disabled):not(.disabled).active,.indigo a.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.indigo .btn-outline-primary.dropdown-toggle,.show>.indigo a.btn-outline-primary.dropdown-toggle{color:#fff;border-color:#3f51b5;background-color:#3f51b5}.indigo .btn-outline-secondary,.indigo a.btn-outline-secondary{color:#ff4081;border-color:#ff4081}.indigo .btn-outline-secondary.disabled,.indigo .btn-outline-secondary:disabled,.indigo .btn-outline-secondary:focus,.indigo .btn-outline-secondary:hover,.indigo .btn-outline-secondary:not(:disabled):not(.disabled).active,.indigo .btn-outline-secondary:not(:disabled):not(.disabled):active,.indigo a.btn-outline-secondary.disabled,.indigo a.btn-outline-secondary:disabled,.indigo a.btn-outline-secondary:focus,.indigo a.btn-outline-secondary:hover,.indigo a.btn-outline-secondary:not(:disabled):not(.disabled).active,.indigo a.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.indigo .btn-outline-secondary.dropdown-toggle,.show>.indigo a.btn-outline-secondary.dropdown-toggle{color:#fff;border-color:#ff4081;background-color:#ff4081}.indigo a,.indigo a.text-primary{color:#3f51b5}.indigo a.text-primary:focus,.indigo a.text-primary:hover,.indigo a:focus,.indigo a:hover{color:#32408f}.indigo .text-primary{color:#3f51b5!important}.indigo .page-link,.indigo .page-link:focus,.indigo .page-link:hover{color:#3f51b5}.indigo .badge-primary,.indigo .bg-primary{background-color:#3f51b5!important;color:#fff!important}.indigo .btn-primary,.indigo .jr-btn-primary,.indigo a.btn-primary,.indigo a.jr-btn-primary{background-color:#3f51b5;border-color:#3f51b5;color:#fff}.indigo .btn-primary:focus,.indigo .btn-primary:hover,.indigo .btn-primary:not([disabled]):not(.disabled):active,.indigo .jr-btn-primary:focus,.indigo .jr-btn-primary:hover,.indigo .jr-btn-primary:not([disabled]):not(.disabled):active,.indigo a.btn-primary:focus,.indigo a.btn-primary:hover,.indigo a.btn-primary:not([disabled]):not(.disabled):active,.indigo a.jr-btn-primary:focus,.indigo a.jr-btn-primary:hover,.indigo a.jr-btn-primary:not([disabled]):not(.disabled):active{background-color:#3849a2!important;border-color:#3849a2!important;color:#fff!important}.indigo .bg-primary.lighten-4{background-color:#c5cae9!important}.indigo .bg-primary.lighten-3{background-color:#9fa8da!important}.indigo .bg-primary.lighten-2{background-color:#7986cb!important}.indigo .bg-primary.lighten-1{background-color:#5c6bc0!important}.indigo .bg-primary.darken-1{background-color:#3949ab!important}.indigo .bg-primary.darken-2{background-color:#303f9f!important}.indigo .bg-primary.darken-3{background-color:#283593!important}.indigo .bg-primary.darken-4{background-color:#1a237e!important}.indigo .bg-primary.accent-1{background-color:#8c9eff!important}.indigo .bg-primary.accent-2{background-color:#536dfe!important}.indigo .bg-primary.accent-3{background-color:#3d5afe!important}.indigo .bg-primary.accent-4{background-color:#304ffe!important}.indigo a.text-secondary{color:#ff4081}.indigo a.text-secondary:focus,.indigo a.text-secondary:hover{color:#ff0d5f!important}.indigo .text-secondary{color:#ff4081!important}.indigo .badge-secondary,.indigo .bg-secondary{background-color:#ff4081!important;color:#fff!important}.indigo .btn-secondary{background-color:#ff4081;border-color:#ff4081;color:#fff}.indigo .btn-secondary:active,.indigo .btn-secondary:focus,.indigo .btn-secondary:hover{background-color:#ff2770!important;border-color:#ff2770!important;color:#fff!important}.indigo .jr-flat-btn{background-color:transparent!important;color:#5c5c5c!important}.indigo .jr-flat-btn:active,.indigo .jr-flat-btn:focus,.indigo .jr-flat-btn:hover{background-color:#f5f5f5!important;color:#5c5c5c!important}.indigo .jr-flat-btn.jr-btn-primary{background-color:transparent!important;color:#3f51b5!important;border-color:transparent!important}.indigo .jr-flat-btn.jr-btn-primary:focus,.indigo .jr-flat-btn.jr-btn-primary:hover{background-color:rgba(63,81,181,.12)!important;color:#3f51b5!important}.indigo .bg-primary .jr-flat-btn.jr-btn-primary{background-color:transparent!important;color:#fff!important;border-color:transparent!important}.indigo .bg-primary .jr-flat-btn.jr-btn-primary:focus,.indigo .bg-primary .jr-flat-btn.jr-btn-primary:hover{background-color:hsla(0,0%,100%,.12)!important;color:#fff!important}.indigo .jr-flat-btn.jr-btn-secondary{background-color:transparent!important;color:#ff4081!important;border-color:transparent!important}.indigo .jr-flat-btn.jr-btn-secondary:focus,.indigo .jr-flat-btn.jr-btn-secondary:hover{background-color:rgba(255,64,129,.12)!important;color:#ff4081!important}.indigo .bg-secondary .jr-flat-btn.jr-btn-secondary{background-color:transparent!important;color:#fff!important;border-color:transparent!important}.indigo .bg-secondary .jr-flat-btn.jr-btn-secondary:focus,.indigo .bg-secondary .jr-flat-btn.jr-btn-secondary:hover{background-color:hsla(0,0%,100%,.12)!important;color:#fff!important}@media screen and (max-width:575px){.indigo .app-main-header .search-dropdown input{background-color:#fff}}.indigo .color-theme-header{background-color:#3f51b5}.indigo .side-nav{background-color:#fff!important;color:#868e96!important}.indigo .side-nav .user-profile{background-color:#f8f9fa;position:relative;z-index:2}.indigo .side-nav .user-profile .text-white{color:#3f51b5!important}.indigo .side-nav .customizer{border-bottom:1px solid #e6e7e9}.indigo .side-nav .user-detail .user-name{color:#3f51b5}.indigo ul.nav-menu .nav-header,.indigo ul.nav-menu li a{color:#868e96}.indigo ul.nav-menu>li.open>a,.indigo ul.nav-menu>li>a:focus,.indigo ul.nav-menu>li>a:hover{background-color:#fff;color:#3f51b5}.indigo ul.nav-menu li.menu>a:focus:before,.indigo ul.nav-menu li.menu>a:hover:before{color:#3f51b5}.indigo ul.nav-menu li ul{background-color:#fff}.indigo ul.nav-menu li.menu>a:before{color:#868e96}.indigo ul.nav-menu li.menu.open>a:before,.indigo ul.nav-menu li.menu>a:focus:before,.indigo ul.nav-menu li.menu li>a:hover:before{color:#3f51b5}.indigo ul.nav-menu li.menu .sub-menu li>a:before{color:#868e96}.indigo ul.nav-menu li.menu .sub-menu li>a.active .nav-text{background-color:#3f51b5}.indigo ul.nav-menu li.menu.open .sub-menu li>a.active:before,.indigo ul.nav-menu li.menu .sub-menu li>a:focus,.indigo ul.nav-menu li.menu .sub-menu li>a:focus:before,.indigo ul.nav-menu li.menu .sub-menu li>a:hover,.indigo ul.nav-menu li.menu .sub-menu li>a:hover:before{background-color:#fff;color:#3f51b5}.indigo .navbar-nav li:focus>a,.indigo .navbar-nav li:hover>a{color:#3f51b5}.indigo .navbar-nav li a{color:#868e96}.indigo .navbar-nav li.nav-item.active>a,.indigo .navbar-nav li a:focus,.indigo .navbar-nav li a:hover,.indigo .navbar-nav ul.sub-menu li.active>a,.indigo .navbar-nav ul.sub-menu li a.active{color:#3f51b5}.indigo .navbar-nav .nav-arrow>a:before{color:#868e96}.indigo .navbar-nav .nav-arrow.active>a:before,.indigo .navbar-nav .nav-arrow:focus>a:before,.indigo .navbar-nav .nav-arrow:hover>a:before,.indigo .navbar-nav .nav-arrow a:focus:before,.indigo .navbar-nav .nav-arrow a:hover:before{color:#3f51b5}.indigo .app-top-nav{background-color:#3f51b5}.indigo .app-top-nav .navbar-nav li.nav-item>a{color:#fff}.indigo .app-top-nav .navbar-nav li.nav-item.active>a,.indigo .app-top-nav .navbar-nav li.nav-item:focus>a,.indigo .app-top-nav .navbar-nav li.nav-item:hover>a,.indigo .app-top-nav .navbar-nav li.nav-item>a:focus,.indigo .app-top-nav .navbar-nav li.nav-item>a:hover{color:#ff4081}.indigo .module-nav li a.active{border-color:#3f51b5}.indigo .rbc-event{background-color:#3f51b5}.indigo .rbc-event.rbc-selected{background-color:#32408f}.indigo .rbc-slot-selection{background-color:rgba(63,81,181,.7)}.indigo .rbc-toolbar button.rbc-active,.indigo .rbc-toolbar button.rbc-active:focus,.indigo .rbc-toolbar button.rbc-active:hover,.indigo .rbc-toolbar button:active,.indigo .rbc-toolbar button:active:focus,.indigo .rbc-toolbar button:active:hover,.indigo .rbc-toolbar button:focus,.indigo .rbc-toolbar button:hover{background-color:rgba(63,81,181,.9);border-color:#3f51b5}.indigo .rbc-day-slot .rbc-event{border-color:#3f51b5}.indigo .chat-sidenav-title{color:#3f51b5}.indigo .chat-user-item.active,.indigo .chat-user-item:hover{background-color:#e4e7f6}.indigo .contact-list i{color:#3f51b5}.indigo .Collapsible__trigger{background:#3f51b5}.indigo .categories-list li.active a,.indigo .categories-list li a:focus,.indigo .categories-list li a:hover{color:#3f51b5}.indigo .filter-with-bg-color ul li a,.indigo .login-content .form-control:focus{border-color:#3f51b5}.indigo .filter-with-bg-color ul li a.active,.indigo .filter-with-bg-color ul li a:focus,.indigo .filter-with-bg-color ul li a:hover{background-color:#3f51b5}.indigo .profile-intro .icon{color:#3f51b5}.indigo .actions,.indigo .social-link li.active a,.indigo .social-link li a:focus,.indigo .social-link li a:hover{color:#ff4081}.indigo .table-hover tbody tr:hover{background-color:rgba(63,81,181,.075)}.indigo .border-primary{border-color:#3f51b5!important}.indigo .app-logo-content{background-color:#3f51b5}.indigo .app-social-block .social-link button{border:1px solid #3f51b5;color:#3f51b5}.indigo .app-social-block .social-link button:focus,.indigo .app-social-block .social-link button:hover{color:#fff;background-color:#3f51b5}.indigo .btn-group-vertical>.btn-default.active,.indigo .btn-group-vertical>.jr-btn.active,.indigo .btn-group>.btn-default.active,.indigo .btn-group>.jr-btn.active{background-color:#3f51b5;border-color:#3f51b5}.indigo .btn-group-vertical>.jr-flat-btn,.indigo .btn-group>.jr-flat-btn{border-color:transparent}.indigo .btn-group-vertical>.jr-flat-btn.active,.indigo .btn-group>.jr-flat-btn.active{background-color:transparent;color:#3f51b5!important;border-color:transparent!important}.indigo .btn-group-vertical>.jr-flat-btn.active:focus,.indigo .btn-group-vertical>.jr-flat-btn.active:hover,.indigo .btn-group>.jr-flat-btn.active:focus,.indigo .btn-group>.jr-flat-btn.active:hover{background-color:rgba(63,81,181,.12)!important;color:#3f51b5!important}.indigo .nav-pill-sales .nav-link.active{background-color:#3f51b5;border-color:#3f51b5}.indigo .form-checkbox>input+.check,.indigo .form-checkbox>input.sm+.check{color:#3f51b5}.cyan .right-arrow,.cyan .right-arrow:after{color:#00bcd4}.cyan .btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.cyan .btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.cyan .btn-primary.focus,.cyan .btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.cyan .btn-primary.disabled,.cyan .btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.cyan .btn-primary:not(:disabled):not(.disabled).active,.cyan .btn-primary:not(:disabled):not(.disabled):active,.show>.cyan .btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.cyan .btn-primary:not(:disabled):not(.disabled).active:focus,.cyan .btn-primary:not(:disabled):not(.disabled):active:focus,.show>.cyan .btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.cyan .btn-secondary{background-color:#e91e63;border-color:#e91e63;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.cyan .btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.cyan .btn-secondary.focus,.cyan .btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.cyan .btn-secondary.disabled,.cyan .btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.cyan .btn-secondary:not(:disabled):not(.disabled).active,.cyan .btn-secondary:not(:disabled):not(.disabled):active,.show>.cyan .btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.cyan .btn-secondary:not(:disabled):not(.disabled).active:focus,.cyan .btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.cyan .btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.cyan .btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.cyan .btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.cyan .btn-success.focus,.cyan .btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.cyan .btn-success.disabled,.cyan .btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.cyan .btn-success:not(:disabled):not(.disabled).active,.cyan .btn-success:not(:disabled):not(.disabled):active,.show>.cyan .btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.cyan .btn-success:not(:disabled):not(.disabled).active:focus,.cyan .btn-success:not(:disabled):not(.disabled):active:focus,.show>.cyan .btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.cyan .btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.cyan .btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.cyan .btn-info.focus,.cyan .btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.cyan .btn-info.disabled,.cyan .btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.cyan .btn-info:not(:disabled):not(.disabled).active,.cyan .btn-info:not(:disabled):not(.disabled):active,.show>.cyan .btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.cyan .btn-info:not(:disabled):not(.disabled).active:focus,.cyan .btn-info:not(:disabled):not(.disabled):active:focus,.show>.cyan .btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.cyan .btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.cyan .btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.cyan .btn-warning.focus,.cyan .btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.cyan .btn-warning.disabled,.cyan .btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.cyan .btn-warning:not(:disabled):not(.disabled).active,.cyan .btn-warning:not(:disabled):not(.disabled):active,.show>.cyan .btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.cyan .btn-warning:not(:disabled):not(.disabled).active:focus,.cyan .btn-warning:not(:disabled):not(.disabled):active:focus,.show>.cyan .btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.cyan .btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.cyan .btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.cyan .btn-danger.focus,.cyan .btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.cyan .btn-danger.disabled,.cyan .btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.cyan .btn-danger:not(:disabled):not(.disabled).active,.cyan .btn-danger:not(:disabled):not(.disabled):active,.show>.cyan .btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.cyan .btn-danger:not(:disabled):not(.disabled).active:focus,.cyan .btn-danger:not(:disabled):not(.disabled):active:focus,.show>.cyan .btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.cyan .btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.cyan .btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.cyan .btn-light.focus,.cyan .btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.cyan .btn-light.disabled,.cyan .btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.cyan .btn-light:not(:disabled):not(.disabled).active,.cyan .btn-light:not(:disabled):not(.disabled):active,.show>.cyan .btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.cyan .btn-light:not(:disabled):not(.disabled).active:focus,.cyan .btn-light:not(:disabled):not(.disabled):active:focus,.show>.cyan .btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.cyan .btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.cyan .btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.cyan .btn-dark.focus,.cyan .btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.cyan .btn-dark.disabled,.cyan .btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.cyan .btn-dark:not(:disabled):not(.disabled).active,.cyan .btn-dark:not(:disabled):not(.disabled):active,.show>.cyan .btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.cyan .btn-dark:not(:disabled):not(.disabled).active:focus,.cyan .btn-dark:not(:disabled):not(.disabled):active:focus,.show>.cyan .btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.cyan a.btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.cyan a.btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.cyan a.btn-primary.focus,.cyan a.btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.cyan a.btn-primary.disabled,.cyan a.btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.cyan a.btn-primary:not(:disabled):not(.disabled).active,.cyan a.btn-primary:not(:disabled):not(.disabled):active,.show>.cyan a.btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.cyan a.btn-primary:not(:disabled):not(.disabled).active:focus,.cyan a.btn-primary:not(:disabled):not(.disabled):active:focus,.show>.cyan a.btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.cyan a.btn-secondary{color:#fff;background-color:#e91e63;border-color:#e91e63;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.cyan a.btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.cyan a.btn-secondary.focus,.cyan a.btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.cyan a.btn-secondary.disabled,.cyan a.btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.cyan a.btn-secondary:not(:disabled):not(.disabled).active,.cyan a.btn-secondary:not(:disabled):not(.disabled):active,.show>.cyan a.btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.cyan a.btn-secondary:not(:disabled):not(.disabled).active:focus,.cyan a.btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.cyan a.btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.cyan a.btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.cyan a.btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.cyan a.btn-success.focus,.cyan a.btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.cyan a.btn-success.disabled,.cyan a.btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.cyan a.btn-success:not(:disabled):not(.disabled).active,.cyan a.btn-success:not(:disabled):not(.disabled):active,.show>.cyan a.btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.cyan a.btn-success:not(:disabled):not(.disabled).active:focus,.cyan a.btn-success:not(:disabled):not(.disabled):active:focus,.show>.cyan a.btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.cyan a.btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.cyan a.btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.cyan a.btn-info.focus,.cyan a.btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.cyan a.btn-info.disabled,.cyan a.btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.cyan a.btn-info:not(:disabled):not(.disabled).active,.cyan a.btn-info:not(:disabled):not(.disabled):active,.show>.cyan a.btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.cyan a.btn-info:not(:disabled):not(.disabled).active:focus,.cyan a.btn-info:not(:disabled):not(.disabled):active:focus,.show>.cyan a.btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.cyan a.btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.cyan a.btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.cyan a.btn-warning.focus,.cyan a.btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.cyan a.btn-warning.disabled,.cyan a.btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.cyan a.btn-warning:not(:disabled):not(.disabled).active,.cyan a.btn-warning:not(:disabled):not(.disabled):active,.show>.cyan a.btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.cyan a.btn-warning:not(:disabled):not(.disabled).active:focus,.cyan a.btn-warning:not(:disabled):not(.disabled):active:focus,.show>.cyan a.btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.cyan a.btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.cyan a.btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.cyan a.btn-danger.focus,.cyan a.btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.cyan a.btn-danger.disabled,.cyan a.btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.cyan a.btn-danger:not(:disabled):not(.disabled).active,.cyan a.btn-danger:not(:disabled):not(.disabled):active,.show>.cyan a.btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.cyan a.btn-danger:not(:disabled):not(.disabled).active:focus,.cyan a.btn-danger:not(:disabled):not(.disabled):active:focus,.show>.cyan a.btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.cyan a.btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.cyan a.btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.cyan a.btn-light.focus,.cyan a.btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.cyan a.btn-light.disabled,.cyan a.btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.cyan a.btn-light:not(:disabled):not(.disabled).active,.cyan a.btn-light:not(:disabled):not(.disabled):active,.show>.cyan a.btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.cyan a.btn-light:not(:disabled):not(.disabled).active:focus,.cyan a.btn-light:not(:disabled):not(.disabled):active:focus,.show>.cyan a.btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.cyan a.btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.cyan a.btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.cyan a.btn-dark.focus,.cyan a.btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.cyan a.btn-dark.disabled,.cyan a.btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.cyan a.btn-dark:not(:disabled):not(.disabled).active,.cyan a.btn-dark:not(:disabled):not(.disabled):active,.show>.cyan a.btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.cyan a.btn-dark:not(:disabled):not(.disabled).active:focus,.cyan a.btn-dark:not(:disabled):not(.disabled):active:focus,.show>.cyan a.btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.cyan .btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.cyan .btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.cyan .btn-outline-primary.focus,.cyan .btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.cyan .btn-outline-primary.disabled,.cyan .btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.cyan .btn-outline-primary:not(:disabled):not(.disabled).active,.cyan .btn-outline-primary:not(:disabled):not(.disabled):active,.show>.cyan .btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.cyan .btn-outline-primary:not(:disabled):not(.disabled).active:focus,.cyan .btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.cyan .btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.cyan .btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.cyan .btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.cyan .btn-outline-secondary.focus,.cyan .btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.cyan .btn-outline-secondary.disabled,.cyan .btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.cyan .btn-outline-secondary:not(:disabled):not(.disabled).active,.cyan .btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.cyan .btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.cyan .btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.cyan .btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.cyan .btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.cyan .btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.cyan .btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.cyan .btn-outline-success.focus,.cyan .btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.cyan .btn-outline-success.disabled,.cyan .btn-outline-success:disabled{color:#4caf50;background-color:transparent}.cyan .btn-outline-success:not(:disabled):not(.disabled).active,.cyan .btn-outline-success:not(:disabled):not(.disabled):active,.show>.cyan .btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.cyan .btn-outline-success:not(:disabled):not(.disabled).active:focus,.cyan .btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.cyan .btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.cyan .btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.cyan .btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.cyan .btn-outline-info.focus,.cyan .btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.cyan .btn-outline-info.disabled,.cyan .btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.cyan .btn-outline-info:not(:disabled):not(.disabled).active,.cyan .btn-outline-info:not(:disabled):not(.disabled):active,.show>.cyan .btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.cyan .btn-outline-info:not(:disabled):not(.disabled).active:focus,.cyan .btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.cyan .btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.cyan .btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.cyan .btn-outline-warning:hover{color:#fff;background-color:#ff9800;border-color:#ff9800}.cyan .btn-outline-warning.focus,.cyan .btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.cyan .btn-outline-warning.disabled,.cyan .btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.cyan .btn-outline-warning:not(:disabled):not(.disabled).active,.cyan .btn-outline-warning:not(:disabled):not(.disabled):active,.show>.cyan .btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.cyan .btn-outline-warning:not(:disabled):not(.disabled).active:focus,.cyan .btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.cyan .btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.cyan .btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.cyan .btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.cyan .btn-outline-danger.focus,.cyan .btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.cyan .btn-outline-danger.disabled,.cyan .btn-outline-danger:disabled{color:#f44336;background-color:transparent}.cyan .btn-outline-danger:not(:disabled):not(.disabled).active,.cyan .btn-outline-danger:not(:disabled):not(.disabled):active,.show>.cyan .btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.cyan .btn-outline-danger:not(:disabled):not(.disabled).active:focus,.cyan .btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.cyan .btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.cyan .btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.cyan .btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.cyan .btn-outline-light.focus,.cyan .btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.cyan .btn-outline-light.disabled,.cyan .btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.cyan .btn-outline-light:not(:disabled):not(.disabled).active,.cyan .btn-outline-light:not(:disabled):not(.disabled):active,.show>.cyan .btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.cyan .btn-outline-light:not(:disabled):not(.disabled).active:focus,.cyan .btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.cyan .btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.cyan .btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.cyan .btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.cyan .btn-outline-dark.focus,.cyan .btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.cyan .btn-outline-dark.disabled,.cyan .btn-outline-dark:disabled{color:#343a40;background-color:transparent}.cyan .btn-outline-dark:not(:disabled):not(.disabled).active,.cyan .btn-outline-dark:not(:disabled):not(.disabled):active,.show>.cyan .btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.cyan .btn-outline-dark:not(:disabled):not(.disabled).active:focus,.cyan .btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.cyan .btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.cyan a.btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.cyan a.btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.cyan a.btn-outline-primary.focus,.cyan a.btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.cyan a.btn-outline-primary.disabled,.cyan a.btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.cyan a.btn-outline-primary:not(:disabled):not(.disabled).active,.cyan a.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.cyan a.btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.cyan a.btn-outline-primary:not(:disabled):not(.disabled).active:focus,.cyan a.btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.cyan a.btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.cyan a.btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.cyan a.btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.cyan a.btn-outline-secondary.focus,.cyan a.btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.cyan a.btn-outline-secondary.disabled,.cyan a.btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.cyan a.btn-outline-secondary:not(:disabled):not(.disabled).active,.cyan a.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.cyan a.btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.cyan a.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.cyan a.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.cyan a.btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.cyan a.btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.cyan a.btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.cyan a.btn-outline-success.focus,.cyan a.btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.cyan a.btn-outline-success.disabled,.cyan a.btn-outline-success:disabled{color:#4caf50;background-color:transparent}.cyan a.btn-outline-success:not(:disabled):not(.disabled).active,.cyan a.btn-outline-success:not(:disabled):not(.disabled):active,.show>.cyan a.btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.cyan a.btn-outline-success:not(:disabled):not(.disabled).active:focus,.cyan a.btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.cyan a.btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.cyan a.btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.cyan a.btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.cyan a.btn-outline-info.focus,.cyan a.btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.cyan a.btn-outline-info.disabled,.cyan a.btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.cyan a.btn-outline-info:not(:disabled):not(.disabled).active,.cyan a.btn-outline-info:not(:disabled):not(.disabled):active,.show>.cyan a.btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.cyan a.btn-outline-info:not(:disabled):not(.disabled).active:focus,.cyan a.btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.cyan a.btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.cyan a.btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.cyan a.btn-outline-warning:hover{color:#fff;background-color:#ff9800;border-color:#ff9800}.cyan a.btn-outline-warning.focus,.cyan a.btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.cyan a.btn-outline-warning.disabled,.cyan a.btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.cyan a.btn-outline-warning:not(:disabled):not(.disabled).active,.cyan a.btn-outline-warning:not(:disabled):not(.disabled):active,.show>.cyan a.btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.cyan a.btn-outline-warning:not(:disabled):not(.disabled).active:focus,.cyan a.btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.cyan a.btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.cyan a.btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.cyan a.btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.cyan a.btn-outline-danger.focus,.cyan a.btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.cyan a.btn-outline-danger.disabled,.cyan a.btn-outline-danger:disabled{color:#f44336;background-color:transparent}.cyan a.btn-outline-danger:not(:disabled):not(.disabled).active,.cyan a.btn-outline-danger:not(:disabled):not(.disabled):active,.show>.cyan a.btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.cyan a.btn-outline-danger:not(:disabled):not(.disabled).active:focus,.cyan a.btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.cyan a.btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.cyan a.btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.cyan a.btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.cyan a.btn-outline-light.focus,.cyan a.btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.cyan a.btn-outline-light.disabled,.cyan a.btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.cyan a.btn-outline-light:not(:disabled):not(.disabled).active,.cyan a.btn-outline-light:not(:disabled):not(.disabled):active,.show>.cyan a.btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.cyan a.btn-outline-light:not(:disabled):not(.disabled).active:focus,.cyan a.btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.cyan a.btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.cyan a.btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.cyan a.btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.cyan a.btn-outline-dark.focus,.cyan a.btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.cyan a.btn-outline-dark.disabled,.cyan a.btn-outline-dark:disabled{color:#343a40;background-color:transparent}.cyan a.btn-outline-dark:not(:disabled):not(.disabled).active,.cyan a.btn-outline-dark:not(:disabled):not(.disabled):active,.show>.cyan a.btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.cyan a.btn-outline-dark:not(:disabled):not(.disabled).active:focus,.cyan a.btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.cyan a.btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.cyan .btn-outline-primary,.cyan a.btn-outline-primary{color:#00bcd4;border-color:#00bcd4}.cyan .btn-outline-primary.disabled,.cyan .btn-outline-primary:disabled,.cyan .btn-outline-primary:focus,.cyan .btn-outline-primary:hover,.cyan .btn-outline-primary:not(:disabled):not(.disabled).active,.cyan .btn-outline-primary:not(:disabled):not(.disabled):active,.cyan a.btn-outline-primary.disabled,.cyan a.btn-outline-primary:disabled,.cyan a.btn-outline-primary:focus,.cyan a.btn-outline-primary:hover,.cyan a.btn-outline-primary:not(:disabled):not(.disabled).active,.cyan a.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.cyan .btn-outline-primary.dropdown-toggle,.show>.cyan a.btn-outline-primary.dropdown-toggle{color:#fff;border-color:#00bcd4;background-color:#00bcd4}.cyan .btn-outline-secondary,.cyan a.btn-outline-secondary{color:#69f0ae;border-color:#69f0ae}.cyan .btn-outline-secondary.disabled,.cyan .btn-outline-secondary:disabled,.cyan .btn-outline-secondary:focus,.cyan .btn-outline-secondary:hover,.cyan .btn-outline-secondary:not(:disabled):not(.disabled).active,.cyan .btn-outline-secondary:not(:disabled):not(.disabled):active,.cyan a.btn-outline-secondary.disabled,.cyan a.btn-outline-secondary:disabled,.cyan a.btn-outline-secondary:focus,.cyan a.btn-outline-secondary:hover,.cyan a.btn-outline-secondary:not(:disabled):not(.disabled).active,.cyan a.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.cyan .btn-outline-secondary.dropdown-toggle,.show>.cyan a.btn-outline-secondary.dropdown-toggle{color:#fff;border-color:#69f0ae;background-color:#69f0ae}.cyan a,.cyan a.text-primary{color:#00bcd4}.cyan a.text-primary:focus,.cyan a.text-primary:hover,.cyan a:focus,.cyan a:hover{color:#008fa1}.cyan .text-primary{color:#00bcd4!important}.cyan .page-link,.cyan .page-link:focus,.cyan .page-link:hover{color:#00bcd4}.cyan .badge-primary,.cyan .bg-primary{background-color:#00bcd4!important;color:#fff!important}.cyan .btn-primary,.cyan .jr-btn-primary,.cyan a.btn-primary,.cyan a.jr-btn-primary{background-color:#00bcd4;border-color:#00bcd4;color:#fff}.cyan .btn-primary:focus,.cyan .btn-primary:hover,.cyan .btn-primary:not([disabled]):not(.disabled):active,.cyan .jr-btn-primary:focus,.cyan .jr-btn-primary:hover,.cyan .jr-btn-primary:not([disabled]):not(.disabled):active,.cyan a.btn-primary:focus,.cyan a.btn-primary:hover,.cyan a.btn-primary:not([disabled]):not(.disabled):active,.cyan a.jr-btn-primary:focus,.cyan a.jr-btn-primary:hover,.cyan a.jr-btn-primary:not([disabled]):not(.disabled):active{background-color:#00a5bb!important;border-color:#00a5bb!important;color:#fff!important}.cyan .bg-primary.lighten-4{background-color:#b2ebf2!important}.cyan .bg-primary.lighten-3{background-color:#80deea!important}.cyan .bg-primary.lighten-2{background-color:#4dd0e1!important}.cyan .bg-primary.lighten-1{background-color:#26c6da!important}.cyan .bg-primary.darken-1{background-color:#00acc1!important}.cyan .bg-primary.darken-2{background-color:#0097a7!important}.cyan .bg-primary.darken-3{background-color:#00838f!important}.cyan .bg-primary.darken-4{background-color:#006064!important}.cyan .bg-primary.accent-1{background-color:#84ffff!important}.cyan .bg-primary.accent-2{background-color:#18ffff!important}.cyan .bg-primary.accent-3{background-color:#00e5ff!important}.cyan .bg-primary.accent-4{background-color:#00b8d4!important}.cyan a.text-secondary{color:#69f0ae}.cyan a.text-secondary:focus,.cyan a.text-secondary:hover{color:#3beb95!important}.cyan .text-secondary{color:#69f0ae!important}.cyan .badge-secondary,.cyan .bg-secondary{background-color:#69f0ae!important;color:#fff!important}.cyan .btn-secondary{background-color:#69f0ae;border-color:#69f0ae;color:#fff}.cyan .btn-secondary:active,.cyan .btn-secondary:focus,.cyan .btn-secondary:hover{background-color:#52eea1!important;border-color:#52eea1!important;color:#fff!important}.cyan .jr-flat-btn{background-color:transparent!important;color:#5c5c5c!important}.cyan .jr-flat-btn:active,.cyan .jr-flat-btn:focus,.cyan .jr-flat-btn:hover{background-color:#f5f5f5!important;color:#5c5c5c!important}.cyan .jr-flat-btn.jr-btn-primary{background-color:transparent!important;color:#00bcd4!important;border-color:transparent!important}.cyan .jr-flat-btn.jr-btn-primary:focus,.cyan .jr-flat-btn.jr-btn-primary:hover{background-color:rgba(0,188,212,.12)!important;color:#00bcd4!important}.cyan .bg-primary .jr-flat-btn.jr-btn-primary{background-color:transparent!important;color:#fff!important;border-color:transparent!important}.cyan .bg-primary .jr-flat-btn.jr-btn-primary:focus,.cyan .bg-primary .jr-flat-btn.jr-btn-primary:hover{background-color:hsla(0,0%,100%,.12)!important;color:#fff!important}.cyan .jr-flat-btn.jr-btn-secondary{background-color:transparent!important;color:#69f0ae!important;border-color:transparent!important}.cyan .jr-flat-btn.jr-btn-secondary:focus,.cyan .jr-flat-btn.jr-btn-secondary:hover{background-color:rgba(105,240,174,.12)!important;color:#69f0ae!important}.cyan .bg-secondary .jr-flat-btn.jr-btn-secondary{background-color:transparent!important;color:#fff!important;border-color:transparent!important}.cyan .bg-secondary .jr-flat-btn.jr-btn-secondary:focus,.cyan .bg-secondary .jr-flat-btn.jr-btn-secondary:hover{background-color:hsla(0,0%,100%,.12)!important;color:#fff!important}@media screen and (max-width:575px){.cyan .app-main-header .search-dropdown input{background-color:#fff}}.cyan .color-theme-header{background-color:#00bcd4}.cyan .side-nav{background-color:#fff!important;color:#868e96!important}.cyan .side-nav .user-profile{background-color:#f8f9fa;position:relative;z-index:2}.cyan .side-nav .user-profile .text-white{color:#00bcd4!important}.cyan .side-nav .customizer{border-bottom:1px solid #e6e7e9}.cyan .side-nav .user-detail .user-name{color:#00bcd4}.cyan ul.nav-menu .nav-header,.cyan ul.nav-menu li a{color:#868e96}.cyan ul.nav-menu>li.open>a,.cyan ul.nav-menu>li>a:focus,.cyan ul.nav-menu>li>a:hover{background-color:#fff;color:#00bcd4}.cyan ul.nav-menu li.menu>a:focus:before,.cyan ul.nav-menu li.menu>a:hover:before{color:#00bcd4}.cyan ul.nav-menu li ul{background-color:#fff}.cyan ul.nav-menu li.menu>a:before{color:#868e96}.cyan ul.nav-menu li.menu.open>a:before,.cyan ul.nav-menu li.menu>a:focus:before,.cyan ul.nav-menu li.menu li>a:hover:before{color:#00bcd4}.cyan ul.nav-menu li.menu .sub-menu li>a:before{color:#868e96}.cyan ul.nav-menu li.menu .sub-menu li>a.active .nav-text{background-color:#00bcd4}.cyan ul.nav-menu li.menu.open .sub-menu li>a.active:before,.cyan ul.nav-menu li.menu .sub-menu li>a:focus,.cyan ul.nav-menu li.menu .sub-menu li>a:focus:before,.cyan ul.nav-menu li.menu .sub-menu li>a:hover,.cyan ul.nav-menu li.menu .sub-menu li>a:hover:before{background-color:#fff;color:#00bcd4}.cyan .navbar-nav li:focus>a,.cyan .navbar-nav li:hover>a{color:#00bcd4}.cyan .navbar-nav li a{color:#868e96}.cyan .navbar-nav li.nav-item.active>a,.cyan .navbar-nav li a:focus,.cyan .navbar-nav li a:hover,.cyan .navbar-nav ul.sub-menu li.active>a,.cyan .navbar-nav ul.sub-menu li a.active{color:#00bcd4}.cyan .navbar-nav .nav-arrow>a:before{color:#868e96}.cyan .navbar-nav .nav-arrow.active>a:before,.cyan .navbar-nav .nav-arrow:focus>a:before,.cyan .navbar-nav .nav-arrow:hover>a:before,.cyan .navbar-nav .nav-arrow a:focus:before,.cyan .navbar-nav .nav-arrow a:hover:before{color:#00bcd4}.cyan .app-top-nav{background-color:#00bcd4}.cyan .app-top-nav .navbar-nav li.nav-item>a{color:#fff}.cyan .app-top-nav .navbar-nav li.nav-item.active>a,.cyan .app-top-nav .navbar-nav li.nav-item:focus>a,.cyan .app-top-nav .navbar-nav li.nav-item:hover>a,.cyan .app-top-nav .navbar-nav li.nav-item>a:focus,.cyan .app-top-nav .navbar-nav li.nav-item>a:hover{color:#69f0ae}.cyan .module-nav li a.active{border-color:#00bcd4}.cyan .rbc-event{background-color:#00bcd4}.cyan .rbc-event.rbc-selected{background-color:#008fa1}.cyan .rbc-slot-selection{background-color:rgba(0,188,212,.7)}.cyan .rbc-toolbar button.rbc-active,.cyan .rbc-toolbar button.rbc-active:focus,.cyan .rbc-toolbar button.rbc-active:hover,.cyan .rbc-toolbar button:active,.cyan .rbc-toolbar button:active:focus,.cyan .rbc-toolbar button:active:hover,.cyan .rbc-toolbar button:focus,.cyan .rbc-toolbar button:hover{background-color:rgba(0,188,212,.9);border-color:#00bcd4}.cyan .rbc-day-slot .rbc-event{border-color:#00bcd4}.cyan .chat-sidenav-title{color:#00bcd4}.cyan .chat-user-item.active,.cyan .chat-user-item:hover{background-color:#bbf7ff}.cyan .contact-list i{color:#00bcd4}.cyan .Collapsible__trigger{background:#00bcd4}.cyan .categories-list li.active a,.cyan .categories-list li a:focus,.cyan .categories-list li a:hover{color:#00bcd4}.cyan .filter-with-bg-color ul li a,.cyan .login-content .form-control:focus{border-color:#00bcd4}.cyan .filter-with-bg-color ul li a.active,.cyan .filter-with-bg-color ul li a:focus,.cyan .filter-with-bg-color ul li a:hover{background-color:#00bcd4}.cyan .profile-intro .icon{color:#00bcd4}.cyan .actions,.cyan .social-link li.active a,.cyan .social-link li a:focus,.cyan .social-link li a:hover{color:#69f0ae}.cyan .table-hover tbody tr:hover{background-color:rgba(0,188,212,.075)}.cyan .border-primary{border-color:#00bcd4!important}.cyan .app-logo-content{background-color:#00bcd4}.cyan .app-social-block .social-link button{border:1px solid #00bcd4;color:#00bcd4}.cyan .app-social-block .social-link button:focus,.cyan .app-social-block .social-link button:hover{color:#fff;background-color:#00bcd4}.cyan .btn-group-vertical>.btn-default.active,.cyan .btn-group-vertical>.jr-btn.active,.cyan .btn-group>.btn-default.active,.cyan .btn-group>.jr-btn.active{background-color:#00bcd4;border-color:#00bcd4}.cyan .btn-group-vertical>.jr-flat-btn,.cyan .btn-group>.jr-flat-btn{border-color:transparent}.cyan .btn-group-vertical>.jr-flat-btn.active,.cyan .btn-group>.jr-flat-btn.active{background-color:transparent;color:#00bcd4!important;border-color:transparent!important}.cyan .btn-group-vertical>.jr-flat-btn.active:focus,.cyan .btn-group-vertical>.jr-flat-btn.active:hover,.cyan .btn-group>.jr-flat-btn.active:focus,.cyan .btn-group>.jr-flat-btn.active:hover{background-color:rgba(0,188,212,.12)!important;color:#00bcd4!important}.cyan .nav-pill-sales .nav-link.active{background-color:#00bcd4;border-color:#00bcd4}.cyan .form-checkbox>input+.check,.cyan .form-checkbox>input.sm+.check{color:#00bcd4}.amber ul.nav-menu li.open>a{border-color:#ffc107}.amber .right-arrow,.amber .right-arrow:after{color:#ffc107}.amber .btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.amber .btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.amber .btn-primary.focus,.amber .btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.amber .btn-primary.disabled,.amber .btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.amber .btn-primary:not(:disabled):not(.disabled).active,.amber .btn-primary:not(:disabled):not(.disabled):active,.show>.amber .btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.amber .btn-primary:not(:disabled):not(.disabled).active:focus,.amber .btn-primary:not(:disabled):not(.disabled):active:focus,.show>.amber .btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.amber .btn-secondary{background-color:#e91e63;border-color:#e91e63;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.amber .btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.amber .btn-secondary.focus,.amber .btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.amber .btn-secondary.disabled,.amber .btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.amber .btn-secondary:not(:disabled):not(.disabled).active,.amber .btn-secondary:not(:disabled):not(.disabled):active,.show>.amber .btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.amber .btn-secondary:not(:disabled):not(.disabled).active:focus,.amber .btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.amber .btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.amber .btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.amber .btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.amber .btn-success.focus,.amber .btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.amber .btn-success.disabled,.amber .btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.amber .btn-success:not(:disabled):not(.disabled).active,.amber .btn-success:not(:disabled):not(.disabled):active,.show>.amber .btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.amber .btn-success:not(:disabled):not(.disabled).active:focus,.amber .btn-success:not(:disabled):not(.disabled):active:focus,.show>.amber .btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.amber .btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.amber .btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.amber .btn-info.focus,.amber .btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.amber .btn-info.disabled,.amber .btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.amber .btn-info:not(:disabled):not(.disabled).active,.amber .btn-info:not(:disabled):not(.disabled):active,.show>.amber .btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.amber .btn-info:not(:disabled):not(.disabled).active:focus,.amber .btn-info:not(:disabled):not(.disabled):active:focus,.show>.amber .btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.amber .btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.amber .btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.amber .btn-warning.focus,.amber .btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.amber .btn-warning.disabled,.amber .btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.amber .btn-warning:not(:disabled):not(.disabled).active,.amber .btn-warning:not(:disabled):not(.disabled):active,.show>.amber .btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.amber .btn-warning:not(:disabled):not(.disabled).active:focus,.amber .btn-warning:not(:disabled):not(.disabled):active:focus,.show>.amber .btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.amber .btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.amber .btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.amber .btn-danger.focus,.amber .btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.amber .btn-danger.disabled,.amber .btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.amber .btn-danger:not(:disabled):not(.disabled).active,.amber .btn-danger:not(:disabled):not(.disabled):active,.show>.amber .btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.amber .btn-danger:not(:disabled):not(.disabled).active:focus,.amber .btn-danger:not(:disabled):not(.disabled):active:focus,.show>.amber .btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.amber .btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.amber .btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.amber .btn-light.focus,.amber .btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.amber .btn-light.disabled,.amber .btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.amber .btn-light:not(:disabled):not(.disabled).active,.amber .btn-light:not(:disabled):not(.disabled):active,.show>.amber .btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.amber .btn-light:not(:disabled):not(.disabled).active:focus,.amber .btn-light:not(:disabled):not(.disabled):active:focus,.show>.amber .btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.amber .btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.amber .btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.amber .btn-dark.focus,.amber .btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.amber .btn-dark.disabled,.amber .btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.amber .btn-dark:not(:disabled):not(.disabled).active,.amber .btn-dark:not(:disabled):not(.disabled):active,.show>.amber .btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.amber .btn-dark:not(:disabled):not(.disabled).active:focus,.amber .btn-dark:not(:disabled):not(.disabled):active:focus,.show>.amber .btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.amber a.btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.amber a.btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.amber a.btn-primary.focus,.amber a.btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.amber a.btn-primary.disabled,.amber a.btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.amber a.btn-primary:not(:disabled):not(.disabled).active,.amber a.btn-primary:not(:disabled):not(.disabled):active,.show>.amber a.btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.amber a.btn-primary:not(:disabled):not(.disabled).active:focus,.amber a.btn-primary:not(:disabled):not(.disabled):active:focus,.show>.amber a.btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.amber a.btn-secondary{color:#fff;background-color:#e91e63;border-color:#e91e63;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.amber a.btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.amber a.btn-secondary.focus,.amber a.btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.amber a.btn-secondary.disabled,.amber a.btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.amber a.btn-secondary:not(:disabled):not(.disabled).active,.amber a.btn-secondary:not(:disabled):not(.disabled):active,.show>.amber a.btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.amber a.btn-secondary:not(:disabled):not(.disabled).active:focus,.amber a.btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.amber a.btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.amber a.btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.amber a.btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.amber a.btn-success.focus,.amber a.btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.amber a.btn-success.disabled,.amber a.btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.amber a.btn-success:not(:disabled):not(.disabled).active,.amber a.btn-success:not(:disabled):not(.disabled):active,.show>.amber a.btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.amber a.btn-success:not(:disabled):not(.disabled).active:focus,.amber a.btn-success:not(:disabled):not(.disabled):active:focus,.show>.amber a.btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.amber a.btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.amber a.btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.amber a.btn-info.focus,.amber a.btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.amber a.btn-info.disabled,.amber a.btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.amber a.btn-info:not(:disabled):not(.disabled).active,.amber a.btn-info:not(:disabled):not(.disabled):active,.show>.amber a.btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.amber a.btn-info:not(:disabled):not(.disabled).active:focus,.amber a.btn-info:not(:disabled):not(.disabled):active:focus,.show>.amber a.btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.amber a.btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.amber a.btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.amber a.btn-warning.focus,.amber a.btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.amber a.btn-warning.disabled,.amber a.btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.amber a.btn-warning:not(:disabled):not(.disabled).active,.amber a.btn-warning:not(:disabled):not(.disabled):active,.show>.amber a.btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.amber a.btn-warning:not(:disabled):not(.disabled).active:focus,.amber a.btn-warning:not(:disabled):not(.disabled):active:focus,.show>.amber a.btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.amber a.btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.amber a.btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.amber a.btn-danger.focus,.amber a.btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.amber a.btn-danger.disabled,.amber a.btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.amber a.btn-danger:not(:disabled):not(.disabled).active,.amber a.btn-danger:not(:disabled):not(.disabled):active,.show>.amber a.btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.amber a.btn-danger:not(:disabled):not(.disabled).active:focus,.amber a.btn-danger:not(:disabled):not(.disabled):active:focus,.show>.amber a.btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.amber a.btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.amber a.btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.amber a.btn-light.focus,.amber a.btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.amber a.btn-light.disabled,.amber a.btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.amber a.btn-light:not(:disabled):not(.disabled).active,.amber a.btn-light:not(:disabled):not(.disabled):active,.show>.amber a.btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.amber a.btn-light:not(:disabled):not(.disabled).active:focus,.amber a.btn-light:not(:disabled):not(.disabled):active:focus,.show>.amber a.btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.amber a.btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.amber a.btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.amber a.btn-dark.focus,.amber a.btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.amber a.btn-dark.disabled,.amber a.btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.amber a.btn-dark:not(:disabled):not(.disabled).active,.amber a.btn-dark:not(:disabled):not(.disabled):active,.show>.amber a.btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.amber a.btn-dark:not(:disabled):not(.disabled).active:focus,.amber a.btn-dark:not(:disabled):not(.disabled):active:focus,.show>.amber a.btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.amber .btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.amber .btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.amber .btn-outline-primary.focus,.amber .btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.amber .btn-outline-primary.disabled,.amber .btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.amber .btn-outline-primary:not(:disabled):not(.disabled).active,.amber .btn-outline-primary:not(:disabled):not(.disabled):active,.show>.amber .btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.amber .btn-outline-primary:not(:disabled):not(.disabled).active:focus,.amber .btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.amber .btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.amber .btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.amber .btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.amber .btn-outline-secondary.focus,.amber .btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.amber .btn-outline-secondary.disabled,.amber .btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.amber .btn-outline-secondary:not(:disabled):not(.disabled).active,.amber .btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.amber .btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.amber .btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.amber .btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.amber .btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.amber .btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.amber .btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.amber .btn-outline-success.focus,.amber .btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.amber .btn-outline-success.disabled,.amber .btn-outline-success:disabled{color:#4caf50;background-color:transparent}.amber .btn-outline-success:not(:disabled):not(.disabled).active,.amber .btn-outline-success:not(:disabled):not(.disabled):active,.show>.amber .btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.amber .btn-outline-success:not(:disabled):not(.disabled).active:focus,.amber .btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.amber .btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.amber .btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.amber .btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.amber .btn-outline-info.focus,.amber .btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.amber .btn-outline-info.disabled,.amber .btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.amber .btn-outline-info:not(:disabled):not(.disabled).active,.amber .btn-outline-info:not(:disabled):not(.disabled):active,.show>.amber .btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.amber .btn-outline-info:not(:disabled):not(.disabled).active:focus,.amber .btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.amber .btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.amber .btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.amber .btn-outline-warning:hover{color:#fff;background-color:#ff9800;border-color:#ff9800}.amber .btn-outline-warning.focus,.amber .btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.amber .btn-outline-warning.disabled,.amber .btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.amber .btn-outline-warning:not(:disabled):not(.disabled).active,.amber .btn-outline-warning:not(:disabled):not(.disabled):active,.show>.amber .btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.amber .btn-outline-warning:not(:disabled):not(.disabled).active:focus,.amber .btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.amber .btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.amber .btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.amber .btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.amber .btn-outline-danger.focus,.amber .btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.amber .btn-outline-danger.disabled,.amber .btn-outline-danger:disabled{color:#f44336;background-color:transparent}.amber .btn-outline-danger:not(:disabled):not(.disabled).active,.amber .btn-outline-danger:not(:disabled):not(.disabled):active,.show>.amber .btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.amber .btn-outline-danger:not(:disabled):not(.disabled).active:focus,.amber .btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.amber .btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.amber .btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.amber .btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.amber .btn-outline-light.focus,.amber .btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.amber .btn-outline-light.disabled,.amber .btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.amber .btn-outline-light:not(:disabled):not(.disabled).active,.amber .btn-outline-light:not(:disabled):not(.disabled):active,.show>.amber .btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.amber .btn-outline-light:not(:disabled):not(.disabled).active:focus,.amber .btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.amber .btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.amber .btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.amber .btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.amber .btn-outline-dark.focus,.amber .btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.amber .btn-outline-dark.disabled,.amber .btn-outline-dark:disabled{color:#343a40;background-color:transparent}.amber .btn-outline-dark:not(:disabled):not(.disabled).active,.amber .btn-outline-dark:not(:disabled):not(.disabled):active,.show>.amber .btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.amber .btn-outline-dark:not(:disabled):not(.disabled).active:focus,.amber .btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.amber .btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.amber a.btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.amber a.btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.amber a.btn-outline-primary.focus,.amber a.btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.amber a.btn-outline-primary.disabled,.amber a.btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.amber a.btn-outline-primary:not(:disabled):not(.disabled).active,.amber a.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.amber a.btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.amber a.btn-outline-primary:not(:disabled):not(.disabled).active:focus,.amber a.btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.amber a.btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.amber a.btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.amber a.btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.amber a.btn-outline-secondary.focus,.amber a.btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.amber a.btn-outline-secondary.disabled,.amber a.btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.amber a.btn-outline-secondary:not(:disabled):not(.disabled).active,.amber a.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.amber a.btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.amber a.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.amber a.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.amber a.btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.amber a.btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.amber a.btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.amber a.btn-outline-success.focus,.amber a.btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.amber a.btn-outline-success.disabled,.amber a.btn-outline-success:disabled{color:#4caf50;background-color:transparent}.amber a.btn-outline-success:not(:disabled):not(.disabled).active,.amber a.btn-outline-success:not(:disabled):not(.disabled):active,.show>.amber a.btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.amber a.btn-outline-success:not(:disabled):not(.disabled).active:focus,.amber a.btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.amber a.btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.amber a.btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.amber a.btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.amber a.btn-outline-info.focus,.amber a.btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.amber a.btn-outline-info.disabled,.amber a.btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.amber a.btn-outline-info:not(:disabled):not(.disabled).active,.amber a.btn-outline-info:not(:disabled):not(.disabled):active,.show>.amber a.btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.amber a.btn-outline-info:not(:disabled):not(.disabled).active:focus,.amber a.btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.amber a.btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.amber a.btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.amber a.btn-outline-warning:hover{color:#fff;background-color:#ff9800;border-color:#ff9800}.amber a.btn-outline-warning.focus,.amber a.btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.amber a.btn-outline-warning.disabled,.amber a.btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.amber a.btn-outline-warning:not(:disabled):not(.disabled).active,.amber a.btn-outline-warning:not(:disabled):not(.disabled):active,.show>.amber a.btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.amber a.btn-outline-warning:not(:disabled):not(.disabled).active:focus,.amber a.btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.amber a.btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.amber a.btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.amber a.btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.amber a.btn-outline-danger.focus,.amber a.btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.amber a.btn-outline-danger.disabled,.amber a.btn-outline-danger:disabled{color:#f44336;background-color:transparent}.amber a.btn-outline-danger:not(:disabled):not(.disabled).active,.amber a.btn-outline-danger:not(:disabled):not(.disabled):active,.show>.amber a.btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.amber a.btn-outline-danger:not(:disabled):not(.disabled).active:focus,.amber a.btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.amber a.btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.amber a.btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.amber a.btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.amber a.btn-outline-light.focus,.amber a.btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.amber a.btn-outline-light.disabled,.amber a.btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.amber a.btn-outline-light:not(:disabled):not(.disabled).active,.amber a.btn-outline-light:not(:disabled):not(.disabled):active,.show>.amber a.btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.amber a.btn-outline-light:not(:disabled):not(.disabled).active:focus,.amber a.btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.amber a.btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.amber a.btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.amber a.btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.amber a.btn-outline-dark.focus,.amber a.btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.amber a.btn-outline-dark.disabled,.amber a.btn-outline-dark:disabled{color:#343a40;background-color:transparent}.amber a.btn-outline-dark:not(:disabled):not(.disabled).active,.amber a.btn-outline-dark:not(:disabled):not(.disabled):active,.show>.amber a.btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.amber a.btn-outline-dark:not(:disabled):not(.disabled).active:focus,.amber a.btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.amber a.btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.amber .btn-outline-primary,.amber a.btn-outline-primary{color:#ffc107;border-color:#ffc107}.amber .btn-outline-primary.disabled,.amber .btn-outline-primary:disabled,.amber .btn-outline-primary:focus,.amber .btn-outline-primary:hover,.amber .btn-outline-primary:not(:disabled):not(.disabled).active,.amber .btn-outline-primary:not(:disabled):not(.disabled):active,.amber a.btn-outline-primary.disabled,.amber a.btn-outline-primary:disabled,.amber a.btn-outline-primary:focus,.amber a.btn-outline-primary:hover,.amber a.btn-outline-primary:not(:disabled):not(.disabled).active,.amber a.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.amber .btn-outline-primary.dropdown-toggle,.show>.amber a.btn-outline-primary.dropdown-toggle{color:#fff;border-color:#ffc107;background-color:#ffc107}.amber .btn-outline-secondary,.amber a.btn-outline-secondary{color:#ff3d00;border-color:#ff3d00}.amber .btn-outline-secondary.disabled,.amber .btn-outline-secondary:disabled,.amber .btn-outline-secondary:focus,.amber .btn-outline-secondary:hover,.amber .btn-outline-secondary:not(:disabled):not(.disabled).active,.amber .btn-outline-secondary:not(:disabled):not(.disabled):active,.amber a.btn-outline-secondary.disabled,.amber a.btn-outline-secondary:disabled,.amber a.btn-outline-secondary:focus,.amber a.btn-outline-secondary:hover,.amber a.btn-outline-secondary:not(:disabled):not(.disabled).active,.amber a.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.amber .btn-outline-secondary.dropdown-toggle,.show>.amber a.btn-outline-secondary.dropdown-toggle{color:#fff;border-color:#ff3d00;background-color:#ff3d00}.amber a,.amber a.text-primary{color:#ffc107}.amber a.text-primary:focus,.amber a.text-primary:hover,.amber a:focus,.amber a:hover{color:#d39e00}.amber .text-primary{color:#ffc107!important}.amber .page-link,.amber .page-link:focus,.amber .page-link:hover{color:#ffc107}.amber .badge-primary,.amber .bg-primary{background-color:#ffc107!important;color:#fff!important}.amber .btn-primary,.amber .jr-btn-primary,.amber a.btn-primary,.amber a.jr-btn-primary{background-color:#ffc107;border-color:#ffc107;color:#fff}.amber .btn-primary:focus,.amber .btn-primary:hover,.amber .btn-primary:not([disabled]):not(.disabled):active,.amber .jr-btn-primary:focus,.amber .jr-btn-primary:hover,.amber .jr-btn-primary:not([disabled]):not(.disabled):active,.amber a.btn-primary:focus,.amber a.btn-primary:hover,.amber a.btn-primary:not([disabled]):not(.disabled):active,.amber a.jr-btn-primary:focus,.amber a.jr-btn-primary:hover,.amber a.jr-btn-primary:not([disabled]):not(.disabled):active{background-color:#edb100!important;border-color:#edb100!important;color:#fff!important}.amber .bg-primary.lighten-4{background-color:#ffecb3!important}.amber .bg-primary.lighten-3{background-color:#ffe082!important}.amber .bg-primary.lighten-2{background-color:#ffd54f!important}.amber .bg-primary.lighten-1{background-color:#ffca28!important}.amber .bg-primary.darken-1{background-color:#ffb300!important}.amber .bg-primary.darken-2{background-color:#ffa000!important}.amber .bg-primary.darken-3{background-color:#ff8f00!important}.amber .bg-primary.darken-4{background-color:#ff6f00!important}.amber .bg-primary.accent-1{background-color:#ffe57f!important}.amber .bg-primary.accent-2{background-color:#ffd740!important}.amber .bg-primary.accent-3{background-color:#ffc400!important}.amber .bg-primary.accent-4{background-color:#ffab00!important}.amber a.text-secondary{color:#ff3d00}.amber a.text-secondary:focus,.amber a.text-secondary:hover{color:#cc3100!important}.amber .text-secondary{color:#ff3d00!important}.amber .badge-secondary,.amber .bg-secondary{background-color:#ff3d00!important;color:#fff!important}.amber .btn-secondary{background-color:#ff3d00;border-color:#ff3d00;color:#fff}.amber .btn-secondary:active,.amber .btn-secondary:focus,.amber .btn-secondary:hover{background-color:#e63700!important;border-color:#e63700!important;color:#fff!important}@media screen and (max-width:575px){.amber .app-main-header .search-dropdown input{background-color:#fff}}.amber .color-theme-header{background-color:#ffc107}.amber .side-nav{background-color:#fff!important;color:#868e96!important}.amber .side-nav .user-profile{background-color:#f8f9fa}.amber .side-nav .user-profile .text-white{color:#ffc107!important}.amber .side-nav .user-detail .user-name{color:#ffc107}.amber .side-nav .customizer{border-bottom:1px solid #e6e7e9}.amber ul.nav-menu .nav-header,.amber ul.nav-menu li a{color:#868e96}.amber ul.nav-menu>li.open>a,.amber ul.nav-menu>li>a:focus,.amber ul.nav-menu>li>a:hover{background-color:#fff;color:#ffc107}.amber ul.nav-menu li.menu>a:focus:before,.amber ul.nav-menu li.menu>a:hover:before{color:#ffc107}.amber ul.nav-menu li ul{background-color:#fff}.amber ul.nav-menu li.menu>a:before{color:#868e96}.amber ul.nav-menu li.menu.open>a:before,.amber ul.nav-menu li.menu>a:focus:before,.amber ul.nav-menu li.menu li>a:hover:before{color:#ffc107}.amber ul.nav-menu li.menu .sub-menu li>a:before{color:#868e96}.amber ul.nav-menu li.menu .sub-menu li>a.active .nav-text{background-color:#ffc107}.amber ul.nav-menu li.menu.open .sub-menu li>a.active:before,.amber ul.nav-menu li.menu .sub-menu li>a:focus,.amber ul.nav-menu li.menu .sub-menu li>a:focus:before,.amber ul.nav-menu li.menu .sub-menu li>a:hover,.amber ul.nav-menu li.menu .sub-menu li>a:hover:before{background-color:#fff;color:#ffc107}.amber .navbar-nav li:focus>a,.amber .navbar-nav li:hover>a{color:#ffc107}.amber .navbar-nav li a{color:#868e96}.amber .navbar-nav li.nav-item.active>a,.amber .navbar-nav li a:focus,.amber .navbar-nav li a:hover,.amber .navbar-nav ul.sub-menu li.active>a,.amber .navbar-nav ul.sub-menu li a.active{color:#ffc107}.amber .navbar-nav .nav-arrow>a:before{color:#868e96}.amber .navbar-nav .nav-arrow.active>a:before,.amber .navbar-nav .nav-arrow:focus>a:before,.amber .navbar-nav .nav-arrow:hover>a:before,.amber .navbar-nav .nav-arrow a:focus:before,.amber .navbar-nav .nav-arrow a:hover:before{color:#ffc107}.amber .app-top-nav{background-color:#ffc107}.amber .app-top-nav .navbar-nav li.nav-item>a{color:#fff}.amber .app-top-nav .navbar-nav li.nav-item.active>a,.amber .app-top-nav .navbar-nav li.nav-item:focus>a,.amber .app-top-nav .navbar-nav li.nav-item:hover>a,.amber .app-top-nav .navbar-nav li.nav-item>a:focus,.amber .app-top-nav .navbar-nav li.nav-item>a:hover{color:#ff3d00}.amber .module-nav li a.active{border-color:#ffc107}.amber .rbc-event{background-color:#ffc107}.amber .rbc-event.rbc-selected{background-color:#d39e00}.amber .rbc-slot-selection{background-color:rgba(255,193,7,.7)}.amber .rbc-toolbar button.rbc-active,.amber .rbc-toolbar button.rbc-active:focus,.amber .rbc-toolbar button.rbc-active:hover,.amber .rbc-toolbar button:active,.amber .rbc-toolbar button:active:focus,.amber .rbc-toolbar button:active:hover,.amber .rbc-toolbar button:focus,.amber .rbc-toolbar button:hover{background-color:rgba(255,193,7,.9);border-color:#ffc107}.amber .rbc-day-slot .rbc-event{border-color:#ffc107}.amber .chat-sidenav-title{color:#ffc107}.amber .chat-user-item.active,.amber .chat-user-item:hover{background-color:#fffaed}.amber .contact-list i{color:#ffc107}.amber .Collapsible__trigger{background:#ffc107}.amber .categories-list li.active a,.amber .categories-list li a:focus,.amber .categories-list li a:hover{color:#ffc107}.amber .filter-with-bg-color ul li a,.amber .login-content .form-control:focus{border-color:#ffc107}.amber .filter-with-bg-color ul li a.active,.amber .filter-with-bg-color ul li a:focus,.amber .filter-with-bg-color ul li a:hover{background-color:#ffc107}.amber .profile-intro .icon{color:#ffc107}.amber .actions,.amber .social-link li.active a,.amber .social-link li a:focus,.amber .social-link li a:hover{color:#ff3d00}.amber .table-hover tbody tr:hover{background-color:rgba(255,193,7,.075)}.amber .border-primary{border-color:#ffc107!important}.amber .app-logo-content{background-color:#ffc107}.amber .app-social-block .social-link button{border:1px solid #ffc107;color:#ffc107}.amber .app-social-block .social-link button:focus,.amber .app-social-block .social-link button:hover{color:#fff;background-color:#ffc107}.amber .btn-group-vertical>.btn-default.active,.amber .btn-group-vertical>.jr-btn.active,.amber .btn-group>.btn-default.active,.amber .btn-group>.jr-btn.active{background-color:#ffc107;border-color:#ffc107}.amber .btn-group-vertical>.jr-flat-btn,.amber .btn-group>.jr-flat-btn{border-color:transparent}.amber .btn-group-vertical>.jr-flat-btn.active,.amber .btn-group>.jr-flat-btn.active{background-color:transparent;color:#ffc107!important;border-color:transparent!important}.amber .btn-group-vertical>.jr-flat-btn.active:focus,.amber .btn-group-vertical>.jr-flat-btn.active:hover,.amber .btn-group>.jr-flat-btn.active:focus,.amber .btn-group>.jr-flat-btn.active:hover{background-color:rgba(255,193,7,.12)!important;color:#ffc107!important}.amber .nav-pill-sales .nav-link.active{background-color:#ffc107;border-color:#ffc107}.amber .form-checkbox>input+.check,.amber .form-checkbox>input.sm+.check{color:#ffc107}.deep-orange .right-arrow,.deep-orange .right-arrow:after{color:#ff5722}.deep-orange .btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.deep-orange .btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.deep-orange .btn-primary.focus,.deep-orange .btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.deep-orange .btn-primary.disabled,.deep-orange .btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.deep-orange .btn-primary:not(:disabled):not(.disabled).active,.deep-orange .btn-primary:not(:disabled):not(.disabled):active,.show>.deep-orange .btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.deep-orange .btn-primary:not(:disabled):not(.disabled).active:focus,.deep-orange .btn-primary:not(:disabled):not(.disabled):active:focus,.show>.deep-orange .btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.deep-orange .btn-secondary{background-color:#e91e63;border-color:#e91e63;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.deep-orange .btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.deep-orange .btn-secondary.focus,.deep-orange .btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.deep-orange .btn-secondary.disabled,.deep-orange .btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.deep-orange .btn-secondary:not(:disabled):not(.disabled).active,.deep-orange .btn-secondary:not(:disabled):not(.disabled):active,.show>.deep-orange .btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.deep-orange .btn-secondary:not(:disabled):not(.disabled).active:focus,.deep-orange .btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.deep-orange .btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.deep-orange .btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.deep-orange .btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.deep-orange .btn-success.focus,.deep-orange .btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.deep-orange .btn-success.disabled,.deep-orange .btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.deep-orange .btn-success:not(:disabled):not(.disabled).active,.deep-orange .btn-success:not(:disabled):not(.disabled):active,.show>.deep-orange .btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.deep-orange .btn-success:not(:disabled):not(.disabled).active:focus,.deep-orange .btn-success:not(:disabled):not(.disabled):active:focus,.show>.deep-orange .btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.deep-orange .btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.deep-orange .btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.deep-orange .btn-info.focus,.deep-orange .btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.deep-orange .btn-info.disabled,.deep-orange .btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.deep-orange .btn-info:not(:disabled):not(.disabled).active,.deep-orange .btn-info:not(:disabled):not(.disabled):active,.show>.deep-orange .btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.deep-orange .btn-info:not(:disabled):not(.disabled).active:focus,.deep-orange .btn-info:not(:disabled):not(.disabled):active:focus,.show>.deep-orange .btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.deep-orange .btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.deep-orange .btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.deep-orange .btn-warning.focus,.deep-orange .btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.deep-orange .btn-warning.disabled,.deep-orange .btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.deep-orange .btn-warning:not(:disabled):not(.disabled).active,.deep-orange .btn-warning:not(:disabled):not(.disabled):active,.show>.deep-orange .btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.deep-orange .btn-warning:not(:disabled):not(.disabled).active:focus,.deep-orange .btn-warning:not(:disabled):not(.disabled):active:focus,.show>.deep-orange .btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.deep-orange .btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.deep-orange .btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.deep-orange .btn-danger.focus,.deep-orange .btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.deep-orange .btn-danger.disabled,.deep-orange .btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.deep-orange .btn-danger:not(:disabled):not(.disabled).active,.deep-orange .btn-danger:not(:disabled):not(.disabled):active,.show>.deep-orange .btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.deep-orange .btn-danger:not(:disabled):not(.disabled).active:focus,.deep-orange .btn-danger:not(:disabled):not(.disabled):active:focus,.show>.deep-orange .btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.deep-orange .btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.deep-orange .btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.deep-orange .btn-light.focus,.deep-orange .btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.deep-orange .btn-light.disabled,.deep-orange .btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.deep-orange .btn-light:not(:disabled):not(.disabled).active,.deep-orange .btn-light:not(:disabled):not(.disabled):active,.show>.deep-orange .btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.deep-orange .btn-light:not(:disabled):not(.disabled).active:focus,.deep-orange .btn-light:not(:disabled):not(.disabled):active:focus,.show>.deep-orange .btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.deep-orange .btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.deep-orange .btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.deep-orange .btn-dark.focus,.deep-orange .btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.deep-orange .btn-dark.disabled,.deep-orange .btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.deep-orange .btn-dark:not(:disabled):not(.disabled).active,.deep-orange .btn-dark:not(:disabled):not(.disabled):active,.show>.deep-orange .btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.deep-orange .btn-dark:not(:disabled):not(.disabled).active:focus,.deep-orange .btn-dark:not(:disabled):not(.disabled):active:focus,.show>.deep-orange .btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.deep-orange a.btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.deep-orange a.btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.deep-orange a.btn-primary.focus,.deep-orange a.btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.deep-orange a.btn-primary.disabled,.deep-orange a.btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.deep-orange a.btn-primary:not(:disabled):not(.disabled).active,.deep-orange a.btn-primary:not(:disabled):not(.disabled):active,.show>.deep-orange a.btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.deep-orange a.btn-primary:not(:disabled):not(.disabled).active:focus,.deep-orange a.btn-primary:not(:disabled):not(.disabled):active:focus,.show>.deep-orange a.btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.deep-orange a.btn-secondary{color:#fff;background-color:#e91e63;border-color:#e91e63;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.deep-orange a.btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.deep-orange a.btn-secondary.focus,.deep-orange a.btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.deep-orange a.btn-secondary.disabled,.deep-orange a.btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.deep-orange a.btn-secondary:not(:disabled):not(.disabled).active,.deep-orange a.btn-secondary:not(:disabled):not(.disabled):active,.show>.deep-orange a.btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.deep-orange a.btn-secondary:not(:disabled):not(.disabled).active:focus,.deep-orange a.btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.deep-orange a.btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.deep-orange a.btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.deep-orange a.btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.deep-orange a.btn-success.focus,.deep-orange a.btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.deep-orange a.btn-success.disabled,.deep-orange a.btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.deep-orange a.btn-success:not(:disabled):not(.disabled).active,.deep-orange a.btn-success:not(:disabled):not(.disabled):active,.show>.deep-orange a.btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.deep-orange a.btn-success:not(:disabled):not(.disabled).active:focus,.deep-orange a.btn-success:not(:disabled):not(.disabled):active:focus,.show>.deep-orange a.btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.deep-orange a.btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.deep-orange a.btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.deep-orange a.btn-info.focus,.deep-orange a.btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.deep-orange a.btn-info.disabled,.deep-orange a.btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.deep-orange a.btn-info:not(:disabled):not(.disabled).active,.deep-orange a.btn-info:not(:disabled):not(.disabled):active,.show>.deep-orange a.btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.deep-orange a.btn-info:not(:disabled):not(.disabled).active:focus,.deep-orange a.btn-info:not(:disabled):not(.disabled):active:focus,.show>.deep-orange a.btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.deep-orange a.btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.deep-orange a.btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.deep-orange a.btn-warning.focus,.deep-orange a.btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.deep-orange a.btn-warning.disabled,.deep-orange a.btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.deep-orange a.btn-warning:not(:disabled):not(.disabled).active,.deep-orange a.btn-warning:not(:disabled):not(.disabled):active,.show>.deep-orange a.btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.deep-orange a.btn-warning:not(:disabled):not(.disabled).active:focus,.deep-orange a.btn-warning:not(:disabled):not(.disabled):active:focus,.show>.deep-orange a.btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.deep-orange a.btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.deep-orange a.btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.deep-orange a.btn-danger.focus,.deep-orange a.btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.deep-orange a.btn-danger.disabled,.deep-orange a.btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.deep-orange a.btn-danger:not(:disabled):not(.disabled).active,.deep-orange a.btn-danger:not(:disabled):not(.disabled):active,.show>.deep-orange a.btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.deep-orange a.btn-danger:not(:disabled):not(.disabled).active:focus,.deep-orange a.btn-danger:not(:disabled):not(.disabled):active:focus,.show>.deep-orange a.btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.deep-orange a.btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.deep-orange a.btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.deep-orange a.btn-light.focus,.deep-orange a.btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.deep-orange a.btn-light.disabled,.deep-orange a.btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.deep-orange a.btn-light:not(:disabled):not(.disabled).active,.deep-orange a.btn-light:not(:disabled):not(.disabled):active,.show>.deep-orange a.btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.deep-orange a.btn-light:not(:disabled):not(.disabled).active:focus,.deep-orange a.btn-light:not(:disabled):not(.disabled):active:focus,.show>.deep-orange a.btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.deep-orange a.btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.deep-orange a.btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.deep-orange a.btn-dark.focus,.deep-orange a.btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.deep-orange a.btn-dark.disabled,.deep-orange a.btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.deep-orange a.btn-dark:not(:disabled):not(.disabled).active,.deep-orange a.btn-dark:not(:disabled):not(.disabled):active,.show>.deep-orange a.btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.deep-orange a.btn-dark:not(:disabled):not(.disabled).active:focus,.deep-orange a.btn-dark:not(:disabled):not(.disabled):active:focus,.show>.deep-orange a.btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.deep-orange .btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.deep-orange .btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.deep-orange .btn-outline-primary.focus,.deep-orange .btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.deep-orange .btn-outline-primary.disabled,.deep-orange .btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.deep-orange .btn-outline-primary:not(:disabled):not(.disabled).active,.deep-orange .btn-outline-primary:not(:disabled):not(.disabled):active,.show>.deep-orange .btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.deep-orange .btn-outline-primary:not(:disabled):not(.disabled).active:focus,.deep-orange .btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.deep-orange .btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.deep-orange .btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.deep-orange .btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.deep-orange .btn-outline-secondary.focus,.deep-orange .btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.deep-orange .btn-outline-secondary.disabled,.deep-orange .btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.deep-orange .btn-outline-secondary:not(:disabled):not(.disabled).active,.deep-orange .btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.deep-orange .btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.deep-orange .btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.deep-orange .btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.deep-orange .btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.deep-orange .btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.deep-orange .btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.deep-orange .btn-outline-success.focus,.deep-orange .btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.deep-orange .btn-outline-success.disabled,.deep-orange .btn-outline-success:disabled{color:#4caf50;background-color:transparent}.deep-orange .btn-outline-success:not(:disabled):not(.disabled).active,.deep-orange .btn-outline-success:not(:disabled):not(.disabled):active,.show>.deep-orange .btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.deep-orange .btn-outline-success:not(:disabled):not(.disabled).active:focus,.deep-orange .btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.deep-orange .btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.deep-orange .btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.deep-orange .btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.deep-orange .btn-outline-info.focus,.deep-orange .btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.deep-orange .btn-outline-info.disabled,.deep-orange .btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.deep-orange .btn-outline-info:not(:disabled):not(.disabled).active,.deep-orange .btn-outline-info:not(:disabled):not(.disabled):active,.show>.deep-orange .btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.deep-orange .btn-outline-info:not(:disabled):not(.disabled).active:focus,.deep-orange .btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.deep-orange .btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.deep-orange .btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.deep-orange .btn-outline-warning:hover{color:#fff;background-color:#ff9800;border-color:#ff9800}.deep-orange .btn-outline-warning.focus,.deep-orange .btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.deep-orange .btn-outline-warning.disabled,.deep-orange .btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.deep-orange .btn-outline-warning:not(:disabled):not(.disabled).active,.deep-orange .btn-outline-warning:not(:disabled):not(.disabled):active,.show>.deep-orange .btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.deep-orange .btn-outline-warning:not(:disabled):not(.disabled).active:focus,.deep-orange .btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.deep-orange .btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.deep-orange .btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.deep-orange .btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.deep-orange .btn-outline-danger.focus,.deep-orange .btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.deep-orange .btn-outline-danger.disabled,.deep-orange .btn-outline-danger:disabled{color:#f44336;background-color:transparent}.deep-orange .btn-outline-danger:not(:disabled):not(.disabled).active,.deep-orange .btn-outline-danger:not(:disabled):not(.disabled):active,.show>.deep-orange .btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.deep-orange .btn-outline-danger:not(:disabled):not(.disabled).active:focus,.deep-orange .btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.deep-orange .btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.deep-orange .btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.deep-orange .btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.deep-orange .btn-outline-light.focus,.deep-orange .btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.deep-orange .btn-outline-light.disabled,.deep-orange .btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.deep-orange .btn-outline-light:not(:disabled):not(.disabled).active,.deep-orange .btn-outline-light:not(:disabled):not(.disabled):active,.show>.deep-orange .btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.deep-orange .btn-outline-light:not(:disabled):not(.disabled).active:focus,.deep-orange .btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.deep-orange .btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.deep-orange .btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.deep-orange .btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.deep-orange .btn-outline-dark.focus,.deep-orange .btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.deep-orange .btn-outline-dark.disabled,.deep-orange .btn-outline-dark:disabled{color:#343a40;background-color:transparent}.deep-orange .btn-outline-dark:not(:disabled):not(.disabled).active,.deep-orange .btn-outline-dark:not(:disabled):not(.disabled):active,.show>.deep-orange .btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.deep-orange .btn-outline-dark:not(:disabled):not(.disabled).active:focus,.deep-orange .btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.deep-orange .btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.deep-orange a.btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.deep-orange a.btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.deep-orange a.btn-outline-primary.focus,.deep-orange a.btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.deep-orange a.btn-outline-primary.disabled,.deep-orange a.btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.deep-orange a.btn-outline-primary:not(:disabled):not(.disabled).active,.deep-orange a.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.deep-orange a.btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.deep-orange a.btn-outline-primary:not(:disabled):not(.disabled).active:focus,.deep-orange a.btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.deep-orange a.btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.deep-orange a.btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.deep-orange a.btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.deep-orange a.btn-outline-secondary.focus,.deep-orange a.btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.deep-orange a.btn-outline-secondary.disabled,.deep-orange a.btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.deep-orange a.btn-outline-secondary:not(:disabled):not(.disabled).active,.deep-orange a.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.deep-orange a.btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.deep-orange a.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.deep-orange a.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.deep-orange a.btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.deep-orange a.btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.deep-orange a.btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.deep-orange a.btn-outline-success.focus,.deep-orange a.btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.deep-orange a.btn-outline-success.disabled,.deep-orange a.btn-outline-success:disabled{color:#4caf50;background-color:transparent}.deep-orange a.btn-outline-success:not(:disabled):not(.disabled).active,.deep-orange a.btn-outline-success:not(:disabled):not(.disabled):active,.show>.deep-orange a.btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.deep-orange a.btn-outline-success:not(:disabled):not(.disabled).active:focus,.deep-orange a.btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.deep-orange a.btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.deep-orange a.btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.deep-orange a.btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.deep-orange a.btn-outline-info.focus,.deep-orange a.btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.deep-orange a.btn-outline-info.disabled,.deep-orange a.btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.deep-orange a.btn-outline-info:not(:disabled):not(.disabled).active,.deep-orange a.btn-outline-info:not(:disabled):not(.disabled):active,.show>.deep-orange a.btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.deep-orange a.btn-outline-info:not(:disabled):not(.disabled).active:focus,.deep-orange a.btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.deep-orange a.btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.deep-orange a.btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.deep-orange a.btn-outline-warning:hover{color:#fff;background-color:#ff9800;border-color:#ff9800}.deep-orange a.btn-outline-warning.focus,.deep-orange a.btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.deep-orange a.btn-outline-warning.disabled,.deep-orange a.btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.deep-orange a.btn-outline-warning:not(:disabled):not(.disabled).active,.deep-orange a.btn-outline-warning:not(:disabled):not(.disabled):active,.show>.deep-orange a.btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.deep-orange a.btn-outline-warning:not(:disabled):not(.disabled).active:focus,.deep-orange a.btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.deep-orange a.btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.deep-orange a.btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.deep-orange a.btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.deep-orange a.btn-outline-danger.focus,.deep-orange a.btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.deep-orange a.btn-outline-danger.disabled,.deep-orange a.btn-outline-danger:disabled{color:#f44336;background-color:transparent}.deep-orange a.btn-outline-danger:not(:disabled):not(.disabled).active,.deep-orange a.btn-outline-danger:not(:disabled):not(.disabled):active,.show>.deep-orange a.btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.deep-orange a.btn-outline-danger:not(:disabled):not(.disabled).active:focus,.deep-orange a.btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.deep-orange a.btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.deep-orange a.btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.deep-orange a.btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.deep-orange a.btn-outline-light.focus,.deep-orange a.btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.deep-orange a.btn-outline-light.disabled,.deep-orange a.btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.deep-orange a.btn-outline-light:not(:disabled):not(.disabled).active,.deep-orange a.btn-outline-light:not(:disabled):not(.disabled):active,.show>.deep-orange a.btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.deep-orange a.btn-outline-light:not(:disabled):not(.disabled).active:focus,.deep-orange a.btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.deep-orange a.btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.deep-orange a.btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.deep-orange a.btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.deep-orange a.btn-outline-dark.focus,.deep-orange a.btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.deep-orange a.btn-outline-dark.disabled,.deep-orange a.btn-outline-dark:disabled{color:#343a40;background-color:transparent}.deep-orange a.btn-outline-dark:not(:disabled):not(.disabled).active,.deep-orange a.btn-outline-dark:not(:disabled):not(.disabled):active,.show>.deep-orange a.btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.deep-orange a.btn-outline-dark:not(:disabled):not(.disabled).active:focus,.deep-orange a.btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.deep-orange a.btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.deep-orange .btn-outline-primary,.deep-orange a.btn-outline-primary{color:#ff5722;border-color:#ff5722}.deep-orange .btn-outline-primary.disabled,.deep-orange .btn-outline-primary:disabled,.deep-orange .btn-outline-primary:focus,.deep-orange .btn-outline-primary:hover,.deep-orange .btn-outline-primary:not(:disabled):not(.disabled).active,.deep-orange .btn-outline-primary:not(:disabled):not(.disabled):active,.deep-orange a.btn-outline-primary.disabled,.deep-orange a.btn-outline-primary:disabled,.deep-orange a.btn-outline-primary:focus,.deep-orange a.btn-outline-primary:hover,.deep-orange a.btn-outline-primary:not(:disabled):not(.disabled).active,.deep-orange a.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.deep-orange .btn-outline-primary.dropdown-toggle,.show>.deep-orange a.btn-outline-primary.dropdown-toggle{color:#fff;border-color:#ff5722;background-color:#ff5722}.deep-orange .btn-outline-secondary,.deep-orange a.btn-outline-secondary{color:#40c4ff;border-color:#40c4ff}.deep-orange .btn-outline-secondary.disabled,.deep-orange .btn-outline-secondary:disabled,.deep-orange .btn-outline-secondary:focus,.deep-orange .btn-outline-secondary:hover,.deep-orange .btn-outline-secondary:not(:disabled):not(.disabled).active,.deep-orange .btn-outline-secondary:not(:disabled):not(.disabled):active,.deep-orange a.btn-outline-secondary.disabled,.deep-orange a.btn-outline-secondary:disabled,.deep-orange a.btn-outline-secondary:focus,.deep-orange a.btn-outline-secondary:hover,.deep-orange a.btn-outline-secondary:not(:disabled):not(.disabled).active,.deep-orange a.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.deep-orange .btn-outline-secondary.dropdown-toggle,.show>.deep-orange a.btn-outline-secondary.dropdown-toggle{color:#fff;border-color:#40c4ff;background-color:#40c4ff}.deep-orange a,.deep-orange a.text-primary{color:#ff5722}.deep-orange a.text-primary:focus,.deep-orange a.text-primary:hover,.deep-orange a:focus,.deep-orange a:hover{color:#ee3900}.deep-orange .text-primary{color:#ff5722!important}.deep-orange .page-link,.deep-orange .page-link:focus,.deep-orange .page-link:hover{color:#ff5722}.deep-orange .badge-primary,.deep-orange .bg-primary{background-color:#ff5722!important;color:#fff!important}.deep-orange .btn-primary,.deep-orange .jr-btn-primary,.deep-orange a.btn-primary,.deep-orange a.jr-btn-primary{background-color:#ff5722;border-color:#ff5722;color:#fff}.deep-orange .btn-primary:focus,.deep-orange .btn-primary:hover,.deep-orange .btn-primary:not([disabled]):not(.disabled):active,.deep-orange .jr-btn-primary:focus,.deep-orange .jr-btn-primary:hover,.deep-orange .jr-btn-primary:not([disabled]):not(.disabled):active,.deep-orange a.btn-primary:focus,.deep-orange a.btn-primary:hover,.deep-orange a.btn-primary:not([disabled]):not(.disabled):active,.deep-orange a.jr-btn-primary:focus,.deep-orange a.jr-btn-primary:hover,.deep-orange a.jr-btn-primary:not([disabled]):not(.disabled):active{background-color:#ff4409!important;border-color:#ff4409!important;color:#fff!important}.deep-orange .bg-primary.lighten-4{background-color:#ffccbc!important}.deep-orange .bg-primary.lighten-3{background-color:#ffab91!important}.deep-orange .bg-primary.lighten-2{background-color:#ff8a65!important}.deep-orange .bg-primary.lighten-1{background-color:#ff7043!important}.deep-orange .bg-primary.darken-1{background-color:#f4511e!important}.deep-orange .bg-primary.darken-2{background-color:#e64a19!important}.deep-orange .bg-primary.darken-3{background-color:#d84315!important}.deep-orange .bg-primary.darken-4{background-color:#bf360c!important}.deep-orange .bg-primary.accent-1{background-color:#ff9e80!important}.deep-orange .bg-primary.accent-2{background-color:#ff6e40!important}.deep-orange .bg-primary.accent-3{background-color:#ff3d00!important}.deep-orange .bg-primary.accent-4{background-color:#dd2c00!important}.deep-orange a.text-secondary{color:#40c4ff}.deep-orange a.text-secondary:focus,.deep-orange a.text-secondary:hover{color:#0db4ff!important}.deep-orange .text-secondary{color:#40c4ff!important}.deep-orange .badge-secondary,.deep-orange .bg-secondary{background-color:#40c4ff!important;color:#fff!important}.deep-orange .btn-secondary{background-color:#40c4ff;border-color:#40c4ff;color:#fff}.deep-orange .btn-secondary:active,.deep-orange .btn-secondary:focus,.deep-orange .btn-secondary:hover{background-color:#27bcff!important;border-color:#27bcff!important;color:#fff!important}.deep-orange .jr-flat-btn{background-color:transparent!important;color:#5c5c5c!important}.deep-orange .jr-flat-btn:active,.deep-orange .jr-flat-btn:focus,.deep-orange .jr-flat-btn:hover{background-color:#f5f5f5!important;color:#5c5c5c!important}.deep-orange .jr-flat-btn.jr-btn-primary{background-color:transparent!important;color:#ff5722!important;border-color:transparent!important}.deep-orange .jr-flat-btn.jr-btn-primary:focus,.deep-orange .jr-flat-btn.jr-btn-primary:hover{background-color:rgba(255,87,34,.12)!important;color:#ff5722!important}.deep-orange .bg-primary .jr-flat-btn.jr-btn-primary{background-color:transparent!important;color:#fff!important;border-color:transparent!important}.deep-orange .bg-primary .jr-flat-btn.jr-btn-primary:focus,.deep-orange .bg-primary .jr-flat-btn.jr-btn-primary:hover{background-color:hsla(0,0%,100%,.12)!important;color:#fff!important}.deep-orange .jr-flat-btn.jr-btn-secondary{background-color:transparent!important;color:#40c4ff!important;border-color:transparent!important}.deep-orange .jr-flat-btn.jr-btn-secondary:focus,.deep-orange .jr-flat-btn.jr-btn-secondary:hover{background-color:rgba(64,196,255,.12)!important;color:#40c4ff!important}.deep-orange .bg-secondary .jr-flat-btn.jr-btn-secondary{background-color:transparent!important;color:#fff!important;border-color:transparent!important}.deep-orange .bg-secondary .jr-flat-btn.jr-btn-secondary:focus,.deep-orange .bg-secondary .jr-flat-btn.jr-btn-secondary:hover{background-color:hsla(0,0%,100%,.12)!important;color:#fff!important}@media screen and (max-width:575px){.deep-orange .app-main-header .search-dropdown input{background-color:#fff}}.deep-orange .color-theme-header{background-color:#ff5722}.deep-orange .side-nav{background-color:#fff!important;color:#868e96!important}.deep-orange .side-nav .user-profile{background-color:#f8f9fa;position:relative;z-index:2}.deep-orange .side-nav .user-profile .text-white{color:#ff5722!important}.deep-orange .side-nav .customizer{border-bottom:1px solid #e6e7e9}.deep-orange .side-nav .user-detail .user-name{color:#ff5722}.deep-orange ul.nav-menu .nav-header,.deep-orange ul.nav-menu li a{color:#868e96}.deep-orange ul.nav-menu>li.open>a,.deep-orange ul.nav-menu>li>a:focus,.deep-orange ul.nav-menu>li>a:hover{background-color:#fff;color:#ff5722}.deep-orange ul.nav-menu li.menu>a:focus:before,.deep-orange ul.nav-menu li.menu>a:hover:before{color:#ff5722}.deep-orange ul.nav-menu li ul{background-color:#fff}.deep-orange ul.nav-menu li.menu>a:before{color:#868e96}.deep-orange ul.nav-menu li.menu.open>a:before,.deep-orange ul.nav-menu li.menu>a:focus:before,.deep-orange ul.nav-menu li.menu li>a:hover:before{color:#ff5722}.deep-orange ul.nav-menu li.menu .sub-menu li>a:before{color:#868e96}.deep-orange ul.nav-menu li.menu .sub-menu li>a.active .nav-text{background-color:#ff5722}.deep-orange ul.nav-menu li.menu.open .sub-menu li>a.active:before,.deep-orange ul.nav-menu li.menu .sub-menu li>a:focus,.deep-orange ul.nav-menu li.menu .sub-menu li>a:focus:before,.deep-orange ul.nav-menu li.menu .sub-menu li>a:hover,.deep-orange ul.nav-menu li.menu .sub-menu li>a:hover:before{background-color:#fff;color:#ff5722}.deep-orange .navbar-nav li:focus>a,.deep-orange .navbar-nav li:hover>a{color:#ff5722}.deep-orange .navbar-nav li a{color:#868e96}.deep-orange .navbar-nav li.nav-item.active>a,.deep-orange .navbar-nav li a:focus,.deep-orange .navbar-nav li a:hover,.deep-orange .navbar-nav ul.sub-menu li.active>a,.deep-orange .navbar-nav ul.sub-menu li a.active{color:#ff5722}.deep-orange .navbar-nav .nav-arrow>a:before{color:#868e96}.deep-orange .navbar-nav .nav-arrow.active>a:before,.deep-orange .navbar-nav .nav-arrow:focus>a:before,.deep-orange .navbar-nav .nav-arrow:hover>a:before,.deep-orange .navbar-nav .nav-arrow a:focus:before,.deep-orange .navbar-nav .nav-arrow a:hover:before{color:#ff5722}.deep-orange .app-top-nav{background-color:#ff5722}.deep-orange .app-top-nav .navbar-nav li.nav-item>a{color:#fff}.deep-orange .app-top-nav .navbar-nav li.nav-item.active>a,.deep-orange .app-top-nav .navbar-nav li.nav-item:focus>a,.deep-orange .app-top-nav .navbar-nav li.nav-item:hover>a,.deep-orange .app-top-nav .navbar-nav li.nav-item>a:focus,.deep-orange .app-top-nav .navbar-nav li.nav-item>a:hover{color:#40c4ff}.deep-orange .module-nav li a.active{border-color:#ff5722}.deep-orange .rbc-event{background-color:#ff5722}.deep-orange .rbc-event.rbc-selected{background-color:#ee3900}.deep-orange .rbc-slot-selection{background-color:rgba(255,87,34,.7)}.deep-orange .rbc-toolbar button.rbc-active,.deep-orange .rbc-toolbar button.rbc-active:focus,.deep-orange .rbc-toolbar button.rbc-active:hover,.deep-orange .rbc-toolbar button:active,.deep-orange .rbc-toolbar button:active:focus,.deep-orange .rbc-toolbar button:active:hover,.deep-orange .rbc-toolbar button:focus,.deep-orange .rbc-toolbar button:hover{background-color:rgba(255,87,34,.9);border-color:#ff5722}.deep-orange .rbc-day-slot .rbc-event{border-color:#ff5722}.deep-orange .chat-sidenav-title{color:#ff5722}.deep-orange .chat-user-item.active,.deep-orange .chat-user-item:hover{background-color:#fff2ee}.deep-orange .contact-list i{color:#ff5722}.deep-orange .Collapsible__trigger{background:#ff5722}.deep-orange .categories-list li.active a,.deep-orange .categories-list li a:focus,.deep-orange .categories-list li a:hover{color:#ff5722}.deep-orange .filter-with-bg-color ul li a,.deep-orange .login-content .form-control:focus{border-color:#ff5722}.deep-orange .filter-with-bg-color ul li a.active,.deep-orange .filter-with-bg-color ul li a:focus,.deep-orange .filter-with-bg-color ul li a:hover{background-color:#ff5722}.deep-orange .profile-intro .icon{color:#ff5722}.deep-orange .actions,.deep-orange .social-link li.active a,.deep-orange .social-link li a:focus,.deep-orange .social-link li a:hover{color:#40c4ff}.deep-orange .table-hover tbody tr:hover{background-color:rgba(255,87,34,.075)}.deep-orange .border-primary{border-color:#ff5722!important}.deep-orange .app-logo-content{background-color:#ff5722}.deep-orange .app-social-block .social-link button{border:1px solid #ff5722;color:#ff5722}.deep-orange .app-social-block .social-link button:focus,.deep-orange .app-social-block .social-link button:hover{color:#fff;background-color:#ff5722}.deep-orange .btn-group-vertical>.btn-default.active,.deep-orange .btn-group-vertical>.jr-btn.active,.deep-orange .btn-group>.btn-default.active,.deep-orange .btn-group>.jr-btn.active{background-color:#ff5722;border-color:#ff5722}.deep-orange .btn-group-vertical>.jr-flat-btn,.deep-orange .btn-group>.jr-flat-btn{border-color:transparent}.deep-orange .btn-group-vertical>.jr-flat-btn.active,.deep-orange .btn-group>.jr-flat-btn.active{background-color:transparent;color:#ff5722!important;border-color:transparent!important}.deep-orange .btn-group-vertical>.jr-flat-btn.active:focus,.deep-orange .btn-group-vertical>.jr-flat-btn.active:hover,.deep-orange .btn-group>.jr-flat-btn.active:focus,.deep-orange .btn-group>.jr-flat-btn.active:hover{background-color:rgba(255,87,34,.12)!important;color:#ff5722!important}.deep-orange .nav-pill-sales .nav-link.active{background-color:#ff5722;border-color:#ff5722}.deep-orange .form-checkbox>input+.check,.deep-orange .form-checkbox>input.sm+.check{color:#ff5722}.pink .right-arrow,.pink .right-arrow:after{color:#e91e63}.pink .btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.pink .btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.pink .btn-primary.focus,.pink .btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.pink .btn-primary.disabled,.pink .btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.pink .btn-primary:not(:disabled):not(.disabled).active,.pink .btn-primary:not(:disabled):not(.disabled):active,.show>.pink .btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.pink .btn-primary:not(:disabled):not(.disabled).active:focus,.pink .btn-primary:not(:disabled):not(.disabled):active:focus,.show>.pink .btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.pink .btn-secondary{background-color:#e91e63;border-color:#e91e63;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.pink .btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.pink .btn-secondary.focus,.pink .btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.pink .btn-secondary.disabled,.pink .btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.pink .btn-secondary:not(:disabled):not(.disabled).active,.pink .btn-secondary:not(:disabled):not(.disabled):active,.show>.pink .btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.pink .btn-secondary:not(:disabled):not(.disabled).active:focus,.pink .btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.pink .btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.pink .btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.pink .btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.pink .btn-success.focus,.pink .btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.pink .btn-success.disabled,.pink .btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.pink .btn-success:not(:disabled):not(.disabled).active,.pink .btn-success:not(:disabled):not(.disabled):active,.show>.pink .btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.pink .btn-success:not(:disabled):not(.disabled).active:focus,.pink .btn-success:not(:disabled):not(.disabled):active:focus,.show>.pink .btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.pink .btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.pink .btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.pink .btn-info.focus,.pink .btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.pink .btn-info.disabled,.pink .btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.pink .btn-info:not(:disabled):not(.disabled).active,.pink .btn-info:not(:disabled):not(.disabled):active,.show>.pink .btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.pink .btn-info:not(:disabled):not(.disabled).active:focus,.pink .btn-info:not(:disabled):not(.disabled):active:focus,.show>.pink .btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.pink .btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.pink .btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.pink .btn-warning.focus,.pink .btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.pink .btn-warning.disabled,.pink .btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.pink .btn-warning:not(:disabled):not(.disabled).active,.pink .btn-warning:not(:disabled):not(.disabled):active,.show>.pink .btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.pink .btn-warning:not(:disabled):not(.disabled).active:focus,.pink .btn-warning:not(:disabled):not(.disabled):active:focus,.show>.pink .btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.pink .btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.pink .btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.pink .btn-danger.focus,.pink .btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.pink .btn-danger.disabled,.pink .btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.pink .btn-danger:not(:disabled):not(.disabled).active,.pink .btn-danger:not(:disabled):not(.disabled):active,.show>.pink .btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.pink .btn-danger:not(:disabled):not(.disabled).active:focus,.pink .btn-danger:not(:disabled):not(.disabled):active:focus,.show>.pink .btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.pink .btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.pink .btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.pink .btn-light.focus,.pink .btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.pink .btn-light.disabled,.pink .btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.pink .btn-light:not(:disabled):not(.disabled).active,.pink .btn-light:not(:disabled):not(.disabled):active,.show>.pink .btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.pink .btn-light:not(:disabled):not(.disabled).active:focus,.pink .btn-light:not(:disabled):not(.disabled):active:focus,.show>.pink .btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.pink .btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.pink .btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.pink .btn-dark.focus,.pink .btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.pink .btn-dark.disabled,.pink .btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.pink .btn-dark:not(:disabled):not(.disabled).active,.pink .btn-dark:not(:disabled):not(.disabled):active,.show>.pink .btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.pink .btn-dark:not(:disabled):not(.disabled).active:focus,.pink .btn-dark:not(:disabled):not(.disabled):active:focus,.show>.pink .btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.pink a.btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.pink a.btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.pink a.btn-primary.focus,.pink a.btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.pink a.btn-primary.disabled,.pink a.btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.pink a.btn-primary:not(:disabled):not(.disabled).active,.pink a.btn-primary:not(:disabled):not(.disabled):active,.show>.pink a.btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.pink a.btn-primary:not(:disabled):not(.disabled).active:focus,.pink a.btn-primary:not(:disabled):not(.disabled):active:focus,.show>.pink a.btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.pink a.btn-secondary{color:#fff;background-color:#e91e63;border-color:#e91e63;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.pink a.btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.pink a.btn-secondary.focus,.pink a.btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.pink a.btn-secondary.disabled,.pink a.btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.pink a.btn-secondary:not(:disabled):not(.disabled).active,.pink a.btn-secondary:not(:disabled):not(.disabled):active,.show>.pink a.btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.pink a.btn-secondary:not(:disabled):not(.disabled).active:focus,.pink a.btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.pink a.btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.pink a.btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.pink a.btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.pink a.btn-success.focus,.pink a.btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.pink a.btn-success.disabled,.pink a.btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.pink a.btn-success:not(:disabled):not(.disabled).active,.pink a.btn-success:not(:disabled):not(.disabled):active,.show>.pink a.btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.pink a.btn-success:not(:disabled):not(.disabled).active:focus,.pink a.btn-success:not(:disabled):not(.disabled):active:focus,.show>.pink a.btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.pink a.btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.pink a.btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.pink a.btn-info.focus,.pink a.btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.pink a.btn-info.disabled,.pink a.btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.pink a.btn-info:not(:disabled):not(.disabled).active,.pink a.btn-info:not(:disabled):not(.disabled):active,.show>.pink a.btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.pink a.btn-info:not(:disabled):not(.disabled).active:focus,.pink a.btn-info:not(:disabled):not(.disabled):active:focus,.show>.pink a.btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.pink a.btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.pink a.btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.pink a.btn-warning.focus,.pink a.btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.pink a.btn-warning.disabled,.pink a.btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.pink a.btn-warning:not(:disabled):not(.disabled).active,.pink a.btn-warning:not(:disabled):not(.disabled):active,.show>.pink a.btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.pink a.btn-warning:not(:disabled):not(.disabled).active:focus,.pink a.btn-warning:not(:disabled):not(.disabled):active:focus,.show>.pink a.btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.pink a.btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.pink a.btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.pink a.btn-danger.focus,.pink a.btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.pink a.btn-danger.disabled,.pink a.btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.pink a.btn-danger:not(:disabled):not(.disabled).active,.pink a.btn-danger:not(:disabled):not(.disabled):active,.show>.pink a.btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.pink a.btn-danger:not(:disabled):not(.disabled).active:focus,.pink a.btn-danger:not(:disabled):not(.disabled):active:focus,.show>.pink a.btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.pink a.btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.pink a.btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.pink a.btn-light.focus,.pink a.btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.pink a.btn-light.disabled,.pink a.btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.pink a.btn-light:not(:disabled):not(.disabled).active,.pink a.btn-light:not(:disabled):not(.disabled):active,.show>.pink a.btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.pink a.btn-light:not(:disabled):not(.disabled).active:focus,.pink a.btn-light:not(:disabled):not(.disabled):active:focus,.show>.pink a.btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.pink a.btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.pink a.btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.pink a.btn-dark.focus,.pink a.btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.pink a.btn-dark.disabled,.pink a.btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.pink a.btn-dark:not(:disabled):not(.disabled).active,.pink a.btn-dark:not(:disabled):not(.disabled):active,.show>.pink a.btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.pink a.btn-dark:not(:disabled):not(.disabled).active:focus,.pink a.btn-dark:not(:disabled):not(.disabled):active:focus,.show>.pink a.btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.pink .btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.pink .btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.pink .btn-outline-primary.focus,.pink .btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.pink .btn-outline-primary.disabled,.pink .btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.pink .btn-outline-primary:not(:disabled):not(.disabled).active,.pink .btn-outline-primary:not(:disabled):not(.disabled):active,.show>.pink .btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.pink .btn-outline-primary:not(:disabled):not(.disabled).active:focus,.pink .btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.pink .btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.pink .btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.pink .btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.pink .btn-outline-secondary.focus,.pink .btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.pink .btn-outline-secondary.disabled,.pink .btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.pink .btn-outline-secondary:not(:disabled):not(.disabled).active,.pink .btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.pink .btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.pink .btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.pink .btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.pink .btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.pink .btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.pink .btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.pink .btn-outline-success.focus,.pink .btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.pink .btn-outline-success.disabled,.pink .btn-outline-success:disabled{color:#4caf50;background-color:transparent}.pink .btn-outline-success:not(:disabled):not(.disabled).active,.pink .btn-outline-success:not(:disabled):not(.disabled):active,.show>.pink .btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.pink .btn-outline-success:not(:disabled):not(.disabled).active:focus,.pink .btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.pink .btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.pink .btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.pink .btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.pink .btn-outline-info.focus,.pink .btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.pink .btn-outline-info.disabled,.pink .btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.pink .btn-outline-info:not(:disabled):not(.disabled).active,.pink .btn-outline-info:not(:disabled):not(.disabled):active,.show>.pink .btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.pink .btn-outline-info:not(:disabled):not(.disabled).active:focus,.pink .btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.pink .btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.pink .btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.pink .btn-outline-warning:hover{color:#fff;background-color:#ff9800;border-color:#ff9800}.pink .btn-outline-warning.focus,.pink .btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.pink .btn-outline-warning.disabled,.pink .btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.pink .btn-outline-warning:not(:disabled):not(.disabled).active,.pink .btn-outline-warning:not(:disabled):not(.disabled):active,.show>.pink .btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.pink .btn-outline-warning:not(:disabled):not(.disabled).active:focus,.pink .btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.pink .btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.pink .btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.pink .btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.pink .btn-outline-danger.focus,.pink .btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.pink .btn-outline-danger.disabled,.pink .btn-outline-danger:disabled{color:#f44336;background-color:transparent}.pink .btn-outline-danger:not(:disabled):not(.disabled).active,.pink .btn-outline-danger:not(:disabled):not(.disabled):active,.show>.pink .btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.pink .btn-outline-danger:not(:disabled):not(.disabled).active:focus,.pink .btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.pink .btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.pink .btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.pink .btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.pink .btn-outline-light.focus,.pink .btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.pink .btn-outline-light.disabled,.pink .btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.pink .btn-outline-light:not(:disabled):not(.disabled).active,.pink .btn-outline-light:not(:disabled):not(.disabled):active,.show>.pink .btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.pink .btn-outline-light:not(:disabled):not(.disabled).active:focus,.pink .btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.pink .btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.pink .btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.pink .btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.pink .btn-outline-dark.focus,.pink .btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.pink .btn-outline-dark.disabled,.pink .btn-outline-dark:disabled{color:#343a40;background-color:transparent}.pink .btn-outline-dark:not(:disabled):not(.disabled).active,.pink .btn-outline-dark:not(:disabled):not(.disabled):active,.show>.pink .btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.pink .btn-outline-dark:not(:disabled):not(.disabled).active:focus,.pink .btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.pink .btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.pink a.btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.pink a.btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.pink a.btn-outline-primary.focus,.pink a.btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.pink a.btn-outline-primary.disabled,.pink a.btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.pink a.btn-outline-primary:not(:disabled):not(.disabled).active,.pink a.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.pink a.btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.pink a.btn-outline-primary:not(:disabled):not(.disabled).active:focus,.pink a.btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.pink a.btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.pink a.btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.pink a.btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.pink a.btn-outline-secondary.focus,.pink a.btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.pink a.btn-outline-secondary.disabled,.pink a.btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.pink a.btn-outline-secondary:not(:disabled):not(.disabled).active,.pink a.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.pink a.btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.pink a.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.pink a.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.pink a.btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.pink a.btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.pink a.btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.pink a.btn-outline-success.focus,.pink a.btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.pink a.btn-outline-success.disabled,.pink a.btn-outline-success:disabled{color:#4caf50;background-color:transparent}.pink a.btn-outline-success:not(:disabled):not(.disabled).active,.pink a.btn-outline-success:not(:disabled):not(.disabled):active,.show>.pink a.btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.pink a.btn-outline-success:not(:disabled):not(.disabled).active:focus,.pink a.btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.pink a.btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.pink a.btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.pink a.btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.pink a.btn-outline-info.focus,.pink a.btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.pink a.btn-outline-info.disabled,.pink a.btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.pink a.btn-outline-info:not(:disabled):not(.disabled).active,.pink a.btn-outline-info:not(:disabled):not(.disabled):active,.show>.pink a.btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.pink a.btn-outline-info:not(:disabled):not(.disabled).active:focus,.pink a.btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.pink a.btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.pink a.btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.pink a.btn-outline-warning:hover{color:#fff;background-color:#ff9800;border-color:#ff9800}.pink a.btn-outline-warning.focus,.pink a.btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.pink a.btn-outline-warning.disabled,.pink a.btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.pink a.btn-outline-warning:not(:disabled):not(.disabled).active,.pink a.btn-outline-warning:not(:disabled):not(.disabled):active,.show>.pink a.btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.pink a.btn-outline-warning:not(:disabled):not(.disabled).active:focus,.pink a.btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.pink a.btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.pink a.btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.pink a.btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.pink a.btn-outline-danger.focus,.pink a.btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.pink a.btn-outline-danger.disabled,.pink a.btn-outline-danger:disabled{color:#f44336;background-color:transparent}.pink a.btn-outline-danger:not(:disabled):not(.disabled).active,.pink a.btn-outline-danger:not(:disabled):not(.disabled):active,.show>.pink a.btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.pink a.btn-outline-danger:not(:disabled):not(.disabled).active:focus,.pink a.btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.pink a.btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.pink a.btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.pink a.btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.pink a.btn-outline-light.focus,.pink a.btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.pink a.btn-outline-light.disabled,.pink a.btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.pink a.btn-outline-light:not(:disabled):not(.disabled).active,.pink a.btn-outline-light:not(:disabled):not(.disabled):active,.show>.pink a.btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.pink a.btn-outline-light:not(:disabled):not(.disabled).active:focus,.pink a.btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.pink a.btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.pink a.btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.pink a.btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.pink a.btn-outline-dark.focus,.pink a.btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.pink a.btn-outline-dark.disabled,.pink a.btn-outline-dark:disabled{color:#343a40;background-color:transparent}.pink a.btn-outline-dark:not(:disabled):not(.disabled).active,.pink a.btn-outline-dark:not(:disabled):not(.disabled):active,.show>.pink a.btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.pink a.btn-outline-dark:not(:disabled):not(.disabled).active:focus,.pink a.btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.pink a.btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.pink .btn-outline-primary,.pink a.btn-outline-primary{color:#e91e63;border-color:#e91e63}.pink .btn-outline-primary.disabled,.pink .btn-outline-primary:disabled,.pink .btn-outline-primary:focus,.pink .btn-outline-primary:hover,.pink .btn-outline-primary:not(:disabled):not(.disabled).active,.pink .btn-outline-primary:not(:disabled):not(.disabled):active,.pink a.btn-outline-primary.disabled,.pink a.btn-outline-primary:disabled,.pink a.btn-outline-primary:focus,.pink a.btn-outline-primary:hover,.pink a.btn-outline-primary:not(:disabled):not(.disabled).active,.pink a.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.pink .btn-outline-primary.dropdown-toggle,.show>.pink a.btn-outline-primary.dropdown-toggle{color:#fff;border-color:#e91e63;background-color:#e91e63}.pink .btn-outline-secondary,.pink a.btn-outline-secondary{color:#00bfa5;border-color:#00bfa5}.pink .btn-outline-secondary.disabled,.pink .btn-outline-secondary:disabled,.pink .btn-outline-secondary:focus,.pink .btn-outline-secondary:hover,.pink .btn-outline-secondary:not(:disabled):not(.disabled).active,.pink .btn-outline-secondary:not(:disabled):not(.disabled):active,.pink a.btn-outline-secondary.disabled,.pink a.btn-outline-secondary:disabled,.pink a.btn-outline-secondary:focus,.pink a.btn-outline-secondary:hover,.pink a.btn-outline-secondary:not(:disabled):not(.disabled).active,.pink a.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.pink .btn-outline-secondary.dropdown-toggle,.show>.pink a.btn-outline-secondary.dropdown-toggle{color:#fff;border-color:#00bfa5;background-color:#00bfa5}.pink a,.pink a.text-primary{color:#e91e63}.pink a.text-primary:focus,.pink a.text-primary:hover,.pink a:focus,.pink a:hover{color:#c1134e}.pink .text-primary{color:#e91e63!important}.pink .page-link,.pink .page-link:focus,.pink .page-link:hover{color:#e91e63}.pink .badge-primary,.pink .bg-primary{background-color:#e91e63!important;color:#fff!important}.pink .btn-primary,.pink .jr-btn-primary,.pink a.btn-primary,.pink a.jr-btn-primary{background-color:#e91e63;border-color:#e91e63;color:#fff}.pink .btn-primary:focus,.pink .btn-primary:hover,.pink .btn-primary:not([disabled]):not(.disabled):active,.pink .jr-btn-primary:focus,.pink .jr-btn-primary:hover,.pink .jr-btn-primary:not([disabled]):not(.disabled):active,.pink a.btn-primary:focus,.pink a.btn-primary:hover,.pink a.btn-primary:not([disabled]):not(.disabled):active,.pink a.jr-btn-primary:focus,.pink a.jr-btn-primary:hover,.pink a.jr-btn-primary:not([disabled]):not(.disabled):active{background-color:#d81558!important;border-color:#d81558!important;color:#fff!important}.pink .bg-primary.lighten-4{background-color:#f8bbd0!important}.pink .bg-primary.lighten-3{background-color:#f48fb1!important}.pink .bg-primary.lighten-2{background-color:#f06292!important}.pink .bg-primary.lighten-1{background-color:#ec407a!important}.pink .bg-primary.darken-1{background-color:#d81b60!important}.pink .bg-primary.darken-2{background-color:#c2185b!important}.pink .bg-primary.darken-3{background-color:#ad1457!important}.pink .bg-primary.darken-4{background-color:#880e4f!important}.pink .bg-primary.accent-1{background-color:#ff80ab!important}.pink .bg-primary.accent-2{background-color:#ff4081!important}.pink .bg-primary.accent-3{background-color:#f50057!important}.pink .bg-primary.accent-4{background-color:#c51162!important}.pink a.text-secondary{color:#00bfa5}.pink a.text-secondary:focus,.pink a.text-secondary:hover{color:#008c79!important}.pink .text-secondary{color:#00bfa5!important}.pink .badge-secondary,.pink .bg-secondary{background-color:#00bfa5!important;color:#fff!important}.pink .btn-secondary{background-color:#00bfa5;border-color:#00bfa5;color:#fff}.pink .btn-secondary:active,.pink .btn-secondary:focus,.pink .btn-secondary:hover{background-color:#00a68f!important;border-color:#00a68f!important;color:#fff!important}.pink .jr-flat-btn{background-color:transparent!important;color:#5c5c5c!important}.pink .jr-flat-btn:active,.pink .jr-flat-btn:focus,.pink .jr-flat-btn:hover{background-color:#f5f5f5!important;color:#5c5c5c!important}.pink .jr-flat-btn.jr-btn-primary{background-color:transparent!important;color:#e91e63!important;border-color:transparent!important}.pink .jr-flat-btn.jr-btn-primary:focus,.pink .jr-flat-btn.jr-btn-primary:hover{background-color:rgba(233,30,99,.12)!important;color:#e91e63!important}.pink .bg-primary .jr-flat-btn.jr-btn-primary{background-color:transparent!important;color:#fff!important;border-color:transparent!important}.pink .bg-primary .jr-flat-btn.jr-btn-primary:focus,.pink .bg-primary .jr-flat-btn.jr-btn-primary:hover{background-color:hsla(0,0%,100%,.12)!important;color:#fff!important}.pink .jr-flat-btn.jr-btn-secondary{background-color:transparent!important;color:#00bfa5!important;border-color:transparent!important}.pink .jr-flat-btn.jr-btn-secondary:focus,.pink .jr-flat-btn.jr-btn-secondary:hover{background-color:rgba(0,191,165,.12)!important;color:#00bfa5!important}.pink .bg-secondary .jr-flat-btn.jr-btn-secondary{background-color:transparent!important;color:#fff!important;border-color:transparent!important}.pink .bg-secondary .jr-flat-btn.jr-btn-secondary:focus,.pink .bg-secondary .jr-flat-btn.jr-btn-secondary:hover{background-color:hsla(0,0%,100%,.12)!important;color:#fff!important}@media screen and (max-width:575px){.pink .app-main-header .search-dropdown input{background-color:#fff}}.pink .color-theme-header{background-color:#e91e63}.pink .side-nav{background-color:#fff!important;color:#868e96!important;border-right:1px solid #e9ecef!important}.pink .side-nav .user-profile{background-color:#f8f9fa;position:relative;z-index:2}.pink .side-nav .user-profile .text-white{color:#e91e63!important}.pink .side-nav .customizer{border-bottom:1px solid #e6e7e9}.pink .side-nav .user-detail .user-name{color:#e91e63}.pink ul.nav-menu .nav-header,.pink ul.nav-menu li a{color:#868e96}.pink ul.nav-menu>li.open>a,.pink ul.nav-menu>li>a:focus,.pink ul.nav-menu>li>a:hover{background-color:#fff;color:#e91e63}.pink ul.nav-menu li.menu>a:focus:before,.pink ul.nav-menu li.menu>a:hover:before{color:#e91e63}.pink ul.nav-menu li ul{background-color:#fff}.pink ul.nav-menu li.menu>a:before{color:#868e96}.pink ul.nav-menu li.menu.open>a:before,.pink ul.nav-menu li.menu>a:focus:before,.pink ul.nav-menu li.menu li>a:hover:before{color:#e91e63}.pink ul.nav-menu li.menu .sub-menu li>a:before{color:#868e96}.pink ul.nav-menu li.menu .sub-menu li>a.active .nav-text{background-color:#e91e63}.pink ul.nav-menu li.menu.open .sub-menu li>a.active:before,.pink ul.nav-menu li.menu .sub-menu li>a:focus,.pink ul.nav-menu li.menu .sub-menu li>a:focus:before,.pink ul.nav-menu li.menu .sub-menu li>a:hover,.pink ul.nav-menu li.menu .sub-menu li>a:hover:before{background-color:#fff;color:#e91e63}.pink .navbar-nav li:focus>a,.pink .navbar-nav li:hover>a{color:#e91e63}.pink .navbar-nav li a{color:#868e96}.pink .navbar-nav li.nav-item.active>a,.pink .navbar-nav li a:focus,.pink .navbar-nav li a:hover,.pink .navbar-nav ul.sub-menu li.active>a,.pink .navbar-nav ul.sub-menu li a.active{color:#e91e63}.pink .navbar-nav .nav-arrow>a:before{color:#868e96}.pink .navbar-nav .nav-arrow.active>a:before,.pink .navbar-nav .nav-arrow:focus>a:before,.pink .navbar-nav .nav-arrow:hover>a:before,.pink .navbar-nav .nav-arrow a:focus:before,.pink .navbar-nav .nav-arrow a:hover:before{color:#e91e63}.pink .app-top-nav{background-color:#e91e63}.pink .app-top-nav .navbar-nav li.nav-item>a{color:#fff}.pink .app-top-nav .navbar-nav li.nav-item.active>a,.pink .app-top-nav .navbar-nav li.nav-item:focus>a,.pink .app-top-nav .navbar-nav li.nav-item:hover>a,.pink .app-top-nav .navbar-nav li.nav-item>a:focus,.pink .app-top-nav .navbar-nav li.nav-item>a:hover{color:#00bfa5}.pink .module-nav li a.active{border-color:#e91e63}.pink .rbc-event{background-color:#e91e63}.pink .rbc-event.rbc-selected{background-color:#c1134e}.pink .rbc-slot-selection{background-color:rgba(233,30,99,.7)}.pink .rbc-toolbar button.rbc-active,.pink .rbc-toolbar button.rbc-active:focus,.pink .rbc-toolbar button.rbc-active:hover,.pink .rbc-toolbar button:active,.pink .rbc-toolbar button:active:focus,.pink .rbc-toolbar button:active:hover,.pink .rbc-toolbar button:focus,.pink .rbc-toolbar button:hover{background-color:rgba(233,30,99,.9);border-color:#e91e63}.pink .rbc-day-slot .rbc-event{border-color:#e91e63}.pink .chat-sidenav-title{color:#e91e63}.pink .chat-user-item.active,.pink .chat-user-item:hover{background-color:#fdeff4}.pink .contact-list i{color:#e91e63}.pink .Collapsible__trigger{background:#e91e63}.pink .categories-list li.active a,.pink .categories-list li a:focus,.pink .categories-list li a:hover{color:#e91e63}.pink .filter-with-bg-color ul li a,.pink .login-content .form-control:focus{border-color:#e91e63}.pink .filter-with-bg-color ul li a.active,.pink .filter-with-bg-color ul li a:focus,.pink .filter-with-bg-color ul li a:hover{background-color:#e91e63}.pink .profile-intro .icon{color:#e91e63}.pink .actions,.pink .social-link li.active a,.pink .social-link li a:focus,.pink .social-link li a:hover{color:#00bfa5}.pink .table-hover tbody tr:hover{background-color:rgba(233,30,99,.075)}.pink .border-primary{border-color:#e91e63!important}.pink .app-logo-content{background-color:#e91e63}.pink .app-social-block .social-link button{border:1px solid #e91e63;color:#e91e63}.pink .app-social-block .social-link button:focus,.pink .app-social-block .social-link button:hover{color:#fff;background-color:#e91e63}.pink .btn-group-vertical>.btn-default.active,.pink .btn-group-vertical>.jr-btn.active,.pink .btn-group>.btn-default.active,.pink .btn-group>.jr-btn.active{background-color:#e91e63;border-color:#e91e63}.pink .btn-group-vertical>.jr-flat-btn,.pink .btn-group>.jr-flat-btn{border-color:transparent}.pink .btn-group-vertical>.jr-flat-btn.active,.pink .btn-group>.jr-flat-btn.active{background-color:transparent;color:#e91e63!important;border-color:transparent!important}.pink .btn-group-vertical>.jr-flat-btn.active:focus,.pink .btn-group-vertical>.jr-flat-btn.active:hover,.pink .btn-group>.jr-flat-btn.active:focus,.pink .btn-group>.jr-flat-btn.active:hover{background-color:rgba(233,30,99,.12)!important;color:#e91e63!important}.pink .nav-pill-sales .nav-link.active{background-color:#e91e63;border-color:#e91e63}.pink .form-checkbox>input+.check,.pink .form-checkbox>input.sm+.check{color:#e91e63}.blue .right-arrow,.blue .right-arrow:after{color:#2196f3}.blue .btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.blue .btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.blue .btn-primary.focus,.blue .btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.blue .btn-primary.disabled,.blue .btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.blue .btn-primary:not(:disabled):not(.disabled).active,.blue .btn-primary:not(:disabled):not(.disabled):active,.show>.blue .btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.blue .btn-primary:not(:disabled):not(.disabled).active:focus,.blue .btn-primary:not(:disabled):not(.disabled):active:focus,.show>.blue .btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.blue .btn-secondary{background-color:#e91e63;border-color:#e91e63;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.blue .btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.blue .btn-secondary.focus,.blue .btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.blue .btn-secondary.disabled,.blue .btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.blue .btn-secondary:not(:disabled):not(.disabled).active,.blue .btn-secondary:not(:disabled):not(.disabled):active,.show>.blue .btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.blue .btn-secondary:not(:disabled):not(.disabled).active:focus,.blue .btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.blue .btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.blue .btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.blue .btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.blue .btn-success.focus,.blue .btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.blue .btn-success.disabled,.blue .btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.blue .btn-success:not(:disabled):not(.disabled).active,.blue .btn-success:not(:disabled):not(.disabled):active,.show>.blue .btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.blue .btn-success:not(:disabled):not(.disabled).active:focus,.blue .btn-success:not(:disabled):not(.disabled):active:focus,.show>.blue .btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.blue .btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.blue .btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.blue .btn-info.focus,.blue .btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.blue .btn-info.disabled,.blue .btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.blue .btn-info:not(:disabled):not(.disabled).active,.blue .btn-info:not(:disabled):not(.disabled):active,.show>.blue .btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.blue .btn-info:not(:disabled):not(.disabled).active:focus,.blue .btn-info:not(:disabled):not(.disabled):active:focus,.show>.blue .btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.blue .btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.blue .btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.blue .btn-warning.focus,.blue .btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.blue .btn-warning.disabled,.blue .btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.blue .btn-warning:not(:disabled):not(.disabled).active,.blue .btn-warning:not(:disabled):not(.disabled):active,.show>.blue .btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.blue .btn-warning:not(:disabled):not(.disabled).active:focus,.blue .btn-warning:not(:disabled):not(.disabled):active:focus,.show>.blue .btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.blue .btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.blue .btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.blue .btn-danger.focus,.blue .btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.blue .btn-danger.disabled,.blue .btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.blue .btn-danger:not(:disabled):not(.disabled).active,.blue .btn-danger:not(:disabled):not(.disabled):active,.show>.blue .btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.blue .btn-danger:not(:disabled):not(.disabled).active:focus,.blue .btn-danger:not(:disabled):not(.disabled):active:focus,.show>.blue .btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.blue .btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.blue .btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.blue .btn-light.focus,.blue .btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.blue .btn-light.disabled,.blue .btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.blue .btn-light:not(:disabled):not(.disabled).active,.blue .btn-light:not(:disabled):not(.disabled):active,.show>.blue .btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.blue .btn-light:not(:disabled):not(.disabled).active:focus,.blue .btn-light:not(:disabled):not(.disabled):active:focus,.show>.blue .btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.blue .btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.blue .btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.blue .btn-dark.focus,.blue .btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.blue .btn-dark.disabled,.blue .btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.blue .btn-dark:not(:disabled):not(.disabled).active,.blue .btn-dark:not(:disabled):not(.disabled):active,.show>.blue .btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.blue .btn-dark:not(:disabled):not(.disabled).active:focus,.blue .btn-dark:not(:disabled):not(.disabled):active:focus,.show>.blue .btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.blue a.btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.blue a.btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.blue a.btn-primary.focus,.blue a.btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.blue a.btn-primary.disabled,.blue a.btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.blue a.btn-primary:not(:disabled):not(.disabled).active,.blue a.btn-primary:not(:disabled):not(.disabled):active,.show>.blue a.btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.blue a.btn-primary:not(:disabled):not(.disabled).active:focus,.blue a.btn-primary:not(:disabled):not(.disabled):active:focus,.show>.blue a.btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.blue a.btn-secondary{color:#fff;background-color:#e91e63;border-color:#e91e63;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.blue a.btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.blue a.btn-secondary.focus,.blue a.btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.blue a.btn-secondary.disabled,.blue a.btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.blue a.btn-secondary:not(:disabled):not(.disabled).active,.blue a.btn-secondary:not(:disabled):not(.disabled):active,.show>.blue a.btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.blue a.btn-secondary:not(:disabled):not(.disabled).active:focus,.blue a.btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.blue a.btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.blue a.btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.blue a.btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.blue a.btn-success.focus,.blue a.btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.blue a.btn-success.disabled,.blue a.btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.blue a.btn-success:not(:disabled):not(.disabled).active,.blue a.btn-success:not(:disabled):not(.disabled):active,.show>.blue a.btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.blue a.btn-success:not(:disabled):not(.disabled).active:focus,.blue a.btn-success:not(:disabled):not(.disabled):active:focus,.show>.blue a.btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.blue a.btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.blue a.btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.blue a.btn-info.focus,.blue a.btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.blue a.btn-info.disabled,.blue a.btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.blue a.btn-info:not(:disabled):not(.disabled).active,.blue a.btn-info:not(:disabled):not(.disabled):active,.show>.blue a.btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.blue a.btn-info:not(:disabled):not(.disabled).active:focus,.blue a.btn-info:not(:disabled):not(.disabled):active:focus,.show>.blue a.btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.blue a.btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.blue a.btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.blue a.btn-warning.focus,.blue a.btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.blue a.btn-warning.disabled,.blue a.btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.blue a.btn-warning:not(:disabled):not(.disabled).active,.blue a.btn-warning:not(:disabled):not(.disabled):active,.show>.blue a.btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.blue a.btn-warning:not(:disabled):not(.disabled).active:focus,.blue a.btn-warning:not(:disabled):not(.disabled):active:focus,.show>.blue a.btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.blue a.btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.blue a.btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.blue a.btn-danger.focus,.blue a.btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.blue a.btn-danger.disabled,.blue a.btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.blue a.btn-danger:not(:disabled):not(.disabled).active,.blue a.btn-danger:not(:disabled):not(.disabled):active,.show>.blue a.btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.blue a.btn-danger:not(:disabled):not(.disabled).active:focus,.blue a.btn-danger:not(:disabled):not(.disabled):active:focus,.show>.blue a.btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.blue a.btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.blue a.btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.blue a.btn-light.focus,.blue a.btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.blue a.btn-light.disabled,.blue a.btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.blue a.btn-light:not(:disabled):not(.disabled).active,.blue a.btn-light:not(:disabled):not(.disabled):active,.show>.blue a.btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.blue a.btn-light:not(:disabled):not(.disabled).active:focus,.blue a.btn-light:not(:disabled):not(.disabled):active:focus,.show>.blue a.btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.blue a.btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.blue a.btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.blue a.btn-dark.focus,.blue a.btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.blue a.btn-dark.disabled,.blue a.btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.blue a.btn-dark:not(:disabled):not(.disabled).active,.blue a.btn-dark:not(:disabled):not(.disabled):active,.show>.blue a.btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.blue a.btn-dark:not(:disabled):not(.disabled).active:focus,.blue a.btn-dark:not(:disabled):not(.disabled):active:focus,.show>.blue a.btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.blue .btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.blue .btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.blue .btn-outline-primary.focus,.blue .btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.blue .btn-outline-primary.disabled,.blue .btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.blue .btn-outline-primary:not(:disabled):not(.disabled).active,.blue .btn-outline-primary:not(:disabled):not(.disabled):active,.show>.blue .btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.blue .btn-outline-primary:not(:disabled):not(.disabled).active:focus,.blue .btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.blue .btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.blue .btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.blue .btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.blue .btn-outline-secondary.focus,.blue .btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.blue .btn-outline-secondary.disabled,.blue .btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.blue .btn-outline-secondary:not(:disabled):not(.disabled).active,.blue .btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.blue .btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.blue .btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.blue .btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.blue .btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.blue .btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.blue .btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.blue .btn-outline-success.focus,.blue .btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.blue .btn-outline-success.disabled,.blue .btn-outline-success:disabled{color:#4caf50;background-color:transparent}.blue .btn-outline-success:not(:disabled):not(.disabled).active,.blue .btn-outline-success:not(:disabled):not(.disabled):active,.show>.blue .btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.blue .btn-outline-success:not(:disabled):not(.disabled).active:focus,.blue .btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.blue .btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.blue .btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.blue .btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.blue .btn-outline-info.focus,.blue .btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.blue .btn-outline-info.disabled,.blue .btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.blue .btn-outline-info:not(:disabled):not(.disabled).active,.blue .btn-outline-info:not(:disabled):not(.disabled):active,.show>.blue .btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.blue .btn-outline-info:not(:disabled):not(.disabled).active:focus,.blue .btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.blue .btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.blue .btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.blue .btn-outline-warning:hover{color:#fff;background-color:#ff9800;border-color:#ff9800}.blue .btn-outline-warning.focus,.blue .btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.blue .btn-outline-warning.disabled,.blue .btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.blue .btn-outline-warning:not(:disabled):not(.disabled).active,.blue .btn-outline-warning:not(:disabled):not(.disabled):active,.show>.blue .btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.blue .btn-outline-warning:not(:disabled):not(.disabled).active:focus,.blue .btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.blue .btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.blue .btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.blue .btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.blue .btn-outline-danger.focus,.blue .btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.blue .btn-outline-danger.disabled,.blue .btn-outline-danger:disabled{color:#f44336;background-color:transparent}.blue .btn-outline-danger:not(:disabled):not(.disabled).active,.blue .btn-outline-danger:not(:disabled):not(.disabled):active,.show>.blue .btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.blue .btn-outline-danger:not(:disabled):not(.disabled).active:focus,.blue .btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.blue .btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.blue .btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.blue .btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.blue .btn-outline-light.focus,.blue .btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.blue .btn-outline-light.disabled,.blue .btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.blue .btn-outline-light:not(:disabled):not(.disabled).active,.blue .btn-outline-light:not(:disabled):not(.disabled):active,.show>.blue .btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.blue .btn-outline-light:not(:disabled):not(.disabled).active:focus,.blue .btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.blue .btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.blue .btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.blue .btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.blue .btn-outline-dark.focus,.blue .btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.blue .btn-outline-dark.disabled,.blue .btn-outline-dark:disabled{color:#343a40;background-color:transparent}.blue .btn-outline-dark:not(:disabled):not(.disabled).active,.blue .btn-outline-dark:not(:disabled):not(.disabled):active,.show>.blue .btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.blue .btn-outline-dark:not(:disabled):not(.disabled).active:focus,.blue .btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.blue .btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.blue a.btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.blue a.btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.blue a.btn-outline-primary.focus,.blue a.btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.blue a.btn-outline-primary.disabled,.blue a.btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.blue a.btn-outline-primary:not(:disabled):not(.disabled).active,.blue a.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.blue a.btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.blue a.btn-outline-primary:not(:disabled):not(.disabled).active:focus,.blue a.btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.blue a.btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.blue a.btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.blue a.btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.blue a.btn-outline-secondary.focus,.blue a.btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.blue a.btn-outline-secondary.disabled,.blue a.btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.blue a.btn-outline-secondary:not(:disabled):not(.disabled).active,.blue a.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.blue a.btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.blue a.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.blue a.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.blue a.btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.blue a.btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.blue a.btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.blue a.btn-outline-success.focus,.blue a.btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.blue a.btn-outline-success.disabled,.blue a.btn-outline-success:disabled{color:#4caf50;background-color:transparent}.blue a.btn-outline-success:not(:disabled):not(.disabled).active,.blue a.btn-outline-success:not(:disabled):not(.disabled):active,.show>.blue a.btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.blue a.btn-outline-success:not(:disabled):not(.disabled).active:focus,.blue a.btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.blue a.btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.blue a.btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.blue a.btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.blue a.btn-outline-info.focus,.blue a.btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.blue a.btn-outline-info.disabled,.blue a.btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.blue a.btn-outline-info:not(:disabled):not(.disabled).active,.blue a.btn-outline-info:not(:disabled):not(.disabled):active,.show>.blue a.btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.blue a.btn-outline-info:not(:disabled):not(.disabled).active:focus,.blue a.btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.blue a.btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.blue a.btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.blue a.btn-outline-warning:hover{color:#fff;background-color:#ff9800;border-color:#ff9800}.blue a.btn-outline-warning.focus,.blue a.btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.blue a.btn-outline-warning.disabled,.blue a.btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.blue a.btn-outline-warning:not(:disabled):not(.disabled).active,.blue a.btn-outline-warning:not(:disabled):not(.disabled):active,.show>.blue a.btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.blue a.btn-outline-warning:not(:disabled):not(.disabled).active:focus,.blue a.btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.blue a.btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.blue a.btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.blue a.btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.blue a.btn-outline-danger.focus,.blue a.btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.blue a.btn-outline-danger.disabled,.blue a.btn-outline-danger:disabled{color:#f44336;background-color:transparent}.blue a.btn-outline-danger:not(:disabled):not(.disabled).active,.blue a.btn-outline-danger:not(:disabled):not(.disabled):active,.show>.blue a.btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.blue a.btn-outline-danger:not(:disabled):not(.disabled).active:focus,.blue a.btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.blue a.btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.blue a.btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.blue a.btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.blue a.btn-outline-light.focus,.blue a.btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.blue a.btn-outline-light.disabled,.blue a.btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.blue a.btn-outline-light:not(:disabled):not(.disabled).active,.blue a.btn-outline-light:not(:disabled):not(.disabled):active,.show>.blue a.btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.blue a.btn-outline-light:not(:disabled):not(.disabled).active:focus,.blue a.btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.blue a.btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.blue a.btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.blue a.btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.blue a.btn-outline-dark.focus,.blue a.btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.blue a.btn-outline-dark.disabled,.blue a.btn-outline-dark:disabled{color:#343a40;background-color:transparent}.blue a.btn-outline-dark:not(:disabled):not(.disabled).active,.blue a.btn-outline-dark:not(:disabled):not(.disabled):active,.show>.blue a.btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.blue a.btn-outline-dark:not(:disabled):not(.disabled).active:focus,.blue a.btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.blue a.btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.blue .btn-outline-primary,.blue a.btn-outline-primary{color:#2196f3;border-color:#2196f3}.blue .btn-outline-primary.disabled,.blue .btn-outline-primary:disabled,.blue .btn-outline-primary:focus,.blue .btn-outline-primary:hover,.blue .btn-outline-primary:not(:disabled):not(.disabled).active,.blue .btn-outline-primary:not(:disabled):not(.disabled):active,.blue a.btn-outline-primary.disabled,.blue a.btn-outline-primary:disabled,.blue a.btn-outline-primary:focus,.blue a.btn-outline-primary:hover,.blue a.btn-outline-primary:not(:disabled):not(.disabled).active,.blue a.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.blue .btn-outline-primary.dropdown-toggle,.show>.blue a.btn-outline-primary.dropdown-toggle{color:#fff;border-color:#2196f3;background-color:#2196f3}.blue .btn-outline-secondary,.blue a.btn-outline-secondary{color:#ff6e40;border-color:#ff6e40}.blue .btn-outline-secondary.disabled,.blue .btn-outline-secondary:disabled,.blue .btn-outline-secondary:focus,.blue .btn-outline-secondary:hover,.blue .btn-outline-secondary:not(:disabled):not(.disabled).active,.blue .btn-outline-secondary:not(:disabled):not(.disabled):active,.blue a.btn-outline-secondary.disabled,.blue a.btn-outline-secondary:disabled,.blue a.btn-outline-secondary:focus,.blue a.btn-outline-secondary:hover,.blue a.btn-outline-secondary:not(:disabled):not(.disabled).active,.blue a.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.blue .btn-outline-secondary.dropdown-toggle,.show>.blue a.btn-outline-secondary.dropdown-toggle{color:#fff;border-color:#ff6e40;background-color:#ff6e40}.blue a,.blue a.text-primary{color:#2196f3}.blue a.text-primary:focus,.blue a.text-primary:hover,.blue a:focus,.blue a:hover{color:#0c7cd5}.blue .text-primary{color:#2196f3!important}.blue .page-link,.blue .page-link:focus,.blue .page-link:hover{color:#2196f3}.blue .badge-primary,.blue .bg-primary{background-color:#2196f3!important;color:#fff!important}.blue .btn-primary,.blue .jr-btn-primary,.blue a.btn-primary,.blue a.jr-btn-primary{background-color:#2196f3;border-color:#2196f3;color:#fff}.blue .btn-primary:focus,.blue .btn-primary:hover,.blue .btn-primary:not([disabled]):not(.disabled):active,.blue .jr-btn-primary:focus,.blue .jr-btn-primary:hover,.blue .jr-btn-primary:not([disabled]):not(.disabled):active,.blue a.btn-primary:focus,.blue a.btn-primary:hover,.blue a.btn-primary:not([disabled]):not(.disabled):active,.blue a.jr-btn-primary:focus,.blue a.jr-btn-primary:hover,.blue a.jr-btn-primary:not([disabled]):not(.disabled):active{background-color:#0d8aee!important;border-color:#0d8aee!important;color:#fff!important}.blue .bg-primary.lighten-4{background-color:#bbdefb!important}.blue .bg-primary.lighten-3{background-color:#90caf9!important}.blue .bg-primary.lighten-2{background-color:#64b5f6!important}.blue .bg-primary.lighten-1{background-color:#42a5f5!important}.blue .bg-primary.darken-1{background-color:#1e88e5!important}.blue .bg-primary.darken-2{background-color:#1976d2!important}.blue .bg-primary.darken-3{background-color:#1565c0!important}.blue .bg-primary.darken-4{background-color:#0d47a1!important}.blue .bg-primary.accent-1{background-color:#82b1ff!important}.blue .bg-primary.accent-2{background-color:#448aff!important}.blue .bg-primary.accent-3{background-color:#2979ff!important}.blue .bg-primary.accent-4{background-color:#2962ff!important}.blue a.text-secondary{color:#ff6e40}.blue a.text-secondary:focus,.blue a.text-secondary:hover{color:#ff470d!important}.blue .text-secondary{color:#ff6e40!important}.blue .badge-secondary,.blue .bg-secondary{background-color:#ff6e40!important;color:#fff!important}.blue .btn-secondary{background-color:#ff6e40;border-color:#ff6e40;color:#fff}.blue .btn-secondary:active,.blue .btn-secondary:focus,.blue .btn-secondary:hover{background-color:#ff5b27!important;border-color:#ff5b27!important;color:#fff!important}.blue .jr-flat-btn{background-color:transparent!important;color:#5c5c5c!important}.blue .jr-flat-btn:active,.blue .jr-flat-btn:focus,.blue .jr-flat-btn:hover{background-color:#f5f5f5!important;color:#5c5c5c!important}.blue .jr-flat-btn.jr-btn-primary{background-color:transparent!important;color:#2196f3!important;border-color:transparent!important}.blue .jr-flat-btn.jr-btn-primary:focus,.blue .jr-flat-btn.jr-btn-primary:hover{background-color:rgba(33,150,243,.12)!important;color:#2196f3!important}.blue .bg-primary .jr-flat-btn.jr-btn-primary{background-color:transparent!important;color:#fff!important;border-color:transparent!important}.blue .bg-primary .jr-flat-btn.jr-btn-primary:focus,.blue .bg-primary .jr-flat-btn.jr-btn-primary:hover{background-color:hsla(0,0%,100%,.12)!important;color:#fff!important}.blue .jr-flat-btn.jr-btn-secondary{background-color:transparent!important;color:#ff6e40!important;border-color:#ff6e40!important}.blue .jr-flat-btn.jr-btn-secondary:focus,.blue .jr-flat-btn.jr-btn-secondary:hover{background-color:rgba(255,110,64,.12)!important;color:#ff6e40!important}.blue .bg-secondary .jr-flat-btn.jr-btn-secondary{background-color:transparent!important;color:#fff!important;border-color:transparent!important}.blue .bg-secondary .jr-flat-btn.jr-btn-secondary:focus,.blue .bg-secondary .jr-flat-btn.jr-btn-secondary:hover{background-color:hsla(0,0%,100%,.12)!important;color:#fff!important}@media screen and (max-width:575px){.blue .app-main-header .search-dropdown input{background-color:#fff}}.blue .color-theme-header{background-color:#2196f3}.blue .side-nav{background-color:#fff!important;color:#868e96!important}.blue .side-nav .user-profile{background-color:#f8f9fa;position:relative;z-index:2}.blue .side-nav .user-profile .text-white{color:#2196f3!important}.blue .side-nav .customizer{border-bottom:1px solid #e6e7e9}.blue .side-nav .user-detail .user-name{color:#2196f3}.blue ul.nav-menu .nav-header,.blue ul.nav-menu li a{color:#868e96}.blue ul.nav-menu>li.open>a,.blue ul.nav-menu>li>a:focus,.blue ul.nav-menu>li>a:hover{background-color:#fff;color:#2196f3}.blue ul.nav-menu li.menu>a:focus:before,.blue ul.nav-menu li.menu>a:hover:before{color:#2196f3}.blue ul.nav-menu li ul{background-color:#fff}.blue ul.nav-menu li.menu>a:before{color:#868e96}.blue ul.nav-menu li.menu.open>a:before,.blue ul.nav-menu li.menu>a:focus:before,.blue ul.nav-menu li.menu li>a:hover:before{color:#2196f3}.blue ul.nav-menu li.menu .sub-menu li>a:before{color:#868e96}.blue ul.nav-menu li.menu .sub-menu li>a.active .nav-text{background-color:#2196f3}.blue ul.nav-menu li.menu.open .sub-menu li>a.active:before,.blue ul.nav-menu li.menu .sub-menu li>a:focus,.blue ul.nav-menu li.menu .sub-menu li>a:focus:before,.blue ul.nav-menu li.menu .sub-menu li>a:hover,.blue ul.nav-menu li.menu .sub-menu li>a:hover:before{background-color:#fff;color:#2196f3}.blue .navbar-nav li:focus>a,.blue .navbar-nav li:hover>a{color:#2196f3}.blue .navbar-nav li a{color:#868e96}.blue .navbar-nav li.nav-item.active>a,.blue .navbar-nav li a:focus,.blue .navbar-nav li a:hover,.blue .navbar-nav ul.sub-menu li.active>a,.blue .navbar-nav ul.sub-menu li a.active{color:#2196f3}.blue .navbar-nav .nav-arrow>a:before{color:#868e96}.blue .navbar-nav .nav-arrow.active>a:before,.blue .navbar-nav .nav-arrow:focus>a:before,.blue .navbar-nav .nav-arrow:hover>a:before,.blue .navbar-nav .nav-arrow a:focus:before,.blue .navbar-nav .nav-arrow a:hover:before{color:#2196f3}.blue .app-top-nav{background-color:#2196f3}.blue .app-top-nav .navbar-nav li.nav-item>a{color:#fff}.blue .app-top-nav .navbar-nav li.nav-item.active>a,.blue .app-top-nav .navbar-nav li.nav-item:focus>a,.blue .app-top-nav .navbar-nav li.nav-item:hover>a,.blue .app-top-nav .navbar-nav li.nav-item>a:focus,.blue .app-top-nav .navbar-nav li.nav-item>a:hover{color:#ff6e40}.blue .module-nav li a.active{border-color:#2196f3}.blue .rbc-event{background-color:#2196f3}.blue .rbc-event.rbc-selected{background-color:#0c7cd5}.blue .rbc-slot-selection{background-color:rgba(33,150,243,.7)}.blue .rbc-toolbar button.rbc-active,.blue .rbc-toolbar button.rbc-active:focus,.blue .rbc-toolbar button.rbc-active:hover,.blue .rbc-toolbar button:active,.blue .rbc-toolbar button:active:focus,.blue .rbc-toolbar button:active:hover,.blue .rbc-toolbar button:focus,.blue .rbc-toolbar button:hover{background-color:rgba(33,150,243,.9);border-color:#2196f3}.blue .rbc-day-slot .rbc-event{border-color:#2196f3}.blue .chat-sidenav-title{color:#2196f3}.blue .chat-user-item.active,.blue .chat-user-item:hover{background-color:#e3f2fd}.blue .contact-list i{color:#2196f3}.blue .Collapsible__trigger{background:#2196f3}.blue .categories-list li.active a,.blue .categories-list li a:focus,.blue .categories-list li a:hover{color:#2196f3}.blue .filter-with-bg-color ul li a,.blue .login-content .form-control:focus{border-color:#2196f3}.blue .filter-with-bg-color ul li a.active,.blue .filter-with-bg-color ul li a:focus,.blue .filter-with-bg-color ul li a:hover{background-color:#2196f3}.blue .profile-intro .icon{color:#2196f3}.blue .actions,.blue .social-link li.active a,.blue .social-link li a:focus,.blue .social-link li a:hover{color:#ff6e40}.blue .table-hover tbody tr:hover{background-color:rgba(33,150,243,.075)}.blue .border-primary{border-color:#2196f3!important}.blue .app-logo-content{background-color:#2196f3}.blue .app-social-block .social-link button{border:1px solid #2196f3;color:#2196f3}.blue .app-social-block .social-link button:focus,.blue .app-social-block .social-link button:hover{color:#fff;background-color:#2196f3}.blue .btn-group-vertical>.btn-default.active,.blue .btn-group-vertical>.jr-btn.active,.blue .btn-group>.btn-default.active,.blue .btn-group>.jr-btn.active{background-color:#2196f3;border-color:#2196f3}.blue .btn-group-vertical>.jr-flat-btn,.blue .btn-group>.jr-flat-btn{border-color:transparent}.blue .btn-group-vertical>.jr-flat-btn.active,.blue .btn-group>.jr-flat-btn.active{background-color:transparent;color:#2196f3!important;border-color:transparent!important}.blue .btn-group-vertical>.jr-flat-btn.active:focus,.blue .btn-group-vertical>.jr-flat-btn.active:hover,.blue .btn-group>.jr-flat-btn.active:focus,.blue .btn-group>.jr-flat-btn.active:hover{background-color:rgba(33,150,243,.12)!important;color:#2196f3!important}.blue .nav-pill-sales .nav-link.active{background-color:#2196f3;border-color:#2196f3}.blue .form-checkbox>input+.check,.blue .form-checkbox>input.sm+.check{color:#2196f3}.deep-purple .right-arrow,.deep-purple .right-arrow:after{color:#673ab7}.deep-purple .btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.deep-purple .btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.deep-purple .btn-primary.focus,.deep-purple .btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.deep-purple .btn-primary.disabled,.deep-purple .btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.deep-purple .btn-primary:not(:disabled):not(.disabled).active,.deep-purple .btn-primary:not(:disabled):not(.disabled):active,.show>.deep-purple .btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.deep-purple .btn-primary:not(:disabled):not(.disabled).active:focus,.deep-purple .btn-primary:not(:disabled):not(.disabled):active:focus,.show>.deep-purple .btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.deep-purple .btn-secondary{background-color:#e91e63;border-color:#e91e63;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.deep-purple .btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.deep-purple .btn-secondary.focus,.deep-purple .btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.deep-purple .btn-secondary.disabled,.deep-purple .btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.deep-purple .btn-secondary:not(:disabled):not(.disabled).active,.deep-purple .btn-secondary:not(:disabled):not(.disabled):active,.show>.deep-purple .btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.deep-purple .btn-secondary:not(:disabled):not(.disabled).active:focus,.deep-purple .btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.deep-purple .btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.deep-purple .btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.deep-purple .btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.deep-purple .btn-success.focus,.deep-purple .btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.deep-purple .btn-success.disabled,.deep-purple .btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.deep-purple .btn-success:not(:disabled):not(.disabled).active,.deep-purple .btn-success:not(:disabled):not(.disabled):active,.show>.deep-purple .btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.deep-purple .btn-success:not(:disabled):not(.disabled).active:focus,.deep-purple .btn-success:not(:disabled):not(.disabled):active:focus,.show>.deep-purple .btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.deep-purple .btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.deep-purple .btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.deep-purple .btn-info.focus,.deep-purple .btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.deep-purple .btn-info.disabled,.deep-purple .btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.deep-purple .btn-info:not(:disabled):not(.disabled).active,.deep-purple .btn-info:not(:disabled):not(.disabled):active,.show>.deep-purple .btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.deep-purple .btn-info:not(:disabled):not(.disabled).active:focus,.deep-purple .btn-info:not(:disabled):not(.disabled):active:focus,.show>.deep-purple .btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.deep-purple .btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.deep-purple .btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.deep-purple .btn-warning.focus,.deep-purple .btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.deep-purple .btn-warning.disabled,.deep-purple .btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.deep-purple .btn-warning:not(:disabled):not(.disabled).active,.deep-purple .btn-warning:not(:disabled):not(.disabled):active,.show>.deep-purple .btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.deep-purple .btn-warning:not(:disabled):not(.disabled).active:focus,.deep-purple .btn-warning:not(:disabled):not(.disabled):active:focus,.show>.deep-purple .btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.deep-purple .btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.deep-purple .btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.deep-purple .btn-danger.focus,.deep-purple .btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.deep-purple .btn-danger.disabled,.deep-purple .btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.deep-purple .btn-danger:not(:disabled):not(.disabled).active,.deep-purple .btn-danger:not(:disabled):not(.disabled):active,.show>.deep-purple .btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.deep-purple .btn-danger:not(:disabled):not(.disabled).active:focus,.deep-purple .btn-danger:not(:disabled):not(.disabled):active:focus,.show>.deep-purple .btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.deep-purple .btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.deep-purple .btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.deep-purple .btn-light.focus,.deep-purple .btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.deep-purple .btn-light.disabled,.deep-purple .btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.deep-purple .btn-light:not(:disabled):not(.disabled).active,.deep-purple .btn-light:not(:disabled):not(.disabled):active,.show>.deep-purple .btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.deep-purple .btn-light:not(:disabled):not(.disabled).active:focus,.deep-purple .btn-light:not(:disabled):not(.disabled):active:focus,.show>.deep-purple .btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.deep-purple .btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.deep-purple .btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.deep-purple .btn-dark.focus,.deep-purple .btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.deep-purple .btn-dark.disabled,.deep-purple .btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.deep-purple .btn-dark:not(:disabled):not(.disabled).active,.deep-purple .btn-dark:not(:disabled):not(.disabled):active,.show>.deep-purple .btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.deep-purple .btn-dark:not(:disabled):not(.disabled).active:focus,.deep-purple .btn-dark:not(:disabled):not(.disabled):active:focus,.show>.deep-purple .btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.deep-purple a.btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.deep-purple a.btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.deep-purple a.btn-primary.focus,.deep-purple a.btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.deep-purple a.btn-primary.disabled,.deep-purple a.btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.deep-purple a.btn-primary:not(:disabled):not(.disabled).active,.deep-purple a.btn-primary:not(:disabled):not(.disabled):active,.show>.deep-purple a.btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.deep-purple a.btn-primary:not(:disabled):not(.disabled).active:focus,.deep-purple a.btn-primary:not(:disabled):not(.disabled):active:focus,.show>.deep-purple a.btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.deep-purple a.btn-secondary{color:#fff;background-color:#e91e63;border-color:#e91e63;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.deep-purple a.btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.deep-purple a.btn-secondary.focus,.deep-purple a.btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.deep-purple a.btn-secondary.disabled,.deep-purple a.btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.deep-purple a.btn-secondary:not(:disabled):not(.disabled).active,.deep-purple a.btn-secondary:not(:disabled):not(.disabled):active,.show>.deep-purple a.btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.deep-purple a.btn-secondary:not(:disabled):not(.disabled).active:focus,.deep-purple a.btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.deep-purple a.btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.deep-purple a.btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.deep-purple a.btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.deep-purple a.btn-success.focus,.deep-purple a.btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.deep-purple a.btn-success.disabled,.deep-purple a.btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.deep-purple a.btn-success:not(:disabled):not(.disabled).active,.deep-purple a.btn-success:not(:disabled):not(.disabled):active,.show>.deep-purple a.btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.deep-purple a.btn-success:not(:disabled):not(.disabled).active:focus,.deep-purple a.btn-success:not(:disabled):not(.disabled):active:focus,.show>.deep-purple a.btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.deep-purple a.btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.deep-purple a.btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.deep-purple a.btn-info.focus,.deep-purple a.btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.deep-purple a.btn-info.disabled,.deep-purple a.btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.deep-purple a.btn-info:not(:disabled):not(.disabled).active,.deep-purple a.btn-info:not(:disabled):not(.disabled):active,.show>.deep-purple a.btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.deep-purple a.btn-info:not(:disabled):not(.disabled).active:focus,.deep-purple a.btn-info:not(:disabled):not(.disabled):active:focus,.show>.deep-purple a.btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.deep-purple a.btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.deep-purple a.btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.deep-purple a.btn-warning.focus,.deep-purple a.btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.deep-purple a.btn-warning.disabled,.deep-purple a.btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.deep-purple a.btn-warning:not(:disabled):not(.disabled).active,.deep-purple a.btn-warning:not(:disabled):not(.disabled):active,.show>.deep-purple a.btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.deep-purple a.btn-warning:not(:disabled):not(.disabled).active:focus,.deep-purple a.btn-warning:not(:disabled):not(.disabled):active:focus,.show>.deep-purple a.btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.deep-purple a.btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.deep-purple a.btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.deep-purple a.btn-danger.focus,.deep-purple a.btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.deep-purple a.btn-danger.disabled,.deep-purple a.btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.deep-purple a.btn-danger:not(:disabled):not(.disabled).active,.deep-purple a.btn-danger:not(:disabled):not(.disabled):active,.show>.deep-purple a.btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.deep-purple a.btn-danger:not(:disabled):not(.disabled).active:focus,.deep-purple a.btn-danger:not(:disabled):not(.disabled):active:focus,.show>.deep-purple a.btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.deep-purple a.btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.deep-purple a.btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.deep-purple a.btn-light.focus,.deep-purple a.btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.deep-purple a.btn-light.disabled,.deep-purple a.btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.deep-purple a.btn-light:not(:disabled):not(.disabled).active,.deep-purple a.btn-light:not(:disabled):not(.disabled):active,.show>.deep-purple a.btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.deep-purple a.btn-light:not(:disabled):not(.disabled).active:focus,.deep-purple a.btn-light:not(:disabled):not(.disabled):active:focus,.show>.deep-purple a.btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.deep-purple a.btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.deep-purple a.btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.deep-purple a.btn-dark.focus,.deep-purple a.btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.deep-purple a.btn-dark.disabled,.deep-purple a.btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.deep-purple a.btn-dark:not(:disabled):not(.disabled).active,.deep-purple a.btn-dark:not(:disabled):not(.disabled):active,.show>.deep-purple a.btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.deep-purple a.btn-dark:not(:disabled):not(.disabled).active:focus,.deep-purple a.btn-dark:not(:disabled):not(.disabled):active:focus,.show>.deep-purple a.btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.deep-purple .btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.deep-purple .btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.deep-purple .btn-outline-primary.focus,.deep-purple .btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.deep-purple .btn-outline-primary.disabled,.deep-purple .btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.deep-purple .btn-outline-primary:not(:disabled):not(.disabled).active,.deep-purple .btn-outline-primary:not(:disabled):not(.disabled):active,.show>.deep-purple .btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.deep-purple .btn-outline-primary:not(:disabled):not(.disabled).active:focus,.deep-purple .btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.deep-purple .btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.deep-purple .btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.deep-purple .btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.deep-purple .btn-outline-secondary.focus,.deep-purple .btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.deep-purple .btn-outline-secondary.disabled,.deep-purple .btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.deep-purple .btn-outline-secondary:not(:disabled):not(.disabled).active,.deep-purple .btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.deep-purple .btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.deep-purple .btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.deep-purple .btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.deep-purple .btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.deep-purple .btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.deep-purple .btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.deep-purple .btn-outline-success.focus,.deep-purple .btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.deep-purple .btn-outline-success.disabled,.deep-purple .btn-outline-success:disabled{color:#4caf50;background-color:transparent}.deep-purple .btn-outline-success:not(:disabled):not(.disabled).active,.deep-purple .btn-outline-success:not(:disabled):not(.disabled):active,.show>.deep-purple .btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.deep-purple .btn-outline-success:not(:disabled):not(.disabled).active:focus,.deep-purple .btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.deep-purple .btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.deep-purple .btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.deep-purple .btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.deep-purple .btn-outline-info.focus,.deep-purple .btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.deep-purple .btn-outline-info.disabled,.deep-purple .btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.deep-purple .btn-outline-info:not(:disabled):not(.disabled).active,.deep-purple .btn-outline-info:not(:disabled):not(.disabled):active,.show>.deep-purple .btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.deep-purple .btn-outline-info:not(:disabled):not(.disabled).active:focus,.deep-purple .btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.deep-purple .btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.deep-purple .btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.deep-purple .btn-outline-warning:hover{color:#fff;background-color:#ff9800;border-color:#ff9800}.deep-purple .btn-outline-warning.focus,.deep-purple .btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.deep-purple .btn-outline-warning.disabled,.deep-purple .btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.deep-purple .btn-outline-warning:not(:disabled):not(.disabled).active,.deep-purple .btn-outline-warning:not(:disabled):not(.disabled):active,.show>.deep-purple .btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.deep-purple .btn-outline-warning:not(:disabled):not(.disabled).active:focus,.deep-purple .btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.deep-purple .btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.deep-purple .btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.deep-purple .btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.deep-purple .btn-outline-danger.focus,.deep-purple .btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.deep-purple .btn-outline-danger.disabled,.deep-purple .btn-outline-danger:disabled{color:#f44336;background-color:transparent}.deep-purple .btn-outline-danger:not(:disabled):not(.disabled).active,.deep-purple .btn-outline-danger:not(:disabled):not(.disabled):active,.show>.deep-purple .btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.deep-purple .btn-outline-danger:not(:disabled):not(.disabled).active:focus,.deep-purple .btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.deep-purple .btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.deep-purple .btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.deep-purple .btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.deep-purple .btn-outline-light.focus,.deep-purple .btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.deep-purple .btn-outline-light.disabled,.deep-purple .btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.deep-purple .btn-outline-light:not(:disabled):not(.disabled).active,.deep-purple .btn-outline-light:not(:disabled):not(.disabled):active,.show>.deep-purple .btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.deep-purple .btn-outline-light:not(:disabled):not(.disabled).active:focus,.deep-purple .btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.deep-purple .btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.deep-purple .btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.deep-purple .btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.deep-purple .btn-outline-dark.focus,.deep-purple .btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.deep-purple .btn-outline-dark.disabled,.deep-purple .btn-outline-dark:disabled{color:#343a40;background-color:transparent}.deep-purple .btn-outline-dark:not(:disabled):not(.disabled).active,.deep-purple .btn-outline-dark:not(:disabled):not(.disabled):active,.show>.deep-purple .btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.deep-purple .btn-outline-dark:not(:disabled):not(.disabled).active:focus,.deep-purple .btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.deep-purple .btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.deep-purple a.btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.deep-purple a.btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.deep-purple a.btn-outline-primary.focus,.deep-purple a.btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.deep-purple a.btn-outline-primary.disabled,.deep-purple a.btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.deep-purple a.btn-outline-primary:not(:disabled):not(.disabled).active,.deep-purple a.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.deep-purple a.btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.deep-purple a.btn-outline-primary:not(:disabled):not(.disabled).active:focus,.deep-purple a.btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.deep-purple a.btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.deep-purple a.btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.deep-purple a.btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.deep-purple a.btn-outline-secondary.focus,.deep-purple a.btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.deep-purple a.btn-outline-secondary.disabled,.deep-purple a.btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.deep-purple a.btn-outline-secondary:not(:disabled):not(.disabled).active,.deep-purple a.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.deep-purple a.btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.deep-purple a.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.deep-purple a.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.deep-purple a.btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.deep-purple a.btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.deep-purple a.btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.deep-purple a.btn-outline-success.focus,.deep-purple a.btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.deep-purple a.btn-outline-success.disabled,.deep-purple a.btn-outline-success:disabled{color:#4caf50;background-color:transparent}.deep-purple a.btn-outline-success:not(:disabled):not(.disabled).active,.deep-purple a.btn-outline-success:not(:disabled):not(.disabled):active,.show>.deep-purple a.btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.deep-purple a.btn-outline-success:not(:disabled):not(.disabled).active:focus,.deep-purple a.btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.deep-purple a.btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.deep-purple a.btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.deep-purple a.btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.deep-purple a.btn-outline-info.focus,.deep-purple a.btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.deep-purple a.btn-outline-info.disabled,.deep-purple a.btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.deep-purple a.btn-outline-info:not(:disabled):not(.disabled).active,.deep-purple a.btn-outline-info:not(:disabled):not(.disabled):active,.show>.deep-purple a.btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.deep-purple a.btn-outline-info:not(:disabled):not(.disabled).active:focus,.deep-purple a.btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.deep-purple a.btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.deep-purple a.btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.deep-purple a.btn-outline-warning:hover{color:#fff;background-color:#ff9800;border-color:#ff9800}.deep-purple a.btn-outline-warning.focus,.deep-purple a.btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.deep-purple a.btn-outline-warning.disabled,.deep-purple a.btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.deep-purple a.btn-outline-warning:not(:disabled):not(.disabled).active,.deep-purple a.btn-outline-warning:not(:disabled):not(.disabled):active,.show>.deep-purple a.btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.deep-purple a.btn-outline-warning:not(:disabled):not(.disabled).active:focus,.deep-purple a.btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.deep-purple a.btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.deep-purple a.btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.deep-purple a.btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.deep-purple a.btn-outline-danger.focus,.deep-purple a.btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.deep-purple a.btn-outline-danger.disabled,.deep-purple a.btn-outline-danger:disabled{color:#f44336;background-color:transparent}.deep-purple a.btn-outline-danger:not(:disabled):not(.disabled).active,.deep-purple a.btn-outline-danger:not(:disabled):not(.disabled):active,.show>.deep-purple a.btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.deep-purple a.btn-outline-danger:not(:disabled):not(.disabled).active:focus,.deep-purple a.btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.deep-purple a.btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.deep-purple a.btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.deep-purple a.btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.deep-purple a.btn-outline-light.focus,.deep-purple a.btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.deep-purple a.btn-outline-light.disabled,.deep-purple a.btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.deep-purple a.btn-outline-light:not(:disabled):not(.disabled).active,.deep-purple a.btn-outline-light:not(:disabled):not(.disabled):active,.show>.deep-purple a.btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.deep-purple a.btn-outline-light:not(:disabled):not(.disabled).active:focus,.deep-purple a.btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.deep-purple a.btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.deep-purple a.btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.deep-purple a.btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.deep-purple a.btn-outline-dark.focus,.deep-purple a.btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.deep-purple a.btn-outline-dark.disabled,.deep-purple a.btn-outline-dark:disabled{color:#343a40;background-color:transparent}.deep-purple a.btn-outline-dark:not(:disabled):not(.disabled).active,.deep-purple a.btn-outline-dark:not(:disabled):not(.disabled):active,.show>.deep-purple a.btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.deep-purple a.btn-outline-dark:not(:disabled):not(.disabled).active:focus,.deep-purple a.btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.deep-purple a.btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.deep-purple .btn-outline-primary,.deep-purple a.btn-outline-primary{color:#673ab7;border-color:#673ab7}.deep-purple .btn-outline-primary.disabled,.deep-purple .btn-outline-primary:disabled,.deep-purple .btn-outline-primary:focus,.deep-purple .btn-outline-primary:hover,.deep-purple .btn-outline-primary:not(:disabled):not(.disabled).active,.deep-purple .btn-outline-primary:not(:disabled):not(.disabled):active,.deep-purple a.btn-outline-primary.disabled,.deep-purple a.btn-outline-primary:disabled,.deep-purple a.btn-outline-primary:focus,.deep-purple a.btn-outline-primary:hover,.deep-purple a.btn-outline-primary:not(:disabled):not(.disabled).active,.deep-purple a.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.deep-purple .btn-outline-primary.dropdown-toggle,.show>.deep-purple a.btn-outline-primary.dropdown-toggle{color:#fff;border-color:#673ab7;background-color:#673ab7}.deep-purple .btn-outline-secondary,.deep-purple a.btn-outline-secondary{color:#ffab00;border-color:#ffab00}.deep-purple .btn-outline-secondary.disabled,.deep-purple .btn-outline-secondary:disabled,.deep-purple .btn-outline-secondary:focus,.deep-purple .btn-outline-secondary:hover,.deep-purple .btn-outline-secondary:not(:disabled):not(.disabled).active,.deep-purple .btn-outline-secondary:not(:disabled):not(.disabled):active,.deep-purple a.btn-outline-secondary.disabled,.deep-purple a.btn-outline-secondary:disabled,.deep-purple a.btn-outline-secondary:focus,.deep-purple a.btn-outline-secondary:hover,.deep-purple a.btn-outline-secondary:not(:disabled):not(.disabled).active,.deep-purple a.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.deep-purple .btn-outline-secondary.dropdown-toggle,.show>.deep-purple a.btn-outline-secondary.dropdown-toggle{color:#fff;border-color:#ffab00;background-color:#ffab00}.deep-purple a,.deep-purple a.text-primary{color:#673ab7}.deep-purple a.text-primary:focus,.deep-purple a.text-primary:hover,.deep-purple a:focus,.deep-purple a:hover{color:#512e90}.deep-purple .text-primary{color:#673ab7!important}.deep-purple .page-link,.deep-purple .page-link:focus,.deep-purple .page-link:hover{color:#673ab7}.deep-purple .badge-primary,.deep-purple .bg-primary{background-color:#673ab7!important;color:#fff!important}.deep-purple .btn-primary,.deep-purple .jr-btn-primary,.deep-purple a.btn-primary,.deep-purple a.jr-btn-primary{background-color:#673ab7;border-color:#673ab7;color:#fff}.deep-purple .btn-primary:focus,.deep-purple .btn-primary:hover,.deep-purple .btn-primary:not([disabled]):not(.disabled):active,.deep-purple .jr-btn-primary:focus,.deep-purple .jr-btn-primary:hover,.deep-purple .jr-btn-primary:not([disabled]):not(.disabled):active,.deep-purple a.btn-primary:focus,.deep-purple a.btn-primary:hover,.deep-purple a.btn-primary:not([disabled]):not(.disabled):active,.deep-purple a.jr-btn-primary:focus,.deep-purple a.jr-btn-primary:hover,.deep-purple a.jr-btn-primary:not([disabled]):not(.disabled):active{background-color:#5c34a4!important;border-color:#5c34a4!important;color:#fff!important}.deep-purple .bg-primary.lighten-4{background-color:#d1c4e9!important}.deep-purple .bg-primary.lighten-3{background-color:#b39ddb!important}.deep-purple .bg-primary.lighten-2{background-color:#9575cd!important}.deep-purple .bg-primary.lighten-1{background-color:#7e57c2!important}.deep-purple .bg-primary.darken-1{background-color:#5e35b1!important}.deep-purple .bg-primary.darken-2{background-color:#512da8!important}.deep-purple .bg-primary.darken-3{background-color:#4527a0!important}.deep-purple .bg-primary.darken-4{background-color:#311b92!important}.deep-purple .bg-primary.accent-1{background-color:#b388ff!important}.deep-purple .bg-primary.accent-2{background-color:#7c4dff!important}.deep-purple .bg-primary.accent-3{background-color:#651fff!important}.deep-purple .bg-primary.accent-4{background-color:#6200ea!important}.deep-purple a.text-secondary{color:#ffab00}.deep-purple a.text-secondary:focus,.deep-purple a.text-secondary:hover{color:#cc8900!important}.deep-purple .text-secondary{color:#ffab00!important}.deep-purple .badge-secondary,.deep-purple .bg-secondary{background-color:#ffab00!important;color:#fff!important}.deep-purple .btn-secondary{background-color:#ffab00;border-color:#ffab00;color:#fff}.deep-purple .btn-secondary:active,.deep-purple .btn-secondary:focus,.deep-purple .btn-secondary:hover{background-color:#e69a00!important;border-color:#e69a00!important;color:#fff!important}.deep-purple .jr-flat-btn{background-color:transparent!important;color:#5c5c5c!important}.deep-purple .jr-flat-btn:active,.deep-purple .jr-flat-btn:focus,.deep-purple .jr-flat-btn:hover{background-color:#f5f5f5!important;color:#5c5c5c!important}.deep-purple .jr-flat-btn.jr-btn-primary{background-color:transparent!important;color:#673ab7!important;border-color:transparent!important}.deep-purple .jr-flat-btn.jr-btn-primary:focus,.deep-purple .jr-flat-btn.jr-btn-primary:hover{background-color:rgba(103,58,183,.12)!important;color:#673ab7!important}.deep-purple .bg-primary .jr-flat-btn.jr-btn-primary{background-color:transparent!important;color:#fff!important;border-color:transparent!important}.deep-purple .bg-primary .jr-flat-btn.jr-btn-primary:focus,.deep-purple .bg-primary .jr-flat-btn.jr-btn-primary:hover{background-color:hsla(0,0%,100%,.12)!important;color:#fff!important}.deep-purple .jr-flat-btn.jr-btn-secondary{background-color:transparent!important;color:#ffab00!important;border-color:transparent!important}.deep-purple .jr-flat-btn.jr-btn-secondary:focus,.deep-purple .jr-flat-btn.jr-btn-secondary:hover{background-color:rgba(255,171,0,.12)!important;color:#ffab00!important}.deep-purple .bg-secondary .jr-flat-btn.jr-btn-secondary{background-color:transparent!important;color:#fff!important;border-color:transparent!important}.deep-purple .bg-secondary .jr-flat-btn.jr-btn-secondary:focus,.deep-purple .bg-secondary .jr-flat-btn.jr-btn-secondary:hover{background-color:hsla(0,0%,100%,.12)!important;color:#fff!important}@media screen and (max-width:575px){.deep-purple .app-main-header .search-dropdown input{background-color:#fff}}.deep-purple .color-theme-header{background-color:#673ab7}.deep-purple .side-nav{background-color:#fff!important;color:#868e96!important}.deep-purple .side-nav .user-profile{background-color:#f8f9fa;position:relative;z-index:2}.deep-purple .side-nav .user-profile .text-white{color:#673ab7!important}.deep-purple .side-nav .customizer{border-bottom:1px solid #e6e7e9}.deep-purple .side-nav .user-detail .user-name{color:#673ab7}.deep-purple ul.nav-menu .nav-header,.deep-purple ul.nav-menu li a{color:#868e96}.deep-purple ul.nav-menu>li.open>a,.deep-purple ul.nav-menu>li>a:focus,.deep-purple ul.nav-menu>li>a:hover{background-color:#fff;color:#673ab7}.deep-purple ul.nav-menu li.menu>a:focus:before,.deep-purple ul.nav-menu li.menu>a:hover:before{color:#673ab7}.deep-purple ul.nav-menu li ul{background-color:#fff}.deep-purple ul.nav-menu li.menu>a:before{color:#868e96}.deep-purple ul.nav-menu li.menu.open>a:before,.deep-purple ul.nav-menu li.menu>a:focus:before,.deep-purple ul.nav-menu li.menu li>a:hover:before{color:#673ab7}.deep-purple ul.nav-menu li.menu .sub-menu li>a:before{color:#868e96}.deep-purple ul.nav-menu li.menu .sub-menu li>a.active .nav-text{background-color:#673ab7}.deep-purple ul.nav-menu li.menu.open .sub-menu li>a.active:before,.deep-purple ul.nav-menu li.menu .sub-menu li>a:focus,.deep-purple ul.nav-menu li.menu .sub-menu li>a:focus:before,.deep-purple ul.nav-menu li.menu .sub-menu li>a:hover,.deep-purple ul.nav-menu li.menu .sub-menu li>a:hover:before{background-color:#fff;color:#673ab7}.deep-purple .navbar-nav li:focus>a,.deep-purple .navbar-nav li:hover>a{color:#673ab7}.deep-purple .navbar-nav li a{color:#868e96}.deep-purple .navbar-nav li.nav-item.active>a,.deep-purple .navbar-nav li a:focus,.deep-purple .navbar-nav li a:hover,.deep-purple .navbar-nav ul.sub-menu li.active>a,.deep-purple .navbar-nav ul.sub-menu li a.active{color:#673ab7}.deep-purple .navbar-nav .nav-arrow>a:before{color:#868e96}.deep-purple .navbar-nav .nav-arrow.active>a:before,.deep-purple .navbar-nav .nav-arrow:focus>a:before,.deep-purple .navbar-nav .nav-arrow:hover>a:before,.deep-purple .navbar-nav .nav-arrow a:focus:before,.deep-purple .navbar-nav .nav-arrow a:hover:before{color:#673ab7}.deep-purple .app-top-nav{background-color:#673ab7}.deep-purple .app-top-nav .navbar-nav li.nav-item>a{color:#fff}.deep-purple .app-top-nav .navbar-nav li.nav-item.active>a,.deep-purple .app-top-nav .navbar-nav li.nav-item:focus>a,.deep-purple .app-top-nav .navbar-nav li.nav-item:hover>a,.deep-purple .app-top-nav .navbar-nav li.nav-item>a:focus,.deep-purple .app-top-nav .navbar-nav li.nav-item>a:hover{color:#ffab00}.deep-purple .module-nav li a.active{border-color:#673ab7}.deep-purple .rbc-event{background-color:#673ab7}.deep-purple .rbc-event.rbc-selected{background-color:#512e90}.deep-purple .rbc-slot-selection{background-color:rgba(103,58,183,.7)}.deep-purple .rbc-toolbar button.rbc-active,.deep-purple .rbc-toolbar button.rbc-active:focus,.deep-purple .rbc-toolbar button.rbc-active:hover,.deep-purple .rbc-toolbar button:active,.deep-purple .rbc-toolbar button:active:focus,.deep-purple .rbc-toolbar button:active:hover,.deep-purple .rbc-toolbar button:focus,.deep-purple .rbc-toolbar button:hover{background-color:rgba(103,58,183,.9);border-color:#673ab7}.deep-purple .rbc-day-slot .rbc-event{border-color:#673ab7}.deep-purple .chat-sidenav-title{color:#673ab7}.deep-purple .chat-user-item.active,.deep-purple .chat-user-item:hover{background-color:#e8e1f5}.deep-purple .contact-list i{color:#673ab7}.deep-purple .Collapsible__trigger{background:#673ab7}.deep-purple .categories-list li.active a,.deep-purple .categories-list li a:focus,.deep-purple .categories-list li a:hover{color:#673ab7}.deep-purple .filter-with-bg-color ul li a,.deep-purple .login-content .form-control:focus{border-color:#673ab7}.deep-purple .filter-with-bg-color ul li a.active,.deep-purple .filter-with-bg-color ul li a:focus,.deep-purple .filter-with-bg-color ul li a:hover{background-color:#673ab7}.deep-purple .profile-intro .icon{color:#673ab7}.deep-purple .actions,.deep-purple .social-link li.active a,.deep-purple .social-link li a:focus,.deep-purple .social-link li a:hover{color:#ffab00}.deep-purple .table-hover tbody tr:hover{background-color:rgba(103,58,183,.075)}.deep-purple .border-primary{border-color:#673ab7!important}.deep-purple .app-logo-content{background-color:#673ab7}.deep-purple .app-social-block .social-link button{border:1px solid #673ab7;color:#673ab7}.deep-purple .app-social-block .social-link button:focus,.deep-purple .app-social-block .social-link button:hover{color:#fff;background-color:#673ab7}.deep-purple .btn-group-vertical>.btn-default.active,.deep-purple .btn-group-vertical>.jr-btn.active,.deep-purple .btn-group>.btn-default.active,.deep-purple .btn-group>.jr-btn.active{background-color:#673ab7;border-color:#673ab7}.deep-purple .btn-group-vertical>.jr-flat-btn,.deep-purple .btn-group>.jr-flat-btn{border-color:transparent}.deep-purple .btn-group-vertical>.jr-flat-btn.active,.deep-purple .btn-group>.jr-flat-btn.active{background-color:transparent;color:#673ab7!important;border-color:transparent!important}.deep-purple .btn-group-vertical>.jr-flat-btn.active:focus,.deep-purple .btn-group-vertical>.jr-flat-btn.active:hover,.deep-purple .btn-group>.jr-flat-btn.active:focus,.deep-purple .btn-group>.jr-flat-btn.active:hover{background-color:rgba(103,58,183,.12)!important;color:#673ab7!important}.deep-purple .nav-pill-sales .nav-link.active{background-color:#673ab7;border-color:#673ab7}.deep-purple .form-checkbox>input+.check,.deep-purple .form-checkbox>input.sm+.check{color:#673ab7}.green .right-arrow,.green .right-arrow:after{color:#4caf50}.green .btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.green .btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.green .btn-primary.focus,.green .btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.green .btn-primary.disabled,.green .btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.green .btn-primary:not(:disabled):not(.disabled).active,.green .btn-primary:not(:disabled):not(.disabled):active,.show>.green .btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.green .btn-primary:not(:disabled):not(.disabled).active:focus,.green .btn-primary:not(:disabled):not(.disabled):active:focus,.show>.green .btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.green .btn-secondary{background-color:#e91e63;border-color:#e91e63;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.green .btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.green .btn-secondary.focus,.green .btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.green .btn-secondary.disabled,.green .btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.green .btn-secondary:not(:disabled):not(.disabled).active,.green .btn-secondary:not(:disabled):not(.disabled):active,.show>.green .btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.green .btn-secondary:not(:disabled):not(.disabled).active:focus,.green .btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.green .btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.green .btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.green .btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.green .btn-success.focus,.green .btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.green .btn-success.disabled,.green .btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.green .btn-success:not(:disabled):not(.disabled).active,.green .btn-success:not(:disabled):not(.disabled):active,.show>.green .btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.green .btn-success:not(:disabled):not(.disabled).active:focus,.green .btn-success:not(:disabled):not(.disabled):active:focus,.show>.green .btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.green .btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.green .btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.green .btn-info.focus,.green .btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.green .btn-info.disabled,.green .btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.green .btn-info:not(:disabled):not(.disabled).active,.green .btn-info:not(:disabled):not(.disabled):active,.show>.green .btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.green .btn-info:not(:disabled):not(.disabled).active:focus,.green .btn-info:not(:disabled):not(.disabled):active:focus,.show>.green .btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.green .btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.green .btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.green .btn-warning.focus,.green .btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.green .btn-warning.disabled,.green .btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.green .btn-warning:not(:disabled):not(.disabled).active,.green .btn-warning:not(:disabled):not(.disabled):active,.show>.green .btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.green .btn-warning:not(:disabled):not(.disabled).active:focus,.green .btn-warning:not(:disabled):not(.disabled):active:focus,.show>.green .btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.green .btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.green .btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.green .btn-danger.focus,.green .btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.green .btn-danger.disabled,.green .btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.green .btn-danger:not(:disabled):not(.disabled).active,.green .btn-danger:not(:disabled):not(.disabled):active,.show>.green .btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.green .btn-danger:not(:disabled):not(.disabled).active:focus,.green .btn-danger:not(:disabled):not(.disabled):active:focus,.show>.green .btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.green .btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.green .btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.green .btn-light.focus,.green .btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.green .btn-light.disabled,.green .btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.green .btn-light:not(:disabled):not(.disabled).active,.green .btn-light:not(:disabled):not(.disabled):active,.show>.green .btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.green .btn-light:not(:disabled):not(.disabled).active:focus,.green .btn-light:not(:disabled):not(.disabled):active:focus,.show>.green .btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.green .btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.green .btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.green .btn-dark.focus,.green .btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.green .btn-dark.disabled,.green .btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.green .btn-dark:not(:disabled):not(.disabled).active,.green .btn-dark:not(:disabled):not(.disabled):active,.show>.green .btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.green .btn-dark:not(:disabled):not(.disabled).active:focus,.green .btn-dark:not(:disabled):not(.disabled):active:focus,.show>.green .btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.green a.btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.green a.btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.green a.btn-primary.focus,.green a.btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.green a.btn-primary.disabled,.green a.btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.green a.btn-primary:not(:disabled):not(.disabled).active,.green a.btn-primary:not(:disabled):not(.disabled):active,.show>.green a.btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.green a.btn-primary:not(:disabled):not(.disabled).active:focus,.green a.btn-primary:not(:disabled):not(.disabled):active:focus,.show>.green a.btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.green a.btn-secondary{color:#fff;background-color:#e91e63;border-color:#e91e63;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.green a.btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.green a.btn-secondary.focus,.green a.btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.green a.btn-secondary.disabled,.green a.btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.green a.btn-secondary:not(:disabled):not(.disabled).active,.green a.btn-secondary:not(:disabled):not(.disabled):active,.show>.green a.btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.green a.btn-secondary:not(:disabled):not(.disabled).active:focus,.green a.btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.green a.btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.green a.btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.green a.btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.green a.btn-success.focus,.green a.btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.green a.btn-success.disabled,.green a.btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.green a.btn-success:not(:disabled):not(.disabled).active,.green a.btn-success:not(:disabled):not(.disabled):active,.show>.green a.btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.green a.btn-success:not(:disabled):not(.disabled).active:focus,.green a.btn-success:not(:disabled):not(.disabled):active:focus,.show>.green a.btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.green a.btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.green a.btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.green a.btn-info.focus,.green a.btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.green a.btn-info.disabled,.green a.btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.green a.btn-info:not(:disabled):not(.disabled).active,.green a.btn-info:not(:disabled):not(.disabled):active,.show>.green a.btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.green a.btn-info:not(:disabled):not(.disabled).active:focus,.green a.btn-info:not(:disabled):not(.disabled):active:focus,.show>.green a.btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.green a.btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.green a.btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.green a.btn-warning.focus,.green a.btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.green a.btn-warning.disabled,.green a.btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.green a.btn-warning:not(:disabled):not(.disabled).active,.green a.btn-warning:not(:disabled):not(.disabled):active,.show>.green a.btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.green a.btn-warning:not(:disabled):not(.disabled).active:focus,.green a.btn-warning:not(:disabled):not(.disabled):active:focus,.show>.green a.btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.green a.btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.green a.btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.green a.btn-danger.focus,.green a.btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.green a.btn-danger.disabled,.green a.btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.green a.btn-danger:not(:disabled):not(.disabled).active,.green a.btn-danger:not(:disabled):not(.disabled):active,.show>.green a.btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.green a.btn-danger:not(:disabled):not(.disabled).active:focus,.green a.btn-danger:not(:disabled):not(.disabled):active:focus,.show>.green a.btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.green a.btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.green a.btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.green a.btn-light.focus,.green a.btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.green a.btn-light.disabled,.green a.btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.green a.btn-light:not(:disabled):not(.disabled).active,.green a.btn-light:not(:disabled):not(.disabled):active,.show>.green a.btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.green a.btn-light:not(:disabled):not(.disabled).active:focus,.green a.btn-light:not(:disabled):not(.disabled):active:focus,.show>.green a.btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.green a.btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.green a.btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.green a.btn-dark.focus,.green a.btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.green a.btn-dark.disabled,.green a.btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.green a.btn-dark:not(:disabled):not(.disabled).active,.green a.btn-dark:not(:disabled):not(.disabled):active,.show>.green a.btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.green a.btn-dark:not(:disabled):not(.disabled).active:focus,.green a.btn-dark:not(:disabled):not(.disabled):active:focus,.show>.green a.btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.green .btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.green .btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.green .btn-outline-primary.focus,.green .btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.green .btn-outline-primary.disabled,.green .btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.green .btn-outline-primary:not(:disabled):not(.disabled).active,.green .btn-outline-primary:not(:disabled):not(.disabled):active,.show>.green .btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.green .btn-outline-primary:not(:disabled):not(.disabled).active:focus,.green .btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.green .btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.green .btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.green .btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.green .btn-outline-secondary.focus,.green .btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.green .btn-outline-secondary.disabled,.green .btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.green .btn-outline-secondary:not(:disabled):not(.disabled).active,.green .btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.green .btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.green .btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.green .btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.green .btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.green .btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.green .btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.green .btn-outline-success.focus,.green .btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.green .btn-outline-success.disabled,.green .btn-outline-success:disabled{color:#4caf50;background-color:transparent}.green .btn-outline-success:not(:disabled):not(.disabled).active,.green .btn-outline-success:not(:disabled):not(.disabled):active,.show>.green .btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.green .btn-outline-success:not(:disabled):not(.disabled).active:focus,.green .btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.green .btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.green .btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.green .btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.green .btn-outline-info.focus,.green .btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.green .btn-outline-info.disabled,.green .btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.green .btn-outline-info:not(:disabled):not(.disabled).active,.green .btn-outline-info:not(:disabled):not(.disabled):active,.show>.green .btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.green .btn-outline-info:not(:disabled):not(.disabled).active:focus,.green .btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.green .btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.green .btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.green .btn-outline-warning:hover{color:#fff;background-color:#ff9800;border-color:#ff9800}.green .btn-outline-warning.focus,.green .btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.green .btn-outline-warning.disabled,.green .btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.green .btn-outline-warning:not(:disabled):not(.disabled).active,.green .btn-outline-warning:not(:disabled):not(.disabled):active,.show>.green .btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.green .btn-outline-warning:not(:disabled):not(.disabled).active:focus,.green .btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.green .btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.green .btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.green .btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.green .btn-outline-danger.focus,.green .btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.green .btn-outline-danger.disabled,.green .btn-outline-danger:disabled{color:#f44336;background-color:transparent}.green .btn-outline-danger:not(:disabled):not(.disabled).active,.green .btn-outline-danger:not(:disabled):not(.disabled):active,.show>.green .btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.green .btn-outline-danger:not(:disabled):not(.disabled).active:focus,.green .btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.green .btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.green .btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.green .btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.green .btn-outline-light.focus,.green .btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.green .btn-outline-light.disabled,.green .btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.green .btn-outline-light:not(:disabled):not(.disabled).active,.green .btn-outline-light:not(:disabled):not(.disabled):active,.show>.green .btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.green .btn-outline-light:not(:disabled):not(.disabled).active:focus,.green .btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.green .btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.green .btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.green .btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.green .btn-outline-dark.focus,.green .btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.green .btn-outline-dark.disabled,.green .btn-outline-dark:disabled{color:#343a40;background-color:transparent}.green .btn-outline-dark:not(:disabled):not(.disabled).active,.green .btn-outline-dark:not(:disabled):not(.disabled):active,.show>.green .btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.green .btn-outline-dark:not(:disabled):not(.disabled).active:focus,.green .btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.green .btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.green a.btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.green a.btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.green a.btn-outline-primary.focus,.green a.btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.green a.btn-outline-primary.disabled,.green a.btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.green a.btn-outline-primary:not(:disabled):not(.disabled).active,.green a.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.green a.btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.green a.btn-outline-primary:not(:disabled):not(.disabled).active:focus,.green a.btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.green a.btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.green a.btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.green a.btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.green a.btn-outline-secondary.focus,.green a.btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.green a.btn-outline-secondary.disabled,.green a.btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.green a.btn-outline-secondary:not(:disabled):not(.disabled).active,.green a.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.green a.btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.green a.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.green a.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.green a.btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.green a.btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.green a.btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.green a.btn-outline-success.focus,.green a.btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.green a.btn-outline-success.disabled,.green a.btn-outline-success:disabled{color:#4caf50;background-color:transparent}.green a.btn-outline-success:not(:disabled):not(.disabled).active,.green a.btn-outline-success:not(:disabled):not(.disabled):active,.show>.green a.btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.green a.btn-outline-success:not(:disabled):not(.disabled).active:focus,.green a.btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.green a.btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.green a.btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.green a.btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.green a.btn-outline-info.focus,.green a.btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.green a.btn-outline-info.disabled,.green a.btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.green a.btn-outline-info:not(:disabled):not(.disabled).active,.green a.btn-outline-info:not(:disabled):not(.disabled):active,.show>.green a.btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.green a.btn-outline-info:not(:disabled):not(.disabled).active:focus,.green a.btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.green a.btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.green a.btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.green a.btn-outline-warning:hover{color:#fff;background-color:#ff9800;border-color:#ff9800}.green a.btn-outline-warning.focus,.green a.btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.green a.btn-outline-warning.disabled,.green a.btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.green a.btn-outline-warning:not(:disabled):not(.disabled).active,.green a.btn-outline-warning:not(:disabled):not(.disabled):active,.show>.green a.btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.green a.btn-outline-warning:not(:disabled):not(.disabled).active:focus,.green a.btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.green a.btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.green a.btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.green a.btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.green a.btn-outline-danger.focus,.green a.btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.green a.btn-outline-danger.disabled,.green a.btn-outline-danger:disabled{color:#f44336;background-color:transparent}.green a.btn-outline-danger:not(:disabled):not(.disabled).active,.green a.btn-outline-danger:not(:disabled):not(.disabled):active,.show>.green a.btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.green a.btn-outline-danger:not(:disabled):not(.disabled).active:focus,.green a.btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.green a.btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.green a.btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.green a.btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.green a.btn-outline-light.focus,.green a.btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.green a.btn-outline-light.disabled,.green a.btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.green a.btn-outline-light:not(:disabled):not(.disabled).active,.green a.btn-outline-light:not(:disabled):not(.disabled):active,.show>.green a.btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.green a.btn-outline-light:not(:disabled):not(.disabled).active:focus,.green a.btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.green a.btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.green a.btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.green a.btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.green a.btn-outline-dark.focus,.green a.btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.green a.btn-outline-dark.disabled,.green a.btn-outline-dark:disabled{color:#343a40;background-color:transparent}.green a.btn-outline-dark:not(:disabled):not(.disabled).active,.green a.btn-outline-dark:not(:disabled):not(.disabled):active,.show>.green a.btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.green a.btn-outline-dark:not(:disabled):not(.disabled).active:focus,.green a.btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.green a.btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.green .btn-outline-primary,.green a.btn-outline-primary{color:#4caf50;border-color:#4caf50}.green .btn-outline-primary.disabled,.green .btn-outline-primary:disabled,.green .btn-outline-primary:focus,.green .btn-outline-primary:hover,.green .btn-outline-primary:not(:disabled):not(.disabled).active,.green .btn-outline-primary:not(:disabled):not(.disabled):active,.green a.btn-outline-primary.disabled,.green a.btn-outline-primary:disabled,.green a.btn-outline-primary:focus,.green a.btn-outline-primary:hover,.green a.btn-outline-primary:not(:disabled):not(.disabled).active,.green a.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.green .btn-outline-primary.dropdown-toggle,.show>.green a.btn-outline-primary.dropdown-toggle{color:#fff;border-color:#4caf50;background-color:#4caf50}.green .btn-outline-secondary,.green a.btn-outline-secondary{color:#ff6d00;border-color:#ff6d00}.green .btn-outline-secondary.disabled,.green .btn-outline-secondary:disabled,.green .btn-outline-secondary:focus,.green .btn-outline-secondary:hover,.green .btn-outline-secondary:not(:disabled):not(.disabled).active,.green .btn-outline-secondary:not(:disabled):not(.disabled):active,.green a.btn-outline-secondary.disabled,.green a.btn-outline-secondary:disabled,.green a.btn-outline-secondary:focus,.green a.btn-outline-secondary:hover,.green a.btn-outline-secondary:not(:disabled):not(.disabled).active,.green a.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.green .btn-outline-secondary.dropdown-toggle,.show>.green a.btn-outline-secondary.dropdown-toggle{color:#fff;border-color:#ff6d00;background-color:#ff6d00}.green a,.green a.text-primary{color:#4caf50}.green a.text-primary:focus,.green a.text-primary:hover,.green a:focus,.green a:hover{color:#3d8b40}.green .text-primary{color:#4caf50!important}.green .page-link,.green .page-link:focus,.green .page-link:hover{color:#4caf50}.green .badge-primary,.green .bg-primary{background-color:#4caf50!important;color:#fff!important}.green .btn-primary,.green .jr-btn-primary,.green a.btn-primary,.green a.jr-btn-primary{background-color:#4caf50;border-color:#4caf50;color:#fff}.green .btn-primary:focus,.green .btn-primary:hover,.green .btn-primary:not([disabled]):not(.disabled):active,.green .jr-btn-primary:focus,.green .jr-btn-primary:hover,.green .jr-btn-primary:not([disabled]):not(.disabled):active,.green a.btn-primary:focus,.green a.btn-primary:hover,.green a.btn-primary:not([disabled]):not(.disabled):active,.green a.jr-btn-primary:focus,.green a.jr-btn-primary:hover,.green a.jr-btn-primary:not([disabled]):not(.disabled):active{background-color:#449d48!important;border-color:#449d48!important;color:#fff!important}.green .bg-primary.lighten-4{background-color:#c8e6c9!important}.green .bg-primary.lighten-3{background-color:#a5d6a7!important}.green .bg-primary.lighten-2{background-color:#81c784!important}.green .bg-primary.lighten-1{background-color:#66bb6a!important}.green .bg-primary.darken-1{background-color:#43a047!important}.green .bg-primary.darken-2{background-color:#388e3c!important}.green .bg-primary.darken-3{background-color:#2e7d32!important}.green .bg-primary.darken-4{background-color:#1b5e20!important}.green .bg-primary.accent-1{background-color:#b9f6ca!important}.green .bg-primary.accent-2{background-color:#69f0ae!important}.green .bg-primary.accent-3{background-color:#00e676!important}.green .bg-primary.accent-4{background-color:#00c853!important}.green a.text-secondary{color:#ff6d00}.green a.text-secondary:focus,.green a.text-secondary:hover{color:#cc5700!important}.green .text-secondary{color:#ff6d00!important}.green .badge-secondary,.green .bg-secondary{background-color:#ff6d00!important;color:#fff!important}.green .btn-secondary{background-color:#ff6d00;border-color:#ff6d00;color:#fff}.green .btn-secondary:active,.green .btn-secondary:focus,.green .btn-secondary:hover{background-color:#e66200!important;border-color:#e66200!important;color:#fff!important}.green .jr-flat-btn{background-color:transparent!important;color:#5c5c5c!important}.green .jr-flat-btn:active,.green .jr-flat-btn:focus,.green .jr-flat-btn:hover{background-color:#f5f5f5!important;color:#5c5c5c!important}.green .jr-flat-btn.jr-btn-primary{background-color:transparent!important;color:#4caf50!important;border-color:transparent!important}.green .jr-flat-btn.jr-btn-primary:focus,.green .jr-flat-btn.jr-btn-primary:hover{background-color:rgba(76,175,80,.12)!important;color:#4caf50!important}.green .bg-primary .jr-flat-btn.jr-btn-primary{background-color:transparent!important;color:#fff!important;border-color:transparent!important}.green .bg-primary .jr-flat-btn.jr-btn-primary:focus,.green .bg-primary .jr-flat-btn.jr-btn-primary:hover{background-color:hsla(0,0%,100%,.12)!important;color:#fff!important}.green .jr-flat-btn.jr-btn-secondary{background-color:transparent!important;color:#ff6d00!important;border-color:transparent!important}.green .jr-flat-btn.jr-btn-secondary:focus,.green .jr-flat-btn.jr-btn-secondary:hover{background-color:rgba(255,109,0,.12)!important;color:#ff6d00!important}.green .bg-secondary .jr-flat-btn.jr-btn-secondary{background-color:transparent!important;color:#fff!important;border-color:transparent!important}.green .bg-secondary .jr-flat-btn.jr-btn-secondary:focus,.green .bg-secondary .jr-flat-btn.jr-btn-secondary:hover{background-color:hsla(0,0%,100%,.12)!important;color:#fff!important}@media screen and (max-width:575px){.green .app-main-header .search-dropdown input{background-color:#fff}}.green .color-theme-header{background-color:#4caf50}.green .side-nav{background-color:#fff!important;color:#868e96!important;border-right:1px solid #e9ecef!important}.green .side-nav .user-profile{background-color:#f8f9fa;position:relative;z-index:2}.green .side-nav .user-profile .text-white{color:#4caf50!important}.green .side-nav .customizer{border-bottom:1px solid #e6e7e9}.green .side-nav .user-detail .user-name{color:#4caf50}.green ul.nav-menu .nav-header,.green ul.nav-menu li a{color:#868e96}.green ul.nav-menu>li.open>a,.green ul.nav-menu>li>a:focus,.green ul.nav-menu>li>a:hover{background-color:#fff;color:#4caf50}.green ul.nav-menu li.menu>a:focus:before,.green ul.nav-menu li.menu>a:hover:before{color:#4caf50}.green ul.nav-menu li ul{background-color:#fff}.green ul.nav-menu li.menu>a:before{color:#868e96}.green ul.nav-menu li.menu.open>a:before,.green ul.nav-menu li.menu>a:focus:before,.green ul.nav-menu li.menu li>a:hover:before{color:#4caf50}.green ul.nav-menu li.menu .sub-menu li>a:before{color:#868e96}.green ul.nav-menu li.menu .sub-menu li>a.active .nav-text{background-color:#4caf50}.green ul.nav-menu li.menu.open .sub-menu li>a.active:before,.green ul.nav-menu li.menu .sub-menu li>a:focus,.green ul.nav-menu li.menu .sub-menu li>a:focus:before,.green ul.nav-menu li.menu .sub-menu li>a:hover,.green ul.nav-menu li.menu .sub-menu li>a:hover:before{background-color:#fff;color:#4caf50}.green .navbar-nav li:focus>a,.green .navbar-nav li:hover>a{color:#4caf50}.green .navbar-nav li a{color:#868e96}.green .navbar-nav li.nav-item.active>a,.green .navbar-nav li a:focus,.green .navbar-nav li a:hover,.green .navbar-nav ul.sub-menu li.active>a,.green .navbar-nav ul.sub-menu li a.active{color:#4caf50}.green .navbar-nav .nav-arrow>a:before{color:#868e96}.green .navbar-nav .nav-arrow.active>a:before,.green .navbar-nav .nav-arrow:focus>a:before,.green .navbar-nav .nav-arrow:hover>a:before,.green .navbar-nav .nav-arrow a:focus:before,.green .navbar-nav .nav-arrow a:hover:before{color:#4caf50}.green .app-top-nav{background-color:#4caf50}.green .app-top-nav .navbar-nav li.nav-item>a{color:#fff}.green .app-top-nav .navbar-nav li.nav-item.active>a,.green .app-top-nav .navbar-nav li.nav-item:focus>a,.green .app-top-nav .navbar-nav li.nav-item:hover>a,.green .app-top-nav .navbar-nav li.nav-item>a:focus,.green .app-top-nav .navbar-nav li.nav-item>a:hover{color:#ff6d00}.green .module-nav li a.active{border-color:#4caf50}.green .rbc-event{background-color:#4caf50}.green .rbc-event.rbc-selected{background-color:#3d8b40}.green .rbc-slot-selection{background-color:rgba(76,175,80,.7)}.green .rbc-toolbar button.rbc-active,.green .rbc-toolbar button.rbc-active:focus,.green .rbc-toolbar button.rbc-active:hover,.green .rbc-toolbar button:active,.green .rbc-toolbar button:active:focus,.green .rbc-toolbar button:active:hover,.green .rbc-toolbar button:focus,.green .rbc-toolbar button:hover{background-color:rgba(76,175,80,.9);border-color:#4caf50}.green .rbc-day-slot .rbc-event{border-color:#4caf50}.green .chat-sidenav-title{color:#4caf50}.green .chat-user-item.active,.green .chat-user-item:hover{background-color:#eaf6eb}.green .contact-list i{color:#4caf50}.green .Collapsible__trigger{background:#4caf50}.green .categories-list li.active a,.green .categories-list li a:focus,.green .categories-list li a:hover{color:#4caf50}.green .filter-with-bg-color ul li a,.green .login-content .form-control:focus{border-color:#4caf50}.green .filter-with-bg-color ul li a.active,.green .filter-with-bg-color ul li a:focus,.green .filter-with-bg-color ul li a:hover{background-color:#4caf50}.green .profile-intro .icon{color:#4caf50}.green .actions,.green .social-link li.active a,.green .social-link li a:focus,.green .social-link li a:hover{color:#ff6d00}.green .table-hover tbody tr:hover{background-color:rgba(76,175,80,.075)}.green .border-primary{border-color:#4caf50!important}.green .app-logo-content{background-color:#4caf50}.green .app-social-block .social-link button{border:1px solid #4caf50;color:#4caf50}.green .app-social-block .social-link button:focus,.green .app-social-block .social-link button:hover{color:#fff;background-color:#4caf50}.green .btn-group-vertical>.btn-default.active,.green .btn-group-vertical>.jr-btn.active,.green .btn-group>.btn-default.active,.green .btn-group>.jr-btn.active{background-color:#4caf50;border-color:#4caf50}.green .btn-group-vertical>.jr-flat-btn,.green .btn-group>.jr-flat-btn{border-color:transparent}.green .btn-group-vertical>.jr-flat-btn.active,.green .btn-group>.jr-flat-btn.active{background-color:transparent;color:#4caf50!important;border-color:transparent!important}.green .btn-group-vertical>.jr-flat-btn.active:focus,.green .btn-group-vertical>.jr-flat-btn.active:hover,.green .btn-group>.jr-flat-btn.active:focus,.green .btn-group>.jr-flat-btn.active:hover{background-color:rgba(76,175,80,.12)!important;color:#4caf50!important}.green .nav-pill-sales .nav-link.active{background-color:#4caf50;border-color:#4caf50}.green .form-checkbox>input+.check,.green .form-checkbox>input.sm+.check{color:#4caf50}.dark-indigo .right-arrow,.dark-indigo .right-arrow:after{color:#3f51b5}.dark-indigo .btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-indigo .btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.dark-indigo .btn-primary.focus,.dark-indigo .btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.dark-indigo .btn-primary.disabled,.dark-indigo .btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-indigo .btn-primary:not(:disabled):not(.disabled).active,.dark-indigo .btn-primary:not(:disabled):not(.disabled):active,.show>.dark-indigo .btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.dark-indigo .btn-primary:not(:disabled):not(.disabled).active:focus,.dark-indigo .btn-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-indigo .btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-indigo .btn-secondary{background-color:#e91e63;border-color:#e91e63;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-indigo .btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.dark-indigo .btn-secondary.focus,.dark-indigo .btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.dark-indigo .btn-secondary.disabled,.dark-indigo .btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-indigo .btn-secondary:not(:disabled):not(.disabled).active,.dark-indigo .btn-secondary:not(:disabled):not(.disabled):active,.show>.dark-indigo .btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.dark-indigo .btn-secondary:not(:disabled):not(.disabled).active:focus,.dark-indigo .btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-indigo .btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-indigo .btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-indigo .btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.dark-indigo .btn-success.focus,.dark-indigo .btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.dark-indigo .btn-success.disabled,.dark-indigo .btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-indigo .btn-success:not(:disabled):not(.disabled).active,.dark-indigo .btn-success:not(:disabled):not(.disabled):active,.show>.dark-indigo .btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.dark-indigo .btn-success:not(:disabled):not(.disabled).active:focus,.dark-indigo .btn-success:not(:disabled):not(.disabled):active:focus,.show>.dark-indigo .btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-indigo .btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-indigo .btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.dark-indigo .btn-info.focus,.dark-indigo .btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.dark-indigo .btn-info.disabled,.dark-indigo .btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-indigo .btn-info:not(:disabled):not(.disabled).active,.dark-indigo .btn-info:not(:disabled):not(.disabled):active,.show>.dark-indigo .btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.dark-indigo .btn-info:not(:disabled):not(.disabled).active:focus,.dark-indigo .btn-info:not(:disabled):not(.disabled):active:focus,.show>.dark-indigo .btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-indigo .btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-indigo .btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.dark-indigo .btn-warning.focus,.dark-indigo .btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.dark-indigo .btn-warning.disabled,.dark-indigo .btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-indigo .btn-warning:not(:disabled):not(.disabled).active,.dark-indigo .btn-warning:not(:disabled):not(.disabled):active,.show>.dark-indigo .btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.dark-indigo .btn-warning:not(:disabled):not(.disabled).active:focus,.dark-indigo .btn-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-indigo .btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-indigo .btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-indigo .btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.dark-indigo .btn-danger.focus,.dark-indigo .btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.dark-indigo .btn-danger.disabled,.dark-indigo .btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.dark-indigo .btn-danger:not(:disabled):not(.disabled).active,.dark-indigo .btn-danger:not(:disabled):not(.disabled):active,.show>.dark-indigo .btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.dark-indigo .btn-danger:not(:disabled):not(.disabled).active:focus,.dark-indigo .btn-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-indigo .btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-indigo .btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-indigo .btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.dark-indigo .btn-light.focus,.dark-indigo .btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.dark-indigo .btn-light.disabled,.dark-indigo .btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-indigo .btn-light:not(:disabled):not(.disabled).active,.dark-indigo .btn-light:not(:disabled):not(.disabled):active,.show>.dark-indigo .btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.dark-indigo .btn-light:not(:disabled):not(.disabled).active:focus,.dark-indigo .btn-light:not(:disabled):not(.disabled):active:focus,.show>.dark-indigo .btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-indigo .btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-indigo .btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.dark-indigo .btn-dark.focus,.dark-indigo .btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.dark-indigo .btn-dark.disabled,.dark-indigo .btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.dark-indigo .btn-dark:not(:disabled):not(.disabled).active,.dark-indigo .btn-dark:not(:disabled):not(.disabled):active,.show>.dark-indigo .btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.dark-indigo .btn-dark:not(:disabled):not(.disabled).active:focus,.dark-indigo .btn-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-indigo .btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-indigo a.btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-indigo a.btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.dark-indigo a.btn-primary.focus,.dark-indigo a.btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.dark-indigo a.btn-primary.disabled,.dark-indigo a.btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-indigo a.btn-primary:not(:disabled):not(.disabled).active,.dark-indigo a.btn-primary:not(:disabled):not(.disabled):active,.show>.dark-indigo a.btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.dark-indigo a.btn-primary:not(:disabled):not(.disabled).active:focus,.dark-indigo a.btn-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-indigo a.btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-indigo a.btn-secondary{color:#fff;background-color:#e91e63;border-color:#e91e63;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-indigo a.btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.dark-indigo a.btn-secondary.focus,.dark-indigo a.btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.dark-indigo a.btn-secondary.disabled,.dark-indigo a.btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-indigo a.btn-secondary:not(:disabled):not(.disabled).active,.dark-indigo a.btn-secondary:not(:disabled):not(.disabled):active,.show>.dark-indigo a.btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.dark-indigo a.btn-secondary:not(:disabled):not(.disabled).active:focus,.dark-indigo a.btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-indigo a.btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-indigo a.btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-indigo a.btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.dark-indigo a.btn-success.focus,.dark-indigo a.btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.dark-indigo a.btn-success.disabled,.dark-indigo a.btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-indigo a.btn-success:not(:disabled):not(.disabled).active,.dark-indigo a.btn-success:not(:disabled):not(.disabled):active,.show>.dark-indigo a.btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.dark-indigo a.btn-success:not(:disabled):not(.disabled).active:focus,.dark-indigo a.btn-success:not(:disabled):not(.disabled):active:focus,.show>.dark-indigo a.btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-indigo a.btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-indigo a.btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.dark-indigo a.btn-info.focus,.dark-indigo a.btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.dark-indigo a.btn-info.disabled,.dark-indigo a.btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-indigo a.btn-info:not(:disabled):not(.disabled).active,.dark-indigo a.btn-info:not(:disabled):not(.disabled):active,.show>.dark-indigo a.btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.dark-indigo a.btn-info:not(:disabled):not(.disabled).active:focus,.dark-indigo a.btn-info:not(:disabled):not(.disabled):active:focus,.show>.dark-indigo a.btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-indigo a.btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-indigo a.btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.dark-indigo a.btn-warning.focus,.dark-indigo a.btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.dark-indigo a.btn-warning.disabled,.dark-indigo a.btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-indigo a.btn-warning:not(:disabled):not(.disabled).active,.dark-indigo a.btn-warning:not(:disabled):not(.disabled):active,.show>.dark-indigo a.btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.dark-indigo a.btn-warning:not(:disabled):not(.disabled).active:focus,.dark-indigo a.btn-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-indigo a.btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-indigo a.btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-indigo a.btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.dark-indigo a.btn-danger.focus,.dark-indigo a.btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.dark-indigo a.btn-danger.disabled,.dark-indigo a.btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.dark-indigo a.btn-danger:not(:disabled):not(.disabled).active,.dark-indigo a.btn-danger:not(:disabled):not(.disabled):active,.show>.dark-indigo a.btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.dark-indigo a.btn-danger:not(:disabled):not(.disabled).active:focus,.dark-indigo a.btn-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-indigo a.btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-indigo a.btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-indigo a.btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.dark-indigo a.btn-light.focus,.dark-indigo a.btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.dark-indigo a.btn-light.disabled,.dark-indigo a.btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-indigo a.btn-light:not(:disabled):not(.disabled).active,.dark-indigo a.btn-light:not(:disabled):not(.disabled):active,.show>.dark-indigo a.btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.dark-indigo a.btn-light:not(:disabled):not(.disabled).active:focus,.dark-indigo a.btn-light:not(:disabled):not(.disabled):active:focus,.show>.dark-indigo a.btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-indigo a.btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-indigo a.btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.dark-indigo a.btn-dark.focus,.dark-indigo a.btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.dark-indigo a.btn-dark.disabled,.dark-indigo a.btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.dark-indigo a.btn-dark:not(:disabled):not(.disabled).active,.dark-indigo a.btn-dark:not(:disabled):not(.disabled):active,.show>.dark-indigo a.btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.dark-indigo a.btn-dark:not(:disabled):not(.disabled).active:focus,.dark-indigo a.btn-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-indigo a.btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-indigo .btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.dark-indigo .btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-indigo .btn-outline-primary.focus,.dark-indigo .btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.dark-indigo .btn-outline-primary.disabled,.dark-indigo .btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.dark-indigo .btn-outline-primary:not(:disabled):not(.disabled).active,.dark-indigo .btn-outline-primary:not(:disabled):not(.disabled):active,.show>.dark-indigo .btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-indigo .btn-outline-primary:not(:disabled):not(.disabled).active:focus,.dark-indigo .btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-indigo .btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-indigo .btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.dark-indigo .btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-indigo .btn-outline-secondary.focus,.dark-indigo .btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.dark-indigo .btn-outline-secondary.disabled,.dark-indigo .btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.dark-indigo .btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-indigo .btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.dark-indigo .btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-indigo .btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.dark-indigo .btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-indigo .btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-indigo .btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.dark-indigo .btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-indigo .btn-outline-success.focus,.dark-indigo .btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.dark-indigo .btn-outline-success.disabled,.dark-indigo .btn-outline-success:disabled{color:#4caf50;background-color:transparent}.dark-indigo .btn-outline-success:not(:disabled):not(.disabled).active,.dark-indigo .btn-outline-success:not(:disabled):not(.disabled):active,.show>.dark-indigo .btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-indigo .btn-outline-success:not(:disabled):not(.disabled).active:focus,.dark-indigo .btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.dark-indigo .btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-indigo .btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.dark-indigo .btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-indigo .btn-outline-info.focus,.dark-indigo .btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.dark-indigo .btn-outline-info.disabled,.dark-indigo .btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.dark-indigo .btn-outline-info:not(:disabled):not(.disabled).active,.dark-indigo .btn-outline-info:not(:disabled):not(.disabled):active,.show>.dark-indigo .btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-indigo .btn-outline-info:not(:disabled):not(.disabled).active:focus,.dark-indigo .btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.dark-indigo .btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-indigo .btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.dark-indigo .btn-outline-warning:hover{color:#fff;background-color:#ff9800;border-color:#ff9800}.dark-indigo .btn-outline-warning.focus,.dark-indigo .btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.dark-indigo .btn-outline-warning.disabled,.dark-indigo .btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.dark-indigo .btn-outline-warning:not(:disabled):not(.disabled).active,.dark-indigo .btn-outline-warning:not(:disabled):not(.disabled):active,.show>.dark-indigo .btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-indigo .btn-outline-warning:not(:disabled):not(.disabled).active:focus,.dark-indigo .btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-indigo .btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-indigo .btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.dark-indigo .btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.dark-indigo .btn-outline-danger.focus,.dark-indigo .btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.dark-indigo .btn-outline-danger.disabled,.dark-indigo .btn-outline-danger:disabled{color:#f44336;background-color:transparent}.dark-indigo .btn-outline-danger:not(:disabled):not(.disabled).active,.dark-indigo .btn-outline-danger:not(:disabled):not(.disabled):active,.show>.dark-indigo .btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.dark-indigo .btn-outline-danger:not(:disabled):not(.disabled).active:focus,.dark-indigo .btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-indigo .btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-indigo .btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.dark-indigo .btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-indigo .btn-outline-light.focus,.dark-indigo .btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.dark-indigo .btn-outline-light.disabled,.dark-indigo .btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.dark-indigo .btn-outline-light:not(:disabled):not(.disabled).active,.dark-indigo .btn-outline-light:not(:disabled):not(.disabled):active,.show>.dark-indigo .btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-indigo .btn-outline-light:not(:disabled):not(.disabled).active:focus,.dark-indigo .btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.dark-indigo .btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-indigo .btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.dark-indigo .btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.dark-indigo .btn-outline-dark.focus,.dark-indigo .btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.dark-indigo .btn-outline-dark.disabled,.dark-indigo .btn-outline-dark:disabled{color:#343a40;background-color:transparent}.dark-indigo .btn-outline-dark:not(:disabled):not(.disabled).active,.dark-indigo .btn-outline-dark:not(:disabled):not(.disabled):active,.show>.dark-indigo .btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.dark-indigo .btn-outline-dark:not(:disabled):not(.disabled).active:focus,.dark-indigo .btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-indigo .btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-indigo a.btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.dark-indigo a.btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-indigo a.btn-outline-primary.focus,.dark-indigo a.btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.dark-indigo a.btn-outline-primary.disabled,.dark-indigo a.btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.dark-indigo a.btn-outline-primary:not(:disabled):not(.disabled).active,.dark-indigo a.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.dark-indigo a.btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-indigo a.btn-outline-primary:not(:disabled):not(.disabled).active:focus,.dark-indigo a.btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-indigo a.btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-indigo a.btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.dark-indigo a.btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-indigo a.btn-outline-secondary.focus,.dark-indigo a.btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.dark-indigo a.btn-outline-secondary.disabled,.dark-indigo a.btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.dark-indigo a.btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-indigo a.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.dark-indigo a.btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-indigo a.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.dark-indigo a.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-indigo a.btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-indigo a.btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.dark-indigo a.btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-indigo a.btn-outline-success.focus,.dark-indigo a.btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.dark-indigo a.btn-outline-success.disabled,.dark-indigo a.btn-outline-success:disabled{color:#4caf50;background-color:transparent}.dark-indigo a.btn-outline-success:not(:disabled):not(.disabled).active,.dark-indigo a.btn-outline-success:not(:disabled):not(.disabled):active,.show>.dark-indigo a.btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-indigo a.btn-outline-success:not(:disabled):not(.disabled).active:focus,.dark-indigo a.btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.dark-indigo a.btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-indigo a.btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.dark-indigo a.btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-indigo a.btn-outline-info.focus,.dark-indigo a.btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.dark-indigo a.btn-outline-info.disabled,.dark-indigo a.btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.dark-indigo a.btn-outline-info:not(:disabled):not(.disabled).active,.dark-indigo a.btn-outline-info:not(:disabled):not(.disabled):active,.show>.dark-indigo a.btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-indigo a.btn-outline-info:not(:disabled):not(.disabled).active:focus,.dark-indigo a.btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.dark-indigo a.btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-indigo a.btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.dark-indigo a.btn-outline-warning:hover{color:#fff;background-color:#ff9800;border-color:#ff9800}.dark-indigo a.btn-outline-warning.focus,.dark-indigo a.btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.dark-indigo a.btn-outline-warning.disabled,.dark-indigo a.btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.dark-indigo a.btn-outline-warning:not(:disabled):not(.disabled).active,.dark-indigo a.btn-outline-warning:not(:disabled):not(.disabled):active,.show>.dark-indigo a.btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-indigo a.btn-outline-warning:not(:disabled):not(.disabled).active:focus,.dark-indigo a.btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-indigo a.btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-indigo a.btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.dark-indigo a.btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.dark-indigo a.btn-outline-danger.focus,.dark-indigo a.btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.dark-indigo a.btn-outline-danger.disabled,.dark-indigo a.btn-outline-danger:disabled{color:#f44336;background-color:transparent}.dark-indigo a.btn-outline-danger:not(:disabled):not(.disabled).active,.dark-indigo a.btn-outline-danger:not(:disabled):not(.disabled):active,.show>.dark-indigo a.btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.dark-indigo a.btn-outline-danger:not(:disabled):not(.disabled).active:focus,.dark-indigo a.btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-indigo a.btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-indigo a.btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.dark-indigo a.btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-indigo a.btn-outline-light.focus,.dark-indigo a.btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.dark-indigo a.btn-outline-light.disabled,.dark-indigo a.btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.dark-indigo a.btn-outline-light:not(:disabled):not(.disabled).active,.dark-indigo a.btn-outline-light:not(:disabled):not(.disabled):active,.show>.dark-indigo a.btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-indigo a.btn-outline-light:not(:disabled):not(.disabled).active:focus,.dark-indigo a.btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.dark-indigo a.btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-indigo a.btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.dark-indigo a.btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.dark-indigo a.btn-outline-dark.focus,.dark-indigo a.btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.dark-indigo a.btn-outline-dark.disabled,.dark-indigo a.btn-outline-dark:disabled{color:#343a40;background-color:transparent}.dark-indigo a.btn-outline-dark:not(:disabled):not(.disabled).active,.dark-indigo a.btn-outline-dark:not(:disabled):not(.disabled):active,.show>.dark-indigo a.btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.dark-indigo a.btn-outline-dark:not(:disabled):not(.disabled).active:focus,.dark-indigo a.btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-indigo a.btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-indigo .btn-outline-primary,.dark-indigo a.btn-outline-primary{color:#3f51b5;border-color:#3f51b5}.dark-indigo .btn-outline-primary.disabled,.dark-indigo .btn-outline-primary:disabled,.dark-indigo .btn-outline-primary:focus,.dark-indigo .btn-outline-primary:hover,.dark-indigo .btn-outline-primary:not(:disabled):not(.disabled).active,.dark-indigo .btn-outline-primary:not(:disabled):not(.disabled):active,.dark-indigo a.btn-outline-primary.disabled,.dark-indigo a.btn-outline-primary:disabled,.dark-indigo a.btn-outline-primary:focus,.dark-indigo a.btn-outline-primary:hover,.dark-indigo a.btn-outline-primary:not(:disabled):not(.disabled).active,.dark-indigo a.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.dark-indigo .btn-outline-primary.dropdown-toggle,.show>.dark-indigo a.btn-outline-primary.dropdown-toggle{color:#fff;border-color:#3f51b5;background-color:#3f51b5}.dark-indigo .btn-outline-secondary,.dark-indigo a.btn-outline-secondary{color:#ff4081;border-color:#ff4081}.dark-indigo .btn-outline-secondary.disabled,.dark-indigo .btn-outline-secondary:disabled,.dark-indigo .btn-outline-secondary:focus,.dark-indigo .btn-outline-secondary:hover,.dark-indigo .btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-indigo .btn-outline-secondary:not(:disabled):not(.disabled):active,.dark-indigo a.btn-outline-secondary.disabled,.dark-indigo a.btn-outline-secondary:disabled,.dark-indigo a.btn-outline-secondary:focus,.dark-indigo a.btn-outline-secondary:hover,.dark-indigo a.btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-indigo a.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.dark-indigo .btn-outline-secondary.dropdown-toggle,.show>.dark-indigo a.btn-outline-secondary.dropdown-toggle{color:#fff;border-color:#ff4081;background-color:#ff4081}.dark-indigo a,.dark-indigo a.text-primary{color:#3f51b5}.dark-indigo a.text-primary:focus,.dark-indigo a.text-primary:hover,.dark-indigo a:focus,.dark-indigo a:hover{color:#32408f}.dark-indigo .text-primary{color:#3f51b5!important}.dark-indigo .page-link,.dark-indigo .page-link:focus,.dark-indigo .page-link:hover{color:#3f51b5}.dark-indigo .badge-primary,.dark-indigo .bg-primary{background-color:#3f51b5!important;color:#fff!important}.dark-indigo .btn-primary,.dark-indigo .jr-btn-primary,.dark-indigo a.btn-primary,.dark-indigo a.jr-btn-primary{background-color:#3f51b5;border-color:#3f51b5;color:#fff}.dark-indigo .btn-primary:focus,.dark-indigo .btn-primary:hover,.dark-indigo .btn-primary:not([disabled]):not(.disabled):active,.dark-indigo .jr-btn-primary:focus,.dark-indigo .jr-btn-primary:hover,.dark-indigo .jr-btn-primary:not([disabled]):not(.disabled):active,.dark-indigo a.btn-primary:focus,.dark-indigo a.btn-primary:hover,.dark-indigo a.btn-primary:not([disabled]):not(.disabled):active,.dark-indigo a.jr-btn-primary:focus,.dark-indigo a.jr-btn-primary:hover,.dark-indigo a.jr-btn-primary:not([disabled]):not(.disabled):active{background-color:#3849a2!important;border-color:#3849a2!important;color:#fff!important}.dark-indigo .bg-primary.lighten-4{background-color:#c5cae9!important}.dark-indigo .bg-primary.lighten-3{background-color:#9fa8da!important}.dark-indigo .bg-primary.lighten-2{background-color:#7986cb!important}.dark-indigo .bg-primary.lighten-1{background-color:#5c6bc0!important}.dark-indigo .bg-primary.darken-1{background-color:#3949ab!important}.dark-indigo .bg-primary.darken-2{background-color:#303f9f!important}.dark-indigo .bg-primary.darken-3{background-color:#283593!important}.dark-indigo .bg-primary.darken-4{background-color:#1a237e!important}.dark-indigo .bg-primary.accent-1{background-color:#8c9eff!important}.dark-indigo .bg-primary.accent-2{background-color:#536dfe!important}.dark-indigo .bg-primary.accent-3{background-color:#3d5afe!important}.dark-indigo .bg-primary.accent-4{background-color:#304ffe!important}.dark-indigo a.text-secondary{color:#ff4081}.dark-indigo a.text-secondary:focus,.dark-indigo a.text-secondary:hover{color:#ff0d5f!important}.dark-indigo .text-secondary{color:#ff4081!important}.dark-indigo .badge-secondary,.dark-indigo .bg-secondary{background-color:#ff4081!important;color:#fff!important}.dark-indigo .btn-secondary{background-color:#ff4081;border-color:#ff4081;color:#fff}.dark-indigo .btn-secondary:active,.dark-indigo .btn-secondary:focus,.dark-indigo .btn-secondary:hover{background-color:#ff2770!important;border-color:#ff2770!important;color:#fff!important}.dark-indigo .jr-flat-btn{background-color:transparent!important;color:#5c5c5c!important}.dark-indigo .jr-flat-btn:active,.dark-indigo .jr-flat-btn:focus,.dark-indigo .jr-flat-btn:hover{background-color:#f5f5f5!important;color:#5c5c5c!important}.dark-indigo .jr-flat-btn.jr-btn-primary{background-color:transparent!important;color:#3f51b5!important;border-color:transparent!important}.dark-indigo .jr-flat-btn.jr-btn-primary:focus,.dark-indigo .jr-flat-btn.jr-btn-primary:hover{background-color:rgba(63,81,181,.12)!important;color:#3f51b5!important}.dark-indigo .bg-primary .jr-flat-btn.jr-btn-primary{background-color:transparent!important;color:#fff!important;border-color:transparent!important}.dark-indigo .bg-primary .jr-flat-btn.jr-btn-primary:focus,.dark-indigo .bg-primary .jr-flat-btn.jr-btn-primary:hover{background-color:hsla(0,0%,100%,.12)!important;color:#fff!important}.dark-indigo .jr-flat-btn.jr-btn-secondary{background-color:transparent!important;color:#ff4081!important;border-color:transparent!important}.dark-indigo .jr-flat-btn.jr-btn-secondary:focus,.dark-indigo .jr-flat-btn.jr-btn-secondary:hover{background-color:rgba(255,64,129,.12)!important;color:#ff4081!important}.dark-indigo .bg-secondary .jr-flat-btn.jr-btn-secondary{background-color:transparent!important;color:#fff!important;border-color:transparent!important}.dark-indigo .bg-secondary .jr-flat-btn.jr-btn-secondary:focus,.dark-indigo .bg-secondary .jr-flat-btn.jr-btn-secondary:hover{background-color:hsla(0,0%,100%,.12)!important;color:#fff!important}.dark-indigo .app-main-header{background-color:#3f51b5!important;color:#fff;border-color:#3f51b5}.dark-indigo .app-main-header .search-bar input{background-color:#4d5ec1}.dark-indigo .app-main-header .search-bar input+.search-icon i{color:#fff}.dark-indigo .app-main-header .search-bar input:focus{background-color:#fff}.dark-indigo .app-main-header .search-bar input:focus+.search-icon i{color:hsla(0,0%,50%,.8)}@media screen and (max-width:575px){.dark-indigo .app-main-header .search-dropdown input{background-color:#fff}.dark-indigo .app-main-header .search-dropdown input+.search-icon i{color:hsla(0,0%,50%,.8)}}.dark-indigo .app-main-header .jr-menu-icon .menu-icon{background-color:#fff!important}.dark-indigo .app-header .jr-menu-icon .menu-icon{background-color:#fff}.dark-indigo .quick-menu .icon-btn{color:#fff}.dark-indigo .react-logo-white.d-block{display:block!important}@media screen and (min-width:992px){.dark-indigo .react-logo-white.d-lg-block{display:block!important}.dark-indigo .react-logo-white.d-lg-none{display:none!important}}.dark-indigo .react-logo-color.d-block{display:none!important}@media screen and (min-width:992px){.dark-indigo .react-logo-color.d-lg-block{display:none!important}}.dark-indigo .color-theme-header{background-color:#3f51b5}.dark-indigo .sidebar-header{border-bottom:0 none;background-color:#1d1d1d}.dark-indigo .side-nav{background-color:#252525!important;color:#a1a1a1!important;border-right:0 none!important}.dark-indigo .side-nav .user-profile{background-color:#1d1d1d;position:relative;z-index:2}.dark-indigo .side-nav .customizer{border-bottom:0 none}.dark-indigo .side-nav .user-detail .user-name{color:#fff}.dark-indigo ul.nav-menu .nav-header,.dark-indigo ul.nav-menu li a{color:#a1a1a1}.dark-indigo ul.nav-menu>li.open>a,.dark-indigo ul.nav-menu>li>a:focus,.dark-indigo ul.nav-menu>li>a:hover{background-color:#1d1d1d;color:#fff}.dark-indigo ul.nav-menu li.menu.open>a{border-color:#3f51b5}.dark-indigo ul.nav-menu li.menu>a:focus:before,.dark-indigo ul.nav-menu li.menu>a:hover:before{color:#fff}.dark-indigo ul.nav-menu li ul{background-color:#1d1d1d}.dark-indigo ul.nav-menu li.menu>a:before{color:#a1a1a1}.dark-indigo ul.nav-menu li.menu.open>a:before,.dark-indigo ul.nav-menu li.menu>a:focus:before,.dark-indigo ul.nav-menu li.menu li>a:hover:before{color:#fff}.dark-indigo ul.nav-menu li.menu .sub-menu li>a:before{color:#a1a1a1}.dark-indigo ul.nav-menu li.menu .sub-menu li>a.active .nav-text{background-color:#3f51b5}.dark-indigo ul.nav-menu li.menu.open .sub-menu li>a.active:before,.dark-indigo ul.nav-menu li.menu .sub-menu li>a:focus,.dark-indigo ul.nav-menu li.menu .sub-menu li>a:focus:before,.dark-indigo ul.nav-menu li.menu .sub-menu li>a:hover,.dark-indigo ul.nav-menu li.menu .sub-menu li>a:hover:before{background-color:#1d1d1d;color:#fff}.dark-indigo .navbar-nav li:focus>a,.dark-indigo .navbar-nav li:hover>a{color:#3f51b5}.dark-indigo .navbar-nav li a{color:#868e96}.dark-indigo .navbar-nav li a:focus,.dark-indigo .navbar-nav li a:hover{color:#3f51b5}.dark-indigo .navbar-nav li.nav-item>a{color:#fff}.dark-indigo .navbar-nav li.nav-item.active>a,.dark-indigo .navbar-nav li.nav-item:focus>a,.dark-indigo .navbar-nav li.nav-item:hover>a,.dark-indigo .navbar-nav li.nav-item>a:focus,.dark-indigo .navbar-nav li.nav-item>a:hover{color:#ff4081}.dark-indigo .navbar-nav ul.sub-menu li.active>a,.dark-indigo .navbar-nav ul.sub-menu li a.active{color:#3f51b5}.dark-indigo .navbar-nav .nav-arrow>a:before{color:#868e96}.dark-indigo .navbar-nav .nav-arrow.active>a:before,.dark-indigo .navbar-nav .nav-arrow:focus>a:before,.dark-indigo .navbar-nav .nav-arrow:hover>a:before,.dark-indigo .navbar-nav .nav-arrow a:focus:before,.dark-indigo .navbar-nav .nav-arrow a:hover:before{color:#3f51b5}.dark-indigo .app-top-nav{background-color:#252525!important;border-color:#252525}.dark-indigo .app-top-nav .navbar-nav li.nav-item>a{color:#fff}.dark-indigo .app-top-nav .navbar-nav li.nav-item.active>a,.dark-indigo .app-top-nav .navbar-nav li.nav-item:focus>a,.dark-indigo .app-top-nav .navbar-nav li.nav-item:hover>a,.dark-indigo .app-top-nav .navbar-nav li.nav-item>a:focus,.dark-indigo .app-top-nav .navbar-nav li.nav-item>a:hover{color:#ff4081}.dark-indigo .module-nav li a.active{color:#3f51b5}.dark-indigo .rbc-event{background-color:#3f51b5}.dark-indigo .rbc-event.rbc-selected{background-color:#32408f}.dark-indigo .rbc-slot-selection{background-color:rgba(63,81,181,.7)}.dark-indigo .rbc-toolbar button.rbc-active,.dark-indigo .rbc-toolbar button.rbc-active:focus,.dark-indigo .rbc-toolbar button.rbc-active:hover,.dark-indigo .rbc-toolbar button:active,.dark-indigo .rbc-toolbar button:active:focus,.dark-indigo .rbc-toolbar button:active:hover,.dark-indigo .rbc-toolbar button:focus,.dark-indigo .rbc-toolbar button:hover{background-color:rgba(63,81,181,.9);border-color:#3f51b5}.dark-indigo .rbc-day-slot .rbc-event{border-color:#3f51b5}.dark-indigo .chat-sidenav-title{color:#3f51b5}.dark-indigo .chat-user-item.active,.dark-indigo .chat-user-item:hover{background-color:#e4e7f6}.dark-indigo .contact-list i{color:#3f51b5}.dark-indigo .Collapsible__trigger{background:#3f51b5}.dark-indigo .categories-list li.active a,.dark-indigo .categories-list li a:focus,.dark-indigo .categories-list li a:hover{color:#3f51b5}.dark-indigo .filter-with-bg-color ul li a,.dark-indigo .login-content .form-control:focus{border-color:#3f51b5}.dark-indigo .filter-with-bg-color ul li a.active,.dark-indigo .filter-with-bg-color ul li a:focus,.dark-indigo .filter-with-bg-color ul li a:hover{background-color:#3f51b5}.dark-indigo .profile-intro .icon{color:#3f51b5}.dark-indigo .actions,.dark-indigo .social-link li.active a,.dark-indigo .social-link li a:focus,.dark-indigo .social-link li a:hover{color:#ff4081}.dark-indigo .table-hover tbody tr:hover{background-color:rgba(63,81,181,.075)}.dark-indigo .border-primary{border-color:#3f51b5!important}.dark-indigo .app-logo-content{background-color:#3f51b5}.dark-indigo .app-social-block .social-link button{border:1px solid #3f51b5;color:#3f51b5}.dark-indigo .app-social-block .social-link button:focus,.dark-indigo .app-social-block .social-link button:hover{color:#fff;background-color:#3f51b5}.dark-indigo .btn-group-vertical>.btn-default.active,.dark-indigo .btn-group-vertical>.jr-btn.active,.dark-indigo .btn-group>.btn-default.active,.dark-indigo .btn-group>.jr-btn.active{background-color:#3f51b5;border-color:#3f51b5}.dark-indigo .btn-group-vertical>.jr-flat-btn,.dark-indigo .btn-group>.jr-flat-btn{border-color:transparent}.dark-indigo .btn-group-vertical>.jr-flat-btn.active,.dark-indigo .btn-group>.jr-flat-btn.active{background-color:transparent;color:#3f51b5!important;border-color:transparent!important}.dark-indigo .btn-group-vertical>.jr-flat-btn.active:focus,.dark-indigo .btn-group-vertical>.jr-flat-btn.active:hover,.dark-indigo .btn-group>.jr-flat-btn.active:focus,.dark-indigo .btn-group>.jr-flat-btn.active:hover{background-color:rgba(63,81,181,.12)!important;color:#3f51b5!important}.dark-indigo .nav-pill-sales .nav-link.active{background-color:#3f51b5;border-color:#3f51b5}.dark-indigo .switch.on{background:#3f51b5}.dark-indigo .form-checkbox>input+.check,.dark-indigo .form-checkbox>input.sm+.check{color:#3f51b5}.dark-indigo .app-main-header ::-webkit-input-placeholder{color:#ebebeb}.dark-indigo .app-main-header ::-moz-placeholder{color:#ebebeb}.dark-indigo .app-main-header :-ms-input-placeholder{color:#ebebeb}.dark-indigo .app-main-header :-moz-placeholder{color:#ebebeb}.dark-indigo .app-main-header input:focus::-webkit-input-placeholder{color:#dcdcdc}.dark-indigo .app-main-header input:focus::-moz-placeholder{color:#dcdcdc}.dark-indigo .app-main-header input:focus:-ms-input-placeholder{color:#dcdcdc}.dark-indigo .app-main-header input:focus:-moz-placeholder{color:#dcdcdc}.dark-cyan .right-arrow,.dark-cyan .right-arrow:after{color:#00bcd4}.dark-cyan .btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-cyan .btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.dark-cyan .btn-primary.focus,.dark-cyan .btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.dark-cyan .btn-primary.disabled,.dark-cyan .btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-cyan .btn-primary:not(:disabled):not(.disabled).active,.dark-cyan .btn-primary:not(:disabled):not(.disabled):active,.show>.dark-cyan .btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.dark-cyan .btn-primary:not(:disabled):not(.disabled).active:focus,.dark-cyan .btn-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-cyan .btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-cyan .btn-secondary{background-color:#e91e63;border-color:#e91e63;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-cyan .btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.dark-cyan .btn-secondary.focus,.dark-cyan .btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.dark-cyan .btn-secondary.disabled,.dark-cyan .btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-cyan .btn-secondary:not(:disabled):not(.disabled).active,.dark-cyan .btn-secondary:not(:disabled):not(.disabled):active,.show>.dark-cyan .btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.dark-cyan .btn-secondary:not(:disabled):not(.disabled).active:focus,.dark-cyan .btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-cyan .btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-cyan .btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-cyan .btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.dark-cyan .btn-success.focus,.dark-cyan .btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.dark-cyan .btn-success.disabled,.dark-cyan .btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-cyan .btn-success:not(:disabled):not(.disabled).active,.dark-cyan .btn-success:not(:disabled):not(.disabled):active,.show>.dark-cyan .btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.dark-cyan .btn-success:not(:disabled):not(.disabled).active:focus,.dark-cyan .btn-success:not(:disabled):not(.disabled):active:focus,.show>.dark-cyan .btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-cyan .btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-cyan .btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.dark-cyan .btn-info.focus,.dark-cyan .btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.dark-cyan .btn-info.disabled,.dark-cyan .btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-cyan .btn-info:not(:disabled):not(.disabled).active,.dark-cyan .btn-info:not(:disabled):not(.disabled):active,.show>.dark-cyan .btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.dark-cyan .btn-info:not(:disabled):not(.disabled).active:focus,.dark-cyan .btn-info:not(:disabled):not(.disabled):active:focus,.show>.dark-cyan .btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-cyan .btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-cyan .btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.dark-cyan .btn-warning.focus,.dark-cyan .btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.dark-cyan .btn-warning.disabled,.dark-cyan .btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-cyan .btn-warning:not(:disabled):not(.disabled).active,.dark-cyan .btn-warning:not(:disabled):not(.disabled):active,.show>.dark-cyan .btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.dark-cyan .btn-warning:not(:disabled):not(.disabled).active:focus,.dark-cyan .btn-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-cyan .btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-cyan .btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-cyan .btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.dark-cyan .btn-danger.focus,.dark-cyan .btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.dark-cyan .btn-danger.disabled,.dark-cyan .btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.dark-cyan .btn-danger:not(:disabled):not(.disabled).active,.dark-cyan .btn-danger:not(:disabled):not(.disabled):active,.show>.dark-cyan .btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.dark-cyan .btn-danger:not(:disabled):not(.disabled).active:focus,.dark-cyan .btn-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-cyan .btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-cyan .btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-cyan .btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.dark-cyan .btn-light.focus,.dark-cyan .btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.dark-cyan .btn-light.disabled,.dark-cyan .btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-cyan .btn-light:not(:disabled):not(.disabled).active,.dark-cyan .btn-light:not(:disabled):not(.disabled):active,.show>.dark-cyan .btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.dark-cyan .btn-light:not(:disabled):not(.disabled).active:focus,.dark-cyan .btn-light:not(:disabled):not(.disabled):active:focus,.show>.dark-cyan .btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-cyan .btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-cyan .btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.dark-cyan .btn-dark.focus,.dark-cyan .btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.dark-cyan .btn-dark.disabled,.dark-cyan .btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.dark-cyan .btn-dark:not(:disabled):not(.disabled).active,.dark-cyan .btn-dark:not(:disabled):not(.disabled):active,.show>.dark-cyan .btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.dark-cyan .btn-dark:not(:disabled):not(.disabled).active:focus,.dark-cyan .btn-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-cyan .btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-cyan a.btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-cyan a.btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.dark-cyan a.btn-primary.focus,.dark-cyan a.btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.dark-cyan a.btn-primary.disabled,.dark-cyan a.btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-cyan a.btn-primary:not(:disabled):not(.disabled).active,.dark-cyan a.btn-primary:not(:disabled):not(.disabled):active,.show>.dark-cyan a.btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.dark-cyan a.btn-primary:not(:disabled):not(.disabled).active:focus,.dark-cyan a.btn-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-cyan a.btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-cyan a.btn-secondary{color:#fff;background-color:#e91e63;border-color:#e91e63;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-cyan a.btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.dark-cyan a.btn-secondary.focus,.dark-cyan a.btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.dark-cyan a.btn-secondary.disabled,.dark-cyan a.btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-cyan a.btn-secondary:not(:disabled):not(.disabled).active,.dark-cyan a.btn-secondary:not(:disabled):not(.disabled):active,.show>.dark-cyan a.btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.dark-cyan a.btn-secondary:not(:disabled):not(.disabled).active:focus,.dark-cyan a.btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-cyan a.btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-cyan a.btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-cyan a.btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.dark-cyan a.btn-success.focus,.dark-cyan a.btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.dark-cyan a.btn-success.disabled,.dark-cyan a.btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-cyan a.btn-success:not(:disabled):not(.disabled).active,.dark-cyan a.btn-success:not(:disabled):not(.disabled):active,.show>.dark-cyan a.btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.dark-cyan a.btn-success:not(:disabled):not(.disabled).active:focus,.dark-cyan a.btn-success:not(:disabled):not(.disabled):active:focus,.show>.dark-cyan a.btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-cyan a.btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-cyan a.btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.dark-cyan a.btn-info.focus,.dark-cyan a.btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.dark-cyan a.btn-info.disabled,.dark-cyan a.btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-cyan a.btn-info:not(:disabled):not(.disabled).active,.dark-cyan a.btn-info:not(:disabled):not(.disabled):active,.show>.dark-cyan a.btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.dark-cyan a.btn-info:not(:disabled):not(.disabled).active:focus,.dark-cyan a.btn-info:not(:disabled):not(.disabled):active:focus,.show>.dark-cyan a.btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-cyan a.btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-cyan a.btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.dark-cyan a.btn-warning.focus,.dark-cyan a.btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.dark-cyan a.btn-warning.disabled,.dark-cyan a.btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-cyan a.btn-warning:not(:disabled):not(.disabled).active,.dark-cyan a.btn-warning:not(:disabled):not(.disabled):active,.show>.dark-cyan a.btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.dark-cyan a.btn-warning:not(:disabled):not(.disabled).active:focus,.dark-cyan a.btn-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-cyan a.btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-cyan a.btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-cyan a.btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.dark-cyan a.btn-danger.focus,.dark-cyan a.btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.dark-cyan a.btn-danger.disabled,.dark-cyan a.btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.dark-cyan a.btn-danger:not(:disabled):not(.disabled).active,.dark-cyan a.btn-danger:not(:disabled):not(.disabled):active,.show>.dark-cyan a.btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.dark-cyan a.btn-danger:not(:disabled):not(.disabled).active:focus,.dark-cyan a.btn-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-cyan a.btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-cyan a.btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-cyan a.btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.dark-cyan a.btn-light.focus,.dark-cyan a.btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.dark-cyan a.btn-light.disabled,.dark-cyan a.btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-cyan a.btn-light:not(:disabled):not(.disabled).active,.dark-cyan a.btn-light:not(:disabled):not(.disabled):active,.show>.dark-cyan a.btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.dark-cyan a.btn-light:not(:disabled):not(.disabled).active:focus,.dark-cyan a.btn-light:not(:disabled):not(.disabled):active:focus,.show>.dark-cyan a.btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-cyan a.btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-cyan a.btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.dark-cyan a.btn-dark.focus,.dark-cyan a.btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.dark-cyan a.btn-dark.disabled,.dark-cyan a.btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.dark-cyan a.btn-dark:not(:disabled):not(.disabled).active,.dark-cyan a.btn-dark:not(:disabled):not(.disabled):active,.show>.dark-cyan a.btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.dark-cyan a.btn-dark:not(:disabled):not(.disabled).active:focus,.dark-cyan a.btn-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-cyan a.btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-cyan .btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.dark-cyan .btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-cyan .btn-outline-primary.focus,.dark-cyan .btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.dark-cyan .btn-outline-primary.disabled,.dark-cyan .btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.dark-cyan .btn-outline-primary:not(:disabled):not(.disabled).active,.dark-cyan .btn-outline-primary:not(:disabled):not(.disabled):active,.show>.dark-cyan .btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-cyan .btn-outline-primary:not(:disabled):not(.disabled).active:focus,.dark-cyan .btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-cyan .btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-cyan .btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.dark-cyan .btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-cyan .btn-outline-secondary.focus,.dark-cyan .btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.dark-cyan .btn-outline-secondary.disabled,.dark-cyan .btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.dark-cyan .btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-cyan .btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.dark-cyan .btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-cyan .btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.dark-cyan .btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-cyan .btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-cyan .btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.dark-cyan .btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-cyan .btn-outline-success.focus,.dark-cyan .btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.dark-cyan .btn-outline-success.disabled,.dark-cyan .btn-outline-success:disabled{color:#4caf50;background-color:transparent}.dark-cyan .btn-outline-success:not(:disabled):not(.disabled).active,.dark-cyan .btn-outline-success:not(:disabled):not(.disabled):active,.show>.dark-cyan .btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-cyan .btn-outline-success:not(:disabled):not(.disabled).active:focus,.dark-cyan .btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.dark-cyan .btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-cyan .btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.dark-cyan .btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-cyan .btn-outline-info.focus,.dark-cyan .btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.dark-cyan .btn-outline-info.disabled,.dark-cyan .btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.dark-cyan .btn-outline-info:not(:disabled):not(.disabled).active,.dark-cyan .btn-outline-info:not(:disabled):not(.disabled):active,.show>.dark-cyan .btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-cyan .btn-outline-info:not(:disabled):not(.disabled).active:focus,.dark-cyan .btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.dark-cyan .btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-cyan .btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.dark-cyan .btn-outline-warning:hover{color:#fff;background-color:#ff9800;border-color:#ff9800}.dark-cyan .btn-outline-warning.focus,.dark-cyan .btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.dark-cyan .btn-outline-warning.disabled,.dark-cyan .btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.dark-cyan .btn-outline-warning:not(:disabled):not(.disabled).active,.dark-cyan .btn-outline-warning:not(:disabled):not(.disabled):active,.show>.dark-cyan .btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-cyan .btn-outline-warning:not(:disabled):not(.disabled).active:focus,.dark-cyan .btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-cyan .btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-cyan .btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.dark-cyan .btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.dark-cyan .btn-outline-danger.focus,.dark-cyan .btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.dark-cyan .btn-outline-danger.disabled,.dark-cyan .btn-outline-danger:disabled{color:#f44336;background-color:transparent}.dark-cyan .btn-outline-danger:not(:disabled):not(.disabled).active,.dark-cyan .btn-outline-danger:not(:disabled):not(.disabled):active,.show>.dark-cyan .btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.dark-cyan .btn-outline-danger:not(:disabled):not(.disabled).active:focus,.dark-cyan .btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-cyan .btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-cyan .btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.dark-cyan .btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-cyan .btn-outline-light.focus,.dark-cyan .btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.dark-cyan .btn-outline-light.disabled,.dark-cyan .btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.dark-cyan .btn-outline-light:not(:disabled):not(.disabled).active,.dark-cyan .btn-outline-light:not(:disabled):not(.disabled):active,.show>.dark-cyan .btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-cyan .btn-outline-light:not(:disabled):not(.disabled).active:focus,.dark-cyan .btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.dark-cyan .btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-cyan .btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.dark-cyan .btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.dark-cyan .btn-outline-dark.focus,.dark-cyan .btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.dark-cyan .btn-outline-dark.disabled,.dark-cyan .btn-outline-dark:disabled{color:#343a40;background-color:transparent}.dark-cyan .btn-outline-dark:not(:disabled):not(.disabled).active,.dark-cyan .btn-outline-dark:not(:disabled):not(.disabled):active,.show>.dark-cyan .btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.dark-cyan .btn-outline-dark:not(:disabled):not(.disabled).active:focus,.dark-cyan .btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-cyan .btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-cyan a.btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.dark-cyan a.btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-cyan a.btn-outline-primary.focus,.dark-cyan a.btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.dark-cyan a.btn-outline-primary.disabled,.dark-cyan a.btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.dark-cyan a.btn-outline-primary:not(:disabled):not(.disabled).active,.dark-cyan a.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.dark-cyan a.btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-cyan a.btn-outline-primary:not(:disabled):not(.disabled).active:focus,.dark-cyan a.btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-cyan a.btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-cyan a.btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.dark-cyan a.btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-cyan a.btn-outline-secondary.focus,.dark-cyan a.btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.dark-cyan a.btn-outline-secondary.disabled,.dark-cyan a.btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.dark-cyan a.btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-cyan a.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.dark-cyan a.btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-cyan a.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.dark-cyan a.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-cyan a.btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-cyan a.btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.dark-cyan a.btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-cyan a.btn-outline-success.focus,.dark-cyan a.btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.dark-cyan a.btn-outline-success.disabled,.dark-cyan a.btn-outline-success:disabled{color:#4caf50;background-color:transparent}.dark-cyan a.btn-outline-success:not(:disabled):not(.disabled).active,.dark-cyan a.btn-outline-success:not(:disabled):not(.disabled):active,.show>.dark-cyan a.btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-cyan a.btn-outline-success:not(:disabled):not(.disabled).active:focus,.dark-cyan a.btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.dark-cyan a.btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-cyan a.btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.dark-cyan a.btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-cyan a.btn-outline-info.focus,.dark-cyan a.btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.dark-cyan a.btn-outline-info.disabled,.dark-cyan a.btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.dark-cyan a.btn-outline-info:not(:disabled):not(.disabled).active,.dark-cyan a.btn-outline-info:not(:disabled):not(.disabled):active,.show>.dark-cyan a.btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-cyan a.btn-outline-info:not(:disabled):not(.disabled).active:focus,.dark-cyan a.btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.dark-cyan a.btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-cyan a.btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.dark-cyan a.btn-outline-warning:hover{color:#fff;background-color:#ff9800;border-color:#ff9800}.dark-cyan a.btn-outline-warning.focus,.dark-cyan a.btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.dark-cyan a.btn-outline-warning.disabled,.dark-cyan a.btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.dark-cyan a.btn-outline-warning:not(:disabled):not(.disabled).active,.dark-cyan a.btn-outline-warning:not(:disabled):not(.disabled):active,.show>.dark-cyan a.btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-cyan a.btn-outline-warning:not(:disabled):not(.disabled).active:focus,.dark-cyan a.btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-cyan a.btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-cyan a.btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.dark-cyan a.btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.dark-cyan a.btn-outline-danger.focus,.dark-cyan a.btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.dark-cyan a.btn-outline-danger.disabled,.dark-cyan a.btn-outline-danger:disabled{color:#f44336;background-color:transparent}.dark-cyan a.btn-outline-danger:not(:disabled):not(.disabled).active,.dark-cyan a.btn-outline-danger:not(:disabled):not(.disabled):active,.show>.dark-cyan a.btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.dark-cyan a.btn-outline-danger:not(:disabled):not(.disabled).active:focus,.dark-cyan a.btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-cyan a.btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-cyan a.btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.dark-cyan a.btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-cyan a.btn-outline-light.focus,.dark-cyan a.btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.dark-cyan a.btn-outline-light.disabled,.dark-cyan a.btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.dark-cyan a.btn-outline-light:not(:disabled):not(.disabled).active,.dark-cyan a.btn-outline-light:not(:disabled):not(.disabled):active,.show>.dark-cyan a.btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-cyan a.btn-outline-light:not(:disabled):not(.disabled).active:focus,.dark-cyan a.btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.dark-cyan a.btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-cyan a.btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.dark-cyan a.btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.dark-cyan a.btn-outline-dark.focus,.dark-cyan a.btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.dark-cyan a.btn-outline-dark.disabled,.dark-cyan a.btn-outline-dark:disabled{color:#343a40;background-color:transparent}.dark-cyan a.btn-outline-dark:not(:disabled):not(.disabled).active,.dark-cyan a.btn-outline-dark:not(:disabled):not(.disabled):active,.show>.dark-cyan a.btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.dark-cyan a.btn-outline-dark:not(:disabled):not(.disabled).active:focus,.dark-cyan a.btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-cyan a.btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-cyan .btn-outline-primary,.dark-cyan a.btn-outline-primary{color:#00bcd4;border-color:#00bcd4}.dark-cyan .btn-outline-primary.disabled,.dark-cyan .btn-outline-primary:disabled,.dark-cyan .btn-outline-primary:focus,.dark-cyan .btn-outline-primary:hover,.dark-cyan .btn-outline-primary:not(:disabled):not(.disabled).active,.dark-cyan .btn-outline-primary:not(:disabled):not(.disabled):active,.dark-cyan a.btn-outline-primary.disabled,.dark-cyan a.btn-outline-primary:disabled,.dark-cyan a.btn-outline-primary:focus,.dark-cyan a.btn-outline-primary:hover,.dark-cyan a.btn-outline-primary:not(:disabled):not(.disabled).active,.dark-cyan a.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.dark-cyan .btn-outline-primary.dropdown-toggle,.show>.dark-cyan a.btn-outline-primary.dropdown-toggle{color:#fff;border-color:#00bcd4;background-color:#00bcd4}.dark-cyan .btn-outline-secondary,.dark-cyan a.btn-outline-secondary{color:#69f0ae;border-color:#69f0ae}.dark-cyan .btn-outline-secondary.disabled,.dark-cyan .btn-outline-secondary:disabled,.dark-cyan .btn-outline-secondary:focus,.dark-cyan .btn-outline-secondary:hover,.dark-cyan .btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-cyan .btn-outline-secondary:not(:disabled):not(.disabled):active,.dark-cyan a.btn-outline-secondary.disabled,.dark-cyan a.btn-outline-secondary:disabled,.dark-cyan a.btn-outline-secondary:focus,.dark-cyan a.btn-outline-secondary:hover,.dark-cyan a.btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-cyan a.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.dark-cyan .btn-outline-secondary.dropdown-toggle,.show>.dark-cyan a.btn-outline-secondary.dropdown-toggle{color:#fff;border-color:#69f0ae;background-color:#69f0ae}.dark-cyan a,.dark-cyan a.text-primary{color:#00bcd4}.dark-cyan a.text-primary:focus,.dark-cyan a.text-primary:hover,.dark-cyan a:focus,.dark-cyan a:hover{color:#008fa1}.dark-cyan .text-primary{color:#00bcd4!important}.dark-cyan .page-link,.dark-cyan .page-link:focus,.dark-cyan .page-link:hover{color:#00bcd4}.dark-cyan .badge-primary,.dark-cyan .bg-primary{background-color:#00bcd4!important;color:#fff!important}.dark-cyan .btn-primary,.dark-cyan .jr-btn-primary,.dark-cyan a.btn-primary,.dark-cyan a.jr-btn-primary{background-color:#00bcd4;border-color:#00bcd4;color:#fff}.dark-cyan .btn-primary:focus,.dark-cyan .btn-primary:hover,.dark-cyan .btn-primary:not([disabled]):not(.disabled):active,.dark-cyan .jr-btn-primary:focus,.dark-cyan .jr-btn-primary:hover,.dark-cyan .jr-btn-primary:not([disabled]):not(.disabled):active,.dark-cyan a.btn-primary:focus,.dark-cyan a.btn-primary:hover,.dark-cyan a.btn-primary:not([disabled]):not(.disabled):active,.dark-cyan a.jr-btn-primary:focus,.dark-cyan a.jr-btn-primary:hover,.dark-cyan a.jr-btn-primary:not([disabled]):not(.disabled):active{background-color:#00a5bb!important;border-color:#00a5bb!important;color:#fff!important}.dark-cyan .bg-primary.lighten-4{background-color:#b2ebf2!important}.dark-cyan .bg-primary.lighten-3{background-color:#80deea!important}.dark-cyan .bg-primary.lighten-2{background-color:#4dd0e1!important}.dark-cyan .bg-primary.lighten-1{background-color:#26c6da!important}.dark-cyan .bg-primary.darken-1{background-color:#00acc1!important}.dark-cyan .bg-primary.darken-2{background-color:#0097a7!important}.dark-cyan .bg-primary.darken-3{background-color:#00838f!important}.dark-cyan .bg-primary.darken-4{background-color:#006064!important}.dark-cyan .bg-primary.accent-1{background-color:#84ffff!important}.dark-cyan .bg-primary.accent-2{background-color:#18ffff!important}.dark-cyan .bg-primary.accent-3{background-color:#00e5ff!important}.dark-cyan .bg-primary.accent-4{background-color:#00b8d4!important}.dark-cyan a.text-secondary{color:#69f0ae}.dark-cyan a.text-secondary:focus,.dark-cyan a.text-secondary:hover{color:#3beb95!important}.dark-cyan .text-secondary{color:#69f0ae!important}.dark-cyan .badge-secondary,.dark-cyan .bg-secondary{background-color:#69f0ae!important;color:#fff!important}.dark-cyan .btn-secondary{background-color:#69f0ae;border-color:#69f0ae;color:#fff}.dark-cyan .btn-secondary:active,.dark-cyan .btn-secondary:focus,.dark-cyan .btn-secondary:hover{background-color:#52eea1!important;border-color:#52eea1!important;color:#fff!important}.dark-cyan .jr-flat-btn{background-color:transparent!important;color:#5c5c5c!important}.dark-cyan .jr-flat-btn:active,.dark-cyan .jr-flat-btn:focus,.dark-cyan .jr-flat-btn:hover{background-color:#f5f5f5!important;color:#5c5c5c!important}.dark-cyan .jr-flat-btn.jr-btn-primary{background-color:transparent!important;color:#00bcd4!important;border-color:transparent!important}.dark-cyan .jr-flat-btn.jr-btn-primary:focus,.dark-cyan .jr-flat-btn.jr-btn-primary:hover{background-color:rgba(0,188,212,.12)!important;color:#00bcd4!important}.dark-cyan .bg-primary .jr-flat-btn.jr-btn-primary{background-color:transparent!important;color:#fff!important;border-color:transparent!important}.dark-cyan .bg-primary .jr-flat-btn.jr-btn-primary:focus,.dark-cyan .bg-primary .jr-flat-btn.jr-btn-primary:hover{background-color:hsla(0,0%,100%,.12)!important;color:#fff!important}.dark-cyan .jr-flat-btn.jr-btn-secondary{background-color:transparent!important;color:#69f0ae!important;border-color:transparent!important}.dark-cyan .jr-flat-btn.jr-btn-secondary:focus,.dark-cyan .jr-flat-btn.jr-btn-secondary:hover{background-color:rgba(105,240,174,.12)!important;color:#69f0ae!important}.dark-cyan .bg-secondary .jr-flat-btn.jr-btn-secondary{background-color:transparent!important;color:#fff!important;border-color:transparent!important}.dark-cyan .bg-secondary .jr-flat-btn.jr-btn-secondary:focus,.dark-cyan .bg-secondary .jr-flat-btn.jr-btn-secondary:hover{background-color:hsla(0,0%,100%,.12)!important;color:#fff!important}.dark-cyan .app-main-header{background-color:#00bcd4!important;color:#fff;border-color:#00bcd4}.dark-cyan .app-main-header .search-bar input{background-color:#00d3ee}.dark-cyan .app-main-header .search-bar input+.search-icon i{color:#fff}.dark-cyan .app-main-header .search-bar input:focus{background-color:#fff}.dark-cyan .app-main-header .search-bar input:focus+.search-icon i{color:hsla(0,0%,50%,.8)}@media screen and (max-width:575px){.dark-cyan .app-main-header .search-dropdown input{background-color:#fff}.dark-cyan .app-main-header .search-dropdown input+.search-icon i{color:hsla(0,0%,50%,.8)}}.dark-cyan .app-main-header .jr-menu-icon .menu-icon{background-color:#fff!important}.dark-cyan .app-header .jr-menu-icon .menu-icon{background-color:#fff}.dark-cyan .quick-menu .icon-btn{color:#fff}.dark-cyan .react-logo-white.d-block{display:block!important}@media screen and (min-width:992px){.dark-cyan .react-logo-white.d-lg-block{display:block!important}.dark-cyan .react-logo-white.d-lg-none{display:none!important}}.dark-cyan .react-logo-color.d-block{display:none!important}@media screen and (min-width:992px){.dark-cyan .react-logo-color.d-lg-block{display:none!important}}.dark-cyan .color-theme-header{background-color:#00bcd4}.dark-cyan .sidebar-header{border-bottom:0 none;background-color:#1d1d1d}.dark-cyan .side-nav{background-color:#252525!important;color:#a1a1a1!important;border-right:0 none!important}.dark-cyan .side-nav .user-profile{background-color:#1d1d1d;position:relative;z-index:2}.dark-cyan .side-nav .customizer{border-bottom:0 none}.dark-cyan .side-nav .user-detail .user-name{color:#fff}.dark-cyan ul.nav-menu .nav-header,.dark-cyan ul.nav-menu li a{color:#a1a1a1}.dark-cyan ul.nav-menu>li.open>a,.dark-cyan ul.nav-menu>li>a:focus,.dark-cyan ul.nav-menu>li>a:hover{background-color:#1d1d1d;color:#fff}.dark-cyan ul.nav-menu li.menu.open>a{border-color:#00bcd4}.dark-cyan ul.nav-menu li.menu>a:focus:before,.dark-cyan ul.nav-menu li.menu>a:hover:before{color:#fff}.dark-cyan ul.nav-menu li ul{background-color:#1d1d1d}.dark-cyan ul.nav-menu li.menu>a:before{color:#a1a1a1}.dark-cyan ul.nav-menu li.menu.open>a:before,.dark-cyan ul.nav-menu li.menu>a:focus:before,.dark-cyan ul.nav-menu li.menu li>a:hover:before{color:#fff}.dark-cyan ul.nav-menu li.menu .sub-menu li>a:before{color:#a1a1a1}.dark-cyan ul.nav-menu li.menu .sub-menu li>a.active .nav-text{background-color:#00bcd4}.dark-cyan ul.nav-menu li.menu.open .sub-menu li>a.active:before,.dark-cyan ul.nav-menu li.menu .sub-menu li>a:focus,.dark-cyan ul.nav-menu li.menu .sub-menu li>a:focus:before,.dark-cyan ul.nav-menu li.menu .sub-menu li>a:hover,.dark-cyan ul.nav-menu li.menu .sub-menu li>a:hover:before{background-color:#1d1d1d;color:#fff}.dark-cyan .navbar-nav li:focus>a,.dark-cyan .navbar-nav li:hover>a{color:#00bcd4}.dark-cyan .navbar-nav li a{color:#868e96}.dark-cyan .navbar-nav li a:focus,.dark-cyan .navbar-nav li a:hover{color:#00bcd4}.dark-cyan .navbar-nav li.nav-item>a{color:#fff}.dark-cyan .navbar-nav li.nav-item.active>a,.dark-cyan .navbar-nav li.nav-item:focus>a,.dark-cyan .navbar-nav li.nav-item:hover>a,.dark-cyan .navbar-nav li.nav-item>a:focus,.dark-cyan .navbar-nav li.nav-item>a:hover{color:#69f0ae}.dark-cyan .navbar-nav ul.sub-menu li.active>a,.dark-cyan .navbar-nav ul.sub-menu li a.active{color:#00bcd4}.dark-cyan .navbar-nav .nav-arrow>a:before{color:#868e96}.dark-cyan .navbar-nav .nav-arrow.active>a:before,.dark-cyan .navbar-nav .nav-arrow:focus>a:before,.dark-cyan .navbar-nav .nav-arrow:hover>a:before,.dark-cyan .navbar-nav .nav-arrow a:focus:before,.dark-cyan .navbar-nav .nav-arrow a:hover:before{color:#00bcd4}.dark-cyan .app-top-nav{background-color:#252525!important;border-color:#252525}.dark-cyan .app-top-nav .navbar-nav li.nav-item>a{color:#fff}.dark-cyan .app-top-nav .navbar-nav li.nav-item.active>a,.dark-cyan .app-top-nav .navbar-nav li.nav-item:focus>a,.dark-cyan .app-top-nav .navbar-nav li.nav-item:hover>a,.dark-cyan .app-top-nav .navbar-nav li.nav-item>a:focus,.dark-cyan .app-top-nav .navbar-nav li.nav-item>a:hover{color:#69f0ae}.dark-cyan .module-nav li a.active{border-color:#00bcd4}.dark-cyan .rbc-event{background-color:#00bcd4}.dark-cyan .rbc-event.rbc-selected{background-color:#008fa1}.dark-cyan .rbc-slot-selection{background-color:rgba(0,188,212,.7)}.dark-cyan .rbc-toolbar button.rbc-active,.dark-cyan .rbc-toolbar button.rbc-active:focus,.dark-cyan .rbc-toolbar button.rbc-active:hover,.dark-cyan .rbc-toolbar button:active,.dark-cyan .rbc-toolbar button:active:focus,.dark-cyan .rbc-toolbar button:active:hover,.dark-cyan .rbc-toolbar button:focus,.dark-cyan .rbc-toolbar button:hover{background-color:rgba(0,188,212,.9);border-color:#00bcd4}.dark-cyan .rbc-day-slot .rbc-event{border-color:#00bcd4}.dark-cyan .chat-sidenav-title{color:#00bcd4}.dark-cyan .chat-user-item.active,.dark-cyan .chat-user-item:hover{background-color:#bbf7ff}.dark-cyan .contact-list i{color:#00bcd4}.dark-cyan .Collapsible__trigger{background:#00bcd4}.dark-cyan .categories-list li.active a,.dark-cyan .categories-list li a:focus,.dark-cyan .categories-list li a:hover{color:#00bcd4}.dark-cyan .filter-with-bg-color ul li a,.dark-cyan .login-content .form-control:focus{border-color:#00bcd4}.dark-cyan .filter-with-bg-color ul li a.active,.dark-cyan .filter-with-bg-color ul li a:focus,.dark-cyan .filter-with-bg-color ul li a:hover{background-color:#00bcd4}.dark-cyan .profile-intro .icon{color:#00bcd4}.dark-cyan .actions,.dark-cyan .social-link li.active a,.dark-cyan .social-link li a:focus,.dark-cyan .social-link li a:hover{color:#69f0ae}.dark-cyan .table-hover tbody tr:hover{background-color:rgba(0,188,212,.075)}.dark-cyan .border-primary{border-color:#00bcd4!important}.dark-cyan .app-logo-content{background-color:#00bcd4}.dark-cyan .app-social-block .social-link button{border:1px solid #00bcd4;color:#00bcd4}.dark-cyan .app-social-block .social-link button:focus,.dark-cyan .app-social-block .social-link button:hover{color:#fff;background-color:#00bcd4}.dark-cyan .btn-group-vertical>.btn-default.active,.dark-cyan .btn-group-vertical>.jr-btn.active,.dark-cyan .btn-group>.btn-default.active,.dark-cyan .btn-group>.jr-btn.active{background-color:#00bcd4;border-color:#00bcd4}.dark-cyan .btn-group-vertical>.jr-flat-btn,.dark-cyan .btn-group>.jr-flat-btn{border-color:transparent}.dark-cyan .btn-group-vertical>.jr-flat-btn.active,.dark-cyan .btn-group>.jr-flat-btn.active{background-color:transparent;color:#00bcd4!important;border-color:transparent!important}.dark-cyan .btn-group-vertical>.jr-flat-btn.active:focus,.dark-cyan .btn-group-vertical>.jr-flat-btn.active:hover,.dark-cyan .btn-group>.jr-flat-btn.active:focus,.dark-cyan .btn-group>.jr-flat-btn.active:hover{background-color:rgba(0,188,212,.12)!important;color:#00bcd4!important}.dark-cyan .nav-pill-sales .nav-link.active{background-color:#00bcd4;border-color:#00bcd4}.dark-cyan .form-checkbox>input+.check,.dark-cyan .form-checkbox>input.sm+.check{color:#00bcd4}.dark-cyan .app-main-header ::-webkit-input-placeholder{color:#ebebeb}.dark-cyan .app-main-header ::-moz-placeholder{color:#ebebeb}.dark-cyan .app-main-header :-ms-input-placeholder{color:#ebebeb}.dark-cyan .app-main-header :-moz-placeholder{color:#ebebeb}.dark-cyan .app-main-header input:focus::-webkit-input-placeholder{color:#dcdcdc}.dark-cyan .app-main-header input:focus::-moz-placeholder{color:#dcdcdc}.dark-cyan .app-main-header input:focus:-ms-input-placeholder{color:#dcdcdc}.dark-cyan .app-main-header input:focus:-moz-placeholder{color:#dcdcdc}.dark-amber .right-arrow,.dark-amber .right-arrow:after{color:#ffc107}.dark-amber .btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-amber .btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.dark-amber .btn-primary.focus,.dark-amber .btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.dark-amber .btn-primary.disabled,.dark-amber .btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-amber .btn-primary:not(:disabled):not(.disabled).active,.dark-amber .btn-primary:not(:disabled):not(.disabled):active,.show>.dark-amber .btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.dark-amber .btn-primary:not(:disabled):not(.disabled).active:focus,.dark-amber .btn-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-amber .btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-amber .btn-secondary{background-color:#e91e63;border-color:#e91e63;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-amber .btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.dark-amber .btn-secondary.focus,.dark-amber .btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.dark-amber .btn-secondary.disabled,.dark-amber .btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-amber .btn-secondary:not(:disabled):not(.disabled).active,.dark-amber .btn-secondary:not(:disabled):not(.disabled):active,.show>.dark-amber .btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.dark-amber .btn-secondary:not(:disabled):not(.disabled).active:focus,.dark-amber .btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-amber .btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-amber .btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-amber .btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.dark-amber .btn-success.focus,.dark-amber .btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.dark-amber .btn-success.disabled,.dark-amber .btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-amber .btn-success:not(:disabled):not(.disabled).active,.dark-amber .btn-success:not(:disabled):not(.disabled):active,.show>.dark-amber .btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.dark-amber .btn-success:not(:disabled):not(.disabled).active:focus,.dark-amber .btn-success:not(:disabled):not(.disabled):active:focus,.show>.dark-amber .btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-amber .btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-amber .btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.dark-amber .btn-info.focus,.dark-amber .btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.dark-amber .btn-info.disabled,.dark-amber .btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-amber .btn-info:not(:disabled):not(.disabled).active,.dark-amber .btn-info:not(:disabled):not(.disabled):active,.show>.dark-amber .btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.dark-amber .btn-info:not(:disabled):not(.disabled).active:focus,.dark-amber .btn-info:not(:disabled):not(.disabled):active:focus,.show>.dark-amber .btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-amber .btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-amber .btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.dark-amber .btn-warning.focus,.dark-amber .btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.dark-amber .btn-warning.disabled,.dark-amber .btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-amber .btn-warning:not(:disabled):not(.disabled).active,.dark-amber .btn-warning:not(:disabled):not(.disabled):active,.show>.dark-amber .btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.dark-amber .btn-warning:not(:disabled):not(.disabled).active:focus,.dark-amber .btn-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-amber .btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-amber .btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-amber .btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.dark-amber .btn-danger.focus,.dark-amber .btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.dark-amber .btn-danger.disabled,.dark-amber .btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.dark-amber .btn-danger:not(:disabled):not(.disabled).active,.dark-amber .btn-danger:not(:disabled):not(.disabled):active,.show>.dark-amber .btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.dark-amber .btn-danger:not(:disabled):not(.disabled).active:focus,.dark-amber .btn-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-amber .btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-amber .btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-amber .btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.dark-amber .btn-light.focus,.dark-amber .btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.dark-amber .btn-light.disabled,.dark-amber .btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-amber .btn-light:not(:disabled):not(.disabled).active,.dark-amber .btn-light:not(:disabled):not(.disabled):active,.show>.dark-amber .btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.dark-amber .btn-light:not(:disabled):not(.disabled).active:focus,.dark-amber .btn-light:not(:disabled):not(.disabled):active:focus,.show>.dark-amber .btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-amber .btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-amber .btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.dark-amber .btn-dark.focus,.dark-amber .btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.dark-amber .btn-dark.disabled,.dark-amber .btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.dark-amber .btn-dark:not(:disabled):not(.disabled).active,.dark-amber .btn-dark:not(:disabled):not(.disabled):active,.show>.dark-amber .btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.dark-amber .btn-dark:not(:disabled):not(.disabled).active:focus,.dark-amber .btn-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-amber .btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-amber a.btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-amber a.btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.dark-amber a.btn-primary.focus,.dark-amber a.btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.dark-amber a.btn-primary.disabled,.dark-amber a.btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-amber a.btn-primary:not(:disabled):not(.disabled).active,.dark-amber a.btn-primary:not(:disabled):not(.disabled):active,.show>.dark-amber a.btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.dark-amber a.btn-primary:not(:disabled):not(.disabled).active:focus,.dark-amber a.btn-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-amber a.btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-amber a.btn-secondary{color:#fff;background-color:#e91e63;border-color:#e91e63;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-amber a.btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.dark-amber a.btn-secondary.focus,.dark-amber a.btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.dark-amber a.btn-secondary.disabled,.dark-amber a.btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-amber a.btn-secondary:not(:disabled):not(.disabled).active,.dark-amber a.btn-secondary:not(:disabled):not(.disabled):active,.show>.dark-amber a.btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.dark-amber a.btn-secondary:not(:disabled):not(.disabled).active:focus,.dark-amber a.btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-amber a.btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-amber a.btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-amber a.btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.dark-amber a.btn-success.focus,.dark-amber a.btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.dark-amber a.btn-success.disabled,.dark-amber a.btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-amber a.btn-success:not(:disabled):not(.disabled).active,.dark-amber a.btn-success:not(:disabled):not(.disabled):active,.show>.dark-amber a.btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.dark-amber a.btn-success:not(:disabled):not(.disabled).active:focus,.dark-amber a.btn-success:not(:disabled):not(.disabled):active:focus,.show>.dark-amber a.btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-amber a.btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-amber a.btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.dark-amber a.btn-info.focus,.dark-amber a.btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.dark-amber a.btn-info.disabled,.dark-amber a.btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-amber a.btn-info:not(:disabled):not(.disabled).active,.dark-amber a.btn-info:not(:disabled):not(.disabled):active,.show>.dark-amber a.btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.dark-amber a.btn-info:not(:disabled):not(.disabled).active:focus,.dark-amber a.btn-info:not(:disabled):not(.disabled):active:focus,.show>.dark-amber a.btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-amber a.btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-amber a.btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.dark-amber a.btn-warning.focus,.dark-amber a.btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.dark-amber a.btn-warning.disabled,.dark-amber a.btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-amber a.btn-warning:not(:disabled):not(.disabled).active,.dark-amber a.btn-warning:not(:disabled):not(.disabled):active,.show>.dark-amber a.btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.dark-amber a.btn-warning:not(:disabled):not(.disabled).active:focus,.dark-amber a.btn-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-amber a.btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-amber a.btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-amber a.btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.dark-amber a.btn-danger.focus,.dark-amber a.btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.dark-amber a.btn-danger.disabled,.dark-amber a.btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.dark-amber a.btn-danger:not(:disabled):not(.disabled).active,.dark-amber a.btn-danger:not(:disabled):not(.disabled):active,.show>.dark-amber a.btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.dark-amber a.btn-danger:not(:disabled):not(.disabled).active:focus,.dark-amber a.btn-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-amber a.btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-amber a.btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-amber a.btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.dark-amber a.btn-light.focus,.dark-amber a.btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.dark-amber a.btn-light.disabled,.dark-amber a.btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-amber a.btn-light:not(:disabled):not(.disabled).active,.dark-amber a.btn-light:not(:disabled):not(.disabled):active,.show>.dark-amber a.btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.dark-amber a.btn-light:not(:disabled):not(.disabled).active:focus,.dark-amber a.btn-light:not(:disabled):not(.disabled):active:focus,.show>.dark-amber a.btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-amber a.btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-amber a.btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.dark-amber a.btn-dark.focus,.dark-amber a.btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.dark-amber a.btn-dark.disabled,.dark-amber a.btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.dark-amber a.btn-dark:not(:disabled):not(.disabled).active,.dark-amber a.btn-dark:not(:disabled):not(.disabled):active,.show>.dark-amber a.btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.dark-amber a.btn-dark:not(:disabled):not(.disabled).active:focus,.dark-amber a.btn-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-amber a.btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-amber .btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.dark-amber .btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-amber .btn-outline-primary.focus,.dark-amber .btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.dark-amber .btn-outline-primary.disabled,.dark-amber .btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.dark-amber .btn-outline-primary:not(:disabled):not(.disabled).active,.dark-amber .btn-outline-primary:not(:disabled):not(.disabled):active,.show>.dark-amber .btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-amber .btn-outline-primary:not(:disabled):not(.disabled).active:focus,.dark-amber .btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-amber .btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-amber .btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.dark-amber .btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-amber .btn-outline-secondary.focus,.dark-amber .btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.dark-amber .btn-outline-secondary.disabled,.dark-amber .btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.dark-amber .btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-amber .btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.dark-amber .btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-amber .btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.dark-amber .btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-amber .btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-amber .btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.dark-amber .btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-amber .btn-outline-success.focus,.dark-amber .btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.dark-amber .btn-outline-success.disabled,.dark-amber .btn-outline-success:disabled{color:#4caf50;background-color:transparent}.dark-amber .btn-outline-success:not(:disabled):not(.disabled).active,.dark-amber .btn-outline-success:not(:disabled):not(.disabled):active,.show>.dark-amber .btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-amber .btn-outline-success:not(:disabled):not(.disabled).active:focus,.dark-amber .btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.dark-amber .btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-amber .btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.dark-amber .btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-amber .btn-outline-info.focus,.dark-amber .btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.dark-amber .btn-outline-info.disabled,.dark-amber .btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.dark-amber .btn-outline-info:not(:disabled):not(.disabled).active,.dark-amber .btn-outline-info:not(:disabled):not(.disabled):active,.show>.dark-amber .btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-amber .btn-outline-info:not(:disabled):not(.disabled).active:focus,.dark-amber .btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.dark-amber .btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-amber .btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.dark-amber .btn-outline-warning:hover{color:#fff;background-color:#ff9800;border-color:#ff9800}.dark-amber .btn-outline-warning.focus,.dark-amber .btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.dark-amber .btn-outline-warning.disabled,.dark-amber .btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.dark-amber .btn-outline-warning:not(:disabled):not(.disabled).active,.dark-amber .btn-outline-warning:not(:disabled):not(.disabled):active,.show>.dark-amber .btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-amber .btn-outline-warning:not(:disabled):not(.disabled).active:focus,.dark-amber .btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-amber .btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-amber .btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.dark-amber .btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.dark-amber .btn-outline-danger.focus,.dark-amber .btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.dark-amber .btn-outline-danger.disabled,.dark-amber .btn-outline-danger:disabled{color:#f44336;background-color:transparent}.dark-amber .btn-outline-danger:not(:disabled):not(.disabled).active,.dark-amber .btn-outline-danger:not(:disabled):not(.disabled):active,.show>.dark-amber .btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.dark-amber .btn-outline-danger:not(:disabled):not(.disabled).active:focus,.dark-amber .btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-amber .btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-amber .btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.dark-amber .btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-amber .btn-outline-light.focus,.dark-amber .btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.dark-amber .btn-outline-light.disabled,.dark-amber .btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.dark-amber .btn-outline-light:not(:disabled):not(.disabled).active,.dark-amber .btn-outline-light:not(:disabled):not(.disabled):active,.show>.dark-amber .btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-amber .btn-outline-light:not(:disabled):not(.disabled).active:focus,.dark-amber .btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.dark-amber .btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-amber .btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.dark-amber .btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.dark-amber .btn-outline-dark.focus,.dark-amber .btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.dark-amber .btn-outline-dark.disabled,.dark-amber .btn-outline-dark:disabled{color:#343a40;background-color:transparent}.dark-amber .btn-outline-dark:not(:disabled):not(.disabled).active,.dark-amber .btn-outline-dark:not(:disabled):not(.disabled):active,.show>.dark-amber .btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.dark-amber .btn-outline-dark:not(:disabled):not(.disabled).active:focus,.dark-amber .btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-amber .btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-amber a.btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.dark-amber a.btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-amber a.btn-outline-primary.focus,.dark-amber a.btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.dark-amber a.btn-outline-primary.disabled,.dark-amber a.btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.dark-amber a.btn-outline-primary:not(:disabled):not(.disabled).active,.dark-amber a.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.dark-amber a.btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-amber a.btn-outline-primary:not(:disabled):not(.disabled).active:focus,.dark-amber a.btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-amber a.btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-amber a.btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.dark-amber a.btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-amber a.btn-outline-secondary.focus,.dark-amber a.btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.dark-amber a.btn-outline-secondary.disabled,.dark-amber a.btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.dark-amber a.btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-amber a.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.dark-amber a.btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-amber a.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.dark-amber a.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-amber a.btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-amber a.btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.dark-amber a.btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-amber a.btn-outline-success.focus,.dark-amber a.btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.dark-amber a.btn-outline-success.disabled,.dark-amber a.btn-outline-success:disabled{color:#4caf50;background-color:transparent}.dark-amber a.btn-outline-success:not(:disabled):not(.disabled).active,.dark-amber a.btn-outline-success:not(:disabled):not(.disabled):active,.show>.dark-amber a.btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-amber a.btn-outline-success:not(:disabled):not(.disabled).active:focus,.dark-amber a.btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.dark-amber a.btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-amber a.btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.dark-amber a.btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-amber a.btn-outline-info.focus,.dark-amber a.btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.dark-amber a.btn-outline-info.disabled,.dark-amber a.btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.dark-amber a.btn-outline-info:not(:disabled):not(.disabled).active,.dark-amber a.btn-outline-info:not(:disabled):not(.disabled):active,.show>.dark-amber a.btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-amber a.btn-outline-info:not(:disabled):not(.disabled).active:focus,.dark-amber a.btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.dark-amber a.btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-amber a.btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.dark-amber a.btn-outline-warning:hover{color:#fff;background-color:#ff9800;border-color:#ff9800}.dark-amber a.btn-outline-warning.focus,.dark-amber a.btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.dark-amber a.btn-outline-warning.disabled,.dark-amber a.btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.dark-amber a.btn-outline-warning:not(:disabled):not(.disabled).active,.dark-amber a.btn-outline-warning:not(:disabled):not(.disabled):active,.show>.dark-amber a.btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-amber a.btn-outline-warning:not(:disabled):not(.disabled).active:focus,.dark-amber a.btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-amber a.btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-amber a.btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.dark-amber a.btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.dark-amber a.btn-outline-danger.focus,.dark-amber a.btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.dark-amber a.btn-outline-danger.disabled,.dark-amber a.btn-outline-danger:disabled{color:#f44336;background-color:transparent}.dark-amber a.btn-outline-danger:not(:disabled):not(.disabled).active,.dark-amber a.btn-outline-danger:not(:disabled):not(.disabled):active,.show>.dark-amber a.btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.dark-amber a.btn-outline-danger:not(:disabled):not(.disabled).active:focus,.dark-amber a.btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-amber a.btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-amber a.btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.dark-amber a.btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-amber a.btn-outline-light.focus,.dark-amber a.btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.dark-amber a.btn-outline-light.disabled,.dark-amber a.btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.dark-amber a.btn-outline-light:not(:disabled):not(.disabled).active,.dark-amber a.btn-outline-light:not(:disabled):not(.disabled):active,.show>.dark-amber a.btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-amber a.btn-outline-light:not(:disabled):not(.disabled).active:focus,.dark-amber a.btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.dark-amber a.btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-amber a.btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.dark-amber a.btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.dark-amber a.btn-outline-dark.focus,.dark-amber a.btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.dark-amber a.btn-outline-dark.disabled,.dark-amber a.btn-outline-dark:disabled{color:#343a40;background-color:transparent}.dark-amber a.btn-outline-dark:not(:disabled):not(.disabled).active,.dark-amber a.btn-outline-dark:not(:disabled):not(.disabled):active,.show>.dark-amber a.btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.dark-amber a.btn-outline-dark:not(:disabled):not(.disabled).active:focus,.dark-amber a.btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-amber a.btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-amber .btn-outline-primary,.dark-amber a.btn-outline-primary{color:#ffc107;border-color:#ffc107}.dark-amber .btn-outline-primary.disabled,.dark-amber .btn-outline-primary:disabled,.dark-amber .btn-outline-primary:focus,.dark-amber .btn-outline-primary:hover,.dark-amber .btn-outline-primary:not(:disabled):not(.disabled).active,.dark-amber .btn-outline-primary:not(:disabled):not(.disabled):active,.dark-amber a.btn-outline-primary.disabled,.dark-amber a.btn-outline-primary:disabled,.dark-amber a.btn-outline-primary:focus,.dark-amber a.btn-outline-primary:hover,.dark-amber a.btn-outline-primary:not(:disabled):not(.disabled).active,.dark-amber a.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.dark-amber .btn-outline-primary.dropdown-toggle,.show>.dark-amber a.btn-outline-primary.dropdown-toggle{color:#fff;border-color:#ffc107;background-color:#ffc107}.dark-amber .btn-outline-secondary,.dark-amber a.btn-outline-secondary{color:#ff3d00;border-color:#ff3d00}.dark-amber .btn-outline-secondary.disabled,.dark-amber .btn-outline-secondary:disabled,.dark-amber .btn-outline-secondary:focus,.dark-amber .btn-outline-secondary:hover,.dark-amber .btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-amber .btn-outline-secondary:not(:disabled):not(.disabled):active,.dark-amber a.btn-outline-secondary.disabled,.dark-amber a.btn-outline-secondary:disabled,.dark-amber a.btn-outline-secondary:focus,.dark-amber a.btn-outline-secondary:hover,.dark-amber a.btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-amber a.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.dark-amber .btn-outline-secondary.dropdown-toggle,.show>.dark-amber a.btn-outline-secondary.dropdown-toggle{color:#fff;border-color:#ff3d00;background-color:#ff3d00}.dark-amber a,.dark-amber a.text-primary{color:#ffc107}.dark-amber a.text-primary:focus,.dark-amber a.text-primary:hover,.dark-amber a:focus,.dark-amber a:hover{color:#d39e00}.dark-amber .text-primary{color:#ffc107!important}.dark-amber .page-link,.dark-amber .page-link:focus,.dark-amber .page-link:hover{color:#ffc107}.dark-amber .badge-primary,.dark-amber .bg-primary{background-color:#ffc107!important;color:#fff!important}.dark-amber .btn-primary,.dark-amber .jr-btn-primary,.dark-amber a.btn-primary,.dark-amber a.jr-btn-primary{background-color:#ffc107;border-color:#ffc107;color:#fff}.dark-amber .btn-primary:focus,.dark-amber .btn-primary:hover,.dark-amber .btn-primary:not([disabled]):not(.disabled):active,.dark-amber .jr-btn-primary:focus,.dark-amber .jr-btn-primary:hover,.dark-amber .jr-btn-primary:not([disabled]):not(.disabled):active,.dark-amber a.btn-primary:focus,.dark-amber a.btn-primary:hover,.dark-amber a.btn-primary:not([disabled]):not(.disabled):active,.dark-amber a.jr-btn-primary:focus,.dark-amber a.jr-btn-primary:hover,.dark-amber a.jr-btn-primary:not([disabled]):not(.disabled):active{background-color:#edb100!important;border-color:#edb100!important;color:#fff!important}.dark-amber .bg-primary.lighten-4{background-color:#ffecb3!important}.dark-amber .bg-primary.lighten-3{background-color:#ffe082!important}.dark-amber .bg-primary.lighten-2{background-color:#ffd54f!important}.dark-amber .bg-primary.lighten-1{background-color:#ffca28!important}.dark-amber .bg-primary.darken-1{background-color:#ffb300!important}.dark-amber .bg-primary.darken-2{background-color:#ffa000!important}.dark-amber .bg-primary.darken-3{background-color:#ff8f00!important}.dark-amber .bg-primary.darken-4{background-color:#ff6f00!important}.dark-amber .bg-primary.accent-1{background-color:#ffe57f!important}.dark-amber .bg-primary.accent-2{background-color:#ffd740!important}.dark-amber .bg-primary.accent-3{background-color:#ffc400!important}.dark-amber .bg-primary.accent-4{background-color:#ffab00!important}.dark-amber a.text-secondary{color:#ff3d00}.dark-amber a.text-secondary:focus,.dark-amber a.text-secondary:hover{color:#cc3100!important}.dark-amber .text-secondary{color:#ff3d00!important}.dark-amber .badge-secondary,.dark-amber .bg-secondary{background-color:#ff3d00!important;color:#fff!important}.dark-amber .btn-secondary{background-color:#ff3d00;border-color:#ff3d00;color:#fff}.dark-amber .btn-secondary:active,.dark-amber .btn-secondary:focus,.dark-amber .btn-secondary:hover{background-color:#e63700!important;border-color:#e63700!important;color:#fff!important}.amber .jr-flat-btn{background-color:transparent!important;color:#5c5c5c!important}.amber .jr-flat-btn:active,.amber .jr-flat-btn:focus,.amber .jr-flat-btn:hover{background-color:#f5f5f5!important;color:#5c5c5c!important}.amber .jr-flat-btn.jr-btn-primary{background-color:transparent!important;color:#ffc107!important;border-color:transparent!important}.amber .jr-flat-btn.jr-btn-primary:focus,.amber .jr-flat-btn.jr-btn-primary:hover{background-color:rgba(255,193,7,.12)!important;color:#ffc107!important}.amber .bg-primary .jr-flat-btn.jr-btn-primary{background-color:transparent!important;color:#fff!important;border-color:transparent!important}.amber .bg-primary .jr-flat-btn.jr-btn-primary:focus,.amber .bg-primary .jr-flat-btn.jr-btn-primary:hover{background-color:hsla(0,0%,100%,.12)!important;color:#fff!important}.amber .jr-flat-btn.jr-btn-secondary{background-color:transparent!important;color:#ff3d00!important;border-color:transparent!important}.amber .jr-flat-btn.jr-btn-secondary:focus,.amber .jr-flat-btn.jr-btn-secondary:hover{background-color:rgba(255,61,0,.12)!important;color:#ff3d00!important}.amber .bg-secondary .jr-flat-btn.jr-btn-secondary{background-color:transparent!important;color:#fff!important;border-color:transparent!important}.amber .bg-secondary .jr-flat-btn.jr-btn-secondary:focus,.amber .bg-secondary .jr-flat-btn.jr-btn-secondary:hover{background-color:hsla(0,0%,100%,.12)!important;color:#fff!important}.dark-amber .app-main-header{background-color:#ffc107!important;color:#fff;border-color:#ffc107}.dark-amber .app-main-header .search-bar input{background-color:#ffc721}.dark-amber .app-main-header .search-bar input+.search-icon i{color:#fff}.dark-amber .app-main-header .search-bar input:focus{background-color:#fff}.dark-amber .app-main-header .search-bar input:focus+.search-icon i{color:hsla(0,0%,50%,.8)}@media screen and (max-width:575px){.dark-amber .app-main-header .search-dropdown input{background-color:#fff}.dark-amber .app-main-header .search-dropdown input+.search-icon i{color:hsla(0,0%,50%,.8)}}.dark-amber .app-main-header .jr-menu-icon .menu-icon{background-color:#fff!important}.dark-amber .app-header .jr-menu-icon .menu-icon{background-color:#fff}.dark-amber .quick-menu .icon-btn{color:#fff}.dark-amber .react-logo-white.d-block{display:block!important}@media screen and (min-width:992px){.dark-amber .react-logo-white.d-lg-block{display:block!important}.dark-amber .react-logo-white.d-lg-none{display:none!important}}.dark-amber .react-logo-color.d-block{display:none!important}@media screen and (min-width:992px){.dark-amber .react-logo-color.d-lg-block{display:none!important}}.dark-amber .color-theme-header{background-color:#ffc107}.dark-amber .sidebar-header{border-bottom:0 none;background-color:#1d1d1d}.dark-amber .side-nav{background-color:#252525!important;color:#a1a1a1!important;border-right:0 none!important}.dark-amber .side-nav .user-profile{background-color:#1d1d1d;position:relative;z-index:2}.dark-amber .side-nav .customizer{border-bottom:0 none}.dark-amber .side-nav .user-detail .user-name{color:#fff}.dark-amber ul.nav-menu .nav-header,.dark-amber ul.nav-menu li a{color:#a1a1a1}.dark-amber ul.nav-menu>li.open>a,.dark-amber ul.nav-menu>li>a:focus,.dark-amber ul.nav-menu>li>a:hover{background-color:#1d1d1d;color:#fff}.dark-amber ul.nav-menu li.menu.open>a{border-color:#ffc107}.dark-amber ul.nav-menu li.menu>a:focus:before,.dark-amber ul.nav-menu li.menu>a:hover:before{color:#fff}.dark-amber ul.nav-menu li ul{background-color:#1d1d1d}.dark-amber ul.nav-menu li.menu>a:before{color:#a1a1a1}.dark-amber ul.nav-menu li.menu.open>a:before,.dark-amber ul.nav-menu li.menu>a:focus:before,.dark-amber ul.nav-menu li.menu li>a:hover:before{color:#fff}.dark-amber ul.nav-menu li.menu .sub-menu li>a:before{color:#a1a1a1}.dark-amber ul.nav-menu li.menu .sub-menu li>a.active .nav-text{background-color:#ffc107}.dark-amber ul.nav-menu li.menu.open .sub-menu li>a.active:before,.dark-amber ul.nav-menu li.menu .sub-menu li>a:focus,.dark-amber ul.nav-menu li.menu .sub-menu li>a:focus:before,.dark-amber ul.nav-menu li.menu .sub-menu li>a:hover,.dark-amber ul.nav-menu li.menu .sub-menu li>a:hover:before{background-color:#1d1d1d;color:#fff}.dark-amber .navbar-nav li:focus>a,.dark-amber .navbar-nav li:hover>a{color:#ffc107}.dark-amber .navbar-nav li a{color:#868e96}.dark-amber .navbar-nav li a:focus,.dark-amber .navbar-nav li a:hover{color:#ffc107}.dark-amber .navbar-nav li.nav-item>a{color:#fff}.dark-amber .navbar-nav li.nav-item.active>a,.dark-amber .navbar-nav li.nav-item:focus>a,.dark-amber .navbar-nav li.nav-item:hover>a,.dark-amber .navbar-nav li.nav-item>a:focus,.dark-amber .navbar-nav li.nav-item>a:hover{color:#ff3d00}.dark-amber .navbar-nav ul.sub-menu li.active>a,.dark-amber .navbar-nav ul.sub-menu li a.active{color:#ffc107}.dark-amber .navbar-nav .nav-arrow>a:before{color:#868e96}.dark-amber .navbar-nav .nav-arrow.active>a:before,.dark-amber .navbar-nav .nav-arrow:focus>a:before,.dark-amber .navbar-nav .nav-arrow:hover>a:before,.dark-amber .navbar-nav .nav-arrow a:focus:before,.dark-amber .navbar-nav .nav-arrow a:hover:before{color:#ffc107}.dark-amber .app-top-nav{background-color:#252525!important;border-color:#252525}.dark-amber .app-top-nav .navbar-nav li.nav-item>a{color:#fff}.dark-amber .app-top-nav .navbar-nav li.nav-item.active>a,.dark-amber .app-top-nav .navbar-nav li.nav-item:focus>a,.dark-amber .app-top-nav .navbar-nav li.nav-item:hover>a,.dark-amber .app-top-nav .navbar-nav li.nav-item>a:focus,.dark-amber .app-top-nav .navbar-nav li.nav-item>a:hover{color:#ff3d00}.dark-amber .module-nav li a.active{border-color:#ffc107}.dark-amber .rbc-event{background-color:#ffc107}.dark-amber .rbc-event.rbc-selected{background-color:#d39e00}.dark-amber .rbc-slot-selection{background-color:rgba(255,193,7,.7)}.dark-amber .rbc-toolbar button.rbc-active,.dark-amber .rbc-toolbar button.rbc-active:focus,.dark-amber .rbc-toolbar button.rbc-active:hover,.dark-amber .rbc-toolbar button:active,.dark-amber .rbc-toolbar button:active:focus,.dark-amber .rbc-toolbar button:active:hover,.dark-amber .rbc-toolbar button:focus,.dark-amber .rbc-toolbar button:hover{background-color:rgba(255,193,7,.9);border-color:#ffc107}.dark-amber .rbc-day-slot .rbc-event{border-color:#ffc107}.dark-amber .chat-sidenav-title{color:#ffc107}.dark-amber .chat-user-item.active,.dark-amber .chat-user-item:hover{background-color:#fffaed}.dark-amber .contact-list i{color:#ffc107}.dark-amber .Collapsible__trigger{background:#ffc107}.dark-amber .categories-list li.active a,.dark-amber .categories-list li a:focus,.dark-amber .categories-list li a:hover{color:#ffc107}.dark-amber .filter-with-bg-color ul li a,.dark-amber .login-content .form-control:focus{border-color:#ffc107}.dark-amber .filter-with-bg-color ul li a.active,.dark-amber .filter-with-bg-color ul li a:focus,.dark-amber .filter-with-bg-color ul li a:hover{background-color:#ffc107}.dark-amber .profile-intro .icon{color:#ffc107}.dark-amber .actions,.dark-amber .social-link li.active a,.dark-amber .social-link li a:focus,.dark-amber .social-link li a:hover{color:#ff3d00}.dark-amber .table-hover tbody tr:hover{background-color:rgba(255,193,7,.075)}.dark-amber .border-primary{border-color:#ffc107!important}.dark-amber .app-logo-content{background-color:#ffc107}.dark-amber .app-social-block .social-link button{border:1px solid #ffc107;color:#ffc107}.dark-amber .app-social-block .social-link button:focus,.dark-amber .app-social-block .social-link button:hover{color:#fff;background-color:#ffc107}.dark-amber .btn-group-vertical>.btn-default.active,.dark-amber .btn-group-vertical>.jr-btn.active,.dark-amber .btn-group>.btn-default.active,.dark-amber .btn-group>.jr-btn.active{background-color:#ffc107;border-color:#ffc107}.dark-amber .btn-group-vertical>.jr-flat-btn,.dark-amber .btn-group>.jr-flat-btn{border-color:transparent}.dark-amber .btn-group-vertical>.jr-flat-btn.active,.dark-amber .btn-group>.jr-flat-btn.active{background-color:transparent;color:#ffc107!important;border-color:transparent!important}.dark-amber .btn-group-vertical>.jr-flat-btn.active:focus,.dark-amber .btn-group-vertical>.jr-flat-btn.active:hover,.dark-amber .btn-group>.jr-flat-btn.active:focus,.dark-amber .btn-group>.jr-flat-btn.active:hover{background-color:rgba(255,193,7,.12)!important;color:#ffc107!important}.dark-amber .nav-pill-sales .nav-link.active{background-color:#ffc107;border-color:#ffc107}.dark-amber .form-checkbox>input+.check,.dark-amber .form-checkbox>input.sm+.check{color:#ffc107}.dark-amber .app-main-header ::-webkit-input-placeholder{color:#ebebeb}.dark-amber .app-main-header ::-moz-placeholder{color:#ebebeb}.dark-amber .app-main-header :-ms-input-placeholder{color:#ebebeb}.dark-amber .app-main-header :-moz-placeholder{color:#ebebeb}.dark-amber .app-main-header input:focus::-webkit-input-placeholder{color:#dcdcdc}.dark-amber .app-main-header input:focus::-moz-placeholder{color:#dcdcdc}.dark-amber .app-main-header input:focus:-ms-input-placeholder{color:#dcdcdc}.dark-amber .app-main-header input:focus:-moz-placeholder{color:#dcdcdc}.dark-deep-orange .right-arrow,.dark-deep-orange .right-arrow:after{color:#ff5722}.dark-deep-orange .btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-deep-orange .btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.dark-deep-orange .btn-primary.focus,.dark-deep-orange .btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.dark-deep-orange .btn-primary.disabled,.dark-deep-orange .btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-deep-orange .btn-primary:not(:disabled):not(.disabled).active,.dark-deep-orange .btn-primary:not(:disabled):not(.disabled):active,.show>.dark-deep-orange .btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.dark-deep-orange .btn-primary:not(:disabled):not(.disabled).active:focus,.dark-deep-orange .btn-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-orange .btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-deep-orange .btn-secondary{background-color:#e91e63;border-color:#e91e63;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-deep-orange .btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.dark-deep-orange .btn-secondary.focus,.dark-deep-orange .btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.dark-deep-orange .btn-secondary.disabled,.dark-deep-orange .btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-deep-orange .btn-secondary:not(:disabled):not(.disabled).active,.dark-deep-orange .btn-secondary:not(:disabled):not(.disabled):active,.show>.dark-deep-orange .btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.dark-deep-orange .btn-secondary:not(:disabled):not(.disabled).active:focus,.dark-deep-orange .btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-orange .btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-deep-orange .btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-deep-orange .btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.dark-deep-orange .btn-success.focus,.dark-deep-orange .btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.dark-deep-orange .btn-success.disabled,.dark-deep-orange .btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-deep-orange .btn-success:not(:disabled):not(.disabled).active,.dark-deep-orange .btn-success:not(:disabled):not(.disabled):active,.show>.dark-deep-orange .btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.dark-deep-orange .btn-success:not(:disabled):not(.disabled).active:focus,.dark-deep-orange .btn-success:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-orange .btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-deep-orange .btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-deep-orange .btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.dark-deep-orange .btn-info.focus,.dark-deep-orange .btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.dark-deep-orange .btn-info.disabled,.dark-deep-orange .btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-deep-orange .btn-info:not(:disabled):not(.disabled).active,.dark-deep-orange .btn-info:not(:disabled):not(.disabled):active,.show>.dark-deep-orange .btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.dark-deep-orange .btn-info:not(:disabled):not(.disabled).active:focus,.dark-deep-orange .btn-info:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-orange .btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-deep-orange .btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-deep-orange .btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.dark-deep-orange .btn-warning.focus,.dark-deep-orange .btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.dark-deep-orange .btn-warning.disabled,.dark-deep-orange .btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-deep-orange .btn-warning:not(:disabled):not(.disabled).active,.dark-deep-orange .btn-warning:not(:disabled):not(.disabled):active,.show>.dark-deep-orange .btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.dark-deep-orange .btn-warning:not(:disabled):not(.disabled).active:focus,.dark-deep-orange .btn-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-orange .btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-deep-orange .btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-deep-orange .btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.dark-deep-orange .btn-danger.focus,.dark-deep-orange .btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.dark-deep-orange .btn-danger.disabled,.dark-deep-orange .btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.dark-deep-orange .btn-danger:not(:disabled):not(.disabled).active,.dark-deep-orange .btn-danger:not(:disabled):not(.disabled):active,.show>.dark-deep-orange .btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.dark-deep-orange .btn-danger:not(:disabled):not(.disabled).active:focus,.dark-deep-orange .btn-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-orange .btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-deep-orange .btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-deep-orange .btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.dark-deep-orange .btn-light.focus,.dark-deep-orange .btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.dark-deep-orange .btn-light.disabled,.dark-deep-orange .btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-deep-orange .btn-light:not(:disabled):not(.disabled).active,.dark-deep-orange .btn-light:not(:disabled):not(.disabled):active,.show>.dark-deep-orange .btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.dark-deep-orange .btn-light:not(:disabled):not(.disabled).active:focus,.dark-deep-orange .btn-light:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-orange .btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-deep-orange .btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-deep-orange .btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.dark-deep-orange .btn-dark.focus,.dark-deep-orange .btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.dark-deep-orange .btn-dark.disabled,.dark-deep-orange .btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.dark-deep-orange .btn-dark:not(:disabled):not(.disabled).active,.dark-deep-orange .btn-dark:not(:disabled):not(.disabled):active,.show>.dark-deep-orange .btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.dark-deep-orange .btn-dark:not(:disabled):not(.disabled).active:focus,.dark-deep-orange .btn-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-orange .btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-deep-orange a.btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-deep-orange a.btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.dark-deep-orange a.btn-primary.focus,.dark-deep-orange a.btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.dark-deep-orange a.btn-primary.disabled,.dark-deep-orange a.btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-deep-orange a.btn-primary:not(:disabled):not(.disabled).active,.dark-deep-orange a.btn-primary:not(:disabled):not(.disabled):active,.show>.dark-deep-orange a.btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.dark-deep-orange a.btn-primary:not(:disabled):not(.disabled).active:focus,.dark-deep-orange a.btn-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-orange a.btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-deep-orange a.btn-secondary{color:#fff;background-color:#e91e63;border-color:#e91e63;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-deep-orange a.btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.dark-deep-orange a.btn-secondary.focus,.dark-deep-orange a.btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.dark-deep-orange a.btn-secondary.disabled,.dark-deep-orange a.btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-deep-orange a.btn-secondary:not(:disabled):not(.disabled).active,.dark-deep-orange a.btn-secondary:not(:disabled):not(.disabled):active,.show>.dark-deep-orange a.btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.dark-deep-orange a.btn-secondary:not(:disabled):not(.disabled).active:focus,.dark-deep-orange a.btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-orange a.btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-deep-orange a.btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-deep-orange a.btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.dark-deep-orange a.btn-success.focus,.dark-deep-orange a.btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.dark-deep-orange a.btn-success.disabled,.dark-deep-orange a.btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-deep-orange a.btn-success:not(:disabled):not(.disabled).active,.dark-deep-orange a.btn-success:not(:disabled):not(.disabled):active,.show>.dark-deep-orange a.btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.dark-deep-orange a.btn-success:not(:disabled):not(.disabled).active:focus,.dark-deep-orange a.btn-success:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-orange a.btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-deep-orange a.btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-deep-orange a.btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.dark-deep-orange a.btn-info.focus,.dark-deep-orange a.btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.dark-deep-orange a.btn-info.disabled,.dark-deep-orange a.btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-deep-orange a.btn-info:not(:disabled):not(.disabled).active,.dark-deep-orange a.btn-info:not(:disabled):not(.disabled):active,.show>.dark-deep-orange a.btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.dark-deep-orange a.btn-info:not(:disabled):not(.disabled).active:focus,.dark-deep-orange a.btn-info:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-orange a.btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-deep-orange a.btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-deep-orange a.btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.dark-deep-orange a.btn-warning.focus,.dark-deep-orange a.btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.dark-deep-orange a.btn-warning.disabled,.dark-deep-orange a.btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-deep-orange a.btn-warning:not(:disabled):not(.disabled).active,.dark-deep-orange a.btn-warning:not(:disabled):not(.disabled):active,.show>.dark-deep-orange a.btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.dark-deep-orange a.btn-warning:not(:disabled):not(.disabled).active:focus,.dark-deep-orange a.btn-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-orange a.btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-deep-orange a.btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-deep-orange a.btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.dark-deep-orange a.btn-danger.focus,.dark-deep-orange a.btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.dark-deep-orange a.btn-danger.disabled,.dark-deep-orange a.btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.dark-deep-orange a.btn-danger:not(:disabled):not(.disabled).active,.dark-deep-orange a.btn-danger:not(:disabled):not(.disabled):active,.show>.dark-deep-orange a.btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.dark-deep-orange a.btn-danger:not(:disabled):not(.disabled).active:focus,.dark-deep-orange a.btn-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-orange a.btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-deep-orange a.btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-deep-orange a.btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.dark-deep-orange a.btn-light.focus,.dark-deep-orange a.btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.dark-deep-orange a.btn-light.disabled,.dark-deep-orange a.btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-deep-orange a.btn-light:not(:disabled):not(.disabled).active,.dark-deep-orange a.btn-light:not(:disabled):not(.disabled):active,.show>.dark-deep-orange a.btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.dark-deep-orange a.btn-light:not(:disabled):not(.disabled).active:focus,.dark-deep-orange a.btn-light:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-orange a.btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-deep-orange a.btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-deep-orange a.btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.dark-deep-orange a.btn-dark.focus,.dark-deep-orange a.btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.dark-deep-orange a.btn-dark.disabled,.dark-deep-orange a.btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.dark-deep-orange a.btn-dark:not(:disabled):not(.disabled).active,.dark-deep-orange a.btn-dark:not(:disabled):not(.disabled):active,.show>.dark-deep-orange a.btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.dark-deep-orange a.btn-dark:not(:disabled):not(.disabled).active:focus,.dark-deep-orange a.btn-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-orange a.btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-deep-orange .btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.dark-deep-orange .btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-deep-orange .btn-outline-primary.focus,.dark-deep-orange .btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.dark-deep-orange .btn-outline-primary.disabled,.dark-deep-orange .btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.dark-deep-orange .btn-outline-primary:not(:disabled):not(.disabled).active,.dark-deep-orange .btn-outline-primary:not(:disabled):not(.disabled):active,.show>.dark-deep-orange .btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-deep-orange .btn-outline-primary:not(:disabled):not(.disabled).active:focus,.dark-deep-orange .btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-orange .btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-deep-orange .btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.dark-deep-orange .btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-deep-orange .btn-outline-secondary.focus,.dark-deep-orange .btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.dark-deep-orange .btn-outline-secondary.disabled,.dark-deep-orange .btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.dark-deep-orange .btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-deep-orange .btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.dark-deep-orange .btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-deep-orange .btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.dark-deep-orange .btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-orange .btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-deep-orange .btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.dark-deep-orange .btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-deep-orange .btn-outline-success.focus,.dark-deep-orange .btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.dark-deep-orange .btn-outline-success.disabled,.dark-deep-orange .btn-outline-success:disabled{color:#4caf50;background-color:transparent}.dark-deep-orange .btn-outline-success:not(:disabled):not(.disabled).active,.dark-deep-orange .btn-outline-success:not(:disabled):not(.disabled):active,.show>.dark-deep-orange .btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-deep-orange .btn-outline-success:not(:disabled):not(.disabled).active:focus,.dark-deep-orange .btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-orange .btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-deep-orange .btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.dark-deep-orange .btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-deep-orange .btn-outline-info.focus,.dark-deep-orange .btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.dark-deep-orange .btn-outline-info.disabled,.dark-deep-orange .btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.dark-deep-orange .btn-outline-info:not(:disabled):not(.disabled).active,.dark-deep-orange .btn-outline-info:not(:disabled):not(.disabled):active,.show>.dark-deep-orange .btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-deep-orange .btn-outline-info:not(:disabled):not(.disabled).active:focus,.dark-deep-orange .btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-orange .btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-deep-orange .btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.dark-deep-orange .btn-outline-warning:hover{color:#fff;background-color:#ff9800;border-color:#ff9800}.dark-deep-orange .btn-outline-warning.focus,.dark-deep-orange .btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.dark-deep-orange .btn-outline-warning.disabled,.dark-deep-orange .btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.dark-deep-orange .btn-outline-warning:not(:disabled):not(.disabled).active,.dark-deep-orange .btn-outline-warning:not(:disabled):not(.disabled):active,.show>.dark-deep-orange .btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-deep-orange .btn-outline-warning:not(:disabled):not(.disabled).active:focus,.dark-deep-orange .btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-orange .btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-deep-orange .btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.dark-deep-orange .btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.dark-deep-orange .btn-outline-danger.focus,.dark-deep-orange .btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.dark-deep-orange .btn-outline-danger.disabled,.dark-deep-orange .btn-outline-danger:disabled{color:#f44336;background-color:transparent}.dark-deep-orange .btn-outline-danger:not(:disabled):not(.disabled).active,.dark-deep-orange .btn-outline-danger:not(:disabled):not(.disabled):active,.show>.dark-deep-orange .btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.dark-deep-orange .btn-outline-danger:not(:disabled):not(.disabled).active:focus,.dark-deep-orange .btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-orange .btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-deep-orange .btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.dark-deep-orange .btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-deep-orange .btn-outline-light.focus,.dark-deep-orange .btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.dark-deep-orange .btn-outline-light.disabled,.dark-deep-orange .btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.dark-deep-orange .btn-outline-light:not(:disabled):not(.disabled).active,.dark-deep-orange .btn-outline-light:not(:disabled):not(.disabled):active,.show>.dark-deep-orange .btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-deep-orange .btn-outline-light:not(:disabled):not(.disabled).active:focus,.dark-deep-orange .btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-orange .btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-deep-orange .btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.dark-deep-orange .btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.dark-deep-orange .btn-outline-dark.focus,.dark-deep-orange .btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.dark-deep-orange .btn-outline-dark.disabled,.dark-deep-orange .btn-outline-dark:disabled{color:#343a40;background-color:transparent}.dark-deep-orange .btn-outline-dark:not(:disabled):not(.disabled).active,.dark-deep-orange .btn-outline-dark:not(:disabled):not(.disabled):active,.show>.dark-deep-orange .btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.dark-deep-orange .btn-outline-dark:not(:disabled):not(.disabled).active:focus,.dark-deep-orange .btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-orange .btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-deep-orange a.btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.dark-deep-orange a.btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-deep-orange a.btn-outline-primary.focus,.dark-deep-orange a.btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.dark-deep-orange a.btn-outline-primary.disabled,.dark-deep-orange a.btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.dark-deep-orange a.btn-outline-primary:not(:disabled):not(.disabled).active,.dark-deep-orange a.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.dark-deep-orange a.btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-deep-orange a.btn-outline-primary:not(:disabled):not(.disabled).active:focus,.dark-deep-orange a.btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-orange a.btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-deep-orange a.btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.dark-deep-orange a.btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-deep-orange a.btn-outline-secondary.focus,.dark-deep-orange a.btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.dark-deep-orange a.btn-outline-secondary.disabled,.dark-deep-orange a.btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.dark-deep-orange a.btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-deep-orange a.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.dark-deep-orange a.btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-deep-orange a.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.dark-deep-orange a.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-orange a.btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-deep-orange a.btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.dark-deep-orange a.btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-deep-orange a.btn-outline-success.focus,.dark-deep-orange a.btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.dark-deep-orange a.btn-outline-success.disabled,.dark-deep-orange a.btn-outline-success:disabled{color:#4caf50;background-color:transparent}.dark-deep-orange a.btn-outline-success:not(:disabled):not(.disabled).active,.dark-deep-orange a.btn-outline-success:not(:disabled):not(.disabled):active,.show>.dark-deep-orange a.btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-deep-orange a.btn-outline-success:not(:disabled):not(.disabled).active:focus,.dark-deep-orange a.btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-orange a.btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-deep-orange a.btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.dark-deep-orange a.btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-deep-orange a.btn-outline-info.focus,.dark-deep-orange a.btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.dark-deep-orange a.btn-outline-info.disabled,.dark-deep-orange a.btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.dark-deep-orange a.btn-outline-info:not(:disabled):not(.disabled).active,.dark-deep-orange a.btn-outline-info:not(:disabled):not(.disabled):active,.show>.dark-deep-orange a.btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-deep-orange a.btn-outline-info:not(:disabled):not(.disabled).active:focus,.dark-deep-orange a.btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-orange a.btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-deep-orange a.btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.dark-deep-orange a.btn-outline-warning:hover{color:#fff;background-color:#ff9800;border-color:#ff9800}.dark-deep-orange a.btn-outline-warning.focus,.dark-deep-orange a.btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.dark-deep-orange a.btn-outline-warning.disabled,.dark-deep-orange a.btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.dark-deep-orange a.btn-outline-warning:not(:disabled):not(.disabled).active,.dark-deep-orange a.btn-outline-warning:not(:disabled):not(.disabled):active,.show>.dark-deep-orange a.btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-deep-orange a.btn-outline-warning:not(:disabled):not(.disabled).active:focus,.dark-deep-orange a.btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-orange a.btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-deep-orange a.btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.dark-deep-orange a.btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.dark-deep-orange a.btn-outline-danger.focus,.dark-deep-orange a.btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.dark-deep-orange a.btn-outline-danger.disabled,.dark-deep-orange a.btn-outline-danger:disabled{color:#f44336;background-color:transparent}.dark-deep-orange a.btn-outline-danger:not(:disabled):not(.disabled).active,.dark-deep-orange a.btn-outline-danger:not(:disabled):not(.disabled):active,.show>.dark-deep-orange a.btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.dark-deep-orange a.btn-outline-danger:not(:disabled):not(.disabled).active:focus,.dark-deep-orange a.btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-orange a.btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-deep-orange a.btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.dark-deep-orange a.btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-deep-orange a.btn-outline-light.focus,.dark-deep-orange a.btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.dark-deep-orange a.btn-outline-light.disabled,.dark-deep-orange a.btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.dark-deep-orange a.btn-outline-light:not(:disabled):not(.disabled).active,.dark-deep-orange a.btn-outline-light:not(:disabled):not(.disabled):active,.show>.dark-deep-orange a.btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-deep-orange a.btn-outline-light:not(:disabled):not(.disabled).active:focus,.dark-deep-orange a.btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-orange a.btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-deep-orange a.btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.dark-deep-orange a.btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.dark-deep-orange a.btn-outline-dark.focus,.dark-deep-orange a.btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.dark-deep-orange a.btn-outline-dark.disabled,.dark-deep-orange a.btn-outline-dark:disabled{color:#343a40;background-color:transparent}.dark-deep-orange a.btn-outline-dark:not(:disabled):not(.disabled).active,.dark-deep-orange a.btn-outline-dark:not(:disabled):not(.disabled):active,.show>.dark-deep-orange a.btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.dark-deep-orange a.btn-outline-dark:not(:disabled):not(.disabled).active:focus,.dark-deep-orange a.btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-orange a.btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-deep-orange .btn-outline-primary,.dark-deep-orange a.btn-outline-primary{color:#ff5722;border-color:#ff5722}.dark-deep-orange .btn-outline-primary.disabled,.dark-deep-orange .btn-outline-primary:disabled,.dark-deep-orange .btn-outline-primary:focus,.dark-deep-orange .btn-outline-primary:hover,.dark-deep-orange .btn-outline-primary:not(:disabled):not(.disabled).active,.dark-deep-orange .btn-outline-primary:not(:disabled):not(.disabled):active,.dark-deep-orange a.btn-outline-primary.disabled,.dark-deep-orange a.btn-outline-primary:disabled,.dark-deep-orange a.btn-outline-primary:focus,.dark-deep-orange a.btn-outline-primary:hover,.dark-deep-orange a.btn-outline-primary:not(:disabled):not(.disabled).active,.dark-deep-orange a.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.dark-deep-orange .btn-outline-primary.dropdown-toggle,.show>.dark-deep-orange a.btn-outline-primary.dropdown-toggle{color:#fff;border-color:#ff5722;background-color:#ff5722}.dark-deep-orange .btn-outline-secondary,.dark-deep-orange a.btn-outline-secondary{color:#40c4ff;border-color:#40c4ff}.dark-deep-orange .btn-outline-secondary.disabled,.dark-deep-orange .btn-outline-secondary:disabled,.dark-deep-orange .btn-outline-secondary:focus,.dark-deep-orange .btn-outline-secondary:hover,.dark-deep-orange .btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-deep-orange .btn-outline-secondary:not(:disabled):not(.disabled):active,.dark-deep-orange a.btn-outline-secondary.disabled,.dark-deep-orange a.btn-outline-secondary:disabled,.dark-deep-orange a.btn-outline-secondary:focus,.dark-deep-orange a.btn-outline-secondary:hover,.dark-deep-orange a.btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-deep-orange a.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.dark-deep-orange .btn-outline-secondary.dropdown-toggle,.show>.dark-deep-orange a.btn-outline-secondary.dropdown-toggle{color:#fff;border-color:#40c4ff;background-color:#40c4ff}.dark-deep-orange a,.dark-deep-orange a.text-primary{color:#ff5722}.dark-deep-orange a.text-primary:focus,.dark-deep-orange a.text-primary:hover,.dark-deep-orange a:focus,.dark-deep-orange a:hover{color:#ee3900}.dark-deep-orange .text-primary{color:#ff5722!important}.dark-deep-orange .page-link,.dark-deep-orange .page-link:focus,.dark-deep-orange .page-link:hover{color:#ff5722}.dark-deep-orange .badge-primary,.dark-deep-orange .bg-primary{background-color:#ff5722!important;color:#fff!important}.dark-deep-orange .btn-primary,.dark-deep-orange .jr-btn-primary,.dark-deep-orange a.btn-primary,.dark-deep-orange a.jr-btn-primary{background-color:#ff5722;border-color:#ff5722;color:#fff}.dark-deep-orange .btn-primary:focus,.dark-deep-orange .btn-primary:hover,.dark-deep-orange .btn-primary:not([disabled]):not(.disabled):active,.dark-deep-orange .jr-btn-primary:focus,.dark-deep-orange .jr-btn-primary:hover,.dark-deep-orange .jr-btn-primary:not([disabled]):not(.disabled):active,.dark-deep-orange a.btn-primary:focus,.dark-deep-orange a.btn-primary:hover,.dark-deep-orange a.btn-primary:not([disabled]):not(.disabled):active,.dark-deep-orange a.jr-btn-primary:focus,.dark-deep-orange a.jr-btn-primary:hover,.dark-deep-orange a.jr-btn-primary:not([disabled]):not(.disabled):active{background-color:#ff4409!important;border-color:#ff4409!important;color:#fff!important}.dark-deep-orange .bg-primary.lighten-4{background-color:#ffccbc!important}.dark-deep-orange .bg-primary.lighten-3{background-color:#ffab91!important}.dark-deep-orange .bg-primary.lighten-2{background-color:#ff8a65!important}.dark-deep-orange .bg-primary.lighten-1{background-color:#ff7043!important}.dark-deep-orange .bg-primary.darken-1{background-color:#f4511e!important}.dark-deep-orange .bg-primary.darken-2{background-color:#e64a19!important}.dark-deep-orange .bg-primary.darken-3{background-color:#d84315!important}.dark-deep-orange .bg-primary.darken-4{background-color:#bf360c!important}.dark-deep-orange .bg-primary.accent-1{background-color:#ff9e80!important}.dark-deep-orange .bg-primary.accent-2{background-color:#ff6e40!important}.dark-deep-orange .bg-primary.accent-3{background-color:#ff3d00!important}.dark-deep-orange .bg-primary.accent-4{background-color:#dd2c00!important}.dark-deep-orange a.text-secondary{color:#40c4ff}.dark-deep-orange a.text-secondary:focus,.dark-deep-orange a.text-secondary:hover{color:#0db4ff!important}.dark-deep-orange .text-secondary{color:#40c4ff!important}.dark-deep-orange .badge-secondary,.dark-deep-orange .bg-secondary{background-color:#40c4ff!important;color:#fff!important}.dark-deep-orange .btn-secondary{background-color:#40c4ff;border-color:#40c4ff;color:#fff}.dark-deep-orange .btn-secondary:active,.dark-deep-orange .btn-secondary:focus,.dark-deep-orange .btn-secondary:hover{background-color:#27bcff!important;border-color:#27bcff!important;color:#fff!important}.dark-deep-orange .jr-flat-btn{background-color:transparent!important;color:#5c5c5c!important}.dark-deep-orange .jr-flat-btn:active,.dark-deep-orange .jr-flat-btn:focus,.dark-deep-orange .jr-flat-btn:hover{background-color:#f5f5f5!important;color:#5c5c5c!important}.dark-deep-orange .jr-flat-btn.jr-btn-primary{background-color:transparent!important;color:#ff5722!important;border-color:transparent!important}.dark-deep-orange .jr-flat-btn.jr-btn-primary:focus,.dark-deep-orange .jr-flat-btn.jr-btn-primary:hover{background-color:rgba(255,87,34,.12)!important;color:#ff5722!important}.dark-deep-orange .bg-primary .jr-flat-btn.jr-btn-primary{background-color:transparent!important;color:#fff!important;border-color:transparent!important}.dark-deep-orange .bg-primary .jr-flat-btn.jr-btn-primary:focus,.dark-deep-orange .bg-primary .jr-flat-btn.jr-btn-primary:hover{background-color:hsla(0,0%,100%,.12)!important;color:#fff!important}.dark-deep-orange .jr-flat-btn.jr-btn-secondary{background-color:transparent!important;color:#40c4ff!important;border-color:transparent!important}.dark-deep-orange .jr-flat-btn.jr-btn-secondary:focus,.dark-deep-orange .jr-flat-btn.jr-btn-secondary:hover{background-color:rgba(64,196,255,.12)!important;color:#40c4ff!important}.dark-deep-orange .bg-secondary .jr-flat-btn.jr-btn-secondary{background-color:transparent!important;color:#fff!important;border-color:transparent!important}.dark-deep-orange .bg-secondary .jr-flat-btn.jr-btn-secondary:focus,.dark-deep-orange .bg-secondary .jr-flat-btn.jr-btn-secondary:hover{background-color:hsla(0,0%,100%,.12)!important;color:#fff!important}.dark-deep-orange .app-main-header{background-color:#ff5722!important;color:#fff;border-color:#ff5722}.dark-deep-orange .app-main-header .search-bar input{background-color:#ff6a3c}.dark-deep-orange .app-main-header .search-bar input+.search-icon i{color:#fff}.dark-deep-orange .app-main-header .search-bar input:focus{background-color:#fff}.dark-deep-orange .app-main-header .search-bar input:focus+.search-icon i{color:hsla(0,0%,50%,.8)}@media screen and (max-width:575px){.dark-deep-orange .app-main-header .search-dropdown input{background-color:#fff}.dark-deep-orange .app-main-header .search-dropdown input+.search-icon i{color:hsla(0,0%,50%,.8)}}.dark-deep-orange .app-main-header .jr-menu-icon .menu-icon{background-color:#fff!important}.dark-deep-orange .app-header .jr-menu-icon .menu-icon{background-color:#fff}.dark-deep-orange .quick-menu .icon-btn{color:#fff}.dark-deep-orange .react-logo-white.d-block{display:block!important}@media screen and (min-width:992px){.dark-deep-orange .react-logo-white.d-lg-block{display:block!important}.dark-deep-orange .react-logo-white.d-lg-none{display:none!important}}.dark-deep-orange .react-logo-color.d-block{display:none!important}@media screen and (min-width:992px){.dark-deep-orange .react-logo-color.d-lg-block{display:none!important}}.dark-deep-orange .color-theme-header{background-color:#ff5722}.dark-deep-orange .sidebar-header{border-bottom:0 none;background-color:#1d1d1d}.dark-deep-orange .side-nav{background-color:#252525!important;color:#a1a1a1!important;border-right:0 none!important}.dark-deep-orange .side-nav .user-profile{background-color:#1d1d1d;position:relative;z-index:2}.dark-deep-orange .side-nav .customizer{border-bottom:0 none}.dark-deep-orange .side-nav .user-detail .user-name{color:#fff}.dark-deep-orange ul.nav-menu .nav-header,.dark-deep-orange ul.nav-menu li a{color:#a1a1a1}.dark-deep-orange ul.nav-menu>li.open>a,.dark-deep-orange ul.nav-menu>li>a:focus,.dark-deep-orange ul.nav-menu>li>a:hover{background-color:#1d1d1d;color:#fff}.dark-deep-orange ul.nav-menu li.menu.open>a{border-color:#ff5722}.dark-deep-orange ul.nav-menu li.menu>a:focus:before,.dark-deep-orange ul.nav-menu li.menu>a:hover:before{color:#fff}.dark-deep-orange ul.nav-menu li ul{background-color:#1d1d1d}.dark-deep-orange ul.nav-menu li.menu>a:before{color:#a1a1a1}.dark-deep-orange ul.nav-menu li.menu.open>a:before,.dark-deep-orange ul.nav-menu li.menu>a:focus:before,.dark-deep-orange ul.nav-menu li.menu li>a:hover:before{color:#fff}.dark-deep-orange ul.nav-menu li.menu .sub-menu li>a:before{color:#a1a1a1}.dark-deep-orange ul.nav-menu li.menu .sub-menu li>a.active .nav-text{background-color:#ff5722}.dark-deep-orange ul.nav-menu li.menu.open .sub-menu li>a.active:before,.dark-deep-orange ul.nav-menu li.menu .sub-menu li>a:focus,.dark-deep-orange ul.nav-menu li.menu .sub-menu li>a:focus:before,.dark-deep-orange ul.nav-menu li.menu .sub-menu li>a:hover,.dark-deep-orange ul.nav-menu li.menu .sub-menu li>a:hover:before{background-color:#1d1d1d;color:#fff}.dark-deep-orange .navbar-nav li:focus>a,.dark-deep-orange .navbar-nav li:hover>a{color:#ff5722}.dark-deep-orange .navbar-nav li a{color:#868e96}.dark-deep-orange .navbar-nav li a:focus,.dark-deep-orange .navbar-nav li a:hover{color:#ff5722}.dark-deep-orange .navbar-nav li.nav-item>a{color:#fff}.dark-deep-orange .navbar-nav li.nav-item.active>a,.dark-deep-orange .navbar-nav li.nav-item:focus>a,.dark-deep-orange .navbar-nav li.nav-item:hover>a,.dark-deep-orange .navbar-nav li.nav-item>a:focus,.dark-deep-orange .navbar-nav li.nav-item>a:hover{color:#40c4ff}.dark-deep-orange .navbar-nav ul.sub-menu li.active>a,.dark-deep-orange .navbar-nav ul.sub-menu li a.active{color:#ff5722}.dark-deep-orange .navbar-nav .nav-arrow>a:before{color:#868e96}.dark-deep-orange .navbar-nav .nav-arrow.active>a:before,.dark-deep-orange .navbar-nav .nav-arrow:focus>a:before,.dark-deep-orange .navbar-nav .nav-arrow:hover>a:before,.dark-deep-orange .navbar-nav .nav-arrow a:focus:before,.dark-deep-orange .navbar-nav .nav-arrow a:hover:before{color:#ff5722}.dark-deep-orange .app-top-nav{background-color:#252525!important;border-color:#252525}.dark-deep-orange .app-top-nav .navbar-nav li.nav-item>a{color:#fff}.dark-deep-orange .app-top-nav .navbar-nav li.nav-item.active>a,.dark-deep-orange .app-top-nav .navbar-nav li.nav-item:focus>a,.dark-deep-orange .app-top-nav .navbar-nav li.nav-item:hover>a,.dark-deep-orange .app-top-nav .navbar-nav li.nav-item>a:focus,.dark-deep-orange .app-top-nav .navbar-nav li.nav-item>a:hover{color:#40c4ff}.dark-deep-orange .module-nav li a.active{border-color:#ff5722}.dark-deep-orange .rbc-event{background-color:#ff5722}.dark-deep-orange .rbc-event.rbc-selected{background-color:#ee3900}.dark-deep-orange .rbc-slot-selection{background-color:rgba(255,87,34,.7)}.dark-deep-orange .rbc-toolbar button.rbc-active,.dark-deep-orange .rbc-toolbar button.rbc-active:focus,.dark-deep-orange .rbc-toolbar button.rbc-active:hover,.dark-deep-orange .rbc-toolbar button:active,.dark-deep-orange .rbc-toolbar button:active:focus,.dark-deep-orange .rbc-toolbar button:active:hover,.dark-deep-orange .rbc-toolbar button:focus,.dark-deep-orange .rbc-toolbar button:hover{background-color:rgba(255,87,34,.9);border-color:#ff5722}.dark-deep-orange .rbc-day-slot .rbc-event{border-color:#ff5722}.dark-deep-orange .chat-sidenav-title{color:#ff5722}.dark-deep-orange .chat-user-item.active,.dark-deep-orange .chat-user-item:hover{background-color:#fff2ee}.dark-deep-orange .contact-list i{color:#ff5722}.dark-deep-orange .Collapsible__trigger{background:#ff5722}.dark-deep-orange .categories-list li.active a,.dark-deep-orange .categories-list li a:focus,.dark-deep-orange .categories-list li a:hover{color:#ff5722}.dark-deep-orange .filter-with-bg-color ul li a,.dark-deep-orange .login-content .form-control:focus{border-color:#ff5722}.dark-deep-orange .filter-with-bg-color ul li a.active,.dark-deep-orange .filter-with-bg-color ul li a:focus,.dark-deep-orange .filter-with-bg-color ul li a:hover{background-color:#ff5722}.dark-deep-orange .profile-intro .icon{color:#ff5722}.dark-deep-orange .actions,.dark-deep-orange .social-link li.active a,.dark-deep-orange .social-link li a:focus,.dark-deep-orange .social-link li a:hover{color:#40c4ff}.dark-deep-orange .table-hover tbody tr:hover{background-color:rgba(255,87,34,.075)}.dark-deep-orange .border-primary{border-color:#ff5722!important}.dark-deep-orange .app-logo-content{background-color:#ff5722}.dark-deep-orange .app-social-block .social-link button{border:1px solid #ff5722;color:#ff5722}.dark-deep-orange .app-social-block .social-link button:focus,.dark-deep-orange .app-social-block .social-link button:hover{color:#fff;background-color:#ff5722}.dark-deep-orange .btn-group-vertical>.btn-default.active,.dark-deep-orange .btn-group-vertical>.jr-btn.active,.dark-deep-orange .btn-group>.btn-default.active,.dark-deep-orange .btn-group>.jr-btn.active{background-color:#ff5722;border-color:#ff5722}.dark-deep-orange .btn-group-vertical>.jr-flat-btn,.dark-deep-orange .btn-group>.jr-flat-btn{border-color:transparent}.dark-deep-orange .btn-group-vertical>.jr-flat-btn.active,.dark-deep-orange .btn-group>.jr-flat-btn.active{background-color:transparent;color:#ff5722!important;border-color:transparent!important}.dark-deep-orange .btn-group-vertical>.jr-flat-btn.active:focus,.dark-deep-orange .btn-group-vertical>.jr-flat-btn.active:hover,.dark-deep-orange .btn-group>.jr-flat-btn.active:focus,.dark-deep-orange .btn-group>.jr-flat-btn.active:hover{background-color:rgba(255,87,34,.12)!important;color:#ff5722!important}.dark-deep-orange .nav-pill-sales .nav-link.active{background-color:#ff5722;border-color:#ff5722}.dark-deep-orange .form-checkbox>input+.check,.dark-deep-orange .form-checkbox>input.sm+.check{color:#ff5722}.dark-deep-orange .app-main-header ::-webkit-input-placeholder{color:#ebebeb}.dark-deep-orange .app-main-header ::-moz-placeholder{color:#ebebeb}.dark-deep-orange .app-main-header :-ms-input-placeholder{color:#ebebeb}.dark-deep-orange .app-main-header :-moz-placeholder{color:#ebebeb}.dark-deep-orange .app-main-header input:focus::-webkit-input-placeholder{color:#dcdcdc}.dark-deep-orange .app-main-header input:focus::-moz-placeholder{color:#dcdcdc}.dark-deep-orange .app-main-header input:focus:-ms-input-placeholder{color:#dcdcdc}.dark-deep-orange .app-main-header input:focus:-moz-placeholder{color:#dcdcdc}.dark-pink .right-arrow,.dark-pink .right-arrow:after{color:#e91e63}.dark-pink .btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-pink .btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.dark-pink .btn-primary.focus,.dark-pink .btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.dark-pink .btn-primary.disabled,.dark-pink .btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-pink .btn-primary:not(:disabled):not(.disabled).active,.dark-pink .btn-primary:not(:disabled):not(.disabled):active,.show>.dark-pink .btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.dark-pink .btn-primary:not(:disabled):not(.disabled).active:focus,.dark-pink .btn-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-pink .btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-pink .btn-secondary{background-color:#e91e63;border-color:#e91e63;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-pink .btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.dark-pink .btn-secondary.focus,.dark-pink .btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.dark-pink .btn-secondary.disabled,.dark-pink .btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-pink .btn-secondary:not(:disabled):not(.disabled).active,.dark-pink .btn-secondary:not(:disabled):not(.disabled):active,.show>.dark-pink .btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.dark-pink .btn-secondary:not(:disabled):not(.disabled).active:focus,.dark-pink .btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-pink .btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-pink .btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-pink .btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.dark-pink .btn-success.focus,.dark-pink .btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.dark-pink .btn-success.disabled,.dark-pink .btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-pink .btn-success:not(:disabled):not(.disabled).active,.dark-pink .btn-success:not(:disabled):not(.disabled):active,.show>.dark-pink .btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.dark-pink .btn-success:not(:disabled):not(.disabled).active:focus,.dark-pink .btn-success:not(:disabled):not(.disabled):active:focus,.show>.dark-pink .btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-pink .btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-pink .btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.dark-pink .btn-info.focus,.dark-pink .btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.dark-pink .btn-info.disabled,.dark-pink .btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-pink .btn-info:not(:disabled):not(.disabled).active,.dark-pink .btn-info:not(:disabled):not(.disabled):active,.show>.dark-pink .btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.dark-pink .btn-info:not(:disabled):not(.disabled).active:focus,.dark-pink .btn-info:not(:disabled):not(.disabled):active:focus,.show>.dark-pink .btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-pink .btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-pink .btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.dark-pink .btn-warning.focus,.dark-pink .btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.dark-pink .btn-warning.disabled,.dark-pink .btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-pink .btn-warning:not(:disabled):not(.disabled).active,.dark-pink .btn-warning:not(:disabled):not(.disabled):active,.show>.dark-pink .btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.dark-pink .btn-warning:not(:disabled):not(.disabled).active:focus,.dark-pink .btn-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-pink .btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-pink .btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-pink .btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.dark-pink .btn-danger.focus,.dark-pink .btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.dark-pink .btn-danger.disabled,.dark-pink .btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.dark-pink .btn-danger:not(:disabled):not(.disabled).active,.dark-pink .btn-danger:not(:disabled):not(.disabled):active,.show>.dark-pink .btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.dark-pink .btn-danger:not(:disabled):not(.disabled).active:focus,.dark-pink .btn-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-pink .btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-pink .btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-pink .btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.dark-pink .btn-light.focus,.dark-pink .btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.dark-pink .btn-light.disabled,.dark-pink .btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-pink .btn-light:not(:disabled):not(.disabled).active,.dark-pink .btn-light:not(:disabled):not(.disabled):active,.show>.dark-pink .btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.dark-pink .btn-light:not(:disabled):not(.disabled).active:focus,.dark-pink .btn-light:not(:disabled):not(.disabled):active:focus,.show>.dark-pink .btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-pink .btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-pink .btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.dark-pink .btn-dark.focus,.dark-pink .btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.dark-pink .btn-dark.disabled,.dark-pink .btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.dark-pink .btn-dark:not(:disabled):not(.disabled).active,.dark-pink .btn-dark:not(:disabled):not(.disabled):active,.show>.dark-pink .btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.dark-pink .btn-dark:not(:disabled):not(.disabled).active:focus,.dark-pink .btn-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-pink .btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-pink a.btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-pink a.btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.dark-pink a.btn-primary.focus,.dark-pink a.btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.dark-pink a.btn-primary.disabled,.dark-pink a.btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-pink a.btn-primary:not(:disabled):not(.disabled).active,.dark-pink a.btn-primary:not(:disabled):not(.disabled):active,.show>.dark-pink a.btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.dark-pink a.btn-primary:not(:disabled):not(.disabled).active:focus,.dark-pink a.btn-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-pink a.btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-pink a.btn-secondary{color:#fff;background-color:#e91e63;border-color:#e91e63;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-pink a.btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.dark-pink a.btn-secondary.focus,.dark-pink a.btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.dark-pink a.btn-secondary.disabled,.dark-pink a.btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-pink a.btn-secondary:not(:disabled):not(.disabled).active,.dark-pink a.btn-secondary:not(:disabled):not(.disabled):active,.show>.dark-pink a.btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.dark-pink a.btn-secondary:not(:disabled):not(.disabled).active:focus,.dark-pink a.btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-pink a.btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-pink a.btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-pink a.btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.dark-pink a.btn-success.focus,.dark-pink a.btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.dark-pink a.btn-success.disabled,.dark-pink a.btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-pink a.btn-success:not(:disabled):not(.disabled).active,.dark-pink a.btn-success:not(:disabled):not(.disabled):active,.show>.dark-pink a.btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.dark-pink a.btn-success:not(:disabled):not(.disabled).active:focus,.dark-pink a.btn-success:not(:disabled):not(.disabled):active:focus,.show>.dark-pink a.btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-pink a.btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-pink a.btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.dark-pink a.btn-info.focus,.dark-pink a.btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.dark-pink a.btn-info.disabled,.dark-pink a.btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-pink a.btn-info:not(:disabled):not(.disabled).active,.dark-pink a.btn-info:not(:disabled):not(.disabled):active,.show>.dark-pink a.btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.dark-pink a.btn-info:not(:disabled):not(.disabled).active:focus,.dark-pink a.btn-info:not(:disabled):not(.disabled):active:focus,.show>.dark-pink a.btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-pink a.btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-pink a.btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.dark-pink a.btn-warning.focus,.dark-pink a.btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.dark-pink a.btn-warning.disabled,.dark-pink a.btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-pink a.btn-warning:not(:disabled):not(.disabled).active,.dark-pink a.btn-warning:not(:disabled):not(.disabled):active,.show>.dark-pink a.btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.dark-pink a.btn-warning:not(:disabled):not(.disabled).active:focus,.dark-pink a.btn-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-pink a.btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-pink a.btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-pink a.btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.dark-pink a.btn-danger.focus,.dark-pink a.btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.dark-pink a.btn-danger.disabled,.dark-pink a.btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.dark-pink a.btn-danger:not(:disabled):not(.disabled).active,.dark-pink a.btn-danger:not(:disabled):not(.disabled):active,.show>.dark-pink a.btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.dark-pink a.btn-danger:not(:disabled):not(.disabled).active:focus,.dark-pink a.btn-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-pink a.btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-pink a.btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-pink a.btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.dark-pink a.btn-light.focus,.dark-pink a.btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.dark-pink a.btn-light.disabled,.dark-pink a.btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-pink a.btn-light:not(:disabled):not(.disabled).active,.dark-pink a.btn-light:not(:disabled):not(.disabled):active,.show>.dark-pink a.btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.dark-pink a.btn-light:not(:disabled):not(.disabled).active:focus,.dark-pink a.btn-light:not(:disabled):not(.disabled):active:focus,.show>.dark-pink a.btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-pink a.btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-pink a.btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.dark-pink a.btn-dark.focus,.dark-pink a.btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.dark-pink a.btn-dark.disabled,.dark-pink a.btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.dark-pink a.btn-dark:not(:disabled):not(.disabled).active,.dark-pink a.btn-dark:not(:disabled):not(.disabled):active,.show>.dark-pink a.btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.dark-pink a.btn-dark:not(:disabled):not(.disabled).active:focus,.dark-pink a.btn-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-pink a.btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-pink .btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.dark-pink .btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-pink .btn-outline-primary.focus,.dark-pink .btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.dark-pink .btn-outline-primary.disabled,.dark-pink .btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.dark-pink .btn-outline-primary:not(:disabled):not(.disabled).active,.dark-pink .btn-outline-primary:not(:disabled):not(.disabled):active,.show>.dark-pink .btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-pink .btn-outline-primary:not(:disabled):not(.disabled).active:focus,.dark-pink .btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-pink .btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-pink .btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.dark-pink .btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-pink .btn-outline-secondary.focus,.dark-pink .btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.dark-pink .btn-outline-secondary.disabled,.dark-pink .btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.dark-pink .btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-pink .btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.dark-pink .btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-pink .btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.dark-pink .btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-pink .btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-pink .btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.dark-pink .btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-pink .btn-outline-success.focus,.dark-pink .btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.dark-pink .btn-outline-success.disabled,.dark-pink .btn-outline-success:disabled{color:#4caf50;background-color:transparent}.dark-pink .btn-outline-success:not(:disabled):not(.disabled).active,.dark-pink .btn-outline-success:not(:disabled):not(.disabled):active,.show>.dark-pink .btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-pink .btn-outline-success:not(:disabled):not(.disabled).active:focus,.dark-pink .btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.dark-pink .btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-pink .btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.dark-pink .btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-pink .btn-outline-info.focus,.dark-pink .btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.dark-pink .btn-outline-info.disabled,.dark-pink .btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.dark-pink .btn-outline-info:not(:disabled):not(.disabled).active,.dark-pink .btn-outline-info:not(:disabled):not(.disabled):active,.show>.dark-pink .btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-pink .btn-outline-info:not(:disabled):not(.disabled).active:focus,.dark-pink .btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.dark-pink .btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-pink .btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.dark-pink .btn-outline-warning:hover{color:#fff;background-color:#ff9800;border-color:#ff9800}.dark-pink .btn-outline-warning.focus,.dark-pink .btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.dark-pink .btn-outline-warning.disabled,.dark-pink .btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.dark-pink .btn-outline-warning:not(:disabled):not(.disabled).active,.dark-pink .btn-outline-warning:not(:disabled):not(.disabled):active,.show>.dark-pink .btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-pink .btn-outline-warning:not(:disabled):not(.disabled).active:focus,.dark-pink .btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-pink .btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-pink .btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.dark-pink .btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.dark-pink .btn-outline-danger.focus,.dark-pink .btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.dark-pink .btn-outline-danger.disabled,.dark-pink .btn-outline-danger:disabled{color:#f44336;background-color:transparent}.dark-pink .btn-outline-danger:not(:disabled):not(.disabled).active,.dark-pink .btn-outline-danger:not(:disabled):not(.disabled):active,.show>.dark-pink .btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.dark-pink .btn-outline-danger:not(:disabled):not(.disabled).active:focus,.dark-pink .btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-pink .btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-pink .btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.dark-pink .btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-pink .btn-outline-light.focus,.dark-pink .btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.dark-pink .btn-outline-light.disabled,.dark-pink .btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.dark-pink .btn-outline-light:not(:disabled):not(.disabled).active,.dark-pink .btn-outline-light:not(:disabled):not(.disabled):active,.show>.dark-pink .btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-pink .btn-outline-light:not(:disabled):not(.disabled).active:focus,.dark-pink .btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.dark-pink .btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-pink .btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.dark-pink .btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.dark-pink .btn-outline-dark.focus,.dark-pink .btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.dark-pink .btn-outline-dark.disabled,.dark-pink .btn-outline-dark:disabled{color:#343a40;background-color:transparent}.dark-pink .btn-outline-dark:not(:disabled):not(.disabled).active,.dark-pink .btn-outline-dark:not(:disabled):not(.disabled):active,.show>.dark-pink .btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.dark-pink .btn-outline-dark:not(:disabled):not(.disabled).active:focus,.dark-pink .btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-pink .btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-pink a.btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.dark-pink a.btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-pink a.btn-outline-primary.focus,.dark-pink a.btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.dark-pink a.btn-outline-primary.disabled,.dark-pink a.btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.dark-pink a.btn-outline-primary:not(:disabled):not(.disabled).active,.dark-pink a.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.dark-pink a.btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-pink a.btn-outline-primary:not(:disabled):not(.disabled).active:focus,.dark-pink a.btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-pink a.btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-pink a.btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.dark-pink a.btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-pink a.btn-outline-secondary.focus,.dark-pink a.btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.dark-pink a.btn-outline-secondary.disabled,.dark-pink a.btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.dark-pink a.btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-pink a.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.dark-pink a.btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-pink a.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.dark-pink a.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-pink a.btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-pink a.btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.dark-pink a.btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-pink a.btn-outline-success.focus,.dark-pink a.btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.dark-pink a.btn-outline-success.disabled,.dark-pink a.btn-outline-success:disabled{color:#4caf50;background-color:transparent}.dark-pink a.btn-outline-success:not(:disabled):not(.disabled).active,.dark-pink a.btn-outline-success:not(:disabled):not(.disabled):active,.show>.dark-pink a.btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-pink a.btn-outline-success:not(:disabled):not(.disabled).active:focus,.dark-pink a.btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.dark-pink a.btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-pink a.btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.dark-pink a.btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-pink a.btn-outline-info.focus,.dark-pink a.btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.dark-pink a.btn-outline-info.disabled,.dark-pink a.btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.dark-pink a.btn-outline-info:not(:disabled):not(.disabled).active,.dark-pink a.btn-outline-info:not(:disabled):not(.disabled):active,.show>.dark-pink a.btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-pink a.btn-outline-info:not(:disabled):not(.disabled).active:focus,.dark-pink a.btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.dark-pink a.btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-pink a.btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.dark-pink a.btn-outline-warning:hover{color:#fff;background-color:#ff9800;border-color:#ff9800}.dark-pink a.btn-outline-warning.focus,.dark-pink a.btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.dark-pink a.btn-outline-warning.disabled,.dark-pink a.btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.dark-pink a.btn-outline-warning:not(:disabled):not(.disabled).active,.dark-pink a.btn-outline-warning:not(:disabled):not(.disabled):active,.show>.dark-pink a.btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-pink a.btn-outline-warning:not(:disabled):not(.disabled).active:focus,.dark-pink a.btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-pink a.btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-pink a.btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.dark-pink a.btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.dark-pink a.btn-outline-danger.focus,.dark-pink a.btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.dark-pink a.btn-outline-danger.disabled,.dark-pink a.btn-outline-danger:disabled{color:#f44336;background-color:transparent}.dark-pink a.btn-outline-danger:not(:disabled):not(.disabled).active,.dark-pink a.btn-outline-danger:not(:disabled):not(.disabled):active,.show>.dark-pink a.btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.dark-pink a.btn-outline-danger:not(:disabled):not(.disabled).active:focus,.dark-pink a.btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-pink a.btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-pink a.btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.dark-pink a.btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-pink a.btn-outline-light.focus,.dark-pink a.btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.dark-pink a.btn-outline-light.disabled,.dark-pink a.btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.dark-pink a.btn-outline-light:not(:disabled):not(.disabled).active,.dark-pink a.btn-outline-light:not(:disabled):not(.disabled):active,.show>.dark-pink a.btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-pink a.btn-outline-light:not(:disabled):not(.disabled).active:focus,.dark-pink a.btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.dark-pink a.btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-pink a.btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.dark-pink a.btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.dark-pink a.btn-outline-dark.focus,.dark-pink a.btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.dark-pink a.btn-outline-dark.disabled,.dark-pink a.btn-outline-dark:disabled{color:#343a40;background-color:transparent}.dark-pink a.btn-outline-dark:not(:disabled):not(.disabled).active,.dark-pink a.btn-outline-dark:not(:disabled):not(.disabled):active,.show>.dark-pink a.btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.dark-pink a.btn-outline-dark:not(:disabled):not(.disabled).active:focus,.dark-pink a.btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-pink a.btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-pink .btn-outline-primary,.dark-pink a.btn-outline-primary{color:#e91e63;border-color:#e91e63}.dark-pink .btn-outline-primary.disabled,.dark-pink .btn-outline-primary:disabled,.dark-pink .btn-outline-primary:focus,.dark-pink .btn-outline-primary:hover,.dark-pink .btn-outline-primary:not(:disabled):not(.disabled).active,.dark-pink .btn-outline-primary:not(:disabled):not(.disabled):active,.dark-pink a.btn-outline-primary.disabled,.dark-pink a.btn-outline-primary:disabled,.dark-pink a.btn-outline-primary:focus,.dark-pink a.btn-outline-primary:hover,.dark-pink a.btn-outline-primary:not(:disabled):not(.disabled).active,.dark-pink a.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.dark-pink .btn-outline-primary.dropdown-toggle,.show>.dark-pink a.btn-outline-primary.dropdown-toggle{color:#fff;border-color:#e91e63;background-color:#e91e63}.dark-pink .btn-outline-secondary,.dark-pink a.btn-outline-secondary{color:#00bfa5;border-color:#00bfa5}.dark-pink .btn-outline-secondary.disabled,.dark-pink .btn-outline-secondary:disabled,.dark-pink .btn-outline-secondary:focus,.dark-pink .btn-outline-secondary:hover,.dark-pink .btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-pink .btn-outline-secondary:not(:disabled):not(.disabled):active,.dark-pink a.btn-outline-secondary.disabled,.dark-pink a.btn-outline-secondary:disabled,.dark-pink a.btn-outline-secondary:focus,.dark-pink a.btn-outline-secondary:hover,.dark-pink a.btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-pink a.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.dark-pink .btn-outline-secondary.dropdown-toggle,.show>.dark-pink a.btn-outline-secondary.dropdown-toggle{color:#fff;border-color:#00bfa5;background-color:#00bfa5}.dark-pink a,.dark-pink a.text-primary{color:#e91e63}.dark-pink a.text-primary:focus,.dark-pink a.text-primary:hover,.dark-pink a:focus,.dark-pink a:hover{color:#c1134e}.dark-pink .text-primary{color:#e91e63!important}.dark-pink .page-link,.dark-pink .page-link:focus,.dark-pink .page-link:hover{color:#e91e63}.dark-pink .badge-primary,.dark-pink .bg-primary{background-color:#e91e63!important;color:#fff!important}.dark-pink .btn-primary,.dark-pink .jr-btn-primary,.dark-pink a.btn-primary,.dark-pink a.jr-btn-primary{background-color:#e91e63;border-color:#e91e63;color:#fff}.dark-pink .btn-primary:focus,.dark-pink .btn-primary:hover,.dark-pink .btn-primary:not([disabled]):not(.disabled):active,.dark-pink .jr-btn-primary:focus,.dark-pink .jr-btn-primary:hover,.dark-pink .jr-btn-primary:not([disabled]):not(.disabled):active,.dark-pink a.btn-primary:focus,.dark-pink a.btn-primary:hover,.dark-pink a.btn-primary:not([disabled]):not(.disabled):active,.dark-pink a.jr-btn-primary:focus,.dark-pink a.jr-btn-primary:hover,.dark-pink a.jr-btn-primary:not([disabled]):not(.disabled):active{background-color:#d81558!important;border-color:#d81558!important;color:#fff!important}.dark-pink .bg-primary.lighten-4{background-color:#f8bbd0!important}.dark-pink .bg-primary.lighten-3{background-color:#f48fb1!important}.dark-pink .bg-primary.lighten-2{background-color:#f06292!important}.dark-pink .bg-primary.lighten-1{background-color:#ec407a!important}.dark-pink .bg-primary.darken-1{background-color:#d81b60!important}.dark-pink .bg-primary.darken-2{background-color:#c2185b!important}.dark-pink .bg-primary.darken-3{background-color:#ad1457!important}.dark-pink .bg-primary.darken-4{background-color:#880e4f!important}.dark-pink .bg-primary.accent-1{background-color:#ff80ab!important}.dark-pink .bg-primary.accent-2{background-color:#ff4081!important}.dark-pink .bg-primary.accent-3{background-color:#f50057!important}.dark-pink .bg-primary.accent-4{background-color:#c51162!important}.dark-pink a.text-secondary{color:#00bfa5}.dark-pink a.text-secondary:focus,.dark-pink a.text-secondary:hover{color:#008c79!important}.dark-pink .text-secondary{color:#00bfa5!important}.dark-pink .badge-secondary,.dark-pink .bg-secondary{background-color:#00bfa5!important;color:#fff!important}.dark-pink .btn-secondary{background-color:#00bfa5;border-color:#00bfa5;color:#fff}.dark-pink .btn-secondary:active,.dark-pink .btn-secondary:focus,.dark-pink .btn-secondary:hover{background-color:#00a68f!important;border-color:#00a68f!important;color:#fff!important}.dark-pink .jr-flat-btn{background-color:transparent!important;color:#5c5c5c!important}.dark-pink .jr-flat-btn:active,.dark-pink .jr-flat-btn:focus,.dark-pink .jr-flat-btn:hover{background-color:#f5f5f5!important;color:#5c5c5c!important}.dark-pink .jr-flat-btn.jr-btn-primary{background-color:transparent!important;color:#e91e63!important;border-color:transparent!important}.dark-pink .jr-flat-btn.jr-btn-primary:focus,.dark-pink .jr-flat-btn.jr-btn-primary:hover{background-color:rgba(233,30,99,.12)!important;color:#e91e63!important}.dark-pink .bg-primary .jr-flat-btn.jr-btn-primary{background-color:transparent!important;color:#fff!important;border-color:transparent!important}.dark-pink .bg-primary .jr-flat-btn.jr-btn-primary:focus,.dark-pink .bg-primary .jr-flat-btn.jr-btn-primary:hover{background-color:hsla(0,0%,100%,.12)!important;color:#fff!important}.dark-pink .jr-flat-btn.jr-btn-secondary{background-color:transparent!important;color:#00bfa5!important;border-color:transparent!important}.dark-pink .jr-flat-btn.jr-btn-secondary:focus,.dark-pink .jr-flat-btn.jr-btn-secondary:hover{background-color:rgba(0,191,165,.12)!important;color:#00bfa5!important}.dark-pink .bg-secondary .jr-flat-btn.jr-btn-secondary{background-color:transparent!important;color:#fff!important;border-color:transparent!important}.dark-pink .bg-secondary .jr-flat-btn.jr-btn-secondary:focus,.dark-pink .bg-secondary .jr-flat-btn.jr-btn-secondary:hover{background-color:hsla(0,0%,100%,.12)!important;color:#fff!important}.dark-pink .app-main-header{background-color:#e91e63!important;color:#fff;border-color:#e91e63}.dark-pink .app-main-header .search-bar input{background-color:#eb3573}.dark-pink .app-main-header .search-bar input+.search-icon i{color:#fff}.dark-pink .app-main-header .search-bar input:focus{background-color:#fff}.dark-pink .app-main-header .search-bar input:focus+.search-icon i{color:hsla(0,0%,50%,.8)}@media screen and (max-width:575px){.dark-pink .app-main-header .search-dropdown input{background-color:#fff}.dark-pink .app-main-header .search-dropdown input+.search-icon i{color:hsla(0,0%,50%,.8)}}.dark-pink .app-main-header .jr-menu-icon .menu-icon{background-color:#fff!important}.dark-pink .app-header .jr-menu-icon .menu-icon{background-color:#fff}.dark-pink .quick-menu .icon-btn{color:#fff}.dark-pink .react-logo-white.d-block{display:block!important}@media screen and (min-width:992px){.dark-pink .react-logo-white.d-lg-block{display:block!important}.dark-pink .react-logo-white.d-lg-none{display:none!important}}.dark-pink .react-logo-color.d-block{display:none!important}@media screen and (min-width:992px){.dark-pink .react-logo-color.d-lg-block{display:none!important}}.dark-pink .color-theme-header{background-color:#e91e63}.dark-pink .sidebar-header{border-bottom:0 none;background-color:#1d1d1d}.dark-pink .side-nav{background-color:#252525!important;color:#a1a1a1!important;border-right:0 none!important}.dark-pink .side-nav .user-profile{background-color:#1d1d1d;position:relative;z-index:2}.dark-pink .side-nav .customizer{border-bottom:0 none}.dark-pink .side-nav .user-detail .user-name{color:#fff}.dark-pink ul.nav-menu .nav-header,.dark-pink ul.nav-menu li a{color:#a1a1a1}.dark-pink ul.nav-menu>li.open>a,.dark-pink ul.nav-menu>li>a:focus,.dark-pink ul.nav-menu>li>a:hover{background-color:#1d1d1d;color:#fff}.dark-pink ul.nav-menu li.menu.open>a{border-color:#e91e63}.dark-pink ul.nav-menu li.menu>a:focus:before,.dark-pink ul.nav-menu li.menu>a:hover:before{color:#fff}.dark-pink ul.nav-menu li ul{background-color:#1d1d1d}.dark-pink ul.nav-menu li.menu>a:before{color:#a1a1a1}.dark-pink ul.nav-menu li.menu.open>a:before,.dark-pink ul.nav-menu li.menu>a:focus:before,.dark-pink ul.nav-menu li.menu li>a:hover:before{color:#fff}.dark-pink ul.nav-menu li.menu .sub-menu li>a:before{color:#a1a1a1}.dark-pink ul.nav-menu li.menu .sub-menu li>a.active .nav-text{background-color:#e91e63}.dark-pink ul.nav-menu li.menu.open .sub-menu li>a.active:before,.dark-pink ul.nav-menu li.menu .sub-menu li>a:focus,.dark-pink ul.nav-menu li.menu .sub-menu li>a:focus:before,.dark-pink ul.nav-menu li.menu .sub-menu li>a:hover,.dark-pink ul.nav-menu li.menu .sub-menu li>a:hover:before{background-color:#1d1d1d;color:#fff}.dark-pink .navbar-nav li:focus>a,.dark-pink .navbar-nav li:hover>a{color:#e91e63}.dark-pink .navbar-nav li a{color:#868e96}.dark-pink .navbar-nav li a:focus,.dark-pink .navbar-nav li a:hover{color:#e91e63}.dark-pink .navbar-nav li.nav-item>a{color:#fff}.dark-pink .navbar-nav li.nav-item.active>a,.dark-pink .navbar-nav li.nav-item:focus>a,.dark-pink .navbar-nav li.nav-item:hover>a,.dark-pink .navbar-nav li.nav-item>a:focus,.dark-pink .navbar-nav li.nav-item>a:hover{color:#00bfa5}.dark-pink .navbar-nav ul.sub-menu li.active>a,.dark-pink .navbar-nav ul.sub-menu li a.active{color:#e91e63}.dark-pink .navbar-nav .nav-arrow>a:before{color:#868e96}.dark-pink .navbar-nav .nav-arrow.active>a:before,.dark-pink .navbar-nav .nav-arrow:focus>a:before,.dark-pink .navbar-nav .nav-arrow:hover>a:before,.dark-pink .navbar-nav .nav-arrow a:focus:before,.dark-pink .navbar-nav .nav-arrow a:hover:before{color:#e91e63}.dark-pink .app-top-nav{background-color:#252525!important;border-color:#252525}.dark-pink .app-top-nav .navbar-nav li.nav-item>a{color:#fff}.dark-pink .app-top-nav .navbar-nav li.nav-item.active>a,.dark-pink .app-top-nav .navbar-nav li.nav-item:focus>a,.dark-pink .app-top-nav .navbar-nav li.nav-item:hover>a,.dark-pink .app-top-nav .navbar-nav li.nav-item>a:focus,.dark-pink .app-top-nav .navbar-nav li.nav-item>a:hover{color:#00bfa5}.dark-pink .module-nav li a.active{border-color:#e91e63}.dark-pink .rbc-event{background-color:#e91e63}.dark-pink .rbc-event.rbc-selected{background-color:#c1134e}.dark-pink .rbc-slot-selection{background-color:rgba(233,30,99,.7)}.dark-pink .rbc-toolbar button.rbc-active,.dark-pink .rbc-toolbar button.rbc-active:focus,.dark-pink .rbc-toolbar button.rbc-active:hover,.dark-pink .rbc-toolbar button:active,.dark-pink .rbc-toolbar button:active:focus,.dark-pink .rbc-toolbar button:active:hover,.dark-pink .rbc-toolbar button:focus,.dark-pink .rbc-toolbar button:hover{background-color:rgba(233,30,99,.9);border-color:#e91e63}.dark-pink .rbc-day-slot .rbc-event{border-color:#e91e63}.dark-pink .chat-sidenav-title{color:#e91e63}.dark-pink .chat-user-item.active,.dark-pink .chat-user-item:hover{background-color:#fdeff4}.dark-pink .contact-list i{color:#e91e63}.dark-pink .Collapsible__trigger{background:#e91e63}.dark-pink .categories-list li.active a,.dark-pink .categories-list li a:focus,.dark-pink .categories-list li a:hover{color:#e91e63}.dark-pink .filter-with-bg-color ul li a,.dark-pink .login-content .form-control:focus{border-color:#e91e63}.dark-pink .filter-with-bg-color ul li a.active,.dark-pink .filter-with-bg-color ul li a:focus,.dark-pink .filter-with-bg-color ul li a:hover{background-color:#e91e63}.dark-pink .profile-intro .icon{color:#e91e63}.dark-pink .actions,.dark-pink .social-link li.active a,.dark-pink .social-link li a:focus,.dark-pink .social-link li a:hover{color:#00bfa5}.dark-pink .table-hover tbody tr:hover{background-color:rgba(233,30,99,.075)}.dark-pink .border-primary{border-color:#e91e63!important}.dark-pink .app-logo-content{background-color:#e91e63}.dark-pink .app-social-block .social-link button{border:1px solid #e91e63;color:#e91e63}.dark-pink .app-social-block .social-link button:focus,.dark-pink .app-social-block .social-link button:hover{color:#fff;background-color:#e91e63}.dark-pink .btn-group-vertical>.btn-default.active,.dark-pink .btn-group-vertical>.jr-btn.active,.dark-pink .btn-group>.btn-default.active,.dark-pink .btn-group>.jr-btn.active{background-color:#e91e63;border-color:#e91e63}.dark-pink .btn-group-vertical>.jr-flat-btn,.dark-pink .btn-group>.jr-flat-btn{border-color:transparent}.dark-pink .btn-group-vertical>.jr-flat-btn.active,.dark-pink .btn-group>.jr-flat-btn.active{background-color:transparent;color:#e91e63!important;border-color:transparent!important}.dark-pink .btn-group-vertical>.jr-flat-btn.active:focus,.dark-pink .btn-group-vertical>.jr-flat-btn.active:hover,.dark-pink .btn-group>.jr-flat-btn.active:focus,.dark-pink .btn-group>.jr-flat-btn.active:hover{background-color:rgba(233,30,99,.12)!important;color:#e91e63!important}.dark-pink .nav-pill-sales .nav-link.active{background-color:#e91e63;border-color:#e91e63}.dark-pink .form-checkbox>input+.check,.dark-pink .form-checkbox>input.sm+.check{color:#e91e63}.dark-pink .app-main-header ::-webkit-input-placeholder{color:#ebebeb}.dark-pink .app-main-header ::-moz-placeholder{color:#ebebeb}.dark-pink .app-main-header :-ms-input-placeholder{color:#ebebeb}.dark-pink .app-main-header :-moz-placeholder{color:#ebebeb}.dark-pink .app-main-header input:focus::-webkit-input-placeholder{color:#dcdcdc}.dark-pink .app-main-header input:focus::-moz-placeholder{color:#dcdcdc}.dark-pink .app-main-header input:focus:-ms-input-placeholder{color:#dcdcdc}.dark-pink .app-main-header input:focus:-moz-placeholder{color:#dcdcdc}.dark-blue .right-arrow,.dark-blue .right-arrow:after{color:#2196f3}.dark-blue .btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-blue .btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.dark-blue .btn-primary.focus,.dark-blue .btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.dark-blue .btn-primary.disabled,.dark-blue .btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-blue .btn-primary:not(:disabled):not(.disabled).active,.dark-blue .btn-primary:not(:disabled):not(.disabled):active,.show>.dark-blue .btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.dark-blue .btn-primary:not(:disabled):not(.disabled).active:focus,.dark-blue .btn-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-blue .btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-blue .btn-secondary{background-color:#e91e63;border-color:#e91e63;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-blue .btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.dark-blue .btn-secondary.focus,.dark-blue .btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.dark-blue .btn-secondary.disabled,.dark-blue .btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-blue .btn-secondary:not(:disabled):not(.disabled).active,.dark-blue .btn-secondary:not(:disabled):not(.disabled):active,.show>.dark-blue .btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.dark-blue .btn-secondary:not(:disabled):not(.disabled).active:focus,.dark-blue .btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-blue .btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-blue .btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-blue .btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.dark-blue .btn-success.focus,.dark-blue .btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.dark-blue .btn-success.disabled,.dark-blue .btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-blue .btn-success:not(:disabled):not(.disabled).active,.dark-blue .btn-success:not(:disabled):not(.disabled):active,.show>.dark-blue .btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.dark-blue .btn-success:not(:disabled):not(.disabled).active:focus,.dark-blue .btn-success:not(:disabled):not(.disabled):active:focus,.show>.dark-blue .btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-blue .btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-blue .btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.dark-blue .btn-info.focus,.dark-blue .btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.dark-blue .btn-info.disabled,.dark-blue .btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-blue .btn-info:not(:disabled):not(.disabled).active,.dark-blue .btn-info:not(:disabled):not(.disabled):active,.show>.dark-blue .btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.dark-blue .btn-info:not(:disabled):not(.disabled).active:focus,.dark-blue .btn-info:not(:disabled):not(.disabled):active:focus,.show>.dark-blue .btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-blue .btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-blue .btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.dark-blue .btn-warning.focus,.dark-blue .btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.dark-blue .btn-warning.disabled,.dark-blue .btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-blue .btn-warning:not(:disabled):not(.disabled).active,.dark-blue .btn-warning:not(:disabled):not(.disabled):active,.show>.dark-blue .btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.dark-blue .btn-warning:not(:disabled):not(.disabled).active:focus,.dark-blue .btn-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-blue .btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-blue .btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-blue .btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.dark-blue .btn-danger.focus,.dark-blue .btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.dark-blue .btn-danger.disabled,.dark-blue .btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.dark-blue .btn-danger:not(:disabled):not(.disabled).active,.dark-blue .btn-danger:not(:disabled):not(.disabled):active,.show>.dark-blue .btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.dark-blue .btn-danger:not(:disabled):not(.disabled).active:focus,.dark-blue .btn-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-blue .btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-blue .btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-blue .btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.dark-blue .btn-light.focus,.dark-blue .btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.dark-blue .btn-light.disabled,.dark-blue .btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-blue .btn-light:not(:disabled):not(.disabled).active,.dark-blue .btn-light:not(:disabled):not(.disabled):active,.show>.dark-blue .btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.dark-blue .btn-light:not(:disabled):not(.disabled).active:focus,.dark-blue .btn-light:not(:disabled):not(.disabled):active:focus,.show>.dark-blue .btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-blue .btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-blue .btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.dark-blue .btn-dark.focus,.dark-blue .btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.dark-blue .btn-dark.disabled,.dark-blue .btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.dark-blue .btn-dark:not(:disabled):not(.disabled).active,.dark-blue .btn-dark:not(:disabled):not(.disabled):active,.show>.dark-blue .btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.dark-blue .btn-dark:not(:disabled):not(.disabled).active:focus,.dark-blue .btn-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-blue .btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-blue a.btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-blue a.btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.dark-blue a.btn-primary.focus,.dark-blue a.btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.dark-blue a.btn-primary.disabled,.dark-blue a.btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-blue a.btn-primary:not(:disabled):not(.disabled).active,.dark-blue a.btn-primary:not(:disabled):not(.disabled):active,.show>.dark-blue a.btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.dark-blue a.btn-primary:not(:disabled):not(.disabled).active:focus,.dark-blue a.btn-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-blue a.btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-blue a.btn-secondary{color:#fff;background-color:#e91e63;border-color:#e91e63;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-blue a.btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.dark-blue a.btn-secondary.focus,.dark-blue a.btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.dark-blue a.btn-secondary.disabled,.dark-blue a.btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-blue a.btn-secondary:not(:disabled):not(.disabled).active,.dark-blue a.btn-secondary:not(:disabled):not(.disabled):active,.show>.dark-blue a.btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.dark-blue a.btn-secondary:not(:disabled):not(.disabled).active:focus,.dark-blue a.btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-blue a.btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-blue a.btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-blue a.btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.dark-blue a.btn-success.focus,.dark-blue a.btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.dark-blue a.btn-success.disabled,.dark-blue a.btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-blue a.btn-success:not(:disabled):not(.disabled).active,.dark-blue a.btn-success:not(:disabled):not(.disabled):active,.show>.dark-blue a.btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.dark-blue a.btn-success:not(:disabled):not(.disabled).active:focus,.dark-blue a.btn-success:not(:disabled):not(.disabled):active:focus,.show>.dark-blue a.btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-blue a.btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-blue a.btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.dark-blue a.btn-info.focus,.dark-blue a.btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.dark-blue a.btn-info.disabled,.dark-blue a.btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-blue a.btn-info:not(:disabled):not(.disabled).active,.dark-blue a.btn-info:not(:disabled):not(.disabled):active,.show>.dark-blue a.btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.dark-blue a.btn-info:not(:disabled):not(.disabled).active:focus,.dark-blue a.btn-info:not(:disabled):not(.disabled):active:focus,.show>.dark-blue a.btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-blue a.btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-blue a.btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.dark-blue a.btn-warning.focus,.dark-blue a.btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.dark-blue a.btn-warning.disabled,.dark-blue a.btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-blue a.btn-warning:not(:disabled):not(.disabled).active,.dark-blue a.btn-warning:not(:disabled):not(.disabled):active,.show>.dark-blue a.btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.dark-blue a.btn-warning:not(:disabled):not(.disabled).active:focus,.dark-blue a.btn-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-blue a.btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-blue a.btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-blue a.btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.dark-blue a.btn-danger.focus,.dark-blue a.btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.dark-blue a.btn-danger.disabled,.dark-blue a.btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.dark-blue a.btn-danger:not(:disabled):not(.disabled).active,.dark-blue a.btn-danger:not(:disabled):not(.disabled):active,.show>.dark-blue a.btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.dark-blue a.btn-danger:not(:disabled):not(.disabled).active:focus,.dark-blue a.btn-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-blue a.btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-blue a.btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-blue a.btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.dark-blue a.btn-light.focus,.dark-blue a.btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.dark-blue a.btn-light.disabled,.dark-blue a.btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-blue a.btn-light:not(:disabled):not(.disabled).active,.dark-blue a.btn-light:not(:disabled):not(.disabled):active,.show>.dark-blue a.btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.dark-blue a.btn-light:not(:disabled):not(.disabled).active:focus,.dark-blue a.btn-light:not(:disabled):not(.disabled):active:focus,.show>.dark-blue a.btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-blue a.btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-blue a.btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.dark-blue a.btn-dark.focus,.dark-blue a.btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.dark-blue a.btn-dark.disabled,.dark-blue a.btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.dark-blue a.btn-dark:not(:disabled):not(.disabled).active,.dark-blue a.btn-dark:not(:disabled):not(.disabled):active,.show>.dark-blue a.btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.dark-blue a.btn-dark:not(:disabled):not(.disabled).active:focus,.dark-blue a.btn-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-blue a.btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-blue .btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.dark-blue .btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-blue .btn-outline-primary.focus,.dark-blue .btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.dark-blue .btn-outline-primary.disabled,.dark-blue .btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.dark-blue .btn-outline-primary:not(:disabled):not(.disabled).active,.dark-blue .btn-outline-primary:not(:disabled):not(.disabled):active,.show>.dark-blue .btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-blue .btn-outline-primary:not(:disabled):not(.disabled).active:focus,.dark-blue .btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-blue .btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-blue .btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.dark-blue .btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-blue .btn-outline-secondary.focus,.dark-blue .btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.dark-blue .btn-outline-secondary.disabled,.dark-blue .btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.dark-blue .btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-blue .btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.dark-blue .btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-blue .btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.dark-blue .btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-blue .btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-blue .btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.dark-blue .btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-blue .btn-outline-success.focus,.dark-blue .btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.dark-blue .btn-outline-success.disabled,.dark-blue .btn-outline-success:disabled{color:#4caf50;background-color:transparent}.dark-blue .btn-outline-success:not(:disabled):not(.disabled).active,.dark-blue .btn-outline-success:not(:disabled):not(.disabled):active,.show>.dark-blue .btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-blue .btn-outline-success:not(:disabled):not(.disabled).active:focus,.dark-blue .btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.dark-blue .btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-blue .btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.dark-blue .btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-blue .btn-outline-info.focus,.dark-blue .btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.dark-blue .btn-outline-info.disabled,.dark-blue .btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.dark-blue .btn-outline-info:not(:disabled):not(.disabled).active,.dark-blue .btn-outline-info:not(:disabled):not(.disabled):active,.show>.dark-blue .btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-blue .btn-outline-info:not(:disabled):not(.disabled).active:focus,.dark-blue .btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.dark-blue .btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-blue .btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.dark-blue .btn-outline-warning:hover{color:#fff;background-color:#ff9800;border-color:#ff9800}.dark-blue .btn-outline-warning.focus,.dark-blue .btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.dark-blue .btn-outline-warning.disabled,.dark-blue .btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.dark-blue .btn-outline-warning:not(:disabled):not(.disabled).active,.dark-blue .btn-outline-warning:not(:disabled):not(.disabled):active,.show>.dark-blue .btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-blue .btn-outline-warning:not(:disabled):not(.disabled).active:focus,.dark-blue .btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-blue .btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-blue .btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.dark-blue .btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.dark-blue .btn-outline-danger.focus,.dark-blue .btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.dark-blue .btn-outline-danger.disabled,.dark-blue .btn-outline-danger:disabled{color:#f44336;background-color:transparent}.dark-blue .btn-outline-danger:not(:disabled):not(.disabled).active,.dark-blue .btn-outline-danger:not(:disabled):not(.disabled):active,.show>.dark-blue .btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.dark-blue .btn-outline-danger:not(:disabled):not(.disabled).active:focus,.dark-blue .btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-blue .btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-blue .btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.dark-blue .btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-blue .btn-outline-light.focus,.dark-blue .btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.dark-blue .btn-outline-light.disabled,.dark-blue .btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.dark-blue .btn-outline-light:not(:disabled):not(.disabled).active,.dark-blue .btn-outline-light:not(:disabled):not(.disabled):active,.show>.dark-blue .btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-blue .btn-outline-light:not(:disabled):not(.disabled).active:focus,.dark-blue .btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.dark-blue .btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-blue .btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.dark-blue .btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.dark-blue .btn-outline-dark.focus,.dark-blue .btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.dark-blue .btn-outline-dark.disabled,.dark-blue .btn-outline-dark:disabled{color:#343a40;background-color:transparent}.dark-blue .btn-outline-dark:not(:disabled):not(.disabled).active,.dark-blue .btn-outline-dark:not(:disabled):not(.disabled):active,.show>.dark-blue .btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.dark-blue .btn-outline-dark:not(:disabled):not(.disabled).active:focus,.dark-blue .btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-blue .btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-blue a.btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.dark-blue a.btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-blue a.btn-outline-primary.focus,.dark-blue a.btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.dark-blue a.btn-outline-primary.disabled,.dark-blue a.btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.dark-blue a.btn-outline-primary:not(:disabled):not(.disabled).active,.dark-blue a.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.dark-blue a.btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-blue a.btn-outline-primary:not(:disabled):not(.disabled).active:focus,.dark-blue a.btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-blue a.btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-blue a.btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.dark-blue a.btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-blue a.btn-outline-secondary.focus,.dark-blue a.btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.dark-blue a.btn-outline-secondary.disabled,.dark-blue a.btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.dark-blue a.btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-blue a.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.dark-blue a.btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-blue a.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.dark-blue a.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-blue a.btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-blue a.btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.dark-blue a.btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-blue a.btn-outline-success.focus,.dark-blue a.btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.dark-blue a.btn-outline-success.disabled,.dark-blue a.btn-outline-success:disabled{color:#4caf50;background-color:transparent}.dark-blue a.btn-outline-success:not(:disabled):not(.disabled).active,.dark-blue a.btn-outline-success:not(:disabled):not(.disabled):active,.show>.dark-blue a.btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-blue a.btn-outline-success:not(:disabled):not(.disabled).active:focus,.dark-blue a.btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.dark-blue a.btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-blue a.btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.dark-blue a.btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-blue a.btn-outline-info.focus,.dark-blue a.btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.dark-blue a.btn-outline-info.disabled,.dark-blue a.btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.dark-blue a.btn-outline-info:not(:disabled):not(.disabled).active,.dark-blue a.btn-outline-info:not(:disabled):not(.disabled):active,.show>.dark-blue a.btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-blue a.btn-outline-info:not(:disabled):not(.disabled).active:focus,.dark-blue a.btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.dark-blue a.btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-blue a.btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.dark-blue a.btn-outline-warning:hover{color:#fff;background-color:#ff9800;border-color:#ff9800}.dark-blue a.btn-outline-warning.focus,.dark-blue a.btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.dark-blue a.btn-outline-warning.disabled,.dark-blue a.btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.dark-blue a.btn-outline-warning:not(:disabled):not(.disabled).active,.dark-blue a.btn-outline-warning:not(:disabled):not(.disabled):active,.show>.dark-blue a.btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-blue a.btn-outline-warning:not(:disabled):not(.disabled).active:focus,.dark-blue a.btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-blue a.btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-blue a.btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.dark-blue a.btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.dark-blue a.btn-outline-danger.focus,.dark-blue a.btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.dark-blue a.btn-outline-danger.disabled,.dark-blue a.btn-outline-danger:disabled{color:#f44336;background-color:transparent}.dark-blue a.btn-outline-danger:not(:disabled):not(.disabled).active,.dark-blue a.btn-outline-danger:not(:disabled):not(.disabled):active,.show>.dark-blue a.btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.dark-blue a.btn-outline-danger:not(:disabled):not(.disabled).active:focus,.dark-blue a.btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-blue a.btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-blue a.btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.dark-blue a.btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-blue a.btn-outline-light.focus,.dark-blue a.btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.dark-blue a.btn-outline-light.disabled,.dark-blue a.btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.dark-blue a.btn-outline-light:not(:disabled):not(.disabled).active,.dark-blue a.btn-outline-light:not(:disabled):not(.disabled):active,.show>.dark-blue a.btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-blue a.btn-outline-light:not(:disabled):not(.disabled).active:focus,.dark-blue a.btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.dark-blue a.btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-blue a.btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.dark-blue a.btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.dark-blue a.btn-outline-dark.focus,.dark-blue a.btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.dark-blue a.btn-outline-dark.disabled,.dark-blue a.btn-outline-dark:disabled{color:#343a40;background-color:transparent}.dark-blue a.btn-outline-dark:not(:disabled):not(.disabled).active,.dark-blue a.btn-outline-dark:not(:disabled):not(.disabled):active,.show>.dark-blue a.btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.dark-blue a.btn-outline-dark:not(:disabled):not(.disabled).active:focus,.dark-blue a.btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-blue a.btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-blue .btn-outline-primary,.dark-blue a.btn-outline-primary{color:#2196f3;border-color:#2196f3}.dark-blue .btn-outline-primary.disabled,.dark-blue .btn-outline-primary:disabled,.dark-blue .btn-outline-primary:focus,.dark-blue .btn-outline-primary:hover,.dark-blue .btn-outline-primary:not(:disabled):not(.disabled).active,.dark-blue .btn-outline-primary:not(:disabled):not(.disabled):active,.dark-blue a.btn-outline-primary.disabled,.dark-blue a.btn-outline-primary:disabled,.dark-blue a.btn-outline-primary:focus,.dark-blue a.btn-outline-primary:hover,.dark-blue a.btn-outline-primary:not(:disabled):not(.disabled).active,.dark-blue a.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.dark-blue .btn-outline-primary.dropdown-toggle,.show>.dark-blue a.btn-outline-primary.dropdown-toggle{color:#fff;border-color:#2196f3;background-color:#2196f3}.dark-blue .btn-outline-secondary,.dark-blue a.btn-outline-secondary{color:#ff6e40;border-color:#ff6e40}.dark-blue .btn-outline-secondary.disabled,.dark-blue .btn-outline-secondary:disabled,.dark-blue .btn-outline-secondary:focus,.dark-blue .btn-outline-secondary:hover,.dark-blue .btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-blue .btn-outline-secondary:not(:disabled):not(.disabled):active,.dark-blue a.btn-outline-secondary.disabled,.dark-blue a.btn-outline-secondary:disabled,.dark-blue a.btn-outline-secondary:focus,.dark-blue a.btn-outline-secondary:hover,.dark-blue a.btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-blue a.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.dark-blue .btn-outline-secondary.dropdown-toggle,.show>.dark-blue a.btn-outline-secondary.dropdown-toggle{color:#fff;border-color:#ff6e40;background-color:#ff6e40}.dark-blue a,.dark-blue a.text-primary{color:#2196f3}.dark-blue a.text-primary:focus,.dark-blue a.text-primary:hover,.dark-blue a:focus,.dark-blue a:hover{color:#0c7cd5}.dark-blue .text-primary{color:#2196f3!important}.dark-blue .page-link,.dark-blue .page-link:focus,.dark-blue .page-link:hover{color:#2196f3}.dark-blue .badge-primary,.dark-blue .bg-primary{background-color:#2196f3!important;color:#fff!important}.dark-blue .btn-primary,.dark-blue .jr-btn-primary,.dark-blue a.btn-primary,.dark-blue a.jr-btn-primary{background-color:#2196f3;border-color:#2196f3;color:#fff}.dark-blue .btn-primary:focus,.dark-blue .btn-primary:hover,.dark-blue .btn-primary:not([disabled]):not(.disabled):active,.dark-blue .jr-btn-primary:focus,.dark-blue .jr-btn-primary:hover,.dark-blue .jr-btn-primary:not([disabled]):not(.disabled):active,.dark-blue a.btn-primary:focus,.dark-blue a.btn-primary:hover,.dark-blue a.btn-primary:not([disabled]):not(.disabled):active,.dark-blue a.jr-btn-primary:focus,.dark-blue a.jr-btn-primary:hover,.dark-blue a.jr-btn-primary:not([disabled]):not(.disabled):active{background-color:#0d8aee!important;border-color:#0d8aee!important;color:#fff!important}.dark-blue .bg-primary.lighten-4{background-color:#bbdefb!important}.dark-blue .bg-primary.lighten-3{background-color:#90caf9!important}.dark-blue .bg-primary.lighten-2{background-color:#64b5f6!important}.dark-blue .bg-primary.lighten-1{background-color:#42a5f5!important}.dark-blue .bg-primary.darken-1{background-color:#1e88e5!important}.dark-blue .bg-primary.darken-2{background-color:#1976d2!important}.dark-blue .bg-primary.darken-3{background-color:#1565c0!important}.dark-blue .bg-primary.darken-4{background-color:#0d47a1!important}.dark-blue .bg-primary.accent-1{background-color:#82b1ff!important}.dark-blue .bg-primary.accent-2{background-color:#448aff!important}.dark-blue .bg-primary.accent-3{background-color:#2979ff!important}.dark-blue .bg-primary.accent-4{background-color:#2962ff!important}.dark-blue a.text-secondary{color:#ff6e40}.dark-blue a.text-secondary:focus,.dark-blue a.text-secondary:hover{color:#ff470d!important}.dark-blue .text-secondary{color:#ff6e40!important}.dark-blue .badge-secondary,.dark-blue .bg-secondary{background-color:#ff6e40!important;color:#fff!important}.dark-blue .btn-secondary{background-color:#ff6e40;border-color:#ff6e40;color:#fff}.dark-blue .btn-secondary:active,.dark-blue .btn-secondary:focus,.dark-blue .btn-secondary:hover{background-color:#ff5b27!important;border-color:#ff5b27!important;color:#fff!important}.dark-blue .jr-flat-btn{background-color:transparent!important;color:#5c5c5c!important}.dark-blue .jr-flat-btn:active,.dark-blue .jr-flat-btn:focus,.dark-blue .jr-flat-btn:hover{background-color:#f5f5f5!important;color:#5c5c5c!important}.dark-blue .jr-flat-btn.jr-btn-primary{background-color:transparent!important;color:#2196f3!important;border-color:transparent!important}.dark-blue .jr-flat-btn.jr-btn-primary:focus,.dark-blue .jr-flat-btn.jr-btn-primary:hover{background-color:rgba(33,150,243,.12)!important;color:#2196f3!important}.dark-blue .bg-primary .jr-flat-btn.jr-btn-primary{background-color:transparent!important;color:#fff!important;border-color:transparent!important}.dark-blue .bg-primary .jr-flat-btn.jr-btn-primary:focus,.dark-blue .bg-primary .jr-flat-btn.jr-btn-primary:hover{background-color:hsla(0,0%,100%,.12)!important;color:#fff!important}.dark-blue .jr-flat-btn.jr-btn-secondary{background-color:transparent!important;color:#ff6e40!important;border-color:transparent!important}.dark-blue .jr-flat-btn.jr-btn-secondary:focus,.dark-blue .jr-flat-btn.jr-btn-secondary:hover{background-color:rgba(255,110,64,.12)!important;color:#ff6e40!important}.dark-blue .bg-secondary .jr-flat-btn.jr-btn-secondary{background-color:transparent!important;color:#fff!important;border-color:transparent!important}.dark-blue .bg-secondary .jr-flat-btn.jr-btn-secondary:focus,.dark-blue .bg-secondary .jr-flat-btn.jr-btn-secondary:hover{background-color:hsla(0,0%,100%,.12)!important;color:#fff!important}.dark-blue .app-main-header{background-color:#2196f3!important;color:#fff;border-color:#2196f3}.dark-blue .app-main-header .search-bar input{background-color:#39a1f4}.dark-blue .app-main-header .search-bar input+.search-icon i{color:#fff}.dark-blue .app-main-header .search-bar input:focus{background-color:#fff}.dark-blue .app-main-header .search-bar input:focus+.search-icon i{color:hsla(0,0%,50%,.8)}@media screen and (max-width:575px){.dark-blue .app-main-header .search-dropdown input{background-color:#fff}.dark-blue .app-main-header .search-dropdown input+.search-icon i{color:hsla(0,0%,50%,.8)}}.dark-blue .app-main-header .jr-menu-icon .menu-icon{background-color:#fff!important}.dark-blue .app-header .jr-menu-icon .menu-icon{background-color:#fff}.dark-blue .quick-menu .icon-btn{color:#fff}.dark-blue .react-logo-white.d-block{display:block!important}@media screen and (min-width:992px){.dark-blue .react-logo-white.d-lg-block{display:block!important}.dark-blue .react-logo-white.d-lg-none{display:none!important}}.dark-blue .react-logo-color.d-block{display:none!important}@media screen and (min-width:992px){.dark-blue .react-logo-color.d-lg-block{display:none!important}}.dark-blue .color-theme-header{background-color:#2196f3}.dark-blue .sidebar-header{border-bottom:0 none;background-color:#1d1d1d}.dark-blue .side-nav{background-color:#252525!important;color:#a1a1a1!important;border-right:0 none!important}.dark-blue .side-nav .user-profile{background-color:#1d1d1d;position:relative;z-index:2}.dark-blue .side-nav .customizer{border-bottom:0 none}.dark-blue .side-nav .user-detail .user-name{color:#fff}.dark-blue ul.nav-menu .nav-header,.dark-blue ul.nav-menu li a{color:#a1a1a1}.dark-blue ul.nav-menu>li.open>a,.dark-blue ul.nav-menu>li>a:focus,.dark-blue ul.nav-menu>li>a:hover{background-color:#1d1d1d;color:#fff}.dark-blue ul.nav-menu li.menu.open>a{border-color:#2196f3}.dark-blue ul.nav-menu li.menu>a:focus:before,.dark-blue ul.nav-menu li.menu>a:hover:before{color:#fff}.dark-blue ul.nav-menu li ul{background-color:#1d1d1d}.dark-blue ul.nav-menu li.menu>a:before{color:#a1a1a1}.dark-blue ul.nav-menu li.menu.open>a:before,.dark-blue ul.nav-menu li.menu>a:focus:before,.dark-blue ul.nav-menu li.menu li>a:hover:before{color:#fff}.dark-blue ul.nav-menu li.menu .sub-menu li>a:before{color:#a1a1a1}.dark-blue ul.nav-menu li.menu .sub-menu li>a.active .nav-text{background-color:#2196f3}.dark-blue ul.nav-menu li.menu.open .sub-menu li>a.active:before,.dark-blue ul.nav-menu li.menu .sub-menu li>a:focus,.dark-blue ul.nav-menu li.menu .sub-menu li>a:focus:before,.dark-blue ul.nav-menu li.menu .sub-menu li>a:hover,.dark-blue ul.nav-menu li.menu .sub-menu li>a:hover:before{background-color:#1d1d1d;color:#fff}.dark-blue .navbar-nav li:focus>a,.dark-blue .navbar-nav li:hover>a{color:#2196f3}.dark-blue .navbar-nav li a{color:#868e96}.dark-blue .navbar-nav li a:focus,.dark-blue .navbar-nav li a:hover{color:#2196f3}.dark-blue .navbar-nav li.nav-item>a{color:#fff}.dark-blue .navbar-nav li.nav-item.active>a,.dark-blue .navbar-nav li.nav-item:focus>a,.dark-blue .navbar-nav li.nav-item:hover>a,.dark-blue .navbar-nav li.nav-item>a:focus,.dark-blue .navbar-nav li.nav-item>a:hover{color:#ff6e40}.dark-blue .navbar-nav ul.sub-menu li.active>a,.dark-blue .navbar-nav ul.sub-menu li a.active{color:#2196f3}.dark-blue .navbar-nav .nav-arrow>a:before{color:#868e96}.dark-blue .navbar-nav .nav-arrow.active>a:before,.dark-blue .navbar-nav .nav-arrow:focus>a:before,.dark-blue .navbar-nav .nav-arrow:hover>a:before,.dark-blue .navbar-nav .nav-arrow a:focus:before,.dark-blue .navbar-nav .nav-arrow a:hover:before{color:#2196f3}.dark-blue .app-top-nav{background-color:#252525!important;border-color:#252525}.dark-blue .app-top-nav .navbar-nav li.nav-item>a{color:#fff}.dark-blue .app-top-nav .navbar-nav li.nav-item.active>a,.dark-blue .app-top-nav .navbar-nav li.nav-item:focus>a,.dark-blue .app-top-nav .navbar-nav li.nav-item:hover>a,.dark-blue .app-top-nav .navbar-nav li.nav-item>a:focus,.dark-blue .app-top-nav .navbar-nav li.nav-item>a:hover{color:#ff6e40}.dark-blue .module-nav li a.active{border-color:#2196f3}.dark-blue .rbc-event{background-color:#2196f3}.dark-blue .rbc-event.rbc-selected{background-color:#0c7cd5}.dark-blue .rbc-slot-selection{background-color:rgba(33,150,243,.7)}.dark-blue .rbc-toolbar button.rbc-active,.dark-blue .rbc-toolbar button.rbc-active:focus,.dark-blue .rbc-toolbar button.rbc-active:hover,.dark-blue .rbc-toolbar button:active,.dark-blue .rbc-toolbar button:active:focus,.dark-blue .rbc-toolbar button:active:hover,.dark-blue .rbc-toolbar button:focus,.dark-blue .rbc-toolbar button:hover{background-color:rgba(33,150,243,.9);border-color:#2196f3}.dark-blue .rbc-day-slot .rbc-event{border-color:#2196f3}.dark-blue .chat-sidenav-title{color:#2196f3}.dark-blue .chat-user-item.active,.dark-blue .chat-user-item:hover{background-color:#e3f2fd}.dark-blue .contact-list i{color:#2196f3}.dark-blue .Collapsible__trigger{background:#2196f3}.dark-blue .categories-list li.active a,.dark-blue .categories-list li a:focus,.dark-blue .categories-list li a:hover{color:#2196f3}.dark-blue .filter-with-bg-color ul li a,.dark-blue .login-content .form-control:focus{border-color:#2196f3}.dark-blue .filter-with-bg-color ul li a.active,.dark-blue .filter-with-bg-color ul li a:focus,.dark-blue .filter-with-bg-color ul li a:hover{background-color:#2196f3}.dark-blue .profile-intro .icon{color:#2196f3}.dark-blue .actions,.dark-blue .social-link li.active a,.dark-blue .social-link li a:focus,.dark-blue .social-link li a:hover{color:#ff6e40}.dark-blue .table-hover tbody tr:hover{background-color:rgba(33,150,243,.075)}.dark-blue .border-primary{border-color:#2196f3!important}.dark-blue .app-logo-content{background-color:#2196f3}.dark-blue .app-social-block .social-link button{border:1px solid #2196f3;color:#2196f3}.dark-blue .app-social-block .social-link button:focus,.dark-blue .app-social-block .social-link button:hover{color:#fff;background-color:#2196f3}.dark-blue .btn-group-vertical>.btn-default.active,.dark-blue .btn-group-vertical>.jr-btn.active,.dark-blue .btn-group>.btn-default.active,.dark-blue .btn-group>.jr-btn.active{background-color:#2196f3;border-color:#2196f3}.dark-blue .btn-group-vertical>.jr-flat-btn,.dark-blue .btn-group>.jr-flat-btn{border-color:transparent}.dark-blue .btn-group-vertical>.jr-flat-btn.active,.dark-blue .btn-group>.jr-flat-btn.active{background-color:transparent;color:#2196f3!important;border-color:transparent!important}.dark-blue .btn-group-vertical>.jr-flat-btn.active:focus,.dark-blue .btn-group-vertical>.jr-flat-btn.active:hover,.dark-blue .btn-group>.jr-flat-btn.active:focus,.dark-blue .btn-group>.jr-flat-btn.active:hover{background-color:rgba(33,150,243,.12)!important;color:#2196f3!important}.dark-blue .nav-pill-sales .nav-link.active{background-color:#2196f3;border-color:#2196f3}.dark-blue .form-checkbox>input+.check,.dark-blue .form-checkbox>input.sm+.check{color:#2196f3}.dark-blue .app-main-header ::-webkit-input-placeholder{color:#ebebeb}.dark-blue .app-main-header ::-moz-placeholder{color:#ebebeb}.dark-blue .app-main-header :-ms-input-placeholder{color:#ebebeb}.dark-blue .app-main-header :-moz-placeholder{color:#ebebeb}.dark-blue .app-main-header input:focus::-webkit-input-placeholder{color:#dcdcdc}.dark-blue .app-main-header input:focus::-moz-placeholder{color:#dcdcdc}.dark-blue .app-main-header input:focus:-ms-input-placeholder{color:#dcdcdc}.dark-blue .app-main-header input:focus:-moz-placeholder{color:#dcdcdc}.dark-deep-purple .right-arrow,.dark-deep-purple .right-arrow:after{color:#673ab7}.dark-deep-purple .btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-deep-purple .btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.dark-deep-purple .btn-primary.focus,.dark-deep-purple .btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.dark-deep-purple .btn-primary.disabled,.dark-deep-purple .btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-deep-purple .btn-primary:not(:disabled):not(.disabled).active,.dark-deep-purple .btn-primary:not(:disabled):not(.disabled):active,.show>.dark-deep-purple .btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.dark-deep-purple .btn-primary:not(:disabled):not(.disabled).active:focus,.dark-deep-purple .btn-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-purple .btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-deep-purple .btn-secondary{background-color:#e91e63;border-color:#e91e63;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-deep-purple .btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.dark-deep-purple .btn-secondary.focus,.dark-deep-purple .btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.dark-deep-purple .btn-secondary.disabled,.dark-deep-purple .btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-deep-purple .btn-secondary:not(:disabled):not(.disabled).active,.dark-deep-purple .btn-secondary:not(:disabled):not(.disabled):active,.show>.dark-deep-purple .btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.dark-deep-purple .btn-secondary:not(:disabled):not(.disabled).active:focus,.dark-deep-purple .btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-purple .btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-deep-purple .btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-deep-purple .btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.dark-deep-purple .btn-success.focus,.dark-deep-purple .btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.dark-deep-purple .btn-success.disabled,.dark-deep-purple .btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-deep-purple .btn-success:not(:disabled):not(.disabled).active,.dark-deep-purple .btn-success:not(:disabled):not(.disabled):active,.show>.dark-deep-purple .btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.dark-deep-purple .btn-success:not(:disabled):not(.disabled).active:focus,.dark-deep-purple .btn-success:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-purple .btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-deep-purple .btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-deep-purple .btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.dark-deep-purple .btn-info.focus,.dark-deep-purple .btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.dark-deep-purple .btn-info.disabled,.dark-deep-purple .btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-deep-purple .btn-info:not(:disabled):not(.disabled).active,.dark-deep-purple .btn-info:not(:disabled):not(.disabled):active,.show>.dark-deep-purple .btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.dark-deep-purple .btn-info:not(:disabled):not(.disabled).active:focus,.dark-deep-purple .btn-info:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-purple .btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-deep-purple .btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-deep-purple .btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.dark-deep-purple .btn-warning.focus,.dark-deep-purple .btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.dark-deep-purple .btn-warning.disabled,.dark-deep-purple .btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-deep-purple .btn-warning:not(:disabled):not(.disabled).active,.dark-deep-purple .btn-warning:not(:disabled):not(.disabled):active,.show>.dark-deep-purple .btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.dark-deep-purple .btn-warning:not(:disabled):not(.disabled).active:focus,.dark-deep-purple .btn-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-purple .btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-deep-purple .btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-deep-purple .btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.dark-deep-purple .btn-danger.focus,.dark-deep-purple .btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.dark-deep-purple .btn-danger.disabled,.dark-deep-purple .btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.dark-deep-purple .btn-danger:not(:disabled):not(.disabled).active,.dark-deep-purple .btn-danger:not(:disabled):not(.disabled):active,.show>.dark-deep-purple .btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.dark-deep-purple .btn-danger:not(:disabled):not(.disabled).active:focus,.dark-deep-purple .btn-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-purple .btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-deep-purple .btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-deep-purple .btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.dark-deep-purple .btn-light.focus,.dark-deep-purple .btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.dark-deep-purple .btn-light.disabled,.dark-deep-purple .btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-deep-purple .btn-light:not(:disabled):not(.disabled).active,.dark-deep-purple .btn-light:not(:disabled):not(.disabled):active,.show>.dark-deep-purple .btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.dark-deep-purple .btn-light:not(:disabled):not(.disabled).active:focus,.dark-deep-purple .btn-light:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-purple .btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-deep-purple .btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-deep-purple .btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.dark-deep-purple .btn-dark.focus,.dark-deep-purple .btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.dark-deep-purple .btn-dark.disabled,.dark-deep-purple .btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.dark-deep-purple .btn-dark:not(:disabled):not(.disabled).active,.dark-deep-purple .btn-dark:not(:disabled):not(.disabled):active,.show>.dark-deep-purple .btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.dark-deep-purple .btn-dark:not(:disabled):not(.disabled).active:focus,.dark-deep-purple .btn-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-purple .btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-deep-purple a.btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-deep-purple a.btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.dark-deep-purple a.btn-primary.focus,.dark-deep-purple a.btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.dark-deep-purple a.btn-primary.disabled,.dark-deep-purple a.btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-deep-purple a.btn-primary:not(:disabled):not(.disabled).active,.dark-deep-purple a.btn-primary:not(:disabled):not(.disabled):active,.show>.dark-deep-purple a.btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.dark-deep-purple a.btn-primary:not(:disabled):not(.disabled).active:focus,.dark-deep-purple a.btn-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-purple a.btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-deep-purple a.btn-secondary{color:#fff;background-color:#e91e63;border-color:#e91e63;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-deep-purple a.btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.dark-deep-purple a.btn-secondary.focus,.dark-deep-purple a.btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.dark-deep-purple a.btn-secondary.disabled,.dark-deep-purple a.btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-deep-purple a.btn-secondary:not(:disabled):not(.disabled).active,.dark-deep-purple a.btn-secondary:not(:disabled):not(.disabled):active,.show>.dark-deep-purple a.btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.dark-deep-purple a.btn-secondary:not(:disabled):not(.disabled).active:focus,.dark-deep-purple a.btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-purple a.btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-deep-purple a.btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-deep-purple a.btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.dark-deep-purple a.btn-success.focus,.dark-deep-purple a.btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.dark-deep-purple a.btn-success.disabled,.dark-deep-purple a.btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-deep-purple a.btn-success:not(:disabled):not(.disabled).active,.dark-deep-purple a.btn-success:not(:disabled):not(.disabled):active,.show>.dark-deep-purple a.btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.dark-deep-purple a.btn-success:not(:disabled):not(.disabled).active:focus,.dark-deep-purple a.btn-success:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-purple a.btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-deep-purple a.btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-deep-purple a.btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.dark-deep-purple a.btn-info.focus,.dark-deep-purple a.btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.dark-deep-purple a.btn-info.disabled,.dark-deep-purple a.btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-deep-purple a.btn-info:not(:disabled):not(.disabled).active,.dark-deep-purple a.btn-info:not(:disabled):not(.disabled):active,.show>.dark-deep-purple a.btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.dark-deep-purple a.btn-info:not(:disabled):not(.disabled).active:focus,.dark-deep-purple a.btn-info:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-purple a.btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-deep-purple a.btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-deep-purple a.btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.dark-deep-purple a.btn-warning.focus,.dark-deep-purple a.btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.dark-deep-purple a.btn-warning.disabled,.dark-deep-purple a.btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-deep-purple a.btn-warning:not(:disabled):not(.disabled).active,.dark-deep-purple a.btn-warning:not(:disabled):not(.disabled):active,.show>.dark-deep-purple a.btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.dark-deep-purple a.btn-warning:not(:disabled):not(.disabled).active:focus,.dark-deep-purple a.btn-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-purple a.btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-deep-purple a.btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-deep-purple a.btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.dark-deep-purple a.btn-danger.focus,.dark-deep-purple a.btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.dark-deep-purple a.btn-danger.disabled,.dark-deep-purple a.btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.dark-deep-purple a.btn-danger:not(:disabled):not(.disabled).active,.dark-deep-purple a.btn-danger:not(:disabled):not(.disabled):active,.show>.dark-deep-purple a.btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.dark-deep-purple a.btn-danger:not(:disabled):not(.disabled).active:focus,.dark-deep-purple a.btn-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-purple a.btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-deep-purple a.btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-deep-purple a.btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.dark-deep-purple a.btn-light.focus,.dark-deep-purple a.btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.dark-deep-purple a.btn-light.disabled,.dark-deep-purple a.btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-deep-purple a.btn-light:not(:disabled):not(.disabled).active,.dark-deep-purple a.btn-light:not(:disabled):not(.disabled):active,.show>.dark-deep-purple a.btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.dark-deep-purple a.btn-light:not(:disabled):not(.disabled).active:focus,.dark-deep-purple a.btn-light:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-purple a.btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-deep-purple a.btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-deep-purple a.btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.dark-deep-purple a.btn-dark.focus,.dark-deep-purple a.btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.dark-deep-purple a.btn-dark.disabled,.dark-deep-purple a.btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.dark-deep-purple a.btn-dark:not(:disabled):not(.disabled).active,.dark-deep-purple a.btn-dark:not(:disabled):not(.disabled):active,.show>.dark-deep-purple a.btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.dark-deep-purple a.btn-dark:not(:disabled):not(.disabled).active:focus,.dark-deep-purple a.btn-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-purple a.btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-deep-purple .btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.dark-deep-purple .btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-deep-purple .btn-outline-primary.focus,.dark-deep-purple .btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.dark-deep-purple .btn-outline-primary.disabled,.dark-deep-purple .btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.dark-deep-purple .btn-outline-primary:not(:disabled):not(.disabled).active,.dark-deep-purple .btn-outline-primary:not(:disabled):not(.disabled):active,.show>.dark-deep-purple .btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-deep-purple .btn-outline-primary:not(:disabled):not(.disabled).active:focus,.dark-deep-purple .btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-purple .btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-deep-purple .btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.dark-deep-purple .btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-deep-purple .btn-outline-secondary.focus,.dark-deep-purple .btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.dark-deep-purple .btn-outline-secondary.disabled,.dark-deep-purple .btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.dark-deep-purple .btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-deep-purple .btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.dark-deep-purple .btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-deep-purple .btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.dark-deep-purple .btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-purple .btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-deep-purple .btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.dark-deep-purple .btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-deep-purple .btn-outline-success.focus,.dark-deep-purple .btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.dark-deep-purple .btn-outline-success.disabled,.dark-deep-purple .btn-outline-success:disabled{color:#4caf50;background-color:transparent}.dark-deep-purple .btn-outline-success:not(:disabled):not(.disabled).active,.dark-deep-purple .btn-outline-success:not(:disabled):not(.disabled):active,.show>.dark-deep-purple .btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-deep-purple .btn-outline-success:not(:disabled):not(.disabled).active:focus,.dark-deep-purple .btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-purple .btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-deep-purple .btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.dark-deep-purple .btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-deep-purple .btn-outline-info.focus,.dark-deep-purple .btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.dark-deep-purple .btn-outline-info.disabled,.dark-deep-purple .btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.dark-deep-purple .btn-outline-info:not(:disabled):not(.disabled).active,.dark-deep-purple .btn-outline-info:not(:disabled):not(.disabled):active,.show>.dark-deep-purple .btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-deep-purple .btn-outline-info:not(:disabled):not(.disabled).active:focus,.dark-deep-purple .btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-purple .btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-deep-purple .btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.dark-deep-purple .btn-outline-warning:hover{color:#fff;background-color:#ff9800;border-color:#ff9800}.dark-deep-purple .btn-outline-warning.focus,.dark-deep-purple .btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.dark-deep-purple .btn-outline-warning.disabled,.dark-deep-purple .btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.dark-deep-purple .btn-outline-warning:not(:disabled):not(.disabled).active,.dark-deep-purple .btn-outline-warning:not(:disabled):not(.disabled):active,.show>.dark-deep-purple .btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-deep-purple .btn-outline-warning:not(:disabled):not(.disabled).active:focus,.dark-deep-purple .btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-purple .btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-deep-purple .btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.dark-deep-purple .btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.dark-deep-purple .btn-outline-danger.focus,.dark-deep-purple .btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.dark-deep-purple .btn-outline-danger.disabled,.dark-deep-purple .btn-outline-danger:disabled{color:#f44336;background-color:transparent}.dark-deep-purple .btn-outline-danger:not(:disabled):not(.disabled).active,.dark-deep-purple .btn-outline-danger:not(:disabled):not(.disabled):active,.show>.dark-deep-purple .btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.dark-deep-purple .btn-outline-danger:not(:disabled):not(.disabled).active:focus,.dark-deep-purple .btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-purple .btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-deep-purple .btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.dark-deep-purple .btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-deep-purple .btn-outline-light.focus,.dark-deep-purple .btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.dark-deep-purple .btn-outline-light.disabled,.dark-deep-purple .btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.dark-deep-purple .btn-outline-light:not(:disabled):not(.disabled).active,.dark-deep-purple .btn-outline-light:not(:disabled):not(.disabled):active,.show>.dark-deep-purple .btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-deep-purple .btn-outline-light:not(:disabled):not(.disabled).active:focus,.dark-deep-purple .btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-purple .btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-deep-purple .btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.dark-deep-purple .btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.dark-deep-purple .btn-outline-dark.focus,.dark-deep-purple .btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.dark-deep-purple .btn-outline-dark.disabled,.dark-deep-purple .btn-outline-dark:disabled{color:#343a40;background-color:transparent}.dark-deep-purple .btn-outline-dark:not(:disabled):not(.disabled).active,.dark-deep-purple .btn-outline-dark:not(:disabled):not(.disabled):active,.show>.dark-deep-purple .btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.dark-deep-purple .btn-outline-dark:not(:disabled):not(.disabled).active:focus,.dark-deep-purple .btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-purple .btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-deep-purple a.btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.dark-deep-purple a.btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-deep-purple a.btn-outline-primary.focus,.dark-deep-purple a.btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.dark-deep-purple a.btn-outline-primary.disabled,.dark-deep-purple a.btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.dark-deep-purple a.btn-outline-primary:not(:disabled):not(.disabled).active,.dark-deep-purple a.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.dark-deep-purple a.btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-deep-purple a.btn-outline-primary:not(:disabled):not(.disabled).active:focus,.dark-deep-purple a.btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-purple a.btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-deep-purple a.btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.dark-deep-purple a.btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-deep-purple a.btn-outline-secondary.focus,.dark-deep-purple a.btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.dark-deep-purple a.btn-outline-secondary.disabled,.dark-deep-purple a.btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.dark-deep-purple a.btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-deep-purple a.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.dark-deep-purple a.btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-deep-purple a.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.dark-deep-purple a.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-purple a.btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-deep-purple a.btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.dark-deep-purple a.btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-deep-purple a.btn-outline-success.focus,.dark-deep-purple a.btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.dark-deep-purple a.btn-outline-success.disabled,.dark-deep-purple a.btn-outline-success:disabled{color:#4caf50;background-color:transparent}.dark-deep-purple a.btn-outline-success:not(:disabled):not(.disabled).active,.dark-deep-purple a.btn-outline-success:not(:disabled):not(.disabled):active,.show>.dark-deep-purple a.btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-deep-purple a.btn-outline-success:not(:disabled):not(.disabled).active:focus,.dark-deep-purple a.btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-purple a.btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-deep-purple a.btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.dark-deep-purple a.btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-deep-purple a.btn-outline-info.focus,.dark-deep-purple a.btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.dark-deep-purple a.btn-outline-info.disabled,.dark-deep-purple a.btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.dark-deep-purple a.btn-outline-info:not(:disabled):not(.disabled).active,.dark-deep-purple a.btn-outline-info:not(:disabled):not(.disabled):active,.show>.dark-deep-purple a.btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-deep-purple a.btn-outline-info:not(:disabled):not(.disabled).active:focus,.dark-deep-purple a.btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-purple a.btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-deep-purple a.btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.dark-deep-purple a.btn-outline-warning:hover{color:#fff;background-color:#ff9800;border-color:#ff9800}.dark-deep-purple a.btn-outline-warning.focus,.dark-deep-purple a.btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.dark-deep-purple a.btn-outline-warning.disabled,.dark-deep-purple a.btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.dark-deep-purple a.btn-outline-warning:not(:disabled):not(.disabled).active,.dark-deep-purple a.btn-outline-warning:not(:disabled):not(.disabled):active,.show>.dark-deep-purple a.btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-deep-purple a.btn-outline-warning:not(:disabled):not(.disabled).active:focus,.dark-deep-purple a.btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-purple a.btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-deep-purple a.btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.dark-deep-purple a.btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.dark-deep-purple a.btn-outline-danger.focus,.dark-deep-purple a.btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.dark-deep-purple a.btn-outline-danger.disabled,.dark-deep-purple a.btn-outline-danger:disabled{color:#f44336;background-color:transparent}.dark-deep-purple a.btn-outline-danger:not(:disabled):not(.disabled).active,.dark-deep-purple a.btn-outline-danger:not(:disabled):not(.disabled):active,.show>.dark-deep-purple a.btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.dark-deep-purple a.btn-outline-danger:not(:disabled):not(.disabled).active:focus,.dark-deep-purple a.btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-purple a.btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-deep-purple a.btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.dark-deep-purple a.btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-deep-purple a.btn-outline-light.focus,.dark-deep-purple a.btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.dark-deep-purple a.btn-outline-light.disabled,.dark-deep-purple a.btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.dark-deep-purple a.btn-outline-light:not(:disabled):not(.disabled).active,.dark-deep-purple a.btn-outline-light:not(:disabled):not(.disabled):active,.show>.dark-deep-purple a.btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-deep-purple a.btn-outline-light:not(:disabled):not(.disabled).active:focus,.dark-deep-purple a.btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-purple a.btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-deep-purple a.btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.dark-deep-purple a.btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.dark-deep-purple a.btn-outline-dark.focus,.dark-deep-purple a.btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.dark-deep-purple a.btn-outline-dark.disabled,.dark-deep-purple a.btn-outline-dark:disabled{color:#343a40;background-color:transparent}.dark-deep-purple a.btn-outline-dark:not(:disabled):not(.disabled).active,.dark-deep-purple a.btn-outline-dark:not(:disabled):not(.disabled):active,.show>.dark-deep-purple a.btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.dark-deep-purple a.btn-outline-dark:not(:disabled):not(.disabled).active:focus,.dark-deep-purple a.btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-deep-purple a.btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-deep-purple .btn-outline-primary,.dark-deep-purple a.btn-outline-primary{color:#673ab7;border-color:#673ab7}.dark-deep-purple .btn-outline-primary.disabled,.dark-deep-purple .btn-outline-primary:disabled,.dark-deep-purple .btn-outline-primary:focus,.dark-deep-purple .btn-outline-primary:hover,.dark-deep-purple .btn-outline-primary:not(:disabled):not(.disabled).active,.dark-deep-purple .btn-outline-primary:not(:disabled):not(.disabled):active,.dark-deep-purple a.btn-outline-primary.disabled,.dark-deep-purple a.btn-outline-primary:disabled,.dark-deep-purple a.btn-outline-primary:focus,.dark-deep-purple a.btn-outline-primary:hover,.dark-deep-purple a.btn-outline-primary:not(:disabled):not(.disabled).active,.dark-deep-purple a.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.dark-deep-purple .btn-outline-primary.dropdown-toggle,.show>.dark-deep-purple a.btn-outline-primary.dropdown-toggle{color:#fff;border-color:#673ab7;background-color:#673ab7}.dark-deep-purple .btn-outline-secondary,.dark-deep-purple a.btn-outline-secondary{color:#ffab00;border-color:#ffab00}.dark-deep-purple .btn-outline-secondary.disabled,.dark-deep-purple .btn-outline-secondary:disabled,.dark-deep-purple .btn-outline-secondary:focus,.dark-deep-purple .btn-outline-secondary:hover,.dark-deep-purple .btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-deep-purple .btn-outline-secondary:not(:disabled):not(.disabled):active,.dark-deep-purple a.btn-outline-secondary.disabled,.dark-deep-purple a.btn-outline-secondary:disabled,.dark-deep-purple a.btn-outline-secondary:focus,.dark-deep-purple a.btn-outline-secondary:hover,.dark-deep-purple a.btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-deep-purple a.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.dark-deep-purple .btn-outline-secondary.dropdown-toggle,.show>.dark-deep-purple a.btn-outline-secondary.dropdown-toggle{color:#fff;border-color:#ffab00;background-color:#ffab00}.dark-deep-purple a,.dark-deep-purple a.text-primary{color:#673ab7}.dark-deep-purple a.text-primary:focus,.dark-deep-purple a.text-primary:hover,.dark-deep-purple a:focus,.dark-deep-purple a:hover{color:#512e90}.dark-deep-purple .text-primary{color:#673ab7!important}.dark-deep-purple .page-link,.dark-deep-purple .page-link:focus,.dark-deep-purple .page-link:hover{color:#673ab7}.dark-deep-purple .badge-primary,.dark-deep-purple .bg-primary{background-color:#673ab7!important;color:#fff!important}.dark-deep-purple .btn-primary,.dark-deep-purple .jr-btn-primary,.dark-deep-purple a.btn-primary,.dark-deep-purple a.jr-btn-primary{background-color:#673ab7;border-color:#673ab7;color:#fff}.dark-deep-purple .btn-primary:focus,.dark-deep-purple .btn-primary:hover,.dark-deep-purple .btn-primary:not([disabled]):not(.disabled):active,.dark-deep-purple .jr-btn-primary:focus,.dark-deep-purple .jr-btn-primary:hover,.dark-deep-purple .jr-btn-primary:not([disabled]):not(.disabled):active,.dark-deep-purple a.btn-primary:focus,.dark-deep-purple a.btn-primary:hover,.dark-deep-purple a.btn-primary:not([disabled]):not(.disabled):active,.dark-deep-purple a.jr-btn-primary:focus,.dark-deep-purple a.jr-btn-primary:hover,.dark-deep-purple a.jr-btn-primary:not([disabled]):not(.disabled):active{background-color:#5c34a4!important;border-color:#5c34a4!important;color:#fff!important}.dark-deep-purple .bg-primary.lighten-4{background-color:#d1c4e9!important}.dark-deep-purple .bg-primary.lighten-3{background-color:#b39ddb!important}.dark-deep-purple .bg-primary.lighten-2{background-color:#9575cd!important}.dark-deep-purple .bg-primary.lighten-1{background-color:#7e57c2!important}.dark-deep-purple .bg-primary.darken-1{background-color:#5e35b1!important}.dark-deep-purple .bg-primary.darken-2{background-color:#512da8!important}.dark-deep-purple .bg-primary.darken-3{background-color:#4527a0!important}.dark-deep-purple .bg-primary.darken-4{background-color:#311b92!important}.dark-deep-purple .bg-primary.accent-1{background-color:#b388ff!important}.dark-deep-purple .bg-primary.accent-2{background-color:#7c4dff!important}.dark-deep-purple .bg-primary.accent-3{background-color:#651fff!important}.dark-deep-purple .bg-primary.accent-4{background-color:#6200ea!important}.dark-deep-purple a.text-secondary{color:#ffab00}.dark-deep-purple a.text-secondary:focus,.dark-deep-purple a.text-secondary:hover{color:#cc8900!important}.dark-deep-purple .text-secondary{color:#ffab00!important}.dark-deep-purple .badge-secondary,.dark-deep-purple .bg-secondary{background-color:#ffab00!important;color:#fff!important}.dark-deep-purple .btn-secondary{background-color:#ffab00;border-color:#ffab00;color:#fff}.dark-deep-purple .btn-secondary:active,.dark-deep-purple .btn-secondary:focus,.dark-deep-purple .btn-secondary:hover{background-color:#e69a00!important;border-color:#e69a00!important;color:#fff!important}.dark-deep-purple .jr-flat-btn{background-color:transparent!important;color:#5c5c5c!important}.dark-deep-purple .jr-flat-btn:active,.dark-deep-purple .jr-flat-btn:focus,.dark-deep-purple .jr-flat-btn:hover{background-color:#f5f5f5!important;color:#5c5c5c!important}.dark-deep-purple .jr-flat-btn.jr-btn-primary{background-color:transparent!important;color:#673ab7!important;border-color:transparent!important}.dark-deep-purple .jr-flat-btn.jr-btn-primary:focus,.dark-deep-purple .jr-flat-btn.jr-btn-primary:hover{background-color:rgba(103,58,183,.12)!important;color:#673ab7!important}.dark-deep-purple .bg-primary .jr-flat-btn.jr-btn-primary{background-color:transparent!important;color:#fff!important;border-color:transparent!important}.dark-deep-purple .bg-primary .jr-flat-btn.jr-btn-primary:focus,.dark-deep-purple .bg-primary .jr-flat-btn.jr-btn-primary:hover{background-color:hsla(0,0%,100%,.12)!important;color:#fff!important}.dark-deep-purple .jr-flat-btn.jr-btn-secondary{background-color:transparent!important;color:#ffab00!important;border-color:transparent!important}.dark-deep-purple .jr-flat-btn.jr-btn-secondary:focus,.dark-deep-purple .jr-flat-btn.jr-btn-secondary:hover{background-color:rgba(255,171,0,.12)!important;color:#ffab00!important}.dark-deep-purple .bg-secondary .jr-flat-btn.jr-btn-secondary{background-color:transparent!important;color:#fff!important;border-color:transparent!important}.dark-deep-purple .bg-secondary .jr-flat-btn.jr-btn-secondary:focus,.dark-deep-purple .bg-secondary .jr-flat-btn.jr-btn-secondary:hover{background-color:hsla(0,0%,100%,.12)!important;color:#fff!important}.dark-deep-purple .app-main-header{background-color:#673ab7!important;color:#fff;border-color:#673ab7}.dark-deep-purple .app-main-header .search-bar input{background-color:#7446c4}.dark-deep-purple .app-main-header .search-bar input+.search-icon i{color:#fff}.dark-deep-purple .app-main-header .search-bar input:focus{background-color:#fff}.dark-deep-purple .app-main-header .search-bar input:focus+.search-icon i{color:hsla(0,0%,50%,.8)}@media screen and (max-width:575px){.dark-deep-purple .app-main-header .search-dropdown input{background-color:#fff}.dark-deep-purple .app-main-header .search-dropdown input+.search-icon i{color:hsla(0,0%,50%,.8)}}.dark-deep-purple .app-main-header .jr-menu-icon .menu-icon{background-color:#fff!important}.dark-deep-purple .app-header .jr-menu-icon .menu-icon{background-color:#fff}.dark-deep-purple .quick-menu .icon-btn{color:#fff}.dark-deep-purple .react-logo-white.d-block{display:block!important}@media screen and (min-width:992px){.dark-deep-purple .react-logo-white.d-lg-block{display:block!important}.dark-deep-purple .react-logo-white.d-lg-none{display:none!important}}.dark-deep-purple .react-logo-color.d-block{display:none!important}@media screen and (min-width:992px){.dark-deep-purple .react-logo-color.d-lg-block{display:none!important}}.dark-deep-purple .color-theme-header{background-color:#673ab7}.dark-deep-purple .sidebar-header{border-bottom:0 none;background-color:#1d1d1d}.dark-deep-purple .side-nav{background-color:#252525!important;color:#a1a1a1!important;border-right:0 none!important}.dark-deep-purple .side-nav .user-profile{background-color:#1d1d1d;position:relative;z-index:2}.dark-deep-purple .side-nav .customizer{border-bottom:0 none}.dark-deep-purple .side-nav .user-detail .user-name{color:#fff}.dark-deep-purple ul.nav-menu .nav-header,.dark-deep-purple ul.nav-menu li a{color:#a1a1a1}.dark-deep-purple ul.nav-menu>li.open>a,.dark-deep-purple ul.nav-menu>li>a:focus,.dark-deep-purple ul.nav-menu>li>a:hover{background-color:#1d1d1d;color:#fff}.dark-deep-purple ul.nav-menu li.menu.open>a{border-color:#ffab00}.dark-deep-purple ul.nav-menu li.menu>a:focus:before,.dark-deep-purple ul.nav-menu li.menu>a:hover:before{color:#fff}.dark-deep-purple ul.nav-menu li ul{background-color:#1d1d1d}.dark-deep-purple ul.nav-menu li.menu>a:before{color:#a1a1a1}.dark-deep-purple ul.nav-menu li.menu.open>a:before,.dark-deep-purple ul.nav-menu li.menu>a:focus:before,.dark-deep-purple ul.nav-menu li.menu li>a:hover:before{color:#fff}.dark-deep-purple ul.nav-menu li.menu .sub-menu li>a:before{color:#a1a1a1}.dark-deep-purple ul.nav-menu li.menu .sub-menu li>a.active .nav-text{background-color:#673ab7}.dark-deep-purple ul.nav-menu li.menu.open .sub-menu li>a.active:before,.dark-deep-purple ul.nav-menu li.menu .sub-menu li>a:focus,.dark-deep-purple ul.nav-menu li.menu .sub-menu li>a:focus:before,.dark-deep-purple ul.nav-menu li.menu .sub-menu li>a:hover,.dark-deep-purple ul.nav-menu li.menu .sub-menu li>a:hover:before{background-color:#1d1d1d;color:#fff}.dark-deep-purple .navbar-nav li:focus>a,.dark-deep-purple .navbar-nav li:hover>a{color:#673ab7}.dark-deep-purple .navbar-nav li a{color:#868e96}.dark-deep-purple .navbar-nav li a:focus,.dark-deep-purple .navbar-nav li a:hover{color:#673ab7}.dark-deep-purple .navbar-nav li.nav-item>a{color:#fff}.dark-deep-purple .navbar-nav li.nav-item.active>a,.dark-deep-purple .navbar-nav li.nav-item:focus>a,.dark-deep-purple .navbar-nav li.nav-item:hover>a,.dark-deep-purple .navbar-nav li.nav-item>a:focus,.dark-deep-purple .navbar-nav li.nav-item>a:hover{color:#ffab00}.dark-deep-purple .navbar-nav ul.sub-menu li.active>a,.dark-deep-purple .navbar-nav ul.sub-menu li a.active{color:#673ab7}.dark-deep-purple .navbar-nav .nav-arrow>a:before{color:#868e96}.dark-deep-purple .navbar-nav .nav-arrow.active>a:before,.dark-deep-purple .navbar-nav .nav-arrow:focus>a:before,.dark-deep-purple .navbar-nav .nav-arrow:hover>a:before,.dark-deep-purple .navbar-nav .nav-arrow a:focus:before,.dark-deep-purple .navbar-nav .nav-arrow a:hover:before{color:#673ab7}.dark-deep-purple .app-top-nav{background-color:#252525!important;border-color:#252525}.dark-deep-purple .app-top-nav .navbar-nav li.nav-item>a{color:#fff}.dark-deep-purple .app-top-nav .navbar-nav li.nav-item.active>a,.dark-deep-purple .app-top-nav .navbar-nav li.nav-item:focus>a,.dark-deep-purple .app-top-nav .navbar-nav li.nav-item:hover>a,.dark-deep-purple .app-top-nav .navbar-nav li.nav-item>a:focus,.dark-deep-purple .app-top-nav .navbar-nav li.nav-item>a:hover{color:#ffab00}.dark-deep-purple .module-nav li a.active{border-color:#673ab7}.dark-deep-purple .rbc-event{background-color:#673ab7}.dark-deep-purple .rbc-event.rbc-selected{background-color:#512e90}.dark-deep-purple .rbc-slot-selection{background-color:rgba(103,58,183,.7)}.dark-deep-purple .rbc-toolbar button.rbc-active,.dark-deep-purple .rbc-toolbar button.rbc-active:focus,.dark-deep-purple .rbc-toolbar button.rbc-active:hover,.dark-deep-purple .rbc-toolbar button:active,.dark-deep-purple .rbc-toolbar button:active:focus,.dark-deep-purple .rbc-toolbar button:active:hover,.dark-deep-purple .rbc-toolbar button:focus,.dark-deep-purple .rbc-toolbar button:hover{background-color:rgba(103,58,183,.9);border-color:#673ab7}.dark-deep-purple .rbc-day-slot .rbc-event{border-color:#673ab7}.dark-deep-purple .chat-sidenav-title{color:#673ab7}.dark-deep-purple .chat-user-item.active,.dark-deep-purple .chat-user-item:hover{background-color:#e8e1f5}.dark-deep-purple .contact-list i{color:#673ab7}.dark-deep-purple .Collapsible__trigger{background:#673ab7}.dark-deep-purple .categories-list li.active a,.dark-deep-purple .categories-list li a:focus,.dark-deep-purple .categories-list li a:hover{color:#673ab7}.dark-deep-purple .filter-with-bg-color ul li a,.dark-deep-purple .login-content .form-control:focus{border-color:#673ab7}.dark-deep-purple .filter-with-bg-color ul li a.active,.dark-deep-purple .filter-with-bg-color ul li a:focus,.dark-deep-purple .filter-with-bg-color ul li a:hover{background-color:#673ab7}.dark-deep-purple .profile-intro .icon{color:#673ab7}.dark-deep-purple .actions,.dark-deep-purple .social-link li.active a,.dark-deep-purple .social-link li a:focus,.dark-deep-purple .social-link li a:hover{color:#ffab00}.dark-deep-purple .table-hover tbody tr:hover{background-color:rgba(103,58,183,.075)}.dark-deep-purple .border-primary{border-color:#673ab7!important}.dark-deep-purple .app-logo-content{background-color:#673ab7}.dark-deep-purple .app-social-block .social-link button{border:1px solid #673ab7;color:#673ab7}.dark-deep-purple .app-social-block .social-link button:focus,.dark-deep-purple .app-social-block .social-link button:hover{color:#fff;background-color:#673ab7}.dark-deep-purple .btn-group-vertical>.btn-default.active,.dark-deep-purple .btn-group-vertical>.jr-btn.active,.dark-deep-purple .btn-group>.btn-default.active,.dark-deep-purple .btn-group>.jr-btn.active{background-color:#673ab7;border-color:#673ab7}.dark-deep-purple .btn-group-vertical>.jr-flat-btn,.dark-deep-purple .btn-group>.jr-flat-btn{border-color:transparent}.dark-deep-purple .btn-group-vertical>.jr-flat-btn.active,.dark-deep-purple .btn-group>.jr-flat-btn.active{background-color:transparent;color:#673ab7!important;border-color:transparent!important}.dark-deep-purple .btn-group-vertical>.jr-flat-btn.active:focus,.dark-deep-purple .btn-group-vertical>.jr-flat-btn.active:hover,.dark-deep-purple .btn-group>.jr-flat-btn.active:focus,.dark-deep-purple .btn-group>.jr-flat-btn.active:hover{background-color:rgba(103,58,183,.12)!important;color:#673ab7!important}.dark-deep-purple .nav-pill-sales .nav-link.active{background-color:#673ab7;border-color:#673ab7}.dark-deep-purple .form-checkbox>input+.check,.dark-deep-purple .form-checkbox>input.sm+.check{color:#673ab7}.dark-deep-purple .app-main-header ::-webkit-input-placeholder{color:#ebebeb}.dark-deep-purple .app-main-header ::-moz-placeholder{color:#ebebeb}.dark-deep-purple .app-main-header :-ms-input-placeholder{color:#ebebeb}.dark-deep-purple .app-main-header :-moz-placeholder{color:#ebebeb}.dark-deep-purple .app-main-header input:focus::-webkit-input-placeholder{color:#dcdcdc}.dark-deep-purple .app-main-header input:focus::-moz-placeholder{color:#dcdcdc}.dark-deep-purple .app-main-header input:focus:-ms-input-placeholder{color:#dcdcdc}.dark-deep-purple .app-main-header input:focus:-moz-placeholder{color:#dcdcdc}.dark-green .right-arrow,.dark-green .right-arrow:after{color:#4caf50}.dark-green .btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-green .btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.dark-green .btn-primary.focus,.dark-green .btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.dark-green .btn-primary.disabled,.dark-green .btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-green .btn-primary:not(:disabled):not(.disabled).active,.dark-green .btn-primary:not(:disabled):not(.disabled):active,.show>.dark-green .btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.dark-green .btn-primary:not(:disabled):not(.disabled).active:focus,.dark-green .btn-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-green .btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-green .btn-secondary{background-color:#e91e63;border-color:#e91e63;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-green .btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.dark-green .btn-secondary.focus,.dark-green .btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.dark-green .btn-secondary.disabled,.dark-green .btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-green .btn-secondary:not(:disabled):not(.disabled).active,.dark-green .btn-secondary:not(:disabled):not(.disabled):active,.show>.dark-green .btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.dark-green .btn-secondary:not(:disabled):not(.disabled).active:focus,.dark-green .btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-green .btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-green .btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-green .btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.dark-green .btn-success.focus,.dark-green .btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.dark-green .btn-success.disabled,.dark-green .btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-green .btn-success:not(:disabled):not(.disabled).active,.dark-green .btn-success:not(:disabled):not(.disabled):active,.show>.dark-green .btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.dark-green .btn-success:not(:disabled):not(.disabled).active:focus,.dark-green .btn-success:not(:disabled):not(.disabled):active:focus,.show>.dark-green .btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-green .btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-green .btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.dark-green .btn-info.focus,.dark-green .btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.dark-green .btn-info.disabled,.dark-green .btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-green .btn-info:not(:disabled):not(.disabled).active,.dark-green .btn-info:not(:disabled):not(.disabled):active,.show>.dark-green .btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.dark-green .btn-info:not(:disabled):not(.disabled).active:focus,.dark-green .btn-info:not(:disabled):not(.disabled):active:focus,.show>.dark-green .btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-green .btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-green .btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.dark-green .btn-warning.focus,.dark-green .btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.dark-green .btn-warning.disabled,.dark-green .btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-green .btn-warning:not(:disabled):not(.disabled).active,.dark-green .btn-warning:not(:disabled):not(.disabled):active,.show>.dark-green .btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.dark-green .btn-warning:not(:disabled):not(.disabled).active:focus,.dark-green .btn-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-green .btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-green .btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-green .btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.dark-green .btn-danger.focus,.dark-green .btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.dark-green .btn-danger.disabled,.dark-green .btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.dark-green .btn-danger:not(:disabled):not(.disabled).active,.dark-green .btn-danger:not(:disabled):not(.disabled):active,.show>.dark-green .btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.dark-green .btn-danger:not(:disabled):not(.disabled).active:focus,.dark-green .btn-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-green .btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-green .btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-green .btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.dark-green .btn-light.focus,.dark-green .btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.dark-green .btn-light.disabled,.dark-green .btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-green .btn-light:not(:disabled):not(.disabled).active,.dark-green .btn-light:not(:disabled):not(.disabled):active,.show>.dark-green .btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.dark-green .btn-light:not(:disabled):not(.disabled).active:focus,.dark-green .btn-light:not(:disabled):not(.disabled):active:focus,.show>.dark-green .btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-green .btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-green .btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.dark-green .btn-dark.focus,.dark-green .btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.dark-green .btn-dark.disabled,.dark-green .btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.dark-green .btn-dark:not(:disabled):not(.disabled).active,.dark-green .btn-dark:not(:disabled):not(.disabled):active,.show>.dark-green .btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.dark-green .btn-dark:not(:disabled):not(.disabled).active:focus,.dark-green .btn-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-green .btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-green a.btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-green a.btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.dark-green a.btn-primary.focus,.dark-green a.btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.dark-green a.btn-primary.disabled,.dark-green a.btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-green a.btn-primary:not(:disabled):not(.disabled).active,.dark-green a.btn-primary:not(:disabled):not(.disabled):active,.show>.dark-green a.btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.dark-green a.btn-primary:not(:disabled):not(.disabled).active:focus,.dark-green a.btn-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-green a.btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-green a.btn-secondary{color:#fff;background-color:#e91e63;border-color:#e91e63;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-green a.btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.dark-green a.btn-secondary.focus,.dark-green a.btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.dark-green a.btn-secondary.disabled,.dark-green a.btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-green a.btn-secondary:not(:disabled):not(.disabled).active,.dark-green a.btn-secondary:not(:disabled):not(.disabled):active,.show>.dark-green a.btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.dark-green a.btn-secondary:not(:disabled):not(.disabled).active:focus,.dark-green a.btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-green a.btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-green a.btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-green a.btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.dark-green a.btn-success.focus,.dark-green a.btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.dark-green a.btn-success.disabled,.dark-green a.btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-green a.btn-success:not(:disabled):not(.disabled).active,.dark-green a.btn-success:not(:disabled):not(.disabled):active,.show>.dark-green a.btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.dark-green a.btn-success:not(:disabled):not(.disabled).active:focus,.dark-green a.btn-success:not(:disabled):not(.disabled):active:focus,.show>.dark-green a.btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-green a.btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-green a.btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.dark-green a.btn-info.focus,.dark-green a.btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.dark-green a.btn-info.disabled,.dark-green a.btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-green a.btn-info:not(:disabled):not(.disabled).active,.dark-green a.btn-info:not(:disabled):not(.disabled):active,.show>.dark-green a.btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.dark-green a.btn-info:not(:disabled):not(.disabled).active:focus,.dark-green a.btn-info:not(:disabled):not(.disabled):active:focus,.show>.dark-green a.btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-green a.btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-green a.btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.dark-green a.btn-warning.focus,.dark-green a.btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.dark-green a.btn-warning.disabled,.dark-green a.btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-green a.btn-warning:not(:disabled):not(.disabled).active,.dark-green a.btn-warning:not(:disabled):not(.disabled):active,.show>.dark-green a.btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.dark-green a.btn-warning:not(:disabled):not(.disabled).active:focus,.dark-green a.btn-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-green a.btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-green a.btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-green a.btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.dark-green a.btn-danger.focus,.dark-green a.btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.dark-green a.btn-danger.disabled,.dark-green a.btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.dark-green a.btn-danger:not(:disabled):not(.disabled).active,.dark-green a.btn-danger:not(:disabled):not(.disabled):active,.show>.dark-green a.btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.dark-green a.btn-danger:not(:disabled):not(.disabled).active:focus,.dark-green a.btn-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-green a.btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-green a.btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-green a.btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.dark-green a.btn-light.focus,.dark-green a.btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.dark-green a.btn-light.disabled,.dark-green a.btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-green a.btn-light:not(:disabled):not(.disabled).active,.dark-green a.btn-light:not(:disabled):not(.disabled):active,.show>.dark-green a.btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.dark-green a.btn-light:not(:disabled):not(.disabled).active:focus,.dark-green a.btn-light:not(:disabled):not(.disabled):active:focus,.show>.dark-green a.btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-green a.btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-green a.btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.dark-green a.btn-dark.focus,.dark-green a.btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.dark-green a.btn-dark.disabled,.dark-green a.btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.dark-green a.btn-dark:not(:disabled):not(.disabled).active,.dark-green a.btn-dark:not(:disabled):not(.disabled):active,.show>.dark-green a.btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.dark-green a.btn-dark:not(:disabled):not(.disabled).active:focus,.dark-green a.btn-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-green a.btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-green .btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.dark-green .btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-green .btn-outline-primary.focus,.dark-green .btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.dark-green .btn-outline-primary.disabled,.dark-green .btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.dark-green .btn-outline-primary:not(:disabled):not(.disabled).active,.dark-green .btn-outline-primary:not(:disabled):not(.disabled):active,.show>.dark-green .btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-green .btn-outline-primary:not(:disabled):not(.disabled).active:focus,.dark-green .btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-green .btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-green .btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.dark-green .btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-green .btn-outline-secondary.focus,.dark-green .btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.dark-green .btn-outline-secondary.disabled,.dark-green .btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.dark-green .btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-green .btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.dark-green .btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-green .btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.dark-green .btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-green .btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-green .btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.dark-green .btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-green .btn-outline-success.focus,.dark-green .btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.dark-green .btn-outline-success.disabled,.dark-green .btn-outline-success:disabled{color:#4caf50;background-color:transparent}.dark-green .btn-outline-success:not(:disabled):not(.disabled).active,.dark-green .btn-outline-success:not(:disabled):not(.disabled):active,.show>.dark-green .btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-green .btn-outline-success:not(:disabled):not(.disabled).active:focus,.dark-green .btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.dark-green .btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-green .btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.dark-green .btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-green .btn-outline-info.focus,.dark-green .btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.dark-green .btn-outline-info.disabled,.dark-green .btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.dark-green .btn-outline-info:not(:disabled):not(.disabled).active,.dark-green .btn-outline-info:not(:disabled):not(.disabled):active,.show>.dark-green .btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-green .btn-outline-info:not(:disabled):not(.disabled).active:focus,.dark-green .btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.dark-green .btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-green .btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.dark-green .btn-outline-warning:hover{color:#fff;background-color:#ff9800;border-color:#ff9800}.dark-green .btn-outline-warning.focus,.dark-green .btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.dark-green .btn-outline-warning.disabled,.dark-green .btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.dark-green .btn-outline-warning:not(:disabled):not(.disabled).active,.dark-green .btn-outline-warning:not(:disabled):not(.disabled):active,.show>.dark-green .btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-green .btn-outline-warning:not(:disabled):not(.disabled).active:focus,.dark-green .btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-green .btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-green .btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.dark-green .btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.dark-green .btn-outline-danger.focus,.dark-green .btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.dark-green .btn-outline-danger.disabled,.dark-green .btn-outline-danger:disabled{color:#f44336;background-color:transparent}.dark-green .btn-outline-danger:not(:disabled):not(.disabled).active,.dark-green .btn-outline-danger:not(:disabled):not(.disabled):active,.show>.dark-green .btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.dark-green .btn-outline-danger:not(:disabled):not(.disabled).active:focus,.dark-green .btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-green .btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-green .btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.dark-green .btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-green .btn-outline-light.focus,.dark-green .btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.dark-green .btn-outline-light.disabled,.dark-green .btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.dark-green .btn-outline-light:not(:disabled):not(.disabled).active,.dark-green .btn-outline-light:not(:disabled):not(.disabled):active,.show>.dark-green .btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-green .btn-outline-light:not(:disabled):not(.disabled).active:focus,.dark-green .btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.dark-green .btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-green .btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.dark-green .btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.dark-green .btn-outline-dark.focus,.dark-green .btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.dark-green .btn-outline-dark.disabled,.dark-green .btn-outline-dark:disabled{color:#343a40;background-color:transparent}.dark-green .btn-outline-dark:not(:disabled):not(.disabled).active,.dark-green .btn-outline-dark:not(:disabled):not(.disabled):active,.show>.dark-green .btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.dark-green .btn-outline-dark:not(:disabled):not(.disabled).active:focus,.dark-green .btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-green .btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-green a.btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.dark-green a.btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-green a.btn-outline-primary.focus,.dark-green a.btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.dark-green a.btn-outline-primary.disabled,.dark-green a.btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.dark-green a.btn-outline-primary:not(:disabled):not(.disabled).active,.dark-green a.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.dark-green a.btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-green a.btn-outline-primary:not(:disabled):not(.disabled).active:focus,.dark-green a.btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-green a.btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-green a.btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.dark-green a.btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-green a.btn-outline-secondary.focus,.dark-green a.btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.dark-green a.btn-outline-secondary.disabled,.dark-green a.btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.dark-green a.btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-green a.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.dark-green a.btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-green a.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.dark-green a.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-green a.btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-green a.btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.dark-green a.btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-green a.btn-outline-success.focus,.dark-green a.btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.dark-green a.btn-outline-success.disabled,.dark-green a.btn-outline-success:disabled{color:#4caf50;background-color:transparent}.dark-green a.btn-outline-success:not(:disabled):not(.disabled).active,.dark-green a.btn-outline-success:not(:disabled):not(.disabled):active,.show>.dark-green a.btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-green a.btn-outline-success:not(:disabled):not(.disabled).active:focus,.dark-green a.btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.dark-green a.btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-green a.btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.dark-green a.btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-green a.btn-outline-info.focus,.dark-green a.btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.dark-green a.btn-outline-info.disabled,.dark-green a.btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.dark-green a.btn-outline-info:not(:disabled):not(.disabled).active,.dark-green a.btn-outline-info:not(:disabled):not(.disabled):active,.show>.dark-green a.btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-green a.btn-outline-info:not(:disabled):not(.disabled).active:focus,.dark-green a.btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.dark-green a.btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-green a.btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.dark-green a.btn-outline-warning:hover{color:#fff;background-color:#ff9800;border-color:#ff9800}.dark-green a.btn-outline-warning.focus,.dark-green a.btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.dark-green a.btn-outline-warning.disabled,.dark-green a.btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.dark-green a.btn-outline-warning:not(:disabled):not(.disabled).active,.dark-green a.btn-outline-warning:not(:disabled):not(.disabled):active,.show>.dark-green a.btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-green a.btn-outline-warning:not(:disabled):not(.disabled).active:focus,.dark-green a.btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-green a.btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-green a.btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.dark-green a.btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.dark-green a.btn-outline-danger.focus,.dark-green a.btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.dark-green a.btn-outline-danger.disabled,.dark-green a.btn-outline-danger:disabled{color:#f44336;background-color:transparent}.dark-green a.btn-outline-danger:not(:disabled):not(.disabled).active,.dark-green a.btn-outline-danger:not(:disabled):not(.disabled):active,.show>.dark-green a.btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.dark-green a.btn-outline-danger:not(:disabled):not(.disabled).active:focus,.dark-green a.btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-green a.btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-green a.btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.dark-green a.btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-green a.btn-outline-light.focus,.dark-green a.btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.dark-green a.btn-outline-light.disabled,.dark-green a.btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.dark-green a.btn-outline-light:not(:disabled):not(.disabled).active,.dark-green a.btn-outline-light:not(:disabled):not(.disabled):active,.show>.dark-green a.btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-green a.btn-outline-light:not(:disabled):not(.disabled).active:focus,.dark-green a.btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.dark-green a.btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-green a.btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.dark-green a.btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.dark-green a.btn-outline-dark.focus,.dark-green a.btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.dark-green a.btn-outline-dark.disabled,.dark-green a.btn-outline-dark:disabled{color:#343a40;background-color:transparent}.dark-green a.btn-outline-dark:not(:disabled):not(.disabled).active,.dark-green a.btn-outline-dark:not(:disabled):not(.disabled):active,.show>.dark-green a.btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.dark-green a.btn-outline-dark:not(:disabled):not(.disabled).active:focus,.dark-green a.btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-green a.btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-green .btn-outline-primary,.dark-green a.btn-outline-primary{color:#4caf50;border-color:#4caf50}.dark-green .btn-outline-primary.disabled,.dark-green .btn-outline-primary:disabled,.dark-green .btn-outline-primary:focus,.dark-green .btn-outline-primary:hover,.dark-green .btn-outline-primary:not(:disabled):not(.disabled).active,.dark-green .btn-outline-primary:not(:disabled):not(.disabled):active,.dark-green a.btn-outline-primary.disabled,.dark-green a.btn-outline-primary:disabled,.dark-green a.btn-outline-primary:focus,.dark-green a.btn-outline-primary:hover,.dark-green a.btn-outline-primary:not(:disabled):not(.disabled).active,.dark-green a.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.dark-green .btn-outline-primary.dropdown-toggle,.show>.dark-green a.btn-outline-primary.dropdown-toggle{color:#fff;border-color:#4caf50;background-color:#4caf50}.dark-green .btn-outline-secondary,.dark-green a.btn-outline-secondary{color:#ff6d00;border-color:#ff6d00}.dark-green .btn-outline-secondary.disabled,.dark-green .btn-outline-secondary:disabled,.dark-green .btn-outline-secondary:focus,.dark-green .btn-outline-secondary:hover,.dark-green .btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-green .btn-outline-secondary:not(:disabled):not(.disabled):active,.dark-green a.btn-outline-secondary.disabled,.dark-green a.btn-outline-secondary:disabled,.dark-green a.btn-outline-secondary:focus,.dark-green a.btn-outline-secondary:hover,.dark-green a.btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-green a.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.dark-green .btn-outline-secondary.dropdown-toggle,.show>.dark-green a.btn-outline-secondary.dropdown-toggle{color:#fff;border-color:#ff6d00;background-color:#ff6d00}.dark-green a,.dark-green a.text-primary{color:#4caf50}.dark-green a.text-primary:focus,.dark-green a.text-primary:hover,.dark-green a:focus,.dark-green a:hover{color:#3d8b40}.dark-green .text-primary{color:#4caf50!important}.dark-green .page-link,.dark-green .page-link:focus,.dark-green .page-link:hover{color:#4caf50}.dark-green .badge-primary,.dark-green .bg-primary{background-color:#4caf50!important;color:#fff!important}.dark-green .btn-primary,.dark-green .jr-btn-primary,.dark-green a.btn-primary,.dark-green a.jr-btn-primary{background-color:#4caf50;border-color:#4caf50;color:#fff}.dark-green .btn-primary:focus,.dark-green .btn-primary:hover,.dark-green .btn-primary:not([disabled]):not(.disabled):active,.dark-green .jr-btn-primary:focus,.dark-green .jr-btn-primary:hover,.dark-green .jr-btn-primary:not([disabled]):not(.disabled):active,.dark-green a.btn-primary:focus,.dark-green a.btn-primary:hover,.dark-green a.btn-primary:not([disabled]):not(.disabled):active,.dark-green a.jr-btn-primary:focus,.dark-green a.jr-btn-primary:hover,.dark-green a.jr-btn-primary:not([disabled]):not(.disabled):active{background-color:#449d48!important;border-color:#449d48!important;color:#fff!important}.dark-green .bg-primary.lighten-4{background-color:#c8e6c9!important}.dark-green .bg-primary.lighten-3{background-color:#a5d6a7!important}.dark-green .bg-primary.lighten-2{background-color:#81c784!important}.dark-green .bg-primary.lighten-1{background-color:#66bb6a!important}.dark-green .bg-primary.darken-1{background-color:#43a047!important}.dark-green .bg-primary.darken-2{background-color:#388e3c!important}.dark-green .bg-primary.darken-3{background-color:#2e7d32!important}.dark-green .bg-primary.darken-4{background-color:#1b5e20!important}.dark-green .bg-primary.accent-1{background-color:#b9f6ca!important}.dark-green .bg-primary.accent-2{background-color:#69f0ae!important}.dark-green .bg-primary.accent-3{background-color:#00e676!important}.dark-green .bg-primary.accent-4{background-color:#00c853!important}.dark-green a.text-secondary{color:#ff6d00}.dark-green a.text-secondary:focus,.dark-green a.text-secondary:hover{color:#cc5700!important}.dark-green .text-secondary{color:#ff6d00!important}.dark-green .badge-secondary,.dark-green .bg-secondary{background-color:#ff6d00!important;color:#fff!important}.dark-green .btn-secondary{background-color:#ff6d00;border-color:#ff6d00;color:#fff}.dark-green .btn-secondary:active,.dark-green .btn-secondary:focus,.dark-green .btn-secondary:hover{background-color:#e66200!important;border-color:#e66200!important;color:#fff!important}.dark-green .jr-flat-btn{background-color:transparent!important;color:#5c5c5c!important}.dark-green .jr-flat-btn:active,.dark-green .jr-flat-btn:focus,.dark-green .jr-flat-btn:hover{background-color:#f5f5f5!important;color:#5c5c5c!important}.dark-green .jr-flat-btn.jr-btn-primary{background-color:transparent!important;color:#4caf50!important;border-color:transparent!important}.dark-green .jr-flat-btn.jr-btn-primary:focus,.dark-green .jr-flat-btn.jr-btn-primary:hover{background-color:rgba(76,175,80,.12)!important;color:#4caf50!important}.dark-green .bg-primary .jr-flat-btn.jr-btn-primary{background-color:transparent!important;color:#fff!important;border-color:transparent!important}.dark-green .bg-primary .jr-flat-btn.jr-btn-primary:focus,.dark-green .bg-primary .jr-flat-btn.jr-btn-primary:hover{background-color:hsla(0,0%,100%,.12)!important;color:#fff!important}.dark-green .jr-flat-btn.jr-btn-secondary{background-color:transparent!important;color:#ff6d00!important;border-color:transparent!important}.dark-green .jr-flat-btn.jr-btn-secondary:focus,.dark-green .jr-flat-btn.jr-btn-secondary:hover{background-color:rgba(255,109,0,.12)!important;color:#ff6d00!important}.dark-green .bg-secondary .jr-flat-btn.jr-btn-secondary{background-color:transparent!important;color:#fff!important;border-color:transparent!important}.dark-green .bg-secondary .jr-flat-btn.jr-btn-secondary:focus,.dark-green .bg-secondary .jr-flat-btn.jr-btn-secondary:hover{background-color:hsla(0,0%,100%,.12)!important;color:#fff!important}.dark-green .app-main-header{background-color:#4caf50!important;color:#fff;border-color:#4caf50}.dark-green .app-main-header .search-bar input{background-color:#5cb860}.dark-green .app-main-header .search-bar input+.search-icon i{color:#fff}.dark-green .app-main-header .search-bar input:focus{background-color:#fff}.dark-green .app-main-header .search-bar input:focus+.search-icon i{color:hsla(0,0%,50%,.8)}@media screen and (max-width:575px){.dark-green .app-main-header .search-dropdown input{background-color:#fff}.dark-green .app-main-header .search-dropdown input+.search-icon i{color:hsla(0,0%,50%,.8)}}.dark-green .app-main-header .jr-menu-icon .menu-icon{background-color:#fff!important}.dark-green .app-header .jr-menu-icon .menu-icon{background-color:#fff}.dark-green .quick-menu .icon-btn{color:#fff}.dark-green .react-logo-white.d-block{display:block!important}@media screen and (min-width:992px){.dark-green .react-logo-white.d-lg-block{display:block!important}.dark-green .react-logo-white.d-lg-none{display:none!important}}.dark-green .react-logo-color.d-block{display:none!important}@media screen and (min-width:992px){.dark-green .react-logo-color.d-lg-block{display:none!important}}.dark-green .color-theme-header{background-color:#4caf50}.dark-green .sidebar-header{border-bottom:0 none;background-color:#1d1d1d}.dark-green .side-nav{background-color:#252525!important;color:#a1a1a1!important;border-right:0 none!important}.dark-green .side-nav .user-profile{background-color:#1d1d1d;position:relative;z-index:2}.dark-green .side-nav .customizer{border-bottom:0 none}.dark-green .side-nav .user-detail .user-name{color:#fff}.dark-green ul.nav-menu .nav-header,.dark-green ul.nav-menu li a{color:#a1a1a1}.dark-green ul.nav-menu>li.open>a,.dark-green ul.nav-menu>li>a:focus,.dark-green ul.nav-menu>li>a:hover{background-color:#1d1d1d;color:#fff}.dark-green ul.nav-menu li.menu.open>a{border-color:#4caf50}.dark-green ul.nav-menu li.menu>a:focus:before,.dark-green ul.nav-menu li.menu>a:hover:before{color:#fff}.dark-green ul.nav-menu li ul{background-color:#1d1d1d}.dark-green ul.nav-menu li.menu>a:before{color:#a1a1a1}.dark-green ul.nav-menu li.menu.open>a:before,.dark-green ul.nav-menu li.menu>a:focus:before,.dark-green ul.nav-menu li.menu li>a:hover:before{color:#fff}.dark-green ul.nav-menu li.menu .sub-menu li>a:before{color:#a1a1a1}.dark-green ul.nav-menu li.menu .sub-menu li>a.active .nav-text{background-color:#4caf50}.dark-green ul.nav-menu li.menu.open .sub-menu li>a.active:before,.dark-green ul.nav-menu li.menu .sub-menu li>a:focus,.dark-green ul.nav-menu li.menu .sub-menu li>a:focus:before,.dark-green ul.nav-menu li.menu .sub-menu li>a:hover,.dark-green ul.nav-menu li.menu .sub-menu li>a:hover:before{background-color:#1d1d1d;color:#fff}.dark-green .navbar-nav li:focus>a,.dark-green .navbar-nav li:hover>a{color:#4caf50}.dark-green .navbar-nav li a{color:#868e96}.dark-green .navbar-nav li a:focus,.dark-green .navbar-nav li a:hover{color:#4caf50}.dark-green .navbar-nav li.nav-item>a{color:#fff}.dark-green .navbar-nav li.nav-item.active>a,.dark-green .navbar-nav li.nav-item:focus>a,.dark-green .navbar-nav li.nav-item:hover>a,.dark-green .navbar-nav li.nav-item>a:focus,.dark-green .navbar-nav li.nav-item>a:hover{color:#ff6d00}.dark-green .navbar-nav ul.sub-menu li.active>a,.dark-green .navbar-nav ul.sub-menu li a.active{color:#4caf50}.dark-green .navbar-nav .nav-arrow>a:before{color:#868e96}.dark-green .navbar-nav .nav-arrow.active>a:before,.dark-green .navbar-nav .nav-arrow:focus>a:before,.dark-green .navbar-nav .nav-arrow:hover>a:before,.dark-green .navbar-nav .nav-arrow a:focus:before,.dark-green .navbar-nav .nav-arrow a:hover:before{color:#4caf50}.dark-green .app-top-nav{background-color:#252525!important;border-color:#252525}.dark-green .app-top-nav .navbar-nav li.nav-item>a{color:#fff}.dark-green .app-top-nav .navbar-nav li.nav-item.active>a,.dark-green .app-top-nav .navbar-nav li.nav-item:focus>a,.dark-green .app-top-nav .navbar-nav li.nav-item:hover>a,.dark-green .app-top-nav .navbar-nav li.nav-item>a:focus,.dark-green .app-top-nav .navbar-nav li.nav-item>a:hover{color:#ff6d00}.dark-green .module-nav li a.active{border-color:#4caf50}.dark-green .rbc-event{background-color:#4caf50}.dark-green .rbc-event.rbc-selected{background-color:#3d8b40}.dark-green .rbc-slot-selection{background-color:rgba(76,175,80,.7)}.dark-green .rbc-toolbar button.rbc-active,.dark-green .rbc-toolbar button.rbc-active:focus,.dark-green .rbc-toolbar button.rbc-active:hover,.dark-green .rbc-toolbar button:active,.dark-green .rbc-toolbar button:active:focus,.dark-green .rbc-toolbar button:active:hover,.dark-green .rbc-toolbar button:focus,.dark-green .rbc-toolbar button:hover{background-color:rgba(76,175,80,.9);border-color:#4caf50}.dark-green .rbc-day-slot .rbc-event{border-color:#4caf50}.dark-green .chat-sidenav-title{color:#4caf50}.dark-green .chat-user-item.active,.dark-green .chat-user-item:hover{background-color:#eaf6eb}.dark-green .contact-list i{color:#4caf50}.dark-green .Collapsible__trigger{background:#4caf50}.dark-green .categories-list li.active a,.dark-green .categories-list li a:focus,.dark-green .categories-list li a:hover{color:#4caf50}.dark-green .filter-with-bg-color ul li a,.dark-green .login-content .form-control:focus{border-color:#4caf50}.dark-green .filter-with-bg-color ul li a.active,.dark-green .filter-with-bg-color ul li a:focus,.dark-green .filter-with-bg-color ul li a:hover{background-color:#4caf50}.dark-green .profile-intro .icon{color:#4caf50}.dark-green .actions,.dark-green .social-link li.active a,.dark-green .social-link li a:focus,.dark-green .social-link li a:hover{color:#ff6d00}.dark-green .table-hover tbody tr:hover{background-color:rgba(76,175,80,.075)}.dark-green .border-primary{border-color:#4caf50!important}.dark-green .app-logo-content{background-color:#4caf50}.dark-green .app-social-block .social-link button{border:1px solid #4caf50;color:#4caf50}.dark-green .app-social-block .social-link button:focus,.dark-green .app-social-block .social-link button:hover{color:#fff;background-color:#4caf50}.dark-green .btn-group-vertical>.btn-default.active,.dark-green .btn-group-vertical>.jr-btn.active,.dark-green .btn-group>.btn-default.active,.dark-green .btn-group>.jr-btn.active{background-color:#4caf50;border-color:#4caf50}.dark-green .btn-group-vertical>.jr-flat-btn,.dark-green .btn-group>.jr-flat-btn{border-color:transparent}.dark-green .btn-group-vertical>.jr-flat-btn.active,.dark-green .btn-group>.jr-flat-btn.active{background-color:transparent;color:#4caf50!important;border-color:transparent!important}.dark-green .btn-group-vertical>.jr-flat-btn.active:focus,.dark-green .btn-group-vertical>.jr-flat-btn.active:hover,.dark-green .btn-group>.jr-flat-btn.active:focus,.dark-green .btn-group>.jr-flat-btn.active:hover{background-color:rgba(76,175,80,.12)!important;color:#4caf50!important}.dark-green .nav-pill-sales .nav-link.active{background-color:#4caf50;border-color:#4caf50}.dark-green .form-checkbox>input+.check,.dark-green .form-checkbox>input.sm+.check{color:#4caf50}.dark-green .app-main-header ::-webkit-input-placeholder{color:#ebebeb}.dark-green .app-main-header ::-moz-placeholder{color:#ebebeb}.dark-green .app-main-header :-ms-input-placeholder{color:#ebebeb}.dark-green .app-main-header :-moz-placeholder{color:#ebebeb}.dark-green .app-main-header input:focus::-webkit-input-placeholder{color:#dcdcdc}.dark-green .app-main-header input:focus::-moz-placeholder{color:#dcdcdc}.dark-green .app-main-header input:focus:-ms-input-placeholder{color:#dcdcdc}.dark-green .app-main-header input:focus:-moz-placeholder{color:#dcdcdc}body.dark-theme{color:#e0e0e0;background-color:#38424b}.dark-theme .modal{color:#38424b}.dark-theme .project-list .project-name{color:#e0e0e0}.dark-theme .list-group-item{background-color:#434f5a;color:#e0e0e0;border-color:#495762}.dark-theme .list-group-item:hover{background-color:#414c57}.dark-theme .modal .list-group-item{background-color:#fff;color:#38424b;border-color:#fff}.dark-theme .modal .list-group-item:hover{background-color:#fff}.dark-theme .quick-menu .icon-btn{color:#e0e0e0}.dark-theme .text-dark{color:#e0e0e0!important}.dark-theme .nav-pill-sales .nav-link{background-color:#495762;color:#e0e0e0;border-color:#495762}.dark-theme .nav-pill-sales .nav-link.active{background-color:#38424b;color:#e0e0e0;border-color:#38424b}.dark-theme .nav-pill-sales .nav-link.active:focus,.dark-theme .nav-pill-sales .nav-link.active:hover{color:#e0e0e0}.dark-theme .nav-tabs{border-color:#38424b;background-color:#22282e}.dark-theme .nav-tabs .nav-link,.dark-theme .nav-tabs .nav-link:focus,.dark-theme .nav-tabs .nav-link:hover{border-color:transparent}.dark-theme .nav-tabs .nav-item.show .nav-link,.dark-theme .nav-tabs .nav-link.active{color:#e0e0e0;background-color:#22282e;border-color:#22282e;border-bottom-color:#495762}.dark-theme .bg-grey.lighten-4,.dark-theme .jr-card-header-color{background-color:#495762!important;color:#e0e0e0}.dark-theme .card,.dark-theme .jr-card{background-color:#434f5a;border-color:#495762}.dark-theme .card-footer{border-color:#495762;background-color:transparent!important}.dark-theme .meta-comment,.dark-theme .meta-date,.dark-theme .sub-heading,.dark-theme .text-muted,.dark-theme .user-detail .user-description{color:#adadad!important}.dark-theme .right-arrow,.dark-theme .right-arrow:after{color:#d3d3d3}.dark-theme .btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-theme .btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.dark-theme .btn-primary.focus,.dark-theme .btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.dark-theme .btn-primary.disabled,.dark-theme .btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-theme .btn-primary:not(:disabled):not(.disabled).active,.dark-theme .btn-primary:not(:disabled):not(.disabled):active,.show>.dark-theme .btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.dark-theme .btn-primary:not(:disabled):not(.disabled).active:focus,.dark-theme .btn-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-theme .btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-theme .btn-secondary{color:#fff;background-color:#e91e63;border-color:#e91e63;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-theme .btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.dark-theme .btn-secondary.focus,.dark-theme .btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.dark-theme .btn-secondary.disabled,.dark-theme .btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-theme .btn-secondary:not(:disabled):not(.disabled).active,.dark-theme .btn-secondary:not(:disabled):not(.disabled):active,.show>.dark-theme .btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.dark-theme .btn-secondary:not(:disabled):not(.disabled).active:focus,.dark-theme .btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-theme .btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-theme .btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-theme .btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.dark-theme .btn-success.focus,.dark-theme .btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.dark-theme .btn-success.disabled,.dark-theme .btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-theme .btn-success:not(:disabled):not(.disabled).active,.dark-theme .btn-success:not(:disabled):not(.disabled):active,.show>.dark-theme .btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.dark-theme .btn-success:not(:disabled):not(.disabled).active:focus,.dark-theme .btn-success:not(:disabled):not(.disabled):active:focus,.show>.dark-theme .btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-theme .btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-theme .btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.dark-theme .btn-info.focus,.dark-theme .btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.dark-theme .btn-info.disabled,.dark-theme .btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-theme .btn-info:not(:disabled):not(.disabled).active,.dark-theme .btn-info:not(:disabled):not(.disabled):active,.show>.dark-theme .btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.dark-theme .btn-info:not(:disabled):not(.disabled).active:focus,.dark-theme .btn-info:not(:disabled):not(.disabled):active:focus,.show>.dark-theme .btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-theme .btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-theme .btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.dark-theme .btn-warning.focus,.dark-theme .btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.dark-theme .btn-warning.disabled,.dark-theme .btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-theme .btn-warning:not(:disabled):not(.disabled).active,.dark-theme .btn-warning:not(:disabled):not(.disabled):active,.show>.dark-theme .btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.dark-theme .btn-warning:not(:disabled):not(.disabled).active:focus,.dark-theme .btn-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-theme .btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-theme .btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-theme .btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.dark-theme .btn-danger.focus,.dark-theme .btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.dark-theme .btn-danger.disabled,.dark-theme .btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.dark-theme .btn-danger:not(:disabled):not(.disabled).active,.dark-theme .btn-danger:not(:disabled):not(.disabled):active,.show>.dark-theme .btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.dark-theme .btn-danger:not(:disabled):not(.disabled).active:focus,.dark-theme .btn-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-theme .btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-theme .btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-theme .btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.dark-theme .btn-light.focus,.dark-theme .btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.dark-theme .btn-light.disabled,.dark-theme .btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-theme .btn-light:not(:disabled):not(.disabled).active,.dark-theme .btn-light:not(:disabled):not(.disabled):active,.show>.dark-theme .btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.dark-theme .btn-light:not(:disabled):not(.disabled).active:focus,.dark-theme .btn-light:not(:disabled):not(.disabled):active:focus,.show>.dark-theme .btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-theme .btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-theme .btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.dark-theme .btn-dark.focus,.dark-theme .btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.dark-theme .btn-dark.disabled,.dark-theme .btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.dark-theme .btn-dark:not(:disabled):not(.disabled).active,.dark-theme .btn-dark:not(:disabled):not(.disabled):active,.show>.dark-theme .btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.dark-theme .btn-dark:not(:disabled):not(.disabled).active:focus,.dark-theme .btn-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-theme .btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-theme a.btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-theme a.btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.dark-theme a.btn-primary.focus,.dark-theme a.btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.dark-theme a.btn-primary.disabled,.dark-theme a.btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-theme a.btn-primary:not(:disabled):not(.disabled).active,.dark-theme a.btn-primary:not(:disabled):not(.disabled):active,.show>.dark-theme a.btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.dark-theme a.btn-primary:not(:disabled):not(.disabled).active:focus,.dark-theme a.btn-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-theme a.btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-theme a.btn-secondary{color:#fff;background-color:#e91e63;border-color:#e91e63;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-theme a.btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.dark-theme a.btn-secondary.focus,.dark-theme a.btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.dark-theme a.btn-secondary.disabled,.dark-theme a.btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-theme a.btn-secondary:not(:disabled):not(.disabled).active,.dark-theme a.btn-secondary:not(:disabled):not(.disabled):active,.show>.dark-theme a.btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.dark-theme a.btn-secondary:not(:disabled):not(.disabled).active:focus,.dark-theme a.btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-theme a.btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-theme a.btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-theme a.btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.dark-theme a.btn-success.focus,.dark-theme a.btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.dark-theme a.btn-success.disabled,.dark-theme a.btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-theme a.btn-success:not(:disabled):not(.disabled).active,.dark-theme a.btn-success:not(:disabled):not(.disabled):active,.show>.dark-theme a.btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.dark-theme a.btn-success:not(:disabled):not(.disabled).active:focus,.dark-theme a.btn-success:not(:disabled):not(.disabled):active:focus,.show>.dark-theme a.btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-theme a.btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-theme a.btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.dark-theme a.btn-info.focus,.dark-theme a.btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.dark-theme a.btn-info.disabled,.dark-theme a.btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-theme a.btn-info:not(:disabled):not(.disabled).active,.dark-theme a.btn-info:not(:disabled):not(.disabled):active,.show>.dark-theme a.btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.dark-theme a.btn-info:not(:disabled):not(.disabled).active:focus,.dark-theme a.btn-info:not(:disabled):not(.disabled):active:focus,.show>.dark-theme a.btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-theme a.btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-theme a.btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.dark-theme a.btn-warning.focus,.dark-theme a.btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.dark-theme a.btn-warning.disabled,.dark-theme a.btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-theme a.btn-warning:not(:disabled):not(.disabled).active,.dark-theme a.btn-warning:not(:disabled):not(.disabled):active,.show>.dark-theme a.btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.dark-theme a.btn-warning:not(:disabled):not(.disabled).active:focus,.dark-theme a.btn-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-theme a.btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-theme a.btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-theme a.btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.dark-theme a.btn-danger.focus,.dark-theme a.btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.dark-theme a.btn-danger.disabled,.dark-theme a.btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.dark-theme a.btn-danger:not(:disabled):not(.disabled).active,.dark-theme a.btn-danger:not(:disabled):not(.disabled):active,.show>.dark-theme a.btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.dark-theme a.btn-danger:not(:disabled):not(.disabled).active:focus,.dark-theme a.btn-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-theme a.btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-theme a.btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-theme a.btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.dark-theme a.btn-light.focus,.dark-theme a.btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.dark-theme a.btn-light.disabled,.dark-theme a.btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-theme a.btn-light:not(:disabled):not(.disabled).active,.dark-theme a.btn-light:not(:disabled):not(.disabled):active,.show>.dark-theme a.btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.dark-theme a.btn-light:not(:disabled):not(.disabled).active:focus,.dark-theme a.btn-light:not(:disabled):not(.disabled):active:focus,.show>.dark-theme a.btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-theme a.btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);-o-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.dark-theme a.btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.dark-theme a.btn-dark.focus,.dark-theme a.btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.dark-theme a.btn-dark.disabled,.dark-theme a.btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.dark-theme a.btn-dark:not(:disabled):not(.disabled).active,.dark-theme a.btn-dark:not(:disabled):not(.disabled):active,.show>.dark-theme a.btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.dark-theme a.btn-dark:not(:disabled):not(.disabled).active:focus,.dark-theme a.btn-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-theme a.btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-theme .btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.dark-theme .btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-theme .btn-outline-primary.focus,.dark-theme .btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.dark-theme .btn-outline-primary.disabled,.dark-theme .btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.dark-theme .btn-outline-primary:not(:disabled):not(.disabled).active,.dark-theme .btn-outline-primary:not(:disabled):not(.disabled):active,.show>.dark-theme .btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-theme .btn-outline-primary:not(:disabled):not(.disabled).active:focus,.dark-theme .btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-theme .btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-theme .btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.dark-theme .btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-theme .btn-outline-secondary.focus,.dark-theme .btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.dark-theme .btn-outline-secondary.disabled,.dark-theme .btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.dark-theme .btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-theme .btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.dark-theme .btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-theme .btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.dark-theme .btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-theme .btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-theme .btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.dark-theme .btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-theme .btn-outline-success.focus,.dark-theme .btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.dark-theme .btn-outline-success.disabled,.dark-theme .btn-outline-success:disabled{color:#4caf50;background-color:transparent}.dark-theme .btn-outline-success:not(:disabled):not(.disabled).active,.dark-theme .btn-outline-success:not(:disabled):not(.disabled):active,.show>.dark-theme .btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-theme .btn-outline-success:not(:disabled):not(.disabled).active:focus,.dark-theme .btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.dark-theme .btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-theme .btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.dark-theme .btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-theme .btn-outline-info.focus,.dark-theme .btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.dark-theme .btn-outline-info.disabled,.dark-theme .btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.dark-theme .btn-outline-info:not(:disabled):not(.disabled).active,.dark-theme .btn-outline-info:not(:disabled):not(.disabled):active,.show>.dark-theme .btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-theme .btn-outline-info:not(:disabled):not(.disabled).active:focus,.dark-theme .btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.dark-theme .btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-theme .btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.dark-theme .btn-outline-warning:hover{color:#fff;background-color:#ff9800;border-color:#ff9800}.dark-theme .btn-outline-warning.focus,.dark-theme .btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.dark-theme .btn-outline-warning.disabled,.dark-theme .btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.dark-theme .btn-outline-warning:not(:disabled):not(.disabled).active,.dark-theme .btn-outline-warning:not(:disabled):not(.disabled):active,.show>.dark-theme .btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-theme .btn-outline-warning:not(:disabled):not(.disabled).active:focus,.dark-theme .btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-theme .btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-theme .btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.dark-theme .btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.dark-theme .btn-outline-danger.focus,.dark-theme .btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.dark-theme .btn-outline-danger.disabled,.dark-theme .btn-outline-danger:disabled{color:#f44336;background-color:transparent}.dark-theme .btn-outline-danger:not(:disabled):not(.disabled).active,.dark-theme .btn-outline-danger:not(:disabled):not(.disabled):active,.show>.dark-theme .btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.dark-theme .btn-outline-danger:not(:disabled):not(.disabled).active:focus,.dark-theme .btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-theme .btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-theme .btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.dark-theme .btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-theme .btn-outline-light.focus,.dark-theme .btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.dark-theme .btn-outline-light.disabled,.dark-theme .btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.dark-theme .btn-outline-light:not(:disabled):not(.disabled).active,.dark-theme .btn-outline-light:not(:disabled):not(.disabled):active,.show>.dark-theme .btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-theme .btn-outline-light:not(:disabled):not(.disabled).active:focus,.dark-theme .btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.dark-theme .btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-theme .btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.dark-theme .btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.dark-theme .btn-outline-dark.focus,.dark-theme .btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.dark-theme .btn-outline-dark.disabled,.dark-theme .btn-outline-dark:disabled{color:#343a40;background-color:transparent}.dark-theme .btn-outline-dark:not(:disabled):not(.disabled).active,.dark-theme .btn-outline-dark:not(:disabled):not(.disabled):active,.show>.dark-theme .btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.dark-theme .btn-outline-dark:not(:disabled):not(.disabled).active:focus,.dark-theme .btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-theme .btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-theme a.btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.dark-theme a.btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-theme a.btn-outline-primary.focus,.dark-theme a.btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.dark-theme a.btn-outline-primary.disabled,.dark-theme a.btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.dark-theme a.btn-outline-primary:not(:disabled):not(.disabled).active,.dark-theme a.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.dark-theme a.btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.dark-theme a.btn-outline-primary:not(:disabled):not(.disabled).active:focus,.dark-theme a.btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.dark-theme a.btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.dark-theme a.btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.dark-theme a.btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-theme a.btn-outline-secondary.focus,.dark-theme a.btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.dark-theme a.btn-outline-secondary.disabled,.dark-theme a.btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.dark-theme a.btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-theme a.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.dark-theme a.btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.dark-theme a.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.dark-theme a.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.dark-theme a.btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.dark-theme a.btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.dark-theme a.btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-theme a.btn-outline-success.focus,.dark-theme a.btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.dark-theme a.btn-outline-success.disabled,.dark-theme a.btn-outline-success:disabled{color:#4caf50;background-color:transparent}.dark-theme a.btn-outline-success:not(:disabled):not(.disabled).active,.dark-theme a.btn-outline-success:not(:disabled):not(.disabled):active,.show>.dark-theme a.btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.dark-theme a.btn-outline-success:not(:disabled):not(.disabled).active:focus,.dark-theme a.btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.dark-theme a.btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.dark-theme a.btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.dark-theme a.btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-theme a.btn-outline-info.focus,.dark-theme a.btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.dark-theme a.btn-outline-info.disabled,.dark-theme a.btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.dark-theme a.btn-outline-info:not(:disabled):not(.disabled).active,.dark-theme a.btn-outline-info:not(:disabled):not(.disabled):active,.show>.dark-theme a.btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.dark-theme a.btn-outline-info:not(:disabled):not(.disabled).active:focus,.dark-theme a.btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.dark-theme a.btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.dark-theme a.btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.dark-theme a.btn-outline-warning:hover{color:#fff;background-color:#ff9800;border-color:#ff9800}.dark-theme a.btn-outline-warning.focus,.dark-theme a.btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.dark-theme a.btn-outline-warning.disabled,.dark-theme a.btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.dark-theme a.btn-outline-warning:not(:disabled):not(.disabled).active,.dark-theme a.btn-outline-warning:not(:disabled):not(.disabled):active,.show>.dark-theme a.btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.dark-theme a.btn-outline-warning:not(:disabled):not(.disabled).active:focus,.dark-theme a.btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.dark-theme a.btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.dark-theme a.btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.dark-theme a.btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.dark-theme a.btn-outline-danger.focus,.dark-theme a.btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.dark-theme a.btn-outline-danger.disabled,.dark-theme a.btn-outline-danger:disabled{color:#f44336;background-color:transparent}.dark-theme a.btn-outline-danger:not(:disabled):not(.disabled).active,.dark-theme a.btn-outline-danger:not(:disabled):not(.disabled):active,.show>.dark-theme a.btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.dark-theme a.btn-outline-danger:not(:disabled):not(.disabled).active:focus,.dark-theme a.btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.dark-theme a.btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.dark-theme a.btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.dark-theme a.btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-theme a.btn-outline-light.focus,.dark-theme a.btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.dark-theme a.btn-outline-light.disabled,.dark-theme a.btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.dark-theme a.btn-outline-light:not(:disabled):not(.disabled).active,.dark-theme a.btn-outline-light:not(:disabled):not(.disabled):active,.show>.dark-theme a.btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.dark-theme a.btn-outline-light:not(:disabled):not(.disabled).active:focus,.dark-theme a.btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.dark-theme a.btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.dark-theme a.btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.dark-theme a.btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.dark-theme a.btn-outline-dark.focus,.dark-theme a.btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.dark-theme a.btn-outline-dark.disabled,.dark-theme a.btn-outline-dark:disabled{color:#343a40;background-color:transparent}.dark-theme a.btn-outline-dark:not(:disabled):not(.disabled).active,.dark-theme a.btn-outline-dark:not(:disabled):not(.disabled):active,.show>.dark-theme a.btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.dark-theme a.btn-outline-dark:not(:disabled):not(.disabled).active:focus,.dark-theme a.btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.dark-theme a.btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.dark-theme .btn-outline-primary,.dark-theme a.btn-outline-primary{color:#2d353c;border-color:#2d353c}.dark-theme .btn-outline-primary.disabled,.dark-theme .btn-outline-primary:disabled,.dark-theme .btn-outline-primary:focus,.dark-theme .btn-outline-primary:hover,.dark-theme .btn-outline-primary:not(:disabled):not(.disabled).active,.dark-theme .btn-outline-primary:not(:disabled):not(.disabled):active,.dark-theme a.btn-outline-primary.disabled,.dark-theme a.btn-outline-primary:disabled,.dark-theme a.btn-outline-primary:focus,.dark-theme a.btn-outline-primary:hover,.dark-theme a.btn-outline-primary:not(:disabled):not(.disabled).active,.dark-theme a.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.dark-theme .btn-outline-primary.dropdown-toggle,.show>.dark-theme a.btn-outline-primary.dropdown-toggle{color:#fff;border-color:#2d353c;background-color:#2d353c}.dark-theme .btn-outline-secondary,.dark-theme a.btn-outline-secondary{color:#4e5c68;border-color:#4e5c68}.dark-theme .btn-outline-secondary.disabled,.dark-theme .btn-outline-secondary:disabled,.dark-theme .btn-outline-secondary:focus,.dark-theme .btn-outline-secondary:hover,.dark-theme .btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-theme .btn-outline-secondary:not(:disabled):not(.disabled):active,.dark-theme a.btn-outline-secondary.disabled,.dark-theme a.btn-outline-secondary:disabled,.dark-theme a.btn-outline-secondary:focus,.dark-theme a.btn-outline-secondary:hover,.dark-theme a.btn-outline-secondary:not(:disabled):not(.disabled).active,.dark-theme a.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.dark-theme .btn-outline-secondary.dropdown-toggle,.show>.dark-theme a.btn-outline-secondary.dropdown-toggle{color:#fff;border-color:#4e5c68;background-color:#4e5c68}.dark-theme a,.dark-theme a.text-primary{color:#d3d3d3}.dark-theme a.text-primary:focus,.dark-theme a.text-primary:hover,.dark-theme a:focus,.dark-theme a:hover{color:#c7c7c7!important}.dark-theme a.badge-light{color:#616161}.dark-theme a.badge-light:focus,.dark-theme a.badge-light:hover{color:#474747!important}.dark-theme .text-primary{color:#d3d3d3!important}.dark-theme .page-link{color:#596977}.dark-theme .page-link:focus,.dark-theme .page-link:hover{color:#4e5c68}.dark-theme .badge-primary,.dark-theme .bg-primary{background-color:#2d353c!important;color:#e0e0e0!important}.dark-theme .btn-primary,.dark-theme .jr-btn-primary,.dark-theme a.btn-primary,.dark-theme a.jr-btn-primary{border-color:#38424b;background-color:#2d353c!important;color:#e0e0e0!important;-webkit-box-shadow:none;-moz-box-shadow:none;-o-box-shadow:none;box-shadow:none}.dark-theme .btn-primary.disabled,.dark-theme .btn-primary:active,.dark-theme .btn-primary:disabled,.dark-theme .btn-primary:focus,.dark-theme .btn-primary:hover,.dark-theme .jr-btn-primary.disabled,.dark-theme .jr-btn-primary:active,.dark-theme .jr-btn-primary:disabled,.dark-theme .jr-btn-primary:focus,.dark-theme .jr-btn-primary:hover,.dark-theme a.btn-primary.disabled,.dark-theme a.btn-primary:active,.dark-theme a.btn-primary:disabled,.dark-theme a.btn-primary:focus,.dark-theme a.btn-primary:hover,.dark-theme a.jr-btn-primary.disabled,.dark-theme a.jr-btn-primary:active,.dark-theme a.jr-btn-primary:disabled,.dark-theme a.jr-btn-primary:focus,.dark-theme a.jr-btn-primary:hover{background-color:#2d353c!important;border-color:#2d353c!important;color:#d3d3d3!important}.dark-theme .btn-outline-primary{color:#d3d3d3;border-color:#d3d3d3}.dark-theme .btn-outline-primary:active,.dark-theme .btn-outline-primary:focus,.dark-theme .btn-outline-primary:hover{background-color:#2d353c;border-color:#2d353c;color:#d3d3d3}.dark-theme .jr-flat-btn{color:#d3d3d3}.dark-theme .jr-flat-btn:active,.dark-theme .jr-flat-btn:focus,.dark-theme .jr-flat-btn:hover{background-color:#f5f5f5;color:#5c5c5c}.dark-theme .jr-flat-btn.jr-btn-secondary{color:#e91e63}.dark-theme .jr-flat-btn.jr-btn-secondary:focus,.dark-theme .jr-flat-btn.jr-btn-secondary:hover{background-color:rgba(233,30,99,.12);color:#e91e63}.dark-theme .jr-flat-btn.jr-btn-primary{color:#d3d3d3}.dark-theme .jr-flat-btn.jr-btn-primary:focus,.dark-theme .jr-flat-btn.jr-btn-primary:hover{background-color:hsla(0,0%,83%,.12);color:#d3d3d3}.dark-theme .btn-group-vertical>.btn-default.active,.dark-theme .btn-group-vertical>.jr-btn.active,.dark-theme .btn-group>.btn-default.active,.dark-theme .btn-group>.jr-btn.active{background-color:#38424b;border-color:#38424b;color:#d3d3d3}.dark-theme .btn-group-vertical>.jr-flat-btn,.dark-theme .btn-group>.jr-flat-btn{border-color:transparent}.dark-theme .btn-group-vertical>.jr-flat-btn.active,.dark-theme .btn-group>.jr-flat-btn.active{background-color:transparent;color:#0c0f11}.dark-theme .btn-group-vertical>.jr-flat-btn.active:focus,.dark-theme .btn-group-vertical>.jr-flat-btn.active:hover,.dark-theme .btn-group>.jr-flat-btn.active:focus,.dark-theme .btn-group>.jr-flat-btn.active:hover{background-color:rgba(56,66,75,.5);color:#0c0f11}.dark-theme a.text-secondary{color:#4e5c68}.dark-theme a.text-secondary:focus,.dark-theme a.text-secondary:hover{color:#38424b!important}.dark-theme .text-secondary{color:#4e5c68!important}.dark-theme .bg-secondary{background-color:#4e5c68!important;color:#d3d3d3!important}.dark-theme .badge-secondary{background-color:#38424b!important;color:#d3d3d3!important}.dark-theme .btn-secondary{background-color:#4e5c68;border-color:#4e5c68;color:#d3d3d3}.dark-theme .btn-secondary:active,.dark-theme .btn-secondary:focus,.dark-theme .btn-secondary:hover{background-color:#38424b!important;border-color:#38424b!important;color:#d3d3d3!important}.dark-theme .jr-flat-btn{background-color:transparent!important;color:#d3d3d3!important}.dark-theme .jr-flat-btn:active,.dark-theme .jr-flat-btn:focus,.dark-theme .jr-flat-btn:hover{background-color:#f5f5f5!important;color:#5c5c5c!important}.dark-theme .jr-flat-btn.jr-btn-primary{background-color:transparent!important;color:#d3d3d3!important;border-color:transparent!important}.dark-theme .jr-flat-btn.jr-btn-primary:focus,.dark-theme .jr-flat-btn.jr-btn-primary:hover{background-color:rgba(56,66,75,.5)!important;color:#d3d3d3!important}.dark-theme .bg-primary .jr-flat-btn.jr-btn-primary{background-color:transparent!important;color:#fff!important;border-color:transparent!important}.dark-theme .bg-primary .jr-flat-btn.jr-btn-primary:focus,.dark-theme .bg-primary .jr-flat-btn.jr-btn-primary:hover{background-color:hsla(0,0%,100%,.12)!important;color:#fff!important}.dark-theme .jr-flat-btn.jr-btn-secondary{background-color:transparent!important;color:#e0e0e0!important;border-color:transparent!important}.dark-theme .jr-flat-btn.jr-btn-secondary:focus,.dark-theme .jr-flat-btn.jr-btn-secondary:hover{background-color:rgba(78,92,104,.5)!important;color:#e0e0e0!important}.dark-theme .bg-secondary .jr-flat-btn.jr-btn-secondary{background-color:transparent!important;color:#fff!important;border-color:transparent!important}.dark-theme .bg-secondary .jr-flat-btn.jr-btn-secondary:focus,.dark-theme .bg-secondary .jr-flat-btn.jr-btn-secondary:hover{background-color:hsla(0,0%,100%,.12)!important;color:#fff!important}.dark-theme .app-main-header{background-color:#2d353c!important}.dark-theme .app-main-header .search-bar input{background-color:#434f5a}.dark-theme .app-main-header .search-bar input:focus{background-color:#fff}@media screen and (max-width:575px){.dark-theme .app-main-header .search-dropdown input{background-color:#fff}}.dark-theme .card-header,.dark-theme .col-with-divider div[class*=col-],.dark-theme .jr-card .app-main-header,.dark-theme .sidebar-header{border-color:#495762}.dark-theme .app-header .app-main-header{border-color:#2d353c}.dark-theme .app-header{-webkit-box-shadow:none;-moz-box-shadow:none;-o-box-shadow:none;box-shadow:none}.dark-theme .app-footer{padding:0 24px;border-color:#495762;background-color:#38424b;color:#e0e0e0}.dark-theme .app-footer a.text-secondary{color:#e0e0e0!important}.dark-theme .app-footer a.text-secondary:hover{color:#c7c7c7!important}.dark-theme .media-list:not(:last-child){border-color:#495762}.dark-theme .app-main-header.bg-white{color:#fff!important}.dark-theme .color-theme-header{background-color:#38424b}.dark-theme .side-nav{background-color:#2d353c!important;color:#e0e0e0!important;border-color:#495762!important}.dark-theme .side-nav .user-profile{background-color:#343d45;position:relative;z-index:2}.dark-theme .side-nav .customizer{border-bottom:0 none}.dark-theme .side-nav .user-detail .user-name{color:#d3d3d3}.dark-theme ul.nav-menu .nav-header,.dark-theme ul.nav-menu li a{color:#e0e0e0}.dark-theme ul.nav-menu>li.open>a,.dark-theme ul.nav-menu>li>a:focus,.dark-theme ul.nav-menu>li>a:hover{background-color:#343d45;color:#d3d3d3}.dark-theme ul.nav-menu li.menu.open>a{border-color:#d3d3d3}.dark-theme ul.nav-menu li.menu>a:focus:before,.dark-theme ul.nav-menu li.menu>a:hover:before{color:#d3d3d3}.dark-theme ul.nav-menu li ul{background-color:#343d45}.dark-theme ul.nav-menu li.menu>a:before{color:#e0e0e0}.dark-theme ul.nav-menu li.menu.open>a:before,.dark-theme ul.nav-menu li.menu>a:focus:before,.dark-theme ul.nav-menu li.menu li>a:hover:before{color:#d3d3d3}.dark-theme ul.nav-menu li.menu .sub-menu li>a:before{color:#e0e0e0}.dark-theme ul.nav-menu li.menu.open .sub-menu li>a.active,.dark-theme ul.nav-menu li.menu.open .sub-menu li>a.active:before,.dark-theme ul.nav-menu li.menu .sub-menu li>a:focus,.dark-theme ul.nav-menu li.menu .sub-menu li>a:focus:before,.dark-theme ul.nav-menu li.menu .sub-menu li>a:hover,.dark-theme ul.nav-menu li.menu .sub-menu li>a:hover:before{background-color:#2d353c;color:#fff}.dark-theme ul.nav-menu li.menu .sub-menu li>a.active .nav-text{background-color:#38424b}.dark-theme .navbar-nav li:focus>a,.dark-theme .navbar-nav li:hover>a{color:#b8c1ca}.dark-theme .navbar-nav li a{color:#868e96}.dark-theme .navbar-nav li a:focus,.dark-theme .navbar-nav li a:hover{color:#b8c1ca}.dark-theme .navbar-nav li.nav-item>a{color:#fff}.dark-theme .navbar-nav li.nav-item.active>a,.dark-theme .navbar-nav li.nav-item:focus>a,.dark-theme .navbar-nav li.nav-item:hover>a,.dark-theme .navbar-nav li.nav-item>a:focus,.dark-theme .navbar-nav li.nav-item>a:hover{color:#b8c1ca}.dark-theme .navbar-nav ul.sub-menu{background-color:#434f5a;border-color:#4c5965}.dark-theme .navbar-nav ul.sub-menu li.active>a,.dark-theme .navbar-nav ul.sub-menu li a.active{color:#b8c1ca}.dark-theme .navbar-nav .nav-arrow>a:before{color:#868e96}.dark-theme .navbar-nav .nav-arrow.active>a:before,.dark-theme .navbar-nav .nav-arrow:focus>a:before,.dark-theme .navbar-nav .nav-arrow:hover>a:before,.dark-theme .navbar-nav .nav-arrow a:focus:before,.dark-theme .navbar-nav .nav-arrow a:hover:before{color:#b8c1ca}.dark-theme .app-top-nav{background-color:#252525!important}.dark-theme .app-top-nav .navbar-nav li.nav-item>a{color:#fff}.dark-theme .app-top-nav .navbar-nav li.nav-item.active>a,.dark-theme .app-top-nav .navbar-nav li.nav-item:focus>a,.dark-theme .app-top-nav .navbar-nav li.nav-item:hover>a,.dark-theme .app-top-nav .navbar-nav li.nav-item>a:focus,.dark-theme .app-top-nav .navbar-nav li.nav-item>a:hover{color:#b8c1ca}.dark-theme .rbc-event{background-color:#7e8f9e}.dark-theme .rbc-event.rbc-selected{background-color:#22282e}.dark-theme .rbc-slot-selection{background-color:rgba(56,66,75,.7)}.dark-theme .rbc-toolbar button.rbc-active,.dark-theme .rbc-toolbar button.rbc-active:focus,.dark-theme .rbc-toolbar button.rbc-active:hover,.dark-theme .rbc-toolbar button:active,.dark-theme .rbc-toolbar button:active:focus,.dark-theme .rbc-toolbar button:active:hover,.dark-theme .rbc-toolbar button:focus,.dark-theme .rbc-toolbar button:hover{background-color:rgba(56,66,75,.9);border-color:#9ba8b4;color:#fff}.dark-theme .rbc-toolbar button{background-color:rgba(56,66,75,.9);border-color:#9ba8b4;color:#9ba8b4}.dark-theme .rbc-show-more{background-color:#7e8f9e}.dark-theme .rbc-off-range-bg{background-color:#4e5c68}.dark-theme .rbc-day-slot .rbc-event{border-color:#38424b}.dark-theme .chat-sidenav-title{color:#38424b}.dark-theme .chat-user-item.active,.dark-theme .chat-user-item:hover{background-color:#a9b5bf}.dark-theme .contact-list i{color:#38424b}.dark-theme .filter-with-bg-color ul li a,.dark-theme .login-content .form-control:focus{border-color:#38424b}.dark-theme .filter-with-bg-color ul li a.active,.dark-theme .filter-with-bg-color ul li a:focus,.dark-theme .filter-with-bg-color ul li a:hover{background-color:#38424b}.dark-theme .profile-intro .icon{color:#647585}.dark-theme .actions,.dark-theme .social-link li.active a,.dark-theme .social-link li a:focus,.dark-theme .social-link li a:hover{color:#d3d3d3}.dark-theme .table-hover tbody tr:hover{background-color:rgba(56,66,75,.075)}.dark-theme .border-primary{border-color:#d3d3d3!important}.dark-theme .breadcrumb,.dark-theme .desc-list.even-odd li:nth-child(2n){background-color:#38424b}.dark-theme .timeline-item:before{border-color:#495762}.dark-theme .timeline-panel{background-color:#434f5a;border-color:#495762}.dark-theme .timeline-panel:after{border-color:transparent #434f5a}.dark-theme .timeline-panel:before{border-color:transparent #4c5965}.dark-theme .login-content{background-color:#434f5a;border-color:#495762}.dark-theme .chat-sidenav-header,.dark-theme .chat-tabs{background-color:#22282e}.dark-theme .module-nav li a{color:#adb5bd!important}.dark-theme .module-nav li a.active,.dark-theme .module-nav li a:focus,.dark-theme .module-nav li a:hover{color:#fff!important}.dark-theme .module-nav li a.active{border-color:#22282e}.dark-theme .module-side{background-color:#434f5a}.dark-theme .app-module-sidenav,.dark-theme .dropdown-menu,.dark-theme .module-box-header{background-color:#434f5a;border-color:#495762;color:#e0e0e0}.dark-theme .dropdown-item{color:#e0e0e0}.dark-theme .dropdown-item:focus,.dark-theme .dropdown-item:hover{background-color:#38424b;color:#e0e0e0}.dark-theme .quick-menu .dropdown-menu .jr-card-header{-webkit-box-shadow:none;-moz-box-shadow:none;-o-box-shadow:none;box-shadow:none;border-color:#495762}.dark-theme .quick-menu .dropdown-menu:after{border-left:5px solid transparent;border-right:5px solid transparent;border-bottom:5px solid #434f5a}.dark-theme .quick-menu .dropdown-menu:before{border-left:5px solid transparent;border-right:5px solid transparent;border-bottom:5px solid #495762}.dark-theme .module-box-header .icon-btn{color:#e0e0e0}.dark-theme .module-box-header .search-bar input{background-color:#38424b}.dark-theme .module-box-header .search-bar input:focus{background-color:#fff}.dark-theme .chat-sidenav-header .search-bar input{background-color:#38424b}.dark-theme .chat-sidenav-header .search-bar input:focus{background-color:#fff}.dark-theme .chat-main-footer,.dark-theme .chat-main-header,.dark-theme .chat-sidenav,.dark-theme .chat-user-item,.dark-theme .messages-list ul li,.dark-theme .modal-header,.dark-theme .module-box-topbar,.dark-theme .module-list-item,.dark-theme .module-side-header,.dark-theme hr{border-color:#495762}.dark-theme .module-logo,.dark-theme .user-nav .quick-menu .user-profile{background-color:#38424b;color:#e0e0e0}.dark-theme .messages-list ul li .user-name a{color:#e0e0e0}.dark-theme .chat-main-footer,.dark-theme .chat-main-header,.dark-theme .chat-module-box,.dark-theme .chat-sidenav-content,.dark-theme .chat-textarea,.dark-theme .modal-box-footer,.dark-theme .module-box-content,.dark-theme .module-detail-header{background-color:#38424b}.dark-theme .modal-box-content{background-color:#434f5a}.dark-theme .chat-user-item.active,.dark-theme .chat-user-item:hover{background-color:#22282e}.dark-theme .chat-textarea{color:#fff}.dark-theme .chat-item{padding:16px}.dark-theme .chat-item .bubble{background-color:#4e5c68;border-color:#2f383f}.dark-theme .chat-item .bubble:before{border-right:9px solid #4e5c68}.dark-theme .chat-item .bubble:after{border-right:8px solid #4e5c68}.dark-theme .chat-item.flex-row-reverse .bubble{margin-right:16px;margin-left:0;background-color:#22282e;border-color:#4e5c68}.dark-theme .chat-item.flex-row-reverse .bubble:before{left:auto;right:-9px;border-left:9px solid #22282e;border-right:0 none}.dark-theme .chat-item.flex-row-reverse .bubble:after{left:auto;right:-8px;border-left:8px solid #22282e;border-right:0 none}.dark-theme .modal-box-footer{padding-top:12px}.dark-theme .app-logo-content{background-color:#38424b}.dark-theme .app-social-block .social-link button{border:1px solid #38424b;color:#38424b}.dark-theme .app-social-block .social-link button:focus,.dark-theme .app-social-block .social-link button:hover{color:#fff;background-color:#38424b}.dark-theme .form-checkbox>input+.check,.dark-theme .form-checkbox>input.sm+.check{color:#868e96}.dark-theme .rc-drawer-pin,.dark-theme .rc-drawer-sidebar-dark-theme{color:#e0e0e0;background-color:#38424b}.dark-theme .rc-drawer-left .rc-drawer-sidebar-dark-theme,.dark-theme .rc-drawer-right .rc-drawer-sidebar-dark-theme{height:100vh}.dark-theme .rc-drawer-left .rc-drawer-sidebar-dark-theme,.dark-theme .rc-drawer-pin,.dark-theme .rc-drawer-right .rc-drawer-sidebar-dark-theme{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.dark-theme .rc-drawer-pin{height:100%;padding:20px}.dark-theme .rc-drawer-docked .rc-drawer-content{border-left:0 none}.dark-theme .rc-drawer-sidebar{background-color:#38424b}.dark-theme .rc-collapse{background-color:#434f5a;border-color:#495762}.dark-theme .rc-collapse>.rc-collapse-item{border-color:#495762}.dark-theme .rc-collapse>.rc-collapse-item>.rc-collapse-header{color:#e0e0e0}.dark-theme .rc-collapse>.rc-collapse-item>.rc-collapse-header .arrow{border-left-color:#e0e0e0}.dark-theme .rc-collapse .rc-collapse-content{background-color:#434f5a;border-color:#495762;color:#e0e0e0}.dark-theme .rc-collapse .rc-collapse-item-disabled>.rc-collapse-header{background-color:#434f5a;color:#e0e0e0}.dark-theme .rc-time-picker-panel{color:#38424b}.dark-theme .Collapsible__trigger{background-color:#2d353c}.dark-theme .Collapsible__contentInner{background-color:#434f5a;border-color:#495762}.dark-theme .categories-list li.active a,.dark-theme .categories-list li a:focus,.dark-theme .categories-list li a:hover{color:#a0a0a0}.dark-theme .table td,.dark-theme .table th{border-color:#495762}.dark-theme .table-unbordered .th-border-b th{border-color:#495762!important}.dark-theme .ReactTable,.dark-theme .ReactTable .rt-thead.-header,.dark-theme .ReactTable .rt-thead .rt-td,.dark-theme .ReactTable .rt-thead .rt-th{border-color:#495762}.dark-theme .ReactTable .rt-table .rt-thead.-headerGroups{background-color:#434f5a;border-color:#495762}.dark-theme .ReactTable.-highlight .rt-tbody .rt-tr:not(.-padRow):hover,.dark-theme .ReactTable.-striped .rt-tbody .rt-tr-group .rt-tr.-odd{background-color:#495762!important}.dark-theme .ReactTable .-pagination,.dark-theme .ReactTable .rt-tbody .rt-td,.dark-theme .ReactTable .rt-tbody .rt-tr-group{border-color:#495762}.dark-theme .ReactTable .-pagination .-btn:not([disabled]){background-color:#3c4751;color:#e0e0e0}.dark-theme .ReactTable .-pagination .-btn:not([disabled]):hover{background-color:#38424b;color:#e0e0e0}.dark-theme .ReactTable .-pagination .-btn[disabled]{color:#e0e0e0}.dark-theme .card-strip,.dark-theme .contact-item{border-color:#495762}", ""]);

// exports


/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1315);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(65)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./app-rtl.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./app-rtl.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(64)(false);
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Nunito+Sans:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i);", ""]);

// module
exports.push([module.i, ".rtl .color-option,.rtl .contact-info,.rtl .list-inline,.rtl .list-unstyled,.rtl .module-nav,.rtl .social-link{padding-right:0}.rtl .zmdi-hc-ul{margin-left:0;margin-right:2.14285714em}.rtl .zmdi-hc-li{left:auto;right:-2.14285714em}.rtl .ml-0,.rtl .mr-0{margin-left:0!important;margin-right:0!important}.rtl .mr-1{margin-left:.25rem!important;margin-right:0!important}.rtl .ml-1{margin-right:.25rem!important;margin-left:0!important}.rtl .mr-2{margin-left:.5rem!important;margin-right:0!important}.rtl .ml-2{margin-right:.5rem!important;margin-left:0!important}.rtl .mr-3{margin-left:1rem!important;margin-right:0!important}.rtl .ml-3{margin-right:1rem!important;margin-left:0!important}.rtl .mr-4{margin-left:1.5rem!important;margin-right:0!important}.rtl .ml-4{margin-right:1.5rem!important;margin-left:0!important}.rtl .mr-5{margin-left:3rem!important;margin-right:0!important}.rtl .ml-5{margin-right:3rem!important;margin-left:0!important}.rtl .pl-0,.rtl .pr-0{padding-left:0!important;padding-right:0!important}.rtl .pr-1{padding-left:.25rem!important;padding-right:0!important}.rtl .pl-1{padding-right:.25rem!important;padding-left:0!important}.rtl .pr-2{padding-left:.5rem!important;padding-right:0!important}.rtl .pl-2{padding-right:.5rem!important;padding-left:0!important}.rtl .pr-3{padding-left:1rem!important;padding-right:0!important}.rtl .pl-3{padding-right:1rem!important;padding-left:0!important}.rtl .pr-4{padding-left:1.5rem!important;padding-right:0!important}.rtl .pl-4{padding-right:1.5rem!important;padding-left:0!important}.rtl .pr-5{padding-left:3rem!important;padding-right:0!important}.rtl .pl-5{padding-right:3rem!important;padding-left:0!important}.rtl .mr-auto{margin-left:auto!important;margin-right:0!important}.rtl .ml-auto{margin-right:auto!important;margin-left:0!important}@media (min-width:576px){.rtl .ml-sm-0,.rtl .mr-sm-0{margin-left:0!important;margin-right:0!important}.rtl .mr-sm-1{margin-left:.25rem!important;margin-right:0!important}.rtl .ml-sm-1{margin-right:.25rem!important;margin-left:0!important}.rtl .mr-sm-2{margin-left:.5rem!important;margin-right:0!important}.rtl .ml-sm-2{margin-right:.5rem!important;margin-left:0!important}.rtl .mr-sm-3{margin-left:1rem!important;margin-right:0!important}.rtl .ml-sm-3{margin-right:1rem!important;margin-left:0!important}.rtl .mr-sm-4{margin-left:1.5rem!important;margin-right:0!important}.rtl .ml-sm-4{margin-right:1.5rem!important;margin-left:0!important}.rtl .mr-sm-5{margin-left:3rem!important;margin-right:0!important}.rtl .ml-sm-5{margin-right:3rem!important;margin-left:0!important}.rtl .pl-sm-0,.rtl .pr-sm-0{padding-left:0!important;padding-right:0!important}.rtl .pr-sm-1{padding-left:.25rem!important;padding-right:0!important}.rtl .pl-sm-1{padding-right:.25rem!important;padding-left:0!important}.rtl .pr-sm-2{padding-left:.5rem!important;padding-right:0!important}.rtl .pl-sm-2{padding-right:.5rem!important;padding-left:0!important}.rtl .pr-sm-3{padding-left:1rem!important;padding-right:0!important}.rtl .pl-sm-3{padding-right:1rem!important;padding-left:0!important}.rtl .pr-sm-4{padding-left:1.5rem!important;padding-right:0!important}.rtl .pl-sm-4{padding-right:1.5rem!important;padding-left:0!important}.rtl .pr-sm-5{padding-left:3rem!important;padding-right:0!important}.rtl .pl-sm-5{padding-right:3rem!important;padding-left:0!important}.rtl .mr-sm-auto{margin-left:auto!important;margin-right:0!important}.rtl .ml-sm-auto{margin-right:auto!important;margin-left:0!important}}@media (min-width:768px){.rtl .ml-md-0,.rtl .mr-md-0{margin-left:0!important;margin-right:0!important}.rtl .mr-md-1{margin-left:.25rem!important;margin-right:0!important}.rtl .ml-md-1{margin-right:.25rem!important;margin-left:0!important}.rtl .mr-md-2{margin-left:.5rem!important;margin-right:0!important}.rtl .ml-md-2{margin-right:.5rem!important;margin-left:0!important}.rtl .mr-md-3{margin-left:1rem!important;margin-right:0!important}.rtl .ml-md-3{margin-right:1rem!important;margin-left:0!important}.rtl .mr-md-4{margin-left:1.5rem!important;margin-right:0!important}.rtl .ml-md-4{margin-right:1.5rem!important;margin-left:0!important}.rtl .mr-md-5{margin-left:3rem!important;margin-right:0!important}.rtl .ml-md-5{margin-right:3rem!important;margin-left:0!important}.rtl .pl-md-0,.rtl .pr-md-0{padding-left:0!important;padding-right:0!important}.rtl .pr-md-1{padding-left:.25rem!important;padding-right:0!important}.rtl .pl-md-1{padding-right:.25rem!important;padding-left:0!important}.rtl .pr-md-2{padding-left:.5rem!important;padding-right:0!important}.rtl .pl-md-2{padding-right:.5rem!important;padding-left:0!important}.rtl .pr-md-3{padding-left:1rem!important;padding-right:0!important}.rtl .pl-md-3{padding-right:1rem!important;padding-left:0!important}.rtl .pr-md-4{padding-left:1.5rem!important;padding-right:0!important}.rtl .pl-md-4{padding-right:1.5rem!important;padding-left:0!important}.rtl .pr-md-5{padding-left:3rem!important;padding-right:0!important}.rtl .pl-md-5{padding-right:3rem!important;padding-left:0!important}.rtl .mr-md-auto{margin-left:auto!important;margin-right:0!important}.rtl .ml-md-auto{margin-right:auto!important;margin-left:0!important}}@media (min-width:992px){.rtl .ml-lg-0,.rtl .mr-lg-0{margin-left:0!important;margin-right:0!important}.rtl .mr-lg-1{margin-left:.25rem!important;margin-right:0!important}.rtl .ml-lg-1{margin-right:.25rem!important;margin-left:0!important}.rtl .mr-lg-2{margin-left:.5rem!important;margin-right:0!important}.rtl .ml-lg-2{margin-right:.5rem!important;margin-left:0!important}.rtl .mr-lg-3{margin-left:1rem!important;margin-right:0!important}.rtl .ml-lg-3{margin-right:1rem!important;margin-left:0!important}.rtl .mr-lg-4{margin-left:1.5rem!important;margin-right:0!important}.rtl .ml-lg-4{margin-right:1.5rem!important;margin-left:0!important}.rtl .mr-lg-5{margin-left:3rem!important;margin-right:0!important}.rtl .ml-lg-5{margin-right:3rem!important;margin-left:0!important}.rtl .pl-lg-0,.rtl .pr-lg-0{padding-left:0!important;padding-right:0!important}.rtl .pr-lg-1{padding-left:.25rem!important;padding-right:0!important}.rtl .pl-lg-1{padding-right:.25rem!important;padding-left:0!important}.rtl .pr-lg-2{padding-left:.5rem!important;padding-right:0!important}.rtl .pl-lg-2{padding-right:.5rem!important;padding-left:0!important}.rtl .pr-lg-3{padding-left:1rem!important;padding-right:0!important}.rtl .pl-lg-3{padding-right:1rem!important;padding-left:0!important}.rtl .pr-lg-4{padding-left:1.5rem!important;padding-right:0!important}.rtl .pl-lg-4{padding-right:1.5rem!important;padding-left:0!important}.rtl .pr-lg-5{padding-left:3rem!important;padding-right:0!important}.rtl .pl-lg-5{padding-right:3rem!important;padding-left:0!important}.rtl .mr-lg-auto{margin-left:auto!important;margin-right:0!important}.rtl .ml-lg-auto{margin-right:auto!important;margin-left:0!important}}@media (min-width:1200px){.rtl .ml-xl-0,.rtl .mr-xl-0{margin-left:0!important;margin-right:0!important}.rtl .mr-xl-1{margin-left:.25rem!important;margin-right:0!important}.rtl .ml-xl-1{margin-right:.25rem!important;margin-left:0!important}.rtl .mr-xl-2{margin-left:.5rem!important;margin-right:0!important}.rtl .ml-xl-2{margin-right:.5rem!important;margin-left:0!important}.rtl .mr-xl-3{margin-left:1rem!important;margin-right:0!important}.rtl .ml-xl-3{margin-right:1rem!important;margin-left:0!important}.rtl .mr-xl-4{margin-left:1.5rem!important;margin-right:0!important}.rtl .ml-xl-4{margin-right:1.5rem!important;margin-left:0!important}.rtl .mr-xl-5{margin-left:3rem!important;margin-right:0!important}.rtl .ml-xl-5{margin-right:3rem!important;margin-left:0!important}.rtl .pl-xl-0,.rtl .pr-xl-0{padding-left:0!important;padding-right:0!important}.rtl .pr-xl-1{padding-left:.25rem!important;padding-right:0!important}.rtl .pl-xl-1{padding-right:.25rem!important;padding-left:0!important}.rtl .pr-xl-2{padding-left:.5rem!important;padding-right:0!important}.rtl .pl-xl-2{padding-right:.5rem!important;padding-left:0!important}.rtl .pr-xl-3{padding-left:1rem!important;padding-right:0!important}.rtl .pl-xl-3{padding-right:1rem!important;padding-left:0!important}.rtl .pr-xl-4{padding-left:1.5rem!important;padding-right:0!important}.rtl .pl-xl-4{padding-right:1.5rem!important;padding-left:0!important}.rtl .pr-xl-5{padding-left:3rem!important;padding-right:0!important}.rtl .pl-xl-5{padding-right:3rem!important;padding-left:0!important}.rtl .mr-xl-auto{margin-left:auto!important;margin-right:0!important}.rtl .ml-xl-auto{margin-right:auto!important;margin-left:0!important}}.rtl .text-left{text-align:right!important}.rtl .text-right{text-align:left!important}@media (min-width:576px){.rtl .text-sm-left{text-align:right!important}.rtl .text-sm-right{text-align:left!important}}@media (min-width:768px){.rtl .text-md-left{text-align:right!important}.rtl .text-md-right{text-align:left!important}}@media (min-width:992px){.rtl .text-lg-left{text-align:right!important}.rtl .text-lg-right{text-align:left!important}}@media (min-width:1200px){.rtl .text-xl-left{text-align:right!important}.rtl .text-xl-right{text-align:left!important}}.rtl .jr-menu-icon .menu-icon:after,.rtl .jr-menu-icon .menu-icon:before{left:auto;right:0}.rtl .side-nav{border-left:1px solid #e9ecef!important}.rtl .side-nav .user-avatar{margin:0 0 0 15px!important}.rtl.dark-amber .side-nav,.rtl.dark-blue .side-nav,.rtl.dark-cyan .side-nav,.rtl.dark-deep-orange .side-nav,.rtl.dark-deep-purple .side-nav,.rtl.dark-green .side-nav,.rtl.dark-indigo .side-nav,.rtl.dark-pink .side-nav{border-left:0 none!important}.rtl ul.nav-menu li.menu>a{border-left:0 none;border-right:2px solid transparent}.rtl ul.nav-menu li.menu>a:before{float:left;-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);-o-transform:rotate(180deg);transform:rotate(180deg);margin-left:0;margin-right:10px}.rtl ul.nav-menu li.menu.active>a:before,.rtl ul.nav-menu li.menu.open>a:before{-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);-o-transform:rotate(90deg);transform:rotate(90deg)}.rtl ul.nav-menu li i{margin-left:16px;margin-right:0}.rtl ul.nav-menu li ul>li>a{padding-left:20px;padding-right:56px}.rtl ul.nav-menu li ul>li>ul>li>a{padding-left:20px;padding-right:76px}.rtl ul.nav-menu li ul>li>ul>li>ul>li>a{padding-left:20px;padding-right:96px}.rtl ul.nav-menu li ul>li>ul>li>ul>li>ul>li>a{padding-left:20px;padding-right:116px}.rtl .app-container.mini-drawer .side-nav:hover ul.nav-menu li{text-align:right}.rtl .app-container.mini-drawer .side-nav:hover ul.nav-menu li i{margin-left:16px;margin-right:0}.rtl .app-container.mini-drawer .side-nav:hover ul.nav-menu ul.sub-menu li a{padding-left:20px;padding-right:56px}.rtl .app-container.mini-drawer .side-nav:hover ul.nav-menu ul.sub-menu>li>ul>li>a{padding-left:20px;padding-right:76px}.rtl .app-container.mini-drawer .side-nav:hover ul.nav-menu ul.sub-menu>li>ul>li>ul>li>a{padding-left:20px;padding-right:96px}.rtl .app-container.mini-drawer .side-nav:hover ul.nav-menu ul.sub-menu>li>ul>li>ul>li>ul>li>a{padding-left:20px;padding-right:116px}.rtl .navbar-nav{padding-right:0}.rtl .navbar-nav>li:last-child ul.sub-menu{left:0;right:auto}.rtl .navbar-nav>li:last-child ul.sub-menu ul.sub-menu{left:100%;right:auto}.rtl .navbar-nav ul.sub-menu{left:auto;right:0}.rtl .navbar-nav ul.sub-menu li>ul.sub-menu{left:auto;right:100%}.rtl .navbar-nav ul.sub-menu li a i{margin-right:0;margin-left:10px}.rtl .navbar-nav .nav-arrow>a:before{float:left;margin-left:0;margin-right:10px;-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);-o-transform:rotate(180deg);transform:rotate(180deg)}.rtl .navbar-nav .nav-item+.nav-item{margin-right:0}.rtl .theme-option{right:auto;left:0;border-top-left-radius:0;border-bottom-left-radius:0;border-top-right-radius:4px;border-bottom-right-radius:4px}.rtl .cr-op-dark-sidebar li a:after{left:auto;right:0}.rtl .jr-menu-icon{margin-right:0;margin-left:15px}.rtl .app-toolbar .search-bar{margin-right:0}.rtl .app-toolbar .nav-searchbox .search-bar{margin-left:auto;margin-right:0}.rtl .quick-menu .dropdown-menu .jr-card-header{padding:10px 20px 10px 10px}.rtl .quick-menu .dropdown-menu:after,.rtl .quick-menu .dropdown-menu:before{right:auto;left:8px}.rtl .quick-menu .messages-list .badge{left:auto;right:-4px}.rtl .messages-list ul li .jr-btn{margin-right:auto!important;margin-left:0!important}.rtl .quick-menu .icon-alert:after{right:auto;left:0}.rtl .quick-menu .dropdown-menu{right:auto!important;left:0!important}.rtl .app-logo{margin-right:0;margin-left:12px}.rtl .app-header .app-logo{margin-right:0;margin-left:20px}@media screen and (max-width:991px){.rtl .app-header .app-logo{margin-right:0;margin-left:auto}}.rtl .net-chart{padding-left:15px;padding-right:80px}.rtl .net-chart .jr-card-thumb{left:auto;right:15px}.rtl .net-chart:hover .jr-card-thumb{right:0}.rtl .net-chart-hr{padding-right:24px;padding-left:8px}.rtl .net-chart-hr .jr-card-thumb{margin:-30px -24px -30px 12px}.rtl .jr-card-header-top{margin-right:0;margin-left:-16px}.rtl .social-list-line:not(:last-child):before{border-left:0 none;border-right:1px solid #adb5bd;left:0;right:20px}.rtl .list-line-item{padding-left:0;padding-right:40px}.rtl .list-line-item:not(:last-child):before{border-left:0 none;border-right:1px solid #adb5bd;left:0;right:20px}.rtl .list-line-badge{left:0;right:16px}.rtl .box .box-bottom .size-h5,.rtl .box .box-top .size-h5{margin-left:0;margin-right:2px}.rtl .contact-list i{margin-right:0;margin-left:14px}.rtl .status-cell{padding-right:0!important;padding-left:24px!important}.rtl .breadcrumb-item+.breadcrumb-item:before,.rtl .zmdi-chevron-right:before{content:\"\\F2FA\"}.rtl .chartAreaWrapper,.rtl .chartWrapper,.rtl .recharts-responsive-container{direction:rtl}.rtl .manage-margin>:not(:last-child){margin-right:0;margin-left:16px}.rtl .col-with-divider div[class*=col-]{border-left:0 none;border-right:1px solid #dee2e6}.rtl .right-arrow:after{margin-left:0;margin-right:8px}.rtl .module-nav li i{margin-right:0;margin-left:16px}.rtl .module-box-header .search-bar.right-side-icon .form-control{padding:18px 70px 18px 18px}.rtl .module-box-header .search-bar.right-side-icon .search-icon{left:auto;right:9px}.rtl .toolbar-separator{border-left:0 none;border-right:1px solid #ced4da}.rtl .module-list-item.mail-cell{padding-left:26px;padding-right:12px}.rtl .module-list-actions{text-align:left}.rtl .chat-todo-avatar{margin-right:0;margin-left:15px}.rtl .chat-sidenav{border-right:0 none;border-left:1px solid #ced4da}.rtl .search-wrapper .search-bar.right-side-icon .form-control{padding-left:16px;padding-right:32px}.rtl .search-wrapper .search-bar.right-side-icon .search-icon{left:auto;right:0}.rtl .chat-avatar-mode .chat-mode{right:auto;left:0}.rtl .chat-date{text-align:left}.rtl .chat-item .bubble{border-radius:20px 20px 0 20px;margin-left:0;margin-right:16px}.rtl .chat-item.flex-row-reverse .bubble{margin-right:0;margin-left:16px;border-radius:20px 20px 20px 0}.rtl .chat-btn{margin:0 -8px 0 10px}.rtl .modal-box-header h2 button{right:auto;left:0}.rtl .btn-fixed{right:auto;left:40px}.rtl .mail-user-info .avatar{margin-right:0;margin-left:10px}.rtl .sender-name{margin-right:0;margin-left:8px}.rtl .mail-header-actions{text-align:left}.rtl .mail-header-actions .btn:not(:last-child){margin-right:0;margin-left:3px}.rtl .contact-block .contact-info li{border-right:0 none;border-left:2px solid #5c5c5c}.rtl .contact-block .contact-info li>i{float:right;margin-right:0;margin-left:5px}.rtl .contact-block .contact-info li .contact-body .icon{margin-right:0;margin-left:6px}.rtl .contact-block .contact-info li .contact-body .icon:last-child{margin-left:0}.rtl .contact-block .contact-info.vertical li{border-left:0 none}.rtl .Collapsible__trigger:after{right:auto;left:24px}.rtl .meta-date+.meta-comment{margin-left:0;margin-right:10px}.rtl .search-bar input[type=search]{padding-right:15px;padding-left:50px}.rtl .search-bar .form-control.form-control-lg+.search-icon,.rtl .search-bar .search-icon{right:auto;left:14px}.rtl .search-bar.right-side-icon input[type=search]{padding-right:50px;padding-left:16px}.rtl .search-bar.right-side-icon .form-control.form-control-lg+.search-icon,.rtl .search-bar.right-side-icon .search-icon{left:auto;right:14px}.rtl .meta-comment i,.rtl .meta-date i{margin-right:0;margin-left:6px}.rtl .alert .alert-addon{left:auto;right:0}.rtl .alert-dismissible{padding-left:60px}.rtl .alert-addon-card{padding-right:80px}.rtl .user-avatar{margin-right:0;margin-left:8px}.rtl .user-avatar.ml-3{margin-left:8px!important}.rtl .badge:not(:last-child){margin-right:0;margin-left:15px}.rtl blockquote{padding:10px 20px 10px 0}.rtl .blockquote{border-left:0 none;border-right:5px solid #e9ecef}.rtl .blockquote-reverse{border-right:0 none;border-left:5px solid #e9ecef;text-align:left;padding-left:20px;padding-right:0}.rtl .btn:not(:last-child),.rtl .jr-btn:not(:last-child),.rtl .jr-fab-btn:not(:last-child){margin-right:0;margin-left:15px}.rtl .right-sidebar .btn:not(:last-child),.rtl .right-sidebar .jr-btn:not(:last-child),.rtl .right-sidebar .jr-fab-btn:not(:last-child){margin-left:0}.rtl .jr-btn i+span,.rtl .jr-btn span+i{margin-left:0;margin-right:6px}.rtl .complex-btn .img-marked{left:auto;right:calc(50% - 9px)}.rtl .jr-btn.jr-btn-label.left i{left:auto;right:0}.rtl .jr-btn.jr-btn-label.right i{right:auto;left:0}.rtl .jr-btn.jr-btn-label.left i+span{margin-left:0;margin-right:30px}.rtl .jr-btn.jr-btn-label.right i+span{margin-right:0;margin-left:30px}.rtl .btn-group-vertical .btn-group+.btn-group,.rtl .btn-group-vertical .btn-group+.jr-btn,.rtl .btn-group-vertical .jr-btn+.btn-group,.rtl .btn-group-vertical .jr-btn+.jr-btn,.rtl .btn-group .btn-group+.btn-group,.rtl .btn-group .btn-group+.jr-btn,.rtl .btn-group .btn:not(:last-child),.rtl .btn-group .jr-btn+.btn-group,.rtl .btn-group .jr-btn+.jr-btn,.rtl .btn-group .jr-btn:not(:last-child),.rtl .btn-group .jr-fab-btn:not(:last-child){margin-left:-1px}.rtl .btn-group>.jr-btn:first-child:not(:last-child):not(.dropdown-toggle){border-top-right-radius:2px!important;border-bottom-right-radius:2px!important;border-top-left-radius:0!important;border-bottom-left-radius:0!important}.rtl .btn-group>.dropdown-toggle:not(:first-child),.rtl .btn-group>.jr-btn:last-child:not(:first-child){border-top-left-radius:2px!important;border-bottom-left-radius:2px!important;border-top-right-radius:0!important;border-bottom-right-radius:0!important}.rtl .product-row{text-align:left}.rtl .product-row.even{text-align:right}.rtl .profile-intro .icon:not(:last-child){margin-right:0;margin-left:10px}.rtl .jr-card-header .badge:last-child{margin-left:0;margin-right:10px}.rtl .icons-wrapper+.icons-wrapper{margin-left:0;margin-right:25px}.rtl .user-list .user-avatar{margin-right:0;margin-left:20px}.rtl .jr-mbtn-list{margin-left:0;margin-right:-20px}.rtl .pt-circle .package-header>.price>i,.rtl .pt-classic .package-header>.price>i,.rtl .pt-dark .package-header>.price>i,.rtl .pt-default .package-header>.price>i{margin-right:0;margin-left:6px}.rtl .pt-circle .package-items li i,.rtl .pt-classic .package-items li i,.rtl .pt-dark .package-items li i,.rtl .pt-default .package-items li i{float:right;margin-right:0;margin-left:16px}.rtl .fab-progress{left:auto;right:-6px}.rtl .btn-progress{margin-left:0;margin-right:-12px}.rtl .table-header{padding-right:24px!important;padding-left:2px!important}.rtl .testimonial-in-bg{padding:30px 150px 30px 30px}@media screen and (max-width:450px){.rtl .testimonial-in-bg{padding-left:30px;padding-right:100px}}.rtl .testimonial-in-bg .pic{left:auto;right:20px}.rtl .testimonial-in-bg .description:before{left:auto;right:-24px}.rtl .timeline-left{float:right;margin-right:0;margin-left:20px}.rtl .timeline-right{float:left;margin-left:0;margin-right:20px}.rtl .timeline-item{padding-left:0;padding-right:80px}.rtl .timeline-item:before{border-left:0 none;border-right:2px solid #dee2e6;left:auto;right:25px}.rtl .timeline-item:first-child:before,.rtl .timeline-item:last-child:before{border-right-style:dashed}.rtl .timeline-badge{left:auto;right:0}.rtl .timeline-panel:before{border-width:10px 0 10px 17px;left:auto;right:-17px}.rtl .timeline-panel:after{border-width:10px 0 10px 16px;left:auto;right:-16px}.rtl .timeline-inverted .timeline-left{float:left;margin-right:20px;margin-left:0}.rtl .timeline-center .timeline-item{float:left;padding-left:0;padding-right:55px}.rtl .timeline-center .timeline-item:before{left:auto;right:0}.rtl .timeline-center .timeline-badge{left:auto;right:-25px}.rtl .timeline-center .timeline-time{left:auto;right:-150px}.rtl .timeline-center .timeline-inverted{float:right;text-align:left;padding-left:55px;padding-right:0}.rtl .timeline-center .timeline-inverted:before{border-left:2px solid #dee2e6;border-right:0 none;left:-2px;right:auto}.rtl .timeline-center .timeline-inverted .timeline-badge{left:-25px;right:auto}.rtl .timeline-center .timeline-inverted .timeline-panel:before{border-width:10px 17px 10px 0;left:-17px;right:auto}.rtl .timeline-center .timeline-inverted .timeline-panel:after{border-width:10px 16px 10px 0;left:-16px;right:auto}.rtl .timeline-center .timeline-inverted .timeline-time{right:auto;left:-150px}.rtl .timeline-zigzag .timeline-item{padding-left:0;padding-right:150px}.rtl .timeline-zigzag .timeline-img{left:auto;right:5px}.rtl .timeline-zigzag .timeline-inverted .timeline-img{right:auto!important;left:5px!important}.rtl .timeline-zigzag .timeline-inverted{padding-left:150px;padding-right:0}.rtl .timeline-zigzag .timeline-item:first-child:before{border-right-style:solid}.rtl .module-box-topbar-todo{padding-left:0;padding-right:64px}@media screen and (max-width:575px){.rtl .module-box-topbar-todo{padding-left:0;padding-right:27px}}.rtl .module-list-icon{padding-right:0;padding-left:10px}.rtl .bar-icon{margin-right:0;margin-left:15px}@media screen and (max-width:1199px){.rtl .module-box-header .search-bar.right-side-icon .form-control{padding-left:0;padding-right:100px}.rtl .module-box-header .search-bar.right-side-icon .search-icon{left:auto;right:48px}.rtl .module-box-header .drawer-btn{left:auto;right:0}}@media screen and (max-width:991px){.rtl .module-list-item.mail-cell{padding-right:0;padding-left:20px}.rtl .timeline-zigzag .timeline-item{padding-left:0;padding-right:120px}.rtl .timeline-zigzag .timeline-inverted{padding-right:0;padding-left:120px}}@media screen and (max-width:767px){.rtl .contact-block .contact-info li{border-left:0 none}.rtl .timeline-center .timeline-item{padding-left:0;padding-right:80px}.rtl .timeline-center .timeline-item:before{left:auto;right:25px}.rtl .timeline-center .timeline-badge{left:auto;right:0}.rtl .timeline-center .timeline-inverted{text-align:right;padding-left:0}.rtl .timeline-center .timeline-inverted:before{border-left:0 none;border-right:2px solid #dee2e6;left:auto;right:24px}.rtl .timeline-center .timeline-inverted .timeline-badge{right:0;left:auto}.rtl .timeline-center .timeline-inverted .timeline-panel:before{border-width:10px 0 10px 17px;left:auto;right:-17px}.rtl .timeline-center .timeline-inverted .timeline-panel:after{border-width:10px 0 10px 16px;left:auto;right:-16px}.rtl .timeline-inverted .timeline-left{float:right;margin-left:20px;margin-right:0}.rtl .timeline-zigzag .timeline-item{padding-left:0;padding-right:100px}.rtl .timeline-zigzag .timeline-item:before{left:auto;right:45px}.rtl .product-row,.rtl .product-row.even{text-align:center}.rtl .timeline-center .timeline-time{right:0}.rtl .timeline-center .timeline-inverted .timeline-time{left:0}}@media screen and (max-width:575px){.rtl .jr-menu-icon{margin-left:0}.rtl .app-main-header .list-inline-item:not(:last-child){margin-right:0}}@media screen and (max-width:499px){.rtl .mail-header-actions{text-align:right}}@media screen and (max-width:399px){.rtl .timeline-left{margin-left:10px}.rtl .timeline-right{margin-right:0}.rtl .timeline-inverted .timeline-left{margin-left:0}}.rtl .scrollbar{direction:rtl!important}.rtl .scrollbar>div:first-child{margin-right:0!important;margin-left:-17px!important}.rtl .scrollbar>div:last-child{left:2px;right:auto!important}.rtl .rbc-btn-group>button:first-child:not(:last-child){border-top-right-radius:4px;border-bottom-right-radius:4px;border-top-left-radius:0;border-bottom-left-radius:0}.rtl .rbc-btn-group>button:last-child:not(:first-child){border-top-left-radius:4px;border-bottom-left-radius:4px;border-top-right-radius:0;border-bottom-right-radius:0}.rtl .rbc-btn-group>button:first-child{margin-left:-1px}.rtl .app-module-sidenav{border-right:0 none;border-left:1px solid #e9ecef}.rtl .owl-carousel{direction:ltr}.rtl .rc-collapse-header .arrow{margin-left:8px}.rtl .list-group{padding-left:0}.rtl .switch.on .switch-toggle{right:23px}.rtl .switch-toggle{right:0}.rtl .nav-pill-sales li:first-child .nav-link{border-top-left-radius:0;border-bottom-left-radius:0;border-top-right-radius:4px;border-bottom-right-radius:4px}.rtl .nav-pill-sales li:last-child .nav-link{border-top-right-radius:0;border-bottom-right-radius:0;border-top-left-radius:4px;border-bottom-left-radius:4px}.rtl .form-checkbox-custom .check{margin-right:0;margin-left:10px}.rtl .grid>img{left:auto;right:50%;transform:translate(50%,-50%)}.rtl .card-header .badge:last-child{margin-left:0;margin-right:10px}.rtl .icons-showcase>div{text-align:right}", ""]);

// exports


/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _enUS = _interopRequireDefault(__webpack_require__(1317));

var _zhHansCN = _interopRequireDefault(__webpack_require__(1320));

var _ar_SA = _interopRequireDefault(__webpack_require__(1323));

var _it_IT = _interopRequireDefault(__webpack_require__(1326));

var _es_ES = _interopRequireDefault(__webpack_require__(1329));

var _fr_FR = _interopRequireDefault(__webpack_require__(1332));

var _reactIntl = __webpack_require__(366);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var AppLocale = {
  en: _enUS["default"],
  zh: _zhHansCN["default"],
  ar: _ar_SA["default"],
  it: _it_IT["default"],
  es: _es_ES["default"],
  fr: _fr_FR["default"]
};
(0, _reactIntl.addLocaleData)(AppLocale.en.data);
(0, _reactIntl.addLocaleData)(AppLocale.zh.data);
(0, _reactIntl.addLocaleData)(AppLocale.ar.data);
(0, _reactIntl.addLocaleData)(AppLocale.it.data);
(0, _reactIntl.addLocaleData)(AppLocale.es.data);
(0, _reactIntl.addLocaleData)(AppLocale.fr.data);
var _default = AppLocale;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AppLocale, "AppLocale", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_enUS, "_enUS", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/index.js");

  __REACT_HOT_LOADER__.register(_zhHansCN, "_zhHansCN", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/index.js");

  __REACT_HOT_LOADER__.register(_ar_SA, "_ar_SA", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/index.js");

  __REACT_HOT_LOADER__.register(_it_IT, "_it_IT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/index.js");

  __REACT_HOT_LOADER__.register(_es_ES, "_es_ES", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/index.js");

  __REACT_HOT_LOADER__.register(_fr_FR, "_fr_FR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/index.js");

  __REACT_HOT_LOADER__.register(AppLocale, "AppLocale", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/index.js");
}();

;

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _en = _interopRequireDefault(__webpack_require__(1318));

var _en_US = _interopRequireDefault(__webpack_require__(1319));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var EnLang = {
  messages: _objectSpread({}, _en_US["default"]),
  locale: 'en-US',
  data: _en["default"]
};
var _default = EnLang;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(EnLang, "EnLang", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/en-US.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/en-US.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_en, "_en", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/en-US.js");

  __REACT_HOT_LOADER__.register(_en_US, "_en_US", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/en-US.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/en-US.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/en-US.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/en-US.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/en-US.js");

  __REACT_HOT_LOADER__.register(EnLang, "EnLang", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/en-US.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/en-US.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/en-US.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/en-US.js");
}();

;

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.en=a())}(this,function(){"use strict";return[{locale:"en",pluralRuleFunction:function(e,a){var t=String(e).split("."),o=!t[1],n=Number(t[0])==e,r=n&&t[0].slice(-1),i=n&&t[0].slice(-2);return a?1==r&&11!=i?"one":2==r&&12!=i?"two":3==r&&13!=i?"few":"other":1==e&&o?"one":"other"},fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr.",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr.",other:"in {0} yr."},past:{one:"{0} yr. ago",other:"{0} yr. ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mo."},past:{one:"{0} mo. ago",other:"{0} mo. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr.",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr.",other:"in {0} hr."},past:{one:"{0} hr. ago",other:"{0} hr. ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} min."},past:{one:"{0} min. ago",other:"{0} min. ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} sec."},past:{one:"{0} sec. ago",other:"{0} sec. ago"}}}}},{locale:"en-001",parentLocale:"en",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr",other:"in {0} yr"},past:{one:"{0} yr ago",other:"{0} yr ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo",other:"in {0} mo"},past:{one:"{0} mo ago",other:"{0} mo ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hr"},past:{one:"{0} hr ago",other:"{0} hr ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min",other:"in {0} min"},past:{one:"{0} min ago",other:"{0} min ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec",other:"in {0} sec"},past:{one:"{0} sec ago",other:"{0} sec ago"}}}}},{locale:"en-150",parentLocale:"en-001"},{locale:"en-AG",parentLocale:"en-001"},{locale:"en-AI",parentLocale:"en-001"},{locale:"en-AS",parentLocale:"en"},{locale:"en-AT",parentLocale:"en-150"},{locale:"en-AU",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr",other:"in {0} yrs"},past:{one:"{0} yr ago",other:"{0} yrs ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mo."},past:{one:"{0} mo. ago",other:"{0} mo. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"h",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hrs"},past:{one:"{0} hr ago",other:"{0} hrs ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} mins"},past:{one:"{0} min. ago",other:"{0} mins ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} secs"},past:{one:"{0} sec. ago",other:"{0} secs ago"}}}}},{locale:"en-BB",parentLocale:"en-001"},{locale:"en-BE",parentLocale:"en-001"},{locale:"en-BI",parentLocale:"en"},{locale:"en-BM",parentLocale:"en-001"},{locale:"en-BS",parentLocale:"en-001"},{locale:"en-BW",parentLocale:"en-001"},{locale:"en-BZ",parentLocale:"en-001"},{locale:"en-CA",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr.",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr.",other:"in {0} yrs."},past:{one:"{0} yr. ago",other:"{0} yrs. ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mos."},past:{one:"{0} mo. ago",other:"{0} mos. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr.",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr.",other:"in {0} hrs."},past:{one:"{0} hr. ago",other:"{0} hrs. ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} mins."},past:{one:"{0} min. ago",other:"{0} mins. ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} secs."},past:{one:"{0} sec. ago",other:"{0} secs. ago"}}}}},{locale:"en-CC",parentLocale:"en-001"},{locale:"en-CH",parentLocale:"en-150"},{locale:"en-CK",parentLocale:"en-001"},{locale:"en-CM",parentLocale:"en-001"},{locale:"en-CX",parentLocale:"en-001"},{locale:"en-CY",parentLocale:"en-001"},{locale:"en-DE",parentLocale:"en-150"},{locale:"en-DG",parentLocale:"en-001"},{locale:"en-DK",parentLocale:"en-150"},{locale:"en-DM",parentLocale:"en-001"},{locale:"en-Dsrt",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},"year-short":{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},"month-short":{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},"day-short":{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},"hour-short":{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},"minute-short":{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}},"second-short":{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-ER",parentLocale:"en-001"},{locale:"en-FI",parentLocale:"en-150"},{locale:"en-FJ",parentLocale:"en-001"},{locale:"en-FK",parentLocale:"en-001"},{locale:"en-FM",parentLocale:"en-001"},{locale:"en-GB",parentLocale:"en-001"},{locale:"en-GD",parentLocale:"en-001"},{locale:"en-GG",parentLocale:"en-001"},{locale:"en-GH",parentLocale:"en-001"},{locale:"en-GI",parentLocale:"en-001"},{locale:"en-GM",parentLocale:"en-001"},{locale:"en-GU",parentLocale:"en"},{locale:"en-GY",parentLocale:"en-001"},{locale:"en-HK",parentLocale:"en-001"},{locale:"en-IE",parentLocale:"en-001"},{locale:"en-IL",parentLocale:"en-001"},{locale:"en-IM",parentLocale:"en-001"},{locale:"en-IN",parentLocale:"en-001"},{locale:"en-IO",parentLocale:"en-001"},{locale:"en-JE",parentLocale:"en-001"},{locale:"en-JM",parentLocale:"en-001"},{locale:"en-KE",parentLocale:"en-001"},{locale:"en-KI",parentLocale:"en-001"},{locale:"en-KN",parentLocale:"en-001"},{locale:"en-KY",parentLocale:"en-001"},{locale:"en-LC",parentLocale:"en-001"},{locale:"en-LR",parentLocale:"en-001"},{locale:"en-LS",parentLocale:"en-001"},{locale:"en-MG",parentLocale:"en-001"},{locale:"en-MH",parentLocale:"en"},{locale:"en-MO",parentLocale:"en-001"},{locale:"en-MP",parentLocale:"en"},{locale:"en-MS",parentLocale:"en-001"},{locale:"en-MT",parentLocale:"en-001"},{locale:"en-MU",parentLocale:"en-001"},{locale:"en-MW",parentLocale:"en-001"},{locale:"en-MY",parentLocale:"en-001"},{locale:"en-NA",parentLocale:"en-001"},{locale:"en-NF",parentLocale:"en-001"},{locale:"en-NG",parentLocale:"en-001"},{locale:"en-NL",parentLocale:"en-150"},{locale:"en-NR",parentLocale:"en-001"},{locale:"en-NU",parentLocale:"en-001"},{locale:"en-NZ",parentLocale:"en-001"},{locale:"en-PG",parentLocale:"en-001"},{locale:"en-PH",parentLocale:"en-001"},{locale:"en-PK",parentLocale:"en-001"},{locale:"en-PN",parentLocale:"en-001"},{locale:"en-PR",parentLocale:"en"},{locale:"en-PW",parentLocale:"en-001"},{locale:"en-RW",parentLocale:"en-001"},{locale:"en-SB",parentLocale:"en-001"},{locale:"en-SC",parentLocale:"en-001"},{locale:"en-SD",parentLocale:"en-001"},{locale:"en-SE",parentLocale:"en-150"},{locale:"en-SG",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr",1:"next yr","-1":"last yr"},relativeTime:{future:{one:"in {0} yr",other:"in {0} yr"},past:{one:"{0} yr ago",other:"{0} yr ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mth",relative:{0:"this mth",1:"next mth","-1":"last mth"},relativeTime:{future:{one:"in {0} mth",other:"in {0} mth"},past:{one:"{0} mth ago",other:"{0} mth ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hr"},past:{one:"{0} hr ago",other:"{0} hr ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min",other:"in {0} min"},past:{one:"{0} min ago",other:"{0} min ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec",other:"in {0} sec"},past:{one:"{0} sec ago",other:"{0} sec ago"}}}}},{locale:"en-SH",parentLocale:"en-001"},{locale:"en-SI",parentLocale:"en-150"},{locale:"en-SL",parentLocale:"en-001"},{locale:"en-SS",parentLocale:"en-001"},{locale:"en-SX",parentLocale:"en-001"},{locale:"en-SZ",parentLocale:"en-001"},{locale:"en-Shaw",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},"year-short":{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},"month-short":{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},"day-short":{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},"hour-short":{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},"minute-short":{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}},"second-short":{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-TC",parentLocale:"en-001"},{locale:"en-TK",parentLocale:"en-001"},{locale:"en-TO",parentLocale:"en-001"},{locale:"en-TT",parentLocale:"en-001"},{locale:"en-TV",parentLocale:"en-001"},{locale:"en-TZ",parentLocale:"en-001"},{locale:"en-UG",parentLocale:"en-001"},{locale:"en-UM",parentLocale:"en"},{locale:"en-US",parentLocale:"en"},{locale:"en-VC",parentLocale:"en-001"},{locale:"en-VG",parentLocale:"en-001"},{locale:"en-VI",parentLocale:"en"},{locale:"en-VU",parentLocale:"en-001"},{locale:"en-WS",parentLocale:"en-001"},{locale:"en-ZA",parentLocale:"en-001"},{locale:"en-ZM",parentLocale:"en-001"},{locale:"en-ZW",parentLocale:"en-001"}]});


/***/ }),
/* 1319 */
/***/ (function(module, exports) {

module.exports = {"general.company.name":"Client Plus Solutions 2020","general.todo":"TODO...","general.areYouSure":"Are you sure?","general.updateSelections":"Update Selections","label.edit":"Edit","label.delete":"Delete","label.startDate":"Start Date","label.createdDate":"Created Date","label.endDate":"End Date","label.resolutionDate":"Resolution Date","label.name":"Name","label.description":"Description","label.successIndicators":"Success Indicators","label.initiative":"Initiative","label.priority":"Priority","label.progress.total":"Progress/ Total","label.status":"Status","label.resolution.type":"Resolution Type","label.resolution.description":"Resolution Description","label.sub.tasks":"Sub tasks","label.filter.selected":"Hide selected","label.inwardDependencies":"Blocked by","label.outwardDependencies":"Is blocking","label.portfolio":"Portfolio","label.valueProposition":"Value Proposition","label.budget":"Budget","label.kpi":"KPI","label.systems":"Systems","label.owner":"Owner","label.theme":"Theme","label.role":"Role","label.rate":"Rate","label.feature":"Feature","label.allocation":"Allocation","label.valueStream":"Value Stream","label.manager":"Manager","label.businessUnit":"Business Unit","label.product":"Product","label.project":"Project","label.productType":"Product Type","label.productCount":"Product Count","label.fyBudget":"FY Budget","label.key":"Key","label.url":"Url","label.account":"Account","label.phone":"Phone","label.email":"Email","label.department":"Department/ Position","label.type":"Type","label.assignee":"Assignee","label.releaseEnv":"Release Environment","label.releaseDate":"Release Date","label.releaseCutoffDate":"Release Cutoff","label.releaseVersion":"Release Version","userInfoModal.header":"User Profile Information","options.lookAndFeelCustomizer":"Customize look and feel","options.action":"Action","projectCostPriority.addProjectCostPriority":"Add Cost Priority","projectCostPriority.saveProjectCostPriority":"Save Cost Priority","projectCostPriority.deleteProjectCostPriority":"Delete Cost Priority","sidebar.projectCostPrioritys":"Cost Priorities","projectBusPriority.addProjectBusPriority":"Add Business Priority","projectBusPriority.saveProjectBusPriority":"Save Business Priority","projectBusPriority.deleteProjectBusPriority":"Delete Business Priority","sidebar.projectBusPrioritys":"Business Priorities","issue.addIssue":"Add Issue","issue.saveIssue":"Save Issue","issue.deleteIssue":"Delete Issue","issue.features":"Features","sidebar.issues":"Issues","product.addProduct":"Add Product","product.saveProduct":"Save Product","product.deleteProduct":"Delete Product","product.valueStreams":"Value Stream","sidebar.products":"Products","initiative.addInitiative":"Add Initiative","initiative.saveInitiative":"Save Initiative","initiative.deleteInitiative":"Delete Initiative","initiative.products":"Products","sidebar.initiatives":"Initiatives","team.addTeam":"Add Team","team.saveTeam":"Save Team","team.deleteTeam":"Delete Team","team.members":"Members","sidebar.teams":"Teams","member.addMember":"Add Member","member.saveMember":"Save Member","member.deleteMember":"Delete Member","sidebar.members":"Members","valueStream.addValueStream":"Add Value Stream","valueStream.saveValueStream":"Save Value Stream","valueStream.deleteValueStream":"Delete Value Stream","valueStream.teams":"Teams","sidebar.valueStreams":"Value Streams","businessUnit.addBusinessUnit":"Add Business Unit","businessUnit.saveBusinessUnit":"Save Business Unit","businessUnit.deleteBusinessUnit":"Delete Business Unit","sidebar.businessUnits":"Business Units","feature.addFeature":"Add Feature","feature.saveFeature":"Save Feature","feature.deleteFeature":"Delete Feature","feature.inwardDependencies":"Blocked by","feature.outwardDependencies":"Is blocking","feature.successIndicators":"Success Indicators","sidebar.features":"Features","portfolio.addPortfolio":"Add Portfolio","portfolio.savePortfolio":"Save Portfolio","portfolio.deletePortfolio":"Delete Portfolio","portfolio.dashboard.valueStreams":"Value Streams","portfolio.dashboard.products":"Products","portfolio.dashboard.initiatives":"Initiatives","portfolio.dashboard.features":"Features","portfolio.dashboard.portfolioViewHeader":"Portfolio View","sidebar.portfolios":"Portfolios","projectPriority.saveProjectPriority":"Save Project Priority","projectPriority.addProjectPriority":"Add Project Priority","projectPriority.deleteProjectPriority":"Delete Project Priority. NOTE - this will remove this priority from all projects.","sidebar.projectPriorities":"Project Priorities","sidebar.globalProjectPriorities":"Global Project Priorities","project.refreshJIRAProjects":"Refresh JIRA Projects","project.importProjects":"Import Projects","project.addDependencies":"Add Dependencies","project.addInwardDependencyModalBodyText":"Select Inward (Blocked By) Dependencies","project.addOutwardDependencyModalBodyText":"Select Outward (Blocks) Dependencies","project.addProject":"Add Project","project.saveProject":"Save Project","project.updateProjectCostPriorities":"Cost Priorities","project.updateProjectBusinessPriorities":"Business Priorities","project.projectIssues":"Issues","project.inwardDependencies":"Blocked by","project.outwardDependencies":"Is blocking","project.projectName":"Project Name","project.projectInitiative":"Project Initiative","project.projectDescription":"Project Description","project.projectWeight":"Project Weight","project.projectBudget":"Project Budget","project.projectBusinessValueIndicator":"Project Business Value","project.busValuePriorities":"Business Value Priorities","project.costImplPriorities":"Cost Implication Priorities","projectIssue.addProjectIssue":"Add Project Issue","projectIssue.saveProjectIssue":"Save Project Issue","projectIssue.deleteProjectIssue":"Delete Project Issue","projectIssue.inwardDependencies":"Blocked by","projectIssue.outwardDependencies":"Is blocking","sidebar.projectIssues":"Project Issues","sidebar.addNewProjectIssue":"Add Non JIRA Issue","sidebar.addNewJiraProjectIssue":"Add JIRA Issue","sidebar.projects":"Projects","sidebar.main":"Main","sidebar.agile.dashboard":"Dashboard","sidebar.agile.dashboards":"Dashboards","sidebar.agile.dashboard.employee":"Employees Dashboard","sidebar.agile.dashboard.organisation":"Organisation Dashboard","sidebar.agile.dashboard.portfolio":"Portfolio Dashboard","orgDashboard.employees":"Employees","orgDashboard.surveys":"Surveys","orgDashboard.editEmployees":"Edit Employees","orgDashboard.editSurveys":"Edit Surveys","orgDashboard.compareSurveys":"Compare Surveys","orgDashboard.activeSurveys":"Active Surveys","orgDashboard.noActiveSurveys":"No Active Surveys","orgDashboard.inActiveSurveys":"Past Surveys","orgDashboard.noInActiveSurveys":"No Past Surveys","orgDashboard.noProjects":"No Projects","orgDashboard.projects":"Projects","orgDashboard.projectList":"Projects (Displaying up to the top 5)","org.saveOrg":"Save Organisation","org.addOrg":"Add Organisation","org.searchOrg":"Search Organisation","sidebar.compareSurveys":"Compare Surveys","sidebar.organisations":"Organisations","sidebar.orgSurvey":"Organisation Survey","orgSurvey.saveOrgSurvey":"Save Org Survey","orgSurvey.addOrgSurvey":"Add Org Survey","orgSurvey.addOrgSurveyStartDate":"Please select a start date","orgSurvey.addOrgSurveyEndDate":"Please select an end date","orgSurvey.searchOrgSurvey":"Search Org Survey","orgEmpSurvey.nextQuestion":"Next","orgEmpSurvey.previousQuestion":"Previous","orgEmpSurvey.saveSurvey":"Save","orgEmpSurvey.answerHeader":"What do you think ?","orgEmpSurvey.saveAndCloseSurvey":"Save and Close Survey","orgEmpSurvey.finaliseSurveyWarning":"Selecting 'YES' will close the survey from further changes. Select 'NO' to return to the survey","orgEmpSurvey.activeSurvey":"Active survey to be completed","orgEmpSurvey.inactiveSurvey":"This survey has been closed - no further changes can be made","sidebar.employees":"Employees","emp.deleteEmp":"Delete Employee","emp.saveEmp":"Save Employee","emp.addEmp":"Add Employee","emp.searchEmp":"Search Employee","emp.dashboard":"Employee Dashboard","sidebar.surveys":"Surveys","sidebar.surveyGroup":"Survey Groups","survey.addSurvey":"Add Survey","surveyGroup.saveSurveyGroup":"Save Survey Group","surveyGroup.addSurveyGroup":"Add Survey Group","surveyGroup.searchSurveyGroup":"Search Survey Group","sidebar.surveyGroupQuestion":"Survey Groups","surveyGroup.saveSurveyGroupQuestion":"Save Survey Group Question","surveyGroup.addSurveyGroupQuestion":"Add Survey Group Question","surveyGroup.searchSurveyGroupQuestion":"Search Survey Group Question","surveyGroupQuestion.addSurveyGroupQuestion":"Add Survey Group Question","engagement.survey.results.expectations":"EXPECTATIONS","engagement.survey.results.comparison":"Comparison of both survey results","engagement.survey.results.top":"Top results","engagement.survey.results.bottom":"Bottom Results","compare.survey.header.message":"Select 2 surveys to compare and then select an option to get the results","security.addSecurity":"Add Security","security.saveSecurity":"Save Security","security.deleteSecurity":"Delete Security","sidebar.securitys":"Securitys","sidebar.lookups":"Lookup Data","sidebar.developer":"Developer","sidebar.superuser.dashboard":"Super User Dashboard - Select an Organisation to edit its details","sidebar.dashboard":"Dashboard","sidebar.dashboard.default":"Default","sidebar.dashboard.ecommerce":"eCommerce","sidebar.dashboard.news":"News","sidebar.dashboard.intranet":"Intranet","sidebar.components":"Components","sidebar.components.alerts":"Alerts","sidebar.components.appbar":"App Bar","sidebar.components.autocomplete":"AutoComplete","sidebar.components.avatars":"Avatars","sidebar.components.badge":"Badge","sidebar.components.bottomNavigation":"Bottom Navigation","sidebar.components.breadcrumbs":"Breadcrumbs","sidebar.components.buttons":"Buttons","sidebar.components.buttonGroup":"Button Group","sidebar.components.cards":"Cards","sidebar.components.carousel":"Carousel","sidebar.components.chips":"Chips","sidebar.components.colorPicker":"Color Picker","sidebar.components.modals":"Modals","sidebar.components.dividers":"Dividers","sidebar.components.expansionPanel":"Expansion Panel","sidebar.components.drawer":"Drawer","sidebar.components.gridList":"Grid List","sidebar.components.lists":"Lists","sidebar.components.menusPaper":"Menus & Paper","sidebar.components.pickers":"Pickers","sidebar.components.popovers":"Popovers","sidebar.components.progress":"Progress","sidebar.components.selects":"Selects","sidebar.components.selectionControl":"Selection Controls","sidebar.components.snackbars":"Snackbars","sidebar.components.stepper":"Stepper","sidebar.components.tables":"Tables","sidebar.components.tabs":"Tabs","sidebar.components.textFields":"Text Fields","sidebar.components.tooltips":"Tooltips","sidebar.components.typography":"Typography","sidebar.widgets":"Widgets","sidebar.metrics":"Metrics","sidebar.view":"View","sidebar.tables":"Tables","sidebar.tables.basicTable":"Basic Table","sidebar.tables.dataTable":"Data Table","sidebar.timeLine":"Time Line","sidebar.timeLine.default":"Default","sidebar.timeLine.defaultwithIcons":"Default with Icons","sidebar.timeLine.leftAligned":"Left Aligned","sidebar.timeLine.zigzag":"Zigzag","sidebar.customViews":"Custom Views","sidebar.customViews.plainListView":"Plain List View","sidebar.customViews.withDivider":"Plain List with Divider","sidebar.customViews.cardListView":"Cards List View","sidebar.form":"Form","sidebar.forms":"Forms","sidebar.forms.components":"Components","sidebar.forms.stepper":"Stepper","sidebar.extensions":"Extensions","sidebar.editors":"Editors","sidebar.editors.CKEditor":"CKEditor","sidebar.editors.WYSISWYGEditor":"WYSISWYG Editor","sidebar.pickers":"Pickers","sidebar.pickers.dateTimePickers":"Date & Time Pickers","sidebar.pickers.colorPickers":"Color Pickers","sidebar.extensions.dragNDrop":"Drag and Drop","sidebar.extensions.dropzone":"Dropzone","sidebar.extensions.sweetAlert":"Sweet Alert","sidebar.extensions.notification":"Notification","sidebar.chart":"Chart","sidebar.chart.line":"Line Chart","sidebar.chart.bar":"Bar Chart","sidebar.chart.area":"Area Chart","sidebar.chart.composed":"Composed Chart","sidebar.chart.scatter":"Scatter Chart","sidebar.chart.pie":"Pie Chart","sidebar.chart.radial":"Radial Chart","sidebar.chart.radar":"Radar Chart","sidebar.chart.tree":"Tree Chart","sidebar.map":"Google Map","sidebar.map.simple":"Simple Map","sidebar.map.styled":"Styled Map","sidebar.map.geoLocation":"Geo Location","sidebar.map.mapDirection":"Map Direction","sidebar.map.overlay":"Map Overlay","sidebar.map.kmLayer":"Map Km Layer","sidebar.map.popupInfo":"Map Popup Info","sidebar.map.trafficLayer":"Map Traffic Layer","sidebar.map.streetView":"Street View","sidebar.map.eventListener":"Event Listener","sidebar.map.mapDrawing":"Map Drawing","sidebar.map.mapClustering":"Map Clustering","sidebar.modules":"Modules","sidebar.calendar":"Calendar","sidebar.calendar.basic":"Basic","sidebar.calendar.cultures":"Cultures","sidebar.calendar.dnd":"Dnd","sidebar.calendar.popup":"Popup","sidebar.calendar.rendering":"Rendering","sidebar.calendar.selectable":"Selectable","sidebar.calendar.timeslots":"Timeslots","sidebar.eCommerce":"eCommerce","sidebar.eCommerce.productsList":"Products List","sidebar.eCommerce.productsGrid":"Products Grid","sidebar.appModule":"App Module","sidebar.appModule.login":"Login Page","sidebar.appModule.login2":"Login Page 2","sidebar.appModule.loginStepper":"Login with Stepper","sidebar.appModule.signup":"Signup Page","sidebar.appModule.signup2":"Signup Page 2","sidebar.appModule.forgotPassword":"Forgot Password","sidebar.appModule.forgotPassword2":"Forgot Password 2","sidebar.appModule.lock":"Lock Screen","sidebar.appModule.lock2":"Lock Screen 2","sidebar.appModule.toDo":"To-Do","sidebar.appModule.toDoRedux":"To-Do Redux","sidebar.appModule.mail":"Mail","sidebar.appModule.mailRedux":"Mail Redux","sidebar.appModule.chat":"Chat","sidebar.appModule.chatRedux":"Chat Redux","sidebar.appModule.contact":"Contact","sidebar.appModule.contactRedux":"Contact Redux","sidebar.extras":"Extras","sidebar.icons":"Icons","sidebar.icons.material":"Google Material Icons","sidebar.extraElements":"Extra Elements","sidebar.extraElements.pricingTable":"Pricing Table","sidebar.extraElements.callouts":"Callouts","sidebar.extraElements.testimonials":"Testimonials","sidebar.extraPages":"Extra Pages","sidebar.extraPages.aboutUs":"About Us","sidebar.extraPages.contactUs":"Contact Us","sidebar.extraPages.blog":"Blog","sidebar.extraPages.faq":"FAQ","sidebar.extraPages.portfolio":"Portfolio","sidebar.extraPages.404":"404 Error Page","sidebar.extraPages.500":"500 Error Page","sidebar.menuLevels":"Menu Levels","sidebar.menuLevels.level1":"Level 1","sidebar.menuLevels.level2":"Level 2","sidebar.menuLevels.level3":"Level 3","appModule.forgotPassword":"Forgot your password?","appModule.dntRememberEmail":"Don't remember your email?","appModule.contactSupport":"Contact Support","appModule.resetPassword":"Reset Password","appModule.enterPasswordUnlock":"Enter your password to unlock the screen!","appModule.unlock":"Unlock","appModule.signInDiffAccount":"Sign in using different account","appModule.rememberMe":"Remember me","appModule.signIn":"Sign In","appModule.requestCode":"Request Code","appModule.resendCode":"Resend Code","appModule.signinInstructions":"A code has been sent to your email. Please enter that code below to continue.","appModule.enterCode":"Enter Code","appModule.next":"Next","appModule.back":"Back","appModule.allStepsCompleted":"All steps completed","appModule.reset":"Reset","appModule.loginSuccessfully":"Login Successfully","appModule.password":"Password","appModule.email":"Email","appModule.username":"Username","appModule.name":"Name","appModule.phone":"Phone","appModule.designation":"Designation","appModule.register":"Register","appModule.hvAccount":"Have an account","appModule.createAccount":"Create an account","chart.area":"Area Graph","chart.bar":"Bar Graph","chart.composed":"Composed Graph","chart.line":"Line Graph","chart.pie":"Pie Graph","chart.radar":"Radar Graph","chart.radial":"Radial Graph","chart.scatter":"Scatter Graph","chart.tree":"Tree Graph","chat.selectUserChat":"Select User to start Chat","chat.selectContactChat":"Select contact to start Chat","chat.chatUser":"Chats","chat.contacts":"Contacts","chat.searchStartNewChat":"Search or start new chat","chat.typeMessage":"Type and hit enter to send message","chat.status":"it's a status....not your diary...","contact.saveContact":"Save Contact","contact.addContact":"Add Contact","contact.searchContact":"Search contact","button.close":"Close","button.modify":"Modify","button.delete":"Delete","button.yesDeleteIt":"Yes, delete it!","button.cancel":"Cancel","button.yes":"Yes","button.no":"No","eCommerce.readMore":"Read More","eCommerce.addToCart":"Add to Cart","eCommerce.buyNow":"Buy now","extension.sweetAlerts":"Sweet Alerts","extension.notification":"Notification","sweetAlerts.basic":"Basic","sweetAlerts.description":"With Description","sweetAlerts.success":"Success","sweetAlerts.warning":"Warning","sweetAlerts.custom":"Custom","sweetAlerts.htmlTag":"Html Tag","sweetAlerts.prompt":"Prompt","sweetAlerts.itsBlue":"It's blue!","sweetAlerts.passwordPrompt":"Password Prompt","sweetAlerts.customStyle":"Custom Style","sweetAlerts.itPretty":"It's pretty, isn't it?","sweetAlerts.btnClicked":"You clicked the button!","sweetAlerts.youWillFind":"You will find they are up!","sweetAlerts.youWillNotAble":"You will not be able to recover this imaginary file!","sweetAlerts.hereIsaMessage":"Here's a message!","sweetAlerts.goodJob":"Good job!","sweetAlerts.yesDeleteIt":"Yes, delete it!","sweetAlerts.areYouSure":"Are you sure?","sweetAlerts.doYouLikeThumb":"Do you like thumbs?","sweetAlerts.anInput":"An input!","sweetAlerts.writeSomethingInteresting":"Write something interesting:","sweetAlerts.writeSomething":"Write something","sweetAlerts.youMustEnterPassword":"You must enter your password!","sweetAlerts.enterPassword":"Enter Password","notification.infoMsg":"Info message","notification.successMessage":"Success message","notification.warningMessage":"Warning message","notification.closeAfter3000ms":"Close after 3000ms","notification.errorMessage":"Error message","notification.titleHere":"Title here","notification.clickMe":"Click me!","notification.info":"Info","notification.success":"Success","notification.warning":"Warning","notification.error":"Error","extraElements.callouts":"Callouts","extraElements.pricingTable":"Pricing Table","extraElements.testimonials":"Testimonials","callouts.viewRange":"View Range","callouts.basic":"Basic","pricingTable.basic":"Basic","pricingTable.circle":"Circle","pricingTable.classic":"Classic","pricingTable.dark":"Dark","pricingTable.personal":"PERSONAL","pricingTable.easyTranslation":"Easy Translation","pricingTable.awesomeGoogleFonts":"Awesome Google Fonts","pricingTable.hotelBookingSystem":"Hotel Booking System","pricingTable.emailComposeInterface":"Email Compose Interface","pricingTable.locationFinderApp":"Location Finder App","pricingTable.buyNow":"buy now","pricingTable.business":"BUSINESS","pricingTable.professional":"PROFESSIONAL","testimonials.basic":"Basic","testimonials.classic":"Classic","testimonials.standard":"Standard","extraPages.goHome":"Go to Home","extraPages.ourClients":"Our Clients","extraPages.all":"All","extraPages.graphicDesign":"graphic design","extraPages.logo":"logo","extraPages.mobileApp":"mobile app","extraPages.web":"web","extraPages.404Msg":"Oops, an error has occurred. Page not found!","extraPages.500Msg":"Sorry, server goes wrong","extraPages.aboutUs.showCase":"Showcase your services here with information about them","aboutUs.readMore":"Read More","extraPages.goSomewhere":"Go somewhere","icon.material":"900+ Official Material Design Icons","mail.mailbox":"Mailbox","mail.compose":"COMPOSE","mail.filters":"Filters","mail.labels":"Labels","picker.color.alpha":"Alpha Pickers","picker.color.hue":"Hue Pickers","picker.color.circle":"Circle Pickers","picker.color.compact":"Compact Pickers","picker.color.block":"Block Pickers","picker.color.chrome":"Chrome Pickers","picker.color.github":"Github Pickers","picker.color.twitter":"Twitter Pickers","picker.color.withRedux":"With Redux","picker.color.sketch":"Sketch Pickers","picker.color.material":"Material Pickers","picker.color.slider":"Slider Pickers","picker.color.basic":"Basic Pickers","picker.color.basicToggle":"Basic Toggle","picker.color.custom":"Custom Pickers","picker.color.customPointer":"Custom Pointer","picker.color.photoshop":"Photoshop Pickers","picker.color.swatches":"Swatches Pickers","picker.color.basicPositioning":"Basic Positioning","picker.date.pickers":"Pickers","picker.date.toggle":"Toggle Pickers","picker.date.input":"Input Field Picker","picker.date.localization":"Localization Pickers","picker.date.basic":"Basic Picker","picker.date.selectDay":"Select Day","table.marketingCampaign":"Marketing Campaign","table.thisWeek":"This Week","table.defaultSorting":"Default Sorting","table.customSorting":"Custom Sorting","table.editableContent":"Editable Content","table.customFilter":"Custom Filter","table.recentOrders":"Recent Orders","table.dataTable":"Data Table","table.basicTable":"Basic Table","table.application":"Application Table","todo":"To-Do","todo.addTask":"ADD TASK","todo.all":"All","todo.filters":"Filters","todo.labels":"Labels","dashboard.nextBestActions":"Next Best Actions","dashboard.numberOfInactiveSurveys":"Number of Inactive Surveys","dashboard.numberOfActiveSurveys":"Number of Active Surveys","dashboard.numberOfProjects":"Number of Projects","dashboard.currentOrganisation":"Your Organisation","dashboard.gotoQuestion":"Go directly to a question","dashboard.recentActivities":"Recent Activities","dashboard.gotoQuestionSubHeading":"Go directly to a question","dashboard.currentProjects":"Current Projects List","dashboard.toDoItems":"To-do Items List","dashboard.today":"Today","dashboard.marketingCampaign":"Marketing Campaign","dashboard.yourDailyFeed":"Your Daily Feed","dashboard.googleInsight":"Google insight score","dashboard.lastCalculated":"Last calculated 1 month ago","dashboard.refresh":"Refresh","dashboard.upgradeToday":"Download v 3.0","dashboard.onlineSignups":"Online Signups","dashboard.lastMonthSale":"Last Month Sale","dashboard.newVisits":"New Visits this month","dashboard.totalRevenue":"Total Revenue this year","dashboard.latestPosts":"Latest Posts","dashboard.loremIpsum":"Lorem ipsum is dummy content dollar sit is...","dashboard.viewAllPosts":"VIEW ALL POSTS","dashboard.popularProducts":"Popular Products","dashboard.popularProductsTxt":"It is a long established fact that a reader will be distracted by the readable content..","dashboard.allProducts":"all products","dashboard.userStatstics":"User Statstics","dashboard.orders":"Orders","dashboard.thisYearSaleReport":"This Year Sale Report","dashboard.post9MonthData":"Post 9 month data","dashboard.newCustomers":"New Customers","dashboard.newThisMonth":"32 new this Month","dashboard.monthly":"Monthly","dashboard.totalView":"Total View","dashboard.annual":"Annual","dashboard.newOrder":"New order","dashboard.visited":"Visited","dashboard.rapidPace":"Rapid pace","dashboard.slowPace":"Slow pace","dashboard.newConnections":"New Connections","dashboard.thisWeek":"3 This week","dashboard.newFeed":"23 New Feeds","dashboard.newSubscriber":"New Subscriber","dashboard.newArticles":"New Articles","dashboard.newAuthors":"New Authors","dashboard.avgDailyTraffic":"Avg Daily Traffic","dashboard.popularAuthors":"Popular Authors","dashboard.authorsWith":"Authors With 500+ avg. view","dashboard.popularArticles":"Popular Articles","dashboard.comments":"Comments","component.alert.default":"Default Alerts","component.alert.highlighted":"Highlighted Alerts","component.alert.dismissible":"Dismissible Alerts","component.alert.withIcons":"Alerts With Icons","component.alert.withDetailedHTML":"Alert With Detailed HTML","component.appbar.simple":"Simple App bar","component.appbar.colored":"Colored App bar","component.appbar.fullyFeatured":"Fully Featured App bar","component.autocomplete.Basic":"Basic","component.autocomplete.controlinSelection":"Control Selection","component.autocomplete.Behaviors":"Behaviors","component.autocomplete.inputSize":"Input Size","component.autocomplete.menuAlign":"Menu Align","component.avatars.image":"Image Avatars","component.avatars.letter":"Letter Avatars","component.avatars.icon":"Icon Avatars","component.badge.scaling":"Scaling Badges","component.badge.insideLinks":"Inside Links & Butons","component.badge.contextual":"Contextual variations","component.badge.pill":"Pill Badges","component.badge.link":"Link Badges","component.bottomNavigation.withLabels":"Bottom Navigation with labels","component.bottomNavigation.withActiveLabels":"Bottom Navigation With Active Label","component.bottomNavigation.withNoLabels":"Bottom Navigation with No Label","component.breadcrumbs.simple":"Simple","component.breadcrumbs.noList":"No list","component.buttons.colorScheme":"Color Scheme","component.buttons.colorSchemeTxt":"Bootstrap Color Scheme With Material Concept","component.buttons.icon":"Icon Buttons","component.buttons.iconTxt":"You can pick any icon from the font-icons listed under Icons page. Or feel free to add any new font icons and use that.","component.buttons.differentSizes":"Different Sizes","component.buttons.differentSizesTxt":"Material buttons with different sizes","component.buttons.flatFullWidth":"Flat & Full Width Buttons","component.buttons.flatFullWidthTxt":"All type buttons with disabled states","component.buttons.raised":"Raised Buttons","component.buttons.raisedTxt":"Bootstrap Color Scheme With Material Concept","component.buttons.fab":"Floating Action Buttons","component.buttons.fabTxt":"Bootstrap Color Scheme With Material Concept","component.buttons.socialMedia":"Social Media Buttons","component.buttons.socialMediaTxt":"Various social media buttons for your project","component.buttons.complex":"Complex Buttons","component.buttonGroup.horizontalVariations":"Horizontal Variations","component.buttonGroup.defaultStyle":"Default buttons group style","component.buttonGroup.highlightedStyle":"Highlighted button group style","component.buttonGroup.flatStyle":"Flat button group style","component.buttonGroup.default":"Default Button Group","component.buttonGroup.flat":"Flat Button Group","component.buttonGroup.highlighted":"Highlighted Button Group","component.buttonGroup.icon":"Icon Button Group","component.buttonGroup.iconFlat":"Icon Flat Button Group","component.buttonGroup.nested":"Nested Button Group","component.cards.basic":"Basic Cards","component.cards.special":"Special Cards","component.cards.withHeader":"Cards with Header, Footer and Alignment","component.cards.navigational":"Navigational Cards","component.cards.image":"Image Cards","component.cards.solid":"Solid Cards","component.carousel.basic":"Basic Carousel","component.carousel.basicTxt":"Basic BS4 Carousel Powered With ReactStrap","component.carousel.product":"Product Carousel","component.carousel.productTxt":"A Horizontal Grid View Carousel","component.carousel.testimonial":"Testimonial Carousel","component.carousel.testimonialTxt":"One item carousel at a time","component.chips.default":"Default Chip","component.chips.outline":"Outline Chip","component.chips.chipWithText":"Chip With Text Avatar","component.chips.clickable":"Clickable Chip","component.chips.withImage":"Chip With Image Avatar","component.chips.deletable":"Deletable Chip","component.chips.withIcon":"Chip With Icon Avatar","component.chips.custom":"Custom Clickable Chip","component.chips.array":"Chip Array","component.chips.withInput":"Chips Implementation With Input Box","component.dividers.list":"List Dividers","component.dividers.inset":"Inset Dividers","component.dividers.default":"Default","component.drawer.persistent":"Persistent Drawer","component.drawer.permanent":"Permanent Drawer","component.drawer.mini":"Mini Drawer","component.drawer.responsive":"Responsive Drawer","component.expansionPanel.simple":"Simple Expansion Panel","component.expansionPanel.nested":"Nested Expansion Panel","component.gridList.image":"Image-only Grid list","component.gridList.advanced":"Advanced Grid list","component.gridList.singleLine":"Single line Grid list","component.gridList.withTitlebars":"Grid list with titlebars","component.lists.folder":"Folder List","component.lists.switch":"Switch List Controls","component.lists.dividers":"List Dividers","component.lists.simple":"Simple List","component.lists.inset":"Inset List","component.lists.nested":"Nested List","component.lists.checkbox":"Checkbox Secondary List Controls","component.lists.checkboxControls":"Checkbox List Controls","component.lists.pinned":"Pinned Subheader List","component.lists.interactive":"Interactive List Controls","component.chips":"Recent","component.menusPaper.simple":"Simple menus","component.menusPaper.withIcon":"Menu With Icon","component.menusPaper.withMoreButton":"Menu with More Button","component.menusPaper.withSelectedValue":"Menu With Selected Value","component.menusPaper.paper":"Paper","component.pickers.Date":"Date pickers","component.progress.indeterminateCircular":"Indeterminate Circular","component.progress.animatedProgress":"Animated Progress","component.progress.simpleProgress":"Simple Progress","component.progress.colorVariants":"Color Variants","component.progress.labelsProgress":"Labels Progress","component.progress.multipleProgress":"Multiple Progress","component.progress.interactiveIntegration":"Interactive Integration","component.progress.stripedProgress":"Striped Progress","component.selectionControl.checkboxes":"Checkboxes","component.selectionControl.disabled":"Disabled","component.selectionControl.intermediate":"Intermediate","component.selectionControl.checkboxesWithForm":"Checkboxes with Form Group","component.selectionControl.basicRadio":"Basic Radio Buttons","component.selectionControl.disabledRadio":"Disabled Radio Buttons","component.selectionControl.withError":"With Error Message","component.selectionControl.switches":"Switches","component.selectionControl.verticalSwitches":"Vertical Switches","component.selectionControl.groupedSwitches":"Grouped Switches","component.selectionControl.verticalImplementation":"Vertical implementation of switches","component.selectionControl.generalSettings":"General Settings","component.selectionControl.themeSettings":"Theme Settings","component.selectionControl.onOffSwitches":"on/off switches","component.selectionControl.verticalInlineRadio":"Vertical and Inline radio buttons","component.selectionControl.checkboxesWithFormTxt":"Menus are positioned over their emitting elements such that the currently selected menu item appears on top of the emitting element.","component.selects.simple":"Basic","component.selects.native":"Modifier","component.selects.multiple":"Direction","component.selects.dialog":"Size","component.selects.select":"Select","component.snackbars.transition":"Transition Control Direction","component.snackbars.simple":"Simple","component.snackbars.positioned":"Positioned","component.snackbars.messageWithButton":"Message With Button","component.snackbars.colors":"Colors","component.snackbars.multilineText":"Multiline Text","component.snackbars.onlyMessage":"Only Message","component.snackbars.withIconButton":"Message with IconButton","component.stepper.horizontalLinear":"Horizontal Linear","component.stepper.horizontalLinearAlternativeLabel":"Horizontal Linear - Alternative Label","component.stepper.vertical":"Vertical Stepper","component.stepper.horizontalNonLinear":"Horizontal Non-linear","component.stepper.horizontalNonLinearAlternativeLabel":"Horizontal Non Linear - Alternative Label","component.stepper.mobileDots":"Mobile Stepper - Dots","component.stepper.mobileProgress":"Mobile Stepper - Progress","component.stepper.mobileText":"Mobile Stepper - Text","component.tabs.basic":"Basic Tabs","component.tabs.fixed":"Fixed Tabs Full width","component.tabs.icon":"Icon Tabs","component.tabs.disabled":"Disabled Tab","component.tabs.wrappedLabels":"Wrapped Labels","component.tabs.iconWithLabel":"Icon Tabs with Label","component.tabs.fixedCentered":"Fixed Tabs Centered","component.tabs.automaticScroll":"Automatic Scroll Buttons","component.tabs.forcedScroll":"Forced Scroll Buttons","component.tabs.preventScroll":"Prevent Scroll Buttons","component.textFields.textfield":"TextField","component.textFields.components":"Components","component.textFields.layout":"Layout","component.textFields.inputAdornments":"Input Adornments","component.textFields.formattedInputs":"Formatted Inputs","component.textFields.inputs":"Inputs","component.tooltips.avatar":"Avatar Tooltip","component.tooltips.button":"Button Tooltip","component.tooltips.icon":"Icon Tooltip","component.tooltips.controlled":"Controlled Tooltip","component.tooltips.positioned":"Positioned Tooltip","component.typography.lightHeadings":"Light Headings","component.typography.normalHeadings":"Normal Headings","component.typography.semiBoldHeadings":"Semi-bold Headings","component.typography.boldHeadings":"Bold Headings","component.typography.paragraphText":"Paragraph Text","component.typography.leadParagraphText":"Lead Paragraph Text","component.typography.unstyledList":"Unstyled List","component.typography.orderedList":"Ordered List","component.typography.unorderedList":"Unordered List","component.typography.listWithIcons":"List With Icons","component.typography.compactList":"Compact List","component.typography.extendedList":"Extended List","component.typography.leftIconGroupedList":"Left Icon Grouped List","component.typography.rightIconGroupedList":"Right Icon Grouped List","component.typography.badgesGroupedList":"Badges Grouped List","component.typography.defaultDescriptionList":"Default Description List","component.typography.evenOddDescriptionList":"Even-Odd Description List","component.typography.leftBlockquoteWithAuthorAvatar":"Left Blockquote With Author Avatar","component.typography.rightBlockquoteWithAuthorAvatar":"Right Blockquote With Author Avatar","signIn.success":"Login successfully!","signIn.error":"Invalid email or password!","signUp.success":"Account successfully created","signUp.error":"Right","signIn.signUp":"Create an account","signIn.connectWith":"or connect with","signUp.alreadyMember":"I am already a member","appModule.signin":"Sign In","appModule.signup":"Sign Up","pages.samplePage":"Sample Page","pages.samplePage.description":"Start building your app. Happy Coding!","mailNotification.title":"Messages","appNotification.title":" Notifications","mailNotification.message":" No new messages as of now!","appNotification.message":"No notifications as of now!","popup.profile":"Profile","popup.setting":"Setting","popup.logout":"Logout","popup.updateData":"Update Data","popup.detailedLog":"Detailed Log","popup.statistics":"Statistics","popup.clearData":"Clear Data","component.selectionControl.radioBtnGroup":"Radio Buttons Group","component.popover.anchorPlayground":"Anchor Playground"}

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _zh = _interopRequireDefault(__webpack_require__(1321));

var _zhHans = _interopRequireDefault(__webpack_require__(1322));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ZhLan = {
  messages: _objectSpread({}, _zhHans["default"]),
  locale: 'zh-Hans-CN',
  data: _zh["default"]
};
var _default = ZhLan;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ZhLan, "ZhLan", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/zh-Hans-CN.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/zh-Hans-CN.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_zh, "_zh", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/zh-Hans-CN.js");

  __REACT_HOT_LOADER__.register(_zhHans, "_zhHans", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/zh-Hans-CN.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/zh-Hans-CN.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/zh-Hans-CN.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/zh-Hans-CN.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/zh-Hans-CN.js");

  __REACT_HOT_LOADER__.register(ZhLan, "ZhLan", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/zh-Hans-CN.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/zh-Hans-CN.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/zh-Hans-CN.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/zh-Hans-CN.js");
}();

;

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.zh=t())}(this,function(){"use strict";return[{locale:"zh",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},"day-short":{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},"hour-short":{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},"minute-short":{displayName:"分",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒钟后"},past:{other:"{0}秒钟前"}}},"second-short":{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hans",parentLocale:"zh"},{locale:"zh-Hans-HK",parentLocale:"zh-Hans",fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},"day-short":{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},"hour-short":{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},"minute-short":{displayName:"分",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}},"second-short":{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hans-MO",parentLocale:"zh-Hans",fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},"day-short":{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},"hour-short":{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},"minute-short":{displayName:"分",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}},"second-short":{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hans-SG",parentLocale:"zh-Hans",fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},"day-short":{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},"hour-short":{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},"minute-short":{displayName:"分",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}},"second-short":{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hant",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下個月","-1":"上個月"},relativeTime:{future:{other:"{0} 個月後"},past:{other:"{0} 個月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下個月","-1":"上個月"},relativeTime:{future:{other:"{0} 個月後"},past:{other:"{0} 個月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"後天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0} 天後"},past:{other:"{0} 天前"}}},"day-short":{displayName:"日",relative:{0:"今天",1:"明天",2:"後天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0} 天後"},past:{other:"{0} 天前"}}},hour:{displayName:"小時",relative:{0:"這一小時"},relativeTime:{future:{other:"{0} 小時後"},past:{other:"{0} 小時前"}}},"hour-short":{displayName:"小時",relative:{0:"這一小時"},relativeTime:{future:{other:"{0} 小時後"},past:{other:"{0} 小時前"}}},minute:{displayName:"分鐘",relative:{0:"這一分鐘"},relativeTime:{future:{other:"{0} 分鐘後"},past:{other:"{0} 分鐘前"}}},"minute-short":{displayName:"分鐘",relative:{0:"這一分鐘"},relativeTime:{future:{other:"{0} 分鐘後"},past:{other:"{0} 分鐘前"}}},second:{displayName:"秒",relative:{0:"現在"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}},"second-short":{displayName:"秒",relative:{0:"現在"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}}}},{locale:"zh-Hant-HK",parentLocale:"zh-Hant",fields:{year:{displayName:"年",relative:{0:"今年",1:"下年","-1":"上年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"下年","-1":"上年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下個月","-1":"上個月"},relativeTime:{future:{other:"{0} 個月後"},past:{other:"{0} 個月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下個月","-1":"上個月"},relativeTime:{future:{other:"{0} 個月後"},past:{other:"{0} 個月前"}}},day:{displayName:"日",relative:{0:"今日",1:"明日",2:"後日","-2":"前日","-1":"昨日"},relativeTime:{future:{other:"{0} 日後"},past:{other:"{0} 日前"}}},"day-short":{displayName:"日",relative:{0:"今日",1:"明日",2:"後日","-2":"前日","-1":"昨日"},relativeTime:{future:{other:"{0} 日後"},past:{other:"{0} 日前"}}},hour:{displayName:"小時",relative:{0:"這個小時"},relativeTime:{future:{other:"{0} 小時後"},past:{other:"{0} 小時前"}}},"hour-short":{displayName:"小時",relative:{0:"這個小時"},relativeTime:{future:{other:"{0} 小時後"},past:{other:"{0} 小時前"}}},minute:{displayName:"分鐘",relative:{0:"這分鐘"},relativeTime:{future:{other:"{0} 分鐘後"},past:{other:"{0} 分鐘前"}}},"minute-short":{displayName:"分鐘",relative:{0:"這分鐘"},relativeTime:{future:{other:"{0} 分鐘後"},past:{other:"{0} 分鐘前"}}},second:{displayName:"秒",relative:{0:"現在"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}},"second-short":{displayName:"秒",relative:{0:"現在"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}}}},{locale:"zh-Hant-MO",parentLocale:"zh-Hant-HK"}]});


/***/ }),
/* 1322 */
/***/ (function(module, exports) {

module.exports = {"sidebar.main":"主要","sidebar.dashboard":"仪表板","sidebar.dashboard.default":"默认","sidebar.dashboard.ecommerce":"电子商务","sidebar.dashboard.news":"新闻","sidebar.dashboard.intranet":"内部网","sidebar.components":"组件","sidebar.components.alerts":"警报","sidebar.components.appbar":"应用程序栏","sidebar.components.autocomplete":"自动完成","sidebar.components.avatars":"头像","sidebar.components.badge":"徽章","sidebar.components.bottomNavigation":"底部导航","sidebar.components.breadcrumbs":"面包屑","sidebar.components.buttons":"纽扣","sidebar.components.buttonGroup":"按钮组","sidebar.components.cards":"牌","sidebar.components.carousel":"圆盘传送带","sidebar.components.chips":"芯片","sidebar.components.colorPicker":"选色器","sidebar.components.modals":"情态动词","sidebar.components.dividers":"分频器","sidebar.components.expansionPanel":"扩展面板","sidebar.components.drawer":"抽屉","sidebar.components.gridList":"网格列表","sidebar.components.lists":"清单","sidebar.components.menusPaper":"菜单和纸张","sidebar.components.pickers":"拾荒者","sidebar.components.popovers":"约夏克布丁","sidebar.components.progress":"进展","sidebar.components.selects":"选择","sidebar.components.selectionControl":"选择控件","sidebar.components.snackbars":"小吃店","sidebar.components.stepper":"步进","sidebar.components.tables":"表","sidebar.components.tabs":"标签","sidebar.components.textFields":"文本字段","sidebar.components.tooltips":"提示","sidebar.components.typography":"活版印刷","sidebar.widgets":"小工具","sidebar.metrics":"度量","sidebar.view":"视图","sidebar.tables":"表","sidebar.tables.basicTable":"基本表","sidebar.tables.dataTable":"数据表","sidebar.timeLine":"时间线","sidebar.timeLine.default":"默认","sidebar.timeLine.defaultwithIcons":"默认使用图标","sidebar.timeLine.leftAligned":"左对齐","sidebar.timeLine.zigzag":"蜿蜒","sidebar.customViews":"自定义视图","sidebar.customViews.plainListView":"普通列表视图","sidebar.customViews.withDivider":"带分隔线的普通列表","sidebar.customViews.cardListView":"卡列表视图","sidebar.form":"形成","sidebar.forms":"形式","sidebar.forms.components":"组件","sidebar.forms.stepper":"步进","sidebar.extensions":"扩展","sidebar.editors":"编者","sidebar.editors.CKEditor":"CK编辑的","sidebar.editors.WYSISWYGEditor":"所见即所得的编辑器","sidebar.pickers":"拾荒者","sidebar.pickers.dateTimePickers":"日期和时间选择器","sidebar.pickers.colorPickers":"颜色选择器","sidebar.extensions.dragNDrop":"拖放","sidebar.extensions.dropzone":"拖放区","sidebar.extensions.sweetAlert":"甜蜜警报","sidebar.extensions.notification":"通知","sidebar.chart":"图表","sidebar.chart.line":"折线图","sidebar.chart.bar":"条形图","sidebar.chart.area":"面积图","sidebar.chart.composed":"组成图表","sidebar.chart.scatter":"散点图","sidebar.chart.pie":"饼形图","sidebar.chart.radial":"径向图","sidebar.chart.radar":"雷达图","sidebar.chart.tree":"树图","sidebar.map":"谷歌地图","sidebar.map.simple":"简单的地图","sidebar.map.styled":"风格地图","sidebar.map.geoLocation":"地理位置","sidebar.map.mapDirection":"地图方向","sidebar.map.overlay":"地图覆盖","sidebar.map.kmLayer":"地图Km层","sidebar.map.popupInfo":"地图弹出信息","sidebar.map.trafficLayer":"映射流量层","sidebar.map.streetView":"街景","sidebar.map.eventListener":"事件监听器","sidebar.map.mapDrawing":"地图绘制","sidebar.map.mapClustering":"地图集群","sidebar.modules":"模块","sidebar.calendar":"日历","sidebar.calendar.basic":"基本","sidebar.calendar.cultures":"文化","sidebar.calendar.dnd":"DND","sidebar.calendar.popup":"弹出","sidebar.calendar.rendering":"渲染","sidebar.calendar.selectable":"可选","sidebar.calendar.timeslots":"时隙","sidebar.eCommerce":"电子商务","sidebar.eCommerce.productsList":"产品列表","sidebar.eCommerce.productsGrid":"产品网格","sidebar.appModule":"App模块","sidebar.appModule.login":"登录页面","sidebar.appModule.login2":"登录页面2","sidebar.appModule.loginStepper":"用步进器登录","sidebar.appModule.signup":"注册页面","sidebar.appModule.signup2":"注册第页","sidebar.appModule.forgotPassword":"忘记密码","sidebar.appModule.forgotPassword2":"忘记密码2","sidebar.appModule.lock":"锁屏","sidebar.appModule.lock2":"锁屏2","sidebar.appModule.toDo":"去做","sidebar.appModule.toDoRedux":"待办事项终极版","sidebar.appModule.mail":"邮件","sidebar.appModule.mailRedux":"邮件终极版","sidebar.appModule.chat":"聊","sidebar.appModule.chatRedux":"聊天终极版","sidebar.appModule.contact":"联系","sidebar.appModule.contactRedux":"联系终极版","sidebar.extras":"附加功能","sidebar.icons":"图标","sidebar.icons.material":"谷歌材料图标","sidebar.extraElements":"额外的元素","sidebar.extraElements.pricingTable":"定价表","sidebar.extraElements.callouts":"标注","sidebar.extraElements.testimonials":"褒奖","sidebar.extraPages":"额外页面","sidebar.extraPages.aboutUs":"关于我们","sidebar.extraPages.contactUs":"联系我们","sidebar.extraPages.blog":"博客","sidebar.extraPages.faq":"常问问题","sidebar.extraPages.portfolio":"投资组合","sidebar.extraPages.404":"404错误页面","sidebar.extraPages.500":"500错误页面","sidebar.menuLevels":"菜单级别","sidebar.menuLevels.level1":"1级","sidebar.menuLevels.level2":"2级","sidebar.menuLevels.level3":"3级","appModule.forgotPassword":"忘记密码了吗？","appModule.dntRememberEmail":"不记得你的电子邮件？","appModule.contactSupport":"联系支持","appModule.resetPassword":"重设密码","appModule.enterPasswordUnlock":"输入您的密码解锁屏幕！","appModule.unlock":"开锁","appModule.signInDiffAccount":"使用其他帐户登录","appModule.rememberMe":"记住我","appModule.signIn":"签到","appModule.next":"下一个","appModule.back":"背部","appModule.allStepsCompleted":"所有步骤完成","appModule.reset":"重启","appModule.loginSuccessfully":"成功登录","appModule.password":"密码","appModule.email":"电子邮件","appModule.name":"名称","appModule.phone":"电话","appModule.designation":"指定","appModule.regsiter":"寄存器","appModule.hvAccount":"有一个账户","appModule.createAccount":"创建一个帐户","chart.area":"面积图","chart.bar":"条状图","chart.composed":"组合图","chart.line":"线形图","chart.pie":"饼图","chart.radar":"雷达图","chart.radial":"径向图","chart.scatter":"散点图","chart.tree":"树图","chat.selectUserChat":"选择用户开始聊天","chat.selectContactChat":"选择联系人即可开始聊天","chat.chatUser":"聊天","chat.contacts":"往来","chat.searchStartNewChat":"搜索或开始新的聊天","chat.typeMessage":"键入并按回车键发送消息","chat.status":"这是一个地位....不是你的日记...","contact.saveContact":"保存联系人","contact.addContact":"增加联系人","contact.searchContact":"搜索联系人","button.modify":"修改","button.delete":"删除","button.yes":"是","button.no":"没有","eCommerce.readMore":"阅读更多","eCommerce.addToCart":"添加到购物车","eCommerce.buyNow":"立即购买","extension.sweetAlerts":"甜蜜警报","extension.notification":"通知","sweetAlerts.basic":"基本","sweetAlerts.description":"带说明","sweetAlerts.success":"成功","sweetAlerts.warning":"警告","sweetAlerts.custom":"习惯","sweetAlerts.htmlTag":"HTML标记","sweetAlerts.prompt":"提示","sweetAlerts.itsBlue":"它是蓝色的！","sweetAlerts.passwordPrompt":"密码提示","sweetAlerts.customStyle":"自定义样式","sweetAlerts.itPretty":"真漂亮，不是吗？","sweetAlerts.btnClicked":"你点击了按钮！","sweetAlerts.youWillFind":"你会发现他们已经起来了！","sweetAlerts.youWillNotAble":"你将无法恢复这个虚构的文件！","sweetAlerts.hereIsaMessage":"这是一条消息！","sweetAlerts.goodJob":"做得好！","sweetAlerts.yesDeleteIt":"是的，删除它！","sweetAlerts.areYouSure":"你确定？","sweetAlerts.doYouLikeThumb":"你喜欢大拇指吗？","sweetAlerts.anInput":"一个输入！","sweetAlerts.writeSomethingInteresting":"写点有趣的东西：","sweetAlerts.writeSomething":"写一些东西","sweetAlerts.youMustEnterPassword":"你必须输入你的密码！","sweetAlerts.enterPassword":"输入密码","notification.infoMsg":"信息消息","notification.successMessage":"成功消息","notification.warningMessage":"警告信息","notification.closeAfter3000ms":"3000ms后关闭","notification.errorMessage":"错误信息","notification.titleHere":"标题在这里","notification.clickMe":"点击我！","notification.info":"信息","notification.success":"成功","notification.warning":"警告","notification.error":"错误","extraElements.callouts":"标注","extraElements.pricingTable":"定价表","extraElements.testimonials":"褒奖","callouts.viewRange":"查看范围","callouts.basic":"基本","pricingTable.basic":"基本","pricingTable.circle":"圈","pricingTable.classic":"经典","pricingTable.dark":"黑暗","pricingTable.personal":"个人","pricingTable.easyTranslation":"易于翻译","pricingTable.awesomeGoogleFonts":"令人敬畏的Google字体","pricingTable.hotelBookingSystem":"酒店预订系统","pricingTable.emailComposeInterface":"电子邮件撰写界面","pricingTable.locationFinderApp":"位置搜索器应用程序","pricingTable.buyNow":"立即购买","pricingTable.business":"商业","pricingTable.professional":"专业的","testimonials.basic":"基本","testimonials.classic":"经典","testimonials.standard":"标准","extraPages.goHome":"回家","extraPages.ourClients":"我们的客户","extraPages.all":"所有","extraPages.graphicDesign":"平面设计","extraPages.logo":"商标","extraPages.mobileApp":"移动应用","extraPages.web":"卷筒纸","extraPages.404Msg":"糟糕，发生错误。 找不到网页！","extraPages.500Msg":"对不起，服务器出错了","extraPages.aboutUs.showCase":"在这里展示您的服务并提供关于它们的信息","aboutUs.readMore":"阅读更多","extraPages.goSomewhere":"去一个地方","icon.material":"900+正式材料设计图标","mail.mailbox":"邮箱","mail.compose":"撰写","mail.filters":"过滤器","mail.labels":"标签","picker.color.alpha":"阿尔法挑选者","picker.color.hue":"色相选择器","picker.color.circle":"圈选手","picker.color.compact":"紧凑型拾取器","picker.color.block":"块挑选器","picker.color.chrome":"铬挑选器","picker.color.github":"Github捡拾器","picker.color.twitter":"推特挑选者","picker.color.withRedux":"与终极版","picker.color.sketch":"素描选择器","picker.color.material":"材料捡拾器","picker.color.slider":"滑块挑选器","picker.color.basic":"基本拾取器","picker.color.basicToggle":"基本切换","picker.color.custom":"自定义选取器","picker.color.customPointer":"自定义指针","picker.color.photoshop":"Photoshop的选择","picker.color.swatches":"色板拾取器","picker.color.basicPositioning":"基本定位","picker.date.pickers":"拾荒者","picker.date.toggle":"切换选取器","picker.date.input":"输入字段选择器","picker.date.localization":"本地化采集器","picker.date.basic":"基本选取器","picker.date.selectDay":"选择日","table.marketingCampaign":"营销活动","table.thisWeek":"本星期","table.defaultSorting":"默认排序","table.customSorting":"自定义排序","table.editableContent":"可编辑的内容","table.customFilter":"定制过滤器","table.recentOrders":"最近的订单","table.dataTable":"数据表","table.basicTable":"基本表","table.application":"应用程序表","todo":"去做","todo.addTask":"添加任务","todo.all":"所有","todo.filters":"过滤器","todo.labels":"标签","dashboard.recentActivities":"近期活动","dashboard.lastActivity":"最后的活动是2天前","dashboard.currentProjects":"当前项目列表","dashboard.toDoItems":"待办事项列表","dashboard.today":"今天","dashboard.marketingCampaign":"营销活动","dashboard.yourDailyFeed":"您的每日饲料","dashboard.googleInsight":"Google洞察分数","dashboard.lastCalculated":"拉斯维加斯计算1个月前","dashboard.refresh":"刷新","dashboard.upgradeToday":"今日更新","dashboard.onlineSignups":"在线注册","dashboard.lastMonthSale":"上个月销售","dashboard.newVisits":"本月新访问","dashboard.totalRevenue":"今年的总收入","dashboard.latestPosts":"最新帖子","dashboard.loremIpsum":"Lorem ipsum是虚拟内容美元坐是...","dashboard.viewAllPosts":"查看所有帖子","dashboard.popularProducts":"热门产品","dashboard.popularProductsTxt":"这是一个长期以来确定的事实，读者会被可读内容分心。","dashboard.allProducts":"所有产品","dashboard.userStatstics":"用户统计","dashboard.orders":"命令","dashboard.thisYearSaleReport":"今年的销售报告","dashboard.post9MonthData":"发布9个月的数据","dashboard.newCustomers":"新客户","dashboard.newThisMonth":"本月32新","dashboard.monthly":"每月一次","dashboard.totalView":"总观点","dashboard.annual":"全年","dashboard.newOrder":"新命令","dashboard.visited":"访问","dashboard.rapidPace":"急速","dashboard.slowPace":"慢节奏","dashboard.newConnections":"新的连接","dashboard.thisWeek":"3本周","dashboard.newFeed":"23个新资讯提供","dashboard.newSubscriber":"新用户","dashboard.newArticles":"新文章","dashboard.newAuthors":"新作者","dashboard.avgDailyTraffic":"平均每日流量","dashboard.popularAuthors":"流行的作者","dashboard.authorsWith":"作者500+平均。 视图","dashboard.popularArticles":"热门文章","dashboard.comments":"注释","component.alert.default":"默认警报","component.alert.highlighted":"突出显示的提醒","component.alert.dismissible":"可接受的警报","component.alert.withIcons":"与图标的警报","component.alert.withDetailedHTML":"警报与详细的HTML","component.appbar.simple":"简单的应用栏","component.appbar.colored":"彩色的应用栏","component.appbar.fullyFeatured":"全功能应用程序栏","component.autocomplete.Basic":"基本","component.autocomplete.controlinSelection":"控制选择","component.autocomplete.Behaviors":"行为","component.autocomplete.inputSize":"输入大小","component.autocomplete.menuAlign":"菜单对齐","component.avatars.image":"图像头像","component.avatars.letter":"信头像","component.avatars.icon":"图标头像","component.badge.scaling":"缩放徽章","component.badge.insideLinks":"内部链接和按钮","component.badge.contextual":"环境变化","component.badge.pill":"丸徽章","component.badge.link":"链接徽章","component.bottomNavigation.withLabels":"底部导航与标签","component.bottomNavigation.withActiveLabels":"带有活动标签的底部导航","component.bottomNavigation.withNoLabels":"底部导航没有标签","component.breadcrumbs.simple":"简单","component.breadcrumbs.noList":"没有名单","component.buttons.colorScheme":"配色方案","component.buttons.colorSchemeTxt":"带材料概念的Bootstrap配色方案","component.buttons.icon":"图标按钮","component.buttons.iconTxt":"您可以从图标页面下列出的字体图标中选取任何图标。 或者随意添加任何新的字体图标并使用它。","component.buttons.differentSizes":"不同的尺寸","component.buttons.differentSizesTxt":"材质按钮大小不同","component.buttons.flatFullWidth":"平面和全宽度按钮","component.buttons.flatFullWidthTxt":"所有类型的按钮具有禁用状态","component.buttons.raised":"凸起的按钮","component.buttons.raisedTxt":"带材料概念的Bootstrap配色方案","component.buttons.fab":"浮动操作按钮","component.buttons.fabTxt":"带材料概念的Bootstrap配色方案","component.buttons.socialMedia":"社交媒体按钮","component.buttons.socialMediaTxt":"您的项目的各种社交媒体按钮","component.buttons.complex":"复杂的按钮","component.buttonGroup.horizontalVariations":"水平变化","component.buttonGroup.defaultStyle":"默认按钮组风格","component.buttonGroup.highlightedStyle":"突出显示的按钮组样式","component.buttonGroup.flatStyle":"平面按钮组风格","component.buttonGroup.default":"默认按钮组","component.buttonGroup.flat":"平面按钮组","component.buttonGroup.highlighted":"突出显示的按钮组","component.buttonGroup.icon":"图标按钮组","component.buttonGroup.iconFlat":"图标平面按钮组","component.buttonGroup.nested":"嵌套按钮组","component.cards.basic":"基本卡片","component.cards.special":"特殊卡片","component.cards.withHeader":"卡片与页眉，页脚和对齐","component.cards.navigational":"导航卡","component.cards.image":"图像卡","component.cards.solid":"固体卡","component.carousel.basic":"基本传送带","component.carousel.basicTxt":"带反应带的基本BS4旋转木马","component.carousel.product":"产品轮播","component.carousel.productTxt":"一个水平网格视图传送带","component.carousel.testimonial":"见证旋转木马","component.carousel.testimonialTxt":"一次一件物品转盘","component.chips.default":"默认芯片","component.chips.outline":"大纲芯片","component.chips.chipWithText":"与文本具体化的芯片","component.chips.clickable":"可点击芯片","component.chips.withImage":"有图象具体化的芯片","component.chips.deletable":"可删除芯片","component.chips.withIcon":"与象具体化的芯片","component.chips.custom":"自定义可点击芯片","component.chips.array":"芯片阵列","component.chips.withInput":"用输入框实现芯片","component.dividers.list":"列出分隔线","component.dividers.inset":"插入分隔线","component.dividers.default":"默认","component.drawer.persistent":"持久的抽屉","component.drawer.permanent":"永久性抽屉","component.drawer.mini":"迷你抽屉","component.drawer.responsive":"响应式抽屉","component.expansionPanel.simple":"简单的扩展面板","component.expansionPanel.controlled":"受控手风琴","component.expansionPanel.secondary":"次要标题和栏目","component.gridList.image":"仅限图片的网格列表","component.gridList.advanced":"高级网格列表","component.gridList.singleLine":"单行网格列表","component.gridList.withTitlebars":"带标题栏的网格列表","component.lists.folder":"文件夹列表","component.lists.switch":"切换列表控件","component.lists.dividers":"列出分隔线","component.lists.simple":"简单列表","component.lists.inset":"插入列表","component.lists.nested":"嵌套列表","component.lists.checkbox":"复选框二级列表控件","component.lists.checkboxControls":"复选框列表控件","component.lists.pinned":"固定的副标题列表","component.lists.interactive":"交互式列表控件","component.chips":"最近","component.menusPaper.simple":"简单的菜单","component.menusPaper.withIcon":"带有图标的菜单","component.menusPaper.withMoreButton":"带有更多按钮的菜单","component.menusPaper.withSelectedValue":"具有选定值的菜单","component.menusPaper.paper":"纸","component.pickers.Date":"日期选择器","component.progress.indeterminateCircular":"不确定通知","component.progress.indeterminateLinear":"不确定线性","component.progress.determinateLinear":"确定线性","component.progress.bufferLinear":"缓冲线性","component.progress.interactiveIntegration":"交互式集成","component.progress.queryLinear":"查询线性","component.selectionControl.checkboxes":"复选框","component.selectionControl.disabled":"残","component.selectionControl.intermediate":"中间","component.selectionControl.checkboxesWithForm":"与表单组复选框","component.selectionControl.basicRadio":"基本的单选按钮","component.selectionControl.disabledRadio":"禁用的单选按钮","component.selectionControl.withError":"与错误消息","component.selectionControl.switches":"开关","component.selectionControl.verticalSwitches":"垂直开关","component.selectionControl.groupedSwitches":"分组交换机","component.selectionControl.verticalImplementation":"垂直实现交换机","component.selectionControl.generalSettings":"常规设置","component.selectionControl.themeSettings":"主题设置","component.selectionControl.onOffSwitches":"开/关开关","component.selectionControl.verticalInlineRadio":"垂直和内联单选按钮","component.selectionControl.checkboxesWithFormTxt":"菜单位于其发光元件上方，使得当前选择的菜单项出现在发光元件的顶部。","component.selects.simple":"基本","component.selects.native":"修改","component.selects.multiple":"方向","component.selects.dialog":"尺寸","component.selects.select":"选择","component.snackbars.transition":"过渡控制方向","component.snackbars.simple":"简单","component.snackbars.positioned":"定位","component.snackbars.messageWithButton":"消息与按钮","component.snackbars.colors":"颜色","component.snackbars.multilineText":"多行文本","component.snackbars.onlyMessage":"只有消息","component.snackbars.withIconButton":"消息与IconButton","component.stepper.horizontalLinear":"水平线性","component.stepper.horizontalLinearAlternativeLabel":"水平线性 - 可选标签","component.stepper.vertical":"垂直步进器","component.stepper.horizontalNonLinear":"水平非线性","component.stepper.horizontalNonLinearAlternativeLabel":"水平非线性 - 可选标签","component.stepper.mobileDots":"移动步进 - 点","component.stepper.mobileProgress":"移动步进 - 进步","component.stepper.mobileText":"移动步进器 - 文本","component.tabs.basic":"基本选项卡","component.tabs.fixed":"固定标签全宽","component.tabs.icon":"图标选项卡","component.tabs.disabled":"禁用选项卡","component.tabs.wrappedLabels":"包装的标签","component.tabs.iconWithLabel":"与标签的图标选项卡","component.tabs.fixedCentered":"固定标签居中","component.tabs.automaticScroll":"自动滚动按钮","component.tabs.forcedScroll":"强制滚动按钮","component.tabs.preventScroll":"防止滚动按钮","component.textFields.textfield":"文本域","component.textFields.components":"组件","component.textFields.layout":"布局","component.textFields.inputAdornments":"输入装饰品","component.textFields.formattedInputs":"格式化输入","component.textFields.inputs":"输入","component.tooltips.avatar":"头像工具提示","component.tooltips.button":"按钮工具提示","component.tooltips.icon":"图标工具提示","component.tooltips.controlled":"受控工具提示","component.tooltips.positioned":"定位工具提示","component.typography.lightHeadings":"轻的标题","component.typography.normalHeadings":"正常标题","component.typography.semiBoldHeadings":"半粗体标题","component.typography.boldHeadings":"大胆的标题","component.typography.paragraphText":"段落文本","component.typography.leadParagraphText":"铅段文本","component.typography.unstyledList":"无风格列表","component.typography.orderedList":"有序列表","component.typography.unorderedList":"无序列表","component.typography.listWithIcons":"与图标列表","component.typography.compactList":"紧凑列表","component.typography.extendedList":"扩展列表","component.typography.leftIconGroupedList":"扩展列表","component.typography.rightIconGroupedList":"右图标分组列表","component.typography.badgesGroupedList":"徽章分组列表","component.typography.defaultDescriptionList":"默认描述列表","component.typography.evenOddDescriptionList":"偶数描述列表","component.typography.leftBlockquoteWithAuthorAvatar":"左块引用作者头像","component.typography.rightBlockquoteWithAuthorAvatar":"右屏蔽报价与作者头像","signIn.success":"登录成功！","signIn.error":"无效的电子邮件或密码！","signUp.success":"成功建立帐户","signUp.error":"对","signIn.success1":"对","signIn.signUp":"创建一个帐户","signIn.connectWith":"或连接","signUp.alreadyMember":"我已经是会员了","appModule.signin":"签到","appModule.signup":"注册","pages.samplePage":"示例页面","pages.samplePage.description":"开始构建你的应用。 快乐编码！","mailNotification.title":"消息","appNotification.title":"通知","mailNotification.message":"目前没有新消息！","appNotification.message":"截至目前没有通知！","popup.profile":"轮廓","popup.setting":"设置","popup.logout":"登出","popup.updateData":"更新数据","popup.detailedLog":"详细的日志","popup.statistics":"统计","popup.clearData":"清除数据","component.selectionControl.radioBtnGroup":"单选按钮组","component.popover.anchorPlayground":"锚地游乐场"}

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ar = _interopRequireDefault(__webpack_require__(1324));

var _ar_SA = _interopRequireDefault(__webpack_require__(1325));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var saLang = {
  messages: _objectSpread({}, _ar_SA["default"]),
  locale: 'ar-SA',
  data: _ar["default"]
};
var _default = saLang;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(saLang, "saLang", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/ar_SA.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/ar_SA.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_ar, "_ar", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/ar_SA.js");

  __REACT_HOT_LOADER__.register(_ar_SA, "_ar_SA", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/ar_SA.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/ar_SA.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/ar_SA.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/ar_SA.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/ar_SA.js");

  __REACT_HOT_LOADER__.register(saLang, "saLang", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/ar_SA.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/ar_SA.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/ar_SA.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/ar_SA.js");
}();

;

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.ar=a())}(this,function(){"use strict";return[{locale:"ar",pluralRuleFunction:function(e,a){var o=String(e).split("."),r=Number(o[0])==e&&o[0].slice(-2);return a?"other":0==e?"zero":1==e?"one":2==e?"two":r>=3&&r<=10?"few":r>=11&&r<=99?"many":"other"},fields:{year:{displayName:"السنة",relative:{0:"السنة الحالية",1:"السنة القادمة","-1":"السنة الماضية"},relativeTime:{future:{zero:"خلال {0} سنة",one:"خلال سنة واحدة",two:"خلال سنتين",few:"خلال {0} سنوات",many:"خلال {0} سنة",other:"خلال {0} سنة"},past:{zero:"قبل {0} سنة",one:"قبل سنة واحدة",two:"قبل سنتين",few:"قبل {0} سنوات",many:"قبل {0} سنة",other:"قبل {0} سنة"}}},"year-short":{displayName:"السنة",relative:{0:"السنة الحالية",1:"السنة القادمة","-1":"السنة الماضية"},relativeTime:{future:{zero:"خلال {0} سنة",one:"خلال سنة واحدة",two:"خلال سنتين",few:"خلال {0} سنوات",many:"خلال {0} سنة",other:"خلال {0} سنة"},past:{zero:"قبل {0} سنة",one:"قبل سنة واحدة",two:"قبل سنتين",few:"قبل {0} سنوات",many:"قبل {0} سنة",other:"قبل {0} سنة"}}},month:{displayName:"الشهر",relative:{0:"هذا الشهر",1:"الشهر القادم","-1":"الشهر الماضي"},relativeTime:{future:{zero:"خلال {0} شهر",one:"خلال شهر واحد",two:"خلال شهرين",few:"خلال {0} أشهر",many:"خلال {0} شهرًا",other:"خلال {0} شهر"},past:{zero:"قبل {0} شهر",one:"قبل شهر واحد",two:"قبل شهرين",few:"قبل {0} أشهر",many:"قبل {0} شهرًا",other:"قبل {0} شهر"}}},"month-short":{displayName:"الشهر",relative:{0:"هذا الشهر",1:"الشهر القادم","-1":"الشهر الماضي"},relativeTime:{future:{zero:"خلال {0} شهر",one:"خلال شهر واحد",two:"خلال شهرين",few:"خلال {0} أشهر",many:"خلال {0} شهرًا",other:"خلال {0} شهر"},past:{zero:"قبل {0} شهر",one:"قبل شهر واحد",two:"قبل شهرين",few:"خلال {0} أشهر",many:"قبل {0} شهرًا",other:"قبل {0} شهر"}}},day:{displayName:"يوم",relative:{0:"اليوم",1:"غدًا",2:"بعد الغد","-2":"أول أمس","-1":"أمس"},relativeTime:{future:{zero:"خلال {0} يوم",one:"خلال يوم واحد",two:"خلال يومين",few:"خلال {0} أيام",many:"خلال {0} يومًا",other:"خلال {0} يوم"},past:{zero:"قبل {0} يوم",one:"قبل يوم واحد",two:"قبل يومين",few:"قبل {0} أيام",many:"قبل {0} يومًا",other:"قبل {0} يوم"}}},"day-short":{displayName:"يوم",relative:{0:"اليوم",1:"غدًا",2:"بعد الغد","-2":"أول أمس","-1":"أمس"},relativeTime:{future:{zero:"خلال {0} يوم",one:"خلال يوم واحد",two:"خلال يومين",few:"خلال {0} أيام",many:"خلال {0} يومًا",other:"خلال {0} يوم"},past:{zero:"قبل {0} يوم",one:"قبل يوم واحد",two:"قبل يومين",few:"قبل {0} أيام",many:"قبل {0} يومًا",other:"قبل {0} يوم"}}},hour:{displayName:"الساعات",relative:{0:"الساعة الحالية"},relativeTime:{future:{zero:"خلال {0} ساعة",one:"خلال ساعة واحدة",two:"خلال ساعتين",few:"خلال {0} ساعات",many:"خلال {0} ساعة",other:"خلال {0} ساعة"},past:{zero:"قبل {0} ساعة",one:"قبل ساعة واحدة",two:"قبل ساعتين",few:"قبل {0} ساعات",many:"قبل {0} ساعة",other:"قبل {0} ساعة"}}},"hour-short":{displayName:"الساعات",relative:{0:"الساعة الحالية"},relativeTime:{future:{zero:"خلال {0} ساعة",one:"خلال ساعة واحدة",two:"خلال ساعتين",few:"خلال {0} ساعات",many:"خلال {0} ساعة",other:"خلال {0} ساعة"},past:{zero:"قبل {0} ساعة",one:"قبل ساعة واحدة",two:"قبل ساعتين",few:"قبل {0} ساعات",many:"قبل {0} ساعة",other:"قبل {0} ساعة"}}},minute:{displayName:"الدقائق",relative:{0:"هذه الدقيقة"},relativeTime:{future:{zero:"خلال {0} دقيقة",one:"خلال دقيقة واحدة",two:"خلال دقيقتين",few:"خلال {0} دقائق",many:"خلال {0} دقيقة",other:"خلال {0} دقيقة"},past:{zero:"قبل {0} دقيقة",one:"قبل دقيقة واحدة",two:"قبل دقيقتين",few:"قبل {0} دقائق",many:"قبل {0} دقيقة",other:"قبل {0} دقيقة"}}},"minute-short":{displayName:"الدقائق",relative:{0:"هذه الدقيقة"},relativeTime:{future:{zero:"خلال {0} دقيقة",one:"خلال دقيقة واحدة",two:"خلال دقيقتين",few:"خلال {0} دقائق",many:"خلال {0} دقيقة",other:"خلال {0} دقيقة"},past:{zero:"قبل {0} دقيقة",one:"قبل دقيقة واحدة",two:"قبل دقيقتين",few:"قبل {0} دقائق",many:"قبل {0} دقيقة",other:"قبل {0} دقيقة"}}},second:{displayName:"الثواني",relative:{0:"الآن"},relativeTime:{future:{zero:"خلال {0} ثانية",one:"خلال ثانية واحدة",two:"خلال ثانيتين",few:"خلال {0} ثوانٍ",many:"خلال {0} ثانية",other:"خلال {0} ثانية"},past:{zero:"قبل {0} ثانية",one:"قبل ثانية واحدة",two:"قبل ثانيتين",few:"قبل {0} ثوانِ",many:"قبل {0} ثانية",other:"قبل {0} ثانية"}}},"second-short":{displayName:"الثواني",relative:{0:"الآن"},relativeTime:{future:{zero:"خلال {0} ثانية",one:"خلال ثانية واحدة",two:"خلال ثانيتين",few:"خلال {0} ثوانٍ",many:"خلال {0} ثانية",other:"خلال {0} ثانية"},past:{zero:"قبل {0} ثانية",one:"قبل ثانية واحدة",two:"قبل ثانيتين",few:"قبل {0} ثوانٍ",many:"قبل {0} ثانية",other:"قبل {0} ثانية"}}}}},{locale:"ar-AE",parentLocale:"ar",fields:{year:{displayName:"السنة",relative:{0:"هذه السنة",1:"السنة التالية","-1":"السنة الماضية"},relativeTime:{future:{zero:"خلال {0} سنة",one:"خلال سنة واحدة",two:"خلال سنتين",few:"خلال {0} سنوات",many:"خلال {0} سنة",other:"خلال {0} سنة"},past:{zero:"قبل {0} سنة",one:"قبل سنة واحدة",two:"قبل سنتين",few:"قبل {0} سنوات",many:"قبل {0} سنة",other:"قبل {0} سنة"}}},"year-short":{displayName:"السنة",relative:{0:"هذه السنة",1:"السنة التالية","-1":"السنة الماضية"},relativeTime:{future:{zero:"خلال {0} سنة",one:"خلال سنة واحدة",two:"خلال سنتين",few:"خلال {0} سنوات",many:"خلال {0} سنة",other:"خلال {0} سنة"},past:{zero:"قبل {0} سنة",one:"قبل سنة واحدة",two:"قبل سنتين",few:"قبل {0} سنوات",many:"قبل {0} سنة",other:"قبل {0} سنة"}}},month:{displayName:"الشهر",relative:{0:"هذا الشهر",1:"الشهر القادم","-1":"الشهر الماضي"},relativeTime:{future:{zero:"خلال {0} شهر",one:"خلال شهر واحد",two:"خلال شهرين",few:"خلال {0} أشهر",many:"خلال {0} شهرًا",other:"خلال {0} شهر"},past:{zero:"قبل {0} شهر",one:"قبل شهر واحد",two:"قبل شهرين",few:"قبل {0} أشهر",many:"قبل {0} شهرًا",other:"قبل {0} شهر"}}},"month-short":{displayName:"الشهر",relative:{0:"هذا الشهر",1:"الشهر القادم","-1":"الشهر الماضي"},relativeTime:{future:{zero:"خلال {0} شهر",one:"خلال شهر واحد",two:"خلال شهرين",few:"خلال {0} أشهر",many:"خلال {0} شهرًا",other:"خلال {0} شهر"},past:{zero:"قبل {0} شهر",one:"قبل شهر واحد",two:"قبل شهرين",few:"خلال {0} أشهر",many:"قبل {0} شهرًا",other:"قبل {0} شهر"}}},day:{displayName:"يوم",relative:{0:"اليوم",1:"غدًا",2:"بعد الغد","-2":"أول أمس","-1":"أمس"},relativeTime:{future:{zero:"خلال {0} يوم",one:"خلال يوم واحد",two:"خلال يومين",few:"خلال {0} أيام",many:"خلال {0} يومًا",other:"خلال {0} يوم"},past:{zero:"قبل {0} يوم",one:"قبل يوم واحد",two:"قبل يومين",few:"قبل {0} أيام",many:"قبل {0} يومًا",other:"قبل {0} يوم"}}},"day-short":{displayName:"يوم",relative:{0:"اليوم",1:"غدًا",2:"بعد الغد","-2":"أول أمس","-1":"أمس"},relativeTime:{future:{zero:"خلال {0} يوم",one:"خلال يوم واحد",two:"خلال يومين",few:"خلال {0} أيام",many:"خلال {0} يومًا",other:"خلال {0} يوم"},past:{zero:"قبل {0} يوم",one:"قبل يوم واحد",two:"قبل يومين",few:"قبل {0} أيام",many:"قبل {0} يومًا",other:"قبل {0} يوم"}}},hour:{displayName:"الساعات",relative:{0:"الساعة الحالية"},relativeTime:{future:{zero:"خلال {0} ساعة",one:"خلال ساعة واحدة",two:"خلال ساعتين",few:"خلال {0} ساعات",many:"خلال {0} ساعة",other:"خلال {0} ساعة"},past:{zero:"قبل {0} ساعة",one:"قبل ساعة واحدة",two:"قبل ساعتين",few:"قبل {0} ساعات",many:"قبل {0} ساعة",other:"قبل {0} ساعة"}}},"hour-short":{displayName:"الساعات",relative:{0:"الساعة الحالية"},relativeTime:{future:{zero:"خلال {0} ساعة",one:"خلال ساعة واحدة",two:"خلال ساعتين",few:"خلال {0} ساعات",many:"خلال {0} ساعة",other:"خلال {0} ساعة"},past:{zero:"قبل {0} ساعة",one:"قبل ساعة واحدة",two:"قبل ساعتين",few:"قبل {0} ساعات",many:"قبل {0} ساعة",other:"قبل {0} ساعة"}}},minute:{displayName:"الدقائق",relative:{0:"هذه الدقيقة"},relativeTime:{future:{zero:"خلال {0} دقيقة",one:"خلال دقيقة واحدة",two:"خلال دقيقتين",few:"خلال {0} دقائق",many:"خلال {0} دقيقة",other:"خلال {0} دقيقة"},past:{zero:"قبل {0} دقيقة",one:"قبل دقيقة واحدة",two:"قبل دقيقتين",few:"قبل {0} دقائق",many:"قبل {0} دقيقة",other:"قبل {0} دقيقة"}}},"minute-short":{displayName:"الدقائق",relative:{0:"هذه الدقيقة"},relativeTime:{future:{zero:"خلال {0} دقيقة",one:"خلال دقيقة واحدة",two:"خلال دقيقتين",few:"خلال {0} دقائق",many:"خلال {0} دقيقة",other:"خلال {0} دقيقة"},past:{zero:"قبل {0} دقيقة",one:"قبل دقيقة واحدة",two:"قبل دقيقتين",few:"قبل {0} دقائق",many:"قبل {0} دقيقة",other:"قبل {0} دقيقة"}}},second:{displayName:"الثواني",relative:{0:"الآن"},relativeTime:{future:{zero:"خلال {0} ثانية",one:"خلال ثانية واحدة",two:"خلال ثانيتين",few:"خلال {0} ثوانٍ",many:"خلال {0} ثانية",other:"خلال {0} ثانية"},past:{zero:"قبل {0} ثانية",one:"قبل ثانية واحدة",two:"قبل ثانيتين",few:"قبل {0} ثوانِ",many:"قبل {0} ثانية",other:"قبل {0} ثانية"}}},"second-short":{displayName:"الثواني",relative:{0:"الآن"},relativeTime:{future:{zero:"خلال {0} ثانية",one:"خلال ثانية واحدة",two:"خلال ثانيتين",few:"خلال {0} ثوانٍ",many:"خلال {0} ثانية",other:"خلال {0} ثانية"},past:{zero:"قبل {0} ثانية",one:"قبل ثانية واحدة",two:"قبل ثانيتين",few:"قبل {0} ثوانٍ",many:"قبل {0} ثانية",other:"قبل {0} ثانية"}}}}},{locale:"ar-BH",parentLocale:"ar"},{locale:"ar-DJ",parentLocale:"ar"},{locale:"ar-DZ",parentLocale:"ar"},{locale:"ar-EG",parentLocale:"ar"},{locale:"ar-EH",parentLocale:"ar"},{locale:"ar-ER",parentLocale:"ar"},{locale:"ar-IL",parentLocale:"ar"},{locale:"ar-IQ",parentLocale:"ar"},{locale:"ar-JO",parentLocale:"ar"},{locale:"ar-KM",parentLocale:"ar"},{locale:"ar-KW",parentLocale:"ar"},{locale:"ar-LB",parentLocale:"ar"},{locale:"ar-LY",parentLocale:"ar"},{locale:"ar-MA",parentLocale:"ar"},{locale:"ar-MR",parentLocale:"ar"},{locale:"ar-OM",parentLocale:"ar"},{locale:"ar-PS",parentLocale:"ar"},{locale:"ar-QA",parentLocale:"ar"},{locale:"ar-SA",parentLocale:"ar"},{locale:"ar-SD",parentLocale:"ar"},{locale:"ar-SO",parentLocale:"ar"},{locale:"ar-SS",parentLocale:"ar"},{locale:"ar-SY",parentLocale:"ar"},{locale:"ar-TD",parentLocale:"ar"},{locale:"ar-TN",parentLocale:"ar"},{locale:"ar-YE",parentLocale:"ar"}]});


/***/ }),
/* 1325 */
/***/ (function(module, exports) {

module.exports = {"sidebar.main":"الأساسية","sidebar.dashboard":"لوحة القيادة","sidebar.dashboard.default":"افتراضي","sidebar.dashboard.ecommerce":"التجارة الإلكترونية","sidebar.dashboard.news":"أخبار","sidebar.dashboard.intranet":"الشبكة الداخلية","sidebar.components":"المكونات","sidebar.components.alerts":"التنبيهات","sidebar.components.appbar":"بار التطبيق","sidebar.components.autocomplete":"الإكمال التلقائي","sidebar.components.avatars":"الآلهة","sidebar.components.badge":"شارة","sidebar.components.bottomNavigation":"التنقل السفلي","sidebar.components.breadcrumbs":"فتات الخبز","sidebar.components.buttons":"وصفت","sidebar.components.buttonGroup":"زر المجموعة","sidebar.components.cards":"بطاقات","sidebar.components.carousel":"دائري","sidebar.components.chips":"رقائق","sidebar.components.colorPicker":"منتقي الألوان","sidebar.components.modals":"شرطية","sidebar.components.dividers":"فواصل","sidebar.components.expansionPanel":"لوحة التوسع","sidebar.components.drawer":"الدرج","sidebar.components.gridList":"الشبكة قائمة","sidebar.components.lists":"قوائم","sidebar.components.menusPaper":"القوائم والورق","sidebar.components.pickers":"جامعي","sidebar.components.popovers":"بوبوفيرس","sidebar.components.progress":"تقدم","sidebar.components.selects":"يختار","sidebar.components.selectionControl":"ضوابط التحديد","sidebar.components.snackbars":"الوجبات الخفيفة","sidebar.components.stepper":"السائر","sidebar.components.tables":"الجداول","sidebar.components.tabs":"علامات التبويب","sidebar.components.textFields":"حقول النص","sidebar.components.tooltips":"تلميحات","sidebar.components.typography":"طباعة","sidebar.widgets":"الحاجيات","sidebar.metrics":"المقاييس","sidebar.view":"رأي","sidebar.tables":"الجداول","sidebar.tables.basicTable":"الجدول الأساسي","sidebar.tables.dataTable":"جدول البيانات","sidebar.timeLine":"الجدول الزمني","sidebar.timeLine.default":"افتراضي","sidebar.timeLine.defaultwithIcons":"الافتراضي مع الرموز","sidebar.timeLine.leftAligned":"اليسار الانحياز","sidebar.timeLine.zigzag":"متعرج","sidebar.customViews":"طرق عرض مخصصة","sidebar.customViews.plainListView":"عرض قائمة عادي","sidebar.customViews.withDivider":"قائمة بسيطة مع الحاجز","sidebar.customViews.cardListView":"عرض قائمة البطاقات","sidebar.form":"شكل","sidebar.forms":"إستمارات","sidebar.forms.components":"المكونات","sidebar.forms.stepper":"السائر","sidebar.extensions":"ملحقات","sidebar.editors":"المحررين","sidebar.editors.CKEditor":"محرر سك","sidebar.editors.WYSISWYGEditor":"محرر ويسيويغ","sidebar.pickers":"جامعي","sidebar.pickers.dateTimePickers":"التاريخ والوقت المنتقى","sidebar.pickers.colorPickers":"لون بيكرز","sidebar.extensions.dragNDrop":"السحب والإفلات","sidebar.extensions.dropzone":"منطقة الهبوط","sidebar.extensions.sweetAlert":"الحلو تنبيه","sidebar.extensions.notification":"إعلام","sidebar.chart":"خريطة","sidebar.chart.line":"خط الرسم البياني","sidebar.chart.bar":"شريط الرسم البياني","sidebar.chart.area":"مخطط المنطقة","sidebar.chart.composed":"مخطط","sidebar.chart.scatter":"مخطط مبعثر","sidebar.chart.pie":"مخطط دائري","sidebar.chart.radial":"مخطط شعاعي","sidebar.chart.radar":"مخطط الرادار","sidebar.chart.tree":"مخطط الشجرة","sidebar.map":"خرائط جوجل","sidebar.map.simple":"خريطة بسيطة","sidebar.map.styled":"خريطة الأنماط","sidebar.map.geoLocation":"الموقع الجغرافي","sidebar.map.mapDirection":"اتجاه الخريطة","sidebar.map.overlay":"تراكب الخريطة","sidebar.map.kmLayer":"خريطة كم طبقة","sidebar.map.popupInfo":"خريطة معلومات بوبوب","sidebar.map.trafficLayer":"خريطة طبقة حركة المرور","sidebar.map.streetView":"منظر الشارع","sidebar.map.eventListener":"الحدث المستمع","sidebar.map.mapDrawing":"رسم الخريطة","sidebar.map.mapClustering":"خريطة التجمع","sidebar.modules":"وحدات","sidebar.calendar":"التقويم","sidebar.calendar.basic":"الأساسية","sidebar.calendar.cultures":"الثقافات","sidebar.calendar.dnd":"DND","sidebar.calendar.popup":"يظهر فجأة","sidebar.calendar.rendering":"استدعاء","sidebar.calendar.selectable":"اختيار","sidebar.calendar.timeslots":"فتحات الوقت","sidebar.eCommerce":"التجارة الإلكترونية","sidebar.eCommerce.productsList":"قائمة المنتجات","sidebar.eCommerce.productsGrid":"المنتجات الشبكة","sidebar.appModule":"وحدة التطبيق","sidebar.appModule.login":"تسجيل الدخول الصفحة","sidebar.appModule.login2":"تسجيل الدخول الصفحة 2","sidebar.appModule.loginStepper":"تسجيل الدخول مع السائر","sidebar.appModule.signup":"الاشتراك الصفحة","sidebar.appModule.signup2":"الاشتراك الصفحة 2","sidebar.appModule.forgotPassword":"نسيت كلمة المرور","sidebar.appModule.forgotPassword2":"نسيت كلمة المرور 2","sidebar.appModule.lock":"قفل الشاشة","sidebar.appModule.lock2":"قفل الشاشة 2","sidebar.appModule.toDo":"لكى يفعل","sidebar.appModule.toDoRedux":"لكى يفعل...","sidebar.appModule.mail":"بريد","sidebar.appModule.mailRedux":"البريد ريدوكس","sidebar.appModule.chat":"دردشة","sidebar.appModule.chatRedux":"دردشة الدردشة","sidebar.appModule.contact":"اتصل","sidebar.appModule.contactRedux":"الاتصال ريدوكس","sidebar.extras":"إضافات","sidebar.icons":"الرموز","sidebar.icons.material":"رموز غوغل ماتريال","sidebar.extraElements":"عناصر إضافية","sidebar.extraElements.pricingTable":"جدول التسعير","sidebar.extraElements.callouts":"الشرح","sidebar.extraElements.testimonials":"الشهادات - التوصيات","sidebar.extraPages":"صفحات إضافية","sidebar.extraPages.aboutUs":"معلومات عنا","sidebar.extraPages.contactUs":"اتصل بنا","sidebar.extraPages.blog":"مدونة","sidebar.extraPages.faq":"التعليمات","sidebar.extraPages.portfolio":"محفظة","sidebar.extraPages.404":"404 صفحة خطأ","sidebar.extraPages.500":"500 صفحة خطأ","sidebar.menuLevels":"مستويات القائمة","sidebar.menuLevels.level1":"المستوى 1","sidebar.menuLevels.level2":"المستوي 2","sidebar.menuLevels.level3":"مستوى 3","appModule.forgotPassword":"نسيت رقمك السري؟","appModule.dntRememberEmail":"ألا تتذكر بريدك الإلكتروني؟","appModule.contactSupport":"اتصل بالدعم","appModule.resetPassword":"إعادة تعيين كلمة المرور","appModule.enterPasswordUnlock":"أدخل كلمة المرور لفتح الشاشة!","appModule.unlock":"فتح","appModule.signInDiffAccount":"سجل الدخول باستخدام حساب مختلف","appModule.rememberMe":"تذكرنى","appModule.signIn":"تسجيل الدخول","appModule.next":"التالى","appModule.back":"الى الخلف","appModule.allStepsCompleted":"جميع الخطوات المكتملة","appModule.reset":"إعادة تعيين","appModule.loginSuccessfully":"تسجيل الدخول بنجاح","appModule.password":"كلمه السر","appModule.email":"البريد الإلكتروني","appModule.name":"اسم","appModule.phone":"هاتف","appModule.designation":"تعيين","appModule.regsiter":"تسجيل","appModule.hvAccount":"لديك حساب","appModule.createAccount":"انشئ حساب","chart.area":"منطقة الرسم البياني","chart.bar":"شريط الرسم البياني","chart.composed":"الرسم البياني","chart.line":"الرسم البياني...","chart.pie":"رسم بياني","chart.radar":"رادار الرسم البياني","chart.radial":"شعاعي الرسم البياني","chart.scatter":"الرسم البياني مبعثر","chart.tree":"الرسم البياني للشجرة","chat.selectUserChat":"حدد المستخدم لبدء الدردشة","chat.selectContactChat":"حدد جهة الاتصال لبدء الدردشة","chat.chatUser":"الدردشة","chat.contacts":"جهات الاتصال","chat.searchStartNewChat":"بحث أو بدء دردشة جديدة","chat.typeMessage":"اكتب واضغط على إنتر لإرسال الرسالة","chat.status":"انها حالة .... لا اليوميات الخاصة بك ...","contact.saveContact":"حفظ جهة الاتصال","contact.addContact":"إضافة جهة اتصال","contact.searchContact":"بحث الاتصال","button.modify":"تعديل","button.delete":"حذف","button.yes":"نعم فعلا","button.no":"لا","eCommerce.readMore":"اقرأ أكثر","eCommerce.addToCart":"أضف إلى السلة","eCommerce.buyNow":"اشتري الآن","extension.sweetAlerts":"تنبيهات حلوة","extension.notification":"إعلام","sweetAlerts.basic":"الأساسية","sweetAlerts.description":"مع الوصف","sweetAlerts.success":"نجاح","sweetAlerts.warning":"تحذير","sweetAlerts.custom":"العادة","sweetAlerts.htmlTag":"علامة هتمل","sweetAlerts.prompt":"مستعجل","sweetAlerts.itsBlue":"إنه أزرق!","sweetAlerts.passwordPrompt":"كلمة السر موجه","sweetAlerts.customStyle":"نمط مخصص","sweetAlerts.itPretty":"انها جميلة، أليس كذلك؟","sweetAlerts.btnClicked":"النقر على زر!","sweetAlerts.youWillFind":"سوف تجد أنها حتى!","sweetAlerts.youWillNotAble":"لن تكون قادرا على استرداد هذا الملف الخيالي!","sweetAlerts.hereIsaMessage":"إليك رسالة!","sweetAlerts.goodJob":"عمل جيد!","sweetAlerts.yesDeleteIt":"نعم، حذفه!","sweetAlerts.areYouSure":"نعم، حذفه!...","sweetAlerts.doYouLikeThumb":"هل تحب الابهام؟","sweetAlerts.anInput":"مدخلات!","sweetAlerts.writeSomethingInteresting":"كتابة شيء مثير للاهتمام:","sweetAlerts.writeSomething":"أكتب شيئا","sweetAlerts.youMustEnterPassword":"يجب إدخال كلمة المرور الخاصة بك!","sweetAlerts.enterPassword":"أدخل كلمة المرور","notification.infoMsg":"معلومات الرسالة","notification.successMessage":"نجاح رسالة","notification.warningMessage":"رسالة تحذير","notification.closeAfter3000ms":"إغلاق بعد 3000ms","notification.errorMessage":"رسالة خطأ","notification.titleHere":"العنوان هنا","notification.clickMe":"انقر فوق لي!","notification.info":"معلومات","notification.success":"نجاح","notification.warning":"تحذير","notification.error":"خطأ","extraElements.callouts":"الشرح","extraElements.pricingTable":"جدول التسعير","extraElements.testimonials":"الشهادات - التوصيات","callouts.viewRange":"عرض النطاق","callouts.basic":"الأساسية","pricingTable.basic":"الأساسية","pricingTable.circle":"دائرة","pricingTable.classic":"كلاسيكي","pricingTable.dark":"داكن","pricingTable.personal":"الشخصية","pricingTable.easyTranslation":"ترجمة سهلة","pricingTable.awesomeGoogleFonts":"خطوط غوغل رهيبة","pricingTable.hotelBookingSystem":"نظام حجز الفنادق","pricingTable.emailComposeInterface":"البريد الإلكتروني إنشاء واجهة","pricingTable.locationFinderApp":"الموقع الباحث التطبيق","pricingTable.buyNow":"اشتري الآن","pricingTable.business":"اعمال","pricingTable.professional":"المحترفين","testimonials.basic":"الأساسية","testimonials.classic":"كلاسيكي","testimonials.standard":"اساسي","extraPages.goHome":"اساسي...","extraPages.ourClients":"عملائنا","extraPages.all":"الكل","extraPages.graphicDesign":"التصميم الجرافيكي","extraPages.logo":"شعار","extraPages.mobileApp":"شعار...","extraPages.web":"شبكة","extraPages.404Msg":"عفوا، حدث خطأ. الصفحة غير موجودة!","extraPages.500Msg":"عذرا، هناك خطأ في الخادم","extraPages.aboutUs.showCase":"اعرض خدماتك هنا مع معلومات عنها","aboutUs.readMore":"اقرأ أكثر","extraPages.goSomewhere":"اذهب لمكان ما","icon.material":"900+ الرسمية أيقونات تصميم المواد","mail.mailbox":"صندوق بريد","mail.compose":"مؤلف موسيقى","mail.filters":"مرشحات","mail.labels":"تسميات","picker.color.alpha":"ألفا بيكرز","picker.color.hue":"هيو بيكرز","picker.color.circle":"دائرة المنتقى","picker.color.compact":"كومباكت بيكرز","picker.color.block":"بلوك بيكرز","picker.color.chrome":"كروم بيكرز","picker.color.github":"جيثب بيكرز","picker.color.twitter":"تويتر المنتقى","picker.color.withRedux":"مع ريدوكس","picker.color.sketch":"رسم بيكرز","picker.color.material":"المواد المنتقى","picker.color.slider":"المتزلجون المنتقى","picker.color.basic":"المنتقى الأساسيون","picker.color.basicToggle":"تبديل أساسي","picker.color.custom":"مخصصون","picker.color.customPointer":"مؤشر مخصص","picker.color.photoshop":"فوتوشوب بيكرز","picker.color.swatches":"سواتشس بيكرز","picker.color.basicPositioning":"تحديد المواقع الأساسية","picker.date.pickers":"جامعي","picker.date.toggle":"تبديل القاطرات","picker.date.input":"منتقي مجال الإدخال","picker.date.localization":"توطين الملتقطين","picker.date.basic":"انتقاء الأساسية","picker.date.selectDay":"اختر اليوم","table.marketingCampaign":"حملة تسويق","table.thisWeek":"هذا الاسبوع","table.defaultSorting":"الفرز الافتراضى","table.customSorting":"فرز مخصص","table.editableContent":"محتوى قابل للتحرير","table.customFilter":"تصفية مخصص","table.recentOrders":"الطلبيات الأخيرة","table.dataTable":"جدول البيانات","table.basicTable":"الجدول الأساسي","table.application":"جدول التطبيق","todo":"لكى يفعل","todo.addTask":"إضافة مهمة","todo.all":"الكل","todo.filters":"مرشحات","todo.labels":"تسميات","dashboard.recentActivities":"أنشطة حالية","dashboard.lastActivity":"آخر نشاط كان قبل يومين","dashboard.currentProjects":"قائمة المشاريع الحالية","dashboard.toDoItems":"تأليف لائحة البنود","dashboard.today":"اليوم","dashboard.marketingCampaign":"حملة تسويق","dashboard.yourDailyFeed":"الخلاصة اليومية","dashboard.googleInsight":"النتيجة البصيرة جوجل","dashboard.lastCalculated":"لاس كالكولاتد 1 مونث أغو","dashboard.refresh":"تحديث","dashboard.upgradeToday":"ترقية اليوم","dashboard.onlineSignups":"الاشتراك عبر الإنترنت","dashboard.lastMonthSale":"الشهر الماضي بيع","dashboard.newVisits":"الزيارات الجديدة هذا الشهر","dashboard.totalRevenue":"إجمالي الإيرادات هذا العام","dashboard.latestPosts":"آخر المشاركات","dashboard.loremIpsum":"أبجد هوز هو محتوى دمية الدولار الجلوس ...","dashboard.viewAllPosts":"عرض جميع المشاركات","dashboard.popularProducts":"المنتجات الشعبية","dashboard.popularProductsTxt":"ومن الحقائق الثابتة منذ فترة طويلة أن القارئ سوف يصرف من قبل محتوى قابل للقراءة ..","dashboard.allProducts":"جميع المنتجات","dashboard.userStatstics":"إحصائيات المستخدم","dashboard.orders":"أوامر","dashboard.thisYearSaleReport":"تقرير بيع هذا العام","dashboard.post9MonthData":"نشر بيانات 9 أشهر","dashboard.newCustomers":"زبائن الجدد","dashboard.newThisMonth":"32 جديد هذا الشهر","dashboard.monthly":"شهريا","dashboard.totalView":"إجمالي العرض","dashboard.annual":"سنوي","dashboard.newOrder":"أمر جديد","dashboard.visited":"زار","dashboard.rapidPace":"ايقاع متسارع","dashboard.slowPace":"بطء","dashboard.newConnections":"اتصالات جديدة","dashboard.thisWeek":"3 هذا الأسبوع","dashboard.newFeed":"23 خلاصات جديدة","dashboard.newSubscriber":"مشترك جديد","dashboard.newArticles":"مقالات جديدة","dashboard.newAuthors":"المؤلفون الجدد","dashboard.avgDailyTraffic":"متوسط عدد الزيارات اليومية","dashboard.popularAuthors":"مؤلفون شعبيون","dashboard.authorsWith":"المؤلفون مع 500+ أفغ. رأي","dashboard.popularArticles":"المواد شعبية","dashboard.comments":"تعليقات","component.alert.default":"التنبيهات الافتراضية","component.alert.highlighted":"أبرز التنبيهات","component.alert.dismissible":"التنبيهات القابلة للتصفية","component.alert.withIcons":"التنبيهات مع الرموز","component.alert.withDetailedHTML":"تنبيه مع هتمل مفصل","component.appbar.simple":"بسيطة التطبيق بار","component.appbar.colored":"الملونة التطبيق بار","component.appbar.fullyFeatured":"بار متميز تماما التطبيقات","component.autocomplete.Basic":"الأساسية","component.autocomplete.controlinSelection":"اختيار التحكم","component.autocomplete.Behaviors":"السلوكيات","component.autocomplete.inputSize":"حجم المدخلات","component.autocomplete.menuAlign":"القائمة محاذاة","component.avatars.image":"الصورة الرمزية","component.avatars.letter":"رسالة الرمزية","component.avatars.icon":"الرمز الرمزية","component.badge.scaling":"شارات التحجيم","component.badge.insideLinks":"داخل الروابط والأزرار","component.badge.contextual":"الاختلافات السياقية","component.badge.pill":"حبوب منع الحمل، الشارات","component.badge.link":"شارات الارتباط","component.bottomNavigation.withLabels":"التنقل في الأسفل مع التصنيفات","component.bottomNavigation.withActiveLabels":"التنقل السفلي مع التسمية النشطة","component.bottomNavigation.withNoLabels":"التنقل السفلي بدون تسمية","component.breadcrumbs.simple":"بسيط","component.breadcrumbs.noList":"ليست هناك قائمة","component.buttons.colorScheme":"نظام الألوان","component.buttons.colorSchemeTxt":"بوتستراب، لون، برنامج، ب، مادة، كونسيبت","component.buttons.icon":"أزرار الرمز","component.buttons.iconTxt":"يمكنك اختيار أي رمز من الرموز الخط المدرجة تحت صفحة الأيقونات. أو لا تتردد في إضافة أي رموز الخط الجديد واستخدام ذلك.","component.buttons.differentSizes":"مقاسات مختلفة","component.buttons.differentSizesTxt":"أزرار المواد مع أحجام مختلفة","component.buttons.flatFullWidth":"أزرار مسطحة و كاملة العرض","component.buttons.flatFullWidthTxt":"جميع أزرار نوع مع حالات تعطيل","component.buttons.raised":"أزرار أثارت","component.buttons.raisedTxt":"بوتستراب، لون، برنامج، ب، مادة، كونسيبت","component.buttons.fab":"أزرار العمل العائمة","component.buttons.fabTxt":"بوتستراب، لون، برنامج، ب، مادة، كونسيبت","component.buttons.socialMedia":"أزرار وسائل الإعلام الاجتماعية","component.buttons.socialMediaTxt":"مختلف أزرار وسائل الاعلام الاجتماعية لمشروعك","component.buttons.complex":"أزرار معقدة","component.buttonGroup.horizontalVariations":"الاختلافات الأفقية","component.buttonGroup.defaultStyle":"نمط مجموعة الأزرار الافتراضية","component.buttonGroup.highlightedStyle":"نمط مجموعة الزر المميز","component.buttonGroup.flatStyle":"شقة زر مجموعة نمط","component.buttonGroup.default":"مجموعة زر افتراضي","component.buttonGroup.flat":"شقة زر المجموعة","component.buttonGroup.highlighted":"أبرز مجموعة زر","component.buttonGroup.icon":"أيقونة زر المجموعة","component.buttonGroup.iconFlat":"أيقونة زر شقة المجموعة","component.buttonGroup.nested":"مجموعة زر متداخلة","component.cards.basic":"البطاقات الأساسية","component.cards.special":"بطاقات خاصة","component.cards.withHeader":"بطاقات مع رأس، تذييل و محاذاة","component.cards.navigational":"البطاقات الملاحية","component.cards.image":"بطاقات الصورة","component.cards.solid":"بطاقات صلبة","component.carousel.basic":"دائري الأساسي","component.carousel.basicTxt":"الأساسية BS4 دائري بدعم مع رياكتستراب","component.carousel.product":"المنتج دائري","component.carousel.productTxt":"الأفقي عرض الشبكة كاروسيل","component.carousel.testimonial":"شهادة دائري","component.carousel.testimonialTxt":"عنصر واحد دائري في وقت واحد","component.chips.default":"رقاقة افتراضية","component.chips.outline":"الخطوط العريضة رقاقة","component.chips.chipWithText":"رقاقة مع النص الرمزية","component.chips.clickable":"شريحة قابلة للنقر","component.chips.withImage":"رقاقة مع الصورة الرمزية","component.chips.deletable":"رقاقة قابلة للتحرير","component.chips.withIcon":"رقاقة مع رمز الرمزية","component.chips.custom":"العرف رقاقة قابلة للنقر","component.chips.array":"رقاقة صفيف","component.chips.withInput":"تنفيذ رقائق مع مربع الإدخال","component.dividers.list":"قائمة الفواصل","component.dividers.inset":"فواصل مقسمة","component.dividers.default":"افتراضي","component.drawer.persistent":"درج ثابت","component.drawer.permanent":"درج دائم","component.drawer.mini":"درج صغير","component.drawer.responsive":"درج الاستجابة","component.expansionPanel.simple":"لوحة توسع بسيطة","component.expansionPanel.controlled":"الأكورديون الخاضعة للرقابة","component.expansionPanel.secondary":"العنوان الثانوي والأعمدة","component.gridList.image":"إيماج-أونلي غريد ليست","component.gridList.advanced":"قائمة الشبكة المتقدمة","component.gridList.singleLine":"قائمة شبكة خط واحد","component.gridList.withTitlebars":"قائمة الشبكة مع تيتلبارس","component.lists.folder":"قائمة المجلدات","component.lists.switch":"تبديل عناصر التحكم في القائمة","component.lists.dividers":"قائمة الفواصل","component.lists.simple":"قائمة بسيطة","component.lists.inset":"قائمة إدراج","component.lists.nested":"قائمة متداخلة","component.lists.checkbox":"مربع الاختيار عناصر تحكم القائمة الثانوية","component.lists.checkboxControls":"ضوابط قائمة الاختيار","component.lists.pinned":"بيند سوبهيدر ليست","component.lists.interactive":"عناصر التحكم في القائمة التفاعلية","component.chips":"الأخيرة","component.menusPaper.simple":"القوائم بسيطة","component.menusPaper.withIcon":"القائمة مع أيقونة","component.menusPaper.withMoreButton":"القائمة مع المزيد من زر","component.menusPaper.withSelectedValue":"القائمة مع القيمة المحددة","component.menusPaper.paper":"ورقة","component.pickers.Date":"منتقي التاريخ","component.progress.indeterminateCircular":"تعميم غير محدد","component.progress.indeterminateLinear":"غير محدد الخطية","component.progress.determinateLinear":"تحديد الخطي","component.progress.bufferLinear":"المخزن المؤقت الخطي","component.progress.interactiveIntegration":"التكامل التفاعلي","component.progress.queryLinear":"الاستعلام الخطي","component.selectionControl.checkboxes":"مربعات","component.selectionControl.disabled":"معاق","component.selectionControl.intermediate":"متوسط","component.selectionControl.checkboxesWithForm":"مربعات الاختيار مع مجموعة النموذج","component.selectionControl.basicRadio":"أزرار الراديو الأساسية","component.selectionControl.disabledRadio":"أزرار راديو معطل","component.selectionControl.withError":"مع رسالة خطأ","component.selectionControl.switches":"مفاتيح","component.selectionControl.verticalSwitches":"مفاتيح عمودية","component.selectionControl.groupedSwitches":"مفاتيح مجمعة","component.selectionControl.verticalImplementation":"تنفيذ عمودي من مفاتيح","component.selectionControl.generalSettings":"الاعدادات العامة","component.selectionControl.themeSettings":"إعدادات الموضوع","component.selectionControl.onOffSwitches":"تشغيل / إيقاف مفاتيح","component.selectionControl.verticalInlineRadio":"أزرار الراديو العمودية والمضمنة","component.selectionControl.checkboxesWithFormTxt":"يتم وضع القوائم على العناصر التي تنبعث منها بحيث يظهر عنصر القائمة المحدد حاليا أعلى العنصر الذي ينبعث منه.","component.selects.simple":"الأساسية","component.selects.native":"التعديل","component.selects.multiple":"اتجاه","component.selects.dialog":"بحجم","component.selects.select":"تحديد","component.snackbars.transition":"اتجاه التحكم في الانتقال","component.snackbars.simple":"بسيط","component.snackbars.positioned":"وضع","component.snackbars.messageWithButton":"رسالة مع زر","component.snackbars.colors":"الألوان","component.snackbars.multilineText":"نص متعدد الطبقات","component.snackbars.onlyMessage":"الرسالة فقط","component.snackbars.withIconButton":"رسالة مع إكونبوتون","component.stepper.horizontalLinear":"أفقي الخطي","component.stepper.horizontalLinearAlternativeLabel":"أفقي خطي - تسمية بديلة","component.stepper.vertical":"السائر العمودي","component.stepper.horizontalNonLinear":"أفقي غير خطي","component.stepper.horizontalNonLinearAlternativeLabel":"أفقي غير خطي - تسمية بديلة","component.stepper.mobileDots":"السائر المحمول - النقاط","component.stepper.mobileProgress":"السائر المحمول - التقدم","component.stepper.mobileText":"السائر المحمول - النص","component.tabs.basic":"علامات التبويب الأساسية","component.tabs.fixed":"علامات التبويب الثابتة العرض الكامل","component.tabs.icon":"أيقونة علامات التبويب","component.tabs.disabled":"تم تعطيل علامة التبويب","component.tabs.wrappedLabels":"ملفوفة","component.tabs.iconWithLabel":"أيقونة علامات التبويب مع التسمية","component.tabs.fixedCentered":"علامات التبويب الثابتة المتمركزة","component.tabs.automaticScroll":"أزرار التمرير التلقائي","component.tabs.forcedScroll":"أزرار التمرير القسري","component.tabs.preventScroll":"منع أزرار التمرير","component.textFields.textfield":"حقل النص","component.textFields.components":"المكونات","component.textFields.layout":"نسق","component.textFields.inputAdornments":"إدخال الزينة","component.textFields.formattedInputs":"المدخلات المنسقة","component.textFields.inputs":"المدخلات","component.tooltips.avatar":"الصورة الرمزية تولتيب","component.tooltips.button":"بوتون تولتيب","component.tooltips.icon":"إيكون تولتيب","component.tooltips.controlled":"تلميح أدوات التحكم","component.tooltips.positioned":"تلميح محدد الموضع","component.typography.lightHeadings":"العناوين الخفيفة","component.typography.normalHeadings":"العناوين العادية","component.typography.semiBoldHeadings":"عناوين شبه جريئة","component.typography.boldHeadings":"عناوين غامقة","component.typography.paragraphText":"نص الفقرة","component.typography.leadParagraphText":"نص فقرة الرصاص","component.typography.unstyledList":"قائمة غير مستغلة","component.typography.orderedList":"قائمة المطلوبة","component.typography.unorderedList":"قائمة غير مرتبة","component.typography.listWithIcons":"قائمة بأيقونات","component.typography.compactList":"قائمة مدمجة","component.typography.extendedList":"القائمة الموسعة","component.typography.leftIconGroupedList":"اليسار رمز قائمة مجمعة","component.typography.rightIconGroupedList":"الحق قائمة رمز مجمعة","component.typography.badgesGroupedList":"شارات قائمة مجمعة","component.typography.defaultDescriptionList":"قائمة الوصف الافتراضي","component.typography.evenOddDescriptionList":"حتى الغريب قائمة الوصف","component.typography.leftBlockquoteWithAuthorAvatar":"اليسار اقتباس اقتباس مع الكاتب الصورة الرمزية","component.typography.rightBlockquoteWithAuthorAvatar":"الحق اقتباس مع الكاتب الصورة الرمزية","signIn.success":"تسجيل الدخول بنجاح!","signIn.error":"البريد الإلكتروني أو كلمة السر خاطئة!","signUp.success":"تم إنشاء الحساب بنجاح","signUp.error":"حق","signIn.success1":"حق","signIn.signUp":"انشئ حساب","signIn.connectWith":"أو التواصل مع","signUp.alreadyMember":"أنا عضو بالفعل","appModule.signin":"تسجيل الدخول","appModule.signup":"سجل","pages.samplePage":"نموذج الصفحة","pages.samplePage.description":"ابدأ في إنشاء تطبيقك. سعيد الترميز!","mailNotification.title":"رسائل","appNotification.title":"إخطارات","mailNotification.message":"لا رسائل جديدة حتى الآن!","appNotification.message":"لا الإخطارات حتى الآن!","popup.profile":"الملف الشخصي","popup.setting":"ضبط","popup.logout":"الخروج","popup.updateData":"تحديث البيانات","popup.detailedLog":"سجل مفصل","popup.statistics":"الإحصاء","popup.clearData":"امسح البيانات","component.selectionControl.radioBtnGroup":"مجموعة أزرار الراديو","component.popover.anchorPlayground":"ملعب انكور"}

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _it = _interopRequireDefault(__webpack_require__(1327));

var _it_IT = _interopRequireDefault(__webpack_require__(1328));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var saLang = {
  messages: _objectSpread({}, _it_IT["default"]),
  locale: 'it-IT',
  data: _it["default"]
};
var _default = saLang;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(saLang, "saLang", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/it_IT.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/it_IT.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_it, "_it", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/it_IT.js");

  __REACT_HOT_LOADER__.register(_it_IT, "_it_IT", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/it_IT.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/it_IT.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/it_IT.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/it_IT.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/it_IT.js");

  __REACT_HOT_LOADER__.register(saLang, "saLang", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/it_IT.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/it_IT.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/it_IT.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/it_IT.js");
}();

;

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.it=a())}(this,function(){"use strict";return[{locale:"it",pluralRuleFunction:function(e,a){var t=!String(e).split(".")[1];return a?11==e||8==e||80==e||800==e?"many":"other":1==e&&t?"one":"other"},fields:{year:{displayName:"anno",relative:{0:"quest’anno",1:"anno prossimo","-1":"anno scorso"},relativeTime:{future:{one:"tra {0} anno",other:"tra {0} anni"},past:{one:"{0} anno fa",other:"{0} anni fa"}}},"year-short":{displayName:"anno",relative:{0:"quest’anno",1:"anno prossimo","-1":"anno scorso"},relativeTime:{future:{one:"tra {0} anno",other:"tra {0} anni"},past:{one:"{0} anno fa",other:"{0} anni fa"}}},month:{displayName:"mese",relative:{0:"questo mese",1:"mese prossimo","-1":"mese scorso"},relativeTime:{future:{one:"tra {0} mese",other:"tra {0} mesi"},past:{one:"{0} mese fa",other:"{0} mesi fa"}}},"month-short":{displayName:"mese",relative:{0:"questo mese",1:"mese prossimo","-1":"mese scorso"},relativeTime:{future:{one:"tra {0} mese",other:"tra {0} mesi"},past:{one:"{0} mese fa",other:"{0} mesi fa"}}},day:{displayName:"giorno",relative:{0:"oggi",1:"domani",2:"dopodomani","-2":"l’altro ieri","-1":"ieri"},relativeTime:{future:{one:"tra {0} giorno",other:"tra {0} giorni"},past:{one:"{0} giorno fa",other:"{0} giorni fa"}}},"day-short":{displayName:"g",relative:{0:"oggi",1:"domani",2:"dopodomani","-2":"l’altro ieri","-1":"ieri"},relativeTime:{future:{one:"tra {0} g",other:"tra {0} gg"},past:{one:"{0} g fa",other:"{0} gg fa"}}},hour:{displayName:"ora",relative:{0:"quest’ora"},relativeTime:{future:{one:"tra {0} ora",other:"tra {0} ore"},past:{one:"{0} ora fa",other:"{0} ore fa"}}},"hour-short":{displayName:"h.",relative:{0:"quest’ora"},relativeTime:{future:{one:"tra {0} h",other:"tra {0} h"},past:{one:"{0} h fa",other:"{0} h fa"}}},minute:{displayName:"minuto",relative:{0:"questo minuto"},relativeTime:{future:{one:"tra {0} minuto",other:"tra {0} minuti"},past:{one:"{0} minuto fa",other:"{0} minuti fa"}}},"minute-short":{displayName:"min",relative:{0:"questo minuto"},relativeTime:{future:{one:"tra {0} min",other:"tra {0} min"},past:{one:"{0} min fa",other:"{0} min fa"}}},second:{displayName:"secondo",relative:{0:"ora"},relativeTime:{future:{one:"tra {0} secondo",other:"tra {0} secondi"},past:{one:"{0} secondo fa",other:"{0} secondi fa"}}},"second-short":{displayName:"s",relative:{0:"ora"},relativeTime:{future:{one:"tra {0} s",other:"tra {0} sec."},past:{one:"{0} s fa",other:"{0} sec. fa"}}}}},{locale:"it-CH",parentLocale:"it"},{locale:"it-SM",parentLocale:"it"},{locale:"it-VA",parentLocale:"it"}]});


/***/ }),
/* 1328 */
/***/ (function(module, exports) {

module.exports = {"sidebar.main":"Principale","sidebar.dashboard":"Cruscotto","sidebar.dashboard.default":"Predefinito","sidebar.dashboard.ecommerce":"eCommerce","sidebar.dashboard.news":"notizia","sidebar.dashboard.intranet":"Intranet","sidebar.components":"componenti","sidebar.components.alerts":"avvisi","sidebar.components.appbar":"App Bar","sidebar.components.autocomplete":"Completamento automatico","sidebar.components.avatars":"avatars","sidebar.components.badge":"Distintivo","sidebar.components.bottomNavigation":"Navigazione inferiore","sidebar.components.breadcrumbs":"Briciole di pane","sidebar.components.buttons":"pulsanti","sidebar.components.buttonGroup":"Gruppo di pulsanti","sidebar.components.cards":"Carte","sidebar.components.carousel":"Giostra","sidebar.components.chips":"Patatine fritte","sidebar.components.colorPicker":"Color Picker","sidebar.components.modals":"Modals","sidebar.components.dividers":"divisori","sidebar.components.expansionPanel":"Pannello di espansione","sidebar.components.drawer":"Cassetto","sidebar.components.gridList":"Grid List","sidebar.components.lists":"elenchi","sidebar.components.menusPaper":"Menu e carta","sidebar.components.pickers":"Pickers","sidebar.components.popovers":"popovers","sidebar.components.progress":"Progresso","sidebar.components.selects":"Seleziona","sidebar.components.selectionControl":"Controlli di selezione","sidebar.components.snackbars":"snackbars","sidebar.components.stepper":"stepper","sidebar.components.tables":"tabelle","sidebar.components.tabs":"Tabs","sidebar.components.textFields":"Campi di testo","sidebar.components.tooltips":"Tooltips","sidebar.components.typography":"Tipografia","sidebar.widgets":"widget","sidebar.metrics":"Metrica","sidebar.view":"vista","sidebar.tables":"tabelle","sidebar.tables.basicTable":"Tabella di base","sidebar.tables.dataTable":"Tabella dati","sidebar.timeLine":"Sequenza temporale","sidebar.timeLine.default":"Predefinito","sidebar.timeLine.defaultwithIcons":"Predefinito con icone","sidebar.timeLine.leftAligned":"Sinistra allineata","sidebar.timeLine.zigzag":"Zigzag","sidebar.customViews":"Visualizzazioni personalizzate","sidebar.customViews.plainListView":"Lista semplice","sidebar.customViews.withDivider":"Lista semplice con divisore","sidebar.customViews.cardListView":"Visualizzazione elenco schede","sidebar.form":"Modulo","sidebar.forms":"Forme","sidebar.forms.components":"componenti","sidebar.forms.stepper":"stepper","sidebar.extensions":"estensioni","sidebar.editors":"Editors","sidebar.editors.CKEditor":"CKEditor","sidebar.editors.WYSISWYGEditor":"WYSIWYG Editor","sidebar.pickers":"Pickers","sidebar.pickers.dateTimePickers":"Raccoglitori di data e ora","sidebar.pickers.colorPickers":"Raccoglitori di colori","sidebar.extensions.dragNDrop":"Trascinare e rilasciare","sidebar.extensions.dropzone":"Zona di rilascio","sidebar.extensions.sweetAlert":"Dolce avviso","sidebar.extensions.notification":"Notifica","sidebar.chart":"Grafico","sidebar.chart.line":"Grafico a linee","sidebar.chart.bar":"Grafico a barre","sidebar.chart.area":"Area grafico","sidebar.chart.composed":"Grafico composto","sidebar.chart.scatter":"Grafico a dispersione","sidebar.chart.pie":"Grafico a torta","sidebar.chart.radial":"Grafico radiale","sidebar.chart.radar":"Grafico radar","sidebar.chart.tree":"Grafico ad albero","sidebar.map":"Google Map","sidebar.map.simple":"Mappa semplice","sidebar.map.styled":"Mappa in stile","sidebar.map.geoLocation":"Posizione geografica","sidebar.map.mapDirection":"Direzione della mappa","sidebar.map.overlay":"Sovrapposizione mappa","sidebar.map.kmLayer":"Mappa Km Layer","sidebar.map.popupInfo":"Mappa Informazioni popup","sidebar.map.trafficLayer":"Mappa dello strato di traffico","sidebar.map.streetView":"vista stradale","sidebar.map.eventListener":"Listener di eventi","sidebar.map.mapDrawing":"Disegno della mappa","sidebar.map.mapClustering":"Raggruppamento di mappe","sidebar.modules":"moduli","sidebar.calendar":"Calendario","sidebar.calendar.basic":"Di base","sidebar.calendar.cultures":"culture","sidebar.calendar.dnd":"Dnd","sidebar.calendar.popup":"Apparire","sidebar.calendar.rendering":"Rendering","sidebar.calendar.selectable":"selezionabile","sidebar.calendar.timeslots":"Fasce orarie","sidebar.eCommerce":"eCommerce","sidebar.eCommerce.productsList":"Elenco prodotti","sidebar.eCommerce.productsGrid":"Griglia di prodotti","sidebar.appModule":"Modulo dell'app","sidebar.appModule.login":"Pagina di accesso","sidebar.appModule.login2":"Pagina di accesso 2","sidebar.appModule.loginStepper":"Accedi con Stepper","sidebar.appModule.signup":"Pagina di iscrizione","sidebar.appModule.signup2":"Iscriviti Pagina 2","sidebar.appModule.forgotPassword":"Password dimenticata","sidebar.appModule.forgotPassword2":"Password dimenticata 2","sidebar.appModule.lock":"Blocca schermo","sidebar.appModule.lock2":"Blocca schermo 2","sidebar.appModule.toDo":"Fare","sidebar.appModule.toDoRedux":"To-Do Redux","sidebar.appModule.mail":"posta","sidebar.appModule.mailRedux":"Mail Redux","sidebar.appModule.chat":"Chiacchierare","sidebar.appModule.chatRedux":"Chat Redux","sidebar.appModule.contact":"Contatto","sidebar.appModule.contactRedux":"Contatta Redux","sidebar.extras":"extra","sidebar.icons":"Icone","sidebar.icons.material":"Google Material Icons","sidebar.extraElements":"Elementi extra","sidebar.extraElements.pricingTable":"Tabella dei prezzi","sidebar.extraElements.callouts":"didascalie","sidebar.extraElements.testimonials":"Testimonianze","sidebar.extraPages":"Pagine extra","sidebar.extraPages.aboutUs":"Riguardo a noi","sidebar.extraPages.contactUs":"Contattaci","sidebar.extraPages.blog":"blog","sidebar.extraPages.faq":"FAQ","sidebar.extraPages.portfolio":"Portafoglio","sidebar.extraPages.404":"404 Pagina di errore","sidebar.extraPages.500":"500 Pagina di errore","sidebar.menuLevels":"Livelli di menu","sidebar.menuLevels.level1":"Livello 1","sidebar.menuLevels.level2":"Livello 2","sidebar.menuLevels.level3":"Livello 3","appModule.forgotPassword":"Hai dimenticato la password?","appModule.dntRememberEmail":"Non ricordi la tua email?","appModule.contactSupport":"Contatta il supporto","appModule.resetPassword":"Resetta la password","appModule.enterPasswordUnlock":"Inserisci la tua password per sbloccare lo schermo!","appModule.unlock":"Sbloccare","appModule.signInDiffAccount":"Accedi utilizzando un account diverso","appModule.rememberMe":"Ricordati di me","appModule.signIn":"Registrati","appModule.next":"Il prossimo","appModule.back":"Indietro","appModule.allStepsCompleted":"Tutti i passaggi completati","appModule.reset":"Reset","appModule.loginSuccessfully":"Accedi con successo","appModule.password":"Parola d'ordine","appModule.email":"E-mail","appModule.name":"Nome","appModule.phone":"Telefono","appModule.designation":"Designazione","appModule.regsiter":"Registrare","appModule.hvAccount":"Avere un conto","appModule.createAccount":"Crea un account","chart.area":"Area Graph","chart.bar":"Istogramma","chart.composed":"Grafico composto","chart.line":"Grafico a linee","chart.pie":"Grafico a torta","chart.radar":"Grafico radar","chart.radial":"Grafico radiale","chart.scatter":"Grafico di dispersione","chart.tree":"Grafico ad albero","chat.selectUserChat":"Seleziona Utente per avviare la chat","chat.selectContactChat":"Seleziona contatto per avviare la chat","chat.chatUser":"Chat","chat.contacts":"Contatti","chat.searchStartNewChat":"Cerca o inizia nuova chat","chat.typeMessage":"Scrivi e premi invio per inviare un messaggio","chat.status":"è uno status .... non è il tuo diario ...","contact.saveContact":"Salva contatto","contact.addContact":"Aggiungi contatto","contact.searchContact":"Cerca contatto","button.modify":"Modificare","button.delete":"Elimina","button.yes":"sì","button.no":"No","eCommerce.readMore":"Leggi di più","eCommerce.addToCart":"Aggiungi al carrello","eCommerce.buyNow":"Acquista ora","extension.sweetAlerts":"Avvisi dolci","extension.notification":"Notifica","sweetAlerts.basic":"Di base","sweetAlerts.description":"Con descrizione","sweetAlerts.success":"Successo","sweetAlerts.warning":"avvertimento","sweetAlerts.custom":"costume","sweetAlerts.htmlTag":"Tag HTML","sweetAlerts.prompt":"Richiesta","sweetAlerts.itsBlue":"È blu!","sweetAlerts.passwordPrompt":"Richiesta password","sweetAlerts.customStyle":"Stile personalizzato","sweetAlerts.itPretty":"È carino, non è vero?","sweetAlerts.btnClicked":"Hai fatto clic sul pulsante!","sweetAlerts.youWillFind":"Scoprirai che sono su!","sweetAlerts.youWillNotAble":"Non sarai in grado di recuperare questo file immaginario!","sweetAlerts.hereIsaMessage":"Ecco un messaggio!","sweetAlerts.goodJob":"Buon lavoro!","sweetAlerts.yesDeleteIt":"Sì, cancellalo!","sweetAlerts.areYouSure":"Sei sicuro?","sweetAlerts.doYouLikeThumb":"Ti piacciono i pollici?","sweetAlerts.anInput":"Un input!","sweetAlerts.writeSomethingInteresting":"Scrivi qualcosa di interessante:","sweetAlerts.writeSomething":"Scrivi qualcosa","sweetAlerts.youMustEnterPassword":"Devi inserire la tua password!","sweetAlerts.enterPassword":"Inserire la password","notification.infoMsg":"Messaggio informativo","notification.successMessage":"Messaggio di successo","notification.warningMessage":"Messaggio di avvertimento","notification.closeAfter3000ms":"Chiudi dopo 3000 ms","notification.errorMessage":"Messaggio di errore","notification.titleHere":"Titolo qui","notification.clickMe":"Cliccami!","notification.info":"Informazioni","notification.success":"Successo","notification.warning":"avvertimento","notification.error":"Errore","extraElements.callouts":"didascalie","extraElements.pricingTable":"Tabella dei prezzi","extraElements.testimonials":"Testimonianze","callouts.viewRange":"Visualizza gamma","callouts.basic":"Di base","pricingTable.basic":"Di base","pricingTable.circle":"Cerchio","pricingTable.classic":"Classico","pricingTable.dark":"Buio","pricingTable.personal":"PERSONALE","pricingTable.easyTranslation":"Traduzione semplice","pricingTable.awesomeGoogleFonts":"Font Google fantastici","pricingTable.hotelBookingSystem":"Sistema di prenotazione alberghiera","pricingTable.emailComposeInterface":"Email Compose Interface","pricingTable.locationFinderApp":"Location Finder App","pricingTable.buyNow":"acquista ora","pricingTable.business":"ATTIVITÀ COMMERCIALE","pricingTable.professional":"PROFESSIONALE","testimonials.basic":"Di base","testimonials.classic":"Classico","testimonials.standard":"Standard","extraPages.goHome":"Vai a casa","extraPages.ourClients":"I nostri clienti","extraPages.all":"Tutti","extraPages.graphicDesign":"disegno grafico","extraPages.logo":"logo","extraPages.mobileApp":"app mobile","extraPages.web":"web","extraPages.404Msg":"Spiacenti, si è verificato un errore. Pagina non trovata!","extraPages.500Msg":"Spiacente, il server va male","extraPages.aboutUs.showCase":"Mostra i tuoi servizi qui con le informazioni su di loro","aboutUs.readMore":"Leggi di più","extraPages.goSomewhere":"Andare da qualche parte","icon.material":"Oltre 900 icone ufficiali di design dei materiali","mail.mailbox":"Cassetta postale","mail.compose":"COMPORRE","mail.filters":"filtri","mail.labels":"etichette","picker.color.alpha":"Raccoglitrici Alpha","picker.color.hue":"Selezionatori di tinte","picker.color.circle":"Raccoglitori di cerchi","picker.color.compact":"Picker compatti","picker.color.block":"Raccoglitori di blocchi","picker.color.chrome":"Raccoglitrici di cromo","picker.color.github":"Github Pickers","picker.color.twitter":"Raccoglitori di Twitter","picker.color.withRedux":"Con Redux","picker.color.sketch":"Raccoglitori di schizzo","picker.color.material":"Raccoglitori di materiale","picker.color.slider":"Raccoglitori di cursori","picker.color.basic":"Raccoglitori di base","picker.color.basicToggle":"Toggle di base","picker.color.custom":"Raccoglitori personalizzati","picker.color.customPointer":"Puntatore personalizzato","picker.color.photoshop":"Selettori di Photoshop","picker.color.swatches":"Raccoglitrici di campioni","picker.color.basicPositioning":"Posizionamento di base","picker.date.pickers":"Pickers","picker.date.toggle":"Attiva / disattiva i raccoglitori","picker.date.input":"Input Field Picker","picker.date.localization":"Raccoglitori di localizzazione","picker.date.basic":"Selettore di base","picker.date.selectDay":"Seleziona giorno","table.marketingCampaign":"Campagna di marketing","table.thisWeek":"Questa settimana","table.defaultSorting":"Ordinamento predefinito","table.customSorting":"Ordinamento personalizzato","table.editableContent":"Contenuto modificabile","table.customFilter":"Filtro personalizzato","table.recentOrders":"Ordini Recenti","table.dataTable":"Tabella dati","table.basicTable":"Tabella di base","table.application":"Tabella delle applicazioni","todo":"Fare","todo.addTask":"AGGIUNGI TASK","todo.all":"Tutti","todo.filters":"filtri","todo.labels":"etichette","dashboard.recentActivities":"Attività recenti","dashboard.lastActivity":"L'ultima attività è stata 2 giorni fa","dashboard.currentProjects":"Elenco Progetti attuali","dashboard.toDoItems":"Lista delle cose da fare","dashboard.today":"Oggi","dashboard.marketingCampaign":"Campagna di marketing","dashboard.yourDailyFeed":"Il tuo feed giornaliero","dashboard.googleInsight":"Punteggio di intuizione di Google","dashboard.lastCalculated":"Las calcolato 1 mese fa","dashboard.refresh":"ricaricare","dashboard.upgradeToday":"aggiorna oggi","dashboard.onlineSignups":"Iscrizioni online","dashboard.lastMonthSale":"Vendita del mese scorso","dashboard.newVisits":"Nuove visite questo mese","dashboard.totalRevenue":"Totale delle entrate di quest'anno","dashboard.latestPosts":"ultimi post","dashboard.loremIpsum":"Lorem ipsum è finto contenuto dollaro si siede è ...","dashboard.viewAllPosts":"VISUALIZZA TUTTI I POSTI","dashboard.popularProducts":"Prodotti popolari","dashboard.popularProductsTxt":"È un fatto ormai consolidato che un lettore sarà distratto dal contenuto leggibile.","dashboard.allProducts":"tutti i prodotti","dashboard.userStatstics":"Statistiche utente","dashboard.orders":"Ordini","dashboard.thisYearSaleReport":"Questo rapporto di vendita di anno","dashboard.post9MonthData":"Invia dati a 9 mesi","dashboard.newCustomers":"nuovi clienti","dashboard.newThisMonth":"32 nuovi questo mese","dashboard.monthly":"Mensile","dashboard.totalView":"Vista totale","dashboard.annual":"Annuale","dashboard.newOrder":"Nuovo ordine","dashboard.visited":"visitato","dashboard.rapidPace":"Ritmo veloce","dashboard.slowPace":"Passo lento","dashboard.newConnections":"Nuove connessioni","dashboard.thisWeek":"3 Questa settimana","dashboard.newFeed":"23 nuovi feed","dashboard.newSubscriber":"Nuovo iscritto","dashboard.newArticles":"Nuovi articoli","dashboard.newAuthors":"Nuovi autori","dashboard.avgDailyTraffic":"Traffico giornaliero medio","dashboard.popularAuthors":"Autori popolari","dashboard.authorsWith":"Autori con oltre 500 avg. vista","dashboard.popularArticles":"Articoli popolari","dashboard.comments":"Commenti","component.alert.default":"Avvisi predefiniti","component.alert.highlighted":"Avvisi evidenziati","component.alert.dismissible":"Avvisi non ammissibili","component.alert.withIcons":"Avvisi con icone","component.alert.withDetailedHTML":"Avviso con HTML dettagliato","component.appbar.simple":"App semplice","component.appbar.colored":"Barra delle applicazioni colorata","component.appbar.fullyFeatured":"Barra delle applicazioni completamente in evidenza","component.autocomplete.Basic":"Di base","component.autocomplete.controlinSelection":"Selezione del controllo","component.autocomplete.Behaviors":"comportamenti","component.autocomplete.inputSize":"Dimensione di input","component.autocomplete.menuAlign":"Menu Allinea","component.avatars.image":"Avatar di immagini","component.avatars.letter":"Avatar di lettere","component.avatars.icon":"Avatar di icone","component.badge.scaling":"Distillare i distintivi","component.badge.insideLinks":"All'interno di collegamenti e pulsanti","component.badge.contextual":"Variazioni contestuali","component.badge.pill":"Distintivi della pillola","component.badge.link":"Link Badge","component.bottomNavigation.withLabels":"Navigazione inferiore con etichette","component.bottomNavigation.withActiveLabels":"Navigazione inferiore con etichetta attiva","component.bottomNavigation.withNoLabels":"Navigazione inferiore senza etichetta","component.breadcrumbs.simple":"Semplice","component.breadcrumbs.noList":"Nessuna lista","component.buttons.colorScheme":"Combinazione di colori","component.buttons.colorSchemeTxt":"Schema dei colori Bootstrap con il concetto di materiale","component.buttons.icon":"Pulsanti icona","component.buttons.iconTxt":"Puoi scegliere qualsiasi icona dalle icone dei caratteri elencati nella pagina Icone. O sentiti libero di aggiungere nuove icone di font e usarlo.","component.buttons.differentSizes":"Misure differenti","component.buttons.differentSizesTxt":"Bottoni materiale con diverse dimensioni","component.buttons.flatFullWidth":"Pulsanti di larghezza piatta e intera","component.buttons.flatFullWidthTxt":"Tutti i pulsanti di tipo con stati disabilitati","component.buttons.raised":"Pulsanti sollevati","component.buttons.raisedTxt":"Schema dei colori Bootstrap con il concetto di materiale","component.buttons.fab":"Pulsanti di azione fluttuanti","component.buttons.fabTxt":"Schema dei colori Bootstrap con il concetto di materiale","component.buttons.socialMedia":"Pulsanti di social media","component.buttons.socialMediaTxt":"Vari pulsanti di social media per il tuo progetto","component.buttons.complex":"Pulsanti complessi","component.buttonGroup.horizontalVariations":"Variazioni orizzontali","component.buttonGroup.defaultStyle":"Stile di gruppo pulsanti predefiniti","component.buttonGroup.highlightedStyle":"Evidenziato stile del gruppo di pulsanti","component.buttonGroup.flatStyle":"Stile del gruppo di pulsanti piatto","component.buttonGroup.default":"Gruppo di pulsanti predefinito","component.buttonGroup.flat":"Gruppo di pulsanti piatto","component.buttonGroup.highlighted":"Gruppo di pulsanti evidenziati","component.buttonGroup.icon":"Icona Pulsante Gruppo","component.buttonGroup.iconFlat":"Icona Gruppo pulsante piatto","component.buttonGroup.nested":"Gruppo di pulsanti annidati","component.cards.basic":"Carte base","component.cards.special":"Carte speciali","component.cards.withHeader":"Carte con intestazione, piè di pagina e allineamento","component.cards.navigational":"Carte di navigazione","component.cards.image":"Carte Immagine","component.cards.solid":"Carte solide","component.carousel.basic":"Carosello di base","component.carousel.basicTxt":"Carosello di base BS4 alimentato con ReactStrap","component.carousel.product":"Carousel prodotto","component.carousel.productTxt":"Una giostra con vista a griglia orizzontale","component.carousel.testimonial":"Testimonial Carousel","component.carousel.testimonialTxt":"Un elemento carosello alla volta","component.chips.default":"Chip predefinito","component.chips.outline":"Chip di contorno","component.chips.chipWithText":"Chip con Avatar di testo","component.chips.clickable":"Chip cliccabile","component.chips.withImage":"Chip con Avatar di immagini","component.chips.deletable":"Chip eliminabile","component.chips.withIcon":"Chip con Icon Avatar","component.chips.custom":"Chip cliccabile personalizzato","component.chips.array":"Chip Array","component.chips.withInput":"Implementazione di chip con casella di input","component.dividers.list":"Lista divisori","component.dividers.inset":"Divisori interni","component.dividers.default":"Predefinito","component.drawer.persistent":"Cassetto persistente","component.drawer.permanent":"Cassetto permanente","component.drawer.mini":"Mini cassetto","component.drawer.responsive":"Cassetto reattivo","component.expansionPanel.simple":"Semplice pannello di espansione","component.expansionPanel.controlled":"Fisarmonica controllata","component.expansionPanel.secondary":"Intestazione secondaria e colonne","component.gridList.image":"Elenco griglia di immagini","component.gridList.advanced":"Elenco griglia avanzato","component.gridList.singleLine":"Elenco Griglia a riga singola","component.gridList.withTitlebars":"Elenco griglia con barre del titolo","component.lists.folder":"Elenco cartelle","component.lists.switch":"Commuta i controlli dell'elenco","component.lists.dividers":"Lista divisori","component.lists.simple":"Lista semplice","component.lists.inset":"Elenco inserto","component.lists.nested":"Elenco annidato","component.lists.checkbox":"Checkbox Controlli dell'elenco secondario","component.lists.checkboxControls":"Controlli Elenco caselle di controllo","component.lists.pinned":"Elenco Sottotitoli aggiunti","component.lists.interactive":"Controlli elenco interattivo","component.chips":"Recente","component.menusPaper.simple":"Menu semplici","component.menusPaper.withIcon":"Menu con l'icona","component.menusPaper.withMoreButton":"Menu con più pulsanti","component.menusPaper.withSelectedValue":"Menu con valore selezionato","component.menusPaper.paper":"Carta","component.pickers.Date":"Raccoglitori di date","component.progress.indeterminateCircular":"Circolare indeterminata","component.progress.indeterminateLinear":"Lineare indeterminata","component.progress.determinateLinear":"Determina lineare","component.progress.bufferLinear":"Buffer lineare","component.progress.interactiveIntegration":"Integrazione interattiva","component.progress.queryLinear":"Interrogazione lineare","component.selectionControl.checkboxes":"caselle di controllo","component.selectionControl.disabled":"Disabilitato","component.selectionControl.intermediate":"Intermedio","component.selectionControl.checkboxesWithForm":"Caselle di controllo con gruppo di moduli","component.selectionControl.basicRadio":"Pulsanti radio di base","component.selectionControl.disabledRadio":"Pulsanti radio disabilitati","component.selectionControl.withError":"Con messaggio di errore","component.selectionControl.switches":"Interruttori","component.selectionControl.verticalSwitches":"Interruttori verticali","component.selectionControl.groupedSwitches":"Interruttori raggruppati","component.selectionControl.verticalImplementation":"Implementazione verticale di interruttori","component.selectionControl.generalSettings":"impostazioni generali","component.selectionControl.themeSettings":"Impostazioni tema","component.selectionControl.onOffSwitches":"interruttori on / off","component.selectionControl.verticalInlineRadio":"Pulsanti radio verticali e in linea","component.selectionControl.checkboxesWithFormTxt":"I menu sono posizionati sopra i loro elementi di emissione in modo che la voce di menu attualmente selezionata appaia sopra l'elemento emittente.","component.selects.simple":"Di base","component.selects.native":"Modificatore","component.selects.multiple":"Direzione","component.selects.dialog":"Dimensione","component.selects.select":"Selezionare","component.snackbars.transition":"Direzione del controllo di transizione","component.snackbars.simple":"Semplice","component.snackbars.positioned":"posizionato","component.snackbars.messageWithButton":"Messaggio con pulsante","component.snackbars.colors":"Colori","component.snackbars.multilineText":"Testo multilinea","component.snackbars.onlyMessage":"Solo messaggio","component.snackbars.withIconButton":"Messaggio con IconButton","component.stepper.horizontalLinear":"Lineare orizzontale","component.stepper.horizontalLinearAlternativeLabel":"Lineare orizzontale - Etichetta alternativa","component.stepper.vertical":"Stepper verticale","component.stepper.horizontalNonLinear":"Orizzontale Non lineare","component.stepper.horizontalNonLinearAlternativeLabel":"Orizzontale non lineare - Etichetta alternativa","component.stepper.mobileDots":"Stepper mobile - Punti","component.stepper.mobileProgress":"Mobile Stepper: progresso","component.stepper.mobileText":"Stepper mobile - Testo","component.tabs.basic":"Schede di base","component.tabs.fixed":"Fixed Tabs Full width","component.tabs.icon":"Schede icona","component.tabs.disabled":"Scheda disabilitata","component.tabs.wrappedLabels":"Etichette avvolte","component.tabs.iconWithLabel":"Schede icona con etichetta","component.tabs.fixedCentered":"Corrette le schede centrate","component.tabs.automaticScroll":"Pulsanti di scorrimento automatici","component.tabs.forcedScroll":"Pulsanti di scorrimento forzato","component.tabs.preventScroll":"Previene i pulsanti di scorrimento","component.textFields.textfield":"Campo di testo","component.textFields.components":"componenti","component.textFields.layout":"disposizione","component.textFields.inputAdornments":"Input ornamenti","component.textFields.formattedInputs":"Input formattati","component.textFields.inputs":"ingressi","component.tooltips.avatar":"Tooltip Avatar","component.tooltips.button":"Pulsante Tooltip","component.tooltips.icon":"Icona Tooltip","component.tooltips.controlled":"Tooltip controllato","component.tooltips.positioned":"Tooltip posizionato","component.typography.lightHeadings":"Titoli chiari","component.typography.normalHeadings":"Intestazioni normali","component.typography.semiBoldHeadings":"Intestazioni semi-audaci","component.typography.boldHeadings":"Intestazioni audaci","component.typography.paragraphText":"Testo del paragrafo","component.typography.leadParagraphText":"Testo del paragrafo principale","component.typography.unstyledList":"Elenco Unstyled","component.typography.orderedList":"Lista ordinata","component.typography.unorderedList":"Lista non ordinata","component.typography.listWithIcons":"Elenco con icone","component.typography.compactList":"Elenco compatto","component.typography.extendedList":"Elenco esteso","component.typography.leftIconGroupedList":"Icona raggruppata a sinistra","component.typography.rightIconGroupedList":"Elenco delle icone a destra","component.typography.badgesGroupedList":"Lista raggruppata distintivi","component.typography.defaultDescriptionList":"Elenco di descrizione predefinito","component.typography.evenOddDescriptionList":"Elenco di descrizione pari-dispari","component.typography.leftBlockquoteWithAuthorAvatar":"Left Blockquote With Author Avatar","component.typography.rightBlockquoteWithAuthorAvatar":"Right Blockquote With Author Avatar","signIn.success":"Accedi con successo!","signIn.error":"E-mail o password non validi!","signUp.success":"account creato con successo","signUp.error":"Destra","signIn.success1":"Destra","signIn.signUp":"Crea un account","signIn.connectWith":"o connettersi con","signUp.alreadyMember":"Sono già un membro","appModule.signin":"Registrati","appModule.signup":"Iscriviti","pages.samplePage":"Pagina di esempio","pages.samplePage.description":"Inizia a costruire la tua app. Felice codifica!","mailNotification.title":"messaggi","appNotification.title":"notifiche","mailNotification.message":"Nessun nuovo messaggio al momento!","appNotification.message":"Nessuna notifica al momento!","popup.profile":"Profilo","popup.setting":"Ambientazione","popup.logout":"Disconnettersi","popup.updateData":"Aggiorna dati","popup.detailedLog":"Log dettagliato","popup.statistics":"statistica","popup.clearData":"Cancella i dati","component.selectionControl.radioBtnGroup":"Gruppo pulsanti radio","component.popover.anchorPlayground":"Parco giochi di ancoraggio"}

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _es = _interopRequireDefault(__webpack_require__(1330));

var _es_ES = _interopRequireDefault(__webpack_require__(1331));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var saLang = {
  messages: _objectSpread({}, _es_ES["default"]),
  locale: 'es',
  data: _es["default"]
};
var _default = saLang;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(saLang, "saLang", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/es_ES.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/es_ES.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_es, "_es", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/es_ES.js");

  __REACT_HOT_LOADER__.register(_es_ES, "_es_ES", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/es_ES.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/es_ES.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/es_ES.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/es_ES.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/es_ES.js");

  __REACT_HOT_LOADER__.register(saLang, "saLang", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/es_ES.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/es_ES.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/es_ES.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/es_ES.js");
}();

;

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.es=a())}(this,function(){"use strict";return[{locale:"es",pluralRuleFunction:function(e,a){return a?"other":1==e?"one":"other"},fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-419",parentLocale:"es"},{locale:"es-AR",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} días",other:"dentro de {0} días"},past:{one:"hace {0} días",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"seg.",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} seg.",other:"dentro de {0} seg."},past:{one:"hace {0} seg.",other:"hace {0} seg."}}}}},{locale:"es-BO",parentLocale:"es-419"},{locale:"es-BR",parentLocale:"es-419"},{locale:"es-BZ",parentLocale:"es-419"},{locale:"es-CL",parentLocale:"es-419"},{locale:"es-CO",parentLocale:"es-419"},{locale:"es-CR",parentLocale:"es-419"},{locale:"es-CU",parentLocale:"es-419"},{locale:"es-DO",parentLocale:"es-419",fields:{year:{displayName:"Año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"Mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"Día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"Minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"Segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-EA",parentLocale:"es"},{locale:"es-EC",parentLocale:"es-419"},{locale:"es-GQ",parentLocale:"es"},{locale:"es-GT",parentLocale:"es-419"},{locale:"es-HN",parentLocale:"es-419"},{locale:"es-IC",parentLocale:"es"},{locale:"es-MX",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el año próximo","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"en {0} a",other:"en {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el mes próximo","-1":"el mes pasado"},relativeTime:{future:{one:"en {0} mes",other:"en {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"en {0} m",other:"en {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"en {0} día",other:"en {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"en {0} h",other:"en {0} n"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"en {0} min",other:"en {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"en {0} s",other:"en {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-NI",parentLocale:"es-419"},{locale:"es-PA",parentLocale:"es-419"},{locale:"es-PE",parentLocale:"es-419"},{locale:"es-PH",parentLocale:"es"},{locale:"es-PR",parentLocale:"es-419"},{locale:"es-PY",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"seg.",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} seg.",other:"dentro de {0} seg."},past:{one:"hace {0} seg.",other:"hace {0} seg."}}}}},{locale:"es-SV",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-US",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el año próximo","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el mes próximo","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-UY",parentLocale:"es-419"},{locale:"es-VE",parentLocale:"es-419"}]});


/***/ }),
/* 1331 */
/***/ (function(module, exports) {

module.exports = {"sidebar.main":"Principal","sidebar.dashboard":"Tablero","sidebar.dashboard.default":"Defecto","sidebar.dashboard.ecommerce":"eCommerce","sidebar.dashboard.news":"Noticias","sidebar.dashboard.intranet":"Intranet","sidebar.components":"Componentes","sidebar.components.alerts":"Alertas","sidebar.components.appbar":"Barra de aplicaciones","sidebar.components.autocomplete":"Autocompletar","sidebar.components.avatars":"Avatares","sidebar.components.badge":"Distintivo","sidebar.components.bottomNavigation":"Navegación inferior","sidebar.components.breadcrumbs":"Migas de pan","sidebar.components.buttons":"Botones","sidebar.components.buttonGroup":"Grupo de botones","sidebar.components.cards":"Tarjetas","sidebar.components.carousel":"Carrusel","sidebar.components.chips":"Papas fritas","sidebar.components.colorPicker":"Selector de color","sidebar.components.modals":"Modals","sidebar.components.dividers":"Divisores","sidebar.components.expansionPanel":"Panel de Expansión","sidebar.components.drawer":"Cajón","sidebar.components.gridList":"Lista de cuadrícula","sidebar.components.lists":"Liza","sidebar.components.menusPaper":"Menús y papel","sidebar.components.pickers":"Pickers","sidebar.components.popovers":"Popovers","sidebar.components.progress":"Progreso","sidebar.components.selects":"Selecciona","sidebar.components.selectionControl":"Controles de selección","sidebar.components.snackbars":"Barras de merienda","sidebar.components.stepper":"Paso a paso","sidebar.components.tables":"Mesas","sidebar.components.tabs":"Pestañas","sidebar.components.textFields":"Campos de texto","sidebar.components.tooltips":"Información sobre herramientas","sidebar.components.typography":"Tipografía","sidebar.widgets":"Widgets","sidebar.metrics":"Métrica","sidebar.view":"Ver","sidebar.tables":"Mesas","sidebar.tables.basicTable":"Tabla básica","sidebar.tables.dataTable":"Tabla de datos","sidebar.timeLine":"Time Line","sidebar.timeLine.default":"Defecto","sidebar.timeLine.defaultwithIcons":"Predeterminado con iconos","sidebar.timeLine.leftAligned":"Alineado a la izquierda","sidebar.timeLine.zigzag":"Zigzag","sidebar.customViews":"Vistas personalizadas","sidebar.customViews.plainListView":"Vista de lista simple","sidebar.customViews.withDivider":"Lista simple con divisor","sidebar.customViews.cardListView":"Vista de lista de tarjetas","sidebar.form":"Formar","sidebar.forms":"Formularios","sidebar.forms.components":"Componentes","sidebar.forms.stepper":"Paso a paso","sidebar.extensions":"Extensiones","sidebar.editors":"Editores","sidebar.editors.CKEditor":"CKEditor","sidebar.editors.WYSISWYGEditor":"Editor WYSIWYG","sidebar.pickers":"Pickers","sidebar.pickers.dateTimePickers":"Selector de fecha y hora","sidebar.pickers.colorPickers":"Selector de color","sidebar.extensions.dragNDrop":"Arrastrar y soltar","sidebar.extensions.dropzone":"Zona de descenso","sidebar.extensions.sweetAlert":"Sweet Alert","sidebar.extensions.notification":"Notificación","sidebar.chart":"Gráfico","sidebar.chart.line":"Gráfico de linea","sidebar.chart.bar":"Gráfico de barras","sidebar.chart.area":"Carta de área","sidebar.chart.composed":"Gráfico compuesto","sidebar.chart.scatter":"Gráfico de dispersión","sidebar.chart.pie":"Gráfico circular","sidebar.chart.radial":"Gráfico radial","sidebar.chart.radar":"Gráfico de radar","sidebar.chart.tree":"Árbol de Carta","sidebar.map":"Mapa de Google","sidebar.map.simple":"Mapa simple","sidebar.map.styled":"Mapa de estilo","sidebar.map.geoLocation":"Ubicación geográfica","sidebar.map.mapDirection":"Dirección del mapa","sidebar.map.overlay":"Superposición de mapa","sidebar.map.kmLayer":"Mapa Km Layer","sidebar.map.popupInfo":"Mapa de información emergente","sidebar.map.trafficLayer":"Mapa Traffic Layer","sidebar.map.streetView":"vista de calle","sidebar.map.eventListener":"Escucha del evento","sidebar.map.mapDrawing":"Mapa de dibujo","sidebar.map.mapClustering":"Agrupación de mapas","sidebar.modules":"Módulos","sidebar.calendar":"Calendario","sidebar.calendar.basic":"BASIC","sidebar.calendar.cultures":"Culturas","sidebar.calendar.dnd":"Dnd","sidebar.calendar.popup":"Surgir","sidebar.calendar.rendering":"Representación","sidebar.calendar.selectable":"Seleccionable","sidebar.calendar.timeslots":"Ranuras de tiempo","sidebar.eCommerce":"eCommerce","sidebar.eCommerce.productsList":"Lista de productos","sidebar.eCommerce.productsGrid":"Cuadrícula de productos","sidebar.appModule":"Módulo de aplicación","sidebar.appModule.login":"Inicio de sesión Página","sidebar.appModule.login2":"Inicio de sesión Página 2","sidebar.appModule.loginStepper":"Iniciar sesión con Stepper","sidebar.appModule.signup":"Registrarse Página","sidebar.appModule.signup2":"Registrarse Página 2","sidebar.appModule.forgotPassword":"Olvidé mi contraseña","sidebar.appModule.forgotPassword2":"Olvidé mi contraseña 2","sidebar.appModule.lock":"Pantalla de bloqueo","sidebar.appModule.lock2":"Pantalla de bloqueo 2","sidebar.appModule.toDo":"Que hacer","sidebar.appModule.toDoRedux":"To-Do Redux","sidebar.appModule.mail":"Correo","sidebar.appModule.mailRedux":"Mail Redux","sidebar.appModule.chat":"Charla","sidebar.appModule.chatRedux":"Chat Redux","sidebar.appModule.contact":"Contacto","sidebar.appModule.contactRedux":"Contactar con Redux","sidebar.extras":"Extras","sidebar.icons":"Iconos","sidebar.icons.material":"Iconos de material de Google","sidebar.extraElements":"Elementos extra","sidebar.extraElements.pricingTable":"Tabla de precios","sidebar.extraElements.callouts":"Llamadas","sidebar.extraElements.testimonials":"Testimonios","sidebar.extraPages":"Páginas extra","sidebar.extraPages.aboutUs":"Sobre nosotros","sidebar.extraPages.contactUs":"Contáctenos","sidebar.extraPages.blog":"Blog","sidebar.extraPages.faq":"Preguntas más frecuentes","sidebar.extraPages.portfolio":"portafolio","sidebar.extraPages.404":"Página de error 404","sidebar.extraPages.500":"500 página de error","sidebar.menuLevels":"Niveles de menú","sidebar.menuLevels.level1":"Nivel 1","sidebar.menuLevels.level2":"Nivel 2","sidebar.menuLevels.level3":"Nivel 3","appModule.forgotPassword":"¿Olvidaste tu contraseña?","appModule.dntRememberEmail":"¿No recuerdas tu correo electrónico?","appModule.contactSupport":"Soporte de contacto","appModule.resetPassword":"Restablecer la contraseña","appModule.enterPasswordUnlock":"¡Ingresa tu contraseña para desbloquear la pantalla!","appModule.unlock":"desbloquear","appModule.signInDiffAccount":"Inicie sesión usando una cuenta diferente","appModule.rememberMe":"Recuérdame","appModule.signIn":"Registrarse","appModule.next":"Siguiente","appModule.back":"Espalda","appModule.allStepsCompleted":"Todos los pasos completados","appModule.reset":"Reiniciar","appModule.loginSuccessfully":"Iniciar sesión exitosamente","appModule.password":"Contraseña","appModule.email":"Email","appModule.name":"Nombre","appModule.phone":"Teléfono","appModule.designation":"Designacion","appModule.regsiter":"Registro","appModule.hvAccount":"Tener una cuenta","appModule.createAccount":"Crea una cuenta","chart.area":"Gráfico de área","chart.bar":"Gráfico de barras","chart.composed":"Gráfico compuesto","chart.line":"Gráfico de líneas","chart.pie":"Gráfico de torta","chart.radar":"Gráfico de radar","chart.radial":"Gráfico radial","chart.scatter":"Gráfico de dispersión","chart.tree":"Gráfico de árbol","chat.selectUserChat":"Seleccionar usuario para iniciar el chat","chat.selectContactChat":"Seleccionar contacto para iniciar el chat","chat.chatUser":"Chats","chat.contacts":"Contactos","chat.searchStartNewChat":"Buscar o iniciar un chat nuevo","chat.typeMessage":"Escribe y presiona enter para enviar el mensaje","chat.status":"es un estado ... no es tu diario ...","contact.saveContact":"Guardar contacto","contact.addContact":"Agregar contacto","contact.searchContact":"Buscar contacto","button.modify":"Modificar","button.delete":"Borrar","button.yes":"Sí","button.no":"No","eCommerce.readMore":"Lee mas","eCommerce.addToCart":"añadir a la cesta","eCommerce.buyNow":"Compra ahora","extension.sweetAlerts":"Sweet Alerts","extension.notification":"Notificación","sweetAlerts.basic":"BASIC","sweetAlerts.description":"Con descripción","sweetAlerts.success":"Éxito","sweetAlerts.warning":"Advertencia","sweetAlerts.custom":"Personalizado","sweetAlerts.htmlTag":"Etiqueta Html","sweetAlerts.prompt":"Rápido","sweetAlerts.itsBlue":"¡Es azul!","sweetAlerts.passwordPrompt":"Indicación de contraseña","sweetAlerts.customStyle":"Estilo personalizado","sweetAlerts.itPretty":"Es lindo, ¿verdad?","sweetAlerts.btnClicked":"Hiciste clic en el botón!","sweetAlerts.youWillFind":"¡Encontrarás que están listos!","sweetAlerts.youWillNotAble":"¡No podrás recuperar este archivo imaginario!","sweetAlerts.hereIsaMessage":"¡Aquí hay un mensaje!","sweetAlerts.goodJob":"¡Buen trabajo!","sweetAlerts.yesDeleteIt":"Sí, eliminarlo!","sweetAlerts.areYouSure":"¿Estás seguro?","sweetAlerts.doYouLikeThumb":"¿Te gustan los pulgares?","sweetAlerts.anInput":"Una entrada!","sweetAlerts.writeSomethingInteresting":"Escribe algo interesante:","sweetAlerts.writeSomething":"Escribe algo","sweetAlerts.youMustEnterPassword":"¡Debes ingresar tu contraseña!","sweetAlerts.enterPassword":"Introducir la contraseña","notification.infoMsg":"Mensaje de información","notification.successMessage":"Mensaje de éxito","notification.warningMessage":"Mensaje de advertencia","notification.closeAfter3000ms":"Cerrar después de 3000ms","notification.errorMessage":"Mensaje de error","notification.titleHere":"Título aquí","notification.clickMe":"¡Haz click en mi!","notification.info":"Información","notification.success":"Éxito","notification.warning":"Advertencia","notification.error":"Error","extraElements.callouts":"Llamadas","extraElements.pricingTable":"Tabla de precios","extraElements.testimonials":"Testimonios","callouts.viewRange":"Ver rango","callouts.basic":"BASIC","pricingTable.basic":"BASIC","pricingTable.circle":"Circulo","pricingTable.classic":"Clásico","pricingTable.dark":"Oscuro","pricingTable.personal":"PERSONAL","pricingTable.easyTranslation":"Traducción fácil","pricingTable.awesomeGoogleFonts":"Fuentes increíbles de Google","pricingTable.hotelBookingSystem":"Sistema de reserva de hotel","pricingTable.emailComposeInterface":"Interfaz de redacción de correo electrónico","pricingTable.locationFinderApp":"Aplicación de buscador de ubicación","pricingTable.buyNow":"compra ahora","pricingTable.business":"NEGOCIO","pricingTable.professional":"PROFESIONAL","testimonials.basic":"BASIC","testimonials.classic":"Clásico","testimonials.standard":"Estándar","extraPages.goHome":"Ir a casa","extraPages.ourClients":"Nuestros clientes","extraPages.all":"Todas","extraPages.graphicDesign":"diseño gráfico","extraPages.logo":"logo","extraPages.mobileApp":"aplicación movil","extraPages.web":"web","extraPages.404Msg":"Vaya, ha ocurrido un error. ¡Página no encontrada!","extraPages.500Msg":"Lo siento, el servidor sale mal","extraPages.aboutUs.showCase":"Muestre sus servicios aquí con información sobre ellos","aboutUs.readMore":"Lee mas","extraPages.goSomewhere":"Ve a algún lugar","icon.material":"Más de 900 iconos de diseño de material oficial","mail.mailbox":"Buzón","mail.compose":"COMPONER","mail.filters":"Filtros","mail.labels":"Etiquetas","picker.color.alpha":"Recolectores alfa","picker.color.hue":"Recogedores de tono","picker.color.circle":"Seleccionadores de círculo","picker.color.compact":"Selector compacto","picker.color.block":"Selector de bloque","picker.color.chrome":"Recogedores de Chrome","picker.color.github":"Segadores Github","picker.color.twitter":"Seleccionadores de Twitter","picker.color.withRedux":"Con Redux","picker.color.sketch":"Recogedores de bosquejos","picker.color.material":"Recogedores de materiales","picker.color.slider":"Seleccionadores de control deslizante","picker.color.basic":"Selector básico","picker.color.basicToggle":"Alternar básico","picker.color.custom":"Recogedores personalizados","picker.color.customPointer":"Puntero personalizado","picker.color.photoshop":"Selector de Photoshop","picker.color.swatches":"Selector de muestras","picker.color.basicPositioning":"Posicionamiento Básico","picker.date.pickers":"Pickers","picker.date.toggle":"Selectores","picker.date.input":"Selector de campo de entrada","picker.date.localization":"Seleccionadores de localización","picker.date.basic":"Selector básico","picker.date.selectDay":"Seleccionar día","table.marketingCampaign":"CAMPAÑA de Marketing","table.thisWeek":"Esta semana","table.defaultSorting":"Clasificación por defecto","table.customSorting":"Clasificación personalizada","table.editableContent":"Contenido editable","table.customFilter":"Filtro personalizado","table.recentOrders":"órdenes recientes","table.dataTable":"Tabla de datos","table.basicTable":"Tabla básica","table.application":"Tabla de aplicaciones","todo":"Que hacer","todo.addTask":"AGREGAR TAREA","todo.all":"Todas","todo.filters":"Filtros","todo.labels":"Etiquetas","dashboard.recentActivities":"Actividades recientes","dashboard.lastActivity":"Última actividad fue hace 2 días","dashboard.currentProjects":"Lista de proyectos actuales","dashboard.toDoItems":"Lista de elementos para hacer","dashboard.today":"Hoy","dashboard.marketingCampaign":"CAMPAÑA de Marketing","dashboard.yourDailyFeed":"Tu alimentación diaria","dashboard.googleInsight":"Puntaje de información de Google","dashboard.lastCalculated":"Las calculó hace 1 mes","dashboard.refresh":"Refrescar","dashboard.upgradeToday":"actualice hoy","dashboard.onlineSignups":"Suscripciones en línea","dashboard.lastMonthSale":"Última venta del mes","dashboard.newVisits":"Nuevas visitas este mes","dashboard.totalRevenue":"Ingresos totales este año","dashboard.latestPosts":"últimas publicaciones","dashboard.loremIpsum":"Lorem ipsum es un tonto contenido dólar sentarse es ...","dashboard.viewAllPosts":"VER TODOS LOS PUESTOS","dashboard.popularProducts":"productos populares","dashboard.popularProductsTxt":"Es un hecho establecido desde hace tiempo que un lector se distraerá con el contenido legible.","dashboard.allProducts":"todos los productos","dashboard.userStatstics":"Estadísticas de usuario","dashboard.orders":"Pedidos","dashboard.thisYearSaleReport":"Reporte de venta de este año","dashboard.post9MonthData":"Publicar datos de 9 meses","dashboard.newCustomers":"nuevos clientes","dashboard.newThisMonth":"32 nuevos este mes","dashboard.monthly":"Mensual","dashboard.totalView":"Vista total","dashboard.annual":"Anual","dashboard.newOrder":"Nuevo orden","dashboard.visited":"Visitó","dashboard.rapidPace":"Paso veloz","dashboard.slowPace":"Paso lento","dashboard.newConnections":"Nuevas conexiones","dashboard.thisWeek":"3 Esta semana","dashboard.newFeed":"23 nuevos feeds","dashboard.newSubscriber":"Nuevo suscriptor","dashboard.newArticles":"Artículos nuevos","dashboard.newAuthors":"Nuevos autores","dashboard.avgDailyTraffic":"Avg Daily Traffic","dashboard.popularAuthors":"Autores populares","dashboard.authorsWith":"Autores con más de 500 prom. ver","dashboard.popularArticles":"articulos populares","dashboard.comments":"Comentarios","component.alert.default":"Alertas predeterminadas","component.alert.highlighted":"Alertas destacadas","component.alert.dismissible":"Alertas imposibles","component.alert.withIcons":"Alertas con iconos","component.alert.withDetailedHTML":"Alerta con HTML detallado","component.appbar.simple":"Barra de aplicación simple","component.appbar.colored":"Barra de aplicaciones de color","component.appbar.fullyFeatured":"Barra de aplicaciones totalmente destacada","component.autocomplete.Basic":"BASIC","component.autocomplete.controlinSelection":"Selección de control","component.autocomplete.Behaviors":"Comportamientos","component.autocomplete.inputSize":"Tamaño de entrada","component.autocomplete.menuAlign":"Menú Alinear","component.avatars.image":"Avatares de imagen","component.avatars.letter":"Carta Avatares","component.avatars.icon":"Avatares de icono","component.badge.scaling":"Insignias de escala","component.badge.insideLinks":"Enlaces y botones internos","component.badge.contextual":"Variaciones contextuales","component.badge.pill":"Insignias de píldoras","component.badge.link":"Insignias de enlace","component.bottomNavigation.withLabels":"Navegación inferior con etiquetas","component.bottomNavigation.withActiveLabels":"Navegación inferior con etiqueta activa","component.bottomNavigation.withNoLabels":"Navegación inferior sin etiqueta","component.breadcrumbs.simple":"Sencillo","component.breadcrumbs.noList":"Sin lista","component.buttons.colorScheme":"Esquema de colores","component.buttons.colorSchemeTxt":"Esquema de color Bootstrap con concepto de material","component.buttons.icon":"Botones de icono","component.buttons.iconTxt":"Puede elegir cualquier ícono de los íconos de fuentes que figuran en la página de Iconos. O siéntase libre de agregar cualquier ícono de fuente nuevo y usarlo.","component.buttons.differentSizes":"Diferentes tamaños","component.buttons.differentSizesTxt":"Botones de material con diferentes tamaños","component.buttons.flatFullWidth":"Botones de ancho plano y completo","component.buttons.flatFullWidthTxt":"Todos los botones de tipo con estados desactivados","component.buttons.raised":"Botones elevados","component.buttons.raisedTxt":"Esquema de color Bootstrap con concepto de material","component.buttons.fab":"Botones de acción flotante","component.buttons.fabTxt":"Esquema de color Bootstrap con concepto de material","component.buttons.socialMedia":"Botones de redes sociales","component.buttons.socialMediaTxt":"Varios botones de redes sociales para su proyecto","component.buttons.complex":"Botones complejos","component.buttonGroup.horizontalVariations":"Variaciones horizontales","component.buttonGroup.defaultStyle":"Estilo de grupo de botones predeterminados","component.buttonGroup.highlightedStyle":"Estilo resaltado del grupo de botones","component.buttonGroup.flatStyle":"Estilo de grupo de botón plano","component.buttonGroup.default":"Grupo de botones predeterminados","component.buttonGroup.flat":"Grupo de botones planos","component.buttonGroup.highlighted":"Grupo de botones resaltados","component.buttonGroup.icon":"Grupo de botones de icono","component.buttonGroup.iconFlat":"Grupo de botones planos de iconos","component.buttonGroup.nested":"Grupo de botones anidados","component.cards.basic":"Tarjetas básicas","component.cards.special":"Tarjetas especiales","component.cards.withHeader":"Tarjetas con encabezado, pie de página y alineación","component.cards.navigational":"Tarjetas de navegación","component.cards.image":"Tarjetas de imagen","component.cards.solid":"Tarjetas sólidas","component.carousel.basic":"Carrusel básico","component.carousel.basicTxt":"Carrusel básico BS4 con ReactStrap","component.carousel.product":"Carrusel de productos","component.carousel.productTxt":"Un carrusel de vista de cuadrícula horizontal","component.carousel.testimonial":"Carrusel testimonial","component.carousel.testimonialTxt":"Un carrusel de elementos a la vez","component.chips.default":"Chip predeterminado","component.chips.outline":"Chip de esquema","component.chips.chipWithText":"Chip con texto Avatar","component.chips.clickable":"Chip Clickable","component.chips.withImage":"Chip con imagen de Avatar","component.chips.deletable":"Chip eliminable","component.chips.withIcon":"Chip con el icono de Avatar","component.chips.custom":"Chip Clickable personalizado","component.chips.array":"Chip Array","component.chips.withInput":"Implementación de chips con cuadro de entrada","component.dividers.list":"List Dividers","component.dividers.inset":"Divisores de inserción","component.dividers.default":"Defecto","component.drawer.persistent":"Cajón persistente","component.drawer.permanent":"Cajón permanente","component.drawer.mini":"Mini cajón","component.drawer.responsive":"Cajón de respuesta","component.expansionPanel.simple":"Panel de expansión simple","component.expansionPanel.controlled":"Acordeón controlado","component.expansionPanel.secondary":"Título secundario y Columnas","component.gridList.image":"Lista de cuadrícula solo de imagen","component.gridList.advanced":"Lista de rejilla avanzada","component.gridList.singleLine":"Lista de cuadrícula de una sola línea","component.gridList.withTitlebars":"Cuadrícula lista con barras de título","component.lists.folder":"Lista de carpetas","component.lists.switch":"Controles de lista de cambio","component.lists.dividers":"List Dividers","component.lists.simple":"Lista simple","component.lists.inset":"Lista de inserción","component.lists.nested":"Lista anidada","component.lists.checkbox":"Casilla de verificación Controles de lista secundaria","component.lists.checkboxControls":"Controles de lista de casillas de verificación","component.lists.pinned":"Lista de subcarpetas fijadas","component.lists.interactive":"Controles de lista interactivos","component.chips":"Reciente","component.menusPaper.simple":"Menús simples","component.menusPaper.withIcon":"Menú con icono","component.menusPaper.withMoreButton":"Menú con más botón","component.menusPaper.withSelectedValue":"Menú con valor seleccionado","component.menusPaper.paper":"Papel","component.pickers.Date":"Selectores de fecha","component.progress.indeterminateCircular":"Circular indeterminada","component.progress.indeterminateLinear":"Indeterminado Linear","component.progress.determinateLinear":"Determinado lineal","component.progress.bufferLinear":"Buffer Linear","component.progress.interactiveIntegration":"Integración Interactiva","component.progress.queryLinear":"Consulta lineal","component.selectionControl.checkboxes":"Casillas de verificación","component.selectionControl.disabled":"Discapacitado","component.selectionControl.intermediate":"Intermedio","component.selectionControl.checkboxesWithForm":"Casillas de verificación con grupo de formularios","component.selectionControl.basicRadio":"Botones de radio básicos","component.selectionControl.disabledRadio":"Botones de radio desactivados","component.selectionControl.withError":"Con mensaje de error","component.selectionControl.switches":"Interruptores","component.selectionControl.verticalSwitches":"Interruptores verticales","component.selectionControl.groupedSwitches":"Interruptores agrupados","component.selectionControl.verticalImplementation":"Implementación vertical de interruptores","component.selectionControl.generalSettings":"Configuración general","component.selectionControl.themeSettings":"Ajustes de tema","component.selectionControl.onOffSwitches":"interruptores de encendido / apagado","component.selectionControl.verticalInlineRadio":"Botones de radio verticales y en línea","component.selectionControl.checkboxesWithFormTxt":"Los menús se colocan sobre sus elementos emisores de manera que el elemento del menú seleccionado actualmente aparece sobre el elemento emisor.","component.selects.simple":"BASIC","component.selects.native":"Modificador","component.selects.multiple":"Dirección","component.selects.dialog":"tamaño","component.selects.select":"Seleccionar","component.snackbars.transition":"Dirección de control de transición","component.snackbars.simple":"Sencillo","component.snackbars.positioned":"Posicionado","component.snackbars.messageWithButton":"Mensaje con el botón","component.snackbars.colors":"Colores","component.snackbars.multilineText":"Texto de líneas múltiples","component.snackbars.onlyMessage":"Solo mensaje","component.snackbars.withIconButton":"Mensaje con IconButton","component.stepper.horizontalLinear":"Horizontal lineal","component.stepper.horizontalLinearAlternativeLabel":"Horizontal lineal - Etiqueta alternativa","component.stepper.vertical":"Stepper vertical","component.stepper.horizontalNonLinear":"Horizontal no lineal","component.stepper.horizontalNonLinearAlternativeLabel":"Horizontal no lineal - Etiqueta alternativa","component.stepper.mobileDots":"Paso a paso móvil - Puntos","component.stepper.mobileProgress":"Paso a paso móvil - Progreso","component.stepper.mobileText":"Paso a paso móvil - Texto","component.tabs.basic":"Pestañas básicas","component.tabs.fixed":"Pestañas fijas Ancho completo","component.tabs.icon":"Pestañas de iconos","component.tabs.disabled":"Pestaña deshabilitada","component.tabs.wrappedLabels":"Etiquetas envueltas","component.tabs.iconWithLabel":"Pestañas de icono con etiqueta","component.tabs.fixedCentered":"Pestañas fijas centradas","component.tabs.automaticScroll":"Botones de desplazamiento automáticos","component.tabs.forcedScroll":"Botones de desplazamiento forzado","component.tabs.preventScroll":"Evitar botones de desplazamiento","component.textFields.textfield":"Campo de texto","component.textFields.components":"Componentes","component.textFields.layout":"Diseño","component.textFields.inputAdornments":"Adornos de entrada","component.textFields.formattedInputs":"Entradas formateadas","component.textFields.inputs":"Entradas","component.tooltips.avatar":"Avatar Tooltip","component.tooltips.button":"Button Tooltip","component.tooltips.icon":"Icon Tooltip","component.tooltips.controlled":"Información sobre herramientas controladas","component.tooltips.positioned":"Información sobre herramientas posicionada","component.typography.lightHeadings":"Encabezados ligeros","component.typography.normalHeadings":"Encabezados normales","component.typography.semiBoldHeadings":"Encabezados semiarudados","component.typography.boldHeadings":"Encabezados audaces","component.typography.paragraphText":"Texto de párrafo","component.typography.leadParagraphText":"Texto del párrafo principal","component.typography.unstyledList":"Lista sin estilo","component.typography.orderedList":"Lista ordenada","component.typography.unorderedList":"Lista desordenada","component.typography.listWithIcons":"Lista con iconos","component.typography.compactList":"Lista compacta","component.typography.extendedList":"Lista extendida","component.typography.leftIconGroupedList":"Lista Agrupada de Íconos Izquierdos","component.typography.rightIconGroupedList":"Lista derecha de iconos agrupados","component.typography.badgesGroupedList":"Inscripciones Lista agrupada","component.typography.defaultDescriptionList":"Lista de descripción predeterminada","component.typography.evenOddDescriptionList":"Even-Odd Description List","component.typography.leftBlockquoteWithAuthorAvatar":"Left Blockquote con el autor Avatar","component.typography.rightBlockquoteWithAuthorAvatar":"Right Blockquote con el autor Avatar","signIn.success":"¡Ingresa exitosamente!","signIn.error":"Correo electrónico o contraseña inválidos","signUp.success":"Cuenta creada con éxito","signUp.error":"Derecha","signIn.success1":"Derecha","signIn.signUp":"Crea una cuenta","signIn.connectWith":"o conectarse con","signUp.alreadyMember":"Yo ya soy un miembro","appModule.signin":"Registrarse","appModule.signup":"Regístrate","pages.samplePage":"Página de Ejemplo","pages.samplePage.description":"Comience a construir su aplicación. Feliz Codificación!","mailNotification.title":"Mensajes","appNotification.title":"Notificaciones","mailNotification.message":"¡No hay mensajes nuevos a partir de ahora!","appNotification.message":"Sin notificaciones a partir de ahora!","popup.profile":"Perfil","popup.setting":"Ajuste","popup.logout":"Cerrar sesión","popup.updateData":"Actualizar datos","popup.detailedLog":"Registro detallado","popup.statistics":"Estadística","popup.clearData":"Borrar datos","component.selectionControl.radioBtnGroup":"Grupo de botones de radio","component.popover.anchorPlayground":"Anchor Playground"}

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _fr = _interopRequireDefault(__webpack_require__(1333));

var _fr_FR = _interopRequireDefault(__webpack_require__(1334));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var saLang = {
  messages: _objectSpread({}, _fr_FR["default"]),
  locale: 'fr-FR',
  data: _fr["default"]
};
var _default = saLang;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(saLang, "saLang", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/fr_FR.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/fr_FR.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_fr, "_fr", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/fr_FR.js");

  __REACT_HOT_LOADER__.register(_fr_FR, "_fr_FR", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/fr_FR.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/fr_FR.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/fr_FR.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/fr_FR.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/fr_FR.js");

  __REACT_HOT_LOADER__.register(saLang, "saLang", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/fr_FR.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/fr_FR.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/fr_FR.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/lngProvider/entries/fr_FR.js");
}();

;

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.fr=a())}(this,function(){"use strict";return[{locale:"fr",pluralRuleFunction:function(e,a){return a?1==e?"one":"other":e>=0&&e<2?"one":"other"},fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} an",other:"dans {0} ans"},past:{one:"il y a {0} an",other:"il y a {0} ans"}}},"year-short":{displayName:"an",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} a",other:"dans {0} a"},past:{one:"il y a {0} a",other:"il y a {0} a"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},"month-short":{displayName:"m.",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} m.",other:"dans {0} m."},past:{one:"il y a {0} m.",other:"il y a {0} m."}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},"day-short":{displayName:"j",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} j",other:"dans {0} j"},past:{one:"il y a {0} j",other:"il y a {0} j"}}},hour:{displayName:"heure",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},"hour-short":{displayName:"h",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} h",other:"dans {0} h"},past:{one:"il y a {0} h",other:"il y a {0} h"}}},minute:{displayName:"minute",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},"minute-short":{displayName:"min",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} min",other:"dans {0} min"},past:{one:"il y a {0} min",other:"il y a {0} min"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}},"second-short":{displayName:"s",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} s",other:"dans {0} s"},past:{one:"il y a {0} s",other:"il y a {0} s"}}}}},{locale:"fr-BE",parentLocale:"fr"},{locale:"fr-BF",parentLocale:"fr"},{locale:"fr-BI",parentLocale:"fr"},{locale:"fr-BJ",parentLocale:"fr"},{locale:"fr-BL",parentLocale:"fr"},{locale:"fr-CA",parentLocale:"fr",fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"Dans {0} an",other:"Dans {0} ans"},past:{one:"Il y a {0} an",other:"Il y a {0} ans"}}},"year-short":{displayName:"a",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} a",other:"dans {0} a"},past:{one:"il y a {0} a",other:"il y a {0} a"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},"month-short":{displayName:"m.",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} m.",other:"dans {0} m."},past:{one:"il y a {0} m.",other:"il y a {0} m."}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},"day-short":{displayName:"j",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} j",other:"dans {0} j"},past:{one:"il y a {0} j",other:"il y a {0} j"}}},hour:{displayName:"heure",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},"hour-short":{displayName:"h",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} h",other:"dans {0} h"},past:{one:"il y a {0} h",other:"il y a {0} h"}}},minute:{displayName:"minute",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},"minute-short":{displayName:"min",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} min",other:"dans {0} min"},past:{one:"il y a {0} min",other:"il y a {0} min"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}},"second-short":{displayName:"s",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} s",other:"dans {0} s"},past:{one:"il y a {0} s",other:"il y a {0} s"}}}}},{locale:"fr-CD",parentLocale:"fr"},{locale:"fr-CF",parentLocale:"fr"},{locale:"fr-CG",parentLocale:"fr"},{locale:"fr-CH",parentLocale:"fr"},{locale:"fr-CI",parentLocale:"fr"},{locale:"fr-CM",parentLocale:"fr"},{locale:"fr-DJ",parentLocale:"fr"},{locale:"fr-DZ",parentLocale:"fr"},{locale:"fr-GA",parentLocale:"fr"},{locale:"fr-GF",parentLocale:"fr"},{locale:"fr-GN",parentLocale:"fr"},{locale:"fr-GP",parentLocale:"fr"},{locale:"fr-GQ",parentLocale:"fr"},{locale:"fr-HT",parentLocale:"fr",fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} an",other:"dans {0} ans"},past:{one:"il y a {0} an",other:"il y a {0} ans"}}},"year-short":{displayName:"an",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} a",other:"dans {0} a"},past:{one:"il y a {0} a",other:"il y a {0} a"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},"month-short":{displayName:"m.",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} m.",other:"dans {0} m."},past:{one:"il y a {0} m.",other:"il y a {0} m."}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},"day-short":{displayName:"jr.",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} j",other:"dans {0} j"},past:{one:"il y a {0} j",other:"il y a {0} j"}}},hour:{displayName:"heure",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},"hour-short":{displayName:"hr",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} h",other:"dans {0} h"},past:{one:"il y a {0} h",other:"il y a {0} h"}}},minute:{displayName:"minute",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},"minute-short":{displayName:"min.",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} min",other:"dans {0} min"},past:{one:"il y a {0} min",other:"il y a {0} min"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}},"second-short":{displayName:"s",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} s",other:"dans {0} s"},past:{one:"il y a {0} s",other:"il y a {0} s"}}}}},{locale:"fr-KM",parentLocale:"fr"},{locale:"fr-LU",parentLocale:"fr"},{locale:"fr-MA",parentLocale:"fr"},{locale:"fr-MC",parentLocale:"fr"},{locale:"fr-MF",parentLocale:"fr"},{locale:"fr-MG",parentLocale:"fr"},{locale:"fr-ML",parentLocale:"fr"},{locale:"fr-MQ",parentLocale:"fr"},{locale:"fr-MR",parentLocale:"fr"},{locale:"fr-MU",parentLocale:"fr"},{locale:"fr-NC",parentLocale:"fr"},{locale:"fr-NE",parentLocale:"fr"},{locale:"fr-PF",parentLocale:"fr"},{locale:"fr-PM",parentLocale:"fr"},{locale:"fr-RE",parentLocale:"fr"},{locale:"fr-RW",parentLocale:"fr"},{locale:"fr-SC",parentLocale:"fr"},{locale:"fr-SN",parentLocale:"fr"},{locale:"fr-SY",parentLocale:"fr"},{locale:"fr-TD",parentLocale:"fr"},{locale:"fr-TG",parentLocale:"fr"},{locale:"fr-TN",parentLocale:"fr"},{locale:"fr-VU",parentLocale:"fr"},{locale:"fr-WF",parentLocale:"fr"},{locale:"fr-YT",parentLocale:"fr"}]});


/***/ }),
/* 1334 */
/***/ (function(module, exports) {

module.exports = {"sidebar.main":"Principale","sidebar.dashboard":"Tableau de bord","sidebar.dashboard.default":"Défaut","sidebar.dashboard.ecommerce":"eCommerce","sidebar.dashboard.news":"Nouvelles","sidebar.dashboard.intranet":"Intranet","sidebar.components":"Composants","sidebar.components.alerts":"Alertes","sidebar.components.appbar":"App Bar","sidebar.components.autocomplete":"Saisie semi-automatique","sidebar.components.avatars":"Avatars","sidebar.components.badge":"Badge","sidebar.components.bottomNavigation":"Navigation par le bas","sidebar.components.breadcrumbs":"Chapelure","sidebar.components.buttons":"Boutons","sidebar.components.buttonGroup":"Groupe de boutons","sidebar.components.cards":"Cartes","sidebar.components.carousel":"Carrousel","sidebar.components.chips":"chips","sidebar.components.colorPicker":"Pipette à couleurs","sidebar.components.modals":"Modals","sidebar.components.dividers":"Intercalaires","sidebar.components.expansionPanel":"Panneau d'extension","sidebar.components.drawer":"Tiroir","sidebar.components.gridList":"Grille Liste","sidebar.components.lists":"Listes","sidebar.components.menusPaper":"Menus et papier","sidebar.components.pickers":"Pickers","sidebar.components.popovers":"Popovers","sidebar.components.progress":"popovers","sidebar.components.selects":"Sélectionne","sidebar.components.selectionControl":"Contrôles de sélection","sidebar.components.snackbars":"Barre de céréales","sidebar.components.stepper":"Stepper","sidebar.components.tables":"les tables","sidebar.components.tabs":"Tabs","sidebar.components.textFields":"Champs de texte","sidebar.components.tooltips":"Info-bulles","sidebar.components.typography":"Typographie","sidebar.widgets":"Widgets","sidebar.metrics":"Métrique","sidebar.view":"Vue","sidebar.tables":"les tables","sidebar.tables.basicTable":"Table de base","sidebar.tables.dataTable":"Tableau de données","sidebar.timeLine":"Chronologie","sidebar.timeLine.default":"Défaut","sidebar.timeLine.defaultwithIcons":"Par défaut avec des icônes","sidebar.timeLine.leftAligned":"Aligné à gauche","sidebar.timeLine.zigzag":"Zigzag","sidebar.customViews":"Affichages personnalisés","sidebar.customViews.plainListView":"Vue en liste simple","sidebar.customViews.withDivider":"Liste simple avec diviseur","sidebar.customViews.cardListView":"Vue liste de cartes","sidebar.form":"Forme","sidebar.forms":"Formes","sidebar.forms.components":"Composants","sidebar.forms.stepper":"Stepper","sidebar.extensions":"Extensions","sidebar.editors":"Éditeurs","sidebar.editors.CKEditor":"CKEditor","sidebar.editors.WYSISWYGEditor":"Éditeur WYSIWYG","sidebar.pickers":"Pickers","sidebar.pickers.dateTimePickers":"Sélecteurs de date et d'heure","sidebar.pickers.colorPickers":"Color Pickers","sidebar.extensions.dragNDrop":"Glisser déposer","sidebar.extensions.dropzone":"Zone de largage","sidebar.extensions.sweetAlert":"Alerte douce","sidebar.extensions.notification":"Notification","sidebar.chart":"Graphique","sidebar.chart.line":"Graphique en ligne","sidebar.chart.bar":"Diagramme à bandes","sidebar.chart.area":"Graphique de zone","sidebar.chart.composed":"Tableau composé","sidebar.chart.scatter":"Diagramme de dispersion","sidebar.chart.pie":"Camembert","sidebar.chart.radial":"Graphique radial","sidebar.chart.radar":"Graphique radar","sidebar.chart.tree":"Arbre","sidebar.map":"Google Map","sidebar.map.simple":"Carte simple","sidebar.map.styled":"Carte stylée","sidebar.map.geoLocation":"Emplacement géographique","sidebar.map.mapDirection":"Direction de la carte","sidebar.map.overlay":"Superposition de carte","sidebar.map.kmLayer":"Carte Km Layer","sidebar.map.popupInfo":"Map Popup Info","sidebar.map.trafficLayer":"Couche routière","sidebar.map.streetView":"Street View","sidebar.map.eventListener":"Event Listener","sidebar.map.mapDrawing":"Dessin de carte","sidebar.map.mapClustering":"Clustering de carte","sidebar.modules":"Modules","sidebar.calendar":"Calendrier","sidebar.calendar.basic":"De base","sidebar.calendar.cultures":"Des cultures","sidebar.calendar.dnd":"Dnd","sidebar.calendar.popup":"Apparaitre","sidebar.calendar.rendering":"Le rendu","sidebar.calendar.selectable":"Sélectionnable","sidebar.calendar.timeslots":"Tranches de temps","sidebar.eCommerce":"commerce électronique","sidebar.eCommerce.productsList":"Liste de produits","sidebar.eCommerce.productsGrid":"Grille de produits","sidebar.appModule":"Module App","sidebar.appModule.login":"Connexion Page","sidebar.appModule.login2":"Connexion Page 2","sidebar.appModule.loginStepper":"Login with Stepper","sidebar.appModule.signup":"Inscription Page","sidebar.appModule.signup2":"Inscription Page 2","sidebar.appModule.forgotPassword":"Mot de passe oublié","sidebar.appModule.forgotPassword2":"Mot de passe oublié 2","sidebar.appModule.lock":"Verrouiller l'écran","sidebar.appModule.lock2":"Verrouiller l'écran 2","sidebar.appModule.toDo":"Faire","sidebar.appModule.toDoRedux":"To-Do Redux","sidebar.appModule.mail":"Courrier","sidebar.appModule.mailRedux":"Mail Redux","sidebar.appModule.chat":"Bavarder","sidebar.appModule.chatRedux":"Chat Redux","sidebar.appModule.contact":"Contact","sidebar.appModule.contactRedux":"Contactez Redux","sidebar.extras":"Extras","sidebar.icons":"Icônes","sidebar.icons.material":"Icônes de matériel de Google","sidebar.extraElements":"Éléments supplémentaires","sidebar.extraElements.pricingTable":"Tableau de tarification","sidebar.extraElements.callouts":"Légendes","sidebar.extraElements.testimonials":"Témoignages","sidebar.extraPages":"Pages supplémentaires","sidebar.extraPages.aboutUs":"À propos de nous","sidebar.extraPages.contactUs":"Contactez nous","sidebar.extraPages.blog":"Blog","sidebar.extraPages.faq":"FAQ","sidebar.extraPages.portfolio":"Portefeuille","sidebar.extraPages.404":"404 Page d'erreur","sidebar.extraPages.500":"500 page d'erreur","sidebar.menuLevels":"Niveaux de menu","sidebar.menuLevels.level1":"Niveau 1","sidebar.menuLevels.level2":"Niveau 2","sidebar.menuLevels.level3":"Niveau 3","appModule.forgotPassword":"Mot de passe oublié?","appModule.dntRememberEmail":"Vous ne vous souvenez pas de votre email?","appModule.contactSupport":"Contactez le support","appModule.resetPassword":"réinitialiser le mot de passe","appModule.enterPasswordUnlock":"Entrez votre mot de passe pour déverrouiller l'écran!","appModule.unlock":"Ouvrir","appModule.signInDiffAccount":"Connectez-vous en utilisant un compte différent","appModule.rememberMe":"Souviens-toi de moi","appModule.signIn":"Se connecter","appModule.next":"Prochain","appModule.back":"Arrière","appModule.allStepsCompleted":"Toutes les étapes sont terminées","appModule.reset":"Réinitialiser","appModule.loginSuccessfully":"Connectez-vous avec succès","appModule.password":"Mot de passe","appModule.email":"Email","appModule.name":"prénom","appModule.phone":"Téléphone","appModule.designation":"La désignation","appModule.regsiter":"registre","appModule.hvAccount":"Avoir un compte","appModule.createAccount":"Créer un compte","chart.area":"Graphique de secteur","chart.bar":"Graphique à barres","chart.composed":"Graphique composé","chart.line":"Graphique linéaire","chart.pie":"Diagramme circulaire","chart.radar":"Graphique radar","chart.radial":"Graphique radial","chart.scatter":"Scatter Graphique","chart.tree":"Arbre graphique","chat.selectUserChat":"Sélectionnez Utilisateur pour lancer le chat","chat.selectContactChat":"Sélectionnez le contact pour démarrer le chat","chat.chatUser":"Chats","chat.contacts":"Contacts","chat.searchStartNewChat":"Rechercher ou démarrer une nouvelle discussion","chat.typeMessage":"Tapez et appuyez sur Entrée pour envoyer un message","chat.status":"c'est un statut ... pas votre journal ...","contact.saveContact":"Enregistrer le contact","contact.addContact":"Ajouter le contact","contact.searchContact":"Rechercher un contact","button.modify":"Modifier","button.delete":"Effacer","button.yes":"Oui","button.no":"Non","eCommerce.readMore":"Lire la suite","eCommerce.addToCart":"Ajouter au panier","eCommerce.buyNow":"Acheter maintenant","extension.sweetAlerts":"Alertes douces","extension.notification":"Notification","sweetAlerts.basic":"De base","sweetAlerts.description":"Avec description","sweetAlerts.success":"Succès","sweetAlerts.warning":"Attention","sweetAlerts.custom":"Douane","sweetAlerts.htmlTag":"Balise Html","sweetAlerts.prompt":"Rapide","sweetAlerts.itsBlue":"C'est bleu!","sweetAlerts.passwordPrompt":"Invite de mot de passe","sweetAlerts.customStyle":"Style personnalisé","sweetAlerts.itPretty":"C'est joli, n'est-ce pas?","sweetAlerts.btnClicked":"Vous avez cliqué sur le bouton!","sweetAlerts.youWillFind":"Vous trouverez qu'ils sont en place!","sweetAlerts.youWillNotAble":"Vous ne serez pas capable de récupérer ce fichier imaginaire!","sweetAlerts.hereIsaMessage":"Voici un message!","sweetAlerts.goodJob":"Bon travail!","sweetAlerts.yesDeleteIt":"Oui, supprimez-le!","sweetAlerts.areYouSure":"Êtes-vous sûr?","sweetAlerts.doYouLikeThumb":"Aimez-vous les pouces?","sweetAlerts.anInput":"Une entrée!","sweetAlerts.writeSomethingInteresting":"Ecrire quelque chose d'intéressant:","sweetAlerts.writeSomething":"Write something","sweetAlerts.youMustEnterPassword":"Vous devez entrer votre mot de passe!","sweetAlerts.enterPassword":"Entrer le mot de passe","notification.infoMsg":"Message d'information","notification.successMessage":"Message de réussite","notification.warningMessage":"Message d'alerte","notification.closeAfter3000ms":"Fermer après 3000ms","notification.errorMessage":"Message d'erreur","notification.titleHere":"Titre ici","notification.clickMe":"Clique moi!","notification.info":"Info","notification.success":"Succès","notification.warning":"Attention","notification.error":"Erreur","extraElements.callouts":"Légendes","extraElements.pricingTable":"Tableau de tarification","extraElements.testimonials":"Témoignages","callouts.viewRange":"Afficher la plage","callouts.basic":"De base","pricingTable.basic":"De base","pricingTable.circle":"Cercle","pricingTable.classic":"Classique","pricingTable.dark":"Foncé","pricingTable.personal":"PERSONNEL","pricingTable.easyTranslation":"Traduction facile","pricingTable.awesomeGoogleFonts":"Impressionnant Google Fonts","pricingTable.hotelBookingSystem":"Système de réservation d'hôtel","pricingTable.emailComposeInterface":"Email Compose Interface","pricingTable.locationFinderApp":"Application de localisation","pricingTable.buyNow":"Acheter maintenant","pricingTable.business":"ENTREPRISE","pricingTable.professional":"PROFESSIONNEL","testimonials.basic":"De base","testimonials.classic":"Classique","testimonials.standard":"la norme","extraPages.goHome":"Aller à la maison","extraPages.ourClients":"Nos clients","extraPages.all":"Tout","extraPages.graphicDesign":"conception graphique","extraPages.logo":"logo","extraPages.mobileApp":"application mobile","extraPages.web":"web","extraPages.404Msg":"Oups, une erreur s'est produite. Page non trouvée!","extraPages.500Msg":"Désolé, le serveur va mal","extraPages.aboutUs.showCase":"Présentez vos services ici avec des informations à leur sujet","aboutUs.readMore":"Lire la suite","extraPages.goSomewhere":"Aller quelque part","icon.material":"900+ icônes officielles de conception de matériel","mail.mailbox":"Boites aux lettres","mail.compose":"COMPOSER","mail.filters":"Filtres","mail.labels":"LabelsÉtiquettes","picker.color.alpha":"Alpha Pickers","picker.color.hue":"Pickers de teinte","picker.color.circle":"Cueilleurs de cercle","picker.color.compact":"Pickers compacts","picker.color.block":"Ramasseurs de blocs","picker.color.chrome":"Chrome Pickers","picker.color.github":"Github Cueilleurs","picker.color.twitter":"Capteurs Twitter","picker.color.withRedux":"Avec Redux","picker.color.sketch":"Sketch Pickers","picker.color.material":"Ramasseurs de matériel","picker.color.slider":"Sliders Pickers","picker.color.basic":"Cueilleurs de base","picker.color.basicToggle":"Bascule basique","picker.color.custom":"Pickers personnalisés","picker.color.customPointer":"Pointeur personnalisé","picker.color.photoshop":"Photoshop Pickers","picker.color.swatches":"Nuanciers","picker.color.basicPositioning":"Positionnement de base","picker.date.pickers":"Pickers","picker.date.toggle":"Toggle Pickers","picker.date.input":"Sélecteur de champ de saisie","picker.date.localization":"Cueilleurs de localisation","picker.date.basic":"Sélecteur de base","picker.date.selectDay":"Sélectionnez le jour","table.marketingCampaign":"Campagne de marketing","table.thisWeek":"Cette semaine","table.defaultSorting":"Tri par défaut","table.customSorting":"Tri personnalisé","table.editableContent":"Contenu modifiable","table.customFilter":"Filtre personnalisé","table.recentOrders":"Dernières commandes","table.dataTable":"Tableau de données","table.basicTable":"Table de base","table.application":"Tableau d'application","todo":"Faire","todo.addTask":"AJOUTER UNE TÂCHE","todo.all":"Tout","todo.filters":"Filtres","todo.labels":"Étiquettes","dashboard.recentActivities":"Activités récentes","dashboard.lastActivity":"Dernière activité il y a 2 jours","dashboard.currentProjects":"Liste des projets en cours","dashboard.toDoItems":"Liste des éléments à faire","dashboard.today":"Aujourd'hui","dashboard.marketingCampaign":"Campagne de marketing","dashboard.yourDailyFeed":"Votre flux quotidien","dashboard.googleInsight":"Score Google Insight","dashboard.lastCalculated":"Las calculé il y a 1 mois","dashboard.refresh":"Rafraîchir","dashboard.upgradeToday":"mettre à jour aujourd'hui","dashboard.onlineSignups":"Inscription en ligne","dashboard.lastMonthSale":"Vente du mois dernier","dashboard.newVisits":"Nouvelles visites ce mois-ci","dashboard.totalRevenue":"Total des revenus cette année","dashboard.latestPosts":"Derniers messages","dashboard.loremIpsum":"Lorem ipsum est le contenu factice dollar sit est ...","dashboard.viewAllPosts":"VOIR TOUS LES POSTES","dashboard.popularProducts":"Produits populaires","dashboard.popularProductsTxt":"C'est un fait établi depuis longtemps qu'un lecteur sera distrait par le contenu lisible.","dashboard.allProducts":"tous les produits","dashboard.userStatstics":"Statistiques de l'utilisateur","dashboard.orders":"Ordres","dashboard.thisYearSaleReport":"Ce rapport de vente d'année","dashboard.post9MonthData":"Post 9 mois de données","dashboard.newCustomers":"nouveaux clients","dashboard.newThisMonth":"32 nouveau ce mois","dashboard.monthly":"Mensuel","dashboard.totalView":"Total View","dashboard.annual":"Annuel","dashboard.newOrder":"nouvel ordre","dashboard.visited":"A visité","dashboard.rapidPace":"Pas rapide","dashboard.slowPace":"Rythme lent","dashboard.newConnections":"Nouvelles connexions","dashboard.thisWeek":"3 Cette semaine","dashboard.newFeed":"23 nouveaux flux","dashboard.newSubscriber":"Nouvel abonné","dashboard.newArticles":"Nouveaux articles","dashboard.newAuthors":"Nouveaux auteurs","dashboard.avgDailyTraffic":"Trafic quotidien moyen","dashboard.popularAuthors":"Auteurs populaires","dashboard.authorsWith":"Auteurs Avec 500+ avg. vue","dashboard.popularArticles":"Articles populaires","dashboard.comments":"commentaires","component.alert.default":"Alertes par défaut","component.alert.highlighted":"Alertes en surbrillance","component.alert.dismissible":"Alertes inadmissibles","component.alert.withIcons":"Alertes avec des icônes","component.alert.withDetailedHTML":"Alerte avec HTML détaillé","component.appbar.simple":"Barre d'application simple","component.appbar.colored":"Barre d'application colorée","component.appbar.fullyFeatured":"Barre d'application entièrement sélectionnée","component.autocomplete.Basic":"Basic","component.autocomplete.controlinSelection":"Control Selection","component.autocomplete.Behaviors":"Behaviors","component.autocomplete.inputSize":"Input Size","component.autocomplete.menuAlign":"Menu Align","component.avatars.image":"Avatars d'images","component.avatars.letter":"Avatars de lettre","component.avatars.icon":"Avatars d'icônes","component.badge.scaling":"Badges d'échelle","component.badge.insideLinks":"Liens intérieurs et boutons","component.badge.contextual":"Variations contextuelles","component.badge.pill":"Badges","component.badge.link":"Badges de liaison","component.bottomNavigation.withLabels":"Navigation par le bas avec des étiquettes","component.bottomNavigation.withActiveLabels":"Navigation inférieure avec étiquette active","component.bottomNavigation.withNoLabels":"Navigation par le bas sans étiquette","component.breadcrumbs.simple":"Simple","component.breadcrumbs.noList":"Pas de liste","component.buttons.colorScheme":"Schéma de couleur","component.buttons.colorSchemeTxt":"Bootstrap Color Scheme avec le concept de matériel","component.buttons.icon":"Boutons d'icône","component.buttons.iconTxt":"Vous pouvez choisir n'importe quelle icône parmi les icônes de polices listées sous la page Icônes. Ou n'hésitez pas à ajouter de nouvelles icônes de polices et utilisez-les.","component.buttons.differentSizes":"Des tailles différentes","component.buttons.differentSizesTxt":"Boutons de matière avec différentes tailles","component.buttons.flatFullWidth":"Boutons plats et pleine largeur","component.buttons.flatFullWidthTxt":"Tous les boutons de type avec des états désactivés","component.buttons.raised":"Boutons surélevés","component.buttons.raisedTxt":"Bootstrap Color Scheme avec le concept de matériel","component.buttons.fab":"Boutons d'action flottants","component.buttons.fabTxt":"Bootstrap Color Scheme avec le concept de matériel","component.buttons.socialMedia":"Boutons de médias sociaux","component.buttons.socialMediaTxt":"Divers boutons de médias sociaux pour votre projet","component.buttons.complex":"Boutons complexes","component.buttonGroup.horizontalVariations":"Variations horizontales","component.buttonGroup.defaultStyle":"Style de groupe de boutons par défaut","component.buttonGroup.highlightedStyle":"Style de groupe de boutons en surbrillance","component.buttonGroup.flatStyle":"Style de groupe bouton plat","component.buttonGroup.default":"Groupe de boutons par défaut","component.buttonGroup.flat":"Groupe de boutons plats","component.buttonGroup.highlighted":"Groupe de boutons en surbrillance","component.buttonGroup.icon":"Groupe de boutons d'icônes","component.buttonGroup.iconFlat":"Groupe de boutons plats","component.buttonGroup.nested":"Groupe de boutons imbriqués","component.cards.basic":"Cartes de base","component.cards.special":"Cartes spéciales","component.cards.withHeader":"Cartes avec en-tête, pied de page et alignement","component.cards.navigational":"Cartes de navigation","component.cards.image":"Cartes d'image","component.cards.solid":"Cartes solides","component.carousel.basic":"Carrousel de base","component.carousel.basicTxt":"Carousel de base de BS4 actionné avec ReactStrap","component.carousel.product":"Carrousel de produit","component.carousel.productTxt":"Un carrousel de vue de grille horizontale","component.carousel.testimonial":"Carousel Témoignage","component.carousel.testimonialTxt":"Un carrousel à la fois","component.chips.default":"Puce par défaut","component.chips.outline":"Puce de contour","component.chips.chipWithText":"Puce avec Avatar texte","component.chips.clickable":"Puce cliquable","component.chips.withImage":"Puce avec Image Avatar","component.chips.deletable":"Puce Deletable","component.chips.withIcon":"Puce avec icône Avatar","component.chips.custom":"Puce Clickable personnalisée","component.chips.array":"Chip Array","component.chips.withInput":"Implémentation de puces avec boîte de saisie","component.dividers.list":"List Diviseurs","component.dividers.inset":"Intercalaires","component.dividers.default":"Défaut","component.drawer.persistent":"Tiroir persistant","component.drawer.permanent":"Tiroir permanent","component.drawer.mini":"Mini tiroir","component.drawer.responsive":"Tiroir réactif","component.expansionPanel.simple":"Panneau d'extension simple","component.expansionPanel.controlled":"Accordéon contrôlé","component.expansionPanel.secondary":"En-tête secondaire et colonnes","component.gridList.image":"Liste de grille d'images uniquement","component.gridList.advanced":"Liste de grille avancée","component.gridList.singleLine":"Liste de grille simple ligne","component.gridList.withTitlebars":"Liste de grille avec des barres de titre","component.lists.folder":"Liste des dossiers","component.lists.switch":"Commuter la liste de contrôle","component.lists.dividers":"List Diviseurs","component.lists.simple":"Liste simple","component.lists.inset":"Liste d'encart","component.lists.nested":"Liste imbriquée","component.lists.checkbox":"Contrôles de liste secondaire de case à cocher","component.lists.checkboxControls":"Contrôles de la liste de cases","component.lists.pinned":"Liste de sous-titres épinglés","component.lists.interactive":"Contrôles interactifs de liste","component.chips":"Récent","component.menusPaper.simple":"Menus simples","component.menusPaper.withIcon":"Menu avec icône","component.menusPaper.withMoreButton":"Menu avec plus de bouton","component.menusPaper.withSelectedValue":"Menu avec la valeur sélectionnée","component.menusPaper.paper":"Papier","component.pickers.Date":"Cueilleurs de date","component.progress.indeterminateCircular":"Circulaire indéterminée","component.progress.indeterminateLinear":"Linéaire indéterminée","component.progress.determinateLinear":"Déterminé linéaire","component.progress.bufferLinear":"Tampon linéaire","component.progress.interactiveIntegration":"Intégration interactive","component.progress.queryLinear":"Requête linéaire","component.selectionControl.checkboxes":"Cases à cocher","component.selectionControl.disabled":"désactivé","component.selectionControl.intermediate":"Intermédiaire","component.selectionControl.checkboxesWithForm":"Cases à cocher avec groupe de formulaires","component.selectionControl.basicRadio":"Boutons radio de base","component.selectionControl.disabledRadio":"Boutons radio désactivés","component.selectionControl.withError":"Avec un message d'erreur","component.selectionControl.switches":"Commutateurs","component.selectionControl.verticalSwitches":"Commutateurs verticaux","component.selectionControl.groupedSwitches":"Commutateurs groupés","component.selectionControl.verticalImplementation":"Implantation verticale des commutateurs","component.selectionControl.generalSettings":"réglages généraux","component.selectionControl.themeSettings":"Réglage des thèmes","component.selectionControl.onOffSwitches":"interrupteurs marche / arrêt","component.selectionControl.verticalInlineRadio":"Boutons radio verticaux et en ligne","component.selectionControl.checkboxesWithFormTxt":"Les menus sont positionnés sur leurs éléments émetteurs de sorte que l'élément de menu actuellement sélectionné apparaisse au-dessus de l'élément émetteur.","component.selects.simple":"De base","component.selects.native":"Modificateur","component.selects.multiple":"Direction","component.selects.dialog":"Taille","component.selects.select":"Sélectionner","component.snackbars.transition":"Direction du contrôle de la transition","component.snackbars.simple":"Simple","component.snackbars.positioned":"Positionné","component.snackbars.messageWithButton":"Message avec bouton","component.snackbars.colors":"Couleurs","component.snackbars.multilineText":"Texte multiligne","component.snackbars.onlyMessage":"Seul message","component.snackbars.withIconButton":"Message avec IconButton","component.stepper.horizontalLinear":"Linéaire linéaire","component.stepper.horizontalLinearAlternativeLabel":"Horizontal Linéaire - Étiquette alternative","component.stepper.vertical":"Stepper vertical","component.stepper.horizontalNonLinear":"Horizontal non linéaire","component.stepper.horizontalNonLinearAlternativeLabel":"Horizontal non linéaire - Autre étiquette","component.stepper.mobileDots":"Mobile Stepper - Points","component.stepper.mobileProgress":"Mobile Stepper - Progress","component.stepper.mobileText":"Stepper mobile - Texte","component.tabs.basic":"Onglets de base","component.tabs.fixed":"Onglets fixes pleine largeur","component.tabs.icon":"Icônes","component.tabs.disabled":"Onglet désactivé","component.tabs.wrappedLabels":"Étiquettes enveloppées","component.tabs.iconWithLabel":"Icônes avec étiquette","component.tabs.fixedCentered":"Onglets fixes centrés","component.tabs.automaticScroll":"Boutons de défilement automatiques","component.tabs.forcedScroll":"Boutons de défilement forcé","component.tabs.preventScroll":"Empêcher les boutons de défilement","component.textFields.textfield":"Champ de texte","component.textFields.components":"Composants","component.textFields.layout":"Disposition","component.textFields.inputAdornments":"Adornments d'entrée","component.textFields.formattedInputs":"Entrées formatées","component.textFields.inputs":"Contributions","component.tooltips.avatar":"Avatar Tooltip","component.tooltips.button":"Bouton Info-bulle","component.tooltips.icon":"Icon Tooltip","component.tooltips.controlled":"Info-bulle contrôlée","component.tooltips.positioned":"Info-bulle positionnée","component.typography.lightHeadings":"Rubriques légères","component.typography.normalHeadings":"Rubriques normales","component.typography.semiBoldHeadings":"Rubriques semi-bold","component.typography.boldHeadings":"En-têtes gras","component.typography.paragraphText":"Texte du paragraphe","component.typography.leadParagraphText":"Texte du paragraphe principal","component.typography.unstyledList":"Liste non nommée","component.typography.orderedList":"Liste ordonnée","component.typography.unorderedList":"Liste non ordonnée","component.typography.listWithIcons":"Liste avec des icônes","component.typography.compactList":"Liste compacte","component.typography.extendedList":"Liste étendue","component.typography.leftIconGroupedList":"Liste des icônes de gauche","component.typography.rightIconGroupedList":"Liste groupée des icônes droites","component.typography.badgesGroupedList":"Liste groupée des badges","component.typography.defaultDescriptionList":"Liste de description par défaut","component.typography.evenOddDescriptionList":"Liste de description paire-impaire","component.typography.leftBlockquoteWithAuthorAvatar":"Blocage de gauche avec avatar d'auteur","component.typography.rightBlockquoteWithAuthorAvatar":"Blockquote à droite avec l'avatar de l'auteur","signIn.success":"Connectez-vous avec succès!","signIn.error":"Email ou mot de passe invalide!","signUp.success":"Compte créé avec succès","signUp.error":"Droite","signIn.success1":"Droite","signIn.signUp":"Créer un compte","signIn.connectWith":"ou se connecter avec","signUp.alreadyMember":"Je suis déjà membre","appModule.signin":"Se connecter","appModule.signup":"S'inscrire","pages.samplePage":"Page d'exemple","pages.samplePage.description":"Commencez à construire votre application. Codage heureux!","mailNotification.title":"Messages","appNotification.title":"Notifications","mailNotification.message":"Pas de nouveaux messages à partir de maintenant!","appNotification.message":"Aucune notification pour le moment!","popup.profile":"Profil","popup.setting":"Réglage","popup.logout":"Connectez - Out","popup.updateData":"Mettre à jour","popup.detailedLog":"Journal détaillé","popup.statistics":"Statistiques","popup.clearData":"Effacer les données","component.selectionControl.radioBtnGroup":"Groupe de boutons radio","component.popover.anchorPlayground":"Anchor Playground"}

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRouterDom = __webpack_require__(13);

var _reactRedux = __webpack_require__(10);

var _index = _interopRequireDefault(__webpack_require__(1336));

var _index2 = _interopRequireDefault(__webpack_require__(1443));

var _Footer = _interopRequireDefault(__webpack_require__(1486));

var _dashboard = _interopRequireDefault(__webpack_require__(1487));

var _components = _interopRequireDefault(__webpack_require__(1737));

var _index3 = _interopRequireDefault(__webpack_require__(1767));

var _form = _interopRequireDefault(__webpack_require__(1768));

var _editors = _interopRequireDefault(__webpack_require__(1769));

var _pickers = _interopRequireDefault(__webpack_require__(1770));

var _extensions = _interopRequireDefault(__webpack_require__(1771));

var _table = _interopRequireDefault(__webpack_require__(1791));

var _charts = _interopRequireDefault(__webpack_require__(1798));

var _map = _interopRequireDefault(__webpack_require__(1799));

var _calendar = _interopRequireDefault(__webpack_require__(1800));

var _timeLine = _interopRequireDefault(__webpack_require__(1801));

var _customViews = _interopRequireDefault(__webpack_require__(1802));

var _extraElements = _interopRequireDefault(__webpack_require__(1803));

var _eCommerce = _interopRequireDefault(__webpack_require__(1804));

var _appModule = _interopRequireDefault(__webpack_require__(1805));

var _extraPages = _interopRequireDefault(__webpack_require__(1806));

var _organisation = _interopRequireDefault(__webpack_require__(1807));

var _employee = _interopRequireDefault(__webpack_require__(1812));

var _Dashboard = _interopRequireDefault(__webpack_require__(1815));

var _OrgDashboard = _interopRequireDefault(__webpack_require__(1817));

var _EmpDashboard = _interopRequireDefault(__webpack_require__(1823));

var _OrgSurvey = _interopRequireDefault(__webpack_require__(1827));

var _OrgSurveyCompare = _interopRequireDefault(__webpack_require__(1830));

var _OrgSurveyEngagementDetails = _interopRequireDefault(__webpack_require__(1835));

var _OrgSurveyCompareRadar = _interopRequireDefault(__webpack_require__(1844));

var _OrgEmpSurvey = _interopRequireDefault(__webpack_require__(1848));

var _SurveyGroup = _interopRequireDefault(__webpack_require__(1869));

var _SurveyGroupQuestion = _interopRequireDefault(__webpack_require__(1872));

var _project = _interopRequireDefault(__webpack_require__(1877));

var _projectPriority = _interopRequireDefault(__webpack_require__(1886));

var _security = _interopRequireDefault(__webpack_require__(1891));

var _projectIssue = _interopRequireDefault(__webpack_require__(1896));

var _businessUnit = _interopRequireDefault(__webpack_require__(1906));

var _portfolio = _interopRequireDefault(__webpack_require__(1911));

var _portfolioDashboard = _interopRequireDefault(__webpack_require__(1917));

var _feature = _interopRequireDefault(__webpack_require__(1929));

var _valueStream = _interopRequireDefault(__webpack_require__(1938));

var _member = _interopRequireDefault(__webpack_require__(1944));

var _team = _interopRequireDefault(__webpack_require__(1950));

var _product = _interopRequireDefault(__webpack_require__(1958));

var _initiative = _interopRequireDefault(__webpack_require__(1966));

var _issue = _interopRequireDefault(__webpack_require__(1974));

var _projectBusPriority = _interopRequireDefault(__webpack_require__(1981));

var _projectCostPriority = _interopRequireDefault(__webpack_require__(1987));

var _ActionTypes = __webpack_require__(7);

var _reactDeviceDetect = __webpack_require__(1993);

var _asyncComponent = _interopRequireDefault(__webpack_require__(44));

var _TopNav = _interopRequireDefault(__webpack_require__(1994));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
} // import Tour from 'components/Tour/index';


var App =
/*#__PURE__*/
function (_React$Component) {
  _inherits(App, _React$Component);

  function App() {
    _classCallCheck(this, App);

    return _possibleConstructorReturn(this, _getPrototypeOf(App).apply(this, arguments));
  }

  _createClass(App, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          match = _this$props.match,
          drawerType = _this$props.drawerType,
          navigationStyle = _this$props.navigationStyle,
          horizontalNavPosition = _this$props.horizontalNavPosition;
      var drawerStyle = drawerType.includes(_ActionTypes.FIXED_DRAWER) ? 'fixed-drawer' : drawerType.includes(_ActionTypes.COLLAPSED_DRAWER) ? 'collapsible-drawer' : 'mini-drawer'; //set default height and overflow for iOS mobile Safari 10+ support.

      if (_reactDeviceDetect.isIOS && _reactDeviceDetect.isMobile) {
        document.body.classList.add('ios-mobile-view-height');
      } else if (document.body.classList.contains('ios-mobile-view-height')) {
        document.body.classList.remove('ios-mobile-view-height');
      }

      return _react["default"].createElement("div", {
        className: "app-container ".concat(drawerStyle)
      }, _react["default"].createElement(_index2["default"], null), _react["default"].createElement("div", {
        className: "app-main-container"
      }, _react["default"].createElement("div", {
        className: "app-header"
      }, navigationStyle === _ActionTypes.HORIZONTAL_NAVIGATION && horizontalNavPosition === _ActionTypes.ABOVE_THE_HEADER && _react["default"].createElement(_TopNav["default"], {
        styleName: "app-top-header"
      }), _react["default"].createElement(_index["default"], null), navigationStyle === _ActionTypes.HORIZONTAL_NAVIGATION && horizontalNavPosition === _ActionTypes.BELOW_THE_HEADER && _react["default"].createElement(_TopNav["default"], null)), _react["default"].createElement("main", {
        className: "app-main-content-wrapper"
      }, _react["default"].createElement("div", {
        className: "app-main-content"
      }, _react["default"].createElement(_reactRouterDom.Switch, null, _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/projectCostPriority"),
        component: _projectCostPriority["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/projectBusPriority"),
        component: _projectBusPriority["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/issue"),
        component: _issue["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/initiative"),
        component: _initiative["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/product"),
        component: _product["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/team"),
        component: _team["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/member"),
        component: _member["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/valueStream"),
        component: _valueStream["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/feature"),
        component: _feature["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/portfolio"),
        component: _portfolio["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/portfolio-dashboard"),
        component: _portfolioDashboard["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/businessUnit"),
        component: _businessUnit["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/projectIssue"),
        component: _projectIssue["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/security"),
        component: _security["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/projectPriority"),
        component: _projectPriority["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/project"),
        component: _project["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/agile-dashboard"),
        component: _Dashboard["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/org-dashboard"),
        component: _OrgDashboard["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/emp-dashboard"),
        component: _EmpDashboard["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/org-emp-survey"),
        component: _OrgEmpSurvey["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/organisation"),
        component: _organisation["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/employee"),
        component: _employee["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/org-survey"),
        component: _OrgSurvey["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/org-survey-compare"),
        component: _OrgSurveyCompare["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/org-survey-compare-radar"),
        component: _OrgSurveyCompareRadar["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/org-survey-engagement-details"),
        component: _OrgSurveyEngagementDetails["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/survey-group"),
        component: _SurveyGroup["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/survey-group-question"),
        component: _SurveyGroupQuestion["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/dashboard"),
        component: _dashboard["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/components"),
        component: _components["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/icons"),
        component: _index3["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/form"),
        component: _form["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/editor"),
        component: _editors["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/pickers"),
        component: _pickers["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/extensions"),
        component: _extensions["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/table"),
        component: _table["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/chart"),
        component: _charts["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/map"),
        component: _map["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/calendar"),
        component: _calendar["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/time-line"),
        component: _timeLine["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/custom-views"),
        component: _customViews["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/widgets"),
        component: (0, _asyncComponent["default"])(function () {
          return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 2090));
        })
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/metrics"),
        component: (0, _asyncComponent["default"])(function () {
          return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 2091));
        })
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/extra-elements"),
        component: _extraElements["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/ecommerce"),
        component: _eCommerce["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/app-module"),
        component: _appModule["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/to-do"),
        component: (0, _asyncComponent["default"])(function () {
          return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 2092));
        })
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/to-do-redux"),
        component: (0, _asyncComponent["default"])(function () {
          return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 2093));
        })
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/mail"),
        component: (0, _asyncComponent["default"])(function () {
          return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 2094));
        })
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/mail-redux"),
        component: (0, _asyncComponent["default"])(function () {
          return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 2095));
        })
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/chat"),
        component: (0, _asyncComponent["default"])(function () {
          return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 2096));
        })
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/chat-redux"),
        component: (0, _asyncComponent["default"])(function () {
          return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 2097));
        })
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/contact"),
        component: (0, _asyncComponent["default"])(function () {
          return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 2098));
        })
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/contact-redux"),
        component: (0, _asyncComponent["default"])(function () {
          return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 2099));
        })
      }), _react["default"].createElement(_reactRouterDom.Route, {
        path: "".concat(match.url, "/extra-pages"),
        component: _extraPages["default"]
      }), _react["default"].createElement(_reactRouterDom.Route, {
        component: (0, _asyncComponent["default"])(function () {
          return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 39));
        })
      }))), _react["default"].createElement(_Footer["default"], null))));
    }
  }]);

  return App;
}(_react["default"].Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var settings = _ref.settings;
  var drawerType = settings.drawerType,
      navigationStyle = settings.navigationStyle,
      horizontalNavPosition = settings.horizontalNavPosition;
  return {
    drawerType: drawerType,
    navigationStyle: navigationStyle,
    horizontalNavPosition: horizontalNavPosition
  };
};

var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps)(App));

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(App, "App", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_index2, "_index2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_Footer, "_Footer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_dashboard, "_dashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_components, "_components", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_index3, "_index3", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_form, "_form", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_editors, "_editors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_pickers, "_pickers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_extensions, "_extensions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_table, "_table", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_charts, "_charts", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_map, "_map", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_calendar, "_calendar", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_timeLine, "_timeLine", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_customViews, "_customViews", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_extraElements, "_extraElements", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_eCommerce, "_eCommerce", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_appModule, "_appModule", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_extraPages, "_extraPages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_organisation, "_organisation", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_employee, "_employee", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_Dashboard, "_Dashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_OrgDashboard, "_OrgDashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_EmpDashboard, "_EmpDashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_OrgSurvey, "_OrgSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_OrgSurveyCompare, "_OrgSurveyCompare", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_OrgSurveyEngagementDetails, "_OrgSurveyEngagementDetails", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_OrgSurveyCompareRadar, "_OrgSurveyCompareRadar", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_OrgEmpSurvey, "_OrgEmpSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_SurveyGroup, "_SurveyGroup", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_SurveyGroupQuestion, "_SurveyGroupQuestion", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_project, "_project", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_projectPriority, "_projectPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_security, "_security", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_projectIssue, "_projectIssue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_businessUnit, "_businessUnit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_portfolio, "_portfolio", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_portfolioDashboard, "_portfolioDashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_feature, "_feature", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_valueStream, "_valueStream", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_member, "_member", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_team, "_team", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_product, "_product", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_initiative, "_initiative", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_issue, "_issue", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_projectBusPriority, "_projectBusPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_projectCostPriority, "_projectCostPriority", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_asyncComponent, "_asyncComponent", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_TopNav, "_TopNav", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(App, "App", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/index.js");
}();

;

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRouterDom = __webpack_require__(13);

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _ActionTypes = __webpack_require__(7);

var _SearchBox = _interopRequireDefault(__webpack_require__(427));

var _index = _interopRequireDefault(__webpack_require__(1419));

var _index2 = _interopRequireDefault(__webpack_require__(426));

var _Setting = __webpack_require__(265);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _index3 = _interopRequireDefault(__webpack_require__(1436));

var _UserInfo = _interopRequireDefault(__webpack_require__(1439));

var _Menu = _interopRequireDefault(__webpack_require__(686));

var _Authentication = __webpack_require__(42);

var _System = __webpack_require__(55);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Header =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Header, _React$Component);

  _createClass(Header, [{
    key: "__onAppNotificationSelect__REACT_HOT_LOADER__",
    value: function __onAppNotificationSelect__REACT_HOT_LOADER__() {
      this.setState({
        appNotification: !this.state.appNotification
      });
    }
  }, {
    key: "__onUserInfoSelect__REACT_HOT_LOADER__",
    value: function __onUserInfoSelect__REACT_HOT_LOADER__() {
      this.setState({
        userInfo: !this.state.userInfo
      });
    }
  }, {
    key: "__onLangSwitcherSelect__REACT_HOT_LOADER__",
    value: function __onLangSwitcherSelect__REACT_HOT_LOADER__() {
      this.setState({
        langSwitcher: !this.state.langSwitcher
      });
    }
  }, {
    key: "__onSearchBoxSelect__REACT_HOT_LOADER__",
    value: function __onSearchBoxSelect__REACT_HOT_LOADER__() {
      this.setState({
        searchBox: !this.state.searchBox
      });
    }
  }, {
    key: "__handleRequestClose__REACT_HOT_LOADER__",
    value: function __handleRequestClose__REACT_HOT_LOADER__() {
      this.setState({
        langSwitcher: false,
        mailNotification: false,
        appNotification: false,
        searchBox: false
      });
    }
  }, {
    key: "__onToggleCollapsedNav__REACT_HOT_LOADER__",
    value: function __onToggleCollapsedNav__REACT_HOT_LOADER__() {
      var val = !this.props.navCollapsed;
      this.props.toggleCollapsedNav(val);
    }
  }, {
    key: "__onDisplayProfileDetails__REACT_HOT_LOADER__",
    value: function __onDisplayProfileDetails__REACT_HOT_LOADER__() {
      this.setState({
        viewProfileDetails: true
      });
    }
  }]);

  function Header() {
    var _this;

    _classCallCheck(this, Header);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Header).call(this));

    _defineProperty(_assertThisInitialized(_this), "onAppNotificationSelect", function () {
      var _this2;

      return (_this2 = _this).__onAppNotificationSelect__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onUserInfoSelect", function () {
      var _this3;

      return (_this3 = _this).__onUserInfoSelect__REACT_HOT_LOADER__.apply(_this3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onLangSwitcherSelect", function () {
      var _this4;

      return (_this4 = _this).__onLangSwitcherSelect__REACT_HOT_LOADER__.apply(_this4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onSearchBoxSelect", function () {
      var _this5;

      return (_this5 = _this).__onSearchBoxSelect__REACT_HOT_LOADER__.apply(_this5, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "handleRequestClose", function () {
      var _this6;

      return (_this6 = _this).__handleRequestClose__REACT_HOT_LOADER__.apply(_this6, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onToggleCollapsedNav", function () {
      var _this7;

      return (_this7 = _this).__onToggleCollapsedNav__REACT_HOT_LOADER__.apply(_this7, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onDisplayProfileDetails", function () {
      var _this8;

      return (_this8 = _this).__onDisplayProfileDetails__REACT_HOT_LOADER__.apply(_this8, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "getHeaderDetails", function () {
      var _this9;

      return (_this9 = _this).__getHeaderDetails__REACT_HOT_LOADER__.apply(_this9, arguments);
    });

    _this.state = {
      searchBox: false,
      searchText: '',
      mailNotification: false,
      langSwitcher: false,
      appNotification: false,
      userInfo: false
    };
    return _this;
  }

  _createClass(Header, [{
    key: "updateSearchText",
    value: function updateSearchText(evt) {
      this.setState({
        searchText: evt.target.value
      });
    }
  }, {
    key: "__getHeaderDetails__REACT_HOT_LOADER__",
    value: function __getHeaderDetails__REACT_HOT_LOADER__() {
      var selectedOrg = this.props.selectedOrg;
      var headerDetail = ' (You are currently impersonating this organisation)';

      if ((0, _Authentication.isSuperUser)()) {
        if (selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.name) {
          headerDetail = selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.name.concat(headerDetail);
        } else {
          headerDetail = 'NONE SELECTED YET'.concat(headerDetail);
        }

        return headerDetail;
      }

      return '';
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          drawerType = _this$props.drawerType,
          locale = _this$props.locale,
          navigationStyle = _this$props.navigationStyle,
          horizontalNavPosition = _this$props.horizontalNavPosition,
          width = _this$props.width;
      var drawerStyle = drawerType.includes(_ActionTypes.FIXED_DRAWER) ? 'd-flex d-xl-none' : drawerType.includes(_ActionTypes.COLLAPSED_DRAWER) ? 'd-flex' : 'd-none';
      var headerMarginLeft = width > _System.TIGHT_FIT_PARAM ? 'ml-5' : 'ml-1';
      return _react["default"].createElement("div", {
        className: "app-main-header"
      }, _react["default"].createElement("div", {
        className: "d-flex app-toolbar align-items-center"
      }, navigationStyle === _ActionTypes.HORIZONTAL_NAVIGATION ? _react["default"].createElement("div", {
        className: "app-logo-bl"
      }, _react["default"].createElement("div", {
        className: "d-block d-md-none"
      }, _react["default"].createElement("span", {
        className: "jr-menu-icon",
        onClick: this.onToggleCollapsedNav
      }, _react["default"].createElement("span", {
        className: "menu-icon"
      }))), _react["default"].createElement("div", {
        className: "app-logo pointer d-none d-md-block"
      }, _react["default"].createElement("img", {
        className: "d-none d-lg-block",
        alt: "...",
        src: "http://via.placeholder.com/105x36"
      }), _react["default"].createElement("img", {
        className: "d-block d-lg-none mr-3",
        alt: "...",
        src: "http://via.placeholder.com/32x32"
      }))) : _react["default"].createElement("span", {
        className: "jr-menu-icon pointer ".concat(drawerStyle),
        onClick: this.onToggleCollapsedNav
      }, _react["default"].createElement("span", {
        className: "menu-icon"
      })), _react["default"].createElement("div", {
        className: headerMarginLeft,
        style: {
          fontWeight: '700',
          fontSize: '1.25rem',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }
      }, this.getHeaderDetails()), navigationStyle === _ActionTypes.HORIZONTAL_NAVIGATION && horizontalNavPosition === _ActionTypes.INSIDE_THE_HEADER && _react["default"].createElement(_Menu["default"], null), _react["default"].createElement("ul", {
        className: "header-notifications list-inline ml-auto"
      }, _react["default"].createElement("li", {
        className: "d-inline-block d-lg-none list-inline-item"
      }, _react["default"].createElement(_reactstrap.Dropdown, {
        className: "quick-menu nav-searchbox",
        isOpen: this.state.searchBox,
        toggle: this.onSearchBoxSelect.bind(this)
      }, _react["default"].createElement(_reactstrap.DropdownToggle, {
        className: "d-inline-block",
        tag: "span",
        "data-toggle": "dropdown"
      }, _react["default"].createElement("span", {
        className: "icon-btn size-30"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-search zmdi-hc-fw"
      }))), _react["default"].createElement(_reactstrap.DropdownMenu, {
        right: true,
        className: "p-0"
      }, _react["default"].createElement(_SearchBox["default"], {
        styleName: "search-dropdown",
        placeholder: "",
        onChange: this.updateSearchText.bind(this),
        value: this.state.searchText
      })))), _react["default"].createElement("li", {
        className: "list-inline-item"
      }, _react["default"].createElement(_reactstrap.Dropdown, {
        className: "quick-menu",
        isOpen: this.state.langSwitcher,
        toggle: this.onLangSwitcherSelect.bind(this)
      }, _react["default"].createElement(_reactstrap.DropdownToggle, {
        className: "d-inline-block",
        tag: "span",
        "data-toggle": "dropdown"
      }, _react["default"].createElement("div", {
        className: "d-flex align-items-center pointer"
      }, _react["default"].createElement("i", {
        className: "flag flag-24 flag-".concat(locale.icon)
      }))), _react["default"].createElement(_reactstrap.DropdownMenu, {
        right: true,
        className: "w-50"
      }, _react["default"].createElement(_index3["default"], {
        switchLanguage: this.props.switchLanguage,
        handleRequestClose: this.handleRequestClose
      })))), _react["default"].createElement("li", {
        className: "list-inline-item app-tour"
      }, _react["default"].createElement(_reactstrap.Dropdown, {
        className: "quick-menu",
        isOpen: this.state.appNotification,
        toggle: this.onAppNotificationSelect.bind(this)
      }, _react["default"].createElement(_reactstrap.DropdownToggle, {
        className: "d-inline-block",
        tag: "span",
        "data-toggle": "dropdown"
      }, _react["default"].createElement("span", {
        className: "icon-btn size-20 font-size-16"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-notifications-active zmdi-hc-lg icon-alert"
      }))), _react["default"].createElement(_reactstrap.DropdownMenu, {
        right: true
      }, _react["default"].createElement(_index2["default"], {
        styleName: "align-items-center",
        heading: _react["default"].createElement(_IntlMessages["default"], {
          id: "appNotification.title"
        })
      }), _react["default"].createElement(_index["default"], null)))), _react["default"].createElement("li", {
        className: "list-inline-item user-nav"
      }, _react["default"].createElement(_reactstrap.Dropdown, {
        className: "quick-menu",
        isOpen: this.state.userInfo,
        toggle: this.onUserInfoSelect.bind(this)
      }, _react["default"].createElement(_reactstrap.DropdownToggle, {
        className: "d-inline-block",
        tag: "span",
        "data-toggle": "dropdown"
      }, _react["default"].createElement("img", {
        alt: "...",
        src: "assets/images/person-150_150.jpg",
        className: "pointer user-avatar size-30"
      })), _react["default"].createElement(_reactstrap.DropdownMenu, {
        right: true
      }, _react["default"].createElement(_UserInfo["default"], null)))))));
    }
  }]);

  return Header;
}(_react["default"].Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var settings = _ref.settings,
      orgs = _ref.orgs;
  var drawerType = settings.drawerType,
      locale = settings.locale,
      navigationStyle = settings.navigationStyle,
      horizontalNavPosition = settings.horizontalNavPosition,
      width = settings.width;
  var selectedOrg = orgs.selectedOrg;
  return {
    drawerType: drawerType,
    locale: locale,
    navigationStyle: navigationStyle,
    horizontalNavPosition: horizontalNavPosition,
    selectedOrg: selectedOrg,
    width: width
  };
};

var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, {
  toggleCollapsedNav: _Setting.toggleCollapsedNav,
  switchLanguage: _Setting.switchLanguage
})(Header));

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Header, "Header", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_SearchBox, "_SearchBox", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_index2, "_index2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_index3, "_index3", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_UserInfo, "_UserInfo", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_Menu, "_Menu", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(Header, "Header", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Header/index.js");
}();

;

/***/ }),
/* 1337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  fluid: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div'
};

var Container = function Container(props) {
  var className = props.className,
      cssModule = props.cssModule,
      fluid = props.fluid,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "fluid", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, fluid ? 'container-fluid' : 'container'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

Container.propTypes = propTypes;
Container.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Container);

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    nullTag = '[object Null]',
    proxyTag = '[object Proxy]',
    undefinedTag = '[object Undefined]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isFunction;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)))

/***/ }),
/* 1339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  noGutters: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  form: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};
var defaultProps = {
  tag: 'div'
};

var Row = function Row(props) {
  var className = props.className,
      cssModule = props.cssModule,
      noGutters = props.noGutters,
      Tag = props.tag,
      form = props.form,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "noGutters", "tag", "form"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, noGutters ? 'no-gutters' : null, form ? 'form-row' : 'row'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

Row.propTypes = propTypes;
Row.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Row);

/***/ }),
/* 1340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isobject__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isobject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isobject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(9);







var colWidths = ['xs', 'sm', 'md', 'lg', 'xl'];
var stringOrNumberProp = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string]);
var columnProps = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
  size: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string]),
  push: Object(__WEBPACK_IMPORTED_MODULE_6__utils__["deprecated"])(stringOrNumberProp, 'Please use the prop "order"'),
  pull: Object(__WEBPACK_IMPORTED_MODULE_6__utils__["deprecated"])(stringOrNumberProp, 'Please use the prop "order"'),
  order: stringOrNumberProp,
  offset: stringOrNumberProp
})]);
var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_6__utils__["tagPropType"],
  xs: columnProps,
  sm: columnProps,
  md: columnProps,
  lg: columnProps,
  xl: columnProps,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  widths: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array
};
var defaultProps = {
  tag: 'div',
  widths: colWidths
};

var getColumnSizeClass = function getColumnSizeClass(isXs, colWidth, colSize) {
  if (colSize === true || colSize === '') {
    return isXs ? 'col' : "col-" + colWidth;
  } else if (colSize === 'auto') {
    return isXs ? 'col-auto' : "col-" + colWidth + "-auto";
  }

  return isXs ? "col-" + colSize : "col-" + colWidth + "-" + colSize;
};

var Col = function Col(props) {
  var className = props.className,
      cssModule = props.cssModule,
      widths = props.widths,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "widths", "tag"]);

  var colClasses = [];
  widths.forEach(function (colWidth, i) {
    var columnProp = props[colWidth];
    delete attributes[colWidth];

    if (!columnProp && columnProp !== '') {
      return;
    }

    var isXs = !i;

    if (__WEBPACK_IMPORTED_MODULE_2_lodash_isobject___default()(columnProp)) {
      var _classNames;

      var colSizeInterfix = isXs ? '-' : "-" + colWidth + "-";
      var colClass = getColumnSizeClass(isXs, colWidth, columnProp.size);
      colClasses.push(Object(__WEBPACK_IMPORTED_MODULE_6__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_5_classnames___default()((_classNames = {}, _classNames[colClass] = columnProp.size || columnProp.size === '', _classNames["order" + colSizeInterfix + columnProp.order] = columnProp.order || columnProp.order === 0, _classNames["offset" + colSizeInterfix + columnProp.offset] = columnProp.offset || columnProp.offset === 0, _classNames)), cssModule));
    } else {
      var _colClass = getColumnSizeClass(isXs, colWidth, columnProp);

      colClasses.push(_colClass);
    }
  });

  if (!colClasses.length) {
    colClasses.push('col');
  }

  var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, colClasses), cssModule);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

Col.propTypes = propTypes;
Col.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Col);

/***/ }),
/* 1341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  light: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  dark: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  inverse: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["deprecated"])(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool, 'Please use the prop "dark"'),
  full: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  fixed: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  sticky: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  color: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  role: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  toggleable: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["deprecated"])(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]), 'Please use the prop "expand"'),
  expand: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string])
};
var defaultProps = {
  tag: 'nav',
  expand: false
};

var getExpandClass = function getExpandClass(expand) {
  if (expand === false) {
    return false;
  } else if (expand === true || expand === 'xs') {
    return 'navbar-expand';
  }

  return "navbar-expand-" + expand;
}; // To better maintain backwards compatibility while toggleable is deprecated.
// We must map breakpoints to the next breakpoint so that toggleable and expand do the same things at the same breakpoint.


var toggleableToExpand = {
  xs: 'sm',
  sm: 'md',
  md: 'lg',
  lg: 'xl'
};

var getToggleableClass = function getToggleableClass(toggleable) {
  if (toggleable === undefined || toggleable === 'xl') {
    return false;
  } else if (toggleable === false) {
    return 'navbar-expand';
  }

  return "navbar-expand-" + (toggleable === true ? 'sm' : toggleableToExpand[toggleable] || toggleable);
};

var Navbar = function Navbar(props) {
  var _classNames;

  var toggleable = props.toggleable,
      expand = props.expand,
      className = props.className,
      cssModule = props.cssModule,
      light = props.light,
      dark = props.dark,
      inverse = props.inverse,
      fixed = props.fixed,
      sticky = props.sticky,
      color = props.color,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["toggleable", "expand", "className", "cssModule", "light", "dark", "inverse", "fixed", "sticky", "color", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'navbar', getExpandClass(expand) || getToggleableClass(toggleable), (_classNames = {
    'navbar-light': light,
    'navbar-dark': inverse || dark
  }, _classNames["bg-" + color] = color, _classNames["fixed-" + fixed] = fixed, _classNames["sticky-" + sticky] = sticky, _classNames)), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

Navbar.propTypes = propTypes;
Navbar.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Navbar);

/***/ }),
/* 1342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'a'
};

var NavbarBrand = function NavbarBrand(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'navbar-brand'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

NavbarBrand.propTypes = propTypes;
NavbarBrand.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (NavbarBrand);

/***/ }),
/* 1343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  type: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
var defaultProps = {
  tag: 'button',
  type: 'button'
};

var NavbarToggler = function NavbarToggler(props) {
  var className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "children", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'navbar-toggler'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }), children || __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])('navbar-toggler-icon', cssModule)
  }));
};

NavbarToggler.propTypes = propTypes;
NavbarToggler.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (NavbarToggler);

/***/ }),
/* 1344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tabs: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  pills: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  vertical: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),
  horizontal: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  justified: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  fill: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  navbar: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  card: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'ul',
  vertical: false
};

var getVerticalClass = function getVerticalClass(vertical) {
  if (vertical === false) {
    return false;
  } else if (vertical === true || vertical === 'xs') {
    return 'flex-column';
  }

  return "flex-" + vertical + "-column";
};

var Nav = function Nav(props) {
  var className = props.className,
      cssModule = props.cssModule,
      tabs = props.tabs,
      pills = props.pills,
      vertical = props.vertical,
      horizontal = props.horizontal,
      justified = props.justified,
      fill = props.fill,
      navbar = props.navbar,
      card = props.card,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tabs", "pills", "vertical", "horizontal", "justified", "fill", "navbar", "card", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, navbar ? 'navbar-nav' : 'nav', horizontal ? "justify-content-" + horizontal : false, getVerticalClass(vertical), {
    'nav-tabs': tabs,
    'card-header-tabs': card && tabs,
    'nav-pills': pills,
    'card-header-pills': card && pills,
    'nav-justified': justified,
    'nav-fill': fill
  }), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

Nav.propTypes = propTypes;
Nav.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Nav);

/***/ }),
/* 1345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  active: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'li'
};

var NavItem = function NavItem(props) {
  var className = props.className,
      cssModule = props.cssModule,
      active = props.active,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "active", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'nav-item', active ? 'active' : false), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

NavItem.propTypes = propTypes;
NavItem.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (NavItem);

/***/ }),
/* 1346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = NavDropdown;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dropdown__ = __webpack_require__(212);




function NavDropdown(props) {
  Object(__WEBPACK_IMPORTED_MODULE_2__utils__["warnOnce"])('The "NavDropdown" component has been deprecated.\nPlease use component "Dropdown" with nav prop.');
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Dropdown__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    nav: true
  }, props));
}

/***/ }),
/* 1347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Manager = function (_Component) {
  _inherits(Manager, _Component);

  function Manager() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Manager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Manager.__proto__ || Object.getPrototypeOf(Manager)).call.apply(_ref, [this].concat(args))), _this), _this._setTargetNode = function (node) {
      _this._targetNode = node;
    }, _this._getTargetNode = function () {
      return _this._targetNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Manager, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popperManager: {
          setTargetNode: this._setTargetNode,
          getTargetNode: this._getTargetNode
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          tag = _props.tag,
          children = _props.children,
          restProps = _objectWithoutProperties(_props, ['tag', 'children']);

      if (tag !== false) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(tag, restProps, children);
      } else {
        return children;
      }
    }
  }]);

  return Manager;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Manager.childContextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
Manager.propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Manager.defaultProps = {
  tag: 'div'
};


/* harmony default export */ __webpack_exports__["a"] = (Manager);

/***/ }),
/* 1348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var Target = function Target(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'div' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popperManager = context.popperManager;

  var targetRef = function targetRef(node) {
    popperManager.setTargetNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };

  if (typeof children === 'function') {
    var targetProps = { ref: targetRef };
    return children({ targetProps: targetProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps);

  if (typeof component === 'string') {
    componentProps.ref = targetRef;
  } else {
    componentProps.innerRef = targetRef;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, componentProps, children);
};

Target.contextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

Target.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};

/* harmony default export */ __webpack_exports__["a"] = (Target);

/***/ }),
/* 1349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export placements */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_popper_js__ = __webpack_require__(869);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var placements = __WEBPACK_IMPORTED_MODULE_2_popper_js__["default"].placements;

var Popper = function (_Component) {
  _inherits(Popper, _Component);

  function Popper() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Popper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popper.__proto__ || Object.getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._setArrowNode = function (node) {
      _this._arrowNode = node;
    }, _this._getTargetNode = function () {
      if (_this.props.target) {
        return _this.props.target;
      } else if (!_this.context.popperManager || !_this.context.popperManager.getTargetNode()) {
        throw new Error('Target missing. Popper must be given a target from the Popper Manager, or as a prop.');
      }
      return _this.context.popperManager.getTargetNode();
    }, _this._getOffsets = function (data) {
      return Object.keys(data.offsets).map(function (key) {
        return data.offsets[key];
      });
    }, _this._isDataDirty = function (data) {
      if (_this.state.data) {
        return JSON.stringify(_this._getOffsets(_this.state.data)) !== JSON.stringify(_this._getOffsets(data));
      } else {
        return true;
      }
    }, _this._updateStateModifier = {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        if (_this._isDataDirty(data)) {
          _this.setState({ data: data });
        }
        return data;
      }
    }, _this._getPopperStyle = function () {
      var data = _this.state.data;


      if (!_this._popper || !data) {
        return {
          position: 'absolute',
          pointerEvents: 'none',
          opacity: 0
        };
      }

      return _extends({
        position: data.offsets.popper.position
      }, data.styles);
    }, _this._getPopperPlacement = function () {
      return _this.state.data ? _this.state.data.placement : undefined;
    }, _this._getPopperHide = function () {
      return !!_this.state.data && _this.state.data.hide ? '' : undefined;
    }, _this._getArrowStyle = function () {
      if (!_this.state.data || !_this.state.data.offsets.arrow) {
        return {};
      } else {
        var _this$state$data$offs = _this.state.data.offsets.arrow,
            top = _this$state$data$offs.top,
            left = _this$state$data$offs.left;

        return { top: top, left: left };
      }
    }, _this._handlePopperRef = function (node) {
      _this._popperNode = node;
      if (node) {
        _this._createPopper();
      } else {
        _this._destroyPopper();
      }
      if (_this.props.innerRef) {
        _this.props.innerRef(node);
      }
    }, _this._scheduleUpdate = function () {
      _this._popper && _this._popper.scheduleUpdate();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Popper, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popper: {
          setArrowNode: this._setArrowNode,
          getArrowStyle: this._getArrowStyle
        }
      };
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(lastProps) {
      if (lastProps.placement !== this.props.placement || lastProps.eventsEnabled !== this.props.eventsEnabled || lastProps.target !== this.props.target) {
        this._destroyPopper();
        this._createPopper();
      }
      if (lastProps.children !== this.props.children) {
        this._scheduleUpdate();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._destroyPopper();
    }
  }, {
    key: '_createPopper',
    value: function _createPopper() {
      var _this2 = this;

      var _props = this.props,
          placement = _props.placement,
          eventsEnabled = _props.eventsEnabled,
          positionFixed = _props.positionFixed;

      var modifiers = _extends({}, this.props.modifiers, {
        applyStyle: { enabled: false },
        updateState: this._updateStateModifier
      });
      if (this._arrowNode) {
        modifiers.arrow = _extends({}, this.props.modifiers.arrow || {}, {
          element: this._arrowNode
        });
      }
      this._popper = new __WEBPACK_IMPORTED_MODULE_2_popper_js__["default"](this._getTargetNode(), this._popperNode, {
        placement: placement,
        positionFixed: positionFixed,
        eventsEnabled: eventsEnabled,
        modifiers: modifiers
      });

      // TODO: look into setTimeout scheduleUpdate call, without it, the popper will not position properly on creation
      setTimeout(function () {
        return _this2._scheduleUpdate();
      });
    }
  }, {
    key: '_destroyPopper',
    value: function _destroyPopper() {
      if (this._popper) {
        this._popper.destroy();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          component = _props2.component,
          innerRef = _props2.innerRef,
          placement = _props2.placement,
          eventsEnabled = _props2.eventsEnabled,
          positionFixed = _props2.positionFixed,
          modifiers = _props2.modifiers,
          children = _props2.children,
          restProps = _objectWithoutProperties(_props2, ['component', 'innerRef', 'placement', 'eventsEnabled', 'positionFixed', 'modifiers', 'children']);

      var popperStyle = this._getPopperStyle();
      var popperPlacement = this._getPopperPlacement();
      var popperHide = this._getPopperHide();

      if (typeof children === 'function') {
        var popperProps = {
          ref: this._handlePopperRef,
          style: popperStyle,
          'data-placement': popperPlacement,
          'data-x-out-of-boundaries': popperHide
        };
        return children({
          popperProps: popperProps,
          restProps: restProps,
          scheduleUpdate: this._scheduleUpdate
        });
      }

      var componentProps = _extends({}, restProps, {
        style: _extends({}, restProps.style, popperStyle),
        'data-placement': popperPlacement,
        'data-x-out-of-boundaries': popperHide
      });

      if (typeof component === 'string') {
        componentProps.ref = this._handlePopperRef;
      } else {
        componentProps.innerRef = this._handlePopperRef;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, componentProps, children);
    }
  }]);

  return Popper;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Popper.contextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
Popper.childContextTypes = {
  popper: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
Popper.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(placements),
  eventsEnabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  positionFixed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  modifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([
  // the following check is needed for SSR
  __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(typeof Element !== 'undefined' ? Element : Object), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    getBoundingClientRect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    clientWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    clientHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  })])
};
Popper.defaultProps = {
  component: 'div',
  placement: 'bottom',
  eventsEnabled: true,
  positionFixed: false,
  modifiers: {}
};


/* harmony default export */ __webpack_exports__["a"] = (Popper);

/***/ }),
/* 1350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var Arrow = function Arrow(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'span' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popper = context.popper;

  var arrowRef = function arrowRef(node) {
    popper.setArrowNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };
  var arrowStyle = popper.getArrowStyle();

  if (typeof children === 'function') {
    var arrowProps = {
      ref: arrowRef,
      style: arrowStyle
    };
    return children({ arrowProps: arrowProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps, {
    style: _extends({}, arrowStyle, restProps.style)
  });

  if (typeof component === 'string') {
    componentProps.ref = arrowRef;
  } else {
    componentProps.innerRef = arrowRef;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, componentProps, children);
};

Arrow.contextTypes = {
  popper: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

Arrow.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};

/* harmony default export */ __webpack_exports__["a"] = (Arrow);

/***/ }),
/* 1351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(9);








var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_7__utils__["tagPropType"],
  innerRef: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  onClick: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  href: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any
};
var defaultProps = {
  tag: 'a'
};

var NavLink =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(NavLink, _React$Component);

  function NavLink(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.onClick = _this.onClick.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = NavLink.prototype;

  _proto.onClick = function onClick(e) {
    if (this.props.disabled) {
      e.preventDefault();
      return;
    }

    if (this.props.href === '#') {
      e.preventDefault();
    }

    if (this.props.onClick) {
      this.props.onClick(e);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        cssModule = _this$props.cssModule,
        active = _this$props.active,
        Tag = _this$props.tag,
        innerRef = _this$props.innerRef,
        attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className", "cssModule", "active", "tag", "innerRef"]);

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, 'nav-link', {
      disabled: attributes.disabled,
      active: active
    }), cssModule);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
      ref: innerRef,
      onClick: this.onClick,
      className: classes
    }));
  };

  return NavLink;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

NavLink.propTypes = propTypes;
NavLink.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 1352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  listTag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  listClassName: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  'aria-label': __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};
var defaultProps = {
  tag: 'nav',
  listTag: 'ol',
  'aria-label': 'breadcrumb'
};

var Breadcrumb = function Breadcrumb(props) {
  var className = props.className,
      listClassName = props.listClassName,
      cssModule = props.cssModule,
      children = props.children,
      Tag = props.tag,
      ListTag = props.listTag,
      label = props['aria-label'],
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "listClassName", "cssModule", "children", "tag", "listTag", "aria-label"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className), cssModule);
  var listClasses = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()('breadcrumb', listClassName), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes,
    "aria-label": label
  }), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ListTag, {
    className: listClasses
  }, children));
};

Breadcrumb.propTypes = propTypes;
Breadcrumb.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Breadcrumb);

/***/ }),
/* 1353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  active: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'li'
};

var BreadcrumbItem = function BreadcrumbItem(props) {
  var className = props.className,
      cssModule = props.cssModule,
      active = props.active,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "active", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, active ? 'active' : false, 'breadcrumb-item'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes,
    "aria-current": active ? 'page' : undefined
  }));
};

BreadcrumbItem.propTypes = propTypes;
BreadcrumbItem.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (BreadcrumbItem);

/***/ }),
/* 1354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  'aria-label': __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  role: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  vertical: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};
var defaultProps = {
  tag: 'div',
  role: 'group'
};

var ButtonGroup = function ButtonGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      size = props.size,
      vertical = props.vertical,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "size", "vertical", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, size ? 'btn-group-' + size : false, vertical ? 'btn-group-vertical' : 'btn-group'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

ButtonGroup.propTypes = propTypes;
ButtonGroup.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (ButtonGroup);

/***/ }),
/* 1355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  'aria-label': __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  role: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};
var defaultProps = {
  tag: 'div',
  role: 'toolbar'
};

var ButtonToolbar = function ButtonToolbar(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'btn-toolbar'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

ButtonToolbar.propTypes = propTypes;
ButtonToolbar.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (ButtonToolbar);

/***/ }),
/* 1356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(9);








var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  active: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  divider: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_7__utils__["tagPropType"],
  header: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  toggle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var contextTypes = {
  toggle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};
var defaultProps = {
  tag: 'button',
  toggle: true
};

var DropdownItem =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(DropdownItem, _React$Component);

  function DropdownItem(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.onClick = _this.onClick.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.getTabIndex = _this.getTabIndex.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = DropdownItem.prototype;

  _proto.onClick = function onClick(e) {
    if (this.props.disabled || this.props.header || this.props.divider) {
      e.preventDefault();
      return;
    }

    if (this.props.onClick) {
      this.props.onClick(e);
    }

    if (this.props.toggle) {
      this.context.toggle(e);
    }
  };

  _proto.getTabIndex = function getTabIndex() {
    if (this.props.disabled || this.props.header || this.props.divider) {
      return '-1';
    }

    return '0';
  };

  _proto.render = function render() {
    var tabIndex = this.getTabIndex();
    var role = tabIndex > -1 ? 'menuitem' : undefined;

    var _omit = Object(__WEBPACK_IMPORTED_MODULE_7__utils__["omit"])(this.props, ['toggle']),
        className = _omit.className,
        cssModule = _omit.cssModule,
        divider = _omit.divider,
        Tag = _omit.tag,
        header = _omit.header,
        active = _omit.active,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_omit, ["className", "cssModule", "divider", "tag", "header", "active"]);

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, {
      disabled: props.disabled,
      'dropdown-item': !divider && !header,
      active: active,
      'dropdown-header': header,
      'dropdown-divider': divider
    }), cssModule);

    if (Tag === 'button') {
      if (header) {
        Tag = 'h6';
      } else if (divider) {
        Tag = 'div';
      } else if (props.href) {
        Tag = 'a';
      }
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      type: Tag === 'button' && (props.onClick || this.props.toggle) ? 'button' : undefined
    }, props, {
      tabIndex: tabIndex,
      role: role,
      className: classes,
      onClick: this.onClick
    }));
  };

  return DropdownItem;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

DropdownItem.propTypes = propTypes;
DropdownItem.defaultProps = defaultProps;
DropdownItem.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (DropdownItem);

/***/ }),
/* 1357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_popper__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(9);








var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_7__utils__["tagPropType"],
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node.isRequired,
  right: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  flip: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  modifiers: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  persist: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
};
var defaultProps = {
  tag: 'div',
  flip: true
};
var contextTypes = {
  isOpen: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
  direction: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['up', 'down', 'left', 'right']).isRequired,
  inNavbar: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired
};
var noFlipModifier = {
  flip: {
    enabled: false
  }
};
var directionPositionMap = {
  up: 'top',
  left: 'left',
  right: 'right',
  down: 'bottom'
};

var DropdownMenu = function DropdownMenu(props, context) {
  var className = props.className,
      cssModule = props.cssModule,
      right = props.right,
      tag = props.tag,
      flip = props.flip,
      modifiers = props.modifiers,
      persist = props.persist,
      attrs = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "right", "tag", "flip", "modifiers", "persist"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, 'dropdown-menu', {
    'dropdown-menu-right': right,
    show: context.isOpen
  }), cssModule);
  var Tag = tag;

  if (persist || context.isOpen && !context.inNavbar) {
    Tag = __WEBPACK_IMPORTED_MODULE_6_react_popper__["c" /* Popper */];
    var position1 = directionPositionMap[context.direction] || 'bottom';
    var position2 = right ? 'end' : 'start';
    attrs.placement = position1 + "-" + position2;
    attrs.component = tag;
    attrs.modifiers = !flip ? Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, modifiers, noFlipModifier) : modifiers;
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    tabIndex: "-1",
    role: "menu"
  }, attrs, {
    "aria-hidden": !context.isOpen,
    className: classes,
    "x-placement": attrs.placement
  }));
};

DropdownMenu.propTypes = propTypes;
DropdownMenu.defaultProps = defaultProps;
DropdownMenu.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (DropdownMenu);

/***/ }),
/* 1358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),
/* 1359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_popper__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Button__ = __webpack_require__(367);










var propTypes = {
  caret: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  'aria-haspopup': __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  split: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_8__utils__["tagPropType"],
  nav: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var defaultProps = {
  'aria-haspopup': true,
  color: 'secondary'
};
var contextTypes = {
  isOpen: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired,
  toggle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  inNavbar: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired
};

var DropdownToggle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(DropdownToggle, _React$Component);

  function DropdownToggle(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.onClick = _this.onClick.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = DropdownToggle.prototype;

  _proto.onClick = function onClick(e) {
    if (this.props.disabled) {
      e.preventDefault();
      return;
    }

    if (this.props.nav && !this.props.tag) {
      e.preventDefault();
    }

    if (this.props.onClick) {
      this.props.onClick(e);
    }

    this.context.toggle(e);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        color = _this$props.color,
        cssModule = _this$props.cssModule,
        caret = _this$props.caret,
        split = _this$props.split,
        nav = _this$props.nav,
        tag = _this$props.tag,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className", "color", "cssModule", "caret", "split", "nav", "tag"]);

    var ariaLabel = props['aria-label'] || 'Toggle Dropdown';
    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, {
      'dropdown-toggle': caret || split,
      'dropdown-toggle-split': split,
      'nav-link': nav
    }), cssModule);
    var children = props.children || __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", {
      className: "sr-only"
    }, ariaLabel);
    var Tag;

    if (nav && !tag) {
      Tag = 'a';
      props.href = '#';
    } else if (!tag) {
      Tag = __WEBPACK_IMPORTED_MODULE_9__Button__["a" /* default */];
      props.color = color;
      props.cssModule = cssModule;
    } else {
      Tag = tag;
    }

    if (this.context.inNavbar) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
        className: classes,
        onClick: this.onClick,
        "aria-expanded": this.context.isOpen,
        children: children
      }));
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_popper__["d" /* Target */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      className: classes,
      component: Tag,
      onClick: this.onClick,
      "aria-expanded": this.context.isOpen,
      children: children
    }));
  };

  return DropdownToggle;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

DropdownToggle.propTypes = propTypes;
DropdownToggle.defaultProps = defaultProps;
DropdownToggle.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (DropdownToggle);

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(214));

var _addClass = _interopRequireDefault(__webpack_require__(442));

var _removeClass = _interopRequireDefault(__webpack_require__(443));

var _react = _interopRequireDefault(__webpack_require__(0));

var _Transition = _interopRequireDefault(__webpack_require__(665));

var _PropTypes = __webpack_require__(666);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass.default)(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass.default)(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity: 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */


var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');

      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var appearClassName = _this.getClassNames('appear').doneClassName;

      var enterClassName = _this.getClassNames('enter').doneClassName;

      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      var _this$getClassNames3 = _this.getClassNames('exit'),
          className = _this$getClassNames3.className;

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames4.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames5.doneClassName;

      _this.removeClasses(node, 'exit');

      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
      var className = isStringClassNames ? prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$getClassNames6 = this.getClassNames(type),
        className = _this$getClassNames6.className,
        activeClassName = _this$getClassNames6.activeClassName,
        doneClassName = _this$getClassNames6.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */

      addClass(node, className);
    }
  };

  _proto.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;
    return _react.default.createElement(_Transition.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react.default.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
  /**
   * The animation classNames applied to the component as it enters, exits or
   * has finished the transition. A single name can be provided and it will be
   * suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
   *
   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
   * This allows you to define different behavior for when appearing is done and
   * when regular entering is done, using selectors like
   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
   * epic entrance animation when element first appears in the DOM using
   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   * simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
var _default = CSSTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1362);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(214));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = __webpack_require__(35);

var _TransitionGroup = _interopRequireDefault(__webpack_require__(667));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */
var ReplaceTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);

    var _React$Children$toArr = _react.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : _react.default.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(_react.default.Component);

ReplaceTransition.propTypes =  false ? {
  in: _propTypes.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};
var _default = ReplaceTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, _react.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),
/* 1365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  color: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  pill: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  innerRef: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  color: 'secondary',
  pill: false,
  tag: 'span'
};

var Badge = function Badge(props) {
  var className = props.className,
      cssModule = props.cssModule,
      color = props.color,
      innerRef = props.innerRef,
      pill = props.pill,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "color", "innerRef", "pill", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'badge', 'badge-' + color, pill ? 'badge-pill' : false), cssModule);

  if (attributes.href && Tag === 'span') {
    Tag = 'a';
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes,
    ref: innerRef
  }));
};

Badge.propTypes = propTypes;
Badge.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Badge);

/***/ }),
/* 1366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  inverse: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  block: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["deprecated"])(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool, 'Please use the props "body"'),
  body: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  outline: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  innerRef: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func])
};
var defaultProps = {
  tag: 'div'
};

var Card = function Card(props) {
  var className = props.className,
      cssModule = props.cssModule,
      color = props.color,
      block = props.block,
      body = props.body,
      inverse = props.inverse,
      outline = props.outline,
      Tag = props.tag,
      innerRef = props.innerRef,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "color", "block", "body", "inverse", "outline", "tag", "innerRef"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card', inverse ? 'text-white' : false, block || body ? 'card-body' : false, color ? (outline ? 'border' : 'bg') + "-" + color : false), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes,
    ref: innerRef
  }));
};

Card.propTypes = propTypes;
Card.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Card);

/***/ }),
/* 1367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div'
};

var CardGroup = function CardGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card-group'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

CardGroup.propTypes = propTypes;
CardGroup.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (CardGroup);

/***/ }),
/* 1368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div'
};

var CardDeck = function CardDeck(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card-deck'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

CardDeck.propTypes = propTypes;
CardDeck.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (CardDeck);

/***/ }),
/* 1369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div'
};

var CardColumns = function CardColumns(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card-columns'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

CardColumns.propTypes = propTypes;
CardColumns.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (CardColumns);

/***/ }),
/* 1370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardBlock;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CardBody__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(9);



function CardBlock(props) {
  Object(__WEBPACK_IMPORTED_MODULE_2__utils__["warnOnce"])('The "CardBlock" component has been deprecated.\nPlease use component "CardBody".');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__CardBody__["a" /* default */], props);
}

/***/ }),
/* 1371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  innerRef: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'a'
};

var CardLink = function CardLink(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      innerRef = props.innerRef,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag", "innerRef"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card-link'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    ref: innerRef,
    className: classes
  }));
};

CardLink.propTypes = propTypes;
CardLink.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (CardLink);

/***/ }),
/* 1372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div'
};

var CardFooter = function CardFooter(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card-footer'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

CardFooter.propTypes = propTypes;
CardFooter.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (CardFooter);

/***/ }),
/* 1373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div'
};

var CardHeader = function CardHeader(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card-header'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

CardHeader.propTypes = propTypes;
CardHeader.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (CardHeader);

/***/ }),
/* 1374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  top: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  bottom: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'img'
};

var CardImg = function CardImg(props) {
  var className = props.className,
      cssModule = props.cssModule,
      top = props.top,
      bottom = props.bottom,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "top", "bottom", "tag"]);

  var cardImgClassName = 'card-img';

  if (top) {
    cardImgClassName = 'card-img-top';
  }

  if (bottom) {
    cardImgClassName = 'card-img-bottom';
  }

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, cardImgClassName), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

CardImg.propTypes = propTypes;
CardImg.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (CardImg);

/***/ }),
/* 1375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div'
};

var CardImgOverlay = function CardImgOverlay(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card-img-overlay'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

CardImgOverlay.propTypes = propTypes;
CardImgOverlay.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (CardImgOverlay);

/***/ }),
/* 1376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Carousel__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CarouselItem__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CarouselControl__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CarouselIndicators__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CarouselCaption__ = __webpack_require__(672);











var propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array.isRequired,
  indicators: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  controls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  autoPlay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  defaultActiveIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  activeIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  next: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  previous: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  goToIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};

var UncontrolledCarousel =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(UncontrolledCarousel, _Component);

  function UncontrolledCarousel(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.animating = false;
    _this.state = {
      activeIndex: props.defaultActiveIndex || 0
    };
    _this.next = _this.next.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.previous = _this.previous.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.goToIndex = _this.goToIndex.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.onExiting = _this.onExiting.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.onExited = _this.onExited.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = UncontrolledCarousel.prototype;

  _proto.onExiting = function onExiting() {
    this.animating = true;
  };

  _proto.onExited = function onExited() {
    this.animating = false;
  };

  _proto.next = function next() {
    if (this.animating) return;
    var nextIndex = this.state.activeIndex === this.props.items.length - 1 ? 0 : this.state.activeIndex + 1;
    this.setState({
      activeIndex: nextIndex
    });
  };

  _proto.previous = function previous() {
    if (this.animating) return;
    var nextIndex = this.state.activeIndex === 0 ? this.props.items.length - 1 : this.state.activeIndex - 1;
    this.setState({
      activeIndex: nextIndex
    });
  };

  _proto.goToIndex = function goToIndex(newIndex) {
    if (this.animating) return;
    this.setState({
      activeIndex: newIndex
    });
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        defaultActiveIndex = _this$props.defaultActiveIndex,
        autoPlay = _this$props.autoPlay,
        indicators = _this$props.indicators,
        controls = _this$props.controls,
        items = _this$props.items,
        goToIndex = _this$props.goToIndex,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["defaultActiveIndex", "autoPlay", "indicators", "controls", "items", "goToIndex"]);

    var activeIndex = this.state.activeIndex;
    var slides = items.map(function (item) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__CarouselItem__["a" /* default */], {
        onExiting: _this2.onExiting,
        onExited: _this2.onExited,
        key: item.src
      }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", {
        className: "d-block w-100",
        src: item.src,
        alt: item.altText
      }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__CarouselCaption__["a" /* default */], {
        captionText: item.caption,
        captionHeader: item.header || item.caption
      }));
    });
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Carousel__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      activeIndex: activeIndex,
      next: this.next,
      previous: this.previous,
      ride: autoPlay ? 'carousel' : undefined
    }, props), indicators && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__CarouselIndicators__["a" /* default */], {
      items: items,
      activeIndex: props.activeIndex || activeIndex,
      onClickHandler: goToIndex || this.goToIndex
    }), slides, controls && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__CarouselControl__["a" /* default */], {
      direction: "prev",
      directionText: "Previous",
      onClickHandler: props.previous || this.previous
    }), controls && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__CarouselControl__["a" /* default */], {
      direction: "next",
      directionText: "Next",
      onClickHandler: props.next || this.next
    }));
  };

  return UncontrolledCarousel;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

UncontrolledCarousel.propTypes = propTypes;
UncontrolledCarousel.defaultProps = {
  controls: true,
  indicators: true,
  autoPlay: true
};
/* harmony default export */ __webpack_exports__["a"] = (UncontrolledCarousel);

/***/ }),
/* 1377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div'
};

var CardSubtitle = function CardSubtitle(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card-subtitle'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

CardSubtitle.propTypes = propTypes;
CardSubtitle.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (CardSubtitle);

/***/ }),
/* 1378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'p'
};

var CardText = function CardText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card-text'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

CardText.propTypes = propTypes;
CardText.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (CardText);

/***/ }),
/* 1379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div'
};

var CardTitle = function CardTitle(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card-title'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

CardTitle.propTypes = propTypes;
CardTitle.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (CardTitle);

/***/ }),
/* 1380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  id: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]).isRequired,
  type: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  inline: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  valid: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  invalid: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  bsSize: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func]),
  innerRef: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func])
};

function CustomInput(props) {
  var className = props.className,
      label = props.label,
      inline = props.inline,
      valid = props.valid,
      invalid = props.invalid,
      cssModule = props.cssModule,
      children = props.children,
      bsSize = props.bsSize,
      innerRef = props.innerRef,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "label", "inline", "valid", "invalid", "cssModule", "children", "bsSize", "innerRef"]);

  var type = attributes.type;
  var customClass = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, "custom-" + type, bsSize ? "custom-" + type + "-" + bsSize : false), cssModule);
  var validationClassNames = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(invalid && 'is-invalid', valid && 'is-valid'), cssModule);

  if (type === 'select') {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("select", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
      ref: innerRef,
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(validationClassNames, customClass)
    }), children);
  }

  if (type === 'file') {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
      className: customClass
    }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("input", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
      ref: innerRef,
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(validationClassNames, Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])('custom-file-input', cssModule))
    })), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("label", {
      className: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])('custom-file-label', cssModule),
      htmlFor: attributes.id
    }, label || 'Choose file'));
  }

  if (type !== 'checkbox' && type !== 'radio' && type !== 'switch') {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("input", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
      ref: innerRef,
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(validationClassNames, customClass)
    }));
  }

  var wrapperClasses = __WEBPACK_IMPORTED_MODULE_4_classnames___default()(customClass, Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()('custom-control', {
    'custom-control-inline': inline
  }), cssModule));
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: wrapperClasses
  }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("input", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    type: type === 'switch' ? 'checkbox' : type,
    ref: innerRef,
    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(validationClassNames, Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])('custom-control-input', cssModule))
  })), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("label", {
    className: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])('custom-control-label', cssModule),
    htmlFor: attributes.id
  }, label), children);
}

CustomInput.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (CustomInput);

/***/ }),
/* 1381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(9);



var PopperTargetHelper = function PopperTargetHelper(props, context) {
  context.popperManager.setTargetNode(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["getTarget"])(props.target));
  return null;
};

PopperTargetHelper.contextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};
PopperTargetHelper.propTypes = {
  target: __WEBPACK_IMPORTED_MODULE_1__utils__["targetPropType"].isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (PopperTargetHelper);

/***/ }),
/* 1382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UncontrolledPopover; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Popover__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(9);








var omitKeys = ['defaultOpen'];

var UncontrolledPopover =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(UncontrolledPopover, _Component);

  function UncontrolledPopover(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      isOpen: props.defaultOpen || false
    };
    _this.toggle = _this.toggle.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = UncontrolledPopover.prototype;

  _proto.toggle = function toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Popover__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      isOpen: this.state.isOpen,
      toggle: this.toggle
    }, Object(__WEBPACK_IMPORTED_MODULE_7__utils__["omit"])(this.props, omitKeys)));
  };

  return UncontrolledPopover;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);


UncontrolledPopover.propTypes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({
  defaultOpen: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
}, __WEBPACK_IMPORTED_MODULE_6__Popover__["a" /* default */].propTypes);

/***/ }),
/* 1383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PopoverTitle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PopoverHeader__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(9);



function PopoverTitle(props) {
  Object(__WEBPACK_IMPORTED_MODULE_2__utils__["warnOnce"])('The "PopoverTitle" component has been deprecated.\nPlease use component "PopoverHeader".');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__PopoverHeader__["a" /* default */], props);
}

/***/ }),
/* 1384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PopoverContent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PopoverBody__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(9);



function PopoverContent(props) {
  Object(__WEBPACK_IMPORTED_MODULE_2__utils__["warnOnce"])('The "PopoverContent" component has been deprecated.\nPlease use component "PopoverBody".');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__PopoverBody__["a" /* default */], props);
}

/***/ }),
/* 1385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_tonumber__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_tonumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_tonumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(9);







var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  bar: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  multi: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_6__utils__["tagPropType"],
  value: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]),
  max: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]),
  animated: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  striped: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  barClassName: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div',
  value: 0,
  max: 100
};

var Progress = function Progress(props) {
  var children = props.children,
      className = props.className,
      barClassName = props.barClassName,
      cssModule = props.cssModule,
      value = props.value,
      max = props.max,
      animated = props.animated,
      striped = props.striped,
      color = props.color,
      bar = props.bar,
      multi = props.multi,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["children", "className", "barClassName", "cssModule", "value", "max", "animated", "striped", "color", "bar", "multi", "tag"]);

  var percent = __WEBPACK_IMPORTED_MODULE_5_lodash_tonumber___default()(value) / __WEBPACK_IMPORTED_MODULE_5_lodash_tonumber___default()(max) * 100;
  var progressClasses = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'progress'), cssModule);
  var progressBarClasses = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()('progress-bar', bar ? className || barClassName : barClassName, animated ? 'progress-bar-animated' : null, color ? "bg-" + color : null, striped || animated ? 'progress-bar-striped' : null), cssModule);
  var ProgressBar = multi ? children : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: progressBarClasses,
    style: {
      width: percent + "%"
    },
    role: "progressbar",
    "aria-valuenow": value,
    "aria-valuemin": "0",
    "aria-valuemax": max,
    children: children
  });

  if (bar) {
    return ProgressBar;
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: progressClasses,
    children: ProgressBar
  }));
};

Progress.propTypes = propTypes;
Progress.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Progress);

/***/ }),
/* 1386 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 1387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Portal__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Fade__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(9);











function noop() {}

var FadePropTypes = __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_8__Fade__["a" /* default */].propTypes);
var propTypes = {
  isOpen: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  autoFocus: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  centered: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  size: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  toggle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  keyboard: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  labelledBy: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  backdrop: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['static'])]),
  onEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onExit: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onOpened: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onClosed: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  wrapClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  modalClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  backdropClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  contentClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  external: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  fade: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  zIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),
  backdropTransition: FadePropTypes,
  modalTransition: FadePropTypes,
  innerRef: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func])
};
var propsToOmit = Object.keys(propTypes);
var defaultProps = {
  isOpen: false,
  autoFocus: true,
  centered: false,
  role: 'dialog',
  backdrop: true,
  keyboard: true,
  zIndex: 1050,
  fade: true,
  onOpened: noop,
  onClosed: noop,
  modalTransition: {
    timeout: __WEBPACK_IMPORTED_MODULE_9__utils__["TransitionTimeouts"].Modal
  },
  backdropTransition: {
    mountOnEnter: true,
    timeout: __WEBPACK_IMPORTED_MODULE_9__utils__["TransitionTimeouts"].Fade // uses standard fade transition

  }
};

var Modal =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Modal, _React$Component);

  function Modal(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this._element = null;
    _this._originalBodyPadding = null;
    _this.getFocusableChildren = _this.getFocusableChildren.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleBackdropClick = _this.handleBackdropClick.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleBackdropMouseDown = _this.handleBackdropMouseDown.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleEscape = _this.handleEscape.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleTab = _this.handleTab.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.onOpened = _this.onOpened.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.onClosed = _this.onClosed.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.state = {
      isOpen: props.isOpen
    };

    if (props.isOpen) {
      _this.init();
    }

    return _this;
  }

  var _proto = Modal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.onEnter) {
      this.props.onEnter();
    }

    if (this.state.isOpen && this.props.autoFocus) {
      this.setFocus();
    }

    this._isMounted = true;
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.isOpen && !this.props.isOpen) {
      this.setState({
        isOpen: nextProps.isOpen
      });
    }
  };

  _proto.componentWillUpdate = function componentWillUpdate(nextProps, nextState) {
    if (nextState.isOpen && !this.state.isOpen) {
      this.init();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (this.props.autoFocus && this.state.isOpen && !prevState.isOpen) {
      this.setFocus();
    }

    if (this._element && prevProps.zIndex !== this.props.zIndex) {
      this._element.style.zIndex = this.props.zIndex;
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.onExit) {
      this.props.onExit();
    }

    if (this.state.isOpen) {
      this.destroy();
    }

    this._isMounted = false;
  };

  _proto.onOpened = function onOpened(node, isAppearing) {
    this.props.onOpened();
    (this.props.modalTransition.onEntered || noop)(node, isAppearing);
  };

  _proto.onClosed = function onClosed(node) {
    // so all methods get called before it is unmounted
    this.props.onClosed();
    (this.props.modalTransition.onExited || noop)(node);
    this.destroy();

    if (this._isMounted) {
      this.setState({
        isOpen: false
      });
    }
  };

  _proto.setFocus = function setFocus() {
    if (this._dialog && this._dialog.parentNode && typeof this._dialog.parentNode.focus === 'function') {
      this._dialog.parentNode.focus();
    }
  };

  _proto.getFocusableChildren = function getFocusableChildren() {
    return this._element.querySelectorAll(__WEBPACK_IMPORTED_MODULE_9__utils__["focusableElements"].join(', '));
  };

  _proto.getFocusedChild = function getFocusedChild() {
    var currentFocus;
    var focusableChildren = this.getFocusableChildren();

    try {
      currentFocus = document.activeElement;
    } catch (err) {
      currentFocus = focusableChildren[0];
    }

    return currentFocus;
  } // not mouseUp because scrollbar fires it, shouldn't close when user scrolls
  ;

  _proto.handleBackdropClick = function handleBackdropClick(e) {
    if (e.target === this._mouseDownElement) {
      e.stopPropagation();
      if (!this.props.isOpen || this.props.backdrop !== true) return;
      var backdrop = this._dialog ? this._dialog.parentNode : null;

      if (backdrop && e.target === backdrop && this.props.toggle) {
        this.props.toggle(e);
      }
    }
  };

  _proto.handleTab = function handleTab(e) {
    if (e.which !== 9) return;
    var focusableChildren = this.getFocusableChildren();
    var totalFocusable = focusableChildren.length;
    var currentFocus = this.getFocusedChild();
    var focusedIndex = 0;

    for (var i = 0; i < totalFocusable; i += 1) {
      if (focusableChildren[i] === currentFocus) {
        focusedIndex = i;
        break;
      }
    }

    if (e.shiftKey && focusedIndex === 0) {
      e.preventDefault();
      focusableChildren[totalFocusable - 1].focus();
    } else if (!e.shiftKey && focusedIndex === totalFocusable - 1) {
      e.preventDefault();
      focusableChildren[0].focus();
    }
  };

  _proto.handleBackdropMouseDown = function handleBackdropMouseDown(e) {
    this._mouseDownElement = e.target;
  };

  _proto.handleEscape = function handleEscape(e) {
    if (this.props.isOpen && this.props.keyboard && e.keyCode === 27 && this.props.toggle) {
      e.preventDefault();
      e.stopPropagation();
      this.props.toggle(e);
    }
  };

  _proto.init = function init() {
    try {
      this._triggeringElement = document.activeElement;
    } catch (err) {
      this._triggeringElement = null;
    }

    this._element = document.createElement('div');

    this._element.setAttribute('tabindex', '-1');

    this._element.style.position = 'relative';
    this._element.style.zIndex = this.props.zIndex;
    this._originalBodyPadding = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["getOriginalBodyPadding"])();
    Object(__WEBPACK_IMPORTED_MODULE_9__utils__["conditionallyUpdateScrollbar"])();
    document.body.appendChild(this._element);

    if (Modal.openCount === 0) {
      document.body.className = __WEBPACK_IMPORTED_MODULE_6_classnames___default()(document.body.className, Object(__WEBPACK_IMPORTED_MODULE_9__utils__["mapToCssModules"])('modal-open', this.props.cssModule));
    }

    Modal.openCount += 1;
  };

  _proto.destroy = function destroy() {
    if (this._element) {
      document.body.removeChild(this._element);
      this._element = null;
    }

    if (this._triggeringElement) {
      if (this._triggeringElement.focus) this._triggeringElement.focus();
      this._triggeringElement = null;
    }

    if (Modal.openCount <= 1) {
      var modalOpenClassName = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["mapToCssModules"])('modal-open', this.props.cssModule); // Use regex to prevent matching `modal-open` as part of a different class, e.g. `my-modal-opened`

      var modalOpenClassNameRegex = new RegExp("(^| )" + modalOpenClassName + "( |$)");
      document.body.className = document.body.className.replace(modalOpenClassNameRegex, ' ').trim();
    }

    Modal.openCount -= 1;
    Object(__WEBPACK_IMPORTED_MODULE_9__utils__["setScrollbarWidth"])(this._originalBodyPadding);
  };

  _proto.renderModalDialog = function renderModalDialog() {
    var _classNames,
        _this2 = this;

    var attributes = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["omit"])(this.props, propsToOmit);
    var dialogBaseClass = 'modal-dialog';
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
      className: Object(__WEBPACK_IMPORTED_MODULE_9__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_6_classnames___default()(dialogBaseClass, this.props.className, (_classNames = {}, _classNames["modal-" + this.props.size] = this.props.size, _classNames[dialogBaseClass + "-centered"] = this.props.centered, _classNames)), this.props.cssModule),
      role: "document",
      ref: function ref(c) {
        _this2._dialog = c;
      }
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: Object(__WEBPACK_IMPORTED_MODULE_9__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_6_classnames___default()('modal-content', this.props.contentClassName), this.props.cssModule)
    }, this.props.children));
  };

  _proto.render = function render() {
    if (this.state.isOpen) {
      var _this$props = this.props,
          wrapClassName = _this$props.wrapClassName,
          modalClassName = _this$props.modalClassName,
          backdropClassName = _this$props.backdropClassName,
          cssModule = _this$props.cssModule,
          isOpen = _this$props.isOpen,
          backdrop = _this$props.backdrop,
          role = _this$props.role,
          labelledBy = _this$props.labelledBy,
          external = _this$props.external,
          innerRef = _this$props.innerRef;
      var modalAttributes = {
        onClick: this.handleBackdropClick,
        onMouseDown: this.handleBackdropMouseDown,
        onKeyUp: this.handleEscape,
        onKeyDown: this.handleTab,
        style: {
          display: 'block'
        },
        'aria-labelledby': labelledBy,
        role: role,
        tabIndex: '-1'
      };
      var hasTransition = this.props.fade;

      var modalTransition = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_8__Fade__["a" /* default */].defaultProps, this.props.modalTransition, {
        baseClass: hasTransition ? this.props.modalTransition.baseClass : '',
        timeout: hasTransition ? this.props.modalTransition.timeout : 0
      });

      var backdropTransition = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_8__Fade__["a" /* default */].defaultProps, this.props.backdropTransition, {
        baseClass: hasTransition ? this.props.backdropTransition.baseClass : '',
        timeout: hasTransition ? this.props.backdropTransition.timeout : 0
      });

      var Backdrop = backdrop && (hasTransition ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Fade__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, backdropTransition, {
        in: isOpen && !!backdrop,
        cssModule: cssModule,
        className: Object(__WEBPACK_IMPORTED_MODULE_9__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_6_classnames___default()('modal-backdrop', backdropClassName), cssModule)
      })) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
        className: Object(__WEBPACK_IMPORTED_MODULE_9__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_6_classnames___default()('modal-backdrop', 'show', backdropClassName), cssModule)
      }));
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Portal__["a" /* default */], {
        node: this._element
      }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
        className: Object(__WEBPACK_IMPORTED_MODULE_9__utils__["mapToCssModules"])(wrapClassName)
      }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Fade__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, modalAttributes, modalTransition, {
        in: isOpen,
        onEntered: this.onOpened,
        onExited: this.onClosed,
        cssModule: cssModule,
        className: Object(__WEBPACK_IMPORTED_MODULE_9__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_6_classnames___default()('modal', modalClassName), cssModule),
        innerRef: innerRef
      }), external, this.renderModalDialog()), Backdrop));
    }

    return null;
  };

  return Modal;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;
Modal.openCount = 0;
/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),
/* 1388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(9);





var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any
};

var Portal =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Portal, _React$Component);

  function Portal() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Portal.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.defaultNode) {
      document.body.removeChild(this.defaultNode);
    }

    this.defaultNode = null;
  };

  _proto.render = function render() {
    if (!__WEBPACK_IMPORTED_MODULE_4__utils__["canUseDOM"]) {
      return null;
    }

    if (!this.props.node && !this.defaultNode) {
      this.defaultNode = document.createElement('div');
      document.body.appendChild(this.defaultNode);
    }

    return __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.createPortal(this.props.children, this.props.node || this.defaultNode);
  };

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

Portal.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (Portal);

/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  wrapTag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  toggle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  closeAriaLabel: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  charCode: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]),
  close: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'h5',
  wrapTag: 'div',
  closeAriaLabel: 'Close',
  charCode: 215
};

var ModalHeader = function ModalHeader(props) {
  var closeButton;

  var className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      toggle = props.toggle,
      Tag = props.tag,
      WrapTag = props.wrapTag,
      closeAriaLabel = props.closeAriaLabel,
      charCode = props.charCode,
      close = props.close,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "children", "toggle", "tag", "wrapTag", "closeAriaLabel", "charCode", "close"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'modal-header'), cssModule);

  if (!close && toggle) {
    var closeIcon = typeof charCode === 'number' ? String.fromCharCode(charCode) : charCode;
    closeButton = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("button", {
      type: "button",
      onClick: toggle,
      className: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])('close', cssModule),
      "aria-label": closeAriaLabel
    }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
      "aria-hidden": "true"
    }, closeIcon));
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(WrapTag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, {
    className: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])('modal-title', cssModule)
  }, children), close || closeButton);
};

ModalHeader.propTypes = propTypes;
ModalHeader.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (ModalHeader);

/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div'
};

var ModalBody = function ModalBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'modal-body'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

ModalBody.propTypes = propTypes;
ModalBody.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (ModalBody);

/***/ }),
/* 1391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div'
};

var ModalFooter = function ModalFooter(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'modal-footer'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

ModalFooter.propTypes = propTypes;
ModalFooter.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (ModalFooter);

/***/ }),
/* 1392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  size: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  bordered: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  borderless: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  striped: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  inverse: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["deprecated"])(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool, 'Please use the prop "dark"'),
  dark: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  hover: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  responsive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  responsiveTag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  innerRef: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
var defaultProps = {
  tag: 'table',
  responsiveTag: 'div'
};

var Table = function Table(props) {
  var className = props.className,
      cssModule = props.cssModule,
      size = props.size,
      bordered = props.bordered,
      borderless = props.borderless,
      striped = props.striped,
      inverse = props.inverse,
      dark = props.dark,
      hover = props.hover,
      responsive = props.responsive,
      Tag = props.tag,
      ResponsiveTag = props.responsiveTag,
      innerRef = props.innerRef,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "size", "bordered", "borderless", "striped", "inverse", "dark", "hover", "responsive", "tag", "responsiveTag", "innerRef"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'table', size ? 'table-' + size : false, bordered ? 'table-bordered' : false, borderless ? 'table-borderless' : false, striped ? 'table-striped' : false, dark || inverse ? 'table-dark' : false, hover ? 'table-hover' : false), cssModule);
  var table = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    ref: innerRef,
    className: classes
  }));

  if (responsive) {
    var responsiveClassName = responsive === true ? 'table-responsive' : "table-responsive-" + responsive;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ResponsiveTag, {
      className: responsiveClassName
    }, table);
  }

  return table;
};

Table.propTypes = propTypes;
Table.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Table);

/***/ }),
/* 1393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  flush: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'ul'
};

var ListGroup = function ListGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      flush = props.flush,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag", "flush"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'list-group', flush ? 'list-group-flush' : false), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

ListGroup.propTypes = propTypes;
ListGroup.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (ListGroup);

/***/ }),
/* 1394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(9);








var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  inline: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_7__utils__["tagPropType"],
  innerRef: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object
};
var defaultProps = {
  tag: 'form'
};

var Form =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Form, _Component);

  function Form(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.getRef = _this.getRef.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.submit = _this.submit.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = Form.prototype;

  _proto.getRef = function getRef(ref) {
    if (this.props.innerRef) {
      this.props.innerRef(ref);
    }

    this.ref = ref;
  };

  _proto.submit = function submit() {
    if (this.ref) {
      this.ref.submit();
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        cssModule = _this$props.cssModule,
        inline = _this$props.inline,
        Tag = _this$props.tag,
        innerRef = _this$props.innerRef,
        attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className", "cssModule", "inline", "tag", "innerRef"]);

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, inline ? 'form-inline' : false), cssModule);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
      ref: innerRef,
      className: classes
    }));
  };

  return Form;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Form.propTypes = propTypes;
Form.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Form);

/***/ }),
/* 1395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  valid: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  tooltip: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};
var defaultProps = {
  tag: 'div',
  valid: undefined
};

var FormFeedback = function FormFeedback(props) {
  var className = props.className,
      cssModule = props.cssModule,
      valid = props.valid,
      tooltip = props.tooltip,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "valid", "tooltip", "tag"]);

  var validMode = tooltip ? 'tooltip' : 'feedback';
  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, valid ? "valid-" + validMode : "invalid-" + validMode), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

FormFeedback.propTypes = propTypes;
FormFeedback.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (FormFeedback);

/***/ }),
/* 1396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  row: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  check: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  inline: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div'
};

var FormGroup = function FormGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      row = props.row,
      disabled = props.disabled,
      check = props.check,
      inline = props.inline,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "row", "disabled", "check", "inline", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, row ? 'row' : false, check ? 'form-check' : 'form-group', check && inline ? 'form-check-inline' : false, check && disabled ? 'disabled' : false), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

FormGroup.propTypes = propTypes;
FormGroup.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (FormGroup);

/***/ }),
/* 1397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  inline: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  color: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'small',
  color: 'muted'
};

var FormText = function FormText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      inline = props.inline,
      color = props.color,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "inline", "color", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, !inline ? 'form-text' : false, color ? "text-" + color : false), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

FormText.propTypes = propTypes;
FormText.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (FormText);

/***/ }),
/* 1398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(9);





/* eslint react/prefer-stateless-function: 0 */




var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  type: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  bsSize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  state: Object(__WEBPACK_IMPORTED_MODULE_7__utils__["deprecated"])(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, 'Please use the props "valid" and "invalid" to indicate the state.'),
  valid: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  invalid: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_7__utils__["tagPropType"],
  innerRef: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),
  static: Object(__WEBPACK_IMPORTED_MODULE_7__utils__["deprecated"])(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool, 'Please use the prop "plaintext"'),
  plaintext: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  addon: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object
};
var defaultProps = {
  type: 'text'
};

var Input =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Input, _React$Component);

  function Input(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.getRef = _this.getRef.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.focus = _this.focus.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = Input.prototype;

  _proto.getRef = function getRef(ref) {
    if (this.props.innerRef) {
      this.props.innerRef(ref);
    }

    this.ref = ref;
  };

  _proto.focus = function focus() {
    if (this.ref) {
      this.ref.focus();
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        cssModule = _this$props.cssModule,
        type = _this$props.type,
        bsSize = _this$props.bsSize,
        state = _this$props.state,
        valid = _this$props.valid,
        invalid = _this$props.invalid,
        tag = _this$props.tag,
        addon = _this$props.addon,
        staticInput = _this$props.static,
        plaintext = _this$props.plaintext,
        innerRef = _this$props.innerRef,
        attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className", "cssModule", "type", "bsSize", "state", "valid", "invalid", "tag", "addon", "static", "plaintext", "innerRef"]);

    var checkInput = ['radio', 'checkbox'].indexOf(type) > -1;
    var isNotaNumber = new RegExp('\\D', 'g');
    var fileInput = type === 'file';
    var textareaInput = type === 'textarea';
    var selectInput = type === 'select';
    var Tag = tag || (selectInput || textareaInput ? type : 'input');
    var formControlClass = 'form-control';

    if (plaintext || staticInput) {
      formControlClass = formControlClass + "-plaintext";
      Tag = tag || 'input';
    } else if (fileInput) {
      formControlClass = formControlClass + "-file";
    } else if (checkInput) {
      if (addon) {
        formControlClass = null;
      } else {
        formControlClass = 'form-check-input';
      }
    }

    if (state && typeof valid === 'undefined' && typeof invalid === 'undefined') {
      if (state === 'danger') {
        invalid = true;
      } else if (state === 'success') {
        valid = true;
      }
    }

    if (attributes.size && isNotaNumber.test(attributes.size)) {
      Object(__WEBPACK_IMPORTED_MODULE_7__utils__["warnOnce"])('Please use the prop "bsSize" instead of the "size" to bootstrap\'s input sizing.');
      bsSize = attributes.size;
      delete attributes.size;
    }

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, invalid && 'is-invalid', valid && 'is-valid', bsSize ? "form-control-" + bsSize : false, formControlClass), cssModule);

    if (Tag === 'input' || tag && typeof tag === 'function') {
      attributes.type = type;
    }

    if (attributes.children && !(plaintext || staticInput || type === 'select' || typeof Tag !== 'string' || Tag === 'select')) {
      Object(__WEBPACK_IMPORTED_MODULE_7__utils__["warnOnce"])("Input with a type of \"" + type + "\" cannot have children. Please use \"value\"/\"defaultValue\" instead.");
      delete attributes.children;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
      ref: innerRef,
      className: classes
    }));
  };

  return Input;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Input.propTypes = propTypes;
Input.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Input);

/***/ }),
/* 1399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  size: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div'
};

var InputGroup = function InputGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      size = props.size,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag", "size"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'input-group', size ? "input-group-" + size : null), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

InputGroup.propTypes = propTypes;
InputGroup.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (InputGroup);

/***/ }),
/* 1400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InputGroupAddon__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(9);








var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_7__utils__["tagPropType"],
  addonType: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['prepend', 'append']).isRequired,
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node,
  groupClassName: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  groupAttributes: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object
};

var InputGroupButton = function InputGroupButton(props) {
  Object(__WEBPACK_IMPORTED_MODULE_7__utils__["warnOnce"])('The "InputGroupButton" component has been deprecated.\nPlease use component "InputGroupAddon".');

  var children = props.children,
      groupClassName = props.groupClassName,
      groupAttributes = props.groupAttributes,
      propsWithoutGroup = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["children", "groupClassName", "groupAttributes"]);

  if (typeof children === 'string') {
    var cssModule = propsWithoutGroup.cssModule,
        tag = propsWithoutGroup.tag,
        addonType = propsWithoutGroup.addonType,
        attributes = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(propsWithoutGroup, ["cssModule", "tag", "addonType"]);

    var allGroupAttributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, groupAttributes, {
      cssModule: cssModule,
      tag: tag,
      addonType: addonType
    });

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__InputGroupAddon__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, allGroupAttributes, {
      className: groupClassName
    }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Button__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
      children: children
    })));
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__InputGroupAddon__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    children: children
  }));
};

InputGroupButton.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (InputGroupButton);

/***/ }),
/* 1401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dropdown__ = __webpack_require__(212);



var propTypes = {
  addonType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prepend', 'append']).isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

var InputGroupButtonDropdown = function InputGroupButtonDropdown(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Dropdown__["a" /* default */], props);
};

InputGroupButtonDropdown.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (InputGroupButtonDropdown);

/***/ }),
/* 1402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isobject__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isobject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isobject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(9);







var colWidths = ['xs', 'sm', 'md', 'lg', 'xl'];
var stringOrNumberProp = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]);
var columnProps = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
  size: stringOrNumberProp,
  push: Object(__WEBPACK_IMPORTED_MODULE_6__utils__["deprecated"])(stringOrNumberProp, 'Please use the prop "order"'),
  pull: Object(__WEBPACK_IMPORTED_MODULE_6__utils__["deprecated"])(stringOrNumberProp, 'Please use the prop "order"'),
  order: stringOrNumberProp,
  offset: stringOrNumberProp
})]);
var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  hidden: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  check: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  size: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  for: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_6__utils__["tagPropType"],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  xs: columnProps,
  sm: columnProps,
  md: columnProps,
  lg: columnProps,
  xl: columnProps,
  widths: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array
};
var defaultProps = {
  tag: 'label',
  widths: colWidths
};

var getColumnSizeClass = function getColumnSizeClass(isXs, colWidth, colSize) {
  if (colSize === true || colSize === '') {
    return isXs ? 'col' : "col-" + colWidth;
  } else if (colSize === 'auto') {
    return isXs ? 'col-auto' : "col-" + colWidth + "-auto";
  }

  return isXs ? "col-" + colSize : "col-" + colWidth + "-" + colSize;
};

var Label = function Label(props) {
  var className = props.className,
      cssModule = props.cssModule,
      hidden = props.hidden,
      widths = props.widths,
      Tag = props.tag,
      check = props.check,
      size = props.size,
      htmlFor = props.for,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "hidden", "widths", "tag", "check", "size", "for"]);

  var colClasses = [];
  widths.forEach(function (colWidth, i) {
    var columnProp = props[colWidth];
    delete attributes[colWidth];

    if (!columnProp && columnProp !== '') {
      return;
    }

    var isXs = !i;
    var colClass;

    if (__WEBPACK_IMPORTED_MODULE_5_lodash_isobject___default()(columnProp)) {
      var _classNames;

      var colSizeInterfix = isXs ? '-' : "-" + colWidth + "-";
      colClass = getColumnSizeClass(isXs, colWidth, columnProp.size);
      colClasses.push(Object(__WEBPACK_IMPORTED_MODULE_6__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()((_classNames = {}, _classNames[colClass] = columnProp.size || columnProp.size === '', _classNames["order" + colSizeInterfix + columnProp.order] = columnProp.order || columnProp.order === 0, _classNames["offset" + colSizeInterfix + columnProp.offset] = columnProp.offset || columnProp.offset === 0, _classNames))), cssModule);
    } else {
      colClass = getColumnSizeClass(isXs, colWidth, columnProp);
      colClasses.push(colClass);
    }
  });
  var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, hidden ? 'sr-only' : false, check ? 'form-check-label' : false, size ? "col-form-label-" + size : false, colClasses, colClasses.length ? 'col-form-label' : false), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    htmlFor: htmlFor
  }, attributes, {
    className: classes
  }));
};

Label.propTypes = propTypes;
Label.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Label);

/***/ }),
/* 1403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  body: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  bottom: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  heading: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  left: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  list: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  middle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  object: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  right: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  top: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};

var Media = function Media(props) {
  var body = props.body,
      bottom = props.bottom,
      className = props.className,
      cssModule = props.cssModule,
      heading = props.heading,
      left = props.left,
      list = props.list,
      middle = props.middle,
      object = props.object,
      right = props.right,
      tag = props.tag,
      top = props.top,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["body", "bottom", "className", "cssModule", "heading", "left", "list", "middle", "object", "right", "tag", "top"]);

  var defaultTag;

  if (heading) {
    defaultTag = 'h4';
  } else if (attributes.href) {
    defaultTag = 'a';
  } else if (attributes.src || object) {
    defaultTag = 'img';
  } else if (list) {
    defaultTag = 'ul';
  } else {
    defaultTag = 'div';
  }

  var Tag = tag || defaultTag;
  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, {
    'media-body': body,
    'media-heading': heading,
    'media-left': left,
    'media-right': right,
    'media-top': top,
    'media-bottom': bottom,
    'media-middle': middle,
    'media-object': object,
    'media-list': list,
    media: !body && !heading && !left && !right && !top && !bottom && !middle && !object && !list
  }), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

Media.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (Media);

/***/ }),
/* 1404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  listClassName: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  size: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  listTag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  'aria-label': __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};
var defaultProps = {
  tag: 'nav',
  listTag: 'ul',
  'aria-label': 'pagination'
};

var Pagination = function Pagination(props) {
  var _classNames;

  var className = props.className,
      listClassName = props.listClassName,
      cssModule = props.cssModule,
      size = props.size,
      Tag = props.tag,
      ListTag = props.listTag,
      label = props['aria-label'],
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "listClassName", "cssModule", "size", "tag", "listTag", "aria-label"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className), cssModule);
  var listClasses = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(listClassName, 'pagination', (_classNames = {}, _classNames["pagination-" + size] = !!size, _classNames)), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, {
    className: classes,
    "aria-label": label
  }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ListTag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: listClasses
  })));
};

Pagination.propTypes = propTypes;
Pagination.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Pagination);

/***/ }),
/* 1405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  disabled: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"]
};
var defaultProps = {
  tag: 'li'
};

var PaginationItem = function PaginationItem(props) {
  var active = props.active,
      className = props.className,
      cssModule = props.cssModule,
      disabled = props.disabled,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["active", "className", "cssModule", "disabled", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'page-item', {
    active: active,
    disabled: disabled
  }), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

PaginationItem.propTypes = propTypes;
PaginationItem.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (PaginationItem);

/***/ }),
/* 1406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  'aria-label': __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  next: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  previous: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"]
};
var defaultProps = {
  tag: 'a'
};

var PaginationLink = function PaginationLink(props) {
  var className = props.className,
      cssModule = props.cssModule,
      next = props.next,
      previous = props.previous,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "next", "previous", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'page-link'), cssModule);
  var defaultAriaLabel;

  if (previous) {
    defaultAriaLabel = 'Previous';
  } else if (next) {
    defaultAriaLabel = 'Next';
  }

  var ariaLabel = props['aria-label'] || defaultAriaLabel;
  var defaultCaret;

  if (previous) {
    defaultCaret = "\xAB";
  } else if (next) {
    defaultCaret = "\xBB";
  }

  var children = props.children;

  if (children && Array.isArray(children) && children.length === 0) {
    children = null;
  }

  if (!attributes.href && Tag === 'a') {
    Tag = 'button';
  }

  if (previous || next) {
    children = [__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
      "aria-hidden": "true",
      key: "caret"
    }, children || defaultCaret), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
      className: "sr-only",
      key: "sr"
    }, ariaLabel)];
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes,
    "aria-label": ariaLabel
  }), children);
};

PaginationLink.propTypes = propTypes;
PaginationLink.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (PaginationLink);

/***/ }),
/* 1407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_lifecycles_compat__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(9);







var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_6__utils__["tagPropType"],
  activeTab: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div'
};
var childContextTypes = {
  activeTabId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};

var TabContent =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(TabContent, _Component);

  TabContent.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.activeTab !== nextProps.activeTab) {
      return {
        activeTab: nextProps.activeTab
      };
    }

    return null;
  };

  function TabContent(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      activeTab: _this.props.activeTab
    };
    return _this;
  }

  var _proto = TabContent.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      activeTabId: this.state.activeTab
    };
  };

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        cssModule = _this$props.cssModule,
        Tag = _this$props.tag;
    var attributes = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["omit"])(this.props, Object.keys(propTypes));
    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_5_classnames___default()('tab-content', className), cssModule);
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
      className: classes
    }));
  };

  return TabContent;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

Object(__WEBPACK_IMPORTED_MODULE_3_react_lifecycles_compat__["polyfill"])(TabContent);
/* harmony default export */ __webpack_exports__["a"] = (TabContent);
TabContent.propTypes = propTypes;
TabContent.defaultProps = defaultProps;
TabContent.childContextTypes = childContextTypes;

/***/ }),
/* 1408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = TabPane;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  tabId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any
};
var defaultProps = {
  tag: 'div'
};
var contextTypes = {
  activeTabId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any
};
function TabPane(props, context) {
  var className = props.className,
      cssModule = props.cssModule,
      tabId = props.tabId,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tabId", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()('tab-pane', className, {
    active: tabId === context.activeTabId
  }), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
}
TabPane.propTypes = propTypes;
TabPane.defaultProps = defaultProps;
TabPane.contextTypes = contextTypes;

/***/ }),
/* 1409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  fluid: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div'
};

var Jumbotron = function Jumbotron(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      fluid = props.fluid,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag", "fluid"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'jumbotron', fluid ? 'jumbotron-fluid' : false), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

Jumbotron.propTypes = propTypes;
Jumbotron.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Jumbotron);

/***/ }),
/* 1410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  active: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  action: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'li'
};

var handleDisabledOnClick = function handleDisabledOnClick(e) {
  e.preventDefault();
};

var ListGroupItem = function ListGroupItem(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      active = props.active,
      disabled = props.disabled,
      action = props.action,
      color = props.color,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag", "active", "disabled", "action", "color"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, active ? 'active' : false, disabled ? 'disabled' : false, action ? 'list-group-item-action' : false, color ? "list-group-item-" + color : false, 'list-group-item'), cssModule); // Prevent click event when disabled.

  if (disabled) {
    attributes.onClick = handleDisabledOnClick;
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

ListGroupItem.propTypes = propTypes;
ListGroupItem.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (ListGroupItem);

/***/ }),
/* 1411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'h5'
};

var ListGroupItemHeading = function ListGroupItemHeading(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'list-group-item-heading'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

ListGroupItemHeading.propTypes = propTypes;
ListGroupItemHeading.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (ListGroupItemHeading);

/***/ }),
/* 1412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'p'
};

var ListGroupItemText = function ListGroupItemText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'list-group-item-text'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

ListGroupItemText.propTypes = propTypes;
ListGroupItemText.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (ListGroupItemText);

/***/ }),
/* 1413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Alert__ = __webpack_require__(681);






var UncontrolledAlert =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(UncontrolledAlert, _Component);

  function UncontrolledAlert(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      isOpen: true
    };
    _this.toggle = _this.toggle.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = UncontrolledAlert.prototype;

  _proto.toggle = function toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Alert__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      isOpen: this.state.isOpen,
      toggle: this.toggle
    }, this.props));
  };

  return UncontrolledAlert;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (UncontrolledAlert);

/***/ }),
/* 1414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UncontrolledButtonDropdown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ButtonDropdown__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(9);








var omitKeys = ['defaultOpen'];

var UncontrolledButtonDropdown =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(UncontrolledButtonDropdown, _Component);

  function UncontrolledButtonDropdown(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      isOpen: props.defaultOpen || false
    };
    _this.toggle = _this.toggle.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = UncontrolledButtonDropdown.prototype;

  _proto.toggle = function toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ButtonDropdown__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      isOpen: this.state.isOpen,
      toggle: this.toggle
    }, Object(__WEBPACK_IMPORTED_MODULE_7__utils__["omit"])(this.props, omitKeys)));
  };

  return UncontrolledButtonDropdown;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);


UncontrolledButtonDropdown.propTypes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({
  defaultOpen: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
}, __WEBPACK_IMPORTED_MODULE_6__ButtonDropdown__["a" /* default */].propTypes);

/***/ }),
/* 1415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Collapse__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(9);







var omitKeys = ['toggleEvents', 'defaultOpen'];
var propTypes = {
  defaultOpen: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  toggler: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  toggleEvents: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string)
};
var defaultProps = {
  toggleEvents: __WEBPACK_IMPORTED_MODULE_6__utils__["defaultToggleEvents"]
};

var UncontrolledCollapse =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(UncontrolledCollapse, _Component);

  function UncontrolledCollapse(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.togglers = null;
    _this.removeEventListeners = null;
    _this.toggle = _this.toggle.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.state = {
      isOpen: props.defaultOpen || false
    };
    return _this;
  }

  var _proto = UncontrolledCollapse.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.togglers = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["findDOMElements"])(this.props.toggler);

    if (this.togglers.length) {
      this.removeEventListeners = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["addMultipleEventListeners"])(this.togglers, this.toggle, this.props.toggleEvents);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.togglers.length && this.removeEventListeners) {
      this.removeEventListeners();
    }
  };

  _proto.toggle = function toggle(e) {
    this.setState(function (_ref) {
      var isOpen = _ref.isOpen;
      return {
        isOpen: !isOpen
      };
    });
    e.preventDefault();
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Collapse__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      isOpen: this.state.isOpen
    }, Object(__WEBPACK_IMPORTED_MODULE_6__utils__["omit"])(this.props, omitKeys)));
  };

  return UncontrolledCollapse;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

UncontrolledCollapse.propTypes = propTypes;
UncontrolledCollapse.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (UncontrolledCollapse);

/***/ }),
/* 1416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UncontrolledDropdown__ = __webpack_require__(683);





var UncontrolledNavDropdown = function UncontrolledNavDropdown(props) {
  Object(__WEBPACK_IMPORTED_MODULE_2__utils__["warnOnce"])('The "UncontrolledNavDropdown" component has been deprecated.\nPlease use component "UncontrolledDropdown" with nav prop.');
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__UncontrolledDropdown__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    nav: true
  }, props));
};

/* harmony default export */ __webpack_exports__["a"] = (UncontrolledNavDropdown);

/***/ }),
/* 1417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UncontrolledTooltip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Tooltip__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(9);








var omitKeys = ['defaultOpen'];

var UncontrolledTooltip =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(UncontrolledTooltip, _Component);

  function UncontrolledTooltip(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      isOpen: props.defaultOpen || false
    };
    _this.toggle = _this.toggle.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = UncontrolledTooltip.prototype;

  _proto.toggle = function toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Tooltip__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      isOpen: this.state.isOpen,
      toggle: this.toggle
    }, Object(__WEBPACK_IMPORTED_MODULE_7__utils__["omit"])(this.props, omitKeys)));
  };

  return UncontrolledTooltip;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);


UncontrolledTooltip.propTypes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({
  defaultOpen: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
}, __WEBPACK_IMPORTED_MODULE_6__Tooltip__["a" /* default */].propTypes);

/***/ }),
/* 1418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["tagPropType"],
  type: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  color: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};
var defaultProps = {
  tag: 'div',
  type: 'border',
  children: 'Loading...'
};

var Spinner = function Spinner(props) {
  var className = props.className,
      cssModule = props.cssModule,
      type = props.type,
      size = props.size,
      color = props.color,
      children = props.children,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "type", "size", "color", "children", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, size ? "spinner-" + type + "-" + size : false, "spinner-" + type, color ? "text-" + color : false), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    role: "status"
  }, attributes, {
    className: classes
  }), children && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["mapToCssModules"])('sr-only', cssModule)
  }, children));
};

Spinner.propTypes = propTypes;
Spinner.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Spinner);

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRouterDom = __webpack_require__(13);

var _reactRedux = __webpack_require__(10);

var _NotificationItem = _interopRequireDefault(__webpack_require__(1420));

var _CustomScrollbars = _interopRequireDefault(__webpack_require__(27));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var AppNotification =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AppNotification, _React$Component);

  function AppNotification() {
    _classCallCheck(this, AppNotification);

    return _possibleConstructorReturn(this, _getPrototypeOf(AppNotification).apply(this, arguments));
  }

  _createClass(AppNotification, [{
    key: "render",
    value: function render() {
      var notifications = this.props.notifications;
      return _react["default"].createElement(_CustomScrollbars["default"], {
        className: "messages-list scrollbar",
        style: {
          height: 280
        }
      }, _react["default"].createElement("ul", {
        className: "list-unstyled"
      }, notifications.map(function (notification, index) {
        return _react["default"].createElement(_NotificationItem["default"], {
          key: index,
          notification: notification
        });
      })));
    }
  }]);

  return AppNotification;
}(_react["default"].Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var emps = _ref.emps;
  var notifications = emps.notifications;
  return {
    notifications: notifications
  };
};

var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, null)(AppNotification));

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AppNotification, "AppNotification", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppNotification/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppNotification/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppNotification/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppNotification/index.js");

  __REACT_HOT_LOADER__.register(_NotificationItem, "_NotificationItem", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppNotification/index.js");

  __REACT_HOT_LOADER__.register(_CustomScrollbars, "_CustomScrollbars", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppNotification/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppNotification/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppNotification/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppNotification/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppNotification/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppNotification/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppNotification/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppNotification/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppNotification/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppNotification/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppNotification/index.js");

  __REACT_HOT_LOADER__.register(AppNotification, "AppNotification", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppNotification/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppNotification/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppNotification/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppNotification/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppNotification/index.js");
}();

;

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var NotificationItem = function NotificationItem(_ref) {
  var notification = _ref.notification;
  var icon = notification.icon,
      image = notification.image,
      title = notification.title;
  return _react["default"].createElement("li", {
    className: "media"
  }, _react["default"].createElement("img", {
    alt: image,
    src: image,
    className: "avatar-sm rounded-circle mr-2 rounded-circle"
  }), _react["default"].createElement("span", {
    className: "media-body align-self-center"
  }, _react["default"].createElement("i", {
    className: "zmdi ".concat(icon, " zmdi-hc-fw d-inline-block")
  }), _react["default"].createElement("p", {
    className: "sub-heading mb-0 d-inline-block"
  }, title)));
};

var _default = NotificationItem;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(NotificationItem, "NotificationItem", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppNotification/NotificationItem.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppNotification/NotificationItem.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppNotification/NotificationItem.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppNotification/NotificationItem.js");

  __REACT_HOT_LOADER__.register(NotificationItem, "NotificationItem", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppNotification/NotificationItem.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppNotification/NotificationItem.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppNotification/NotificationItem.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/AppNotification/NotificationItem.js");
}();

;

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Scrollbars = undefined;

var _Scrollbars = __webpack_require__(1422);

var _Scrollbars2 = _interopRequireDefault(_Scrollbars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Scrollbars2["default"];
exports.Scrollbars = _Scrollbars2["default"];

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _raf2 = __webpack_require__(306);

var _raf3 = _interopRequireDefault(_raf2);

var _domCss = __webpack_require__(684);

var _domCss2 = _interopRequireDefault(_domCss);

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isString = __webpack_require__(1429);

var _isString2 = _interopRequireDefault(_isString);

var _getScrollbarWidth = __webpack_require__(1430);

var _getScrollbarWidth2 = _interopRequireDefault(_getScrollbarWidth);

var _returnFalse = __webpack_require__(1431);

var _returnFalse2 = _interopRequireDefault(_returnFalse);

var _getInnerWidth = __webpack_require__(1432);

var _getInnerWidth2 = _interopRequireDefault(_getInnerWidth);

var _getInnerHeight = __webpack_require__(1433);

var _getInnerHeight2 = _interopRequireDefault(_getInnerHeight);

var _styles = __webpack_require__(1434);

var _defaultRenderElements = __webpack_require__(1435);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Scrollbars = function (_Component) {
    _inherits(Scrollbars, _Component);

    function Scrollbars(props) {
        var _ref;

        _classCallCheck(this, Scrollbars);

        for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            rest[_key - 1] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = Scrollbars.__proto__ || Object.getPrototypeOf(Scrollbars)).call.apply(_ref, [this, props].concat(rest)));

        _this.getScrollLeft = _this.getScrollLeft.bind(_this);
        _this.getScrollTop = _this.getScrollTop.bind(_this);
        _this.getScrollWidth = _this.getScrollWidth.bind(_this);
        _this.getScrollHeight = _this.getScrollHeight.bind(_this);
        _this.getClientWidth = _this.getClientWidth.bind(_this);
        _this.getClientHeight = _this.getClientHeight.bind(_this);
        _this.getValues = _this.getValues.bind(_this);
        _this.getThumbHorizontalWidth = _this.getThumbHorizontalWidth.bind(_this);
        _this.getThumbVerticalHeight = _this.getThumbVerticalHeight.bind(_this);
        _this.getScrollLeftForOffset = _this.getScrollLeftForOffset.bind(_this);
        _this.getScrollTopForOffset = _this.getScrollTopForOffset.bind(_this);

        _this.scrollLeft = _this.scrollLeft.bind(_this);
        _this.scrollTop = _this.scrollTop.bind(_this);
        _this.scrollToLeft = _this.scrollToLeft.bind(_this);
        _this.scrollToTop = _this.scrollToTop.bind(_this);
        _this.scrollToRight = _this.scrollToRight.bind(_this);
        _this.scrollToBottom = _this.scrollToBottom.bind(_this);

        _this.handleTrackMouseEnter = _this.handleTrackMouseEnter.bind(_this);
        _this.handleTrackMouseLeave = _this.handleTrackMouseLeave.bind(_this);
        _this.handleHorizontalTrackMouseDown = _this.handleHorizontalTrackMouseDown.bind(_this);
        _this.handleVerticalTrackMouseDown = _this.handleVerticalTrackMouseDown.bind(_this);
        _this.handleHorizontalThumbMouseDown = _this.handleHorizontalThumbMouseDown.bind(_this);
        _this.handleVerticalThumbMouseDown = _this.handleVerticalThumbMouseDown.bind(_this);
        _this.handleWindowResize = _this.handleWindowResize.bind(_this);
        _this.handleScroll = _this.handleScroll.bind(_this);
        _this.handleDrag = _this.handleDrag.bind(_this);
        _this.handleDragEnd = _this.handleDragEnd.bind(_this);

        _this.state = {
            didMountUniversal: false
        };
        return _this;
    }

    _createClass(Scrollbars, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.addListeners();
            this.update();
            this.componentDidMountUniversal();
        }
    }, {
        key: 'componentDidMountUniversal',
        value: function componentDidMountUniversal() {
            // eslint-disable-line react/sort-comp
            var universal = this.props.universal;

            if (!universal) return;
            this.setState({ didMountUniversal: true });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.update();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.removeListeners();
            (0, _raf2.cancel)(this.requestFrame);
            clearTimeout(this.hideTracksTimeout);
            clearInterval(this.detectScrollingInterval);
        }
    }, {
        key: 'getScrollLeft',
        value: function getScrollLeft() {
            if (!this.view) return 0;
            return this.view.scrollLeft;
        }
    }, {
        key: 'getScrollTop',
        value: function getScrollTop() {
            if (!this.view) return 0;
            return this.view.scrollTop;
        }
    }, {
        key: 'getScrollWidth',
        value: function getScrollWidth() {
            if (!this.view) return 0;
            return this.view.scrollWidth;
        }
    }, {
        key: 'getScrollHeight',
        value: function getScrollHeight() {
            if (!this.view) return 0;
            return this.view.scrollHeight;
        }
    }, {
        key: 'getClientWidth',
        value: function getClientWidth() {
            if (!this.view) return 0;
            return this.view.clientWidth;
        }
    }, {
        key: 'getClientHeight',
        value: function getClientHeight() {
            if (!this.view) return 0;
            return this.view.clientHeight;
        }
    }, {
        key: 'getValues',
        value: function getValues() {
            var _ref2 = this.view || {},
                _ref2$scrollLeft = _ref2.scrollLeft,
                scrollLeft = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft,
                _ref2$scrollTop = _ref2.scrollTop,
                scrollTop = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop,
                _ref2$scrollWidth = _ref2.scrollWidth,
                scrollWidth = _ref2$scrollWidth === undefined ? 0 : _ref2$scrollWidth,
                _ref2$scrollHeight = _ref2.scrollHeight,
                scrollHeight = _ref2$scrollHeight === undefined ? 0 : _ref2$scrollHeight,
                _ref2$clientWidth = _ref2.clientWidth,
                clientWidth = _ref2$clientWidth === undefined ? 0 : _ref2$clientWidth,
                _ref2$clientHeight = _ref2.clientHeight,
                clientHeight = _ref2$clientHeight === undefined ? 0 : _ref2$clientHeight;

            return {
                left: scrollLeft / (scrollWidth - clientWidth) || 0,
                top: scrollTop / (scrollHeight - clientHeight) || 0,
                scrollLeft: scrollLeft,
                scrollTop: scrollTop,
                scrollWidth: scrollWidth,
                scrollHeight: scrollHeight,
                clientWidth: clientWidth,
                clientHeight: clientHeight
            };
        }
    }, {
        key: 'getThumbHorizontalWidth',
        value: function getThumbHorizontalWidth() {
            var _props = this.props,
                thumbSize = _props.thumbSize,
                thumbMinSize = _props.thumbMinSize;
            var _view = this.view,
                scrollWidth = _view.scrollWidth,
                clientWidth = _view.clientWidth;

            var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
            var width = Math.ceil(clientWidth / scrollWidth * trackWidth);
            if (trackWidth === width) return 0;
            if (thumbSize) return thumbSize;
            return Math.max(width, thumbMinSize);
        }
    }, {
        key: 'getThumbVerticalHeight',
        value: function getThumbVerticalHeight() {
            var _props2 = this.props,
                thumbSize = _props2.thumbSize,
                thumbMinSize = _props2.thumbMinSize;
            var _view2 = this.view,
                scrollHeight = _view2.scrollHeight,
                clientHeight = _view2.clientHeight;

            var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
            var height = Math.ceil(clientHeight / scrollHeight * trackHeight);
            if (trackHeight === height) return 0;
            if (thumbSize) return thumbSize;
            return Math.max(height, thumbMinSize);
        }
    }, {
        key: 'getScrollLeftForOffset',
        value: function getScrollLeftForOffset(offset) {
            var _view3 = this.view,
                scrollWidth = _view3.scrollWidth,
                clientWidth = _view3.clientWidth;

            var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
            var thumbWidth = this.getThumbHorizontalWidth();
            return offset / (trackWidth - thumbWidth) * (scrollWidth - clientWidth);
        }
    }, {
        key: 'getScrollTopForOffset',
        value: function getScrollTopForOffset(offset) {
            var _view4 = this.view,
                scrollHeight = _view4.scrollHeight,
                clientHeight = _view4.clientHeight;

            var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
            var thumbHeight = this.getThumbVerticalHeight();
            return offset / (trackHeight - thumbHeight) * (scrollHeight - clientHeight);
        }
    }, {
        key: 'scrollLeft',
        value: function scrollLeft() {
            var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            if (!this.view) return;
            this.view.scrollLeft = left;
        }
    }, {
        key: 'scrollTop',
        value: function scrollTop() {
            var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            if (!this.view) return;
            this.view.scrollTop = top;
        }
    }, {
        key: 'scrollToLeft',
        value: function scrollToLeft() {
            if (!this.view) return;
            this.view.scrollLeft = 0;
        }
    }, {
        key: 'scrollToTop',
        value: function scrollToTop() {
            if (!this.view) return;
            this.view.scrollTop = 0;
        }
    }, {
        key: 'scrollToRight',
        value: function scrollToRight() {
            if (!this.view) return;
            this.view.scrollLeft = this.view.scrollWidth;
        }
    }, {
        key: 'scrollToBottom',
        value: function scrollToBottom() {
            if (!this.view) return;
            this.view.scrollTop = this.view.scrollHeight;
        }
    }, {
        key: 'addListeners',
        value: function addListeners() {
            /* istanbul ignore if */
            if (typeof document === 'undefined' || !this.view) return;
            var view = this.view,
                trackHorizontal = this.trackHorizontal,
                trackVertical = this.trackVertical,
                thumbHorizontal = this.thumbHorizontal,
                thumbVertical = this.thumbVertical;

            view.addEventListener('scroll', this.handleScroll);
            if (!(0, _getScrollbarWidth2["default"])()) return;
            trackHorizontal.addEventListener('mouseenter', this.handleTrackMouseEnter);
            trackHorizontal.addEventListener('mouseleave', this.handleTrackMouseLeave);
            trackHorizontal.addEventListener('mousedown', this.handleHorizontalTrackMouseDown);
            trackVertical.addEventListener('mouseenter', this.handleTrackMouseEnter);
            trackVertical.addEventListener('mouseleave', this.handleTrackMouseLeave);
            trackVertical.addEventListener('mousedown', this.handleVerticalTrackMouseDown);
            thumbHorizontal.addEventListener('mousedown', this.handleHorizontalThumbMouseDown);
            thumbVertical.addEventListener('mousedown', this.handleVerticalThumbMouseDown);
            window.addEventListener('resize', this.handleWindowResize);
        }
    }, {
        key: 'removeListeners',
        value: function removeListeners() {
            /* istanbul ignore if */
            if (typeof document === 'undefined' || !this.view) return;
            var view = this.view,
                trackHorizontal = this.trackHorizontal,
                trackVertical = this.trackVertical,
                thumbHorizontal = this.thumbHorizontal,
                thumbVertical = this.thumbVertical;

            view.removeEventListener('scroll', this.handleScroll);
            if (!(0, _getScrollbarWidth2["default"])()) return;
            trackHorizontal.removeEventListener('mouseenter', this.handleTrackMouseEnter);
            trackHorizontal.removeEventListener('mouseleave', this.handleTrackMouseLeave);
            trackHorizontal.removeEventListener('mousedown', this.handleHorizontalTrackMouseDown);
            trackVertical.removeEventListener('mouseenter', this.handleTrackMouseEnter);
            trackVertical.removeEventListener('mouseleave', this.handleTrackMouseLeave);
            trackVertical.removeEventListener('mousedown', this.handleVerticalTrackMouseDown);
            thumbHorizontal.removeEventListener('mousedown', this.handleHorizontalThumbMouseDown);
            thumbVertical.removeEventListener('mousedown', this.handleVerticalThumbMouseDown);
            window.removeEventListener('resize', this.handleWindowResize);
            // Possibly setup by `handleDragStart`
            this.teardownDragging();
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll(event) {
            var _this2 = this;

            var _props3 = this.props,
                onScroll = _props3.onScroll,
                onScrollFrame = _props3.onScrollFrame;

            if (onScroll) onScroll(event);
            this.update(function (values) {
                var scrollLeft = values.scrollLeft,
                    scrollTop = values.scrollTop;

                _this2.viewScrollLeft = scrollLeft;
                _this2.viewScrollTop = scrollTop;
                if (onScrollFrame) onScrollFrame(values);
            });
            this.detectScrolling();
        }
    }, {
        key: 'handleScrollStart',
        value: function handleScrollStart() {
            var onScrollStart = this.props.onScrollStart;

            if (onScrollStart) onScrollStart();
            this.handleScrollStartAutoHide();
        }
    }, {
        key: 'handleScrollStartAutoHide',
        value: function handleScrollStartAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.showTracks();
        }
    }, {
        key: 'handleScrollStop',
        value: function handleScrollStop() {
            var onScrollStop = this.props.onScrollStop;

            if (onScrollStop) onScrollStop();
            this.handleScrollStopAutoHide();
        }
    }, {
        key: 'handleScrollStopAutoHide',
        value: function handleScrollStopAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.hideTracks();
        }
    }, {
        key: 'handleWindowResize',
        value: function handleWindowResize() {
            this.update();
        }
    }, {
        key: 'handleHorizontalTrackMouseDown',
        value: function handleHorizontalTrackMouseDown(event) {
            event.preventDefault();
            var target = event.target,
                clientX = event.clientX;

            var _target$getBoundingCl = target.getBoundingClientRect(),
                targetLeft = _target$getBoundingCl.left;

            var thumbWidth = this.getThumbHorizontalWidth();
            var offset = Math.abs(targetLeft - clientX) - thumbWidth / 2;
            this.view.scrollLeft = this.getScrollLeftForOffset(offset);
        }
    }, {
        key: 'handleVerticalTrackMouseDown',
        value: function handleVerticalTrackMouseDown(event) {
            event.preventDefault();
            var target = event.target,
                clientY = event.clientY;

            var _target$getBoundingCl2 = target.getBoundingClientRect(),
                targetTop = _target$getBoundingCl2.top;

            var thumbHeight = this.getThumbVerticalHeight();
            var offset = Math.abs(targetTop - clientY) - thumbHeight / 2;
            this.view.scrollTop = this.getScrollTopForOffset(offset);
        }
    }, {
        key: 'handleHorizontalThumbMouseDown',
        value: function handleHorizontalThumbMouseDown(event) {
            event.preventDefault();
            this.handleDragStart(event);
            var target = event.target,
                clientX = event.clientX;
            var offsetWidth = target.offsetWidth;

            var _target$getBoundingCl3 = target.getBoundingClientRect(),
                left = _target$getBoundingCl3.left;

            this.prevPageX = offsetWidth - (clientX - left);
        }
    }, {
        key: 'handleVerticalThumbMouseDown',
        value: function handleVerticalThumbMouseDown(event) {
            event.preventDefault();
            this.handleDragStart(event);
            var target = event.target,
                clientY = event.clientY;
            var offsetHeight = target.offsetHeight;

            var _target$getBoundingCl4 = target.getBoundingClientRect(),
                top = _target$getBoundingCl4.top;

            this.prevPageY = offsetHeight - (clientY - top);
        }
    }, {
        key: 'setupDragging',
        value: function setupDragging() {
            (0, _domCss2["default"])(document.body, _styles.disableSelectStyle);
            document.addEventListener('mousemove', this.handleDrag);
            document.addEventListener('mouseup', this.handleDragEnd);
            document.onselectstart = _returnFalse2["default"];
        }
    }, {
        key: 'teardownDragging',
        value: function teardownDragging() {
            (0, _domCss2["default"])(document.body, _styles.disableSelectStyleReset);
            document.removeEventListener('mousemove', this.handleDrag);
            document.removeEventListener('mouseup', this.handleDragEnd);
            document.onselectstart = undefined;
        }
    }, {
        key: 'handleDragStart',
        value: function handleDragStart(event) {
            this.dragging = true;
            event.stopImmediatePropagation();
            this.setupDragging();
        }
    }, {
        key: 'handleDrag',
        value: function handleDrag(event) {
            if (this.prevPageX) {
                var clientX = event.clientX;

                var _trackHorizontal$getB = this.trackHorizontal.getBoundingClientRect(),
                    trackLeft = _trackHorizontal$getB.left;

                var thumbWidth = this.getThumbHorizontalWidth();
                var clickPosition = thumbWidth - this.prevPageX;
                var offset = -trackLeft + clientX - clickPosition;
                this.view.scrollLeft = this.getScrollLeftForOffset(offset);
            }
            if (this.prevPageY) {
                var clientY = event.clientY;

                var _trackVertical$getBou = this.trackVertical.getBoundingClientRect(),
                    trackTop = _trackVertical$getBou.top;

                var thumbHeight = this.getThumbVerticalHeight();
                var _clickPosition = thumbHeight - this.prevPageY;
                var _offset = -trackTop + clientY - _clickPosition;
                this.view.scrollTop = this.getScrollTopForOffset(_offset);
            }
            return false;
        }
    }, {
        key: 'handleDragEnd',
        value: function handleDragEnd() {
            this.dragging = false;
            this.prevPageX = this.prevPageY = 0;
            this.teardownDragging();
            this.handleDragEndAutoHide();
        }
    }, {
        key: 'handleDragEndAutoHide',
        value: function handleDragEndAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.hideTracks();
        }
    }, {
        key: 'handleTrackMouseEnter',
        value: function handleTrackMouseEnter() {
            this.trackMouseOver = true;
            this.handleTrackMouseEnterAutoHide();
        }
    }, {
        key: 'handleTrackMouseEnterAutoHide',
        value: function handleTrackMouseEnterAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.showTracks();
        }
    }, {
        key: 'handleTrackMouseLeave',
        value: function handleTrackMouseLeave() {
            this.trackMouseOver = false;
            this.handleTrackMouseLeaveAutoHide();
        }
    }, {
        key: 'handleTrackMouseLeaveAutoHide',
        value: function handleTrackMouseLeaveAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.hideTracks();
        }
    }, {
        key: 'showTracks',
        value: function showTracks() {
            clearTimeout(this.hideTracksTimeout);
            (0, _domCss2["default"])(this.trackHorizontal, { opacity: 1 });
            (0, _domCss2["default"])(this.trackVertical, { opacity: 1 });
        }
    }, {
        key: 'hideTracks',
        value: function hideTracks() {
            var _this3 = this;

            if (this.dragging) return;
            if (this.scrolling) return;
            if (this.trackMouseOver) return;
            var autoHideTimeout = this.props.autoHideTimeout;

            clearTimeout(this.hideTracksTimeout);
            this.hideTracksTimeout = setTimeout(function () {
                (0, _domCss2["default"])(_this3.trackHorizontal, { opacity: 0 });
                (0, _domCss2["default"])(_this3.trackVertical, { opacity: 0 });
            }, autoHideTimeout);
        }
    }, {
        key: 'detectScrolling',
        value: function detectScrolling() {
            var _this4 = this;

            if (this.scrolling) return;
            this.scrolling = true;
            this.handleScrollStart();
            this.detectScrollingInterval = setInterval(function () {
                if (_this4.lastViewScrollLeft === _this4.viewScrollLeft && _this4.lastViewScrollTop === _this4.viewScrollTop) {
                    clearInterval(_this4.detectScrollingInterval);
                    _this4.scrolling = false;
                    _this4.handleScrollStop();
                }
                _this4.lastViewScrollLeft = _this4.viewScrollLeft;
                _this4.lastViewScrollTop = _this4.viewScrollTop;
            }, 100);
        }
    }, {
        key: 'raf',
        value: function raf(callback) {
            var _this5 = this;

            if (this.requestFrame) _raf3["default"].cancel(this.requestFrame);
            this.requestFrame = (0, _raf3["default"])(function () {
                _this5.requestFrame = undefined;
                callback();
            });
        }
    }, {
        key: 'update',
        value: function update(callback) {
            var _this6 = this;

            this.raf(function () {
                return _this6._update(callback);
            });
        }
    }, {
        key: '_update',
        value: function _update(callback) {
            var _props4 = this.props,
                onUpdate = _props4.onUpdate,
                hideTracksWhenNotNeeded = _props4.hideTracksWhenNotNeeded;

            var values = this.getValues();
            if ((0, _getScrollbarWidth2["default"])()) {
                var scrollLeft = values.scrollLeft,
                    clientWidth = values.clientWidth,
                    scrollWidth = values.scrollWidth;

                var trackHorizontalWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
                var thumbHorizontalWidth = this.getThumbHorizontalWidth();
                var thumbHorizontalX = scrollLeft / (scrollWidth - clientWidth) * (trackHorizontalWidth - thumbHorizontalWidth);
                var thumbHorizontalStyle = {
                    width: thumbHorizontalWidth,
                    transform: 'translateX(' + thumbHorizontalX + 'px)'
                };
                var scrollTop = values.scrollTop,
                    clientHeight = values.clientHeight,
                    scrollHeight = values.scrollHeight;

                var trackVerticalHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
                var thumbVerticalHeight = this.getThumbVerticalHeight();
                var thumbVerticalY = scrollTop / (scrollHeight - clientHeight) * (trackVerticalHeight - thumbVerticalHeight);
                var thumbVerticalStyle = {
                    height: thumbVerticalHeight,
                    transform: 'translateY(' + thumbVerticalY + 'px)'
                };
                if (hideTracksWhenNotNeeded) {
                    var trackHorizontalStyle = {
                        visibility: scrollWidth > clientWidth ? 'visible' : 'hidden'
                    };
                    var trackVerticalStyle = {
                        visibility: scrollHeight > clientHeight ? 'visible' : 'hidden'
                    };
                    (0, _domCss2["default"])(this.trackHorizontal, trackHorizontalStyle);
                    (0, _domCss2["default"])(this.trackVertical, trackVerticalStyle);
                }
                (0, _domCss2["default"])(this.thumbHorizontal, thumbHorizontalStyle);
                (0, _domCss2["default"])(this.thumbVertical, thumbVerticalStyle);
            }
            if (onUpdate) onUpdate(values);
            if (typeof callback !== 'function') return;
            callback(values);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this7 = this;

            var scrollbarWidth = (0, _getScrollbarWidth2["default"])();
            /* eslint-disable no-unused-vars */

            var _props5 = this.props,
                onScroll = _props5.onScroll,
                onScrollFrame = _props5.onScrollFrame,
                onScrollStart = _props5.onScrollStart,
                onScrollStop = _props5.onScrollStop,
                onUpdate = _props5.onUpdate,
                renderView = _props5.renderView,
                renderTrackHorizontal = _props5.renderTrackHorizontal,
                renderTrackVertical = _props5.renderTrackVertical,
                renderThumbHorizontal = _props5.renderThumbHorizontal,
                renderThumbVertical = _props5.renderThumbVertical,
                tagName = _props5.tagName,
                hideTracksWhenNotNeeded = _props5.hideTracksWhenNotNeeded,
                autoHide = _props5.autoHide,
                autoHideTimeout = _props5.autoHideTimeout,
                autoHideDuration = _props5.autoHideDuration,
                thumbSize = _props5.thumbSize,
                thumbMinSize = _props5.thumbMinSize,
                universal = _props5.universal,
                autoHeight = _props5.autoHeight,
                autoHeightMin = _props5.autoHeightMin,
                autoHeightMax = _props5.autoHeightMax,
                style = _props5.style,
                children = _props5.children,
                props = _objectWithoutProperties(_props5, ['onScroll', 'onScrollFrame', 'onScrollStart', 'onScrollStop', 'onUpdate', 'renderView', 'renderTrackHorizontal', 'renderTrackVertical', 'renderThumbHorizontal', 'renderThumbVertical', 'tagName', 'hideTracksWhenNotNeeded', 'autoHide', 'autoHideTimeout', 'autoHideDuration', 'thumbSize', 'thumbMinSize', 'universal', 'autoHeight', 'autoHeightMin', 'autoHeightMax', 'style', 'children']);
            /* eslint-enable no-unused-vars */

            var didMountUniversal = this.state.didMountUniversal;


            var containerStyle = _extends({}, _styles.containerStyleDefault, autoHeight && _extends({}, _styles.containerStyleAutoHeight, {
                minHeight: autoHeightMin,
                maxHeight: autoHeightMax
            }), style);

            var viewStyle = _extends({}, _styles.viewStyleDefault, {
                // Hide scrollbars by setting a negative margin
                marginRight: scrollbarWidth ? -scrollbarWidth : 0,
                marginBottom: scrollbarWidth ? -scrollbarWidth : 0
            }, autoHeight && _extends({}, _styles.viewStyleAutoHeight, {
                // Add scrollbarWidth to autoHeight in order to compensate negative margins
                minHeight: (0, _isString2["default"])(autoHeightMin) ? 'calc(' + autoHeightMin + ' + ' + scrollbarWidth + 'px)' : autoHeightMin + scrollbarWidth,
                maxHeight: (0, _isString2["default"])(autoHeightMax) ? 'calc(' + autoHeightMax + ' + ' + scrollbarWidth + 'px)' : autoHeightMax + scrollbarWidth
            }), autoHeight && universal && !didMountUniversal && {
                minHeight: autoHeightMin,
                maxHeight: autoHeightMax
            }, universal && !didMountUniversal && _styles.viewStyleUniversalInitial);

            var trackAutoHeightStyle = {
                transition: 'opacity ' + autoHideDuration + 'ms',
                opacity: 0
            };

            var trackHorizontalStyle = _extends({}, _styles.trackHorizontalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                display: 'none'
            });

            var trackVerticalStyle = _extends({}, _styles.trackVerticalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                display: 'none'
            });

            return (0, _react.createElement)(tagName, _extends({}, props, { style: containerStyle, ref: function ref(_ref3) {
                    _this7.container = _ref3;
                } }), [(0, _react.cloneElement)(renderView({ style: viewStyle }), { key: 'view', ref: function ref(_ref4) {
                    _this7.view = _ref4;
                } }, children), (0, _react.cloneElement)(renderTrackHorizontal({ style: trackHorizontalStyle }), { key: 'trackHorizontal', ref: function ref(_ref5) {
                    _this7.trackHorizontal = _ref5;
                } }, (0, _react.cloneElement)(renderThumbHorizontal({ style: _styles.thumbHorizontalStyleDefault }), { ref: function ref(_ref6) {
                    _this7.thumbHorizontal = _ref6;
                } })), (0, _react.cloneElement)(renderTrackVertical({ style: trackVerticalStyle }), { key: 'trackVertical', ref: function ref(_ref7) {
                    _this7.trackVertical = _ref7;
                } }, (0, _react.cloneElement)(renderThumbVertical({ style: _styles.thumbVerticalStyleDefault }), { ref: function ref(_ref8) {
                    _this7.thumbVertical = _ref8;
                } }))]);
        }
    }]);

    return Scrollbars;
}(_react.Component);

exports["default"] = Scrollbars;


Scrollbars.propTypes = {
    onScroll: _propTypes2["default"].func,
    onScrollFrame: _propTypes2["default"].func,
    onScrollStart: _propTypes2["default"].func,
    onScrollStop: _propTypes2["default"].func,
    onUpdate: _propTypes2["default"].func,
    renderView: _propTypes2["default"].func,
    renderTrackHorizontal: _propTypes2["default"].func,
    renderTrackVertical: _propTypes2["default"].func,
    renderThumbHorizontal: _propTypes2["default"].func,
    renderThumbVertical: _propTypes2["default"].func,
    tagName: _propTypes2["default"].string,
    thumbSize: _propTypes2["default"].number,
    thumbMinSize: _propTypes2["default"].number,
    hideTracksWhenNotNeeded: _propTypes2["default"].bool,
    autoHide: _propTypes2["default"].bool,
    autoHideTimeout: _propTypes2["default"].number,
    autoHideDuration: _propTypes2["default"].number,
    autoHeight: _propTypes2["default"].bool,
    autoHeightMin: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
    autoHeightMax: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
    universal: _propTypes2["default"].bool,
    style: _propTypes2["default"].object,
    children: _propTypes2["default"].node
};

Scrollbars.defaultProps = {
    renderView: _defaultRenderElements.renderViewDefault,
    renderTrackHorizontal: _defaultRenderElements.renderTrackHorizontalDefault,
    renderTrackVertical: _defaultRenderElements.renderTrackVerticalDefault,
    renderThumbHorizontal: _defaultRenderElements.renderThumbHorizontalDefault,
    renderThumbVertical: _defaultRenderElements.renderThumbVerticalDefault,
    tagName: 'div',
    thumbMinSize: 30,
    hideTracksWhenNotNeeded: false,
    autoHide: false,
    autoHideTimeout: 1000,
    autoHideDuration: 200,
    autoHeight: false,
    autoHeightMin: 0,
    autoHeightMax: 200,
    universal: false
};

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(315)))

/***/ }),
/* 1424 */
/***/ (function(module, exports) {

var div = null
var prefixes = [ 'Webkit', 'Moz', 'O', 'ms' ]

module.exports = function prefixStyle (prop) {
  // re-use a dummy div
  if (!div) {
    div = document.createElement('div')
  }

  var style = div.style

  // prop exists without prefix
  if (prop in style) {
    return prop
  }

  // borderRadius -> BorderRadius
  var titleCase = prop.charAt(0).toUpperCase() + prop.slice(1)

  // find the vendor-prefixed prop
  for (var i = prefixes.length; i >= 0; i--) {
    var name = prefixes[i] + titleCase
    // e.g. WebkitBorderRadius or webkitBorderRadius
    if (name in style) {
      return name
    }
  }

  return false
}


/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {


var space = __webpack_require__(1426)

/**
 * Export.
 */

module.exports = toCamelCase

/**
 * Convert a `string` to camel case.
 *
 * @param {String} string
 * @return {String}
 */

function toCamelCase(string) {
  return space(string).replace(/\s(\w)/g, function (matches, letter) {
    return letter.toUpperCase()
  })
}


/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {


var clean = __webpack_require__(1427)

/**
 * Export.
 */

module.exports = toSpaceCase

/**
 * Convert a `string` to space case.
 *
 * @param {String} string
 * @return {String}
 */

function toSpaceCase(string) {
  return clean(string).replace(/[\W_]+(.|$)/g, function (matches, match) {
    return match ? ' ' + match : ''
  }).trim()
}


/***/ }),
/* 1427 */
/***/ (function(module, exports) {


/**
 * Export.
 */

module.exports = toNoCase

/**
 * Test whether a string is camel-case.
 */

var hasSpace = /\s/
var hasSeparator = /(_|-|\.|:)/
var hasCamel = /([a-z][A-Z]|[A-Z][a-z])/

/**
 * Remove any starting case from a `string`, like camel or snake, but keep
 * spaces and punctuation that may be important otherwise.
 *
 * @param {String} string
 * @return {String}
 */

function toNoCase(string) {
  if (hasSpace.test(string)) return string.toLowerCase()
  if (hasSeparator.test(string)) return (unseparate(string) || string).toLowerCase()
  if (hasCamel.test(string)) return uncamelize(string).toLowerCase()
  return string.toLowerCase()
}

/**
 * Separator splitter.
 */

var separatorSplitter = /[\W_]+(.|$)/g

/**
 * Un-separate a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function unseparate(string) {
  return string.replace(separatorSplitter, function (m, next) {
    return next ? ' ' + next : ''
  })
}

/**
 * Camelcase splitter.
 */

var camelSplitter = /(.)([A-Z]+)/g

/**
 * Un-camelcase a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function uncamelize(string) {
  return string.replace(camelSplitter, function (m, previous, uppers) {
    return previous + ' ' + uppers.toLowerCase().split('').join(' ')
  })
}


/***/ }),
/* 1428 */
/***/ (function(module, exports) {

/* The following list is defined in React's core */
var IS_UNITLESS = {
  animationIterationCount: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridColumn: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  stopOpacity: true,
  strokeDashoffset: true,
  strokeOpacity: true,
  strokeWidth: true
};

module.exports = function(name, value) {
  if(typeof value === 'number' && !IS_UNITLESS[ name ]) {
    return value + 'px';
  } else {
    return value;
  }
};

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = isString;
function isString(maybe) {
    return typeof maybe === 'string';
}

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = getScrollbarWidth;

var _domCss = __webpack_require__(684);

var _domCss2 = _interopRequireDefault(_domCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var scrollbarWidth = false;

function getScrollbarWidth() {
    if (scrollbarWidth !== false) return scrollbarWidth;
    /* istanbul ignore else */
    if (typeof document !== 'undefined') {
        var div = document.createElement('div');
        (0, _domCss2["default"])(div, {
            width: 100,
            height: 100,
            position: 'absolute',
            top: -9999,
            overflow: 'scroll',
            MsOverflowStyle: 'scrollbar'
        });
        document.body.appendChild(div);
        scrollbarWidth = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
    } else {
        scrollbarWidth = 0;
    }
    return scrollbarWidth || 0;
}

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = returnFalse;
function returnFalse() {
    return false;
}

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = getInnerWidth;
function getInnerWidth(el) {
    var clientWidth = el.clientWidth;

    var _getComputedStyle = getComputedStyle(el),
        paddingLeft = _getComputedStyle.paddingLeft,
        paddingRight = _getComputedStyle.paddingRight;

    return clientWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
}

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = getInnerHeight;
function getInnerHeight(el) {
    var clientHeight = el.clientHeight;

    var _getComputedStyle = getComputedStyle(el),
        paddingTop = _getComputedStyle.paddingTop,
        paddingBottom = _getComputedStyle.paddingBottom;

    return clientHeight - parseFloat(paddingTop) - parseFloat(paddingBottom);
}

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var containerStyleDefault = exports.containerStyleDefault = {
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    height: '100%'
};

// Overrides containerStyleDefault properties
var containerStyleAutoHeight = exports.containerStyleAutoHeight = {
    height: 'auto'
};

var viewStyleDefault = exports.viewStyleDefault = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: 'scroll',
    WebkitOverflowScrolling: 'touch'
};

// Overrides viewStyleDefault properties
var viewStyleAutoHeight = exports.viewStyleAutoHeight = {
    position: 'relative',
    top: undefined,
    left: undefined,
    right: undefined,
    bottom: undefined
};

var viewStyleUniversalInitial = exports.viewStyleUniversalInitial = {
    overflow: 'hidden',
    marginRight: 0,
    marginBottom: 0
};

var trackHorizontalStyleDefault = exports.trackHorizontalStyleDefault = {
    position: 'absolute',
    height: 6
};

var trackVerticalStyleDefault = exports.trackVerticalStyleDefault = {
    position: 'absolute',
    width: 6
};

var thumbHorizontalStyleDefault = exports.thumbHorizontalStyleDefault = {
    position: 'relative',
    display: 'block',
    height: '100%'
};

var thumbVerticalStyleDefault = exports.thumbVerticalStyleDefault = {
    position: 'relative',
    display: 'block',
    width: '100%'
};

var disableSelectStyle = exports.disableSelectStyle = {
    userSelect: 'none'
};

var disableSelectStyleReset = exports.disableSelectStyleReset = {
    userSelect: ''
};

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.renderViewDefault = renderViewDefault;
exports.renderTrackHorizontalDefault = renderTrackHorizontalDefault;
exports.renderTrackVerticalDefault = renderTrackVerticalDefault;
exports.renderThumbHorizontalDefault = renderThumbHorizontalDefault;
exports.renderThumbVerticalDefault = renderThumbVerticalDefault;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/* eslint-disable react/prop-types */

function renderViewDefault(props) {
    return _react2["default"].createElement('div', props);
}

function renderTrackHorizontalDefault(_ref) {
    var style = _ref.style,
        props = _objectWithoutProperties(_ref, ['style']);

    var finalStyle = _extends({}, style, {
        right: 2,
        bottom: 2,
        left: 2,
        borderRadius: 3
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

function renderTrackVerticalDefault(_ref2) {
    var style = _ref2.style,
        props = _objectWithoutProperties(_ref2, ['style']);

    var finalStyle = _extends({}, style, {
        right: 2,
        bottom: 2,
        top: 2,
        borderRadius: 3
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

function renderThumbHorizontalDefault(_ref3) {
    var style = _ref3.style,
        props = _objectWithoutProperties(_ref3, ['style']);

    var finalStyle = _extends({}, style, {
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: 'rgba(0,0,0,.2)'
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

function renderThumbVerticalDefault(_ref4) {
    var style = _ref4.style,
        props = _objectWithoutProperties(_ref4, ['style']);

    var finalStyle = _extends({}, style, {
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: 'rgba(0,0,0,.2)'
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _LanguageItem = _interopRequireDefault(__webpack_require__(1437));

var _data = _interopRequireDefault(__webpack_require__(1438));

var _CustomScrollbars = _interopRequireDefault(__webpack_require__(27));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var LanguageSwitcher = function LanguageSwitcher(_ref) {
  var switchLanguage = _ref.switchLanguage,
      handleRequestClose = _ref.handleRequestClose;
  return _react["default"].createElement(_CustomScrollbars["default"], {
    className: "messages-list language-list scrollbar",
    style: {
      height: 230
    }
  }, _react["default"].createElement("ul", {
    className: "list-unstyled"
  }, _data["default"].map(function (language, index) {
    return _react["default"].createElement(_LanguageItem["default"], {
      key: index,
      language: language,
      handleRequestClose: handleRequestClose,
      switchLanguage: switchLanguage
    });
  })));
};

var _default = LanguageSwitcher;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(LanguageSwitcher, "LanguageSwitcher", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/LanguageSwitcher/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/LanguageSwitcher/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/LanguageSwitcher/index.js");

  __REACT_HOT_LOADER__.register(_LanguageItem, "_LanguageItem", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/LanguageSwitcher/index.js");

  __REACT_HOT_LOADER__.register(_data, "_data", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/LanguageSwitcher/index.js");

  __REACT_HOT_LOADER__.register(_CustomScrollbars, "_CustomScrollbars", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/LanguageSwitcher/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/LanguageSwitcher/index.js");

  __REACT_HOT_LOADER__.register(LanguageSwitcher, "LanguageSwitcher", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/LanguageSwitcher/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/LanguageSwitcher/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/LanguageSwitcher/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/LanguageSwitcher/index.js");
}();

;

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var LanguageItem = function LanguageItem(_ref) {
  var language = _ref.language,
      switchLanguage = _ref.switchLanguage,
      handleRequestClose = _ref.handleRequestClose;
  var icon = language.icon,
      name = language.name;
  return _react["default"].createElement("li", {
    className: "pointer",
    onClick: function onClick() {
      handleRequestClose();
      switchLanguage(language);
    }
  }, _react["default"].createElement("div", {
    className: "d-flex align-items-center"
  }, _react["default"].createElement("i", {
    className: "flag flag-24 flag-".concat(icon)
  }), _react["default"].createElement("h4", {
    className: "mb-0 ml-2"
  }, name)));
};

var _default = LanguageItem;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(LanguageItem, "LanguageItem", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/LanguageSwitcher/LanguageItem.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/LanguageSwitcher/LanguageItem.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/LanguageSwitcher/LanguageItem.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/LanguageSwitcher/LanguageItem.js");

  __REACT_HOT_LOADER__.register(LanguageItem, "LanguageItem", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/LanguageSwitcher/LanguageItem.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/LanguageSwitcher/LanguageItem.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/LanguageSwitcher/LanguageItem.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/LanguageSwitcher/LanguageItem.js");
}();

;

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var languageData = [{
  languageId: 'english',
  locale: 'en',
  name: 'English',
  icon: 'us'
}, {
  languageId: 'chinese',
  locale: 'zh',
  name: 'Chinese',
  icon: 'cn'
}, {
  languageId: 'spanish',
  locale: 'es',
  name: 'Spanish',
  icon: 'es'
}, {
  languageId: 'french',
  locale: 'fr',
  name: 'French',
  icon: 'fr'
}, {
  languageId: 'italian',
  locale: 'it',
  name: 'Italian',
  icon: 'it'
}, {
  languageId: 'saudi-arabia',
  locale: 'ar',
  name: 'Arabic',
  icon: 'sa'
}];
var _default = languageData;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(languageData, "languageData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/LanguageSwitcher/data.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/LanguageSwitcher/data.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(languageData, "languageData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/LanguageSwitcher/data.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/LanguageSwitcher/data.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/LanguageSwitcher/data.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/LanguageSwitcher/data.js");
}();

;

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _Auth = __webpack_require__(143);

var _userInfoModal = _interopRequireDefault(__webpack_require__(1440));

var _colorOptionsModal = _interopRequireDefault(__webpack_require__(685));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _Authentication = __webpack_require__(42);

var _index = __webpack_require__(267);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var UserInfo =
/*#__PURE__*/
function (_React$Component) {
  _inherits(UserInfo, _React$Component);

  function UserInfo() {
    _classCallCheck(this, UserInfo);

    return _possibleConstructorReturn(this, _getPrototypeOf(UserInfo).apply(this, arguments));
  }

  _createClass(UserInfo, [{
    key: "getModalBody",
    value: function getModalBody() {
      var modalBodyText = '';
      modalBodyText += '<div className="text-center">'; // concat wont work here ??

      modalBodyText += '<img src="assets/images/coming-soon_225_225.jpg" alt="Coming Soon" />';
      modalBodyText += '<h1>Coming Soon</h1>';
      modalBodyText += '</div>';
      return modalBodyText;
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var userName = (0, _Authentication.getIdentityName)();
      var roleName = (0, _Authentication.getRoleName)();
      var _this$props = this.props,
          showHideColorOptionsModal = _this$props.showHideColorOptionsModal,
          showHideUserInfoModal = _this$props.showHideUserInfoModal;
      return _react["default"].createElement("div", null, _react["default"].createElement("div", {
        className: "user-profile"
      }, _react["default"].createElement("img", {
        className: "user-avatar border-0 size-40",
        src: "assets/images/person-150_150.jpg",
        alt: "User"
      }), _react["default"].createElement("div", {
        className: "user-detail ml-2"
      }, _react["default"].createElement("h4", {
        className: "user-name mb-0"
      }, userName), _react["default"].createElement("small", null, roleName))), _react["default"].createElement(_colorOptionsModal["default"], {
        actionComponent: _react["default"].createElement("a", {
          className: "dropdown-item text-muted",
          href: "#",
          onClick: function onClick() {
            return showHideColorOptionsModal();
          }
        }, _react["default"].createElement("i", {
          className: "zmdi zmdi-settings zmdi-hc-fw mr-1"
        }), _react["default"].createElement(_IntlMessages["default"], {
          id: "popup.setting"
        }))
      }), _react["default"].createElement(_userInfoModal["default"], {
        modalTitle: _react["default"].createElement(_IntlMessages["default"], {
          id: "userInfoModal.header"
        }),
        modalBody: this.getModalBody(),
        actionComponent: _react["default"].createElement("a", {
          className: "dropdown-item text-muted",
          href: "#",
          onClick: function onClick() {
            return showHideUserInfoModal();
          }
        }, _react["default"].createElement("i", {
          className: "zmdi zmdi-face zmdi-hc-fw mr-1"
        }), _react["default"].createElement(_IntlMessages["default"], {
          id: "popup.profile"
        }))
      }), _react["default"].createElement("a", {
        className: "dropdown-item text-muted",
        href: "#",
        onClick: function onClick() {
          console.log('Try to logout');

          _this.props.userSignOut();
        }
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-sign-in zmdi-hc-fw mr-1"
      }), _react["default"].createElement(_IntlMessages["default"], {
        id: "popup.logout"
      })));
    }
  }]);

  return UserInfo;
}(_react["default"].Component);

var _default = (0, _reactRedux.connect)(null, {
  userSignOut: _Auth.userSignOut,
  showHideColorOptionsModal: _index.showHideColorOptionsModal,
  showHideUserInfoModal: _index.showHideUserInfoModal
})(UserInfo);

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(UserInfo, "UserInfo", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/UserInfo/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(_userInfoModal, "_userInfoModal", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(_colorOptionsModal, "_colorOptionsModal", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(UserInfo, "UserInfo", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/UserInfo/index.js");
}();

;

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _dompurify = _interopRequireDefault(__webpack_require__(266));

var _index = __webpack_require__(267);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var UserInfoModal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(UserInfoModal, _React$Component);

  function UserInfoModal(props) {
    var _this;

    _classCallCheck(this, UserInfoModal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UserInfoModal).call(this, props));
    _this.toggle = _this.toggle.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(UserInfoModal, [{
    key: "toggle",
    value: function toggle() {
      var showHideUserInfoModal = this.props.showHideUserInfoModal;
      showHideUserInfoModal();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          modalTitle = _this$props.modalTitle,
          buttonText = _this$props.buttonText,
          modalBody = _this$props.modalBody,
          actionComponent = _this$props.actionComponent,
          className = _this$props.className,
          userInfoModal = _this$props.userInfoModal;
      return _react["default"].createElement(_react["default"].Fragment, null, actionComponent ? actionComponent : _react["default"].createElement("a", {
        className: "btn btn-light jr-btn-rounded",
        href: "javascript:void(0)",
        onClick: this.toggle
      }, buttonText), _react["default"].createElement("div", {
        className: "text-center"
      }, _react["default"].createElement(_reactstrap.Modal, {
        isOpen: userInfoModal,
        toggle: this.toggle,
        className: className,
        style: {
          maxHeight: 600,
          width: 400
        }
      }, _react["default"].createElement(_reactstrap.ModalHeader, null, modalTitle), _react["default"].createElement(_reactstrap.ModalBody, null, _react["default"].createElement("div", {
        dangerouslySetInnerHTML: {
          __html: _dompurify["default"].sanitize(modalBody)
        }
      })), _react["default"].createElement(_reactstrap.ModalFooter, null, _react["default"].createElement(_reactstrap.Button, {
        color: "primary",
        onClick: this.toggle
      }, "Close")))));
    }
  }]);

  return UserInfoModal;
}(_react["default"].Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var settings = _ref.settings;
  var userInfoModal = settings.userInfoModal;
  return {
    userInfoModal: userInfoModal
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  showHideUserInfoModal: _index.showHideUserInfoModal
})(UserInfoModal);

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(UserInfoModal, "UserInfoModal", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/userInfoModal/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/userInfoModal/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/userInfoModal/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/userInfoModal/index.js");

  __REACT_HOT_LOADER__.register(_dompurify, "_dompurify", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/userInfoModal/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/userInfoModal/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/userInfoModal/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/userInfoModal/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/userInfoModal/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/userInfoModal/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/userInfoModal/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/userInfoModal/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/userInfoModal/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/userInfoModal/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/userInfoModal/index.js");

  __REACT_HOT_LOADER__.register(UserInfoModal, "UserInfoModal", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/userInfoModal/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/userInfoModal/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/userInfoModal/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/userInfoModal/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/userInfoModal/index.js");
}();

;

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactRouterDom = __webpack_require__(13);

var _ActionTypes = __webpack_require__(7);

var _index = __webpack_require__(267);

var _reactstrap = __webpack_require__(6);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Customizer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Customizer, _React$Component);

  function Customizer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Customizer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Customizer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "setFixedDrawer", function () {
      var _this2;

      return (_this2 = _this).__setFixedDrawer__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "setCollapsedDrawer", function () {
      var _this3;

      return (_this3 = _this).__setCollapsedDrawer__REACT_HOT_LOADER__.apply(_this3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "setMiniDrawer", function () {
      var _this4;

      return (_this4 = _this).__setMiniDrawer__REACT_HOT_LOADER__.apply(_this4, arguments);
    });

    return _this;
  }

  _createClass(Customizer, [{
    key: "__setFixedDrawer__REACT_HOT_LOADER__",
    value: function __setFixedDrawer__REACT_HOT_LOADER__() {
      this.props.setDrawerType(_ActionTypes.FIXED_DRAWER);
    }
  }, {
    key: "__setCollapsedDrawer__REACT_HOT_LOADER__",
    value: function __setCollapsedDrawer__REACT_HOT_LOADER__() {
      this.props.setDrawerType(_ActionTypes.COLLAPSED_DRAWER);
    }
  }, {
    key: "__setMiniDrawer__REACT_HOT_LOADER__",
    value: function __setMiniDrawer__REACT_HOT_LOADER__() {
      this.props.setDrawerType(_ActionTypes.MINI_DRAWER);
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$props = this.props,
          drawerType = _this$props.drawerType,
          navigationStyle = _this$props.navigationStyle,
          horizontalNavPosition = _this$props.horizontalNavPosition;
      return _react["default"].createElement("div", {
        className: "side-nav-option"
      }, _react["default"].createElement("div", {
        className: "mb-1"
      }, _react["default"].createElement("h3", {
        className: "mb-3 mt-4"
      }, "Navigation Style"), _react["default"].createElement("div", {
        className: "row row-5 mb-3"
      }, _react["default"].createElement("div", {
        className: "col-6"
      }, _react["default"].createElement("div", {
        className: "custom-control custom-radio"
      }, _react["default"].createElement("input", {
        type: "radio",
        id: "in-app-layout-type",
        className: "custom-control-input",
        checked: navigationStyle === _ActionTypes.HORIZONTAL_NAVIGATION,
        onChange: function onChange() {
          _this5.props.changeNavigationStyle(_ActionTypes.HORIZONTAL_NAVIGATION);
        }
      }), _react["default"].createElement("label", {
        className: "custom-control-label pointer",
        htmlFor: "in-app-layout-type"
      }, "Horizontal"))), _react["default"].createElement("div", {
        className: "col-6"
      }, _react["default"].createElement("div", {
        className: "custom-control custom-radio"
      }, _react["default"].createElement("input", {
        type: "radio",
        id: "top-app-layout-type",
        className: "custom-control-input",
        checked: navigationStyle === _ActionTypes.VERTICAL_NAVIGATION,
        onChange: function onChange() {
          _this5.props.changeNavigationStyle(_ActionTypes.VERTICAL_NAVIGATION);
        }
      }), _react["default"].createElement("label", {
        className: "custom-control-label pointer",
        htmlFor: "top-app-layout-type"
      }, "Vertical"))))), navigationStyle === _ActionTypes.HORIZONTAL_NAVIGATION ? _react["default"].createElement(_reactstrap.ButtonGroup, null, _react["default"].createElement(_reactstrap.Button, {
        color: "default",
        className: "jr-btn  ".concat(horizontalNavPosition === _ActionTypes.INSIDE_THE_HEADER && 'active', " "),
        onClick: function onClick() {
          _this5.props.setHorizontalMenuPosition(_ActionTypes.INSIDE_THE_HEADER);
        }
      }, "Inside"), _react["default"].createElement(_reactstrap.Button, {
        color: "default",
        className: "jr-btn ".concat(horizontalNavPosition === _ActionTypes.ABOVE_THE_HEADER && 'active', " "),
        onClick: function onClick() {
          _this5.props.setHorizontalMenuPosition(_ActionTypes.ABOVE_THE_HEADER);
        }
      }, "Top"), _react["default"].createElement(_reactstrap.Button, {
        color: "default",
        className: "jr-btn ".concat(horizontalNavPosition === _ActionTypes.BELOW_THE_HEADER && 'active', " "),
        onClick: function onClick() {
          _this5.props.setHorizontalMenuPosition(_ActionTypes.BELOW_THE_HEADER);
        }
      }, "Below")) : _react["default"].createElement(_reactstrap.ButtonGroup, null, _react["default"].createElement(_reactstrap.Button, {
        color: "default",
        className: "jr-btn  ".concat(drawerType === _ActionTypes.FIXED_DRAWER && 'active', " "),
        onClick: this.setFixedDrawer.bind(this)
      }, "Fixed"), _react["default"].createElement(_reactstrap.Button, {
        color: "default",
        className: "jr-btn ".concat(drawerType === _ActionTypes.COLLAPSED_DRAWER && 'active', " "),
        onClick: this.setCollapsedDrawer.bind(this)
      }, "Collapsed"), _react["default"].createElement(_reactstrap.Button, {
        color: "default",
        className: "jr-btn ".concat(drawerType === _ActionTypes.MINI_DRAWER && 'active', " "),
        onClick: this.setMiniDrawer.bind(this)
      }, "Mini")));
    }
  }]);

  return Customizer;
}(_react["default"].Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var settings = _ref.settings;
  var drawerType = settings.drawerType,
      navigationStyle = settings.navigationStyle,
      horizontalNavPosition = settings.horizontalNavPosition;
  return {
    drawerType: drawerType,
    navigationStyle: navigationStyle,
    horizontalNavPosition: horizontalNavPosition
  };
};

var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, {
  setDrawerType: _index.setDrawerType,
  changeNavigationStyle: _index.changeNavigationStyle,
  setHorizontalMenuPosition: _index.setHorizontalMenuPosition
})(Customizer));

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Customizer, "Customizer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/Customizer/SideNavOption.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/Customizer/SideNavOption.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/Customizer/SideNavOption.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/Customizer/SideNavOption.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/Customizer/SideNavOption.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/Customizer/SideNavOption.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/Customizer/SideNavOption.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/Customizer/SideNavOption.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/Customizer/SideNavOption.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/Customizer/SideNavOption.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/Customizer/SideNavOption.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/Customizer/SideNavOption.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/Customizer/SideNavOption.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/Customizer/SideNavOption.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/Customizer/SideNavOption.js");

  __REACT_HOT_LOADER__.register(Customizer, "Customizer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/Customizer/SideNavOption.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/Customizer/SideNavOption.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/Customizer/SideNavOption.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/Customizer/SideNavOption.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/Customizer/SideNavOption.js");
}();

;

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _propTypes=__webpack_require__(1),_propTypes2=_interopRequireDefault(_propTypes),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react);function _interopRequireDefault(a){return a&&a.__esModule?a:{default:a}}var propTypes={on:_propTypes2.default.bool.isRequired,onClick:_propTypes2.default.func.isRequired,enabled:_propTypes2.default.bool,className:_propTypes2.default.string},defaultProps={enabled:!0,className:'',onDisabledClick:function onDisabledClick(){}};function Switch(a){var b=a.on,c=a.onClick,d=a.onDisabledClick,f=a.enabled,e=a.className,g=a.children,h=['switch',e,b?'on ':'',f?'':'disabled '].join(' ');return _react2.default.createElement('div',{className:h,onClick:function onClick(a){return f?c(a):d(a)}},_react2.default.createElement('div',{className:'switch-toggle',children:g}))}Switch.propTypes=propTypes,Switch.defaultProps=defaultProps,exports.default=Switch;


/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactRouterDom = __webpack_require__(13);

var _rcDrawer = _interopRequireDefault(__webpack_require__(31));

var _SidenavContent = _interopRequireDefault(__webpack_require__(1481));

var _SidenavLogo = _interopRequireDefault(__webpack_require__(1485));

var _ActionTypes = __webpack_require__(7);

var _Setting = __webpack_require__(265);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SideNav =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(SideNav, _React$PureComponent);

  _createClass(SideNav, [{
    key: "__onToggleCollapsedNav__REACT_HOT_LOADER__",
    value: function __onToggleCollapsedNav__REACT_HOT_LOADER__() {
      var val = !this.props.navCollapsed;
      this.props.toggleCollapsedNav(val);
    }
  }]);

  function SideNav(props) {
    var _this;

    _classCallCheck(this, SideNav);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SideNav).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onToggleCollapsedNav", function () {
      var _this2;

      return (_this2 = _this).__onToggleCollapsedNav__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    return _this;
  }

  _createClass(SideNav, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      window.addEventListener('resize', function () {
        _this3.props.updateWindowWidth(window.innerWidth);

        _this3.props.updateWindowHeight(window.innerHeight);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          navCollapsed = _this$props.navCollapsed,
          drawerType = _this$props.drawerType,
          width = _this$props.width,
          isDirectionRTL = _this$props.isDirectionRTL,
          navigationStyle = _this$props.navigationStyle;
      var drawerStyle = drawerType.includes(_ActionTypes.FIXED_DRAWER) ? 'd-xl-flex' : drawerType.includes(_ActionTypes.COLLAPSED_DRAWER) ? '' : 'd-flex';
      var type = true;

      if (drawerType.includes(_ActionTypes.COLLAPSED_DRAWER) || drawerType.includes(_ActionTypes.FIXED_DRAWER) && width < 1200) {
        type = false;
      }

      if (navigationStyle === _ActionTypes.HORIZONTAL_NAVIGATION) {
        drawerStyle = '';
        type = false;
      }

      return _react["default"].createElement(_rcDrawer["default"], {
        docked: type,
        className: "app-sidebar ".concat(drawerStyle),
        style: {
          overflow: 'auto'
        },
        touch: true,
        position: isDirectionRTL ? 'right' : 'left',
        transitions: true,
        enableDragHandle: true,
        open: navCollapsed,
        onOpenChange: this.onToggleCollapsedNav,
        sidebar: _react["default"].createElement("div", {
          className: "side-nav"
        }, _react["default"].createElement(_SidenavLogo["default"], {
          drawerType: drawerType
        }), _react["default"].createElement(_SidenavContent["default"], null))
      }, _react["default"].createElement("div", null));
    }
  }]);

  return SideNav;
}(_react["default"].PureComponent);

var mapStateToProps = function mapStateToProps(_ref) {
  var settings = _ref.settings;
  var navCollapsed = settings.navCollapsed,
      drawerType = settings.drawerType,
      width = settings.width,
      isDirectionRTL = settings.isDirectionRTL,
      navigationStyle = settings.navigationStyle;
  return {
    navCollapsed: navCollapsed,
    drawerType: drawerType,
    width: width,
    isDirectionRTL: isDirectionRTL,
    navigationStyle: navigationStyle
  };
};

var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, {
  toggleCollapsedNav: _Setting.toggleCollapsedNav,
  updateWindowWidth: _Setting.updateWindowWidth,
  updateWindowHeight: _Setting.updateWindowHeight
})(SideNav));

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SideNav, "SideNav", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/index.js");

  __REACT_HOT_LOADER__.register(_rcDrawer, "_rcDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/index.js");

  __REACT_HOT_LOADER__.register(_SidenavContent, "_SidenavContent", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/index.js");

  __REACT_HOT_LOADER__.register(_SidenavLogo, "_SidenavLogo", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/index.js");

  __REACT_HOT_LOADER__.register(SideNav, "SideNav", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/index.js");
}();

;

/***/ }),
/* 1444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);












function getOffset(ele) {
  var el = ele;
  var _x = 0;
  var _y = 0;
  while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
    _x += el.offsetLeft - el.scrollLeft;
    _y += el.offsetTop - el.scrollTop;
    el = el.offsetParent;
  }
  return { top: _y, left: _x };
}

var CANCEL_DISTANCE_ON_SCROLL = 20;

var Drawer = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Drawer, _React$Component);

  function Drawer(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Drawer);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Drawer.__proto__ || Object.getPrototypeOf(Drawer)).call(this, props));

    _this.onOverlayClicked = function () {
      if (_this.props.open) {
        // see https://github.com/react-component/drawer/issues/9
        setTimeout(function () {
          _this.props.onOpenChange(false, { overlayClicked: true });
        }, 0);
      }
    };

    _this.onTouchStart = function (ev) {
      // filter out if a user starts swiping with a second finger
      if (!_this.isTouching()) {
        var touch = ev.targetTouches[0];
        _this.setState({
          touchIdentifier: !_this.notTouch ? touch.identifier : null,
          touchStartX: touch.clientX,
          touchStartY: touch.clientY,
          touchCurrentX: touch.clientX,
          touchCurrentY: touch.clientY
        });
      }
    };

    _this.onTouchMove = function (ev) {
      // ev.preventDefault(); // cannot touchmove with FastClick
      if (_this.isTouching()) {
        for (var ind = 0; ind < ev.targetTouches.length; ind++) {
          // we only care about the finger that we are tracking
          if (ev.targetTouches[ind].identifier === _this.state.touchIdentifier) {
            _this.setState({
              touchCurrentX: ev.targetTouches[ind].clientX,
              touchCurrentY: ev.targetTouches[ind].clientY
            });
            break;
          }
        }
      }
    };

    _this.onTouchEnd = function () {
      _this.notTouch = false;
      if (_this.isTouching()) {
        // trigger a change to open if sidebar has been dragged beyond dragToggleDistance
        var touchWidth = _this.touchSidebarWidth();

        if (_this.props.open && touchWidth < _this.state.sidebarWidth - _this.props.dragToggleDistance || !_this.props.open && touchWidth > _this.props.dragToggleDistance) {
          _this.props.onOpenChange(!_this.props.open);
        }

        var touchHeight = _this.touchSidebarHeight();

        if (_this.props.open && touchHeight < _this.state.sidebarHeight - _this.props.dragToggleDistance || !_this.props.open && touchHeight > _this.props.dragToggleDistance) {
          _this.props.onOpenChange(!_this.props.open);
        }

        _this.setState({
          touchIdentifier: null,
          touchStartX: null,
          touchStartY: null,
          touchCurrentX: null,
          touchCurrentY: null
        });
      }
    };

    _this.onScroll = function () {
      if (_this.isTouching() && _this.inCancelDistanceOnScroll()) {
        _this.setState({
          touchIdentifier: null,
          touchStartX: null,
          touchStartY: null,
          touchCurrentX: null,
          touchCurrentY: null
        });
      }
    };

    _this.inCancelDistanceOnScroll = function () {
      var cancelDistanceOnScroll = void 0;
      switch (_this.props.position) {
        case 'right':
          cancelDistanceOnScroll = Math.abs(_this.state.touchCurrentX - _this.state.touchStartX) < CANCEL_DISTANCE_ON_SCROLL;
          break;
        case 'bottom':
          cancelDistanceOnScroll = Math.abs(_this.state.touchCurrentY - _this.state.touchStartY) < CANCEL_DISTANCE_ON_SCROLL;
          break;
        case 'top':
          cancelDistanceOnScroll = Math.abs(_this.state.touchStartY - _this.state.touchCurrentY) < CANCEL_DISTANCE_ON_SCROLL;
          break;
        case 'left':
        default:
          cancelDistanceOnScroll = Math.abs(_this.state.touchStartX - _this.state.touchCurrentX) < CANCEL_DISTANCE_ON_SCROLL;
      }
      return cancelDistanceOnScroll;
    };

    _this.isTouching = function () {
      return _this.state.touchIdentifier !== null;
    };

    _this.saveSidebarSize = function () {
      var sidebar = __WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.findDOMNode(_this.refs.sidebar);
      var width = sidebar.offsetWidth;
      var height = sidebar.offsetHeight;
      var sidebarTop = getOffset(__WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.findDOMNode(_this.refs.sidebar)).top;
      var dragHandleTop = getOffset(__WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.findDOMNode(_this.refs.dragHandle)).top;

      if (width !== _this.state.sidebarWidth) {
        _this.setState({ sidebarWidth: width });
      }
      if (height !== _this.state.sidebarHeight) {
        _this.setState({ sidebarHeight: height });
      }
      if (sidebarTop !== _this.state.sidebarTop) {
        _this.setState({ sidebarTop: sidebarTop });
      }
      if (dragHandleTop !== _this.state.dragHandleTop) {
        _this.setState({ dragHandleTop: dragHandleTop });
      }
    };

    _this.touchSidebarWidth = function () {
      // if the sidebar is open and start point of drag is inside the sidebar
      // we will only drag the distance they moved their finger
      // otherwise we will move the sidebar to be below the finger.
      if (_this.props.position === 'right') {
        if (_this.props.open && window.innerWidth - _this.state.touchStartX < _this.state.sidebarWidth) {
          if (_this.state.touchCurrentX > _this.state.touchStartX) {
            return _this.state.sidebarWidth + _this.state.touchStartX - _this.state.touchCurrentX;
          }
          return _this.state.sidebarWidth;
        }
        return Math.min(window.innerWidth - _this.state.touchCurrentX, _this.state.sidebarWidth);
      }

      if (_this.props.position === 'left') {
        if (_this.props.open && _this.state.touchStartX < _this.state.sidebarWidth) {
          if (_this.state.touchCurrentX > _this.state.touchStartX) {
            return _this.state.sidebarWidth;
          }
          return _this.state.sidebarWidth - _this.state.touchStartX + _this.state.touchCurrentX;
        }
        return Math.min(_this.state.touchCurrentX, _this.state.sidebarWidth);
      }
    };

    _this.touchSidebarHeight = function () {
      // if the sidebar is open and start point of drag is inside the sidebar
      // we will only drag the distance they moved their finger
      // otherwise we will move the sidebar to be below the finger.
      if (_this.props.position === 'bottom') {
        if (_this.props.open && window.innerHeight - _this.state.touchStartY < _this.state.sidebarHeight) {
          if (_this.state.touchCurrentY > _this.state.touchStartY) {
            return _this.state.sidebarHeight + _this.state.touchStartY - _this.state.touchCurrentY;
          }
          return _this.state.sidebarHeight;
        }
        return Math.min(window.innerHeight - _this.state.touchCurrentY, _this.state.sidebarHeight);
      }

      if (_this.props.position === 'top') {
        var touchStartOffsetY = _this.state.touchStartY - _this.state.sidebarTop;
        if (_this.props.open && touchStartOffsetY < _this.state.sidebarHeight) {
          if (_this.state.touchCurrentY > _this.state.touchStartY) {
            return _this.state.sidebarHeight;
          }
          return _this.state.sidebarHeight - _this.state.touchStartY + _this.state.touchCurrentY;
        }
        return Math.min(_this.state.touchCurrentY - _this.state.dragHandleTop, _this.state.sidebarHeight);
      }
    };

    _this.renderStyle = function (_ref) {
      var sidebarStyle = _ref.sidebarStyle,
          isTouching = _ref.isTouching,
          overlayStyle = _ref.overlayStyle,
          contentStyle = _ref.contentStyle;

      if (_this.props.position === 'right' || _this.props.position === 'left') {
        sidebarStyle.transform = 'translateX(0%)';
        sidebarStyle.WebkitTransform = 'translateX(0%)';
        if (isTouching) {
          var percentage = _this.touchSidebarWidth() / _this.state.sidebarWidth;
          // slide open to what we dragged
          if (_this.props.position === 'right') {
            sidebarStyle.transform = 'translateX(' + (1 - percentage) * 100 + '%)';
            sidebarStyle.WebkitTransform = 'translateX(' + (1 - percentage) * 100 + '%)';
          }
          if (_this.props.position === 'left') {
            sidebarStyle.transform = 'translateX(-' + (1 - percentage) * 100 + '%)';
            sidebarStyle.WebkitTransform = 'translateX(-' + (1 - percentage) * 100 + '%)';
          }
          // fade overlay to match distance of drag
          overlayStyle.opacity = percentage;
          overlayStyle.visibility = 'visible';
        }
        if (contentStyle) {
          contentStyle[_this.props.position] = _this.state.sidebarWidth + 'px';
        }
      }
      if (_this.props.position === 'top' || _this.props.position === 'bottom') {
        sidebarStyle.transform = 'translateY(0%)';
        sidebarStyle.WebkitTransform = 'translateY(0%)';
        if (isTouching) {
          var _percentage = _this.touchSidebarHeight() / _this.state.sidebarHeight;
          // slide open to what we dragged
          if (_this.props.position === 'bottom') {
            sidebarStyle.transform = 'translateY(' + (1 - _percentage) * 100 + '%)';
            sidebarStyle.WebkitTransform = 'translateY(' + (1 - _percentage) * 100 + '%)';
          }
          if (_this.props.position === 'top') {
            sidebarStyle.transform = 'translateY(-' + (1 - _percentage) * 100 + '%)';
            sidebarStyle.WebkitTransform = 'translateY(-' + (1 - _percentage) * 100 + '%)';
          }
          // fade overlay to match distance of drag
          overlayStyle.opacity = _percentage;
          overlayStyle.visibility = 'visible';
        }
        if (contentStyle) {
          contentStyle[_this.props.position] = _this.state.sidebarHeight + 'px';
        }
      }
    };

    _this.state = {
      // the detected width of the sidebar in pixels
      sidebarWidth: 0,
      sidebarHeight: 0,
      sidebarTop: 0,
      dragHandleTop: 0,

      // keep track of touching params
      touchIdentifier: null,
      touchStartX: null,
      touchStartY: null,
      touchCurrentX: null,
      touchCurrentY: null,

      // if touch is supported by the browser
      touchSupported: (typeof window === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(window)) === 'object' && 'ontouchstart' in window
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Drawer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.saveSidebarSize();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      // filter out the updates when we're touching
      if (!this.isTouching()) {
        this.saveSidebarSize();
      }
    }

    // This logic helps us prevents the user from sliding the sidebar horizontally
    // while scrolling the sidebar vertically. When a scroll event comes in, we're
    // cancelling the ongoing gesture if it did not move horizontally much.


    // True if the on going gesture X distance is less than the cancel distance


    // calculate the sidebarWidth based on current touch info

    // calculate the sidebarHeight based on current touch info

  }, {
    key: 'render',
    value: function render() {
      var _rootCls,
          _this2 = this;

      var _props = this.props,
          className = _props.className,
          style = _props.style,
          prefixCls = _props.prefixCls,
          position = _props.position,
          transitions = _props.transitions,
          touch = _props.touch,
          enableDragHandle = _props.enableDragHandle,
          sidebar = _props.sidebar,
          children = _props.children,
          docked = _props.docked,
          open = _props.open;


      var sidebarStyle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.props.sidebarStyle);
      var contentStyle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.props.contentStyle);
      var overlayStyle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.props.overlayStyle);

      var rootCls = (_rootCls = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_rootCls, className, !!className), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_rootCls, prefixCls, true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_rootCls, prefixCls + '-' + position, true), _rootCls);

      var rootProps = { style: style };
      var isTouching = this.isTouching();

      if (isTouching) {
        this.renderStyle({ sidebarStyle: sidebarStyle, isTouching: true, overlayStyle: overlayStyle });
      } else if (docked) {
        if (this.state.sidebarWidth !== 0) {
          rootCls[prefixCls + '-docked'] = true;
          this.renderStyle({ sidebarStyle: sidebarStyle, contentStyle: contentStyle });
        }
      } else if (open) {
        rootCls[prefixCls + '-open'] = true;
        this.renderStyle({ sidebarStyle: sidebarStyle });
        overlayStyle.opacity = 1;
        overlayStyle.visibility = 'visible';
      }

      if (isTouching || !transitions) {
        sidebarStyle.transition = 'none';
        sidebarStyle.WebkitTransition = 'none';
        contentStyle.transition = 'none';
        overlayStyle.transition = 'none';
      }

      var dragHandle = null;

      if (this.state.touchSupported && touch) {
        if (open) {
          rootProps.onTouchStart = function (ev) {
            _this2.notTouch = true;
            _this2.onTouchStart(ev);
          };
          rootProps.onTouchMove = this.onTouchMove;
          rootProps.onTouchEnd = this.onTouchEnd;
          rootProps.onTouchCancel = this.onTouchEnd;
          rootProps.onScroll = this.onScroll;
        } else if (enableDragHandle) {
          dragHandle = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', { className: prefixCls + '-draghandle', style: this.props.dragHandleStyle,
            onTouchStart: this.onTouchStart, onTouchMove: this.onTouchMove,
            onTouchEnd: this.onTouchEnd, onTouchCancel: this.onTouchEnd,
            ref: 'dragHandle'
          });
        }
      }

      // const evt = {};
      // // FastClick use touchstart instead of click
      // if (this.state.touchSupported) {
      //   evt.onTouchStart = () => {
      //     this.notTouch = true;
      //     this.onOverlayClicked();
      //   };
      //   evt.onTouchEnd = () => {
      //     this.notTouch = false;
      //     this.setState({
      //       touchIdentifier: null,
      //     });
      //   };
      // } else {
      //   evt.onClick = this.onOverlayClicked;
      // }

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ className: __WEBPACK_IMPORTED_MODULE_10_classnames___default()(rootCls) }, rootProps),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'div',
          { className: prefixCls + '-sidebar', style: sidebarStyle,
            ref: 'sidebar'
          },
          sidebar
        ),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', { className: prefixCls + '-overlay',
          style: overlayStyle,
          role: 'presentation',
          ref: 'overlay',
          onClick: this.onOverlayClicked
        }),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'div',
          { className: prefixCls + '-content', style: contentStyle,
            ref: 'content'
          },
          dragHandle,
          children
        )
      );
    }
  }]);

  return Drawer;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Drawer.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  // main content to render
  children: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node.isRequired,

  // styles
  // styles: PropTypes.shape({
  //   dragHandle: PropTypes.object,
  // }),
  style: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  sidebarStyle: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  contentStyle: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  overlayStyle: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  dragHandleStyle: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,

  // sidebar content to render
  sidebar: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node.isRequired,

  // boolean if sidebar should be docked
  docked: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  // boolean if sidebar should slide open
  open: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  // boolean if transitions should be disabled
  transitions: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  // boolean if touch gestures are enabled
  touch: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  enableDragHandle: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  // where to place the sidebar
  position: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(['left', 'right', 'top', 'bottom']),

  // distance we have to drag the sidebar to toggle open state
  dragToggleDistance: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,

  // callback called when the overlay is clicked
  onOpenChange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
};
Drawer.defaultProps = {
  prefixCls: 'rc-drawer',
  sidebarStyle: {},
  contentStyle: {},
  overlayStyle: {},
  dragHandleStyle: {},
  docked: false,
  open: false,
  transitions: true,
  touch: true,
  enableDragHandle: true,
  position: 'left',
  dragToggleDistance: 30,
  onOpenChange: function onOpenChange() {}
};
/* harmony default export */ __webpack_exports__["a"] = (Drawer);

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1446);
var $Object = __webpack_require__(61).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(118);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(121), 'Object', { defineProperty: __webpack_require__(120).f });


/***/ }),
/* 1447 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1449), __esModule: true };

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1450);
module.exports = __webpack_require__(61).Object.assign;


/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(118);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1451) });


/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(121);
var getKeys = __webpack_require__(268);
var gOPS = __webpack_require__(378);
var pIE = __webpack_require__(271);
var toObject = __webpack_require__(216);
var IObject = __webpack_require__(691);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(185)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(149);
var toLength = __webpack_require__(692);
var toAbsoluteIndex = __webpack_require__(1453);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(374);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1455), __esModule: true };

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(693);
__webpack_require__(1460);
module.exports = __webpack_require__(381).f('iterator');


/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(374);
var defined = __webpack_require__(373);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(379);
var descriptor = __webpack_require__(215);
var setToStringTag = __webpack_require__(380);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(182)(IteratorPrototype, __webpack_require__(90)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(120);
var anObject = __webpack_require__(183);
var getKeys = __webpack_require__(268);

module.exports = __webpack_require__(121) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(119).document;
module.exports = document && document.documentElement;


/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1461);
var global = __webpack_require__(119);
var hide = __webpack_require__(182);
var Iterators = __webpack_require__(217);
var TO_STRING_TAG = __webpack_require__(90)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(1462);
var step = __webpack_require__(1463);
var Iterators = __webpack_require__(217);
var toIObject = __webpack_require__(149);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(694)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 1462 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 1463 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1465), __esModule: true };

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1466);
__webpack_require__(1471);
__webpack_require__(1472);
__webpack_require__(1473);
module.exports = __webpack_require__(61).Symbol;


/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(119);
var has = __webpack_require__(148);
var DESCRIPTORS = __webpack_require__(121);
var $export = __webpack_require__(118);
var redefine = __webpack_require__(695);
var META = __webpack_require__(1467).KEY;
var $fails = __webpack_require__(185);
var shared = __webpack_require__(376);
var setToStringTag = __webpack_require__(380);
var uid = __webpack_require__(270);
var wks = __webpack_require__(90);
var wksExt = __webpack_require__(381);
var wksDefine = __webpack_require__(382);
var enumKeys = __webpack_require__(1468);
var isArray = __webpack_require__(1469);
var anObject = __webpack_require__(183);
var isObject = __webpack_require__(184);
var toObject = __webpack_require__(216);
var toIObject = __webpack_require__(149);
var toPrimitive = __webpack_require__(371);
var createDesc = __webpack_require__(215);
var _create = __webpack_require__(379);
var gOPNExt = __webpack_require__(1470);
var $GOPD = __webpack_require__(383);
var $GOPS = __webpack_require__(378);
var $DP = __webpack_require__(120);
var $keys = __webpack_require__(268);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(697).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(271).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(269)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(182)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(270)('meta');
var isObject = __webpack_require__(184);
var has = __webpack_require__(148);
var setDesc = __webpack_require__(120).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(185)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(268);
var gOPS = __webpack_require__(378);
var pIE = __webpack_require__(271);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(372);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(149);
var gOPN = __webpack_require__(697).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 1471 */
/***/ (function(module, exports) {



/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(382)('asyncIterator');


/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(382)('observable');


/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1475), __esModule: true };

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1476);
module.exports = __webpack_require__(61).Object.setPrototypeOf;


/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(118);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(1477).set });


/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(184);
var anObject = __webpack_require__(183);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(370)(Function.call, __webpack_require__(383).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1479), __esModule: true };

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1480);
var $Object = __webpack_require__(61).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(118);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(379) });


/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRouterDom = __webpack_require__(13);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _CustomScrollbars = _interopRequireDefault(__webpack_require__(27));

var _Authentication = __webpack_require__(42);

var _SidenavDeveloperContent = _interopRequireDefault(__webpack_require__(1482));

var _SidenavSuperuserContent = _interopRequireDefault(__webpack_require__(1483));

var _SidenavAdminContent = _interopRequireDefault(__webpack_require__(1484));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var SidenavContent =
/*#__PURE__*/
function (_Component) {
  _inherits(SidenavContent, _Component);

  function SidenavContent() {
    _classCallCheck(this, SidenavContent);

    return _possibleConstructorReturn(this, _getPrototypeOf(SidenavContent).apply(this, arguments));
  }

  _createClass(SidenavContent, [{
    key: "linkClick",
    value: function linkClick(e) {
      e.preventDefault();
      console.log('link clicked');
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var history = this.props.history;
      var that = this;
      var pathname = "javascript:void(0)".concat(history.location.pathname); // get current path

      var subMenuLi = document.querySelectorAll('.sub-menu > li');

      for (var i = 0; i < subMenuLi.length; i++) {
        subMenuLi[i].onclick = function (event) {
          event.stopPropagation();
        };
      }

      var menuLi = document.getElementsByClassName('menu');

      for (var _i = 0; _i < menuLi.length; _i++) {
        menuLi[_i].onclick = function (event) {
          for (var j = 0; j < menuLi.length; j++) {
            var parentLi = that.closest(this, 'li');

            if (menuLi[j] !== this && (parentLi === null || !parentLi.classList.contains('open'))) {
              menuLi[j].classList.remove('open');
            }
          }

          this.classList.toggle('open');
          event.stopPropagation();
        };
      }

      var activeLi = document.querySelector('a[href="' + pathname + '"]'); // select current a element

      try {
        var activeNav = this.closest(activeLi, 'ul'); // select closest ul

        if (activeNav.classList.contains('sub-menu')) {
          this.closest(activeNav, 'li').classList.add('open');
        } else {
          this.closest(activeLi, 'li').classList.add('open');
        }
      } catch (error) {
        (function (error) {
          return error;
        });
      }
    }
  }, {
    key: "closest",
    value: function closest(el, selector) {
      try {
        var matchesFn; // find vendor prefix

        ['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'].some(function (fn) {
          if (typeof document.body[fn] == 'function') {
            matchesFn = fn;
            return true;
          }

          return false;
        });
        var parent; // traverse parents

        while (el) {
          parent = el.parentElement;

          if (parent && parent[matchesFn](selector)) {
            return parent;
          }

          el = parent;
        }
      } catch (error) {
        (function (error) {
          return error;
        });
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      if ((0, _Authentication.isSuperUser)()) {
        return _react["default"].createElement(_CustomScrollbars["default"], {
          className: "scrollbar",
          style: {
            height: 'calc(100vh - 70px)'
          }
        }, _react["default"].createElement("ul", {
          className: "nav-menu"
        }, _react["default"].createElement("li", {
          className: "nav-header"
        }, _react["default"].createElement(_IntlMessages["default"], {
          id: "sidebar.main"
        })), _react["default"].createElement(_SidenavSuperuserContent["default"], null), _react["default"].createElement(_SidenavDeveloperContent["default"], null), (0, _Authentication.getIdentityOrgId)() ? _react["default"].createElement(_SidenavAdminContent["default"], null) : null));
      } else if ((0, _Authentication.isAdmin)()) {
        return _react["default"].createElement(_CustomScrollbars["default"], {
          className: "scrollbar",
          style: {
            height: 'calc(100vh - 70px)'
          }
        }, _react["default"].createElement("ul", {
          className: "nav-menu"
        }, _react["default"].createElement("li", {
          className: "nav-header"
        }, _react["default"].createElement(_IntlMessages["default"], {
          id: "sidebar.main"
        })), _react["default"].createElement(_SidenavAdminContent["default"], null)));
      } else {
        // may be an admin user - they can get to their employee dashboard but will land on the org dashboard
        // otherwise it is a standard user - will default to the employee dashboard
        // only allow the option to go to the organisation dashboard if they have admin rights
        return _react["default"].createElement(_CustomScrollbars["default"], {
          className: "scrollbar",
          style: {
            height: 'calc(100vh - 70px)'
          }
        }, _react["default"].createElement("ul", {
          className: "nav-menu"
        }, _react["default"].createElement("li", {
          className: "nav-header"
        }, _react["default"].createElement(_IntlMessages["default"], {
          id: "sidebar.main"
        })), _react["default"].createElement("li", {
          className: "menu no-arrow"
        }, _react["default"].createElement(_reactRouterDom.NavLink, {
          to: "/app/emp-dashboard/default"
        }, _react["default"].createElement("i", {
          className: "zmdi zmdi-check-square zmdi-hc-fw"
        }), _react["default"].createElement("span", {
          className: "nav-text"
        }, _react["default"].createElement(_IntlMessages["default"], {
          id: "sidebar.agile.dashboard.employee"
        })))), (0, _Authentication.isAdmin)() ? _react["default"].createElement("li", {
          className: "menu no-arrow"
        }, _react["default"].createElement(_reactRouterDom.NavLink, {
          to: "/app/org-dashboard/default"
        }, _react["default"].createElement("i", {
          className: "zmdi zmdi-check-square zmdi-hc-fw"
        }), _react["default"].createElement("span", {
          className: "nav-text"
        }, _react["default"].createElement(_IntlMessages["default"], {
          id: "sidebar.agile.dashboard.organisation"
        })))) : null));
      }
    }
  }]);

  return SidenavContent;
}(_react.Component);

var _default = (0, _reactRouterDom.withRouter)(SidenavContent);

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SidenavContent, "SidenavContent", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavContent.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavContent.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavContent.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavContent.js");

  __REACT_HOT_LOADER__.register(_CustomScrollbars, "_CustomScrollbars", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavContent.js");

  __REACT_HOT_LOADER__.register(_SidenavDeveloperContent, "_SidenavDeveloperContent", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavContent.js");

  __REACT_HOT_LOADER__.register(_SidenavSuperuserContent, "_SidenavSuperuserContent", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavContent.js");

  __REACT_HOT_LOADER__.register(_SidenavAdminContent, "_SidenavAdminContent", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavContent.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavContent.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavContent.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavContent.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavContent.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavContent.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavContent.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavContent.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavContent.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavContent.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavContent.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavContent.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavContent.js");

  __REACT_HOT_LOADER__.register(SidenavContent, "SidenavContent", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavContent.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavContent.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavContent.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavContent.js");
}();

;

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRouterDom = __webpack_require__(13);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _this = void 0;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var SidenavDeveloperContent = function SidenavDeveloperContent() {
  return _react["default"].createElement("li", {
    className: "menu"
  }, _react["default"].createElement("a", {
    role: "button",
    href: "javascript:void(0)",
    onClick: function onClick(e) {
      return _this.linkClick(e);
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-view-dashboard zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.developer"
  }))), _react["default"].createElement("ul", {
    className: "sub-menu"
  }, _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/dashboard/default"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.dashboard.default"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/dashboard/eCommerce"
  }, _react["default"].createElement("span", {
    className: "nav-text text-transform-none"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.dashboard.ecommerce"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/dashboard/news"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.dashboard.news"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/dashboard/intranet"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.dashboard.intranet"
  })))), _react["default"].createElement("li", {
    className: "ui_tooltip menu"
  }, _react["default"].createElement("a", {
    role: "button",
    href: "javascript:void(0)",
    onClick: function onClick(e) {
      return _this.linkClick(e);
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-folder zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.components"
  }))), _react["default"].createElement("ul", {
    className: "sub-menu"
  }, _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/components/alerts"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.components.alerts"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/components/appbar"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.components.appbar"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/components/auto-complete"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.components.autocomplete"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/components/avatars"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.components.avatars"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/components/badges"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.components.badge"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/components/breadcrumbs"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.components.breadcrumbs"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/components/buttons"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.components.buttons"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/components/button-group"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.components.buttonGroup"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/components/cards"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.components.cards"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/components/carousel"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.components.carousel"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/components/color-picker"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.components.colorPicker"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/components/dividers"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.components.dividers"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/components/drawer"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.components.drawer"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/components/expansion-panel"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.components.expansionPanel"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/components/grid-list"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.components.gridList"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/components/list"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.components.lists"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/components/modals"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.components.modals"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/components/pickers"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.components.pickers"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/components/popovers"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.components.popovers"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/components/progressbar"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.components.progress"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/components/selection"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.components.selectionControl"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/components/selects"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.components.selects"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/components/tabs"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.components.tabs"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/components/text-fields"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.components.textFields"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/components/tooltips"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.components.tooltips"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/components/typography"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.components.typography"
  })))))), _react["default"].createElement("li", {
    className: "menu no-arrow"
  }, _react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/app/widgets"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-widgets zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.widgets"
  })))), _react["default"].createElement("li", {
    className: "menu no-arrow"
  }, _react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/app/metrics"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-trending-up zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.metrics"
  })))), _react["default"].createElement("li", {
    className: "menu"
  }, _react["default"].createElement("a", {
    role: "button",
    href: "javascript:void(0)",
    onClick: function onClick(e) {
      return _this.linkClick(e);
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-view-web zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.tables"
  }))), _react["default"].createElement("ul", {
    className: "sub-menu"
  }, _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/table/basic"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.tables.basicTable"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/table/data"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.tables.dataTable"
  })))))), _react["default"].createElement("li", {
    className: "timeline_tooltip menu"
  }, _react["default"].createElement("a", {
    role: "button",
    href: "javascript:void(0)",
    onClick: function onClick(e) {
      return _this.linkClick(e);
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-swap-alt zmdi-hc-fw zmdi-hc-rotate-90"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.timeLine"
  }))), _react["default"].createElement("ul", {
    className: "sub-menu"
  }, _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/time-line/default"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.timeLine.default"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/time-line/default-with-icon"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.timeLine.defaultwithIcons"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/time-line/left-align"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.timeLine.leftAligned"
  })))))), _react["default"].createElement("li", {
    className: "menu"
  }, _react["default"].createElement("a", {
    role: "button",
    href: "javascript:void(0)",
    onClick: function onClick(e) {
      return _this.linkClick(e);
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-view-list zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.customViews"
  }))), _react["default"].createElement("ul", {
    className: "sub-menu"
  }, _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/custom-views/simple-list"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.customViews.plainListView"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/custom-views/strip-list"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.customViews.withDivider"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/custom-views/card-list"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.customViews.cardListView"
  })))))), _react["default"].createElement("li", {
    className: "menu"
  }, _react["default"].createElement("a", {
    role: "button",
    href: "javascript:void(0)",
    onClick: function onClick(e) {
      return _this.linkClick(e);
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-book-image zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.forms"
  }))), _react["default"].createElement("ul", {
    className: "sub-menu"
  }, _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/form/components"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.forms.components"
  })))))), _react["default"].createElement("li", {
    className: "menu"
  }, _react["default"].createElement("a", {
    role: "button",
    href: "javascript:void(0)",
    onClick: function onClick(e) {
      return _this.linkClick(e);
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-code-setting zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.editors"
  }))), _react["default"].createElement("ul", {
    className: "sub-menu"
  }, _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/editor/ck"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.editors.CKEditor"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/editor/wysiswyg"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.editors.WYSISWYGEditor"
  })))))), _react["default"].createElement("li", {
    className: "menu"
  }, _react["default"].createElement("a", {
    role: "button",
    href: "javascript:void(0)",
    onClick: function onClick(e) {
      return _this.linkClick(e);
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-brush zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.pickers"
  }))), _react["default"].createElement("ul", {
    className: "sub-menu"
  }, _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/pickers/date-time"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.pickers.dateTimePickers"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/pickers/color"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.pickers.colorPickers"
  })))))), _react["default"].createElement("li", {
    className: "menu"
  }, _react["default"].createElement("a", {
    role: "button",
    href: "javascript:void(0)",
    onClick: function onClick(e) {
      return _this.linkClick(e);
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-key zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.extensions"
  }))), _react["default"].createElement("ul", {
    className: "sub-menu"
  }, _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/extensions/dnd"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.extensions.dragNDrop"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/extensions/dropzone"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.extensions.dropzone"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/extensions/sweet-alert"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.extensions.sweetAlert"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/extensions/notification"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.extensions.notification"
  })))))), _react["default"].createElement("li", {
    className: "menu"
  }, _react["default"].createElement("a", {
    role: "button",
    href: "javascript:void(0)",
    onClick: function onClick(e) {
      return _this.linkClick(e);
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-chart zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.chart"
  }))), _react["default"].createElement("ul", {
    className: "sub-menu"
  }, _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/chart/line"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.chart.line"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/chart/bar"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.chart.bar"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/chart/area"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.chart.area"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/chart/composed"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.chart.composed"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/chart/scatter"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.chart.scatter"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/chart/pie"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.chart.pie"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/chart/radial"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.chart.radial"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/chart/radar"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.chart.radar"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/chart/treemap"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.chart.tree"
  })))))), _react["default"].createElement("li", {
    className: "map_tooltip menu"
  }, _react["default"].createElement("a", {
    role: "button",
    href: "javascript:void(0)",
    onClick: function onClick(e) {
      return _this.linkClick(e);
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-google-maps zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.map"
  }))), _react["default"].createElement("ul", {
    className: "sub-menu"
  }, _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/map/simple"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.map.simple"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/map/styled"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.map.styled"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/map/geo-location"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.map.geoLocation"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/map/directions"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.map.mapDirection"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/map/overlay"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.map.overlay"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/map/kml"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.map.kmLayer"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/map/popup-info"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.map.popupInfo"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/map/traffic"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.map.trafficLayer"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/map/street-view"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.map.streetView"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/map/event"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.map.eventListener"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/map/drawing"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.map.mapDrawing"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/map/clustering"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.map.mapClustering"
  })))))), _react["default"].createElement("li", {
    className: "menu"
  }, _react["default"].createElement("a", {
    role: "button",
    href: "javascript:void(0)",
    onClick: function onClick(e) {
      return _this.linkClick(e);
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-calendar zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.calendar"
  }))), _react["default"].createElement("ul", {
    className: "sub-menu"
  }, _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/calendar/basic"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.calendar.basic"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/calendar/cultures"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.calendar.cultures"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/calendar/dnd"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.calendar.dnd"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/calendar/popup"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.calendar.popup"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/calendar/rendering"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.calendar.rendering"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/calendar/selectable"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.calendar.selectable"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/calendar/timeslots"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.calendar.timeslots"
  })))))), _react["default"].createElement("li", {
    className: "menu"
  }, _react["default"].createElement("a", {
    role: "button",
    href: "javascript:void(0)",
    onClick: function onClick(e) {
      return _this.linkClick(e);
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-shopping-cart zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text text-transform-none"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.eCommerce"
  }))), _react["default"].createElement("ul", {
    className: "sub-menu"
  }, _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/ecommerce/products-list"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.eCommerce.productsList"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/ecommerce/products-grid"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.eCommerce.productsGrid"
  })))))), _react["default"].createElement("li", {
    className: "menu"
  }, _react["default"].createElement("a", {
    role: "button",
    href: "javascript:void(0)",
    onClick: function onClick(e) {
      return _this.linkClick(e);
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-collection-item-8 zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.appModule"
  }))), _react["default"].createElement("ul", {
    className: "sub-menu"
  }, _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/app-module/login"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.appModule.login"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/app-module/sign-up"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.appModule.signup"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/app-module/forgot-password"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.appModule.forgotPassword"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/app-module/lock-screen"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.appModule.lock"
  })))))), _react["default"].createElement("li", {
    className: "menu no-arrow"
  }, _react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/app/to-do"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-check-square zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.appModule.toDo"
  })))), _react["default"].createElement("li", {
    className: "menu no-arrow"
  }, _react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/app/to-do-redux"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-check-square zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.appModule.toDoRedux"
  })))), _react["default"].createElement("li", {
    className: "menu no-arrow"
  }, _react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/app/mail"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-email zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.appModule.mail"
  })))), _react["default"].createElement("li", {
    className: "menu no-arrow"
  }, _react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/app/mail-redux"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-email zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.appModule.mailRedux"
  })))), _react["default"].createElement("li", {
    className: "menu no-arrow"
  }, _react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/app/chat"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-comment zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.appModule.chat"
  })))), _react["default"].createElement("li", {
    className: "menu no-arrow"
  }, _react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/app/chat-redux"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-comment zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.appModule.chatRedux"
  })))), _react["default"].createElement("li", {
    className: "menu no-arrow"
  }, _react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/app/contact"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-account-box zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.appModule.contact"
  })))), _react["default"].createElement("li", {
    className: "menu no-arrow"
  }, _react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/app/contact-redux"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-account-box zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.appModule.contactRedux"
  })))), _react["default"].createElement("li", {
    className: "menu"
  }, _react["default"].createElement("a", {
    role: "button",
    href: "javascript:void(0)",
    onClick: function onClick(e) {
      return _this.linkClick(e);
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-view-web zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.icons"
  }))), _react["default"].createElement("ul", {
    className: "sub-menu"
  }, _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/icons/material"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.icons.material"
  })))))), _react["default"].createElement("li", {
    className: "menu"
  }, _react["default"].createElement("a", {
    role: "button",
    href: "javascript:void(0)",
    onClick: function onClick(e) {
      return _this.linkClick(e);
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-collection-bookmark zmdi-hc-fw zmdi-hc-rotate-90"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.extraElements"
  }))), _react["default"].createElement("ul", {
    className: "sub-menu"
  }, _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/extra-elements/pricing-table"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.extraElements.pricingTable"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/extra-elements/callouts"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.extraElements.callouts"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/extra-elements/testimonials"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.extraElements.testimonials"
  })))))), _react["default"].createElement("li", {
    className: "menu"
  }, _react["default"].createElement("a", {
    role: "button",
    href: "javascript:void(0)",
    onClick: function onClick(e) {
      return _this.linkClick(e);
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-pages zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.extraPages"
  }))), _react["default"].createElement("ul", {
    className: "sub-menu"
  }, _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/extra-pages/about-us"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.extraPages.aboutUs"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/extra-pages/contact-us"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.extraPages.contactUs"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/extra-pages/blog"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.extraPages.blog"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/extra-pages/faq"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.extraPages.faq"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/extra-pages/portfolio"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.extraPages.portfolio"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/extra-pages/error-404"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.extraPages.404"
  })))), _react["default"].createElement("li", null, _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "prepend-icon",
    to: "/app/extra-pages/error-500"
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.extraPages.500"
  })))))), _react["default"].createElement("li", {
    className: "menu"
  }, _react["default"].createElement("a", {
    role: "button",
    href: "javascript:void(0)",
    onClick: function onClick(e) {
      return _this.linkClick(e);
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-device-hub zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.menuLevels"
  }))), _react["default"].createElement("ul", {
    className: "sub-menu"
  }, _react["default"].createElement("li", null, _react["default"].createElement("a", {
    role: "button",
    className: "prepend-icon",
    href: "javascript:void(0)",
    onClick: function onClick(e) {
      return _this.linkClick(e);
    }
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.menuLevels.level1"
  })))), _react["default"].createElement("li", {
    className: "menu"
  }, _react["default"].createElement("a", {
    role: "button",
    className: "prepend-icon",
    href: "javascript:void(0)",
    onClick: function onClick(e) {
      return _this.linkClick(e);
    }
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.menuLevels.level1"
  }))), _react["default"].createElement("ul", {
    className: "sub-menu"
  }, _react["default"].createElement("li", null, _react["default"].createElement("a", {
    role: "button",
    href: "javascript:void(0)",
    onClick: function onClick(e) {
      return _this.linkClick(e);
    }
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.menuLevels.level2"
  })))), _react["default"].createElement("li", {
    className: "menu"
  }, _react["default"].createElement("a", {
    role: "button",
    href: "javascript:void(0)",
    onClick: function onClick(e) {
      return _this.linkClick(e);
    }
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.menuLevels.level2"
  }))), _react["default"].createElement("ul", {
    className: "sub-menu"
  }, _react["default"].createElement("li", null, _react["default"].createElement("a", {
    role: "button",
    href: "javascript:void(0)",
    onClick: function onClick(e) {
      return _this.linkClick(e);
    }
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.menuLevels.level3"
  })))), _react["default"].createElement("li", null, _react["default"].createElement("a", {
    role: "button",
    href: "javascript:void(0)",
    onClick: function onClick(e) {
      return _this.linkClick(e);
    }
  }, _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.menuLevels.level3"
  }))))))))))));
};

var _default = SidenavDeveloperContent;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SidenavDeveloperContent, "SidenavDeveloperContent", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavDeveloperContent.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavDeveloperContent.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavDeveloperContent.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavDeveloperContent.js");

  __REACT_HOT_LOADER__.register(_this, "_this", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavDeveloperContent.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavDeveloperContent.js");

  __REACT_HOT_LOADER__.register(SidenavDeveloperContent, "SidenavDeveloperContent", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavDeveloperContent.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavDeveloperContent.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavDeveloperContent.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavDeveloperContent.js");
}();

;

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRouterDom = __webpack_require__(13);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var SidenavSuperuserContent = function SidenavSuperuserContent() {
  return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("li", {
    className: "menu no-arrow"
  }, _react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/app/agile-dashboard/default"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-check-square zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.agile.dashboard"
  })))), _react["default"].createElement("li", {
    className: "menu no-arrow"
  }, _react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/app/organisation/default"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-view-dashboard zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.organisations"
  })))), _react["default"].createElement("li", {
    className: "menu no-arrow"
  }, _react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/app/survey-group/default"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-view-dashboard zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.surveyGroup"
  })))));
};

var _default = SidenavSuperuserContent;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SidenavSuperuserContent, "SidenavSuperuserContent", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavSuperuserContent.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavSuperuserContent.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavSuperuserContent.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavSuperuserContent.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavSuperuserContent.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavSuperuserContent.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavSuperuserContent.js");

  __REACT_HOT_LOADER__.register(SidenavSuperuserContent, "SidenavSuperuserContent", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavSuperuserContent.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavSuperuserContent.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavSuperuserContent.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavSuperuserContent.js");
}();

;

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRouterDom = __webpack_require__(13);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _this = void 0;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var SidenavAdminContent = function SidenavAdminContent() {
  return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("li", {
    className: "menu"
  }, _react["default"].createElement("a", {
    role: "button",
    href: "javascript:void(0)",
    onClick: function onClick(e) {
      return _this.linkClick(e);
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-menu zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.agile.dashboards"
  }))), _react["default"].createElement("ul", {
    className: "sub-menu"
  }, _react["default"].createElement("li", {
    className: "menu no-arrow"
  }, _react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/app/org-dashboard/default"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-check-square zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.agile.dashboard"
  })))), _react["default"].createElement("li", {
    className: "menu no-arrow"
  }, _react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/app/emp-dashboard/default"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-check-square zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.agile.dashboard.employee"
  })))))), _react["default"].createElement("li", {
    className: "menu no-arrow"
  }, _react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/app/employee/default"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-account-o zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "orgDashboard.employees"
  })))), _react["default"].createElement("li", {
    className: "menu no-arrow"
  }, _react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/app/portfolio/default"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-view-dashboard zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.portfolios"
  })))), _react["default"].createElement("li", {
    className: "menu no-arrow"
  }, _react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/app/valueStream/default"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-view-dashboard zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.valueStreams"
  })))), _react["default"].createElement("li", {
    className: "menu no-arrow"
  }, _react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/app/product/default"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-view-dashboard zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.products"
  })))), _react["default"].createElement("li", {
    className: "menu no-arrow"
  }, _react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/app/initiative/default"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-view-dashboard zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.initiatives"
  })))), _react["default"].createElement("li", {
    className: "menu no-arrow"
  }, _react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/app/feature/default"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-view-dashboard zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.features"
  })))), _react["default"].createElement("li", {
    className: "menu"
  }, _react["default"].createElement("a", {
    role: "button",
    href: "javascript:void(0)",
    onClick: function onClick(e) {
      return _this.linkClick(e);
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-menu zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "orgDashboard.projects"
  }))), _react["default"].createElement("ul", {
    className: "sub-menu"
  }, _react["default"].createElement("li", {
    className: "menu no-arrow"
  }, _react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/app/project/default"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-storage zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "orgDashboard.projects"
  })))), _react["default"].createElement("li", {
    className: "menu no-arrow"
  }, _react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/app/projectBusPriority/default"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-view-dashboard zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.projectBusPrioritys"
  })))), _react["default"].createElement("li", {
    className: "menu no-arrow"
  }, _react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/app/projectCostPriority/default"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-view-dashboard zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.projectCostPrioritys"
  })))))), _react["default"].createElement("li", {
    className: "menu no-arrow"
  }, _react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/app/issue/default"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-view-dashboard zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.issues"
  })))), _react["default"].createElement("li", {
    className: "menu"
  }, _react["default"].createElement("a", {
    role: "button",
    href: "javascript:void(0)",
    onClick: function onClick(e) {
      return _this.linkClick(e);
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-menu zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.teams"
  }))), _react["default"].createElement("ul", {
    className: "sub-menu"
  }, _react["default"].createElement("li", {
    className: "menu no-arrow"
  }, _react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/app/team/default"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-view-dashboard zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.teams"
  })))), _react["default"].createElement("li", {
    className: "menu no-arrow"
  }, _react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/app/member/default"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-view-dashboard zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.members"
  })))))), _react["default"].createElement("li", {
    className: "menu"
  }, _react["default"].createElement("a", {
    role: "button",
    href: "javascript:void(0)",
    onClick: function onClick(e) {
      return _this.linkClick(e);
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-menu zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.lookups"
  }))), _react["default"].createElement("ul", {
    className: "sub-menu"
  }, _react["default"].createElement("li", {
    className: "menu no-arrow"
  }, _react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/app/security/default"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-view-dashboard zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.securitys"
  })))), _react["default"].createElement("li", {
    className: "menu no-arrow"
  }, _react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/app/businessUnit/default"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-view-dashboard zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "sidebar.businessUnits"
  })))))), _react["default"].createElement("li", {
    className: "menu"
  }, _react["default"].createElement("a", {
    role: "button",
    href: "javascript:void(0)",
    onClick: function onClick(e) {
      return _this.linkClick(e);
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-menu zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "orgDashboard.surveys"
  }))), _react["default"].createElement("ul", {
    className: "sub-menu"
  }, _react["default"].createElement("li", {
    className: "menu no-arrow"
  }, _react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/app/org-survey/default"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-chart zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "orgDashboard.surveys"
  })))), _react["default"].createElement("li", {
    className: "menu no-arrow"
  }, _react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/app/org-survey-compare/default"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-chart zmdi-hc-fw"
  }), _react["default"].createElement("span", {
    className: "nav-text"
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "orgDashboard.compareSurveys"
  })))))));
};

var _default = SidenavAdminContent;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SidenavAdminContent, "SidenavAdminContent", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavAdminContent.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavAdminContent.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavAdminContent.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavAdminContent.js");

  __REACT_HOT_LOADER__.register(_this, "_this", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavAdminContent.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavAdminContent.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavAdminContent.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavAdminContent.js");

  __REACT_HOT_LOADER__.register(SidenavAdminContent, "SidenavAdminContent", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavAdminContent.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavAdminContent.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavAdminContent.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SideNav/SidenavAdminContent.js");
}();

;

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _ActionTypes = __webpack_require__(7);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var SidenavLogo = function SidenavLogo(_ref) {
  var drawerType = _ref.drawerType;
  var showMini = drawerType.includes(_ActionTypes.MINI_DRAWER);
  return _react["default"].createElement("div", {
    className: "sidebar-header d-flex align-items-center"
  }, showMini ? _react["default"].createElement("div", {
    className: "mini-logo"
  }, _react["default"].createElement("img", {
    className: "mini-logo-img",
    alt: "...",
    src: "http://via.placeholder.com/32x32"
  }), _react["default"].createElement("img", {
    className: "mini-logo-img-hover",
    alt: "...",
    src: "http://via.placeholder.com/105x36"
  })) : _react["default"].createElement("img", {
    alt: "...",
    src: "http://via.placeholder.com/105x36"
  }));
};

var _default = SidenavLogo;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SidenavLogo, "SidenavLogo", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/SidenavLogo/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/SidenavLogo/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/SidenavLogo/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/SidenavLogo/index.js");

  __REACT_HOT_LOADER__.register(SidenavLogo, "SidenavLogo", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/SidenavLogo/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/SidenavLogo/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/SidenavLogo/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/SidenavLogo/index.js");
}();

;

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Footer = function Footer() {
  return _react["default"].createElement("footer", {
    className: "app-footer"
  }, _react["default"].createElement("div", {
    className: "d-flex flex-row justify-content-between"
  }, _react["default"].createElement("div", null, _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
    id: "general.company.name"
  }), " \xA9")), _react["default"].createElement("div", null, _react["default"].createElement(_reactstrap.Button, {
    color: "link" // href="https://firebase.google.com/docs/firestore"
    ,
    href: "http://clientplussolutions.com.au",
    target: "_blank",
    size: "sm",
    className: "text-uppercase"
  }, "CPS"))));
};

var _default = Footer;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Footer, "Footer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Footer/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Footer/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Footer/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Footer/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Footer/index.js");

  __REACT_HOT_LOADER__.register(Footer, "Footer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Footer/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Footer/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Footer/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Footer/index.js");
}();

;

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRouterDom = __webpack_require__(13);

var _asyncComponent = _interopRequireDefault(__webpack_require__(44));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Dashboard = function Dashboard(_ref) {
  var match = _ref.match;
  return _react["default"].createElement("div", {
    className: "app-wrapper"
  }, _react["default"].createElement(_reactRouterDom.Switch, null, _react["default"].createElement(_reactRouterDom.Redirect, {
    exact: true,
    from: "".concat(match.url, "/"),
    to: "".concat(match.url, "/default")
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/default"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1998));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/eCommerce"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1999));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/news"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 2000));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/intranet"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 2001));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 39));
    })
  })));
};

var _default = Dashboard;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Dashboard, "Dashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/index.js");

  __REACT_HOT_LOADER__.register(_asyncComponent, "_asyncComponent", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/index.js");

  __REACT_HOT_LOADER__.register(Dashboard, "Dashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/dashboard/index.js");
}();

;

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* NProgress, (c) 2013, 2014 Rico Sta. Cruz - http://ricostacruz.com/nprogress
 * @license MIT */

;(function(root, factory) {

  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    module.exports = factory();
  } else {
    root.NProgress = factory();
  }

})(this, function() {
  var NProgress = {};

  NProgress.version = '0.2.0';

  var Settings = NProgress.settings = {
    minimum: 0.08,
    easing: 'ease',
    positionUsing: '',
    speed: 200,
    trickle: true,
    trickleRate: 0.02,
    trickleSpeed: 800,
    showSpinner: true,
    barSelector: '[role="bar"]',
    spinnerSelector: '[role="spinner"]',
    parent: 'body',
    template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
  };

  /**
   * Updates configuration.
   *
   *     NProgress.configure({
   *       minimum: 0.1
   *     });
   */
  NProgress.configure = function(options) {
    var key, value;
    for (key in options) {
      value = options[key];
      if (value !== undefined && options.hasOwnProperty(key)) Settings[key] = value;
    }

    return this;
  };

  /**
   * Last number.
   */

  NProgress.status = null;

  /**
   * Sets the progress bar status, where `n` is a number from `0.0` to `1.0`.
   *
   *     NProgress.set(0.4);
   *     NProgress.set(1.0);
   */

  NProgress.set = function(n) {
    var started = NProgress.isStarted();

    n = clamp(n, Settings.minimum, 1);
    NProgress.status = (n === 1 ? null : n);

    var progress = NProgress.render(!started),
        bar      = progress.querySelector(Settings.barSelector),
        speed    = Settings.speed,
        ease     = Settings.easing;

    progress.offsetWidth; /* Repaint */

    queue(function(next) {
      // Set positionUsing if it hasn't already been set
      if (Settings.positionUsing === '') Settings.positionUsing = NProgress.getPositioningCSS();

      // Add transition
      css(bar, barPositionCSS(n, speed, ease));

      if (n === 1) {
        // Fade out
        css(progress, { 
          transition: 'none', 
          opacity: 1 
        });
        progress.offsetWidth; /* Repaint */

        setTimeout(function() {
          css(progress, { 
            transition: 'all ' + speed + 'ms linear', 
            opacity: 0 
          });
          setTimeout(function() {
            NProgress.remove();
            next();
          }, speed);
        }, speed);
      } else {
        setTimeout(next, speed);
      }
    });

    return this;
  };

  NProgress.isStarted = function() {
    return typeof NProgress.status === 'number';
  };

  /**
   * Shows the progress bar.
   * This is the same as setting the status to 0%, except that it doesn't go backwards.
   *
   *     NProgress.start();
   *
   */
  NProgress.start = function() {
    if (!NProgress.status) NProgress.set(0);

    var work = function() {
      setTimeout(function() {
        if (!NProgress.status) return;
        NProgress.trickle();
        work();
      }, Settings.trickleSpeed);
    };

    if (Settings.trickle) work();

    return this;
  };

  /**
   * Hides the progress bar.
   * This is the *sort of* the same as setting the status to 100%, with the
   * difference being `done()` makes some placebo effect of some realistic motion.
   *
   *     NProgress.done();
   *
   * If `true` is passed, it will show the progress bar even if its hidden.
   *
   *     NProgress.done(true);
   */

  NProgress.done = function(force) {
    if (!force && !NProgress.status) return this;

    return NProgress.inc(0.3 + 0.5 * Math.random()).set(1);
  };

  /**
   * Increments by a random amount.
   */

  NProgress.inc = function(amount) {
    var n = NProgress.status;

    if (!n) {
      return NProgress.start();
    } else {
      if (typeof amount !== 'number') {
        amount = (1 - n) * clamp(Math.random() * n, 0.1, 0.95);
      }

      n = clamp(n + amount, 0, 0.994);
      return NProgress.set(n);
    }
  };

  NProgress.trickle = function() {
    return NProgress.inc(Math.random() * Settings.trickleRate);
  };

  /**
   * Waits for all supplied jQuery promises and
   * increases the progress as the promises resolve.
   *
   * @param $promise jQUery Promise
   */
  (function() {
    var initial = 0, current = 0;

    NProgress.promise = function($promise) {
      if (!$promise || $promise.state() === "resolved") {
        return this;
      }

      if (current === 0) {
        NProgress.start();
      }

      initial++;
      current++;

      $promise.always(function() {
        current--;
        if (current === 0) {
            initial = 0;
            NProgress.done();
        } else {
            NProgress.set((initial - current) / initial);
        }
      });

      return this;
    };

  })();

  /**
   * (Internal) renders the progress bar markup based on the `template`
   * setting.
   */

  NProgress.render = function(fromStart) {
    if (NProgress.isRendered()) return document.getElementById('nprogress');

    addClass(document.documentElement, 'nprogress-busy');
    
    var progress = document.createElement('div');
    progress.id = 'nprogress';
    progress.innerHTML = Settings.template;

    var bar      = progress.querySelector(Settings.barSelector),
        perc     = fromStart ? '-100' : toBarPerc(NProgress.status || 0),
        parent   = document.querySelector(Settings.parent),
        spinner;
    
    css(bar, {
      transition: 'all 0 linear',
      transform: 'translate3d(' + perc + '%,0,0)'
    });

    if (!Settings.showSpinner) {
      spinner = progress.querySelector(Settings.spinnerSelector);
      spinner && removeElement(spinner);
    }

    if (parent != document.body) {
      addClass(parent, 'nprogress-custom-parent');
    }

    parent.appendChild(progress);
    return progress;
  };

  /**
   * Removes the element. Opposite of render().
   */

  NProgress.remove = function() {
    removeClass(document.documentElement, 'nprogress-busy');
    removeClass(document.querySelector(Settings.parent), 'nprogress-custom-parent');
    var progress = document.getElementById('nprogress');
    progress && removeElement(progress);
  };

  /**
   * Checks if the progress bar is rendered.
   */

  NProgress.isRendered = function() {
    return !!document.getElementById('nprogress');
  };

  /**
   * Determine which positioning CSS rule to use.
   */

  NProgress.getPositioningCSS = function() {
    // Sniff on document.body.style
    var bodyStyle = document.body.style;

    // Sniff prefixes
    var vendorPrefix = ('WebkitTransform' in bodyStyle) ? 'Webkit' :
                       ('MozTransform' in bodyStyle) ? 'Moz' :
                       ('msTransform' in bodyStyle) ? 'ms' :
                       ('OTransform' in bodyStyle) ? 'O' : '';

    if (vendorPrefix + 'Perspective' in bodyStyle) {
      // Modern browsers with 3D support, e.g. Webkit, IE10
      return 'translate3d';
    } else if (vendorPrefix + 'Transform' in bodyStyle) {
      // Browsers without 3D support, e.g. IE9
      return 'translate';
    } else {
      // Browsers without translate() support, e.g. IE7-8
      return 'margin';
    }
  };

  /**
   * Helpers
   */

  function clamp(n, min, max) {
    if (n < min) return min;
    if (n > max) return max;
    return n;
  }

  /**
   * (Internal) converts a percentage (`0..1`) to a bar translateX
   * percentage (`-100%..0%`).
   */

  function toBarPerc(n) {
    return (-1 + n) * 100;
  }


  /**
   * (Internal) returns the correct CSS for changing the bar's
   * position given an n percentage, and speed and ease from Settings
   */

  function barPositionCSS(n, speed, ease) {
    var barCSS;

    if (Settings.positionUsing === 'translate3d') {
      barCSS = { transform: 'translate3d('+toBarPerc(n)+'%,0,0)' };
    } else if (Settings.positionUsing === 'translate') {
      barCSS = { transform: 'translate('+toBarPerc(n)+'%,0)' };
    } else {
      barCSS = { 'margin-left': toBarPerc(n)+'%' };
    }

    barCSS.transition = 'all '+speed+'ms '+ease;

    return barCSS;
  }

  /**
   * (Internal) Queues a function to be executed.
   */

  var queue = (function() {
    var pending = [];
    
    function next() {
      var fn = pending.shift();
      if (fn) {
        fn(next);
      }
    }

    return function(fn) {
      pending.push(fn);
      if (pending.length == 1) next();
    };
  })();

  /**
   * (Internal) Applies css properties to an element, similar to the jQuery 
   * css method.
   *
   * While this helper does assist with vendor prefixed property names, it 
   * does not perform any manipulation of values prior to setting styles.
   */

  var css = (function() {
    var cssPrefixes = [ 'Webkit', 'O', 'Moz', 'ms' ],
        cssProps    = {};

    function camelCase(string) {
      return string.replace(/^-ms-/, 'ms-').replace(/-([\da-z])/gi, function(match, letter) {
        return letter.toUpperCase();
      });
    }

    function getVendorProp(name) {
      var style = document.body.style;
      if (name in style) return name;

      var i = cssPrefixes.length,
          capName = name.charAt(0).toUpperCase() + name.slice(1),
          vendorName;
      while (i--) {
        vendorName = cssPrefixes[i] + capName;
        if (vendorName in style) return vendorName;
      }

      return name;
    }

    function getStyleProp(name) {
      name = camelCase(name);
      return cssProps[name] || (cssProps[name] = getVendorProp(name));
    }

    function applyCss(element, prop, value) {
      prop = getStyleProp(prop);
      element.style[prop] = value;
    }

    return function(element, properties) {
      var args = arguments,
          prop, 
          value;

      if (args.length == 2) {
        for (prop in properties) {
          value = properties[prop];
          if (value !== undefined && properties.hasOwnProperty(prop)) applyCss(element, prop, value);
        }
      } else {
        applyCss(element, args[1], args[2]);
      }
    }
  })();

  /**
   * (Internal) Determines if an element or space separated list of class names contains a class name.
   */

  function hasClass(element, name) {
    var list = typeof element == 'string' ? element : classList(element);
    return list.indexOf(' ' + name + ' ') >= 0;
  }

  /**
   * (Internal) Adds a class to an element.
   */

  function addClass(element, name) {
    var oldList = classList(element),
        newList = oldList + name;

    if (hasClass(oldList, name)) return; 

    // Trim the opening space.
    element.className = newList.substring(1);
  }

  /**
   * (Internal) Removes a class from an element.
   */

  function removeClass(element, name) {
    var oldList = classList(element),
        newList;

    if (!hasClass(element, name)) return;

    // Replace the class name.
    newList = oldList.replace(' ' + name + ' ', ' ');

    // Trim the opening and closing spaces.
    element.className = newList.substring(1, newList.length - 1);
  }

  /**
   * (Internal) Gets a space separated list of the class names on the element. 
   * The list is wrapped with a single space on each end to facilitate finding 
   * matches within the list.
   */

  function classList(element) {
    return (' ' + (element.className || '') + ' ').replace(/\s+/gi, ' ');
  }

  /**
   * (Internal) Removes an element from the DOM.
   */

  function removeElement(element) {
    element && element.parentNode && element.parentNode.removeChild(element);
  }

  return NProgress;
});



/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _ReactPlaceholder = __webpack_require__(1490);

var _ReactPlaceholder2 = _interopRequireDefault(_ReactPlaceholder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ReactPlaceholder2.default;

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _placeholders = __webpack_require__(1491);

var placeholders = _interopRequireWildcard(_placeholders);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReactPlaceholder = (_temp2 = _class = function (_React$Component) {
  _inherits(ReactPlaceholder, _React$Component);

  function ReactPlaceholder() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReactPlaceholder);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactPlaceholder.__proto__ || Object.getPrototypeOf(ReactPlaceholder)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      ready: _this.props.ready
    }, _this.getFiller = function () {
      var _this$props = _this.props,
          firstLaunchOnly = _this$props.firstLaunchOnly,
          children = _this$props.children,
          ready = _this$props.ready,
          className = _this$props.className,
          type = _this$props.type,
          customPlaceholder = _this$props.customPlaceholder,
          showLoadingAnimation = _this$props.showLoadingAnimation,
          rest = _objectWithoutProperties(_this$props, ['firstLaunchOnly', 'children', 'ready', 'className', 'type', 'customPlaceholder', 'showLoadingAnimation']);

      var classes = showLoadingAnimation ? ['show-loading-animation', className].filter(function (c) {
        return c;
      }).join(' ') : className;

      if (customPlaceholder && _react2.default.isValidElement(customPlaceholder)) {
        var mergedCustomClasses = [customPlaceholder.props.className, classes].filter(function (c) {
          return c;
        }).join(' ');
        return _react2.default.cloneElement(customPlaceholder, { className: mergedCustomClasses });
      } else if (customPlaceholder) {
        return customPlaceholder;
      }

      var Placeholder = placeholders[type];

      return _react2.default.createElement(Placeholder, _extends({}, rest, { className: classes }));
    }, _this.setNotReady = function () {
      var delay = _this.props.delay;


      if (delay > 0) {
        _this.timeout = setTimeout(function () {
          _this.setState({ ready: false });
        }, delay);
      } else {
        _this.setState({ ready: false });
      }
    }, _this.setReady = function () {
      if (_this.timeout) {
        clearTimeout(_this.timeout);
      }

      if (!_this.state.ready) {
        _this.setState({ ready: true });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReactPlaceholder, [{
    key: 'render',
    value: function render() {
      return this.state.ready ? this.props.children : this.getFiller();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.firstLaunchOnly && this.state.ready && !nextProps.ready) {
        this.setNotReady();
      } else if (nextProps.ready) {
        this.setReady();
      }
    }
  }]);

  return ReactPlaceholder;
}(_react2.default.Component), _class.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.element]).isRequired,
  delay: _propTypes2.default.number,
  ready: _propTypes2.default.bool.isRequired,
  firstLaunchOnly: _propTypes2.default.bool,
  type: _propTypes2.default.oneOf(['text', 'media', 'textRow', 'rect', 'round']),
  rows: _propTypes2.default.number,
  color: _propTypes2.default.string,
  showLoadingAnimation: _propTypes2.default.bool,
  customPlaceholder: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.element])
}, _class.defaultProps = {
  delay: 0,
  type: 'text',
  color: '#CDCDCD'
}, _temp2);
exports.default = ReactPlaceholder;

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.media = exports.text = exports.rect = exports.round = exports.textRow = exports.MediaBlock = exports.TextBlock = exports.RectShape = exports.RoundShape = exports.TextRow = undefined;

var _TextRow2 = __webpack_require__(698);

var _TextRow3 = _interopRequireDefault(_TextRow2);

var _RoundShape2 = __webpack_require__(699);

var _RoundShape3 = _interopRequireDefault(_RoundShape2);

var _RectShape2 = __webpack_require__(1492);

var _RectShape3 = _interopRequireDefault(_RectShape2);

var _TextBlock2 = __webpack_require__(700);

var _TextBlock3 = _interopRequireDefault(_TextBlock2);

var _MediaBlock2 = __webpack_require__(1493);

var _MediaBlock3 = _interopRequireDefault(_MediaBlock2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.TextRow = _TextRow3.default;
// import Card from 'Card';

exports.RoundShape = _RoundShape3.default;
exports.RectShape = _RectShape3.default;
exports.TextBlock = _TextBlock3.default;
exports.MediaBlock = _MediaBlock3.default;
var textRow = exports.textRow = _TextRow3.default;
var round = exports.round = _RoundShape3.default;
var rect = exports.rect = _RectShape3.default;
var text = exports.text = _TextBlock3.default;
var media = exports.media = _MediaBlock3.default;

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RectShape = (_temp = _class = function (_React$Component) {
  _inherits(RectShape, _React$Component);

  function RectShape() {
    _classCallCheck(this, RectShape);

    return _possibleConstructorReturn(this, (RectShape.__proto__ || Object.getPrototypeOf(RectShape)).apply(this, arguments));
  }

  _createClass(RectShape, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          style = _props.style,
          color = _props.color;


      var defaultStyle = {
        backgroundColor: color,
        width: '100%',
        height: '100%',
        marginRight: 10
      };

      var classes = ['rect-shape', className].filter(function (c) {
        return c;
      }).join(' ');

      return _react2.default.createElement('div', { className: classes, style: _extends({}, defaultStyle, style) });
    }
  }]);

  return RectShape;
}(_react2.default.Component), _class.propTypes = {
  color: _propTypes2.default.string,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object
}, _temp);
exports.default = RectShape;

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TextBlock = __webpack_require__(700);

var _TextBlock2 = _interopRequireDefault(_TextBlock);

var _RoundShape = __webpack_require__(699);

var _RoundShape2 = _interopRequireDefault(_RoundShape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MediaBlock = (_temp = _class = function (_React$Component) {
  _inherits(MediaBlock, _React$Component);

  function MediaBlock() {
    _classCallCheck(this, MediaBlock);

    return _possibleConstructorReturn(this, (MediaBlock.__proto__ || Object.getPrototypeOf(MediaBlock)).apply(this, arguments));
  }

  _createClass(MediaBlock, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          style = _props.style,
          color = _props.color,
          rows = _props.rows;


      var classes = ['media-block', className].filter(function (c) {
        return c;
      }).join(' ');

      return _react2.default.createElement(
        'div',
        { className: classes, style: _extends({}, style, { display: 'flex' }) },
        _react2.default.createElement(_RoundShape2.default, {
          color: color,
          style: { minHeight: 55, width: 55, minWidth: 55, marginRight: 10 }
        }),
        _react2.default.createElement(_TextBlock2.default, { color: color, rows: rows })
      );
    }
  }]);

  return MediaBlock;
}(_react2.default.Component), _class.propTypes = {
  rows: _propTypes2.default.number.isRequired,
  color: _propTypes2.default.string.isRequired,
  style: _propTypes2.default.object,
  className: _propTypes2.default.string
}, _temp);
exports.default = MediaBlock;

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1495);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(65)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../css-loader/index.js!./nprogress.css", function() {
			var newContent = require("!!../css-loader/index.js!./nprogress.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(64)(false);
// imports


// module
exports.push([module.i, "#nprogress{pointer-events:none}#nprogress .bar{background:#29d;position:fixed;z-index:1031;top:0;left:0;width:100%;height:2px}#nprogress .peg{display:block;position:absolute;right:0;width:100px;height:100%;box-shadow:0 0 10px #29d,0 0 5px #29d;opacity:1;-webkit-transform:rotate(3deg) translateY(-4px);-ms-transform:rotate(3deg) translateY(-4px);transform:rotate(3deg) translateY(-4px)}#nprogress .spinner{display:block;position:fixed;z-index:1031;top:15px;right:15px}#nprogress .spinner-icon{width:18px;height:18px;box-sizing:border-box;border:2px solid transparent;border-top-color:#29d;border-left-color:#29d;border-radius:50%;-webkit-animation:nprogress-spinner .4s linear infinite;animation:nprogress-spinner .4s linear infinite}.nprogress-custom-parent{overflow:hidden;position:relative}.nprogress-custom-parent #nprogress .bar,.nprogress-custom-parent #nprogress .spinner{position:absolute}@-webkit-keyframes nprogress-spinner{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(1turn)}}@keyframes nprogress-spinner{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);

// exports


/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1497);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(65)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js!./reactPlaceholder.css", function() {
			var newContent = require("!!../../css-loader/index.js!./reactPlaceholder.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(64)(false);
// imports


// module
exports.push([module.i, ".show-loading-animation.rect-shape,.show-loading-animation .rect-shape,.show-loading-animation.round-shape,.show-loading-animation .round-shape,.show-loading-animation.text-row,.show-loading-animation .text-row{animation:react-placeholder-pulse 1.5s infinite}@keyframes react-placeholder-pulse{0%{opacity:.6}50%{opacity:1}to{opacity:.6}}", ""]);

// exports


/***/ }),
/* 1498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_es6_math__ = __webpack_require__(1499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_es6_math___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_es6_math__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_es6_number__ = __webpack_require__(1521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_es6_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_es6_number__);


/* eslint no-proto: 0 */

var testObject = {};

if (!(Object.setPrototypeOf || testObject.__proto__)) {
  var nativeGetPrototypeOf = Object.getPrototypeOf;

  Object.getPrototypeOf = function (object) {
    if (object.__proto__) {
      return object.__proto__;
    }

    return nativeGetPrototypeOf.call(Object, object);
  };
}

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1500);
__webpack_require__(1504);
__webpack_require__(1505);
__webpack_require__(1506);
__webpack_require__(1507);
__webpack_require__(1508);
__webpack_require__(1509);
__webpack_require__(1510);
__webpack_require__(1512);
__webpack_require__(1513);
__webpack_require__(1514);
__webpack_require__(1515);
__webpack_require__(1516);
__webpack_require__(1517);
__webpack_require__(1518);
__webpack_require__(1519);
__webpack_require__(1520);
module.exports = __webpack_require__(218).Math;


/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(22);
var log1p = __webpack_require__(709);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(707)('native-function-to-string', Function.toString);


/***/ }),
/* 1502 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 1503 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(22);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(22);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(22);
var sign = __webpack_require__(386);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(22);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(22);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(22);
var $expm1 = __webpack_require__(387);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(22);

$export($export.S, 'Math', { fround: __webpack_require__(1511) });


/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(386);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(22);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(22);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(122)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(22);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(22);

$export($export.S, 'Math', { log1p: __webpack_require__(709) });


/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(22);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(22);

$export($export.S, 'Math', { sign: __webpack_require__(386) });


/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(22);
var expm1 = __webpack_require__(387);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(122)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(22);
var expm1 = __webpack_require__(387);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(22);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1522);
__webpack_require__(1535);
__webpack_require__(1537);
__webpack_require__(1538);
__webpack_require__(1539);
__webpack_require__(1540);
__webpack_require__(1541);
__webpack_require__(1542);
__webpack_require__(1543);
__webpack_require__(1544);
__webpack_require__(1545);
__webpack_require__(1547);
module.exports = __webpack_require__(218).Number;


/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(102);
var has = __webpack_require__(274);
var cof = __webpack_require__(388);
var inheritIfRequired = __webpack_require__(1523);
var toPrimitive = __webpack_require__(385);
var fails = __webpack_require__(122);
var gOPN = __webpack_require__(1527).f;
var gOPD = __webpack_require__(710).f;
var dP = __webpack_require__(384).f;
var $trim = __webpack_require__(392).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(1531)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(187) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(705)(global, NUMBER, $Number);
}


/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(186);
var setPrototypeOf = __webpack_require__(1524).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(186);
var anObject = __webpack_require__(273);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(708)(Function.call, __webpack_require__(710).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 1525 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(388);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(711);
var hiddenKeys = __webpack_require__(391).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(389);
var toLength = __webpack_require__(1529);
var toAbsoluteIndex = __webpack_require__(1530);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(275);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(275);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(273);
var dPs = __webpack_require__(1532);
var enumBugKeys = __webpack_require__(391);
var IE_PROTO = __webpack_require__(712)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(703)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(1534).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(384);
var anObject = __webpack_require__(273);
var getKeys = __webpack_require__(1533);

module.exports = __webpack_require__(187) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(711);
var enumBugKeys = __webpack_require__(391);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(102).document;
module.exports = document && document.documentElement;


/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(22);
var toInteger = __webpack_require__(275);
var aNumberValue = __webpack_require__(713);
var repeat = __webpack_require__(1536);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(122)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(275);
var defined = __webpack_require__(390);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(22);
var $fails = __webpack_require__(122);
var aNumberValue = __webpack_require__(713);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(22);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(22);
var _isFinite = __webpack_require__(102).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(22);

$export($export.S, 'Number', { isInteger: __webpack_require__(714) });


/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(22);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(22);
var isInteger = __webpack_require__(714);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(22);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(22);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(22);
var $parseFloat = __webpack_require__(1546);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(102).parseFloat;
var $trim = __webpack_require__(392).trim;

module.exports = 1 / $parseFloat(__webpack_require__(393) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(22);
var $parseInt = __webpack_require__(1548);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(102).parseInt;
var $trim = __webpack_require__(392).trim;
var ws = __webpack_require__(393);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(640),
    baseIsNaN = __webpack_require__(1550),
    strictIndexOf = __webpack_require__(1551);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 1550 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 1551 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(637),
    noop = __webpack_require__(835),
    setToArray = __webpack_require__(351);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 1553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__container_Surface__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shape_Symbols__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__ = __webpack_require__(12);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Default Legend Content
 */






var SIZE = 32;
var ICON_TYPES = __WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["b" /* LEGEND_TYPES */].filter(function (type) {
  return type !== 'none';
});

var DefaultLegendContent =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(DefaultLegendContent, _PureComponent);

  function DefaultLegendContent() {
    _classCallCheck(this, DefaultLegendContent);

    return _possibleConstructorReturn(this, _getPrototypeOf(DefaultLegendContent).apply(this, arguments));
  }

  _createClass(DefaultLegendContent, [{
    key: "renderIcon",

    /**
     * Render the path of icon
     * @param {Object} data Data of each legend item
     * @return {String} Path element
     */
    value: function renderIcon(data) {
      var inactiveColor = this.props.inactiveColor;
      var halfSize = SIZE / 2;
      var sixthSize = SIZE / 6;
      var thirdSize = SIZE / 3;
      var color = data.inactive ? inactiveColor : data.color;

      if (data.type === 'plainline') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("line", {
          strokeWidth: 4,
          fill: "none",
          stroke: color,
          strokeDasharray: data.payload.strokeDasharray,
          x1: 0,
          y1: halfSize,
          x2: SIZE,
          y2: halfSize,
          className: "recharts-legend-icon"
        });
      }

      if (data.type === 'line') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          strokeWidth: 4,
          fill: "none",
          stroke: color,
          d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat(SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
          className: "recharts-legend-icon"
        });
      }

      if (data.type === 'rect') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          stroke: "none",
          fill: color,
          d: "M0,".concat(SIZE / 8, "h").concat(SIZE, "v").concat(SIZE * 3 / 4, "h").concat(-SIZE, "z"),
          className: "recharts-legend-icon"
        });
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shape_Symbols__["a" /* default */], {
        fill: color,
        cx: halfSize,
        cy: halfSize,
        size: SIZE,
        sizeType: "diameter",
        type: data.type
      });
    }
    /**
     * Draw items of legend
     * @return {ReactElement} Items
     */

  }, {
    key: "renderItems",
    value: function renderItems() {
      var _this = this;

      var _this$props = this.props,
          payload = _this$props.payload,
          iconSize = _this$props.iconSize,
          layout = _this$props.layout,
          formatter = _this$props.formatter;
      var viewBox = {
        x: 0,
        y: 0,
        width: SIZE,
        height: SIZE
      };
      var itemStyle = {
        display: layout === 'horizontal' ? 'inline-block' : 'block',
        marginRight: 10
      };
      var svgStyle = {
        display: 'inline-block',
        verticalAlign: 'middle',
        marginRight: 4
      };
      return payload.map(function (entry, i) {
        var _classNames;

        var finalFormatter = entry.formatter || formatter;
        var className = __WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames = {
          'recharts-legend-item': true
        }, _defineProperty(_classNames, "legend-item-".concat(i), true), _defineProperty(_classNames, "inactive", entry.inactive), _classNames));

        if (entry.type === 'none') {
          return null;
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", _extends({
          className: className,
          style: itemStyle,
          key: "legend-item-".concat(i) // eslint-disable-line react/no-array-index-key

        }, Object(__WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["g" /* filterEventsOfChild */])(_this.props, entry, i)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__container_Surface__["a" /* default */], {
          width: iconSize,
          height: iconSize,
          viewBox: viewBox,
          style: svgStyle
        }, _this.renderIcon(entry)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          className: "recharts-legend-item-text"
        }, finalFormatter ? finalFormatter(entry.value, entry, i) : entry.value));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          payload = _this$props2.payload,
          layout = _this$props2.layout,
          align = _this$props2.align;

      if (!payload || !payload.length) {
        return null;
      }

      var finalStyle = {
        padding: 0,
        margin: 0,
        textAlign: layout === 'horizontal' ? align : 'left'
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
        className: "recharts-default-legend",
        style: finalStyle
      }, this.renderItems());
    }
  }]);

  return DefaultLegendContent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

DefaultLegendContent.displayName = 'Legend';
DefaultLegendContent.propTypes = {
  content: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  iconSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  iconType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(ICON_TYPES),
  layout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['horizontal', 'vertical']),
  align: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['center', 'left', 'right']),
  verticalAlign: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['top', 'bottom', 'middle']),
  payload: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["b" /* LEGEND_TYPES */])
  })),
  inactiveColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  formatter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
DefaultLegendContent.defaultProps = {
  iconSize: 14,
  layout: 'horizontal',
  align: 'center',
  verticalAlign: 'middle',
  inactiveColor: '#ccc'
};
/* harmony default export */ __webpack_exports__["a"] = (DefaultLegendContent);

/***/ }),
/* 1554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(221);




function arcInnerRadius(d) {
  return d.innerRadius;
}

function arcOuterRadius(d) {
  return d.outerRadius;
}

function arcStartAngle(d) {
  return d.startAngle;
}

function arcEndAngle(d) {
  return d.endAngle;
}

function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}

function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0,
      x32 = x3 - x2, y32 = y3 - y2,
      t = y32 * x10 - x32 * y10;
  if (t * t < __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) return;
  t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* max */])(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;

  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;

  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["g" /* halfPi */],
        a1 = endAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["g" /* halfPi */],
        da = Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(a1 - a0),
        cw = a1 > a0;

    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */])) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > __WEBPACK_IMPORTED_MODULE_2__math__["m" /* tau */] - __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
      context.moveTo(r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a0), r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        context.moveTo(r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a1), r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }

    // Or is it a circular or annular sector?
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = (ap > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) && (padRadius ? +padRadius.apply(this, arguments) : Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(r0 * r0 + r1 * r1)),
          rc = Object(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* min */])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1;

      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
      if (rp > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        var p0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* asin */])(rp / r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(ap)),
            p1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* asin */])(rp / r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(ap));
        if ((da0 -= p0 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }

      var x01 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a01),
          y01 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a01),
          x10 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a10),
          y10 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a10);

      // Apply rounded corners?
      if (rc > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        var x11 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a11),
            y11 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a11),
            x00 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a00),
            y00 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a00),
            oc;

        // Restrict the corner radius according to the sector angle.
        if (da < __WEBPACK_IMPORTED_MODULE_2__math__["j" /* pi */] && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
          var ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["b" /* acos */])((ax * bx + ay * by) / (Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(ax * ax + ay * ay) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(bx * bx + by * by))) / 2),
              lc = Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* min */])(rc, (r0 - lc) / (kc - 1));
          rc1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* min */])(rc, (r1 - lc) / (kc + 1));
        }
      }

      // Is the sector collapsed to a line?
      if (!(da1 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */])) context.moveTo(x01, y01);

      // Does the sector’s outer ring have rounded corners?
      else if (rc1 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);

        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.cy + t0.y11, t0.cx + t0.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y11, t1.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

      // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?
      if (!(r0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) || !(da0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */])) context.lineTo(x10, y10);

      // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);

        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.cy + t0.y11, t0.cx + t0.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y11, t1.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }

    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - __WEBPACK_IMPORTED_MODULE_2__math__["j" /* pi */] / 2;
    return [Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a) * r, Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a) * r];
  };

  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : innerRadius;
  };

  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : outerRadius;
  };

  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : cornerRadius;
  };

  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : padRadius;
  };

  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : startAngle;
  };

  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : endAngle;
  };

  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : padAngle;
  };

  arc.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
  };

  return arc;
});


/***/ }),
/* 1555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var pi = Math.PI,
    tau = 2 * pi,
    epsilon = 1e-6,
    tauEpsilon = tau - epsilon;

function Path() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath
  this._ = "";
}

function path() {
  return new Path;
}

Path.prototype = path.prototype = {
  constructor: Path,
  moveTo: function(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function(x1, y1, x, y) {
    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon));

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Otherwise, draw an arc!
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }

      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r, ccw = !!ccw;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
      this._ += "L" + x0 + "," + y0;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % tau + tau;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon) {
      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
  },
  toString: function() {
    return this._;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (path);


/***/ }),
/* 1556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__descending__ = __webpack_require__(1557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity__ = __webpack_require__(1558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__math__ = __webpack_require__(221);





/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_2__identity__["a" /* default */],
      sortValues = __WEBPACK_IMPORTED_MODULE_1__descending__["a" /* default */],
      sort = null,
      startAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0),
      endAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__math__["m" /* tau */]),
      padAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0);

  function pie(data) {
    var i,
        n = data.length,
        j,
        k,
        sum = 0,
        index = new Array(n),
        arcs = new Array(n),
        a0 = +startAngle.apply(this, arguments),
        da = Math.min(__WEBPACK_IMPORTED_MODULE_3__math__["m" /* tau */], Math.max(-__WEBPACK_IMPORTED_MODULE_3__math__["m" /* tau */], endAngle.apply(this, arguments) - a0)),
        a1,
        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
        pa = p * (da < 0 ? -1 : 1),
        v;

    for (i = 0; i < n; ++i) {
      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
        sum += v;
      }
    }

    // Optionally sort the arcs by previously-computed values or by data.
    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });

    // Compute the arcs! They are stored in the original data's order.
    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }

    return arcs;
  }

  pie.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : value;
  };

  pie.sortValues = function(_) {
    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
  };

  pie.sort = function(_) {
    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
  };

  pie.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : startAngle;
  };

  pie.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : endAngle;
  };

  pie.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : padAngle;
  };

  return pie;
});


/***/ }),
/* 1557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 1558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(d) {
  return d;
});


/***/ }),
/* 1559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__area__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lineRadial__ = __webpack_require__(718);




/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var a = Object(__WEBPACK_IMPORTED_MODULE_1__area__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["a" /* curveRadialLinear */]),
      c = a.curve,
      x0 = a.lineX0,
      x1 = a.lineX1,
      y0 = a.lineY0,
      y1 = a.lineY1;

  a.angle = a.x, delete a.x;
  a.startAngle = a.x0, delete a.x0;
  a.endAngle = a.x1, delete a.x1;
  a.radius = a.y, delete a.y;
  a.innerRadius = a.y0, delete a.y0;
  a.outerRadius = a.y1, delete a.y1;
  a.lineStartAngle = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["a" /* lineRadial */])(x0()); }, delete a.lineX0;
  a.lineEndAngle = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["a" /* lineRadial */])(x1()); }, delete a.lineX1;
  a.lineInnerRadius = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["a" /* lineRadial */])(y0()); }, delete a.lineY0;
  a.lineOuterRadius = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["a" /* lineRadial */])(y1()); }, delete a.lineY1;

  a.curve = function(_) {
    return arguments.length ? c(Object(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["b" /* default */])(_)) : c()._curve;
  };

  return a;
});


/***/ }),
/* 1560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export linkHorizontal */
/* unused harmony export linkVertical */
/* unused harmony export linkRadial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__point__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pointRadial__ = __webpack_require__(719);






function linkSource(d) {
  return d.source;
}

function linkTarget(d) {
  return d.target;
}

function link(curve) {
  var source = linkSource,
      target = linkTarget,
      x = __WEBPACK_IMPORTED_MODULE_3__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_3__point__["b" /* y */],
      context = null;

  function link() {
    var buffer, argv = __WEBPACK_IMPORTED_MODULE_1__array__["a" /* slice */].call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();
    curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
    if (buffer) return context = null, buffer + "" || null;
  }

  link.source = function(_) {
    return arguments.length ? (source = _, link) : source;
  };

  link.target = function(_) {
    return arguments.length ? (target = _, link) : target;
  };

  link.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(+_), link) : x;
  };

  link.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(+_), link) : y;
  };

  link.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), link) : context;
  };

  return link;
}

function curveHorizontal(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}

function curveVertical(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}

function curveRadial(context, x0, y0, x1, y1) {
  var p0 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x0, y0),
      p1 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x0, y0 = (y0 + y1) / 2),
      p2 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x1, y0),
      p3 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x1, y1);
  context.moveTo(p0[0], p0[1]);
  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}

function linkHorizontal() {
  return link(curveHorizontal);
}

function linkVertical() {
  return link(curveVertical);
}

function linkRadial() {
  var l = link(curveRadial);
  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;
  return l;
}


/***/ }),
/* 1561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export symbols */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__symbol_circle__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__symbol_cross__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__symbol_diamond__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__symbol_star__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__symbol_square__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__symbol_triangle__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__symbol_wye__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constant__ = __webpack_require__(150);










var symbols = [
  __WEBPACK_IMPORTED_MODULE_1__symbol_circle__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_2__symbol_cross__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_3__symbol_diamond__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_5__symbol_square__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_4__symbol_star__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_6__symbol_triangle__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_7__symbol_wye__["a" /* default */]
];

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var type = Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__symbol_circle__["a" /* default */]),
      size = Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(64),
      context = null;

  function symbol() {
    var buffer;
    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();
    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer) return context = null, buffer + "" || null;
  }

  symbol.type = function(_) {
    return arguments.length ? (type = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(_), symbol) : type;
  };

  symbol.size = function(_) {
    return arguments.length ? (size = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(+_), symbol) : size;
  };

  symbol.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
  };

  return symbol;
});


/***/ }),
/* 1562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(281);



function BasisClosed(context) {
  this._context = context;
}

BasisClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2);
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
      default: Object(__WEBPACK_IMPORTED_MODULE_1__basis__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new BasisClosed(context);
});


/***/ }),
/* 1563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(281);


function BasisOpen(context) {
  this._context = context;
}

BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_0__basis__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new BasisOpen(context);
});


/***/ }),
/* 1564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(281);


function Bundle(context, beta) {
  this._basis = new __WEBPACK_IMPORTED_MODULE_0__basis__["a" /* Basis */](context);
  this._beta = beta;
}

Bundle.prototype = {
  lineStart: function() {
    this._x = [];
    this._y = [];
    this._basis.lineStart();
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        j = x.length - 1;

    if (j > 0) {
      var x0 = x[0],
          y0 = y[0],
          dx = x[j] - x0,
          dy = y[j] - y0,
          i = -1,
          t;

      while (++i <= j) {
        t = i / j;
        this._basis.point(
          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
        );
      }
    }

    this._x = this._y = null;
    this._basis.lineEnd();
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(beta) {

  function bundle(context) {
    return beta === 1 ? new __WEBPACK_IMPORTED_MODULE_0__basis__["a" /* Basis */](context) : new Bundle(context, beta);
  }

  bundle.beta = function(beta) {
    return custom(+beta);
  };

  return bundle;
})(0.85));


/***/ }),
/* 1565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalClosed__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__catmullRom__ = __webpack_require__(399);




function CatmullRomClosed(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: Object(__WEBPACK_IMPORTED_MODULE_2__catmullRom__["a" /* point */])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomClosed(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalClosed__["a" /* CardinalClosed */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 1566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalOpen__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__catmullRom__ = __webpack_require__(399);



function CatmullRomOpen(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_1__catmullRom__["a" /* point */])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomOpen(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalOpen__["a" /* CardinalOpen */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 1567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(280);


function LinearClosed(context) {
  this._context = context;
}

LinearClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._point) this._context.closePath();
  },
  point: function(x, y) {
    x = +x, y = +y;
    if (this._point) this._context.lineTo(x, y);
    else this._point = 1, this._context.moveTo(x, y);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new LinearClosed(context);
});


/***/ }),
/* 1568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = monotoneX;
/* harmony export (immutable) */ __webpack_exports__["b"] = monotoneY;
function sign(x) {
  return x < 0 ? -1 : 1;
}

// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
      h1 = x2 - that._x1,
      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
      p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}

// Calculate a one-sided slope.
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}

// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
  var x0 = that._x0,
      y0 = that._y0,
      x1 = that._x1,
      y1 = that._y1,
      dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}

function MonotoneX(context) {
  this._context = context;
}

MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 =
    this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x1, this._y1); break;
      case 3: point(this, this._t0, slope2(this, this._t0)); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    var t1 = NaN;

    x = +x, y = +y;
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; point(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
      default: point(this, this._t0, t1 = slope3(this, x, y)); break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
    this._t0 = t1;
  }
}

function MonotoneY(context) {
  this._context = new ReflectContext(context);
}

(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};

function ReflectContext(context) {
  this._context = context;
}

ReflectContext.prototype = {
  moveTo: function(x, y) { this._context.moveTo(y, x); },
  closePath: function() { this._context.closePath(); },
  lineTo: function(x, y) { this._context.lineTo(y, x); },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
};

function monotoneX(context) {
  return new MonotoneX(context);
}

function monotoneY(context) {
  return new MonotoneY(context);
}


/***/ }),
/* 1569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Natural(context) {
  this._context = context;
}

Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        n = x.length;

    if (n) {
      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
      if (n === 2) {
        this._context.lineTo(x[1], y[1]);
      } else {
        var px = controlPoints(x),
            py = controlPoints(y);
        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
        }
      }
    }

    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
  var i,
      n = x.length - 1,
      m,
      a = new Array(n),
      b = new Array(n),
      r = new Array(n);
  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
  a[n - 1] = r[n - 1] / b[n - 1];
  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
  b[n - 1] = (x[n] + a[n - 1]) / 2;
  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
  return [a, b];
}

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Natural(context);
});


/***/ }),
/* 1570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = stepBefore;
/* harmony export (immutable) */ __webpack_exports__["b"] = stepAfter;
function Step(context, t) {
  this._context = context;
  this._t = t;
}

Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y);
          this._context.lineTo(x, y);
        } else {
          var x1 = this._x * (1 - this._t) + x * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y);
        }
        break;
      }
    }
    this._x = x, this._y = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Step(context, 0.5);
});

function stepBefore(context) {
  return new Step(context, 0);
}

function stepAfter(context) {
  return new Step(context, 1);
}


/***/ }),
/* 1571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__offset_none__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__order_none__ = __webpack_require__(223);





function stackValue(d, key) {
  return d[key];
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var keys = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])([]),
      order = __WEBPACK_IMPORTED_MODULE_3__order_none__["a" /* default */],
      offset = __WEBPACK_IMPORTED_MODULE_2__offset_none__["a" /* default */],
      value = stackValue;

  function stack(data) {
    var kz = keys.apply(this, arguments),
        i,
        m = data.length,
        n = kz.length,
        sz = new Array(n),
        oz;

    for (i = 0; i < n; ++i) {
      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
        si[j] = sij = [0, +value(data[j], ki, j, data)];
        sij.data = data[j];
      }
      si.key = ki;
    }

    for (i = 0, oz = order(sz); i < n; ++i) {
      sz[oz[i]].index = i;
    }

    offset(sz, oz);
    return sz;
  }

  stack.keys = function(_) {
    return arguments.length ? (keys = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_)), stack) : keys;
  };

  stack.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), stack) : value;
  };

  stack.order = function(_) {
    return arguments.length ? (order = _ == null ? __WEBPACK_IMPORTED_MODULE_3__order_none__["a" /* default */] : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_)), stack) : order;
  };

  stack.offset = function(_) {
    return arguments.length ? (offset = _ == null ? __WEBPACK_IMPORTED_MODULE_2__offset_none__["a" /* default */] : _, stack) : offset;
  };

  return stack;
});


/***/ }),
/* 1572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(222);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 1573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
    for (yp = yn = 0, i = 0; i < n; ++i) {
      if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) {
        d[0] = yp, d[1] = yp += dy;
      } else if (dy < 0) {
        d[1] = yn, d[0] = yn += dy;
      } else {
        d[0] = yp;
      }
    }
  }
});


/***/ }),
/* 1574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(222);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
    s0[j][1] += s0[j][0] = -y / 2;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 1575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(222);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
      var si = series[order[i]],
          sij0 = si[j][1] || 0,
          sij1 = si[j - 1][1] || 0,
          s3 = (sij0 - sij1) / 2;
      for (var k = 0; k < i; ++k) {
        var sk = series[order[k]],
            skj0 = sk[j][1] || 0,
            skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      s1 += sij0, s2 += s3 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    if (s1) y -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y;
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 1576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(400);


/* unused harmony default export */ var _unused_webpack_default_export = (function(series) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */])(series).reverse();
});


/***/ }),
/* 1577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appearance__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(400);



/* unused harmony default export */ var _unused_webpack_default_export = (function(series) {
  var n = series.length,
      i,
      j,
      sums = series.map(__WEBPACK_IMPORTED_MODULE_1__ascending__["b" /* sum */]),
      order = Object(__WEBPACK_IMPORTED_MODULE_0__appearance__["a" /* default */])(series),
      top = 0,
      bottom = 0,
      tops = [],
      bottoms = [];

  for (i = 0; i < n; ++i) {
    j = order[i];
    if (top < bottom) {
      top += sums[j];
      tops.push(j);
    } else {
      bottom += sums[j];
      bottoms.push(j);
    }
  }

  return bottoms.reverse().concat(tops);
});


/***/ }),
/* 1578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(223);


/* unused harmony default export */ var _unused_webpack_default_export = (function(series) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).reverse();
});


/***/ }),
/* 1579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createAnimateManager;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setRafTimeout__ = __webpack_require__(1580);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }


function createAnimateManager() {
  var currStyle = {};

  var handleChange = function handleChange() {
    return null;
  };

  var shouldStop = false;

  var setStyle = function setStyle(_style) {
    if (shouldStop) {
      return;
    }

    if (Array.isArray(_style)) {
      if (!_style.length) {
        return;
      }

      var styles = _style;

      var _styles = _toArray(styles),
          curr = _styles[0],
          restStyles = _styles.slice(1);

      if (typeof curr === 'number') {
        Object(__WEBPACK_IMPORTED_MODULE_0__setRafTimeout__["a" /* default */])(setStyle.bind(null, restStyles), curr);
        return;
      }

      setStyle(curr);
      Object(__WEBPACK_IMPORTED_MODULE_0__setRafTimeout__["a" /* default */])(setStyle.bind(null, restStyles));
      return;
    }

    if (_typeof(_style) === 'object') {
      currStyle = _style;
      handleChange(currStyle);
    }

    if (typeof _style === 'function') {
      _style();
    }
  };

  return {
    stop: function stop() {
      shouldStop = true;
    },
    start: function start(style) {
      shouldStop = false;
      setStyle(style);
    },
    subscribe: function subscribe(_handleChange) {
      handleChange = _handleChange;
      return function () {
        handleChange = function handleChange() {
          return null;
        };
      };
    }
  };
}

/***/ }),
/* 1580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setRafTimeout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raf__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_raf__);

function setRafTimeout(callback) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var currTime = -1;

  var shouldUpdate = function shouldUpdate(now) {
    if (currTime < 0) {
      currTime = now;
    }

    if (now - currTime > timeout) {
      callback(now);
      currTime = -1;
    } else {
      __WEBPACK_IMPORTED_MODULE_0_raf___default()(shouldUpdate);
    }
  };

  __WEBPACK_IMPORTED_MODULE_0_raf___default()(shouldUpdate);
}

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(311),
    arrayIncludes = __webpack_require__(428),
    arrayIncludesWith = __webpack_require__(444),
    arrayMap = __webpack_require__(160),
    baseUnary = __webpack_require__(202),
    cacheHas = __webpack_require__(312);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith : arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = arrayMap(array, baseUnary(iteratee));
    }
    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new SetCache(othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? cacheHas(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? cacheHas(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseIntersection;


/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLikeObject = __webpack_require__(844);

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

module.exports = castArrayLikeObject;


/***/ }),
/* 1583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_filter__ = __webpack_require__(1584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raf__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_raf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(284);


function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




var alpha = function alpha(begin, end, k) {
  return begin + (end - begin) * k;
};

var needContinue = function needContinue(_ref) {
  var from = _ref.from,
      to = _ref.to;
  return from !== to;
};
/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */


var calStepperVals = function calStepperVals(easing, preVals, steps) {
  var nextStepVals = Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* mapObject */])(function (key, val) {
    if (needContinue(val)) {
      var _easing = easing(val.from, val.to, val.velocity),
          _easing2 = _slicedToArray(_easing, 2),
          newX = _easing2[0],
          newV = _easing2[1];

      return _objectSpread({}, val, {
        from: newX,
        velocity: newV
      });
    }

    return val;
  }, preVals);

  if (steps < 1) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* mapObject */])(function (key, val) {
      if (needContinue(val)) {
        return _objectSpread({}, val, {
          velocity: alpha(val.velocity, nextStepVals[key].velocity, steps),
          from: alpha(val.from, nextStepVals[key].from, steps)
        });
      }

      return val;
    }, preVals);
  }

  return calStepperVals(easing, nextStepVals, steps - 1);
}; // configure update function


/* harmony default export */ __webpack_exports__["a"] = (function (from, to, easing, duration, render) {
  var interKeys = Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* getIntersectionKeys */])(from, to);
  var timingStyle = interKeys.reduce(function (res, key) {
    return _objectSpread({}, res, _defineProperty({}, key, [from[key], to[key]]));
  }, {});
  var stepperStyle = interKeys.reduce(function (res, key) {
    return _objectSpread({}, res, _defineProperty({}, key, {
      from: from[key],
      velocity: 0,
      to: to[key]
    }));
  }, {});
  var cafId = -1;
  var preTime;
  var beginTime;

  var update = function update() {
    return null;
  };

  var getCurrStyle = function getCurrStyle() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* mapObject */])(function (key, val) {
      return val.from;
    }, stepperStyle);
  };

  var shouldStopAnimation = function shouldStopAnimation() {
    return !__WEBPACK_IMPORTED_MODULE_0_lodash_filter___default()(stepperStyle, needContinue).length;
  }; // stepper timing function like spring


  var stepperUpdate = function stepperUpdate(now) {
    if (!preTime) {
      preTime = now;
    }

    var deltaTime = now - preTime;
    var steps = deltaTime / easing.dt;
    stepperStyle = calStepperVals(easing, stepperStyle, steps); // get union set and add compatible prefix

    render(_objectSpread({}, from, to, getCurrStyle(stepperStyle)));
    preTime = now;

    if (!shouldStopAnimation()) {
      cafId = __WEBPACK_IMPORTED_MODULE_1_raf___default()(update);
    }
  }; // t => val timing function like cubic-bezier


  var timingUpdate = function timingUpdate(now) {
    if (!beginTime) {
      beginTime = now;
    }

    var t = (now - beginTime) / duration;
    var currStyle = Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* mapObject */])(function (key, val) {
      return alpha.apply(void 0, _toConsumableArray(val).concat([easing(t)]));
    }, timingStyle); // get union set and add compatible prefix

    render(_objectSpread({}, from, to, currStyle));

    if (t < 1) {
      cafId = __WEBPACK_IMPORTED_MODULE_1_raf___default()(update);
    } else {
      var finalStyle = Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* mapObject */])(function (key, val) {
        return alpha.apply(void 0, _toConsumableArray(val).concat([easing(1)]));
      }, timingStyle);
      render(_objectSpread({}, from, to, finalStyle));
    }
  };

  update = easing.isStepper ? stepperUpdate : timingUpdate; // return start animation method

  return function () {
    __WEBPACK_IMPORTED_MODULE_1_raf___default()(update); // return stop animation method

    return function () {
      Object(__WEBPACK_IMPORTED_MODULE_1_raf__["cancel"])(cafId);
    };
  };
});

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(437),
    baseFilter = __webpack_require__(1585),
    baseIteratee = __webpack_require__(67),
    isArray = __webpack_require__(26);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(230);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),
/* 1586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AnimateGroupChild__ = __webpack_require__(1587);





function AnimateGroup(props) {
  var component = props.component,
      children = props.children,
      appear = props.appear,
      enter = props.enter,
      leave = props.leave;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_transition_group__["TransitionGroup"], {
    component: component
  }, __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children, function (child, index) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AnimateGroupChild__["a" /* default */], {
      appearOptions: appear,
      enterOptions: enter,
      leaveOptions: leave,
      key: "child-".concat(index)
    }, child);
  }));
}

AnimateGroup.propTypes = {
  appear: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  enter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  leave: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element]),
  component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any
};
AnimateGroup.defaultProps = {
  component: 'span'
};
/* unused harmony default export */ var _unused_webpack_default_export = (AnimateGroup);

/***/ }),
/* 1587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNumber__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transition_group__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Animate__ = __webpack_require__(731);


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }






var parseDurationOfSingleTransition = function parseDurationOfSingleTransition() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var steps = options.steps,
      duration = options.duration;

  if (steps && steps.length) {
    return steps.reduce(function (result, entry) {
      return result + (__WEBPACK_IMPORTED_MODULE_0_lodash_isNumber___default()(entry.duration) && entry.duration > 0 ? entry.duration : 0);
    }, 0);
  }

  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isNumber___default()(duration)) {
    return duration;
  }

  return 0;
};

var AnimateGroupChild =
/*#__PURE__*/
function (_Component) {
  _inherits(AnimateGroupChild, _Component);

  function AnimateGroupChild() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, AnimateGroupChild);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AnimateGroupChild)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      isActive: false
    };

    _this.handleEnter = function (node, isAppearing) {
      var _this$props = _this.props,
          appearOptions = _this$props.appearOptions,
          enterOptions = _this$props.enterOptions;

      _this.handleStyleActive(isAppearing ? appearOptions : enterOptions);
    };

    _this.handleExit = function () {
      _this.handleStyleActive(_this.props.leaveOptions);
    };

    return _this;
  }

  _createClass(AnimateGroupChild, [{
    key: "handleStyleActive",
    value: function handleStyleActive(style) {
      if (style) {
        var onAnimationEnd = style.onAnimationEnd ? function () {
          style.onAnimationEnd();
        } : null;
        this.setState(_objectSpread({}, style, {
          onAnimationEnd: onAnimationEnd,
          isActive: true
        }));
      }
    }
  }, {
    key: "parseTimeout",
    value: function parseTimeout() {
      var _this$props2 = this.props,
          appearOptions = _this$props2.appearOptions,
          enterOptions = _this$props2.enterOptions,
          leaveOptions = _this$props2.leaveOptions;
      return parseDurationOfSingleTransition(appearOptions) + parseDurationOfSingleTransition(enterOptions) + parseDurationOfSingleTransition(leaveOptions);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          children = _this$props3.children,
          appearOptions = _this$props3.appearOptions,
          enterOptions = _this$props3.enterOptions,
          leaveOptions = _this$props3.leaveOptions,
          props = _objectWithoutProperties(_this$props3, ["children", "appearOptions", "enterOptions", "leaveOptions"]);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_transition_group__["Transition"], _extends({}, props, {
        onEnter: this.handleEnter,
        onExit: this.handleExit,
        timeout: this.parseTimeout()
      }), function () {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Animate__["a" /* default */], _this2.state, __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(children));
      });
    }
  }]);

  return AnimateGroupChild;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

AnimateGroupChild.propTypes = {
  appearOptions: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  enterOptions: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  leaveOptions: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element
};
/* harmony default export */ __webpack_exports__["a"] = (AnimateGroupChild);

/***/ }),
/* 1588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isArray__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_DataUtils__ = __webpack_require__(23);



function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }






var defaultFormatter = function defaultFormatter(value) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_isArray___default()(value) && Object(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["g" /* isNumOrStr */])(value[0]) && Object(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["g" /* isNumOrStr */])(value[1]) ? value.join(' ~ ') : value;
};

var DefaultTooltipContent =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(DefaultTooltipContent, _PureComponent);

  function DefaultTooltipContent() {
    _classCallCheck(this, DefaultTooltipContent);

    return _possibleConstructorReturn(this, _getPrototypeOf(DefaultTooltipContent).apply(this, arguments));
  }

  _createClass(DefaultTooltipContent, [{
    key: "renderContent",
    value: function renderContent() {
      var _this$props = this.props,
          payload = _this$props.payload,
          separator = _this$props.separator,
          formatter = _this$props.formatter,
          itemStyle = _this$props.itemStyle,
          itemSorter = _this$props.itemSorter;

      if (payload && payload.length) {
        var listStyle = {
          padding: 0,
          margin: 0
        };
        var items = (itemSorter ? __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default()(payload, itemSorter) : payload).map(function (entry, i) {
          if (entry.type === 'none') {
            return null;
          }

          var finalItemStyle = _objectSpread({
            display: 'block',
            paddingTop: 4,
            paddingBottom: 4,
            color: entry.color || '#000'
          }, itemStyle);

          var finalFormatter = entry.formatter || formatter || defaultFormatter;
          var name = entry.name,
              value = entry.value;

          if (finalFormatter) {
            var formatted = finalFormatter(value, name, entry, i);

            if (Array.isArray(formatted)) {
              var _formatted = _slicedToArray(formatted, 2);

              value = _formatted[0];
              name = _formatted[1];
            } else {
              value = formatted;
            }
          }

          return (// eslint-disable-next-line react/no-array-index-key
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("li", {
              className: "recharts-tooltip-item",
              key: "tooltip-item-".concat(i),
              style: finalItemStyle
            }, Object(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["g" /* isNumOrStr */])(name) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
              className: "recharts-tooltip-item-name"
            }, name) : null, Object(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["g" /* isNumOrStr */])(name) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
              className: "recharts-tooltip-item-separator"
            }, separator) : null, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
              className: "recharts-tooltip-item-value"
            }, value), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
              className: "recharts-tooltip-item-unit"
            }, entry.unit || ''))
          );
        });
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("ul", {
          className: "recharts-tooltip-item-list",
          style: listStyle
        }, items);
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          wrapperClassName = _this$props2.wrapperClassName,
          contentStyle = _this$props2.contentStyle,
          labelClassName = _this$props2.labelClassName,
          labelStyle = _this$props2.labelStyle,
          label = _this$props2.label,
          labelFormatter = _this$props2.labelFormatter;

      var finalStyle = _objectSpread({
        margin: 0,
        padding: 10,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        whiteSpace: 'nowrap'
      }, contentStyle);

      var finalLabelStyle = _objectSpread({
        margin: 0
      }, labelStyle);

      var hasLabel = Object(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["g" /* isNumOrStr */])(label);
      var finalLabel = hasLabel ? label : '';
      var wrapperCN = __WEBPACK_IMPORTED_MODULE_4_classnames___default()('recharts-default-tooltip', wrapperClassName);
      var labelCN = __WEBPACK_IMPORTED_MODULE_4_classnames___default()('recharts-tooltip-label', labelClassName);

      if (hasLabel && labelFormatter) {
        finalLabel = labelFormatter(label);
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
        className: wrapperCN,
        style: finalStyle
      }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("p", {
        className: labelCN,
        style: finalLabelStyle
      }, finalLabel), this.renderContent());
    }
  }]);

  return DefaultTooltipContent;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);

DefaultTooltipContent.displayName = 'DefaultTooltipContent';
DefaultTooltipContent.propTypes = {
  separator: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  wrapperClassName: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  labelClassName: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  formatter: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  contentStyle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  itemStyle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  labelStyle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  labelFormatter: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  label: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,
  payload: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    name: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,
    value: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array]),
    unit: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any
  })),
  itemSorter: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
};
DefaultTooltipContent.defaultProps = {
  separator: ' : ',
  contentStyle: {},
  itemStyle: {},
  labelStyle: {}
};
/* harmony default export */ __webpack_exports__["a"] = (DefaultTooltipContent);

/***/ }),
/* 1589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_resize_detector__ = __webpack_require__(1591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_resize_detector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_resize_detector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_DataUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_LogUtils__ = __webpack_require__(188);


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Wrapper component to make charts adapt to the size of parent * DOM
 */







var ResponsiveContainer =
/*#__PURE__*/
function (_Component) {
  _inherits(ResponsiveContainer, _Component);

  function ResponsiveContainer(props) {
    var _this;

    _classCallCheck(this, ResponsiveContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ResponsiveContainer).call(this, props));

    _this.updateDimensionsImmediate = function () {
      if (!_this.mounted) {
        return;
      }

      var newSize = _this.getContainerSize();

      if (newSize) {
        var _this$state = _this.state,
            oldWidth = _this$state.containerWidth,
            oldHeight = _this$state.containerHeight;
        var containerWidth = newSize.containerWidth,
            containerHeight = newSize.containerHeight;

        if (containerWidth !== oldWidth || containerHeight !== oldHeight) {
          _this.setState({
            containerWidth: containerWidth,
            containerHeight: containerHeight
          });
        }
      }
    };

    _this.state = {
      containerWidth: -1,
      containerHeight: -1
    };
    _this.handleResize = props.debounce > 0 ? __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(_this.updateDimensionsImmediate, props.debounce) : _this.updateDimensionsImmediate;
    return _this;
  }
  /* eslint-disable  react/no-did-mount-set-state */


  _createClass(ResponsiveContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      var size = this.getContainerSize();

      if (size) {
        this.setState(size);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "getContainerSize",
    value: function getContainerSize() {
      if (!this.container) {
        return null;
      }

      return {
        containerWidth: this.container.clientWidth,
        containerHeight: this.container.clientHeight
      };
    }
  }, {
    key: "renderChart",
    value: function renderChart() {
      var _this$state2 = this.state,
          containerWidth = _this$state2.containerWidth,
          containerHeight = _this$state2.containerHeight;

      if (containerWidth < 0 || containerHeight < 0) {
        return null;
      }

      var _this$props = this.props,
          aspect = _this$props.aspect,
          width = _this$props.width,
          height = _this$props.height,
          minWidth = _this$props.minWidth,
          minHeight = _this$props.minHeight,
          maxHeight = _this$props.maxHeight,
          children = _this$props.children;
      Object(__WEBPACK_IMPORTED_MODULE_6__util_LogUtils__["a" /* warn */])(Object(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["i" /* isPercent */])(width) || Object(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["i" /* isPercent */])(height), "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.", width, height);
      Object(__WEBPACK_IMPORTED_MODULE_6__util_LogUtils__["a" /* warn */])(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
      var calculatedWidth = Object(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["i" /* isPercent */])(width) ? containerWidth : width;
      var calculatedHeight = Object(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["i" /* isPercent */])(height) ? containerHeight : height;

      if (aspect && aspect > 0) {
        // Preserve the desired aspect ratio
        if (calculatedWidth) {
          // Will default to using width for aspect ratio
          calculatedHeight = calculatedWidth / aspect;
        } else if (calculatedHeight) {
          // But we should also take height into consideration
          calculatedWidth = calculatedHeight * aspect;
        } // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight


        if (maxHeight && calculatedHeight > maxHeight) {
          calculatedHeight = maxHeight;
        }
      }

      Object(__WEBPACK_IMPORTED_MODULE_6__util_LogUtils__["a" /* warn */])(calculatedWidth > 0 || calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
        width: calculatedWidth,
        height: calculatedHeight
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          minWidth = _this$props2.minWidth,
          minHeight = _this$props2.minHeight,
          width = _this$props2.width,
          height = _this$props2.height,
          maxHeight = _this$props2.maxHeight,
          id = _this$props2.id,
          className = _this$props2.className;
      var style = {
        width: width,
        height: height,
        minWidth: minWidth,
        minHeight: minHeight,
        maxHeight: maxHeight
      };
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        id: id,
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('recharts-responsive-container', className),
        style: style,
        ref: function ref(node) {
          _this2.container = node;
        }
      }, this.renderChart(), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_resize_detector___default.a, {
        handleWidth: true,
        handleHeight: true,
        onResize: this.handleResize
      }));
    }
  }]);

  return ResponsiveContainer;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

ResponsiveContainer.displayName = 'ResponsiveContainer';
ResponsiveContainer.propTypes = {
  aspect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  height: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  minHeight: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  minWidth: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  maxHeight: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,
  debounce: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number])
};
ResponsiveContainer.defaultProps = {
  width: '100%',
  height: '100%',
  debounce: 0
};
/* harmony default export */ __webpack_exports__["a"] = (ResponsiveContainer);

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(78);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ResizeDetector = __webpack_require__(1592);

var _ResizeDetector2 = _interopRequireDefault(_ResizeDetector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ResizeDetector2.default;

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _resizeObserverPolyfill = __webpack_require__(1593);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

var _lodash = __webpack_require__(1594);

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__(1595);

var _lodash4 = _interopRequireDefault(_lodash3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var listMode = { debounce: _lodash2.default, throttle: _lodash4.default };

var styles = {
  position: 'absolute',
  width: 0,
  height: 0,
  visibility: 'hidden',
  display: 'none'
};

var ResizeDetector = function (_PureComponent) {
  _inherits(ResizeDetector, _PureComponent);

  function ResizeDetector(props) {
    _classCallCheck(this, ResizeDetector);

    var _this = _possibleConstructorReturn(this, (ResizeDetector.__proto__ || Object.getPrototypeOf(ResizeDetector)).call(this, props));

    _this.createResizeObserver = function (entries) {
      var _this$props = _this.props,
          handleWidth = _this$props.handleWidth,
          handleHeight = _this$props.handleHeight,
          onResize = _this$props.onResize;

      entries.forEach(function (entry) {
        var _entry$contentRect = entry.contentRect,
            width = _entry$contentRect.width,
            height = _entry$contentRect.height;

        var notifyWidth = handleWidth && _this.width !== width;
        var notifyHeight = handleHeight && _this.height !== height;
        if (!_this.skipOnMount && (notifyWidth || notifyHeight)) {
          onResize(width, height);
        }
        _this.width = width;
        _this.height = height;
        _this.skipOnMount = false;
      });
    };

    var skipOnMount = props.skipOnMount,
        refreshMode = props.refreshMode,
        refreshRate = props.refreshRate;


    _this.width = undefined;
    _this.height = undefined;
    _this.skipOnMount = skipOnMount;

    var resizeObserver = listMode[refreshMode] && listMode[refreshMode](_this.createResizeObserver, refreshRate) || _this.createResizeObserver;

    _this.ro = new _resizeObserverPolyfill2.default(resizeObserver);
    return _this;
  }

  _createClass(ResizeDetector, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var resizableElementId = this.props.resizableElementId;

      var resizableElement = resizableElementId ? document.getElementById(resizableElementId) : this.el.parentElement;
      this.ro.observe(resizableElement);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var resizableElementId = this.props.resizableElementId;

      var resizableElement = resizableElementId ? document.getElementById(resizableElementId) : this.el.parentElement;
      this.ro.unobserve(resizableElement);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement('div', {
        style: styles,
        ref: function ref(el) {
          _this2.el = el;
        }
      });
    }
  }]);

  return ResizeDetector;
}(_react.PureComponent);

exports.default = ResizeDetector;


ResizeDetector.propTypes = {
  handleWidth: _propTypes2.default.bool,
  handleHeight: _propTypes2.default.bool,
  skipOnMount: _propTypes2.default.bool,
  refreshRate: _propTypes2.default.number,
  refreshMode: _propTypes2.default.string,
  resizableElementId: _propTypes2.default.string,
  onResize: _propTypes2.default.func
};

ResizeDetector.defaultProps = {
  handleWidth: false,
  handleHeight: false,
  skipOnMount: false,
  refreshRate: 1000,
  refreshMode: undefined,
  resizableElementId: '',
  onResize: function onResize(e) {
    return e;
  }
};

/***/ }),
/* 1593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(57)))

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)))

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)))

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies
 */
var balanced = __webpack_require__(1597)
var reduceFunctionCall = __webpack_require__(1598)
var mexp = __webpack_require__(1600)

/**
 * Constantes
 */
var MAX_STACK = 100 // should be enough for a single calc()...
var NESTED_CALC_RE = /(\+|\-|\*|\\|[^a-z]|)(\s*)(\()/g

/**
 * Global variables
 */
var stack

/**
 * Expose reduceCSSCalc plugin
 *
 * @type {Function}
 */
module.exports = reduceCSSCalc

/**
 * Reduce CSS calc() in a string, whenever it's possible
 *
 * @param {String} value css input
 */
function reduceCSSCalc(value, decimalPrecision) {
  stack = 0
  decimalPrecision = Math.pow(10, decimalPrecision === undefined ? 5 : decimalPrecision)

  // Allow calc() on multiple lines
  value = value.replace(/\n+/g, " ")

  /**
   * Evaluates an expression
   *
   * @param {String} expression
   * @returns {String}
   */
  function evaluateExpression (expression, functionIdentifier, call) {
    if (stack++ > MAX_STACK) {
      stack = 0
      throw new Error("Call stack overflow for " + call)
    }

    if (expression === "") {
      throw new Error(functionIdentifier + "(): '" + call + "' must contain a non-whitespace string")
    }

    expression = evaluateNestedExpression(expression, call)

    var units = getUnitsInExpression(expression)

    // If the expression contains multiple units or CSS variables,
    // then let the expression be (i.e. browser calc())
    if (units.length > 1 || expression.indexOf("var(") > -1) {
      return functionIdentifier + "(" + expression + ")"
    }

    var unit = units[0] || ""

    if (unit === "%") {
      // Convert percentages to numbers, to handle expressions like: 50% * 50% (will become: 25%):
      // console.log(expression)
      expression = expression.replace(/\b[0-9\.]+%/g, function(percent) {
        return parseFloat(percent.slice(0, -1)) * 0.01
      })
    }

    // Remove units in expression:
    var toEvaluate = expression.replace(new RegExp(unit, "gi"), "")
    var result

    try {
      result = mexp.eval(toEvaluate)
    }
    catch (e) {
      return functionIdentifier + "(" + expression + ")"
    }

    // Transform back to a percentage result:
    if (unit === "%") {
      result *= 100
    }

    // adjust rounding shit
    // (0.1 * 0.2 === 0.020000000000000004)
    if (functionIdentifier.length || unit === "%") {
      result = Math.round(result * decimalPrecision) / decimalPrecision
    }

    // Add unit
    result += unit

    return result
  }

  /**
   * Evaluates nested expressions
   *
   * @param {String} expression
   * @returns {String}
   */
  function evaluateNestedExpression(expression, call) {
    // Remove the calc part from nested expressions to ensure
    // better browser compatibility
    expression = expression.replace(/((?:\-[a-z]+\-)?calc)/g, "")
    var evaluatedPart = ""
    var nonEvaluatedPart = expression
    var matches
    while ((matches = NESTED_CALC_RE.exec(nonEvaluatedPart))) {
      if (matches[0].index > 0) {
        evaluatedPart += nonEvaluatedPart.substring(0, matches[0].index)
      }

      var balancedExpr = balanced("(", ")", nonEvaluatedPart.substring([0].index))
      if (balancedExpr.body === "") {
        throw new Error("'" + expression + "' must contain a non-whitespace string")
      }

      var evaluated = evaluateExpression(balancedExpr.body, "", call)

      evaluatedPart += balancedExpr.pre + evaluated
      nonEvaluatedPart = balancedExpr.post
    }

    return evaluatedPart + nonEvaluatedPart
  }

  return reduceFunctionCall(value, /((?:\-[a-z]+\-)?calc)\(/, evaluateExpression)
}

/**
 * Checks what units are used in an expression
 *
 * @param {String} expression
 * @returns {Array}
 */

function getUnitsInExpression(expression) {
  var uniqueUnits = []
  var uniqueLowerCaseUnits = []
  var unitRegEx = /[\.0-9]([%a-z]+)/gi
  var matches = unitRegEx.exec(expression)

  while (matches) {
    if (!matches || !matches[1]) {
      continue
    }

    if (uniqueLowerCaseUnits.indexOf(matches[1].toLowerCase()) === -1) {
      uniqueUnits.push(matches[1])
      uniqueLowerCaseUnits.push(matches[1].toLowerCase())
    }

    matches = unitRegEx.exec(expression)
  }

  return uniqueUnits
}


/***/ }),
/* 1597 */
/***/ (function(module, exports) {

module.exports = balanced;
function balanced(a, b, str) {
  if (a instanceof RegExp) a = maybeMatch(a, str);
  if (b instanceof RegExp) b = maybeMatch(b, str);

  var r = range(a, b, str);

  return r && {
    start: r[0],
    end: r[1],
    pre: str.slice(0, r[0]),
    body: str.slice(r[0] + a.length, r[1]),
    post: str.slice(r[1] + b.length)
  };
}

function maybeMatch(reg, str) {
  var m = str.match(reg);
  return m ? m[0] : null;
}

balanced.range = range;
function range(a, b, str) {
  var begs, beg, left, right, result;
  var ai = str.indexOf(a);
  var bi = str.indexOf(b, ai + 1);
  var i = ai;

  if (ai >= 0 && bi > 0) {
    begs = [];
    left = str.length;

    while (i >= 0 && !result) {
      if (i == ai) {
        begs.push(i);
        ai = str.indexOf(a, i + 1);
      } else if (begs.length == 1) {
        result = [ begs.pop(), bi ];
      } else {
        beg = begs.pop();
        if (beg < left) {
          left = beg;
          right = bi;
        }

        bi = str.indexOf(b, i + 1);
      }

      i = ai < bi && ai >= 0 ? ai : bi;
    }

    if (begs.length) {
      result = [ left, right ];
    }
  }

  return result;
}


/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * Module dependencies
 */
var balanced = __webpack_require__(1599)

/**
 * Expose `reduceFunctionCall`
 *
 * @type {Function}
 */
module.exports = reduceFunctionCall

/**
 * Walkthrough all expressions, evaluate them and insert them into the declaration
 *
 * @param {Array} expressions
 * @param {Object} declaration
 */

function reduceFunctionCall(string, functionRE, callback) {
  var call = string
  return getFunctionCalls(string, functionRE).reduce(function(string, obj) {
    return string.replace(obj.functionIdentifier + "(" + obj.matches.body + ")", evalFunctionCall(obj.matches.body, obj.functionIdentifier, callback, call, functionRE))
  }, string)
}

/**
 * Parses expressions in a value
 *
 * @param {String} value
 * @returns {Array}
 * @api private
 */

function getFunctionCalls(call, functionRE) {
  var expressions = []

  var fnRE = typeof functionRE === "string" ? new RegExp("\\b(" + functionRE + ")\\(") : functionRE
  do {
    var searchMatch = fnRE.exec(call)
    if (!searchMatch) {
      return expressions
    }
    if (searchMatch[1] === undefined) {
      throw new Error("Missing the first couple of parenthesis to get the function identifier in " + functionRE)
    }
    var fn = searchMatch[1]
    var startIndex = searchMatch.index
    var matches = balanced("(", ")", call.substring(startIndex))

    if (!matches || matches.start !== searchMatch[0].length - 1) {
      throw new SyntaxError(fn + "(): missing closing ')' in the value '" + call + "'")
    }

    expressions.push({matches: matches, functionIdentifier: fn})
    call = matches.post
  }
  while (fnRE.test(call))

  return expressions
}

/**
 * Evaluates an expression
 *
 * @param {String} expression
 * @returns {String}
 * @api private
 */

function evalFunctionCall (string, functionIdentifier, callback, call, functionRE) {
  // allow recursivity
  return callback(reduceFunctionCall(string, functionRE, callback), functionIdentifier, call)
}


/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = balanced;
function balanced(a, b, str) {
  if (a instanceof RegExp) a = maybeMatch(a, str);
  if (b instanceof RegExp) b = maybeMatch(b, str);

  var r = range(a, b, str);

  return r && {
    start: r[0],
    end: r[1],
    pre: str.slice(0, r[0]),
    body: str.slice(r[0] + a.length, r[1]),
    post: str.slice(r[1] + b.length)
  };
}

function maybeMatch(reg, str) {
  var m = str.match(reg);
  return m ? m[0] : null;
}

balanced.range = range;
function range(a, b, str) {
  var begs, beg, left, right, result;
  var ai = str.indexOf(a);
  var bi = str.indexOf(b, ai + 1);
  var i = ai;

  if (ai >= 0 && bi > 0) {
    begs = [];
    left = str.length;

    while (i >= 0 && !result) {
      if (i == ai) {
        begs.push(i);
        ai = str.indexOf(a, i + 1);
      } else if (begs.length == 1) {
        result = [ begs.pop(), bi ];
      } else {
        beg = begs.pop();
        if (beg < left) {
          left = beg;
          right = bi;
        }

        bi = str.indexOf(b, i + 1);
      }

      i = ai < bi && ai >= 0 ? ai : bi;
    }

    if (begs.length) {
      result = [ left, right ];
    }
  }

  return result;
}


/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

var Mexp=__webpack_require__(1601);
Mexp.prototype.formulaEval = function () {
	"use strict";
	var stack=[],pop1,pop2,pop3;
	var disp=[];
	var temp='';
	var arr=this.value;
	for(var i=0;i<arr.length;i++){
		if(arr[i].type===1||arr[i].type===3){
			disp.push({value:arr[i].type===3?arr[i].show:arr[i].value,type:1});
		}
		else if(arr[i].type===13){
			disp.push({value:arr[i].show,type:1});
		}
		else if(arr[i].type===0){
			disp[disp.length-1]={value:arr[i].show+(arr[i].show!="-"?"(":"")+disp[disp.length-1].value+(arr[i].show!="-"?")":""),type:0};
		}
		else if(arr[i].type===7){
			disp[disp.length-1]={value:(disp[disp.length-1].type!=1?"(":"")+disp[disp.length-1].value+(disp[disp.length-1].type!=1?")":"")+arr[i].show,type:7};
		}
		else if(arr[i].type===10){
			pop1=disp.pop();
			pop2=disp.pop();
			if(arr[i].show==='P'||arr[i].show==='C')disp.push({value:"<sup>"+pop2.value+"</sup>"+arr[i].show+"<sub>"+pop1.value+"</sub>",type:10});
			else disp.push({value:(pop2.type!=1?"(":"")+pop2.value+(pop2.type!=1?")":"")+"<sup>"+pop1.value+"</sup>",type:1});
		}
		else if(arr[i].type===2||arr[i].type===9){
			pop1=disp.pop();
			pop2=disp.pop();
			disp.push({value:(pop2.type!=1?"(":"")+pop2.value+(pop2.type!=1?")":"")+arr[i].show+(pop1.type!=1?"(":"")+pop1.value+(pop1.type!=1?")":""),type:arr[i].type});
		}
		else if(arr[i].type===12){
			pop1=disp.pop();
			pop2=disp.pop();
			pop3=disp.pop();
			disp.push({value:arr[i].show+"("+pop3.value+","+pop2.value+","+pop1.value+")",type:12});
		}
	}
	return disp[0].value;
};
module.exports=Mexp;

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

var Mexp=__webpack_require__(1602);
Mexp.prototype.postfixEval = function (UserDefined) {
	'use strict';
	UserDefined=UserDefined||{};
	UserDefined.PI=Math.PI;
	UserDefined.E=Math.E;
	var stack=[],pop1,pop2,pop3;
	var disp=[];
	var temp='';
	var arr=this.value;
	var bool=(typeof UserDefined.n!=="undefined");
	for(var i=0;i<arr.length;i++){
		if(arr[i].type===1){
			stack.push({value:arr[i].value,type:1});
		}
		else if(arr[i].type===3){
			stack.push({value:UserDefined[arr[i].value],type:1});
		}
		else if(arr[i].type===0){
			if(typeof stack[stack.length-1].type==="undefined"){
				stack[stack.length-1].value.push(arr[i]);
			}
			else stack[stack.length-1].value=arr[i].value(stack[stack.length-1].value);
		}
		else if(arr[i].type===7){
			if(typeof stack[stack.length-1].type==="undefined"){
				stack[stack.length-1].value.push(arr[i]);
			}
			else stack[stack.length-1].value=arr[i].value(stack[stack.length-1].value);
		}
		else if(arr[i].type===8){
			pop1=stack.pop();
			pop2=stack.pop();
			stack.push({type:1,value:arr[i].value(pop2.value,pop1.value)});
		}
		else if(arr[i].type===10){
			pop1=stack.pop();
			pop2=stack.pop();
			if(typeof pop2.type==="undefined"){
				pop2.value=pop2.concat(pop1);
				pop2.value.push(arr[i]);
				stack.push(pop2);
			}
			else if (typeof pop1.type==="undefined") {
				pop1.unshift(pop2);
				pop1.push(arr[i]);
				stack.push(pop1);
			}
			else{
				stack.push({type:1,value:arr[i].value(pop2.value,pop1.value)});
            }
		}
		else if(arr[i].type===2||arr[i].type===9){
			pop1=stack.pop();
			pop2=stack.pop();
			if(typeof pop2.type==="undefined"){
                console.log(pop2);
				pop2=pop2.concat(pop1);
				pop2.push(arr[i]);
				stack.push(pop2);
			}
			else if (typeof pop1.type==="undefined") {
				pop1.unshift(pop2);
				pop1.push(arr[i]);
				stack.push(pop1);
			}
			else{
				stack.push({type:1,value:arr[i].value(pop2.value,pop1.value)});
			}
		}
		else if(arr[i].type===12){
			pop1=stack.pop();
			if (typeof pop1.type!=="undefined") {
				pop1=[pop1];
			}
			pop2=stack.pop();
			pop3=stack.pop();
			stack.push({type:1,value:arr[i].value(pop3.value,pop2.value,new Mexp(pop1))});
		}
		else if(arr[i].type===13){
			if(bool){
				stack.push({value:UserDefined[arr[i].value],type:3});
			}
			else stack.push([arr[i]]);
		}
	}
	if (stack.length>1) {
		throw(new Mexp.exception("Uncaught Syntax error"));
	}
	return stack[0].value>1000000000000000?"Infinity":parseFloat(stack[0].value.toFixed(15));
};
Mexp.eval=function(str,tokens,obj){
	if (typeof tokens==="undefined") {
		return this.lex(str).toPostfix().postfixEval();
	}
	else if (typeof obj==="undefined") {
		if (typeof tokens.length!=="undefined") 
			return this.lex(str,tokens).toPostfix().postfixEval();
		else
			return this.lex(str).toPostfix().postfixEval(tokens);
	}
	else
		return this.lex(str,tokens).toPostfix().postfixEval(obj);
};
module.exports=Mexp;

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {


    var Mexp=__webpack_require__(1603);

	Mexp.prototype.toPostfix = function () {
		'use strict';
		var post=[],elem,popped,prep,pre,ele;
    	var stack=[{value:"(",type:4,pre:0}];
		var arr=this.value;
		for (var i=1; i < arr.length; i++) {
			if(arr[i].type===1||arr[i].type===3||arr[i].type===13){	//if token is number,constant,or n(which is also a special constant in our case)
				if(arr[i].type===1)
					arr[i].value=Number(arr[i].value);
				post.push(arr[i]);
			}
			else if(arr[i].type===4){
				stack.push(arr[i]);
			}
			else if(arr[i].type===5){
				while((popped=stack.pop()).type!==4){
					post.push(popped);
				}
			}
			else if(arr[i].type===11){
				while((popped=stack.pop()).type!==4){
					post.push(popped);
				}
				stack.push(popped);
			}
			else {
				elem=arr[i];
				pre=elem.pre;
				ele=stack[stack.length-1];
				prep=ele.pre;
				var flag=ele.value=='Math.pow'&&elem.value=='Math.pow';
				if(pre>prep)stack.push(elem);
				else {
					while(prep>=pre&&!flag||flag&&pre<prep){
						popped=stack.pop();
						ele=stack[stack.length-1];
						post.push(popped);
						prep=ele.pre;
						flag=elem.value=='Math.pow'&&ele.value=='Math.pow';
					}
					stack.push(elem);
				}
			}
		}
		return new Mexp(post);
	};
    module.exports=Mexp;

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

var Mexp=__webpack_require__(1604);
	function inc(arr,val){
		for(var i=0;i<arr.length;i++)
			arr[i]+=val;
		return arr;
	}
	var token=['sin','cos','tan','pi','(',')','P','C',
		  'asin','acos','atan','7','8','9','int',
		  'cosh','acosh','ln','^','root','4','5','6','/','!',
		  'tanh','atanh','Mod','1','2','3','*',
		  'sinh','asinh','e','log','0','.','+','-',',','Sigma','n','Pi','pow'];
	var show=['sin','cos','tan','&pi;','(',')','P','C',
		'asin','acos','atan','7','8','9','Int',
		'cosh','acosh',' ln','^','root','4','5','6','&divide;','!',
		'tanh','atanh',' Mod ','1','2','3','&times;',
		'sinh','asinh','e',' log','0','.','+','-',',','&Sigma;','n','&Pi;','pow'];
	var eva=[Mexp.math.sin,Mexp.math.cos,Mexp.math.tan,'PI','(',')',Mexp.math.P,Mexp.math.C,
		Mexp.math.asin,Mexp.math.acos,Mexp.math.atan,'7','8','9',Math.floor,
		Mexp.math.cosh,Mexp.math.acosh,Math.log,Math.pow,Math.sqrt,'4','5','6',Mexp.math.div,Mexp.math.fact,
		Mexp.math.tanh,Mexp.math.atanh,Mexp.math.mod,'1','2','3',Mexp.math.mul,
		Mexp.math.sinh,Mexp.math.asinh,'E',Mexp.math.log,'0','.',Mexp.math.add,Mexp.math.sub,',',Mexp.math.sigma,'n',Mexp.math.Pi,Math.pow];
	var preced={0:11,1:0,2:3,3:0,4:0,5:0,6:0,7:11,8:11,9:1,10:10,11:0,12:11,13:0};
	var type=[0,0,0,3,4,5,10,10,
		0,0,0,1,1,1,0,
		0,0,0,10,0,1,1,1,2,7,
		0,0,2,1,1,1,2,
		0,0,3,0,1,6,9,9,11,12,13,12,8];
	 /*
	0 : function with syntax function_name(Maths_exp)
	1 : numbers
	2 : binary operators like * / Mod left associate and same precedence
	3 : Math constant values like e,pi,Cruncher ans
	4 : opening bracket
	5 : closing bracket
	6 : decimal
	7 : function with syntax (Math_exp)function_name
	8: function with syntax function_name(Math_exp1,Math_exp2)
	9 : binary operator like +,-
	10: binary operator like P C or ^
	11: ,
	12: function with , seperated three parameters
	13: variable of Sigma function
	 */
	var type0={0:true,1:true,3:true,4:true,6:true,8:true,9:true,12:true,13:true},//type2:true,type4:true,type9:true,type11:true,type21:true,type22
	type1={0:true,1:true,2:true,3:true,4:true,5:true,6:true,7:true,8:true,9:true,10:true,11:true,12:true,13:true},//type3:true,type5:true,type7:true,type23
	type_1={0:true,3:true,4:true,8:true,12:true,13:true},
	empty={},
	type_3={0:true,1:true,3:true,4:true,6:true,8:true,12:true,13:true},//type_5:true,type_7:true,type_23
	type6={1:true},
	newAr=[[],
			["1","2","3","7","8","9","4","5","6","+","-","*","/","(",")","^","!","P","C","e","0",".",",","n"],
			["pi","ln","Pi"],
			["sin","cos","tan","Del","int","Mod","log","pow"],
			["asin","acos","atan","cosh","root","tanh","sinh"],
			["acosh","atanh","asinh","Sigma"]];
	function match(str1,str2,i,x){
		for(var f=0;f<x;f++){
			if (str1[i+f]!==str2[f])
				return false;
		}
		return true;
	}
	Mexp.addToken=function(tokens){
		for(i=0;i<tokens.length;i++){
			x=tokens[i].token.length;
			var temp=-1;

			//newAr is a specially designed data structure in which 1D array at location one of 2d array has all string with length 1 2 with 2 and so on

			if (x<newAr.length)	//match to check if token is really huge and not existing
								//if not checked it will break in next line as undefined index
				for(y=0;y<newAr[x].length;y++){
					if (tokens[i].token===newAr[x][y]){
						temp=token.indexOf(newAr[x][y]);
						break;
					}
				}
			if (temp===-1) {
				token.push(tokens[i].token);
				type.push(tokens[i].type);
				if(newAr.length<=tokens[i].token.length)
					newAr[tokens[i].token.length]=[];
				newAr[tokens[i].token.length].push(tokens[i].token);
				eva.push(tokens[i].value);
				show.push(tokens[i].show);
			}
			else {
				token[temp]=tokens[i].token;
				type[temp]=tokens[i].type;
				eva[temp]=tokens[i].value;
				show[temp]=tokens[i].show;
			}
		}
	};
	Mexp.lex=function(inp,tokens){
		'use strict';
		var str=[{type:4,value:"(",show:"(",pre:0}];
		var ptc=[];	//Parenthesis to close at the beginning is after one token
		var inpStr=inp;
		var key;
        var pcounter=0;
		var allowed=type0;
		var bracToClose=0;
		var asterick=empty;
		var prevKey='';
		var i,x,y;
		if(typeof tokens!=="undefined")
			Mexp.addToken(tokens);
		var obj={};
		for(i=0;i<inpStr.length;i++){
			if (inpStr[i]==' ') {
				continue;
			}
			key='';
			sec:for(x=(inpStr.length-i>(newAr.length-2)?newAr.length-1:inpStr.length-i);x>0;x--){
				for(y=0;y<newAr[x].length;y++){
					if (match(inpStr,newAr[x][y],i,x)){
						key=newAr[x][y];
						break sec;
					}
				}
			}
			i+=key.length-1;
			if(key===''){
				throw(new Mexp.exception("Can't understand after "+inpStr.slice(i)));
			}
			var index=token.indexOf(key);
			var cToken=key;
			var cType=type[index];
			var cEv=eva[index];
			var cPre=preced[cType];
			var	cShow=show[index];
			var pre=str[str.length-1];
			for(j=ptc.length;j--;){	//loop over ptc
				if(ptc[j]===0){
					if([0,2,3,5,9,11,12,13].indexOf(cType)!==-1){
						if(allowed[cType]!==true){
							throw(new Mexp.exception(key+" is not allowed after "+prevKey));
						}
						str.push({value:")",type:5,pre:0,show:")"});
						allowed=type1;
						asterick=type_3;
						inc(ptc,-1).pop();
					}
				}
			}
			if(allowed[cType]!==true){
				throw(new Mexp.exception(key+" is not allowed after "+prevKey));
			}
			if(asterick[cType]===true){
				cType=2;
				cEv=Mexp.math.mul;
				cShow="&times;";
				cPre=3;
				i=i-key.length;
		 	}
			obj={value:cEv,type:cType,pre:cPre,show:cShow};
			if(cType===0){
				allowed=type0;
				asterick=empty;
				inc(ptc,2).push(2);
				str.push(obj);
				str.push({value:"(",type:4,pre:0,show:"("});
			}
			else if(cType===1){
				if(pre.type===1){
					pre.value+=cEv;
					inc(ptc,1);
				}
				else {
					str.push(obj);
				}
				allowed=type1;
				asterick=type_1;
			}
			else if(cType===2){
				allowed=type0;
				asterick=empty;
				inc(ptc,2);
				str.push(obj);
			}
			else if(cType===3){//constant
				str.push(obj);
				allowed=type1;
				asterick=type_3;
			}
			else if(cType===4){
                pcounter+=ptc.length;
                ptc=[];
				bracToClose++;
				allowed=type0;
				asterick=empty;
				str.push(obj);
			}
			else if(cType===5){
				if(!bracToClose){
					throw(new Mexp.exception("Closing parenthesis are more than opening one, wait What!!!"));
				}
                while(pcounter--){	//loop over ptc
    						str.push({value:")",type:5,pre:0,show:")"});
    			}
                pcounter=0;
				bracToClose--;
				allowed=type1;
				asterick=type_3;
				str.push(obj);
			}
			else if(cType===6){
				if(pre.hasDec){
					throw(new Mexp.exception("Two decimals are not allowed in one number"));
				}
				if(pre.type!==1){
					pre={value:0,type:1,pre:0};	//pre needs to be changed as it will the last value now to be safe in later code
					str.push(pre);
					inc(ptc,-1);
				}
				allowed=type6;
				inc(ptc,1);
				asterick=empty;
				pre.value+=cEv;
				pre.hasDec=true;
			}
			else if(cType===7){
				allowed=type1;
				asterick=type_3;
				inc(ptc,1);
				str.push(obj);
			}
			if(cType===8){
				allowed=type0;
				asterick=empty;
				inc(ptc,4).push(4);
				str.push(obj);
				str.push({value:"(",type:4,pre:0,show:"("});
			}
			else if(cType===9){
				if(pre.type===9){
					if(pre.value===Mexp.math.add){
						pre.value=cEv;
						pre.show=cShow;
						inc(ptc,1);
					}
					else if(pre.value===Mexp.math.sub&&cShow==='-'){
						pre.value=Mexp.math.add;
						pre.show='+';
						inc(ptc,1);
					}
				}
				else if(pre.type!==5&&pre.type!==7&&pre.type!==1&&pre.type!==3&&pre.type!==13){//changesign only when negative is found
					if(cToken==='-'){//do nothing for + token
									//don't add with the above if statement as that will run the else statement of parent if on Ctoken +
						allowed=type0;
						asterick=empty;
						inc(ptc,2).push(2);
						str.push({value:Mexp.math.changeSign,type:0,pre:21,show:"-"});
						str.push({value:"(",type:4,pre:0,show:"("});
					}
				}
				else{
					str.push(obj);
					inc(ptc,2);
				}
				allowed=type0;
				asterick=empty;
			}
			else if(cType===10){
				allowed=type0;
				asterick=empty;
				inc(ptc,2);
				str.push(obj);
			}
			else if(cType===11){
				allowed=type0;
				asterick=empty;
				str.push(obj);
			}
			else if(cType===12){
				allowed=type0;
				asterick=empty;
				inc(ptc,6).push(6);
				str.push(obj);
				str.push({value:"(",type:4,pre:0});
			}
			else if(cType===13){
				allowed=type1;
				asterick=type_3;
				str.push(obj);
			}
			inc(ptc,-1);
			prevKey=key;
		}
		for(var j=ptc.length;j--;){	//loop over ptc
			if(ptc[j]===0){

				str.push({value:")",show:")",type:5,pre:3});
				inc(ptc,-1).pop();
			}
		}
		if (allowed[5]!==true) {
			throw(new Mexp.exception("complete the expression"));
		}
		while(bracToClose--)
			str.push({value:")",show:")",type:5,pre:3});

		str.push({type:5,value:")",show:")",pre:0});
//        console.log(str);
		return new Mexp(str);
	};
    module.exports=Mexp;


/***/ }),
/* 1604 */
/***/ (function(module, exports) {

	var Mexp=function(parsed){
		this.value=parsed;

	};

	Mexp.math={
		isDegree:true, //mode of calculator
		acos:function(x){
			return (Mexp.math.isDegree?180/Math.PI*Math.acos(x):Math.acos(x));
		},
		add:function(a,b){
			return a+b;
		},
		asin:function(x){
			return (Mexp.math.isDegree?180/Math.PI*Math.asin(x):Math.asin(x));
		},
		atan:function(x){
			return (Mexp.math.isDegree?180/Math.PI*Math.atan(x):Math.atan(x));
		},
		acosh:function(x){
			return Math.log(x+Math.sqrt(x*x-1));
		},
		asinh:function(x){
			return Math.log(x+Math.sqrt(x*x+1));
		},
		atanh:function(x){
			return Math.log((1+x)/(1-x));
		},
		C:function(n,r){
			var pro=1,other=n-r,choice=r;
			if(choice<other){
			choice=other;
			other=r;
			}
			for(var i=choice+1;i<=n;i++)
				pro*=i;
			return pro/Mexp.math.fact(other);
		},
		changeSign:function(x){
			return -x;
		},
		cos:function(x){
			if(Mexp.math.isDegree)x=Mexp.math.toRadian(x);
			return Math.cos(x);
		},
		cosh:function(x){
			return (Math.pow(Math.E,x)+Math.pow(Math.E,-1*x))/2;
		},
		div:function(a,b){
		return a/b;
		},
		fact:function(n) {
		if(n%1!==0)return "NAN";
			var pro=1;
			for(var i=2;i<=n;i++)
				pro*=i;
			return pro;
		},
		inverse:function(x){
			return 1/x;
		},
		log:function(i){
			return Math.log(i)/Math.log(10);
		},
		mod:function(a,b){
		return a%b;
		},
		mul:function(a,b){
		return a*b;
		},
		P:function(n,r){var pro=1;
			 for(var i=Math.floor(n)-Math.floor(r)+1;i<=Math.floor(n);i++)
					pro*=i;
					return pro;

		},
		Pi:function(low,high,ex){
			var pro=1;
			for(var i=low;i<=high;i++){
				pro*=Number(ex.postfixEval({n:i}));
			}
			return pro;
		},
		pow10x:function(e){
			var x=1;
			while(e--){x*=10;}
			return x;
		},
		sigma:function(low,high,ex){
			var sum=0;
			for(var i=low;i<=high;i++){
				sum+=Number(ex.postfixEval({n:i}));
			}
			return sum;
		},
		sin:function(x){
			if(Mexp.math.isDegree)x=Mexp.math.toRadian(x);
			return Math.sin(x);
		},
		sinh:function(x){
			return (Math.pow(Math.E,x)-Math.pow(Math.E,-1*x))/2;
		},
		sub:function(a,b){
		return a-b;
		},
		tan:function(x){
			if(Mexp.math.isDegree)x=Mexp.math.toRadian(x);
			return Math.tan(x);
		},
		tanh:function(x){
			return Mexp.sinha(x)/Mexp.cosha(x);
		},
		toRadian:function(x){
			return x*Math.PI/180;
		}
	};
	Mexp.exception=function(message){
		this.message=message;
	};
    module.exports=Mexp;

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(308),
    map = __webpack_require__(836);

/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */
function flatMap(collection, iteratee) {
  return baseFlatten(map(collection, iteratee), 1);
}

module.exports = flatMap;


/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "getTickValues", {
  enumerable: true,
  get: function get() {
    return _getNiceTickValues.getTickValues;
  }
});
Object.defineProperty(exports, "getNiceTickValues", {
  enumerable: true,
  get: function get() {
    return _getNiceTickValues.getNiceTickValues;
  }
});
Object.defineProperty(exports, "getTickValuesFixedDomain", {
  enumerable: true,
  get: function get() {
    return _getNiceTickValues.getTickValuesFixedDomain;
  }
});

var _getNiceTickValues = __webpack_require__(1607);

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTickValuesFixedDomain = exports.getTickValues = exports.getNiceTickValues = void 0;

var _decimal = _interopRequireDefault(__webpack_require__(737));

var _utils = __webpack_require__(738);

var _arithmetic = _interopRequireDefault(__webpack_require__(1608));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Calculate a interval of a minimum value and a maximum value
 *
 * @param  {Number} min       The minimum value
 * @param  {Number} max       The maximum value
 * @return {Array} An interval
 */
function getValidInterval(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      min = _ref2[0],
      max = _ref2[1];

  var validMin = min,
      validMax = max; // exchange

  if (min > max) {
    validMin = max;
    validMax = min;
  }

  return [validMin, validMax];
}
/**
 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
 *
 * @param  {Decimal} roughStep        The rough step calculated by deviding the
 * difference by the tickCount
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Integer} correctionFactor A correction factor
 * @return {Decimal} The step which is easy to understand between two ticks
 */


function getFormatStep(roughStep, allowDecimals, correctionFactor) {
  if (roughStep.lte(0)) {
    return new _decimal.default(0);
  }

  var digitCount = _arithmetic.default.getDigitCount(roughStep.toNumber()); // The ratio between the rough step and the smallest number which has a bigger
  // order of magnitudes than the rough step


  var digitCountValue = new _decimal.default(10).pow(digitCount);
  var stepRatio = roughStep.div(digitCountValue); // When an integer and a float multiplied, the accuracy of result may be wrong

  var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
  var amendStepRatio = new _decimal.default(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
  var formatStep = amendStepRatio.mul(digitCountValue);
  return allowDecimals ? formatStep : new _decimal.default(Math.ceil(formatStep));
}
/**
 * calculate the ticks when the minimum value equals to the maximum value
 *
 * @param  {Number}  value         The minimum valuue which is also the maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}                 ticks
 */


function getTickOfSingleValue(value, tickCount, allowDecimals) {
  var step = 1; // calculate the middle value of ticks

  var middle = new _decimal.default(value);

  if (!middle.isint() && allowDecimals) {
    var absVal = Math.abs(value);

    if (absVal < 1) {
      // The step should be a float number when the difference is smaller than 1
      step = new _decimal.default(10).pow(_arithmetic.default.getDigitCount(value) - 1);
      middle = new _decimal.default(Math.floor(middle.div(step).toNumber())).mul(step);
    } else if (absVal > 1) {
      // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
      middle = new _decimal.default(Math.floor(value));
    }
  } else if (value === 0) {
    middle = new _decimal.default(Math.floor((tickCount - 1) / 2));
  } else if (!allowDecimals) {
    middle = new _decimal.default(Math.floor(value));
  }

  var middleIndex = Math.floor((tickCount - 1) / 2);
  var fn = (0, _utils.compose)((0, _utils.map)(function (n) {
    return middle.add(new _decimal.default(n - middleIndex).mul(step)).toNumber();
  }), _utils.range);
  return fn(0, tickCount);
}
/**
 * Calculate the step
 *
 * @param  {Number}  min              The minimum value of an interval
 * @param  {Number}  max              The maximum value of an interval
 * @param  {Integer} tickCount        The count of ticks
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Number}  correctionFactor A correction factor
 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
 */


function calculateStep(min, max, tickCount, allowDecimals) {
  var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

  // dirty hack (for recharts' test)
  if (!Number.isFinite((max - min) / (tickCount - 1))) {
    return {
      step: new _decimal.default(0),
      tickMin: new _decimal.default(0),
      tickMax: new _decimal.default(0)
    };
  } // The step which is easy to understand between two ticks


  var step = getFormatStep(new _decimal.default(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor); // A medial value of ticks

  var middle; // When 0 is inside the interval, 0 should be a tick

  if (min <= 0 && max >= 0) {
    middle = new _decimal.default(0);
  } else {
    // calculate the middle value
    middle = new _decimal.default(min).add(max).div(2); // minus modulo value

    middle = middle.sub(new _decimal.default(middle).mod(step));
  }

  var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
  var upCount = Math.ceil(new _decimal.default(max).sub(middle).div(step).toNumber());
  var scaleCount = belowCount + upCount + 1;

  if (scaleCount > tickCount) {
    // When more ticks need to cover the interval, step should be bigger.
    return calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
  }

  if (scaleCount < tickCount) {
    // When less ticks can cover the interval, we should add some additional ticks
    upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
    belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
  }

  return {
    step: step,
    tickMin: middle.sub(new _decimal.default(belowCount).mul(step)),
    tickMax: middle.add(new _decimal.default(upCount).mul(step))
  };
}
/**
 * Calculate the ticks of an interval, the count of ticks will be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */


function getNiceTickValuesFn(_ref3) {
  var _ref4 = _slicedToArray(_ref3, 2),
      min = _ref4[0],
      max = _ref4[1];

  var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  // More than two ticks should be return
  var count = Math.max(tickCount, 2);

  var _getValidInterval = getValidInterval([min, max]),
      _getValidInterval2 = _slicedToArray(_getValidInterval, 2),
      cormin = _getValidInterval2[0],
      cormax = _getValidInterval2[1];

  if (cormin === -Infinity || cormax === Infinity) {
    var _values = cormax === Infinity ? [cormin].concat(_toConsumableArray((0, _utils.range)(0, tickCount - 1).map(function () {
      return Infinity;
    }))) : _toConsumableArray((0, _utils.range)(0, tickCount - 1).map(function () {
      return -Infinity;
    })).concat([cormax]);

    return min > max ? (0, _utils.reverse)(_values) : _values;
  }

  if (cormin === cormax) {
    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
  } // Get the step between two ticks


  var _calculateStep = calculateStep(cormin, cormax, count, allowDecimals),
      step = _calculateStep.step,
      tickMin = _calculateStep.tickMin,
      tickMax = _calculateStep.tickMax;

  var values = _arithmetic.default.rangeStep(tickMin, tickMax.add(new _decimal.default(0.1).mul(step)), step);

  return min > max ? (0, _utils.reverse)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */


function getTickValuesFn(_ref5) {
  var _ref6 = _slicedToArray(_ref5, 2),
      min = _ref6[0],
      max = _ref6[1];

  var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  // More than two ticks should be return
  var count = Math.max(tickCount, 2);

  var _getValidInterval3 = getValidInterval([min, max]),
      _getValidInterval4 = _slicedToArray(_getValidInterval3, 2),
      cormin = _getValidInterval4[0],
      cormax = _getValidInterval4[1];

  if (cormin === -Infinity || cormax === Infinity) {
    return [min, max];
  }

  if (cormin === cormax) {
    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
  }

  var step = getFormatStep(new _decimal.default(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
  var fn = (0, _utils.compose)((0, _utils.map)(function (n) {
    return new _decimal.default(cormin).add(new _decimal.default(n).mul(step)).toNumber();
  }), _utils.range);
  var values = fn(0, count).filter(function (entry) {
    return entry >= cormin && entry <= cormax;
  });
  return min > max ? (0, _utils.reverse)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed,
 * but the domain will be guaranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */


function getTickValuesFixedDomainFn(_ref7, tickCount) {
  var _ref8 = _slicedToArray(_ref7, 2),
      min = _ref8[0],
      max = _ref8[1];

  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  // More than two ticks should be return
  var _getValidInterval5 = getValidInterval([min, max]),
      _getValidInterval6 = _slicedToArray(_getValidInterval5, 2),
      cormin = _getValidInterval6[0],
      cormax = _getValidInterval6[1];

  if (cormin === -Infinity || cormax === Infinity) {
    return [min, max];
  }

  if (cormin === cormax) {
    return [cormin];
  }

  var count = Math.max(tickCount, 2);
  var step = getFormatStep(new _decimal.default(cormax).sub(cormin).div(count - 1), allowDecimals, 0);

  var values = _toConsumableArray(_arithmetic.default.rangeStep(new _decimal.default(cormin), new _decimal.default(cormax).sub(new _decimal.default(0.99).mul(step)), step)).concat([cormax]);

  return min > max ? (0, _utils.reverse)(values) : values;
}

var getNiceTickValues = (0, _utils.memoize)(getNiceTickValuesFn);
exports.getNiceTickValues = getNiceTickValues;
var getTickValues = (0, _utils.memoize)(getTickValuesFn);
exports.getTickValues = getTickValues;
var getTickValuesFixedDomain = (0, _utils.memoize)(getTickValuesFixedDomainFn);
exports.getTickValuesFixedDomain = getTickValuesFixedDomain;

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _decimal = _interopRequireDefault(__webpack_require__(737));

var _utils = __webpack_require__(738);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @fileOverview 一些公用的运算方法
 * @author xile611
 * @date 2015-09-17
 */

/**
 * 获取数值的位数
 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
 *
 * @param  {Number} value 数值
 * @return {Integer} 位数
 */
function getDigitCount(value) {
  var result;

  if (value === 0) {
    result = 1;
  } else {
    result = Math.floor(new _decimal.default(value).abs().log(10).toNumber()) + 1;
  }

  return result;
}
/**
 * 按照固定的步长获取[start, end)这个区间的数据
 * 并且需要处理js计算精度的问题
 *
 * @param  {Decimal} start 起点
 * @param  {Decimal} end   终点，不包含该值
 * @param  {Decimal} step  步长
 * @return {Array}         若干数值
 */


function rangeStep(start, end, step) {
  var num = new _decimal.default(start);
  var result = [];

  while (num.lt(end)) {
    result.push(num.toNumber());
    num = num.add(step);
  }

  return result;
}
/**
 * 对数值进行线性插值
 *
 * @param  {Number} a  定义域的极点
 * @param  {Number} b  定义域的极点
 * @param  {Number} t  [0, 1]内的某个值
 * @return {Number}    定义域内的某个值
 */


var interpolateNumber = (0, _utils.curry)(function (a, b, t) {
  var newA = +a;
  var newB = +b;
  return newA + t * (newB - newA);
});
/**
 * 线性插值的逆运算
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
 */

var uninterpolateNumber = (0, _utils.curry)(function (a, b, x) {
  var diff = b - +a;
  diff = diff || Infinity;
  return (x - a) / diff;
});
/**
 * 线性插值的逆运算，并且有截断的操作
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
 */

var uninterpolateTruncation = (0, _utils.curry)(function (a, b, x) {
  var diff = b - +a;
  diff = diff || Infinity;
  return Math.max(0, Math.min(1, (x - a) / diff));
});
var _default = {
  rangeStep: rangeStep,
  getDigitCount: getDigitCount,
  interpolateNumber: interpolateNumber,
  uninterpolateNumber: uninterpolateNumber,
  uninterpolateTruncation: uninterpolateTruncation
};
exports.default = _default;

/***/ }),
/* 1609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = band;
/* harmony export (immutable) */ __webpack_exports__["b"] = point;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__init__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ordinal__ = __webpack_require__(752);




function band() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_2__ordinal__["a" /* default */])().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      range = [0, 1],
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = range[1] < range[0],
        start = range[reverse - 0],
        stop = range[1 - reverse];
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["e" /* range */])(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = [+_[0], +_[1]], round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band(domain(), range)
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return __WEBPACK_IMPORTED_MODULE_1__init__["b" /* initRange */].apply(rescale(), arguments);
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function() {
    return pointish(copy());
  };

  return scale;
}

function point() {
  return pointish(band.apply(null, arguments).paddingInner(1));
}


/***/ }),
/* 1610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pairs__ = __webpack_require__(742);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values0, values1, reduce) {
  var n0 = values0.length,
      n1 = values1.length,
      values = new Array(n0 * n1),
      i0,
      i1,
      i,
      value0;

  if (reduce == null) reduce = __WEBPACK_IMPORTED_MODULE_0__pairs__["a" /* pair */];

  for (i0 = i = 0; i0 < n0; ++i0) {
    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
      values[i] = reduce(value0, values1[i1]);
    }
  }

  return values;
});


/***/ }),
/* 1611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 1612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisect__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(1613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extent__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__identity__ = __webpack_require__(1614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__range__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ticks__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__ = __webpack_require__(749);









/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */],
      domain = __WEBPACK_IMPORTED_MODULE_3__extent__["a" /* default */],
      threshold = __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__["a" /* default */];

  function histogram(data) {
    var i,
        n = data.length,
        x,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      tz = Object(__WEBPACK_IMPORTED_MODULE_6__ticks__["c" /* tickStep */])(x0, x1, tz);
      tz = Object(__WEBPACK_IMPORTED_MODULE_5__range__["a" /* default */])(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
    }

    // Remove any thresholds outside the domain.
    var m = tz.length;
    while (tz[0] <= x0) tz.shift(), --m;
    while (tz[m - 1] > x1) tz.pop(), --m;

    var bins = new Array(m + 1),
        bin;

    // Initialize bins.
    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    }

    // Assign data to bins by value, ignoring any outside the domain.
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x0 <= x && x <= x1) {
        bins[Object(__WEBPACK_IMPORTED_MODULE_1__bisect__["a" /* default */])(tz, x, 0, m)].push(data[i]);
      }
    }

    return bins;
  }

  histogram.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : value;
  };

  histogram.domain = function(_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["b" /* slice */].call(_)) : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : threshold;
  };

  return histogram;
});


/***/ }),
/* 1613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 1614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 1615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__quantile__ = __webpack_require__(401);





/* unused harmony default export */ var _unused_webpack_default_export = (function(values, min, max) {
  values = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(values, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]).sort(__WEBPACK_IMPORTED_MODULE_1__ascending__["a" /* default */]);
  return Math.ceil((max - min) / (2 * (Object(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.75) - Object(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.25)) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 1616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deviation__ = __webpack_require__(743);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, min, max) {
  return Math.ceil((max - min) / (3.5 * Object(__WEBPACK_IMPORTED_MODULE_0__deviation__["a" /* default */])(values) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 1617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  return max;
});


/***/ }),
/* 1618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(224);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      m = n,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) sum += value;
      else --m;
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) sum += value;
      else --m;
    }
  }

  if (m) return sum / m;
});


/***/ }),
/* 1619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__number__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__quantile__ = __webpack_require__(401);




/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      numbers = [];

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(values[i]))) {
        numbers.push(value);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(valueof(values[i], i, values)))) {
        numbers.push(value);
      }
    }
  }

  return Object(__WEBPACK_IMPORTED_MODULE_2__quantile__["a" /* default */])(numbers.sort(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]), 0.5);
});


/***/ }),
/* 1620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(arrays) {
  var n = arrays.length,
      m,
      i = -1,
      j = 0,
      merged,
      array;

  while (++i < n) j += arrays[i].length;
  merged = new Array(j);

  while (--n >= 0) {
    array = arrays[n];
    m = array.length;
    while (--m >= 0) {
      merged[--j] = array[m];
    }
  }

  return merged;
});


/***/ }),
/* 1621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, indexes) {
  var i = indexes.length, permutes = new Array(i);
  while (i--) permutes[i] = array[indexes[i]];
  return permutes;
});


/***/ }),
/* 1622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(190);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, compare) {
  if (!(n = values.length)) return;
  var n,
      i = 0,
      j = 0,
      xi,
      xj = values[j];

  if (compare == null) compare = __WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */];

  while (++i < n) {
    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
      xj = xi, j = i;
    }
  }

  if (compare(xj, xj) === 0) return j;
});


/***/ }),
/* 1623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, i0, i1) {
  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m + i0];
    array[m + i0] = array[i + i0];
    array[i + i0] = t;
  }

  return array;
});


/***/ }),
/* 1624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    }
  }

  else {
    while (++i < n) {
      if (value = +valueof(values[i], i, values)) sum += value;
    }
  }

  return sum;
});


/***/ }),
/* 1625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transpose__ = __webpack_require__(751);


/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__transpose__["a" /* default */])(arguments);
});


/***/ }),
/* 1626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nest__ = __webpack_require__(1627);
/* unused harmony reexport nest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__set__ = __webpack_require__(1628);
/* unused harmony reexport set */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__map__ = __webpack_require__(402);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__map__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__keys__ = __webpack_require__(1629);
/* unused harmony reexport keys */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__values__ = __webpack_require__(1630);
/* unused harmony reexport values */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__entries__ = __webpack_require__(1631);
/* unused harmony reexport entries */








/***/ }),
/* 1627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(402);


/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var keys = [],
      sortKeys = [],
      sortValues,
      rollup,
      nest;

  function apply(array, depth, createResult, setResult) {
    if (depth >= keys.length) {
      if (sortValues != null) array.sort(sortValues);
      return rollup != null ? rollup(array) : array;
    }

    var i = -1,
        n = array.length,
        key = keys[depth++],
        keyValue,
        value,
        valuesByKey = Object(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])(),
        values,
        result = createResult();

    while (++i < n) {
      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
        values.push(value);
      } else {
        valuesByKey.set(keyValue, [value]);
      }
    }

    valuesByKey.each(function(values, key) {
      setResult(result, key, apply(values, depth, createResult, setResult));
    });

    return result;
  }

  function entries(map, depth) {
    if (++depth > keys.length) return map;
    var array, sortKey = sortKeys[depth - 1];
    if (rollup != null && depth >= keys.length) array = map.entries();
    else array = [], map.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
  }

  return nest = {
    object: function(array) { return apply(array, 0, createObject, setObject); },
    map: function(array) { return apply(array, 0, createMap, setMap); },
    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
    key: function(d) { keys.push(d); return nest; },
    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
    sortValues: function(order) { sortValues = order; return nest; },
    rollup: function(f) { rollup = f; return nest; }
  };
});

function createObject() {
  return {};
}

function setObject(object, key, value) {
  object[key] = value;
}

function createMap() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])();
}

function setMap(map, key, value) {
  map.set(key, value);
}


/***/ }),
/* 1628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(402);


function Set() {}

var proto = __WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */].prototype;

Set.prototype = set.prototype = {
  constructor: Set,
  has: proto.has,
  add: function(value) {
    value += "";
    this[__WEBPACK_IMPORTED_MODULE_0__map__["b" /* prefix */] + value] = value;
    return this;
  },
  remove: proto.remove,
  clear: proto.clear,
  values: proto.keys,
  size: proto.size,
  empty: proto.empty,
  each: proto.each
};

function set(object, f) {
  var set = new Set;

  // Copy constructor.
  if (object instanceof Set) object.each(function(value) { set.add(value); });

  // Otherwise, assume it’s an array.
  else if (object) {
    var i = -1, n = object.length;
    if (f == null) while (++i < n) set.add(object[i]);
    else while (++i < n) set.add(f(object[i], i, object));
  }

  return set;
}

/* unused harmony default export */ var _unused_webpack_default_export = (set);


/***/ }),
/* 1629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var keys = [];
  for (var key in map) keys.push(key);
  return keys;
});


/***/ }),
/* 1630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var values = [];
  for (var key in map) values.push(map[key]);
  return values;
});


/***/ }),
/* 1631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var entries = [];
  for (var key in map) entries.push({key: key, value: map[key]});
  return entries;
});


/***/ }),
/* 1632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = identity;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(761);




function identity(domain) {
  var unknown;

  function scale(x) {
    return isNaN(x = +x) ? unknown : x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]), scale) : domain.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return identity(domain).unknown(unknown);
  };

  domain = arguments.length ? __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(domain, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]) : [0, 1];

  return Object(__WEBPACK_IMPORTED_MODULE_1__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 1633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(403);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__value__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(757);
/* unused harmony reexport interpolateArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basis__ = __webpack_require__(406);
/* unused harmony reexport interpolateBasis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__basisClosed__ = __webpack_require__(755);
/* unused harmony reexport interpolateBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__date__ = __webpack_require__(758);
/* unused harmony reexport interpolateDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__discrete__ = __webpack_require__(1636);
/* unused harmony reexport interpolateDiscrete */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hue__ = __webpack_require__(1637);
/* unused harmony reexport interpolateHue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__number__ = __webpack_require__(287);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__number__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__object__ = __webpack_require__(759);
/* unused harmony reexport interpolateObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__round__ = __webpack_require__(1638);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_9__round__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__string__ = __webpack_require__(760);
/* unused harmony reexport interpolateString */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__transform_index__ = __webpack_require__(1639);
/* unused harmony reexport interpolateTransformCss */
/* unused harmony reexport interpolateTransformSvg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zoom__ = __webpack_require__(1642);
/* unused harmony reexport interpolateZoom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__rgb__ = __webpack_require__(754);
/* unused harmony reexport interpolateRgb */
/* unused harmony reexport interpolateRgbBasis */
/* unused harmony reexport interpolateRgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__hsl__ = __webpack_require__(1643);
/* unused harmony reexport interpolateHsl */
/* unused harmony reexport interpolateHslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lab__ = __webpack_require__(1644);
/* unused harmony reexport interpolateLab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hcl__ = __webpack_require__(1645);
/* unused harmony reexport interpolateHcl */
/* unused harmony reexport interpolateHclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__cubehelix__ = __webpack_require__(1646);
/* unused harmony reexport interpolateCubehelix */
/* unused harmony reexport interpolateCubehelixLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__piecewise__ = __webpack_require__(1647);
/* unused harmony reexport piecewise */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__quantize__ = __webpack_require__(1648);
/* unused harmony reexport quantize */






















/***/ }),
/* 1634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gray */
/* harmony export (immutable) */ __webpack_exports__["a"] = lab;
/* unused harmony export Lab */
/* unused harmony export lch */
/* harmony export (immutable) */ __webpack_exports__["b"] = hcl;
/* unused harmony export Hcl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define_js__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_js__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math_js__ = __webpack_require__(753);




// https://observablehq.com/@mbostock/lab-and-rgb
var K = 18,
    Xn = 0.96422,
    Yn = 1,
    Zn = 0.82521,
    t0 = 4 / 29,
    t1 = 6 / 29,
    t2 = 3 * t1 * t1,
    t3 = t1 * t1 * t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) return hcl2lab(o);
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color_js__["b" /* Rgb */])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["h" /* rgbConvert */])(o);
  var r = rgb2lrgb(o.r),
      g = rgb2lrgb(o.g),
      b = rgb2lrgb(o.b),
      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
  if (r === g && g === b) x = z = y; else {
    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
  }
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function gray(l, opacity) {
  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
}

function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Lab, lab, Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* Color */], {
  brighter: function(k) {
    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function(k) {
    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    x = Xn * lab2xyz(x);
    y = Yn * lab2xyz(y);
    z = Zn * lab2xyz(z);
    return new __WEBPACK_IMPORTED_MODULE_1__color_js__["b" /* Rgb */](
      lrgb2rgb( 3.1338561 * x - 1.6168667 * y - 0.4906146 * z),
      lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z),
      lrgb2rgb( 0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
      this.opacity
    );
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}

function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}

function lrgb2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2lrgb(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
  var h = Math.atan2(o.b, o.a) * __WEBPACK_IMPORTED_MODULE_2__math_js__["b" /* rad2deg */];
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function lch(l, c, h, opacity) {
  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

function hcl2lab(o) {
  if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
  var h = o.h * __WEBPACK_IMPORTED_MODULE_2__math_js__["a" /* deg2rad */];
  return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}

Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Hcl, hcl, Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* Color */], {
  brighter: function(k) {
    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
  },
  darker: function(k) {
    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
  },
  rgb: function() {
    return hcl2lab(this).rgb();
  }
}));


/***/ }),
/* 1635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cubehelix;
/* unused harmony export Cubehelix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define_js__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_js__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math_js__ = __webpack_require__(753);




var A = -0.14861,
    B = +1.78277,
    C = -0.29227,
    D = -0.90649,
    E = +1.97294,
    ED = E * D,
    EB = E * B,
    BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color_js__["b" /* Rgb */])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["h" /* rgbConvert */])(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
      h = s ? Math.atan2(k, bl) * __WEBPACK_IMPORTED_MODULE_2__math_js__["b" /* rad2deg */] - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Cubehelix, cubehelix, Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* Color */], {
  brighter: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color_js__["c" /* brighter */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color_js__["c" /* brighter */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color_js__["d" /* darker */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color_js__["d" /* darker */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * __WEBPACK_IMPORTED_MODULE_2__math_js__["a" /* deg2rad */],
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new __WEBPACK_IMPORTED_MODULE_1__color_js__["b" /* Rgb */](
      255 * (l + a * (A * cosh + B * sinh)),
      255 * (l + a * (C * cosh + D * sinh)),
      255 * (l + a * (E * cosh)),
      this.opacity
    );
  }
}));


/***/ }),
/* 1636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
});


/***/ }),
/* 1637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color__ = __webpack_require__(192);


/* unused harmony default export */ var _unused_webpack_default_export = (function(a, b) {
  var i = Object(__WEBPACK_IMPORTED_MODULE_0__color__["c" /* hue */])(+a, +b);
  return function(t) {
    var x = i(t);
    return x - 360 * Math.floor(x / 360);
  };
});


/***/ }),
/* 1638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return Math.round(a + b * t);
  };
});


/***/ }),
/* 1639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export interpolateTransformCss */
/* unused harmony export interpolateTransformSvg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse__ = __webpack_require__(1640);



function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["a" /* parseCss */], "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["b" /* parseSvg */], ", ", ")", ")");


/***/ }),
/* 1640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseCss;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseSvg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__decompose__ = __webpack_require__(1641);


var cssNode,
    cssRoot,
    cssView,
    svgNode;

function parseCss(value) {
  if (value === "none") return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* default */])(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  value = value.matrix;
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* default */])(value.a, value.b, value.c, value.d, value.e, value.f);
}


/***/ }),
/* 1641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return identity; });
var degrees = 180 / Math.PI;

var identity = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

/* harmony default export */ __webpack_exports__["a"] = (function(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
});


/***/ }),
/* 1642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rho = Math.SQRT2,
    rho2 = 2,
    rho4 = 4,
    epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
/* unused harmony default export */ var _unused_webpack_default_export = (function(p0, p1) {
  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

  // Special case for u0 ≅ u1.
  if (d2 < epsilon2) {
    S = Math.log(w1 / w0) / rho;
    i = function(t) {
      return [
        ux0 + t * dx,
        uy0 + t * dy,
        w0 * Math.exp(rho * t * S)
      ];
    }
  }

  // General case.
  else {
    var d1 = Math.sqrt(d2),
        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
    S = (r1 - r0) / rho;
    i = function(t) {
      var s = t * S,
          coshr0 = cosh(r0),
          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
      return [
        ux0 + u * dx,
        uy0 + u * dy,
        w0 * coshr0 / cosh(rho * s + r0)
      ];
    }
  }

  i.duration = S * 1000;

  return i;
});


/***/ }),
/* 1643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(192);



function hsl(hue) {
  return function(start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(end)).h),
        s = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (hsl(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var hslLong = hsl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 1644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(192);



function lab(start, end) {
  var l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* lab */])(start)).l, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* lab */])(end)).l),
      a = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.a, end.a),
      b = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.b, end.b),
      opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
  return function(t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}


/***/ }),
/* 1645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(192);



function hcl(hue) {
  return function(start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* hcl */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* hcl */])(end)).h),
        c = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.c, end.c),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (hcl(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var hclLong = hcl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 1646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export cubehelixLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(192);



function cubehelix(hue) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix(start, end) {
      var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(end)).h),
          s = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
          l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
          opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix.gamma = cubehelixGamma;

    return cubehelix;
  })(1);
}

/* unused harmony default export */ var _unused_webpack_default_export = (cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var cubehelixLong = cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 1647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
function piecewise(interpolate, values) {
  var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
  while (i < n) I[i] = interpolate(v, v = values[++i]);
  return function(t) {
    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
    return I[i](t - i);
  };
}


/***/ }),
/* 1648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
});


/***/ }),
/* 1649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 1650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatPrefix; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_js__ = __webpack_require__(764);


var locale;
var format;
var formatPrefix;

defaultLocale({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""],
  minus: "-"
});

function defaultLocale(definition) {
  locale = Object(__WEBPACK_IMPORTED_MODULE_0__locale_js__["a" /* default */])(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}


/***/ }),
/* 1651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
});


/***/ }),
/* 1652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
});


/***/ }),
/* 1653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
/* harmony default export */ __webpack_exports__["a"] = (function(s) {
  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (s[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      default: if (i0 > 0) { if (!+s[i]) break out; i0 = 0; } break;
    }
  }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
});


/***/ }),
/* 1654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatPrefixAuto_js__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatRounded_js__ = __webpack_require__(1655);



/* harmony default export */ __webpack_exports__["a"] = ({
  "%": function(x, p) { return (x * 100).toFixed(p); },
  "b": function(x) { return Math.round(x).toString(2); },
  "c": function(x) { return x + ""; },
  "d": function(x) { return Math.round(x).toString(10); },
  "e": function(x, p) { return x.toExponential(p); },
  "f": function(x, p) { return x.toFixed(p); },
  "g": function(x, p) { return x.toPrecision(p); },
  "o": function(x) { return Math.round(x).toString(8); },
  "p": function(x, p) { return Object(__WEBPACK_IMPORTED_MODULE_1__formatRounded_js__["a" /* default */])(x * 100, p); },
  "r": __WEBPACK_IMPORTED_MODULE_1__formatRounded_js__["a" /* default */],
  "s": __WEBPACK_IMPORTED_MODULE_0__formatPrefixAuto_js__["a" /* default */],
  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
  "x": function(x) { return Math.round(x).toString(16); }
});


/***/ }),
/* 1655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__ = __webpack_require__(407);


/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
});


/***/ }),
/* 1656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 1657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent_js__ = __webpack_require__(288);


/* harmony default export */ __webpack_exports__["a"] = (function(step) {
  return Math.max(0, -Object(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 1658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent_js__ = __webpack_require__(288);


/* harmony default export */ __webpack_exports__["a"] = (function(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a" /* default */])(value) / 3))) * 3 - Object(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 1659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent_js__ = __webpack_require__(288);


/* harmony default export */ __webpack_exports__["a"] = (function(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, Object(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a" /* default */])(max) - Object(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a" /* default */])(step)) + 1;
});


/***/ }),
/* 1660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quantile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__init__ = __webpack_require__(56);




function quantile() {
  var domain = [],
      range = [],
      thresholds = [],
      unknown;

  function rescale() {
    var i = 0, n = Math.max(1, range.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["d" /* quantile */])(domain, i / n);
    return scale;
  }

  function scale(x) {
    return isNaN(x = +x) ? unknown : range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(thresholds, x)];
  }

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : [
      i > 0 ? thresholds[i - 1] : domain[0],
      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
    ];
  };

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(__WEBPACK_IMPORTED_MODULE_0_d3_array__["a" /* ascending */]);
    return rescale();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.quantiles = function() {
    return thresholds.slice();
  };

  scale.copy = function() {
    return quantile()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return __WEBPACK_IMPORTED_MODULE_2__init__["b" /* initRange */].apply(scale, arguments);
}


/***/ }),
/* 1661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quantize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__init__ = __webpack_require__(56);





function quantize() {
  var x0 = 0,
      x1 = 1,
      n = 1,
      domain = [0.5],
      range = [0, 1],
      unknown;

  function scale(x) {
    return x <= x ? range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(domain, x, 0, n)] : unknown;
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    return scale;
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
  };

  scale.range = function(_) {
    return arguments.length ? (n = (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_)).length - 1, rescale()) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN]
        : i < 1 ? [x0, domain[0]]
        : i >= n ? [domain[n - 1], x1]
        : [domain[i - 1], domain[i]];
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : scale;
  };

  scale.thresholds = function() {
    return domain.slice();
  };

  scale.copy = function() {
    return quantize()
        .domain([x0, x1])
        .range(range)
        .unknown(unknown);
  };

  return __WEBPACK_IMPORTED_MODULE_3__init__["b" /* initRange */].apply(Object(__WEBPACK_IMPORTED_MODULE_2__linear__["b" /* linearish */])(scale), arguments);
}


/***/ }),
/* 1662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = threshold;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__init__ = __webpack_require__(56);




function threshold() {
  var domain = [0.5],
      range = [0, 1],
      unknown,
      n = 1;

  function scale(x) {
    return x <= x ? range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(domain, x, 0, n)] : unknown;
  }

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return threshold()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return __WEBPACK_IMPORTED_MODULE_2__init__["b" /* initRange */].apply(scale, arguments);
}


/***/ }),
/* 1663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export milliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(52);


var millisecond = Object(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};

/* harmony default export */ __webpack_exports__["a"] = (millisecond);
var milliseconds = millisecond.range;


/***/ }),
/* 1664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export seconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(103);



var second = Object(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setTime(date - date.getMilliseconds());
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration_js__["d" /* durationSecond */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["d" /* durationSecond */];
}, function(date) {
  return date.getUTCSeconds();
});

/* harmony default export */ __webpack_exports__["a"] = (second);
var seconds = second.range;


/***/ }),
/* 1665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export minutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(103);



var minute = Object(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * __WEBPACK_IMPORTED_MODULE_1__duration_js__["d" /* durationSecond */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration_js__["c" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["c" /* durationMinute */];
}, function(date) {
  return date.getMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (minute);
var minutes = minute.range;


/***/ }),
/* 1666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(103);



var hour = Object(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * __WEBPACK_IMPORTED_MODULE_1__duration_js__["d" /* durationSecond */] - date.getMinutes() * __WEBPACK_IMPORTED_MODULE_1__duration_js__["c" /* durationMinute */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration_js__["b" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["b" /* durationHour */];
}, function(date) {
  return date.getHours();
});

/* harmony default export */ __webpack_exports__["a"] = (hour);
var hours = hour.range;


/***/ }),
/* 1667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export days */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(103);



var day = Object(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setDate(date.getDate() + step);
}, function(start, end) {
  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration_js__["c" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["a" /* durationDay */];
}, function(date) {
  return date.getDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (day);
var days = day.range;


/***/ }),
/* 1668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return monday; });
/* unused harmony export tuesday */
/* unused harmony export wednesday */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return thursday; });
/* unused harmony export friday */
/* unused harmony export saturday */
/* unused harmony export sundays */
/* unused harmony export mondays */
/* unused harmony export tuesdays */
/* unused harmony export wednesdays */
/* unused harmony export thursdays */
/* unused harmony export fridays */
/* unused harmony export saturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(103);



function weekday(i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration_js__["c" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["e" /* durationWeek */];
  });
}

var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);

var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;


/***/ }),
/* 1669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export months */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(52);


var month = Object(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (month);
var months = month.range;


/***/ }),
/* 1670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export years */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(52);


var year = Object(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : Object(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (year);
var years = year.range;


/***/ }),
/* 1671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(103);



var utcMinute = Object(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration_js__["c" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["c" /* durationMinute */];
}, function(date) {
  return date.getUTCMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMinute);
var utcMinutes = utcMinute.range;


/***/ }),
/* 1672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(103);



var utcHour = Object(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration_js__["b" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["b" /* durationHour */];
}, function(date) {
  return date.getUTCHours();
});

/* harmony default export */ __webpack_exports__["a"] = (utcHour);
var utcHours = utcHour.range;


/***/ }),
/* 1673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(103);



var utcDay = Object(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["a" /* durationDay */];
}, function(date) {
  return date.getUTCDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (utcDay);
var utcDays = utcDay.range;


/***/ }),
/* 1674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcSunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return utcMonday; });
/* unused harmony export utcTuesday */
/* unused harmony export utcWednesday */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return utcThursday; });
/* unused harmony export utcFriday */
/* unused harmony export utcSaturday */
/* unused harmony export utcSundays */
/* unused harmony export utcMondays */
/* unused harmony export utcTuesdays */
/* unused harmony export utcWednesdays */
/* unused harmony export utcThursdays */
/* unused harmony export utcFridays */
/* unused harmony export utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(103);



function utcWeekday(i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["e" /* durationWeek */];
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);

var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;


/***/ }),
/* 1675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(52);


var utcMonth = Object(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMonth);
var utcMonths = utcMonth.range;


/***/ }),
/* 1676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(52);


var utcYear = Object(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : Object(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (utcYear);
var utcYears = utcYear.range;


/***/ }),
/* 1677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isoFormat_js__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultLocale_js__ = __webpack_require__(412);



function parseIsoNative(string) {
  var date = new Date(string);
  return isNaN(date) ? null : date;
}

var parseIso = +new Date("2000-01-01T00:00:00.000Z")
    ? parseIsoNative
    : Object(__WEBPACK_IMPORTED_MODULE_1__defaultLocale_js__["c" /* utcParse */])(__WEBPACK_IMPORTED_MODULE_0__isoFormat_js__["a" /* isoSpecifier */]);

/* unused harmony default export */ var _unused_webpack_default_export = (parseIso);


/***/ }),
/* 1678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__time__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_time_format__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__init__ = __webpack_require__(56);





/* harmony default export */ __webpack_exports__["a"] = (function() {
  return __WEBPACK_IMPORTED_MODULE_3__init__["b" /* initRange */].apply(Object(__WEBPACK_IMPORTED_MODULE_0__time__["a" /* calendar */])(__WEBPACK_IMPORTED_MODULE_2_d3_time__["v" /* utcYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["q" /* utcMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["u" /* utcWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["l" /* utcDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["m" /* utcHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["o" /* utcMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["r" /* utcSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["n" /* utcMillisecond */], __WEBPACK_IMPORTED_MODULE_1_d3_time_format__["b" /* utcFormat */]).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]), arguments);
});


/***/ }),
/* 1679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sequentialQuantile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__continuous__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__init__ = __webpack_require__(56);




function sequentialQuantile() {
  var domain = [],
      interpolator = __WEBPACK_IMPORTED_MODULE_1__continuous__["c" /* identity */];

  function scale(x) {
    if (!isNaN(x = +x)) return interpolator((Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(domain, x) - 1) / (domain.length - 1));
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(__WEBPACK_IMPORTED_MODULE_0_d3_array__["a" /* ascending */]);
    return scale;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.copy = function() {
    return sequentialQuantile(interpolator).domain(domain);
  };

  return __WEBPACK_IMPORTED_MODULE_2__init__["a" /* initInterpolator */].apply(scale, arguments);
}


/***/ }),
/* 1680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = diverging;
/* harmony export (immutable) */ __webpack_exports__["b"] = divergingLog;
/* harmony export (immutable) */ __webpack_exports__["e"] = divergingSymlog;
/* harmony export (immutable) */ __webpack_exports__["c"] = divergingPow;
/* harmony export (immutable) */ __webpack_exports__["d"] = divergingSqrt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__continuous__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__init__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__log__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sequential__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__symlog__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pow__ = __webpack_require__(410);








function transformer() {
  var x0 = 0,
      x1 = 0.5,
      x2 = 1,
      t0,
      t1,
      t2,
      k10,
      k21,
      interpolator = __WEBPACK_IMPORTED_MODULE_0__continuous__["c" /* identity */],
      transform,
      clamp = false,
      unknown;

  function scale(x) {
    return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (x < t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
  }

  scale.domain = function(_) {
    return arguments.length ? (t0 = transform(x0 = +_[0]), t1 = transform(x1 = +_[1]), t2 = transform(x2 = +_[2]), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), scale) : [x0, x1, x2];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  return function(t) {
    transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1);
    return scale;
  };
}

function diverging() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_2__linear__["b" /* linearish */])(transformer()(__WEBPACK_IMPORTED_MODULE_0__continuous__["c" /* identity */]));

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_4__sequential__["a" /* copy */])(scale, diverging());
  };

  return __WEBPACK_IMPORTED_MODULE_1__init__["a" /* initInterpolator */].apply(scale, arguments);
}

function divergingLog() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_3__log__["b" /* loggish */])(transformer()).domain([0.1, 1, 10]);

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_4__sequential__["a" /* copy */])(scale, divergingLog()).base(scale.base());
  };

  return __WEBPACK_IMPORTED_MODULE_1__init__["a" /* initInterpolator */].apply(scale, arguments);
}

function divergingSymlog() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_5__symlog__["b" /* symlogish */])(transformer());

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_4__sequential__["a" /* copy */])(scale, divergingSymlog()).constant(scale.constant());
  };

  return __WEBPACK_IMPORTED_MODULE_1__init__["a" /* initInterpolator */].apply(scale, arguments);
}

function divergingPow() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_6__pow__["b" /* powish */])(transformer());

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_4__sequential__["a" /* copy */])(scale, divergingPow()).exponent(scale.exponent());
  };

  return __WEBPACK_IMPORTED_MODULE_1__init__["a" /* initInterpolator */].apply(scale, arguments);
}

function divergingSqrt() {
  return divergingPow.apply(null, arguments).exponent(0.5);
}


/***/ }),
/* 1681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Customized;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__container_Layer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_LogUtils__ = __webpack_require__(188);


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * @fileOverview Customized
 */




/**
 * custom svg elements by rechart instance props and state.
 * @returns {Object}   svg elements
 */

function Customized(_ref) {
  var component = _ref.component,
      props = _objectWithoutProperties(_ref, ["component"]);

  var child;

  if (Object(__WEBPACK_IMPORTED_MODULE_1_react__["isValidElement"])(component)) {
    child = Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(component, props);
  } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(component)) {
    child = component(props);
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_4__util_LogUtils__["a" /* warn */])(false, 'Customized\'s props `component` must be React.element or Function, but got %s.', _typeof(component));
  }

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__container_Layer__["a" /* default */], {
    className: "recharts-customized-wrapper"
  }, child);
}
Customized.displayName = 'Customized';
Customized.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func]).isRequired
};

/***/ }),
/* 1682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_PolarUtils__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__ = __webpack_require__(12);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Polar Grid
 */





var PolarGrid =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(PolarGrid, _PureComponent);

  function PolarGrid() {
    _classCallCheck(this, PolarGrid);

    return _possibleConstructorReturn(this, _getPrototypeOf(PolarGrid).apply(this, arguments));
  }

  _createClass(PolarGrid, [{
    key: "getPolygonPath",
    value: function getPolygonPath(radius) {
      var _this$props = this.props,
          cx = _this$props.cx,
          cy = _this$props.cy,
          polarAngles = _this$props.polarAngles;
      var path = '';
      polarAngles.forEach(function (angle, i) {
        var point = Object(__WEBPACK_IMPORTED_MODULE_2__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, radius, angle);

        if (i) {
          path += "L ".concat(point.x, ",").concat(point.y);
        } else {
          path += "M ".concat(point.x, ",").concat(point.y);
        }
      });
      path += 'Z';
      return path;
    }
    /**
     * Draw axis of radial line
     * @return {[type]} The lines
     */

  }, {
    key: "renderPolarAngles",
    value: function renderPolarAngles() {
      var _this$props2 = this.props,
          cx = _this$props2.cx,
          cy = _this$props2.cy,
          innerRadius = _this$props2.innerRadius,
          outerRadius = _this$props2.outerRadius,
          polarAngles = _this$props2.polarAngles;

      if (!polarAngles || !polarAngles.length) {
        return null;
      }

      var props = _objectSpread({
        stroke: '#ccc'
      }, Object(__WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["l" /* getPresentationAttributes */])(this.props));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
        className: "recharts-polar-grid-angle"
      }, polarAngles.map(function (entry, i) {
        var start = Object(__WEBPACK_IMPORTED_MODULE_2__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, innerRadius, entry);
        var end = Object(__WEBPACK_IMPORTED_MODULE_2__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, outerRadius, entry);
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("line", _extends({}, props, {
          key: "line-".concat(i) // eslint-disable-line react/no-array-index-key
          ,
          x1: start.x,
          y1: start.y,
          x2: end.x,
          y2: end.y
        }));
      }));
    }
    /**
     * Draw concentric circles
     * @param {Number} radius The radius of circle
     * @param {Number} index  The index of circle
     * @param {Object} extraProps Extra props
     * @return {ReactElement} circle
     */

  }, {
    key: "renderConcentricCircle",
    value: function renderConcentricCircle(radius, index, extraProps) {
      var _this$props3 = this.props,
          cx = _this$props3.cx,
          cy = _this$props3.cy;

      var props = _objectSpread({
        stroke: '#ccc'
      }, Object(__WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["l" /* getPresentationAttributes */])(this.props), {
        fill: 'none'
      }, extraProps);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", _extends({}, props, {
        className: "recharts-polar-grid-concentric-circle",
        key: "circle-".concat(index),
        cx: cx,
        cy: cy,
        r: radius
      }));
    }
    /**
     * Draw concentric polygons
     * @param {Number} radius     The radius of polygon
     * @param {Number} index      The index of polygon
     * @param {Object} extraProps Extra props
     * @return {ReactElement} polygon
     */

  }, {
    key: "renderConcentricPolygon",
    value: function renderConcentricPolygon(radius, index, extraProps) {
      var props = _objectSpread({
        stroke: '#ccc'
      }, Object(__WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["l" /* getPresentationAttributes */])(this.props), {
        fill: 'none'
      }, extraProps);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", _extends({}, props, {
        className: "recharts-polar-grid-concentric-polygon",
        key: "path-".concat(index),
        d: this.getPolygonPath(radius)
      }));
    }
    /**
     * Draw concentric axis
     * @return {ReactElement} Concentric axis
     * @todo Optimize the name
     */

  }, {
    key: "renderConcentricPath",
    value: function renderConcentricPath() {
      var _this = this;

      var _this$props4 = this.props,
          polarRadius = _this$props4.polarRadius,
          gridType = _this$props4.gridType;

      if (!polarRadius || !polarRadius.length) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
        className: "recharts-polar-grid-concentric"
      }, polarRadius.map(function (entry, i) {
        return gridType === 'circle' ? _this.renderConcentricCircle(entry, i) : _this.renderConcentricPolygon(entry, i);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var outerRadius = this.props.outerRadius;

      if (outerRadius <= 0) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
        className: "recharts-polar-grid"
      }, this.renderPolarAngles(), this.renderConcentricPath());
    }
  }]);

  return PolarGrid;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

PolarGrid.displayName = 'PolarGrid';
PolarGrid.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  cx: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  cy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  innerRadius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  outerRadius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  polarAngles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number),
  polarRadius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number),
  gridType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['polygon', 'circle'])
});
PolarGrid.defaultProps = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  gridType: 'polygon'
};
/* harmony default export */ __webpack_exports__["a"] = (PolarGrid);

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

var baseExtremum = __webpack_require__(286),
    baseIteratee = __webpack_require__(67),
    baseLt = __webpack_require__(736);

/**
 * This method is like `_.min` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.minBy(objects, function(o) { return o.n; });
 * // => { 'n': 1 }
 *
 * // The `_.property` iteratee shorthand.
 * _.minBy(objects, 'n');
 * // => { 'n': 1 }
 */
function minBy(array, iteratee) {
  return (array && array.length)
    ? baseExtremum(array, baseIteratee(iteratee, 2), baseLt)
    : undefined;
}

module.exports = minBy;


/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

var baseRange = __webpack_require__(1685),
    isIterateeCall = __webpack_require__(231),
    toFinite = __webpack_require__(641);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),
/* 1685 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),
/* 1686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generatePrefixStyle; });
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PREFIX_LIST = ['Webkit', 'Moz', 'O', 'ms'];
var generatePrefixStyle = function generatePrefixStyle(name, value) {
  if (!name) {
    return null;
  }

  var camelName = name.replace(/(\w)/, function (v) {
    return v.toUpperCase();
  });
  var result = PREFIX_LIST.reduce(function (res, entry) {
    return _objectSpread({}, res, _defineProperty({}, entry + camelName, value));
  }, {});
  result[name] = value;
  return result;
};

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(230);

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

module.exports = baseSome;


/***/ }),
/* 1688 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */
function arrayEvery(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (!predicate(array[index], index, array)) {
      return false;
    }
  }
  return true;
}

module.exports = arrayEvery;


/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(230);

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */
function baseEvery(collection, predicate) {
  var result = true;
  baseEach(collection, function(value, index, collection) {
    result = !!predicate(value, index, collection);
    return result;
  });
  return result;
}

module.exports = baseEvery;


/***/ }),
/* 1690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_DataUtils__ = __webpack_require__(23);


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Cartesian Grid
 */





var CartesianGrid =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(CartesianGrid, _PureComponent);

  function CartesianGrid() {
    _classCallCheck(this, CartesianGrid);

    return _possibleConstructorReturn(this, _getPrototypeOf(CartesianGrid).apply(this, arguments));
  }

  _createClass(CartesianGrid, [{
    key: "renderHorizontal",

    /**
     * Draw the horizontal grid lines
     * @param {Array} horizontalPoints either passed in as props or generated from function
     * @return {Group} Horizontal lines
     */
    value: function renderHorizontal(horizontalPoints) {
      var _this = this;

      var _this$props = this.props,
          x = _this$props.x,
          width = _this$props.width,
          horizontal = _this$props.horizontal;

      if (!horizontalPoints || !horizontalPoints.length) {
        return null;
      }

      var items = horizontalPoints.map(function (entry, i) {
        var props = _objectSpread({}, _this.props, {
          x1: x,
          y1: entry,
          x2: x + width,
          y2: entry,
          key: "line-".concat(i),
          index: i
        });

        return _this.constructor.renderLineItem(horizontal, props);
      });
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g", {
        className: "recharts-cartesian-grid-horizontal"
      }, items);
    }
    /**
     * Draw vertical grid lines
     * @param {Array} verticalPoints either passed in as props or generated from function
     * @return {Group} Vertical lines
     */

  }, {
    key: "renderVertical",
    value: function renderVertical(verticalPoints) {
      var _this2 = this;

      var _this$props2 = this.props,
          y = _this$props2.y,
          height = _this$props2.height,
          vertical = _this$props2.vertical;

      if (!verticalPoints || !verticalPoints.length) {
        return null;
      }

      var items = verticalPoints.map(function (entry, i) {
        var props = _objectSpread({}, _this2.props, {
          x1: entry,
          y1: y,
          x2: entry,
          y2: y + height,
          key: "line-".concat(i),
          index: i
        });

        return _this2.constructor.renderLineItem(vertical, props);
      });
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g", {
        className: "recharts-cartesian-grid-vertical"
      }, items);
    }
    /**
     * Draw vertical grid stripes filled by colors
     * @param {Array} verticalPoints either passed in as props or generated from function
     * @return {Group} Vertical stripes
     */

  }, {
    key: "renderVerticalStripes",
    value: function renderVerticalStripes(verticalPoints) {
      var verticalFill = this.props.verticalFill;

      if (!verticalFill || !verticalFill.length) {
        return null;
      }

      var _this$props3 = this.props,
          fillOpacity = _this$props3.fillOpacity,
          x = _this$props3.x,
          y = _this$props3.y,
          width = _this$props3.width,
          height = _this$props3.height;
      var verticalPointsUpdated = verticalPoints.slice().sort(function (a, b) {
        return a - b;
      });

      if (x !== verticalPointsUpdated[0]) {
        verticalPointsUpdated.unshift(0);
      }

      var items = verticalPointsUpdated.map(function (entry, i) {
        var lineWidth = verticalPointsUpdated[i + 1] ? verticalPointsUpdated[i + 1] - entry : x + width - entry;

        if (lineWidth <= 0) {
          return null;
        }

        var colorIndex = i % verticalFill.length;
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect", {
          key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
          ,
          x: Math.round(entry + x - x),
          y: y,
          width: lineWidth,
          height: height,
          stroke: "none",
          fill: verticalFill[colorIndex],
          fillOpacity: fillOpacity,
          className: "recharts-cartesian-grid-bg"
        });
      });
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g", {
        className: "recharts-cartesian-gridstripes-vertical"
      }, items);
    }
    /**
     * Draw horizontal grid stripes filled by colors
     * @param {Array} horizontalPoints either passed in as props or generated from function
     * @return {Group} Horizontal stripes
     */

  }, {
    key: "renderHorizontalStripes",
    value: function renderHorizontalStripes(horizontalPoints) {
      var horizontalFill = this.props.horizontalFill;

      if (!horizontalFill || !horizontalFill.length) {
        return null;
      }

      var _this$props4 = this.props,
          fillOpacity = _this$props4.fillOpacity,
          x = _this$props4.x,
          y = _this$props4.y,
          width = _this$props4.width,
          height = _this$props4.height;
      var horizontalPointsUpdated = horizontalPoints.slice().sort(function (a, b) {
        return a - b;
      });

      if (y !== horizontalPointsUpdated[0]) {
        horizontalPointsUpdated.unshift(0);
      }

      var items = horizontalPointsUpdated.map(function (entry, i) {
        var lineHeight = horizontalPointsUpdated[i + 1] ? horizontalPointsUpdated[i + 1] - entry : y + height - entry;

        if (lineHeight <= 0) {
          return null;
        }

        var colorIndex = i % horizontalFill.length;
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect", {
          key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
          ,
          y: Math.round(entry + y - y),
          x: x,
          height: lineHeight,
          width: width,
          stroke: "none",
          fill: horizontalFill[colorIndex],
          fillOpacity: fillOpacity,
          className: "recharts-cartesian-grid-bg"
        });
      });
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g", {
        className: "recharts-cartesian-gridstripes-horizontal"
      }, items);
    }
  }, {
    key: "renderBackground",
    value: function renderBackground() {
      var fill = this.props.fill;

      if (!fill || fill === 'none') {
        return null;
      }

      var _this$props5 = this.props,
          fillOpacity = _this$props5.fillOpacity,
          x = _this$props5.x,
          y = _this$props5.y,
          width = _this$props5.width,
          height = _this$props5.height;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect", {
        x: x,
        y: y,
        width: width,
        height: height,
        stroke: "none",
        fill: fill,
        fillOpacity: fillOpacity,
        className: "recharts-cartesian-grid-bg"
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          x = _this$props6.x,
          y = _this$props6.y,
          width = _this$props6.width,
          height = _this$props6.height,
          horizontal = _this$props6.horizontal,
          vertical = _this$props6.vertical,
          horizontalCoordinatesGenerator = _this$props6.horizontalCoordinatesGenerator,
          verticalCoordinatesGenerator = _this$props6.verticalCoordinatesGenerator,
          xAxis = _this$props6.xAxis,
          yAxis = _this$props6.yAxis,
          offset = _this$props6.offset,
          chartWidth = _this$props6.chartWidth,
          chartHeight = _this$props6.chartHeight;

      if (!Object(__WEBPACK_IMPORTED_MODULE_4__util_DataUtils__["h" /* isNumber */])(width) || width <= 0 || !Object(__WEBPACK_IMPORTED_MODULE_4__util_DataUtils__["h" /* isNumber */])(height) || height <= 0 || !Object(__WEBPACK_IMPORTED_MODULE_4__util_DataUtils__["h" /* isNumber */])(x) || x !== +x || !Object(__WEBPACK_IMPORTED_MODULE_4__util_DataUtils__["h" /* isNumber */])(y) || y !== +y) {
        return null;
      }

      var _this$props7 = this.props,
          horizontalPoints = _this$props7.horizontalPoints,
          verticalPoints = _this$props7.verticalPoints; // No horizontal points are specified

      if ((!horizontalPoints || !horizontalPoints.length) && __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(horizontalCoordinatesGenerator)) {
        horizontalPoints = horizontalCoordinatesGenerator({
          yAxis: yAxis,
          width: chartWidth,
          height: chartHeight,
          offset: offset
        });
      } // No vertical points are specified


      if ((!verticalPoints || !verticalPoints.length) && __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(verticalCoordinatesGenerator)) {
        verticalPoints = verticalCoordinatesGenerator({
          xAxis: xAxis,
          width: chartWidth,
          height: chartHeight,
          offset: offset
        });
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g", {
        className: "recharts-cartesian-grid"
      }, this.renderBackground(), horizontal && this.renderHorizontal(horizontalPoints), vertical && this.renderVertical(verticalPoints), horizontal && this.renderHorizontalStripes(horizontalPoints), vertical && this.renderVerticalStripes(verticalPoints));
    }
  }], [{
    key: "renderLineItem",
    value: function renderLineItem(option, props) {
      var lineItem;

      if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(option)) {
        lineItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        lineItem = option(props);
      } else {
        var x1 = props.x1,
            y1 = props.y1,
            x2 = props.x2,
            y2 = props.y2,
            key = props.key,
            others = _objectWithoutProperties(props, ["x1", "y1", "x2", "y2", "key"]);

        lineItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line", _extends({}, Object(__WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["l" /* getPresentationAttributes */])(others), {
          x1: x1,
          y1: y1,
          x2: x2,
          y2: y2,
          fill: "none",
          key: key
        }));
      }

      return lineItem;
    }
  }]);

  return CartesianGrid;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

CartesianGrid.displayName = 'CartesianGrid';
CartesianGrid.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  x: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  y: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  horizontal: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool]),
  vertical: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool]),
  horizontalPoints: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number),
  verticalPoints: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number),
  horizontalCoordinatesGenerator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  verticalCoordinatesGenerator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  xAxis: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  yAxis: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  offset: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  chartWidth: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  chartHeight: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  verticalFill: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string),
  horizontalFill: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string)
});
CartesianGrid.defaultProps = {
  horizontal: true,
  vertical: true,
  // The ordinates of horizontal grid lines
  horizontalPoints: [],
  // The abscissas of vertical grid lines
  verticalPoints: [],
  stroke: '#ccc',
  fill: 'none',
  // The fill of colors of grid lines
  verticalFill: [],
  horizontalFill: []
};
/* harmony default export */ __webpack_exports__["a"] = (CartesianGrid);

/***/ }),
/* 1691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__generateCategoricalChart__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartesian_Line__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cartesian_XAxis__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cartesian_YAxis__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_CartesianUtils__ = __webpack_require__(125);
/**
 * @fileOverview Line Chart
 */





/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__generateCategoricalChart__["a" /* default */])({
  chartName: 'LineChart',
  GraphicalChild: __WEBPACK_IMPORTED_MODULE_1__cartesian_Line__["a" /* default */],
  axisComponents: [{
    axisType: 'xAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_2__cartesian_XAxis__["a" /* default */]
  }, {
    axisType: 'yAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_3__cartesian_YAxis__["a" /* default */]
  }],
  formatAxisMap: __WEBPACK_IMPORTED_MODULE_4__util_CartesianUtils__["b" /* formatAxisMap */]
}));

/***/ }),
/* 1692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return detectReferenceElementsDomain; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cartesian_ReferenceDot__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartesian_ReferenceLine__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cartesian_ReferenceArea__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__IfOverflowMatches__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ReactUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DataUtils__ = __webpack_require__(23);






var detectReferenceElementsDomain = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
  var lines = Object(__WEBPACK_IMPORTED_MODULE_4__ReactUtils__["i" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_1__cartesian_ReferenceLine__["a" /* default */]);
  var dots = Object(__WEBPACK_IMPORTED_MODULE_4__ReactUtils__["i" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_0__cartesian_ReferenceDot__["a" /* default */]);
  var elements = lines.concat(dots);
  var areas = Object(__WEBPACK_IMPORTED_MODULE_4__ReactUtils__["i" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_2__cartesian_ReferenceArea__["a" /* default */]);
  var idKey = "".concat(axisType, "Id");
  var valueKey = axisType[0];
  var finalDomain = domain;

  if (elements.length) {
    finalDomain = elements.reduce(function (result, el) {
      if (el.props[idKey] === axisId && Object(__WEBPACK_IMPORTED_MODULE_3__IfOverflowMatches__["a" /* ifOverflowMatches */])(el.props, 'extendDomain') && Object(__WEBPACK_IMPORTED_MODULE_5__DataUtils__["h" /* isNumber */])(el.props[valueKey])) {
        var value = el.props[valueKey];
        return [Math.min(result[0], value), Math.max(result[1], value)];
      }

      return result;
    }, finalDomain);
  }

  if (areas.length) {
    var key1 = "".concat(valueKey, "1");
    var key2 = "".concat(valueKey, "2");
    finalDomain = areas.reduce(function (result, el) {
      if (el.props[idKey] === axisId && Object(__WEBPACK_IMPORTED_MODULE_3__IfOverflowMatches__["a" /* ifOverflowMatches */])(el.props, 'extendDomain') && Object(__WEBPACK_IMPORTED_MODULE_5__DataUtils__["h" /* isNumber */])(el.props[key1]) && Object(__WEBPACK_IMPORTED_MODULE_5__DataUtils__["h" /* isNumber */])(el.props[key2])) {
        var value1 = el.props[key1];
        var value2 = el.props[key2];
        return [Math.min(result[0], value1, value2), Math.max(result[1], value1, value2)];
      }

      return result;
    }, finalDomain);
  }

  if (specifiedTicks && specifiedTicks.length) {
    finalDomain = specifiedTicks.reduce(function (result, tick) {
      if (Object(__WEBPACK_IMPORTED_MODULE_5__DataUtils__["h" /* isNumber */])(tick)) {
        return [Math.min(result[0], tick), Math.max(result[1], tick)];
      }

      return result;
    }, finalDomain);
  }

  return finalDomain;
};

/***/ }),
/* 1693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return eventCenter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SYNC_EVENT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_events__);

var eventCenter = new __WEBPACK_IMPORTED_MODULE_0_events___default.a();

if (eventCenter.setMaxListeners) {
  eventCenter.setMaxListeners(10);
}


var SYNC_EVENT = 'recharts.syncMouseEvents';

/***/ }),
/* 1694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__generateCategoricalChart__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartesian_Bar__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cartesian_XAxis__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cartesian_YAxis__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_CartesianUtils__ = __webpack_require__(125);
/**
 * @fileOverview Bar Chart
 */





/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__generateCategoricalChart__["a" /* default */])({
  chartName: 'BarChart',
  GraphicalChild: __WEBPACK_IMPORTED_MODULE_1__cartesian_Bar__["a" /* default */],
  axisComponents: [{
    axisType: 'xAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_2__cartesian_XAxis__["a" /* default */]
  }, {
    axisType: 'yAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_3__cartesian_YAxis__["a" /* default */]
  }],
  formatAxisMap: __WEBPACK_IMPORTED_MODULE_4__util_CartesianUtils__["b" /* formatAxisMap */]
}));

/***/ }),
/* 1695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__generateCategoricalChart__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__polar_PolarAngleAxis__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__polar_PolarRadiusAxis__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_PolarUtils__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__polar_Pie__ = __webpack_require__(776);
/**
 * @fileOverview Pie Chart
 */






/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__generateCategoricalChart__["a" /* default */])({
  chartName: 'PieChart',
  GraphicalChild: __WEBPACK_IMPORTED_MODULE_5__polar_Pie__["a" /* default */],
  eventType: 'item',
  legendContent: 'children',
  axisComponents: [{
    axisType: 'angleAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_2__polar_PolarAngleAxis__["a" /* default */]
  }, {
    axisType: 'radiusAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_3__polar_PolarRadiusAxis__["a" /* default */]
  }],
  formatAxisMap: __WEBPACK_IMPORTED_MODULE_4__util_PolarUtils__["b" /* formatAxisMap */],
  defaultProps: {
    layout: 'centric',
    startAngle: 0,
    endAngle: 360,
    cx: '50%',
    cy: '50%',
    innerRadius: 0,
    outerRadius: '80%'
  },
  propTypes: {
    layout: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['centric']),
    startAngle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
    endAngle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
    cx: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
    cy: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
    innerRadius: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
    outerRadius: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string])
  }
}));

/***/ }),
/* 1696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_omit__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isFunction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNaN__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNaN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isNaN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_smooth__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__container_Surface__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__container_Layer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shape_Rectangle__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__component_Tooltip__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shape_Polygon__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_ChartUtils__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_Constants__ = __webpack_require__(1716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_DOMUtils__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_DataUtils__ = __webpack_require__(23);





function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable jsx-a11y/no-static-element-interactions */

/**
 * @fileOverview TreemapChart
 */















var computeNode = function computeNode(_ref) {
  var depth = _ref.depth,
      node = _ref.node,
      index = _ref.index,
      valueKey = _ref.valueKey;
  var children = node.children;
  var childDepth = depth + 1;
  var computedChildren = children && children.length ? children.map(function (child, i) {
    return computeNode({
      depth: childDepth,
      node: child,
      index: i,
      valueKey: valueKey
    });
  }) : null;
  var value;

  if (children && children.length) {
    value = computedChildren.reduce(function (result, child) {
      return result + child.value;
    }, 0);
  } else {
    value = __WEBPACK_IMPORTED_MODULE_3_lodash_isNaN___default()(node[valueKey]) || node[valueKey] <= 0 ? 0 : node[valueKey];
  }

  return _objectSpread({}, node, {
    children: computedChildren,
    value: value,
    depth: depth,
    index: index
  });
};

var filterRect = function filterRect(node) {
  return {
    x: node.x,
    y: node.y,
    width: node.width,
    height: node.height
  };
}; // Compute the area for each child based on value & scale.


var getAreaOfChildren = function getAreaOfChildren(children, areaValueRatio) {
  var ratio = areaValueRatio < 0 ? 0 : areaValueRatio;
  return children.map(function (child) {
    var area = child.value * ratio;
    return _objectSpread({}, child, {
      area: __WEBPACK_IMPORTED_MODULE_3_lodash_isNaN___default()(area) || area <= 0 ? 0 : area
    });
  });
}; // Computes the score for the specified row, as the worst aspect ratio.


var getWorstScore = function getWorstScore(row, parentSize, aspectRatio) {
  var parentArea = parentSize * parentSize;
  var rowArea = row.area * row.area;

  var _row$reduce = row.reduce(function (result, child) {
    return {
      min: Math.min(result.min, child.area),
      max: Math.max(result.max, child.area)
    };
  }, {
    min: Infinity,
    max: 0
  }),
      min = _row$reduce.min,
      max = _row$reduce.max;

  return rowArea ? Math.max(parentArea * max * aspectRatio / rowArea, rowArea / (parentArea * min * aspectRatio)) : Infinity;
};

var horizontalPosition = function horizontalPosition(row, parentSize, parentRect, isFlush) {
  var rowHeight = parentSize ? Math.round(row.area / parentSize) : 0;

  if (isFlush || rowHeight > parentRect.height) {
    rowHeight = parentRect.height;
  }

  var curX = parentRect.x;
  var child;

  for (var i = 0, len = row.length; i < len; i++) {
    child = row[i];
    child.x = curX;
    child.y = parentRect.y;
    child.height = rowHeight;
    child.width = Math.min(rowHeight ? Math.round(child.area / rowHeight) : 0, parentRect.x + parentRect.width - curX);
    curX += child.width;
  } // what's z


  child.z = true; // add the remain x to the last one of row

  child.width += parentRect.x + parentRect.width - curX;
  return _objectSpread({}, parentRect, {
    y: parentRect.y + rowHeight,
    height: parentRect.height - rowHeight
  });
};

var verticalPosition = function verticalPosition(row, parentSize, parentRect, isFlush) {
  var rowWidth = parentSize ? Math.round(row.area / parentSize) : 0;

  if (isFlush || rowWidth > parentRect.width) {
    rowWidth = parentRect.width;
  }

  var curY = parentRect.y;
  var child;

  for (var i = 0, len = row.length; i < len; i++) {
    child = row[i];
    child.x = parentRect.x;
    child.y = curY;
    child.width = rowWidth;
    child.height = Math.min(rowWidth ? Math.round(child.area / rowWidth) : 0, parentRect.y + parentRect.height - curY);
    curY += child.height;
  }

  child.z = false;
  child.height += parentRect.y + parentRect.height - curY;
  return _objectSpread({}, parentRect, {
    x: parentRect.x + rowWidth,
    width: parentRect.width - rowWidth
  });
};

var position = function position(row, parentSize, parentRect, isFlush) {
  if (parentSize === parentRect.width) {
    return horizontalPosition(row, parentSize, parentRect, isFlush);
  }

  return verticalPosition(row, parentSize, parentRect, isFlush);
}; // Recursively arranges the specified node's children into squarified rows.


var squarify = function squarify(node, aspectRatio) {
  var children = node.children;

  if (children && children.length) {
    var rect = filterRect(node);
    var row = [];
    var best = Infinity; // the best row score so far

    var child, score; // the current row score

    var size = Math.min(rect.width, rect.height); // initial orientation

    var scaleChildren = getAreaOfChildren(children, rect.width * rect.height / node.value);
    var tempChildren = scaleChildren.slice();
    row.area = 0;

    while (tempChildren.length > 0) {
      // row first
      // eslint-disable-next-line prefer-destructuring
      row.push(child = tempChildren[0]);
      row.area += child.area;
      score = getWorstScore(row, size, aspectRatio);

      if (score <= best) {
        // continue with this orientation
        tempChildren.shift();
        best = score;
      } else {
        // abort, and try a different orientation
        row.area -= row.pop().area;
        rect = position(row, size, rect, false);
        size = Math.min(rect.width, rect.height);
        row.length = row.area = 0;
        best = Infinity;
      }
    }

    if (row.length) {
      rect = position(row, size, rect, true);
      row.length = row.area = 0;
    }

    return _objectSpread({}, node, {
      children: scaleChildren.map(function (c) {
        return squarify(c, aspectRatio);
      })
    });
  }

  return node;
};

var Treemap =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Treemap, _PureComponent);

  function Treemap() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Treemap);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Treemap)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = _this.constructor.createDefaultState();

    _this.handleAnimationEnd = function () {
      var onAnimationEnd = _this.props.onAnimationEnd;

      _this.setState({
        isAnimationFinished: true
      });

      if (__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default()(onAnimationEnd)) {
        onAnimationEnd();
      }
    };

    _this.handleAnimationStart = function () {
      var onAnimationStart = _this.props.onAnimationStart;

      _this.setState({
        isAnimationFinished: false
      });

      if (__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default()(onAnimationStart)) {
        onAnimationStart();
      }
    };

    return _this;
  }

  _createClass(Treemap, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          type = _this$props.type,
          width = _this$props.width,
          height = _this$props.height,
          data = _this$props.data,
          dataKey = _this$props.dataKey,
          aspectRatio = _this$props.aspectRatio;

      var _this$computeRoot = this.computeRoot({
        type: type,
        width: width,
        height: height,
        data: data,
        dataKey: dataKey,
        aspectRatio: aspectRatio
      }),
          formatRoot = _this$computeRoot.formatRoot,
          currentRoot = _this$computeRoot.currentRoot,
          nestIndex = _this$computeRoot.nestIndex;

      this.setState({
        formatRoot: formatRoot,
        currentRoot: currentRoot,
        nestIndex: nestIndex
      });
    }
  }, {
    key: "computeRoot",
    value: function computeRoot(_ref2) {
      var type = _ref2.type,
          width = _ref2.width,
          height = _ref2.height,
          data = _ref2.data,
          dataKey = _ref2.dataKey,
          aspectRatio = _ref2.aspectRatio;
      var root = computeNode({
        depth: 0,
        node: {
          children: data,
          x: 0,
          y: 0,
          width: width,
          height: height
        },
        index: 0,
        valueKey: dataKey
      });
      var formatRoot = squarify(root, aspectRatio);
      var nestIndex = this.state.nestIndex;

      if (type === 'nest') {
        nestIndex.push(root);
      }

      return {
        formatRoot: formatRoot,
        currentRoot: root,
        nestIndex: nestIndex
      };
    } // eslint-disable-next-line camelcase

  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var type = nextProps.type,
          width = nextProps.width,
          height = nextProps.height,
          data = nextProps.data,
          dataKey = nextProps.dataKey,
          aspectRatio = nextProps.aspectRatio;

      if (data !== this.props.data || type !== this.props.type || width !== this.props.width || height !== this.props.height || dataKey !== this.props.dataKey || aspectRatio !== this.props.aspectRatio) {
        var nextRoot = this.computeRoot({
          type: type,
          width: width,
          height: height,
          data: data,
          dataKey: dataKey,
          aspectRatio: aspectRatio
        });
        this.setState(_objectSpread({}, this.constructor.createDefaultState(), {}, nextRoot, {
          nestIndex: [nextRoot.currentRoot]
        }));
      }
    }
    /**
     * Returns default, reset state for the treemap chart.
     * @return {Object} Whole new state
     */

  }, {
    key: "handleMouseEnter",
    value: function handleMouseEnter(node, e) {
      var _this$props2 = this.props,
          onMouseEnter = _this$props2.onMouseEnter,
          children = _this$props2.children;
      var tooltipItem = Object(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["j" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_12__component_Tooltip__["a" /* default */]);

      if (tooltipItem) {
        this.setState({
          isTooltipActive: true,
          activeNode: node
        }, function () {
          if (onMouseEnter) {
            onMouseEnter(node, e);
          }
        });
      } else if (onMouseEnter) {
        onMouseEnter(node, e);
      }
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave(node, e) {
      var _this$props3 = this.props,
          onMouseLeave = _this$props3.onMouseLeave,
          children = _this$props3.children;
      var tooltipItem = Object(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["j" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_12__component_Tooltip__["a" /* default */]);

      if (tooltipItem) {
        this.setState({
          isTooltipActive: false,
          activeNode: null
        }, function () {
          if (onMouseLeave) {
            onMouseLeave(node, e);
          }
        });
      } else if (onMouseLeave) {
        onMouseLeave(node, e);
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(node) {
      var _this$props4 = this.props,
          onClick = _this$props4.onClick,
          type = _this$props4.type;

      if (type === 'nest' && node.children) {
        var _this$props5 = this.props,
            width = _this$props5.width,
            height = _this$props5.height,
            dataKey = _this$props5.dataKey,
            aspectRatio = _this$props5.aspectRatio;
        var root = computeNode({
          depth: 0,
          node: _objectSpread({}, node, {
            x: 0,
            y: 0,
            width: width,
            height: height
          }),
          index: 0,
          valueKey: dataKey
        });
        var formatRoot = squarify(root, aspectRatio);
        var nestIndex = this.state.nestIndex;
        nestIndex.push(node);
        this.setState({
          formatRoot: formatRoot,
          currentRoot: root,
          nestIndex: nestIndex
        });
      }

      if (onClick) {
        onClick(node);
      }
    }
  }, {
    key: "handleNestIndex",
    value: function handleNestIndex(node, i) {
      var nestIndex = this.state.nestIndex;
      var _this$props6 = this.props,
          width = _this$props6.width,
          height = _this$props6.height,
          dataKey = _this$props6.dataKey,
          aspectRatio = _this$props6.aspectRatio;
      var root = computeNode({
        depth: 0,
        node: _objectSpread({}, node, {
          x: 0,
          y: 0,
          width: width,
          height: height
        }),
        index: 0,
        valueKey: dataKey
      });
      var formatRoot = squarify(root, aspectRatio);
      nestIndex = nestIndex.slice(0, i + 1);
      this.setState({
        formatRoot: formatRoot,
        currentRoot: node,
        nestIndex: nestIndex
      });
    }
  }, {
    key: "renderItem",
    value: function renderItem(content, nodeProps, isLeaf) {
      var _this2 = this;

      var _this$props7 = this.props,
          isAnimationActive = _this$props7.isAnimationActive,
          animationBegin = _this$props7.animationBegin,
          animationDuration = _this$props7.animationDuration,
          animationEasing = _this$props7.animationEasing,
          isUpdateAnimationActive = _this$props7.isUpdateAnimationActive,
          type = _this$props7.type,
          animationId = _this$props7.animationId,
          colorPanel = _this$props7.colorPanel;
      var isAnimationFinished = this.state.isAnimationFinished;
      var width = nodeProps.width,
          height = nodeProps.height,
          x = nodeProps.x,
          y = nodeProps.y,
          depth = nodeProps.depth;
      var translateX = parseInt((Math.random() * 2 - 1) * width, 10);
      var event = {};

      if (isLeaf || type === 'nest') {
        event = {
          onMouseEnter: this.handleMouseEnter.bind(this, nodeProps),
          onMouseLeave: this.handleMouseLeave.bind(this, nodeProps),
          onClick: this.handleClick.bind(this, nodeProps)
        };
      }

      if (!isAnimationActive) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */], event, this.constructor.renderContentItem(content, _objectSpread({}, nodeProps, {
          isAnimationActive: false,
          isUpdateAnimationActive: false,
          width: width,
          height: height,
          x: x,
          y: y
        }), type, colorPanel));
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_smooth__["a" /* default */], {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        key: "treemap-".concat(animationId),
        from: {
          x: x,
          y: y,
          width: width,
          height: height
        },
        to: {
          x: x,
          y: y,
          width: width,
          height: height
        },
        onAnimationStart: this.handleAnimationStart,
        onAnimationEnd: this.handleAnimationEnd
      }, function (_ref3) {
        var currX = _ref3.x,
            currY = _ref3.y,
            currWidth = _ref3.width,
            currHeight = _ref3.height;
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_smooth__["a" /* default */], {
          from: "translate(".concat(translateX, "px, ").concat(translateX, "px)"),
          to: "translate(0, 0)",
          attributeName: "transform",
          begin: animationBegin,
          easing: animationEasing,
          isActive: isAnimationActive,
          duration: animationDuration
        }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */], event, function () {
          // when animation Duration , only render depth=1 nodes
          if (depth > 2 && !isAnimationFinished) {
            return null;
          }

          return _this2.constructor.renderContentItem(content, _objectSpread({}, nodeProps, {
            isAnimationActive: isAnimationActive,
            isUpdateAnimationActive: !isUpdateAnimationActive,
            width: currWidth,
            height: currHeight,
            x: currX,
            y: currY
          }), type, colorPanel);
        }()));
      });
    }
  }, {
    key: "renderNode",
    value: function renderNode(root, node, i) {
      var _this3 = this;

      var _this$props8 = this.props,
          content = _this$props8.content,
          type = _this$props8.type;

      var nodeProps = _objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["l" /* getPresentationAttributes */])(this.props), {}, node, {
        root: root
      });

      var isLeaf = !node.children || !node.children.length;
      var currentRoot = this.state.currentRoot;
      var isCurrentRootChild = (currentRoot.children || []).filter(function (item) {
        return item.depth === node.depth && item.name === node.name;
      });

      if (!isCurrentRootChild.length && root.depth && type === 'nest') {
        return null;
      }

      return (// eslint-disable-next-line react/no-array-index-key
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */], {
          key: "recharts-treemap-node-".concat(i),
          className: "recharts-treemap-depth-".concat(node.depth)
        }, this.renderItem(content, nodeProps, isLeaf), node.children && node.children.length ? node.children.map(function (child, index) {
          return _this3.renderNode(node, child, index);
        }) : null)
      );
    }
  }, {
    key: "renderAllNodes",
    value: function renderAllNodes() {
      var formatRoot = this.state.formatRoot;

      if (!formatRoot) {
        return null;
      }

      return this.renderNode(formatRoot, formatRoot, 0);
    }
  }, {
    key: "renderTooltip",
    value: function renderTooltip() {
      var _this$props9 = this.props,
          children = _this$props9.children,
          nameKey = _this$props9.nameKey;
      var tooltipItem = Object(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["j" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_12__component_Tooltip__["a" /* default */]);

      if (!tooltipItem) {
        return null;
      }

      var _this$props10 = this.props,
          width = _this$props10.width,
          height = _this$props10.height,
          dataKey = _this$props10.dataKey;
      var _this$state = this.state,
          isTooltipActive = _this$state.isTooltipActive,
          activeNode = _this$state.activeNode;
      var viewBox = {
        x: 0,
        y: 0,
        width: width,
        height: height
      };
      var coordinate = activeNode ? {
        x: activeNode.x + activeNode.width / 2,
        y: activeNode.y + activeNode.height / 2
      } : null;
      var payload = isTooltipActive && activeNode ? [{
        payload: activeNode,
        name: Object(__WEBPACK_IMPORTED_MODULE_14__util_ChartUtils__["v" /* getValueByDataKey */])(activeNode, nameKey, ''),
        value: Object(__WEBPACK_IMPORTED_MODULE_14__util_ChartUtils__["v" /* getValueByDataKey */])(activeNode, dataKey)
      }] : [];
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(tooltipItem, {
        viewBox: viewBox,
        active: isTooltipActive,
        coordinate: coordinate,
        label: '',
        payload: payload
      });
    } // render nest treemap

  }, {
    key: "renderNestIndex",
    value: function renderNestIndex() {
      var _this4 = this;

      var _this$props11 = this.props,
          nameKey = _this$props11.nameKey,
          nestIndexContent = _this$props11.nestIndexContent;
      var nestIndex = this.state.nestIndex;
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
        className: "recharts-treemap-nest-index-wrapper",
        style: {
          marginTop: '8px',
          textAlign: 'center'
        }
      }, nestIndex.map(function (item, i) {
        var name = __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(item, nameKey, 'root');

        var content = null;

        if (__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(nestIndexContent)) {
          content = __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(nestIndexContent, item, i);
        }

        if (__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default()(nestIndexContent)) {
          content = nestIndexContent(item, i);
        } else {
          content = name;
        }

        return (// eslint-disable-next-line jsx-a11y/click-events-have-key-events
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
            onClick: _this4.handleNestIndex.bind(_this4, item, i),
            key: "nest-index-".concat(Object(__WEBPACK_IMPORTED_MODULE_17__util_DataUtils__["k" /* uniqueId */])()),
            className: "recharts-treemap-nest-index-box",
            style: {
              cursor: 'pointer',
              display: 'inline-block',
              padding: '0 7px',
              background: '#000',
              color: '#fff',
              marginRight: '3px'
            }
          }, content)
        );
      }));
    }
  }, {
    key: "render",
    value: function render() {
      if (!Object(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["r" /* validateWidthHeight */])(this)) {
        return null;
      }

      var _this$props12 = this.props,
          width = _this$props12.width,
          height = _this$props12.height,
          className = _this$props12.className,
          style = _this$props12.style,
          children = _this$props12.children,
          type = _this$props12.type,
          others = _objectWithoutProperties(_this$props12, ["width", "height", "className", "style", "children", "type"]);

      var attrs = Object(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["l" /* getPresentationAttributes */])(others);
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('recharts-wrapper', className),
        style: _objectSpread({}, style, {
          position: 'relative',
          cursor: 'default',
          width: width,
          height: height
        })
      }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__container_Surface__["a" /* default */], _extends({}, attrs, {
        width: width,
        height: type === 'nest' ? height - 30 : height
      }), this.renderAllNodes(), Object(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["h" /* filterSvgElements */])(children)), this.renderTooltip(), type === 'nest' && this.renderNestIndex());
    }
  }], [{
    key: "createDefaultState",
    value: function createDefaultState() {
      return {
        isTooltipActive: false,
        isAnimationFinished: false,
        activeNode: null,
        currentRoot: null,
        formatRoot: null,
        nestIndex: []
      };
    }
  }, {
    key: "renderContentItem",
    value: function renderContentItem(content, nodeProps, type, colorPanel) {
      if (__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(content)) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(content, nodeProps);
      }

      if (__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default()(content)) {
        return content(nodeProps);
      } // optimize default shape


      var x = nodeProps.x,
          y = nodeProps.y,
          width = nodeProps.width,
          height = nodeProps.height,
          index = nodeProps.index;
      var arrow = null;

      if (width > 10 && height > 10 && nodeProps.children && type === 'nest') {
        arrow = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shape_Polygon__["a" /* default */], {
          points: [{
            x: x + 2,
            y: y + height / 2
          }, {
            x: x + 6,
            y: y + height / 2 + 3
          }, {
            x: x + 2,
            y: y + height / 2 + 6
          }]
        });
      }

      var text = null;
      var nameSize = Object(__WEBPACK_IMPORTED_MODULE_16__util_DOMUtils__["c" /* getStringSize */])(nodeProps.name);

      if (width > 20 && height > 20 && nameSize.width < width && nameSize.height < height) {
        text = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("text", {
          x: x + 8,
          y: y + height / 2 + 7,
          fontSize: 14
        }, nodeProps.name);
      }

      var colors = colorPanel || __WEBPACK_IMPORTED_MODULE_15__util_Constants__["a" /* COLOR_PANEL */];
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("g", null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shape_Rectangle__["a" /* default */], _extends({
        fill: nodeProps.depth < 2 ? colors[index % colors.length] : 'rgba(255,255,255,0)',
        stroke: "#fff"
      }, __WEBPACK_IMPORTED_MODULE_1_lodash_omit___default()(nodeProps, 'children'))), arrow, text);
    }
  }]);

  return Treemap;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

Treemap.displayName = 'Treemap';
Treemap.propTypes = {
  width: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  data: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array,
  animationId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  style: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  aspectRatio: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  content: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]),
  fill: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  stroke: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  nameKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]),
  dataKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]),
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node]),
  // optional values flat/nest, flat show whole treemap, nest only show depth=1 node
  type: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['flat', 'nest']),
  colorPanel: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array,
  // customize nest index content
  nestIndexContent: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]),
  onAnimationStart: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onAnimationEnd: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  isAnimationActive: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  isUpdateAnimationActive: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  animationBegin: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
};
Treemap.defaultProps = {
  dataKey: 'value',
  aspectRatio: 0.5 * (1 + Math.sqrt(5)),
  isAnimationActive: !Object(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["o" /* isSsr */])(),
  isUpdateAnimationActive: !Object(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["o" /* isSsr */])(),
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'linear',
  type: 'flat'
};
/* harmony default export */ __webpack_exports__["a"] = (Treemap);

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(199),
    keys = __webpack_require__(159);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(199),
    keysIn = __webpack_require__(432);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(58),
    isPrototype = __webpack_require__(305),
    nativeKeysIn = __webpack_require__(1700);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 1700 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(199),
    getSymbols = __webpack_require__(353);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(199),
    getSymbolsIn = __webpack_require__(786);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 1703 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(417),
    cloneDataView = __webpack_require__(1705),
    cloneRegExp = __webpack_require__(1706),
    cloneSymbol = __webpack_require__(1707),
    cloneTypedArray = __webpack_require__(876);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(417);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 1706 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(168);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(1709),
    baseUnary = __webpack_require__(202),
    nodeUtil = __webpack_require__(355);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(256),
    isObjectLike = __webpack_require__(79);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(1711),
    baseUnary = __webpack_require__(202),
    nodeUtil = __webpack_require__(355);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(256),
    isObjectLike = __webpack_require__(79);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(235),
    last = __webpack_require__(773),
    parent = __webpack_require__(1713),
    toKey = __webpack_require__(203);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(314),
    baseSlice = __webpack_require__(845);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(303);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(308);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 1716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COLOR_PANEL; });
var COLOR_PANEL = ['#1890FF', '#66B5FF', '#41D9C7', '#2FC25B', '#6EDB8F', '#9AE65C', '#FACC14', '#E6965C', '#57AD71', '#223273', '#738AE6', '#7564CC', '#8543E0', '#A877ED', '#5C8EE6', '#13C2C2', '#70E0E0', '#5CA3E6', '#3436C7', '#8082FF', '#DD81E6', '#F04864', '#FA7D92', '#D598D9'];

/***/ }),
/* 1717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy__ = __webpack_require__(1718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_sumBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_min__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_maxBy__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_maxBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__container_Surface__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__container_Layer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__component_Tooltip__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shape_Rectangle__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_ShallowEqual__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_ChartUtils__ = __webpack_require__(51);





function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @file TreemapChart
 */










var defaultCoordinateOfTooltip = {
  x: 0,
  y: 0
};

var interpolationGenerator = function interpolationGenerator(a, b) {
  var ka = +a;
  var kb = b - ka;
  return function (t) {
    return ka + kb * t;
  };
};

var centerY = function centerY(node) {
  return node.y + node.dy / 2;
};

var getValue = function getValue(entry) {
  return entry && entry.value || 0;
};

var getSumOfIds = function getSumOfIds(links, ids) {
  return ids.reduce(function (result, id) {
    return result + getValue(links[id]);
  }, 0);
};

var getSumWithWeightedSource = function getSumWithWeightedSource(tree, links, ids) {
  return ids.reduce(function (result, id) {
    var link = links[id];
    var sourceNode = tree[link.source];
    return result + centerY(sourceNode) * getValue(links[id]);
  }, 0);
};

var getSumWithWeightedTarget = function getSumWithWeightedTarget(tree, links, ids) {
  return ids.reduce(function (result, id) {
    var link = links[id];
    var targetNode = tree[link.target];
    return result + centerY(targetNode) * getValue(links[id]);
  }, 0);
};

var ascendingY = function ascendingY(a, b) {
  return a.y - b.y;
};

var searchTargetsAndSources = function searchTargetsAndSources(links, id) {
  var sourceNodes = [];
  var sourceLinks = [];
  var targetNodes = [];
  var targetLinks = [];

  for (var i = 0, len = links.length; i < len; i++) {
    var link = links[i];

    if (link.source === id) {
      targetNodes.push(link.target);
      targetLinks.push(i);
    }

    if (link.target === id) {
      sourceNodes.push(link.source);
      sourceLinks.push(i);
    }
  }

  return {
    sourceNodes: sourceNodes,
    sourceLinks: sourceLinks,
    targetLinks: targetLinks,
    targetNodes: targetNodes
  };
};

var updateDepthOfTargets = function updateDepthOfTargets(tree, curNode) {
  var targetNodes = curNode.targetNodes;

  for (var i = 0, len = targetNodes.length; i < len; i++) {
    var target = tree[targetNodes[i]];

    if (target) {
      target.depth = Math.max(curNode.depth + 1, target.depth);
      updateDepthOfTargets(tree, target);
    }
  }
};

var getNodesTree = function getNodesTree(_ref, width, nodeWidth) {
  var nodes = _ref.nodes,
      links = _ref.links;
  var tree = nodes.map(function (entry, index) {
    var result = searchTargetsAndSources(links, index);
    return _objectSpread({}, entry, {}, result, {
      value: Math.max(getSumOfIds(links, result.sourceLinks), getSumOfIds(links, result.targetLinks)),
      depth: 0
    });
  });

  for (var i = 0, len = tree.length; i < len; i++) {
    var node = tree[i];

    if (!node.sourceNodes.length) {
      updateDepthOfTargets(tree, node);
    }
  }

  var maxDepth = __WEBPACK_IMPORTED_MODULE_3_lodash_maxBy___default()(tree, function (entry) {
    return entry.depth;
  }).depth;

  if (maxDepth >= 1) {
    var childWidth = (width - nodeWidth) / maxDepth;

    for (var _i = 0, _len = tree.length; _i < _len; _i++) {
      var _node = tree[_i];

      if (!_node.targetNodes.length) {
        _node.depth = maxDepth;
      }

      _node.x = _node.depth * childWidth;
      _node.dx = nodeWidth;
    }
  }

  return {
    tree: tree,
    maxDepth: maxDepth
  };
};

var getDepthTree = function getDepthTree(tree) {
  var result = [];

  for (var i = 0, len = tree.length; i < len; i++) {
    var node = tree[i];

    if (!result[node.depth]) {
      result[node.depth] = [];
    }

    result[node.depth].push(node);
  }

  return result;
};

var updateYOfTree = function updateYOfTree(depthTree, height, nodePadding, links) {
  var yRatio = __WEBPACK_IMPORTED_MODULE_2_lodash_min___default()(depthTree.map(function (nodes) {
    return (height - (nodes.length - 1) * nodePadding) / __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default()(nodes, getValue);
  }));

  for (var d = 0, maxDepth = depthTree.length; d < maxDepth; d++) {
    for (var i = 0, len = depthTree[d].length; i < len; i++) {
      var node = depthTree[d][i];
      node.y = i;
      node.dy = node.value * yRatio;
    }
  }

  return links.map(function (link) {
    return _objectSpread({}, link, {
      dy: getValue(link) * yRatio
    });
  });
};

var resolveCollisions = function resolveCollisions(depthTree, height, nodePadding) {
  for (var i = 0, len = depthTree.length; i < len; i++) {
    var nodes = depthTree[i];
    var n = nodes.length; // Sort by the value of y

    nodes.sort(ascendingY);
    var y0 = 0;

    for (var j = 0; j < n; j++) {
      var node = nodes[j];
      var dy = y0 - node.y;

      if (dy > 0) {
        node.y += dy;
      }

      y0 = node.y + node.dy + nodePadding;
    }

    y0 = height + nodePadding;

    for (var _j = n - 1; _j >= 0; _j--) {
      var _node2 = nodes[_j];

      var _dy = _node2.y + _node2.dy + nodePadding - y0;

      if (_dy > 0) {
        _node2.y -= _dy;
        y0 = _node2.y;
      } else {
        break;
      }
    }
  }
};

var relaxLeftToRight = function relaxLeftToRight(tree, depthTree, links, alpha) {
  for (var i = 0, maxDepth = depthTree.length; i < maxDepth; i++) {
    var nodes = depthTree[i];

    for (var j = 0, len = nodes.length; j < len; j++) {
      var node = nodes[j];

      if (node.sourceLinks.length) {
        var sourceSum = getSumOfIds(links, node.sourceLinks);
        var weightedSum = getSumWithWeightedSource(tree, links, node.sourceLinks);
        var y = weightedSum / sourceSum;
        node.y += (y - centerY(node)) * alpha;
      }
    }
  }
};

var relaxRightToLeft = function relaxRightToLeft(tree, depthTree, links, alpha) {
  for (var i = depthTree.length - 1; i >= 0; i--) {
    var nodes = depthTree[i];

    for (var j = 0, len = nodes.length; j < len; j++) {
      var node = nodes[j];

      if (node.targetLinks.length) {
        var targetSum = getSumOfIds(links, node.targetLinks);
        var weightedSum = getSumWithWeightedTarget(tree, links, node.targetLinks);
        var y = weightedSum / targetSum;
        node.y += (y - centerY(node)) * alpha;
      }
    }
  }
};

var updateYOfLinks = function updateYOfLinks(tree, links) {
  for (var i = 0, len = tree.length; i < len; i++) {
    var node = tree[i];
    var sy = 0;
    var ty = 0;
    node.targetLinks.sort(function (a, b) {
      return tree[links[a].target].y - tree[links[b].target].y;
    });
    node.sourceLinks.sort(function (a, b) {
      return tree[links[a].source].y - tree[links[b].source].y;
    });

    for (var j = 0, tLen = node.targetLinks.length; j < tLen; j++) {
      var link = links[node.targetLinks[j]];

      if (link) {
        link.sy = sy;
        sy += link.dy;
      }
    }

    for (var _j2 = 0, sLen = node.sourceLinks.length; _j2 < sLen; _j2++) {
      var _link = links[node.sourceLinks[_j2]];

      if (_link) {
        _link.ty = ty;
        ty += _link.dy;
      }
    }
  }
};

var computeData = function computeData(_ref2) {
  var data = _ref2.data,
      width = _ref2.width,
      height = _ref2.height,
      iterations = _ref2.iterations,
      nodeWidth = _ref2.nodeWidth,
      nodePadding = _ref2.nodePadding;
  var links = data.links;

  var _getNodesTree = getNodesTree(data, width, nodeWidth),
      tree = _getNodesTree.tree;

  var depthTree = getDepthTree(tree);
  var newLinks = updateYOfTree(depthTree, height, nodePadding, links);
  resolveCollisions(depthTree, height, nodePadding);
  var alpha = 1;

  for (var i = 1; i <= iterations; i++) {
    relaxRightToLeft(tree, depthTree, newLinks, alpha *= 0.99);
    resolveCollisions(depthTree, height, nodePadding);
    relaxLeftToRight(tree, depthTree, newLinks, alpha);
    resolveCollisions(depthTree, height, nodePadding);
  }

  updateYOfLinks(tree, newLinks);
  return {
    nodes: tree,
    links: newLinks
  };
};

var getCoordinateOfTooltip = function getCoordinateOfTooltip(el, type) {
  if (type === 'node') {
    return {
      x: el.x + el.width / 2,
      y: el.y + el.height / 2
    };
  }

  return {
    x: (el.sourceX + el.targetX) / 2,
    y: (el.sourceY + el.targetY) / 2
  };
};

var getPayloadOfTooltip = function getPayloadOfTooltip(el, type, nameKey) {
  var payload = el.payload;

  if (type === 'node') {
    return [{
      payload: el,
      name: Object(__WEBPACK_IMPORTED_MODULE_13__util_ChartUtils__["v" /* getValueByDataKey */])(payload, nameKey, ''),
      value: Object(__WEBPACK_IMPORTED_MODULE_13__util_ChartUtils__["v" /* getValueByDataKey */])(payload, 'value')
    }];
  }

  if (payload.source && payload.target) {
    var sourceName = Object(__WEBPACK_IMPORTED_MODULE_13__util_ChartUtils__["v" /* getValueByDataKey */])(payload.source, nameKey, '');
    var targetName = Object(__WEBPACK_IMPORTED_MODULE_13__util_ChartUtils__["v" /* getValueByDataKey */])(payload.target, nameKey, '');
    return [{
      payload: el,
      name: "".concat(sourceName, " - ").concat(targetName),
      value: Object(__WEBPACK_IMPORTED_MODULE_13__util_ChartUtils__["v" /* getValueByDataKey */])(payload, 'value')
    }];
  }

  return [];
};

var Sankey =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Sankey, _PureComponent);

  function Sankey(props) {
    var _this;

    _classCallCheck(this, Sankey);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Sankey).call(this, props));
    _this.state = _this.constructor.createDefaultState(props);
    return _this;
  } // eslint-disable-next-line camelcase


  _createClass(Sankey, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this$props = this.props,
          data = _this$props.data,
          width = _this$props.width,
          height = _this$props.height,
          margin = _this$props.margin,
          iterations = _this$props.iterations,
          nodeWidth = _this$props.nodeWidth,
          nodePadding = _this$props.nodePadding,
          nameKey = _this$props.nameKey;

      if (nextProps.data !== data || nextProps.width !== width || nextProps.height !== height || !Object(__WEBPACK_IMPORTED_MODULE_11__util_ShallowEqual__["a" /* shallowEqual */])(nextProps.margin, margin) || nextProps.iterations !== iterations || nextProps.nodeWidth !== nodeWidth || nextProps.nodePadding !== nodePadding || nextProps.nameKey !== nameKey) {
        this.setState(this.constructor.createDefaultState(nextProps));
      }
    }
    /**
     * Returns default, reset state for the sankey chart.
     * @param  {Object} props The latest props
     * @return {Object} Whole new state
     */

  }, {
    key: "handleMouseEnter",
    value: function handleMouseEnter(el, type, e) {
      var _this$props2 = this.props,
          onMouseEnter = _this$props2.onMouseEnter,
          children = _this$props2.children;
      var tooltipItem = Object(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["j" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_9__component_Tooltip__["a" /* default */]);

      if (tooltipItem) {
        this.setState({
          activeElement: el,
          activeElementType: type,
          isTooltipActive: true
        }, function () {
          if (onMouseEnter) {
            onMouseEnter(el, type, e);
          }
        });
      } else if (onMouseEnter) {
        onMouseEnter(el, type, e);
      }
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave(el, type, e) {
      var _this$props3 = this.props,
          onMouseLeave = _this$props3.onMouseLeave,
          children = _this$props3.children;
      var tooltipItem = Object(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["j" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_9__component_Tooltip__["a" /* default */]);

      if (tooltipItem) {
        this.setState({
          isTooltipActive: false
        }, function () {
          if (onMouseLeave) {
            onMouseLeave(el, type, e);
          }
        });
      } else if (onMouseLeave) {
        onMouseLeave(el, type, e);
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(el, type, e) {
      var onClick = this.props.onClick;
      if (onClick) onClick(el, type, e);
    }
  }, {
    key: "renderLinks",
    value: function renderLinks(links, nodes) {
      var _this2 = this;

      var _this$props4 = this.props,
          linkCurvature = _this$props4.linkCurvature,
          linkContent = _this$props4.link,
          margin = _this$props4.margin;
      var top = margin.top || 0;
      var left = margin.left || 0;
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */], {
        className: "recharts-sankey-links",
        key: "recharts-sankey-links"
      }, links.map(function (link, i) {
        var sourceRelativeY = link.sy,
            targetRelativeY = link.ty,
            linkWidth = link.dy;
        var source = nodes[link.source];
        var target = nodes[link.target];
        var sourceX = source.x + source.dx + left;
        var targetX = target.x + left;
        var interpolationFunc = interpolationGenerator(sourceX, targetX);
        var sourceControlX = interpolationFunc(linkCurvature);
        var targetControlX = interpolationFunc(1 - linkCurvature);
        var sourceY = source.y + sourceRelativeY + linkWidth / 2 + top;
        var targetY = target.y + targetRelativeY + linkWidth / 2 + top;

        var linkProps = _objectSpread({
          sourceX: sourceX,
          targetX: targetX,
          sourceY: sourceY,
          targetY: targetY,
          sourceControlX: sourceControlX,
          targetControlX: targetControlX,
          sourceRelativeY: sourceRelativeY,
          targetRelativeY: targetRelativeY,
          linkWidth: linkWidth,
          index: i,
          payload: _objectSpread({}, link, {
            source: source,
            target: target
          })
        }, Object(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["l" /* getPresentationAttributes */])(linkContent));

        var events = {
          onMouseEnter: _this2.handleMouseEnter.bind(_this2, linkProps, 'link'),
          onMouseLeave: _this2.handleMouseLeave.bind(_this2, linkProps, 'link'),
          onClick: _this2.handleClick.bind(_this2, linkProps, 'link')
        };
        return (// eslint-disable-next-line react/no-array-index-key
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */], _extends({
            key: "link".concat(i)
          }, events), _this2.constructor.renderLinkItem(linkContent, linkProps))
        );
      }));
    }
  }, {
    key: "renderNodes",
    value: function renderNodes(nodes) {
      var _this3 = this;

      var _this$props5 = this.props,
          nodeContent = _this$props5.node,
          margin = _this$props5.margin;
      var top = margin.top || 0;
      var left = margin.left || 0;
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */], {
        className: "recharts-sankey-nodes",
        key: "recharts-sankey-nodes"
      }, nodes.map(function (node, i) {
        var x = node.x,
            y = node.y,
            dx = node.dx,
            dy = node.dy;

        var nodeProps = _objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["l" /* getPresentationAttributes */])(nodeContent), {
          x: x + left,
          y: y + top,
          width: dx,
          height: dy,
          index: i,
          payload: node
        });

        var events = {
          onMouseEnter: _this3.handleMouseEnter.bind(_this3, nodeProps, 'node'),
          onMouseLeave: _this3.handleMouseLeave.bind(_this3, nodeProps, 'node'),
          onClick: _this3.handleClick.bind(_this3, nodeProps, 'node')
        };
        return (// eslint-disable-next-line react/no-array-index-key
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */], _extends({
            key: "node".concat(i)
          }, events), _this3.constructor.renderNodeItem(nodeContent, nodeProps))
        );
      }));
    }
  }, {
    key: "renderTooltip",
    value: function renderTooltip() {
      var _this$props6 = this.props,
          children = _this$props6.children,
          width = _this$props6.width,
          height = _this$props6.height,
          nameKey = _this$props6.nameKey;
      var tooltipItem = Object(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["j" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_9__component_Tooltip__["a" /* default */]);

      if (!tooltipItem) {
        return null;
      }

      var _this$state = this.state,
          isTooltipActive = _this$state.isTooltipActive,
          activeElement = _this$state.activeElement,
          activeElementType = _this$state.activeElementType;
      var viewBox = {
        x: 0,
        y: 0,
        width: width,
        height: height
      };
      var coordinate = activeElement ? getCoordinateOfTooltip(activeElement, activeElementType) : defaultCoordinateOfTooltip;
      var payload = activeElement ? getPayloadOfTooltip(activeElement, activeElementType, nameKey) : [];
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(tooltipItem, {
        viewBox: viewBox,
        active: isTooltipActive,
        coordinate: coordinate,
        label: '',
        payload: payload
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (!Object(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["r" /* validateWidthHeight */])(this)) {
        return null;
      }

      var _this$props7 = this.props,
          width = _this$props7.width,
          height = _this$props7.height,
          className = _this$props7.className,
          style = _this$props7.style,
          children = _this$props7.children,
          others = _objectWithoutProperties(_this$props7, ["width", "height", "className", "style", "children"]);

      var _this$state2 = this.state,
          links = _this$state2.links,
          nodes = _this$state2.nodes;
      var attrs = Object(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["l" /* getPresentationAttributes */])(others);
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('recharts-wrapper', className),
        style: _objectSpread({}, style, {
          position: 'relative',
          cursor: 'default',
          width: width,
          height: height
        })
      }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__container_Surface__["a" /* default */], _extends({}, attrs, {
        width: width,
        height: height
      }), Object(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["h" /* filterSvgElements */])(children), this.renderLinks(links, nodes), this.renderNodes(nodes)), this.renderTooltip());
    }
  }], [{
    key: "createDefaultState",
    value: function createDefaultState(props) {
      var data = props.data,
          width = props.width,
          height = props.height,
          margin = props.margin,
          iterations = props.iterations,
          nodeWidth = props.nodeWidth,
          nodePadding = props.nodePadding;
      var contentWidth = width - (margin && margin.left || 0) - (margin && margin.right || 0);
      var contentHeight = height - (margin && margin.top || 0) - (margin && margin.bottom || 0);

      var _computeData = computeData({
        data: data,
        width: contentWidth,
        height: contentHeight,
        iterations: iterations,
        nodeWidth: nodeWidth,
        nodePadding: nodePadding
      }),
          links = _computeData.links,
          nodes = _computeData.nodes;

      return {
        activeElement: null,
        activeElementType: null,
        isTooltipActive: false,
        nodes: nodes,
        links: links
      };
    }
  }, {
    key: "renderLinkItem",
    value: function renderLinkItem(option, props) {
      if (__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(option)) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(option, props);
      }

      if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        return option(props);
      }

      var sourceX = props.sourceX,
          sourceY = props.sourceY,
          sourceControlX = props.sourceControlX,
          targetX = props.targetX,
          targetY = props.targetY,
          targetControlX = props.targetControlX,
          linkWidth = props.linkWidth,
          others = _objectWithoutProperties(props, ["sourceX", "sourceY", "sourceControlX", "targetX", "targetY", "targetControlX", "linkWidth"]);

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", _extends({
        className: "recharts-sankey-link",
        d: "\n          M".concat(sourceX, ",").concat(sourceY, "\n          C").concat(sourceControlX, ",").concat(sourceY, " ").concat(targetControlX, ",").concat(targetY, " ").concat(targetX, ",").concat(targetY, "\n        "),
        fill: "none",
        stroke: "#333",
        strokeWidth: linkWidth,
        strokeOpacity: "0.2"
      }, Object(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["l" /* getPresentationAttributes */])(others)));
    }
  }, {
    key: "renderNodeItem",
    value: function renderNodeItem(option, props) {
      if (__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(option)) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(option, props);
      }

      if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        return option(props);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shape_Rectangle__["a" /* default */], _extends({
        className: "recharts-sankey-node",
        fill: "#0088fe",
        fillOpacity: "0.8"
      }, props));
    }
  }]);

  return Sankey;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

Sankey.displayName = 'Sankey';
Sankey.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {}, __WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["a" /* EVENT_ATTRIBUTES */], {
  nameKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]),
  dataKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]),
  width: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  data: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    nodes: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array,
    links: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
      target: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
      source: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
      value: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
    }))
  }),
  nodePadding: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  nodeWidth: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  linkCurvature: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  iterations: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  node: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]),
  link: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]),
  style: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node]),
  margin: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    top: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    right: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    bottom: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    left: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })
});
Sankey.defaultProps = {
  nodePadding: 10,
  nodeWidth: 10,
  nameKey: 'name',
  dataKey: 'value',
  linkCurvature: 0.5,
  iterations: 32,
  margin: {
    top: 5,
    right: 5,
    bottom: 5,
    left: 5
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Sankey);

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(67),
    baseSum = __webpack_require__(1719);

/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */
function sumBy(array, iteratee) {
  return (array && array.length)
    ? baseSum(array, baseIteratee(iteratee, 2))
    : 0;
}

module.exports = sumBy;


/***/ }),
/* 1719 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */
function baseSum(array, iteratee) {
  var result,
      index = -1,
      length = array.length;

  while (++index < length) {
    var current = iteratee(array[index]);
    if (current !== undefined) {
      result = result === undefined ? current : (result + current);
    }
  }
  return result;
}

module.exports = baseSum;


/***/ }),
/* 1720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__generateCategoricalChart__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__polar_Radar__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__polar_PolarAngleAxis__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__polar_PolarRadiusAxis__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_PolarUtils__ = __webpack_require__(82);
/**
 * @fileOverview Radar Chart
 */






/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__generateCategoricalChart__["a" /* default */])({
  chartName: 'RadarChart',
  GraphicalChild: __WEBPACK_IMPORTED_MODULE_2__polar_Radar__["a" /* default */],
  axisComponents: [{
    axisType: 'angleAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_3__polar_PolarAngleAxis__["a" /* default */]
  }, {
    axisType: 'radiusAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_4__polar_PolarRadiusAxis__["a" /* default */]
  }],
  formatAxisMap: __WEBPACK_IMPORTED_MODULE_5__util_PolarUtils__["b" /* formatAxisMap */],
  defaultProps: {
    layout: 'centric',
    startAngle: 90,
    endAngle: -270,
    cx: '50%',
    cy: '50%',
    innerRadius: 0,
    outerRadius: '80%'
  },
  propTypes: {
    layout: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['centric']),
    startAngle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
    endAngle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
    cx: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
    cy: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
    innerRadius: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
    outerRadius: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string])
  }
}));

/***/ }),
/* 1721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__generateCategoricalChart__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartesian_Scatter__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cartesian_XAxis__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cartesian_YAxis__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cartesian_ZAxis__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_CartesianUtils__ = __webpack_require__(125);
/**
 * @fileOverview Scatter Chart
 */






/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__generateCategoricalChart__["a" /* default */])({
  chartName: 'ScatterChart',
  GraphicalChild: __WEBPACK_IMPORTED_MODULE_1__cartesian_Scatter__["a" /* default */],
  eventType: 'single',
  axisComponents: [{
    axisType: 'xAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_2__cartesian_XAxis__["a" /* default */]
  }, {
    axisType: 'yAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_3__cartesian_YAxis__["a" /* default */]
  }, {
    axisType: 'zAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_4__cartesian_ZAxis__["a" /* default */]
  }],
  formatAxisMap: __WEBPACK_IMPORTED_MODULE_5__util_CartesianUtils__["b" /* formatAxisMap */]
}));

/***/ }),
/* 1722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__generateCategoricalChart__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartesian_Area__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cartesian_XAxis__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cartesian_YAxis__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_CartesianUtils__ = __webpack_require__(125);
/**
 * @fileOverview Area Chart
 */





/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__generateCategoricalChart__["a" /* default */])({
  chartName: 'AreaChart',
  GraphicalChild: __WEBPACK_IMPORTED_MODULE_1__cartesian_Area__["a" /* default */],
  axisComponents: [{
    axisType: 'xAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_2__cartesian_XAxis__["a" /* default */]
  }, {
    axisType: 'yAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_3__cartesian_YAxis__["a" /* default */]
  }],
  formatAxisMap: __WEBPACK_IMPORTED_MODULE_4__util_CartesianUtils__["b" /* formatAxisMap */]
}));

/***/ }),
/* 1723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__generateCategoricalChart__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__polar_PolarAngleAxis__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__polar_PolarRadiusAxis__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_PolarUtils__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__polar_RadialBar__ = __webpack_require__(778);
/**
 * @fileOverview Radar Bar Chart
 */






/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__generateCategoricalChart__["a" /* default */])({
  chartName: 'RadialBarChart',
  GraphicalChild: __WEBPACK_IMPORTED_MODULE_5__polar_RadialBar__["a" /* default */],
  legendContent: 'children',
  axisComponents: [{
    axisType: 'angleAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_2__polar_PolarAngleAxis__["a" /* default */]
  }, {
    axisType: 'radiusAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_3__polar_PolarRadiusAxis__["a" /* default */]
  }],
  formatAxisMap: __WEBPACK_IMPORTED_MODULE_4__util_PolarUtils__["b" /* formatAxisMap */],
  defaultProps: {
    layout: 'radial',
    startAngle: 0,
    endAngle: 360,
    cx: '50%',
    cy: '50%',
    innerRadius: 0,
    outerRadius: '80%'
  },
  propTypes: {
    layout: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['radial']),
    startAngle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
    endAngle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
    cx: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
    cy: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
    innerRadius: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
    outerRadius: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string])
  }
}));

/***/ }),
/* 1724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__generateCategoricalChart__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartesian_Area__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cartesian_Bar__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cartesian_Line__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cartesian_Scatter__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cartesian_XAxis__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cartesian_YAxis__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cartesian_ZAxis__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_CartesianUtils__ = __webpack_require__(125);
/**
 * @fileOverview Composed Chart
 */









/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__generateCategoricalChart__["a" /* default */])({
  chartName: 'ComposedChart',
  GraphicalChild: [__WEBPACK_IMPORTED_MODULE_3__cartesian_Line__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__cartesian_Area__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__cartesian_Bar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__cartesian_Scatter__["a" /* default */]],
  axisComponents: [{
    axisType: 'xAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_5__cartesian_XAxis__["a" /* default */]
  }, {
    axisType: 'yAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_6__cartesian_YAxis__["a" /* default */]
  }, {
    axisType: 'zAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_7__cartesian_ZAxis__["a" /* default */]
  }],
  formatAxisMap: __WEBPACK_IMPORTED_MODULE_8__util_CartesianUtils__["b" /* formatAxisMap */]
}));

/***/ }),
/* 1725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__generateCategoricalChart__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__numberAxis_Funnel__ = __webpack_require__(788);
/**
 * @fileOverview Funnel Chart
 */



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__generateCategoricalChart__["a" /* default */])({
  chartName: 'FunnelChart',
  GraphicalChild: __WEBPACK_IMPORTED_MODULE_2__numberAxis_Funnel__["a" /* default */],
  eventType: 'item',
  axisComponents: [],
  defaultProps: {
    layout: 'centric'
  },
  propTypes: {
    layout: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['centric'])
  }
}));

/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1727);
module.exports = __webpack_require__(61).Object.getPrototypeOf;


/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(216);
var $getPrototypeOf = __webpack_require__(696);

__webpack_require__(790)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1729), __esModule: true };

/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(693);
__webpack_require__(1730);
module.exports = __webpack_require__(61).Array.from;


/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(370);
var $export = __webpack_require__(118);
var toObject = __webpack_require__(216);
var call = __webpack_require__(1731);
var isArrayIter = __webpack_require__(1732);
var toLength = __webpack_require__(692);
var createProperty = __webpack_require__(1733);
var getIterFn = __webpack_require__(1734);

$export($export.S + $export.F * !__webpack_require__(1736)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(183);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(217);
var ITERATOR = __webpack_require__(90)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(120);
var createDesc = __webpack_require__(215);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(1735);
var ITERATOR = __webpack_require__(90)('iterator');
var Iterators = __webpack_require__(217);
module.exports = __webpack_require__(61).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(372);
var TAG = __webpack_require__(90)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(90)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRouterDom = __webpack_require__(13);

var _asyncComponent = _interopRequireDefault(__webpack_require__(44));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Components = function Components(_ref) {
  var match = _ref.match;
  return _react["default"].createElement("div", {
    className: "app-wrapper"
  }, _react["default"].createElement(_reactRouterDom.Switch, null, _react["default"].createElement(_reactRouterDom.Redirect, {
    exact: true,
    from: "".concat(match.url, "/"),
    to: "".concat(match.url, "/alerts")
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/alerts"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 2002));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/appbar"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 2003));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/auto-complete"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 2004));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/avatars"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 2005));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/badges"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 2006));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/buttons"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 2007));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/button-group"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 2008));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/breadcrumbs"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, 2009));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/cards"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 2010));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/carousel"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(4/* aggressive-merge */).then(__webpack_require__.bind(null, 2011));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/color-picker"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(5/* aggressive-merge */).then(__webpack_require__.bind(null, 2012));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/modals"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 2013));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/dividers"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 2014));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/drawer"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 2015));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/expansion-panel"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 2016));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/grid-list"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 2017));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/list"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 2018));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/pickers"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(6/* aggressive-merge */).then(__webpack_require__.bind(null, 2019));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/popovers"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, 2020));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/progressbar"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 2021));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/selection"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 2022));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/selects"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 2023));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/tabs"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 2024));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/text-fields"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, 2025));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/tooltips"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, 2026));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/typography"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 2027));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 39));
    })
  })));
};

var _default = Components;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Components, "Components", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/components/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/components/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/components/index.js");

  __REACT_HOT_LOADER__.register(_asyncComponent, "_asyncComponent", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/components/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/components/index.js");

  __REACT_HOT_LOADER__.register(Components, "Components", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/components/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/components/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/components/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/components/index.js");
}();

;

/***/ }),
/* 1738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = toArrayChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = findChildInChildrenByKey;
/* harmony export (immutable) */ __webpack_exports__["b"] = findShownChildInChildrenByKey;
/* unused harmony export findHiddenChildInChildrenByKey */
/* harmony export (immutable) */ __webpack_exports__["c"] = isSameChildren;
/* harmony export (immutable) */ __webpack_exports__["d"] = mergeChildren;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function toArrayChildren(children) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    ret.push(child);
  });
  return ret;
}

function findChildInChildrenByKey(children, key) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (ret) {
        return;
      }
      if (child && child.key === key) {
        ret = child;
      }
    });
  }
  return ret;
}

function findShownChildInChildrenByKey(children, key, showProp) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (child && child.key === key && child.props[showProp]) {
        if (ret) {
          throw new Error('two child with same key for <rc-animate> children');
        }
        ret = child;
      }
    });
  }
  return ret;
}

function findHiddenChildInChildrenByKey(children, key, showProp) {
  var found = 0;
  if (children) {
    children.forEach(function (child) {
      if (found) {
        return;
      }
      found = child && child.key === key && !child.props[showProp];
    });
  }
  return found;
}

function isSameChildren(c1, c2, showProp) {
  var same = c1.length === c2.length;
  if (same) {
    c1.forEach(function (child, index) {
      var child2 = c2[index];
      if (child && child2) {
        if (child && !child2 || !child && child2) {
          same = false;
        } else if (child.key !== child2.key) {
          same = false;
        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
          same = false;
        }
      }
    });
  }
  return same;
}

function mergeChildren(prev, next) {
  var ret = [];

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextChildrenPending = {};
  var pendingChildren = [];
  prev.forEach(function (child) {
    if (child && findChildInChildrenByKey(next, child.key)) {
      if (pendingChildren.length) {
        nextChildrenPending[child.key] = pendingChildren;
        pendingChildren = [];
      }
    } else {
      pendingChildren.push(child);
    }
  });

  next.forEach(function (child) {
    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
      ret = ret.concat(nextChildrenPending[child.key]);
    }
    ret.push(child);
  });

  ret = ret.concat(pendingChildren);

  return ret;
}

/***/ }),
/* 1739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_css_animation__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_animate__ = __webpack_require__(792);










var transitionMap = {
  enter: 'transitionEnter',
  appear: 'transitionAppear',
  leave: 'transitionLeave'
};

var AnimateChild = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AnimateChild, _React$Component);

  function AnimateChild() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AnimateChild);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AnimateChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isEnterSupported(this.props)) {
        this.transition('enter', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isAppearSupported(this.props)) {
        this.transition('appear', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isLeaveSupported(this.props)) {
        this.transition('leave', done);
      } else {
        // always sync, do not interupt with react component life cycle
        // update hidden -> animate hidden ->
        // didUpdate -> animate leave -> unmount (if animate is none)
        done();
      }
    }
  }, {
    key: 'transition',
    value: function transition(animationType, finishCallback) {
      var _this2 = this;

      var node = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
      var props = this.props;
      var transitionName = props.transitionName;
      var nameIsObj = typeof transitionName === 'object';
      this.stop();
      var end = function end() {
        _this2.stopper = null;
        finishCallback();
      };
      if ((__WEBPACK_IMPORTED_MODULE_7_css_animation__["b" /* isCssAnimationSupported */] || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
        var activeName = name + '-active';
        if (nameIsObj && transitionName[animationType + 'Active']) {
          activeName = transitionName[animationType + 'Active'];
        }
        this.stopper = Object(__WEBPACK_IMPORTED_MODULE_7_css_animation__["a" /* default */])(node, {
          name: name,
          active: activeName
        }, end);
      } else {
        this.stopper = props.animation[animationType](node, end);
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var stopper = this.stopper;
      if (stopper) {
        this.stopper = null;
        stopper.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return AnimateChild;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

AnimateChild.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (AnimateChild);

/***/ }),
/* 1740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: 'transitionstart',
    WebkitTransition: 'webkitTransitionStart',
    MozTransition: 'mozTransitionStart',
    OTransition: 'oTransitionStart',
    msTransition: 'MSTransitionStart'
  },

  animationstart: {
    animation: 'animationstart',
    WebkitAnimation: 'webkitAnimationStart',
    MozAnimation: 'mozAnimationStart',
    OAnimation: 'oAnimationStart',
    msAnimation: 'MSAnimationStart'
  }
};

var END_EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var startEvents = [];
var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete START_EVENT_NAME_MAP.animationstart.animation;
    delete END_EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete START_EVENT_NAME_MAP.transitionstart.transition;
    delete END_EVENT_NAME_MAP.transitionend.transition;
  }

  function process(EVENT_NAME_MAP, events) {
    for (var baseEventName in EVENT_NAME_MAP) {
      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
        var baseEvents = EVENT_NAME_MAP[baseEventName];
        for (var styleName in baseEvents) {
          if (styleName in style) {
            events.push(baseEvents[styleName]);
            break;
          }
        }
      }
    }
  }

  process(START_EVENT_NAME_MAP, startEvents);
  process(END_EVENT_NAME_MAP, endEvents);
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  // Start events
  startEvents: startEvents,

  addStartEventListener: function addStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    startEvents.forEach(function (startEvent) {
      addEventListener(node, startEvent, eventListener);
    });
  },
  removeStartEventListener: function removeStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      return;
    }
    startEvents.forEach(function (startEvent) {
      removeEventListener(node, startEvent, eventListener);
    });
  },


  // End events
  endEvents: endEvents,

  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TransitionEvents);

/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var index = __webpack_require__(791);
} catch (err) {
  var index = __webpack_require__(791);
}

/**
 * Whitespace regexp.
 */

var re = /\s+/;

/**
 * toString reference.
 */

var toString = Object.prototype.toString;

/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */

module.exports = function(el){
  return new ClassList(el);
};

/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */

function ClassList(el) {
  if (!el || !el.nodeType) {
    throw new Error('A DOM element reference is required');
  }
  this.el = el;
  this.list = el.classList;
}

/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.add = function(name){
  // classList
  if (this.list) {
    this.list.add(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (!~i) arr.push(name);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.remove = function(name){
  if ('[object RegExp]' == toString.call(name)) {
    return this.removeMatching(name);
  }

  // classList
  if (this.list) {
    this.list.remove(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (~i) arr.splice(i, 1);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */

ClassList.prototype.removeMatching = function(re){
  var arr = this.array();
  for (var i = 0; i < arr.length; i++) {
    if (re.test(arr[i])) {
      this.remove(arr[i]);
    }
  }
  return this;
};

/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.toggle = function(name, force){
  // classList
  if (this.list) {
    if ("undefined" !== typeof force) {
      if (force !== this.list.toggle(name, force)) {
        this.list.toggle(name); // toggle again to correct
      }
    } else {
      this.list.toggle(name);
    }
    return this;
  }

  // fallback
  if ("undefined" !== typeof force) {
    if (!force) {
      this.remove(name);
    } else {
      this.add(name);
    }
  } else {
    if (this.has(name)) {
      this.remove(name);
    } else {
      this.add(name);
    }
  }

  return this;
};

/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */

ClassList.prototype.array = function(){
  var className = this.el.getAttribute('class') || '';
  var str = className.replace(/^\s+|\s+$/g, '');
  var arr = str.split(re);
  if ('' === arr[0]) arr.shift();
  return arr;
};

/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.has =
ClassList.prototype.contains = function(name){
  return this.list
    ? this.list.contains(name)
    : !! ~index(this.array(), name);
};


/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = addEventListener;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventObject = __webpack_require__(1743);

var _EventObject2 = _interopRequireDefault(_EventObject);

function addEventListener(target, eventType, callback, option) {
  function wrapCallback(e) {
    var ne = new _EventObject2['default'](e);
    callback.call(target, ne);
  }

  if (target.addEventListener) {
    var _ret = (function () {
      var useCapture = false;
      if (typeof option === 'object') {
        useCapture = option.capture || false;
      } else if (typeof option === 'boolean') {
        useCapture = option;
      }

      target.addEventListener(eventType, wrapCallback, option || false);

      return {
        v: {
          remove: function remove() {
            target.removeEventListener(eventType, wrapCallback, useCapture);
          }
        }
      };
    })();

    if (typeof _ret === 'object') return _ret.v;
  } else if (target.attachEvent) {
    target.attachEvent('on' + eventType, wrapCallback);
    return {
      remove: function remove() {
        target.detachEvent('on' + eventType, wrapCallback);
      }
    };
  }
}

module.exports = exports['default'];

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * event object for dom
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventBaseObject = __webpack_require__(1744);

var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);

var _objectAssign = __webpack_require__(77);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var TRUE = true;
var FALSE = false;
var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];

function isNullOrUndefined(w) {
  return w === null || w === undefined;
}

var eventNormalizers = [{
  reg: /^key/,
  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
  fix: function fix(event, nativeEvent) {
    if (isNullOrUndefined(event.which)) {
      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
    }

    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
    if (event.metaKey === undefined) {
      event.metaKey = event.ctrlKey;
    }
  }
}, {
  reg: /^touch/,
  props: ['touches', 'changedTouches', 'targetTouches']
}, {
  reg: /^hashchange$/,
  props: ['newURL', 'oldURL']
}, {
  reg: /^gesturechange$/i,
  props: ['rotation', 'scale']
}, {
  reg: /^(mousewheel|DOMMouseScroll)$/,
  props: [],
  fix: function fix(event, nativeEvent) {
    var deltaX = undefined;
    var deltaY = undefined;
    var delta = undefined;
    var wheelDelta = nativeEvent.wheelDelta;
    var axis = nativeEvent.axis;
    var wheelDeltaY = nativeEvent.wheelDeltaY;
    var wheelDeltaX = nativeEvent.wheelDeltaX;
    var detail = nativeEvent.detail;

    // ie/webkit
    if (wheelDelta) {
      delta = wheelDelta / 120;
    }

    // gecko
    if (detail) {
      // press control e.detail == 1 else e.detail == 3
      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
    }

    // Gecko
    if (axis !== undefined) {
      if (axis === event.HORIZONTAL_AXIS) {
        deltaY = 0;
        deltaX = 0 - delta;
      } else if (axis === event.VERTICAL_AXIS) {
        deltaX = 0;
        deltaY = delta;
      }
    }

    // Webkit
    if (wheelDeltaY !== undefined) {
      deltaY = wheelDeltaY / 120;
    }
    if (wheelDeltaX !== undefined) {
      deltaX = -1 * wheelDeltaX / 120;
    }

    // 默认 deltaY (ie)
    if (!deltaX && !deltaY) {
      deltaY = delta;
    }

    if (deltaX !== undefined) {
      /**
       * deltaX of mousewheel event
       * @property deltaX
       * @member Event.DomEvent.Object
       */
      event.deltaX = deltaX;
    }

    if (deltaY !== undefined) {
      /**
       * deltaY of mousewheel event
       * @property deltaY
       * @member Event.DomEvent.Object
       */
      event.deltaY = deltaY;
    }

    if (delta !== undefined) {
      /**
       * delta of mousewheel event
       * @property delta
       * @member Event.DomEvent.Object
       */
      event.delta = delta;
    }
  }
}, {
  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
  fix: function fix(event, nativeEvent) {
    var eventDoc = undefined;
    var doc = undefined;
    var body = undefined;
    var target = event.target;
    var button = nativeEvent.button;

    // Calculate pageX/Y if missing and clientX/Y available
    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
      eventDoc = target.ownerDocument || document;
      doc = eventDoc.documentElement;
      body = eventDoc.body;
      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
    }

    // which for click: 1 === left; 2 === middle; 3 === right
    // do not use button
    if (!event.which && button !== undefined) {
      if (button & 1) {
        event.which = 1;
      } else if (button & 2) {
        event.which = 3;
      } else if (button & 4) {
        event.which = 2;
      } else {
        event.which = 0;
      }
    }

    // add relatedTarget, if necessary
    if (!event.relatedTarget && event.fromElement) {
      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
    }

    return event;
  }
}];

function retTrue() {
  return TRUE;
}

function retFalse() {
  return FALSE;
}

function DomEventObject(nativeEvent) {
  var type = nativeEvent.type;

  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';

  _EventBaseObject2['default'].call(this);

  this.nativeEvent = nativeEvent;

  // in case dom event has been mark as default prevented by lower dom node
  var isDefaultPrevented = retFalse;
  if ('defaultPrevented' in nativeEvent) {
    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
  } else if ('getPreventDefault' in nativeEvent) {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
  } else if ('returnValue' in nativeEvent) {
    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
  }

  this.isDefaultPrevented = isDefaultPrevented;

  var fixFns = [];
  var fixFn = undefined;
  var l = undefined;
  var prop = undefined;
  var props = commonProps.concat();

  eventNormalizers.forEach(function (normalizer) {
    if (type.match(normalizer.reg)) {
      props = props.concat(normalizer.props);
      if (normalizer.fix) {
        fixFns.push(normalizer.fix);
      }
    }
  });

  l = props.length;

  // clone properties of the original event object
  while (l) {
    prop = props[--l];
    this[prop] = nativeEvent[prop];
  }

  // fix target property, if necessary
  if (!this.target && isNative) {
    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
  }

  // check if target is a text node (safari)
  if (this.target && this.target.nodeType === 3) {
    this.target = this.target.parentNode;
  }

  l = fixFns.length;

  while (l) {
    fixFn = fixFns[--l];
    fixFn(this, nativeEvent);
  }

  this.timeStamp = nativeEvent.timeStamp || Date.now();
}

var EventBaseObjectProto = _EventBaseObject2['default'].prototype;

(0, _objectAssign2['default'])(DomEventObject.prototype, EventBaseObjectProto, {
  constructor: DomEventObject,

  preventDefault: function preventDefault() {
    var e = this.nativeEvent;

    // if preventDefault exists run it on the original event
    if (e.preventDefault) {
      e.preventDefault();
    } else {
      // otherwise set the returnValue property of the original event to FALSE (IE)
      e.returnValue = FALSE;
    }

    EventBaseObjectProto.preventDefault.call(this);
  },

  stopPropagation: function stopPropagation() {
    var e = this.nativeEvent;

    // if stopPropagation exists run it on the original event
    if (e.stopPropagation) {
      e.stopPropagation();
    } else {
      // otherwise set the cancelBubble property of the original event to TRUE (IE)
      e.cancelBubble = TRUE;
    }

    EventBaseObjectProto.stopPropagation.call(this);
  }
});

exports['default'] = DomEventObject;
module.exports = exports['default'];

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * base event object for custom and dom event.
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, "__esModule", {
  value: true
});
function returnFalse() {
  return false;
}

function returnTrue() {
  return true;
}

function EventBaseObject() {
  this.timeStamp = Date.now();
  this.target = undefined;
  this.currentTarget = undefined;
}

EventBaseObject.prototype = {
  isEventObject: 1,

  constructor: EventBaseObject,

  isDefaultPrevented: returnFalse,

  isPropagationStopped: returnFalse,

  isImmediatePropagationStopped: returnFalse,

  preventDefault: function preventDefault() {
    this.isDefaultPrevented = returnTrue;
  },

  stopPropagation: function stopPropagation() {
    this.isPropagationStopped = returnTrue;
  },

  stopImmediatePropagation: function stopImmediatePropagation() {
    this.isImmediatePropagationStopped = returnTrue;
    // fixed 1.2
    // call stopPropagation implicitly
    this.stopPropagation();
  },

  halt: function halt(immediate) {
    if (immediate) {
      this.stopImmediatePropagation();
    } else {
      this.stopPropagation();
    }
    this.preventDefault();
  }
};

exports["default"] = EventBaseObject;
module.exports = exports["default"];

/***/ }),
/* 1745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);








var ContainerRender = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ContainerRender, _React$Component);

  function ContainerRender() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ContainerRender);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ContainerRender.__proto__ || Object.getPrototypeOf(ContainerRender)).call.apply(_ref, [this].concat(args))), _this), _this.removeContainer = function () {
      if (_this.container) {
        __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unmountComponentAtNode(_this.container);
        _this.container.parentNode.removeChild(_this.container);
        _this.container = null;
      }
    }, _this.renderComponent = function (props, ready) {
      var _this$props = _this.props,
          visible = _this$props.visible,
          getComponent = _this$props.getComponent,
          forceRender = _this$props.forceRender,
          getContainer = _this$props.getContainer,
          parent = _this$props.parent;

      if (visible || parent._component || forceRender) {
        if (!_this.container) {
          _this.container = getContainer();
        }
        __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unstable_renderSubtreeIntoContainer(parent, getComponent(props), _this.container, function callback() {
          if (ready) {
            ready.call(this);
          }
        });
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ContainerRender, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.autoDestroy) {
        this.removeContainer();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children({
        renderComponent: this.renderComponent,
        removeContainer: this.removeContainer
      });
    }
  }]);

  return ContainerRender;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ContainerRender.propTypes = {
  autoMount: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  autoDestroy: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  visible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  forceRender: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  parent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  getComponent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  getContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired
};
ContainerRender.defaultProps = {
  autoMount: true,
  autoDestroy: true,
  forceRender: false
};
/* harmony default export */ __webpack_exports__["a"] = (ContainerRender);

/***/ }),
/* 1746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);








var Portal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Portal, _React$Component);

  function Portal() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Portal);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.createContainer();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var didUpdate = this.props.didUpdate;

      if (didUpdate) {
        didUpdate(prevProps);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeContainer();
    }
  }, {
    key: 'createContainer',
    value: function createContainer() {
      this._container = this.props.getContainer();
      this.forceUpdate();
    }
  }, {
    key: 'removeContainer',
    value: function removeContainer() {
      if (this._container) {
        this._container.parentNode.removeChild(this._container);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (this._container) {
        return __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.createPortal(this.props.children, this._container);
      }
      return null;
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Portal.propTypes = {
  getContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node.isRequired,
  didUpdate: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (Portal);

/***/ }),
/* 1747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_align__ = __webpack_require__(1748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_animate__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PopupInner__ = __webpack_require__(1759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(794);













var Popup = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Popup, _Component);

  function Popup(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Popup);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      // Used for stretch
      stretchChecked: false,
      targetWidth: undefined,
      targetHeight: undefined
    };

    _this.savePopupRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'popupInstance');
    _this.saveAlignRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'alignInstance');
    return _this;
  }

  Popup.prototype.componentDidMount = function componentDidMount() {
    this.rootNode = this.getPopupDomNode();
    this.setStretchSize();
  };

  Popup.prototype.componentDidUpdate = function componentDidUpdate() {
    this.setStretchSize();
  };

  // Record size if stretch needed


  Popup.prototype.getPopupDomNode = function getPopupDomNode() {
    return __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.popupInstance);
  };

  // `target` on `rc-align` can accept as a function to get the bind element or a point.
  // ref: https://www.npmjs.com/package/rc-align


  Popup.prototype.getMaskTransitionName = function getMaskTransitionName() {
    var props = this.props;
    var transitionName = props.maskTransitionName;
    var animation = props.maskAnimation;
    if (!transitionName && animation) {
      transitionName = props.prefixCls + '-' + animation;
    }
    return transitionName;
  };

  Popup.prototype.getTransitionName = function getTransitionName() {
    var props = this.props;
    var transitionName = props.transitionName;
    if (!transitionName && props.animation) {
      transitionName = props.prefixCls + '-' + props.animation;
    }
    return transitionName;
  };

  Popup.prototype.getClassName = function getClassName(currentAlignClassName) {
    return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
  };

  Popup.prototype.getPopupElement = function getPopupElement() {
    var _this2 = this;

    var savePopupRef = this.savePopupRef;
    var _state = this.state,
        stretchChecked = _state.stretchChecked,
        targetHeight = _state.targetHeight,
        targetWidth = _state.targetWidth;
    var _props = this.props,
        align = _props.align,
        visible = _props.visible,
        prefixCls = _props.prefixCls,
        style = _props.style,
        getClassNameFromAlign = _props.getClassNameFromAlign,
        destroyPopupOnHide = _props.destroyPopupOnHide,
        stretch = _props.stretch,
        children = _props.children,
        onMouseEnter = _props.onMouseEnter,
        onMouseLeave = _props.onMouseLeave,
        onMouseDown = _props.onMouseDown,
        onTouchStart = _props.onTouchStart;

    var className = this.getClassName(this.currentAlignClassName || getClassNameFromAlign(align));
    var hiddenClassName = prefixCls + '-hidden';

    if (!visible) {
      this.currentAlignClassName = null;
    }

    var sizeStyle = {};
    if (stretch) {
      // Stretch with target
      if (stretch.indexOf('height') !== -1) {
        sizeStyle.height = targetHeight;
      } else if (stretch.indexOf('minHeight') !== -1) {
        sizeStyle.minHeight = targetHeight;
      }
      if (stretch.indexOf('width') !== -1) {
        sizeStyle.width = targetWidth;
      } else if (stretch.indexOf('minWidth') !== -1) {
        sizeStyle.minWidth = targetWidth;
      }

      // Delay force align to makes ui smooth
      if (!stretchChecked) {
        sizeStyle.visibility = 'hidden';
        setTimeout(function () {
          if (_this2.alignInstance) {
            _this2.alignInstance.forceAlign();
          }
        }, 0);
      }
    }

    var newStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, sizeStyle, style, this.getZIndexStyle());

    var popupInnerProps = {
      className: className,
      prefixCls: prefixCls,
      ref: savePopupRef,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onMouseDown: onMouseDown,
      onTouchStart: onTouchStart,
      style: newStyle
    };
    if (destroyPopupOnHide) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
        {
          component: '',
          exclusive: true,
          transitionAppear: true,
          transitionName: this.getTransitionName()
        },
        visible ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
          {
            target: this.getAlignTarget(),
            key: 'popup',
            ref: this.saveAlignRef,
            monitorWindowResize: true,
            align: align,
            onAlign: this.onAlign
          },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              visible: true
            }, popupInnerProps),
            children
          )
        ) : null
      );
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
      {
        component: '',
        exclusive: true,
        transitionAppear: true,
        transitionName: this.getTransitionName(),
        showProp: 'xVisible'
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
        {
          target: this.getAlignTarget(),
          key: 'popup',
          ref: this.saveAlignRef,
          monitorWindowResize: true,
          xVisible: visible,
          childrenProps: { visible: 'xVisible' },
          disabled: !visible,
          align: align,
          onAlign: this.onAlign
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            hiddenClassName: hiddenClassName
          }, popupInnerProps),
          children
        )
      )
    );
  };

  Popup.prototype.getZIndexStyle = function getZIndexStyle() {
    var style = {};
    var props = this.props;
    if (props.zIndex !== undefined) {
      style.zIndex = props.zIndex;
    }
    return style;
  };

  Popup.prototype.getMaskElement = function getMaskElement() {
    var props = this.props;
    var maskElement = void 0;
    if (props.mask) {
      var maskTransition = this.getMaskTransitionName();
      maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__["a" /* default */], {
        style: this.getZIndexStyle(),
        key: 'mask',
        className: props.prefixCls + '-mask',
        hiddenClassName: props.prefixCls + '-mask-hidden',
        visible: props.visible
      });
      if (maskTransition) {
        maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
          {
            key: 'mask',
            showProp: 'visible',
            transitionAppear: true,
            component: '',
            transitionName: maskTransition
          },
          maskElement
        );
      }
    }
    return maskElement;
  };

  Popup.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'div',
      null,
      this.getMaskElement(),
      this.getPopupElement()
    );
  };

  return Popup;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Popup.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  getClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getRootDomNode: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  point: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    pageX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onAlign = function (popupDomNode, align) {
    var props = _this3.props;
    var currentAlignClassName = props.getClassNameFromAlign(align);
    // FIX: https://github.com/react-component/trigger/issues/56
    // FIX: https://github.com/react-component/tooltip/issues/79
    if (_this3.currentAlignClassName !== currentAlignClassName) {
      _this3.currentAlignClassName = currentAlignClassName;
      popupDomNode.className = _this3.getClassName(currentAlignClassName);
    }
    props.onAlign(popupDomNode, align);
  };

  this.setStretchSize = function () {
    var _props2 = _this3.props,
        stretch = _props2.stretch,
        getRootDomNode = _props2.getRootDomNode,
        visible = _props2.visible;
    var _state2 = _this3.state,
        stretchChecked = _state2.stretchChecked,
        targetHeight = _state2.targetHeight,
        targetWidth = _state2.targetWidth;


    if (!stretch || !visible) {
      if (stretchChecked) {
        _this3.setState({ stretchChecked: false });
      }
      return;
    }

    var $ele = getRootDomNode();
    if (!$ele) return;

    var height = $ele.offsetHeight;
    var width = $ele.offsetWidth;

    if (targetHeight !== height || targetWidth !== width || !stretchChecked) {
      _this3.setState({
        stretchChecked: true,
        targetHeight: height,
        targetWidth: width
      });
    }
  };

  this.getTargetElement = function () {
    return _this3.props.getRootDomNode();
  };

  this.getAlignTarget = function () {
    var point = _this3.props.point;

    if (point) {
      return point;
    }
    return _this3.getTargetElement;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Popup);

/***/ }),
/* 1748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Align__ = __webpack_require__(1749);
// export this package's api


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Align__["a" /* default */]);

/***/ }),
/* 1749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_align__ = __webpack_require__(1750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(1758);












function getElement(func) {
  if (typeof func !== 'function' || !func) return null;
  return func();
}

function getPoint(point) {
  if (typeof point !== 'object' || !point) return null;
  return point;
}

var Align = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Align, _Component);

  function Align() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Align);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Align.__proto__ || Object.getPrototypeOf(Align)).call.apply(_ref, [this].concat(args))), _this), _this.forceAlign = function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          target = _this$props.target,
          align = _this$props.align,
          onAlign = _this$props.onAlign;

      if (!disabled && target) {
        var source = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(_this);

        var result = void 0;
        var element = getElement(target);
        var point = getPoint(target);

        // IE lose focus after element realign
        // We should record activeElement and restore later
        var activeElement = document.activeElement;

        if (element) {
          result = Object(__WEBPACK_IMPORTED_MODULE_7_dom_align__["a" /* alignElement */])(source, element, align);
        } else if (point) {
          result = Object(__WEBPACK_IMPORTED_MODULE_7_dom_align__["b" /* alignPoint */])(source, point, align);
        }

        Object(__WEBPACK_IMPORTED_MODULE_9__util__["e" /* restoreFocus */])(activeElement, source);

        if (onAlign) {
          onAlign(source, result);
        }
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Align, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var props = this.props;
      // if parent ref not attached .... use document.getElementById
      this.forceAlign();
      if (!props.disabled && props.monitorWindowResize) {
        this.startMonitorWindowResize();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var reAlign = false;
      var props = this.props;

      if (!props.disabled) {
        var source = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this);
        var sourceRect = source ? source.getBoundingClientRect() : null;

        if (prevProps.disabled) {
          reAlign = true;
        } else {
          var lastElement = getElement(prevProps.target);
          var currentElement = getElement(props.target);
          var lastPoint = getPoint(prevProps.target);
          var currentPoint = getPoint(props.target);

          if (Object(__WEBPACK_IMPORTED_MODULE_9__util__["d" /* isWindow */])(lastElement) && Object(__WEBPACK_IMPORTED_MODULE_9__util__["d" /* isWindow */])(currentElement)) {
            // Skip if is window
            reAlign = false;
          } else if (lastElement !== currentElement || // Element change
          lastElement && !currentElement && currentPoint || // Change from element to point
          lastPoint && currentPoint && currentElement || // Change from point to element
          currentPoint && !Object(__WEBPACK_IMPORTED_MODULE_9__util__["b" /* isSamePoint */])(lastPoint, currentPoint)) {
            reAlign = true;
          }

          // If source element size changed
          var preRect = this.sourceRect || {};
          if (!reAlign && source && (!Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* isSimilarValue */])(preRect.width, sourceRect.width) || !Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* isSimilarValue */])(preRect.height, sourceRect.height))) {
            reAlign = true;
          }
        }

        this.sourceRect = sourceRect;
      }

      if (reAlign) {
        this.forceAlign();
      }

      if (props.monitorWindowResize && !props.disabled) {
        this.startMonitorWindowResize();
      } else {
        this.stopMonitorWindowResize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopMonitorWindowResize();
    }
  }, {
    key: 'startMonitorWindowResize',
    value: function startMonitorWindowResize() {
      if (!this.resizeHandler) {
        this.bufferMonitor = Object(__WEBPACK_IMPORTED_MODULE_9__util__["a" /* buffer */])(this.forceAlign, this.props.monitorBufferTime);
        this.resizeHandler = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'resize', this.bufferMonitor);
      }
    }
  }, {
    key: 'stopMonitorWindowResize',
    value: function stopMonitorWindowResize() {
      if (this.resizeHandler) {
        this.bufferMonitor.clear();
        this.resizeHandler.remove();
        this.resizeHandler = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          childrenProps = _props.childrenProps,
          children = _props.children;

      var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
      if (childrenProps) {
        var newProps = {};
        var propList = Object.keys(childrenProps);
        propList.forEach(function (prop) {
          newProps[prop] = _this2.props[childrenProps[prop]];
        });

        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newProps);
      }
      return child;
    }
  }]);

  return Align;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Align.propTypes = {
  childrenProps: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
  target: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    clientX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    clientY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })]),
  onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  monitorBufferTime: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  monitorWindowResize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any
};
Align.defaultProps = {
  target: function target() {
    return window;
  },
  monitorBufferTime: 50,
  monitorWindowResize: false,
  disabled: false
};


/* harmony default export */ __webpack_exports__["a"] = (Align);

/***/ }),
/* 1750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__align_alignElement__ = __webpack_require__(1751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__align_alignPoint__ = __webpack_require__(1757);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__align_alignElement__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__align_alignPoint__["a"]; });





/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__align_alignElement__["a" /* default */]);

/***/ }),
/* 1751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__align__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getOffsetParent__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getVisibleRectForElement__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getRegion__ = __webpack_require__(798);





function isOutOfVisibleRect(target) {
  var visibleRect = Object(__WEBPACK_IMPORTED_MODULE_2__getVisibleRectForElement__["a" /* default */])(target);
  var targetRegion = Object(__WEBPACK_IMPORTED_MODULE_3__getRegion__["a" /* default */])(target);

  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}

function alignElement(el, refNode, align) {
  var target = align.target || refNode;
  var refNodeRegion = Object(__WEBPACK_IMPORTED_MODULE_3__getRegion__["a" /* default */])(target);

  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target);

  return Object(__WEBPACK_IMPORTED_MODULE_0__align__["a" /* default */])(el, refNodeRegion, align, isTargetNotOutOfVisible);
}

alignElement.__getOffsetParent = __WEBPACK_IMPORTED_MODULE_1__getOffsetParent__["a" /* default */];

alignElement.__getVisibleRectForElement = __WEBPACK_IMPORTED_MODULE_2__getVisibleRectForElement__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (alignElement);

/***/ }),
/* 1752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTransformName;
/* harmony export (immutable) */ __webpack_exports__["e"] = setTransitionProperty;
/* harmony export (immutable) */ __webpack_exports__["c"] = getTransitionProperty;
/* harmony export (immutable) */ __webpack_exports__["b"] = getTransformXY;
/* harmony export (immutable) */ __webpack_exports__["d"] = setTransformXY;
var vendorPrefix = void 0;

var jsCssMap = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  // IE did it wrong again ...
  ms: '-ms-',
  O: '-o-'
};

function getVendorPrefix() {
  if (vendorPrefix !== undefined) {
    return vendorPrefix;
  }
  vendorPrefix = '';
  var style = document.createElement('p').style;
  var testProp = 'Transform';
  for (var key in jsCssMap) {
    if (key + testProp in style) {
      vendorPrefix = key;
    }
  }
  return vendorPrefix;
}

function getTransitionName() {
  return getVendorPrefix() ? getVendorPrefix() + 'TransitionProperty' : 'transitionProperty';
}

function getTransformName() {
  return getVendorPrefix() ? getVendorPrefix() + 'Transform' : 'transform';
}

function setTransitionProperty(node, value) {
  var name = getTransitionName();
  if (name) {
    node.style[name] = value;
    if (name !== 'transitionProperty') {
      node.style.transitionProperty = value;
    }
  }
}

function setTransform(node, value) {
  var name = getTransformName();
  if (name) {
    node.style[name] = value;
    if (name !== 'transform') {
      node.style.transform = value;
    }
  }
}

function getTransitionProperty(node) {
  return node.style.transitionProperty || node.style[getTransitionName()];
}

function getTransformXY(node) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
  if (transform && transform !== 'none') {
    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
    return { x: parseFloat(matrix[12] || matrix[4], 0), y: parseFloat(matrix[13] || matrix[5], 0) };
  }
  return {
    x: 0,
    y: 0
  };
}

var matrix2d = /matrix\((.*)\)/;
var matrix3d = /matrix3d\((.*)\)/;

function setTransformXY(node, xy) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
  if (transform && transform !== 'none') {
    var arr = void 0;
    var match2d = transform.match(matrix2d);
    if (match2d) {
      match2d = match2d[1];
      arr = match2d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[4] = xy.x;
      arr[5] = xy.y;
      setTransform(node, 'matrix(' + arr.join(',') + ')');
    } else {
      var match3d = transform.match(matrix3d)[1];
      arr = match3d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[12] = xy.x;
      arr[13] = xy.y;
      setTransform(node, 'matrix3d(' + arr.join(',') + ')');
    }
  } else {
    setTransform(node, 'translateX(' + xy.x + 'px) translateY(' + xy.y + 'px) translateZ(0)');
  }
}

/***/ }),
/* 1753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isAncestorFixed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(155);


function isAncestorFixed(element) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].isWindow(element) || element.nodeType === 9) {
    return false;
  }

  var doc = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getDocument(element);
  var body = doc.body;
  var parent = null;
  for (parent = element.parentNode; parent && parent !== body; parent = parent.parentNode) {
    var positionStyle = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(parent, 'position');
    if (positionStyle === 'fixed') {
      return true;
    }
  }
  return false;
}

/***/ }),
/* 1754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(155);


function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
  var pos = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].clone(elFuturePos);
  var size = {
    width: elRegion.width,
    height: elRegion.height
  };

  if (overflow.adjustX && pos.left < visibleRect.left) {
    pos.left = visibleRect.left;
  }

  // Left edge inside and right edge outside viewport, try to resize it.
  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
    size.width -= pos.left + size.width - visibleRect.right;
  }

  // Right edge outside viewport, try to move it.
  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
    // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
  }

  // Top edge outside viewport, try to move it.
  if (overflow.adjustY && pos.top < visibleRect.top) {
    pos.top = visibleRect.top;
  }

  // Top edge inside and bottom edge outside viewport, try to resize it.
  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
    size.height -= pos.top + size.height - visibleRect.bottom;
  }

  // Bottom edge outside viewport, try to move it.
  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
    // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
  }

  return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].mix(pos, size);
}

/* harmony default export */ __webpack_exports__["a"] = (adjustForViewport);

/***/ }),
/* 1755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getAlignOffset__ = __webpack_require__(1756);


function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
  var p1 = Object(__WEBPACK_IMPORTED_MODULE_0__getAlignOffset__["a" /* default */])(refNodeRegion, points[1]);
  var p2 = Object(__WEBPACK_IMPORTED_MODULE_0__getAlignOffset__["a" /* default */])(elRegion, points[0]);
  var diff = [p2.left - p1.left, p2.top - p1.top];

  return {
    left: elRegion.left - diff[0] + offset[0] - targetOffset[0],
    top: elRegion.top - diff[1] + offset[1] - targetOffset[1]
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getElFuturePos);

/***/ }),
/* 1756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */

function getAlignOffset(region, align) {
  var V = align.charAt(0);
  var H = align.charAt(1);
  var w = region.width;
  var h = region.height;

  var x = region.left;
  var y = region.top;

  if (V === 'c') {
    y += h / 2;
  } else if (V === 'b') {
    y += h;
  }

  if (H === 'c') {
    x += w / 2;
  } else if (H === 'r') {
    x += w;
  }

  return {
    left: x,
    top: y
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getAlignOffset);

/***/ }),
/* 1757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__align__ = __webpack_require__(795);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */

function alignPoint(el, tgtPoint, align) {
  var pageX = void 0;
  var pageY = void 0;

  var doc = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getDocument(el);
  var win = doc.defaultView || doc.parentWindow;

  var scrollX = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollLeft(win);
  var scrollY = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollTop(win);
  var viewportWidth = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportWidth(win);
  var viewportHeight = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportHeight(win);

  if ('pageX' in tgtPoint) {
    pageX = tgtPoint.pageX;
  } else {
    pageX = scrollX + tgtPoint.clientX;
  }

  if ('pageY' in tgtPoint) {
    pageY = tgtPoint.pageY;
  } else {
    pageY = scrollY + tgtPoint.clientY;
  }

  var tgtRegion = {
    left: pageX,
    top: pageY,
    width: 0,
    height: 0
  };

  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;

  // Provide default target point
  var points = [align.points[0], 'cc'];

  return Object(__WEBPACK_IMPORTED_MODULE_1__align__["a" /* default */])(el, tgtRegion, _extends({}, align, { points: points }), pointInView);
}

/* harmony default export */ __webpack_exports__["a"] = (alignPoint);

/***/ }),
/* 1758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buffer;
/* harmony export (immutable) */ __webpack_exports__["b"] = isSamePoint;
/* harmony export (immutable) */ __webpack_exports__["d"] = isWindow;
/* harmony export (immutable) */ __webpack_exports__["c"] = isSimilarValue;
/* harmony export (immutable) */ __webpack_exports__["e"] = restoreFocus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rc_util_es_Dom_contains__ = __webpack_require__(793);


function buffer(fn, ms) {
  var timer = void 0;

  function clear() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function bufferFn() {
    clear();
    timer = setTimeout(fn, ms);
  }

  bufferFn.clear = clear;

  return bufferFn;
}

function isSamePoint(prev, next) {
  if (prev === next) return true;
  if (!prev || !next) return false;

  if ('pageX' in next && 'pageY' in next) {
    return prev.pageX === next.pageX && prev.pageY === next.pageY;
  }

  if ('clientX' in next && 'clientY' in next) {
    return prev.clientX === next.clientX && prev.clientY === next.clientY;
  }

  return false;
}

function isWindow(obj) {
  return obj && typeof obj === 'object' && obj.window === obj;
}

function isSimilarValue(val1, val2) {
  var int1 = Math.floor(val1);
  var int2 = Math.floor(val2);
  return Math.abs(int1 - int2) <= 1;
}

function restoreFocus(activeElement, container) {
  // Focus back if is in the container
  if (activeElement !== document.activeElement && Object(__WEBPACK_IMPORTED_MODULE_0_rc_util_es_Dom_contains__["a" /* default */])(container, activeElement)) {
    activeElement.focus();
  }
}

/***/ }),
/* 1759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__ = __webpack_require__(799);







var PopupInner = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(PopupInner, _Component);

  function PopupInner() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PopupInner);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  PopupInner.prototype.render = function render() {
    var props = this.props;
    var className = props.className;
    if (!props.visible) {
      className += ' ' + props.hiddenClassName;
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      {
        className: className,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onMouseDown: props.onMouseDown,
        onTouchStart: props.onTouchStart,
        style: props.style
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__["a" /* default */],
        { className: props.prefixCls + '-content', visible: props.visible },
        props.children
      )
    );
  };

  return PopupInner;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

PopupInner.propTypes = {
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};


/* harmony default export */ __webpack_exports__["a"] = (PopupInner);

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LocaleUtils = __webpack_require__(296);

var _LocaleUtils2 = _interopRequireDefault(_LocaleUtils);

var _keys = __webpack_require__(226);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Caption = function (_Component) {
  _inherits(Caption, _Component);

  function Caption(props) {
    _classCallCheck(this, Caption);

    var _this = _possibleConstructorReturn(this, (Caption.__proto__ || Object.getPrototypeOf(Caption)).call(this, props));

    _this.handleKeyUp = _this.handleKeyUp.bind(_this);
    return _this;
  }

  _createClass(Caption, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.locale !== this.props.locale || nextProps.classNames !== this.props.classNames || nextProps.date.getMonth() !== this.props.date.getMonth() || nextProps.date.getFullYear() !== this.props.date.getFullYear();
    }
  }, {
    key: 'handleKeyUp',
    value: function handleKeyUp(e) {
      if (e.keyCode === _keys.ENTER) {
        this.props.onClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          date = _props.date,
          months = _props.months,
          locale = _props.locale,
          localeUtils = _props.localeUtils,
          onClick = _props.onClick;

      return _react2.default.createElement(
        'div',
        { className: classNames.caption, role: 'heading' },
        _react2.default.createElement(
          'div',
          { onClick: onClick, onKeyUp: this.handleKeyUp },
          months ? months[date.getMonth()] + ' ' + date.getFullYear() : localeUtils.formatMonthTitle(date, locale)
        )
      );
    }
  }]);

  return Caption;
}(_react.Component);

Caption.propTypes = {
  date: _propTypes2.default.instanceOf(Date),
  months: _propTypes2.default.arrayOf(_propTypes2.default.string),
  locale: _propTypes2.default.string,
  localeUtils: _propTypes2.default.object,
  onClick: _propTypes2.default.func,
  classNames: _propTypes2.default.shape({
    caption: _propTypes2.default.string.isRequired
  }).isRequired
};
Caption.defaultProps = {
  localeUtils: _LocaleUtils2.default
};
exports.default = Caption;
//# sourceMappingURL=Caption.js.map

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Weekdays = __webpack_require__(1762);

var _Weekdays2 = _interopRequireDefault(_Weekdays);

var _Day = __webpack_require__(1763);

var _Day2 = _interopRequireDefault(_Day);

var _keys = __webpack_require__(226);

var _ModifiersUtils = __webpack_require__(299);

var ModifiersUtils = _interopRequireWildcard(_ModifiersUtils);

var _Helpers = __webpack_require__(298);

var Helpers = _interopRequireWildcard(_Helpers);

var _DateUtils = __webpack_require__(156);

var DateUtils = _interopRequireWildcard(_DateUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Month = function (_Component) {
  _inherits(Month, _Component);

  function Month() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Month);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Month.__proto__ || Object.getPrototypeOf(Month)).call.apply(_ref, [this].concat(args))), _this), _this.renderDay = function (day) {
      var monthNumber = _this.props.month.getMonth();
      var propModifiers = Helpers.getModifiersFromProps(_this.props);
      var dayModifiers = ModifiersUtils.getModifiersForDay(day, propModifiers);
      if (DateUtils.isSameDay(day, new Date()) && !Object.prototype.hasOwnProperty.call(propModifiers, _this.props.classNames.today)) {
        dayModifiers.push(_this.props.classNames.today);
      }
      if (day.getMonth() !== monthNumber) {
        dayModifiers.push(_this.props.classNames.outside);
      }

      var isOutside = day.getMonth() !== monthNumber;
      var tabIndex = -1;
      // Focus on the first day of the month
      if (_this.props.onDayClick && !isOutside && day.getDate() === 1) {
        tabIndex = _this.props.tabIndex; // eslint-disable-line prefer-destructuring
      }
      var key = '' + day.getFullYear() + day.getMonth() + day.getDate();
      var modifiers = {};
      dayModifiers.forEach(function (modifier) {
        modifiers[modifier] = true;
      });

      return _react2.default.createElement(
        _Day2.default,
        {
          key: '' + (isOutside ? 'outside-' : '') + key,
          classNames: _this.props.classNames,
          day: day,
          modifiers: modifiers,
          modifiersStyles: _this.props.modifiersStyles,
          empty: isOutside && !_this.props.showOutsideDays && !_this.props.fixedWeeks,
          tabIndex: tabIndex,
          ariaLabel: _this.props.localeUtils.formatDay(day, _this.props.locale),
          ariaDisabled: isOutside || dayModifiers.indexOf('disabled') > -1,
          ariaSelected: dayModifiers.indexOf('selected') > -1,
          onClick: _this.props.onDayClick,
          onFocus: _this.props.onDayFocus,
          onKeyDown: _this.props.onDayKeyDown,
          onMouseEnter: _this.props.onDayMouseEnter,
          onMouseLeave: _this.props.onDayMouseLeave,
          onMouseDown: _this.props.onDayMouseDown,
          onMouseUp: _this.props.onDayMouseUp,
          onTouchEnd: _this.props.onDayTouchEnd,
          onTouchStart: _this.props.onDayTouchStart
        },
        _this.props.renderDay(day, modifiers)
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Month, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          classNames = _props.classNames,
          month = _props.month,
          months = _props.months,
          fixedWeeks = _props.fixedWeeks,
          captionElement = _props.captionElement,
          weekdayElement = _props.weekdayElement,
          locale = _props.locale,
          localeUtils = _props.localeUtils,
          weekdaysLong = _props.weekdaysLong,
          weekdaysShort = _props.weekdaysShort,
          firstDayOfWeek = _props.firstDayOfWeek,
          onCaptionClick = _props.onCaptionClick,
          showWeekNumbers = _props.showWeekNumbers,
          showWeekDays = _props.showWeekDays,
          onWeekClick = _props.onWeekClick;


      var captionProps = {
        date: month,
        classNames: classNames,
        months: months,
        localeUtils: localeUtils,
        locale: locale,
        onClick: onCaptionClick ? function (e) {
          return onCaptionClick(month, e);
        } : undefined
      };
      var caption = _react2.default.isValidElement(captionElement) ? _react2.default.cloneElement(captionElement, captionProps) : _react2.default.createElement(captionElement, captionProps);

      var weeks = Helpers.getWeekArray(month, firstDayOfWeek, fixedWeeks);
      return _react2.default.createElement(
        'div',
        { className: classNames.month, role: 'grid' },
        caption,
        showWeekDays && _react2.default.createElement(_Weekdays2.default, {
          classNames: classNames,
          weekdaysShort: weekdaysShort,
          weekdaysLong: weekdaysLong,
          firstDayOfWeek: firstDayOfWeek,
          showWeekNumbers: showWeekNumbers,
          locale: locale,
          localeUtils: localeUtils,
          weekdayElement: weekdayElement
        }),
        _react2.default.createElement(
          'div',
          { className: classNames.body, role: 'rowgroup' },
          weeks.map(function (week) {
            var weekNumber = void 0;
            if (showWeekNumbers) {
              weekNumber = DateUtils.getWeekNumber(week[6]);
            }
            return _react2.default.createElement(
              'div',
              {
                key: week[0].getTime(),
                className: classNames.week,
                role: 'row'
              },
              showWeekNumbers && _react2.default.createElement(
                'div',
                {
                  className: classNames.weekNumber,
                  tabIndex: onWeekClick ? 0 : -1,
                  role: 'gridcell',
                  onClick: onWeekClick ? function (e) {
                    return onWeekClick(weekNumber, week, e);
                  } : undefined,
                  onKeyUp: onWeekClick ? function (e) {
                    return e.keyCode === _keys.ENTER && onWeekClick(weekNumber, week, e);
                  } : undefined
                },
                _this2.props.renderWeek(weekNumber, week, month)
              ),
              week.map(_this2.renderDay)
            );
          })
        )
      );
    }
  }]);

  return Month;
}(_react.Component);

Month.propTypes = {
  classNames: _propTypes2.default.shape({
    body: _propTypes2.default.string.isRequired,
    month: _propTypes2.default.string.isRequired,
    outside: _propTypes2.default.string.isRequired,
    today: _propTypes2.default.string.isRequired,
    week: _propTypes2.default.string.isRequired,
    weekNumber: _propTypes2.default.string.isRequired
  }).isRequired,
  tabIndex: _propTypes2.default.number,

  month: _propTypes2.default.instanceOf(Date).isRequired,
  months: _propTypes2.default.arrayOf(_propTypes2.default.string),

  modifiersStyles: _propTypes2.default.object,

  showWeekDays: _propTypes2.default.bool,
  showOutsideDays: _propTypes2.default.bool,

  renderDay: _propTypes2.default.func.isRequired,
  renderWeek: _propTypes2.default.func.isRequired,

  captionElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)]).isRequired,
  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)]),

  fixedWeeks: _propTypes2.default.bool,
  showWeekNumbers: _propTypes2.default.bool,

  locale: _propTypes2.default.string.isRequired,
  localeUtils: _propTypes2.default.object.isRequired,
  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),
  firstDayOfWeek: _propTypes2.default.number.isRequired,

  onCaptionClick: _propTypes2.default.func,
  onDayClick: _propTypes2.default.func,
  onDayFocus: _propTypes2.default.func,
  onDayKeyDown: _propTypes2.default.func,
  onDayMouseEnter: _propTypes2.default.func,
  onDayMouseLeave: _propTypes2.default.func,
  onDayMouseDown: _propTypes2.default.func,
  onDayMouseUp: _propTypes2.default.func,
  onDayTouchEnd: _propTypes2.default.func,
  onDayTouchStart: _propTypes2.default.func,
  onWeekClick: _propTypes2.default.func
};
exports.default = Month;
//# sourceMappingURL=Month.js.map

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Weekdays = function (_Component) {
  _inherits(Weekdays, _Component);

  function Weekdays() {
    _classCallCheck(this, Weekdays);

    return _possibleConstructorReturn(this, (Weekdays.__proto__ || Object.getPrototypeOf(Weekdays)).apply(this, arguments));
  }

  _createClass(Weekdays, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props !== nextProps;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          firstDayOfWeek = _props.firstDayOfWeek,
          showWeekNumbers = _props.showWeekNumbers,
          weekdaysLong = _props.weekdaysLong,
          weekdaysShort = _props.weekdaysShort,
          locale = _props.locale,
          localeUtils = _props.localeUtils,
          weekdayElement = _props.weekdayElement;

      var days = [];
      for (var i = 0; i < 7; i += 1) {
        var weekday = (i + firstDayOfWeek) % 7;
        var elementProps = {
          key: i,
          className: classNames.weekday,
          weekday: weekday,
          weekdaysLong: weekdaysLong,
          weekdaysShort: weekdaysShort,
          localeUtils: localeUtils,
          locale: locale
        };
        var element = _react2.default.isValidElement(weekdayElement) ? _react2.default.cloneElement(weekdayElement, elementProps) : _react2.default.createElement(weekdayElement, elementProps);
        days.push(element);
      }

      return _react2.default.createElement(
        'div',
        { className: classNames.weekdays, role: 'rowgroup' },
        _react2.default.createElement(
          'div',
          { className: classNames.weekdaysRow, role: 'row' },
          showWeekNumbers && _react2.default.createElement('div', { className: classNames.weekday }),
          days
        )
      );
    }
  }]);

  return Weekdays;
}(_react.Component);

Weekdays.propTypes = {
  classNames: _propTypes2.default.shape({
    weekday: _propTypes2.default.string.isRequired,
    weekdays: _propTypes2.default.string.isRequired,
    weekdaysRow: _propTypes2.default.string.isRequired
  }).isRequired,

  firstDayOfWeek: _propTypes2.default.number.isRequired,
  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),
  showWeekNumbers: _propTypes2.default.bool,
  locale: _propTypes2.default.string.isRequired,
  localeUtils: _propTypes2.default.object.isRequired,
  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)])
};
exports.default = Weekdays;
//# sourceMappingURL=Weekdays.js.map

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DateUtils = __webpack_require__(156);

var _Helpers = __webpack_require__(298);

var _classNames = __webpack_require__(297);

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable jsx-a11y/no-static-element-interactions, react/forbid-prop-types */

function handleEvent(handler, day, modifiers) {
  if (!handler) {
    return undefined;
  }
  return function (e) {
    e.persist();
    handler(day, modifiers, e);
  };
}

var Day = function (_Component) {
  _inherits(Day, _Component);

  function Day() {
    _classCallCheck(this, Day);

    return _possibleConstructorReturn(this, (Day.__proto__ || Object.getPrototypeOf(Day)).apply(this, arguments));
  }

  _createClass(Day, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var _this2 = this;

      var propNames = Object.keys(this.props);
      var nextPropNames = Object.keys(nextProps);
      if (propNames.length !== nextPropNames.length) {
        return true;
      }
      return propNames.some(function (name) {
        if (name === 'modifiers' || name === 'modifiersStyles' || name === 'classNames') {
          var prop = _this2.props[name];
          var nextProp = nextProps[name];
          var modifiers = Object.keys(prop);
          var nextModifiers = Object.keys(nextProp);
          if (modifiers.length !== nextModifiers.length) {
            return true;
          }
          return modifiers.some(function (mod) {
            return !(0, _Helpers.hasOwnProp)(nextProp, mod) || prop[mod] !== nextProp[mod];
          });
        }
        if (name === 'day') {
          return !(0, _DateUtils.isSameDay)(_this2.props[name], nextProps[name]);
        }
        return !(0, _Helpers.hasOwnProp)(nextProps, name) || _this2.props[name] !== nextProps[name];
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          modifiersStyles = _props.modifiersStyles,
          day = _props.day,
          tabIndex = _props.tabIndex,
          empty = _props.empty,
          modifiers = _props.modifiers,
          onMouseEnter = _props.onMouseEnter,
          onMouseLeave = _props.onMouseLeave,
          onMouseUp = _props.onMouseUp,
          onMouseDown = _props.onMouseDown,
          onClick = _props.onClick,
          onKeyDown = _props.onKeyDown,
          onTouchStart = _props.onTouchStart,
          onTouchEnd = _props.onTouchEnd,
          onFocus = _props.onFocus,
          ariaLabel = _props.ariaLabel,
          ariaDisabled = _props.ariaDisabled,
          ariaSelected = _props.ariaSelected,
          children = _props.children;


      var className = classNames.day;
      if (classNames !== _classNames2.default) {
        // When using CSS modules prefix the modifier as required by the BEM syntax
        className += ' ' + Object.keys(modifiers).join(' ');
      } else {
        className += Object.keys(modifiers).map(function (modifier) {
          return ' ' + className + '--' + modifier;
        }).join('');
      }

      var style = void 0;
      if (modifiersStyles) {
        Object.keys(modifiers).filter(function (modifier) {
          return !!modifiersStyles[modifier];
        }).forEach(function (modifier) {
          style = _extends({}, style, modifiersStyles[modifier]);
        });
      }

      if (empty) {
        return _react2.default.createElement('div', { 'aria-disabled': true, className: className, style: style });
      }
      return _react2.default.createElement(
        'div',
        {
          className: className,
          tabIndex: tabIndex,
          style: style,
          role: 'gridcell',
          'aria-label': ariaLabel,
          'aria-disabled': ariaDisabled,
          'aria-selected': ariaSelected,
          onClick: handleEvent(onClick, day, modifiers),
          onKeyDown: handleEvent(onKeyDown, day, modifiers),
          onMouseEnter: handleEvent(onMouseEnter, day, modifiers),
          onMouseLeave: handleEvent(onMouseLeave, day, modifiers),
          onMouseUp: handleEvent(onMouseUp, day, modifiers),
          onMouseDown: handleEvent(onMouseDown, day, modifiers),
          onTouchEnd: handleEvent(onTouchEnd, day, modifiers),
          onTouchStart: handleEvent(onTouchStart, day, modifiers),
          onFocus: handleEvent(onFocus, day, modifiers)
        },
        children
      );
    }
  }]);

  return Day;
}(_react.Component);

Day.propTypes = {
  classNames: _propTypes2.default.shape({
    day: _propTypes2.default.string.isRequired
  }).isRequired,

  day: _propTypes2.default.instanceOf(Date).isRequired,
  children: _propTypes2.default.node.isRequired,

  ariaDisabled: _propTypes2.default.bool,
  ariaLabel: _propTypes2.default.string,
  ariaSelected: _propTypes2.default.bool,
  empty: _propTypes2.default.bool,
  modifiers: _propTypes2.default.object,
  modifiersStyles: _propTypes2.default.object,
  onClick: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onMouseEnter: _propTypes2.default.func,
  onMouseLeave: _propTypes2.default.func,
  onMouseDown: _propTypes2.default.func,
  onMouseUp: _propTypes2.default.func,
  onTouchEnd: _propTypes2.default.func,
  onTouchStart: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  tabIndex: _propTypes2.default.number
};
Day.defaultProps = {
  tabIndex: -1
};
Day.defaultProps = {
  modifiers: {},
  modifiersStyles: {},
  empty: false
};
exports.default = Day;
//# sourceMappingURL=Day.js.map

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModifierPropType = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrimitiveTypes = {
  localeUtils: _propTypes2.default.shape({
    formatMonthTitle: _propTypes2.default.func,
    formatWeekdayShort: _propTypes2.default.func,
    formatWeekdayLong: _propTypes2.default.func,
    getFirstDayOfWeek: _propTypes2.default.func
  }),
  range: _propTypes2.default.shape({
    from: _propTypes2.default.instanceOf(Date),
    to: _propTypes2.default.instanceOf(Date)
  }),
  after: _propTypes2.default.shape({
    after: _propTypes2.default.instanceOf(Date)
  }),
  before: _propTypes2.default.shape({
    before: _propTypes2.default.instanceOf(Date)
  })
};

var ModifierPropType = exports.ModifierPropType = _propTypes2.default.oneOfType([PrimitiveTypes.after, PrimitiveTypes.before, PrimitiveTypes.range, _propTypes2.default.func, _propTypes2.default.array]);

exports.default = PrimitiveTypes;
//# sourceMappingURL=PropTypes.js.map

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(64)(false);
// imports


// module
exports.push([module.i, ".DayPicker{display:inline-block;font-size:1rem}.DayPicker-wrapper{position:relative;flex-direction:row;padding-bottom:1em;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.DayPicker-Months{display:flex;flex-wrap:wrap;justify-content:center}.DayPicker-Month{display:table;margin:0 1em;margin-top:1em;border-spacing:0;border-collapse:collapse;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.DayPicker-NavButton{position:absolute;top:1em;right:1.5em;left:auto;display:inline-block;margin-top:2px;width:1.25em;height:1.25em;background-position:50%;background-size:50%;background-repeat:no-repeat;color:#8b9898;cursor:pointer}.DayPicker-NavButton:hover{opacity:.8}.DayPicker-NavButton--prev{margin-right:1.5em;background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAVVJREFUWAnN2G0KgjAYwPHpGfRkaZeqvgQaK+hY3SUHrk1YzNLay/OiEFp92I+/Mp2F2Mh2lLISWnflFjzH263RQjzMZ19wgs73ez0o1WmtW+dgA01VxrE3p6l2GLsnBy1VYQOtVSEH/atCCgqpQgKKqYIOiq2CBkqtggLKqQIKgqgCBjpJ2Y5CdJ+zrT9A7HHSTA1dxUdHgzCqJIEwq0SDsKsEg6iqBIEoq/wEcVRZBXFV+QJxV5mBtlDFB5VjYTaGZ2sf4R9PM7U9ZU+lLuaetPP/5Die3ToO1+u+MKtHs06qODB2zBnI/jBd4MPQm1VkY79Tb18gB+C62FdBFsZR6yeIo1YQiLJWMIiqVjQIu1YSCLNWFgijVjYIuhYYCKoWKAiiFgoopxYaKLUWOii2FgkophYp6F3r42W5A9s9OcgNvva8xQaysKXlFytoqdYmQH6tF3toSUo0INq9AAAAAElFTkSuQmCC\")}.DayPicker-NavButton--next{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAXRJREFUWAnN119ugjAcwPHWzJ1gnmxzB/BBE0n24m4xfNkTaOL7wOtsl3AXMMb+Vjaa1BG00N8fSEibPpAP3xAKKs2yjzTPH9RAjhEo9WzPr/Vm8zgE0+gXATAxxuxtqeJ9t5tIwv5AtQAApsfT6TPdbp+kUBcgVwvO51KqVhMkXKsVJFXrOkigVhCIs1Y4iKlWZxB1rX4gwlpRIIpa8SDkWmggrFq4IIRaJKCYWnSgnrXIQV1r8YD+1Vrn+bReagysIFfLABRt31v8oBu1xEBttfRbltmfjgEcWh9snUS2kNdBK6WN1vrOWxObWsz+fjxevsxmB1GQDfINWiev83nhaoiB/CoOU438oPrhXS0WpQ9xc1ZQWxWHqUYe0I0qrKCQKjygDlXIQV2r0IF6ViEBxVTBBSFUQQNhVYkHIVeJAtkNsbQ7c1LtzP6FsObhb2rCKv7NBIGoq4SDmKoEgTirXAcJVGkFSVVpgoSrXICGUMUH/QBZNSUy5XWUhwAAAABJRU5ErkJggg==\")}.DayPicker-NavButton--interactionDisabled{display:none}.DayPicker-Caption{display:table-caption;margin-bottom:.5em;padding:0 .5em;text-align:left}.DayPicker-Caption>div{font-weight:500;font-size:1.15em}.DayPicker-Weekdays{display:table-header-group;margin-top:1em}.DayPicker-WeekdaysRow{display:table-row}.DayPicker-Weekday{display:table-cell;padding:.5em;color:#8b9898;text-align:center;font-size:.875em}.DayPicker-Weekday abbr[title]{border-bottom:none;text-decoration:none}.DayPicker-Body{display:table-row-group}.DayPicker-Week{display:table-row}.DayPicker-Day{border-radius:50%;text-align:center}.DayPicker-Day,.DayPicker-WeekNumber{display:table-cell;padding:.5em;vertical-align:middle;cursor:pointer}.DayPicker-WeekNumber{min-width:1em;border-right:1px solid #eaecec;color:#8b9898;text-align:right;font-size:.75em}.DayPicker--interactionDisabled .DayPicker-Day{cursor:default}.DayPicker-Footer{padding-top:.5em}.DayPicker-TodayButton{border:none;background-color:transparent;background-image:none;box-shadow:none;color:#4a90e2;font-size:.875em;cursor:pointer}.DayPicker-Day--today{color:#d0021b;font-weight:700}.DayPicker-Day--outside{color:#8b9898;cursor:default}.DayPicker-Day--disabled{color:#dce0e0;cursor:default}.DayPicker-Day--sunday{background-color:#f7f8f8}.DayPicker-Day--sunday:not(.DayPicker-Day--today){color:#dce0e0}.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside){position:relative;background-color:#4a90e2;color:#f0f8ff}.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover{background-color:#51a0fa}.DayPicker:not(.DayPicker--interactionDisabled) .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover{background-color:#f0f8ff}.DayPickerInput{display:inline-block}.DayPickerInput-OverlayWrapper{position:relative}.DayPickerInput-Overlay{position:absolute;left:0;z-index:1;background:#fff;box-shadow:0 2px 5px rgba(0,0,0,.15)}", ""]);

// exports


/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HIDE_TIMEOUT = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.OverlayComponent = OverlayComponent;
exports.defaultFormat = defaultFormat;
exports.defaultParse = defaultParse;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DayPicker = __webpack_require__(800);

var _DayPicker2 = _interopRequireDefault(_DayPicker);

var _DateUtils = __webpack_require__(156);

var _ModifiersUtils = __webpack_require__(299);

var _keys = __webpack_require__(226);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// When clicking on a day cell, overlay will be hidden after this timeout
var HIDE_TIMEOUT = exports.HIDE_TIMEOUT = 100;

/**
 * The default component used as Overlay.
 *
 * @param {Object} props
 */
function OverlayComponent(_ref) {
  var input = _ref.input,
      selectedDay = _ref.selectedDay,
      month = _ref.month,
      children = _ref.children,
      classNames = _ref.classNames,
      props = _objectWithoutProperties(_ref, ['input', 'selectedDay', 'month', 'children', 'classNames']);

  return _react2.default.createElement(
    'div',
    _extends({ className: classNames.overlayWrapper }, props),
    _react2.default.createElement(
      'div',
      { className: classNames.overlay },
      children
    )
  );
}

OverlayComponent.propTypes = {
  input: _propTypes2.default.any,
  selectedDay: _propTypes2.default.any,
  month: _propTypes2.default.instanceOf(Date),
  children: _propTypes2.default.node,
  classNames: _propTypes2.default.object
};

/**
 * The default function used to format a Date to String, passed to the `format`
 * prop.
 * @param {Date} d
 * @return {String}
 */
function defaultFormat(d) {
  if ((0, _DateUtils.isDate)(d)) {
    var year = d.getFullYear();
    var month = '' + (d.getMonth() + 1);
    var day = '' + d.getDate();
    return year + '-' + month + '-' + day;
  }
  return '';
}

/**
 * The default function used to parse a String as Date, passed to the `parse`
 * prop.
 * @param {String} str
 * @return {Date}
 */
function defaultParse(str) {
  if (typeof str !== 'string') {
    return undefined;
  }
  var split = str.split('-');
  if (split.length !== 3) {
    return undefined;
  }
  var year = parseInt(split[0], 10);
  var month = parseInt(split[1], 10) - 1;
  var day = parseInt(split[2], 10);
  if (isNaN(year) || String(year).length > 4 || isNaN(month) || isNaN(day) || day <= 0 || day > 31 || month < 0 || month >= 12) {
    return undefined;
  }

  return new Date(year, month, day, 12, 0, 0, 0); // always set noon to avoid time zone issues
}

var DayPickerInput = function (_React$Component) {
  _inherits(DayPickerInput, _React$Component);

  function DayPickerInput(props) {
    _classCallCheck(this, DayPickerInput);

    var _this = _possibleConstructorReturn(this, (DayPickerInput.__proto__ || Object.getPrototypeOf(DayPickerInput)).call(this, props));

    _this.input = null;
    _this.daypicker = null;
    _this.clickTimeout = null;
    _this.hideTimeout = null;
    _this.inputBlurTimeout = null;
    _this.inputFocusTimeout = null;


    _this.state = _this.getInitialStateFromProps(props);
    _this.state.showOverlay = props.showOverlay;

    _this.hideAfterDayClick = _this.hideAfterDayClick.bind(_this);
    _this.handleInputClick = _this.handleInputClick.bind(_this);
    _this.handleInputFocus = _this.handleInputFocus.bind(_this);
    _this.handleInputBlur = _this.handleInputBlur.bind(_this);
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleInputKeyDown = _this.handleInputKeyDown.bind(_this);
    _this.handleInputKeyUp = _this.handleInputKeyUp.bind(_this);
    _this.handleDayClick = _this.handleDayClick.bind(_this);
    _this.handleMonthChange = _this.handleMonthChange.bind(_this);
    _this.handleOverlayFocus = _this.handleOverlayFocus.bind(_this);
    _this.handleOverlayBlur = _this.handleOverlayBlur.bind(_this);
    return _this;
  }

  _createClass(DayPickerInput, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var newState = {};

      // Current props
      var _props = this.props,
          value = _props.value,
          formatDate = _props.formatDate,
          format = _props.format,
          dayPickerProps = _props.dayPickerProps;

      // Update the input value if `value`, `dayPickerProps.locale` or `format`
      // props have changed

      if (value !== prevProps.value || dayPickerProps.locale !== prevProps.dayPickerProps.locale || format !== prevProps.format) {
        if ((0, _DateUtils.isDate)(value)) {
          newState.value = formatDate(value, format, dayPickerProps.locale);
        } else {
          newState.value = value;
        }
      }

      // Update the month if the months from props changed
      var prevMonth = prevProps.dayPickerProps.month;
      if (dayPickerProps.month && dayPickerProps.month !== prevMonth && !(0, _DateUtils.isSameMonth)(dayPickerProps.month, prevMonth)) {
        newState.month = dayPickerProps.month;
      }

      // Updated the selected days from props if they changed
      if (prevProps.dayPickerProps.selectedDays !== dayPickerProps.selectedDays) {
        newState.selectedDays = dayPickerProps.selectedDays;
      }

      if (Object.keys(newState).length > 0) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState(newState);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.clickTimeout);
      clearTimeout(this.hideTimeout);
      clearTimeout(this.inputFocusTimeout);
      clearTimeout(this.inputBlurTimeout);
      clearTimeout(this.overlayBlurTimeout);
    }
  }, {
    key: 'getInitialMonthFromProps',
    value: function getInitialMonthFromProps(props) {
      var dayPickerProps = props.dayPickerProps,
          format = props.format;

      var day = void 0;
      if (props.value) {
        if ((0, _DateUtils.isDate)(props.value)) {
          day = props.value;
        } else {
          day = props.parseDate(props.value, format, dayPickerProps.locale);
        }
      }
      return dayPickerProps.initialMonth || dayPickerProps.month || day || new Date();
    }
  }, {
    key: 'getInitialStateFromProps',
    value: function getInitialStateFromProps(props) {
      var dayPickerProps = props.dayPickerProps,
          formatDate = props.formatDate,
          format = props.format,
          typedValue = props.typedValue;
      var value = props.value;

      if (props.value && (0, _DateUtils.isDate)(props.value)) {
        value = formatDate(props.value, format, dayPickerProps.locale);
      }

      return {
        value: value,
        typedValue: typedValue,
        month: this.getInitialMonthFromProps(props),
        selectedDays: dayPickerProps.selectedDays
      };
    }
  }, {
    key: 'getInput',
    value: function getInput() {
      return this.input;
    }
  }, {
    key: 'getDayPicker',
    value: function getDayPicker() {
      return this.daypicker;
    }

    /**
     * Update the component's state and fire the `onDayChange` event passing the
     * day's modifiers to it.
     *
     * @param {Date} day - Will be used for changing the month
     * @param {String} value - Input field value
     * @private
     */

  }, {
    key: 'updateState',
    value: function updateState(day, value, callback) {
      var _this2 = this;

      var _props2 = this.props,
          dayPickerProps = _props2.dayPickerProps,
          onDayChange = _props2.onDayChange;

      this.setState({ month: day, value: value, typedValue: '' }, function () {
        if (callback) {
          callback();
        }
        if (!onDayChange) {
          return;
        }
        var modifiersObj = _extends({
          disabled: dayPickerProps.disabledDays,
          selected: dayPickerProps.selectedDays
        }, dayPickerProps.modifiers);
        var modifiers = (0, _ModifiersUtils.getModifiersForDay)(day, modifiersObj).reduce(function (obj, modifier) {
          return _extends({}, obj, _defineProperty({}, modifier, true));
        }, {});
        onDayChange(day, modifiers, _this2);
      });
    }

    /**
     * Show the Day Picker overlay.
     *
     * @memberof DayPickerInput
     */

  }, {
    key: 'showDayPicker',
    value: function showDayPicker() {
      var _this3 = this;

      var _props3 = this.props,
          parseDate = _props3.parseDate,
          format = _props3.format,
          dayPickerProps = _props3.dayPickerProps;
      var _state = this.state,
          value = _state.value,
          showOverlay = _state.showOverlay;

      if (showOverlay) {
        return;
      }
      // Reset the current displayed month when showing the overlay
      var month = value ? parseDate(value, format, dayPickerProps.locale) // Use the month in the input field
      : this.getInitialMonthFromProps(this.props); // Restore the month from the props
      this.setState(function (state) {
        return {
          showOverlay: true,
          month: month || state.month
        };
      }, function () {
        if (_this3.props.onDayPickerShow) _this3.props.onDayPickerShow();
      });
    }

    /**
     * Hide the Day Picker overlay
     *
     * @memberof DayPickerInput
     */

  }, {
    key: 'hideDayPicker',
    value: function hideDayPicker() {
      var _this4 = this;

      if (this.state.showOverlay === false) {
        return;
      }
      this.setState({ showOverlay: false }, function () {
        if (_this4.props.onDayPickerHide) _this4.props.onDayPickerHide();
      });
    }
  }, {
    key: 'hideAfterDayClick',
    value: function hideAfterDayClick() {
      var _this5 = this;

      if (!this.props.hideOnDayClick) {
        return;
      }
      this.hideTimeout = setTimeout(function () {
        _this5.overlayHasFocus = false;
        _this5.hideDayPicker();
      }, HIDE_TIMEOUT);
    }
  }, {
    key: 'handleInputClick',
    value: function handleInputClick(e) {
      this.showDayPicker();
      if (this.props.inputProps.onClick) {
        e.persist();
        this.props.inputProps.onClick(e);
      }
    }
  }, {
    key: 'handleInputFocus',
    value: function handleInputFocus(e) {
      var _this6 = this;

      this.showDayPicker();
      // Set `overlayHasFocus` after a timeout so the overlay can be hidden when
      // the input is blurred
      this.inputFocusTimeout = setTimeout(function () {
        _this6.overlayHasFocus = false;
      }, 2);
      if (this.props.inputProps.onFocus) {
        e.persist();
        this.props.inputProps.onFocus(e);
      }
    }

    // When the input is blurred, the overlay should disappear. However the input
    // is blurred also when the user interacts with the overlay (e.g. the overlay
    // get the focus by clicking it). In these cases, the overlay should not be
    // hidden. There are different approaches to avoid hiding the overlay when
    // this happens, but the only cross-browser hack we’ve found is to set all
    // these timeouts in code before changing `overlayHasFocus`.

  }, {
    key: 'handleInputBlur',
    value: function handleInputBlur(e) {
      var _this7 = this;

      this.inputBlurTimeout = setTimeout(function () {
        if (!_this7.overlayHasFocus) {
          _this7.hideDayPicker();
        }
      }, 1);
      if (this.props.inputProps.onBlur) {
        e.persist();
        this.props.inputProps.onBlur(e);
      }
    }
  }, {
    key: 'handleOverlayFocus',
    value: function handleOverlayFocus(e) {
      e.preventDefault();
      this.overlayHasFocus = true;
      if (!this.props.keepFocus || !this.input || typeof this.input.focus !== 'function') {
        return;
      }
      this.input.focus();
    }
  }, {
    key: 'handleOverlayBlur',
    value: function handleOverlayBlur() {
      var _this8 = this;

      // We need to set a timeout otherwise IE11 will hide the overlay when
      // focusing it
      this.overlayBlurTimeout = setTimeout(function () {
        _this8.overlayHasFocus = false;
      }, 3);
    }
  }, {
    key: 'handleInputChange',
    value: function handleInputChange(e) {
      var _props4 = this.props,
          dayPickerProps = _props4.dayPickerProps,
          format = _props4.format,
          inputProps = _props4.inputProps,
          onDayChange = _props4.onDayChange,
          parseDate = _props4.parseDate;

      if (inputProps.onChange) {
        e.persist();
        inputProps.onChange(e);
      }
      var value = e.target.value;

      if (value.trim() === '') {
        this.setState({ value: value, typedValue: '' });
        if (onDayChange) onDayChange(undefined, {}, this);
        return;
      }
      var day = parseDate(value, format, dayPickerProps.locale);
      if (!day) {
        // Day is invalid: we save the value in the typedValue state
        this.setState({ value: value, typedValue: value });
        if (onDayChange) onDayChange(undefined, {}, this);
        return;
      }
      this.updateState(day, value);
    }
  }, {
    key: 'handleInputKeyDown',
    value: function handleInputKeyDown(e) {
      if (e.keyCode === _keys.TAB) {
        this.hideDayPicker();
      } else {
        this.showDayPicker();
      }
      if (this.props.inputProps.onKeyDown) {
        e.persist();
        this.props.inputProps.onKeyDown(e);
      }
    }
  }, {
    key: 'handleInputKeyUp',
    value: function handleInputKeyUp(e) {
      if (e.keyCode === _keys.ESC) {
        this.hideDayPicker();
      } else {
        this.showDayPicker();
      }
      if (this.props.inputProps.onKeyUp) {
        e.persist();
        this.props.inputProps.onKeyUp(e);
      }
    }
  }, {
    key: 'handleMonthChange',
    value: function handleMonthChange(month) {
      var _this9 = this;

      this.setState({ month: month }, function () {
        if (_this9.props.dayPickerProps && _this9.props.dayPickerProps.onMonthChange) {
          _this9.props.dayPickerProps.onMonthChange(month);
        }
      });
    }
  }, {
    key: 'handleDayClick',
    value: function handleDayClick(day, modifiers, e) {
      var _this10 = this;

      var _props5 = this.props,
          clickUnselectsDay = _props5.clickUnselectsDay,
          dayPickerProps = _props5.dayPickerProps,
          onDayChange = _props5.onDayChange,
          formatDate = _props5.formatDate,
          format = _props5.format;

      if (dayPickerProps.onDayClick) {
        dayPickerProps.onDayClick(day, modifiers, e);
      }

      // Do nothing if the day is disabled
      if (modifiers.disabled || dayPickerProps && dayPickerProps.classNames && modifiers[dayPickerProps.classNames.disabled]) {
        return;
      }

      // If the clicked day is already selected, remove the clicked day
      // from the selected days and empty the field value
      if (modifiers.selected && clickUnselectsDay) {
        var selectedDays = this.state.selectedDays;

        if (Array.isArray(selectedDays)) {
          selectedDays = selectedDays.slice(0);
          var selectedDayIdx = selectedDays.indexOf(day);
          selectedDays.splice(selectedDayIdx, 1);
        } else if (selectedDays) {
          selectedDays = null;
        }

        this.setState({ value: '', typedValue: '', selectedDays: selectedDays }, this.hideAfterDayClick);

        if (onDayChange) {
          onDayChange(undefined, modifiers, this);
        }
        return;
      }

      var value = formatDate(day, format, dayPickerProps.locale);
      this.setState({ value: value, typedValue: undefined, month: day }, function () {
        if (onDayChange) {
          onDayChange(day, modifiers, _this10);
        }
        _this10.hideAfterDayClick();
      });
    }
  }, {
    key: 'renderOverlay',
    value: function renderOverlay() {
      var _this11 = this;

      var _props6 = this.props,
          classNames = _props6.classNames,
          dayPickerProps = _props6.dayPickerProps,
          parseDate = _props6.parseDate,
          formatDate = _props6.formatDate,
          format = _props6.format;
      var _state2 = this.state,
          selectedDays = _state2.selectedDays,
          value = _state2.value;

      var selectedDay = void 0;
      if (!selectedDays && value) {
        var day = parseDate(value, format, dayPickerProps.locale);
        if (day) {
          selectedDay = day;
        }
      } else if (selectedDays) {
        selectedDay = selectedDays;
      }
      var onTodayButtonClick = void 0;
      if (dayPickerProps.todayButton) {
        // Set the current day when clicking the today button
        onTodayButtonClick = function onTodayButtonClick() {
          return _this11.updateState(new Date(), formatDate(new Date(), format, dayPickerProps.locale), _this11.hideAfterDayClick);
        };
      }
      var Overlay = this.props.overlayComponent;
      return _react2.default.createElement(
        Overlay,
        {
          classNames: classNames,
          month: this.state.month,
          selectedDay: selectedDay,
          input: this.input,
          tabIndex: 0 // tabIndex is necessary to catch focus/blur events on Safari
          , onFocus: this.handleOverlayFocus,
          onBlur: this.handleOverlayBlur
        },
        _react2.default.createElement(_DayPicker2.default, _extends({
          ref: function ref(el) {
            return _this11.daypicker = el;
          },
          onTodayButtonClick: onTodayButtonClick
        }, dayPickerProps, {
          month: this.state.month,
          selectedDays: selectedDay,
          onDayClick: this.handleDayClick,
          onMonthChange: this.handleMonthChange
        }))
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this12 = this;

      var Input = this.props.component;
      var inputProps = this.props.inputProps;

      return _react2.default.createElement(
        'div',
        { className: this.props.classNames.container, style: this.props.style },
        _react2.default.createElement(Input, _extends({
          ref: function ref(el) {
            return _this12.input = el;
          },
          placeholder: this.props.placeholder
        }, inputProps, {
          value: this.state.value || this.state.typedValue,
          onChange: this.handleInputChange,
          onFocus: this.handleInputFocus,
          onBlur: this.handleInputBlur,
          onKeyDown: this.handleInputKeyDown,
          onKeyUp: this.handleInputKeyUp,
          onClick: !inputProps.disabled ? this.handleInputClick : undefined
        })),
        this.state.showOverlay && this.renderOverlay()
      );
    }
  }]);

  return DayPickerInput;
}(_react2.default.Component);

DayPickerInput.propTypes = {
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]),
  inputProps: _propTypes2.default.object,
  placeholder: _propTypes2.default.string,

  format: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),

  formatDate: _propTypes2.default.func,
  parseDate: _propTypes2.default.func,
  typedValue: _propTypes2.default.string,

  showOverlay: _propTypes2.default.bool,
  dayPickerProps: _propTypes2.default.object,
  hideOnDayClick: _propTypes2.default.bool,
  clickUnselectsDay: _propTypes2.default.bool,
  keepFocus: _propTypes2.default.bool,
  component: _propTypes2.default.any,
  overlayComponent: _propTypes2.default.any,

  style: _propTypes2.default.object,
  classNames: _propTypes2.default.shape({
    container: _propTypes2.default.string,
    overlayWrapper: _propTypes2.default.string,
    overlay: _propTypes2.default.string.isRequired
  }),

  onDayChange: _propTypes2.default.func,
  onDayPickerHide: _propTypes2.default.func,
  onDayPickerShow: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  onKeyUp: _propTypes2.default.func
};
DayPickerInput.defaultProps = {
  dayPickerProps: {},
  value: '',
  typedValue: '',
  placeholder: 'YYYY-M-D',
  format: 'L',
  formatDate: defaultFormat,
  parseDate: defaultParse,
  showOverlay: false,
  hideOnDayClick: true,
  clickUnselectsDay: false,
  keepFocus: true,
  component: 'input',
  inputProps: {},
  overlayComponent: OverlayComponent,
  classNames: {
    container: 'DayPickerInput',
    overlayWrapper: 'DayPickerInput-OverlayWrapper',
    overlay: 'DayPickerInput-Overlay'
  }
};
exports.default = DayPickerInput;
//# sourceMappingURL=DayPickerInput.js.map

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRouterDom = __webpack_require__(13);

var _asyncComponent = _interopRequireDefault(__webpack_require__(44));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Icons = function Icons(_ref) {
  var match = _ref.match;
  return _react["default"].createElement("div", {
    className: "app-wrapper"
  }, _react["default"].createElement(_reactRouterDom.Switch, null, _react["default"].createElement(_reactRouterDom.Redirect, {
    exact: true,
    from: "".concat(match.url, "/"),
    to: "".concat(match.url, "/material")
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/material"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, 2028));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 39));
    })
  })));
};

var _default = Icons;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Icons, "Icons", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/icons/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/icons/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/icons/index.js");

  __REACT_HOT_LOADER__.register(_asyncComponent, "_asyncComponent", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/icons/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/icons/index.js");

  __REACT_HOT_LOADER__.register(Icons, "Icons", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/icons/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/icons/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/icons/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/icons/index.js");
}();

;

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRouterDom = __webpack_require__(13);

var _asyncComponent = _interopRequireDefault(__webpack_require__(44));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Form = function Form(_ref) {
  var match = _ref.match;
  return _react["default"].createElement("div", {
    className: "app-wrapper"
  }, _react["default"].createElement(_reactRouterDom.Switch, null, _react["default"].createElement(_reactRouterDom.Redirect, {
    exact: true,
    from: "".concat(match.url, "/"),
    to: "".concat(match.url, "/components")
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/components"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 2029));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 39));
    })
  })));
};

var _default = Form;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Form, "Form", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/form/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/form/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/form/index.js");

  __REACT_HOT_LOADER__.register(_asyncComponent, "_asyncComponent", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/form/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/form/index.js");

  __REACT_HOT_LOADER__.register(Form, "Form", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/form/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/form/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/form/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/form/index.js");
}();

;

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRouterDom = __webpack_require__(13);

var _asyncComponent = _interopRequireDefault(__webpack_require__(44));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Editors = function Editors(_ref) {
  var match = _ref.match;
  return _react["default"].createElement("div", {
    className: "app-wrapper"
  }, _react["default"].createElement(_reactRouterDom.Switch, null, _react["default"].createElement(_reactRouterDom.Redirect, {
    exact: true,
    from: "".concat(match.url, "/"),
    to: "".concat(match.url, "/ck")
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/ck"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 2030));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/wysiswyg"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 2031));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 39));
    })
  })));
};

var _default = Editors;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Editors, "Editors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/editors/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/editors/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/editors/index.js");

  __REACT_HOT_LOADER__.register(_asyncComponent, "_asyncComponent", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/editors/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/editors/index.js");

  __REACT_HOT_LOADER__.register(Editors, "Editors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/editors/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/editors/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/editors/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/editors/index.js");
}();

;

/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRouterDom = __webpack_require__(13);

var _asyncComponent = _interopRequireDefault(__webpack_require__(44));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Pickers = function Pickers(_ref) {
  var match = _ref.match;
  return _react["default"].createElement("div", {
    className: "app-wrapper"
  }, _react["default"].createElement(_reactRouterDom.Switch, null, _react["default"].createElement(_reactRouterDom.Redirect, {
    exact: true,
    from: "".concat(match.url, "/"),
    to: "".concat(match.url, "/date-time")
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/date-time"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(6/* aggressive-merge */).then(__webpack_require__.bind(null, 2032));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/color"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(5/* aggressive-merge */).then(__webpack_require__.bind(null, 2033));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 39));
    })
  })));
};

var _default = Pickers;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Pickers, "Pickers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/pickers/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/pickers/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/pickers/index.js");

  __REACT_HOT_LOADER__.register(_asyncComponent, "_asyncComponent", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/pickers/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/pickers/index.js");

  __REACT_HOT_LOADER__.register(Pickers, "Pickers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/pickers/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/pickers/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/pickers/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/pickers/index.js");
}();

;

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRouterDom = __webpack_require__(13);

var _asyncComponent = _interopRequireDefault(__webpack_require__(44));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Extensions = function Extensions(_ref) {
  var match = _ref.match;
  return _react["default"].createElement("div", {
    className: "app-wrapper"
  }, _react["default"].createElement(_reactRouterDom.Switch, null, _react["default"].createElement(_reactRouterDom.Redirect, {
    exact: true,
    from: "".concat(match.url, "/"),
    to: "".concat(match.url, "/dnd")
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/dnd"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(72).then(__webpack_require__.bind(null, 2034));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/sweet-alert"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(77).then(__webpack_require__.bind(null, 2035));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/notification"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(78).then(__webpack_require__.bind(null, 2036));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/dropzone"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 2037));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 39));
    })
  })));
};

var _default = Extensions;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Extensions, "Extensions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/extensions/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/extensions/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/extensions/index.js");

  __REACT_HOT_LOADER__.register(_asyncComponent, "_asyncComponent", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/extensions/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/extensions/index.js");

  __REACT_HOT_LOADER__.register(Extensions, "Extensions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/extensions/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/extensions/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/extensions/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/extensions/index.js");
}();

;

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// third-party

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _objectAssign = __webpack_require__(77);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _SuccessIcon = __webpack_require__(1773);

var _SuccessIcon2 = _interopRequireDefault(_SuccessIcon);

var _ErrorIcon = __webpack_require__(1774);

var _ErrorIcon2 = _interopRequireDefault(_ErrorIcon);

var _InfoIcon = __webpack_require__(1775);

var _InfoIcon2 = _interopRequireDefault(_InfoIcon);

var _WarningIcon = __webpack_require__(1776);

var _WarningIcon2 = _interopRequireDefault(_WarningIcon);

var _CustomIcon = __webpack_require__(1777);

var _CustomIcon2 = _interopRequireDefault(_CustomIcon);

var _Buttons = __webpack_require__(1778);

var _Buttons2 = _interopRequireDefault(_Buttons);

var _Input = __webpack_require__(1779);

var _Input2 = _interopRequireDefault(_Input);

var _ValidationMessage = __webpack_require__(1780);

var _ValidationMessage2 = _interopRequireDefault(_ValidationMessage);

var _Title = __webpack_require__(1781);

var _Title2 = _interopRequireDefault(_Title);

var _Content = __webpack_require__(1782);

var _Content2 = _interopRequireDefault(_Content);

var _SweetAlertStyles = __webpack_require__(106);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// components


// styles


var defaultRegex = /^.+$/;
var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

var style = _SweetAlertStyles2.default.sweetAlert;

if (typeof window !== 'undefined') {
  if (window && window.innerWidth && window.innerWidth < 767) {
    style = (0, _objectAssign2.default)({}, style, _SweetAlertStyles2.default.sweetAlertMobile);
  }
}

var SweetAlert = function (_React$Component) {
  _inherits(SweetAlert, _React$Component);

  function SweetAlert() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SweetAlert);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SweetAlert.__proto__ || Object.getPrototypeOf(SweetAlert)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      type: 'default',
      focusConfirmBtn: true,
      inputValue: '',
      showValidationMessage: false,
      timer: null
    }, _this.setStateFromProps = function (props) {
      props = props || _this.props;
      var type = _this.getTypeFromProps(props);
      _this.setState({
        type: type,
        focusConfirmBtn: props.focusConfirmBtn && type !== 'input'
      });
    }, _this.getTypeFromProps = function (props) {
      if (props.type) return props.type;
      if (props.info) return 'info';
      if (props.success) return 'success';
      if (props.warning) return 'warning';
      if (props.danger || props.error) return 'danger';
      if (props.input) return 'input';
      if (props.custom) return 'custom';
      return _this.state.type;
    }, _this.unsupportedProp = function (oldProp, message) {
      try {
        console.warn('react-bootstrap-sweetalert: Unsupported prop \'' + oldProp + '\'. Please ' + message);
      } catch (e) {}
    }, _this.getIcon = function () {
      switch (_this.state.type) {
        case 'danger':
        case 'error':
          return _react2.default.createElement(_ErrorIcon2.default, null);
        case 'warning':
          return _react2.default.createElement(_WarningIcon2.default, null);
        case 'info':
          return _react2.default.createElement(_InfoIcon2.default, null);
        case 'success':
          return _react2.default.createElement(_SuccessIcon2.default, null);
        case 'custom':
          if (_this.props.customIcon) {
            if (typeof _this.props.customIcon == 'string') {
              return _react2.default.createElement(_CustomIcon2.default, { iconUrl: _this.props.customIcon });
            } else {
              return _this.props.customIcon;
            }
          }
      }
    }, _this.onChangeInput = function (e) {
      _this.setState({
        inputValue: e.target.value,
        showValidationMessage: false
      });
    }, _this.isValidInput = function () {
      if (!_this.props.required) {
        return true;
      }
      var regex = _this.props.validationRegex || (_this.props.inputType === 'email' ? emailRegex : defaultRegex);
      return regex.test(_this.state.inputValue);
    }, _this.onConfirm = function () {
      if (_this.state.type === 'input') {
        if (_this.isValidInput()) {
          _this.props.onConfirm(_this.state.inputValue);
        } else {
          _this.setState({
            showValidationMessage: true
          });
        }
      } else {
        _this.props.onConfirm();
      }
    }, _this.onInputKeyDown = function (e) {
      if (e.keyCode == 13) {
        if (_this.props.onConfirm) {
          _this.onConfirm();
          e.stopPropagation();
        }
      }
    }, _this.onKeyDown = function (e) {
      if (e.keyCode == 27) {
        if (_this.props.allowEscape && _this.props.onCancel) {
          _this.props.onCancel();
          e.stopPropagation();
        }
      }
    }, _this.onClickOutside = function () {
      if (_this.props.closeOnClickOutside && _this.props.onCancel) {
        _this.props.onCancel();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SweetAlert, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.inputPlaceHolder) {
        this.unsupportedProp('inputPlaceHolder', 'use props.placeholder');
      }
      if (this.props.inputValidationMsg) {
        this.unsupportedProp('inputValidationMsg', 'use props.validationMsg');
      }
      if (this.props.content) {
        this.unsupportedProp('content', 'use props.children <SweetAlert>your content</SweetAlert>');
      }
      if (this.props.defaultValue != null) {
        this.setState({
          inputValue: this.props.defaultValue
        });
      }

      this.setStateFromProps();

      this.props.beforeMount();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.afterMount();
      this.handleTimeout();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.getTypeFromProps(this.props) !== this.getTypeFromProps(nextProps)) {
        this.setStateFromProps(nextProps);
        this.handleTimeout(nextProps);
      } else if (this.props.timeout !== nextProps.timeout) {
        this.handleTimeout(nextProps);
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      this.props.beforeUpdate(nextProps, nextState);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      this.props.afterUpdate(prevProps, prevState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.beforeUnmount();
    }
  }, {
    key: 'handleTimeout',
    value: function handleTimeout(props) {
      props = props || this.props;

      if (this.state.timer) {
        clearTimeout(this.state.timer);
      }

      if (props.timeout && props.timeout > 0) {
        var timer = setTimeout(function () {
          return props.onConfirm();
        }, props.timeout);

        this.setState({ timer: timer });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.show) {
        return false;
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'style',
          { type: 'text/css', scoped: true },
          '@-webkit-keyframes showSweetAlert {\n                      0% {\n                        transform: scale(0.7);\n                        -webkit-transform: scale(0.7);\n                      }\n                      45% {\n                        transform: scale(1.05);\n                        -webkit-transform: scale(1.05);\n                      }\n                      80% {\n                        transform: scale(0.95);\n                        -webkit-tranform: scale(0.95);\n                      }\n                      100% {\n                        transform: scale(1);\n                        -webkit-transform: scale(1);\n                      }\n                    }\n                    @keyframes showSweetAlert {\n                      0% {\n                        transform: scale(0.7);\n                        -webkit-transform: scale(0.7);\n                      }\n                      45% {\n                        transform: scale(1.05);\n                        -webkit-transform: scale(1.05);\n                      }\n                      80% {\n                        transform: scale(0.95);\n                        -webkit-tranform: scale(0.95);\n                      }\n                      100% {\n                        transform: scale(1);\n                        -webkit-transform: scale(1);\n                      }\n                    }\n                    @-webkit-keyframes hideSweetAlert {\n                      0% {\n                        transform: scale(1);\n                        -webkit-transform: scale(1);\n                      }\n                      100% {\n                        transform: scale(0.5);\n                        -webkit-transform: scale(0.5);\n                      }\n                    }\n                    @keyframes hideSweetAlert {\n                      0% {\n                        transform: scale(1);\n                        -webkit-transform: scale(1);\n                      }\n                      100% {\n                        transform: scale(0.5);\n                        -webkit-transform: scale(0.5);\n                      }\n                    }\n                    @-webkit-keyframes animateSuccessTip {\n                      0% {\n                        width: 0;\n                        left: 1px;\n                        top: 19px;\n                      }\n                      54% {\n                        width: 0;\n                        left: 1px;\n                        top: 19px;\n                      }\n                      70% {\n                        width: 50px;\n                        left: -8px;\n                        top: 37px;\n                      }\n                      84% {\n                        width: 17px;\n                        left: 21px;\n                        top: 48px;\n                      }\n                      100% {\n                        width: 25px;\n                        left: 14px;\n                        top: 45px;\n                      }\n                    }\n                    @keyframes animateSuccessTip {\n                      0% {\n                        width: 0;\n                        left: 1px;\n                        top: 19px;\n                      }\n                      54% {\n                        width: 0;\n                        left: 1px;\n                        top: 19px;\n                      }\n                      70% {\n                        width: 50px;\n                        left: -8px;\n                        top: 37px;\n                      }\n                      84% {\n                        width: 17px;\n                        left: 21px;\n                        top: 48px;\n                      }\n                      100% {\n                        width: 25px;\n                        left: 14px;\n                        top: 45px;\n                      }\n                    }\n                    @-webkit-keyframes animateSuccessLong {\n                      0% {\n                        width: 0;\n                        right: 46px;\n                        top: 54px;\n                      }\n                      65% {\n                        width: 0;\n                        right: 46px;\n                        top: 54px;\n                      }\n                      84% {\n                        width: 55px;\n                        right: 0px;\n                        top: 35px;\n                      }\n                      100% {\n                        width: 47px;\n                        right: 8px;\n                        top: 38px;\n                      }\n                    }\n                    @keyframes animateSuccessLong {\n                      0% {\n                        width: 0;\n                        right: 46px;\n                        top: 54px;\n                      }\n                      65% {\n                        width: 0;\n                        right: 46px;\n                        top: 54px;\n                      }\n                      84% {\n                        width: 55px;\n                        right: 0px;\n                        top: 35px;\n                      }\n                      100% {\n                        width: 47px;\n                        right: 8px;\n                        top: 38px;\n                      }\n                    }\n                    @-webkit-keyframes rotatePlaceholder {\n                      0% {\n                        transform: rotate(-45deg);\n                        -webkit-transform: rotate(-45deg);\n                      }\n                      5% {\n                        transform: rotate(-45deg);\n                        -webkit-transform: rotate(-45deg);\n                      }\n                      12% {\n                        transform: rotate(-405deg);\n                        -webkit-transform: rotate(-405deg);\n                      }\n                      100% {\n                        transform: rotate(-405deg);\n                        -webkit-transform: rotate(-405deg);\n                      }\n                    }\n                    @keyframes rotatePlaceholder {\n                      0% {\n                        transform: rotate(-45deg);\n                        -webkit-transform: rotate(-45deg);\n                      }\n                      5% {\n                        transform: rotate(-45deg);\n                        -webkit-transform: rotate(-45deg);\n                      }\n                      12% {\n                        transform: rotate(-405deg);\n                        -webkit-transform: rotate(-405deg);\n                      }\n                      100% {\n                        transform: rotate(-405deg);\n                        -webkit-transform: rotate(-405deg);\n                      }\n                    }\n                    @-webkit-keyframes animateErrorIcon {\n                      0% {\n                        transform: rotateX(100deg);\n                        -webkit-transform: rotateX(100deg);\n                        opacity: 0;\n                      }\n                      100% {\n                        transform: rotateX(0deg);\n                        -webkit-transform: rotateX(0deg);\n                        opacity: 1;\n                      }\n                    }\n                    @keyframes animateErrorIcon {\n                      0% {\n                        transform: rotateX(100deg);\n                        -webkit-transform: rotateX(100deg);\n                        opacity: 0;\n                      }\n                      100% {\n                        transform: rotateX(0deg);\n                        -webkit-transform: rotateX(0deg);\n                        opacity: 1;\n                      }\n                    }\n                    @-webkit-keyframes animateXMark {\n                      0% {\n                        transform: scale(0.4);\n                        -webkit-transform: scale(0.4);\n                        margin-top: 26px;\n                        opacity: 0;\n                      }\n                      50% {\n                        transform: scale(0.4);\n                        -webkit-transform: scale(0.4);\n                        margin-top: 26px;\n                        opacity: 0;\n                      }\n                      80% {\n                        transform: scale(1.15);\n                        -webkit-transform: scale(1.15);\n                        margin-top: -6px;\n                      }\n                      100% {\n                        transform: scale(1);\n                        -webkit-transform: scale(1);\n                        margin-top: 0;\n                        opacity: 1;\n                      }\n                    }\n                    @keyframes animateXMark {\n                      0% {\n                        transform: scale(0.4);\n                        -webkit-transform: scale(0.4);\n                        margin-top: 26px;\n                        opacity: 0;\n                      }\n                      50% {\n                        transform: scale(0.4);\n                        -webkit-transform: scale(0.4);\n                        margin-top: 26px;\n                        opacity: 0;\n                      }\n                      80% {\n                        transform: scale(1.15);\n                        -webkit-transform: scale(1.15);\n                        margin-top: -6px;\n                      }\n                      100% {\n                        transform: scale(1);\n                        -webkit-transform: scale(1);\n                        margin-top: 0;\n                        opacity: 1;\n                      }\n                    }\n                    @-webkit-keyframes pulseWarning {\n                      0% {\n                        border-color: #F8D486;\n                      }\n                      100% {\n                        border-color: #F8BB86;\n                      }\n                    }\n                    @keyframes pulseWarning {\n                      0% {\n                        border-color: #F8D486;\n                      }\n                      100% {\n                        border-color: #F8BB86;\n                      }\n                    }\n                    @-webkit-keyframes pulseWarningIns {\n                      0% {\n                        background-color: #F8D486;\n                      }\n                      100% {\n                        background-color: #F8BB86;\n                      }\n                    }\n                    @keyframes pulseWarningIns {\n                      0% {\n                        background-color: #F8D486;\n                      }\n                      100% {\n                        background-color: #F8BB86;\n                      }\n                    }'
        ),
        !this.props.hideOverlay && _react2.default.createElement('div', { style: _SweetAlertStyles2.default.overlay, onClick: this.onClickOutside }),
        _react2.default.createElement(
          'div',
          {
            style: (0, _objectAssign2.default)({}, style, this.props.style),
            tabIndex: '0',
            ref: 'container',
            onKeyDown: this.onKeyDown,
            className: 'sweet-alert ' + this.props.customClass
          },
          this.getIcon(),
          _react2.default.createElement(
            _Title2.default,
            null,
            this.props.title
          ),
          _react2.default.createElement(
            _Content2.default,
            null,
            this.props.children
          ),
          this.state.type === 'input' && _react2.default.createElement(_Input2.default, _extends({}, this.props, this.state, {
            type: this.state.type,
            onInputKeyDown: this.onInputKeyDown,
            onChangeInput: this.onChangeInput
          })),
          this.state.showValidationMessage && _react2.default.createElement(_ValidationMessage2.default, this.props),
          _react2.default.createElement(_Buttons2.default, _extends({}, this.props, {
            type: this.state.type,
            onConfirm: this.onConfirm,
            focusConfirmBtn: this.state.focusConfirmBtn
          }))
        )
      );
    }
  }]);

  return SweetAlert;
}(_react2.default.Component);

SweetAlert.propTypes = {
  type: _propTypes2.default.oneOf(['default', 'info', 'success', 'warning', 'danger', 'error', 'input', 'custom']),
  title: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]).isRequired,
  onCancel: _propTypes2.default.func,
  onConfirm: _propTypes2.default.func.isRequired,
  confirmBtnText: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
  confirmBtnBsStyle: _propTypes2.default.oneOf(['default', 'primary', 'link', 'info', 'success', 'warning', 'danger']),
  confirmBtnCssClass: _propTypes2.default.string,
  confirmBtnStyle: _propTypes2.default.object,
  cancelBtnText: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
  cancelBtnBsStyle: _propTypes2.default.oneOf(['default', 'primary', 'link', 'info', 'success', 'warning', 'danger']),
  cancelBtnCssClass: _propTypes2.default.string,
  cancelBtnStyle: _propTypes2.default.object,
  btnSize: _propTypes2.default.string,
  customIcon: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
  show: _propTypes2.default.bool,
  required: _propTypes2.default.bool,
  placeholder: _propTypes2.default.string,
  validationMsg: _propTypes2.default.string,
  validationRegex: _propTypes2.default.object,
  defaultValue: _propTypes2.default.string,
  inputType: _propTypes2.default.string,
  style: _propTypes2.default.object,
  customClass: _propTypes2.default.string,
  showConfirm: _propTypes2.default.bool,
  showCancel: _propTypes2.default.bool,
  allowEscape: _propTypes2.default.bool,
  closeOnClickOutside: _propTypes2.default.bool,
  hideOverlay: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  focusConfirmBtn: _propTypes2.default.bool,
  beforeMount: _propTypes2.default.func,
  afterMount: _propTypes2.default.func,
  beforeUpdate: _propTypes2.default.func,
  afterUpdate: _propTypes2.default.func,
  beforeUnmount: _propTypes2.default.func,
  timeout: _propTypes2.default.number
};
SweetAlert.defaultProps = {
  allowEscape: true,
  closeOnClickOutside: true,
  validationMsg: null,
  validationRegex: null,
  inputType: 'text',
  customClass: '',
  hideOverlay: false,
  show: true,
  required: true,
  disabled: false,
  focusConfirmBtn: true,
  beforeMount: function beforeMount() {},
  afterMount: function afterMount() {},
  beforeUpdate: function beforeUpdate() {},
  afterUpdate: function afterUpdate() {},
  beforeUnmount: function beforeUnmount() {},
  timeout: 0
};
SweetAlert.SuccessIcon = _SuccessIcon2.default;
SweetAlert.ErrorIcon = _ErrorIcon2.default;
SweetAlert.InfoIcon = _InfoIcon2.default;
SweetAlert.WarningIcon = _WarningIcon2.default;
SweetAlert.CustomIcon = _CustomIcon2.default;
SweetAlert.Buttons = _Buttons2.default;
SweetAlert.Input = _Input2.default;
SweetAlert.ValidationMessage = _ValidationMessage2.default;
SweetAlert.Title = _Title2.default;
SweetAlert.Content = _Content2.default;
exports.default = SweetAlert;

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(77);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _SweetAlertStyles = __webpack_require__(106);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    return _react2.default.createElement(
        'div',
        { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.icon, _SweetAlertStyles2.default.iconSuccess) },
        _react2.default.createElement('div', { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.iconSuccessBeforeAfter, _SweetAlertStyles2.default.iconSuccessBefore) }),
        _react2.default.createElement('span', { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.iconSuccessLine, _SweetAlertStyles2.default.iconSuccessLineTip) }),
        _react2.default.createElement('span', { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.iconSuccessLine, _SweetAlertStyles2.default.iconSuccessLineLong) }),
        _react2.default.createElement('div', { style: _SweetAlertStyles2.default.iconSuccessPlaceholder }),
        _react2.default.createElement('div', { style: _SweetAlertStyles2.default.iconSuccessFix }),
        _react2.default.createElement('div', { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.iconSuccessBeforeAfter, _SweetAlertStyles2.default.iconSuccessAfter) })
    );
};

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(77);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _SweetAlertStyles = __webpack_require__(106);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
	return _react2.default.createElement(
		'div',
		{ style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.icon, _SweetAlertStyles2.default.iconError) },
		_react2.default.createElement(
			'span',
			{ style: _SweetAlertStyles2.default.iconErrorX },
			_react2.default.createElement('span', { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.iconErrorLine, _SweetAlertStyles2.default.iconErrorLineLeft) }),
			_react2.default.createElement('span', { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.iconErrorLine, _SweetAlertStyles2.default.iconErrorLineRight) })
		)
	);
};

/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
       value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(77);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _SweetAlertStyles = __webpack_require__(106);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
       return _react2.default.createElement(
              'div',
              { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.icon, _SweetAlertStyles2.default.iconInfo) },
              _react2.default.createElement('div', { style: _SweetAlertStyles2.default.iconInfoBefore }),
              _react2.default.createElement('div', { style: _SweetAlertStyles2.default.iconInfoAfter })
       );
};

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(77);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _SweetAlertStyles = __webpack_require__(106);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
	return _react2.default.createElement(
		'div',
		{ style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.icon, _SweetAlertStyles2.default.iconWarning) },
		_react2.default.createElement('span', { style: _SweetAlertStyles2.default.iconWarningBody }),
		_react2.default.createElement('span', { style: _SweetAlertStyles2.default.iconWarningDot })
	);
};

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(77);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _SweetAlertStyles = __webpack_require__(106);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.icon, _SweetAlertStyles2.default.iconCustom);

exports.default = function (_ref) {
    var iconUrl = _ref.iconUrl;
    return _react2.default.createElement('div', { style: (0, _objectAssign2.default)({}, style, { backgroundImage: 'url(' + iconUrl + ')' }) });
};

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _objectAssign = __webpack_require__(77);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _SweetAlertStyles = __webpack_require__(106);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Buttons = function (_React$Component) {
    _inherits(Buttons, _React$Component);

    function Buttons() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Buttons);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Buttons.__proto__ || Object.getPrototypeOf(Buttons)).call.apply(_ref, [this].concat(args))), _this), _this.buttonStyles = {}, _this.getButtonStyle = function (bsStyle) {
            if (bsStyle === 'error') bsStyle = 'danger';
            if (_this.buttonStyles[bsStyle] == null) {
                var style = Buttons.styles[bsStyle] || Buttons.styles.default;
                var borderColor = 'borderColor: ' + style.borderColor + ' !important';
                var boxShadow = 'boxShadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px ' + style.shadowColor + ' !important;';
                _this.buttonStyles[bsStyle] = ' ' + borderColor + ' ' + boxShadow;
            }
            return _this.buttonStyles[bsStyle];
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Buttons, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.focusButton();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            var _this2 = this;

            // when displaying back to back alerts React will treat this
            // as an update to the same alert. this causes componentDidMount
            // to not be called for the subsequent alerts. i hope to find a better
            // way to handle this in the future, but for now i'm checking if the
            // title, type, or button text has changed
            if (prevProps.type !== this.props.type || prevProps.confirmBtnText !== this.props.confirmBtnText || prevProps.title !== this.props.title) {
                setTimeout(function () {
                    return _this2.focusButton();
                }, 0);
            }
        }
    }, {
        key: 'focusButton',
        value: function focusButton() {
            if (this.props.focusConfirmBtn && this.refs.confirmBtn) {
                try {
                    this.refs.confirmBtn.focus();
                } catch (e) {
                    // whoops
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.props.showConfirm && !this.props.showCancel) {
                return false;
            }
            var cancelBtnBsStyle = this.props.cancelBtnBsStyle === 'error' ? 'danger' : this.props.cancelBtnBsStyle;
            var confirmBtnBsStyle = this.props.confirmBtnBsStyle === 'error' ? 'danger' : this.props.confirmBtnBsStyle;
            return _react2.default.createElement(
                'p',
                { style: { marginTop: 20 } },
                this.props.showCancel && _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(
                        'style',
                        { type: 'text/css', scoped: true },
                        'button { outline: 0 !important; ' + this.getButtonStyle(cancelBtnBsStyle) + '}'
                    ),
                    _react2.default.createElement(
                        'button',
                        {
                            style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.button, this.props.cancelBtnStyle),
                            className: 'btn btn-' + this.props.btnSize + ' btn-' + cancelBtnBsStyle + ' ' + this.props.cancelBtnCssClass,
                            onClick: this.props.onCancel,
                            type: 'button' },
                        this.props.cancelBtnText
                    )
                ),
                this.props.showConfirm && _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(
                        'style',
                        { type: 'text/css', scoped: true },
                        'button { outline: 0 !important; ' + this.getButtonStyle(confirmBtnBsStyle) + '}'
                    ),
                    _react2.default.createElement(
                        'button',
                        {
                            ref: 'confirmBtn',
                            disabled: this.props.disabled,
                            style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.button, this.props.confirmBtnStyle),
                            className: 'btn btn-' + this.props.btnSize + ' btn-' + confirmBtnBsStyle + ' ' + this.props.confirmBtnCssClass,
                            onClick: this.props.onConfirm,
                            type: 'button' },
                        this.props.confirmBtnText
                    )
                )
            );
        }
    }]);

    return Buttons;
}(_react2.default.Component);

Buttons.propTypes = {
    confirmBtnText: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
    confirmBtnBsStyle: _propTypes2.default.oneOf(['default', 'primary', 'link', 'info', 'success', 'warning', 'danger']),
    confirmBtnCssClass: _propTypes2.default.string,
    confirmBtnStyle: _propTypes2.default.object,
    cancelBtnText: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
    cancelBtnBsStyle: _propTypes2.default.oneOf(['default', 'primary', 'link', 'info', 'success', 'warning', 'danger']),
    cancelBtnCssClass: _propTypes2.default.string,
    cancelBtnStyle: _propTypes2.default.object,
    btnSize: _propTypes2.default.string,
    onCancel: _propTypes2.default.func,
    onConfirm: _propTypes2.default.func,
    showConfirm: _propTypes2.default.bool,
    showCancel: _propTypes2.default.bool,
    focusConfirmBtn: _propTypes2.default.bool
};
Buttons.defaultProps = {
    confirmBtnText: 'OK',
    confirmBtnBsStyle: 'primary',
    confirmBtnCssClass: '',
    confirmBtnStyle: {},
    cancelBtnText: 'Cancel',
    cancelBtnBsStyle: 'link',
    cancelBtnCssClass: '',
    cancelBtnStyle: {},
    focusConfirmBtn: true,
    showConfirm: true,
    showCancel: false,
    btnSize: 'lg'
};
Buttons.styles = {
    primary: {
        borderColor: '#286090',
        shadowColor: 'rgb(165, 202, 234)'
    },
    success: {
        borderColor: '#4cae4c',
        shadowColor: 'rgba(76, 174, 76, 0.6)'
    },
    info: {
        borderColor: '#46b8da',
        shadowColor: 'rgba(70, 184, 218, 0.6)'
    },
    danger: {
        borderColor: '#d43f3a',
        shadowColor: 'rgba(212, 63, 58, 0.6)'
    },
    warning: {
        borderColor: '#eea236',
        shadowColor: 'rgba(238, 162, 54, 0.6)'
    },
    default: {
        borderColor: '#cccccc',
        shadowColor: 'rgba(204, 204, 204, 0.6)'
    }
};
exports.default = Buttons;

/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(77);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _SweetAlertStyles = __webpack_require__(106);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Input = function (_React$Component) {
	_inherits(Input, _React$Component);

	function Input() {
		_classCallCheck(this, Input);

		return _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).apply(this, arguments));
	}

	_createClass(Input, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (this.props.type === 'input') {
				try {
					this.refs.input.focus();
				} catch (e) {
					// whoops
				}
			}
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				{ style: { position: 'relative' } },
				this.props.inputType === 'textarea' ? _react2.default.createElement('textarea', {
					ref: 'input',
					rows: 4,
					className: 'form-control',
					value: this.props.inputValue || '',
					onChange: this.props.onChangeInput,
					onKeyDown: this.props.onInputKeyDown,
					placeholder: this.props.placeholder }) : _react2.default.createElement('input', {
					type: this.props.inputType,
					ref: 'input',
					className: 'form-control',
					value: this.props.inputValue || '',
					onChange: this.props.onChangeInput,
					onKeyDown: this.props.onInputKeyDown,
					placeholder: this.props.placeholder }),
				this.props.showValidationMessage && _react2.default.createElement(
					'div',
					{ style: _SweetAlertStyles2.default.inputErrorIcon },
					_react2.default.createElement('div', { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.inputErrorIconBeforeAfter, _SweetAlertStyles2.default.inputErrorIconBefore) }),
					_react2.default.createElement('div', { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.inputErrorIconBeforeAfter, _SweetAlertStyles2.default.inputErrorIconAfter) })
				)
			);
		}
	}]);

	return Input;
}(_react2.default.Component);

exports.default = Input;

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SweetAlertStyles = __webpack_require__(106);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultMessage = 'Please enter a response!';
var emailMessage = 'Please enter a valid email!';

exports.default = function (_ref) {
    var validationMsg = _ref.validationMsg,
        inputType = _ref.inputType;

    var message = validationMsg || (inputType === 'email' ? emailMessage : defaultMessage);

    return _react2.default.createElement(
        'div',
        { style: _SweetAlertStyles2.default.validationMessage },
        _react2.default.createElement(
            'div',
            { style: _SweetAlertStyles2.default.exclamationIcon },
            '!'
        ),
        message
    );
};

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'h2',
    null,
    children
  );
};

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
    var children = _ref.children;
    return _react2.default.createElement(
        'div',
        { className: 'text-muted lead' },
        children
    );
};

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransitionGroup = __webpack_require__(1784);

var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);

var _TransitionGroup = __webpack_require__(804);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  TransitionGroup: _TransitionGroup2.default,
  CSSTransitionGroup: _CSSTransitionGroup2.default
};

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(804);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _CSSTransitionGroupChild = __webpack_require__(1788);

var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);

var _PropTypes = __webpack_require__(805);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  transitionName: _PropTypes.nameShape.isRequired,

  transitionAppear: _propTypes2.default.bool,
  transitionEnter: _propTypes2.default.bool,
  transitionLeave: _propTypes2.default.bool,
  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
};

var defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true
};

var CSSTransitionGroup = function (_React$Component) {
  _inherits(CSSTransitionGroup, _React$Component);

  function CSSTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
        name: _this.props.transitionName,
        appear: _this.props.transitionAppear,
        enter: _this.props.transitionEnter,
        leave: _this.props.transitionLeave,
        appearTimeout: _this.props.transitionAppearTimeout,
        enterTimeout: _this.props.transitionEnterTimeout,
        leaveTimeout: _this.props.transitionLeaveTimeout
      }, child);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // We need to provide this childFactory so that
  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
  // leave while it is leaving.


  CSSTransitionGroup.prototype.render = function render() {
    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
  };

  return CSSTransitionGroup;
}(_react2.default.Component);

CSSTransitionGroup.displayName = 'CSSTransitionGroup';


CSSTransitionGroup.propTypes =  false ? propTypes : {};
CSSTransitionGroup.defaultProps = defaultProps;

exports.default = CSSTransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 1785 */
/***/ (function(module, exports) {


module.exports = function chain(){
  var len = arguments.length
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i]

  args = args.filter(function(fn){ return fn != null })

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
}


/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _addClass = __webpack_require__(442);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(443);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _requestAnimationFrame = __webpack_require__(882);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _properties = __webpack_require__(883);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(35);

var _PropTypes = __webpack_require__(805);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var events = [];
if (_properties.transitionEnd) events.push(_properties.transitionEnd);
if (_properties.animationEnd) events.push(_properties.animationEnd);

function addEndListener(node, listener) {
  if (events.length) {
    events.forEach(function (e) {
      return node.addEventListener(e, listener, false);
    });
  } else {
    setTimeout(listener, 0);
  }

  return function () {
    if (!events.length) return;
    events.forEach(function (e) {
      return node.removeEventListener(e, listener, false);
    });
  };
}

var propTypes = {
  children: _propTypes2.default.node,
  name: _PropTypes.nameShape.isRequired,

  // Once we require timeouts to be specified, we can remove the
  // boolean flags (appear etc.) and just accept a number
  // or a bool for the timeout flags (appearTimeout etc.)
  appear: _propTypes2.default.bool,
  enter: _propTypes2.default.bool,
  leave: _propTypes2.default.bool,
  appearTimeout: _propTypes2.default.number,
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};

var CSSTransitionGroupChild = function (_React$Component) {
  _inherits(CSSTransitionGroupChild, _React$Component);

  function CSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
    var node = (0, _reactDom.findDOMNode)(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timer = null;
    var removeListeners = void 0;

    (0, _addClass2.default)(node, className);

    // Need to do this to actually trigger a transition.
    this.queueClassAndNode(activeClassName, node);

    // Clean-up the animation after the specified delay
    var finish = function finish(e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timer);
      if (removeListeners) removeListeners();

      (0, _removeClass2.default)(node, className);
      (0, _removeClass2.default)(node, activeClassName);

      if (removeListeners) removeListeners();

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (finishCallback) {
        finishCallback();
      }
    };

    if (timeout) {
      timer = setTimeout(finish, timeout);
      this.transitionTimeouts.push(timer);
    } else if (_properties.transitionEnd) {
      removeListeners = addEndListener(node, finish);
    }
  };

  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
    var _this2 = this;

    this.classNameAndNodeQueue.push({
      className: className,
      node: node
    });

    if (!this.rafHandle) {
      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
        return _this2.flushClassNameAndNodeQueue();
      });
    }
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
    if (!this.unmounted) {
      this.classNameAndNodeQueue.forEach(function (obj) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        /* eslint-disable no-unused-expressions */
        obj.node.scrollTop;
        /* eslint-enable no-unused-expressions */
        (0, _addClass2.default)(obj.node, obj.className);
      });
    }
    this.classNameAndNodeQueue.length = 0;
    this.rafHandle = null;
  };

  CSSTransitionGroupChild.prototype.render = function render() {
    var props = _extends({}, this.props);
    delete props.name;
    delete props.appear;
    delete props.enter;
    delete props.leave;
    delete props.appearTimeout;
    delete props.enterTimeout;
    delete props.leaveTimeout;
    delete props.children;
    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
  };

  return CSSTransitionGroupChild;
}(_react2.default.Component);

CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';


CSSTransitionGroupChild.propTypes =  false ? propTypes : {};

exports.default = CSSTransitionGroupChild;
module.exports = exports['default'];

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Notification = function (_React$Component) {
  _inherits(Notification, _React$Component);

  function Notification() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Notification);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Notification.__proto__ || Object.getPrototypeOf(Notification)).call.apply(_ref, [this].concat(args))), _this), _this.componentDidMount = function () {
      var timeOut = _this.props.timeOut;

      if (timeOut !== 0) {
        _this.timer = setTimeout(_this.requestHide, timeOut);
      }
    }, _this.componentWillUnmount = function () {
      if (_this.timer) {
        clearTimeout(_this.timer);
      }
    }, _this.handleClick = function () {
      var onClick = _this.props.onClick;

      if (onClick) {
        onClick();
      }
      _this.requestHide();
    }, _this.requestHide = function () {
      var onRequestHide = _this.props.onRequestHide;

      if (onRequestHide) {
        onRequestHide();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Notification, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          type = _props.type,
          message = _props.message;
      var title = this.props.title;

      var className = (0, _classnames2.default)(['notification', 'notification-' + type]);
      title = title ? _react2.default.createElement(
        'h4',
        { className: 'title' },
        title
      ) : null;
      return _react2.default.createElement(
        'div',
        { className: className, onClick: this.handleClick },
        _react2.default.createElement(
          'div',
          { className: 'notification-message', role: 'alert' },
          title,
          _react2.default.createElement(
            'div',
            { className: 'message' },
            message
          )
        )
      );
    }
  }]);

  return Notification;
}(_react2.default.Component);

Notification.propTypes = {
  type: _propTypes2.default.oneOf(['info', 'success', 'warning', 'error']),
  title: _propTypes2.default.node,
  message: _propTypes2.default.node.isRequired,
  timeOut: _propTypes2.default.number,
  onClick: _propTypes2.default.func,
  onRequestHide: _propTypes2.default.func
};
Notification.defaultProps = {
  type: 'info',
  title: null,
  message: null,
  timeOut: 5000,
  onClick: function onClick() {},
  onRequestHide: function onRequestHide() {}
};
exports.default = Notification;
module.exports = exports['default'];

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _NotificationManager = __webpack_require__(806);

var _NotificationManager2 = _interopRequireDefault(_NotificationManager);

var _Notifications = __webpack_require__(803);

var _Notifications2 = _interopRequireDefault(_Notifications);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NotificationContainer = function (_React$Component) {
  _inherits(NotificationContainer, _React$Component);

  function NotificationContainer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NotificationContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NotificationContainer.__proto__ || Object.getPrototypeOf(NotificationContainer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      notifications: []
    }, _this.componentWillMount = function () {
      _NotificationManager2.default.addChangeListener(_this.handleStoreChange);
    }, _this.componentWillUnmount = function () {
      _NotificationManager2.default.removeChangeListener(_this.handleStoreChange);
    }, _this.handleStoreChange = function (notifications) {
      _this.setState({
        notifications: notifications
      });
    }, _this.handleRequestHide = function (notification) {
      _NotificationManager2.default.remove(notification);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NotificationContainer, [{
    key: 'render',
    value: function render() {
      var notifications = this.state.notifications;
      var _props = this.props,
          enterTimeout = _props.enterTimeout,
          leaveTimeout = _props.leaveTimeout;

      return _react2.default.createElement(_Notifications2.default, {
        enterTimeout: enterTimeout,
        leaveTimeout: leaveTimeout,
        notifications: notifications,
        onRequestHide: this.handleRequestHide
      });
    }
  }]);

  return NotificationContainer;
}(_react2.default.Component);

NotificationContainer.propTypes = {
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};
NotificationContainer.defaultProps = {
  enterTimeout: 400,
  leaveTimeout: 400
};
exports.default = NotificationContainer;
module.exports = exports['default'];

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRouterDom = __webpack_require__(13);

var _asyncComponent = _interopRequireDefault(__webpack_require__(44));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Table = function Table(_ref) {
  var match = _ref.match;
  return _react["default"].createElement("div", {
    className: "app-wrapper"
  }, _react["default"].createElement(_reactRouterDom.Switch, null, _react["default"].createElement(_reactRouterDom.Redirect, {
    exact: true,
    from: "".concat(match.url, "/"),
    to: "".concat(match.url, "/basic")
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/basic"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 2038));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/data"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 2039));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 39));
    })
  })));
};

var _default = Table;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Table, "Table", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/table/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/table/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/table/index.js");

  __REACT_HOT_LOADER__.register(_asyncComponent, "_asyncComponent", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/table/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/table/index.js");

  __REACT_HOT_LOADER__.register(Table, "Table", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/table/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/table/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/table/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/table/index.js");
}();

;

/***/ }),
/* 1792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* harmony default export */ __webpack_exports__["a"] = (function (Base) {
  return function (_Base) {
    _inherits(_class, _Base);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'UNSAFE_componentWillMount',
      value: function UNSAFE_componentWillMount() {
        this.setStateWithData(this.getDataModel(this.getResolvedState(), true));
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.fireFetchData();
      }
    }, {
      key: 'UNSAFE_componentWillReceiveProps',
      value: function UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        var oldState = this.getResolvedState();
        var newState = this.getResolvedState(nextProps, nextState);

        // Do a deep compare of new and old `defaultOption` and
        // if they are different reset `option = defaultOption`
        var defaultableOptions = ['sorted', 'filtered', 'resized', 'expanded'];
        defaultableOptions.forEach(function (x) {
          var defaultName = 'default' + (x.charAt(0).toUpperCase() + x.slice(1));
          if (JSON.stringify(oldState[defaultName]) !== JSON.stringify(newState[defaultName])) {
            newState[x] = newState[defaultName];
          }
        });

        // If they change these table options, we need to reset defaults
        // or else we could get into a state where the user has changed the UI
        // and then disabled the ability to change it back.
        // e.g. If `filterable` has changed, set `filtered = defaultFiltered`
        var resettableOptions = ['sortable', 'filterable', 'resizable'];
        resettableOptions.forEach(function (x) {
          if (oldState[x] !== newState[x]) {
            var baseName = x.replace('able', '');
            var optionName = baseName + 'ed';
            var defaultName = 'default' + (optionName.charAt(0).toUpperCase() + optionName.slice(1));
            newState[optionName] = newState[defaultName];
          }
        });

        // Props that trigger a data update
        if (oldState.data !== newState.data || oldState.columns !== newState.columns || oldState.pivotBy !== newState.pivotBy || oldState.sorted !== newState.sorted || oldState.filtered !== newState.filtered) {
          this.setStateWithData(this.getDataModel(newState, oldState.data !== newState.data));
        }
      }
    }, {
      key: 'setStateWithData',
      value: function setStateWithData(newState, cb) {
        var _this2 = this;

        var oldState = this.getResolvedState();
        var newResolvedState = this.getResolvedState({}, newState);
        var freezeWhenExpanded = newResolvedState.freezeWhenExpanded;

        // Default to unfrozen state

        newResolvedState.frozen = false;

        // If freezeWhenExpanded is set, check for frozen conditions
        if (freezeWhenExpanded) {
          // if any rows are expanded, freeze the existing data and sorting
          var keys = Object.keys(newResolvedState.expanded);
          for (var i = 0; i < keys.length; i += 1) {
            if (newResolvedState.expanded[keys[i]]) {
              newResolvedState.frozen = true;
              break;
            }
          }
        }

        // If the data isn't frozen and either the data or
        // sorting model has changed, update the data
        if (oldState.frozen && !newResolvedState.frozen || oldState.sorted !== newResolvedState.sorted || oldState.filtered !== newResolvedState.filtered || oldState.showFilters !== newResolvedState.showFilters || !newResolvedState.frozen && oldState.resolvedData !== newResolvedState.resolvedData) {
          // Handle collapseOnsortedChange & collapseOnDataChange
          if (oldState.sorted !== newResolvedState.sorted && this.props.collapseOnSortingChange || oldState.filtered !== newResolvedState.filtered || oldState.showFilters !== newResolvedState.showFilters || oldState.sortedData && !newResolvedState.frozen && oldState.resolvedData !== newResolvedState.resolvedData && this.props.collapseOnDataChange) {
            newResolvedState.expanded = {};
          }

          Object.assign(newResolvedState, this.getSortedData(newResolvedState));
        }

        // Set page to 0 if filters change
        if (oldState.filtered !== newResolvedState.filtered) {
          newResolvedState.page = 0;
        }

        // Calculate pageSize all the time
        if (newResolvedState.sortedData) {
          newResolvedState.pages = newResolvedState.manual ? newResolvedState.pages : Math.ceil(newResolvedState.sortedData.length / newResolvedState.pageSize);
          newResolvedState.page = newResolvedState.manual ? newResolvedState.page : Math.max(newResolvedState.page >= newResolvedState.pages ? newResolvedState.pages - 1 : newResolvedState.page, 0);
        }

        return this.setState(newResolvedState, function () {
          if (cb) {
            cb();
          }
          if (oldState.page !== newResolvedState.page || oldState.pageSize !== newResolvedState.pageSize || oldState.sorted !== newResolvedState.sorted || oldState.filtered !== newResolvedState.filtered) {
            _this2.fireFetchData();
          }
        });
      }
    }]);

    return _class;
  }(Base);
});
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(418);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




/* harmony default export */ __webpack_exports__["a"] = (function (Base) {
  return function (_Base) {
    _inherits(_class, _Base);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'getResolvedState',
      value: function getResolvedState(props, state) {
        var resolvedState = _extends({}, __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].compactObject(this.state), __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].compactObject(this.props), __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].compactObject(state), __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].compactObject(props));
        return resolvedState;
      }
    }, {
      key: 'getDataModel',
      value: function getDataModel(newState, dataChanged) {
        var _this2 = this;

        var columns = newState.columns,
            _newState$pivotBy = newState.pivotBy,
            pivotBy = _newState$pivotBy === undefined ? [] : _newState$pivotBy,
            data = newState.data,
            resolveData = newState.resolveData,
            pivotIDKey = newState.pivotIDKey,
            pivotValKey = newState.pivotValKey,
            subRowsKey = newState.subRowsKey,
            aggregatedKey = newState.aggregatedKey,
            nestingLevelKey = newState.nestingLevelKey,
            originalKey = newState.originalKey,
            indexKey = newState.indexKey,
            groupedByPivotKey = newState.groupedByPivotKey,
            SubComponent = newState.SubComponent;

        // Determine Header Groups

        var hasHeaderGroups = false;
        columns.forEach(function (column) {
          if (column.columns) {
            hasHeaderGroups = true;
          }
        });

        var columnsWithExpander = [].concat(_toConsumableArray(columns));

        var expanderColumn = columns.find(function (col) {
          return col.expander || col.columns && col.columns.some(function (col2) {
            return col2.expander;
          });
        });
        // The actual expander might be in the columns field of a group column
        if (expanderColumn && !expanderColumn.expander) {
          expanderColumn = expanderColumn.columns.find(function (col) {
            return col.expander;
          });
        }

        // If we have SubComponent's we need to make sure we have an expander column
        if (SubComponent && !expanderColumn) {
          expanderColumn = { expander: true };
          columnsWithExpander = [expanderColumn].concat(_toConsumableArray(columnsWithExpander));
        }

        var makeDecoratedColumn = function makeDecoratedColumn(column, parentColumn) {
          var dcol = void 0;
          if (column.expander) {
            dcol = _extends({}, _this2.props.column, _this2.props.expanderDefaults, column);
          } else {
            dcol = _extends({}, _this2.props.column, column);
          }

          // Ensure minWidth is not greater than maxWidth if set
          if (dcol.maxWidth < dcol.minWidth) {
            dcol.minWidth = dcol.maxWidth;
          }

          if (parentColumn) {
            dcol.parentColumn = parentColumn;
          }

          // First check for string accessor
          if (typeof dcol.accessor === 'string') {
            dcol.id = dcol.id || dcol.accessor;
            var accessorString = dcol.accessor;
            dcol.accessor = function (row) {
              return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].get(row, accessorString);
            };
            return dcol;
          }

          // Fall back to functional accessor (but require an ID)
          if (dcol.accessor && !dcol.id) {
            console.warn(dcol);
            throw new Error('A column id is required if using a non-string accessor for column above.');
          }

          // Fall back to an undefined accessor
          if (!dcol.accessor) {
            dcol.accessor = function () {
              return undefined;
            };
          }

          return dcol;
        };

        var allDecoratedColumns = [];

        // Decorate the columns
        var decorateAndAddToAll = function decorateAndAddToAll(column, parentColumn) {
          var decoratedColumn = makeDecoratedColumn(column, parentColumn);
          allDecoratedColumns.push(decoratedColumn);
          return decoratedColumn;
        };

        var decoratedColumns = columnsWithExpander.map(function (column) {
          if (column.columns) {
            return _extends({}, column, {
              columns: column.columns.map(function (d) {
                return decorateAndAddToAll(d, column);
              })
            });
          }
          return decorateAndAddToAll(column);
        });

        // Build the visible columns, headers and flat column list
        var visibleColumns = decoratedColumns.slice();
        var allVisibleColumns = [];

        visibleColumns = visibleColumns.map(function (column) {
          if (column.columns) {
            var visibleSubColumns = column.columns.filter(function (d) {
              return pivotBy.indexOf(d.id) > -1 ? false : __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].getFirstDefined(d.show, true);
            });
            return _extends({}, column, {
              columns: visibleSubColumns
            });
          }
          return column;
        });

        visibleColumns = visibleColumns.filter(function (column) {
          return column.columns ? column.columns.length : pivotBy.indexOf(column.id) > -1 ? false : __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].getFirstDefined(column.show, true);
        });

        // Find any custom pivot location
        var pivotIndex = visibleColumns.findIndex(function (col) {
          return col.pivot;
        });

        // Handle Pivot Columns
        if (pivotBy.length) {
          // Retrieve the pivot columns in the correct pivot order
          var pivotColumns = [];
          pivotBy.forEach(function (pivotID) {
            var found = allDecoratedColumns.find(function (d) {
              return d.id === pivotID;
            });
            if (found) {
              pivotColumns.push(found);
            }
          });

          var PivotParentColumn = pivotColumns.reduce(function (prev, current) {
            return prev && prev === current.parentColumn && current.parentColumn;
          }, pivotColumns[0].parentColumn);

          var PivotGroupHeader = hasHeaderGroups && PivotParentColumn.Header;
          PivotGroupHeader = PivotGroupHeader || function () {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              null,
              'Pivoted'
            );
          };

          var pivotColumnGroup = {
            Header: PivotGroupHeader,
            columns: pivotColumns.map(function (col) {
              return _extends({}, _this2.props.pivotDefaults, col, {
                pivoted: true
              });
            })

            // Place the pivotColumns back into the visibleColumns
          };if (pivotIndex >= 0) {
            pivotColumnGroup = _extends({}, visibleColumns[pivotIndex], pivotColumnGroup);
            visibleColumns.splice(pivotIndex, 1, pivotColumnGroup);
          } else {
            visibleColumns.unshift(pivotColumnGroup);
          }
        }

        // Build Header Groups
        var headerGroups = [];
        var currentSpan = [];

        // A convenience function to add a header and reset the currentSpan
        var addHeader = function addHeader(columns, column) {
          headerGroups.push(_extends({}, _this2.props.column, column, {
            columns: columns
          }));
          currentSpan = [];
        };

        // Build flast list of allVisibleColumns and HeaderGroups
        visibleColumns.forEach(function (column) {
          if (column.columns) {
            allVisibleColumns = allVisibleColumns.concat(column.columns);
            if (currentSpan.length > 0) {
              addHeader(currentSpan);
            }
            addHeader(column.columns, column);
            return;
          }
          allVisibleColumns.push(column);
          currentSpan.push(column);
        });
        if (hasHeaderGroups && currentSpan.length > 0) {
          addHeader(currentSpan);
        }

        // Access the data
        var accessRow = function accessRow(d, i) {
          var _row;

          var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

          var row = (_row = {}, _defineProperty(_row, originalKey, d), _defineProperty(_row, indexKey, i), _defineProperty(_row, subRowsKey, d[subRowsKey]), _defineProperty(_row, nestingLevelKey, level), _row);
          allDecoratedColumns.forEach(function (column) {
            if (column.expander) return;
            row[column.id] = column.accessor(d);
          });
          if (row[subRowsKey]) {
            row[subRowsKey] = row[subRowsKey].map(function (d, i) {
              return accessRow(d, i, level + 1);
            });
          }
          return row;
        };

        // // If the data hasn't changed, just use the cached data
        var resolvedData = this.resolvedData;
        // If the data has changed, run the data resolver and cache the result
        if (!this.resolvedData || dataChanged) {
          resolvedData = resolveData(data);
          this.resolvedData = resolvedData;
        }
        // Use the resolved data
        resolvedData = resolvedData.map(function (d, i) {
          return accessRow(d, i);
        });

        // TODO: Make it possible to fabricate nested rows without pivoting
        var aggregatingColumns = allVisibleColumns.filter(function (d) {
          return !d.expander && d.aggregate;
        });

        // If pivoting, recursively group the data
        var aggregate = function aggregate(rows) {
          var aggregationValues = {};
          aggregatingColumns.forEach(function (column) {
            var values = rows.map(function (d) {
              return d[column.id];
            });
            aggregationValues[column.id] = column.aggregate(values, rows);
          });
          return aggregationValues;
        };
        if (pivotBy.length) {
          var groupRecursively = function groupRecursively(rows, keys) {
            var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

            // This is the last level, just return the rows
            if (i === keys.length) {
              return rows;
            }
            // Group the rows together for this level
            var groupedRows = Object.entries(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].groupBy(rows, keys[i])).map(function (_ref) {
              var _ref3;

              var _ref2 = _slicedToArray(_ref, 2),
                  key = _ref2[0],
                  value = _ref2[1];

              return _ref3 = {}, _defineProperty(_ref3, pivotIDKey, keys[i]), _defineProperty(_ref3, pivotValKey, key), _defineProperty(_ref3, keys[i], key), _defineProperty(_ref3, subRowsKey, value), _defineProperty(_ref3, nestingLevelKey, i), _defineProperty(_ref3, groupedByPivotKey, true), _ref3;
            });
            // Recurse into the subRows
            groupedRows = groupedRows.map(function (rowGroup) {
              var _extends2;

              var subRows = groupRecursively(rowGroup[subRowsKey], keys, i + 1);
              return _extends({}, rowGroup, (_extends2 = {}, _defineProperty(_extends2, subRowsKey, subRows), _defineProperty(_extends2, aggregatedKey, true), _extends2), aggregate(subRows));
            });
            return groupedRows;
          };
          resolvedData = groupRecursively(resolvedData, pivotBy);
        }

        return _extends({}, newState, {
          resolvedData: resolvedData,
          allVisibleColumns: allVisibleColumns,
          headerGroups: headerGroups,
          allDecoratedColumns: allDecoratedColumns,
          hasHeaderGroups: hasHeaderGroups
        });
      }
    }, {
      key: 'getSortedData',
      value: function getSortedData(resolvedState) {
        var manual = resolvedState.manual,
            sorted = resolvedState.sorted,
            filtered = resolvedState.filtered,
            defaultFilterMethod = resolvedState.defaultFilterMethod,
            resolvedData = resolvedState.resolvedData,
            allDecoratedColumns = resolvedState.allDecoratedColumns;


        var sortMethodsByColumnID = {};

        allDecoratedColumns.filter(function (col) {
          return col.sortMethod;
        }).forEach(function (col) {
          sortMethodsByColumnID[col.id] = col.sortMethod;
        });

        // Resolve the data from either manual data or sorted data
        return {
          sortedData: manual ? resolvedData : this.sortData(this.filterData(resolvedData, filtered, defaultFilterMethod, allDecoratedColumns), sorted, sortMethodsByColumnID)
        };
      }
    }, {
      key: 'fireFetchData',
      value: function fireFetchData() {
        // determine the current state, preferring certain state values over props
        var currentState = _extends({}, this.getResolvedState(), {
          page: this.getStateOrProp('page'),
          pageSize: this.getStateOrProp('pageSize'),
          filtered: this.getStateOrProp('filtered')
        });

        this.props.onFetchData(currentState, this);
      }
    }, {
      key: 'getPropOrState',
      value: function getPropOrState(key) {
        return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].getFirstDefined(this.props[key], this.state[key]);
      }
    }, {
      key: 'getStateOrProp',
      value: function getStateOrProp(key) {
        return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].getFirstDefined(this.state[key], this.props[key]);
      }
    }, {
      key: 'filterData',
      value: function filterData(data, filtered, defaultFilterMethod, allVisibleColumns) {
        var _this3 = this;

        var filteredData = data;

        if (filtered.length) {
          filteredData = filtered.reduce(function (filteredSoFar, nextFilter) {
            var column = allVisibleColumns.find(function (x) {
              return x.id === nextFilter.id;
            });

            // Don't filter hidden columns or columns that have had their filters disabled
            if (!column || column.filterable === false) {
              return filteredSoFar;
            }

            var filterMethod = column.filterMethod || defaultFilterMethod;

            // If 'filterAll' is set to true, pass the entire dataset to the filter method
            if (column.filterAll) {
              return filterMethod(nextFilter, filteredSoFar, column);
            }
            return filteredSoFar.filter(function (row) {
              return filterMethod(nextFilter, row, column);
            });
          }, filteredData);

          // Apply the filter to the subrows if we are pivoting, and then
          // filter any rows without subcolumns because it would be strange to show
          filteredData = filteredData.map(function (row) {
            if (!row[_this3.props.subRowsKey]) {
              return row;
            }
            return _extends({}, row, _defineProperty({}, _this3.props.subRowsKey, _this3.filterData(row[_this3.props.subRowsKey], filtered, defaultFilterMethod, allVisibleColumns)));
          }).filter(function (row) {
            if (!row[_this3.props.subRowsKey]) {
              return true;
            }
            return row[_this3.props.subRowsKey].length > 0;
          });
        }

        return filteredData;
      }
    }, {
      key: 'sortData',
      value: function sortData(data, sorted) {
        var _this4 = this;

        var sortMethodsByColumnID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        if (!sorted.length) {
          return data;
        }

        var sortedData = (this.props.orderByMethod || __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].orderBy)(data, sorted.map(function (sort) {
          // Support custom sorting methods for each column
          if (sortMethodsByColumnID[sort.id]) {
            return function (a, b) {
              return sortMethodsByColumnID[sort.id](a[sort.id], b[sort.id], sort.desc);
            };
          }
          return function (a, b) {
            return _this4.props.defaultSortMethod(a[sort.id], b[sort.id], sort.desc);
          };
        }), sorted.map(function (d) {
          return !d.desc;
        }), this.props.indexKey);

        sortedData.forEach(function (row) {
          if (!row[_this4.props.subRowsKey]) {
            return;
          }
          row[_this4.props.subRowsKey] = _this4.sortData(row[_this4.props.subRowsKey], sorted, sortMethodsByColumnID);
        });

        return sortedData;
      }
    }, {
      key: 'getMinRows',
      value: function getMinRows() {
        return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].getFirstDefined(this.props.minRows, this.getStateOrProp('pageSize'));
      }

      // User actions

    }, {
      key: 'onPageChange',
      value: function onPageChange(page) {
        var _props = this.props,
            onPageChange = _props.onPageChange,
            collapseOnPageChange = _props.collapseOnPageChange;


        var newState = { page: page };
        if (collapseOnPageChange) {
          newState.expanded = {};
        }
        this.setStateWithData(newState, function () {
          return onPageChange && onPageChange(page);
        });
      }
    }, {
      key: 'onPageSizeChange',
      value: function onPageSizeChange(newPageSize) {
        var onPageSizeChange = this.props.onPageSizeChange;

        var _getResolvedState = this.getResolvedState(),
            pageSize = _getResolvedState.pageSize,
            page = _getResolvedState.page;

        // Normalize the page to display


        var currentRow = pageSize * page;
        var newPage = Math.floor(currentRow / newPageSize);

        this.setStateWithData({
          pageSize: newPageSize,
          page: newPage
        }, function () {
          return onPageSizeChange && onPageSizeChange(newPageSize, newPage);
        });
      }
    }, {
      key: 'sortColumn',
      value: function sortColumn(column, additive) {
        var _getResolvedState2 = this.getResolvedState(),
            sorted = _getResolvedState2.sorted,
            skipNextSort = _getResolvedState2.skipNextSort,
            defaultSortDesc = _getResolvedState2.defaultSortDesc;

        var firstSortDirection = Object.prototype.hasOwnProperty.call(column, 'defaultSortDesc') ? column.defaultSortDesc : defaultSortDesc;
        var secondSortDirection = !firstSortDirection;

        // we can't stop event propagation from the column resize move handlers
        // attached to the document because of react's synthetic events
        // so we have to prevent the sort function from actually sorting
        // if we click on the column resize element within a header.
        if (skipNextSort) {
          this.setStateWithData({
            skipNextSort: false
          });
          return;
        }

        var onSortedChange = this.props.onSortedChange;


        var newSorted = __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].clone(sorted || []).map(function (d) {
          d.desc = __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].isSortingDesc(d);
          return d;
        });
        if (!__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].isArray(column)) {
          // Single-Sort
          var existingIndex = newSorted.findIndex(function (d) {
            return d.id === column.id;
          });
          if (existingIndex > -1) {
            var existing = newSorted[existingIndex];
            if (existing.desc === secondSortDirection) {
              if (additive) {
                newSorted.splice(existingIndex, 1);
              } else {
                existing.desc = firstSortDirection;
                newSorted = [existing];
              }
            } else {
              existing.desc = secondSortDirection;
              if (!additive) {
                newSorted = [existing];
              }
            }
          } else if (additive) {
            newSorted.push({
              id: column.id,
              desc: firstSortDirection
            });
          } else {
            newSorted = [{
              id: column.id,
              desc: firstSortDirection
            }];
          }
        } else {
          // Multi-Sort
          var _existingIndex = newSorted.findIndex(function (d) {
            return d.id === column[0].id;
          });
          // Existing Sorted Column
          if (_existingIndex > -1) {
            var _existing = newSorted[_existingIndex];
            if (_existing.desc === secondSortDirection) {
              if (additive) {
                newSorted.splice(_existingIndex, column.length);
              } else {
                column.forEach(function (d, i) {
                  newSorted[_existingIndex + i].desc = firstSortDirection;
                });
              }
            } else {
              column.forEach(function (d, i) {
                newSorted[_existingIndex + i].desc = secondSortDirection;
              });
            }
            if (!additive) {
              newSorted = newSorted.slice(_existingIndex, column.length);
            }
            // New Sort Column
          } else if (additive) {
            newSorted = newSorted.concat(column.map(function (d) {
              return {
                id: d.id,
                desc: firstSortDirection
              };
            }));
          } else {
            newSorted = column.map(function (d) {
              return {
                id: d.id,
                desc: firstSortDirection
              };
            });
          }
        }

        this.setStateWithData({
          page: !sorted.length && newSorted.length || !additive ? 0 : this.state.page,
          sorted: newSorted
        }, function () {
          return onSortedChange && onSortedChange(newSorted, column, additive);
        });
      }
    }, {
      key: 'filterColumn',
      value: function filterColumn(column, value) {
        var _getResolvedState3 = this.getResolvedState(),
            filtered = _getResolvedState3.filtered;

        var onFilteredChange = this.props.onFilteredChange;

        // Remove old filter first if it exists

        var newFiltering = (filtered || []).filter(function (x) {
          return x.id !== column.id;
        });

        if (value !== '') {
          newFiltering.push({
            id: column.id,
            value: value
          });
        }

        this.setStateWithData({
          filtered: newFiltering
        }, function () {
          return onFilteredChange && onFilteredChange(newFiltering, column, value);
        });
      }
    }, {
      key: 'resizeColumnStart',
      value: function resizeColumnStart(event, column, isTouch) {
        var _this5 = this;

        event.stopPropagation();
        var parentWidth = event.target.parentElement.getBoundingClientRect().width;

        var pageX = void 0;
        if (isTouch) {
          pageX = event.changedTouches[0].pageX;
        } else {
          pageX = event.pageX;
        }

        this.trapEvents = true;
        this.setStateWithData({
          currentlyResizing: {
            id: column.id,
            startX: pageX,
            parentWidth: parentWidth
          }
        }, function () {
          if (isTouch) {
            document.addEventListener('touchmove', _this5.resizeColumnMoving);
            document.addEventListener('touchcancel', _this5.resizeColumnEnd);
            document.addEventListener('touchend', _this5.resizeColumnEnd);
          } else {
            document.addEventListener('mousemove', _this5.resizeColumnMoving);
            document.addEventListener('mouseup', _this5.resizeColumnEnd);
            document.addEventListener('mouseleave', _this5.resizeColumnEnd);
          }
        });
      }
    }, {
      key: 'resizeColumnMoving',
      value: function resizeColumnMoving(event) {
        event.stopPropagation();
        var _props2 = this.props,
            onResizedChange = _props2.onResizedChange,
            column = _props2.column;

        var _getResolvedState4 = this.getResolvedState(),
            resized = _getResolvedState4.resized,
            currentlyResizing = _getResolvedState4.currentlyResizing,
            columns = _getResolvedState4.columns;

        var currentColumn = columns.find(function (c) {
          return c.accessor === currentlyResizing.id || c.id === currentlyResizing.id;
        });
        var minResizeWidth = currentColumn && currentColumn.minResizeWidth != null ? currentColumn.minResizeWidth : column.minResizeWidth;

        // Delete old value
        var newResized = resized.filter(function (x) {
          return x.id !== currentlyResizing.id;
        });

        var pageX = void 0;

        if (event.type === 'touchmove') {
          pageX = event.changedTouches[0].pageX;
        } else if (event.type === 'mousemove') {
          pageX = event.pageX;
        }

        var newWidth = Math.max(currentlyResizing.parentWidth + pageX - currentlyResizing.startX, minResizeWidth);

        newResized.push({
          id: currentlyResizing.id,
          value: newWidth
        });

        this.setStateWithData({
          resized: newResized
        }, function () {
          return onResizedChange && onResizedChange(newResized, event);
        });
      }
    }, {
      key: 'resizeColumnEnd',
      value: function resizeColumnEnd(event) {
        event.stopPropagation();
        var isTouch = event.type === 'touchend' || event.type === 'touchcancel';

        if (isTouch) {
          document.removeEventListener('touchmove', this.resizeColumnMoving);
          document.removeEventListener('touchcancel', this.resizeColumnEnd);
          document.removeEventListener('touchend', this.resizeColumnEnd);
        }

        // If its a touch event clear the mouse one's as well because sometimes
        // the mouseDown event gets called as well, but the mouseUp event doesn't
        document.removeEventListener('mousemove', this.resizeColumnMoving);
        document.removeEventListener('mouseup', this.resizeColumnEnd);
        document.removeEventListener('mouseleave', this.resizeColumnEnd);

        // The touch events don't propagate up to the sorting's onMouseDown event so
        // no need to prevent it from happening or else the first click after a touch
        // event resize will not sort the column.
        if (!isTouch) {
          this.setStateWithData({
            skipNextSort: true,
            currentlyResizing: false
          });
        }
      }
    }]);

    return _class;
  }(Base);
});
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pagination__ = __webpack_require__(1795);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



//



var emptyObj = function emptyObj() {
  return {};
};

/* harmony default export */ __webpack_exports__["a"] = ({
  // General
  data: [],
  resolveData: function resolveData(data) {
    return data;
  },
  loading: false,
  showPagination: true,
  showPaginationTop: false,
  showPaginationBottom: true,
  showPageSizeOptions: true,
  pageSizeOptions: [5, 10, 20, 25, 50, 100],
  defaultPage: 0,
  defaultPageSize: 20,
  showPageJump: true,
  collapseOnSortingChange: true,
  collapseOnPageChange: true,
  collapseOnDataChange: true,
  freezeWhenExpanded: false,
  sortable: true,
  multiSort: true,
  resizable: true,
  filterable: false,
  defaultSortDesc: false,
  defaultSorted: [],
  defaultFiltered: [],
  defaultResized: [],
  defaultExpanded: {},
  // eslint-disable-next-line no-unused-vars
  defaultFilterMethod: function defaultFilterMethod(filter, row, column) {
    var id = filter.pivotId || filter.id;
    return row[id] !== undefined ? String(row[id]).startsWith(filter.value) : true;
  },
  // eslint-disable-next-line no-unused-vars
  defaultSortMethod: function defaultSortMethod(a, b, desc) {
    // force null and undefined to the bottom
    a = a === null || a === undefined ? '' : a;
    b = b === null || b === undefined ? '' : b;
    // force any string values to lowercase
    a = typeof a === 'string' ? a.toLowerCase() : a;
    b = typeof b === 'string' ? b.toLowerCase() : b;
    // Return either 1 or -1 to indicate a sort priority
    if (a > b) {
      return 1;
    }
    if (a < b) {
      return -1;
    }
    // returning 0, undefined or any falsey value will use subsequent sorts or
    // the index as a tiebreaker
    return 0;
  },

  // Controlled State Props
  // page: undefined,
  // pageSize: undefined,
  // sorted: [],
  // filtered: [],
  // resized: [],
  // expanded: {},

  // Controlled State Callbacks
  onPageChange: undefined,
  onPageSizeChange: undefined,
  onSortedChange: undefined,
  onFilteredChange: undefined,
  onResizedChange: undefined,
  onExpandedChange: undefined,

  // Pivoting
  pivotBy: undefined,

  // Key Constants
  pivotValKey: '_pivotVal',
  pivotIDKey: '_pivotID',
  subRowsKey: '_subRows',
  aggregatedKey: '_aggregated',
  nestingLevelKey: '_nestingLevel',
  originalKey: '_original',
  indexKey: '_index',
  groupedByPivotKey: '_groupedByPivot',

  // Server-side Callbacks
  onFetchData: function onFetchData() {
    return null;
  },

  // Classes
  className: '',
  style: {},

  // Component decorators
  getProps: emptyObj,
  getTableProps: emptyObj,
  getTheadGroupProps: emptyObj,
  getTheadGroupTrProps: emptyObj,
  getTheadGroupThProps: emptyObj,
  getTheadProps: emptyObj,
  getTheadTrProps: emptyObj,
  getTheadThProps: emptyObj,
  getTheadFilterProps: emptyObj,
  getTheadFilterTrProps: emptyObj,
  getTheadFilterThProps: emptyObj,
  getTbodyProps: emptyObj,
  getTrGroupProps: emptyObj,
  getTrProps: emptyObj,
  getTdProps: emptyObj,
  getTfootProps: emptyObj,
  getTfootTrProps: emptyObj,
  getTfootTdProps: emptyObj,
  getPaginationProps: emptyObj,
  getLoadingProps: emptyObj,
  getNoDataProps: emptyObj,
  getResizerProps: emptyObj,

  // Global Column Defaults
  column: {
    // Renderers
    Cell: undefined,
    Header: undefined,
    Footer: undefined,
    Aggregated: undefined,
    Pivot: undefined,
    PivotValue: undefined,
    Expander: undefined,
    Filter: undefined,
    Placeholder: undefined,
    // All Columns
    sortable: undefined, // use table default
    resizable: undefined, // use table default
    filterable: undefined, // use table default
    show: true,
    minWidth: 100,
    minResizeWidth: 11,
    // Cells only
    className: '',
    style: {},
    getProps: emptyObj,
    // Pivot only
    aggregate: undefined,
    // Headers only
    headerClassName: '',
    headerStyle: {},
    getHeaderProps: emptyObj,
    // Footers only
    footerClassName: '',
    footerStyle: {},
    getFooterProps: emptyObj,
    filterMethod: undefined,
    filterAll: false,
    sortMethod: undefined
  },

  // Global Expander Column Defaults
  expanderDefaults: {
    sortable: false,
    resizable: false,
    filterable: false,
    width: 35
  },

  pivotDefaults: {
    // extend the defaults for pivoted columns here
  },

  // Text
  previousText: 'Previous',
  nextText: 'Next',
  loadingText: 'Loading...',
  noDataText: 'No rows found',
  pageText: 'Page',
  ofText: 'of',
  rowsText: 'rows',
  pageJumpText: 'jump to page',
  rowsSelectorText: 'rows per page',

  // Components
  TableComponent: function TableComponent(_ref) {
    var children = _ref.children,
        className = _ref.className,
        rest = _objectWithoutProperties(_ref, ['children', 'className']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      _extends({
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('rt-table', className),
        role: 'grid'
        // tabIndex='0'
      }, rest),
      children
    );
  },
  TheadComponent: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].makeTemplateComponent('rt-thead', 'Thead'),
  TbodyComponent: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].makeTemplateComponent('rt-tbody', 'Tbody'),
  TrGroupComponent: function TrGroupComponent(_ref2) {
    var children = _ref2.children,
        className = _ref2.className,
        rest = _objectWithoutProperties(_ref2, ['children', 'className']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      _extends({ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('rt-tr-group', className), role: 'rowgroup' }, rest),
      children
    );
  },
  TrComponent: function TrComponent(_ref3) {
    var children = _ref3.children,
        className = _ref3.className,
        rest = _objectWithoutProperties(_ref3, ['children', 'className']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      _extends({ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('rt-tr', className), role: 'row' }, rest),
      children
    );
  },
  ThComponent: function ThComponent(_ref4) {
    var toggleSort = _ref4.toggleSort,
        className = _ref4.className,
        children = _ref4.children,
        rest = _objectWithoutProperties(_ref4, ['toggleSort', 'className', 'children']);

    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('rt-th', className),
          onClick: function onClick(e) {
            return toggleSort && toggleSort(e);
          },
          role: 'columnheader',
          tabIndex: '-1' // Resolves eslint issues without implementing keyboard navigation incorrectly
        }, rest),
        children
      )
    );
  },
  TdComponent: function TdComponent(_ref5) {
    var toggleSort = _ref5.toggleSort,
        className = _ref5.className,
        children = _ref5.children,
        rest = _objectWithoutProperties(_ref5, ['toggleSort', 'className', 'children']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      _extends({ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('rt-td', className), role: 'gridcell' }, rest),
      children
    );
  },
  TfootComponent: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].makeTemplateComponent('rt-tfoot', 'Tfoot'),
  FilterComponent: function FilterComponent(_ref6) {
    var filter = _ref6.filter,
        _onChange = _ref6.onChange,
        column = _ref6.column;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
      type: 'text',
      style: {
        width: '100%'
      },
      placeholder: column.Placeholder,
      value: filter ? filter.value : '',
      onChange: function onChange(event) {
        return _onChange(event.target.value);
      }
    });
  },
  ExpanderComponent: function ExpanderComponent(_ref7) {
    var isExpanded = _ref7.isExpanded;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('rt-expander', isExpanded && '-open') },
      '\u2022'
    );
  },
  PivotValueComponent: function PivotValueComponent(_ref8) {
    var subRows = _ref8.subRows,
        value = _ref8.value;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      null,
      value,
      ' ',
      subRows && '(' + subRows.length + ')'
    );
  },
  AggregatedComponent: function AggregatedComponent(_ref9) {
    var subRows = _ref9.subRows,
        column = _ref9.column;

    var previewValues = subRows.filter(function (d) {
      return typeof d[column.id] !== 'undefined';
    }).map(function (row, i) {
      return (
        // eslint-disable-next-line react/no-array-index-key
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { key: i },
          row[column.id],
          i < subRows.length - 1 ? ', ' : ''
        )
      );
    });
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      null,
      previewValues
    );
  },
  PivotComponent: undefined, // this is a computed default generated using
  // the ExpanderComponent and PivotValueComponent at run-time in methods.js
  PaginationComponent: __WEBPACK_IMPORTED_MODULE_3__pagination__["a" /* default */],
  PreviousComponent: undefined,
  NextComponent: undefined,
  LoadingComponent: function LoadingComponent(_ref10) {
    var className = _ref10.className,
        loading = _ref10.loading,
        loadingText = _ref10.loadingText,
        rest = _objectWithoutProperties(_ref10, ['className', 'loading', 'loadingText']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      _extends({ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('-loading', { '-active': loading }, className) }, rest),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: '-loading-inner' },
        loadingText
      )
    );
  },
  NoDataComponent: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].makeTemplateComponent('rt-noData', 'NoData'),
  ResizerComponent: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].makeTemplateComponent('rt-resizer', 'Resizer'),
  PadRowComponent: function PadRowComponent() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      null,
      '\xA0'
    );
  }
});
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var defaultButton = function defaultButton(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'button',
    _extends({ type: 'button' }, props, { className: '-btn' }),
    props.children
  );
};

var ReactTablePagination = function (_Component) {
  _inherits(ReactTablePagination, _Component);

  function ReactTablePagination(props) {
    _classCallCheck(this, ReactTablePagination);

    var _this = _possibleConstructorReturn(this, (ReactTablePagination.__proto__ || Object.getPrototypeOf(ReactTablePagination)).call(this, props));

    _this.getSafePage = _this.getSafePage.bind(_this);
    _this.changePage = _this.changePage.bind(_this);
    _this.applyPage = _this.applyPage.bind(_this);

    _this.state = {
      page: props.page
    };
    return _this;
  }

  _createClass(ReactTablePagination, [{
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.page !== nextProps.page) {
        this.setState({ page: nextProps.page });
      }
    }
  }, {
    key: 'getSafePage',
    value: function getSafePage(page) {
      if (Number.isNaN(page)) {
        page = this.props.page;
      }
      return Math.min(Math.max(page, 0), this.props.pages - 1);
    }
  }, {
    key: 'changePage',
    value: function changePage(page) {
      page = this.getSafePage(page);
      this.setState({ page: page });
      if (this.props.page !== page) {
        this.props.onPageChange(page);
      }
    }
  }, {
    key: 'applyPage',
    value: function applyPage(e) {
      if (e) {
        e.preventDefault();
      }
      var page = this.state.page;
      this.changePage(page === '' ? this.props.page : page);
    }
  }, {
    key: 'getPageJumpProperties',
    value: function getPageJumpProperties() {
      var _this2 = this;

      return {
        onKeyPress: function onKeyPress(e) {
          if (e.which === 13 || e.keyCode === 13) {
            _this2.applyPage();
          }
        },
        onBlur: this.applyPage,
        value: this.state.page === '' ? '' : this.state.page + 1,
        onChange: function onChange(e) {
          var val = e.target.value;
          var page = val - 1;
          if (val === '') {
            return _this2.setState({ page: val });
          }
          _this2.setState({ page: _this2.getSafePage(page) });
        },
        inputType: this.state.page === '' ? 'text' : 'number',
        pageJumpText: this.props.pageJumpText
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          pages = _props.pages,
          page = _props.page,
          showPageSizeOptions = _props.showPageSizeOptions,
          pageSizeOptions = _props.pageSizeOptions,
          pageSize = _props.pageSize,
          showPageJump = _props.showPageJump,
          canPrevious = _props.canPrevious,
          canNext = _props.canNext,
          onPageSizeChange = _props.onPageSizeChange,
          className = _props.className,
          PreviousComponent = _props.PreviousComponent,
          NextComponent = _props.NextComponent,
          renderPageJump = _props.renderPageJump,
          renderCurrentPage = _props.renderCurrentPage,
          renderTotalPagesCount = _props.renderTotalPagesCount,
          renderPageSizeOptions = _props.renderPageSizeOptions;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(className, '-pagination'), style: this.props.style },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: '-previous' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            PreviousComponent,
            {
              onClick: function onClick() {
                if (!canPrevious) return;
                _this3.changePage(page - 1);
              },
              disabled: !canPrevious
            },
            this.props.previousText
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: '-center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: '-pageInfo' },
            this.props.pageText,
            ' ',
            showPageJump ? renderPageJump(this.getPageJumpProperties()) : renderCurrentPage(page),
            ' ',
            this.props.ofText,
            ' ',
            renderTotalPagesCount(pages)
          ),
          showPageSizeOptions && renderPageSizeOptions({
            pageSize: pageSize,
            rowsSelectorText: this.props.rowsSelectorText,
            pageSizeOptions: pageSizeOptions,
            onPageSizeChange: onPageSizeChange,
            rowsText: this.props.rowsText
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: '-next' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            NextComponent,
            {
              onClick: function onClick() {
                if (!canNext) return;
                _this3.changePage(page + 1);
              },
              disabled: !canNext
            },
            this.props.nextText
          )
        )
      );
    }
  }]);

  return ReactTablePagination;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ReactTablePagination.defaultProps = {
  PreviousComponent: defaultButton,
  NextComponent: defaultButton,
  renderPageJump: function renderPageJump(_ref) {
    var onChange = _ref.onChange,
        value = _ref.value,
        onBlur = _ref.onBlur,
        onKeyPress = _ref.onKeyPress,
        inputType = _ref.inputType,
        pageJumpText = _ref.pageJumpText;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: '-pageJump' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
        'aria-label': pageJumpText,
        type: inputType,
        onChange: onChange,
        value: value,
        onBlur: onBlur,
        onKeyPress: onKeyPress
      })
    );
  },
  renderCurrentPage: function renderCurrentPage(page) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: '-currentPage' },
      page + 1
    );
  },
  renderTotalPagesCount: function renderTotalPagesCount(pages) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: '-totalPages' },
      pages || 1
    );
  },
  renderPageSizeOptions: function renderPageSizeOptions(_ref2) {
    var pageSize = _ref2.pageSize,
        pageSizeOptions = _ref2.pageSizeOptions,
        rowsSelectorText = _ref2.rowsSelectorText,
        onPageSizeChange = _ref2.onPageSizeChange,
        rowsText = _ref2.rowsText;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: 'select-wrap -pageSizeOptions' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'select',
        {
          'aria-label': rowsSelectorText,
          onChange: function onChange(e) {
            return onPageSizeChange(Number(e.target.value));
          },
          value: pageSize
        },
        pageSizeOptions.map(function (option, i) {
          return (
            // eslint-disable-next-line react/no-array-index-key
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'option',
              { key: i, value: option },
              option + ' ' + rowsText
            )
          );
        })
      )
    );
  }
};
/* harmony default export */ __webpack_exports__["a"] = (ReactTablePagination);
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


/* harmony default export */ __webpack_exports__["a"] = ({
  // General
  data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any,
  loading: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  showPagination: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  showPaginationTop: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  showPaginationBottom: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  showPageSizeOptions: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  pageSizeOptions: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,
  defaultPageSize: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  showPageJump: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  collapseOnSortingChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  collapseOnPageChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  collapseOnDataChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  freezeWhenExpanded: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  sortable: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  resizable: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  filterable: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  defaultSortDesc: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  defaultSorted: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,
  defaultFiltered: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,
  defaultResized: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,
  defaultExpanded: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  defaultFilterMethod: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  defaultSortMethod: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,

  // Controlled State Callbacks
  onPageChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onPageSizeChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onSortedChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onFilteredChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onResizedChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onExpandedChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,

  // Pivoting
  pivotBy: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,

  // Key Constants
  pivotValKey: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  pivotIDKey: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  subRowsKey: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  aggregatedKey: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  nestingLevelKey: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  originalKey: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  indexKey: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  groupedByPivotKey: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,

  // Server-side Callbacks
  onFetchData: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,

  // Classes
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,

  // Component decorators
  getProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getTableProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getTheadGroupProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getTheadGroupTrProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getTheadGroupThProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getTheadProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getTheadTrProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getTheadThProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getTheadFilterProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getTheadFilterTrProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getTheadFilterThProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getTbodyProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getTrGroupProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getTrProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getTdProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getTfootProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getTfootTrProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getTfootTdProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getPaginationProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getLoadingProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getNoDataProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getResizerProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,

  // Global Column Defaults
  columns: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    // Renderers
    Cell: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func]),
    Header: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func]),
    Footer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func]),
    Aggregated: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func]),
    Pivot: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func]),
    PivotValue: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func]),
    Expander: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func]),
    Filter: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func]),

    // All Columns
    sortable: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool, // use table default
    resizable: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool, // use table default
    filterable: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool, // use table default
    show: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    minWidth: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
    minResizeWidth: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,

    // Cells only
    className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    style: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
    getProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,

    // Pivot only
    aggregate: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,

    // Headers only
    headerClassName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    headerStyle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
    getHeaderProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,

    // Footers only
    footerClassName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    footerStyle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
    getFooterProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
    filterMethod: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
    filterAll: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    sortMethod: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
  })),

  // Global Expander Column Defaults
  expanderDefaults: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    sortable: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    resizable: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    filterable: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    width: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number
  }),

  pivotDefaults: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,

  // Text
  previousText: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  nextText: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  loadingText: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  noDataText: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  pageText: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  ofText: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  rowsText: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  pageJumpText: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  rowsSelectorText: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,

  // Components
  TableComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.elementType,
  TheadComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.elementType,
  TbodyComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.elementType,
  TrGroupComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.elementType,
  TrComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.elementType,
  ThComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.elementType,
  TdComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.elementType,
  TfootComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.elementType,
  FilterComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.elementType,
  ExpanderComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.elementType,
  PivotValueComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.elementType,
  AggregatedComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.elementType,
  // this is a computed default generated using
  PivotComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.elementType,
  // the ExpanderComponent and PivotValueComponent at run-time in methods.js
  PaginationComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.elementType,
  PreviousComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.elementType,
  NextComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.elementType,
  LoadingComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.elementType,
  NoDataComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.elementType,
  ResizerComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.elementType,
  PadRowComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.elementType
});
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(64)(false);
// imports


// module
exports.push([module.i, ".ReactTable{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;border:1px solid rgba(0,0,0,.1)}.ReactTable *{box-sizing:border-box}.ReactTable .rt-table{-ms-flex:auto 1;flex:auto 1;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;width:100%;border-collapse:collapse;overflow:auto}.ReactTable .rt-table,.ReactTable .rt-thead{-webkit-box-flex:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal}.ReactTable .rt-thead{-ms-flex:1 0 auto;flex:1 0 auto;-ms-flex-direction:column;flex-direction:column;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ReactTable .rt-thead.-headerGroups{background:rgba(0,0,0,.03)}.ReactTable .rt-thead.-filters,.ReactTable .rt-thead.-headerGroups{border-bottom:1px solid rgba(0,0,0,.05)}.ReactTable .rt-thead.-filters input,.ReactTable .rt-thead.-filters select{border:1px solid rgba(0,0,0,.1);background:#fff;padding:5px 7px;font-size:inherit;border-radius:3px;font-weight:400;outline-width:0}.ReactTable .rt-thead.-filters .rt-th{border-right:1px solid rgba(0,0,0,.02)}.ReactTable .rt-thead.-header{box-shadow:0 2px 15px 0 rgba(0,0,0,.15)}.ReactTable .rt-thead .rt-tr{text-align:center}.ReactTable .rt-thead .rt-td,.ReactTable .rt-thead .rt-th{padding:5px;line-height:normal;position:relative;border-right:1px solid rgba(0,0,0,.05);transition:box-shadow .3s cubic-bezier(.175,.885,.32,1.275);box-shadow:inset 0 0 0 0 transparent}.ReactTable .rt-thead .rt-td.-sort-asc,.ReactTable .rt-thead .rt-th.-sort-asc{box-shadow:inset 0 3px 0 0 rgba(0,0,0,.6)}.ReactTable .rt-thead .rt-td.-sort-desc,.ReactTable .rt-thead .rt-th.-sort-desc{box-shadow:inset 0 -3px 0 0 rgba(0,0,0,.6)}.ReactTable .rt-thead .rt-td.-cursor-pointer,.ReactTable .rt-thead .rt-th.-cursor-pointer{cursor:pointer}.ReactTable .rt-thead .rt-td:last-child,.ReactTable .rt-thead .rt-th:last-child{border-right:0}.ReactTable .rt-thead .rt-th:focus{outline-width:0}.ReactTable .rt-thead .rt-resizable-header{overflow:visible}.ReactTable .rt-thead .rt-resizable-header:last-child{overflow:hidden}.ReactTable .rt-thead .rt-resizable-header-content{overflow:hidden;text-overflow:ellipsis}.ReactTable .rt-thead .rt-header-pivot{border-right-color:#f7f7f7}.ReactTable .rt-thead .rt-header-pivot:after,.ReactTable .rt-thead .rt-header-pivot:before{left:100%;top:50%;border:solid transparent;content:\" \";height:0;width:0;position:absolute;pointer-events:none}.ReactTable .rt-thead .rt-header-pivot:after{border-color:hsla(0,0%,100%,0);border-left-color:#fff;border-width:8px;margin-top:-8px}.ReactTable .rt-thead .rt-header-pivot:before{border-color:hsla(0,0%,40%,0);border-left-color:#f7f7f7;border-width:10px;margin-top:-10px}.ReactTable .rt-tbody{-webkit-box-flex:99999;-ms-flex:99999 1 auto;flex:99999 1 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;overflow:auto}.ReactTable .rt-tbody .rt-tr-group{border-bottom:1px solid rgba(0,0,0,.05)}.ReactTable .rt-tbody .rt-tr-group:last-child{border-bottom:0}.ReactTable .rt-tbody .rt-td{border-right:1px solid rgba(0,0,0,.02)}.ReactTable .rt-tbody .rt-td:last-child{border-right:0}.ReactTable .rt-tbody .rt-expandable{cursor:pointer;text-overflow:clip}.ReactTable .rt-tr-group{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch}.ReactTable .rt-tr{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.ReactTable .rt-td,.ReactTable .rt-th{-webkit-box-flex:1;-ms-flex:1 0 0px;flex:1 0 0;white-space:nowrap;text-overflow:ellipsis;padding:7px 5px;overflow:hidden;transition:.3s ease;transition-property:width,min-width,padding,opacity}.ReactTable .rt-td.-hidden,.ReactTable .rt-th.-hidden{width:0!important;min-width:0!important;padding:0!important;border:0!important;opacity:0!important}.ReactTable .rt-expander{display:inline-block;position:relative;margin:0;color:transparent;margin:0 10px}.ReactTable .rt-expander:after{content:\"\";position:absolute;width:0;height:0;top:50%;left:50%;-webkit-transform:translate(-50%,-50%) rotate(-90deg);transform:translate(-50%,-50%) rotate(-90deg);border-left:5.04px solid transparent;border-right:5.04px solid transparent;border-top:7px solid rgba(0,0,0,.8);transition:all .3s cubic-bezier(.175,.885,.32,1.275);cursor:pointer}.ReactTable .rt-expander.-open:after{-webkit-transform:translate(-50%,-50%) rotate(0);transform:translate(-50%,-50%) rotate(0)}.ReactTable .rt-resizer{display:inline-block;position:absolute;width:36px;top:0;bottom:0;right:-18px;cursor:col-resize;z-index:10}.ReactTable .rt-tfoot{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;box-shadow:0 0 15px 0 rgba(0,0,0,.15)}.ReactTable .rt-tfoot .rt-td{border-right:1px solid rgba(0,0,0,.05)}.ReactTable .rt-tfoot .rt-td:last-child{border-right:0}.ReactTable.-striped .rt-tr.-odd{background:rgba(0,0,0,.03)}.ReactTable.-highlight .rt-tbody .rt-tr:not(.-padRow):hover{background:rgba(0,0,0,.05)}.ReactTable .-pagination{z-index:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;-ms-flex-wrap:wrap;flex-wrap:wrap;padding:3px;box-shadow:0 0 15px 0 rgba(0,0,0,.1);border-top:2px solid rgba(0,0,0,.1)}.ReactTable .-pagination input,.ReactTable .-pagination select{border:1px solid rgba(0,0,0,.1);background:#fff;padding:5px 7px;font-size:inherit;border-radius:3px;font-weight:400;outline-width:0}.ReactTable .-pagination .-btn{-webkit-appearance:none;-moz-appearance:none;appearance:none;display:block;width:100%;height:100%;border:0;border-radius:3px;padding:6px;font-size:1em;color:rgba(0,0,0,.6);background:rgba(0,0,0,.1);transition:all .1s ease;cursor:pointer;outline-width:0}.ReactTable .-pagination .-btn[disabled]{opacity:.5;cursor:default}.ReactTable .-pagination .-btn:not([disabled]):hover{background:rgba(0,0,0,.3);color:#fff}.ReactTable .-pagination .-next,.ReactTable .-pagination .-previous{-webkit-box-flex:1;-ms-flex:1;flex:1;text-align:center}.ReactTable .-pagination .-center{-webkit-box-flex:1.5;-ms-flex:1.5;flex:1.5;text-align:center;margin-bottom:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-pack:distribute;justify-content:space-around}.ReactTable .-pagination .-pageInfo{display:inline-block;margin:3px 10px;white-space:nowrap}.ReactTable .-pagination .-pageJump{display:inline-block}.ReactTable .-pagination .-pageJump input{width:70px;text-align:center}.ReactTable .-pagination .-pageSizeOptions{margin:3px 10px}.ReactTable .rt-noData{left:50%;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);z-index:1;padding:20px;color:rgba(0,0,0,.5)}.ReactTable .-loading,.ReactTable .rt-noData{display:block;position:absolute;background:hsla(0,0%,100%,.8);transition:all .3s ease;pointer-events:none}.ReactTable .-loading{left:0;right:0;top:0;bottom:0;z-index:-1;opacity:0}.ReactTable .-loading>div{position:absolute;display:block;text-align:center;width:100%;top:50%;left:0;font-size:15px;color:rgba(0,0,0,.6);-webkit-transform:translateY(-52%);transform:translateY(-52%);transition:all .3s cubic-bezier(.25,.46,.45,.94)}.ReactTable .-loading.-active{opacity:1;z-index:2;pointer-events:all}.ReactTable .-loading.-active>div{-webkit-transform:translateY(50%);transform:translateY(50%)}.ReactTable .rt-resizing .rt-td,.ReactTable .rt-resizing .rt-th{transition:none!important;cursor:col-resize;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}", ""]);

// exports


/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRouterDom = __webpack_require__(13);

var _asyncComponent = _interopRequireDefault(__webpack_require__(44));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Chart = function Chart(_ref) {
  var match = _ref.match;
  return _react["default"].createElement("div", {
    className: "app-wrapper"
  }, _react["default"].createElement(_reactRouterDom.Switch, null, _react["default"].createElement(_reactRouterDom.Redirect, {
    exact: true,
    from: "".concat(match.url, "/"),
    to: "".concat(match.url, "/area")
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/area"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 2040));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/bar"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 2041));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/composed"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 2042));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/line"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 2043));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/pie"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 2044));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/radar"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 2045));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/radial"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, 2046));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/scatter"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 2047));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/treemap"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, 2048));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 39));
    })
  })));
};

var _default = Chart;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Chart, "Chart", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/charts/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/charts/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/charts/index.js");

  __REACT_HOT_LOADER__.register(_asyncComponent, "_asyncComponent", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/charts/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/charts/index.js");

  __REACT_HOT_LOADER__.register(Chart, "Chart", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/charts/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/charts/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/charts/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/charts/index.js");
}();

;

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRouterDom = __webpack_require__(13);

var _asyncComponent = _interopRequireDefault(__webpack_require__(44));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Map = function Map(_ref) {
  var match = _ref.match;
  return _react["default"].createElement("div", {
    className: "app-wrapper"
  }, _react["default"].createElement(_reactRouterDom.Switch, null, _react["default"].createElement(_reactRouterDom.Redirect, {
    exact: true,
    from: "".concat(match.url, "/"),
    to: "".concat(match.url, "/simple")
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/directions"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(1/* aggressive-merge */).then(__webpack_require__.bind(null, 2049));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/drawing"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(3/* aggressive-merge */).then(__webpack_require__.bind(null, 2050));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/event"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(1/* aggressive-merge */).then(__webpack_require__.bind(null, 2051));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/geo-location"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(1/* aggressive-merge */).then(__webpack_require__.bind(null, 2052));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/kml"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(1/* aggressive-merge */).then(__webpack_require__.bind(null, 2053));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/clustering"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(3/* aggressive-merge */).then(__webpack_require__.bind(null, 2054));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/overlay"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(1/* aggressive-merge */).then(__webpack_require__.bind(null, 2055));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/popup-info"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(3/* aggressive-merge */).then(__webpack_require__.bind(null, 2056));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/simple"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(1/* aggressive-merge */).then(__webpack_require__.bind(null, 2057));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/street-view"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(1/* aggressive-merge */).then(__webpack_require__.bind(null, 2058));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/styled"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(3/* aggressive-merge */).then(__webpack_require__.bind(null, 2059));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/traffic"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(1/* aggressive-merge */).then(__webpack_require__.bind(null, 2060));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 39));
    })
  })));
};

var _default = Map;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Map, "Map", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/map/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/map/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/map/index.js");

  __REACT_HOT_LOADER__.register(_asyncComponent, "_asyncComponent", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/map/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/map/index.js");

  __REACT_HOT_LOADER__.register(Map, "Map", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/map/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/map/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/map/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/map/index.js");
}();

;

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRouterDom = __webpack_require__(13);

var _asyncComponent = _interopRequireDefault(__webpack_require__(44));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Calendar = function Calendar(_ref) {
  var match = _ref.match;
  return _react["default"].createElement("div", {
    className: "app-wrapper"
  }, _react["default"].createElement(_reactRouterDom.Switch, null, _react["default"].createElement(_reactRouterDom.Redirect, {
    exact: true,
    from: "".concat(match.url, "/"),
    to: "".concat(match.url, "/basic")
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/basic"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(2/* aggressive-merge */).then(__webpack_require__.bind(null, 2061));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/cultures"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(2/* aggressive-merge */).then(__webpack_require__.bind(null, 2062));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/dnd"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(2/* aggressive-merge */).then(__webpack_require__.bind(null, 2063));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/popup"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(2/* aggressive-merge */).then(__webpack_require__.bind(null, 2064));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/rendering"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(2/* aggressive-merge */).then(__webpack_require__.bind(null, 2065));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/selectable"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(2/* aggressive-merge */).then(__webpack_require__.bind(null, 2066));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/timeslots"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(2/* aggressive-merge */).then(__webpack_require__.bind(null, 2067));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 39));
    })
  })));
};

var _default = Calendar;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Calendar, "Calendar", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/calendar/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/calendar/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/calendar/index.js");

  __REACT_HOT_LOADER__.register(_asyncComponent, "_asyncComponent", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/calendar/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/calendar/index.js");

  __REACT_HOT_LOADER__.register(Calendar, "Calendar", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/calendar/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/calendar/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/calendar/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/calendar/index.js");
}();

;

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRouterDom = __webpack_require__(13);

var _asyncComponent = _interopRequireDefault(__webpack_require__(44));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var TimeLine = function TimeLine(_ref) {
  var match = _ref.match;
  return _react["default"].createElement("div", {
    className: "app-wrapper"
  }, _react["default"].createElement(_reactRouterDom.Switch, null, _react["default"].createElement(_reactRouterDom.Redirect, {
    exact: true,
    from: "".concat(match.url, "/"),
    to: "".concat(match.url, "/default")
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/default"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, 2068));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/default-with-icon"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, 2069));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/left-align"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, 2070));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/zigzag"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, 2071));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 39));
    })
  })));
};

var _default = TimeLine;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TimeLine, "TimeLine", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/timeLine/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/timeLine/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/timeLine/index.js");

  __REACT_HOT_LOADER__.register(_asyncComponent, "_asyncComponent", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/timeLine/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/timeLine/index.js");

  __REACT_HOT_LOADER__.register(TimeLine, "TimeLine", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/timeLine/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/timeLine/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/timeLine/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/timeLine/index.js");
}();

;

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRouterDom = __webpack_require__(13);

var _asyncComponent = _interopRequireDefault(__webpack_require__(44));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var CustomViews = function CustomViews(_ref) {
  var match = _ref.match;
  return _react["default"].createElement("div", {
    className: "app-wrapper"
  }, _react["default"].createElement(_reactRouterDom.Switch, null, _react["default"].createElement(_reactRouterDom.Redirect, {
    exact: true,
    from: "".concat(match.url, "/"),
    to: "".concat(match.url, "/simple-list")
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/simple-list"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, 2072));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/strip-list"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 2073));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/card-list"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, 2074));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 39));
    })
  })));
};

var _default = CustomViews;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CustomViews, "CustomViews", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/customViews/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/customViews/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/customViews/index.js");

  __REACT_HOT_LOADER__.register(_asyncComponent, "_asyncComponent", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/customViews/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/customViews/index.js");

  __REACT_HOT_LOADER__.register(CustomViews, "CustomViews", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/customViews/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/customViews/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/customViews/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/customViews/index.js");
}();

;

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRouterDom = __webpack_require__(13);

var _asyncComponent = _interopRequireDefault(__webpack_require__(44));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ExtraElements = function ExtraElements(_ref) {
  var match = _ref.match;
  return _react["default"].createElement("div", {
    className: "app-wrapper"
  }, _react["default"].createElement(_reactRouterDom.Switch, null, _react["default"].createElement(_reactRouterDom.Redirect, {
    exact: true,
    from: "".concat(match.url, "/"),
    to: "".concat(match.url, "/pricing-table")
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/pricing-table"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 2075));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/callouts"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 2076));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/testimonials"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(4/* aggressive-merge */).then(__webpack_require__.bind(null, 2077));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 39));
    })
  })));
};

var _default = ExtraElements;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ExtraElements, "ExtraElements", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/extraElements/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/extraElements/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/extraElements/index.js");

  __REACT_HOT_LOADER__.register(_asyncComponent, "_asyncComponent", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/extraElements/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/extraElements/index.js");

  __REACT_HOT_LOADER__.register(ExtraElements, "ExtraElements", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/extraElements/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/extraElements/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/extraElements/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/extraElements/index.js");
}();

;

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRouterDom = __webpack_require__(13);

var _asyncComponent = _interopRequireDefault(__webpack_require__(44));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var eCommerce = function eCommerce(_ref) {
  var match = _ref.match;
  return _react["default"].createElement("div", {
    className: "app-wrapper"
  }, _react["default"].createElement(_reactRouterDom.Switch, null, _react["default"].createElement(_reactRouterDom.Redirect, {
    exact: true,
    from: "".concat(match.url, "/"),
    to: "".concat(match.url, "/products-list")
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/products-list"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 2078));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/products-grid"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 2079));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 39));
    })
  })));
};

var _default = eCommerce;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(eCommerce, "eCommerce", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/eCommerce/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/eCommerce/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/eCommerce/index.js");

  __REACT_HOT_LOADER__.register(_asyncComponent, "_asyncComponent", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/eCommerce/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/eCommerce/index.js");

  __REACT_HOT_LOADER__.register(eCommerce, "eCommerce", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/eCommerce/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/eCommerce/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/eCommerce/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/eCommerce/index.js");
}();

;

/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRouterDom = __webpack_require__(13);

var _asyncComponent = _interopRequireDefault(__webpack_require__(44));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var AppModule = function AppModule(_ref) {
  var match = _ref.match;
  return _react["default"].createElement("div", {
    className: "app-wrapper h-100"
  }, _react["default"].createElement(_reactRouterDom.Switch, null, _react["default"].createElement(_reactRouterDom.Redirect, {
    exact: true,
    from: "".concat(match.url, "/"),
    to: "".concat(match.url, "/login-1")
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/login"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(80).then(__webpack_require__.bind(null, 2080));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/sign-up"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(79).then(__webpack_require__.bind(null, 2081));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/forgot-password"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(82).then(__webpack_require__.bind(null, 2082));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/lock-screen"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(81).then(__webpack_require__.bind(null, 2083));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 39));
    })
  })));
};

var _default = AppModule;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AppModule, "AppModule", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/appModule/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/appModule/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/appModule/index.js");

  __REACT_HOT_LOADER__.register(_asyncComponent, "_asyncComponent", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/appModule/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/appModule/index.js");

  __REACT_HOT_LOADER__.register(AppModule, "AppModule", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/appModule/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/appModule/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/appModule/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/appModule/index.js");
}();

;

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRouterDom = __webpack_require__(13);

var _asyncComponent = _interopRequireDefault(__webpack_require__(44));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Pages = function Pages(_ref) {
  var match = _ref.match;
  return _react["default"].createElement("div", {
    className: "app-wrapper"
  }, _react["default"].createElement(_reactRouterDom.Switch, null, _react["default"].createElement(_reactRouterDom.Redirect, {
    exact: true,
    from: "".concat(match.url, "/"),
    to: "".concat(match.url, "/about-us")
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/about-us"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(4/* aggressive-merge */).then(__webpack_require__.bind(null, 2084));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/contact-us"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(75).then(__webpack_require__.bind(null, 2085));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/blog"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, 2086));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/faq"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, 2087));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/portfolio"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(74).then(__webpack_require__.bind(null, 2088));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/error-404"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 39));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/error-500"),
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(76).then(__webpack_require__.bind(null, 2089));
    })
  }), _react["default"].createElement(_reactRouterDom.Route, {
    component: (0, _asyncComponent["default"])(function () {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 39));
    })
  })));
};

var _default = Pages;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Pages, "Pages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/extraPages/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/extraPages/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/extraPages/index.js");

  __REACT_HOT_LOADER__.register(_asyncComponent, "_asyncComponent", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/extraPages/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/extraPages/index.js");

  __REACT_HOT_LOADER__.register(Pages, "Pages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/extraPages/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/extraPages/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/extraPages/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/app/routes/extraPages/index.js");
}();

;

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _container["default"];
  }
});

var _container = _interopRequireDefault(__webpack_require__(1808));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_container, "_container", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/index.js");
}();

;

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactRedux = __webpack_require__(10);

var _component = _interopRequireDefault(__webpack_require__(1809));

var _Organisation = __webpack_require__(144);

var _session = __webpack_require__(649);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var mapStateToProps = function mapStateToProps(_ref) {
  var orgs = _ref.orgs,
      settings = _ref.settings;
  var width = settings.width;
  var loader = orgs.loader,
      alertMessage = orgs.alertMessage,
      showMessage = orgs.showMessage,
      noContentFoundMessage = orgs.noContentFoundMessage,
      selectedSectionId = orgs.selectedSectionId,
      drawerState = orgs.drawerState,
      org = orgs.org,
      searchOrg = orgs.searchOrg,
      filterOption = orgs.filterOption,
      allOrg = orgs.allOrg,
      orgList = orgs.orgList,
      selectedOrg = orgs.selectedOrg,
      selectedOrgs = orgs.selectedOrgs,
      addOrgState = orgs.addOrgState;
  return {
    width: width,
    loader: loader,
    alertMessage: alertMessage,
    showMessage: showMessage,
    noContentFoundMessage: noContentFoundMessage,
    selectedSectionId: selectedSectionId,
    drawerState: drawerState,
    org: org,
    searchOrg: searchOrg,
    filterOption: filterOption,
    allOrg: allOrg,
    orgList: orgList,
    selectedOrg: selectedOrg,
    selectedOrgs: selectedOrgs,
    addOrgState: addOrgState
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  fetchOrgs: _Organisation.fetchOrgs,
  addFavouriteOrg: _Organisation.addFavouriteOrg,
  onOrgSelect: _Organisation.onOrgSelect,
  onAddOrg: _Organisation.onAddOrg,
  onOrgClose: _Organisation.onOrgClose,
  onFilterOrgOptionSelect: _Organisation.onFilterOrgOptionSelect,
  onSaveOrg: _Organisation.onSaveOrg,
  onDeleteOrg: _Organisation.onDeleteOrg,
  onDeleteSelectedOrg: _Organisation.onDeleteSelectedOrg,
  filterOrg: _Organisation.filterOrg,
  getAllOrg: _Organisation.getAllOrg,
  getUnselectedAllOrg: _Organisation.getUnselectedAllOrg,
  onAllOrgSelect: _Organisation.onAllOrgSelect,
  updateSearchOrg: _Organisation.updateSearchOrg,
  onToggleOrgDrawer: _Organisation.onToggleOrgDrawer,
  handleOrgRequestClose: _Organisation.handleOrgRequestClose,
  hideOrgLoader: _Organisation.hideOrgLoader,
  showOrgLoader: _Organisation.showOrgLoader,
  onEmpDashboard: _Organisation.onEmpDashboard,
  onOrgSurveyDashboard: _Organisation.onOrgSurveyDashboard,
  onProjectDashboard: _Organisation.onProjectDashboard,
  onImpersonateOrg: _Organisation.onImpersonateOrg,
  clearSelectedObjects: _session.clearSelectedObjects
})(_component["default"]);

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/container.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/container.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_component, "_component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/container.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/container.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/container.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/container.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/container.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/container.js");
}();

;

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Component = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _rcDrawer = _interopRequireDefault(__webpack_require__(31));

var _reactNotifications = __webpack_require__(30);

var _reactstrap = __webpack_require__(6);

var _OrgList = _interopRequireDefault(__webpack_require__(1810));

var _index = _interopRequireDefault(__webpack_require__(66));

var _AddOrg = _interopRequireDefault(__webpack_require__(807));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _CircularProgress = _interopRequireDefault(__webpack_require__(24));

var _CustomScrollbars = _interopRequireDefault(__webpack_require__(27));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var filterOptions = [{
  id: 1,
  name: 'All organisations',
  icon: 'zmdi-menu'
}, {
  id: 2,
  name: 'Frequently accessed',
  icon: 'zmdi-time-restore'
}, {
  id: 3,
  name: 'Starred organisations',
  icon: 'zmdi-star'
}];

var Component =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Component, _React$Component);

  _createClass(Component, [{
    key: "__OrgSideBar__REACT_HOT_LOADER__",
    value: function __OrgSideBar__REACT_HOT_LOADER__() {
      var _this2 = this;

      return _react["default"].createElement("div", {
        className: "module-side"
      }, _react["default"].createElement("div", {
        className: "module-side-header"
      }, _react["default"].createElement("div", {
        className: "module-logo"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-city-alt mr-4"
      }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.organisations"
      })))), _react["default"].createElement("div", {
        className: "module-side-content"
      }, _react["default"].createElement(_CustomScrollbars["default"], {
        className: "module-side-scroll scrollbar",
        style: {
          height: this.props.width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)'
        }
      }, _react["default"].createElement("div", {
        className: "module-add-task"
      }, _react["default"].createElement(_reactstrap.Button, {
        className: "btn-block jr-btn",
        color: "primary",
        onClick: this.onAddOrg
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-accounts-add zmdi-hc-fw"
      }), _react["default"].createElement("span", null, "Add New Organisation"))), _react["default"].createElement("div", {
        className: "module-side-nav"
      }, _react["default"].createElement("ul", {
        className: "module-nav"
      }, filterOptions.map(function (option) {
        return _react["default"].createElement("li", {
          key: option.id,
          className: "nav-item"
        }, _react["default"].createElement("a", {
          href: "javascript:void(0)",
          className: option.id === _this2.props.selectedSectionId ? 'active' : '',
          onClick: _this2.onFilterOrgOptionSelect.bind(_this2, option)
        }, _react["default"].createElement("i", {
          className: "zmdi ".concat(option.icon)
        }), _react["default"].createElement("span", null, option.name)));
      }))))));
    }
  }, {
    key: "__addFavouriteOrg__REACT_HOT_LOADER__",
    value: function __addFavouriteOrg__REACT_HOT_LOADER__(data) {
      this.props.addFavouriteOrg(data);
    }
  }, {
    key: "__onOrgSelect__REACT_HOT_LOADER__",
    value: function __onOrgSelect__REACT_HOT_LOADER__(data) {
      this.props.onOrgSelect(data);
    }
  }, {
    key: "__onProjectDashboard__REACT_HOT_LOADER__",
    value: function __onProjectDashboard__REACT_HOT_LOADER__(data) {
      this.props.onProjectDashboard(data);
    }
  }, {
    key: "__onImpersonateOrg__REACT_HOT_LOADER__",
    value: function __onImpersonateOrg__REACT_HOT_LOADER__(data) {
      this.props.onImpersonateOrg(data);
    }
  }, {
    key: "__onClearSelectedObjects__REACT_HOT_LOADER__",
    value: function __onClearSelectedObjects__REACT_HOT_LOADER__() {
      this.props.clearSelectedObjects();
    }
  }, {
    key: "__onEmpDashboard__REACT_HOT_LOADER__",
    value: function __onEmpDashboard__REACT_HOT_LOADER__(data) {
      this.props.onEmpDashboard(data);
    }
  }, {
    key: "__onOrgSurveyDashboard__REACT_HOT_LOADER__",
    value: function __onOrgSurveyDashboard__REACT_HOT_LOADER__(data) {
      this.props.onOrgSurveyDashboard(data);
    }
  }, {
    key: "__onAddOrg__REACT_HOT_LOADER__",
    value: function __onAddOrg__REACT_HOT_LOADER__() {
      this.props.onAddOrg();
    }
  }, {
    key: "__onOrgClose__REACT_HOT_LOADER__",
    value: function __onOrgClose__REACT_HOT_LOADER__() {
      this.props.onOrgClose();
    }
  }, {
    key: "__onFilterOrgOptionSelect__REACT_HOT_LOADER__",
    value: function __onFilterOrgOptionSelect__REACT_HOT_LOADER__(option) {
      this.props.onFilterOrgOptionSelect(option);
    }
  }, {
    key: "__onSaveOrg__REACT_HOT_LOADER__",
    value: function __onSaveOrg__REACT_HOT_LOADER__(data) {
      this.props.onSaveOrg(data);
    }
  }, {
    key: "__onDeleteOrg__REACT_HOT_LOADER__",
    value: function __onDeleteOrg__REACT_HOT_LOADER__(data) {
      this.props.onDeleteOrg(data);
    }
  }, {
    key: "__onDeleteSelectedOrg__REACT_HOT_LOADER__",
    value: function __onDeleteSelectedOrg__REACT_HOT_LOADER__() {
      this.props.onDeleteSelectedOrg();
    }
  }, {
    key: "__filterOrg__REACT_HOT_LOADER__",
    value: function __filterOrg__REACT_HOT_LOADER__(orgName) {
      if (orgName === '') {
        this.onFilterOrgOptionSelect(this.props.filterOption);
      } else {
        this.props.filterOrg(orgName);
      }
    }
  }, {
    key: "__handleOrgRequestClose__REACT_HOT_LOADER__",
    value: function __handleOrgRequestClose__REACT_HOT_LOADER__() {
      this.props.handleOrgRequestClose();
    }
  }, {
    key: "__getAllOrg__REACT_HOT_LOADER__",
    value: function __getAllOrg__REACT_HOT_LOADER__() {
      this.props.getAllOrg();
    }
  }, {
    key: "__getUnselectedAllOrg__REACT_HOT_LOADER__",
    value: function __getUnselectedAllOrg__REACT_HOT_LOADER__() {
      this.props.getUnselectedAllOrg();
    }
  }, {
    key: "__onAllOrgSelect__REACT_HOT_LOADER__",
    value: function __onAllOrgSelect__REACT_HOT_LOADER__() {
      var selectAll = this.props.selectedOrgs < this.props.orgList.length;

      if (selectAll) {
        this.props.getAllOrg();
      } else {
        this.props.getUnselectedAllOrg();
      }
    }
  }, {
    key: "__onToggleOrgDrawer__REACT_HOT_LOADER__",
    value: function __onToggleOrgDrawer__REACT_HOT_LOADER__() {
      this.props.onToggleOrgDrawer();
    }
  }, {
    key: "__showOrgLoader__REACT_HOT_LOADER__",
    value: function __showOrgLoader__REACT_HOT_LOADER__() {
      this.props.showOrgLoader();
    }
  }]);

  function Component() {
    var _this;

    _classCallCheck(this, Component);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Component).call(this));

    _defineProperty(_assertThisInitialized(_this), "OrgSideBar", function () {
      var _this3;

      return (_this3 = _this).__OrgSideBar__REACT_HOT_LOADER__.apply(_this3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "addFavouriteOrg", function () {
      var _this4;

      return (_this4 = _this).__addFavouriteOrg__REACT_HOT_LOADER__.apply(_this4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onOrgSelect", function () {
      var _this5;

      return (_this5 = _this).__onOrgSelect__REACT_HOT_LOADER__.apply(_this5, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onProjectDashboard", function () {
      var _this6;

      return (_this6 = _this).__onProjectDashboard__REACT_HOT_LOADER__.apply(_this6, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onImpersonateOrg", function () {
      var _this7;

      return (_this7 = _this).__onImpersonateOrg__REACT_HOT_LOADER__.apply(_this7, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onClearSelectedObjects", function () {
      var _this8;

      return (_this8 = _this).__onClearSelectedObjects__REACT_HOT_LOADER__.apply(_this8, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onEmpDashboard", function () {
      var _this9;

      return (_this9 = _this).__onEmpDashboard__REACT_HOT_LOADER__.apply(_this9, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onOrgSurveyDashboard", function () {
      var _this10;

      return (_this10 = _this).__onOrgSurveyDashboard__REACT_HOT_LOADER__.apply(_this10, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onAddOrg", function () {
      var _this11;

      return (_this11 = _this).__onAddOrg__REACT_HOT_LOADER__.apply(_this11, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onOrgClose", function () {
      var _this12;

      return (_this12 = _this).__onOrgClose__REACT_HOT_LOADER__.apply(_this12, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onFilterOrgOptionSelect", function () {
      var _this13;

      return (_this13 = _this).__onFilterOrgOptionSelect__REACT_HOT_LOADER__.apply(_this13, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onSaveOrg", function () {
      var _this14;

      return (_this14 = _this).__onSaveOrg__REACT_HOT_LOADER__.apply(_this14, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onDeleteOrg", function () {
      var _this15;

      return (_this15 = _this).__onDeleteOrg__REACT_HOT_LOADER__.apply(_this15, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onDeleteSelectedOrg", function () {
      var _this16;

      return (_this16 = _this).__onDeleteSelectedOrg__REACT_HOT_LOADER__.apply(_this16, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "filterOrg", function () {
      var _this17;

      return (_this17 = _this).__filterOrg__REACT_HOT_LOADER__.apply(_this17, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "handleOrgRequestClose", function () {
      var _this18;

      return (_this18 = _this).__handleOrgRequestClose__REACT_HOT_LOADER__.apply(_this18, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "getAllOrg", function () {
      var _this19;

      return (_this19 = _this).__getAllOrg__REACT_HOT_LOADER__.apply(_this19, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "getUnselectedAllOrg", function () {
      var _this20;

      return (_this20 = _this).__getUnselectedAllOrg__REACT_HOT_LOADER__.apply(_this20, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onAllOrgSelect", function () {
      var _this21;

      return (_this21 = _this).__onAllOrgSelect__REACT_HOT_LOADER__.apply(_this21, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onToggleOrgDrawer", function () {
      var _this22;

      return (_this22 = _this).__onToggleOrgDrawer__REACT_HOT_LOADER__.apply(_this22, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "showOrgLoader", function () {
      var _this23;

      return (_this23 = _this).__showOrgLoader__REACT_HOT_LOADER__.apply(_this23, arguments);
    });

    return _this;
  }

  _createClass(Component, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.showOrgLoader();
      this.props.fetchOrgs();
    }
  }, {
    key: "updateSearchOrg",
    value: function updateSearchOrg(evt) {
      this.props.updateSearchOrg(evt.target.value);
      this.props.filterOrg(evt.target.value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          org = _this$props.org,
          orgList = _this$props.orgList,
          addOrgState = _this$props.addOrgState,
          selectedOrgs = _this$props.selectedOrgs,
          alertMessage = _this$props.alertMessage,
          showMessage = _this$props.showMessage,
          drawerState = _this$props.drawerState,
          noContentFoundMessage = _this$props.noContentFoundMessage,
          loader = _this$props.loader;
      return _react["default"].createElement("div", {
        className: "app-wrapper"
      }, _react["default"].createElement("div", {
        className: "app-module animated slideInUpTiny animation-duration-3"
      }, _react["default"].createElement("div", {
        className: "d-block d-xl-none"
      }, _react["default"].createElement(_rcDrawer["default"], {
        touch: true,
        transitions: true,
        enableDragHandle: true,
        open: drawerState,
        onOpenChange: this.onToggleOrgDrawer.bind(this),
        sidebar: this.OrgSideBar(org)
      })), _react["default"].createElement("div", {
        className: "app-module-sidenav d-none d-xl-flex"
      }, this.OrgSideBar(org)), _react["default"].createElement("div", {
        className: "module-box"
      }, _react["default"].createElement("div", {
        className: "module-box-header"
      }, _react["default"].createElement("span", {
        className: "icon-btn drawer-btn d-flex d-xl-none",
        onClick: this.onToggleOrgDrawer.bind(this)
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-menu"
      })), _react["default"].createElement(_index["default"], {
        placeholder: "Search org",
        notification: false,
        apps: false,
        user: this.props.org,
        onChange: this.updateSearchOrg.bind(this),
        value: this.props.searchOrg
      })), _react["default"].createElement("div", {
        className: "module-box-content"
      }, _react["default"].createElement("div", {
        className: "module-box-topbar align-items-center"
      }, _react["default"].createElement("div", {
        className: "form-control-checkbox d-flex"
      }, _react["default"].createElement("div", {
        className: "form-checkbox"
      }, _react["default"].createElement("input", {
        type: "checkbox",
        checked: selectedOrgs > 0,
        onChange: this.onAllOrgSelect.bind(this)
      }), _react["default"].createElement("span", {
        className: "check"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-check zmdi-hc-lg"
      })))), _react["default"].createElement(_reactstrap.Button, {
        size: "sm",
        className: "jr-btn jr-flat-btn",
        color: "default",
        onClick: this.onDeleteSelectedOrg.bind(this)
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-filter-list zmdi-hc-fw"
      }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "label.filter.selected"
      })))), _react["default"].createElement(_CustomScrollbars["default"], {
        className: "module-list-scroll scrollbar",
        style: {
          height: this.props.width >= 1200 ? 'calc(100vh - 265px)' : 'calc(100vh - 245px)'
        }
      }, loader ? _react["default"].createElement("div", {
        className: "loader-view-block h-100"
      }, _react["default"].createElement("div", {
        className: "loader-view"
      }, _react["default"].createElement(_CircularProgress["default"], null))) : orgList && orgList.length > 0 ? _react["default"].createElement(_OrgList["default"], {
        data: orgList,
        addFavouriteOrg: this.addFavouriteOrg.bind(this),
        onOrgSelect: this.onOrgSelect.bind(this),
        onDeleteOrg: this.onDeleteOrg.bind(this),
        onSaveOrg: this.onSaveOrg.bind(this),
        showOrgLoader: this.showOrgLoader.bind(this),
        onEmpDashboard: this.onEmpDashboard.bind(this),
        onProjectDashboard: this.onProjectDashboard.bind(this),
        onImpersonateOrg: this.onImpersonateOrg.bind(this),
        onClearSelectedObjects: this.onClearSelectedObjects.bind(this),
        onOrgSurveyDashboard: this.onOrgSurveyDashboard.bind(this)
      }) : _react["default"].createElement("div", {
        className: "h-100 d-flex align-items-center justify-content-center"
      }, noContentFoundMessage))))), _react["default"].createElement(_AddOrg["default"], {
        open: addOrgState,
        organisation: {
          'id': '',
          'name': '',
          'thumb': null,
          'email': '',
          'phone': '',
          'designation': '',
          'selected': false,
          'starred': false,
          'frequently': false,
          'role': '',
          'surveys': []
        },
        onSaveOrg: this.onSaveOrg,
        onOrgClose: this.onOrgClose,
        onDeleteOrg: this.onDeleteOrg,
        showOrgLoader: this.showOrgLoader
      }), showMessage && _reactNotifications.NotificationManager.success(alertMessage, this.handleOrgRequestClose()), _react["default"].createElement(_reactNotifications.NotificationContainer, null));
    }
  }]);

  return Component;
}(_react["default"].Component);

exports.Component = Component;
var _default = Component;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(filterOptions, "filterOptions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/component.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/component.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/component.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/component.js");

  __REACT_HOT_LOADER__.register(_rcDrawer, "_rcDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/component.js");

  __REACT_HOT_LOADER__.register(_OrgList, "_OrgList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/component.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/component.js");

  __REACT_HOT_LOADER__.register(_AddOrg, "_AddOrg", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/component.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/component.js");

  __REACT_HOT_LOADER__.register(_CircularProgress, "_CircularProgress", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/component.js");

  __REACT_HOT_LOADER__.register(_CustomScrollbars, "_CustomScrollbars", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/component.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/component.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/component.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/component.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/component.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/component.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/component.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/component.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/component.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/component.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/component.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/component.js");

  __REACT_HOT_LOADER__.register(filterOptions, "filterOptions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/component.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/component.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/component.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/component.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/organisation/component.js");
}();

;

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _index = _interopRequireDefault(__webpack_require__(1811));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var OrgList = function OrgList(_ref) {
  var data = _ref.data,
      addFavouriteOrg = _ref.addFavouriteOrg,
      onOrgSelect = _ref.onOrgSelect,
      onSaveOrg = _ref.onSaveOrg,
      onDeleteOrg = _ref.onDeleteOrg,
      showOrgLoader = _ref.showOrgLoader,
      onEmpDashboard = _ref.onEmpDashboard,
      onOrgSurveyDashboard = _ref.onOrgSurveyDashboard,
      onProjectDashboard = _ref.onProjectDashboard,
      onImpersonateOrg = _ref.onImpersonateOrg,
      onClearSelectedObjects = _ref.onClearSelectedObjects;
  return _react["default"].createElement("div", {
    className: "app-main-content"
  }, data.map(function (data, index) {
    return _react["default"].createElement(_index["default"], {
      key: index,
      organisation: data,
      onDeleteOrg: onDeleteOrg,
      onSaveOrg: onSaveOrg,
      showOrgLoader: showOrgLoader,
      addFavouriteOrg: addFavouriteOrg,
      onOrgSelect: onOrgSelect,
      onEmpDashboard: onEmpDashboard,
      onOrgSurveyDashboard: onOrgSurveyDashboard,
      onProjectDashboard: onProjectDashboard,
      onImpersonateOrg: onImpersonateOrg,
      onClearSelectedObjects: onClearSelectedObjects
    });
  }));
};

var _default = OrgList;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OrgList, "OrgList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/OrgList/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/OrgList/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/OrgList/index.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/OrgList/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/OrgList/index.js");

  __REACT_HOT_LOADER__.register(OrgList, "OrgList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/OrgList/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/OrgList/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/OrgList/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/OrgList/index.js");
}();

;

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _index = _interopRequireDefault(__webpack_require__(807));

var _listRowImage = _interopRequireDefault(__webpack_require__(126));

var _ListRowFavourite = _interopRequireDefault(__webpack_require__(127));

var _ListRowCheckbox = _interopRequireDefault(__webpack_require__(107));

var _ListRowDropdown = _interopRequireDefault(__webpack_require__(128));

var _ListRowData = _interopRequireDefault(__webpack_require__(129));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var OrgRow =
/*#__PURE__*/
function (_React$Component) {
  _inherits(OrgRow, _React$Component);

  _createClass(OrgRow, [{
    key: "__onOrgOptionToggle__REACT_HOT_LOADER__",
    value: function __onOrgOptionToggle__REACT_HOT_LOADER__() {
      this.setState({
        menuState: !this.state.menuState
      });
    }
  }, {
    key: "__onOrgClose__REACT_HOT_LOADER__",
    value: function __onOrgClose__REACT_HOT_LOADER__() {
      this.setState({
        addOrgState: false
      });
    }
  }, {
    key: "__onDeleteOrg__REACT_HOT_LOADER__",
    value: function __onDeleteOrg__REACT_HOT_LOADER__(org) {
      this.setState({
        addOrgState: false
      });
      this.props.onDeleteOrg(org);
    }
  }, {
    key: "__onImpersonateOrg__REACT_HOT_LOADER__",
    value: function __onImpersonateOrg__REACT_HOT_LOADER__(org) {
      this.setState({
        addOrgState: false
      });
      this.props.onClearSelectedObjects();
      this.props.onImpersonateOrg(org);
    }
  }, {
    key: "__onEditOrg__REACT_HOT_LOADER__",
    value: function __onEditOrg__REACT_HOT_LOADER__() {
      this.setState({
        menuState: false,
        addOrgState: true
      });
    }
  }]);

  function OrgRow() {
    var _this;

    _classCallCheck(this, OrgRow);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OrgRow).call(this));

    _defineProperty(_assertThisInitialized(_this), "onOrgOptionToggle", function () {
      var _this2;

      return (_this2 = _this).__onOrgOptionToggle__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onOrgClose", function () {
      var _this3;

      return (_this3 = _this).__onOrgClose__REACT_HOT_LOADER__.apply(_this3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onDeleteOrg", function () {
      var _this4;

      return (_this4 = _this).__onDeleteOrg__REACT_HOT_LOADER__.apply(_this4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onImpersonateOrg", function () {
      var _this5;

      return (_this5 = _this).__onImpersonateOrg__REACT_HOT_LOADER__.apply(_this5, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onEditOrg", function () {
      var _this6;

      return (_this6 = _this).__onEditOrg__REACT_HOT_LOADER__.apply(_this6, arguments);
    });

    _this.state = {
      menuState: false,
      addOrgState: false
    };
    return _this;
  }

  _createClass(OrgRow, [{
    key: "render",
    value: function render() {
      var _this7 = this;

      var _this$props = this.props,
          width = _this$props.width,
          organisation = _this$props.organisation,
          addFavouriteOrg = _this$props.addFavouriteOrg,
          onOrgSelect = _this$props.onOrgSelect,
          onSaveOrg = _this$props.onSaveOrg,
          showOrgLoader = _this$props.showOrgLoader;
      var _this$state = this.state,
          menuState = _this$state.menuState,
          addOrgState = _this$state.addOrgState;
      var name = organisation.name,
          email = organisation.email,
          phone = organisation.phone,
          starred = organisation.starred;
      var options = ['Edit', 'Delete', 'Impersonate'];
      return _react["default"].createElement("div", {
        className: "contact-item"
      }, _react["default"].createElement(_ListRowCheckbox["default"], {
        selected: organisation.selected,
        onClick: function onClick() {
          onOrgSelect(organisation);
        }
      }), _react["default"].createElement(_ListRowFavourite["default"], {
        width: width,
        onClick: function onClick() {
          addFavouriteOrg(organisation);
        },
        starred: starred
      }), _react["default"].createElement(_listRowImage["default"], {
        width: width,
        data: organisation
      }), _react["default"].createElement(_ListRowData["default"], {
        lineOne: name,
        lineTwoLeft: email,
        lineTwoRight: phone
      }), _react["default"].createElement(_ListRowDropdown["default"], {
        menuState: menuState,
        toggle: this.onOrgOptionToggle.bind(this),
        options: options,
        dropdownItems: options.map(function (option) {
          return _react["default"].createElement(_reactstrap.DropdownItem, {
            key: option,
            onClick: function onClick() {
              if (option === 'Edit') {
                _this7.onEditOrg();
              } else if (option === 'Delete') {
                _this7.onDeleteOrg(organisation);
              } else if (option === 'Impersonate') {
                _this7.onImpersonateOrg(organisation);
              }
            }
          }, option);
        })
      }), _react["default"].createElement("div", null, addOrgState && _react["default"].createElement(_index["default"], {
        open: addOrgState,
        organisation: organisation,
        onSaveOrg: onSaveOrg,
        onOrgClose: this.onOrgClose,
        onDeleteOrg: this.onDeleteOrg,
        showOrgLoader: showOrgLoader
      })));
    }
  }]);

  return OrgRow;
}(_react["default"].Component);

var _default = OrgRow;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OrgRow, "OrgRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/OrgList/OrgRow/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/OrgList/OrgRow/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/OrgList/OrgRow/index.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/OrgList/OrgRow/index.js");

  __REACT_HOT_LOADER__.register(_listRowImage, "_listRowImage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/OrgList/OrgRow/index.js");

  __REACT_HOT_LOADER__.register(_ListRowFavourite, "_ListRowFavourite", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/OrgList/OrgRow/index.js");

  __REACT_HOT_LOADER__.register(_ListRowCheckbox, "_ListRowCheckbox", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/OrgList/OrgRow/index.js");

  __REACT_HOT_LOADER__.register(_ListRowDropdown, "_ListRowDropdown", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/OrgList/OrgRow/index.js");

  __REACT_HOT_LOADER__.register(_ListRowData, "_ListRowData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/OrgList/OrgRow/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/OrgList/OrgRow/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/OrgList/OrgRow/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/OrgList/OrgRow/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/OrgList/OrgRow/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/OrgList/OrgRow/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/OrgList/OrgRow/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/OrgList/OrgRow/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/OrgList/OrgRow/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/OrgList/OrgRow/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/OrgList/OrgRow/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/OrgList/OrgRow/index.js");

  __REACT_HOT_LOADER__.register(OrgRow, "OrgRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/OrgList/OrgRow/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/OrgList/OrgRow/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/OrgList/OrgRow/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Organisation/OrgList/OrgRow/index.js");
}();

;

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _rcDrawer = _interopRequireDefault(__webpack_require__(31));

var _reactNotifications = __webpack_require__(30);

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _EmpList = _interopRequireDefault(__webpack_require__(1813));

var _index = _interopRequireDefault(__webpack_require__(66));

var _AddEmp = _interopRequireDefault(__webpack_require__(808));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _CircularProgress = _interopRequireDefault(__webpack_require__(24));

var _CustomScrollbars = _interopRequireDefault(__webpack_require__(27));

var _Employee = __webpack_require__(173);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var filterOptions = [{
  id: 1,
  name: 'All employees',
  icon: 'zmdi-menu'
}, {
  id: 2,
  name: 'Starred employees',
  icon: 'zmdi-star'
}];

var Employee =
/*#__PURE__*/
function (_Component) {
  _inherits(Employee, _Component);

  _createClass(Employee, [{
    key: "__EmpSideBar__REACT_HOT_LOADER__",
    value: function __EmpSideBar__REACT_HOT_LOADER__() {
      var _this2 = this;

      return _react["default"].createElement("div", {
        className: "module-side"
      }, _react["default"].createElement("div", {
        className: "module-side-header"
      }, _react["default"].createElement("div", {
        className: "module-logo"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-city-alt mr-4"
      }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.employees"
      })))), _react["default"].createElement("div", {
        className: "module-side-content"
      }, _react["default"].createElement(_CustomScrollbars["default"], {
        className: "module-side-scroll scrollbar",
        style: {
          height: this.props.width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)'
        }
      }, _react["default"].createElement("div", {
        className: "module-add-task"
      }, _react["default"].createElement(_reactstrap.Button, {
        className: "btn-block jr-btn",
        color: "primary",
        onClick: this.onAddEmp
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-accounts-add zmdi-hc-fw"
      }), _react["default"].createElement("span", null, "Add New Employee"))), _react["default"].createElement("div", {
        className: "module-side-nav"
      }, _react["default"].createElement("ul", {
        className: "module-nav"
      }, filterOptions.map(function (option) {
        return _react["default"].createElement("li", {
          key: option.id,
          className: "nav-item"
        }, _react["default"].createElement("a", {
          href: "javascript:void(0)",
          className: option.id === _this2.props.selectedSectionId ? 'active' : '',
          onClick: _this2.onFilterEmpOptionSelect.bind(_this2, option)
        }, _react["default"].createElement("i", {
          className: "zmdi ".concat(option.icon)
        }), _react["default"].createElement("span", null, option.name)));
      }))))));
    }
  }, {
    key: "__addFavouriteEmp__REACT_HOT_LOADER__",
    value: function __addFavouriteEmp__REACT_HOT_LOADER__(data) {
      this.props.addFavouriteEmp(data);
    }
  }, {
    key: "__onEmpSelect__REACT_HOT_LOADER__",
    value: function __onEmpSelect__REACT_HOT_LOADER__(data) {
      this.props.onEmpSelect(data);
    }
  }, {
    key: "__onAddEmp__REACT_HOT_LOADER__",
    value: function __onAddEmp__REACT_HOT_LOADER__() {
      this.props.onAddEmp();
    }
  }, {
    key: "__onEmpClose__REACT_HOT_LOADER__",
    value: function __onEmpClose__REACT_HOT_LOADER__() {
      this.props.onEmpClose();
    }
  }, {
    key: "__onFilterEmpOptionSelect__REACT_HOT_LOADER__",
    value: function __onFilterEmpOptionSelect__REACT_HOT_LOADER__(option) {
      this.props.onFilterEmpOptionSelect(option);
    }
  }, {
    key: "__onSaveEmp__REACT_HOT_LOADER__",
    value: function __onSaveEmp__REACT_HOT_LOADER__(data) {
      this.props.onSaveEmp(data);
    }
  }, {
    key: "__onDeleteEmp__REACT_HOT_LOADER__",
    value: function __onDeleteEmp__REACT_HOT_LOADER__(data) {
      this.props.onDeleteEmp(data);
    }
  }, {
    key: "__onDeleteSelectedEmp__REACT_HOT_LOADER__",
    value: function __onDeleteSelectedEmp__REACT_HOT_LOADER__() {
      this.props.onDeleteSelectedEmp();
    }
  }, {
    key: "__filterEmp__REACT_HOT_LOADER__",
    value: function __filterEmp__REACT_HOT_LOADER__(empName) {
      if (empName === '') {
        this.onFilterEmpOptionSelect(this.props.filterOption);
      } else {
        this.props.filterEmp(empName);
      }
    }
  }, {
    key: "__handleEmpRequestClose__REACT_HOT_LOADER__",
    value: function __handleEmpRequestClose__REACT_HOT_LOADER__() {
      this.props.handleEmpRequestClose();
    }
  }, {
    key: "__getAllEmp__REACT_HOT_LOADER__",
    value: function __getAllEmp__REACT_HOT_LOADER__() {
      this.props.getAllEmp();
    }
  }, {
    key: "__getUnselectedAllEmp__REACT_HOT_LOADER__",
    value: function __getUnselectedAllEmp__REACT_HOT_LOADER__() {
      this.props.getUnselectedAllEmp();
    }
  }, {
    key: "__onAllEmpSelect__REACT_HOT_LOADER__",
    value: function __onAllEmpSelect__REACT_HOT_LOADER__() {
      var selectAll = this.props.selectedEmps < this.props.empList.length;

      if (selectAll) {
        this.props.getAllEmp();
      } else {
        this.props.getUnselectedAllEmp();
      }
    }
  }, {
    key: "__onToggleEmpDrawer__REACT_HOT_LOADER__",
    value: function __onToggleEmpDrawer__REACT_HOT_LOADER__() {
      this.props.onToggleEmpDrawer();
    }
  }, {
    key: "__showEmpLoader__REACT_HOT_LOADER__",
    value: function __showEmpLoader__REACT_HOT_LOADER__() {
      this.props.showEmpLoader();
    }
  }]);

  function Employee() {
    var _this;

    _classCallCheck(this, Employee);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Employee).call(this));

    _defineProperty(_assertThisInitialized(_this), "EmpSideBar", function () {
      var _this3;

      return (_this3 = _this).__EmpSideBar__REACT_HOT_LOADER__.apply(_this3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "addFavouriteEmp", function () {
      var _this4;

      return (_this4 = _this).__addFavouriteEmp__REACT_HOT_LOADER__.apply(_this4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onEmpSelect", function () {
      var _this5;

      return (_this5 = _this).__onEmpSelect__REACT_HOT_LOADER__.apply(_this5, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onAddEmp", function () {
      var _this6;

      return (_this6 = _this).__onAddEmp__REACT_HOT_LOADER__.apply(_this6, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onEmpClose", function () {
      var _this7;

      return (_this7 = _this).__onEmpClose__REACT_HOT_LOADER__.apply(_this7, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onFilterEmpOptionSelect", function () {
      var _this8;

      return (_this8 = _this).__onFilterEmpOptionSelect__REACT_HOT_LOADER__.apply(_this8, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onSaveEmp", function () {
      var _this9;

      return (_this9 = _this).__onSaveEmp__REACT_HOT_LOADER__.apply(_this9, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onDeleteEmp", function () {
      var _this10;

      return (_this10 = _this).__onDeleteEmp__REACT_HOT_LOADER__.apply(_this10, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onDeleteSelectedEmp", function () {
      var _this11;

      return (_this11 = _this).__onDeleteSelectedEmp__REACT_HOT_LOADER__.apply(_this11, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "filterEmp", function () {
      var _this12;

      return (_this12 = _this).__filterEmp__REACT_HOT_LOADER__.apply(_this12, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "handleEmpRequestClose", function () {
      var _this13;

      return (_this13 = _this).__handleEmpRequestClose__REACT_HOT_LOADER__.apply(_this13, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "getAllEmp", function () {
      var _this14;

      return (_this14 = _this).__getAllEmp__REACT_HOT_LOADER__.apply(_this14, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "getUnselectedAllEmp", function () {
      var _this15;

      return (_this15 = _this).__getUnselectedAllEmp__REACT_HOT_LOADER__.apply(_this15, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onAllEmpSelect", function () {
      var _this16;

      return (_this16 = _this).__onAllEmpSelect__REACT_HOT_LOADER__.apply(_this16, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onToggleEmpDrawer", function () {
      var _this17;

      return (_this17 = _this).__onToggleEmpDrawer__REACT_HOT_LOADER__.apply(_this17, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "showEmpLoader", function () {
      var _this18;

      return (_this18 = _this).__showEmpLoader__REACT_HOT_LOADER__.apply(_this18, arguments);
    });

    return _this;
  }

  _createClass(Employee, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.showEmpLoader();
      this.props.fetchEmps();
    }
  }, {
    key: "updateSearchEmp",
    value: function updateSearchEmp(evt) {
      this.props.updateSearchEmp(evt.target.value);
      this.props.filterEmp(evt.target.value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          width = _this$props.width,
          emp = _this$props.emp,
          org = _this$props.org,
          empList = _this$props.empList,
          addEmpState = _this$props.addEmpState,
          selectedEmps = _this$props.selectedEmps,
          alertMessage = _this$props.alertMessage,
          showMessage = _this$props.showMessage,
          drawerState = _this$props.drawerState,
          noContentFoundMessage = _this$props.noContentFoundMessage,
          loader = _this$props.loader,
          searchEmp = _this$props.searchEmp;
      return _react["default"].createElement("div", {
        className: "app-wrapper"
      }, _react["default"].createElement("div", {
        className: "app-module animated slideInUpTiny animation-duration-3"
      }, _react["default"].createElement("div", {
        className: "d-block d-xl-none"
      }, _react["default"].createElement(_rcDrawer["default"], {
        touch: true,
        transitions: true,
        enableDragHandle: true,
        open: drawerState,
        onOpenChange: this.onToggleEmpDrawer.bind(this),
        sidebar: this.EmpSideBar(emp)
      })), _react["default"].createElement("div", {
        className: "app-module-sidenav d-none d-xl-flex"
      }, this.EmpSideBar(emp)), _react["default"].createElement("div", {
        className: "module-box"
      }, _react["default"].createElement("div", {
        className: "module-box-header"
      }, _react["default"].createElement("span", {
        className: "icon-btn drawer-btn d-flex d-xl-none",
        onClick: this.onToggleEmpDrawer.bind(this)
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-menu"
      })), _react["default"].createElement(_index["default"], {
        placeholder: "Search employees",
        notification: false,
        apps: false,
        user: org,
        onChange: this.updateSearchEmp.bind(this),
        value: searchEmp
      })), _react["default"].createElement("div", {
        className: "module-box-content"
      }, _react["default"].createElement("div", {
        className: "module-box-topbar align-items-center"
      }, _react["default"].createElement("div", {
        className: "form-control-checkbox d-flex"
      }, _react["default"].createElement("div", {
        className: "form-checkbox"
      }, _react["default"].createElement("input", {
        type: "checkbox",
        checked: selectedEmps > 0,
        onChange: this.onAllEmpSelect.bind(this)
      }), _react["default"].createElement("span", {
        className: "check"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-check zmdi-hc-lg"
      })))), _react["default"].createElement(_reactstrap.Button, {
        size: "sm",
        className: "jr-btn jr-flat-btn",
        color: "default",
        onClick: this.onDeleteSelectedEmp.bind(this)
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-filter-list zmdi-hc-fw"
      }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "label.filter.selected"
      })))), _react["default"].createElement(_CustomScrollbars["default"], {
        className: "module-list-scroll scrollbar",
        style: {
          height: this.props.width >= 1200 ? 'calc(100vh - 265px)' : 'calc(100vh - 245px)'
        }
      }, loader ? _react["default"].createElement("div", {
        className: "loader-view-block h-100"
      }, _react["default"].createElement("div", {
        className: "loader-view"
      }, _react["default"].createElement(_CircularProgress["default"], null))) : empList && empList.length === 0 ? _react["default"].createElement("div", {
        className: "h-100 d-flex align-items-center justify-content-center"
      }, noContentFoundMessage) : _react["default"].createElement(_EmpList["default"], {
        data: empList,
        width: width,
        addFavouriteEmp: this.addFavouriteEmp.bind(this),
        onEmpSelect: this.onEmpSelect.bind(this),
        onDeleteEmp: this.onDeleteEmp.bind(this),
        onSaveEmp: this.onSaveEmp.bind(this),
        showEmpLoader: this.showEmpLoader.bind(this)
      }))))), _react["default"].createElement(_AddEmp["default"], {
        open: addEmpState,
        employee: {
          'id': '',
          'name': '',
          'thumb': null,
          'email': '',
          'phone': '',
          'designation': '',
          'selected': false,
          'starred': false,
          'frequently': false,
          'password': '',
          role: ''
        },
        onSaveEmp: this.onSaveEmp,
        onEmpClose: this.onEmpClose,
        onDeleteEmp: this.onDeleteEmp,
        showEmpLoader: this.showEmpLoader
      }), showMessage && _reactNotifications.NotificationManager.success(alertMessage, this.handleEmpRequestClose()), _react["default"].createElement(_reactNotifications.NotificationContainer, null));
    }
  }]);

  return Employee;
}(_react.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var emps = _ref.emps,
      settings = _ref.settings,
      orgs = _ref.orgs;
  var width = settings.width;
  var org = orgs.org;
  var loader = emps.loader,
      alertMessage = emps.alertMessage,
      showMessage = emps.showMessage,
      noContentFoundMessage = emps.noContentFoundMessage,
      selectedSectionId = emps.selectedSectionId,
      drawerState = emps.drawerState,
      emp = emps.emp,
      searchEmp = emps.searchEmp,
      filterOption = emps.filterOption,
      allEmp = emps.allEmp,
      empList = emps.empList,
      selectedEmp = emps.selectedEmp,
      selectedEmps = emps.selectedEmps,
      addEmpState = emps.addEmpState;
  return {
    width: width,
    loader: loader,
    alertMessage: alertMessage,
    showMessage: showMessage,
    noContentFoundMessage: noContentFoundMessage,
    selectedSectionId: selectedSectionId,
    drawerState: drawerState,
    emp: emp,
    searchEmp: searchEmp,
    filterOption: filterOption,
    allEmp: allEmp,
    empList: empList,
    selectedEmp: selectedEmp,
    selectedEmps: selectedEmps,
    addEmpState: addEmpState,
    org: org
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  fetchEmps: _Employee.fetchEmps,
  addFavouriteEmp: _Employee.addFavouriteEmp,
  onEmpSelect: _Employee.onEmpSelect,
  onAddEmp: _Employee.onAddEmp,
  onEmpClose: _Employee.onEmpClose,
  onFilterEmpOptionSelect: _Employee.onFilterEmpOptionSelect,
  onSaveEmp: _Employee.onSaveEmp,
  onDeleteEmp: _Employee.onDeleteEmp,
  onDeleteSelectedEmp: _Employee.onDeleteSelectedEmp,
  filterEmp: _Employee.filterEmp,
  getAllEmp: _Employee.getAllEmp,
  getUnselectedAllEmp: _Employee.getUnselectedAllEmp,
  onAllEmpSelect: _Employee.onAllEmpSelect,
  updateSearchEmp: _Employee.updateSearchEmp,
  onToggleEmpDrawer: _Employee.onToggleEmpDrawer,
  handleEmpRequestClose: _Employee.handleEmpRequestClose,
  hideEmpLoader: _Employee.hideEmpLoader,
  showEmpLoader: _Employee.showEmpLoader
})(Employee);

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(filterOptions, "filterOptions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/employee/index.js");

  __REACT_HOT_LOADER__.register(Employee, "Employee", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/employee/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/employee/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/employee/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/employee/index.js");

  __REACT_HOT_LOADER__.register(_rcDrawer, "_rcDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/employee/index.js");

  __REACT_HOT_LOADER__.register(_EmpList, "_EmpList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/employee/index.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/employee/index.js");

  __REACT_HOT_LOADER__.register(_AddEmp, "_AddEmp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/employee/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/employee/index.js");

  __REACT_HOT_LOADER__.register(_CircularProgress, "_CircularProgress", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/employee/index.js");

  __REACT_HOT_LOADER__.register(_CustomScrollbars, "_CustomScrollbars", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/employee/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/employee/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/employee/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/employee/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/employee/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/employee/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/employee/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/employee/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/employee/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/employee/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/employee/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/employee/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/employee/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/employee/index.js");

  __REACT_HOT_LOADER__.register(filterOptions, "filterOptions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/employee/index.js");

  __REACT_HOT_LOADER__.register(Employee, "Employee", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/employee/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/employee/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/employee/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/employee/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/employee/index.js");
}();

;

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _index = _interopRequireDefault(__webpack_require__(1814));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var EmpList = function EmpList(_ref) {
  var width = _ref.width,
      data = _ref.data,
      addFavouriteEmp = _ref.addFavouriteEmp,
      onEmpSelect = _ref.onEmpSelect,
      onSaveEmp = _ref.onSaveEmp,
      onDeleteEmp = _ref.onDeleteEmp,
      showEmpLoader = _ref.showEmpLoader;
  return _react["default"].createElement("div", {
    className: "app-main-content"
  }, data.map(function (data, index) {
    return _react["default"].createElement(_index["default"], {
      key: index,
      width: width,
      employee: data,
      onDeleteEmp: onDeleteEmp,
      onSaveEmp: onSaveEmp,
      showEmpLoader: showEmpLoader,
      addFavouriteEmp: addFavouriteEmp,
      onEmpSelect: onEmpSelect
    });
  }));
};

var _default = EmpList;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(EmpList, "EmpList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/EmpList/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/EmpList/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/EmpList/index.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/EmpList/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/EmpList/index.js");

  __REACT_HOT_LOADER__.register(EmpList, "EmpList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/EmpList/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/EmpList/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/EmpList/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/EmpList/index.js");
}();

;

/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _reactBootstrapSweetalert = _interopRequireDefault(__webpack_require__(80));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _index = _interopRequireDefault(__webpack_require__(808));

var _listRowImage = _interopRequireDefault(__webpack_require__(126));

var _ListRowFavourite = _interopRequireDefault(__webpack_require__(127));

var _ListRowCheckbox = _interopRequireDefault(__webpack_require__(107));

var _ListRowDropdown = _interopRequireDefault(__webpack_require__(128));

var _ListRowData = _interopRequireDefault(__webpack_require__(129));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var EmpRow =
/*#__PURE__*/
function (_React$Component) {
  _inherits(EmpRow, _React$Component);

  function EmpRow() {
    var _this;

    _classCallCheck(this, EmpRow);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EmpRow).call(this));

    _defineProperty(_assertThisInitialized(_this), "onEmpOptionToggle", function () {
      var _this2;

      return (_this2 = _this).__onEmpOptionToggle__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onEmpClose", function () {
      var _this3;

      return (_this3 = _this).__onEmpClose__REACT_HOT_LOADER__.apply(_this3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onDeleteEmp", function () {
      var _this4;

      return (_this4 = _this).__onDeleteEmp__REACT_HOT_LOADER__.apply(_this4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onEditEmp", function () {
      var _this5;

      return (_this5 = _this).__onEditEmp__REACT_HOT_LOADER__.apply(_this5, arguments);
    });

    _this.state = {
      menuState: false,
      addEmpState: false,
      deleteCheck: false
    };
    return _this;
  }

  _createClass(EmpRow, [{
    key: "__onEmpOptionToggle__REACT_HOT_LOADER__",
    value: function __onEmpOptionToggle__REACT_HOT_LOADER__() {
      this.setState({
        menuState: !this.state.menuState
      });
    }
  }, {
    key: "__onEmpClose__REACT_HOT_LOADER__",
    value: function __onEmpClose__REACT_HOT_LOADER__() {
      this.setState({
        addEmpState: false,
        deleteCheck: false
      });
    }
  }, {
    key: "__onDeleteEmp__REACT_HOT_LOADER__",
    value: function __onDeleteEmp__REACT_HOT_LOADER__(org) {
      this.setState({
        addEmpState: false,
        deleteCheck: false
      });
      this.props.onDeleteEmp(org);
    }
  }, {
    key: "__onEditEmp__REACT_HOT_LOADER__",
    value: function __onEditEmp__REACT_HOT_LOADER__() {
      this.setState({
        menuState: false,
        addEmpState: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var _this$props = this.props,
          width = _this$props.width,
          employee = _this$props.employee,
          addFavouriteEmp = _this$props.addFavouriteEmp,
          onEmpSelect = _this$props.onEmpSelect,
          onSaveEmp = _this$props.onSaveEmp,
          showEmpLoader = _this$props.showEmpLoader;
      var _this$state = this.state,
          menuState = _this$state.menuState,
          addEmpState = _this$state.addEmpState,
          deleteCheck = _this$state.deleteCheck;
      var name = employee.name,
          email = employee.email,
          phone = employee.phone,
          starred = employee.starred;
      var options = ['Edit', 'Deleteit'];
      return _react["default"].createElement("div", {
        className: "contact-item"
      }, _react["default"].createElement(_ListRowCheckbox["default"], {
        selected: employee.selected,
        onClick: function onClick() {
          onEmpSelect(employee);
        }
      }), _react["default"].createElement(_ListRowFavourite["default"], {
        width: width,
        onClick: function onClick() {
          addFavouriteEmp(employee);
        },
        starred: starred
      }), _react["default"].createElement(_listRowImage["default"], {
        width: width,
        data: employee
      }), _react["default"].createElement(_ListRowData["default"], {
        lineOne: name,
        lineTwoLeft: email,
        lineTwoRight: phone
      }), _react["default"].createElement(_ListRowDropdown["default"], {
        menuState: menuState,
        toggle: this.onEmpOptionToggle.bind(this),
        options: options,
        dropdownItems: options.map(function (option) {
          return _react["default"].createElement(_reactstrap.DropdownItem, {
            key: option,
            onClick: function onClick() {
              if (option === 'Edit') {
                _this6.onEditEmp();
              } else if (option === 'Deleteit') {
                _this6.setState({
                  deleteCheck: true
                });
              }
            }
          }, option);
        })
      }), _react["default"].createElement("div", null, addEmpState && _react["default"].createElement(_index["default"], {
        open: addEmpState,
        employee: employee,
        onSaveEmp: onSaveEmp,
        onEmpClose: this.onEmpClose,
        onDeleteEmp: this.onDeleteEmp,
        showEmpLoader: showEmpLoader
      })), _react["default"].createElement(_reactBootstrapSweetalert["default"], {
        show: deleteCheck,
        warning: true,
        showCancel: true,
        confirmBtnText: _react["default"].createElement(_IntlMessages["default"], {
          id: "button.yesDeleteIt"
        }),
        cancelBtnText: _react["default"].createElement(_IntlMessages["default"], {
          id: "button.cancel"
        }),
        confirmBtnBsStyle: "danger",
        cancelBtnBsStyle: "default",
        title: _react["default"].createElement("span", {
          style: {
            fontWeight: 'bold',
            color: 'grey',
            fontSize: '200%'
          }
        }, _react["default"].createElement(_IntlMessages["default"], {
          id: "general.areYouSure"
        })),
        onConfirm: function onConfirm() {
          _this6.onDeleteEmp(employee);

          _this6.setState({
            deleteCheck: false
          });
        },
        onCancel: function onCancel() {
          _this6.setState({
            deleteCheck: false
          });
        }
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "emp.deleteEmp"
      })));
    }
  }]);

  return EmpRow;
}(_react["default"].Component);

var _default = EmpRow;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(EmpRow, "EmpRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/EmpList/EmpRow/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/EmpList/EmpRow/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/EmpList/EmpRow/index.js");

  __REACT_HOT_LOADER__.register(_reactBootstrapSweetalert, "_reactBootstrapSweetalert", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/EmpList/EmpRow/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/EmpList/EmpRow/index.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/EmpList/EmpRow/index.js");

  __REACT_HOT_LOADER__.register(_listRowImage, "_listRowImage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/EmpList/EmpRow/index.js");

  __REACT_HOT_LOADER__.register(_ListRowFavourite, "_ListRowFavourite", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/EmpList/EmpRow/index.js");

  __REACT_HOT_LOADER__.register(_ListRowCheckbox, "_ListRowCheckbox", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/EmpList/EmpRow/index.js");

  __REACT_HOT_LOADER__.register(_ListRowDropdown, "_ListRowDropdown", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/EmpList/EmpRow/index.js");

  __REACT_HOT_LOADER__.register(_ListRowData, "_ListRowData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/EmpList/EmpRow/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/EmpList/EmpRow/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/EmpList/EmpRow/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/EmpList/EmpRow/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/EmpList/EmpRow/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/EmpList/EmpRow/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/EmpList/EmpRow/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/EmpList/EmpRow/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/EmpList/EmpRow/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/EmpList/EmpRow/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/EmpList/EmpRow/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/EmpList/EmpRow/index.js");

  __REACT_HOT_LOADER__.register(EmpRow, "EmpRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/EmpList/EmpRow/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/EmpList/EmpRow/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/EmpList/EmpRow/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Employee/EmpList/EmpRow/index.js");
}();

;

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _recharts = __webpack_require__(108);

var _data = __webpack_require__(1816);

var _ChartCard = _interopRequireDefault(__webpack_require__(233));

var _index = _interopRequireDefault(__webpack_require__(63));

var _SalesStatistic = _interopRequireDefault(__webpack_require__(879));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var AgileDashboard =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AgileDashboard, _React$Component);

  _createClass(AgileDashboard, [{
    key: "__onOptionMenuToggle__REACT_HOT_LOADER__",
    value: function __onOptionMenuToggle__REACT_HOT_LOADER__() {
      this.setState({
        menuState: !this.state.menuState
      });
    }
  }, {
    key: "__handleRequestClose__REACT_HOT_LOADER__",
    value: function __handleRequestClose__REACT_HOT_LOADER__() {
      this.setState({
        menuState: false
      });
    }
  }]);

  function AgileDashboard() {
    var _this;

    _classCallCheck(this, AgileDashboard);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AgileDashboard).call(this));

    _defineProperty(_assertThisInitialized(_this), "onOptionMenuToggle", function () {
      var _this2;

      return (_this2 = _this).__onOptionMenuToggle__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "handleRequestClose", function () {
      var _this3;

      return (_this3 = _this).__handleRequestClose__REACT_HOT_LOADER__.apply(_this3, arguments);
    });

    _this.state = {
      menuState: false
    };
    return _this;
  }

  _createClass(AgileDashboard, [{
    key: "render",
    value: function render() {
      return _react["default"].createElement("div", {
        className: "dashboard animated slideInUpTiny animation-duration-3"
      }, _react["default"].createElement(_index["default"], {
        match: this.props.match,
        title: _react["default"].createElement(_IntlMessages["default"], {
          id: "sidebar.superuser.dashboard"
        })
      }), _react["default"].createElement("div", {
        className: "row"
      }, _react["default"].createElement("div", {
        className: "col-lg-3 col-sm-6 col-12"
      }, _react["default"].createElement(_ChartCard["default"], {
        styleName: "bg-secondary text-white"
      }, _react["default"].createElement("div", {
        className: "chart-title"
      }, _react["default"].createElement("h2", null, "1379"), _react["default"].createElement("p", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "dashboard.onlineSignups"
      }))), _react["default"].createElement(_recharts.ResponsiveContainer, {
        width: "100%",
        height: 110
      }, _react["default"].createElement(_recharts.BarChart, {
        data: _data.data
      }, _react["default"].createElement(_recharts.Bar, {
        dataKey: "pv",
        fill: "white"
      }), _react["default"].createElement(_recharts.Bar, {
        dataKey: "uv",
        fill: "white"
      }))))), _react["default"].createElement("div", {
        className: "col-lg-3 col-sm-6 col-12"
      }, _react["default"].createElement(_ChartCard["default"], {
        styleName: "bg-primary text-white"
      }, _react["default"].createElement("div", {
        className: "chart-title"
      }, _react["default"].createElement("h2", null, "$7,890"), _react["default"].createElement("p", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "dashboard.lastMonthSale"
      }))), _react["default"].createElement(_recharts.ResponsiveContainer, {
        width: "100%",
        height: 110
      }, _react["default"].createElement(_recharts.AreaChart, {
        data: _data.data1,
        margin: {
          top: 0,
          right: 0,
          left: 0,
          bottom: 0
        }
      }, _react["default"].createElement(_recharts.Area, {
        type: "monotone",
        dataKey: "pv",
        stroke: "rgba(255,255,255,0.5)",
        activeDot: {
          r: 8
        },
        fillOpacity: .5,
        fill: "white"
      }))))), _react["default"].createElement("div", {
        className: "col-lg-3 col-sm-6 col-12"
      }, _react["default"].createElement(_ChartCard["default"], {
        styleName: "bg-teal lighten-1 text-white"
      }, _react["default"].createElement("div", {
        className: "chart-title"
      }, _react["default"].createElement("h2", null, "236"), _react["default"].createElement("p", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "dashboard.newVisits"
      }))), _react["default"].createElement(_recharts.ResponsiveContainer, {
        width: "100%",
        height: 110
      }, _react["default"].createElement(_recharts.LineChart, {
        data: _data.data2
      }, _react["default"].createElement(_recharts.Line, {
        type: "monotone",
        dataKey: "uv",
        stroke: "#ffffff",
        activeDot: {
          r: 8
        }
      }), _react["default"].createElement(_recharts.Line, {
        type: "monotone",
        dataKey: "pv",
        stroke: "#ffffff"
      }), _react["default"].createElement(_recharts.Line, {
        type: "monotone",
        dataKey: "amt",
        stroke: "#ffffff"
      }))))), _react["default"].createElement("div", {
        className: "col-lg-3 col-sm-6 col-12"
      }, _react["default"].createElement(_ChartCard["default"], {
        styleName: "bg-blue text-white"
      }, _react["default"].createElement("div", {
        className: "chart-title"
      }, _react["default"].createElement("h2", null, "$87,345"), _react["default"].createElement("p", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "dashboard.totalRevenue"
      }))), _react["default"].createElement(_recharts.ResponsiveContainer, {
        width: "100%",
        height: 110
      }, _react["default"].createElement(_recharts.LineChart, {
        data: _data.data1
      }, _react["default"].createElement(_recharts.Line, {
        dataKey: "uv",
        stroke: "#ffffff",
        activeDot: {
          r: 8
        }
      })))))), _react["default"].createElement("div", {
        className: "row"
      }, _react["default"].createElement("div", {
        className: "col-12"
      }, _react["default"].createElement(_SalesStatistic["default"], null))));
    }
  }]);

  return AgileDashboard;
}(_react["default"].Component);

var _default = AgileDashboard;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AgileDashboard, "AgileDashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/index.js");

  __REACT_HOT_LOADER__.register(_ChartCard, "_ChartCard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/index.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/index.js");

  __REACT_HOT_LOADER__.register(_SalesStatistic, "_SalesStatistic", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/index.js");

  __REACT_HOT_LOADER__.register(AgileDashboard, "AgileDashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/index.js");
}();

;

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.marketingData = exports.announcementsNotification = exports.appNotification = exports.customers = exports.products = exports.radialData = exports.lineChartData = exports.pieChartData = exports.chartDataWithoutAxis = exports.chartData = exports.radarChartData = exports.data2 = exports.data1 = exports.data = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var data = [{
  name: 'Let A',
  uv: 0,
  pv: 0,
  amt: 20
}, {
  name: 'Let B',
  uv: 30,
  pv: 13,
  amt: 21
}, {
  name: 'Let C',
  uv: 20,
  pv: 98,
  amt: 29
}, {
  name: 'Let D',
  uv: 27,
  pv: 39,
  amt: 20
}, {
  name: 'Let E',
  uv: 18,
  pv: 48,
  amt: 28
}, {
  name: 'Let F',
  uv: 23,
  pv: 38,
  amt: 20
}, {
  name: 'Let G',
  uv: 0,
  pv: 0,
  amt: 20
}];
exports.data = data;
var data1 = [{
  name: 'Let A',
  uv: 40,
  pv: 24,
  amt: 20
}, {
  name: 'Let B',
  uv: 30,
  pv: 13,
  amt: 21
}, {
  name: 'Let C',
  uv: 60,
  pv: 98,
  amt: 29
}, {
  name: 'Let D',
  uv: 27,
  pv: 39,
  amt: 20
}, {
  name: 'Let E',
  uv: 78,
  pv: 48,
  amt: 28
}, {
  name: 'Let F',
  uv: 23,
  pv: 38,
  amt: 20
}, {
  name: 'Let G',
  uv: 56,
  pv: 43,
  amt: 20
}];
exports.data1 = data1;
var data2 = [{
  name: 'Let A',
  uv: 40,
  pv: 24,
  amt: 20
}, {
  name: 'Let B',
  uv: 10,
  pv: 13,
  amt: 21
}, {
  name: 'Let C',
  uv: 60,
  pv: 98,
  amt: 29
}, {
  name: 'Let D',
  uv: 27,
  pv: 15,
  amt: 20
}, {
  name: 'Let E',
  uv: 56,
  pv: 45,
  amt: 28
}, {
  name: 'Let F',
  uv: 23,
  pv: 56,
  amt: 20
}, {
  name: 'Let G',
  uv: 56,
  pv: 43,
  amt: 20
}];
exports.data2 = data2;
var radarChartData = [{
  subject: 'Math',
  A: 120,
  B: 110,
  fullMark: 150
}, {
  subject: 'Chinese',
  A: 98,
  B: 130,
  fullMark: 150
}, {
  subject: 'English',
  A: 86,
  B: 130,
  fullMark: 150
}, {
  subject: 'Geography',
  A: 99,
  B: 100,
  fullMark: 150
}, {
  subject: 'Physics',
  A: 85,
  B: 90,
  fullMark: 150
}, {
  subject: 'History',
  A: 65,
  B: 85,
  fullMark: 150
}];
exports.radarChartData = radarChartData;
var chartData = [{
  name: 'J',
  amt: 1400
}, {
  name: 'F',
  amt: 2210
}, {
  name: 'M',
  amt: 1000
}, {
  name: 'A',
  amt: 2000
}, {
  name: 'M',
  amt: 1400
}, {
  name: 'J',
  amt: 2300
}, {
  name: 'J',
  amt: 500
}, {
  name: 'A',
  amt: 2000
}, {
  name: 'S',
  amt: 1500
}, {
  name: 'S',
  amt: 1500
}, {
  name: 'O',
  amt: 1000
}, {
  name: 'N',
  amt: 2000
}, {
  name: 'D',
  amt: 500
}];
exports.chartData = chartData;
var chartDataWithoutAxis = [{
  name: 'J',
  amt: 1400
}, {
  name: 'F',
  amt: 2210
}, {
  name: 'M',
  amt: 1000
}, {
  name: 'A',
  amt: 2000
}, {
  name: 'M',
  amt: 1400
}, {
  name: 'J',
  amt: 2300
}, {
  name: 'J',
  amt: 500
}, {
  name: 'A',
  amt: 2000
}, {
  name: 'S',
  amt: 1500
}, {
  name: 'O',
  amt: 1000
}, {
  name: 'N',
  amt: 2000
}, {
  name: 'D',
  amt: 500
}, {
  name: 'M',
  amt: 1000
}, {
  name: 'A',
  amt: 2000
}, {
  name: 'M',
  amt: 1400
}];
exports.chartDataWithoutAxis = chartDataWithoutAxis;
var pieChartData = [{
  name: 'J',
  amt: 24
}, {
  name: 'F',
  amt: 18
}, {
  name: 'M',
  amt: 22
}, {
  name: 'A',
  amt: 17
}, {
  name: 'M',
  amt: 25
}, {
  name: 'J',
  amt: 12
}, {
  name: 'J',
  amt: 21
}];
exports.pieChartData = pieChartData;
var lineChartData = [{
  name: 'J',
  amt: 24244
}, {
  name: 'F',
  amt: 18123
}, {
  name: 'M',
  amt: 22765
}, {
  name: 'A',
  amt: 17097
}, {
  name: 'M',
  amt: 25529
}, {
  name: 'J',
  amt: 18669
}, {
  name: 'J',
  amt: 21812
}, {
  name: 'S',
  amt: 14988
}, {
  name: 'O',
  amt: 18693
}, {
  name: 'N',
  amt: 22900
}, {
  name: 'D',
  amt: 25313
}];
exports.lineChartData = lineChartData;
var radialData = [{
  name: 'Monthly Data',
  data: 48845,
  fill: '#3367d6'
}, {
  name: 'Orders Weekly',
  data: 8875,
  fill: '#83a6ed'
}, {
  name: 'Average Revenue',
  data: 21342,
  fill: '#8dd1e1'
}, {
  name: 'Total Revenue',
  data: 51875,
  fill: '#ffc658'
}, {
  name: 'Total Orders',
  data: 9223,
  fill: '#a4de6c'
}, {
  name: 'Past Orders',
  data: 8543,
  fill: '#d0ed57'
}];
exports.radialData = radialData;
var products = [{
  image: 'http://via.placeholder.com/600x450',
  title: "Up unpacked friendly",
  description: "Contrary to popular belief, Lorem Ipsum is not simply random text.",
  mrp: 250,
  offerPrice: 200
}, {
  image: 'http://via.placeholder.com/500x330',
  title: "It allowance prevailed",
  description: "It is a long established fact that a reader will be distracted",
  mrp: 250,
  offerPrice: 200
}, {
  image: 'http://via.placeholder.com/500x330',
  title: "Case read they must",
  description: "There are many variations of passages of Lorem Ipsum available",
  mrp: 250,
  offerPrice: 200
}, {
  image: 'http://via.placeholder.com/500x330',
  title: "Too carriage attended",
  description: "The standard chunk of Lorem Ipsum used since the 1500s",
  mrp: 250,
  offerPrice: 200
}];
exports.products = products;
var customers = [{
  id: 1,
  image: 'http://via.placeholder.com/150x150',
  name: "John Smith",
  about: "@john.s",
  detail: "3 orders",
  color: "success"
}, {
  id: 2,
  image: 'http://via.placeholder.com/150x150',
  name: "alex dolgove",
  about: "@Alex.Dolgove",
  detail: "2 orders",
  color: "primary"
}, {
  id: 3,
  image: 'http://via.placeholder.com/150x150',
  name: "Domnic Brown",
  about: "@domnic.brown",
  detail: "0 orders",
  color: "danger"
}, {
  id: 4,
  image: 'http://via.placeholder.com/150x150',
  name: "Jimmy jo",
  about: "@jimmy.jo",
  detail: "1 orders",
  color: "primary"
}];
exports.customers = customers;
var appNotification = [{
  id: 1,
  title: "NEW ORDER",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Stella"), " has placed an order for 3 items of $234.0"],
  image: 'http://via.placeholder.com/150x150'
}, {
  id: 2,
  title: "Support ticket",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Jeson Born"), " raised a support ticket"],
  image: 'http://via.placeholder.com/150x150'
}, {
  id: 3,
  title: "new enquiry",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Guptil"), " has placed an order for 5 items of $425.0"],
  image: 'http://via.placeholder.com/150x150'
}, {
  id: 4,
  title: "NEW ORDER",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Alex Dolgove"), " raised a support ticket"],
  image: 'http://via.placeholder.com/150x150'
}];
exports.appNotification = appNotification;
var announcementsNotification = [{
  id: 5,
  title: "NEW ORDER",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Alex Dolgove"), " raised a support ticket"],
  image: 'http://via.placeholder.com/150x150'
}, {
  id: 6,
  title: "Support ticket",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Jeson Born"), " raised a support ticket"],
  image: 'http://via.placeholder.com/150x150'
}, {
  id: 7,
  title: "NEW ORDER",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Stella"), " has placed an order for 3 items of $234.0"],
  image: 'http://via.placeholder.com/150x150'
}, {
  id: 8,
  title: "new enquiry",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Guptil"), " has placed an order for 5 items of $425.0"],
  image: 'http://via.placeholder.com/150x150'
}];
exports.announcementsNotification = announcementsNotification;
var marketingData = [{
  id: 1,
  name: 'Facebook Ads',
  desc: '63 Likes, 387 Shares',
  icon: 'facebook',
  color: 'bg-indigo lighten-1',
  budget: 570,
  growth: 20
}, {
  id: 2,
  name: 'Twitter Ads',
  desc: '43 Likes, 545 Shares',
  icon: 'twitter',
  color: 'bg-light-blue accent-2',
  budget: 811,
  growth: -5
}, {
  id: 3,
  name: 'Instagram',
  desc: '83 Follows, 210 Likes',
  icon: 'instagram',
  color: 'bg-brown lighten-1',
  budget: 685,
  growth: 20
}, {
  id: 4,
  name: 'LinkedIn',
  desc: '23 Shares, 764 Likes',
  icon: 'linkedin',
  color: 'bg-light-blue darken-3',
  budget: 868,
  growth: 25
}, {
  id: 5,
  name: 'Youtube',
  desc: '1.2k subscribe, 1.8M Likes',
  icon: 'youtube',
  color: 'bg-red accent-4',
  budget: 780,
  growth: 45
}, {
  id: 6,
  name: 'Dribbble',
  desc: '23 Shares, 1.4k Likes',
  icon: 'dribbble',
  color: 'bg-pink lighten-2',
  budget: 868,
  growth: 25
}];
exports.marketingData = marketingData;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(data, "data", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/data.js");

  __REACT_HOT_LOADER__.register(data1, "data1", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/data.js");

  __REACT_HOT_LOADER__.register(data2, "data2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/data.js");

  __REACT_HOT_LOADER__.register(radarChartData, "radarChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/data.js");

  __REACT_HOT_LOADER__.register(chartData, "chartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/data.js");

  __REACT_HOT_LOADER__.register(chartDataWithoutAxis, "chartDataWithoutAxis", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/data.js");

  __REACT_HOT_LOADER__.register(pieChartData, "pieChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/data.js");

  __REACT_HOT_LOADER__.register(lineChartData, "lineChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/data.js");

  __REACT_HOT_LOADER__.register(radialData, "radialData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/data.js");

  __REACT_HOT_LOADER__.register(products, "products", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/data.js");

  __REACT_HOT_LOADER__.register(customers, "customers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/data.js");

  __REACT_HOT_LOADER__.register(appNotification, "appNotification", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/data.js");

  __REACT_HOT_LOADER__.register(announcementsNotification, "announcementsNotification", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/data.js");

  __REACT_HOT_LOADER__.register(marketingData, "marketingData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/data.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/data.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/data.js");

  __REACT_HOT_LOADER__.register(data, "data", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/data.js");

  __REACT_HOT_LOADER__.register(data1, "data1", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/data.js");

  __REACT_HOT_LOADER__.register(data2, "data2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/data.js");

  __REACT_HOT_LOADER__.register(radarChartData, "radarChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/data.js");

  __REACT_HOT_LOADER__.register(chartData, "chartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/data.js");

  __REACT_HOT_LOADER__.register(chartDataWithoutAxis, "chartDataWithoutAxis", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/data.js");

  __REACT_HOT_LOADER__.register(pieChartData, "pieChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/data.js");

  __REACT_HOT_LOADER__.register(lineChartData, "lineChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/data.js");

  __REACT_HOT_LOADER__.register(radialData, "radialData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/data.js");

  __REACT_HOT_LOADER__.register(products, "products", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/data.js");

  __REACT_HOT_LOADER__.register(customers, "customers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/data.js");

  __REACT_HOT_LOADER__.register(appNotification, "appNotification", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/data.js");

  __REACT_HOT_LOADER__.register(announcementsNotification, "announcementsNotification", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/data.js");

  __REACT_HOT_LOADER__.register(marketingData, "marketingData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/data.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Dashboard/data.js");
}();

;

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Container["default"];
  }
});

var _Container = _interopRequireDefault(__webpack_require__(1818));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_Container, "_Container", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/index.js");
}();

;

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactRedux = __webpack_require__(10);

var _Organisation = __webpack_require__(144);

var _project = __webpack_require__(179);

var _Component = _interopRequireDefault(__webpack_require__(1819));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var mapStateToProps = function mapStateToProps(_ref) {
  var orgs = _ref.orgs,
      projects = _ref.projects;
  var loader = orgs.loader,
      alertMessage = orgs.alertMessage,
      showMessage = orgs.showMessage,
      selectedOrg = orgs.selectedOrg,
      orgDashboardData = orgs.orgDashboardData,
      orgStatisticsData = orgs.orgStatisticsData;
  var projectList = projects.projectList;
  return {
    loader: loader,
    alertMessage: alertMessage,
    showMessage: showMessage,
    selectedOrg: selectedOrg,
    orgDashboardData: orgDashboardData,
    projectList: projectList,
    orgStatisticsData: orgStatisticsData
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  onEmpDashboard: _Organisation.onEmpDashboard,
  onOrgSurveyDashboard: _Organisation.onOrgSurveyDashboard,
  onOrgSurveyCompareDashboard: _Organisation.onOrgSurveyCompareDashboard,
  showOrgLoader: _Organisation.showOrgLoader,
  fetchOrgs: _Organisation.fetchOrgs,
  fetchOrg: _Organisation.fetchOrg,
  fetchOrgsAndSelectOrg: _Organisation.fetchOrgsAndSelectOrg,
  onOrgDashboard: _Organisation.onOrgDashboard,
  fetchProjects: _project.fetchProjects,
  onProjectPrioritiesDashboard: _project.onProjectPrioritiesDashboard,
  onProjectCostPrioritiesDashboard: _project.onProjectCostPrioritiesDashboard,
  onProjectBusinessPrioritiesDashboard: _project.onProjectBusinessPrioritiesDashboard,
  fetchOrgStatistics: _Organisation.fetchOrgStatistics
})(_Component["default"]);

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/Container.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/Container.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_Component, "_Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/Container.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/Container.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/Container.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/Container.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/Container.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/Container.js");
}();

;

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Component = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _recharts = __webpack_require__(108);

var _data = __webpack_require__(1820);

var _store = __webpack_require__(54);

var _ChartCard = _interopRequireDefault(__webpack_require__(233));

var _index = _interopRequireDefault(__webpack_require__(63));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _Authentication = __webpack_require__(42);

var _surveyStatistic = _interopRequireDefault(__webpack_require__(1821));

var _projectListItem = _interopRequireDefault(__webpack_require__(1822));

var _projectService = __webpack_require__(175);

var _SurveyService = __webpack_require__(176);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Component =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Component, _React$Component);

  _createClass(Component, [{
    key: "__onOptionMenuToggle__REACT_HOT_LOADER__",
    value: function __onOptionMenuToggle__REACT_HOT_LOADER__() {
      this.setState({
        menuState: !this.state.menuState
      });
    }
  }, {
    key: "__handleRequestClose__REACT_HOT_LOADER__",
    value: function __handleRequestClose__REACT_HOT_LOADER__() {
      this.setState({
        menuState: false
      });
    }
  }]);

  function Component() {
    var _this;

    _classCallCheck(this, Component);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Component).call(this));

    _defineProperty(_assertThisInitialized(_this), "onOptionMenuToggle", function () {
      var _this2;

      return (_this2 = _this).__onOptionMenuToggle__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "handleRequestClose", function () {
      var _this3;

      return (_this3 = _this).__handleRequestClose__REACT_HOT_LOADER__.apply(_this3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onProject", function () {
      var _this4;

      return (_this4 = _this).__onProject__REACT_HOT_LOADER__.apply(_this4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onProjectCostPrioritiesDashboard", function () {
      var _this5;

      return (_this5 = _this).__onProjectCostPrioritiesDashboard__REACT_HOT_LOADER__.apply(_this5, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onProjectBusinessPrioritiesDashboard", function () {
      var _this6;

      return (_this6 = _this).__onProjectBusinessPrioritiesDashboard__REACT_HOT_LOADER__.apply(_this6, arguments);
    });

    _this.state = {
      menuState: false,
      cardHeight: 0 // set to 60+ if you want the graphs to show on the dashboard (does take up room)

    };
    return _this;
  }

  _createClass(Component, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          showOrgLoader = _this$props.showOrgLoader,
          onOrgDashboard = _this$props.onOrgDashboard,
          fetchOrgsAndSelectOrg = _this$props.fetchOrgsAndSelectOrg,
          fetchProjects = _this$props.fetchProjects,
          fetchOrgStatistics = _this$props.fetchOrgStatistics;
      var orgid = (0, _Authentication.getIdentityOrgId)();
      showOrgLoader();
      fetchOrgsAndSelectOrg(orgid); // required if the org is updated - the org is updated but the whole list is required as well for the UI.

      fetchOrgStatistics(orgid); // projects have 2 components - local data and data we get from jira. use cache means get local data but use cache for jira data

      fetchProjects({
        orgid: orgid,
        useCache: true
      });
      onOrgDashboard();
    }
  }, {
    key: "__onProject__REACT_HOT_LOADER__",
    value: function __onProject__REACT_HOT_LOADER__() {
      _store.history.push('/app/project/default');
    }
  }, {
    key: "__onProjectCostPrioritiesDashboard__REACT_HOT_LOADER__",
    value: function __onProjectCostPrioritiesDashboard__REACT_HOT_LOADER__(project) {
      this.props.onProjectPrioritiesDashboard(project);
      this.props.onProjectCostPrioritiesDashboard(project);

      _store.history.push('/app/projectPriority/default');
    }
  }, {
    key: "__onProjectBusinessPrioritiesDashboard__REACT_HOT_LOADER__",
    value: function __onProjectBusinessPrioritiesDashboard__REACT_HOT_LOADER__(project) {
      this.props.onProjectPrioritiesDashboard(project);
      this.props.onProjectBusinessPrioritiesDashboard(project);

      _store.history.push('/app/projectPriority/default');
    }
  }, {
    key: "render",
    value: function render() {
      var _sortProjectsByWeight,
          _sortProjectsByWeight2,
          _this7 = this,
          _orgDashboardData$act,
          _orgDashboardData$ina;

      var _this$props2 = this.props,
          orgDashboardData = _this$props2.orgDashboardData,
          projectList = _this$props2.projectList,
          orgStatisticsData = _this$props2.orgStatisticsData,
          selectedOrg = _this$props2.selectedOrg;
      var cardHeight = this.state.cardHeight;
      var orderProjectList = ((_sortProjectsByWeight = (0, _projectService.sortProjectsByWeight)(projectList)) === null || _sortProjectsByWeight === void 0 ? void 0 : (_sortProjectsByWeight2 = _sortProjectsByWeight.reverse()) === null || _sortProjectsByWeight2 === void 0 ? void 0 : _sortProjectsByWeight2.slice(0, 5)) || [];
      return _react["default"].createElement("div", {
        className: "dashboard animated slideInUpTiny animation-duration-3"
      }, _react["default"].createElement("div", {
        className: "ml-3 mt-2",
        id: "orgDashboardHeader"
      }, _react["default"].createElement(_index["default"], {
        match: this.props.match,
        title: _react["default"].createElement(_IntlMessages["default"], {
          id: "sidebar.agile.dashboard.organisation"
        })
      })), _react["default"].createElement("div", {
        className: "row ml-2 mr-2 mt-2"
      }, _react["default"].createElement("div", {
        className: "col-lg-3 col-sm-6 col-12"
      }, _react["default"].createElement(_ChartCard["default"], {
        styleName: "bg-secondary text-white"
      }, _react["default"].createElement("div", {
        className: "chart-title"
      }, _react["default"].createElement("p", null, "Employees"), _react["default"].createElement("h2", null, "1")), _react["default"].createElement(_recharts.ResponsiveContainer, {
        width: "100%",
        height: cardHeight
      }, _react["default"].createElement(_recharts.BarChart, {
        data: _data.data
      }, _react["default"].createElement(_recharts.Bar, {
        dataKey: "pv",
        fill: "white"
      }), _react["default"].createElement(_recharts.Bar, {
        dataKey: "uv",
        fill: "white"
      }))))), _react["default"].createElement("div", {
        className: "col-lg-3 col-sm-6 col-12"
      }, _react["default"].createElement(_ChartCard["default"], {
        styleName: "bg-primary text-white"
      }, _react["default"].createElement("div", {
        className: "chart-title"
      }, _react["default"].createElement("p", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "dashboard.numberOfActiveSurveys"
      })), _react["default"].createElement("h2", null, (0, _SurveyService.getActiveSurveysCount)(selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.surveys))), _react["default"].createElement(_recharts.ResponsiveContainer, {
        width: "100%",
        height: cardHeight
      }, _react["default"].createElement(_recharts.AreaChart, {
        data: _data.data1,
        margin: {
          top: 0,
          right: 0,
          left: 0,
          bottom: 0
        }
      }, _react["default"].createElement(_recharts.Area, {
        type: "monotone",
        dataKey: "pv",
        stroke: "rgba(255,255,255,0.5)",
        activeDot: {
          r: 8
        },
        fillOpacity: .5,
        fill: "white"
      }))))), _react["default"].createElement("div", {
        className: "col-lg-3 col-sm-6 col-12"
      }, _react["default"].createElement(_ChartCard["default"], {
        styleName: "bg-teal lighten-1 text-white"
      }, _react["default"].createElement("div", {
        className: "chart-title"
      }, _react["default"].createElement("p", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "dashboard.numberOfInactiveSurveys"
      })), _react["default"].createElement("h2", null, (0, _SurveyService.getInactiveSurveysCount)(selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.surveys))), _react["default"].createElement(_recharts.ResponsiveContainer, {
        width: "100%",
        height: cardHeight
      }, _react["default"].createElement(_recharts.LineChart, {
        data: _data.data2
      }, _react["default"].createElement(_recharts.Line, {
        type: "monotone",
        dataKey: "uv",
        stroke: "#ffffff",
        activeDot: {
          r: 8
        }
      }), _react["default"].createElement(_recharts.Line, {
        type: "monotone",
        dataKey: "pv",
        stroke: "#ffffff"
      }), _react["default"].createElement(_recharts.Line, {
        type: "monotone",
        dataKey: "amt",
        stroke: "#ffffff"
      }))))), _react["default"].createElement("div", {
        className: "col-lg-3 col-sm-6 col-12"
      }, _react["default"].createElement(_ChartCard["default"], {
        styleName: "bg-blue text-white"
      }, _react["default"].createElement("div", {
        className: "chart-title"
      }, _react["default"].createElement("p", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "dashboard.numberOfProjects"
      })), _react["default"].createElement("h2", null, (orgStatisticsData === null || orgStatisticsData === void 0 ? void 0 : orgStatisticsData.projectCount) || 0)), _react["default"].createElement(_recharts.ResponsiveContainer, {
        width: "100%",
        height: cardHeight
      }, _react["default"].createElement(_recharts.LineChart, {
        data: _data.data1
      }, _react["default"].createElement(_recharts.Line, {
        dataKey: "uv",
        stroke: "#ffffff",
        activeDot: {
          r: 8
        }
      })))))), _react["default"].createElement("div", {
        className: "row"
      }, _react["default"].createElement("div", {
        className: "col-12"
      }, _react["default"].createElement("div", {
        className: "ml-3 mb-2"
      }, _react["default"].createElement(_index["default"], {
        title: _react["default"].createElement(_IntlMessages["default"], {
          id: "orgDashboard.projectList"
        })
      })), _react["default"].createElement("div", {
        className: "animated slideInUpTiny animation-duration-3"
      }, orderProjectList.map(function (project, index) {
        return _react["default"].createElement(_projectListItem["default"], {
          key: index,
          data: project,
          onProjectCostPrioritiesDashboard: _this7.onProjectCostPrioritiesDashboard.bind(_this7, project),
          onProjectBusinessPrioritiesDashboard: _this7.onProjectBusinessPrioritiesDashboard.bind(_this7, project)
        });
      })))), (orgDashboardData === null || orgDashboardData === void 0 ? void 0 : (_orgDashboardData$act = orgDashboardData.activeOrgSurveysSimpleChartData) === null || _orgDashboardData$act === void 0 ? void 0 : _orgDashboardData$act.length) > 0 ? _react["default"].createElement("div", {
        className: "row"
      }, _react["default"].createElement("div", {
        className: "col-12",
        style: {
          marginLeft: '20px',
          marginTop: '10px'
        }
      }, _react["default"].createElement(_index["default"], {
        title: _react["default"].createElement(_IntlMessages["default"], {
          id: "orgDashboard.activeSurveys"
        })
      })), _react["default"].createElement("div", {
        className: "col-12"
      }, (orgDashboardData === null || orgDashboardData === void 0 ? void 0 : orgDashboardData.activeOrgSurveysSimpleChartData) ? orgDashboardData.activeOrgSurveysSimpleChartData.map(function (data, index) {
        return _react["default"].createElement(_surveyStatistic["default"], {
          key: index,
          data: data
        });
      }) : _react["default"].createElement(_react["default"].Fragment, null))) : null, (orgDashboardData === null || orgDashboardData === void 0 ? void 0 : (_orgDashboardData$ina = orgDashboardData.inactiveOrgSurveysSimpleChartData) === null || _orgDashboardData$ina === void 0 ? void 0 : _orgDashboardData$ina.length) > 0 ? _react["default"].createElement("div", {
        className: "row"
      }, _react["default"].createElement("div", {
        className: "col-12",
        style: {
          marginLeft: '20px',
          marginTop: '10px'
        }
      }, _react["default"].createElement(_index["default"], {
        title: _react["default"].createElement(_IntlMessages["default"], {
          id: "orgDashboard.inActiveSurveys"
        })
      })), _react["default"].createElement("div", {
        className: "col-12"
      }, (orgDashboardData === null || orgDashboardData === void 0 ? void 0 : orgDashboardData.inactiveOrgSurveysSimpleChartData) ? orgDashboardData.inactiveOrgSurveysSimpleChartData.map(function (data, index) {
        return _react["default"].createElement(_surveyStatistic["default"], {
          key: index,
          data: data
        });
      }) : _react["default"].createElement(_react["default"].Fragment, null))) : null);
    }
  }]);

  return Component;
}(_react["default"].Component);

exports.Component = Component;
var _default = Component;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/Component.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/Component.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/Component.js");

  __REACT_HOT_LOADER__.register(_ChartCard, "_ChartCard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/Component.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/Component.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/Component.js");

  __REACT_HOT_LOADER__.register(_surveyStatistic, "_surveyStatistic", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/Component.js");

  __REACT_HOT_LOADER__.register(_projectListItem, "_projectListItem", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/Component.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/Component.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/Component.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/Component.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/Component.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/Component.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/Component.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/Component.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/Component.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/Component.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/Component.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/Component.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/Component.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/Component.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/Component.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/Component.js");
}();

;

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.marketingData = exports.announcementsNotification = exports.appNotification = exports.customers = exports.products = exports.radialData = exports.pieChartData = exports.chartDataWithoutAxis = exports.chartData = exports.radarChartData = exports.data2 = exports.data1 = exports.data = exports.lineChartData = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var lineChartData = [[{
  name: 'J',
  amt: 24244
}, {
  name: 'F',
  amt: 18123
}, {
  name: 'M',
  amt: 22765
}, {
  name: 'A',
  amt: 17097
}, {
  name: 'M',
  amt: 25529
}, {
  name: 'J',
  amt: 18669
}, {
  name: 'J',
  amt: 21812
}, {
  name: 'S',
  amt: 14988
}, {
  name: 'O',
  amt: 18693
}, {
  name: 'N',
  amt: 22900
}, {
  name: 'D',
  amt: 25313
}]];
exports.lineChartData = lineChartData;
var data = [{
  name: 'Let A',
  uv: 0,
  pv: 0,
  amt: 20
}, {
  name: 'Let B',
  uv: 30,
  pv: 13,
  amt: 21
}, {
  name: 'Let C',
  uv: 20,
  pv: 98,
  amt: 29
}, {
  name: 'Let D',
  uv: 27,
  pv: 39,
  amt: 20
}, {
  name: 'Let E',
  uv: 18,
  pv: 48,
  amt: 28
}, {
  name: 'Let F',
  uv: 23,
  pv: 38,
  amt: 20
}, {
  name: 'Let G',
  uv: 0,
  pv: 0,
  amt: 20
}];
exports.data = data;
var data1 = [{
  name: 'Let A',
  uv: 40,
  pv: 24,
  amt: 20
}, {
  name: 'Let B',
  uv: 30,
  pv: 13,
  amt: 21
}, {
  name: 'Let C',
  uv: 60,
  pv: 98,
  amt: 29
}, {
  name: 'Let D',
  uv: 27,
  pv: 39,
  amt: 20
}, {
  name: 'Let E',
  uv: 78,
  pv: 48,
  amt: 28
}, {
  name: 'Let F',
  uv: 23,
  pv: 38,
  amt: 20
}, {
  name: 'Let G',
  uv: 56,
  pv: 43,
  amt: 20
}];
exports.data1 = data1;
var data2 = [{
  name: 'Let A',
  uv: 40,
  pv: 24,
  amt: 20
}, {
  name: 'Let B',
  uv: 10,
  pv: 13,
  amt: 21
}, {
  name: 'Let C',
  uv: 60,
  pv: 98,
  amt: 29
}, {
  name: 'Let D',
  uv: 27,
  pv: 15,
  amt: 20
}, {
  name: 'Let E',
  uv: 56,
  pv: 45,
  amt: 28
}, {
  name: 'Let F',
  uv: 23,
  pv: 56,
  amt: 20
}, {
  name: 'Let G',
  uv: 56,
  pv: 43,
  amt: 20
}];
exports.data2 = data2;
var radarChartData = [{
  subject: 'Math',
  A: 120,
  B: 110,
  fullMark: 150
}, {
  subject: 'Chinese',
  A: 98,
  B: 130,
  fullMark: 150
}, {
  subject: 'English',
  A: 86,
  B: 130,
  fullMark: 150
}, {
  subject: 'Geography',
  A: 99,
  B: 100,
  fullMark: 150
}, {
  subject: 'Physics',
  A: 85,
  B: 90,
  fullMark: 150
}, {
  subject: 'History',
  A: 65,
  B: 85,
  fullMark: 150
}];
exports.radarChartData = radarChartData;
var chartData = [{
  name: 'J',
  amt: 1400
}, {
  name: 'F',
  amt: 2210
}, {
  name: 'M',
  amt: 1000
}, {
  name: 'A',
  amt: 2000
}, {
  name: 'M',
  amt: 1400
}, {
  name: 'J',
  amt: 2300
}, {
  name: 'J',
  amt: 500
}, {
  name: 'A',
  amt: 2000
}, {
  name: 'S',
  amt: 1500
}, {
  name: 'S',
  amt: 1500
}, {
  name: 'O',
  amt: 1000
}, {
  name: 'N',
  amt: 2000
}, {
  name: 'D',
  amt: 500
}];
exports.chartData = chartData;
var chartDataWithoutAxis = [{
  name: 'J',
  amt: 1400
}, {
  name: 'F',
  amt: 2210
}, {
  name: 'M',
  amt: 1000
}, {
  name: 'A',
  amt: 2000
}, {
  name: 'M',
  amt: 1400
}, {
  name: 'J',
  amt: 2300
}, {
  name: 'J',
  amt: 500
}, {
  name: 'A',
  amt: 2000
}, {
  name: 'S',
  amt: 1500
}, {
  name: 'O',
  amt: 1000
}, {
  name: 'N',
  amt: 2000
}, {
  name: 'D',
  amt: 500
}, {
  name: 'M',
  amt: 1000
}, {
  name: 'A',
  amt: 2000
}, {
  name: 'M',
  amt: 1400
}];
exports.chartDataWithoutAxis = chartDataWithoutAxis;
var pieChartData = [{
  name: 'J',
  amt: 24
}, {
  name: 'F',
  amt: 18
}, {
  name: 'M',
  amt: 22
}, {
  name: 'A',
  amt: 17
}, {
  name: 'M',
  amt: 25
}, {
  name: 'J',
  amt: 12
}, {
  name: 'J',
  amt: 21
}];
exports.pieChartData = pieChartData;
var radialData = [{
  name: 'Monthly Data',
  data: 48845,
  fill: '#3367d6'
}, {
  name: 'Orders Weekly',
  data: 8875,
  fill: '#83a6ed'
}, {
  name: 'Average Revenue',
  data: 21342,
  fill: '#8dd1e1'
}, {
  name: 'Total Revenue',
  data: 51875,
  fill: '#ffc658'
}, {
  name: 'Total Orders',
  data: 9223,
  fill: '#a4de6c'
}, {
  name: 'Past Orders',
  data: 8543,
  fill: '#d0ed57'
}];
exports.radialData = radialData;
var products = [{
  image: 'http://via.placeholder.com/600x450',
  title: "Up unpacked friendly",
  description: "Contrary to popular belief, Lorem Ipsum is not simply random text.",
  mrp: 250,
  offerPrice: 200
}, {
  image: 'http://via.placeholder.com/500x330',
  title: "It allowance prevailed",
  description: "It is a long established fact that a reader will be distracted",
  mrp: 250,
  offerPrice: 200
}, {
  image: 'http://via.placeholder.com/500x330',
  title: "Case read they must",
  description: "There are many variations of passages of Lorem Ipsum available",
  mrp: 250,
  offerPrice: 200
}, {
  image: 'http://via.placeholder.com/500x330',
  title: "Too carriage attended",
  description: "The standard chunk of Lorem Ipsum used since the 1500s",
  mrp: 250,
  offerPrice: 200
}];
exports.products = products;
var customers = [{
  id: 1,
  image: 'http://via.placeholder.com/150x150',
  name: "John Smith",
  about: "@john.s",
  detail: "3 orders",
  color: "success"
}, {
  id: 2,
  image: 'http://via.placeholder.com/150x150',
  name: "alex dolgove",
  about: "@Alex.Dolgove",
  detail: "2 orders",
  color: "primary"
}, {
  id: 3,
  image: 'http://via.placeholder.com/150x150',
  name: "Domnic Brown",
  about: "@domnic.brown",
  detail: "0 orders",
  color: "danger"
}, {
  id: 4,
  image: 'http://via.placeholder.com/150x150',
  name: "Jimmy jo",
  about: "@jimmy.jo",
  detail: "1 orders",
  color: "primary"
}];
exports.customers = customers;
var appNotification = [{
  id: 1,
  title: "NEW ORDER",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Stella"), " has placed an order for 3 items of $234.0"],
  image: 'http://via.placeholder.com/150x150'
}, {
  id: 2,
  title: "Support ticket",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Jeson Born"), " raised a support ticket"],
  image: 'http://via.placeholder.com/150x150'
}, {
  id: 3,
  title: "new enquiry",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Guptil"), " has placed an order for 5 items of $425.0"],
  image: 'http://via.placeholder.com/150x150'
}, {
  id: 4,
  title: "NEW ORDER",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Alex Dolgove"), " raised a support ticket"],
  image: 'http://via.placeholder.com/150x150'
}];
exports.appNotification = appNotification;
var announcementsNotification = [{
  id: 5,
  title: "NEW ORDER",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Alex Dolgove"), " raised a support ticket"],
  image: 'http://via.placeholder.com/150x150'
}, {
  id: 6,
  title: "Support ticket",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Jeson Born"), " raised a support ticket"],
  image: 'http://via.placeholder.com/150x150'
}, {
  id: 7,
  title: "NEW ORDER",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Stella"), " has placed an order for 3 items of $234.0"],
  image: 'http://via.placeholder.com/150x150'
}, {
  id: 8,
  title: "new enquiry",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Guptil"), " has placed an order for 5 items of $425.0"],
  image: 'http://via.placeholder.com/150x150'
}];
exports.announcementsNotification = announcementsNotification;
var marketingData = [{
  id: 1,
  name: 'Facebook Ads',
  desc: '63 Likes, 387 Shares',
  icon: 'facebook',
  color: 'bg-indigo lighten-1',
  budget: 570,
  growth: 20
}, {
  id: 2,
  name: 'Twitter Ads',
  desc: '43 Likes, 545 Shares',
  icon: 'twitter',
  color: 'bg-light-blue accent-2',
  budget: 811,
  growth: -5
}, {
  id: 3,
  name: 'Instagram',
  desc: '83 Follows, 210 Likes',
  icon: 'instagram',
  color: 'bg-brown lighten-1',
  budget: 685,
  growth: 20
}, {
  id: 4,
  name: 'LinkedIn',
  desc: '23 Shares, 764 Likes',
  icon: 'linkedin',
  color: 'bg-light-blue darken-3',
  budget: 868,
  growth: 25
}, {
  id: 5,
  name: 'Youtube',
  desc: '1.2k subscribe, 1.8M Likes',
  icon: 'youtube',
  color: 'bg-red accent-4',
  budget: 780,
  growth: 45
}, {
  id: 6,
  name: 'Dribbble',
  desc: '23 Shares, 1.4k Likes',
  icon: 'dribbble',
  color: 'bg-pink lighten-2',
  budget: 868,
  growth: 25
}];
exports.marketingData = marketingData;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(lineChartData, "lineChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/data.js");

  __REACT_HOT_LOADER__.register(data, "data", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/data.js");

  __REACT_HOT_LOADER__.register(data1, "data1", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/data.js");

  __REACT_HOT_LOADER__.register(data2, "data2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/data.js");

  __REACT_HOT_LOADER__.register(radarChartData, "radarChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/data.js");

  __REACT_HOT_LOADER__.register(chartData, "chartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/data.js");

  __REACT_HOT_LOADER__.register(chartDataWithoutAxis, "chartDataWithoutAxis", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/data.js");

  __REACT_HOT_LOADER__.register(pieChartData, "pieChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/data.js");

  __REACT_HOT_LOADER__.register(radialData, "radialData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/data.js");

  __REACT_HOT_LOADER__.register(products, "products", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/data.js");

  __REACT_HOT_LOADER__.register(customers, "customers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/data.js");

  __REACT_HOT_LOADER__.register(appNotification, "appNotification", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/data.js");

  __REACT_HOT_LOADER__.register(announcementsNotification, "announcementsNotification", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/data.js");

  __REACT_HOT_LOADER__.register(marketingData, "marketingData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/data.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/data.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/data.js");

  __REACT_HOT_LOADER__.register(lineChartData, "lineChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/data.js");

  __REACT_HOT_LOADER__.register(data, "data", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/data.js");

  __REACT_HOT_LOADER__.register(data1, "data1", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/data.js");

  __REACT_HOT_LOADER__.register(data2, "data2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/data.js");

  __REACT_HOT_LOADER__.register(radarChartData, "radarChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/data.js");

  __REACT_HOT_LOADER__.register(chartData, "chartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/data.js");

  __REACT_HOT_LOADER__.register(chartDataWithoutAxis, "chartDataWithoutAxis", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/data.js");

  __REACT_HOT_LOADER__.register(pieChartData, "pieChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/data.js");

  __REACT_HOT_LOADER__.register(radialData, "radialData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/data.js");

  __REACT_HOT_LOADER__.register(products, "products", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/data.js");

  __REACT_HOT_LOADER__.register(customers, "customers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/data.js");

  __REACT_HOT_LOADER__.register(appNotification, "appNotification", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/data.js");

  __REACT_HOT_LOADER__.register(announcementsNotification, "announcementsNotification", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/data.js");

  __REACT_HOT_LOADER__.register(marketingData, "marketingData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/data.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/data.js");
}();

;

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _recharts = __webpack_require__(108);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var SurveyStatistic = function SurveyStatistic(_ref) {
  var data = _ref.data;
  var surveyName = data.surveyName,
      surveyEndDate = data.surveyEndDate,
      surveyStartDate = data.surveyStartDate,
      noEmployeesInvited = data.noEmployeesInvited,
      noQuestionsCompleted = data.noQuestionsCompleted,
      noQuestionsToComplete = data.noQuestionsToComplete,
      simpleChartData = data.simpleChartData,
      surveyActive = data.surveyActive;
  return _react["default"].createElement("div", {
    className: "jr-card",
    style: {
      marginLeft: '5px',
      width: '99%'
    }
  }, _react["default"].createElement("div", {
    className: "jr-card-header d-flex align-items-center"
  }, _react["default"].createElement("h3", {
    className: "mb-0"
  }, "Survey statistics for ", surveyName)), _react["default"].createElement("div", {
    className: "row mb-3"
  }, _react["default"].createElement("div", {
    className: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, _react["default"].createElement("span", {
    className: "d-flex align-items-center mb-2"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-calendar-check text-muted chart-f20"
  }), _react["default"].createElement("span", {
    className: "ml-3 text-dark"
  }, noEmployeesInvited)), _react["default"].createElement("p", {
    className: "text-muted"
  }, "Total invited")), _react["default"].createElement("div", {
    className: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, _react["default"].createElement("span", {
    className: "d-flex align-items-center mb-2"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-calendar-note text-muted chart-f20"
  }), _react["default"].createElement("span", {
    className: "ml-3 text-dark"
  }, noQuestionsCompleted)), _react["default"].createElement("p", {
    className: "text-muted"
  }, "Questions completed")), _react["default"].createElement("div", {
    className: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, _react["default"].createElement("span", {
    className: "d-flex align-items-center mb-2"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-calendar-note text-muted chart-f20"
  }), _react["default"].createElement("span", {
    className: "ml-3 text-dark"
  }, noQuestionsToComplete)), _react["default"].createElement("p", {
    className: "text-muted"
  }, "Question to complete")), _react["default"].createElement("div", {
    className: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, _react["default"].createElement("span", {
    className: "d-flex align-items-center mb-2"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-calendar-alt text-muted chart-f20"
  }), _react["default"].createElement("span", {
    className: "ml-3 text-dark"
  }, surveyStartDate)), _react["default"].createElement("p", {
    className: "text-muted"
  }, "Start date")), _react["default"].createElement("div", {
    className: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, _react["default"].createElement("span", {
    className: "d-flex align-items-center mb-2"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-calendar text-muted chart-f20"
  }), _react["default"].createElement("span", {
    className: "ml-3 text-dark"
  }, surveyEndDate)), _react["default"].createElement("p", {
    className: "text-muted"
  }, "End date")), _react["default"].createElement("div", {
    className: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, _react["default"].createElement("span", {
    className: "d-flex align-items-center mb-2"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-calendar-alt text-muted chart-f20"
  }), _react["default"].createElement("span", {
    className: "ml-3 text-dark"
  }, surveyActive ? 'Yes' : 'No')), _react["default"].createElement("p", {
    className: "text-muted"
  }, "Still active"))), _react["default"].createElement("div", {
    className: "row"
  }, _react["default"].createElement("div", {
    className: "col-lg-12 col-12 mb-5 mb-lg-1"
  }, _react["default"].createElement(_recharts.ResponsiveContainer, {
    width: "100%",
    height: 150
  }, _react["default"].createElement(_recharts.LineChart, {
    data: simpleChartData,
    margin: {
      top: 0,
      right: 0,
      left: 0,
      bottom: 0
    }
  }, _react["default"].createElement(_recharts.XAxis, {
    dataKey: "name"
  }), _react["default"].createElement(_recharts.YAxis, null), _react["default"].createElement(_recharts.CartesianGrid, {
    strokeDasharray: "3 3"
  }), _react["default"].createElement(_recharts.Tooltip, null), _react["default"].createElement(_recharts.Line, {
    type: "monotone",
    dataKey: "amt",
    stackId: "1",
    stroke: "#59AA2B",
    fill: "#59AA2B"
  }))))));
};

var _default = SurveyStatistic;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SurveyStatistic, "SurveyStatistic", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/surveyStatistic/surveyStatistic.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/surveyStatistic/surveyStatistic.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/surveyStatistic/surveyStatistic.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/surveyStatistic/surveyStatistic.js");

  __REACT_HOT_LOADER__.register(SurveyStatistic, "SurveyStatistic", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/surveyStatistic/surveyStatistic.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/surveyStatistic/surveyStatistic.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/surveyStatistic/surveyStatistic.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/surveyStatistic/surveyStatistic.js");
}();

;

/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _projectService = __webpack_require__(175);

var _simpleModal = _interopRequireDefault(__webpack_require__(419));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var getModalBody = function getModalBody(data) {
  var _data$busValPriorityP, _data$costImplPriorit;

  var modalBodyText = '';

  if ((data === null || data === void 0 ? void 0 : data.busValPriorityParams) && (data === null || data === void 0 ? void 0 : (_data$busValPriorityP = data.busValPriorityParams) === null || _data$busValPriorityP === void 0 ? void 0 : _data$busValPriorityP.length) > 0) {
    modalBodyText += '<b>Business value priority parameters (name and value)</b><br/>';
    var sortedBusValData = (0, _projectService.sortProjectPrioritiesByValue)(data === null || data === void 0 ? void 0 : data.busValPriorityParams);

    if (sortedBusValData && (sortedBusValData === null || sortedBusValData === void 0 ? void 0 : sortedBusValData.length) > 0) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = sortedBusValData.reverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var element = _step.value;
          var lineContent = element.name.concat(' ').concat(element.value).concat('<br/>');
          modalBodyText += lineContent;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  } else {
    modalBodyText += '<b>No business value priority parameters have been specified.</b><br/>';
  }

  if ((data === null || data === void 0 ? void 0 : data.costImplPriorityParams) && (data === null || data === void 0 ? void 0 : (_data$costImplPriorit = data.costImplPriorityParams) === null || _data$costImplPriorit === void 0 ? void 0 : _data$costImplPriorit.length) > 0) {
    modalBodyText += '<b>Cost implementation priority parameters (name and value)</b><br/>';
    var sortedCostImplData = (0, _projectService.sortProjectPrioritiesByValue)(data === null || data === void 0 ? void 0 : data.costImplPriorityParams);

    if (sortedCostImplData && (sortedCostImplData === null || sortedCostImplData === void 0 ? void 0 : sortedCostImplData.length) > 0) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = sortedCostImplData.reverse()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _element = _step2.value;

          var _lineContent = _element.name.concat(' ').concat(_element.value).concat('<br/>');

          modalBodyText += _lineContent;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
            _iterator2["return"]();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  } else {
    modalBodyText += '<b>No cost implementation priority parameters have been specified.</b><br/>';
  }

  return modalBodyText;
};

function ProjectListItem(_ref) {
  var data = _ref.data,
      onProjectCostPrioritiesDashboard = _ref.onProjectCostPrioritiesDashboard,
      onProjectBusinessPrioritiesDashboard = _ref.onProjectBusinessPrioritiesDashboard;
  var name = data.name,
      description = data.description,
      weight = data.weight;
  return _react["default"].createElement("div", {
    className: "user-list d-sm-flex flex-sm-row card",
    style: {
      marginLeft: '5px',
      width: '99%',
      marginBottom: '5px'
    }
  }, _react["default"].createElement("div", {
    className: "description col-xl-1 col-lg-1 col-md-1"
  }, _react["default"].createElement("div", {
    className: "bg-blue avatar rounded-circle size-40 text-white d-flex align-items-center justify-content-center mx-1 mx-md-3",
    style: {
      fontSize: 16
    }
  }, name ? name.charAt(0).toUpperCase() : '')), _react["default"].createElement("div", {
    className: "description col-xl-8 col-lg-8 col-md-8"
  }, _react["default"].createElement("h3", null, name), _react["default"].createElement("p", null, description), _react["default"].createElement(_reactstrap.ListGroup, {
    className: "list-inline d-sm-flex flex-sm-row gx-btn-list"
  }, _react["default"].createElement(_reactstrap.ListGroupItem, {
    className: "border-0"
  }, _react["default"].createElement(_simpleModal["default"], {
    modalTitle: "Project Priority Details",
    buttonText: "More info",
    modalBody: getModalBody(data)
  })), _react["default"].createElement(_reactstrap.ListGroupItem, {
    className: "border-0"
  }, _react["default"].createElement("a", {
    className: "btn btn-light jr-btn-rounded",
    href: "javascript:void(0)",
    onClick: onProjectCostPrioritiesDashboard
  }, "Cost priorities")), _react["default"].createElement(_reactstrap.ListGroupItem, {
    className: "border-0"
  }, _react["default"].createElement("a", {
    className: "btn btn-light jr-btn-rounded",
    href: "javascript:void(0)",
    onClick: onProjectBusinessPrioritiesDashboard
  }, "Business priorities")))), _react["default"].createElement("div", {
    className: "col-xl-3 col-lg-3 col-md-3"
  }, _react["default"].createElement("div", {
    className: "border-0 text-center bg-white"
  }, _react["default"].createElement("h3", null, "Weight - ", weight))));
}

var _default = ProjectListItem;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(getModalBody, "getModalBody", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/projectListItem/projectListItem.js");

  __REACT_HOT_LOADER__.register(ProjectListItem, "ProjectListItem", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/projectListItem/projectListItem.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/projectListItem/projectListItem.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/projectListItem/projectListItem.js");

  __REACT_HOT_LOADER__.register(_simpleModal, "_simpleModal", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/projectListItem/projectListItem.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/projectListItem/projectListItem.js");

  __REACT_HOT_LOADER__.register(getModalBody, "getModalBody", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/projectListItem/projectListItem.js");

  __REACT_HOT_LOADER__.register(ProjectListItem, "ProjectListItem", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/projectListItem/projectListItem.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/projectListItem/projectListItem.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/projectListItem/projectListItem.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgDashboard/projectListItem/projectListItem.js");
}();

;

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _store = __webpack_require__(54);

var _recharts = __webpack_require__(108);

var _data = __webpack_require__(1824);

var _ChartCard = _interopRequireDefault(__webpack_require__(233));

var _index = _interopRequireDefault(__webpack_require__(63));

var _CircularProgress = _interopRequireDefault(__webpack_require__(24));

var _NextBestActions = _interopRequireDefault(__webpack_require__(1825));

var _colorOptionsModal = _interopRequireDefault(__webpack_require__(685));

var _index2 = _interopRequireDefault(__webpack_require__(426));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _Authentication = __webpack_require__(42);

var _SurveyService = __webpack_require__(176);

var _Organisation = __webpack_require__(144);

var _Employee = __webpack_require__(173);

var _ApiService = __webpack_require__(16);

var _NumberFormatters = __webpack_require__(99);

var _api = __webpack_require__(25);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var EmpDashboard =
/*#__PURE__*/
function (_React$Component) {
  _inherits(EmpDashboard, _React$Component);

  _createClass(EmpDashboard, [{
    key: "__onOptionMenuToggle__REACT_HOT_LOADER__",
    value: function __onOptionMenuToggle__REACT_HOT_LOADER__() {
      this.setState({
        menuState: !this.state.menuState
      });
    }
  }, {
    key: "__handleRequestClose__REACT_HOT_LOADER__",
    value: function __handleRequestClose__REACT_HOT_LOADER__() {
      this.setState({
        menuState: false
      });
    }
  }]);

  function EmpDashboard() {
    var _this;

    _classCallCheck(this, EmpDashboard);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EmpDashboard).call(this));

    _defineProperty(_assertThisInitialized(_this), "onOptionMenuToggle", function () {
      var _this2;

      return (_this2 = _this).__onOptionMenuToggle__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "handleRequestClose", function () {
      var _this3;

      return (_this3 = _this).__handleRequestClose__REACT_HOT_LOADER__.apply(_this3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "counter", 0);

    _this.state = {
      menuState: false,
      nextBestActions: null,
      cardHeight: 110 // set to 60+ if you want the graphs to show on the dashboard (does take up room)

    };
    return _this;
  }

  _createClass(EmpDashboard, [{
    key: "createData",
    value: function createData(name, desc, image, color, action, component) {
      this.counter += 1;
      return {
        id: this.counter,
        name: name,
        desc: desc,
        image: image,
        color: color,
        action: action,
        component: component
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          showEmpDashboardLoader = _this$props.showEmpDashboardLoader,
          fetchOrg = _this$props.fetchOrg,
          fetchOrgStatistics = _this$props.fetchOrgStatistics;
      var orgid = (0, _Authentication.getIdentityOrgId)();
      showEmpDashboardLoader();
      fetchOrgStatistics(orgid);
      fetchOrg(orgid);
    }
  }, {
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(prevProps) {
        var _this$props2, selectedOrg, hideEmpDashboardLoader;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props2 = this.props, selectedOrg = _this$props2.selectedOrg, hideEmpDashboardLoader = _this$props2.hideEmpDashboardLoader;

                if (!(selectedOrg !== prevProps.selectedOrg)) {
                  _context.next = 4;
                  break;
                }

                _context.next = 4;
                return this.getNextBestActions();

              case 4:
                hideEmpDashboardLoader();

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidUpdate(_x) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "getNextBestActions",
    value: function () {
      var _getNextBestActions = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var _this4 = this;

        var _this$props3, fetchEmpSurveyAnswers, showEmpLoader, selectedOrg, nextActions, empId, activeSurveys, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step;

        return regeneratorRuntime.wrap(function _callee2$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$props3 = this.props, fetchEmpSurveyAnswers = _this$props3.fetchEmpSurveyAnswers, showEmpLoader = _this$props3.showEmpLoader, selectedOrg = _this$props3.selectedOrg;
                nextActions = [];
                empId = (0, _Authentication.getIdentityId)();

                if ((0, _Authentication.isAdmin)()) {
                  nextActions.push(this.createData('You are an administrator', 'You can make changes at the organisation level to maintain projects and project priorities, setup and administer surveys - goto the dashboard', 'account-box-mail', 'bg-light-blue darken-3', function () {
                    console.log('Click admin org dashboard');

                    _store.history.push('/app/org-dashboard/default');
                  }));
                } // TODO convert to a single API call


                activeSurveys = (0, _SurveyService.getActiveSurveys)(selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.surveys); // CAREFUL - took me a while to work out the pitfalls of async/ await with forEach, etc
                // https://medium.com/dailyjs/the-pitfalls-of-async-await-in-array-loops-cf9cf713bfeb
                // basically forEach and async/ await - order not guaranteed. Promise.all but For ... of works but is the slowest option

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 8;
                _loop =
                /*#__PURE__*/
                regeneratorRuntime.mark(function _loop() {
                  var orgSurvey, answers, empSurveyAnswers, surveySummaryStatistics;
                  return regeneratorRuntime.wrap(function _loop$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          orgSurvey = _step.value;
                          _context2.next = 3;
                          return (0, _ApiService.fetchDataRequest)(_api.ORG_SURVEY_ANSWERS_ENDPOINT, [_api.ORGID_PATH_PARAM, 'orgSurveyId'], [selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id, orgSurvey === null || orgSurvey === void 0 ? void 0 : orgSurvey.id]);

                        case 3:
                          answers = _context2.sent;
                          empSurveyAnswers = (0, _SurveyService.getEmpSurveyAnswers)((answers === null || answers === void 0 ? void 0 : answers.length) > 0 ? answers[0] : answers, empId); // NOTE before first access the emp survey will equal [] - questions/ answers are injected only on first access

                          if (empSurveyAnswers && (0, _SurveyService.surveyActive)(empSurveyAnswers[0])) {
                            surveySummaryStatistics = (0, _SurveyService.empSurveySummaryStatistics)(empSurveyAnswers[0]);
                            nextActions.push(_this4.createData('You have a survey to complete', "Survey ".concat(orgSurvey.name, " is only ").concat((0, _NumberFormatters.formatPercentageRounded)(surveySummaryStatistics.percentCompleted), " complete. \n                    You have completed ").concat(surveySummaryStatistics.questionsCompleted, " out of ").concat(surveySummaryStatistics.numberOfQuestions, " questions."), 'view-dashboard', 'bg-red accent-4', function () {
                              console.log("Click org survey id ".concat(orgSurvey.id));
                              showEmpLoader();
                              fetchEmpSurveyAnswers({
                                orgSurveyId: orgSurvey.id,
                                surveyId: orgSurvey.surveyId
                              });

                              _store.history.push('/app/org-emp-survey/default');
                            }));
                          }

                        case 6:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _loop);
                });
                _iterator = activeSurveys[Symbol.iterator]();

              case 11:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context3.next = 16;
                  break;
                }

                return _context3.delegateYield(_loop(), "t0", 13);

              case 13:
                _iteratorNormalCompletion = true;
                _context3.next = 11;
                break;

              case 16:
                _context3.next = 22;
                break;

              case 18:
                _context3.prev = 18;
                _context3.t1 = _context3["catch"](8);
                _didIteratorError = true;
                _iteratorError = _context3.t1;

              case 22:
                _context3.prev = 22;
                _context3.prev = 23;

                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                  _iterator["return"]();
                }

              case 25:
                _context3.prev = 25;

                if (!_didIteratorError) {
                  _context3.next = 28;
                  break;
                }

                throw _iteratorError;

              case 28:
                return _context3.finish(25);

              case 29:
                return _context3.finish(22);

              case 30:
                nextActions.push(this.createData('Account details', 'You can make changes to your details like email, your name, your phone number.', 'account-box-mail', 'bg-light-blue darken-3', function () {
                  console.log('Click account details'); // return (<Redirect to={'/app/agile-dashboard/default'} />)
                }));
                nextActions.push(this.createData('Look and feel', 'You can make changes to the look and feel of the application', 'account-box-mail', 'bg-light-blue darken-3', function () {
                  console.log('change look and feel clicked'); // return (<Redirect to={'/app/agile-dashboard/default'} />)
                }, _react["default"].createElement(_colorOptionsModal["default"], null)));
                this.setState({
                  nextBestActions: nextActions
                });

              case 33:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee2, this, [[8, 18, 22, 30], [23,, 25, 29]]);
      }));

      function getNextBestActions() {
        return _getNextBestActions.apply(this, arguments);
      }

      return getNextBestActions;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          selectedOrg = _this$props4.selectedOrg,
          match = _this$props4.match,
          orgStatisticsData = _this$props4.orgStatisticsData,
          loadingDashboard = _this$props4.loadingDashboard;
      var _this$state = this.state,
          nextBestActions = _this$state.nextBestActions,
          cardHeight = _this$state.cardHeight;
      return _react["default"].createElement("div", {
        className: "dashboard animated slideInUpTiny animation-duration-3"
      }, loadingDashboard ? _react["default"].createElement("div", {
        className: "loader-view-block h-100"
      }, _react["default"].createElement("div", {
        className: "loader-view"
      }, _react["default"].createElement(_CircularProgress["default"], null))) : _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("div", {
        style: {
          marginLeft: '20px',
          marginTop: '20px'
        }
      }, _react["default"].createElement(_index["default"], {
        match: match,
        title: _react["default"].createElement(_IntlMessages["default"], {
          id: "emp.dashboard"
        })
      })), _react["default"].createElement("div", {
        className: "row",
        style: {
          marginLeft: '5px',
          marginRight: '5px',
          marginTop: '5px'
        }
      }, _react["default"].createElement("div", {
        className: "col-lg-3 col-sm-6 col-12"
      }, _react["default"].createElement(_ChartCard["default"], {
        styleName: "bg-secondary text-white"
      }, _react["default"].createElement("div", {
        className: "chart-title"
      }, _react["default"].createElement("p", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "dashboard.currentOrganisation"
      })), _react["default"].createElement("h2", null, selectedOrg ? selectedOrg.name : null)), _react["default"].createElement(_recharts.ResponsiveContainer, {
        width: "100%",
        height: cardHeight
      }, _react["default"].createElement(_recharts.BarChart, {
        data: _data.data
      }, _react["default"].createElement(_recharts.Bar, {
        dataKey: "pv",
        fill: "white"
      }), _react["default"].createElement(_recharts.Bar, {
        dataKey: "uv",
        fill: "white"
      }))))), _react["default"].createElement("div", {
        className: "col-lg-3 col-sm-6 col-12"
      }, _react["default"].createElement(_ChartCard["default"], {
        styleName: "bg-primary text-white"
      }, _react["default"].createElement("div", {
        className: "chart-title"
      }, _react["default"].createElement("p", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "dashboard.numberOfInactiveSurveys"
      })), _react["default"].createElement("h2", null, (0, _SurveyService.getInactiveSurveysCount)(selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.surveys))), _react["default"].createElement(_recharts.ResponsiveContainer, {
        width: "100%",
        height: cardHeight
      }, _react["default"].createElement(_recharts.AreaChart, {
        data: _data.data1,
        margin: {
          top: 0,
          right: 0,
          left: 0,
          bottom: 0
        }
      }, _react["default"].createElement(_recharts.Area, {
        type: "monotone",
        dataKey: "pv",
        stroke: "rgba(255,255,255,0.5)",
        activeDot: {
          r: 8
        },
        fillOpacity: .5,
        fill: "white"
      }))))), _react["default"].createElement("div", {
        className: "col-lg-3 col-sm-6 col-12"
      }, _react["default"].createElement(_ChartCard["default"], {
        styleName: "bg-teal text-white"
      }, _react["default"].createElement("div", {
        className: "chart-title"
      }, _react["default"].createElement("p", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "dashboard.numberOfActiveSurveys"
      })), _react["default"].createElement("h2", null, (0, _SurveyService.getActiveSurveysCount)(selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.surveys))), _react["default"].createElement(_recharts.ResponsiveContainer, {
        width: "100%",
        height: cardHeight
      }, _react["default"].createElement(_recharts.LineChart, {
        data: _data.data2
      }, _react["default"].createElement(_recharts.Line, {
        type: "monotone",
        dataKey: "uv",
        stroke: "#ffffff",
        activeDot: {
          r: 8
        }
      }), _react["default"].createElement(_recharts.Line, {
        type: "monotone",
        dataKey: "pv",
        stroke: "#ffffff"
      }), _react["default"].createElement(_recharts.Line, {
        type: "monotone",
        dataKey: "amt",
        stroke: "#ffffff"
      }))))), _react["default"].createElement("div", {
        className: "col-lg-3 col-sm-6 col-12"
      }, _react["default"].createElement(_ChartCard["default"], {
        styleName: "bg-blue lighten-1 text-white"
      }, _react["default"].createElement("div", {
        className: "chart-title"
      }, _react["default"].createElement("p", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "dashboard.numberOfProjects"
      })), _react["default"].createElement("h2", null, (orgStatisticsData === null || orgStatisticsData === void 0 ? void 0 : orgStatisticsData.projectCount) || 0)), _react["default"].createElement(_recharts.ResponsiveContainer, {
        width: "100%",
        height: cardHeight
      }, _react["default"].createElement(_recharts.LineChart, {
        data: _data.data2
      }, _react["default"].createElement(_recharts.Line, {
        type: "monotone",
        dataKey: "uv",
        stroke: "#ffffff",
        activeDot: {
          r: 8
        }
      }), _react["default"].createElement(_recharts.Line, {
        type: "monotone",
        dataKey: "pv",
        stroke: "#ffffff"
      }), _react["default"].createElement(_recharts.Line, {
        type: "monotone",
        dataKey: "amt",
        stroke: "#ffffff"
      })))))), _react["default"].createElement("div", {
        className: "row",
        style: {
          marginLeft: '5px',
          marginRight: '5px'
        }
      }, _react["default"].createElement("div", {
        className: "col-lg-12 col-sm-12 col-12"
      }, _react["default"].createElement("div", {
        className: "jr-card"
      }, _react["default"].createElement(_index2["default"], {
        heading: _react["default"].createElement(_IntlMessages["default"], {
          id: "dashboard.nextBestActions"
        }),
        styleName: "mb-2"
      }), _react["default"].createElement(_NextBestActions["default"], {
        actions: nextBestActions
      }))))));
    }
  }]);

  return EmpDashboard;
}(_react["default"].Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var orgs = _ref.orgs,
      emps = _ref.emps;
  var selectedOrg = orgs.selectedOrg,
      orgStatisticsData = orgs.orgStatisticsData;
  var loadingDashboard = emps.loadingDashboard;
  return {
    selectedOrg: selectedOrg,
    orgStatisticsData: orgStatisticsData,
    loadingDashboard: loadingDashboard
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  fetchOrg: _Organisation.fetchOrg,
  showOrgLoader: _Organisation.showOrgLoader,
  showEmpLoader: _Employee.showEmpLoader,
  showEmpDashboardLoader: _Employee.showEmpDashboardLoader,
  hideEmpDashboardLoader: _Employee.hideEmpDashboardLoader,
  fetchEmpSurveyAnswers: _Employee.fetchEmpSurveyAnswers,
  fetchOrgStatistics: _Organisation.fetchOrgStatistics
})(EmpDashboard);

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(EmpDashboard, "EmpDashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/index.js");

  __REACT_HOT_LOADER__.register(_ChartCard, "_ChartCard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/index.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/index.js");

  __REACT_HOT_LOADER__.register(_CircularProgress, "_CircularProgress", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/index.js");

  __REACT_HOT_LOADER__.register(_NextBestActions, "_NextBestActions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/index.js");

  __REACT_HOT_LOADER__.register(_colorOptionsModal, "_colorOptionsModal", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/index.js");

  __REACT_HOT_LOADER__.register(_index2, "_index2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/index.js");

  __REACT_HOT_LOADER__.register(asyncGeneratorStep, "asyncGeneratorStep", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/index.js");

  __REACT_HOT_LOADER__.register(_asyncToGenerator, "_asyncToGenerator", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/index.js");

  __REACT_HOT_LOADER__.register(EmpDashboard, "EmpDashboard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/index.js");
}();

;

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dailyFeedData = exports.marketingData = exports.announcementsNotification = exports.appNotification = exports.customers = exports.products = exports.radialData = exports.lineChartData = exports.pieChartData = exports.chartDataWithoutAxis = exports.chartData = exports.radarChartData = exports.data2 = exports.data1 = exports.data = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var data = [{
  name: 'Let A',
  uv: 0,
  pv: 0,
  amt: 20
}, {
  name: 'Let B',
  uv: 30,
  pv: 13,
  amt: 21
}, {
  name: 'Let C',
  uv: 20,
  pv: 98,
  amt: 29
}, {
  name: 'Let D',
  uv: 27,
  pv: 39,
  amt: 20
}, {
  name: 'Let E',
  uv: 18,
  pv: 48,
  amt: 28
}, {
  name: 'Let F',
  uv: 23,
  pv: 38,
  amt: 20
}, {
  name: 'Let G',
  uv: 0,
  pv: 0,
  amt: 20
}];
exports.data = data;
var data1 = [{
  name: 'Let A',
  uv: 40,
  pv: 24,
  amt: 20
}, {
  name: 'Let B',
  uv: 30,
  pv: 13,
  amt: 21
}, {
  name: 'Let C',
  uv: 60,
  pv: 98,
  amt: 29
}, {
  name: 'Let D',
  uv: 27,
  pv: 39,
  amt: 20
}, {
  name: 'Let E',
  uv: 78,
  pv: 48,
  amt: 28
}, {
  name: 'Let F',
  uv: 23,
  pv: 38,
  amt: 20
}, {
  name: 'Let G',
  uv: 56,
  pv: 43,
  amt: 20
}];
exports.data1 = data1;
var data2 = [{
  name: 'Let A',
  uv: 40,
  pv: 24,
  amt: 20
}, {
  name: 'Let B',
  uv: 10,
  pv: 13,
  amt: 21
}, {
  name: 'Let C',
  uv: 60,
  pv: 98,
  amt: 29
}, {
  name: 'Let D',
  uv: 27,
  pv: 15,
  amt: 20
}, {
  name: 'Let E',
  uv: 56,
  pv: 45,
  amt: 28
}, {
  name: 'Let F',
  uv: 23,
  pv: 56,
  amt: 20
}, {
  name: 'Let G',
  uv: 56,
  pv: 43,
  amt: 20
}];
exports.data2 = data2;
var radarChartData = [{
  subject: 'Math',
  A: 120,
  B: 110,
  fullMark: 150
}, {
  subject: 'Chinese',
  A: 98,
  B: 130,
  fullMark: 150
}, {
  subject: 'English',
  A: 86,
  B: 130,
  fullMark: 150
}, {
  subject: 'Geography',
  A: 99,
  B: 100,
  fullMark: 150
}, {
  subject: 'Physics',
  A: 85,
  B: 90,
  fullMark: 150
}, {
  subject: 'History',
  A: 65,
  B: 85,
  fullMark: 150
}];
exports.radarChartData = radarChartData;
var chartData = [{
  name: 'J',
  amt: 1400
}, {
  name: 'F',
  amt: 2210
}, {
  name: 'M',
  amt: 1000
}, {
  name: 'A',
  amt: 2000
}, {
  name: 'M',
  amt: 1400
}, {
  name: 'J',
  amt: 2300
}, {
  name: 'J',
  amt: 500
}, {
  name: 'A',
  amt: 2000
}, {
  name: 'S',
  amt: 1500
}, {
  name: 'S',
  amt: 1500
}, {
  name: 'O',
  amt: 1000
}, {
  name: 'N',
  amt: 2000
}, {
  name: 'D',
  amt: 500
}];
exports.chartData = chartData;
var chartDataWithoutAxis = [{
  name: 'J',
  amt: 1400
}, {
  name: 'F',
  amt: 2210
}, {
  name: 'M',
  amt: 1000
}, {
  name: 'A',
  amt: 2000
}, {
  name: 'M',
  amt: 1400
}, {
  name: 'J',
  amt: 2300
}, {
  name: 'J',
  amt: 500
}, {
  name: 'A',
  amt: 2000
}, {
  name: 'S',
  amt: 1500
}, {
  name: 'O',
  amt: 1000
}, {
  name: 'N',
  amt: 2000
}, {
  name: 'D',
  amt: 500
}, {
  name: 'M',
  amt: 1000
}, {
  name: 'A',
  amt: 2000
}, {
  name: 'M',
  amt: 1400
}];
exports.chartDataWithoutAxis = chartDataWithoutAxis;
var pieChartData = [{
  name: 'J',
  amt: 24
}, {
  name: 'F',
  amt: 18
}, {
  name: 'M',
  amt: 22
}, {
  name: 'A',
  amt: 17
}, {
  name: 'M',
  amt: 25
}, {
  name: 'J',
  amt: 12
}, {
  name: 'J',
  amt: 21
}];
exports.pieChartData = pieChartData;
var lineChartData = [{
  name: 'J',
  amt: 24244
}, {
  name: 'F',
  amt: 18123
}, {
  name: 'M',
  amt: 22765
}, {
  name: 'A',
  amt: 17097
}, {
  name: 'M',
  amt: 25529
}, {
  name: 'J',
  amt: 18669
}, {
  name: 'J',
  amt: 21812
}, {
  name: 'S',
  amt: 14988
}, {
  name: 'O',
  amt: 18693
}, {
  name: 'N',
  amt: 22900
}, {
  name: 'D',
  amt: 25313
}];
exports.lineChartData = lineChartData;
var radialData = [{
  name: 'Monthly Data',
  data: 48845,
  fill: '#3367d6'
}, {
  name: 'Orders Weekly',
  data: 8875,
  fill: '#83a6ed'
}, {
  name: 'Average Revenue',
  data: 21342,
  fill: '#8dd1e1'
}, {
  name: 'Total Revenue',
  data: 51875,
  fill: '#ffc658'
}, {
  name: 'Total Orders',
  data: 9223,
  fill: '#a4de6c'
}, {
  name: 'Past Orders',
  data: 8543,
  fill: '#d0ed57'
}];
exports.radialData = radialData;
var products = [{
  image: 'http://via.placeholder.com/600x450',
  title: "Up unpacked friendly",
  description: "Contrary to popular belief, Lorem Ipsum is not simply random text.",
  mrp: 250,
  offerPrice: 200
}, {
  image: 'http://via.placeholder.com/500x330',
  title: "It allowance prevailed",
  description: "It is a long established fact that a reader will be distracted",
  mrp: 250,
  offerPrice: 200
}, {
  image: 'http://via.placeholder.com/500x330',
  title: "Case read they must",
  description: "There are many variations of passages of Lorem Ipsum available",
  mrp: 250,
  offerPrice: 200
}, {
  image: 'http://via.placeholder.com/500x330',
  title: "Too carriage attended",
  description: "The standard chunk of Lorem Ipsum used since the 1500s",
  mrp: 250,
  offerPrice: 200
}];
exports.products = products;
var customers = [{
  id: 1,
  image: 'http://via.placeholder.com/150x150',
  name: "John Smith",
  about: "@john.s",
  detail: "3 orders",
  color: "success"
}, {
  id: 2,
  image: 'http://via.placeholder.com/150x150',
  name: "alex dolgove",
  about: "@Alex.Dolgove",
  detail: "2 orders",
  color: "primary"
}, {
  id: 3,
  image: 'http://via.placeholder.com/150x150',
  name: "Domnic Brown",
  about: "@domnic.brown",
  detail: "0 orders",
  color: "danger"
}, {
  id: 4,
  image: 'http://via.placeholder.com/150x150',
  name: "Jimmy jo",
  about: "@jimmy.jo",
  detail: "1 orders",
  color: "primary"
}];
exports.customers = customers;
var appNotification = [{
  id: 1,
  title: "NEW ORDER",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Stella"), " has placed an order for 3 items of $234.0"],
  image: 'http://via.placeholder.com/150x150'
}, {
  id: 2,
  title: "Support ticket",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Jeson Born"), " raised a support ticket"],
  image: 'http://via.placeholder.com/150x150'
}, {
  id: 3,
  title: "new enquiry",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Guptil"), " has placed an order for 5 items of $425.0"],
  image: 'http://via.placeholder.com/150x150'
}, {
  id: 4,
  title: "NEW ORDER",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Alex Dolgove"), " raised a support ticket"],
  image: 'http://via.placeholder.com/150x150'
}];
exports.appNotification = appNotification;
var announcementsNotification = [{
  id: 5,
  title: "NEW ORDER",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Alex Dolgove"), " raised a support ticket"],
  image: 'http://via.placeholder.com/150x150'
}, {
  id: 6,
  title: "Support ticket",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Jeson Born"), " raised a support ticket"],
  image: 'http://via.placeholder.com/150x150'
}, {
  id: 7,
  title: "NEW ORDER",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Stella"), " has placed an order for 3 items of $234.0"],
  image: 'http://via.placeholder.com/150x150'
}, {
  id: 8,
  title: "new enquiry",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Guptil"), " has placed an order for 5 items of $425.0"],
  image: 'http://via.placeholder.com/150x150'
}];
exports.announcementsNotification = announcementsNotification;
var marketingData = [{
  id: 1,
  name: 'Facebook Ads',
  desc: '63 Likes, 387 Shares',
  icon: 'facebook',
  color: 'bg-indigo lighten-1',
  budget: 570,
  growth: 20
}, {
  id: 2,
  name: 'Twitter Ads',
  desc: '43 Likes, 545 Shares',
  icon: 'twitter',
  color: 'bg-light-blue accent-2',
  budget: 811,
  growth: -5
}, {
  id: 3,
  name: 'Instagram',
  desc: '83 Follows, 210 Likes',
  icon: 'instagram',
  color: 'bg-brown lighten-1',
  budget: 685,
  growth: 20
}, {
  id: 4,
  name: 'LinkedIn',
  desc: '23 Shares, 764 Likes',
  icon: 'linkedin',
  color: 'bg-light-blue darken-3',
  budget: 868,
  growth: 25
}, {
  id: 5,
  name: 'Youtube',
  desc: '1.2k subscribe, 1.8M Likes',
  icon: 'youtube',
  color: 'bg-red accent-4',
  budget: 780,
  growth: 45
}, {
  id: 6,
  name: 'Dribbble',
  desc: '23 Shares, 1.4k Likes',
  icon: 'dribbble',
  color: 'bg-pink lighten-2',
  budget: 868,
  growth: 25
}];
exports.marketingData = marketingData;
var dailyFeedData = [{
  id: 1,
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Guptil"), " has sent you an invitation to join project ", _react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Mouldifi")],
  image: 'http://via.placeholder.com/150x150',
  time: "Today 06:30 pm - 12.10.17",
  updateTime: "5m ago"
}, {
  id: 2,
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Mich"), " uploaded 6 new photos in ", _react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Art Lovers"), " group"],
  image: 'http://via.placeholder.com/150x150',
  time: "Today 06:30 pm - 12.10.17",
  updateTime: "3m ago"
}, {
  id: 3,
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Joshua"), " has shared a post asaying this is bigening."],
  image: 'http://via.placeholder.com/150x150',
  time: "Today 06:30 pm - 12.10.17",
  updateTime: "1 day ago",
  isSocial: "true"
}, {
  id: 4,
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Stella"), " has sent you an invitation"],
  image: 'http://via.placeholder.com/150x150',
  time: "Today 06:30 pm - 12.10.17",
  updateTime: "2 day ago"
}, {
  id: 5,
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Kadir"), " uploaded 1 new photos in"],
  image: 'http://via.placeholder.com/150x150',
  time: "Yesterday 01:30 pm - 11.10.17",
  updateTime: "3 day ago"
}];
exports.dailyFeedData = dailyFeedData;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(data, "data", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/data.js");

  __REACT_HOT_LOADER__.register(data1, "data1", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/data.js");

  __REACT_HOT_LOADER__.register(data2, "data2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/data.js");

  __REACT_HOT_LOADER__.register(radarChartData, "radarChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/data.js");

  __REACT_HOT_LOADER__.register(chartData, "chartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/data.js");

  __REACT_HOT_LOADER__.register(chartDataWithoutAxis, "chartDataWithoutAxis", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/data.js");

  __REACT_HOT_LOADER__.register(pieChartData, "pieChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/data.js");

  __REACT_HOT_LOADER__.register(lineChartData, "lineChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/data.js");

  __REACT_HOT_LOADER__.register(radialData, "radialData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/data.js");

  __REACT_HOT_LOADER__.register(products, "products", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/data.js");

  __REACT_HOT_LOADER__.register(customers, "customers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/data.js");

  __REACT_HOT_LOADER__.register(appNotification, "appNotification", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/data.js");

  __REACT_HOT_LOADER__.register(announcementsNotification, "announcementsNotification", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/data.js");

  __REACT_HOT_LOADER__.register(marketingData, "marketingData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/data.js");

  __REACT_HOT_LOADER__.register(dailyFeedData, "dailyFeedData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/data.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/data.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/data.js");

  __REACT_HOT_LOADER__.register(data, "data", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/data.js");

  __REACT_HOT_LOADER__.register(data1, "data1", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/data.js");

  __REACT_HOT_LOADER__.register(data2, "data2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/data.js");

  __REACT_HOT_LOADER__.register(radarChartData, "radarChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/data.js");

  __REACT_HOT_LOADER__.register(chartData, "chartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/data.js");

  __REACT_HOT_LOADER__.register(chartDataWithoutAxis, "chartDataWithoutAxis", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/data.js");

  __REACT_HOT_LOADER__.register(pieChartData, "pieChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/data.js");

  __REACT_HOT_LOADER__.register(lineChartData, "lineChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/data.js");

  __REACT_HOT_LOADER__.register(radialData, "radialData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/data.js");

  __REACT_HOT_LOADER__.register(products, "products", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/data.js");

  __REACT_HOT_LOADER__.register(customers, "customers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/data.js");

  __REACT_HOT_LOADER__.register(appNotification, "appNotification", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/data.js");

  __REACT_HOT_LOADER__.register(announcementsNotification, "announcementsNotification", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/data.js");

  __REACT_HOT_LOADER__.register(marketingData, "marketingData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/data.js");

  __REACT_HOT_LOADER__.register(dailyFeedData, "dailyFeedData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/data.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/EmpDashboard/data.js");
}();

;

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _NextBestActionsRow = _interopRequireDefault(__webpack_require__(1826));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var NextBestActions =
/*#__PURE__*/
function (_Component) {
  _inherits(NextBestActions, _Component);

  function NextBestActions() {
    _classCallCheck(this, NextBestActions);

    return _possibleConstructorReturn(this, _getPrototypeOf(NextBestActions).apply(this, arguments));
  }

  _createClass(NextBestActions, [{
    key: "render",
    value: function render() {
      var actions = this.props.actions;
      return _react["default"].createElement("div", null, (actions === null || actions === void 0 ? void 0 : actions.length) > 0 ? actions.map(function (nextBestAction) {
        return _react["default"].createElement(_NextBestActionsRow["default"], {
          key: nextBestAction.id,
          data: nextBestAction
        });
      }) : _react["default"].createElement("p", null, "TODO No next best actions message"));
    }
  }]);

  return NextBestActions;
}(_react.Component);

var _default = NextBestActions;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(NextBestActions, "NextBestActions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Components/NextBestActions.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Components/NextBestActions.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Components/NextBestActions.js");

  __REACT_HOT_LOADER__.register(_NextBestActionsRow, "_NextBestActionsRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Components/NextBestActions.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Components/NextBestActions.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Components/NextBestActions.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Components/NextBestActions.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Components/NextBestActions.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Components/NextBestActions.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Components/NextBestActions.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Components/NextBestActions.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Components/NextBestActions.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Components/NextBestActions.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Components/NextBestActions.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Components/NextBestActions.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Components/NextBestActions.js");

  __REACT_HOT_LOADER__.register(NextBestActions, "NextBestActions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Components/NextBestActions.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Components/NextBestActions.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Components/NextBestActions.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Components/NextBestActions.js");
}();

;

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _lodash = __webpack_require__(72);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var NextBestActionsRow = function NextBestActionsRow(_ref) {
  var data = _ref.data;
  var name = data.name,
      desc = data.desc,
      image = data.image,
      color = data.color,
      action = data.action,
      component = data.component;
  return _react["default"].createElement("div", {
    className: "media media-list"
  }, _react["default"].createElement("img", {
    title: "",
    alt: "",
    className: "zmdi zmdi-".concat(image, " text-").concat(color, " zmdi-hc-fw")
  }), _react["default"].createElement("div", {
    className: "media-body"
  }, _react["default"].createElement("h3", {
    className: "mt-0"
  }, name), _react["default"].createElement("p", {
    className: "card-text"
  }, desc), component ? component : _react["default"].createElement("div", {
    className: "my-2 btn-group-mins"
  }, _react["default"].createElement(_reactstrap.Button, {
    size: "lg",
    color: "primary",
    className: "btn jr-btn-sm btn-primary",
    onClick: action && (0, _lodash.isFunction)(action) ? action : null
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-comment-alert mr-1"
  }), _react["default"].createElement(_IntlMessages["default"], {
    id: "options.action"
  })))));
};

var _default = NextBestActionsRow;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(NextBestActionsRow, "NextBestActionsRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Components/NextBestActionsRow.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Components/NextBestActionsRow.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Components/NextBestActionsRow.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Components/NextBestActionsRow.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Components/NextBestActionsRow.js");

  __REACT_HOT_LOADER__.register(NextBestActionsRow, "NextBestActionsRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Components/NextBestActionsRow.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Components/NextBestActionsRow.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Components/NextBestActionsRow.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/Components/NextBestActionsRow.js");
}();

;

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _rcDrawer = _interopRequireDefault(__webpack_require__(31));

var _reactNotifications = __webpack_require__(30);

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _index = _interopRequireDefault(__webpack_require__(66));

var _OrgSurveyList = _interopRequireDefault(__webpack_require__(1828));

var _AddOrgSurvey = _interopRequireDefault(__webpack_require__(809));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _CircularProgress = _interopRequireDefault(__webpack_require__(24));

var _CustomScrollbars = _interopRequireDefault(__webpack_require__(27));

var _OrgSurvey = __webpack_require__(178);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var OrgSurvey =
/*#__PURE__*/
function (_Component) {
  _inherits(OrgSurvey, _Component);

  _createClass(OrgSurvey, [{
    key: "__orgSurveySideBar__REACT_HOT_LOADER__",
    value: function __orgSurveySideBar__REACT_HOT_LOADER__() {
      return _react["default"].createElement("div", {
        className: "module-side"
      }, _react["default"].createElement("div", {
        className: "module-side-header"
      }, _react["default"].createElement("div", {
        className: "module-logo"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-city-alt mr-4"
      }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.surveys"
      })))), _react["default"].createElement("div", {
        className: "module-side-content"
      }, _react["default"].createElement(_CustomScrollbars["default"], {
        className: "module-side-scroll scrollbar",
        style: {
          height: this.props.width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)'
        }
      }, _react["default"].createElement("div", {
        className: "module-add-task"
      }, _react["default"].createElement(_reactstrap.Button, {
        className: "btn-block jr-btn",
        color: "primary",
        onClick: this.onAddOrgSurvey
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-accounts-add zmdi-hc-fw"
      }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "survey.addSurvey"
      })))))));
    }
  }, {
    key: "__onAddOrgSurvey__REACT_HOT_LOADER__",
    value: function __onAddOrgSurvey__REACT_HOT_LOADER__() {
      this.props.onAddOrgSurvey();
    }
  }, {
    key: "__onOrgSurveyClose__REACT_HOT_LOADER__",
    value: function __onOrgSurveyClose__REACT_HOT_LOADER__() {
      this.props.onOrgSurveyClose();
    }
  }, {
    key: "__onSaveOrgSurvey__REACT_HOT_LOADER__",
    value: function __onSaveOrgSurvey__REACT_HOT_LOADER__(data) {
      this.props.onSaveOrgSurvey(data);
    }
  }, {
    key: "__onDeleteOrgSurvey__REACT_HOT_LOADER__",
    value: function __onDeleteOrgSurvey__REACT_HOT_LOADER__(data) {
      this.props.onDeleteOrgSurvey(data);
    }
  }, {
    key: "__handleOrgSurveyRequestClose__REACT_HOT_LOADER__",
    value: function __handleOrgSurveyRequestClose__REACT_HOT_LOADER__() {
      this.props.handleOrgSurveyRequestClose();
    }
  }, {
    key: "__onToggleOrgSurveyDrawer__REACT_HOT_LOADER__",
    value: function __onToggleOrgSurveyDrawer__REACT_HOT_LOADER__() {
      this.props.onToggleOrgSurveyDrawer();
    }
  }, {
    key: "__showOrgSurveyLoader__REACT_HOT_LOADER__",
    value: function __showOrgSurveyLoader__REACT_HOT_LOADER__() {
      this.props.showOrgSurveyLoader();
    }
  }, {
    key: "__showSurveyLoader__REACT_HOT_LOADER__",
    value: function __showSurveyLoader__REACT_HOT_LOADER__() {
      this.props.showSurveyLoader();
    }
  }]);

  function OrgSurvey() {
    var _this;

    _classCallCheck(this, OrgSurvey);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OrgSurvey).call(this));

    _defineProperty(_assertThisInitialized(_this), "orgSurveySideBar", function () {
      var _this2;

      return (_this2 = _this).__orgSurveySideBar__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onAddOrgSurvey", function () {
      var _this3;

      return (_this3 = _this).__onAddOrgSurvey__REACT_HOT_LOADER__.apply(_this3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onOrgSurveyClose", function () {
      var _this4;

      return (_this4 = _this).__onOrgSurveyClose__REACT_HOT_LOADER__.apply(_this4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onSaveOrgSurvey", function () {
      var _this5;

      return (_this5 = _this).__onSaveOrgSurvey__REACT_HOT_LOADER__.apply(_this5, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onDeleteOrgSurvey", function () {
      var _this6;

      return (_this6 = _this).__onDeleteOrgSurvey__REACT_HOT_LOADER__.apply(_this6, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "handleOrgSurveyRequestClose", function () {
      var _this7;

      return (_this7 = _this).__handleOrgSurveyRequestClose__REACT_HOT_LOADER__.apply(_this7, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onToggleOrgSurveyDrawer", function () {
      var _this8;

      return (_this8 = _this).__onToggleOrgSurveyDrawer__REACT_HOT_LOADER__.apply(_this8, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "showOrgSurveyLoader", function () {
      var _this9;

      return (_this9 = _this).__showOrgSurveyLoader__REACT_HOT_LOADER__.apply(_this9, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "showSurveyLoader", function () {
      var _this10;

      return (_this10 = _this).__showSurveyLoader__REACT_HOT_LOADER__.apply(_this10, arguments);
    });

    return _this;
  }

  _createClass(OrgSurvey, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.showOrgSurveyLoader();
      this.props.fetchOrgSurveys();
    }
  }, {
    key: "render",
    value: function render() {
      var _selectedOrg$surveys;

      var _this$props = this.props,
          addOrgSurveyState = _this$props.addOrgSurveyState,
          alertMessage = _this$props.alertMessage,
          showMessage = _this$props.showMessage,
          drawerState = _this$props.drawerState,
          noContentFoundMessage = _this$props.noContentFoundMessage,
          loader = _this$props.loader,
          selectedOrg = _this$props.selectedOrg,
          surveyList = _this$props.surveyList,
          org = _this$props.org,
          searchOrgSurvey = _this$props.searchOrgSurvey;
      return _react["default"].createElement("div", {
        className: "app-wrapper"
      }, _react["default"].createElement("div", {
        className: "app-module animated slideInUpTiny animation-duration-3"
      }, _react["default"].createElement("div", {
        className: "d-block d-xl-none"
      }, _react["default"].createElement(_rcDrawer["default"], {
        touch: true,
        transitions: true,
        enableDragHandle: true,
        open: drawerState,
        onOpenChange: this.onToggleOrgSurveyDrawer.bind(this),
        sidebar: this.orgSurveySideBar(selectedOrg)
      })), _react["default"].createElement("div", {
        className: "app-module-sidenav d-none d-xl-flex"
      }, this.orgSurveySideBar(selectedOrg)), _react["default"].createElement("div", {
        className: "module-box"
      }, _react["default"].createElement("div", {
        className: "module-box-header"
      }, _react["default"].createElement("span", {
        className: "icon-btn drawer-btn d-flex d-xl-none",
        onClick: this.onToggleOrgSurveyDrawer.bind(this)
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-menu"
      })), _react["default"].createElement(_index["default"], {
        placeholder: "Search Unavailable",
        notification: false,
        apps: false,
        user: org,
        onChange: function onChange() {},
        value: searchOrgSurvey
      })), _react["default"].createElement("div", {
        className: "module-box-content"
      }, _react["default"].createElement(_CustomScrollbars["default"], {
        className: "module-list-scroll scrollbar",
        style: {
          height: this.props.width >= 1200 ? 'calc(100vh - 265px)' : 'calc(100vh - 245px)'
        }
      }, loader ? _react["default"].createElement("div", {
        className: "loader-view-block h-100"
      }, _react["default"].createElement("div", {
        className: "loader-view"
      }, _react["default"].createElement(_CircularProgress["default"], null))) : (selectedOrg === null || selectedOrg === void 0 ? void 0 : (_selectedOrg$surveys = selectedOrg.surveys) === null || _selectedOrg$surveys === void 0 ? void 0 : _selectedOrg$surveys.length) === 0 ? _react["default"].createElement("div", {
        className: "h-100 d-flex align-items-center justify-content-center"
      }, noContentFoundMessage) : _react["default"].createElement(_OrgSurveyList["default"], {
        surveys: surveyList,
        selectedOrg: selectedOrg,
        onSaveOrgSurvey: this.onSaveOrgSurvey.bind(this),
        showOrgSurveyLoader: this.showOrgSurveyLoader.bind(this)
      }))))), _react["default"].createElement(_AddOrgSurvey["default"], {
        surveys: surveyList,
        open: addOrgSurveyState,
        orgSurvey: {
          id: '',
          name: '',
          startDate: '',
          endDate: ''
        },
        onSaveOrgSurvey: this.onSaveOrgSurvey.bind(this),
        onOrgSurveyClose: this.onOrgSurveyClose.bind(this),
        showOrgSurveyLoader: this.showOrgSurveyLoader.bind(this)
      }), showMessage && _reactNotifications.NotificationManager.success(alertMessage, this.handleOrgSurveyRequestClose()), _react["default"].createElement(_reactNotifications.NotificationContainer, null));
    }
  }]);

  return OrgSurvey;
}(_react.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var orgs = _ref.orgs,
      surveys = _ref.surveys,
      settings = _ref.settings,
      orgSurveys = _ref.orgSurveys;
  var width = settings.width;
  var selectedOrg = orgs.selectedOrg,
      org = orgs.org;
  var surveyList = surveys.surveyList;
  var loader = orgSurveys.loader,
      alertMessage = orgSurveys.alertMessage,
      showMessage = orgSurveys.showMessage,
      drawerState = orgSurveys.drawerState,
      searchOrgSurvey = orgSurveys.searchOrgSurvey,
      addOrgSurveyState = orgSurveys.addOrgSurveyState;
  return {
    org: org,
    width: width,
    loader: loader,
    alertMessage: alertMessage,
    showMessage: showMessage,
    drawerState: drawerState,
    selectedOrg: selectedOrg,
    surveyList: surveyList,
    searchOrgSurvey: searchOrgSurvey,
    addOrgSurveyState: addOrgSurveyState
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  fetchOrgSurveys: _OrgSurvey.fetchOrgSurveys,
  showOrgSurveyLoader: _OrgSurvey.showOrgSurveyLoader,
  hideOrgSurveyLoader: _OrgSurvey.hideOrgSurveyLoader,
  onAddOrgSurvey: _OrgSurvey.onAddOrgSurvey,
  onOrgSurveyClose: _OrgSurvey.onOrgSurveyClose,
  onSaveOrgSurvey: _OrgSurvey.onSaveOrgSurvey,
  onToggleOrgSurveyDrawer: _OrgSurvey.onToggleOrgSurveyDrawer,
  handleOrgSurveyRequestClose: _OrgSurvey.handleOrgSurveyRequestClose
})(OrgSurvey);

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OrgSurvey, "OrgSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_rcDrawer, "_rcDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_OrgSurveyList, "_OrgSurveyList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_AddOrgSurvey, "_AddOrgSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_CircularProgress, "_CircularProgress", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_CustomScrollbars, "_CustomScrollbars", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(OrgSurvey, "OrgSurvey", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/index.js");
}();

;

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _index = _interopRequireDefault(__webpack_require__(1829));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var OrgSurveyList = function OrgSurveyList(_ref) {
  var selectedOrg = _ref.selectedOrg,
      onSaveOrgSurvey = _ref.onSaveOrgSurvey,
      showOrgSurveyLoader = _ref.showOrgSurveyLoader,
      surveys = _ref.surveys;
  return _react["default"].createElement("div", {
    className: "app-main-content"
  }, (selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.surveys) ? selectedOrg.surveys.map(function (data, index) {
    return _react["default"].createElement(_index["default"], {
      key: index,
      selectedOrgSurvey: data,
      surveys: surveys,
      onSaveOrgSurvey: onSaveOrgSurvey,
      showOrgSurveyLoader: showOrgSurveyLoader
    });
  }) : null);
};

var _default = OrgSurveyList;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OrgSurveyList, "OrgSurveyList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/OrgSurveyList/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/OrgSurveyList/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/OrgSurveyList/index.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/OrgSurveyList/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/OrgSurveyList/index.js");

  __REACT_HOT_LOADER__.register(OrgSurveyList, "OrgSurveyList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/OrgSurveyList/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/OrgSurveyList/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/OrgSurveyList/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/OrgSurveyList/index.js");
}();

;

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _index = _interopRequireDefault(__webpack_require__(809));

var _DateFormatters = __webpack_require__(43);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var OrgSurveyRow =
/*#__PURE__*/
function (_React$Component) {
  _inherits(OrgSurveyRow, _React$Component);

  _createClass(OrgSurveyRow, [{
    key: "__onOrgSurveyOptionToggle__REACT_HOT_LOADER__",
    value: function __onOrgSurveyOptionToggle__REACT_HOT_LOADER__() {
      this.setState({
        menuState: !this.state.menuState
      });
    }
  }, {
    key: "__onOrgSurveyClose__REACT_HOT_LOADER__",
    value: function __onOrgSurveyClose__REACT_HOT_LOADER__() {
      this.setState({
        addOrgSurveyState: false
      });
    }
  }, {
    key: "__onEditOrgSurvey__REACT_HOT_LOADER__",
    value: function __onEditOrgSurvey__REACT_HOT_LOADER__() {
      this.setState({
        menuState: false,
        addOrgSurveyState: true
      });
    }
  }]);

  function OrgSurveyRow() {
    var _this;

    _classCallCheck(this, OrgSurveyRow);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OrgSurveyRow).call(this));

    _defineProperty(_assertThisInitialized(_this), "onOrgSurveyOptionToggle", function () {
      var _this2;

      return (_this2 = _this).__onOrgSurveyOptionToggle__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onOrgSurveyClose", function () {
      var _this3;

      return (_this3 = _this).__onOrgSurveyClose__REACT_HOT_LOADER__.apply(_this3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onEditOrgSurvey", function () {
      var _this4;

      return (_this4 = _this).__onEditOrgSurvey__REACT_HOT_LOADER__.apply(_this4, arguments);
    });

    _this.state = {
      menuState: false,
      addOrgSurveyState: false
    };
    return _this;
  }

  _createClass(OrgSurveyRow, [{
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$props = this.props,
          selectedOrgSurvey = _this$props.selectedOrgSurvey,
          surveys = _this$props.surveys,
          onSaveOrgSurvey = _this$props.onSaveOrgSurvey,
          showOrgSurveyLoader = _this$props.showOrgSurveyLoader;
      var _this$state = this.state,
          menuState = _this$state.menuState,
          addOrgSurveyState = _this$state.addOrgSurveyState;
      var name = selectedOrgSurvey.name,
          startDate = selectedOrgSurvey.startDate,
          endDate = selectedOrgSurvey.endDate;
      var options = ['Edit'];
      return _react["default"].createElement("div", {
        className: "contact-item"
      }, _react["default"].createElement("div", {
        className: "col"
      }, _react["default"].createElement("p", {
        className: "mb-0"
      }, _react["default"].createElement("span", {
        className: "contact-name"
      }, name)), _react["default"].createElement("div", {
        className: "text-muted"
      }, _react["default"].createElement("span", {
        className: "email d-inline-block mr-2"
      }, "Start Date - ", (0, _DateFormatters.formatDateDefault)(startDate)), _react["default"].createElement("span", {
        className: "d-inline-block toolbar-separator"
      }, "\xA0"), _react["default"].createElement("span", {
        className: "phone d-inline-block"
      }, "End Date - ", (0, _DateFormatters.formatDateDefault)(endDate)))), _react["default"].createElement("div", {
        className: "col-auto px-1 actions d-sm-flex"
      }, _react["default"].createElement(_reactstrap.Dropdown, {
        isOpen: menuState,
        toggle: this.onOrgSurveyOptionToggle.bind(this)
      }, _react["default"].createElement(_reactstrap.DropdownToggle, {
        tag: "span"
      }, _react["default"].createElement("span", {
        className: "icon-btn text-grey pointer"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-more-vert zmdi-hc-lg"
      }))), _react["default"].createElement(_reactstrap.DropdownMenu, null, options.map(function (option) {
        return _react["default"].createElement(_reactstrap.DropdownItem, {
          key: option,
          onClick: function onClick() {
            if (option === 'Edit') {
              _this5.onEditOrgSurvey();
            }
          }
        }, option);
      }))), addOrgSurveyState && _react["default"].createElement(_index["default"], {
        surveys: surveys,
        open: addOrgSurveyState,
        orgSurvey: selectedOrgSurvey,
        onSaveOrgSurvey: onSaveOrgSurvey,
        onOrgSurveyClose: this.onOrgSurveyClose,
        showOrgSurveyLoader: showOrgSurveyLoader
      })));
    }
  }]);

  return OrgSurveyRow;
}(_react["default"].Component);

var _default = OrgSurveyRow;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OrgSurveyRow, "OrgSurveyRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/OrgSurveyList/OrgSurveyRow/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/OrgSurveyList/OrgSurveyRow/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/OrgSurveyList/OrgSurveyRow/index.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/OrgSurveyList/OrgSurveyRow/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/OrgSurveyList/OrgSurveyRow/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/OrgSurveyList/OrgSurveyRow/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/OrgSurveyList/OrgSurveyRow/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/OrgSurveyList/OrgSurveyRow/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/OrgSurveyList/OrgSurveyRow/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/OrgSurveyList/OrgSurveyRow/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/OrgSurveyList/OrgSurveyRow/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/OrgSurveyList/OrgSurveyRow/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/OrgSurveyList/OrgSurveyRow/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/OrgSurveyList/OrgSurveyRow/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/OrgSurveyList/OrgSurveyRow/index.js");

  __REACT_HOT_LOADER__.register(OrgSurveyRow, "OrgSurveyRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/OrgSurveyList/OrgSurveyRow/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/OrgSurveyList/OrgSurveyRow/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/OrgSurveyList/OrgSurveyRow/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurvey/OrgSurveyList/OrgSurveyRow/index.js");
}();

;

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Container["default"];
  }
});

var _Container = _interopRequireDefault(__webpack_require__(1831));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_Container, "_Container", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/index.js");
}();

;

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.mapStateToProps = void 0;

var _reactRedux = __webpack_require__(10);

var _OrgSurvey = __webpack_require__(178);

var _Component = _interopRequireDefault(__webpack_require__(1832));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var mapStateToProps = function mapStateToProps(_ref) {
  var settings = _ref.settings,
      orgSurveys = _ref.orgSurveys,
      orgs = _ref.orgs;
  var width = settings.width;
  var loader = orgSurveys.loader,
      drawerState = orgSurveys.drawerState,
      alertMessage = orgSurveys.alertMessage,
      showMessage = orgSurveys.showMessage,
      orgSurveyCompareList = orgSurveys.orgSurveyCompareList;
  var selectedOrg = orgs.selectedOrg;
  return {
    width: width,
    loader: loader,
    drawerState: drawerState,
    alertMessage: alertMessage,
    showMessage: showMessage,
    selectedOrg: selectedOrg,
    orgSurveyCompareList: orgSurveyCompareList
  };
};

exports.mapStateToProps = mapStateToProps;

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  showOrgSurveyLoader: _OrgSurvey.showOrgSurveyLoader,
  fetchOrgSurveysCompare: _OrgSurvey.fetchOrgSurveysCompare,
  onOrgSurveyCompareSelect: _OrgSurvey.onOrgSurveyCompareSelect,
  onToggleOrgSurveyDrawer: _OrgSurvey.onToggleOrgSurveyDrawer,
  handleOrgSurveyRequestClose: _OrgSurvey.handleOrgSurveyRequestClose
})(_Component["default"]);

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/Container.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/Container.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_Component, "_Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/Container.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/Container.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/Container.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/Container.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/Container.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/Container.js");
}();

;

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Component = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactNotifications = __webpack_require__(30);

var _reactstrap = __webpack_require__(6);

var _rcDrawer = _interopRequireDefault(__webpack_require__(31));

var _store = __webpack_require__(54);

var _OrgSurveyCompareList = _interopRequireDefault(__webpack_require__(1833));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _CircularProgress = _interopRequireDefault(__webpack_require__(24));

var _CustomScrollbars = _interopRequireDefault(__webpack_require__(27));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Component =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Component, _React$Component);

  function Component() {
    var _this;

    _classCallCheck(this, Component);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Component).call(this));

    _defineProperty(_assertThisInitialized(_this), "onOrgSurveyCompareSelect", function () {
      var _this2;

      return (_this2 = _this).__onOrgSurveyCompareSelect__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onToggleOrgSurveyDrawer", function () {
      var _this3;

      return (_this3 = _this).__onToggleOrgSurveyDrawer__REACT_HOT_LOADER__.apply(_this3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "handleOrgSurveyRequestClose", function () {
      var _this4;

      return (_this4 = _this).__handleOrgSurveyRequestClose__REACT_HOT_LOADER__.apply(_this4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onFilterOrgSurveyOptionSelect", function () {
      var _this5;

      return (_this5 = _this).__onFilterOrgSurveyOptionSelect__REACT_HOT_LOADER__.apply(_this5, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onCompareSelected", function () {
      var _this6;

      return (_this6 = _this).__onCompareSelected__REACT_HOT_LOADER__.apply(_this6, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onEngagementDetails", function () {
      var _this7;

      return (_this7 = _this).__onEngagementDetails__REACT_HOT_LOADER__.apply(_this7, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onAllSurveySelect", function () {
      var _this8;

      return (_this8 = _this).__onAllSurveySelect__REACT_HOT_LOADER__.apply(_this8, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "compareReadyFromSelections", function () {
      var _this9;

      return (_this9 = _this).__compareReadyFromSelections__REACT_HOT_LOADER__.apply(_this9, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "SurveySideBar", function () {
      var _this10;

      return (_this10 = _this).__SurveySideBar__REACT_HOT_LOADER__.apply(_this10, arguments);
    });

    return _this;
  }

  _createClass(Component, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.showOrgSurveyLoader();
      this.props.fetchOrgSurveysCompare();
    }
  }, {
    key: "__onOrgSurveyCompareSelect__REACT_HOT_LOADER__",
    value: function __onOrgSurveyCompareSelect__REACT_HOT_LOADER__(survey) {
      var onOrgSurveyCompareSelect = this.props.onOrgSurveyCompareSelect;
      onOrgSurveyCompareSelect(survey);
    }
  }, {
    key: "__onToggleOrgSurveyDrawer__REACT_HOT_LOADER__",
    value: function __onToggleOrgSurveyDrawer__REACT_HOT_LOADER__() {
      this.props.onToggleOrgSurveyDrawer();
    }
  }, {
    key: "__handleOrgSurveyRequestClose__REACT_HOT_LOADER__",
    value: function __handleOrgSurveyRequestClose__REACT_HOT_LOADER__() {
      this.props.handleOrgSurveyRequestClose();
    }
  }, {
    key: "__onFilterOrgSurveyOptionSelect__REACT_HOT_LOADER__",
    value: function __onFilterOrgSurveyOptionSelect__REACT_HOT_LOADER__(option) {// this.props.onFilterOrgOptionSelect(option);
    }
  }, {
    key: "__onCompareSelected__REACT_HOT_LOADER__",
    value: function __onCompareSelected__REACT_HOT_LOADER__() {
      _store.history.push('/app/org-survey-compare-radar/default');
    }
  }, {
    key: "__onEngagementDetails__REACT_HOT_LOADER__",
    value: function __onEngagementDetails__REACT_HOT_LOADER__() {
      _store.history.push('/app/org-survey-engagement-details/default');
    }
  }, {
    key: "__onAllSurveySelect__REACT_HOT_LOADER__",
    value: function __onAllSurveySelect__REACT_HOT_LOADER__() {// const selectAll = this.props.selectedEmps < this.props.empList.length;
      // if (selectAll) {
      //     this.props.getAllEmp();
      // } else {
      //     this.props.getUnselectedAllEmp();
      // }
    }
  }, {
    key: "__compareReadyFromSelections__REACT_HOT_LOADER__",
    value: function __compareReadyFromSelections__REACT_HOT_LOADER__() {
      var compareReady = false;
      var orgSurveyCompareList = this.props.orgSurveyCompareList;

      if (Array.isArray(orgSurveyCompareList)) {
        return orgSurveyCompareList.filter(function (entry) {
          return entry.selected;
        }).length === 2;
      }

      return compareReady;
    }
  }, {
    key: "__SurveySideBar__REACT_HOT_LOADER__",
    value: function __SurveySideBar__REACT_HOT_LOADER__() {
      return _react["default"].createElement("div", {
        className: "module-side"
      }, _react["default"].createElement("div", {
        className: "module-side-header"
      }, _react["default"].createElement("div", {
        className: "module-logo"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-city-alt mr-4"
      }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.compareSurveys"
      })))), _react["default"].createElement("div", {
        className: "module-side-content"
      }, _react["default"].createElement(_CustomScrollbars["default"], {
        className: "module-side-scroll scrollbar",
        style: {
          height: this.props.width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)'
        }
      }, _react["default"].createElement("div", {
        className: "module-add-task"
      }, _react["default"].createElement(_reactstrap.Button, {
        className: "btn-block jr-btn",
        color: "primary",
        onClick: this.onCompareSelected,
        disabled: !this.compareReadyFromSelections()
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-accounts-add zmdi-hc-fw"
      }), _react["default"].createElement("span", null, "Compare selected"))), _react["default"].createElement("div", {
        className: "module-add-task",
        style: {
          marginTop: '-40px'
        }
      }, _react["default"].createElement(_reactstrap.Button, {
        className: "btn-block jr-btn",
        color: "primary",
        onClick: this.onEngagementDetails,
        disabled: !this.compareReadyFromSelections()
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-accounts-add zmdi-hc-fw"
      }), _react["default"].createElement("span", null, "Engagement details"))))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          alertMessage = _this$props.alertMessage,
          showMessage = _this$props.showMessage,
          drawerState = _this$props.drawerState,
          noContentFoundMessage = _this$props.noContentFoundMessage,
          loader = _this$props.loader,
          orgSurveyCompareList = _this$props.orgSurveyCompareList;
      return _react["default"].createElement("div", {
        className: "app-wrapper"
      }, _react["default"].createElement("div", {
        className: "app-module animated slideInUpTiny animation-duration-3"
      }, _react["default"].createElement("div", {
        className: "d-block d-xl-none"
      }, _react["default"].createElement(_rcDrawer["default"], {
        touch: true,
        transitions: true,
        enableDragHandle: true,
        open: drawerState,
        onOpenChange: this.onToggleOrgSurveyDrawer.bind(this),
        sidebar: this.SurveySideBar()
      })), _react["default"].createElement("div", {
        className: "app-module-sidenav d-none d-xl-flex"
      }, this.SurveySideBar()), _react["default"].createElement("div", {
        className: "module-box"
      }, _react["default"].createElement("div", {
        className: "module-box-header"
      }, _react["default"].createElement("span", {
        className: "icon-btn drawer-btn d-flex d-xl-none",
        onClick: this.onToggleOrgSurveyDrawer.bind(this)
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-menu"
      })), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "compare.survey.header.message"
      }))), _react["default"].createElement("div", {
        className: "module-box-content"
      }, _react["default"].createElement(_CustomScrollbars["default"], {
        className: "module-list-scroll scrollbar",
        style: {
          height: this.props.width >= 1200 ? 'calc(100vh - 265px)' : 'calc(100vh - 245px)'
        }
      }, loader ? _react["default"].createElement("div", {
        className: "loader-view-block h-100"
      }, _react["default"].createElement("div", {
        className: "loader-view"
      }, _react["default"].createElement(_CircularProgress["default"], null))) : (orgSurveyCompareList === null || orgSurveyCompareList === void 0 ? void 0 : orgSurveyCompareList.length) === 0 ? _react["default"].createElement("div", {
        className: "h-100 d-flex align-items-center justify-content-center"
      }, noContentFoundMessage) : _react["default"].createElement(_OrgSurveyCompareList["default"], {
        orgSurveysCompare: orgSurveyCompareList,
        onOrgSurveyCompareSelect: this.onOrgSurveyCompareSelect.bind(this)
      }))))), showMessage && _reactNotifications.NotificationManager.success(alertMessage, this.handleOrgSurveyRequestClose()), _react["default"].createElement(_reactNotifications.NotificationContainer, null));
    }
  }]);

  return Component;
}(_react["default"].Component);

exports.Component = Component;
var _default = Component;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/Component.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/Component.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/Component.js");

  __REACT_HOT_LOADER__.register(_rcDrawer, "_rcDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/Component.js");

  __REACT_HOT_LOADER__.register(_OrgSurveyCompareList, "_OrgSurveyCompareList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/Component.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/Component.js");

  __REACT_HOT_LOADER__.register(_CircularProgress, "_CircularProgress", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/Component.js");

  __REACT_HOT_LOADER__.register(_CustomScrollbars, "_CustomScrollbars", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/Component.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/Component.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/Component.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/Component.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/Component.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/Component.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/Component.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/Component.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/Component.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/Component.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/Component.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/Component.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/Component.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/Component.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/Component.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/Component.js");
}();

;

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _index = _interopRequireDefault(__webpack_require__(1834));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var OrgSurveyCompareList = function OrgSurveyCompareList(_ref) {
  var orgSurveysCompare = _ref.orgSurveysCompare,
      onOrgSurveyCompareSelect = _ref.onOrgSurveyCompareSelect;
  return _react["default"].createElement("div", {
    className: "app-main-content"
  }, orgSurveysCompare ? orgSurveysCompare.map(function (data, index) {
    return _react["default"].createElement(_index["default"], {
      key: index,
      orgSurveyCompare: data,
      onOrgSurveyCompareSelect: onOrgSurveyCompareSelect
    });
  }) : null);
};

var _default = OrgSurveyCompareList;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OrgSurveyCompareList, "OrgSurveyCompareList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareList/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareList/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareList/index.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareList/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareList/index.js");

  __REACT_HOT_LOADER__.register(OrgSurveyCompareList, "OrgSurveyCompareList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareList/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareList/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareList/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareList/index.js");
}();

;

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _reactBootstrapSweetalert = _interopRequireDefault(__webpack_require__(80));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _DateFormatters = __webpack_require__(43);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var OrgSurveyCompareRow =
/*#__PURE__*/
function (_React$Component) {
  _inherits(OrgSurveyCompareRow, _React$Component);

  function OrgSurveyCompareRow() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, OrgSurveyCompareRow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(OrgSurveyCompareRow)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      menuState: false,
      viewSurveyDetails: false,
      selectedSurveyDetails: ''
    });

    _defineProperty(_assertThisInitialized(_this), "onOrgSurveyCompareSelected", function () {
      var _this2;

      return (_this2 = _this).__onOrgSurveyCompareSelected__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onOrgOptionToggle", function () {
      var _this3;

      return (_this3 = _this).__onOrgOptionToggle__REACT_HOT_LOADER__.apply(_this3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onDisplaySelectedSurveyDetails", function () {
      var _this4;

      return (_this4 = _this).__onDisplaySelectedSurveyDetails__REACT_HOT_LOADER__.apply(_this4, arguments);
    });

    return _this;
  }

  _createClass(OrgSurveyCompareRow, [{
    key: "__onOrgSurveyCompareSelected__REACT_HOT_LOADER__",
    value: function __onOrgSurveyCompareSelected__REACT_HOT_LOADER__(survey) {
      var onOrgSurveyCompareSelect = this.props.onOrgSurveyCompareSelect;
      onOrgSurveyCompareSelect(survey);
    }
  }, {
    key: "__onOrgOptionToggle__REACT_HOT_LOADER__",
    value: function __onOrgOptionToggle__REACT_HOT_LOADER__() {
      this.setState({
        menuState: !this.state.menuState
      });
    }
  }, {
    key: "__onDisplaySelectedSurveyDetails__REACT_HOT_LOADER__",
    value: function __onDisplaySelectedSurveyDetails__REACT_HOT_LOADER__() {
      this.setState({
        selectedSurveyDetails: 'farted'
      });
      this.setState({
        viewSurveyDetails: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var orgSurveyCompare = this.props.orgSurveyCompare;
      var _this$state = this.state,
          menuState = _this$state.menuState,
          viewSurveyDetails = _this$state.viewSurveyDetails,
          selectedSurveyDetails = _this$state.selectedSurveyDetails;
      var name = orgSurveyCompare.name,
          startDate = orgSurveyCompare.startDate,
          endDate = orgSurveyCompare.endDate;
      var options = ['Details'];
      return _react["default"].createElement("div", {
        className: "contact-item"
      }, _react["default"].createElement("div", {
        className: "form-control-checkbox d-flex"
      }, _react["default"].createElement("div", {
        className: "form-checkbox"
      }, _react["default"].createElement("input", {
        type: "checkbox",
        checked: orgSurveyCompare === null || orgSurveyCompare === void 0 ? void 0 : orgSurveyCompare.selected,
        value: "checked",
        onClick: function onClick() {
          _this5.onOrgSurveyCompareSelected(orgSurveyCompare);
        },
        onChange: function onChange() {}
      }), _react["default"].createElement("span", {
        className: "check"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-check zmdi-hc-lg"
      })))), _react["default"].createElement("div", {
        className: "col"
      }, _react["default"].createElement("p", {
        className: "mb-0"
      }, _react["default"].createElement("span", {
        className: "contact-name"
      }, name), _react["default"].createElement("span", {
        className: "d-inline-block toolbar-separator"
      }, "\xA0"), _react["default"].createElement("span", {
        className: "email d-inline-block mr-2"
      }, "Start Date - ", (0, _DateFormatters.formatDateDefault)(startDate)), _react["default"].createElement("span", {
        className: "d-inline-block toolbar-separator"
      }, "\xA0"), _react["default"].createElement("span", {
        className: "phone d-inline-block"
      }, "End Date - ", (0, _DateFormatters.formatDateDefault)(endDate)))), _react["default"].createElement("div", {
        className: "col-auto px-1 actions d-sm-flex"
      }, _react["default"].createElement(_reactstrap.Dropdown, {
        isOpen: menuState,
        toggle: this.onOrgOptionToggle.bind(this)
      }, _react["default"].createElement(_reactstrap.DropdownToggle, {
        tag: "span"
      }, _react["default"].createElement("span", {
        className: "icon-btn text-grey pointer"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-more-vert zmdi-hc-lg"
      }))), _react["default"].createElement(_reactstrap.DropdownMenu, null, options.map(function (option) {
        return _react["default"].createElement(_reactstrap.DropdownItem, {
          key: option,
          onClick: function onClick() {
            if (option === 'Details') {
              _this5.onDisplaySelectedSurveyDetails(orgSurveyCompare);
            }
          }
        }, option);
      })))), _react["default"].createElement(_reactBootstrapSweetalert["default"], {
        show: viewSurveyDetails,
        custom: true,
        confirmBtnText: _react["default"].createElement(_IntlMessages["default"], {
          id: "button.close"
        }),
        confirmBtnBsStyle: "primary",
        customIcon: "assets/images/online-survey.jpeg",
        title: "Survey name - ".concat((orgSurveyCompare === null || orgSurveyCompare === void 0 ? void 0 : orgSurveyCompare.name) ? orgSurveyCompare.name : 'survey name not defined'),
        onConfirm: function onConfirm() {
          _this5.setState({
            viewSurveyDetails: false
          });
        }
      }, selectedSurveyDetails));
    }
  }]);

  return OrgSurveyCompareRow;
}(_react["default"].Component);

var _default = OrgSurveyCompareRow;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OrgSurveyCompareRow, "OrgSurveyCompareRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareList/OrgSurveyCompareRow/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareList/OrgSurveyCompareRow/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareList/OrgSurveyCompareRow/index.js");

  __REACT_HOT_LOADER__.register(_reactBootstrapSweetalert, "_reactBootstrapSweetalert", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareList/OrgSurveyCompareRow/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareList/OrgSurveyCompareRow/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareList/OrgSurveyCompareRow/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareList/OrgSurveyCompareRow/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareList/OrgSurveyCompareRow/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareList/OrgSurveyCompareRow/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareList/OrgSurveyCompareRow/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareList/OrgSurveyCompareRow/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareList/OrgSurveyCompareRow/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareList/OrgSurveyCompareRow/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareList/OrgSurveyCompareRow/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareList/OrgSurveyCompareRow/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareList/OrgSurveyCompareRow/index.js");

  __REACT_HOT_LOADER__.register(OrgSurveyCompareRow, "OrgSurveyCompareRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareList/OrgSurveyCompareRow/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareList/OrgSurveyCompareRow/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareList/OrgSurveyCompareRow/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareList/OrgSurveyCompareRow/index.js");
}();

;

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Container["default"];
  }
});

var _Container = _interopRequireDefault(__webpack_require__(1836));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_Container, "_Container", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/index.js");
}();

;

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.mapStateToProps = void 0;

var _reactRedux = __webpack_require__(10);

var _OrgSurvey = __webpack_require__(178);

var _Component = _interopRequireDefault(__webpack_require__(1837));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var mapStateToProps = function mapStateToProps(_ref) {
  var orgSurveys = _ref.orgSurveys;
  var orgSurveyCompareList = orgSurveys.orgSurveyCompareList,
      orgSurveyCompareDistributionsChartData = orgSurveys.orgSurveyCompareDistributionsChartData,
      orgSurveyCompareTopResultsChartData = orgSurveys.orgSurveyCompareTopResultsChartData,
      orgSurveyCompareBottomResultsChartData = orgSurveys.orgSurveyCompareBottomResultsChartData;
  return {
    orgSurveyCompareList: orgSurveyCompareList,
    orgSurveyCompareDistributionsChartData: orgSurveyCompareDistributionsChartData,
    orgSurveyCompareTopResultsChartData: orgSurveyCompareTopResultsChartData,
    orgSurveyCompareBottomResultsChartData: orgSurveyCompareBottomResultsChartData
  };
};

exports.mapStateToProps = mapStateToProps;

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  showOrgSurveyLoader: _OrgSurvey.showOrgSurveyLoader,
  fetchOrgSurveysEngagementReportChartData: _OrgSurvey.fetchOrgSurveysEngagementReportChartData
})(_Component["default"]);

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Container.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Container.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_Component, "_Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Container.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Container.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Container.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Container.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Container.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Container.js");
}();

;

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Component = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _store = __webpack_require__(54);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _ContainerHeader = _interopRequireDefault(__webpack_require__(63));

var _reactCollapsible = _interopRequireDefault(__webpack_require__(161));

var _ListItem = _interopRequireDefault(__webpack_require__(1838));

var _Distribution = _interopRequireDefault(__webpack_require__(1839));

var _DimensionTable = _interopRequireDefault(__webpack_require__(1840));

var _expectationsData = __webpack_require__(1843);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Component =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Component, _React$Component);

  function Component() {
    var _this;

    _classCallCheck(this, Component);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Component).call(this));

    _defineProperty(_assertThisInitialized(_this), "state", {
      topResultsTableData: []
    });

    _defineProperty(_assertThisInitialized(_this), "counter", 0);

    _defineProperty(_assertThisInitialized(_this), "onBackToCompare", function () {
      var _this2;

      return (_this2 = _this).__onBackToCompare__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    return _this;
  }

  _createClass(Component, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          showOrgSurveyLoader = _this$props.showOrgSurveyLoader,
          fetchOrgSurveysEngagementReportChartData = _this$props.fetchOrgSurveysEngagementReportChartData;
      showOrgSurveyLoader();
      fetchOrgSurveysEngagementReportChartData();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this; // TODO - move these to separate services


      var _this$props2 = this.props,
          orgSurveyCompareTopResultsChartData = _this$props2.orgSurveyCompareTopResultsChartData,
          orgSurveyCompareBottomResultsChartData = _this$props2.orgSurveyCompareBottomResultsChartData,
          orgSurveyCompareDistributionsChartData = _this$props2.orgSurveyCompareDistributionsChartData;

      if (orgSurveyCompareTopResultsChartData !== prevProps.orgSurveyCompareTopResultsChartData) {
        var newTopResultsDataSet = orgSurveyCompareTopResultsChartData.map(function (results) {
          return results.map(function (entry) {
            var _entry$values, _entry$values2, _entry$engagementData, _entry$engagementData2, _entry$engagementData3, _entry$engagementData4, _entry$engagementData5, _entry$engagementData6, _entry$engagementData7, _entry$engagementData8;

            console.log('top result entry '.concat(JSON.stringify(entry)));
            var answeredCount = (entry === null || entry === void 0 ? void 0 : (_entry$values = entry.values) === null || _entry$values === void 0 ? void 0 : _entry$values.answeredCount) > 0 ? entry === null || entry === void 0 ? void 0 : (_entry$values2 = entry.values) === null || _entry$values2 === void 0 ? void 0 : _entry$values2.answeredCount : 1;
            var perceptionData = [(entry === null || entry === void 0 ? void 0 : (_entry$engagementData = entry.engagementData) === null || _entry$engagementData === void 0 ? void 0 : _entry$engagementData.activelyDisengaged) > 0 ? (entry === null || entry === void 0 ? void 0 : (_entry$engagementData2 = entry.engagementData) === null || _entry$engagementData2 === void 0 ? void 0 : _entry$engagementData2.activelyDisengaged) / answeredCount * 100 : 0, (entry === null || entry === void 0 ? void 0 : (_entry$engagementData3 = entry.engagementData) === null || _entry$engagementData3 === void 0 ? void 0 : _entry$engagementData3.passive) > 0 ? (entry === null || entry === void 0 ? void 0 : (_entry$engagementData4 = entry.engagementData) === null || _entry$engagementData4 === void 0 ? void 0 : _entry$engagementData4.passive) / answeredCount * 100 : 0, (entry === null || entry === void 0 ? void 0 : (_entry$engagementData5 = entry.engagementData) === null || _entry$engagementData5 === void 0 ? void 0 : _entry$engagementData5.moderatelyEngaged) > 0 ? (entry === null || entry === void 0 ? void 0 : (_entry$engagementData6 = entry.engagementData) === null || _entry$engagementData6 === void 0 ? void 0 : _entry$engagementData6.moderatelyEngaged) / answeredCount * 100 : 0, (entry === null || entry === void 0 ? void 0 : (_entry$engagementData7 = entry.engagementData) === null || _entry$engagementData7 === void 0 ? void 0 : _entry$engagementData7.highlyEngaged) > 0 ? (entry === null || entry === void 0 ? void 0 : (_entry$engagementData8 = entry.engagementData) === null || _entry$engagementData8 === void 0 ? void 0 : _entry$engagementData8.highlyEngaged) / answeredCount * 100 : 0];

            var data = _this3.createData(entry.id, entry.question, perceptionData, '---');

            console.log('top result '.concat(JSON.stringify(data)));
            return data;
          });
        });
        this.setState({
          topResultsTableData: newTopResultsDataSet
        });
      }

      if (orgSurveyCompareBottomResultsChartData !== prevProps.orgSurveyCompareBottomResultsChartData) {
        var newBottomResultsDataSet = orgSurveyCompareBottomResultsChartData.map(function (results) {
          return results.map(function (entry) {
            var _entry$values3, _entry$values4, _entry$engagementData9, _entry$engagementData10, _entry$engagementData11, _entry$engagementData12, _entry$engagementData13, _entry$engagementData14, _entry$engagementData15, _entry$engagementData16;

            console.log('bottom result entry '.concat(JSON.stringify(entry)));
            var answeredCount = (entry === null || entry === void 0 ? void 0 : (_entry$values3 = entry.values) === null || _entry$values3 === void 0 ? void 0 : _entry$values3.answeredCount) > 0 ? entry === null || entry === void 0 ? void 0 : (_entry$values4 = entry.values) === null || _entry$values4 === void 0 ? void 0 : _entry$values4.answeredCount : 1;
            var perceptionData = [(entry === null || entry === void 0 ? void 0 : (_entry$engagementData9 = entry.engagementData) === null || _entry$engagementData9 === void 0 ? void 0 : _entry$engagementData9.activelyDisengaged) > 0 ? (entry === null || entry === void 0 ? void 0 : (_entry$engagementData10 = entry.engagementData) === null || _entry$engagementData10 === void 0 ? void 0 : _entry$engagementData10.activelyDisengaged) / answeredCount * 100 : 0, (entry === null || entry === void 0 ? void 0 : (_entry$engagementData11 = entry.engagementData) === null || _entry$engagementData11 === void 0 ? void 0 : _entry$engagementData11.passive) > 0 ? (entry === null || entry === void 0 ? void 0 : (_entry$engagementData12 = entry.engagementData) === null || _entry$engagementData12 === void 0 ? void 0 : _entry$engagementData12.passive) / answeredCount * 100 : 0, (entry === null || entry === void 0 ? void 0 : (_entry$engagementData13 = entry.engagementData) === null || _entry$engagementData13 === void 0 ? void 0 : _entry$engagementData13.moderatelyEngaged) > 0 ? (entry === null || entry === void 0 ? void 0 : (_entry$engagementData14 = entry.engagementData) === null || _entry$engagementData14 === void 0 ? void 0 : _entry$engagementData14.moderatelyEngaged) / answeredCount * 100 : 0, (entry === null || entry === void 0 ? void 0 : (_entry$engagementData15 = entry.engagementData) === null || _entry$engagementData15 === void 0 ? void 0 : _entry$engagementData15.highlyEngaged) > 0 ? (entry === null || entry === void 0 ? void 0 : (_entry$engagementData16 = entry.engagementData) === null || _entry$engagementData16 === void 0 ? void 0 : _entry$engagementData16.highlyEngaged) / answeredCount * 100 : 0];

            var data = _this3.createData(entry.id, entry.question, perceptionData, '---');

            console.log('bottom result '.concat(JSON.stringify(data)));
            return data;
          });
        });
        this.setState({
          bottomResultsTableData: newBottomResultsDataSet
        });
      }

      if (orgSurveyCompareDistributionsChartData !== prevProps.orgSurveyCompareDistributionsChartData) {
        this.setState({
          distributionChartData: orgSurveyCompareDistributionsChartData
        });
      }
    }
  }, {
    key: "__onBackToCompare__REACT_HOT_LOADER__",
    value: function __onBackToCompare__REACT_HOT_LOADER__() {
      _store.history.push('/app/org-survey-compare/default');
    }
  }, {
    key: "createData",
    value: function createData(grouping, question, perceptionData, shift) {
      this.counter += 1;
      return {
        id: this.counter,
        grouping: grouping,
        question: question,
        perceptionData: perceptionData,
        shift: shift
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          topResultsTableData = _this$state.topResultsTableData,
          bottomResultsTableData = _this$state.bottomResultsTableData,
          distributionChartData = _this$state.distributionChartData;
      return _react["default"].createElement("div", null, _react["default"].createElement("div", {
        className: "col-md-12 col-sm-12 col-12 animation slideInRight"
      }, _react["default"].createElement("div", {
        className: "p-4"
      }, _react["default"].createElement(_reactCollapsible["default"], {
        trigger: _react["default"].createElement(_IntlMessages["default"], {
          id: "engagement.survey.results.expectations"
        })
      }, _react["default"].createElement("div", {
        className: "animated slideInUpTiny animation-duration-3"
      }, _expectationsData.expectationsData.map(function (data, index) {
        return _react["default"].createElement(_ListItem["default"], {
          key: index,
          data: data,
          styleName: "card-strip"
        });
      }))))), _react["default"].createElement("div", {
        className: "col-md-12 col-sm-12 col-12 animation slideInRight"
      }, _react["default"].createElement(_ContainerHeader["default"], {
        title: _react["default"].createElement(_IntlMessages["default"], {
          id: "engagement.survey.results.comparison"
        })
      }), _react["default"].createElement("div", {
        className: "card p-4"
      }, _react["default"].createElement("div", {
        className: "row"
      }, _react["default"].createElement(_Distribution["default"], {
        distributionData: distributionChartData
      })))), _react["default"].createElement("div", {
        className: "col-md-12 col-sm-12 col-12 animation slideInRight"
      }, _react["default"].createElement(_ContainerHeader["default"], {
        title: _react["default"].createElement(_IntlMessages["default"], {
          id: "engagement.survey.results.top"
        })
      }), _react["default"].createElement("div", {
        className: "card p-4"
      }, Array.isArray(topResultsTableData) ? topResultsTableData.map(function (topResult, index) {
        return _react["default"].createElement(_DimensionTable["default"], {
          key: index,
          data: topResult
        });
      }) : null, ";")), _react["default"].createElement("div", {
        className: "col-md-12 col-sm-12 col-12 animation slideInRight"
      }, _react["default"].createElement(_ContainerHeader["default"], {
        title: _react["default"].createElement(_IntlMessages["default"], {
          id: "engagement.survey.results.bottom"
        })
      }), _react["default"].createElement("div", {
        className: "card p-4"
      }, _react["default"].createElement(_DimensionTable["default"], {
        data: bottomResultsTableData
      }))));
    }
  }]);

  return Component;
}(_react["default"].Component);

exports.Component = Component;
var _default = Component;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Component.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Component.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Component.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Component.js");

  __REACT_HOT_LOADER__.register(_ContainerHeader, "_ContainerHeader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Component.js");

  __REACT_HOT_LOADER__.register(_reactCollapsible, "_reactCollapsible", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Component.js");

  __REACT_HOT_LOADER__.register(_ListItem, "_ListItem", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Component.js");

  __REACT_HOT_LOADER__.register(_Distribution, "_Distribution", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Component.js");

  __REACT_HOT_LOADER__.register(_DimensionTable, "_DimensionTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Component.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Component.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Component.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Component.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Component.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Component.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Component.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Component.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Component.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Component.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Component.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Component.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Component.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Component.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Component.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Component.js");
}();

;

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _dompurify = _interopRequireDefault(__webpack_require__(266));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ListItem = function ListItem(_ref) {
  var styleName = _ref.styleName,
      data = _ref.data;
  var name = data.name,
      description = data.description;
  return _react["default"].createElement("div", {
    className: "user-list d-flex flex-row  ".concat(styleName)
  }, _react["default"].createElement("div", {
    className: "description"
  }, _react["default"].createElement("h3", null, name), _react["default"].createElement("div", {
    dangerouslySetInnerHTML: {
      __html: _dompurify["default"].sanitize(description)
    }
  })));
};

var _default = ListItem;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ListItem, "ListItem", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/ListItem.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/ListItem.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/ListItem.js");

  __REACT_HOT_LOADER__.register(_dompurify, "_dompurify", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/ListItem.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/ListItem.js");

  __REACT_HOT_LOADER__.register(ListItem, "ListItem", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/ListItem.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/ListItem.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/ListItem.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/ListItem.js");
}();

;

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _recharts = __webpack_require__(108);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Distribution = function Distribution(_ref) {
  var distributionData = _ref.distributionData; // console.log(JSON.stringify(data));

  var uniqueKeys = distributionData ? distributionData.shift() : [];
  return (uniqueKeys === null || uniqueKeys === void 0 ? void 0 : uniqueKeys.length) > 1 ? _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_recharts.ResponsiveContainer, {
    width: "100%",
    height: 200
  }, _react["default"].createElement(_recharts.BarChart, {
    data: distributionData,
    margin: {
      top: 10,
      right: 0,
      left: -25,
      bottom: 0
    }
  }, _react["default"].createElement(_recharts.XAxis, {
    dataKey: "question"
  }), _react["default"].createElement(_recharts.YAxis, null), _react["default"].createElement(_recharts.CartesianGrid, {
    strokeDasharray: "3 3"
  }), _react["default"].createElement(_recharts.Tooltip, null), _react["default"].createElement(_recharts.Legend, null), _react["default"].createElement(_recharts.Bar, {
    dataKey: uniqueKeys[0],
    fill: "#3367d6"
  }), _react["default"].createElement(_recharts.Bar, {
    dataKey: uniqueKeys[1],
    fill: "#ffc658"
  })))) : _react["default"].createElement(_react["default"].Fragment, null);
};

var _default = Distribution;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Distribution, "Distribution", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/Distribution.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/Distribution.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/Distribution.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/Distribution.js");

  __REACT_HOT_LOADER__.register(Distribution, "Distribution", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/Distribution.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/Distribution.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/Distribution.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/Distribution.js");
}();

;

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _DimensionTableCell = _interopRequireDefault(__webpack_require__(1841));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var DimensionTable = function DimensionTable(_ref) {
  var data = _ref.data;
  return _react["default"].createElement("div", {
    className: "table-responsive-material"
  }, _react["default"].createElement("table", {
    className: "default-table table-unbordered table table-hover"
  }, _react["default"].createElement("thead", {
    className: "th-border-b"
  }, _react["default"].createElement("tr", null, _react["default"].createElement("th", null, "Dimension"), _react["default"].createElement("th", null, "Question"), _react["default"].createElement("th", null, _react["default"].createElement("div", {
    className: "media project-list"
  }, _react["default"].createElement("span", {
    className: "circle-shape bg-red"
  }), _react["default"].createElement("div", {
    className: "media-body"
  }, "% neg perception"), _react["default"].createElement("span", {
    className: "circle-shape bg-orange"
  }), _react["default"].createElement("div", {
    className: "media-body"
  }, "% neg hesitance"), _react["default"].createElement("span", {
    className: "circle-shape bg-blue"
  }), _react["default"].createElement("div", {
    className: "media-body"
  }, "% pos hesitance"), _react["default"].createElement("span", {
    className: "circle-shape bg-green"
  }), _react["default"].createElement("div", {
    className: "media-body"
  }, "% pos perception"))), _react["default"].createElement("th", null, "Shift"))), _react["default"].createElement("tbody", null, Array.isArray(data) ? data.map(function (data) {
    return _react["default"].createElement(_DimensionTableCell["default"], {
      key: data.id,
      data: data
    });
  }) : _react["default"].createElement(_react["default"].Fragment, null))));
};

var _default = DimensionTable;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(DimensionTable, "DimensionTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/DimensionTable.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/DimensionTable.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/DimensionTable.js");

  __REACT_HOT_LOADER__.register(_DimensionTableCell, "_DimensionTableCell", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/DimensionTable.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/DimensionTable.js");

  __REACT_HOT_LOADER__.register(DimensionTable, "DimensionTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/DimensionTable.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/DimensionTable.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/DimensionTable.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/DimensionTable.js");
}();

;

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _MultiCellProgressBar = _interopRequireDefault(__webpack_require__(1842));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var DimensionTableCell = function DimensionTableCell(_ref) {
  var key = _ref.key,
      data = _ref.data;
  var grouping = data.grouping,
      question = data.question,
      perceptionData = data.perceptionData,
      shift = data.shift;
  return _react["default"].createElement("tr", {
    tabIndex: -1,
    key: key
  }, _react["default"].createElement("td", {
    width: "10%"
  }, grouping), _react["default"].createElement("td", {
    width: "45%"
  }, question), _react["default"].createElement("td", {
    width: "40%"
  }, _react["default"].createElement("div", {
    className: "user-profile d-flex flex-row align-items-center"
  }, _react["default"].createElement("div", {
    className: "user-detail"
  }, _react["default"].createElement("h5", {
    className: "user-name"
  }, _react["default"].createElement(_MultiCellProgressBar["default"], {
    key: key,
    data: perceptionData
  }))))), _react["default"].createElement("td", {
    width: "5%"
  }, shift));
};

var _default = DimensionTableCell;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(DimensionTableCell, "DimensionTableCell", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/DimensionTableCell.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/DimensionTableCell.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/DimensionTableCell.js");

  __REACT_HOT_LOADER__.register(_MultiCellProgressBar, "_MultiCellProgressBar", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/DimensionTableCell.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/DimensionTableCell.js");

  __REACT_HOT_LOADER__.register(DimensionTableCell, "DimensionTableCell", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/DimensionTableCell.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/DimensionTableCell.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/DimensionTableCell.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/DimensionTableCell.js");
}();

;

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _NumberFormatters = __webpack_require__(99);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var MultiCellProgressBar = function MultiCellProgressBar(_ref) {
  var data = _ref.data;

  if (Array.isArray(data) && data.length > 3) {
    return _react["default"].createElement(_reactstrap.Progress, {
      multi: true
    }, _react["default"].createElement(_reactstrap.Progress, {
      bar: true,
      color: "danger",
      value: data[0] > 0 ? data[0] : 1
    }, data[0] > 0 ? (0, _NumberFormatters.formatPercentageRounded)(data[0]) : ''), _react["default"].createElement(_reactstrap.Progress, {
      bar: true,
      color: "warning",
      value: data[1] > 0 ? data[1] : 1
    }, data[1] > 0 ? (0, _NumberFormatters.formatPercentageRounded)(data[1]) : ''), _react["default"].createElement(_reactstrap.Progress, {
      bar: true,
      value: data[2]
    }, data[2] > 0 ? (0, _NumberFormatters.formatPercentageRounded)(data[2]) : ''), _react["default"].createElement(_reactstrap.Progress, {
      bar: true,
      color: "success",
      value: data[3] > 0 ? data[3] : 1
    }, data[3] > 0 ? (0, _NumberFormatters.formatPercentageRounded)(data[3]) : ''));
  }

  return null;
};

var _default = MultiCellProgressBar;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MultiCellProgressBar, "MultiCellProgressBar", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/MultiCellProgressBar.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/MultiCellProgressBar.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/MultiCellProgressBar.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/MultiCellProgressBar.js");

  __REACT_HOT_LOADER__.register(MultiCellProgressBar, "MultiCellProgressBar", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/MultiCellProgressBar.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/MultiCellProgressBar.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/MultiCellProgressBar.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/MultiCellProgressBar.js");
}();

;

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.expectationsData = void 0;
var expectationsData = [{
  name: 'UNDERSTAND YOUR RESULTS',
  description: 'This report provides a summary of the teams results from the engagement survey.</br>To explore all dimensions, drill down into the relevant sections of the results to gain further insight.'
}, {
  name: 'TEST',
  description: 'In a professional context it often happens that private or corporate clients corder a publication to be made and presented with the actual content still not being ready.</br>Think of a news blog that\'s filled with content hourly on the day of going live.'
}, {
  name: 'REVIEW AND REFLECT',
  description: 'Review your teams results</br>Explore how well you are demonstrating leadership behaviours and expectations via indexes.'
}, {
  name: 'OPENLY SHARE YOUR RESULTS',
  description: 'In the next few weeks share the results with your team and ask open questions to gain more insight.</br>Agree with your tem what yu can do as a group.</br>'
}, {
  name: 'IDENTIFY AND IMPLEMENT ACTIONS',
  description: 'Identify 2-3 actions that matter most to your team</br>Inform management about the priorities and actions agreed upon by the team</br>Implement and regularly track progress.'
}, {
  name: 'COMMUNICATE REGULARLY',
  description: 'It\'s critical to discuss engagement regularly with your team to ensure they understand that it\'s a priority all year, not just when the survey is conducted</br>Sharing regular messages that "you said x, and we\'er doing Y" will ensure your team know you are together action on their feedback.'
}];
exports.expectationsData = expectationsData;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(expectationsData, "expectationsData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/Data/expectationsData.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(expectationsData, "expectationsData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/Data/expectationsData.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/Data/expectationsData.js");
}();

;

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Container["default"];
  }
});

var _Container = _interopRequireDefault(__webpack_require__(1845));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_Container, "_Container", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/index.js");
}();

;

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.mapStateToProps = void 0;

var _reactRedux = __webpack_require__(10);

var _OrgSurvey = __webpack_require__(178);

var _Component = _interopRequireDefault(__webpack_require__(1846));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var mapStateToProps = function mapStateToProps(_ref) {
  var orgSurveys = _ref.orgSurveys;
  var orgSurveyCompareList = orgSurveys.orgSurveyCompareList,
      orgSurveyCompareRadarChartData = orgSurveys.orgSurveyCompareRadarChartData;
  return {
    orgSurveyCompareList: orgSurveyCompareList,
    orgSurveyCompareRadarChartData: orgSurveyCompareRadarChartData
  };
};

exports.mapStateToProps = mapStateToProps;

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  showOrgSurveyLoader: _OrgSurvey.showOrgSurveyLoader,
  fetchOrgSurveysCompareRadarChartData: _OrgSurvey.fetchOrgSurveysCompareRadarChartData
})(_Component["default"]);

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Container.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Container.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_Component, "_Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Container.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Container.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Container.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Container.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Container.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Container.js");
}();

;

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Component = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _store = __webpack_require__(54);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _CardBox = _interopRequireDefault(__webpack_require__(228));

var _ContainerHeader = _interopRequireDefault(__webpack_require__(63));

var _OrgSurveyCompareRadarChart = _interopRequireDefault(__webpack_require__(1847));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Component =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Component, _React$Component);

  function Component() {
    var _this;

    _classCallCheck(this, Component);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Component).call(this));

    _defineProperty(_assertThisInitialized(_this), "onBackToCompare", function () {
      var _this2;

      return (_this2 = _this).__onBackToCompare__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    return _this;
  }

  _createClass(Component, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.showOrgSurveyLoader();
      this.props.fetchOrgSurveysCompareRadarChartData();
    }
  }, {
    key: "__onBackToCompare__REACT_HOT_LOADER__",
    value: function __onBackToCompare__REACT_HOT_LOADER__() {
      _store.history.push('/app/org-survey-compare/default');
    }
  }, {
    key: "render",
    value: function render() {
      var orgSurveyCompareRadarChartData = this.props.orgSurveyCompareRadarChartData;
      return _react["default"].createElement("div", {
        className: "animated slideInUpTiny animation-duration-3"
      }, _react["default"].createElement(_ContainerHeader["default"], {
        title: _react["default"].createElement(_IntlMessages["default"], {
          id: "chart.radar"
        })
      }), _react["default"].createElement("div", {
        className: "row"
      }, _react["default"].createElement(_CardBox["default"], {
        heading: "Selected Surveys Radar Chart"
      }, _react["default"].createElement(_OrgSurveyCompareRadarChart["default"], {
        data: orgSurveyCompareRadarChartData
      }))));
    }
  }]);

  return Component;
}(_react["default"].Component);

exports.Component = Component;
var _default = Component;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Component.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Component.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Component.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Component.js");

  __REACT_HOT_LOADER__.register(_CardBox, "_CardBox", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Component.js");

  __REACT_HOT_LOADER__.register(_ContainerHeader, "_ContainerHeader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Component.js");

  __REACT_HOT_LOADER__.register(_OrgSurveyCompareRadarChart, "_OrgSurveyCompareRadarChart", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Component.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Component.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Component.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Component.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Component.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Component.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Component.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Component.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Component.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Component.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Component.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Component.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Component.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Component.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Component.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Component.js");
}();

;

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _recharts = __webpack_require__(108);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var OrgSurveyCompareRadarChart = function OrgSurveyCompareRadarChart(_ref) {
  var data = _ref.data; // console.log(JSON.stringify(data));

  var uniqueKeys = data.shift(); // removes the first row from the data set to be used by the chart

  return (uniqueKeys === null || uniqueKeys === void 0 ? void 0 : uniqueKeys.length) > 1 ? _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_recharts.ResponsiveContainer, {
    width: "100%",
    height: 600
  }, _react["default"].createElement(_recharts.RadarChart, {
    outerRadius: 150,
    data: data
  }, _react["default"].createElement(_recharts.Radar, {
    name: "Survey 1",
    dataKey: uniqueKeys[0],
    stroke: "#ffc658",
    fill: "#ffc658",
    fillOpacity: 0.6
  }), _react["default"].createElement(_recharts.Radar, {
    name: "Survey 2",
    dataKey: uniqueKeys[1],
    stroke: "#3367d6",
    fill: "#3367d6",
    fillOpacity: 0.6
  }), _react["default"].createElement(_recharts.PolarGrid, null), _react["default"].createElement(_recharts.Legend, null), _react["default"].createElement(_recharts.PolarAngleAxis, {
    dataKey: "question"
  }), _react["default"].createElement(_recharts.PolarRadiusAxis, {
    angle: 45,
    domain: [0, 9]
  }))), ";") : _react["default"].createElement(_react["default"].Fragment, null);
};

var _default = OrgSurveyCompareRadarChart;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OrgSurveyCompareRadarChart, "OrgSurveyCompareRadarChart", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Components/OrgSurveyCompareRadarChart.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Components/OrgSurveyCompareRadarChart.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Components/OrgSurveyCompareRadarChart.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Components/OrgSurveyCompareRadarChart.js");

  __REACT_HOT_LOADER__.register(OrgSurveyCompareRadarChart, "OrgSurveyCompareRadarChart", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Components/OrgSurveyCompareRadarChart.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Components/OrgSurveyCompareRadarChart.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Components/OrgSurveyCompareRadarChart.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Components/OrgSurveyCompareRadarChart.js");
}();

;

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Container["default"];
  }
});

var _Container = _interopRequireDefault(__webpack_require__(1849));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_Container, "_Container", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/index.js");
}();

;

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.mapStateToProps = void 0;

var _reactRedux = __webpack_require__(10);

var _Employee = __webpack_require__(173);

var _OrgSurveyAnswers = __webpack_require__(211);

var _Component = _interopRequireDefault(__webpack_require__(1850));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var mapStateToProps = function mapStateToProps(_ref) {
  var emps = _ref.emps,
      surveys = _ref.surveys,
      settings = _ref.settings,
      surveyGroups = _ref.surveyGroups,
      surveyQuestions = _ref.surveyQuestions,
      orgSurveyAnswers = _ref.orgSurveyAnswers;
  var width = settings.width;
  var empSurveyAnswers = emps.empSurveyAnswers,
      emploader = emps.loader;
  var surveyList = surveys.surveyList;
  var surveyGroupList = surveyGroups.surveyGroupList;
  var surveyQuestionList = surveyQuestions.surveyQuestionList;
  var showMessage = orgSurveyAnswers.showMessage,
      alertMessage = orgSurveyAnswers.alertMessage,
      answersloader = orgSurveyAnswers.loader;
  var match = false;
  return {
    width: width,
    emploader: emploader,
    empSurveyAnswers: empSurveyAnswers,
    surveyList: surveyList,
    surveyGroupList: surveyGroupList,
    surveyQuestionList: surveyQuestionList,
    showMessage: showMessage,
    alertMessage: alertMessage,
    answersloader: answersloader,
    match: match
  };
};

exports.mapStateToProps = mapStateToProps;

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  saveEmpSurveyAnswers: _Employee.saveEmpSurveyAnswers,
  showEmpLoader: _Employee.showEmpLoader,
  showOrgSurveyAnswersLoader: _OrgSurveyAnswers.showOrgSurveyAnswersLoader,
  handleAnswersMessageClose: _OrgSurveyAnswers.handleAnswersMessageClose
})(_Component["default"]);

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/Container.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/Container.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_Component, "_Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/Container.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/Container.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/Container.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/Container.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/Container.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/Container.js");
}();

;

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Component = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactCollapsible = _interopRequireDefault(__webpack_require__(161));

var _reactstrap = __webpack_require__(6);

var _dompurify = _interopRequireDefault(__webpack_require__(266));

var _reactBootstrapSweetalert = _interopRequireDefault(__webpack_require__(80));

var _rcSlider = _interopRequireDefault(__webpack_require__(1851));

var _index = _interopRequireDefault(__webpack_require__(63));

var _index2 = _interopRequireDefault(__webpack_require__(1866));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

__webpack_require__(1867);

var _CircularProgress = _interopRequireDefault(__webpack_require__(24));

var _SurveyService = __webpack_require__(176);

var _System = __webpack_require__(55);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Component =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Component, _React$Component);

  function Component() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Component);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Component)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      menuState: false,
      currentQuestionName: '',
      currentQuestionText: '',
      currentQuestionSelected: 0,
      currentQuestionAnswerValue: 0,
      finaliseSurveyCheck: false,
      icon: 503,
      iconColour: 'blue-grey'
    });

    _defineProperty(_assertThisInitialized(_this), "handleRequestClose", function () {
      var _this2;

      return (_this2 = _this).__handleRequestClose__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "currentQuestionDisplayName", function () {
      var _this3;

      return (_this3 = _this).__currentQuestionDisplayName__REACT_HOT_LOADER__.apply(_this3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "currentQuestionDisplayText", function () {
      var _this4;

      return (_this4 = _this).__currentQuestionDisplayText__REACT_HOT_LOADER__.apply(_this4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "getCurrentQuestion", function () {
      var _this5;

      return (_this5 = _this).__getCurrentQuestion__REACT_HOT_LOADER__.apply(_this5, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "getCurrentQuestionById", function () {
      var _this6;

      return (_this6 = _this).__getCurrentQuestionById__REACT_HOT_LOADER__.apply(_this6, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "currentQuestionPagingDisplayText", function () {
      var _this7;

      return (_this7 = _this).__currentQuestionPagingDisplayText__REACT_HOT_LOADER__.apply(_this7, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "currentQuestionsCount", function () {
      var _this8;

      return (_this8 = _this).__currentQuestionsCount__REACT_HOT_LOADER__.apply(_this8, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "hasNextQuestion", function () {
      var _this9;

      return (_this9 = _this).__hasNextQuestion__REACT_HOT_LOADER__.apply(_this9, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "hasPreviousQuestion", function () {
      var _this10;

      return (_this10 = _this).__hasPreviousQuestion__REACT_HOT_LOADER__.apply(_this10, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "setNextQuestion", function () {
      var _this11;

      return (_this11 = _this).__setNextQuestion__REACT_HOT_LOADER__.apply(_this11, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "setPreviousQuestion", function () {
      var _this12;

      return (_this12 = _this).__setPreviousQuestion__REACT_HOT_LOADER__.apply(_this12, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "gotoQuestion", function () {
      var _this13;

      return (_this13 = _this).__gotoQuestion__REACT_HOT_LOADER__.apply(_this13, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "setCurrentQuestionAnswerValue", function () {
      var _this14;

      return (_this14 = _this).__setCurrentQuestionAnswerValue__REACT_HOT_LOADER__.apply(_this14, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "setIcon", function () {
      var _this15;

      return (_this15 = _this).__setIcon__REACT_HOT_LOADER__.apply(_this15, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "getUpdatedCurrentEmpSurveyAnswers", function () {
      var _this16;

      return (_this16 = _this).__getUpdatedCurrentEmpSurveyAnswers__REACT_HOT_LOADER__.apply(_this16, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "getUpdatedAndClosedCurrentEmpSurveyAnswers", function () {
      var _this17;

      return (_this17 = _this).__getUpdatedAndClosedCurrentEmpSurveyAnswers__REACT_HOT_LOADER__.apply(_this17, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onGotoQuestionClick", function () {
      var _this18;

      return (_this18 = _this).__onGotoQuestionClick__REACT_HOT_LOADER__.apply(_this18, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "getQuestionAnswerList", function () {
      var _this19;

      return (_this19 = _this).__getQuestionAnswerList__REACT_HOT_LOADER__.apply(_this19, arguments);
    });

    return _this;
  }

  _createClass(Component, [{
    key: "__handleRequestClose__REACT_HOT_LOADER__",
    value: function __handleRequestClose__REACT_HOT_LOADER__() {
      var handleAnswersMessageClose = this.props.handleAnswersMessageClose;
      handleAnswersMessageClose(); // this.setState({ menuState: false });
    }
  }, {
    key: "log",
    value: function log(value) {
      console.log(value); //eslint-disable-line
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var currentQuestionSelected = this.state.currentQuestionSelected;
      this.setCurrentQuestionAnswerValue(currentQuestionSelected);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var currentQuestionSelected = this.state.currentQuestionSelected;

      if (this.props.empSurveyAnswers !== prevProps.empSurveyAnswers) {
        this.setCurrentQuestionAnswerValue(currentQuestionSelected);
      }
    }
    /***
     * use the current question name
     */

  }, {
    key: "__currentQuestionDisplayName__REACT_HOT_LOADER__",
    value: function __currentQuestionDisplayName__REACT_HOT_LOADER__() {
      var currentQuestion = this.getCurrentQuestion();

      if (currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.name) {
        return currentQuestion.name;
      }

      return undefined;
    }
  }, {
    key: "__currentQuestionDisplayText__REACT_HOT_LOADER__",
    value: function __currentQuestionDisplayText__REACT_HOT_LOADER__() {
      var currentQuestion = this.getCurrentQuestion();

      if (currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.text) {
        return currentQuestion.text;
      }

      return undefined;
    }
  }, {
    key: "__getCurrentQuestion__REACT_HOT_LOADER__",
    value: function __getCurrentQuestion__REACT_HOT_LOADER__() {
      var _empSurveyAnswers$ans;

      var currentQuestionSelected = this.state.currentQuestionSelected;
      var empSurveyAnswers = this.props.empSurveyAnswers;

      if ((empSurveyAnswers === null || empSurveyAnswers === void 0 ? void 0 : (_empSurveyAnswers$ans = empSurveyAnswers.answers) === null || _empSurveyAnswers$ans === void 0 ? void 0 : _empSurveyAnswers$ans.length) > 0) {
        var currentQuestionId = empSurveyAnswers === null || empSurveyAnswers === void 0 ? void 0 : empSurveyAnswers.answers[currentQuestionSelected].questionId;
        return this.getCurrentQuestionById(currentQuestionId);
      }

      return undefined;
    }
  }, {
    key: "__getCurrentQuestionById__REACT_HOT_LOADER__",
    value: function __getCurrentQuestionById__REACT_HOT_LOADER__(questionId) {
      var surveyQuestionList = this.props.surveyQuestionList;

      if (questionId) {
        var currentQuestion = surveyQuestionList.filter(function (question) {
          return question.id === questionId;
        });

        if ((currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.length) > 0) {
          return currentQuestion[0];
        }
      }

      return undefined;
    }
  }, {
    key: "__currentQuestionPagingDisplayText__REACT_HOT_LOADER__",
    value: function __currentQuestionPagingDisplayText__REACT_HOT_LOADER__() {
      var currentQuestionSelected = this.state.currentQuestionSelected;
      return 'Question '.concat(currentQuestionSelected + 1).concat(' of ').concat(this.currentQuestionsCount());
    }
  }, {
    key: "__currentQuestionsCount__REACT_HOT_LOADER__",
    value: function __currentQuestionsCount__REACT_HOT_LOADER__() {
      var _empSurveyAnswers$ans2, _empSurveyAnswers$ans3;

      var empSurveyAnswers = this.props.empSurveyAnswers;
      return (empSurveyAnswers === null || empSurveyAnswers === void 0 ? void 0 : (_empSurveyAnswers$ans2 = empSurveyAnswers.answers) === null || _empSurveyAnswers$ans2 === void 0 ? void 0 : _empSurveyAnswers$ans2.length) > 0 ? empSurveyAnswers === null || empSurveyAnswers === void 0 ? void 0 : (_empSurveyAnswers$ans3 = empSurveyAnswers.answers) === null || _empSurveyAnswers$ans3 === void 0 ? void 0 : _empSurveyAnswers$ans3.length : 0;
    }
  }, {
    key: "__hasNextQuestion__REACT_HOT_LOADER__",
    value: function __hasNextQuestion__REACT_HOT_LOADER__() {
      var currentQuestionSelected = this.state.currentQuestionSelected;
      return currentQuestionSelected < this.currentQuestionsCount() - 1;
    }
  }, {
    key: "__hasPreviousQuestion__REACT_HOT_LOADER__",
    value: function __hasPreviousQuestion__REACT_HOT_LOADER__() {
      var currentQuestionSelected = this.state.currentQuestionSelected;
      return currentQuestionSelected > 0;
    }
  }, {
    key: "__setNextQuestion__REACT_HOT_LOADER__",
    value: function __setNextQuestion__REACT_HOT_LOADER__() {
      var currentQuestionSelected = this.state.currentQuestionSelected;
      var questionToSelect = currentQuestionSelected + 1;
      this.gotoQuestion(questionToSelect);
    }
  }, {
    key: "__setPreviousQuestion__REACT_HOT_LOADER__",
    value: function __setPreviousQuestion__REACT_HOT_LOADER__() {
      var currentQuestionSelected = this.state.currentQuestionSelected;
      var questionToSelect = currentQuestionSelected - 1;
      this.gotoQuestion(questionToSelect);
    }
  }, {
    key: "__gotoQuestion__REACT_HOT_LOADER__",
    value: function __gotoQuestion__REACT_HOT_LOADER__(questionNumber) {
      if (questionNumber > -1 && questionNumber < this.currentQuestionsCount()) {
        this.setState({
          currentQuestionSelected: questionNumber
        });
        this.setCurrentQuestionAnswerValue(questionNumber);
      }
    }
  }, {
    key: "__setCurrentQuestionAnswerValue__REACT_HOT_LOADER__",
    value: function __setCurrentQuestionAnswerValue__REACT_HOT_LOADER__(currentQuestionSelected) {
      var _empSurveyAnswers$ans4;

      var empSurveyAnswers = this.props.empSurveyAnswers;

      if (currentQuestionSelected >= 0 && currentQuestionSelected < (empSurveyAnswers === null || empSurveyAnswers === void 0 ? void 0 : (_empSurveyAnswers$ans4 = empSurveyAnswers.answers) === null || _empSurveyAnswers$ans4 === void 0 ? void 0 : _empSurveyAnswers$ans4.length)) {
        var currentAnswerValue = empSurveyAnswers.answers[currentQuestionSelected].answer;
        this.setState({
          currentQuestionAnswerValue: currentAnswerValue
        });
        this.setIcon(currentAnswerValue);
      }
    }
  }, {
    key: "__setIcon__REACT_HOT_LOADER__",
    value: function __setIcon__REACT_HOT_LOADER__(value) {
      var iconValues = {
        0: {
          icon: 'day-800',
          iconColour: 'blue-grey'
        },
        1: {
          icon: '503',
          iconColour: 'blue-grey'
        },
        2: {
          icon: '601',
          iconColour: 'blue'
        },
        3: {
          icon: 'day-701',
          iconColour: 'green'
        },
        4: {
          icon: 'day-801',
          iconColour: 'amber'
        },
        5: {
          icon: 'day-800',
          iconColour: 'amber'
        }
      };

      if (value >= 0 && value <= 5) {
        // console.log('setting values to '.concat(value).concat(' ').concat(iconValues[value].icon).concat(' ').concat(iconValues[value].iconColour));
        this.setState({
          icon: iconValues[value].icon,
          iconColour: iconValues[value].iconColour
        });
      }
    }
  }, {
    key: "__getUpdatedCurrentEmpSurveyAnswers__REACT_HOT_LOADER__",
    value: function __getUpdatedCurrentEmpSurveyAnswers__REACT_HOT_LOADER__() {
      var _empSurveyAnswers$ans5;

      var _this$state = this.state,
          currentQuestionSelected = _this$state.currentQuestionSelected,
          currentQuestionAnswerValue = _this$state.currentQuestionAnswerValue;
      var empSurveyAnswers = this.props.empSurveyAnswers;

      if ((empSurveyAnswers === null || empSurveyAnswers === void 0 ? void 0 : (_empSurveyAnswers$ans5 = empSurveyAnswers.answers) === null || _empSurveyAnswers$ans5 === void 0 ? void 0 : _empSurveyAnswers$ans5.length) > 0) {
        empSurveyAnswers.answers[currentQuestionSelected].answer = currentQuestionAnswerValue;
      }

      return empSurveyAnswers;
    }
  }, {
    key: "__getUpdatedAndClosedCurrentEmpSurveyAnswers__REACT_HOT_LOADER__",
    value: function __getUpdatedAndClosedCurrentEmpSurveyAnswers__REACT_HOT_LOADER__() {
      var empSurveyAnswers = this.getUpdatedCurrentEmpSurveyAnswers();
      empSurveyAnswers.surveyClosedDate = new Date();
      return empSurveyAnswers;
    }
  }, {
    key: "__onGotoQuestionClick__REACT_HOT_LOADER__",
    value: function __onGotoQuestionClick__REACT_HOT_LOADER__(index) {
      var _this$props = this.props,
          showOrgSurveyAnswersLoader = _this$props.showOrgSurveyAnswersLoader,
          saveEmpSurveyAnswers = _this$props.saveEmpSurveyAnswers,
          empSurveyAnswers = _this$props.empSurveyAnswers;

      if (!(0, _SurveyService.surveyComplete)(empSurveyAnswers)) {
        showOrgSurveyAnswersLoader();
        saveEmpSurveyAnswers(this.getUpdatedCurrentEmpSurveyAnswers());
      }

      this.gotoQuestion(index);
    }
  }, {
    key: "__getQuestionAnswerList__REACT_HOT_LOADER__",
    value: function __getQuestionAnswerList__REACT_HOT_LOADER__() {
      var _empSurveyAnswers$ans6,
          _this20 = this;

      var empSurveyAnswers = this.props.empSurveyAnswers;

      if ((empSurveyAnswers === null || empSurveyAnswers === void 0 ? void 0 : (_empSurveyAnswers$ans6 = empSurveyAnswers.answers) === null || _empSurveyAnswers$ans6 === void 0 ? void 0 : _empSurveyAnswers$ans6.length) > 0) {
        var empSurveyAnswersList = empSurveyAnswers.answers.map(function (empSurveyAnswer, index) {
          if (empSurveyAnswer === null || empSurveyAnswer === void 0 ? void 0 : empSurveyAnswer.questionId) {
            var questionById = _this20.getCurrentQuestionById(empSurveyAnswer.questionId);

            if (questionById) {
              return {
                image: empSurveyAnswer.answer > 0 ? 'check' : 'minus',
                title: questionById ? questionById.name : '???',
                clickEvent: function clickEvent() {
                  _this20.onGotoQuestionClick(index);
                },
                color: empSurveyAnswer.answer > 0 ? 'green' : 'amber',
                borderColor: empSurveyAnswer.answer > 0 ? 'green' : 'amber'
              };
            }
          }
        });
        return empSurveyAnswersList;
      }

      return [];
    }
  }, {
    key: "render",
    value: function render() {
      var _this21 = this;

      var _this$state2 = this.state,
          currentQuestionAnswerValue = _this$state2.currentQuestionAnswerValue,
          finaliseSurveyCheck = _this$state2.finaliseSurveyCheck,
          icon = _this$state2.icon,
          iconColour = _this$state2.iconColour;
      var _this$props2 = this.props,
          answersloader = _this$props2.answersloader,
          emploader = _this$props2.emploader,
          saveEmpSurveyAnswers = _this$props2.saveEmpSurveyAnswers,
          showOrgSurveyAnswersLoader = _this$props2.showOrgSurveyAnswersLoader,
          empSurveyAnswers = _this$props2.empSurveyAnswers; // const style = { width: 400, margin: 20 };

      var marks = {
        0: currentQuestionAnswerValue > 0 ? 'Selected' : {
          style: {
            color: 'red'
          },
          label: _react["default"].createElement("strong", null, "Select")
        },
        1: currentQuestionAnswerValue === 1 ? {
          style: {
            color: 'green'
          },
          label: _react["default"].createElement("strong", null, "Blocked")
        } : 'Blocked',
        2: currentQuestionAnswerValue === 2 ? {
          style: {
            color: 'green'
          },
          label: _react["default"].createElement("strong", null, "Developing")
        } : 'Developing',
        3: currentQuestionAnswerValue === 3 ? {
          style: {
            color: 'green'
          },
          label: _react["default"].createElement("strong", null, "Emerging")
        } : 'Emerging',
        4: currentQuestionAnswerValue === 4 ? {
          style: {
            color: 'green'
          },
          label: _react["default"].createElement("strong", null, "Adapting")
        } : 'Adapting',
        5: currentQuestionAnswerValue === 5 ? {
          style: {
            color: 'green'
          },
          label: _react["default"].createElement("strong", null, "Optimizing")
        } : 'Optimizing'
      };
      return _react["default"].createElement("div", {
        className: "dashboard animated slideInUpTiny animation-duration-3"
      }, emploader || answersloader ? _react["default"].createElement("div", {
        className: "loader-view",
        style: {
          height: this.props.width >= 1200 ? 'calc(100vh - 266px)' : 'calc(100vh - 246px)'
        }
      }, _react["default"].createElement(_CircularProgress["default"], null)) : _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("div", {
        className: "ml-3 mt-3"
      }, _react["default"].createElement(_index["default"], {
        match: this.props.match,
        title: (0, _SurveyService.surveyActive)(empSurveyAnswers) ? _react["default"].createElement(_IntlMessages["default"], {
          id: "orgEmpSurvey.activeSurvey"
        }) : _react["default"].createElement(_IntlMessages["default"], {
          id: "orgEmpSurvey.inactiveSurvey"
        })
      })), _react["default"].createElement("div", {
        className: "row"
      }, _react["default"].createElement("div", {
        className: "col-md-9 col-12"
      }, _react["default"].createElement("div", {
        className: "jr-card ml-2 mr-2"
      }, _react["default"].createElement("div", {
        className: "jr-card-header d-flex"
      }, _react["default"].createElement("div", {
        className: "mr-auto"
      }, _react["default"].createElement("h3", {
        className: "card-heading"
      }, _react["default"].createElement("div", {
        dangerouslySetInnerHTML: {
          __html: _dompurify["default"].sanitize(this.currentQuestionDisplayName())
        }
      })), _react["default"].createElement("p", {
        className: "sub-heading"
      }, this.currentQuestionPagingDisplayText()))), _react["default"].createElement("div", {
        className: "jr-card-body"
      }, _react["default"].createElement("div", {
        className: "row"
      }, _react["default"].createElement("div", {
        className: "col-sm-3"
      }, _react["default"].createElement("div", {
        className: "temp-section mb-4 mb-sm-0 text-center text-sm-left"
      }, _react["default"].createElement("p", null, _react["default"].createElement("i", {
        className: 'detail-icon text-' + iconColour + ' wi wi-owm-' + icon
      })))), _react["default"].createElement("div", {
        key: "surveyQuestion",
        className: "col-sm-9 text-left text-sm-left"
      }, _react["default"].createElement("div", {
        dangerouslySetInnerHTML: {
          __html: _dompurify["default"].sanitize(this.currentQuestionDisplayText())
        }
      }))))), _react["default"].createElement("div", {
        className: "jr-card ml-2 mr-2"
      }, _react["default"].createElement("div", {
        className: "jr-card-header d-flex justify-content-between"
      }, _react["default"].createElement("div", null, _react["default"].createElement("h3", {
        className: "card-heading"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "orgEmpSurvey.answerHeader"
      })), _react["default"].createElement("div", null, _react["default"].createElement("div", {
        style: {
          width: this.props.width > 700 ? this.props.width - 570 : 300,
          margin: this.props.width > _System.TIGHT_FIT_PARAM ? 20 : 2
        }
      }, _react["default"].createElement(_rcSlider["default"], {
        max: 5,
        marks: marks,
        onChange: function onChange(value) {
          // this.log(value);
          _this21.setState({
            currentQuestionAnswerValue: value
          });

          _this21.setIcon(value);
        },
        value: currentQuestionAnswerValue,
        disabled: !(0, _SurveyService.surveyActive)(empSurveyAnswers)
      })))))), _react["default"].createElement("div", {
        className: "row"
      }, _react["default"].createElement("div", {
        className: "modal-box-footer d-flex flex-row"
      }, _react["default"].createElement(_reactstrap.Button, {
        className: "text-uppercase",
        id: "prevButton",
        disabled: !this.hasPreviousQuestion(),
        color: "primary",
        onClick: function onClick() {
          if ((0, _SurveyService.surveyActive)(empSurveyAnswers)) {
            showOrgSurveyAnswersLoader();
            saveEmpSurveyAnswers(_this21.getUpdatedCurrentEmpSurveyAnswers());
          }

          _this21.setPreviousQuestion();
        }
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "orgEmpSurvey.previousQuestion"
      })), _react["default"].createElement(_reactstrap.Button, {
        className: "text-uppercase",
        id: "nextButton",
        disabled: !this.hasNextQuestion(),
        color: "primary",
        onClick: function onClick() {
          if ((0, _SurveyService.surveyActive)(empSurveyAnswers)) {
            showOrgSurveyAnswersLoader();
            saveEmpSurveyAnswers(_this21.getUpdatedCurrentEmpSurveyAnswers());
          }

          _this21.setNextQuestion();
        }
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "orgEmpSurvey.nextQuestion"
      })), (0, _SurveyService.surveyActive)(empSurveyAnswers) ? (0, _SurveyService.surveyComplete)(empSurveyAnswers) ? _react["default"].createElement(_reactstrap.Button, {
        className: "text-uppercase",
        id: "finishButton",
        color: "primary",
        onClick: function onClick() {
          _this21.setState({
            finaliseSurveyCheck: true
          });
        }
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "orgEmpSurvey.saveAndCloseSurvey"
      })) : _react["default"].createElement(_reactstrap.Button, {
        className: "text-uppercase",
        id: "gotoButton",
        color: "primary",
        onClick: function onClick() {
          showOrgSurveyAnswersLoader();
          saveEmpSurveyAnswers(_this21.getUpdatedCurrentEmpSurveyAnswers());
        }
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "orgEmpSurvey.saveSurvey"
      })) : null))), _react["default"].createElement("div", {
        className: "col-md-3"
      }, _react["default"].createElement("div", {
        className: "jr-card jr-card-full-height ml-2 mr-2"
      }, _react["default"].createElement(_reactCollapsible["default"], {
        trigger: _react["default"].createElement(_IntlMessages["default"], {
          id: "dashboard.gotoQuestion"
        })
      }, this.getQuestionAnswerList().map(function (questionAnswerList, index) {
        return _react["default"].createElement(_index2["default"], {
          key: index,
          recentData: questionAnswerList
        });
      }))))), _react["default"].createElement(_reactBootstrapSweetalert["default"], {
        style: {
          width: this.props.width > _System.TIGHT_FIT_PARAM ? 500 : 300
        },
        show: finaliseSurveyCheck,
        custom: true,
        showCancel: true,
        confirmBtnText: _react["default"].createElement(_IntlMessages["default"], {
          id: "button.yes"
        }),
        cancelBtnText: _react["default"].createElement(_IntlMessages["default"], {
          id: "button.no"
        }),
        confirmBtnBsStyle: "primary",
        cancelBtnBsStyle: "default",
        customIcon: "assets/images/online-survey.jpeg",
        title: _react["default"].createElement(_IntlMessages["default"], {
          id: "general.areYouSure"
        }),
        onConfirm: function onConfirm() {
          saveEmpSurveyAnswers(_this21.getUpdatedAndClosedCurrentEmpSurveyAnswers());

          _this21.setState({
            finaliseSurveyCheck: false
          });
        },
        onCancel: function onCancel() {
          _this21.setState({
            finaliseSurveyCheck: false
          });
        }
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "orgEmpSurvey.finaliseSurveyWarning"
      }))));
    }
  }]);

  return Component;
}(_react["default"].Component);

exports.Component = Component;
var _default = Component;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/Component.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/Component.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/Component.js");

  __REACT_HOT_LOADER__.register(_reactCollapsible, "_reactCollapsible", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/Component.js");

  __REACT_HOT_LOADER__.register(_dompurify, "_dompurify", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/Component.js");

  __REACT_HOT_LOADER__.register(_reactBootstrapSweetalert, "_reactBootstrapSweetalert", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/Component.js");

  __REACT_HOT_LOADER__.register(_rcSlider, "_rcSlider", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/Component.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/Component.js");

  __REACT_HOT_LOADER__.register(_index2, "_index2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/Component.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/Component.js");

  __REACT_HOT_LOADER__.register(_CircularProgress, "_CircularProgress", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/Component.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/Component.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/Component.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/Component.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/Component.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/Component.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/Component.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/Component.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/Component.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/Component.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/Component.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/Component.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/Component.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/Component.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/Component.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/OrgEmpSurvey/Component.js");
}();

;

/***/ }),
/* 1851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Slider__ = __webpack_require__(1852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Range__ = __webpack_require__(1860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Handle__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createSliderWithTooltip__ = __webpack_require__(1861);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Range", function() { return __WEBPACK_IMPORTED_MODULE_1__Range__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Handle", function() { return __WEBPACK_IMPORTED_MODULE_2__Handle__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createSliderWithTooltip", function() { return __WEBPACK_IMPORTED_MODULE_3__createSliderWithTooltip__["a"]; });





__WEBPACK_IMPORTED_MODULE_0__Slider__["a" /* default */].Range = __WEBPACK_IMPORTED_MODULE_1__Range__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__Slider__["a" /* default */].Handle = __WEBPACK_IMPORTED_MODULE_2__Handle__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__Slider__["a" /* default */].createSliderWithTooltip = __WEBPACK_IMPORTED_MODULE_3__createSliderWithTooltip__["a" /* default */];
/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Slider__["a" /* default */]);


/***/ }),
/* 1852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_warning__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Track__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_createSlider__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(421);





/* eslint-disable react/prop-types */







var Slider = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Slider, _React$Component);

  function Slider(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Slider);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));

    _this.onEnd = function (force) {
      var dragging = _this.state.dragging;

      _this.removeDocumentEvents();
      if (dragging || force) {
        _this.props.onAfterChange(_this.getValue());
      }
      _this.setState({ dragging: false });
    };

    var defaultValue = props.defaultValue !== undefined ? props.defaultValue : props.min;
    var value = props.value !== undefined ? props.value : defaultValue;

    _this.state = {
      value: _this.trimAlignValue(value),
      dragging: false
    };

    __WEBPACK_IMPORTED_MODULE_7_warning___default()(!('minimumTrackStyle' in props), 'minimumTrackStyle will be deprecated, please use trackStyle instead.');
    __WEBPACK_IMPORTED_MODULE_7_warning___default()(!('maximumTrackStyle' in props), 'maximumTrackStyle will be deprecated, please use railStyle instead.');
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Slider, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (!('value' in this.props || 'min' in this.props || 'max' in this.props)) {
        return;
      }
      var _props = this.props,
          value = _props.value,
          onChange = _props.onChange;

      var theValue = value !== undefined ? value : prevState.value;
      var nextValue = this.trimAlignValue(theValue, this.props);
      if (nextValue !== prevState.value) {
        // eslint-disable-next-line
        this.setState({ value: nextValue });
        if (__WEBPACK_IMPORTED_MODULE_10__utils__["i" /* isValueOutOfRange */](theValue, this.props)) {
          onChange(nextValue);
        }
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(state) {
      var props = this.props;
      var isNotControlled = !('value' in props);
      var nextState = state.value > this.props.max ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state, { value: this.props.max }) : state;
      if (isNotControlled) {
        this.setState(nextState);
      }

      var changedValue = nextState.value;
      props.onChange(changedValue);
    }
  }, {
    key: 'onStart',
    value: function onStart(position) {
      this.setState({ dragging: true });
      var props = this.props;
      var prevValue = this.getValue();
      props.onBeforeChange(prevValue);

      var value = this.calcValueByPos(position);
      this.startValue = value;
      this.startPosition = position;

      if (value === prevValue) return;

      this.prevMovedHandleIndex = 0;

      this.onChange({ value: value });
    }
  }, {
    key: 'onMove',
    value: function onMove(e, position) {
      __WEBPACK_IMPORTED_MODULE_10__utils__["j" /* pauseEvent */](e);
      var oldValue = this.state.value;

      var value = this.calcValueByPos(position);
      if (value === oldValue) return;

      this.onChange({ value: value });
    }
  }, {
    key: 'onKeyboard',
    value: function onKeyboard(e) {
      var _props2 = this.props,
          reverse = _props2.reverse,
          vertical = _props2.vertical;

      var valueMutator = __WEBPACK_IMPORTED_MODULE_10__utils__["d" /* getKeyboardValueMutator */](e, vertical, reverse);
      if (valueMutator) {
        __WEBPACK_IMPORTED_MODULE_10__utils__["j" /* pauseEvent */](e);
        var state = this.state;
        var oldValue = state.value;
        var mutatedValue = valueMutator(oldValue, this.props);
        var value = this.trimAlignValue(mutatedValue);
        if (value === oldValue) return;

        this.onChange({ value: value });
        this.props.onAfterChange(value);
        this.onEnd();
      }
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.state.value;
    }
  }, {
    key: 'getLowerBound',
    value: function getLowerBound() {
      return this.props.min;
    }
  }, {
    key: 'getUpperBound',
    value: function getUpperBound() {
      return this.state.value;
    }
  }, {
    key: 'trimAlignValue',
    value: function trimAlignValue(v) {
      var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (v === null) {
        return null;
      }

      var mergedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, nextProps);
      var val = __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* ensureValueInRange */](v, mergedProps);
      return __WEBPACK_IMPORTED_MODULE_10__utils__["b" /* ensureValuePrecision */](val, mergedProps);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          prefixCls = _props3.prefixCls,
          vertical = _props3.vertical,
          included = _props3.included,
          disabled = _props3.disabled,
          minimumTrackStyle = _props3.minimumTrackStyle,
          trackStyle = _props3.trackStyle,
          handleStyle = _props3.handleStyle,
          tabIndex = _props3.tabIndex,
          min = _props3.min,
          max = _props3.max,
          reverse = _props3.reverse,
          handleGenerator = _props3.handle;
      var _state = this.state,
          value = _state.value,
          dragging = _state.dragging;

      var offset = this.calcOffset(value);
      var handle = handleGenerator({
        className: prefixCls + '-handle',
        prefixCls: prefixCls,
        vertical: vertical,
        offset: offset,
        value: value,
        dragging: dragging,
        disabled: disabled,
        min: min,
        max: max,
        reverse: reverse,
        index: 0,
        tabIndex: tabIndex,
        style: handleStyle[0] || handleStyle,
        ref: function ref(h) {
          return _this2.saveHandle(0, h);
        }
      });

      var _trackStyle = trackStyle[0] || trackStyle;
      var track = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_Track__["a" /* default */], {
        className: prefixCls + '-track',
        vertical: vertical,
        included: included,
        offset: 0,
        reverse: reverse,
        length: offset,
        style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, minimumTrackStyle, _trackStyle)
      });

      return { tracks: track, handles: handle };
    }
  }]);

  return Slider;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Slider.propTypes = {
  defaultValue: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  value: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  autoFocus: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  tabIndex: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  reverse: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  min: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  max: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__common_createSlider__["a" /* default */])(Slider));

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getPrototypeOf = __webpack_require__(833);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _getOwnPropertyDescriptor = __webpack_require__(1854);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);

  if (desc === undefined) {
    var parent = (0, _getPrototypeOf2.default)(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1855), __esModule: true };

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1856);
var $Object = __webpack_require__(61).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(149);
var $getOwnPropertyDescriptor = __webpack_require__(383).f;

__webpack_require__(790)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 1857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_warning__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_warning__);







var calcPoints = function calcPoints(vertical, marks, dots, step, min, max) {
  __WEBPACK_IMPORTED_MODULE_5_warning___default()(dots ? step > 0 : true, '`Slider[step]` should be a positive number in order to make Slider[dots] work.');
  var points = Object.keys(marks).map(parseFloat).sort(function (a, b) {
    return a - b;
  });
  if (dots && step) {
    for (var i = min; i <= max; i += step) {
      if (points.indexOf(i) === -1) {
        points.push(i);
      }
    }
  }
  return points;
};

var Steps = function Steps(_ref) {
  var prefixCls = _ref.prefixCls,
      vertical = _ref.vertical,
      reverse = _ref.reverse,
      marks = _ref.marks,
      dots = _ref.dots,
      step = _ref.step,
      included = _ref.included,
      lowerBound = _ref.lowerBound,
      upperBound = _ref.upperBound,
      max = _ref.max,
      min = _ref.min,
      dotStyle = _ref.dotStyle,
      activeDotStyle = _ref.activeDotStyle;

  var range = max - min;
  var elements = calcPoints(vertical, marks, dots, step, min, max).map(function (point) {
    var _classNames;

    var offset = Math.abs(point - min) / range * 100 + '%';

    var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var style = vertical ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, dotStyle, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, reverse ? 'top' : 'bottom', offset)) : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, dotStyle, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, reverse ? 'right' : 'left', offset));
    if (isActived) {
      style = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, style, activeDotStyle);
    }

    var pointClassName = __WEBPACK_IMPORTED_MODULE_4_classnames___default()((_classNames = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-dot', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-dot-active', isActived), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-dot-reverse', reverse), _classNames));

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: pointClassName, style: style, key: point });
  });

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    { className: prefixCls + '-step' },
    elements
  );
};

Steps.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  activeDotStyle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  dotStyle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  min: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  max: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  upperBound: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  lowerBound: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  included: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  dots: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  step: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  marks: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  vertical: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  reverse: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (Steps);

/***/ }),
/* 1858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);






var Marks = function Marks(_ref) {
  var className = _ref.className,
      vertical = _ref.vertical,
      reverse = _ref.reverse,
      marks = _ref.marks,
      included = _ref.included,
      upperBound = _ref.upperBound,
      lowerBound = _ref.lowerBound,
      max = _ref.max,
      min = _ref.min,
      onClickLabel = _ref.onClickLabel;

  var marksKeys = Object.keys(marks);

  var range = max - min;
  var elements = marksKeys.map(parseFloat).sort(function (a, b) {
    return a - b;
  }).map(function (point) {
    var _classNames;

    var markPoint = marks[point];
    var markPointIsObject = typeof markPoint === 'object' && !__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(markPoint);
    var markLabel = markPointIsObject ? markPoint.label : markPoint;
    if (!markLabel && markLabel !== 0) {
      return null;
    }

    var isActive = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var markClassName = __WEBPACK_IMPORTED_MODULE_4_classnames___default()((_classNames = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classNames, className + '-text', true), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classNames, className + '-text-active', isActive), _classNames));

    var bottomStyle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
      marginBottom: '-50%'
    }, reverse ? 'top' : 'bottom', (point - min) / range * 100 + '%');

    var leftStyle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
      transform: 'translateX(-50%)',
      msTransform: 'translateX(-50%)'
    }, reverse ? 'right' : 'left', reverse ? (point - min / 4) / range * 100 + '%' : (point - min) / range * 100 + '%');

    var style = vertical ? bottomStyle : leftStyle;
    var markStyle = markPointIsObject ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, markPoint.style) : style;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'span',
      {
        className: markClassName,
        style: markStyle,
        key: point,
        onMouseDown: function onMouseDown(e) {
          return onClickLabel(e, point);
        },
        onTouchStart: function onTouchStart(e) {
          return onClickLabel(e, point);
        }
      },
      markLabel
    );
  });

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    { className: className },
    elements
  );
};

Marks.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  vertical: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  reverse: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  marks: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  included: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  upperBound: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  lowerBound: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  max: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  min: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  onClickLabel: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (Marks);

/***/ }),
/* 1859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */

var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12, // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33, // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34, // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35, // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36, // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37, // also NUM_WEST
  /**
   * UP
   */
  UP: 38, // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39, // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40, // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45, // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46, // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63, // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91, // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186, // needs localization
  /**
   * DASH
   */
  DASH: 189, // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187, // needs localization
  /**
   * COMMA
   */
  COMMA: 188, // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190, // needs localization
  /**
   * SLASH
   */
  SLASH: 191, // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192, // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222, // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219, // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220, // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221, // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224, // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229
};

/*
 whether text and modified key is entered at the same time.
 */
KeyCode.isTextModifyingKeyEvent = function isTextModifyingKeyEvent(e) {
  var keyCode = e.keyCode;
  if (e.altKey && !e.ctrlKey || e.metaKey ||
  // Function keys don't generate text
  keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
    return false;
  }

  // The following keys are quite harmless, even in combination with
  // CTRL, ALT or SHIFT.
  switch (keyCode) {
    case KeyCode.ALT:
    case KeyCode.CAPS_LOCK:
    case KeyCode.CONTEXT_MENU:
    case KeyCode.CTRL:
    case KeyCode.DOWN:
    case KeyCode.END:
    case KeyCode.ESC:
    case KeyCode.HOME:
    case KeyCode.INSERT:
    case KeyCode.LEFT:
    case KeyCode.MAC_FF_META:
    case KeyCode.META:
    case KeyCode.NUMLOCK:
    case KeyCode.NUM_CENTER:
    case KeyCode.PAGE_DOWN:
    case KeyCode.PAGE_UP:
    case KeyCode.PAUSE:
    case KeyCode.PRINT_SCREEN:
    case KeyCode.RIGHT:
    case KeyCode.SHIFT:
    case KeyCode.UP:
    case KeyCode.WIN_KEY:
    case KeyCode.WIN_KEY_RIGHT:
      return false;
    default:
      return true;
  }
};

/*
 whether character is entered.
 */
KeyCode.isCharacterKey = function isCharacterKey(keyCode) {
  if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
    return true;
  }

  if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
    return true;
  }

  if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
    return true;
  }

  // Safari sends zero key code for non-latin characters.
  if (window.navigation.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
    return true;
  }

  switch (keyCode) {
    case KeyCode.SPACE:
    case KeyCode.QUESTION_MARK:
    case KeyCode.NUM_PLUS:
    case KeyCode.NUM_MINUS:
    case KeyCode.NUM_PERIOD:
    case KeyCode.NUM_DIVISION:
    case KeyCode.SEMICOLON:
    case KeyCode.DASH:
    case KeyCode.EQUALS:
    case KeyCode.COMMA:
    case KeyCode.PERIOD:
    case KeyCode.SLASH:
    case KeyCode.APOSTROPHE:
    case KeyCode.SINGLE_QUOTE:
    case KeyCode.OPEN_SQUARE_BRACKET:
    case KeyCode.BACKSLASH:
    case KeyCode.CLOSE_SQUARE_BRACKET:
      return true;
    default:
      return false;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (KeyCode);

/***/ }),
/* 1860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_lifecycles_compat__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shallowequal__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_Track__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_createSlider__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils__ = __webpack_require__(421);







/* eslint-disable react/prop-types */









var _trimAlignValue = function _trimAlignValue(_ref) {
  var value = _ref.value,
      handle = _ref.handle,
      bounds = _ref.bounds,
      props = _ref.props;
  var allowCross = props.allowCross,
      pushable = props.pushable;

  var thershold = Number(pushable);
  var valInRange = __WEBPACK_IMPORTED_MODULE_14__utils__["a" /* ensureValueInRange */](value, props);
  var valNotConflict = valInRange;
  if (!allowCross && handle != null && bounds !== undefined) {
    if (handle > 0 && valInRange <= bounds[handle - 1] + thershold) {
      valNotConflict = bounds[handle - 1] + thershold;
    }
    if (handle < bounds.length - 1 && valInRange >= bounds[handle + 1] - thershold) {
      valNotConflict = bounds[handle + 1] - thershold;
    }
  }
  return __WEBPACK_IMPORTED_MODULE_14__utils__["b" /* ensureValuePrecision */](valNotConflict, props);
};

var Range = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Range, _React$Component);

  function Range(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Range);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Range.__proto__ || Object.getPrototypeOf(Range)).call(this, props));

    _this.onEnd = function (force) {
      var handle = _this.state.handle;

      _this.removeDocumentEvents();

      if (handle !== null || force) {
        _this.props.onAfterChange(_this.getValue());
      }

      _this.setState({
        handle: null
      });
    };

    var count = props.count,
        min = props.min,
        max = props.max;

    var initialValue = Array.apply(undefined, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(Array(count + 1))).map(function () {
      return min;
    });
    var defaultValue = 'defaultValue' in props ? props.defaultValue : initialValue;
    var value = props.value !== undefined ? props.value : defaultValue;
    var bounds = value.map(function (v, i) {
      return _trimAlignValue({
        value: v,
        handle: i,
        props: props
      });
    });
    var recent = bounds[0] === max ? 0 : bounds.length - 1;

    _this.state = {
      handle: null,
      recent: recent,
      bounds: bounds
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Range, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      if (!('value' in this.props || 'min' in this.props || 'max' in this.props)) {
        return;
      }
      if (this.props.min === prevProps.min && this.props.max === prevProps.max && __WEBPACK_IMPORTED_MODULE_11_shallowequal___default()(this.props.value, prevProps.value)) {
        return;
      }
      var _props = this.props,
          onChange = _props.onChange,
          value = _props.value;

      var currentValue = value || prevState.bounds;
      if (currentValue.some(function (v) {
        return __WEBPACK_IMPORTED_MODULE_14__utils__["i" /* isValueOutOfRange */](v, _this2.props);
      })) {
        var newValues = currentValue.map(function (v) {
          return __WEBPACK_IMPORTED_MODULE_14__utils__["a" /* ensureValueInRange */](v, _this2.props);
        });
        onChange(newValues);
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(state) {
      var props = this.props;
      var isNotControlled = !('value' in props);
      if (isNotControlled) {
        this.setState(state);
      } else {
        var controlledState = {};

        ['handle', 'recent'].forEach(function (item) {
          if (state[item] !== undefined) {
            controlledState[item] = state[item];
          }
        });

        if (Object.keys(controlledState).length) {
          this.setState(controlledState);
        }
      }

      var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.state, state);
      var changedValue = data.bounds;
      props.onChange(changedValue);
    }
  }, {
    key: 'onStart',
    value: function onStart(position) {
      var props = this.props;
      var state = this.state;
      var bounds = this.getValue();
      props.onBeforeChange(bounds);

      var value = this.calcValueByPos(position);
      this.startValue = value;
      this.startPosition = position;

      var closestBound = this.getClosestBound(value);
      this.prevMovedHandleIndex = this.getBoundNeedMoving(value, closestBound);

      this.setState({
        handle: this.prevMovedHandleIndex,
        recent: this.prevMovedHandleIndex
      });

      var prevValue = bounds[this.prevMovedHandleIndex];
      if (value === prevValue) return;

      var nextBounds = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.bounds));
      nextBounds[this.prevMovedHandleIndex] = value;
      this.onChange({ bounds: nextBounds });
    }
  }, {
    key: 'onMove',
    value: function onMove(e, position) {
      __WEBPACK_IMPORTED_MODULE_14__utils__["j" /* pauseEvent */](e);
      var state = this.state;

      var value = this.calcValueByPos(position);
      var oldValue = state.bounds[state.handle];
      if (value === oldValue) return;

      this.moveTo(value);
    }
  }, {
    key: 'onKeyboard',
    value: function onKeyboard(e) {
      var _props2 = this.props,
          reverse = _props2.reverse,
          vertical = _props2.vertical;

      var valueMutator = __WEBPACK_IMPORTED_MODULE_14__utils__["d" /* getKeyboardValueMutator */](e, vertical, reverse);

      if (valueMutator) {
        __WEBPACK_IMPORTED_MODULE_14__utils__["j" /* pauseEvent */](e);
        var state = this.state,
            props = this.props;
        var bounds = state.bounds,
            handle = state.handle;

        var oldValue = bounds[handle === null ? state.recent : handle];
        var mutatedValue = valueMutator(oldValue, props);
        var value = _trimAlignValue({
          value: mutatedValue,
          handle: handle,
          bounds: state.bounds,
          props: props
        });
        if (value === oldValue) return;
        var isFromKeyboardEvent = true;
        this.moveTo(value, isFromKeyboardEvent);
      }
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.state.bounds;
    }
  }, {
    key: 'getClosestBound',
    value: function getClosestBound(value) {
      var bounds = this.state.bounds;

      var closestBound = 0;
      for (var i = 1; i < bounds.length - 1; ++i) {
        if (value >= bounds[i]) {
          closestBound = i;
        }
      }
      if (Math.abs(bounds[closestBound + 1] - value) < Math.abs(bounds[closestBound] - value)) {
        closestBound += 1;
      }
      return closestBound;
    }
  }, {
    key: 'getBoundNeedMoving',
    value: function getBoundNeedMoving(value, closestBound) {
      var _state = this.state,
          bounds = _state.bounds,
          recent = _state.recent;

      var boundNeedMoving = closestBound;
      var isAtTheSamePoint = bounds[closestBound + 1] === bounds[closestBound];

      if (isAtTheSamePoint && bounds[recent] === bounds[closestBound]) {
        boundNeedMoving = recent;
      }

      if (isAtTheSamePoint && value !== bounds[closestBound + 1]) {
        boundNeedMoving = value < bounds[closestBound + 1] ? closestBound : closestBound + 1;
      }
      return boundNeedMoving;
    }
  }, {
    key: 'getLowerBound',
    value: function getLowerBound() {
      return this.state.bounds[0];
    }
  }, {
    key: 'getUpperBound',
    value: function getUpperBound() {
      var bounds = this.state.bounds;

      return bounds[bounds.length - 1];
    }

    /**
     * Returns an array of possible slider points, taking into account both
     * `marks` and `step`. The result is cached.
     */

  }, {
    key: 'getPoints',
    value: function getPoints() {
      var _props3 = this.props,
          marks = _props3.marks,
          step = _props3.step,
          min = _props3.min,
          max = _props3.max;

      var cache = this._getPointsCache;
      if (!cache || cache.marks !== marks || cache.step !== step) {
        var pointsObject = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, marks);
        if (step !== null) {
          for (var point = min; point <= max; point += step) {
            pointsObject[point] = point;
          }
        }
        var points = Object.keys(pointsObject).map(parseFloat);
        points.sort(function (a, b) {
          return a - b;
        });
        this._getPointsCache = { marks: marks, step: step, points: points };
      }
      return this._getPointsCache.points;
    }
  }, {
    key: 'moveTo',
    value: function moveTo(value, isFromKeyboardEvent) {
      var _this3 = this;

      var state = this.state,
          props = this.props;

      var nextBounds = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.bounds));
      var handle = state.handle === null ? state.recent : state.handle;
      nextBounds[handle] = value;
      var nextHandle = handle;
      if (props.pushable !== false) {
        this.pushSurroundingHandles(nextBounds, nextHandle);
      } else if (props.allowCross) {
        nextBounds.sort(function (a, b) {
          return a - b;
        });
        nextHandle = nextBounds.indexOf(value);
      }
      this.onChange({
        recent: nextHandle,
        handle: nextHandle,
        bounds: nextBounds
      });
      if (isFromKeyboardEvent) {
        // known problem: because setState is async,
        // so trigger focus will invoke handler's onEnd and another handler's onStart too early,
        // cause onBeforeChange and onAfterChange receive wrong value.
        // here use setState callback to hack，but not elegant
        this.props.onAfterChange(nextBounds);
        this.setState({}, function () {
          _this3.handlesRefs[nextHandle].focus();
        });
        this.onEnd();
      }
    }
  }, {
    key: 'pushSurroundingHandles',
    value: function pushSurroundingHandles(bounds, handle) {
      var value = bounds[handle];
      var threshold = this.props.pushable;

      threshold = Number(threshold);

      var direction = 0;
      if (bounds[handle + 1] - value < threshold) {
        direction = +1; // push to right
      }
      if (value - bounds[handle - 1] < threshold) {
        direction = -1; // push to left
      }

      if (direction === 0) {
        return;
      }

      var nextHandle = handle + direction;
      var diffToNext = direction * (bounds[nextHandle] - value);
      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
        // revert to original value if pushing is impossible
        bounds[handle] = bounds[nextHandle] - direction * threshold;
      }
    }
  }, {
    key: 'pushHandle',
    value: function pushHandle(bounds, handle, direction, amount) {
      var originalValue = bounds[handle];
      var currentValue = bounds[handle];
      while (direction * (currentValue - originalValue) < amount) {
        if (!this.pushHandleOnePoint(bounds, handle, direction)) {
          // can't push handle enough to create the needed `amount` gap, so we
          // revert its position to the original value
          bounds[handle] = originalValue;
          return false;
        }
        currentValue = bounds[handle];
      }
      // the handle was pushed enough to create the needed `amount` gap
      return true;
    }
  }, {
    key: 'pushHandleOnePoint',
    value: function pushHandleOnePoint(bounds, handle, direction) {
      var points = this.getPoints();
      var pointIndex = points.indexOf(bounds[handle]);
      var nextPointIndex = pointIndex + direction;
      if (nextPointIndex >= points.length || nextPointIndex < 0) {
        // reached the minimum or maximum available point, can't push anymore
        return false;
      }
      var nextHandle = handle + direction;
      var nextValue = points[nextPointIndex];
      var threshold = this.props.pushable;

      var diffToNext = direction * (bounds[nextHandle] - nextValue);
      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
        // couldn't push next handle, so we won't push this one either
        return false;
      }
      // push the handle
      bounds[handle] = nextValue;
      return true;
    }
  }, {
    key: 'trimAlignValue',
    value: function trimAlignValue(value) {
      var _state2 = this.state,
          handle = _state2.handle,
          bounds = _state2.bounds;

      return _trimAlignValue({
        value: value,
        handle: handle,
        bounds: bounds,
        props: this.props
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _state3 = this.state,
          handle = _state3.handle,
          bounds = _state3.bounds;
      var _props4 = this.props,
          prefixCls = _props4.prefixCls,
          vertical = _props4.vertical,
          included = _props4.included,
          disabled = _props4.disabled,
          min = _props4.min,
          max = _props4.max,
          reverse = _props4.reverse,
          handleGenerator = _props4.handle,
          trackStyle = _props4.trackStyle,
          handleStyle = _props4.handleStyle,
          tabIndex = _props4.tabIndex;


      var offsets = bounds.map(function (v) {
        return _this4.calcOffset(v);
      });

      var handleClassName = prefixCls + '-handle';
      var handles = bounds.map(function (v, i) {
        var _classNames;

        var _tabIndex = tabIndex[i] || 0;
        if (disabled || tabIndex[i] === null) {
          _tabIndex = null;
        }
        return handleGenerator({
          className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()((_classNames = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, handleClassName, true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, handleClassName + '-' + (i + 1), true), _classNames)),
          prefixCls: prefixCls,
          vertical: vertical,
          offset: offsets[i],
          value: v,
          dragging: handle === i,
          index: i,
          tabIndex: _tabIndex,
          min: min,
          max: max,
          reverse: reverse,
          disabled: disabled,
          style: handleStyle[i],
          ref: function ref(h) {
            return _this4.saveHandle(i, h);
          }
        });
      });

      var tracks = bounds.slice(0, -1).map(function (_, index) {
        var _classNames2;

        var i = index + 1;
        var trackClassName = __WEBPACK_IMPORTED_MODULE_9_classnames___default()((_classNames2 = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames2, prefixCls + '-track', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames2, prefixCls + '-track-' + i, true), _classNames2));
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__common_Track__["a" /* default */], {
          className: trackClassName,
          vertical: vertical,
          reverse: reverse,
          included: included,
          offset: offsets[i - 1],
          length: offsets[i] - offsets[i - 1],
          style: trackStyle[index],
          key: i
        });
      });

      return { tracks: tracks, handles: handles };
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, state) {
      if ('value' in props || 'min' in props || 'max' in props) {
        var value = props.value || state.bounds;
        var nextBounds = value.map(function (v, i) {
          return _trimAlignValue({
            value: v,
            handle: i,
            bounds: state.bounds,
            props: props
          });
        });
        if (nextBounds.length === state.bounds.length && nextBounds.every(function (v, i) {
          return v === state.bounds[i];
        })) {
          return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state, {
          bounds: nextBounds
        });
      }
      return null;
    }
  }]);

  return Range;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Range.displayName = 'Range';
Range.propTypes = {
  autoFocus: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  defaultValue: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number),
  value: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number),
  count: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  pushable: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number]),
  allowCross: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  reverse: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  tabIndex: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number),
  min: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  max: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number
};
Range.defaultProps = {
  count: 1,
  allowCross: true,
  pushable: false,
  tabIndex: []
};


Object(__WEBPACK_IMPORTED_MODULE_10_react_lifecycles_compat__["polyfill"])(Range);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13__common_createSlider__["a" /* default */])(Range));

/***/ }),
/* 1861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSliderWithTooltip;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_tooltip__ = __webpack_require__(1862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Handle__ = __webpack_require__(420);












function createSliderWithTooltip(Component) {
  var _class, _temp2;

  return _temp2 = _class = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ComponentWrapper, _React$Component);

    function ComponentWrapper() {
      var _ref;

      var _temp, _this, _ret;

      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ComponentWrapper);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ComponentWrapper.__proto__ || Object.getPrototypeOf(ComponentWrapper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        visibles: {}
      }, _this.handleTooltipVisibleChange = function (index, visible) {
        _this.setState(function (prevState) {
          return {
            visibles: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, prevState.visibles, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, index, visible))
          };
        });
      }, _this.handleWithTooltip = function (_ref2) {
        var value = _ref2.value,
            dragging = _ref2.dragging,
            index = _ref2.index,
            disabled = _ref2.disabled,
            restProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref2, ['value', 'dragging', 'index', 'disabled']);

        var _this$props = _this.props,
            tipFormatter = _this$props.tipFormatter,
            tipProps = _this$props.tipProps,
            handleStyle = _this$props.handleStyle;

        var _tipProps$prefixCls = tipProps.prefixCls,
            prefixCls = _tipProps$prefixCls === undefined ? 'rc-slider-tooltip' : _tipProps$prefixCls,
            _tipProps$overlay = tipProps.overlay,
            overlay = _tipProps$overlay === undefined ? tipFormatter(value) : _tipProps$overlay,
            _tipProps$placement = tipProps.placement,
            placement = _tipProps$placement === undefined ? 'top' : _tipProps$placement,
            _tipProps$visible = tipProps.visible,
            visible = _tipProps$visible === undefined ? false : _tipProps$visible,
            restTooltipProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(tipProps, ['prefixCls', 'overlay', 'placement', 'visible']);

        var handleStyleWithIndex = void 0;
        if (Array.isArray(handleStyle)) {
          handleStyleWithIndex = handleStyle[index] || handleStyle[0];
        } else {
          handleStyleWithIndex = handleStyle;
        }

        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_rc_tooltip__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, restTooltipProps, {
            prefixCls: prefixCls,
            overlay: overlay,
            placement: placement,
            visible: !disabled && (_this.state.visibles[index] || dragging) || visible,
            key: index
          }),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Handle__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, restProps, {
            style: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, handleStyleWithIndex),
            value: value,
            onMouseEnter: function onMouseEnter() {
              return _this.handleTooltipVisibleChange(index, true);
            },
            onMouseLeave: function onMouseLeave() {
              return _this.handleTooltipVisibleChange(index, false);
            }
          }))
        );
      }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ComponentWrapper, [{
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.props, { handle: this.handleWithTooltip }));
      }
    }]);

    return ComponentWrapper;
  }(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component), _class.propTypes = {
    tipFormatter: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    handleStyle: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object)]),
    tipProps: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object
  }, _class.defaultProps = {
    tipFormatter: function tipFormatter(value) {
      return value;
    },

    handleStyle: [{}],
    tipProps: {}
  }, _temp2;
}

/***/ }),
/* 1862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tooltip__ = __webpack_require__(1863);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Tooltip__["a" /* default */]);

/***/ }),
/* 1863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_trigger__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__placements__ = __webpack_require__(1864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Content__ = __webpack_require__(1865);











var Tooltip = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Tooltip, _Component);

  function Tooltip() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getPopupElement = function () {
      var _this$props = _this.props,
          arrowContent = _this$props.arrowContent,
          overlay = _this$props.overlay,
          prefixCls = _this$props.prefixCls,
          id = _this$props.id;

      return [__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: prefixCls + '-arrow', key: 'arrow' },
        arrowContent
      ), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Content__["a" /* default */], {
        key: 'content',
        trigger: _this.trigger,
        prefixCls: prefixCls,
        id: id,
        overlay: overlay
      })];
    }, _this.saveTrigger = function (node) {
      _this.trigger = node;
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Tooltip.prototype.getPopupDomNode = function getPopupDomNode() {
    return this.trigger.getPopupDomNode();
  };

  Tooltip.prototype.render = function render() {
    var _props = this.props,
        overlayClassName = _props.overlayClassName,
        trigger = _props.trigger,
        mouseEnterDelay = _props.mouseEnterDelay,
        mouseLeaveDelay = _props.mouseLeaveDelay,
        overlayStyle = _props.overlayStyle,
        prefixCls = _props.prefixCls,
        children = _props.children,
        onVisibleChange = _props.onVisibleChange,
        afterVisibleChange = _props.afterVisibleChange,
        transitionName = _props.transitionName,
        animation = _props.animation,
        placement = _props.placement,
        align = _props.align,
        destroyTooltipOnHide = _props.destroyTooltipOnHide,
        defaultVisible = _props.defaultVisible,
        getTooltipContainer = _props.getTooltipContainer,
        restProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['overlayClassName', 'trigger', 'mouseEnterDelay', 'mouseLeaveDelay', 'overlayStyle', 'prefixCls', 'children', 'onVisibleChange', 'afterVisibleChange', 'transitionName', 'animation', 'placement', 'align', 'destroyTooltipOnHide', 'defaultVisible', 'getTooltipContainer']);

    var extraProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, restProps);
    if ('visible' in this.props) {
      extraProps.popupVisible = this.props.visible;
    }
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_rc_trigger__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        popupClassName: overlayClassName,
        ref: this.saveTrigger,
        prefixCls: prefixCls,
        popup: this.getPopupElement,
        action: trigger,
        builtinPlacements: __WEBPACK_IMPORTED_MODULE_8__placements__["a" /* placements */],
        popupPlacement: placement,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onPopupVisibleChange: onVisibleChange,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        defaultPopupVisible: defaultVisible,
        destroyPopupOnHide: destroyTooltipOnHide,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: overlayStyle,
        mouseEnterDelay: mouseEnterDelay
      }, extraProps),
      children
    );
  };

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Tooltip.propTypes = {
  trigger: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  defaultVisible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  visible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  placement: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  transitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object]),
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  onVisibleChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  afterVisibleChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  overlay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]).isRequired,
  overlayStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  overlayClassName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  getTooltipContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  destroyTooltipOnHide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  align: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  arrowContent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
Tooltip.defaultProps = {
  prefixCls: 'rc-tooltip',
  mouseEnterDelay: 0,
  destroyTooltipOnHide: false,
  mouseLeaveDelay: 0.1,
  align: {},
  placement: 'right',
  trigger: ['hover'],
  arrowContent: null
};


/* harmony default export */ __webpack_exports__["a"] = (Tooltip);

/***/ }),
/* 1864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return placements; });
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var targetOffset = [0, 0];

var placements = {
  left: {
    points: ['cr', 'cl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  right: {
    points: ['cl', 'cr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  top: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottom: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  rightBottom: {
    points: ['bl', 'br'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  leftBottom: {
    points: ['br', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (placements);

/***/ }),
/* 1865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);






var Content = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Content, _React$Component);

  function Content() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Content);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Content.prototype.componentDidUpdate = function componentDidUpdate() {
    var trigger = this.props.trigger;

    if (trigger) {
      trigger.forcePopupAlign();
    }
  };

  Content.prototype.render = function render() {
    var _props = this.props,
        overlay = _props.overlay,
        prefixCls = _props.prefixCls,
        id = _props.id;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: prefixCls + '-inner', id: id, role: 'tooltip' },
      typeof overlay === 'function' ? overlay() : overlay
    );
  };

  return Content;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Content.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  overlay: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]).isRequired,
  id: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  trigger: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (Content);

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var SurveyAnswerActivities = function SurveyAnswerActivities(_ref) {
  var recentData = _ref.recentData;
  var image = recentData.image,
      title = recentData.title,
      color = recentData.color,
      borderColor = recentData.borderColor,
      clickEvent = recentData.clickEvent;
  return _react["default"].createElement("div", {
    className: "media survey-list-line",
    onClick: clickEvent
  }, _react["default"].createElement("div", {
    className: "border-".concat(borderColor, " bg-white icon-btn user-avatar size-40 z-index-20 align-item-self mr-3")
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-".concat(image, " text-").concat(color, " zmdi-hc-fw")
  })), _react["default"].createElement("div", {
    className: "media-body"
  }, _react["default"].createElement("h4", null, title)));
};

var _default = SurveyAnswerActivities;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SurveyAnswerActivities, "SurveyAnswerActivities", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/Common/SurveyAnswerActivities/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/Common/SurveyAnswerActivities/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/Common/SurveyAnswerActivities/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/Common/SurveyAnswerActivities/index.js");

  __REACT_HOT_LOADER__.register(SurveyAnswerActivities, "SurveyAnswerActivities", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/Common/SurveyAnswerActivities/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/Common/SurveyAnswerActivities/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/Common/SurveyAnswerActivities/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/dashboard/Common/SurveyAnswerActivities/index.js");
}();

;

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1868);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(65)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js!./index.css", function() {
			var newContent = require("!!../../css-loader/index.js!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(64)(false);
// imports


// module
exports.push([module.i, ".rc-slider{position:relative;height:14px;padding:5px 0;width:100%;border-radius:6px;-ms-touch-action:none;touch-action:none}.rc-slider,.rc-slider *{box-sizing:border-box;-webkit-tap-highlight-color:rgba(0,0,0,0)}.rc-slider-rail{width:100%;background-color:#e9e9e9}.rc-slider-rail,.rc-slider-track{position:absolute;height:4px;border-radius:6px}.rc-slider-track{left:0;background-color:#abe2fb}.rc-slider-handle{position:absolute;width:14px;height:14px;cursor:pointer;cursor:-webkit-grab;margin-top:-5px;cursor:grab;border-radius:50%;border:2px solid #96dbfa;background-color:#fff;-ms-touch-action:pan-x;touch-action:pan-x}.rc-slider-handle:focus{border-color:#57c5f7;box-shadow:0 0 0 5px #96dbfa;outline:none}.rc-slider-handle-click-focused:focus{border-color:#96dbfa;box-shadow:unset}.rc-slider-handle:hover{border-color:#57c5f7}.rc-slider-handle:active{border-color:#57c5f7;box-shadow:0 0 5px #57c5f7;cursor:-webkit-grabbing;cursor:grabbing}.rc-slider-mark{position:absolute;top:18px;left:0;width:100%;font-size:12px}.rc-slider-mark-text{position:absolute;display:inline-block;vertical-align:middle;text-align:center;cursor:pointer;color:#999}.rc-slider-mark-text-active{color:#666}.rc-slider-step{position:absolute;width:100%;height:4px;background:transparent}.rc-slider-dot{position:absolute;bottom:-2px;margin-left:-4px;width:8px;height:8px;border:2px solid #e9e9e9;background-color:#fff;cursor:pointer;border-radius:50%;vertical-align:middle}.rc-slider-dot-active{border-color:#96dbfa}.rc-slider-dot-reverse{margin-left:0;margin-right:-4px}.rc-slider-disabled{background-color:#e9e9e9}.rc-slider-disabled .rc-slider-track{background-color:#ccc}.rc-slider-disabled .rc-slider-dot,.rc-slider-disabled .rc-slider-handle{border-color:#ccc;box-shadow:none;background-color:#fff;cursor:not-allowed}.rc-slider-disabled .rc-slider-dot,.rc-slider-disabled .rc-slider-mark-text{cursor:not-allowed!important}.rc-slider-vertical{width:14px;height:100%;padding:0 5px}.rc-slider-vertical .rc-slider-rail{height:100%;width:4px}.rc-slider-vertical .rc-slider-track{left:5px;bottom:0;width:4px}.rc-slider-vertical .rc-slider-handle{margin-left:-5px;-ms-touch-action:pan-y;touch-action:pan-y}.rc-slider-vertical .rc-slider-mark{top:0;left:18px;height:100%}.rc-slider-vertical .rc-slider-step{height:100%;width:4px}.rc-slider-vertical .rc-slider-dot{left:2px;margin-bottom:-4px}.rc-slider-vertical .rc-slider-dot:first-child,.rc-slider-vertical .rc-slider-dot:last-child{margin-bottom:-4px}.rc-slider-tooltip-zoom-down-appear,.rc-slider-tooltip-zoom-down-enter,.rc-slider-tooltip-zoom-down-leave{animation-duration:.3s;animation-fill-mode:both;display:block!important;animation-play-state:paused}.rc-slider-tooltip-zoom-down-appear.rc-slider-tooltip-zoom-down-appear-active,.rc-slider-tooltip-zoom-down-enter.rc-slider-tooltip-zoom-down-enter-active{animation-name:rcSliderTooltipZoomDownIn;animation-play-state:running}.rc-slider-tooltip-zoom-down-leave.rc-slider-tooltip-zoom-down-leave-active{animation-name:rcSliderTooltipZoomDownOut;animation-play-state:running}.rc-slider-tooltip-zoom-down-appear,.rc-slider-tooltip-zoom-down-enter{transform:scale(0);animation-timing-function:cubic-bezier(.23,1,.32,1)}.rc-slider-tooltip-zoom-down-leave{animation-timing-function:cubic-bezier(.755,.05,.855,.06)}@keyframes rcSliderTooltipZoomDownIn{0%{opacity:0;transform-origin:50% 100%;transform:scale(0)}to{transform-origin:50% 100%;transform:scale(1)}}@keyframes rcSliderTooltipZoomDownOut{0%{transform-origin:50% 100%;transform:scale(1)}to{opacity:0;transform-origin:50% 100%;transform:scale(0)}}.rc-slider-tooltip{position:absolute;left:-9999px;top:-9999px;visibility:visible}.rc-slider-tooltip,.rc-slider-tooltip *{box-sizing:border-box;-webkit-tap-highlight-color:rgba(0,0,0,0)}.rc-slider-tooltip-hidden{display:none}.rc-slider-tooltip-placement-top{padding:4px 0 8px}.rc-slider-tooltip-inner{padding:6px 2px;min-width:24px;height:24px;font-size:12px;line-height:1;color:#fff;text-align:center;text-decoration:none;background-color:#6c6c6c;border-radius:6px;box-shadow:0 0 4px #d9d9d9}.rc-slider-tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.rc-slider-tooltip-placement-top .rc-slider-tooltip-arrow{bottom:4px;left:50%;margin-left:-4px;border-width:4px 4px 0;border-top-color:#6c6c6c}", ""]);

// exports


/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.mapStateToProps = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _rcDrawer = _interopRequireDefault(__webpack_require__(31));

var _reactNotifications = __webpack_require__(30);

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _SurveyGroupList = _interopRequireDefault(__webpack_require__(1870));

var _index = _interopRequireDefault(__webpack_require__(66));

var _AddSurveyGroup = _interopRequireDefault(__webpack_require__(812));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _CircularProgress = _interopRequireDefault(__webpack_require__(24));

var _CustomScrollbars = _interopRequireDefault(__webpack_require__(27));

var _SurveyGroup = __webpack_require__(177);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var filterOptions = [{
  id: 1,
  name: 'All Survey Groups',
  icon: 'zmdi-menu'
}, {
  id: 2,
  name: 'Frequently Accessed',
  icon: 'zmdi-time-restore'
}, {
  id: 3,
  name: 'Starred Survey Groups',
  icon: 'zmdi-star'
}];

var SurveyGroup =
/*#__PURE__*/
function (_Component) {
  _inherits(SurveyGroup, _Component);

  _createClass(SurveyGroup, [{
    key: "__surveyGroupSideBar__REACT_HOT_LOADER__",
    value: function __surveyGroupSideBar__REACT_HOT_LOADER__() {
      var _this2 = this;

      return _react["default"].createElement("div", {
        className: "module-side"
      }, _react["default"].createElement("div", {
        className: "module-side-header"
      }, _react["default"].createElement("div", {
        className: "module-logo"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-city-alt mr-4"
      }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.surveyGroup"
      })))), _react["default"].createElement("div", {
        className: "module-side-content"
      }, _react["default"].createElement(_CustomScrollbars["default"], {
        className: "module-side-scroll scrollbar",
        style: {
          height: this.props.width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)'
        }
      }, _react["default"].createElement("div", {
        className: "module-add-task"
      }, _react["default"].createElement(_reactstrap.Button, {
        className: "btn-block jr-btn",
        color: "primary",
        onClick: this.onAddSurveyGroup
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-accounts-add zmdi-hc-fw"
      }), _react["default"].createElement("span", null, "Add New SurveyGroup"))), _react["default"].createElement("div", {
        className: "module-side-nav"
      }, _react["default"].createElement("ul", {
        className: "module-nav"
      }, filterOptions.map(function (option) {
        return _react["default"].createElement("li", {
          key: option.id,
          className: "nav-item"
        }, _react["default"].createElement("a", {
          href: "javascript:void(0)",
          className: option.id === _this2.props.selectedSectionId ? 'active' : '',
          onClick: _this2.onFilterSurveyGroupOptionSelect.bind(_this2, option)
        }, _react["default"].createElement("i", {
          className: "zmdi ".concat(option.icon)
        }), _react["default"].createElement("span", null, option.name)));
      }))))));
    }
  }, {
    key: "__addFavouriteSurveyGroup__REACT_HOT_LOADER__",
    value: function __addFavouriteSurveyGroup__REACT_HOT_LOADER__(data) {
      this.props.addFavouriteSurveyGroup(data);
    }
  }, {
    key: "__onSurveyGroupSelect__REACT_HOT_LOADER__",
    value: function __onSurveyGroupSelect__REACT_HOT_LOADER__(data) {
      this.props.onSurveyGroupSelect(data);
    }
  }, {
    key: "__onSurveyGroupQuestions__REACT_HOT_LOADER__",
    value: function __onSurveyGroupQuestions__REACT_HOT_LOADER__(data) {
      this.props.onSurveyGroupQuestions(data);
    }
  }, {
    key: "__onAddSurveyGroup__REACT_HOT_LOADER__",
    value: function __onAddSurveyGroup__REACT_HOT_LOADER__() {
      this.props.onAddSurveyGroup();
    }
  }, {
    key: "__onSurveyGroupClose__REACT_HOT_LOADER__",
    value: function __onSurveyGroupClose__REACT_HOT_LOADER__() {
      this.props.onSurveyGroupClose();
    }
  }, {
    key: "__onFilterSurveyGroupOptionSelect__REACT_HOT_LOADER__",
    value: function __onFilterSurveyGroupOptionSelect__REACT_HOT_LOADER__(option) {
      this.props.onFilterSurveyGroupOptionSelect(option);
    }
  }, {
    key: "__onSaveSurveyGroup__REACT_HOT_LOADER__",
    value: function __onSaveSurveyGroup__REACT_HOT_LOADER__(data) {
      this.props.onSaveSurveyGroup(data);
    }
  }, {
    key: "__onDeleteSurveyGroup__REACT_HOT_LOADER__",
    value: function __onDeleteSurveyGroup__REACT_HOT_LOADER__(data) {
      this.props.onDeleteSurveyGroup(data);
    }
  }, {
    key: "__onDeleteSelectedSurveyGroup__REACT_HOT_LOADER__",
    value: function __onDeleteSelectedSurveyGroup__REACT_HOT_LOADER__() {
      this.props.onDeleteSelectedSurveyGroup();
    }
  }, {
    key: "__filterSurveyGroup__REACT_HOT_LOADER__",
    value: function __filterSurveyGroup__REACT_HOT_LOADER__(surveyGroupName) {
      if (surveyGroupName === '') {
        this.onFilterSurveyGroupOptionSelect(this.props.filterOption);
      } else {
        this.props.filterSurveyGroup(surveyGroupName);
      }
    }
  }, {
    key: "__handleSurveyGroupRequestClose__REACT_HOT_LOADER__",
    value: function __handleSurveyGroupRequestClose__REACT_HOT_LOADER__() {
      this.props.handleSurveyGroupRequestClose();
    }
  }, {
    key: "__getAllSurveyGroup__REACT_HOT_LOADER__",
    value: function __getAllSurveyGroup__REACT_HOT_LOADER__() {
      this.props.getAllSurveyGroup();
    }
  }, {
    key: "__getUnselectedAllSurveyGroup__REACT_HOT_LOADER__",
    value: function __getUnselectedAllSurveyGroup__REACT_HOT_LOADER__() {
      this.props.getUnselectedAllSurveyGroup();
    }
  }, {
    key: "__onAllSurveyGroupSelect__REACT_HOT_LOADER__",
    value: function __onAllSurveyGroupSelect__REACT_HOT_LOADER__() {
      var selectAll = this.props.selectedSurveyGroups < this.props.surveyGroupList.length;

      if (selectAll) {
        this.props.getAllSurveyGroup();
      } else {
        this.props.getUnselectedAllSurveyGroup();
      }
    }
  }, {
    key: "__onToggleSurveyGroupDrawer__REACT_HOT_LOADER__",
    value: function __onToggleSurveyGroupDrawer__REACT_HOT_LOADER__() {
      this.props.onToggleSurveyGroupDrawer();
    }
  }, {
    key: "__showSurveyGroupLoader__REACT_HOT_LOADER__",
    value: function __showSurveyGroupLoader__REACT_HOT_LOADER__() {
      this.props.showSurveyGroupLoader();
    }
  }]);

  function SurveyGroup() {
    var _this;

    _classCallCheck(this, SurveyGroup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SurveyGroup).call(this));

    _defineProperty(_assertThisInitialized(_this), "surveyGroupSideBar", function () {
      var _this3;

      return (_this3 = _this).__surveyGroupSideBar__REACT_HOT_LOADER__.apply(_this3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "addFavouriteSurveyGroup", function () {
      var _this4;

      return (_this4 = _this).__addFavouriteSurveyGroup__REACT_HOT_LOADER__.apply(_this4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onSurveyGroupSelect", function () {
      var _this5;

      return (_this5 = _this).__onSurveyGroupSelect__REACT_HOT_LOADER__.apply(_this5, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onSurveyGroupQuestions", function () {
      var _this6;

      return (_this6 = _this).__onSurveyGroupQuestions__REACT_HOT_LOADER__.apply(_this6, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onAddSurveyGroup", function () {
      var _this7;

      return (_this7 = _this).__onAddSurveyGroup__REACT_HOT_LOADER__.apply(_this7, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onSurveyGroupClose", function () {
      var _this8;

      return (_this8 = _this).__onSurveyGroupClose__REACT_HOT_LOADER__.apply(_this8, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onFilterSurveyGroupOptionSelect", function () {
      var _this9;

      return (_this9 = _this).__onFilterSurveyGroupOptionSelect__REACT_HOT_LOADER__.apply(_this9, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onSaveSurveyGroup", function () {
      var _this10;

      return (_this10 = _this).__onSaveSurveyGroup__REACT_HOT_LOADER__.apply(_this10, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onDeleteSurveyGroup", function () {
      var _this11;

      return (_this11 = _this).__onDeleteSurveyGroup__REACT_HOT_LOADER__.apply(_this11, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onDeleteSelectedSurveyGroup", function () {
      var _this12;

      return (_this12 = _this).__onDeleteSelectedSurveyGroup__REACT_HOT_LOADER__.apply(_this12, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "filterSurveyGroup", function () {
      var _this13;

      return (_this13 = _this).__filterSurveyGroup__REACT_HOT_LOADER__.apply(_this13, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "handleSurveyGroupRequestClose", function () {
      var _this14;

      return (_this14 = _this).__handleSurveyGroupRequestClose__REACT_HOT_LOADER__.apply(_this14, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "getAllSurveyGroup", function () {
      var _this15;

      return (_this15 = _this).__getAllSurveyGroup__REACT_HOT_LOADER__.apply(_this15, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "getUnselectedAllSurveyGroup", function () {
      var _this16;

      return (_this16 = _this).__getUnselectedAllSurveyGroup__REACT_HOT_LOADER__.apply(_this16, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onAllSurveyGroupSelect", function () {
      var _this17;

      return (_this17 = _this).__onAllSurveyGroupSelect__REACT_HOT_LOADER__.apply(_this17, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onToggleSurveyGroupDrawer", function () {
      var _this18;

      return (_this18 = _this).__onToggleSurveyGroupDrawer__REACT_HOT_LOADER__.apply(_this18, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "showSurveyGroupLoader", function () {
      var _this19;

      return (_this19 = _this).__showSurveyGroupLoader__REACT_HOT_LOADER__.apply(_this19, arguments);
    });

    return _this;
  }

  _createClass(SurveyGroup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.showSurveyGroupLoader();
      this.props.fetchSurveyGroups();
    }
  }, {
    key: "updateSearchSurveyGroup",
    value: function updateSearchSurveyGroup(evt) {
      this.props.updateSearchSurveyGroup(evt.target.value);
      this.props.filterSurveyGroup(evt.target.value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          surveyGroup = _this$props.surveyGroup,
          surveyGroupList = _this$props.surveyGroupList,
          addSurveyGroupState = _this$props.addSurveyGroupState,
          selectedSurveyGroups = _this$props.selectedSurveyGroups,
          alertMessage = _this$props.alertMessage,
          showMessage = _this$props.showMessage,
          drawerState = _this$props.drawerState,
          noContentFoundMessage = _this$props.noContentFoundMessage,
          loader = _this$props.loader;
      return _react["default"].createElement("div", {
        className: "app-wrapper"
      }, _react["default"].createElement("div", {
        className: "app-module animated slideInUpTiny animation-duration-3"
      }, _react["default"].createElement("div", {
        className: "d-block d-xl-none"
      }, _react["default"].createElement(_rcDrawer["default"], {
        touch: true,
        transitions: true,
        enableDragHandle: true,
        open: drawerState,
        onOpenChange: this.onToggleSurveyGroupDrawer.bind(this),
        sidebar: this.surveyGroupSideBar(surveyGroup)
      })), _react["default"].createElement("div", {
        className: "app-module-sidenav d-none d-xl-flex"
      }, this.surveyGroupSideBar(surveyGroup)), _react["default"].createElement("div", {
        className: "module-box"
      }, _react["default"].createElement("div", {
        className: "module-box-header"
      }, _react["default"].createElement("span", {
        className: "icon-btn drawer-btn d-flex d-xl-none",
        onClick: this.onToggleSurveyGroupDrawer.bind(this)
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-menu"
      })), _react["default"].createElement(_index["default"], {
        placeholder: "Search Survey Group",
        notification: false,
        apps: false,
        user: this.props.surveyGroup,
        onChange: this.updateSearchSurveyGroup.bind(this),
        value: this.props.searchSurveyGroup
      })), _react["default"].createElement("div", {
        className: "module-box-content"
      }, _react["default"].createElement("div", {
        className: "module-box-topbar align-items-center"
      }, _react["default"].createElement("div", {
        className: "form-control-checkbox d-flex"
      }, _react["default"].createElement("div", {
        className: "form-checkbox"
      }, _react["default"].createElement("input", {
        type: "checkbox",
        checked: selectedSurveyGroups > 0,
        onChange: this.onAllSurveyGroupSelect.bind(this)
      }), _react["default"].createElement("span", {
        className: "check"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-check zmdi-hc-lg"
      })))), selectedSurveyGroups > 0 && _react["default"].createElement("span", {
        className: "icon-btn",
        onClick: this.onDeleteSelectedSurveyGroup.bind(this)
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-delete"
      }))), _react["default"].createElement(_CustomScrollbars["default"], {
        className: "module-list-scroll scrollbar",
        style: {
          height: this.props.width >= 1200 ? 'calc(100vh - 265px)' : 'calc(100vh - 245px)'
        }
      }, loader ? _react["default"].createElement("div", {
        className: "loader-view-block h-100"
      }, _react["default"].createElement("div", {
        className: "loader-view"
      }, _react["default"].createElement(_CircularProgress["default"], null))) : surveyGroupList && surveyGroupList.length > 0 ? _react["default"].createElement(_SurveyGroupList["default"], {
        data: surveyGroupList,
        addFavouriteSurveyGroup: this.addFavouriteSurveyGroup.bind(this),
        onSurveyGroupSelect: this.onSurveyGroupSelect.bind(this),
        onDeleteSurveyGroup: this.onDeleteSurveyGroup.bind(this),
        onSaveSurveyGroup: this.onSaveSurveyGroup.bind(this),
        showSurveyGroupLoader: this.showSurveyGroupLoader.bind(this),
        onSurveyGroupQuestions: this.onSurveyGroupQuestions.bind(this)
      }) : _react["default"].createElement("div", {
        className: "h-100 d-flex align-items-center justify-content-center"
      }, noContentFoundMessage))))), _react["default"].createElement(_AddSurveyGroup["default"], {
        open: addSurveyGroupState,
        surveyGroup: {
          'name': '',
          'selected': false,
          'starred': false,
          'frequently': false
        },
        onSaveSurveyGroup: this.onSaveSurveyGroup,
        onSurveyGroupClose: this.onSurveyGroupClose,
        onDeleteSurveyGroup: this.onDeleteSurveyGroup,
        showSurveyGroupLoader: this.showSurveyGroupLoader
      }), showMessage && _reactNotifications.NotificationManager.success(alertMessage, this.handleSurveyGroupRequestClose()), _react["default"].createElement(_reactNotifications.NotificationContainer, null));
    }
  }]);

  return SurveyGroup;
}(_react.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var surveyGroups = _ref.surveyGroups,
      settings = _ref.settings;
  var width = settings.width;
  var loader = surveyGroups.loader,
      alertMessage = surveyGroups.alertMessage,
      showMessage = surveyGroups.showMessage,
      noContentFoundMessage = surveyGroups.noContentFoundMessage,
      selectedSectionId = surveyGroups.selectedSectionId,
      drawerState = surveyGroups.drawerState,
      surveyGroup = surveyGroups.surveyGroup,
      searchSurveyGroup = surveyGroups.searchSurveyGroup,
      filterOption = surveyGroups.filterOption,
      allSurveyGroup = surveyGroups.allSurveyGroup,
      surveyGroupList = surveyGroups.surveyGroupList,
      selectedSurveyGroup = surveyGroups.selectedSurveyGroup,
      selectedSurveyGroups = surveyGroups.selectedSurveyGroups,
      addSurveyGroupState = surveyGroups.addSurveyGroupState;
  return {
    width: width,
    loader: loader,
    alertMessage: alertMessage,
    showMessage: showMessage,
    noContentFoundMessage: noContentFoundMessage,
    selectedSectionId: selectedSectionId,
    drawerState: drawerState,
    surveyGroup: surveyGroup,
    searchSurveyGroup: searchSurveyGroup,
    filterOption: filterOption,
    allSurveyGroup: allSurveyGroup,
    surveyGroupList: surveyGroupList,
    selectedSurveyGroup: selectedSurveyGroup,
    selectedSurveyGroups: selectedSurveyGroups,
    addSurveyGroupState: addSurveyGroupState
  };
};

exports.mapStateToProps = mapStateToProps;

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  fetchSurveyGroups: _SurveyGroup.fetchSurveyGroups,
  addFavouriteSurveyGroup: _SurveyGroup.addFavouriteSurveyGroup,
  onSurveyGroupSelect: _SurveyGroup.onSurveyGroupSelect,
  onAddSurveyGroup: _SurveyGroup.onAddSurveyGroup,
  onSurveyGroupClose: _SurveyGroup.onSurveyGroupClose,
  onFilterSurveyGroupOptionSelect: _SurveyGroup.onFilterSurveyGroupOptionSelect,
  onSaveSurveyGroup: _SurveyGroup.onSaveSurveyGroup,
  onDeleteSurveyGroup: _SurveyGroup.onDeleteSurveyGroup,
  onDeleteSelectedSurveyGroup: _SurveyGroup.onDeleteSelectedSurveyGroup,
  filterSurveyGroup: _SurveyGroup.filterSurveyGroup,
  getAllSurveyGroup: _SurveyGroup.getAllSurveyGroup,
  getUnselectedAllSurveyGroup: _SurveyGroup.getUnselectedAllSurveyGroup,
  onAllSurveyGroupSelect: _SurveyGroup.onAllSurveyGroupSelect,
  updateSearchSurveyGroup: _SurveyGroup.updateSearchSurveyGroup,
  onToggleSurveyGroupDrawer: _SurveyGroup.onToggleSurveyGroupDrawer,
  handleSurveyGroupRequestClose: _SurveyGroup.handleSurveyGroupRequestClose,
  hideSurveyGroupLoader: _SurveyGroup.hideSurveyGroupLoader,
  showSurveyGroupLoader: _SurveyGroup.showSurveyGroupLoader,
  onSurveyGroupQuestions: _SurveyGroup.onSurveyGroupQuestions
})(SurveyGroup);

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(filterOptions, "filterOptions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(SurveyGroup, "SurveyGroup", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_rcDrawer, "_rcDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_SurveyGroupList, "_SurveyGroupList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_AddSurveyGroup, "_AddSurveyGroup", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_CircularProgress, "_CircularProgress", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_CustomScrollbars, "_CustomScrollbars", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(filterOptions, "filterOptions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(SurveyGroup, "SurveyGroup", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/index.js");
}();

;

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _index = _interopRequireDefault(__webpack_require__(1871));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var SurveyGroupList = function SurveyGroupList(_ref) {
  var data = _ref.data,
      addFavouriteSurveyGroup = _ref.addFavouriteSurveyGroup,
      onSurveyGroupSelect = _ref.onSurveyGroupSelect,
      onSaveSurveyGroup = _ref.onSaveSurveyGroup,
      onDeleteSurveyGroup = _ref.onDeleteSurveyGroup,
      showSurveyGroupLoader = _ref.showSurveyGroupLoader,
      onSurveyGroupQuestions = _ref.onSurveyGroupQuestions;
  return _react["default"].createElement("div", {
    className: "app-main-content"
  }, data.map(function (data, index) {
    return _react["default"].createElement(_index["default"], {
      key: index,
      surveyGroup: data,
      onDeleteSurveyGroup: onDeleteSurveyGroup,
      onSaveSurveyGroup: onSaveSurveyGroup,
      showSurveyGroupLoader: showSurveyGroupLoader,
      addFavouriteSurveyGroup: addFavouriteSurveyGroup,
      onSurveyGroupSelect: onSurveyGroupSelect,
      onSurveyGroupQuestions: onSurveyGroupQuestions
    });
  }));
};

var _default = SurveyGroupList;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SurveyGroupList, "SurveyGroupList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/SurveyGroupList/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/SurveyGroupList/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/SurveyGroupList/index.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/SurveyGroupList/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/SurveyGroupList/index.js");

  __REACT_HOT_LOADER__.register(SurveyGroupList, "SurveyGroupList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/SurveyGroupList/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/SurveyGroupList/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/SurveyGroupList/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/SurveyGroupList/index.js");
}();

;

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _store = __webpack_require__(54);

var _index = _interopRequireDefault(__webpack_require__(812));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SurveyGroupRow =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SurveyGroupRow, _React$Component);

  _createClass(SurveyGroupRow, [{
    key: "__onSurveyGroupOptionToggle__REACT_HOT_LOADER__",
    value: function __onSurveyGroupOptionToggle__REACT_HOT_LOADER__() {
      this.setState({
        menuState: !this.state.menuState
      });
    }
  }, {
    key: "__onSurveyGroupClose__REACT_HOT_LOADER__",
    value: function __onSurveyGroupClose__REACT_HOT_LOADER__() {
      this.setState({
        addSurveyGroupState: false
      });
    }
  }, {
    key: "__onDeleteSurveyGroup__REACT_HOT_LOADER__",
    value: function __onDeleteSurveyGroup__REACT_HOT_LOADER__(group) {
      this.setState({
        addSurveyGroupState: false
      });
      this.props.onDeleteSurveyGroup(group);
    }
  }, {
    key: "__onEditSurveyGroup__REACT_HOT_LOADER__",
    value: function __onEditSurveyGroup__REACT_HOT_LOADER__() {
      this.setState({
        menuState: false,
        addSurveyGroupState: true
      });
    }
  }, {
    key: "__onSurveyGroupQuestions__REACT_HOT_LOADER__",
    value: function __onSurveyGroupQuestions__REACT_HOT_LOADER__(group) {
      this.setState({
        addSurveyGroupState: false
      });
      this.props.onSurveyGroupQuestions(group);

      _store.history.push('/app/survey-group-question/default');
    }
  }]);

  function SurveyGroupRow() {
    var _this;

    _classCallCheck(this, SurveyGroupRow);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SurveyGroupRow).call(this));

    _defineProperty(_assertThisInitialized(_this), "onSurveyGroupOptionToggle", function () {
      var _this2;

      return (_this2 = _this).__onSurveyGroupOptionToggle__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onSurveyGroupClose", function () {
      var _this3;

      return (_this3 = _this).__onSurveyGroupClose__REACT_HOT_LOADER__.apply(_this3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onDeleteSurveyGroup", function () {
      var _this4;

      return (_this4 = _this).__onDeleteSurveyGroup__REACT_HOT_LOADER__.apply(_this4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onEditSurveyGroup", function () {
      var _this5;

      return (_this5 = _this).__onEditSurveyGroup__REACT_HOT_LOADER__.apply(_this5, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onSurveyGroupQuestions", function () {
      var _this6;

      return (_this6 = _this).__onSurveyGroupQuestions__REACT_HOT_LOADER__.apply(_this6, arguments);
    });

    _this.state = {
      menuState: false,
      addSurveyGroupState: false
    };
    return _this;
  }

  _createClass(SurveyGroupRow, [{
    key: "render",
    value: function render() {
      var _this7 = this;

      var _this$props = this.props,
          surveyGroup = _this$props.surveyGroup,
          addFavouriteSurveyGroup = _this$props.addFavouriteSurveyGroup,
          onSurveyGroupSelect = _this$props.onSurveyGroupSelect,
          onSaveSurveyGroup = _this$props.onSaveSurveyGroup,
          showSurveyGroupLoader = _this$props.showSurveyGroupLoader;
      var _this$state = this.state,
          menuState = _this$state.menuState,
          addSurveyGroupState = _this$state.addSurveyGroupState;
      var name = surveyGroup.name,
          starred = surveyGroup.starred,
          thumb = surveyGroup.thumb;
      var options = ['Edit', 'Delete', 'Questions'];
      return _react["default"].createElement("div", {
        className: "contact-item  align-items-center"
      }, _react["default"].createElement("div", {
        className: "form-control-checkbox d-flex"
      }, _react["default"].createElement("div", {
        className: "form-checkbox"
      }, _react["default"].createElement("input", {
        type: "checkbox",
        checked: surveyGroup.selected,
        value: "checked",
        onClick: function onClick() {
          onSurveyGroupSelect(surveyGroup);
        },
        onChange: function onChange() {}
      }), _react["default"].createElement("span", {
        className: "check"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-check zmdi-hc-lg"
      })))), _react["default"].createElement("div", {
        className: "col-auto px-1 actions d-none d-xs-flex"
      }, _react["default"].createElement("span", {
        className: "icon-btn",
        onClick: function onClick() {
          addFavouriteSurveyGroup(surveyGroup);
        }
      }, starred ? _react["default"].createElement("i", {
        className: "zmdi zmdi-star"
      }) : _react["default"].createElement("i", {
        className: "zmdi zmdi-star-outline"
      }))), thumb === null || thumb === '' ? _react["default"].createElement("div", {
        className: "rounded-circle size-40 bg-blue text-center text-white mx-1 mx-md-3",
        style: {
          fontSize: 20
        }
      }, name ? name.charAt(0).toUpperCase() : '') : _react["default"].createElement("img", {
        className: "rounded-circle size-40 mx-1 mx-md-3",
        alt: name,
        src: thumb
      }), _react["default"].createElement("div", {
        className: "col con-inf-mw-100"
      }, _react["default"].createElement("p", {
        className: "mb-0"
      }, _react["default"].createElement("span", {
        className: "text-truncate group-name"
      }, name))), _react["default"].createElement("div", null, _react["default"].createElement(_reactstrap.Dropdown, {
        isOpen: menuState,
        toggle: this.onSurveyGroupOptionToggle.bind(this)
      }, _react["default"].createElement(_reactstrap.DropdownToggle, {
        tag: "span"
      }, _react["default"].createElement("span", {
        className: "icon-btn text-grey pointer"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-more-vert zmdi-hc-lg"
      }))), _react["default"].createElement(_reactstrap.DropdownMenu, null, options.map(function (option) {
        return _react["default"].createElement(_reactstrap.DropdownItem, {
          key: option,
          onClick: function onClick() {
            if (option === 'Edit') {
              _this7.onEditSurveyGroup();
            } else if (option === 'Delete') {
              _this7.onDeleteSurveyGroup(surveyGroup);
            } else if (option === 'Questions') {
              _this7.onSurveyGroupQuestions(surveyGroup);
            }
          }
        }, option);
      }))), addSurveyGroupState && _react["default"].createElement(_index["default"], {
        open: addSurveyGroupState,
        surveyGroup: surveyGroup,
        onSaveSurveyGroup: onSaveSurveyGroup,
        onSurveyGroupClose: this.onSurveyGroupClose,
        onDeleteSurveyGroup: this.onDeleteSurveyGroup,
        showSurveyGroupLoader: showSurveyGroupLoader
      })));
    }
  }]);

  return SurveyGroupRow;
}(_react["default"].Component);

var _default = SurveyGroupRow;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SurveyGroupRow, "SurveyGroupRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/SurveyGroupList/SurveyGroupRow/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/SurveyGroupList/SurveyGroupRow/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/SurveyGroupList/SurveyGroupRow/index.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/SurveyGroupList/SurveyGroupRow/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/SurveyGroupList/SurveyGroupRow/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/SurveyGroupList/SurveyGroupRow/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/SurveyGroupList/SurveyGroupRow/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/SurveyGroupList/SurveyGroupRow/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/SurveyGroupList/SurveyGroupRow/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/SurveyGroupList/SurveyGroupRow/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/SurveyGroupList/SurveyGroupRow/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/SurveyGroupList/SurveyGroupRow/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/SurveyGroupList/SurveyGroupRow/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/SurveyGroupList/SurveyGroupRow/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/SurveyGroupList/SurveyGroupRow/index.js");

  __REACT_HOT_LOADER__.register(SurveyGroupRow, "SurveyGroupRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/SurveyGroupList/SurveyGroupRow/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/SurveyGroupList/SurveyGroupRow/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/SurveyGroupList/SurveyGroupRow/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroup/SurveyGroupList/SurveyGroupRow/index.js");
}();

;

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _rcDrawer = _interopRequireDefault(__webpack_require__(31));

var _reactNotifications = __webpack_require__(30);

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _index = _interopRequireDefault(__webpack_require__(66));

var _SurveyGroupQuestionList = _interopRequireDefault(__webpack_require__(1873));

var _AddSurveyGroupQuestion = _interopRequireDefault(__webpack_require__(1875));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _CircularProgress = _interopRequireDefault(__webpack_require__(24));

var _CustomScrollbars = _interopRequireDefault(__webpack_require__(27));

var _SurveyQuestion = __webpack_require__(261);

var _SurveyGroupQuestion = __webpack_require__(363);

var _SurveyGroup = __webpack_require__(177);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SurveyGroupQuestion =
/*#__PURE__*/
function (_Component) {
  _inherits(SurveyGroupQuestion, _Component);

  _createClass(SurveyGroupQuestion, [{
    key: "__surveyGroupQuestionSideBar__REACT_HOT_LOADER__",
    value: function __surveyGroupQuestionSideBar__REACT_HOT_LOADER__() {
      return _react["default"].createElement("div", {
        className: "module-side"
      }, _react["default"].createElement("div", {
        className: "module-side-header"
      }, _react["default"].createElement("div", {
        className: "module-logo"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-city-alt mr-4"
      }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.surveyGroupQuestion"
      })))), _react["default"].createElement("div", {
        className: "module-side-content"
      }, _react["default"].createElement(_CustomScrollbars["default"], {
        className: "module-side-scroll scrollbar",
        style: {
          height: this.props.width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)'
        }
      }, _react["default"].createElement("div", {
        className: "module-add-task"
      }, _react["default"].createElement(_reactstrap.Button, {
        className: "btn-block jr-btn",
        color: "primary",
        onClick: this.onAddSurveyGroupQuestion
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-accounts-add zmdi-hc-fw"
      }), _react["default"].createElement("span", null, "Add New Question"))))));
    }
  }, {
    key: "__onAddSurveyGroupQuestion__REACT_HOT_LOADER__",
    value: function __onAddSurveyGroupQuestion__REACT_HOT_LOADER__() {
      this.props.onAddSurveyGroupQuestion();
    }
  }, {
    key: "__onSurveyGroupQuestionClose__REACT_HOT_LOADER__",
    value: function __onSurveyGroupQuestionClose__REACT_HOT_LOADER__() {
      this.props.onSurveyGroupQuestionClose();
    }
  }, {
    key: "__onSaveSurveyGroupQuestion__REACT_HOT_LOADER__",
    value: function __onSaveSurveyGroupQuestion__REACT_HOT_LOADER__(data) {
      this.props.onSaveSurveyGroupQuestion(data);
    }
  }, {
    key: "__onDeleteSurveyGroupQuestion__REACT_HOT_LOADER__",
    value: function __onDeleteSurveyGroupQuestion__REACT_HOT_LOADER__(data) {
      this.props.onDeleteSurveyGroupQuestion(data);
    }
  }, {
    key: "__handleSurveyGroupQuestionRequestClose__REACT_HOT_LOADER__",
    value: function __handleSurveyGroupQuestionRequestClose__REACT_HOT_LOADER__() {
      this.props.handleSurveyGroupQuestionRequestClose();
    }
  }, {
    key: "__onToggleSurveyGroupQuestionDrawer__REACT_HOT_LOADER__",
    value: function __onToggleSurveyGroupQuestionDrawer__REACT_HOT_LOADER__() {
      this.props.onToggleSurveyGroupQuestionDrawer();
    }
  }, {
    key: "__showSurveyQuestionLoader__REACT_HOT_LOADER__",
    value: function __showSurveyQuestionLoader__REACT_HOT_LOADER__() {
      this.props.showSurveyQuestionLoader();
    }
  }, {
    key: "__showSurveyGroupLoader__REACT_HOT_LOADER__",
    value: function __showSurveyGroupLoader__REACT_HOT_LOADER__() {
      this.props.showSurveyGroupLoader();
    }
  }]);

  function SurveyGroupQuestion() {
    var _this;

    _classCallCheck(this, SurveyGroupQuestion);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SurveyGroupQuestion).call(this));

    _defineProperty(_assertThisInitialized(_this), "surveyGroupQuestionSideBar", function () {
      var _this2;

      return (_this2 = _this).__surveyGroupQuestionSideBar__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onAddSurveyGroupQuestion", function () {
      var _this3;

      return (_this3 = _this).__onAddSurveyGroupQuestion__REACT_HOT_LOADER__.apply(_this3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onSurveyGroupQuestionClose", function () {
      var _this4;

      return (_this4 = _this).__onSurveyGroupQuestionClose__REACT_HOT_LOADER__.apply(_this4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onSaveSurveyGroupQuestion", function () {
      var _this5;

      return (_this5 = _this).__onSaveSurveyGroupQuestion__REACT_HOT_LOADER__.apply(_this5, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onDeleteSurveyGroupQuestion", function () {
      var _this6;

      return (_this6 = _this).__onDeleteSurveyGroupQuestion__REACT_HOT_LOADER__.apply(_this6, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "handleSurveyGroupQuestionRequestClose", function () {
      var _this7;

      return (_this7 = _this).__handleSurveyGroupQuestionRequestClose__REACT_HOT_LOADER__.apply(_this7, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onToggleSurveyGroupQuestionDrawer", function () {
      var _this8;

      return (_this8 = _this).__onToggleSurveyGroupQuestionDrawer__REACT_HOT_LOADER__.apply(_this8, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "showSurveyQuestionLoader", function () {
      var _this9;

      return (_this9 = _this).__showSurveyQuestionLoader__REACT_HOT_LOADER__.apply(_this9, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "showSurveyGroupLoader", function () {
      var _this10;

      return (_this10 = _this).__showSurveyGroupLoader__REACT_HOT_LOADER__.apply(_this10, arguments);
    });

    return _this;
  }

  _createClass(SurveyGroupQuestion, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.showSurveyQuestionLoader();
      this.props.fetchSurveyQuestions();
    }
  }, {
    key: "render",
    value: function render() {
      var _selectedSurveyGroup$;

      var _this$props = this.props,
          surveyGroupQuestion = _this$props.surveyGroupQuestion,
          addSurveyGroupQuestionState = _this$props.addSurveyGroupQuestionState,
          alertMessage = _this$props.alertMessage,
          showMessage = _this$props.showMessage,
          drawerState = _this$props.drawerState,
          noContentFoundMessage = _this$props.noContentFoundMessage,
          loader = _this$props.loader,
          selectedSurveyGroup = _this$props.selectedSurveyGroup,
          surveyQuestionList = _this$props.surveyQuestionList;
      return _react["default"].createElement("div", {
        className: "app-wrapper"
      }, _react["default"].createElement("div", {
        className: "app-module animated slideInUpTiny animation-duration-3"
      }, _react["default"].createElement("div", {
        className: "d-block d-xl-none"
      }, _react["default"].createElement(_rcDrawer["default"], {
        touch: true,
        transitions: true,
        enableDragHandle: true,
        open: drawerState,
        onOpenChange: this.onToggleSurveyGroupQuestionDrawer.bind(this),
        sidebar: this.surveyGroupQuestionSideBar(surveyGroupQuestion)
      })), _react["default"].createElement("div", {
        className: "app-module-sidenav d-none d-xl-flex"
      }, this.surveyGroupQuestionSideBar(surveyGroupQuestion)), _react["default"].createElement("div", {
        className: "module-box"
      }, _react["default"].createElement("div", {
        className: "module-box-header"
      }, _react["default"].createElement("span", {
        className: "icon-btn drawer-btn d-flex d-xl-none",
        onClick: this.onToggleSurveyGroupQuestionDrawer.bind(this)
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-menu"
      })), _react["default"].createElement(_index["default"], {
        placeholder: "Search Unavailable",
        notification: false,
        apps: false,
        user: this.props.surveyGroup,
        onChange: function onChange() {},
        value: this.props.searchSurveyGroup
      })), _react["default"].createElement("div", {
        className: "module-box-content"
      }, _react["default"].createElement(_CustomScrollbars["default"], {
        className: "module-list-scroll scrollbar",
        style: {
          height: this.props.width >= 1200 ? 'calc(100vh - 265px)' : 'calc(100vh - 245px)'
        }
      }, loader ? _react["default"].createElement("div", {
        className: "loader-view-block h-100"
      }, _react["default"].createElement("div", {
        className: "loader-view"
      }, _react["default"].createElement(_CircularProgress["default"], null))) : (selectedSurveyGroup === null || selectedSurveyGroup === void 0 ? void 0 : (_selectedSurveyGroup$ = selectedSurveyGroup.questions) === null || _selectedSurveyGroup$ === void 0 ? void 0 : _selectedSurveyGroup$.length) === 0 ? _react["default"].createElement("div", {
        className: "h-100 d-flex align-items-center justify-content-center"
      }, noContentFoundMessage) : _react["default"].createElement(_SurveyGroupQuestionList["default"], {
        surveyQuestionList: surveyQuestionList,
        selectedSurveyGroup: selectedSurveyGroup,
        onDeleteSurveyGroupQuestion: this.onDeleteSurveyGroupQuestion.bind(this),
        showSurveyQuestionLoader: this.showSurveyQuestionLoader.bind(this)
      }))))), _react["default"].createElement(_AddSurveyGroupQuestion["default"], {
        surveyQuestions: surveyQuestionList,
        surveyGroup: selectedSurveyGroup,
        open: addSurveyGroupQuestionState,
        surveyGroupQuestion: {
          id: ''
        },
        onSaveSurveyGroupQuestion: this.onSaveSurveyGroupQuestion.bind(this),
        onSurveyGroupQuestionClose: this.onSurveyGroupQuestionClose.bind(this),
        showSurveyGroupLoader: this.showSurveyGroupLoader
      }), showMessage && _reactNotifications.NotificationManager.success(alertMessage, this.handleSurveyGroupQuestionRequestClose()), _react["default"].createElement(_reactNotifications.NotificationContainer, null));
    }
  }]);

  return SurveyGroupQuestion;
}(_react.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var surveyQuestions = _ref.surveyQuestions,
      surveyGroups = _ref.surveyGroups,
      settings = _ref.settings,
      surveyGroupQuestions = _ref.surveyGroupQuestions;
  var width = settings.width;
  var loader = surveyQuestions.loader,
      alertMessage = surveyQuestions.alertMessage,
      showMessage = surveyQuestions.showMessage,
      surveyQuestionList = surveyQuestions.surveyQuestionList;
  var selectedSurveyGroup = surveyGroups.selectedSurveyGroup,
      surveyGroup = surveyGroups.surveyGroup;
  var addSurveyGroupQuestionState = surveyGroupQuestions.addSurveyGroupQuestionState,
      drawerState = surveyGroupQuestions.drawerState;
  return {
    width: width,
    loader: loader,
    alertMessage: alertMessage,
    showMessage: showMessage,
    surveyQuestionList: surveyQuestionList,
    selectedSurveyGroup: selectedSurveyGroup,
    surveyGroup: surveyGroup,
    addSurveyGroupQuestionState: addSurveyGroupQuestionState,
    drawerState: drawerState
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  fetchSurveyQuestions: _SurveyQuestion.fetchSurveyQuestions,
  showSurveyQuestionLoader: _SurveyQuestion.showSurveyQuestionLoader,
  hideSurveyQuestionLoader: _SurveyQuestion.hideSurveyQuestionLoader,
  onAddSurveyGroupQuestion: _SurveyGroupQuestion.onAddSurveyGroupQuestion,
  showSurveyGroupLoader: _SurveyGroup.showSurveyGroupLoader,
  onSurveyGroupQuestionClose: _SurveyGroupQuestion.onSurveyGroupQuestionClose,
  onSaveSurveyGroupQuestion: _SurveyGroupQuestion.onSaveSurveyGroupQuestion,
  onToggleSurveyGroupQuestionDrawer: _SurveyGroupQuestion.onToggleSurveyGroupQuestionDrawer
})(SurveyGroupQuestion);

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SurveyGroupQuestion, "SurveyGroupQuestion", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_rcDrawer, "_rcDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_SurveyGroupQuestionList, "_SurveyGroupQuestionList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_AddSurveyGroupQuestion, "_AddSurveyGroupQuestion", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_CircularProgress, "_CircularProgress", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_CustomScrollbars, "_CustomScrollbars", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(SurveyGroupQuestion, "SurveyGroupQuestion", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/index.js");
}();

;

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _index = _interopRequireDefault(__webpack_require__(1874));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var SurveyGroupQuestionList = function SurveyGroupQuestionList(_ref) {
  var _selectedSurveyGroup$;

  var surveyQuestionList = _ref.surveyQuestionList,
      selectedSurveyGroup = _ref.selectedSurveyGroup,
      onDeleteSurveyGroupQuestion = _ref.onDeleteSurveyGroupQuestion,
      showSurveyQuestionLoader = _ref.showSurveyQuestionLoader;
  return _react["default"].createElement("div", {
    className: "app-main-content"
  }, (selectedSurveyGroup === null || selectedSurveyGroup === void 0 ? void 0 : (_selectedSurveyGroup$ = selectedSurveyGroup.questions) === null || _selectedSurveyGroup$ === void 0 ? void 0 : _selectedSurveyGroup$.length) > 0 ? selectedSurveyGroup.questions.map(function (data, index) {
    return _react["default"].createElement(_index["default"], {
      key: index,
      surveyGroupQuestionId: data,
      surveyGroupQuestionText: surveyQuestionList[data] // only required if we want to show the question content
      ,
      onDeleteSurveyGroupQuestion: onDeleteSurveyGroupQuestion,
      showSurveyQuestionLoader: showSurveyQuestionLoader
    });
  }) : null);
};

var _default = SurveyGroupQuestionList;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SurveyGroupQuestionList, "SurveyGroupQuestionList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/SurveyGroupQuestionList/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/SurveyGroupQuestionList/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/SurveyGroupQuestionList/index.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/SurveyGroupQuestionList/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/SurveyGroupQuestionList/index.js");

  __REACT_HOT_LOADER__.register(SurveyGroupQuestionList, "SurveyGroupQuestionList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/SurveyGroupQuestionList/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/SurveyGroupQuestionList/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/SurveyGroupQuestionList/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/SurveyGroupQuestionList/index.js");
}();

;

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SurveyGroupQuestionRow =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SurveyGroupQuestionRow, _React$Component);

  _createClass(SurveyGroupQuestionRow, [{
    key: "__onSurveyGroupQuestionOptionToggle__REACT_HOT_LOADER__",
    value: function __onSurveyGroupQuestionOptionToggle__REACT_HOT_LOADER__() {
      this.setState({
        menuState: !this.state.menuState
      });
    }
  }, {
    key: "__onSurveyGroupQuestionClose__REACT_HOT_LOADER__",
    value: function __onSurveyGroupQuestionClose__REACT_HOT_LOADER__() {
      this.setState({
        addSurveyGroupQuestionState: false
      });
    }
  }, {
    key: "__onDeleteSurveyGroupQuestion__REACT_HOT_LOADER__",
    value: function __onDeleteSurveyGroupQuestion__REACT_HOT_LOADER__(question) {
      this.setState({
        addSurveyGroupQuestionState: false
      });
      this.props.onDeleteSurveyGroupQuestion(question);
    }
  }]);

  function SurveyGroupQuestionRow() {
    var _this;

    _classCallCheck(this, SurveyGroupQuestionRow);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SurveyGroupQuestionRow).call(this));

    _defineProperty(_assertThisInitialized(_this), "onSurveyGroupQuestionOptionToggle", function () {
      var _this2;

      return (_this2 = _this).__onSurveyGroupQuestionOptionToggle__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onSurveyGroupQuestionClose", function () {
      var _this3;

      return (_this3 = _this).__onSurveyGroupQuestionClose__REACT_HOT_LOADER__.apply(_this3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onDeleteSurveyGroupQuestion", function () {
      var _this4;

      return (_this4 = _this).__onDeleteSurveyGroupQuestion__REACT_HOT_LOADER__.apply(_this4, arguments);
    });

    _this.state = {
      menuState: false,
      addSurveyGroupQuestionState: false
    };
    return _this;
  }

  _createClass(SurveyGroupQuestionRow, [{
    key: "render",
    value: function render() {
      var _this5 = this;

      var surveyGroupQuestionId = this.props.surveyGroupQuestionId;
      var menuState = this.state.menuState;
      var options = ['Delete'];
      return _react["default"].createElement("div", {
        className: "contact-item"
      }, _react["default"].createElement("div", {
        className: "col con-inf-mw-100"
      }, _react["default"].createElement("p", {
        className: "mb-0"
      }, _react["default"].createElement("span", {
        className: "text-truncate group-name"
      }, surveyGroupQuestionId))), _react["default"].createElement("div", null, _react["default"].createElement(_reactstrap.Dropdown, {
        isOpen: menuState,
        toggle: this.onSurveyGroupQuestionOptionToggle.bind(this)
      }, _react["default"].createElement(_reactstrap.DropdownToggle, {
        tag: "span"
      }, _react["default"].createElement("span", {
        className: "icon-btn text-grey pointer"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-more-vert zmdi-hc-lg"
      }))), _react["default"].createElement(_reactstrap.DropdownMenu, null, options.map(function (option) {
        return _react["default"].createElement(_reactstrap.DropdownItem, {
          key: option,
          onClick: function onClick() {
            if (option === 'Delete') {
              _this5.onDeleteSurveyGroupQuestion(surveyGroupQuestionId);
            }
          }
        }, option);
      })))));
    }
  }]);

  return SurveyGroupQuestionRow;
}(_react["default"].Component);

var _default = SurveyGroupQuestionRow;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SurveyGroupQuestionRow, "SurveyGroupQuestionRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/SurveyGroupQuestionList/SurveyGroupQuestionRow/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/SurveyGroupQuestionList/SurveyGroupQuestionRow/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/SurveyGroupQuestionList/SurveyGroupQuestionRow/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/SurveyGroupQuestionList/SurveyGroupQuestionRow/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/SurveyGroupQuestionList/SurveyGroupQuestionRow/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/SurveyGroupQuestionList/SurveyGroupQuestionRow/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/SurveyGroupQuestionList/SurveyGroupQuestionRow/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/SurveyGroupQuestionList/SurveyGroupQuestionRow/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/SurveyGroupQuestionList/SurveyGroupQuestionRow/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/SurveyGroupQuestionList/SurveyGroupQuestionRow/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/SurveyGroupQuestionList/SurveyGroupQuestionRow/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/SurveyGroupQuestionList/SurveyGroupQuestionRow/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/SurveyGroupQuestionList/SurveyGroupQuestionRow/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/SurveyGroupQuestionList/SurveyGroupQuestionRow/index.js");

  __REACT_HOT_LOADER__.register(SurveyGroupQuestionRow, "SurveyGroupQuestionRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/SurveyGroupQuestionList/SurveyGroupQuestionRow/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/SurveyGroupQuestionList/SurveyGroupQuestionRow/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/SurveyGroupQuestionList/SurveyGroupQuestionRow/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/SurveyGroupQuestionList/SurveyGroupQuestionRow/index.js");
}();

;

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _DataFormatters = __webpack_require__(1876);

var _Validation = __webpack_require__(14);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var AddSurveyGroupQuestion =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AddSurveyGroupQuestion, _React$Component);

  function AddSurveyGroupQuestion(props) {
    var _this;

    _classCallCheck(this, AddSurveyGroupQuestion);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AddSurveyGroupQuestion).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleUserInput", function () {
      var _this2;

      return (_this2 = _this).__handleUserInput__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    var id = props.surveyGroupQuestion.id;
    _this.state = {
      id: id,
      idValid: (0, _Validation.isValueEntered)(id),
      formErrors: {
        id: ''
      },
      formValid: false
    };
    return _this;
  }

  _createClass(AddSurveyGroupQuestion, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.validateForm();
    }
  }, {
    key: "validateForm",
    value: function validateForm() {
      this.setState({
        formValid: this.state.idValid
      });
    }
  }, {
    key: "validateField",
    value: function validateField(fieldName, value) {
      var fieldValidationErrors = this.state.formErrors;
      var idValid = this.state.idValid;

      switch (fieldName) {
        case 'id':
          idValid = (0, _Validation.isValueEntered)(value);
          fieldValidationErrors.name = idValid ? '' : ' is invalid';
          break;

        default:
          break;
      }

      this.setState({
        formErrors: fieldValidationErrors,
        idValid: idValid
      }, this.validateForm);
    }
  }, {
    key: "__handleUserInput__REACT_HOT_LOADER__",
    value: function __handleUserInput__REACT_HOT_LOADER__(e) {
      var _this3 = this;

      var name = e.target.name;
      var value = e.target.value;
      this.setState(_defineProperty({}, name, value), function () {
        _this3.validateField(name, value);
      } // run this call back on state change
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          onSaveSurveyGroupQuestion = _this$props.onSaveSurveyGroupQuestion,
          showSurveyGroupLoader = _this$props.showSurveyGroupLoader,
          onSurveyGroupQuestionClose = _this$props.onSurveyGroupQuestionClose,
          open = _this$props.open,
          surveyQuestions = _this$props.surveyQuestions,
          surveyGroup = _this$props.surveyGroup;
      var id = this.state.id;
      var filteredSurveyQuestions = (0, _DataFormatters.filterDuplicatesById)(surveyQuestions, surveyGroup === null || surveyGroup === void 0 ? void 0 : surveyGroup.questions);
      return _react["default"].createElement(_reactstrap.Modal, {
        className: "modal-box",
        toggle: onSurveyGroupQuestionClose,
        isOpen: open
      }, _react["default"].createElement(_reactstrap.ModalHeader, {
        className: "modal-box-header bg-primary"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "surveyGroupQuestion.addSurveyGroupQuestion"
      }), _react["default"].createElement("span", {
        className: "text-white pointer"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-close zmdi-hc-lg",
        onClick: onSurveyGroupQuestionClose
      }))), _react["default"].createElement("div", {
        className: "modal-box-content"
      }, _react["default"].createElement("div", {
        className: "row no-gutters"
      }, _react["default"].createElement("div", {
        className: "col-lg-9 d-flex flex-column order-lg-1"
      }, _react["default"].createElement(_reactstrap.FormGroup, null, _react["default"].createElement(_reactstrap.Label, {
        "for": "questionSelect"
      }, "Select"), _react["default"].createElement(_reactstrap.Input, {
        type: "select",
        name: "id",
        id: "questionSelect",
        onChange: function onChange(event) {
          return _this4.handleUserInput(event);
        }
      }, _react["default"].createElement("option", {
        key: "emptySelect",
        value: ""
      }, "-- select question --"), filteredSurveyQuestions.map(function (surveyQuestion) {
        return _react["default"].createElement("option", {
          key: surveyQuestion.id,
          value: surveyQuestion.id
        }, surveyQuestion.name);
      })))))), _react["default"].createElement("div", {
        className: "modal-box-footer d-flex flex-row"
      }, _react["default"].createElement(_reactstrap.Button, {
        className: "text-uppercase",
        disabled: !this.state.formValid,
        color: "primary",
        onClick: function onClick() {
          showSurveyGroupLoader();
          onSurveyGroupQuestionClose();
          onSaveSurveyGroupQuestion({
            'id': id
          });

          _this4.setState({
            id: '',
            formErrors: {
              id: ''
            },
            formValid: false
          });
        }
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "surveyGroupQuestion.addSurveyGroupQuestion"
      }))));
    }
  }]);

  return AddSurveyGroupQuestion;
}(_react["default"].Component);

var _default = AddSurveyGroupQuestion;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AddSurveyGroupQuestion, "AddSurveyGroupQuestion", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/AddSurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/AddSurveyGroupQuestion/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/AddSurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/AddSurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/AddSurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/AddSurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/AddSurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/AddSurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/AddSurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/AddSurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/AddSurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/AddSurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/AddSurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/AddSurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/AddSurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(AddSurveyGroupQuestion, "AddSurveyGroupQuestion", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/AddSurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/AddSurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/AddSurveyGroupQuestion/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/SurveyGroupQuestion/AddSurveyGroupQuestion/index.js");
}();

;

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notDuplicateById = exports.filterDuplicatesById = void 0;
/**
 * Remove entires from source that exist in duplicates
 * @param {*} source - the list to remove duplicates from i.e. surveyQuestions
 * @param {*} duplicates - the duplicates to check - assumes it is the id field
 * i.e. the items already selected surveyGroups.questions - map to id field in the list
 */

var filterDuplicatesById = function filterDuplicatesById(source, duplicates) {
  return source.filter(function (entry) {
    return notDuplicateById(entry, duplicates);
  });
};
/**
 * call using the array filter method - refer to filterDuplicatesById
 * @param {*} currentValue 
 */


exports.filterDuplicatesById = filterDuplicatesById;

var notDuplicateById = function notDuplicateById(currentValue, duplicates) {
  var notDuplicate = true;

  if (duplicates) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = duplicates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var duplicate = _step.value;

        if (duplicate === currentValue.id) {
          notDuplicate = false;
          break;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  return notDuplicate;
};

exports.notDuplicateById = notDuplicateById;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(filterDuplicatesById, "filterDuplicatesById", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DataFormatters.js");

  __REACT_HOT_LOADER__.register(notDuplicateById, "notDuplicateById", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DataFormatters.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(filterDuplicatesById, "filterDuplicatesById", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DataFormatters.js");

  __REACT_HOT_LOADER__.register(notDuplicateById, "notDuplicateById", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DataFormatters.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/DataFormatters.js");
}();

;

/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _container["default"];
  }
});

var _container = _interopRequireDefault(__webpack_require__(1878));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_container, "_container", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/index.js");
}();

;

/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.mapStateToProps = void 0;

var _reactRedux = __webpack_require__(10);

var _project = __webpack_require__(179);

var _security = __webpack_require__(262);

var _initiative = __webpack_require__(101);

var _component = _interopRequireDefault(__webpack_require__(1879));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var mapStateToProps = function mapStateToProps(_ref) {
  var projects = _ref.projects,
      settings = _ref.settings,
      orgs = _ref.orgs,
      securitys = _ref.securitys,
      initiatives = _ref.initiatives;
  var width = settings.width;
  var loader = projects.loader,
      alertMessage = projects.alertMessage,
      showMessage = projects.showMessage,
      noContentFoundMessage = projects.noContentFoundMessage,
      selectedSectionId = projects.selectedSectionId,
      drawerState = projects.drawerState,
      project = projects.project,
      searchProject = projects.searchProject,
      filterOption = projects.filterOption,
      allProject = projects.allProject,
      projectList = projects.projectList,
      selectedProject = projects.selectedProject,
      selectedProjects = projects.selectedProjects,
      addProjectState = projects.addProjectState,
      importedProjects = projects.importedProjects,
      importLoader = projects.importLoader;
  var selectedOrg = orgs.selectedOrg;
  var allSecurity = securitys.allSecurity;
  var allInitiative = initiatives.allInitiative;
  return {
    width: width,
    loader: loader,
    alertMessage: alertMessage,
    showMessage: showMessage,
    noContentFoundMessage: noContentFoundMessage,
    selectedSectionId: selectedSectionId,
    drawerState: drawerState,
    project: project,
    searchProject: searchProject,
    filterOption: filterOption,
    allProject: allProject,
    projectList: projectList,
    selectedProject: selectedProject,
    selectedProjects: selectedProjects,
    addProjectState: addProjectState,
    importedProjects: importedProjects,
    importLoader: importLoader,
    selectedOrg: selectedOrg,
    allSecurity: allSecurity,
    allInitiative: allInitiative
  };
};

exports.mapStateToProps = mapStateToProps;

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  fetchProjects: _project.fetchProjects,
  addFavouriteProject: _project.addFavouriteProject,
  onProjectSelect: _project.onProjectSelect,
  onAddProject: _project.onAddProject,
  onProjectClose: _project.onProjectClose,
  onFilterProjectOptionSelect: _project.onFilterProjectOptionSelect,
  onSaveProject: _project.onSaveProject,
  onDeleteProject: _project.onDeleteProject,
  onDeleteSelectedProject: _project.onDeleteSelectedProject,
  filterProject: _project.filterProject,
  getAllProject: _project.getAllProject,
  getUnselectedAllProject: _project.getUnselectedAllProject,
  onAllProjectSelect: _project.onAllProjectSelect,
  updateSearchProject: _project.updateSearchProject,
  onToggleProjectDrawer: _project.onToggleProjectDrawer,
  handleProjectRequestClose: _project.handleProjectRequestClose,
  hideProjectLoader: _project.hideProjectLoader,
  showProjectLoader: _project.showProjectLoader,
  onProjectPrioritiesDashboard: _project.onProjectPrioritiesDashboard,
  onProjectCostPrioritiesDashboard: _project.onProjectCostPrioritiesDashboard,
  onProjectBusinessPrioritiesDashboard: _project.onProjectBusinessPrioritiesDashboard,
  onGlobalProjectCostPrioritiesDashboard: _project.onGlobalProjectCostPrioritiesDashboard,
  onGlobalProjectBusinessPrioritiesDashboard: _project.onGlobalProjectBusinessPrioritiesDashboard,
  onProjectIssuesDashboard: _project.onProjectIssuesDashboard,
  fetchImportProjects: _project.fetchImportProjects,
  showImportProjectsLoader: _project.showImportProjectsLoader,
  onImportProjects: _project.onImportProjects,
  fetchSecuritys: _security.fetchSecuritys,
  setProject: _project.setProject,
  fetchInitiatives: _initiative.fetchInitiatives
})(_component["default"]);

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/container.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/container.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_component, "_component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/container.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/container.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/container.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/container.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/container.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/container.js");
}();

;

/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Component = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _rcDrawer = _interopRequireDefault(__webpack_require__(31));

var _reactNotifications = __webpack_require__(30);

var _reactstrap = __webpack_require__(6);

var _store = __webpack_require__(54);

var _projectList = _interopRequireDefault(__webpack_require__(1880));

var _projectDetail = _interopRequireDefault(__webpack_require__(1882));

var _projectAdd = _interopRequireDefault(__webpack_require__(813));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _CircularProgress = _interopRequireDefault(__webpack_require__(24));

var _CustomScrollbars = _interopRequireDefault(__webpack_require__(27));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Component =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Component, _React$Component);

  _createClass(Component, [{
    key: "__addFavouriteProject__REACT_HOT_LOADER__",
    value: function __addFavouriteProject__REACT_HOT_LOADER__(data) {
      this.props.addFavouriteProject(data);
    }
  }, {
    key: "__onProjectSelect__REACT_HOT_LOADER__",
    value: function __onProjectSelect__REACT_HOT_LOADER__(data) {
      this.props.onProjectSelect(data);
    }
  }, {
    key: "__onAddProject__REACT_HOT_LOADER__",
    value: function __onAddProject__REACT_HOT_LOADER__() {
      this.props.onAddProject();
    }
  }, {
    key: "__onProjectClose__REACT_HOT_LOADER__",
    value: function __onProjectClose__REACT_HOT_LOADER__() {
      this.props.onProjectClose();
    }
  }, {
    key: "__onFilterProjectOptionSelect__REACT_HOT_LOADER__",
    value: function __onFilterProjectOptionSelect__REACT_HOT_LOADER__(option) {
      this.props.onFilterProjectOptionSelect(option);
    }
  }, {
    key: "__onSaveProject__REACT_HOT_LOADER__",
    value: function __onSaveProject__REACT_HOT_LOADER__(data) {
      this.props.onSaveProject(data);
    }
  }, {
    key: "__onDeleteProject__REACT_HOT_LOADER__",
    value: function __onDeleteProject__REACT_HOT_LOADER__(data) {
      this.props.onDeleteProject(data);
    }
  }, {
    key: "__onDeleteSelectedProject__REACT_HOT_LOADER__",
    value: function __onDeleteSelectedProject__REACT_HOT_LOADER__() {
      this.props.onDeleteSelectedProject();
    }
  }, {
    key: "__filterProject__REACT_HOT_LOADER__",
    value: function __filterProject__REACT_HOT_LOADER__(projectName) {
      if (projectName === '') {
        this.onFilterProjectOptionSelect(this.props.filterOption);
      } else {
        this.props.filterProject(projectName);
      }
    }
  }, {
    key: "__handleProjectRequestClose__REACT_HOT_LOADER__",
    value: function __handleProjectRequestClose__REACT_HOT_LOADER__() {
      this.props.handleProjectRequestClose();
    }
  }, {
    key: "__getAllProject__REACT_HOT_LOADER__",
    value: function __getAllProject__REACT_HOT_LOADER__() {
      this.props.getAllProject();
    }
  }, {
    key: "__getUnselectedAllProject__REACT_HOT_LOADER__",
    value: function __getUnselectedAllProject__REACT_HOT_LOADER__() {
      this.props.getUnselectedAllProject();
    }
  }, {
    key: "__onAllProjectSelect__REACT_HOT_LOADER__",
    value: function __onAllProjectSelect__REACT_HOT_LOADER__() {
      var selectAll = this.props.selectedProjects < this.props.projectList.length;

      if (selectAll) {
        this.props.getAllProject();
      } else {
        this.props.getUnselectedAllProject();
      }
    }
  }, {
    key: "__onToggleProjectDrawer__REACT_HOT_LOADER__",
    value: function __onToggleProjectDrawer__REACT_HOT_LOADER__() {
      this.props.onToggleProjectDrawer();
    }
  }, {
    key: "__showProjectLoader__REACT_HOT_LOADER__",
    value: function __showProjectLoader__REACT_HOT_LOADER__() {
      this.props.showProjectLoader();
    }
  }]);

  function Component() {
    var _this;

    _classCallCheck(this, Component);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Component).call(this));

    _defineProperty(_assertThisInitialized(_this), "addFavouriteProject", function () {
      var _this2;

      return (_this2 = _this).__addFavouriteProject__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onProjectSelect", function () {
      var _this3;

      return (_this3 = _this).__onProjectSelect__REACT_HOT_LOADER__.apply(_this3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onAddProject", function () {
      var _this4;

      return (_this4 = _this).__onAddProject__REACT_HOT_LOADER__.apply(_this4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onProjectClose", function () {
      var _this5;

      return (_this5 = _this).__onProjectClose__REACT_HOT_LOADER__.apply(_this5, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onFilterProjectOptionSelect", function () {
      var _this6;

      return (_this6 = _this).__onFilterProjectOptionSelect__REACT_HOT_LOADER__.apply(_this6, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onSaveProject", function () {
      var _this7;

      return (_this7 = _this).__onSaveProject__REACT_HOT_LOADER__.apply(_this7, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onDeleteProject", function () {
      var _this8;

      return (_this8 = _this).__onDeleteProject__REACT_HOT_LOADER__.apply(_this8, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onDeleteSelectedProject", function () {
      var _this9;

      return (_this9 = _this).__onDeleteSelectedProject__REACT_HOT_LOADER__.apply(_this9, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "filterProject", function () {
      var _this10;

      return (_this10 = _this).__filterProject__REACT_HOT_LOADER__.apply(_this10, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "handleProjectRequestClose", function () {
      var _this11;

      return (_this11 = _this).__handleProjectRequestClose__REACT_HOT_LOADER__.apply(_this11, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "getAllProject", function () {
      var _this12;

      return (_this12 = _this).__getAllProject__REACT_HOT_LOADER__.apply(_this12, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "getUnselectedAllProject", function () {
      var _this13;

      return (_this13 = _this).__getUnselectedAllProject__REACT_HOT_LOADER__.apply(_this13, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onAllProjectSelect", function () {
      var _this14;

      return (_this14 = _this).__onAllProjectSelect__REACT_HOT_LOADER__.apply(_this14, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onToggleProjectDrawer", function () {
      var _this15;

      return (_this15 = _this).__onToggleProjectDrawer__REACT_HOT_LOADER__.apply(_this15, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "showProjectLoader", function () {
      var _this16;

      return (_this16 = _this).__showProjectLoader__REACT_HOT_LOADER__.apply(_this16, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onProjectPrioritiesDashboard", function () {
      var _this17;

      return (_this17 = _this).__onProjectPrioritiesDashboard__REACT_HOT_LOADER__.apply(_this17, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onProjectCostPrioritiesDashboard", function () {
      var _this18;

      return (_this18 = _this).__onProjectCostPrioritiesDashboard__REACT_HOT_LOADER__.apply(_this18, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onProjectBusinessPrioritiesDashboard", function () {
      var _this19;

      return (_this19 = _this).__onProjectBusinessPrioritiesDashboard__REACT_HOT_LOADER__.apply(_this19, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onProjectIssuesDashboard", function () {
      var _this20;

      return (_this20 = _this).__onProjectIssuesDashboard__REACT_HOT_LOADER__.apply(_this20, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onGlobalProjectCostPrioritiesDashboard", function () {
      var _this21;

      return (_this21 = _this).__onGlobalProjectCostPrioritiesDashboard__REACT_HOT_LOADER__.apply(_this21, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onGlobalProjectBusinessPrioritiesDashboard", function () {
      var _this22;

      return (_this22 = _this).__onGlobalProjectBusinessPrioritiesDashboard__REACT_HOT_LOADER__.apply(_this22, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "fetchImportProjects", function () {
      var _this23;

      return (_this23 = _this).__fetchImportProjects__REACT_HOT_LOADER__.apply(_this23, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onImportProjects", function () {
      var _this24;

      return (_this24 = _this).__onImportProjects__REACT_HOT_LOADER__.apply(_this24, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "setProject", function () {
      var _this25;

      return (_this25 = _this).__setProject__REACT_HOT_LOADER__.apply(_this25, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "projectSideBar", function () {
      var _this26;

      return (_this26 = _this).__projectSideBar__REACT_HOT_LOADER__.apply(_this26, arguments);
    });

    return _this;
  }

  _createClass(Component, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          selectedOrg = _this$props.selectedOrg,
          showProjectLoader = _this$props.showProjectLoader,
          fetchProjects = _this$props.fetchProjects,
          fetchInitiatives = _this$props.fetchInitiatives;
      showProjectLoader();
      fetchProjects({
        orgid: selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id,
        useCache: true
      });
      fetchInitiatives();
    }
  }, {
    key: "updateSearchProject",
    value: function updateSearchProject(evt) {
      this.props.updateSearchProject(evt.target.value);
      this.props.filterProject(evt.target.value);
    }
  }, {
    key: "__onProjectPrioritiesDashboard__REACT_HOT_LOADER__",
    value: function __onProjectPrioritiesDashboard__REACT_HOT_LOADER__(data) {
      this.props.onProjectPrioritiesDashboard(data);
    }
  }, {
    key: "__onProjectCostPrioritiesDashboard__REACT_HOT_LOADER__",
    value: function __onProjectCostPrioritiesDashboard__REACT_HOT_LOADER__(data) {
      this.props.onProjectCostPrioritiesDashboard(data);
    }
  }, {
    key: "__onProjectBusinessPrioritiesDashboard__REACT_HOT_LOADER__",
    value: function __onProjectBusinessPrioritiesDashboard__REACT_HOT_LOADER__(data) {
      this.props.onProjectBusinessPrioritiesDashboard(data);
    }
  }, {
    key: "__onProjectIssuesDashboard__REACT_HOT_LOADER__",
    value: function __onProjectIssuesDashboard__REACT_HOT_LOADER__(data) {
      this.props.onProjectIssuesDashboard(data);
    }
  }, {
    key: "__onGlobalProjectCostPrioritiesDashboard__REACT_HOT_LOADER__",
    value: function __onGlobalProjectCostPrioritiesDashboard__REACT_HOT_LOADER__() {
      var _selectedProject$cost;

      var projectList = this.props.projectList;
      var selectedProject = (projectList === null || projectList === void 0 ? void 0 : projectList.length) > 0 ? projectList[0] : [];
      var payload = selectedProject && (selectedProject === null || selectedProject === void 0 ? void 0 : (_selectedProject$cost = selectedProject.costImplPriorityParams) === null || _selectedProject$cost === void 0 ? void 0 : _selectedProject$cost.length) > 0 ? selectedProject.costImplPriorityParams : [];
      this.props.onProjectPrioritiesDashboard(selectedProject);
      this.props.onGlobalProjectCostPrioritiesDashboard(payload);

      _store.history.push('/app/projectPriority/default');
    }
  }, {
    key: "__onGlobalProjectBusinessPrioritiesDashboard__REACT_HOT_LOADER__",
    value: function __onGlobalProjectBusinessPrioritiesDashboard__REACT_HOT_LOADER__() {
      var _selectedProject$busV;

      var projectList = this.props.projectList;
      var selectedProject = (projectList === null || projectList === void 0 ? void 0 : projectList.length) > 0 ? projectList[0] : [];
      var payload = selectedProject && (selectedProject === null || selectedProject === void 0 ? void 0 : (_selectedProject$busV = selectedProject.busValPriorityParams) === null || _selectedProject$busV === void 0 ? void 0 : _selectedProject$busV.length) > 0 ? selectedProject.busValPriorityParams : [];
      this.props.onProjectPrioritiesDashboard(selectedProject);
      this.props.onGlobalProjectBusinessPrioritiesDashboard(payload);

      _store.history.push('/app/projectPriority/default');
    }
  }, {
    key: "__fetchImportProjects__REACT_HOT_LOADER__",
    value: function __fetchImportProjects__REACT_HOT_LOADER__(id) {
      this.props.showImportProjectsLoader();
      this.props.fetchImportProjects(id);
    }
  }, {
    key: "__onImportProjects__REACT_HOT_LOADER__",
    value: function __onImportProjects__REACT_HOT_LOADER__() {
      this.props.showProjectLoader();
      this.props.showImportProjectsLoader();
      this.props.onImportProjects();
    }
  }, {
    key: "__setProject__REACT_HOT_LOADER__",
    value: function __setProject__REACT_HOT_LOADER__(id) {
      this.props.setProject(id);
    }
  }, {
    key: "__projectSideBar__REACT_HOT_LOADER__",
    value: function __projectSideBar__REACT_HOT_LOADER__() {
      return _react["default"].createElement("div", {
        className: "module-side"
      }, _react["default"].createElement("div", {
        className: "module-side-header"
      }, _react["default"].createElement("div", {
        className: "module-logo"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-city-alt mr-4"
      }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.projects"
      })))), _react["default"].createElement("div", {
        className: "module-side-content"
      }, _react["default"].createElement(_CustomScrollbars["default"], {
        className: "module-side-scroll scrollbar",
        style: {
          height: this.props.width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)'
        }
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this27 = this;

      var _this$props2 = this.props,
          width = _this$props2.width,
          project = _this$props2.project,
          projectList = _this$props2.projectList,
          addProjectState = _this$props2.addProjectState,
          alertMessage = _this$props2.alertMessage,
          showMessage = _this$props2.showMessage,
          drawerState = _this$props2.drawerState,
          noContentFoundMessage = _this$props2.noContentFoundMessage,
          loader = _this$props2.loader,
          selectedOrg = _this$props2.selectedOrg,
          selectedProject = _this$props2.selectedProject,
          allInitiative = _this$props2.allInitiative;
      return _react["default"].createElement("div", {
        className: "app-wrapper"
      }, _react["default"].createElement("div", {
        className: "app-module animated slideInUpTiny animation-duration-3"
      }, _react["default"].createElement("div", {
        className: "d-block d-xl-none"
      }, _react["default"].createElement(_rcDrawer["default"], {
        touch: true,
        transitions: true,
        enableDragHandle: true,
        open: drawerState,
        onOpenChange: this.onToggleProjectDrawer.bind(this),
        sidebar: this.projectSideBar(project)
      })), _react["default"].createElement("div", {
        className: "app-module-sidenav d-none d-xl-flex"
      }, this.projectSideBar(project)), _react["default"].createElement("div", {
        className: "module-box"
      }, _react["default"].createElement("div", {
        className: "module-box-content"
      }, _react["default"].createElement("div", {
        className: "module-box-header"
      }, _react["default"].createElement("span", {
        className: "icon-btn drawer-btn d-flex d-xl-none",
        onClick: this.onToggleProjectDrawer.bind(this)
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-menu"
      })), _react["default"].createElement("div", {
        className: "d-flex align-items-center justify-content-center",
        style: {
          padding: 10
        }
      }, "NOTE - This dashboard uses data that may be cached for up to 24 hours\xA0\xA0\xA0", _react["default"].createElement(_reactstrap.Button, {
        className: "jr-btn jr-btn-sm btn-primary text-white mb-0",
        color: "primary",
        onClick: function onClick() {
          _this27.props.showProjectLoader();

          _this27.props.fetchProjects({
            orgid: selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id,
            useCache: false
          }); // DONT use the cache

        }
      }, "Refresh Now"))), _react["default"].createElement("div", {
        className: "module-box-topbar"
      }), _react["default"].createElement(_CustomScrollbars["default"], {
        className: "module-list-scroll scrollbar",
        style: {
          height: width >= 1200 ? 'calc(105vh - 265px)' : 'calc(105vh - 245px)'
        }
      }, loader ? _react["default"].createElement("div", {
        className: "loader-view-block h-100"
      }, _react["default"].createElement("div", {
        className: "loader-view"
      }, _react["default"].createElement(_CircularProgress["default"], null))) : projectList && projectList.length > 0 ? _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(_projectList["default"], {
        selected: projectList.findIndex(function (entry) {
          return (entry === null || entry === void 0 ? void 0 : entry.id) === (selectedProject === null || selectedProject === void 0 ? void 0 : selectedProject.id);
        }) || 0,
        data: projectList,
        width: width,
        setProject: this.setProject.bind(this)
      }), _react["default"].createElement("div", {
        style: {
          marginTop: 10
        }
      }, _react["default"].createElement(_projectDetail["default"], {
        projectList: projectList,
        selectedProject: selectedProject,
        width: width,
        setProject: this.setProject.bind(this),
        onProjectPrioritiesDashboard: this.onProjectPrioritiesDashboard.bind(this),
        onProjectCostPrioritiesDashboard: this.onProjectCostPrioritiesDashboard.bind(this),
        onProjectBusinessPrioritiesDashboard: this.onProjectBusinessPrioritiesDashboard.bind(this),
        onProjectIssuesDashboard: this.onProjectIssuesDashboard.bind(this),
        onProjectSelect: this.onProjectSelect.bind(this),
        onDeleteProject: this.onDeleteProject.bind(this),
        onSaveProject: this.onSaveProject.bind(this),
        showProjectLoader: this.showProjectLoader.bind(this),
        initiatives: allInitiative
      }))) : _react["default"].createElement("div", {
        className: "h-100 d-flex align-items-center justify-content-center"
      }, noContentFoundMessage))))), _react["default"].createElement(_projectAdd["default"], {
        open: addProjectState,
        project: {
          'id': '',
          'orgid': '',
          'name': '',
          'description': '',
          'startDate': '',
          'endDate': '',
          'weight': 0,
          'jiraProjectAttributes': {},
          'costImplPriorityParams': [],
          'busValPriorityParams': [],
          'budget': 0,
          'initiative': '',
          'businessValue': '',
          'thumb': null,
          'starred': false,
          'selected': false,
          'frequently': false
        },
        onSaveProject: this.onSaveProject,
        onProjectClose: this.onProjectClose,
        onDeleteProject: this.onDeleteProject,
        showProjectLoader: this.showProjectLoader,
        initiatives: allInitiative
      }), showMessage && _reactNotifications.NotificationManager.success(alertMessage, this.handleProjectRequestClose()), _react["default"].createElement(_reactNotifications.NotificationContainer, null));
    }
  }]);

  return Component;
}(_react["default"].Component);

exports.Component = Component;
var _default = Component;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/component.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/component.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/component.js");

  __REACT_HOT_LOADER__.register(_rcDrawer, "_rcDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/component.js");

  __REACT_HOT_LOADER__.register(_projectList, "_projectList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/component.js");

  __REACT_HOT_LOADER__.register(_projectDetail, "_projectDetail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/component.js");

  __REACT_HOT_LOADER__.register(_projectAdd, "_projectAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/component.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/component.js");

  __REACT_HOT_LOADER__.register(_CircularProgress, "_CircularProgress", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/component.js");

  __REACT_HOT_LOADER__.register(_CustomScrollbars, "_CustomScrollbars", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/component.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/component.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/component.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/component.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/component.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/component.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/component.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/component.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/component.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/component.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/component.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/component.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/component.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/component.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/component.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/component.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/component.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/component.js");
}();

;

/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _projectTable = _interopRequireDefault(__webpack_require__(1881));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ProjectList = function ProjectList(_ref) {
  var data = _ref.data,
      width = _ref.width,
      setProject = _ref.setProject,
      selected = _ref.selected;
  return _react["default"].createElement("div", {
    className: "app-main-content"
  }, _react["default"].createElement(_projectTable["default"], {
    selected: selected,
    data: data,
    width: width,
    setProject: setProject
  }));
};

var _default = ProjectList;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProjectList, "ProjectList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectList/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectList/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectList/index.js");

  __REACT_HOT_LOADER__.register(_projectTable, "_projectTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectList/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectList/index.js");

  __REACT_HOT_LOADER__.register(ProjectList, "ProjectList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectList/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectList/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectList/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectList/index.js");
}();

;

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _matchSorter = _interopRequireDefault(__webpack_require__(95));

var _reactTable = _interopRequireDefault(__webpack_require__(93));

__webpack_require__(94);

var _DateFormatters = __webpack_require__(43);

var _System = __webpack_require__(55);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var ProjectTable =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ProjectTable, _React$Component);

  function ProjectTable(props) {
    var _this;

    _classCallCheck(this, ProjectTable);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProjectTable).call(this, props));
    var selected = props.selected;
    _this.state = {
      selected: selected
    };
    return _this;
  }

  _createClass(ProjectTable, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          data = _this$props.data,
          width = _this$props.width,
          setProject = _this$props.setProject;
      var defaultWidth = width > _System.TIGHT_FIT_PARAM ? 150 : 80; // const smallWidth = width > TIGHT_FIT_PARAM ? 30 : 30; // TODO see how this works

      var styledSummaryColumn = function styledSummaryColumn(value) {
        return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("span", {
          className: "d-inline-block text-black"
        }, _react["default"].createElement("div", {
          className: "font-weight-bold"
        }, value)));
      };

      var weightColumn = {
        Header: 'Weight',
        id: 'weight',
        accessor: function accessor(d) {
          return (d === null || d === void 0 ? void 0 : d.weight) || 0;
        },
        filterMethod: function filterMethod(filter, rows) {
          return (0, _matchSorter["default"])(rows, filter.value, {
            keys: ['weight']
          });
        },
        filterAll: true,
        width: 50
      };
      var summaryColumn = {
        Header: 'Name',
        id: 'name',
        accessor: function accessor(d) {
          return d === null || d === void 0 ? void 0 : d.name;
        },
        filterMethod: function filterMethod(filter, rows) {
          return (0, _matchSorter["default"])(rows, filter.value, {
            keys: ['name']
          });
        },
        Cell: function Cell(_ref) {
          var value = _ref.value;
          return styledSummaryColumn(value);
        },
        filterAll: true
      };
      var createdColumn = {
        Header: 'Start Date',
        id: 'startDate',
        accessor: function accessor(d) {
          return d === null || d === void 0 ? void 0 : d.startDate;
        },
        filterMethod: function filterMethod(filter, rows) {
          return (0, _matchSorter["default"])(rows, filter.value, {
            keys: ['startDate']
          });
        },
        filterAll: true,
        Cell: function Cell(_ref2) {
          var value = _ref2.value;
          return (0, _DateFormatters.formatDateDefault)(value);
        },
        width: defaultWidth
      };
      var resolvedColumn = {
        Header: 'End Date',
        id: 'endDate',
        accessor: function accessor(d) {
          return d === null || d === void 0 ? void 0 : d.endDate;
        },
        filterMethod: function filterMethod(filter, rows) {
          return (0, _matchSorter["default"])(rows, filter.value, {
            keys: ['endDate']
          });
        },
        filterAll: true,
        Cell: function Cell(_ref3) {
          var value = _ref3.value;
          return (0, _DateFormatters.formatDateDefault)(value);
        },
        width: defaultWidth
      };
      var columnsList = new Array();
      columnsList.push(summaryColumn);
      columnsList.push(weightColumn);
      columnsList.push(createdColumn);
      columnsList.push(resolvedColumn);
      return _react["default"].createElement("div", null, _react["default"].createElement(_reactTable["default"], {
        data: data,
        filterable: true,
        defaultFilterMethod: function defaultFilterMethod(filter, row) {
          return String(row[filter.id]) === filter.value;
        },
        columns: [{
          columns: columnsList
        }],
        defaultPageSize: (data === null || data === void 0 ? void 0 : data.length) <= 5 ? 5 : 10,
        className: "-highlight",
        getTrProps: function getTrProps(state, rowInfo) {
          if (rowInfo && rowInfo.row) {
            return {
              onClick: function onClick() {
                var _rowInfo$original;

                console.log(JSON.stringify(rowInfo === null || rowInfo === void 0 ? void 0 : rowInfo.index));
                setProject(rowInfo === null || rowInfo === void 0 ? void 0 : (_rowInfo$original = rowInfo.original) === null || _rowInfo$original === void 0 ? void 0 : _rowInfo$original.id);

                _this2.setState({
                  selected: rowInfo.index
                });
              },
              style: {
                background: rowInfo.index === _this2.state.selected ? '#cfd8dc' : 'white',
                color: rowInfo.index === _this2.state.selected ? 'black' : 'black'
              }
            };
          } else {
            return {};
          }
        }
      }));
    }
  }]);

  return ProjectTable;
}(_react["default"].Component);

var _default = ProjectTable;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProjectTable, "ProjectTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectList/projectTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectList/projectTable/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectList/projectTable/index.js");

  __REACT_HOT_LOADER__.register(_matchSorter, "_matchSorter", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectList/projectTable/index.js");

  __REACT_HOT_LOADER__.register(_reactTable, "_reactTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectList/projectTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectList/projectTable/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectList/projectTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectList/projectTable/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectList/projectTable/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectList/projectTable/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectList/projectTable/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectList/projectTable/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectList/projectTable/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectList/projectTable/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectList/projectTable/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectList/projectTable/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectList/projectTable/index.js");

  __REACT_HOT_LOADER__.register(ProjectTable, "ProjectTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectList/projectTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectList/projectTable/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectList/projectTable/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectList/projectTable/index.js");
}();

;

/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _store = __webpack_require__(54);

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _index = _interopRequireDefault(__webpack_require__(813));

var _projectDetailTable = _interopRequireDefault(__webpack_require__(1883));

var _projectPriorities = _interopRequireDefault(__webpack_require__(1884));

var _projectService = __webpack_require__(175);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ProjectDetail =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ProjectDetail, _React$Component);

  function ProjectDetail() {
    var _this;

    _classCallCheck(this, ProjectDetail);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProjectDetail).call(this));

    _defineProperty(_assertThisInitialized(_this), "onProjectClose", function () {
      var _this2;

      return (_this2 = _this).__onProjectClose__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onDeleteProject", function () {
      var _this3;

      return (_this3 = _this).__onDeleteProject__REACT_HOT_LOADER__.apply(_this3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onEditProject", function () {
      var _this4;

      return (_this4 = _this).__onEditProject__REACT_HOT_LOADER__.apply(_this4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onProjectCostPrioritiesDashboard", function () {
      var _this5;

      return (_this5 = _this).__onProjectCostPrioritiesDashboard__REACT_HOT_LOADER__.apply(_this5, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onProjectBusinessPrioritiesDashboard", function () {
      var _this6;

      return (_this6 = _this).__onProjectBusinessPrioritiesDashboard__REACT_HOT_LOADER__.apply(_this6, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onProjectIssuesDashboard", function () {
      var _this7;

      return (_this7 = _this).__onProjectIssuesDashboard__REACT_HOT_LOADER__.apply(_this7, arguments);
    });

    _this.state = {
      addProjectState: false
    };
    return _this;
  }

  _createClass(ProjectDetail, [{
    key: "__onProjectClose__REACT_HOT_LOADER__",
    value: function __onProjectClose__REACT_HOT_LOADER__() {
      this.setState({
        addProjectState: false
      });
    }
  }, {
    key: "__onDeleteProject__REACT_HOT_LOADER__",
    value: function __onDeleteProject__REACT_HOT_LOADER__(project) {
      this.setState({
        addProjectState: false
      });
      this.props.onDeleteProject(project);
    }
  }, {
    key: "__onEditProject__REACT_HOT_LOADER__",
    value: function __onEditProject__REACT_HOT_LOADER__() {
      this.setState({
        addProjectState: true
      });
    }
  }, {
    key: "__onProjectCostPrioritiesDashboard__REACT_HOT_LOADER__",
    value: function __onProjectCostPrioritiesDashboard__REACT_HOT_LOADER__(project) {
      this.setState({
        addProjectState: false
      });
      this.props.onProjectPrioritiesDashboard(project);
      this.props.onProjectCostPrioritiesDashboard(project);

      _store.history.push('/app/projectPriority/default');
    }
  }, {
    key: "__onProjectBusinessPrioritiesDashboard__REACT_HOT_LOADER__",
    value: function __onProjectBusinessPrioritiesDashboard__REACT_HOT_LOADER__(project) {
      this.setState({
        addProjectState: false
      });
      this.props.onProjectPrioritiesDashboard(project);
      this.props.onProjectBusinessPrioritiesDashboard(project);

      _store.history.push('/app/projectPriority/default');
    }
  }, {
    key: "__onProjectIssuesDashboard__REACT_HOT_LOADER__",
    value: function __onProjectIssuesDashboard__REACT_HOT_LOADER__(project) {
      this.setState({
        addProjectState: false
      });
      this.props.onProjectIssuesDashboard(project);

      _store.history.push('/app/projectIssue/default');
    }
  }, {
    key: "render",
    value: function render() {
      var _this8 = this;

      var _this$props = this.props,
          selectedProject = _this$props.selectedProject,
          onSaveProject = _this$props.onSaveProject,
          showProjectLoader = _this$props.showProjectLoader,
          initiatives = _this$props.initiatives;
      var addProjectState = this.state.addProjectState;

      if (selectedProject) {
        var displayData = (0, _projectService.getProjectDisplayData)(selectedProject);
        return _react["default"].createElement("div", {
          className: "dashboard animated slideInUpTiny animation-duration-3"
        }, _react["default"].createElement("div", {
          className: "row"
        }, _react["default"].createElement("div", {
          className: "col-md-6 col-12"
        }, _react["default"].createElement("div", {
          className: "jr-card jr-card-full-height"
        }, _react["default"].createElement("div", {
          className: "jr-card-header d-flex"
        }, _react["default"].createElement("div", {
          className: "mr-auto"
        }, _react["default"].createElement("h2", {
          className: "card-heading"
        }, displayData === null || displayData === void 0 ? void 0 : displayData.summary)), _react["default"].createElement("div", null, _react["default"].createElement(_reactstrap.Button, {
          size: "sm",
          color: "primary",
          onClick: function onClick() {
            return _this8.onEditProject();
          }
        }, _react["default"].createElement("i", {
          className: "zmdi zmdi-edit zmdi-hc-fw"
        }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
          id: "label.edit"
        }))), _react["default"].createElement(_reactstrap.Button, {
          size: "sm",
          color: "secondary",
          onClick: function onClick() {
            return _this8.onProjectCostPrioritiesDashboard(selectedProject);
          }
        }, _react["default"].createElement("i", {
          className: "zmdi zmdi-trending-up zmdi-hc-fw"
        }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
          id: "project.updateProjectCostPriorities"
        }))), _react["default"].createElement(_reactstrap.Button, {
          size: "sm",
          color: "secondary",
          onClick: function onClick() {
            return _this8.onProjectBusinessPrioritiesDashboard(selectedProject);
          }
        }, _react["default"].createElement("i", {
          className: "zmdi zmdi-trending-up zmdi-hc-fw"
        }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
          id: "project.updateProjectBusinessPriorities"
        }))), _react["default"].createElement(_reactstrap.Button, {
          size: "sm",
          color: "secondary",
          onClick: function onClick() {
            return _this8.onProjectIssuesDashboard(selectedProject);
          }
        }, _react["default"].createElement("i", {
          className: "zmdi zmdi-trending-up zmdi-hc-fw"
        }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
          id: "project.projectIssues"
        }))))), _react["default"].createElement("div", {
          className: "jr-card-body"
        }, _react["default"].createElement("div", {
          className: "row"
        }, _react["default"].createElement("div", {
          className: "col-sm-3"
        }, _react["default"].createElement("div", {
          className: "temp-section mb-4 mb-sm-0 text-center text-sm-left"
        }, _react["default"].createElement("p", null, _react["default"].createElement("i", {
          className: "detail-icon text-blue-grey zmdi zmdi-collection-plus zmdi-hc-fw"
        })), (displayData === null || displayData === void 0 ? void 0 : displayData.weight) ? _react["default"].createElement("h2", {
          className: "temp-point"
        }, displayData === null || displayData === void 0 ? void 0 : displayData.weight) : null)), _react["default"].createElement("div", {
          className: "col-sm-9 text-center text-sm-left"
        }, _react["default"].createElement(_projectDetailTable["default"], {
          displayData: displayData
        })))))), _react["default"].createElement("div", {
          className: "col-md-3"
        }, _react["default"].createElement("div", {
          className: "jr-card jr-card-full-height"
        }, _react["default"].createElement(_projectPriorities["default"], {
          priorities: selectedProject === null || selectedProject === void 0 ? void 0 : selectedProject.busValPriorityParams,
          title: _react["default"].createElement(_IntlMessages["default"], {
            id: "project.busValuePriorities"
          })
        }))), _react["default"].createElement("div", {
          className: "col-md-3"
        }, _react["default"].createElement("div", {
          className: "jr-card jr-card-full-height"
        }, _react["default"].createElement(_projectPriorities["default"], {
          priorities: selectedProject === null || selectedProject === void 0 ? void 0 : selectedProject.costImplPriorityParams,
          title: _react["default"].createElement(_IntlMessages["default"], {
            id: "project.costImplPriorities"
          })
        })))), _react["default"].createElement("div", null, addProjectState && _react["default"].createElement(_index["default"], {
          open: addProjectState,
          project: selectedProject,
          onSaveProject: onSaveProject,
          onProjectClose: this.onProjectClose,
          onDeleteProject: this.onDeleteProject,
          showProjectLoader: showProjectLoader,
          initiatives: initiatives
        })));
      } else {
        return _react["default"].createElement("div", {
          className: "dashboard animated slideInUpTiny animation-duration-3"
        }, _react["default"].createElement("div", {
          className: "row"
        }, _react["default"].createElement("div", {
          className: "col-md-12 col-12"
        }, _react["default"].createElement("div", {
          className: "jr-card jr-card-full-height"
        }, _react["default"].createElement("div", {
          className: "jr-card-header d-flex"
        }, _react["default"].createElement("div", {
          className: "mr-auto"
        }, _react["default"].createElement("h3", {
          className: "card-heading"
        }, "Please select a project to display details")))))));
      }
    }
  }]);

  return ProjectDetail;
}(_react["default"].Component);

var _default = ProjectDetail;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProjectDetail, "ProjectDetail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/index.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/index.js");

  __REACT_HOT_LOADER__.register(_projectDetailTable, "_projectDetailTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/index.js");

  __REACT_HOT_LOADER__.register(_projectPriorities, "_projectPriorities", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/index.js");

  __REACT_HOT_LOADER__.register(ProjectDetail, "ProjectDetail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/index.js");
}();

;

/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _projectDetailRow = _interopRequireDefault(__webpack_require__(814));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var ProjectDetailTable = function ProjectDetailTable(_ref) {
  var displayData = _ref.displayData;

  if (displayData) {
    return _react["default"].createElement("table", {
      className: "default-table table table-sm table-responsive-sm table-hover"
    }, _react["default"].createElement("tbody", null, _react["default"].createElement(_projectDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "project.projectDescription"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.description
    }), _react["default"].createElement(_projectDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "project.projectWeight"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.weight
    }), _react["default"].createElement(_projectDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.startDate"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.startDate
    }), _react["default"].createElement(_projectDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.endDate"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.endDate
    }), _react["default"].createElement(_projectDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "project.projectBudget"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.budget
    }), _react["default"].createElement(_projectDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "project.projectBusinessValueIndicator"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.businessValue
    })));
  } else {
    return _react["default"].createElement(_react.Fragment, null);
  }
};

var _default = ProjectDetailTable;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProjectDetailTable, "ProjectDetailTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectDetailTable/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_projectDetailRow, "_projectDetailRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectDetailTable/index.js");

  __REACT_HOT_LOADER__.register(ProjectDetailTable, "ProjectDetailTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectDetailTable/index.js");
}();

;

/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _ContainerHeader = _interopRequireDefault(__webpack_require__(63));

var _projectPrioritiesTable = _interopRequireDefault(__webpack_require__(1885));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var ProjectPriorities = function ProjectPriorities(_ref) {
  var priorities = _ref.priorities,
      title = _ref.title;

  if (priorities && Array.isArray(priorities) && priorities.length > 0) {
    return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(_ContainerHeader["default"], {
      title: title
    }), _react["default"].createElement("div", {
      className: "row"
    }, _react["default"].createElement("div", {
      className: "col-md-12 col-sm-12 col-12"
    }, _react["default"].createElement("div", {
      className: "col-sm-12 text-center text-sm-left"
    }, _react["default"].createElement(_projectPrioritiesTable["default"], {
      priorities: priorities
    })))));
  } else {
    return _react["default"].createElement("div", {
      className: "row"
    }, _react["default"].createElement("div", {
      className: "col-md-12 col-12"
    }, _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(_ContainerHeader["default"], {
      title: title
    }), _react["default"].createElement("div", {
      className: "mr-auto"
    }, _react["default"].createElement("h3", {
      className: "card-heading"
    }, "No priorities found here")))));
  }
};

var _default = ProjectPriorities;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProjectPriorities, "ProjectPriorities", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectPriorities/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectPriorities/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectPriorities/index.js");

  __REACT_HOT_LOADER__.register(_ContainerHeader, "_ContainerHeader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectPriorities/index.js");

  __REACT_HOT_LOADER__.register(_projectPrioritiesTable, "_projectPrioritiesTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectPriorities/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectPriorities/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectPriorities/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectPriorities/index.js");

  __REACT_HOT_LOADER__.register(ProjectPriorities, "ProjectPriorities", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectPriorities/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectPriorities/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectPriorities/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectPriorities/index.js");
}();

;

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _projectDetailRow = _interopRequireDefault(__webpack_require__(814));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var ProjectPrioritiesTable = function ProjectPrioritiesTable(_ref) {
  var priorities = _ref.priorities;

  if (priorities && Array.isArray(priorities) && priorities.length > 0) {
    return _react["default"].createElement("table", {
      className: "default-table table table-sm table-responsive-sm table-hover"
    }, _react["default"].createElement("tbody", null, priorities.map(function (priority, index) {
      return _react["default"].createElement(_projectDetailRow["default"], {
        key: index,
        label: priority === null || priority === void 0 ? void 0 : priority.name,
        description: priority === null || priority === void 0 ? void 0 : priority.value
      });
    })));
  } else {
    return _react["default"].createElement(_react.Fragment, null);
  }
};

var _default = ProjectPrioritiesTable;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProjectPrioritiesTable, "ProjectPrioritiesTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectPrioritiesTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectPrioritiesTable/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectPrioritiesTable/index.js");

  __REACT_HOT_LOADER__.register(_projectDetailRow, "_projectDetailRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectPrioritiesTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectPrioritiesTable/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectPrioritiesTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectPrioritiesTable/index.js");

  __REACT_HOT_LOADER__.register(ProjectPrioritiesTable, "ProjectPrioritiesTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectPrioritiesTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectPrioritiesTable/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectPrioritiesTable/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/project/projectDetail/projectPrioritiesTable/index.js");
}();

;

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _container["default"];
  }
});

var _container = _interopRequireDefault(__webpack_require__(1887));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_container, "_container", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/index.js");
}();

;

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.mapStateToProps = void 0;

var _reactRedux = __webpack_require__(10);

var _projectPriority = __webpack_require__(364);

var _project = __webpack_require__(179);

var _component = _interopRequireDefault(__webpack_require__(1888));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var mapStateToProps = function mapStateToProps(_ref) {
  var projects = _ref.projects,
      projectPrioritys = _ref.projectPrioritys,
      settings = _ref.settings;
  var width = settings.width;
  var loader = projectPrioritys.loader,
      alertMessage = projectPrioritys.alertMessage,
      showMessage = projectPrioritys.showMessage,
      noContentFoundMessage = projectPrioritys.noContentFoundMessage,
      selectedSectionId = projectPrioritys.selectedSectionId,
      drawerState = projectPrioritys.drawerState,
      projectPriority = projectPrioritys.projectPriority,
      searchProjectPriority = projectPrioritys.searchProjectPriority,
      filterOption = projectPrioritys.filterOption,
      allProjectPriority = projectPrioritys.allProjectPriority,
      projectPriorityList = projectPrioritys.projectPriorityList,
      selectedProjectPriority = projectPrioritys.selectedProjectPriority,
      selectedProjectPrioritys = projectPrioritys.selectedProjectPrioritys,
      addProjectPriorityState = projectPrioritys.addProjectPriorityState,
      updatingGlobalPriorities = projectPrioritys.updatingGlobalPriorities,
      updatingProjectCostPriorities = projectPrioritys.updatingProjectCostPriorities,
      updatingProjectBusinessPriorities = projectPrioritys.updatingProjectBusinessPriorities;
  var projectList = projects.projectList;
  return {
    width: width,
    loader: loader,
    alertMessage: alertMessage,
    showMessage: showMessage,
    noContentFoundMessage: noContentFoundMessage,
    selectedSectionId: selectedSectionId,
    drawerState: drawerState,
    projectPriority: projectPriority,
    searchProjectPriority: searchProjectPriority,
    filterOption: filterOption,
    allProjectPriority: allProjectPriority,
    projectPriorityList: projectPriorityList,
    selectedProjectPriority: selectedProjectPriority,
    selectedProjectPrioritys: selectedProjectPrioritys,
    addProjectPriorityState: addProjectPriorityState,
    updatingGlobalPriorities: updatingGlobalPriorities,
    projectList: projectList,
    updatingProjectCostPriorities: updatingProjectCostPriorities,
    updatingProjectBusinessPriorities: updatingProjectBusinessPriorities
  };
};

exports.mapStateToProps = mapStateToProps;

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  fetchProjectPrioritys: _projectPriority.fetchProjectPrioritys,
  addFavouriteProjectPriority: _projectPriority.addFavouriteProjectPriority,
  onProjectPrioritySelect: _projectPriority.onProjectPrioritySelect,
  onAddProjectPriority: _projectPriority.onAddProjectPriority,
  onProjectPriorityClose: _projectPriority.onProjectPriorityClose,
  onFilterProjectPriorityOptionSelect: _projectPriority.onFilterProjectPriorityOptionSelect,
  onSaveProjectPriority: _projectPriority.onSaveProjectPriority,
  onDeleteProjectPriority: _projectPriority.onDeleteProjectPriority,
  onDeleteSelectedProjectPriority: _projectPriority.onDeleteSelectedProjectPriority,
  filterProjectPriority: _projectPriority.filterProjectPriority,
  getAllProjectPriority: _projectPriority.getAllProjectPriority,
  getUnselectedAllProjectPriority: _projectPriority.getUnselectedAllProjectPriority,
  onAllProjectPrioritySelect: _projectPriority.onAllProjectPrioritySelect,
  updateSearchProjectPriority: _projectPriority.updateSearchProjectPriority,
  onToggleProjectPriorityDrawer: _projectPriority.onToggleProjectPriorityDrawer,
  handleProjectPriorityRequestClose: _projectPriority.handleProjectPriorityRequestClose,
  hideProjectPriorityLoader: _projectPriority.hideProjectPriorityLoader,
  showProjectPriorityLoader: _projectPriority.showProjectPriorityLoader,
  showProjectLoader: _project.showProjectLoader,
  onSaveProject: _project.onSaveProject,
  onUpdateProjectPriorities: _projectPriority.onUpdateProjectPriorities
})(_component["default"]);

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/container.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/container.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_component, "_component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/container.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/container.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/container.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/container.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/container.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/container.js");
}();

;

/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Component = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _rcDrawer = _interopRequireDefault(__webpack_require__(31));

var _reactNotifications = __webpack_require__(30);

var _reactstrap = __webpack_require__(6);

var _store = __webpack_require__(54);

var _projectPriorityList = _interopRequireDefault(__webpack_require__(1889));

var _index = _interopRequireDefault(__webpack_require__(66));

var _projectPriorityAdd = _interopRequireDefault(__webpack_require__(815));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _CircularProgress = _interopRequireDefault(__webpack_require__(24));

var _CustomScrollbars = _interopRequireDefault(__webpack_require__(27));

var _project = __webpack_require__(171);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Component =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Component, _React$Component);

  _createClass(Component, [{
    key: "__addFavouriteProjectPriority__REACT_HOT_LOADER__",
    value: function __addFavouriteProjectPriority__REACT_HOT_LOADER__(data) {
      this.props.addFavouriteProjectPriority(data);
    }
  }, {
    key: "__onProjectPrioritySelect__REACT_HOT_LOADER__",
    value: function __onProjectPrioritySelect__REACT_HOT_LOADER__(data) {
      this.props.onProjectPrioritySelect(data);
    }
  }, {
    key: "__onAddProjectPriority__REACT_HOT_LOADER__",
    value: function __onAddProjectPriority__REACT_HOT_LOADER__() {
      this.props.onAddProjectPriority();
    }
  }, {
    key: "__onProjectPriorityClose__REACT_HOT_LOADER__",
    value: function __onProjectPriorityClose__REACT_HOT_LOADER__() {
      this.props.onProjectPriorityClose();
    }
  }, {
    key: "__onFilterProjectPriorityOptionSelect__REACT_HOT_LOADER__",
    value: function __onFilterProjectPriorityOptionSelect__REACT_HOT_LOADER__(option) {
      this.props.onFilterProjectPriorityOptionSelect(option);
    }
  }, {
    key: "__onSaveProjectPriority__REACT_HOT_LOADER__",
    value: function __onSaveProjectPriority__REACT_HOT_LOADER__(data) {
      this.props.onSaveProjectPriority(data);
    }
  }, {
    key: "__onDeleteProjectPriority__REACT_HOT_LOADER__",
    value: function __onDeleteProjectPriority__REACT_HOT_LOADER__(data) {
      this.props.onDeleteProjectPriority(data);
    }
  }, {
    key: "__onDeleteSelectedProjectPriority__REACT_HOT_LOADER__",
    value: function __onDeleteSelectedProjectPriority__REACT_HOT_LOADER__() {
      this.props.onDeleteSelectedProjectPriority();
    }
  }, {
    key: "__filterProjectPriority__REACT_HOT_LOADER__",
    value: function __filterProjectPriority__REACT_HOT_LOADER__(projectPriorityName) {
      if (projectPriorityName === '') {
        this.onFilterProjectPriorityOptionSelect(this.props.filterOption);
      } else {
        this.props.filterProjectPriority(projectPriorityName);
      }
    }
  }, {
    key: "__handleProjectPriorityRequestClose__REACT_HOT_LOADER__",
    value: function __handleProjectPriorityRequestClose__REACT_HOT_LOADER__() {
      this.props.handleProjectPriorityRequestClose();
    }
  }, {
    key: "__getAllProjectPriority__REACT_HOT_LOADER__",
    value: function __getAllProjectPriority__REACT_HOT_LOADER__() {
      this.props.getAllProjectPriority();
    }
  }, {
    key: "__getUnselectedAllProjectPriority__REACT_HOT_LOADER__",
    value: function __getUnselectedAllProjectPriority__REACT_HOT_LOADER__() {
      this.props.getUnselectedAllProjectPriority();
    }
  }, {
    key: "__onAllProjectPrioritySelect__REACT_HOT_LOADER__",
    value: function __onAllProjectPrioritySelect__REACT_HOT_LOADER__() {
      var selectAll = this.props.selectedProjectPrioritys < this.props.projectPriorityList.length;

      if (selectAll) {
        this.props.getAllProjectPriority();
      } else {
        this.props.getUnselectedAllProjectPriority();
      }
    }
  }, {
    key: "__onToggleProjectPriorityDrawer__REACT_HOT_LOADER__",
    value: function __onToggleProjectPriorityDrawer__REACT_HOT_LOADER__() {
      this.props.onToggleProjectPriorityDrawer();
    }
  }, {
    key: "__showProjectPriorityLoader__REACT_HOT_LOADER__",
    value: function __showProjectPriorityLoader__REACT_HOT_LOADER__() {
      this.props.showProjectPriorityLoader();
    }
  }, {
    key: "__onProjectDashboard__REACT_HOT_LOADER__",
    value: function __onProjectDashboard__REACT_HOT_LOADER__() {
      _store.history.push('/app/project/default');
    }
  }, {
    key: "__onSaveProject__REACT_HOT_LOADER__",
    value: function __onSaveProject__REACT_HOT_LOADER__(data) {
      this.props.onSaveProject(data);
    }
  }, {
    key: "__showProjectLoader__REACT_HOT_LOADER__",
    value: function __showProjectLoader__REACT_HOT_LOADER__() {
      this.props.showProjectLoader();
    }
  }, {
    key: "__onUpdateProjectPriorities__REACT_HOT_LOADER__",
    value: function __onUpdateProjectPriorities__REACT_HOT_LOADER__(data) {
      this.props.onUpdateProjectPriorities(data);
    }
  }]);

  function Component() {
    var _this;

    _classCallCheck(this, Component);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Component).call(this));

    _defineProperty(_assertThisInitialized(_this), "addFavouriteProjectPriority", function () {
      var _this2;

      return (_this2 = _this).__addFavouriteProjectPriority__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onProjectPrioritySelect", function () {
      var _this3;

      return (_this3 = _this).__onProjectPrioritySelect__REACT_HOT_LOADER__.apply(_this3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onAddProjectPriority", function () {
      var _this4;

      return (_this4 = _this).__onAddProjectPriority__REACT_HOT_LOADER__.apply(_this4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onProjectPriorityClose", function () {
      var _this5;

      return (_this5 = _this).__onProjectPriorityClose__REACT_HOT_LOADER__.apply(_this5, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onFilterProjectPriorityOptionSelect", function () {
      var _this6;

      return (_this6 = _this).__onFilterProjectPriorityOptionSelect__REACT_HOT_LOADER__.apply(_this6, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onSaveProjectPriority", function () {
      var _this7;

      return (_this7 = _this).__onSaveProjectPriority__REACT_HOT_LOADER__.apply(_this7, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onDeleteProjectPriority", function () {
      var _this8;

      return (_this8 = _this).__onDeleteProjectPriority__REACT_HOT_LOADER__.apply(_this8, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onDeleteSelectedProjectPriority", function () {
      var _this9;

      return (_this9 = _this).__onDeleteSelectedProjectPriority__REACT_HOT_LOADER__.apply(_this9, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "filterProjectPriority", function () {
      var _this10;

      return (_this10 = _this).__filterProjectPriority__REACT_HOT_LOADER__.apply(_this10, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "handleProjectPriorityRequestClose", function () {
      var _this11;

      return (_this11 = _this).__handleProjectPriorityRequestClose__REACT_HOT_LOADER__.apply(_this11, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "getAllProjectPriority", function () {
      var _this12;

      return (_this12 = _this).__getAllProjectPriority__REACT_HOT_LOADER__.apply(_this12, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "getUnselectedAllProjectPriority", function () {
      var _this13;

      return (_this13 = _this).__getUnselectedAllProjectPriority__REACT_HOT_LOADER__.apply(_this13, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onAllProjectPrioritySelect", function () {
      var _this14;

      return (_this14 = _this).__onAllProjectPrioritySelect__REACT_HOT_LOADER__.apply(_this14, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onToggleProjectPriorityDrawer", function () {
      var _this15;

      return (_this15 = _this).__onToggleProjectPriorityDrawer__REACT_HOT_LOADER__.apply(_this15, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "showProjectPriorityLoader", function () {
      var _this16;

      return (_this16 = _this).__showProjectPriorityLoader__REACT_HOT_LOADER__.apply(_this16, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onProjectDashboard", function () {
      var _this17;

      return (_this17 = _this).__onProjectDashboard__REACT_HOT_LOADER__.apply(_this17, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onSaveProject", function () {
      var _this18;

      return (_this18 = _this).__onSaveProject__REACT_HOT_LOADER__.apply(_this18, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "showProjectLoader", function () {
      var _this19;

      return (_this19 = _this).__showProjectLoader__REACT_HOT_LOADER__.apply(_this19, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onUpdateProjectPriorities", function () {
      var _this20;

      return (_this20 = _this).__onUpdateProjectPriorities__REACT_HOT_LOADER__.apply(_this20, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "projectPrioritySideBar", function () {
      var _this21;

      return (_this21 = _this).__projectPrioritySideBar__REACT_HOT_LOADER__.apply(_this21, arguments);
    });

    return _this;
  } // componentDidUpdate(prevProps) {
  //     const { projectPriorityList } = this.props;
  //     if (projectPriorityList !== prevProps.projectPriorityList) {
  //         this.props.fetchProjectPrioritys();
  //     }
  // }


  _createClass(Component, [{
    key: "updateSearchProjectPriority",
    value: function updateSearchProjectPriority(evt) {
      this.props.updateSearchProjectPriority(evt.target.value);
      this.props.filterProjectPriority(evt.target.value);
    }
  }, {
    key: "__projectPrioritySideBar__REACT_HOT_LOADER__",
    value: function __projectPrioritySideBar__REACT_HOT_LOADER__() {
      var _this$props = this.props,
          projectPriorityList = _this$props.projectPriorityList,
          updatingGlobalPriorities = _this$props.updatingGlobalPriorities;
      return _react["default"].createElement("div", {
        className: "module-side"
      }, _react["default"].createElement("div", {
        className: "module-side-header"
      }, _react["default"].createElement("div", {
        className: "module-logo"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-city-alt mr-4"
      }), _react["default"].createElement("span", null, updatingGlobalPriorities ? _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.globalProjectPriorities"
      }) : _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.projectPriorities"
      })))), _react["default"].createElement("div", {
        className: "module-side-content"
      }, _react["default"].createElement(_CustomScrollbars["default"], {
        className: "module-side-scroll scrollbar",
        style: {
          height: this.props.width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)'
        }
      }, updatingGlobalPriorities ? _react["default"].createElement("div", {
        className: "module-add-task"
      }, _react["default"].createElement("div", null, _react["default"].createElement(_reactstrap.Button, {
        className: "btn-block jr-btn",
        color: "primary",
        onClick: this.onAddProjectPriority,
        disabled: (projectPriorityList === null || projectPriorityList === void 0 ? void 0 : projectPriorityList.length) >= _project.MAX_PROJECT_PRIORITIES
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-plus-circle-o zmdi-hc-fw"
      }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "projectPriority.addProjectPriority"
      }))))) : null)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          width = _this$props2.width,
          projectPriority = _this$props2.projectPriority,
          projectPriorityList = _this$props2.projectPriorityList,
          addProjectPriorityState = _this$props2.addProjectPriorityState,
          alertMessage = _this$props2.alertMessage,
          showMessage = _this$props2.showMessage,
          drawerState = _this$props2.drawerState,
          noContentFoundMessage = _this$props2.noContentFoundMessage,
          loader = _this$props2.loader,
          updatingGlobalPriorities = _this$props2.updatingGlobalPriorities,
          updatingProjectCostPriorities = _this$props2.updatingProjectCostPriorities,
          projectList = _this$props2.projectList;
      return _react["default"].createElement("div", {
        className: "app-wrapper"
      }, _react["default"].createElement("div", {
        className: "app-module animated slideInUpTiny animation-duration-3"
      }, _react["default"].createElement("div", {
        className: "d-block d-xl-none"
      }, _react["default"].createElement(_rcDrawer["default"], {
        touch: true,
        transitions: true,
        enableDragHandle: true,
        open: drawerState,
        onOpenChange: this.onToggleProjectPriorityDrawer.bind(this),
        sidebar: this.projectPrioritySideBar(projectPriority)
      })), _react["default"].createElement("div", {
        className: "app-module-sidenav d-none d-xl-flex"
      }, this.projectPrioritySideBar(projectPriority)), _react["default"].createElement("div", {
        className: "module-box"
      }, _react["default"].createElement("div", {
        className: "module-box-header"
      }, _react["default"].createElement("span", {
        className: "icon-btn drawer-btn d-flex d-xl-none",
        onClick: this.onToggleProjectPriorityDrawer.bind(this)
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-menu"
      })), _react["default"].createElement(_index["default"], {
        searchBar: false,
        placeholder: "Search project priority",
        notification: false,
        apps: false,
        user: this.props.projectPriority,
        onChange: this.updateSearchProjectPriority.bind(this),
        value: this.props.searchProjectPriority
      })), _react["default"].createElement("div", {
        className: "module-box-content"
      }, _react["default"].createElement("div", {
        className: "contact-item"
      }, _react["default"].createElement("div", {
        className: "col"
      }, _react["default"].createElement("h1", null, updatingProjectCostPriorities ? _react["default"].createElement(_IntlMessages["default"], {
        id: "project.updateProjectCostPriorities"
      }) : _react["default"].createElement(_IntlMessages["default"], {
        id: "project.updateProjectBusinessPriorities"
      })))), _react["default"].createElement(_CustomScrollbars["default"], {
        className: "module-list-scroll scrollbar",
        style: {
          height: this.props.width >= 1200 ? 'calc(100vh - 265px)' : 'calc(100vh - 245px)'
        }
      }, loader ? _react["default"].createElement("div", {
        className: "loader-view-block h-100"
      }, _react["default"].createElement("div", {
        className: "loader-view"
      }, _react["default"].createElement(_CircularProgress["default"], null))) : projectPriorityList && projectPriorityList.length > 0 ? _react["default"].createElement(_projectPriorityList["default"], {
        data: projectPriorityList,
        width: width,
        updatingGlobalPriorities: updatingGlobalPriorities,
        projectList: projectList,
        addFavouriteProjectPriority: this.addFavouriteProjectPriority.bind(this),
        onProjectPrioritySelect: this.onProjectPrioritySelect.bind(this),
        onDeleteProjectPriority: this.onDeleteProjectPriority.bind(this),
        onSaveProjectPriority: this.onSaveProjectPriority.bind(this),
        showProjectPriorityLoader: this.showProjectPriorityLoader.bind(this),
        showProjectLoader: this.showProjectLoader.bind(this),
        onSaveProject: this.onSaveProject.bind(this),
        onUpdateProjectPriorities: this.onUpdateProjectPriorities.bind(this)
      }) : _react["default"].createElement("div", {
        className: "h-100 d-flex align-items-center justify-content-center"
      }, noContentFoundMessage))))), _react["default"].createElement(_projectPriorityAdd["default"], {
        open: addProjectPriorityState,
        projectPriority: {
          'id': '',
          'name': '',
          'description': '',
          'value': 0
        },
        updatingGlobalPriorities: updatingGlobalPriorities,
        onSaveProjectPriority: this.onSaveProjectPriority,
        onProjectPriorityClose: this.onProjectPriorityClose,
        onDeleteProjectPriority: this.onDeleteProjectPriority,
        showProjectPriorityLoader: this.showProjectPriorityLoader
      }), showMessage && _reactNotifications.NotificationManager.success(alertMessage, this.handleProjectPriorityRequestClose()), _react["default"].createElement(_reactNotifications.NotificationContainer, null));
    }
  }]);

  return Component;
}(_react["default"].Component);

exports.Component = Component;
var _default = Component;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/component.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/component.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/component.js");

  __REACT_HOT_LOADER__.register(_rcDrawer, "_rcDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/component.js");

  __REACT_HOT_LOADER__.register(_projectPriorityList, "_projectPriorityList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/component.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/component.js");

  __REACT_HOT_LOADER__.register(_projectPriorityAdd, "_projectPriorityAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/component.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/component.js");

  __REACT_HOT_LOADER__.register(_CircularProgress, "_CircularProgress", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/component.js");

  __REACT_HOT_LOADER__.register(_CustomScrollbars, "_CustomScrollbars", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/component.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/component.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/component.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/component.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/component.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/component.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/component.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/component.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/component.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/component.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/component.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/component.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/component.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/component.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/component.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/component.js");
}();

;

/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _index = _interopRequireDefault(__webpack_require__(1890));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ProjectPriorityList = function ProjectPriorityList(_ref) {
  var width = _ref.width,
      data = _ref.data,
      addFavouriteProjectPriority = _ref.addFavouriteProjectPriority,
      onProjectPrioritySelect = _ref.onProjectPrioritySelect,
      onSaveProjectPriority = _ref.onSaveProjectPriority,
      onDeleteProjectPriority = _ref.onDeleteProjectPriority,
      showProjectPriorityLoader = _ref.showProjectPriorityLoader,
      updatingGlobalPriorities = _ref.updatingGlobalPriorities,
      projectList = _ref.projectList,
      onSaveProject = _ref.onSaveProject,
      showProjectLoader = _ref.showProjectLoader,
      onUpdateProjectPriorities = _ref.onUpdateProjectPriorities;
  return _react["default"].createElement("div", {
    className: "app-main-content"
  }, data.map(function (data, index) {
    return _react["default"].createElement(_index["default"], {
      key: index,
      width: width,
      projectPriority: data,
      showProjectLoader: showProjectLoader,
      projectList: projectList,
      onSaveProject: onSaveProject,
      updatingGlobalPriorities: updatingGlobalPriorities,
      onDeleteProjectPriority: onDeleteProjectPriority,
      onSaveProjectPriority: onSaveProjectPriority,
      showProjectPriorityLoader: showProjectPriorityLoader,
      addFavouriteProjectPriority: addFavouriteProjectPriority,
      onProjectPrioritySelect: onProjectPrioritySelect,
      onUpdateProjectPriorities: onUpdateProjectPriorities
    });
  }));
};

var _default = ProjectPriorityList;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProjectPriorityList, "ProjectPriorityList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityList/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityList/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityList/index.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityList/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityList/index.js");

  __REACT_HOT_LOADER__.register(ProjectPriorityList, "ProjectPriorityList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityList/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityList/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityList/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityList/index.js");
}();

;

/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _reactBootstrapSweetalert = _interopRequireDefault(__webpack_require__(80));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _index = _interopRequireDefault(__webpack_require__(815));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ProjectPriorityRow =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ProjectPriorityRow, _React$Component);

  _createClass(ProjectPriorityRow, [{
    key: "__onProjectPriorityOptionToggle__REACT_HOT_LOADER__",
    value: function __onProjectPriorityOptionToggle__REACT_HOT_LOADER__() {
      this.setState({
        menuState: !this.state.menuState
      });
    }
  }, {
    key: "__onProjectPriorityClose__REACT_HOT_LOADER__",
    value: function __onProjectPriorityClose__REACT_HOT_LOADER__() {
      this.setState({
        addProjectPriorityState: false
      });
    }
  }, {
    key: "__onDeleteProjectPriority__REACT_HOT_LOADER__",
    value: function __onDeleteProjectPriority__REACT_HOT_LOADER__(org) {
      this.setState({
        addProjectPriorityState: false
      });
      this.props.onDeleteProjectPriority(org);
    }
  }, {
    key: "__onEditProjectPriority__REACT_HOT_LOADER__",
    value: function __onEditProjectPriority__REACT_HOT_LOADER__() {
      this.setState({
        menuState: false,
        addProjectPriorityState: true
      });
    }
  }]);

  function ProjectPriorityRow() {
    var _this;

    _classCallCheck(this, ProjectPriorityRow);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProjectPriorityRow).call(this));

    _defineProperty(_assertThisInitialized(_this), "onProjectPriorityOptionToggle", function () {
      var _this2;

      return (_this2 = _this).__onProjectPriorityOptionToggle__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onProjectPriorityClose", function () {
      var _this3;

      return (_this3 = _this).__onProjectPriorityClose__REACT_HOT_LOADER__.apply(_this3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onDeleteProjectPriority", function () {
      var _this4;

      return (_this4 = _this).__onDeleteProjectPriority__REACT_HOT_LOADER__.apply(_this4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onEditProjectPriority", function () {
      var _this5;

      return (_this5 = _this).__onEditProjectPriority__REACT_HOT_LOADER__.apply(_this5, arguments);
    });

    _this.state = {
      menuState: false,
      addProjectPriorityState: false,
      deletePriorityCheck: false
    };
    return _this;
  }

  _createClass(ProjectPriorityRow, [{
    key: "render",
    value: function render() {
      var _this6 = this;

      var _this$props = this.props,
          projectPriority = _this$props.projectPriority,
          onSaveProjectPriority = _this$props.onSaveProjectPriority,
          showProjectPriorityLoader = _this$props.showProjectPriorityLoader,
          updatingGlobalPriorities = _this$props.updatingGlobalPriorities,
          projectList = _this$props.projectList,
          showProjectLoader = _this$props.showProjectLoader,
          onSaveProject = _this$props.onSaveProject,
          onUpdateProjectPriorities = _this$props.onUpdateProjectPriorities;
      var _this$state = this.state,
          menuState = _this$state.menuState,
          addProjectPriorityState = _this$state.addProjectPriorityState,
          deletePriorityCheck = _this$state.deletePriorityCheck;
      var name = projectPriority.name,
          description = projectPriority.description,
          value = projectPriority.value;
      var options = updatingGlobalPriorities ? ['Edit', 'Delete'] : ['Edit'];
      return _react["default"].createElement("div", {
        className: "contact-item"
      }, _react["default"].createElement("div", {
        className: "col"
      }, _react["default"].createElement("p", {
        className: "mb-0"
      }, _react["default"].createElement("span", {
        className: "contact-name"
      }, name)), _react["default"].createElement("div", null, _react["default"].createElement("span", {
        className: "job-title"
      }, "Description - ", description ? description : 'No description provided'), updatingGlobalPriorities ? null : _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("span", {
        className: "d-inline-block toolbar-separator"
      }, "\xA0"), _react["default"].createElement("span", {
        className: "value d-inline-block mr-2"
      }, "Value - ", value)))), _react["default"].createElement("div", {
        className: "col-auto px-1 actions d-sm-flex"
      }, _react["default"].createElement(_reactstrap.Dropdown, {
        isOpen: menuState,
        toggle: this.onProjectPriorityOptionToggle.bind(this)
      }, _react["default"].createElement(_reactstrap.DropdownToggle, {
        tag: "span"
      }, _react["default"].createElement("span", {
        className: "icon-btn text-grey pointer"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-more-vert zmdi-hc-lg"
      }))), _react["default"].createElement(_reactstrap.DropdownMenu, null, options.map(function (option) {
        return _react["default"].createElement(_reactstrap.DropdownItem, {
          key: option,
          onClick: function onClick() {
            if (option === 'Edit') {
              _this6.onEditProjectPriority();
            } else if (option === 'Delete') {
              _this6.setState({
                deletePriorityCheck: true
              });
            }
          }
        }, option);
      }))), addProjectPriorityState && _react["default"].createElement(_index["default"], {
        showProjectLoader: showProjectLoader,
        onSaveProject: onSaveProject,
        projectList: projectList,
        updatingGlobalPriorities: updatingGlobalPriorities,
        open: addProjectPriorityState,
        projectPriority: projectPriority,
        onSaveProjectPriority: onSaveProjectPriority,
        onProjectPriorityClose: this.onProjectPriorityClose,
        onDeleteProjectPriority: this.onDeleteProjectPriority,
        showProjectPriorityLoader: showProjectPriorityLoader,
        onUpdateProjectPriorities: onUpdateProjectPriorities
      }), _react["default"].createElement(_reactBootstrapSweetalert["default"], {
        show: deletePriorityCheck,
        warning: true,
        showCancel: true,
        confirmBtnText: _react["default"].createElement(_IntlMessages["default"], {
          id: "button.yesDeleteIt"
        }),
        cancelBtnText: _react["default"].createElement(_IntlMessages["default"], {
          id: "button.cancel"
        }),
        confirmBtnBsStyle: "danger",
        cancelBtnBsStyle: "default",
        title: _react["default"].createElement("span", {
          style: {
            fontWeight: 'bold',
            color: 'grey',
            fontSize: '200%'
          }
        }, _react["default"].createElement(_IntlMessages["default"], {
          id: "general.areYouSure"
        })),
        onConfirm: function onConfirm() {
          _this6.onDeleteProjectPriority(projectPriority);

          _this6.setState({
            deletePriorityCheck: false
          });
        },
        onCancel: function onCancel() {
          _this6.setState({
            deletePriorityCheck: false
          });
        }
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "projectPriority.deleteProjectPriority"
      }))));
    }
  }]);

  return ProjectPriorityRow;
}(_react["default"].Component);

var _default = ProjectPriorityRow;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProjectPriorityRow, "ProjectPriorityRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityList/projectPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityList/projectPriorityRow/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityList/projectPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_reactBootstrapSweetalert, "_reactBootstrapSweetalert", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityList/projectPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityList/projectPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityList/projectPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityList/projectPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityList/projectPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityList/projectPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityList/projectPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityList/projectPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityList/projectPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityList/projectPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityList/projectPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityList/projectPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityList/projectPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityList/projectPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(ProjectPriorityRow, "ProjectPriorityRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityList/projectPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityList/projectPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityList/projectPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectPriority/projectPriorityList/projectPriorityRow/index.js");
}();

;

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _container["default"];
  }
});

var _container = _interopRequireDefault(__webpack_require__(1892));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_container, "_container", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/index.js");
}();

;

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.mapStateToProps = void 0;

var _reactRedux = __webpack_require__(10);

var _security = __webpack_require__(262);

var _component = _interopRequireDefault(__webpack_require__(1893));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var mapStateToProps = function mapStateToProps(_ref) {
  var securitys = _ref.securitys,
      settings = _ref.settings;
  var width = settings.width;
  var loader = securitys.loader,
      alertMessage = securitys.alertMessage,
      showMessage = securitys.showMessage,
      noContentFoundMessage = securitys.noContentFoundMessage,
      selectedSectionId = securitys.selectedSectionId,
      drawerState = securitys.drawerState,
      security = securitys.security,
      searchSecurity = securitys.searchSecurity,
      filterOption = securitys.filterOption,
      allSecurity = securitys.allSecurity,
      securityList = securitys.securityList,
      selectedSecurity = securitys.selectedSecurity,
      selectedSecuritys = securitys.selectedSecuritys,
      addSecurityState = securitys.addSecurityState;
  return {
    width: width,
    loader: loader,
    alertMessage: alertMessage,
    showMessage: showMessage,
    noContentFoundMessage: noContentFoundMessage,
    selectedSectionId: selectedSectionId,
    drawerState: drawerState,
    security: security,
    searchSecurity: searchSecurity,
    filterOption: filterOption,
    allSecurity: allSecurity,
    securityList: securityList,
    selectedSecurity: selectedSecurity,
    selectedSecuritys: selectedSecuritys,
    addSecurityState: addSecurityState
  };
};

exports.mapStateToProps = mapStateToProps;

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  fetchSecuritys: _security.fetchSecuritys,
  addFavouriteSecurity: _security.addFavouriteSecurity,
  onSecuritySelect: _security.onSecuritySelect,
  onAddSecurity: _security.onAddSecurity,
  onSecurityClose: _security.onSecurityClose,
  onFilterSecurityOptionSelect: _security.onFilterSecurityOptionSelect,
  onSaveSecurity: _security.onSaveSecurity,
  onDeleteSecurity: _security.onDeleteSecurity,
  onFilterSelectedSecurity: _security.onFilterSelectedSecurity,
  filterSecurity: _security.filterSecurity,
  getAllSecurity: _security.getAllSecurity,
  getUnselectedAllSecurity: _security.getUnselectedAllSecurity,
  onAllSecuritySelect: _security.onAllSecuritySelect,
  updateSearchSecurity: _security.updateSearchSecurity,
  onToggleSecurityDrawer: _security.onToggleSecurityDrawer,
  handleSecurityRequestClose: _security.handleSecurityRequestClose,
  hideSecurityLoader: _security.hideSecurityLoader,
  showSecurityLoader: _security.showSecurityLoader
})(_component["default"]);

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/container.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/container.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_component, "_component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/container.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/container.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/container.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/container.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/container.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/container.js");
}();

;

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Component = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _rcDrawer = _interopRequireDefault(__webpack_require__(31));

var _reactNotifications = __webpack_require__(30);

var _reactstrap = __webpack_require__(6);

var _securityList = _interopRequireDefault(__webpack_require__(1894));

var _index = _interopRequireDefault(__webpack_require__(66));

var _securityAdd = _interopRequireDefault(__webpack_require__(816));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _CircularProgress = _interopRequireDefault(__webpack_require__(24));

var _CustomScrollbars = _interopRequireDefault(__webpack_require__(27));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var filterOptions = [{
  id: 1,
  name: 'All securitys',
  icon: 'zmdi-menu'
}, {
  id: 2,
  name: 'Starred securitys',
  icon: 'zmdi-star'
}];

var Component =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Component, _React$Component);

  _createClass(Component, [{
    key: "__securitySideBar__REACT_HOT_LOADER__",
    value: function __securitySideBar__REACT_HOT_LOADER__() {
      var _this2 = this;

      return _react["default"].createElement("div", {
        className: "module-side"
      }, _react["default"].createElement("div", {
        className: "module-side-header"
      }, _react["default"].createElement("div", {
        className: "module-logo"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-city-alt mr-4"
      }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.securitys"
      })))), _react["default"].createElement("div", {
        className: "module-side-content"
      }, _react["default"].createElement(_CustomScrollbars["default"], {
        className: "module-side-scroll scrollbar",
        style: {
          height: this.props.width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)'
        }
      }, _react["default"].createElement("div", {
        className: "module-add-task"
      }, _react["default"].createElement(_reactstrap.Button, {
        className: "btn-block jr-btn",
        color: "primary",
        onClick: this.onAddSecurity
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-accounts-add zmdi-hc-fw"
      }), _react["default"].createElement("span", null, "Add New Security"))), _react["default"].createElement("div", {
        className: "module-side-nav"
      }, _react["default"].createElement("ul", {
        className: "module-nav"
      }, filterOptions.map(function (option) {
        return _react["default"].createElement("li", {
          key: option.id,
          className: "nav-item"
        }, _react["default"].createElement("a", {
          href: "javascript:void(0)",
          className: option.id === _this2.props.selectedSectionId ? 'active' : '',
          onClick: _this2.onFilterSecurityOptionSelect.bind(_this2, option)
        }, _react["default"].createElement("i", {
          className: "zmdi ".concat(option.icon)
        }), _react["default"].createElement("span", null, option.name)));
      }))))));
    }
  }, {
    key: "__addFavouriteSecurity__REACT_HOT_LOADER__",
    value: function __addFavouriteSecurity__REACT_HOT_LOADER__(data) {
      this.props.addFavouriteSecurity(data);
    }
  }, {
    key: "__onSecuritySelect__REACT_HOT_LOADER__",
    value: function __onSecuritySelect__REACT_HOT_LOADER__(data) {
      this.props.onSecuritySelect(data);
    }
  }, {
    key: "__onAddSecurity__REACT_HOT_LOADER__",
    value: function __onAddSecurity__REACT_HOT_LOADER__() {
      this.props.onAddSecurity();
    }
  }, {
    key: "__onSecurityClose__REACT_HOT_LOADER__",
    value: function __onSecurityClose__REACT_HOT_LOADER__() {
      this.props.onSecurityClose();
    }
  }, {
    key: "__onFilterSecurityOptionSelect__REACT_HOT_LOADER__",
    value: function __onFilterSecurityOptionSelect__REACT_HOT_LOADER__(option) {
      this.props.onFilterSecurityOptionSelect(option);
    }
  }, {
    key: "__onSaveSecurity__REACT_HOT_LOADER__",
    value: function __onSaveSecurity__REACT_HOT_LOADER__(data) {
      this.props.onSaveSecurity(data);
    }
  }, {
    key: "__onDeleteSecurity__REACT_HOT_LOADER__",
    value: function __onDeleteSecurity__REACT_HOT_LOADER__(data) {
      this.props.onDeleteSecurity(data);
    }
  }, {
    key: "__onFilterSelectedSecurity__REACT_HOT_LOADER__",
    value: function __onFilterSelectedSecurity__REACT_HOT_LOADER__() {
      this.props.onFilterSelectedSecurity();
    }
  }, {
    key: "__filterSecurity__REACT_HOT_LOADER__",
    value: function __filterSecurity__REACT_HOT_LOADER__(securityName) {
      if (securityName === '') {
        this.onFilterSecurityOptionSelect(this.props.filterOption);
      } else {
        this.props.filterSecurity(securityName);
      }
    }
  }, {
    key: "__handleSecurityRequestClose__REACT_HOT_LOADER__",
    value: function __handleSecurityRequestClose__REACT_HOT_LOADER__() {
      this.props.handleSecurityRequestClose();
    }
  }, {
    key: "__getAllSecurity__REACT_HOT_LOADER__",
    value: function __getAllSecurity__REACT_HOT_LOADER__() {
      this.props.getAllSecurity();
    }
  }, {
    key: "__getUnselectedAllSecurity__REACT_HOT_LOADER__",
    value: function __getUnselectedAllSecurity__REACT_HOT_LOADER__() {
      this.props.getUnselectedAllSecurity();
    }
  }, {
    key: "__onAllSecuritySelect__REACT_HOT_LOADER__",
    value: function __onAllSecuritySelect__REACT_HOT_LOADER__() {
      var selectAll = this.props.selectedSecuritys < this.props.securityList.length;

      if (selectAll) {
        this.props.getAllSecurity();
      } else {
        this.props.getUnselectedAllSecurity();
      }
    }
  }, {
    key: "__onToggleSecurityDrawer__REACT_HOT_LOADER__",
    value: function __onToggleSecurityDrawer__REACT_HOT_LOADER__() {
      this.props.onToggleSecurityDrawer();
    }
  }, {
    key: "__showSecurityLoader__REACT_HOT_LOADER__",
    value: function __showSecurityLoader__REACT_HOT_LOADER__() {
      this.props.showSecurityLoader();
    }
  }]);

  function Component() {
    var _this;

    _classCallCheck(this, Component);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Component).call(this));

    _defineProperty(_assertThisInitialized(_this), "securitySideBar", function () {
      var _this3;

      return (_this3 = _this).__securitySideBar__REACT_HOT_LOADER__.apply(_this3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "addFavouriteSecurity", function () {
      var _this4;

      return (_this4 = _this).__addFavouriteSecurity__REACT_HOT_LOADER__.apply(_this4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onSecuritySelect", function () {
      var _this5;

      return (_this5 = _this).__onSecuritySelect__REACT_HOT_LOADER__.apply(_this5, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onAddSecurity", function () {
      var _this6;

      return (_this6 = _this).__onAddSecurity__REACT_HOT_LOADER__.apply(_this6, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onSecurityClose", function () {
      var _this7;

      return (_this7 = _this).__onSecurityClose__REACT_HOT_LOADER__.apply(_this7, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onFilterSecurityOptionSelect", function () {
      var _this8;

      return (_this8 = _this).__onFilterSecurityOptionSelect__REACT_HOT_LOADER__.apply(_this8, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onSaveSecurity", function () {
      var _this9;

      return (_this9 = _this).__onSaveSecurity__REACT_HOT_LOADER__.apply(_this9, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onDeleteSecurity", function () {
      var _this10;

      return (_this10 = _this).__onDeleteSecurity__REACT_HOT_LOADER__.apply(_this10, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onFilterSelectedSecurity", function () {
      var _this11;

      return (_this11 = _this).__onFilterSelectedSecurity__REACT_HOT_LOADER__.apply(_this11, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "filterSecurity", function () {
      var _this12;

      return (_this12 = _this).__filterSecurity__REACT_HOT_LOADER__.apply(_this12, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "handleSecurityRequestClose", function () {
      var _this13;

      return (_this13 = _this).__handleSecurityRequestClose__REACT_HOT_LOADER__.apply(_this13, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "getAllSecurity", function () {
      var _this14;

      return (_this14 = _this).__getAllSecurity__REACT_HOT_LOADER__.apply(_this14, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "getUnselectedAllSecurity", function () {
      var _this15;

      return (_this15 = _this).__getUnselectedAllSecurity__REACT_HOT_LOADER__.apply(_this15, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onAllSecuritySelect", function () {
      var _this16;

      return (_this16 = _this).__onAllSecuritySelect__REACT_HOT_LOADER__.apply(_this16, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onToggleSecurityDrawer", function () {
      var _this17;

      return (_this17 = _this).__onToggleSecurityDrawer__REACT_HOT_LOADER__.apply(_this17, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "showSecurityLoader", function () {
      var _this18;

      return (_this18 = _this).__showSecurityLoader__REACT_HOT_LOADER__.apply(_this18, arguments);
    });

    return _this;
  }

  _createClass(Component, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.showSecurityLoader();
      this.props.fetchSecuritys();
    }
  }, {
    key: "updateSearchSecurity",
    value: function updateSearchSecurity(evt) {
      this.props.updateSearchSecurity(evt.target.value);
      this.props.filterSecurity(evt.target.value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          width = _this$props.width,
          security = _this$props.security,
          securityList = _this$props.securityList,
          addSecurityState = _this$props.addSecurityState,
          selectedSecuritys = _this$props.selectedSecuritys,
          alertMessage = _this$props.alertMessage,
          showMessage = _this$props.showMessage,
          drawerState = _this$props.drawerState,
          noContentFoundMessage = _this$props.noContentFoundMessage,
          loader = _this$props.loader;
      return _react["default"].createElement("div", {
        className: "app-wrapper"
      }, _react["default"].createElement("div", {
        className: "app-module animated slideInUpTiny animation-duration-3"
      }, _react["default"].createElement("div", {
        className: "d-block d-xl-none"
      }, _react["default"].createElement(_rcDrawer["default"], {
        touch: true,
        transitions: true,
        enableDragHandle: true,
        open: drawerState,
        onOpenChange: this.onToggleSecurityDrawer.bind(this),
        sidebar: this.securitySideBar(security)
      })), _react["default"].createElement("div", {
        className: "app-module-sidenav d-none d-xl-flex"
      }, this.securitySideBar(security)), _react["default"].createElement("div", {
        className: "module-box"
      }, _react["default"].createElement("div", {
        className: "module-box-header"
      }, _react["default"].createElement("span", {
        className: "icon-btn drawer-btn d-flex d-xl-none",
        onClick: this.onToggleSecurityDrawer.bind(this)
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-menu"
      })), _react["default"].createElement(_index["default"], {
        placeholder: "Search security",
        notification: false,
        apps: false,
        user: this.props.security,
        onChange: this.updateSearchSecurity.bind(this),
        value: this.props.searchSecurity
      })), _react["default"].createElement("div", {
        className: "module-box-content"
      }, _react["default"].createElement("div", {
        className: "module-box-topbar align-items-center"
      }, _react["default"].createElement("div", {
        className: "form-control-checkbox d-flex"
      }, _react["default"].createElement("div", {
        className: "form-checkbox"
      }, _react["default"].createElement("input", {
        type: "checkbox",
        checked: selectedSecuritys > 0,
        onChange: this.onAllSecuritySelect.bind(this)
      }), _react["default"].createElement("span", {
        className: "check"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-check zmdi-hc-lg"
      })))), _react["default"].createElement(_reactstrap.Button, {
        size: "sm",
        className: "jr-btn jr-flat-btn",
        color: "default",
        onClick: this.onFilterSelectedSecurity.bind(this)
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-filter-list zmdi-hc-fw"
      }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "label.filter.selected"
      })))), _react["default"].createElement(_CustomScrollbars["default"], {
        className: "module-list-scroll scrollbar",
        style: {
          height: this.props.width >= 1200 ? 'calc(100vh - 265px)' : 'calc(100vh - 245px)'
        }
      }, loader ? _react["default"].createElement("div", {
        className: "loader-view-block h-100"
      }, _react["default"].createElement("div", {
        className: "loader-view"
      }, _react["default"].createElement(_CircularProgress["default"], null))) : securityList && securityList.length > 0 ? _react["default"].createElement(_securityList["default"], {
        data: securityList,
        width: width,
        addFavouriteSecurity: this.addFavouriteSecurity.bind(this),
        onSecuritySelect: this.onSecuritySelect.bind(this),
        onDeleteSecurity: this.onDeleteSecurity.bind(this),
        onSaveSecurity: this.onSaveSecurity.bind(this),
        showSecurityLoader: this.showSecurityLoader.bind(this)
      }) : _react["default"].createElement("div", {
        className: "h-100 d-flex align-items-center justify-content-center"
      }, noContentFoundMessage))))), _react["default"].createElement(_securityAdd["default"], {
        open: addSecurityState,
        security: {
          'id': '',
          'orgid': '',
          'name': '',
          'key': '',
          'url': '',
          'account': '',
          'thumb': null,
          'selected': false,
          'starred': false,
          'frequently': false
        },
        onSaveSecurity: this.onSaveSecurity,
        onSecurityClose: this.onSecurityClose,
        onDeleteSecurity: this.onDeleteSecurity,
        showSecurityLoader: this.showSecurityLoader
      }), showMessage && _reactNotifications.NotificationManager.success(alertMessage, this.handleSecurityRequestClose()), _react["default"].createElement(_reactNotifications.NotificationContainer, null));
    }
  }]);

  return Component;
}(_react["default"].Component);

exports.Component = Component;
var _default = Component;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(filterOptions, "filterOptions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/component.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/component.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/component.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/component.js");

  __REACT_HOT_LOADER__.register(_rcDrawer, "_rcDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/component.js");

  __REACT_HOT_LOADER__.register(_securityList, "_securityList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/component.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/component.js");

  __REACT_HOT_LOADER__.register(_securityAdd, "_securityAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/component.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/component.js");

  __REACT_HOT_LOADER__.register(_CircularProgress, "_CircularProgress", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/component.js");

  __REACT_HOT_LOADER__.register(_CustomScrollbars, "_CustomScrollbars", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/component.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/component.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/component.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/component.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/component.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/component.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/component.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/component.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/component.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/component.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/component.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/component.js");

  __REACT_HOT_LOADER__.register(filterOptions, "filterOptions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/component.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/component.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/component.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/component.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/component.js");
}();

;

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _index = _interopRequireDefault(__webpack_require__(1895));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var SecurityList = function SecurityList(_ref) {
  var data = _ref.data,
      width = _ref.width,
      addFavouriteSecurity = _ref.addFavouriteSecurity,
      onSecuritySelect = _ref.onSecuritySelect,
      onSaveSecurity = _ref.onSaveSecurity,
      onDeleteSecurity = _ref.onDeleteSecurity,
      showSecurityLoader = _ref.showSecurityLoader;
  return _react["default"].createElement("div", {
    className: "app-main-content"
  }, data.map(function (data, index) {
    return _react["default"].createElement(_index["default"], {
      key: index,
      security: data,
      width: width,
      onDeleteSecurity: onDeleteSecurity,
      onSaveSecurity: onSaveSecurity,
      showSecurityLoader: showSecurityLoader,
      addFavouriteSecurity: addFavouriteSecurity,
      onSecuritySelect: onSecuritySelect
    });
  }));
};

var _default = SecurityList;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SecurityList, "SecurityList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityList/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityList/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityList/index.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityList/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityList/index.js");

  __REACT_HOT_LOADER__.register(SecurityList, "SecurityList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityList/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityList/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityList/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityList/index.js");
}();

;

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _reactBootstrapSweetalert = _interopRequireDefault(__webpack_require__(80));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _listRowImage = _interopRequireDefault(__webpack_require__(126));

var _ListRowFavourite = _interopRequireDefault(__webpack_require__(127));

var _ListRowCheckbox = _interopRequireDefault(__webpack_require__(107));

var _ListRowData = _interopRequireDefault(__webpack_require__(129));

var _ListRowDropdown = _interopRequireDefault(__webpack_require__(128));

var _index = _interopRequireDefault(__webpack_require__(816));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SecurityRow =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SecurityRow, _React$Component);

  function SecurityRow() {
    var _this;

    _classCallCheck(this, SecurityRow);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SecurityRow).call(this));

    _defineProperty(_assertThisInitialized(_this), "onSecurityOptionToggle", function () {
      var _this2;

      return (_this2 = _this).__onSecurityOptionToggle__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onSecurityClose", function () {
      var _this3;

      return (_this3 = _this).__onSecurityClose__REACT_HOT_LOADER__.apply(_this3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onDeleteSecurity", function () {
      var _this4;

      return (_this4 = _this).__onDeleteSecurity__REACT_HOT_LOADER__.apply(_this4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onEditSecurity", function () {
      var _this5;

      return (_this5 = _this).__onEditSecurity__REACT_HOT_LOADER__.apply(_this5, arguments);
    });

    _this.state = {
      menuState: false,
      addSecurityState: false,
      deleteSecurityCheck: false
    };
    return _this;
  }

  _createClass(SecurityRow, [{
    key: "__onSecurityOptionToggle__REACT_HOT_LOADER__",
    value: function __onSecurityOptionToggle__REACT_HOT_LOADER__() {
      this.setState({
        menuState: !this.state.menuState
      });
    }
  }, {
    key: "__onSecurityClose__REACT_HOT_LOADER__",
    value: function __onSecurityClose__REACT_HOT_LOADER__() {
      this.setState({
        addSecurityState: false
      });
    }
  }, {
    key: "__onDeleteSecurity__REACT_HOT_LOADER__",
    value: function __onDeleteSecurity__REACT_HOT_LOADER__(security) {
      this.setState({
        addSecurityState: false
      });
      this.props.onDeleteSecurity(security === null || security === void 0 ? void 0 : security.id);
    }
  }, {
    key: "__onEditSecurity__REACT_HOT_LOADER__",
    value: function __onEditSecurity__REACT_HOT_LOADER__() {
      this.setState({
        menuState: false,
        addSecurityState: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var _this$props = this.props,
          width = _this$props.width,
          security = _this$props.security,
          addFavouriteSecurity = _this$props.addFavouriteSecurity,
          onSecuritySelect = _this$props.onSecuritySelect,
          onSaveSecurity = _this$props.onSaveSecurity,
          showSecurityLoader = _this$props.showSecurityLoader;
      var _this$state = this.state,
          menuState = _this$state.menuState,
          addSecurityState = _this$state.addSecurityState,
          deleteSecurityCheck = _this$state.deleteSecurityCheck;
      var name = security.name,
          key = security.key,
          account = security.account,
          starred = security.starred;
      var options = ['Edit', 'Delete'];
      var maskKey = '********'.concat(key.substring(key.length - 4, key.length));
      return _react["default"].createElement("div", {
        className: "contact-item"
      }, _react["default"].createElement(_ListRowCheckbox["default"], {
        selected: security.selected,
        onClick: function onClick() {
          onSecuritySelect(security);
        }
      }), _react["default"].createElement(_ListRowFavourite["default"], {
        width: width,
        onClick: function onClick() {
          addFavouriteSecurity(security);
        },
        starred: starred
      }), _react["default"].createElement(_listRowImage["default"], {
        width: width,
        data: security
      }), _react["default"].createElement(_ListRowData["default"], {
        lineOne: name,
        lineTwoLeft: maskKey,
        lineTwoRight: account
      }), _react["default"].createElement(_ListRowDropdown["default"], {
        menuState: menuState,
        toggle: this.onSecurityOptionToggle.bind(this),
        options: options,
        dropdownItems: options.map(function (option) {
          return _react["default"].createElement(_reactstrap.DropdownItem, {
            key: option,
            onClick: function onClick() {
              if (option === 'Edit') {
                _this6.onEditSecurity();
              } else if (option === 'Delete') {
                _this6.setState({
                  deleteSecurityCheck: true
                });
              }
            }
          }, option);
        })
      }), _react["default"].createElement("div", null, addSecurityState && _react["default"].createElement(_index["default"], {
        open: addSecurityState,
        security: security,
        onSaveSecurity: onSaveSecurity,
        onSecurityClose: this.onSecurityClose,
        onDeleteSecurity: this.onDeleteSecurity,
        showSecurityLoader: showSecurityLoader
      })), _react["default"].createElement(_reactBootstrapSweetalert["default"], {
        show: deleteSecurityCheck,
        warning: true,
        showCancel: true,
        confirmBtnText: _react["default"].createElement(_IntlMessages["default"], {
          id: "button.yesDeleteIt"
        }),
        cancelBtnText: _react["default"].createElement(_IntlMessages["default"], {
          id: "button.cancel"
        }),
        confirmBtnBsStyle: "danger",
        cancelBtnBsStyle: "default",
        title: _react["default"].createElement("span", {
          style: {
            fontWeight: 'bold',
            color: 'grey',
            fontSize: '200%'
          }
        }, _react["default"].createElement(_IntlMessages["default"], {
          id: "general.areYouSure"
        })),
        onConfirm: function onConfirm() {
          _this6.onDeleteSecurity(security);

          _this6.setState({
            deleteSecurityCheck: false
          });
        },
        onCancel: function onCancel() {
          _this6.setState({
            deleteSecurityCheck: false
          });
        }
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "security.deleteSecurity"
      })));
    }
  }]);

  return SecurityRow;
}(_react["default"].Component);

var _default = SecurityRow;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SecurityRow, "SecurityRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityList/securityRow/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityList/securityRow/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityList/securityRow/index.js");

  __REACT_HOT_LOADER__.register(_reactBootstrapSweetalert, "_reactBootstrapSweetalert", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityList/securityRow/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityList/securityRow/index.js");

  __REACT_HOT_LOADER__.register(_listRowImage, "_listRowImage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityList/securityRow/index.js");

  __REACT_HOT_LOADER__.register(_ListRowFavourite, "_ListRowFavourite", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityList/securityRow/index.js");

  __REACT_HOT_LOADER__.register(_ListRowCheckbox, "_ListRowCheckbox", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityList/securityRow/index.js");

  __REACT_HOT_LOADER__.register(_ListRowData, "_ListRowData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityList/securityRow/index.js");

  __REACT_HOT_LOADER__.register(_ListRowDropdown, "_ListRowDropdown", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityList/securityRow/index.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityList/securityRow/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityList/securityRow/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityList/securityRow/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityList/securityRow/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityList/securityRow/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityList/securityRow/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityList/securityRow/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityList/securityRow/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityList/securityRow/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityList/securityRow/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityList/securityRow/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityList/securityRow/index.js");

  __REACT_HOT_LOADER__.register(SecurityRow, "SecurityRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityList/securityRow/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityList/securityRow/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityList/securityRow/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/security/securityList/securityRow/index.js");
}();

;

/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _container["default"];
  }
});

var _container = _interopRequireDefault(__webpack_require__(1897));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_container, "_container", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/index.js");
}();

;

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.mapStateToProps = void 0;

var _reactRedux = __webpack_require__(10);

var _projectIssue = __webpack_require__(365);

var _component = _interopRequireDefault(__webpack_require__(1898));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var mapStateToProps = function mapStateToProps(_ref) {
  var projects = _ref.projects,
      projectIssues = _ref.projectIssues,
      settings = _ref.settings;
  var width = settings.width;
  var loader = projectIssues.loader,
      alertMessage = projectIssues.alertMessage,
      showMessage = projectIssues.showMessage,
      noContentFoundMessage = projectIssues.noContentFoundMessage,
      selectedSectionId = projectIssues.selectedSectionId,
      drawerState = projectIssues.drawerState,
      projectIssue = projectIssues.projectIssue,
      searchProjectIssue = projectIssues.searchProjectIssue,
      filterOption = projectIssues.filterOption,
      allProjectIssue = projectIssues.allProjectIssue,
      projectIssueList = projectIssues.projectIssueList,
      selectedProjectIssue = projectIssues.selectedProjectIssue,
      selectedProjectIssues = projectIssues.selectedProjectIssues,
      addProjectIssueState = projectIssues.addProjectIssueState,
      addJiraProjectIssueState = projectIssues.addJiraProjectIssueState;
  var selectedProject = projects.selectedProject;
  return {
    width: width,
    loader: loader,
    alertMessage: alertMessage,
    showMessage: showMessage,
    noContentFoundMessage: noContentFoundMessage,
    selectedSectionId: selectedSectionId,
    drawerState: drawerState,
    projectIssue: projectIssue,
    searchProjectIssue: searchProjectIssue,
    filterOption: filterOption,
    allProjectIssue: allProjectIssue,
    projectIssueList: projectIssueList,
    selectedProjectIssue: selectedProjectIssue,
    selectedProjectIssues: selectedProjectIssues,
    addProjectIssueState: addProjectIssueState,
    addJiraProjectIssueState: addJiraProjectIssueState,
    selectedProject: selectedProject
  };
};

exports.mapStateToProps = mapStateToProps;

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  fetchProjectIssues: _projectIssue.fetchProjectIssues,
  addFavouriteProjectIssue: _projectIssue.addFavouriteProjectIssue,
  onProjectIssueSelect: _projectIssue.onProjectIssueSelect,
  onAddProjectIssue: _projectIssue.onAddProjectIssue,
  onAddJiraProjectIssue: _projectIssue.onAddJiraProjectIssue,
  onProjectIssueClose: _projectIssue.onProjectIssueClose,
  onJiraProjectIssueClose: _projectIssue.onJiraProjectIssueClose,
  onFilterProjectIssueOptionSelect: _projectIssue.onFilterProjectIssueOptionSelect,
  onSaveProjectIssue: _projectIssue.onSaveProjectIssue,
  onSaveJiraProjectIssue: _projectIssue.onSaveJiraProjectIssue,
  onDeleteProjectIssue: _projectIssue.onDeleteProjectIssue,
  onFilterSelectedProjectIssue: _projectIssue.onFilterSelectedProjectIssue,
  filterProjectIssue: _projectIssue.filterProjectIssue,
  getAllProjectIssue: _projectIssue.getAllProjectIssue,
  getUnselectedAllProjectIssue: _projectIssue.getUnselectedAllProjectIssue,
  onAllProjectIssueSelect: _projectIssue.onAllProjectIssueSelect,
  updateSearchProjectIssue: _projectIssue.updateSearchProjectIssue,
  onToggleProjectIssueDrawer: _projectIssue.onToggleProjectIssueDrawer,
  handleProjectIssueRequestClose: _projectIssue.handleProjectIssueRequestClose,
  hideProjectIssueLoader: _projectIssue.hideProjectIssueLoader,
  showProjectIssueLoader: _projectIssue.showProjectIssueLoader,
  setProjectIssue: _projectIssue.setProjectIssue
})(_component["default"]);

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/container.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/container.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_component, "_component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/container.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/container.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/container.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/container.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/container.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/container.js");
}();

;

/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Component = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _rcDrawer = _interopRequireDefault(__webpack_require__(31));

var _reactNotifications = __webpack_require__(30);

var _reactstrap = __webpack_require__(6);

var _projectIssueList = _interopRequireDefault(__webpack_require__(1899));

var _projectIssueDetail = _interopRequireDefault(__webpack_require__(1901));

var _projectIssueAdd = _interopRequireDefault(__webpack_require__(1904));

var _jiraProjectIssueAdd = _interopRequireDefault(__webpack_require__(1905));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _CircularProgress = _interopRequireDefault(__webpack_require__(24));

var _CustomScrollbars = _interopRequireDefault(__webpack_require__(27));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Component =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Component, _React$Component);

  _createClass(Component, [{
    key: "__addFavouriteProjectIssue__REACT_HOT_LOADER__",
    value: function __addFavouriteProjectIssue__REACT_HOT_LOADER__(data) {
      this.props.addFavouriteProjectIssue(data);
    }
  }, {
    key: "__onProjectIssueSelect__REACT_HOT_LOADER__",
    value: function __onProjectIssueSelect__REACT_HOT_LOADER__(data) {
      this.props.onProjectIssueSelect(data);
    }
  }, {
    key: "__onAddProjectIssue__REACT_HOT_LOADER__",
    value: function __onAddProjectIssue__REACT_HOT_LOADER__() {
      this.props.onAddProjectIssue(); // true - add non-jira issue, false - jira issue
    }
  }, {
    key: "__onAddJiraProjectIssue__REACT_HOT_LOADER__",
    value: function __onAddJiraProjectIssue__REACT_HOT_LOADER__() {
      this.props.onAddJiraProjectIssue(); // true - add non-jira issue, false - jira issue
    }
  }, {
    key: "__onProjectIssueClose__REACT_HOT_LOADER__",
    value: function __onProjectIssueClose__REACT_HOT_LOADER__() {
      this.props.onProjectIssueClose();
    }
  }, {
    key: "__onJiraProjectIssueClose__REACT_HOT_LOADER__",
    value: function __onJiraProjectIssueClose__REACT_HOT_LOADER__() {
      this.props.onJiraProjectIssueClose();
    }
  }, {
    key: "__onFilterProjectIssueOptionSelect__REACT_HOT_LOADER__",
    value: function __onFilterProjectIssueOptionSelect__REACT_HOT_LOADER__(option) {
      this.props.onFilterProjectIssueOptionSelect(option);
    }
  }, {
    key: "__onSaveProjectIssue__REACT_HOT_LOADER__",
    value: function __onSaveProjectIssue__REACT_HOT_LOADER__(data) {
      this.props.onSaveProjectIssue(data);
    }
  }, {
    key: "__onSaveJiraProjectIssue__REACT_HOT_LOADER__",
    value: function __onSaveJiraProjectIssue__REACT_HOT_LOADER__(data) {
      this.props.onSaveJiraProjectIssue(data);
    }
  }, {
    key: "__onDeleteProjectIssue__REACT_HOT_LOADER__",
    value: function __onDeleteProjectIssue__REACT_HOT_LOADER__(data) {
      this.props.onDeleteProjectIssue(data);
    }
  }, {
    key: "__onFilterSelectedProjectIssue__REACT_HOT_LOADER__",
    value: function __onFilterSelectedProjectIssue__REACT_HOT_LOADER__() {
      this.props.onFilterSelectedProjectIssue();
    }
  }, {
    key: "__filterProjectIssue__REACT_HOT_LOADER__",
    value: function __filterProjectIssue__REACT_HOT_LOADER__(projectIssueName) {
      if (projectIssueName === '') {
        this.onFilterProjectIssueOptionSelect(this.props.filterOption);
      } else {
        this.props.filterProjectIssue(projectIssueName);
      }
    }
  }, {
    key: "__handleProjectIssueRequestClose__REACT_HOT_LOADER__",
    value: function __handleProjectIssueRequestClose__REACT_HOT_LOADER__() {
      this.props.handleProjectIssueRequestClose();
    }
  }, {
    key: "__getAllProjectIssue__REACT_HOT_LOADER__",
    value: function __getAllProjectIssue__REACT_HOT_LOADER__() {
      this.props.getAllProjectIssue();
    }
  }, {
    key: "__getUnselectedAllProjectIssue__REACT_HOT_LOADER__",
    value: function __getUnselectedAllProjectIssue__REACT_HOT_LOADER__() {
      this.props.getUnselectedAllProjectIssue();
    }
  }, {
    key: "__onAllProjectIssueSelect__REACT_HOT_LOADER__",
    value: function __onAllProjectIssueSelect__REACT_HOT_LOADER__() {
      var selectAll = this.props.selectedProjectIssues < this.props.projectIssueList.length;

      if (selectAll) {
        this.props.getAllProjectIssue();
      } else {
        this.props.getUnselectedAllProjectIssue();
      }
    }
  }, {
    key: "__onToggleProjectIssueDrawer__REACT_HOT_LOADER__",
    value: function __onToggleProjectIssueDrawer__REACT_HOT_LOADER__() {
      this.props.onToggleProjectIssueDrawer();
    }
  }, {
    key: "__showProjectIssueLoader__REACT_HOT_LOADER__",
    value: function __showProjectIssueLoader__REACT_HOT_LOADER__() {
      this.props.showProjectIssueLoader();
    }
  }]);

  function Component() {
    var _this;

    _classCallCheck(this, Component);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Component).call(this));

    _defineProperty(_assertThisInitialized(_this), "addFavouriteProjectIssue", function () {
      var _this2;

      return (_this2 = _this).__addFavouriteProjectIssue__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onProjectIssueSelect", function () {
      var _this3;

      return (_this3 = _this).__onProjectIssueSelect__REACT_HOT_LOADER__.apply(_this3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onAddProjectIssue", function () {
      var _this4;

      return (_this4 = _this).__onAddProjectIssue__REACT_HOT_LOADER__.apply(_this4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onAddJiraProjectIssue", function () {
      var _this5;

      return (_this5 = _this).__onAddJiraProjectIssue__REACT_HOT_LOADER__.apply(_this5, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onProjectIssueClose", function () {
      var _this6;

      return (_this6 = _this).__onProjectIssueClose__REACT_HOT_LOADER__.apply(_this6, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onJiraProjectIssueClose", function () {
      var _this7;

      return (_this7 = _this).__onJiraProjectIssueClose__REACT_HOT_LOADER__.apply(_this7, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onFilterProjectIssueOptionSelect", function () {
      var _this8;

      return (_this8 = _this).__onFilterProjectIssueOptionSelect__REACT_HOT_LOADER__.apply(_this8, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onSaveProjectIssue", function () {
      var _this9;

      return (_this9 = _this).__onSaveProjectIssue__REACT_HOT_LOADER__.apply(_this9, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onSaveJiraProjectIssue", function () {
      var _this10;

      return (_this10 = _this).__onSaveJiraProjectIssue__REACT_HOT_LOADER__.apply(_this10, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onDeleteProjectIssue", function () {
      var _this11;

      return (_this11 = _this).__onDeleteProjectIssue__REACT_HOT_LOADER__.apply(_this11, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onFilterSelectedProjectIssue", function () {
      var _this12;

      return (_this12 = _this).__onFilterSelectedProjectIssue__REACT_HOT_LOADER__.apply(_this12, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "filterProjectIssue", function () {
      var _this13;

      return (_this13 = _this).__filterProjectIssue__REACT_HOT_LOADER__.apply(_this13, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "handleProjectIssueRequestClose", function () {
      var _this14;

      return (_this14 = _this).__handleProjectIssueRequestClose__REACT_HOT_LOADER__.apply(_this14, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "getAllProjectIssue", function () {
      var _this15;

      return (_this15 = _this).__getAllProjectIssue__REACT_HOT_LOADER__.apply(_this15, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "getUnselectedAllProjectIssue", function () {
      var _this16;

      return (_this16 = _this).__getUnselectedAllProjectIssue__REACT_HOT_LOADER__.apply(_this16, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onAllProjectIssueSelect", function () {
      var _this17;

      return (_this17 = _this).__onAllProjectIssueSelect__REACT_HOT_LOADER__.apply(_this17, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onToggleProjectIssueDrawer", function () {
      var _this18;

      return (_this18 = _this).__onToggleProjectIssueDrawer__REACT_HOT_LOADER__.apply(_this18, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "showProjectIssueLoader", function () {
      var _this19;

      return (_this19 = _this).__showProjectIssueLoader__REACT_HOT_LOADER__.apply(_this19, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "setProjectIssue", function () {
      var _this20;

      return (_this20 = _this).__setProjectIssue__REACT_HOT_LOADER__.apply(_this20, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "projectIssueSideBar", function () {
      var _this21;

      return (_this21 = _this).__projectIssueSideBar__REACT_HOT_LOADER__.apply(_this21, arguments);
    });

    return _this;
  }

  _createClass(Component, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.showProjectIssueLoader();
      this.props.fetchProjectIssues(true); // use the cache
    }
  }, {
    key: "updateSearchProjectIssue",
    value: function updateSearchProjectIssue(evt) {
      this.props.updateSearchProjectIssue(evt.target.value);
      this.props.filterProjectIssue(evt.target.value);
    }
  }, {
    key: "__setProjectIssue__REACT_HOT_LOADER__",
    value: function __setProjectIssue__REACT_HOT_LOADER__(id) {
      this.props.setProjectIssue(id);
    }
  }, {
    key: "__projectIssueSideBar__REACT_HOT_LOADER__",
    value: function __projectIssueSideBar__REACT_HOT_LOADER__() {
      return _react["default"].createElement("div", {
        className: "module-side"
      }, _react["default"].createElement("div", {
        className: "module-side-header"
      }, _react["default"].createElement("div", {
        className: "module-logo"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-city-alt mr-4"
      }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.projectIssues"
      })))), _react["default"].createElement("div", {
        className: "module-side-content"
      }, _react["default"].createElement(_CustomScrollbars["default"], {
        className: "module-side-scroll scrollbar",
        style: {
          height: this.props.width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)'
        }
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this22 = this;

      var _this$props = this.props,
          selectedProject = _this$props.selectedProject,
          width = _this$props.width,
          selectedProjectIssue = _this$props.selectedProjectIssue,
          projectIssue = _this$props.projectIssue,
          projectIssueList = _this$props.projectIssueList,
          addProjectIssueState = _this$props.addProjectIssueState,
          addJiraProjectIssueState = _this$props.addJiraProjectIssueState,
          alertMessage = _this$props.alertMessage,
          showMessage = _this$props.showMessage,
          drawerState = _this$props.drawerState,
          noContentFoundMessage = _this$props.noContentFoundMessage,
          loader = _this$props.loader;
      return _react["default"].createElement("div", {
        className: "app-wrapper"
      }, _react["default"].createElement("div", {
        className: "app-module animated slideInUpTiny animation-duration-3"
      }, _react["default"].createElement("div", {
        className: "d-block d-xl-none"
      }, _react["default"].createElement(_rcDrawer["default"], {
        touch: true,
        transitions: true,
        enableDragHandle: true,
        open: drawerState,
        onOpenChange: this.onToggleProjectIssueDrawer.bind(this),
        sidebar: this.projectIssueSideBar(projectIssue)
      })), _react["default"].createElement("div", {
        className: "app-module-sidenav d-none d-xl-flex"
      }, this.projectIssueSideBar(projectIssue)), _react["default"].createElement("div", {
        className: "module-box"
      }, _react["default"].createElement("div", {
        className: "module-box-content"
      }, _react["default"].createElement("div", {
        className: "module-box-header"
      }, _react["default"].createElement("span", {
        className: "icon-btn drawer-btn d-flex d-xl-none",
        onClick: this.onToggleProjectIssueDrawer.bind(this)
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-menu"
      })), _react["default"].createElement("div", {
        className: "d-flex align-items-center justify-content-center",
        style: {
          padding: 10
        }
      }, "Project issues for selected project - ", selectedProject === null || selectedProject === void 0 ? void 0 : selectedProject.name, ". NOTE - This dashboard uses data that may be cached for up to 1 hour\xA0\xA0\xA0", _react["default"].createElement(_reactstrap.Button, {
        className: "jr-btn jr-btn-sm btn-primary text-white mb-0",
        color: "primary",
        onClick: function onClick() {
          _this22.props.showProjectIssueLoader();

          _this22.props.fetchProjectIssues(false); // DONT use the cache

        }
      }, "Refresh Now"))), _react["default"].createElement("div", {
        className: "module-box-topbar"
      }), _react["default"].createElement(_CustomScrollbars["default"], {
        className: "module-list-scroll scrollbar",
        style: {
          height: this.props.width >= 1200 ? 'calc(105vh - 265px)' : 'calc(105vh - 245px)'
        }
      }, loader ? _react["default"].createElement("div", {
        className: "loader-view-block h-100"
      }, _react["default"].createElement("div", {
        className: "loader-view"
      }, _react["default"].createElement(_CircularProgress["default"], null))) : projectIssueList && projectIssueList.length > 0 ? _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(_projectIssueList["default"], {
        data: projectIssueList,
        width: width,
        setProjectIssue: this.setProjectIssue.bind(this),
        onDeleteProjectIssue: this.onDeleteProjectIssue.bind(this),
        onSaveProjectIssue: this.onSaveProjectIssue.bind(this),
        showProjectIssueLoader: this.showProjectIssueLoader.bind(this)
      }), _react["default"].createElement("div", {
        style: {
          marginTop: 10
        }
      }, _react["default"].createElement(_projectIssueDetail["default"], {
        projectIssueList: projectIssueList,
        selectedProjectIssue: selectedProjectIssue,
        width: width,
        setProjectIssue: this.setProjectIssue.bind(this),
        onDeleteProjectIssue: this.onDeleteProjectIssue.bind(this),
        onSaveProjectIssue: this.onSaveProjectIssue.bind(this),
        showProjectIssueLoader: this.showProjectIssueLoader.bind(this)
      }))) : _react["default"].createElement("div", {
        className: "h-100 d-flex align-items-center justify-content-center"
      }, noContentFoundMessage))))), _react["default"].createElement(_projectIssueAdd["default"], {
        open: addProjectIssueState,
        projectIssue: {
          'id': '',
          'orgid': '',
          'name': '',
          'email': '',
          'phone': '',
          'designation': '',
          'thumb': null,
          'selected': false,
          'starred': false,
          'frequently': false
        },
        onSaveProjectIssue: this.onSaveProjectIssue,
        onProjectIssueClose: this.onProjectIssueClose,
        onDeleteProjectIssue: this.onDeleteProjectIssue,
        showProjectIssueLoader: this.showProjectIssueLoader
      }), _react["default"].createElement(_jiraProjectIssueAdd["default"], {
        open: addJiraProjectIssueState,
        projectIssue: {
          'id': '',
          'orgid': '',
          'name': '',
          'email': '',
          'phone': '',
          'designation': '',
          'thumb': null,
          'selected': false,
          'starred': false,
          'frequently': false
        },
        onSaveJiraProjectIssue: this.onSaveJiraProjectIssue,
        onJiraProjectIssueClose: this.onJiraProjectIssueClose,
        showProjectIssueLoader: this.showProjectIssueLoader
      }), showMessage && _reactNotifications.NotificationManager.success(alertMessage, this.handleProjectIssueRequestClose()), _react["default"].createElement(_reactNotifications.NotificationContainer, null));
    }
  }]);

  return Component;
}(_react["default"].Component);

exports.Component = Component;
var _default = Component;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/component.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/component.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/component.js");

  __REACT_HOT_LOADER__.register(_rcDrawer, "_rcDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/component.js");

  __REACT_HOT_LOADER__.register(_projectIssueList, "_projectIssueList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/component.js");

  __REACT_HOT_LOADER__.register(_projectIssueDetail, "_projectIssueDetail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/component.js");

  __REACT_HOT_LOADER__.register(_projectIssueAdd, "_projectIssueAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/component.js");

  __REACT_HOT_LOADER__.register(_jiraProjectIssueAdd, "_jiraProjectIssueAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/component.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/component.js");

  __REACT_HOT_LOADER__.register(_CircularProgress, "_CircularProgress", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/component.js");

  __REACT_HOT_LOADER__.register(_CustomScrollbars, "_CustomScrollbars", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/component.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/component.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/component.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/component.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/component.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/component.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/component.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/component.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/component.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/component.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/component.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/component.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/component.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/component.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/component.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/component.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/component.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/component.js");
}();

;

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _projectIssueTable = _interopRequireDefault(__webpack_require__(1900));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ProjectIssueList = function ProjectIssueList(_ref) {
  var data = _ref.data,
      width = _ref.width,
      setProjectIssue = _ref.setProjectIssue,
      onDeleteProjectIssue = _ref.onDeleteProjectIssue,
      onSaveProjectIssue = _ref.onSaveProjectIssue,
      showProjectIssueLoader = _ref.showProjectIssueLoader;
  return _react["default"].createElement("div", {
    className: "app-main-content"
  }, _react["default"].createElement(_projectIssueTable["default"], {
    data: data,
    width: width,
    setProjectIssue: setProjectIssue,
    onDeleteProjectIssue: onDeleteProjectIssue,
    onSaveProjectIssue: onSaveProjectIssue,
    showProjectIssueLoader: showProjectIssueLoader
  }));
};

var _default = ProjectIssueList;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProjectIssueList, "ProjectIssueList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueList/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueList/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueList/index.js");

  __REACT_HOT_LOADER__.register(_projectIssueTable, "_projectIssueTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueList/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueList/index.js");

  __REACT_HOT_LOADER__.register(ProjectIssueList, "ProjectIssueList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueList/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueList/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueList/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueList/index.js");
}();

;

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _matchSorter = _interopRequireDefault(__webpack_require__(95));

var _reactTable = _interopRequireDefault(__webpack_require__(93));

__webpack_require__(94);

var _DateFormatters = __webpack_require__(43);

var _System = __webpack_require__(55);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var ProjectIssueTable =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ProjectIssueTable, _React$Component);

  function ProjectIssueTable(props) {
    var _this;

    _classCallCheck(this, ProjectIssueTable);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProjectIssueTable).call(this, props));
    var selected = props.selected;
    _this.state = {
      selected: selected
    };
    return _this;
  }

  _createClass(ProjectIssueTable, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          data = _this$props.data,
          width = _this$props.width,
          setProjectIssue = _this$props.setProjectIssue;
      var defaultWidth = width > _System.TIGHT_FIT_PARAM ? 150 : 80;

      var styledSummaryColumn = function styledSummaryColumn(value) {
        return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("span", {
          className: "d-inline-block text-black"
        }, _react["default"].createElement("div", {
          className: "font-weight-bold"
        }, value)));
      };

      var issueTypeColumn = {
        Header: 'Type',
        id: 'issuetype',
        accessor: function accessor(d) {
          var _d$fields, _d$fields$issuetype;

          return ((_d$fields = d.fields) === null || _d$fields === void 0 ? void 0 : (_d$fields$issuetype = _d$fields.issuetype) === null || _d$fields$issuetype === void 0 ? void 0 : _d$fields$issuetype.name) || 'unknown';
        },
        filterMethod: function filterMethod(filter, rows) {
          return (0, _matchSorter["default"])(rows, filter.value, {
            keys: ['issuetype']
          });
        },
        filterAll: true,
        width: defaultWidth
      };
      var summaryColumn = {
        Header: 'Name',
        id: 'summary',
        accessor: function accessor(d) {
          var _d$fields2;

          return (_d$fields2 = d.fields) === null || _d$fields2 === void 0 ? void 0 : _d$fields2.summary;
        },
        filterMethod: function filterMethod(filter, rows) {
          return (0, _matchSorter["default"])(rows, filter.value, {
            keys: ['summary']
          });
        },
        Cell: function Cell(_ref) {
          var value = _ref.value;
          return styledSummaryColumn(value);
        },
        filterAll: true
      };
      var createdColumn = {
        Header: 'Start Date',
        id: 'created',
        accessor: function accessor(d) {
          var _d$fields3;

          return (_d$fields3 = d.fields) === null || _d$fields3 === void 0 ? void 0 : _d$fields3.created;
        },
        filterMethod: function filterMethod(filter, rows) {
          return (0, _matchSorter["default"])(rows, filter.value, {
            keys: ['created']
          });
        },
        filterAll: true,
        Cell: function Cell(_ref2) {
          var value = _ref2.value;
          return (0, _DateFormatters.formatDateDefault)(value);
        },
        width: defaultWidth
      };
      var resolvedColumn = {
        Header: 'Resolved Date',
        id: 'resolved',
        accessor: function accessor(d) {
          var _d$fields4;

          return (_d$fields4 = d.fields) === null || _d$fields4 === void 0 ? void 0 : _d$fields4.resolutiondate;
        },
        filterMethod: function filterMethod(filter, rows) {
          return (0, _matchSorter["default"])(rows, filter.value, {
            keys: ['resolutiondate']
          });
        },
        filterAll: true,
        Cell: function Cell(_ref3) {
          var value = _ref3.value;
          return (0, _DateFormatters.formatDateDefault)(value);
        },
        width: defaultWidth
      };
      var duration = {
        Header: 'Duration',
        accessor: function accessor(d) {
          var _d$fields5, _d$fields5$progress;

          return d === null || d === void 0 ? void 0 : (_d$fields5 = d.fields) === null || _d$fields5 === void 0 ? void 0 : (_d$fields5$progress = _d$fields5.progress) === null || _d$fields5$progress === void 0 ? void 0 : _d$fields5$progress.total;
        },
        id: 'progress',
        Cell: function Cell(_ref4) {
          var value = _ref4.value;
          return (0, _DateFormatters.formatDurationAsDaysHrsMins)(value);
        },
        width: defaultWidth
      };
      var columnsList = new Array();
      columnsList.push(summaryColumn);
      columnsList.push(issueTypeColumn);
      columnsList.push(createdColumn);
      columnsList.push(resolvedColumn);

      if (width > _System.TIGHT_FIT_PARAM) {
        columnsList.push(duration);
      }

      return _react["default"].createElement("div", null, _react["default"].createElement(_reactTable["default"], {
        data: data,
        filterable: true,
        defaultFilterMethod: function defaultFilterMethod(filter, row) {
          return String(row[filter.id]) === filter.value;
        },
        columns: [{
          columns: columnsList
        }],
        defaultPageSize: 10,
        className: "-highlight",
        getTrProps: function getTrProps(state, rowInfo) {
          if (rowInfo && rowInfo.row) {
            return {
              onClick: function onClick() {
                var _rowInfo$original;

                console.log(JSON.stringify(rowInfo === null || rowInfo === void 0 ? void 0 : rowInfo.index));
                setProjectIssue(rowInfo === null || rowInfo === void 0 ? void 0 : (_rowInfo$original = rowInfo.original) === null || _rowInfo$original === void 0 ? void 0 : _rowInfo$original.id);

                _this2.setState({
                  selected: rowInfo.index
                });
              },
              style: {
                background: rowInfo.index === _this2.state.selected ? '#cfd8dc' : 'white',
                color: rowInfo.index === _this2.state.selected ? 'black' : 'black'
              }
            };
          } else {
            return {};
          }
        }
      }));
    }
  }]);

  return ProjectIssueTable;
}(_react["default"].Component);

var _default = ProjectIssueTable;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProjectIssueTable, "ProjectIssueTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueList/projectIssueTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueList/projectIssueTable/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueList/projectIssueTable/index.js");

  __REACT_HOT_LOADER__.register(_matchSorter, "_matchSorter", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueList/projectIssueTable/index.js");

  __REACT_HOT_LOADER__.register(_reactTable, "_reactTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueList/projectIssueTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueList/projectIssueTable/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueList/projectIssueTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueList/projectIssueTable/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueList/projectIssueTable/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueList/projectIssueTable/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueList/projectIssueTable/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueList/projectIssueTable/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueList/projectIssueTable/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueList/projectIssueTable/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueList/projectIssueTable/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueList/projectIssueTable/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueList/projectIssueTable/index.js");

  __REACT_HOT_LOADER__.register(ProjectIssueTable, "ProjectIssueTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueList/projectIssueTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueList/projectIssueTable/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueList/projectIssueTable/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueList/projectIssueTable/index.js");
}();

;

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _projectIssueDetailTable = _interopRequireDefault(__webpack_require__(817));

var _projectIssueDependency = _interopRequireDefault(__webpack_require__(1903));

var _projectIssueService = __webpack_require__(659);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // import { TIGHT_FIT_PARAM } from 'constants/System';


var ProjectIssueDetail = function ProjectIssueDetail(_ref) {
  var projectIssueList = _ref.projectIssueList,
      selectedProjectIssue = _ref.selectedProjectIssue,
      width = _ref.width,
      setProjectIssue = _ref.setProjectIssue; // const defaultWidth = width > TIGHT_FIT_PARAM ? 150 : 80;

  var mainIcon = function mainIcon(issueType) {
    if (issueType && issueType.toLowerCase() === 'epic') {
      return 'dashboard';
    }

    if (issueType && issueType.toLowerCase() === 'story') {
      return 'compact';
    }

    if (issueType && issueType.toLowerCase() === 'task') {
      return 'module';
    }

    if (issueType && issueType.toLowerCase() === 'sub-task') {
      return 'comfy';
    }

    return 'stream';
  };

  if (selectedProjectIssue) {
    // const fields = { ...selectedProjectIssue?.fields };
    var displayData = (0, _projectIssueService.getIssueDisplayData)(selectedProjectIssue);
    var inwardDependencies = (0, _projectIssueService.mapIssuesInwardDependenciesToDisplayData)(projectIssueList, selectedProjectIssue) || null;
    var outwardDependencies = (0, _projectIssueService.mapIssuesOutwardDependenciesToDisplayData)(projectIssueList, selectedProjectIssue) || null;
    return _react["default"].createElement("div", {
      className: "dashboard animated slideInUpTiny animation-duration-3"
    }, _react["default"].createElement("div", {
      className: "row"
    }, _react["default"].createElement("div", {
      className: "col-md-6 col-12"
    }, _react["default"].createElement("div", {
      className: "jr-card jr-card-full-height ml-2 mr-2"
    }, _react["default"].createElement("div", {
      className: "jr-card-header d-flex"
    }, _react["default"].createElement("div", {
      className: "mr-auto"
    }, _react["default"].createElement("h3", {
      className: "card-heading"
    }, displayData === null || displayData === void 0 ? void 0 : displayData.summary), _react["default"].createElement("p", {
      className: "sub-heading"
    }, displayData === null || displayData === void 0 ? void 0 : displayData.description))), _react["default"].createElement("div", {
      className: "jr-card-body"
    }, _react["default"].createElement("div", {
      className: "row"
    }, _react["default"].createElement("div", {
      className: "col-sm-3"
    }, _react["default"].createElement("div", {
      className: "temp-section mb-4 mb-sm-0 text-center text-sm-left"
    }, _react["default"].createElement("p", null, _react["default"].createElement("i", {
      className: "detail-icon text-blue-grey zmdi zmdi-view-".concat(mainIcon(displayData === null || displayData === void 0 ? void 0 : displayData.issuetype), " zmdi-hc-fw")
    })), (displayData === null || displayData === void 0 ? void 0 : displayData.issuetype) ? _react["default"].createElement("h2", {
      className: "temp-point"
    }, displayData === null || displayData === void 0 ? void 0 : displayData.issuetype) : null)), _react["default"].createElement("div", {
      className: "col-sm-9 text-center text-sm-left"
    }, _react["default"].createElement(_projectIssueDetailTable["default"], {
      displayData: displayData
    })))))), _react["default"].createElement("div", {
      className: "col-md-3"
    }, _react["default"].createElement("div", {
      className: "jr-card jr-card-full-height ml-2 mr-2"
    }, _react["default"].createElement(_projectIssueDependency["default"], {
      dependencies: inwardDependencies,
      title: _react["default"].createElement(_IntlMessages["default"], {
        id: "projectIssue.inwardDependencies"
      })
    }))), _react["default"].createElement("div", {
      className: "col-md-3"
    }, _react["default"].createElement("div", {
      className: "jr-card jr-card-full-height ml-2 mr-2"
    }, _react["default"].createElement(_projectIssueDependency["default"], {
      dependencies: outwardDependencies,
      title: _react["default"].createElement(_IntlMessages["default"], {
        id: "projectIssue.outwardDependencies"
      })
    })))));
  } else {
    return _react["default"].createElement("div", {
      className: "dashboard animated slideInUpTiny animation-duration-3"
    }, _react["default"].createElement("div", {
      className: "row"
    }, _react["default"].createElement("div", {
      className: "col-md-12 col-12"
    }, _react["default"].createElement("div", {
      className: "jr-card jr-card-full-height"
    }, _react["default"].createElement("div", {
      className: "jr-card-header d-flex"
    }, _react["default"].createElement("div", {
      className: "mr-auto"
    }, _react["default"].createElement("h3", {
      className: "card-heading"
    }, "Please select an issue to display details")))))));
  }
};

var _default = ProjectIssueDetail;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProjectIssueDetail, "ProjectIssueDetail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/index.js");

  __REACT_HOT_LOADER__.register(_projectIssueDetailTable, "_projectIssueDetailTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/index.js");

  __REACT_HOT_LOADER__.register(_projectIssueDependency, "_projectIssueDependency", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/index.js");

  __REACT_HOT_LOADER__.register(ProjectIssueDetail, "ProjectIssueDetail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/index.js");
}();

;

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ProjectIssueDetailRow = function ProjectIssueDetailRow(_ref) {
  var label = _ref.label,
      description = _ref.description;
  return _react["default"].createElement("tr", null, _react["default"].createElement("td", null, _react["default"].createElement("div", {
    className: "user-profile d-flex flex-row align-items-center"
  }, _react["default"].createElement("div", {
    className: "user-detail"
  }, _react["default"].createElement("h5", {
    className: "user-name"
  }, label, " ")))), _react["default"].createElement("td", {
    className: "text-right"
  }, _react["default"].createElement("div", null, description)));
};

var _default = ProjectIssueDetailRow;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProjectIssueDetailRow, "ProjectIssueDetailRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/projectIssueDetailRow/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/projectIssueDetailRow/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/projectIssueDetailRow/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/projectIssueDetailRow/index.js");

  __REACT_HOT_LOADER__.register(ProjectIssueDetailRow, "ProjectIssueDetailRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/projectIssueDetailRow/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/projectIssueDetailRow/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/projectIssueDetailRow/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/projectIssueDetailRow/index.js");
}();

;

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactCollapsible = _interopRequireDefault(__webpack_require__(161));

var _ContainerHeader = _interopRequireDefault(__webpack_require__(63));

var _projectIssueDetailTable = _interopRequireDefault(__webpack_require__(817));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var ProjectIssueDependency = function ProjectIssueDependency(_ref) {
  var dependencies = _ref.dependencies,
      title = _ref.title;

  if (dependencies && Array.isArray(dependencies) && dependencies.length > 0) {
    return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(_ContainerHeader["default"], {
      title: title
    }), _react["default"].createElement("div", {
      className: "row"
    }, _react["default"].createElement("div", {
      className: "col-md-12 col-sm-12 col-12"
    }, dependencies.map(function (dependency, index) {
      return _react["default"].createElement(_reactCollapsible["default"], {
        trigger: dependency === null || dependency === void 0 ? void 0 : dependency.summary,
        key: index,
        triggerStyle: {
          afterTop: 2,
          backgroundColor: 'black',
          paddingTop: 8,
          paddingBottom: 8
        }
      }, _react["default"].createElement("div", {
        className: "col-sm-12 text-center text-sm-left"
      }, _react["default"].createElement(_projectIssueDetailTable["default"], {
        displayData: dependency
      })));
    }))));
  } else {
    return _react["default"].createElement("div", {
      className: "row"
    }, _react["default"].createElement("div", {
      className: "col-md-12 col-12"
    }, _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(_ContainerHeader["default"], {
      title: title
    }), _react["default"].createElement("div", {
      className: "mr-auto"
    }, _react["default"].createElement("h3", {
      className: "card-heading"
    }, "No dependencies found here")))));
  }
};

var _default = ProjectIssueDependency;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProjectIssueDependency, "ProjectIssueDependency", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/projectIssueDependency/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/projectIssueDependency/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/projectIssueDependency/index.js");

  __REACT_HOT_LOADER__.register(_reactCollapsible, "_reactCollapsible", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/projectIssueDependency/index.js");

  __REACT_HOT_LOADER__.register(_ContainerHeader, "_ContainerHeader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/projectIssueDependency/index.js");

  __REACT_HOT_LOADER__.register(_projectIssueDetailTable, "_projectIssueDetailTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/projectIssueDependency/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/projectIssueDependency/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/projectIssueDependency/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/projectIssueDependency/index.js");

  __REACT_HOT_LOADER__.register(ProjectIssueDependency, "ProjectIssueDependency", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/projectIssueDependency/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/projectIssueDependency/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/projectIssueDependency/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueDetail/projectIssueDependency/index.js");
}();

;

/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _DayPickerInput = _interopRequireDefault(__webpack_require__(201));

var _FormErrors = _interopRequireDefault(__webpack_require__(38));

var _CardBox = _interopRequireDefault(__webpack_require__(228));

var _Validation = __webpack_require__(14);

var _DateService = __webpack_require__(48);

var _DateFormatters = __webpack_require__(43);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ProjectIssueAdd =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ProjectIssueAdd, _React$Component);

  function ProjectIssueAdd(props) {
    var _this;

    _classCallCheck(this, ProjectIssueAdd);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProjectIssueAdd).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleUserInput", function () {
      var _this2;

      return (_this2 = _this).__handleUserInput__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    _this.handleStartDateChange = _this.handleStartDateChange.bind(_assertThisInitialized(_this));
    _this.handleEndDateChange = _this.handleEndDateChange.bind(_assertThisInitialized(_this));
    var _props$projectIssue = props.projectIssue,
        id = _props$projectIssue.id,
        orgid = _props$projectIssue.orgid,
        thumb = _props$projectIssue.thumb,
        name = _props$projectIssue.name,
        description = _props$projectIssue.description,
        startDate = _props$projectIssue.startDate,
        endDate = _props$projectIssue.endDate,
        priority = _props$projectIssue.priority,
        starred = _props$projectIssue.starred,
        selected = _props$projectIssue.selected,
        frequently = _props$projectIssue.frequently;
    _this.state = {
      id: id,
      orgid: orgid,
      thumb: thumb,
      name: name,
      description: description,
      startDate: startDate,
      endDate: endDate,
      priority: priority,
      starred: starred,
      selected: selected,
      frequently: frequently,
      nameValid: (0, _Validation.isNameValid)(name),
      startDateValid: (0, _Validation.isValueEntered)(startDate),
      endDateValid: (0, _Validation.isValueEntered)(endDate),
      formErrors: {
        name: '',
        startDate: '',
        endDate: '',
        dates: ''
      },
      datesValid: false,
      formValid: false
    };
    return _this;
  }

  _createClass(ProjectIssueAdd, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.validateForm();
    }
  }, {
    key: "__handleUserInput__REACT_HOT_LOADER__",
    value: function __handleUserInput__REACT_HOT_LOADER__(e) {
      var _this3 = this;

      var name = e.target.name;
      var value = e.target.value;
      this.setState(_defineProperty({}, name, value), function () {
        _this3.validateField(name, value);
      } // run this call back on state change
      );
    }
  }, {
    key: "validateField",
    value: function validateField(fieldName, value) {
      var fieldValidationErrors = this.state.formErrors;
      var nameValid = this.state.nameValid;
      var startDateValid = this.state.startDateValid;
      var endDateValid = this.state.endDateValid;

      switch (fieldName) {
        case 'name':
          nameValid = (0, _Validation.isNameValid)(value);
          fieldValidationErrors.name = nameValid ? '' : ' is invalid';
          break;

        case 'startDate':
          startDateValid = (0, _Validation.isValueEntered)(value);
          fieldValidationErrors.startDate = startDateValid ? '' : ' is invalid';
          break;

        case 'endDate':
          endDateValid = (0, _Validation.isValueEntered)(value);
          fieldValidationErrors.endDate = endDateValid ? '' : ' is invalid';
          break;

        default:
          break;
      }

      this.setState({
        formErrors: fieldValidationErrors,
        nameValid: nameValid,
        startDateValid: startDateValid,
        endDateValid: endDateValid
      }, this.validateForm);
    }
  }, {
    key: "validateForm",
    value: function validateForm() {
      var datesAreValid = this.datesValid();
      this.setState({
        formValid: this.state.nameValid && datesAreValid
      });
    }
  }, {
    key: "datesValid",
    value: function datesValid() {
      var _this$state = this.state,
          startDate = _this$state.startDate,
          endDate = _this$state.endDate;
      var fieldValidationErrors = this.state.formErrors;

      if ((0, _Validation.isValueEntered)(startDate) && (0, _Validation.isValueEntered)(endDate)) {
        if ((0, _DateService.isDateBefore)(endDate, startDate)) {
          fieldValidationErrors.dates = ' are invalid. The end date selected cannot be before the start date';
          this.setState({
            formErrors: fieldValidationErrors
          });
          return false;
        }

        fieldValidationErrors.dates = '';
        this.setState({
          formErrors: fieldValidationErrors
        });
        return true;
      }

      return true;
    }
  }, {
    key: "handleStartDateChange",
    value: function handleStartDateChange(selectedDay) {
      var _this4 = this;

      this.setState({
        startDate: selectedDay
      }, function () {
        _this4.validateField('startDate', selectedDay);
      });
    }
  }, {
    key: "handleEndDateChange",
    value: function handleEndDateChange(selectedDay) {
      var _this5 = this;

      this.setState({
        endDate: selectedDay
      }, function () {
        _this5.validateField('endDate', selectedDay);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var _this$props = this.props,
          onSaveProjectIssue = _this$props.onSaveProjectIssue,
          showProjectIssueLoader = _this$props.showProjectIssueLoader,
          onProjectIssueClose = _this$props.onProjectIssueClose,
          open = _this$props.open,
          projectIssue = _this$props.projectIssue;
      var _this$state2 = this.state,
          id = _this$state2.id,
          orgid = _this$state2.orgid,
          name = _this$state2.name,
          description = _this$state2.description,
          startDate = _this$state2.startDate,
          endDate = _this$state2.endDate,
          starred = _this$state2.starred,
          selected = _this$state2.selected,
          frequently = _this$state2.frequently;
      var isNew = projectIssue.name === '';
      var thumb = this.state.thumb;
      return _react["default"].createElement(_reactstrap.Modal, {
        className: "modal-box",
        toggle: onProjectIssueClose,
        isOpen: open
      }, _react["default"].createElement(_reactstrap.ModalHeader, {
        className: "modal-box-header bg-primary"
      }, isNew ? _react["default"].createElement(_IntlMessages["default"], {
        id: "projectIssue.addProjectIssue"
      }) : _react["default"].createElement(_IntlMessages["default"], {
        id: "projectIssue.saveProjectIssue"
      }), _react["default"].createElement("span", {
        className: "text-white pointer"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-close zmdi-hc-lg",
        onClick: onProjectIssueClose
      }))), _react["default"].createElement("div", {
        className: "modal-box-content"
      }, _react["default"].createElement("div", {
        className: "row no-gutters"
      }, _react["default"].createElement("div", {
        className: "col-lg-3 text-center text-lg-right order-lg-2"
      }, _react["default"].createElement("img", {
        id: "thumb",
        className: "ml-lg-3 mb-4 mb-lg-0 avatar size-120",
        src: thumb
      })), _react["default"].createElement("div", {
        className: "panel panel-default"
      }, _react["default"].createElement(_FormErrors["default"], {
        formErrors: this.state.formErrors
      })), _react["default"].createElement("div", {
        className: "col-lg-9 d-flex flex-column order-lg-1"
      }, _react["default"].createElement("h3", {
        className: "card-heading"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "label.name"
      })), _react["default"].createElement("input", {
        type: "text",
        className: "form-control mb-2 ".concat(name ? 'is-valid' : 'is-invalid'),
        onChange: function onChange(event) {
          return _this6.handleUserInput(event);
        },
        defaultValue: name,
        name: "name"
      }), _react["default"].createElement("h3", {
        className: "card-heading"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "label.description"
      })), _react["default"].createElement("input", {
        type: "text",
        className: "form-control mb-2",
        onChange: function onChange(event) {
          return _this6.handleUserInput(event);
        },
        defaultValue: description,
        name: "description"
      }), _react["default"].createElement("h3", {
        className: "card-heading mt-2"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "label.startDate"
      })), _react["default"].createElement("div", {
        className: "form-control"
      }, _react["default"].createElement(_DayPickerInput["default"], {
        value: (0, _DateFormatters.formatDateDefault)(startDate),
        onDayChange: this.handleStartDateChange,
        dayPickerProps: {
          selectedDays: new Date(startDate)
        }
      })), _react["default"].createElement("h3", {
        className: "card-heading mt-2"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "label.endDate"
      })), _react["default"].createElement("div", {
        className: "form-control"
      }, _react["default"].createElement(_DayPickerInput["default"], {
        value: (0, _DateFormatters.formatDateDefault)(endDate),
        onDayChange: this.handleEndDateChange,
        dayPickerProps: {
          selectedDays: new Date(endDate)
        }
      }))))), _react["default"].createElement("div", {
        className: "modal-box-footer d-flex flex-row"
      }, _react["default"].createElement(_reactstrap.Button, {
        className: "text-uppercase",
        disabled: !this.state.formValid,
        color: "primary",
        onClick: function onClick() {
          showProjectIssueLoader();
          onProjectIssueClose();
          onSaveProjectIssue({
            'id': id,
            'orgid': orgid,
            'name': name,
            'description': description,
            'startDate': startDate,
            'endDate': endDate,
            'starred': starred,
            'selected': selected,
            'frequently': frequently,
            'thumb': null
          });

          _this6.setState({
            id: '',
            orgid: '',
            name: '',
            description: '',
            startDate: '',
            endDate: '',
            thumb: null,
            selected: false,
            starred: false,
            frequently: false,
            formErrors: {
              name: '',
              startDate: '',
              endDate: '',
              dates: ''
            },
            datesValid: false,
            formValid: false
          });
        }
      }, isNew ? _react["default"].createElement(_IntlMessages["default"], {
        id: "projectIssue.addProjectIssue"
      }) : _react["default"].createElement(_IntlMessages["default"], {
        id: "projectIssue.saveProjectIssue"
      }))));
    }
  }]);

  return ProjectIssueAdd;
}(_react["default"].Component);

var _default = ProjectIssueAdd;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProjectIssueAdd, "ProjectIssueAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueAdd/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_DayPickerInput, "_DayPickerInput", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_FormErrors, "_FormErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_CardBox, "_CardBox", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(ProjectIssueAdd, "ProjectIssueAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/projectIssueAdd/index.js");
}();

;

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _FormErrors = _interopRequireDefault(__webpack_require__(38));

var _Validation = __webpack_require__(14);

var _DateService = __webpack_require__(48);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var JiraProjectIssueAdd =
/*#__PURE__*/
function (_React$Component) {
  _inherits(JiraProjectIssueAdd, _React$Component);

  function JiraProjectIssueAdd(props) {
    var _this;

    _classCallCheck(this, JiraProjectIssueAdd);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(JiraProjectIssueAdd).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleUserInput", function () {
      var _this2;

      return (_this2 = _this).__handleUserInput__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    _this.handleStartDateChange = _this.handleStartDateChange.bind(_assertThisInitialized(_this));
    _this.handleEndDateChange = _this.handleEndDateChange.bind(_assertThisInitialized(_this));
    var _props$projectIssue = props.projectIssue,
        id = _props$projectIssue.id,
        orgid = _props$projectIssue.orgid,
        thumb = _props$projectIssue.thumb,
        name = _props$projectIssue.name,
        description = _props$projectIssue.description,
        startDate = _props$projectIssue.startDate,
        endDate = _props$projectIssue.endDate,
        priority = _props$projectIssue.priority,
        starred = _props$projectIssue.starred,
        selected = _props$projectIssue.selected,
        frequently = _props$projectIssue.frequently;
    _this.state = {
      id: id,
      orgid: orgid,
      thumb: thumb,
      name: name,
      description: description,
      startDate: startDate,
      endDate: endDate,
      priority: priority,
      starred: starred,
      selected: selected,
      frequently: frequently,
      nameValid: (0, _Validation.isNameValid)(name),
      startDateValid: (0, _Validation.isValueEntered)(startDate),
      endDateValid: (0, _Validation.isValueEntered)(endDate),
      formErrors: {
        name: '',
        startDate: '',
        endDate: '',
        dates: ''
      },
      datesValid: false,
      formValid: false
    };
    return _this;
  }

  _createClass(JiraProjectIssueAdd, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.validateForm();
    }
  }, {
    key: "__handleUserInput__REACT_HOT_LOADER__",
    value: function __handleUserInput__REACT_HOT_LOADER__(e) {
      var _this3 = this;

      var name = e.target.name;
      var value = e.target.value;
      this.setState(_defineProperty({}, name, value), function () {
        _this3.validateField(name, value);
      } // run this call back on state change
      );
    }
  }, {
    key: "validateField",
    value: function validateField(fieldName, value) {
      var fieldValidationErrors = this.state.formErrors;
      var nameValid = this.state.nameValid;
      var startDateValid = this.state.startDateValid;
      var endDateValid = this.state.endDateValid;

      switch (fieldName) {
        case 'name':
          nameValid = (0, _Validation.isNameValid)(value);
          fieldValidationErrors.name = nameValid ? '' : ' is invalid';
          break;

        case 'startDate':
          startDateValid = (0, _Validation.isValueEntered)(value);
          fieldValidationErrors.startDate = startDateValid ? '' : ' is invalid';
          break;

        case 'endDate':
          endDateValid = (0, _Validation.isValueEntered)(value);
          fieldValidationErrors.endDate = endDateValid ? '' : ' is invalid';
          break;

        default:
          break;
      }

      this.setState({
        formErrors: fieldValidationErrors,
        nameValid: nameValid,
        startDateValid: startDateValid,
        endDateValid: endDateValid
      }, this.validateForm);
    }
  }, {
    key: "validateForm",
    value: function validateForm() {
      var datesAreValid = this.datesValid();
      this.setState({
        formValid: this.state.nameValid && datesAreValid
      });
    }
  }, {
    key: "datesValid",
    value: function datesValid() {
      var _this$state = this.state,
          startDate = _this$state.startDate,
          endDate = _this$state.endDate;
      var fieldValidationErrors = this.state.formErrors;

      if ((0, _Validation.isValueEntered)(startDate) && (0, _Validation.isValueEntered)(endDate)) {
        if ((0, _DateService.isDateBefore)(endDate, startDate)) {
          fieldValidationErrors.dates = ' are invalid. The end date selected cannot be before the start date';
          this.setState({
            formErrors: fieldValidationErrors
          });
          return false;
        }

        fieldValidationErrors.dates = '';
        this.setState({
          formErrors: fieldValidationErrors
        });
        return true;
      }

      return true;
    }
  }, {
    key: "handleStartDateChange",
    value: function handleStartDateChange(selectedDay) {
      var _this4 = this;

      this.setState({
        startDate: selectedDay
      }, function () {
        _this4.validateField('startDate', selectedDay);
      });
    }
  }, {
    key: "handleEndDateChange",
    value: function handleEndDateChange(selectedDay) {
      var _this5 = this;

      this.setState({
        endDate: selectedDay
      }, function () {
        _this5.validateField('endDate', selectedDay);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var _this$props = this.props,
          onSaveJiraProjectIssue = _this$props.onSaveJiraProjectIssue,
          showProjectIssueLoader = _this$props.showProjectIssueLoader,
          onJiraProjectIssueClose = _this$props.onJiraProjectIssueClose,
          open = _this$props.open,
          projectIssue = _this$props.projectIssue;
      var _this$state2 = this.state,
          id = _this$state2.id,
          orgid = _this$state2.orgid,
          name = _this$state2.name,
          email = _this$state2.email,
          selected = _this$state2.selected,
          starred = _this$state2.starred,
          frequently = _this$state2.frequently;
      var isNew = projectIssue.name === '';
      var thumb = this.state.thumb;
      return _react["default"].createElement(_reactstrap.Modal, {
        className: "modal-box",
        toggle: onJiraProjectIssueClose,
        isOpen: open
      }, _react["default"].createElement(_reactstrap.ModalHeader, {
        className: "modal-box-header bg-primary"
      }, isNew ? _react["default"].createElement(_IntlMessages["default"], {
        id: "projectIssue.addProjectIssue"
      }) : _react["default"].createElement(_IntlMessages["default"], {
        id: "projectIssue.saveProjectIssue"
      }), _react["default"].createElement("span", {
        className: "text-white pointer"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-close zmdi-hc-lg",
        onClick: onJiraProjectIssueClose
      }))), _react["default"].createElement("div", {
        className: "modal-box-content"
      }, _react["default"].createElement("div", {
        className: "row no-gutters"
      }, _react["default"].createElement("div", {
        className: "col-lg-3 text-center text-lg-right order-lg-2"
      }, _react["default"].createElement("img", {
        id: "thumb",
        className: "ml-lg-3 mb-4 mb-lg-0 avatar size-120",
        src: thumb
      })), _react["default"].createElement("div", {
        className: "panel panel-default"
      }, _react["default"].createElement(_FormErrors["default"], {
        formErrors: this.state.formErrors
      })), _react["default"].createElement("div", {
        className: "col-lg-9 d-flex flex-column order-lg-1"
      }, _react["default"].createElement("input", {
        id: "name",
        type: "text",
        className: "form-control mb-2",
        placeholder: "Name",
        onChange: function onChange(event) {
          return _this6.handleUserInput(event);
        },
        defaultValue: name,
        name: "name"
      }), _react["default"].createElement("input", {
        id: "email",
        type: "text",
        className: "form-control mb-2",
        placeholder: "Email",
        onChange: function onChange(event) {
          return _this6.handleUserInput(event);
        },
        value: email,
        name: "email"
      })))), _react["default"].createElement("div", {
        className: "modal-box-footer d-flex flex-row"
      }, _react["default"].createElement(_reactstrap.Button, {
        className: "text-uppercase",
        disabled: !this.state.formValid,
        color: "primary",
        onClick: function onClick() {
          showProjectIssueLoader();
          onJiraProjectIssueClose();
          onSaveJiraProjectIssue({
            'id': id,
            'orgid': orgid,
            'name': name,
            'email': email,
            'thumb': null,
            'selected': selected,
            'starred': starred,
            'frequently': frequently
          });

          _this6.setState({
            id: '',
            orgid: '',
            name: '',
            email: '',
            thumb: null,
            selected: false,
            starred: false,
            frequently: false,
            formErrors: {
              name: '',
              startDate: '',
              endDate: '',
              dates: ''
            },
            datesValid: false,
            formValid: false
          });
        }
      }, isNew ? _react["default"].createElement(_IntlMessages["default"], {
        id: "projectIssue.addProjectIssue"
      }) : _react["default"].createElement(_IntlMessages["default"], {
        id: "projectIssue.saveProjectIssue"
      }))));
    }
  }]);

  return JiraProjectIssueAdd;
}(_react["default"].Component);

var _default = JiraProjectIssueAdd;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(JiraProjectIssueAdd, "JiraProjectIssueAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/jiraProjectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/jiraProjectIssueAdd/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/jiraProjectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/jiraProjectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_FormErrors, "_FormErrors", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/jiraProjectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/jiraProjectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/jiraProjectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/jiraProjectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/jiraProjectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/jiraProjectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/jiraProjectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/jiraProjectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/jiraProjectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/jiraProjectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/jiraProjectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/jiraProjectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(JiraProjectIssueAdd, "JiraProjectIssueAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/jiraProjectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/jiraProjectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/jiraProjectIssueAdd/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectIssue/jiraProjectIssueAdd/index.js");
}();

;

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _container["default"];
  }
});

var _container = _interopRequireDefault(__webpack_require__(1907));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_container, "_container", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/index.js");
}();

;

/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.mapStateToProps = void 0;

var _reactRedux = __webpack_require__(10);

var _businessUnit = __webpack_require__(263);

var _component = _interopRequireDefault(__webpack_require__(1908));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var mapStateToProps = function mapStateToProps(_ref) {
  var businessUnits = _ref.businessUnits,
      settings = _ref.settings;
  var width = settings.width;
  var loader = businessUnits.loader,
      alertMessage = businessUnits.alertMessage,
      showMessage = businessUnits.showMessage,
      noContentFoundMessage = businessUnits.noContentFoundMessage,
      selectedSectionId = businessUnits.selectedSectionId,
      drawerState = businessUnits.drawerState,
      businessUnit = businessUnits.businessUnit,
      searchBusinessUnit = businessUnits.searchBusinessUnit,
      filterOption = businessUnits.filterOption,
      allBusinessUnit = businessUnits.allBusinessUnit,
      businessUnitList = businessUnits.businessUnitList,
      selectedBusinessUnit = businessUnits.selectedBusinessUnit,
      selectedBusinessUnits = businessUnits.selectedBusinessUnits,
      addBusinessUnitState = businessUnits.addBusinessUnitState;
  return {
    width: width,
    loader: loader,
    alertMessage: alertMessage,
    showMessage: showMessage,
    noContentFoundMessage: noContentFoundMessage,
    selectedSectionId: selectedSectionId,
    drawerState: drawerState,
    businessUnit: businessUnit,
    searchBusinessUnit: searchBusinessUnit,
    filterOption: filterOption,
    allBusinessUnit: allBusinessUnit,
    businessUnitList: businessUnitList,
    selectedBusinessUnit: selectedBusinessUnit,
    selectedBusinessUnits: selectedBusinessUnits,
    addBusinessUnitState: addBusinessUnitState
  };
};

exports.mapStateToProps = mapStateToProps;

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  fetchBusinessUnits: _businessUnit.fetchBusinessUnits,
  addFavouriteBusinessUnit: _businessUnit.addFavouriteBusinessUnit,
  onBusinessUnitSelect: _businessUnit.onBusinessUnitSelect,
  onAddBusinessUnit: _businessUnit.onAddBusinessUnit,
  onBusinessUnitClose: _businessUnit.onBusinessUnitClose,
  onFilterBusinessUnitOptionSelect: _businessUnit.onFilterBusinessUnitOptionSelect,
  onSaveBusinessUnit: _businessUnit.onSaveBusinessUnit,
  onDeleteBusinessUnit: _businessUnit.onDeleteBusinessUnit,
  onFilterSelectedBusinessUnit: _businessUnit.onFilterSelectedBusinessUnit,
  filterBusinessUnit: _businessUnit.filterBusinessUnit,
  getAllBusinessUnit: _businessUnit.getAllBusinessUnit,
  getUnselectedAllBusinessUnit: _businessUnit.getUnselectedAllBusinessUnit,
  onAllBusinessUnitSelect: _businessUnit.onAllBusinessUnitSelect,
  updateSearchBusinessUnit: _businessUnit.updateSearchBusinessUnit,
  onToggleBusinessUnitDrawer: _businessUnit.onToggleBusinessUnitDrawer,
  handleBusinessUnitRequestClose: _businessUnit.handleBusinessUnitRequestClose,
  hideBusinessUnitLoader: _businessUnit.hideBusinessUnitLoader,
  showBusinessUnitLoader: _businessUnit.showBusinessUnitLoader
})(_component["default"]);

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/container.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/container.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_component, "_component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/container.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/container.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/container.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/container.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/container.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/container.js");
}();

;

/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Component = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _rcDrawer = _interopRequireDefault(__webpack_require__(31));

var _reactNotifications = __webpack_require__(30);

var _reactstrap = __webpack_require__(6);

var _businessUnitList = _interopRequireDefault(__webpack_require__(1909));

var _index = _interopRequireDefault(__webpack_require__(66));

var _businessUnitAdd = _interopRequireDefault(__webpack_require__(818));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _CircularProgress = _interopRequireDefault(__webpack_require__(24));

var _CustomScrollbars = _interopRequireDefault(__webpack_require__(27));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var filterOptions = [{
  id: 1,
  name: 'All business units',
  icon: 'zmdi-menu'
}, {
  id: 2,
  name: 'Starred business units',
  icon: 'zmdi-star'
}];

var Component =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Component, _React$Component);

  _createClass(Component, [{
    key: "__businessUnitSideBar__REACT_HOT_LOADER__",
    value: function __businessUnitSideBar__REACT_HOT_LOADER__() {
      var _this2 = this;

      return _react["default"].createElement("div", {
        className: "module-side"
      }, _react["default"].createElement("div", {
        className: "module-side-header"
      }, _react["default"].createElement("div", {
        className: "module-logo"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-city-alt mr-4"
      }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "sidebar.businessUnits"
      })))), _react["default"].createElement("div", {
        className: "module-side-content"
      }, _react["default"].createElement(_CustomScrollbars["default"], {
        className: "module-side-scroll scrollbar",
        style: {
          height: this.props.width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)'
        }
      }, _react["default"].createElement("div", {
        className: "module-add-task"
      }, _react["default"].createElement(_reactstrap.Button, {
        className: "btn-block jr-btn",
        color: "primary",
        onClick: this.onAddBusinessUnit
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-accounts-add zmdi-hc-fw"
      }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "businessUnit.addBusinessUnit"
      })))), _react["default"].createElement("div", {
        className: "module-side-nav"
      }, _react["default"].createElement("ul", {
        className: "module-nav"
      }, filterOptions.map(function (option) {
        return _react["default"].createElement("li", {
          key: option.id,
          className: "nav-item"
        }, _react["default"].createElement("a", {
          href: "javascript:void(0)",
          className: option.id === _this2.props.selectedSectionId ? 'active' : '',
          onClick: _this2.onFilterBusinessUnitOptionSelect.bind(_this2, option)
        }, _react["default"].createElement("i", {
          className: "zmdi ".concat(option.icon)
        }), _react["default"].createElement("span", null, option.name)));
      }))))));
    }
  }, {
    key: "__addFavouriteBusinessUnit__REACT_HOT_LOADER__",
    value: function __addFavouriteBusinessUnit__REACT_HOT_LOADER__(data) {
      this.props.addFavouriteBusinessUnit(data);
    }
  }, {
    key: "__onBusinessUnitSelect__REACT_HOT_LOADER__",
    value: function __onBusinessUnitSelect__REACT_HOT_LOADER__(data) {
      this.props.onBusinessUnitSelect(data);
    }
  }, {
    key: "__onAddBusinessUnit__REACT_HOT_LOADER__",
    value: function __onAddBusinessUnit__REACT_HOT_LOADER__() {
      this.props.onAddBusinessUnit();
    }
  }, {
    key: "__onBusinessUnitClose__REACT_HOT_LOADER__",
    value: function __onBusinessUnitClose__REACT_HOT_LOADER__() {
      this.props.onBusinessUnitClose();
    }
  }, {
    key: "__onFilterBusinessUnitOptionSelect__REACT_HOT_LOADER__",
    value: function __onFilterBusinessUnitOptionSelect__REACT_HOT_LOADER__(option) {
      this.props.onFilterBusinessUnitOptionSelect(option);
    }
  }, {
    key: "__onSaveBusinessUnit__REACT_HOT_LOADER__",
    value: function __onSaveBusinessUnit__REACT_HOT_LOADER__(data) {
      this.props.onSaveBusinessUnit(data);
    }
  }, {
    key: "__onDeleteBusinessUnit__REACT_HOT_LOADER__",
    value: function __onDeleteBusinessUnit__REACT_HOT_LOADER__(data) {
      this.props.onDeleteBusinessUnit(data);
    }
  }, {
    key: "__onFilterSelectedBusinessUnit__REACT_HOT_LOADER__",
    value: function __onFilterSelectedBusinessUnit__REACT_HOT_LOADER__() {
      this.props.onFilterSelectedBusinessUnit();
    }
  }, {
    key: "__filterBusinessUnit__REACT_HOT_LOADER__",
    value: function __filterBusinessUnit__REACT_HOT_LOADER__(businessUnitName) {
      if (businessUnitName === '') {
        this.onFilterBusinessUnitOptionSelect(this.props.filterOption);
      } else {
        this.props.filterBusinessUnit(businessUnitName);
      }
    }
  }, {
    key: "__handleBusinessUnitRequestClose__REACT_HOT_LOADER__",
    value: function __handleBusinessUnitRequestClose__REACT_HOT_LOADER__() {
      this.props.handleBusinessUnitRequestClose();
    }
  }, {
    key: "__getAllBusinessUnit__REACT_HOT_LOADER__",
    value: function __getAllBusinessUnit__REACT_HOT_LOADER__() {
      this.props.getAllBusinessUnit();
    }
  }, {
    key: "__getUnselectedAllBusinessUnit__REACT_HOT_LOADER__",
    value: function __getUnselectedAllBusinessUnit__REACT_HOT_LOADER__() {
      this.props.getUnselectedAllBusinessUnit();
    }
  }, {
    key: "__onAllBusinessUnitSelect__REACT_HOT_LOADER__",
    value: function __onAllBusinessUnitSelect__REACT_HOT_LOADER__() {
      var selectAll = this.props.selectedBusinessUnits < this.props.businessUnitList.length;

      if (selectAll) {
        this.props.getAllBusinessUnit();
      } else {
        this.props.getUnselectedAllBusinessUnit();
      }
    }
  }, {
    key: "__onToggleBusinessUnitDrawer__REACT_HOT_LOADER__",
    value: function __onToggleBusinessUnitDrawer__REACT_HOT_LOADER__() {
      this.props.onToggleBusinessUnitDrawer();
    }
  }, {
    key: "__showBusinessUnitLoader__REACT_HOT_LOADER__",
    value: function __showBusinessUnitLoader__REACT_HOT_LOADER__() {
      this.props.showBusinessUnitLoader();
    }
  }]);

  function Component() {
    var _this;

    _classCallCheck(this, Component);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Component).call(this));

    _defineProperty(_assertThisInitialized(_this), "businessUnitSideBar", function () {
      var _this3;

      return (_this3 = _this).__businessUnitSideBar__REACT_HOT_LOADER__.apply(_this3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "addFavouriteBusinessUnit", function () {
      var _this4;

      return (_this4 = _this).__addFavouriteBusinessUnit__REACT_HOT_LOADER__.apply(_this4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onBusinessUnitSelect", function () {
      var _this5;

      return (_this5 = _this).__onBusinessUnitSelect__REACT_HOT_LOADER__.apply(_this5, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onAddBusinessUnit", function () {
      var _this6;

      return (_this6 = _this).__onAddBusinessUnit__REACT_HOT_LOADER__.apply(_this6, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onBusinessUnitClose", function () {
      var _this7;

      return (_this7 = _this).__onBusinessUnitClose__REACT_HOT_LOADER__.apply(_this7, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onFilterBusinessUnitOptionSelect", function () {
      var _this8;

      return (_this8 = _this).__onFilterBusinessUnitOptionSelect__REACT_HOT_LOADER__.apply(_this8, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onSaveBusinessUnit", function () {
      var _this9;

      return (_this9 = _this).__onSaveBusinessUnit__REACT_HOT_LOADER__.apply(_this9, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onDeleteBusinessUnit", function () {
      var _this10;

      return (_this10 = _this).__onDeleteBusinessUnit__REACT_HOT_LOADER__.apply(_this10, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onFilterSelectedBusinessUnit", function () {
      var _this11;

      return (_this11 = _this).__onFilterSelectedBusinessUnit__REACT_HOT_LOADER__.apply(_this11, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "filterBusinessUnit", function () {
      var _this12;

      return (_this12 = _this).__filterBusinessUnit__REACT_HOT_LOADER__.apply(_this12, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "handleBusinessUnitRequestClose", function () {
      var _this13;

      return (_this13 = _this).__handleBusinessUnitRequestClose__REACT_HOT_LOADER__.apply(_this13, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "getAllBusinessUnit", function () {
      var _this14;

      return (_this14 = _this).__getAllBusinessUnit__REACT_HOT_LOADER__.apply(_this14, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "getUnselectedAllBusinessUnit", function () {
      var _this15;

      return (_this15 = _this).__getUnselectedAllBusinessUnit__REACT_HOT_LOADER__.apply(_this15, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onAllBusinessUnitSelect", function () {
      var _this16;

      return (_this16 = _this).__onAllBusinessUnitSelect__REACT_HOT_LOADER__.apply(_this16, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onToggleBusinessUnitDrawer", function () {
      var _this17;

      return (_this17 = _this).__onToggleBusinessUnitDrawer__REACT_HOT_LOADER__.apply(_this17, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "showBusinessUnitLoader", function () {
      var _this18;

      return (_this18 = _this).__showBusinessUnitLoader__REACT_HOT_LOADER__.apply(_this18, arguments);
    });

    return _this;
  }

  _createClass(Component, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.showBusinessUnitLoader();
      this.props.fetchBusinessUnits();
    }
  }, {
    key: "updateSearchBusinessUnit",
    value: function updateSearchBusinessUnit(evt) {
      this.props.updateSearchBusinessUnit(evt.target.value);
      this.props.filterBusinessUnit(evt.target.value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          width = _this$props.width,
          businessUnit = _this$props.businessUnit,
          businessUnitList = _this$props.businessUnitList,
          addBusinessUnitState = _this$props.addBusinessUnitState,
          selectedBusinessUnits = _this$props.selectedBusinessUnits,
          alertMessage = _this$props.alertMessage,
          showMessage = _this$props.showMessage,
          drawerState = _this$props.drawerState,
          noContentFoundMessage = _this$props.noContentFoundMessage,
          loader = _this$props.loader;
      return _react["default"].createElement("div", {
        className: "app-wrapper"
      }, _react["default"].createElement("div", {
        className: "app-module animated slideInUpTiny animation-duration-3"
      }, _react["default"].createElement("div", {
        className: "d-block d-xl-none"
      }, _react["default"].createElement(_rcDrawer["default"], {
        touch: true,
        transitions: true,
        enableDragHandle: true,
        open: drawerState,
        onOpenChange: this.onToggleBusinessUnitDrawer.bind(this),
        sidebar: this.businessUnitSideBar(businessUnit)
      })), _react["default"].createElement("div", {
        className: "app-module-sidenav d-none d-xl-flex"
      }, this.businessUnitSideBar(businessUnit)), _react["default"].createElement("div", {
        className: "module-box"
      }, _react["default"].createElement("div", {
        className: "module-box-header"
      }, _react["default"].createElement("span", {
        className: "icon-btn drawer-btn d-flex d-xl-none",
        onClick: this.onToggleBusinessUnitDrawer.bind(this)
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-menu"
      })), _react["default"].createElement(_index["default"], {
        placeholder: "Search business unit",
        notification: false,
        apps: false,
        user: this.props.businessUnit,
        onChange: this.updateSearchBusinessUnit.bind(this),
        value: this.props.searchBusinessUnit
      })), _react["default"].createElement("div", {
        className: "module-box-content"
      }, _react["default"].createElement("div", {
        className: "module-box-topbar"
      }, _react["default"].createElement("div", {
        className: "form-control-checkbox d-flex"
      }, _react["default"].createElement("div", {
        className: "form-checkbox"
      }, _react["default"].createElement("input", {
        type: "checkbox",
        checked: selectedBusinessUnits > 0,
        onChange: this.onAllBusinessUnitSelect.bind(this)
      }), _react["default"].createElement("span", {
        className: "check"
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-check zmdi-hc-lg"
      })))), _react["default"].createElement(_reactstrap.Button, {
        size: "sm",
        className: "jr-btn jr-flat-btn",
        color: "default",
        onClick: this.onFilterSelectedBusinessUnit.bind(this)
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-filter-list zmdi-hc-fw"
      }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "label.filter.selected"
      })))), _react["default"].createElement(_CustomScrollbars["default"], {
        className: "module-list-scroll scrollbar",
        style: {
          height: this.props.width >= 1200 ? 'calc(100vh - 265px)' : 'calc(100vh - 245px)'
        }
      }, loader ? _react["default"].createElement("div", {
        className: "loader-view-block h-100"
      }, _react["default"].createElement("div", {
        className: "loader-view"
      }, _react["default"].createElement(_CircularProgress["default"], null))) : businessUnitList && businessUnitList.length > 0 ? _react["default"].createElement(_businessUnitList["default"], {
        data: businessUnitList,
        width: width,
        addFavouriteBusinessUnit: this.addFavouriteBusinessUnit.bind(this),
        onBusinessUnitSelect: this.onBusinessUnitSelect.bind(this),
        onDeleteBusinessUnit: this.onDeleteBusinessUnit.bind(this),
        onSaveBusinessUnit: this.onSaveBusinessUnit.bind(this),
        showBusinessUnitLoader: this.showBusinessUnitLoader.bind(this)
      }) : _react["default"].createElement("div", {
        className: "h-100 d-flex align-items-center justify-content-center"
      }, noContentFoundMessage))))), _react["default"].createElement(_businessUnitAdd["default"], {
        open: addBusinessUnitState,
        businessUnit: {
          'id': '',
          'orgid': '',
          'name': '',
          'thumb': null,
          'selected': false,
          'starred': false,
          'frequently': false
        },
        onSaveBusinessUnit: this.onSaveBusinessUnit,
        onBusinessUnitClose: this.onBusinessUnitClose,
        onDeleteBusinessUnit: this.onDeleteBusinessUnit,
        showBusinessUnitLoader: this.showBusinessUnitLoader
      }), showMessage && _reactNotifications.NotificationManager.success(alertMessage, this.handleBusinessUnitRequestClose()), _react["default"].createElement(_reactNotifications.NotificationContainer, null));
    }
  }]);

  return Component;
}(_react["default"].Component);

exports.Component = Component;
var _default = Component;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(filterOptions, "filterOptions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/component.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/component.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/component.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/component.js");

  __REACT_HOT_LOADER__.register(_rcDrawer, "_rcDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/component.js");

  __REACT_HOT_LOADER__.register(_businessUnitList, "_businessUnitList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/component.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/component.js");

  __REACT_HOT_LOADER__.register(_businessUnitAdd, "_businessUnitAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/component.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/component.js");

  __REACT_HOT_LOADER__.register(_CircularProgress, "_CircularProgress", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/component.js");

  __REACT_HOT_LOADER__.register(_CustomScrollbars, "_CustomScrollbars", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/component.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/component.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/component.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/component.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/component.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/component.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/component.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/component.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/component.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/component.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/component.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/component.js");

  __REACT_HOT_LOADER__.register(filterOptions, "filterOptions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/component.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/component.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/component.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/component.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/component.js");
}();

;

/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _index = _interopRequireDefault(__webpack_require__(1910));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var BusinessUnitList = function BusinessUnitList(_ref) {
  var data = _ref.data,
      width = _ref.width,
      addFavouriteBusinessUnit = _ref.addFavouriteBusinessUnit,
      onBusinessUnitSelect = _ref.onBusinessUnitSelect,
      onSaveBusinessUnit = _ref.onSaveBusinessUnit,
      onDeleteBusinessUnit = _ref.onDeleteBusinessUnit,
      showBusinessUnitLoader = _ref.showBusinessUnitLoader;
  return _react["default"].createElement("div", {
    className: "app-main-content"
  }, data.map(function (data, index) {
    return _react["default"].createElement(_index["default"], {
      key: index,
      businessUnit: data,
      width: width,
      onDeleteBusinessUnit: onDeleteBusinessUnit,
      onSaveBusinessUnit: onSaveBusinessUnit,
      showBusinessUnitLoader: showBusinessUnitLoader,
      addFavouriteBusinessUnit: addFavouriteBusinessUnit,
      onBusinessUnitSelect: onBusinessUnitSelect
    });
  }));
};

var _default = BusinessUnitList;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(BusinessUnitList, "BusinessUnitList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitList/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitList/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitList/index.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitList/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitList/index.js");

  __REACT_HOT_LOADER__.register(BusinessUnitList, "BusinessUnitList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitList/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitList/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitList/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitList/index.js");
}();

;

/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _reactBootstrapSweetalert = _interopRequireDefault(__webpack_require__(80));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _listRowImage = _interopRequireDefault(__webpack_require__(126));

var _ListRowFavourite = _interopRequireDefault(__webpack_require__(127));

var _ListRowCheckbox = _interopRequireDefault(__webpack_require__(107));

var _ListRowData = _interopRequireDefault(__webpack_require__(129));

var _ListRowDropdown = _interopRequireDefault(__webpack_require__(128));

var _index = _interopRequireDefault(__webpack_require__(818));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var BusinessUnitRow =
/*#__PURE__*/
function (_React$Component) {
  _inherits(BusinessUnitRow, _React$Component);

  function BusinessUnitRow() {
    var _this;

    _classCallCheck(this, BusinessUnitRow);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BusinessUnitRow).call(this));

    _defineProperty(_assertThisInitialized(_this), "onBusinessUnitOptionToggle", function () {
      var _this2;

      return (_this2 = _this).__onBusinessUnitOptionToggle__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onBusinessUnitClose", function () {
      var _this3;

      return (_this3 = _this).__onBusinessUnitClose__REACT_HOT_LOADER__.apply(_this3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onDeleteBusinessUnit", function () {
      var _this4;

      return (_this4 = _this).__onDeleteBusinessUnit__REACT_HOT_LOADER__.apply(_this4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onEditBusinessUnit", function () {
      var _this5;

      return (_this5 = _this).__onEditBusinessUnit__REACT_HOT_LOADER__.apply(_this5, arguments);
    });

    _this.state = {
      menuState: false,
      addBusinessUnitState: false,
      deleteBusinessUnitCheck: false
    };
    return _this;
  }

  _createClass(BusinessUnitRow, [{
    key: "__onBusinessUnitOptionToggle__REACT_HOT_LOADER__",
    value: function __onBusinessUnitOptionToggle__REACT_HOT_LOADER__() {
      this.setState({
        menuState: !this.state.menuState
      });
    }
  }, {
    key: "__onBusinessUnitClose__REACT_HOT_LOADER__",
    value: function __onBusinessUnitClose__REACT_HOT_LOADER__() {
      this.setState({
        addBusinessUnitState: false
      });
    }
  }, {
    key: "__onDeleteBusinessUnit__REACT_HOT_LOADER__",
    value: function __onDeleteBusinessUnit__REACT_HOT_LOADER__(businessUnit) {
      this.setState({
        addBusinessUnitState: false
      });
      this.props.onDeleteBusinessUnit(businessUnit === null || businessUnit === void 0 ? void 0 : businessUnit.id);
    }
  }, {
    key: "__onEditBusinessUnit__REACT_HOT_LOADER__",
    value: function __onEditBusinessUnit__REACT_HOT_LOADER__() {
      this.setState({
        menuState: false,
        addBusinessUnitState: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var _this$props = this.props,
          width = _this$props.width,
          businessUnit = _this$props.businessUnit,
          addFavouriteBusinessUnit = _this$props.addFavouriteBusinessUnit,
          onBusinessUnitSelect = _this$props.onBusinessUnitSelect,
          onSaveBusinessUnit = _this$props.onSaveBusinessUnit,
          showBusinessUnitLoader = _this$props.showBusinessUnitLoader;
      var _this$state = this.state,
          menuState = _this$state.menuState,
          addBusinessUnitState = _this$state.addBusinessUnitState,
          deleteBusinessUnitCheck = _this$state.deleteBusinessUnitCheck;
      var name = businessUnit.name,
          description = businessUnit.description,
          starred = businessUnit.starred;
      var options = ['Edit', 'Delete'];
      return _react["default"].createElement("div", {
        className: "contact-item"
      }, _react["default"].createElement(_ListRowCheckbox["default"], {
        selected: businessUnit.selected,
        onClick: function onClick() {
          onBusinessUnitSelect(businessUnit);
        }
      }), _react["default"].createElement(_ListRowFavourite["default"], {
        width: width,
        onClick: function onClick() {
          addFavouriteBusinessUnit(businessUnit);
        },
        starred: starred
      }), _react["default"].createElement(_listRowImage["default"], {
        width: width,
        data: businessUnit
      }), _react["default"].createElement(_ListRowData["default"], {
        lineOne: name,
        lineTwoLeft: description
      }), _react["default"].createElement(_ListRowDropdown["default"], {
        menuState: menuState,
        toggle: this.onBusinessUnitOptionToggle.bind(this),
        options: options,
        dropdownItems: options.map(function (option) {
          return _react["default"].createElement(_reactstrap.DropdownItem, {
            key: option,
            onClick: function onClick() {
              if (option === 'Edit') {
                _this6.onEditBusinessUnit();
              } else if (option === 'Delete') {
                _this6.setState({
                  deleteBusinessUnitCheck: true
                });
              }
            }
          }, option);
        })
      }), _react["default"].createElement("div", null, addBusinessUnitState && _react["default"].createElement(_index["default"], {
        open: addBusinessUnitState,
        businessUnit: businessUnit,
        onSaveBusinessUnit: onSaveBusinessUnit,
        onBusinessUnitClose: this.onBusinessUnitClose,
        onDeleteBusinessUnit: this.onDeleteBusinessUnit,
        showBusinessUnitLoader: showBusinessUnitLoader
      })), _react["default"].createElement(_reactBootstrapSweetalert["default"], {
        show: deleteBusinessUnitCheck,
        warning: true,
        showCancel: true,
        confirmBtnText: _react["default"].createElement(_IntlMessages["default"], {
          id: "button.yesDeleteIt"
        }),
        cancelBtnText: _react["default"].createElement(_IntlMessages["default"], {
          id: "button.cancel"
        }),
        confirmBtnBsStyle: "danger",
        cancelBtnBsStyle: "default",
        title: _react["default"].createElement("span", {
          style: {
            fontWeight: 'bold',
            color: 'grey',
            fontSize: '200%'
          }
        }, _react["default"].createElement(_IntlMessages["default"], {
          id: "general.areYouSure"
        })),
        onConfirm: function onConfirm() {
          _this6.onDeleteBusinessUnit(businessUnit);

          _this6.setState({
            deleteBusinessUnitCheck: false
          });
        },
        onCancel: function onCancel() {
          _this6.setState({
            deleteBusinessUnitCheck: false
          });
        }
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "businessUnit.deleteBusinessUnit"
      })));
    }
  }]);

  return BusinessUnitRow;
}(_react["default"].Component);

var _default = BusinessUnitRow;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(BusinessUnitRow, "BusinessUnitRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitList/businessUnitRow/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitList/businessUnitRow/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitList/businessUnitRow/index.js");

  __REACT_HOT_LOADER__.register(_reactBootstrapSweetalert, "_reactBootstrapSweetalert", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitList/businessUnitRow/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitList/businessUnitRow/index.js");

  __REACT_HOT_LOADER__.register(_listRowImage, "_listRowImage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitList/businessUnitRow/index.js");

  __REACT_HOT_LOADER__.register(_ListRowFavourite, "_ListRowFavourite", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitList/businessUnitRow/index.js");

  __REACT_HOT_LOADER__.register(_ListRowCheckbox, "_ListRowCheckbox", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitList/businessUnitRow/index.js");

  __REACT_HOT_LOADER__.register(_ListRowData, "_ListRowData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitList/businessUnitRow/index.js");

  __REACT_HOT_LOADER__.register(_ListRowDropdown, "_ListRowDropdown", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitList/businessUnitRow/index.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitList/businessUnitRow/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitList/businessUnitRow/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitList/businessUnitRow/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitList/businessUnitRow/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitList/businessUnitRow/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitList/businessUnitRow/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitList/businessUnitRow/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitList/businessUnitRow/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitList/businessUnitRow/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitList/businessUnitRow/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitList/businessUnitRow/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitList/businessUnitRow/index.js");

  __REACT_HOT_LOADER__.register(BusinessUnitRow, "BusinessUnitRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitList/businessUnitRow/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitList/businessUnitRow/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitList/businessUnitRow/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/businessUnit/businessUnitList/businessUnitRow/index.js");
}();

;

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _component["default"];
  }
});

var _component = _interopRequireDefault(__webpack_require__(1912));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_component, "_component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/index.js");
}();

;

/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _rcDrawer = _interopRequireDefault(__webpack_require__(31));

var _reactNotifications = __webpack_require__(30);

var _reactstrap = __webpack_require__(6);

var _portfolioList = _interopRequireDefault(__webpack_require__(1913));

var _index = _interopRequireDefault(__webpack_require__(66));

var _portfolioAdd = _interopRequireDefault(__webpack_require__(1916));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _CircularProgress = _interopRequireDefault(__webpack_require__(24));

var _CustomScrollbars = _interopRequireDefault(__webpack_require__(27));

var _portfolio = __webpack_require__(113);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var filterOptions = [{
  id: 1,
  name: 'All portfolios',
  icon: 'zmdi-menu'
}, {
  id: 2,
  name: 'Starred portfolios',
  icon: 'zmdi-star'
}];

var Component = function Component() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var width = (0, _reactRedux.useSelector)(function (state) {
    return state.settings.width;
  });
  var loader = (0, _reactRedux.useSelector)(function (state) {
    return state.portfolios.loader;
  });
  var alertMessage = (0, _reactRedux.useSelector)(function (state) {
    return state.portfolios.alertMessage;
  });
  var showMessage = (0, _reactRedux.useSelector)(function (state) {
    return state.portfolios.showMessage;
  });
  var noContentFoundMessage = (0, _reactRedux.useSelector)(function (state) {
    return state.portfolios.noContentFoundMessage;
  });
  var drawerState = (0, _reactRedux.useSelector)(function (state) {
    return state.portfolios.drawerState;
  });
  var portfolio = (0, _reactRedux.useSelector)(function (state) {
    return state.portfolios.portfolio;
  });
  var searchPortfolio = (0, _reactRedux.useSelector)(function (state) {
    return state.portfolios.searchPortfolio;
  });
  var portfolioList = (0, _reactRedux.useSelector)(function (state) {
    return state.portfolios.portfolioList;
  });
  var selectedPortfolios = (0, _reactRedux.useSelector)(function (state) {
    return state.portfolios.selectedPortfolios;
  });
  var addPortfolioState = (0, _reactRedux.useSelector)(function (state) {
    return state.portfolios.addPortfolioState;
  });
  var selectedSectionId = (0, _reactRedux.useSelector)(function (state) {
    return state.portfolios.selectedSectionId;
  });
  (0, _react.useEffect)(function () {
    dispatch((0, _portfolio.showPortfolioLoader)());
    dispatch((0, _portfolio.fetchPortfolios)());
  }, []);

  var onAllPortfolioSelect = function onAllPortfolioSelect() {
    var selectAll = selectedPortfolios < portfolioList.length;

    if (selectAll) {
      dispatch((0, _portfolio.getAllPortfolio)());
    } else {
      dispatch((0, _portfolio.getUnselectedAllPortfolio)());
    }
  };

  var updatingSearchPortfolio = function updatingSearchPortfolio(evt) {
    dispatch((0, _portfolio.updateSearchPortfolio)(evt.target.value));
    dispatch((0, _portfolio.filterPortfolio)(evt.target.value));
  };

  var portfolioRequestClose = function portfolioRequestClose() {
    dispatch((0, _portfolio.handlePortfolioRequestClose)());
  };

  var portfolioSideBar = function portfolioSideBar() {
    return _react["default"].createElement("div", {
      className: "module-side"
    }, _react["default"].createElement("div", {
      className: "module-side-header"
    }, _react["default"].createElement("div", {
      className: "module-logo"
    }, _react["default"].createElement("i", {
      className: "zmdi zmdi-city-alt mr-4"
    }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
      id: "sidebar.portfolios"
    })))), _react["default"].createElement("div", {
      className: "module-side-content"
    }, _react["default"].createElement(_CustomScrollbars["default"], {
      className: "module-side-scroll scrollbar",
      style: {
        height: width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)'
      }
    }, _react["default"].createElement("div", {
      className: "module-add-task"
    }, _react["default"].createElement(_reactstrap.Button, {
      id: "addPortfolioButton",
      className: "btn-block jr-btn",
      color: "primary",
      onClick: function onClick() {
        return dispatch((0, _portfolio.onAddPortfolio)());
      }
    }, _react["default"].createElement("i", {
      className: "zmdi zmdi-accounts-add zmdi-hc-fw"
    }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
      id: "portfolio.addPortfolio"
    })))), _react["default"].createElement("div", {
      className: "module-side-nav"
    }, _react["default"].createElement("ul", {
      className: "module-nav"
    }, filterOptions.map(function (option) {
      return _react["default"].createElement("li", {
        key: option.id,
        className: "nav-item"
      }, _react["default"].createElement("a", {
        href: "javascript:void(0)",
        className: option.id === selectedSectionId ? 'active' : '',
        onClick: function onClick() {
          return dispatch((0, _portfolio.onFilterPortfolioOptionSelect)(option));
        }
      }, _react["default"].createElement("i", {
        className: "zmdi ".concat(option.icon)
      }), _react["default"].createElement("span", null, option.name)));
    }))))));
  };

  return _react["default"].createElement("div", {
    className: "app-wrapper"
  }, _react["default"].createElement("div", {
    className: "app-module animated slideInUpTiny animation-duration-3"
  }, _react["default"].createElement("div", {
    className: "d-block d-xl-none"
  }, _react["default"].createElement(_rcDrawer["default"], {
    touch: true,
    transitions: true,
    enableDragHandle: true,
    open: drawerState,
    onOpenChange: function onOpenChange() {
      return dispatch((0, _portfolio.onTogglePortfolioDrawer)());
    },
    sidebar: portfolioSideBar(portfolio)
  })), _react["default"].createElement("div", {
    className: "app-module-sidenav d-none d-xl-flex"
  }, portfolioSideBar(portfolio)), _react["default"].createElement("div", {
    className: "module-box"
  }, _react["default"].createElement("div", {
    className: "module-box-header"
  }, _react["default"].createElement("span", {
    className: "icon-btn drawer-btn d-flex d-xl-none",
    onClick: function onClick() {
      return dispatch((0, _portfolio.onTogglePortfolioDrawer)());
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-menu"
  })), _react["default"].createElement(_index["default"], {
    placeholder: "Search portfolio",
    notification: false,
    apps: false,
    user: portfolio,
    onChange: function onChange(event) {
      return updatingSearchPortfolio(event);
    },
    value: searchPortfolio
  })), _react["default"].createElement("div", {
    className: "module-box-content"
  }, _react["default"].createElement("div", {
    className: "module-box-topbar"
  }, _react["default"].createElement("div", {
    className: "form-control-checkbox d-flex"
  }, _react["default"].createElement("div", {
    className: "form-checkbox"
  }, _react["default"].createElement("input", {
    type: "checkbox",
    checked: selectedPortfolios > 0,
    onChange: onAllPortfolioSelect
  }), _react["default"].createElement("span", {
    className: "check"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-check zmdi-hc-lg"
  })))), _react["default"].createElement(_reactstrap.Button, {
    size: "sm",
    className: "jr-btn jr-flat-btn",
    color: "default",
    onClick: function onClick() {
      return dispatch((0, _portfolio.onFilterSelectedPortfolio)());
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-filter-list zmdi-hc-fw"
  }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.filter.selected"
  })))), _react["default"].createElement(_CustomScrollbars["default"], {
    className: "module-list-scroll scrollbar",
    style: {
      height: width >= 1200 ? 'calc(100vh - 265px)' : 'calc(100vh - 245px)'
    }
  }, loader ? _react["default"].createElement("div", {
    className: "loader-view-block h-100"
  }, _react["default"].createElement("div", {
    className: "loader-view"
  }, _react["default"].createElement(_CircularProgress["default"], null))) : portfolioList && portfolioList.length > 0 ? _react["default"].createElement(_portfolioList["default"], null) : _react["default"].createElement("div", {
    className: "h-100 d-flex align-items-center justify-content-center"
  }, noContentFoundMessage))))), _react["default"].createElement(_portfolioAdd["default"], {
    open: addPortfolioState
  }), showMessage && _reactNotifications.NotificationManager.success(alertMessage, portfolioRequestClose()), _react["default"].createElement(_reactNotifications.NotificationContainer, null));
};

var _default = Component;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(filterOptions, "filterOptions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/component.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/component.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/component.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/component.js");

  __REACT_HOT_LOADER__.register(_rcDrawer, "_rcDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/component.js");

  __REACT_HOT_LOADER__.register(_portfolioList, "_portfolioList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/component.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/component.js");

  __REACT_HOT_LOADER__.register(_portfolioAdd, "_portfolioAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/component.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/component.js");

  __REACT_HOT_LOADER__.register(_CircularProgress, "_CircularProgress", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/component.js");

  __REACT_HOT_LOADER__.register(_CustomScrollbars, "_CustomScrollbars", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/component.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/component.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/component.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/component.js");

  __REACT_HOT_LOADER__.register(filterOptions, "filterOptions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/component.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/component.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/component.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/component.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/component.js");
}();

;

/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _index = _interopRequireDefault(__webpack_require__(1914));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var PortfolioList = function PortfolioList() {
  var portfolioList = (0, _reactRedux.useSelector)(function (state) {
    return state.portfolios.portfolioList;
  });
  return _react["default"].createElement("div", {
    className: "app-main-content"
  }, portfolioList.map(function (entry, index) {
    return _react["default"].createElement(_index["default"], {
      key: index,
      portfolio: entry
    });
  }));
};

var _default = PortfolioList;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PortfolioList, "PortfolioList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioList/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioList/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioList/index.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioList/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioList/index.js");

  __REACT_HOT_LOADER__.register(PortfolioList, "PortfolioList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioList/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioList/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioList/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioList/index.js");
}();

;

/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _store = __webpack_require__(54);

var _reactBootstrapSweetalert = _interopRequireDefault(__webpack_require__(80));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _listRowImage = _interopRequireDefault(__webpack_require__(126));

var _ListRowFavourite = _interopRequireDefault(__webpack_require__(127));

var _ListRowCheckbox = _interopRequireDefault(__webpack_require__(107));

var _ListRowData = _interopRequireDefault(__webpack_require__(129));

var _ListRowDropdown = _interopRequireDefault(__webpack_require__(128));

var _index = _interopRequireDefault(__webpack_require__(1915));

var _portfolio = __webpack_require__(113);

var _Authentication = __webpack_require__(42);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var PortfolioRow = function PortfolioRow(props) {
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      menuState = _useState2[0],
      setMenuState = _useState2[1];

  var _useState3 = (0, _react.useState)(props.portfolio),
      _useState4 = _slicedToArray(_useState3, 2),
      portfolio = _useState4[0],
      setPortfolio = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      deletePortfolioCheck = _useState6[0],
      setDeletePortfolioCheck = _useState6[1];

  var width = (0, _reactRedux.useSelector)(function (state) {
    return state.settings.width;
  }); // const { portfolio } = props;

  (0, _react.useEffect)(function () {
    setPortfolio(props.portfolio);
  }, [props]);
  var name = portfolio.name,
      description = portfolio.description,
      starred = portfolio.starred;
  var options = ['Edit', 'Delete', 'Dashboard'];

  var portfolioOptionToggle = function portfolioOptionToggle() {
    setMenuState(!menuState);
  };

  var deletePortfolio = function deletePortfolio(portfolio) {
    dispatch((0, _portfolio.onDeletePortfolio)(portfolio === null || portfolio === void 0 ? void 0 : portfolio.id));
  };

  var editPortfolio = function editPortfolio() {
    setMenuState(false);
    dispatch((0, _portfolio.onEditPortfolio)(portfolio));
  };

  var portfolioDashboard = function portfolioDashboard(portfolio) {
    (0, _Authentication.setStorageItem)(_Authentication.SELECTED_PORTFOLIO, portfolio === null || portfolio === void 0 ? void 0 : portfolio.id); // dispatch(showPortfolioLoader());
    // dispatch(onPortfolioDashboard(portfolio?.id));

    _store.history.push('/app/portfolio-dashboard/default');
  };

  return _react["default"].createElement("div", {
    className: "contact-item"
  }, _react["default"].createElement(_ListRowCheckbox["default"], {
    selected: portfolio.selected,
    onClick: function onClick() {
      return dispatch((0, _portfolio.onPortfolioSelect)(portfolio));
    }
  }), _react["default"].createElement(_ListRowFavourite["default"], {
    width: width,
    onClick: function onClick() {
      return dispatch((0, _portfolio.addFavouritePortfolio)(portfolio));
    },
    starred: starred
  }), _react["default"].createElement(_listRowImage["default"], {
    width: width,
    data: portfolio
  }), _react["default"].createElement(_ListRowData["default"], {
    lineOne: name,
    lineTwoLeft: description
  }), _react["default"].createElement(_ListRowDropdown["default"], {
    menuState: menuState,
    toggle: portfolioOptionToggle,
    options: options,
    dropdownItems: options.map(function (option) {
      return _react["default"].createElement(_reactstrap.DropdownItem, {
        key: option,
        onClick: function onClick() {
          if (option === 'Edit') {
            editPortfolio();
          } else if (option === 'Delete') {
            setDeletePortfolioCheck(true);
          } else if (option === 'Dashboard') {
            portfolioDashboard(portfolio);
          }
        }
      }, option);
    })
  }), _react["default"].createElement("div", null, _react["default"].createElement(_index["default"], null)), _react["default"].createElement(_reactBootstrapSweetalert["default"], {
    show: deletePortfolioCheck,
    warning: true,
    showCancel: true,
    confirmBtnText: _react["default"].createElement(_IntlMessages["default"], {
      id: "button.yesDeleteIt"
    }),
    cancelBtnText: _react["default"].createElement(_IntlMessages["default"], {
      id: "button.cancel"
    }),
    confirmBtnBsStyle: "danger",
    cancelBtnBsStyle: "default",
    title: _react["default"].createElement("span", {
      style: {
        fontWeight: 'bold',
        color: 'grey',
        fontSize: '200%'
      }
    }, _react["default"].createElement(_IntlMessages["default"], {
      id: "general.areYouSure"
    })),
    onConfirm: function onConfirm() {
      deletePortfolio(portfolio);
      setDeletePortfolioCheck(false);
    },
    onCancel: function onCancel() {
      setDeletePortfolioCheck(false);
    }
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "portfolio.deletePortfolio"
  })));
};

var _default = PortfolioRow;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PortfolioRow, "PortfolioRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioList/portfolioRow/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioList/portfolioRow/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioList/portfolioRow/index.js");

  __REACT_HOT_LOADER__.register(_reactBootstrapSweetalert, "_reactBootstrapSweetalert", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioList/portfolioRow/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioList/portfolioRow/index.js");

  __REACT_HOT_LOADER__.register(_listRowImage, "_listRowImage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioList/portfolioRow/index.js");

  __REACT_HOT_LOADER__.register(_ListRowFavourite, "_ListRowFavourite", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioList/portfolioRow/index.js");

  __REACT_HOT_LOADER__.register(_ListRowCheckbox, "_ListRowCheckbox", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioList/portfolioRow/index.js");

  __REACT_HOT_LOADER__.register(_ListRowData, "_ListRowData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioList/portfolioRow/index.js");

  __REACT_HOT_LOADER__.register(_ListRowDropdown, "_ListRowDropdown", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioList/portfolioRow/index.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioList/portfolioRow/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioList/portfolioRow/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioList/portfolioRow/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioList/portfolioRow/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioList/portfolioRow/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioList/portfolioRow/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioList/portfolioRow/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioList/portfolioRow/index.js");

  __REACT_HOT_LOADER__.register(PortfolioRow, "PortfolioRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioList/portfolioRow/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioList/portfolioRow/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioList/portfolioRow/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioList/portfolioRow/index.js");
}();

;

/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

__webpack_require__(198);

var _Validation = __webpack_require__(14);

var _portfolio = __webpack_require__(113);

var _common = __webpack_require__(819);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var PortfolioEdit = function PortfolioEdit() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var editPortfolioState = (0, _reactRedux.useSelector)(function (state) {
    return state.portfolios.editPortfolioState;
  });
  var portfolio = (0, _reactRedux.useSelector)(function (state) {
    return state.portfolios.selectedPortfolio;
  });

  var _useState = (0, _react.useState)(portfolio),
      _useState2 = _slicedToArray(_useState, 2),
      selectedPortfolio = _useState2[0],
      setSelectedPortfolio = _useState2[1];

  var _useState3 = (0, _react.useState)({
    name: ''
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      formErrors = _useState4[0],
      setFormErrors = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      formValid = _useState6[0],
      setFormValid = _useState6[1]; // using selectedPortfolio makes it behave like componentDidUpdate - effect takes place when selectedPortfolio changes


  (0, _react.useEffect)(function () {
    setSelectedPortfolio(portfolio);
    setFormValid(false);
    validateForm(); // console.log('portfolio useEffect '.concat(portfolio.name));
  }, [portfolio]); // using selectedPortfolio makes it behave like componentDidUpdate - effect takes place when selectedPortfolio changes

  (0, _react.useEffect)(function () {
    setFormValid(false);
    validateForm(); // console.log('selectedPortfolio useEffect '.concat(selectedPortfolio.name));
  }, [selectedPortfolio]);

  var handleUserInput = function handleUserInput(event) {
    var name = event.target.name;
    var value = event.target.value;
    updateSelectedPortfolioField(name, value);
    validateField(name, value);
  };

  var updateSelectedPortfolioField = function updateSelectedPortfolioField(fieldName, value) {
    var newPortfolio = _objectSpread({}, portfolio);

    newPortfolio[fieldName] = value;
    setSelectedPortfolio(newPortfolio);
  };

  var validateField = function validateField(fieldName, value) {
    var valueEntered = (0, _Validation.isValueEntered)(value);
    formErrors[fieldName] = valueEntered ? '' : ' is invalid';
    setFormErrors(formErrors);
    validateForm();
  };

  var validateForm = function validateForm() {
    setFormValid((0, _Validation.isValueEntered)(selectedPortfolio === null || selectedPortfolio === void 0 ? void 0 : selectedPortfolio.name));
  };

  var maintainButton = function maintainButton(label) {
    return _react["default"].createElement(_reactstrap.Button, {
      className: "text-uppercase",
      disabled: !formValid,
      color: "primary",
      onClick: function onClick() {
        dispatch((0, _portfolio.showPortfolioLoader)());
        dispatch((0, _portfolio.onPortfolioClose)());
        dispatch((0, _portfolio.onSavePortfolio)(selectedPortfolio));
        setFormValid(false);
      }
    }, label);
  };

  var modalHeaderOnClick = function modalHeaderOnClick() {
    return function () {
      setFormValid(false);
      dispatch((0, _portfolio.onPortfolioClose)());
    };
  };

  var modalBody = function modalBody(buttonText) {
    return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
      className: "modal-box-content"
    }, _react["default"].createElement("div", {
      className: "row no-gutters"
    }, (0, _common.displayedImage)(selectedPortfolio), (0, _common.showErrors)(formErrors), (0, _common.inputFields)(portfolio, handleUserInput))), _react["default"].createElement("div", {
      className: "modal-box-footer d-flex flex-row"
    }, maintainButton(buttonText)));
  };

  return _react["default"].createElement(_reactstrap.Modal, {
    className: "modal-box",
    isOpen: editPortfolioState
  }, (0, _common.modalHeader)(_react["default"].createElement(_IntlMessages["default"], {
    id: "portfolio.savePortfolio"
  }), modalHeaderOnClick), modalBody(_react["default"].createElement(_IntlMessages["default"], {
    id: "portfolio.savePortfolio"
  })));
};

var _default = PortfolioEdit;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PortfolioEdit, "PortfolioEdit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioEdit/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioEdit/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioEdit/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioEdit/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioEdit/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioEdit/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioEdit/index.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioEdit/index.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioEdit/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioEdit/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioEdit/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioEdit/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioEdit/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioEdit/index.js");

  __REACT_HOT_LOADER__.register(PortfolioEdit, "PortfolioEdit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioEdit/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioEdit/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioEdit/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioEdit/index.js");
}();

;

/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _Validation = __webpack_require__(14);

var _portfolio = __webpack_require__(113);

var _common = __webpack_require__(819);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var PortfolioAdd = function PortfolioAdd() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var addPortfolioState = (0, _reactRedux.useSelector)(function (state) {
    return state.portfolios.addPortfolioState;
  });

  var _useState = (0, _react.useState)(_common.initProps),
      _useState2 = _slicedToArray(_useState, 2),
      selectedPortfolio = _useState2[0],
      setSelectedPortfolio = _useState2[1];

  var _useState3 = (0, _react.useState)({
    name: ''
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      formErrors = _useState4[0],
      setFormErrors = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      formValid = _useState6[0],
      setFormValid = _useState6[1];

  (0, _react.useEffect)(function () {
    setSelectedPortfolio((0, _common.initProps)());
  }, []); // using selectedFeature makes it behave like componentDidUpdate - effect takes place when selectedFeature changes

  (0, _react.useEffect)(function () {
    setFormValid(false);
    validateForm();
  }, [selectedPortfolio]);

  var handleUserInput = function handleUserInput(event) {
    var name = event.target.name;
    var value = event.target.value;
    updateSelectedPortfolioField(name, value);
    validateField(name, value);
  };

  var updateSelectedPortfolioField = function updateSelectedPortfolioField(fieldName, value) {
    var newPortfolio = _objectSpread({}, selectedPortfolio);

    newPortfolio[fieldName] = value;
    setSelectedPortfolio(newPortfolio);
  };

  var validateField = function validateField(fieldName, value) {
    var valueEntered = (0, _Validation.isValueEntered)(value);
    formErrors[fieldName] = valueEntered ? '' : ' is invalid';
    setFormErrors(formErrors);
    validateForm();
  };

  var validateForm = function validateForm() {
    setFormValid((0, _Validation.isValueEntered)(selectedPortfolio === null || selectedPortfolio === void 0 ? void 0 : selectedPortfolio.name));
  };

  var maintainButton = function maintainButton(label) {
    return _react["default"].createElement(_reactstrap.Button, {
      className: "text-uppercase",
      disabled: !formValid,
      color: "primary",
      onClick: function onClick() {
        dispatch((0, _portfolio.showPortfolioLoader)());
        dispatch((0, _portfolio.onPortfolioClose)());
        dispatch((0, _portfolio.onSavePortfolio)(selectedPortfolio));
        setSelectedPortfolio((0, _common.initProps)());
        setFormValid(false);
      }
    }, label);
  };

  var modalHeaderOnClick = function modalHeaderOnClick() {
    return function () {
      setFormValid(false);
      dispatch((0, _portfolio.onPortfolioClose)());
    };
  };

  var modalBody = function modalBody(buttonText) {
    return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
      className: "modal-box-content"
    }, _react["default"].createElement("div", {
      className: "row no-gutters"
    }, (0, _common.displayedImage)(selectedPortfolio), (0, _common.showErrors)(formErrors), (0, _common.inputFields)(selectedPortfolio, handleUserInput))), _react["default"].createElement("div", {
      className: "modal-box-footer d-flex flex-row"
    }, maintainButton(buttonText)));
  };

  return _react["default"].createElement(_reactstrap.Modal, {
    className: "modal-box",
    isOpen: addPortfolioState
  }, (0, _common.modalHeader)(_react["default"].createElement(_IntlMessages["default"], {
    id: "portfolio.addPortfolio"
  }), modalHeaderOnClick), modalBody(_react["default"].createElement(_IntlMessages["default"], {
    id: "portfolio.addPortfolio"
  })));
};

var _default = PortfolioAdd;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PortfolioAdd, "PortfolioAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioAdd/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioAdd/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioAdd/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioAdd/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioAdd/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioAdd/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioAdd/index.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioAdd/index.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioAdd/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioAdd/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioAdd/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioAdd/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioAdd/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioAdd/index.js");

  __REACT_HOT_LOADER__.register(PortfolioAdd, "PortfolioAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioAdd/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioAdd/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioAdd/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolio/portfolioMaintenance/portfolioAdd/index.js");
}();

;

/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Container["default"];
  }
});

var _Container = _interopRequireDefault(__webpack_require__(1918));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_Container, "_Container", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/index.js");
}();

;

/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactRedux = __webpack_require__(10);

var _portfolio = __webpack_require__(113);

var _component = _interopRequireDefault(__webpack_require__(1919));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var mapStateToProps = function mapStateToProps(_ref) {
  var portfolios = _ref.portfolios,
      settings = _ref.settings;
  var width = settings.width;
  var loader = portfolios.loader,
      alertMessage = portfolios.alertMessage,
      showMessage = portfolios.showMessage,
      selectedPortfolio = portfolios.selectedPortfolio,
      selectedDashboardPortfolio = portfolios.selectedDashboardPortfolio;
  return {
    width: width,
    loader: loader,
    alertMessage: alertMessage,
    showMessage: showMessage,
    selectedPortfolio: selectedPortfolio,
    selectedDashboardPortfolio: selectedDashboardPortfolio
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  showPortfolioLoader: _portfolio.showPortfolioLoader,
  onPortfolioDashboard: _portfolio.onPortfolioDashboard
})(_component["default"]);

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/Container.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/Container.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_component, "_component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/Container.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/Container.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/Container.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/Container.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/Container.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/Container.js");
}();

;

/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _recharts = __webpack_require__(108);

var _data = __webpack_require__(1920);

var _ChartCard = _interopRequireDefault(__webpack_require__(233));

var _index = _interopRequireDefault(__webpack_require__(63));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _Gantt = _interopRequireDefault(__webpack_require__(1921));

var _portfolioService = __webpack_require__(1926);

var _simpleModal = _interopRequireDefault(__webpack_require__(419));

var _Authentication = __webpack_require__(42);

var _valueStreamDrillDown = _interopRequireDefault(__webpack_require__(1927));

var _productDrillDown = _interopRequireDefault(__webpack_require__(1928));

var _CircularProgress = _interopRequireDefault(__webpack_require__(24));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // const dataGantt = {
//     data: [
//         { id: 1, text: 'Task #1', start_date: '15-04-2019', duration: 3, progress: 0.6 },
//         { id: 2, text: 'Task #2', start_date: '18-04-2019', duration: 3, progress: 0.4 }
//     ],
//     links: [
//         { id: 1, source: 1, target: 2, type: '0' }
//     ]
// };


var Component =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Component, _React$Component);

  _createClass(Component, [{
    key: "__onOptionMenuToggle__REACT_HOT_LOADER__",
    value: function __onOptionMenuToggle__REACT_HOT_LOADER__() {
      this.setState({
        menuState: !this.state.menuState
      });
    }
  }, {
    key: "__handleRequestClose__REACT_HOT_LOADER__",
    value: function __handleRequestClose__REACT_HOT_LOADER__() {
      this.setState({
        menuState: false
      });
    }
  }]);

  function Component() {
    var _this;

    _classCallCheck(this, Component);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Component).call(this));

    _defineProperty(_assertThisInitialized(_this), "onOptionMenuToggle", function () {
      var _this2;

      return (_this2 = _this).__onOptionMenuToggle__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "handleRequestClose", function () {
      var _this3;

      return (_this3 = _this).__handleRequestClose__REACT_HOT_LOADER__.apply(_this3, arguments);
    });

    _this.state = {
      selectedDashboardPortfolio: null,
      menuState: false,
      cardHeight: 0 // set to 60+ if you want the graphs to show on the dashboard (does take up room)

    };
    return _this;
  }

  _createClass(Component, [{
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(prevProps) {
        var selectedDashboardPortfolio;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                selectedDashboardPortfolio = this.props.selectedDashboardPortfolio;

                if (selectedDashboardPortfolio !== prevProps.selectedDashboardPortfolio) {
                  this.setState({
                    selectedDashboardPortfolio: selectedDashboardPortfolio
                  });
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidUpdate(_x) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var portfolioId = (0, _Authentication.getStorageItem)(_Authentication.SELECTED_PORTFOLIO);
      console.log('componentDidMount portfolioId - '.concat(portfolioId));
      var _this$props = this.props,
          showPortfolioLoader = _this$props.showPortfolioLoader,
          onPortfolioDashboard = _this$props.onPortfolioDashboard;
      showPortfolioLoader();
      onPortfolioDashboard(portfolioId);
    }
  }, {
    key: "render",
    value: function render() {
      var _selectedDashboardPor, _selectedDashboardPor2, _selectedDashboardPor3, _selectedDashboardPor4, _selectedDashboardPor5, _selectedDashboardPor6, _selectedDashboardPor7, _selectedDashboardPor8, _selectedDashboardPor9, _selectedDashboardPor10, _selectedDashboardPor11, _selectedDashboardPor12;

      var _this$props2 = this.props,
          width = _this$props2.width,
          loader = _this$props2.loader;
      var _this$state = this.state,
          cardHeight = _this$state.cardHeight,
          selectedDashboardPortfolio = _this$state.selectedDashboardPortfolio;
      return _react["default"].createElement("div", {
        className: "dashboard animated slideInUpTiny animation-duration-3"
      }, _react["default"].createElement("div", {
        style: {
          marginLeft: '20px',
          marginTop: '20px'
        }
      }, _react["default"].createElement(_index["default"], {
        match: this.props.match,
        title: _react["default"].createElement(_IntlMessages["default"], {
          id: "sidebar.agile.dashboard.portfolio"
        })
      })), _react["default"].createElement("div", {
        className: "row ml-2 mr-2 mt-2"
      }, _react["default"].createElement("div", {
        className: "col-lg-3 col-sm-6 col-12"
      }, _react["default"].createElement(_ChartCard["default"], {
        styleName: "bg-secondary text-white"
      }, _react["default"].createElement("div", {
        className: "chart-title"
      }, _react["default"].createElement("p", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "portfolio.dashboard.valueStreams"
      })), _react["default"].createElement("div", {
        className: "row"
      }, (selectedDashboardPortfolio === null || selectedDashboardPortfolio === void 0 ? void 0 : (_selectedDashboardPor = selectedDashboardPortfolio.valueStreams) === null || _selectedDashboardPor === void 0 ? void 0 : _selectedDashboardPor.length) > 0 ? _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
        className: "col-sm-3 col-12"
      }, _react["default"].createElement("h2", null, (selectedDashboardPortfolio === null || selectedDashboardPortfolio === void 0 ? void 0 : (_selectedDashboardPor2 = selectedDashboardPortfolio.valueStreams) === null || _selectedDashboardPor2 === void 0 ? void 0 : _selectedDashboardPor2.length) || 0)), _react["default"].createElement("div", {
        className: "col-sm-9 col-12 text-md-right"
      }, _react["default"].createElement(_simpleModal["default"], {
        modalTitle: "Value Streams",
        buttonText: "More info",
        modalBodyOverride: _react["default"].createElement(_valueStreamDrillDown["default"], {
          data: selectedDashboardPortfolio === null || selectedDashboardPortfolio === void 0 ? void 0 : selectedDashboardPortfolio.valueStreams
        })
      }))) : _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
        className: "col-sm-8 col-12 d-inline-block"
      }, _react["default"].createElement("h2", null, (selectedDashboardPortfolio === null || selectedDashboardPortfolio === void 0 ? void 0 : (_selectedDashboardPor3 = selectedDashboardPortfolio.valueStreams) === null || _selectedDashboardPor3 === void 0 ? void 0 : _selectedDashboardPor3.length) || 0))))), _react["default"].createElement(_recharts.ResponsiveContainer, {
        width: "100%",
        height: cardHeight
      }, _react["default"].createElement(_recharts.BarChart, {
        data: _data.data
      }, _react["default"].createElement(_recharts.Bar, {
        dataKey: "pv",
        fill: "white"
      }), _react["default"].createElement(_recharts.Bar, {
        dataKey: "uv",
        fill: "white"
      }))))), _react["default"].createElement("div", {
        className: "col-lg-3 col-sm-6 col-12"
      }, _react["default"].createElement(_ChartCard["default"], {
        styleName: "bg-primary text-white"
      }, _react["default"].createElement("div", {
        className: "chart-title"
      }, _react["default"].createElement("p", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "portfolio.dashboard.products"
      })), _react["default"].createElement("div", {
        className: "row"
      }, (selectedDashboardPortfolio === null || selectedDashboardPortfolio === void 0 ? void 0 : (_selectedDashboardPor4 = selectedDashboardPortfolio.products) === null || _selectedDashboardPor4 === void 0 ? void 0 : _selectedDashboardPor4.length) > 0 ? _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
        className: "col-sm-3 col-12"
      }, _react["default"].createElement("h2", null, (selectedDashboardPortfolio === null || selectedDashboardPortfolio === void 0 ? void 0 : (_selectedDashboardPor5 = selectedDashboardPortfolio.products) === null || _selectedDashboardPor5 === void 0 ? void 0 : _selectedDashboardPor5.length) || 0)), _react["default"].createElement("div", {
        className: "col-sm-9 col-12 text-md-right"
      }, _react["default"].createElement(_simpleModal["default"], {
        modalTitle: "Products",
        buttonText: "More info",
        modalBodyOverride: _react["default"].createElement(_productDrillDown["default"], {
          data: selectedDashboardPortfolio === null || selectedDashboardPortfolio === void 0 ? void 0 : selectedDashboardPortfolio.products,
          valueStreams: selectedDashboardPortfolio === null || selectedDashboardPortfolio === void 0 ? void 0 : selectedDashboardPortfolio.valueStreams
        })
      }))) : _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
        className: "col-sm-8 col-12 d-inline-block"
      }, _react["default"].createElement("h2", null, (selectedDashboardPortfolio === null || selectedDashboardPortfolio === void 0 ? void 0 : (_selectedDashboardPor6 = selectedDashboardPortfolio.products) === null || _selectedDashboardPor6 === void 0 ? void 0 : _selectedDashboardPor6.length) || 0))))), _react["default"].createElement(_recharts.ResponsiveContainer, {
        width: "100%",
        height: cardHeight
      }, _react["default"].createElement(_recharts.AreaChart, {
        data: _data.data1,
        margin: {
          top: 0,
          right: 0,
          left: 0,
          bottom: 0
        }
      }, _react["default"].createElement(_recharts.Area, {
        type: "monotone",
        dataKey: "pv",
        stroke: "rgba(255,255,255,0.5)",
        activeDot: {
          r: 8
        },
        fillOpacity: .5,
        fill: "white"
      }))))), _react["default"].createElement("div", {
        className: "col-lg-3 col-sm-6 col-12"
      }, _react["default"].createElement(_ChartCard["default"], {
        styleName: "bg-teal lighten-1 text-white"
      }, _react["default"].createElement("div", {
        className: "chart-title"
      }, _react["default"].createElement("p", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "portfolio.dashboard.initiatives"
      })), _react["default"].createElement("h2", null, (selectedDashboardPortfolio === null || selectedDashboardPortfolio === void 0 ? void 0 : (_selectedDashboardPor7 = selectedDashboardPortfolio.initiatives) === null || _selectedDashboardPor7 === void 0 ? void 0 : _selectedDashboardPor7.length) || 0)), _react["default"].createElement(_recharts.ResponsiveContainer, {
        width: "100%",
        height: cardHeight
      }, _react["default"].createElement(_recharts.LineChart, {
        data: _data.data2
      }, _react["default"].createElement(_recharts.Line, {
        type: "monotone",
        dataKey: "uv",
        stroke: "#ffffff",
        activeDot: {
          r: 8
        }
      }), _react["default"].createElement(_recharts.Line, {
        type: "monotone",
        dataKey: "pv",
        stroke: "#ffffff"
      }), _react["default"].createElement(_recharts.Line, {
        type: "monotone",
        dataKey: "amt",
        stroke: "#ffffff"
      }))))), _react["default"].createElement("div", {
        className: "col-lg-3 col-sm-6 col-12"
      }, _react["default"].createElement(_ChartCard["default"], {
        styleName: "bg-blue text-white"
      }, _react["default"].createElement("div", {
        className: "chart-title"
      }, _react["default"].createElement("p", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "portfolio.dashboard.features"
      })), _react["default"].createElement("h2", null, (selectedDashboardPortfolio === null || selectedDashboardPortfolio === void 0 ? void 0 : (_selectedDashboardPor8 = selectedDashboardPortfolio.features) === null || _selectedDashboardPor8 === void 0 ? void 0 : _selectedDashboardPor8.length) || 0)), _react["default"].createElement(_recharts.ResponsiveContainer, {
        width: "100%",
        height: cardHeight
      }, _react["default"].createElement(_recharts.LineChart, {
        data: _data.data1
      }, _react["default"].createElement(_recharts.Line, {
        dataKey: "uv",
        stroke: "#ffffff",
        activeDot: {
          r: 8
        }
      })))))), _react["default"].createElement("div", {
        className: "row"
      }, _react["default"].createElement("div", {
        className: "col-12"
      }, _react["default"].createElement("div", {
        style: {
          marginLeft: '20px',
          marginBottom: '5px'
        }
      }, _react["default"].createElement(_index["default"], {
        title: _react["default"].createElement(_IntlMessages["default"], {
          id: "portfolio.dashboard.portfolioViewHeader"
        })
      })), _react["default"].createElement("div", {
        className: "animated slideInUpTiny animation-duration-3"
      }, _react["default"].createElement("div", {
        className: "gantt-container ml-2 mr-2"
      }, loader ? _react["default"].createElement("div", {
        className: "loader-view-block h-100"
      }, _react["default"].createElement("div", {
        className: "loader-view"
      }, _react["default"].createElement(_CircularProgress["default"], null))) : (selectedDashboardPortfolio === null || selectedDashboardPortfolio === void 0 ? void 0 : (_selectedDashboardPor9 = selectedDashboardPortfolio.initiatives) === null || _selectedDashboardPor9 === void 0 ? void 0 : _selectedDashboardPor9.length) > 0 ? _react["default"].createElement(_Gantt["default"], {
        tasks: (0, _portfolioService.mapToGanttData)(selectedDashboardPortfolio),
        width: width
      }) : _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
        className: "dashboard animated slideInUpTiny animation-duration-3"
      }, _react["default"].createElement("div", {
        className: "row"
      }, _react["default"].createElement("div", {
        className: "col-md-12 col-12"
      }, _react["default"].createElement("div", {
        className: "jr-card jr-card-full-height ml-2 mr-2"
      }, _react["default"].createElement("h3", {
        className: "text-muted"
      }, "There is no portfolio data - this may be due to the following"), _react["default"].createElement("h4", {
        className: "card-heading"
      }, "Value Streams"), _react["default"].createElement("p", {
        className: "sub-heading"
      }, (selectedDashboardPortfolio === null || selectedDashboardPortfolio === void 0 ? void 0 : (_selectedDashboardPor10 = selectedDashboardPortfolio.valueStreams) === null || _selectedDashboardPor10 === void 0 ? void 0 : _selectedDashboardPor10.length) > 0 ? 'Value Streams are associated with this portfolio' : 'You have no Value Streams associated with this Portfolio'), _react["default"].createElement("h4", {
        className: "card-heading"
      }, "Products"), (selectedDashboardPortfolio === null || selectedDashboardPortfolio === void 0 ? void 0 : (_selectedDashboardPor11 = selectedDashboardPortfolio.products) === null || _selectedDashboardPor11 === void 0 ? void 0 : _selectedDashboardPor11.length) > 0 ? _react["default"].createElement("p", {
        className: "sub-heading"
      }, "Products are associated with your Value Streams") : _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("p", {
        className: "sub-heading"
      }, "You have no Products associated with your Value Streams"), _react["default"].createElement("p", {
        className: "sub-heading"
      }, "You will have to edit the Products associated with this Portfolio and select the correct Value Stream")), _react["default"].createElement("h4", {
        className: "card-heading"
      }, "Initiatives"), _react["default"].createElement("p", {
        className: "sub-heading"
      }, (selectedDashboardPortfolio === null || selectedDashboardPortfolio === void 0 ? void 0 : (_selectedDashboardPor12 = selectedDashboardPortfolio.initiatives) === null || _selectedDashboardPor12 === void 0 ? void 0 : _selectedDashboardPor12.length) > 0 ? 'Initiatives are associated with your Products' : _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("p", {
        className: "sub-heading"
      }, "You have no Initiatives associated with your Products"), _react["default"].createElement("p", {
        className: "sub-heading"
      }, "You will have to edit the Initiatives associated with this Portfolio and select the correct Product")))))))))))));
    }
  }]);

  return Component;
}(_react["default"].Component);

var _default = Component;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/component.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/component.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/component.js");

  __REACT_HOT_LOADER__.register(_ChartCard, "_ChartCard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/component.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/component.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/component.js");

  __REACT_HOT_LOADER__.register(_Gantt, "_Gantt", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/component.js");

  __REACT_HOT_LOADER__.register(_simpleModal, "_simpleModal", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/component.js");

  __REACT_HOT_LOADER__.register(_valueStreamDrillDown, "_valueStreamDrillDown", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/component.js");

  __REACT_HOT_LOADER__.register(_productDrillDown, "_productDrillDown", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/component.js");

  __REACT_HOT_LOADER__.register(_CircularProgress, "_CircularProgress", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/component.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/component.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/component.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/component.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/component.js");

  __REACT_HOT_LOADER__.register(asyncGeneratorStep, "asyncGeneratorStep", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/component.js");

  __REACT_HOT_LOADER__.register(_asyncToGenerator, "_asyncToGenerator", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/component.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/component.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/component.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/component.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/component.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/component.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/component.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/component.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/component.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/component.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/component.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/component.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/component.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/component.js");
}();

;

/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ganttData = exports.marketingData = exports.announcementsNotification = exports.appNotification = exports.customers = exports.products = exports.radialData = exports.pieChartData = exports.chartDataWithoutAxis = exports.chartData = exports.radarChartData = exports.data2 = exports.data1 = exports.data = exports.lineChartData = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var lineChartData = [[{
  name: 'J',
  amt: 24244
}, {
  name: 'F',
  amt: 18123
}, {
  name: 'M',
  amt: 22765
}, {
  name: 'A',
  amt: 17097
}, {
  name: 'M',
  amt: 25529
}, {
  name: 'J',
  amt: 18669
}, {
  name: 'J',
  amt: 21812
}, {
  name: 'S',
  amt: 14988
}, {
  name: 'O',
  amt: 18693
}, {
  name: 'N',
  amt: 22900
}, {
  name: 'D',
  amt: 25313
}]];
exports.lineChartData = lineChartData;
var data = [{
  name: 'Let A',
  uv: 0,
  pv: 0,
  amt: 20
}, {
  name: 'Let B',
  uv: 30,
  pv: 13,
  amt: 21
}, {
  name: 'Let C',
  uv: 20,
  pv: 98,
  amt: 29
}, {
  name: 'Let D',
  uv: 27,
  pv: 39,
  amt: 20
}, {
  name: 'Let E',
  uv: 18,
  pv: 48,
  amt: 28
}, {
  name: 'Let F',
  uv: 23,
  pv: 38,
  amt: 20
}, {
  name: 'Let G',
  uv: 0,
  pv: 0,
  amt: 20
}];
exports.data = data;
var data1 = [{
  name: 'Let A',
  uv: 40,
  pv: 24,
  amt: 20
}, {
  name: 'Let B',
  uv: 30,
  pv: 13,
  amt: 21
}, {
  name: 'Let C',
  uv: 60,
  pv: 98,
  amt: 29
}, {
  name: 'Let D',
  uv: 27,
  pv: 39,
  amt: 20
}, {
  name: 'Let E',
  uv: 78,
  pv: 48,
  amt: 28
}, {
  name: 'Let F',
  uv: 23,
  pv: 38,
  amt: 20
}, {
  name: 'Let G',
  uv: 56,
  pv: 43,
  amt: 20
}];
exports.data1 = data1;
var data2 = [{
  name: 'Let A',
  uv: 40,
  pv: 24,
  amt: 20
}, {
  name: 'Let B',
  uv: 10,
  pv: 13,
  amt: 21
}, {
  name: 'Let C',
  uv: 60,
  pv: 98,
  amt: 29
}, {
  name: 'Let D',
  uv: 27,
  pv: 15,
  amt: 20
}, {
  name: 'Let E',
  uv: 56,
  pv: 45,
  amt: 28
}, {
  name: 'Let F',
  uv: 23,
  pv: 56,
  amt: 20
}, {
  name: 'Let G',
  uv: 56,
  pv: 43,
  amt: 20
}];
exports.data2 = data2;
var radarChartData = [{
  subject: 'Math',
  A: 120,
  B: 110,
  fullMark: 150
}, {
  subject: 'Chinese',
  A: 98,
  B: 130,
  fullMark: 150
}, {
  subject: 'English',
  A: 86,
  B: 130,
  fullMark: 150
}, {
  subject: 'Geography',
  A: 99,
  B: 100,
  fullMark: 150
}, {
  subject: 'Physics',
  A: 85,
  B: 90,
  fullMark: 150
}, {
  subject: 'History',
  A: 65,
  B: 85,
  fullMark: 150
}];
exports.radarChartData = radarChartData;
var chartData = [{
  name: 'J',
  amt: 1400
}, {
  name: 'F',
  amt: 2210
}, {
  name: 'M',
  amt: 1000
}, {
  name: 'A',
  amt: 2000
}, {
  name: 'M',
  amt: 1400
}, {
  name: 'J',
  amt: 2300
}, {
  name: 'J',
  amt: 500
}, {
  name: 'A',
  amt: 2000
}, {
  name: 'S',
  amt: 1500
}, {
  name: 'S',
  amt: 1500
}, {
  name: 'O',
  amt: 1000
}, {
  name: 'N',
  amt: 2000
}, {
  name: 'D',
  amt: 500
}];
exports.chartData = chartData;
var chartDataWithoutAxis = [{
  name: 'J',
  amt: 1400
}, {
  name: 'F',
  amt: 2210
}, {
  name: 'M',
  amt: 1000
}, {
  name: 'A',
  amt: 2000
}, {
  name: 'M',
  amt: 1400
}, {
  name: 'J',
  amt: 2300
}, {
  name: 'J',
  amt: 500
}, {
  name: 'A',
  amt: 2000
}, {
  name: 'S',
  amt: 1500
}, {
  name: 'O',
  amt: 1000
}, {
  name: 'N',
  amt: 2000
}, {
  name: 'D',
  amt: 500
}, {
  name: 'M',
  amt: 1000
}, {
  name: 'A',
  amt: 2000
}, {
  name: 'M',
  amt: 1400
}];
exports.chartDataWithoutAxis = chartDataWithoutAxis;
var pieChartData = [{
  name: 'J',
  amt: 24
}, {
  name: 'F',
  amt: 18
}, {
  name: 'M',
  amt: 22
}, {
  name: 'A',
  amt: 17
}, {
  name: 'M',
  amt: 25
}, {
  name: 'J',
  amt: 12
}, {
  name: 'J',
  amt: 21
}];
exports.pieChartData = pieChartData;
var radialData = [{
  name: 'Monthly Data',
  data: 48845,
  fill: '#3367d6'
}, {
  name: 'Orders Weekly',
  data: 8875,
  fill: '#83a6ed'
}, {
  name: 'Average Revenue',
  data: 21342,
  fill: '#8dd1e1'
}, {
  name: 'Total Revenue',
  data: 51875,
  fill: '#ffc658'
}, {
  name: 'Total Orders',
  data: 9223,
  fill: '#a4de6c'
}, {
  name: 'Past Orders',
  data: 8543,
  fill: '#d0ed57'
}];
exports.radialData = radialData;
var products = [{
  image: 'http://via.placeholder.com/600x450',
  title: "Up unpacked friendly",
  description: "Contrary to popular belief, Lorem Ipsum is not simply random text.",
  mrp: 250,
  offerPrice: 200
}, {
  image: 'http://via.placeholder.com/500x330',
  title: "It allowance prevailed",
  description: "It is a long established fact that a reader will be distracted",
  mrp: 250,
  offerPrice: 200
}, {
  image: 'http://via.placeholder.com/500x330',
  title: "Case read they must",
  description: "There are many variations of passages of Lorem Ipsum available",
  mrp: 250,
  offerPrice: 200
}, {
  image: 'http://via.placeholder.com/500x330',
  title: "Too carriage attended",
  description: "The standard chunk of Lorem Ipsum used since the 1500s",
  mrp: 250,
  offerPrice: 200
}];
exports.products = products;
var customers = [{
  id: 1,
  image: 'http://via.placeholder.com/150x150',
  name: "John Smith",
  about: "@john.s",
  detail: "3 orders",
  color: "success"
}, {
  id: 2,
  image: 'http://via.placeholder.com/150x150',
  name: "alex dolgove",
  about: "@Alex.Dolgove",
  detail: "2 orders",
  color: "primary"
}, {
  id: 3,
  image: 'http://via.placeholder.com/150x150',
  name: "Domnic Brown",
  about: "@domnic.brown",
  detail: "0 orders",
  color: "danger"
}, {
  id: 4,
  image: 'http://via.placeholder.com/150x150',
  name: "Jimmy jo",
  about: "@jimmy.jo",
  detail: "1 orders",
  color: "primary"
}];
exports.customers = customers;
var appNotification = [{
  id: 1,
  title: "NEW ORDER",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Stella"), " has placed an order for 3 items of $234.0"],
  image: 'http://via.placeholder.com/150x150'
}, {
  id: 2,
  title: "Support ticket",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Jeson Born"), " raised a support ticket"],
  image: 'http://via.placeholder.com/150x150'
}, {
  id: 3,
  title: "new enquiry",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Guptil"), " has placed an order for 5 items of $425.0"],
  image: 'http://via.placeholder.com/150x150'
}, {
  id: 4,
  title: "NEW ORDER",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Alex Dolgove"), " raised a support ticket"],
  image: 'http://via.placeholder.com/150x150'
}];
exports.appNotification = appNotification;
var announcementsNotification = [{
  id: 5,
  title: "NEW ORDER",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Alex Dolgove"), " raised a support ticket"],
  image: 'http://via.placeholder.com/150x150'
}, {
  id: 6,
  title: "Support ticket",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Jeson Born"), " raised a support ticket"],
  image: 'http://via.placeholder.com/150x150'
}, {
  id: 7,
  title: "NEW ORDER",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Stella"), " has placed an order for 3 items of $234.0"],
  image: 'http://via.placeholder.com/150x150'
}, {
  id: 8,
  title: "new enquiry",
  desc: [_react["default"].createElement("a", {
    href: "javascript:void(0)"
  }, "Guptil"), " has placed an order for 5 items of $425.0"],
  image: 'http://via.placeholder.com/150x150'
}];
exports.announcementsNotification = announcementsNotification;
var marketingData = [{
  id: 1,
  name: 'Facebook Ads',
  desc: '63 Likes, 387 Shares',
  icon: 'facebook',
  color: 'bg-indigo lighten-1',
  budget: 570,
  growth: 20
}, {
  id: 2,
  name: 'Twitter Ads',
  desc: '43 Likes, 545 Shares',
  icon: 'twitter',
  color: 'bg-light-blue accent-2',
  budget: 811,
  growth: -5
}, {
  id: 3,
  name: 'Instagram',
  desc: '83 Follows, 210 Likes',
  icon: 'instagram',
  color: 'bg-brown lighten-1',
  budget: 685,
  growth: 20
}, {
  id: 4,
  name: 'LinkedIn',
  desc: '23 Shares, 764 Likes',
  icon: 'linkedin',
  color: 'bg-light-blue darken-3',
  budget: 868,
  growth: 25
}, {
  id: 5,
  name: 'Youtube',
  desc: '1.2k subscribe, 1.8M Likes',
  icon: 'youtube',
  color: 'bg-red accent-4',
  budget: 780,
  growth: 45
}, {
  id: 6,
  name: 'Dribbble',
  desc: '23 Shares, 1.4k Likes',
  icon: 'dribbble',
  color: 'bg-pink lighten-2',
  budget: 868,
  growth: 25
}];
exports.marketingData = marketingData;
var ganttData = {
  'data': [{
    'id': 1,
    'text': 'Office itinerancy',
    'type': 'project',
    'order': '10',
    'progress': 0.4,
    'open': false,
    'user': '0',
    'start_date': '02-04-2017 00:00',
    'duration': 17,
    'end_date': '19-04-2017 00:00',
    'parent': 0
  }, {
    'id': 2,
    'text': 'Office facing',
    'type': 'project',
    'start_date': '02-04-2017 00:00',
    'duration': 8,
    'order': '10',
    'progress': 0.6,
    'user': '0',
    'parent': '1',
    'open': true,
    'end_date': '10-04-2017 00:00'
  }, {
    'id': 5,
    'text': 'Interior office',
    'start_date': '02-04-2017 00:00',
    'duration': 7,
    'order': '3',
    'parent': '2',
    'progress': 0.6,
    'open': true,
    'user': '1',
    'end_date': '09-04-2017 00:00'
  }, {
    'id': 6,
    'text': 'Air conditioners check',
    'start_date': '03-04-2017 00:00',
    'duration': 7,
    'order': '3',
    'parent': '2',
    'progress': 0.6,
    'open': true,
    'user': '2',
    'end_date': '10-04-2017 00:00'
  }, {
    'id': 3,
    'text': 'Furniture installation',
    'type': 'project',
    'start_date': '11-04-2017 00:00',
    'duration': 8,
    'order': '20',
    'parent': '1',
    'progress': 0.6,
    'user': '0',
    'open': true,
    'end_date': '19-04-2017 00:00'
  }, {
    'id': 7,
    'text': 'Workplaces preparation',
    'start_date': '11-04-2017 00:00',
    'duration': 8,
    'order': '3',
    'parent': '3',
    'progress': 0.6,
    'user': '0',
    'open': true,
    'end_date': '19-04-2017 00:00'
  }, {
    'id': 4,
    'text': 'The employee relocation',
    'type': 'project',
    'start_date': '14-04-2017 00:00',
    'duration': 5,
    'order': '30',
    'parent': '1',
    'progress': 0.5,
    'user': '0',
    'open': true,
    'end_date': '19-04-2017 00:00'
  }, {
    'id': 8,
    'text': 'Preparing workplaces',
    'start_date': '14-04-2017 00:00',
    'duration': 5,
    'order': '3',
    'parent': '4',
    'progress': 0.5,
    'user': '2',
    'open': true,
    'end_date': '19-04-2017 00:00'
  }, {
    'id': 9,
    'text': 'Workplaces importation',
    'start_date': '14-04-2017 00:00',
    'duration': 4,
    'order': '3',
    'parent': '4',
    'progress': 0.5,
    'user': '0',
    'open': true,
    'end_date': '18-04-2017 00:00'
  }, {
    'id': 10,
    'text': 'Workplaces exportation',
    'start_date': '14-04-2017 00:00',
    'duration': 3,
    'order': '3',
    'parent': '4',
    'progress': 0.5,
    'user': '3',
    'open': true,
    'end_date': '17-04-2017 00:00'
  }, {
    'id': 11,
    'text': 'Product launch',
    'type': 'project',
    'order': '5',
    'progress': 0.6,
    'open': true,
    'user': '0',
    'start_date': '02-04-2017 00:00',
    'duration': 13,
    'end_date': '15-04-2017 00:00',
    'parent': 0
  }, {
    'id': 12,
    'text': 'Perform Initial testing',
    'start_date': '03-04-2017 00:00',
    'duration': 5,
    'order': '3',
    'parent': '11',
    'progress': 1,
    'user': '0',
    'open': true,
    'end_date': '08-04-2017 00:00'
  }, {
    'id': 13,
    'text': 'Development',
    'type': 'project',
    'start_date': '03-04-2017 00:00',
    'duration': 11,
    'order': '3',
    'parent': '11',
    'progress': 0.5,
    'user': '0',
    'open': true,
    'end_date': '14-04-2017 00:00'
  }, {
    'id': 17,
    'text': 'Develop System',
    'start_date': '03-04-2017 00:00',
    'duration': 2,
    'order': '3',
    'parent': '13',
    'progress': 1,
    'user': '3',
    'open': true,
    'end_date': '05-04-2017 00:00'
  }, {
    'id': 25,
    'text': 'Beta Release',
    'start_date': '06-04-2017 00:00',
    'order': '3',
    'type': 'milestone',
    'parent': '13',
    'progress': 0,
    'open': true,
    'user': '0',
    'end_date': '06-04-2017 00:00',
    'duration': 0
  }, {
    'id': 18,
    'text': 'Integrate System',
    'start_date': '08-04-2017 00:00',
    'duration': 2,
    'order': '3',
    'parent': '13',
    'progress': 0.8,
    'open': true,
    'user': '1',
    'end_date': '10-04-2017 00:00'
  }, {
    'id': 19,
    'text': 'Test',
    'start_date': '10-04-2017 00:00',
    'duration': 4,
    'order': '3',
    'parent': '13',
    'progress': 0.2,
    'open': true,
    'user': '0',
    'end_date': '14-04-2017 00:00'
  }, {
    'id': 20,
    'text': 'Marketing',
    'start_date': '10-04-2017 00:00',
    'duration': 4,
    'order': '3',
    'parent': '13',
    'progress': 0,
    'user': '3',
    'open': true,
    'end_date': '14-04-2017 00:00'
  }, {
    'id': 14,
    'text': 'Analysis',
    'start_date': '02-04-2017 00:00',
    'duration': 6,
    'order': '3',
    'parent': '11',
    'progress': 0.8,
    'user': '0',
    'open': true,
    'end_date': '08-04-2017 00:00'
  }, {
    'id': 15,
    'text': 'Design',
    'type': 'project',
    'start_date': '03-04-2017 00:00',
    'duration': 5,
    'order': '3',
    'parent': '11',
    'progress': 0.2,
    'user': '0',
    'open': false,
    'end_date': '08-04-2017 00:00'
  }, {
    'id': 21,
    'text': 'Design database',
    'start_date': '03-04-2017 00:00',
    'duration': 4,
    'order': '3',
    'parent': '15',
    'progress': 0.5,
    'user': '0',
    'open': true,
    'end_date': '07-04-2017 00:00'
  }, {
    'id': 22,
    'text': 'Software design',
    'start_date': '03-04-2017 00:00',
    'duration': 4,
    'order': '3',
    'parent': '15',
    'progress': 0.1,
    'user': '2',
    'open': true,
    'end_date': '07-04-2017 00:00'
  }, {
    'id': 23,
    'text': 'Interface setup',
    'start_date': '03-04-2017 00:00',
    'duration': 5,
    'order': '3',
    'parent': '15',
    'progress': 0,
    'user': '3',
    'open': true,
    'end_date': '08-04-2017 00:00'
  }, {
    'id': 16,
    'text': 'Documentation creation',
    'start_date': '02-04-2017 00:00',
    'duration': 7,
    'order': '3',
    'parent': '11',
    'progress': 0,
    'user': '2',
    'open': true,
    'end_date': '09-04-2017 00:00'
  }, {
    'id': 24,
    'text': 'Release v1.0',
    'start_date': '15-04-2017 00:00',
    'order': '3',
    'type': 'milestone',
    'parent': '11',
    'progress': 0,
    'open': true,
    'user': '0',
    'end_date': '15-04-2017 00:00',
    'duration': 0
  }],
  'links': [{
    'id': '1',
    'source': '1',
    'target': '2',
    'type': '1'
  }, {
    'id': '2',
    'source': '2',
    'target': '3',
    'type': '0'
  }, {
    'id': '3',
    'source': '3',
    'target': '4',
    'type': '0'
  }, {
    'id': '4',
    'source': '2',
    'target': '5',
    'type': '2'
  }, {
    'id': '5',
    'source': '2',
    'target': '6',
    'type': '2'
  }, {
    'id': '6',
    'source': '3',
    'target': '7',
    'type': '2'
  }, {
    'id': '7',
    'source': '4',
    'target': '8',
    'type': '2'
  }, {
    'id': '8',
    'source': '4',
    'target': '9',
    'type': '2'
  }, {
    'id': '9',
    'source': '4',
    'target': '10',
    'type': '2'
  }, {
    'id': '10',
    'source': '11',
    'target': '12',
    'type': '1'
  }, {
    'id': '11',
    'source': '11',
    'target': '13',
    'type': '1'
  }, {
    'id': '12',
    'source': '11',
    'target': '14',
    'type': '1'
  }, {
    'id': '13',
    'source': '11',
    'target': '15',
    'type': '1'
  }, {
    'id': '14',
    'source': '11',
    'target': '16',
    'type': '1'
  }, {
    'id': '15',
    'source': '13',
    'target': '17',
    'type': '1'
  }, {
    'id': '16',
    'source': '17',
    'target': '25',
    'type': '0'
  }, {
    'id': '17',
    'source': '18',
    'target': '19',
    'type': '0'
  }, {
    'id': '18',
    'source': '19',
    'target': '20',
    'type': '0'
  }, {
    'id': '19',
    'source': '15',
    'target': '21',
    'type': '2'
  }, {
    'id': '20',
    'source': '15',
    'target': '22',
    'type': '2'
  }, {
    'id': '21',
    'source': '15',
    'target': '23',
    'type': '2'
  }, {
    'id': '22',
    'source': '13',
    'target': '24',
    'type': '0'
  }, {
    'id': '23',
    'source': '25',
    'target': '18',
    'type': '0'
  }]
};
exports.ganttData = ganttData;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(lineChartData, "lineChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/data.js");

  __REACT_HOT_LOADER__.register(data, "data", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/data.js");

  __REACT_HOT_LOADER__.register(data1, "data1", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/data.js");

  __REACT_HOT_LOADER__.register(data2, "data2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/data.js");

  __REACT_HOT_LOADER__.register(radarChartData, "radarChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/data.js");

  __REACT_HOT_LOADER__.register(chartData, "chartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/data.js");

  __REACT_HOT_LOADER__.register(chartDataWithoutAxis, "chartDataWithoutAxis", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/data.js");

  __REACT_HOT_LOADER__.register(pieChartData, "pieChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/data.js");

  __REACT_HOT_LOADER__.register(radialData, "radialData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/data.js");

  __REACT_HOT_LOADER__.register(products, "products", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/data.js");

  __REACT_HOT_LOADER__.register(customers, "customers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/data.js");

  __REACT_HOT_LOADER__.register(appNotification, "appNotification", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/data.js");

  __REACT_HOT_LOADER__.register(announcementsNotification, "announcementsNotification", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/data.js");

  __REACT_HOT_LOADER__.register(marketingData, "marketingData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/data.js");

  __REACT_HOT_LOADER__.register(ganttData, "ganttData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/data.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/data.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/data.js");

  __REACT_HOT_LOADER__.register(lineChartData, "lineChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/data.js");

  __REACT_HOT_LOADER__.register(data, "data", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/data.js");

  __REACT_HOT_LOADER__.register(data1, "data1", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/data.js");

  __REACT_HOT_LOADER__.register(data2, "data2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/data.js");

  __REACT_HOT_LOADER__.register(radarChartData, "radarChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/data.js");

  __REACT_HOT_LOADER__.register(chartData, "chartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/data.js");

  __REACT_HOT_LOADER__.register(chartDataWithoutAxis, "chartDataWithoutAxis", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/data.js");

  __REACT_HOT_LOADER__.register(pieChartData, "pieChartData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/data.js");

  __REACT_HOT_LOADER__.register(radialData, "radialData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/data.js");

  __REACT_HOT_LOADER__.register(products, "products", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/data.js");

  __REACT_HOT_LOADER__.register(customers, "customers", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/data.js");

  __REACT_HOT_LOADER__.register(appNotification, "appNotification", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/data.js");

  __REACT_HOT_LOADER__.register(announcementsNotification, "announcementsNotification", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/data.js");

  __REACT_HOT_LOADER__.register(marketingData, "marketingData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/data.js");

  __REACT_HOT_LOADER__.register(ganttData, "ganttData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/data.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/portfolioDashboard/data.js");
}();

;

/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Gantt = _interopRequireDefault(__webpack_require__(1922));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = _Gantt["default"];
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Gantt/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_Gantt, "_Gantt", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Gantt/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Gantt/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Gantt/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Gantt/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Gantt/index.js");
}();

;

/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _dhtmlxGantt = __webpack_require__(1923);

var _System = __webpack_require__(55);

__webpack_require__(1924);

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var Gantt =
/*#__PURE__*/
function (_Component) {
  _inherits(Gantt, _Component);

  function Gantt() {
    _classCallCheck(this, Gantt);

    return _possibleConstructorReturn(this, _getPrototypeOf(Gantt).apply(this, arguments));
  }

  _createClass(Gantt, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          tasks = _this$props.tasks,
          width = _this$props.width; // const defaultWidth = width > TIGHT_FIT_PARAM ? 150 : 80;

      _dhtmlxGantt.gantt.config.readonly = true; // fantastic - one option to rule them all

      _dhtmlxGantt.gantt.config.xml_date = '%d-%m-%Y %H:%i';
      _dhtmlxGantt.gantt.config.date_grid = '%d-%m-%Y';
      _dhtmlxGantt.gantt.config.scale_unit = 'month';
      _dhtmlxGantt.gantt.config.date_scale = '%F, %Y';
      _dhtmlxGantt.gantt.config.scale_height = 50;
      _dhtmlxGantt.gantt.config.min_column_width = 45;
      _dhtmlxGantt.gantt.config.subscales = [{
        unit: 'day',
        step: 1,
        date: '%j, %D'
      }];

      if (width > _System.TIGHT_FIT_PARAM) {
        _dhtmlxGantt.gantt.config.columns = [{
          name: 'text',
          label: 'Initiatives',
          width: '*',
          tree: true
        }, {
          name: 'start_date',
          label: 'Start time',
          align: 'center'
        }, {
          name: 'duration',
          label: 'Duration',
          align: 'center'
        }];
      } else {
        _dhtmlxGantt.gantt.config.columns = [{
          name: 'text',
          label: 'Initiatives',
          width: '200',
          tree: true
        }];
      } // gantt.attachEvent('onGanttReady', function(){
      // var tooltips = gantt.ext.tooltips;
      // tooltips.tooltip.setViewport(gantt.$task_data);
      // });


      _dhtmlxGantt.gantt.templates.tooltip_text = function (task) {
        return '<b>Task:</b> ' + task.text + '<br/>';
      };

      _dhtmlxGantt.gantt.init(this.ganttContainer);

      _dhtmlxGantt.gantt.parse(tasks);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      return _react["default"].createElement("div", {
        ref: function ref(input) {
          _this.ganttContainer = input;
        },
        style: {
          width: '100%',
          height: '400px'
        }
      });
    }
  }]);

  return Gantt;
}(_react.Component);

exports["default"] = Gantt;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Gantt, "Gantt", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Gantt/Gantt.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Gantt/Gantt.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Gantt/Gantt.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Gantt/Gantt.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Gantt/Gantt.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Gantt/Gantt.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Gantt/Gantt.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Gantt/Gantt.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Gantt/Gantt.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Gantt/Gantt.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Gantt/Gantt.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Gantt/Gantt.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Gantt/Gantt.js");

  __REACT_HOT_LOADER__.register(Gantt, "Gantt", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Gantt/Gantt.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Gantt/Gantt.js");
}();

;

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/*
@license

dhtmlxGantt v.6.3.7 Standard

This version of dhtmlxGantt is distributed under GPL 2.0 license and can be legally used in GPL projects.

To use dhtmlxGantt in non-GPL projects (and get Pro version of the product), please obtain Commercial/Enterprise or Ultimate license on our site https://dhtmlx.com/docs/products/dhtmlxGantt/#licensing or contact us at sales@dhtmlx.com

(c) XB Software Ltd.

*/
!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define("dhtmlxgantt",[],e):"object"==typeof exports?exports.dhtmlxgantt=e():t.dhtmlxgantt=e()}(window,function(){return function(t){var e={};function i(n){if(e[n])return e[n].exports;var r=e[n]={i:n,l:!1,exports:{}};return t[n].call(r.exports,r,r.exports,i),r.l=!0,r.exports}return i.m=t,i.c=e,i.d=function(t,e,n){i.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},i.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},i.t=function(t,e){if(1&e&&(t=i(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(i.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var r in t)i.d(n,r,function(e){return t[e]}.bind(null,r));return n},i.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return i.d(e,"a",e),e},i.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},i.p="/codebase/",i(i.s=163)}([function(t,e,i){var n,r=i(2);t.exports={copy:function t(e){var i,n;if(e&&"object"==typeof e)switch(!0){case r.isDate(e):n=new Date(e);break;case r.isArray(e):for(n=new Array(e.length),i=0;i<e.length;i++)n[i]=t(e[i]);break;case r.isStringObject(e):n=new String(e);break;case r.isNumberObject(e):n=new Number(e);break;case r.isBooleanObject(e):n=new Boolean(e);break;default:for(i in n=function(t){return t.constructor.toString()!=={}.constructor.toString()}(e)?Object.create(e):{},e)Object.prototype.hasOwnProperty.apply(e,[i])&&(n[i]=t(e[i]))}return n||e},defined:function(t){return void 0!==t},mixin:function(t,e,i){for(var n in e)(void 0===t[n]||i)&&(t[n]=e[n]);return t},uid:function(){return n||(n=(new Date).valueOf()),++n},bind:function(t,e){return t.bind?t.bind(e):function(){return t.apply(e,arguments)}},event:function(t,e,i,n){t.addEventListener?t.addEventListener(e,i,void 0!==n&&n):t.attachEvent&&t.attachEvent("on"+e,i)},eventRemove:function(t,e,i,n){t.removeEventListener?t.removeEventListener(e,i,void 0!==n&&n):t.detachEvent&&t.detachEvent("on"+e,i)}}},function(t,e){function i(t){var e=0,i=0,n=0,r=0;if(t.getBoundingClientRect){var a=t.getBoundingClientRect(),o=document.body,s=document.documentElement||document.body.parentNode||document.body,l=window.pageYOffset||s.scrollTop||o.scrollTop,c=window.pageXOffset||s.scrollLeft||o.scrollLeft,u=s.clientTop||o.clientTop||0,d=s.clientLeft||o.clientLeft||0;e=a.top+l-u,i=a.left+c-d,n=document.body.offsetWidth-a.right,r=document.body.offsetHeight-a.bottom}else{for(;t;)e+=parseInt(t.offsetTop,10),i+=parseInt(t.offsetLeft,10),t=t.offsetParent;n=document.body.offsetWidth-t.offsetWidth-i,r=document.body.offsetHeight-t.offsetHeight-e}return{y:Math.round(e),x:Math.round(i),width:t.offsetWidth,height:t.offsetHeight,right:Math.round(n),bottom:Math.round(r)}}function n(t){var e=!1,i=!1;if(window.getComputedStyle){var n=window.getComputedStyle(t,null);e=n.display,i=n.visibility}else t.currentStyle&&(e=t.currentStyle.display,i=t.currentStyle.visibility);return"none"!=e&&"hidden"!=i}function r(t){return!isNaN(t.getAttribute("tabindex"))&&1*t.getAttribute("tabindex")>=0}function a(t){return!{a:!0,area:!0}[t.nodeName.loLowerCase()]||!!t.getAttribute("href")}function o(t){return!{input:!0,select:!0,textarea:!0,button:!0,object:!0}[t.nodeName.toLowerCase()]||!t.hasAttribute("disabled")}function s(t){if(!t)return"";var e=t.className||"";return e.baseVal&&(e=e.baseVal),e.indexOf||(e=""),u(e)}var l=document.createElement("div");function c(t){return t.tagName?t:(t=t||window.event).target||t.srcElement}function u(t){return(String.prototype.trim||function(){return this.replace(/^\s+|\s+$/g,"")}).apply(t)}t.exports={getNodePosition:i,getFocusableNodes:function(t){for(var e=t.querySelectorAll(["a[href]","area[href]","input","select","textarea","button","iframe","object","embed","[tabindex]","[contenteditable]"].join(", ")),i=Array.prototype.slice.call(e,0),s=0;s<i.length;s++){var l=i[s];(r(l)||o(l)||a(l))&&n(l)||(i.splice(s,1),s--)}return i},getScrollSize:function(){var t=document.createElement("div");t.style.cssText="visibility:hidden;position:absolute;left:-1000px;width:100px;padding:0px;margin:0px;height:110px;min-height:100px;overflow-y:scroll;",document.body.appendChild(t);var e=t.offsetWidth-t.clientWidth;return document.body.removeChild(t),e},getClassName:s,addClassName:function(t,e){e&&-1===t.className.indexOf(e)&&(t.className+=" "+e)},removeClassName:function(t,e){e=e.split(" ");for(var i=0;i<e.length;i++){var n=new RegExp("\\s?\\b"+e[i]+"\\b(?![-_.])","");t.className=t.className.replace(n,"")}},insertNode:function(t,e){l.innerHTML=e;var i=l.firstChild;return t.appendChild(i),i},removeNode:function(t){t&&t.parentNode&&t.parentNode.removeChild(t)},getChildNodes:function(t,e){for(var i=t.childNodes,n=i.length,r=[],a=0;a<n;a++){var o=i[a];o.className&&-1!==o.className.indexOf(e)&&r.push(o)}return r},toNode:function(t){return"string"==typeof t?document.getElementById(t)||document.querySelector(t)||document.body:t||document.body},locateClassName:function(t,e,i){var n=c(t),r="";for(void 0===i&&(i=!0);n;){if(r=s(n)){var a=r.indexOf(e);if(a>=0){if(!i)return n;var o=0===a||!u(r.charAt(a-1)),l=a+e.length>=r.length||!u(r.charAt(a+e.length));if(o&&l)return n}}n=n.parentNode}return null},locateAttribute:function(t,e){if(e){for(var i=c(t);i;){if(i.getAttribute&&i.getAttribute(e))return i;i=i.parentNode}return null}},getTargetNode:c,getRelativeEventPosition:function(t,e){var n=document.documentElement,r=i(e);return{x:t.clientX+n.scrollLeft-n.clientLeft-r.x+e.scrollLeft,y:t.clientY+n.scrollTop-n.clientTop-r.y+e.scrollTop}},isChildOf:function(t,e){if(!t||!e)return!1;for(;t&&t!=e;)t=t.parentNode;return t===e},hasClass:function(t,e){return"classList"in t?t.classList.contains(e):new RegExp("\\b"+e+"\\b").test(t.className)},closest:function(t,e){if(t.closest)return t.closest(e);if(t.matches||t.msMatchesSelector||t.webkitMatchesSelector){var i=t;if(!document.documentElement.contains(i))return null;do{if((i.matches||i.msMatchesSelector||i.webkitMatchesSelector).call(i,e))return i;i=i.parentElement||i.parentNode}while(null!==i&&1===i.nodeType);return null}return console.error("Your browser is not supported"),null}}},function(t,e){var i={second:1,minute:60,hour:3600,day:86400,week:604800,month:2592e3,quarter:7776e3,year:31536e3};function n(t){return!(!t||"object"!=typeof t)&&!!(t.getFullYear&&t.getMonth&&t.getDate)}function r(t,e){var i=[];if(t.filter)return t.filter(e);for(var n=0;n<t.length;n++)e(t[n],n)&&(i[i.length]=t[n]);return i}t.exports={getSecondsInUnit:function(t){return i[t]||i.hour},forEach:function(t,e){if(t.forEach)t.forEach(e);else for(var i=t.slice(),n=0;n<i.length;n++)e(i[n],n)},arrayMap:function(t,e){if(t.map)return t.map(e);for(var i=t.slice(),n=[],r=0;r<i.length;r++)n.push(e(i[r],r));return n},arrayFind:function(t,e){if(t.find)return t.find(e);for(var i=0;i<t.length;i++)if(e(t[i],i))return t[i]},arrayFilter:r,arrayDifference:function(t,e){return r(t,function(t,i){return!e(t,i)})},arraySome:function(t,e){if(0===t.length)return!1;for(var i=0;i<t.length;i++)if(e(t[i],i,t))return!0;return!1},hashToArray:function(t){var e=[];for(var i in t)t.hasOwnProperty(i)&&e.push(t[i]);return e},sortArrayOfHash:function(t,e,i){var n=function(t,e){return t<e};t.sort(function(t,r){return t[e]===r[e]?0:i?n(t[e],r[e]):n(r[e],t[e])})},throttle:function(t,e){var i=!1;return function(){i||(t.apply(null,arguments),i=!0,setTimeout(function(){i=!1},e))}},isArray:function(t){return Array.isArray?Array.isArray(t):t&&void 0!==t.length&&t.pop&&t.push},isDate:n,isValidDate:function(t){return n(t)&&!isNaN(t.getTime())},isStringObject:function(t){return t&&"object"==typeof t&&"function String() { [native code] }"===Function.prototype.toString.call(t.constructor)},isNumberObject:function(t){return t&&"object"==typeof t&&"function Number() { [native code] }"===Function.prototype.toString.call(t.constructor)},isBooleanObject:function(t){return t&&"object"==typeof t&&"function Boolean() { [native code] }"===Function.prototype.toString.call(t.constructor)},delay:function(t,e){var i,n=function(){n.$cancelTimeout(),t.$pending=!0;var r=Array.prototype.slice.call(arguments);i=setTimeout(function(){t.apply(this,r),n.$pending=!1},e)};return n.$pending=!1,n.$cancelTimeout=function(){clearTimeout(i),t.$pending=!1},n.$execute=function(){t(),t.$cancelTimeout()},n},objectKeys:function(t){if(Object.keys)return Object.keys(t);var e,i=[];for(e in t)Object.prototype.hasOwnProperty.call(t,e)&&i.push(e);return i},requestAnimationFrame:function(t){var e=window;return(e.requestAnimationFrame||e.webkitRequestAnimationFrame||e.msRequestAnimationFrame||e.mozRequestAnimationFrame||e.oRequestAnimationFrame||function(t){setTimeout(t,1e3/60)})(t)},isEventable:function(t){return t.attachEvent&&t.detachEvent}}},function(t,e){t.exports=function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i]);function n(){this.constructor=t}t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)}},function(t,e){var i=function(){this._connected=[],this._silent_mode=!1};i.prototype={_silentStart:function(){this._silent_mode=!0},_silentEnd:function(){this._silent_mode=!1}};var n=function(t){var e=[],i=function(){for(var i=!0,n=0;n<e.length;n++)if(e[n]){var r=e[n].apply(t,arguments);i=i&&r}return i};return i.addEvent=function(t){return"function"==typeof t&&e.push(t)-1},i.removeEvent=function(t){e[t]=null},i};t.exports=function(t){var e=new i;t.attachEvent=function(t,i,r){return t="ev_"+t.toLowerCase(),e[t]||(e[t]=n(r||this)),t+":"+e[t].addEvent(i)},t.attachAll=function(t,e){this.attachEvent("listen_all",t,e)},t.callEvent=function(t,i,n){if(e._silent_mode)return!0;var r="ev_"+t.toLowerCase();return e.ev_listen_all&&e.ev_listen_all.apply(n||this,[t].concat(i)),!e[r]||e[r].apply(n||this,i)},t.checkEvent=function(t){return!!e["ev_"+t.toLowerCase()]},t.detachEvent=function(t){if(t){var i=t.split(":"),n=i[0],r=i[1];e[n]&&e[n].removeEvent(r)}},t.detachAllEvents=function(){for(var t in e)0===t.indexOf("ev_")&&delete e[t]}}},function(t,e){function i(){console.log("Method is not implemented.")}function n(){}n.prototype.render=i,n.prototype.set_value=i,n.prototype.get_value=i,n.prototype.focus=i,t.exports=function(t){return n}},function(t,e){t.exports=function(t){var e=function(){};return e.prototype={show:function(t,e,i,n){},hide:function(){},set_value:function(t,e,i,n){this.get_input(n).value=t},get_value:function(t,e,i){return this.get_input(i).value||""},is_changed:function(t,e,i,n){var r=this.get_value(e,i,n);return r&&t&&r.valueOf&&t.valueOf?r.valueOf()!=t.valueOf():r!=t},is_valid:function(t,e,i,n){return!0},save:function(t,e,i){},get_input:function(t){return t.querySelector("input")},focus:function(t){var e=this.get_input(t);e&&(e.focus&&e.focus(),e.select&&e.select())}},e}},function(t,e){t.exports=function(t,e,i,n){var r=e.$getConfig().row_height;return{start:Math.max(0,Math.floor(n.y/r)-5),end:Math.min(i.count(),Math.ceil(n.y_end/r)+5)}}},function(t,e,i){var n=i(0),r=i(4),a=i(1),o=function(){"use strict";function t(t,e,i,o){t&&(this.$container=a.toNode(t),this.$parent=t),this.$config=n.mixin(e,{headerHeight:33}),this.$gantt=o,this.$domEvents=o._createDomEventScope(),this.$id=e.id||"c"+n.uid(),this.$name="cell",this.$factory=i,r(this)}return t.prototype.destructor=function(){this.$parent=this.$container=this.$view=null,this.$gantt.$services.getService("mouseEvents").detach("click","gantt_header_arrow",this._headerClickHandler),this.$domEvents.detachAll(),this.callEvent("onDestroy",[]),this.detachAllEvents()},t.prototype.cell=function(t){return null},t.prototype.scrollTo=function(t,e){1*t==t&&(this.$view.scrollLeft=t),1*e==e&&(this.$view.scrollTop=e)},t.prototype.clear=function(){this.getNode().innerHTML="",this.getNode().className="gantt_layout_content",this.getNode().style.padding="0"},t.prototype.resize=function(t){if(this.$parent)return this.$parent.resize(t);!1===t&&(this.$preResize=!0);var e=this.$container,i=e.offsetWidth,n=e.offsetHeight,r=this.getSize();e===document.body&&(i=document.body.offsetWidth,n=document.body.offsetHeight),i<r.minWidth&&(i=r.minWidth),i>r.maxWidth&&(i=r.maxWidth),n<r.minHeight&&(n=r.minHeight),n>r.maxHeight&&(n=r.maxHeight),this.setSize(i,n),this.$preResize,this.$preResize=!1},t.prototype.hide=function(){this._hide(!0),this.resize()},t.prototype.show=function(t){this._hide(!1),t&&this.$parent&&this.$parent.show(),this.resize()},t.prototype._hide=function(t){if(!0===t&&this.$view.parentNode)this.$view.parentNode.removeChild(this.$view);else if(!1===t&&!this.$view.parentNode){var e=this.$parent.cellIndex(this.$id);this.$parent.moveView(this,e)}this.$config.hidden=t},t.prototype.$toHTML=function(t,e){void 0===t&&(t=""),e=[e||"",this.$config.css||""].join(" ");var i=this.$config,n="";i.raw?t="string"==typeof i.raw?i.raw:"":(t||(t="<div class='gantt_layout_content' "+(e?" class='"+e+"' ":"")+" >"+(i.html||"")+"</div>"),i.header&&(n="<div class='gantt_layout_header'>"+(i.canCollapse?"<div class='gantt_layout_header_arrow'></div>":"")+"<div class='gantt_layout_header_content'>"+i.header+"</div></div>"));return"<div class='gantt_layout_cell "+e+"' data-cell-id='"+this.$id+"'>"+n+t+"</div>"},t.prototype.$fill=function(t,e){this.$view=t,this.$parent=e,this.init()},t.prototype.getNode=function(){return this.$view.querySelector("gantt_layout_cell")||this.$view},t.prototype.init=function(){var t=this;this._headerClickHandler=function(e){a.locateAttribute(e,"data-cell-id")==t.$id&&t.toggle()},this.$gantt.$services.getService("mouseEvents").delegate("click","gantt_header_arrow",this._headerClickHandler),this.callEvent("onReady",[])},t.prototype.toggle=function(){this.$config.collapsed=!this.$config.collapsed,this.resize()},t.prototype.getSize=function(){var t={height:this.$config.height||0,width:this.$config.width||0,gravity:this.$config.gravity||1,minHeight:this.$config.minHeight||0,minWidth:this.$config.minWidth||0,maxHeight:this.$config.maxHeight||1e5,maxWidth:this.$config.maxWidth||1e5};if(this.$config.collapsed){var e="x"===this.$config.mode;t[e?"width":"height"]=t[e?"maxWidth":"maxHeight"]=this.$config.headerHeight}return t},t.prototype.getContentSize=function(){var t=this.$lastSize.contentX;t!==1*t&&(t=this.$lastSize.width);var e=this.$lastSize.contentY;return e!==1*e&&(e=this.$lastSize.height),{width:t,height:e}},t.prototype._getBorderSizes=function(){var t={top:0,right:0,bottom:0,left:0,horizontal:0,vertical:0};return this._currentBorders&&(this._currentBorders[this._borders.left]&&(t.left=1,t.horizontal++),this._currentBorders[this._borders.right]&&(t.right=1,t.horizontal++),this._currentBorders[this._borders.top]&&(t.top=1,t.vertical++),this._currentBorders[this._borders.bottom]&&(t.bottom=1,t.vertical++)),t},t.prototype.setSize=function(t,e){this.$view.style.width=t+"px",this.$view.style.height=e+"px";var i=this._getBorderSizes(),n=e-i.vertical,r=t-i.horizontal;this.$lastSize={x:t,y:e,contentX:r,contentY:n},this.$config.header?this._sizeHeader():this._sizeContent()},t.prototype._borders={left:"gantt_layout_cell_border_left",right:"gantt_layout_cell_border_right",top:"gantt_layout_cell_border_top",bottom:"gantt_layout_cell_border_bottom"},t.prototype._setBorders=function(t,e){e||(e=this);var i=e.$view;for(var n in this._borders)a.removeClassName(i,this._borders[n]);"string"==typeof t&&(t=[t]);var r={};for(n=0;n<t.length;n++)a.addClassName(i,t[n]),r[t[n]]=!0;e._currentBorders=r},t.prototype._sizeContent=function(){var t=this.$view.childNodes[0];t&&"gantt_layout_content"==t.className&&(t.style.height=this.$lastSize.contentY+"px")},t.prototype._sizeHeader=function(){var t=this.$lastSize;t.contentY-=this.$config.headerHeight;var e=this.$view.childNodes[0],i=this.$view.childNodes[1],n="x"===this.$config.mode;if(this.$config.collapsed)if(i.style.display="none",n){e.className="gantt_layout_header collapsed_x",e.style.width=t.y+"px";var r=Math.floor(t.y/2-t.x/2);e.style.transform="rotate(90deg) translate("+r+"px, "+r+"px)",i.style.display="none"}else e.className="gantt_layout_header collapsed_y";else e.className=n?"gantt_layout_header":"gantt_layout_header vertical",e.style.width="auto",e.style.transform="",i.style.display="",i.style.height=t.contentY+"px";e.style.height=this.$config.headerHeight+"px"},t}();t.exports=o},function(t,e){var i={isIE:navigator.userAgent.indexOf("MSIE")>=0||navigator.userAgent.indexOf("Trident")>=0,isIE6:!window.XMLHttpRequest&&navigator.userAgent.indexOf("MSIE")>=0,isIE7:navigator.userAgent.indexOf("MSIE 7.0")>=0&&navigator.userAgent.indexOf("Trident")<0,isIE8:navigator.userAgent.indexOf("MSIE 8.0")>=0&&navigator.userAgent.indexOf("Trident")>=0,isOpera:navigator.userAgent.indexOf("Opera")>=0,isChrome:navigator.userAgent.indexOf("Chrome")>=0,isKHTML:navigator.userAgent.indexOf("Safari")>=0||navigator.userAgent.indexOf("Konqueror")>=0,isFF:navigator.userAgent.indexOf("Firefox")>=0,isIPad:navigator.userAgent.search(/iPad/gi)>=0,isEdge:-1!=navigator.userAgent.indexOf("Edge")};t.exports=i},function(t,e,i){var n=i(3),r=i(20);t.exports=function(t){var e=i(5)(t);function a(){return e.apply(this,arguments)||this}return n(a,e),a.prototype.render=function(t){var e="<div class='gantt_cal_ltext' style='height:"+((t.height||"23")+"px")+";'>";return e+=r.getHtmlSelect(t.options,[{key:"style",value:"width:100%;"}]),e+="</div>"},a.prototype.set_value=function(t,e,i,n){var r=t.firstChild;!r._dhx_onchange&&n.onchange&&(r.onchange=n.onchange,r._dhx_onchange=!0),void 0===e&&(e=(r.options[0]||{}).value),r.value=e||""},a.prototype.get_value=function(t){return t.firstChild.value},a.prototype.focus=function(e){var i=e.firstChild;t._focus(i,!0)},a}},function(t,e,i){var n=i(0);t.exports={createDropTargetObject:function(t){var e={targetParent:null,targetIndex:0,targetId:null,child:!1,nextSibling:!1,prevSibling:!1};return t&&n.mixin(e,t,!0),e},nextSiblingTarget:function(t,e,i){var n=this.createDropTargetObject();return n.targetId=e,n.nextSibling=!0,n.targetParent=i.getParent(n.targetId),n.targetIndex=i.getBranchIndex(n.targetId),(i.getParent(t)!=n.targetParent||n.targetIndex<i.getBranchIndex(t))&&(n.targetIndex+=1),n},prevSiblingTarget:function(t,e,i){var n=this.createDropTargetObject();return n.targetId=e,n.prevSibling=!0,n.targetParent=i.getParent(n.targetId),n.targetIndex=i.getBranchIndex(n.targetId),i.getParent(t)==n.targetParent&&n.targetIndex>i.getBranchIndex(t)&&(n.targetIndex-=1),n},firstChildTarget:function(t,e,i){var n=this.createDropTargetObject();return n.targetId=e,n.targetParent=n.targetId,n.targetIndex=0,n.child=!0,n},lastChildTarget:function(t,e,i){var n=i.getChildren(e),r=this.createDropTargetObject();return r.targetId=n[n.length-1],r.targetParent=e,r.targetIndex=n.length,r.nextSibling=!0,r}}},function(t,e){t.exports=function(t){var e=[];return{delegate:function(i,n,r,a){e.push([i,n,r,a]),t.$services.getService("mouseEvents").delegate(i,n,r,a)},destructor:function(){for(var i=t.$services.getService("mouseEvents"),n=0;n<e.length;n++){var r=e[n];i.detach(r[0],r[1],r[2],r[3])}e=[]}}}},function(t,e,i){var n=i(0);t.exports=function(t){var e=t.date,i=t.$services;return{getSum:function(t,e,i){void 0===i&&(i=t.length-1),void 0===e&&(e=0);for(var n=0,r=e;r<=i;r++)n+=t[r];return n},setSumWidth:function(t,e,i,n){var r=e.width;void 0===n&&(n=r.length-1),void 0===i&&(i=0);var a=n-i+1;if(!(i>r.length-1||a<=0||n>r.length-1)){var o=t-this.getSum(r,i,n);this.adjustSize(o,r,i,n),this.adjustSize(-o,r,n+1),e.full_width=this.getSum(r)}},splitSize:function(t,e){for(var i=[],n=0;n<e;n++)i[n]=0;return this.adjustSize(t,i),i},adjustSize:function(t,e,i,n){i||(i=0),void 0===n&&(n=e.length-1);for(var r=n-i+1,a=this.getSum(e,i,n),o=i;o<=n;o++){var s=Math.floor(t*(a?e[o]/a:1/r));a-=e[o],t-=s,r--,e[o]+=s}e[e.length-1]+=t},sortScales:function(t){function i(t,i){var n=new Date(1970,0,1);return e.add(n,i,t)-n}t.sort(function(t,e){return i(t.unit,t.step)<i(e.unit,e.step)?1:i(t.unit,t.step)>i(e.unit,e.step)?-1:0});for(var n=0;n<t.length;n++)t[n].index=n},_isLegacyMode:function(t){var e=t||i.config();return e.scale_unit||e.date_scale||e.subscales},_prepareScaleObject:function(e){var i=e.format;return i||(i=e.template||e.date||"%d %M"),"string"==typeof i&&(i=t.date.date_to_str(i)),{unit:e.unit||"day",step:e.step||1,format:i,css:e.css}},primaryScale:function(t){var e,n=i.getService("templateLoader"),r=this._isLegacyMode(t),a=t||i.config();if(r)n.initTemplate("date_scale",void 0,void 0,a,i.templates()),e={unit:i.config().scale_unit,step:i.config().step,template:i.templates().date_scale,date:i.config().date_scale,css:i.templates().scale_cell_class};else{var o=a.scales[0];e={unit:o.unit,step:o.step,template:o.template,format:o.format,date:o.date,css:o.css||i.templates().scale_cell_class}}return this._prepareScaleObject(e)},getSubScales:function(t){var e=this._isLegacyMode(t),n=t||i.config();return(e?n.subscales||[]:n.scales.slice(1)).map(function(t){return this._prepareScaleObject(t)}.bind(this))},prepareConfigs:function(t,e,i,n,r,a,o){for(var s=this.splitSize(n,t.length),l=i,c=[],u=t.length-1;u>=0;u--){var d=u==t.length-1,h=this.initScaleConfig(t[u],r,a);d&&this.processIgnores(h),this.initColSizes(h,e,l,s[u]),this.limitVisibleRange(h),d&&(l=h.full_width),c.unshift(h)}for(u=0;u<c.length-1;u++)this.alineScaleColumns(c[c.length-1],c[u]);for(u=0;u<c.length;u++)o&&this.reverseScale(c[u]),this.setPosSettings(c[u]);return c},reverseScale:function(t){t.width=t.width.reverse(),t.trace_x=t.trace_x.reverse();var e=t.trace_indexes;t.trace_indexes={},t.trace_index_transition={},t.rtl=!0;for(var i=0;i<t.trace_x.length;i++)t.trace_indexes[t.trace_x[i].valueOf()]=i,t.trace_index_transition[e[t.trace_x[i].valueOf()]]=i;return t},setPosSettings:function(t){for(var e=0,i=t.trace_x.length;e<i;e++)t.left.push((t.width[e-1]||0)+(t.left[e-1]||0))},_ignore_time_config:function(t,n){if(i.config().skip_off_time){for(var r=!0,a=t,o=0;o<n.step;o++)o&&(a=e.add(t,o,n.unit)),r=r&&!this.isWorkTime(a,n.unit);return r}return!1},processIgnores:function(t){t.ignore_x={},t.display_count=t.count},initColSizes:function(t,i,n,r){var a=n;t.height=r;var o=void 0===t.display_count?t.count:t.display_count;o||(o=1),t.col_width=Math.floor(a/o),i&&t.col_width<i&&(t.col_width=i,a=t.col_width*o),t.width=[];for(var s=t.ignore_x||{},l=0;l<t.trace_x.length;l++)if(s[t.trace_x[l].valueOf()]||t.display_count==t.count)t.width[l]=0;else{var c=1;"month"==t.unit&&(c=Math.round((e.add(t.trace_x[l],t.step,t.unit)-t.trace_x[l])/864e5)),t.width[l]=c}this.adjustSize(a-this.getSum(t.width),t.width),t.full_width=this.getSum(t.width)},initScaleConfig:function(t,e,i){var r=n.mixin({count:0,col_width:0,full_width:0,height:0,width:[],left:[],trace_x:[],trace_indexes:{},min_date:new Date(e),max_date:new Date(i)},t);return this.eachColumn(t.unit,t.step,e,i,function(t){r.count++,r.trace_x.push(new Date(t)),r.trace_indexes[t.valueOf()]=r.trace_x.length-1}),r.trace_x_ascending=r.trace_x.slice(),r},iterateScales:function(t,e,i,n,r){for(var a=e.trace_x,o=t.trace_x,s=i||0,l=n||o.length-1,c=0,u=1;u<a.length;u++){var d=t.trace_indexes[+a[u]];void 0!==d&&d<=l&&(r&&r.apply(this,[c,u,s,d]),s=d,c=u)}},alineScaleColumns:function(t,e,i,n){this.iterateScales(t,e,i,n,function(i,n,r,a){var o=this.getSum(t.width,r,a-1);this.getSum(e.width,i,n-1)!=o&&this.setSumWidth(o,e,i,n-1)})},eachColumn:function(i,n,r,a,o){var s=new Date(r),l=new Date(a);e[i+"_start"]&&(s=e[i+"_start"](s));var c=new Date(s);for(+c>=+l&&(l=e.add(c,n,i));+c<+l;){o.call(this,new Date(c));var u=c.getTimezoneOffset();c=e.add(c,n,i),c=t._correct_dst_change(c,u,n,i),e[i+"_start"]&&(c=e[i+"_start"](c))}},limitVisibleRange:function(t){var i=t.trace_x,n=t.width.length-1,r=0;if(+i[0]<+t.min_date&&0!=n){var a=Math.floor(t.width[0]*((i[1]-t.min_date)/(i[1]-i[0])));r+=t.width[0]-a,t.width[0]=a,i[0]=new Date(t.min_date)}var o=i.length-1,s=i[o],l=e.add(s,t.step,t.unit);if(+l>+t.max_date&&o>0&&(a=t.width[o]-Math.floor(t.width[o]*((l-t.max_date)/(l-s))),r+=t.width[o]-a,t.width[o]=a),r){for(var c=this.getSum(t.width),u=0,d=0;d<t.width.length;d++){var h=Math.floor(r*(t.width[d]/c));t.width[d]+=h,u+=h}this.adjustSize(r-u,t.width)}}}}},function(t,e,i){var n=i(13),r=i(4),a=i(0),o=i(32),s=i(133),l=function(t,e,i,s){this.$config=a.mixin({},e||{}),this.$scaleHelper=new n(s),this.$gantt=s,this._posFromDateCache={},this._timelineDragScroll=null,a.mixin(this,o()),r(this)};function c(t,e){for(var i,n,r,a=0,o=t.length-1;a<=o;)if(n=+t[i=Math.floor((a+o)/2)],r=+t[i-1],n<e)a=i+1;else{if(!(n>e)){for(;+t[i]==+t[i+1];)i++;return i}if(!isNaN(r)&&r<e)return i-1;o=i-1}return t.length-1}l.prototype={init:function(t){t.innerHTML+="<div class='gantt_task' style='width:inherit;height:inherit;'></div>",this.$task=t.childNodes[0],this.$task.innerHTML="<div class='gantt_task_scale'></div><div class='gantt_data_area'></div>",this.$task_scale=this.$task.childNodes[0],this.$task_data=this.$task.childNodes[1],this.$task_data.innerHTML="<div class='gantt_task_bg'></div><div class='gantt_links_area'></div><div class='gantt_bars_area'></div>",this.$task_bg=this.$task_data.childNodes[0],this.$task_links=this.$task_data.childNodes[1],this.$task_bars=this.$task_data.childNodes[2],this._tasks={col_width:0,width:[],full_width:0,trace_x:[],rendered:{}};var e=this.$getConfig(),i=e[this.$config.bind+"_attribute"],n=e[this.$config.bindLinks+"_attribute"];!i&&this.$config.bind&&(i=this.$config.bind+"_id"),!n&&this.$config.bindLinks&&(n=this.$config.bindLinks+"_id"),this.$config.item_attribute=i||null,this.$config.link_attribute=n||null;var r=this._createLayerConfig();this.$config.layers||(this.$config.layers=r.tasks),this.$config.linkLayers||(this.$config.linkLayers=r.links),this._attachLayers(this.$gantt),this.callEvent("onReady",[]),this.$gantt.ext.dragTimeline&&(this._timelineDragScroll=this.$gantt.ext.dragTimeline.create(),this._timelineDragScroll.attach(this))},setSize:function(t,e){var i=this.$getConfig();if(1*t===t&&(this.$config.width=t),1*e===e){this.$config.height=e;var n=Math.max(this.$config.height-i.scale_height);this.$task_data.style.height=n+"px"}if(this.refresh(),this.$task_bg.style.backgroundImage="",i.smart_rendering&&this.$config.rowStore){var r=this.$config.rowStore;this.$task_bg.style.height=i.row_height*r.countVisible()+"px"}else this.$task_bg.style.height="";for(var a=this._tasks,o=this.$task_data.childNodes,s=0,l=o.length;s<l;s++){var c=o[s];c.hasAttribute("data-layer")&&c.style&&(c.style.width=a.full_width+"px")}},isVisible:function(){return this.$parent&&this.$parent.$config?!this.$parent.$config.hidden:this.$task.offsetWidth},getSize:function(){var t=this.$getConfig(),e=this.$config.rowStore,i=e?t.row_height*e.countVisible():0,n=this.isVisible()?this._tasks.full_width:0;return{x:this.isVisible()?this.$config.width:0,y:this.isVisible()?this.$config.height:0,contentX:this.isVisible()?n:0,contentY:this.isVisible()?t.scale_height+i:0,scrollHeight:this.isVisible()?i:0,scrollWidth:this.isVisible()?n:0}},scrollTo:function(t,e){if(this.isVisible()){var i=!1;this.$config.scrollTop=this.$config.scrollTop||0,this.$config.scrollLeft=this.$config.scrollLeft||0,1*e===e&&(this.$config.scrollTop=e,this.$task_data.scrollTop=this.$config.scrollTop,i=!0),1*t===t&&(this.$task.scrollLeft=t,this.$config.scrollLeft=this.$task.scrollLeft,this._refreshScales(),i=!0),i&&this.callEvent("onScroll",[this.$config.scrollLeft,this.$config.scrollTop])}},_refreshScales:function(){if(this.isVisible()&&this.$getConfig().smart_scales){var t=this.getViewPort(),e=this._scales;this.$task_scale.innerHTML=this._getScaleChunkHtml(e,t.x,t.x_end)}},getViewPort:function(){var t=this.$config.scrollLeft||0,e=this.$config.scrollTop||0,i=this.$config.height||0,n=this.$config.width||0;return{y:e,y_end:e+i,x:t,x_end:t+n,height:i,width:n}},_createLayerConfig:function(){var t=this,e=function(){return t.isVisible()};return{tasks:[{expose:!0,renderer:this.$gantt.$ui.layers.taskBar(),container:this.$task_bars,filter:[e]},{renderer:this.$gantt.$ui.layers.taskSplitBar(),filter:[e],container:this.$task_bars,append:!0},{renderer:this.$gantt.$ui.layers.taskBg(),container:this.$task_bg,filter:[e]}],links:[{expose:!0,renderer:this.$gantt.$ui.layers.link(),container:this.$task_links,filter:[e]}]}},_attachLayers:function(t){this._taskLayers=[],this._linkLayers=[];var e=this,i=this.$gantt.$services.getService("layers");if(this.$config.bind){this._bindStore();var n=i.getDataRender(this.$config.bind);n||(n=i.createDataRender({name:this.$config.bind,defaultContainer:function(){return e.$task_data}})),n.container=function(){return e.$task_data};for(var r=this.$config.layers,a=0;r&&a<r.length;a++){"string"==typeof(c=r[a])&&(c=this.$gantt.$ui.layers[c]()),("function"==typeof c||c&&c.render&&c.update)&&(c={renderer:c}),c.view=this;var o=n.addLayer(c);this._taskLayers.push(o),c.expose&&(this._taskRenderer=n.getLayer(o))}this._initStaticBackgroundRender()}if(this.$config.bindLinks){e.$config.linkStore=e.$gantt.getDatastore(e.$config.bindLinks);var s=i.getDataRender(this.$config.bindLinks);s||(s=i.createDataRender({name:this.$config.bindLinks,defaultContainer:function(){return e.$task_data}}));var l=this.$config.linkLayers;for(a=0;l&&a<l.length;a++){var c;"string"==typeof c&&(c=this.$gantt.$ui.layers[c]()),(c=l[a]).view=this;var u=s.addLayer(c);this._taskLayers.push(u),l[a].expose&&(this._linkRenderer=s.getLayer(u))}}},_initStaticBackgroundRender:function(){var t=this,e=s.create(),i=t.$config.rowStore;i&&(this._staticBgHandler=i.attachEvent("onStoreUpdated",function(i,n,r){if(null===i&&t.isVisible()){var a=t.$getConfig();if(a.static_background){var o=t.$gantt.getDatastore(t.$config.bind),s=t.$task_bg_static;s||((s=document.createElement("div")).className="gantt_task_bg",t.$task_bg_static=s,t.$task_bg.nextSibling?t.$task_data.insertBefore(s,t.$task_bg.nextSibling):t.$task_data.appendChild(s)),o&&e.render(s,a,t.getScale(),a.row_height*o.countVisible())}else a.static_background&&t.$task_bg_static&&t.$task_bg_static.parentNode&&t.$task_bg_static.parentNode.removeChild(t.$task_bg_static)}}),this.attachEvent("onDestroy",function(){e.destroy()}),this._initStaticBackgroundRender=function(){})},_clearLayers:function(t){var e=this.$gantt.$services.getService("layers"),i=e.getDataRender(this.$config.bind),n=e.getDataRender(this.$config.bindLinks);if(this._taskLayers)for(var r=0;r<this._taskLayers.length;r++)i.removeLayer(this._taskLayers[r]);if(this._linkLayers)for(r=0;r<this._linkLayers.length;r++)n.removeLayer(this._linkLayers[r]);this._linkLayers=[],this._taskLayers=[]},_render_tasks_scales:function(){var t=this.$getConfig(),e="",i=0,n=0,r=this.$gantt.getState();if(this.isVisible()){var a=this.$scaleHelper,o=this._getScales();n=t.scale_height;var s=this.$config.width;"x"!=t.autosize&&"xy"!=t.autosize||(s=Math.max(t.autosize_min_width,0));var l=a.prepareConfigs(o,t.min_column_width,s,n-1,r.min_date,r.max_date,t.rtl),c=this._tasks=l[l.length-1];this._scales=l,this._posFromDateCache={},e=this._getScaleChunkHtml(l,0,this.$config.width),i=c.full_width+"px",n+="px"}this.$task_scale.style.height=n,this.$task_data.style.width=this.$task_scale.style.width=i,this.$task_scale.innerHTML=e},_getScaleChunkHtml:function(t,e,i){for(var n=[],r=this.$gantt.$services.templates().scale_row_class,a=0;a<t.length;a++){var o="gantt_scale_line",s=r(t[a]);s&&(o+=" "+s),n.push('<div class="'+o+'" style="height:'+t[a].height+"px;position:relative;line-height:"+t[a].height+'px">'+this._prepareScaleHtml(t[a],e,i)+"</div>")}return n.join("")},_prepareScaleHtml:function(t,e,i){var n=this.$getConfig(),r=this.$gantt.$services.templates(),a=[],o=null,s=null,l=t.format||t.template||t.date;"string"==typeof l&&(l=this.$gantt.date.date_to_str(l));var u=0,d=t.count;!n.smart_scales||isNaN(e)||isNaN(i)||(u=c(t.left,e),d=c(t.left,i)+1),s=t.css||function(){},!t.css&&n.inherit_scale_class&&(s=r.scale_cell_class);for(var h=u;h<d&&t.trace_x[h];h++){o=new Date(t.trace_x[h]);var f=l.call(this,o),_=t.width[h],g=t.height,p=t.left[h],v="",m="",y="";if(_){v="width:"+_+"px;height:"+g+"px;"+(n.smart_scales?"position:absolute;left:"+p+"px":""),y="gantt_scale_cell"+(h==t.count-1?" gantt_last_cell":""),(m=s.call(this,o))&&(y+=" "+m);var b="<div class='"+y+"'"+this.$gantt._waiAria.getTimelineCellAttr(f)+" style='"+v+"'>"+f+"</div>";a.push(b)}}return a.join("")},dateFromPos:function(t){var e=this._tasks;if(t<0||t>e.full_width||!e.full_width)return null;var i=c(this._tasks.left,t),n=this._tasks.left[i],r=e.width[i]||e.col_width,a=0;r&&(a=(t-n)/r,e.rtl&&(a=1-a));var o=0;return a&&(o=this._getColumnDuration(e,e.trace_x[i])),new Date(e.trace_x[i].valueOf()+Math.round(a*o))},posFromDate:function(t){if(!this.isVisible())return 0;if(!t)return 0;var e=String(t.valueOf());if(void 0!==this._posFromDateCache[e])return this._posFromDateCache[e];var i=this.columnIndexByDate(t);this.$gantt.assert(i>=0,"Invalid day index");var n=Math.floor(i),r=i%1,a=this._tasks.left[Math.min(n,this._tasks.width.length-1)];n==this._tasks.width.length&&(a+=this._tasks.width[this._tasks.width.length-1]),r&&(n<this._tasks.width.length?a+=this._tasks.width[n]*(r%1):a+=1);var o=Math.round(a);return this._posFromDateCache[e]=o,Math.round(o)},_getNextVisibleColumn:function(t,e,i){for(var n=+e[t],r=t;i[n];)n=+e[++r];return r},_getPrevVisibleColumn:function(t,e,i){for(var n=+e[t],r=t;i[n];)n=+e[--r];return r},_getClosestVisibleColumn:function(t,e,i){var n=this._getNextVisibleColumn(t,e,i);return e[n]||(n=this._getPrevVisibleColumn(t,e,i)),n},columnIndexByDate:function(t){var e=new Date(t).valueOf(),i=this._tasks.trace_x_ascending,n=this._tasks.ignore_x,r=this.$gantt.getState();if(e<=r.min_date)return this._tasks.rtl?i.length:0;if(e>=r.max_date)return this._tasks.rtl?0:i.length;var a=c(i,e),o=this._getClosestVisibleColumn(a,i,n),s=i[o],l=this._tasks.trace_index_transition;if(!s)return l?l[0]:0;var u=(t-i[o])/this._getColumnDuration(this._tasks,i[o]);return l?l[o]+(1-u):o+u},getItemPosition:function(t,e,i){var n,r,a;return this._tasks.rtl?(r=this.posFromDate(e||t.start_date),n=this.posFromDate(i||t.end_date)):(n=this.posFromDate(e||t.start_date),r=this.posFromDate(i||t.end_date)),a=Math.max(r-n,0),{left:n,top:this.getItemTop(t.id),height:this.getItemHeight(),width:a}},getItemHeight:function(){var t=this.$getConfig(),e=t.task_height;if("full"==e){var i=t.task_height_offset||5;e=t.row_height-i}return e=Math.min(e,t.row_height),Math.max(e,0)},getScale:function(){return this._tasks},_getScales:function(){var t=this.$getConfig(),e=this.$scaleHelper,i=[e.primaryScale(t)].concat(e.getSubScales(t));return e.sortScales(i),i},_getColumnDuration:function(t,e){return this.$gantt.date.add(e,t.step,t.unit)-e},_bindStore:function(){if(this.$config.bind){var t=this.$gantt.getDatastore(this.$config.bind);if(this.$config.rowStore=t,t&&!t._timelineCacheAttached){var e=this;t._timelineCacheAttached=t.attachEvent("onBeforeFilter",function(){e._resetTopPositionHeight()})}}},_unbindStore:function(){if(this.$config.bind){var t=this.$gantt.getDatastore(this.$config.bind);t._timelineCacheAttached&&(t.detachEvent(t._timelineCacheAttached),t._timelineCacheAttached=!1)}},refresh:function(){this._bindStore(),this.$config.bindLinks&&(this.$config.linkStore=this.$gantt.getDatastore(this.$config.bindLinks)),this._resetTopPositionHeight(),this._initStaticBackgroundRender(),this._render_tasks_scales()},destructor:function(){var t=this.$gantt;this._clearLayers(t),this._unbindStore(),this.$task=null,this.$task_scale=null,this.$task_data=null,this.$task_bg=null,this.$task_links=null,this.$task_bars=null,this.$gantt=null,this.$config.rowStore&&(this.$config.rowStore.detachEvent(this._staticBgHandler),this.$config.rowStore=null),this.$config.linkStore&&(this.$config.linkStore=null),this._timelineDragScroll&&(this._timelineDragScroll.destructor(),this._timelineDragScroll=null),this.callEvent("onDestroy",[]),this.detachAllEvents()}},t.exports=l},function(t,e){t.exports=function(t){return t.config.smart_rendering&&t._smart_render}},function(t,e){var i;i=function(){return this}();try{i=i||Function("return this")()||(0,eval)("this")}catch(t){"object"==typeof window&&(i=window)}t.exports=i},,function(t,e,i){},function(t,e,i){var n=i(0);t.exports=function t(e,i){e=e||n.event,i=i||n.eventRemove;var r=[],a={attach:function(t,i,n,a){r.push({element:t,event:i,callback:n,capture:a}),e(t,i,n,a)},detach:function(t,e,n,a){i(t,e,n,a);for(var o=0;o<r.length;o++){var s=r[o];s.element===t&&s.event===e&&s.callback===n&&s.capture===a&&(r.splice(o,1),o--)}},detachAll:function(){for(var t=r.slice(),e=0;e<t.length;e++){var i=t[e];a.detach(i.element,i.event,i.callback,i.capture),a.detach(i.element,i.event,i.callback,void 0),a.detach(i.element,i.event,i.callback,!1),a.detach(i.element,i.event,i.callback,!0)}r.splice(0,r.length)},extend:function(){return t(this.event,this.eventRemove)}};return window.scopes||(window.scopes=[]),window.scopes.push(r),a}},function(t,e,i){var n=i(2),r={getHtmlSelect:function(t,e,i){var r="",o=this;return t=t||[],n.forEach(t,function(t){var e=[{key:"value",value:t.key}];i==t.key&&(e[e.length]={key:"selected",value:"selected"}),t.attributes&&(e=e.concat(t.attributes)),r+=o.getHtmlOption({innerHTML:t.label},e)}),a("select",{innerHTML:r},e)},getHtmlOption:function(t,e){return a("option",t,e)},getHtmlButton:function(t,e){return a("button",t,e)},getHtmlDiv:function(t,e){return a("div",t,e)},getHtmlLabel:function(t,e){return a("label",t,e)},getHtmlInput:function(t){return"<input"+o(t||[])+">"}};function a(t,e,i){return e=e||[],"<"+t+o(i||[])+">"+(e.innerHTML||"")+"</"+t+">"}function o(t){var e="";return n.forEach(t,function(t){e+=" "+t.key+"='"+t.value+"'"}),e}t.exports=r},function(t,e,i){var n=i(0),r=i(2);function a(t,e,i,n,r){return this.date=t,this.unit=e,this.task=i,this.id=n,this.calendar=r,this}function o(t,e,i,n,r,a){return this.date=t,this.dir=e,this.unit=i,this.task=n,this.id=r,this.calendar=a,this}function s(t,e,i,n,r,a,o){return this.start_date=t,this.duration=e,this.unit=i,this.step=n,this.task=r,this.id=a,this.calendar=o,this}function l(t,e,i,n){return this.start_date=t,this.end_date=e,this.task=i,this.calendar=n,this.unit=null,this.step=null,this}t.exports=function(t){return{getWorkHoursArguments:function(){var e=arguments[0];if(e=r.isDate(e)?{date:e}:n.mixin({},e),!r.isValidDate(e.date))throw t.assert(!1,"Invalid date argument for getWorkHours method"),new Error("Invalid date argument for getWorkHours method");return e},setWorkTimeArguments:function(){return arguments[0]},unsetWorkTimeArguments:function(){return arguments[0]},isWorkTimeArguments:function(){var e,i=arguments[0];if(i instanceof a)return i;if((e=i.date?new a(i.date,i.unit,i.task,null,i.calendar):new a(arguments[0],arguments[1],arguments[2],null,arguments[3])).unit=e.unit||t.config.duration_unit,!r.isValidDate(e.date))throw t.assert(!1,"Invalid date argument for isWorkTime method"),new Error("Invalid date argument for isWorkTime method");return e},getClosestWorkTimeArguments:function(e){var i,n=arguments[0];if(n instanceof o)return n;if(i=r.isDate(n)?new o(n):new o(n.date,n.dir,n.unit,n.task,null,n.calendar),n.id&&(i.task=n),i.dir=n.dir||"any",i.unit=n.unit||t.config.duration_unit,!r.isValidDate(i.date))throw t.assert(!1,"Invalid date argument for getClosestWorkTime method"),new Error("Invalid date argument for getClosestWorkTime method");return i},_getStartEndConfig:function(e){var i,n=l;if(e instanceof n)return e;if(r.isDate(e)?i=new n(arguments[0],arguments[1],arguments[2],arguments[3]):(i=new n(e.start_date,e.end_date,e.task),e.id&&(i.task=e)),i.unit=i.unit||t.config.duration_unit,i.step=i.step||t.config.duration_step,i.start_date=i.start_date||i.start||i.date,!r.isValidDate(i.start_date))throw t.assert(!1,"Invalid start_date argument for getDuration method"),new Error("Invalid start_date argument for getDuration method");if(!r.isValidDate(i.end_date))throw t.assert(!1,"Invalid end_date argument for getDuration method"),new Error("Invalid end_date argument for getDuration method");return i},getDurationArguments:function(t,e,i,n){return this._getStartEndConfig.apply(this,arguments)},hasDurationArguments:function(t,e,i,n){return this._getStartEndConfig.apply(this,arguments)},calculateEndDateArguments:function(e,i,n,a){var o,l=arguments[0];if(l instanceof s)return l;if(o=r.isDate(l)?new s(arguments[0],arguments[1],arguments[2],void 0,arguments[3],void 0,arguments[4]):new s(l.start_date,l.duration,l.unit,l.step,l.task,null,l.calendar),l.id&&(o.task=l,o.unit=null,o.step=null),o.unit=o.unit||t.config.duration_unit,o.step=o.step||t.config.duration_step,!r.isValidDate(o.start_date))throw t.assert(!1,"Invalid start_date argument for calculateEndDate method"),new Error("Invalid start_date argument for calculateEndDate method");return o}}}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=function(){function t(){var t=this;this.canParse=function(e){return!isNaN(t.parse(e))},this.format=function(t){return String(t)},this.parse=function(t){return parseInt(t,10)}}return t.create=function(e){return void 0===e&&(e=null),new t},t}();e.default=n},function(t,e){function i(t,e,i){for(var n=0;n<e.length;n++)t.isLinkExists(e[n])&&(i[e[n]]=t.getLink(e[n]))}function n(t,e,n){i(t,e.$source,n),i(t,e.$target,n)}t.exports={getSubtreeLinks:function(t,e){var i={};return t.isTaskExists(e)&&n(t,t.getTask(e),i),t.eachTask(function(e){n(t,e,i)},e),i},getSubtreeTasks:function(t,e){var i={};return t.eachTask(function(t){i[t.id]=t},e),i}}},function(t,e,i){var n=i(13),r=i(13);function a(t){var e=function(t){var e=new r(t).primaryScale(),i=e.unit,a=e.step;if(t.config.scale_offset_minimal){var o=new n(t),s=[o.primaryScale()].concat(o.getSubScales());o.sortScales(s),i=s[s.length-1].unit,a=s[s.length-1].step||1}return{unit:i,step:a}}(t),i=e.unit,a=e.step,o=function(t,e){var i={start_date:null,end_date:null};if(e.config.start_date&&e.config.end_date){i.start_date=e.date[t+"_start"](new Date(e.config.start_date));var n=new Date(e.config.end_date),r=e.date[t+"_start"](new Date(n));n=+n!=+r?e.date.add(r,1,t):r,i.end_date=n}return i}(i,t);o.start_date&&o.end_date||((o=function(t){return t.getSubtaskDates()}(t)).start_date&&o.end_date||(o={start_date:new Date,end_date:new Date}),o.start_date=t.date[i+"_start"](o.start_date),o.start_date=t.calculateEndDate({start_date:t.date[i+"_start"](o.start_date),duration:-1,unit:i,step:a}),o.end_date=t.date[i+"_start"](o.end_date),o.end_date=t.calculateEndDate({start_date:o.end_date,duration:2,unit:i,step:a})),t._min_date=o.start_date,t._max_date=o.end_date}t.exports=function(t){a(t),function(t){if(t.config.fit_tasks){var e=+t._min_date,i=+t._max_date;if(+t._min_date!=e||+t._max_date!=i)return t.render(),t.callEvent("onScaleAdjusted",[]),!0}}(t)}},function(t,e,i){var n=i(0),r={$create:function(t){return n.mixin(t||[],this)},$removeAt:function(t,e){t>=0&&this.splice(t,e||1)},$remove:function(t){this.$removeAt(this.$find(t))},$insertAt:function(t,e){if(e||0===e){var i=this.splice(e,this.length-e);this[e]=t,this.push.apply(this,i)}else this.push(t)},$find:function(t){for(var e=0;e<this.length;e++)if(t==this[e])return e;return-1},$each:function(t,e){for(var i=0;i<this.length;i++)t.call(e||this,this[i])},$map:function(t,e){for(var i=0;i<this.length;i++)this[i]=t.call(e||this,this[i]);return this},$filter:function(t,e){for(var i=0;i<this.length;i++)t.call(e||this,this[i])||(this.splice(i,1),i--);return this}};t.exports=r},function(t,e,i){var n=i(25),r=i(0),a=i(4),o=function(t){return this.pull={},this.$initItem=t.initItem,this.visibleOrder=n.$create(),this.fullOrder=n.$create(),this._skip_refresh=!1,this._filterRule=null,this._searchVisibleOrder={},this.$config=t,a(this),this};o.prototype={_parseInner:function(t){for(var e=null,i=[],n=0,a=t.length;n<a;n++)e=t[n],this.$initItem&&(e=this.$initItem(r.copy(e))),this.callEvent("onItemLoading",[e])&&(this.pull.hasOwnProperty(e.id)||this.fullOrder.push(e.id),i.push(e),this.pull[e.id]=e);return i},parse:function(t){this.callEvent("onBeforeParse",[t]);var e=this._parseInner(t);this.refresh(),this.callEvent("onParse",[e])},getItem:function(t){return this.pull[t]},_updateOrder:function(t){t.call(this.visibleOrder),t.call(this.fullOrder)},updateItem:function(t,e){if(r.defined(e)||(e=this.getItem(t)),!this._skip_refresh&&!1===this.callEvent("onBeforeUpdate",[e.id,e]))return!1;this.pull[t]=e,this._skip_refresh||(this.callEvent("onAfterUpdate",[e.id,e]),this.callEvent("onStoreUpdated",[e.id,e,"update"]))},_removeItemInner:function(t){this._updateOrder(function(){this.$remove(t)}),delete this.pull[t]},removeItem:function(t){var e=this.getItem(t);if(!this._skip_refresh&&!1===this.callEvent("onBeforeDelete",[e.id,e]))return!1;this._removeItemInner(t),this._skip_refresh||(this.filter(),this.callEvent("onAfterDelete",[e.id,e]),this.callEvent("onStoreUpdated",[e.id,e,"delete"]))},_addItemInner:function(t,e){if(this.exists(t.id))this.silent(function(){this.updateItem(t.id,t)});else{var i=this.visibleOrder,n=i.length;(!r.defined(e)||e<0)&&(e=n),e>n&&(e=Math.min(i.length,e))}this.pull[t.id]=t,this._skip_refresh||this._updateOrder(function(){-1===this.$find(t.id)&&this.$insertAt(t.id,e)}),this.filter()},isVisible:function(t){return this.visibleOrder.$find(t)>-1},getVisibleItems:function(){return this.getIndexRange()},addItem:function(t,e){return r.defined(t.id)||(t.id=r.uid()),this.$initItem&&(t=this.$initItem(t)),!(!this._skip_refresh&&!1===this.callEvent("onBeforeAdd",[t.id,t]))&&(this._addItemInner(t,e),this._skip_refresh||(this.callEvent("onAfterAdd",[t.id,t]),this.callEvent("onStoreUpdated",[t.id,t,"add"])),t.id)},_changeIdInner:function(t,e){this.pull[t]&&(this.pull[e]=this.pull[t]);var i=this._searchVisibleOrder[t];this.pull[e].id=e,this._updateOrder(function(){this[this.$find(t)]=e}),this._searchVisibleOrder[e]=i,delete this._searchVisibleOrder[t],delete this.pull[t]},changeId:function(t,e){this._changeIdInner(t,e),this.callEvent("onIdChange",[t,e])},exists:function(t){return!!this.pull[t]},_moveInner:function(t,e){var i=this.getIdByIndex(t);this._updateOrder(function(){this.$removeAt(t),this.$insertAt(i,Math.min(this.length,e))})},move:function(t,e){var i=this.getIdByIndex(t),n=this.getItem(i);this._moveInner(t,e),this._skip_refresh||this.callEvent("onStoreUpdated",[n.id,n,"move"])},clearAll:function(){this.pull={},this.visibleOrder=n.$create(),this.fullOrder=n.$create(),this._skip_refresh||(this.callEvent("onClearAll",[]),this.refresh())},silent:function(t,e){this._skip_refresh=!0,t.call(e||this),this._skip_refresh=!1},arraysEqual:function(t,e){if(t.length!==e.length)return!1;for(var i=0;i<t.length;i++)if(t[i]!==e[i])return!1;return!0},refresh:function(t,e){var i;if(!this._skip_refresh&&(i=t?[t,this.pull[t],"paint"]:[null,null,null],!1!==this.callEvent("onBeforeStoreUpdate",i))){if(t){if(!e){var n=this.visibleOrder;this.filter(),this.arraysEqual(n,this.visibleOrder)||(t=void 0)}}else this.filter();i=t?[t,this.pull[t],"paint"]:[null,null,null],this.callEvent("onStoreUpdated",i)}},count:function(){return this.fullOrder.length},countVisible:function(){return this.visibleOrder.length},sort:function(t){},serialize:function(){},eachItem:function(t){for(var e=0;e<this.fullOrder.length;e++){var i=this.pull[this.fullOrder[e]];t.call(this,i)}},filter:function(t){this.callEvent("onBeforeFilter",[]);var e=n.$create();this.eachItem(function(t){this.callEvent("onFilterItem",[t.id,t])&&e.push(t.id)}),this.visibleOrder=e,this._searchVisibleOrder={};for(var i=0;i<this.visibleOrder.length;i++)this._searchVisibleOrder[this.visibleOrder[i]]=i;this.callEvent("onFilter",[])},getIndexRange:function(t,e){e=Math.min(e||1/0,this.countVisible()-1);for(var i=[],n=t||0;n<=e;n++)i.push(this.getItem(this.visibleOrder[n]));return i},getItems:function(){var t=[];for(var e in this.pull)t.push(this.pull[e]);return t},getIdByIndex:function(t){return this.visibleOrder[t]},getIndexById:function(t){var e=this._searchVisibleOrder[t];return void 0===e&&(e=-1),e},_getNullIfUndefined:function(t){return void 0===t?null:t},getFirst:function(){return this._getNullIfUndefined(this.visibleOrder[0])},getLast:function(){return this._getNullIfUndefined(this.visibleOrder[this.visibleOrder.length-1])},getNext:function(t){return this._getNullIfUndefined(this.visibleOrder[this.getIndexById(t)+1])},getPrev:function(t){return this._getNullIfUndefined(this.visibleOrder[this.getIndexById(t)-1])},destructor:function(){this.detachAllEvents(),this.pull=null,this.$initItem=null,this.visibleOrder=null,this.fullOrder=null,this._skip_refresh=null,this._filterRule=null,this._searchVisibleOrder=null}},t.exports=o},function(t,e){t.exports=function(t,e){var i=0,n=t.left.length-1;if(e)for(var r=0;r<t.left.length;r++){var a=t.left[r];if(a<e.x&&(i=r),a>e.x_end){n=r;break}}return{start:i,end:n}}},function(t,e){t.exports=function(t,e){var i=e.$getConfig();return{top:e.getItemTop(t.id),height:i.row_height,left:0,right:1/0}}},function(t,e){t.exports=function(t){function e(e,a){if(!t._isAllowedUnscheduledTask(e)&&t._isTaskInTimelineLimits(e)){var o=a.getItemPosition(e),s=a.$getConfig(),l=a.$getTemplates(),c=a.getItemHeight(),u=t.getTaskType(e.type),d=Math.floor((t.config.row_height-c)/2);u==s.types.milestone&&s.link_line_width>1&&(d+=1),u==s.types.milestone&&(o.left-=Math.round(c/2),o.width=c);var h=document.createElement("div"),f=Math.round(o.width);a.$config.item_attribute&&h.setAttribute(a.$config.item_attribute,e.id),s.show_progress&&u!=s.types.milestone&&function(e,i,n,r,a){var o=1*e.progress||0;n=Math.max(n-2,0);var s=document.createElement("div"),l=Math.round(n*o);l=Math.min(n,l),e.progressColor&&(s.style.backgroundColor=e.progressColor,s.style.opacity=1),s.style.width=l+"px",s.className="gantt_task_progress",s.innerHTML=a.progress_text(e.start_date,e.end_date,e),r.rtl&&(s.style.position="absolute",s.style.right="0px");var c=document.createElement("div");if(c.className="gantt_task_progress_wrapper",c.appendChild(s),i.appendChild(c),t.config.drag_progress&&!t.isReadonly(e)){var u=document.createElement("div"),d=l;r.rtl&&(d=n-l),u.style.left=d+"px",u.className="gantt_task_progress_drag",s.appendChild(u),i.appendChild(u)}}(e,h,f,s,l);var _=function(e,i,n){var r=document.createElement("div");return t.getTaskType(e.type)!=t.config.types.milestone&&(r.innerHTML=n.task_text(e.start_date,e.end_date,e)),r.className="gantt_task_content",r}(e,0,l);e.textColor&&(_.style.color=e.textColor),h.appendChild(_);var g=function(e,i,n,r){var a=r.$getConfig(),o=[e];i&&o.push(i);var s=t.getState(),l=t.getTask(n);if(t.getTaskType(l.type)==a.types.milestone?o.push("gantt_milestone"):t.getTaskType(l.type)==a.types.project&&o.push("gantt_project"),o.push("gantt_bar_"+t.getTaskType(l.type)),t.isSummaryTask(l)&&o.push("gantt_dependent_task"),t.isSplitTask(l)&&(a.open_split_tasks&&!l.$open||!a.open_split_tasks)&&o.push("gantt_split_parent"),a.select_task&&t.isSelectedTask(n)&&o.push("gantt_selected"),n==s.drag_id&&(o.push("gantt_drag_"+s.drag_mode),s.touch_drag&&o.push("gantt_touch_"+s.drag_mode)),s.link_source_id==n&&o.push("gantt_link_source"),s.link_target_id==n&&o.push("gantt_link_target"),a.highlight_critical_path&&t.isCriticalTask&&t.isCriticalTask(l)&&o.push("gantt_critical_task"),s.link_landing_area&&s.link_target_id&&s.link_source_id&&s.link_target_id!=s.link_source_id){var c=s.link_source_id,u=s.link_from_start,d=s.link_to_start,h=t.isLinkAllowed(c,n,u,d),f="";f=h?d?"link_start_allow":"link_finish_allow":d?"link_start_deny":"link_finish_deny",o.push(f)}return o.join(" ")}("gantt_task_line",l.task_class(e.start_date,e.end_date,e),e.id,a);(e.color||e.progressColor||e.textColor)&&(g+=" gantt_task_inline_color"),h.className=g;var p=["left:"+o.left+"px","top:"+(d+o.top)+"px","height:"+c+"px","line-height:"+Math.max(c<30?c-2:c,0)+"px","width:"+f+"px"];e.color&&p.push("background-color:"+e.color),e.textColor&&p.push("color:"+e.textColor),h.style.cssText=p.join(";");var v=function(t,e,r){var a="gantt_left "+n(!e.rtl,t);return i(t,r.leftside_text,a)}(e,s,l);v&&h.appendChild(v),(v=function(t,e,r){var a="gantt_right "+n(!!e.rtl,t);return i(t,r.rightside_text,a)}(e,s,l))&&h.appendChild(v),t._waiAria.setTaskBarAttr(e,h);var m=t.getState();return t.isReadonly(e)||(s.drag_resize&&!t.isSummaryTask(e)&&u!=s.types.milestone&&r(h,"gantt_task_drag",e,function(t){var e=document.createElement("div");return e.className=t,e},s),s.drag_links&&s.show_links&&r(h,"gantt_link_control",e,function(t){var e=document.createElement("div");e.className=t,e.style.cssText=["height:"+c+"px","line-height:"+c+"px"].join(";");var i=document.createElement("div");i.className="gantt_link_point";var n=!1;return m.link_source_id&&s.touch&&(n=!0),i.style.display=n?"block":"",e.appendChild(i),e},s)),h}}function i(t,e,i){if(!e)return null;var n=e(t.start_date,t.end_date,t);if(!n)return null;var r=document.createElement("div");return r.className="gantt_side_content "+i,r.innerHTML=n,r}function n(e,i){var n=function(e){return e?{$source:[t.config.links.start_to_start],$target:[t.config.links.start_to_start,t.config.links.finish_to_start]}:{$source:[t.config.links.finish_to_start,t.config.links.finish_to_finish],$target:[t.config.links.finish_to_finish]}}(e);for(var r in n)for(var a=i[r],o=0;o<a.length;o++)for(var s=t.getLink(a[o]),l=0;l<n[r].length;l++)if(s.type==n[r][l])return"gantt_link_crossing";return""}function r(e,i,n,r,a){var o,s=t.getState();+n.start_date>=+s.min_date&&((o=r([i,a.rtl?"task_right":"task_left","task_start_date"].join(" "))).setAttribute("data-bind-property","start_date"),e.appendChild(o)),+n.end_date<=+s.max_date&&((o=r([i,a.rtl?"task_left":"task_right","task_end_date"].join(" "))).setAttribute("data-bind-property","end_date"),e.appendChild(o))}return function(i,n){var r=n.$getConfig().type_renderers[t.getTaskType(i.type)],a=e;return r?r.call(t,i,function(e){return a.call(t,e,n)},n):a.call(t,i,n)}}},function(t,e){t.exports=function(t,e,i,n){if(!t.start_date||!t.end_date)return null;var r=i.$getConfig(),a=i.getItemTop(t.id),o=r.row_height;if(a>e.y_end||a+o<e.y)return!1;var s=i.posFromDate(t.start_date),l=i.posFromDate(t.end_date),c=Math.min(s,l)-200,u=Math.max(s,l)+200;return!(c>e.x_end||u<e.x)}},function(t,e,i){var n=i(1),r=i(0),a=i(4),o=i(132),s=i(32),l=function(t,e,i,n){this.$config=r.mixin({},e||{}),this.$gantt=n,this.$parent=t,a(this),this.$state={},r.mixin(this,s())};l.prototype={init:function(t){var e=this.$gantt,n=e._waiAria.gridAttrString(),r=e._waiAria.gridDataAttrString();t.innerHTML="<div class='gantt_grid' style='height:inherit;width:inherit;' "+n+"></div>",this.$grid=t.childNodes[0],this.$grid.innerHTML="<div class='gantt_grid_scale' "+e._waiAria.gridScaleRowAttrString()+"></div><div class='gantt_grid_data' "+r+"></div>",this.$grid_scale=this.$grid.childNodes[0],this.$grid_data=this.$grid.childNodes[1];var a=this.$getConfig()[this.$config.bind+"_attribute"];if(!a&&this.$config.bind&&(a=this.$config.bind+"_id"),this.$config.item_attribute=a||null,!this.$config.layers){var s=this._createLayerConfig();this.$config.layers=s}var l=o(e,this);l.init(),this._renderHeaderResizers=l.doOnRender,this._mouseDelegates=i(12)(e),this._addLayers(this.$gantt),this._initEvents(),this.callEvent("onReady",[])},_validateColumnWidth:function(t,e){var i=t[e];if(i&&"*"!=i){var n=this.$gantt,r=1*i;isNaN(r)?n.assert(!1,"Wrong "+e+" value of column "+t.name):t[e]=r}},setSize:function(t,e){this.$config.width=this.$state.width=t,this.$config.height=this.$state.height=e;for(var i,n=this.getGridColumns(),r=0,a=0,o=n.length;a<o;a++)this._validateColumnWidth(n[a],"min_width"),this._validateColumnWidth(n[a],"max_width"),this._validateColumnWidth(n[a],"width"),r+=1*n[a].width;!isNaN(r)&&this.$config.scrollable||(r=i=this._setColumnsWidth(t+1)),this.$config.scrollable?(this.$grid_scale.style.width=r+"px",this.$grid_data.style.width=r+"px"):(this.$grid_scale.style.width="inherit",this.$grid_data.style.width="inherit"),this.$config.width-=1;var s=this.$getConfig();i!==t&&(void 0!==i?(s.grid_width=i,this.$config.width=i-1):isNaN(r)||(this._setColumnsWidth(r),s.grid_width=r,this.$config.width=r-1));var l=Math.max(this.$state.height-s.scale_height,0);this.$grid_data.style.height=l+"px",this.refresh()},getSize:function(){var t=this.$getConfig(),e=this.$config.rowStore,i=e?t.row_height*e.countVisible():0,n=this._getGridWidth();return{x:this.$state.width,y:this.$state.height,contentX:this.isVisible()?n:0,contentY:this.isVisible()?t.scale_height+i:0,scrollHeight:this.isVisible()?i:0,scrollWidth:this.isVisible()?n:0}},_bindStore:function(){if(this.$config.bind){var t=this.$gantt.getDatastore(this.$config.bind);if(this.$config.rowStore=t,t&&!t._gridCacheAttached){var e=this;t._gridCacheAttached=t.attachEvent("onBeforeFilter",function(){e._resetTopPositionHeight()})}}},_unbindStore:function(){if(this.$config.bind){var t=this.$gantt.getDatastore(this.$config.bind);t._gridCacheAttached&&(t.detachEvent(t._gridCacheAttached),t._gridCacheAttached=!1)}},refresh:function(){this._bindStore(),this._resetTopPositionHeight(),this._initSmartRenderingPlaceholder(),this._calculateGridWidth(),this._renderGridHeader()},getViewPort:function(){var t=this.$config.scrollLeft||0,e=this.$config.scrollTop||0,i=this.$config.height||0,n=this.$config.width||0;return{y:e,y_end:e+i,x:t,x_end:t+n,height:i,width:n}},scrollTo:function(t,e){if(this.isVisible()){var i=!1;this.$config.scrollTop=this.$config.scrollTop||0,this.$config.scrollLeft=this.$config.scrollLeft||0,1*t==t&&(this.$config.scrollLeft=this.$state.scrollLeft=this.$grid.scrollLeft=t,i=!0),1*e==e&&(this.$config.scrollTop=this.$state.scrollTop=this.$grid_data.scrollTop=e,i=!0),i&&this.callEvent("onScroll",[this.$config.scrollLeft,this.$config.scrollTop])}},getColumnIndex:function(t){for(var e=this.$getConfig().columns,i=0;i<e.length;i++)if(e[i].name==t)return i;return null},getColumn:function(t){var e=this.getColumnIndex(t);return null===e?null:this.$getConfig().columns[e]},getGridColumns:function(){return this.$getConfig().columns.slice()},isVisible:function(){return this.$parent&&this.$parent.$config?!this.$parent.$config.hidden:this.$grid.offsetWidth},getItemHeight:function(){return this.$getConfig().row_height},_createLayerConfig:function(){var t=this;return[{renderer:this.$gantt.$ui.layers.gridLine(),container:this.$grid_data,filter:[function(){return t.isVisible()}]}]},_addLayers:function(t){if(this.$config.bind){this._taskLayers=[];var e=this,i=this.$gantt.$services.getService("layers"),n=i.getDataRender(this.$config.bind);n||(n=i.createDataRender({name:this.$config.bind,defaultContainer:function(){return e.$grid_data}}));for(var r=this.$config.layers,a=0;r&&a<r.length;a++){var o=r[a];o.view=this;var s=n.addLayer(o);this._taskLayers.push(s)}this._bindStore(),this._initSmartRenderingPlaceholder()}},_refreshPlaceholderOnStoreUpdate:function(t){var e=this.$getConfig(),i=this.$config.rowStore;if(i&&null===t&&this.isVisible()&&e.smart_rendering){var n;if(this.$config.scrollY){var r=this.$gantt.$ui.getView(this.$config.scrollY);r&&(n=r.getScrollState().scrollSize)}if(n||(n=i?e.row_height*i.countVisible():0),n){this.$rowsPlaceholder&&this.$rowsPlaceholder.parentNode&&this.$rowsPlaceholder.parentNode.removeChild(this.$rowsPlaceholder);var a=this.$rowsPlaceholder=document.createElement("div");a.style.visibility="hidden",a.style.height=n+"px",a.style.width="1px",this.$grid_data.appendChild(a)}}},_initSmartRenderingPlaceholder:function(){var t=this.$config.rowStore;t&&(this._initSmartRenderingPlaceholder=function(){},this._staticBgHandler=t.attachEvent("onStoreUpdated",r.bind(this._refreshPlaceholderOnStoreUpdate,this)))},_initEvents:function(){var t=this.$gantt;this._mouseDelegates.delegate("click","gantt_close",t.bind(function(t,e,i){var r=this.$config.rowStore;if(!r)return!0;var a=n.locateAttribute(t,this.$config.item_attribute);return a&&r.close(a.getAttribute(this.$config.item_attribute)),!1},this),this.$grid),this._mouseDelegates.delegate("click","gantt_open",t.bind(function(t,e,i){var r=this.$config.rowStore;if(!r)return!0;var a=n.locateAttribute(t,this.$config.item_attribute);return a&&r.open(a.getAttribute(this.$config.item_attribute)),!1},this),this.$grid)},_clearLayers:function(t){var e=this.$gantt.$services.getService("layers").getDataRender(this.$config.bind);if(this._taskLayers)for(var i=0;i<this._taskLayers.length;i++)e.removeLayer(this._taskLayers[i]);this._taskLayers=[]},_getColumnWidth:function(t,e,i){var n=t.min_width||e.min_grid_column_width,r=Math.max(i,n||10);return t.max_width&&(r=Math.min(r,t.max_width)),r},_getGridWidthLimits:function(){for(var t=this.$getConfig(),e=this.getGridColumns(),i=0,n=0,r=0;r<e.length;r++)i+=e[r].min_width?e[r].min_width:t.min_grid_column_width,void 0!==n&&(n=e[r].max_width?n+e[r].max_width:void 0);return[i,n]},_setColumnsWidth:function(t,e){var i=this.$getConfig(),n=this.getGridColumns(),r=0,a=t;e=window.isNaN(e)?-1:e;for(var o=0,s=n.length;o<s;o++)r+=1*n[o].width;if(window.isNaN(r)){this._calculateGridWidth(),r=0;for(o=0,s=n.length;o<s;o++)r+=1*n[o].width}var l=a-r,c=0;for(o=0;o<e+1;o++)c+=n[o].width;r-=c;for(o=e+1;o<n.length;o++){var u=n[o],d=Math.round(l*(u.width/r));l<0?u.min_width&&u.width+d<u.min_width?d=u.min_width-u.width:!u.min_width&&i.min_grid_column_width&&u.width+d<i.min_grid_column_width&&(d=i.min_grid_column_width-u.width):u.max_width&&u.width+d>u.max_width&&(d=u.max_width-u.width),r-=u.width,u.width+=d,l-=d}for(var h=l>0?1:-1;l>0&&1===h||l<0&&-1===h;){var f=l;for(o=e+1;o<n.length;o++){var _;if((_=n[o].width+h)==this._getColumnWidth(n[o],i,_)&&(l-=h,n[o].width=_),!l)break}if(f==l)break}l&&e>-1&&((_=n[e].width+l)==this._getColumnWidth(n[e],i,_)&&(n[e].width=_));return this._getColsTotalWidth()},_getColsTotalWidth:function(){for(var t=this.getGridColumns(),e=0,i=0;i<t.length;i++){var n=parseFloat(t[i].width);if(window.isNaN(n))return!1;e+=n}return e},_calculateGridWidth:function(){for(var t=this.$getConfig(),e=this.getGridColumns(),i=0,n=[],r=[],a=0;a<e.length;a++){var o=parseFloat(e[a].width);window.isNaN(o)&&(o=t.min_grid_column_width||10,n.push(a)),r[a]=o,i+=o}var s=this._getGridWidth()+1;if(t.autofit||n.length){var l=s-i;if(t.autofit)for(a=0;a<r.length;a++){var c=Math.round(l/(r.length-a));r[a]+=c,(u=this._getColumnWidth(e[a],t,r[a]))!=r[a]&&(c=u-r[a],r[a]=u),l-=c}else if(n.length)for(a=0;a<n.length;a++){c=Math.round(l/(n.length-a));var u,d=n[a];r[d]+=c,(u=this._getColumnWidth(e[d],t,r[d]))!=r[d]&&(c=u-r[d],r[d]=u),l-=c}for(a=0;a<r.length;a++)e[a].width=r[a]}else{var h=s!=i;this.$config.width=i-1,t.grid_width=i,h&&this.$parent._setContentSize(this.$config.width,null)}},_renderGridHeader:function(){var t=this.$gantt,e=this.$getConfig(),i=this.$gantt.locale,n=this.$gantt.templates,r=this.getGridColumns();e.rtl&&(r=r.reverse());for(var a=[],o=0,s=i.labels,l=e.scale_height-1,c=0;c<r.length;c++){var u=c==r.length-1,d=r[c];d.name||(d.name=t.uid()+"");var h=1*d.width,f=this._getGridWidth();u&&f>o+h&&(d.width=h=f-o),o+=h;var _=t._sort&&d.name==t._sort.name?"<div class='gantt_sort gantt_"+t._sort.direction+"'></div>":"",g=["gantt_grid_head_cell","gantt_grid_head_"+d.name,u?"gantt_last_cell":"",n.grid_header_class(d.name,d)].join(" "),p="width:"+(h-(u?1:0))+"px;",v=d.label||s["column_"+d.name]||s[d.name];v=v||"";var m="<div class='"+g+"' style='"+p+"' "+t._waiAria.gridScaleCellAttrString(d,v)+" data-column-id='"+d.name+"' column_id='"+d.name+"'>"+v+_+"</div>";a.push(m)}this.$grid_scale.style.height=e.scale_height+"px",this.$grid_scale.style.lineHeight=l+"px",this.$grid_scale.innerHTML=a.join(""),this._renderHeaderResizers&&this._renderHeaderResizers()},_getGridWidth:function(){return this.$config.width},destructor:function(){this._clearLayers(this.$gantt),this._mouseDelegates&&(this._mouseDelegates.destructor(),this._mouseDelegates=null),this._unbindStore(),this.$grid=null,this.$grid_scale=null,this.$grid_data=null,this.$gantt=null,this.$config.rowStore&&(this.$config.rowStore.detachEvent(this._staticBgHandler),this.$config.rowStore=null),this.callEvent("onDestroy",[]),this.detachAllEvents()}},t.exports=l},function(t,e){t.exports=function(){var t={};return{_resetTopPositionHeight:function(){t={}},getRowTop:function(t){return t*this.$getConfig().row_height},getItemTop:function(e){if(this.$config.rowStore){if(void 0!==t[e])return t[e];var i=this.$config.rowStore;if(!i)return 0;var n=i.getIndexById(e);if(-1===n&&i.getParent&&i.exists(e)){var r=i.getParent(e);if(i.exists(r)){var a=i.getItem(r);if(this.$gantt.isSplitTask(a))return this.getRowTop(i.getIndexById(a.id))}}return t[e]=this.getRowTop(n),t[e]}return 0}}}},function(t,e,i){var n=i(3),r=i(1),a=function(t){"use strict";function e(e,i,n){var r=t.apply(this,arguments)||this;return e&&(r.$root=!0),r._parseConfig(i),r.$name="layout",r}return n(e,t),e.prototype.destructor=function(){this.$container&&this.$view&&r.removeNode(this.$view);for(var e=0;e<this.$cells.length;e++){this.$cells[e].destructor()}this.$cells=[],t.prototype.destructor.call(this)},e.prototype._resizeScrollbars=function(t,e){var i,n=!1,r=[],a=[];function o(t){t.$parent.show(),n=!0,r.push(t)}function s(t){t.$parent.hide(),n=!0,a.push(t)}for(var l=0;l<e.length;l++)t[(i=e[l]).$config.scroll]?s(i):i.shouldHide()?s(i):i.shouldShow()?o(i):i.isVisible()?r.push(i):a.push(i);var c={};for(l=0;l<r.length;l++)r[l].$config.group&&(c[r[l].$config.group]=!0);for(l=0;l<a.length;l++)(i=a[l]).$config.group&&c[i.$config.group]&&o(i);return n},e.prototype._syncCellSizes=function(t,e){if(t){var i={};return this._eachChild(function(t){t.$config.group&&"scrollbar"!=t.$name&&"resizer"!=t.$name&&(i[t.$config.group]||(i[t.$config.group]=[]),i[t.$config.group].push(t))}),i[t]&&this._syncGroupSize(i[t],e),i[t]}},e.prototype._syncGroupSize=function(t,e){if(t.length)for(var i=t[0].$parent._xLayout?"width":"height",n=t[0].$parent.getNextSibling(t[0].$id)?1:-1,r=0;r<t.length;r++){var a=t[r].getSize(),o=n>0?t[r].$parent.getNextSibling(t[r].$id):t[r].$parent.getPrevSibling(t[r].$id);"resizer"==o.$name&&(o=n>0?o.$parent.getNextSibling(o.$id):o.$parent.getPrevSibling(o.$id));var s=o.getSize();if(o[i]){var l=a.gravity+s.gravity,c=a[i]+s[i],u=l/c;t[r].$config.gravity=u*e,o.$config[i]=c-e,o.$config.gravity=l-u*e}else t[r].$config[i]=e;var d=this.$gantt.$ui.getView("grid");d&&t[r].$content===d&&!d.$config.scrollable&&(this.$gantt.config.grid_width=e)}},e.prototype.resize=function(e){var i=!1;if(this.$root&&!this._resizeInProgress&&(this.callEvent("onBeforeResize",[]),i=!0,this._resizeInProgress=!0),t.prototype.resize.call(this,!0),t.prototype.resize.call(this,!1),i){var n=[];n=(n=(n=n.concat(this.getCellsByType("viewCell"))).concat(this.getCellsByType("viewLayout"))).concat(this.getCellsByType("hostCell"));for(var r=this.getCellsByType("scroller"),a=0;a<n.length;a++)n[a].$config.hidden||n[a].setContentSize();var o=this._getAutosizeMode(this.$config.autosize),s=this._resizeScrollbars(o,r);if(this.$config.autosize&&(this.autosize(this.$config.autosize),s=!0),s){this.resize();for(a=0;a<n.length;a++)n[a].$config.hidden||n[a].setContentSize()}this.callEvent("onResize",[])}i&&(this._resizeInProgress=!1)},e.prototype._eachChild=function(t,e){if(t(e=e||this),e.$cells)for(var i=0;i<e.$cells.length;i++)this._eachChild(t,e.$cells[i])},e.prototype.isChild=function(t){var e=!1;return this._eachChild(function(i){i!==t&&i.$content!==t||(e=!0)}),e},e.prototype.getCellsByType=function(t){var i=[];if(t===this.$name&&i.push(this),this.$content&&this.$content.$name==t&&i.push(this.$content),this.$cells)for(var n=0;n<this.$cells.length;n++){var r=e.prototype.getCellsByType.call(this.$cells[n],t);r.length&&i.push.apply(i,r)}return i},e.prototype.getNextSibling=function(t){var e=this.cellIndex(t);return e>=0&&this.$cells[e+1]?this.$cells[e+1]:null},e.prototype.getPrevSibling=function(t){var e=this.cellIndex(t);return e>=0&&this.$cells[e-1]?this.$cells[e-1]:null},e.prototype.cell=function(t){for(var e=0;e<this.$cells.length;e++){var i=this.$cells[e];if(i.$id===t)return i;var n=i.cell(t);if(n)return n}},e.prototype.cellIndex=function(t){for(var e=0;e<this.$cells.length;e++)if(this.$cells[e].$id===t)return e;return-1},e.prototype.moveView=function(t,e){if(this.$cells[e]!==t)return window.alert("Not implemented");e+=this.$config.header?1:0;var i=this.$view;e>=i.childNodes.length?i.appendChild(t.$view):i.insertBefore(t.$view,i.childNodes[e])},e.prototype._parseConfig=function(t){this.$cells=[],this._xLayout=!t.rows;for(var e=t.rows||t.cols||t.views,i=0;i<e.length;i++){var n=e[i];n.mode=this._xLayout?"x":"y";var r=this.$factory.initUI(n,this);r?(r.$parent=this,this.$cells.push(r)):(e.splice(i,1),i--)}},e.prototype.getCells=function(){return this.$cells},e.prototype.render=function(){var t=r.insertNode(this.$container,this.$toHTML());this.$fill(t,null),this.callEvent("onReady",[]),this.resize(),this.render=this.resize},e.prototype.$fill=function(t,e){this.$view=t,this.$parent=e;for(var i=r.getChildNodes(t,"gantt_layout_cell"),n=i.length-1;n>=0;n--){var a=this.$cells[n];a.$fill(i[n],this),a.$config.hidden&&a.$view.parentNode.removeChild(a.$view)}},e.prototype.$toHTML=function(){for(var e=this._xLayout?"x":"y",i=[],n=0;n<this.$cells.length;n++)i.push(this.$cells[n].$toHTML());return t.prototype.$toHTML.call(this,i.join(""),(this.$root?"gantt_layout_root ":"")+"gantt_layout gantt_layout_"+e)},e.prototype.getContentSize=function(t){for(var e,i,n,r=0,a=0,o=0;o<this.$cells.length;o++)(i=this.$cells[o]).$config.hidden||(e=i.getContentSize(t),"scrollbar"===i.$config.view&&t[i.$config.scroll]&&(e.height=0,e.width=0),i.$config.resizer&&(this._xLayout?e.height=0:e.width=0),n=i._getBorderSizes(),this._xLayout?(r+=e.width+n.horizontal,a=Math.max(a,e.height+n.vertical)):(r=Math.max(r,e.width+n.horizontal),a+=e.height+n.vertical));return r+=(n=this._getBorderSizes()).horizontal,a+=n.vertical,this.$root&&(r+=1,a+=1),{width:r,height:a}},e.prototype._cleanElSize=function(t){return 1*(t||"").toString().replace("px","")||0},e.prototype._getBoxStyles=function(t){var e=null,i=["width","height","paddingTop","paddingBottom","paddingLeft","paddingRight","borderLeftWidth","borderRightWidth","borderTopWidth","borderBottomWidth"],n={boxSizing:"border-box"==(e=window.getComputedStyle?window.getComputedStyle(t,null):{width:t.clientWidth,height:t.clientHeight}).boxSizing};e.MozBoxSizing&&(n.boxSizing="border-box"==e.MozBoxSizing);for(var r=0;r<i.length;r++)n[i[r]]=e[i[r]]?this._cleanElSize(e[i[r]]):0;var a={horPaddings:n.paddingLeft+n.paddingRight+n.borderLeftWidth+n.borderRightWidth,vertPaddings:n.paddingTop+n.paddingBottom+n.borderTopWidth+n.borderBottomWidth,borderBox:n.boxSizing,innerWidth:n.width,innerHeight:n.height,outerWidth:n.width,outerHeight:n.height};return a.borderBox?(a.innerWidth-=a.horPaddings,a.innerHeight-=a.vertPaddings):(a.outerWidth+=a.horPaddings,a.outerHeight+=a.vertPaddings),a},e.prototype._getAutosizeMode=function(t){var e={x:!1,y:!1};return"xy"===t?e.x=e.y=!0:"y"===t||!0===t?e.y=!0:"x"===t&&(e.x=!0),e},e.prototype.autosize=function(t){var e=this._getAutosizeMode(t),i=this._getBoxStyles(this.$container),n=this.getContentSize(t),r=this.$container;e.x&&(i.borderBox&&(n.width+=i.horPaddings),r.style.width=n.width+"px"),e.y&&(i.borderBox&&(n.height+=i.vertPaddings),r.style.height=n.height+"px")},e.prototype.getSize=function(){this._sizes=[];for(var e=0,i=0,n=1e5,r=0,a=1e5,o=0,s=0;s<this.$cells.length;s++){var l=this._sizes[s]=this.$cells[s].getSize();this.$cells[s].$config.hidden||(this._xLayout?(!l.width&&l.minWidth?e+=l.minWidth:e+=l.width,n+=l.maxWidth,i+=l.minWidth,r=Math.max(r,l.height),a=Math.min(a,l.maxHeight),o=Math.max(o,l.minHeight)):(!l.height&&l.minHeight?r+=l.minHeight:r+=l.height,a+=l.maxHeight,o+=l.minHeight,e=Math.max(e,l.width),n=Math.min(n,l.maxWidth),i=Math.max(i,l.minWidth)))}var c=t.prototype.getSize.call(this);return c.maxWidth>=1e5&&(c.maxWidth=n),c.maxHeight>=1e5&&(c.maxHeight=a),c.minWidth=c.minWidth!=c.minWidth?0:c.minWidth,c.minHeight=c.minHeight!=c.minHeight?0:c.minHeight,this._xLayout?(c.minWidth+=this.$config.margin*this.$cells.length||0,c.minWidth+=2*this.$config.padding||0,c.minHeight+=2*this.$config.padding||0):(c.minHeight+=this.$config.margin*this.$cells.length||0,c.minHeight+=2*this.$config.padding||0),c},e.prototype._calcFreeSpace=function(t,e,i){var n=i?e.minWidth:e.minHeight,r=e.maxWidth,a=t;return a?(a>r&&(a=r),a<n&&(a=n),this._free-=a):((a=Math.floor(this._free/this._gravity*e.gravity))>r&&(a=r,this._free-=a,this._gravity-=e.gravity),a<n&&(a=n,this._free-=a,this._gravity-=e.gravity)),a},e.prototype._calcSize=function(t,e,i){var n=t,r=i?e.minWidth:e.minHeight,a=i?e.maxWidth:e.maxHeight;return n||(n=Math.floor(this._free/this._gravity*e.gravity)),n>a&&(n=a),n<r&&(n=r),n},e.prototype._configureBorders=function(){this.$root&&this._setBorders([this._borders.left,this._borders.top,this._borders.right,this._borders.bottom],this);for(var t=this._xLayout?this._borders.right:this._borders.bottom,e=this.$cells,i=e.length-1,n=i;n>=0;n--)if(!e[n].$config.hidden){i=n;break}for(n=0;n<e.length;n++)if(!e[n].$config.hidden){var r=n>=i,a="";!r&&e[n+1]&&"scrollbar"==e[n+1].$config.view&&(this._xLayout?r=!0:a="gantt_layout_cell_border_transparent"),this._setBorders(r?[]:[t,a],e[n])}},e.prototype._updateCellVisibility=function(){for(var t,e=this._visibleCells||{},i=!this._visibleCells,n={},r=0;r<this._sizes.length;r++)t=this.$cells[r],!i&&t.$config.hidden&&e[t.$id]?t._hide(!0):t.$config.hidden||e[t.$id]||t._hide(!1),t.$config.hidden||(n[t.$id]=!0);this._visibleCells=n},e.prototype.setSize=function(e,i){this._configureBorders(),t.prototype.setSize.call(this,e,i),i=this.$lastSize.contentY,e=this.$lastSize.contentX;var n,r,a=this.$config.padding||0;this.$view.style.padding=a+"px",this._gravity=0,this._free=this._xLayout?e:i,this._free-=2*a,this._updateCellVisibility();for(var o=0;o<this._sizes.length;o++)if(!(n=this.$cells[o]).$config.hidden){var s=this.$config.margin||0;"resizer"!=n.$name||s||(s=-1);var l=n.$view,c=this._xLayout?"marginRight":"marginBottom";o!==this.$cells.length-1&&(l.style[c]=s+"px",this._free-=s),r=this._sizes[o],this._xLayout?r.width||(this._gravity+=r.gravity):r.height||(this._gravity+=r.gravity)}for(o=0;o<this._sizes.length;o++)if(!(n=this.$cells[o]).$config.hidden){var u=(r=this._sizes[o]).width,d=r.height;this._xLayout?this._calcFreeSpace(u,r,!0):this._calcFreeSpace(d,r,!1)}for(o=0;o<this.$cells.length;o++)if(!(n=this.$cells[o]).$config.hidden){r=this._sizes[o];var h=void 0,f=void 0;this._xLayout?(h=this._calcSize(r.width,r,!0),f=i-2*a):(h=e-2*a,f=this._calcSize(r.height,r,!1)),n.setSize(h,f)}},e}(i(8));t.exports=a},function(t,e){t.exports=function(t,e){return{top:e.getItemTop(t.id),height:e.getItemHeight(t.id),left:0,right:1/0}}},function(t,e){var i,n,r=t.exports={};function a(){throw new Error("setTimeout has not been defined")}function o(){throw new Error("clearTimeout has not been defined")}function s(t){if(i===setTimeout)return setTimeout(t,0);if((i===a||!i)&&setTimeout)return i=setTimeout,setTimeout(t,0);try{return i(t,0)}catch(e){try{return i.call(null,t,0)}catch(e){return i.call(this,t,0)}}}!function(){try{i="function"==typeof setTimeout?setTimeout:a}catch(t){i=a}try{n="function"==typeof clearTimeout?clearTimeout:o}catch(t){n=o}}();var l,c=[],u=!1,d=-1;function h(){u&&l&&(u=!1,l.length?c=l.concat(c):d=-1,c.length&&f())}function f(){if(!u){var t=s(h);u=!0;for(var e=c.length;e;){for(l=c,c=[];++d<e;)l&&l[d].run();d=-1,e=c.length}l=null,u=!1,function(t){if(n===clearTimeout)return clearTimeout(t);if((n===o||!n)&&clearTimeout)return n=clearTimeout,clearTimeout(t);try{n(t)}catch(e){try{return n.call(null,t)}catch(e){return n.call(this,t)}}}(t)}}function _(t,e){this.fun=t,this.array=e}function g(){}r.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var i=1;i<arguments.length;i++)e[i-1]=arguments[i];c.push(new _(t,e)),1!==c.length||u||s(f)},_.prototype.run=function(){this.fun.apply(null,this.array)},r.title="browser",r.browser=!0,r.env={},r.argv=[],r.version="",r.versions={},r.on=g,r.addListener=g,r.once=g,r.off=g,r.removeListener=g,r.removeAllListeners=g,r.emit=g,r.prependListener=g,r.prependOnceListener=g,r.listeners=function(t){return[]},r.binding=function(t){throw new Error("process.binding is not supported")},r.cwd=function(){return"/"},r.chdir=function(t){throw new Error("process.chdir is not supported")},r.umask=function(){return 0}},function(t,e){t.exports=function(t,e){if(!e)return!0;if(t._on_timeout)return!1;var i=Math.ceil(1e3/e);return i<2||(setTimeout(function(){delete t._on_timeout},i),t._on_timeout=!0,!0)}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=function(){}},function(t,e){t.exports=function(t){t.destructor=function(){for(var e in t.callEvent("onDestroy",[]),this.clearAll(),this.$root&&delete this.$root.gantt,this._eventRemoveAll(),this.$layout&&this.$layout.destructor(),this.resetLightbox(),this._dp&&this._dp.destructor&&this._dp.destructor(),this.$services.destructor(),this.detachAllEvents(),this)0===e.indexOf("$")&&delete this[e];t.$destroyed=!0}}},function(t,e){t.exports=function(t){return function(e,i){e||t.config.show_errors&&!1!==t.callEvent("onError",[i])&&t.message({type:"error",text:i,expire:-1})}}},function(t,e,i){var n=i(1),r=i(2);t.exports=function(t){var e=i(24);t.assert=i(39)(t),t.init=function(t,e,i){e&&i&&(this.config.start_date=this._min_date=new Date(e),this.config.end_date=this._max_date=new Date(i)),this.date.init(),this.config.scroll_size||(this.config.scroll_size=n.getScrollSize()||1),this.init=function(t){this.$container&&this.$container.parentNode&&(this.$container.parentNode.removeChild(this.$container),this.$container=null),this.$layout&&this.$layout.clear(),this._reinit(t)},this._reinit(t)};var a=function(){this._clearTaskLayers(),this._clearLinkLayers(),this.$layout&&(this.$layout.destructor(),this.$layout=null,this.$ui.reset())}.bind(t),o=function(){this.$root.innerHTML="",this.$root.gantt=this,e(this),this.config.layout.id="main",this.$layout=this.$ui.createView("layout",this.$root,this.config.layout),this.$layout.attachEvent("onBeforeResize",function(){for(var e=t.$services.getService("datastores"),i=0;i<e.length;i++)t.getDatastore(e[i]).filter()}),this.$layout.attachEvent("onResize",function(){t.refreshData()}),this.callEvent("onGanttLayoutReady",[]),this.$layout.render(),this.$container=this.$layout.$container.firstChild,function(t){"static"==window.getComputedStyle(t.$root).getPropertyValue("position")&&(t.$root.style.position="relative");var e=document.createElement("iframe");e.className="gantt_container_resize_watcher",e.tabIndex=-1,t.config.wai_aria_attributes&&(e.setAttribute("role","none"),e.setAttribute("aria-hidden",!0));t.$root.appendChild(e),e.contentWindow?s(t,e.contentWindow):(t.$root.removeChild(e),s(t,window))}(this)}.bind(t);function s(t,e){var i;t.event(e,"resize",function(){clearTimeout(i),i=setTimeout(function(){t.render()},300)})}t.resetLayout=function(){a(),o(),this.render()},t._reinit=function(t){this.callEvent("onBeforeGanttReady",[]),this._eventRemoveAll(),this.$mouseEvents.reset(),this.resetLightbox(),this._update_flags(),this.$services.getService("templateLoader").initTemplates(this),a(),this.$root=n.toNode(t),o(),this.callEvent("onTemplatesReady",[]),this.$mouseEvents.reset(this.$root),this.callEvent("onGanttReady",[]),this.render()},t.$click={buttons:{edit:function(e){t.isReadonly(t.getTask(e))||t.showLightbox(e)},delete:function(e){var i=t.getTask(e);if(!t.isReadonly(i)){var n=t.locale.labels.confirm_deleting,r=t.locale.labels.confirm_deleting_title;t._dhtmlx_confirm(n,r,function(){t.isTaskExists(e)?(i.$new?(t.silent(function(){t.deleteTask(e,!0)}),t.refreshData()):t.deleteTask(e),t.hideLightbox()):t.hideLightbox()})}}}},t.render=function(){this.callEvent("onBeforeGanttRender",[]),!this.config.sort&&this._sort&&(this._sort=void 0);var i=this.getScrollState(),n=i?i.x:0;this._getHorizontalScrollbar()&&(n=this._getHorizontalScrollbar().$config.codeScrollLeft||n||0);var r=null;if(n&&(r=t.dateFromPos(n+this.config.task_scroll_offset)),e(this),this.$layout.$config.autosize=this.config.autosize,this.$layout.resize(),this.config.preserve_scroll&&i&&n){var a=t.getScrollState();+r==+t.dateFromPos(a.x)&&a.y==i.y||(r&&this.showDate(r),i.y&&t.scrollTo(void 0,i.y))}this.callEvent("onGanttRender",[])},t.setSizes=t.render,t.locate=function(t){var e=n.getTargetNode(t);if((n.getClassName(e)||"").indexOf("gantt_task_cell")>=0)return null;var i=arguments[1]||this.config.task_attribute,r=n.locateAttribute(e,i);return r?r.getAttribute(i):null},t._locate_css=function(t,e,i){return n.locateClassName(t,e,i)},t._locateHTML=function(t,e){return n.locateAttribute(t,e||this.config.task_attribute)},t.getTaskRowNode=function(t){for(var e=this.$grid_data.childNodes,i=this.config.task_attribute,n=0;n<e.length;n++){if(e[n].getAttribute)if(e[n].getAttribute(i)==t)return e[n]}return null},t.changeLightboxType=function(e){if(this.getLightboxType()==e)return!0;t._silent_redraw_lightbox(e)},t._get_link_type=function(e,i){var n=null;return e&&i?n=t.config.links.start_to_start:!e&&i?n=t.config.links.finish_to_start:e||i?e&&!i&&(n=t.config.links.start_to_finish):n=t.config.links.finish_to_finish,n},t.isLinkAllowed=function(t,e,i,n){var r=null;if(!(r="object"==typeof t?t:{source:t,target:e,type:this._get_link_type(i,n)}))return!1;if(!(r.source&&r.target&&r.type))return!1;if(r.source==r.target)return!1;var a=!0;return this.checkEvent("onLinkValidation")&&(a=this.callEvent("onLinkValidation",[r])),a},t._correct_dst_change=function(e,i,n,a){var o=r.getSecondsInUnit(a)*n;if(o>3600&&o<86400){var s=e.getTimezoneOffset()-i;s&&(e=t.date.add(e,s,"minute"))}return e},t.isSplitTask=function(e){return t.assert(e&&e instanceof Object,"Invalid argument <b>task</b>="+e+" of gantt.isSplitTask. Task object was expected"),this.$data.tasksStore._isSplitItem(e)},t._is_icon_open_click=function(t){if(!t)return!1;var e=t.target||t.srcElement;if(!e||!e.className)return!1;var i=n.getClassName(e);return-1!==i.indexOf("gantt_tree_icon")&&(-1!==i.indexOf("gantt_close")||-1!==i.indexOf("gantt_open"))}}},function(t,e){t.exports=function(t){t.locale={date:{month_full:["January","February","March","April","May","June","July","August","September","October","November","December"],month_short:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],day_full:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],day_short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"]},labels:{new_task:"New task",icon_save:"Save",icon_cancel:"Cancel",icon_details:"Details",icon_edit:"Edit",icon_delete:"Delete",confirm_closing:"",confirm_deleting:"Task will be deleted permanently, are you sure?",section_description:"Description",section_time:"Time period",section_type:"Type",column_wbs:"WBS",column_text:"Task name",column_start_date:"Start time",column_duration:"Duration",column_add:"",link:"Link",confirm_link_deleting:"will be deleted",link_start:" (start)",link_end:" (end)",type_task:"Task",type_project:"Project",type_milestone:"Milestone",minutes:"Minutes",hours:"Hours",days:"Days",weeks:"Week",months:"Months",years:"Years",message_ok:"OK",message_cancel:"Cancel",section_constraint:"Constraint",constraint_type:"Constraint type",constraint_date:"Constraint date",asap:"As Soon As Possible",alap:"As Late As Possible",snet:"Start No Earlier Than",snlt:"Start No Later Than",fnet:"Finish No Earlier Than",fnlt:"Finish No Later Than",mso:"Must Start On",mfo:"Must Finish On",resources_filter_placeholder:"type to filter",resources_filter_label:"hide empty"}}}},function(t,e){t.exports=function(t){function e(){var e;return t.$ui.getView("timeline")&&(e=t.$ui.getView("timeline")._tasks_dnd),e}t.config.touch_drag=500,t.config.touch=!0,t.config.touch_feedback=!0,t.config.touch_feedback_duration=1,t._prevent_touch_scroll=!1,t._touch_feedback=function(){t.config.touch_feedback&&navigator.vibrate&&navigator.vibrate(t.config.touch_feedback_duration)},t.attachEvent("onGanttReady",t.bind(function(){if("force"!=this.config.touch&&(this.config.touch=this.config.touch&&(-1!=navigator.userAgent.indexOf("Mobile")||-1!=navigator.userAgent.indexOf("iPad")||-1!=navigator.userAgent.indexOf("Android")||-1!=navigator.userAgent.indexOf("Touch"))),this.config.touch){var t=!0;try{document.createEvent("TouchEvent")}catch(e){t=!1}t?this._touch_events(["touchmove","touchstart","touchend"],function(t){return t.touches&&t.touches.length>1?null:t.touches[0]?{target:t.target,pageX:t.touches[0].pageX,pageY:t.touches[0].pageY,clientX:t.touches[0].clientX,clientY:t.touches[0].clientY}:t},function(){return!1}):window.navigator.pointerEnabled?this._touch_events(["pointermove","pointerdown","pointerup"],function(t){return"mouse"==t.pointerType?null:t},function(t){return!t||"mouse"==t.pointerType}):window.navigator.msPointerEnabled&&this._touch_events(["MSPointerMove","MSPointerDown","MSPointerUp"],function(t){return t.pointerType==t.MSPOINTER_TYPE_MOUSE?null:t},function(t){return!t||t.pointerType==t.MSPOINTER_TYPE_MOUSE})}},t));var i=[];t._touch_events=function(n,r,a){for(var o,s=0,l=!1,c=!1,u=null,d=null,h=null,f=0;f<i.length;f++)t.eventRemove(i[f][0],i[f][1],i[f][2]);(i=[]).push([t.$container,n[0],function(i){var n=e();if(!a(i)&&l){d&&clearTimeout(d);var h=r(i);if(n&&(n.drag.id||n.drag.start_drag))return n.on_mouse_move(h),i.preventDefault&&i.preventDefault(),i.cancelBubble=!0,!1;if(!t._prevent_touch_scroll){if(h&&u){var f=u.pageX-h.pageX,g=u.pageY-h.pageY;if(!c&&(Math.abs(f)>5||Math.abs(g)>5)&&(t._touch_scroll_active=c=!0,s=0,o=t.getScrollState()),c){t.scrollTo(o.x+f,o.y+g);var p=t.getScrollState();if(o.x!=p.x&&g>2*f||o.y!=p.y&&f>2*g)return _(i)}}return _(i)}return!0}}]),i.push([this.$container,"contextmenu",function(t){if(l)return _(t)}]),i.push([this.$container,n[1],function(i){if(!a(i))if(i.touches&&i.touches.length>1)l=!1;else{u=r(i),t._locate_css(u,"gantt_hor_scroll")||t._locate_css(u,"gantt_ver_scroll")||(l=!0);var n=e();d=setTimeout(function(){var e=t.locate(u);n&&e&&!t._locate_css(u,"gantt_link_control")&&!t._locate_css(u,"gantt_grid_data")&&(n.on_mouse_down(u),n.drag&&n.drag.start_drag&&(!function(e){var i=t._getTaskLayers(),n=t.getTask(e);if(n&&t.isTaskVisible(e))for(var r=0;r<i.length;r++)if((n=i[r].rendered[e])&&n.getAttribute(t.config.task_attribute)&&n.getAttribute(t.config.task_attribute)==e){var a=n.cloneNode(!0);h=n,i[r].rendered[e]=a,n.style.display="none",a.className+=" gantt_drag_move ",n.parentNode.appendChild(a)}}(e),n._start_dnd(u),t._touch_drag=!0,t.refreshTask(e),t._touch_feedback())),d=null},t.config.touch_drag)}}]),i.push([this.$container,n[2],function(i){if(!a(i)){d&&clearTimeout(d),t._touch_drag=!1,l=!1;var n=r(i),o=e();if(o&&o.on_mouse_up(n),h&&(t.refreshTask(t.locate(h)),h.parentNode&&(h.parentNode.removeChild(h),t._touch_feedback())),t._touch_scroll_active=l=c=!1,h=null,u&&s){var f=new Date;if(f-s<500)t.$services.getService("mouseEvents").onDoubleClick(u),_(i);else s=f}else s=new Date}}]);for(f=0;f<i.length;f++)t.event(i[f][0],i[f][1],i[f][2]);function _(t){return t&&t.preventDefault&&t.preventDefault(),(t||event).cancelBubble=!0,!1}}}},function(t,e){t.exports=function(t){t.skins.contrast_white={config:{grid_width:360,row_height:35,scale_height:35,link_line_width:2,link_arrow_size:6,lightbox_additional_height:75},_second_column_width:100,_third_column_width:80}}},function(t,e){t.exports=function(t){t.skins.contrast_black={config:{grid_width:360,row_height:35,scale_height:35,link_line_width:2,link_arrow_size:6,lightbox_additional_height:75},_second_column_width:100,_third_column_width:80}}},function(t,e){t.exports=function(t){t.skins.material={config:{grid_width:411,row_height:34,task_height_offset:6,scale_height:36,link_line_width:2,link_arrow_size:6,lightbox_additional_height:80},_second_column_width:110,_third_column_width:75,_redefine_lightbox_buttons:{buttons_left:["dhx_delete_btn"],buttons_right:["dhx_save_btn","dhx_cancel_btn"]}},t.attachEvent("onAfterTaskDrag",function(e){var i=t.getTaskNode(e);i&&(i.className+=" gantt_drag_animation",setTimeout(function(){var t=i.className.indexOf(" gantt_drag_animation");t>-1&&(i.className=i.className.slice(0,t))},200))})}},function(t,e){t.exports=function(t){t.skins.broadway={config:{grid_width:360,row_height:35,scale_height:35,link_line_width:1,link_arrow_size:7,lightbox_additional_height:86},_second_column_width:90,_third_column_width:80,_lightbox_template:"<div class='gantt_cal_ltitle'><span class='gantt_mark'>&nbsp;</span><span class='gantt_time'></span><span class='gantt_title'></span><div class='gantt_cancel_btn'></div></div><div class='gantt_cal_larea'></div>",_config_buttons_left:{},_config_buttons_right:{gantt_delete_btn:"icon_delete",gantt_save_btn:"icon_save"}}}},function(t,e){t.exports=function(t){t.skins.terrace={config:{grid_width:360,row_height:35,scale_height:35,link_line_width:2,link_arrow_size:6,lightbox_additional_height:75},_second_column_width:90,_third_column_width:70}}},function(t,e){t.exports=function(t){t.skins.meadow={config:{grid_width:350,row_height:27,scale_height:30,link_line_width:2,link_arrow_size:6,lightbox_additional_height:72},_second_column_width:95,_third_column_width:80}}},function(t,e){t.exports=function(t){t.skins.skyblue={config:{grid_width:350,row_height:27,scale_height:27,link_line_width:1,link_arrow_size:8,lightbox_additional_height:75},_second_column_width:95,_third_column_width:80}}},function(t,e){function i(t,e){var i=e.skin;if(!i||t)for(var n=document.getElementsByTagName("link"),r=0;r<n.length;r++){var a=n[r].href.match("dhtmlxgantt_([a-z_]+).css");if(a&&(e.skins[a[1]]||!i)){i=a[1];break}}e.skin=i||"terrace";var o=e.skins[e.skin]||e.skins.terrace;!function(t,e,i){for(var n in e)(void 0===t[n]||i)&&(t[n]=e[n])}(e.config,o.config,t);var s=e.getGridColumns();s[1]&&!e.defined(s[1].width)&&(s[1].width=o._second_column_width),s[2]&&!e.defined(s[2].width)&&(s[2].width=o._third_column_width);for(r=0;r<s.length;r++){var l=s[r];"add"==l.name&&(l.width||(l.width=44),e.defined(l.min_width)&&e.defined(l.max_width)||(l.min_width=l.min_width||l.width,l.max_width=l.max_width||l.width),l.min_width&&(l.min_width=+l.min_width),l.max_width&&(l.max_width=+l.max_width),l.width&&(l.width=+l.width,l.width=l.min_width&&l.min_width>l.width?l.min_width:l.width,l.width=l.max_width&&l.max_width<l.width?l.max_width:l.width))}o.config.task_height&&(e.config.task_height=o.config.task_height||"full"),o._lightbox_template&&(e._lightbox_template=o._lightbox_template),o._redefine_lightbox_buttons&&(e.config.buttons_right=o._redefine_lightbox_buttons.buttons_right,e.config.buttons_left=o._redefine_lightbox_buttons.buttons_left),e.resetLightbox()}t.exports=function(t){t.resetSkin||(t.resetSkin=function(){this.skin="",i(!0,this)},t.skins={},t.attachEvent("onGanttLayoutReady",function(){i(!1,this)}))}},function(t,e){t.exports=function(t){function e(){return t._cached_functions.update_if_changed(t),t._cached_functions.active||t._cached_functions.activate(),!0}t._cached_functions={cache:{},mode:!1,critical_path_mode:!1,wrap_methods:function(t,e){if(e._prefetch_originals)for(var i in e._prefetch_originals)e[i]=e._prefetch_originals[i];e._prefetch_originals={};for(i=0;i<t.length;i++)this.prefetch(t[i],e)},prefetch:function(t,e){var i=e[t];if(i){var n=this;e._prefetch_originals[t]=i,e[t]=function(){for(var e=new Array(arguments.length),r=0,a=arguments.length;r<a;r++)e[r]=arguments[r];if(n.active){var o=n.get_arguments_hash(Array.prototype.slice.call(e));n.cache[t]||(n.cache[t]={});var s=n.cache[t];if(n.has_cached_value(s,o))return n.get_cached_value(s,o);var l=i.apply(this,e);return n.cache_value(s,o,l),l}return i.apply(this,e)}}return i},cache_value:function(t,e,i){this.is_date(i)&&(i=new Date(i)),t[e]=i},has_cached_value:function(t,e){return t.hasOwnProperty(e)},get_cached_value:function(t,e){var i=t[e];return this.is_date(i)&&(i=new Date(i)),i},is_date:function(t){return t&&t.getUTCDate},get_arguments_hash:function(t){for(var e=[],i=0;i<t.length;i++)e.push(this.stringify_argument(t[i]));return"("+e.join(";")+")"},stringify_argument:function(t){return(t.id?t.id:this.is_date(t)?t.valueOf():t)+""},activate:function(){this.clear(),this.active=!0},deactivate:function(){this.clear(),this.active=!1},clear:function(){this.cache={}},setup:function(t){var e=[],i=["_isProjectEnd","_getProjectEnd","_getSlack"];"auto"==this.mode?t.config.highlight_critical_path&&(e=i):!0===this.mode&&(e=i),this.wrap_methods(e,t)},update_if_changed:function(t){(this.critical_path_mode!=t.config.highlight_critical_path||this.mode!==t.config.optimize_render)&&(this.critical_path_mode=t.config.highlight_critical_path,this.mode=t.config.optimize_render,this.setup(t))}},t.attachEvent("onBeforeGanttRender",e),t.attachEvent("onBeforeDataRender",e),t.attachEvent("onBeforeSmartRender",function(){e()}),t.attachEvent("onBeforeParse",e),t.attachEvent("onDataRender",function(){t._cached_functions.deactivate()});var i=null;t.attachEvent("onSmartRender",function(){i&&clearTimeout(i),i=setTimeout(function(){t._cached_functions.deactivate()},1e3)}),t.attachEvent("onBeforeGanttReady",function(){return t._cached_functions.update_if_changed(t),!0})}},function(t,e){t.exports=function(t){t.getTaskType=function(t){return"task"}}},function(t,e){t.exports=function(t){t._extend_to_optional=function(e){var i=e,n={render:i.render,focus:i.focus,set_value:function(e,r,a,o){var s=t._resolve_default_mapping(o);if(!a[s.start_date]||"start_date"==s.start_date&&this._isAllowedUnscheduledTask(a)){n.disable(e,o);var l={};for(var c in s)l[s[c]]=a[c];return i.set_value.call(t,e,r,l,o)}return n.enable(e,o),i.set_value.call(t,e,r,a,o)},get_value:function(e,n,r){return r.disabled?{start_date:null}:i.get_value.call(t,e,n,r)},update_block:function(e,i){if(t.callEvent("onSectionToggle",[t._lightbox_id,i]),e.style.display=i.disabled?"none":"block",i.button){var n=e.previousSibling.querySelector(".gantt_custom_button_label"),r=t.locale.labels,a=i.disabled?r[i.name+"_enable_button"]:r[i.name+"_disable_button"];n.innerHTML=a}t.resizeLightbox()},disable:function(t,e){e.disabled=!0,n.update_block(t,e)},enable:function(t,e){e.disabled=!1,n.update_block(t,e)},button_click:function(e,i,r,a){if(!1!==t.callEvent("onSectionButton",[t._lightbox_id,r])){var o=t._get_typed_lightbox_config()[e];o.disabled?n.enable(a,o):n.disable(a,o)}}};return n},t.form_blocks.duration_optional=t._extend_to_optional(t.form_blocks.duration),t.form_blocks.time_optional=t._extend_to_optional(t.form_blocks.time)}},function(t,e,i){var n=i(3),r=i(20);t.exports=function(t){var e=i(5)(t);function a(){return e.apply(this,arguments)||this}function o(e){return!e||e===t.config.constraint_types.ASAP||e===t.config.constraint_types.ALAP}function s(t,e){for(var i=o(e),n=0;n<t.length;n++)t[n].disabled=i}return n(a,e),a.prototype.render=function(e){var i=(e.height||30)+"px",n="<div class='gantt_cal_ltext gantt_section_"+e.name+"' style='height:"+i+";'>",a=[];for(var o in t.config.constraint_types)a.push({key:t.config.constraint_types[o],label:t.locale.labels[t.config.constraint_types[o]]});return e.options=e.options||a,n+="<span data-constraint-type-select>"+r.getHtmlSelect(e.options,[{key:"data-type",value:"constraint-type"}])+"</span>",n+="<label data-constraint-time-select>"+(t.locale.labels.constraint_date||"Constraint date")+": "+t.form_blocks.getTimePicker.call(this,e)+"</label>",n+="</div>"},a.prototype.set_value=function(e,i,n,r){var a=e.querySelector("[data-constraint-type-select] select"),o=e.querySelectorAll("[data-constraint-time-select] select"),l=r._time_format_order,c=t._resolve_default_mapping(r);a._eventsInitialized||(a.addEventListener("change",function(t){s(o,t.target.value)}),a._eventsInitialized=!0);var u=n[c.constraint_date]||new Date;t.form_blocks._fill_lightbox_select(o,0,u,l,r);var d=n[c.constraint_type]||t.getConstraintType(n);a.value=d,s(o,d)},a.prototype.get_value=function(e,i,n){var r=e.querySelector("[data-constraint-type-select] select"),a=e.querySelectorAll("[data-constraint-time-select] select"),s=r.value,l=null;return o(s)||(l=t.form_blocks.getTimePickerValue(a,n)),{constraint_type:s,constraint_date:l}},a.prototype.focus=function(e){t._focus(e.querySelector("select"))},a}},function(t,e,i){var n=i(3);t.exports=function(t){var e=i(10)(t);function r(){return e.apply(this,arguments)||this}function a(e,i){var n=[],r=[];i&&(n=t.getTaskByTime(),e.allow_root&&n.unshift({id:t.config.root_id,text:e.root_label||""}),n=function(e,i,n){var r=i.filter||function(){return!0};e=e.slice(0);for(var a=0;a<e.length;a++){var o=e[a];(o.id==n||t.isChildOf(o.id,n)||!1===r(o.id,o))&&(e.splice(a,1),a--)}return e}(n,e,i),e.sort&&n.sort(e.sort));for(var a=e.template||t.templates.task_text,o=0;o<n.length;o++){var s=a.apply(t,[n[o].start_date,n[o].end_date,n[o]]);void 0===s&&(s=""),r.push({key:n[o].id,label:s})}return e.options=r,e.map_to=e.map_to||"parent",t.form_blocks.select.render.apply(this,arguments)}return n(r,e),r.prototype.render=function(t){return a(t,!1)},r.prototype.set_value=function(e,i,n,r){var o=document.createElement("div");o.innerHTML=a(r,n.id);var s=o.removeChild(o.firstChild);return e.onselect=null,e.parentNode.replaceChild(s,e),t.form_blocks.select.set_value.apply(t,[s,i,n,r])},r}},function(t,e,i){var n=i(3),r=i(22).default;t.exports=function(t){var e=i(5)(t);function a(){return e.apply(this,arguments)||this}function o(t){return t.formatter||new r}function s(e,i){var n=e.getElementsByTagName("select"),r=i._time_format_order,a=0,o=0;if(t.defined(r[3])){var s=n[r[3]],l=parseInt(s.value,10);isNaN(l)&&s.hasAttribute("data-value")&&(l=parseInt(s.getAttribute("data-value"),10)),a=Math.floor(l/60),o=l%60}return new Date(n[r[2]].value,n[r[1]].value,n[r[0]].value,a,o)}function l(t,e){var i=t.getElementsByTagName("input")[1];return(i=o(e).parse(i.value))&&!window.isNaN(i)||(i=1),i<0&&(i*=-1),i}return n(a,e),a.prototype.render=function(e){var i="<div class='gantt_time_selects'>"+t.form_blocks.getTimePicker.call(this,e)+"</div>",n=" "+t.locale.labels[t.config.duration_unit+"s"]+" ",r=e.single_date?" style='display:none'":"",a=e.readonly?" disabled='disabled'":"",o=t._waiAria.lightboxDurationInputAttrString(e),s="gantt_duration_value";e.formatter&&(n="",s+=" gantt_duration_value_formatted");var l="<div class='gantt_duration' "+r+"><input type='button' class='gantt_duration_dec' value='−'"+a+"><input type='text' value='5days' class='"+s+"'"+a+" "+o+"><input type='button' class='gantt_duration_inc' value='+'"+a+">"+n+"<span></span></div>";return"<div style='height:"+(e.height||30)+"px;padding-top:0px;font-size:inherit;' class='gantt_section_time'>"+i+" "+l+"</div>"},a.prototype.set_value=function(e,i,n,r){var a,c,u,d,h=e.getElementsByTagName("select"),f=e.getElementsByTagName("input"),_=f[1],g=[f[0],f[2]],p=e.getElementsByTagName("span")[0],v=r._time_format_order;function m(){var i=s.call(t,e,r),a=l.call(t,e,r),o=t.calculateEndDate({start_date:i,duration:a,task:n}),c=t.templates.task_end_date||t.templates.task_date;p.innerHTML=c(o)}function y(t){var e=_.value;e=o(r).parse(e),window.isNaN(e)&&(e=0),(e+=t)<1&&(e=1),_.value=o(r).format(e),m()}g[0].onclick=t.bind(function(){y(-1*t.config.duration_step)},this),g[1].onclick=t.bind(function(){y(1*t.config.duration_step)},this),h[0].onchange=m,h[1].onchange=m,h[2].onchange=m,h[3]&&(h[3].onchange=m),_.onkeydown=t.bind(function(e){var i;return(i=(e=e||window.event).charCode||e.keyCode||e.which)==t.constants.KEY_CODES.DOWN?(y(-1*t.config.duration_step),!1):i==t.constants.KEY_CODES.UP?(y(1*t.config.duration_step),!1):void window.setTimeout(m,1)},this),_.onchange=t.bind(m,this),"string"==typeof(a=t._resolve_default_mapping(r))&&(a={start_date:a}),c=n[a.start_date]||new Date,u=n[a.end_date]||t.calculateEndDate({start_date:c,duration:1,task:n}),d=Math.round(n[a.duration])||t.calculateDuration({start_date:c,end_date:u,task:n}),d=o(r).format(d),t.form_blocks._fill_lightbox_select(h,0,c,v,r),_.value=d,m()},a.prototype.get_value=function(e,i,n){var r=s(e,n),a=l(e,n),o=t.calculateEndDate({start_date:r,duration:a,task:i});return"string"==typeof t._resolve_default_mapping(n)?r:{start_date:r,end_date:o,duration:a}},a.prototype.focus=function(e){t._focus(e.getElementsByTagName("select")[0])},a}},function(t,e,i){var n=i(3);t.exports=function(t){var e=i(5)(t);function r(){return e.apply(this,arguments)||this}return n(r,e),r.prototype.render=function(t){var e="<div class='gantt_cal_ltext' style='height:"+((t.height||"23")+"px")+";'>";if(t.options&&t.options.length)for(var i=0;i<t.options.length;i++)e+="<label><input type='radio' value='"+t.options[i].key+"' name='"+t.name+"'>"+t.options[i].label+"</label>";return e+="</div>"},r.prototype.set_value=function(t,e,i,n){var r;n.options&&n.options.length&&(r=t.querySelector("input[type=radio][value='"+e+"']")||t.querySelector("input[type=radio][value='"+n.default_value+"']"))&&(!t._dhx_onchange&&n.onchange&&(t.onchange=n.onchange,t._dhx_onchange=!0),r.checked=!0)},r.prototype.get_value=function(t,e){var i=t.querySelector("input[type=radio]:checked");return i?i.value:""},r.prototype.focus=function(e){t._focus(e.querySelector("input[type=radio]"))},r}},function(t,e,i){var n=i(2),r=i(3);t.exports=function(t){var e=i(5)(t);function a(){return e.apply(this,arguments)||this}return r(a,e),a.prototype.render=function(t){var e="<div class='gantt_cal_ltext' style='height:"+((t.height||"23")+"px")+";'>";if(t.options&&t.options.length)for(var i=0;i<t.options.length;i++)e+="<label><input type='checkbox' value='"+t.options[i].key+"' name='"+t.name+"'>"+t.options[i].label+"</label>";return e+="</div>"},a.prototype.set_value=function(t,e,i,r){var a=Array.prototype.slice.call(t.querySelectorAll("input[type=checkbox]"));!t._dhx_onchange&&r.onchange&&(t.onchange=r.onchange,t._dhx_onchange=!0),n.forEach(a,function(t){t.checked=!!e&&e.indexOf(t.value)>=0})},a.prototype.get_value=function(t){return n.arrayMap(Array.prototype.slice.call(t.querySelectorAll("input[type=checkbox]:checked")),function(t){return t.value})},a.prototype.focus=function(e){t._focus(e.querySelector("input[type=checkbox]"))},a}},function(t,e,i){var n=i(3);t.exports=function(t){var e=i(5)(t);function r(){return e.apply(this,arguments)||this}return n(r,e),r.prototype.render=function(e){var i=t.form_blocks.getTimePicker.call(this,e),n="<div style='height:"+(e.height||30)+"px;padding-top:0px;font-size:inherit;text-align:center;' class='gantt_section_time'>";return n+=i,e.single_date?(i=t.form_blocks.getTimePicker.call(this,e,!0),n+="<span></span>"):n+="<span style='font-weight:normal; font-size:10pt;'> &nbsp;&ndash;&nbsp; </span>",n+=i,n+="</div>"},r.prototype.set_value=function(e,i,n,r){var a=r,o=e.getElementsByTagName("select"),s=r._time_format_order;if(a.auto_end_date)for(var l=function(){d=new Date(o[s[2]].value,o[s[1]].value,o[s[0]].value,0,0),h=t.calculateEndDate({start_date:d,duration:1,task:n}),t.form_blocks._fill_lightbox_select(o,s.size,h,s,a)},c=0;c<4;c++)o[c].onchange=l;var u=t._resolve_default_mapping(r);"string"==typeof u&&(u={start_date:u});var d=n[u.start_date]||new Date,h=n[u.end_date]||t.calculateEndDate({start_date:d,duration:1,task:n});t.form_blocks._fill_lightbox_select(o,0,d,s,a),t.form_blocks._fill_lightbox_select(o,s.size,h,s,a)},r.prototype.get_value=function(e,i,n){var r,a=e.getElementsByTagName("select"),o=n._time_format_order;return r=t.form_blocks.getTimePickerValue(a,n),"string"==typeof t._resolve_default_mapping(n)?r:{start_date:r,end_date:function(e,i,r){var a=t.form_blocks.getTimePickerValue(e,n,i.size);return a<=r?t.date.add(r,t._get_timepicker_step(),"minute"):a}(a,o,r)}},r.prototype.focus=function(e){t._focus(e.getElementsByTagName("select")[0])},r}},function(t,e,i){var n=i(3);t.exports=function(t){var e=i(5)(t);function r(){return e.apply(this,arguments)||this}return n(r,e),r.prototype.render=function(t){return"<div class='gantt_cal_ltext' style='height:"+((t.height||"130")+"px")+";'><textarea></textarea></div>"},r.prototype.set_value=function(e,i){t.form_blocks.textarea._get_input(e).value=i||""},r.prototype.get_value=function(e){return t.form_blocks.textarea._get_input(e).value},r.prototype.focus=function(e){var i=t.form_blocks.textarea._get_input(e);t._focus(i,!0)},r.prototype._get_input=function(t){return t.querySelector("textarea")},r}},function(t,e,i){var n=i(3);t.exports=function(t){var e=i(5)(t);function r(){return e.apply(this,arguments)||this}return n(r,e),r.prototype.render=function(t){return"<div class='gantt_cal_ltext gantt_cal_template' style='height:"+((t.height||"30")+"px")+";'></div>"},r.prototype.set_value=function(t,e){t.innerHTML=e||""},r.prototype.get_value=function(t){return t.innerHTML||""},r.prototype.focus=function(){},r}},function(t,e,i){t.exports=function(t){var e=i(1),n=i(2),r=i(61)(t),a=i(60)(t),o=i(59)(t),s=i(10)(t),l=i(58)(t),c=i(57)(t),u=i(56)(t),d=i(55)(t),h=i(10)(t),f=i(54)(t);function _(e,i){var n,r,a="";for(r=0;r<e.length;r++)n=t.config._migrate_buttons[e[r]]?t.config._migrate_buttons[e[r]]:e[r],a+="<div "+t._waiAria.lightboxButtonAttrString(n)+" class='gantt_btn_set gantt_left_btn_set "+n+"_set'"+(i?" style='float:right;'":"")+"><div dhx_button='1' data-dhx-button='1' class='"+n+"'></div><div>"+t.locale.labels[n]+"</div></div>";return a}function g(e,i,n){var r,a,o,s,l,c,u="";switch(n.timeFormat[i]){case"%Y":for(e._time_format_order[2]=i,e._time_format_order.size++,e.year_range&&(isNaN(e.year_range)?e.year_range.push&&(o=e.year_range[0],s=e.year_range[1]):r=e.year_range),r=r||10,a=a||Math.floor(r/2),o=o||n.date.getFullYear()-a,s=s||o+r,l=o;l<s;l++)u+="<option value='"+l+"'>"+l+"</option>";break;case"%m":for(e._time_format_order[1]=i,e._time_format_order.size++,l=0;l<12;l++)u+="<option value='"+l+"'>"+t.locale.date.month_full[l]+"</option>";break;case"%d":for(e._time_format_order[0]=i,e._time_format_order.size++,l=1;l<32;l++)u+="<option value='"+l+"'>"+l+"</option>";break;case"%H:%i":for(e._time_format_order[3]=i,e._time_format_order.size++,l=n.first,c=n.date.getDate(),e._time_values=[];l<n.last;)u+="<option value='"+l+"'>"+t.templates.time_picker(n.date)+"</option>",e._time_values.push(l),n.date.setTime(n.date.valueOf()+60*t._get_timepicker_step()*1e3),l=24*(n.date.getDate()!=c?1:0)*60+60*n.date.getHours()+n.date.getMinutes()}return u}t._lightbox_methods={},t._lightbox_template="<div class='gantt_cal_ltitle'><span class='gantt_mark'>&nbsp;</span><span class='gantt_time'></span><span class='gantt_title'></span></div><div class='gantt_cal_larea'></div>",t.$services.getService("state").registerProvider("lightbox",function(){return{lightbox:t._lightbox_id}}),t.showLightbox=function(t){if(this.callEvent("onBeforeLightbox",[t])){var e=this.getTask(t),i=this.getLightbox(this.getTaskType(e.type));this._center_lightbox(i),this.showCover(),this._fill_lightbox(t,i),this._waiAria.lightboxVisibleAttr(i),this.callEvent("onLightbox",[t])}},t._get_timepicker_step=function(){if(this.config.round_dnd_dates){var e;if(function(t){var e=t.$ui.getView("timeline");return!(!e||!e.isVisible())}(this)){var i=t.getScale();e=n.getSecondsInUnit(i.unit)*i.step/60}return(!e||e>=1440)&&(e=this.config.time_step),e}return this.config.time_step},t.getLabel=function(t,e){for(var i=this._get_typed_lightbox_config(),n=0;n<i.length;n++)if(i[n].map_to==t)for(var r=i[n].options,a=0;a<r.length;a++)if(r[a].key==e)return r[a].label;return""},t.updateCollection=function(e,i){i=i.slice(0);var n=t.serverList(e);if(!n)return!1;n.splice(0,n.length),n.push.apply(n,i||[]),t.resetLightbox()},t.getLightboxType=function(){return this.getTaskType(this._lightbox_type)},t.getLightbox=function(e){var i,n,r,a,o="";return void 0===e&&(e=this.getLightboxType()),this._lightbox&&this.getLightboxType()==this.getTaskType(e)||(this._lightbox_type=this.getTaskType(e),i=document.createElement("div"),o="gantt_cal_light",n=this._is_lightbox_timepicker(),(t.config.wide_form||n)&&(o+=" gantt_cal_light_wide"),n&&(t.config.wide_form=!0,o+=" gantt_cal_light_full"),i.className=o,i.style.visibility="hidden",r=this._lightbox_template,r+=_(this.config.buttons_left),r+=_(this.config.buttons_right,!0),i.innerHTML=r,t._waiAria.lightboxAttr(i),t.config.drag_lightbox&&(i.firstChild.onmousedown=t._ready_to_dnd,i.firstChild.onselectstart=function(){return!1},i.firstChild.style.cursor="pointer",t._init_dnd_events()),document.body.insertBefore(i,document.body.firstChild),this._lightbox=i,a=this._get_typed_lightbox_config(e),r=this._render_sections(a),i.querySelector("div.gantt_cal_larea").innerHTML=r,function(e){var i,n,r,a,o,s;for(s=0;s<e.length;s++)i=e[s],r=document.getElementById(i.id),i.id&&r&&(n=r.querySelector("label"),(a=r.nextSibling)&&(o=a.querySelector("input, select, textarea"))&&(o.id=o.id||"input_"+t.uid(),i.inputId=o.id,n.setAttribute("for",i.inputId)))}(a),this.resizeLightbox(),this._init_lightbox_events(this),i.style.display="none",i.style.visibility="visible"),this._lightbox},t._render_sections=function(t){for(var e="",i=0;i<t.length;i++){var n=this.form_blocks[t[i].type];if(n){t[i].id="area_"+this.uid();var r=t[i].hidden?" style='display:none'":"",a="";t[i].button&&(a="<div class='gantt_custom_button' data-index='"+i+"'><div class='gantt_custom_button_"+t[i].button+"'></div><div class='gantt_custom_button_label'>"+this.locale.labels["button_"+t[i].button]+"</div></div>"),this.config.wide_form&&(e+="<div class='gantt_wrap_section' "+r+">"),e+="<div id='"+t[i].id+"' class='gantt_cal_lsection'><label>"+a+this.locale.labels["section_"+t[i].name]+"</label></div>"+n.render.call(this,t[i]),e+="</div>"}}return e},t.resizeLightbox=function(){if(this._lightbox){var t=this._lightbox.childNodes[1];t.style.height="0px",t.style.height=t.scrollHeight+"px",this._lightbox.style.height=t.scrollHeight+this.config.lightbox_additional_height+"px",t.style.height=t.scrollHeight+"px"}},t._center_lightbox=function(t){if(t){t.style.display="block";var e=window.pageYOffset||document.body.scrollTop||document.documentElement.scrollTop,i=window.pageXOffset||document.body.scrollLeft||document.documentElement.scrollLeft,n=window.innerHeight||document.documentElement.clientHeight;t.style.top=e?Math.round(e+Math.max((n-t.offsetHeight)/2,0))+"px":Math.round(Math.max((n-t.offsetHeight)/2,0)+9)+"px",document.documentElement.scrollWidth>document.body.offsetWidth?t.style.left=Math.round(i+(document.body.offsetWidth-t.offsetWidth)/2)+"px":t.style.left=Math.round((document.body.offsetWidth-t.offsetWidth)/2)+"px"}},t.showCover=function(){if(!this._cover){this._cover=document.createElement("DIV"),this._cover.className="gantt_cal_cover";var t=void 0!==document.height?document.height:document.body.offsetHeight,e=document.documentElement?document.documentElement.scrollHeight:0;this._cover.style.height=Math.max(t,e)+"px",document.body.appendChild(this._cover)}},t._init_lightbox_events=function(){t.lightbox_events={},t.lightbox_events.gantt_save_btn=function(){t._save_lightbox()},t.lightbox_events.gantt_delete_btn=function(){t.callEvent("onLightboxDelete",[t._lightbox_id])&&(t.isTaskExists(t._lightbox_id)?t.$click.buttons.delete(t._lightbox_id):t.hideLightbox())},t.lightbox_events.gantt_cancel_btn=function(){t._cancel_lightbox()},t.lightbox_events.default=function(i,n){if(n.getAttribute("data-dhx-button"))t.callEvent("onLightboxButton",[n.className,n,i]);else{var r,a,o=e.getClassName(n);if(-1!=o.indexOf("gantt_custom_button"))if(-1!=o.indexOf("gantt_custom_button_"))for(r=n.parentNode.getAttribute("data-index"),a=n;a&&-1==e.getClassName(a).indexOf("gantt_cal_lsection");)a=a.parentNode;else r=n.getAttribute("data-index"),a=n.parentNode,n=n.firstChild;var s=t._get_typed_lightbox_config();r&&(r*=1,t.form_blocks[s[1*r].type].button_click(r,n,a,a.nextSibling))}},this.event(t.getLightbox(),"click",function(i){var n=(i=i||window.event).target?i.target:i.srcElement,r=e.getClassName(n);return r||(n=n.previousSibling,r=e.getClassName(n)),n&&r&&0===r.indexOf("gantt_btn_set")&&(n=n.firstChild,r=e.getClassName(n)),!(!n||!r)&&(t.defined(t.lightbox_events[n.className])?t.lightbox_events[n.className]:t.lightbox_events.default)(i,n)}),t.getLightbox().onkeydown=function(i){var n=i||window.event,r=i.target||i.srcElement,a=e.getClassName(r).indexOf("gantt_btn_set")>-1;switch((i||n).keyCode){case t.constants.KEY_CODES.SPACE:if((i||n).shiftKey)return;a&&r.click&&r.click();break;case t.keys.edit_save:if((i||n).shiftKey)return;a&&r.click?r.click():t._save_lightbox();break;case t.keys.edit_cancel:t._cancel_lightbox()}}},t._cancel_lightbox=function(){var e=this.getLightboxValues();this.callEvent("onLightboxCancel",[this._lightbox_id,e.$new]),t.isTaskExists(e.id)&&e.$new&&this.silent(function(){t.$data.tasksStore.removeItem(e.id),t._update_flags(e.id,null)}),this.refreshData(),this.hideLightbox()},t._save_lightbox=function(){var t=this.getLightboxValues();this.callEvent("onLightboxSave",[this._lightbox_id,t,!!t.$new])&&(t.$new?(delete t.$new,this.addTask(t,t.parent,this.getTaskIndex(t.id))):this.isTaskExists(t.id)&&(this.mixin(this.getTask(t.id),t,!0),this.refreshTask(t.id),this.updateTask(t.id)),this.refreshData(),this.hideLightbox())},t._resolve_default_mapping=function(t){var e=t.map_to;return!{time:!0,time_optional:!0,duration:!0,duration_optional:!0}[t.type]?"constraint"===t.type&&(t.map_to&&"string"!=typeof t.map_to||(e={constraint_type:"constraint_type",constraint_date:"constraint_date"})):"auto"==t.map_to?e={start_date:"start_date",end_date:"end_date",duration:"duration"}:"string"==typeof t.map_to&&(e={start_date:t.map_to}),e},t.getLightboxValues=function(){var e={};t.isTaskExists(this._lightbox_id)&&(e=this.mixin({},this.getTask(this._lightbox_id)));for(var i=this._get_typed_lightbox_config(),n=0;n<i.length;n++){var r=document.getElementById(i[n].id);r=r?r.nextSibling:r;var a=this.form_blocks[i[n].type];if(a){var o=a.get_value.call(this,r,e,i[n]),s=t._resolve_default_mapping(i[n]);if("string"==typeof s&&"auto"!=s)e[s]=o;else if("object"==typeof s)for(var l in s)s[l]&&(e[s[l]]=o[l])}}return e},t.hideLightbox=function(){var t=this.getLightbox();t&&(t.style.display="none"),this._waiAria.lightboxHiddenAttr(t),this._lightbox_id=null,this.hideCover(),this.callEvent("onAfterLightbox",[])},t.hideCover=function(){this._cover&&this._cover.parentNode.removeChild(this._cover),this._cover=null},t.resetLightbox=function(){t._lightbox&&!t._custom_lightbox&&t._lightbox.parentNode.removeChild(t._lightbox),t._lightbox=null,t.hideCover()},t._set_lightbox_values=function(e,i){var n=e,r=i.getElementsByTagName("span"),a=[];t.templates.lightbox_header?(a.push(""),a.push(t.templates.lightbox_header(n.start_date,n.end_date,n)),r[1].innerHTML="",r[2].innerHTML=t.templates.lightbox_header(n.start_date,n.end_date,n)):(a.push(this.templates.task_time(n.start_date,n.end_date,n)),a.push(String(this.templates.task_text(n.start_date,n.end_date,n)||"").substr(0,70)),r[1].innerHTML=this.templates.task_time(n.start_date,n.end_date,n),r[2].innerHTML=String(this.templates.task_text(n.start_date,n.end_date,n)||"").substr(0,70)),r[1].innerHTML=a[0],r[2].innerHTML=a[1],t._waiAria.lightboxHeader(i,a.join(" "));for(var o=this._get_typed_lightbox_config(this.getLightboxType()),s=0;s<o.length;s++){var l=o[s];if(this.form_blocks[l.type]){var c=document.getElementById(l.id).nextSibling,u=this.form_blocks[l.type],d=t._resolve_default_mapping(o[s]),h=this.defined(n[d])?n[d]:l.default_value;u.set_value.call(t,c,h,n,l),l.focus&&u.focus.call(t,c)}}e.id&&(t._lightbox_id=e.id)},t._fill_lightbox=function(t,e){var i=this.getTask(t);this._set_lightbox_values(i,e)},t.getLightboxSection=function(e){for(var i=this._get_typed_lightbox_config(),n=0;n<i.length&&i[n].name!=e;n++);var r=i[n];if(!r)return null;this._lightbox||this.getLightbox();var a=document.getElementById(r.id),o=a.nextSibling,s={section:r,header:a,node:o,getValue:function(e){return t.form_blocks[r.type].get_value.call(t,o,e||{},r)},setValue:function(e,i){return t.form_blocks[r.type].set_value.call(t,o,e,i||{},r)}},l=this._lightbox_methods["get_"+r.type+"_control"];return l?l(s):s},t._lightbox_methods.get_template_control=function(t){return t.control=t.node,t},t._lightbox_methods.get_select_control=function(t){return t.control=t.node.getElementsByTagName("select")[0],t},t._lightbox_methods.get_textarea_control=function(t){return t.control=t.node.getElementsByTagName("textarea")[0],t},t._lightbox_methods.get_time_control=function(t){return t.control=t.node.getElementsByTagName("select"),t},t._init_dnd_events=function(){this.event(document.body,"mousemove",t._move_while_dnd),this.event(document.body,"mouseup",t._finish_dnd),t._init_dnd_events=function(){}},t._move_while_dnd=function(e){if(t._dnd_start_lb){document.gantt_unselectable||(document.body.className+=" gantt_unselectable",document.gantt_unselectable=!0);var i=t.getLightbox(),n=e&&e.target?[e.pageX,e.pageY]:[event.clientX,event.clientY];i.style.top=t._lb_start[1]+n[1]-t._dnd_start_lb[1]+"px",i.style.left=t._lb_start[0]+n[0]-t._dnd_start_lb[0]+"px"}},t._ready_to_dnd=function(e){var i=t.getLightbox();t._lb_start=[parseInt(i.style.left,10),parseInt(i.style.top,10)],t._dnd_start_lb=e&&e.target?[e.pageX,e.pageY]:[event.clientX,event.clientY]},t._finish_dnd=function(){t._lb_start&&(t._lb_start=t._dnd_start_lb=!1,document.body.className=document.body.className.replace(" gantt_unselectable",""),document.gantt_unselectable=!1)},t._focus=function(e,i){if(e&&e.focus)if(t.config.touch);else try{i&&e.select&&e.select(),e.focus()}catch(t){}},t.form_blocks={getTimePicker:function(e,i){var r,a,o,s="",l=this.config,c={first:0,last:1440,date:this.date.date_part(new Date(t._min_date.valueOf())),timeFormat:function(e){var i,r,a;if(e.time_format)return e.time_format;a=["%d","%m","%Y"],i=t.getScale(),r=i?i.unit:t.config.duration_unit,n.getSecondsInUnit(r)<n.getSecondsInUnit("day")&&a.push("%H:%i");return a}(e)};for(e._time_format_order={size:0},t.config.limit_time_select&&(c.first=60*l.first_hour,c.last=60*l.last_hour+1,c.date.setHours(l.first_hour)),r=0;r<c.timeFormat.length;r++)r>0&&(s+=" "),(a=g(e,r,c))&&(o=t._waiAria.lightboxSelectAttrString(c.timeFormat[r]),s+="<select "+(e.readonly?"disabled='disabled'":"")+(i?" style='display:none' ":"")+o+">"+a+"</select>");return s},getTimePickerValue:function(e,i,n){var r,a=i._time_format_order,o=t.defined(a[3]),s=0,l=0,c=n||0;return o&&(r=parseInt(e[a[3]+c].value,10),s=Math.floor(r/60),l=r%60),new Date(e[a[2]+c].value,e[a[1]+c].value,e[a[0]+c].value,s,l)},_fill_lightbox_select:function(e,i,n,r){if(e[i+r[0]].value=n.getDate(),e[i+r[1]].value=n.getMonth(),e[i+r[2]].value=n.getFullYear(),t.defined(r[3])){var a=60*n.getHours()+n.getMinutes();a=Math.round(a/t._get_timepicker_step())*t._get_timepicker_step();var o=e[i+r[3]];o.value=a,o.setAttribute("data-value",a)}},template:new r,textarea:new a,select:new s,time:new o,duration:new u,parent:new d,radio:new c,checkbox:new l,resources:new h,constraint:new f},t._is_lightbox_timepicker=function(){for(var t=this._get_typed_lightbox_config(),e=0;e<t.length;e++)if("time"==t[e].name&&"time"==t[e].type)return!0;return!1},t._dhtmlx_confirm=function(e,i,n,r){if(!e)return n();var a={text:e};i&&(a.title=i),r&&(a.ok=r),n&&(a.callback=function(t){t&&n()}),t.confirm(a)},t._get_typed_lightbox_config=function(e){void 0===e&&(e=this.getLightboxType());var i=function(t){for(var e in this.config.types)if(this.config.types[e]==t)return e;return"task"}.call(this,e);return t.config.lightbox[i+"_sections"]?t.config.lightbox[i+"_sections"]:t.config.lightbox.sections},t._silent_redraw_lightbox=function(t){var e=this.getLightboxType();if(this.getState().lightbox){var i=this.getState().lightbox,n=this.getLightboxValues(),r=this.copy(this.getTask(i));this.resetLightbox();var a=this.mixin(r,n,!0),o=this.getLightbox(t||void 0);this._center_lightbox(this.getLightbox()),this._set_lightbox_values(a,o),this.showCover()}else this.resetLightbox(),this.getLightbox(t||void 0);this.callEvent("onLightboxChange",[e,this.getLightboxType()])}}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=function(){}},function(t,e,i){var n=i(2);t.exports=function(t){t.isUnscheduledTask=function(e){return t.assert(e&&e instanceof Object,"Invalid argument <b>task</b>="+e+" of gantt.isUnscheduledTask. Task object was expected"),!!e.unscheduled||!e.start_date},t._isAllowedUnscheduledTask=function(e){return!(!e.unscheduled||!t.config.show_unscheduled)},t._isTaskInTimelineLimits=function(t){var e=t.start_date?t.start_date.valueOf():null,i=t.end_date?t.end_date.valueOf():null;return!!(e&&i&&e<=this._max_date.valueOf()&&i>=this._min_date.valueOf())},t.isTaskVisible=function(t){if(!this.isTaskExists(t))return!1;var e=this.getTask(t);return!(!this._isAllowedUnscheduledTask(e)&&!this._isTaskInTimelineLimits(e))&&!!(this.getGlobalTaskIndex(t)>=0)},t._getProjectEnd=function(){if(t.config.project_end)return t.config.project_end;var e=t.getTaskByTime();return(e=e.sort(function(t,e){return+t.end_date>+e.end_date?1:-1})).length?e[e.length-1].end_date:null},t._getProjectStart=function(){if(t.config.project_start)return t.config.project_start;if(t.config.start_date)return t.config.start_date;if(t.getState().min_date)return t.getState().min_date;var e=t.getTaskByTime();return(e=e.sort(function(t,e){return+t.start_date>+e.start_date?1:-1})).length?e[0].start_date:null},t._defaultTaskDate=function(e,i){var n=!(!i||i==t.config.root_id)&&t.getTask(i),r=null;if(n)r=t.config.schedule_from_end?t.calculateEndDate({start_date:n.end_date,duration:-t.config.duration_step,task:e}):n.start_date;else if(t.config.schedule_from_end)r=t.calculateEndDate({start_date:t._getProjectEnd(),duration:-t.config.duration_step,task:e});else{var a=t.getTaskByIndex(0);r=a?a.start_date?a.start_date:a.end_date?t.calculateEndDate({start_date:a.end_date,duration:-t.config.duration_step,task:e}):null:t.config.start_date||t.getState().min_date}return t.assert(r,"Invalid dates"),new Date(r)},t._set_default_task_timing=function(e){e.start_date=e.start_date||t._defaultTaskDate(e,t.getParent(e)),e.duration=e.duration||t.config.duration_step,e.end_date=e.end_date||t.calculateEndDate(e)},t.createTask=function(e,i,n){(e=e||{},t.defined(e.id)||(e.id=t.uid()),e.start_date||(e.start_date=t._defaultTaskDate(e,i)),void 0===e.text&&(e.text=t.locale.labels.new_task),void 0===e.duration&&(e.duration=1),this.isTaskExists(i))&&(this.setParent(e,i,!0),this.getTask(i).$open=!0);return this.callEvent("onTaskCreated",[e])?(this.config.details_on_create?(e.$new=!0,this.silent(function(){t.$data.tasksStore.addItem(e,n)}),this.selectTask(e.id),this.refreshData(),this.showLightbox(e.id)):this.addTask(e,i,n)&&(this.showTask(e.id),this.selectTask(e.id)),e.id):null},t._update_flags=function(e,i){var n=t.$data.tasksStore;void 0===e?(this._lightbox_id=null,n.silent(function(){n.unselect()}),this._tasks_dnd&&this._tasks_dnd.drag&&(this._tasks_dnd.drag.id=null)):(this._lightbox_id==e&&(this._lightbox_id=i),n.getSelectedId()==e&&n.silent(function(){n.unselect(e),n.select(i)}),this._tasks_dnd&&this._tasks_dnd.drag&&this._tasks_dnd.drag.id==e&&(this._tasks_dnd.drag.id=i))},t._get_task_timing_mode=function(t,e){var i=this.getTaskType(t.type),n={type:i,$no_start:!1,$no_end:!1};return e||i!=t.$rendered_type?(i==this.config.types.project?n.$no_end=n.$no_start=!0:i!=this.config.types.milestone&&(n.$no_end=!(t.end_date||t.duration),n.$no_start=!t.start_date,this._isAllowedUnscheduledTask(t)&&(n.$no_end=n.$no_start=!1)),n):(n.$no_start=t.$no_start,n.$no_end=t.$no_end,n)},t._init_task_timing=function(e){var i=t._get_task_timing_mode(e,!0),n=e.$rendered_type!=i.type,r=i.type;n&&(e.$no_start=i.$no_start,e.$no_end=i.$no_end,e.$rendered_type=i.type),n&&r!=this.config.types.milestone&&r==this.config.types.project&&this._set_default_task_timing(e),r==this.config.types.milestone&&(e.end_date=e.start_date),e.start_date&&e.end_date&&(e.duration=this.calculateDuration(e)),e.end_date||(e.end_date=e.start_date),e.duration=e.duration||0},t.isSummaryTask=function(e){t.assert(e&&e instanceof Object,"Invalid argument <b>task</b>="+e+" of gantt.isSummaryTask. Task object was expected");var i=t._get_task_timing_mode(e);return!(!i.$no_end&&!i.$no_start)},t.resetProjectDates=function(t){var e=this._get_task_timing_mode(t);if(e.$no_end||e.$no_start){var i=this.getSubtaskDates(t.id);this._assign_project_dates(t,i.start_date,i.end_date)}},t.getSubtaskDuration=function(e){var i=0,n=void 0!==e?e:t.config.root_id;return this.eachTask(function(e){this.getTaskType(e.type)==t.config.types.project||this.isUnscheduledTask(e)||(i+=e.duration)},n),i},t.getSubtaskDates=function(e){var i=null,n=null,r=void 0!==e?e:t.config.root_id;return this.eachTask(function(e){this.getTaskType(e.type)==t.config.types.project||this.isUnscheduledTask(e)||(e.start_date&&!e.$no_start&&(!i||i>e.start_date.valueOf())&&(i=e.start_date.valueOf()),e.end_date&&!e.$no_end&&(!n||n<e.end_date.valueOf())&&(n=e.end_date.valueOf()))},r),{start_date:i?new Date(i):null,end_date:n?new Date(n):null}},t._assign_project_dates=function(t,e,i){var n=this._get_task_timing_mode(t);n.$no_start&&(t.start_date=e&&e!=1/0?new Date(e):this._defaultTaskDate(t,this.getParent(t))),n.$no_end&&(t.end_date=i&&i!=-1/0?new Date(i):this.calculateEndDate({start_date:t.start_date,duration:this.config.duration_step,task:t})),(n.$no_start||n.$no_end)&&this._init_task_timing(t)},t._update_parents=function(e,i){if(e){var n=this.getTask(e),r=this.getParent(n),a=this._get_task_timing_mode(n),o=!0;if(a.$no_start||a.$no_end){var s=n.start_date.valueOf(),l=n.end_date.valueOf();t.resetProjectDates(n),s==n.start_date.valueOf()&&l==n.end_date.valueOf()&&(o=!1),o&&!i&&this.refreshTask(n.id,!0)}o&&r&&this.isTaskExists(r)&&this._update_parents(r,i)}},t.roundDate=function(e){var i=t.getScale();n.isDate(e)&&(e={date:e,unit:i?i.unit:t.config.duration_unit,step:i?i.step:t.config.duration_step});var r,a,o,s=e.date,l=e.step,c=e.unit;if(!i)return s;if(c==i.unit&&l==i.step&&+s>=+i.min_date&&+s<=+i.max_date)o=Math.floor(t.columnIndexByDate(s)),i.trace_x[o]||(o-=1,i.rtl&&(o=0)),a=new Date(i.trace_x[o]),r=t.date.add(a,l,c);else{for(o=Math.floor(t.columnIndexByDate(s)),r=t.date[c+"_start"](new Date(i.min_date)),i.trace_x[o]&&(r=t.date[c+"_start"](i.trace_x[o]));+r<+s;){var u=(r=t.date[c+"_start"](t.date.add(r,l,c))).getTimezoneOffset();r=t._correct_dst_change(r,u,r,c),t.date[c+"_start"]&&(r=t.date[c+"_start"](r))}a=t.date.add(r,-1*l,c)}return e.dir&&"future"==e.dir?r:e.dir&&"past"==e.dir?a:Math.abs(s-a)<Math.abs(r-s)?a:r},t.correctTaskWorkTime=function(e){t.config.work_time&&t.config.correct_work_time&&(this.isWorkTime(e.start_date,void 0,e)?this.isWorkTime(new Date(+e.end_date-1),void 0,e)||(e.end_date=this.calculateEndDate(e)):(e.start_date=this.getClosestWorkTime({date:e.start_date,dir:"future",task:e}),e.end_date=this.calculateEndDate(e)))},t.attachEvent("onBeforeTaskUpdate",function(e,i){return t._init_task_timing(i),!0}),t.attachEvent("onBeforeTaskAdd",function(e,i){return t._init_task_timing(i),!0})}},function(t,e,i){var n=i(0);t.exports={create:function(t,e){return{getWorkHours:function(t){return e.getWorkHours(t)},setWorkTime:function(t){return e.setWorkTime(t)},unsetWorkTime:function(t){e.unsetWorkTime(t)},isWorkTime:function(t,i,n){return e.isWorkTime(t,i,n)},getClosestWorkTime:function(t){return e.getClosestWorkTime(t)},calculateDuration:function(t,i,n){return e.calculateDuration(t,i,n)},_hasDuration:function(t,i,n){return e.hasDuration(t,i,n)},calculateEndDate:function(t,i,n,r){return e.calculateEndDate(t,i,n,r)},createCalendar:n.bind(t.createCalendar,t),addCalendar:n.bind(t.addCalendar,t),getCalendar:n.bind(t.getCalendar,t),getCalendars:n.bind(t.getCalendars,t),getTaskCalendar:n.bind(t.getTaskCalendar,t),deleteCalendar:n.bind(t.deleteCalendar,t)}}}},function(t,e){function i(t,e){this.argumentsHelper=e,this.$gantt=t}i.prototype={getWorkHours:function(){return[0,24]},setWorkTime:function(){return!0},unsetWorkTime:function(){return!0},isWorkTime:function(){return!0},getClosestWorkTime:function(t){return this.argumentsHelper.getClosestWorkTimeArguments.apply(this.argumentsHelper,arguments).date},calculateDuration:function(){var t=this.argumentsHelper.getDurationArguments.apply(this.argumentsHelper,arguments),e=t.start_date,i=t.end_date,n=t.unit,r=t.step;return this._calculateDuration(e,i,n,r)},_calculateDuration:function(t,e,i,n){var r=this.$gantt.date,a={week:6048e5,day:864e5,hour:36e5,minute:6e4},o=0;if(a[i])o=Math.round((e-t)/(n*a[i]));else{for(var s=new Date(t),l=new Date(e);s.valueOf()<l.valueOf();)o+=1,s=r.add(s,n,i);s.valueOf()!=e.valueOf()&&(o+=(l-s)/(r.add(s,n,i)-s))}return Math.round(o)},hasDuration:function(){var t=this.argumentsHelper.getDurationArguments.apply(this.argumentsHelper,arguments),e=t.start_date,i=t.end_date;return!!t.unit&&(e=new Date(e),i=new Date(i),e.valueOf()<i.valueOf())},calculateEndDate:function(){var t=this.argumentsHelper.calculateEndDateArguments.apply(this.argumentsHelper,arguments),e=t.start_date,i=t.duration,n=t.unit,r=t.step;return this.$gantt.date.add(e,r*i,n)}},t.exports=i},function(t,e,i){var n=i(21),r=i(66);function a(t){this.$gantt=t.$gantt,this.argumentsHelper=n(this.$gantt),this.calendarManager=t,this.$disabledCalendar=new r(this.$gantt,this.argumentsHelper)}a.prototype={_getCalendar:function(t){var e;if(this.$gantt.$services.config().work_time){var i=this.calendarManager;t.task?e=i.getTaskCalendar(t.task):t.id?e=i.getTaskCalendar(t):t.calendar&&(e=t.calendar),e||(e=i.getTaskCalendar())}else e=this.$disabledCalendar;return e},getWorkHours:function(t){return t=this.argumentsHelper.getWorkHoursArguments.apply(this.argumentsHelper,arguments),this._getCalendar(t).getWorkHours(t.date)},setWorkTime:function(t,e){return t=this.argumentsHelper.setWorkTimeArguments.apply(this.argumentsHelper,arguments),e||(e=this.calendarManager.getCalendar()),e.setWorkTime(t)},unsetWorkTime:function(t,e){return t=this.argumentsHelper.unsetWorkTimeArguments.apply(this.argumentsHelper,arguments),e||(e=this.calendarManager.getCalendar()),e.unsetWorkTime(t)},isWorkTime:function(t,e,i,n){var r=this.argumentsHelper.isWorkTimeArguments.apply(this.argumentsHelper,arguments);return this._getCalendar(r).isWorkTime(r)},getClosestWorkTime:function(t){return t=this.argumentsHelper.getClosestWorkTimeArguments.apply(this.argumentsHelper,arguments),this._getCalendar(t).getClosestWorkTime(t)},calculateDuration:function(){var t=this.argumentsHelper.getDurationArguments.apply(this.argumentsHelper,arguments);return this._getCalendar(t).calculateDuration(t)},hasDuration:function(){var t=this.argumentsHelper.hasDurationArguments.apply(this.argumentsHelper,arguments);return this._getCalendar(t).hasDuration(t)},calculateEndDate:function(t){t=this.argumentsHelper.calculateEndDateArguments.apply(this.argumentsHelper,arguments);return this._getCalendar(t).calculateEndDate(t)}},t.exports=a},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=function(){function t(){this.clear()}return t.prototype.getItem=function(t,e){var i=this._cache;if(i&&i[t]){var n=i[t];if(void 0!==n[e])return n[e]}return-1},t.prototype.setItem=function(t,e,i){if(t&&e){var n=this._cache;n&&(n[t]||(n[t]={}),n[t][e]=i)}},t.prototype.clear=function(){this._cache={}},t}();e.WorkUnitsObjectCache=n},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=function(){function t(){this.clear()}return t.prototype.getItem=function(t,e){if(this._cache.has(t)){var i=this._cache.get(t);if(i.has(e))return i.get(e)}return-1},t.prototype.setItem=function(t,e,i){if(t&&e){var n,r=this._cache;r.has(t)?n=r.get(t):(n=new Map,r.set(t,n)),n.set(e,i)}},t.prototype.clear=function(){this._cache=new Map},t}();e.WorkUnitsMapCache=n},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(69),r=i(68);e.createCacheObject=function(){return"undefined"!=typeof Map?new n.WorkUnitsMapCache:new r.WorkUnitsObjectCache}},function(t,e,i){var n=i(70),r=i(0);function a(t,e){this.argumentsHelper=e,this.$gantt=t,this._workingUnitsCache=n.createCacheObject()}a.prototype={units:["year","month","week","day","hour","minute"],_getUnitOrder:function(t){for(var e=0,i=this.units.length;e<i;e++)if(this.units[e]==t)return e},_timestamp:function(t){var e=null;return t.day||0===t.day?e=t.day:t.date&&(e=Date.UTC(t.date.getFullYear(),t.date.getMonth(),t.date.getDate())),e},_checkIfWorkingUnit:function(t,e,i){return void 0===i&&(i=this._getUnitOrder(e)),void 0===i||!(i&&!this._isWorkTime(t,this.units[i-1],i-1))&&(!this["_is_work_"+e]||this["_is_work_"+e](t))},_is_work_day:function(t){var e=this._getWorkHours(t);return e instanceof Array&&e.length>0},_is_work_hour:function(t){for(var e=this._getWorkHours(t),i=t.getHours(),n=0;n<e.length;n+=2){if(void 0===e[n+1])return e[n]==i;if(i>=e[n]&&i<e[n+1])return!0}return!1},_internDatesPull:{},_nextDate:function(t,e,i){return this.$gantt.date.add(t,i,e)},_getWorkUnitsBetweenGeneric:function(t,e,i,n){var r=this.$gantt.date,a=new Date(t),o=new Date(e);n=n||1;var s,l,c=0,u=null,d=!1;(s=r[i+"_start"](new Date(a))).valueOf()!=a.valueOf()&&(d=!0);var h=!1;(l=r[i+"_start"](new Date(e))).valueOf()!=e.valueOf()&&(h=!0);for(var f=!1;a.valueOf()<o.valueOf();)f=(u=this._nextDate(a,i,n)).valueOf()>o.valueOf(),this._isWorkTime(a,i)&&((d||h&&f)&&(s=r[i+"_start"](new Date(a)),l=r.add(s,n,i)),d?(d=!1,u=this._nextDate(s,i,n),c+=(l.valueOf()-a.valueOf())/(l.valueOf()-s.valueOf())):h&&f?(h=!1,c+=(o.valueOf()-a.valueOf())/(l.valueOf()-s.valueOf())):c++),a=u;return c},_getMinutesPerDay:function(t){return 60*this._getHoursPerDay(t)},_getHoursPerDay:function(t){for(var e=this._getWorkHours(t),i=0,n=0;n<e.length;n+=2)i+=e[n+1]-e[n]||0;return i},_getWorkUnitsForRange:function(t,e,i,n){var a,o=0,s=new Date(t),l=new Date(e);for(a="minute"==i?r.bind(this._getMinutesPerDay,this):r.bind(this._getHoursPerDay,this);s.valueOf()<l.valueOf();)this._isWorkTime(s,"day")&&(o+=a(s)),s=this._nextDate(s,"day",1);return o/n},_getWorkUnitsBetweenQuick:function(t,e,i,n){var r=new Date(t),a=new Date(e);n=n||1;var o=new Date(r),s=this.$gantt.date.add(this.$gantt.date.day_start(new Date(r)),1,"day");if(a.valueOf()<=s.valueOf())return this._getWorkUnitsBetweenGeneric(t,e,i,n);var l=this.$gantt.date.day_start(new Date(a)),c=a,u=this._getWorkUnitsBetweenGeneric(o,s,i,n),d=this._getWorkUnitsBetweenGeneric(l,c,i,n);return u+this._getWorkUnitsForRange(s,l,i,n)+d},_getCalendar:function(){return this.worktime},_setCalendar:function(t){this.worktime=t},_tryChangeCalendarSettings:function(t){var e=JSON.stringify(this._getCalendar());return t(),!this._isEmptyCalendar(this._getCalendar())||(this.$gantt.assert(!1,"Invalid calendar settings, no worktime available"),this._setCalendar(JSON.parse(e)),this._workingUnitsCache.clear(),!1)},_isEmptyCalendar:function(t){var e=!1,i=[],n=!0;for(var r in t.dates)e|=!!t.dates[r],i.push(r);var a=[];for(r=0;r<i.length;r++)i[r]<10&&a.push(i[r]);a.sort();for(r=0;r<7;r++)a[r]!=r&&(n=!1);return n?!e:!(e||t.hours)},getWorkHours:function(){var t=this.argumentsHelper.getWorkHoursArguments.apply(this.argumentsHelper,arguments);return this._getWorkHours(t.date)},_getWorkHours:function(t){var e=this._timestamp({date:t}),i=!0,n=this._getCalendar();return void 0!==n.dates[e]?i=n.dates[e]:void 0!==n.dates[t.getDay()]&&(i=n.dates[t.getDay()]),!0===i?n.hours:i||[]},setWorkTime:function(t){return this._tryChangeCalendarSettings(r.bind(function(){var e=void 0===t.hours||t.hours,i=this._timestamp(t);null!==i?this._getCalendar().dates[i]=e:this._getCalendar().hours=e,this._workingUnitsCache.clear()},this))},unsetWorkTime:function(t){return this._tryChangeCalendarSettings(r.bind(function(){if(t){var e=this._timestamp(t);null!==e&&delete this._getCalendar().dates[e]}else this.reset_calendar();this._workingUnitsCache.clear()},this))},_isWorkTime:function(t,e,i){var n=String(t.valueOf()),r=this._workingUnitsCache.getItem(e,n);return-1==r&&(r=this._checkIfWorkingUnit(t,e,i),this._workingUnitsCache.setItem(e,n,r)),r},isWorkTime:function(){var t=this.argumentsHelper.isWorkTimeArguments.apply(this.argumentsHelper,arguments);return this._isWorkTime(t.date,t.unit)},calculateDuration:function(){var t=this.argumentsHelper.getDurationArguments.apply(this.argumentsHelper,arguments);return!!t.unit&&this._calculateDuration(t.start_date,t.end_date,t.unit,t.step)},_calculateDuration:function(t,e,i,n){var r=0;return r="hour"==i||"minute"==i?this._getWorkUnitsBetweenQuick(t,e,i,n):this._getWorkUnitsBetweenGeneric(t,e,i,n),Math.round(r)},hasDuration:function(){var t=this.argumentsHelper.getDurationArguments.apply(this.argumentsHelper,arguments),e=t.start_date,i=t.end_date,n=t.unit,r=t.step;if(!n)return!1;var a=new Date(e),o=new Date(i);for(r=r||1;a.valueOf()<o.valueOf();){if(this._isWorkTime(a,n))return!0;a=this._nextDate(a,n,r)}return!1},calculateEndDate:function(){var t=this.argumentsHelper.calculateEndDateArguments.apply(this.argumentsHelper,arguments),e=t.start_date,i=t.duration,n=t.unit,r=t.step;if(!n)return!1;var a=t.duration>=0?1:-1;return i=Math.abs(1*i),this._calculateEndDate(e,i,n,r*a)},_calculateEndDate:function(t,e,i,n){return!!i&&(1==n&&"minute"==i?this._calculateMinuteEndDate(t,e,n):1==n&&"hour"==i?this._calculateHourEndDate(t,e,n):this._addInterval(t,e,i,n,null).end)},_addInterval:function(t,e,i,n,r){for(var a=0,o=t;a<e&&(!r||!r(o));){var s=this._nextDate(o,i,n);this._isWorkTime(n>0?new Date(s.valueOf()-1):new Date(s.valueOf()+1),i)&&a++,o=s}return{end:o,start:t,added:a}},_calculateHourEndDate:function(t,e,i){var n=new Date(t),r=0;i=i||1,e=Math.abs(1*e);var a=this._addInterval(n,e,"hour",i,function(t){return!(t.getHours()||t.getMinutes()||t.getSeconds()||t.getMilliseconds())});if(r=a.added,n=a.end,(c=e-r)&&c>24){for(var o=n;r<e;){var s=this._nextDate(o,"day",i);if(s.setHours(0),s.setMinutes(0),s.setSeconds(0),this._isWorkTime(i>0?new Date(s.valueOf()-1):new Date(s.valueOf()+1),"day")){var l=this._getHoursPerDay(o);if(r+l>=e)break;r+=l}o=s}n=o}if(r<e){var c=e-r;n=(a=this._addInterval(n,c,"hour",i,null)).end}return n},_calculateMinuteEndDate:function(t,e,i){var n=new Date(t),r=0;i=i||1,e=Math.abs(1*e);var a=this._addInterval(n,e,"minute",i,function(t){return!(t.getMinutes()||t.getSeconds()||t.getMilliseconds())});if(r=a.added,n=a.end,r<e){var o=e-r,s=Math.floor(o/60);s&&(n=this._calculateEndDate(n,s,"hour",i>0?1:-1),r+=60*s)}if(r<e){var l=e-r;n=(a=this._addInterval(n,l,"minute",i,null)).end}return n},getClosestWorkTime:function(){var t=this.argumentsHelper.getClosestWorkTimeArguments.apply(this.argumentsHelper,arguments);return this._getClosestWorkTime(t.date,t.unit,t.dir)},_getClosestWorkTime:function(t,e,i){var n=new Date(t);if(this._isWorkTime(n,e))return n;if(n=this.$gantt.date[e+"_start"](n),"any"!=i&&i)n="past"==i?this._getClosestWorkTimePast(n,e):this._getClosestWorkTimeFuture(n,e);else{var r=this._getClosestWorkTimeFuture(n,e),a=this._getClosestWorkTimePast(n,e);n=Math.abs(r-t)<=Math.abs(t-a)?r:a}return n},_getClosestWorkTimeFuture:function(t,e){return this._getClosestWorkTimeGeneric(t,e,1)},_getClosestWorkTimePast:function(t,e){var i=this._getClosestWorkTimeGeneric(t,e,-1);return this.$gantt.date.add(i,1,e)},_getClosestWorkTimeGeneric:function(t,e,i){for(var n=this._getUnitOrder(e),r=this.units[n-1],a=t,o=0;!this._isWorkTime(a,e)&&(!r||this._isWorkTime(a,r)||(a=i>0?this._getClosestWorkTimeFuture(a,r):this._getClosestWorkTimePast(a,r),!this._isWorkTime(a,e)));){if(++o>3e3)return this.$gantt.assert(!1,"Invalid working time check"),!1;var s=a.getTimezoneOffset();a=this.$gantt.date.add(a,i,e),a=this.$gantt._correct_dst_change(a,s,i,e),this.$gantt.date[e+"_start"]&&(a=this.$gantt.date[e+"_start"](a))}return a}},t.exports=a},function(t,e,i){var n=i(0),r=i(21),a=i(71);function o(t){this.$gantt=t,this._calendars={}}o.prototype={_calendars:{},_getDayHoursForMultiple:function(t,e){for(var i=[],n=!0,r=0,a=this.$gantt.date.day_start(new Date(e)),o=0;o<24;o++)t.reduce(function(t,e){return t&&e._is_work_hour(a)},!0)?(n?(i[r]=o,i[r+1]=o+1,r+=2):i[r-1]+=1,n=!1):n||(n=!0),a=this.$gantt.date.add(a,1,"hour");return i.length||(i=!1),i},mergeCalendars:function(){var t,e=this.createCalendar(),i=[],n=Array.prototype.slice.call(arguments,0);e.worktime.hours=[0,24],e.worktime.dates={};var r=this.$gantt.date.day_start(new Date(2592e5));for(t=0;t<7;t++)i=this._getDayHoursForMultiple(n,r),e.worktime.dates[t]=i,r=this.$gantt.date.add(r,1,"day");for(var a=0;a<n.length;a++)for(var o in n[a].worktime.dates)+o>1e4&&(i=this._getDayHoursForMultiple(n,new Date(+o)),e.worktime.dates[o]=i);return e},_convertWorktimeSettings:function(t){var e=t.days;if(e){t.dates=t.dates||{};for(var i=0;i<e.length;i++)t.dates[i]=e[i],e[i]instanceof Array||(t.dates[i]=!!e[i]);delete t.days}return t},createCalendar:function(t){var e;t||(t={}),e=t.worktime?n.copy(t.worktime):n.copy(t);var i=n.copy(this.defaults.fulltime.worktime);n.mixin(e,i);var o={id:n.uid()+"",worktime:this._convertWorktimeSettings(e)},s=new a(this.$gantt,r(this.$gantt));return n.mixin(s,o),s._tryChangeCalendarSettings(function(){})?s:null},getCalendar:function(t){return t=t||"global",this.createDefaultCalendars(),this._calendars[t]},getCalendars:function(){var t=[];for(var e in this._calendars)t.push(this.getCalendar(e));return t},_getOwnCalendar:function(t){var e=this.$gantt.config;if(t[e.calendar_property])return this.getCalendar(t[e.calendar_property]);if(e.resource_calendars)for(var i in e.resource_calendars){var n=e.resource_calendars[i];if(t[i]){var r=n[t[i]];if(r)return this.getCalendar(r)}}return null},getTaskCalendar:function(t){if(!t)return this.getCalendar();var e=this._getOwnCalendar(t),i=this.$gantt;if(!e&&i.config.inherit_calendar&&i.isTaskExists(t.parent)){var n=!1;i.eachParent(function(t){n||i.isSummaryTask(t)&&(e=this._getOwnCalendar(t))&&(n=!0)},t.id,this)}return e||this.getCalendar()},addCalendar:function(t){if(!(t instanceof a)){var e=t.id;(t=this.createCalendar(t)).id=e}var i=this.$gantt.config;return t.id=t.id||n.uid(),this._calendars[t.id]=t,i.worktimes||(i.worktimes={}),i.worktimes[t.id]=t.worktime,t.id},deleteCalendar:function(t){var e=this.$gantt.config;return!!t&&(!!this._calendars[t]&&(delete this._calendars[t],e.worktimes&&e.worktimes[t]&&delete e.worktimes[t],!0))},restoreConfigCalendars:function(t){for(var e in t)if(!this._calendars[e]){var i=t[e],n=this.createCalendar(i);n.id=e,this.addCalendar(n)}},defaults:{global:{id:"global",worktime:{hours:[8,17],days:[0,1,1,1,1,1,0]}},fulltime:{id:"fulltime",worktime:{hours:[0,24],days:[1,1,1,1,1,1,1]}}},createDefaultCalendars:function(){var t=this.$gantt.config;this.restoreConfigCalendars(this.defaults),this.restoreConfigCalendars(t.worktimes)}},t.exports=o},function(t,e,i){var n=i(72),r=i(67),a=i(65),o=i(0);t.exports=function(t){var e=new n(t),i=new r(e),s=a.create(e,i);o.mixin(t,s)}},function(t,e,i){var n=i(2);t.exports=function(t){function e(e){throw t.assert(!1,"Can't parse data: incorrect value of gantt.parse or gantt.load method. Actual argument value: "+JSON.stringify(e)),new Error("Invalid argument for gantt.parse or gantt.load. An object or a JSON string of format https://docs.dhtmlx.com/gantt/desktop__supported_data_formats.html#json is expected. Actual argument value: "+JSON.stringify(e))}t.load=function(e,i,n){this._load_url=e,this.assert(arguments.length,"Invalid load arguments");var r="json",a=null;return arguments.length>=3?(r=i,a=n):"string"==typeof arguments[1]?r=arguments[1]:"function"==typeof arguments[1]&&(a=arguments[1]),this._load_type=r,this.callEvent("onLoadStart",[e,r]),this.ajax.get(e,t.bind(function(t){this.on_load(t,r),this.callEvent("onLoadEnd",[e,r]),"function"==typeof a&&a.call(this)},this))},t.parse=function(t,e){this.on_load({xmlDoc:{responseText:t}},e)},t.serialize=function(t){return this[t=t||"json"].serialize()},t.on_load=function(t,e){if(t.xmlDoc&&404===t.xmlDoc.status)this.assert(!1,"Failed to load the data from <a href='"+t.xmlDoc.responseURL+"' target='_blank'>"+t.xmlDoc.responseURL+"</a>, server returns 404");else{this.callEvent("onBeforeParse",[]),e||(e="json"),this.assert(this[e],"Invalid data type:'"+e+"'");var i=t.xmlDoc.responseText,n=this[e].parse(i,t);this._process_loading(n)}},t._process_loading=function(t){t.collections&&this._load_collections(t.collections),this.$data.tasksStore.parse(t.data);var e=t.links||(t.collections?t.collections.links:[]);if(this.$data.linksStore.parse(e),this.callEvent("onParse",[]),this.render(),this.config.initial_scroll){var i=this.getTaskByIndex(0),n=i?i.id:this.config.root_id;this.isTaskExists(n)&&this.showTask(n)}},t._load_collections=function(t){var e=!1;for(var i in t)if(t.hasOwnProperty(i)){e=!0;var n=t[i],r=this.serverList[i];if(!r)continue;r.splice(0,r.length);for(var a=0;a<n.length;a++){var o=n[a],s=this.copy(o);for(var l in s.key=s.value,o)if(o.hasOwnProperty(l)){if("value"==l||"label"==l)continue;s[l]=o[l]}r.push(s)}}e&&this.callEvent("onOptionsLoad",[])},t.attachEvent("onBeforeTaskDisplay",function(t,e){return!e.$ignore}),t.json={parse:function(i){if(i||e(i),"string"==typeof i)if(window.JSON)try{i=JSON.parse(i)}catch(t){e(i)}else t.assert(!1,"JSON is not supported");return i.data||e(i),i.dhx_security&&(t.security_key=i.dhx_security),i},serializeTask:function(t){return this._copyObject(t)},serializeLink:function(t){return this._copyLink(t)},_copyLink:function(t){var e={};for(var i in t)e[i]=t[i];return e},_copyObject:function(e){var i={};for(var r in e)"$"!=r.charAt(0)&&(i[r]=e[r],n.isDate(i[r])&&(i[r]=t.templates.xml_format!==t.templates.formate_date?t.templates.xml_format(i[r]):t.templates.formate_date(i[r])));return i},serialize:function(){var e=[],i=[];t.eachTask(function(i){t.resetProjectDates(i),e.push(this.serializeTask(i))},t.config.root_id,this);for(var n=t.getLinks(),r=0;r<n.length;r++)i.push(this.serializeLink(n[r]));return{data:e,links:i}}},t.xml={_xmlNodeToJSON:function(t,e){for(var i={},n=0;n<t.attributes.length;n++)i[t.attributes[n].name]=t.attributes[n].value;if(!e){for(n=0;n<t.childNodes.length;n++){var r=t.childNodes[n];1==r.nodeType&&(i[r.tagName]=r.firstChild?r.firstChild.nodeValue:"")}i.text||(i.text=t.firstChild?t.firstChild.nodeValue:"")}return i},_getCollections:function(e){for(var i={},n=t.ajax.xpath("//coll_options",e),r=0;r<n.length;r++)for(var a=i[n[r].getAttribute("for")]=[],o=t.ajax.xpath(".//item",n[r]),s=0;s<o.length;s++){for(var l=o[s].attributes,c={key:o[s].getAttribute("value"),label:o[s].getAttribute("label")},u=0;u<l.length;u++){var d=l[u];"value"!=d.nodeName&&"label"!=d.nodeName&&(c[d.nodeName]=d.nodeValue)}a.push(c)}return i},_getXML:function(e,i,n){n=n||"data",i.getXMLTopNode||(i=t.ajax.parse(i));var r=t.ajax.xmltop(n,i.xmlDoc);r&&r.tagName==n||function(e){throw t.assert(!1,"Can't parse data: incorrect value of gantt.parse or gantt.load method. Actual argument value: "+JSON.stringify(e)),new Error("Invalid argument for gantt.parse or gantt.load. An XML of format https://docs.dhtmlx.com/gantt/desktop__supported_data_formats.html#xmldhtmlxgantt20 is expected. Actual argument value: "+JSON.stringify(e))}(e);var a=r.getAttribute("dhx_security");return a&&(t.security_key=a),r},parse:function(e,i){i=this._getXML(e,i);for(var n={},r=n.data=[],a=t.ajax.xpath("//task",i),o=0;o<a.length;o++)r[o]=this._xmlNodeToJSON(a[o]);return n.collections=this._getCollections(i),n},_copyLink:function(t){return"<item id='"+t.id+"' source='"+t.source+"' target='"+t.target+"' type='"+t.type+"' />"},_copyObject:function(t){return"<task id='"+t.id+"' parent='"+(t.parent||"")+"' start_date='"+t.start_date+"' duration='"+t.duration+"' open='"+!!t.open+"' progress='"+t.progress+"' end_date='"+t.end_date+"'><![CDATA["+t.text+"]]></task>"},serialize:function(){for(var e=[],i=[],n=t.json.serialize(),r=0,a=n.data.length;r<a;r++)e.push(this._copyObject(n.data[r]));for(r=0,a=n.links.length;r<a;r++)i.push(this._copyLink(n.links[r]));return"<data>"+e.join("")+"<coll_options for='links'>"+i.join("")+"</coll_options></data>"}},t.oldxml={parse:function(e,i){i=t.xml._getXML(e,i,"projects");for(var n={collections:{links:[]}},r=n.data=[],a=t.ajax.xpath("//task",i),o=0;o<a.length;o++){r[o]=t.xml._xmlNodeToJSON(a[o]);var s=a[o].parentNode;"project"==s.tagName?r[o].parent="project-"+s.getAttribute("id"):r[o].parent=s.parentNode.getAttribute("id")}a=t.ajax.xpath("//project",i);for(o=0;o<a.length;o++){(l=t.xml._xmlNodeToJSON(a[o],!0)).id="project-"+l.id,r.push(l)}for(o=0;o<r.length;o++){var l;(l=r[o]).start_date=l.startdate||l.est,l.end_date=l.enddate,l.text=l.name,l.duration=l.duration/8,l.open=1,l.duration||l.end_date||(l.duration=1),l.predecessortasks&&n.collections.links.push({target:l.id,source:l.predecessortasks,type:t.config.links.finish_to_start})}return n},serialize:function(){t.message("Serialization to 'old XML' is not implemented")}},t.serverList=function(t,e){return e?this.serverList[t]=e.slice(0):this.serverList[t]||(this.serverList[t]=[]),this.serverList[t]}}},function(t,e){t.exports=function(t){t.isReadonly=function(t){return(!t||!t[this.config.editable_property])&&(t&&t[this.config.readonly_property]||this.config.readonly)}}},function(t,e){t.exports=function(t){var e=new RegExp("<(?:.|\n)*?>","gm"),i=new RegExp(" +","gm");function n(t){return(t+"").replace(e," ").replace(i," ")}var r=new RegExp("'","gm");function a(t){return(t+"").replace(r,"&#39;")}for(var o in t._waiAria={getAttributeString:function(t){var e=[" "];for(var i in t){var r=a(n(t[i]));e.push(i+"='"+r+"'")}return e.push(" "),e.join(" ")},getTimelineCellAttr:function(e){return t._waiAria.getAttributeString({"aria-label":e})},_taskCommonAttr:function(e,i){e.start_date&&e.end_date&&(i.setAttribute("aria-label",n(t.templates.tooltip_text(e.start_date,e.end_date,e))),e.$dataprocessor_class&&i.setAttribute("aria-busy",!0),i.setAttribute("aria-selected",t.isSelectedTask(e.id)?"true":"false"))},setTaskBarAttr:function(e,i){this._taskCommonAttr(e,i),!t.isReadonly(e)&&t.config.drag_move&&(e.id!=t.getState().drag_id?i.setAttribute("aria-grabbed",!1):i.setAttribute("aria-grabbed",!0))},taskRowAttr:function(e,i){this._taskCommonAttr(e,i),!t.isReadonly(e)&&t.config.order_branch&&i.setAttribute("aria-grabbed",!1),i.setAttribute("role","row"),i.setAttribute("aria-level",e.$level),t.hasChild(e.id)&&i.setAttribute("aria-expanded",e.$open?"true":"false")},linkAttr:function(e,i){var r=t.config.links,a=e.type==r.finish_to_start||e.type==r.start_to_start,o=e.type==r.start_to_start||e.type==r.start_to_finish,s=t.locale.labels.link+" "+t.templates.drag_link(e.source,o,e.target,a);i.setAttribute("aria-label",n(s)),t.isReadonly(e)&&i.setAttribute("aria-readonly",!0)},gridSeparatorAttr:function(t){t.setAttribute("role","separator")},lightboxHiddenAttr:function(t){t.setAttribute("aria-hidden","true")},lightboxVisibleAttr:function(t){t.setAttribute("aria-hidden","false")},lightboxAttr:function(t){t.setAttribute("role","dialog"),t.setAttribute("aria-hidden","true"),t.firstChild.setAttribute("role","heading")},lightboxButtonAttrString:function(e){return this.getAttributeString({role:"button","aria-label":t.locale.labels[e],tabindex:"0"})},lightboxHeader:function(t,e){t.setAttribute("aria-label",e)},lightboxSelectAttrString:function(e){var i="";switch(e){case"%Y":i=t.locale.labels.years;break;case"%m":i=t.locale.labels.months;break;case"%d":i=t.locale.labels.days;break;case"%H:%i":i=t.locale.labels.hours+t.locale.labels.minutes}return t._waiAria.getAttributeString({"aria-label":i})},lightboxDurationInputAttrString:function(e){return this.getAttributeString({"aria-label":t.locale.labels.column_duration,"aria-valuemin":"0"})},gridAttrString:function(){return[" role='treegrid'",t.config.multiselect?"aria-multiselectable='true'":"aria-multiselectable='false'"," "].join(" ")},gridScaleRowAttrString:function(){return"role='row'"},gridScaleCellAttrString:function(e,i){var n="";if("add"==e.name)n=this.getAttributeString({role:"button","aria-label":t.locale.labels.new_task});else{var r={role:"columnheader","aria-label":i};t._sort&&t._sort.name==e.name&&("asc"==t._sort.direction?r["aria-sort"]="ascending":r["aria-sort"]="descending"),n=this.getAttributeString(r)}return n},gridDataAttrString:function(){return"role='rowgroup'"},gridCellAttrString:function(e,i,n){var r={role:"gridcell","aria-label":i};return e.editor&&!t.isReadonly(n)||(r["aria-readonly"]=!0),this.getAttributeString(r)},gridAddButtonAttrString:function(e){return this.getAttributeString({role:"button","aria-label":t.locale.labels.new_task})},messageButtonAttrString:function(t){return"tabindex='0' role='button' aria-label='"+t+"'"},messageInfoAttr:function(t){t.setAttribute("role","alert")},messageModalAttr:function(t,e){t.setAttribute("role","dialog"),e&&t.setAttribute("aria-labelledby",e)},quickInfoAttr:function(t){t.setAttribute("role","dialog")},quickInfoHeaderAttrString:function(){return" role='heading' "},quickInfoHeader:function(t,e){t.setAttribute("aria-label",e)},quickInfoButtonAttrString:function(e){return t._waiAria.getAttributeString({role:"button","aria-label":e,tabindex:"0"})},tooltipAttr:function(t){t.setAttribute("role","tooltip")},tooltipVisibleAttr:function(t){t.setAttribute("aria-hidden","false")},tooltipHiddenAttr:function(t){t.setAttribute("aria-hidden","true")}},t._waiAria)t._waiAria[o]=function(e){return function(){return t.config.wai_aria_attributes?e.apply(this,arguments):""}}(t._waiAria[o])}},function(t,e){t.exports=function(t){t.getGridColumn=function(e){for(var i=t.config.columns,n=0;n<i.length;n++)if(i[n].name==e)return i[n];return null},t.getGridColumns=function(){return t.config.columns.slice()}}},function(t,e){t.exports=function(t){}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(9),r=i(4),a=["ctrlKey","altKey","shiftKey","metaKey"],o=[[{unit:"month",date:"%M",step:1},{unit:"day",date:"%d",step:1}],[{unit:"day",date:"%d %M",step:1}],[{unit:"day",date:"%d %M",step:1},{unit:"hour",date:"%H:00",step:8}],[{unit:"day",date:"%d %M",step:1},{unit:"hour",date:"%H:00",step:1}]],s=function(){function t(t){var e=this;this.zoomIn=function(){var t=e.getCurrentLevel()-1;t<0||e.setLevel(t)},this.zoomOut=function(){var t=e.getCurrentLevel()+1;t>e._levels.length-1||e.setLevel(t)},this.getCurrentLevel=function(){return e._activeLevelIndex},this.getLevels=function(){return e._levels},this.setLevel=function(t){var i=e._getZoomIndexByName(t);-1===i&&e.$gantt.assert(-1!==i,"Invalid zoom level for gantt.ext.zoom.setLevel. "+t+" is not an expected value."),e._setLevel(i,0)},this._getZoomIndexByName=function(t){var i=-1;if("string"==typeof t){if(!isNaN(Number(t))&&e._levels[Number(t)])i=Number(t);else for(var n=0;n<e._levels.length;n++)if(e._levels[n].name===t){i=n;break}}else i=t;return i},this._getVisibleDate=function(){var t=e.$gantt.getScrollState().x,i=e.$gantt.$task.offsetWidth;e._visibleDate=e.$gantt.dateFromPos(t+i/2)},this._setLevel=function(t,i){e._activeLevelIndex=t;var n=e.$gantt,r=n.copy(e._levels[e._activeLevelIndex]),a=n.copy(r);if(delete a.name,n.mixin(n.config,a,!0),!!n.$root){if(i){var o=e.$gantt.dateFromPos(i+e.$gantt.getScrollState().x);e.$gantt.render();var s=e.$gantt.posFromDate(o);e.$gantt.scrollTo(s-i)}else{var l=e.$gantt.$task.offsetWidth;e._visibleDate||e._getVisibleDate();var c=e._visibleDate;e.$gantt.render();s=e.$gantt.posFromDate(c);e.$gantt.scrollTo(s-l/2)}e.callEvent("onAfterZoom",[e._activeLevelIndex,r])}},this._attachWheelEvent=function(t){var i,r=n.isFF?"wheel":"mousewheel";(i="function"==typeof t.element?t.element():t.element)&&e._domEvents.attach(i,r,e.$gantt.bind(function(t){if(this._useKey){if(a.indexOf(this._useKey)<0)return!1;if(!t[this._useKey])return!1}if("function"==typeof this._handler)return this._handler.apply(this,[t]),!0},e))},this._defaultHandler=function(t){var i=e.$gantt.$task.getBoundingClientRect().x,n=t.clientX-i,r=!1;(e.$gantt.env.isFF?-40*t.deltaY:t.wheelDelta)>0&&(r=!0),t.preventDefault(),t.stopPropagation(),e._setScaleSettings(r,n)},this._setScaleDates=function(){e._initialStartDate&&e._initialEndDate&&(e.$gantt.config.start_date=e._initialStartDate,e.$gantt.config.end_date=e._initialEndDate)},this.$gantt=t,this._domEvents=this.$gantt._createDomEventScope()}return t.prototype.init=function(t){var e=this;this._initialStartDate=t.startDate,this._initialEndDate=t.endDate,this._activeLevelIndex=t.activeLevelIndex?t.activeLevelIndex:0,this._levels=this._mapScales(t.levels||o),this._handler=t.handler||this._defaultHandler,this._minColumnWidth=t.minColumnWidth||60,this._maxColumnWidth=t.maxColumnWidth||240,this._widthStep=t.widthStep||3/8*t.minColumnWidth,this._useKey=t.useKey,this._initialized||(r(this),this.$gantt.attachEvent("onGanttScroll",function(){e._getVisibleDate()})),this._domEvents.detachAll(),"wheel"===t.trigger&&(this.$gantt.$root?this._attachWheelEvent(t):this.$gantt.attachEvent("onGanttReady",function(){e._attachWheelEvent(t)})),this._initialized=!0,this.setLevel(this._activeLevelIndex)},t.prototype._mapScales=function(t){return t.map(function(t){return Array.isArray(t)?{scales:t}:t})},t.prototype._setScaleSettings=function(t,e){t?this._stepUp(e):this._stepDown(e)},t.prototype._stepUp=function(t){if(!(this._activeLevelIndex>=this._levels.length-1)){var e=this._activeLevelIndex;if(this._setScaleDates(),this._widthStep){var i=this.$gantt.config.min_column_width+this._widthStep;i>this._maxColumnWidth&&(i=this._minColumnWidth,e++),this.$gantt.config.min_column_width=i}else e++;this._setLevel(e,t)}},t.prototype._stepDown=function(t){if(!(this._activeLevelIndex<1)){var e=this._activeLevelIndex;if(this._setScaleDates(),this._widthStep){var i=this.$gantt.config.min_column_width-this._widthStep;i<this._minColumnWidth&&(i=this._maxColumnWidth,e--),this.$gantt.config.min_column_width=i}else e--;this._setLevel(e,t)}},t}();e.default=s},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=function(){function t(t){var e=this;this.format=function(t){return e._getWBSCode(t.source)},this.canParse=function(t){return e._linkReg.test(t)},this.parse=function(t){if(!e.canParse(t))return null;var i=e._linkReg.exec(t)[0].trim();return{id:void 0,source:e._findSource(i)||null,target:null,type:e._gantt.config.links.finish_to_start,lag:0}},this._getWBSCode=function(t){var i=e._gantt.getTask(t);return e._gantt.getWBSCode(i)},this._findSource=function(t){var i=new RegExp("^[0-9.]+","i");if(i.exec(t)){var n=i.exec(t)[0],r=e._gantt.getTaskByWBSCode(n);if(r)return r.id}return null},this._linkReg=/^[0-9\.]+/,this._gantt=t}return t.create=function(e,i){return void 0===e&&(e=null),new t(i)},t}();e.default=n},function(t,e,i){var n=i(22).default,r=i(80).default;t.exports=function(t){t.ext.formatters={durationFormatter:function(e){return e||(e={}),e.store||(e.store=t.config.duration_unit),e.enter||(e.enter=t.config.duration_unit),n.create(e,t)},linkFormatter:function(e){return r.create(e,t)}}}},function(t,e){t.exports=function(t){function e(e){return function(){return!t.config.auto_types||t.getTaskType(t.config.types.project)!=t.config.types.project||e.apply(this,arguments)}}function i(e){t.batchUpdate(function(){!function e(i){!function(e){e=e.id||e;var i=t.getTask(e),n=a(i);!1!==n&&r(i,n)}(i);var n=t.getParent(i);n!=t.config.root_id&&e(n)}(e)})}var n;function r(e,i){t.getState().group_mode||(e.type=i,t.updateTask(e.id))}function a(e){var i=t.config.types,n=t.hasChild(e.id),r=t.getTaskType(e.type);return n&&r===i.task?i.project:!n&&r===i.project&&i.task}var o,s,l=!0;function c(e){e!=t.config.root_id&&t.isTaskExists(e)&&i(e)}t.attachEvent("onParse",e(function(){l=!1,t.batchUpdate(function(){t.eachTask(function(t){var e=a(t);!1!==e&&r(t,e)})}),l=!0})),t.attachEvent("onAfterTaskAdd",e(function(t){l&&i(t)})),t.attachEvent("onAfterTaskUpdate",e(function(t){l&&i(t)})),t.attachEvent("onBeforeTaskDelete",e(function(e,i){return n=t.getParent(e),!0})),t.attachEvent("onAfterTaskDelete",e(function(t,e){c(n)})),t.attachEvent("onRowDragStart",e(function(e,i,n){return o=t.getParent(e),!0})),t.attachEvent("onRowDragEnd",e(function(t,e){c(o),i(t)})),t.attachEvent("onBeforeTaskMove",e(function(e,i,n){return s=t.getParent(e),!0})),t.attachEvent("onAfterTaskMove",e(function(t,e,n){document.querySelector(".gantt_drag_marker")||(c(s),i(t))}))}},function(t,e){t.exports=function(t){function e(e){return function(){return!t.config.placeholder_task||e.apply(this,arguments)}}function i(){var e=t.getTaskBy("type",t.config.types.placeholder);if(!e.length||!t.isTaskExists(e[0].id)){var i={unscheduled:!0,type:t.config.types.placeholder,duration:0,text:t.locale.labels.new_task};if(!1===t.callEvent("onTaskCreated",[i]))return;t.addTask(i)}}function n(e){var i=t.getTask(e);i.type==t.config.types.placeholder&&(i.start_date&&i.end_date&&i.unscheduled&&(i.unscheduled=!1),t.batchUpdate(function(){var e=t.copy(i);t.silent(function(){t.deleteTask(i.id)}),delete e["!nativeeditor_status"],e.type=t.config.types.task,e.id=t.uid(),t.addTask(e)}))}t.config.types.placeholder="placeholder",t.attachEvent("onDataProcessorReady",e(function(i){i&&!i._silencedPlaceholder&&(i._silencedPlaceholder=!0,i.attachEvent("onBeforeUpdate",e(function(e,n,r){return r.type!=t.config.types.placeholder||(i.setUpdated(e,!1),!1)})))}));var r=!1;function a(e){if(t.config.types.placeholder&&t.isTaskExists(e)&&t.getTask(e).type==t.config.types.placeholder)return!0;return!1}function o(t){return!(!a(t.source)&&!a(t.target))}t.attachEvent("onGanttReady",function(){r||(r=!0,t.attachEvent("onAfterTaskUpdate",e(n)),t.attachEvent("onAfterTaskAdd",e(function(e,n){n.type!=t.config.types.placeholder&&(t.getTaskBy("type",t.config.types.placeholder).forEach(function(e){t.silent(function(){t.isTaskExists(e.id)&&t.deleteTask(e.id)})}),i())})),t.attachEvent("onParse",e(i)))}),t.attachEvent("onLinkValidation",function(t){return!o(t)}),t.attachEvent("onBeforeLinkAdd",function(t,e){return!o(e)}),t.attachEvent("onBeforeUndoStack",function(e){for(var i=0;i<e.commands.length;i++){var n=e.commands[i];"task"===n.entity&&n.value.type===t.config.types.placeholder&&(e.commands.splice(i,1),i--)}return!0})}},function(t,e,i){var n=i(2),r=i(28),a=i(7),o=i(27);function s(t){var e={};function i(e,i){return"function"==typeof e?function(e){var i=[];return t.eachTask(function(t){e(t)&&i.push(t)}),i}(e):n.isArray(i)?c(e,i):c(e,[i])}t.$data.tasksStore.attachEvent("onStoreUpdated",function(){e={}});var s=String(Math.random());function l(t){return null===t?s+String(t):String(t)}function c(i,r){var a,o=r.join("_")+"_"+i,s={};return n.forEach(r,function(t){s[l(t)]=!0}),e[o]?a=e[o]:(a=e[o]=[],t.eachTask(function(e){var r;e.type!=t.config.types.project&&(i in e&&(r=n.isArray(e[i])?e[i]:[e[i]],n.forEach(r,function(t){(s[l(t)]||t&&s[l(t.resource_id)])&&a.push(e)})))})),a}function u(n,r,a,o){var s=n.id+"_"+r+"_"+a.unit+"_"+a.step;return e[s]?e[s]:e[s]=function(e,n,r,a){p="task"==e.$role?[]:i(n,e.id);for(var o=r.unit,s=r.step,l={},c=0;c<p.length;c++)for(var u=p[c],d=t.date[o+"_start"](new Date(u.start_date));d<u.end_date;){var h=d;if(d=t.date.add(d,s,o),t.isWorkTime({date:h,task:u,unit:o})){var f=h.valueOf();l[f]||(l[f]=[]),l[f].push(u)}}for(var _,g,p,v=[],m=a.$getConfig(),c=0;c<r.trace_x.length;c++)_=new Date(r.trace_x[c]),g=t.date.add(_,s,o),(p=l[_.valueOf()]||[]).length||m.resource_render_empty_cells?v.push({start_date:_,end_date:g,tasks:p}):v.push(null);return v}(n,r,a,o)}function d(t,e,i,n){var r=100*(1-(1*t||0)),a=n.posFromDate(e),o=n.posFromDate(i),s=document.createElement("div");return s.className="gantt_histogram_hor_bar",s.style.top=r+"%",s.style.left=a+"px",s.style.width=o-a+1+"px",s}function h(t,e,i){if(t===e)return null;var n=1-Math.max(t,e),r=Math.abs(t-e),a=document.createElement("div");return a.className="gantt_histogram_vert_bar",a.style.top=100*n+"%",a.style.height=100*r+"%",a.style.left=i+"px",a}function f(t,e,i){var n=e.width[t],r=e.left[t]-n,a=e.left[t]+n;return n>0&&r<=i.x_end&&a>=i.x}function _(e,i,n){var r=t.config.resource_property,a=[];if(t.getDatastore("task").exists(i)){var o=t.getTask(i);a=o[r]||[]}Array.isArray(a)||(a=[a]);for(var s=0;s<a.length;s++)a[s].resource_id==e&&n.push({task_id:o.id,resource_id:a[s].resource_id,value:a[s].value})}return{renderLine:function(){var t={};function e(t,e,i,n,r){var a=i.resource_cell_class(e.start_date,e.end_date,t,e.tasks),o=i.resource_cell_value(e.start_date,e.end_date,t,e.tasks);if(a||o){var s=r.getItemPosition(t,e.start_date,e.end_date),l=document.createElement("div");return l.className=["gantt_resource_marker",a].join(" "),l.style.cssText=["left:"+s.left+"px","width:"+s.width+"px","height:"+(n.row_height-1)+"px","line-height:"+(n.row_height-1)+"px","top:"+s.top+"px"].join(";"),o&&(l.innerHTML=o),l}return null}function i(e,i){t[e]&&t[e][i]&&t[e][i].parentNode&&t[e][i].parentNode.removeChild(t[e][i])}return{render:function(i,n,r){var a=n.$getConfig(),s=n.$getTemplates(),l=n.getScale(),c=u(i,a.resource_property,n.getScale(),n),d=!!r,h=[];t[i.id]={};for(var _=o(l,r),g=_.start;g<=_.end;g++){var p=c[g];if(p&&(!d||f(g,l,r))){var v=e(i,p,s,a,n);v&&(h.push(v),t[i.id][g]=v)}}var m=null;if(h.length){m=document.createElement("div");for(var y=0;y<h.length;y++)m.appendChild(h[y])}return m},update:function(n,r,a,s){var l=a.$getConfig(),c=a.$getTemplates(),d=a.getScale(),h=u(n,l.resource_property,a.getScale(),a),_=o(d,s),g={};if(t&&t[n.id])for(var p in t[n.id])g[p]=p;for(var v=_.start;v<=_.end;v++){var m=h[v];if(g[v]=!1,m)if(f(v,d,s))if(t[n.id]&&t[n.id][v])t[n.id]&&t[n.id][v]&&!t[n.id][v].parentNode&&r.appendChild(t[n.id][v]);else{var y=e(n,m,c,l,a);y&&(r.appendChild(y),t[n.id][v]=y)}else i(n.id,v)}for(var p in g)!1!==g[p]&&i(n.id,p)},getRectangle:r,getVisibleRange:a}},renderHistogram:function(){var e={},i={},n={};function s(t,i){var n=e[t];n&&n[i]&&n[i].parentNode&&n[i].parentNode.removeChild(n[i])}function l(e,i,r,a,s,l,c){var u=n[e.id];u&&u.parentNode&&u.parentNode.removeChild(u);var f=function(e,i,n,r){for(var a=i.getScale(),s=document.createElement("div"),l=o(a,r),c=l.start;c<=l.end;c++){var u=a.trace_x[c],f=a.trace_x[c+1]||t.date.add(u,a.step,a.unit),_=a.trace_x[c].valueOf(),g=Math.min(e[_]/n,1)||0;if(g<0)return null;var p=Math.min(e[f.valueOf()]/n,1)||0,v=d(g,u,f,i);v&&s.appendChild(v);var m=h(g,p,i.posFromDate(f));m&&s.appendChild(m)}return s}(r,s,l,c);return f&&(f.setAttribute("data-resource-id",e.id),f.style.position="absolute",f.style.top=i.top+1+"px",f.style.height=a.row_height-1+"px",f.style.left=0),f}function c(t,e,i,n,r,a){var o=r.histogram_cell_class(a.start_date,a.end_date,t,a.tasks),s=r.histogram_cell_label(a.start_date,a.end_date,t,a.tasks),l=r.histogram_cell_allocated(a.start_date,a.end_date,t,a.tasks);if(o||s){var c=document.createElement("div");return c.className=["gantt_histogram_cell",o].join(" "),c.style.cssText=["left:"+e.left+"px","width:"+e.width+"px","height:"+(n.row_height-1)+"px","line-height:"+(n.row_height-1)+"px","top:"+(e.top+1)+"px"].join(";"),s&&(s="<div class='gantt_histogram_label'>"+s+"</div>"),l&&(s="<div class='gantt_histogram_fill' style='height:"+100*Math.min(l/i||0,1)+"%;'></div>"+s),s&&(c.innerHTML=s),c}return null}return{render:function(t,r,a){var s=r.$getConfig(),d=r.$getTemplates(),h=r.getScale(),_=u(t,s.resource_property,h,r),g=[],p={},v=t.capacity||r.$config.capacity||24;e[t.id]={},i[t.id]=null,n[t.id]=null;for(var m=!!a,y=o(h,a),b=y.start;b<=y.end;b++){var k=_[b];if(k&&(!m||f(b,h,a))){var w=d.histogram_cell_capacity(k.start_date,k.end_date,t,k.tasks);p[k.start_date.valueOf()]=w||0;var x=r.getItemPosition(t,k.start_date,k.end_date),$=c(t,x,v,s,d,k);$&&(g.push($),e[t.id][b]=$)}}var S=null;if(g.length){S=document.createElement("div");for(var T=0;T<g.length;T++)S.appendChild(g[T]);var C=l(t,x,p,s,r,v,a);C&&(S.appendChild(C),n[t.id]=C),i[t.id]=S}return S},update:function(t,i,r,a){var d=r.$getConfig(),h=r.$getTemplates(),_=r.getScale(),g=u(t,d.resource_property,_,r),p=t.capacity||r.$config.capacity||24,v={},m=!!a,y=o(_,a),b={};if(e&&e[t.id])for(var k in e[t.id])b[k]=k;for(var w=y.start;w<=y.end;w++){var x=g[w];if(b[w]=!1,x){var $=h.histogram_cell_capacity(x.start_date,x.end_date,t,x.tasks);v[x.start_date.valueOf()]=$||0;var S=r.getItemPosition(t,x.start_date,x.end_date);if(!m||f(w,_,a)){var T=e[t.id];if(T&&T[w])T&&T[w]&&!T[w].parentNode&&i.appendChild(T[w]);else{var C=c(t,S,p,d,h,x);C&&(i.appendChild(C),e[t.id][w]=C)}}else s(t.id,w)}}for(var k in b)!1!==b[k]&&s(t.id,k);var E=l(t,S,v,d,r,p,a);E&&(i.appendChild(E),n[t.id]=E)},getRectangle:r,getVisibleRange:a}},filterTasks:i,getResourceAssignments:function(e,i){var n=[],r=t.config.resource_property;return void 0!==i?_(e,i,n):t.getTaskBy(r,e).forEach(function(t){_(e,t.id,n)}),n}}}t.exports=function(t){var e=s(t);t.getTaskBy=e.filterTasks,t.getResourceAssignments=e.getResourceAssignments,t.$ui.layers.resourceRow=e.renderLine,t.$ui.layers.resourceHistogram=e.renderHistogram,t.config.resource_property="owner_id",t.config.resource_store="resource",t.config.resource_render_empty_cells=!1,t.templates.histogram_cell_class=function(t,e,i,n){},t.templates.histogram_cell_label=function(t,e,i,n){return n.length+"/3"},t.templates.histogram_cell_allocated=function(t,e,i,n){return n.length/3},t.templates.histogram_cell_capacity=function(t,e,i,n){return 0},t.templates.resource_cell_class=function(t,e,i,n){return n.length<=1?"gantt_resource_marker_ok":"gantt_resource_marker_overtime"},t.templates.resource_cell_value=function(t,e,i,n){return 8*n.length}}},function(t,e){window.dhtmlx&&(window.dhtmlx.attaches||(window.dhtmlx.attaches={}),window.dhtmlx.attaches.attachGantt=function(t,e,i){var n=document.createElement("DIV");i=i||window.gantt,n.id="gantt_"+i.uid(),n.style.width="100%",n.style.height="100%",n.cmp="grid",document.body.appendChild(n),this.attachObject(n.id),this.dataType="gantt",this.dataObj=i;var r=this.vs[this.av];r.grid=i,i.init(n.id,t,e),n.firstChild.style.border="none",r.gridId=n.id,r.gridObj=n;return this.vs[this._viewRestore()].grid}),void 0!==window.dhtmlXCellObject&&(window.dhtmlXCellObject.prototype.attachGantt=function(t,e,i){i=i||window.gantt;var n=document.createElement("DIV");return n.id="gantt_"+i.uid(),n.style.width="100%",n.style.height="100%",n.cmp="grid",document.body.appendChild(n),this.attachObject(n.id),this.dataType="gantt",this.dataObj=i,i.init(n.id,t,e),n.firstChild.style.border="none",n=null,this.callEvent("_onContentAttach",[]),this.dataObj}),t.exports=null},function(t,e){__webpack_provided_window_dot_jQuery&&function(t){var e=[];t.fn.dhx_gantt=function(i){if("string"!=typeof(i=i||{})){var n=[];return this.each(function(){if(this&&this.getAttribute)if(this.gantt||window.gantt.$root==this)n.push("object"==typeof this.gantt?this.gantt:window.gantt);else{var t=window.gantt.$container&&window.Gantt?window.Gantt.getGanttInstance():window.gantt;for(var e in i)"data"!=e&&(t.config[e]=i[e]);t.init(this),i.data&&t.parse(i.data),n.push(t)}}),1===n.length?n[0]:n}if(e[i])return e[i].apply(this,[]);t.error("Method "+i+" does not exist on jQuery.dhx_gantt")}}(__webpack_provided_window_dot_jQuery),t.exports=null},function(t,e){t.exports=function(t){var e=function(t){return{_needRecalc:!0,reset:function(){this._needRecalc=!0},_isRecalcNeeded:function(){return!this._isGroupSort()&&this._needRecalc},_isGroupSort:function(){return!!t.getState().group_mode},_getWBSCode:function(t){return t?(this._isRecalcNeeded()&&this._calcWBS(),t.$virtual?"":this._isGroupSort()?t.$wbs||"":(t.$wbs||(this.reset(),this._calcWBS()),t.$wbs)):""},_setWBSCode:function(t,e){t.$wbs=e},getWBSCode:function(t){return this._getWBSCode(t)},getByWBSCode:function(e){for(var i=e.split("."),n=t.config.root_id,r=0;r<i.length;r++){var a=t.getChildren(n),o=1*i[r]-1;if(!t.isTaskExists(a[o]))return null;n=a[o]}return t.isTaskExists(n)?t.getTask(n):null},_calcWBS:function(){if(this._isRecalcNeeded()){var e=!0;t.eachTask(function(i){if(e)return e=!1,void this._setWBSCode(i,"1");var n=t.getPrevSibling(i.id);if(null!==n){var r=t.getTask(n).$wbs;r&&((r=r.split("."))[r.length-1]++,this._setWBSCode(i,r.join(".")))}else{var a=t.getParent(i.id);this._setWBSCode(i,t.getTask(a).$wbs+".1")}},t.config.root_id,this),this._needRecalc=!1}}}}(t);function i(){return e.reset(),!0}t.getWBSCode=function(t){return e.getWBSCode(t)},t.getTaskByWBSCode=function(t){return e.getByWBSCode(t)},t.attachEvent("onAfterTaskMove",i),t.attachEvent("onBeforeParse",i),t.attachEvent("onAfterTaskDelete",i),t.attachEvent("onAfterTaskAdd",i),t.attachEvent("onAfterSort",i)}},function(t,e){function i(t){var e={},i=!1;function n(t,i){i="function"==typeof i?i:function(){},e[t]||(e[t]=this[t],this[t]=i)}function r(t){e[t]&&(this[t]=e[t],e[t]=null)}function a(){for(var t in e)r.call(this,t)}function o(t){try{t()}catch(t){window.console.error(t)}}return t.$services.getService("state").registerProvider("batchUpdate",function(){return{batch_update:i}},!1),function(t,e){if(i)o(t);else{var r,s=this._dp&&"off"!=this._dp.updateMode;s&&(r=this._dp.updateMode,this._dp.setUpdateMode("off"));var l={},c={render:!0,refreshData:!0,refreshTask:!0,refreshLink:!0,resetProjectDates:function(t){l[t.id]=t}};for(var u in function(t){for(var e in t)n.call(this,e,t[e])}.call(this,c),i=!0,this.callEvent("onBeforeBatchUpdate",[]),o(t),this.callEvent("onAfterBatchUpdate",[]),a.call(this),l)this.resetProjectDates(l[u]);i=!1,e||this.render(),s&&(this._dp.setUpdateMode(r),this._dp.setGanttMode("task"),this._dp.sendData(),this._dp.setGanttMode("link"),this._dp.sendData())}}}t.exports=function(t){t.batchUpdate=i(t)}},function(t,e,i){var n=i(1);t.exports=function(t){var e=50,i=30,r=10,a=50,o=null,s=!1,l=null,c={started:!1},u={};function d(e){return e&&n.isChildOf(e,t.$root)&&e.offsetHeight}function h(){var e=!!document.querySelector(".gantt_drag_marker"),i=!!document.querySelector(".gantt_drag_marker.gantt_grid_resize_area"),n=!!document.querySelector(".gantt_link_direction"),r=t.getState(),a=r.autoscroll;return s=e&&!i&&!n,!(!r.drag_mode&&!e||i)||a}function f(e){if(l&&(clearTimeout(l),l=null),e){var i=t.config.autoscroll_speed;i&&i<10&&(i=10),l=setTimeout(function(){o=setInterval(p,i||a)},t.config.autoscroll_delay||r)}}function _(t){t?(f(!0),c.started||(c.x=u.x,c.y=u.y,c.started=!0)):(o&&(clearInterval(o),o=null),f(!1),c.started=!1)}function g(e){var i=h();if(!o&&!l||i||_(!1),!t.config.autoscroll||!i)return!1;u={x:e.clientX,y:e.clientY},!o&&i&&_(!0)}function p(){if(!h())return _(!1),!1;var e=n.getNodePosition(d(t.$task)?t.$task:d(t.$grid)?t.$grid:t.$root),r=u.x-e.x,a=u.y-e.y,o=s?0:v(r,e.width,c.x-e.x),l=v(a,e.height,c.y-e.y),f=t.getScrollState(),g=f.y,p=f.inner_height,m=f.height,y=f.x,b=f.inner_width,k=f.width;l&&!p?l=0:l<0&&!g?l=0:l>0&&g+p>=m+2&&(l=0),o&&!b?o=0:o<0&&!y?o=0:o>0&&y+b>=k&&(o=0);var w=t.config.autoscroll_step;w&&w<2&&(w=2),o*=w||i,l*=w||i,(o||l)&&function(e,i){var n=t.getScrollState(),r=null,a=null;e&&(r=n.x+e,r=Math.min(n.width,r),r=Math.max(0,r));i&&(a=n.y+i,a=Math.min(n.height,a),a=Math.max(0,a));t.scrollTo(r,a)}(o,l)}function v(t,i,n){return t-e<0&&t<n?-1:t>i-e&&t>n?1:0}t.attachEvent("onGanttReady",function(){t.eventRemove(document.body,"mousemove",g),t.event(document.body,"mousemove",g)})}},function(t,e,i){t.exports=function(t){t.ext||(t.ext={});for(var e=[i(89),i(88),i(87),i(86),i(85),i(84),i(83),i(82),i(81)],n=0;n<e.length;n++)e[n]&&e[n](t);var r=i(79).default;t.ext.zoom=new r(t)}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(0),r=function(){function t(){var t=this;this.clear=function(){t._storage={}},this.storeItem=function(e){t._storage[e.id]=n.copy(e)},this.getStoredItem=function(e){return t._storage[e]||null},this._storage={}}return t.create=function(){return new t},t}();e.default=r},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=function(t,e){t.getUserData=function(t,e){return this.userdata||(this.userdata={}),this.userdata[t]&&this.userdata[t][e]?this.userdata[t][e]:""},t.setUserData=function(t,e,i){this.userdata||(this.userdata={}),this.userdata[t]||(this.userdata[t]={}),this.userdata[t][e]=i},t._change_id=function(t,e){"task"!==this._dp._ganttMode?this.changeLinkId(t,e):this.changeTaskId(t,e)},t._row_style=function(e,i){"task"===this._dp._ganttMode&&t.isTaskExists(e)&&(t.getTask(e).$dataprocessor_class=i,t.refreshTask(e))},t._delete_task=function(t,e){},t._sendTaskOrder=function(t,e){e.$drop_target&&(this._dp.setGanttMode("task"),this.getTask(t).target=e.$drop_target,this._dp.setUpdated(t,!0,"order"),delete this.getTask(t).$drop_target)},t.setDp=function(){this._dp=e},t.setDp()}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(2),r=function(){function t(t,e){this.$gantt=t,this.$dp=e,this._dataProcessorHandlers=[]}return t.prototype.attach=function(){var t=this.$dp,e=this.$gantt,n=i(23),r={};function a(i){for(var n=t.updatedRows.slice(),r=!1,a=0;a<n.length&&!t._in_progress[i];a++)n[a]===i&&("inserted"===e.getUserData(i,"!nativeeditor_status")&&(r=!0),t.setUpdated(i,!1));return r}this._dataProcessorHandlers.push(e.attachEvent("onAfterTaskAdd",function(i,n){e.isTaskExists(i)&&(t.setGanttMode("tasks"),t.setUpdated(i,!0,"inserted"))})),this._dataProcessorHandlers.push(e.attachEvent("onAfterTaskUpdate",function(i,n){e.isTaskExists(i)&&(t.setGanttMode("tasks"),t.setUpdated(i,!0),e._sendTaskOrder&&e._sendTaskOrder(i,n))})),this._dataProcessorHandlers.push(e.attachEvent("onBeforeTaskDelete",function(t,i){return!e.config.cascade_delete||(r[t]={tasks:n.getSubtreeTasks(e,t),links:n.getSubtreeLinks(e,t)},!0)})),this._dataProcessorHandlers.push(e.attachEvent("onAfterTaskDelete",function(i,n){if(t.setGanttMode("tasks"),!a(i)){if(e.config.cascade_delete&&r[i]){var o=t.updateMode;t.setUpdateMode("off");var s=r[i];for(var l in s.tasks)a(l)||(t.storeItem(s.tasks[l]),t.setUpdated(l,!0,"deleted"));for(var l in t.setGanttMode("links"),s.links)a(l)||(t.storeItem(s.links[l]),t.setUpdated(l,!0,"deleted"));r[i]=null,"off"!==o&&t.sendAllData(),t.setGanttMode("tasks"),t.setUpdateMode(o)}t.storeItem(n),t.setUpdated(i,!0,"deleted"),"off"===t.updateMode||t._tSend||t.sendAllData()}})),this._dataProcessorHandlers.push(e.attachEvent("onAfterLinkUpdate",function(i,n){e.isLinkExists(i)&&(t.setGanttMode("links"),t.setUpdated(i,!0))})),this._dataProcessorHandlers.push(e.attachEvent("onAfterLinkAdd",function(i,n){e.isLinkExists(i)&&(t.setGanttMode("links"),t.setUpdated(i,!0,"inserted"))})),this._dataProcessorHandlers.push(e.attachEvent("onAfterLinkDelete",function(e,i){t.setGanttMode("links"),!a(e)&&(t.storeItem(i),t.setUpdated(e,!0,"deleted"))})),this._dataProcessorHandlers.push(e.attachEvent("onRowDragEnd",function(t,i){e._sendTaskOrder(t,e.getTask(t))}));var o=null,s=null;this._dataProcessorHandlers.push(e.attachEvent("onTaskIdChange",function(i,n){if(t._waitMode){var r=e.getChildren(n);if(r.length){o=o||{};for(var a=0;a<r.length;a++){var l=this.getTask(r[a]);o[l.id]=l}}var c=function(t){var e=[];return t.$source&&(e=e.concat(t.$source)),t.$target&&(e=e.concat(t.$target)),e}(this.getTask(n));if(c.length){s=s||{};for(a=0;a<c.length;a++){var u=this.getLink(c[a]);s[u.id]=u}}}})),t.attachEvent("onAfterUpdateFinish",function(){(o||s)&&(e.batchUpdate(function(){for(var t in o)e.updateTask(o[t].id);for(var t in s)e.updateLink(s[t].id);o=null,s=null}),o?e._dp.setGanttMode("tasks"):e._dp.setGanttMode("links"))}),t.attachEvent("onBeforeDataSending",function(){if("CUSTOM"===this._tMode)return!0;var t=this._serverProcessor;if("REST-JSON"===this._tMode||"REST"===this._tMode){var i=this._ganttMode;t=t.substring(0,t.indexOf("?")>-1?t.indexOf("?"):t.length),this.serverProcessor=t+("/"===t.slice(-1)?"":"/")+i}else{var n=this._ganttMode+"s";this.serverProcessor=t+e.ajax.urlSeparator(t)+"gantt_mode="+n}return!0}),t.attachEvent("insertCallback",function(t,i,n,r){var a=t.data||e.xml._xmlNodeToJSON(t.firstChild),o={add:e.addTask,isExist:e.isTaskExists};"links"===r&&(o.add=e.addLink,o.isExist=e.isLinkExists),o.isExist.call(e,i)||(a.id=i,o.add.call(e,a))}),t.attachEvent("updateCallback",function(t,i){var n=t.data||e.xml._xmlNodeToJSON(t.firstChild);if(e.isTaskExists(i)){var r=e.getTask(i);for(var a in n){var o=n[a];switch(a){case"id":continue;case"start_date":case"end_date":o=e.templates.xml_date!==e.templates.parse_date?e.templates.xml_date(o):e.templates.parse_date(o);break;case"duration":r.end_date=e.calculateEndDate({start_date:r.start_date,duration:o,task:r})}r[a]=o}e.updateTask(i),e.refreshData()}}),t.attachEvent("deleteCallback",function(t,i,n,r){var a={delete:e.deleteTask,isExist:e.isTaskExists};"links"===r&&(a.delete=e.deleteLink,a.isExist=e.isLinkExists),a.isExist.call(e,i)&&a.delete.call(e,i)})},t.prototype.detach=function(){var t=this;n.forEach(this._dataProcessorHandlers,function(e){t.$gantt.detachEvent(e)}),this._dataProcessorHandlers=[]},t}();e.default=r},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(4),r=i(2),a=i(0),o=i(93),s=i(92),l=i(91);e.createDataProcessor=function(t){var e,i;t instanceof Function?e=t:t.hasOwnProperty("router")?e=t.router:t.hasOwnProperty("link")&&t.hasOwnProperty("task")&&(e=t),i=e?"CUSTOM":t.mode||"REST-JSON";var n=new c(t.url);return n.init(this),n.setTransactionMode({mode:i,router:e},t.batchUpdate),n};var c=function(){function t(t){this.serverProcessor=t,this.action_param="!nativeeditor_status",this.object=null,this.updatedRows=[],this.autoUpdate=!0,this.updateMode="cell",this._headers=null,this._payload=null,this._postDelim="_",this._waitMode=0,this._in_progress={},this._storage=l.default.create(),this._invalid={},this.messages=[],this.styles={updated:"font-weight:bold;",inserted:"font-weight:bold;",deleted:"text-decoration : line-through;",invalid:"background-color:FFE0E0;",invalid_cell:"border-bottom:2px solid red;",error:"color:red;",clear:"font-weight:normal;text-decoration:none;"},this.enableUTFencoding(!0),n(this)}return t.prototype.setTransactionMode=function(t,e){"object"==typeof t?(this._tMode=t.mode||this._tMode,a.defined(t.headers)&&(this._headers=t.headers),a.defined(t.payload)&&(this._payload=t.payload)):(this._tMode=t,this._tSend=e),"REST"===this._tMode&&(this._tSend=!1,this._endnm=!0),"JSON"!==this._tMode&&"REST-JSON"!==this._tMode||(this._tSend=!1,this._endnm=!0,this._serializeAsJson=!0,this._headers=this._headers||{},this._headers["Content-type"]="application/json"),"CUSTOM"===this._tMode&&(this._tSend=!1,this._endnm=!0,this._router=t.router)},t.prototype.escape=function(t){return this._utf?encodeURIComponent(t):escape(t)},t.prototype.enableUTFencoding=function(t){this._utf=!!t},t.prototype.setDataColumns=function(t){this._columns="string"==typeof t?t.split(","):t},t.prototype.getSyncState=function(){return!this.updatedRows.length},t.prototype.enableDataNames=function(t){this._endnm=!!t},t.prototype.enablePartialDataSend=function(t){this._changed=!!t},t.prototype.setUpdateMode=function(t,e){this.autoUpdate="cell"===t,this.updateMode=t,this.dnd=e},t.prototype.ignore=function(t,e){this._silent_mode=!0,t.call(e||window),this._silent_mode=!1},t.prototype.setUpdated=function(t,e,i){if(!this._silent_mode){var n=this.findRow(t);i=i||"updated";var r=this.$gantt.getUserData(t,this.action_param);r&&"updated"===i&&(i=r),e?(this.set_invalid(t,!1),this.updatedRows[n]=t,this.$gantt.setUserData(t,this.action_param,i),this._in_progress[t]&&(this._in_progress[t]="wait")):this.is_invalid(t)||(this.updatedRows.splice(n,1),this.$gantt.setUserData(t,this.action_param,"")),this.markRow(t,e,i),e&&this.autoUpdate&&this.sendData(t)}},t.prototype.markRow=function(t,e,i){var n="",r=this.is_invalid(t);if(r&&(n=this.styles[r],e=!0),this.callEvent("onRowMark",[t,e,i,r])&&(n=this.styles[e?i:"clear"]+n,this.$gantt[this._methods[0]](t,n),r&&r.details)){n+=this.styles[r+"_cell"];for(var a=0;a<r.details.length;a++)r.details[a]&&this.$gantt[this._methods[1]](t,a,n)}},t.prototype.getActionByState=function(t){return"inserted"===t?"create":"updated"===t?"update":"deleted"===t?"delete":"update"},t.prototype.getState=function(t){return this.$gantt.getUserData(t,this.action_param)},t.prototype.is_invalid=function(t){return this._invalid[t]},t.prototype.set_invalid=function(t,e,i){i&&(e={value:e,details:i,toString:function(){return this.value.toString()}}),this._invalid[t]=e},t.prototype.checkBeforeUpdate=function(t){return!0},t.prototype.sendData=function(t){return this.$gantt.editStop&&this.$gantt.editStop(),void 0===t||this._tSend?this.sendAllData():!this._in_progress[t]&&(this.messages=[],!(!this.checkBeforeUpdate(t)&&this.callEvent("onValidationError",[t,this.messages]))&&void this._beforeSendData(this._getRowData(t),t))},t.prototype.serialize=function(t,e){if(this._serializeAsJson)return this._serializeAsJSON(t);if("string"==typeof t)return t;if(void 0!==e)return this.serialize_one(t,"");var i=[],n=[];for(var r in t)t.hasOwnProperty(r)&&(i.push(this.serialize_one(t[r],r+this._postDelim)),n.push(r));return i.push("ids="+this.escape(n.join(","))),this.$gantt.security_key&&i.push("dhx_security="+this.$gantt.security_key),i.join("&")},t.prototype.serialize_one=function(t,e){if("string"==typeof t)return t;var i=[],n="";for(var r in t)if(t.hasOwnProperty(r)){if(("id"===r||r==this.action_param)&&"REST"===this._tMode)continue;n="string"==typeof t[r]||"number"==typeof t[r]?t[r]:JSON.stringify(t[r]),i.push(this.escape((e||"")+r)+"="+this.escape(n))}return i.join("&")},t.prototype.sendAllData=function(){if(this.updatedRows.length){this.messages=[];var t=!0;if(this._forEachUpdatedRow(function(e){t=t&&this.checkBeforeUpdate(e)}),!t&&!this.callEvent("onValidationError",["",this.messages]))return!1;this._tSend?this._sendData(this._getAllData()):this._forEachUpdatedRow(function(t){if(!this._in_progress[t]){if(this.is_invalid(t))return;this._beforeSendData(this._getRowData(t),t)}})}},t.prototype.findRow=function(t){var e=0;for(e=0;e<this.updatedRows.length&&t!=this.updatedRows[e];e++);return e},t.prototype.defineAction=function(t,e){this._uActions||(this._uActions={}),this._uActions[t]=e},t.prototype.afterUpdateCallback=function(t,e,i,n,r){if(this.$gantt){this.setGanttMode(r);var a=t,o="error"!==i&&"invalid"!==i;if(o||this.set_invalid(t,i),this._uActions&&this._uActions[i]&&!this._uActions[i](n))return delete this._in_progress[a];"wait"!==this._in_progress[a]&&this.setUpdated(t,!1);var s=t;switch(i){case"inserted":case"insert":e!=t&&(this.setUpdated(t,!1),this.$gantt[this._methods[2]](t,e),t=e);break;case"delete":case"deleted":return this.$gantt.setUserData(t,this.action_param,"true_deleted"),this.$gantt[this._methods[3]](t),delete this._in_progress[a],this.callEvent("onAfterUpdate",[t,i,e,n])}"wait"!==this._in_progress[a]?(o&&this.$gantt.setUserData(t,this.action_param,""),delete this._in_progress[a]):(delete this._in_progress[a],this.setUpdated(e,!0,this.$gantt.getUserData(t,this.action_param))),this.callEvent("onAfterUpdate",[s,i,e,n])}},t.prototype.afterUpdate=function(t,e,i){var n;n=3===arguments.length?arguments[1]:arguments[4];var r=this.getGanttMode(),a=n.filePath||n.url;r="REST"!==this._tMode&&"REST-JSON"!==this._tMode?-1!==a.indexOf("gantt_mode=links")?"link":"task":a.indexOf("/link")>a.indexOf("/task")?"link":"task",this.setGanttMode(r);var o=this.$gantt.ajax;if(window.JSON){var s=void 0;try{s=JSON.parse(e.xmlDoc.responseText)}catch(t){e.xmlDoc.responseText.length||(s={})}if(s){var l=s.action||this.getState(i)||"updated",c=s.sid||i[0],u=s.tid||i[0];return t.afterUpdateCallback(c,u,l,s,r),t.finalizeUpdate(),void this.setGanttMode(r)}}var d=o.xmltop("data",e.xmlDoc);if(!d)return this.cleanUpdate(i);var h=o.xpath("//data/action",d);if(!h.length)return this.cleanUpdate(i);for(var f=0;f<h.length;f++){var _=h[f];l=_.getAttribute("type"),c=_.getAttribute("sid"),u=_.getAttribute("tid");t.afterUpdateCallback(c,u,l,_,r)}t.finalizeUpdate()},t.prototype.cleanUpdate=function(t){if(t)for(var e=0;e<t.length;e++)delete this._in_progress[t[e]]},t.prototype.finalizeUpdate=function(){this._waitMode&&this._waitMode--,this.callEvent("onAfterUpdateFinish",[]),this.updatedRows.length||this.callEvent("onFullSync",[])},t.prototype.init=function(t){if(!this._initialized){this.$gantt=t,this.$gantt._dp_init&&this.$gantt._dp_init(this),this._setDefaultTransactionMode(),this.styles={updated:"gantt_updated",order:"gantt_updated",inserted:"gantt_inserted",deleted:"gantt_deleted",invalid:"gantt_invalid",error:"gantt_error",clear:""},this._methods=["_row_style","setCellTextStyle","_change_id","_delete_task"],s.default(this.$gantt,this);var e=new o.default(this.$gantt,this);e.attach(),this.attachEvent("onDestroy",function(){delete this.setGanttMode,delete this._getRowData,delete this.$gantt._dp,delete this.$gantt._change_id,delete this.$gantt._row_style,delete this.$gantt._delete_task,delete this.$gantt._sendTaskOrder,delete this.$gantt,e.detach()}),this.$gantt.callEvent("onDataProcessorReady",[this]),this._initialized=!0}},t.prototype.setOnAfterUpdate=function(t){this.attachEvent("onAfterUpdate",t)},t.prototype.setOnBeforeUpdateHandler=function(t){this.attachEvent("onBeforeDataSending",t)},t.prototype.setAutoUpdate=function(t,e){var i=this;t=t||2e3,this._user=e||(new Date).valueOf(),this._needUpdate=!1,this._updateBusy=!1,this.attachEvent("onAfterUpdate",this.afterAutoUpdate),this.attachEvent("onFullSync",this.fullSync),window.setInterval(function(){i.loadUpdate()},t)},t.prototype.afterAutoUpdate=function(t,e,i,n){return"collision"!==e||(this._needUpdate=!0,!1)},t.prototype.fullSync=function(){return this._needUpdate&&(this._needUpdate=!1,this.loadUpdate()),!0},t.prototype.getUpdates=function(t,e){var i=this.$gantt.ajax;if(this._updateBusy)return!1;this._updateBusy=!0,i.get(t,e)},t.prototype.loadUpdate=function(){var t=this,e=this.$gantt.ajax,i=this.$gantt.getUserData(0,"version"),n=this.serverProcessor+e.urlSeparator(this.serverProcessor)+["dhx_user="+this._user,"dhx_version="+i].join("&");n=n.replace("editing=true&",""),this.getUpdates(n,function(i){var n=e.xpath("//userdata",i);t.obj.setUserData(0,"version",t._getXmlNodeValue(n[0]));var r=e.xpath("//update",i);if(r.length){t._silent_mode=!0;for(var a=0;a<r.length;a++){var o=r[a].getAttribute("status"),s=r[a].getAttribute("id"),l=r[a].getAttribute("parent");switch(o){case"inserted":t.callEvent("insertCallback",[r[a],s,l]);break;case"updated":t.callEvent("updateCallback",[r[a],s,l]);break;case"deleted":t.callEvent("deleteCallback",[r[a],s,l])}}t._silent_mode=!1}t._updateBusy=!1})},t.prototype.destructor=function(){this.callEvent("onDestroy",[]),this.detachAllEvents(),this.updatedRows=[],this._in_progress={},this._invalid={},this._storage.clear(),this._storage=null,this._headers=null,this._payload=null,delete this._initialized},t.prototype.setGanttMode=function(t){"tasks"===t?t="task":"links"===t&&(t="link");var e=this.modes||{},i=this.getGanttMode();i&&(e[i]={_in_progress:this._in_progress,_invalid:this._invalid,_storage:this._storage,updatedRows:this.updatedRows});var n=e[t];n||(n=e[t]={_in_progress:{},_invalid:{},_storage:l.default.create(),updatedRows:[]}),this._in_progress=n._in_progress,this._invalid=n._invalid,this._storage=n._storage,this.updatedRows=n.updatedRows,this.modes=e,this._ganttMode=t},t.prototype.getGanttMode=function(){return this._ganttMode},t.prototype.storeItem=function(t){this._storage.storeItem(t)},t.prototype.url=function(t){this.serverProcessor=this._serverProcessor=t},t.prototype._beforeSendData=function(t,e){if(!this.callEvent("onBeforeUpdate",[e,this.getState(e),t]))return!1;this._sendData(t,e)},t.prototype._serializeAsJSON=function(t){if("string"==typeof t)return t;var e=a.copy(t);return"REST-JSON"===this._tMode&&(delete e.id,delete e[this.action_param]),JSON.stringify(e)},t.prototype._applyPayload=function(t){var e=this.$gantt.ajax;if(this._payload)for(var i in this._payload)t=t+e.urlSeparator(t)+this.escape(i)+"="+this.escape(this._payload[i]);return t},t.prototype._cleanupArgumentsBeforeSend=function(t){var e;if(void 0===t[this.action_param])for(var i in e={},t)e[i]=this._cleanupArgumentsBeforeSend(t[i]);else e=this._cleanupItemBeforeSend(t);return e},t.prototype._cleanupItemBeforeSend=function(t){var e=null;return t&&("deleted"===t[this.action_param]?((e={}).id=t.id,e[this.action_param]=t[this.action_param]):e=t),e},t.prototype._sendData=function(t,e){var i=this;if(t){if(!this.callEvent("onBeforeDataSending",e?[e,this.getState(e),t]:[null,null,t]))return!1;e&&(this._in_progress[e]=(new Date).valueOf());var n=this.$gantt.ajax;if("CUSTOM"!==this._tMode){var r;r={callback:function(n){var r=[];if(e)r.push(e);else if(t)for(var a in t)r.push(a);return i.afterUpdate(i,n,r)},headers:this._headers};var a,o=this.serverProcessor+(this._user?n.urlSeparator(this.serverProcessor)+["dhx_user="+this._user,"dhx_version="+this.$gantt.getUserData(0,"version")].join("&"):""),s=this._applyPayload(o);switch(this._tMode){case"GET":a=this._cleanupArgumentsBeforeSend(t),r.url=s+n.urlSeparator(s)+this.serialize(a,e),r.method="GET";break;case"POST":a=this._cleanupArgumentsBeforeSend(t),r.url=s,r.method="POST",r.data=this.serialize(a,e);break;case"JSON":a={};var l=this._cleanupItemBeforeSend(t);for(var c in l)c!==this.action_param&&"id"!==c&&"gr_id"!==c&&(a[c]=l[c]);r.url=s,r.method="POST",r.data=JSON.stringify({id:e,action:t[this.action_param],data:a});break;case"REST":case"REST-JSON":switch(s=o.replace(/(&|\?)editing=true/,""),a="",this.getState(e)){case"inserted":r.method="POST",r.data=this.serialize(t,e);break;case"deleted":r.method="DELETE",s=s+("/"===s.slice(-1)?"":"/")+e;break;default:r.method="PUT",r.data=this.serialize(t,e),s=s+("/"===s.slice(-1)?"":"/")+e}r.url=this._applyPayload(s)}return this._waitMode++,n.query(r)}var u=this.getState(e),d=this.getActionByState(u),h=this.getGanttMode(),f=function(t){var n=u||"updated",r=e,a=e;t&&(n=t.action||u,r=t.sid||r,a=t.id||t.tid||a),i.afterUpdateCallback(r,a,n,t,h)},_=void 0;if(this._router instanceof Function)_=this._router(h,d,t,e);else if(this._router[h]instanceof Function)_=this._router[h](d,t,e);else switch(u){case"inserted":_=this._router[h].create(t);break;case"deleted":_=this._router[h].delete(e);break;default:_=this._router[h].update(t,e)}if(_){if(!_.then&&void 0===_.id&&void 0===_.tid)throw new Error("Incorrect router return value. A Promise or a response object is expected");_.then?_.then(f):f(_)}else f(null)}},t.prototype._forEachUpdatedRow=function(t){for(var e=this.updatedRows.slice(),i=0;i<e.length;i++){var n=e[i];this.$gantt.getUserData(n,this.action_param)&&t.call(this,n)}},t.prototype._setDefaultTransactionMode=function(){this.serverProcessor&&(this.setTransactionMode("POST",!0),this.serverProcessor+=(-1!==this.serverProcessor.indexOf("?")?"&":"?")+"editing=true",this._serverProcessor=this.serverProcessor)},t.prototype._getXmlNodeValue=function(t){return t.firstChild?t.firstChild.nodeValue:""},t.prototype._getAllData=function(){var t={},e=!1;return this._forEachUpdatedRow(function(i){if(!this._in_progress[i]&&!this.is_invalid(i)){var n=this._getRowData(i);this.callEvent("onBeforeUpdate",[i,this.getState(i),n])&&(t[i]=n,e=!0,this._in_progress[i]=(new Date).valueOf())}}),e?t:null},t.prototype._prepareDataItem=function(t){var e={};for(var i in t)if("$"!==i.substr(0,1)){var n=t[i];r.isDate(n)?e[i]=this.$gantt.templates.xml_format!==this.$gantt.templates.format_date?this.$gantt.templates.xml_format(n):this.$gantt.templates.format_date(n):e[i]=null===n?"":n}return e[this.action_param]=this.$gantt.getUserData(t.id,this.action_param),e},t.prototype.getStoredItem=function(t){return this._storage.getStoredItem(t)},t.prototype._getRowData=function(t){var e,i=this.$gantt;return"task"===this.getGanttMode()?i.isTaskExists(t)&&(e=this.$gantt.getTask(t)):i.isLinkExists(t)&&(e=this.$gantt.getLink(t)),e||(e=this.getStoredItem(t)),e||(e={id:t}),this._prepareDataItem(e)},t}();e.DataProcessor=c},function(t,e,i){var n=i(94);t.exports={DEPRECATED_api:function(t){return new n.DataProcessor(t)},createDataProcessor:n.createDataProcessor,getDataProcessorModes:n.getAvailableModes}},function(t,e){t.exports={bindDataStore:function(t,e){var i=e.getDatastore(t),n=function(t,e){var n=e.getLayers(),r=i.getItem(t);if(r&&i.isVisible(t))for(var a=0;a<n.length;a++)n[a].render_item(r)},r=function(t){for(var e=t.getLayers(),n=0;n<e.length;n++)e[n].clear();var r=i.getVisibleItems(),a={};for(n=0;n<e.length;n++){var o=e[n],s=r;if(o.get_visible_range){var l=o.get_visible_range(i),c=l.start+" - "+l.end;a[c]?s=a[c]:(s=i.getIndexRange(l.start,l.end),a[c]=s)}e[n].render_items(s)}},a=function(t){if(t.update_items){var e;if(t.get_visible_range){var n=t.get_visible_range(i);e=i.getIndexRange(n.start,n.end)}else e=i.getVisibleItems();t.update_items(e)}};function o(t){return!!t.$services.getService("state").getState("batchUpdate").batch_update}i.attachEvent("onStoreUpdated",function(i,n,r){var o=e.$services.getService("layers").getDataRender(t);o&&(o.onUpdateRequest=function(t){a(t)})}),i.attachEvent("onStoreUpdated",function(a,s,l){if(!o(e)){var c=e.$services.getService("layers").getDataRender(t);c&&(a&&"move"!=l&&"delete"!=l?(i.callEvent("onBeforeRefreshItem",[s.id]),n(s.id,c),i.callEvent("onAfterRefreshItem",[s.id])):(i.callEvent("onBeforeRefreshAll",[]),r(c),i.callEvent("onAfterRefreshAll",[])))}}),i.attachEvent("onItemOpen",function(){e.render()}),i.attachEvent("onItemClose",function(){e.render()}),i.attachEvent("onIdChange",function(r,a){if(i.callEvent("onBeforeIdChange",[r,a]),!o(e)){var s=e.$services.getService("layers").getDataRender(t);!function(t,e,i,n){for(var r=0;r<t.length;r++)t[r].change_id(e,i)}(s.getLayers(),r,a,i.getItem(a)),n(a,s)}})}}},function(t,e){t.exports=function(t){var e=null,i=t._removeItemInner;function n(t){e=null,this.callEvent("onAfterUnselect",[t])}return t._removeItemInner=function(t){return e==t&&n.call(this,t),e&&this.eachItem&&this.eachItem(function(t){t.id==e&&n.call(this,t.id)},t),i.apply(this,arguments)},t.attachEvent("onIdChange",function(e,i){t.getSelectedId()==e&&t.silent(function(){t.unselect(e),t.select(i)})}),{select:function(t){if(t){if(e==t)return e;if(!this._skip_refresh&&!this.callEvent("onBeforeSelect",[t]))return!1;this.unselect(),e=t,this._skip_refresh||(this.refresh(t),this.callEvent("onAfterSelect",[t]))}return e},getSelectedId:function(){return e},isSelected:function(t){return t==e},unselect:function(t){(t=t||e)&&(e=null,this._skip_refresh||(this.refresh(t),n.call(this,t)))}}}},function(t,e,i){var n=i(25),r=i(0),a=i(26),o=function(t){return a.apply(this,[t]),this._branches={},this.pull={},this.$initItem=t.initItem,this.$parentProperty=t.parentProperty||"parent","function"!=typeof t.rootId?this.$getRootId=function(t){return function(){return t}}(t.rootId||0):this.$getRootId=t.rootId,this.$openInitially=t.openInitially,this.visibleOrder=n.$create(),this.fullOrder=n.$create(),this._searchVisibleOrder={},this._skip_refresh=!1,this._ganttConfig=null,t.getConfig&&(this._ganttConfig=t.getConfig()),this.attachEvent("onFilterItem",function(t,e){var i=!1;if(this._ganttConfig)i=this._ganttConfig.open_split_tasks;var n=!0;return this.eachParent(function(t){n=n&&t.$open&&(i||!this._isSplitItem(t))},e),!!n}),this};o.prototype=r.mixin({_buildTree:function(t){for(var e=null,i=this.$getRootId(),n=0,a=t.length;n<a;n++)e=t[n],this.setParent(e,this.getParent(e)||i);for(n=0,a=t.length;n<a;n++)e=t[n],this._add_branch(e),e.$level=this.calculateItemLevel(e),r.defined(e.$open)||(e.$open=r.defined(e.open)?e.open:this.$openInitially());this._updateOrder()},_isSplitItem:function(t){return"split"==t.render&&this.hasChild(t.id)},parse:function(t){this.callEvent("onBeforeParse",[t]);var e=this._parseInner(t);this._buildTree(e),this.filter(),this.callEvent("onParse",[e])},_addItemInner:function(t,e){var i=this.getParent(t);r.defined(i)||(i=this.$getRootId(),this.setParent(t,i));var n=this.getIndexById(i)+Math.min(Math.max(e,0),this.visibleOrder.length);1*n!==n&&(n=void 0),a.prototype._addItemInner.call(this,t,n),this.setParent(t,i),t.hasOwnProperty("$rendered_parent")&&this._move_branch(t,t.$rendered_parent),this._add_branch(t,e)},_changeIdInner:function(t,e){var i=this.getChildren(t),n=this._searchVisibleOrder[t];a.prototype._changeIdInner.call(this,t,e);var r=this.getParent(e);this._replace_branch_child(r,t,e);for(var o=0;o<i.length;o++)this.setParent(this.getItem(i[o]),e);this._searchVisibleOrder[e]=n,delete this._branches[t]},_traverseBranches:function(t,e){e=e||this.$getRootId();var i=this._branches[e];if(i)for(var n=0;n<i.length;n++){var r=i[n];t.call(this,r),this._branches[r]&&this._traverseBranches(t,r)}},_updateOrder:function(t){this.fullOrder=n.$create(),this._traverseBranches(function(t){this.fullOrder.push(t)}),t&&a.prototype._updateOrder.call(this,t)},_removeItemInner:function(t){var e=[];this.eachItem(function(t){e.push(t)},t),e.push(this.getItem(t));for(var i=0;i<e.length;i++)this._move_branch(e[i],this.getParent(e[i]),null),a.prototype._removeItemInner.call(this,e[i].id),this._move_branch(e[i],this.getParent(e[i]),null)},move:function(t,e,i){var n=arguments[3];if(n){if(n===t)return;i=this.getParent(n),e=this.getBranchIndex(n)}if(t!=i){i=i||this.$getRootId();var r=this.getItem(t),a=this.getParent(r.id),o=this.getChildren(i);if(-1==e&&(e=o.length+1),a==i)if(this.getBranchIndex(t)==e)return;if(!1===this.callEvent("onBeforeItemMove",[t,i,e]))return!1;this._replace_branch_child(a,t),(o=this.getChildren(i))[e]?o=o.slice(0,e).concat([t]).concat(o.slice(e)):o.push(t),this.setParent(r,i),this._branches[i]=o;var s=this.calculateItemLevel(r)-r.$level;r.$level+=s,this.eachItem(function(t){t.$level+=s},r.id,this),this._moveInner(this.getIndexById(t),this.getIndexById(i)+e),this.callEvent("onAfterItemMove",[t,i,e]),this.refresh()}},getBranchIndex:function(t){for(var e=this.getChildren(this.getParent(t)),i=0;i<e.length;i++)if(e[i]==t)return i;return-1},hasChild:function(t){return r.defined(this._branches[t])&&this._branches[t].length},getChildren:function(t){return r.defined(this._branches[t])?this._branches[t]:n.$create()},isChildOf:function(t,e){if(!this.exists(t))return!1;if(e===this.$getRootId())return!0;if(!this.hasChild(e))return!1;var i=this.getItem(t),n=this.getParent(t);if(this.getItem(e).$level>=i.$level)return!1;for(;i&&this.exists(n);){if((i=this.getItem(n))&&i.id==e)return!0;n=this.getParent(i)}return!1},getSiblings:function(t){if(!this.exists(t))return n.$create();var e=this.getParent(t);return this.getChildren(e)},getNextSibling:function(t){for(var e=this.getSiblings(t),i=0,n=e.length;i<n;i++)if(e[i]==t)return e[i+1]||null;return null},getPrevSibling:function(t){for(var e=this.getSiblings(t),i=0,n=e.length;i<n;i++)if(e[i]==t)return e[i-1]||null;return null},getParent:function(t){var e=null;return(e=void 0!==t.id?t:this.getItem(t))?e[this.$parentProperty]:this.$getRootId()},clearAll:function(){this._branches={},a.prototype.clearAll.call(this)},calculateItemLevel:function(t){var e=0;return this.eachParent(function(){e++},t),e},_setParentInner:function(t,e,i){i||(t.hasOwnProperty("$rendered_parent")?this._move_branch(t,t.$rendered_parent,e):this._move_branch(t,t[this.$parentProperty],e))},setParent:function(t,e,i){this._setParentInner(t,e,i),t[this.$parentProperty]=e},eachItem:function(t,e){e=e||this.$getRootId();var i=this.getChildren(e);if(i)for(var n=0;n<i.length;n++){var r=this.pull[i[n]];t.call(this,r),this.hasChild(r.id)&&this.eachItem(t,r.id)}},eachParent:function(t,e){for(var i={},n=e,r=this.getParent(n);this.exists(r);){if(i[r])throw new Error("Invalid tasks tree. Cyclic reference has been detected on task "+r);i[r]=!0,n=this.getItem(r),t.call(this,n),r=this.getParent(n)}},_add_branch:function(t,e,i){var r=void 0===i?this.getParent(t):i;this.hasChild(r)||(this._branches[r]=n.$create());for(var a=this.getChildren(r),o=!1,s=0,l=a.length;s<l;s++)if(a[s]==t.id){o=!0;break}o||(1*e==e?a.splice(e,0,t.id):a.push(t.id),t.$rendered_parent=r)},_move_branch:function(t,e,i){this._replace_branch_child(e,t.id),this.exists(i)||i==this.$getRootId()?this._add_branch(t,void 0,i):delete this._branches[t.id],t.$level=this.calculateItemLevel(t),this.eachItem(function(t){t.$level=this.calculateItemLevel(t)},t.id)},_replace_branch_child:function(t,e,i){var r=this.getChildren(t);if(r&&void 0!==t){for(var a=n.$create(),o=0;o<r.length;o++)r[o]!=e?a.push(r[o]):i&&a.push(i);this._branches[t]=a}},sort:function(t,e,i){this.exists(i)||(i=this.$getRootId()),t||(t="order");var n="string"==typeof t?function(e,i){return e[t]==i[t]?0:e[t]>i[t]?1:-1}:t;if(e){var r=n;n=function(t,e){return r(e,t)}}var a=this.getChildren(i);if(a){for(var o=[],s=a.length-1;s>=0;s--)o[s]=this.getItem(a[s]);o.sort(n);for(s=0;s<o.length;s++)a[s]=o[s].id,this.sort(t,e,a[s])}},filter:function(t){for(var e in this.pull)this.pull[e].$rendered_parent!==this.getParent(this.pull[e])&&this._move_branch(this.pull[e],this.pull[e].$rendered_parent,this.getParent(this.pull[e]));return a.prototype.filter.apply(this,arguments)},open:function(t){this.exists(t)&&(this.getItem(t).$open=!0,this.callEvent("onItemOpen",[t]))},close:function(t){this.exists(t)&&(this.getItem(t).$open=!1,this.callEvent("onItemClose",[t]))},destructor:function(){a.prototype.destructor.call(this),this._branches=null}},a.prototype),t.exports=o},function(t,e,i){var n=i(0);t.exports=function(){return{getLinkCount:function(){return this.$data.linksStore.count()},getLink:function(t){return this.$data.linksStore.getItem(t)},getLinks:function(){return this.$data.linksStore.getItems()},isLinkExists:function(t){return this.$data.linksStore.exists(t)},addLink:function(t){return this.$data.linksStore.addItem(t)},updateLink:function(t,e){n.defined(e)||(e=this.getLink(t)),this.$data.linksStore.updateItem(t,e)},deleteLink:function(t){return this.$data.linksStore.removeItem(t)},changeLinkId:function(t,e){return this.$data.linksStore.changeId(t,e)}}}},function(t,e,i){var n=i(0);t.exports=function(){return{getTask:function(t){this.assert(t,"Invalid argument for gantt.getTask");var e=this.$data.tasksStore.getItem(t);return this.assert(e,"Task not found id="+t),e},getTaskByTime:function(t,e){var i=this.$data.tasksStore.getItems(),n=[];if(t||e){t=+t||-1/0,e=+e||1/0;for(var r=0;r<i.length;r++){var a=i[r];+a.start_date<e&&+a.end_date>t&&n.push(a)}}else n=i;return n},isTaskExists:function(t){return!(!this.$data||!this.$data.tasksStore)&&this.$data.tasksStore.exists(t)},updateTask:function(t,e){n.defined(e)||(e=this.getTask(t)),this.$data.tasksStore.updateItem(t,e),this.isTaskExists(t)&&this.refreshTask(t)},addTask:function(t,e,i){return n.defined(t.id)||(t.id=n.uid()),n.defined(e)||(e=this.getParent(t)||0),this.isTaskExists(e)||(e=this.config.root_id),this.setParent(t,e),this.$data.tasksStore.addItem(t,i,e)},deleteTask:function(t){return this.$data.tasksStore.removeItem(t)},getTaskCount:function(){return this.$data.tasksStore.count()},getVisibleTaskCount:function(){return this.$data.tasksStore.countVisible()},getTaskIndex:function(t){return this.$data.tasksStore.getBranchIndex(t)},getGlobalTaskIndex:function(t){return this.assert(t,"Invalid argument"),this.$data.tasksStore.getIndexById(t)},eachTask:function(t,e,i){return this.$data.tasksStore.eachItem(n.bind(t,i||this),e)},eachParent:function(t,e,i){return this.$data.tasksStore.eachParent(n.bind(t,i||this),e)},changeTaskId:function(t,e){this.$data.tasksStore.changeId(t,e);var i=this.$data.tasksStore.getItem(e),n=[];i.$source&&(n=n.concat(i.$source)),i.$target&&(n=n.concat(i.$target));for(var r=0;r<n.length;r++){var a=this.getLink(n[r]);a.source==t&&(a.source=e),a.target==t&&(a.target=e)}},calculateTaskLevel:function(t){return this.$data.tasksStore.calculateItemLevel(t)},getNext:function(t){return this.$data.tasksStore.getNext(t)},getPrev:function(t){return this.$data.tasksStore.getPrev(t)},getParent:function(t){return this.$data.tasksStore.getParent(t)},setParent:function(t,e,i){return this.$data.tasksStore.setParent(t,e,i)},getSiblings:function(t){return this.$data.tasksStore.getSiblings(t).slice()},getNextSibling:function(t){return this.$data.tasksStore.getNextSibling(t)},getPrevSibling:function(t){return this.$data.tasksStore.getPrevSibling(t)},getTaskByIndex:function(t){var e=this.$data.tasksStore.getIdByIndex(t);return this.isTaskExists(e)?this.getTask(e):null},getChildren:function(t){return this.hasChild(t)?this.$data.tasksStore.getChildren(t).slice():[]},hasChild:function(t){return this.$data.tasksStore.hasChild(t)},open:function(t){this.$data.tasksStore.open(t)},close:function(t){this.$data.tasksStore.close(t)},moveTask:function(t,e,i){return this.$data.tasksStore.move.apply(this.$data.tasksStore,arguments)},sort:function(t,e,i,n){var r=!n;this.$data.tasksStore.sort(t,e,i),this.callEvent("onAfterSort",[t,e,i]),r&&this.render()}}}},function(t,e,i){var n=i(0),r=i(100),a=i(99),o=i(26),s=i(98),l=i(97),c=i(96);function u(){for(var t=this.$services.getService("datastores"),e=[],i=0;i<t.length;i++)e.push(this.getDatastore(t[i]));return e}var d=function(){return{createDatastore:function(t){var e="treedatastore"==(t.type||"").toLowerCase()?s:o;if(t){var i=this;t.openInitially=function(){return i.config.open_tree_initially}}var n=new e(t);if(this.mixin(n,l(n)),t.name){this.$services.dropService("datastore:"+t.name),this.$services.setService("datastore:"+t.name,function(){return n});var r=this.$services.getService("datastores");r?r.indexOf(t.name)<0&&r.push(t.name):(r=[],this.$services.setService("datastores",function(){return r}),r.push(t.name)),c.bindDataStore(t.name,this)}return n},getDatastore:function(t){return this.$services.getService("datastore:"+t)},refreshData:function(){var t=this.getScrollState();this.callEvent("onBeforeDataRender",[]);for(var e=u.call(this),i=0;i<e.length;i++)e[i].refresh();(t.x||t.y)&&this.scrollTo(t.x,t.y),this.callEvent("onDataRender",[])},isChildOf:function(t,e){return this.$data.tasksStore.isChildOf(t,e)},refreshTask:function(t,e){var i=this.getTask(t);if(i&&this.isTaskVisible(t)){if(this.$data.tasksStore.refresh(t,!!this.getState().drag_id),void 0!==e&&!e)return;for(var n=0;n<i.$source.length;n++)this.refreshLink(i.$source[n]);for(n=0;n<i.$target.length;n++)this.refreshLink(i.$target[n])}else this.isTaskExists(t)&&this.isTaskExists(this.getParent(t))&&this.refreshTask(this.getParent(t))},refreshLink:function(t){this.$data.linksStore.refresh(t,!!this.getState().drag_id)},silent:function(t){var e=this;e.$data.tasksStore.silent(function(){e.$data.linksStore.silent(function(){t()})})},clearAll:function(){for(var t=u.call(this),e=0;e<t.length;e++)t[e].clearAll();this._update_flags(),this.userdata={},this.callEvent("onClear",[]),this.render()},_clear_data:function(){this.$data.tasksStore.clearAll(),this.$data.linksStore.clearAll(),this._update_flags(),this.userdata={}},selectTask:function(t){var e=this.$data.tasksStore;return!!this.config.select_task&&(t&&e.select(t),e.getSelectedId())},unselectTask:function(t){this.$data.tasksStore.unselect(t)},isSelectedTask:function(t){return this.$data.tasksStore.isSelected(t)},getSelectedId:function(){return this.$data.tasksStore.getSelectedId()}}};t.exports={create:function(){var t=n.mixin({},d());return n.mixin(t,r()),n.mixin(t,a()),t}}},function(t,e,i){var n=i(0),r=i(101),a=i(24);t.exports=function(t){var e=r.create();n.mixin(t,e);var o=t.createDatastore({name:"task",type:"treeDatastore",rootId:function(){return t.config.root_id},initItem:n.bind(function(e){this.defined(e.id)||(e.id=this.uid()),e.start_date&&(e.start_date=t.date.parseDate(e.start_date,"parse_date")),e.end_date&&(e.end_date=t.date.parseDate(e.end_date,"parse_date"));var i=null;(e.duration||0===e.duration)&&(e.duration=i=1*e.duration),i&&(e.start_date&&!e.end_date?e.end_date=this.calculateEndDate(e):!e.start_date&&e.end_date&&(e.start_date=this.calculateEndDate({start_date:e.end_date,duration:-e.duration,task:e}))),e.progress=Number(e.progress)||0,this._isAllowedUnscheduledTask(e)&&this._set_default_task_timing(e),this._init_task_timing(e),e.start_date&&e.end_date&&this.correctTaskWorkTime(e),e.$source=[],e.$target=[];var r=this.$data.tasksStore.getItem(e.id);return r&&!n.defined(e.open)&&(e.$open=r.$open),void 0===e.parent&&(e.parent=this.config.root_id),e},t),getConfig:function(){return t.config}}),s=t.createDatastore({name:"link",initItem:n.bind(function(t){return this.defined(t.id)||(t.id=this.uid()),t},t)});function l(e){var i=t.isTaskVisible(e);if(!i&&t.isTaskExists(e)){var n=t.getParent(e);t.isTaskExists(n)&&t.isTaskVisible(n)&&(n=t.getTask(n),t.isSplitTask(n)&&(i=!0))}return i}function c(e){if(t.isTaskExists(e.source)){var i=t.getTask(e.source);i.$source=i.$source||[],i.$source.push(e.id)}if(t.isTaskExists(e.target)){var n=t.getTask(e.target);n.$target=n.$target||[],n.$target.push(e.id)}}function u(e){if(t.isTaskExists(e.source))for(var i=t.getTask(e.source),n=0;n<i.$source.length;n++)if(i.$source[n]==e.id){i.$source.splice(n,1);break}if(t.isTaskExists(e.target)){var r=t.getTask(e.target);for(n=0;n<r.$target.length;n++)if(r.$target[n]==e.id){r.$target.splice(n,1);break}}}function d(){for(var e=null,i=t.$data.tasksStore.getItems(),n=0,r=i.length;n<r;n++)(e=i[n]).$source=[],e.$target=[];var a=t.$data.linksStore.getItems();for(n=0,r=a.length;n<r;n++)c(a[n])}function h(t){var e=t.source,i=t.target;for(var n in t.events)!function(t,n){e.attachEvent(t,function(){return i.callEvent(n,Array.prototype.slice.call(arguments))},n)}(n,t.events[n])}t.attachEvent("onDestroy",function(){o.destructor(),s.destructor()}),o.attachEvent("onBeforeRefreshAll",function(){for(var e=o.getVisibleItems(),i=0;i<e.length;i++){var n=e[i];n.$index=i,t.resetProjectDates(n)}}),o.attachEvent("onFilterItem",function(e,i){if(t.config.show_tasks_outside_timescale)return!0;var n=null,r=null;if(t.config.start_date&&t.config.end_date){if(t._isAllowedUnscheduledTask(i))return!0;if(n=t.config.start_date.valueOf(),r=t.config.end_date.valueOf(),+i.start_date>r||+i.end_date<+n)return!1}return!0}),o.attachEvent("onIdChange",function(e,i){t._update_flags(e,i)}),o.attachEvent("onAfterUpdate",function(e){if(t._update_parents(e),t.getState("batchUpdate").batch_update)return!0;for(var i=o.getItem(e),n=0;n<i.$source.length;n++)s.refresh(i.$source[n]);for(n=0;n<i.$target.length;n++)s.refresh(i.$target[n])}),o.attachEvent("onAfterItemMove",function(e,i,n){var r=t.getTask(e);null!==this.getNextSibling(e)?r.$drop_target=this.getNextSibling(e):null!==this.getPrevSibling(e)?r.$drop_target="next:"+this.getPrevSibling(e):r.$drop_target="next:null"}),o.attachEvent("onStoreUpdated",function(e,i,n){if("delete"==n&&t._update_flags(e,null),!t.$services.getService("state").getState("batchUpdate").batch_update){if(t.config.fit_tasks&&"paint"!==n){var r=t.getState();a(t);var o=t.getState();if(+r.min_date!=+o.min_date||+r.max_date!=+o.max_date)return t.render(),t.callEvent("onScaleAdjusted",[]),!0}"add"==n||"move"==n||"delete"==n?t.$layout.resize():e||s.refresh()}}),s.attachEvent("onAfterAdd",function(t,e){c(e)}),s.attachEvent("onAfterUpdate",function(t,e){d()}),s.attachEvent("onAfterDelete",function(t,e){u(e)}),s.attachEvent("onBeforeIdChange",function(e,i){u(t.mixin({id:e},t.$data.linksStore.getItem(i))),c(t.$data.linksStore.getItem(i))}),s.attachEvent("onFilterItem",function(e,i){if(!t.config.show_links)return!1;var n=l(i.source),r=l(i.target);return!(!n||!r||t._isAllowedUnscheduledTask(t.getTask(i.source))||t._isAllowedUnscheduledTask(t.getTask(i.target)))&&t.callEvent("onBeforeLinkDisplay",[e,i])}),function(){var e=i(23),n={};t.attachEvent("onBeforeTaskDelete",function(i,r){return n[i]=e.getSubtreeLinks(t,i),!0}),t.attachEvent("onAfterTaskDelete",function(e,i){n[e]&&t.$data.linksStore.silent(function(){for(var i in n[e])t.$data.linksStore.removeItem(i),u(n[e][i]);n[e]=null})})}(),t.attachEvent("onAfterLinkDelete",function(e,i){t.refreshTask(i.source),t.refreshTask(i.target)}),t.attachEvent("onParse",d),h({source:s,target:t,events:{onItemLoading:"onLinkLoading",onBeforeAdd:"onBeforeLinkAdd",onAfterAdd:"onAfterLinkAdd",onBeforeUpdate:"onBeforeLinkUpdate",onAfterUpdate:"onAfterLinkUpdate",onBeforeDelete:"onBeforeLinkDelete",onAfterDelete:"onAfterLinkDelete",onIdChange:"onLinkIdChange"}}),h({source:o,target:t,events:{onItemLoading:"onTaskLoading",onBeforeAdd:"onBeforeTaskAdd",onAfterAdd:"onAfterTaskAdd",onBeforeUpdate:"onBeforeTaskUpdate",onAfterUpdate:"onAfterTaskUpdate",onBeforeDelete:"onBeforeTaskDelete",onAfterDelete:"onAfterTaskDelete",onIdChange:"onTaskIdChange",onBeforeItemMove:"onBeforeTaskMove",onAfterItemMove:"onAfterTaskMove",onFilterItem:"onBeforeTaskDisplay",onItemOpen:"onTaskOpened",onItemClose:"onTaskClosed",onBeforeSelect:"onBeforeTaskSelected",onAfterSelect:"onTaskSelected",onAfterUnselect:"onTaskUnselected"}}),t.$data={tasksStore:o,linksStore:s}}},function(t,e){t.exports=function(){function t(t){return t.$ui.getView("timeline")}function e(t){return t.$ui.getView("grid")}function i(t){return t.$ui.getView("scrollVer")}function n(t){return t.$ui.getView("scrollHor")}var r="DEFAULT_VALUE";function a(t,e,i,n){var a=t(this);return a&&a.isVisible()?a[e].apply(a,i):n?n():r}return{getColumnIndex:function(t){var i=a.call(this,e,"getColumnIndex",[t]);return i===r?0:i},dateFromPos:function(e){var i=a.call(this,t,"dateFromPos",Array.prototype.slice.call(arguments));return i===r?this.getState().min_date:i},posFromDate:function(e){var i=a.call(this,t,"posFromDate",[e]);return i===r?0:i},getRowTop:function(i){var n=this,o=a.call(n,t,"getRowTop",[i],function(){return a.call(n,e,"getRowTop",[i])});return o===r?0:o},getTaskTop:function(i){var n=this,o=a.call(n,t,"getItemTop",[i],function(){return a.call(n,e,"getItemTop",[i])});return o===r?0:o},getTaskPosition:function(e,i,n){var o=a.call(this,t,"getItemPosition",[e,i,n]);return o===r?{left:0,top:this.getTaskTop(e.id),height:this.getTaskHeight(),width:0}:o},getTaskHeight:function(){var i=this,n=a.call(i,t,"getItemHeight",[],function(){return a.call(i,e,"getItemHeight",[])});return n===r?0:n},columnIndexByDate:function(e){var i=a.call(this,t,"columnIndexByDate",[e]);return i===r?0:i},roundTaskDates:function(){a.call(this,t,"roundTaskDates",[])},getScale:function(){var e=a.call(this,t,"getScale",[]);return e===r?null:e},getTaskNode:function(e){var i=t(this);if(i&&i.isVisible()){var n=i._taskRenderer.rendered[e];if(!n){var r=i.$config.item_attribute;n=i.$task_bars.querySelector("["+r+"='"+e+"']")}return n||null}return null},getLinkNode:function(e){var i=t(this);return i.isVisible()?i._linkRenderer.rendered[e]:null},scrollTo:function(t,e){var r=i(this),a=n(this),o={position:0},s={position:0};r&&(s=r.getScrollState()),a&&(o=a.getScrollState()),a&&1*t==t&&a.scroll(t),r&&1*e==e&&r.scroll(e);var l={position:0},c={position:0};r&&(l=r.getScrollState()),a&&(c=a.getScrollState()),this.callEvent("onGanttScroll",[o.position,s.position,c.position,l.position])},showDate:function(t){var e=this.posFromDate(t),i=Math.max(e-this.config.task_scroll_offset,0);this.scrollTo(i)},showTask:function(t){var e,i=this.getTaskPosition(this.getTask(t)),n=Math.max(i.left-this.config.task_scroll_offset,0),r=this._scroll_state().y;e=r?i.top-(r-this.config.row_height)/2:i.top,this.scrollTo(n,e)},_scroll_state:function(){var t={x:!1,y:!1,x_pos:0,y_pos:0,scroll_size:this.config.scroll_size+1,x_inner:0,y_inner:0},e=i(this),r=n(this);if(r){var a=r.getScrollState();a.visible&&(t.x=a.size,t.x_inner=a.scrollSize),t.x_pos=a.position||0}if(e){var o=e.getScrollState();o.visible&&(t.y=o.size,t.y_inner=o.scrollSize),t.y_pos=o.position||0}return t},getScrollState:function(){var t=this._scroll_state();return{x:t.x_pos,y:t.y_pos,inner_width:t.x,inner_height:t.y,width:t.x_inner,height:t.y_inner}}}}},function(t,e){t.exports=function(t){delete t.addTaskLayer,delete t.addLinkLayer}},function(t,e,i){var n=i(1),r=function(t){return{getVerticalScrollbar:function(){return t.$ui.getView("scrollVer")},getHorizontalScrollbar:function(){return t.$ui.getView("scrollHor")},_legacyGridResizerClass:function(t){for(var e=t.getCellsByType("resizer"),i=0;i<e.length;i++){var n=e[i],r=!1,a=n.$parent.getPrevSibling(n.$id);if(a&&a.$config&&"grid"===a.$config.id)r=!0;else{var o=n.$parent.getNextSibling(n.$id);o&&o.$config&&"grid"===o.$config.id&&(r=!0)}r&&(n.$config.css=(n.$config.css?n.$config.css+" ":"")+"gantt_grid_resize_wrap")}},onCreated:function(e){var i=!0;this._legacyGridResizerClass(e),e.attachEvent("onBeforeResize",function(){var r=t.$ui.getView("timeline");r&&(r.$config.hidden=r.$parent.$config.hidden=!t.config.show_chart);var a=t.$ui.getView("grid");if(a){var o=t.config.show_grid;if(i){var s=a._getColsTotalWidth();!1!==s&&(t.config.grid_width=s),o=o&&!!t.config.grid_width,t.config.show_grid=o}if(a.$config.hidden=a.$parent.$config.hidden=!o,!a.$config.hidden){var l=a._getGridWidthLimits();if(l[0]&&t.config.grid_width<l[0]&&(t.config.grid_width=l[0]),l[1]&&t.config.grid_width>l[1]&&(t.config.grid_width=l[1]),r&&t.config.show_chart)if(a.$config.width=t.config.grid_width-1,i)a.$parent.$config.width=t.config.grid_width,a.$parent.$config.group&&t.$layout._syncCellSizes(a.$parent.$config.group,a.$parent.$config.width);else if(r&&!n.isChildOf(r.$task,e.$view)){if(!a.$config.original_grid_width){var c=t.skins[t.skin];c&&c.config&&c.config.grid_width?a.$config.original_grid_width=c.config.grid_width:a.$config.original_grid_width=0}t.config.grid_width=a.$config.original_grid_width,a.$parent.$config.width=t.config.grid_width}else a.$parent._setContentSize(a.$config.width,null),t.$layout._syncCellSizes(a.$parent.$config.group,t.config.grid_width);else r&&n.isChildOf(r.$task,e.$view)&&(a.$config.original_grid_width=t.config.grid_width),i||(a.$parent.$config.width=0)}i=!1}}),this._initScrollStateEvents(e)},_initScrollStateEvents:function(e){t._getVerticalScrollbar=this.getVerticalScrollbar,t._getHorizontalScrollbar=this.getHorizontalScrollbar;var i=this.getVerticalScrollbar(),n=this.getHorizontalScrollbar();i&&i.attachEvent("onScroll",function(e,i,n){var r=t.getScrollState();t.callEvent("onGanttScroll",[r.x,e,r.x,i])}),n&&n.attachEvent("onScroll",function(e,i,n){var r=t.getScrollState();t.callEvent("onGanttScroll",[e,r.y,i,r.y])}),e.attachEvent("onResize",function(){i&&!t.$scroll_ver&&(t.$scroll_ver=i.$scroll_ver),n&&!t.$scroll_hor&&(t.$scroll_hor=n.$scroll_hor)})},_findGridResizer:function(t,e){for(var i,n=t.getCellsByType("resizer"),r=!0,a=0;a<n.length;a++){var o=n[a];o._getSiblings();var s=o._behind,l=o._front;if(s&&s.$content===e||s.isChild&&s.isChild(e)){i=o,r=!0;break}if(l&&l.$content===e||l.isChild&&l.isChild(e)){i=o,r=!1;break}}return{resizer:i,gridFirst:r}},onInitialized:function(e){var i=t.$ui.getView("grid"),n=this._findGridResizer(e,i);if(n.resizer){var r,a=n.gridFirst,o=n.resizer;o.attachEvent("onResizeStart",function(e,i){var n=t.$ui.getView("grid"),o=n?n.$parent:null;if(o){var s=n._getGridWidthLimits();n.$config.scrollable||(o.$config.minWidth=s[0]),o.$config.maxWidth=s[1]}return r=a?e:i,t.callEvent("onGridResizeStart",[r])}),o.attachEvent("onResize",function(e,i){var n=a?e:i;return t.callEvent("onGridResize",[r,n])}),o.attachEvent("onResizeEnd",function(e,i,n,r){var o=a?e:i,s=a?n:r,l=t.$ui.getView("grid"),c=l?l.$parent:null;c&&(c.$config.minWidth=void 0);var u=t.callEvent("onGridResizeEnd",[o,s]);return u&&(t.config.grid_width=s),u})}},onDestroyed:function(t){}}};t.exports=r},function(t,e,i){var n=i(1),r=function(t,e){var i,r,a,o,s,l=10,c=18;function u(){return{link_source_id:o,link_target_id:r,link_from_start:s,link_to_start:a,link_landing_area:i}}var d=e.$services,h=d.getService("state"),f=d.getService("dnd");h.registerProvider("linksDnD",u);var _=new f(t.$task_bars,{sensitivity:0,updates_per_second:60});function g(i,n,r,a,o){var s=function(i,n,r){var a=n(i),o={x:a.left,y:a.top,width:a.width,height:a.height};r.rtl?(o.xEnd=o.x,o.x=o.xEnd+o.width):o.xEnd=o.x+o.width;if(o.yEnd=o.y+o.height,e.getTaskType(i.type)==e.config.types.milestone){var s=function(){var e=t.getItemHeight();return Math.round(Math.sqrt(2*e*e))-2}();o.x+=(r.rtl?1:-1)*(s/2),o.xEnd+=(r.rtl?-1:1)*(s/2),o.width=a.xEnd-a.x}return o}(i,function(t){return e.getTaskPosition(t)},a),l={x:s.x,y:s.y};n||(l.x=s.xEnd),l.y+=e.config.row_height/2;var c=function(t){return e.getTaskType(t.type)==e.config.types.milestone}(i)&&o?2:0;return r=r||0,a.rtl&&(r*=-1),l.x+=(n?-1:1)*r-c,l}function p(t,i){var n=_.getPosition(t),r=function(t){var e=0,i=0;return t&&(e=t.offsetWidth||0,i=t.offsetHeight||0),{width:e,height:i}}(i),a=function(){var t=e.$root;return{right:t.offsetWidth,bottom:t.offsetHeight}}(),o=e.config.tooltip_offset_x||l,s=e.config.tooltip_offset_y||l,u=e.config.scroll_size||c,d={y:n.y+s,x:n.x+o,bottom:n.y+r.height+s+u,right:n.x+r.width+o+u};return d.bottom>a.bottom&&(d.y=a.bottom-r.height-s),d.right>a.right&&(d.x=a.right-r.width-o),d}function v(t){var i=u(),n=["gantt_link_tooltip"];i.link_source_id&&i.link_target_id&&(e.isLinkAllowed(i.link_source_id,i.link_target_id,i.link_from_start,i.link_to_start)?n.push("gantt_allowed_link"):n.push("gantt_invalid_link"));var r=e.templates.drag_link_class(i.link_source_id,i.link_from_start,i.link_target_id,i.link_to_start);r&&n.push(r);var a="<div class='"+r+"'>"+e.templates.drag_link(i.link_source_id,i.link_from_start,i.link_target_id,i.link_to_start)+"</div>";t.innerHTML=a}function m(){o=s=r=null,a=!0}function y(i,n,r,a){var o=function(){_._direction&&_._direction.parentNode||(_._direction=document.createElement("div"),t.$task_links.appendChild(_._direction));return _._direction}(),s=u(),l=["gantt_link_direction"];e.templates.link_direction_class&&l.push(e.templates.link_direction_class(s.link_source_id,s.link_from_start,s.link_target_id,s.link_to_start));var c=Math.sqrt(Math.pow(r-i,2)+Math.pow(a-n,2));if(c=Math.max(0,c-3)){o.className=l.join(" ");var d=(a-n)/(r-i),h=Math.atan(d);2==b(i,r,n,a)?h+=Math.PI:3==b(i,r,n,a)&&(h-=Math.PI);var f=Math.sin(h),g=Math.cos(h),p=Math.round(n),v=Math.round(i),m=["-webkit-transform: rotate("+h+"rad)","-moz-transform: rotate("+h+"rad)","-ms-transform: rotate("+h+"rad)","-o-transform: rotate("+h+"rad)","transform: rotate("+h+"rad)","width:"+Math.round(c)+"px"];if(-1!=window.navigator.userAgent.indexOf("MSIE 8.0")){m.push('-ms-filter: "'+function(t,e){return"progid:DXImageTransform.Microsoft.Matrix(M11 = "+e+",M12 = -"+t+",M21 = "+t+",M22 = "+e+",SizingMethod = 'auto expand')"}(f,g)+'"');var y=Math.abs(Math.round(i-r)),k=Math.abs(Math.round(a-n));switch(b(i,r,n,a)){case 1:p-=k;break;case 2:v-=y,p-=k;break;case 3:v-=y}}m.push("top:"+p+"px"),m.push("left:"+v+"px"),o.style.cssText=m.join(";")}}function b(t,e,i,n){return e>=t?n<=i?1:4:n<=i?2:3}_.attachEvent("onBeforeDragStart",e.bind(function(i,r){var a=r.target||r.srcElement;if(m(),e.getState().drag_id)return!1;if(n.locateClassName(a,"gantt_link_point")){n.locateClassName(a,"task_start_date")&&(s=!0);var l=e.locate(r);o=l;var c=e.getTask(l);if(e.isReadonly(c))return m(),!1;return this._dir_start=g(c,!!s,0,t.$getConfig(),!0),!0}return!1},this)),_.attachEvent("onAfterDragStart",e.bind(function(t,i){e.config.touch&&e.refreshData(),v(_.config.marker)},this)),_.attachEvent("onDragMove",e.bind(function(o,s){var l=_.config,c=p(s,l.marker);!function(t,e){t.style.left=e.x+"px",t.style.top=e.y+"px"}(l.marker,c);var u=!!n.locateClassName(s,"gantt_link_control"),d=r,h=i,f=a,m=e.locate(s),b=!0;if(n.isChildOf(s.target||s.srcElement,e.$root)||(u=!1,m=null),u&&(b=!n.locateClassName(s,"task_end_date"),u=!!m),r=m,i=u,a=b,u){var k=e.getTask(m),w=t.$getConfig(),x=n.locateClassName(s,"gantt_link_control"),$=0;x&&($=Math.floor(x.offsetWidth/2)),this._dir_end=g(k,!!a,$,w)}else this._dir_end=n.getRelativeEventPosition(s,t.$task_data),e.env.isEdge&&(this._dir_end.y+=window.scrollY);var S=!(h==u&&d==m&&f==b);return S&&(d&&e.refreshTask(d,!1),m&&e.refreshTask(m,!1)),S&&v(l.marker),y(this._dir_start.x,this._dir_start.y,this._dir_end.x,this._dir_end.y),!0},this)),_.attachEvent("onDragEnd",e.bind(function(){var t=u();if(t.link_source_id&&t.link_target_id&&t.link_source_id!=t.link_target_id){var i=e._get_link_type(t.link_from_start,t.link_to_start),n={source:t.link_source_id,target:t.link_target_id,type:i};n.type&&e.isLinkAllowed(n)&&e.callEvent("onLinkCreated",[n])&&e.addLink(n)}m(),e.config.touch?e.refreshData():(t.link_source_id&&e.refreshTask(t.link_source_id,!1),t.link_target_id&&e.refreshTask(t.link_target_id,!1)),_._direction&&(_._direction.parentNode&&_._direction.parentNode.removeChild(_._direction),_._direction=null)},this)),e.attachEvent("onGanttRender",e.bind(function(){_._direction&&y(this._dir_start.x,this._dir_start.y,this._dir_end.x,this._dir_end.y)},this))};t.exports={createLinkDND:function(){return{init:r}}}},function(t,e,i){var n=i(1),r=i(0),a=i(36),o=i(2);t.exports={createTaskDND:function(){var t;return{extend:function(e){e.roundTaskDates=function(e){t.round_task_dates(e)}},init:function(e,i){return t=function(t,e){var i=e.$services;return{drag:null,dragMultiple:{},_events:{before_start:{},before_finish:{},after_finish:{}},_handlers:{},init:function(){this._domEvents=e._createDomEventScope(),this.clear_drag_state();var t=e.config.drag_mode;this.set_actions(),i.getService("state").registerProvider("tasksDnd",r.bind(function(){return{drag_id:this.drag?this.drag.id:void 0,drag_mode:this.drag?this.drag.mode:void 0,drag_from_start:this.drag?this.drag.left:void 0}},this));var n={before_start:"onBeforeTaskDrag",before_finish:"onBeforeTaskChanged",after_finish:"onAfterTaskDrag"};for(var a in this._events)for(var o in t)this._events[a][o]=n[a];this._handlers[t.move]=this._move,this._handlers[t.resize]=this._resize,this._handlers[t.progress]=this._resize_progress},set_actions:function(){var i=t.$task_data;this._domEvents.attach(i,"mousemove",e.bind(function(t){this.on_mouse_move(t||event)},this)),this._domEvents.attach(i,"mousedown",e.bind(function(t){this.on_mouse_down(t||event)},this)),this._domEvents.attach(e.$root,"mouseup",e.bind(function(t){this.on_mouse_up(t||event)},this))},clear_drag_state:function(){this.drag={id:null,mode:null,pos:null,start_x:null,start_y:null,obj:null,left:null},this.dragMultiple={}},_resize:function(i,n,r){var a=t.$getConfig(),o=this._drag_task_coords(i,r);r.left?(i.start_date=e.dateFromPos(o.start+n),i.start_date||(i.start_date=new Date(e.getState().min_date))):(i.end_date=e.dateFromPos(o.end+n),i.end_date||(i.end_date=new Date(e.getState().max_date)));var s=this._calculateMinDuration(a.min_duration,a.duration_unit);i.end_date-i.start_date<a.min_duration&&(r.left?i.start_date=e.calculateEndDate(i.end_date,-s,a.duration_unit,i):i.end_date=e.calculateEndDate(i.start_date,s,a.duration_unit,i)),e._init_task_timing(i)},_calculateMinDuration:function(t,e){return Math.ceil(t/{minute:6e4,hour:36e5,day:864e5,week:6048e5,month:24192e5,year:31356e6}[e])},_resize_progress:function(e,i,n){var r=this._drag_task_coords(e,n),a=t.$getConfig().rtl?r.start-n.pos.x:n.pos.x-r.start,o=Math.max(0,a);e.progress=Math.min(1,o/Math.abs(r.end-r.start))},_find_max_shift:function(t,i){var n;for(var r in t){var a=t[r],o=e.getTask(a.id),s=this._drag_task_coords(o,a),l=e.posFromDate(new Date(e.getState().min_date)),c=e.posFromDate(new Date(e.getState().max_date));if(s.end+i>c){var u=c-s.end;(u<n||void 0===n)&&(n=u)}else if(s.start+i<l){var d=l-s.start;(d>n||void 0===n)&&(n=d)}}return n},_move:function(t,i,n){var r=this._drag_task_coords(t,n),a=e.dateFromPos(r.start+i),o=e.dateFromPos(r.end+i);a?o?(t.start_date=a,t.end_date=o):(t.end_date=new Date(e.getState().max_date),t.start_date=e.dateFromPos(e.posFromDate(t.end_date)-(r.end-r.start))):(t.start_date=new Date(e.getState().min_date),t.end_date=e.dateFromPos(e.posFromDate(t.start_date)+(r.end-r.start)))},_drag_task_coords:function(t,i){return{start:i.obj_s_x=i.obj_s_x||e.posFromDate(t.start_date),end:i.obj_e_x=i.obj_e_x||e.posFromDate(t.end_date)}},_mouse_position_change:function(t,e){var i=t.x-e.x,n=t.y-e.y;return Math.sqrt(i*i+n*n)},_is_number:function(t){return!isNaN(parseFloat(t))&&isFinite(t)},on_mouse_move:function(t){if(this.drag.start_drag){var i=n.getRelativeEventPosition(t,e.$task_data),r=this.drag.start_drag.start_x,o=this.drag.start_drag.start_y;(Date.now()-this.drag.timestamp>50||this._is_number(r)&&this._is_number(o)&&this._mouse_position_change({x:r,y:o},i)>20)&&this._start_dnd(t)}if(this.drag.mode){if(!a(this,40))return;this._update_on_move(t)}},_update_item_on_move:function(t,i,n,r,a){var o=e.getTask(i),s=e.mixin({},o),l=e.mixin({},o);this._handlers[n].apply(this,[l,t,r]),e.mixin(o,l,!0),e.callEvent("onTaskDrag",[o.id,n,l,s,a]),e.mixin(o,l,!0),e.refreshTask(i)},_update_on_move:function(i){var a=this.drag,o=t.$getConfig();if(a.mode){var s=n.getRelativeEventPosition(i,t.$task_data);if(a.pos&&a.pos.x==s.x)return;a.pos=s;var l=e.dateFromPos(s.x);if(!l||isNaN(l.getTime()))return;var c=s.x-a.start_x,u=e.getTask(a.id);if(this._handlers[a.mode]){if(a.mode===o.drag_mode.move){var d={};if(this._isMultiselect()&&e.getSelectedTasks().indexOf(a.id)>=0&&(d=this.dragMultiple),e.isSummaryTask(u)&&e.config.drag_project){var h={};h[a.id]=r.copy(a),d=r.mixin(h,this.dragMultiple)}var f=this._find_max_shift(d,c);for(var _ in void 0!==f&&(c=f),this._update_item_on_move(c,a.id,a.mode,a,i),d){var g=d[_];this._update_item_on_move(c,g.id,g.mode,g,i)}}else this._update_item_on_move(c,a.id,a.mode,a,i);e._update_parents(a.id)}}},on_mouse_down:function(i,r){if(2!=i.button||void 0===i.button){var a=t.$getConfig(),o=e.locate(i),s=null;if(e.isTaskExists(o)&&(s=e.getTask(o)),!e.isReadonly(s)&&!this.drag.mode){this.clear_drag_state(),r=r||i.target||i.srcElement;var l=n.getClassName(r),c=this._get_drag_mode(l,r);if(!l||!c)return r.parentNode?this.on_mouse_down(i,r.parentNode):void 0;if(c)if(c.mode&&c.mode!=a.drag_mode.ignore&&a["drag_"+c.mode]){if(o=e.locate(r),s=e.copy(e.getTask(o)||{}),e.isReadonly(s))return this.clear_drag_state(),!1;if(e.isSummaryTask(s)&&!a.drag_project&&c.mode!=a.drag_mode.progress)return void this.clear_drag_state();c.id=o;var u=n.getRelativeEventPosition(i,e.$task_data);c.start_x=u.x,c.start_y=u.y,c.obj=s,this.drag.start_drag=c,this.drag.timestamp=Date.now()}else this.clear_drag_state();else if(e.checkEvent("onMouseDown")&&e.callEvent("onMouseDown",[l.split(" ")[0]])&&r.parentNode)return this.on_mouse_down(i,r.parentNode)}}},_fix_dnd_scale_time:function(i,n){var r=t.$getConfig(),a=e.getScale().unit,o=e.getScale().step;function s(i){if(e.config.correct_work_time){var n=t.$getConfig();e.isWorkTime(i.start_date,void 0,i)||(i.start_date=e.calculateEndDate({start_date:i.start_date,duration:-1,unit:n.duration_unit,task:i}))}}r.round_dnd_dates||(a="minute",o=r.time_step),n.mode==r.drag_mode.resize?n.left?(i.start_date=e.roundDate({date:i.start_date,unit:a,step:o}),s(i)):(i.end_date=e.roundDate({date:i.end_date,unit:a,step:o}),function(i){if(e.config.correct_work_time){var n=t.$getConfig();e.isWorkTime(new Date(i.end_date-1),void 0,i)||(i.end_date=e.calculateEndDate({start_date:i.end_date,duration:1,unit:n.duration_unit,task:i}))}}(i)):n.mode==r.drag_mode.move&&(i.start_date=e.roundDate({date:i.start_date,unit:a,step:o}),s(i),i.end_date=e.calculateEndDate(i))},_fix_working_times:function(i,n){var r=t.$getConfig();(n=n||{mode:r.drag_mode.move}).mode==r.drag_mode.resize?n.left?i.start_date=e.getClosestWorkTime({date:i.start_date,dir:"future",task:i}):i.end_date=e.getClosestWorkTime({date:i.end_date,dir:"past",task:i}):n.mode==r.drag_mode.move&&e.correctTaskWorkTime(i)},_finalize_mouse_up:function(t,i,n,r){var a=e.getTask(t);if(i.work_time&&i.correct_work_time&&this._fix_working_times(a,n),this._fix_dnd_scale_time(a,n),this._fireEvent("before_finish",n.mode,[t,n.mode,e.copy(n.obj),r])){var o=t;e._init_task_timing(a),this.clear_drag_state(),e.updateTask(a.id),this._fireEvent("after_finish",n.mode,[o,n.mode,r])}else this.clear_drag_state(),t==n.id&&(n.obj._dhx_changed=!1,e.mixin(a,n.obj,!0)),e.refreshTask(a.id)},on_mouse_up:function(i){var n=this.drag;if(n.mode&&n.id){var r=t.$getConfig(),a=e.getTask(n.id),o=this.dragMultiple;if(n.mode===r.drag_mode.move&&(e.isSummaryTask(a)&&r.drag_project||this._isMultiselect()))for(var s in o)this._finalize_mouse_up(o[s].id,r,o[s],i);this._finalize_mouse_up(n.id,r,n,i)}this.clear_drag_state()},_get_drag_mode:function(e,i){var n=t.$getConfig().drag_mode,r={mode:null,left:null};switch((e||"").split(" ")[0]){case"gantt_task_line":case"gantt_task_content":r.mode=n.move;break;case"gantt_task_drag":r.mode=n.resize;var a=i.getAttribute("data-bind-property");r.left="start_date"==a;break;case"gantt_task_progress_drag":r.mode=n.progress;break;case"gantt_link_control":case"gantt_link_point":r.mode=n.ignore;break;default:r=null}return r},_start_dnd:function(i){var n=this.drag=this.drag.start_drag;delete n.start_drag;var r=t.$getConfig(),a=n.id;if(r["drag_"+n.mode]&&e.callEvent("onBeforeDrag",[a,n.mode,i])&&this._fireEvent("before_start",n.mode,[a,n.mode,i])){delete n.start_drag;var s=e.getTask(a);if(e.isReadonly(s))return void this.clear_drag_state();if(this._isMultiselect()){var l=e.getSelectedTasks();l.indexOf(n.id)>=0&&o.forEach(l,e.bind(function(t){var i=e.getTask(t);e.isSummaryTask(i)&&e.config.drag_project&&n.mode==r.drag_mode.move&&this._addSubtasksToDragMultiple(i.id),this.dragMultiple[t]=e.mixin({id:i.id,obj:e.copy(i)},this.drag)},this))}e.isSummaryTask(s)&&e.config.drag_project&&n.mode==r.drag_mode.move&&this._addSubtasksToDragMultiple(s.id),e.callEvent("onTaskDragStart",[])}else this.clear_drag_state()},_fireEvent:function(t,i,n){e.assert(this._events[t],"Invalid stage:{"+t+"}");var r=this._events[t][i];return e.assert(r,"Unknown after drop mode:{"+i+"}"),e.assert(n,"Invalid event arguments"),!e.checkEvent(r)||e.callEvent(r,n)},round_task_dates:function(e){var i=this.drag,n=t.$getConfig();i||(i={mode:n.drag_mode.move}),this._fix_dnd_scale_time(e,i)},destructor:function(){this._domEvents.detachAll()},_isMultiselect:function(){return e.config.drag_multiple&&!!(e.getSelectedTasks&&e.getSelectedTasks().length>0)},_addSubtasksToDragMultiple:function(t){e.eachTask(function(t){this.dragMultiple[t.id]=e.mixin({id:t.id,obj:e.copy(t)},this.drag)},t,this)}}}(e,i),e._tasks_dnd=t,t.init(i)},destructor:function(){t&&(t.destructor(),t=null)}}}}},function(t,e,i){var n=i(0),r=i(107),a=i(106),o=i(1),s=function(t){var e=t.$services;return{onCreated:function(e){var o=e.$config;o.bind=n.defined(o.bind)?o.bind:"task",o.bindLinks=n.defined(o.bindLinks)?o.bindLinks:"link",e._linksDnD=a.createLinkDND(),e._tasksDnD=r.createTaskDND(),e._tasksDnD.extend(e),this._mouseDelegates=i(12)(t)},onInitialized:function(e){this._attachDomEvents(t),this._attachStateProvider(t,e),e._tasksDnD.init(e,t),e._linksDnD.init(e,t),"timeline"==e.$config.id&&this.extendDom(e)},onDestroyed:function(e){this._clearDomEvents(t),this._clearStateProvider(t),e._tasksDnD&&e._tasksDnD.destructor()},extendDom:function(e){t.$task=e.$task,t.$task_scale=e.$task_scale,t.$task_data=e.$task_data,t.$task_bg=e.$task_bg,t.$task_links=e.$task_links,t.$task_bars=e.$task_bars},_clearDomEvents:function(){this._mouseDelegates.destructor(),this._mouseDelegates=null},_attachDomEvents:function(t){function e(e,i){if(e&&this.callEvent("onLinkDblClick",[e,i])){var n=this.getLink(e);if(this.isReadonly(n))return;var r=this.locale.labels.link+" "+this.templates.link_description(this.getLink(e))+" "+this.locale.labels.confirm_link_deleting;window.setTimeout(function(){t._dhtmlx_confirm(r,"",function(){t.deleteLink(e)})},this.config.touch?300:1)}}this._mouseDelegates.delegate("click","gantt_task_link",t.bind(function(t,e){var i=this.locate(t,this.config.link_attribute);i&&this.callEvent("onLinkClick",[i,t])},t),this.$task),this._mouseDelegates.delegate("click","gantt_scale_cell",t.bind(function(e,i){var n=o.getRelativeEventPosition(e,t.$task_data),r=t.dateFromPos(n.x),a=Math.floor(t.columnIndexByDate(r)),s=t.getScale().trace_x[a];t.callEvent("onScaleClick",[e,s])},t),this.$task),this._mouseDelegates.delegate("doubleclick","gantt_task_link",t.bind(function(i,n,r){n=this.locate(i,t.config.link_attribute),e.call(this,n,i)},t),this.$task),this._mouseDelegates.delegate("doubleclick","gantt_link_point",t.bind(function(t,i,n){i=this.locate(t);var r=this.getTask(i),a=null;return n.parentNode&&o.getClassName(n.parentNode)&&(a=o.getClassName(n.parentNode).indexOf("_left")>-1?r.$target[0]:r.$source[0]),a&&e.call(this,a,t),!1},t),this.$task)},_attachStateProvider:function(t,i){var n=i;e.getService("state").registerProvider("tasksTimeline",function(){return{scale_unit:n._tasks?n._tasks.unit:void 0,scale_step:n._tasks?n._tasks.step:void 0}})},_clearStateProvider:function(){e.getService("state").unregisterProvider("tasksTimeline")}}};t.exports=s},function(t,e,i){var n=i(1);function r(t,e){var i=n.getNodePosition(e.$grid_data);return t.x+=i.x-e.$grid.scrollLeft,t.y+=i.y-e.$grid_data.scrollTop,t}t.exports={removeLineHighlight:function(t){t.markerLine&&t.markerLine.parentNode&&t.markerLine.parentNode.removeChild(t.markerLine),t.markerLine=null},highlightPosition:function(t,e,i){var a=function(t,e){var i=n.getNodePosition(e.$grid_data),r=n.getRelativeEventPosition(t,e.$grid_data),a=e.$config.rowStore,o=i.x,s=r.y-10,l=e.$getConfig();s<i.y&&(s=i.y);var c=a.countVisible()*l.row_height;return s>i.y+c-l.row_height&&(s=i.y+c-l.row_height),i.x=o,i.y=s,i}(t,i);e.marker.style.left=a.x+9+"px",e.marker.style.top=a.y+"px";var o=e.markerLine;o||((o=document.createElement("div")).className="gantt_drag_marker gantt_grid_dnd_marker",o.innerHTML="<div class='gantt_grid_dnd_marker_line'></div>",o.style.pointerEvents="none",document.body.appendChild(o),e.markerLine=o),t.child?function(t,e,i){var n=t.targetParent,a=r({x:0,y:i.getItemTop(n)},i);e.innerHTML="<div class='gantt_grid_dnd_marker_folder'></div>",e.style.width=i.$grid_data.offsetWidth+"px",e.style.top=a.y+"px",e.style.left=a.x+"px",e.style.height=i.getItemHeight(n)+"px"}(t,o,i):function(t,e,i){var n=function(t,e){var i=e.$config.rowStore,n={x:0,y:0},a=e.$grid_data.querySelector(".gantt_tree_indent"),o=15,s=0;if(a&&(o=a.offsetWidth),t.targetId!==i.$getRootId()){var l=e.getItemTop(t.targetId),c=e.getItemHeight(t.targetId);if(s=i.exists(t.targetId)?i.calculateItemLevel(i.getItem(t.targetId)):0,t.prevSibling)n.y=l;else if(t.nextSibling){var u=0;i.eachItem(function(t){-1!==i.getIndexById(t.id)&&u++},t.targetId),n.y=l+c+u*c}else n.y=l+c,s+=1}return n.x=40+s*o,n.width=Math.max(e.$grid_data.offsetWidth-n.x,0),r(n,e)}(t,i);e.innerHTML="<div class='gantt_grid_dnd_marker_line'></div>",e.style.left=n.x+"px",e.style.height="4px",e.style.top=n.y-2+"px",e.style.width=n.width+"px"}(t,o,i)}}},function(t,e,i){var n=i(11);t.exports=function(t,e,i,r,a){var o;if(e!==a.$getRootId())o=i<.25?n.prevSiblingTarget(t,e,a):!(i>.6)||a.hasChild(e)&&a.getItem(e).$open?n.firstChildTarget(t,e,a):n.nextSiblingTarget(t,e,a);else{var s=a.$getRootId();o=a.hasChild(s)&&r>=0?n.lastChildTarget(t,s,a):n.firstChildTarget(t,s,a)}return o}},function(t,e,i){var n=i(11);function r(t,e,i,r,a){for(var o=e;r.exists(o);){var s=r.calculateItemLevel(r.getItem(o));if((s===i||s===i-1)&&r.getBranchIndex(o)>-1)break;o=a?r.getPrev(o):r.getNext(o)}return r.exists(o)?r.calculateItemLevel(r.getItem(o))===i?a?n.nextSiblingTarget(t,o,r):n.prevSiblingTarget(t,o,r):n.firstChildTarget(t,o,r):null}function a(t,e,i,n){return r(t,e,i,n,!0)}function o(t,e,i,n){return r(t,e,i,n,!1)}t.exports=function(t,e,i,r,s,l){var c;if(e!==s.$getRootId())i<.5?s.calculateItemLevel(s.getItem(e))===l?c=s.getPrevSibling(e)?n.nextSiblingTarget(t,s.getPrevSibling(e),s):n.prevSiblingTarget(t,e,s):(c=a(t,e,l,s))&&(c=o(t,e,l,s)):s.calculateItemLevel(s.getItem(e))===l?c=n.nextSiblingTarget(t,e,s):(c=o(t,e,l,s))&&(c=a(t,e,l,s));else{var u=s.$getRootId(),d=s.getChildren(u);c=n.createDropTargetObject(),c=d.length&&r>=0?a(t,function(t){for(var e=t.getNext();t.exists(e);){var i=t.getNext(e);if(!t.exists(i))return e;e=i}return null}(s),l,s):o(t,u,l,s)}return c}},function(t,e,i){var n=i(1),r=i(11),a=i(111),o=i(110),s=i(109);t.exports={init:function(t,e){var i=t.$services.getService("dnd");if(e.$config.bind&&t.getDatastore(e.$config.bind)){var l=new i(e.$grid_data,{updates_per_second:60});t.defined(e.$getConfig().dnd_sensitivity)&&(l.config.sensitivity=e.$getConfig().dnd_sensitivity),l.attachEvent("onBeforeDragStart",t.bind(function(i,r){var a=c(r);if(!a)return!1;if(t.hideQuickInfo&&t._hideQuickInfo(),n.closest(r.target,".gantt_grid_editor_placeholder"))return!1;var o=a.getAttribute(e.$config.item_attribute),s=e.$config.rowStore.getItem(o);return!t.isReadonly(s)&&(l.config.initial_open_state=s.$open,!!t.callEvent("onRowDragStart",[o,r.target||r.srcElement,r])&&void 0)},t)),l.attachEvent("onAfterDragStart",t.bind(function(t,i){var n=c(i);l.config.marker.innerHTML=n.outerHTML;var a=l.config.marker.firstChild;a&&(l.config.marker.style.opacity=.4,a.style.position="static",a.style.pointerEvents="none"),l.config.id=n.getAttribute(e.$config.item_attribute);var o=e.$config.rowStore,s=o.getItem(l.config.id);l.config.level=o.calculateItemLevel(s),l.config.drop_target=r.createDropTargetObject({targetParent:o.getParent(s.id),targetIndex:o.getBranchIndex(s.id),targetId:s.id,nextSibling:!0}),s.$open=!1,s.$transparent=!0,this.refreshData()},t)),l.attachEvent("onDragMove",t.bind(function(i,n){var a=u(n);return a&&!1!==t.callEvent("onBeforeRowDragMove",[l.config.id,a.targetParent,a.targetIndex])||(a=r.createDropTargetObject(l.config.drop_target)),s.highlightPosition(a,l.config,e),l.config.drop_target=a,this.callEvent("onRowDragMove",[l.config.id,a.targetParent,a.targetIndex]),!0},t)),l.attachEvent("onDragEnd",t.bind(function(){var t=e.$config.rowStore,i=t.getItem(l.config.id);s.removeLineHighlight(l.config),i.$transparent=!1,i.$open=l.config.initial_open_state;var n=l.config.drop_target;!1===this.callEvent("onBeforeRowDragEnd",[l.config.id,n.targetParent,n.targetIndex])?i.$drop_target=null:(t.move(l.config.id,n.targetIndex,n.targetParent),this.callEvent("onRowDragEnd",[l.config.id,n.targetParent,n.targetIndex])),t.refresh(i.id)},t))}function c(t){return n.locateAttribute(t,e.$config.item_attribute)}function u(t){var i=function(t){var i=n.getRelativeEventPosition(t,e.$grid_data).y,r=e.$config.rowStore;if((i=i||0)<0)return r.$getRootId();var a=Math.floor(i/e.getItemHeight());return a>r.countVisible()-1?r.$getRootId():r.getIdByIndex(a)}(t),r=null,s=e.$config.rowStore,c=!e.$getConfig().order_branch_free,u=n.getRelativeEventPosition(t,e.$grid_data).y;return i!==s.$getRootId()&&(r=(u-e.getItemTop(i))/e.getItemHeight()),c?a(l.config.id,i,r,u,s,l.config.level):o(l.config.id,i,r,u,s)}}}},function(t,e,i){var n=i(1);t.exports={init:function(t,e){var i=t.$services.getService("dnd");if(e.$config.bind&&t.getDatastore(e.$config.bind)){var r=new i(e.$grid_data,{updates_per_second:60});t.defined(e.$getConfig().dnd_sensitivity)&&(r.config.sensitivity=e.$getConfig().dnd_sensitivity),r.attachEvent("onBeforeDragStart",t.bind(function(i,s){var l=a(s);if(!l)return!1;if(t.hideQuickInfo&&t._hideQuickInfo(),n.closest(s.target,".gantt_grid_editor_placeholder"))return!1;var c=l.getAttribute(e.$config.item_attribute),u=o().getItem(c);return!t.isReadonly(u)&&(r.config.initial_open_state=u.$open,!!t.callEvent("onRowDragStart",[c,s.target||s.srcElement,s])&&void 0)},t)),r.attachEvent("onAfterDragStart",t.bind(function(t,i){var n=a(i);r.config.marker.innerHTML=n.outerHTML;var s=r.config.marker.firstChild;s&&(s.style.position="static"),r.config.id=n.getAttribute(e.$config.item_attribute);var l=o(),c=l.getItem(r.config.id);r.config.index=l.getBranchIndex(r.config.id),r.config.parent=c.parent,c.$open=!1,c.$transparent=!0,this.refreshData()},t)),r.lastTaskOfLevel=function(t){for(var e=null,i=o().getItems(),n=0,r=i.length;n<r;n++)i[n].$level==t&&(e=i[n]);return e?e.id:null},r._getGridPos=t.bind(function(t){var i=n.getNodePosition(e.$grid_data),r=o(),a=i.x,s=t.pos.y-10,l=e.$getConfig();s<i.y&&(s=i.y);var c=r.countVisible()*l.row_height;return s>i.y+c-l.row_height&&(s=i.y+c-l.row_height),i.x=a,i.y=s,i},t),r._getTargetY=t.bind(function(t){var i=n.getNodePosition(e.$grid_data),r=t.pageY-i.y+(e.$state.scrollTop||0);return r<0&&(r=0),r},t),r._getTaskByY=t.bind(function(t,i){var n=e.$getConfig(),r=o();t=t||0;var a=Math.floor(t/n.row_height);return(a=i<a?a-1:a)>r.countVisible()-1?null:r.getIdByIndex(a)},t),r.attachEvent("onDragMove",t.bind(function(t,i){var n=r.config,a=r._getGridPos(i),s=e.$getConfig(),l=o();n.marker.style.left=a.x+10+"px",n.marker.style.top=a.y+"px";var c=l.getItem(r.config.id),u=r._getTargetY(i),d=r._getTaskByY(u,l.getIndexById(c.id));function h(t,e){return!l.isChildOf(f.id,e.id)&&(t.$level==e.$level||s.order_branch_free)}if(l.exists(d)||(d=r.lastTaskOfLevel(s.order_branch_free?c.$level:0))==r.config.id&&(d=null),l.exists(d)){var f=l.getItem(d);if(l.getIndexById(f.id)*s.row_height+s.row_height/2<u){var _=l.getIndexById(f.id),g=l.getNext(f.id),p=l.getItem(g);if(p){if(p.id==c.id)return s.order_branch_free&&l.isChildOf(c.id,f.id)&&1==l.getChildren(f.id).length?void l.move(c.id,l.getBranchIndex(f.id)+1,l.getParent(f.id)):void 0;f=p}else if(g=l.getIdByIndex(_),h(p=l.getItem(g),c)&&p.id!=c.id)return void l.move(c.id,-1,l.getParent(p.id))}else if(s.order_branch_free&&f.id!=c.id&&h(f,c)){if(!l.hasChild(f.id))return f.$open=!0,void l.move(c.id,-1,f.id);if(l.getIndexById(f.id)||s.row_height/3<u)return}_=l.getIndexById(f.id);for(var v=l.getIdByIndex(_-1),m=l.getItem(v),y=1;(!m||m.id==f.id)&&_-y>=0;)v=l.getIdByIndex(_-y),m=l.getItem(v),y++;if(c.id==f.id)return;h(f,c)&&c.id!=f.id?l.move(c.id,0,0,f.id):f.$level!=c.$level-1||l.getChildren(f.id).length?m&&h(m,c)&&c.id!=m.id&&l.move(c.id,-1,l.getParent(m.id)):l.move(c.id,0,f.id)}return!0},t)),r.attachEvent("onDragEnd",t.bind(function(){var t=o(),e=t.getItem(r.config.id);e.$transparent=!1,e.$open=r.config.initial_open_state,!1===this.callEvent("onBeforeRowDragEnd",[r.config.id,r.config.parent,r.config.index])?(t.move(r.config.id,r.config.index,r.config.parent),e.$drop_target=null):this.callEvent("onRowDragEnd",[r.config.id,e.$drop_target]),this.refreshData()},t))}function a(t){return n.locateAttribute(t,e.$config.item_attribute)}function o(){return t.getDatastore(e.$config.bind)}}}},function(t,e,i){var n=i(0),r=i(113),a=i(112),o=function(t){return{onCreated:function(e){e.$config=n.mixin(e.$config,{bind:"task"}),"grid"==e.$config.id&&(this.extendGantt(e),t.ext.inlineEditors=t.ext._inlineEditors.createEditors(e),t.ext.inlineEditors.init()),this._mouseDelegates=i(12)(t)},onInitialized:function(e){var i=e.$getConfig();i.order_branch&&("marker"==i.order_branch?a.init(e.$gantt,e):r.init(e.$gantt,e)),this.initEvents(e,t),"grid"==e.$config.id&&this.extendDom(e)},onDestroyed:function(e){"grid"==e.$config.id&&t.ext.inlineEditors.destructor(),this.clearEvents(e,t)},initEvents:function(t,e){this._mouseDelegates.delegate("click","gantt_row",e.bind(function(i,n,r){var a=t.$getConfig();if(null!==n){var o=this.getTask(n);a.scroll_on_click&&!e._is_icon_open_click(i)&&this.showDate(o.start_date),e.callEvent("onTaskRowClick",[n,r])}},e),t.$grid),this._mouseDelegates.delegate("click","gantt_grid_head_cell",e.bind(function(i,n,r){var a=r.getAttribute("data-column-id");if(e.callEvent("onGridHeaderClick",[a,i])){var o=t.$getConfig();if("add"!=a){if(o.sort){for(var s,l=a,c=0;c<o.columns.length;c++)if(o.columns[c].name==a){s=o.columns[c];break}if(s&&void 0!==s.sort&&!0!==s.sort&&!(l=s.sort))return;var u=this._sort&&this._sort.direction&&this._sort.name==a?this._sort.direction:"desc";u="desc"==u?"asc":"desc",this._sort={name:a,direction:u},this.sort(l,"desc"==u)}}else e.$services.getService("mouseEvents").callHandler("click","gantt_add",t.$grid,[i,o.root_id])}},e),t.$grid),this._mouseDelegates.delegate("click","gantt_add",e.bind(function(i,n,r){if(!t.$getConfig().readonly)return this.createTask({},n||e.config.root_id),!1},e),t.$grid)},clearEvents:function(t,e){this._mouseDelegates.destructor(),this._mouseDelegates=null},extendDom:function(e){t.$grid=e.$grid,t.$grid_scale=e.$grid_scale,t.$grid_data=e.$grid_data},extendGantt:function(e){t.getGridColumns=t.bind(e.getGridColumns,e),e.attachEvent("onColumnResizeStart",function(){return t.callEvent("onColumnResizeStart",arguments)}),e.attachEvent("onColumnResize",function(){return t.callEvent("onColumnResize",arguments)}),e.attachEvent("onColumnResizeEnd",function(){return t.callEvent("onColumnResizeEnd",arguments)}),e.attachEvent("onColumnResizeComplete",function(e,i){t.config.grid_width=i})}}};t.exports=o},function(t,e,i){var n=i(2),r=i(34),a=i(7);t.exports=function(t){return{render:function(e,i,r){var a=i.getGridColumns(),o=i.$getConfig(),s=i.$getTemplates(),l=i.$config.rowStore;o.rtl&&(a=a.reverse());for(var c=[],u=0;u<a.length;u++){var d,h,f,_=u==a.length-1,g=a[u];"add"==g.name?(h="<div "+(b=t._waiAria.gridAddButtonAttrString(g))+" class='gantt_add'></div>",f=""):(h=g.template?g.template(e):e[g.name],n.isDate(h)&&(h=s.date_grid(h,e,g.name)),null!==h&&void 0!==h||(h=""),f=h,h="<div class='gantt_tree_content'>"+h+"</div>");var p="gantt_cell"+(_?" gantt_last_cell":""),v=[];if(g.tree){for(var m=0;m<e.$level;m++)v.push(s.grid_indent(e));!l.hasChild(e.id)||t.isSplitTask(e)&&!t.config.open_split_tasks?(v.push(s.grid_blank(e)),v.push(s.grid_file(e))):(v.push(s.grid_open(e)),v.push(s.grid_folder(e)))}var y="width:"+(g.width-(_?1:0))+"px;";this.defined(g.align)&&(y+="text-align:"+g.align+";");var b=t._waiAria.gridCellAttrString(g,f,e);v.push(h),o.rtl&&(v=v.reverse()),d="<div class='"+p+"' data-column-index='"+u+"' data-column-name='"+g.name+"' style='"+y+"' "+b+">"+v.join("")+"</div>",c.push(d)}if(p=t.getGlobalTaskIndex(e.id)%2==0?"":" odd",p+=e.$transparent?" gantt_transparent":"",p+=e.$dataprocessor_class?" "+e.$dataprocessor_class:"",s.grid_row_class){var k=s.grid_row_class.call(t,e.start_date,e.end_date,e);k&&(p+=" "+k)}l.isSelected(e.id)&&(p+=" gantt_selected");var w=document.createElement("div");w.className="gantt_row"+p+" gantt_row_"+t.getTaskType(e.type);var x=i.getItemHeight();return w.style.height=x+"px",w.style.lineHeight=x+"px",o.smart_rendering&&(w.style.position="absolute",w.style.left="0px",w.style.top=i.getItemTop(e.id)+"px"),i.$config.item_attribute&&w.setAttribute(i.$config.item_attribute,e.id),t._waiAria.taskRowAttr(e,w),w.innerHTML=c.join(""),w},update:null,getRectangle:r,getVisibleRange:a}}},function(t,e){t.exports=function(t,e,i,n){var r=i.$gantt.getTask(t.source),a=i.$gantt.getTask(t.target),o=i.$getConfig(),s=i.getItemTop(r.id),l=o.row_height,c=i.getItemTop(a.id),u=o.row_height;if(e.y>s+l&&e.y>c+u)return!1;if(e.y_end<c&&e.y_end<c+u)return!1;var d=i.posFromDate(r.start_date),h=i.posFromDate(r.end_date),f=i.posFromDate(a.start_date),_=i.posFromDate(a.end_date);if(d>h){var g=h;h=d,d=g}if(f>_){g=_;_=f,f=g}return d+=-100,h+=100,f+=-100,_+=100,!(e.x>h&&e.x>_)&&!(e.x_end<d&&e.x_end<f)}},function(t,e,i){var n=i(116);t.exports=function(t){var e={current_pos:null,dirs:{left:"left",right:"right",up:"up",down:"down"},path:[],clear:function(){this.current_pos=null,this.path=[]},point:function(e){this.current_pos=t.copy(e)},get_lines:function(t){this.clear(),this.point(t[0]);for(var e=1;e<t.length;e++)this.line_to(t[e]);return this.get_path()},line_to:function(e){var i=t.copy(e),n=this.current_pos,r=this._get_line(n,i);this.path.push(r),this.current_pos=i},get_path:function(){return this.path},get_wrapper_sizes:function(t,e){var i,n=e.$getConfig(),r=n.link_wrapper_width,a=t.y+(n.row_height-r)/2;switch(t.direction){case this.dirs.left:i={top:a,height:r,lineHeight:r,left:t.x-t.size-r/2,width:t.size+r};break;case this.dirs.right:i={top:a,lineHeight:r,height:r,left:t.x-r/2,width:t.size+r};break;case this.dirs.up:i={top:a-t.size,lineHeight:t.size+r,height:t.size+r,left:t.x-r/2,width:r};break;case this.dirs.down:i={top:a,lineHeight:t.size+r,height:t.size+r,left:t.x-r/2,width:r}}return i},get_line_sizes:function(t,e){var i,n=e.$getConfig(),r=n.link_line_width,a=n.link_wrapper_width,o=t.size+r;switch(t.direction){case this.dirs.left:case this.dirs.right:i={height:r,width:o,marginTop:(a-r)/2,marginLeft:(a-r)/2};break;case this.dirs.up:case this.dirs.down:i={height:o,width:r,marginTop:(a-r)/2,marginLeft:(a-r)/2}}return i},render_line:function(t,e,i){var n=this.get_wrapper_sizes(t,i),r=document.createElement("div");r.style.cssText=["top:"+n.top+"px","left:"+n.left+"px","height:"+n.height+"px","width:"+n.width+"px"].join(";"),r.className="gantt_line_wrapper";var a=this.get_line_sizes(t,i),o=document.createElement("div");return o.style.cssText=["height:"+a.height+"px","width:"+a.width+"px","margin-top:"+a.marginTop+"px","margin-left:"+a.marginLeft+"px"].join(";"),o.className="gantt_link_line_"+t.direction,r.appendChild(o),r},_get_line:function(t,e){var i=this.get_direction(t,e),n={x:t.x,y:t.y,direction:this.get_direction(t,e)};return i==this.dirs.left||i==this.dirs.right?n.size=Math.abs(t.x-e.x):n.size=Math.abs(t.y-e.y),n},get_direction:function(t,e){return e.x<t.x?this.dirs.left:e.x>t.x?this.dirs.right:e.y>t.y?this.dirs.down:this.dirs.up}},i={path:[],clear:function(){this.path=[]},current:function(){return this.path[this.path.length-1]},point:function(e){return e?(this.path.push(t.copy(e)),e):this.current()},point_to:function(i,n,r){r=r?{x:r.x,y:r.y}:t.copy(this.point());var a=e.dirs;switch(i){case a.left:r.x-=n;break;case a.right:r.x+=n;break;case a.up:r.y-=n;break;case a.down:r.y+=n}return this.point(r)},get_points:function(i,n){var r=this.get_endpoint(i,n),a=t.config,o=r.e_y-r.y,s=r.e_x-r.x,l=e.dirs;this.clear(),this.point({x:r.x,y:r.y});var c=2*a.link_arrow_size,u=this.get_line_type(i,n.$getConfig()),d=r.e_x>r.x;if(u.from_start&&u.to_start)this.point_to(l.left,c),d?(this.point_to(l.down,o),this.point_to(l.right,s)):(this.point_to(l.right,s),this.point_to(l.down,o)),this.point_to(l.right,c);else if(!u.from_start&&u.to_start)if(d=r.e_x>r.x+2*c,this.point_to(l.right,c),d)s-=c,this.point_to(l.down,o),this.point_to(l.right,s);else{s-=2*c;var h=o>0?1:-1;this.point_to(l.down,h*(a.row_height/2)),this.point_to(l.right,s),this.point_to(l.down,h*(Math.abs(o)-a.row_height/2)),this.point_to(l.right,c)}else u.from_start||u.to_start?u.from_start&&!u.to_start&&(d=r.e_x>r.x-2*c,this.point_to(l.left,c),d?(s+=2*c,h=o>0?1:-1,this.point_to(l.down,h*(a.row_height/2)),this.point_to(l.right,s),this.point_to(l.down,h*(Math.abs(o)-a.row_height/2)),this.point_to(l.left,c)):(s+=c,this.point_to(l.down,o),this.point_to(l.right,s))):(this.point_to(l.right,c),d?(this.point_to(l.right,s),this.point_to(l.down,o)):(this.point_to(l.down,o),this.point_to(l.right,s)),this.point_to(l.left,c));return this.path},get_line_type:function(e,i){var n=i.links,r=!1,a=!1;return e.type==n.start_to_start?r=a=!0:e.type==n.finish_to_finish?r=a=!1:e.type==n.finish_to_start?(r=!1,a=!0):e.type==n.start_to_finish?(r=!0,a=!1):t.assert(!1,"Invalid link type"),i.rtl&&(r=!r,a=!a),{from_start:r,to_start:a}},get_endpoint:function(e,i){var n=i.$getConfig(),a=this.get_line_type(e,n),o=a.from_start,s=a.to_start,l=t.getTask(e.source),c=t.getTask(e.target),u=r(l,i),d=r(c,i);return{x:o?u.left:u.left+u.width,e_x:s?d.left:d.left+d.width,y:u.top,e_y:d.top}}};function r(e,i){var n=i.$getConfig(),r=i.getItemPosition(e);if(t.getTaskType(e.type)==n.types.milestone){var a=t.getTaskHeight(),o=Math.sqrt(2*a*a);r.left-=o/2,r.width=o}return r}return{render:function(n,r){var a=r.$getConfig(),o=i.get_endpoint(n,r),s=o.e_y-o.y;if(!(o.e_x-o.x||s))return null;var l=i.get_points(n,r),c=e.get_lines(l,r),u=document.createElement("div"),d="gantt_task_link";n.color&&(d+=" gantt_link_inline_color");var h=t.templates.link_class?t.templates.link_class(n):"";h&&(d+=" "+h),a.highlight_critical_path&&t.isCriticalLink&&t.isCriticalLink(n)&&(d+=" gantt_critical_link"),u.className=d,r.$config.link_attribute&&u.setAttribute(r.$config.link_attribute,n.id);for(var f=0;f<c.length;f++){f==c.length-1&&(c[f].size-=a.link_arrow_size);var _=e.render_line(c[f],c[f+1],r);n.color&&(_.firstChild.style.backgroundColor=n.color),u.appendChild(_)}var g=c[c.length-1].direction,p=function(t,i,n){var r=n.$getConfig(),a=document.createElement("div"),o=t.y,s=t.x,l=r.link_arrow_size,c=r.row_height,u="gantt_link_arrow gantt_link_arrow_"+i;switch(i){case e.dirs.right:o-=(l-c)/2,s-=l;break;case e.dirs.left:o-=(l-c)/2;break;case e.dirs.up:s-=l;break;case e.dirs.down:o+=2*l,s-=l}return a.style.cssText=["top:"+o+"px","left:"+s+"px"].join(";"),a.className=u,a}(l[l.length-1],g,r);return n.color&&(p.style.borderColor=n.color),u.appendChild(p),t._waiAria.linkAttr(n,u),u},update:null,isInViewPort:n}}},function(t,e,i){var n=i(28),r=i(15),a=i(7),o=i(27);t.exports=function(t){var e={},i={};function s(t,i){return!(!e[t.id][i]||!e[t.id][i].parentNode)}function l(t,i){e[t]&&e[t][i]&&e[t][i].parentNode&&e[t][i].parentNode.removeChild(e[t][i])}function c(t){var e,i=t.$getTemplates();return void 0!==i.task_cell_class?(e=i.task_cell_class,(console.warn||console.log)("gantt.templates.task_cell_class template is deprecated and will be removed soon. Please use gantt.templates.timeline_cell_class instead.")):e=i.timeline_cell_class,e}function u(n,a,o,s,l,c,u){var d=n.width[a],h="";if(function(e,i,n){var a=i.width[e];if(a<=0)return!1;if(!t.config.smart_rendering||r(t))return!0;var o=i.left[e]-a,s=i.left[e]+a;return o<=n.x_end&&s>=n.x}(a,n,s)){var f=c(o,n.trace_x[a]);if(u.static_background&&(!u.static_background_cells||!f))return null;if(e[o.id][a])return i[o.id][a]=a,e[o.id][a];var _=document.createElement("div");return _.style.width=d+"px",h="gantt_task_cell"+(a==l-1?" gantt_last_cell":""),f&&(h+=" "+f),_.className=h,_.style.position="absolute",_.style.left=n.left[a]+"px",e[o.id][a]=_,i[o.id][a]=a,_}return null}return{render:function(n,a,s){var l=a.$getConfig(),d=a.$getTemplates(),h=a.getScale(),f=h.count;if(l.static_background&&!l.static_background_cells)return null;var _,g=document.createElement("div"),p=c(a);if(_=s&&l.smart_rendering&&!r(t)?o(h,s.x):{start:0,end:f-1},l.show_task_cells){e[n.id]={},i[n.id]={};for(var v=_.start;v<=_.end;v++){var m=u(h,v,n,s,f,p,l);m&&g.appendChild(m)}}var y=t.getGlobalTaskIndex(n.id)%2!=0,b=d.task_row_class(n.start_date,n.end_date,n),k="gantt_task_row"+(y?" odd":"")+(b?" "+b:"");return a.$config.rowStore.isSelected(n.id)&&(k+=" gantt_selected"),g.className=k,l.smart_rendering?(g.style.position="absolute",g.style.top=a.getItemTop(n.id)+"px",g.style.width="100%"):g.style.position="relative",g.style.height=l.row_height+"px",a.$config.item_attribute&&g.setAttribute(a.$config.item_attribute,n.id),g},update:function(t,n,r,a){var d=r.$getConfig(),h=r.getScale(),f=h.count,_=c(r);if(d.show_task_cells){e[t.id]||(e[t.id]={}),i[t.id]||(i[t.id]={});var g=o(h,a);for(var p in i[t.id]){var v=i[t.id][p];(Number(v)<g.start||Number(v)>g.end)&&l(t.id,v)}i[t.id]={};for(var m=g.start;m<=g.end;m++){var y=u(h,m,t,a,f,_,d);!y&&s(t,m)?l(t.id,m):y&&!y.parentNode&&n.appendChild(y)}}},getRectangle:n,getVisibleRange:a}}},function(t,e,i){var n=i(29),r=i(30),a=i(7);t.exports=function(t){var e=n(t);return{render:function(i,n){if(t.isSplitTask(i)&&(t.config.open_split_tasks&&!i.$open||!t.config.open_split_tasks)){for(var r=document.createElement("div"),a=t.getTaskPosition(i),o=t.getChildren(i.id),s=0;s<o.length;s++){var l=t.getTask(o[s]),c=e(l,n);if(c){var u=Math.floor((t.config.row_height-a.height)/2);c.style.top=a.top+u+"px",c.className+=" gantt_split_child",r.appendChild(c)}}return r}return!1},update:null,isInViewPort:r,getVisibleRange:a}}},function(t,e,i){var n=i(30),r=i(7),a=i(29);t.exports=function(t){return{render:a(t),update:null,isInViewPort:n,getVisibleRange:r}}},function(t,e){t.exports=function(t){return function(e,i,n){"keepDates"==n?function(e,i){"duration"==i?e.end_date=t.calculateEndDate(e):"end_date"!=i&&"start_date"!=i||(e.duration=t.calculateDuration(e))}(e,i):"keepDuration"==n?function(e,i){"end_date"==i?e.start_date=t.calculateEndDate({start_date:e.end_date,duration:-e.duration,task:e}):"start_date"!=i&&"duration"!=i||(e.end_date=t.calculateEndDate(e))}(e,i):function(e,i){"start_date"==i||"duration"==i?e.end_date=t.calculateEndDate(e):"end_date"==i&&(e.duration=t.calculateDuration(e))}(e,i)}}},function(t,e,i){t.exports=function(t){var e=i(6)(t),n=i(0);function r(){return e.apply(this,arguments)||this}function a(e){return e.formatter||t.ext.formatters.durationFormatter()}return i(3)(r,e),n.mixin(r.prototype,{show:function(t,e,i,n){var r="<div><input type='text' name='"+e.name+"'></div>";n.innerHTML=r},set_value:function(t,e,i,n){this.get_input(n).value=a(i.editor).format(t)},get_value:function(t,e,i){return a(e.editor).parse(this.get_input(i).value||"")}},!0),r}},function(t,e,i){t.exports=function(t){var e=i(6)(t),n=i(0);function r(){return e.apply(this,arguments)||this}function a(e){return e.formatter||t.ext.formatters.linkFormatter()}function o(t,e){for(var i=(t||"").split(e.delimiter||","),n=0;n<i.length;n++){var r=i[n].trim();r?i[n]=r:(i.splice(n,1),n--)}return i.sort(),i}function s(t,e,i){for(var n=t.$target,r=[],o=0;o<n.length;o++){var s=i.getLink(n[o]);r.push(a(e).format(s))}return r.join((e.delimiter||",")+" ")}function l(t){return t.source+"_"+t.target+"_"+t.type+"_"+(t.lag||0)}function c(e,i,n){var r=function(e,i,n){var r=[];return i.forEach(function(i){var o=a(n).parse(i);o&&(o.target=e,t.isLinkAllowed(o)&&r.push(o))}),r}(e.id,i,n),o={};e.$target.forEach(function(e){var i=t.getLink(e);o[l(i)]=i.id});var s=[];r.forEach(function(t){var e=l(t);o[e]?delete o[e]:s.push(t)});var c=[];for(var u in o)c.push(o[u]);return{add:s,remove:c}}return i(3)(r,e),n.mixin(r.prototype,{show:function(t,e,i,n){var r="<div><input type='text' name='"+e.name+"'></div>";n.innerHTML=r},hide:function(){},set_value:function(e,i,n,r){this.get_input(r).value=s(e,n.editor,t)},get_value:function(t,e,i){return o(this.get_input(i).value||"",e.editor)},save:function(e,i,n){var r=c(t.getTask(e),this.get_value(e,i,n),i.editor);(r.add.length||r.remove.length)&&t.batchUpdate(function(){r.add.forEach(function(e){t.addLink(e)}),r.remove.forEach(function(e){t.deleteLink(e)}),t.autoSchedule&&t.autoSchedule()})},is_changed:function(e,i,n,r){var a=this.get_value(i,n,r),l=o(s(e,n.editor,t),n.editor);return a.join()!==l.join()}},!0),r}},function(t,e,i){t.exports=function(t){var e=i(6)(t),n=i(0),r="%Y-%m-%d",a=null,o=null;function s(){return e.apply(this,arguments)||this}return i(3)(s,e),n.mixin(s.prototype,{show:function(e,i,n,s){a||(a=t.date.date_to_str(r)),o||(o=t.date.str_to_date(r));var l=null,c=null;l="function"==typeof n.min?n.min(e,i):n.min,c="function"==typeof n.max?n.max(e,i):n.max;var u="<div style='width:140px'><input type='date' "+(l?" min='"+a(l)+"' ":"")+(c?" max='"+a(c)+"' ":"")+" name='"+i.name+"'></div>";s.innerHTML=u},set_value:function(t,e,i,n){t&&t.getFullYear?this.get_input(n).value=a(t):this.get_input(n).value=t},is_valid:function(t,e,i,n){return!(!t||isNaN(t.getTime()))},get_value:function(t,e,i){var n;try{n=o(this.get_input(i).value||"")}catch(t){n=null}return n}},!0),s}},function(t,e,i){t.exports=function(t){var e=i(6)(t),n=i(0);function r(){return e.apply(this,arguments)||this}return i(3)(r,e),n.mixin(r.prototype,{show:function(t,e,i,n){for(var r="<div><select name='"+e.name+"'>",a=[],o=i.options||[],s=0;s<o.length;s++)a.push("<option value='"+i.options[s].key+"'>"+o[s].label+"</option>");r+=a.join("")+"</select></div>",n.innerHTML=r},get_input:function(t){return t.querySelector("select")}},!0),r}},function(t,e,i){t.exports=function(t){var e=i(6)(t),n=i(0);function r(){return e.apply(this,arguments)||this}return i(3)(r,e),n.mixin(r.prototype,{show:function(t,e,i,n){var r="<div><input type='number' min='"+(i.min||0)+"' max='"+(i.max||100)+"' name='"+e.name+"'></div>";n.innerHTML=r},get_value:function(t,e,i){return this.get_input(i).value||""},is_valid:function(t,e,i,n){return!isNaN(parseInt(t,10))}},!0),r}},function(t,e,i){t.exports=function(t){var e=i(6)(t),n=i(0);function r(){return e.apply(this,arguments)||this}return i(3)(r,e),n.mixin(r.prototype,{show:function(t,e,i,n){var r="<div><input type='text' name='"+e.name+"'></div>";n.innerHTML=r}},!0),r}},function(t,e){t.exports={init:function(t,e){var i=t,n=e.$gantt,r=null,a=n.ext.keyboardNavigation;a.attachEvent("onBeforeFocus",function(e){var n=t.locateCell(e);if(clearTimeout(r),n){var a=n.columnName,o=n.id,s=i.getState();if(i.isVisible()&&s.id==o&&s.columnName===a)return!1}return!0}),a.attachEvent("onFocus",function(e){var n=t.locateCell(e),a=t.getState();return clearTimeout(r),!n||n.id==a.id&&n.columnName==a.columnName||i.isVisible()&&i.save(),!0}),t.attachEvent("onHide",function(){clearTimeout(r)}),a.attachEvent("onBlur",function(){return r=setTimeout(function(){i.save()}),!0}),n.attachEvent("onTaskDblClick",function(e,i){var n=t.getState(),r=t.locateCell(i.target);return!r||!t.isVisible()||r.columnName!=n.columnName}),n.attachEvent("onTaskClick",function(e,i){if(n._is_icon_open_click(i))return!0;var r=t.getState(),a=t.locateCell(i.target);return!a||!t.getEditorConfig(a.columnName)||(t.isVisible()&&r.id==a.id&&r.columnName==a.columnName||t.startEdit(a.id,a.columnName),!1)}),n.attachEvent("onEmptyClick",function(){return i.save(),!0}),a.attachEvent("onKeyDown",function(e,r){var o=t.locateCell(r.target),s=!!o&&t.getEditorConfig(o.columnName),l=t.getState(),c=n.constants.KEY_CODES,u=r.keyCode,d=!1;switch(u){case c.ENTER:t.isVisible()?(t.save(),r.preventDefault(),d=!0):s&&!(r.ctrlKey||r.metaKey||r.shiftKey)&&(i.startEdit(o.id,o.columnName),r.preventDefault(),d=!0);break;case c.ESC:t.isVisible()&&(t.hide(),r.preventDefault(),d=!0);break;case c.UP:case c.DOWN:break;case c.LEFT:case c.RIGHT:(s&&t.isVisible()||"date"===l.editorType)&&(d=!0);break;case c.SPACE:t.isVisible()&&(d=!0),s&&!t.isVisible()&&(i.startEdit(o.id,o.columnName),r.preventDefault(),d=!0);break;case c.DELETE:s&&!t.isVisible()?(i.startEdit(o.id,o.columnName),d=!0):s&&t.isVisible()&&(d=!0);break;case c.TAB:if(t.isVisible()){r.shiftKey?t.editPrevCell(!0):t.editNextCell(!0);var h=t.getState();h.id&&a.focus({type:"taskCell",id:h.id,column:h.columnName}),r.preventDefault(),d=!0}break;default:if(t.isVisible())d=!0;else if(u>=48&&u<=57||u>95&&u<112||u>=64&&u<=91||u>185&&u<193||u>218&&u<223){var f=e.modifiers,_=f.alt||f.ctrl||f.meta||f.shift;f.alt||_&&a.getCommandHandler(e,"taskCell")||s&&!t.isVisible()&&(i.startEdit(o.id,o.columnName),d=!0)}}return!d})},onShow:function(t,e,i){},onHide:function(t,e,i){i.$gantt.focus()},destroy:function(){}}},function(t,e){t.exports={init:function(t,e){var i=e.$gantt;i.attachEvent("onTaskClick",function(e,n){if(i._is_icon_open_click(n))return!0;var r=t.getState(),a=t.locateCell(n.target);return!a||!t.getEditorConfig(a.columnName)||(t.isVisible()&&r.id==a.id&&r.columnName==a.columnName||t.startEdit(a.id,a.columnName),!1)}),i.attachEvent("onEmptyClick",function(){return t.isVisible()&&t.isChanged()?t.save():t.hide(),!0}),i.attachEvent("onTaskDblClick",function(e,i){var n=t.getState(),r=t.locateCell(i.target);return!r||!t.isVisible()||r.columnName!=n.columnName||(t.hide(),!1)})},onShow:function(t,e,i){var n=i.$gantt;n.ext&&n.ext.keyboardNavigation&&n.ext.keyboardNavigation.attachEvent("onKeyDown",function(e,i){var r=n.constants.KEY_CODES,a=!1;switch(i.keyCode){case r.SPACE:t.isVisible()&&(a=!0)}return!a});e.onkeydown=function(e){e=e||window.event;var i=n.constants.KEY_CODES;if(!(e.defaultPrevented||e.shiftKey&&e.keyCode!=i.TAB)){var r=!0;switch(e.keyCode){case n.keys.edit_save:t.save();break;case n.keys.edit_cancel:t.hide();break;case i.UP:case i.DOWN:t.isVisible()&&(t.hide(),r=!1);break;case i.TAB:e.shiftKey?t.editPrevCell(!0):t.editNextCell(!0);break;default:r=!1}r&&e.preventDefault()}}},onHide:function(){},destroy:function(){}}},function(t,e,i){var n=i(129),r=i(128);t.exports=function(t){var e=null;return{setMapping:function(t){e=t},getMapping:function(){return e||(t.config.keyboard_navigation_cells?r:n)}}}},function(t,e,i){var n=i(130),r=i(127),a=i(126),o=i(125),s=i(124),l=i(123),c=i(122),u=i(0),d=i(1),h=i(4),f=i(121);function _(t){t.config.editor_types={text:new(r(t)),number:new(a(t)),select:new(o(t)),date:new(s(t)),predecessor:new(l(t)),duration:new(c(t))}}t.exports=function(t){var e=n(t),i={};h(i);var r={init:_,createEditors:function(n){function r(t,e){var i=function(t,e){for(var i=n.getItemTop(t),r=n.getItemHeight(t),a=n.getGridColumns(),o=0,s=0,l=0;l<a.length;l++){if(a[l].name==e){s=a[l].width;break}o+=a[l].width}return{top:i,left:o,height:r,width:s}}(t,e),r=document.createElement("div");r.className="gantt_grid_editor_placeholder",r.setAttribute(n.$config.item_attribute,t),r.setAttribute("data-column-name",e);var a=function(t,e){for(var i=t.getGridColumns(),n=0;n<i.length;n++)if(i[n].name==e)return n;return 0}(n,e);return r.setAttribute("data-column-index",a),r.style.cssText=["top:"+i.top+"px","left:"+i.left+"px","width:"+i.width+"px","height:"+i.height+"px"].join(";"),r}var a=f(t),o=[],s=null,l={_itemId:null,_columnName:null,_editor:null,_editorType:null,_placeholder:null,locateCell:function(t){if(!d.isChildOf(t,n.$grid))return null;var e=d.locateAttribute(t,n.$config.item_attribute),i=d.locateAttribute(t,"data-column-name");if(i){var r=i.getAttribute("data-column-name");return{id:e.getAttribute(n.$config.item_attribute),columnName:r}}return null},getEditorConfig:function(t){return n.getColumn(t).editor},init:function(){var t=e.getMapping();t.init&&t.init(this,n),s=n.$gantt.getDatastore(n.$config.bind);var i=this;o.push(s.attachEvent("onIdChange",function(t,e){i._itemId==t&&(i._itemId=e)})),o.push(s.attachEvent("onStoreUpdated",function(){n.$gantt.getState("batchUpdate").batch_update||i.isVisible()&&!s.isVisible(i._itemId)&&i.hide()})),this.init=function(){}},getState:function(){return{editor:this._editor,editorType:this._editorType,placeholder:this._placeholder,id:this._itemId,columnName:this._columnName}},startEdit:function(e,i){if(this.isVisible()&&this.save(),s.exists(e)){var n={id:e,columnName:i};t.isReadonly(s.getItem(e))?this.callEvent("onEditPrevent",[n]):!1!==this.callEvent("onBeforeEditStart",[n])?(this.show(n.id,n.columnName),this.setValue(),this.callEvent("onEditStart",[n])):this.callEvent("onEditPrevent",[n])}},isVisible:function(){return!(!this._editor||!d.isChildOf(this._placeholder,document.body))},show:function(t,i){this.isVisible()&&this.save();var a={id:t,columnName:i},o=n.getColumn(a.columnName),s=this.getEditorConfig(o.name);if(s){var l=n.$getConfig().editor_types[s.type],c=r(a.id,a.columnName);n.$grid_data.appendChild(c),l.show(a.id,o,s,c),this._editor=l,this._placeholder=c,this._itemId=a.id,this._columnName=a.columnName,this._editorType=s.type;var u=e.getMapping();u.onShow&&u.onShow(this,c,n)}},setValue:function(){var t=this.getState(),e=t.id,i=t.columnName,r=n.getColumn(i),a=s.getItem(e),o=this.getEditorConfig(i);if(o){var l=a[o.map_to];"auto"==o.map_to&&(l=s.getItem(e)),this._editor.set_value(l,e,r,this._placeholder),this.focus()}},focus:function(){this._editor.focus(this._placeholder)},getValue:function(){var t=n.getColumn(this._columnName);return this._editor.get_value(this._itemId,t,this._placeholder)},_getItemValue:function(){var e=this.getEditorConfig(this._columnName);if(e){var i=t.getTask(this._itemId)[e.map_to];return"auto"==e.map_to&&(i=s.getItem(this._itemId)),i}},isChanged:function(){var t=n.getColumn(this._columnName),e=this._getItemValue();return this._editor.is_changed(e,this._itemId,t,this._placeholder)},hide:function(){if(this._itemId){var t=this._itemId,i=this._columnName,r=e.getMapping();r.onHide&&r.onHide(this,this._placeholder,n),this._itemId=null,this._columnName=null,this._editorType=null,this._placeholder&&(this._editor&&this._editor.hide(this._placeholder),this._editor=null,this._placeholder.parentNode&&this._placeholder.parentNode.removeChild(this._placeholder),this._placeholder=null,this.callEvent("onEditEnd",[{id:t,columnName:i}]))}},save:function(){if(this.isVisible()&&s.exists(this._itemId)&&this.isChanged()){var e=this._itemId,i=this._columnName;if(s.exists(e)){var r=s.getItem(e),o=this.getEditorConfig(i),l={id:e,columnName:i,newValue:this.getValue(),oldValue:this._getItemValue()};if(!1!==this.callEvent("onBeforeSave",[l])&&this._editor.is_valid(l.newValue,l.id,l.columnName,this._placeholder)){var c=o.map_to,u=l.newValue;"auto"!=c?(r[c]=u,a(r,c,t.config.inline_editors_date_processing),s.updateItem(e)):this._editor.save(e,n.getColumn(i),this._placeholder),this.callEvent("onSave",[l])}this.hide()}}else this.hide()},_findEditableCell:function(t,e){var i=t,r=n.getGridColumns()[i],a=r?r.name:null;if(a){for(;a&&!this.getEditorConfig(a);)a=this._findEditableCell(t+e,e);return a}return null},getNextCell:function(t){return this._findEditableCell(n.getColumnIndex(this._columnName)+t,t)},getFirstCell:function(){return this._findEditableCell(0,1)},getLastCell:function(){return this._findEditableCell(n.getGridColumns().length-1,-1)},editNextCell:function(t){var e=this.getNextCell(1);if(e){var i=this.getNextCell(1);i&&this.getEditorConfig(i)&&this.startEdit(this._itemId,i)}else if(t&&this.moveRow(1)){var n=this.moveRow(1);(e=this.getFirstCell())&&this.getEditorConfig(e)&&this.startEdit(n,e)}},editPrevCell:function(t){var e=this.getNextCell(-1);if(e){var i=this.getNextCell(-1);i&&this.getEditorConfig(i)&&this.startEdit(this._itemId,i)}else if(t&&this.moveRow(-1)){var n=this.moveRow(-1);(e=this.getLastCell())&&this.getEditorConfig(e)&&this.startEdit(n,e)}},moveRow:function(e){for(var i=e>0?t.getNext:t.getPrev,n=(i=t.bind(i,t))(this._itemId);t.isTaskExists(n)&&t.isReadonly(t.getTask(n));)n=i(n);return n},editNextRow:function(){var t=this.getNextCell(1);t&&this.startEdit(t,this._columnName)},editPrevRow:function(){var t=this.getNextCell(-1);t&&this.startEdit(t,this._columnName)},destructor:function(){o.forEach(function(t){s.detachEvent(t)}),s=null,this.hide(),this.detachAllEvents()}};return u.mixin(l,e),u.mixin(l,i),l}};return u.mixin(r,e),u.mixin(r,i),r}},function(t,e){t.exports=function(t,e){return{init:function(){},doOnRender:function(){}}}},function(t,e){t.exports={create:function(){return{render:function(){},destroy:function(){}}}}},function(t,e,i){var n=i(3),r=i(1),a=i(0),o=i(9),s=function(t){"use strict";var e=["altKey","shiftKey","metaKey"];function i(e,i,n,r){var o=t.apply(this,arguments)||this;this.$config=a.mixin(i,{scroll:"x"}),o._scrollHorizontalHandler=a.bind(o._scrollHorizontalHandler,o),o._scrollVerticalHandler=a.bind(o._scrollVerticalHandler,o),o._outerScrollVerticalHandler=a.bind(o._outerScrollVerticalHandler,o),o._outerScrollHorizontalHandler=a.bind(o._outerScrollHorizontalHandler,o),o._mouseWheelHandler=a.bind(o._mouseWheelHandler,o),this.$config.hidden=!0;var s=r.config.scroll_size;return r.env.isIE&&(s+=1),this._isHorizontal()?(o.$config.height=s,o.$parent.$config.height=s):(o.$config.width=s,o.$parent.$config.width=s),this.$config.scrollPosition=0,o.$name="scroller",o}return n(i,t),i.prototype.init=function(t){t.innerHTML=this.$toHTML(),this.$view=t.firstChild,this.$view||this.init(),this._isVertical()?this._initVertical():this._initHorizontal(),this._initMouseWheel(),this._initLinkedViews()},i.prototype.$toHTML=function(){return"<div class='gantt_layout_cell "+(this._isHorizontal()?"gantt_hor_scroll":"gantt_ver_scroll")+"'><div style='"+(this._isHorizontal()?"width:2000px":"height:2000px")+"'></div></div>"},i.prototype._getRootParent=function(){for(var t=this.$parent;t&&t.$parent;)t=t.$parent;if(t)return t},i.prototype._eachView=function(){var t=[];return function t(e,i){if(i.push(e),e.$cells)for(var n=0;n<e.$cells.length;n++)t(e.$cells[n],i)}(this._getRootParent(),t),t},i.prototype._getLinkedViews=function(){for(var t=this._eachView(),e=[],i=0;i<t.length;i++)t[i].$config&&(this._isVertical()&&t[i].$config.scrollY==this.$id||this._isHorizontal()&&t[i].$config.scrollX==this.$id)&&e.push(t[i]);return e},i.prototype._initHorizontal=function(){this.$scroll_hor=this.$view,this.$domEvents.attach(this.$view,"scroll",this._scrollHorizontalHandler)},i.prototype._initLinkedViews=function(){for(var t=this._getLinkedViews(),e=this._isVertical()?"gantt_layout_outer_scroll gantt_layout_outer_scroll_vertical":"gantt_layout_outer_scroll gantt_layout_outer_scroll_horizontal",i=0;i<t.length;i++)r.addClassName(t[i].$view||t[i].getNode(),e)},i.prototype._initVertical=function(){this.$scroll_ver=this.$view,this.$domEvents.attach(this.$view,"scroll",this._scrollVerticalHandler)},i.prototype._updateLinkedViews=function(){},i.prototype._initMouseWheel=function(){o.isFF?this.$domEvents.attach(this._getRootParent().$view,"wheel",this._mouseWheelHandler):this.$domEvents.attach(this._getRootParent().$view,"mousewheel",this._mouseWheelHandler)},i.prototype.scrollHorizontally=function(t){if(!this._scrolling){this._scrolling=!0,this.$scroll_hor.scrollLeft=t,this.$config.codeScrollLeft=t,t=this.$scroll_hor.scrollLeft;for(var e=this._getLinkedViews(),i=0;i<e.length;i++)e[i].scrollTo&&e[i].scrollTo(t,void 0);var n=this.$config.scrollPosition;this.$config.scrollPosition=t,this.callEvent("onScroll",[n,t,this.$config.scroll]),this._scrolling=!1}},i.prototype.scrollVertically=function(t){if(!this._scrolling){this._scrolling=!0,this.$scroll_ver.scrollTop=t,t=this.$scroll_ver.scrollTop;for(var e=this._getLinkedViews(),i=0;i<e.length;i++)e[i].scrollTo&&e[i].scrollTo(void 0,t);var n=this.$config.scrollPosition;this.$config.scrollPosition=t,this.callEvent("onScroll",[n,t,this.$config.scroll]),this._scrolling=!1}},i.prototype._isVertical=function(){return"y"==this.$config.scroll},i.prototype._isHorizontal=function(){return"x"==this.$config.scroll},i.prototype._scrollHorizontalHandler=function(t){if(!this._isVertical()&&!this._scrolling){if(new Date-(this._wheel_time||0)<100)return!0;if(!this.$gantt._touch_scroll_active){var e=this.$scroll_hor.scrollLeft;this.scrollHorizontally(e),this._oldLeft=this.$scroll_hor.scrollLeft}}},i.prototype._outerScrollHorizontalHandler=function(t){this._isVertical()},i.prototype.show=function(){this.$parent.show()},i.prototype.hide=function(){this.$parent.hide()},i.prototype._getScrollSize=function(){for(var t,e=0,i=0,n=this._isHorizontal(),r=this._getLinkedViews(),a=n?"scrollWidth":"scrollHeight",o=n?"contentX":"contentY",s=n?"x":"y",l=this._getScrollOffset(),c=0;c<r.length;c++)if((t=r[c])&&t.$content&&t.$content.getSize&&!t.$config.hidden){var u,d=t.$content.getSize();if(u=d.hasOwnProperty(a)?d[a]:d[o],l)d[o]>d[s]&&d[o]>e&&u>d[s]-l+2&&(e=u+(n?0:2),i=d[s]);else{var h=Math.max(d[o]-u,0);(u+=h)>Math.max(d[s]-h,0)&&u>e&&(e=u,i=d[s])}}return{outerScroll:i,innerScroll:e}},i.prototype.scroll=function(t){this._isHorizontal()?this.scrollHorizontally(t):this.scrollVertically(t)},i.prototype.getScrollState=function(){return{visible:this.isVisible(),direction:this.$config.scroll,size:this.$config.outerSize,scrollSize:this.$config.scrollSize||0,position:this.$config.scrollPosition||0}},i.prototype.setSize=function(e,i){t.prototype.setSize.apply(this,arguments);var n=this._getScrollSize(),r=(this._isVertical()?i:e)-this._getScrollOffset()+(this._isHorizontal()?1:0);n.innerScroll&&r>n.outerScroll&&(n.innerScroll+=r-n.outerScroll),this.$config.scrollSize=n.innerScroll,this.$config.width=e,this.$config.height=i,this._setScrollSize(n.innerScroll)},i.prototype.isVisible=function(){return!(!this.$parent||!this.$parent.$view.parentNode)},i.prototype.shouldShow=function(){var t=this._getScrollSize();return!(!t.innerScroll&&this.$parent&&this.$parent.$view.parentNode)&&!(!t.innerScroll||this.$parent&&this.$parent.$view.parentNode)},i.prototype.shouldHide=function(){return!(this._getScrollSize().innerScroll||!this.$parent||!this.$parent.$view.parentNode)},i.prototype.toggleVisibility=function(){this.shouldHide()?this.hide():this.shouldShow()&&this.show()},i.prototype._getScaleOffset=function(t){var e=0;return!t||"timeline"!=t.$config.view&&"grid"!=t.$config.view||(e=t.$content.$getConfig().scale_height),e},i.prototype._getScrollOffset=function(){var t=0;if(this._isVertical()){var e=this.$parent.$parent;t=Math.max(this._getScaleOffset(e.getPrevSibling(this.$parent.$id)),this._getScaleOffset(e.getNextSibling(this.$parent.$id)))}else for(var i=this._getLinkedViews(),n=0;n<i.length;n++){var r=i[n].$parent.$cells,a=r[r.length-1];if(a&&"scrollbar"==a.$config.view&&!1===a.$config.hidden){t=a.$config.width;break}}return t||0},i.prototype._setScrollSize=function(t){var e=this._isHorizontal()?"width":"height",i=this._isHorizontal()?this.$scroll_hor:this.$scroll_ver,n=this._getScrollOffset(),a=i.firstChild;n?this._isVertical()?(this.$config.outerSize=this.$config.height-n+3,i.style.height=this.$config.outerSize+"px",i.style.top=n-1+"px",r.addClassName(i,this.$parent._borders.top),r.addClassName(i.parentNode,"gantt_task_vscroll")):(this.$config.outerSize=this.$config.width-n+1,i.style.width=this.$config.outerSize+"px"):(i.style.top="auto",r.removeClassName(i,this.$parent._borders.top),r.removeClassName(i.parentNode,"gantt_task_vscroll"),this.$config.outerSize=this.$config.height),a.style[e]=t+"px"},i.prototype._scrollVerticalHandler=function(t){if(!this._scrollHorizontalHandler()&&!this._scrolling&&!this.$gantt._touch_scroll_active){var e=this.$scroll_ver.scrollTop;e!=this._oldTop&&(this.scrollVertically(e),this._oldTop=this.$scroll_ver.scrollTop)}},i.prototype._outerScrollVerticalHandler=function(t){this._scrollHorizontalHandler()},i.prototype._checkWheelTarget=function(t){for(var e=this._getLinkedViews().concat(this),i=0;i<e.length;i++){var n=e[i].$view;if(r.isChildOf(t,n))return!0}return!1},i.prototype._mouseWheelHandler=function(t){var i=t.target||t.srcElement;if(this._checkWheelTarget(i)){this._wheel_time=new Date;var n={},r=o.isFF,a=r?-20*t.deltaX:2*t.wheelDeltaX,s=r?-40*t.deltaY:t.wheelDelta,l=this.$gantt.config.horizontal_scroll_key;if(!1!==l&&e.indexOf(l)>=0&&(!t[l]||t.deltaX||t.wheelDeltaX||(a=2*s,s=0)),a&&Math.abs(a)>Math.abs(s)){if(this._isVertical())return;if(n.x)return!0;if(!this.$scroll_hor||!this.$scroll_hor.offsetWidth)return!0;var c=a/-40,u=this._oldLeft,d=u+30*c;if(this.scrollHorizontally(d),this.$scroll_hor.scrollLeft=d,u==this.$scroll_hor.scrollLeft)return!0;this._oldLeft=this.$scroll_hor.scrollLeft}else{if(this._isHorizontal())return;if(n.y)return!0;if(!this.$scroll_ver||!this.$scroll_ver.offsetHeight)return!0;c=s/-40;void 0===s&&(c=t.detail);var h=this._oldTop,f=this.$scroll_ver.scrollTop+30*c;if(this.scrollVertically(f),this.$scroll_ver.scrollTop=f,h==this.$scroll_ver.scrollTop)return!0;this._oldTop=this.$scroll_ver.scrollTop}return t.preventDefault&&t.preventDefault(),t.cancelBubble=!0,!1}},i}(i(8));t.exports=s},function(t,e){t.exports=null},function(t,e,i){var n=i(3),r=i(0),a=function(t){"use strict";function e(e,i,n){var a=t.apply(this,arguments)||this;if(i.view){i.id&&(this.$id=r.uid());var o=r.copy(i);if(delete o.config,delete o.templates,this.$content=this.$factory.createView(i.view,this,o,this),!this.$content)return!1}return a.$name="viewCell",a}return n(e,t),e.prototype.destructor=function(){this.clear(),t.prototype.destructor.call(this)},e.prototype.clear=function(){if(this.$initialized=!1,this.$content){var e=this.$content.unload||this.$content.destructor;e&&e.call(this.$content)}t.prototype.clear.call(this)},e.prototype.scrollTo=function(e,i){this.$content&&this.$content.scrollTo?this.$content.scrollTo(e,i):t.prototype.scrollTo.call(this,e,i)},e.prototype._setContentSize=function(t,e){var i=this._getBorderSizes();if("number"==typeof t){var n=t+i.horizontal;this.$config.width=n}if("number"==typeof e){var r=e+i.vertical;this.$config.height=r}},e.prototype.setSize=function(e,i){if(t.prototype.setSize.call(this,e,i),!this.$preResize&&this.$content&&!this.$initialized){this.$initialized=!0;var n=this.$view.childNodes[0],r=this.$view.childNodes[1];r||(r=n),this.$content.init(r)}},e.prototype.setContentSize=function(){!this.$preResize&&this.$content&&this.$initialized&&this.$content.setSize(this.$lastSize.contentX,this.$lastSize.contentY)},e.prototype.getContentSize=function(){var e=t.prototype.getContentSize.call(this);if(this.$content&&this.$initialized){var i=this.$content.getSize();e.width=void 0===i.contentX?i.width:i.contentX,e.height=void 0===i.contentY?i.height:i.contentY}var n=this._getBorderSizes();return e.width+=n.horizontal,e.height+=n.vertical,e},e}(i(8));t.exports=a},function(t,e,i){var n=i(3),r=i(33),a=i(8),o=function(t){"use strict";function e(e,i,n){for(var r=t.apply(this,arguments)||this,a=0;a<r.$cells.length;a++)r.$cells[a].$config.hidden=0!==a;return r.$cell=r.$cells[0],r.$name="viewLayout",r}return n(e,t),e.prototype.cell=function(e){var i=t.prototype.cell.call(this,e);return i.$view||this.$fill(null,this),i},e.prototype.moveView=function(t){var e=this.$view;this.$cell&&(this.$cell.$config.hidden=!0,e.removeChild(this.$cell.$view)),this.$cell=t,e.appendChild(t.$view)},e.prototype.setSize=function(t,e){a.prototype.setSize.call(this,t,e)},e.prototype.setContentSize=function(){var t=this.$lastSize;this.$cell.setSize(t.contentX,t.contentY)},e.prototype.getSize=function(){var e=t.prototype.getSize.call(this);if(this.$cell){var i=this.$cell.getSize();if(this.$config.byMaxSize)for(var n=0;n<this.$cells.length;n++){var r=this.$cells[n].getSize();for(var a in i)i[a]=Math.max(i[a],r[a])}for(var o in e)e[o]=e[o]||i[o];e.gravity=Math.max(e.gravity,i.gravity)}return e},e}(r);t.exports=o},function(t,e){t.exports=function(t,e){return!!e&&(!(e.left>t.x_end||e.left+e.width<t.x)&&!(e.top>t.y_end||e.top+e.height<t.y))}},function(t,e,i){var n=i(138),r=i(15),a=i(34);t.exports=function(t){var e=t.$services,i={},o={};function s(e){var i=null;return"string"==typeof e.view?i=t.$ui.getView(e.view):e.view&&(i=e.view),i}function l(l,c,u){if(o[l])return o[l];c.renderer||t.assert(!1,"Invalid renderer call");var d=null,h=null,f=null,_=null;"function"==typeof c.renderer?(d=c.renderer,f=a):(d=c.renderer.render,h=c.renderer.update,c.renderer.isInViewPort?_=c.renderer.isInViewPort:f=c.renderer.getRectangle,f||null===f||(f=a));var g=c.filter;return u&&u.setAttribute(e.config().layer_attribute,!0),o[l]={render_item:function(e,i,a){if(i=i||u,!g||g(e)){var o=s(c),l=a;!l&&o&&o.$getConfig().smart_rendering&&(l=o.getViewPort());var h=null;!r(t)&&(f||_)&&l?(_?_(e,l,o,t):n(l,f(e,o,t)))&&(h=d.call(t,e,o,l)):h=d.call(t,e,o,l),this.append(e,h,i)}else this.remove_item(e.id)},clear:function(t){this.rendered=i[l]={},c.append||this.clear_container(t)},clear_container:function(t){(t=t||u)&&(t.innerHTML="")},get_visible_range:function(e){var i,n=s(c);return n&&n.$getConfig().smart_rendering&&(i=n.getViewPort()),n&&i&&c.renderer&&c.renderer.getVisibleRange?c.renderer.getVisibleRange(t,n,e,i):{start:0,end:e.count()}},render_items:function(t,e){e=e||u;var i=document.createDocumentFragment();this.clear(e);var n=null,r=s(c);r&&r.$getConfig().smart_rendering&&(n=r.getViewPort());for(var a=0,o=t.length;a<o;a++)this.render_item(t[a],i,n);e.appendChild(i,e)},update_items:function(e,i){var a=s(c);if(a&&a.$getConfig().smart_rendering&&!r(t)&&this.rendered&&(f||_)){i=i||u;var o=document.createDocumentFragment(),l=null;a&&(l=a.getViewPort());var d={};for(var g in this.rendered)d[g]=!0;g=0;for(var p=e.length;g<p;g++){var v=e[g],m=this.rendered[v.id];d[v.id]=!1,m&&m.parentNode?(_?_(v,l,a,t):n(l,f(v,a,t)))?(h&&h.call(t,v,m,a,l),this.restore(v,o)):d[v.id]=!0:this.render_item(e[g],o,l)}for(var g in d)d[g]&&this.hide(g);o.childNodes.length&&i.appendChild(o,i)}},append:function(t,e,i){this.rendered&&(e?(this.rendered[t.id]&&this.rendered[t.id].parentNode?this.replace_item(t.id,e):i.appendChild(e),this.rendered[t.id]=e):this.rendered[t.id]&&this.remove_item(t.id))},replace_item:function(t,e){var i=this.rendered[t];i&&i.parentNode&&i.parentNode.replaceChild(e,i),this.rendered[t]=e},remove_item:function(t){this.hide(t),delete this.rendered[t]},hide:function(t){var e=this.rendered[t];e&&e.parentNode&&e.parentNode.removeChild(e)},restore:function(t,e){var i=this.rendered[t.id];i?i.parentNode||this.append(t,i,e||u):this.render_item(t,e||u)},change_id:function(t,e){this.rendered[e]=this.rendered[t],delete this.rendered[t]},rendered:i[l],node:u,destructor:function(){this.clear(),delete o[l],delete i[l]}},o[l]}return{getRenderer:l,clearRenderers:function(){for(var t in o)l(t).destructor()}}}},function(t,e,i){var n=i(139),r=i(0),a=i(1),o=i(15);function s(t){return t instanceof Array||(t=Array.prototype.slice.call(arguments,0)),function(e){for(var i=!0,n=0,r=t.length;n<r;n++){var a=t[n];a&&(i=i&&!1!==a(e.id,e))}return i}}t.exports=function(t){var e=n(t);return{createGroup:function(i,n,l,c){var u={tempCollection:[],renderers:{},container:i,filters:[],getLayers:function(){this._add();var t=[];for(var e in this.renderers)t.push(this.renderers[e]);return t},getLayer:function(t){return this.renderers[t]},_add:function(i){i&&(i.id=i.id||r.uid(),this.tempCollection.push(i));for(var o=this.container(),s=this.tempCollection,l=0;l<s.length;l++)if(i=s[l],this.container()||i&&i.container&&a.isChildOf(i.container,document.body)){var u=i.container,d=i.id,h=i.topmost;if(!u.parentNode)if(h)o.appendChild(u);else{var f=n?n():o.firstChild;f?o.insertBefore(u,f):o.appendChild(u)}this.renderers[d]=e.getRenderer(d,i,u),c&&c(i,t),this.tempCollection.splice(l,1),l--}},addLayer:function(e){if(e){"function"==typeof e&&(e={renderer:e}),void 0===e.filter?e.filter=s(l||[]):e.filter instanceof Array&&(e.filter.push(l),e.filter=s(e.filter)),e.container||(e.container=document.createElement("div"));var i=this;e.requestUpdate=function(){t.config.smart_rendering&&!o(t)&&i.renderers[e.id]&&i.onUpdateRequest(i.renderers[e.id])}}return this._add(e),e?e.id:void 0},onUpdateRequest:function(t){},eachLayer:function(t){for(var e in this.renderers)t(this.renderers[e])},removeLayer:function(t){this.renderers[t]&&(this.renderers[t].destructor(),delete this.renderers[t])},clear:function(){for(var t in this.renderers)this.renderers[t].destructor();this.renderers={}}};return t.attachEvent("onDestroy",function(){u.clear(),u=null}),u}}}},function(t,e,i){var n=i(140);function r(t,e){if(t.view){var i=t.view;"string"==typeof i&&(i=e.$ui.getView(i)),i&&i.attachEvent&&i.attachEvent("onScroll",function(){t.requestUpdate&&t.requestUpdate()})}}t.exports=function(t){var e=n(t);return{getDataRender:function(e){return t.$services.getService("layer:"+e)||null},createDataRender:function(i){var n=i.name,a=i.defaultContainer,o=i.defaultContainerSibling,s=e.createGroup(a,o,function(t,e){if(!s.filters)return!0;for(var i=0;i<s.filters.length;i++)if(!1===s.filters[i](t,e))return!1},r);return t.$services.setService("layer:"+n,function(){return s}),t.attachEvent("onGanttReady",function(){s.addLayer()}),s},init:function(){var e=this.createDataRender({name:"task",defaultContainer:function(){return t.$task_data?t.$task_data:t.$ui.getView("timeline")?t.$ui.getView("timeline").$task_data:void 0},defaultContainerSibling:function(){return t.$task_links?t.$task_links:t.$ui.getView("timeline")?t.$ui.getView("timeline").$task_links:void 0},filter:function(t){}},t),i=this.createDataRender({name:"link",defaultContainer:function(){return t.$task_data?t.$task_data:t.$ui.getView("timeline")?t.$ui.getView("timeline").$task_data:void 0}},t);return{addTaskLayer:function(t){return"function"==typeof t&&(t={renderer:t}),t.view="timeline",e.addLayer(t)},_getTaskLayers:function(){return e.getLayers()},removeTaskLayer:function(t){e.removeLayer(t)},_clearTaskLayers:function(){e.clear()},addLinkLayer:function(t){return"function"==typeof t&&(t={renderer:t}),t.view="timeline",i.addLayer(t)},_getLinkLayers:function(){return i.getLayers()},removeLinkLayer:function(t){i.removeLayer(t)},_clearLinkLayers:function(){i.clear()}}}}}},function(t,e,i){var n=function(t){return function(e){var i={click:{},doubleclick:{},contextMenu:{}};function n(t,e,n,r){i[t][e]||(i[t][e]=[]),i[t][e].push({handler:n,root:r})}function r(t){t=t||window.event;var n=e.locate(t),r=o(t,i.click),a=!0;if(null!==n?a=!e.checkEvent("onTaskClick")||e.callEvent("onTaskClick",[n,t]):e.callEvent("onEmptyClick",[t]),a){if(!s(r,t,n))return;n&&e.getTask(n)&&e.config.select_task&&!e.config.multiselect&&e.selectTask(n)}}function a(t){var i=(t=t||window.event).target||t.srcElement,n=e.locate(i),r=e.locate(i,e.config.link_attribute),a=!e.checkEvent("onContextMenu")||e.callEvent("onContextMenu",[n,r,t]);return a||(t.preventDefault?t.preventDefault():t.returnValue=!1),a}function o(e,i){for(var n=e.target||e.srcElement,r=[];n;){var a=t.getClassName(n);if(a){a=a.split(" ");for(var o=0;o<a.length;o++)if(a[o]&&i[a[o]])for(var s=i[a[o]],l=0;l<s.length;l++)s[l].root&&!t.isChildOf(n,s[l].root)||r.push(s[l].handler)}n=n.parentNode}return r}function s(t,i,n){for(var r=!0,a=0;a<t.length;a++){var o=t[a].call(e,i,n,i.target||i.srcElement);r=r&&!(void 0!==o&&!0!==o)}return r}function l(t){t=t||window.event;var n=e.locate(t),r=o(t,i.doubleclick),a=!e.checkEvent("onTaskDblClick")||null===n||e.callEvent("onTaskDblClick",[n,t]);if(a){if(!s(r,t,n))return;null!==n&&e.getTask(n)&&a&&e.config.details_on_dblclick&&!e.isReadonly()&&e.showLightbox(n)}}function c(t){if(e.checkEvent("onMouseMove")){var i=e.locate(t);e._last_move_event=t,e.callEvent("onMouseMove",[i,t])}}var u=e._createDomEventScope();function d(t){u.detachAll(),t&&(u.attach(t,"click",r),u.attach(t,"dblclick",l),u.attach(t,"mousemove",c),u.attach(t,"contextmenu",a))}return{reset:d,global:function(t,e,i){n(t,e,i,null)},delegate:n,detach:function(t,e,n,r){if(i[t]&&i[t][e]){for(var a=i[t],o=a[e],s=0;s<o.length;s++)o[s].root==r&&(o.splice(s,1),s--);o.length||delete a[e]}},callHandler:function(t,e,n,r){var a=i[t][e];if(a)for(var o=0;o<a.length;o++)(n||a[o].root)&&a[o].root!==n||a[o].handler.apply(this,r)},onDoubleClick:l,onMouseMove:c,onContextMenu:a,onClick:r,destructor:function(){d(),i=null,u=null}}}}(i(1));t.exports={init:n}},function(t,e,i){var n=i(0);function r(t){n.mixin(this,t,!0)}function a(t,e){var i=this.$config[t];return i?i instanceof r?i:(r.prototype=e,this.$config[t]=new r(i),this.$config[t]):e}t.exports=function(t,e){n.mixin(t,function(t){var e,i;return{$getConfig:function(){return e||(e=t?t.$getConfig():this.$gantt.config),this.$config.config?a.call(this,"config",e):e},$getTemplates:function(){return i||(i=t?t.$getTemplates():this.$gantt.templates),this.$config.templates?a.call(this,"templates",i):i}}}(e))}},function(t,e,i){var n=i(0),r=i(143);t.exports={createFactory:function(t){var e={};var i={};function a(a,o,s,l){var c=e[a];if(!c||!c.create)return!1;"resizer"!=a||s.mode||(l.$config.cols?s.mode="x":s.mode="y"),"viewcell"!=a||"scrollbar"!=s.view||s.scroll||(l.$config.cols?s.scroll="y":s.scroll="x"),(s=n.copy(s)).id||i[s.view]||(s.id=s.view),s.id&&!s.css&&(s.css=s.id+"_cell");var u=new c.create(o,s,this,t);return c.configure&&c.configure(u),r(u,l),u.$id||(u.$id=s.id||t.uid()),u.$parent||"object"!=typeof o||(u.$parent=o),u.$config||(u.$config=s),i[u.$id]&&(u.$id=t.uid()),i[u.$id]=u,u}return{initUI:function(t,e){var i="cell";return t.view?i="viewcell":t.resizer?i="resizer":t.rows||t.cols?i="layout":t.views&&(i="multiview"),a.call(this,i,null,t,e)},reset:function(){i={}},registerView:function(t,i,n){e[t]={create:i,configure:n}},createView:a,getView:function(t){return i[t]}}}}},function(t,e,i){var n=i(144),r=i(142),a=i(141),o=i(8),s=i(33),l=i(137),c=i(136),u=i(135),d=i(134),h=i(14),f=i(31),_=i(31),g=i(14),p=i(14),v=i(131),m=i(120),y=i(119),b=i(118),k=i(117),w=i(115),x=i(114),$=i(108),S=i(105);t.exports={init:function(t){function e(e,i){var n=i(t);n.onCreated&&n.onCreated(e),e.attachEvent("onReady",function(){n.onInitialized&&n.onInitialized(e)}),e.attachEvent("onDestroy",function(){n.onDestroyed&&n.onDestroyed(e)})}var i=n.createFactory(t);i.registerView("cell",o),i.registerView("resizer",u),i.registerView("scrollbar",d),i.registerView("layout",s,function(t){"main"===(t.$config?t.$config.id:null)&&e(t,S)}),i.registerView("viewcell",c),i.registerView("multiview",l),i.registerView("timeline",h,function(t){"timeline"!==(t.$config?t.$config.id:null)&&"task"!=t.$config.bind||e(t,$)}),i.registerView("grid",f,function(t){"grid"!==(t.$config?t.$config.id:null)&&"task"!=t.$config.bind||e(t,x)}),i.registerView("resourceGrid",_),i.registerView("resourceTimeline",g),i.registerView("resourceHistogram",p);var T=a(t),C=v(t);return t.ext.inlineEditors=C,t.ext._inlineEditors=C,C.init(t),{factory:i,mouseEvents:r.init(t),layersApi:T.init(),render:{gridLine:function(){return w(t)},taskBg:function(){return b(t)},taskBar:function(){return m(t)},taskSplitBar:function(){return y(t)},link:function(){return k(t)}},layersService:{getDataRender:function(e){return T.getDataRender(e,t)},createDataRender:function(e){return T.createDataRender(e,t)}}}}}},function(t,e,i){var n=i(0),r=i(1);t.exports=function(t){var e="data-dhxbox",i=null;function a(t,e){var n=t.callback;g.hide(t.box),i=t.box=null,n&&n(e)}function o(t){if(i){var e=(t=t||event).which||event.keyCode,n=!1;if(p.keyboard){if(13==e||32==e){var o=t.target||t.srcElement;r.getClassName(o).indexOf("gantt_popup_button")>-1&&o.click?o.click():(a(i,!0),n=!0)}27==e&&(a(i,!1),n=!0)}return n?(t.preventDefault&&t.preventDefault(),!(t.cancelBubble=!0)):void 0}}function s(t){s.cover||(s.cover=document.createElement("div"),s.cover.onkeydown=o,s.cover.className="dhx_modal_cover",document.body.appendChild(s.cover)),s.cover.style.display=t?"inline-block":"none"}function l(e,i,n){var r=t._waiAria.messageButtonAttrString(e),a=i.toLowerCase().replace(/ /g,"_");return"<div "+r+" class='gantt_popup_button dhtmlx_popup_button "+("gantt_"+a+"_button dhtmlx_"+a+"_button")+"' data-result='"+n+"' result='"+n+"' ><div>"+e+"</div></div>"}function c(){for(var t=[].slice.apply(arguments,[0]),e=0;e<t.length;e++)if(t[e])return t[e]}function u(r,u,d){var h=r.tagName?r:function(r,o,s){var u=document.createElement("div"),d=n.uid();t._waiAria.messageModalAttr(u,d),u.className=" gantt_modal_box dhtmlx_modal_box gantt-"+r.type+" dhtmlx-"+r.type,u.setAttribute(e,1);var h="";if(r.width&&(u.style.width=r.width),r.height&&(u.style.height=r.height),r.title&&(h+='<div class="gantt_popup_title dhtmlx_popup_title">'+r.title+"</div>"),h+='<div class="gantt_popup_text dhtmlx_popup_text" id="'+d+'"><span>'+(r.content?"":r.text)+'</span></div><div  class="gantt_popup_controls dhtmlx_popup_controls">',o&&(h+=l(c(r.ok,t.locale.labels.message_ok,"OK"),"ok",!0)),s&&(h+=l(c(r.cancel,t.locale.labels.message_cancel,"Cancel"),"cancel",!1)),r.buttons)for(var f=0;f<r.buttons.length;f++){var _=r.buttons[f];h+="object"==typeof _?l(_.label,_.css||"gantt_"+_.label.toLowerCase()+"_button dhtmlx_"+_.label.toLowerCase()+"_button",_.value||f):l(_,_,f)}if(h+="</div>",u.innerHTML=h,r.content){var g=r.content;"string"==typeof g&&(g=document.getElementById(g)),"none"==g.style.display&&(g.style.display=""),u.childNodes[r.title?1:0].appendChild(g)}return u.onclick=function(t){var e=(t=t||event).target||t.srcElement;if(e.className||(e=e.parentNode),"gantt_popup_button"==e.className.split(" ")[0]){var i=e.getAttribute("data-result");a(r,i="true"==i||"false"!=i&&i)}},r.box=u,(o||s)&&(i=r),u}(r,u,d);r.hidden||s(!0),document.body.appendChild(h);var f=Math.abs(Math.floor(((window.innerWidth||document.documentElement.offsetWidth)-h.offsetWidth)/2)),_=Math.abs(Math.floor(((window.innerHeight||document.documentElement.offsetHeight)-h.offsetHeight)/2));return"top"==r.position?h.style.top="-3px":h.style.top=_+"px",h.style.left=f+"px",h.onkeydown=o,g.focus(h),r.hidden&&g.hide(h),t.callEvent("onMessagePopup",[h]),h}function d(t){return u(t,!0,!1)}function h(t){return u(t,!0,!0)}function f(t){return u(t)}function _(t,e,i){return"object"!=typeof t&&("function"==typeof e&&(i=e,e=""),t={text:t,type:e,callback:i}),t}t.event(document,"keydown",o,!0);var g=function(){var t=_.apply(this,arguments);return t.type=t.type||"alert",f(t)};g.hide=function(i){for(;i&&i.getAttribute&&!i.getAttribute(e);)i=i.parentNode;i&&(i.parentNode.removeChild(i),s(!1),t.callEvent("onAfterMessagePopup",[i]))},g.focus=function(t){setTimeout(function(){var e=r.getFocusableNodes(t);e.length&&e[0].focus&&e[0].focus()},1)};var p=function(e,i,r,a){switch((e=function(t,e,i,r){return"object"!=typeof t&&(t={text:t,type:e,expire:i,id:r}),t.id=t.id||n.uid(),t.expire=t.expire||p.expire,t}.apply(this,arguments)).type=e.type||"info",e.type.split("-")[0]){case"alert":return d(e);case"confirm":return h(e);case"modalbox":return f(e);default:return function(e){p.area||(p.area=document.createElement("div"),p.area.className="gantt_message_area dhtmlx_message_area",p.area.style[p.position]="5px",document.body.appendChild(p.area)),p.hide(e.id);var i=document.createElement("div");return i.innerHTML="<div>"+e.text+"</div>",i.className="gantt-info dhtmlx-info gantt-"+e.type+" dhtmlx-"+e.type,i.onclick=function(){p.hide(e.id),e=null},t._waiAria.messageInfoAttr(i),"bottom"==p.position&&p.area.firstChild?p.area.insertBefore(i,p.area.firstChild):p.area.appendChild(i),e.expire>0&&(p.timers[e.id]=window.setTimeout(function(){p.hide(e.id)},e.expire)),p.pull[e.id]=i,i=null,e.id}(e)}};p.seed=(new Date).valueOf(),p.uid=n.uid,p.expire=4e3,p.keyboard=!0,p.position="top",p.pull={},p.timers={},p.hideAll=function(){for(var t in p.pull)p.hide(t)},p.hide=function(t){var e=p.pull[t];e&&e.parentNode&&(window.setTimeout(function(){e.parentNode.removeChild(e),e=null},2e3),e.className+=" hidden",p.timers[t]&&window.clearTimeout(p.timers[t]),delete p.pull[t])};var v=[];return t.attachEvent("onMessagePopup",function(t){v.push(t)}),t.attachEvent("onAfterMessagePopup",function(t){for(var e=0;e<v.length;e++)v[e]===t&&(v.splice(e,1),e--)}),t.attachEvent("onDestroy",function(){s.cover&&s.cover.parentNode&&s.cover.parentNode.removeChild(s.cover);for(var t=0;t<v.length;t++)v[t].parentNode&&v[t].parentNode.removeChild(v[t]);v=null,p.area&&p.area.parentNode&&p.area.parentNode.removeChild(p.area),p=null}),{alert:function(){var t=_.apply(this,arguments);return t.type=t.type||"confirm",d(t)},confirm:function(){var t=_.apply(this,arguments);return t.type=t.type||"alert",h(t)},message:p,modalbox:g}}},function(t,e,i){(function(t,e){!function(t,i){"use strict";if(!t.setImmediate){var n,r=1,a={},o=!1,s=t.document,l=Object.getPrototypeOf&&Object.getPrototypeOf(t);l=l&&l.setTimeout?l:t,"[object process]"==={}.toString.call(t.process)?n=function(t){e.nextTick(function(){u(t)})}:function(){if(t.postMessage&&!t.importScripts){var e=!0,i=t.onmessage;return t.onmessage=function(){e=!1},t.postMessage("","*"),t.onmessage=i,e}}()?function(){var e="setImmediate$"+Math.random()+"$",i=function(i){i.source===t&&"string"==typeof i.data&&0===i.data.indexOf(e)&&u(+i.data.slice(e.length))};t.addEventListener?t.addEventListener("message",i,!1):t.attachEvent("onmessage",i),n=function(i){t.postMessage(e+i,"*")}}():t.MessageChannel?function(){var t=new MessageChannel;t.port1.onmessage=function(t){u(t.data)},n=function(e){t.port2.postMessage(e)}}():s&&"onreadystatechange"in s.createElement("script")?function(){var t=s.documentElement;n=function(e){var i=s.createElement("script");i.onreadystatechange=function(){u(e),i.onreadystatechange=null,t.removeChild(i),i=null},t.appendChild(i)}}():n=function(t){setTimeout(u,0,t)},l.setImmediate=function(t){"function"!=typeof t&&(t=new Function(""+t));for(var e=new Array(arguments.length-1),i=0;i<e.length;i++)e[i]=arguments[i+1];var o={callback:t,args:e};return a[r]=o,n(r),r++},l.clearImmediate=c}function c(t){delete a[t]}function u(t){if(o)setTimeout(u,0,t);else{var e=a[t];if(e){o=!0;try{!function(t){var e=t.callback,n=t.args;switch(n.length){case 0:e();break;case 1:e(n[0]);break;case 2:e(n[0],n[1]);break;case 3:e(n[0],n[1],n[2]);break;default:e.apply(i,n)}}(e)}finally{c(t),o=!1}}}}}("undefined"==typeof self?void 0===t?this:t:self)}).call(this,i(16),i(35))},function(t,e,i){(function(t){var n=void 0!==t&&t||"undefined"!=typeof self&&self||window,r=Function.prototype.apply;function a(t,e){this._id=t,this._clearFn=e}e.setTimeout=function(){return new a(r.call(setTimeout,n,arguments),clearTimeout)},e.setInterval=function(){return new a(r.call(setInterval,n,arguments),clearInterval)},e.clearTimeout=e.clearInterval=function(t){t&&t.close()},a.prototype.unref=a.prototype.ref=function(){},a.prototype.close=function(){this._clearFn.call(n,this._id)},e.enroll=function(t,e){clearTimeout(t._idleTimeoutId),t._idleTimeout=e},e.unenroll=function(t){clearTimeout(t._idleTimeoutId),t._idleTimeout=-1},e._unrefActive=e.active=function(t){clearTimeout(t._idleTimeoutId);var e=t._idleTimeout;e>=0&&(t._idleTimeoutId=setTimeout(function(){t._onTimeout&&t._onTimeout()},e))},i(147),e.setImmediate="undefined"!=typeof self&&self.setImmediate||void 0!==t&&t.setImmediate||this&&this.setImmediate,e.clearImmediate="undefined"!=typeof self&&self.clearImmediate||void 0!==t&&t.clearImmediate||this&&this.clearImmediate}).call(this,i(16))},function(t,e,i){(function(e,i,n){t.exports=function(){var t,r,a;return function t(e,i,n){function r(o,s){if(!i[o]){if(!e[o]){var l="function"==typeof _dereq_&&_dereq_;if(!s&&l)return l(o,!0);if(a)return a(o,!0);var c=new Error("Cannot find module '"+o+"'");throw c.code="MODULE_NOT_FOUND",c}var u=i[o]={exports:{}};e[o][0].call(u.exports,function(t){var i=e[o][1][t];return r(i||t)},u,u.exports,t,e,i,n)}return i[o].exports}for(var a="function"==typeof _dereq_&&_dereq_,o=0;o<n.length;o++)r(n[o]);return r}({1:[function(t,e,i){"use strict";e.exports=function(t){var e=t._SomePromiseArray;function i(t){var i=new e(t),n=i.promise();return i.setHowMany(1),i.setUnwrap(),i.init(),n}t.any=function(t){return i(t)},t.prototype.any=function(){return i(this)}}},{}],2:[function(t,i,n){"use strict";var r;try{throw new Error}catch(t){r=t}var a=t("./schedule"),o=t("./queue"),s=t("./util");function l(){this._customScheduler=!1,this._isTickUsed=!1,this._lateQueue=new o(16),this._normalQueue=new o(16),this._haveDrainedQueues=!1,this._trampolineEnabled=!0;var t=this;this.drainQueues=function(){t._drainQueues()},this._schedule=a}function c(t,e,i){this._lateQueue.push(t,e,i),this._queueTick()}function u(t,e,i){this._normalQueue.push(t,e,i),this._queueTick()}function d(t){this._normalQueue._pushOne(t),this._queueTick()}function h(t){for(;t.length()>0;)f(t)}function f(t){var e=t.shift();if("function"!=typeof e)e._settlePromises();else{var i=t.shift(),n=t.shift();e.call(i,n)}}l.prototype.setScheduler=function(t){var e=this._schedule;return this._schedule=t,this._customScheduler=!0,e},l.prototype.hasCustomScheduler=function(){return this._customScheduler},l.prototype.enableTrampoline=function(){this._trampolineEnabled=!0},l.prototype.disableTrampolineIfNecessary=function(){s.hasDevTools&&(this._trampolineEnabled=!1)},l.prototype.haveItemsQueued=function(){return this._isTickUsed||this._haveDrainedQueues},l.prototype.fatalError=function(t,i){i?(e.stderr.write("Fatal "+(t instanceof Error?t.stack:t)+"\n"),e.exit(2)):this.throwLater(t)},l.prototype.throwLater=function(t,e){if(1===arguments.length&&(e=t,t=function(){throw e}),"undefined"!=typeof setTimeout)setTimeout(function(){t(e)},0);else try{this._schedule(function(){t(e)})}catch(t){throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n")}},s.hasDevTools?(l.prototype.invokeLater=function(t,e,i){this._trampolineEnabled?c.call(this,t,e,i):this._schedule(function(){setTimeout(function(){t.call(e,i)},100)})},l.prototype.invoke=function(t,e,i){this._trampolineEnabled?u.call(this,t,e,i):this._schedule(function(){t.call(e,i)})},l.prototype.settlePromises=function(t){this._trampolineEnabled?d.call(this,t):this._schedule(function(){t._settlePromises()})}):(l.prototype.invokeLater=c,l.prototype.invoke=u,l.prototype.settlePromises=d),l.prototype._drainQueues=function(){h(this._normalQueue),this._reset(),this._haveDrainedQueues=!0,h(this._lateQueue)},l.prototype._queueTick=function(){this._isTickUsed||(this._isTickUsed=!0,this._schedule(this.drainQueues))},l.prototype._reset=function(){this._isTickUsed=!1},i.exports=l,i.exports.firstLineError=r},{"./queue":26,"./schedule":29,"./util":36}],3:[function(t,e,i){"use strict";e.exports=function(t,e,i,n){var r=!1,a=function(t,e){this._reject(e)},o=function(t,e){e.promiseRejectionQueued=!0,e.bindingPromise._then(a,a,null,this,t)},s=function(t,e){0==(50397184&this._bitField)&&this._resolveCallback(e.target)},l=function(t,e){e.promiseRejectionQueued||this._reject(t)};t.prototype.bind=function(a){r||(r=!0,t.prototype._propagateFrom=n.propagateFromFunction(),t.prototype._boundValue=n.boundValueFunction());var c=i(a),u=new t(e);u._propagateFrom(this,1);var d=this._target();if(u._setBoundTo(c),c instanceof t){var h={promiseRejectionQueued:!1,promise:u,target:d,bindingPromise:c};d._then(e,o,void 0,u,h),c._then(s,l,void 0,u,h),u._setOnCancel(c)}else u._resolveCallback(d);return u},t.prototype._setBoundTo=function(t){void 0!==t?(this._bitField=2097152|this._bitField,this._boundTo=t):this._bitField=-2097153&this._bitField},t.prototype._isBound=function(){return 2097152==(2097152&this._bitField)},t.bind=function(e,i){return t.resolve(i).bind(e)}}},{}],4:[function(t,e,i){"use strict";var n;"undefined"!=typeof Promise&&(n=Promise);var r=t("./promise")();r.noConflict=function(){try{Promise===r&&(Promise=n)}catch(t){}return r},e.exports=r},{"./promise":22}],5:[function(t,e,i){"use strict";var n=Object.create;if(n){var r=n(null),a=n(null);r[" size"]=a[" size"]=0}e.exports=function(e){var i=t("./util"),n=i.canEvaluate;function r(t){var n=this.pop(),r=function(t,n){var r;if(null!=t&&(r=t[n]),"function"!=typeof r){var a="Object "+i.classString(t)+" has no method '"+i.toString(n)+"'";throw new e.TypeError(a)}return r}(t,n);return r.apply(t,this)}function a(t){return t[this]}function o(t){var e=+this;return e<0&&(e=Math.max(0,e+t.length)),t[e]}i.isIdentifier,e.prototype.call=function(t){var e=[].slice.call(arguments,1);return e.push(t),this._then(r,void 0,void 0,e,void 0)},e.prototype.get=function(t){var e,i="number"==typeof t;if(i)e=o;else if(n){var r=(void 0)(t);e=null!==r?r:a}else e=a;return this._then(e,void 0,void 0,t,void 0)}}},{"./util":36}],6:[function(t,e,i){"use strict";e.exports=function(e,i,n,r){var a=t("./util"),o=a.tryCatch,s=a.errorObj,l=e._async;e.prototype.break=e.prototype.cancel=function(){if(!r.cancellation())return this._warn("cancellation is disabled");for(var t=this,e=t;t._isCancellable();){if(!t._cancelBy(e)){e._isFollowing()?e._followee().cancel():e._cancelBranched();break}var i=t._cancellationParent;if(null==i||!i._isCancellable()){t._isFollowing()?t._followee().cancel():t._cancelBranched();break}t._isFollowing()&&t._followee().cancel(),t._setWillBeCancelled(),e=t,t=i}},e.prototype._branchHasCancelled=function(){this._branchesRemainingToCancel--},e.prototype._enoughBranchesHaveCancelled=function(){return void 0===this._branchesRemainingToCancel||this._branchesRemainingToCancel<=0},e.prototype._cancelBy=function(t){return t===this?(this._branchesRemainingToCancel=0,this._invokeOnCancel(),!0):(this._branchHasCancelled(),!!this._enoughBranchesHaveCancelled()&&(this._invokeOnCancel(),!0))},e.prototype._cancelBranched=function(){this._enoughBranchesHaveCancelled()&&this._cancel()},e.prototype._cancel=function(){this._isCancellable()&&(this._setCancelled(),l.invoke(this._cancelPromises,this,void 0))},e.prototype._cancelPromises=function(){this._length()>0&&this._settlePromises()},e.prototype._unsetOnCancel=function(){this._onCancelField=void 0},e.prototype._isCancellable=function(){return this.isPending()&&!this._isCancelled()},e.prototype.isCancellable=function(){return this.isPending()&&!this.isCancelled()},e.prototype._doInvokeOnCancel=function(t,e){if(a.isArray(t))for(var i=0;i<t.length;++i)this._doInvokeOnCancel(t[i],e);else if(void 0!==t)if("function"==typeof t){if(!e){var n=o(t).call(this._boundValue());n===s&&(this._attachExtraTrace(n.e),l.throwLater(n.e))}}else t._resultCancelled(this)},e.prototype._invokeOnCancel=function(){var t=this._onCancel();this._unsetOnCancel(),l.invoke(this._doInvokeOnCancel,this,t)},e.prototype._invokeInternalOnCancel=function(){this._isCancellable()&&(this._doInvokeOnCancel(this._onCancel(),!0),this._unsetOnCancel())},e.prototype._resultCancelled=function(){this.cancel()}}},{"./util":36}],7:[function(t,e,i){"use strict";e.exports=function(e){var i=t("./util"),n=t("./es5").keys,r=i.tryCatch,a=i.errorObj;return function(t,o,s){return function(l){var c=s._boundValue();t:for(var u=0;u<t.length;++u){var d=t[u];if(d===Error||null!=d&&d.prototype instanceof Error){if(l instanceof d)return r(o).call(c,l)}else if("function"==typeof d){var h=r(d).call(c,l);if(h===a)return h;if(h)return r(o).call(c,l)}else if(i.isObject(l)){for(var f=n(d),_=0;_<f.length;++_){var g=f[_];if(d[g]!=l[g])continue t}return r(o).call(c,l)}}return e}}}},{"./es5":13,"./util":36}],8:[function(t,e,i){"use strict";e.exports=function(t){var e=!1,i=[];function n(){this._trace=new n.CapturedTrace(r())}function r(){var t=i.length-1;if(t>=0)return i[t]}return t.prototype._promiseCreated=function(){},t.prototype._pushContext=function(){},t.prototype._popContext=function(){return null},t._peekContext=t.prototype._peekContext=function(){},n.prototype._pushContext=function(){void 0!==this._trace&&(this._trace._promiseCreated=null,i.push(this._trace))},n.prototype._popContext=function(){if(void 0!==this._trace){var t=i.pop(),e=t._promiseCreated;return t._promiseCreated=null,e}return null},n.CapturedTrace=null,n.create=function(){if(e)return new n},n.deactivateLongStackTraces=function(){},n.activateLongStackTraces=function(){var i=t.prototype._pushContext,a=t.prototype._popContext,o=t._peekContext,s=t.prototype._peekContext,l=t.prototype._promiseCreated;n.deactivateLongStackTraces=function(){t.prototype._pushContext=i,t.prototype._popContext=a,t._peekContext=o,t.prototype._peekContext=s,t.prototype._promiseCreated=l,e=!1},e=!0,t.prototype._pushContext=n.prototype._pushContext,t.prototype._popContext=n.prototype._popContext,t._peekContext=t.prototype._peekContext=r,t.prototype._promiseCreated=function(){var t=this._peekContext();t&&null==t._promiseCreated&&(t._promiseCreated=this)}},n}},{}],9:[function(t,i,n){"use strict";i.exports=function(i,n){var r,a,o,s=i._getDomain,l=i._async,c=t("./errors").Warning,u=t("./util"),d=t("./es5"),h=u.canAttachTrace,f=/[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/,_=/\((?:timers\.js):\d+:\d+\)/,g=/[\/<\(](.+?):(\d+):(\d+)\)?\s*$/,p=null,v=null,m=!1,y=!(0==u.env("BLUEBIRD_DEBUG")),b=!(0==u.env("BLUEBIRD_WARNINGS")||!y&&!u.env("BLUEBIRD_WARNINGS")),k=!(0==u.env("BLUEBIRD_LONG_STACK_TRACES")||!y&&!u.env("BLUEBIRD_LONG_STACK_TRACES")),w=0!=u.env("BLUEBIRD_W_FORGOTTEN_RETURN")&&(b||!!u.env("BLUEBIRD_W_FORGOTTEN_RETURN"));i.prototype.suppressUnhandledRejections=function(){var t=this._target();t._bitField=-1048577&t._bitField|524288},i.prototype._ensurePossibleRejectionHandled=function(){if(0==(524288&this._bitField)){this._setRejectionIsUnhandled();var t=this;setTimeout(function(){t._notifyUnhandledRejection()},1)}},i.prototype._notifyUnhandledRejectionIsHandled=function(){U("rejectionHandled",r,void 0,this)},i.prototype._setReturnedNonUndefined=function(){this._bitField=268435456|this._bitField},i.prototype._returnedNonUndefined=function(){return 0!=(268435456&this._bitField)},i.prototype._notifyUnhandledRejection=function(){if(this._isRejectionUnhandled()){var t=this._settledValue();this._setUnhandledRejectionIsNotified(),U("unhandledRejection",a,t,this)}},i.prototype._setUnhandledRejectionIsNotified=function(){this._bitField=262144|this._bitField},i.prototype._unsetUnhandledRejectionIsNotified=function(){this._bitField=-262145&this._bitField},i.prototype._isUnhandledRejectionNotified=function(){return(262144&this._bitField)>0},i.prototype._setRejectionIsUnhandled=function(){this._bitField=1048576|this._bitField},i.prototype._unsetRejectionIsUnhandled=function(){this._bitField=-1048577&this._bitField,this._isUnhandledRejectionNotified()&&(this._unsetUnhandledRejectionIsNotified(),this._notifyUnhandledRejectionIsHandled())},i.prototype._isRejectionUnhandled=function(){return(1048576&this._bitField)>0},i.prototype._warn=function(t,e,i){return F(t,e,i||this)},i.onPossiblyUnhandledRejection=function(t){var e=s();a="function"==typeof t?null===e?t:u.domainBind(e,t):void 0},i.onUnhandledRejectionHandled=function(t){var e=s();r="function"==typeof t?null===e?t:u.domainBind(e,t):void 0};var x=function(){};i.longStackTraces=function(){if(l.haveItemsQueued()&&!Z.longStackTraces)throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");if(!Z.longStackTraces&&q()){var t=i.prototype._captureStackTrace,e=i.prototype._attachExtraTrace,r=i.prototype._dereferenceTrace;Z.longStackTraces=!0,x=function(){if(l.haveItemsQueued()&&!Z.longStackTraces)throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");i.prototype._captureStackTrace=t,i.prototype._attachExtraTrace=e,i.prototype._dereferenceTrace=r,n.deactivateLongStackTraces(),l.enableTrampoline(),Z.longStackTraces=!1},i.prototype._captureStackTrace=R,i.prototype._attachExtraTrace=H,i.prototype._dereferenceTrace=z,n.activateLongStackTraces(),l.disableTrampolineIfNecessary()}},i.hasLongStackTraces=function(){return Z.longStackTraces&&q()};var $=function(){try{if("function"==typeof CustomEvent){var t=new CustomEvent("CustomEvent");return u.global.dispatchEvent(t),function(t,e){var i={detail:e,cancelable:!0};d.defineProperty(i,"promise",{value:e.promise}),d.defineProperty(i,"reason",{value:e.reason});var n=new CustomEvent(t.toLowerCase(),i);return!u.global.dispatchEvent(n)}}if("function"==typeof Event){var t=new Event("CustomEvent");return u.global.dispatchEvent(t),function(t,e){var i=new Event(t.toLowerCase(),{cancelable:!0});return i.detail=e,d.defineProperty(i,"promise",{value:e.promise}),d.defineProperty(i,"reason",{value:e.reason}),!u.global.dispatchEvent(i)}}var t=document.createEvent("CustomEvent");return t.initCustomEvent("testingtheevent",!1,!0,{}),u.global.dispatchEvent(t),function(t,e){var i=document.createEvent("CustomEvent");return i.initCustomEvent(t.toLowerCase(),!1,!0,e),!u.global.dispatchEvent(i)}}catch(t){}return function(){return!1}}(),S=u.isNode?function(){return e.emit.apply(e,arguments)}:u.global?function(t){var e="on"+t.toLowerCase(),i=u.global[e];return!!i&&(i.apply(u.global,[].slice.call(arguments,1)),!0)}:function(){return!1};function T(t,e){return{promise:e}}var C={promiseCreated:T,promiseFulfilled:T,promiseRejected:T,promiseResolved:T,promiseCancelled:T,promiseChained:function(t,e,i){return{promise:e,child:i}},warning:function(t,e){return{warning:e}},unhandledRejection:function(t,e,i){return{reason:e,promise:i}},rejectionHandled:T},E=function(t){var e=!1;try{e=S.apply(null,arguments)}catch(t){l.throwLater(t),e=!0}var i=!1;try{i=$(t,C[t].apply(null,arguments))}catch(t){l.throwLater(t),i=!0}return i||e};function D(){return!1}function I(t,e,i){var n=this;try{t(e,i,function(t){if("function"!=typeof t)throw new TypeError("onCancel must be a function, got: "+u.toString(t));n._attachCancellationCallback(t)})}catch(t){return t}}function A(t){if(!this._isCancellable())return this;var e=this._onCancel();void 0!==e?u.isArray(e)?e.push(t):this._setOnCancel([e,t]):this._setOnCancel(t)}function P(){return this._onCancelField}function L(t){this._onCancelField=t}function M(){this._cancellationParent=void 0,this._onCancelField=void 0}function O(t,e){if(0!=(1&e)){this._cancellationParent=t;var i=t._branchesRemainingToCancel;void 0===i&&(i=0),t._branchesRemainingToCancel=i+1}0!=(2&e)&&t._isBound()&&this._setBoundTo(t._boundTo)}i.config=function(t){if("longStackTraces"in(t=Object(t))&&(t.longStackTraces?i.longStackTraces():!t.longStackTraces&&i.hasLongStackTraces()&&x()),"warnings"in t){var e=t.warnings;Z.warnings=!!e,w=Z.warnings,u.isObject(e)&&"wForgottenReturn"in e&&(w=!!e.wForgottenReturn)}if("cancellation"in t&&t.cancellation&&!Z.cancellation){if(l.haveItemsQueued())throw new Error("cannot enable cancellation after promises are in use");i.prototype._clearCancellationData=M,i.prototype._propagateFrom=O,i.prototype._onCancel=P,i.prototype._setOnCancel=L,i.prototype._attachCancellationCallback=A,i.prototype._execute=I,N=O,Z.cancellation=!0}return"monitoring"in t&&(t.monitoring&&!Z.monitoring?(Z.monitoring=!0,i.prototype._fireEvent=E):!t.monitoring&&Z.monitoring&&(Z.monitoring=!1,i.prototype._fireEvent=D)),i},i.prototype._fireEvent=D,i.prototype._execute=function(t,e,i){try{t(e,i)}catch(t){return t}},i.prototype._onCancel=function(){},i.prototype._setOnCancel=function(t){},i.prototype._attachCancellationCallback=function(t){},i.prototype._captureStackTrace=function(){},i.prototype._attachExtraTrace=function(){},i.prototype._dereferenceTrace=function(){},i.prototype._clearCancellationData=function(){},i.prototype._propagateFrom=function(t,e){};var N=function(t,e){0!=(2&e)&&t._isBound()&&this._setBoundTo(t._boundTo)};function j(){var t=this._boundTo;return void 0!==t&&t instanceof i?t.isFulfilled()?t.value():void 0:t}function R(){this._trace=new J(this._peekContext())}function H(t,e){if(h(t)){var i=this._trace;if(void 0!==i&&e&&(i=i._parent),void 0!==i)i.attachExtraTrace(t);else if(!t.__stackCleaned__){var n=V(t);u.notEnumerableProp(t,"stack",n.message+"\n"+n.stack.join("\n")),u.notEnumerableProp(t,"__stackCleaned__",!0)}}}function z(){this._trace=void 0}function F(t,e,n){if(Z.warnings){var r,a=new c(t);if(e)n._attachExtraTrace(a);else if(Z.longStackTraces&&(r=i._peekContext()))r.attachExtraTrace(a);else{var o=V(a);a.stack=o.message+"\n"+o.stack.join("\n")}E("warning",a)||W(a,"",!0)}}function B(t){for(var e=[],i=0;i<t.length;++i){var n=t[i],r="    (No stack trace)"===n||p.test(n),a=r&&Y(n);r&&!a&&(m&&" "!==n.charAt(0)&&(n="    "+n),e.push(n))}return e}function V(t){var e=t.stack,i=t.toString();return e="string"==typeof e&&e.length>0?function(t){for(var e=t.stack.replace(/\s+$/g,"").split("\n"),i=0;i<e.length;++i){var n=e[i];if("    (No stack trace)"===n||p.test(n))break}return i>0&&"SyntaxError"!=t.name&&(e=e.slice(i)),e}(t):["    (No stack trace)"],{message:i,stack:"SyntaxError"==t.name?e:B(e)}}function W(t,e,i){if("undefined"!=typeof console){var n;if(u.isObject(t)){var r=t.stack;n=e+v(r,t)}else n=e+String(t);"function"==typeof o?o(n,i):"function"!=typeof console.log&&"object"!=typeof console.log||console.log(n)}}function U(t,e,i,n){var r=!1;try{"function"==typeof e&&(r=!0,"rejectionHandled"===t?e(n):e(i,n))}catch(t){l.throwLater(t)}"unhandledRejection"===t?E(t,i,n)||r||W(i,"Unhandled rejection "):E(t,n)}function G(t){var e;if("function"==typeof t)e="[function "+(t.name||"anonymous")+"]";else{if(e=t&&"function"==typeof t.toString?t.toString():u.toString(t),/\[object [a-zA-Z0-9$_]+\]/.test(e))try{var i=JSON.stringify(t);e=i}catch(t){}0===e.length&&(e="(empty array)")}return"(<"+function(t){return t.length<41?t:t.substr(0,38)+"..."}(e)+">, no stack trace)"}function q(){return"function"==typeof Q}var Y=function(){return!1},X=/[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;function K(t){var e=t.match(X);if(e)return{fileName:e[1],line:parseInt(e[2],10)}}function J(t){this._parent=t,this._promisesCreated=0;var e=this._length=1+(void 0===t?0:t._length);Q(this,J),e>32&&this.uncycle()}u.inherits(J,Error),n.CapturedTrace=J,J.prototype.uncycle=function(){var t=this._length;if(!(t<2)){for(var e=[],i={},n=0,r=this;void 0!==r;++n)e.push(r),r=r._parent;for(var n=(t=this._length=n)-1;n>=0;--n){var a=e[n].stack;void 0===i[a]&&(i[a]=n)}for(var n=0;n<t;++n){var o=e[n].stack,s=i[o];if(void 0!==s&&s!==n){s>0&&(e[s-1]._parent=void 0,e[s-1]._length=1),e[n]._parent=void 0,e[n]._length=1;var l=n>0?e[n-1]:this;s<t-1?(l._parent=e[s+1],l._parent.uncycle(),l._length=l._parent._length+1):(l._parent=void 0,l._length=1);for(var c=l._length+1,u=n-2;u>=0;--u)e[u]._length=c,c++;return}}}},J.prototype.attachExtraTrace=function(t){if(!t.__stackCleaned__){this.uncycle();for(var e=V(t),i=e.message,n=[e.stack],r=this;void 0!==r;)n.push(B(r.stack.split("\n"))),r=r._parent;!function(t){for(var e=t[0],i=1;i<t.length;++i){for(var n=t[i],r=e.length-1,a=e[r],o=-1,s=n.length-1;s>=0;--s)if(n[s]===a){o=s;break}for(var s=o;s>=0;--s){var l=n[s];if(e[r]!==l)break;e.pop(),r--}e=n}}(n),function(t){for(var e=0;e<t.length;++e)(0===t[e].length||e+1<t.length&&t[e][0]===t[e+1][0])&&(t.splice(e,1),e--)}(n),u.notEnumerableProp(t,"stack",function(t,e){for(var i=0;i<e.length-1;++i)e[i].push("From previous event:"),e[i]=e[i].join("\n");return i<e.length&&(e[i]=e[i].join("\n")),t+"\n"+e.join("\n")}(i,n)),u.notEnumerableProp(t,"__stackCleaned__",!0)}};var Q=function(){var t=/^\s*at\s*/,e=function(t,e){return"string"==typeof t?t:void 0!==e.name&&void 0!==e.message?e.toString():G(e)};if("number"==typeof Error.stackTraceLimit&&"function"==typeof Error.captureStackTrace){Error.stackTraceLimit+=6,p=t,v=e;var i=Error.captureStackTrace;return Y=function(t){return f.test(t)},function(t,e){Error.stackTraceLimit+=6,i(t,e),Error.stackTraceLimit-=6}}var n,r=new Error;if("string"==typeof r.stack&&r.stack.split("\n")[0].indexOf("stackDetection@")>=0)return p=/@/,v=e,m=!0,function(t){t.stack=(new Error).stack};try{throw new Error}catch(t){n="stack"in t}return"stack"in r||!n||"number"!=typeof Error.stackTraceLimit?(v=function(t,e){return"string"==typeof t?t:"object"!=typeof e&&"function"!=typeof e||void 0===e.name||void 0===e.message?G(e):e.toString()},null):(p=t,v=e,function(t){Error.stackTraceLimit+=6;try{throw new Error}catch(e){t.stack=e.stack}Error.stackTraceLimit-=6})}();"undefined"!=typeof console&&void 0!==console.warn&&(o=function(t){console.warn(t)},u.isNode&&e.stderr.isTTY?o=function(t,e){var i=e?"[33m":"[31m";console.warn(i+t+"[0m\n")}:u.isNode||"string"!=typeof(new Error).stack||(o=function(t,e){console.warn("%c"+t,e?"color: darkorange":"color: red")}));var Z={warnings:b,longStackTraces:!1,cancellation:!1,monitoring:!1};return k&&i.longStackTraces(),{longStackTraces:function(){return Z.longStackTraces},warnings:function(){return Z.warnings},cancellation:function(){return Z.cancellation},monitoring:function(){return Z.monitoring},propagateFromFunction:function(){return N},boundValueFunction:function(){return j},checkForgottenReturns:function(t,e,i,n,r){if(void 0===t&&null!==e&&w){if(void 0!==r&&r._returnedNonUndefined())return;if(0==(65535&n._bitField))return;i&&(i+=" ");var a="",o="";if(e._trace){for(var s=e._trace.stack.split("\n"),l=B(s),c=l.length-1;c>=0;--c){var u=l[c];if(!_.test(u)){var d=u.match(g);d&&(a="at "+d[1]+":"+d[2]+":"+d[3]+" ");break}}if(l.length>0)for(var h=l[0],c=0;c<s.length;++c)if(s[c]===h){c>0&&(o="\n"+s[c-1]);break}}var f="a promise was created in a "+i+"handler "+a+"but was not returned from it, see http://goo.gl/rRqMUw"+o;n._warn(f,!0,e)}},setBounds:function(t,e){if(q()){for(var i,n,r=t.stack.split("\n"),a=e.stack.split("\n"),o=-1,s=-1,l=0;l<r.length;++l){var c=K(r[l]);if(c){i=c.fileName,o=c.line;break}}for(var l=0;l<a.length;++l){var c=K(a[l]);if(c){n=c.fileName,s=c.line;break}}o<0||s<0||!i||!n||i!==n||o>=s||(Y=function(t){if(f.test(t))return!0;var e=K(t);return!!(e&&e.fileName===i&&o<=e.line&&e.line<=s)})}},warn:F,deprecated:function(t,e){var i=t+" is deprecated and will be removed in a future version.";return e&&(i+=" Use "+e+" instead."),F(i)},CapturedTrace:J,fireDomEvent:$,fireGlobalEvent:S}}},{"./errors":12,"./es5":13,"./util":36}],10:[function(t,e,i){"use strict";e.exports=function(t){function e(){return this.value}function i(){throw this.reason}t.prototype.return=t.prototype.thenReturn=function(i){return i instanceof t&&i.suppressUnhandledRejections(),this._then(e,void 0,void 0,{value:i},void 0)},t.prototype.throw=t.prototype.thenThrow=function(t){return this._then(i,void 0,void 0,{reason:t},void 0)},t.prototype.catchThrow=function(t){if(arguments.length<=1)return this._then(void 0,i,void 0,{reason:t},void 0);var e=arguments[1];return this.caught(t,function(){throw e})},t.prototype.catchReturn=function(i){if(arguments.length<=1)return i instanceof t&&i.suppressUnhandledRejections(),this._then(void 0,e,void 0,{value:i},void 0);var n=arguments[1];return n instanceof t&&n.suppressUnhandledRejections(),this.caught(i,function(){return n})}}},{}],11:[function(t,e,i){"use strict";e.exports=function(t,e){var i=t.reduce,n=t.all;function r(){return n(this)}t.prototype.each=function(t){return i(this,t,e,0)._then(r,void 0,void 0,this,void 0)},t.prototype.mapSeries=function(t){return i(this,t,e,e)},t.each=function(t,n){return i(t,n,e,0)._then(r,void 0,void 0,t,void 0)},t.mapSeries=function(t,n){return i(t,n,e,e)}}},{}],12:[function(t,e,i){"use strict";var n,r,a=t("./es5"),o=a.freeze,s=t("./util"),l=s.inherits,c=s.notEnumerableProp;function u(t,e){function i(n){if(!(this instanceof i))return new i(n);c(this,"message","string"==typeof n?n:e),c(this,"name",t),Error.captureStackTrace?Error.captureStackTrace(this,this.constructor):Error.call(this)}return l(i,Error),i}var d=u("Warning","warning"),h=u("CancellationError","cancellation error"),f=u("TimeoutError","timeout error"),_=u("AggregateError","aggregate error");try{n=TypeError,r=RangeError}catch(t){n=u("TypeError","type error"),r=u("RangeError","range error")}for(var g="join pop push shift unshift slice filter forEach some every map indexOf lastIndexOf reduce reduceRight sort reverse".split(" "),p=0;p<g.length;++p)"function"==typeof Array.prototype[g[p]]&&(_.prototype[g[p]]=Array.prototype[g[p]]);a.defineProperty(_.prototype,"length",{value:0,configurable:!1,writable:!0,enumerable:!0}),_.prototype.isOperational=!0;var v=0;function m(t){if(!(this instanceof m))return new m(t);c(this,"name","OperationalError"),c(this,"message",t),this.cause=t,this.isOperational=!0,t instanceof Error?(c(this,"message",t.message),c(this,"stack",t.stack)):Error.captureStackTrace&&Error.captureStackTrace(this,this.constructor)}_.prototype.toString=function(){var t=Array(4*v+1).join(" "),e="\n"+t+"AggregateError of:\n";v++,t=Array(4*v+1).join(" ");for(var i=0;i<this.length;++i){for(var n=this[i]===this?"[Circular AggregateError]":this[i]+"",r=n.split("\n"),a=0;a<r.length;++a)r[a]=t+r[a];n=r.join("\n"),e+=n+"\n"}return v--,e},l(m,Error);var y=Error.__BluebirdErrorTypes__;y||(y=o({CancellationError:h,TimeoutError:f,OperationalError:m,RejectionError:m,AggregateError:_}),a.defineProperty(Error,"__BluebirdErrorTypes__",{value:y,writable:!1,enumerable:!1,configurable:!1})),e.exports={Error:Error,TypeError:n,RangeError:r,CancellationError:y.CancellationError,OperationalError:y.OperationalError,TimeoutError:y.TimeoutError,AggregateError:y.AggregateError,Warning:d}},{"./es5":13,"./util":36}],13:[function(t,e,i){var n=function(){"use strict";return void 0===this}();if(n)e.exports={freeze:Object.freeze,defineProperty:Object.defineProperty,getDescriptor:Object.getOwnPropertyDescriptor,keys:Object.keys,names:Object.getOwnPropertyNames,getPrototypeOf:Object.getPrototypeOf,isArray:Array.isArray,isES5:n,propertyIsWritable:function(t,e){var i=Object.getOwnPropertyDescriptor(t,e);return!(i&&!i.writable&&!i.set)}};else{var r={}.hasOwnProperty,a={}.toString,o={}.constructor.prototype,s=function(t){var e=[];for(var i in t)r.call(t,i)&&e.push(i);return e};e.exports={isArray:function(t){try{return"[object Array]"===a.call(t)}catch(t){return!1}},keys:s,names:s,defineProperty:function(t,e,i){return t[e]=i.value,t},getDescriptor:function(t,e){return{value:t[e]}},freeze:function(t){return t},getPrototypeOf:function(t){try{return Object(t).constructor.prototype}catch(t){return o}},isES5:n,propertyIsWritable:function(){return!0}}}},{}],14:[function(t,e,i){"use strict";e.exports=function(t,e){var i=t.map;t.prototype.filter=function(t,n){return i(this,t,n,e)},t.filter=function(t,n,r){return i(t,n,r,e)}}},{}],15:[function(t,e,i){"use strict";e.exports=function(e,i,n){var r=t("./util"),a=e.CancellationError,o=r.errorObj,s=t("./catch_filter")(n);function l(t,e,i){this.promise=t,this.type=e,this.handler=i,this.called=!1,this.cancelPromise=null}function c(t){this.finallyHandler=t}function u(t,e){return null!=t.cancelPromise&&(arguments.length>1?t.cancelPromise._reject(e):t.cancelPromise._cancel(),t.cancelPromise=null,!0)}function d(){return f.call(this,this.promise._target()._settledValue())}function h(t){if(!u(this,t))return o.e=t,o}function f(t){var r=this.promise,s=this.handler;if(!this.called){this.called=!0;var l=this.isFinallyHandler()?s.call(r._boundValue()):s.call(r._boundValue(),t);if(l===n)return l;if(void 0!==l){r._setReturnedNonUndefined();var f=i(l,r);if(f instanceof e){if(null!=this.cancelPromise){if(f._isCancelled()){var _=new a("late cancellation observer");return r._attachExtraTrace(_),o.e=_,o}f.isPending()&&f._attachCancellationCallback(new c(this))}return f._then(d,h,void 0,this,void 0)}}}return r.isRejected()?(u(this),o.e=t,o):(u(this),t)}return l.prototype.isFinallyHandler=function(){return 0===this.type},c.prototype._resultCancelled=function(){u(this.finallyHandler)},e.prototype._passThrough=function(t,e,i,n){return"function"!=typeof t?this.then():this._then(i,n,void 0,new l(this,e,t),void 0)},e.prototype.lastly=e.prototype.finally=function(t){return this._passThrough(t,0,f,f)},e.prototype.tap=function(t){return this._passThrough(t,1,f)},e.prototype.tapCatch=function(t){var i=arguments.length;if(1===i)return this._passThrough(t,1,void 0,f);var n,a=new Array(i-1),o=0;for(n=0;n<i-1;++n){var l=arguments[n];if(!r.isObject(l))return e.reject(new TypeError("tapCatch statement predicate: expecting an object but got "+r.classString(l)));a[o++]=l}a.length=o;var c=arguments[n];return this._passThrough(s(a,c,this),1,void 0,f)},l}},{"./catch_filter":7,"./util":36}],16:[function(t,e,i){"use strict";e.exports=function(e,i,n,r,a,o){var s=t("./errors"),l=s.TypeError,c=t("./util"),u=c.errorObj,d=c.tryCatch,h=[];function f(t,i,r,a){if(o.cancellation()){var s=new e(n),l=this._finallyPromise=new e(n);this._promise=s.lastly(function(){return l}),s._captureStackTrace(),s._setOnCancel(this)}else{var c=this._promise=new e(n);c._captureStackTrace()}this._stack=a,this._generatorFunction=t,this._receiver=i,this._generator=void 0,this._yieldHandlers="function"==typeof r?[r].concat(h):h,this._yieldedPromise=null,this._cancellationPhase=!1}c.inherits(f,a),f.prototype._isResolved=function(){return null===this._promise},f.prototype._cleanup=function(){this._promise=this._generator=null,o.cancellation()&&null!==this._finallyPromise&&(this._finallyPromise._fulfill(),this._finallyPromise=null)},f.prototype._promiseCancelled=function(){if(!this._isResolved()){var t,i=void 0!==this._generator.return;if(i)this._promise._pushContext(),t=d(this._generator.return).call(this._generator,void 0),this._promise._popContext();else{var n=new e.CancellationError("generator .return() sentinel");e.coroutine.returnSentinel=n,this._promise._attachExtraTrace(n),this._promise._pushContext(),t=d(this._generator.throw).call(this._generator,n),this._promise._popContext()}this._cancellationPhase=!0,this._yieldedPromise=null,this._continue(t)}},f.prototype._promiseFulfilled=function(t){this._yieldedPromise=null,this._promise._pushContext();var e=d(this._generator.next).call(this._generator,t);this._promise._popContext(),this._continue(e)},f.prototype._promiseRejected=function(t){this._yieldedPromise=null,this._promise._attachExtraTrace(t),this._promise._pushContext();var e=d(this._generator.throw).call(this._generator,t);this._promise._popContext(),this._continue(e)},f.prototype._resultCancelled=function(){if(this._yieldedPromise instanceof e){var t=this._yieldedPromise;this._yieldedPromise=null,t.cancel()}},f.prototype.promise=function(){return this._promise},f.prototype._run=function(){this._generator=this._generatorFunction.call(this._receiver),this._receiver=this._generatorFunction=void 0,this._promiseFulfilled(void 0)},f.prototype._continue=function(t){var i=this._promise;if(t===u)return this._cleanup(),this._cancellationPhase?i.cancel():i._rejectCallback(t.e,!1);var n=t.value;if(!0===t.done)return this._cleanup(),this._cancellationPhase?i.cancel():i._resolveCallback(n);var a=r(n,this._promise);if(a instanceof e||null!==(a=function(t,i,n){for(var a=0;a<i.length;++a){n._pushContext();var o=d(i[a])(t);if(n._popContext(),o===u){n._pushContext();var s=e.reject(u.e);return n._popContext(),s}var l=r(o,n);if(l instanceof e)return l}return null}(a,this._yieldHandlers,this._promise))){var o=(a=a._target())._bitField;0==(50397184&o)?(this._yieldedPromise=a,a._proxy(this,null)):0!=(33554432&o)?e._async.invoke(this._promiseFulfilled,this,a._value()):0!=(16777216&o)?e._async.invoke(this._promiseRejected,this,a._reason()):this._promiseCancelled()}else this._promiseRejected(new l("A value %s was yielded that could not be treated as a promise\n\n    See http://goo.gl/MqrFmX\n\n".replace("%s",String(n))+"From coroutine:\n"+this._stack.split("\n").slice(1,-7).join("\n")))},e.coroutine=function(t,e){if("function"!=typeof t)throw new l("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");var i=Object(e).yieldHandler,n=f,r=(new Error).stack;return function(){var e=t.apply(this,arguments),a=new n(void 0,void 0,i,r),o=a.promise();return a._generator=e,a._promiseFulfilled(void 0),o}},e.coroutine.addYieldHandler=function(t){if("function"!=typeof t)throw new l("expecting a function but got "+c.classString(t));h.push(t)},e.spawn=function(t){if(o.deprecated("Promise.spawn()","Promise.coroutine()"),"function"!=typeof t)return i("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");var n=new f(t,this),r=n.promise();return n._run(e.spawn),r}}},{"./errors":12,"./util":36}],17:[function(t,e,i){"use strict";e.exports=function(e,i,n,r,a,o){var s=t("./util");s.canEvaluate,s.tryCatch,s.errorObj,e.join=function(){var t,e=arguments.length-1;e>0&&"function"==typeof arguments[e]&&(t=arguments[e]);var n=[].slice.call(arguments);t&&n.pop();var r=new i(n).promise();return void 0!==t?r.spread(t):r}}},{"./util":36}],18:[function(t,e,i){"use strict";e.exports=function(e,i,n,r,a,o){var s=e._getDomain,l=t("./util"),c=l.tryCatch,u=l.errorObj,d=e._async;function h(t,e,i,n){this.constructor$(t),this._promise._captureStackTrace();var r=s();this._callback=null===r?e:l.domainBind(r,e),this._preservedValues=n===a?new Array(this.length()):null,this._limit=i,this._inFlight=0,this._queue=[],d.invoke(this._asyncInit,this,void 0)}function f(t,i,r,a){if("function"!=typeof i)return n("expecting a function but got "+l.classString(i));var o=0;if(void 0!==r){if("object"!=typeof r||null===r)return e.reject(new TypeError("options argument must be an object but it is "+l.classString(r)));if("number"!=typeof r.concurrency)return e.reject(new TypeError("'concurrency' must be a number but it is "+l.classString(r.concurrency)));o=r.concurrency}return o="number"==typeof o&&isFinite(o)&&o>=1?o:0,new h(t,i,o,a).promise()}l.inherits(h,i),h.prototype._asyncInit=function(){this._init$(void 0,-2)},h.prototype._init=function(){},h.prototype._promiseFulfilled=function(t,i){var n=this._values,a=this.length(),s=this._preservedValues,l=this._limit;if(i<0){if(n[i=-1*i-1]=t,l>=1&&(this._inFlight--,this._drainQueue(),this._isResolved()))return!0}else{if(l>=1&&this._inFlight>=l)return n[i]=t,this._queue.push(i),!1;null!==s&&(s[i]=t);var d=this._promise,h=this._callback,f=d._boundValue();d._pushContext();var _=c(h).call(f,t,i,a),g=d._popContext();if(o.checkForgottenReturns(_,g,null!==s?"Promise.filter":"Promise.map",d),_===u)return this._reject(_.e),!0;var p=r(_,this._promise);if(p instanceof e){var v=(p=p._target())._bitField;if(0==(50397184&v))return l>=1&&this._inFlight++,n[i]=p,p._proxy(this,-1*(i+1)),!1;if(0==(33554432&v))return 0!=(16777216&v)?(this._reject(p._reason()),!0):(this._cancel(),!0);_=p._value()}n[i]=_}var m=++this._totalResolved;return m>=a&&(null!==s?this._filter(n,s):this._resolve(n),!0)},h.prototype._drainQueue=function(){for(var t=this._queue,e=this._limit,i=this._values;t.length>0&&this._inFlight<e;){if(this._isResolved())return;var n=t.pop();this._promiseFulfilled(i[n],n)}},h.prototype._filter=function(t,e){for(var i=e.length,n=new Array(i),r=0,a=0;a<i;++a)t[a]&&(n[r++]=e[a]);n.length=r,this._resolve(n)},h.prototype.preservedValues=function(){return this._preservedValues},e.prototype.map=function(t,e){return f(this,t,e,null)},e.map=function(t,e,i,n){return f(t,e,i,n)}}},{"./util":36}],19:[function(t,e,i){"use strict";e.exports=function(e,i,n,r,a){var o=t("./util"),s=o.tryCatch;e.method=function(t){if("function"!=typeof t)throw new e.TypeError("expecting a function but got "+o.classString(t));return function(){var n=new e(i);n._captureStackTrace(),n._pushContext();var r=s(t).apply(this,arguments),o=n._popContext();return a.checkForgottenReturns(r,o,"Promise.method",n),n._resolveFromSyncValue(r),n}},e.attempt=e.try=function(t){if("function"!=typeof t)return r("expecting a function but got "+o.classString(t));var n,l=new e(i);if(l._captureStackTrace(),l._pushContext(),arguments.length>1){a.deprecated("calling Promise.try with more than 1 argument");var c=arguments[1],u=arguments[2];n=o.isArray(c)?s(t).apply(u,c):s(t).call(u,c)}else n=s(t)();var d=l._popContext();return a.checkForgottenReturns(n,d,"Promise.try",l),l._resolveFromSyncValue(n),l},e.prototype._resolveFromSyncValue=function(t){t===o.errorObj?this._rejectCallback(t.e,!1):this._resolveCallback(t,!0)}}},{"./util":36}],20:[function(t,e,i){"use strict";var n=t("./util"),r=n.maybeWrapAsError,a=t("./errors"),o=a.OperationalError,s=t("./es5"),l=/^(?:name|message|stack|cause)$/;function c(t){var e;if(function(t){return t instanceof Error&&s.getPrototypeOf(t)===Error.prototype}(t)){(e=new o(t)).name=t.name,e.message=t.message,e.stack=t.stack;for(var i=s.keys(t),r=0;r<i.length;++r){var a=i[r];l.test(a)||(e[a]=t[a])}return e}return n.markAsOriginatingFromRejection(t),t}e.exports=function(t,e){return function(i,n){if(null!==t){if(i){var a=c(r(i));t._attachExtraTrace(a),t._reject(a)}else if(e){var o=[].slice.call(arguments,1);t._fulfill(o)}else t._fulfill(n);t=null}}}},{"./errors":12,"./es5":13,"./util":36}],21:[function(t,e,i){"use strict";e.exports=function(e){var i=t("./util"),n=e._async,r=i.tryCatch,a=i.errorObj;function o(t,e){if(!i.isArray(t))return s.call(this,t,e);var o=r(e).apply(this._boundValue(),[null].concat(t));o===a&&n.throwLater(o.e)}function s(t,e){var i=this._boundValue(),o=void 0===t?r(e).call(i,null):r(e).call(i,null,t);o===a&&n.throwLater(o.e)}function l(t,e){if(!t){var i=new Error(t+"");i.cause=t,t=i}var o=r(e).call(this._boundValue(),t);o===a&&n.throwLater(o.e)}e.prototype.asCallback=e.prototype.nodeify=function(t,e){if("function"==typeof t){var i=s;void 0!==e&&Object(e).spread&&(i=o),this._then(i,l,void 0,this,t)}return this}}},{"./util":36}],22:[function(t,i,n){"use strict";i.exports=function(){var n=function(){return new _("circular promise resolution chain\n\n    See http://goo.gl/MqrFmX\n")},r=function(){return new D.PromiseInspection(this._target())},a=function(t){return D.reject(new _(t))};function o(){}var s,l={},c=t("./util");s=c.isNode?function(){var t=e.domain;return void 0===t&&(t=null),t}:function(){return null},c.notEnumerableProp(D,"_getDomain",s);var u=t("./es5"),d=t("./async"),h=new d;u.defineProperty(D,"_async",{value:h});var f=t("./errors"),_=D.TypeError=f.TypeError;D.RangeError=f.RangeError;var g=D.CancellationError=f.CancellationError;D.TimeoutError=f.TimeoutError,D.OperationalError=f.OperationalError,D.RejectionError=f.OperationalError,D.AggregateError=f.AggregateError;var p=function(){},v={},m={},y=t("./thenables")(D,p),b=t("./promise_array")(D,p,y,a,o),k=t("./context")(D),w=k.create,x=t("./debuggability")(D,k),$=(x.CapturedTrace,t("./finally")(D,y,m)),S=t("./catch_filter")(m),T=t("./nodeback"),C=c.errorObj,E=c.tryCatch;function D(t){t!==p&&function(t,e){if(null==t||t.constructor!==D)throw new _("the promise constructor cannot be invoked directly\n\n    See http://goo.gl/MqrFmX\n");if("function"!=typeof e)throw new _("expecting a function but got "+c.classString(e))}(this,t),this._bitField=0,this._fulfillmentHandler0=void 0,this._rejectionHandler0=void 0,this._promise0=void 0,this._receiver0=void 0,this._resolveFromExecutor(t),this._promiseCreated(),this._fireEvent("promiseCreated",this)}function I(t){this.promise._resolveCallback(t)}function A(t){this.promise._rejectCallback(t,!1)}function P(t){var e=new D(p);e._fulfillmentHandler0=t,e._rejectionHandler0=t,e._promise0=t,e._receiver0=t}return D.prototype.toString=function(){return"[object Promise]"},D.prototype.caught=D.prototype.catch=function(t){var e=arguments.length;if(e>1){var i,n=new Array(e-1),r=0;for(i=0;i<e-1;++i){var o=arguments[i];if(!c.isObject(o))return a("Catch statement predicate: expecting an object but got "+c.classString(o));n[r++]=o}return n.length=r,t=arguments[i],this.then(void 0,S(n,t,this))}return this.then(void 0,t)},D.prototype.reflect=function(){return this._then(r,r,void 0,this,void 0)},D.prototype.then=function(t,e){if(x.warnings()&&arguments.length>0&&"function"!=typeof t&&"function"!=typeof e){var i=".then() only accepts functions but was passed: "+c.classString(t);arguments.length>1&&(i+=", "+c.classString(e)),this._warn(i)}return this._then(t,e,void 0,void 0,void 0)},D.prototype.done=function(t,e){var i=this._then(t,e,void 0,void 0,void 0);i._setIsFinal()},D.prototype.spread=function(t){return"function"!=typeof t?a("expecting a function but got "+c.classString(t)):this.all()._then(t,void 0,void 0,v,void 0)},D.prototype.toJSON=function(){var t={isFulfilled:!1,isRejected:!1,fulfillmentValue:void 0,rejectionReason:void 0};return this.isFulfilled()?(t.fulfillmentValue=this.value(),t.isFulfilled=!0):this.isRejected()&&(t.rejectionReason=this.reason(),t.isRejected=!0),t},D.prototype.all=function(){return arguments.length>0&&this._warn(".all() was passed arguments but it does not take any"),new b(this).promise()},D.prototype.error=function(t){return this.caught(c.originatesFromRejection,t)},D.getNewLibraryCopy=i.exports,D.is=function(t){return t instanceof D},D.fromNode=D.fromCallback=function(t){var e=new D(p);e._captureStackTrace();var i=arguments.length>1&&!!Object(arguments[1]).multiArgs,n=E(t)(T(e,i));return n===C&&e._rejectCallback(n.e,!0),e._isFateSealed()||e._setAsyncGuaranteed(),e},D.all=function(t){return new b(t).promise()},D.cast=function(t){var e=y(t);return e instanceof D||((e=new D(p))._captureStackTrace(),e._setFulfilled(),e._rejectionHandler0=t),e},D.resolve=D.fulfilled=D.cast,D.reject=D.rejected=function(t){var e=new D(p);return e._captureStackTrace(),e._rejectCallback(t,!0),e},D.setScheduler=function(t){if("function"!=typeof t)throw new _("expecting a function but got "+c.classString(t));return h.setScheduler(t)},D.prototype._then=function(t,e,i,n,r){var a=void 0!==r,o=a?r:new D(p),l=this._target(),u=l._bitField;a||(o._propagateFrom(this,3),o._captureStackTrace(),void 0===n&&0!=(2097152&this._bitField)&&(n=0!=(50397184&u)?this._boundValue():l===this?void 0:this._boundTo),this._fireEvent("promiseChained",this,o));var d=s();if(0!=(50397184&u)){var f,_,v=l._settlePromiseCtx;0!=(33554432&u)?(_=l._rejectionHandler0,f=t):0!=(16777216&u)?(_=l._fulfillmentHandler0,f=e,l._unsetRejectionIsUnhandled()):(v=l._settlePromiseLateCancellationObserver,_=new g("late cancellation observer"),l._attachExtraTrace(_),f=e),h.invoke(v,l,{handler:null===d?f:"function"==typeof f&&c.domainBind(d,f),promise:o,receiver:n,value:_})}else l._addCallbacks(t,e,o,n,d);return o},D.prototype._length=function(){return 65535&this._bitField},D.prototype._isFateSealed=function(){return 0!=(117506048&this._bitField)},D.prototype._isFollowing=function(){return 67108864==(67108864&this._bitField)},D.prototype._setLength=function(t){this._bitField=-65536&this._bitField|65535&t},D.prototype._setFulfilled=function(){this._bitField=33554432|this._bitField,this._fireEvent("promiseFulfilled",this)},D.prototype._setRejected=function(){this._bitField=16777216|this._bitField,this._fireEvent("promiseRejected",this)},D.prototype._setFollowing=function(){this._bitField=67108864|this._bitField,this._fireEvent("promiseResolved",this)},D.prototype._setIsFinal=function(){this._bitField=4194304|this._bitField},D.prototype._isFinal=function(){return(4194304&this._bitField)>0},D.prototype._unsetCancelled=function(){this._bitField=-65537&this._bitField},D.prototype._setCancelled=function(){this._bitField=65536|this._bitField,this._fireEvent("promiseCancelled",this)},D.prototype._setWillBeCancelled=function(){this._bitField=8388608|this._bitField},D.prototype._setAsyncGuaranteed=function(){h.hasCustomScheduler()||(this._bitField=134217728|this._bitField)},D.prototype._receiverAt=function(t){var e=0===t?this._receiver0:this[4*t-4+3];if(e!==l)return void 0===e&&this._isBound()?this._boundValue():e},D.prototype._promiseAt=function(t){return this[4*t-4+2]},D.prototype._fulfillmentHandlerAt=function(t){return this[4*t-4+0]},D.prototype._rejectionHandlerAt=function(t){return this[4*t-4+1]},D.prototype._boundValue=function(){},D.prototype._migrateCallback0=function(t){t._bitField;var e=t._fulfillmentHandler0,i=t._rejectionHandler0,n=t._promise0,r=t._receiverAt(0);void 0===r&&(r=l),this._addCallbacks(e,i,n,r,null)},D.prototype._migrateCallbackAt=function(t,e){var i=t._fulfillmentHandlerAt(e),n=t._rejectionHandlerAt(e),r=t._promiseAt(e),a=t._receiverAt(e);void 0===a&&(a=l),this._addCallbacks(i,n,r,a,null)},D.prototype._addCallbacks=function(t,e,i,n,r){var a=this._length();if(a>=65531&&(a=0,this._setLength(0)),0===a)this._promise0=i,this._receiver0=n,"function"==typeof t&&(this._fulfillmentHandler0=null===r?t:c.domainBind(r,t)),"function"==typeof e&&(this._rejectionHandler0=null===r?e:c.domainBind(r,e));else{var o=4*a-4;this[o+2]=i,this[o+3]=n,"function"==typeof t&&(this[o+0]=null===r?t:c.domainBind(r,t)),"function"==typeof e&&(this[o+1]=null===r?e:c.domainBind(r,e))}return this._setLength(a+1),a},D.prototype._proxy=function(t,e){this._addCallbacks(void 0,void 0,e,t,null)},D.prototype._resolveCallback=function(t,e){if(0==(117506048&this._bitField)){if(t===this)return this._rejectCallback(n(),!1);var i=y(t,this);if(!(i instanceof D))return this._fulfill(t);e&&this._propagateFrom(i,2);var r=i._target();if(r!==this){var a=r._bitField;if(0==(50397184&a)){var o=this._length();o>0&&r._migrateCallback0(this);for(var s=1;s<o;++s)r._migrateCallbackAt(this,s);this._setFollowing(),this._setLength(0),this._setFollowee(r)}else if(0!=(33554432&a))this._fulfill(r._value());else if(0!=(16777216&a))this._reject(r._reason());else{var l=new g("late cancellation observer");r._attachExtraTrace(l),this._reject(l)}}else this._reject(n())}},D.prototype._rejectCallback=function(t,e,i){var n=c.ensureErrorObject(t),r=n===t;if(!r&&!i&&x.warnings()){var a="a promise was rejected with a non-error: "+c.classString(t);this._warn(a,!0)}this._attachExtraTrace(n,!!e&&r),this._reject(t)},D.prototype._resolveFromExecutor=function(t){if(t!==p){var e=this;this._captureStackTrace(),this._pushContext();var i=!0,n=this._execute(t,function(t){e._resolveCallback(t)},function(t){e._rejectCallback(t,i)});i=!1,this._popContext(),void 0!==n&&e._rejectCallback(n,!0)}},D.prototype._settlePromiseFromHandler=function(t,e,i,n){var r=n._bitField;if(0==(65536&r)){var a;n._pushContext(),e===v?i&&"number"==typeof i.length?a=E(t).apply(this._boundValue(),i):(a=C).e=new _("cannot .spread() a non-array: "+c.classString(i)):a=E(t).call(e,i);var o=n._popContext();0==(65536&(r=n._bitField))&&(a===m?n._reject(i):a===C?n._rejectCallback(a.e,!1):(x.checkForgottenReturns(a,o,"",n,this),n._resolveCallback(a)))}},D.prototype._target=function(){for(var t=this;t._isFollowing();)t=t._followee();return t},D.prototype._followee=function(){return this._rejectionHandler0},D.prototype._setFollowee=function(t){this._rejectionHandler0=t},D.prototype._settlePromise=function(t,e,i,n){var a=t instanceof D,s=this._bitField,l=0!=(134217728&s);0!=(65536&s)?(a&&t._invokeInternalOnCancel(),i instanceof $&&i.isFinallyHandler()?(i.cancelPromise=t,E(e).call(i,n)===C&&t._reject(C.e)):e===r?t._fulfill(r.call(i)):i instanceof o?i._promiseCancelled(t):a||t instanceof b?t._cancel():i.cancel()):"function"==typeof e?a?(l&&t._setAsyncGuaranteed(),this._settlePromiseFromHandler(e,i,n,t)):e.call(i,n,t):i instanceof o?i._isResolved()||(0!=(33554432&s)?i._promiseFulfilled(n,t):i._promiseRejected(n,t)):a&&(l&&t._setAsyncGuaranteed(),0!=(33554432&s)?t._fulfill(n):t._reject(n))},D.prototype._settlePromiseLateCancellationObserver=function(t){var e=t.handler,i=t.promise,n=t.receiver,r=t.value;"function"==typeof e?i instanceof D?this._settlePromiseFromHandler(e,n,r,i):e.call(n,r,i):i instanceof D&&i._reject(r)},D.prototype._settlePromiseCtx=function(t){this._settlePromise(t.promise,t.handler,t.receiver,t.value)},D.prototype._settlePromise0=function(t,e,i){var n=this._promise0,r=this._receiverAt(0);this._promise0=void 0,this._receiver0=void 0,this._settlePromise(n,t,r,e)},D.prototype._clearCallbackDataAtIndex=function(t){var e=4*t-4;this[e+2]=this[e+3]=this[e+0]=this[e+1]=void 0},D.prototype._fulfill=function(t){var e=this._bitField;if(!((117506048&e)>>>16)){if(t===this){var i=n();return this._attachExtraTrace(i),this._reject(i)}this._setFulfilled(),this._rejectionHandler0=t,(65535&e)>0&&(0!=(134217728&e)?this._settlePromises():h.settlePromises(this),this._dereferenceTrace())}},D.prototype._reject=function(t){var e=this._bitField;if(!((117506048&e)>>>16)){if(this._setRejected(),this._fulfillmentHandler0=t,this._isFinal())return h.fatalError(t,c.isNode);(65535&e)>0?h.settlePromises(this):this._ensurePossibleRejectionHandled()}},D.prototype._fulfillPromises=function(t,e){for(var i=1;i<t;i++){var n=this._fulfillmentHandlerAt(i),r=this._promiseAt(i),a=this._receiverAt(i);this._clearCallbackDataAtIndex(i),this._settlePromise(r,n,a,e)}},D.prototype._rejectPromises=function(t,e){for(var i=1;i<t;i++){var n=this._rejectionHandlerAt(i),r=this._promiseAt(i),a=this._receiverAt(i);this._clearCallbackDataAtIndex(i),this._settlePromise(r,n,a,e)}},D.prototype._settlePromises=function(){var t=this._bitField,e=65535&t;if(e>0){if(0!=(16842752&t)){var i=this._fulfillmentHandler0;this._settlePromise0(this._rejectionHandler0,i,t),this._rejectPromises(e,i)}else{var n=this._rejectionHandler0;this._settlePromise0(this._fulfillmentHandler0,n,t),this._fulfillPromises(e,n)}this._setLength(0)}this._clearCancellationData()},D.prototype._settledValue=function(){var t=this._bitField;return 0!=(33554432&t)?this._rejectionHandler0:0!=(16777216&t)?this._fulfillmentHandler0:void 0},D.defer=D.pending=function(){x.deprecated("Promise.defer","new Promise");var t=new D(p);return{promise:t,resolve:I,reject:A}},c.notEnumerableProp(D,"_makeSelfResolutionError",n),t("./method")(D,p,y,a,x),t("./bind")(D,p,y,x),t("./cancel")(D,b,a,x),t("./direct_resolve")(D),t("./synchronous_inspection")(D),t("./join")(D,b,y,p,h,s),D.Promise=D,D.version="3.5.4",t("./map.js")(D,b,a,y,p,x),t("./call_get.js")(D),t("./using.js")(D,a,y,w,p,x),t("./timers.js")(D,p,x),t("./generators.js")(D,a,p,y,o,x),t("./nodeify.js")(D),t("./promisify.js")(D,p),t("./props.js")(D,b,y,a),t("./race.js")(D,p,y,a),t("./reduce.js")(D,b,a,y,p,x),t("./settle.js")(D,b,x),t("./some.js")(D,b,a),t("./filter.js")(D,p),t("./each.js")(D,p),t("./any.js")(D),c.toFastProperties(D),c.toFastProperties(D.prototype),P({a:1}),P({b:2}),P({c:3}),P(1),P(function(){}),P(void 0),P(!1),P(new D(p)),x.setBounds(d.firstLineError,c.lastLineError),D}},{"./any.js":1,"./async":2,"./bind":3,"./call_get.js":5,"./cancel":6,"./catch_filter":7,"./context":8,"./debuggability":9,"./direct_resolve":10,"./each.js":11,"./errors":12,"./es5":13,"./filter.js":14,"./finally":15,"./generators.js":16,"./join":17,"./map.js":18,"./method":19,"./nodeback":20,"./nodeify.js":21,"./promise_array":23,"./promisify.js":24,"./props.js":25,"./race.js":27,"./reduce.js":28,"./settle.js":30,"./some.js":31,"./synchronous_inspection":32,"./thenables":33,"./timers.js":34,"./using.js":35,"./util":36}],23:[function(t,e,i){"use strict";e.exports=function(e,i,n,r,a){var o=t("./util");function s(t){var n=this._promise=new e(i);t instanceof e&&n._propagateFrom(t,3),n._setOnCancel(this),this._values=t,this._length=0,this._totalResolved=0,this._init(void 0,-2)}return o.isArray,o.inherits(s,a),s.prototype.length=function(){return this._length},s.prototype.promise=function(){return this._promise},s.prototype._init=function t(i,a){var s=n(this._values,this._promise);if(s instanceof e){var l=(s=s._target())._bitField;if(this._values=s,0==(50397184&l))return this._promise._setAsyncGuaranteed(),s._then(t,this._reject,void 0,this,a);if(0==(33554432&l))return 0!=(16777216&l)?this._reject(s._reason()):this._cancel();s=s._value()}if(null!==(s=o.asArray(s)))0!==s.length?this._iterate(s):-5===a?this._resolveEmptyArray():this._resolve(function(t){switch(t){case-2:return[];case-3:return{};case-6:return new Map}}(a));else{var c=r("expecting an array or an iterable object but got "+o.classString(s)).reason();this._promise._rejectCallback(c,!1)}},s.prototype._iterate=function(t){var i=this.getActualLength(t.length);this._length=i,this._values=this.shouldCopyValues()?new Array(i):this._values;for(var r=this._promise,a=!1,o=null,s=0;s<i;++s){var l=n(t[s],r);l instanceof e?(l=l._target(),o=l._bitField):o=null,a?null!==o&&l.suppressUnhandledRejections():null!==o?0==(50397184&o)?(l._proxy(this,s),this._values[s]=l):a=0!=(33554432&o)?this._promiseFulfilled(l._value(),s):0!=(16777216&o)?this._promiseRejected(l._reason(),s):this._promiseCancelled(s):a=this._promiseFulfilled(l,s)}a||r._setAsyncGuaranteed()},s.prototype._isResolved=function(){return null===this._values},s.prototype._resolve=function(t){this._values=null,this._promise._fulfill(t)},s.prototype._cancel=function(){!this._isResolved()&&this._promise._isCancellable()&&(this._values=null,this._promise._cancel())},s.prototype._reject=function(t){this._values=null,this._promise._rejectCallback(t,!1)},s.prototype._promiseFulfilled=function(t,e){this._values[e]=t;var i=++this._totalResolved;return i>=this._length&&(this._resolve(this._values),!0)},s.prototype._promiseCancelled=function(){return this._cancel(),!0},s.prototype._promiseRejected=function(t){return this._totalResolved++,this._reject(t),!0},s.prototype._resultCancelled=function(){if(!this._isResolved()){var t=this._values;if(this._cancel(),t instanceof e)t.cancel();else for(var i=0;i<t.length;++i)t[i]instanceof e&&t[i].cancel()}},s.prototype.shouldCopyValues=function(){return!0},s.prototype.getActualLength=function(t){return t},s}},{"./util":36}],24:[function(t,e,i){"use strict";e.exports=function(e,i){var n={},r=t("./util"),a=t("./nodeback"),o=r.withAppended,s=r.maybeWrapAsError,l=r.canEvaluate,c=t("./errors").TypeError,u={__isPromisified__:!0},d=new RegExp("^(?:"+["arity","length","name","arguments","caller","callee","prototype","__isPromisified__"].join("|")+")$"),h=function(t){return r.isIdentifier(t)&&"_"!==t.charAt(0)&&"constructor"!==t};function f(t){return!d.test(t)}function _(t){try{return!0===t.__isPromisified__}catch(t){return!1}}function g(t,e,i){var n=r.getDataPropertyOrDefault(t,e+i,u);return!!n&&_(n)}function p(t,e,i,n){for(var a=r.inheritedDataKeys(t),o=[],s=0;s<a.length;++s){var l=a[s],u=t[l],d=n===h||h(l,u,t);"function"!=typeof u||_(u)||g(t,l,e)||!n(l,u,t,d)||o.push(l,u)}return function(t,e,i){for(var n=0;n<t.length;n+=2){var r=t[n];if(i.test(r))for(var a=r.replace(i,""),o=0;o<t.length;o+=2)if(t[o]===a)throw new c("Cannot promisify an API that has normal methods with '%s'-suffix\n\n    See http://goo.gl/MqrFmX\n".replace("%s",e))}}(o,e,i),o}var v=function(t){return t.replace(/([$])/,"\\$")},m=l?void 0:function(t,l,c,u,d,h){var f=function(){return this}(),_=t;function g(){var r=l;l===n&&(r=this);var c=new e(i);c._captureStackTrace();var u="string"==typeof _&&this!==f?this[_]:t,d=a(c,h);try{u.apply(r,o(arguments,d))}catch(t){c._rejectCallback(s(t),!0,!0)}return c._isFateSealed()||c._setAsyncGuaranteed(),c}return"string"==typeof _&&(t=u),r.notEnumerableProp(g,"__isPromisified__",!0),g};function y(t,e,i,a,o){for(var s=new RegExp(v(e)+"$"),l=p(t,e,s,i),c=0,u=l.length;c<u;c+=2){var d=l[c],h=l[c+1],f=d+e;if(a===m)t[f]=m(d,n,d,h,e,o);else{var _=a(h,function(){return m(d,n,d,h,e,o)});r.notEnumerableProp(_,"__isPromisified__",!0),t[f]=_}}return r.toFastProperties(t),t}e.promisify=function(t,e){if("function"!=typeof t)throw new c("expecting a function but got "+r.classString(t));if(_(t))return t;var i=void 0===(e=Object(e)).context?n:e.context,a=!!e.multiArgs,o=function(t,e,i){return m(t,e,void 0,t,null,i)}(t,i,a);return r.copyDescriptors(t,o,f),o},e.promisifyAll=function(t,e){if("function"!=typeof t&&"object"!=typeof t)throw new c("the target of promisifyAll must be an object or a function\n\n    See http://goo.gl/MqrFmX\n");var i=!!(e=Object(e)).multiArgs,n=e.suffix;"string"!=typeof n&&(n="Async");var a=e.filter;"function"!=typeof a&&(a=h);var o=e.promisifier;if("function"!=typeof o&&(o=m),!r.isIdentifier(n))throw new RangeError("suffix must be a valid identifier\n\n    See http://goo.gl/MqrFmX\n");for(var s=r.inheritedDataKeys(t),l=0;l<s.length;++l){var u=t[s[l]];"constructor"!==s[l]&&r.isClass(u)&&(y(u.prototype,n,a,o,i),y(u,n,a,o,i))}return y(t,n,a,o,i)}}},{"./errors":12,"./nodeback":20,"./util":36}],25:[function(t,e,i){"use strict";e.exports=function(e,i,n,r){var a,o=t("./util"),s=o.isObject,l=t("./es5");"function"==typeof Map&&(a=Map);var c=function(){var t=0,e=0;function i(i,n){this[t]=i,this[t+e]=n,t++}return function(n){e=n.size,t=0;var r=new Array(2*n.size);return n.forEach(i,r),r}}();function u(t){var e,i=!1;if(void 0!==a&&t instanceof a)e=c(t),i=!0;else{var n=l.keys(t),r=n.length;e=new Array(2*r);for(var o=0;o<r;++o){var s=n[o];e[o]=t[s],e[o+r]=s}}this.constructor$(e),this._isMap=i,this._init$(void 0,i?-6:-3)}function d(t){var i,a=n(t);return s(a)?(i=a instanceof e?a._then(e.props,void 0,void 0,void 0,void 0):new u(a).promise(),a instanceof e&&i._propagateFrom(a,2),i):r("cannot await properties of a non-object\n\n    See http://goo.gl/MqrFmX\n")}o.inherits(u,i),u.prototype._init=function(){},u.prototype._promiseFulfilled=function(t,e){this._values[e]=t;var i=++this._totalResolved;if(i>=this._length){var n;if(this._isMap)n=function(t){for(var e=new a,i=t.length/2|0,n=0;n<i;++n){var r=t[i+n],o=t[n];e.set(r,o)}return e}(this._values);else{n={};for(var r=this.length(),o=0,s=this.length();o<s;++o)n[this._values[o+r]]=this._values[o]}return this._resolve(n),!0}return!1},u.prototype.shouldCopyValues=function(){return!1},u.prototype.getActualLength=function(t){return t>>1},e.prototype.props=function(){return d(this)},e.props=function(t){return d(t)}}},{"./es5":13,"./util":36}],26:[function(t,e,i){"use strict";function n(t){this._capacity=t,this._length=0,this._front=0}n.prototype._willBeOverCapacity=function(t){return this._capacity<t},n.prototype._pushOne=function(t){var e=this.length();this._checkCapacity(e+1);var i=this._front+e&this._capacity-1;this[i]=t,this._length=e+1},n.prototype.push=function(t,e,i){var n=this.length()+3;if(this._willBeOverCapacity(n))return this._pushOne(t),this._pushOne(e),void this._pushOne(i);var r=this._front+n-3;this._checkCapacity(n);var a=this._capacity-1;this[r+0&a]=t,this[r+1&a]=e,this[r+2&a]=i,this._length=n},n.prototype.shift=function(){var t=this._front,e=this[t];return this[t]=void 0,this._front=t+1&this._capacity-1,this._length--,e},n.prototype.length=function(){return this._length},n.prototype._checkCapacity=function(t){this._capacity<t&&this._resizeTo(this._capacity<<1)},n.prototype._resizeTo=function(t){var e=this._capacity;this._capacity=t;var i=this._front,n=this._length,r=i+n&e-1;!function(t,e,i,n,r){for(var a=0;a<r;++a)i[a+n]=t[a+e],t[a+e]=void 0}(this,0,this,e,r)},e.exports=n},{}],27:[function(t,e,i){"use strict";e.exports=function(e,i,n,r){var a=t("./util"),o=function(t){return t.then(function(e){return s(e,t)})};function s(t,s){var l=n(t);if(l instanceof e)return o(l);if(null===(t=a.asArray(t)))return r("expecting an array or an iterable object but got "+a.classString(t));var c=new e(i);void 0!==s&&c._propagateFrom(s,3);for(var u=c._fulfill,d=c._reject,h=0,f=t.length;h<f;++h){var _=t[h];(void 0!==_||h in t)&&e.cast(_)._then(u,d,void 0,c,null)}return c}e.race=function(t){return s(t,void 0)},e.prototype.race=function(){return s(this,void 0)}}},{"./util":36}],28:[function(t,e,i){"use strict";e.exports=function(e,i,n,r,a,o){var s=e._getDomain,l=t("./util"),c=l.tryCatch;function u(t,i,n,r){this.constructor$(t);var o=s();this._fn=null===o?i:l.domainBind(o,i),void 0!==n&&(n=e.resolve(n))._attachCancellationCallback(this),this._initialValue=n,this._currentCancellable=null,this._eachValues=r===a?Array(this._length):0===r?null:void 0,this._promise._captureStackTrace(),this._init$(void 0,-5)}function d(t,e){this.isFulfilled()?e._resolve(t):e._reject(t)}function h(t,e,i,r){if("function"!=typeof e)return n("expecting a function but got "+l.classString(e));var a=new u(t,e,i,r);return a.promise()}function f(t){this.accum=t,this.array._gotAccum(t);var i=r(this.value,this.array._promise);return i instanceof e?(this.array._currentCancellable=i,i._then(_,void 0,void 0,this,void 0)):_.call(this,i)}function _(t){var i,n=this.array,r=n._promise,a=c(n._fn);r._pushContext(),(i=void 0!==n._eachValues?a.call(r._boundValue(),t,this.index,this.length):a.call(r._boundValue(),this.accum,t,this.index,this.length))instanceof e&&(n._currentCancellable=i);var s=r._popContext();return o.checkForgottenReturns(i,s,void 0!==n._eachValues?"Promise.each":"Promise.reduce",r),i}l.inherits(u,i),u.prototype._gotAccum=function(t){void 0!==this._eachValues&&null!==this._eachValues&&t!==a&&this._eachValues.push(t)},u.prototype._eachComplete=function(t){return null!==this._eachValues&&this._eachValues.push(t),this._eachValues},u.prototype._init=function(){},u.prototype._resolveEmptyArray=function(){this._resolve(void 0!==this._eachValues?this._eachValues:this._initialValue)},u.prototype.shouldCopyValues=function(){return!1},u.prototype._resolve=function(t){this._promise._resolveCallback(t),this._values=null},u.prototype._resultCancelled=function(t){if(t===this._initialValue)return this._cancel();this._isResolved()||(this._resultCancelled$(),this._currentCancellable instanceof e&&this._currentCancellable.cancel(),this._initialValue instanceof e&&this._initialValue.cancel())},u.prototype._iterate=function(t){var i,n;this._values=t;var r=t.length;if(void 0!==this._initialValue?(i=this._initialValue,n=0):(i=e.resolve(t[0]),n=1),this._currentCancellable=i,!i.isRejected())for(;n<r;++n){var a={accum:null,value:t[n],index:n,length:r,array:this};i=i._then(f,void 0,void 0,a,void 0)}void 0!==this._eachValues&&(i=i._then(this._eachComplete,void 0,void 0,this,void 0)),i._then(d,d,void 0,i,this)},e.prototype.reduce=function(t,e){return h(this,t,e,null)},e.reduce=function(t,e,i,n){return h(t,e,i,n)}}},{"./util":36}],29:[function(t,r,a){"use strict";var o,s=t("./util"),l=s.getNativePromise();if(s.isNode&&"undefined"==typeof MutationObserver){var c=i.setImmediate,u=e.nextTick;o=s.isRecentNode?function(t){c.call(i,t)}:function(t){u.call(e,t)}}else if("function"==typeof l&&"function"==typeof l.resolve){var d=l.resolve();o=function(t){d.then(t)}}else o="undefined"==typeof MutationObserver||"undefined"!=typeof window&&window.navigator&&(window.navigator.standalone||window.cordova)?void 0!==n?function(t){n(t)}:"undefined"!=typeof setTimeout?function(t){setTimeout(t,0)}:function(){throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n")}:function(){var t=document.createElement("div"),e={attributes:!0},i=!1,n=document.createElement("div"),r=new MutationObserver(function(){t.classList.toggle("foo"),i=!1});return r.observe(n,e),function(r){var a=new MutationObserver(function(){a.disconnect(),r()});a.observe(t,e),i||(i=!0,n.classList.toggle("foo"))}}();r.exports=o},{"./util":36}],30:[function(t,e,i){"use strict";e.exports=function(e,i,n){var r=e.PromiseInspection,a=t("./util");function o(t){this.constructor$(t)}a.inherits(o,i),o.prototype._promiseResolved=function(t,e){this._values[t]=e;var i=++this._totalResolved;return i>=this._length&&(this._resolve(this._values),!0)},o.prototype._promiseFulfilled=function(t,e){var i=new r;return i._bitField=33554432,i._settledValueField=t,this._promiseResolved(e,i)},o.prototype._promiseRejected=function(t,e){var i=new r;return i._bitField=16777216,i._settledValueField=t,this._promiseResolved(e,i)},e.settle=function(t){return n.deprecated(".settle()",".reflect()"),new o(t).promise()},e.prototype.settle=function(){return e.settle(this)}}},{"./util":36}],31:[function(t,e,i){"use strict";e.exports=function(e,i,n){var r=t("./util"),a=t("./errors").RangeError,o=t("./errors").AggregateError,s=r.isArray,l={};function c(t){this.constructor$(t),this._howMany=0,this._unwrap=!1,this._initialized=!1}function u(t,e){if((0|e)!==e||e<0)return n("expecting a positive integer\n\n    See http://goo.gl/MqrFmX\n");var i=new c(t),r=i.promise();return i.setHowMany(e),i.init(),r}r.inherits(c,i),c.prototype._init=function(){if(this._initialized)if(0!==this._howMany){this._init$(void 0,-5);var t=s(this._values);!this._isResolved()&&t&&this._howMany>this._canPossiblyFulfill()&&this._reject(this._getRangeError(this.length()))}else this._resolve([])},c.prototype.init=function(){this._initialized=!0,this._init()},c.prototype.setUnwrap=function(){this._unwrap=!0},c.prototype.howMany=function(){return this._howMany},c.prototype.setHowMany=function(t){this._howMany=t},c.prototype._promiseFulfilled=function(t){return this._addFulfilled(t),this._fulfilled()===this.howMany()&&(this._values.length=this.howMany(),1===this.howMany()&&this._unwrap?this._resolve(this._values[0]):this._resolve(this._values),!0)},c.prototype._promiseRejected=function(t){return this._addRejected(t),this._checkOutcome()},c.prototype._promiseCancelled=function(){return this._values instanceof e||null==this._values?this._cancel():(this._addRejected(l),this._checkOutcome())},c.prototype._checkOutcome=function(){if(this.howMany()>this._canPossiblyFulfill()){for(var t=new o,e=this.length();e<this._values.length;++e)this._values[e]!==l&&t.push(this._values[e]);return t.length>0?this._reject(t):this._cancel(),!0}return!1},c.prototype._fulfilled=function(){return this._totalResolved},c.prototype._rejected=function(){return this._values.length-this.length()},c.prototype._addRejected=function(t){this._values.push(t)},c.prototype._addFulfilled=function(t){this._values[this._totalResolved++]=t},c.prototype._canPossiblyFulfill=function(){return this.length()-this._rejected()},c.prototype._getRangeError=function(t){var e="Input array must contain at least "+this._howMany+" items but contains only "+t+" items";return new a(e)},c.prototype._resolveEmptyArray=function(){this._reject(this._getRangeError(0))},e.some=function(t,e){return u(t,e)},e.prototype.some=function(t){return u(this,t)},e._SomePromiseArray=c}},{"./errors":12,"./util":36}],32:[function(t,e,i){"use strict";e.exports=function(t){function e(t){void 0!==t?(t=t._target(),this._bitField=t._bitField,this._settledValueField=t._isFateSealed()?t._settledValue():void 0):(this._bitField=0,this._settledValueField=void 0)}e.prototype._settledValue=function(){return this._settledValueField};var i=e.prototype.value=function(){if(!this.isFulfilled())throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\n\n    See http://goo.gl/MqrFmX\n");return this._settledValue()},n=e.prototype.error=e.prototype.reason=function(){if(!this.isRejected())throw new TypeError("cannot get rejection reason of a non-rejected promise\n\n    See http://goo.gl/MqrFmX\n");return this._settledValue()},r=e.prototype.isFulfilled=function(){return 0!=(33554432&this._bitField)},a=e.prototype.isRejected=function(){return 0!=(16777216&this._bitField)},o=e.prototype.isPending=function(){return 0==(50397184&this._bitField)},s=e.prototype.isResolved=function(){return 0!=(50331648&this._bitField)};e.prototype.isCancelled=function(){return 0!=(8454144&this._bitField)},t.prototype.__isCancelled=function(){return 65536==(65536&this._bitField)},t.prototype._isCancelled=function(){return this._target().__isCancelled()},t.prototype.isCancelled=function(){return 0!=(8454144&this._target()._bitField)},t.prototype.isPending=function(){return o.call(this._target())},t.prototype.isRejected=function(){return a.call(this._target())},t.prototype.isFulfilled=function(){return r.call(this._target())},t.prototype.isResolved=function(){return s.call(this._target())},t.prototype.value=function(){return i.call(this._target())},t.prototype.reason=function(){var t=this._target();return t._unsetRejectionIsUnhandled(),n.call(t)},t.prototype._value=function(){return this._settledValue()},t.prototype._reason=function(){return this._unsetRejectionIsUnhandled(),this._settledValue()},t.PromiseInspection=e}},{}],33:[function(t,e,i){"use strict";e.exports=function(e,i){var n=t("./util"),r=n.errorObj,a=n.isObject,o={}.hasOwnProperty;return function(t,s){if(a(t)){if(t instanceof e)return t;var l=function(t){try{return function(t){return t.then}(t)}catch(t){return r.e=t,r}}(t);if(l===r){s&&s._pushContext();var c=e.reject(l.e);return s&&s._popContext(),c}if("function"==typeof l){if(function(t){try{return o.call(t,"_promise0")}catch(t){return!1}}(t)){var c=new e(i);return t._then(c._fulfill,c._reject,void 0,c,null),c}return function(t,a,o){var s=new e(i),l=s;o&&o._pushContext(),s._captureStackTrace(),o&&o._popContext();var c=!0,u=n.tryCatch(a).call(t,function(t){s&&(s._resolveCallback(t),s=null)},function(t){s&&(s._rejectCallback(t,c,!0),s=null)});return c=!1,s&&u===r&&(s._rejectCallback(u.e,!0,!0),s=null),l}(t,l,s)}}return t}}},{"./util":36}],34:[function(t,e,i){"use strict";e.exports=function(e,i,n){var r=t("./util"),a=e.TimeoutError;function o(t){this.handle=t}o.prototype._resultCancelled=function(){clearTimeout(this.handle)};var s=function(t){return l(+this).thenReturn(t)},l=e.delay=function(t,r){var a,l;return void 0!==r?(a=e.resolve(r)._then(s,null,null,t,void 0),n.cancellation()&&r instanceof e&&a._setOnCancel(r)):(a=new e(i),l=setTimeout(function(){a._fulfill()},+t),n.cancellation()&&a._setOnCancel(new o(l)),a._captureStackTrace()),a._setAsyncGuaranteed(),a};function c(t){return clearTimeout(this.handle),t}function u(t){throw clearTimeout(this.handle),t}e.prototype.delay=function(t){return l(t,this)},e.prototype.timeout=function(t,e){var i,s;t=+t;var l=new o(setTimeout(function(){i.isPending()&&function(t,e,i){var n;n="string"!=typeof e?e instanceof Error?e:new a("operation timed out"):new a(e),r.markAsOriginatingFromRejection(n),t._attachExtraTrace(n),t._reject(n),null!=i&&i.cancel()}(i,e,s)},t));return n.cancellation()?(s=this.then(),(i=s._then(c,u,void 0,l,void 0))._setOnCancel(l)):i=this._then(c,u,void 0,l,void 0),i}}},{"./util":36}],35:[function(t,e,i){"use strict";e.exports=function(e,i,n,r,a,o){var s=t("./util"),l=t("./errors").TypeError,c=t("./util").inherits,u=s.errorObj,d=s.tryCatch,h={};function f(t){setTimeout(function(){throw t},0)}function _(t,i){var r=0,o=t.length,s=new e(a);return function a(){if(r>=o)return s._fulfill();var l=function(t){var e=n(t);return e!==t&&"function"==typeof t._isDisposable&&"function"==typeof t._getDisposer&&t._isDisposable()&&e._setDisposable(t._getDisposer()),e}(t[r++]);if(l instanceof e&&l._isDisposable()){try{l=n(l._getDisposer().tryDispose(i),t.promise)}catch(t){return f(t)}if(l instanceof e)return l._then(a,f,null,null,null)}a()}(),s}function g(t,e,i){this._data=t,this._promise=e,this._context=i}function p(t,e,i){this.constructor$(t,e,i)}function v(t){return g.isDisposer(t)?(this.resources[this.index]._setDisposable(t),t.promise()):t}function m(t){this.length=t,this.promise=null,this[t-1]=null}g.prototype.data=function(){return this._data},g.prototype.promise=function(){return this._promise},g.prototype.resource=function(){return this.promise().isFulfilled()?this.promise().value():h},g.prototype.tryDispose=function(t){var e=this.resource(),i=this._context;void 0!==i&&i._pushContext();var n=e!==h?this.doDispose(e,t):null;return void 0!==i&&i._popContext(),this._promise._unsetDisposable(),this._data=null,n},g.isDisposer=function(t){return null!=t&&"function"==typeof t.resource&&"function"==typeof t.tryDispose},c(p,g),p.prototype.doDispose=function(t,e){var i=this.data();return i.call(t,t,e)},m.prototype._resultCancelled=function(){for(var t=this.length,i=0;i<t;++i){var n=this[i];n instanceof e&&n.cancel()}},e.using=function(){var t=arguments.length;if(t<2)return i("you must pass at least 2 arguments to Promise.using");var r,a=arguments[t-1];if("function"!=typeof a)return i("expecting a function but got "+s.classString(a));var l=!0;2===t&&Array.isArray(arguments[0])?(r=arguments[0],t=r.length,l=!1):(r=arguments,t--);for(var c=new m(t),h=0;h<t;++h){var f=r[h];if(g.isDisposer(f)){var p=f;(f=f.promise())._setDisposable(p)}else{var y=n(f);y instanceof e&&(f=y._then(v,null,null,{resources:c,index:h},void 0))}c[h]=f}for(var b=new Array(c.length),h=0;h<b.length;++h)b[h]=e.resolve(c[h]).reflect();var k=e.all(b).then(function(t){for(var e=0;e<t.length;++e){var i=t[e];if(i.isRejected())return u.e=i.error(),u;if(!i.isFulfilled())return void k.cancel();t[e]=i.value()}w._pushContext(),a=d(a);var n=l?a.apply(void 0,t):a(t),r=w._popContext();return o.checkForgottenReturns(n,r,"Promise.using",w),n}),w=k.lastly(function(){var t=new e.PromiseInspection(k);return _(c,t)});return c.promise=w,w._setOnCancel(c),w},e.prototype._setDisposable=function(t){this._bitField=131072|this._bitField,this._disposer=t},e.prototype._isDisposable=function(){return(131072&this._bitField)>0},e.prototype._getDisposer=function(){return this._disposer},e.prototype._unsetDisposable=function(){this._bitField=-131073&this._bitField,this._disposer=void 0},e.prototype.disposer=function(t){if("function"==typeof t)return new p(t,this,r());throw new l}}},{"./errors":12,"./util":36}],36:[function(t,n,r){"use strict";var a=t("./es5"),o="undefined"==typeof navigator,s={e:{}},l,c="undefined"!=typeof self?self:"undefined"!=typeof window?window:void 0!==i?i:void 0!==this?this:null;function u(){try{var t=l;return l=null,t.apply(this,arguments)}catch(t){return s.e=t,s}}function d(t){return l=t,u}var h=function(t,e){var i={}.hasOwnProperty;function n(){for(var n in this.constructor=t,this.constructor$=e,e.prototype)i.call(e.prototype,n)&&"$"!==n.charAt(n.length-1)&&(this[n+"$"]=e.prototype[n])}return n.prototype=e.prototype,t.prototype=new n,t.prototype};function f(t){return null==t||!0===t||!1===t||"string"==typeof t||"number"==typeof t}function _(t){return"function"==typeof t||"object"==typeof t&&null!==t}function g(t){return f(t)?new Error(C(t)):t}function p(t,e){var i,n=t.length,r=new Array(n+1);for(i=0;i<n;++i)r[i]=t[i];return r[i]=e,r}function v(t,e,i){if(!a.isES5)return{}.hasOwnProperty.call(t,e)?t[e]:void 0;var n=Object.getOwnPropertyDescriptor(t,e);return null!=n?null==n.get&&null==n.set?n.value:i:void 0}function m(t,e,i){if(f(t))return t;var n={value:i,configurable:!0,enumerable:!1,writable:!0};return a.defineProperty(t,e,n),t}function y(t){throw t}var b=function(){var t=[Array.prototype,Object.prototype,Function.prototype],e=function(e){for(var i=0;i<t.length;++i)if(t[i]===e)return!0;return!1};if(a.isES5){var i=Object.getOwnPropertyNames;return function(t){for(var n=[],r=Object.create(null);null!=t&&!e(t);){var o;try{o=i(t)}catch(t){return n}for(var s=0;s<o.length;++s){var l=o[s];if(!r[l]){r[l]=!0;var c=Object.getOwnPropertyDescriptor(t,l);null!=c&&null==c.get&&null==c.set&&n.push(l)}}t=a.getPrototypeOf(t)}return n}}var n={}.hasOwnProperty;return function(i){if(e(i))return[];var r=[];t:for(var a in i)if(n.call(i,a))r.push(a);else{for(var o=0;o<t.length;++o)if(n.call(t[o],a))continue t;r.push(a)}return r}}(),k=/this\s*\.\s*\S+\s*=/;function w(t){try{if("function"==typeof t){var e=a.names(t.prototype),i=a.isES5&&e.length>1,n=e.length>0&&!(1===e.length&&"constructor"===e[0]),r=k.test(t+"")&&a.names(t).length>0;if(i||n||r)return!0}return!1}catch(t){return!1}}function x(t){function e(){}e.prototype=t;var i=new e;function n(){return typeof i.foo}return n(),n(),t}var $=/^[a-z$_][a-z$_0-9]*$/i;function S(t){return $.test(t)}function T(t,e,i){for(var n=new Array(t),r=0;r<t;++r)n[r]=e+r+i;return n}function C(t){try{return t+""}catch(t){return"[no string representation]"}}function E(t){return t instanceof Error||null!==t&&"object"==typeof t&&"string"==typeof t.message&&"string"==typeof t.name}function D(t){try{m(t,"isOperational",!0)}catch(t){}}function I(t){return null!=t&&(t instanceof Error.__BluebirdErrorTypes__.OperationalError||!0===t.isOperational)}function A(t){return E(t)&&a.propertyIsWritable(t,"stack")}var P="stack"in new Error?function(t){return A(t)?t:new Error(C(t))}:function(t){if(A(t))return t;try{throw new Error(C(t))}catch(t){return t}};function L(t){return{}.toString.call(t)}function M(t,e,i){for(var n=a.names(t),r=0;r<n.length;++r){var o=n[r];if(i(o))try{a.defineProperty(e,o,a.getDescriptor(t,o))}catch(t){}}}var O=function(t){return a.isArray(t)?t:null};if("undefined"!=typeof Symbol&&Symbol.iterator){var N="function"==typeof Array.from?function(t){return Array.from(t)}:function(t){for(var e,i=[],n=t[Symbol.iterator]();!(e=n.next()).done;)i.push(e.value);return i};O=function(t){return a.isArray(t)?t:null!=t&&"function"==typeof t[Symbol.iterator]?N(t):null}}var j=void 0!==e&&"[object process]"===L(e).toLowerCase(),R=void 0!==e&&void 0!==e.env;function H(t){return R?e.env[t]:void 0}function z(){if("function"==typeof Promise)try{var t=new Promise(function(){});if("[object Promise]"==={}.toString.call(t))return Promise}catch(t){}}function F(t,e){return t.bind(e)}var B={isClass:w,isIdentifier:S,inheritedDataKeys:b,getDataPropertyOrDefault:v,thrower:y,isArray:a.isArray,asArray:O,notEnumerableProp:m,isPrimitive:f,isObject:_,isError:E,canEvaluate:o,errorObj:s,tryCatch:d,inherits:h,withAppended:p,maybeWrapAsError:g,toFastProperties:x,filledRange:T,toString:C,canAttachTrace:A,ensureErrorObject:P,originatesFromRejection:I,markAsOriginatingFromRejection:D,classString:L,copyDescriptors:M,hasDevTools:"undefined"!=typeof chrome&&chrome&&"function"==typeof chrome.loadTimes,isNode:j,hasEnvVariables:R,env:H,global:c,getNativePromise:z,domainBind:F};B.isRecentNode=B.isNode&&function(){var t;return e.versions&&e.versions.node?t=e.versions.node.split(".").map(Number):e.version&&(t=e.version.split(".").map(Number)),0===t[0]&&t[1]>10||t[0]>0}(),B.isNode&&B.toFastProperties(e);try{throw new Error}catch(t){B.lastLineError=t}n.exports=B},{"./es5":13}]},{},[4])(4)}(),"undefined"!=typeof window&&null!==window?window.P=window.Promise:"undefined"!=typeof self&&null!==self&&(self.P=self.Promise)}).call(this,i(35),i(16),i(148).setImmediate)},function(t,e,i){t.exports=i(149)},function(t,e,i){var n=i(0);t.exports=function(){var t={};return{getState:function(e){if(e)return t[e].method();var i={};for(var r in t)t[r].internal||n.mixin(i,t[r].method(),!0);return i},registerProvider:function(e,i,n){t[e]={method:i,internal:n}},unregisterProvider:function(e){delete t[e]}}}},function(t,e){t.exports=function(t){var e={};function i(i,n,r){r=r||i;var a=t.config,o=t.templates;t.config[i]&&e[r]!=a[i]&&(n&&o[r]||(o[r]=t.date.date_to_str(a[i]),e[r]=a[i]))}return{initTemplates:function(){var e=t.locale.labels;e.gantt_save_btn=e.icon_save,e.gantt_cancel_btn=e.icon_cancel,e.gantt_delete_btn=e.icon_delete;var n=t.date,r=n.date_to_str,a=t.config,o=r(a.xml_date||a.date_format,a.server_utc),s=n.str_to_date(a.xml_date||a.date_format,a.server_utc);i("date_scale",!0,void 0,t.config,t.templates),i("date_grid",!0,"grid_date_format",t.config,t.templates),i("task_date",!0,void 0,t.config,t.templates),t.mixin(t.templates,{xml_format:o,format_date:o,xml_date:s,parse_date:s,progress_text:function(t,e,i){return""},grid_header_class:function(t,e){return""},task_text:function(t,e,i){return i.text},task_class:function(t,e,i){return""},task_end_date:function(e){return t.templates.task_date(e)},grid_row_class:function(t,e,i){return""},task_row_class:function(t,e,i){return""},timeline_cell_class:function(t,e){return""},scale_cell_class:function(t){return""},scale_row_class:function(t){return""},grid_indent:function(t){return"<div class='gantt_tree_indent'></div>"},grid_folder:function(t){return"<div class='gantt_tree_icon gantt_folder_"+(t.$open?"open":"closed")+"'></div>"},grid_file:function(t){return"<div class='gantt_tree_icon gantt_file'></div>"},grid_open:function(t){return"<div class='gantt_tree_icon gantt_"+(t.$open?"close":"open")+"'></div>"},grid_blank:function(t){return"<div class='gantt_tree_icon gantt_blank'></div>"},date_grid:function(e,i,n){return i&&t.isUnscheduledTask(i)&&t.config.show_unscheduled?t.templates.task_unscheduled_time(i):t.templates.grid_date_format(e,n)},task_time:function(e,i,n){return t.isUnscheduledTask(n)&&t.config.show_unscheduled?t.templates.task_unscheduled_time(n):t.templates.task_date(e)+" - "+t.templates.task_end_date(i)},task_unscheduled_time:function(t){return""},time_picker:r(a.time_picker),link_class:function(t){return""},link_description:function(e){var i=t.getTask(e.source),n=t.getTask(e.target);return"<b>"+i.text+"</b> &ndash;  <b>"+n.text+"</b>"},drag_link:function(e,i,n,r){e=t.getTask(e);var a=t.locale.labels,o="<b>"+e.text+"</b> "+(i?a.link_start:a.link_end)+"<br/>";return n&&(o+="<b> "+(n=t.getTask(n)).text+"</b> "+(r?a.link_start:a.link_end)+"<br/>"),o},drag_link_class:function(e,i,n,r){var a="";return e&&n&&(a=" "+(t.isLinkAllowed(e,n,i,r)?"gantt_link_allow":"gantt_link_deny")),"gantt_link_tooltip"+a},tooltip_date_format:n.date_to_str("%Y-%m-%d"),tooltip_text:function(e,i,n){return"<b>Task:</b> "+n.text+"<br/><b>Start date:</b> "+t.templates.tooltip_date_format(e)+"<br/><b>End date:</b> "+t.templates.tooltip_date_format(i)}})},initTemplate:i}}},function(t,e,i){var n=i(4),r=i(0),a=i(36);t.exports=function(t){function e(t){return{target:t.target||t.srcElement,pageX:t.pageX,pageY:t.pageY,clientX:t.clientX,clientY:t.clientY,metaKey:t.metaKey,shiftKey:t.shiftKey,ctrlKey:t.ctrlKey,altKey:t.altKey}}function i(i,a){this._obj=i,this._settings=a||{},n(this);var o=this.getInputMethods();this._drag_start_timer=null,t.attachEvent("onGanttScroll",r.bind(function(t,e){this.clearDragTimer()},this));for(var s=0;s<o.length;s++)r.bind(function(n){t.event(i,n.down,r.bind(function(a){n.accessor(a)&&(this._settings.original_target=e(a),t.config.touch?(this.clearDragTimer(),this._drag_start_timer=setTimeout(r.bind(function(){this.dragStart(i,a,n)},this),t.config.touch_drag)):this.dragStart(i,a,n))},this)),t.event(document.body,n.up,r.bind(function(t){n.accessor(t)&&this.clearDragTimer()},this))},this)(o[s])}return i.prototype={traceDragEvents:function(e,i){var n=r.bind(function(t){return this.dragMove(e,t,i.accessor)},this);r.bind(function(t){return this.dragScroll(e,t)},this);var o=r.bind(function(t){if(!this.config.started||!r.defined(this.config.updates_per_second)||a(this,this.config.updates_per_second)){var e=n(t);return e&&(t&&t.preventDefault&&t.preventDefault(),t.cancelBubble=!0),e}},this),s=r.bind(function(n){return t.eventRemove(document.body,i.move,o),t.eventRemove(document.body,i.up,s),this.dragEnd(e)},this);t.event(document.body,i.move,o),t.event(document.body,i.up,s)},checkPositionChange:function(t){var e=t.x-this.config.pos.x,i=t.y-this.config.pos.y;return Math.sqrt(Math.pow(Math.abs(e),2)+Math.pow(Math.abs(i),2))>this.config.sensitivity},initDnDMarker:function(){var t=this.config.marker=document.createElement("div");t.className="gantt_drag_marker",t.innerHTML="Dragging object",document.body.appendChild(t)},backupEventTarget:function(i,n){if(t.config.touch){var r=n(i),a=r.target||r.srcElement,o=a.cloneNode(!0);this.config.original_target=e(r),this.config.original_target.target=o,this.config.backup_element=a,a.parentNode.appendChild(o),a.style.display="none",document.body.appendChild(a)}},getInputMethods:function(){var e=[];if(e.push({move:"mousemove",down:"mousedown",up:"mouseup",accessor:function(t){return t}}),t.config.touch){var i=!0;try{document.createEvent("TouchEvent")}catch(t){i=!1}i?e.push({move:"touchmove",down:"touchstart",up:"touchend",accessor:function(t){return t.touches&&t.touches.length>1?null:t.touches[0]?{target:document.elementFromPoint(t.touches[0].clientX,t.touches[0].clientY),pageX:t.touches[0].pageX,pageY:t.touches[0].pageY,clientX:t.touches[0].clientX,clientY:t.touches[0].clientY}:t}}):window.navigator.pointerEnabled?e.push({move:"pointermove",down:"pointerdown",up:"pointerup",accessor:function(t){return"mouse"==t.pointerType?null:t}}):window.navigator.msPointerEnabled&&e.push({move:"MSPointerMove",down:"MSPointerDown",up:"MSPointerUp",accessor:function(t){return t.pointerType==t.MSPOINTER_TYPE_MOUSE?null:t}})}return e},clearDragTimer:function(){this._drag_start_timer&&(clearTimeout(this._drag_start_timer),this._drag_start_timer=null)},dragStart:function(e,i,n){this.config&&this.config.started||(this.config={obj:e,marker:null,started:!1,pos:this.getPosition(i),sensitivity:4},this._settings&&r.mixin(this.config,this._settings,!0),this.traceDragEvents(e,n),t._prevent_touch_scroll=!0,document.body.className+=" gantt_noselect",t.config.touch&&this.dragMove(e,i,n.accessor))},dragMove:function(e,i,n){var r=n(i);if(!r)return!1;if(!this.config.marker&&!this.config.started){var a=this.getPosition(r);if(t.config.touch||this.checkPositionChange(a)){if(this.config.started=!0,this.config.ignore=!1,!1===this.callEvent("onBeforeDragStart",[e,this.config.original_target]))return this.config.ignore=!0,!1;this.backupEventTarget(i,n),this.initDnDMarker(),t._touch_feedback(),this.callEvent("onAfterDragStart",[e,this.config.original_target])}else this.config.ignore=!0}return!this.config.ignore&&(r.pos=this.getPosition(r),this.config.marker.style.left=r.pos.x+"px",this.config.marker.style.top=r.pos.y+"px",this.callEvent("onDragMove",[e,r]),!0)},dragEnd:function(e){var i=this.config.backup_element;i&&i.parentNode&&i.parentNode.removeChild(i),t._prevent_touch_scroll=!1,this.config.marker&&(this.config.marker.parentNode.removeChild(this.config.marker),this.config.marker=null,this.callEvent("onDragEnd",[])),this.config.started=!1,document.body.className=document.body.className.replace(" gantt_noselect","")},getPosition:function(t){var e=0,i=0;return(t=t||window.event).pageX||t.pageY?(e=t.pageX,i=t.pageY):(t.clientX||t.clientY)&&(e=t.clientX+document.body.scrollLeft+document.documentElement.scrollLeft,i=t.clientY+document.body.scrollTop+document.documentElement.scrollTop),{x:e,y:i}}},i}},function(t,e){t.exports=function(t){var e={init:function(){for(var e=t.locale,i=e.date.month_short,n=e.date.month_short_hash={},r=0;r<i.length;r++)n[i[r]]=r;for(i=e.date.month_full,n=e.date.month_full_hash={},r=0;r<i.length;r++)n[i[r]]=r},date_part:function(t){var e=new Date(t);return t.setHours(0),this.hour_start(t),t.getHours()&&(t.getDate()<e.getDate()||t.getMonth()<e.getMonth()||t.getFullYear()<e.getFullYear())&&t.setTime(t.getTime()+36e5*(24-t.getHours())),t},time_part:function(t){return(t.valueOf()/1e3-60*t.getTimezoneOffset())%86400},week_start:function(e){var i=e.getDay();return t.config.start_on_monday&&(0===i?i=6:i--),this.date_part(this.add(e,-1*i,"day"))},month_start:function(t){return t.setDate(1),this.date_part(t)},quarter_start:function(t){this.month_start(t);var e,i=t.getMonth();return e=i>=9?9:i>=6?6:i>=3?3:0,t.setMonth(e),t},year_start:function(t){return t.setMonth(0),this.month_start(t)},day_start:function(t){return this.date_part(t)},hour_start:function(t){return t.getMinutes()&&t.setMinutes(0),this.minute_start(t),t},minute_start:function(t){return t.getSeconds()&&t.setSeconds(0),t.getMilliseconds()&&t.setMilliseconds(0),t},_add_days:function(t,e){var i=new Date(t.valueOf());return i.setDate(i.getDate()+e),e>=0&&!t.getHours()&&i.getHours()&&(i.getDate()<=t.getDate()||i.getMonth()<t.getMonth()||i.getFullYear()<t.getFullYear())&&i.setTime(i.getTime()+36e5*(24-i.getHours())),i},add:function(t,e,i){var n=new Date(t.valueOf());switch(i){case"day":n=this._add_days(n,e);break;case"week":n=this._add_days(n,7*e);break;case"month":n.setMonth(n.getMonth()+e);break;case"year":n.setYear(n.getFullYear()+e);break;case"hour":n.setTime(n.getTime()+60*e*60*1e3);break;case"minute":n.setTime(n.getTime()+60*e*1e3);break;default:return this["add_"+i](t,e,i)}return n},add_quarter:function(t,e){return this.add(t,3*e,"month")},to_fixed:function(t){return t<10?"0"+t:t},copy:function(t){return new Date(t.valueOf())},date_to_str:function(i,n){i=i.replace(/%[a-zA-Z]/g,function(t){switch(t){case"%d":return'"+to_fixed(date.getDate())+"';case"%m":return'"+to_fixed((date.getMonth()+1))+"';case"%j":return'"+date.getDate()+"';case"%n":return'"+(date.getMonth()+1)+"';case"%y":return'"+to_fixed(date.getFullYear()%100)+"';case"%Y":return'"+date.getFullYear()+"';case"%D":return'"+locale.date.day_short[date.getDay()]+"';case"%l":return'"+locale.date.day_full[date.getDay()]+"';case"%M":return'"+locale.date.month_short[date.getMonth()]+"';case"%F":return'"+locale.date.month_full[date.getMonth()]+"';case"%h":return'"+to_fixed((date.getHours()+11)%12+1)+"';case"%g":return'"+((date.getHours()+11)%12+1)+"';case"%G":return'"+date.getHours()+"';case"%H":return'"+to_fixed(date.getHours())+"';case"%i":return'"+to_fixed(date.getMinutes())+"';case"%a":return'"+(date.getHours()>11?"pm":"am")+"';case"%A":return'"+(date.getHours()>11?"PM":"AM")+"';case"%s":return'"+to_fixed(date.getSeconds())+"';case"%W":return'"+to_fixed(getISOWeek(date))+"';case"%w":return'"+to_fixed(getWeek(date))+"';default:return t}}),n&&(i=i.replace(/date\.get/g,"date.getUTC"));var r=new Function("date","to_fixed","locale","getISOWeek","getWeek",'return "'+i+'";');return function(i){return r(i,e.to_fixed,t.locale,e.getISOWeek,e.getWeek)}},str_to_date:function(e,i){for(var n="var temp=date.match(/[a-zA-Z]+|[0-9]+/g);",r=e.match(/%[a-zA-Z]/g),a=0;a<r.length;a++)switch(r[a]){case"%j":case"%d":n+="set[2]=temp["+a+"]||1;";break;case"%n":case"%m":n+="set[1]=(temp["+a+"]||1)-1;";break;case"%y":n+="set[0]=temp["+a+"]*1+(temp["+a+"]>50?1900:2000);";break;case"%g":case"%G":case"%h":case"%H":n+="set[3]=temp["+a+"]||0;";break;case"%i":n+="set[4]=temp["+a+"]||0;";break;case"%Y":n+="set[0]=temp["+a+"]||0;";break;case"%a":case"%A":n+="set[3]=set[3]%12+((temp["+a+"]||'').toLowerCase()=='am'?0:12);";break;case"%s":n+="set[5]=temp["+a+"]||0;";break;case"%M":n+="set[1]=locale.date.month_short_hash[temp["+a+"]]||0;";break;case"%F":n+="set[1]=locale.date.month_full_hash[temp["+a+"]]||0;"}var o="set[0],set[1],set[2],set[3],set[4],set[5]";i&&(o=" Date.UTC("+o+")");var s=new Function("date","locale","var set=[0,0,1,0,0,0]; "+n+" return new Date("+o+");");return function(e){return s(e,t.locale)}},getISOWeek:function(e){return t.date._getWeekNumber(e,!0)},_getWeekNumber:function(t,e){if(!t)return!1;var i=t.getDay();e&&0===i&&(i=7);var n=new Date(t.valueOf());n.setDate(t.getDate()+(4-i));var r=n.getFullYear(),a=Math.round((n.getTime()-new Date(r,0,1).getTime())/864e5);return 1+Math.floor(a/7)},getWeek:function(e){return t.date._getWeekNumber(e,t.config.start_on_monday)},getUTCISOWeek:function(e){return t.date.getISOWeek(e)},convert_to_utc:function(t){return new Date(t.getUTCFullYear(),t.getUTCMonth(),t.getUTCDate(),t.getUTCHours(),t.getUTCMinutes(),t.getUTCSeconds())},parseDate:function(e,i){return e&&!e.getFullYear&&("function"!=typeof i&&("string"==typeof i?"parse_date"===i?(i=t.templates.parse_date,t.defined(t.templates.xml_date)&&t.templates.parse_date!==t.templates.xml_date&&(i=t.templates.xml_date)):i=t.defined(t.templates[i])?t.templates[i]:t.date.str_to_date(i):i=t.templates.xml_date!==t.templates.parse_date?t.templates.xml_date:t.templates.parse_date),e=e?i(e):null),e}};return e}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=function(t){if("string"==typeof t||"number"==typeof t)return t;var e="";for(var i in t){var n="";t.hasOwnProperty(i)&&(n=i+"="+(n="string"==typeof t[i]?encodeURIComponent(t[i]):"number"==typeof t[i]?t[i]:encodeURIComponent(JSON.stringify(t[i]))),e.length&&(n="&"+n),e+=n)}return e}},function(t,e,i){var n=i(9),r=i(155).default;function a(t,e){var i={method:t};if(0===e.length)throw new Error("Arguments list of query is wrong.");if(1===e.length)return"string"==typeof e[0]?(i.url=e[0],i.async=!0):(i.url=e[0].url,i.async=e[0].async||!0,i.callback=e[0].callback,i.headers=e[0].headers),e[0].data?"string"!=typeof e[0].data?i.data=r(e[0].data):i.data=e[0].data:i.data="",i;switch(i.url=e[0],t){case"GET":case"DELETE":i.callback=e[1],i.headers=e[2];break;case"POST":case"PUT":e[1]?"string"!=typeof e[1]?i.data=r(e[1]):i.data=e[1]:i.data="",i.callback=e[2],i.headers=e[3]}return i}t.exports=function(t){return{cache:!0,method:"get",parse:function(t){return"string"!=typeof t?t:(t=t.replace(/^[\s]+/,""),window.DOMParser&&!n.isIE?e=(new window.DOMParser).parseFromString(t,"text/xml"):window.ActiveXObject!==window.undefined&&((e=new window.ActiveXObject("Microsoft.XMLDOM")).async="false",e.loadXML(t)),e);var e},xmltop:function(e,i,n){if(void 0===i.status||i.status<400){var r=i.responseXML?i.responseXML||i:this.parse(i.responseText||i);if(r&&null!==r.documentElement&&!r.getElementsByTagName("parsererror").length)return r.getElementsByTagName(e)[0]}return-1!==n&&t.callEvent("onLoadXMLError",["Incorrect XML",arguments[1],n]),document.createElement("DIV")},xpath:function(t,e){if(e.nodeName||(e=e.responseXML||e),n.isIE)return e.selectNodes(t)||[];for(var i,r=[],a=(e.ownerDocument||e).evaluate(t,e,null,XPathResult.ANY_TYPE,null);i=a.iterateNext();)r.push(i);return r},query:function(t){return this._call(t.method||"GET",t.url,t.data||"",t.async||!0,t.callback,t.headers)},get:function(t,e,i){var n=a("GET",arguments);return this.query(n)},getSync:function(t,e){var i=a("GET",arguments);return i.async=!1,this.query(i)},put:function(t,e,i,n){var r=a("PUT",arguments);return this.query(r)},del:function(t,e,i){var n=a("DELETE",arguments);return this.query(n)},post:function(t,e,i,n){1==arguments.length?e="":2!=arguments.length||"function"!=typeof e&&"function"!=typeof window[e]||(e,e="");var r=a("POST",arguments);return this.query(r)},postSync:function(t,e,i){e=null===e?"":String(e);var n=a("POST",arguments);return n.async=!1,this.query(n)},_call:function(e,i,r,a,o,s){return new t.Promise(function(l,c){var u=window.XMLHttpRequest&&!n.isIE?new XMLHttpRequest:new window.ActiveXObject("Microsoft.XMLHTTP"),d=null!==navigator.userAgent.match(/AppleWebKit/)&&null!==navigator.userAgent.match(/Qt/)&&null!==navigator.userAgent.match(/Safari/);if(a&&(u.onreadystatechange=function(){if(4==u.readyState||d&&3==u.readyState){if((200!=u.status||""===u.responseText)&&!t.callEvent("onAjaxError",[u]))return;window.setTimeout(function(){"function"==typeof o&&o.apply(window,[{xmlDoc:u,filePath:i}]),l(u),"function"==typeof o&&(o=null,u=null)},0)}}),"GET"!=e||this.cache||(i+=(i.indexOf("?")>=0?"&":"?")+"dhxr"+(new Date).getTime()+"=1"),u.open(e,i,a),s)for(var h in s)u.setRequestHeader(h,s[h]);else"POST"==e.toUpperCase()||"PUT"==e||"DELETE"==e?u.setRequestHeader("Content-Type","application/x-www-form-urlencoded"):"GET"==e&&(r=null);if(u.setRequestHeader("X-Requested-With","XMLHttpRequest"),u.send(r),!a)return{xmlDoc:u,filePath:i}})},urlSeparator:function(t){return-1!=t.indexOf("?")?"&":"?"}}}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),t.exports=function(){return{layout:{css:"gantt_container",rows:[{cols:[{view:"grid",scrollX:"scrollHor",scrollY:"scrollVer"},{resizer:!0,width:1},{view:"timeline",scrollX:"scrollHor",scrollY:"scrollVer"},{view:"scrollbar",id:"scrollVer"}]},{view:"scrollbar",id:"scrollHor",height:20}]},links:{finish_to_start:"0",start_to_start:"1",finish_to_finish:"2",start_to_finish:"3"},types:{task:"task",project:"project",milestone:"milestone"},auto_types:!1,duration_unit:"day",work_time:!1,correct_work_time:!1,skip_off_time:!1,cascade_delete:!0,autosize:!1,autosize_min_width:0,autoscroll:!0,autoscroll_speed:30,show_links:!0,show_task_cells:!0,static_background:!1,static_background_cells:!0,branch_loading:!1,branch_loading_property:"$has_child",show_loading:!1,show_chart:!0,show_grid:!0,min_duration:36e5,date_format:"%d-%m-%Y %H:%i",xml_date:void 0,start_on_monday:!0,server_utc:!1,show_progress:!0,fit_tasks:!1,select_task:!0,scroll_on_click:!0,smart_rendering:!0,preserve_scroll:!0,readonly:!1,date_grid:"%Y-%m-%d",drag_links:!0,drag_progress:!0,drag_resize:!0,drag_project:!1,drag_move:!0,drag_mode:{resize:"resize",progress:"progress",move:"move",ignore:"ignore"},round_dnd_dates:!0,link_wrapper_width:20,root_id:0,autofit:!1,columns:[{name:"text",tree:!0,width:"*",resize:!0},{name:"start_date",align:"center",resize:!0},{name:"duration",align:"center"},{name:"add",width:44}],scale_offset_minimal:!0,inherit_scale_class:!1,scales:[{unit:"day",step:1,date:"%d %M"}],time_step:60,duration_step:1,task_date:"%d %F %Y",time_picker:"%H:%i",task_attribute:"task_id",link_attribute:"link_id",layer_attribute:"data-layer",buttons_left:["gantt_save_btn","gantt_cancel_btn"],_migrate_buttons:{dhx_save_btn:"gantt_save_btn",dhx_cancel_btn:"gantt_cancel_btn",dhx_delete_btn:"gantt_delete_btn"},buttons_right:["gantt_delete_btn"],lightbox:{sections:[{name:"description",height:70,map_to:"text",type:"textarea",focus:!0},{name:"time",type:"duration",map_to:"auto"}],project_sections:[{name:"description",height:70,map_to:"text",type:"textarea",focus:!0},{name:"type",type:"typeselect",map_to:"type"},{name:"time",type:"duration",readonly:!0,map_to:"auto"}],milestone_sections:[{name:"description",height:70,map_to:"text",type:"textarea",focus:!0},{name:"type",type:"typeselect",map_to:"type"},{name:"time",type:"duration",single_date:!0,map_to:"auto"}]},drag_lightbox:!0,sort:!1,details_on_create:!0,details_on_dblclick:!0,initial_scroll:!0,task_scroll_offset:100,order_branch:!1,order_branch_free:!1,task_height:"full",min_column_width:70,min_grid_column_width:70,grid_resizer_column_attribute:"column_index",grid_resizer_attribute:"grid_resizer",keep_grid_width:!1,grid_resize:!1,show_tasks_outside_timescale:!1,show_unscheduled:!0,readonly_property:"readonly",editable_property:"editable",calendar_property:"calendar_id",resource_calendars:{},inherit_calendar:!1,type_renderers:{},open_tree_initially:!1,optimize_render:!0,prevent_default_scroll:!1,show_errors:!0,wai_aria_attributes:!0,smart_scales:!0,rtl:!1,placeholder_task:!1,horizontal_scroll_key:"shiftKey",drag_timeline:{useKey:void 0,ignore:".gantt_task_line, .gantt_task_link"},drag_multiple:!0}}},function(t,e){t.exports=function(){var t={};return{services:{config:"config",templates:"templates",locale:"locale"},setService:function(e,i){t[e]=i},getService:function(e){return t[e]?t[e]():null},dropService:function(e){t[e]&&delete t[e]},config:function(){return this.getService("config")},templates:function(){return this.getService("templates")},locale:function(){return this.getService("locale")},destructor:function(){for(var e in t)if(t[e]){var i=t[e];i&&i.destructor&&i.destructor()}t=null}}}},function(t,e){t.exports=function(t){t.$inject=function(t){return t(this.$services)}}},function(t,e){t.exports={KEY_CODES:{UP:38,DOWN:40,LEFT:37,RIGHT:39,SPACE:32,ENTER:13,DELETE:46,ESC:27,TAB:9}}},function(t,e,i){i(18),t.exports=function(){var t=new function(){this.constants=i(160),this.version="6.3.7",this.license="gpl",this.templates={},this.ext={},this.keys={edit_save:this.constants.KEY_CODES.ENTER,edit_cancel:this.constants.KEY_CODES.ESC}};i(159)(t),t.$services=t.$inject(i(158)),t.config=t.$inject(i(157)),t.ajax=i(156)(t),t.date=i(154)(t);var e=i(153)(t);t.$services.setService("dnd",function(){return e}),t.$services.setService("config",function(){return t.config}),t.$services.setService("date",function(){return t.date}),t.$services.setService("locale",function(){return t.locale}),t.$services.setService("templates",function(){return t.templates});var n=i(152)(t);t.$services.setService("templateLoader",function(){return n}),i(4)(t);var r=new(i(151));r.registerProvider("global",function(){var e={min_date:t._min_date,max_date:t._max_date,selected_task:null};return t.$data&&t.$data.tasksStore&&(e.selected_task=t.$data.tasksStore.getSelectedId()),e}),t.getState=r.getState,t.$services.setService("state",function(){return r});var a=i(0);a.mixin(t,a),t.Promise=i(150),t.env=i(9);var o=i(1);t.utils={dom:{getNodePosition:o.getNodePosition,getRelativeEventPosition:o.getRelativeEventPosition,isChildOf:o.isChildOf,hasClass:o.hasClass,closest:o.closest}};var s=i(19)();t.event=s.attach,t.eventRemove=s.detach,t._eventRemoveAll=s.detachAll,t._createDomEventScope=s.extend,a.mixin(t,i(146)(t));var l=i(145).init(t);t.$ui=l.factory,t.$ui.layers=l.render,t.$mouseEvents=l.mouseEvents,t.$services.setService("mouseEvents",function(){return t.$mouseEvents}),t.mixin(t,l.layersApi),i(104)(t),t.$services.setService("layers",function(){return l.layersService});var c=i(103);t.mixin(t,c()),i(102)(t);var u=i(95);return t.dataProcessor=u.DEPRECATED_api,t.createDataProcessor=u.createDataProcessor,i(90)(t),i(78)(t),i(77)(t),i(76)(t),i(75)(t),i(74)(t),i(73)(t),i(64)(t),i(63).default(t),i(62)(t),i(53)(t),i(52)(t),i(51)(t),i(50)(t),i(49)(t),i(48)(t),i(47)(t),i(46)(t),i(45)(t),i(44)(t),i(43)(t),i(42)(t),i(41)(t),i(40)(t),i(38)(t),i(37).default(t),t}},function(t,e){t.exports=function(t){}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(162),r=i(161),a=window.gantt=r();e.gantt=a,n(a),e.default=a}])});
//# sourceMappingURL=dhtmlxgantt.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(855)))

/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1925);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(65)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js!./dhtmlxgantt.css", function() {
			var newContent = require("!!../../css-loader/index.js!./dhtmlxgantt.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(64)(false);
// imports


// module
exports.push([module.i, ".gridHoverStyle,.gridSelection,.timelineSelection{background-color:#fff3a1}.gantt_grid_scale .gantt_grid_head_cell{color:#a6a6a6;border-top:none!important;border-right:none!important}.gantt_grid_data .gantt_cell{border-right:none;color:#454545}.gantt_task_link .gantt_link_arrow_right{border-width:6px;margin-top:-3px}.gantt_task_link .gantt_link_arrow_left{border-width:6px;margin-left:-6px;margin-top:-3px}.gantt_task_link .gantt_link_arrow_down,.gantt_task_link .gantt_link_arrow_up{border-width:6px}.gantt_task_line .gantt_task_progress_drag{bottom:-4px;height:10px;margin-left:-8px;width:16px}.chartHeaderBg{background-color:#fff}.gantt_task .gantt_task_scale .gantt_scale_cell{color:#a6a6a6;border-right:1px solid #ebebeb}.gantt_row.gantt_project,.gantt_row.odd.gantt_project{background-color:#edffef}.gantt_task_row.gantt_project,.gantt_task_row.odd.gantt_project{background-color:#f5fff6}.gantt_task_line.gantt_project{background-color:#65c16f;border:1px solid #3c9445}.gantt_task_line.gantt_project .gantt_task_progress{background-color:#46ad51}.buttonBg{background:#fff}.gantt_cal_light .gantt_btn_set{margin:5px 10px}.gantt_btn_set.gantt_cancel_btn_set{background:#fff;color:#454545;border:1px solid #cecece}.gantt_btn_set.gantt_save_btn_set{background:#3db9d3;text-shadow:0 -1px 0 #248a9f;color:#fff}.gantt_btn_set.gantt_delete_btn_set{text-shadow:0 -1px 0 #6f6f6f;background:#ec8e00;text-shadow:0 -1px 0 #a60;color:#fff}.gantt_cal_light_wide{padding-left:0!important;padding-right:0!important}.gantt_cal_light_wide .gantt_cal_larea{border-left:none!important;border-right:none!important}.gantt_popup_button.gantt_ok_button{background:#3db9d3;text-shadow:0 -1px 0 #248a9f;color:#fff;font-weight:700;border-width:0}.gantt_popup_button.gantt_cancel_button{font-weight:700;color:#454544}.gantt_popup_title{background-color:#fff}.gantt_popup_shadow{box-shadow:3px 3px 3px rgba(0,0,0,.07)}.gantt_qi_big_icon.icon_edit{color:#454545;background:#fff}.gantt_qi_big_icon.icon_delete{text-shadow:0 -1px 0 #a60;background:#ec8e00;color:#fff;border-width:0}.gantt_tooltip{box-shadow:3px 3px 3px rgba(0,0,0,.07);border-left:1px solid rgba(0,0,0,.07);border-top:1px solid rgba(0,0,0,.07);font-size:8pt;color:#454545}.gantt_container,.gantt_tooltip{background-color:#fff;font-family:Arial}.gantt_container{font-size:13px;border:1px solid #cecece;position:relative;white-space:nowrap;overflow-x:hidden;overflow-y:hidden}.gantt_task_scroll{overflow-x:scroll}.gantt_grid,.gantt_task{position:relative;overflow-x:hidden;overflow-y:hidden;display:inline-block;vertical-align:top}.gantt_grid_scale,.gantt_task_scale{color:#6b6b6b;font-size:12px;border-bottom:1px solid #cecece;box-sizing:border-box}.gantt_grid_scale,.gantt_task_scale,.gantt_task_vscroll{background-color:#fff}.gantt_scale_line{box-sizing:border-box;-moz-box-sizing:border-box;border-top:1px solid #cecece}.gantt_scale_line:first-child{border-top:none}.gantt_grid_head_cell{display:inline-block;vertical-align:top;border-right:1px solid #cecece;text-align:center;position:relative;cursor:default;height:100%;box-sizing:border-box;-moz-box-sizing:border-box;line-height:33px;-moz-user-select:-moz-none;-webkit-user-select:none;user-select:none;overflow:hidden}.gantt_scale_line{clear:both}.gantt_grid_data{width:100%;overflow:hidden;position:relative}.gantt_row{position:relative;-webkit-user-select:none;-moz-user-select:none;-moz-user-select:-moz-none}.gantt_add,.gantt_grid_head_add{width:100%;height:100%;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTQ3MjMyMENDNkI0MTFFMjk4MTI5QTg3MDhFNDVDQTkiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTQ3MjMyMERDNkI0MTFFMjk4MTI5QTg3MDhFNDVDQTkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo1NDcyMzIwQUM2QjQxMUUyOTgxMjlBODcwOEU0NUNBOSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo1NDcyMzIwQkM2QjQxMUUyOTgxMjlBODcwOEU0NUNBOSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PshZT8UAAABbSURBVHjaYrTdeZmBEsCER+4wEP+H4sPkGGCDg020ARR7gb4GIAcYDKMDdPnDyAbYkGG5DVW9cIQMvUdBBAuUY4vDz8iAcZinA2zgCHqAYQMseAywJcYFAAEGAM+UFGuohFczAAAAAElFTkSuQmCC);background-position:50%;background-repeat:no-repeat;cursor:pointer;position:relative;-moz-opacity:.3;opacity:.3}.gantt_grid_head_cell.gantt_grid_head_add{-moz-opacity:.6;opacity:.6;top:0}.gantt_grid_head_cell.gantt_grid_head_add:hover{-moz-opacity:1;opacity:1}.gantt_grid_data .gantt_row.odd:hover,.gantt_grid_data .gantt_row:hover{background-color:#fff3a1}.gantt_grid_data .gantt_row.odd:hover .gantt_add,.gantt_grid_data .gantt_row:hover .gantt_add{-moz-opacity:1;opacity:1}.gantt_row,.gantt_task_row{border-bottom:1px solid #ebebeb;background-color:#fff}.gantt_row.odd,.gantt_task_row.odd{background-color:#fff}.gantt_cell,.gantt_grid_head_cell,.gantt_row,.gantt_scale_cell,.gantt_task_cell,.gantt_task_row{box-sizing:border-box;-moz-box-sizing:border-box}.gantt_grid_head_cell,.gantt_scale_cell{line-height:inherit}.gantt_grid_scale .gantt_grid_column_resize_wrap{cursor:col-resize;position:absolute;width:13px;margin-left:-7px}.gantt_grid_column_resize_wrap .gantt_grid_column_resize{background-color:#cecece;height:100%;width:1px;margin:0 auto}.gantt_drag_marker.gantt_grid_resize_area{background-color:hsla(0,0%,91%,.5);border-left:1px solid #cecece;border-right:1px solid #cecece;height:100%;width:100%;box-sizing:border-box}.gantt_cell{display:inline-block;vertical-align:top;border-right:1px solid #ebebeb;padding-left:6px;padding-right:6px;height:100%;overflow:hidden;white-space:nowrap;font-size:13px}.gantt_grid_data .gantt_last_cell,.gantt_grid_scale .gantt_last_cell,.gantt_task .gantt_task_scale .gantt_scale_cell.gantt_last_cell,.gantt_task_bg .gantt_last_cell{border-right-width:0}.gantt_task .gantt_task_scale .gantt_scale_cell.gantt_last_cell{border-right-width:1px}.gantt_task_bg{overflow:hidden}.gantt_scale_cell{display:inline-block;white-space:nowrap;overflow:hidden;border-right:1px solid #cecece;text-align:center;height:100%}.gantt_task_cell{display:inline-block;height:100%;border-right:1px solid #ebebeb}.gantt_layout_cell.gantt_ver_scroll{width:0;background-color:transparent;height:1px;overflow-x:hidden;overflow-y:scroll;position:absolute;right:0;z-index:1}.gantt_ver_scroll>div{width:1px;height:1px}.gantt_hor_scroll{height:0;background-color:transparent;width:100%;clear:both;overflow-x:scroll;overflow-y:hidden}.gantt_layout_cell .gantt_hor_scroll{position:absolute}.gantt_hor_scroll>div{width:5000px;height:1px}.gantt_tree_indent{width:15px;height:100%;display:inline-block}.gantt_tree_content,.gantt_tree_icon{vertical-align:top}.gantt_tree_icon{width:28px;background-repeat:no-repeat;background-position:50%}.gantt_tree_content,.gantt_tree_icon{height:100%;display:inline-block}.gantt_tree_icon.gantt_open{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAArklEQVQ4T2NkoBJgpJI5DEPAoFOnTv0/c+YMQR+bmJgwmJmZwX2E4bVp06b9j4yMZODg4MBp2I8fPxiWL1/OkJWVNUAGcXJyMnz//h3uQrJdRLFBIAPQAchlJLsIFuCMjIwM////B5sJMoRkg2CuIdtrQcHBDOxsbHBfCQgIMHz48AHO//nrF8O6tWsJR7+7uzsDIxMTznT0/98/hp07d+I3iGopm2DewKFg8OV+AJWkfRMrTobLAAAAAElFTkSuQmCC);width:18px;cursor:pointer}.gantt_tree_icon.gantt_close{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAkUlEQVQ4T2NkoBJgpJI5DEPAoFOnTv0/c+YMQR+bmJgwmJmZwX2E4bVp06b9j4yMZODg4MBp2I8fPxiWL1/OkJWVNeIN4uTkxAin79+/M5AcRtgCHGQIyQbhijaiDQoKDmZgZ2PDGf0/f/1iWLd2LeHod3d3Z2BkYsJp0P9//xh27tyJ3yCqpWyCeQOHgsGX+wEZpW4T5LCxKwAAAABJRU5ErkJggg==);width:18px;cursor:pointer}.gantt_tree_icon.gantt_blank{width:18px}.gantt_tree_icon.gantt_folder_open{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAs0lEQVQ4T62T0Q2EIBBEpQlzuaaMsQoqooqLsSljbMLLmMxmUXBR4U+Qt7Mzi2sqLVeJ00SgEMKWAnvvzYLyAyHfT5sU2fXDJSwCAXK8MI0/UTkva7IIFJsg3NSwnKdFoKtAWOQ1CN7CEqeTotE5L7QyJhmBcklZM4ZgTiAr3iOU3kD93ppO5SkMjB1EeXdBWoSkRql3YeIRe+cGvktS056JR9wsmeBUkujCfNXWCPC8GugPqn5ii/hV+FoAAAAASUVORK5CYII=)}.gantt_tree_icon.gantt_folder_closed{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAfElEQVQ4T2NkoBJgpJI5DCgGTZ8+/T82gzMzMwlaCFcAM0RKQgyrI/0Dg/EahmIQyBB0DRvXr4W78tmLV1gtAbmYoEEgnciG4QpTogzCFyEwSyg2CBS2oCAZNQh3cA+hMAJ5AlcKxuVBlOgnNgVjMwyUrQjmamKLGaoZBAAOTFyLnFFW4wAAAABJRU5ErkJggg==)}.gantt_tree_icon.gantt_file{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAeElEQVQ4T2NkoBJgRDZn+vTp/wmZm5mZiaIHph7DICkJMUJmMfgHBmMYhtUgbAo3rl+L4lp0NUQbBPI2umuRDaPIIFAYwAyjv0HoMQALM5JdhG4QLMxGDcKdyIdoGIE89OzFK4KZF5Rl8EY/QROQFGA1iBQD0NUCAJVjcxO0naAQAAAAAElFTkSuQmCC)}.gantt_grid_head_cell .gantt_sort{position:absolute;right:5px;top:8px;width:7px;height:13px;background-repeat:no-repeat;background-position:50%}.gantt_grid_head_cell .gantt_sort.gantt_asc{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAANCAYAAABlyXS1AAAARUlEQVR4nGNgQAKGxib/GbABkIS7b8B/DAUwCRiGK0CXwFBAb1DfP/U/LszwHwi2X7qFgUEArBtdAVwCBmAKMCSQFSDzAWXXaOHsXeqkAAAAAElFTkSuQmCC)}.gantt_grid_head_cell .gantt_sort.gantt_desc{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAANCAYAAABlyXS1AAAARUlEQVR42mNgQAL1/VP/M2ADIIntF2/9x1AAlrh0C47hCmA60DFYwX88gIFGwNDY5D8uDFbg7hvwHx2jmIBTAlkB0e4BAEjlaNtBWJPnAAAAAElFTkSuQmCC)}.gantt_inserted,.gantt_updated{font-weight:700}.gantt_deleted{text-decoration:line-through}.gantt_invalid{background-color:#ffe0e0}.gantt_error{color:red}.gantt_status{right:1px;padding:5px 10px;background:hsla(0,0%,61%,.1);position:absolute;top:1px;transition:opacity .2s;opacity:0}.gantt_status.gantt_status_visible{opacity:1}#gantt_ajax_dots span{transition:opacity .2s;background-repeat:no-repeat;opacity:0}#gantt_ajax_dots span.gantt_dot_visible{opacity:1}.gantt_message_area{position:fixed;right:5px;width:250px;z-index:1000}.gantt-info{min-width:120px;padding:4px 4px 4px 20px;font-family:Arial;z-index:10000;margin:5px;margin-bottom:10px;transition:all .5s ease}.gantt-info.hidden{height:0;padding:0;border-width:0;margin:0;overflow:hidden}.gantt_modal_box{overflow:hidden;display:inline-block;min-width:250px;width:250px;text-align:center;position:fixed;z-index:20000;box-shadow:3px 3px 3px rgba(0,0,0,.07);font-family:Arial;border-radius:6px;border:1px solid #cecece;background:#fff}.gantt_popup_title{border-top-left-radius:6px;border-top-right-radius:6px;border-width:0}.gantt_button,.gantt_popup_button{border:1px solid #cecece;height:30px;line-height:30px;display:inline-block;margin:0 5px;border-radius:4px;background:#fff}.gantt-info,.gantt_button,.gantt_popup_button{user-select:none;-webkit-user-select:none;-moz-user-select:-moz-none;cursor:pointer}.gantt_popup_text{overflow:hidden}.gantt_popup_controls{border-radius:6px;padding:10px}.gantt_popup_button{min-width:100px}div.dhx_modal_cover{background-color:#000;cursor:default;filter:progid:DXImageTransform.Microsoft.Alpha(opacity=20);opacity:.2;position:fixed;z-index:19999;left:0;top:0;width:100%;height:100%;border:none;zoom:1}.gantt-info img,.gantt_modal_box img{float:left;margin-right:20px}.gantt-alert-error,.gantt-confirm-error{border:1px solid red}.gantt_button input,.gantt_popup_button div{border-radius:4px;font-size:14px;box-sizing:content-box;padding:0;margin:0;vertical-align:top}.gantt_popup_title{border-bottom:1px solid #cecece;height:40px;line-height:40px;font-size:20px}.gantt_popup_text{margin:15px 15px 5px;font-size:14px;color:#000;min-height:30px;border-radius:6px}.gantt-error,.gantt-info{font-size:14px;color:#000;box-shadow:3px 3px 3px rgba(0,0,0,.07);padding:0;background-color:#fff;border-radius:3px;border:1px solid #fff}.gantt-info div{padding:5px 10px;background-color:#fff;border-radius:3px;border:1px solid #cecece}.gantt-error{background-color:#d81b1b;border:1px solid #ff3c3c}.gantt-error div{background-color:#d81b1b;border:1px solid #940000;color:#fff}.gantt-warning{background-color:#ff9000;border:1px solid #ffa633}.gantt-warning div{background-color:#ff9000;border:1px solid #b36500;color:#fff}.gantt_data_area div,.gantt_grid div{-ms-touch-action:none;-webkit-tap-highlight-color:rgba(0,0,0,0)}.gantt_data_area{position:relative;overflow-x:hidden;overflow-y:hidden;-moz-user-select:-moz-none;-webkit-user-select:none;user-select:none}.gantt_links_area{position:absolute;left:0;top:0}.gantt_side_content,.gantt_task_content,.gantt_task_progress{line-height:inherit;overflow:hidden;height:100%}.gantt_task_content{font-size:12px;color:#fff;width:100%;top:0;cursor:pointer;position:absolute;white-space:nowrap;text-align:center}.gantt_task_progress{text-align:center;z-index:0;background:#299cb4}.gantt_task_progress_wrapper{border-radius:inherit;position:relative;width:100%;height:100%;overflow:hidden}.gantt_task_line{border-radius:2px;position:absolute;box-sizing:border-box;background-color:#3db9d3;border:1px solid #2898b0;-webkit-user-select:none;-moz-user-select:none;-moz-user-select:-moz-none}.gantt_task_line.gantt_drag_move div{cursor:move}.gantt_touch_move,.gantt_touch_progress .gantt_touch_resize{transform:scale(1.02,1.1);transform-origin:50%}.gantt_touch_progress .gantt_task_progress_drag,.gantt_touch_resize .gantt_task_drag{transform:scaleY(1.3);transform-origin:50%}.gantt_side_content{position:absolute;white-space:nowrap;color:#6e6e6e;top:0;font-size:11px}.gantt_side_content.gantt_left{right:100%;padding-right:20px}.gantt_side_content.gantt_right{left:100%;padding-left:20px}.gantt_side_content.gantt_link_crossing{bottom:8.75px;top:auto}.gantt_link_arrow,.gantt_task_link .gantt_line_wrapper{position:absolute;cursor:pointer}.gantt_line_wrapper div{background-color:#ffa011}.gantt_task_link:hover .gantt_line_wrapper div{box-shadow:0 0 5px 0 #ffa011}.gantt_task_link div.gantt_link_arrow{background-color:transparent;border-style:solid;width:0;height:0}.gantt_link_control{position:absolute;width:20px;top:0}.gantt_link_control div{display:none;cursor:pointer;box-sizing:border-box;position:relative;top:50%;margin-top:-7.5px;vertical-align:middle;border:1px solid #929292;border-radius:6.5px;height:13px;width:13px;background-color:#f0f0f0}.gantt_link_control.task_right div.gantt_link_point{margin-left:7px}.gantt_link_control div:hover{background-color:#fff}.gantt_link_control.task_left{left:-20px}.gantt_link_control.task_right{right:-20px}.gantt_link_target .gantt_link_control div,.gantt_task_line.gantt_drag_move .gantt_link_control div,.gantt_task_line.gantt_drag_move .gantt_task_drag,.gantt_task_line.gantt_drag_move .gantt_task_progress_drag,.gantt_task_line.gantt_drag_progress .gantt_link_control div,.gantt_task_line.gantt_drag_progress .gantt_task_drag,.gantt_task_line.gantt_drag_progress .gantt_task_progress_drag,.gantt_task_line.gantt_drag_resize .gantt_link_control div,.gantt_task_line.gantt_drag_resize .gantt_task_drag,.gantt_task_line.gantt_drag_resize .gantt_task_progress_drag,.gantt_task_line.gantt_selected .gantt_link_control div,.gantt_task_line.gantt_selected .gantt_task_drag,.gantt_task_line.gantt_selected .gantt_task_progress_drag,.gantt_task_line:hover .gantt_link_control div,.gantt_task_line:hover .gantt_task_drag,.gantt_task_line:hover .gantt_task_progress_drag{display:block}.gantt_link_source,.gantt_link_target{box-shadow:0 0 3px #3db9d3}.gantt_link_target.link_finish_allow,.gantt_link_target.link_start_allow{box-shadow:0 0 3px #ffbf5e}.gantt_link_target.link_finish_deny,.gantt_link_target.link_start_deny{box-shadow:0 0 3px #e87e7b}.link_finish_allow .gantt_link_control.task_end_date div,.link_start_allow .gantt_link_control.task_start_date div{background-color:#ffbf5e;border-color:#ffa011}.link_finish_deny .gantt_link_control.task_end_date div,.link_start_deny .gantt_link_control.task_start_date div{background-color:#e87e7b;border-color:#dd3e3a}.gantt_link_arrow_right{border-width:4px 0 4px 6px;border-top-color:transparent!important;border-right-color:transparent!important;border-bottom-color:transparent!important;border-left-color:#ffa011;margin-top:-1px}.gantt_link_arrow_left{border-width:4px 6px 4px 0;margin-top:-1px;border-top-color:transparent!important;border-right-color:#ffa011;border-bottom-color:transparent!important;border-left-color:transparent!important}.gantt_link_arrow_up{border-width:0 4px 6px;border-color:transparent transparent #ffa011;border-top-color:transparent!important;border-right-color:transparent!important;border-bottom-color:#ffa011;border-left-color:transparent!important}.gantt_link_arrow_down{border-width:4px 6px 0 4px;border-top-color:#ffa011;border-right-color:transparent!important;border-bottom-color:transparent!important;border-left-color:transparent!important}.gantt_task_drag,.gantt_task_progress_drag{cursor:ew-resize;display:none;position:absolute}.gantt_task_drag.task_right{cursor:e-resize}.gantt_task_drag.task_left{cursor:w-resize}.gantt_task_drag{height:100%;width:8px;z-index:1;top:-1px}.gantt_task_drag.task_left{left:-7px}.gantt_task_drag.task_right{right:-7px}.gantt_task_progress_drag{height:8px;width:8px;bottom:-4px;margin-left:-4px;background-position:bottom;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAYAAAB24g05AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MkY3Rjk0RUVDMkYzMTFFMkI1OThEQTA3ODU0OTkzMEEiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MkY3Rjk0RUZDMkYzMTFFMkI1OThEQTA3ODU0OTkzMEEiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoyRjdGOTRFQ0MyRjMxMUUyQjU5OERBMDc4NTQ5OTMwQSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoyRjdGOTRFREMyRjMxMUUyQjU5OERBMDc4NTQ5OTMwQSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PobPBzIAAADkSURBVHjaYpk2bRoDDsAExL1QdjEQ/8OmiAWHZk4gXqymqhQM4ty6fU8OSMUA8XdiDBAB4k0a6iqWRga6EKcwMQXduHlnL5DpB8Rv0J2JDFSA+JiOtgZcMwiA2CAxkBxUDVYDLEAKgIpV9XQ0MZwFEgPJAZnHoWpRDAgC4n2W5saiQKfjClQGkBxQDciL+6B6wAbkA/EqJwdrTkUFOQZCAKQGpBbIXA3SCzJggo+XK7OEuBgDsQCkFqgHrBfsBT5eHgZSAUwP2IBfv36TbABMDygdtK1Zv6UESLORaAbIhG6AAAMAKN8wE24DXWcAAAAASUVORK5CYII=);background-repeat:no-repeat;z-index:1}.gantt_task_progress_drag:hover{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAYAAAB24g05AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAs0lEQVQoz6WMPW7CQBgFJxZaiZ60qcgdwjVMmzu8gpwhDULabXyBdHAGuzRHivQiQZovigS2+Jtu95t5T03TMITtCtjEc5VSOgx5k5F4CnxJWgKUUl5sv6eUvk/daiCeAe1fDCCpBtq4jQ/YngO9pMWpGH99OOcDtt8ifmWEuO3D/R+wXQOdpGcuIGkGdNFQ2RawlTTlSsLd2RY55+O95JyPFQ/y8MAE+CylfADpxvYHWP8CXj+JR4wdKHYAAAAASUVORK5CYII=)}.gantt_link_tooltip{box-shadow:3px 3px 3px #888;background-color:#fff;border-left:1px dotted #cecece;border-top:1px dotted #cecece;font-family:Tahoma;font-size:8pt;color:#444;padding:6px;line-height:20px}.gantt_link_direction{height:0;border:0 none #ffa011;border-bottom-style:dashed;border-bottom-width:2px;transform-origin:0 0;-ms-transform-origin:0 0;-webkit-transform-origin:0 0;z-index:2;margin-left:1px;position:absolute}.gantt_grid_data .gantt_row.gantt_selected,.gantt_grid_data .gantt_row.odd.gantt_selected,.gantt_task_row.gantt_selected{background-color:#fff3a1}.gantt_task_row.gantt_selected .gantt_task_cell{border-right-color:#ffec6e}.gantt_task_line.gantt_selected{box-shadow:0 0 5px #299cb4}.gantt_task_line.gantt_project.gantt_selected{box-shadow:0 0 5px #46ad51}.gantt_task_line.gantt_milestone{visibility:hidden;background-color:#d33daf;border:0 solid #61164f;box-sizing:content-box;-moz-box-sizing:content-box}.gantt_task_line.gantt_milestone div{visibility:visible}.gantt_task_line.gantt_milestone .gantt_task_content{background:inherit;border:inherit;border-width:1px;border-radius:inherit;box-sizing:border-box;-moz-box-sizing:border-box;transform:rotate(45deg)}.gantt_task_line.gantt_task_inline_color{border-color:#999}.gantt_task_line.gantt_task_inline_color .gantt_task_progress{background-color:#363636;opacity:.2}.gantt_task_line.gantt_task_inline_color.gantt_project.gantt_selected,.gantt_task_line.gantt_task_inline_color.gantt_selected{box-shadow:0 0 5px #999}.gantt_task_link.gantt_link_inline_color:hover .gantt_line_wrapper div{box-shadow:0 0 5px 0 #999}.gantt_critical_task{background-color:#e63030;border-color:#9d3a3a}.gantt_critical_task .gantt_task_progress{background-color:rgba(0,0,0,.4)}.gantt_critical_link .gantt_line_wrapper>div{background-color:#e63030}.gantt_critical_link .gantt_link_arrow{border-color:#e63030}.gantt_btn_set:focus,.gantt_cell:focus,.gantt_grid_head_cell:focus,.gantt_popup_button:focus,.gantt_qi_big_icon:focus,.gantt_row:focus{box-shadow:inset 0 0 1px 1px #4d90fe}.gantt_split_parent{opacity:.1;pointer-events:none}.gantt_unselectable,.gantt_unselectable div{-webkit-user-select:none;-moz-user-select:none;-moz-user-select:-moz-none}.gantt_cal_light{-webkit-tap-highlight-color:transparent;background:#fff;border-radius:6px;font-family:Arial;font-size:13px;border:1px solid #cecece;color:#6b6b6b;font-size:12px;position:absolute;z-index:10001;width:550px;height:250px;box-shadow:3px 3px 3px rgba(0,0,0,.07)}.gantt_cal_light_wide{width:650px}.gantt_cal_light select{font-family:Arial;border:1px solid #cecece;font-size:13px;padding:2px;margin:0}.gantt_cal_ltitle{padding:7px 10px;overflow:hidden;-webkit-border-top-left-radius:6px;-webkit-border-bottom-left-radius:0;-webkit-border-top-right-radius:6px;-webkit-border-bottom-right-radius:0;-moz-border-radius-topleft:6px;-moz-border-radius-bottomleft:0;-moz-border-radius-topright:6px;-moz-border-radius-bottomright:0;border-top-left-radius:6px;border-bottom-left-radius:0;border-top-right-radius:6px;border-bottom-right-radius:0}.gantt_cal_ltitle,.gantt_cal_ltitle span{white-space:nowrap}.gantt_cal_lsection{color:#727272;font-weight:700;padding:12px 0 5px 10px}.gantt_cal_lsection .gantt_fullday{float:right;margin-right:5px;font-size:12px;font-weight:400;line-height:20px;vertical-align:top;cursor:pointer}.gantt_cal_lsection{font-size:13px}.gantt_cal_ltext{padding:2px 10px;overflow:hidden}.gantt_cal_ltext textarea{overflow-y:auto;overflow-x:hidden;font-family:Arial;font-size:13px;box-sizing:border-box;border:1px solid #cecece;height:100%;width:100%;outline:none!important;resize:none}.gantt_section_constraint [data-constraint-time-select]{margin-left:20px}.gantt_time{font-weight:700}.gantt_cal_light .gantt_title{padding-left:10px}.gantt_cal_larea{border:1px solid #cecece;border-left:none;border-right:none;background-color:#fff;overflow:hidden;height:1px}.gantt_btn_set{margin:10px 7px 5px 10px;padding:5px 15px 5px 10px;float:left;border-radius:4px;border:0 solid #cecece;height:32px;font-weight:700;background:#fff;box-sizing:border-box;cursor:pointer}.gantt_hidden{display:none}.gantt_btn_set div{float:left;font-size:13px;height:22px;line-height:22px;background-repeat:no-repeat;vertical-align:middle}.gantt_save_btn{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MTk1OUU5RDFDMzA0MTFFMkExMUZBQTdDNDAzOUE5RjMiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MTk1OUU5RDJDMzA0MTFFMkExMUZBQTdDNDAzOUE5RjMiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoxOTU5RTlDRkMzMDQxMUUyQTExRkFBN0M0MDM5QTlGMyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoxOTU5RTlEMEMzMDQxMUUyQTExRkFBN0M0MDM5QTlGMyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PjDroXYAAAEXSURBVHjaYvz//z8DJYCRUgPIAUxAbAnEHiAHMIBcQCwGaRYXF3e6evXqoffv39/dv38/CymaGSUkJBzv3LlzCsj///fv3wdAihkkIQnEvkAshU8zLy+v7a1bt06ANP/79+87kDIAy505cybq06dPr3p7ezuwGQLTfOPGjWP/ESAZLg8kPKBO+g01RBJNszWyZqC6uSgWgIg/f/4shxnS2dnZBjMEqNkSFGBImi8CKTYMA4BYCGjIczRDHC5dunQQSfN7IKWI4UUkjjdMMdCwnw8ePLjwHxV4Yw1gZA5Q47z/2EELzhhCE+ABGvIQWSeQvwcU38QaAML2wHj+C/X3MyAlijeB4ZBoBOIPQGxJKIVSnBsBAgwABddBclWfcZUAAAAASUVORK5CYII=);margin-top:2px;width:21px}.gantt_cancel_btn{margin-top:2px;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MDkzMDA3MzlDMzA0MTFFMjg2QTVFMzFEQzgwRkJERDYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MDkzMDA3M0FDMzA0MTFFMjg2QTVFMzFEQzgwRkJERDYiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDowOTMwMDczN0MzMDQxMUUyODZBNUUzMURDODBGQkRENiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowOTMwMDczOEMzMDQxMUUyODZBNUUzMURDODBGQkRENiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PmYuYOUAAAEdSURBVHjaYvz//z8DJYAFXWDlypU8QKoIiD2A2AwqfAqIdwBxX3h4+Bdk9YzILgBqtgdS84FYEYeF94E4EWjIQZgAE5LmQCB1AKoZZKMPEAtAMYh9GSp3AKjWD8UFQAEhIPshEIOc3wHENUBb/qJ57SyQMoJyPwKxElDNO1gYFEE17wMKVmIJlzNQzeegrjaA6qmBecEbSvfh0GwMxGeBhoPoemQ9MAO0kEIbl2YTqPAFKK2IbMB3AjabYIkRZmQD7kNpMyI0G0PpO8gGbIUFJj7NQDk2INWIrIcJKfBAKcwJqvkcDs0TgFgXGo19KCkRmpDWQdWDEk0NUoCBoq0FqhkE/IEWbKJKUmZEz43QzFSKIzN1481M5ACAAAMAlfl/lCwRpagAAAAASUVORK5CYII=);width:20px}.gantt_delete_btn{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MjFENzI3NUNDMzA0MTFFMjhBNjJGQTc3MUIyQzYzNEYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MjFENzI3NURDMzA0MTFFMjhBNjJGQTc3MUIyQzYzNEYiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoyMUQ3Mjc1QUMzMDQxMUUyOEE2MkZBNzcxQjJDNjM0RiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoyMUQ3Mjc1QkMzMDQxMUUyOEE2MkZBNzcxQjJDNjM0RiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PmUD0gAAAABvSURBVHjaYvz//z8DIyMjAxYQicReji4J0ofKQNP8HwmgGQbXB8IsWGwDSSwDuioKjY9uBthVjFAXYHUGAQA2kYmBUoAUBpGk0LAwgBvwH+YX4mkwptgLowYMRgOITUyYKRFIN/wnDjQgJySAAAMApryKzL8wjfUAAAAASUVORK5CYII=);margin-top:2px;width:20px}.gantt_cal_cover{width:100%;height:100%;position:absolute;z-index:10000;top:0;left:0;background-color:#000;opacity:.1;filter:progid:DXImageTransform.Microsoft.Alpha(opacity=10)}.gantt_custom_button{padding:0 3px;font-family:Arial;font-size:13px;font-weight:400;margin-right:10px;margin-top:-5px;cursor:pointer;float:right;height:21px;width:90px;border:1px solid #cecece;text-align:center;border-radius:4px}.gantt_custom_button div{cursor:pointer;float:none;height:21px;line-height:21px;vertical-align:middle}.gantt_custom_button div:first-child{display:none}.gantt_cal_light_wide{width:580px;padding:2px 4px}.gantt_cal_light_wide .gantt_cal_larea{box-sizing:border-box;border:1px solid #cecece}.gantt_cal_light_wide .gantt_cal_lsection{border:0;float:left;text-align:right;width:80px;height:20px;padding:5px 10px 0 0}.gantt_cal_light_wide .gantt_wrap_section{position:relative;padding:10px 0;overflow:hidden;border-bottom:1px solid #ebebeb}.gantt_cal_light_wide .gantt_section_time{overflow:hidden;padding-top:2px!important;padding-right:0;height:20px!important}.gantt_cal_light_wide .gantt_cal_ltext{padding-right:0}.gantt_cal_light_wide .gantt_cal_larea{padding:0 10px;width:100%}.gantt_cal_light_wide .gantt_section_time{background:transparent}.gantt_cal_light_wide .gantt_cal_checkbox label{padding-left:0}.gantt_cal_light_wide .gantt_cal_lsection .gantt_fullday{float:none;margin-right:0;font-weight:700;cursor:pointer}.gantt_cal_light_wide .gantt_custom_button{position:absolute;top:0;right:0;margin-top:2px}.gantt_cal_light_wide .gantt_repeat_right{margin-right:55px}.gantt_cal_light_wide.gantt_cal_light_full{width:738px}.gantt_cal_wide_checkbox input{margin-top:8px;margin-left:14px}.gantt_cal_light input{font-size:13px}.gantt_section_time{background-color:#fff;white-space:nowrap;padding:2px 10px 5px;padding-top:2px!important}.gantt_section_time .gantt_time_selects{float:left;height:25px}.gantt_section_time .gantt_time_selects select{height:23px;padding:2px;border:1px solid #cecece}.gantt_duration{width:100px;height:23px;float:left;white-space:nowrap;margin-left:20px;line-height:23px}.gantt_duration .gantt_duration_dec,.gantt_duration .gantt_duration_inc,.gantt_duration .gantt_duration_value{box-sizing:border-box;text-align:center;vertical-align:top;height:100%;border:1px solid #cecece}.gantt_duration .gantt_duration_value{width:40px;padding:3px 4px;border-left-width:0;border-right-width:0}.gantt_duration .gantt_duration_value.gantt_duration_value_formatted{width:70px}.gantt_duration .gantt_duration_dec,.gantt_duration .gantt_duration_inc{width:20px;padding:1px;padding-bottom:1px;background:#fff}.gantt_duration .gantt_duration_dec{-moz-border-top-left-radius:4px;-moz-border-bottom-left-radius:4px;-webkit-border-top-left-radius:4px;-webkit-border-bottom-left-radius:4px;border-top-left-radius:4px;border-bottom-left-radius:4px}.gantt_duration .gantt_duration_inc{margin-right:4px;-moz-border-top-right-radius:4px;-moz-border-bottom-right-radius:4px;-webkit-border-top-right-radius:4px;-webkit-border-bottom-right-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:4px}.gantt_resources{max-height:150px;height:auto;overflow-y:auto}.gantt_resource_row{display:block;padding:10px 0;border-bottom:1px solid #ebebeb;cursor:pointer}.gantt_resource_row input[type=checkbox]:not(:checked),.gantt_resource_row input[type=checkbox]:not(:checked)~div{opacity:.5}.gantt_resource_toggle{vertical-align:middle}.gantt_resources_filter .gantt_resources_filter_input{padding:1px 2px;box-sizing:border-box}.gantt_resources_filter .switch_unsetted{vertical-align:middle}.gantt_resource_cell{display:inline-block}.gantt_resource_cell.gantt_resource_cell_checkbox{width:24px;max-width:24px;min-width:24px;vertical-align:middle}.gantt_resource_cell.gantt_resource_cell_label{width:40%;max-width:40%;vertical-align:middle}.gantt_resource_cell.gantt_resource_cell_value{width:30%;max-width:30%;vertical-align:middle}.gantt_resource_cell.gantt_resource_cell_value input,.gantt_resource_cell.gantt_resource_cell_value select{width:80%;vertical-align:middle;padding:1px 2px;box-sizing:border-box}.gantt_resource_cell.gantt_resource_cell_unit{width:10%;max-width:10%;vertical-align:middle}.gantt_resource_early_value{opacity:.8;font-size:.9em}.gantt_cal_quick_info{border:1px solid #cecece;border-radius:6px;position:absolute;z-index:300;box-shadow:3px 3px 3px rgba(0,0,0,.07);background-color:#fff;width:300px;transition:left .5s ease,right .5s;-moz-transition:left .5s ease,right .5s;-webkit-transition:left .5s ease,right .5s;-o-transition:left .5s ease,right .5s}.gantt_no_animate{transition:none;-moz-transition:none;-webkit-transition:none;-o-transition:none}.gantt_cal_quick_info.gantt_qi_left .gantt_qi_big_icon{float:right}.gantt_cal_qi_title{-webkit-border-top-left-radius:6px;-webkit-border-bottom-left-radius:0;-webkit-border-top-right-radius:6px;-webkit-border-bottom-right-radius:0;-moz-border-radius-topleft:6px;-moz-border-radius-bottomleft:0;-moz-border-radius-topright:6px;-moz-border-radius-bottomright:0;border-top-left-radius:6px;border-bottom-left-radius:0;border-top-right-radius:6px;border-bottom-right-radius:0;padding:5px 0 8px 12px;color:#454545;background-color:#fff;border-bottom:1px solid #cecece}.gantt_cal_qi_tdate{font-size:14px;font-weight:700}.gantt_cal_qi_tcontent{font-size:13px}.gantt_cal_qi_content{padding:16px 8px;font-size:13px;color:#454545;overflow:hidden}.gantt_cal_qi_controls{-webkit-border-top-left-radius:0;-webkit-border-bottom-left-radius:6px;-webkit-border-top-right-radius:0;-webkit-border-bottom-right-radius:6px;-moz-border-radius-topleft:0;-moz-border-radius-bottomleft:6px;-moz-border-radius-topright:0;-moz-border-radius-bottomright:6px;border-top-left-radius:0;border-bottom-left-radius:6px;border-top-right-radius:0;border-bottom-right-radius:6px;padding-left:7px}.gantt_cal_qi_controls .gantt_menu_icon{margin-top:6px;background-repeat:no-repeat}.gantt_cal_qi_controls .gantt_menu_icon.icon_edit{width:20px;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAB3RJTUUH3QYFCjI5ZQj5bAAAAFNJREFUOMvt0zEOACAIA0DkwTymH8bJTRTKZGJXyaWEKPKTCQAH4Ls37cItcDUzsxHNDLZNhCq7Gt1wh9ErV7EjyGAhyGLphlnsClWuS32rn0czAV+vNGrM/LBtAAAAAElFTkSuQmCC)}.gantt_cal_qi_controls .gantt_menu_icon.icon_delete{width:20px;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MjFENzI3NUNDMzA0MTFFMjhBNjJGQTc3MUIyQzYzNEYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MjFENzI3NURDMzA0MTFFMjhBNjJGQTc3MUIyQzYzNEYiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoyMUQ3Mjc1QUMzMDQxMUUyOEE2MkZBNzcxQjJDNjM0RiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoyMUQ3Mjc1QkMzMDQxMUUyOEE2MkZBNzcxQjJDNjM0RiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PmUD0gAAAABvSURBVHjaYvz//z8DIyMjAxYQicReji4J0ofKQNP8HwmgGQbXB8IsWGwDSSwDuioKjY9uBthVjFAXYHUGAQA2kYmBUoAUBpGk0LAwgBvwH+YX4mkwptgLowYMRgOITUyYKRFIN/wnDjQgJySAAAMApryKzL8wjfUAAAAASUVORK5CYII=)}.gantt_qi_big_icon{font-size:13px;border-radius:4px;font-weight:700;background:#fff;margin:5px 9px 8px 0;min-width:60px;line-height:32px;vertical-align:middle;padding:0 10px 0 5px;cursor:pointer;border:1px solid #cecece}.gantt_cal_qi_controls div{float:left;height:32px;text-align:center;line-height:32px}.gantt_tooltip{padding:10px;position:absolute;z-index:50;white-space:nowrap}.gantt_resource_marker{position:absolute;text-align:center;font-size:14px;color:#fff}.gantt_resource_marker_ok{background:rgba(78,208,134,.75)}.gantt_resource_marker_overtime{background:hsla(0,100%,76%,.69)}.gantt_histogram_label{width:100%;height:100%;position:absolute;z-index:1;font-weight:700;font-size:13px}.gantt_histogram_fill{background-color:rgba(41,157,180,.2);width:100%;position:absolute;bottom:0}.gantt_histogram_hor_bar{height:1px;margin-top:-1px}.gantt_histogram_hor_bar,.gantt_histogram_vert_bar{position:absolute;background:#299db4;margin-left:-1px}.gantt_histogram_vert_bar{width:1px}.gantt_histogram_cell{position:absolute;text-align:center;font-size:13px;color:#000}.gantt_marker{height:100%;width:2px;top:0;position:absolute;text-align:center;background-color:rgba(255,0,0,.4);box-sizing:border-box}.gantt_marker .gantt_marker_content{padding:5px;background:inherit;color:#fff;position:absolute;font-size:12px;line-height:12px;opacity:.8}.gantt_marker_area{position:absolute;top:0;left:0}.gantt_grid_editor_placeholder{position:absolute}.gantt_grid_editor_placeholder>div,.gantt_grid_editor_placeholder input,.gantt_grid_editor_placeholder select{width:100%;height:100%;box-sizing:border-box}.gantt_row_placeholder div{opacity:.5}.gantt_row_placeholder .gantt_add,.gantt_row_placeholder .gantt_file{display:none}.gantt_drag_marker.gantt_grid_dnd_marker{background-color:transparent;transition:all .1s ease}.gantt_grid_dnd_marker_line{height:4px;width:100%;background-color:#3498db}.gantt_grid_dnd_marker_line:before{background:#fff;width:12px;height:12px;box-sizing:border-box;border:3px solid #3498db;border-radius:6px;content:\"\";line-height:1px;display:block;position:absolute;margin-left:-11px;margin-top:-4px;pointer-events:none}.gantt_grid_dnd_marker_folder{height:100%;width:100%;position:absolute;pointer-events:none;box-sizing:border-box;box-shadow:inset 0 0 0 2px #3f98db;background:transparent}.gantt_overlay_area{display:none}.gantt_overlay,.gantt_overlay_area{position:absolute;height:inherit;width:inherit;top:0;left:0}.gantt_click_drag_rect{position:absolute;left:0;top:0;outline:1px solid #3f98db;background-color:rgba(52,152,219,.3)}.gantt_timeline_move_available,.gantt_timeline_move_available *{cursor:move}.gantt_layout_content{width:100%;overflow:auto;box-sizing:border-box}.gantt_layout_cell{position:relative;box-sizing:border-box}.gantt_layout_cell>.gantt_layout_header{background:#33aae8;color:#fff;font-size:17px;padding:5px 10px;box-sizing:border-box}.gantt_layout_header.collapsed_x{background:#a9a9a9}.gantt_layout_header.collapsed_x .gantt_header_arrow:before{content:\"\\21E7\"}.gantt_layout_header.collapsed_y{background:#a9a9a9}.gantt_layout_header.collapsed_y .gantt_header_arrow:before{content:\"\\21E9\"}.gantt_layout_header{cursor:pointer}.gantt_layout_header .gantt_header_arrow{float:right;text-align:right}.gantt_layout_header .gantt_header_arrow:before{content:\"\\21E6\"}.gantt_layout_header.vertical .gantt_header_arrow:before{content:\"\\21E7\"}.gantt_layout_outer_scroll_vertical .gantt_layout_content{overflow-y:hidden}.gantt_layout_outer_scroll_horizontal .gantt_layout_content{overflow-x:hidden}.gantt_layout_x>.gantt_layout_cell{display:inline-block;vertical-align:top}.gantt_layout_x{white-space:nowrap}.gantt_resizing{opacity:.7;background:#f2f2f2}.gantt_layout_cell_border_right.gantt_resizer{overflow:visible;border-right:0}.gantt_resizer{cursor:e-resize;position:relative}.gantt_resizer_y{cursor:n-resize}.gantt_resizer_stick{background:#33aae8;z-index:9999;position:absolute;top:0;width:100%}.gantt_resizer_x .gantt_resizer_x{position:absolute;width:20px;height:100%;margin-left:-10px;top:0;left:0;z-index:1}.gantt_resizer_y .gantt_resizer_y{position:absolute;height:20px;width:100%;top:-10px;left:0;z-index:1}.gantt_resizer_error{background:#cd5c5c!important}.gantt_layout_cell_border_left{border-left:1px solid #cecece}.gantt_layout_cell_border_right{border-right:1px solid #cecece}.gantt_layout_cell_border_top{border-top:1px solid #cecece}.gantt_layout_cell_border_bottom{border-bottom:1px solid #cecece}.gantt_layout_cell_border_transparent{border-color:transparent}.gantt_window{position:absolute;top:50%;left:50%;z-index:999999999;background:#fff}.gantt_window_content{position:relative}.gantt_window_content_header{background:#39c;color:#fff;height:33px;padding:10px 10px 0;border-bottom:2px solid #fff;position:relative}.gantt_window_content_header_text{padding-left:10%}.gantt_window_content_header_buttons{position:absolute;top:10px;right:10px}.gantt_window_content_header_buttons:hover{color:#000;cursor:pointer}.gantt_window_content_resizer{position:absolute;width:15px;height:15px;bottom:0;line-height:15px;right:-1px;text-align:center;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAMAAAAMCGV4AAAABlBMVEUAAAAAAAClZ7nPAAAAAXRSTlMAQObYZgAAABZJREFUeAFjIAUwUshlpJDLSIhLGAAACQ4AFk79JaMAAAAASUVORK5CYII=);cursor:nw-resize;z-index:999}.gantt_window_content_frame{position:absolute;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.1);z-index:9999}.gantt_window_drag{cursor:pointer!important}.gantt_window_resizing{overflow:visible}.gantt_window_resizing_body{overflow:hidden!important}.gantt_window_modal{background:rgba(0,0,0,.1);z-index:9999;top:0;left:0;width:100%;height:100%;position:fixed}.gantt_cal_light,.gantt_cal_quick_info,.gantt_container,.gantt_message_area,.gantt_modal_box,.gantt_tooltip{text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.gantt_noselect{-moz-user-select:-moz-none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.gantt_drag_marker{position:absolute;top:-1000px;left:-1000px;font-family:Arial;font-size:13px;z-index:1;white-space:nowrap}.gantt_drag_marker .gantt_tree_icon.gantt_blank,.gantt_drag_marker .gantt_tree_icon.gantt_close,.gantt_drag_marker .gantt_tree_icon.gantt_open,.gantt_drag_marker .gantt_tree_indent{display:none}.gantt_drag_marker,.gantt_drag_marker .gantt_row.odd{background-color:#fff}.gantt_drag_marker .gantt_row{border-left:1px solid #d2d2d2;border-top:1px solid #d2d2d2}.gantt_drag_marker .gantt_cell{border-color:#d2d2d2}.gantt_row.gantt_over,.gantt_task_row.gantt_over{background-color:#0070fe}.gantt_row.gantt_transparent .gantt_cell{opacity:.7}.gantt_task_row.gantt_transparent{background-color:#f8fdfd}.gantt_popup_button.gantt_delete_button{background:#3db9d3;text-shadow:0 -1px 0 #248a9f;color:#fff;font-weight:700;border-width:0}.gantt_container_resize_watcher{background:transparent;width:100%;height:100%;position:absolute;top:0;left:0;z-index:-1;pointer-events:none;border:0;box-sizing:border-box;opacity:0}", ""]);

// exports


/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapToGanttData = void 0;

var _DateFormatters = __webpack_require__(43);

var _DateService = __webpack_require__(48);

var _sorting = __webpack_require__(259);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var mapToGanttData = function mapToGanttData(portfolioData) {
  var _portfolioData$initia;

  var taskData = new Array();
  var linkData = new Array();
  var ganttData = {};
  var rowId = 1;

  if (Array.isArray(portfolioData === null || portfolioData === void 0 ? void 0 : portfolioData.initiatives) && (portfolioData === null || portfolioData === void 0 ? void 0 : (_portfolioData$initia = portfolioData.initiatives) === null || _portfolioData$initia === void 0 ? void 0 : _portfolioData$initia.length) > 0) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      var _loop = function _loop() {
        var _portfolioData$featur;

        var initiative = _step.value;
        var initiativeGanttEntry = {
          id: rowId,
          text: initiative === null || initiative === void 0 ? void 0 : initiative.name,
          type: 'initiative',
          order: rowId.toString(),
          open: false,
          parent: 0,
          objectId: initiative === null || initiative === void 0 ? void 0 : initiative.id
        };
        var parentId = rowId; // store for any features

        var startDate = null; // to update the start date of the feature - earliest start date of all the features

        var endDate = null; // to update the end date of the feature - latest end date of all the features

        rowId++;
        var features = portfolioData === null || portfolioData === void 0 ? void 0 : (_portfolioData$featur = portfolioData.features) === null || _portfolioData$featur === void 0 ? void 0 : _portfolioData$featur.filter(function (feature) {
          return (initiative === null || initiative === void 0 ? void 0 : initiative.id) === (feature === null || feature === void 0 ? void 0 : feature.initiativeId);
        });
        var featureGanttEntries = new Array();
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          var _loop2 = function _loop2() {
            var _portfolioData$issues;

            var feature = _step2.value;
            var featureGanttEntry = {
              id: rowId,
              text: feature === null || feature === void 0 ? void 0 : feature.name,
              type: 'feature',
              order: rowId.toString(),
              open: false,
              start_date: (0, _DateFormatters.formatDateGanttChartDefault)(feature === null || feature === void 0 ? void 0 : feature.startDate),
              end_date: (0, _DateFormatters.formatDateGanttChartDefault)(feature === null || feature === void 0 ? void 0 : feature.endDate),
              parent: parentId,
              objectId: feature === null || feature === void 0 ? void 0 : feature.id,
              color: '#2196F3'
            };
            featureGanttEntries.push(featureGanttEntry);
            var featureParentId = rowId; // store for any issues

            rowId++;
            var issues = portfolioData === null || portfolioData === void 0 ? void 0 : (_portfolioData$issues = portfolioData.issues) === null || _portfolioData$issues === void 0 ? void 0 : _portfolioData$issues.filter(function (issue) {
              return (feature === null || feature === void 0 ? void 0 : feature.id) === (issue === null || issue === void 0 ? void 0 : issue.featureId);
            });
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
              for (var _iterator4 = issues[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var issue = _step4.value;
                var issueGanttEntry = {
                  id: rowId,
                  text: issue === null || issue === void 0 ? void 0 : issue.name,
                  type: 'issue',
                  order: rowId.toString(),
                  open: false,
                  start_date: (0, _DateFormatters.formatDateGanttChartDefault)(issue === null || issue === void 0 ? void 0 : issue.startDate),
                  end_date: (0, _DateFormatters.formatDateGanttChartDefault)(issue === null || issue === void 0 ? void 0 : issue.endDate),
                  parent: featureParentId,
                  objectId: issue === null || issue === void 0 ? void 0 : issue.id,
                  color: '#4dd0e1'
                };
                taskData.push(issueGanttEntry);
                rowId++;
              }
            } catch (err) {
              _didIteratorError4 = true;
              _iteratorError4 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion4 && _iterator4["return"] != null) {
                  _iterator4["return"]();
                }
              } finally {
                if (_didIteratorError4) {
                  throw _iteratorError4;
                }
              }
            }

            startDate = (0, _DateService.isDateBefore)((0, _DateFormatters.formatDateDefault)(startDate), (0, _DateFormatters.formatDateDefault)(feature === null || feature === void 0 ? void 0 : feature.startDate)) ? startDate : feature === null || feature === void 0 ? void 0 : feature.startDate;
            endDate = (0, _DateService.isDateAfter)((0, _DateFormatters.formatDateDefault)(endDate), (0, _DateFormatters.formatDateDefault)(feature === null || feature === void 0 ? void 0 : feature.endDate)) ? endDate : feature === null || feature === void 0 ? void 0 : feature.endDate;
          };

          for (var _iterator2 = features[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            _loop2();
          } // okay - we have calculated the initiative start date from the earliest and latest start and end dates of the features
          // we do have dates in the initiatives so use them - use feature dates as backup if not set on the initiative

        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
              _iterator2["return"]();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        if ((initiative === null || initiative === void 0 ? void 0 : initiative.startDate) && (initiative === null || initiative === void 0 ? void 0 : initiative.endDate)) {
          startDate = initiative === null || initiative === void 0 ? void 0 : initiative.startDate;
          endDate = initiative === null || initiative === void 0 ? void 0 : initiative.endDate;
        }

        taskData.push(_objectSpread({}, initiativeGanttEntry, {
          start_date: (0, _DateFormatters.formatDateGanttChartDefault)(startDate || new Date()),
          end_date: (0, _DateFormatters.formatDateGanttChartDefault)(endDate || new Date())
        }));
        var id = 1; // TODO - passed to method - have to get latest value back

        if (featureGanttEntries) {
          var links = (featureGanttEntries === null || featureGanttEntries === void 0 ? void 0 : featureGanttEntries.length) > 1 ? mapDependenciesToGanttLinkData(portfolioData === null || portfolioData === void 0 ? void 0 : portfolioData.features, featureGanttEntries, id) : null;
          var sortedFeatureGanttEntries = (0, _sorting.sortByDate)(featureGanttEntries, 'startDate');
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = (sortedFeatureGanttEntries === null || sortedFeatureGanttEntries === void 0 ? void 0 : sortedFeatureGanttEntries.reverse())[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var featureGanttEntry = _step3.value;
              taskData.push(featureGanttEntry);
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                _iterator3["return"]();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }

          if (links) linkData = linkData.concat(links);
        }
      };

      for (var _iterator = (portfolioData === null || portfolioData === void 0 ? void 0 : portfolioData.initiatives)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        _loop();
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    ganttData = {
      data: taskData,
      links: linkData
    };
  }

  return ganttData;
}; // portfolioData?.features, featureGanttEntries
// {
//     'id': '4',
//     'source': '2',
//     'target': '5',
//     'type': '2'
//   }


exports.mapToGanttData = mapToGanttData;

var mapDependenciesToGanttLinkData = function mapDependenciesToGanttLinkData(allFeatures, featureGanttEntries, id) {
  var linkData = new Array();
  var _iteratorNormalCompletion5 = true;
  var _didIteratorError5 = false;
  var _iteratorError5 = undefined;

  try {
    var _loop3 = function _loop3() {
      var featureEntry = _step5.value; // get the original feature and see if it has dependencies

      var feature = allFeatures === null || allFeatures === void 0 ? void 0 : allFeatures.find(function (feature) {
        return (feature === null || feature === void 0 ? void 0 : feature.id) === (featureEntry === null || featureEntry === void 0 ? void 0 : featureEntry.objectId);
      });

      if (feature) {
        var _feature$dependencies; // have the original feature so see if it has inward dependencies


        feature === null || feature === void 0 ? void 0 : (_feature$dependencies = feature.dependencies) === null || _feature$dependencies === void 0 ? void 0 : _feature$dependencies.forEach(function (link) {
          var linkedId = 0;

          if ((link === null || link === void 0 ? void 0 : link.outward) !== undefined) {
            var _link$outward;

            linkedId = link === null || link === void 0 ? void 0 : (_link$outward = link.outward) === null || _link$outward === void 0 ? void 0 : _link$outward.id;
          } // has an outward link so check if that other dependency is in the gantt items list to create the link


          var found = featureGanttEntries === null || featureGanttEntries === void 0 ? void 0 : featureGanttEntries.find(function (element) {
            return (element === null || element === void 0 ? void 0 : element.objectId) === linkedId;
          });

          if (found) {
            linkData.push({
              id: id,
              source: featureEntry === null || featureEntry === void 0 ? void 0 : featureEntry.id,
              target: found === null || found === void 0 ? void 0 : found.id,
              type: 0
            });
            id++;
          }
        });
      }
    };

    for (var _iterator5 = featureGanttEntries[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
      _loop3();
    }
  } catch (err) {
    _didIteratorError5 = true;
    _iteratorError5 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion5 && _iterator5["return"] != null) {
        _iterator5["return"]();
      }
    } finally {
      if (_didIteratorError5) {
        throw _iteratorError5;
      }
    }
  }

  return linkData;
};

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapToGanttData, "mapToGanttData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/portfolioService.js");

  __REACT_HOT_LOADER__.register(mapDependenciesToGanttLinkData, "mapDependenciesToGanttLinkData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/portfolioService.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/portfolioService.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/portfolioService.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/portfolioService.js");

  __REACT_HOT_LOADER__.register(mapToGanttData, "mapToGanttData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/portfolioService.js");

  __REACT_HOT_LOADER__.register(mapDependenciesToGanttLinkData, "mapDependenciesToGanttLinkData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/portfolioService.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/portfolioService.js");
}();

;

/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _multiDetailDrillDown = _interopRequireDefault(__webpack_require__(820));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _NumberFormatters = __webpack_require__(99);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/**
 * 
 * @param {Array} data of value stream objects
 */


var ValueStreamDrillDown = function ValueStreamDrillDown(_ref) {
  var data = _ref.data;
  var entries = new Array();

  if (Array.isArray(data)) {
    // need to convert data to label, description objects for use by basicDetailDrillDown
    entries = data.map(function (entry) {
      return {
        name: entry === null || entry === void 0 ? void 0 : entry.name,
        drillDownData: [{
          label: _react["default"].createElement(_IntlMessages["default"], {
            id: "label.description"
          }),
          description: (entry === null || entry === void 0 ? void 0 : entry.description) ? entry === null || entry === void 0 ? void 0 : entry.description : 'no description specified'
        }, {
          label: _react["default"].createElement(_IntlMessages["default"], {
            id: "label.valueProposition"
          }),
          description: (entry === null || entry === void 0 ? void 0 : entry.valueProposition) ? entry === null || entry === void 0 ? void 0 : entry.valueProposition : 'no value proposition specified'
        }, {
          label: _react["default"].createElement(_IntlMessages["default"], {
            id: "label.budget"
          }),
          description: (entry === null || entry === void 0 ? void 0 : entry.budget) ? (0, _NumberFormatters.formatBalance)(entry === null || entry === void 0 ? void 0 : entry.budget) : (0, _NumberFormatters.formatBalance)(0)
        }, {
          label: _react["default"].createElement(_IntlMessages["default"], {
            id: "label.kpi"
          }),
          description: (entry === null || entry === void 0 ? void 0 : entry.kpi) ? entry === null || entry === void 0 ? void 0 : entry.kpi : 'no kpi specified'
        }, {
          label: _react["default"].createElement(_IntlMessages["default"], {
            id: "label.systems"
          }),
          description: (entry === null || entry === void 0 ? void 0 : entry.systems) ? entry === null || entry === void 0 ? void 0 : entry.systems : 'no systems specified'
        }, {
          label: _react["default"].createElement(_IntlMessages["default"], {
            id: "label.owner"
          }),
          description: (entry === null || entry === void 0 ? void 0 : entry.owner) ? entry === null || entry === void 0 ? void 0 : entry.owner : 'no owner specified'
        }, {
          label: _react["default"].createElement(_IntlMessages["default"], {
            id: "label.theme"
          }),
          description: (entry === null || entry === void 0 ? void 0 : entry.theme) ? entry === null || entry === void 0 ? void 0 : entry.theme : 'no theme specified'
        }]
      };
    });
    return _react["default"].createElement("div", null, _react["default"].createElement(_multiDetailDrillDown["default"], {
      entries: entries
    }));
  }

  return _react["default"].createElement(_react.Fragment, null);
};

var _default = ValueStreamDrillDown;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ValueStreamDrillDown, "ValueStreamDrillDown", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/agileDrillDowns/valueStreamDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/agileDrillDowns/valueStreamDrillDown/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/agileDrillDowns/valueStreamDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_multiDetailDrillDown, "_multiDetailDrillDown", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/agileDrillDowns/valueStreamDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/agileDrillDowns/valueStreamDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/agileDrillDowns/valueStreamDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/agileDrillDowns/valueStreamDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/agileDrillDowns/valueStreamDrillDown/index.js");

  __REACT_HOT_LOADER__.register(ValueStreamDrillDown, "ValueStreamDrillDown", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/agileDrillDowns/valueStreamDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/agileDrillDowns/valueStreamDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/agileDrillDowns/valueStreamDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/agileDrillDowns/valueStreamDrillDown/index.js");
}();

;

/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _multiDetailDrillDown = _interopRequireDefault(__webpack_require__(820));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _NumberFormatters = __webpack_require__(99);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/**
 * 
 * @param {Array} data of product objects
 */


var ProductDrillDown = function ProductDrillDown(_ref) {
  var data = _ref.data,
      valueStreams = _ref.valueStreams;
  var entries = new Array();

  if (Array.isArray(data)) {
    // need to convert data to label, description objects for use by basicDetailDrillDown
    entries = data.map(function (entry) {
      var valueStream = Array.isArray(valueStreams) ? valueStreams.find(function (vs) {
        return (vs === null || vs === void 0 ? void 0 : vs.id) === (entry === null || entry === void 0 ? void 0 : entry.valueStreamId);
      }) : null;
      return {
        name: entry === null || entry === void 0 ? void 0 : entry.name,
        drillDownData: [{
          label: _react["default"].createElement(_IntlMessages["default"], {
            id: "label.description"
          }),
          description: (entry === null || entry === void 0 ? void 0 : entry.description) ? entry === null || entry === void 0 ? void 0 : entry.description : 'no description specified'
        }, {
          label: _react["default"].createElement(_IntlMessages["default"], {
            id: "label.valueStream"
          }),
          description: valueStream ? valueStream === null || valueStream === void 0 ? void 0 : valueStream.name : 'no value stream selected'
        }, {
          label: _react["default"].createElement(_IntlMessages["default"], {
            id: "label.fyBudget"
          }),
          description: (entry === null || entry === void 0 ? void 0 : entry.fyBudget) ? (0, _NumberFormatters.formatBalance)(entry === null || entry === void 0 ? void 0 : entry.fyBudget) : (0, _NumberFormatters.formatBalance)(0)
        }, {
          label: _react["default"].createElement(_IntlMessages["default"], {
            id: "label.productType"
          }),
          description: (entry === null || entry === void 0 ? void 0 : entry.productType) ? entry === null || entry === void 0 ? void 0 : entry.productType : 'no product type specified'
        }]
      };
    });
    return _react["default"].createElement("div", null, _react["default"].createElement(_multiDetailDrillDown["default"], {
      entries: entries
    }));
  }

  return _react["default"].createElement(_react.Fragment, null);
};

var _default = ProductDrillDown;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProductDrillDown, "ProductDrillDown", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/agileDrillDowns/productDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/agileDrillDowns/productDrillDown/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/agileDrillDowns/productDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_multiDetailDrillDown, "_multiDetailDrillDown", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/agileDrillDowns/productDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/agileDrillDowns/productDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/agileDrillDowns/productDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/agileDrillDowns/productDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/agileDrillDowns/productDrillDown/index.js");

  __REACT_HOT_LOADER__.register(ProductDrillDown, "ProductDrillDown", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/agileDrillDowns/productDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/agileDrillDowns/productDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/agileDrillDowns/productDrillDown/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/agileDrillDowns/productDrillDown/index.js");
}();

;

/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _component["default"];
  }
});

var _component = _interopRequireDefault(__webpack_require__(1930));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_component, "_component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/index.js");
}();

;

/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _rcDrawer = _interopRequireDefault(__webpack_require__(31));

var _reactNotifications = __webpack_require__(30);

var _reactstrap = __webpack_require__(6);

var _featureDetail = _interopRequireDefault(__webpack_require__(1931));

var _featureTable = _interopRequireDefault(__webpack_require__(1936));

var _featureAdd = _interopRequireDefault(__webpack_require__(1937));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _CircularProgress = _interopRequireDefault(__webpack_require__(24));

var _CustomScrollbars = _interopRequireDefault(__webpack_require__(27));

var _feature = __webpack_require__(114);

var _initiative = __webpack_require__(101);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Component = function Component() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var width = (0, _reactRedux.useSelector)(function (state) {
    return state.settings.width;
  });
  var loader = (0, _reactRedux.useSelector)(function (state) {
    return state.features.loader;
  });
  var alertMessage = (0, _reactRedux.useSelector)(function (state) {
    return state.features.alertMessage;
  });
  var showMessage = (0, _reactRedux.useSelector)(function (state) {
    return state.features.showMessage;
  });
  var noContentFoundMessage = (0, _reactRedux.useSelector)(function (state) {
    return state.features.noContentFoundMessage;
  });
  var drawerState = (0, _reactRedux.useSelector)(function (state) {
    return state.features.drawerState;
  });
  var feature = (0, _reactRedux.useSelector)(function (state) {
    return state.features.feature;
  });
  var featureList = (0, _reactRedux.useSelector)(function (state) {
    return state.features.featureList;
  });
  (0, _react.useEffect)(function () {
    dispatch((0, _feature.showFeatureLoader)());
    dispatch((0, _feature.fetchFeatures)());
    dispatch((0, _initiative.fetchInitiatives)()); // need to fetchInitiatives when they are available
  }, []);

  var featureSideBar = function featureSideBar() {
    return _react["default"].createElement("div", {
      className: "module-side"
    }, _react["default"].createElement("div", {
      className: "module-side-header"
    }, _react["default"].createElement("div", {
      className: "module-logo"
    }, _react["default"].createElement("i", {
      className: "zmdi zmdi-city-alt mr-4"
    }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
      id: "sidebar.features"
    })))), _react["default"].createElement("div", {
      className: "module-side-content"
    }, _react["default"].createElement(_CustomScrollbars["default"], {
      className: "module-side-scroll scrollbar",
      style: {
        height: width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)'
      }
    }, _react["default"].createElement("div", {
      className: "module-add-task"
    }, _react["default"].createElement(_reactstrap.Button, {
      className: "btn-block jr-btn",
      color: "primary",
      onClick: function onClick() {
        return dispatch((0, _feature.onAddFeature)());
      }
    }, _react["default"].createElement("i", {
      className: "zmdi zmdi-accounts-add zmdi-hc-fw"
    }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
      id: "feature.addFeature"
    })))))));
  };

  var featureRequestClose = function featureRequestClose() {
    dispatch((0, _feature.handleFeatureRequestClose)());
  };

  return _react["default"].createElement("div", {
    className: "app-wrapper"
  }, _react["default"].createElement("div", {
    className: "app-module animated slideInUpTiny animation-duration-3"
  }, _react["default"].createElement("div", {
    className: "d-block d-xl-none"
  }, _react["default"].createElement(_rcDrawer["default"], {
    touch: true,
    transitions: true,
    enableDragHandle: true,
    open: drawerState,
    onOpenChange: function onOpenChange() {
      return dispatch((0, _feature.onToggleFeatureDrawer)());
    },
    sidebar: featureSideBar(feature)
  })), _react["default"].createElement("div", {
    className: "app-module-sidenav d-none d-xl-flex"
  }, featureSideBar(feature)), _react["default"].createElement("div", {
    className: "module-box"
  }, _react["default"].createElement("div", {
    className: "module-box-content"
  }, _react["default"].createElement("div", {
    className: "module-box-header"
  }, _react["default"].createElement("span", {
    className: "icon-btn drawer-btn d-flex d-xl-none",
    onClick: function onClick() {
      return dispatch((0, _feature.onToggleFeatureDrawer)());
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-menu"
  }))), _react["default"].createElement(_CustomScrollbars["default"], {
    className: "module-list-scroll scrollbar",
    style: {
      height: width >= 1200 ? 'calc(108vh - 265px)' : 'calc(108vh - 245px)'
    }
  }, loader ? _react["default"].createElement("div", {
    className: "loader-view-block h-100"
  }, _react["default"].createElement("div", {
    className: "loader-view"
  }, _react["default"].createElement(_CircularProgress["default"], null))) : featureList && featureList.length > 0 ? _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
    className: "app-main-content"
  }, _react["default"].createElement(_featureTable["default"], null), _react["default"].createElement("div", {
    style: {
      marginTop: 10
    }
  }, _react["default"].createElement(_featureDetail["default"], null)))) : _react["default"].createElement("div", {
    className: "h-100 d-flex align-items-center justify-content-center"
  }, noContentFoundMessage))))), _react["default"].createElement(_featureAdd["default"], null), showMessage && _reactNotifications.NotificationManager.success(alertMessage, featureRequestClose()), _react["default"].createElement(_reactNotifications.NotificationContainer, null));
};

var _default = Component;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/component.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/component.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/component.js");

  __REACT_HOT_LOADER__.register(_rcDrawer, "_rcDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/component.js");

  __REACT_HOT_LOADER__.register(_featureDetail, "_featureDetail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/component.js");

  __REACT_HOT_LOADER__.register(_featureTable, "_featureTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/component.js");

  __REACT_HOT_LOADER__.register(_featureAdd, "_featureAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/component.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/component.js");

  __REACT_HOT_LOADER__.register(_CircularProgress, "_CircularProgress", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/component.js");

  __REACT_HOT_LOADER__.register(_CustomScrollbars, "_CustomScrollbars", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/component.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/component.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/component.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/component.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/component.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/component.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/component.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/component.js");
}();

;

/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _featureDetailTable = _interopRequireDefault(__webpack_require__(422));

var _featureDependency = _interopRequireDefault(__webpack_require__(1933));

var _featureEdit = _interopRequireDefault(__webpack_require__(1934));

var _featureService = __webpack_require__(822);

var _selectByIdModal = _interopRequireDefault(__webpack_require__(301));

var _feature = __webpack_require__(114);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // import { TIGHT_FIT_PARAM } from 'constants/System';


var FeatureDetail = function FeatureDetail() {
  // const defaultWidth = width > TIGHT_FIT_PARAM ? 150 : 80;
  var dispatch = (0, _reactRedux.useDispatch)();
  var width = (0, _reactRedux.useSelector)(function (state) {
    return state.settings.width;
  });
  var featureList = (0, _reactRedux.useSelector)(function (state) {
    return state.features.featureList;
  });
  var selectedFeature = (0, _reactRedux.useSelector)(function (state) {
    return state.features.selectedFeature;
  });
  var dependencyList = (0, _reactRedux.useSelector)(function (state) {
    return state.features.dependencyList;
  });

  var mainIcon = function mainIcon(issueType) {
    if (issueType && issueType.toLowerCase() === 'high') {
      return 'dashboard';
    }

    if (issueType && issueType.toLowerCase() === 'medium') {
      return 'compact';
    }

    if (issueType && issueType.toLowerCase() === 'low') {
      return 'module';
    }

    return 'stream';
  };

  if (selectedFeature) {
    // const fields = { ...selectedFeature?.fields };
    var displayData = (0, _featureService.getDisplayData)(selectedFeature);
    var inwardDependencies = (0, _featureService.mapInwardDependenciesToDisplayData)(featureList, selectedFeature) || null;
    var outwardDependencies = (0, _featureService.mapOutwardDependenciesToDisplayData)(featureList, selectedFeature) || null;
    return _react["default"].createElement("div", {
      className: "dashboard animated slideInUpTiny animation-duration-3"
    }, _react["default"].createElement("div", {
      className: "row"
    }, _react["default"].createElement("div", {
      className: "col-md-6 col-12"
    }, _react["default"].createElement("div", {
      className: "jr-card jr-card-full-height ml-2 mr-2"
    }, _react["default"].createElement("div", {
      className: "jr-card-header d-flex"
    }, _react["default"].createElement("div", {
      className: "mr-auto"
    }, _react["default"].createElement("h2", {
      className: "card-heading"
    }, displayData === null || displayData === void 0 ? void 0 : displayData.name)), _react["default"].createElement("div", null, _react["default"].createElement(_selectByIdModal["default"], {
      modalTitle: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.inwardDependencies"
      }),
      onUpdateHandler: _feature.onFeatureInwardDependencyUpdate,
      onSelectRowHandler: _feature.onFeatureSelect,
      onClickButtonHandler: _feature.onFetchSelectFeatureInwardDependencies,
      selectLoader: _feature.showFeatureLoader,
      data: dependencyList,
      width: width,
      actionButtonTextId: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.inwardDependencies"
      })
    }), _react["default"].createElement(_selectByIdModal["default"], {
      modalTitle: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.outwardDependencies"
      }),
      onUpdateHandler: _feature.onFeatureOutwardDependencyUpdate,
      onSelectRowHandler: _feature.onFeatureSelect,
      onClickButtonHandler: _feature.onFetchSelectFeatureOutwardDependencies,
      selectLoader: _feature.showFeatureLoader,
      data: dependencyList,
      width: true,
      actionButtonTextId: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.outwardDependencies"
      })
    }), _react["default"].createElement(_reactstrap.Button, {
      size: "sm",
      color: "primary",
      onClick: function onClick() {
        return dispatch((0, _feature.onEditFeature)());
      }
    }, _react["default"].createElement("i", {
      className: "zmdi zmdi-edit zmdi-hc-fw"
    }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
      id: "label.edit"
    }))))), _react["default"].createElement("div", {
      className: "jr-card-body"
    }, _react["default"].createElement("div", {
      className: "row"
    }, _react["default"].createElement("div", {
      className: "col-sm-3"
    }, _react["default"].createElement("div", {
      className: "temp-section mb-4 mb-sm-0 text-center text-sm-left"
    }, _react["default"].createElement("p", null, _react["default"].createElement("i", {
      className: "detail-icon text-blue-grey zmdi zmdi-view-".concat(mainIcon(displayData === null || displayData === void 0 ? void 0 : displayData.priority), " zmdi-hc-fw")
    })), (displayData === null || displayData === void 0 ? void 0 : displayData.priority) ? _react["default"].createElement("h2", {
      className: "temp-point"
    }, displayData === null || displayData === void 0 ? void 0 : displayData.priority) : null)), _react["default"].createElement("div", {
      className: "col-sm-9 text-center text-sm-left"
    }, _react["default"].createElement(_featureDetailTable["default"], {
      displayData: displayData
    }))))), _react["default"].createElement(_featureEdit["default"], null)), _react["default"].createElement("div", {
      className: "col-md-3"
    }, _react["default"].createElement("div", {
      className: "jr-card jr-card-full-height ml-2 mr-2"
    }, _react["default"].createElement(_featureDependency["default"], {
      dependencies: inwardDependencies,
      title: _react["default"].createElement(_IntlMessages["default"], {
        id: "feature.inwardDependencies"
      })
    }))), _react["default"].createElement("div", {
      className: "col-md-3"
    }, _react["default"].createElement("div", {
      className: "jr-card jr-card-full-height ml-2 mr-2"
    }, _react["default"].createElement(_featureDependency["default"], {
      dependencies: outwardDependencies,
      title: _react["default"].createElement(_IntlMessages["default"], {
        id: "feature.outwardDependencies"
      })
    })))));
  } else {
    return _react["default"].createElement("div", {
      className: "dashboard animated slideInUpTiny animation-duration-3"
    }, _react["default"].createElement("div", {
      className: "row"
    }, _react["default"].createElement("div", {
      className: "col-md-12 col-12"
    }, _react["default"].createElement("div", {
      className: "jr-card jr-card-full-height"
    }, _react["default"].createElement("div", {
      className: "jr-card-header d-flex"
    }, _react["default"].createElement("div", {
      className: "mr-auto"
    }, _react["default"].createElement("h3", {
      className: "card-heading"
    }, "Please select an issue to display details")))))));
  }
};

var _default = FeatureDetail;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(FeatureDetail, "FeatureDetail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/index.js");

  __REACT_HOT_LOADER__.register(_featureDetailTable, "_featureDetailTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/index.js");

  __REACT_HOT_LOADER__.register(_featureDependency, "_featureDependency", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/index.js");

  __REACT_HOT_LOADER__.register(_featureEdit, "_featureEdit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/index.js");

  __REACT_HOT_LOADER__.register(_selectByIdModal, "_selectByIdModal", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/index.js");

  __REACT_HOT_LOADER__.register(FeatureDetail, "FeatureDetail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/index.js");
}();

;

/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var FeatureDetailRow = function FeatureDetailRow(_ref) {
  var label = _ref.label,
      description = _ref.description;
  return _react["default"].createElement("tr", null, _react["default"].createElement("td", null, _react["default"].createElement("div", {
    className: "user-profile d-flex flex-row align-items-center"
  }, _react["default"].createElement("div", {
    className: "user-detail"
  }, _react["default"].createElement("h5", {
    className: "user-name"
  }, label, " ")))), _react["default"].createElement("td", {
    className: "text-right"
  }, _react["default"].createElement("div", null, description)));
};

var _default = FeatureDetailRow;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(FeatureDetailRow, "FeatureDetailRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/featureDetailRow/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/featureDetailRow/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/featureDetailRow/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/featureDetailRow/index.js");

  __REACT_HOT_LOADER__.register(FeatureDetailRow, "FeatureDetailRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/featureDetailRow/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/featureDetailRow/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/featureDetailRow/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/featureDetailRow/index.js");
}();

;

/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactCollapsible = _interopRequireDefault(__webpack_require__(161));

var _ContainerHeader = _interopRequireDefault(__webpack_require__(63));

var _featureDetailTable = _interopRequireDefault(__webpack_require__(422));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var FeatureDependency = function FeatureDependency(_ref) {
  var dependencies = _ref.dependencies,
      title = _ref.title;

  if (dependencies && Array.isArray(dependencies) && dependencies.length > 0) {
    return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(_ContainerHeader["default"], {
      title: title
    }), _react["default"].createElement("div", {
      className: "row"
    }, _react["default"].createElement("div", {
      className: "col-md-12 col-sm-12 col-12"
    }, dependencies.map(function (dependency, index) {
      return _react["default"].createElement(_reactCollapsible["default"], {
        trigger: dependency === null || dependency === void 0 ? void 0 : dependency.name,
        key: index,
        triggerStyle: {
          afterTop: 2,
          backgroundColor: 'black',
          paddingTop: 8,
          paddingBottom: 8
        }
      }, _react["default"].createElement("div", {
        className: "col-sm-12 text-center text-sm-left"
      }, _react["default"].createElement(_featureDetailTable["default"], {
        displayData: dependency
      })));
    }))));
  } else {
    return _react["default"].createElement("div", {
      className: "row"
    }, _react["default"].createElement("div", {
      className: "col-md-12 col-12"
    }, _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(_ContainerHeader["default"], {
      title: title
    }), _react["default"].createElement("div", {
      className: "mr-auto"
    }, _react["default"].createElement("h3", {
      className: "card-heading"
    }, "No dependencies found here")))));
  }
};

var _default = FeatureDependency;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(FeatureDependency, "FeatureDependency", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/featureDependency/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/featureDependency/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/featureDependency/index.js");

  __REACT_HOT_LOADER__.register(_reactCollapsible, "_reactCollapsible", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/featureDependency/index.js");

  __REACT_HOT_LOADER__.register(_ContainerHeader, "_ContainerHeader", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/featureDependency/index.js");

  __REACT_HOT_LOADER__.register(_featureDetailTable, "_featureDetailTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/featureDependency/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/featureDependency/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/featureDependency/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/featureDependency/index.js");

  __REACT_HOT_LOADER__.register(FeatureDependency, "FeatureDependency", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/featureDependency/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/featureDependency/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/featureDependency/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureDetail/featureDependency/index.js");
}();

;

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

__webpack_require__(198);

var _moment = _interopRequireDefault(__webpack_require__(2));

var _Validation = __webpack_require__(14);

var _DateService = __webpack_require__(48);

var _feature = __webpack_require__(114);

var _common = __webpack_require__(821);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var FeatureEdit = function FeatureEdit() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var editFeatureState = (0, _reactRedux.useSelector)(function (state) {
    return state.features.editFeatureState;
  });
  var feature = (0, _reactRedux.useSelector)(function (state) {
    return state.features.selectedFeature;
  });

  var _useState = (0, _react.useState)(feature),
      _useState2 = _slicedToArray(_useState, 2),
      selectedFeature = _useState2[0],
      setSelectedFeature = _useState2[1];

  var _useState3 = (0, _react.useState)({
    name: '',
    description: '',
    initiative: ''
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      formErrors = _useState4[0],
      setFormErrors = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      formValid = _useState6[0],
      setFormValid = _useState6[1];

  var initiatives = (0, _reactRedux.useSelector)(function (state) {
    return state.initiatives.allInitiative;
  }); // using selectedFeature makes it behave like componentDidUpdate - effect takes place when selectedFeature changes

  (0, _react.useEffect)(function () {
    setSelectedFeature(feature);
    setFormValid(false);
    validateForm();
  }, [feature]); // using selectedFeature makes it behave like componentDidUpdate - effect takes place when selectedFeature changes

  (0, _react.useEffect)(function () {
    setFormValid(false);
    validateForm();
  }, [selectedFeature]);

  var handleUserInput = function handleUserInput(event) {
    var name = event.target.name;
    var value = event.target.value; // console.log('handleUserInput start '.concat(selectedFeature?.name).concat(' - ').concat(selectedFeature?.description).concat(' - ').concat(selectedFeature?.initiativeId).concat(' - '));

    updateSelectedFeatureField(name, value); // console.log('handleUserInput end '.concat(selectedFeature?.name).concat(' - ').concat(selectedFeature?.description).concat(' - ').concat(selectedFeature?.initiativeId).concat(' - '));

    validateField(name, value);
  };

  var handleDateInput = function handleDateInput(fieldName, value) {
    updateSelectedFeatureField(fieldName, value);
    validateForm();
  };

  var updateSelectedFeatureField = function updateSelectedFeatureField(fieldName, value) {
    var newFeature = _objectSpread({}, selectedFeature);

    newFeature[fieldName] = value;
    setSelectedFeature(newFeature);
  };

  var checkDatesValid = function checkDatesValid() {
    var fieldValidationErrors = formErrors;

    if ((0, _Validation.isValueEntered)(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.endDate) && (0, _Validation.isValueEntered)(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.startDate)) {
      // DayPickerInput gives a format that DateService does not like so utilise moment as the default before passing to the date check
      if ((0, _DateService.isDateBefore)((0, _moment["default"])(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.endDate), (0, _moment["default"])(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.startDate))) {
        fieldValidationErrors.dates = ' are invalid. The end date selected cannot be before the start date';
        setFormErrors(fieldValidationErrors);
        return false;
      }

      fieldValidationErrors.dates = '';
      setFormErrors(fieldValidationErrors);
      return true;
    }

    return true; // dates are not mandatory on features so dont return false - just check start is before end date
  };

  var validateField = function validateField(fieldName, value) {
    var valueEntered = (0, _Validation.isValueEntered)(value);
    formErrors[fieldName] = valueEntered ? '' : ' is invalid';
    setFormErrors(formErrors);
    validateForm();
  };

  var validateForm = function validateForm() {
    // console.log('validateForm '.concat(selectedFeature?.name).concat(' - ').concat(selectedFeature?.description).concat(' - ').concat(selectedFeature?.initiativeId).concat(' - '));
    // console.log('validateForm '.concat(isValueEntered(selectedFeature?.name) && checkDatesValid() && isValueEntered(selectedFeature?.description) && isValueEntered(selectedFeature?.initiativeId)));
    setFormValid((0, _Validation.isValueEntered)(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.name) && checkDatesValid() && (0, _Validation.isValueEntered)(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.initiativeId));
  };

  var maintainButton = function maintainButton(label) {
    return _react["default"].createElement(_reactstrap.Button, {
      className: "text-uppercase",
      disabled: !formValid,
      color: "primary",
      onClick: function onClick() {
        dispatch((0, _feature.showFeatureLoader)());
        dispatch((0, _feature.onFeatureClose)());
        dispatch((0, _feature.onSaveFeature)(selectedFeature));
        setFormValid(false);
      }
    }, label);
  };

  var modalHeaderOnClick = function modalHeaderOnClick() {
    return function () {
      setFormValid(false);
      dispatch((0, _feature.onFeatureClose)());
    };
  };

  var modalBody = function modalBody(buttonText) {
    return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
      className: "modal-box-content"
    }, _react["default"].createElement("div", {
      className: "row no-gutters"
    }, (0, _common.displayedImage)(selectedFeature), (0, _common.showErrors)(formErrors), (0, _common.inputFields)(selectedFeature, initiatives, handleUserInput, handleDateInput))), _react["default"].createElement("div", {
      className: "modal-box-footer d-flex flex-row"
    }, maintainButton(buttonText)));
  };

  return _react["default"].createElement(_reactstrap.Modal, {
    className: "modal-box",
    isOpen: editFeatureState
  }, (0, _common.modalHeader)(_react["default"].createElement(_IntlMessages["default"], {
    id: "feature.saveFeature"
  }), modalHeaderOnClick), modalBody(_react["default"].createElement(_IntlMessages["default"], {
    id: "feature.saveFeature"
  })));
};

var _default = FeatureEdit;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(FeatureEdit, "FeatureEdit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureEdit/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureEdit/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureEdit/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureEdit/index.js");

  __REACT_HOT_LOADER__.register(_moment, "_moment", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureEdit/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureEdit/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureEdit/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureEdit/index.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureEdit/index.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureEdit/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureEdit/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureEdit/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureEdit/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureEdit/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureEdit/index.js");

  __REACT_HOT_LOADER__.register(FeatureEdit, "FeatureEdit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureEdit/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureEdit/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureEdit/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureEdit/index.js");
}();

;

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _matchSorter = _interopRequireDefault(__webpack_require__(95));

var _reactTable = _interopRequireDefault(__webpack_require__(93));

__webpack_require__(94);

var _System = __webpack_require__(55);

var _ListRowCheckbox = _interopRequireDefault(__webpack_require__(107));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var SelectByIdTable = function SelectByIdTable(_ref) {
  var data = _ref.data,
      width = _ref.width,
      dispatchOnClick = _ref.dispatchOnClick;
  var smallWidth = width > _System.TIGHT_FIT_PARAM ? 50 : 50; // TODO see how this works

  var styledSummaryColumn = function styledSummaryColumn(value) {
    return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("span", {
      className: "d-inline-block text-black"
    }, _react["default"].createElement("div", {
      className: "font-weight-bold"
    }, value)));
  };

  var dispatch = (0, _reactRedux.useDispatch)();

  var styledActionColumn = function styledActionColumn(value) {
    return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(_ListRowCheckbox["default"], {
      selected: value === null || value === void 0 ? void 0 : value.selected,
      onClick: function onClick() {
        return dispatch(dispatchOnClick(value));
      }
    }));
  };

  var actionColumn = {
    id: 'action',
    accessor: function accessor(d) {
      return d;
    },
    Cell: function Cell(_ref2) {
      var value = _ref2.value;
      return styledActionColumn(value);
    },
    sortable: false,
    // need both sortable and filterable = false so col is not clickable
    filterable: false,
    width: smallWidth
  };
  var summaryColumn = {
    Header: 'Description',
    id: 'name',
    accessor: function accessor(d) {
      return d === null || d === void 0 ? void 0 : d.name;
    },
    filterMethod: function filterMethod(filter, rows) {
      return (0, _matchSorter["default"])(rows, filter.value, {
        keys: ['name']
      });
    },
    Cell: function Cell(_ref3) {
      var value = _ref3.value;
      return styledSummaryColumn(value);
    },
    filterAll: true
  };
  var columnsList = new Array();
  columnsList.push(actionColumn);
  columnsList.push(summaryColumn);
  return _react["default"].createElement("div", null, _react["default"].createElement(_reactTable["default"], {
    data: data,
    filterable: true,
    defaultFilterMethod: function defaultFilterMethod(filter, row) {
      return String(row[filter.id]) === filter.value;
    },
    columns: [{
      columns: columnsList
    }],
    defaultPageSize: (data === null || data === void 0 ? void 0 : data.length) <= 5 ? 5 : 10,
    className: "-highlight"
  }));
};

var _default = SelectByIdTable;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SelectByIdTable, "SelectByIdTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/selectByIdModal/selectByIdTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/selectByIdModal/selectByIdTable/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/selectByIdModal/selectByIdTable/index.js");

  __REACT_HOT_LOADER__.register(_matchSorter, "_matchSorter", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/selectByIdModal/selectByIdTable/index.js");

  __REACT_HOT_LOADER__.register(_reactTable, "_reactTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/selectByIdModal/selectByIdTable/index.js");

  __REACT_HOT_LOADER__.register(_ListRowCheckbox, "_ListRowCheckbox", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/selectByIdModal/selectByIdTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/selectByIdModal/selectByIdTable/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/selectByIdModal/selectByIdTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/selectByIdModal/selectByIdTable/index.js");

  __REACT_HOT_LOADER__.register(SelectByIdTable, "SelectByIdTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/selectByIdModal/selectByIdTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/selectByIdModal/selectByIdTable/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/selectByIdModal/selectByIdTable/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/selectByIdModal/selectByIdTable/index.js");
}();

;

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _matchSorter = _interopRequireDefault(__webpack_require__(95));

var _reactTable = _interopRequireDefault(__webpack_require__(93));

__webpack_require__(94);

var _DateFormatters = __webpack_require__(43);

var _System = __webpack_require__(55);

var _feature = __webpack_require__(114);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var FeatureTable = function FeatureTable() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var width = (0, _reactRedux.useSelector)(function (state) {
    return state.settings.width;
  });
  var featureList = (0, _reactRedux.useSelector)(function (state) {
    return state.features.featureList;
  });
  var selectedFeature = (0, _reactRedux.useSelector)(function (state) {
    return state.features.selectedFeature;
  });

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  (0, _react.useLayoutEffect)(function () {
    var selected = featureList.findIndex(function (entry) {
      return (entry === null || entry === void 0 ? void 0 : entry.id) === (selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.id);
    }) || 0;
    setSelected(selected);
  }, []);
  var defaultWidth = width > _System.TIGHT_FIT_PARAM ? 150 : 80;

  var styledSummaryColumn = function styledSummaryColumn(value) {
    return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("span", {
      className: "d-inline-block text-black"
    }, _react["default"].createElement("div", {
      className: "font-weight-bold"
    }, value)));
  };

  var priorityColumn = {
    Header: 'Priority',
    id: 'priority',
    accessor: function accessor(d) {
      return (d === null || d === void 0 ? void 0 : d.priority) || 'unknown';
    },
    filterMethod: function filterMethod(filter, rows) {
      return (0, _matchSorter["default"])(rows, filter.value, {
        keys: ['priority']
      });
    },
    filterAll: true,
    width: defaultWidth
  };
  var nameColumn = {
    Header: 'Name',
    id: 'name',
    accessor: function accessor(d) {
      return d === null || d === void 0 ? void 0 : d.name;
    },
    filterMethod: function filterMethod(filter, rows) {
      return (0, _matchSorter["default"])(rows, filter.value, {
        keys: ['name']
      });
    },
    Cell: function Cell(_ref) {
      var value = _ref.value;
      return styledSummaryColumn(value);
    },
    filterAll: true
  };
  var startDateColumn = {
    Header: 'Start Date',
    id: 'startDate',
    accessor: function accessor(d) {
      return d === null || d === void 0 ? void 0 : d.startDate;
    },
    filterMethod: function filterMethod(filter, rows) {
      return (0, _matchSorter["default"])(rows, filter.value, {
        keys: ['startDate']
      });
    },
    filterAll: true,
    Cell: function Cell(_ref2) {
      var value = _ref2.value;
      return (0, _DateFormatters.formatDateDefault)(value);
    },
    width: defaultWidth
  };
  var endDateColumn = {
    Header: 'End Date',
    id: 'endDate',
    accessor: function accessor(d) {
      return d === null || d === void 0 ? void 0 : d.endDate;
    },
    filterMethod: function filterMethod(filter, rows) {
      return (0, _matchSorter["default"])(rows, filter.value, {
        keys: ['endDate']
      });
    },
    filterAll: true,
    Cell: function Cell(_ref3) {
      var value = _ref3.value;
      return (0, _DateFormatters.formatDateDefault)(value);
    },
    width: defaultWidth
  };
  var columnsList = new Array();
  columnsList.push(nameColumn);

  if (width > _System.TIGHT_FIT_PARAM) {
    columnsList.push(priorityColumn);
    columnsList.push(startDateColumn);
    columnsList.push(endDateColumn);
  }

  return _react["default"].createElement("div", null, _react["default"].createElement(_reactTable["default"], {
    data: featureList,
    filterable: true,
    defaultFilterMethod: function defaultFilterMethod(filter, row) {
      return String(row[filter.id]) === filter.value;
    },
    columns: [{
      columns: columnsList
    }],
    defaultPageSize: 10,
    getTrProps: function getTrProps(state, rowInfo) {
      if (rowInfo && rowInfo.row) {
        return {
          onClick: function onClick() {
            var _rowInfo$original; // console.log(JSON.stringify(rowInfo?.index));


            dispatch((0, _feature.setFeature)(rowInfo === null || rowInfo === void 0 ? void 0 : (_rowInfo$original = rowInfo.original) === null || _rowInfo$original === void 0 ? void 0 : _rowInfo$original.id));
            setSelected(rowInfo.index);
          },
          style: {
            background: rowInfo.index === selected ? '#cfd8dc' : 'white',
            color: rowInfo.index === selected ? 'black' : 'black'
          }
        };
      } else {
        return {};
      }
    }
  }));
};

var _default = FeatureTable;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(FeatureTable, "FeatureTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureTable/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureTable/index.js");

  __REACT_HOT_LOADER__.register(_matchSorter, "_matchSorter", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureTable/index.js");

  __REACT_HOT_LOADER__.register(_reactTable, "_reactTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureTable/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureTable/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureTable/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureTable/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureTable/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureTable/index.js");

  __REACT_HOT_LOADER__.register(FeatureTable, "FeatureTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureTable/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureTable/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureTable/index.js");
}();

;

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

__webpack_require__(198);

var _moment = _interopRequireDefault(__webpack_require__(2));

var _Validation = __webpack_require__(14);

var _DateService = __webpack_require__(48);

var _feature = __webpack_require__(114);

var _common = __webpack_require__(821);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var FeatureAdd = function FeatureAdd() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var addFeatureState = (0, _reactRedux.useSelector)(function (state) {
    return state.features.addFeatureState;
  });

  var _useState = (0, _react.useState)(initProps),
      _useState2 = _slicedToArray(_useState, 2),
      selectedFeature = _useState2[0],
      setSelectedFeature = _useState2[1];

  var _useState3 = (0, _react.useState)({
    name: '',
    description: '',
    initiative: ''
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      formErrors = _useState4[0],
      setFormErrors = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      formValid = _useState6[0],
      setFormValid = _useState6[1];

  var initiatives = (0, _reactRedux.useSelector)(function (state) {
    return state.initiatives.allInitiative;
  });
  (0, _react.useEffect)(function () {
    setSelectedFeature(initProps());
  }, []); // using selectedFeature makes it behave like componentDidUpdate - effect takes place when selectedFeature changes

  (0, _react.useEffect)(function () {
    setFormValid(false);
    validateForm();
  }, [selectedFeature]);

  var initProps = function initProps() {
    return {
      id: '',
      orgid: '',
      name: '',
      description: '',
      priority: '',
      initiativeId: '',
      successIndicators: '',
      dependencies: [],
      startDate: '',
      endDate: '',
      starred: false,
      frequently: false
    };
  };

  var handleUserInput = function handleUserInput(event) {
    var name = event.target.name;
    var value = event.target.value; // console.log('handleUserInput start '.concat(selectedFeature?.name).concat(' - ').concat(selectedFeature?.description).concat(' - ').concat(selectedFeature?.initiativeId).concat(' - '));

    updateSelectedFeatureField(name, value); // console.log('handleUserInput end '.concat(selectedFeature?.name).concat(' - ').concat(selectedFeature?.description).concat(' - ').concat(selectedFeature?.initiativeId).concat(' - '));

    validateField(name, value);
  };

  var handleDateInput = function handleDateInput(fieldName, value) {
    updateSelectedFeatureField(fieldName, value);
    validateForm();
  };

  var updateSelectedFeatureField = function updateSelectedFeatureField(fieldName, value) {
    var newFeature = _objectSpread({}, selectedFeature);

    newFeature[fieldName] = value;
    setSelectedFeature(newFeature);
  };

  var checkDatesValid = function checkDatesValid() {
    var fieldValidationErrors = formErrors;

    if ((0, _Validation.isValueEntered)(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.endDate) && (0, _Validation.isValueEntered)(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.startDate)) {
      // DayPickerInput gives a format that DateService does not like so utilise moment as the default before passing to the date check
      if ((0, _DateService.isDateBefore)((0, _moment["default"])(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.endDate), (0, _moment["default"])(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.startDate))) {
        fieldValidationErrors.dates = ' are invalid. The end date selected cannot be before the start date';
        setFormErrors(fieldValidationErrors);
        return false;
      }

      fieldValidationErrors.dates = '';
      setFormErrors(fieldValidationErrors);
      return true;
    }

    return true; // dates are not mandatory on features so dont return false - just check start is before end date
  };

  var validateField = function validateField(fieldName, value) {
    var valueEntered = (0, _Validation.isValueEntered)(value);
    formErrors[fieldName] = valueEntered ? '' : ' is invalid';
    setFormErrors(formErrors);
    validateForm();
  };

  var validateForm = function validateForm() {
    // console.log('validateForm '.concat(selectedFeature?.name).concat(' - ').concat(selectedFeature?.description).concat(' - ').concat(selectedFeature?.initiativeId).concat(' - '));
    // console.log('validateForm '.concat(isValueEntered(selectedFeature?.name) && checkDatesValid() && isValueEntered(selectedFeature?.description) && isValueEntered(selectedFeature?.initiativeId)));
    setFormValid((0, _Validation.isValueEntered)(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.name) && checkDatesValid() && (0, _Validation.isValueEntered)(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.initiativeId));
  };

  var maintainButton = function maintainButton(label) {
    return _react["default"].createElement(_reactstrap.Button, {
      className: "text-uppercase",
      disabled: !formValid,
      color: "primary",
      onClick: function onClick() {
        dispatch((0, _feature.showFeatureLoader)());
        dispatch((0, _feature.onFeatureClose)());
        dispatch((0, _feature.onSaveFeature)(selectedFeature));
        setSelectedFeature(initProps());
        setFormValid(false);
      }
    }, label);
  };

  var modalHeaderOnClick = function modalHeaderOnClick() {
    return function () {
      setFormValid(false);
      dispatch((0, _feature.onFeatureClose)());
    };
  };

  var modalBody = function modalBody(buttonText) {
    return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
      className: "modal-box-content"
    }, _react["default"].createElement("div", {
      className: "row no-gutters"
    }, (0, _common.displayedImage)(selectedFeature), (0, _common.showErrors)(formErrors), (0, _common.inputFields)(selectedFeature, initiatives, handleUserInput, handleDateInput))), _react["default"].createElement("div", {
      className: "modal-box-footer d-flex flex-row"
    }, maintainButton(buttonText)));
  };

  return _react["default"].createElement(_reactstrap.Modal, {
    className: "modal-box",
    isOpen: addFeatureState
  }, (0, _common.modalHeader)(_react["default"].createElement(_IntlMessages["default"], {
    id: "feature.addFeature"
  }), modalHeaderOnClick), modalBody(_react["default"].createElement(_IntlMessages["default"], {
    id: "feature.addFeature"
  })));
};

var _default = FeatureAdd;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(FeatureAdd, "FeatureAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureAdd/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureAdd/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureAdd/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureAdd/index.js");

  __REACT_HOT_LOADER__.register(_moment, "_moment", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureAdd/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureAdd/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureAdd/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureAdd/index.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureAdd/index.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureAdd/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureAdd/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureAdd/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureAdd/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureAdd/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureAdd/index.js");

  __REACT_HOT_LOADER__.register(FeatureAdd, "FeatureAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureAdd/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureAdd/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureAdd/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/feature/featureMaintenance/featureAdd/index.js");
}();

;

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _component["default"];
  }
});

var _component = _interopRequireDefault(__webpack_require__(1939));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_component, "_component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/index.js");
}();

;

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _rcDrawer = _interopRequireDefault(__webpack_require__(31));

var _reactNotifications = __webpack_require__(30);

var _reactstrap = __webpack_require__(6);

var _valueStreamDetail = _interopRequireDefault(__webpack_require__(1940));

var _valueStreamTable = _interopRequireDefault(__webpack_require__(1942));

var _valueStreamAdd = _interopRequireDefault(__webpack_require__(1943));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _CircularProgress = _interopRequireDefault(__webpack_require__(24));

var _CustomScrollbars = _interopRequireDefault(__webpack_require__(27));

var _valueStream = __webpack_require__(115);

var _portfolio = __webpack_require__(113);

var _team = __webpack_require__(116);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Component = function Component() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var width = (0, _reactRedux.useSelector)(function (state) {
    return state.settings.width;
  });
  var loader = (0, _reactRedux.useSelector)(function (state) {
    return state.valueStreams.loader;
  });
  var alertMessage = (0, _reactRedux.useSelector)(function (state) {
    return state.valueStreams.alertMessage;
  });
  var showMessage = (0, _reactRedux.useSelector)(function (state) {
    return state.valueStreams.showMessage;
  });
  var noContentFoundMessage = (0, _reactRedux.useSelector)(function (state) {
    return state.valueStreams.noContentFoundMessage;
  });
  var drawerState = (0, _reactRedux.useSelector)(function (state) {
    return state.valueStreams.drawerState;
  });
  var valueStream = (0, _reactRedux.useSelector)(function (state) {
    return state.valueStreams.valueStream;
  });
  var valueStreamList = (0, _reactRedux.useSelector)(function (state) {
    return state.valueStreams.valueStreamList;
  });
  (0, _react.useEffect)(function () {
    dispatch((0, _valueStream.showValueStreamLoader)());
    dispatch((0, _valueStream.fetchValueStreams)());
    dispatch((0, _portfolio.fetchPortfolios)());
    dispatch((0, _team.fetchTeams)());
  }, []);

  var valueStreamSideBar = function valueStreamSideBar() {
    return _react["default"].createElement("div", {
      className: "module-side"
    }, _react["default"].createElement("div", {
      className: "module-side-header"
    }, _react["default"].createElement("div", {
      className: "module-logo"
    }, _react["default"].createElement("i", {
      className: "zmdi zmdi-city-alt mr-4"
    }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
      id: "sidebar.valueStreams"
    })))), _react["default"].createElement("div", {
      className: "module-side-content"
    }, _react["default"].createElement(_CustomScrollbars["default"], {
      className: "module-side-scroll scrollbar",
      style: {
        height: width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)'
      }
    }, _react["default"].createElement("div", {
      className: "module-add-task"
    }, _react["default"].createElement(_reactstrap.Button, {
      className: "btn-block jr-btn",
      color: "primary",
      onClick: function onClick() {
        return dispatch((0, _valueStream.onAddValueStream)());
      }
    }, _react["default"].createElement("i", {
      className: "zmdi zmdi-accounts-add zmdi-hc-fw"
    }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
      id: "valueStream.addValueStream"
    })))))));
  };

  var valueStreamRequestClose = function valueStreamRequestClose() {
    dispatch((0, _valueStream.handleValueStreamRequestClose)());
  };

  return _react["default"].createElement("div", {
    className: "app-wrapper"
  }, _react["default"].createElement("div", {
    className: "app-module animated slideInUpTiny animation-duration-3"
  }, _react["default"].createElement("div", {
    className: "d-block d-xl-none"
  }, _react["default"].createElement(_rcDrawer["default"], {
    touch: true,
    transitions: true,
    enableDragHandle: true,
    open: drawerState,
    onOpenChange: function onOpenChange() {
      return dispatch((0, _valueStream.onToggleValueStreamDrawer)());
    },
    sidebar: valueStreamSideBar(valueStream)
  })), _react["default"].createElement("div", {
    className: "app-module-sidenav d-none d-xl-flex"
  }, valueStreamSideBar(valueStream)), _react["default"].createElement("div", {
    className: "module-box"
  }, _react["default"].createElement("div", {
    className: "module-box-content"
  }, _react["default"].createElement("div", {
    className: "module-box-header"
  }, _react["default"].createElement("span", {
    className: "icon-btn drawer-btn d-flex d-xl-none",
    onClick: function onClick() {
      return dispatch((0, _valueStream.onToggleValueStreamDrawer)());
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-menu"
  }))), _react["default"].createElement(_CustomScrollbars["default"], {
    className: "module-list-scroll scrollbar",
    style: {
      height: width >= 1200 ? 'calc(108vh - 265px)' : 'calc(108vh - 245px)'
    }
  }, loader ? _react["default"].createElement("div", {
    className: "loader-view-block h-100"
  }, _react["default"].createElement("div", {
    className: "loader-view"
  }, _react["default"].createElement(_CircularProgress["default"], null))) : valueStreamList && valueStreamList.length > 0 ? _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
    className: "app-main-content"
  }, _react["default"].createElement(_valueStreamTable["default"], null), _react["default"].createElement("div", {
    style: {
      marginTop: 10
    }
  }, _react["default"].createElement(_valueStreamDetail["default"], null)))) : _react["default"].createElement("div", {
    className: "h-100 d-flex align-items-center justify-content-center"
  }, noContentFoundMessage))))), _react["default"].createElement(_valueStreamAdd["default"], null), showMessage && _reactNotifications.NotificationManager.success(alertMessage, valueStreamRequestClose()), _react["default"].createElement(_reactNotifications.NotificationContainer, null));
};

var _default = Component;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/component.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/component.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/component.js");

  __REACT_HOT_LOADER__.register(_rcDrawer, "_rcDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/component.js");

  __REACT_HOT_LOADER__.register(_valueStreamDetail, "_valueStreamDetail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/component.js");

  __REACT_HOT_LOADER__.register(_valueStreamTable, "_valueStreamTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/component.js");

  __REACT_HOT_LOADER__.register(_valueStreamAdd, "_valueStreamAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/component.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/component.js");

  __REACT_HOT_LOADER__.register(_CircularProgress, "_CircularProgress", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/component.js");

  __REACT_HOT_LOADER__.register(_CustomScrollbars, "_CustomScrollbars", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/component.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/component.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/component.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/component.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/component.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/component.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/component.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/component.js");
}();

;

/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _valueStreamDetailTable = _interopRequireDefault(__webpack_require__(823));

var _basicDetailDrillDown = _interopRequireDefault(__webpack_require__(423));

var _valueStreamEdit = _interopRequireDefault(__webpack_require__(1941));

var _valueStreamService = __webpack_require__(825);

var _selectByIdModal = _interopRequireDefault(__webpack_require__(301));

var _arrayService = __webpack_require__(34);

var _valueStream = __webpack_require__(115);

var _deleteItemCheck = _interopRequireDefault(__webpack_require__(227));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
} // import { TIGHT_FIT_PARAM } from 'constants/System';


var ValueStreamDetail = function ValueStreamDetail() {
  // const defaultWidth = width > TIGHT_FIT_PARAM ? 150 : 80;
  var dispatch = (0, _reactRedux.useDispatch)();
  var width = (0, _reactRedux.useSelector)(function (state) {
    return state.settings.width;
  });
  var allTeams = (0, _reactRedux.useSelector)(function (state) {
    return state.teams.allTeam;
  });
  var selectedOrg = (0, _reactRedux.useSelector)(function (state) {
    return state.orgs.selectedOrg;
  });
  var selectedValueStream = (0, _reactRedux.useSelector)(function (state) {
    return state.valueStreams.selectedValueStream;
  });
  var teamSelectionList = (0, _reactRedux.useSelector)(function (state) {
    return state.valueStreams.teamSelectionList;
  });

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      selectedTeams = _useState2[0],
      setSelectedTeams = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      displayData = _useState4[0],
      setDisplayData = _useState4[1];

  (0, _react.useEffect)(function () {
    // update the selectedTeams
    // TODO - do not fetch if no selected valueStream
    setSelectedTeams([]);
    var teams = (0, _arrayService.sameByIdValue)(allTeams, selectedValueStream === null || selectedValueStream === void 0 ? void 0 : selectedValueStream.teams);
    setSelectedTeams(teams);

    var fetchDisplayData =
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _valueStreamService.getValueStreamDisplayData)(selectedValueStream === null || selectedValueStream === void 0 ? void 0 : selectedValueStream.id, selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id);

              case 2:
                result = _context.sent;
                setDisplayData(result);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetchDisplayData() {
        return _ref.apply(this, arguments);
      };
    }();

    fetchDisplayData();
  }, [selectedValueStream]);

  var mainIcon = function mainIcon() {
    // TODO pass in type to change the icon on the detail tab
    // if (type && type.toLowerCase() === 'high') {
    //     return 'stream';
    // }
    // if (type && type.toLowerCase() === 'medium') {
    //     return 'compact';
    // }
    // if (type && type.toLowerCase() === 'low') {
    //     return 'module';
    // }
    return 'dashboard';
  };

  if (selectedValueStream) {
    return _react["default"].createElement("div", {
      className: "dashboard animated slideInUpTiny animation-duration-3"
    }, _react["default"].createElement("div", {
      className: "row"
    }, _react["default"].createElement("div", {
      className: "col-md-7 col-12"
    }, _react["default"].createElement("div", {
      className: "jr-card jr-card-full-height ml-2 mr-2"
    }, _react["default"].createElement("div", {
      className: "jr-card-header d-flex"
    }, _react["default"].createElement("div", {
      className: "mr-auto"
    }, _react["default"].createElement("h2", {
      className: "card-heading"
    }, displayData === null || displayData === void 0 ? void 0 : displayData.name)), _react["default"].createElement("div", null, _react["default"].createElement(_selectByIdModal["default"], {
      modalTitle: _react["default"].createElement(_IntlMessages["default"], {
        id: "valueStream.teams"
      }),
      onUpdateHandler: _valueStream.onValueStreamTeamUpdate,
      onSelectRowHandler: _valueStream.onValueStreamSelect,
      onClickButtonHandler: _valueStream.onFetchSelectTeamData,
      selectLoader: _valueStream.showValueStreamLoader,
      data: teamSelectionList,
      width: width,
      actionButtonTextId: _react["default"].createElement(_IntlMessages["default"], {
        id: "valueStream.teams"
      })
    }), _react["default"].createElement(_deleteItemCheck["default"], {
      id: selectedValueStream === null || selectedValueStream === void 0 ? void 0 : selectedValueStream.id,
      onConfirm: _valueStream.onDeleteValueStream,
      alertMessage: _react["default"].createElement(_IntlMessages["default"], {
        id: "valueStream.deleteValueStream"
      })
    }), _react["default"].createElement(_reactstrap.Button, {
      size: "sm",
      color: "primary",
      onClick: function onClick() {
        return dispatch((0, _valueStream.onEditValueStream)(selectedValueStream));
      }
    }, _react["default"].createElement("i", {
      className: "zmdi zmdi-edit zmdi-hc-fw"
    }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
      id: "label.edit"
    }))))), _react["default"].createElement("div", {
      className: "jr-card-body"
    }, _react["default"].createElement("div", {
      className: "row"
    }, _react["default"].createElement("div", {
      className: "col-sm-3"
    }, _react["default"].createElement("div", {
      className: "temp-section mb-4 mb-sm-0 text-center text-sm-left"
    }, _react["default"].createElement("p", null, _react["default"].createElement("i", {
      className: "detail-icon text-blue-grey zmdi zmdi-view-".concat(mainIcon(), " zmdi-hc-fw")
    })))), _react["default"].createElement("div", {
      className: "col-sm-9 text-center text-sm-left"
    }, _react["default"].createElement(_valueStreamDetailTable["default"], {
      displayData: displayData
    }))))), _react["default"].createElement(_valueStreamEdit["default"], null)), _react["default"].createElement("div", {
      className: "col-md-5"
    }, _react["default"].createElement("div", {
      className: "jr-card jr-card-full-height ml-2 mr-2"
    }, _react["default"].createElement(_basicDetailDrillDown["default"], {
      entries: selectedTeams,
      title: _react["default"].createElement(_IntlMessages["default"], {
        id: "valueStream.teams"
      })
    })))));
  } else {
    return _react["default"].createElement("div", {
      className: "dashboard animated slideInUpTiny animation-duration-3"
    }, _react["default"].createElement("div", {
      className: "row"
    }, _react["default"].createElement("div", {
      className: "col-md-12 col-12"
    }, _react["default"].createElement("div", {
      className: "jr-card jr-card-full-height"
    }, _react["default"].createElement("div", {
      className: "jr-card-header d-flex"
    }, _react["default"].createElement("div", {
      className: "mr-auto"
    }, _react["default"].createElement("h3", {
      className: "card-heading"
    }, "Please select an entry to display details")))))));
  }
};

var _default = ValueStreamDetail;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ValueStreamDetail, "ValueStreamDetail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamDetail/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamDetail/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamDetail/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamDetail/index.js");

  __REACT_HOT_LOADER__.register(_valueStreamDetailTable, "_valueStreamDetailTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamDetail/index.js");

  __REACT_HOT_LOADER__.register(_basicDetailDrillDown, "_basicDetailDrillDown", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamDetail/index.js");

  __REACT_HOT_LOADER__.register(_valueStreamEdit, "_valueStreamEdit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamDetail/index.js");

  __REACT_HOT_LOADER__.register(_selectByIdModal, "_selectByIdModal", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamDetail/index.js");

  __REACT_HOT_LOADER__.register(_deleteItemCheck, "_deleteItemCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamDetail/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamDetail/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamDetail/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamDetail/index.js");

  __REACT_HOT_LOADER__.register(asyncGeneratorStep, "asyncGeneratorStep", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamDetail/index.js");

  __REACT_HOT_LOADER__.register(_asyncToGenerator, "_asyncToGenerator", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamDetail/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamDetail/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamDetail/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamDetail/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamDetail/index.js");

  __REACT_HOT_LOADER__.register(ValueStreamDetail, "ValueStreamDetail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamDetail/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamDetail/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamDetail/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamDetail/index.js");
}();

;

/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _valueStream = __webpack_require__(115);

var _common = __webpack_require__(824);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ValueStreamEdit = function ValueStreamEdit() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var editValueStreamState = (0, _reactRedux.useSelector)(function (state) {
    return state.valueStreams.editValueStreamState;
  });
  var valueStream = (0, _reactRedux.useSelector)(function (state) {
    return state.valueStreams.selectedValueStream;
  });
  var portfolios = (0, _reactRedux.useSelector)(function (state) {
    return state.portfolios.allPortfolio;
  });

  var _useState = (0, _react.useState)(valueStream),
      _useState2 = _slicedToArray(_useState, 2),
      selectedValueStream = _useState2[0],
      setSelectedValueStream = _useState2[1];

  var _useState3 = (0, _react.useState)({
    name: ''
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      formErrors = _useState4[0],
      setFormErrors = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      formValid = _useState6[0],
      setFormValid = _useState6[1]; // using selectedValueStream makes it behave like componentDidUpdate - effect takes place when selectedValueStream changes


  (0, _react.useEffect)(function () {
    setSelectedValueStream(valueStream);
    setFormValid(false);
    validateForm();
    console.log('valueStreamEdit useEffect valueStream change');
  }, [valueStream]); // using selectedValueStream makes it behave like componentDidUpdate - effect takes place when selectedValueStream changes

  (0, _react.useEffect)(function () {
    setFormValid(false);
    validateForm();
    console.log('valueStreamEdit useEffect selectedValueStream change');
  }, [selectedValueStream]);

  var handleUserInput = function handleUserInput(event, isNumber) {
    var name = event.target.name;
    var value = event.target.value;

    if (isNumber) {
      value = Number(event.target.value);
    }

    updateSelectedValueStreamField(name, value);
    validateField(name, value);
  };

  var updateSelectedValueStreamField = function updateSelectedValueStreamField(fieldName, value) {
    var newValueStream = _objectSpread({}, selectedValueStream);

    newValueStream[fieldName] = value;
    setSelectedValueStream(newValueStream);
  };

  var validateField = function validateField(fieldName, value) {
    formErrors[fieldName] = (0, _common.getFormError)(fieldName, value);
    setFormErrors(formErrors);
    validateForm();
  };

  var validateForm = function validateForm() {
    setFormValid((0, _common.isFormValid)(selectedValueStream));
  };

  var maintainButton = function maintainButton(label) {
    return _react["default"].createElement(_reactstrap.Button, {
      className: "text-uppercase",
      disabled: !formValid,
      color: "primary",
      onClick: function onClick() {
        dispatch((0, _valueStream.showValueStreamLoader)());
        dispatch((0, _valueStream.onValueStreamClose)());
        dispatch((0, _valueStream.onSaveValueStream)(selectedValueStream));
        setFormValid(false);
      }
    }, label);
  };

  var modalHeaderOnClick = function modalHeaderOnClick() {
    return function () {
      setFormValid(false);
      dispatch((0, _valueStream.onValueStreamClose)());
    };
  };

  var modalBody = function modalBody(buttonText) {
    return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
      className: "modal-box-content"
    }, _react["default"].createElement("div", {
      className: "row no-gutters"
    }, (0, _common.displayedImage)(selectedValueStream), (0, _common.showErrors)(formErrors), (0, _common.inputFields)(selectedValueStream, portfolios, handleUserInput))), _react["default"].createElement("div", {
      className: "modal-box-footer d-flex flex-row"
    }, maintainButton(buttonText)));
  };

  return _react["default"].createElement(_reactstrap.Modal, {
    className: "modal-box",
    isOpen: editValueStreamState
  }, (0, _common.modalHeader)(_react["default"].createElement(_IntlMessages["default"], {
    id: "valueStream.saveValueStream"
  }), modalHeaderOnClick), modalBody(_react["default"].createElement(_IntlMessages["default"], {
    id: "valueStream.saveValueStream"
  })));
};

var _default = ValueStreamEdit;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ValueStreamEdit, "ValueStreamEdit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamEdit/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamEdit/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamEdit/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamEdit/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamEdit/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamEdit/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamEdit/index.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamEdit/index.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamEdit/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamEdit/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamEdit/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamEdit/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamEdit/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamEdit/index.js");

  __REACT_HOT_LOADER__.register(ValueStreamEdit, "ValueStreamEdit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamEdit/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamEdit/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamEdit/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamEdit/index.js");
}();

;

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _matchSorter = _interopRequireDefault(__webpack_require__(95));

var _reactTable = _interopRequireDefault(__webpack_require__(93));

__webpack_require__(94);

var _valueStream = __webpack_require__(115);

var _System = __webpack_require__(55);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ValueStreamTable = function ValueStreamTable() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var valueStreamList = (0, _reactRedux.useSelector)(function (state) {
    return state.valueStreams.valueStreamList;
  });
  var selectedValueStream = (0, _reactRedux.useSelector)(function (state) {
    return state.valueStreams.selectedValueStream;
  });
  var width = (0, _reactRedux.useSelector)(function (state) {
    return state.settings.width;
  });

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  (0, _react.useLayoutEffect)(function () {
    var selected = valueStreamList.findIndex(function (entry) {
      return (entry === null || entry === void 0 ? void 0 : entry.id) === (selectedValueStream === null || selectedValueStream === void 0 ? void 0 : selectedValueStream.id);
    }) || 0;
    setSelected(selected);
  }, []);

  var styledSummaryColumn = function styledSummaryColumn(value) {
    return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("span", {
      className: "d-inline-block text-black"
    }, _react["default"].createElement("div", {
      className: "font-weight-bold"
    }, value)));
  };

  var nameColumn = {
    Header: 'Name',
    id: 'name',
    accessor: function accessor(d) {
      return d === null || d === void 0 ? void 0 : d.name;
    },
    filterMethod: function filterMethod(filter, rows) {
      return (0, _matchSorter["default"])(rows, filter.value, {
        keys: ['name']
      });
    },
    Cell: function Cell(_ref) {
      var value = _ref.value;
      return styledSummaryColumn(value);
    },
    filterAll: true
  };
  var descColumn = {
    Header: 'Description',
    id: 'desc',
    accessor: function accessor(d) {
      return d === null || d === void 0 ? void 0 : d.description;
    },
    filterMethod: function filterMethod(filter, rows) {
      return (0, _matchSorter["default"])(rows, filter.value, {
        keys: ['desc']
      });
    },
    filterAll: true
  };
  var columnsList = new Array();
  columnsList.push(nameColumn);

  if (width > _System.TIGHT_FIT_PARAM) {
    columnsList.push(descColumn);
  }

  return _react["default"].createElement("div", {
    style: {
      marginLeft: '10px',
      marginRight: '10px'
    }
  }, _react["default"].createElement(_reactTable["default"], {
    data: valueStreamList,
    filterable: true,
    defaultFilterMethod: function defaultFilterMethod(filter, row) {
      return String(row[filter.id]) === filter.value;
    },
    columns: [{
      columns: columnsList
    }],
    defaultPageSize: 10,
    getTrProps: function getTrProps(state, rowInfo) {
      if (rowInfo && rowInfo.row) {
        return {
          onClick: function onClick() {
            var _rowInfo$original; // console.log(JSON.stringify(rowInfo?.index));


            dispatch((0, _valueStream.setValueStream)(rowInfo === null || rowInfo === void 0 ? void 0 : (_rowInfo$original = rowInfo.original) === null || _rowInfo$original === void 0 ? void 0 : _rowInfo$original.id));
            setSelected(rowInfo.index);
          },
          style: {
            background: rowInfo.index === selected ? '#cfd8dc' : 'white',
            color: rowInfo.index === selected ? 'black' : 'black'
          }
        };
      } else {
        return {};
      }
    }
  }));
};

var _default = ValueStreamTable;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ValueStreamTable, "ValueStreamTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamTable/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamTable/index.js");

  __REACT_HOT_LOADER__.register(_matchSorter, "_matchSorter", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamTable/index.js");

  __REACT_HOT_LOADER__.register(_reactTable, "_reactTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamTable/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamTable/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamTable/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamTable/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamTable/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamTable/index.js");

  __REACT_HOT_LOADER__.register(ValueStreamTable, "ValueStreamTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamTable/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamTable/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamTable/index.js");
}();

;

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _valueStream = __webpack_require__(115);

var _common = __webpack_require__(824);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ValueStreamAdd = function ValueStreamAdd() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var addValueStreamState = (0, _reactRedux.useSelector)(function (state) {
    return state.valueStreams.addValueStreamState;
  });
  var portfolios = (0, _reactRedux.useSelector)(function (state) {
    return state.portfolios.allPortfolio;
  });

  var _useState = (0, _react.useState)(initProps),
      _useState2 = _slicedToArray(_useState, 2),
      selectedValueStream = _useState2[0],
      setSelectedValueStream = _useState2[1];

  var _useState3 = (0, _react.useState)({
    name: '',
    budget: ''
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      formErrors = _useState4[0],
      setFormErrors = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      formValid = _useState6[0],
      setFormValid = _useState6[1];

  (0, _react.useEffect)(function () {
    setSelectedValueStream(initProps());
  }, [addValueStreamState]); // using selectedValueStream makes it behave like componentDidUpdate - effect takes place when selectedValueStream changes

  (0, _react.useEffect)(function () {
    setFormValid(false);
    validateForm();
  }, [selectedValueStream]);

  var initProps = function initProps() {
    return {
      id: '',
      orgid: '',
      name: '',
      description: '',
      teams: [],
      valueProposition: '',
      budget: 0,
      kpi: '',
      systems: '',
      owner: '',
      theme: '',
      starred: false,
      frequently: false
    };
  };

  var handleUserInput = function handleUserInput(event, isNumber) {
    var name = event.target.name;
    var value = event.target.value;

    if (isNumber) {
      value = Number(event.target.value);
    }

    updateSelectedValueStreamField(name, value);
    validateField(name, value);
  };

  var updateSelectedValueStreamField = function updateSelectedValueStreamField(fieldName, value) {
    var newValueStream = _objectSpread({}, selectedValueStream);

    newValueStream[fieldName] = value;
    setSelectedValueStream(newValueStream);
  };

  var validateField = function validateField(fieldName, value) {
    formErrors[fieldName] = (0, _common.getFormError)(fieldName, value);
    setFormErrors(formErrors);
    validateForm();
  };

  var validateForm = function validateForm() {
    setFormValid((0, _common.isFormValid)(selectedValueStream));
  };

  var maintainButton = function maintainButton(label) {
    return _react["default"].createElement(_reactstrap.Button, {
      className: "text-uppercase",
      disabled: !formValid,
      color: "primary",
      onClick: function onClick() {
        dispatch((0, _valueStream.showValueStreamLoader)());
        dispatch((0, _valueStream.onValueStreamClose)());
        dispatch((0, _valueStream.onSaveValueStream)(selectedValueStream));
        setSelectedValueStream(initProps());
        setFormValid(false);
      }
    }, label);
  };

  var modalHeaderOnClick = function modalHeaderOnClick() {
    return function () {
      setFormValid(false);
      dispatch((0, _valueStream.onValueStreamClose)());
    };
  };

  var modalBody = function modalBody(buttonText) {
    return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
      className: "modal-box-content"
    }, _react["default"].createElement("div", {
      className: "row no-gutters"
    }, (0, _common.displayedImage)(selectedValueStream), (0, _common.showErrors)(formErrors), (0, _common.inputFields)(selectedValueStream, portfolios, handleUserInput))), _react["default"].createElement("div", {
      className: "modal-box-footer d-flex flex-row"
    }, maintainButton(buttonText)));
  };

  return _react["default"].createElement(_reactstrap.Modal, {
    className: "modal-box",
    isOpen: addValueStreamState
  }, (0, _common.modalHeader)(_react["default"].createElement(_IntlMessages["default"], {
    id: "valueStream.addValueStream"
  }), modalHeaderOnClick), modalBody(_react["default"].createElement(_IntlMessages["default"], {
    id: "valueStream.addValueStream"
  })));
};

var _default = ValueStreamAdd;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ValueStreamAdd, "ValueStreamAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamAdd/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamAdd/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamAdd/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamAdd/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamAdd/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamAdd/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamAdd/index.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamAdd/index.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamAdd/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamAdd/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamAdd/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamAdd/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamAdd/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamAdd/index.js");

  __REACT_HOT_LOADER__.register(ValueStreamAdd, "ValueStreamAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamAdd/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamAdd/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamAdd/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/valueStream/valueStreamMaintenance/valueStreamAdd/index.js");
}();

;

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _component["default"];
  }
});

var _component = _interopRequireDefault(__webpack_require__(1945));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_component, "_component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/index.js");
}();

;

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _rcDrawer = _interopRequireDefault(__webpack_require__(31));

var _reactNotifications = __webpack_require__(30);

var _reactstrap = __webpack_require__(6);

var _memberList = _interopRequireDefault(__webpack_require__(1946));

var _index = _interopRequireDefault(__webpack_require__(66));

var _memberAdd = _interopRequireDefault(__webpack_require__(1949));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _CircularProgress = _interopRequireDefault(__webpack_require__(24));

var _CustomScrollbars = _interopRequireDefault(__webpack_require__(27));

var _member = __webpack_require__(100);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var filterOptions = [{
  id: 1,
  name: 'All members',
  icon: 'zmdi-menu'
}, {
  id: 2,
  name: 'Starred members',
  icon: 'zmdi-star'
}];

var Component = function Component() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var width = (0, _reactRedux.useSelector)(function (state) {
    return state.settings.width;
  });
  var loader = (0, _reactRedux.useSelector)(function (state) {
    return state.members.loader;
  });
  var alertMessage = (0, _reactRedux.useSelector)(function (state) {
    return state.members.alertMessage;
  });
  var showMessage = (0, _reactRedux.useSelector)(function (state) {
    return state.members.showMessage;
  });
  var noContentFoundMessage = (0, _reactRedux.useSelector)(function (state) {
    return state.members.noContentFoundMessage;
  });
  var drawerState = (0, _reactRedux.useSelector)(function (state) {
    return state.members.drawerState;
  });
  var member = (0, _reactRedux.useSelector)(function (state) {
    return state.members.member;
  });
  var searchMember = (0, _reactRedux.useSelector)(function (state) {
    return state.members.searchMember;
  });
  var memberList = (0, _reactRedux.useSelector)(function (state) {
    return state.members.memberList;
  });
  var selectedMembers = (0, _reactRedux.useSelector)(function (state) {
    return state.members.selectedMembers;
  });
  var addMemberState = (0, _reactRedux.useSelector)(function (state) {
    return state.members.addMemberState;
  });
  var selectedSectionId = (0, _reactRedux.useSelector)(function (state) {
    return state.members.selectedSectionId;
  });
  (0, _react.useEffect)(function () {
    dispatch((0, _member.showMemberLoader)());
    dispatch((0, _member.fetchMembers)());
  }, []);

  var onAllMemberSelect = function onAllMemberSelect() {
    var selectAll = selectedMembers < memberList.length;

    if (selectAll) {
      dispatch((0, _member.getAllMember)());
    } else {
      dispatch((0, _member.getUnselectedAllMember)());
    }
  };

  var updatingSearchMember = function updatingSearchMember(evt) {
    dispatch((0, _member.updateSearchMember)(evt.target.value));
    dispatch((0, _member.filterMember)(evt.target.value));
  };

  var memberRequestClose = function memberRequestClose() {
    dispatch((0, _member.handleMemberRequestClose)());
  };

  var memberSideBar = function memberSideBar() {
    return _react["default"].createElement("div", {
      className: "module-side"
    }, _react["default"].createElement("div", {
      className: "module-side-header"
    }, _react["default"].createElement("div", {
      className: "module-logo"
    }, _react["default"].createElement("i", {
      className: "zmdi zmdi-city-alt mr-4"
    }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
      id: "sidebar.members"
    })))), _react["default"].createElement("div", {
      className: "module-side-content"
    }, _react["default"].createElement(_CustomScrollbars["default"], {
      className: "module-side-scroll scrollbar",
      style: {
        height: width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)'
      }
    }, _react["default"].createElement("div", {
      className: "module-add-task"
    }, _react["default"].createElement(_reactstrap.Button, {
      className: "btn-block jr-btn",
      color: "primary",
      onClick: function onClick() {
        return dispatch((0, _member.onAddMember)());
      }
    }, _react["default"].createElement("i", {
      className: "zmdi zmdi-accounts-add zmdi-hc-fw"
    }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
      id: "member.addMember"
    })))), _react["default"].createElement("div", {
      className: "module-side-nav"
    }, _react["default"].createElement("ul", {
      className: "module-nav"
    }, filterOptions.map(function (option) {
      return _react["default"].createElement("li", {
        key: option.id,
        className: "nav-item"
      }, _react["default"].createElement("a", {
        href: "javascript:void(0)",
        className: option.id === selectedSectionId ? 'active' : '',
        onClick: function onClick() {
          return dispatch((0, _member.onFilterMemberOptionSelect)(option));
        }
      }, _react["default"].createElement("i", {
        className: "zmdi ".concat(option.icon)
      }), _react["default"].createElement("span", null, option.name)));
    }))))));
  };

  return _react["default"].createElement("div", {
    className: "app-wrapper"
  }, _react["default"].createElement("div", {
    className: "app-module animated slideInUpTiny animation-duration-3"
  }, _react["default"].createElement("div", {
    className: "d-block d-xl-none"
  }, _react["default"].createElement(_rcDrawer["default"], {
    touch: true,
    transitions: true,
    enableDragHandle: true,
    open: drawerState,
    onOpenChange: function onOpenChange() {
      return dispatch((0, _member.onToggleMemberDrawer)());
    },
    sidebar: memberSideBar(member)
  })), _react["default"].createElement("div", {
    className: "app-module-sidenav d-none d-xl-flex"
  }, memberSideBar(member)), _react["default"].createElement("div", {
    className: "module-box"
  }, _react["default"].createElement("div", {
    className: "module-box-header"
  }, _react["default"].createElement("span", {
    className: "icon-btn drawer-btn d-flex d-xl-none",
    onClick: function onClick() {
      return dispatch((0, _member.onToggleMemberDrawer)());
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-menu"
  })), _react["default"].createElement(_index["default"], {
    placeholder: "Search member",
    notification: false,
    apps: false,
    user: member,
    onChange: function onChange(event) {
      return updatingSearchMember(event);
    },
    value: searchMember
  })), _react["default"].createElement("div", {
    className: "module-box-content"
  }, _react["default"].createElement("div", {
    className: "module-box-topbar"
  }, _react["default"].createElement("div", {
    className: "form-control-checkbox d-flex"
  }, _react["default"].createElement("div", {
    className: "form-checkbox"
  }, _react["default"].createElement("input", {
    type: "checkbox",
    checked: selectedMembers > 0,
    onChange: onAllMemberSelect
  }), _react["default"].createElement("span", {
    className: "check"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-check zmdi-hc-lg"
  })))), _react["default"].createElement(_reactstrap.Button, {
    size: "sm",
    className: "jr-btn jr-flat-btn",
    color: "default",
    onClick: function onClick() {
      return dispatch((0, _member.onFilterSelectedMember)());
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-filter-list zmdi-hc-fw"
  }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.filter.selected"
  })))), _react["default"].createElement(_CustomScrollbars["default"], {
    className: "module-list-scroll scrollbar",
    style: {
      height: width >= 1200 ? 'calc(100vh - 265px)' : 'calc(100vh - 245px)'
    }
  }, loader ? _react["default"].createElement("div", {
    className: "loader-view-block h-100"
  }, _react["default"].createElement("div", {
    className: "loader-view"
  }, _react["default"].createElement(_CircularProgress["default"], null))) : memberList && memberList.length > 0 ? _react["default"].createElement(_memberList["default"], null) : _react["default"].createElement("div", {
    className: "h-100 d-flex align-items-center justify-content-center"
  }, noContentFoundMessage))))), _react["default"].createElement(_memberAdd["default"], {
    open: addMemberState
  }), showMessage && _reactNotifications.NotificationManager.success(alertMessage, memberRequestClose()), _react["default"].createElement(_reactNotifications.NotificationContainer, null));
};

var _default = Component;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(filterOptions, "filterOptions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/component.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/component.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/component.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/component.js");

  __REACT_HOT_LOADER__.register(_rcDrawer, "_rcDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/component.js");

  __REACT_HOT_LOADER__.register(_memberList, "_memberList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/component.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/component.js");

  __REACT_HOT_LOADER__.register(_memberAdd, "_memberAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/component.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/component.js");

  __REACT_HOT_LOADER__.register(_CircularProgress, "_CircularProgress", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/component.js");

  __REACT_HOT_LOADER__.register(_CustomScrollbars, "_CustomScrollbars", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/component.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/component.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/component.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/component.js");

  __REACT_HOT_LOADER__.register(filterOptions, "filterOptions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/component.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/component.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/component.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/component.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/component.js");
}();

;

/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _index = _interopRequireDefault(__webpack_require__(1947));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var MemberList = function MemberList() {
  var memberList = (0, _reactRedux.useSelector)(function (state) {
    return state.members.memberList;
  });
  return _react["default"].createElement("div", {
    className: "app-main-content"
  }, memberList.map(function (entry, index) {
    return _react["default"].createElement(_index["default"], {
      key: index,
      member: entry
    });
  }));
};

var _default = MemberList;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MemberList, "MemberList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberList/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberList/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberList/index.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberList/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberList/index.js");

  __REACT_HOT_LOADER__.register(MemberList, "MemberList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberList/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberList/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberList/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberList/index.js");
}();

;

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _store = __webpack_require__(54);

var _reactBootstrapSweetalert = _interopRequireDefault(__webpack_require__(80));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _listRowImage = _interopRequireDefault(__webpack_require__(126));

var _ListRowFavourite = _interopRequireDefault(__webpack_require__(127));

var _ListRowCheckbox = _interopRequireDefault(__webpack_require__(107));

var _ListRowData = _interopRequireDefault(__webpack_require__(129));

var _ListRowDropdown = _interopRequireDefault(__webpack_require__(128));

var _index = _interopRequireDefault(__webpack_require__(1948));

var _member = __webpack_require__(100);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var MemberRow = function MemberRow(props) {
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      menuState = _useState2[0],
      setMenuState = _useState2[1];

  var _useState3 = (0, _react.useState)(props.member),
      _useState4 = _slicedToArray(_useState3, 2),
      member = _useState4[0],
      setMember = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      deleteMemberCheck = _useState6[0],
      setDeleteMemberCheck = _useState6[1];

  var width = (0, _reactRedux.useSelector)(function (state) {
    return state.settings.width;
  }); // const { member } = props;

  (0, _react.useEffect)(function () {
    setMember(props.member);
  }, [props]);
  var name = member.name,
      starred = member.starred;
  var options = ['Edit', 'Delete'];

  var memberOptionToggle = function memberOptionToggle() {
    setMenuState(!menuState);
  };

  var deleteMember = function deleteMember(member) {
    dispatch((0, _member.onDeleteMember)(member === null || member === void 0 ? void 0 : member.id));
  };

  var editMember = function editMember() {
    setMenuState(false);
    dispatch((0, _member.onEditMember)(member));
  };

  return _react["default"].createElement("div", {
    className: "contact-item"
  }, _react["default"].createElement(_ListRowCheckbox["default"], {
    selected: member.selected,
    onClick: function onClick() {
      return dispatch((0, _member.onMemberSelect)(member));
    }
  }), _react["default"].createElement(_ListRowFavourite["default"], {
    width: width,
    onClick: function onClick() {
      return dispatch((0, _member.addFavouriteMember)(member));
    },
    starred: starred
  }), _react["default"].createElement(_listRowImage["default"], {
    width: width,
    data: member
  }), _react["default"].createElement(_ListRowData["default"], {
    lineOne: name
  }), _react["default"].createElement(_ListRowDropdown["default"], {
    menuState: menuState,
    toggle: memberOptionToggle,
    options: options,
    dropdownItems: options.map(function (option) {
      return _react["default"].createElement(_reactstrap.DropdownItem, {
        key: option,
        onClick: function onClick() {
          if (option === 'Edit') {
            editMember();
          } else if (option === 'Delete') {
            setDeleteMemberCheck(true);
          }
        }
      }, option);
    })
  }), _react["default"].createElement("div", null, _react["default"].createElement(_index["default"], null)), _react["default"].createElement(_reactBootstrapSweetalert["default"], {
    show: deleteMemberCheck,
    warning: true,
    showCancel: true,
    confirmBtnText: _react["default"].createElement(_IntlMessages["default"], {
      id: "button.yesDeleteIt"
    }),
    cancelBtnText: _react["default"].createElement(_IntlMessages["default"], {
      id: "button.cancel"
    }),
    confirmBtnBsStyle: "danger",
    cancelBtnBsStyle: "default",
    title: _react["default"].createElement("span", {
      style: {
        fontWeight: 'bold',
        color: 'grey',
        fontSize: '200%'
      }
    }, _react["default"].createElement(_IntlMessages["default"], {
      id: "general.areYouSure"
    })),
    onConfirm: function onConfirm() {
      deleteMember(member);
      setDeleteMemberCheck(false);
    },
    onCancel: function onCancel() {
      setDeleteMemberCheck(false);
    }
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "member.deleteMember"
  })));
};

var _default = MemberRow;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MemberRow, "MemberRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberList/memberRow/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberList/memberRow/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberList/memberRow/index.js");

  __REACT_HOT_LOADER__.register(_reactBootstrapSweetalert, "_reactBootstrapSweetalert", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberList/memberRow/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberList/memberRow/index.js");

  __REACT_HOT_LOADER__.register(_listRowImage, "_listRowImage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberList/memberRow/index.js");

  __REACT_HOT_LOADER__.register(_ListRowFavourite, "_ListRowFavourite", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberList/memberRow/index.js");

  __REACT_HOT_LOADER__.register(_ListRowCheckbox, "_ListRowCheckbox", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberList/memberRow/index.js");

  __REACT_HOT_LOADER__.register(_ListRowData, "_ListRowData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberList/memberRow/index.js");

  __REACT_HOT_LOADER__.register(_ListRowDropdown, "_ListRowDropdown", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberList/memberRow/index.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberList/memberRow/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberList/memberRow/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberList/memberRow/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberList/memberRow/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberList/memberRow/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberList/memberRow/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberList/memberRow/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberList/memberRow/index.js");

  __REACT_HOT_LOADER__.register(MemberRow, "MemberRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberList/memberRow/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberList/memberRow/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberList/memberRow/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberList/memberRow/index.js");
}();

;

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _member = __webpack_require__(100);

var _common = __webpack_require__(826);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var MemberEdit = function MemberEdit() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var editMemberState = (0, _reactRedux.useSelector)(function (state) {
    return state.members.editMemberState;
  });
  var member = (0, _reactRedux.useSelector)(function (state) {
    return state.members.selectedMember;
  });

  var _useState = (0, _react.useState)(member),
      _useState2 = _slicedToArray(_useState, 2),
      selectedMember = _useState2[0],
      setSelectedMember = _useState2[1];

  var _useState3 = (0, _react.useState)({
    name: ''
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      formErrors = _useState4[0],
      setFormErrors = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      formValid = _useState6[0],
      setFormValid = _useState6[1]; // using selectedMember makes it behave like componentDidUpdate - effect takes place when selectedMember changes


  (0, _react.useEffect)(function () {
    setSelectedMember(member);
    setFormValid(false);
    validateForm();
  }, [member]); // using selectedMember makes it behave like componentDidUpdate - effect takes place when selectedMember changes

  (0, _react.useEffect)(function () {
    setFormValid(false);
    validateForm();
  }, [selectedMember]);

  var handleUserInput = function handleUserInput(event, isNumber) {
    var name = event.target.name;
    var value = event.target.value;

    if (isNumber) {
      value = Number(event.target.value);
    }

    updateSelectedMemberField(name, value);
    validateField(name, value);
  };

  var updateSelectedMemberField = function updateSelectedMemberField(fieldName, value) {
    var newMember = _objectSpread({}, member);

    newMember[fieldName] = value;
    setSelectedMember(newMember);
  };

  var validateField = function validateField(fieldName, value) {
    formErrors[fieldName] = (0, _common.getFormError)(fieldName, value);
    setFormErrors(formErrors);
    validateForm();
  };

  var validateForm = function validateForm() {
    setFormValid((0, _common.isFormValid)(selectedMember));
  };

  var maintainButton = function maintainButton(label) {
    return _react["default"].createElement(_reactstrap.Button, {
      className: "text-uppercase",
      disabled: !formValid,
      color: "primary",
      onClick: function onClick() {
        dispatch((0, _member.showMemberLoader)());
        dispatch((0, _member.onMemberClose)());
        dispatch((0, _member.onSaveMember)(selectedMember));
        setFormValid(false);
      }
    }, label);
  };

  var modalHeaderOnClick = function modalHeaderOnClick() {
    return function () {
      setFormValid(false);
      dispatch((0, _member.onMemberClose)());
    };
  };

  var modalBody = function modalBody(buttonText) {
    return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
      className: "modal-box-content"
    }, _react["default"].createElement("div", {
      className: "row no-gutters"
    }, (0, _common.displayedImage)(selectedMember), (0, _common.showErrors)(formErrors), (0, _common.inputFields)(member, handleUserInput))), _react["default"].createElement("div", {
      className: "modal-box-footer d-flex flex-row"
    }, maintainButton(buttonText)));
  };

  return _react["default"].createElement(_reactstrap.Modal, {
    className: "modal-box",
    isOpen: editMemberState
  }, (0, _common.modalHeader)(_react["default"].createElement(_IntlMessages["default"], {
    id: "member.saveMember"
  }), modalHeaderOnClick), modalBody(_react["default"].createElement(_IntlMessages["default"], {
    id: "member.saveMember"
  })));
};

var _default = MemberEdit;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MemberEdit, "MemberEdit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberEdit/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberEdit/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberEdit/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberEdit/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberEdit/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberEdit/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberEdit/index.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberEdit/index.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberEdit/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberEdit/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberEdit/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberEdit/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberEdit/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberEdit/index.js");

  __REACT_HOT_LOADER__.register(MemberEdit, "MemberEdit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberEdit/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberEdit/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberEdit/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberEdit/index.js");
}();

;

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _member = __webpack_require__(100);

var _common = __webpack_require__(826);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var MemberAdd = function MemberAdd() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var addMemberState = (0, _reactRedux.useSelector)(function (state) {
    return state.members.addMemberState;
  });

  var _useState = (0, _react.useState)(initProps),
      _useState2 = _slicedToArray(_useState, 2),
      selectedMember = _useState2[0],
      setSelectedMember = _useState2[1];

  var _useState3 = (0, _react.useState)({
    name: ''
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      formErrors = _useState4[0],
      setFormErrors = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      formValid = _useState6[0],
      setFormValid = _useState6[1];

  (0, _react.useEffect)(function () {
    setSelectedMember(initProps());
  }, [addMemberState]); // using selectedMember makes it behave like componentDidUpdate - effect takes place when selectedMember changes

  (0, _react.useEffect)(function () {
    setFormValid(false);
    validateForm();
  }, [selectedMember]);

  var initProps = function initProps() {
    return {
      id: '',
      orgid: '',
      name: '',
      description: '',
      starred: false,
      frequently: false
    };
  };

  var handleUserInput = function handleUserInput(event, isNumber) {
    var name = event.target.name;
    var value = event.target.value;

    if (isNumber) {
      value = Number(event.target.value);
    }

    updateSelectedMemberField(name, value);
    validateField(name, value);
  };

  var updateSelectedMemberField = function updateSelectedMemberField(fieldName, value) {
    var newMember = _objectSpread({}, selectedMember);

    newMember[fieldName] = value;
    setSelectedMember(newMember);
  };

  var validateField = function validateField(fieldName, value) {
    formErrors[fieldName] = (0, _common.getFormError)(fieldName, value);
    setFormErrors(formErrors);
    validateForm();
  };

  var validateForm = function validateForm() {
    setFormValid((0, _common.isFormValid)(selectedMember));
  };

  var maintainButton = function maintainButton(label) {
    return _react["default"].createElement(_reactstrap.Button, {
      className: "text-uppercase",
      disabled: !formValid,
      color: "primary",
      onClick: function onClick() {
        dispatch((0, _member.showMemberLoader)());
        dispatch((0, _member.onMemberClose)());
        dispatch((0, _member.onSaveMember)(selectedMember));
        setSelectedMember(initProps());
        setFormValid(false);
      }
    }, label);
  };

  var modalHeaderOnClick = function modalHeaderOnClick() {
    return function () {
      setFormValid(false);
      dispatch((0, _member.onMemberClose)());
    };
  };

  var modalBody = function modalBody(buttonText) {
    return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
      className: "modal-box-content"
    }, _react["default"].createElement("div", {
      className: "row no-gutters"
    }, (0, _common.displayedImage)(selectedMember), (0, _common.showErrors)(formErrors), (0, _common.inputFields)(selectedMember, handleUserInput))), _react["default"].createElement("div", {
      className: "modal-box-footer d-flex flex-row"
    }, maintainButton(buttonText)));
  };

  return _react["default"].createElement(_reactstrap.Modal, {
    className: "modal-box",
    isOpen: addMemberState
  }, (0, _common.modalHeader)(_react["default"].createElement(_IntlMessages["default"], {
    id: "member.addMember"
  }), modalHeaderOnClick), modalBody(_react["default"].createElement(_IntlMessages["default"], {
    id: "member.addMember"
  })));
};

var _default = MemberAdd;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MemberAdd, "MemberAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberAdd/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberAdd/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberAdd/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberAdd/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberAdd/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberAdd/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberAdd/index.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberAdd/index.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberAdd/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberAdd/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberAdd/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberAdd/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberAdd/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberAdd/index.js");

  __REACT_HOT_LOADER__.register(MemberAdd, "MemberAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberAdd/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberAdd/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberAdd/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/member/memberMaintenance/memberAdd/index.js");
}();

;

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _component["default"];
  }
});

var _component = _interopRequireDefault(__webpack_require__(1951));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_component, "_component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/index.js");
}();

;

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _rcDrawer = _interopRequireDefault(__webpack_require__(31));

var _reactNotifications = __webpack_require__(30);

var _reactstrap = __webpack_require__(6);

var _teamDetail = _interopRequireDefault(__webpack_require__(1952));

var _teamTable = _interopRequireDefault(__webpack_require__(1956));

var _teamAdd = _interopRequireDefault(__webpack_require__(1957));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _CircularProgress = _interopRequireDefault(__webpack_require__(24));

var _CustomScrollbars = _interopRequireDefault(__webpack_require__(27));

var _team = __webpack_require__(116);

var _member = __webpack_require__(100);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Component = function Component() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var width = (0, _reactRedux.useSelector)(function (state) {
    return state.settings.width;
  });
  var loader = (0, _reactRedux.useSelector)(function (state) {
    return state.teams.loader;
  });
  var alertMessage = (0, _reactRedux.useSelector)(function (state) {
    return state.teams.alertMessage;
  });
  var showMessage = (0, _reactRedux.useSelector)(function (state) {
    return state.teams.showMessage;
  });
  var noContentFoundMessage = (0, _reactRedux.useSelector)(function (state) {
    return state.teams.noContentFoundMessage;
  });
  var drawerState = (0, _reactRedux.useSelector)(function (state) {
    return state.teams.drawerState;
  });
  var team = (0, _reactRedux.useSelector)(function (state) {
    return state.teams.team;
  });
  var teamList = (0, _reactRedux.useSelector)(function (state) {
    return state.teams.teamList;
  });
  (0, _react.useEffect)(function () {
    dispatch((0, _team.showTeamLoader)());
    dispatch((0, _team.fetchTeams)());
    dispatch((0, _member.fetchMembers)());
  }, []);

  var teamSideBar = function teamSideBar() {
    return _react["default"].createElement("div", {
      className: "module-side"
    }, _react["default"].createElement("div", {
      className: "module-side-header"
    }, _react["default"].createElement("div", {
      className: "module-logo"
    }, _react["default"].createElement("i", {
      className: "zmdi zmdi-city-alt mr-4"
    }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
      id: "sidebar.teams"
    })))), _react["default"].createElement("div", {
      className: "module-side-content"
    }, _react["default"].createElement(_CustomScrollbars["default"], {
      className: "module-side-scroll scrollbar",
      style: {
        height: width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)'
      }
    }, _react["default"].createElement("div", {
      className: "module-add-task"
    }, _react["default"].createElement(_reactstrap.Button, {
      className: "btn-block jr-btn",
      color: "primary",
      onClick: function onClick() {
        return dispatch((0, _team.onAddTeam)());
      }
    }, _react["default"].createElement("i", {
      className: "zmdi zmdi-accounts-add zmdi-hc-fw"
    }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
      id: "team.addTeam"
    })))))));
  };

  var teamRequestClose = function teamRequestClose() {
    dispatch((0, _team.handleTeamRequestClose)());
  };

  return _react["default"].createElement("div", {
    className: "app-wrapper"
  }, _react["default"].createElement("div", {
    className: "app-module animated slideInUpTiny animation-duration-3"
  }, _react["default"].createElement("div", {
    className: "d-block d-xl-none"
  }, _react["default"].createElement(_rcDrawer["default"], {
    touch: true,
    transitions: true,
    enableDragHandle: true,
    open: drawerState,
    onOpenChange: function onOpenChange() {
      return dispatch((0, _team.onToggleTeamDrawer)());
    },
    sidebar: teamSideBar(team)
  })), _react["default"].createElement("div", {
    className: "app-module-sidenav d-none d-xl-flex"
  }, teamSideBar(team)), _react["default"].createElement("div", {
    className: "module-box"
  }, _react["default"].createElement("div", {
    className: "module-box-content"
  }, _react["default"].createElement("div", {
    className: "module-box-header"
  }, _react["default"].createElement("span", {
    className: "icon-btn drawer-btn d-flex d-xl-none",
    onClick: function onClick() {
      return dispatch((0, _team.onToggleTeamDrawer)());
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-menu"
  }))), _react["default"].createElement(_CustomScrollbars["default"], {
    className: "module-list-scroll scrollbar",
    style: {
      height: width >= 1200 ? 'calc(108vh - 265px)' : 'calc(108vh - 245px)'
    }
  }, loader ? _react["default"].createElement("div", {
    className: "loader-view-block h-100"
  }, _react["default"].createElement("div", {
    className: "loader-view"
  }, _react["default"].createElement(_CircularProgress["default"], null))) : teamList && teamList.length > 0 ? _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
    className: "app-main-content"
  }, _react["default"].createElement(_teamTable["default"], null), _react["default"].createElement("div", {
    style: {
      marginTop: 10
    }
  }, _react["default"].createElement(_teamDetail["default"], null)))) : _react["default"].createElement("div", {
    className: "h-100 d-flex align-items-center justify-content-center"
  }, noContentFoundMessage))))), _react["default"].createElement(_teamAdd["default"], null), showMessage && _reactNotifications.NotificationManager.success(alertMessage, teamRequestClose()), _react["default"].createElement(_reactNotifications.NotificationContainer, null));
};

var _default = Component;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/component.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/component.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/component.js");

  __REACT_HOT_LOADER__.register(_rcDrawer, "_rcDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/component.js");

  __REACT_HOT_LOADER__.register(_teamDetail, "_teamDetail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/component.js");

  __REACT_HOT_LOADER__.register(_teamTable, "_teamTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/component.js");

  __REACT_HOT_LOADER__.register(_teamAdd, "_teamAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/component.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/component.js");

  __REACT_HOT_LOADER__.register(_CircularProgress, "_CircularProgress", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/component.js");

  __REACT_HOT_LOADER__.register(_CustomScrollbars, "_CustomScrollbars", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/component.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/component.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/component.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/component.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/component.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/component.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/component.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/component.js");
}();

;

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _teamDetailTable = _interopRequireDefault(__webpack_require__(1953));

var _basicDetailDrillDown = _interopRequireDefault(__webpack_require__(423));

var _teamEdit = _interopRequireDefault(__webpack_require__(1954));

var _teamService = __webpack_require__(1955);

var _selectByIdModal = _interopRequireDefault(__webpack_require__(301));

var _arrayService = __webpack_require__(34);

var _team = __webpack_require__(116);

var _deleteItemCheck = _interopRequireDefault(__webpack_require__(227));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
} // import { TIGHT_FIT_PARAM } from 'constants/System';


var TeamDetail = function TeamDetail() {
  // const defaultWidth = width > TIGHT_FIT_PARAM ? 150 : 80;
  var dispatch = (0, _reactRedux.useDispatch)();
  var width = (0, _reactRedux.useSelector)(function (state) {
    return state.settings.width;
  });
  var allMembers = (0, _reactRedux.useSelector)(function (state) {
    return state.members.allMember;
  });
  var selectedTeam = (0, _reactRedux.useSelector)(function (state) {
    return state.teams.selectedTeam;
  });
  var memberSelectionList = (0, _reactRedux.useSelector)(function (state) {
    return state.teams.memberSelectionList;
  });

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      selectedMembers = _useState2[0],
      setSelectedMembers = _useState2[1];

  (0, _react.useEffect)(function () {
    // update the selectedMembers
    setSelectedMembers([]);
    var members = (0, _arrayService.sameByIdValue)(allMembers, selectedTeam === null || selectedTeam === void 0 ? void 0 : selectedTeam.members);
    setSelectedMembers(members);
  }, [selectedTeam]);

  var mainIcon = function mainIcon() {
    // TODO pass in type to change the icon on the detail tab
    // if (type && type.toLowerCase() === 'high') {
    //     return 'stream';
    // }
    // if (type && type.toLowerCase() === 'medium') {
    //     return 'compact';
    // }
    // if (type && type.toLowerCase() === 'low') {
    //     return 'module';
    // }
    return 'dashboard';
  };

  if (selectedTeam) {
    // const fields = { ...selectedTeam?.fields };
    var displayData = (0, _teamService.getDisplayData)(selectedTeam);
    return _react["default"].createElement("div", {
      className: "dashboard animated slideInUpTiny animation-duration-3"
    }, _react["default"].createElement("div", {
      className: "row"
    }, _react["default"].createElement("div", {
      className: "col-md-7 col-12"
    }, _react["default"].createElement("div", {
      className: "jr-card jr-card-full-height ml-2 mr-2"
    }, _react["default"].createElement("div", {
      className: "jr-card-header d-flex"
    }, _react["default"].createElement("div", {
      className: "mr-auto"
    }, _react["default"].createElement("h2", {
      className: "card-heading"
    }, displayData === null || displayData === void 0 ? void 0 : displayData.name)), _react["default"].createElement("div", null, _react["default"].createElement(_selectByIdModal["default"], {
      modalTitle: _react["default"].createElement(_IntlMessages["default"], {
        id: "team.members"
      }),
      onUpdateHandler: _team.onTeamMemberUpdate,
      onSelectRowHandler: _team.onTeamSelect,
      onClickButtonHandler: _team.onFetchSelectMemberData,
      selectLoader: _team.showTeamLoader,
      data: memberSelectionList,
      width: width,
      actionButtonTextId: _react["default"].createElement(_IntlMessages["default"], {
        id: "team.members"
      })
    }), _react["default"].createElement(_deleteItemCheck["default"], {
      id: selectedTeam === null || selectedTeam === void 0 ? void 0 : selectedTeam.id,
      onConfirm: _team.onDeleteTeam,
      alertMessage: _react["default"].createElement(_IntlMessages["default"], {
        id: "team.deleteTeam"
      })
    }), _react["default"].createElement(_reactstrap.Button, {
      size: "sm",
      color: "primary",
      onClick: function onClick() {
        return dispatch((0, _team.onEditTeam)(selectedTeam));
      }
    }, _react["default"].createElement("i", {
      className: "zmdi zmdi-edit zmdi-hc-fw"
    }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
      id: "label.edit"
    }))))), _react["default"].createElement("div", {
      className: "jr-card-body"
    }, _react["default"].createElement("div", {
      className: "row"
    }, _react["default"].createElement("div", {
      className: "col-sm-3"
    }, _react["default"].createElement("div", {
      className: "temp-section mb-4 mb-sm-0 text-center text-sm-left"
    }, _react["default"].createElement("p", null, _react["default"].createElement("i", {
      className: "detail-icon text-blue-grey zmdi zmdi-view-".concat(mainIcon(), " zmdi-hc-fw")
    })))), _react["default"].createElement("div", {
      className: "col-sm-9 text-center text-sm-left"
    }, _react["default"].createElement(_teamDetailTable["default"], {
      displayData: displayData
    }))))), _react["default"].createElement(_teamEdit["default"], null)), _react["default"].createElement("div", {
      className: "col-md-5"
    }, _react["default"].createElement("div", {
      className: "jr-card jr-card-full-height mr-2 ml-2"
    }, _react["default"].createElement(_basicDetailDrillDown["default"], {
      entries: selectedMembers,
      title: _react["default"].createElement(_IntlMessages["default"], {
        id: "team.members"
      })
    })))));
  } else {
    return _react["default"].createElement("div", {
      className: "dashboard animated slideInUpTiny animation-duration-3"
    }, _react["default"].createElement("div", {
      className: "row"
    }, _react["default"].createElement("div", {
      className: "col-md-12 col-12"
    }, _react["default"].createElement("div", {
      className: "jr-card jr-card-full-height"
    }, _react["default"].createElement("div", {
      className: "jr-card-header d-flex"
    }, _react["default"].createElement("div", {
      className: "mr-auto"
    }, _react["default"].createElement("h3", {
      className: "card-heading"
    }, "Please select an entry to display details")))))));
  }
};

var _default = TeamDetail;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TeamDetail, "TeamDetail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamDetail/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamDetail/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamDetail/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamDetail/index.js");

  __REACT_HOT_LOADER__.register(_teamDetailTable, "_teamDetailTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamDetail/index.js");

  __REACT_HOT_LOADER__.register(_basicDetailDrillDown, "_basicDetailDrillDown", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamDetail/index.js");

  __REACT_HOT_LOADER__.register(_teamEdit, "_teamEdit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamDetail/index.js");

  __REACT_HOT_LOADER__.register(_selectByIdModal, "_selectByIdModal", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamDetail/index.js");

  __REACT_HOT_LOADER__.register(_deleteItemCheck, "_deleteItemCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamDetail/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamDetail/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamDetail/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamDetail/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamDetail/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamDetail/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamDetail/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamDetail/index.js");

  __REACT_HOT_LOADER__.register(TeamDetail, "TeamDetail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamDetail/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamDetail/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamDetail/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamDetail/index.js");
}();

;

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _basicDetailRow = _interopRequireDefault(__webpack_require__(157));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var TeamDetailTable = function TeamDetailTable(_ref) {
  var displayData = _ref.displayData;

  if (displayData) {
    return _react["default"].createElement("table", {
      className: "default-table table table-sm table-responsive-sm table-hover"
    }, _react["default"].createElement("tbody", null, _react["default"].createElement(_basicDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.description"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.description
    })));
  } else {
    return _react["default"].createElement(_react.Fragment, null);
  }
};

var _default = TeamDetailTable;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TeamDetailTable, "TeamDetailTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamDetail/teamDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamDetail/teamDetailTable/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamDetail/teamDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamDetail/teamDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_basicDetailRow, "_basicDetailRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamDetail/teamDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamDetail/teamDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamDetail/teamDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamDetail/teamDetailTable/index.js");

  __REACT_HOT_LOADER__.register(TeamDetailTable, "TeamDetailTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamDetail/teamDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamDetail/teamDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamDetail/teamDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamDetail/teamDetailTable/index.js");
}();

;

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _team = __webpack_require__(116);

var _common = __webpack_require__(827);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var TeamEdit = function TeamEdit() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var editTeamState = (0, _reactRedux.useSelector)(function (state) {
    return state.teams.editTeamState;
  });
  var team = (0, _reactRedux.useSelector)(function (state) {
    return state.teams.selectedTeam;
  });

  var _useState = (0, _react.useState)(team),
      _useState2 = _slicedToArray(_useState, 2),
      selectedTeam = _useState2[0],
      setSelectedTeam = _useState2[1];

  var _useState3 = (0, _react.useState)({
    name: ''
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      formErrors = _useState4[0],
      setFormErrors = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      formValid = _useState6[0],
      setFormValid = _useState6[1]; // using selectedTeam makes it behave like componentDidUpdate - effect takes place when selectedTeam changes


  (0, _react.useEffect)(function () {
    setSelectedTeam(team);
    setFormValid(false);
    validateForm();
  }, [team]); // using selectedTeam makes it behave like componentDidUpdate - effect takes place when selectedTeam changes

  (0, _react.useEffect)(function () {
    setFormValid(false);
    validateForm();
  }, [selectedTeam]);

  var handleUserInput = function handleUserInput(event, isNumber) {
    var name = event.target.name;
    var value = event.target.value;

    if (isNumber) {
      value = Number(event.target.value);
    }

    updateSelectedTeamField(name, value);
    validateField(name, value);
  };

  var updateSelectedTeamField = function updateSelectedTeamField(fieldName, value) {
    var newTeam = _objectSpread({}, selectedTeam);

    newTeam[fieldName] = value;
    setSelectedTeam(newTeam);
  };

  var validateField = function validateField(fieldName, value) {
    formErrors[fieldName] = (0, _common.getFormError)(fieldName, value);
    setFormErrors(formErrors);
    validateForm();
  };

  var validateForm = function validateForm() {
    setFormValid((0, _common.isFormValid)(selectedTeam));
  };

  var maintainButton = function maintainButton(label) {
    return _react["default"].createElement(_reactstrap.Button, {
      className: "text-uppercase",
      disabled: !formValid,
      color: "primary",
      onClick: function onClick() {
        dispatch((0, _team.showTeamLoader)());
        dispatch((0, _team.onTeamClose)());
        dispatch((0, _team.onSaveTeam)(selectedTeam));
        setFormValid(false);
      }
    }, label);
  };

  var modalHeaderOnClick = function modalHeaderOnClick() {
    return function () {
      setFormValid(false);
      dispatch((0, _team.onTeamClose)());
    };
  };

  var modalBody = function modalBody(buttonText) {
    return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
      className: "modal-box-content"
    }, _react["default"].createElement("div", {
      className: "row no-gutters"
    }, (0, _common.displayedImage)(selectedTeam), (0, _common.showErrors)(formErrors), (0, _common.inputFields)(selectedTeam, handleUserInput))), _react["default"].createElement("div", {
      className: "modal-box-footer d-flex flex-row"
    }, maintainButton(buttonText)));
  };

  return _react["default"].createElement(_reactstrap.Modal, {
    className: "modal-box",
    isOpen: editTeamState
  }, (0, _common.modalHeader)(_react["default"].createElement(_IntlMessages["default"], {
    id: "team.saveTeam"
  }), modalHeaderOnClick), modalBody(_react["default"].createElement(_IntlMessages["default"], {
    id: "team.saveTeam"
  })));
};

var _default = TeamEdit;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TeamEdit, "TeamEdit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamEdit/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamEdit/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamEdit/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamEdit/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamEdit/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamEdit/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamEdit/index.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamEdit/index.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamEdit/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamEdit/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamEdit/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamEdit/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamEdit/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamEdit/index.js");

  __REACT_HOT_LOADER__.register(TeamEdit, "TeamEdit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamEdit/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamEdit/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamEdit/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamEdit/index.js");
}();

;

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMockDrillDownData = exports.getDisplayData = void 0;

var getDisplayData = function getDisplayData(team) {
  return {
    id: (team === null || team === void 0 ? void 0 : team.id) ? team === null || team === void 0 ? void 0 : team.id : 0,
    name: (team === null || team === void 0 ? void 0 : team.name) ? team === null || team === void 0 ? void 0 : team.name : 'No name specified',
    description: (team === null || team === void 0 ? void 0 : team.description) ? team === null || team === void 0 ? void 0 : team.description : 'No description specified'
  };
}; // temp solution to mock drill down data after component generation - data may not exist
// makes it easy to clean up mock data and use real data when available (just search for this functions usage)


exports.getDisplayData = getDisplayData;

var getMockDrillDownData = function getMockDrillDownData() {
  return [{
    id: '2578cb65923bb7ba0845014820190617',
    name: 'fake member number 1',
    description: 'description number 1'
  }, {
    id: '9876cb65923bb7ba0845014820190617',
    name: 'fake member number 2',
    description: 'description number 2'
  }];
};

exports.getMockDrillDownData = getMockDrillDownData;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(getDisplayData, "getDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/teamService.js");

  __REACT_HOT_LOADER__.register(getMockDrillDownData, "getMockDrillDownData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/teamService.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(getDisplayData, "getDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/teamService.js");

  __REACT_HOT_LOADER__.register(getMockDrillDownData, "getMockDrillDownData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/teamService.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/teamService.js");
}();

;

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _matchSorter = _interopRequireDefault(__webpack_require__(95));

var _reactTable = _interopRequireDefault(__webpack_require__(93));

__webpack_require__(94);

var _team = __webpack_require__(116);

var _System = __webpack_require__(55);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var TeamTable = function TeamTable() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var width = (0, _reactRedux.useSelector)(function (state) {
    return state.settings.width;
  });
  var teamList = (0, _reactRedux.useSelector)(function (state) {
    return state.teams.teamList;
  });
  var selectedTeam = (0, _reactRedux.useSelector)(function (state) {
    return state.teams.selectedTeam;
  });

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  (0, _react.useLayoutEffect)(function () {
    var selected = teamList.findIndex(function (entry) {
      return (entry === null || entry === void 0 ? void 0 : entry.id) === (selectedTeam === null || selectedTeam === void 0 ? void 0 : selectedTeam.id);
    }) || 0;
    setSelected(selected);
  }, []);

  var styledSummaryColumn = function styledSummaryColumn(value) {
    return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("span", {
      className: "d-inline-block text-black"
    }, _react["default"].createElement("div", {
      className: "font-weight-bold"
    }, value)));
  };

  var nameColumn = {
    Header: 'Name',
    id: 'name',
    accessor: function accessor(d) {
      return d === null || d === void 0 ? void 0 : d.name;
    },
    filterMethod: function filterMethod(filter, rows) {
      return (0, _matchSorter["default"])(rows, filter.value, {
        keys: ['name']
      });
    },
    Cell: function Cell(_ref) {
      var value = _ref.value;
      return styledSummaryColumn(value);
    },
    filterAll: true
  };
  var descColumn = {
    Header: 'Description',
    id: 'desc',
    accessor: function accessor(d) {
      return d === null || d === void 0 ? void 0 : d.description;
    },
    filterMethod: function filterMethod(filter, rows) {
      return (0, _matchSorter["default"])(rows, filter.value, {
        keys: ['desc']
      });
    },
    filterAll: true
  };
  var columnsList = new Array();
  columnsList.push(nameColumn);

  if (width > _System.TIGHT_FIT_PARAM) {
    columnsList.push(descColumn);
  }

  return _react["default"].createElement("div", {
    style: {
      marginLeft: '10px',
      marginRight: '10px'
    }
  }, _react["default"].createElement(_reactTable["default"], {
    data: teamList,
    filterable: true,
    defaultFilterMethod: function defaultFilterMethod(filter, row) {
      return String(row[filter.id]) === filter.value;
    },
    columns: [{
      columns: columnsList
    }],
    defaultPageSize: 10,
    getTrProps: function getTrProps(state, rowInfo) {
      if (rowInfo && rowInfo.row) {
        return {
          onClick: function onClick() {
            var _rowInfo$original; // console.log(JSON.stringify(rowInfo?.index));


            dispatch((0, _team.setTeam)(rowInfo === null || rowInfo === void 0 ? void 0 : (_rowInfo$original = rowInfo.original) === null || _rowInfo$original === void 0 ? void 0 : _rowInfo$original.id));
            setSelected(rowInfo.index);
          },
          style: {
            background: rowInfo.index === selected ? '#cfd8dc' : 'white',
            color: rowInfo.index === selected ? 'black' : 'black'
          }
        };
      } else {
        return {};
      }
    }
  }));
};

var _default = TeamTable;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TeamTable, "TeamTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamTable/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamTable/index.js");

  __REACT_HOT_LOADER__.register(_matchSorter, "_matchSorter", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamTable/index.js");

  __REACT_HOT_LOADER__.register(_reactTable, "_reactTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamTable/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamTable/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamTable/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamTable/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamTable/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamTable/index.js");

  __REACT_HOT_LOADER__.register(TeamTable, "TeamTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamTable/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamTable/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamTable/index.js");
}();

;

/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _team = __webpack_require__(116);

var _common = __webpack_require__(827);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var TeamAdd = function TeamAdd() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var addTeamState = (0, _reactRedux.useSelector)(function (state) {
    return state.teams.addTeamState;
  });

  var _useState = (0, _react.useState)(initProps),
      _useState2 = _slicedToArray(_useState, 2),
      selectedTeam = _useState2[0],
      setSelectedTeam = _useState2[1];

  var _useState3 = (0, _react.useState)({
    name: ''
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      formErrors = _useState4[0],
      setFormErrors = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      formValid = _useState6[0],
      setFormValid = _useState6[1];

  (0, _react.useEffect)(function () {
    setSelectedTeam(initProps());
  }, [addTeamState]); // using selectedTeam makes it behave like componentDidUpdate - effect takes place when selectedTeam changes

  (0, _react.useEffect)(function () {
    setFormValid(false);
    validateForm();
  }, [selectedTeam]);

  var initProps = function initProps() {
    return {
      id: '',
      orgid: '',
      name: '',
      description: '',
      starred: false,
      frequently: false
    };
  };

  var handleUserInput = function handleUserInput(event, isNumber) {
    var name = event.target.name;
    var value = event.target.value;

    if (isNumber) {
      value = Number(event.target.value);
    }

    updateSelectedTeamField(name, value);
    validateField(name, value);
  };

  var updateSelectedTeamField = function updateSelectedTeamField(fieldName, value) {
    var newTeam = _objectSpread({}, selectedTeam);

    newTeam[fieldName] = value;
    setSelectedTeam(newTeam);
  };

  var validateField = function validateField(fieldName, value) {
    formErrors[fieldName] = (0, _common.getFormError)(fieldName, value);
    setFormErrors(formErrors);
    validateForm();
  };

  var validateForm = function validateForm() {
    setFormValid((0, _common.isFormValid)(selectedTeam));
  };

  var maintainButton = function maintainButton(label) {
    return _react["default"].createElement(_reactstrap.Button, {
      className: "text-uppercase",
      disabled: !formValid,
      color: "primary",
      onClick: function onClick() {
        dispatch((0, _team.showTeamLoader)());
        dispatch((0, _team.onTeamClose)());
        dispatch((0, _team.onSaveTeam)(selectedTeam));
        setSelectedTeam(initProps());
        setFormValid(false);
      }
    }, label);
  };

  var modalHeaderOnClick = function modalHeaderOnClick() {
    return function () {
      setFormValid(false);
      dispatch((0, _team.onTeamClose)());
    };
  };

  var modalBody = function modalBody(buttonText) {
    return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
      className: "modal-box-content"
    }, _react["default"].createElement("div", {
      className: "row no-gutters"
    }, (0, _common.displayedImage)(selectedTeam), (0, _common.showErrors)(formErrors), (0, _common.inputFields)(selectedTeam, handleUserInput))), _react["default"].createElement("div", {
      className: "modal-box-footer d-flex flex-row"
    }, maintainButton(buttonText)));
  };

  return _react["default"].createElement(_reactstrap.Modal, {
    className: "modal-box",
    isOpen: addTeamState
  }, (0, _common.modalHeader)(_react["default"].createElement(_IntlMessages["default"], {
    id: "team.addTeam"
  }), modalHeaderOnClick), modalBody(_react["default"].createElement(_IntlMessages["default"], {
    id: "team.addTeam"
  })));
};

var _default = TeamAdd;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TeamAdd, "TeamAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamAdd/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamAdd/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamAdd/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamAdd/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamAdd/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamAdd/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamAdd/index.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamAdd/index.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamAdd/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamAdd/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamAdd/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamAdd/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamAdd/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamAdd/index.js");

  __REACT_HOT_LOADER__.register(TeamAdd, "TeamAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamAdd/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamAdd/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamAdd/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/team/teamMaintenance/teamAdd/index.js");
}();

;

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _component["default"];
  }
});

var _component = _interopRequireDefault(__webpack_require__(1959));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_component, "_component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/index.js");
}();

;

/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _rcDrawer = _interopRequireDefault(__webpack_require__(31));

var _reactNotifications = __webpack_require__(30);

var _reactstrap = __webpack_require__(6);

var _productDetail = _interopRequireDefault(__webpack_require__(1960));

var _productTable = _interopRequireDefault(__webpack_require__(1964));

var _productAdd = _interopRequireDefault(__webpack_require__(1965));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _CircularProgress = _interopRequireDefault(__webpack_require__(24));

var _CustomScrollbars = _interopRequireDefault(__webpack_require__(27));

var _product = __webpack_require__(117);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Component = function Component() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var width = (0, _reactRedux.useSelector)(function (state) {
    return state.settings.width;
  });
  var loader = (0, _reactRedux.useSelector)(function (state) {
    return state.products.loader;
  });
  var alertMessage = (0, _reactRedux.useSelector)(function (state) {
    return state.products.alertMessage;
  });
  var showMessage = (0, _reactRedux.useSelector)(function (state) {
    return state.products.showMessage;
  });
  var noContentFoundMessage = (0, _reactRedux.useSelector)(function (state) {
    return state.products.noContentFoundMessage;
  });
  var drawerState = (0, _reactRedux.useSelector)(function (state) {
    return state.products.drawerState;
  });
  var product = (0, _reactRedux.useSelector)(function (state) {
    return state.products.product;
  });
  var productList = (0, _reactRedux.useSelector)(function (state) {
    return state.products.productList;
  });
  (0, _react.useEffect)(function () {
    dispatch((0, _product.showProductLoader)());
    dispatch((0, _product.fetchProducts)());
    dispatch((0, _product.fetchProductLookupData)());
  }, []);

  var productSideBar = function productSideBar() {
    return _react["default"].createElement("div", {
      className: "module-side"
    }, _react["default"].createElement("div", {
      className: "module-side-header"
    }, _react["default"].createElement("div", {
      className: "module-logo"
    }, _react["default"].createElement("i", {
      className: "zmdi zmdi-city-alt mr-4"
    }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
      id: "sidebar.products"
    })))), _react["default"].createElement("div", {
      className: "module-side-content"
    }, _react["default"].createElement(_CustomScrollbars["default"], {
      className: "module-side-scroll scrollbar",
      style: {
        height: width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)'
      }
    }, _react["default"].createElement("div", {
      className: "module-add-task"
    }, _react["default"].createElement(_reactstrap.Button, {
      className: "btn-block jr-btn",
      color: "primary",
      onClick: function onClick() {
        return dispatch((0, _product.onAddProduct)());
      }
    }, _react["default"].createElement("i", {
      className: "zmdi zmdi-accounts-add zmdi-hc-fw"
    }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
      id: "product.addProduct"
    })))))));
  };

  var productRequestClose = function productRequestClose() {
    dispatch((0, _product.handleProductRequestClose)());
  };

  return _react["default"].createElement("div", {
    className: "app-wrapper"
  }, _react["default"].createElement("div", {
    className: "app-module animated slideInUpTiny animation-duration-3"
  }, _react["default"].createElement("div", {
    className: "d-block d-xl-none"
  }, _react["default"].createElement(_rcDrawer["default"], {
    touch: true,
    transitions: true,
    enableDragHandle: true,
    open: drawerState,
    onOpenChange: function onOpenChange() {
      return dispatch((0, _product.onToggleProductDrawer)());
    },
    sidebar: productSideBar(product)
  })), _react["default"].createElement("div", {
    className: "app-module-sidenav d-none d-xl-flex"
  }, productSideBar(product)), _react["default"].createElement("div", {
    className: "module-box"
  }, _react["default"].createElement("div", {
    className: "module-box-content"
  }, _react["default"].createElement("div", {
    className: "module-box-header"
  }, _react["default"].createElement("span", {
    className: "icon-btn drawer-btn d-flex d-xl-none",
    onClick: function onClick() {
      return dispatch((0, _product.onToggleProductDrawer)());
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-menu"
  }))), _react["default"].createElement(_CustomScrollbars["default"], {
    className: "module-list-scroll scrollbar",
    style: {
      height: width >= 1200 ? 'calc(108vh - 265px)' : 'calc(108vh - 245px)'
    }
  }, loader ? _react["default"].createElement("div", {
    className: "loader-view-block h-100"
  }, _react["default"].createElement("div", {
    className: "loader-view"
  }, _react["default"].createElement(_CircularProgress["default"], null))) : productList && productList.length > 0 ? _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
    className: "app-main-content"
  }, _react["default"].createElement(_productTable["default"], null), _react["default"].createElement("div", {
    style: {
      marginTop: 10
    }
  }, _react["default"].createElement(_productDetail["default"], null)))) : _react["default"].createElement("div", {
    className: "h-100 d-flex align-items-center justify-content-center"
  }, noContentFoundMessage))))), _react["default"].createElement(_productAdd["default"], null), showMessage && _reactNotifications.NotificationManager.success(alertMessage, productRequestClose()), _react["default"].createElement(_reactNotifications.NotificationContainer, null));
};

var _default = Component;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/component.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/component.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/component.js");

  __REACT_HOT_LOADER__.register(_rcDrawer, "_rcDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/component.js");

  __REACT_HOT_LOADER__.register(_productDetail, "_productDetail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/component.js");

  __REACT_HOT_LOADER__.register(_productTable, "_productTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/component.js");

  __REACT_HOT_LOADER__.register(_productAdd, "_productAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/component.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/component.js");

  __REACT_HOT_LOADER__.register(_CircularProgress, "_CircularProgress", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/component.js");

  __REACT_HOT_LOADER__.register(_CustomScrollbars, "_CustomScrollbars", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/component.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/component.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/component.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/component.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/component.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/component.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/component.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/component.js");
}();

;

/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _productDetailTable = _interopRequireDefault(__webpack_require__(1961));

var _valueStreamDetailTable = _interopRequireDefault(__webpack_require__(823));

var _productEdit = _interopRequireDefault(__webpack_require__(1962));

var _productService = __webpack_require__(1963);

var _valueStreamService = __webpack_require__(825);

var _product = __webpack_require__(117);

var _deleteItemCheck = _interopRequireDefault(__webpack_require__(227));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
} // import { TIGHT_FIT_PARAM } from 'constants/System';


var ProductDetail = function ProductDetail() {
  // const defaultWidth = width > TIGHT_FIT_PARAM ? 150 : 80;
  var dispatch = (0, _reactRedux.useDispatch)(); // const allValueStreams = useSelector(state => state.valueStreams.allValueStream);

  var selectedProduct = (0, _reactRedux.useSelector)(function (state) {
    return state.products.selectedProduct;
  });
  var selectedOrg = (0, _reactRedux.useSelector)(function (state) {
    return state.orgs.selectedOrg;
  });

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      valueStreamDisplayData = _useState2[0],
      setValueStreamDisplayData = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      displayData = _useState4[0],
      setDisplayData = _useState4[1];

  (0, _react.useEffect)(function () {
    // TODO - do not fetch if no selected product
    var mounted = true; // fix warning on no-op state when component not mounted https://www.debuggr.io/react-update-unmounted-component/

    var productPromise = new Promise(function (resolve) {
      return resolve((0, _productService.getProductDisplayData)(selectedProduct, selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id));
    });
    var valueStreamPromise = new Promise(function (resolve) {
      return resolve((0, _valueStreamService.getValueStreamDisplayData)(selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.valueStreamId, selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id));
    });

    var fetchDisplayData =
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Promise.all([productPromise, valueStreamPromise].map(function (result) {
                  return result["catch"](function (error) {
                    return error;
                  });
                })).then(function (values) {
                  var _values = _slicedToArray(values, 2),
                      productDisplayData = _values[0],
                      valueStreamDisplayData = _values[1];

                  setDisplayData(productDisplayData);
                  setValueStreamDisplayData(valueStreamDisplayData);
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetchDisplayData() {
        return _ref.apply(this, arguments);
      };
    }();

    if (mounted) {
      fetchDisplayData();
    }

    return function () {
      return mounted = false;
    };
  }, [selectedProduct]);

  var mainIcon = function mainIcon() {
    // TODO pass in type to change the icon on the detail tab
    // if (type && type.toLowerCase() === 'high') {
    //     return 'stream';
    // }
    // if (type && type.toLowerCase() === 'medium') {
    //     return 'compact';
    // }
    // if (type && type.toLowerCase() === 'low') {
    //     return 'module';
    // }
    return 'dashboard';
  };

  if (selectedProduct) {
    // const fields = { ...selectedProduct?.fields };
    return _react["default"].createElement("div", {
      className: "dashboard animated slideInUpTiny animation-duration-3"
    }, _react["default"].createElement("div", {
      className: "row"
    }, _react["default"].createElement("div", {
      className: "col-md-7 col-12"
    }, _react["default"].createElement("div", {
      className: "jr-card jr-card-full-height ml-2 mr-2"
    }, _react["default"].createElement("div", {
      className: "jr-card-header d-flex"
    }, _react["default"].createElement("div", {
      className: "mr-auto"
    }, _react["default"].createElement("h2", {
      className: "card-heading"
    }, displayData === null || displayData === void 0 ? void 0 : displayData.name)), _react["default"].createElement("div", null, _react["default"].createElement(_deleteItemCheck["default"], {
      id: selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.id,
      onConfirm: _product.onDeleteProduct,
      alertMessage: _react["default"].createElement(_IntlMessages["default"], {
        id: "product.deleteProduct"
      })
    }), _react["default"].createElement(_reactstrap.Button, {
      size: "sm",
      color: "primary",
      onClick: function onClick() {
        return dispatch((0, _product.onEditProduct)(selectedProduct));
      }
    }, _react["default"].createElement("i", {
      className: "zmdi zmdi-edit zmdi-hc-fw"
    }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
      id: "label.edit"
    }))))), _react["default"].createElement("div", {
      className: "jr-card-body"
    }, _react["default"].createElement("div", {
      className: "row"
    }, _react["default"].createElement("div", {
      className: "col-sm-3"
    }, _react["default"].createElement("div", {
      className: "temp-section mb-4 mb-sm-0 text-center text-sm-left"
    }, _react["default"].createElement("p", null, _react["default"].createElement("i", {
      className: "detail-icon text-blue-grey zmdi zmdi-view-".concat(mainIcon(), " zmdi-hc-fw")
    })))), _react["default"].createElement("div", {
      className: "col-sm-9 text-center text-sm-left"
    }, _react["default"].createElement(_productDetailTable["default"], {
      displayData: displayData
    }))))), _react["default"].createElement(_productEdit["default"], null)), _react["default"].createElement("div", {
      className: "col-md-5"
    }, _react["default"].createElement("div", {
      className: "jr-card jr-card-full-height ml-2 mr-2"
    }, _react["default"].createElement("div", {
      className: "mr-auto"
    }, _react["default"].createElement("h2", {
      className: "card-heading"
    }, _react["default"].createElement(_IntlMessages["default"], {
      id: "product.valueStreams"
    }))), _react["default"].createElement("div", null, _react["default"].createElement(_valueStreamDetailTable["default"], {
      displayData: valueStreamDisplayData
    }))))));
  } else {
    return _react["default"].createElement("div", {
      className: "dashboard animated slideInUpTiny animation-duration-3"
    }, _react["default"].createElement("div", {
      className: "row"
    }, _react["default"].createElement("div", {
      className: "col-md-12 col-12"
    }, _react["default"].createElement("div", {
      className: "jr-card jr-card-full-height"
    }, _react["default"].createElement("div", {
      className: "jr-card-header d-flex"
    }, _react["default"].createElement("div", {
      className: "mr-auto"
    }, _react["default"].createElement("h3", {
      className: "card-heading"
    }, "Please select an entry to display details")))))));
  }
};

var _default = ProductDetail;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProductDetail, "ProductDetail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productDetail/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productDetail/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productDetail/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productDetail/index.js");

  __REACT_HOT_LOADER__.register(_productDetailTable, "_productDetailTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productDetail/index.js");

  __REACT_HOT_LOADER__.register(_valueStreamDetailTable, "_valueStreamDetailTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productDetail/index.js");

  __REACT_HOT_LOADER__.register(_productEdit, "_productEdit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productDetail/index.js");

  __REACT_HOT_LOADER__.register(_deleteItemCheck, "_deleteItemCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productDetail/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productDetail/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productDetail/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productDetail/index.js");

  __REACT_HOT_LOADER__.register(asyncGeneratorStep, "asyncGeneratorStep", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productDetail/index.js");

  __REACT_HOT_LOADER__.register(_asyncToGenerator, "_asyncToGenerator", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productDetail/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productDetail/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productDetail/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productDetail/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productDetail/index.js");

  __REACT_HOT_LOADER__.register(ProductDetail, "ProductDetail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productDetail/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productDetail/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productDetail/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productDetail/index.js");
}();

;

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _basicDetailRow = _interopRequireDefault(__webpack_require__(157));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var ProductDetailTable = function ProductDetailTable(_ref) {
  var displayData = _ref.displayData;

  if (displayData) {
    return _react["default"].createElement("table", {
      className: "default-table table table-sm table-responsive-sm table-hover"
    }, _react["default"].createElement("tbody", null, _react["default"].createElement(_basicDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.description"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.description
    }), _react["default"].createElement(_basicDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.manager"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.manager
    }), _react["default"].createElement(_basicDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.fyBudget"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.fyBudget
    }), _react["default"].createElement(_basicDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.valueStream"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.valueStream
    }), _react["default"].createElement(_basicDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.businessUnit"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.businessUnit
    }), _react["default"].createElement(_basicDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.productType"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.productType
    })));
  } else {
    return _react["default"].createElement(_react.Fragment, null);
  }
};

var _default = ProductDetailTable;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProductDetailTable, "ProductDetailTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productDetail/productDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productDetail/productDetailTable/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productDetail/productDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productDetail/productDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_basicDetailRow, "_basicDetailRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productDetail/productDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productDetail/productDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productDetail/productDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productDetail/productDetailTable/index.js");

  __REACT_HOT_LOADER__.register(ProductDetailTable, "ProductDetailTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productDetail/productDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productDetail/productDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productDetail/productDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productDetail/productDetailTable/index.js");
}();

;

/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _product = __webpack_require__(117);

var _common = __webpack_require__(828);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ProductEdit = function ProductEdit() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var editProductState = (0, _reactRedux.useSelector)(function (state) {
    return state.products.editProductState;
  });
  var product = (0, _reactRedux.useSelector)(function (state) {
    return state.products.selectedProduct;
  });
  var allValueStreams = (0, _reactRedux.useSelector)(function (state) {
    return state.valueStreams.allValueStream;
  });
  var allMembers = (0, _reactRedux.useSelector)(function (state) {
    return state.members.allMember;
  });
  var allBusinessUnits = (0, _reactRedux.useSelector)(function (state) {
    return state.businessUnits.allBusinessUnit;
  });

  var _useState = (0, _react.useState)(product),
      _useState2 = _slicedToArray(_useState, 2),
      selectedProduct = _useState2[0],
      setSelectedProduct = _useState2[1];

  var _useState3 = (0, _react.useState)({
    name: ''
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      formErrors = _useState4[0],
      setFormErrors = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      formValid = _useState6[0],
      setFormValid = _useState6[1]; // using selectedProduct makes it behave like componentDidUpdate - effect takes place when selectedProduct changes


  (0, _react.useEffect)(function () {
    setSelectedProduct(product);
    setFormValid(false);
    validateForm();
  }, [product]); // using selectedProduct makes it behave like componentDidUpdate - effect takes place when selectedProduct changes

  (0, _react.useEffect)(function () {
    setFormValid(false);
    validateForm();
  }, [selectedProduct]);

  var handleUserInput = function handleUserInput(event, isNumber) {
    var name = event.target.name;
    var value = event.target.value;

    if (isNumber) {
      value = Number(event.target.value);
    }

    updateSelectedProductField(name, value);
    validateField(name, value);
  };

  var updateSelectedProductField = function updateSelectedProductField(fieldName, value) {
    var newProduct = _objectSpread({}, selectedProduct);

    newProduct[fieldName] = value;
    setSelectedProduct(newProduct);
  };

  var validateField = function validateField(fieldName, value) {
    formErrors[fieldName] = (0, _common.getFormError)(fieldName, value);
    setFormErrors(formErrors);
    validateForm();
  };

  var validateForm = function validateForm() {
    setFormValid((0, _common.isFormValid)(selectedProduct));
  };

  var maintainButton = function maintainButton(label) {
    return _react["default"].createElement(_reactstrap.Button, {
      className: "text-uppercase",
      disabled: !formValid,
      color: "primary",
      onClick: function onClick() {
        dispatch((0, _product.showProductLoader)());
        dispatch((0, _product.onProductClose)());
        dispatch((0, _product.onSaveProduct)(selectedProduct));
        setFormValid(false);
      }
    }, label);
  };

  var modalHeaderOnClick = function modalHeaderOnClick() {
    return function () {
      setFormValid(false);
      dispatch((0, _product.onProductClose)());
    };
  };

  var modalBody = function modalBody(buttonText) {
    return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
      className: "modal-box-content"
    }, _react["default"].createElement("div", {
      className: "row no-gutters"
    }, (0, _common.displayedImage)(selectedProduct), (0, _common.showErrors)(formErrors), (0, _common.inputFields)(selectedProduct, allValueStreams, allBusinessUnits, allMembers, handleUserInput))), _react["default"].createElement("div", {
      className: "modal-box-footer d-flex flex-row"
    }, maintainButton(buttonText)));
  };

  return _react["default"].createElement(_reactstrap.Modal, {
    className: "modal-box",
    isOpen: editProductState
  }, (0, _common.modalHeader)(_react["default"].createElement(_IntlMessages["default"], {
    id: "product.saveProduct"
  }), modalHeaderOnClick), modalBody(_react["default"].createElement(_IntlMessages["default"], {
    id: "product.saveProduct"
  })));
};

var _default = ProductEdit;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProductEdit, "ProductEdit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productEdit/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productEdit/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productEdit/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productEdit/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productEdit/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productEdit/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productEdit/index.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productEdit/index.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productEdit/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productEdit/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productEdit/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productEdit/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productEdit/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productEdit/index.js");

  __REACT_HOT_LOADER__.register(ProductEdit, "ProductEdit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productEdit/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productEdit/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productEdit/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productEdit/index.js");
}();

;

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMockDrillDownData = exports.getProductDisplayData = void 0;

var _NumberFormatters = __webpack_require__(99);

var _ApiService = __webpack_require__(16);

var _api = __webpack_require__(25);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var getProductDisplayData =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(product, orgid) {
    var fetchedProducts;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _ApiService.fetchDataRequest)('productDisplayData', [_api.ORGID_PATH_PARAM, _api.PRODUCTID_PATH_PARAM], [orgid, product === null || product === void 0 ? void 0 : product.id]);

          case 2:
            _context.t0 = _context.sent;

            if (_context.t0) {
              _context.next = 5;
              break;
            }

            _context.t0 = [];

          case 5:
            fetchedProducts = _context.t0;
            return _context.abrupt("return", {
              id: (product === null || product === void 0 ? void 0 : product.id) ? product === null || product === void 0 ? void 0 : product.id : 0,
              name: (product === null || product === void 0 ? void 0 : product.name) ? product === null || product === void 0 ? void 0 : product.name : 'No name specified',
              description: (product === null || product === void 0 ? void 0 : product.description) ? product === null || product === void 0 ? void 0 : product.description : 'No description specified',
              valueStream: (fetchedProducts === null || fetchedProducts === void 0 ? void 0 : fetchedProducts.valueStreamName) ? fetchedProducts === null || fetchedProducts === void 0 ? void 0 : fetchedProducts.valueStreamName : 'No value stream selected',
              manager: (fetchedProducts === null || fetchedProducts === void 0 ? void 0 : fetchedProducts.managerName) ? fetchedProducts === null || fetchedProducts === void 0 ? void 0 : fetchedProducts.managerName : 'No manager selected',
              businessUnit: (fetchedProducts === null || fetchedProducts === void 0 ? void 0 : fetchedProducts.businessUnitName) ? fetchedProducts === null || fetchedProducts === void 0 ? void 0 : fetchedProducts.businessUnitName : 'No business unit selected',
              fyBudget: (product === null || product === void 0 ? void 0 : product.fyBudget) ? (0, _NumberFormatters.formatBalance)(product === null || product === void 0 ? void 0 : product.fyBudget) : (0, _NumberFormatters.formatBalance)(0),
              productType: (product === null || product === void 0 ? void 0 : product.productType) ? product === null || product === void 0 ? void 0 : product.productType : 'No product type selected'
            });

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getProductDisplayData(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}(); // temp solution to mock drill down data after component generation - data may not exist
// makes it easy to clean up mock data and use real data when available (just search for this functions usage)


exports.getProductDisplayData = getProductDisplayData;

var getMockDrillDownData = function getMockDrillDownData() {
  return [{
    id: '2578cb65923bb7ba0845014820190617',
    name: 'fake valueStream number 1',
    description: 'description number 1'
  }, {
    id: '9876cb65923bb7ba0845014820190617',
    name: 'fake valueStream number 2',
    description: 'description number 2'
  }];
};

exports.getMockDrillDownData = getMockDrillDownData;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(getProductDisplayData, "getProductDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/productService.js");

  __REACT_HOT_LOADER__.register(getMockDrillDownData, "getMockDrillDownData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/productService.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(asyncGeneratorStep, "asyncGeneratorStep", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/productService.js");

  __REACT_HOT_LOADER__.register(_asyncToGenerator, "_asyncToGenerator", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/productService.js");

  __REACT_HOT_LOADER__.register(getProductDisplayData, "getProductDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/productService.js");

  __REACT_HOT_LOADER__.register(getMockDrillDownData, "getMockDrillDownData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/productService.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/productService.js");
}();

;

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _matchSorter = _interopRequireDefault(__webpack_require__(95));

var _reactTable = _interopRequireDefault(__webpack_require__(93));

__webpack_require__(94);

var _product = __webpack_require__(117);

var _System = __webpack_require__(55);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ProductTable = function ProductTable() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var productList = (0, _reactRedux.useSelector)(function (state) {
    return state.products.productList;
  });
  var selectedProduct = (0, _reactRedux.useSelector)(function (state) {
    return state.products.selectedProduct;
  });
  var width = (0, _reactRedux.useSelector)(function (state) {
    return state.settings.width;
  });

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  (0, _react.useLayoutEffect)(function () {
    var selected = productList.findIndex(function (entry) {
      return (entry === null || entry === void 0 ? void 0 : entry.id) === (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.id);
    }) || 0;
    setSelected(selected);
  }, []);

  var styledSummaryColumn = function styledSummaryColumn(value) {
    return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("span", {
      className: "d-inline-block text-black"
    }, _react["default"].createElement("div", {
      className: "font-weight-bold"
    }, value)));
  };

  var nameColumn = {
    Header: 'Name',
    id: 'name',
    accessor: function accessor(d) {
      return d === null || d === void 0 ? void 0 : d.name;
    },
    filterMethod: function filterMethod(filter, rows) {
      return (0, _matchSorter["default"])(rows, filter.value, {
        keys: ['name']
      });
    },
    Cell: function Cell(_ref) {
      var value = _ref.value;
      return styledSummaryColumn(value);
    },
    filterAll: true
  };
  var descColumn = {
    Header: 'Description',
    id: 'desc',
    accessor: function accessor(d) {
      return d === null || d === void 0 ? void 0 : d.description;
    },
    filterMethod: function filterMethod(filter, rows) {
      return (0, _matchSorter["default"])(rows, filter.value, {
        keys: ['desc']
      });
    },
    filterAll: true
  };
  var columnsList = new Array();
  columnsList.push(nameColumn);

  if (width > _System.TIGHT_FIT_PARAM) {
    columnsList.push(descColumn);
  }

  return _react["default"].createElement("div", {
    style: {
      marginLeft: '10px',
      marginRight: '10px'
    }
  }, _react["default"].createElement(_reactTable["default"], {
    data: productList,
    filterable: true,
    defaultFilterMethod: function defaultFilterMethod(filter, row) {
      return String(row[filter.id]) === filter.value;
    },
    columns: [{
      columns: columnsList
    }],
    defaultPageSize: 10,
    getTrProps: function getTrProps(state, rowInfo) {
      if (rowInfo && rowInfo.row) {
        return {
          onClick: function onClick() {
            var _rowInfo$original; // console.log(JSON.stringify(rowInfo?.index));


            dispatch((0, _product.setProduct)(rowInfo === null || rowInfo === void 0 ? void 0 : (_rowInfo$original = rowInfo.original) === null || _rowInfo$original === void 0 ? void 0 : _rowInfo$original.id));
            setSelected(rowInfo.index);
          },
          style: {
            background: rowInfo.index === selected ? '#cfd8dc' : 'white',
            color: rowInfo.index === selected ? 'black' : 'black'
          }
        };
      } else {
        return {};
      }
    }
  }));
};

var _default = ProductTable;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProductTable, "ProductTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productTable/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productTable/index.js");

  __REACT_HOT_LOADER__.register(_matchSorter, "_matchSorter", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productTable/index.js");

  __REACT_HOT_LOADER__.register(_reactTable, "_reactTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productTable/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productTable/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productTable/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productTable/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productTable/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productTable/index.js");

  __REACT_HOT_LOADER__.register(ProductTable, "ProductTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productTable/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productTable/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productTable/index.js");
}();

;

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _product = __webpack_require__(117);

var _common = __webpack_require__(828);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ProductAdd = function ProductAdd() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var addProductState = (0, _reactRedux.useSelector)(function (state) {
    return state.products.addProductState;
  });
  var allValueStreams = (0, _reactRedux.useSelector)(function (state) {
    return state.valueStreams.allValueStream;
  });
  var allMembers = (0, _reactRedux.useSelector)(function (state) {
    return state.members.allMember;
  });
  var allBusinessUnits = (0, _reactRedux.useSelector)(function (state) {
    return state.businessUnits.allBusinessUnit;
  });

  var _useState = (0, _react.useState)(initProps),
      _useState2 = _slicedToArray(_useState, 2),
      selectedProduct = _useState2[0],
      setSelectedProduct = _useState2[1];

  var _useState3 = (0, _react.useState)({
    name: ''
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      formErrors = _useState4[0],
      setFormErrors = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      formValid = _useState6[0],
      setFormValid = _useState6[1];

  (0, _react.useEffect)(function () {
    setSelectedProduct(initProps());
  }, [addProductState]); // using selectedProduct makes it behave like componentDidUpdate - effect takes place when selectedProduct changes

  (0, _react.useEffect)(function () {
    setFormValid(false);
    validateForm();
  }, [selectedProduct]);

  var initProps = function initProps() {
    return {
      id: '',
      orgid: '',
      name: '',
      description: '',
      manager: '',
      fyBudget: 0,
      businessUnitId: '',
      valueStreamId: '',
      productType: '',
      starred: false,
      frequently: false
    };
  };

  var handleUserInput = function handleUserInput(event, isNumber) {
    var name = event.target.name;
    var value = event.target.value;

    if (isNumber) {
      value = Number(event.target.value);
    }

    updateSelectedProductField(name, value);
    validateField(name, value);
  };

  var updateSelectedProductField = function updateSelectedProductField(fieldName, value) {
    var newProduct = _objectSpread({}, selectedProduct);

    newProduct[fieldName] = value;
    setSelectedProduct(newProduct);
  };

  var validateField = function validateField(fieldName, value) {
    formErrors[fieldName] = (0, _common.getFormError)(fieldName, value);
    setFormErrors(formErrors);
    validateForm();
  };

  var validateForm = function validateForm() {
    setFormValid((0, _common.isFormValid)(selectedProduct));
  };

  var maintainButton = function maintainButton(label) {
    return _react["default"].createElement(_reactstrap.Button, {
      className: "text-uppercase",
      disabled: !formValid,
      color: "primary",
      onClick: function onClick() {
        dispatch((0, _product.showProductLoader)());
        dispatch((0, _product.onProductClose)());
        dispatch((0, _product.onSaveProduct)(selectedProduct));
        setSelectedProduct(initProps());
        setFormValid(false);
      }
    }, label);
  };

  var modalHeaderOnClick = function modalHeaderOnClick() {
    return function () {
      setFormValid(false);
      dispatch((0, _product.onProductClose)());
    };
  };

  var modalBody = function modalBody(buttonText) {
    return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
      className: "modal-box-content"
    }, _react["default"].createElement("div", {
      className: "row no-gutters"
    }, (0, _common.displayedImage)(selectedProduct), (0, _common.showErrors)(formErrors), (0, _common.inputFields)(selectedProduct, allValueStreams, allBusinessUnits, allMembers, handleUserInput))), _react["default"].createElement("div", {
      className: "modal-box-footer d-flex flex-row"
    }, maintainButton(buttonText)));
  };

  return _react["default"].createElement(_reactstrap.Modal, {
    className: "modal-box",
    isOpen: addProductState
  }, (0, _common.modalHeader)(_react["default"].createElement(_IntlMessages["default"], {
    id: "product.addProduct"
  }), modalHeaderOnClick), modalBody(_react["default"].createElement(_IntlMessages["default"], {
    id: "product.addProduct"
  })));
};

var _default = ProductAdd;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProductAdd, "ProductAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productAdd/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productAdd/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productAdd/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productAdd/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productAdd/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productAdd/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productAdd/index.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productAdd/index.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productAdd/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productAdd/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productAdd/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productAdd/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productAdd/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productAdd/index.js");

  __REACT_HOT_LOADER__.register(ProductAdd, "ProductAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productAdd/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productAdd/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productAdd/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/product/productMaintenance/productAdd/index.js");
}();

;

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _component["default"];
  }
});

var _component = _interopRequireDefault(__webpack_require__(1967));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_component, "_component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/index.js");
}();

;

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _rcDrawer = _interopRequireDefault(__webpack_require__(31));

var _reactNotifications = __webpack_require__(30);

var _reactstrap = __webpack_require__(6);

var _initiativeDetail = _interopRequireDefault(__webpack_require__(1968));

var _initiativeTable = _interopRequireDefault(__webpack_require__(1972));

var _initiativeAdd = _interopRequireDefault(__webpack_require__(1973));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _CircularProgress = _interopRequireDefault(__webpack_require__(24));

var _CustomScrollbars = _interopRequireDefault(__webpack_require__(27));

var _initiative = __webpack_require__(101);

var _product = __webpack_require__(117);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Component = function Component() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var width = (0, _reactRedux.useSelector)(function (state) {
    return state.settings.width;
  });
  var loader = (0, _reactRedux.useSelector)(function (state) {
    return state.initiatives.loader;
  });
  var alertMessage = (0, _reactRedux.useSelector)(function (state) {
    return state.initiatives.alertMessage;
  });
  var showMessage = (0, _reactRedux.useSelector)(function (state) {
    return state.initiatives.showMessage;
  });
  var noContentFoundMessage = (0, _reactRedux.useSelector)(function (state) {
    return state.initiatives.noContentFoundMessage;
  });
  var drawerState = (0, _reactRedux.useSelector)(function (state) {
    return state.initiatives.drawerState;
  });
  var initiative = (0, _reactRedux.useSelector)(function (state) {
    return state.initiatives.initiative;
  });
  var initiativeList = (0, _reactRedux.useSelector)(function (state) {
    return state.initiatives.initiativeList;
  });
  (0, _react.useEffect)(function () {
    dispatch((0, _initiative.showInitiativeLoader)());
    dispatch((0, _initiative.fetchInitiatives)());
    dispatch((0, _product.fetchProducts)());
  }, []);

  var initiativeSideBar = function initiativeSideBar() {
    return _react["default"].createElement("div", {
      className: "module-side"
    }, _react["default"].createElement("div", {
      className: "module-side-header"
    }, _react["default"].createElement("div", {
      className: "module-logo"
    }, _react["default"].createElement("i", {
      className: "zmdi zmdi-city-alt mr-4"
    }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
      id: "sidebar.initiatives"
    })))), _react["default"].createElement("div", {
      className: "module-side-content"
    }, _react["default"].createElement(_CustomScrollbars["default"], {
      className: "module-side-scroll scrollbar",
      style: {
        height: width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)'
      }
    }, _react["default"].createElement("div", {
      className: "module-add-task"
    }, _react["default"].createElement(_reactstrap.Button, {
      className: "btn-block jr-btn",
      color: "primary",
      onClick: function onClick() {
        return dispatch((0, _initiative.onAddInitiative)());
      }
    }, _react["default"].createElement("i", {
      className: "zmdi zmdi-accounts-add zmdi-hc-fw"
    }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
      id: "initiative.addInitiative"
    })))))));
  };

  var initiativeRequestClose = function initiativeRequestClose() {
    dispatch((0, _initiative.handleInitiativeRequestClose)());
  };

  return _react["default"].createElement("div", {
    className: "app-wrapper"
  }, _react["default"].createElement("div", {
    className: "app-module animated slideInUpTiny animation-duration-3"
  }, _react["default"].createElement("div", {
    className: "d-block d-xl-none"
  }, _react["default"].createElement(_rcDrawer["default"], {
    touch: true,
    transitions: true,
    enableDragHandle: true,
    open: drawerState,
    onOpenChange: function onOpenChange() {
      return dispatch((0, _initiative.onToggleInitiativeDrawer)());
    },
    sidebar: initiativeSideBar(initiative)
  })), _react["default"].createElement("div", {
    className: "app-module-sidenav d-none d-xl-flex"
  }, initiativeSideBar(initiative)), _react["default"].createElement("div", {
    className: "module-box"
  }, _react["default"].createElement("div", {
    className: "module-box-content"
  }, _react["default"].createElement("div", {
    className: "module-box-header"
  }, _react["default"].createElement("span", {
    className: "icon-btn drawer-btn d-flex d-xl-none",
    onClick: function onClick() {
      return dispatch((0, _initiative.onToggleInitiativeDrawer)());
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-menu"
  }))), _react["default"].createElement(_CustomScrollbars["default"], {
    className: "module-list-scroll scrollbar",
    style: {
      height: width >= 1200 ? 'calc(108vh - 265px)' : 'calc(108vh - 245px)'
    }
  }, loader ? _react["default"].createElement("div", {
    className: "loader-view-block h-100"
  }, _react["default"].createElement("div", {
    className: "loader-view"
  }, _react["default"].createElement(_CircularProgress["default"], null))) : initiativeList && initiativeList.length > 0 ? _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
    className: "app-main-content"
  }, _react["default"].createElement(_initiativeTable["default"], null), _react["default"].createElement("div", {
    style: {
      marginTop: 10
    }
  }, _react["default"].createElement(_initiativeDetail["default"], null)))) : _react["default"].createElement("div", {
    className: "h-100 d-flex align-items-center justify-content-center"
  }, noContentFoundMessage))))), _react["default"].createElement(_initiativeAdd["default"], null), showMessage && _reactNotifications.NotificationManager.success(alertMessage, initiativeRequestClose()), _react["default"].createElement(_reactNotifications.NotificationContainer, null));
};

var _default = Component;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/component.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/component.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/component.js");

  __REACT_HOT_LOADER__.register(_rcDrawer, "_rcDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/component.js");

  __REACT_HOT_LOADER__.register(_initiativeDetail, "_initiativeDetail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/component.js");

  __REACT_HOT_LOADER__.register(_initiativeTable, "_initiativeTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/component.js");

  __REACT_HOT_LOADER__.register(_initiativeAdd, "_initiativeAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/component.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/component.js");

  __REACT_HOT_LOADER__.register(_CircularProgress, "_CircularProgress", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/component.js");

  __REACT_HOT_LOADER__.register(_CustomScrollbars, "_CustomScrollbars", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/component.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/component.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/component.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/component.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/component.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/component.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/component.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/component.js");
}();

;

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _initiativeDetailTable = _interopRequireDefault(__webpack_require__(1969));

var _basicDetailDrillDown = _interopRequireDefault(__webpack_require__(423));

var _initiativeEdit = _interopRequireDefault(__webpack_require__(1970));

var _initiativeService = __webpack_require__(1971);

var _selectByIdModal = _interopRequireDefault(__webpack_require__(301));

var _arrayService = __webpack_require__(34);

var _initiative = __webpack_require__(101);

var _deleteItemCheck = _interopRequireDefault(__webpack_require__(227));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
} // import { TIGHT_FIT_PARAM } from 'constants/System';


var InitiativeDetail = function InitiativeDetail() {
  // const defaultWidth = width > TIGHT_FIT_PARAM ? 150 : 80;
  var dispatch = (0, _reactRedux.useDispatch)();
  var width = (0, _reactRedux.useSelector)(function (state) {
    return state.settings.width;
  });
  var allProducts = (0, _reactRedux.useSelector)(function (state) {
    return state.products.allProduct;
  });
  var selectedOrg = (0, _reactRedux.useSelector)(function (state) {
    return state.orgs.selectedOrg;
  });
  var selectedInitiative = (0, _reactRedux.useSelector)(function (state) {
    return state.initiatives.selectedInitiative;
  });
  var productSelectionList = (0, _reactRedux.useSelector)(function (state) {
    return state.initiatives.productSelectionList;
  });

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      selectedProducts = _useState2[0],
      setSelectedProducts = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      displayData = _useState4[0],
      setDisplayData = _useState4[1];

  (0, _react.useEffect)(function () {
    // TODO - do not fetch if no selected initiative
    // update the selectedProducts
    setSelectedProducts([]);
    var products = (0, _arrayService.sameByIdValue)(allProducts, selectedInitiative === null || selectedInitiative === void 0 ? void 0 : selectedInitiative.products);
    setSelectedProducts(products);

    var fetchDisplayData =
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _initiativeService.getInitiativeDisplayData)(selectedInitiative === null || selectedInitiative === void 0 ? void 0 : selectedInitiative.id, selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id);

              case 2:
                result = _context.sent;
                setDisplayData(result);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetchDisplayData() {
        return _ref.apply(this, arguments);
      };
    }();

    fetchDisplayData();
  }, [selectedInitiative]);

  var mainIcon = function mainIcon() {
    // TODO pass in type to change the icon on the detail tab
    // if (type && type.toLowerCase() === 'high') {
    //     return 'stream';
    // }
    // if (type && type.toLowerCase() === 'medium') {
    //     return 'compact';
    // }
    // if (type && type.toLowerCase() === 'low') {
    //     return 'module';
    // }
    return 'dashboard';
  };

  if (selectedInitiative) {
    return _react["default"].createElement("div", {
      className: "dashboard animated slideInUpTiny animation-duration-3"
    }, _react["default"].createElement("div", {
      className: "row"
    }, _react["default"].createElement("div", {
      className: "col-md-7 col-12"
    }, _react["default"].createElement("div", {
      className: "jr-card jr-card-full-height ml-2 mr-2"
    }, _react["default"].createElement("div", {
      className: "jr-card-header d-flex"
    }, _react["default"].createElement("div", {
      className: "mr-auto"
    }, _react["default"].createElement("h2", {
      className: "card-heading"
    }, displayData === null || displayData === void 0 ? void 0 : displayData.name)), _react["default"].createElement("div", null, _react["default"].createElement(_selectByIdModal["default"], {
      modalTitle: _react["default"].createElement(_IntlMessages["default"], {
        id: "initiative.products"
      }),
      onUpdateHandler: _initiative.onInitiativeProductUpdate,
      onSelectRowHandler: _initiative.onInitiativeSelect,
      onClickButtonHandler: _initiative.onFetchSelectProductData,
      selectLoader: _initiative.showInitiativeLoader,
      data: productSelectionList,
      width: width,
      actionButtonTextId: _react["default"].createElement(_IntlMessages["default"], {
        id: "initiative.products"
      })
    }), _react["default"].createElement(_deleteItemCheck["default"], {
      id: selectedInitiative === null || selectedInitiative === void 0 ? void 0 : selectedInitiative.id,
      onConfirm: _initiative.onDeleteInitiative,
      alertMessage: _react["default"].createElement(_IntlMessages["default"], {
        id: "initiative.deleteInitiative"
      })
    }), _react["default"].createElement(_reactstrap.Button, {
      size: "sm",
      color: "primary",
      onClick: function onClick() {
        return dispatch((0, _initiative.onEditInitiative)(selectedInitiative));
      }
    }, _react["default"].createElement("i", {
      className: "zmdi zmdi-edit zmdi-hc-fw"
    }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
      id: "label.edit"
    }))))), _react["default"].createElement("div", {
      className: "jr-card-body"
    }, _react["default"].createElement("div", {
      className: "row"
    }, _react["default"].createElement("div", {
      className: "col-sm-3"
    }, _react["default"].createElement("div", {
      className: "temp-section mb-4 mb-sm-0 text-center text-sm-left"
    }, _react["default"].createElement("p", null, _react["default"].createElement("i", {
      className: "detail-icon text-blue-grey zmdi zmdi-view-".concat(mainIcon(), " zmdi-hc-fw")
    })))), _react["default"].createElement("div", {
      className: "col-sm-9 text-center text-sm-left"
    }, _react["default"].createElement(_initiativeDetailTable["default"], {
      displayData: displayData
    }))))), _react["default"].createElement(_initiativeEdit["default"], null)), _react["default"].createElement("div", {
      className: "col-md-5"
    }, _react["default"].createElement("div", {
      className: "jr-card jr-card-full-height ml-2 mr-2"
    }, _react["default"].createElement(_basicDetailDrillDown["default"], {
      entries: selectedProducts,
      title: _react["default"].createElement(_IntlMessages["default"], {
        id: "initiative.products"
      })
    })))));
  } else {
    return _react["default"].createElement("div", {
      className: "dashboard animated slideInUpTiny animation-duration-3"
    }, _react["default"].createElement("div", {
      className: "row"
    }, _react["default"].createElement("div", {
      className: "col-md-12 col-12"
    }, _react["default"].createElement("div", {
      className: "jr-card jr-card-full-height"
    }, _react["default"].createElement("div", {
      className: "jr-card-header d-flex"
    }, _react["default"].createElement("div", {
      className: "mr-auto"
    }, _react["default"].createElement("h3", {
      className: "card-heading"
    }, "Please select an entry to display details")))))));
  }
};

var _default = InitiativeDetail;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(InitiativeDetail, "InitiativeDetail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeDetail/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeDetail/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeDetail/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeDetail/index.js");

  __REACT_HOT_LOADER__.register(_initiativeDetailTable, "_initiativeDetailTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeDetail/index.js");

  __REACT_HOT_LOADER__.register(_basicDetailDrillDown, "_basicDetailDrillDown", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeDetail/index.js");

  __REACT_HOT_LOADER__.register(_initiativeEdit, "_initiativeEdit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeDetail/index.js");

  __REACT_HOT_LOADER__.register(_selectByIdModal, "_selectByIdModal", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeDetail/index.js");

  __REACT_HOT_LOADER__.register(_deleteItemCheck, "_deleteItemCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeDetail/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeDetail/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeDetail/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeDetail/index.js");

  __REACT_HOT_LOADER__.register(asyncGeneratorStep, "asyncGeneratorStep", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeDetail/index.js");

  __REACT_HOT_LOADER__.register(_asyncToGenerator, "_asyncToGenerator", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeDetail/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeDetail/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeDetail/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeDetail/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeDetail/index.js");

  __REACT_HOT_LOADER__.register(InitiativeDetail, "InitiativeDetail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeDetail/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeDetail/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeDetail/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeDetail/index.js");
}();

;

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _basicDetailRow = _interopRequireDefault(__webpack_require__(157));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var InitiativeDetailTable = function InitiativeDetailTable(_ref) {
  var displayData = _ref.displayData;

  if (displayData) {
    return _react["default"].createElement("table", {
      className: "default-table table table-sm table-responsive-sm table-hover"
    }, _react["default"].createElement("tbody", null, _react["default"].createElement(_basicDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.description"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.description
    }), _react["default"].createElement(_basicDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.status"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.status
    }), _react["default"].createElement(_basicDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.project"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.project
    }), _react["default"].createElement(_basicDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.startDate"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.startDate
    }), _react["default"].createElement(_basicDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.endDate"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.endDate
    }), _react["default"].createElement(_basicDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.budget"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.budget
    }), _react["default"].createElement(_basicDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.productCount"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.productCount
    })));
  } else {
    return _react["default"].createElement(_react.Fragment, null);
  }
};

var _default = InitiativeDetailTable;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(InitiativeDetailTable, "InitiativeDetailTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeDetail/initiativeDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeDetail/initiativeDetailTable/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeDetail/initiativeDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeDetail/initiativeDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_basicDetailRow, "_basicDetailRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeDetail/initiativeDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeDetail/initiativeDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeDetail/initiativeDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeDetail/initiativeDetailTable/index.js");

  __REACT_HOT_LOADER__.register(InitiativeDetailTable, "InitiativeDetailTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeDetail/initiativeDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeDetail/initiativeDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeDetail/initiativeDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeDetail/initiativeDetailTable/index.js");
}();

;

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _initiative = __webpack_require__(101);

var _common = __webpack_require__(829);

var _Validation = __webpack_require__(14);

var _moment = _interopRequireDefault(__webpack_require__(2));

var _DateService = __webpack_require__(48);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var InitiativeEdit = function InitiativeEdit() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var editInitiativeState = (0, _reactRedux.useSelector)(function (state) {
    return state.initiatives.editInitiativeState;
  });
  var initiative = (0, _reactRedux.useSelector)(function (state) {
    return state.initiatives.selectedInitiative;
  });
  var allProjects = (0, _reactRedux.useSelector)(function (state) {
    return state.projects.allProject;
  });

  var _useState = (0, _react.useState)(initiative),
      _useState2 = _slicedToArray(_useState, 2),
      selectedInitiative = _useState2[0],
      setSelectedInitiative = _useState2[1];

  var _useState3 = (0, _react.useState)({
    name: ''
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      formErrors = _useState4[0],
      setFormErrors = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      formValid = _useState6[0],
      setFormValid = _useState6[1]; // using selectedInitiative makes it behave like componentDidUpdate - effect takes place when selectedInitiative changes


  (0, _react.useEffect)(function () {
    setSelectedInitiative(initiative);
    setFormValid(false);
    validateForm();
  }, [initiative]); // using selectedInitiative makes it behave like componentDidUpdate - effect takes place when selectedInitiative changes

  (0, _react.useEffect)(function () {
    setFormValid(false);
    validateForm();
  }, [selectedInitiative]);

  var handleUserInput = function handleUserInput(event, isNumber) {
    var name = event.target.name;
    var value = event.target.value;

    if (isNumber) {
      value = Number(event.target.value);
    }

    updateSelectedInitiativeField(name, value);
    validateField(name, value);
  };

  var handleDateInput = function handleDateInput(name, value) {
    updateSelectedInitiativeField(name, value);
    validateDateFields(name, value);
    validateForm();
  };

  var updateSelectedInitiativeField = function updateSelectedInitiativeField(fieldName, value) {
    var newInitiative = _objectSpread({}, selectedInitiative);

    newInitiative[fieldName] = value;
    setSelectedInitiative(newInitiative);
  };

  var validateDateFields = function validateDateFields(name, value) {
    formErrors['dates'] = '';

    switch (name) {
      case 'endDate':
        // check its not before the start date
        if ((0, _Validation.isValueEntered)(value) && (0, _Validation.isValueEntered)(selectedInitiative === null || selectedInitiative === void 0 ? void 0 : selectedInitiative.startDate)) {
          if ((0, _DateService.isDateBefore)((0, _moment["default"])(value), (0, _moment["default"])(selectedInitiative === null || selectedInitiative === void 0 ? void 0 : selectedInitiative.startDate))) {
            formErrors['dates'] = ' are invalid. The end date selected cannot be before the start date';
          }
        }

        break;

      case 'startDate':
        // check its not after the end date
        if ((0, _Validation.isValueEntered)(selectedInitiative === null || selectedInitiative === void 0 ? void 0 : selectedInitiative.endDate) && (0, _Validation.isValueEntered)(value)) {
          if ((0, _DateService.isDateBefore)((0, _moment["default"])(selectedInitiative === null || selectedInitiative === void 0 ? void 0 : selectedInitiative.endDate), (0, _moment["default"])(value))) {
            formErrors['dates'] = ' are invalid. The start date selected cannot be after the end date';
          }
        }

        break;

      default:
        break;
    }
  };

  var validateField = function validateField(fieldName, value) {
    formErrors[fieldName] = (0, _common.getFormError)(fieldName, value);
    setFormErrors(formErrors);
    validateForm();
  };

  var validateForm = function validateForm() {
    setFormValid((0, _common.isFormValid)(selectedInitiative) && (0, _common.checkDatesValid)(selectedInitiative));
  };

  var maintainButton = function maintainButton(label) {
    return _react["default"].createElement(_reactstrap.Button, {
      className: "text-uppercase",
      disabled: !formValid,
      color: "primary",
      onClick: function onClick() {
        dispatch((0, _initiative.showInitiativeLoader)());
        dispatch((0, _initiative.onInitiativeClose)());
        dispatch((0, _initiative.onSaveInitiative)(selectedInitiative));
        setFormValid(false);
      }
    }, label);
  };

  var modalHeaderOnClick = function modalHeaderOnClick() {
    return function () {
      setFormValid(false);
      dispatch((0, _initiative.onInitiativeClose)());
    };
  };

  var modalBody = function modalBody(buttonText) {
    return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
      className: "modal-box-content"
    }, _react["default"].createElement("div", {
      className: "row no-gutters"
    }, (0, _common.displayedImage)(selectedInitiative), (0, _common.showErrors)(formErrors), (0, _common.inputFields)(selectedInitiative, allProjects, handleUserInput, handleDateInput))), _react["default"].createElement("div", {
      className: "modal-box-footer d-flex flex-row"
    }, maintainButton(buttonText)));
  };

  return _react["default"].createElement(_reactstrap.Modal, {
    className: "modal-box",
    isOpen: editInitiativeState
  }, (0, _common.modalHeader)(_react["default"].createElement(_IntlMessages["default"], {
    id: "initiative.saveInitiative"
  }), modalHeaderOnClick), modalBody(_react["default"].createElement(_IntlMessages["default"], {
    id: "initiative.saveInitiative"
  })));
};

var _default = InitiativeEdit;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(InitiativeEdit, "InitiativeEdit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeEdit/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeEdit/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeEdit/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeEdit/index.js");

  __REACT_HOT_LOADER__.register(_moment, "_moment", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeEdit/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeEdit/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeEdit/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeEdit/index.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeEdit/index.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeEdit/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeEdit/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeEdit/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeEdit/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeEdit/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeEdit/index.js");

  __REACT_HOT_LOADER__.register(InitiativeEdit, "InitiativeEdit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeEdit/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeEdit/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeEdit/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeEdit/index.js");
}();

;

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMockDrillDownData = exports.getInitiativeDisplayData = void 0;

var _ApiService = __webpack_require__(16);

var _api = __webpack_require__(25);

var _NumberFormatters = __webpack_require__(99);

var _DateFormatters = __webpack_require__(43);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var getInitiativeDisplayData =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(initiativeId, orgid) {
    var fetchedInitiative;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _ApiService.fetchDataRequest)('initiativeDisplayData', [_api.ORGID_PATH_PARAM, _api.INITIATIVEID_PATH_PARAM], [orgid, initiativeId]);

          case 2:
            _context.t0 = _context.sent;

            if (_context.t0) {
              _context.next = 5;
              break;
            }

            _context.t0 = [];

          case 5:
            fetchedInitiative = _context.t0;
            return _context.abrupt("return", {
              id: (fetchedInitiative === null || fetchedInitiative === void 0 ? void 0 : fetchedInitiative.id) ? fetchedInitiative === null || fetchedInitiative === void 0 ? void 0 : fetchedInitiative.id : 0,
              name: (fetchedInitiative === null || fetchedInitiative === void 0 ? void 0 : fetchedInitiative.name) ? fetchedInitiative === null || fetchedInitiative === void 0 ? void 0 : fetchedInitiative.name : 'No name specified',
              description: (fetchedInitiative === null || fetchedInitiative === void 0 ? void 0 : fetchedInitiative.description) ? fetchedInitiative === null || fetchedInitiative === void 0 ? void 0 : fetchedInitiative.description : 'No description specified',
              status: (fetchedInitiative === null || fetchedInitiative === void 0 ? void 0 : fetchedInitiative.status) ? fetchedInitiative === null || fetchedInitiative === void 0 ? void 0 : fetchedInitiative.status : 'No status specified',
              project: (fetchedInitiative === null || fetchedInitiative === void 0 ? void 0 : fetchedInitiative.projectName) ? fetchedInitiative === null || fetchedInitiative === void 0 ? void 0 : fetchedInitiative.projectName : 'No project specified',
              budget: (fetchedInitiative === null || fetchedInitiative === void 0 ? void 0 : fetchedInitiative.budget) ? (0, _NumberFormatters.formatBalance)(fetchedInitiative === null || fetchedInitiative === void 0 ? void 0 : fetchedInitiative.budget) : (0, _NumberFormatters.formatBalance)(0),
              startDate: (fetchedInitiative === null || fetchedInitiative === void 0 ? void 0 : fetchedInitiative.startDate) ? (0, _DateFormatters.formatDateDefault)(fetchedInitiative === null || fetchedInitiative === void 0 ? void 0 : fetchedInitiative.startDate) : 'No start date specified',
              endDate: (fetchedInitiative === null || fetchedInitiative === void 0 ? void 0 : fetchedInitiative.endDate) ? (0, _DateFormatters.formatDateDefault)(fetchedInitiative === null || fetchedInitiative === void 0 ? void 0 : fetchedInitiative.endDate) : 'No end date specified',
              productCount: Array.isArray(fetchedInitiative === null || fetchedInitiative === void 0 ? void 0 : fetchedInitiative.products) ? fetchedInitiative === null || fetchedInitiative === void 0 ? void 0 : fetchedInitiative.products.length : 0
            });

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getInitiativeDisplayData(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}(); // temp solution to mock drill down data after component generation - data may not exist
// makes it easy to clean up mock data and use real data when available (just search for this functions usage)


exports.getInitiativeDisplayData = getInitiativeDisplayData;

var getMockDrillDownData = function getMockDrillDownData() {
  return [{
    id: '2578cb65923bb7ba0845014820190617',
    name: 'fake product number 1',
    description: 'description number 1'
  }, {
    id: '9876cb65923bb7ba0845014820190617',
    name: 'fake product number 2',
    description: 'description number 2'
  }];
};

exports.getMockDrillDownData = getMockDrillDownData;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(getInitiativeDisplayData, "getInitiativeDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/initiativeService.js");

  __REACT_HOT_LOADER__.register(getMockDrillDownData, "getMockDrillDownData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/initiativeService.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(asyncGeneratorStep, "asyncGeneratorStep", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/initiativeService.js");

  __REACT_HOT_LOADER__.register(_asyncToGenerator, "_asyncToGenerator", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/initiativeService.js");

  __REACT_HOT_LOADER__.register(getInitiativeDisplayData, "getInitiativeDisplayData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/initiativeService.js");

  __REACT_HOT_LOADER__.register(getMockDrillDownData, "getMockDrillDownData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/initiativeService.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/services/initiativeService.js");
}();

;

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _matchSorter = _interopRequireDefault(__webpack_require__(95));

var _reactTable = _interopRequireDefault(__webpack_require__(93));

__webpack_require__(94);

var _initiative = __webpack_require__(101);

var _System = __webpack_require__(55);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var InitiativeTable = function InitiativeTable() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var width = (0, _reactRedux.useSelector)(function (state) {
    return state.settings.width;
  });
  var initiativeList = (0, _reactRedux.useSelector)(function (state) {
    return state.initiatives.initiativeList;
  });
  var selectedInitiative = (0, _reactRedux.useSelector)(function (state) {
    return state.initiatives.selectedInitiative;
  });

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var defaultWidth = width > _System.TIGHT_FIT_PARAM ? _System.TABLE_NAME_FIELD_WIDTH : _System.TABLE_NAME_FIELD_TIGHT_FIT_WIDTH;
  (0, _react.useLayoutEffect)(function () {
    var selected = initiativeList.findIndex(function (entry) {
      return (entry === null || entry === void 0 ? void 0 : entry.id) === (selectedInitiative === null || selectedInitiative === void 0 ? void 0 : selectedInitiative.id);
    }) || 0;
    setSelected(selected);
  }, []);

  var styledSummaryColumn = function styledSummaryColumn(value) {
    return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("span", {
      className: "d-inline-block text-black"
    }, _react["default"].createElement("div", {
      className: "font-weight-bold"
    }, value)));
  };

  var nameColumn = {
    Header: 'Name',
    id: 'name',
    accessor: function accessor(d) {
      return d === null || d === void 0 ? void 0 : d.name;
    },
    filterMethod: function filterMethod(filter, rows) {
      return (0, _matchSorter["default"])(rows, filter.value, {
        keys: ['name']
      });
    },
    Cell: function Cell(_ref) {
      var value = _ref.value;
      return styledSummaryColumn(value);
    },
    filterAll: true,
    width: defaultWidth
  };
  var descColumn = {
    Header: 'Description',
    id: 'desc',
    accessor: function accessor(d) {
      return d === null || d === void 0 ? void 0 : d.description;
    },
    filterMethod: function filterMethod(filter, rows) {
      return (0, _matchSorter["default"])(rows, filter.value, {
        keys: ['desc']
      });
    },
    filterAll: true
  };
  var columnsList = new Array();
  columnsList.push(nameColumn);

  if (width > _System.TIGHT_FIT_PARAM) {
    columnsList.push(descColumn);
  }

  return _react["default"].createElement("div", {
    style: {
      marginLeft: '10px',
      marginRight: '10px'
    }
  }, _react["default"].createElement(_reactTable["default"], {
    data: initiativeList,
    filterable: true,
    defaultFilterMethod: function defaultFilterMethod(filter, row) {
      return String(row[filter.id]) === filter.value;
    },
    columns: [{
      columns: columnsList
    }],
    defaultPageSize: 10,
    getTrProps: function getTrProps(state, rowInfo) {
      if (rowInfo && rowInfo.row) {
        return {
          onClick: function onClick() {
            var _rowInfo$original; // console.log(JSON.stringify(rowInfo?.index));


            dispatch((0, _initiative.setInitiative)(rowInfo === null || rowInfo === void 0 ? void 0 : (_rowInfo$original = rowInfo.original) === null || _rowInfo$original === void 0 ? void 0 : _rowInfo$original.id));
            setSelected(rowInfo.index);
          },
          style: {
            background: rowInfo.index === selected ? '#cfd8dc' : 'white',
            color: rowInfo.index === selected ? 'black' : 'black'
          }
        };
      } else {
        return {};
      }
    }
  }));
};

var _default = InitiativeTable;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(InitiativeTable, "InitiativeTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeTable/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeTable/index.js");

  __REACT_HOT_LOADER__.register(_matchSorter, "_matchSorter", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeTable/index.js");

  __REACT_HOT_LOADER__.register(_reactTable, "_reactTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeTable/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeTable/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeTable/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeTable/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeTable/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeTable/index.js");

  __REACT_HOT_LOADER__.register(InitiativeTable, "InitiativeTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeTable/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeTable/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeTable/index.js");
}();

;

/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _initiative = __webpack_require__(101);

var _moment = _interopRequireDefault(__webpack_require__(2));

var _DateService = __webpack_require__(48);

var _Validation = __webpack_require__(14);

var _common = __webpack_require__(829);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var InitiativeAdd = function InitiativeAdd() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var addInitiativeState = (0, _reactRedux.useSelector)(function (state) {
    return state.initiatives.addInitiativeState;
  });
  var allProjects = (0, _reactRedux.useSelector)(function (state) {
    return state.projects.allProject;
  });

  var _useState = (0, _react.useState)(initProps),
      _useState2 = _slicedToArray(_useState, 2),
      selectedInitiative = _useState2[0],
      setSelectedInitiative = _useState2[1];

  var _useState3 = (0, _react.useState)({
    name: ''
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      formErrors = _useState4[0],
      setFormErrors = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      formValid = _useState6[0],
      setFormValid = _useState6[1];

  (0, _react.useEffect)(function () {
    setSelectedInitiative(initProps());
  }, [addInitiativeState]); // using selectedInitiative makes it behave like componentDidUpdate - effect takes place when selectedInitiative changes

  (0, _react.useEffect)(function () {
    setFormValid(false);
    validateForm();
  }, [selectedInitiative]);

  var initProps = function initProps() {
    return {
      id: '',
      orgid: '',
      name: '',
      description: '',
      status: '',
      projectId: '',
      products: [],
      startDate: '',
      endDate: '',
      budget: 0,
      starred: false,
      frequently: false
    };
  };

  var handleUserInput = function handleUserInput(event, isNumber) {
    var name = event.target.name;
    var value = event.target.value;

    if (isNumber) {
      value = Number(event.target.value);
    }

    updateSelectedInitiativeField(name, value);
    validateField(name, value);
  };

  var handleDateInput = function handleDateInput(name, value) {
    updateSelectedInitiativeField(name, value);
    validateDateFields(name, value);
    validateForm();
  };

  var updateSelectedInitiativeField = function updateSelectedInitiativeField(fieldName, value) {
    var newInitiative = _objectSpread({}, selectedInitiative);

    newInitiative[fieldName] = value;
    setSelectedInitiative(newInitiative);
  };

  var validateDateFields = function validateDateFields(name, value) {
    formErrors['dates'] = '';

    switch (name) {
      case 'endDate':
        // check its not before the start date
        if ((0, _Validation.isValueEntered)(value) && (0, _Validation.isValueEntered)(selectedInitiative === null || selectedInitiative === void 0 ? void 0 : selectedInitiative.startDate)) {
          if ((0, _DateService.isDateBefore)((0, _moment["default"])(value), (0, _moment["default"])(selectedInitiative === null || selectedInitiative === void 0 ? void 0 : selectedInitiative.startDate))) {
            formErrors['dates'] = ' are invalid. The end date selected cannot be before the start date';
          }
        }

        break;

      case 'startDate':
        // check its not after the end date
        if ((0, _Validation.isValueEntered)(selectedInitiative === null || selectedInitiative === void 0 ? void 0 : selectedInitiative.endDate) && (0, _Validation.isValueEntered)(value)) {
          if ((0, _DateService.isDateBefore)((0, _moment["default"])(selectedInitiative === null || selectedInitiative === void 0 ? void 0 : selectedInitiative.endDate), (0, _moment["default"])(value))) {
            formErrors['dates'] = ' are invalid. The start date selected cannot be after the end date';
          }
        }

        break;

      default:
        break;
    }
  };

  var validateField = function validateField(fieldName, value) {
    formErrors[fieldName] = (0, _common.getFormError)(fieldName, value);
    setFormErrors(formErrors);
    validateForm();
  };

  var validateForm = function validateForm() {
    setFormValid((0, _common.isFormValid)(selectedInitiative) && (0, _common.checkDatesValid)(selectedInitiative));
  };

  var maintainButton = function maintainButton(label) {
    return _react["default"].createElement(_reactstrap.Button, {
      className: "text-uppercase",
      disabled: !formValid,
      color: "primary",
      onClick: function onClick() {
        dispatch((0, _initiative.showInitiativeLoader)());
        dispatch((0, _initiative.onInitiativeClose)());
        dispatch((0, _initiative.onSaveInitiative)(selectedInitiative));
        setSelectedInitiative(initProps());
        setFormValid(false);
      }
    }, label);
  };

  var modalHeaderOnClick = function modalHeaderOnClick() {
    return function () {
      setFormValid(false);
      dispatch((0, _initiative.onInitiativeClose)());
    };
  };

  var modalBody = function modalBody(buttonText) {
    return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
      className: "modal-box-content"
    }, _react["default"].createElement("div", {
      className: "row no-gutters"
    }, (0, _common.displayedImage)(selectedInitiative), (0, _common.showErrors)(formErrors), (0, _common.inputFields)(selectedInitiative, allProjects, handleUserInput, handleDateInput))), _react["default"].createElement("div", {
      className: "modal-box-footer d-flex flex-row"
    }, maintainButton(buttonText)));
  };

  return _react["default"].createElement(_reactstrap.Modal, {
    className: "modal-box",
    isOpen: addInitiativeState
  }, (0, _common.modalHeader)(_react["default"].createElement(_IntlMessages["default"], {
    id: "initiative.addInitiative"
  }), modalHeaderOnClick), modalBody(_react["default"].createElement(_IntlMessages["default"], {
    id: "initiative.addInitiative"
  })));
};

var _default = InitiativeAdd;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(InitiativeAdd, "InitiativeAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeAdd/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeAdd/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeAdd/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeAdd/index.js");

  __REACT_HOT_LOADER__.register(_moment, "_moment", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeAdd/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeAdd/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeAdd/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeAdd/index.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeAdd/index.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeAdd/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeAdd/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeAdd/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeAdd/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeAdd/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeAdd/index.js");

  __REACT_HOT_LOADER__.register(InitiativeAdd, "InitiativeAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeAdd/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeAdd/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeAdd/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/initiative/initiativeMaintenance/initiativeAdd/index.js");
}();

;

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _component["default"];
  }
});

var _component = _interopRequireDefault(__webpack_require__(1975));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_component, "_component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/index.js");
}();

;

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _rcDrawer = _interopRequireDefault(__webpack_require__(31));

var _reactNotifications = __webpack_require__(30);

var _reactstrap = __webpack_require__(6);

var _issueDetail = _interopRequireDefault(__webpack_require__(1976));

var _issueTable = _interopRequireDefault(__webpack_require__(1979));

var _issueAdd = _interopRequireDefault(__webpack_require__(1980));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _CircularProgress = _interopRequireDefault(__webpack_require__(24));

var _CustomScrollbars = _interopRequireDefault(__webpack_require__(27));

var _issue = __webpack_require__(147);

var _feature = __webpack_require__(114);

var _member = __webpack_require__(100);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Component = function Component() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var width = (0, _reactRedux.useSelector)(function (state) {
    return state.settings.width;
  });
  var loader = (0, _reactRedux.useSelector)(function (state) {
    return state.issues.loader;
  });
  var alertMessage = (0, _reactRedux.useSelector)(function (state) {
    return state.issues.alertMessage;
  });
  var showMessage = (0, _reactRedux.useSelector)(function (state) {
    return state.issues.showMessage;
  });
  var noContentFoundMessage = (0, _reactRedux.useSelector)(function (state) {
    return state.issues.noContentFoundMessage;
  });
  var drawerState = (0, _reactRedux.useSelector)(function (state) {
    return state.issues.drawerState;
  });
  var issue = (0, _reactRedux.useSelector)(function (state) {
    return state.issues.issue;
  });
  var issueList = (0, _reactRedux.useSelector)(function (state) {
    return state.issues.issueList;
  });
  (0, _react.useEffect)(function () {
    dispatch((0, _issue.showIssueLoader)());
    dispatch((0, _issue.fetchIssues)());
    dispatch((0, _feature.fetchFeatures)());
    dispatch((0, _member.fetchMembers)());
  }, []);

  var issueSideBar = function issueSideBar() {
    return _react["default"].createElement("div", {
      className: "module-side"
    }, _react["default"].createElement("div", {
      className: "module-side-header"
    }, _react["default"].createElement("div", {
      className: "module-logo"
    }, _react["default"].createElement("i", {
      className: "zmdi zmdi-city-alt mr-4"
    }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
      id: "sidebar.issues"
    })))), _react["default"].createElement("div", {
      className: "module-side-content"
    }, _react["default"].createElement(_CustomScrollbars["default"], {
      className: "module-side-scroll scrollbar",
      style: {
        height: width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)'
      }
    }, _react["default"].createElement("div", {
      className: "module-add-task"
    }, _react["default"].createElement(_reactstrap.Button, {
      className: "btn-block jr-btn",
      color: "primary",
      onClick: function onClick() {
        return dispatch((0, _issue.onAddIssue)());
      }
    }, _react["default"].createElement("i", {
      className: "zmdi zmdi-accounts-add zmdi-hc-fw"
    }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
      id: "issue.addIssue"
    })))))));
  };

  var issueRequestClose = function issueRequestClose() {
    dispatch((0, _issue.handleIssueRequestClose)());
  };

  return _react["default"].createElement("div", {
    className: "app-wrapper"
  }, _react["default"].createElement("div", {
    className: "app-module animated slideInUpTiny animation-duration-3"
  }, _react["default"].createElement("div", {
    className: "d-block d-xl-none"
  }, _react["default"].createElement(_rcDrawer["default"], {
    touch: true,
    transitions: true,
    enableDragHandle: true,
    open: drawerState,
    onOpenChange: function onOpenChange() {
      return dispatch((0, _issue.onToggleIssueDrawer)());
    },
    sidebar: issueSideBar(issue)
  })), _react["default"].createElement("div", {
    className: "app-module-sidenav d-none d-xl-flex"
  }, issueSideBar(issue)), _react["default"].createElement("div", {
    className: "module-box"
  }, _react["default"].createElement("div", {
    className: "module-box-content"
  }, _react["default"].createElement("div", {
    className: "module-box-header"
  }, _react["default"].createElement("span", {
    className: "icon-btn drawer-btn d-flex d-xl-none",
    onClick: function onClick() {
      return dispatch((0, _issue.onToggleIssueDrawer)());
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-menu"
  }))), _react["default"].createElement(_CustomScrollbars["default"], {
    className: "module-list-scroll scrollbar",
    style: {
      height: width >= 1200 ? 'calc(108vh - 265px)' : 'calc(108vh - 245px)'
    }
  }, loader ? _react["default"].createElement("div", {
    className: "loader-view-block h-100"
  }, _react["default"].createElement("div", {
    className: "loader-view"
  }, _react["default"].createElement(_CircularProgress["default"], null))) : issueList && issueList.length > 0 ? _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
    className: "app-main-content"
  }, _react["default"].createElement(_issueTable["default"], null), _react["default"].createElement("div", {
    style: {
      marginTop: 10
    }
  }, _react["default"].createElement(_issueDetail["default"], null)))) : _react["default"].createElement("div", {
    className: "h-100 d-flex align-items-center justify-content-center"
  }, noContentFoundMessage))))), _react["default"].createElement(_issueAdd["default"], null), showMessage && _reactNotifications.NotificationManager.success(alertMessage, issueRequestClose()), _react["default"].createElement(_reactNotifications.NotificationContainer, null));
};

var _default = Component;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/component.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/component.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/component.js");

  __REACT_HOT_LOADER__.register(_rcDrawer, "_rcDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/component.js");

  __REACT_HOT_LOADER__.register(_issueDetail, "_issueDetail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/component.js");

  __REACT_HOT_LOADER__.register(_issueTable, "_issueTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/component.js");

  __REACT_HOT_LOADER__.register(_issueAdd, "_issueAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/component.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/component.js");

  __REACT_HOT_LOADER__.register(_CircularProgress, "_CircularProgress", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/component.js");

  __REACT_HOT_LOADER__.register(_CustomScrollbars, "_CustomScrollbars", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/component.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/component.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/component.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/component.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/component.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/component.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/component.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/component.js");
}();

;

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _issueDetailTable = _interopRequireDefault(__webpack_require__(1977));

var _featureDetailTable = _interopRequireDefault(__webpack_require__(422));

var _issueEdit = _interopRequireDefault(__webpack_require__(1978));

var _issueService = __webpack_require__(660);

var _featureService = __webpack_require__(822);

var _issue = __webpack_require__(147);

var _deleteItemCheck = _interopRequireDefault(__webpack_require__(227));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
} // import { TIGHT_FIT_PARAM } from 'constants/System';


var IssueDetail = function IssueDetail() {
  // const defaultWidth = width > TIGHT_FIT_PARAM ? 150 : 80;
  var dispatch = (0, _reactRedux.useDispatch)(); // const allValueStreams = useSelector(state => state.valueStreams.allValueStream);

  var selectedIssue = (0, _reactRedux.useSelector)(function (state) {
    return state.issues.selectedIssue;
  });
  var selectedOrg = (0, _reactRedux.useSelector)(function (state) {
    return state.orgs.selectedOrg;
  });

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      featureDisplayData = _useState2[0],
      setFeatureDisplayData = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      displayData = _useState4[0],
      setDisplayData = _useState4[1];

  (0, _react.useEffect)(function () {
    // TODO - do not fetch if no selected issue
    var mounted = true; // fix warning on no-op state when component not mounted https://www.debuggr.io/react-update-unmounted-component/

    var issuePromise = new Promise(function (resolve) {
      return resolve((0, _issueService.getIssueDisplayData)(selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.id, selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id));
    });
    var featurePromise = new Promise(function (resolve) {
      return resolve((0, _featureService.getFeatureDisplayData)(selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.featureId, selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id));
    });

    var fetchDisplayData =
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(ready) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!ready) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return Promise.all([issuePromise, featurePromise].map(function (result) {
                  return result["catch"](function (error) {
                    return error;
                  });
                })).then(function (values) {
                  var _values = _slicedToArray(values, 2),
                      issueDisplayData = _values[0],
                      featureDisplayData = _values[1];

                  setDisplayData(issueDisplayData);
                  setFeatureDisplayData(featureDisplayData);
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetchDisplayData(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    fetchDisplayData(mounted);
    return function () {
      return mounted = false;
    };
  }, [selectedIssue]);

  var mainIcon = function mainIcon() {
    // TODO pass in type to change the icon on the detail tab
    // if (type && type.toLowerCase() === 'high') {
    //     return 'stream';
    // }
    // if (type && type.toLowerCase() === 'medium') {
    //     return 'compact';
    // }
    // if (type && type.toLowerCase() === 'low') {
    //     return 'module';
    // }
    return 'dashboard';
  };

  if (selectedIssue) {
    // const fields = { ...selectedIssue?.fields };
    return _react["default"].createElement("div", {
      className: "dashboard animated slideInUpTiny animation-duration-3"
    }, _react["default"].createElement("div", {
      className: "row"
    }, _react["default"].createElement("div", {
      className: "col-md-7 col-12"
    }, _react["default"].createElement("div", {
      className: "jr-card jr-card-full-height ml-2 mr-2"
    }, _react["default"].createElement("div", {
      className: "jr-card-header d-flex"
    }, _react["default"].createElement("div", {
      className: "mr-auto"
    }, _react["default"].createElement("h2", {
      className: "card-heading"
    }, displayData === null || displayData === void 0 ? void 0 : displayData.name)), _react["default"].createElement("div", null, _react["default"].createElement(_deleteItemCheck["default"], {
      id: selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.id,
      onConfirm: _issue.onDeleteIssue,
      alertMessage: _react["default"].createElement(_IntlMessages["default"], {
        id: "issue.deleteIssue"
      })
    }), _react["default"].createElement(_reactstrap.Button, {
      size: "sm",
      color: "primary",
      onClick: function onClick() {
        return dispatch((0, _issue.onEditIssue)(selectedIssue));
      }
    }, _react["default"].createElement("i", {
      className: "zmdi zmdi-edit zmdi-hc-fw"
    }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
      id: "label.edit"
    }))))), _react["default"].createElement("div", {
      className: "jr-card-body"
    }, _react["default"].createElement("div", {
      className: "row"
    }, _react["default"].createElement("div", {
      className: "col-sm-3"
    }, _react["default"].createElement("div", {
      className: "temp-section mb-4 mb-sm-0 text-center text-sm-left"
    }, _react["default"].createElement("p", null, _react["default"].createElement("i", {
      className: "detail-icon text-blue-grey zmdi zmdi-view-".concat(mainIcon(), " zmdi-hc-fw")
    })))), _react["default"].createElement("div", {
      className: "col-sm-9 text-center text-sm-left"
    }, _react["default"].createElement(_issueDetailTable["default"], {
      displayData: displayData
    }))))), _react["default"].createElement(_issueEdit["default"], null)), _react["default"].createElement("div", {
      className: "col-md-5"
    }, _react["default"].createElement("div", {
      className: "jr-card jr-card-full-height ml-2 mr-2"
    }, _react["default"].createElement("div", {
      className: "mr-auto"
    }, _react["default"].createElement("h2", {
      className: "card-heading"
    }, _react["default"].createElement(_IntlMessages["default"], {
      id: "label.feature"
    }))), _react["default"].createElement("div", null, _react["default"].createElement(_featureDetailTable["default"], {
      displayData: featureDisplayData
    }))))));
  } else {
    return _react["default"].createElement("div", {
      className: "dashboard animated slideInUpTiny animation-duration-3"
    }, _react["default"].createElement("div", {
      className: "row"
    }, _react["default"].createElement("div", {
      className: "col-md-12 col-12"
    }, _react["default"].createElement("div", {
      className: "jr-card jr-card-full-height"
    }, _react["default"].createElement("div", {
      className: "jr-card-header d-flex"
    }, _react["default"].createElement("div", {
      className: "mr-auto"
    }, _react["default"].createElement("h3", {
      className: "card-heading"
    }, "Please select an entry to display details")))))));
  }
};

var _default = IssueDetail;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(IssueDetail, "IssueDetail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueDetail/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueDetail/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueDetail/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueDetail/index.js");

  __REACT_HOT_LOADER__.register(_issueDetailTable, "_issueDetailTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueDetail/index.js");

  __REACT_HOT_LOADER__.register(_featureDetailTable, "_featureDetailTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueDetail/index.js");

  __REACT_HOT_LOADER__.register(_issueEdit, "_issueEdit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueDetail/index.js");

  __REACT_HOT_LOADER__.register(_deleteItemCheck, "_deleteItemCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueDetail/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueDetail/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueDetail/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueDetail/index.js");

  __REACT_HOT_LOADER__.register(asyncGeneratorStep, "asyncGeneratorStep", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueDetail/index.js");

  __REACT_HOT_LOADER__.register(_asyncToGenerator, "_asyncToGenerator", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueDetail/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueDetail/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueDetail/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueDetail/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueDetail/index.js");

  __REACT_HOT_LOADER__.register(IssueDetail, "IssueDetail", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueDetail/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueDetail/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueDetail/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueDetail/index.js");
}();

;

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _basicDetailRow = _interopRequireDefault(__webpack_require__(157));

var _project = __webpack_require__(171);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var IssueDetailTable = function IssueDetailTable(_ref) {
  var displayData = _ref.displayData;

  if (displayData) {
    return _react["default"].createElement("table", {
      className: "default-table table table-sm table-responsive-sm table-hover"
    }, _react["default"].createElement("tbody", null, _react["default"].createElement(_basicDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.description"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.description
    }), _react["default"].createElement(_basicDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.type"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.type
    }), _react["default"].createElement(_basicDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.assignee"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.assignee
    }), _react["default"].createElement(_basicDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.feature"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.feature
    }), _react["default"].createElement(_basicDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.startDate"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.startDate
    }), _react["default"].createElement(_basicDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.endDate"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.endDate
    }), (displayData === null || displayData === void 0 ? void 0 : displayData.type) === _project.ISSUE_TYPE_RELEASE ? _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(_basicDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.releaseEnv"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.releaseEnv
    }), _react["default"].createElement(_basicDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.releaseDate"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.releaseDate
    }), _react["default"].createElement(_basicDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.releaseCutoffDate"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.releaseCutoffDate
    }), _react["default"].createElement(_basicDetailRow["default"], {
      label: _react["default"].createElement(_IntlMessages["default"], {
        id: "label.releaseVersion"
      }),
      description: displayData === null || displayData === void 0 ? void 0 : displayData.releaseVersion
    })) : null));
  } else {
    return _react["default"].createElement(_react.Fragment, null);
  }
};

var _default = IssueDetailTable;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(IssueDetailTable, "IssueDetailTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueDetail/issueDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueDetail/issueDetailTable/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueDetail/issueDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueDetail/issueDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_basicDetailRow, "_basicDetailRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueDetail/issueDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueDetail/issueDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueDetail/issueDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueDetail/issueDetailTable/index.js");

  __REACT_HOT_LOADER__.register(IssueDetailTable, "IssueDetailTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueDetail/issueDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueDetail/issueDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueDetail/issueDetailTable/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueDetail/issueDetailTable/index.js");
}();

;

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _issue = __webpack_require__(147);

var _common = __webpack_require__(830);

var _Validation = __webpack_require__(14);

var _moment = _interopRequireDefault(__webpack_require__(2));

var _DateService = __webpack_require__(48);

var _project = __webpack_require__(171);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var IssueEdit = function IssueEdit() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var editIssueState = (0, _reactRedux.useSelector)(function (state) {
    return state.issues.editIssueState;
  });
  var allMembers = (0, _reactRedux.useSelector)(function (state) {
    return state.members.allMember;
  });
  var allFeatures = (0, _reactRedux.useSelector)(function (state) {
    return state.features.allFeature;
  });
  var issue = (0, _reactRedux.useSelector)(function (state) {
    return state.issues.selectedIssue;
  });

  var _useState = (0, _react.useState)(issue),
      _useState2 = _slicedToArray(_useState, 2),
      selectedIssue = _useState2[0],
      setSelectedIssue = _useState2[1];

  var _useState3 = (0, _react.useState)({
    name: ''
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      formErrors = _useState4[0],
      setFormErrors = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      formValid = _useState6[0],
      setFormValid = _useState6[1]; // using selectedIssue makes it behave like componentDidUpdate - effect takes place when selectedIssue changes


  (0, _react.useEffect)(function () {
    setSelectedIssue(issue);
    setFormValid(false);
    validateForm();
  }, [issue]); // using selectedIssue makes it behave like componentDidUpdate - effect takes place when selectedIssue changes

  (0, _react.useEffect)(function () {
    setFormValid(false);
    validateForm();
  }, [selectedIssue]);

  var handleUserInput = function handleUserInput(event, isNumber) {
    var name = event.target.name;
    var value = event.target.value;

    if (isNumber) {
      value = Number(event.target.value);
    }

    updateSelectedIssueField(name, value);
    validateField(name, value);
  };

  var handleDateInput = function handleDateInput(fieldName, value) {
    updateSelectedIssueField(fieldName, value);
    validateDateFields(fieldName, value);
    validateForm();
  };

  var updateSelectedIssueField = function updateSelectedIssueField(fieldName, value) {
    var newIssue = _objectSpread({}, selectedIssue);

    newIssue[fieldName] = value;
    setSelectedIssue(newIssue);
  };

  var validateDateFields = function validateDateFields(name, value) {
    formErrors['dates'] = '';
    formErrors['releaseDate'] = ''; // may be mandatory if type = Release

    formErrors['releaseDates'] = ''; // check

    switch (name) {
      case 'endDate':
        // check its not before the start date
        if ((0, _Validation.isValueEntered)(value) && (0, _Validation.isValueEntered)(selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.startDate)) {
          if ((0, _DateService.isDateBefore)((0, _moment["default"])(value), (0, _moment["default"])(selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.startDate))) {
            formErrors['dates'] = ' are invalid. The end date selected cannot be before the start date';
          }
        }

        break;

      case 'startDate':
        // check its not after the end date
        if ((0, _Validation.isValueEntered)(selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.endDate) && (0, _Validation.isValueEntered)(value)) {
          if ((0, _DateService.isDateBefore)((0, _moment["default"])(selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.endDate), (0, _moment["default"])(value))) {
            formErrors['dates'] = ' are invalid. The start date selected cannot be after the end date';
          }
        }

        break;

      case 'releaseDate':
        // check its not before the start date
        if (_project.ISSUE_TYPE_RELEASE === (selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.type)) {
          if ((0, _Validation.isValueEntered)(value) && (0, _Validation.isValueEntered)(selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.releaseCutoffDate)) {
            if ((0, _DateService.isDateBefore)((0, _moment["default"])(value), (0, _moment["default"])(selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.releaseCutoffDate))) {
              formErrors['releaseDates'] = ' are invalid. The release date selected cannot be before the release cutoff date';
            }
          }
        }

        break;

      case 'releaseCutoffDate':
        // check its not before the start date
        if (_project.ISSUE_TYPE_RELEASE === (selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.type)) {
          if ((0, _Validation.isValueEntered)(selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.releaseDate) && (0, _Validation.isValueEntered)(value)) {
            if ((0, _DateService.isDateBefore)((0, _moment["default"])(selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.releaseDate), (0, _moment["default"])(value))) {
              formErrors['releaseDates'] = ' are invalid. The release cutoff date selected cannot be after the release date';
            }
          }
        }

        break;

      default:
        break;
    }
  };

  var validateField = function validateField(fieldName, value) {
    formErrors[fieldName] = (0, _common.getFormError)(fieldName, value, selectedIssue);
    setFormErrors(formErrors);
    validateForm();
  };

  var validateForm = function validateForm() {
    setFormValid((0, _common.isFormValid)(selectedIssue) && (0, _common.checkDatesValid)(selectedIssue));
  };

  var maintainButton = function maintainButton(label) {
    return _react["default"].createElement(_reactstrap.Button, {
      className: "text-uppercase",
      disabled: !formValid,
      color: "primary",
      onClick: function onClick() {
        dispatch((0, _issue.showIssueLoader)());
        dispatch((0, _issue.onIssueClose)());
        dispatch((0, _issue.onSaveIssue)(selectedIssue));
        setFormValid(false);
      }
    }, label);
  };

  var modalHeaderOnClick = function modalHeaderOnClick() {
    return function () {
      setFormValid(false);
      dispatch((0, _issue.onIssueClose)());
    };
  };

  var modalBody = function modalBody(buttonText) {
    return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
      className: "modal-box-content"
    }, _react["default"].createElement("div", {
      className: "row no-gutters"
    }, (0, _common.displayedImage)(selectedIssue), (0, _common.showErrors)(formErrors), (0, _common.inputFields)(selectedIssue, allFeatures, allMembers, handleUserInput, handleDateInput))), _react["default"].createElement("div", {
      className: "modal-box-footer d-flex flex-row"
    }, maintainButton(buttonText)));
  };

  return _react["default"].createElement(_reactstrap.Modal, {
    className: "modal-box",
    isOpen: editIssueState
  }, (0, _common.modalHeader)(_react["default"].createElement(_IntlMessages["default"], {
    id: "issue.saveIssue"
  }), modalHeaderOnClick), modalBody(_react["default"].createElement(_IntlMessages["default"], {
    id: "issue.saveIssue"
  })));
};

var _default = IssueEdit;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(IssueEdit, "IssueEdit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueEdit/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueEdit/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueEdit/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueEdit/index.js");

  __REACT_HOT_LOADER__.register(_moment, "_moment", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueEdit/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueEdit/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueEdit/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueEdit/index.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueEdit/index.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueEdit/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueEdit/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueEdit/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueEdit/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueEdit/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueEdit/index.js");

  __REACT_HOT_LOADER__.register(IssueEdit, "IssueEdit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueEdit/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueEdit/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueEdit/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueEdit/index.js");
}();

;

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _matchSorter = _interopRequireDefault(__webpack_require__(95));

var _reactTable = _interopRequireDefault(__webpack_require__(93));

__webpack_require__(94);

var _issue = __webpack_require__(147);

var _System = __webpack_require__(55);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var IssueTable = function IssueTable() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var issueList = (0, _reactRedux.useSelector)(function (state) {
    return state.issues.issueList;
  });
  var selectedIssue = (0, _reactRedux.useSelector)(function (state) {
    return state.issues.selectedIssue;
  });
  var width = (0, _reactRedux.useSelector)(function (state) {
    return state.settings.width;
  });

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  (0, _react.useLayoutEffect)(function () {
    var selected = issueList.findIndex(function (entry) {
      return (entry === null || entry === void 0 ? void 0 : entry.id) === (selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.id);
    }) || 0;
    setSelected(selected);
  }, []);

  var styledSummaryColumn = function styledSummaryColumn(value) {
    return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("span", {
      className: "d-inline-block text-black"
    }, _react["default"].createElement("div", {
      className: "font-weight-bold"
    }, value)));
  };

  var nameColumn = {
    Header: 'Name',
    id: 'name',
    accessor: function accessor(d) {
      return d === null || d === void 0 ? void 0 : d.name;
    },
    filterMethod: function filterMethod(filter, rows) {
      return (0, _matchSorter["default"])(rows, filter.value, {
        keys: ['name']
      });
    },
    Cell: function Cell(_ref) {
      var value = _ref.value;
      return styledSummaryColumn(value);
    },
    filterAll: true
  };
  var descColumn = {
    Header: 'Description',
    id: 'desc',
    accessor: function accessor(d) {
      return d === null || d === void 0 ? void 0 : d.description;
    },
    filterMethod: function filterMethod(filter, rows) {
      return (0, _matchSorter["default"])(rows, filter.value, {
        keys: ['desc']
      });
    },
    filterAll: true
  };
  var columnsList = new Array();
  columnsList.push(nameColumn);

  if (width > _System.TIGHT_FIT_PARAM) {
    columnsList.push(descColumn);
  }

  return _react["default"].createElement("div", {
    style: {
      marginLeft: '10px',
      marginRight: '10px'
    }
  }, _react["default"].createElement(_reactTable["default"], {
    data: issueList,
    filterable: true,
    defaultFilterMethod: function defaultFilterMethod(filter, row) {
      return String(row[filter.id]) === filter.value;
    },
    columns: [{
      columns: columnsList
    }],
    defaultPageSize: 10,
    getTrProps: function getTrProps(state, rowInfo) {
      if (rowInfo && rowInfo.row) {
        return {
          onClick: function onClick() {
            var _rowInfo$original; // console.log(JSON.stringify(rowInfo?.index));


            dispatch((0, _issue.setIssue)(rowInfo === null || rowInfo === void 0 ? void 0 : (_rowInfo$original = rowInfo.original) === null || _rowInfo$original === void 0 ? void 0 : _rowInfo$original.id));
            setSelected(rowInfo.index);
          },
          style: {
            background: rowInfo.index === selected ? '#cfd8dc' : 'white',
            color: rowInfo.index === selected ? 'black' : 'black'
          }
        };
      } else {
        return {};
      }
    }
  }));
};

var _default = IssueTable;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(IssueTable, "IssueTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueTable/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueTable/index.js");

  __REACT_HOT_LOADER__.register(_matchSorter, "_matchSorter", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueTable/index.js");

  __REACT_HOT_LOADER__.register(_reactTable, "_reactTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueTable/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueTable/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueTable/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueTable/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueTable/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueTable/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueTable/index.js");

  __REACT_HOT_LOADER__.register(IssueTable, "IssueTable", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueTable/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueTable/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueTable/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueTable/index.js");
}();

;

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _issue = __webpack_require__(147);

var _common = __webpack_require__(830);

var _Validation = __webpack_require__(14);

var _moment = _interopRequireDefault(__webpack_require__(2));

var _DateService = __webpack_require__(48);

var _project = __webpack_require__(171);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var IssueAdd = function IssueAdd() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var addIssueState = (0, _reactRedux.useSelector)(function (state) {
    return state.issues.addIssueState;
  });
  var allMembers = (0, _reactRedux.useSelector)(function (state) {
    return state.members.allMember;
  });
  var allFeatures = (0, _reactRedux.useSelector)(function (state) {
    return state.features.allFeature;
  });

  var _useState = (0, _react.useState)(initProps),
      _useState2 = _slicedToArray(_useState, 2),
      selectedIssue = _useState2[0],
      setSelectedIssue = _useState2[1];

  var _useState3 = (0, _react.useState)({
    name: ''
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      formErrors = _useState4[0],
      setFormErrors = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      formValid = _useState6[0],
      setFormValid = _useState6[1];

  (0, _react.useEffect)(function () {
    setSelectedIssue(initProps());
  }, [addIssueState]); // using selectedIssue makes it behave like componentDidUpdate - effect takes place when selectedIssue changes

  (0, _react.useEffect)(function () {
    setFormValid(false);
    validateForm();
  }, [selectedIssue]);

  var initProps = function initProps() {
    return {
      id: '',
      orgid: '',
      name: '',
      description: '',
      type: '',
      startDate: '',
      endDate: '',
      releaseEnv: '',
      releaseDate: '',
      releaseCutoffDate: '',
      starred: false,
      frequently: false
    };
  };

  var handleUserInput = function handleUserInput(event, isNumber) {
    var name = event.target.name;
    var value = event.target.value;

    if (isNumber) {
      value = Number(event.target.value);
    }

    updateSelectedIssueField(name, value);
    validateField(name, value);
  };

  var handleDateInput = function handleDateInput(fieldName, value) {
    updateSelectedIssueField(fieldName, value);
    validateDateFields(name, value);
    validateForm();
  };

  var updateSelectedIssueField = function updateSelectedIssueField(fieldName, value) {
    var newIssue = _objectSpread({}, selectedIssue);

    newIssue[fieldName] = value;
    setSelectedIssue(newIssue);
  };

  var validateDateFields = function validateDateFields(name, value) {
    formErrors['dates'] = '';
    formErrors['releaseDate'] = ''; // may be mandatory if type = Release

    formErrors['releaseDates'] = ''; // check

    switch (name) {
      case 'endDate':
        // check its not before the start date
        if ((0, _Validation.isValueEntered)(value) && (0, _Validation.isValueEntered)(selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.startDate)) {
          if ((0, _DateService.isDateBefore)((0, _moment["default"])(value), (0, _moment["default"])(selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.startDate))) {
            formErrors['dates'] = ' are invalid. The end date selected cannot be before the start date';
          }
        }

        break;

      case 'startDate':
        // check its not after the end date
        if ((0, _Validation.isValueEntered)(selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.endDate) && (0, _Validation.isValueEntered)(value)) {
          if ((0, _DateService.isDateBefore)((0, _moment["default"])(selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.endDate), (0, _moment["default"])(value))) {
            formErrors['dates'] = ' are invalid. The start date selected cannot be after the end date';
          }
        }

        break;

      case 'releaseDate':
        // check its not before the start date
        if (_project.ISSUE_TYPE_RELEASE === (selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.type)) {
          if ((0, _Validation.isValueEntered)(value) && (0, _Validation.isValueEntered)(selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.releaseCutoffDate)) {
            if ((0, _DateService.isDateBefore)((0, _moment["default"])(value), (0, _moment["default"])(selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.releaseCutoffDate))) {
              formErrors['releaseDates'] = ' are invalid. The release date selected cannot be before the release cutoff date';
            }
          }
        }

        break;

      case 'releaseCutoffDate':
        // check its not before the start date
        if (_project.ISSUE_TYPE_RELEASE === (selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.type)) {
          if ((0, _Validation.isValueEntered)(selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.releaseDate) && (0, _Validation.isValueEntered)(value)) {
            if ((0, _DateService.isDateBefore)((0, _moment["default"])(selectedIssue === null || selectedIssue === void 0 ? void 0 : selectedIssue.releaseDate), (0, _moment["default"])(value))) {
              formErrors['releaseDates'] = ' are invalid. The release cutoff date selected cannot be after the release date';
            }
          }
        }

        break;

      default:
        break;
    }
  };

  var validateField = function validateField(fieldName, value) {
    formErrors[fieldName] = (0, _common.getFormError)(fieldName, value, selectedIssue);
    setFormErrors(formErrors);
    validateForm();
  };

  var validateForm = function validateForm() {
    setFormValid((0, _common.isFormValid)(selectedIssue) && (0, _common.checkDatesValid)(selectedIssue));
  };

  var maintainButton = function maintainButton(label) {
    return _react["default"].createElement(_reactstrap.Button, {
      className: "text-uppercase",
      disabled: !formValid,
      color: "primary",
      onClick: function onClick() {
        dispatch((0, _issue.showIssueLoader)());
        dispatch((0, _issue.onIssueClose)());
        dispatch((0, _issue.onSaveIssue)(selectedIssue));
        setSelectedIssue(initProps());
        setFormValid(false);
      }
    }, label);
  };

  var modalHeaderOnClick = function modalHeaderOnClick() {
    return function () {
      setFormValid(false);
      dispatch((0, _issue.onIssueClose)());
    };
  };

  var modalBody = function modalBody(buttonText) {
    return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
      className: "modal-box-content"
    }, _react["default"].createElement("div", {
      className: "row no-gutters"
    }, (0, _common.displayedImage)(selectedIssue), (0, _common.showErrors)(formErrors), (0, _common.inputFields)(selectedIssue, allFeatures, allMembers, handleUserInput, handleDateInput))), _react["default"].createElement("div", {
      className: "modal-box-footer d-flex flex-row"
    }, maintainButton(buttonText)));
  };

  return _react["default"].createElement(_reactstrap.Modal, {
    className: "modal-box",
    isOpen: addIssueState
  }, (0, _common.modalHeader)(_react["default"].createElement(_IntlMessages["default"], {
    id: "issue.addIssue"
  }), modalHeaderOnClick), modalBody(_react["default"].createElement(_IntlMessages["default"], {
    id: "issue.addIssue"
  })));
};

var _default = IssueAdd;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(IssueAdd, "IssueAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueAdd/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueAdd/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueAdd/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueAdd/index.js");

  __REACT_HOT_LOADER__.register(_moment, "_moment", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueAdd/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueAdd/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueAdd/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueAdd/index.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueAdd/index.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueAdd/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueAdd/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueAdd/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueAdd/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueAdd/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueAdd/index.js");

  __REACT_HOT_LOADER__.register(IssueAdd, "IssueAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueAdd/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueAdd/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueAdd/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/issue/issueMaintenance/issueAdd/index.js");
}();

;

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _component["default"];
  }
});

var _component = _interopRequireDefault(__webpack_require__(1982));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_component, "_component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/index.js");
}();

;

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _rcDrawer = _interopRequireDefault(__webpack_require__(31));

var _reactNotifications = __webpack_require__(30);

var _reactstrap = __webpack_require__(6);

var _projectBusPriorityList = _interopRequireDefault(__webpack_require__(1983));

var _index = _interopRequireDefault(__webpack_require__(66));

var _projectBusPriorityAdd = _interopRequireDefault(__webpack_require__(1986));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _CircularProgress = _interopRequireDefault(__webpack_require__(24));

var _CustomScrollbars = _interopRequireDefault(__webpack_require__(27));

var _projectBusPriority = __webpack_require__(180);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var filterOptions = [{
  id: 1,
  name: 'All projectBusPrioritys',
  icon: 'zmdi-menu'
}, {
  id: 2,
  name: 'Starred projectBusPrioritys',
  icon: 'zmdi-star'
}];

var Component = function Component() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var width = (0, _reactRedux.useSelector)(function (state) {
    return state.settings.width;
  });
  var loader = (0, _reactRedux.useSelector)(function (state) {
    return state.projectBusPrioritys.loader;
  });
  var alertMessage = (0, _reactRedux.useSelector)(function (state) {
    return state.projectBusPrioritys.alertMessage;
  });
  var showMessage = (0, _reactRedux.useSelector)(function (state) {
    return state.projectBusPrioritys.showMessage;
  });
  var noContentFoundMessage = (0, _reactRedux.useSelector)(function (state) {
    return state.projectBusPrioritys.noContentFoundMessage;
  });
  var drawerState = (0, _reactRedux.useSelector)(function (state) {
    return state.projectBusPrioritys.drawerState;
  });
  var projectBusPriority = (0, _reactRedux.useSelector)(function (state) {
    return state.projectBusPrioritys.projectBusPriority;
  });
  var searchProjectBusPriority = (0, _reactRedux.useSelector)(function (state) {
    return state.projectBusPrioritys.searchProjectBusPriority;
  });
  var projectBusPriorityList = (0, _reactRedux.useSelector)(function (state) {
    return state.projectBusPrioritys.projectBusPriorityList;
  });
  var selectedProjectBusPrioritys = (0, _reactRedux.useSelector)(function (state) {
    return state.projectBusPrioritys.selectedProjectBusPrioritys;
  });
  var addProjectBusPriorityState = (0, _reactRedux.useSelector)(function (state) {
    return state.projectBusPrioritys.addProjectBusPriorityState;
  });
  var selectedSectionId = (0, _reactRedux.useSelector)(function (state) {
    return state.projectBusPrioritys.selectedSectionId;
  });
  (0, _react.useEffect)(function () {
    dispatch((0, _projectBusPriority.showProjectBusPriorityLoader)());
    dispatch((0, _projectBusPriority.fetchProjectBusPrioritys)());
  }, []);

  var onAllProjectBusPrioritySelect = function onAllProjectBusPrioritySelect() {
    var selectAll = selectedProjectBusPrioritys < projectBusPriorityList.length;

    if (selectAll) {
      dispatch((0, _projectBusPriority.getAllProjectBusPriority)());
    } else {
      dispatch((0, _projectBusPriority.getUnselectedAllProjectBusPriority)());
    }
  };

  var updatingSearchProjectBusPriority = function updatingSearchProjectBusPriority(evt) {
    dispatch((0, _projectBusPriority.updateSearchProjectBusPriority)(evt.target.value));
    dispatch((0, _projectBusPriority.filterProjectBusPriority)(evt.target.value));
  };

  var projectBusPriorityRequestClose = function projectBusPriorityRequestClose() {
    dispatch((0, _projectBusPriority.handleProjectBusPriorityRequestClose)());
  };

  var projectBusPrioritySideBar = function projectBusPrioritySideBar() {
    return _react["default"].createElement("div", {
      className: "module-side"
    }, _react["default"].createElement("div", {
      className: "module-side-header"
    }, _react["default"].createElement("div", {
      className: "module-logo"
    }, _react["default"].createElement("i", {
      className: "zmdi zmdi-city-alt mr-4"
    }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
      id: "sidebar.projectBusPrioritys"
    })))), _react["default"].createElement("div", {
      className: "module-side-content"
    }, _react["default"].createElement(_CustomScrollbars["default"], {
      className: "module-side-scroll scrollbar",
      style: {
        height: width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)'
      }
    }, _react["default"].createElement("div", {
      className: "module-add-task"
    }, _react["default"].createElement(_reactstrap.Button, {
      className: "btn-block jr-btn",
      color: "primary",
      onClick: function onClick() {
        return dispatch((0, _projectBusPriority.onAddProjectBusPriority)());
      }
    }, _react["default"].createElement("i", {
      className: "zmdi zmdi-accounts-add zmdi-hc-fw"
    }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
      id: "projectBusPriority.addProjectBusPriority"
    })))), _react["default"].createElement("div", {
      className: "module-side-nav"
    }, _react["default"].createElement("ul", {
      className: "module-nav"
    }, filterOptions.map(function (option) {
      return _react["default"].createElement("li", {
        key: option.id,
        className: "nav-item"
      }, _react["default"].createElement("a", {
        href: "javascript:void(0)",
        className: option.id === selectedSectionId ? 'active' : '',
        onClick: function onClick() {
          return dispatch((0, _projectBusPriority.onFilterProjectBusPriorityOptionSelect)(option));
        }
      }, _react["default"].createElement("i", {
        className: "zmdi ".concat(option.icon)
      }), _react["default"].createElement("span", null, option.name)));
    }))))));
  };

  return _react["default"].createElement("div", {
    className: "app-wrapper"
  }, _react["default"].createElement("div", {
    className: "app-module animated slideInUpTiny animation-duration-3"
  }, _react["default"].createElement("div", {
    className: "d-block d-xl-none"
  }, _react["default"].createElement(_rcDrawer["default"], {
    touch: true,
    transitions: true,
    enableDragHandle: true,
    open: drawerState,
    onOpenChange: function onOpenChange() {
      return dispatch((0, _projectBusPriority.onToggleProjectBusPriorityDrawer)());
    },
    sidebar: projectBusPrioritySideBar(projectBusPriority)
  })), _react["default"].createElement("div", {
    className: "app-module-sidenav d-none d-xl-flex"
  }, projectBusPrioritySideBar(projectBusPriority)), _react["default"].createElement("div", {
    className: "module-box"
  }, _react["default"].createElement("div", {
    className: "module-box-header"
  }, _react["default"].createElement("span", {
    className: "icon-btn drawer-btn d-flex d-xl-none",
    onClick: function onClick() {
      return dispatch((0, _projectBusPriority.onToggleProjectBusPriorityDrawer)());
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-menu"
  })), _react["default"].createElement(_index["default"], {
    placeholder: "Search projectBusPriority",
    notification: false,
    apps: false,
    user: projectBusPriority,
    onChange: function onChange(event) {
      return updatingSearchProjectBusPriority(event);
    },
    value: searchProjectBusPriority
  })), _react["default"].createElement("div", {
    className: "module-box-content"
  }, _react["default"].createElement("div", {
    className: "module-box-topbar"
  }, _react["default"].createElement("div", {
    className: "form-control-checkbox d-flex"
  }, _react["default"].createElement("div", {
    className: "form-checkbox"
  }, _react["default"].createElement("input", {
    type: "checkbox",
    checked: selectedProjectBusPrioritys > 0,
    onChange: onAllProjectBusPrioritySelect
  }), _react["default"].createElement("span", {
    className: "check"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-check zmdi-hc-lg"
  })))), _react["default"].createElement(_reactstrap.Button, {
    size: "sm",
    className: "jr-btn jr-flat-btn",
    color: "default",
    onClick: function onClick() {
      return dispatch((0, _projectBusPriority.onFilterSelectedProjectBusPriority)());
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-filter-list zmdi-hc-fw"
  }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.filter.selected"
  })))), _react["default"].createElement(_CustomScrollbars["default"], {
    className: "module-list-scroll scrollbar",
    style: {
      height: width >= 1200 ? 'calc(100vh - 265px)' : 'calc(100vh - 245px)'
    }
  }, loader ? _react["default"].createElement("div", {
    className: "loader-view-block h-100"
  }, _react["default"].createElement("div", {
    className: "loader-view"
  }, _react["default"].createElement(_CircularProgress["default"], null))) : projectBusPriorityList && projectBusPriorityList.length > 0 ? _react["default"].createElement(_projectBusPriorityList["default"], null) : _react["default"].createElement("div", {
    className: "h-100 d-flex align-items-center justify-content-center"
  }, noContentFoundMessage))))), _react["default"].createElement(_projectBusPriorityAdd["default"], {
    open: addProjectBusPriorityState
  }), showMessage && _reactNotifications.NotificationManager.success(alertMessage, projectBusPriorityRequestClose()), _react["default"].createElement(_reactNotifications.NotificationContainer, null));
};

var _default = Component;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(filterOptions, "filterOptions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/component.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/component.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/component.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/component.js");

  __REACT_HOT_LOADER__.register(_rcDrawer, "_rcDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/component.js");

  __REACT_HOT_LOADER__.register(_projectBusPriorityList, "_projectBusPriorityList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/component.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/component.js");

  __REACT_HOT_LOADER__.register(_projectBusPriorityAdd, "_projectBusPriorityAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/component.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/component.js");

  __REACT_HOT_LOADER__.register(_CircularProgress, "_CircularProgress", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/component.js");

  __REACT_HOT_LOADER__.register(_CustomScrollbars, "_CustomScrollbars", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/component.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/component.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/component.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/component.js");

  __REACT_HOT_LOADER__.register(filterOptions, "filterOptions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/component.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/component.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/component.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/component.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/component.js");
}();

;

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _index = _interopRequireDefault(__webpack_require__(1984));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ProjectBusPriorityList = function ProjectBusPriorityList() {
  var projectBusPriorityList = (0, _reactRedux.useSelector)(function (state) {
    return state.projectBusPrioritys.projectBusPriorityList;
  });
  return _react["default"].createElement("div", {
    className: "app-main-content"
  }, projectBusPriorityList.map(function (entry, index) {
    return _react["default"].createElement(_index["default"], {
      key: index,
      projectBusPriority: entry
    });
  }));
};

var _default = ProjectBusPriorityList;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProjectBusPriorityList, "ProjectBusPriorityList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityList/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityList/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityList/index.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityList/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityList/index.js");

  __REACT_HOT_LOADER__.register(ProjectBusPriorityList, "ProjectBusPriorityList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityList/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityList/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityList/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityList/index.js");
}();

;

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _store = __webpack_require__(54);

var _reactBootstrapSweetalert = _interopRequireDefault(__webpack_require__(80));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _listRowImage = _interopRequireDefault(__webpack_require__(126));

var _ListRowFavourite = _interopRequireDefault(__webpack_require__(127));

var _ListRowCheckbox = _interopRequireDefault(__webpack_require__(107));

var _ListRowData = _interopRequireDefault(__webpack_require__(129));

var _ListRowDropdown = _interopRequireDefault(__webpack_require__(128));

var _index = _interopRequireDefault(__webpack_require__(1985));

var _projectBusPriority = __webpack_require__(180);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ProjectBusPriorityRow = function ProjectBusPriorityRow(props) {
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      menuState = _useState2[0],
      setMenuState = _useState2[1];

  var _useState3 = (0, _react.useState)(props.projectBusPriority),
      _useState4 = _slicedToArray(_useState3, 2),
      projectBusPriority = _useState4[0],
      setProjectBusPriority = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      deleteProjectBusPriorityCheck = _useState6[0],
      setDeleteProjectBusPriorityCheck = _useState6[1];

  var width = (0, _reactRedux.useSelector)(function (state) {
    return state.settings.width;
  }); // const { projectBusPriority } = props;

  (0, _react.useEffect)(function () {
    setProjectBusPriority(props.projectBusPriority);
  }, [props]);
  var name = projectBusPriority.name,
      starred = projectBusPriority.starred;
  var options = ['Edit', 'Delete'];

  var projectBusPriorityOptionToggle = function projectBusPriorityOptionToggle() {
    setMenuState(!menuState);
  };

  var deleteProjectBusPriority = function deleteProjectBusPriority(projectBusPriority) {
    dispatch((0, _projectBusPriority.onDeleteProjectBusPriority)(projectBusPriority === null || projectBusPriority === void 0 ? void 0 : projectBusPriority.id));
  };

  var editProjectBusPriority = function editProjectBusPriority() {
    setMenuState(false);
    dispatch((0, _projectBusPriority.onEditProjectBusPriority)(projectBusPriority));
  };

  return _react["default"].createElement("div", {
    className: "contact-item"
  }, _react["default"].createElement(_ListRowCheckbox["default"], {
    selected: projectBusPriority.selected,
    onClick: function onClick() {
      return dispatch((0, _projectBusPriority.onProjectBusPrioritySelect)(projectBusPriority));
    }
  }), _react["default"].createElement(_ListRowFavourite["default"], {
    width: width,
    onClick: function onClick() {
      return dispatch((0, _projectBusPriority.addFavouriteProjectBusPriority)(projectBusPriority));
    },
    starred: starred
  }), _react["default"].createElement(_listRowImage["default"], {
    width: width,
    data: projectBusPriority
  }), _react["default"].createElement(_ListRowData["default"], {
    lineOne: name
  }), _react["default"].createElement(_ListRowDropdown["default"], {
    menuState: menuState,
    toggle: projectBusPriorityOptionToggle,
    options: options,
    dropdownItems: options.map(function (option) {
      return _react["default"].createElement(_reactstrap.DropdownItem, {
        key: option,
        onClick: function onClick() {
          if (option === 'Edit') {
            editProjectBusPriority();
          } else if (option === 'Delete') {
            setDeleteProjectBusPriorityCheck(true);
          }
        }
      }, option);
    })
  }), _react["default"].createElement("div", null, _react["default"].createElement(_index["default"], null)), _react["default"].createElement(_reactBootstrapSweetalert["default"], {
    show: deleteProjectBusPriorityCheck,
    warning: true,
    showCancel: true,
    confirmBtnText: _react["default"].createElement(_IntlMessages["default"], {
      id: "button.yesDeleteIt"
    }),
    cancelBtnText: _react["default"].createElement(_IntlMessages["default"], {
      id: "button.cancel"
    }),
    confirmBtnBsStyle: "danger",
    cancelBtnBsStyle: "default",
    title: _react["default"].createElement("span", {
      style: {
        fontWeight: 'bold',
        color: 'grey',
        fontSize: '200%'
      }
    }, _react["default"].createElement(_IntlMessages["default"], {
      id: "general.areYouSure"
    })),
    onConfirm: function onConfirm() {
      deleteProjectBusPriority(projectBusPriority);
      setDeleteProjectBusPriorityCheck(false);
    },
    onCancel: function onCancel() {
      setDeleteProjectBusPriorityCheck(false);
    }
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "projectBusPriority.deleteProjectBusPriority"
  })));
};

var _default = ProjectBusPriorityRow;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProjectBusPriorityRow, "ProjectBusPriorityRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityList/projectBusPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityList/projectBusPriorityRow/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityList/projectBusPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_reactBootstrapSweetalert, "_reactBootstrapSweetalert", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityList/projectBusPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityList/projectBusPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_listRowImage, "_listRowImage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityList/projectBusPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_ListRowFavourite, "_ListRowFavourite", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityList/projectBusPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_ListRowCheckbox, "_ListRowCheckbox", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityList/projectBusPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_ListRowData, "_ListRowData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityList/projectBusPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_ListRowDropdown, "_ListRowDropdown", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityList/projectBusPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityList/projectBusPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityList/projectBusPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityList/projectBusPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityList/projectBusPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityList/projectBusPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityList/projectBusPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityList/projectBusPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityList/projectBusPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(ProjectBusPriorityRow, "ProjectBusPriorityRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityList/projectBusPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityList/projectBusPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityList/projectBusPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityList/projectBusPriorityRow/index.js");
}();

;

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _projectBusPriority = __webpack_require__(180);

var _common = __webpack_require__(831);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ProjectBusPriorityEdit = function ProjectBusPriorityEdit() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var editProjectBusPriorityState = (0, _reactRedux.useSelector)(function (state) {
    return state.projectBusPrioritys.editProjectBusPriorityState;
  });
  var projectBusPriority = (0, _reactRedux.useSelector)(function (state) {
    return state.projectBusPrioritys.selectedProjectBusPriority;
  });

  var _useState = (0, _react.useState)(projectBusPriority),
      _useState2 = _slicedToArray(_useState, 2),
      selectedProjectBusPriority = _useState2[0],
      setSelectedProjectBusPriority = _useState2[1];

  var _useState3 = (0, _react.useState)({
    name: ''
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      formErrors = _useState4[0],
      setFormErrors = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      formValid = _useState6[0],
      setFormValid = _useState6[1]; // using selectedProjectBusPriority makes it behave like componentDidUpdate - effect takes place when selectedProjectBusPriority changes


  (0, _react.useEffect)(function () {
    setSelectedProjectBusPriority(projectBusPriority);
    setFormValid(false);
    validateForm();
  }, [projectBusPriority]); // using selectedProjectBusPriority makes it behave like componentDidUpdate - effect takes place when selectedProjectBusPriority changes

  (0, _react.useEffect)(function () {
    setFormValid(false);
    validateForm();
  }, [selectedProjectBusPriority]);

  var handleUserInput = function handleUserInput(event, isNumber) {
    var name = event.target.name;
    var value = event.target.value;

    if (isNumber) {
      value = Number(event.target.value);
    }

    updateSelectedProjectBusPriorityField(name, value);
    validateField(name, value);
  };

  var updateSelectedProjectBusPriorityField = function updateSelectedProjectBusPriorityField(fieldName, value) {
    var newProjectBusPriority = _objectSpread({}, projectBusPriority);

    newProjectBusPriority[fieldName] = value;
    setSelectedProjectBusPriority(newProjectBusPriority);
  };

  var validateField = function validateField(fieldName, value) {
    formErrors[fieldName] = (0, _common.getFormError)(fieldName, value);
    setFormErrors(formErrors);
    validateForm();
  };

  var validateForm = function validateForm() {
    setFormValid((0, _common.isFormValid)(selectedProjectBusPriority));
  };

  var maintainButton = function maintainButton(label) {
    return _react["default"].createElement(_reactstrap.Button, {
      className: "text-uppercase",
      disabled: !formValid,
      color: "primary",
      onClick: function onClick() {
        dispatch((0, _projectBusPriority.showProjectBusPriorityLoader)());
        dispatch((0, _projectBusPriority.onProjectBusPriorityClose)());
        dispatch((0, _projectBusPriority.onSaveProjectBusPriority)(selectedProjectBusPriority));
        setFormValid(false);
      }
    }, label);
  };

  var modalHeaderOnClick = function modalHeaderOnClick() {
    return function () {
      setFormValid(false);
      dispatch((0, _projectBusPriority.onProjectBusPriorityClose)());
    };
  };

  var modalBody = function modalBody(buttonText) {
    return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
      className: "modal-box-content"
    }, _react["default"].createElement("div", {
      className: "row no-gutters"
    }, (0, _common.displayedImage)(selectedProjectBusPriority), (0, _common.showErrors)(formErrors), (0, _common.inputFields)(projectBusPriority, handleUserInput))), _react["default"].createElement("div", {
      className: "modal-box-footer d-flex flex-row"
    }, maintainButton(buttonText)));
  };

  return _react["default"].createElement(_reactstrap.Modal, {
    className: "modal-box",
    isOpen: editProjectBusPriorityState
  }, (0, _common.modalHeader)(_react["default"].createElement(_IntlMessages["default"], {
    id: "projectBusPriority.saveProjectBusPriority"
  }), modalHeaderOnClick), modalBody(_react["default"].createElement(_IntlMessages["default"], {
    id: "projectBusPriority.saveProjectBusPriority"
  })));
};

var _default = ProjectBusPriorityEdit;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProjectBusPriorityEdit, "ProjectBusPriorityEdit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityEdit/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityEdit/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityEdit/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityEdit/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityEdit/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityEdit/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityEdit/index.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityEdit/index.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityEdit/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityEdit/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityEdit/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityEdit/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityEdit/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityEdit/index.js");

  __REACT_HOT_LOADER__.register(ProjectBusPriorityEdit, "ProjectBusPriorityEdit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityEdit/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityEdit/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityEdit/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityEdit/index.js");
}();

;

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _projectBusPriority = __webpack_require__(180);

var _common = __webpack_require__(831);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ProjectBusPriorityAdd = function ProjectBusPriorityAdd() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var addProjectBusPriorityState = (0, _reactRedux.useSelector)(function (state) {
    return state.projectBusPrioritys.addProjectBusPriorityState;
  });

  var _useState = (0, _react.useState)(_common.initProps),
      _useState2 = _slicedToArray(_useState, 2),
      selectedProjectBusPriority = _useState2[0],
      setSelectedProjectBusPriority = _useState2[1];

  var _useState3 = (0, _react.useState)({
    name: ''
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      formErrors = _useState4[0],
      setFormErrors = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      formValid = _useState6[0],
      setFormValid = _useState6[1];

  (0, _react.useEffect)(function () {
    setSelectedProjectBusPriority((0, _common.initProps)());
  }, [addProjectBusPriorityState]); // using selectedProjectBusPriority makes it behave like componentDidUpdate - effect takes place when selectedProjectBusPriority changes

  (0, _react.useEffect)(function () {
    setFormValid(false);
    validateForm();
  }, [selectedProjectBusPriority]);

  var handleUserInput = function handleUserInput(event, isNumber) {
    var name = event.target.name;
    var value = event.target.value;

    if (isNumber) {
      value = Number(event.target.value);
    }

    updateSelectedProjectBusPriorityField(name, value);
    validateField(name, value);
  };

  var updateSelectedProjectBusPriorityField = function updateSelectedProjectBusPriorityField(fieldName, value) {
    var newProjectBusPriority = _objectSpread({}, selectedProjectBusPriority);

    newProjectBusPriority[fieldName] = value;
    setSelectedProjectBusPriority(newProjectBusPriority);
  };

  var validateField = function validateField(fieldName, value) {
    formErrors[fieldName] = (0, _common.getFormError)(fieldName, value);
    setFormErrors(formErrors);
    validateForm();
  };

  var validateForm = function validateForm() {
    setFormValid((0, _common.isFormValid)(selectedProjectBusPriority));
  };

  var maintainButton = function maintainButton(label) {
    return _react["default"].createElement(_reactstrap.Button, {
      className: "text-uppercase",
      disabled: !formValid,
      color: "primary",
      onClick: function onClick() {
        dispatch((0, _projectBusPriority.showProjectBusPriorityLoader)());
        dispatch((0, _projectBusPriority.onProjectBusPriorityClose)());
        dispatch((0, _projectBusPriority.onSaveProjectBusPriority)(selectedProjectBusPriority));
        setSelectedProjectBusPriority((0, _common.initProps)());
        setFormValid(false);
      }
    }, label);
  };

  var modalHeaderOnClick = function modalHeaderOnClick() {
    return function () {
      setFormValid(false);
      dispatch((0, _projectBusPriority.onProjectBusPriorityClose)());
    };
  };

  var modalBody = function modalBody(buttonText) {
    return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
      className: "modal-box-content"
    }, _react["default"].createElement("div", {
      className: "row no-gutters"
    }, (0, _common.displayedImage)(selectedProjectBusPriority), (0, _common.showErrors)(formErrors), (0, _common.inputFields)(selectedProjectBusPriority, handleUserInput))), _react["default"].createElement("div", {
      className: "modal-box-footer d-flex flex-row"
    }, maintainButton(buttonText)));
  };

  return _react["default"].createElement(_reactstrap.Modal, {
    className: "modal-box",
    isOpen: addProjectBusPriorityState
  }, (0, _common.modalHeader)(_react["default"].createElement(_IntlMessages["default"], {
    id: "projectBusPriority.addProjectBusPriority"
  }), modalHeaderOnClick), modalBody(_react["default"].createElement(_IntlMessages["default"], {
    id: "projectBusPriority.addProjectBusPriority"
  })));
};

var _default = ProjectBusPriorityAdd;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProjectBusPriorityAdd, "ProjectBusPriorityAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityAdd/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(ProjectBusPriorityAdd, "ProjectBusPriorityAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityAdd/index.js");
}();

;

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _component["default"];
  }
});

var _component = _interopRequireDefault(__webpack_require__(1988));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_component, "_component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/index.js");
}();

;

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _rcDrawer = _interopRequireDefault(__webpack_require__(31));

var _reactNotifications = __webpack_require__(30);

var _reactstrap = __webpack_require__(6);

var _projectCostPriorityList = _interopRequireDefault(__webpack_require__(1989));

var _index = _interopRequireDefault(__webpack_require__(66));

var _projectCostPriorityAdd = _interopRequireDefault(__webpack_require__(1992));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _CircularProgress = _interopRequireDefault(__webpack_require__(24));

var _CustomScrollbars = _interopRequireDefault(__webpack_require__(27));

var _projectCostPriority = __webpack_require__(181);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var filterOptions = [{
  id: 1,
  name: 'All projectCostPrioritys',
  icon: 'zmdi-menu'
}, {
  id: 2,
  name: 'Starred projectCostPrioritys',
  icon: 'zmdi-star'
}];

var Component = function Component() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var width = (0, _reactRedux.useSelector)(function (state) {
    return state.settings.width;
  });
  var loader = (0, _reactRedux.useSelector)(function (state) {
    return state.projectCostPrioritys.loader;
  });
  var alertMessage = (0, _reactRedux.useSelector)(function (state) {
    return state.projectCostPrioritys.alertMessage;
  });
  var showMessage = (0, _reactRedux.useSelector)(function (state) {
    return state.projectCostPrioritys.showMessage;
  });
  var noContentFoundMessage = (0, _reactRedux.useSelector)(function (state) {
    return state.projectCostPrioritys.noContentFoundMessage;
  });
  var drawerState = (0, _reactRedux.useSelector)(function (state) {
    return state.projectCostPrioritys.drawerState;
  });
  var projectCostPriority = (0, _reactRedux.useSelector)(function (state) {
    return state.projectCostPrioritys.projectCostPriority;
  });
  var searchProjectCostPriority = (0, _reactRedux.useSelector)(function (state) {
    return state.projectCostPrioritys.searchProjectCostPriority;
  });
  var projectCostPriorityList = (0, _reactRedux.useSelector)(function (state) {
    return state.projectCostPrioritys.projectCostPriorityList;
  });
  var selectedProjectCostPrioritys = (0, _reactRedux.useSelector)(function (state) {
    return state.projectCostPrioritys.selectedProjectCostPrioritys;
  });
  var addProjectCostPriorityState = (0, _reactRedux.useSelector)(function (state) {
    return state.projectCostPrioritys.addProjectCostPriorityState;
  });
  var selectedSectionId = (0, _reactRedux.useSelector)(function (state) {
    return state.projectCostPrioritys.selectedSectionId;
  });
  (0, _react.useEffect)(function () {
    dispatch((0, _projectCostPriority.showProjectCostPriorityLoader)());
    dispatch((0, _projectCostPriority.fetchProjectCostPrioritys)());
  }, []);

  var onAllProjectCostPrioritySelect = function onAllProjectCostPrioritySelect() {
    var selectAll = selectedProjectCostPrioritys < projectCostPriorityList.length;

    if (selectAll) {
      dispatch((0, _projectCostPriority.getAllProjectCostPriority)());
    } else {
      dispatch((0, _projectCostPriority.getUnselectedAllProjectCostPriority)());
    }
  };

  var updatingSearchProjectCostPriority = function updatingSearchProjectCostPriority(evt) {
    dispatch((0, _projectCostPriority.updateSearchProjectCostPriority)(evt.target.value));
    dispatch((0, _projectCostPriority.filterProjectCostPriority)(evt.target.value));
  };

  var projectCostPriorityRequestClose = function projectCostPriorityRequestClose() {
    dispatch((0, _projectCostPriority.handleProjectCostPriorityRequestClose)());
  };

  var projectCostPrioritySideBar = function projectCostPrioritySideBar() {
    return _react["default"].createElement("div", {
      className: "module-side"
    }, _react["default"].createElement("div", {
      className: "module-side-header"
    }, _react["default"].createElement("div", {
      className: "module-logo"
    }, _react["default"].createElement("i", {
      className: "zmdi zmdi-city-alt mr-4"
    }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
      id: "sidebar.projectCostPrioritys"
    })))), _react["default"].createElement("div", {
      className: "module-side-content"
    }, _react["default"].createElement(_CustomScrollbars["default"], {
      className: "module-side-scroll scrollbar",
      style: {
        height: width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)'
      }
    }, _react["default"].createElement("div", {
      className: "module-add-task"
    }, _react["default"].createElement(_reactstrap.Button, {
      className: "btn-block jr-btn",
      color: "primary",
      onClick: function onClick() {
        return dispatch((0, _projectCostPriority.onAddProjectCostPriority)());
      }
    }, _react["default"].createElement("i", {
      className: "zmdi zmdi-accounts-add zmdi-hc-fw"
    }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
      id: "projectCostPriority.addProjectCostPriority"
    })))), _react["default"].createElement("div", {
      className: "module-side-nav"
    }, _react["default"].createElement("ul", {
      className: "module-nav"
    }, filterOptions.map(function (option) {
      return _react["default"].createElement("li", {
        key: option.id,
        className: "nav-item"
      }, _react["default"].createElement("a", {
        href: "javascript:void(0)",
        className: option.id === selectedSectionId ? 'active' : '',
        onClick: function onClick() {
          return dispatch((0, _projectCostPriority.onFilterProjectCostPriorityOptionSelect)(option));
        }
      }, _react["default"].createElement("i", {
        className: "zmdi ".concat(option.icon)
      }), _react["default"].createElement("span", null, option.name)));
    }))))));
  };

  return _react["default"].createElement("div", {
    className: "app-wrapper"
  }, _react["default"].createElement("div", {
    className: "app-module animated slideInUpTiny animation-duration-3"
  }, _react["default"].createElement("div", {
    className: "d-block d-xl-none"
  }, _react["default"].createElement(_rcDrawer["default"], {
    touch: true,
    transitions: true,
    enableDragHandle: true,
    open: drawerState,
    onOpenChange: function onOpenChange() {
      return dispatch((0, _projectCostPriority.onToggleProjectCostPriorityDrawer)());
    },
    sidebar: projectCostPrioritySideBar(projectCostPriority)
  })), _react["default"].createElement("div", {
    className: "app-module-sidenav d-none d-xl-flex"
  }, projectCostPrioritySideBar(projectCostPriority)), _react["default"].createElement("div", {
    className: "module-box"
  }, _react["default"].createElement("div", {
    className: "module-box-header"
  }, _react["default"].createElement("span", {
    className: "icon-btn drawer-btn d-flex d-xl-none",
    onClick: function onClick() {
      return dispatch((0, _projectCostPriority.onToggleProjectCostPriorityDrawer)());
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-menu"
  })), _react["default"].createElement(_index["default"], {
    placeholder: "Search projectCostPriority",
    notification: false,
    apps: false,
    user: projectCostPriority,
    onChange: function onChange(event) {
      return updatingSearchProjectCostPriority(event);
    },
    value: searchProjectCostPriority
  })), _react["default"].createElement("div", {
    className: "module-box-content"
  }, _react["default"].createElement("div", {
    className: "module-box-topbar"
  }, _react["default"].createElement("div", {
    className: "form-control-checkbox d-flex"
  }, _react["default"].createElement("div", {
    className: "form-checkbox"
  }, _react["default"].createElement("input", {
    type: "checkbox",
    checked: selectedProjectCostPrioritys > 0,
    onChange: onAllProjectCostPrioritySelect
  }), _react["default"].createElement("span", {
    className: "check"
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-check zmdi-hc-lg"
  })))), _react["default"].createElement(_reactstrap.Button, {
    size: "sm",
    className: "jr-btn jr-flat-btn",
    color: "default",
    onClick: function onClick() {
      return dispatch((0, _projectCostPriority.onFilterSelectedProjectCostPriority)());
    }
  }, _react["default"].createElement("i", {
    className: "zmdi zmdi-filter-list zmdi-hc-fw"
  }), _react["default"].createElement("span", null, _react["default"].createElement(_IntlMessages["default"], {
    id: "label.filter.selected"
  })))), _react["default"].createElement(_CustomScrollbars["default"], {
    className: "module-list-scroll scrollbar",
    style: {
      height: width >= 1200 ? 'calc(100vh - 265px)' : 'calc(100vh - 245px)'
    }
  }, loader ? _react["default"].createElement("div", {
    className: "loader-view-block h-100"
  }, _react["default"].createElement("div", {
    className: "loader-view"
  }, _react["default"].createElement(_CircularProgress["default"], null))) : projectCostPriorityList && projectCostPriorityList.length > 0 ? _react["default"].createElement(_projectCostPriorityList["default"], null) : _react["default"].createElement("div", {
    className: "h-100 d-flex align-items-center justify-content-center"
  }, noContentFoundMessage))))), _react["default"].createElement(_projectCostPriorityAdd["default"], {
    open: addProjectCostPriorityState
  }), showMessage && _reactNotifications.NotificationManager.success(alertMessage, projectCostPriorityRequestClose()), _react["default"].createElement(_reactNotifications.NotificationContainer, null));
};

var _default = Component;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(filterOptions, "filterOptions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/component.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/component.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/component.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/component.js");

  __REACT_HOT_LOADER__.register(_rcDrawer, "_rcDrawer", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/component.js");

  __REACT_HOT_LOADER__.register(_projectCostPriorityList, "_projectCostPriorityList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/component.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/component.js");

  __REACT_HOT_LOADER__.register(_projectCostPriorityAdd, "_projectCostPriorityAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/component.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/component.js");

  __REACT_HOT_LOADER__.register(_CircularProgress, "_CircularProgress", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/component.js");

  __REACT_HOT_LOADER__.register(_CustomScrollbars, "_CustomScrollbars", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/component.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/component.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/component.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/component.js");

  __REACT_HOT_LOADER__.register(filterOptions, "filterOptions", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/component.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/component.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/component.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/component.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/component.js");
}();

;

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _index = _interopRequireDefault(__webpack_require__(1990));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ProjectCostPriorityList = function ProjectCostPriorityList() {
  var projectCostPriorityList = (0, _reactRedux.useSelector)(function (state) {
    return state.projectCostPrioritys.projectCostPriorityList;
  });
  return _react["default"].createElement("div", {
    className: "app-main-content"
  }, projectCostPriorityList.map(function (entry, index) {
    return _react["default"].createElement(_index["default"], {
      key: index,
      projectCostPriority: entry
    });
  }));
};

var _default = ProjectCostPriorityList;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProjectCostPriorityList, "ProjectCostPriorityList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityList/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityList/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityList/index.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityList/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityList/index.js");

  __REACT_HOT_LOADER__.register(ProjectCostPriorityList, "ProjectCostPriorityList", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityList/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityList/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityList/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityList/index.js");
}();

;

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _store = __webpack_require__(54);

var _reactBootstrapSweetalert = _interopRequireDefault(__webpack_require__(80));

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _listRowImage = _interopRequireDefault(__webpack_require__(126));

var _ListRowFavourite = _interopRequireDefault(__webpack_require__(127));

var _ListRowCheckbox = _interopRequireDefault(__webpack_require__(107));

var _ListRowData = _interopRequireDefault(__webpack_require__(129));

var _ListRowDropdown = _interopRequireDefault(__webpack_require__(128));

var _index = _interopRequireDefault(__webpack_require__(1991));

var _projectCostPriority = __webpack_require__(181);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ProjectCostPriorityRow = function ProjectCostPriorityRow(props) {
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      menuState = _useState2[0],
      setMenuState = _useState2[1];

  var _useState3 = (0, _react.useState)(props.projectCostPriority),
      _useState4 = _slicedToArray(_useState3, 2),
      projectCostPriority = _useState4[0],
      setProjectCostPriority = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      deleteProjectCostPriorityCheck = _useState6[0],
      setDeleteProjectCostPriorityCheck = _useState6[1];

  var width = (0, _reactRedux.useSelector)(function (state) {
    return state.settings.width;
  }); // const { projectCostPriority } = props;

  (0, _react.useEffect)(function () {
    setProjectCostPriority(props.projectCostPriority);
  }, [props]);
  var name = projectCostPriority.name,
      starred = projectCostPriority.starred;
  var options = ['Edit', 'Delete'];

  var projectCostPriorityOptionToggle = function projectCostPriorityOptionToggle() {
    setMenuState(!menuState);
  };

  var deleteProjectCostPriority = function deleteProjectCostPriority(projectCostPriority) {
    dispatch((0, _projectCostPriority.onDeleteProjectCostPriority)(projectCostPriority === null || projectCostPriority === void 0 ? void 0 : projectCostPriority.id));
  };

  var editProjectCostPriority = function editProjectCostPriority() {
    setMenuState(false);
    dispatch((0, _projectCostPriority.onEditProjectCostPriority)(projectCostPriority));
  };

  return _react["default"].createElement("div", {
    className: "contact-item"
  }, _react["default"].createElement(_ListRowCheckbox["default"], {
    selected: projectCostPriority.selected,
    onClick: function onClick() {
      return dispatch((0, _projectCostPriority.onProjectCostPrioritySelect)(projectCostPriority));
    }
  }), _react["default"].createElement(_ListRowFavourite["default"], {
    width: width,
    onClick: function onClick() {
      return dispatch((0, _projectCostPriority.addFavouriteProjectCostPriority)(projectCostPriority));
    },
    starred: starred
  }), _react["default"].createElement(_listRowImage["default"], {
    width: width,
    data: projectCostPriority
  }), _react["default"].createElement(_ListRowData["default"], {
    lineOne: name
  }), _react["default"].createElement(_ListRowDropdown["default"], {
    menuState: menuState,
    toggle: projectCostPriorityOptionToggle,
    options: options,
    dropdownItems: options.map(function (option) {
      return _react["default"].createElement(_reactstrap.DropdownItem, {
        key: option,
        onClick: function onClick() {
          if (option === 'Edit') {
            editProjectCostPriority();
          } else if (option === 'Delete') {
            setDeleteProjectCostPriorityCheck(true);
          }
        }
      }, option);
    })
  }), _react["default"].createElement("div", null, _react["default"].createElement(_index["default"], null)), _react["default"].createElement(_reactBootstrapSweetalert["default"], {
    show: deleteProjectCostPriorityCheck,
    warning: true,
    showCancel: true,
    confirmBtnText: _react["default"].createElement(_IntlMessages["default"], {
      id: "button.yesDeleteIt"
    }),
    cancelBtnText: _react["default"].createElement(_IntlMessages["default"], {
      id: "button.cancel"
    }),
    confirmBtnBsStyle: "danger",
    cancelBtnBsStyle: "default",
    title: _react["default"].createElement("span", {
      style: {
        fontWeight: 'bold',
        color: 'grey',
        fontSize: '200%'
      }
    }, _react["default"].createElement(_IntlMessages["default"], {
      id: "general.areYouSure"
    })),
    onConfirm: function onConfirm() {
      deleteProjectCostPriority(projectCostPriority);
      setDeleteProjectCostPriorityCheck(false);
    },
    onCancel: function onCancel() {
      setDeleteProjectCostPriorityCheck(false);
    }
  }, _react["default"].createElement(_IntlMessages["default"], {
    id: "projectCostPriority.deleteProjectCostPriority"
  })));
};

var _default = ProjectCostPriorityRow;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProjectCostPriorityRow, "ProjectCostPriorityRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityList/projectCostPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityList/projectCostPriorityRow/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityList/projectCostPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_reactBootstrapSweetalert, "_reactBootstrapSweetalert", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityList/projectCostPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityList/projectCostPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_listRowImage, "_listRowImage", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityList/projectCostPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_ListRowFavourite, "_ListRowFavourite", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityList/projectCostPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_ListRowCheckbox, "_ListRowCheckbox", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityList/projectCostPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_ListRowData, "_ListRowData", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityList/projectCostPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_ListRowDropdown, "_ListRowDropdown", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityList/projectCostPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_index, "_index", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityList/projectCostPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityList/projectCostPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityList/projectCostPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityList/projectCostPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityList/projectCostPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityList/projectCostPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityList/projectCostPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityList/projectCostPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(ProjectCostPriorityRow, "ProjectCostPriorityRow", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityList/projectCostPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityList/projectCostPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityList/projectCostPriorityRow/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityList/projectCostPriorityRow/index.js");
}();

;

/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _projectCostPriority = __webpack_require__(181);

var _common = __webpack_require__(832);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ProjectCostPriorityEdit = function ProjectCostPriorityEdit() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var editProjectCostPriorityState = (0, _reactRedux.useSelector)(function (state) {
    return state.projectCostPrioritys.editProjectCostPriorityState;
  });
  var projectCostPriority = (0, _reactRedux.useSelector)(function (state) {
    return state.projectCostPrioritys.selectedProjectCostPriority;
  });

  var _useState = (0, _react.useState)(projectCostPriority),
      _useState2 = _slicedToArray(_useState, 2),
      selectedProjectCostPriority = _useState2[0],
      setSelectedProjectCostPriority = _useState2[1];

  var _useState3 = (0, _react.useState)({
    name: ''
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      formErrors = _useState4[0],
      setFormErrors = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      formValid = _useState6[0],
      setFormValid = _useState6[1]; // using selectedProjectCostPriority makes it behave like componentDidUpdate - effect takes place when selectedProjectCostPriority changes


  (0, _react.useEffect)(function () {
    setSelectedProjectCostPriority(projectCostPriority);
    setFormValid(false);
    validateForm();
  }, [projectCostPriority]); // using selectedProjectCostPriority makes it behave like componentDidUpdate - effect takes place when selectedProjectCostPriority changes

  (0, _react.useEffect)(function () {
    setFormValid(false);
    validateForm();
  }, [selectedProjectCostPriority]);

  var handleUserInput = function handleUserInput(event, isNumber) {
    var name = event.target.name;
    var value = event.target.value;

    if (isNumber) {
      value = Number(event.target.value);
    }

    updateSelectedProjectCostPriorityField(name, value);
    validateField(name, value);
  };

  var updateSelectedProjectCostPriorityField = function updateSelectedProjectCostPriorityField(fieldName, value) {
    var newProjectCostPriority = _objectSpread({}, projectCostPriority);

    newProjectCostPriority[fieldName] = value;
    setSelectedProjectCostPriority(newProjectCostPriority);
  };

  var validateField = function validateField(fieldName, value) {
    formErrors[fieldName] = (0, _common.getFormError)(fieldName, value);
    setFormErrors(formErrors);
    validateForm();
  };

  var validateForm = function validateForm() {
    setFormValid((0, _common.isFormValid)(selectedProjectCostPriority));
  };

  var maintainButton = function maintainButton(label) {
    return _react["default"].createElement(_reactstrap.Button, {
      className: "text-uppercase",
      disabled: !formValid,
      color: "primary",
      onClick: function onClick() {
        dispatch((0, _projectCostPriority.showProjectCostPriorityLoader)());
        dispatch((0, _projectCostPriority.onProjectCostPriorityClose)());
        dispatch((0, _projectCostPriority.onSaveProjectCostPriority)(selectedProjectCostPriority));
        setFormValid(false);
      }
    }, label);
  };

  var modalHeaderOnClick = function modalHeaderOnClick() {
    return function () {
      setFormValid(false);
      dispatch((0, _projectCostPriority.onProjectCostPriorityClose)());
    };
  };

  var modalBody = function modalBody(buttonText) {
    return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
      className: "modal-box-content"
    }, _react["default"].createElement("div", {
      className: "row no-gutters"
    }, (0, _common.displayedImage)(selectedProjectCostPriority), (0, _common.showErrors)(formErrors), (0, _common.inputFields)(projectCostPriority, handleUserInput))), _react["default"].createElement("div", {
      className: "modal-box-footer d-flex flex-row"
    }, maintainButton(buttonText)));
  };

  return _react["default"].createElement(_reactstrap.Modal, {
    className: "modal-box",
    isOpen: editProjectCostPriorityState
  }, (0, _common.modalHeader)(_react["default"].createElement(_IntlMessages["default"], {
    id: "projectCostPriority.saveProjectCostPriority"
  }), modalHeaderOnClick), modalBody(_react["default"].createElement(_IntlMessages["default"], {
    id: "projectCostPriority.saveProjectCostPriority"
  })));
};

var _default = ProjectCostPriorityEdit;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProjectCostPriorityEdit, "ProjectCostPriorityEdit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityEdit/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityEdit/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityEdit/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityEdit/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityEdit/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityEdit/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityEdit/index.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityEdit/index.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityEdit/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityEdit/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityEdit/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityEdit/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityEdit/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityEdit/index.js");

  __REACT_HOT_LOADER__.register(ProjectCostPriorityEdit, "ProjectCostPriorityEdit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityEdit/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityEdit/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityEdit/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityEdit/index.js");
}();

;

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactRedux = __webpack_require__(10);

var _reactstrap = __webpack_require__(6);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _projectCostPriority = __webpack_require__(181);

var _common = __webpack_require__(832);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ProjectCostPriorityAdd = function ProjectCostPriorityAdd() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var addProjectCostPriorityState = (0, _reactRedux.useSelector)(function (state) {
    return state.projectCostPrioritys.addProjectCostPriorityState;
  });

  var _useState = (0, _react.useState)(_common.initProps),
      _useState2 = _slicedToArray(_useState, 2),
      selectedProjectCostPriority = _useState2[0],
      setSelectedProjectCostPriority = _useState2[1];

  var _useState3 = (0, _react.useState)({
    name: ''
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      formErrors = _useState4[0],
      setFormErrors = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      formValid = _useState6[0],
      setFormValid = _useState6[1];

  (0, _react.useEffect)(function () {
    setSelectedProjectCostPriority((0, _common.initProps)());
  }, [addProjectCostPriorityState]); // using selectedProjectCostPriority makes it behave like componentDidUpdate - effect takes place when selectedProjectCostPriority changes

  (0, _react.useEffect)(function () {
    setFormValid(false);
    validateForm();
  }, [selectedProjectCostPriority]);

  var handleUserInput = function handleUserInput(event, isNumber) {
    var name = event.target.name;
    var value = event.target.value;

    if (isNumber) {
      value = Number(event.target.value);
    }

    updateSelectedProjectCostPriorityField(name, value);
    validateField(name, value);
  };

  var updateSelectedProjectCostPriorityField = function updateSelectedProjectCostPriorityField(fieldName, value) {
    var newProjectCostPriority = _objectSpread({}, selectedProjectCostPriority);

    newProjectCostPriority[fieldName] = value;
    setSelectedProjectCostPriority(newProjectCostPriority);
  };

  var validateField = function validateField(fieldName, value) {
    formErrors[fieldName] = (0, _common.getFormError)(fieldName, value);
    setFormErrors(formErrors);
    validateForm();
  };

  var validateForm = function validateForm() {
    setFormValid((0, _common.isFormValid)(selectedProjectCostPriority));
  };

  var maintainButton = function maintainButton(label) {
    return _react["default"].createElement(_reactstrap.Button, {
      className: "text-uppercase",
      disabled: !formValid,
      color: "primary",
      onClick: function onClick() {
        dispatch((0, _projectCostPriority.showProjectCostPriorityLoader)());
        dispatch((0, _projectCostPriority.onProjectCostPriorityClose)());
        dispatch((0, _projectCostPriority.onSaveProjectCostPriority)(selectedProjectCostPriority));
        setSelectedProjectCostPriority((0, _common.initProps)());
        setFormValid(false);
      }
    }, label);
  };

  var modalHeaderOnClick = function modalHeaderOnClick() {
    return function () {
      setFormValid(false);
      dispatch((0, _projectCostPriority.onProjectCostPriorityClose)());
    };
  };

  var modalBody = function modalBody(buttonText) {
    return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
      className: "modal-box-content"
    }, _react["default"].createElement("div", {
      className: "row no-gutters"
    }, (0, _common.displayedImage)(selectedProjectCostPriority), (0, _common.showErrors)(formErrors), (0, _common.inputFields)(selectedProjectCostPriority, handleUserInput))), _react["default"].createElement("div", {
      className: "modal-box-footer d-flex flex-row"
    }, maintainButton(buttonText)));
  };

  return _react["default"].createElement(_reactstrap.Modal, {
    className: "modal-box",
    isOpen: addProjectCostPriorityState
  }, (0, _common.modalHeader)(_react["default"].createElement(_IntlMessages["default"], {
    id: "projectCostPriority.addProjectCostPriority"
  }), modalHeaderOnClick), modalBody(_react["default"].createElement(_IntlMessages["default"], {
    id: "projectCostPriority.addProjectCostPriority"
  })));
};

var _default = ProjectCostPriorityAdd;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProjectCostPriorityAdd, "ProjectCostPriorityAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityAdd/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_getRequireWildcardCache, "_getRequireWildcardCache", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(ownKeys, "ownKeys", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_objectSpread, "_objectSpread", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_slicedToArray, "_slicedToArray", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_nonIterableRest, "_nonIterableRest", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_arrayWithHoles, "_arrayWithHoles", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(ProjectCostPriorityAdd, "ProjectCostPriorityAdd", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityAdd/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityAdd/index.js");
}();

;

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var UAParser = __webpack_require__(5);

var UA = exports.UA = new UAParser();

var browser = exports.browser = UA.getBrowser();
var cpu = exports.cpu = UA.getCPU();
var device = exports.device = UA.getDevice();
var engine = exports.engine = UA.getEngine();
var os = exports.os = UA.getOS();
var ua = exports.ua = UA.getUA();
var setStr = exports.setStr = function setStr(uaStr) {
    return UA.setUA(uaStr);
};
var mockUserAgent = exports.mockUserAgent = function mockUserAgent(userAgent) {
    var nav = window.navigator;
    nav.__defineGetter__('userAgent', function () {
        return userAgent;
    });
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deviceDetect = exports.isMobileOnly = exports.isWinPhone = exports.isTablet = exports.isSafari = exports.isOpera = exports.isMobile = exports.isIOS = exports.isIE = exports.isFirefox = exports.isChrome = exports.isBrowser = exports.isAndroid = exports.MobileOnlyView = exports.WinPhoneView = exports.IEView = exports.IOSView = exports.AndroidView = exports.TabletView = exports.BrowserView = exports.MobileView = undefined;

var _views = __webpack_require__(2);

var _detect = __webpack_require__(4);

var _detect2 = _interopRequireDefault(_detect);

var _selectors = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//detect
exports.MobileView = _views.MobileView;
exports.BrowserView = _views.BrowserView;
exports.TabletView = _views.TabletView;
exports.AndroidView = _views.AndroidView;
exports.IOSView = _views.IOSView;
exports.IEView = _views.IEView;
exports.WinPhoneView = _views.WinPhoneView;
exports.MobileOnlyView = _views.MobileOnlyView;
exports.isAndroid = _selectors.isAndroid;
exports.isBrowser = _selectors.isBrowser;
exports.isChrome = _selectors.isChrome;
exports.isFirefox = _selectors.isFirefox;
exports.isIE = _selectors.isIE;
exports.isIOS = _selectors.isIOS;
exports.isMobile = _selectors.isMobile;
exports.isOpera = _selectors.isOpera;
exports.isSafari = _selectors.isSafari;
exports.isTablet = _selectors.isTablet;
exports.isWinPhone = _selectors.isWinPhone;
exports.isMobileOnly = _selectors.isMobileOnly;
exports.deviceDetect = _detect2.default;

//selectors
//views

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MobileOnlyView = exports.WinPhoneView = exports.TabletView = exports.MobileView = exports.IOSView = exports.IEView = exports.BrowserView = exports.AndroidView = undefined;

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AndroidView = exports.AndroidView = function AndroidView(props) {
    return props.device ? _react2.default.createElement(
        'div',
        { className: props.viewClassName, style: props.style },
        props.children
    ) : null;
};

var BrowserView = exports.BrowserView = function BrowserView(props) {
    return props.device ? _react2.default.createElement(
        'div',
        { className: props.viewClassName, style: props.style },
        props.children
    ) : null;
};

var IEView = exports.IEView = function IEView(props) {
    return props.device ? _react2.default.createElement(
        'div',
        { className: props.viewClassName, style: props.style },
        props.children
    ) : null;
};

var IOSView = exports.IOSView = function IOSView(props) {
    return props.device ? _react2.default.createElement(
        'div',
        { className: props.viewClassName, style: props.style },
        props.children
    ) : null;
};

var MobileView = exports.MobileView = function MobileView(props) {
    return props.device ? _react2.default.createElement(
        'div',
        { className: props.viewClassName, style: props.style },
        props.children
    ) : null;
};

var TabletView = exports.TabletView = function TabletView(props) {
    return props.device ? _react2.default.createElement(
        'div',
        { className: props.viewClassName, style: props.style },
        props.children
    ) : null;
};

var WinPhoneView = exports.WinPhoneView = function WinPhoneView(props) {
    return props.device ? _react2.default.createElement(
        'div',
        { className: props.viewClassName, style: props.style },
        props.children
    ) : null;
};

var MobileOnlyView = exports.MobileOnlyView = function MobileOnlyView(props) {
    return props.device ? _react2.default.createElement(
        'div',
        { className: props.viewClassName, style: props.style },
        props.children
    ) : null;
};

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(0);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _getUaData = __webpack_require__(0);

var checkDeviceType = function checkDeviceType() {
    switch (_getUaData.device.type) {
        case 'mobile':
            return {
                isMobile: true
            };
        case 'tablet':
            return {
                isTablet: true
            };
        case undefined:
            return {
                isBrowser: true
            };
        default:
            return {
                isMobile: false,
                isTablet: false,
                isBrowser: false
            };
    };
};

var getCurrentBrowser = function getCurrentBrowser() {
    var name = _getUaData.browser.name;
    if (name === 'Chrome' || name === 'Firefox' || name === 'Opera' || name === 'Yandex' || name === 'Safari') {
        return true;
    } else {
        return false;
    }
};

var type = checkDeviceType();

var deviceDetect = function deviceDetect() {
    var isBrowser = type.isBrowser,
        isMobile = type.isMobile,
        isTablet = type.isTablet;

    if (isBrowser) {
        var result = {
            isBrowser: getCurrentBrowser(),
            browserMajorVersion: _getUaData.browser.major,
            browserFullVersion: _getUaData.browser.version,
            browserName: _getUaData.browser.name,
            engineName: _getUaData.engine.name || false,
            engineVersion: _getUaData.engine.version,
            osName: _getUaData.os.name,
            osVersion: _getUaData.os.version,
            userAgent: _getUaData.ua
        };
        return result;
    }

    if (isMobile || isTablet) {
        var _result = _extends({}, type, {
            vendor: _getUaData.device.vendor || "none",
            model: _getUaData.device.model || "none",
            os: _getUaData.os.name || "none",
            osVersion: _getUaData.os.version || "none",
            ua: _getUaData.ua || "none"
        });
        return _result;
    }
};

exports.default = deviceDetect;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * UAParser.js v0.7.17
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
 * Dual licensed under GPLv2 & MIT
 */
(function(window,undefined){"use strict";var LIBVERSION="0.7.17",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded";var util={extend:function(regexes,extensions){var margedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){margedRegexes[i]=extensions[i].concat(regexes[i])}else{margedRegexes[i]=regexes[i]}}return margedRegexes},has:function(str1,str2){if(typeof str1==="string"){return str2.toLowerCase().indexOf(str1.toLowerCase())!==-1}else{return false}},lowerize:function(str){return str.toLowerCase()},major:function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,"").split(".")[0]:undefined},trim:function(str){return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,"")}};var mapper={rgx:function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length==2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match)}else{this[q[0]]=q[1]}}else if(q.length==3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined}else{this[q[0]]=match?match.replace(q[1],q[2]):undefined}}else if(q.length==4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined}}else{this[q]=match?match:undefined}}}}i+=2}},str:function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(util.has(map[i][j],str)){return i===UNKNOWN?undefined:i}}}else if(util.has(map[i],str)){return i===UNKNOWN?undefined:i}}return str}};var maps={browser:{oldsafari:{version:{"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"}}},device:{amazon:{model:{"Fire Phone":["SD","KF"]}},sprint:{model:{"Evo Shift 4G":"7373KT"},vendor:{HTC:"APA",Sprint:"Sprint"}}},os:{windows:{version:{ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2000:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"}}}};var regexes={browser:[[/(opera\smini)\/([\w\.-]+)/i,/(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,/(opera).+version\/([\w\.]+)/i,/(opera)[\/\s]+([\w\.]+)/i],[NAME,VERSION],[/(opios)[\/\s]+([\w\.]+)/i],[[NAME,"Opera Mini"],VERSION],[/\s(opr)\/([\w\.]+)/i],[[NAME,"Opera"],VERSION],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]+)*/i,/(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,/(?:ms|\()(ie)\s([\w\.]+)/i,/(rekonq)\/([\w\.]+)*/i,/(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser)\/([\w\.-]+)/i],[NAME,VERSION],[/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i],[[NAME,"IE"],VERSION],[/(edge)\/((\d+)?[\w\.]+)/i],[NAME,VERSION],[/(yabrowser)\/([\w\.]+)/i],[[NAME,"Yandex"],VERSION],[/(puffin)\/([\w\.]+)/i],[[NAME,"Puffin"],VERSION],[/((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i],[[NAME,"UCBrowser"],VERSION],[/(comodo_dragon)\/([\w\.]+)/i],[[NAME,/_/g," "],VERSION],[/(micromessenger)\/([\w\.]+)/i],[[NAME,"WeChat"],VERSION],[/(QQ)\/([\d\.]+)/i],[NAME,VERSION],[/m?(qqbrowser)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/xiaomi\/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI Browser"]],[/;fbav\/([\w\.]+);/i],[VERSION,[NAME,"Facebook"]],[/headlesschrome(?:\/([\w\.]+)|\s)/i],[VERSION,[NAME,"Chrome Headless"]],[/\swv\).+(chrome)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 WebView"],VERSION],[/((?:oculus|samsung)browser)\/([\w\.]+)/i],[[NAME,/(.+(?:g|us))(.+)/,"$1 $2"],VERSION],[/android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i],[VERSION,[NAME,"Android Browser"]],[/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/(dolfin)\/([\w\.]+)/i],[[NAME,"Dolphin"],VERSION],[/((?:android.+)crmo|crios)\/([\w\.]+)/i],[[NAME,"Chrome"],VERSION],[/(coast)\/([\w\.]+)/i],[[NAME,"Opera Coast"],VERSION],[/fxios\/([\w\.-]+)/i],[VERSION,[NAME,"Firefox"]],[/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w\.]+).+?(mobile\s?safari|safari)/i],[VERSION,NAME],[/webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[[NAME,"GSA"],VERSION],[/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,mapper.str,maps.browser.oldsafari.version]],[/(konqueror)\/([\w\.]+)/i,/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape)\/([\w\.-]+)/i],[[NAME,"Netscape"],VERSION],[/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,/(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix)\/([\w\.-]+)/i,/(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,/(links)\s\(([\w\.]+)/i,/(gobrowser)\/?([\w\.]+)*/i,/(ice\s?browser)\/v?([\w\._]+)/i,/(mosaic)[\/\s]([\w\.]+)/i],[NAME,VERSION]],cpu:[[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i],[[ARCHITECTURE,util.lowerize]],[/((?:i[346]|x)86)[;\)]/i],[[ARCHITECTURE,"ia32"]],[/windows\s(ce|mobile);\sppc;/i],[[ARCHITECTURE,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i],[[ARCHITECTURE,/ower/,"",util.lowerize]],[/(sun4\w)[;\)]/i],[[ARCHITECTURE,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i],[[ARCHITECTURE,util.lowerize]]],device:[[/\((ipad|playbook);[\w\s\);-]+(rim|apple)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/applecoremedia\/[\w\.]+ \((ipad)/],[MODEL,[VENDOR,"Apple"],[TYPE,TABLET]],[/(apple\s{0,1}tv)/i],[[MODEL,"Apple TV"],[VENDOR,"Apple"]],[/(archos)\s(gamepad2?)/i,/(hp).+(touchpad)/i,/(hp).+(tablet)/i,/(kindle)\/([\w\.]+)/i,/\s(nook)[\w\s]+build\/(\w+)/i,/(dell)\s(strea[kpr\s\d]*[\dko])/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(kf[A-z]+)\sbuild\/[\w\.]+.*silk\//i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/(sd|kf)[0349hijorstuw]+\sbuild\/[\w\.]+.*silk\//i],[[MODEL,mapper.str,maps.device.amazon.model],[VENDOR,"Amazon"],[TYPE,MOBILE]],[/\((ip[honed|\s\w*]+);.+(apple)/i],[MODEL,VENDOR,[TYPE,MOBILE]],[/\((ip[honed|\s\w*]+);/i],[MODEL,[VENDOR,"Apple"],[TYPE,MOBILE]],[/(blackberry)[\s-]?(\w+)/i,/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]+)*/i,/(hp)\s([\w\s]+\w)/i,/(asus)-?(\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/\(bb10;\s(\w+)/i],[MODEL,[VENDOR,"BlackBerry"],[TYPE,MOBILE]],[/android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i],[MODEL,[VENDOR,"Asus"],[TYPE,TABLET]],[/(sony)\s(tablet\s[ps])\sbuild\//i,/(sony)?(?:sgp.+)\sbuild\//i],[[VENDOR,"Sony"],[MODEL,"Xperia Tablet"],[TYPE,TABLET]],[/android.+\s([c-g]\d{4}|so[-l]\w+)\sbuild\//i],[MODEL,[VENDOR,"Sony"],[TYPE,MOBILE]],[/\s(ouya)\s/i,/(nintendo)\s([wids3u]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/android.+;\s(shield)\sbuild/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,CONSOLE]],[/(playstation\s[34portablevi]+)/i],[MODEL,[VENDOR,"Sony"],[TYPE,CONSOLE]],[/(sprint\s(\w+))/i],[[VENDOR,mapper.str,maps.device.sprint.vendor],[MODEL,mapper.str,maps.device.sprint.model],[TYPE,MOBILE]],[/(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,/(zte)-(\w+)*/i,/(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]+)*/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/(nexus\s9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/d\/huawei([\w\s-]+)[;\)]/i,/(nexus\s6p)/i],[MODEL,[VENDOR,"Huawei"],[TYPE,MOBILE]],[/(microsoft);\s(lumia[\s\w]+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/[\s\(;](xbox(?:\sone)?)[\s\);]/i],[MODEL,[VENDOR,"Microsoft"],[TYPE,CONSOLE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,"Microsoft"],[TYPE,MOBILE]],[/\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?(:?\s4g)?)[\w\s]+build\//i,/mot[\s-]?(\w+)*/i,/(XT\d{3,4}) build\//i,/(nexus\s6)/i],[MODEL,[VENDOR,"Motorola"],[TYPE,MOBILE]],[/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i],[MODEL,[VENDOR,"Motorola"],[TYPE,TABLET]],[/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i],[[VENDOR,util.trim],[MODEL,util.trim],[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,"Samsung"],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i],[MODEL,[VENDOR,"Sharp"],[TYPE,SMARTTV]],[/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,/((SM-T\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,TABLET]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV],MODEL],[/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,/(sam[sung]*)[\s-]*(\w+-?[\w-]*)*/i,/sec-((sgh\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,MOBILE]],[/sie-(\w+)*/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/(maemo|nokia).*(n900|lumia\s\d+)/i,/(nokia)[\s_-]?([\w-]+)*/i],[[VENDOR,"Nokia"],MODEL,[TYPE,MOBILE]],[/android\s3\.[\s\w;-]{10}(a\d{3})/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/android.+([vl]k\-?\d{3})\s+build/i],[MODEL,[VENDOR,"LG"],[TYPE,TABLET]],[/android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i],[[VENDOR,"LG"],MODEL,[TYPE,TABLET]],[/(lg) netcast\.tv/i],[VENDOR,MODEL,[TYPE,SMARTTV]],[/(nexus\s[45])/i,/lg[e;\s\/-]+(\w+)*/i,/android.+lg(\-?[\d\w]+)\s+build/i],[MODEL,[VENDOR,"LG"],[TYPE,MOBILE]],[/android.+(ideatab[a-z0-9\-\s]+)/i],[MODEL,[VENDOR,"Lenovo"],[TYPE,TABLET]],[/linux;.+((jolla));/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/((pebble))app\/[\d\.]+\s/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/android.+;\s(oppo)\s?([\w\s]+)\sbuild/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/crkey/i],[[MODEL,"Chromecast"],[VENDOR,"Google"]],[/android.+;\s(glass)\s\d/i],[MODEL,[VENDOR,"Google"],[TYPE,WEARABLE]],[/android.+;\s(pixel c)\s/i],[MODEL,[VENDOR,"Google"],[TYPE,TABLET]],[/android.+;\s(pixel xl|pixel)\s/i],[MODEL,[VENDOR,"Google"],[TYPE,MOBILE]],[/android.+(\w+)\s+build\/hm\1/i,/android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,/android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d\w)?)\s+build/i,/android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+)?)\s+build/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,MOBILE]],[/android.+(mi[\s\-_]*(?:pad)?(?:[\s_]*[\w\s]+)?)\s+build/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,TABLET]],[/android.+;\s(m[1-5]\snote)\sbuild/i],[MODEL,[VENDOR,"Meizu"],[TYPE,TABLET]],[/android.+a000(1)\s+build/i],[MODEL,[VENDOR,"OnePlus"],[TYPE,MOBILE]],[/android.+[;\/]\s*(RCT[\d\w]+)\s+build/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/android.+[;\/]\s*(Venue[\d\s]*)\s+build/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i],[[VENDOR,"Barnes & Noble"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/android.+[;\/]\s*(zte)?.+(k\d{2})\s+build/i],[[VENDOR,"ZTE"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(gen\d{3})\s+build.*49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/android.+[;\/]\s*(zur\d{3})\s+build/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/(android).+[;\/]\s+([YR]\d{2}x?.*)\s+build/i,/android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(.+)\s+build/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(NS-?.+)\s+build/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/android.+[;\/]\s*((NX|Next)-?.+)\s+build/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/android.+[;\/]\s*(Xtreme\_?)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/android.+[;\/]\s*(LVTEL\-?)?(V1[12])\s+build/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(.*\b)\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*TU_(1491)\s+build/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/android.+(KS(.+))\s+build/i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/android.+(Gigaset)[\s\-]+(Q.+)\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/\s(tablet|tab)[;\/]/i,/\s(mobile)(?:[;\/]|\ssafari)/i],[[TYPE,util.lowerize],VENDOR,MODEL],[/(android.+)[;\/].+build/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+\sedge\/([\w\.]+)/i],[VERSION,[NAME,"EdgeHTML"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,/(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,/(icab)[\/\s]([23]\.[\d\.]+)/i],[NAME,VERSION],[/rv\:([\w\.]+).*(gecko)/i],[VERSION,NAME]],os:[[/microsoft\s(windows)\s(vista|xp)/i],[NAME,VERSION],[/(windows)\snt\s6\.2;\s(arm)/i,/(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s]+\w)*/i,/(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i],[NAME,[VERSION,mapper.str,maps.os.windows.version]],[/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i],[[NAME,"Windows"],[VERSION,mapper.str,maps.os.windows.version]],[/\((bb)(10);/i],[[NAME,"BlackBerry"],VERSION],[/(blackberry)\w*\/?([\w\.]+)*/i,/(tizen)[\/\s]([\w\.]+)/i,/(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]+)*/i,/linux;.+(sailfish);/i],[NAME,VERSION],[/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]+)*/i],[[NAME,"Symbian"],VERSION],[/\((series40);/i],[NAME],[/mozilla.+\(mobile;.+gecko.+firefox/i],[[NAME,"Firefox OS"],VERSION],[/(nintendo|playstation)\s([wids34portablevu]+)/i,/(mint)[\/\s\(]?(\w+)*/i,/(mageia|vectorlinux)[;\s]/i,/(joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]+)*/i,/(hurd|linux)\s?([\w\.]+)*/i,/(gnu)\s?([\w\.]+)*/i],[NAME,VERSION],[/(cros)\s[\w]+\s([\w\.]+\w)/i],[[NAME,"Chromium OS"],VERSION],[/(sunos)\s?([\w\.]+\d)*/i],[[NAME,"Solaris"],VERSION],[/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]+)*/i],[NAME,VERSION],[/(haiku)\s(\w+)/i],[NAME,VERSION],[/cfnetwork\/.+darwin/i,/ip[honead]+(?:.*os\s([\w]+)\slike\smac|;\sopera)/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac\sos\sx)\s?([\w\s\.]+\w)*/i,/(macintosh|mac(?=_powerpc)\s)/i],[[NAME,"Mac OS"],[VERSION,/_/g,"."]],[/((?:open)?solaris)[\/\s-]?([\w\.]+)*/i,/(aix)\s((\d)(?=\.|\)|\s)[\w\.]*)*/i,/(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i,/(unix)\s?([\w\.]+)*/i],[NAME,VERSION]]};var UAParser=function(uastring,extensions){if(typeof uastring==="object"){extensions=uastring;uastring=undefined}if(!(this instanceof UAParser)){return new UAParser(uastring,extensions).getResult()}var ua=uastring||(window&&window.navigator&&window.navigator.userAgent?window.navigator.userAgent:EMPTY);var rgxmap=extensions?util.extend(regexes,extensions):regexes;this.getBrowser=function(){var browser={name:undefined,version:undefined};mapper.rgx.call(browser,ua,rgxmap.browser);browser.major=util.major(browser.version);return browser};this.getCPU=function(){var cpu={architecture:undefined};mapper.rgx.call(cpu,ua,rgxmap.cpu);return cpu};this.getDevice=function(){var device={vendor:undefined,model:undefined,type:undefined};mapper.rgx.call(device,ua,rgxmap.device);return device};this.getEngine=function(){var engine={name:undefined,version:undefined};mapper.rgx.call(engine,ua,rgxmap.engine);return engine};this.getOS=function(){var os={name:undefined,version:undefined};mapper.rgx.call(os,ua,rgxmap.os);return os};this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return ua};this.setUA=function(uastring){ua=uastring;return this};return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER={NAME:NAME,MAJOR:MAJOR,VERSION:VERSION};UAParser.CPU={ARCHITECTURE:ARCHITECTURE};UAParser.DEVICE={MODEL:MODEL,VENDOR:VENDOR,TYPE:TYPE,CONSOLE:CONSOLE,MOBILE:MOBILE,SMARTTV:SMARTTV,TABLET:TABLET,WEARABLE:WEARABLE,EMBEDDED:EMBEDDED};UAParser.ENGINE={NAME:NAME,VERSION:VERSION};UAParser.OS={NAME:NAME,VERSION:VERSION};if(typeof exports!==UNDEF_TYPE){if(typeof module!==UNDEF_TYPE&&module.exports){exports=module.exports=UAParser}exports.UAParser=UAParser}else{if("function"===FUNC_TYPE&&__webpack_require__(6)){!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return UAParser}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(window){window.UAParser=UAParser}}var $=window&&(window.jQuery||window.Zepto);if(typeof $!==UNDEF_TYPE){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(uastring){parser.setUA(uastring);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop]}}}})(typeof window==="object"?window:this);

/***/ }),
/* 6 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isIE = exports.isOpera = exports.isSafari = exports.isFirefox = exports.isChrome = exports.isIOS = exports.isWinPhone = exports.isAndroid = exports.isBrowser = exports.isTablet = exports.isMobileOnly = exports.isMobile = undefined;

var _getUaData = __webpack_require__(0);

var isMobileType = function isMobileType() {
    return _getUaData.device.type === 'mobile' ? true : false;
};

var isTabletType = function isTabletType() {
    return _getUaData.device.type === 'tablet' ? true : false;
};

var isMobileAndTabletType = function isMobileAndTabletType() {
    switch (_getUaData.device.type) {
        case 'mobile':
            return true;
        case 'tablet':
            return true;
        default:
            return false;
    };
};

var isBrowserType = function isBrowserType() {
    return _getUaData.device.type === undefined ? true : false;
};

var isAndroidType = function isAndroidType() {
    return _getUaData.os.name === 'Android' ? true : false;
};

var isWinPhoneType = function isWinPhoneType() {
    return _getUaData.os.name === 'Windows Phone' ? true : false;
};

var isIOSType = function isIOSType() {
    return _getUaData.os.name === 'iOS' ? true : false;
};

var isChromeType = function isChromeType() {
    return _getUaData.browser.name === 'Chrome' ? true : false;
};

var isFirefoxType = function isFirefoxType() {
    return _getUaData.browser.name === 'Firefox' ? true : false;
};

var isSafariType = function isSafariType() {
    return _getUaData.browser.name === 'Safari' ? true : false;
};

var isOperaType = function isOperaType() {
    return _getUaData.browser.name === 'Opera' ? true : false;
};

var isIEType = function isIEType() {
    return _getUaData.browser.name === 'Internet Explorer' ? true : false;
};

var isMobile = exports.isMobile = isMobileAndTabletType();
var isMobileOnly = exports.isMobileOnly = isMobileType();
var isTablet = exports.isTablet = isTabletType();
var isBrowser = exports.isBrowser = isBrowserType();
var isAndroid = exports.isAndroid = isAndroidType();
var isWinPhone = exports.isWinPhone = isWinPhoneType();
var isIOS = exports.isIOS = isIOSType();
var isChrome = exports.isChrome = isChromeType();
var isFirefox = exports.isFirefox = isFirefoxType();
var isSafari = exports.isSafari = isSafariType();
var isOpera = exports.isOpera = isOperaType();
var isIE = exports.isIE = isIEType();

/***/ })
/******/ ]);

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRouterDom = __webpack_require__(13);

var _Menu = _interopRequireDefault(__webpack_require__(686));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var TopNav =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TopNav, _React$Component);

  function TopNav() {
    _classCallCheck(this, TopNav);

    return _possibleConstructorReturn(this, _getPrototypeOf(TopNav).apply(this, arguments));
  }

  _createClass(TopNav, [{
    key: "render",
    value: function render() {
      return _react["default"].createElement("div", {
        className: "app-top-nav d-none d-md-block ".concat(this.props.styleName)
      }, _react["default"].createElement("div", {
        className: "d-flex app-toolbar align-items-center"
      }, _react["default"].createElement(_Menu["default"], null)));
    }
  }]);

  return TopNav;
}(_react["default"].Component);

var _default = (0, _reactRouterDom.withRouter)(TopNav);

var _default2 = _default;
exports["default"] = _default2;
TopNav.defaultProps = {
  styleName: ""
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TopNav, "TopNav", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/TopNav/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/TopNav/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/TopNav/index.js");

  __REACT_HOT_LOADER__.register(_Menu, "_Menu", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/TopNav/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/TopNav/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/TopNav/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/TopNav/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/TopNav/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/TopNav/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/TopNav/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/TopNav/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/TopNav/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/TopNav/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/TopNav/index.js");

  __REACT_HOT_LOADER__.register(TopNav, "TopNav", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/TopNav/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/TopNav/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/TopNav/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/TopNav/index.js");
}();

;

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _reactRouterDom = __webpack_require__(13);

var _reactRedux = __webpack_require__(10);

var _reactNotifications = __webpack_require__(30);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _Auth = __webpack_require__(143);

var _CircularProgress = _interopRequireDefault(__webpack_require__(24));

var _Authentication = __webpack_require__(42);

var _simpleModal = _interopRequireDefault(__webpack_require__(419));

var _errorBoundary = _interopRequireDefault(__webpack_require__(1996));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var SignIn =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SignIn, _React$Component);

  function SignIn() {
    var _this;

    _classCallCheck(this, SignIn);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SignIn).call(this)); // username: 'cpsolutions28@gmail.com emptest@emptest.com.au orgtest@orgtest.com.au', - testtest

    _this.state = {
      username: '',
      password: '',
      code: ''
    };
    return _this;
  }

  _createClass(SignIn, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.hideAuthLoader();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      if (this.props.showMessage) {
        setTimeout(function () {
          _this2.props.hideMessage();
        }, 100);
      }

      if ((0, _Authentication.isAuthenticated)()) {
        this.props.history.push('/');
      }
    }
  }, {
    key: "getModalBody",
    value: function getModalBody() {
      var modalBodyText = '';
      modalBodyText += 'Step 1 - Enter your username and a code will be sent to your nominated email address.<br/>';
      modalBodyText += 'Check your email for the code (please check your spam folder as well if it is not found).<br/>';
      modalBodyText += 'Step 2 - Enter the code sent to your email.<br/>';
      modalBodyText += 'If for any reason the email with the was not received - please use the resend code option.<br/>';
      return modalBodyText;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state = this.state,
          username = _this$state.username,
          code = _this$state.code,
          password = _this$state.password;
      var _this$props = this.props,
          showMessage = _this$props.showMessage,
          loader = _this$props.loader,
          alertMessage = _this$props.alertMessage,
          authUserCode = _this$props.authUserCode;
      return _react["default"].createElement("div", {
        className: "app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3"
      }, _react["default"].createElement("div", {
        className: "app-login-main-content"
      }, _react["default"].createElement("div", {
        className: "app-logo-content d-flex align-items-center justify-content-center"
      }, _react["default"].createElement(_reactRouterDom.Link, {
        className: "logo-lg",
        to: "/"
      }, _react["default"].createElement("img", {
        src: "assets/images/sea.jpg",
        height: "150",
        width: "177"
      }))), _react["default"].createElement("div", {
        className: "app-login-content"
      }, _react["default"].createElement("div", {
        className: "text-center"
      }, _react["default"].createElement("div", {
        className: "d-flex justify-content-between"
      }, _react["default"].createElement("h1", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "appModule.signIn"
      })), _react["default"].createElement("span", null, _react["default"].createElement(_simpleModal["default"], {
        modalTitle: "Sign in instructions",
        buttonText: "Help",
        modalBody: this.getModalBody(),
        actionClassName: "icon"
      })))), _react["default"].createElement("div", {
        className: "app-login-form"
      }, _react["default"].createElement("form", null, _react["default"].createElement("div", {
        className: "form-group mb-3"
      }, _react["default"].createElement("input", {
        id: "loginInput",
        placeholder: "Username",
        onChange: function onChange(event) {
          return _this3.setState({
            username: event.target.value
          });
        },
        defaultValue: username,
        className: "form-control form-control-lg"
      })), _react["default"].createElement("div", {
        className: "form-group mb-3"
      }, _react["default"].createElement("input", {
        id: "pwInput",
        type: "password",
        placeholder: "Password",
        onChange: function onChange(event) {
          return _this3.setState({
            password: event.target.value
          });
        },
        defaultValue: password,
        className: "form-control form-control-lg"
      })), _react["default"].createElement("div", {
        className: "mb-3 d-flex align-items-center justify-content-between"
      }, _react["default"].createElement(_reactstrap.Button, {
        id: "loginBtn",
        onClick: function onClick() {
          _this3.props.showAuthLoader();

          _this3.props.userSignIn({
            username: username,
            password: password
          });
        },
        color: "primary",
        className: "text-uppercase"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "appModule.signIn"
      }))), _react["default"].createElement("div", {
        className: "mb-3 d-flex align-items-center justify-content-between"
      }, _react["default"].createElement(_reactstrap.Button, {
        onClick: function onClick() {
          _this3.props.showAuthLoader();

          _this3.props.userRequestSignInCode({
            username: username
          });
        },
        color: "primary",
        className: "text-uppercase"
      }, authUserCode ? _react["default"].createElement(_IntlMessages["default"], {
        id: "appModule.resendCode"
      }) : _react["default"].createElement(_IntlMessages["default"], {
        id: "appModule.requestCode"
      }))), authUserCode ? _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("div", {
        className: "description"
      }, _react["default"].createElement("p", {
        className: "timeline-tile text-red"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "appModule.signinInstructions"
      }))), _react["default"].createElement("div", {
        className: "form-group mb-3"
      }, _react["default"].createElement("input", {
        placeholder: "Code",
        onChange: function onChange(event) {
          return _this3.setState({
            code: event.target.value
          });
        },
        defaultValue: code,
        className: "form-control form-control-lg"
      })), _react["default"].createElement("div", {
        className: "mb-3 d-flex align-items-center justify-content-between"
      }, _react["default"].createElement(_reactstrap.Button, {
        onClick: function onClick() {
          _this3.props.showAuthLoader();

          _this3.props.userSignInPasswordless({
            username: username,
            code: code
          });
        },
        color: "primary",
        className: "text-uppercase"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "appModule.enterCode"
      })))) : null)))), loader && _react["default"].createElement("div", {
        className: "loader-view"
      }, _react["default"].createElement(_CircularProgress["default"], null)), showMessage && _reactNotifications.NotificationManager.error(alertMessage || ''), _react["default"].createElement(_errorBoundary["default"], null, _react["default"].createElement(_reactNotifications.NotificationContainer, null)));
    }
  }]);

  return SignIn;
}(_react["default"].Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var auth = _ref.auth;
  var loader = auth.loader,
      alertMessage = auth.alertMessage,
      showMessage = auth.showMessage,
      authUser = auth.authUser,
      authUserCode = auth.authUserCode;
  return {
    loader: loader,
    alertMessage: alertMessage,
    showMessage: showMessage,
    authUser: authUser,
    authUserCode: authUserCode
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  userSignIn: _Auth.userSignIn,
  userSignInPasswordless: _Auth.userSignInPasswordless,
  userRequestSignInCode: _Auth.userRequestSignInCode,
  showAuthLoader: _Auth.showAuthLoader,
  hideAuthLoader: _Auth.hideAuthLoader,
  hideMessage: _Auth.hideMessage,
  userFacebookSignIn: _Auth.userFacebookSignIn,
  userGoogleSignIn: _Auth.userGoogleSignIn,
  userGithubSignIn: _Auth.userGithubSignIn,
  userTwitterSignIn: _Auth.userTwitterSignIn
})(SignIn);

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SignIn, "SignIn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignIn.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(_CircularProgress, "_CircularProgress", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(_simpleModal, "_simpleModal", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(_errorBoundary, "_errorBoundary", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(SignIn, "SignIn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignIn.js");
}();

;

/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var ErrorBoundary =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);

  function ErrorBoundary(props) {
    var _this;

    _classCallCheck(this, ErrorBoundary);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ErrorBoundary).call(this, props));
    _this.state = {
      hasError: false
    };
    return _this;
  }

  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      // You can also log the error to an error reporting service
      console.error(error, errorInfo);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        // You can render any custom fallback UI
        return _react["default"].createElement("h1", null, "Something went wrong.");
      }

      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      // Update state so the next render will show the fallback UI.
      return {
        hasError: true
      };
    }
  }]);

  return ErrorBoundary;
}(_react["default"].Component);

var _default = ErrorBoundary;
var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ErrorBoundary, "ErrorBoundary", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/errorBoundary/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/errorBoundary/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/errorBoundary/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/errorBoundary/index.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/errorBoundary/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/errorBoundary/index.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/errorBoundary/index.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/errorBoundary/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/errorBoundary/index.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/errorBoundary/index.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/errorBoundary/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/errorBoundary/index.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/errorBoundary/index.js");

  __REACT_HOT_LOADER__.register(ErrorBoundary, "ErrorBoundary", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/errorBoundary/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/errorBoundary/index.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/errorBoundary/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/components/errorBoundary/index.js");
}();

;

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactstrap = __webpack_require__(6);

var _reactRedux = __webpack_require__(10);

var _reactNotifications = __webpack_require__(30);

var _reactRouterDom = __webpack_require__(13);

var _IntlMessages = _interopRequireDefault(__webpack_require__(4));

var _Auth = __webpack_require__(143);

var _CircularProgress = _interopRequireDefault(__webpack_require__(24));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var SignUp =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SignUp, _React$Component);

  function SignUp() {
    var _this;

    _classCallCheck(this, SignUp);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SignUp).call(this));
    _this.state = {
      name: '',
      email: '',
      password: '',
      allowFederatedAuth: false
    };
    return _this;
  }

  _createClass(SignUp, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      if (this.props.showMessage) {
        setTimeout(function () {
          _this2.props.hideMessage();
        }, 3000);
      }

      if (this.props.authUser !== null) {
        this.props.history.push('/');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state = this.state,
          name = _this$state.name,
          email = _this$state.email,
          password = _this$state.password,
          allowFederatedAuth = _this$state.allowFederatedAuth;
      var _this$props = this.props,
          showMessage = _this$props.showMessage,
          loader = _this$props.loader,
          alertMessage = _this$props.alertMessage;
      return _react["default"].createElement("div", {
        className: "app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3"
      }, _react["default"].createElement("div", {
        className: "app-login-main-content"
      }, _react["default"].createElement("div", {
        className: "app-logo-content d-flex align-items-center justify-content-center"
      }, _react["default"].createElement(_reactRouterDom.Link, {
        className: "logo-lg",
        to: "/",
        title: "Jambo"
      }, _react["default"].createElement("img", {
        src: "http://via.placeholder.com/177x65",
        alt: "jambo",
        title: "jambo"
      }))), _react["default"].createElement("div", {
        className: "app-login-content"
      }, _react["default"].createElement("div", {
        className: "app-login-header"
      }, _react["default"].createElement("h1", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "appModule.signup"
      }))), _react["default"].createElement("div", {
        className: "mb-4"
      }, _react["default"].createElement("h2", null, _react["default"].createElement(_IntlMessages["default"], {
        id: "appModule.createAccount"
      }))), _react["default"].createElement("div", {
        className: "app-login-form"
      }, _react["default"].createElement("form", {
        method: "post",
        action: "/"
      }, _react["default"].createElement("div", {
        className: "form-group mb-3"
      }, _react["default"].createElement("input", {
        type: "text",
        placeholder: "Name",
        onChange: function onChange(event) {
          return _this3.setState({
            name: event.target.value
          });
        },
        defaultValue: name,
        className: "form-control form-control-lg"
      })), _react["default"].createElement("div", {
        className: "form-group mb-3"
      }, _react["default"].createElement("input", {
        type: "email",
        onChange: function onChange(event) {
          return _this3.setState({
            email: event.target.value
          });
        },
        placeholder: "Email",
        defaultValue: email,
        className: "form-control form-control-lg"
      })), _react["default"].createElement("div", {
        className: "form-group mb-3"
      }, _react["default"].createElement("input", {
        type: "password",
        onChange: function onChange(event) {
          return _this3.setState({
            password: event.target.value
          });
        },
        placeholder: "Password",
        defaultValue: password,
        className: "form-control form-control-lg"
      })), _react["default"].createElement("div", {
        className: "mb-3 d-flex align-items-center justify-content-between"
      }, _react["default"].createElement(_reactstrap.Button, {
        onClick: function onClick() {
          _this3.props.showLoader();

          _this3.props.userSignUp({
            email: email,
            password: password
          });
        },
        color: "primary",
        className: "text-uppercase"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "appModule.register"
      })), _react["default"].createElement(_reactRouterDom.Link, {
        to: "/signin"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "signUp.alreadyMember"
      }))), allowFederatedAuth ? _react["default"].createElement("div", {
        className: "app-social-block my-1 my-sm-3"
      }, _react["default"].createElement(_IntlMessages["default"], {
        id: "signIn.connectWith"
      }), _react["default"].createElement("ul", {
        className: "social-link"
      }, _react["default"].createElement("li", null, _react["default"].createElement("span", {
        className: "icon-btn icon",
        onClick: function onClick() {
          _this3.props.showAuthLoader();

          _this3.props.userFacebookSignIn();
        }
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-facebook zmdi-hc-lg"
      }))), _react["default"].createElement("li", null, _react["default"].createElement("span", {
        className: "icon-btn icon",
        onClick: function onClick() {
          _this3.props.showAuthLoader();

          _this3.props.userTwitterSignIn();
        }
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-twitter zmdi-hc-lg"
      }))), _react["default"].createElement("li", null, _react["default"].createElement("span", {
        className: "icon-btn icon",
        onClick: function onClick() {
          _this3.props.showAuthLoader();

          _this3.props.userGoogleSignIn();
        }
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-google-plus zmdi-hc-lg"
      }))), _react["default"].createElement("li", null, _react["default"].createElement("span", {
        className: "icon-btn icon",
        onClick: function onClick() {
          _this3.props.showAuthLoader();

          _this3.props.userGithubSignIn();
        }
      }, _react["default"].createElement("i", {
        className: "zmdi zmdi-github zmdi-hc-lg"
      }))))) : null)))), loader && _react["default"].createElement("div", {
        className: "loader-view"
      }, _react["default"].createElement(_CircularProgress["default"], null)), showMessage && _reactNotifications.NotificationManager.error(alertMessage), _react["default"].createElement(_reactNotifications.NotificationContainer, null));
    }
  }]);

  return SignUp;
}(_react["default"].Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var auth = _ref.auth;
  var loader = auth.loader,
      alertMessage = auth.alertMessage,
      showMessage = auth.showMessage,
      authUser = auth.authUser;
  return {
    loader: loader,
    alertMessage: alertMessage,
    showMessage: showMessage,
    authUser: authUser
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  userSignUp: _Auth.userSignUp,
  hideMessage: _Auth.hideMessage,
  showAuthLoader: _Auth.showAuthLoader,
  userFacebookSignIn: _Auth.userFacebookSignIn,
  userGoogleSignIn: _Auth.userGoogleSignIn,
  userGithubSignIn: _Auth.userGithubSignIn,
  userTwitterSignIn: _Auth.userTwitterSignIn
})(SignUp);

var _default2 = _default;
exports["default"] = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SignUp, "SignUp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignUp.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignUp.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignUp.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react, "_react", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignUp.js");

  __REACT_HOT_LOADER__.register(_IntlMessages, "_IntlMessages", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignUp.js");

  __REACT_HOT_LOADER__.register(_CircularProgress, "_CircularProgress", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignUp.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignUp.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignUp.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignUp.js");

  __REACT_HOT_LOADER__.register(_defineProperties, "_defineProperties", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignUp.js");

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignUp.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignUp.js");

  __REACT_HOT_LOADER__.register(_assertThisInitialized, "_assertThisInitialized", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignUp.js");

  __REACT_HOT_LOADER__.register(_getPrototypeOf, "_getPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignUp.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignUp.js");

  __REACT_HOT_LOADER__.register(_setPrototypeOf, "_setPrototypeOf", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignUp.js");

  __REACT_HOT_LOADER__.register(SignUp, "SignUp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignUp.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignUp.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignUp.js");

  __REACT_HOT_LOADER__.register(_default2, "_default2", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignUp.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "/Users/eddielewis/workspace/TeamCity/buildAgent/work/9147d7cf55cbcdae/src/containers/SignUp.js");
}();

;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// assets/app.js